export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  date: any;
  geography: any;
  geometry: any;
  jsonb: any;
  numeric: any;
  smallint: any;
  time: any;
  timestamp: any;
  timestamptz: any;
  tstzrange: any;
  uuid: any;
};

/** columns and relationships of "amenities" */
export type Amenities = {
  __typename?: 'Amenities';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "amenities" */
export type AmenitiesAggregate = {
  __typename?: 'AmenitiesAggregate';
  aggregate?: Maybe<AmenitiesAggregateFields>;
  nodes: Array<Amenities>;
};

/** aggregate fields of "amenities" */
export type AmenitiesAggregateFields = {
  __typename?: 'AmenitiesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<AmenitiesMaxFields>;
  min?: Maybe<AmenitiesMinFields>;
};


/** aggregate fields of "amenities" */
export type AmenitiesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AmenitiesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "amenities". All fields are combined with a logical 'AND'. */
export type AmenitiesBoolExp = {
  _and?: InputMaybe<Array<AmenitiesBoolExp>>;
  _not?: InputMaybe<AmenitiesBoolExp>;
  _or?: InputMaybe<Array<AmenitiesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "amenities" */
export enum AmenitiesConstraint {
  /** unique or primary key constraint on columns "value" */
  AmenitiesPkey = 'amenities_pkey'
}

export enum AmenitiesEnum {
  AccessibleParking = 'ACCESSIBLE_PARKING',
  AirConditioning = 'AIR_CONDITIONING',
  Backboard = 'BACKBOARD',
  Bar = 'BAR',
  Cafe = 'CAFE',
  ChildFriendly = 'CHILD_FRIENDLY',
  DogFriendly = 'DOG_FRIENDLY',
  EquipmentRental = 'EQUIPMENT_RENTAL',
  Food = 'FOOD',
  FreeWifi = 'FREE_WIFI',
  Lights = 'LIGHTS',
  LockerRooms = 'LOCKER_ROOMS',
  OutdoorSeating = 'OUTDOOR_SEATING',
  Parking = 'PARKING',
  ProShop = 'PRO_SHOP',
  Restaurant = 'RESTAURANT',
  Restrooms = 'RESTROOMS',
  Shower = 'SHOWER',
  Training = 'TRAINING',
  Water = 'WATER',
  WheelchairAccessible = 'WHEELCHAIR_ACCESSIBLE'
}

/** Boolean expression to compare columns of type "AmenitiesEnum". All fields are combined with logical 'AND'. */
export type AmenitiesEnumComparisonExp = {
  _eq?: InputMaybe<AmenitiesEnum>;
  _in?: InputMaybe<Array<AmenitiesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<AmenitiesEnum>;
  _nin?: InputMaybe<Array<AmenitiesEnum>>;
};

/** input type for inserting data into table "amenities" */
export type AmenitiesInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type AmenitiesMaxFields = {
  __typename?: 'AmenitiesMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type AmenitiesMinFields = {
  __typename?: 'AmenitiesMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "amenities" */
export type AmenitiesMutationResponse = {
  __typename?: 'AmenitiesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Amenities>;
};

/** on_conflict condition type for table "amenities" */
export type AmenitiesOnConflict = {
  constraint: AmenitiesConstraint;
  updateColumns?: Array<AmenitiesUpdateColumn>;
  where?: InputMaybe<AmenitiesBoolExp>;
};

/** Ordering options when selecting data from "amenities". */
export type AmenitiesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: amenities */
export type AmenitiesPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "amenities" */
export enum AmenitiesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "amenities" */
export type AmenitiesSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "amenities" */
export type AmenitiesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: AmenitiesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AmenitiesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "amenities" */
export enum AmenitiesUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type AmenitiesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AmenitiesSetInput>;
  /** filter the rows which have to be updated */
  where: AmenitiesBoolExp;
};

/** columns and relationships of "app_personas" */
export type AppPersonas = {
  __typename?: 'AppPersonas';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "app_personas" */
export type AppPersonasAggregate = {
  __typename?: 'AppPersonasAggregate';
  aggregate?: Maybe<AppPersonasAggregateFields>;
  nodes: Array<AppPersonas>;
};

/** aggregate fields of "app_personas" */
export type AppPersonasAggregateFields = {
  __typename?: 'AppPersonasAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<AppPersonasMaxFields>;
  min?: Maybe<AppPersonasMinFields>;
};


/** aggregate fields of "app_personas" */
export type AppPersonasAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AppPersonasSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "app_personas". All fields are combined with a logical 'AND'. */
export type AppPersonasBoolExp = {
  _and?: InputMaybe<Array<AppPersonasBoolExp>>;
  _not?: InputMaybe<AppPersonasBoolExp>;
  _or?: InputMaybe<Array<AppPersonasBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "app_personas" */
export enum AppPersonasConstraint {
  /** unique or primary key constraint on columns "value" */
  AppPersonasPkey = 'app_personas_pkey'
}

export enum AppPersonasEnum {
  Admin = 'ADMIN',
  Coach = 'COACH',
  Organizer = 'ORGANIZER',
  Player = 'PLAYER',
  System = 'SYSTEM'
}

/** Boolean expression to compare columns of type "AppPersonasEnum". All fields are combined with logical 'AND'. */
export type AppPersonasEnumComparisonExp = {
  _eq?: InputMaybe<AppPersonasEnum>;
  _in?: InputMaybe<Array<AppPersonasEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<AppPersonasEnum>;
  _nin?: InputMaybe<Array<AppPersonasEnum>>;
};

/** input type for inserting data into table "app_personas" */
export type AppPersonasInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type AppPersonasMaxFields = {
  __typename?: 'AppPersonasMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type AppPersonasMinFields = {
  __typename?: 'AppPersonasMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "app_personas" */
export type AppPersonasMutationResponse = {
  __typename?: 'AppPersonasMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AppPersonas>;
};

/** on_conflict condition type for table "app_personas" */
export type AppPersonasOnConflict = {
  constraint: AppPersonasConstraint;
  updateColumns?: Array<AppPersonasUpdateColumn>;
  where?: InputMaybe<AppPersonasBoolExp>;
};

/** Ordering options when selecting data from "app_personas". */
export type AppPersonasOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: app_personas */
export type AppPersonasPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "app_personas" */
export enum AppPersonasSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "app_personas" */
export type AppPersonasSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "app_personas" */
export type AppPersonasStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: AppPersonasStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AppPersonasStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "app_personas" */
export enum AppPersonasUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type AppPersonasUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AppPersonasSetInput>;
  /** filter the rows which have to be updated */
  where: AppPersonasBoolExp;
};

/** columns and relationships of "app_pings" */
export type AppPings = {
  __typename?: 'AppPings';
  city: Scalars['String'];
  country: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  firebaseId?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  ip: Scalars['String'];
  ipResponse?: Maybe<Scalars['jsonb']>;
  pathname: Scalars['String'];
  /** iOS, Android, Web */
  platform: Scalars['String'];
  queryString: Scalars['String'];
  region: Scalars['String'];
  timezone: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user?: Maybe<Users>;
  userId?: Maybe<Scalars['uuid']>;
  zip: Scalars['String'];
};


/** columns and relationships of "app_pings" */
export type AppPingsIpResponseArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "app_pings" */
export type AppPingsAggregate = {
  __typename?: 'AppPingsAggregate';
  aggregate?: Maybe<AppPingsAggregateFields>;
  nodes: Array<AppPings>;
};

/** aggregate fields of "app_pings" */
export type AppPingsAggregateFields = {
  __typename?: 'AppPingsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<AppPingsMaxFields>;
  min?: Maybe<AppPingsMinFields>;
};


/** aggregate fields of "app_pings" */
export type AppPingsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AppPingsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type AppPingsAppendInput = {
  ipResponse?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "app_pings". All fields are combined with a logical 'AND'. */
export type AppPingsBoolExp = {
  _and?: InputMaybe<Array<AppPingsBoolExp>>;
  _not?: InputMaybe<AppPingsBoolExp>;
  _or?: InputMaybe<Array<AppPingsBoolExp>>;
  city?: InputMaybe<StringComparisonExp>;
  country?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  firebaseId?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  ip?: InputMaybe<StringComparisonExp>;
  ipResponse?: InputMaybe<JsonbComparisonExp>;
  pathname?: InputMaybe<StringComparisonExp>;
  platform?: InputMaybe<StringComparisonExp>;
  queryString?: InputMaybe<StringComparisonExp>;
  region?: InputMaybe<StringComparisonExp>;
  timezone?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
  zip?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "app_pings" */
export enum AppPingsConstraint {
  /** unique or primary key constraint on columns "id" */
  AppPingsPkey = 'app_pings_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type AppPingsDeleteAtPathInput = {
  ipResponse?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type AppPingsDeleteElemInput = {
  ipResponse?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type AppPingsDeleteKeyInput = {
  ipResponse?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "app_pings" */
export type AppPingsInsertInput = {
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  firebaseId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  ip?: InputMaybe<Scalars['String']>;
  ipResponse?: InputMaybe<Scalars['jsonb']>;
  pathname?: InputMaybe<Scalars['String']>;
  /** iOS, Android, Web */
  platform?: InputMaybe<Scalars['String']>;
  queryString?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']>;
  zip?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type AppPingsMaxFields = {
  __typename?: 'AppPingsMaxFields';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  ip?: Maybe<Scalars['String']>;
  pathname?: Maybe<Scalars['String']>;
  /** iOS, Android, Web */
  platform?: Maybe<Scalars['String']>;
  queryString?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
  zip?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type AppPingsMinFields = {
  __typename?: 'AppPingsMinFields';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  firebaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  ip?: Maybe<Scalars['String']>;
  pathname?: Maybe<Scalars['String']>;
  /** iOS, Android, Web */
  platform?: Maybe<Scalars['String']>;
  queryString?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
  zip?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "app_pings" */
export type AppPingsMutationResponse = {
  __typename?: 'AppPingsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AppPings>;
};

/** on_conflict condition type for table "app_pings" */
export type AppPingsOnConflict = {
  constraint: AppPingsConstraint;
  updateColumns?: Array<AppPingsUpdateColumn>;
  where?: InputMaybe<AppPingsBoolExp>;
};

/** Ordering options when selecting data from "app_pings". */
export type AppPingsOrderBy = {
  city?: InputMaybe<OrderBy>;
  country?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  firebaseId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  ip?: InputMaybe<OrderBy>;
  ipResponse?: InputMaybe<OrderBy>;
  pathname?: InputMaybe<OrderBy>;
  platform?: InputMaybe<OrderBy>;
  queryString?: InputMaybe<OrderBy>;
  region?: InputMaybe<OrderBy>;
  timezone?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
  zip?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: app_pings */
export type AppPingsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type AppPingsPrependInput = {
  ipResponse?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "app_pings" */
export enum AppPingsSelectColumn {
  /** column name */
  City = 'city',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  FirebaseId = 'firebaseId',
  /** column name */
  Id = 'id',
  /** column name */
  Ip = 'ip',
  /** column name */
  IpResponse = 'ipResponse',
  /** column name */
  Pathname = 'pathname',
  /** column name */
  Platform = 'platform',
  /** column name */
  QueryString = 'queryString',
  /** column name */
  Region = 'region',
  /** column name */
  Timezone = 'timezone',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId',
  /** column name */
  Zip = 'zip'
}

/** input type for updating data in table "app_pings" */
export type AppPingsSetInput = {
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  firebaseId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  ip?: InputMaybe<Scalars['String']>;
  ipResponse?: InputMaybe<Scalars['jsonb']>;
  pathname?: InputMaybe<Scalars['String']>;
  /** iOS, Android, Web */
  platform?: InputMaybe<Scalars['String']>;
  queryString?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
  zip?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "app_pings" */
export type AppPingsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: AppPingsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AppPingsStreamCursorValueInput = {
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  firebaseId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  ip?: InputMaybe<Scalars['String']>;
  ipResponse?: InputMaybe<Scalars['jsonb']>;
  pathname?: InputMaybe<Scalars['String']>;
  /** iOS, Android, Web */
  platform?: InputMaybe<Scalars['String']>;
  queryString?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
  zip?: InputMaybe<Scalars['String']>;
};

/** update columns of table "app_pings" */
export enum AppPingsUpdateColumn {
  /** column name */
  City = 'city',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  FirebaseId = 'firebaseId',
  /** column name */
  Id = 'id',
  /** column name */
  Ip = 'ip',
  /** column name */
  IpResponse = 'ipResponse',
  /** column name */
  Pathname = 'pathname',
  /** column name */
  Platform = 'platform',
  /** column name */
  QueryString = 'queryString',
  /** column name */
  Region = 'region',
  /** column name */
  Timezone = 'timezone',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId',
  /** column name */
  Zip = 'zip'
}

export type AppPingsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<AppPingsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _deleteAtPath?: InputMaybe<AppPingsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _deleteElem?: InputMaybe<AppPingsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _deleteKey?: InputMaybe<AppPingsDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<AppPingsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AppPingsSetInput>;
  /** filter the rows which have to be updated */
  where: AppPingsBoolExp;
};

/** columns and relationships of "ball_types" */
export type BallTypes = {
  __typename?: 'BallTypes';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "ball_types" */
export type BallTypesAggregate = {
  __typename?: 'BallTypesAggregate';
  aggregate?: Maybe<BallTypesAggregateFields>;
  nodes: Array<BallTypes>;
};

/** aggregate fields of "ball_types" */
export type BallTypesAggregateFields = {
  __typename?: 'BallTypesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<BallTypesMaxFields>;
  min?: Maybe<BallTypesMinFields>;
};


/** aggregate fields of "ball_types" */
export type BallTypesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<BallTypesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "ball_types". All fields are combined with a logical 'AND'. */
export type BallTypesBoolExp = {
  _and?: InputMaybe<Array<BallTypesBoolExp>>;
  _not?: InputMaybe<BallTypesBoolExp>;
  _or?: InputMaybe<Array<BallTypesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "ball_types" */
export enum BallTypesConstraint {
  /** unique or primary key constraint on columns "value" */
  BallTypesPkey = 'ball_types_pkey'
}

export enum BallTypesEnum {
  Custom = 'CUSTOM',
  FranklinX_40Pickleball = 'FRANKLIN_X_40_PICKLEBALL',
  GammaPhotonPickleball = 'GAMMA_PHOTON_PICKLEBALL',
  NotSelected = 'NOT_SELECTED',
  OnixDuraFast_40Pickleball = 'ONIX_DURA_FAST_40_PICKLEBALL',
  OnixFuseG2Pickleball = 'ONIX_FUSE_G2_PICKLEBALL',
  SelkirkProS1Pickleball = 'SELKIRK_PRO_S1_PICKLEBALL'
}

/** Boolean expression to compare columns of type "BallTypesEnum". All fields are combined with logical 'AND'. */
export type BallTypesEnumComparisonExp = {
  _eq?: InputMaybe<BallTypesEnum>;
  _in?: InputMaybe<Array<BallTypesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<BallTypesEnum>;
  _nin?: InputMaybe<Array<BallTypesEnum>>;
};

/** input type for inserting data into table "ball_types" */
export type BallTypesInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type BallTypesMaxFields = {
  __typename?: 'BallTypesMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type BallTypesMinFields = {
  __typename?: 'BallTypesMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "ball_types" */
export type BallTypesMutationResponse = {
  __typename?: 'BallTypesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<BallTypes>;
};

/** on_conflict condition type for table "ball_types" */
export type BallTypesOnConflict = {
  constraint: BallTypesConstraint;
  updateColumns?: Array<BallTypesUpdateColumn>;
  where?: InputMaybe<BallTypesBoolExp>;
};

/** Ordering options when selecting data from "ball_types". */
export type BallTypesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: ball_types */
export type BallTypesPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "ball_types" */
export enum BallTypesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "ball_types" */
export type BallTypesSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "ball_types" */
export type BallTypesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: BallTypesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BallTypesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "ball_types" */
export enum BallTypesUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type BallTypesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BallTypesSetInput>;
  /** filter the rows which have to be updated */
  where: BallTypesBoolExp;
};

/** columns and relationships of "birthday_visibility" */
export type BirthdayVisibility = {
  __typename?: 'BirthdayVisibility';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "birthday_visibility" */
export type BirthdayVisibilityAggregate = {
  __typename?: 'BirthdayVisibilityAggregate';
  aggregate?: Maybe<BirthdayVisibilityAggregateFields>;
  nodes: Array<BirthdayVisibility>;
};

/** aggregate fields of "birthday_visibility" */
export type BirthdayVisibilityAggregateFields = {
  __typename?: 'BirthdayVisibilityAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<BirthdayVisibilityMaxFields>;
  min?: Maybe<BirthdayVisibilityMinFields>;
};


/** aggregate fields of "birthday_visibility" */
export type BirthdayVisibilityAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<BirthdayVisibilitySelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "birthday_visibility". All fields are combined with a logical 'AND'. */
export type BirthdayVisibilityBoolExp = {
  _and?: InputMaybe<Array<BirthdayVisibilityBoolExp>>;
  _not?: InputMaybe<BirthdayVisibilityBoolExp>;
  _or?: InputMaybe<Array<BirthdayVisibilityBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "birthday_visibility" */
export enum BirthdayVisibilityConstraint {
  /** unique or primary key constraint on columns "value" */
  BirthdayVisibilityPkey = 'birthday_visibility_pkey'
}

export enum BirthdayVisibilityEnum {
  HideYear = 'HIDE_YEAR',
  Visible = 'VISIBLE'
}

/** Boolean expression to compare columns of type "BirthdayVisibilityEnum". All fields are combined with logical 'AND'. */
export type BirthdayVisibilityEnumComparisonExp = {
  _eq?: InputMaybe<BirthdayVisibilityEnum>;
  _in?: InputMaybe<Array<BirthdayVisibilityEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<BirthdayVisibilityEnum>;
  _nin?: InputMaybe<Array<BirthdayVisibilityEnum>>;
};

/** input type for inserting data into table "birthday_visibility" */
export type BirthdayVisibilityInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type BirthdayVisibilityMaxFields = {
  __typename?: 'BirthdayVisibilityMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type BirthdayVisibilityMinFields = {
  __typename?: 'BirthdayVisibilityMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "birthday_visibility" */
export type BirthdayVisibilityMutationResponse = {
  __typename?: 'BirthdayVisibilityMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<BirthdayVisibility>;
};

/** on_conflict condition type for table "birthday_visibility" */
export type BirthdayVisibilityOnConflict = {
  constraint: BirthdayVisibilityConstraint;
  updateColumns?: Array<BirthdayVisibilityUpdateColumn>;
  where?: InputMaybe<BirthdayVisibilityBoolExp>;
};

/** Ordering options when selecting data from "birthday_visibility". */
export type BirthdayVisibilityOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: birthday_visibility */
export type BirthdayVisibilityPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "birthday_visibility" */
export enum BirthdayVisibilitySelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "birthday_visibility" */
export type BirthdayVisibilitySetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "birthday_visibility" */
export type BirthdayVisibilityStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: BirthdayVisibilityStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BirthdayVisibilityStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "birthday_visibility" */
export enum BirthdayVisibilityUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type BirthdayVisibilityUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BirthdayVisibilitySetInput>;
  /** filter the rows which have to be updated */
  where: BirthdayVisibilityBoolExp;
};

/** columns and relationships of "booking_config_change_types" */
export type BookingConfigChangeTypes = {
  __typename?: 'BookingConfigChangeTypes';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "booking_config_change_types" */
export type BookingConfigChangeTypesAggregate = {
  __typename?: 'BookingConfigChangeTypesAggregate';
  aggregate?: Maybe<BookingConfigChangeTypesAggregateFields>;
  nodes: Array<BookingConfigChangeTypes>;
};

/** aggregate fields of "booking_config_change_types" */
export type BookingConfigChangeTypesAggregateFields = {
  __typename?: 'BookingConfigChangeTypesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<BookingConfigChangeTypesMaxFields>;
  min?: Maybe<BookingConfigChangeTypesMinFields>;
};


/** aggregate fields of "booking_config_change_types" */
export type BookingConfigChangeTypesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<BookingConfigChangeTypesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "booking_config_change_types". All fields are combined with a logical 'AND'. */
export type BookingConfigChangeTypesBoolExp = {
  _and?: InputMaybe<Array<BookingConfigChangeTypesBoolExp>>;
  _not?: InputMaybe<BookingConfigChangeTypesBoolExp>;
  _or?: InputMaybe<Array<BookingConfigChangeTypesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "booking_config_change_types" */
export enum BookingConfigChangeTypesConstraint {
  /** unique or primary key constraint on columns "value" */
  BookingConfigChangeTypesPkey = 'booking_config_change_types_pkey'
}

export enum BookingConfigChangeTypesEnum {
  /** Club approved the terms */
  Authorized = 'AUTHORIZED',
  /** Integration paused */
  Paused = 'PAUSED',
  /** Discount tiers changed */
  PricingUpdated = 'PRICING_UPDATED',
  /** Integration resumed */
  Resumed = 'RESUMED',
  /** Schedule mode or windows changed */
  ScheduleUpdated = 'SCHEDULE_UPDATED',
  /** Booking system changed */
  SystemChanged = 'SYSTEM_CHANGED'
}

/** Boolean expression to compare columns of type "BookingConfigChangeTypesEnum". All fields are combined with logical 'AND'. */
export type BookingConfigChangeTypesEnumComparisonExp = {
  _eq?: InputMaybe<BookingConfigChangeTypesEnum>;
  _in?: InputMaybe<Array<BookingConfigChangeTypesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<BookingConfigChangeTypesEnum>;
  _nin?: InputMaybe<Array<BookingConfigChangeTypesEnum>>;
};

/** input type for inserting data into table "booking_config_change_types" */
export type BookingConfigChangeTypesInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type BookingConfigChangeTypesMaxFields = {
  __typename?: 'BookingConfigChangeTypesMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type BookingConfigChangeTypesMinFields = {
  __typename?: 'BookingConfigChangeTypesMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "booking_config_change_types" */
export type BookingConfigChangeTypesMutationResponse = {
  __typename?: 'BookingConfigChangeTypesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<BookingConfigChangeTypes>;
};

/** on_conflict condition type for table "booking_config_change_types" */
export type BookingConfigChangeTypesOnConflict = {
  constraint: BookingConfigChangeTypesConstraint;
  updateColumns?: Array<BookingConfigChangeTypesUpdateColumn>;
  where?: InputMaybe<BookingConfigChangeTypesBoolExp>;
};

/** Ordering options when selecting data from "booking_config_change_types". */
export type BookingConfigChangeTypesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: booking_config_change_types */
export type BookingConfigChangeTypesPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "booking_config_change_types" */
export enum BookingConfigChangeTypesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "booking_config_change_types" */
export type BookingConfigChangeTypesSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "booking_config_change_types" */
export type BookingConfigChangeTypesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: BookingConfigChangeTypesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BookingConfigChangeTypesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "booking_config_change_types" */
export enum BookingConfigChangeTypesUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type BookingConfigChangeTypesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BookingConfigChangeTypesSetInput>;
  /** filter the rows which have to be updated */
  where: BookingConfigChangeTypesBoolExp;
};

/** columns and relationships of "booking_connection_statuses" */
export type BookingConnectionStatuses = {
  __typename?: 'BookingConnectionStatuses';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "booking_connection_statuses" */
export type BookingConnectionStatusesAggregate = {
  __typename?: 'BookingConnectionStatusesAggregate';
  aggregate?: Maybe<BookingConnectionStatusesAggregateFields>;
  nodes: Array<BookingConnectionStatuses>;
};

/** aggregate fields of "booking_connection_statuses" */
export type BookingConnectionStatusesAggregateFields = {
  __typename?: 'BookingConnectionStatusesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<BookingConnectionStatusesMaxFields>;
  min?: Maybe<BookingConnectionStatusesMinFields>;
};


/** aggregate fields of "booking_connection_statuses" */
export type BookingConnectionStatusesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<BookingConnectionStatusesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "booking_connection_statuses". All fields are combined with a logical 'AND'. */
export type BookingConnectionStatusesBoolExp = {
  _and?: InputMaybe<Array<BookingConnectionStatusesBoolExp>>;
  _not?: InputMaybe<BookingConnectionStatusesBoolExp>;
  _or?: InputMaybe<Array<BookingConnectionStatusesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "booking_connection_statuses" */
export enum BookingConnectionStatusesConstraint {
  /** unique or primary key constraint on columns "value" */
  BookingConnectionStatusesPkey = 'booking_connection_statuses_pkey'
}

export enum BookingConnectionStatusesEnum {
  /** Booking account could not be confirmed */
  Failed = 'FAILED',
  /** Waiting on ops to confirm the booking account */
  Pending = 'PENDING',
  /** Booking account confirmed */
  Verified = 'VERIFIED'
}

/** Boolean expression to compare columns of type "BookingConnectionStatusesEnum". All fields are combined with logical 'AND'. */
export type BookingConnectionStatusesEnumComparisonExp = {
  _eq?: InputMaybe<BookingConnectionStatusesEnum>;
  _in?: InputMaybe<Array<BookingConnectionStatusesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<BookingConnectionStatusesEnum>;
  _nin?: InputMaybe<Array<BookingConnectionStatusesEnum>>;
};

/** input type for inserting data into table "booking_connection_statuses" */
export type BookingConnectionStatusesInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type BookingConnectionStatusesMaxFields = {
  __typename?: 'BookingConnectionStatusesMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type BookingConnectionStatusesMinFields = {
  __typename?: 'BookingConnectionStatusesMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "booking_connection_statuses" */
export type BookingConnectionStatusesMutationResponse = {
  __typename?: 'BookingConnectionStatusesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<BookingConnectionStatuses>;
};

/** on_conflict condition type for table "booking_connection_statuses" */
export type BookingConnectionStatusesOnConflict = {
  constraint: BookingConnectionStatusesConstraint;
  updateColumns?: Array<BookingConnectionStatusesUpdateColumn>;
  where?: InputMaybe<BookingConnectionStatusesBoolExp>;
};

/** Ordering options when selecting data from "booking_connection_statuses". */
export type BookingConnectionStatusesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: booking_connection_statuses */
export type BookingConnectionStatusesPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "booking_connection_statuses" */
export enum BookingConnectionStatusesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "booking_connection_statuses" */
export type BookingConnectionStatusesSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "booking_connection_statuses" */
export type BookingConnectionStatusesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: BookingConnectionStatusesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BookingConnectionStatusesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "booking_connection_statuses" */
export enum BookingConnectionStatusesUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type BookingConnectionStatusesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BookingConnectionStatusesSetInput>;
  /** filter the rows which have to be updated */
  where: BookingConnectionStatusesBoolExp;
};

/** columns and relationships of "booking_integration_statuses" */
export type BookingIntegrationStatuses = {
  __typename?: 'BookingIntegrationStatuses';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "booking_integration_statuses" */
export type BookingIntegrationStatusesAggregate = {
  __typename?: 'BookingIntegrationStatusesAggregate';
  aggregate?: Maybe<BookingIntegrationStatusesAggregateFields>;
  nodes: Array<BookingIntegrationStatuses>;
};

/** aggregate fields of "booking_integration_statuses" */
export type BookingIntegrationStatusesAggregateFields = {
  __typename?: 'BookingIntegrationStatusesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<BookingIntegrationStatusesMaxFields>;
  min?: Maybe<BookingIntegrationStatusesMinFields>;
};


/** aggregate fields of "booking_integration_statuses" */
export type BookingIntegrationStatusesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<BookingIntegrationStatusesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "booking_integration_statuses". All fields are combined with a logical 'AND'. */
export type BookingIntegrationStatusesBoolExp = {
  _and?: InputMaybe<Array<BookingIntegrationStatusesBoolExp>>;
  _not?: InputMaybe<BookingIntegrationStatusesBoolExp>;
  _or?: InputMaybe<Array<BookingIntegrationStatusesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "booking_integration_statuses" */
export enum BookingIntegrationStatusesConstraint {
  /** unique or primary key constraint on columns "value" */
  BookingIntegrationStatusesPkey = 'booking_integration_statuses_pkey'
}

export enum BookingIntegrationStatusesEnum {
  /** Live */
  Active = 'ACTIVE',
  /** Wizard not finished; not live */
  Draft = 'DRAFT',
  /** Temporarily not live */
  Paused = 'PAUSED'
}

/** Boolean expression to compare columns of type "BookingIntegrationStatusesEnum". All fields are combined with logical 'AND'. */
export type BookingIntegrationStatusesEnumComparisonExp = {
  _eq?: InputMaybe<BookingIntegrationStatusesEnum>;
  _in?: InputMaybe<Array<BookingIntegrationStatusesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<BookingIntegrationStatusesEnum>;
  _nin?: InputMaybe<Array<BookingIntegrationStatusesEnum>>;
};

/** input type for inserting data into table "booking_integration_statuses" */
export type BookingIntegrationStatusesInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type BookingIntegrationStatusesMaxFields = {
  __typename?: 'BookingIntegrationStatusesMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type BookingIntegrationStatusesMinFields = {
  __typename?: 'BookingIntegrationStatusesMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "booking_integration_statuses" */
export type BookingIntegrationStatusesMutationResponse = {
  __typename?: 'BookingIntegrationStatusesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<BookingIntegrationStatuses>;
};

/** on_conflict condition type for table "booking_integration_statuses" */
export type BookingIntegrationStatusesOnConflict = {
  constraint: BookingIntegrationStatusesConstraint;
  updateColumns?: Array<BookingIntegrationStatusesUpdateColumn>;
  where?: InputMaybe<BookingIntegrationStatusesBoolExp>;
};

/** Ordering options when selecting data from "booking_integration_statuses". */
export type BookingIntegrationStatusesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: booking_integration_statuses */
export type BookingIntegrationStatusesPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "booking_integration_statuses" */
export enum BookingIntegrationStatusesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "booking_integration_statuses" */
export type BookingIntegrationStatusesSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "booking_integration_statuses" */
export type BookingIntegrationStatusesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: BookingIntegrationStatusesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BookingIntegrationStatusesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "booking_integration_statuses" */
export enum BookingIntegrationStatusesUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type BookingIntegrationStatusesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BookingIntegrationStatusesSetInput>;
  /** filter the rows which have to be updated */
  where: BookingIntegrationStatusesBoolExp;
};

/** columns and relationships of "booking_inventory_types" */
export type BookingInventoryTypes = {
  __typename?: 'BookingInventoryTypes';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "booking_inventory_types" */
export type BookingInventoryTypesAggregate = {
  __typename?: 'BookingInventoryTypesAggregate';
  aggregate?: Maybe<BookingInventoryTypesAggregateFields>;
  nodes: Array<BookingInventoryTypes>;
};

/** aggregate fields of "booking_inventory_types" */
export type BookingInventoryTypesAggregateFields = {
  __typename?: 'BookingInventoryTypesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<BookingInventoryTypesMaxFields>;
  min?: Maybe<BookingInventoryTypesMinFields>;
};


/** aggregate fields of "booking_inventory_types" */
export type BookingInventoryTypesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<BookingInventoryTypesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "booking_inventory_types". All fields are combined with a logical 'AND'. */
export type BookingInventoryTypesBoolExp = {
  _and?: InputMaybe<Array<BookingInventoryTypesBoolExp>>;
  _not?: InputMaybe<BookingInventoryTypesBoolExp>;
  _or?: InputMaybe<Array<BookingInventoryTypesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "booking_inventory_types" */
export enum BookingInventoryTypesConstraint {
  /** unique or primary key constraint on columns "value" */
  BookingInventoryTypesPkey = 'booking_inventory_types_pkey'
}

export enum BookingInventoryTypesEnum {
  /** Court bookings */
  Court = 'COURT',
  /** Programming bookings */
  Program = 'PROGRAM'
}

/** Boolean expression to compare columns of type "BookingInventoryTypesEnum". All fields are combined with logical 'AND'. */
export type BookingInventoryTypesEnumComparisonExp = {
  _eq?: InputMaybe<BookingInventoryTypesEnum>;
  _in?: InputMaybe<Array<BookingInventoryTypesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<BookingInventoryTypesEnum>;
  _nin?: InputMaybe<Array<BookingInventoryTypesEnum>>;
};

/** input type for inserting data into table "booking_inventory_types" */
export type BookingInventoryTypesInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type BookingInventoryTypesMaxFields = {
  __typename?: 'BookingInventoryTypesMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type BookingInventoryTypesMinFields = {
  __typename?: 'BookingInventoryTypesMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "booking_inventory_types" */
export type BookingInventoryTypesMutationResponse = {
  __typename?: 'BookingInventoryTypesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<BookingInventoryTypes>;
};

/** on_conflict condition type for table "booking_inventory_types" */
export type BookingInventoryTypesOnConflict = {
  constraint: BookingInventoryTypesConstraint;
  updateColumns?: Array<BookingInventoryTypesUpdateColumn>;
  where?: InputMaybe<BookingInventoryTypesBoolExp>;
};

/** Ordering options when selecting data from "booking_inventory_types". */
export type BookingInventoryTypesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: booking_inventory_types */
export type BookingInventoryTypesPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "booking_inventory_types" */
export enum BookingInventoryTypesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "booking_inventory_types" */
export type BookingInventoryTypesSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "booking_inventory_types" */
export type BookingInventoryTypesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: BookingInventoryTypesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BookingInventoryTypesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "booking_inventory_types" */
export enum BookingInventoryTypesUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type BookingInventoryTypesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BookingInventoryTypesSetInput>;
  /** filter the rows which have to be updated */
  where: BookingInventoryTypesBoolExp;
};

/** columns and relationships of "booking_schedule_modes" */
export type BookingScheduleModes = {
  __typename?: 'BookingScheduleModes';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "booking_schedule_modes" */
export type BookingScheduleModesAggregate = {
  __typename?: 'BookingScheduleModesAggregate';
  aggregate?: Maybe<BookingScheduleModesAggregateFields>;
  nodes: Array<BookingScheduleModes>;
};

/** aggregate fields of "booking_schedule_modes" */
export type BookingScheduleModesAggregateFields = {
  __typename?: 'BookingScheduleModesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<BookingScheduleModesMaxFields>;
  min?: Maybe<BookingScheduleModesMinFields>;
};


/** aggregate fields of "booking_schedule_modes" */
export type BookingScheduleModesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<BookingScheduleModesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "booking_schedule_modes". All fields are combined with a logical 'AND'. */
export type BookingScheduleModesBoolExp = {
  _and?: InputMaybe<Array<BookingScheduleModesBoolExp>>;
  _not?: InputMaybe<BookingScheduleModesBoolExp>;
  _or?: InputMaybe<Array<BookingScheduleModesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "booking_schedule_modes" */
export enum BookingScheduleModesConstraint {
  /** unique or primary key constraint on columns "value" */
  BookingScheduleModesPkey = 'booking_schedule_modes_pkey'
}

export enum BookingScheduleModesEnum {
  /** Applies at all times */
  Always = 'ALWAYS',
  /** Applies only inside the configured windows */
  Scheduled = 'SCHEDULED'
}

/** Boolean expression to compare columns of type "BookingScheduleModesEnum". All fields are combined with logical 'AND'. */
export type BookingScheduleModesEnumComparisonExp = {
  _eq?: InputMaybe<BookingScheduleModesEnum>;
  _in?: InputMaybe<Array<BookingScheduleModesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<BookingScheduleModesEnum>;
  _nin?: InputMaybe<Array<BookingScheduleModesEnum>>;
};

/** input type for inserting data into table "booking_schedule_modes" */
export type BookingScheduleModesInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type BookingScheduleModesMaxFields = {
  __typename?: 'BookingScheduleModesMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type BookingScheduleModesMinFields = {
  __typename?: 'BookingScheduleModesMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "booking_schedule_modes" */
export type BookingScheduleModesMutationResponse = {
  __typename?: 'BookingScheduleModesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<BookingScheduleModes>;
};

/** on_conflict condition type for table "booking_schedule_modes" */
export type BookingScheduleModesOnConflict = {
  constraint: BookingScheduleModesConstraint;
  updateColumns?: Array<BookingScheduleModesUpdateColumn>;
  where?: InputMaybe<BookingScheduleModesBoolExp>;
};

/** Ordering options when selecting data from "booking_schedule_modes". */
export type BookingScheduleModesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: booking_schedule_modes */
export type BookingScheduleModesPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "booking_schedule_modes" */
export enum BookingScheduleModesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "booking_schedule_modes" */
export type BookingScheduleModesSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "booking_schedule_modes" */
export type BookingScheduleModesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: BookingScheduleModesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BookingScheduleModesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "booking_schedule_modes" */
export enum BookingScheduleModesUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type BookingScheduleModesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BookingScheduleModesSetInput>;
  /** filter the rows which have to be updated */
  where: BookingScheduleModesBoolExp;
};

/** columns and relationships of "booking_systems" */
export type BookingSystems = {
  __typename?: 'BookingSystems';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "booking_systems" */
export type BookingSystemsAggregate = {
  __typename?: 'BookingSystemsAggregate';
  aggregate?: Maybe<BookingSystemsAggregateFields>;
  nodes: Array<BookingSystems>;
};

/** aggregate fields of "booking_systems" */
export type BookingSystemsAggregateFields = {
  __typename?: 'BookingSystemsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<BookingSystemsMaxFields>;
  min?: Maybe<BookingSystemsMinFields>;
};


/** aggregate fields of "booking_systems" */
export type BookingSystemsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<BookingSystemsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "booking_systems". All fields are combined with a logical 'AND'. */
export type BookingSystemsBoolExp = {
  _and?: InputMaybe<Array<BookingSystemsBoolExp>>;
  _not?: InputMaybe<BookingSystemsBoolExp>;
  _or?: InputMaybe<Array<BookingSystemsBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "booking_systems" */
export enum BookingSystemsConstraint {
  /** unique or primary key constraint on columns "value" */
  BookingSystemsPkey = 'booking_systems_pkey'
}

export enum BookingSystemsEnum {
  /** CourtReserve */
  CourtReserve = 'COURT_RESERVE',
  /** No booking system */
  None = 'NONE',
  /** Another booking system */
  Other = 'OTHER',
  /** PlayByPoint */
  Playbypoint = 'PLAYBYPOINT',
  /** PodPlay */
  Podplay = 'PODPLAY'
}

/** Boolean expression to compare columns of type "BookingSystemsEnum". All fields are combined with logical 'AND'. */
export type BookingSystemsEnumComparisonExp = {
  _eq?: InputMaybe<BookingSystemsEnum>;
  _in?: InputMaybe<Array<BookingSystemsEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<BookingSystemsEnum>;
  _nin?: InputMaybe<Array<BookingSystemsEnum>>;
};

/** input type for inserting data into table "booking_systems" */
export type BookingSystemsInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type BookingSystemsMaxFields = {
  __typename?: 'BookingSystemsMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type BookingSystemsMinFields = {
  __typename?: 'BookingSystemsMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "booking_systems" */
export type BookingSystemsMutationResponse = {
  __typename?: 'BookingSystemsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<BookingSystems>;
};

/** on_conflict condition type for table "booking_systems" */
export type BookingSystemsOnConflict = {
  constraint: BookingSystemsConstraint;
  updateColumns?: Array<BookingSystemsUpdateColumn>;
  where?: InputMaybe<BookingSystemsBoolExp>;
};

/** Ordering options when selecting data from "booking_systems". */
export type BookingSystemsOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: booking_systems */
export type BookingSystemsPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "booking_systems" */
export enum BookingSystemsSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "booking_systems" */
export type BookingSystemsSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "booking_systems" */
export type BookingSystemsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: BookingSystemsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BookingSystemsStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "booking_systems" */
export enum BookingSystemsUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type BookingSystemsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BookingSystemsSetInput>;
  /** filter the rows which have to be updated */
  where: BookingSystemsBoolExp;
};

/** columns and relationships of "booking_window_kinds" */
export type BookingWindowKinds = {
  __typename?: 'BookingWindowKinds';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "booking_window_kinds" */
export type BookingWindowKindsAggregate = {
  __typename?: 'BookingWindowKindsAggregate';
  aggregate?: Maybe<BookingWindowKindsAggregateFields>;
  nodes: Array<BookingWindowKinds>;
};

/** aggregate fields of "booking_window_kinds" */
export type BookingWindowKindsAggregateFields = {
  __typename?: 'BookingWindowKindsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<BookingWindowKindsMaxFields>;
  min?: Maybe<BookingWindowKindsMinFields>;
};


/** aggregate fields of "booking_window_kinds" */
export type BookingWindowKindsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<BookingWindowKindsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "booking_window_kinds". All fields are combined with a logical 'AND'. */
export type BookingWindowKindsBoolExp = {
  _and?: InputMaybe<Array<BookingWindowKindsBoolExp>>;
  _not?: InputMaybe<BookingWindowKindsBoolExp>;
  _or?: InputMaybe<Array<BookingWindowKindsBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "booking_window_kinds" */
export enum BookingWindowKindsConstraint {
  /** unique or primary key constraint on columns "value" */
  BookingWindowKindsPkey = 'booking_window_kinds_pkey'
}

export enum BookingWindowKindsEnum {
  /** When Bounce may book */
  Bookable = 'BOOKABLE',
  /** When the partner discount applies */
  Discount = 'DISCOUNT',
  /** When the peak rate applies */
  Peak = 'PEAK'
}

/** Boolean expression to compare columns of type "BookingWindowKindsEnum". All fields are combined with logical 'AND'. */
export type BookingWindowKindsEnumComparisonExp = {
  _eq?: InputMaybe<BookingWindowKindsEnum>;
  _in?: InputMaybe<Array<BookingWindowKindsEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<BookingWindowKindsEnum>;
  _nin?: InputMaybe<Array<BookingWindowKindsEnum>>;
};

/** input type for inserting data into table "booking_window_kinds" */
export type BookingWindowKindsInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type BookingWindowKindsMaxFields = {
  __typename?: 'BookingWindowKindsMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type BookingWindowKindsMinFields = {
  __typename?: 'BookingWindowKindsMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "booking_window_kinds" */
export type BookingWindowKindsMutationResponse = {
  __typename?: 'BookingWindowKindsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<BookingWindowKinds>;
};

/** on_conflict condition type for table "booking_window_kinds" */
export type BookingWindowKindsOnConflict = {
  constraint: BookingWindowKindsConstraint;
  updateColumns?: Array<BookingWindowKindsUpdateColumn>;
  where?: InputMaybe<BookingWindowKindsBoolExp>;
};

/** Ordering options when selecting data from "booking_window_kinds". */
export type BookingWindowKindsOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: booking_window_kinds */
export type BookingWindowKindsPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "booking_window_kinds" */
export enum BookingWindowKindsSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "booking_window_kinds" */
export type BookingWindowKindsSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "booking_window_kinds" */
export type BookingWindowKindsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: BookingWindowKindsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BookingWindowKindsStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "booking_window_kinds" */
export enum BookingWindowKindsUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type BookingWindowKindsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BookingWindowKindsSetInput>;
  /** filter the rows which have to be updated */
  where: BookingWindowKindsBoolExp;
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type BooleanComparisonExp = {
  _eq?: InputMaybe<Scalars['Boolean']>;
  _gt?: InputMaybe<Scalars['Boolean']>;
  _gte?: InputMaybe<Scalars['Boolean']>;
  _in?: InputMaybe<Array<Scalars['Boolean']>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Boolean']>;
  _lte?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Scalars['Boolean']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']>>;
};

/** columns and relationships of "boost_channels" */
export type BoostChannels = {
  __typename?: 'BoostChannels';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "boost_channels" */
export type BoostChannelsAggregate = {
  __typename?: 'BoostChannelsAggregate';
  aggregate?: Maybe<BoostChannelsAggregateFields>;
  nodes: Array<BoostChannels>;
};

/** aggregate fields of "boost_channels" */
export type BoostChannelsAggregateFields = {
  __typename?: 'BoostChannelsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<BoostChannelsMaxFields>;
  min?: Maybe<BoostChannelsMinFields>;
};


/** aggregate fields of "boost_channels" */
export type BoostChannelsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<BoostChannelsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "boost_channels". All fields are combined with a logical 'AND'. */
export type BoostChannelsBoolExp = {
  _and?: InputMaybe<Array<BoostChannelsBoolExp>>;
  _not?: InputMaybe<BoostChannelsBoolExp>;
  _or?: InputMaybe<Array<BoostChannelsBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "boost_channels" */
export enum BoostChannelsConstraint {
  /** unique or primary key constraint on columns "value" */
  BoostChannelsPkey = 'boost_channels_pkey'
}

export enum BoostChannelsEnum {
  Marketplace = 'MARKETPLACE',
  Newsletter = 'NEWSLETTER'
}

/** Boolean expression to compare columns of type "BoostChannelsEnum". All fields are combined with logical 'AND'. */
export type BoostChannelsEnumComparisonExp = {
  _eq?: InputMaybe<BoostChannelsEnum>;
  _in?: InputMaybe<Array<BoostChannelsEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<BoostChannelsEnum>;
  _nin?: InputMaybe<Array<BoostChannelsEnum>>;
};

/** input type for inserting data into table "boost_channels" */
export type BoostChannelsInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type BoostChannelsMaxFields = {
  __typename?: 'BoostChannelsMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type BoostChannelsMinFields = {
  __typename?: 'BoostChannelsMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "boost_channels" */
export type BoostChannelsMutationResponse = {
  __typename?: 'BoostChannelsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<BoostChannels>;
};

/** on_conflict condition type for table "boost_channels" */
export type BoostChannelsOnConflict = {
  constraint: BoostChannelsConstraint;
  updateColumns?: Array<BoostChannelsUpdateColumn>;
  where?: InputMaybe<BoostChannelsBoolExp>;
};

/** Ordering options when selecting data from "boost_channels". */
export type BoostChannelsOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: boost_channels */
export type BoostChannelsPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "boost_channels" */
export enum BoostChannelsSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "boost_channels" */
export type BoostChannelsSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "boost_channels" */
export type BoostChannelsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: BoostChannelsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BoostChannelsStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "boost_channels" */
export enum BoostChannelsUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type BoostChannelsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BoostChannelsSetInput>;
  /** filter the rows which have to be updated */
  where: BoostChannelsBoolExp;
};

/** columns and relationships of "boost_orders" */
export type BoostOrders = {
  __typename?: 'BoostOrders';
  /** An array relationship */
  boosts: Array<Boosts>;
  /** An aggregate relationship */
  boostsAggregate: BoostsAggregate;
  createdAt: Scalars['timestamptz'];
  currency: Scalars['String'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  externalStripePaymentIntent?: Maybe<StripePaymentIntents>;
  externalStripePaymentIntentId?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  /** An object relationship */
  internalStripePaymentIntent?: Maybe<StripePaymentIntents>;
  internalStripePaymentIntentId?: Maybe<Scalars['uuid']>;
  orderSubtotalUnitAmount: Scalars['Int'];
  orderTotalUnitAmount: Scalars['Int'];
  paidUnitAmount: Scalars['Int'];
  paymentProcessor?: Maybe<PaymentProcessorsEnum>;
  purchasedByUserId: Scalars['uuid'];
  /** An object relationship */
  purchaser: Users;
  refundUnitAmount: Scalars['Int'];
  refundedAt?: Maybe<Scalars['timestamptz']>;
  refundedByPersona?: Maybe<AppPersonasEnum>;
  status: OrderStatusesEnum;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentStatus?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  userCreditCard?: Maybe<UserCreditCards>;
  userCreditCardId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  venue?: Maybe<Venues>;
  venueId?: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "boost_orders" */
export type BoostOrdersBoostsArgs = {
  distinctOn?: InputMaybe<Array<BoostsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BoostsOrderBy>>;
  where?: InputMaybe<BoostsBoolExp>;
};


/** columns and relationships of "boost_orders" */
export type BoostOrdersBoostsAggregateArgs = {
  distinctOn?: InputMaybe<Array<BoostsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BoostsOrderBy>>;
  where?: InputMaybe<BoostsBoolExp>;
};

/** aggregated selection of "boost_orders" */
export type BoostOrdersAggregate = {
  __typename?: 'BoostOrdersAggregate';
  aggregate?: Maybe<BoostOrdersAggregateFields>;
  nodes: Array<BoostOrders>;
};

/** aggregate fields of "boost_orders" */
export type BoostOrdersAggregateFields = {
  __typename?: 'BoostOrdersAggregateFields';
  avg?: Maybe<BoostOrdersAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<BoostOrdersMaxFields>;
  min?: Maybe<BoostOrdersMinFields>;
  stddev?: Maybe<BoostOrdersStddevFields>;
  stddevPop?: Maybe<BoostOrdersStddevPopFields>;
  stddevSamp?: Maybe<BoostOrdersStddevSampFields>;
  sum?: Maybe<BoostOrdersSumFields>;
  varPop?: Maybe<BoostOrdersVarPopFields>;
  varSamp?: Maybe<BoostOrdersVarSampFields>;
  variance?: Maybe<BoostOrdersVarianceFields>;
};


/** aggregate fields of "boost_orders" */
export type BoostOrdersAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<BoostOrdersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type BoostOrdersAvgFields = {
  __typename?: 'BoostOrdersAvgFields';
  orderSubtotalUnitAmount?: Maybe<Scalars['Float']>;
  orderTotalUnitAmount?: Maybe<Scalars['Float']>;
  paidUnitAmount?: Maybe<Scalars['Float']>;
  refundUnitAmount?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "boost_orders". All fields are combined with a logical 'AND'. */
export type BoostOrdersBoolExp = {
  _and?: InputMaybe<Array<BoostOrdersBoolExp>>;
  _not?: InputMaybe<BoostOrdersBoolExp>;
  _or?: InputMaybe<Array<BoostOrdersBoolExp>>;
  boosts?: InputMaybe<BoostsBoolExp>;
  boostsAggregate?: InputMaybe<BoostsAggregateBoolExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  currency?: InputMaybe<StringComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  externalStripePaymentIntent?: InputMaybe<StripePaymentIntentsBoolExp>;
  externalStripePaymentIntentId?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  internalStripePaymentIntent?: InputMaybe<StripePaymentIntentsBoolExp>;
  internalStripePaymentIntentId?: InputMaybe<UuidComparisonExp>;
  orderSubtotalUnitAmount?: InputMaybe<IntComparisonExp>;
  orderTotalUnitAmount?: InputMaybe<IntComparisonExp>;
  paidUnitAmount?: InputMaybe<IntComparisonExp>;
  paymentProcessor?: InputMaybe<PaymentProcessorsEnumComparisonExp>;
  purchasedByUserId?: InputMaybe<UuidComparisonExp>;
  purchaser?: InputMaybe<UsersBoolExp>;
  refundUnitAmount?: InputMaybe<IntComparisonExp>;
  refundedAt?: InputMaybe<TimestamptzComparisonExp>;
  refundedByPersona?: InputMaybe<AppPersonasEnumComparisonExp>;
  status?: InputMaybe<OrderStatusesEnumComparisonExp>;
  stripeCustomerId?: InputMaybe<StringComparisonExp>;
  stripePaymentStatus?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  userCreditCard?: InputMaybe<UserCreditCardsBoolExp>;
  userCreditCardId?: InputMaybe<UuidComparisonExp>;
  venue?: InputMaybe<VenuesBoolExp>;
  venueId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "boost_orders" */
export enum BoostOrdersConstraint {
  /** unique or primary key constraint on columns "id" */
  BoostOrdersPkey = 'boost_orders_pkey'
}

/** input type for incrementing numeric columns in table "boost_orders" */
export type BoostOrdersIncInput = {
  orderSubtotalUnitAmount?: InputMaybe<Scalars['Int']>;
  orderTotalUnitAmount?: InputMaybe<Scalars['Int']>;
  paidUnitAmount?: InputMaybe<Scalars['Int']>;
  refundUnitAmount?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "boost_orders" */
export type BoostOrdersInsertInput = {
  boosts?: InputMaybe<BoostsArrRelInsertInput>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  externalStripePaymentIntent?: InputMaybe<StripePaymentIntentsObjRelInsertInput>;
  externalStripePaymentIntentId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  internalStripePaymentIntent?: InputMaybe<StripePaymentIntentsObjRelInsertInput>;
  internalStripePaymentIntentId?: InputMaybe<Scalars['uuid']>;
  orderSubtotalUnitAmount?: InputMaybe<Scalars['Int']>;
  orderTotalUnitAmount?: InputMaybe<Scalars['Int']>;
  paidUnitAmount?: InputMaybe<Scalars['Int']>;
  paymentProcessor?: InputMaybe<PaymentProcessorsEnum>;
  purchasedByUserId?: InputMaybe<Scalars['uuid']>;
  purchaser?: InputMaybe<UsersObjRelInsertInput>;
  refundUnitAmount?: InputMaybe<Scalars['Int']>;
  refundedAt?: InputMaybe<Scalars['timestamptz']>;
  refundedByPersona?: InputMaybe<AppPersonasEnum>;
  status?: InputMaybe<OrderStatusesEnum>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  stripePaymentStatus?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userCreditCard?: InputMaybe<UserCreditCardsObjRelInsertInput>;
  userCreditCardId?: InputMaybe<Scalars['uuid']>;
  venue?: InputMaybe<VenuesObjRelInsertInput>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type BoostOrdersMaxFields = {
  __typename?: 'BoostOrdersMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  externalStripePaymentIntentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  internalStripePaymentIntentId?: Maybe<Scalars['uuid']>;
  orderSubtotalUnitAmount?: Maybe<Scalars['Int']>;
  orderTotalUnitAmount?: Maybe<Scalars['Int']>;
  paidUnitAmount?: Maybe<Scalars['Int']>;
  purchasedByUserId?: Maybe<Scalars['uuid']>;
  refundUnitAmount?: Maybe<Scalars['Int']>;
  refundedAt?: Maybe<Scalars['timestamptz']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentStatus?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userCreditCardId?: Maybe<Scalars['uuid']>;
  venueId?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type BoostOrdersMinFields = {
  __typename?: 'BoostOrdersMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  externalStripePaymentIntentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  internalStripePaymentIntentId?: Maybe<Scalars['uuid']>;
  orderSubtotalUnitAmount?: Maybe<Scalars['Int']>;
  orderTotalUnitAmount?: Maybe<Scalars['Int']>;
  paidUnitAmount?: Maybe<Scalars['Int']>;
  purchasedByUserId?: Maybe<Scalars['uuid']>;
  refundUnitAmount?: Maybe<Scalars['Int']>;
  refundedAt?: Maybe<Scalars['timestamptz']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentStatus?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userCreditCardId?: Maybe<Scalars['uuid']>;
  venueId?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "boost_orders" */
export type BoostOrdersMutationResponse = {
  __typename?: 'BoostOrdersMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<BoostOrders>;
};

/** input type for inserting object relation for remote table "boost_orders" */
export type BoostOrdersObjRelInsertInput = {
  data: BoostOrdersInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<BoostOrdersOnConflict>;
};

/** on_conflict condition type for table "boost_orders" */
export type BoostOrdersOnConflict = {
  constraint: BoostOrdersConstraint;
  updateColumns?: Array<BoostOrdersUpdateColumn>;
  where?: InputMaybe<BoostOrdersBoolExp>;
};

/** Ordering options when selecting data from "boost_orders". */
export type BoostOrdersOrderBy = {
  boostsAggregate?: InputMaybe<BoostsAggregateOrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  currency?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  externalStripePaymentIntent?: InputMaybe<StripePaymentIntentsOrderBy>;
  externalStripePaymentIntentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  internalStripePaymentIntent?: InputMaybe<StripePaymentIntentsOrderBy>;
  internalStripePaymentIntentId?: InputMaybe<OrderBy>;
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  paymentProcessor?: InputMaybe<OrderBy>;
  purchasedByUserId?: InputMaybe<OrderBy>;
  purchaser?: InputMaybe<UsersOrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  refundedAt?: InputMaybe<OrderBy>;
  refundedByPersona?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  stripeCustomerId?: InputMaybe<OrderBy>;
  stripePaymentStatus?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userCreditCard?: InputMaybe<UserCreditCardsOrderBy>;
  userCreditCardId?: InputMaybe<OrderBy>;
  venue?: InputMaybe<VenuesOrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: boost_orders */
export type BoostOrdersPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "boost_orders" */
export enum BoostOrdersSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Currency = 'currency',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  ExternalStripePaymentIntentId = 'externalStripePaymentIntentId',
  /** column name */
  Id = 'id',
  /** column name */
  InternalStripePaymentIntentId = 'internalStripePaymentIntentId',
  /** column name */
  OrderSubtotalUnitAmount = 'orderSubtotalUnitAmount',
  /** column name */
  OrderTotalUnitAmount = 'orderTotalUnitAmount',
  /** column name */
  PaidUnitAmount = 'paidUnitAmount',
  /** column name */
  PaymentProcessor = 'paymentProcessor',
  /** column name */
  PurchasedByUserId = 'purchasedByUserId',
  /** column name */
  RefundUnitAmount = 'refundUnitAmount',
  /** column name */
  RefundedAt = 'refundedAt',
  /** column name */
  RefundedByPersona = 'refundedByPersona',
  /** column name */
  Status = 'status',
  /** column name */
  StripeCustomerId = 'stripeCustomerId',
  /** column name */
  StripePaymentStatus = 'stripePaymentStatus',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserCreditCardId = 'userCreditCardId',
  /** column name */
  VenueId = 'venueId'
}

/** input type for updating data in table "boost_orders" */
export type BoostOrdersSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  externalStripePaymentIntentId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  internalStripePaymentIntentId?: InputMaybe<Scalars['uuid']>;
  orderSubtotalUnitAmount?: InputMaybe<Scalars['Int']>;
  orderTotalUnitAmount?: InputMaybe<Scalars['Int']>;
  paidUnitAmount?: InputMaybe<Scalars['Int']>;
  paymentProcessor?: InputMaybe<PaymentProcessorsEnum>;
  purchasedByUserId?: InputMaybe<Scalars['uuid']>;
  refundUnitAmount?: InputMaybe<Scalars['Int']>;
  refundedAt?: InputMaybe<Scalars['timestamptz']>;
  refundedByPersona?: InputMaybe<AppPersonasEnum>;
  status?: InputMaybe<OrderStatusesEnum>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  stripePaymentStatus?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userCreditCardId?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type BoostOrdersStddevFields = {
  __typename?: 'BoostOrdersStddevFields';
  orderSubtotalUnitAmount?: Maybe<Scalars['Float']>;
  orderTotalUnitAmount?: Maybe<Scalars['Float']>;
  paidUnitAmount?: Maybe<Scalars['Float']>;
  refundUnitAmount?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type BoostOrdersStddevPopFields = {
  __typename?: 'BoostOrdersStddevPopFields';
  orderSubtotalUnitAmount?: Maybe<Scalars['Float']>;
  orderTotalUnitAmount?: Maybe<Scalars['Float']>;
  paidUnitAmount?: Maybe<Scalars['Float']>;
  refundUnitAmount?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type BoostOrdersStddevSampFields = {
  __typename?: 'BoostOrdersStddevSampFields';
  orderSubtotalUnitAmount?: Maybe<Scalars['Float']>;
  orderTotalUnitAmount?: Maybe<Scalars['Float']>;
  paidUnitAmount?: Maybe<Scalars['Float']>;
  refundUnitAmount?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "boost_orders" */
export type BoostOrdersStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: BoostOrdersStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BoostOrdersStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  externalStripePaymentIntentId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  internalStripePaymentIntentId?: InputMaybe<Scalars['uuid']>;
  orderSubtotalUnitAmount?: InputMaybe<Scalars['Int']>;
  orderTotalUnitAmount?: InputMaybe<Scalars['Int']>;
  paidUnitAmount?: InputMaybe<Scalars['Int']>;
  paymentProcessor?: InputMaybe<PaymentProcessorsEnum>;
  purchasedByUserId?: InputMaybe<Scalars['uuid']>;
  refundUnitAmount?: InputMaybe<Scalars['Int']>;
  refundedAt?: InputMaybe<Scalars['timestamptz']>;
  refundedByPersona?: InputMaybe<AppPersonasEnum>;
  status?: InputMaybe<OrderStatusesEnum>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  stripePaymentStatus?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userCreditCardId?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type BoostOrdersSumFields = {
  __typename?: 'BoostOrdersSumFields';
  orderSubtotalUnitAmount?: Maybe<Scalars['Int']>;
  orderTotalUnitAmount?: Maybe<Scalars['Int']>;
  paidUnitAmount?: Maybe<Scalars['Int']>;
  refundUnitAmount?: Maybe<Scalars['Int']>;
};

/** update columns of table "boost_orders" */
export enum BoostOrdersUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Currency = 'currency',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  ExternalStripePaymentIntentId = 'externalStripePaymentIntentId',
  /** column name */
  Id = 'id',
  /** column name */
  InternalStripePaymentIntentId = 'internalStripePaymentIntentId',
  /** column name */
  OrderSubtotalUnitAmount = 'orderSubtotalUnitAmount',
  /** column name */
  OrderTotalUnitAmount = 'orderTotalUnitAmount',
  /** column name */
  PaidUnitAmount = 'paidUnitAmount',
  /** column name */
  PaymentProcessor = 'paymentProcessor',
  /** column name */
  PurchasedByUserId = 'purchasedByUserId',
  /** column name */
  RefundUnitAmount = 'refundUnitAmount',
  /** column name */
  RefundedAt = 'refundedAt',
  /** column name */
  RefundedByPersona = 'refundedByPersona',
  /** column name */
  Status = 'status',
  /** column name */
  StripeCustomerId = 'stripeCustomerId',
  /** column name */
  StripePaymentStatus = 'stripePaymentStatus',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserCreditCardId = 'userCreditCardId',
  /** column name */
  VenueId = 'venueId'
}

export type BoostOrdersUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<BoostOrdersIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BoostOrdersSetInput>;
  /** filter the rows which have to be updated */
  where: BoostOrdersBoolExp;
};

/** aggregate varPop on columns */
export type BoostOrdersVarPopFields = {
  __typename?: 'BoostOrdersVarPopFields';
  orderSubtotalUnitAmount?: Maybe<Scalars['Float']>;
  orderTotalUnitAmount?: Maybe<Scalars['Float']>;
  paidUnitAmount?: Maybe<Scalars['Float']>;
  refundUnitAmount?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type BoostOrdersVarSampFields = {
  __typename?: 'BoostOrdersVarSampFields';
  orderSubtotalUnitAmount?: Maybe<Scalars['Float']>;
  orderTotalUnitAmount?: Maybe<Scalars['Float']>;
  paidUnitAmount?: Maybe<Scalars['Float']>;
  refundUnitAmount?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type BoostOrdersVarianceFields = {
  __typename?: 'BoostOrdersVarianceFields';
  orderSubtotalUnitAmount?: Maybe<Scalars['Float']>;
  orderTotalUnitAmount?: Maybe<Scalars['Float']>;
  paidUnitAmount?: Maybe<Scalars['Float']>;
  refundUnitAmount?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "boost_statuses" */
export type BoostStatuses = {
  __typename?: 'BoostStatuses';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "boost_statuses" */
export type BoostStatusesAggregate = {
  __typename?: 'BoostStatusesAggregate';
  aggregate?: Maybe<BoostStatusesAggregateFields>;
  nodes: Array<BoostStatuses>;
};

/** aggregate fields of "boost_statuses" */
export type BoostStatusesAggregateFields = {
  __typename?: 'BoostStatusesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<BoostStatusesMaxFields>;
  min?: Maybe<BoostStatusesMinFields>;
};


/** aggregate fields of "boost_statuses" */
export type BoostStatusesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<BoostStatusesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "boost_statuses". All fields are combined with a logical 'AND'. */
export type BoostStatusesBoolExp = {
  _and?: InputMaybe<Array<BoostStatusesBoolExp>>;
  _not?: InputMaybe<BoostStatusesBoolExp>;
  _or?: InputMaybe<Array<BoostStatusesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "boost_statuses" */
export enum BoostStatusesConstraint {
  /** unique or primary key constraint on columns "value" */
  BoostStatusesPkey = 'boost_statuses_pkey'
}

export enum BoostStatusesEnum {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Pending = 'PENDING'
}

/** Boolean expression to compare columns of type "BoostStatusesEnum". All fields are combined with logical 'AND'. */
export type BoostStatusesEnumComparisonExp = {
  _eq?: InputMaybe<BoostStatusesEnum>;
  _in?: InputMaybe<Array<BoostStatusesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<BoostStatusesEnum>;
  _nin?: InputMaybe<Array<BoostStatusesEnum>>;
};

/** input type for inserting data into table "boost_statuses" */
export type BoostStatusesInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type BoostStatusesMaxFields = {
  __typename?: 'BoostStatusesMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type BoostStatusesMinFields = {
  __typename?: 'BoostStatusesMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "boost_statuses" */
export type BoostStatusesMutationResponse = {
  __typename?: 'BoostStatusesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<BoostStatuses>;
};

/** on_conflict condition type for table "boost_statuses" */
export type BoostStatusesOnConflict = {
  constraint: BoostStatusesConstraint;
  updateColumns?: Array<BoostStatusesUpdateColumn>;
  where?: InputMaybe<BoostStatusesBoolExp>;
};

/** Ordering options when selecting data from "boost_statuses". */
export type BoostStatusesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: boost_statuses */
export type BoostStatusesPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "boost_statuses" */
export enum BoostStatusesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "boost_statuses" */
export type BoostStatusesSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "boost_statuses" */
export type BoostStatusesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: BoostStatusesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BoostStatusesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "boost_statuses" */
export enum BoostStatusesUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type BoostStatusesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BoostStatusesSetInput>;
  /** filter the rows which have to be updated */
  where: BoostStatusesBoolExp;
};

/** columns and relationships of "boosts" */
export type Boosts = {
  __typename?: 'Boosts';
  /** An object relationship */
  boostOrder: BoostOrders;
  boostOrderId: Scalars['uuid'];
  channel: BoostChannelsEnum;
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  endsAt: Scalars['timestamptz'];
  /** An array relationship */
  engagements: Array<EngagementAnalytics>;
  /** An aggregate relationship */
  engagementsAggregate: EngagementAnalyticsAggregate;
  entityType: EngagementEntityTypesEnum;
  /** An object relationship */
  event?: Maybe<Events>;
  eventId?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  /** An object relationship */
  lesson?: Maybe<Lessons>;
  lessonId?: Maybe<Scalars['uuid']>;
  priceUnitAmount: Scalars['Int'];
  quantity: Scalars['Int'];
  refundUnitAmount: Scalars['Int'];
  refundedAt?: Maybe<Scalars['timestamptz']>;
  startsAt: Scalars['timestamptz'];
  status: BoostStatusesEnum;
  totalUnitAmount: Scalars['Int'];
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "boosts" */
export type BoostsEngagementsArgs = {
  distinctOn?: InputMaybe<Array<EngagementAnalyticsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EngagementAnalyticsOrderBy>>;
  where?: InputMaybe<EngagementAnalyticsBoolExp>;
};


/** columns and relationships of "boosts" */
export type BoostsEngagementsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EngagementAnalyticsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EngagementAnalyticsOrderBy>>;
  where?: InputMaybe<EngagementAnalyticsBoolExp>;
};

/** aggregated selection of "boosts" */
export type BoostsAggregate = {
  __typename?: 'BoostsAggregate';
  aggregate?: Maybe<BoostsAggregateFields>;
  nodes: Array<Boosts>;
};

export type BoostsAggregateBoolExp = {
  count?: InputMaybe<BoostsAggregateBoolExpCount>;
};

/** aggregate fields of "boosts" */
export type BoostsAggregateFields = {
  __typename?: 'BoostsAggregateFields';
  avg?: Maybe<BoostsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<BoostsMaxFields>;
  min?: Maybe<BoostsMinFields>;
  stddev?: Maybe<BoostsStddevFields>;
  stddevPop?: Maybe<BoostsStddevPopFields>;
  stddevSamp?: Maybe<BoostsStddevSampFields>;
  sum?: Maybe<BoostsSumFields>;
  varPop?: Maybe<BoostsVarPopFields>;
  varSamp?: Maybe<BoostsVarSampFields>;
  variance?: Maybe<BoostsVarianceFields>;
};


/** aggregate fields of "boosts" */
export type BoostsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<BoostsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "boosts" */
export type BoostsAggregateOrderBy = {
  avg?: InputMaybe<BoostsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<BoostsMaxOrderBy>;
  min?: InputMaybe<BoostsMinOrderBy>;
  stddev?: InputMaybe<BoostsStddevOrderBy>;
  stddevPop?: InputMaybe<BoostsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<BoostsStddevSampOrderBy>;
  sum?: InputMaybe<BoostsSumOrderBy>;
  varPop?: InputMaybe<BoostsVarPopOrderBy>;
  varSamp?: InputMaybe<BoostsVarSampOrderBy>;
  variance?: InputMaybe<BoostsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "boosts" */
export type BoostsArrRelInsertInput = {
  data: Array<BoostsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<BoostsOnConflict>;
};

/** aggregate avg on columns */
export type BoostsAvgFields = {
  __typename?: 'BoostsAvgFields';
  priceUnitAmount?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  refundUnitAmount?: Maybe<Scalars['Float']>;
  totalUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "boosts" */
export type BoostsAvgOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
  quantity?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  totalUnitAmount?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "boosts". All fields are combined with a logical 'AND'. */
export type BoostsBoolExp = {
  _and?: InputMaybe<Array<BoostsBoolExp>>;
  _not?: InputMaybe<BoostsBoolExp>;
  _or?: InputMaybe<Array<BoostsBoolExp>>;
  boostOrder?: InputMaybe<BoostOrdersBoolExp>;
  boostOrderId?: InputMaybe<UuidComparisonExp>;
  channel?: InputMaybe<BoostChannelsEnumComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  endsAt?: InputMaybe<TimestamptzComparisonExp>;
  engagements?: InputMaybe<EngagementAnalyticsBoolExp>;
  engagementsAggregate?: InputMaybe<EngagementAnalyticsAggregateBoolExp>;
  entityType?: InputMaybe<EngagementEntityTypesEnumComparisonExp>;
  event?: InputMaybe<EventsBoolExp>;
  eventId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  lesson?: InputMaybe<LessonsBoolExp>;
  lessonId?: InputMaybe<UuidComparisonExp>;
  priceUnitAmount?: InputMaybe<IntComparisonExp>;
  quantity?: InputMaybe<IntComparisonExp>;
  refundUnitAmount?: InputMaybe<IntComparisonExp>;
  refundedAt?: InputMaybe<TimestamptzComparisonExp>;
  startsAt?: InputMaybe<TimestamptzComparisonExp>;
  status?: InputMaybe<BoostStatusesEnumComparisonExp>;
  totalUnitAmount?: InputMaybe<IntComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "boosts" */
export enum BoostsConstraint {
  /** unique or primary key constraint on columns "id" */
  BoostsPkey = 'boosts_pkey'
}

/** input type for incrementing numeric columns in table "boosts" */
export type BoostsIncInput = {
  priceUnitAmount?: InputMaybe<Scalars['Int']>;
  quantity?: InputMaybe<Scalars['Int']>;
  refundUnitAmount?: InputMaybe<Scalars['Int']>;
  totalUnitAmount?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "boosts" */
export type BoostsInsertInput = {
  boostOrder?: InputMaybe<BoostOrdersObjRelInsertInput>;
  boostOrderId?: InputMaybe<Scalars['uuid']>;
  channel?: InputMaybe<BoostChannelsEnum>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  endsAt?: InputMaybe<Scalars['timestamptz']>;
  engagements?: InputMaybe<EngagementAnalyticsArrRelInsertInput>;
  entityType?: InputMaybe<EngagementEntityTypesEnum>;
  event?: InputMaybe<EventsObjRelInsertInput>;
  eventId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  lesson?: InputMaybe<LessonsObjRelInsertInput>;
  lessonId?: InputMaybe<Scalars['uuid']>;
  priceUnitAmount?: InputMaybe<Scalars['Int']>;
  quantity?: InputMaybe<Scalars['Int']>;
  refundUnitAmount?: InputMaybe<Scalars['Int']>;
  refundedAt?: InputMaybe<Scalars['timestamptz']>;
  startsAt?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<BoostStatusesEnum>;
  totalUnitAmount?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type BoostsMaxFields = {
  __typename?: 'BoostsMaxFields';
  boostOrderId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  endsAt?: Maybe<Scalars['timestamptz']>;
  eventId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  lessonId?: Maybe<Scalars['uuid']>;
  priceUnitAmount?: Maybe<Scalars['Int']>;
  quantity?: Maybe<Scalars['Int']>;
  refundUnitAmount?: Maybe<Scalars['Int']>;
  refundedAt?: Maybe<Scalars['timestamptz']>;
  startsAt?: Maybe<Scalars['timestamptz']>;
  totalUnitAmount?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "boosts" */
export type BoostsMaxOrderBy = {
  boostOrderId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  endsAt?: InputMaybe<OrderBy>;
  eventId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lessonId?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  quantity?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  refundedAt?: InputMaybe<OrderBy>;
  startsAt?: InputMaybe<OrderBy>;
  totalUnitAmount?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type BoostsMinFields = {
  __typename?: 'BoostsMinFields';
  boostOrderId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  endsAt?: Maybe<Scalars['timestamptz']>;
  eventId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  lessonId?: Maybe<Scalars['uuid']>;
  priceUnitAmount?: Maybe<Scalars['Int']>;
  quantity?: Maybe<Scalars['Int']>;
  refundUnitAmount?: Maybe<Scalars['Int']>;
  refundedAt?: Maybe<Scalars['timestamptz']>;
  startsAt?: Maybe<Scalars['timestamptz']>;
  totalUnitAmount?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "boosts" */
export type BoostsMinOrderBy = {
  boostOrderId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  endsAt?: InputMaybe<OrderBy>;
  eventId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lessonId?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  quantity?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  refundedAt?: InputMaybe<OrderBy>;
  startsAt?: InputMaybe<OrderBy>;
  totalUnitAmount?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "boosts" */
export type BoostsMutationResponse = {
  __typename?: 'BoostsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Boosts>;
};

/** input type for inserting object relation for remote table "boosts" */
export type BoostsObjRelInsertInput = {
  data: BoostsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<BoostsOnConflict>;
};

/** on_conflict condition type for table "boosts" */
export type BoostsOnConflict = {
  constraint: BoostsConstraint;
  updateColumns?: Array<BoostsUpdateColumn>;
  where?: InputMaybe<BoostsBoolExp>;
};

/** Ordering options when selecting data from "boosts". */
export type BoostsOrderBy = {
  boostOrder?: InputMaybe<BoostOrdersOrderBy>;
  boostOrderId?: InputMaybe<OrderBy>;
  channel?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  endsAt?: InputMaybe<OrderBy>;
  engagementsAggregate?: InputMaybe<EngagementAnalyticsAggregateOrderBy>;
  entityType?: InputMaybe<OrderBy>;
  event?: InputMaybe<EventsOrderBy>;
  eventId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lesson?: InputMaybe<LessonsOrderBy>;
  lessonId?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  quantity?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  refundedAt?: InputMaybe<OrderBy>;
  startsAt?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  totalUnitAmount?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: boosts */
export type BoostsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "boosts" */
export enum BoostsSelectColumn {
  /** column name */
  BoostOrderId = 'boostOrderId',
  /** column name */
  Channel = 'channel',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EndsAt = 'endsAt',
  /** column name */
  EntityType = 'entityType',
  /** column name */
  EventId = 'eventId',
  /** column name */
  Id = 'id',
  /** column name */
  LessonId = 'lessonId',
  /** column name */
  PriceUnitAmount = 'priceUnitAmount',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  RefundUnitAmount = 'refundUnitAmount',
  /** column name */
  RefundedAt = 'refundedAt',
  /** column name */
  StartsAt = 'startsAt',
  /** column name */
  Status = 'status',
  /** column name */
  TotalUnitAmount = 'totalUnitAmount',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "boosts" */
export type BoostsSetInput = {
  boostOrderId?: InputMaybe<Scalars['uuid']>;
  channel?: InputMaybe<BoostChannelsEnum>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  endsAt?: InputMaybe<Scalars['timestamptz']>;
  entityType?: InputMaybe<EngagementEntityTypesEnum>;
  eventId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  lessonId?: InputMaybe<Scalars['uuid']>;
  priceUnitAmount?: InputMaybe<Scalars['Int']>;
  quantity?: InputMaybe<Scalars['Int']>;
  refundUnitAmount?: InputMaybe<Scalars['Int']>;
  refundedAt?: InputMaybe<Scalars['timestamptz']>;
  startsAt?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<BoostStatusesEnum>;
  totalUnitAmount?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type BoostsStddevFields = {
  __typename?: 'BoostsStddevFields';
  priceUnitAmount?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  refundUnitAmount?: Maybe<Scalars['Float']>;
  totalUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "boosts" */
export type BoostsStddevOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
  quantity?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  totalUnitAmount?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type BoostsStddevPopFields = {
  __typename?: 'BoostsStddevPopFields';
  priceUnitAmount?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  refundUnitAmount?: Maybe<Scalars['Float']>;
  totalUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "boosts" */
export type BoostsStddevPopOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
  quantity?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  totalUnitAmount?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type BoostsStddevSampFields = {
  __typename?: 'BoostsStddevSampFields';
  priceUnitAmount?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  refundUnitAmount?: Maybe<Scalars['Float']>;
  totalUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "boosts" */
export type BoostsStddevSampOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
  quantity?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  totalUnitAmount?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "boosts" */
export type BoostsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: BoostsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BoostsStreamCursorValueInput = {
  boostOrderId?: InputMaybe<Scalars['uuid']>;
  channel?: InputMaybe<BoostChannelsEnum>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  endsAt?: InputMaybe<Scalars['timestamptz']>;
  entityType?: InputMaybe<EngagementEntityTypesEnum>;
  eventId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  lessonId?: InputMaybe<Scalars['uuid']>;
  priceUnitAmount?: InputMaybe<Scalars['Int']>;
  quantity?: InputMaybe<Scalars['Int']>;
  refundUnitAmount?: InputMaybe<Scalars['Int']>;
  refundedAt?: InputMaybe<Scalars['timestamptz']>;
  startsAt?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<BoostStatusesEnum>;
  totalUnitAmount?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type BoostsSumFields = {
  __typename?: 'BoostsSumFields';
  priceUnitAmount?: Maybe<Scalars['Int']>;
  quantity?: Maybe<Scalars['Int']>;
  refundUnitAmount?: Maybe<Scalars['Int']>;
  totalUnitAmount?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "boosts" */
export type BoostsSumOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
  quantity?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  totalUnitAmount?: InputMaybe<OrderBy>;
};

/** update columns of table "boosts" */
export enum BoostsUpdateColumn {
  /** column name */
  BoostOrderId = 'boostOrderId',
  /** column name */
  Channel = 'channel',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EndsAt = 'endsAt',
  /** column name */
  EntityType = 'entityType',
  /** column name */
  EventId = 'eventId',
  /** column name */
  Id = 'id',
  /** column name */
  LessonId = 'lessonId',
  /** column name */
  PriceUnitAmount = 'priceUnitAmount',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  RefundUnitAmount = 'refundUnitAmount',
  /** column name */
  RefundedAt = 'refundedAt',
  /** column name */
  StartsAt = 'startsAt',
  /** column name */
  Status = 'status',
  /** column name */
  TotalUnitAmount = 'totalUnitAmount',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type BoostsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<BoostsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BoostsSetInput>;
  /** filter the rows which have to be updated */
  where: BoostsBoolExp;
};

/** aggregate varPop on columns */
export type BoostsVarPopFields = {
  __typename?: 'BoostsVarPopFields';
  priceUnitAmount?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  refundUnitAmount?: Maybe<Scalars['Float']>;
  totalUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "boosts" */
export type BoostsVarPopOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
  quantity?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  totalUnitAmount?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type BoostsVarSampFields = {
  __typename?: 'BoostsVarSampFields';
  priceUnitAmount?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  refundUnitAmount?: Maybe<Scalars['Float']>;
  totalUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "boosts" */
export type BoostsVarSampOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
  quantity?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  totalUnitAmount?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type BoostsVarianceFields = {
  __typename?: 'BoostsVarianceFields';
  priceUnitAmount?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  refundUnitAmount?: Maybe<Scalars['Float']>;
  totalUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "boosts" */
export type BoostsVarianceOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
  quantity?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  totalUnitAmount?: InputMaybe<OrderBy>;
};

/** columns and relationships of "bracket_ranking_mechanism" */
export type BracketRankingMechanism = {
  __typename?: 'BracketRankingMechanism';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "bracket_ranking_mechanism" */
export type BracketRankingMechanismAggregate = {
  __typename?: 'BracketRankingMechanismAggregate';
  aggregate?: Maybe<BracketRankingMechanismAggregateFields>;
  nodes: Array<BracketRankingMechanism>;
};

/** aggregate fields of "bracket_ranking_mechanism" */
export type BracketRankingMechanismAggregateFields = {
  __typename?: 'BracketRankingMechanismAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<BracketRankingMechanismMaxFields>;
  min?: Maybe<BracketRankingMechanismMinFields>;
};


/** aggregate fields of "bracket_ranking_mechanism" */
export type BracketRankingMechanismAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<BracketRankingMechanismSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "bracket_ranking_mechanism". All fields are combined with a logical 'AND'. */
export type BracketRankingMechanismBoolExp = {
  _and?: InputMaybe<Array<BracketRankingMechanismBoolExp>>;
  _not?: InputMaybe<BracketRankingMechanismBoolExp>;
  _or?: InputMaybe<Array<BracketRankingMechanismBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "bracket_ranking_mechanism" */
export enum BracketRankingMechanismConstraint {
  /** unique or primary key constraint on columns "value" */
  BracketRankingMechanismPkey = 'bracket_ranking_mechanism_pkey'
}

export enum BracketRankingMechanismEnum {
  NetPoints = 'NET_POINTS',
  Wins = 'WINS'
}

/** Boolean expression to compare columns of type "BracketRankingMechanismEnum". All fields are combined with logical 'AND'. */
export type BracketRankingMechanismEnumComparisonExp = {
  _eq?: InputMaybe<BracketRankingMechanismEnum>;
  _in?: InputMaybe<Array<BracketRankingMechanismEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<BracketRankingMechanismEnum>;
  _nin?: InputMaybe<Array<BracketRankingMechanismEnum>>;
};

/** input type for inserting data into table "bracket_ranking_mechanism" */
export type BracketRankingMechanismInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type BracketRankingMechanismMaxFields = {
  __typename?: 'BracketRankingMechanismMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type BracketRankingMechanismMinFields = {
  __typename?: 'BracketRankingMechanismMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "bracket_ranking_mechanism" */
export type BracketRankingMechanismMutationResponse = {
  __typename?: 'BracketRankingMechanismMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<BracketRankingMechanism>;
};

/** on_conflict condition type for table "bracket_ranking_mechanism" */
export type BracketRankingMechanismOnConflict = {
  constraint: BracketRankingMechanismConstraint;
  updateColumns?: Array<BracketRankingMechanismUpdateColumn>;
  where?: InputMaybe<BracketRankingMechanismBoolExp>;
};

/** Ordering options when selecting data from "bracket_ranking_mechanism". */
export type BracketRankingMechanismOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: bracket_ranking_mechanism */
export type BracketRankingMechanismPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "bracket_ranking_mechanism" */
export enum BracketRankingMechanismSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "bracket_ranking_mechanism" */
export type BracketRankingMechanismSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "bracket_ranking_mechanism" */
export type BracketRankingMechanismStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: BracketRankingMechanismStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BracketRankingMechanismStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "bracket_ranking_mechanism" */
export enum BracketRankingMechanismUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type BracketRankingMechanismUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BracketRankingMechanismSetInput>;
  /** filter the rows which have to be updated */
  where: BracketRankingMechanismBoolExp;
};

/** columns and relationships of "calendar_accounts" */
export type CalendarAccounts = {
  __typename?: 'CalendarAccounts';
  accessToken: Scalars['String'];
  /** An array relationship */
  calendarPreferences: Array<CalendarPreferences>;
  /** An aggregate relationship */
  calendarPreferencesAggregate: CalendarPreferencesAggregate;
  connected: Scalars['Boolean'];
  createdAt: Scalars['timestamptz'];
  email?: Maybe<Scalars['String']>;
  expiresAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  provider: CalendarAuthProviderEnum;
  refreshToken?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid'];
};


/** columns and relationships of "calendar_accounts" */
export type CalendarAccountsCalendarPreferencesArgs = {
  distinctOn?: InputMaybe<Array<CalendarPreferencesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CalendarPreferencesOrderBy>>;
  where?: InputMaybe<CalendarPreferencesBoolExp>;
};


/** columns and relationships of "calendar_accounts" */
export type CalendarAccountsCalendarPreferencesAggregateArgs = {
  distinctOn?: InputMaybe<Array<CalendarPreferencesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CalendarPreferencesOrderBy>>;
  where?: InputMaybe<CalendarPreferencesBoolExp>;
};

/** aggregated selection of "calendar_accounts" */
export type CalendarAccountsAggregate = {
  __typename?: 'CalendarAccountsAggregate';
  aggregate?: Maybe<CalendarAccountsAggregateFields>;
  nodes: Array<CalendarAccounts>;
};

/** aggregate fields of "calendar_accounts" */
export type CalendarAccountsAggregateFields = {
  __typename?: 'CalendarAccountsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<CalendarAccountsMaxFields>;
  min?: Maybe<CalendarAccountsMinFields>;
};


/** aggregate fields of "calendar_accounts" */
export type CalendarAccountsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CalendarAccountsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "calendar_accounts". All fields are combined with a logical 'AND'. */
export type CalendarAccountsBoolExp = {
  _and?: InputMaybe<Array<CalendarAccountsBoolExp>>;
  _not?: InputMaybe<CalendarAccountsBoolExp>;
  _or?: InputMaybe<Array<CalendarAccountsBoolExp>>;
  accessToken?: InputMaybe<StringComparisonExp>;
  calendarPreferences?: InputMaybe<CalendarPreferencesBoolExp>;
  calendarPreferencesAggregate?: InputMaybe<CalendarPreferencesAggregateBoolExp>;
  connected?: InputMaybe<BooleanComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  email?: InputMaybe<StringComparisonExp>;
  expiresAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  provider?: InputMaybe<CalendarAuthProviderEnumComparisonExp>;
  refreshToken?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "calendar_accounts" */
export enum CalendarAccountsConstraint {
  /** unique or primary key constraint on columns "email" */
  CalendarAccountsEmailKey = 'calendar_accounts_email_key',
  /** unique or primary key constraint on columns "id" */
  CalendarAccountsPkey = 'calendar_accounts_pkey'
}

/** input type for inserting data into table "calendar_accounts" */
export type CalendarAccountsInsertInput = {
  accessToken?: InputMaybe<Scalars['String']>;
  calendarPreferences?: InputMaybe<CalendarPreferencesArrRelInsertInput>;
  connected?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  provider?: InputMaybe<CalendarAuthProviderEnum>;
  refreshToken?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type CalendarAccountsMaxFields = {
  __typename?: 'CalendarAccountsMaxFields';
  accessToken?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  expiresAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  refreshToken?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type CalendarAccountsMinFields = {
  __typename?: 'CalendarAccountsMinFields';
  accessToken?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  expiresAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  refreshToken?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "calendar_accounts" */
export type CalendarAccountsMutationResponse = {
  __typename?: 'CalendarAccountsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CalendarAccounts>;
};

/** input type for inserting object relation for remote table "calendar_accounts" */
export type CalendarAccountsObjRelInsertInput = {
  data: CalendarAccountsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<CalendarAccountsOnConflict>;
};

/** on_conflict condition type for table "calendar_accounts" */
export type CalendarAccountsOnConflict = {
  constraint: CalendarAccountsConstraint;
  updateColumns?: Array<CalendarAccountsUpdateColumn>;
  where?: InputMaybe<CalendarAccountsBoolExp>;
};

/** Ordering options when selecting data from "calendar_accounts". */
export type CalendarAccountsOrderBy = {
  accessToken?: InputMaybe<OrderBy>;
  calendarPreferencesAggregate?: InputMaybe<CalendarPreferencesAggregateOrderBy>;
  connected?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  email?: InputMaybe<OrderBy>;
  expiresAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  provider?: InputMaybe<OrderBy>;
  refreshToken?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: calendar_accounts */
export type CalendarAccountsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "calendar_accounts" */
export enum CalendarAccountsSelectColumn {
  /** column name */
  AccessToken = 'accessToken',
  /** column name */
  Connected = 'connected',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Email = 'email',
  /** column name */
  ExpiresAt = 'expiresAt',
  /** column name */
  Id = 'id',
  /** column name */
  Provider = 'provider',
  /** column name */
  RefreshToken = 'refreshToken',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "calendar_accounts" */
export type CalendarAccountsSetInput = {
  accessToken?: InputMaybe<Scalars['String']>;
  connected?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  provider?: InputMaybe<CalendarAuthProviderEnum>;
  refreshToken?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "calendar_accounts" */
export type CalendarAccountsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CalendarAccountsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CalendarAccountsStreamCursorValueInput = {
  accessToken?: InputMaybe<Scalars['String']>;
  connected?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  provider?: InputMaybe<CalendarAuthProviderEnum>;
  refreshToken?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "calendar_accounts" */
export enum CalendarAccountsUpdateColumn {
  /** column name */
  AccessToken = 'accessToken',
  /** column name */
  Connected = 'connected',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Email = 'email',
  /** column name */
  ExpiresAt = 'expiresAt',
  /** column name */
  Id = 'id',
  /** column name */
  Provider = 'provider',
  /** column name */
  RefreshToken = 'refreshToken',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

export type CalendarAccountsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CalendarAccountsSetInput>;
  /** filter the rows which have to be updated */
  where: CalendarAccountsBoolExp;
};

/** columns and relationships of "calendar_auth_provider" */
export type CalendarAuthProvider = {
  __typename?: 'CalendarAuthProvider';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "calendar_auth_provider" */
export type CalendarAuthProviderAggregate = {
  __typename?: 'CalendarAuthProviderAggregate';
  aggregate?: Maybe<CalendarAuthProviderAggregateFields>;
  nodes: Array<CalendarAuthProvider>;
};

/** aggregate fields of "calendar_auth_provider" */
export type CalendarAuthProviderAggregateFields = {
  __typename?: 'CalendarAuthProviderAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<CalendarAuthProviderMaxFields>;
  min?: Maybe<CalendarAuthProviderMinFields>;
};


/** aggregate fields of "calendar_auth_provider" */
export type CalendarAuthProviderAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CalendarAuthProviderSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "calendar_auth_provider". All fields are combined with a logical 'AND'. */
export type CalendarAuthProviderBoolExp = {
  _and?: InputMaybe<Array<CalendarAuthProviderBoolExp>>;
  _not?: InputMaybe<CalendarAuthProviderBoolExp>;
  _or?: InputMaybe<Array<CalendarAuthProviderBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "calendar_auth_provider" */
export enum CalendarAuthProviderConstraint {
  /** unique or primary key constraint on columns "value" */
  CalendarAuthProviderPkey = 'calendar_auth_provider_pkey'
}

export enum CalendarAuthProviderEnum {
  Google = 'GOOGLE'
}

/** Boolean expression to compare columns of type "CalendarAuthProviderEnum". All fields are combined with logical 'AND'. */
export type CalendarAuthProviderEnumComparisonExp = {
  _eq?: InputMaybe<CalendarAuthProviderEnum>;
  _in?: InputMaybe<Array<CalendarAuthProviderEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<CalendarAuthProviderEnum>;
  _nin?: InputMaybe<Array<CalendarAuthProviderEnum>>;
};

/** input type for inserting data into table "calendar_auth_provider" */
export type CalendarAuthProviderInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type CalendarAuthProviderMaxFields = {
  __typename?: 'CalendarAuthProviderMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type CalendarAuthProviderMinFields = {
  __typename?: 'CalendarAuthProviderMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "calendar_auth_provider" */
export type CalendarAuthProviderMutationResponse = {
  __typename?: 'CalendarAuthProviderMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CalendarAuthProvider>;
};

/** on_conflict condition type for table "calendar_auth_provider" */
export type CalendarAuthProviderOnConflict = {
  constraint: CalendarAuthProviderConstraint;
  updateColumns?: Array<CalendarAuthProviderUpdateColumn>;
  where?: InputMaybe<CalendarAuthProviderBoolExp>;
};

/** Ordering options when selecting data from "calendar_auth_provider". */
export type CalendarAuthProviderOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: calendar_auth_provider */
export type CalendarAuthProviderPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "calendar_auth_provider" */
export enum CalendarAuthProviderSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "calendar_auth_provider" */
export type CalendarAuthProviderSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "calendar_auth_provider" */
export type CalendarAuthProviderStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CalendarAuthProviderStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CalendarAuthProviderStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "calendar_auth_provider" */
export enum CalendarAuthProviderUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type CalendarAuthProviderUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CalendarAuthProviderSetInput>;
  /** filter the rows which have to be updated */
  where: CalendarAuthProviderBoolExp;
};

/** columns and relationships of "calendar_event_mappings" */
export type CalendarEventMappings = {
  __typename?: 'CalendarEventMappings';
  calendarPreferenceId: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  externalEventId: Scalars['String'];
  id: Scalars['uuid'];
  lessonId: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "calendar_event_mappings" */
export type CalendarEventMappingsAggregate = {
  __typename?: 'CalendarEventMappingsAggregate';
  aggregate?: Maybe<CalendarEventMappingsAggregateFields>;
  nodes: Array<CalendarEventMappings>;
};

/** aggregate fields of "calendar_event_mappings" */
export type CalendarEventMappingsAggregateFields = {
  __typename?: 'CalendarEventMappingsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<CalendarEventMappingsMaxFields>;
  min?: Maybe<CalendarEventMappingsMinFields>;
};


/** aggregate fields of "calendar_event_mappings" */
export type CalendarEventMappingsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CalendarEventMappingsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "calendar_event_mappings". All fields are combined with a logical 'AND'. */
export type CalendarEventMappingsBoolExp = {
  _and?: InputMaybe<Array<CalendarEventMappingsBoolExp>>;
  _not?: InputMaybe<CalendarEventMappingsBoolExp>;
  _or?: InputMaybe<Array<CalendarEventMappingsBoolExp>>;
  calendarPreferenceId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  externalEventId?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  lessonId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "calendar_event_mappings" */
export enum CalendarEventMappingsConstraint {
  /** unique or primary key constraint on columns "lesson_id", "calendar_preference_id" */
  CalendarEventMappingsCalendarPreferenceIdLessonIdKey = 'calendar_event_mappings_calendar_preference_id_lesson_id_key',
  /** unique or primary key constraint on columns "id" */
  CalendarEventMappingsPkey = 'calendar_event_mappings_pkey'
}

/** input type for inserting data into table "calendar_event_mappings" */
export type CalendarEventMappingsInsertInput = {
  calendarPreferenceId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  externalEventId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  lessonId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type CalendarEventMappingsMaxFields = {
  __typename?: 'CalendarEventMappingsMaxFields';
  calendarPreferenceId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  externalEventId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  lessonId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type CalendarEventMappingsMinFields = {
  __typename?: 'CalendarEventMappingsMinFields';
  calendarPreferenceId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  externalEventId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  lessonId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "calendar_event_mappings" */
export type CalendarEventMappingsMutationResponse = {
  __typename?: 'CalendarEventMappingsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CalendarEventMappings>;
};

/** on_conflict condition type for table "calendar_event_mappings" */
export type CalendarEventMappingsOnConflict = {
  constraint: CalendarEventMappingsConstraint;
  updateColumns?: Array<CalendarEventMappingsUpdateColumn>;
  where?: InputMaybe<CalendarEventMappingsBoolExp>;
};

/** Ordering options when selecting data from "calendar_event_mappings". */
export type CalendarEventMappingsOrderBy = {
  calendarPreferenceId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  externalEventId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lessonId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: calendar_event_mappings */
export type CalendarEventMappingsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "calendar_event_mappings" */
export enum CalendarEventMappingsSelectColumn {
  /** column name */
  CalendarPreferenceId = 'calendarPreferenceId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  ExternalEventId = 'externalEventId',
  /** column name */
  Id = 'id',
  /** column name */
  LessonId = 'lessonId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "calendar_event_mappings" */
export type CalendarEventMappingsSetInput = {
  calendarPreferenceId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  externalEventId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  lessonId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "calendar_event_mappings" */
export type CalendarEventMappingsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CalendarEventMappingsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CalendarEventMappingsStreamCursorValueInput = {
  calendarPreferenceId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  externalEventId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  lessonId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "calendar_event_mappings" */
export enum CalendarEventMappingsUpdateColumn {
  /** column name */
  CalendarPreferenceId = 'calendarPreferenceId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  ExternalEventId = 'externalEventId',
  /** column name */
  Id = 'id',
  /** column name */
  LessonId = 'lessonId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type CalendarEventMappingsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CalendarEventMappingsSetInput>;
  /** filter the rows which have to be updated */
  where: CalendarEventMappingsBoolExp;
};

/** columns and relationships of "calendar_preferences" */
export type CalendarPreferences = {
  __typename?: 'CalendarPreferences';
  /** An object relationship */
  calendarAccount: CalendarAccounts;
  calendarAccountId: Scalars['uuid'];
  calendarId: Scalars['String'];
  calendarName: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  isDefault?: Maybe<Scalars['Boolean']>;
  isEnabled: Scalars['Boolean'];
  isWritable: Scalars['Boolean'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "calendar_preferences" */
export type CalendarPreferencesAggregate = {
  __typename?: 'CalendarPreferencesAggregate';
  aggregate?: Maybe<CalendarPreferencesAggregateFields>;
  nodes: Array<CalendarPreferences>;
};

export type CalendarPreferencesAggregateBoolExp = {
  bool_and?: InputMaybe<CalendarPreferencesAggregateBoolExpBool_And>;
  bool_or?: InputMaybe<CalendarPreferencesAggregateBoolExpBool_Or>;
  count?: InputMaybe<CalendarPreferencesAggregateBoolExpCount>;
};

/** aggregate fields of "calendar_preferences" */
export type CalendarPreferencesAggregateFields = {
  __typename?: 'CalendarPreferencesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<CalendarPreferencesMaxFields>;
  min?: Maybe<CalendarPreferencesMinFields>;
};


/** aggregate fields of "calendar_preferences" */
export type CalendarPreferencesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CalendarPreferencesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "calendar_preferences" */
export type CalendarPreferencesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<CalendarPreferencesMaxOrderBy>;
  min?: InputMaybe<CalendarPreferencesMinOrderBy>;
};

/** input type for inserting array relation for remote table "calendar_preferences" */
export type CalendarPreferencesArrRelInsertInput = {
  data: Array<CalendarPreferencesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<CalendarPreferencesOnConflict>;
};

/** Boolean expression to filter rows from the table "calendar_preferences". All fields are combined with a logical 'AND'. */
export type CalendarPreferencesBoolExp = {
  _and?: InputMaybe<Array<CalendarPreferencesBoolExp>>;
  _not?: InputMaybe<CalendarPreferencesBoolExp>;
  _or?: InputMaybe<Array<CalendarPreferencesBoolExp>>;
  calendarAccount?: InputMaybe<CalendarAccountsBoolExp>;
  calendarAccountId?: InputMaybe<UuidComparisonExp>;
  calendarId?: InputMaybe<StringComparisonExp>;
  calendarName?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isDefault?: InputMaybe<BooleanComparisonExp>;
  isEnabled?: InputMaybe<BooleanComparisonExp>;
  isWritable?: InputMaybe<BooleanComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "calendar_preferences" */
export enum CalendarPreferencesConstraint {
  /** unique or primary key constraint on columns "calendar_account_id", "calendar_id" */
  CalendarPreferencesCalendarAccountIdCalendarIdKey = 'calendar_preferences_calendar_account_id_calendar_id_key',
  /** unique or primary key constraint on columns "id" */
  CalendarPreferencesPkey = 'calendar_preferences_pkey'
}

/** input type for inserting data into table "calendar_preferences" */
export type CalendarPreferencesInsertInput = {
  calendarAccount?: InputMaybe<CalendarAccountsObjRelInsertInput>;
  calendarAccountId?: InputMaybe<Scalars['uuid']>;
  calendarId?: InputMaybe<Scalars['String']>;
  calendarName?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  isEnabled?: InputMaybe<Scalars['Boolean']>;
  isWritable?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type CalendarPreferencesMaxFields = {
  __typename?: 'CalendarPreferencesMaxFields';
  calendarAccountId?: Maybe<Scalars['uuid']>;
  calendarId?: Maybe<Scalars['String']>;
  calendarName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "calendar_preferences" */
export type CalendarPreferencesMaxOrderBy = {
  calendarAccountId?: InputMaybe<OrderBy>;
  calendarId?: InputMaybe<OrderBy>;
  calendarName?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type CalendarPreferencesMinFields = {
  __typename?: 'CalendarPreferencesMinFields';
  calendarAccountId?: Maybe<Scalars['uuid']>;
  calendarId?: Maybe<Scalars['String']>;
  calendarName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "calendar_preferences" */
export type CalendarPreferencesMinOrderBy = {
  calendarAccountId?: InputMaybe<OrderBy>;
  calendarId?: InputMaybe<OrderBy>;
  calendarName?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "calendar_preferences" */
export type CalendarPreferencesMutationResponse = {
  __typename?: 'CalendarPreferencesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CalendarPreferences>;
};

/** on_conflict condition type for table "calendar_preferences" */
export type CalendarPreferencesOnConflict = {
  constraint: CalendarPreferencesConstraint;
  updateColumns?: Array<CalendarPreferencesUpdateColumn>;
  where?: InputMaybe<CalendarPreferencesBoolExp>;
};

/** Ordering options when selecting data from "calendar_preferences". */
export type CalendarPreferencesOrderBy = {
  calendarAccount?: InputMaybe<CalendarAccountsOrderBy>;
  calendarAccountId?: InputMaybe<OrderBy>;
  calendarId?: InputMaybe<OrderBy>;
  calendarName?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  isDefault?: InputMaybe<OrderBy>;
  isEnabled?: InputMaybe<OrderBy>;
  isWritable?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: calendar_preferences */
export type CalendarPreferencesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "calendar_preferences" */
export enum CalendarPreferencesSelectColumn {
  /** column name */
  CalendarAccountId = 'calendarAccountId',
  /** column name */
  CalendarId = 'calendarId',
  /** column name */
  CalendarName = 'calendarName',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  IsDefault = 'isDefault',
  /** column name */
  IsEnabled = 'isEnabled',
  /** column name */
  IsWritable = 'isWritable',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** select "calendarPreferencesAggregateBoolExpBool_andArgumentsColumns" columns of table "calendar_preferences" */
export enum CalendarPreferencesSelectColumnCalendarPreferencesAggregateBoolExpBool_AndArgumentsColumns {
  /** column name */
  IsDefault = 'isDefault',
  /** column name */
  IsEnabled = 'isEnabled',
  /** column name */
  IsWritable = 'isWritable'
}

/** select "calendarPreferencesAggregateBoolExpBool_orArgumentsColumns" columns of table "calendar_preferences" */
export enum CalendarPreferencesSelectColumnCalendarPreferencesAggregateBoolExpBool_OrArgumentsColumns {
  /** column name */
  IsDefault = 'isDefault',
  /** column name */
  IsEnabled = 'isEnabled',
  /** column name */
  IsWritable = 'isWritable'
}

/** input type for updating data in table "calendar_preferences" */
export type CalendarPreferencesSetInput = {
  calendarAccountId?: InputMaybe<Scalars['uuid']>;
  calendarId?: InputMaybe<Scalars['String']>;
  calendarName?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  isEnabled?: InputMaybe<Scalars['Boolean']>;
  isWritable?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "calendar_preferences" */
export type CalendarPreferencesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CalendarPreferencesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CalendarPreferencesStreamCursorValueInput = {
  calendarAccountId?: InputMaybe<Scalars['uuid']>;
  calendarId?: InputMaybe<Scalars['String']>;
  calendarName?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  isEnabled?: InputMaybe<Scalars['Boolean']>;
  isWritable?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "calendar_preferences" */
export enum CalendarPreferencesUpdateColumn {
  /** column name */
  CalendarAccountId = 'calendarAccountId',
  /** column name */
  CalendarId = 'calendarId',
  /** column name */
  CalendarName = 'calendarName',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  IsDefault = 'isDefault',
  /** column name */
  IsEnabled = 'isEnabled',
  /** column name */
  IsWritable = 'isWritable',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type CalendarPreferencesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CalendarPreferencesSetInput>;
  /** filter the rows which have to be updated */
  where: CalendarPreferencesBoolExp;
};

/** columns and relationships of "cities" */
export type Cities = {
  __typename?: 'Cities';
  citySlug: Scalars['String'];
  /** An array relationship */
  coachStarterProfiles: Array<CoachStarterProfiles>;
  /** An aggregate relationship */
  coachStarterProfilesAggregate: CoachStarterProfilesAggregate;
  /** An object relationship */
  countrySubdivision: CountrySubdivisions;
  countrySubdivisionId: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  events: Array<Events>;
  /** An aggregate relationship */
  eventsAggregate: EventsAggregate;
  geometry?: Maybe<Scalars['geography']>;
  /** An array relationship */
  groups: Array<Groups>;
  /** An aggregate relationship */
  groupsAggregate: GroupsAggregate;
  id: Scalars['uuid'];
  isActive: Scalars['Boolean'];
  latitude: Scalars['numeric'];
  longitude: Scalars['numeric'];
  name: Scalars['String'];
  slug: Scalars['String'];
  source?: Maybe<Scalars['String']>;
  sourceCitySlug?: Maybe<Scalars['String']>;
  sourceCountrySlug?: Maybe<Scalars['String']>;
  sourceId?: Maybe<Scalars['String']>;
  sourceStateSlug?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamptz'];
  /** An array relationship */
  users: Array<Users>;
  /** An aggregate relationship */
  usersAggregate: UsersAggregate;
  /** An array relationship */
  venues: Array<Venues>;
  /** An aggregate relationship */
  venuesAggregate: VenuesAggregate;
};


/** columns and relationships of "cities" */
export type CitiesCoachStarterProfilesArgs = {
  distinctOn?: InputMaybe<Array<CoachStarterProfilesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachStarterProfilesOrderBy>>;
  where?: InputMaybe<CoachStarterProfilesBoolExp>;
};


/** columns and relationships of "cities" */
export type CitiesCoachStarterProfilesAggregateArgs = {
  distinctOn?: InputMaybe<Array<CoachStarterProfilesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachStarterProfilesOrderBy>>;
  where?: InputMaybe<CoachStarterProfilesBoolExp>;
};


/** columns and relationships of "cities" */
export type CitiesEventsArgs = {
  distinctOn?: InputMaybe<Array<EventsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventsOrderBy>>;
  where?: InputMaybe<EventsBoolExp>;
};


/** columns and relationships of "cities" */
export type CitiesEventsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventsOrderBy>>;
  where?: InputMaybe<EventsBoolExp>;
};


/** columns and relationships of "cities" */
export type CitiesGroupsArgs = {
  distinctOn?: InputMaybe<Array<GroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupsOrderBy>>;
  where?: InputMaybe<GroupsBoolExp>;
};


/** columns and relationships of "cities" */
export type CitiesGroupsAggregateArgs = {
  distinctOn?: InputMaybe<Array<GroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupsOrderBy>>;
  where?: InputMaybe<GroupsBoolExp>;
};


/** columns and relationships of "cities" */
export type CitiesUsersArgs = {
  distinctOn?: InputMaybe<Array<UsersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
  where?: InputMaybe<UsersBoolExp>;
};


/** columns and relationships of "cities" */
export type CitiesUsersAggregateArgs = {
  distinctOn?: InputMaybe<Array<UsersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
  where?: InputMaybe<UsersBoolExp>;
};


/** columns and relationships of "cities" */
export type CitiesVenuesArgs = {
  distinctOn?: InputMaybe<Array<VenuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenuesOrderBy>>;
  where?: InputMaybe<VenuesBoolExp>;
};


/** columns and relationships of "cities" */
export type CitiesVenuesAggregateArgs = {
  distinctOn?: InputMaybe<Array<VenuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenuesOrderBy>>;
  where?: InputMaybe<VenuesBoolExp>;
};

/** aggregated selection of "cities" */
export type CitiesAggregate = {
  __typename?: 'CitiesAggregate';
  aggregate?: Maybe<CitiesAggregateFields>;
  nodes: Array<Cities>;
};

export type CitiesAggregateBoolExp = {
  bool_and?: InputMaybe<CitiesAggregateBoolExpBool_And>;
  bool_or?: InputMaybe<CitiesAggregateBoolExpBool_Or>;
  count?: InputMaybe<CitiesAggregateBoolExpCount>;
};

/** aggregate fields of "cities" */
export type CitiesAggregateFields = {
  __typename?: 'CitiesAggregateFields';
  avg?: Maybe<CitiesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CitiesMaxFields>;
  min?: Maybe<CitiesMinFields>;
  stddev?: Maybe<CitiesStddevFields>;
  stddevPop?: Maybe<CitiesStddevPopFields>;
  stddevSamp?: Maybe<CitiesStddevSampFields>;
  sum?: Maybe<CitiesSumFields>;
  varPop?: Maybe<CitiesVarPopFields>;
  varSamp?: Maybe<CitiesVarSampFields>;
  variance?: Maybe<CitiesVarianceFields>;
};


/** aggregate fields of "cities" */
export type CitiesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CitiesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "cities" */
export type CitiesAggregateOrderBy = {
  avg?: InputMaybe<CitiesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<CitiesMaxOrderBy>;
  min?: InputMaybe<CitiesMinOrderBy>;
  stddev?: InputMaybe<CitiesStddevOrderBy>;
  stddevPop?: InputMaybe<CitiesStddevPopOrderBy>;
  stddevSamp?: InputMaybe<CitiesStddevSampOrderBy>;
  sum?: InputMaybe<CitiesSumOrderBy>;
  varPop?: InputMaybe<CitiesVarPopOrderBy>;
  varSamp?: InputMaybe<CitiesVarSampOrderBy>;
  variance?: InputMaybe<CitiesVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "cities" */
export type CitiesArrRelInsertInput = {
  data: Array<CitiesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<CitiesOnConflict>;
};

/** aggregate avg on columns */
export type CitiesAvgFields = {
  __typename?: 'CitiesAvgFields';
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "cities" */
export type CitiesAvgOrderBy = {
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "cities". All fields are combined with a logical 'AND'. */
export type CitiesBoolExp = {
  _and?: InputMaybe<Array<CitiesBoolExp>>;
  _not?: InputMaybe<CitiesBoolExp>;
  _or?: InputMaybe<Array<CitiesBoolExp>>;
  citySlug?: InputMaybe<StringComparisonExp>;
  coachStarterProfiles?: InputMaybe<CoachStarterProfilesBoolExp>;
  coachStarterProfilesAggregate?: InputMaybe<CoachStarterProfilesAggregateBoolExp>;
  countrySubdivision?: InputMaybe<CountrySubdivisionsBoolExp>;
  countrySubdivisionId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  events?: InputMaybe<EventsBoolExp>;
  eventsAggregate?: InputMaybe<EventsAggregateBoolExp>;
  geometry?: InputMaybe<GeographyComparisonExp>;
  groups?: InputMaybe<GroupsBoolExp>;
  groupsAggregate?: InputMaybe<GroupsAggregateBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isActive?: InputMaybe<BooleanComparisonExp>;
  latitude?: InputMaybe<NumericComparisonExp>;
  longitude?: InputMaybe<NumericComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  slug?: InputMaybe<StringComparisonExp>;
  source?: InputMaybe<StringComparisonExp>;
  sourceCitySlug?: InputMaybe<StringComparisonExp>;
  sourceCountrySlug?: InputMaybe<StringComparisonExp>;
  sourceId?: InputMaybe<StringComparisonExp>;
  sourceStateSlug?: InputMaybe<StringComparisonExp>;
  timezone?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  users?: InputMaybe<UsersBoolExp>;
  usersAggregate?: InputMaybe<UsersAggregateBoolExp>;
  venues?: InputMaybe<VenuesBoolExp>;
  venuesAggregate?: InputMaybe<VenuesAggregateBoolExp>;
};

/** unique or primary key constraints on table "cities" */
export enum CitiesConstraint {
  /** unique or primary key constraint on columns "id" */
  CitiesPkey = 'cities_pkey',
  /** unique or primary key constraint on columns "slug" */
  CitiesSlugKey = 'cities_slug_key',
  /** unique or primary key constraint on columns "source_id" */
  CitiesSourceIdKey = 'cities_source_id_key'
}

/** input type for incrementing numeric columns in table "cities" */
export type CitiesIncInput = {
  latitude?: InputMaybe<Scalars['numeric']>;
  longitude?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "cities" */
export type CitiesInsertInput = {
  citySlug?: InputMaybe<Scalars['String']>;
  coachStarterProfiles?: InputMaybe<CoachStarterProfilesArrRelInsertInput>;
  countrySubdivision?: InputMaybe<CountrySubdivisionsObjRelInsertInput>;
  countrySubdivisionId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  events?: InputMaybe<EventsArrRelInsertInput>;
  geometry?: InputMaybe<Scalars['geography']>;
  groups?: InputMaybe<GroupsArrRelInsertInput>;
  id?: InputMaybe<Scalars['uuid']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  latitude?: InputMaybe<Scalars['numeric']>;
  longitude?: InputMaybe<Scalars['numeric']>;
  name?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  sourceCitySlug?: InputMaybe<Scalars['String']>;
  sourceCountrySlug?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  sourceStateSlug?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  users?: InputMaybe<UsersArrRelInsertInput>;
  venues?: InputMaybe<VenuesArrRelInsertInput>;
};

/** aggregate max on columns */
export type CitiesMaxFields = {
  __typename?: 'CitiesMaxFields';
  citySlug?: Maybe<Scalars['String']>;
  countrySubdivisionId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  latitude?: Maybe<Scalars['numeric']>;
  longitude?: Maybe<Scalars['numeric']>;
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  sourceCitySlug?: Maybe<Scalars['String']>;
  sourceCountrySlug?: Maybe<Scalars['String']>;
  sourceId?: Maybe<Scalars['String']>;
  sourceStateSlug?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "cities" */
export type CitiesMaxOrderBy = {
  citySlug?: InputMaybe<OrderBy>;
  countrySubdivisionId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  source?: InputMaybe<OrderBy>;
  sourceCitySlug?: InputMaybe<OrderBy>;
  sourceCountrySlug?: InputMaybe<OrderBy>;
  sourceId?: InputMaybe<OrderBy>;
  sourceStateSlug?: InputMaybe<OrderBy>;
  timezone?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type CitiesMinFields = {
  __typename?: 'CitiesMinFields';
  citySlug?: Maybe<Scalars['String']>;
  countrySubdivisionId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  latitude?: Maybe<Scalars['numeric']>;
  longitude?: Maybe<Scalars['numeric']>;
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  sourceCitySlug?: Maybe<Scalars['String']>;
  sourceCountrySlug?: Maybe<Scalars['String']>;
  sourceId?: Maybe<Scalars['String']>;
  sourceStateSlug?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "cities" */
export type CitiesMinOrderBy = {
  citySlug?: InputMaybe<OrderBy>;
  countrySubdivisionId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  source?: InputMaybe<OrderBy>;
  sourceCitySlug?: InputMaybe<OrderBy>;
  sourceCountrySlug?: InputMaybe<OrderBy>;
  sourceId?: InputMaybe<OrderBy>;
  sourceStateSlug?: InputMaybe<OrderBy>;
  timezone?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "cities" */
export type CitiesMutationResponse = {
  __typename?: 'CitiesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Cities>;
};

/** input type for inserting object relation for remote table "cities" */
export type CitiesObjRelInsertInput = {
  data: CitiesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<CitiesOnConflict>;
};

/** on_conflict condition type for table "cities" */
export type CitiesOnConflict = {
  constraint: CitiesConstraint;
  updateColumns?: Array<CitiesUpdateColumn>;
  where?: InputMaybe<CitiesBoolExp>;
};

/** Ordering options when selecting data from "cities". */
export type CitiesOrderBy = {
  citySlug?: InputMaybe<OrderBy>;
  coachStarterProfilesAggregate?: InputMaybe<CoachStarterProfilesAggregateOrderBy>;
  countrySubdivision?: InputMaybe<CountrySubdivisionsOrderBy>;
  countrySubdivisionId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  eventsAggregate?: InputMaybe<EventsAggregateOrderBy>;
  geometry?: InputMaybe<OrderBy>;
  groupsAggregate?: InputMaybe<GroupsAggregateOrderBy>;
  id?: InputMaybe<OrderBy>;
  isActive?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  source?: InputMaybe<OrderBy>;
  sourceCitySlug?: InputMaybe<OrderBy>;
  sourceCountrySlug?: InputMaybe<OrderBy>;
  sourceId?: InputMaybe<OrderBy>;
  sourceStateSlug?: InputMaybe<OrderBy>;
  timezone?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  usersAggregate?: InputMaybe<UsersAggregateOrderBy>;
  venuesAggregate?: InputMaybe<VenuesAggregateOrderBy>;
};

/** primary key columns input for table: cities */
export type CitiesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "cities" */
export enum CitiesSelectColumn {
  /** column name */
  CitySlug = 'citySlug',
  /** column name */
  CountrySubdivisionId = 'countrySubdivisionId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Geometry = 'geometry',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'isActive',
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Longitude = 'longitude',
  /** column name */
  Name = 'name',
  /** column name */
  Slug = 'slug',
  /** column name */
  Source = 'source',
  /** column name */
  SourceCitySlug = 'sourceCitySlug',
  /** column name */
  SourceCountrySlug = 'sourceCountrySlug',
  /** column name */
  SourceId = 'sourceId',
  /** column name */
  SourceStateSlug = 'sourceStateSlug',
  /** column name */
  Timezone = 'timezone',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** select "citiesAggregateBoolExpBool_andArgumentsColumns" columns of table "cities" */
export enum CitiesSelectColumnCitiesAggregateBoolExpBool_AndArgumentsColumns {
  /** column name */
  IsActive = 'isActive'
}

/** select "citiesAggregateBoolExpBool_orArgumentsColumns" columns of table "cities" */
export enum CitiesSelectColumnCitiesAggregateBoolExpBool_OrArgumentsColumns {
  /** column name */
  IsActive = 'isActive'
}

/** input type for updating data in table "cities" */
export type CitiesSetInput = {
  citySlug?: InputMaybe<Scalars['String']>;
  countrySubdivisionId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  geometry?: InputMaybe<Scalars['geography']>;
  id?: InputMaybe<Scalars['uuid']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  latitude?: InputMaybe<Scalars['numeric']>;
  longitude?: InputMaybe<Scalars['numeric']>;
  name?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  sourceCitySlug?: InputMaybe<Scalars['String']>;
  sourceCountrySlug?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  sourceStateSlug?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type CitiesStddevFields = {
  __typename?: 'CitiesStddevFields';
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "cities" */
export type CitiesStddevOrderBy = {
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type CitiesStddevPopFields = {
  __typename?: 'CitiesStddevPopFields';
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "cities" */
export type CitiesStddevPopOrderBy = {
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type CitiesStddevSampFields = {
  __typename?: 'CitiesStddevSampFields';
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "cities" */
export type CitiesStddevSampOrderBy = {
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "cities" */
export type CitiesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CitiesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CitiesStreamCursorValueInput = {
  citySlug?: InputMaybe<Scalars['String']>;
  countrySubdivisionId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  geometry?: InputMaybe<Scalars['geography']>;
  id?: InputMaybe<Scalars['uuid']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  latitude?: InputMaybe<Scalars['numeric']>;
  longitude?: InputMaybe<Scalars['numeric']>;
  name?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  sourceCitySlug?: InputMaybe<Scalars['String']>;
  sourceCountrySlug?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  sourceStateSlug?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type CitiesSumFields = {
  __typename?: 'CitiesSumFields';
  latitude?: Maybe<Scalars['numeric']>;
  longitude?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "cities" */
export type CitiesSumOrderBy = {
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
};

/** update columns of table "cities" */
export enum CitiesUpdateColumn {
  /** column name */
  CitySlug = 'citySlug',
  /** column name */
  CountrySubdivisionId = 'countrySubdivisionId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Geometry = 'geometry',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'isActive',
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Longitude = 'longitude',
  /** column name */
  Name = 'name',
  /** column name */
  Slug = 'slug',
  /** column name */
  Source = 'source',
  /** column name */
  SourceCitySlug = 'sourceCitySlug',
  /** column name */
  SourceCountrySlug = 'sourceCountrySlug',
  /** column name */
  SourceId = 'sourceId',
  /** column name */
  SourceStateSlug = 'sourceStateSlug',
  /** column name */
  Timezone = 'timezone',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type CitiesUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<CitiesIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CitiesSetInput>;
  /** filter the rows which have to be updated */
  where: CitiesBoolExp;
};

/** aggregate varPop on columns */
export type CitiesVarPopFields = {
  __typename?: 'CitiesVarPopFields';
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "cities" */
export type CitiesVarPopOrderBy = {
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type CitiesVarSampFields = {
  __typename?: 'CitiesVarSampFields';
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "cities" */
export type CitiesVarSampOrderBy = {
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type CitiesVarianceFields = {
  __typename?: 'CitiesVarianceFields';
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "cities" */
export type CitiesVarianceOrderBy = {
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
};

/** columns and relationships of "coach_availability" */
export type CoachAvailability = {
  __typename?: 'CoachAvailability';
  /** An object relationship */
  coachAvailabilityCustomCourt?: Maybe<UserCustomCourts>;
  /** An object relationship */
  coachAvailabilityVenueId?: Maybe<Venues>;
  createdAt: Scalars['timestamptz'];
  dayOfWeek: DayOfWeekEnum;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  endTimeMinutes: Scalars['Int'];
  id: Scalars['uuid'];
  startTimeMinutes: Scalars['Int'];
  status: CoachAvailabilityStatusesEnum;
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  userCustomCourtId?: Maybe<Scalars['uuid']>;
  userId: Scalars['uuid'];
  venueId?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "coach_availability" */
export type CoachAvailabilityAggregate = {
  __typename?: 'CoachAvailabilityAggregate';
  aggregate?: Maybe<CoachAvailabilityAggregateFields>;
  nodes: Array<CoachAvailability>;
};

export type CoachAvailabilityAggregateBoolExp = {
  count?: InputMaybe<CoachAvailabilityAggregateBoolExpCount>;
};

/** aggregate fields of "coach_availability" */
export type CoachAvailabilityAggregateFields = {
  __typename?: 'CoachAvailabilityAggregateFields';
  avg?: Maybe<CoachAvailabilityAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CoachAvailabilityMaxFields>;
  min?: Maybe<CoachAvailabilityMinFields>;
  stddev?: Maybe<CoachAvailabilityStddevFields>;
  stddevPop?: Maybe<CoachAvailabilityStddevPopFields>;
  stddevSamp?: Maybe<CoachAvailabilityStddevSampFields>;
  sum?: Maybe<CoachAvailabilitySumFields>;
  varPop?: Maybe<CoachAvailabilityVarPopFields>;
  varSamp?: Maybe<CoachAvailabilityVarSampFields>;
  variance?: Maybe<CoachAvailabilityVarianceFields>;
};


/** aggregate fields of "coach_availability" */
export type CoachAvailabilityAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CoachAvailabilitySelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "coach_availability" */
export type CoachAvailabilityAggregateOrderBy = {
  avg?: InputMaybe<CoachAvailabilityAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<CoachAvailabilityMaxOrderBy>;
  min?: InputMaybe<CoachAvailabilityMinOrderBy>;
  stddev?: InputMaybe<CoachAvailabilityStddevOrderBy>;
  stddevPop?: InputMaybe<CoachAvailabilityStddevPopOrderBy>;
  stddevSamp?: InputMaybe<CoachAvailabilityStddevSampOrderBy>;
  sum?: InputMaybe<CoachAvailabilitySumOrderBy>;
  varPop?: InputMaybe<CoachAvailabilityVarPopOrderBy>;
  varSamp?: InputMaybe<CoachAvailabilityVarSampOrderBy>;
  variance?: InputMaybe<CoachAvailabilityVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "coach_availability" */
export type CoachAvailabilityArrRelInsertInput = {
  data: Array<CoachAvailabilityInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<CoachAvailabilityOnConflict>;
};

/** aggregate avg on columns */
export type CoachAvailabilityAvgFields = {
  __typename?: 'CoachAvailabilityAvgFields';
  endTimeMinutes?: Maybe<Scalars['Float']>;
  startTimeMinutes?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "coach_availability" */
export type CoachAvailabilityAvgOrderBy = {
  endTimeMinutes?: InputMaybe<OrderBy>;
  startTimeMinutes?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "coach_availability". All fields are combined with a logical 'AND'. */
export type CoachAvailabilityBoolExp = {
  _and?: InputMaybe<Array<CoachAvailabilityBoolExp>>;
  _not?: InputMaybe<CoachAvailabilityBoolExp>;
  _or?: InputMaybe<Array<CoachAvailabilityBoolExp>>;
  coachAvailabilityCustomCourt?: InputMaybe<UserCustomCourtsBoolExp>;
  coachAvailabilityVenueId?: InputMaybe<VenuesBoolExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  dayOfWeek?: InputMaybe<DayOfWeekEnumComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  endTimeMinutes?: InputMaybe<IntComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  startTimeMinutes?: InputMaybe<IntComparisonExp>;
  status?: InputMaybe<CoachAvailabilityStatusesEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userCustomCourtId?: InputMaybe<UuidComparisonExp>;
  userId?: InputMaybe<UuidComparisonExp>;
  venueId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "coach_availability" */
export enum CoachAvailabilityConstraint {
  /** unique or primary key constraint on columns "id" */
  CoachAvailabilityPkey = 'coach_availability_pkey'
}

/** input type for incrementing numeric columns in table "coach_availability" */
export type CoachAvailabilityIncInput = {
  endTimeMinutes?: InputMaybe<Scalars['Int']>;
  startTimeMinutes?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "coach_availability" */
export type CoachAvailabilityInsertInput = {
  coachAvailabilityCustomCourt?: InputMaybe<UserCustomCourtsObjRelInsertInput>;
  coachAvailabilityVenueId?: InputMaybe<VenuesObjRelInsertInput>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  dayOfWeek?: InputMaybe<DayOfWeekEnum>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  endTimeMinutes?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  startTimeMinutes?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<CoachAvailabilityStatusesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userCustomCourtId?: InputMaybe<Scalars['uuid']>;
  userId?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type CoachAvailabilityMaxFields = {
  __typename?: 'CoachAvailabilityMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  endTimeMinutes?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  startTimeMinutes?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userCustomCourtId?: Maybe<Scalars['uuid']>;
  userId?: Maybe<Scalars['uuid']>;
  venueId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "coach_availability" */
export type CoachAvailabilityMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  endTimeMinutes?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  startTimeMinutes?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userCustomCourtId?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type CoachAvailabilityMinFields = {
  __typename?: 'CoachAvailabilityMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  endTimeMinutes?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  startTimeMinutes?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userCustomCourtId?: Maybe<Scalars['uuid']>;
  userId?: Maybe<Scalars['uuid']>;
  venueId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "coach_availability" */
export type CoachAvailabilityMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  endTimeMinutes?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  startTimeMinutes?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userCustomCourtId?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "coach_availability" */
export type CoachAvailabilityMutationResponse = {
  __typename?: 'CoachAvailabilityMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CoachAvailability>;
};

/** on_conflict condition type for table "coach_availability" */
export type CoachAvailabilityOnConflict = {
  constraint: CoachAvailabilityConstraint;
  updateColumns?: Array<CoachAvailabilityUpdateColumn>;
  where?: InputMaybe<CoachAvailabilityBoolExp>;
};

/** Ordering options when selecting data from "coach_availability". */
export type CoachAvailabilityOrderBy = {
  coachAvailabilityCustomCourt?: InputMaybe<UserCustomCourtsOrderBy>;
  coachAvailabilityVenueId?: InputMaybe<VenuesOrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  dayOfWeek?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  endTimeMinutes?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  startTimeMinutes?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userCustomCourtId?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: coach_availability */
export type CoachAvailabilityPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "coach_availability" */
export enum CoachAvailabilitySelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DayOfWeek = 'dayOfWeek',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EndTimeMinutes = 'endTimeMinutes',
  /** column name */
  Id = 'id',
  /** column name */
  StartTimeMinutes = 'startTimeMinutes',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserCustomCourtId = 'userCustomCourtId',
  /** column name */
  UserId = 'userId',
  /** column name */
  VenueId = 'venueId'
}

/** input type for updating data in table "coach_availability" */
export type CoachAvailabilitySetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  dayOfWeek?: InputMaybe<DayOfWeekEnum>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  endTimeMinutes?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  startTimeMinutes?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<CoachAvailabilityStatusesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userCustomCourtId?: InputMaybe<Scalars['uuid']>;
  userId?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** columns and relationships of "coach_availability_statuses" */
export type CoachAvailabilityStatuses = {
  __typename?: 'CoachAvailabilityStatuses';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "coach_availability_statuses" */
export type CoachAvailabilityStatusesAggregate = {
  __typename?: 'CoachAvailabilityStatusesAggregate';
  aggregate?: Maybe<CoachAvailabilityStatusesAggregateFields>;
  nodes: Array<CoachAvailabilityStatuses>;
};

/** aggregate fields of "coach_availability_statuses" */
export type CoachAvailabilityStatusesAggregateFields = {
  __typename?: 'CoachAvailabilityStatusesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<CoachAvailabilityStatusesMaxFields>;
  min?: Maybe<CoachAvailabilityStatusesMinFields>;
};


/** aggregate fields of "coach_availability_statuses" */
export type CoachAvailabilityStatusesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CoachAvailabilityStatusesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "coach_availability_statuses". All fields are combined with a logical 'AND'. */
export type CoachAvailabilityStatusesBoolExp = {
  _and?: InputMaybe<Array<CoachAvailabilityStatusesBoolExp>>;
  _not?: InputMaybe<CoachAvailabilityStatusesBoolExp>;
  _or?: InputMaybe<Array<CoachAvailabilityStatusesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "coach_availability_statuses" */
export enum CoachAvailabilityStatusesConstraint {
  /** unique or primary key constraint on columns "value" */
  CoachAvailabilityStatusesPkey = 'coach_availability_statuses_pkey'
}

export enum CoachAvailabilityStatusesEnum {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

/** Boolean expression to compare columns of type "CoachAvailabilityStatusesEnum". All fields are combined with logical 'AND'. */
export type CoachAvailabilityStatusesEnumComparisonExp = {
  _eq?: InputMaybe<CoachAvailabilityStatusesEnum>;
  _in?: InputMaybe<Array<CoachAvailabilityStatusesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<CoachAvailabilityStatusesEnum>;
  _nin?: InputMaybe<Array<CoachAvailabilityStatusesEnum>>;
};

/** input type for inserting data into table "coach_availability_statuses" */
export type CoachAvailabilityStatusesInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type CoachAvailabilityStatusesMaxFields = {
  __typename?: 'CoachAvailabilityStatusesMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type CoachAvailabilityStatusesMinFields = {
  __typename?: 'CoachAvailabilityStatusesMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "coach_availability_statuses" */
export type CoachAvailabilityStatusesMutationResponse = {
  __typename?: 'CoachAvailabilityStatusesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CoachAvailabilityStatuses>;
};

/** on_conflict condition type for table "coach_availability_statuses" */
export type CoachAvailabilityStatusesOnConflict = {
  constraint: CoachAvailabilityStatusesConstraint;
  updateColumns?: Array<CoachAvailabilityStatusesUpdateColumn>;
  where?: InputMaybe<CoachAvailabilityStatusesBoolExp>;
};

/** Ordering options when selecting data from "coach_availability_statuses". */
export type CoachAvailabilityStatusesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: coach_availability_statuses */
export type CoachAvailabilityStatusesPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "coach_availability_statuses" */
export enum CoachAvailabilityStatusesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "coach_availability_statuses" */
export type CoachAvailabilityStatusesSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "coach_availability_statuses" */
export type CoachAvailabilityStatusesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CoachAvailabilityStatusesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CoachAvailabilityStatusesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "coach_availability_statuses" */
export enum CoachAvailabilityStatusesUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type CoachAvailabilityStatusesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CoachAvailabilityStatusesSetInput>;
  /** filter the rows which have to be updated */
  where: CoachAvailabilityStatusesBoolExp;
};

/** aggregate stddev on columns */
export type CoachAvailabilityStddevFields = {
  __typename?: 'CoachAvailabilityStddevFields';
  endTimeMinutes?: Maybe<Scalars['Float']>;
  startTimeMinutes?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "coach_availability" */
export type CoachAvailabilityStddevOrderBy = {
  endTimeMinutes?: InputMaybe<OrderBy>;
  startTimeMinutes?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type CoachAvailabilityStddevPopFields = {
  __typename?: 'CoachAvailabilityStddevPopFields';
  endTimeMinutes?: Maybe<Scalars['Float']>;
  startTimeMinutes?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "coach_availability" */
export type CoachAvailabilityStddevPopOrderBy = {
  endTimeMinutes?: InputMaybe<OrderBy>;
  startTimeMinutes?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type CoachAvailabilityStddevSampFields = {
  __typename?: 'CoachAvailabilityStddevSampFields';
  endTimeMinutes?: Maybe<Scalars['Float']>;
  startTimeMinutes?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "coach_availability" */
export type CoachAvailabilityStddevSampOrderBy = {
  endTimeMinutes?: InputMaybe<OrderBy>;
  startTimeMinutes?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "coach_availability" */
export type CoachAvailabilityStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CoachAvailabilityStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CoachAvailabilityStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  dayOfWeek?: InputMaybe<DayOfWeekEnum>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  endTimeMinutes?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  startTimeMinutes?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<CoachAvailabilityStatusesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userCustomCourtId?: InputMaybe<Scalars['uuid']>;
  userId?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type CoachAvailabilitySumFields = {
  __typename?: 'CoachAvailabilitySumFields';
  endTimeMinutes?: Maybe<Scalars['Int']>;
  startTimeMinutes?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "coach_availability" */
export type CoachAvailabilitySumOrderBy = {
  endTimeMinutes?: InputMaybe<OrderBy>;
  startTimeMinutes?: InputMaybe<OrderBy>;
};

/** update columns of table "coach_availability" */
export enum CoachAvailabilityUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DayOfWeek = 'dayOfWeek',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EndTimeMinutes = 'endTimeMinutes',
  /** column name */
  Id = 'id',
  /** column name */
  StartTimeMinutes = 'startTimeMinutes',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserCustomCourtId = 'userCustomCourtId',
  /** column name */
  UserId = 'userId',
  /** column name */
  VenueId = 'venueId'
}

export type CoachAvailabilityUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<CoachAvailabilityIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CoachAvailabilitySetInput>;
  /** filter the rows which have to be updated */
  where: CoachAvailabilityBoolExp;
};

/** aggregate varPop on columns */
export type CoachAvailabilityVarPopFields = {
  __typename?: 'CoachAvailabilityVarPopFields';
  endTimeMinutes?: Maybe<Scalars['Float']>;
  startTimeMinutes?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "coach_availability" */
export type CoachAvailabilityVarPopOrderBy = {
  endTimeMinutes?: InputMaybe<OrderBy>;
  startTimeMinutes?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type CoachAvailabilityVarSampFields = {
  __typename?: 'CoachAvailabilityVarSampFields';
  endTimeMinutes?: Maybe<Scalars['Float']>;
  startTimeMinutes?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "coach_availability" */
export type CoachAvailabilityVarSampOrderBy = {
  endTimeMinutes?: InputMaybe<OrderBy>;
  startTimeMinutes?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type CoachAvailabilityVarianceFields = {
  __typename?: 'CoachAvailabilityVarianceFields';
  endTimeMinutes?: Maybe<Scalars['Float']>;
  startTimeMinutes?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "coach_availability" */
export type CoachAvailabilityVarianceOrderBy = {
  endTimeMinutes?: InputMaybe<OrderBy>;
  startTimeMinutes?: InputMaybe<OrderBy>;
};

/** columns and relationships of "coach_booking_requests" */
export type CoachBookingRequests = {
  __typename?: 'CoachBookingRequests';
  coachStarterProfileId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  coachUser?: Maybe<Users>;
  coachUserId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  coachUserProfile?: Maybe<UserProfiles>;
  contactedAt?: Maybe<Scalars['timestamptz']>;
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  message?: Maybe<Scalars['String']>;
  /** An object relationship */
  playerUser: Users;
  playerUserId: Scalars['uuid'];
  /** An object relationship */
  playerUserProfile?: Maybe<UserProfiles>;
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "coach_booking_requests" */
export type CoachBookingRequestsAggregate = {
  __typename?: 'CoachBookingRequestsAggregate';
  aggregate?: Maybe<CoachBookingRequestsAggregateFields>;
  nodes: Array<CoachBookingRequests>;
};

/** aggregate fields of "coach_booking_requests" */
export type CoachBookingRequestsAggregateFields = {
  __typename?: 'CoachBookingRequestsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<CoachBookingRequestsMaxFields>;
  min?: Maybe<CoachBookingRequestsMinFields>;
};


/** aggregate fields of "coach_booking_requests" */
export type CoachBookingRequestsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CoachBookingRequestsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "coach_booking_requests". All fields are combined with a logical 'AND'. */
export type CoachBookingRequestsBoolExp = {
  _and?: InputMaybe<Array<CoachBookingRequestsBoolExp>>;
  _not?: InputMaybe<CoachBookingRequestsBoolExp>;
  _or?: InputMaybe<Array<CoachBookingRequestsBoolExp>>;
  coachStarterProfileId?: InputMaybe<UuidComparisonExp>;
  coachUser?: InputMaybe<UsersBoolExp>;
  coachUserId?: InputMaybe<UuidComparisonExp>;
  coachUserProfile?: InputMaybe<UserProfilesBoolExp>;
  contactedAt?: InputMaybe<TimestamptzComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  message?: InputMaybe<StringComparisonExp>;
  playerUser?: InputMaybe<UsersBoolExp>;
  playerUserId?: InputMaybe<UuidComparisonExp>;
  playerUserProfile?: InputMaybe<UserProfilesBoolExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "coach_booking_requests" */
export enum CoachBookingRequestsConstraint {
  /** unique or primary key constraint on columns "id" */
  CoachBookingRequestsPkey = 'coach_booking_requests_pkey',
  /** unique or primary key constraint on columns "coach_user_id", "coach_starter_profile_id", "player_user_id" */
  CoachBookingRequestsPlayerUserIdCoachStarterProfileKey = 'coach_booking_requests_player_user_id_coach_starter_profile_key'
}

/** input type for inserting data into table "coach_booking_requests" */
export type CoachBookingRequestsInsertInput = {
  coachStarterProfileId?: InputMaybe<Scalars['uuid']>;
  coachUser?: InputMaybe<UsersObjRelInsertInput>;
  coachUserId?: InputMaybe<Scalars['uuid']>;
  coachUserProfile?: InputMaybe<UserProfilesObjRelInsertInput>;
  contactedAt?: InputMaybe<Scalars['timestamptz']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  message?: InputMaybe<Scalars['String']>;
  playerUser?: InputMaybe<UsersObjRelInsertInput>;
  playerUserId?: InputMaybe<Scalars['uuid']>;
  playerUserProfile?: InputMaybe<UserProfilesObjRelInsertInput>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type CoachBookingRequestsMaxFields = {
  __typename?: 'CoachBookingRequestsMaxFields';
  coachStarterProfileId?: Maybe<Scalars['uuid']>;
  coachUserId?: Maybe<Scalars['uuid']>;
  contactedAt?: Maybe<Scalars['timestamptz']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  message?: Maybe<Scalars['String']>;
  playerUserId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type CoachBookingRequestsMinFields = {
  __typename?: 'CoachBookingRequestsMinFields';
  coachStarterProfileId?: Maybe<Scalars['uuid']>;
  coachUserId?: Maybe<Scalars['uuid']>;
  contactedAt?: Maybe<Scalars['timestamptz']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  message?: Maybe<Scalars['String']>;
  playerUserId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "coach_booking_requests" */
export type CoachBookingRequestsMutationResponse = {
  __typename?: 'CoachBookingRequestsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CoachBookingRequests>;
};

/** on_conflict condition type for table "coach_booking_requests" */
export type CoachBookingRequestsOnConflict = {
  constraint: CoachBookingRequestsConstraint;
  updateColumns?: Array<CoachBookingRequestsUpdateColumn>;
  where?: InputMaybe<CoachBookingRequestsBoolExp>;
};

/** Ordering options when selecting data from "coach_booking_requests". */
export type CoachBookingRequestsOrderBy = {
  coachStarterProfileId?: InputMaybe<OrderBy>;
  coachUser?: InputMaybe<UsersOrderBy>;
  coachUserId?: InputMaybe<OrderBy>;
  coachUserProfile?: InputMaybe<UserProfilesOrderBy>;
  contactedAt?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  message?: InputMaybe<OrderBy>;
  playerUser?: InputMaybe<UsersOrderBy>;
  playerUserId?: InputMaybe<OrderBy>;
  playerUserProfile?: InputMaybe<UserProfilesOrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: coach_booking_requests */
export type CoachBookingRequestsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "coach_booking_requests" */
export enum CoachBookingRequestsSelectColumn {
  /** column name */
  CoachStarterProfileId = 'coachStarterProfileId',
  /** column name */
  CoachUserId = 'coachUserId',
  /** column name */
  ContactedAt = 'contactedAt',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  Message = 'message',
  /** column name */
  PlayerUserId = 'playerUserId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "coach_booking_requests" */
export type CoachBookingRequestsSetInput = {
  coachStarterProfileId?: InputMaybe<Scalars['uuid']>;
  coachUserId?: InputMaybe<Scalars['uuid']>;
  contactedAt?: InputMaybe<Scalars['timestamptz']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  message?: InputMaybe<Scalars['String']>;
  playerUserId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "coach_booking_requests" */
export type CoachBookingRequestsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CoachBookingRequestsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CoachBookingRequestsStreamCursorValueInput = {
  coachStarterProfileId?: InputMaybe<Scalars['uuid']>;
  coachUserId?: InputMaybe<Scalars['uuid']>;
  contactedAt?: InputMaybe<Scalars['timestamptz']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  message?: InputMaybe<Scalars['String']>;
  playerUserId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "coach_booking_requests" */
export enum CoachBookingRequestsUpdateColumn {
  /** column name */
  CoachStarterProfileId = 'coachStarterProfileId',
  /** column name */
  CoachUserId = 'coachUserId',
  /** column name */
  ContactedAt = 'contactedAt',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  Message = 'message',
  /** column name */
  PlayerUserId = 'playerUserId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type CoachBookingRequestsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CoachBookingRequestsSetInput>;
  /** filter the rows which have to be updated */
  where: CoachBookingRequestsBoolExp;
};

/** columns and relationships of "coach_external_review_sources" */
export type CoachExternalReviewSources = {
  __typename?: 'CoachExternalReviewSources';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "coach_external_review_sources" */
export type CoachExternalReviewSourcesAggregate = {
  __typename?: 'CoachExternalReviewSourcesAggregate';
  aggregate?: Maybe<CoachExternalReviewSourcesAggregateFields>;
  nodes: Array<CoachExternalReviewSources>;
};

/** aggregate fields of "coach_external_review_sources" */
export type CoachExternalReviewSourcesAggregateFields = {
  __typename?: 'CoachExternalReviewSourcesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<CoachExternalReviewSourcesMaxFields>;
  min?: Maybe<CoachExternalReviewSourcesMinFields>;
};


/** aggregate fields of "coach_external_review_sources" */
export type CoachExternalReviewSourcesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CoachExternalReviewSourcesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "coach_external_review_sources". All fields are combined with a logical 'AND'. */
export type CoachExternalReviewSourcesBoolExp = {
  _and?: InputMaybe<Array<CoachExternalReviewSourcesBoolExp>>;
  _not?: InputMaybe<CoachExternalReviewSourcesBoolExp>;
  _or?: InputMaybe<Array<CoachExternalReviewSourcesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "coach_external_review_sources" */
export enum CoachExternalReviewSourcesConstraint {
  /** unique or primary key constraint on columns "value" */
  CoachExternalReviewSourcesPkey = 'coach_external_review_sources_pkey'
}

export enum CoachExternalReviewSourcesEnum {
  Google = 'GOOGLE',
  Other = 'OTHER',
  Teachme = 'TEACHME'
}

/** Boolean expression to compare columns of type "CoachExternalReviewSourcesEnum". All fields are combined with logical 'AND'. */
export type CoachExternalReviewSourcesEnumComparisonExp = {
  _eq?: InputMaybe<CoachExternalReviewSourcesEnum>;
  _in?: InputMaybe<Array<CoachExternalReviewSourcesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<CoachExternalReviewSourcesEnum>;
  _nin?: InputMaybe<Array<CoachExternalReviewSourcesEnum>>;
};

/** input type for inserting data into table "coach_external_review_sources" */
export type CoachExternalReviewSourcesInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type CoachExternalReviewSourcesMaxFields = {
  __typename?: 'CoachExternalReviewSourcesMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type CoachExternalReviewSourcesMinFields = {
  __typename?: 'CoachExternalReviewSourcesMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "coach_external_review_sources" */
export type CoachExternalReviewSourcesMutationResponse = {
  __typename?: 'CoachExternalReviewSourcesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CoachExternalReviewSources>;
};

/** on_conflict condition type for table "coach_external_review_sources" */
export type CoachExternalReviewSourcesOnConflict = {
  constraint: CoachExternalReviewSourcesConstraint;
  updateColumns?: Array<CoachExternalReviewSourcesUpdateColumn>;
  where?: InputMaybe<CoachExternalReviewSourcesBoolExp>;
};

/** Ordering options when selecting data from "coach_external_review_sources". */
export type CoachExternalReviewSourcesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: coach_external_review_sources */
export type CoachExternalReviewSourcesPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "coach_external_review_sources" */
export enum CoachExternalReviewSourcesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "coach_external_review_sources" */
export type CoachExternalReviewSourcesSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "coach_external_review_sources" */
export type CoachExternalReviewSourcesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CoachExternalReviewSourcesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CoachExternalReviewSourcesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "coach_external_review_sources" */
export enum CoachExternalReviewSourcesUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type CoachExternalReviewSourcesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CoachExternalReviewSourcesSetInput>;
  /** filter the rows which have to be updated */
  where: CoachExternalReviewSourcesBoolExp;
};

/** columns and relationships of "coach_faqs" */
export type CoachFaqs = {
  __typename?: 'CoachFaqs';
  answer: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  question: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid'];
  /** An object relationship */
  userProfile?: Maybe<UserProfiles>;
};

/** aggregated selection of "coach_faqs" */
export type CoachFaqsAggregate = {
  __typename?: 'CoachFaqsAggregate';
  aggregate?: Maybe<CoachFaqsAggregateFields>;
  nodes: Array<CoachFaqs>;
};

export type CoachFaqsAggregateBoolExp = {
  count?: InputMaybe<CoachFaqsAggregateBoolExpCount>;
};

/** aggregate fields of "coach_faqs" */
export type CoachFaqsAggregateFields = {
  __typename?: 'CoachFaqsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<CoachFaqsMaxFields>;
  min?: Maybe<CoachFaqsMinFields>;
};


/** aggregate fields of "coach_faqs" */
export type CoachFaqsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CoachFaqsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "coach_faqs" */
export type CoachFaqsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<CoachFaqsMaxOrderBy>;
  min?: InputMaybe<CoachFaqsMinOrderBy>;
};

/** input type for inserting array relation for remote table "coach_faqs" */
export type CoachFaqsArrRelInsertInput = {
  data: Array<CoachFaqsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<CoachFaqsOnConflict>;
};

/** Boolean expression to filter rows from the table "coach_faqs". All fields are combined with a logical 'AND'. */
export type CoachFaqsBoolExp = {
  _and?: InputMaybe<Array<CoachFaqsBoolExp>>;
  _not?: InputMaybe<CoachFaqsBoolExp>;
  _or?: InputMaybe<Array<CoachFaqsBoolExp>>;
  answer?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  question?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
  userProfile?: InputMaybe<UserProfilesBoolExp>;
};

/** unique or primary key constraints on table "coach_faqs" */
export enum CoachFaqsConstraint {
  /** unique or primary key constraint on columns "id" */
  CoachFaqsPkey = 'coach_faqs_pkey'
}

/** input type for inserting data into table "coach_faqs" */
export type CoachFaqsInsertInput = {
  answer?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  question?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']>;
  userProfile?: InputMaybe<UserProfilesObjRelInsertInput>;
};

/** aggregate max on columns */
export type CoachFaqsMaxFields = {
  __typename?: 'CoachFaqsMaxFields';
  answer?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  question?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "coach_faqs" */
export type CoachFaqsMaxOrderBy = {
  answer?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  question?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type CoachFaqsMinFields = {
  __typename?: 'CoachFaqsMinFields';
  answer?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  question?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "coach_faqs" */
export type CoachFaqsMinOrderBy = {
  answer?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  question?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "coach_faqs" */
export type CoachFaqsMutationResponse = {
  __typename?: 'CoachFaqsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CoachFaqs>;
};

/** on_conflict condition type for table "coach_faqs" */
export type CoachFaqsOnConflict = {
  constraint: CoachFaqsConstraint;
  updateColumns?: Array<CoachFaqsUpdateColumn>;
  where?: InputMaybe<CoachFaqsBoolExp>;
};

/** Ordering options when selecting data from "coach_faqs". */
export type CoachFaqsOrderBy = {
  answer?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  question?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
  userProfile?: InputMaybe<UserProfilesOrderBy>;
};

/** primary key columns input for table: coach_faqs */
export type CoachFaqsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "coach_faqs" */
export enum CoachFaqsSelectColumn {
  /** column name */
  Answer = 'answer',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  Question = 'question',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "coach_faqs" */
export type CoachFaqsSetInput = {
  answer?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  question?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "coach_faqs" */
export type CoachFaqsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CoachFaqsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CoachFaqsStreamCursorValueInput = {
  answer?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  question?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "coach_faqs" */
export enum CoachFaqsUpdateColumn {
  /** column name */
  Answer = 'answer',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  Question = 'question',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

export type CoachFaqsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CoachFaqsSetInput>;
  /** filter the rows which have to be updated */
  where: CoachFaqsBoolExp;
};

/** columns and relationships of "coach_lesson_age_groups" */
export type CoachLessonAgeGroups = {
  __typename?: 'CoachLessonAgeGroups';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  lessonAgeGroup: LessonAgeGroupsEnum;
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid'];
  /** An object relationship */
  userProfile?: Maybe<UserProfiles>;
};

/** aggregated selection of "coach_lesson_age_groups" */
export type CoachLessonAgeGroupsAggregate = {
  __typename?: 'CoachLessonAgeGroupsAggregate';
  aggregate?: Maybe<CoachLessonAgeGroupsAggregateFields>;
  nodes: Array<CoachLessonAgeGroups>;
};

export type CoachLessonAgeGroupsAggregateBoolExp = {
  count?: InputMaybe<CoachLessonAgeGroupsAggregateBoolExpCount>;
};

/** aggregate fields of "coach_lesson_age_groups" */
export type CoachLessonAgeGroupsAggregateFields = {
  __typename?: 'CoachLessonAgeGroupsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<CoachLessonAgeGroupsMaxFields>;
  min?: Maybe<CoachLessonAgeGroupsMinFields>;
};


/** aggregate fields of "coach_lesson_age_groups" */
export type CoachLessonAgeGroupsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CoachLessonAgeGroupsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "coach_lesson_age_groups" */
export type CoachLessonAgeGroupsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<CoachLessonAgeGroupsMaxOrderBy>;
  min?: InputMaybe<CoachLessonAgeGroupsMinOrderBy>;
};

/** input type for inserting array relation for remote table "coach_lesson_age_groups" */
export type CoachLessonAgeGroupsArrRelInsertInput = {
  data: Array<CoachLessonAgeGroupsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<CoachLessonAgeGroupsOnConflict>;
};

/** Boolean expression to filter rows from the table "coach_lesson_age_groups". All fields are combined with a logical 'AND'. */
export type CoachLessonAgeGroupsBoolExp = {
  _and?: InputMaybe<Array<CoachLessonAgeGroupsBoolExp>>;
  _not?: InputMaybe<CoachLessonAgeGroupsBoolExp>;
  _or?: InputMaybe<Array<CoachLessonAgeGroupsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  lessonAgeGroup?: InputMaybe<LessonAgeGroupsEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
  userProfile?: InputMaybe<UserProfilesBoolExp>;
};

/** unique or primary key constraints on table "coach_lesson_age_groups" */
export enum CoachLessonAgeGroupsConstraint {
  /** unique or primary key constraint on columns "id" */
  CoachLessonAgeGroupsPkey = 'coach_lesson_age_groups_pkey',
  /** unique or primary key constraint on columns "user_id", "lesson_age_group" */
  CoachLessonAgeGroupsUserIdLessonAgeGroupKey = 'coach_lesson_age_groups_user_id_lesson_age_group_key'
}

/** input type for inserting data into table "coach_lesson_age_groups" */
export type CoachLessonAgeGroupsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  lessonAgeGroup?: InputMaybe<LessonAgeGroupsEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']>;
  userProfile?: InputMaybe<UserProfilesObjRelInsertInput>;
};

/** aggregate max on columns */
export type CoachLessonAgeGroupsMaxFields = {
  __typename?: 'CoachLessonAgeGroupsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "coach_lesson_age_groups" */
export type CoachLessonAgeGroupsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type CoachLessonAgeGroupsMinFields = {
  __typename?: 'CoachLessonAgeGroupsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "coach_lesson_age_groups" */
export type CoachLessonAgeGroupsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "coach_lesson_age_groups" */
export type CoachLessonAgeGroupsMutationResponse = {
  __typename?: 'CoachLessonAgeGroupsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CoachLessonAgeGroups>;
};

/** on_conflict condition type for table "coach_lesson_age_groups" */
export type CoachLessonAgeGroupsOnConflict = {
  constraint: CoachLessonAgeGroupsConstraint;
  updateColumns?: Array<CoachLessonAgeGroupsUpdateColumn>;
  where?: InputMaybe<CoachLessonAgeGroupsBoolExp>;
};

/** Ordering options when selecting data from "coach_lesson_age_groups". */
export type CoachLessonAgeGroupsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lessonAgeGroup?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
  userProfile?: InputMaybe<UserProfilesOrderBy>;
};

/** primary key columns input for table: coach_lesson_age_groups */
export type CoachLessonAgeGroupsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "coach_lesson_age_groups" */
export enum CoachLessonAgeGroupsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  LessonAgeGroup = 'lessonAgeGroup',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "coach_lesson_age_groups" */
export type CoachLessonAgeGroupsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  lessonAgeGroup?: InputMaybe<LessonAgeGroupsEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "coach_lesson_age_groups" */
export type CoachLessonAgeGroupsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CoachLessonAgeGroupsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CoachLessonAgeGroupsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  lessonAgeGroup?: InputMaybe<LessonAgeGroupsEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "coach_lesson_age_groups" */
export enum CoachLessonAgeGroupsUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  LessonAgeGroup = 'lessonAgeGroup',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

export type CoachLessonAgeGroupsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CoachLessonAgeGroupsSetInput>;
  /** filter the rows which have to be updated */
  where: CoachLessonAgeGroupsBoolExp;
};

/** columns and relationships of "coach_lesson_skill_levels" */
export type CoachLessonSkillLevels = {
  __typename?: 'CoachLessonSkillLevels';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  skillLevel: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid'];
  /** An object relationship */
  userProfile?: Maybe<UserProfiles>;
};

/** aggregated selection of "coach_lesson_skill_levels" */
export type CoachLessonSkillLevelsAggregate = {
  __typename?: 'CoachLessonSkillLevelsAggregate';
  aggregate?: Maybe<CoachLessonSkillLevelsAggregateFields>;
  nodes: Array<CoachLessonSkillLevels>;
};

export type CoachLessonSkillLevelsAggregateBoolExp = {
  count?: InputMaybe<CoachLessonSkillLevelsAggregateBoolExpCount>;
};

/** aggregate fields of "coach_lesson_skill_levels" */
export type CoachLessonSkillLevelsAggregateFields = {
  __typename?: 'CoachLessonSkillLevelsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<CoachLessonSkillLevelsMaxFields>;
  min?: Maybe<CoachLessonSkillLevelsMinFields>;
};


/** aggregate fields of "coach_lesson_skill_levels" */
export type CoachLessonSkillLevelsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CoachLessonSkillLevelsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "coach_lesson_skill_levels" */
export type CoachLessonSkillLevelsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<CoachLessonSkillLevelsMaxOrderBy>;
  min?: InputMaybe<CoachLessonSkillLevelsMinOrderBy>;
};

/** input type for inserting array relation for remote table "coach_lesson_skill_levels" */
export type CoachLessonSkillLevelsArrRelInsertInput = {
  data: Array<CoachLessonSkillLevelsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<CoachLessonSkillLevelsOnConflict>;
};

/** Boolean expression to filter rows from the table "coach_lesson_skill_levels". All fields are combined with a logical 'AND'. */
export type CoachLessonSkillLevelsBoolExp = {
  _and?: InputMaybe<Array<CoachLessonSkillLevelsBoolExp>>;
  _not?: InputMaybe<CoachLessonSkillLevelsBoolExp>;
  _or?: InputMaybe<Array<CoachLessonSkillLevelsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  skillLevel?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
  userProfile?: InputMaybe<UserProfilesBoolExp>;
};

/** unique or primary key constraints on table "coach_lesson_skill_levels" */
export enum CoachLessonSkillLevelsConstraint {
  /** unique or primary key constraint on columns "id" */
  CoachLessonSkillLevelsPkey = 'coach_lesson_skill_levels_pkey',
  /** unique or primary key constraint on columns "user_id", "skill_level" */
  CoachLessonSkillLevelsSkillLevelUserIdKey = 'coach_lesson_skill_levels_skill_level_user_id_key'
}

/** input type for inserting data into table "coach_lesson_skill_levels" */
export type CoachLessonSkillLevelsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  skillLevel?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']>;
  userProfile?: InputMaybe<UserProfilesObjRelInsertInput>;
};

/** aggregate max on columns */
export type CoachLessonSkillLevelsMaxFields = {
  __typename?: 'CoachLessonSkillLevelsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  skillLevel?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "coach_lesson_skill_levels" */
export type CoachLessonSkillLevelsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  skillLevel?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type CoachLessonSkillLevelsMinFields = {
  __typename?: 'CoachLessonSkillLevelsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  skillLevel?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "coach_lesson_skill_levels" */
export type CoachLessonSkillLevelsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  skillLevel?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "coach_lesson_skill_levels" */
export type CoachLessonSkillLevelsMutationResponse = {
  __typename?: 'CoachLessonSkillLevelsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CoachLessonSkillLevels>;
};

/** on_conflict condition type for table "coach_lesson_skill_levels" */
export type CoachLessonSkillLevelsOnConflict = {
  constraint: CoachLessonSkillLevelsConstraint;
  updateColumns?: Array<CoachLessonSkillLevelsUpdateColumn>;
  where?: InputMaybe<CoachLessonSkillLevelsBoolExp>;
};

/** Ordering options when selecting data from "coach_lesson_skill_levels". */
export type CoachLessonSkillLevelsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  skillLevel?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
  userProfile?: InputMaybe<UserProfilesOrderBy>;
};

/** primary key columns input for table: coach_lesson_skill_levels */
export type CoachLessonSkillLevelsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "coach_lesson_skill_levels" */
export enum CoachLessonSkillLevelsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  SkillLevel = 'skillLevel',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "coach_lesson_skill_levels" */
export type CoachLessonSkillLevelsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  skillLevel?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "coach_lesson_skill_levels" */
export type CoachLessonSkillLevelsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CoachLessonSkillLevelsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CoachLessonSkillLevelsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  skillLevel?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "coach_lesson_skill_levels" */
export enum CoachLessonSkillLevelsUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  SkillLevel = 'skillLevel',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

export type CoachLessonSkillLevelsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CoachLessonSkillLevelsSetInput>;
  /** filter the rows which have to be updated */
  where: CoachLessonSkillLevelsBoolExp;
};

/** columns and relationships of "coach_qualification_groups" */
export type CoachQualificationGroups = {
  __typename?: 'CoachQualificationGroups';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "coach_qualification_groups" */
export type CoachQualificationGroupsAggregate = {
  __typename?: 'CoachQualificationGroupsAggregate';
  aggregate?: Maybe<CoachQualificationGroupsAggregateFields>;
  nodes: Array<CoachQualificationGroups>;
};

/** aggregate fields of "coach_qualification_groups" */
export type CoachQualificationGroupsAggregateFields = {
  __typename?: 'CoachQualificationGroupsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<CoachQualificationGroupsMaxFields>;
  min?: Maybe<CoachQualificationGroupsMinFields>;
};


/** aggregate fields of "coach_qualification_groups" */
export type CoachQualificationGroupsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CoachQualificationGroupsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "coach_qualification_groups". All fields are combined with a logical 'AND'. */
export type CoachQualificationGroupsBoolExp = {
  _and?: InputMaybe<Array<CoachQualificationGroupsBoolExp>>;
  _not?: InputMaybe<CoachQualificationGroupsBoolExp>;
  _or?: InputMaybe<Array<CoachQualificationGroupsBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "coach_qualification_groups" */
export enum CoachQualificationGroupsConstraint {
  /** unique or primary key constraint on columns "value" */
  CoachQualificationGroupsPkey = 'coach_qualification_groups_pkey'
}

export enum CoachQualificationGroupsEnum {
  Certificate = 'CERTIFICATE',
  CurrentCollegePlayer = 'CURRENT_COLLEGE_PLAYER',
  FormerCollegePlayer = 'FORMER_COLLEGE_PLAYER'
}

/** Boolean expression to compare columns of type "CoachQualificationGroupsEnum". All fields are combined with logical 'AND'. */
export type CoachQualificationGroupsEnumComparisonExp = {
  _eq?: InputMaybe<CoachQualificationGroupsEnum>;
  _in?: InputMaybe<Array<CoachQualificationGroupsEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<CoachQualificationGroupsEnum>;
  _nin?: InputMaybe<Array<CoachQualificationGroupsEnum>>;
};

/** input type for inserting data into table "coach_qualification_groups" */
export type CoachQualificationGroupsInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type CoachQualificationGroupsMaxFields = {
  __typename?: 'CoachQualificationGroupsMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type CoachQualificationGroupsMinFields = {
  __typename?: 'CoachQualificationGroupsMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "coach_qualification_groups" */
export type CoachQualificationGroupsMutationResponse = {
  __typename?: 'CoachQualificationGroupsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CoachQualificationGroups>;
};

/** on_conflict condition type for table "coach_qualification_groups" */
export type CoachQualificationGroupsOnConflict = {
  constraint: CoachQualificationGroupsConstraint;
  updateColumns?: Array<CoachQualificationGroupsUpdateColumn>;
  where?: InputMaybe<CoachQualificationGroupsBoolExp>;
};

/** Ordering options when selecting data from "coach_qualification_groups". */
export type CoachQualificationGroupsOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: coach_qualification_groups */
export type CoachQualificationGroupsPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "coach_qualification_groups" */
export enum CoachQualificationGroupsSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "coach_qualification_groups" */
export type CoachQualificationGroupsSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "coach_qualification_groups" */
export type CoachQualificationGroupsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CoachQualificationGroupsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CoachQualificationGroupsStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "coach_qualification_groups" */
export enum CoachQualificationGroupsUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type CoachQualificationGroupsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CoachQualificationGroupsSetInput>;
  /** filter the rows which have to be updated */
  where: CoachQualificationGroupsBoolExp;
};

/** columns and relationships of "coach_qualification_statuses" */
export type CoachQualificationStatuses = {
  __typename?: 'CoachQualificationStatuses';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "coach_qualification_statuses" */
export type CoachQualificationStatusesAggregate = {
  __typename?: 'CoachQualificationStatusesAggregate';
  aggregate?: Maybe<CoachQualificationStatusesAggregateFields>;
  nodes: Array<CoachQualificationStatuses>;
};

/** aggregate fields of "coach_qualification_statuses" */
export type CoachQualificationStatusesAggregateFields = {
  __typename?: 'CoachQualificationStatusesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<CoachQualificationStatusesMaxFields>;
  min?: Maybe<CoachQualificationStatusesMinFields>;
};


/** aggregate fields of "coach_qualification_statuses" */
export type CoachQualificationStatusesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CoachQualificationStatusesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "coach_qualification_statuses". All fields are combined with a logical 'AND'. */
export type CoachQualificationStatusesBoolExp = {
  _and?: InputMaybe<Array<CoachQualificationStatusesBoolExp>>;
  _not?: InputMaybe<CoachQualificationStatusesBoolExp>;
  _or?: InputMaybe<Array<CoachQualificationStatusesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "coach_qualification_statuses" */
export enum CoachQualificationStatusesConstraint {
  /** unique or primary key constraint on columns "value" */
  CoachQualificationStatusesPkey = 'coach_qualification_statuses_pkey'
}

export enum CoachQualificationStatusesEnum {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

/** Boolean expression to compare columns of type "CoachQualificationStatusesEnum". All fields are combined with logical 'AND'. */
export type CoachQualificationStatusesEnumComparisonExp = {
  _eq?: InputMaybe<CoachQualificationStatusesEnum>;
  _in?: InputMaybe<Array<CoachQualificationStatusesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<CoachQualificationStatusesEnum>;
  _nin?: InputMaybe<Array<CoachQualificationStatusesEnum>>;
};

/** input type for inserting data into table "coach_qualification_statuses" */
export type CoachQualificationStatusesInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type CoachQualificationStatusesMaxFields = {
  __typename?: 'CoachQualificationStatusesMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type CoachQualificationStatusesMinFields = {
  __typename?: 'CoachQualificationStatusesMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "coach_qualification_statuses" */
export type CoachQualificationStatusesMutationResponse = {
  __typename?: 'CoachQualificationStatusesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CoachQualificationStatuses>;
};

/** on_conflict condition type for table "coach_qualification_statuses" */
export type CoachQualificationStatusesOnConflict = {
  constraint: CoachQualificationStatusesConstraint;
  updateColumns?: Array<CoachQualificationStatusesUpdateColumn>;
  where?: InputMaybe<CoachQualificationStatusesBoolExp>;
};

/** Ordering options when selecting data from "coach_qualification_statuses". */
export type CoachQualificationStatusesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: coach_qualification_statuses */
export type CoachQualificationStatusesPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "coach_qualification_statuses" */
export enum CoachQualificationStatusesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "coach_qualification_statuses" */
export type CoachQualificationStatusesSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "coach_qualification_statuses" */
export type CoachQualificationStatusesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CoachQualificationStatusesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CoachQualificationStatusesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "coach_qualification_statuses" */
export enum CoachQualificationStatusesUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type CoachQualificationStatusesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CoachQualificationStatusesSetInput>;
  /** filter the rows which have to be updated */
  where: CoachQualificationStatusesBoolExp;
};

/** columns and relationships of "coach_qualifications" */
export type CoachQualifications = {
  __typename?: 'CoachQualifications';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  displayKey: Scalars['String'];
  groupId?: Maybe<CoachQualificationGroupsEnum>;
  id: Scalars['uuid'];
  name: Scalars['String'];
  order: Scalars['Int'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "coach_qualifications" */
export type CoachQualificationsAggregate = {
  __typename?: 'CoachQualificationsAggregate';
  aggregate?: Maybe<CoachQualificationsAggregateFields>;
  nodes: Array<CoachQualifications>;
};

/** aggregate fields of "coach_qualifications" */
export type CoachQualificationsAggregateFields = {
  __typename?: 'CoachQualificationsAggregateFields';
  avg?: Maybe<CoachQualificationsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CoachQualificationsMaxFields>;
  min?: Maybe<CoachQualificationsMinFields>;
  stddev?: Maybe<CoachQualificationsStddevFields>;
  stddevPop?: Maybe<CoachQualificationsStddevPopFields>;
  stddevSamp?: Maybe<CoachQualificationsStddevSampFields>;
  sum?: Maybe<CoachQualificationsSumFields>;
  varPop?: Maybe<CoachQualificationsVarPopFields>;
  varSamp?: Maybe<CoachQualificationsVarSampFields>;
  variance?: Maybe<CoachQualificationsVarianceFields>;
};


/** aggregate fields of "coach_qualifications" */
export type CoachQualificationsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CoachQualificationsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type CoachQualificationsAvgFields = {
  __typename?: 'CoachQualificationsAvgFields';
  order?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "coach_qualifications". All fields are combined with a logical 'AND'. */
export type CoachQualificationsBoolExp = {
  _and?: InputMaybe<Array<CoachQualificationsBoolExp>>;
  _not?: InputMaybe<CoachQualificationsBoolExp>;
  _or?: InputMaybe<Array<CoachQualificationsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  displayKey?: InputMaybe<StringComparisonExp>;
  groupId?: InputMaybe<CoachQualificationGroupsEnumComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  order?: InputMaybe<IntComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "coach_qualifications" */
export enum CoachQualificationsConstraint {
  /** unique or primary key constraint on columns "display_key" */
  CoachQualificationsDisplayKeyKey = 'coach_qualifications_display_key_key',
  /** unique or primary key constraint on columns "id" */
  CoachQualificationsPkey = 'coach_qualifications_pkey'
}

/** input type for incrementing numeric columns in table "coach_qualifications" */
export type CoachQualificationsIncInput = {
  order?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "coach_qualifications" */
export type CoachQualificationsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  displayKey?: InputMaybe<Scalars['String']>;
  groupId?: InputMaybe<CoachQualificationGroupsEnum>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type CoachQualificationsMaxFields = {
  __typename?: 'CoachQualificationsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  displayKey?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type CoachQualificationsMinFields = {
  __typename?: 'CoachQualificationsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  displayKey?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "coach_qualifications" */
export type CoachQualificationsMutationResponse = {
  __typename?: 'CoachQualificationsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CoachQualifications>;
};

/** input type for inserting object relation for remote table "coach_qualifications" */
export type CoachQualificationsObjRelInsertInput = {
  data: CoachQualificationsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<CoachQualificationsOnConflict>;
};

/** on_conflict condition type for table "coach_qualifications" */
export type CoachQualificationsOnConflict = {
  constraint: CoachQualificationsConstraint;
  updateColumns?: Array<CoachQualificationsUpdateColumn>;
  where?: InputMaybe<CoachQualificationsBoolExp>;
};

/** Ordering options when selecting data from "coach_qualifications". */
export type CoachQualificationsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  displayKey?: InputMaybe<OrderBy>;
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  order?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: coach_qualifications */
export type CoachQualificationsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "coach_qualifications" */
export enum CoachQualificationsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  DisplayKey = 'displayKey',
  /** column name */
  GroupId = 'groupId',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "coach_qualifications" */
export type CoachQualificationsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  displayKey?: InputMaybe<Scalars['String']>;
  groupId?: InputMaybe<CoachQualificationGroupsEnum>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type CoachQualificationsStddevFields = {
  __typename?: 'CoachQualificationsStddevFields';
  order?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type CoachQualificationsStddevPopFields = {
  __typename?: 'CoachQualificationsStddevPopFields';
  order?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type CoachQualificationsStddevSampFields = {
  __typename?: 'CoachQualificationsStddevSampFields';
  order?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "coach_qualifications" */
export type CoachQualificationsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CoachQualificationsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CoachQualificationsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  displayKey?: InputMaybe<Scalars['String']>;
  groupId?: InputMaybe<CoachQualificationGroupsEnum>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type CoachQualificationsSumFields = {
  __typename?: 'CoachQualificationsSumFields';
  order?: Maybe<Scalars['Int']>;
};

/** update columns of table "coach_qualifications" */
export enum CoachQualificationsUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  DisplayKey = 'displayKey',
  /** column name */
  GroupId = 'groupId',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type CoachQualificationsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<CoachQualificationsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CoachQualificationsSetInput>;
  /** filter the rows which have to be updated */
  where: CoachQualificationsBoolExp;
};

/** aggregate varPop on columns */
export type CoachQualificationsVarPopFields = {
  __typename?: 'CoachQualificationsVarPopFields';
  order?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type CoachQualificationsVarSampFields = {
  __typename?: 'CoachQualificationsVarSampFields';
  order?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type CoachQualificationsVarianceFields = {
  __typename?: 'CoachQualificationsVarianceFields';
  order?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "coach_review_types" */
export type CoachReviewTypes = {
  __typename?: 'CoachReviewTypes';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "coach_review_types" */
export type CoachReviewTypesAggregate = {
  __typename?: 'CoachReviewTypesAggregate';
  aggregate?: Maybe<CoachReviewTypesAggregateFields>;
  nodes: Array<CoachReviewTypes>;
};

/** aggregate fields of "coach_review_types" */
export type CoachReviewTypesAggregateFields = {
  __typename?: 'CoachReviewTypesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<CoachReviewTypesMaxFields>;
  min?: Maybe<CoachReviewTypesMinFields>;
};


/** aggregate fields of "coach_review_types" */
export type CoachReviewTypesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CoachReviewTypesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "coach_review_types". All fields are combined with a logical 'AND'. */
export type CoachReviewTypesBoolExp = {
  _and?: InputMaybe<Array<CoachReviewTypesBoolExp>>;
  _not?: InputMaybe<CoachReviewTypesBoolExp>;
  _or?: InputMaybe<Array<CoachReviewTypesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "coach_review_types" */
export enum CoachReviewTypesConstraint {
  /** unique or primary key constraint on columns "value" */
  CoachReviewTypesPkey = 'coach_review_types_pkey'
}

export enum CoachReviewTypesEnum {
  Court = 'COURT',
  Remote = 'REMOTE'
}

/** Boolean expression to compare columns of type "CoachReviewTypesEnum". All fields are combined with logical 'AND'. */
export type CoachReviewTypesEnumComparisonExp = {
  _eq?: InputMaybe<CoachReviewTypesEnum>;
  _in?: InputMaybe<Array<CoachReviewTypesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<CoachReviewTypesEnum>;
  _nin?: InputMaybe<Array<CoachReviewTypesEnum>>;
};

/** input type for inserting data into table "coach_review_types" */
export type CoachReviewTypesInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type CoachReviewTypesMaxFields = {
  __typename?: 'CoachReviewTypesMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type CoachReviewTypesMinFields = {
  __typename?: 'CoachReviewTypesMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "coach_review_types" */
export type CoachReviewTypesMutationResponse = {
  __typename?: 'CoachReviewTypesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CoachReviewTypes>;
};

/** on_conflict condition type for table "coach_review_types" */
export type CoachReviewTypesOnConflict = {
  constraint: CoachReviewTypesConstraint;
  updateColumns?: Array<CoachReviewTypesUpdateColumn>;
  where?: InputMaybe<CoachReviewTypesBoolExp>;
};

/** Ordering options when selecting data from "coach_review_types". */
export type CoachReviewTypesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: coach_review_types */
export type CoachReviewTypesPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "coach_review_types" */
export enum CoachReviewTypesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "coach_review_types" */
export type CoachReviewTypesSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "coach_review_types" */
export type CoachReviewTypesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CoachReviewTypesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CoachReviewTypesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "coach_review_types" */
export enum CoachReviewTypesUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type CoachReviewTypesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CoachReviewTypesSetInput>;
  /** filter the rows which have to be updated */
  where: CoachReviewTypesBoolExp;
};

/** columns and relationships of "coach_sport_statuses" */
export type CoachSportStatuses = {
  __typename?: 'CoachSportStatuses';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "coach_sport_statuses" */
export type CoachSportStatusesAggregate = {
  __typename?: 'CoachSportStatusesAggregate';
  aggregate?: Maybe<CoachSportStatusesAggregateFields>;
  nodes: Array<CoachSportStatuses>;
};

/** aggregate fields of "coach_sport_statuses" */
export type CoachSportStatusesAggregateFields = {
  __typename?: 'CoachSportStatusesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<CoachSportStatusesMaxFields>;
  min?: Maybe<CoachSportStatusesMinFields>;
};


/** aggregate fields of "coach_sport_statuses" */
export type CoachSportStatusesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CoachSportStatusesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "coach_sport_statuses". All fields are combined with a logical 'AND'. */
export type CoachSportStatusesBoolExp = {
  _and?: InputMaybe<Array<CoachSportStatusesBoolExp>>;
  _not?: InputMaybe<CoachSportStatusesBoolExp>;
  _or?: InputMaybe<Array<CoachSportStatusesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "coach_sport_statuses" */
export enum CoachSportStatusesConstraint {
  /** unique or primary key constraint on columns "value" */
  CoachSportStatusesPkey = 'coach_sport_statuses_pkey'
}

export enum CoachSportStatusesEnum {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

/** Boolean expression to compare columns of type "CoachSportStatusesEnum". All fields are combined with logical 'AND'. */
export type CoachSportStatusesEnumComparisonExp = {
  _eq?: InputMaybe<CoachSportStatusesEnum>;
  _in?: InputMaybe<Array<CoachSportStatusesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<CoachSportStatusesEnum>;
  _nin?: InputMaybe<Array<CoachSportStatusesEnum>>;
};

/** input type for inserting data into table "coach_sport_statuses" */
export type CoachSportStatusesInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type CoachSportStatusesMaxFields = {
  __typename?: 'CoachSportStatusesMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type CoachSportStatusesMinFields = {
  __typename?: 'CoachSportStatusesMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "coach_sport_statuses" */
export type CoachSportStatusesMutationResponse = {
  __typename?: 'CoachSportStatusesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CoachSportStatuses>;
};

/** on_conflict condition type for table "coach_sport_statuses" */
export type CoachSportStatusesOnConflict = {
  constraint: CoachSportStatusesConstraint;
  updateColumns?: Array<CoachSportStatusesUpdateColumn>;
  where?: InputMaybe<CoachSportStatusesBoolExp>;
};

/** Ordering options when selecting data from "coach_sport_statuses". */
export type CoachSportStatusesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: coach_sport_statuses */
export type CoachSportStatusesPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "coach_sport_statuses" */
export enum CoachSportStatusesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "coach_sport_statuses" */
export type CoachSportStatusesSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "coach_sport_statuses" */
export type CoachSportStatusesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CoachSportStatusesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CoachSportStatusesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "coach_sport_statuses" */
export enum CoachSportStatusesUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type CoachSportStatusesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CoachSportStatusesSetInput>;
  /** filter the rows which have to be updated */
  where: CoachSportStatusesBoolExp;
};

/** columns and relationships of "coach_sports" */
export type CoachSports = {
  __typename?: 'CoachSports';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  sport: SportsEnum;
  status: CoachSportStatusesEnum;
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid'];
};

/** aggregated selection of "coach_sports" */
export type CoachSportsAggregate = {
  __typename?: 'CoachSportsAggregate';
  aggregate?: Maybe<CoachSportsAggregateFields>;
  nodes: Array<CoachSports>;
};

export type CoachSportsAggregateBoolExp = {
  count?: InputMaybe<CoachSportsAggregateBoolExpCount>;
};

/** aggregate fields of "coach_sports" */
export type CoachSportsAggregateFields = {
  __typename?: 'CoachSportsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<CoachSportsMaxFields>;
  min?: Maybe<CoachSportsMinFields>;
};


/** aggregate fields of "coach_sports" */
export type CoachSportsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CoachSportsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "coach_sports" */
export type CoachSportsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<CoachSportsMaxOrderBy>;
  min?: InputMaybe<CoachSportsMinOrderBy>;
};

/** input type for inserting array relation for remote table "coach_sports" */
export type CoachSportsArrRelInsertInput = {
  data: Array<CoachSportsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<CoachSportsOnConflict>;
};

/** Boolean expression to filter rows from the table "coach_sports". All fields are combined with a logical 'AND'. */
export type CoachSportsBoolExp = {
  _and?: InputMaybe<Array<CoachSportsBoolExp>>;
  _not?: InputMaybe<CoachSportsBoolExp>;
  _or?: InputMaybe<Array<CoachSportsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  sport?: InputMaybe<SportsEnumComparisonExp>;
  status?: InputMaybe<CoachSportStatusesEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "coach_sports" */
export enum CoachSportsConstraint {
  /** unique or primary key constraint on columns "id" */
  CoachSportsPkey = 'coach_sports_pkey',
  /** unique or primary key constraint on columns "sport", "user_id" */
  CoachSportsUserIdSportKey = 'coach_sports_user_id_sport_key'
}

/** input type for inserting data into table "coach_sports" */
export type CoachSportsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  sport?: InputMaybe<SportsEnum>;
  status?: InputMaybe<CoachSportStatusesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type CoachSportsMaxFields = {
  __typename?: 'CoachSportsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "coach_sports" */
export type CoachSportsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type CoachSportsMinFields = {
  __typename?: 'CoachSportsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "coach_sports" */
export type CoachSportsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "coach_sports" */
export type CoachSportsMutationResponse = {
  __typename?: 'CoachSportsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CoachSports>;
};

/** on_conflict condition type for table "coach_sports" */
export type CoachSportsOnConflict = {
  constraint: CoachSportsConstraint;
  updateColumns?: Array<CoachSportsUpdateColumn>;
  where?: InputMaybe<CoachSportsBoolExp>;
};

/** Ordering options when selecting data from "coach_sports". */
export type CoachSportsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  sport?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: coach_sports */
export type CoachSportsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "coach_sports" */
export enum CoachSportsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  Sport = 'sport',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "coach_sports" */
export type CoachSportsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  sport?: InputMaybe<SportsEnum>;
  status?: InputMaybe<CoachSportStatusesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "coach_sports" */
export type CoachSportsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CoachSportsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CoachSportsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  sport?: InputMaybe<SportsEnum>;
  status?: InputMaybe<CoachSportStatusesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "coach_sports" */
export enum CoachSportsUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  Sport = 'sport',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

export type CoachSportsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CoachSportsSetInput>;
  /** filter the rows which have to be updated */
  where: CoachSportsBoolExp;
};

/** columns and relationships of "coach_starter_profiles" */
export type CoachStarterProfiles = {
  __typename?: 'CoachStarterProfiles';
  aboutMe?: Maybe<Scalars['String']>;
  aboutPhotoImageUrl?: Maybe<Scalars['String']>;
  accountClaimedAt?: Maybe<Scalars['timestamptz']>;
  addressDisplay?: Maybe<Scalars['String']>;
  addressString?: Maybe<Scalars['String']>;
  addressType?: Maybe<Scalars['String']>;
  age?: Maybe<Scalars['String']>;
  birthdate?: Maybe<Scalars['String']>;
  /** An object relationship */
  city?: Maybe<Cities>;
  cityId?: Maybe<Scalars['uuid']>;
  cityName?: Maybe<Scalars['String']>;
  claimUserId?: Maybe<Scalars['uuid']>;
  company?: Maybe<Scalars['String']>;
  countryName?: Maybe<Scalars['String']>;
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  duprProfile?: Maybe<Scalars['String']>;
  duprRating?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  facebook?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  geometry?: Maybe<Scalars['geography']>;
  id: Scalars['uuid'];
  instagram?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['numeric']>;
  level?: Maybe<Scalars['String']>;
  linkedin?: Maybe<Scalars['String']>;
  listingType?: Maybe<Scalars['String']>;
  logoImageUrl?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['numeric']>;
  name?: Maybe<Scalars['String']>;
  needsReview?: Maybe<Scalars['Boolean']>;
  otherSocial?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  playerLevel?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['String']>;
  profileImageUrl?: Maybe<Scalars['String']>;
  selkirkAdv?: Maybe<Scalars['Boolean']>;
  shortDescription?: Maybe<Scalars['String']>;
  source: Scalars['String'];
  sourceAboutPhotoImageUrl?: Maybe<Scalars['String']>;
  sourceCreatedAt?: Maybe<Scalars['timestamptz']>;
  sourceId: Scalars['String'];
  sourceIsActive?: Maybe<Scalars['Boolean']>;
  sourceLocale?: Maybe<Scalars['String']>;
  sourceLogoImageUrl?: Maybe<Scalars['String']>;
  sourceProfileImageUrl?: Maybe<Scalars['String']>;
  sourceProfileSlug?: Maybe<Scalars['String']>;
  sourceSlug?: Maybe<Scalars['String']>;
  sourceSubscribedToEmails?: Maybe<Scalars['Boolean']>;
  sourceUsername?: Maybe<Scalars['String']>;
  stateName?: Maybe<Scalars['String']>;
  teacherCertArr?: Maybe<Scalars['jsonb']>;
  teacherCertImages?: Maybe<Scalars['String']>;
  teacherCertLinks?: Maybe<Scalars['jsonb']>;
  teacherCertifications?: Maybe<Scalars['String']>;
  twitter?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamptz'];
  usapRating?: Maybe<Scalars['String']>;
  /** An object relationship */
  user?: Maybe<Users>;
  verified?: Maybe<Scalars['Boolean']>;
  website?: Maybe<Scalars['String']>;
  youtube?: Maybe<Scalars['String']>;
  zipcode?: Maybe<Scalars['String']>;
};


/** columns and relationships of "coach_starter_profiles" */
export type CoachStarterProfilesTeacherCertArrArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "coach_starter_profiles" */
export type CoachStarterProfilesTeacherCertLinksArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "coach_starter_profiles" */
export type CoachStarterProfilesAggregate = {
  __typename?: 'CoachStarterProfilesAggregate';
  aggregate?: Maybe<CoachStarterProfilesAggregateFields>;
  nodes: Array<CoachStarterProfiles>;
};

export type CoachStarterProfilesAggregateBoolExp = {
  bool_and?: InputMaybe<CoachStarterProfilesAggregateBoolExpBool_And>;
  bool_or?: InputMaybe<CoachStarterProfilesAggregateBoolExpBool_Or>;
  count?: InputMaybe<CoachStarterProfilesAggregateBoolExpCount>;
};

/** aggregate fields of "coach_starter_profiles" */
export type CoachStarterProfilesAggregateFields = {
  __typename?: 'CoachStarterProfilesAggregateFields';
  avg?: Maybe<CoachStarterProfilesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CoachStarterProfilesMaxFields>;
  min?: Maybe<CoachStarterProfilesMinFields>;
  stddev?: Maybe<CoachStarterProfilesStddevFields>;
  stddevPop?: Maybe<CoachStarterProfilesStddevPopFields>;
  stddevSamp?: Maybe<CoachStarterProfilesStddevSampFields>;
  sum?: Maybe<CoachStarterProfilesSumFields>;
  varPop?: Maybe<CoachStarterProfilesVarPopFields>;
  varSamp?: Maybe<CoachStarterProfilesVarSampFields>;
  variance?: Maybe<CoachStarterProfilesVarianceFields>;
};


/** aggregate fields of "coach_starter_profiles" */
export type CoachStarterProfilesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CoachStarterProfilesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "coach_starter_profiles" */
export type CoachStarterProfilesAggregateOrderBy = {
  avg?: InputMaybe<CoachStarterProfilesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<CoachStarterProfilesMaxOrderBy>;
  min?: InputMaybe<CoachStarterProfilesMinOrderBy>;
  stddev?: InputMaybe<CoachStarterProfilesStddevOrderBy>;
  stddevPop?: InputMaybe<CoachStarterProfilesStddevPopOrderBy>;
  stddevSamp?: InputMaybe<CoachStarterProfilesStddevSampOrderBy>;
  sum?: InputMaybe<CoachStarterProfilesSumOrderBy>;
  varPop?: InputMaybe<CoachStarterProfilesVarPopOrderBy>;
  varSamp?: InputMaybe<CoachStarterProfilesVarSampOrderBy>;
  variance?: InputMaybe<CoachStarterProfilesVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type CoachStarterProfilesAppendInput = {
  teacherCertArr?: InputMaybe<Scalars['jsonb']>;
  teacherCertLinks?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "coach_starter_profiles" */
export type CoachStarterProfilesArrRelInsertInput = {
  data: Array<CoachStarterProfilesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<CoachStarterProfilesOnConflict>;
};

/** aggregate avg on columns */
export type CoachStarterProfilesAvgFields = {
  __typename?: 'CoachStarterProfilesAvgFields';
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "coach_starter_profiles" */
export type CoachStarterProfilesAvgOrderBy = {
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "coach_starter_profiles". All fields are combined with a logical 'AND'. */
export type CoachStarterProfilesBoolExp = {
  _and?: InputMaybe<Array<CoachStarterProfilesBoolExp>>;
  _not?: InputMaybe<CoachStarterProfilesBoolExp>;
  _or?: InputMaybe<Array<CoachStarterProfilesBoolExp>>;
  aboutMe?: InputMaybe<StringComparisonExp>;
  aboutPhotoImageUrl?: InputMaybe<StringComparisonExp>;
  accountClaimedAt?: InputMaybe<TimestamptzComparisonExp>;
  addressDisplay?: InputMaybe<StringComparisonExp>;
  addressString?: InputMaybe<StringComparisonExp>;
  addressType?: InputMaybe<StringComparisonExp>;
  age?: InputMaybe<StringComparisonExp>;
  birthdate?: InputMaybe<StringComparisonExp>;
  city?: InputMaybe<CitiesBoolExp>;
  cityId?: InputMaybe<UuidComparisonExp>;
  cityName?: InputMaybe<StringComparisonExp>;
  claimUserId?: InputMaybe<UuidComparisonExp>;
  company?: InputMaybe<StringComparisonExp>;
  countryName?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  duprProfile?: InputMaybe<StringComparisonExp>;
  duprRating?: InputMaybe<StringComparisonExp>;
  email?: InputMaybe<StringComparisonExp>;
  facebook?: InputMaybe<StringComparisonExp>;
  gender?: InputMaybe<StringComparisonExp>;
  geometry?: InputMaybe<GeographyComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  instagram?: InputMaybe<StringComparisonExp>;
  latitude?: InputMaybe<NumericComparisonExp>;
  level?: InputMaybe<StringComparisonExp>;
  linkedin?: InputMaybe<StringComparisonExp>;
  listingType?: InputMaybe<StringComparisonExp>;
  logoImageUrl?: InputMaybe<StringComparisonExp>;
  longitude?: InputMaybe<NumericComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  needsReview?: InputMaybe<BooleanComparisonExp>;
  otherSocial?: InputMaybe<StringComparisonExp>;
  phoneNumber?: InputMaybe<StringComparisonExp>;
  playerLevel?: InputMaybe<StringComparisonExp>;
  position?: InputMaybe<StringComparisonExp>;
  profileImageUrl?: InputMaybe<StringComparisonExp>;
  selkirkAdv?: InputMaybe<BooleanComparisonExp>;
  shortDescription?: InputMaybe<StringComparisonExp>;
  source?: InputMaybe<StringComparisonExp>;
  sourceAboutPhotoImageUrl?: InputMaybe<StringComparisonExp>;
  sourceCreatedAt?: InputMaybe<TimestamptzComparisonExp>;
  sourceId?: InputMaybe<StringComparisonExp>;
  sourceIsActive?: InputMaybe<BooleanComparisonExp>;
  sourceLocale?: InputMaybe<StringComparisonExp>;
  sourceLogoImageUrl?: InputMaybe<StringComparisonExp>;
  sourceProfileImageUrl?: InputMaybe<StringComparisonExp>;
  sourceProfileSlug?: InputMaybe<StringComparisonExp>;
  sourceSlug?: InputMaybe<StringComparisonExp>;
  sourceSubscribedToEmails?: InputMaybe<BooleanComparisonExp>;
  sourceUsername?: InputMaybe<StringComparisonExp>;
  stateName?: InputMaybe<StringComparisonExp>;
  teacherCertArr?: InputMaybe<JsonbComparisonExp>;
  teacherCertImages?: InputMaybe<StringComparisonExp>;
  teacherCertLinks?: InputMaybe<JsonbComparisonExp>;
  teacherCertifications?: InputMaybe<StringComparisonExp>;
  twitter?: InputMaybe<StringComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  usapRating?: InputMaybe<StringComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  verified?: InputMaybe<BooleanComparisonExp>;
  website?: InputMaybe<StringComparisonExp>;
  youtube?: InputMaybe<StringComparisonExp>;
  zipcode?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "coach_starter_profiles" */
export enum CoachStarterProfilesConstraint {
  /** unique or primary key constraint on columns "email" */
  CoachStarterProfilesEmailKey = 'coach_starter_profiles_email_key',
  /** unique or primary key constraint on columns "id" */
  CoachStarterProfilesPkey = 'coach_starter_profiles_pkey',
  /** unique or primary key constraint on columns "source_id" */
  CoachStarterProfilesSourceIdKey = 'coach_starter_profiles_source_id_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type CoachStarterProfilesDeleteAtPathInput = {
  teacherCertArr?: InputMaybe<Array<Scalars['String']>>;
  teacherCertLinks?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type CoachStarterProfilesDeleteElemInput = {
  teacherCertArr?: InputMaybe<Scalars['Int']>;
  teacherCertLinks?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type CoachStarterProfilesDeleteKeyInput = {
  teacherCertArr?: InputMaybe<Scalars['String']>;
  teacherCertLinks?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "coach_starter_profiles" */
export type CoachStarterProfilesIncInput = {
  latitude?: InputMaybe<Scalars['numeric']>;
  longitude?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "coach_starter_profiles" */
export type CoachStarterProfilesInsertInput = {
  aboutMe?: InputMaybe<Scalars['String']>;
  aboutPhotoImageUrl?: InputMaybe<Scalars['String']>;
  accountClaimedAt?: InputMaybe<Scalars['timestamptz']>;
  addressDisplay?: InputMaybe<Scalars['String']>;
  addressString?: InputMaybe<Scalars['String']>;
  addressType?: InputMaybe<Scalars['String']>;
  age?: InputMaybe<Scalars['String']>;
  birthdate?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<CitiesObjRelInsertInput>;
  cityId?: InputMaybe<Scalars['uuid']>;
  cityName?: InputMaybe<Scalars['String']>;
  claimUserId?: InputMaybe<Scalars['uuid']>;
  company?: InputMaybe<Scalars['String']>;
  countryName?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  duprProfile?: InputMaybe<Scalars['String']>;
  duprRating?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  facebook?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  geometry?: InputMaybe<Scalars['geography']>;
  id?: InputMaybe<Scalars['uuid']>;
  instagram?: InputMaybe<Scalars['String']>;
  latitude?: InputMaybe<Scalars['numeric']>;
  level?: InputMaybe<Scalars['String']>;
  linkedin?: InputMaybe<Scalars['String']>;
  listingType?: InputMaybe<Scalars['String']>;
  logoImageUrl?: InputMaybe<Scalars['String']>;
  longitude?: InputMaybe<Scalars['numeric']>;
  name?: InputMaybe<Scalars['String']>;
  needsReview?: InputMaybe<Scalars['Boolean']>;
  otherSocial?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  playerLevel?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['String']>;
  profileImageUrl?: InputMaybe<Scalars['String']>;
  selkirkAdv?: InputMaybe<Scalars['Boolean']>;
  shortDescription?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  sourceAboutPhotoImageUrl?: InputMaybe<Scalars['String']>;
  sourceCreatedAt?: InputMaybe<Scalars['timestamptz']>;
  sourceId?: InputMaybe<Scalars['String']>;
  sourceIsActive?: InputMaybe<Scalars['Boolean']>;
  sourceLocale?: InputMaybe<Scalars['String']>;
  sourceLogoImageUrl?: InputMaybe<Scalars['String']>;
  sourceProfileImageUrl?: InputMaybe<Scalars['String']>;
  sourceProfileSlug?: InputMaybe<Scalars['String']>;
  sourceSlug?: InputMaybe<Scalars['String']>;
  sourceSubscribedToEmails?: InputMaybe<Scalars['Boolean']>;
  sourceUsername?: InputMaybe<Scalars['String']>;
  stateName?: InputMaybe<Scalars['String']>;
  teacherCertArr?: InputMaybe<Scalars['jsonb']>;
  teacherCertImages?: InputMaybe<Scalars['String']>;
  teacherCertLinks?: InputMaybe<Scalars['jsonb']>;
  teacherCertifications?: InputMaybe<Scalars['String']>;
  twitter?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  usapRating?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  verified?: InputMaybe<Scalars['Boolean']>;
  website?: InputMaybe<Scalars['String']>;
  youtube?: InputMaybe<Scalars['String']>;
  zipcode?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type CoachStarterProfilesMaxFields = {
  __typename?: 'CoachStarterProfilesMaxFields';
  aboutMe?: Maybe<Scalars['String']>;
  aboutPhotoImageUrl?: Maybe<Scalars['String']>;
  accountClaimedAt?: Maybe<Scalars['timestamptz']>;
  addressDisplay?: Maybe<Scalars['String']>;
  addressString?: Maybe<Scalars['String']>;
  addressType?: Maybe<Scalars['String']>;
  age?: Maybe<Scalars['String']>;
  birthdate?: Maybe<Scalars['String']>;
  cityId?: Maybe<Scalars['uuid']>;
  cityName?: Maybe<Scalars['String']>;
  claimUserId?: Maybe<Scalars['uuid']>;
  company?: Maybe<Scalars['String']>;
  countryName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  duprProfile?: Maybe<Scalars['String']>;
  duprRating?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  facebook?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  instagram?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['numeric']>;
  level?: Maybe<Scalars['String']>;
  linkedin?: Maybe<Scalars['String']>;
  listingType?: Maybe<Scalars['String']>;
  logoImageUrl?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['numeric']>;
  name?: Maybe<Scalars['String']>;
  otherSocial?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  playerLevel?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['String']>;
  profileImageUrl?: Maybe<Scalars['String']>;
  shortDescription?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  sourceAboutPhotoImageUrl?: Maybe<Scalars['String']>;
  sourceCreatedAt?: Maybe<Scalars['timestamptz']>;
  sourceId?: Maybe<Scalars['String']>;
  sourceLocale?: Maybe<Scalars['String']>;
  sourceLogoImageUrl?: Maybe<Scalars['String']>;
  sourceProfileImageUrl?: Maybe<Scalars['String']>;
  sourceProfileSlug?: Maybe<Scalars['String']>;
  sourceSlug?: Maybe<Scalars['String']>;
  sourceUsername?: Maybe<Scalars['String']>;
  stateName?: Maybe<Scalars['String']>;
  teacherCertImages?: Maybe<Scalars['String']>;
  teacherCertifications?: Maybe<Scalars['String']>;
  twitter?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  usapRating?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
  youtube?: Maybe<Scalars['String']>;
  zipcode?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "coach_starter_profiles" */
export type CoachStarterProfilesMaxOrderBy = {
  aboutMe?: InputMaybe<OrderBy>;
  aboutPhotoImageUrl?: InputMaybe<OrderBy>;
  accountClaimedAt?: InputMaybe<OrderBy>;
  addressDisplay?: InputMaybe<OrderBy>;
  addressString?: InputMaybe<OrderBy>;
  addressType?: InputMaybe<OrderBy>;
  age?: InputMaybe<OrderBy>;
  birthdate?: InputMaybe<OrderBy>;
  cityId?: InputMaybe<OrderBy>;
  cityName?: InputMaybe<OrderBy>;
  claimUserId?: InputMaybe<OrderBy>;
  company?: InputMaybe<OrderBy>;
  countryName?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  duprProfile?: InputMaybe<OrderBy>;
  duprRating?: InputMaybe<OrderBy>;
  email?: InputMaybe<OrderBy>;
  facebook?: InputMaybe<OrderBy>;
  gender?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  instagram?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  level?: InputMaybe<OrderBy>;
  linkedin?: InputMaybe<OrderBy>;
  listingType?: InputMaybe<OrderBy>;
  logoImageUrl?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  otherSocial?: InputMaybe<OrderBy>;
  phoneNumber?: InputMaybe<OrderBy>;
  playerLevel?: InputMaybe<OrderBy>;
  position?: InputMaybe<OrderBy>;
  profileImageUrl?: InputMaybe<OrderBy>;
  shortDescription?: InputMaybe<OrderBy>;
  source?: InputMaybe<OrderBy>;
  sourceAboutPhotoImageUrl?: InputMaybe<OrderBy>;
  sourceCreatedAt?: InputMaybe<OrderBy>;
  sourceId?: InputMaybe<OrderBy>;
  sourceLocale?: InputMaybe<OrderBy>;
  sourceLogoImageUrl?: InputMaybe<OrderBy>;
  sourceProfileImageUrl?: InputMaybe<OrderBy>;
  sourceProfileSlug?: InputMaybe<OrderBy>;
  sourceSlug?: InputMaybe<OrderBy>;
  sourceUsername?: InputMaybe<OrderBy>;
  stateName?: InputMaybe<OrderBy>;
  teacherCertImages?: InputMaybe<OrderBy>;
  teacherCertifications?: InputMaybe<OrderBy>;
  twitter?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  usapRating?: InputMaybe<OrderBy>;
  website?: InputMaybe<OrderBy>;
  youtube?: InputMaybe<OrderBy>;
  zipcode?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type CoachStarterProfilesMinFields = {
  __typename?: 'CoachStarterProfilesMinFields';
  aboutMe?: Maybe<Scalars['String']>;
  aboutPhotoImageUrl?: Maybe<Scalars['String']>;
  accountClaimedAt?: Maybe<Scalars['timestamptz']>;
  addressDisplay?: Maybe<Scalars['String']>;
  addressString?: Maybe<Scalars['String']>;
  addressType?: Maybe<Scalars['String']>;
  age?: Maybe<Scalars['String']>;
  birthdate?: Maybe<Scalars['String']>;
  cityId?: Maybe<Scalars['uuid']>;
  cityName?: Maybe<Scalars['String']>;
  claimUserId?: Maybe<Scalars['uuid']>;
  company?: Maybe<Scalars['String']>;
  countryName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  duprProfile?: Maybe<Scalars['String']>;
  duprRating?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  facebook?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  instagram?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['numeric']>;
  level?: Maybe<Scalars['String']>;
  linkedin?: Maybe<Scalars['String']>;
  listingType?: Maybe<Scalars['String']>;
  logoImageUrl?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['numeric']>;
  name?: Maybe<Scalars['String']>;
  otherSocial?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  playerLevel?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['String']>;
  profileImageUrl?: Maybe<Scalars['String']>;
  shortDescription?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  sourceAboutPhotoImageUrl?: Maybe<Scalars['String']>;
  sourceCreatedAt?: Maybe<Scalars['timestamptz']>;
  sourceId?: Maybe<Scalars['String']>;
  sourceLocale?: Maybe<Scalars['String']>;
  sourceLogoImageUrl?: Maybe<Scalars['String']>;
  sourceProfileImageUrl?: Maybe<Scalars['String']>;
  sourceProfileSlug?: Maybe<Scalars['String']>;
  sourceSlug?: Maybe<Scalars['String']>;
  sourceUsername?: Maybe<Scalars['String']>;
  stateName?: Maybe<Scalars['String']>;
  teacherCertImages?: Maybe<Scalars['String']>;
  teacherCertifications?: Maybe<Scalars['String']>;
  twitter?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  usapRating?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
  youtube?: Maybe<Scalars['String']>;
  zipcode?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "coach_starter_profiles" */
export type CoachStarterProfilesMinOrderBy = {
  aboutMe?: InputMaybe<OrderBy>;
  aboutPhotoImageUrl?: InputMaybe<OrderBy>;
  accountClaimedAt?: InputMaybe<OrderBy>;
  addressDisplay?: InputMaybe<OrderBy>;
  addressString?: InputMaybe<OrderBy>;
  addressType?: InputMaybe<OrderBy>;
  age?: InputMaybe<OrderBy>;
  birthdate?: InputMaybe<OrderBy>;
  cityId?: InputMaybe<OrderBy>;
  cityName?: InputMaybe<OrderBy>;
  claimUserId?: InputMaybe<OrderBy>;
  company?: InputMaybe<OrderBy>;
  countryName?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  duprProfile?: InputMaybe<OrderBy>;
  duprRating?: InputMaybe<OrderBy>;
  email?: InputMaybe<OrderBy>;
  facebook?: InputMaybe<OrderBy>;
  gender?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  instagram?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  level?: InputMaybe<OrderBy>;
  linkedin?: InputMaybe<OrderBy>;
  listingType?: InputMaybe<OrderBy>;
  logoImageUrl?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  otherSocial?: InputMaybe<OrderBy>;
  phoneNumber?: InputMaybe<OrderBy>;
  playerLevel?: InputMaybe<OrderBy>;
  position?: InputMaybe<OrderBy>;
  profileImageUrl?: InputMaybe<OrderBy>;
  shortDescription?: InputMaybe<OrderBy>;
  source?: InputMaybe<OrderBy>;
  sourceAboutPhotoImageUrl?: InputMaybe<OrderBy>;
  sourceCreatedAt?: InputMaybe<OrderBy>;
  sourceId?: InputMaybe<OrderBy>;
  sourceLocale?: InputMaybe<OrderBy>;
  sourceLogoImageUrl?: InputMaybe<OrderBy>;
  sourceProfileImageUrl?: InputMaybe<OrderBy>;
  sourceProfileSlug?: InputMaybe<OrderBy>;
  sourceSlug?: InputMaybe<OrderBy>;
  sourceUsername?: InputMaybe<OrderBy>;
  stateName?: InputMaybe<OrderBy>;
  teacherCertImages?: InputMaybe<OrderBy>;
  teacherCertifications?: InputMaybe<OrderBy>;
  twitter?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  usapRating?: InputMaybe<OrderBy>;
  website?: InputMaybe<OrderBy>;
  youtube?: InputMaybe<OrderBy>;
  zipcode?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "coach_starter_profiles" */
export type CoachStarterProfilesMutationResponse = {
  __typename?: 'CoachStarterProfilesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CoachStarterProfiles>;
};

/** on_conflict condition type for table "coach_starter_profiles" */
export type CoachStarterProfilesOnConflict = {
  constraint: CoachStarterProfilesConstraint;
  updateColumns?: Array<CoachStarterProfilesUpdateColumn>;
  where?: InputMaybe<CoachStarterProfilesBoolExp>;
};

/** Ordering options when selecting data from "coach_starter_profiles". */
export type CoachStarterProfilesOrderBy = {
  aboutMe?: InputMaybe<OrderBy>;
  aboutPhotoImageUrl?: InputMaybe<OrderBy>;
  accountClaimedAt?: InputMaybe<OrderBy>;
  addressDisplay?: InputMaybe<OrderBy>;
  addressString?: InputMaybe<OrderBy>;
  addressType?: InputMaybe<OrderBy>;
  age?: InputMaybe<OrderBy>;
  birthdate?: InputMaybe<OrderBy>;
  city?: InputMaybe<CitiesOrderBy>;
  cityId?: InputMaybe<OrderBy>;
  cityName?: InputMaybe<OrderBy>;
  claimUserId?: InputMaybe<OrderBy>;
  company?: InputMaybe<OrderBy>;
  countryName?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  duprProfile?: InputMaybe<OrderBy>;
  duprRating?: InputMaybe<OrderBy>;
  email?: InputMaybe<OrderBy>;
  facebook?: InputMaybe<OrderBy>;
  gender?: InputMaybe<OrderBy>;
  geometry?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  instagram?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  level?: InputMaybe<OrderBy>;
  linkedin?: InputMaybe<OrderBy>;
  listingType?: InputMaybe<OrderBy>;
  logoImageUrl?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  needsReview?: InputMaybe<OrderBy>;
  otherSocial?: InputMaybe<OrderBy>;
  phoneNumber?: InputMaybe<OrderBy>;
  playerLevel?: InputMaybe<OrderBy>;
  position?: InputMaybe<OrderBy>;
  profileImageUrl?: InputMaybe<OrderBy>;
  selkirkAdv?: InputMaybe<OrderBy>;
  shortDescription?: InputMaybe<OrderBy>;
  source?: InputMaybe<OrderBy>;
  sourceAboutPhotoImageUrl?: InputMaybe<OrderBy>;
  sourceCreatedAt?: InputMaybe<OrderBy>;
  sourceId?: InputMaybe<OrderBy>;
  sourceIsActive?: InputMaybe<OrderBy>;
  sourceLocale?: InputMaybe<OrderBy>;
  sourceLogoImageUrl?: InputMaybe<OrderBy>;
  sourceProfileImageUrl?: InputMaybe<OrderBy>;
  sourceProfileSlug?: InputMaybe<OrderBy>;
  sourceSlug?: InputMaybe<OrderBy>;
  sourceSubscribedToEmails?: InputMaybe<OrderBy>;
  sourceUsername?: InputMaybe<OrderBy>;
  stateName?: InputMaybe<OrderBy>;
  teacherCertArr?: InputMaybe<OrderBy>;
  teacherCertImages?: InputMaybe<OrderBy>;
  teacherCertLinks?: InputMaybe<OrderBy>;
  teacherCertifications?: InputMaybe<OrderBy>;
  twitter?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  usapRating?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  verified?: InputMaybe<OrderBy>;
  website?: InputMaybe<OrderBy>;
  youtube?: InputMaybe<OrderBy>;
  zipcode?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: coach_starter_profiles */
export type CoachStarterProfilesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type CoachStarterProfilesPrependInput = {
  teacherCertArr?: InputMaybe<Scalars['jsonb']>;
  teacherCertLinks?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "coach_starter_profiles" */
export enum CoachStarterProfilesSelectColumn {
  /** column name */
  AboutMe = 'aboutMe',
  /** column name */
  AboutPhotoImageUrl = 'aboutPhotoImageUrl',
  /** column name */
  AccountClaimedAt = 'accountClaimedAt',
  /** column name */
  AddressDisplay = 'addressDisplay',
  /** column name */
  AddressString = 'addressString',
  /** column name */
  AddressType = 'addressType',
  /** column name */
  Age = 'age',
  /** column name */
  Birthdate = 'birthdate',
  /** column name */
  CityId = 'cityId',
  /** column name */
  CityName = 'cityName',
  /** column name */
  ClaimUserId = 'claimUserId',
  /** column name */
  Company = 'company',
  /** column name */
  CountryName = 'countryName',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  DuprProfile = 'duprProfile',
  /** column name */
  DuprRating = 'duprRating',
  /** column name */
  Email = 'email',
  /** column name */
  Facebook = 'facebook',
  /** column name */
  Gender = 'gender',
  /** column name */
  Geometry = 'geometry',
  /** column name */
  Id = 'id',
  /** column name */
  Instagram = 'instagram',
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Level = 'level',
  /** column name */
  Linkedin = 'linkedin',
  /** column name */
  ListingType = 'listingType',
  /** column name */
  LogoImageUrl = 'logoImageUrl',
  /** column name */
  Longitude = 'longitude',
  /** column name */
  Name = 'name',
  /** column name */
  NeedsReview = 'needsReview',
  /** column name */
  OtherSocial = 'otherSocial',
  /** column name */
  PhoneNumber = 'phoneNumber',
  /** column name */
  PlayerLevel = 'playerLevel',
  /** column name */
  Position = 'position',
  /** column name */
  ProfileImageUrl = 'profileImageUrl',
  /** column name */
  SelkirkAdv = 'selkirkAdv',
  /** column name */
  ShortDescription = 'shortDescription',
  /** column name */
  Source = 'source',
  /** column name */
  SourceAboutPhotoImageUrl = 'sourceAboutPhotoImageUrl',
  /** column name */
  SourceCreatedAt = 'sourceCreatedAt',
  /** column name */
  SourceId = 'sourceId',
  /** column name */
  SourceIsActive = 'sourceIsActive',
  /** column name */
  SourceLocale = 'sourceLocale',
  /** column name */
  SourceLogoImageUrl = 'sourceLogoImageUrl',
  /** column name */
  SourceProfileImageUrl = 'sourceProfileImageUrl',
  /** column name */
  SourceProfileSlug = 'sourceProfileSlug',
  /** column name */
  SourceSlug = 'sourceSlug',
  /** column name */
  SourceSubscribedToEmails = 'sourceSubscribedToEmails',
  /** column name */
  SourceUsername = 'sourceUsername',
  /** column name */
  StateName = 'stateName',
  /** column name */
  TeacherCertArr = 'teacherCertArr',
  /** column name */
  TeacherCertImages = 'teacherCertImages',
  /** column name */
  TeacherCertLinks = 'teacherCertLinks',
  /** column name */
  TeacherCertifications = 'teacherCertifications',
  /** column name */
  Twitter = 'twitter',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UsapRating = 'usapRating',
  /** column name */
  Verified = 'verified',
  /** column name */
  Website = 'website',
  /** column name */
  Youtube = 'youtube',
  /** column name */
  Zipcode = 'zipcode'
}

/** select "coachStarterProfilesAggregateBoolExpBool_andArgumentsColumns" columns of table "coach_starter_profiles" */
export enum CoachStarterProfilesSelectColumnCoachStarterProfilesAggregateBoolExpBool_AndArgumentsColumns {
  /** column name */
  NeedsReview = 'needsReview',
  /** column name */
  SelkirkAdv = 'selkirkAdv',
  /** column name */
  SourceIsActive = 'sourceIsActive',
  /** column name */
  SourceSubscribedToEmails = 'sourceSubscribedToEmails',
  /** column name */
  Verified = 'verified'
}

/** select "coachStarterProfilesAggregateBoolExpBool_orArgumentsColumns" columns of table "coach_starter_profiles" */
export enum CoachStarterProfilesSelectColumnCoachStarterProfilesAggregateBoolExpBool_OrArgumentsColumns {
  /** column name */
  NeedsReview = 'needsReview',
  /** column name */
  SelkirkAdv = 'selkirkAdv',
  /** column name */
  SourceIsActive = 'sourceIsActive',
  /** column name */
  SourceSubscribedToEmails = 'sourceSubscribedToEmails',
  /** column name */
  Verified = 'verified'
}

/** input type for updating data in table "coach_starter_profiles" */
export type CoachStarterProfilesSetInput = {
  aboutMe?: InputMaybe<Scalars['String']>;
  aboutPhotoImageUrl?: InputMaybe<Scalars['String']>;
  accountClaimedAt?: InputMaybe<Scalars['timestamptz']>;
  addressDisplay?: InputMaybe<Scalars['String']>;
  addressString?: InputMaybe<Scalars['String']>;
  addressType?: InputMaybe<Scalars['String']>;
  age?: InputMaybe<Scalars['String']>;
  birthdate?: InputMaybe<Scalars['String']>;
  cityId?: InputMaybe<Scalars['uuid']>;
  cityName?: InputMaybe<Scalars['String']>;
  claimUserId?: InputMaybe<Scalars['uuid']>;
  company?: InputMaybe<Scalars['String']>;
  countryName?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  duprProfile?: InputMaybe<Scalars['String']>;
  duprRating?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  facebook?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  geometry?: InputMaybe<Scalars['geography']>;
  id?: InputMaybe<Scalars['uuid']>;
  instagram?: InputMaybe<Scalars['String']>;
  latitude?: InputMaybe<Scalars['numeric']>;
  level?: InputMaybe<Scalars['String']>;
  linkedin?: InputMaybe<Scalars['String']>;
  listingType?: InputMaybe<Scalars['String']>;
  logoImageUrl?: InputMaybe<Scalars['String']>;
  longitude?: InputMaybe<Scalars['numeric']>;
  name?: InputMaybe<Scalars['String']>;
  needsReview?: InputMaybe<Scalars['Boolean']>;
  otherSocial?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  playerLevel?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['String']>;
  profileImageUrl?: InputMaybe<Scalars['String']>;
  selkirkAdv?: InputMaybe<Scalars['Boolean']>;
  shortDescription?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  sourceAboutPhotoImageUrl?: InputMaybe<Scalars['String']>;
  sourceCreatedAt?: InputMaybe<Scalars['timestamptz']>;
  sourceId?: InputMaybe<Scalars['String']>;
  sourceIsActive?: InputMaybe<Scalars['Boolean']>;
  sourceLocale?: InputMaybe<Scalars['String']>;
  sourceLogoImageUrl?: InputMaybe<Scalars['String']>;
  sourceProfileImageUrl?: InputMaybe<Scalars['String']>;
  sourceProfileSlug?: InputMaybe<Scalars['String']>;
  sourceSlug?: InputMaybe<Scalars['String']>;
  sourceSubscribedToEmails?: InputMaybe<Scalars['Boolean']>;
  sourceUsername?: InputMaybe<Scalars['String']>;
  stateName?: InputMaybe<Scalars['String']>;
  teacherCertArr?: InputMaybe<Scalars['jsonb']>;
  teacherCertImages?: InputMaybe<Scalars['String']>;
  teacherCertLinks?: InputMaybe<Scalars['jsonb']>;
  teacherCertifications?: InputMaybe<Scalars['String']>;
  twitter?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  usapRating?: InputMaybe<Scalars['String']>;
  verified?: InputMaybe<Scalars['Boolean']>;
  website?: InputMaybe<Scalars['String']>;
  youtube?: InputMaybe<Scalars['String']>;
  zipcode?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type CoachStarterProfilesStddevFields = {
  __typename?: 'CoachStarterProfilesStddevFields';
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "coach_starter_profiles" */
export type CoachStarterProfilesStddevOrderBy = {
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type CoachStarterProfilesStddevPopFields = {
  __typename?: 'CoachStarterProfilesStddevPopFields';
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "coach_starter_profiles" */
export type CoachStarterProfilesStddevPopOrderBy = {
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type CoachStarterProfilesStddevSampFields = {
  __typename?: 'CoachStarterProfilesStddevSampFields';
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "coach_starter_profiles" */
export type CoachStarterProfilesStddevSampOrderBy = {
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "coach_starter_profiles" */
export type CoachStarterProfilesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CoachStarterProfilesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CoachStarterProfilesStreamCursorValueInput = {
  aboutMe?: InputMaybe<Scalars['String']>;
  aboutPhotoImageUrl?: InputMaybe<Scalars['String']>;
  accountClaimedAt?: InputMaybe<Scalars['timestamptz']>;
  addressDisplay?: InputMaybe<Scalars['String']>;
  addressString?: InputMaybe<Scalars['String']>;
  addressType?: InputMaybe<Scalars['String']>;
  age?: InputMaybe<Scalars['String']>;
  birthdate?: InputMaybe<Scalars['String']>;
  cityId?: InputMaybe<Scalars['uuid']>;
  cityName?: InputMaybe<Scalars['String']>;
  claimUserId?: InputMaybe<Scalars['uuid']>;
  company?: InputMaybe<Scalars['String']>;
  countryName?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  duprProfile?: InputMaybe<Scalars['String']>;
  duprRating?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  facebook?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  geometry?: InputMaybe<Scalars['geography']>;
  id?: InputMaybe<Scalars['uuid']>;
  instagram?: InputMaybe<Scalars['String']>;
  latitude?: InputMaybe<Scalars['numeric']>;
  level?: InputMaybe<Scalars['String']>;
  linkedin?: InputMaybe<Scalars['String']>;
  listingType?: InputMaybe<Scalars['String']>;
  logoImageUrl?: InputMaybe<Scalars['String']>;
  longitude?: InputMaybe<Scalars['numeric']>;
  name?: InputMaybe<Scalars['String']>;
  needsReview?: InputMaybe<Scalars['Boolean']>;
  otherSocial?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  playerLevel?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['String']>;
  profileImageUrl?: InputMaybe<Scalars['String']>;
  selkirkAdv?: InputMaybe<Scalars['Boolean']>;
  shortDescription?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  sourceAboutPhotoImageUrl?: InputMaybe<Scalars['String']>;
  sourceCreatedAt?: InputMaybe<Scalars['timestamptz']>;
  sourceId?: InputMaybe<Scalars['String']>;
  sourceIsActive?: InputMaybe<Scalars['Boolean']>;
  sourceLocale?: InputMaybe<Scalars['String']>;
  sourceLogoImageUrl?: InputMaybe<Scalars['String']>;
  sourceProfileImageUrl?: InputMaybe<Scalars['String']>;
  sourceProfileSlug?: InputMaybe<Scalars['String']>;
  sourceSlug?: InputMaybe<Scalars['String']>;
  sourceSubscribedToEmails?: InputMaybe<Scalars['Boolean']>;
  sourceUsername?: InputMaybe<Scalars['String']>;
  stateName?: InputMaybe<Scalars['String']>;
  teacherCertArr?: InputMaybe<Scalars['jsonb']>;
  teacherCertImages?: InputMaybe<Scalars['String']>;
  teacherCertLinks?: InputMaybe<Scalars['jsonb']>;
  teacherCertifications?: InputMaybe<Scalars['String']>;
  twitter?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  usapRating?: InputMaybe<Scalars['String']>;
  verified?: InputMaybe<Scalars['Boolean']>;
  website?: InputMaybe<Scalars['String']>;
  youtube?: InputMaybe<Scalars['String']>;
  zipcode?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type CoachStarterProfilesSumFields = {
  __typename?: 'CoachStarterProfilesSumFields';
  latitude?: Maybe<Scalars['numeric']>;
  longitude?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "coach_starter_profiles" */
export type CoachStarterProfilesSumOrderBy = {
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
};

/** update columns of table "coach_starter_profiles" */
export enum CoachStarterProfilesUpdateColumn {
  /** column name */
  AboutMe = 'aboutMe',
  /** column name */
  AboutPhotoImageUrl = 'aboutPhotoImageUrl',
  /** column name */
  AccountClaimedAt = 'accountClaimedAt',
  /** column name */
  AddressDisplay = 'addressDisplay',
  /** column name */
  AddressString = 'addressString',
  /** column name */
  AddressType = 'addressType',
  /** column name */
  Age = 'age',
  /** column name */
  Birthdate = 'birthdate',
  /** column name */
  CityId = 'cityId',
  /** column name */
  CityName = 'cityName',
  /** column name */
  ClaimUserId = 'claimUserId',
  /** column name */
  Company = 'company',
  /** column name */
  CountryName = 'countryName',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  DuprProfile = 'duprProfile',
  /** column name */
  DuprRating = 'duprRating',
  /** column name */
  Email = 'email',
  /** column name */
  Facebook = 'facebook',
  /** column name */
  Gender = 'gender',
  /** column name */
  Geometry = 'geometry',
  /** column name */
  Id = 'id',
  /** column name */
  Instagram = 'instagram',
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Level = 'level',
  /** column name */
  Linkedin = 'linkedin',
  /** column name */
  ListingType = 'listingType',
  /** column name */
  LogoImageUrl = 'logoImageUrl',
  /** column name */
  Longitude = 'longitude',
  /** column name */
  Name = 'name',
  /** column name */
  NeedsReview = 'needsReview',
  /** column name */
  OtherSocial = 'otherSocial',
  /** column name */
  PhoneNumber = 'phoneNumber',
  /** column name */
  PlayerLevel = 'playerLevel',
  /** column name */
  Position = 'position',
  /** column name */
  ProfileImageUrl = 'profileImageUrl',
  /** column name */
  SelkirkAdv = 'selkirkAdv',
  /** column name */
  ShortDescription = 'shortDescription',
  /** column name */
  Source = 'source',
  /** column name */
  SourceAboutPhotoImageUrl = 'sourceAboutPhotoImageUrl',
  /** column name */
  SourceCreatedAt = 'sourceCreatedAt',
  /** column name */
  SourceId = 'sourceId',
  /** column name */
  SourceIsActive = 'sourceIsActive',
  /** column name */
  SourceLocale = 'sourceLocale',
  /** column name */
  SourceLogoImageUrl = 'sourceLogoImageUrl',
  /** column name */
  SourceProfileImageUrl = 'sourceProfileImageUrl',
  /** column name */
  SourceProfileSlug = 'sourceProfileSlug',
  /** column name */
  SourceSlug = 'sourceSlug',
  /** column name */
  SourceSubscribedToEmails = 'sourceSubscribedToEmails',
  /** column name */
  SourceUsername = 'sourceUsername',
  /** column name */
  StateName = 'stateName',
  /** column name */
  TeacherCertArr = 'teacherCertArr',
  /** column name */
  TeacherCertImages = 'teacherCertImages',
  /** column name */
  TeacherCertLinks = 'teacherCertLinks',
  /** column name */
  TeacherCertifications = 'teacherCertifications',
  /** column name */
  Twitter = 'twitter',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UsapRating = 'usapRating',
  /** column name */
  Verified = 'verified',
  /** column name */
  Website = 'website',
  /** column name */
  Youtube = 'youtube',
  /** column name */
  Zipcode = 'zipcode'
}

export type CoachStarterProfilesUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<CoachStarterProfilesAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _deleteAtPath?: InputMaybe<CoachStarterProfilesDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _deleteElem?: InputMaybe<CoachStarterProfilesDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _deleteKey?: InputMaybe<CoachStarterProfilesDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<CoachStarterProfilesIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<CoachStarterProfilesPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CoachStarterProfilesSetInput>;
  /** filter the rows which have to be updated */
  where: CoachStarterProfilesBoolExp;
};

/** aggregate varPop on columns */
export type CoachStarterProfilesVarPopFields = {
  __typename?: 'CoachStarterProfilesVarPopFields';
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "coach_starter_profiles" */
export type CoachStarterProfilesVarPopOrderBy = {
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type CoachStarterProfilesVarSampFields = {
  __typename?: 'CoachStarterProfilesVarSampFields';
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "coach_starter_profiles" */
export type CoachStarterProfilesVarSampOrderBy = {
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type CoachStarterProfilesVarianceFields = {
  __typename?: 'CoachStarterProfilesVarianceFields';
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "coach_starter_profiles" */
export type CoachStarterProfilesVarianceOrderBy = {
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
};

/** columns and relationships of "coach_status" */
export type CoachStatus = {
  __typename?: 'CoachStatus';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "coach_status" */
export type CoachStatusAggregate = {
  __typename?: 'CoachStatusAggregate';
  aggregate?: Maybe<CoachStatusAggregateFields>;
  nodes: Array<CoachStatus>;
};

/** aggregate fields of "coach_status" */
export type CoachStatusAggregateFields = {
  __typename?: 'CoachStatusAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<CoachStatusMaxFields>;
  min?: Maybe<CoachStatusMinFields>;
};


/** aggregate fields of "coach_status" */
export type CoachStatusAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CoachStatusSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "coach_status". All fields are combined with a logical 'AND'. */
export type CoachStatusBoolExp = {
  _and?: InputMaybe<Array<CoachStatusBoolExp>>;
  _not?: InputMaybe<CoachStatusBoolExp>;
  _or?: InputMaybe<Array<CoachStatusBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "coach_status" */
export enum CoachStatusConstraint {
  /** unique or primary key constraint on columns "value" */
  CoachStatusPkey = 'coach_status_pkey'
}

export enum CoachStatusEnum {
  Active = 'ACTIVE',
  Blocked = 'BLOCKED',
  Inactive = 'INACTIVE',
  None = 'NONE'
}

/** Boolean expression to compare columns of type "CoachStatusEnum". All fields are combined with logical 'AND'. */
export type CoachStatusEnumComparisonExp = {
  _eq?: InputMaybe<CoachStatusEnum>;
  _in?: InputMaybe<Array<CoachStatusEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<CoachStatusEnum>;
  _nin?: InputMaybe<Array<CoachStatusEnum>>;
};

/** input type for inserting data into table "coach_status" */
export type CoachStatusInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type CoachStatusMaxFields = {
  __typename?: 'CoachStatusMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type CoachStatusMinFields = {
  __typename?: 'CoachStatusMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "coach_status" */
export type CoachStatusMutationResponse = {
  __typename?: 'CoachStatusMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CoachStatus>;
};

/** on_conflict condition type for table "coach_status" */
export type CoachStatusOnConflict = {
  constraint: CoachStatusConstraint;
  updateColumns?: Array<CoachStatusUpdateColumn>;
  where?: InputMaybe<CoachStatusBoolExp>;
};

/** Ordering options when selecting data from "coach_status". */
export type CoachStatusOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: coach_status */
export type CoachStatusPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "coach_status" */
export enum CoachStatusSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "coach_status" */
export type CoachStatusSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "coach_status" */
export type CoachStatusStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CoachStatusStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CoachStatusStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "coach_status" */
export enum CoachStatusUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type CoachStatusUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CoachStatusSetInput>;
  /** filter the rows which have to be updated */
  where: CoachStatusBoolExp;
};

/** columns and relationships of "coach_tips" */
export type CoachTips = {
  __typename?: 'CoachTips';
  coachUserId: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  creditCard?: Maybe<UserCreditCards>;
  customerUserId: Scalars['uuid'];
  deletedAt?: Maybe<Scalars['timestamp']>;
  externalStripePaymentIntentId: Scalars['String'];
  id: Scalars['uuid'];
  internalStripePaymentIntentId: Scalars['uuid'];
  lessonId?: Maybe<Scalars['uuid']>;
  paidUnitAmount: Scalars['Int'];
  /** An object relationship */
  paymentIntentExternal?: Maybe<StripePaymentIntents>;
  /** An object relationship */
  paymentIntentInternal?: Maybe<StripePaymentIntents>;
  paymentProcessor: PaymentProcessorsEnum;
  status: OrderStatusesEnum;
  stripeCustomerId: Scalars['String'];
  stripeMerchantId: Scalars['String'];
  totalUnitAmount: Scalars['Int'];
  updatedAt: Scalars['timestamptz'];
  userCreditCardId?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "coach_tips" */
export type CoachTipsAggregate = {
  __typename?: 'CoachTipsAggregate';
  aggregate?: Maybe<CoachTipsAggregateFields>;
  nodes: Array<CoachTips>;
};

/** aggregate fields of "coach_tips" */
export type CoachTipsAggregateFields = {
  __typename?: 'CoachTipsAggregateFields';
  avg?: Maybe<CoachTipsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CoachTipsMaxFields>;
  min?: Maybe<CoachTipsMinFields>;
  stddev?: Maybe<CoachTipsStddevFields>;
  stddevPop?: Maybe<CoachTipsStddevPopFields>;
  stddevSamp?: Maybe<CoachTipsStddevSampFields>;
  sum?: Maybe<CoachTipsSumFields>;
  varPop?: Maybe<CoachTipsVarPopFields>;
  varSamp?: Maybe<CoachTipsVarSampFields>;
  variance?: Maybe<CoachTipsVarianceFields>;
};


/** aggregate fields of "coach_tips" */
export type CoachTipsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CoachTipsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type CoachTipsAvgFields = {
  __typename?: 'CoachTipsAvgFields';
  paidUnitAmount?: Maybe<Scalars['Float']>;
  totalUnitAmount?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "coach_tips". All fields are combined with a logical 'AND'. */
export type CoachTipsBoolExp = {
  _and?: InputMaybe<Array<CoachTipsBoolExp>>;
  _not?: InputMaybe<CoachTipsBoolExp>;
  _or?: InputMaybe<Array<CoachTipsBoolExp>>;
  coachUserId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  creditCard?: InputMaybe<UserCreditCardsBoolExp>;
  customerUserId?: InputMaybe<UuidComparisonExp>;
  deletedAt?: InputMaybe<TimestampComparisonExp>;
  externalStripePaymentIntentId?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  internalStripePaymentIntentId?: InputMaybe<UuidComparisonExp>;
  lessonId?: InputMaybe<UuidComparisonExp>;
  paidUnitAmount?: InputMaybe<IntComparisonExp>;
  paymentIntentExternal?: InputMaybe<StripePaymentIntentsBoolExp>;
  paymentIntentInternal?: InputMaybe<StripePaymentIntentsBoolExp>;
  paymentProcessor?: InputMaybe<PaymentProcessorsEnumComparisonExp>;
  status?: InputMaybe<OrderStatusesEnumComparisonExp>;
  stripeCustomerId?: InputMaybe<StringComparisonExp>;
  stripeMerchantId?: InputMaybe<StringComparisonExp>;
  totalUnitAmount?: InputMaybe<IntComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  userCreditCardId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "coach_tips" */
export enum CoachTipsConstraint {
  /** unique or primary key constraint on columns "external_stripe_payment_intent_id" */
  CoachTipsExternalStripePaymentIntentIdKey = 'coach_tips_external_stripe_payment_intent_id_key',
  /** unique or primary key constraint on columns "internal_stripe_payment_intent_id" */
  CoachTipsInternalStripePaymentIntentIdKey = 'coach_tips_internal_stripe_payment_intent_id_key',
  /** unique or primary key constraint on columns "id" */
  CoachTipsPkey = 'coach_tips_pkey'
}

/** input type for incrementing numeric columns in table "coach_tips" */
export type CoachTipsIncInput = {
  paidUnitAmount?: InputMaybe<Scalars['Int']>;
  totalUnitAmount?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "coach_tips" */
export type CoachTipsInsertInput = {
  coachUserId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  creditCard?: InputMaybe<UserCreditCardsObjRelInsertInput>;
  customerUserId?: InputMaybe<Scalars['uuid']>;
  deletedAt?: InputMaybe<Scalars['timestamp']>;
  externalStripePaymentIntentId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  internalStripePaymentIntentId?: InputMaybe<Scalars['uuid']>;
  lessonId?: InputMaybe<Scalars['uuid']>;
  paidUnitAmount?: InputMaybe<Scalars['Int']>;
  paymentIntentExternal?: InputMaybe<StripePaymentIntentsObjRelInsertInput>;
  paymentIntentInternal?: InputMaybe<StripePaymentIntentsObjRelInsertInput>;
  paymentProcessor?: InputMaybe<PaymentProcessorsEnum>;
  status?: InputMaybe<OrderStatusesEnum>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  stripeMerchantId?: InputMaybe<Scalars['String']>;
  totalUnitAmount?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userCreditCardId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type CoachTipsMaxFields = {
  __typename?: 'CoachTipsMaxFields';
  coachUserId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  customerUserId?: Maybe<Scalars['uuid']>;
  deletedAt?: Maybe<Scalars['timestamp']>;
  externalStripePaymentIntentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  internalStripePaymentIntentId?: Maybe<Scalars['uuid']>;
  lessonId?: Maybe<Scalars['uuid']>;
  paidUnitAmount?: Maybe<Scalars['Int']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripeMerchantId?: Maybe<Scalars['String']>;
  totalUnitAmount?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userCreditCardId?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type CoachTipsMinFields = {
  __typename?: 'CoachTipsMinFields';
  coachUserId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  customerUserId?: Maybe<Scalars['uuid']>;
  deletedAt?: Maybe<Scalars['timestamp']>;
  externalStripePaymentIntentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  internalStripePaymentIntentId?: Maybe<Scalars['uuid']>;
  lessonId?: Maybe<Scalars['uuid']>;
  paidUnitAmount?: Maybe<Scalars['Int']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripeMerchantId?: Maybe<Scalars['String']>;
  totalUnitAmount?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userCreditCardId?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "coach_tips" */
export type CoachTipsMutationResponse = {
  __typename?: 'CoachTipsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CoachTips>;
};

/** on_conflict condition type for table "coach_tips" */
export type CoachTipsOnConflict = {
  constraint: CoachTipsConstraint;
  updateColumns?: Array<CoachTipsUpdateColumn>;
  where?: InputMaybe<CoachTipsBoolExp>;
};

/** Ordering options when selecting data from "coach_tips". */
export type CoachTipsOrderBy = {
  coachUserId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  creditCard?: InputMaybe<UserCreditCardsOrderBy>;
  customerUserId?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  externalStripePaymentIntentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  internalStripePaymentIntentId?: InputMaybe<OrderBy>;
  lessonId?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  paymentIntentExternal?: InputMaybe<StripePaymentIntentsOrderBy>;
  paymentIntentInternal?: InputMaybe<StripePaymentIntentsOrderBy>;
  paymentProcessor?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  stripeCustomerId?: InputMaybe<OrderBy>;
  stripeMerchantId?: InputMaybe<OrderBy>;
  totalUnitAmount?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userCreditCardId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: coach_tips */
export type CoachTipsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "coach_tips" */
export enum CoachTipsSelectColumn {
  /** column name */
  CoachUserId = 'coachUserId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CustomerUserId = 'customerUserId',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  ExternalStripePaymentIntentId = 'externalStripePaymentIntentId',
  /** column name */
  Id = 'id',
  /** column name */
  InternalStripePaymentIntentId = 'internalStripePaymentIntentId',
  /** column name */
  LessonId = 'lessonId',
  /** column name */
  PaidUnitAmount = 'paidUnitAmount',
  /** column name */
  PaymentProcessor = 'paymentProcessor',
  /** column name */
  Status = 'status',
  /** column name */
  StripeCustomerId = 'stripeCustomerId',
  /** column name */
  StripeMerchantId = 'stripeMerchantId',
  /** column name */
  TotalUnitAmount = 'totalUnitAmount',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserCreditCardId = 'userCreditCardId'
}

/** input type for updating data in table "coach_tips" */
export type CoachTipsSetInput = {
  coachUserId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  customerUserId?: InputMaybe<Scalars['uuid']>;
  deletedAt?: InputMaybe<Scalars['timestamp']>;
  externalStripePaymentIntentId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  internalStripePaymentIntentId?: InputMaybe<Scalars['uuid']>;
  lessonId?: InputMaybe<Scalars['uuid']>;
  paidUnitAmount?: InputMaybe<Scalars['Int']>;
  paymentProcessor?: InputMaybe<PaymentProcessorsEnum>;
  status?: InputMaybe<OrderStatusesEnum>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  stripeMerchantId?: InputMaybe<Scalars['String']>;
  totalUnitAmount?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userCreditCardId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type CoachTipsStddevFields = {
  __typename?: 'CoachTipsStddevFields';
  paidUnitAmount?: Maybe<Scalars['Float']>;
  totalUnitAmount?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type CoachTipsStddevPopFields = {
  __typename?: 'CoachTipsStddevPopFields';
  paidUnitAmount?: Maybe<Scalars['Float']>;
  totalUnitAmount?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type CoachTipsStddevSampFields = {
  __typename?: 'CoachTipsStddevSampFields';
  paidUnitAmount?: Maybe<Scalars['Float']>;
  totalUnitAmount?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "coach_tips" */
export type CoachTipsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CoachTipsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CoachTipsStreamCursorValueInput = {
  coachUserId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  customerUserId?: InputMaybe<Scalars['uuid']>;
  deletedAt?: InputMaybe<Scalars['timestamp']>;
  externalStripePaymentIntentId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  internalStripePaymentIntentId?: InputMaybe<Scalars['uuid']>;
  lessonId?: InputMaybe<Scalars['uuid']>;
  paidUnitAmount?: InputMaybe<Scalars['Int']>;
  paymentProcessor?: InputMaybe<PaymentProcessorsEnum>;
  status?: InputMaybe<OrderStatusesEnum>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  stripeMerchantId?: InputMaybe<Scalars['String']>;
  totalUnitAmount?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userCreditCardId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type CoachTipsSumFields = {
  __typename?: 'CoachTipsSumFields';
  paidUnitAmount?: Maybe<Scalars['Int']>;
  totalUnitAmount?: Maybe<Scalars['Int']>;
};

/** update columns of table "coach_tips" */
export enum CoachTipsUpdateColumn {
  /** column name */
  CoachUserId = 'coachUserId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CustomerUserId = 'customerUserId',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  ExternalStripePaymentIntentId = 'externalStripePaymentIntentId',
  /** column name */
  Id = 'id',
  /** column name */
  InternalStripePaymentIntentId = 'internalStripePaymentIntentId',
  /** column name */
  LessonId = 'lessonId',
  /** column name */
  PaidUnitAmount = 'paidUnitAmount',
  /** column name */
  PaymentProcessor = 'paymentProcessor',
  /** column name */
  Status = 'status',
  /** column name */
  StripeCustomerId = 'stripeCustomerId',
  /** column name */
  StripeMerchantId = 'stripeMerchantId',
  /** column name */
  TotalUnitAmount = 'totalUnitAmount',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserCreditCardId = 'userCreditCardId'
}

export type CoachTipsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<CoachTipsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CoachTipsSetInput>;
  /** filter the rows which have to be updated */
  where: CoachTipsBoolExp;
};

/** aggregate varPop on columns */
export type CoachTipsVarPopFields = {
  __typename?: 'CoachTipsVarPopFields';
  paidUnitAmount?: Maybe<Scalars['Float']>;
  totalUnitAmount?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type CoachTipsVarSampFields = {
  __typename?: 'CoachTipsVarSampFields';
  paidUnitAmount?: Maybe<Scalars['Float']>;
  totalUnitAmount?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type CoachTipsVarianceFields = {
  __typename?: 'CoachTipsVarianceFields';
  paidUnitAmount?: Maybe<Scalars['Float']>;
  totalUnitAmount?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "comment_vote" */
export type CommentVote = {
  __typename?: 'CommentVote';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "comment_vote" */
export type CommentVoteAggregate = {
  __typename?: 'CommentVoteAggregate';
  aggregate?: Maybe<CommentVoteAggregateFields>;
  nodes: Array<CommentVote>;
};

/** aggregate fields of "comment_vote" */
export type CommentVoteAggregateFields = {
  __typename?: 'CommentVoteAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<CommentVoteMaxFields>;
  min?: Maybe<CommentVoteMinFields>;
};


/** aggregate fields of "comment_vote" */
export type CommentVoteAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CommentVoteSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "comment_vote". All fields are combined with a logical 'AND'. */
export type CommentVoteBoolExp = {
  _and?: InputMaybe<Array<CommentVoteBoolExp>>;
  _not?: InputMaybe<CommentVoteBoolExp>;
  _or?: InputMaybe<Array<CommentVoteBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "comment_vote" */
export enum CommentVoteConstraint {
  /** unique or primary key constraint on columns "value" */
  CommentVotePkey = 'comment_vote_pkey'
}

export enum CommentVoteEnum {
  Negative = 'NEGATIVE',
  None = 'NONE',
  Positive = 'POSITIVE'
}

/** Boolean expression to compare columns of type "CommentVoteEnum". All fields are combined with logical 'AND'. */
export type CommentVoteEnumComparisonExp = {
  _eq?: InputMaybe<CommentVoteEnum>;
  _in?: InputMaybe<Array<CommentVoteEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<CommentVoteEnum>;
  _nin?: InputMaybe<Array<CommentVoteEnum>>;
};

/** input type for inserting data into table "comment_vote" */
export type CommentVoteInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type CommentVoteMaxFields = {
  __typename?: 'CommentVoteMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type CommentVoteMinFields = {
  __typename?: 'CommentVoteMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "comment_vote" */
export type CommentVoteMutationResponse = {
  __typename?: 'CommentVoteMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CommentVote>;
};

/** on_conflict condition type for table "comment_vote" */
export type CommentVoteOnConflict = {
  constraint: CommentVoteConstraint;
  updateColumns?: Array<CommentVoteUpdateColumn>;
  where?: InputMaybe<CommentVoteBoolExp>;
};

/** Ordering options when selecting data from "comment_vote". */
export type CommentVoteOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: comment_vote */
export type CommentVotePkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "comment_vote" */
export enum CommentVoteSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "comment_vote" */
export type CommentVoteSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "comment_vote" */
export type CommentVoteStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CommentVoteStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CommentVoteStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "comment_vote" */
export enum CommentVoteUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type CommentVoteUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CommentVoteSetInput>;
  /** filter the rows which have to be updated */
  where: CommentVoteBoolExp;
};

/** columns and relationships of "communication_preference_statuses" */
export type CommunicationPreferenceStatuses = {
  __typename?: 'CommunicationPreferenceStatuses';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "communication_preference_statuses" */
export type CommunicationPreferenceStatusesAggregate = {
  __typename?: 'CommunicationPreferenceStatusesAggregate';
  aggregate?: Maybe<CommunicationPreferenceStatusesAggregateFields>;
  nodes: Array<CommunicationPreferenceStatuses>;
};

/** aggregate fields of "communication_preference_statuses" */
export type CommunicationPreferenceStatusesAggregateFields = {
  __typename?: 'CommunicationPreferenceStatusesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<CommunicationPreferenceStatusesMaxFields>;
  min?: Maybe<CommunicationPreferenceStatusesMinFields>;
};


/** aggregate fields of "communication_preference_statuses" */
export type CommunicationPreferenceStatusesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CommunicationPreferenceStatusesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "communication_preference_statuses". All fields are combined with a logical 'AND'. */
export type CommunicationPreferenceStatusesBoolExp = {
  _and?: InputMaybe<Array<CommunicationPreferenceStatusesBoolExp>>;
  _not?: InputMaybe<CommunicationPreferenceStatusesBoolExp>;
  _or?: InputMaybe<Array<CommunicationPreferenceStatusesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "communication_preference_statuses" */
export enum CommunicationPreferenceStatusesConstraint {
  /** unique or primary key constraint on columns "value" */
  CommunicationPreferenceStatusesPkey = 'communication_preference_statuses_pkey'
}

export enum CommunicationPreferenceStatusesEnum {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

/** Boolean expression to compare columns of type "CommunicationPreferenceStatusesEnum". All fields are combined with logical 'AND'. */
export type CommunicationPreferenceStatusesEnumComparisonExp = {
  _eq?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  _in?: InputMaybe<Array<CommunicationPreferenceStatusesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  _nin?: InputMaybe<Array<CommunicationPreferenceStatusesEnum>>;
};

/** input type for inserting data into table "communication_preference_statuses" */
export type CommunicationPreferenceStatusesInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type CommunicationPreferenceStatusesMaxFields = {
  __typename?: 'CommunicationPreferenceStatusesMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type CommunicationPreferenceStatusesMinFields = {
  __typename?: 'CommunicationPreferenceStatusesMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "communication_preference_statuses" */
export type CommunicationPreferenceStatusesMutationResponse = {
  __typename?: 'CommunicationPreferenceStatusesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CommunicationPreferenceStatuses>;
};

/** on_conflict condition type for table "communication_preference_statuses" */
export type CommunicationPreferenceStatusesOnConflict = {
  constraint: CommunicationPreferenceStatusesConstraint;
  updateColumns?: Array<CommunicationPreferenceStatusesUpdateColumn>;
  where?: InputMaybe<CommunicationPreferenceStatusesBoolExp>;
};

/** Ordering options when selecting data from "communication_preference_statuses". */
export type CommunicationPreferenceStatusesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: communication_preference_statuses */
export type CommunicationPreferenceStatusesPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "communication_preference_statuses" */
export enum CommunicationPreferenceStatusesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "communication_preference_statuses" */
export type CommunicationPreferenceStatusesSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "communication_preference_statuses" */
export type CommunicationPreferenceStatusesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CommunicationPreferenceStatusesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CommunicationPreferenceStatusesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "communication_preference_statuses" */
export enum CommunicationPreferenceStatusesUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type CommunicationPreferenceStatusesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CommunicationPreferenceStatusesSetInput>;
  /** filter the rows which have to be updated */
  where: CommunicationPreferenceStatusesBoolExp;
};

/** columns and relationships of "competition_formats" */
export type CompetitionFormats = {
  __typename?: 'CompetitionFormats';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "competition_formats" */
export type CompetitionFormatsAggregate = {
  __typename?: 'CompetitionFormatsAggregate';
  aggregate?: Maybe<CompetitionFormatsAggregateFields>;
  nodes: Array<CompetitionFormats>;
};

/** aggregate fields of "competition_formats" */
export type CompetitionFormatsAggregateFields = {
  __typename?: 'CompetitionFormatsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<CompetitionFormatsMaxFields>;
  min?: Maybe<CompetitionFormatsMinFields>;
};


/** aggregate fields of "competition_formats" */
export type CompetitionFormatsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CompetitionFormatsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "competition_formats". All fields are combined with a logical 'AND'. */
export type CompetitionFormatsBoolExp = {
  _and?: InputMaybe<Array<CompetitionFormatsBoolExp>>;
  _not?: InputMaybe<CompetitionFormatsBoolExp>;
  _or?: InputMaybe<Array<CompetitionFormatsBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "competition_formats" */
export enum CompetitionFormatsConstraint {
  /** unique or primary key constraint on columns "value" */
  CompetitionFormatsPkey = 'competition_formats_pkey'
}

export enum CompetitionFormatsEnum {
  Custom = 'CUSTOM',
  DoubleElimination = 'DOUBLE_ELIMINATION',
  RoundRobin = 'ROUND_ROBIN',
  SingleElimination = 'SINGLE_ELIMINATION'
}

/** Boolean expression to compare columns of type "CompetitionFormatsEnum". All fields are combined with logical 'AND'. */
export type CompetitionFormatsEnumComparisonExp = {
  _eq?: InputMaybe<CompetitionFormatsEnum>;
  _in?: InputMaybe<Array<CompetitionFormatsEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<CompetitionFormatsEnum>;
  _nin?: InputMaybe<Array<CompetitionFormatsEnum>>;
};

/** input type for inserting data into table "competition_formats" */
export type CompetitionFormatsInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type CompetitionFormatsMaxFields = {
  __typename?: 'CompetitionFormatsMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type CompetitionFormatsMinFields = {
  __typename?: 'CompetitionFormatsMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "competition_formats" */
export type CompetitionFormatsMutationResponse = {
  __typename?: 'CompetitionFormatsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CompetitionFormats>;
};

/** on_conflict condition type for table "competition_formats" */
export type CompetitionFormatsOnConflict = {
  constraint: CompetitionFormatsConstraint;
  updateColumns?: Array<CompetitionFormatsUpdateColumn>;
  where?: InputMaybe<CompetitionFormatsBoolExp>;
};

/** Ordering options when selecting data from "competition_formats". */
export type CompetitionFormatsOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: competition_formats */
export type CompetitionFormatsPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "competition_formats" */
export enum CompetitionFormatsSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "competition_formats" */
export type CompetitionFormatsSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "competition_formats" */
export type CompetitionFormatsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CompetitionFormatsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CompetitionFormatsStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "competition_formats" */
export enum CompetitionFormatsUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type CompetitionFormatsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CompetitionFormatsSetInput>;
  /** filter the rows which have to be updated */
  where: CompetitionFormatsBoolExp;
};

/** columns and relationships of "competition_gender" */
export type CompetitionGender = {
  __typename?: 'CompetitionGender';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "competition_gender" */
export type CompetitionGenderAggregate = {
  __typename?: 'CompetitionGenderAggregate';
  aggregate?: Maybe<CompetitionGenderAggregateFields>;
  nodes: Array<CompetitionGender>;
};

/** aggregate fields of "competition_gender" */
export type CompetitionGenderAggregateFields = {
  __typename?: 'CompetitionGenderAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<CompetitionGenderMaxFields>;
  min?: Maybe<CompetitionGenderMinFields>;
};


/** aggregate fields of "competition_gender" */
export type CompetitionGenderAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CompetitionGenderSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "competition_gender". All fields are combined with a logical 'AND'. */
export type CompetitionGenderBoolExp = {
  _and?: InputMaybe<Array<CompetitionGenderBoolExp>>;
  _not?: InputMaybe<CompetitionGenderBoolExp>;
  _or?: InputMaybe<Array<CompetitionGenderBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "competition_gender" */
export enum CompetitionGenderConstraint {
  /** unique or primary key constraint on columns "value" */
  CompetitionGenderPkey = 'competition_gender_pkey'
}

export enum CompetitionGenderEnum {
  Coed = 'COED',
  Female = 'FEMALE',
  Male = 'MALE',
  Mixed = 'MIXED'
}

/** Boolean expression to compare columns of type "CompetitionGenderEnum". All fields are combined with logical 'AND'. */
export type CompetitionGenderEnumComparisonExp = {
  _eq?: InputMaybe<CompetitionGenderEnum>;
  _in?: InputMaybe<Array<CompetitionGenderEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<CompetitionGenderEnum>;
  _nin?: InputMaybe<Array<CompetitionGenderEnum>>;
};

/** input type for inserting data into table "competition_gender" */
export type CompetitionGenderInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type CompetitionGenderMaxFields = {
  __typename?: 'CompetitionGenderMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type CompetitionGenderMinFields = {
  __typename?: 'CompetitionGenderMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "competition_gender" */
export type CompetitionGenderMutationResponse = {
  __typename?: 'CompetitionGenderMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CompetitionGender>;
};

/** on_conflict condition type for table "competition_gender" */
export type CompetitionGenderOnConflict = {
  constraint: CompetitionGenderConstraint;
  updateColumns?: Array<CompetitionGenderUpdateColumn>;
  where?: InputMaybe<CompetitionGenderBoolExp>;
};

/** Ordering options when selecting data from "competition_gender". */
export type CompetitionGenderOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: competition_gender */
export type CompetitionGenderPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "competition_gender" */
export enum CompetitionGenderSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "competition_gender" */
export type CompetitionGenderSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "competition_gender" */
export type CompetitionGenderStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CompetitionGenderStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CompetitionGenderStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "competition_gender" */
export enum CompetitionGenderUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type CompetitionGenderUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CompetitionGenderSetInput>;
  /** filter the rows which have to be updated */
  where: CompetitionGenderBoolExp;
};

/** columns and relationships of "content_reports" */
export type ContentReports = {
  __typename?: 'ContentReports';
  /** An object relationship */
  conversation?: Maybe<Conversations>;
  conversationId?: Maybe<Scalars['uuid']>;
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  /** An object relationship */
  message?: Maybe<Messages>;
  messageId?: Maybe<Scalars['uuid']>;
  reason: ReportReasonsEnum;
  /** An object relationship */
  reportedUser?: Maybe<Users>;
  reportedUserId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  reporter: Users;
  reporterUserId: Scalars['uuid'];
  resolvedAt?: Maybe<Scalars['timestamptz']>;
  status: ReportStatusesEnum;
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "content_reports" */
export type ContentReportsAggregate = {
  __typename?: 'ContentReportsAggregate';
  aggregate?: Maybe<ContentReportsAggregateFields>;
  nodes: Array<ContentReports>;
};

/** aggregate fields of "content_reports" */
export type ContentReportsAggregateFields = {
  __typename?: 'ContentReportsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<ContentReportsMaxFields>;
  min?: Maybe<ContentReportsMinFields>;
};


/** aggregate fields of "content_reports" */
export type ContentReportsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ContentReportsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "content_reports". All fields are combined with a logical 'AND'. */
export type ContentReportsBoolExp = {
  _and?: InputMaybe<Array<ContentReportsBoolExp>>;
  _not?: InputMaybe<ContentReportsBoolExp>;
  _or?: InputMaybe<Array<ContentReportsBoolExp>>;
  conversation?: InputMaybe<ConversationsBoolExp>;
  conversationId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  message?: InputMaybe<MessagesBoolExp>;
  messageId?: InputMaybe<UuidComparisonExp>;
  reason?: InputMaybe<ReportReasonsEnumComparisonExp>;
  reportedUser?: InputMaybe<UsersBoolExp>;
  reportedUserId?: InputMaybe<UuidComparisonExp>;
  reporter?: InputMaybe<UsersBoolExp>;
  reporterUserId?: InputMaybe<UuidComparisonExp>;
  resolvedAt?: InputMaybe<TimestamptzComparisonExp>;
  status?: InputMaybe<ReportStatusesEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "content_reports" */
export enum ContentReportsConstraint {
  /** unique or primary key constraint on columns "id" */
  ContentReportsPkey = 'content_reports_pkey'
}

/** input type for inserting data into table "content_reports" */
export type ContentReportsInsertInput = {
  conversation?: InputMaybe<ConversationsObjRelInsertInput>;
  conversationId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  message?: InputMaybe<MessagesObjRelInsertInput>;
  messageId?: InputMaybe<Scalars['uuid']>;
  reason?: InputMaybe<ReportReasonsEnum>;
  reportedUser?: InputMaybe<UsersObjRelInsertInput>;
  reportedUserId?: InputMaybe<Scalars['uuid']>;
  reporter?: InputMaybe<UsersObjRelInsertInput>;
  reporterUserId?: InputMaybe<Scalars['uuid']>;
  resolvedAt?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<ReportStatusesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type ContentReportsMaxFields = {
  __typename?: 'ContentReportsMaxFields';
  conversationId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  messageId?: Maybe<Scalars['uuid']>;
  reportedUserId?: Maybe<Scalars['uuid']>;
  reporterUserId?: Maybe<Scalars['uuid']>;
  resolvedAt?: Maybe<Scalars['timestamptz']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type ContentReportsMinFields = {
  __typename?: 'ContentReportsMinFields';
  conversationId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  messageId?: Maybe<Scalars['uuid']>;
  reportedUserId?: Maybe<Scalars['uuid']>;
  reporterUserId?: Maybe<Scalars['uuid']>;
  resolvedAt?: Maybe<Scalars['timestamptz']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "content_reports" */
export type ContentReportsMutationResponse = {
  __typename?: 'ContentReportsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ContentReports>;
};

/** on_conflict condition type for table "content_reports" */
export type ContentReportsOnConflict = {
  constraint: ContentReportsConstraint;
  updateColumns?: Array<ContentReportsUpdateColumn>;
  where?: InputMaybe<ContentReportsBoolExp>;
};

/** Ordering options when selecting data from "content_reports". */
export type ContentReportsOrderBy = {
  conversation?: InputMaybe<ConversationsOrderBy>;
  conversationId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  message?: InputMaybe<MessagesOrderBy>;
  messageId?: InputMaybe<OrderBy>;
  reason?: InputMaybe<OrderBy>;
  reportedUser?: InputMaybe<UsersOrderBy>;
  reportedUserId?: InputMaybe<OrderBy>;
  reporter?: InputMaybe<UsersOrderBy>;
  reporterUserId?: InputMaybe<OrderBy>;
  resolvedAt?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: content_reports */
export type ContentReportsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "content_reports" */
export enum ContentReportsSelectColumn {
  /** column name */
  ConversationId = 'conversationId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  MessageId = 'messageId',
  /** column name */
  Reason = 'reason',
  /** column name */
  ReportedUserId = 'reportedUserId',
  /** column name */
  ReporterUserId = 'reporterUserId',
  /** column name */
  ResolvedAt = 'resolvedAt',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "content_reports" */
export type ContentReportsSetInput = {
  conversationId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  messageId?: InputMaybe<Scalars['uuid']>;
  reason?: InputMaybe<ReportReasonsEnum>;
  reportedUserId?: InputMaybe<Scalars['uuid']>;
  reporterUserId?: InputMaybe<Scalars['uuid']>;
  resolvedAt?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<ReportStatusesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "content_reports" */
export type ContentReportsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ContentReportsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ContentReportsStreamCursorValueInput = {
  conversationId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  messageId?: InputMaybe<Scalars['uuid']>;
  reason?: InputMaybe<ReportReasonsEnum>;
  reportedUserId?: InputMaybe<Scalars['uuid']>;
  reporterUserId?: InputMaybe<Scalars['uuid']>;
  resolvedAt?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<ReportStatusesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "content_reports" */
export enum ContentReportsUpdateColumn {
  /** column name */
  ConversationId = 'conversationId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  MessageId = 'messageId',
  /** column name */
  Reason = 'reason',
  /** column name */
  ReportedUserId = 'reportedUserId',
  /** column name */
  ReporterUserId = 'reporterUserId',
  /** column name */
  ResolvedAt = 'resolvedAt',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type ContentReportsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ContentReportsSetInput>;
  /** filter the rows which have to be updated */
  where: ContentReportsBoolExp;
};

/** columns and relationships of "conversation_participants" */
export type ConversationParticipants = {
  __typename?: 'ConversationParticipants';
  archivedAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  conversation: Conversations;
  conversationId: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  lastReadAt?: Maybe<Scalars['timestamptz']>;
  role: ParticipantRolesEnum;
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid'];
  /** An object relationship */
  userProfile?: Maybe<UserProfiles>;
};

/** aggregated selection of "conversation_participants" */
export type ConversationParticipantsAggregate = {
  __typename?: 'ConversationParticipantsAggregate';
  aggregate?: Maybe<ConversationParticipantsAggregateFields>;
  nodes: Array<ConversationParticipants>;
};

export type ConversationParticipantsAggregateBoolExp = {
  count?: InputMaybe<ConversationParticipantsAggregateBoolExpCount>;
};

/** aggregate fields of "conversation_participants" */
export type ConversationParticipantsAggregateFields = {
  __typename?: 'ConversationParticipantsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<ConversationParticipantsMaxFields>;
  min?: Maybe<ConversationParticipantsMinFields>;
};


/** aggregate fields of "conversation_participants" */
export type ConversationParticipantsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ConversationParticipantsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "conversation_participants" */
export type ConversationParticipantsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ConversationParticipantsMaxOrderBy>;
  min?: InputMaybe<ConversationParticipantsMinOrderBy>;
};

/** input type for inserting array relation for remote table "conversation_participants" */
export type ConversationParticipantsArrRelInsertInput = {
  data: Array<ConversationParticipantsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<ConversationParticipantsOnConflict>;
};

/** Boolean expression to filter rows from the table "conversation_participants". All fields are combined with a logical 'AND'. */
export type ConversationParticipantsBoolExp = {
  _and?: InputMaybe<Array<ConversationParticipantsBoolExp>>;
  _not?: InputMaybe<ConversationParticipantsBoolExp>;
  _or?: InputMaybe<Array<ConversationParticipantsBoolExp>>;
  archivedAt?: InputMaybe<TimestamptzComparisonExp>;
  conversation?: InputMaybe<ConversationsBoolExp>;
  conversationId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  lastReadAt?: InputMaybe<TimestamptzComparisonExp>;
  role?: InputMaybe<ParticipantRolesEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
  userProfile?: InputMaybe<UserProfilesBoolExp>;
};

/** unique or primary key constraints on table "conversation_participants" */
export enum ConversationParticipantsConstraint {
  /** unique or primary key constraint on columns "conversation_id", "user_id" */
  ConversationParticipantsConversationIdUserIdKey = 'conversation_participants_conversation_id_user_id_key',
  /** unique or primary key constraint on columns "id" */
  ConversationParticipantsPkey = 'conversation_participants_pkey'
}

/** input type for inserting data into table "conversation_participants" */
export type ConversationParticipantsInsertInput = {
  archivedAt?: InputMaybe<Scalars['timestamptz']>;
  conversation?: InputMaybe<ConversationsObjRelInsertInput>;
  conversationId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  lastReadAt?: InputMaybe<Scalars['timestamptz']>;
  role?: InputMaybe<ParticipantRolesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']>;
  userProfile?: InputMaybe<UserProfilesObjRelInsertInput>;
};

/** aggregate max on columns */
export type ConversationParticipantsMaxFields = {
  __typename?: 'ConversationParticipantsMaxFields';
  archivedAt?: Maybe<Scalars['timestamptz']>;
  conversationId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  lastReadAt?: Maybe<Scalars['timestamptz']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "conversation_participants" */
export type ConversationParticipantsMaxOrderBy = {
  archivedAt?: InputMaybe<OrderBy>;
  conversationId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lastReadAt?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type ConversationParticipantsMinFields = {
  __typename?: 'ConversationParticipantsMinFields';
  archivedAt?: Maybe<Scalars['timestamptz']>;
  conversationId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  lastReadAt?: Maybe<Scalars['timestamptz']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "conversation_participants" */
export type ConversationParticipantsMinOrderBy = {
  archivedAt?: InputMaybe<OrderBy>;
  conversationId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lastReadAt?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "conversation_participants" */
export type ConversationParticipantsMutationResponse = {
  __typename?: 'ConversationParticipantsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ConversationParticipants>;
};

/** on_conflict condition type for table "conversation_participants" */
export type ConversationParticipantsOnConflict = {
  constraint: ConversationParticipantsConstraint;
  updateColumns?: Array<ConversationParticipantsUpdateColumn>;
  where?: InputMaybe<ConversationParticipantsBoolExp>;
};

/** Ordering options when selecting data from "conversation_participants". */
export type ConversationParticipantsOrderBy = {
  archivedAt?: InputMaybe<OrderBy>;
  conversation?: InputMaybe<ConversationsOrderBy>;
  conversationId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lastReadAt?: InputMaybe<OrderBy>;
  role?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
  userProfile?: InputMaybe<UserProfilesOrderBy>;
};

/** primary key columns input for table: conversation_participants */
export type ConversationParticipantsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "conversation_participants" */
export enum ConversationParticipantsSelectColumn {
  /** column name */
  ArchivedAt = 'archivedAt',
  /** column name */
  ConversationId = 'conversationId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  LastReadAt = 'lastReadAt',
  /** column name */
  Role = 'role',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "conversation_participants" */
export type ConversationParticipantsSetInput = {
  archivedAt?: InputMaybe<Scalars['timestamptz']>;
  conversationId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  lastReadAt?: InputMaybe<Scalars['timestamptz']>;
  role?: InputMaybe<ParticipantRolesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "conversation_participants" */
export type ConversationParticipantsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ConversationParticipantsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ConversationParticipantsStreamCursorValueInput = {
  archivedAt?: InputMaybe<Scalars['timestamptz']>;
  conversationId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  lastReadAt?: InputMaybe<Scalars['timestamptz']>;
  role?: InputMaybe<ParticipantRolesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "conversation_participants" */
export enum ConversationParticipantsUpdateColumn {
  /** column name */
  ArchivedAt = 'archivedAt',
  /** column name */
  ConversationId = 'conversationId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  LastReadAt = 'lastReadAt',
  /** column name */
  Role = 'role',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

export type ConversationParticipantsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ConversationParticipantsSetInput>;
  /** filter the rows which have to be updated */
  where: ConversationParticipantsBoolExp;
};

/** columns and relationships of "conversation_types" */
export type ConversationTypes = {
  __typename?: 'ConversationTypes';
  comment?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "conversation_types" */
export type ConversationTypesAggregate = {
  __typename?: 'ConversationTypesAggregate';
  aggregate?: Maybe<ConversationTypesAggregateFields>;
  nodes: Array<ConversationTypes>;
};

/** aggregate fields of "conversation_types" */
export type ConversationTypesAggregateFields = {
  __typename?: 'ConversationTypesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<ConversationTypesMaxFields>;
  min?: Maybe<ConversationTypesMinFields>;
};


/** aggregate fields of "conversation_types" */
export type ConversationTypesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ConversationTypesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "conversation_types". All fields are combined with a logical 'AND'. */
export type ConversationTypesBoolExp = {
  _and?: InputMaybe<Array<ConversationTypesBoolExp>>;
  _not?: InputMaybe<ConversationTypesBoolExp>;
  _or?: InputMaybe<Array<ConversationTypesBoolExp>>;
  comment?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "conversation_types" */
export enum ConversationTypesConstraint {
  /** unique or primary key constraint on columns "value" */
  ConversationTypesPkey = 'conversation_types_pkey'
}

export enum ConversationTypesEnum {
  /** 1:1 thread */
  Direct = 'DIRECT',
  /** multi-party thread */
  Group = 'GROUP'
}

/** Boolean expression to compare columns of type "ConversationTypesEnum". All fields are combined with logical 'AND'. */
export type ConversationTypesEnumComparisonExp = {
  _eq?: InputMaybe<ConversationTypesEnum>;
  _in?: InputMaybe<Array<ConversationTypesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<ConversationTypesEnum>;
  _nin?: InputMaybe<Array<ConversationTypesEnum>>;
};

/** input type for inserting data into table "conversation_types" */
export type ConversationTypesInsertInput = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ConversationTypesMaxFields = {
  __typename?: 'ConversationTypesMaxFields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type ConversationTypesMinFields = {
  __typename?: 'ConversationTypesMinFields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "conversation_types" */
export type ConversationTypesMutationResponse = {
  __typename?: 'ConversationTypesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ConversationTypes>;
};

/** on_conflict condition type for table "conversation_types" */
export type ConversationTypesOnConflict = {
  constraint: ConversationTypesConstraint;
  updateColumns?: Array<ConversationTypesUpdateColumn>;
  where?: InputMaybe<ConversationTypesBoolExp>;
};

/** Ordering options when selecting data from "conversation_types". */
export type ConversationTypesOrderBy = {
  comment?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: conversation_types */
export type ConversationTypesPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "conversation_types" */
export enum ConversationTypesSelectColumn {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "conversation_types" */
export type ConversationTypesSetInput = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "conversation_types" */
export type ConversationTypesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ConversationTypesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ConversationTypesStreamCursorValueInput = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "conversation_types" */
export enum ConversationTypesUpdateColumn {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type ConversationTypesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ConversationTypesSetInput>;
  /** filter the rows which have to be updated */
  where: ConversationTypesBoolExp;
};

/** columns and relationships of "conversations" */
export type Conversations = {
  __typename?: 'Conversations';
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  createdBy?: Maybe<Users>;
  createdByUserId?: Maybe<Scalars['uuid']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  directKey?: Maybe<Scalars['String']>;
  /** An object relationship */
  event?: Maybe<Events>;
  eventId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  group?: Maybe<Groups>;
  groupId?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  imagePath?: Maybe<Scalars['String']>;
  lastMessageAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  lesson?: Maybe<Lessons>;
  lessonId?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  messages: Array<Messages>;
  /** An aggregate relationship */
  messagesAggregate: MessagesAggregate;
  /** An array relationship */
  participants: Array<ConversationParticipants>;
  /** An aggregate relationship */
  participantsAggregate: ConversationParticipantsAggregate;
  title?: Maybe<Scalars['String']>;
  type: ConversationTypesEnum;
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  venue?: Maybe<Venues>;
  venueId?: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "conversations" */
export type ConversationsMessagesArgs = {
  distinctOn?: InputMaybe<Array<MessagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MessagesOrderBy>>;
  where?: InputMaybe<MessagesBoolExp>;
};


/** columns and relationships of "conversations" */
export type ConversationsMessagesAggregateArgs = {
  distinctOn?: InputMaybe<Array<MessagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MessagesOrderBy>>;
  where?: InputMaybe<MessagesBoolExp>;
};


/** columns and relationships of "conversations" */
export type ConversationsParticipantsArgs = {
  distinctOn?: InputMaybe<Array<ConversationParticipantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ConversationParticipantsOrderBy>>;
  where?: InputMaybe<ConversationParticipantsBoolExp>;
};


/** columns and relationships of "conversations" */
export type ConversationsParticipantsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ConversationParticipantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ConversationParticipantsOrderBy>>;
  where?: InputMaybe<ConversationParticipantsBoolExp>;
};

/** aggregated selection of "conversations" */
export type ConversationsAggregate = {
  __typename?: 'ConversationsAggregate';
  aggregate?: Maybe<ConversationsAggregateFields>;
  nodes: Array<Conversations>;
};

export type ConversationsAggregateBoolExp = {
  count?: InputMaybe<ConversationsAggregateBoolExpCount>;
};

/** aggregate fields of "conversations" */
export type ConversationsAggregateFields = {
  __typename?: 'ConversationsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<ConversationsMaxFields>;
  min?: Maybe<ConversationsMinFields>;
};


/** aggregate fields of "conversations" */
export type ConversationsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ConversationsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "conversations" */
export type ConversationsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ConversationsMaxOrderBy>;
  min?: InputMaybe<ConversationsMinOrderBy>;
};

/** input type for inserting array relation for remote table "conversations" */
export type ConversationsArrRelInsertInput = {
  data: Array<ConversationsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<ConversationsOnConflict>;
};

/** Boolean expression to filter rows from the table "conversations". All fields are combined with a logical 'AND'. */
export type ConversationsBoolExp = {
  _and?: InputMaybe<Array<ConversationsBoolExp>>;
  _not?: InputMaybe<ConversationsBoolExp>;
  _or?: InputMaybe<Array<ConversationsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  createdBy?: InputMaybe<UsersBoolExp>;
  createdByUserId?: InputMaybe<UuidComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  directKey?: InputMaybe<StringComparisonExp>;
  event?: InputMaybe<EventsBoolExp>;
  eventId?: InputMaybe<UuidComparisonExp>;
  group?: InputMaybe<GroupsBoolExp>;
  groupId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  imagePath?: InputMaybe<StringComparisonExp>;
  lastMessageAt?: InputMaybe<TimestamptzComparisonExp>;
  lesson?: InputMaybe<LessonsBoolExp>;
  lessonId?: InputMaybe<UuidComparisonExp>;
  messages?: InputMaybe<MessagesBoolExp>;
  messagesAggregate?: InputMaybe<MessagesAggregateBoolExp>;
  participants?: InputMaybe<ConversationParticipantsBoolExp>;
  participantsAggregate?: InputMaybe<ConversationParticipantsAggregateBoolExp>;
  title?: InputMaybe<StringComparisonExp>;
  type?: InputMaybe<ConversationTypesEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  venue?: InputMaybe<VenuesBoolExp>;
  venueId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "conversations" */
export enum ConversationsConstraint {
  /** unique or primary key constraint on columns "event_id" */
  ConversationsOneActivePerEvent = 'conversations_one_active_per_event',
  /** unique or primary key constraint on columns "group_id" */
  ConversationsOneActivePerGroup = 'conversations_one_active_per_group',
  /** unique or primary key constraint on columns "lesson_id" */
  ConversationsOneActivePerLesson = 'conversations_one_active_per_lesson',
  /** unique or primary key constraint on columns "venue_id" */
  ConversationsOneActivePerVenue = 'conversations_one_active_per_venue',
  /** unique or primary key constraint on columns "direct_key" */
  ConversationsOneDirectPerPair = 'conversations_one_direct_per_pair',
  /** unique or primary key constraint on columns "id" */
  ConversationsPkey = 'conversations_pkey'
}

/** input type for inserting data into table "conversations" */
export type ConversationsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<UsersObjRelInsertInput>;
  createdByUserId?: InputMaybe<Scalars['uuid']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  directKey?: InputMaybe<Scalars['String']>;
  event?: InputMaybe<EventsObjRelInsertInput>;
  eventId?: InputMaybe<Scalars['uuid']>;
  group?: InputMaybe<GroupsObjRelInsertInput>;
  groupId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  imagePath?: InputMaybe<Scalars['String']>;
  lastMessageAt?: InputMaybe<Scalars['timestamptz']>;
  lesson?: InputMaybe<LessonsObjRelInsertInput>;
  lessonId?: InputMaybe<Scalars['uuid']>;
  messages?: InputMaybe<MessagesArrRelInsertInput>;
  participants?: InputMaybe<ConversationParticipantsArrRelInsertInput>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<ConversationTypesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  venue?: InputMaybe<VenuesObjRelInsertInput>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type ConversationsMaxFields = {
  __typename?: 'ConversationsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdByUserId?: Maybe<Scalars['uuid']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  directKey?: Maybe<Scalars['String']>;
  eventId?: Maybe<Scalars['uuid']>;
  groupId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  imagePath?: Maybe<Scalars['String']>;
  lastMessageAt?: Maybe<Scalars['timestamptz']>;
  lessonId?: Maybe<Scalars['uuid']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  venueId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "conversations" */
export type ConversationsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  createdByUserId?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  directKey?: InputMaybe<OrderBy>;
  eventId?: InputMaybe<OrderBy>;
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  imagePath?: InputMaybe<OrderBy>;
  lastMessageAt?: InputMaybe<OrderBy>;
  lessonId?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type ConversationsMinFields = {
  __typename?: 'ConversationsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdByUserId?: Maybe<Scalars['uuid']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  directKey?: Maybe<Scalars['String']>;
  eventId?: Maybe<Scalars['uuid']>;
  groupId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  imagePath?: Maybe<Scalars['String']>;
  lastMessageAt?: Maybe<Scalars['timestamptz']>;
  lessonId?: Maybe<Scalars['uuid']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  venueId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "conversations" */
export type ConversationsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  createdByUserId?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  directKey?: InputMaybe<OrderBy>;
  eventId?: InputMaybe<OrderBy>;
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  imagePath?: InputMaybe<OrderBy>;
  lastMessageAt?: InputMaybe<OrderBy>;
  lessonId?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "conversations" */
export type ConversationsMutationResponse = {
  __typename?: 'ConversationsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Conversations>;
};

/** input type for inserting object relation for remote table "conversations" */
export type ConversationsObjRelInsertInput = {
  data: ConversationsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<ConversationsOnConflict>;
};

/** on_conflict condition type for table "conversations" */
export type ConversationsOnConflict = {
  constraint: ConversationsConstraint;
  updateColumns?: Array<ConversationsUpdateColumn>;
  where?: InputMaybe<ConversationsBoolExp>;
};

/** Ordering options when selecting data from "conversations". */
export type ConversationsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  createdBy?: InputMaybe<UsersOrderBy>;
  createdByUserId?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  directKey?: InputMaybe<OrderBy>;
  event?: InputMaybe<EventsOrderBy>;
  eventId?: InputMaybe<OrderBy>;
  group?: InputMaybe<GroupsOrderBy>;
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  imagePath?: InputMaybe<OrderBy>;
  lastMessageAt?: InputMaybe<OrderBy>;
  lesson?: InputMaybe<LessonsOrderBy>;
  lessonId?: InputMaybe<OrderBy>;
  messagesAggregate?: InputMaybe<MessagesAggregateOrderBy>;
  participantsAggregate?: InputMaybe<ConversationParticipantsAggregateOrderBy>;
  title?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  venue?: InputMaybe<VenuesOrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: conversations */
export type ConversationsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "conversations" */
export enum ConversationsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedByUserId = 'createdByUserId',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  DirectKey = 'directKey',
  /** column name */
  EventId = 'eventId',
  /** column name */
  GroupId = 'groupId',
  /** column name */
  Id = 'id',
  /** column name */
  ImagePath = 'imagePath',
  /** column name */
  LastMessageAt = 'lastMessageAt',
  /** column name */
  LessonId = 'lessonId',
  /** column name */
  Title = 'title',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  VenueId = 'venueId'
}

/** input type for updating data in table "conversations" */
export type ConversationsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserId?: InputMaybe<Scalars['uuid']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  directKey?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['uuid']>;
  groupId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  imagePath?: InputMaybe<Scalars['String']>;
  lastMessageAt?: InputMaybe<Scalars['timestamptz']>;
  lessonId?: InputMaybe<Scalars['uuid']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<ConversationTypesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "conversations" */
export type ConversationsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ConversationsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ConversationsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserId?: InputMaybe<Scalars['uuid']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  directKey?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['uuid']>;
  groupId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  imagePath?: InputMaybe<Scalars['String']>;
  lastMessageAt?: InputMaybe<Scalars['timestamptz']>;
  lessonId?: InputMaybe<Scalars['uuid']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<ConversationTypesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "conversations" */
export enum ConversationsUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedByUserId = 'createdByUserId',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  DirectKey = 'directKey',
  /** column name */
  EventId = 'eventId',
  /** column name */
  GroupId = 'groupId',
  /** column name */
  Id = 'id',
  /** column name */
  ImagePath = 'imagePath',
  /** column name */
  LastMessageAt = 'lastMessageAt',
  /** column name */
  LessonId = 'lessonId',
  /** column name */
  Title = 'title',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  VenueId = 'venueId'
}

export type ConversationsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ConversationsSetInput>;
  /** filter the rows which have to be updated */
  where: ConversationsBoolExp;
};

/** Note that this breaks from the standard and uses the country iso3 as a text field for the id */
export type Countries = {
  __typename?: 'Countries';
  createdAt: Scalars['timestamptz'];
  currency: Scalars['String'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  emoji: Scalars['String'];
  geometry?: Maybe<Scalars['geography']>;
  id: Scalars['String'];
  iso2: Scalars['String'];
  iso3: Scalars['String'];
  latitude: Scalars['numeric'];
  longitude: Scalars['numeric'];
  name: Scalars['String'];
  nameSlug: Scalars['String'];
  numericCode: Scalars['String'];
  phoneCode: Scalars['String'];
  slug: Scalars['String'];
  /** An array relationship */
  subdivisions: Array<CountrySubdivisions>;
  /** An aggregate relationship */
  subdivisionsAggregate: CountrySubdivisionsAggregate;
  updatedAt: Scalars['timestamptz'];
};


/** Note that this breaks from the standard and uses the country iso3 as a text field for the id */
export type CountriesSubdivisionsArgs = {
  distinctOn?: InputMaybe<Array<CountrySubdivisionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CountrySubdivisionsOrderBy>>;
  where?: InputMaybe<CountrySubdivisionsBoolExp>;
};


/** Note that this breaks from the standard and uses the country iso3 as a text field for the id */
export type CountriesSubdivisionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<CountrySubdivisionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CountrySubdivisionsOrderBy>>;
  where?: InputMaybe<CountrySubdivisionsBoolExp>;
};

/** aggregated selection of "countries" */
export type CountriesAggregate = {
  __typename?: 'CountriesAggregate';
  aggregate?: Maybe<CountriesAggregateFields>;
  nodes: Array<Countries>;
};

/** aggregate fields of "countries" */
export type CountriesAggregateFields = {
  __typename?: 'CountriesAggregateFields';
  avg?: Maybe<CountriesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CountriesMaxFields>;
  min?: Maybe<CountriesMinFields>;
  stddev?: Maybe<CountriesStddevFields>;
  stddevPop?: Maybe<CountriesStddevPopFields>;
  stddevSamp?: Maybe<CountriesStddevSampFields>;
  sum?: Maybe<CountriesSumFields>;
  varPop?: Maybe<CountriesVarPopFields>;
  varSamp?: Maybe<CountriesVarSampFields>;
  variance?: Maybe<CountriesVarianceFields>;
};


/** aggregate fields of "countries" */
export type CountriesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CountriesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type CountriesAvgFields = {
  __typename?: 'CountriesAvgFields';
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "countries". All fields are combined with a logical 'AND'. */
export type CountriesBoolExp = {
  _and?: InputMaybe<Array<CountriesBoolExp>>;
  _not?: InputMaybe<CountriesBoolExp>;
  _or?: InputMaybe<Array<CountriesBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  currency?: InputMaybe<StringComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  emoji?: InputMaybe<StringComparisonExp>;
  geometry?: InputMaybe<GeographyComparisonExp>;
  id?: InputMaybe<StringComparisonExp>;
  iso2?: InputMaybe<StringComparisonExp>;
  iso3?: InputMaybe<StringComparisonExp>;
  latitude?: InputMaybe<NumericComparisonExp>;
  longitude?: InputMaybe<NumericComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  nameSlug?: InputMaybe<StringComparisonExp>;
  numericCode?: InputMaybe<StringComparisonExp>;
  phoneCode?: InputMaybe<StringComparisonExp>;
  slug?: InputMaybe<StringComparisonExp>;
  subdivisions?: InputMaybe<CountrySubdivisionsBoolExp>;
  subdivisionsAggregate?: InputMaybe<CountrySubdivisionsAggregateBoolExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "countries" */
export enum CountriesConstraint {
  /** unique or primary key constraint on columns "iso2" */
  CountriesIso2Key = 'countries_iso2_key',
  /** unique or primary key constraint on columns "name_slug" */
  CountriesNameSlugKey = 'countries_name_slug_key',
  /** unique or primary key constraint on columns "id" */
  CountriesPkey = 'countries_pkey',
  /** unique or primary key constraint on columns "slug" */
  CountriesSlugKey = 'countries_slug_key'
}

/** input type for incrementing numeric columns in table "countries" */
export type CountriesIncInput = {
  latitude?: InputMaybe<Scalars['numeric']>;
  longitude?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "countries" */
export type CountriesInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  emoji?: InputMaybe<Scalars['String']>;
  geometry?: InputMaybe<Scalars['geography']>;
  id?: InputMaybe<Scalars['String']>;
  iso2?: InputMaybe<Scalars['String']>;
  iso3?: InputMaybe<Scalars['String']>;
  latitude?: InputMaybe<Scalars['numeric']>;
  longitude?: InputMaybe<Scalars['numeric']>;
  name?: InputMaybe<Scalars['String']>;
  nameSlug?: InputMaybe<Scalars['String']>;
  numericCode?: InputMaybe<Scalars['String']>;
  phoneCode?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  subdivisions?: InputMaybe<CountrySubdivisionsArrRelInsertInput>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type CountriesMaxFields = {
  __typename?: 'CountriesMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  emoji?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  iso2?: Maybe<Scalars['String']>;
  iso3?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['numeric']>;
  longitude?: Maybe<Scalars['numeric']>;
  name?: Maybe<Scalars['String']>;
  nameSlug?: Maybe<Scalars['String']>;
  numericCode?: Maybe<Scalars['String']>;
  phoneCode?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type CountriesMinFields = {
  __typename?: 'CountriesMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  emoji?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  iso2?: Maybe<Scalars['String']>;
  iso3?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['numeric']>;
  longitude?: Maybe<Scalars['numeric']>;
  name?: Maybe<Scalars['String']>;
  nameSlug?: Maybe<Scalars['String']>;
  numericCode?: Maybe<Scalars['String']>;
  phoneCode?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "countries" */
export type CountriesMutationResponse = {
  __typename?: 'CountriesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Countries>;
};

/** input type for inserting object relation for remote table "countries" */
export type CountriesObjRelInsertInput = {
  data: CountriesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<CountriesOnConflict>;
};

/** on_conflict condition type for table "countries" */
export type CountriesOnConflict = {
  constraint: CountriesConstraint;
  updateColumns?: Array<CountriesUpdateColumn>;
  where?: InputMaybe<CountriesBoolExp>;
};

/** Ordering options when selecting data from "countries". */
export type CountriesOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  currency?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  emoji?: InputMaybe<OrderBy>;
  geometry?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  iso2?: InputMaybe<OrderBy>;
  iso3?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  nameSlug?: InputMaybe<OrderBy>;
  numericCode?: InputMaybe<OrderBy>;
  phoneCode?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  subdivisionsAggregate?: InputMaybe<CountrySubdivisionsAggregateOrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: countries */
export type CountriesPkColumnsInput = {
  id: Scalars['String'];
};

/** select columns of table "countries" */
export enum CountriesSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Currency = 'currency',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Emoji = 'emoji',
  /** column name */
  Geometry = 'geometry',
  /** column name */
  Id = 'id',
  /** column name */
  Iso2 = 'iso2',
  /** column name */
  Iso3 = 'iso3',
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Longitude = 'longitude',
  /** column name */
  Name = 'name',
  /** column name */
  NameSlug = 'nameSlug',
  /** column name */
  NumericCode = 'numericCode',
  /** column name */
  PhoneCode = 'phoneCode',
  /** column name */
  Slug = 'slug',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "countries" */
export type CountriesSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  emoji?: InputMaybe<Scalars['String']>;
  geometry?: InputMaybe<Scalars['geography']>;
  id?: InputMaybe<Scalars['String']>;
  iso2?: InputMaybe<Scalars['String']>;
  iso3?: InputMaybe<Scalars['String']>;
  latitude?: InputMaybe<Scalars['numeric']>;
  longitude?: InputMaybe<Scalars['numeric']>;
  name?: InputMaybe<Scalars['String']>;
  nameSlug?: InputMaybe<Scalars['String']>;
  numericCode?: InputMaybe<Scalars['String']>;
  phoneCode?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type CountriesStddevFields = {
  __typename?: 'CountriesStddevFields';
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type CountriesStddevPopFields = {
  __typename?: 'CountriesStddevPopFields';
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type CountriesStddevSampFields = {
  __typename?: 'CountriesStddevSampFields';
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "countries" */
export type CountriesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CountriesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CountriesStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  emoji?: InputMaybe<Scalars['String']>;
  geometry?: InputMaybe<Scalars['geography']>;
  id?: InputMaybe<Scalars['String']>;
  iso2?: InputMaybe<Scalars['String']>;
  iso3?: InputMaybe<Scalars['String']>;
  latitude?: InputMaybe<Scalars['numeric']>;
  longitude?: InputMaybe<Scalars['numeric']>;
  name?: InputMaybe<Scalars['String']>;
  nameSlug?: InputMaybe<Scalars['String']>;
  numericCode?: InputMaybe<Scalars['String']>;
  phoneCode?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type CountriesSumFields = {
  __typename?: 'CountriesSumFields';
  latitude?: Maybe<Scalars['numeric']>;
  longitude?: Maybe<Scalars['numeric']>;
};

/** update columns of table "countries" */
export enum CountriesUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Currency = 'currency',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Emoji = 'emoji',
  /** column name */
  Geometry = 'geometry',
  /** column name */
  Id = 'id',
  /** column name */
  Iso2 = 'iso2',
  /** column name */
  Iso3 = 'iso3',
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Longitude = 'longitude',
  /** column name */
  Name = 'name',
  /** column name */
  NameSlug = 'nameSlug',
  /** column name */
  NumericCode = 'numericCode',
  /** column name */
  PhoneCode = 'phoneCode',
  /** column name */
  Slug = 'slug',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type CountriesUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<CountriesIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CountriesSetInput>;
  /** filter the rows which have to be updated */
  where: CountriesBoolExp;
};

/** aggregate varPop on columns */
export type CountriesVarPopFields = {
  __typename?: 'CountriesVarPopFields';
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type CountriesVarSampFields = {
  __typename?: 'CountriesVarSampFields';
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type CountriesVarianceFields = {
  __typename?: 'CountriesVarianceFields';
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "country_subdivisions" */
export type CountrySubdivisions = {
  __typename?: 'CountrySubdivisions';
  /** An array relationship */
  cities: Array<Cities>;
  /** An aggregate relationship */
  citiesAggregate: CitiesAggregate;
  code: Scalars['String'];
  /** An object relationship */
  country: Countries;
  countryId: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  geometry?: Maybe<Scalars['geography']>;
  id: Scalars['uuid'];
  latitude?: Maybe<Scalars['numeric']>;
  longitude?: Maybe<Scalars['numeric']>;
  name: Scalars['String'];
  slug: Scalars['String'];
  type: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "country_subdivisions" */
export type CountrySubdivisionsCitiesArgs = {
  distinctOn?: InputMaybe<Array<CitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CitiesOrderBy>>;
  where?: InputMaybe<CitiesBoolExp>;
};


/** columns and relationships of "country_subdivisions" */
export type CountrySubdivisionsCitiesAggregateArgs = {
  distinctOn?: InputMaybe<Array<CitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CitiesOrderBy>>;
  where?: InputMaybe<CitiesBoolExp>;
};

/** aggregated selection of "country_subdivisions" */
export type CountrySubdivisionsAggregate = {
  __typename?: 'CountrySubdivisionsAggregate';
  aggregate?: Maybe<CountrySubdivisionsAggregateFields>;
  nodes: Array<CountrySubdivisions>;
};

export type CountrySubdivisionsAggregateBoolExp = {
  count?: InputMaybe<CountrySubdivisionsAggregateBoolExpCount>;
};

/** aggregate fields of "country_subdivisions" */
export type CountrySubdivisionsAggregateFields = {
  __typename?: 'CountrySubdivisionsAggregateFields';
  avg?: Maybe<CountrySubdivisionsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CountrySubdivisionsMaxFields>;
  min?: Maybe<CountrySubdivisionsMinFields>;
  stddev?: Maybe<CountrySubdivisionsStddevFields>;
  stddevPop?: Maybe<CountrySubdivisionsStddevPopFields>;
  stddevSamp?: Maybe<CountrySubdivisionsStddevSampFields>;
  sum?: Maybe<CountrySubdivisionsSumFields>;
  varPop?: Maybe<CountrySubdivisionsVarPopFields>;
  varSamp?: Maybe<CountrySubdivisionsVarSampFields>;
  variance?: Maybe<CountrySubdivisionsVarianceFields>;
};


/** aggregate fields of "country_subdivisions" */
export type CountrySubdivisionsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CountrySubdivisionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "country_subdivisions" */
export type CountrySubdivisionsAggregateOrderBy = {
  avg?: InputMaybe<CountrySubdivisionsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<CountrySubdivisionsMaxOrderBy>;
  min?: InputMaybe<CountrySubdivisionsMinOrderBy>;
  stddev?: InputMaybe<CountrySubdivisionsStddevOrderBy>;
  stddevPop?: InputMaybe<CountrySubdivisionsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<CountrySubdivisionsStddevSampOrderBy>;
  sum?: InputMaybe<CountrySubdivisionsSumOrderBy>;
  varPop?: InputMaybe<CountrySubdivisionsVarPopOrderBy>;
  varSamp?: InputMaybe<CountrySubdivisionsVarSampOrderBy>;
  variance?: InputMaybe<CountrySubdivisionsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "country_subdivisions" */
export type CountrySubdivisionsArrRelInsertInput = {
  data: Array<CountrySubdivisionsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<CountrySubdivisionsOnConflict>;
};

/** aggregate avg on columns */
export type CountrySubdivisionsAvgFields = {
  __typename?: 'CountrySubdivisionsAvgFields';
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "country_subdivisions" */
export type CountrySubdivisionsAvgOrderBy = {
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "country_subdivisions". All fields are combined with a logical 'AND'. */
export type CountrySubdivisionsBoolExp = {
  _and?: InputMaybe<Array<CountrySubdivisionsBoolExp>>;
  _not?: InputMaybe<CountrySubdivisionsBoolExp>;
  _or?: InputMaybe<Array<CountrySubdivisionsBoolExp>>;
  cities?: InputMaybe<CitiesBoolExp>;
  citiesAggregate?: InputMaybe<CitiesAggregateBoolExp>;
  code?: InputMaybe<StringComparisonExp>;
  country?: InputMaybe<CountriesBoolExp>;
  countryId?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  geometry?: InputMaybe<GeographyComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  latitude?: InputMaybe<NumericComparisonExp>;
  longitude?: InputMaybe<NumericComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  slug?: InputMaybe<StringComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "country_subdivisions" */
export enum CountrySubdivisionsConstraint {
  /** unique or primary key constraint on columns "id" */
  CountrySubdivisionsPkey = 'country_subdivisions_pkey',
  /** unique or primary key constraint on columns "slug" */
  CountrySubdivisionsSlugKey = 'country_subdivisions_slug_key'
}

/** input type for incrementing numeric columns in table "country_subdivisions" */
export type CountrySubdivisionsIncInput = {
  latitude?: InputMaybe<Scalars['numeric']>;
  longitude?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "country_subdivisions" */
export type CountrySubdivisionsInsertInput = {
  cities?: InputMaybe<CitiesArrRelInsertInput>;
  code?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<CountriesObjRelInsertInput>;
  countryId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  geometry?: InputMaybe<Scalars['geography']>;
  id?: InputMaybe<Scalars['uuid']>;
  latitude?: InputMaybe<Scalars['numeric']>;
  longitude?: InputMaybe<Scalars['numeric']>;
  name?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type CountrySubdivisionsMaxFields = {
  __typename?: 'CountrySubdivisionsMaxFields';
  code?: Maybe<Scalars['String']>;
  countryId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  latitude?: Maybe<Scalars['numeric']>;
  longitude?: Maybe<Scalars['numeric']>;
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "country_subdivisions" */
export type CountrySubdivisionsMaxOrderBy = {
  code?: InputMaybe<OrderBy>;
  countryId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type CountrySubdivisionsMinFields = {
  __typename?: 'CountrySubdivisionsMinFields';
  code?: Maybe<Scalars['String']>;
  countryId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  latitude?: Maybe<Scalars['numeric']>;
  longitude?: Maybe<Scalars['numeric']>;
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "country_subdivisions" */
export type CountrySubdivisionsMinOrderBy = {
  code?: InputMaybe<OrderBy>;
  countryId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "country_subdivisions" */
export type CountrySubdivisionsMutationResponse = {
  __typename?: 'CountrySubdivisionsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CountrySubdivisions>;
};

/** input type for inserting object relation for remote table "country_subdivisions" */
export type CountrySubdivisionsObjRelInsertInput = {
  data: CountrySubdivisionsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<CountrySubdivisionsOnConflict>;
};

/** on_conflict condition type for table "country_subdivisions" */
export type CountrySubdivisionsOnConflict = {
  constraint: CountrySubdivisionsConstraint;
  updateColumns?: Array<CountrySubdivisionsUpdateColumn>;
  where?: InputMaybe<CountrySubdivisionsBoolExp>;
};

/** Ordering options when selecting data from "country_subdivisions". */
export type CountrySubdivisionsOrderBy = {
  citiesAggregate?: InputMaybe<CitiesAggregateOrderBy>;
  code?: InputMaybe<OrderBy>;
  country?: InputMaybe<CountriesOrderBy>;
  countryId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  geometry?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: country_subdivisions */
export type CountrySubdivisionsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "country_subdivisions" */
export enum CountrySubdivisionsSelectColumn {
  /** column name */
  Code = 'code',
  /** column name */
  CountryId = 'countryId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Geometry = 'geometry',
  /** column name */
  Id = 'id',
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Longitude = 'longitude',
  /** column name */
  Name = 'name',
  /** column name */
  Slug = 'slug',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "country_subdivisions" */
export type CountrySubdivisionsSetInput = {
  code?: InputMaybe<Scalars['String']>;
  countryId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  geometry?: InputMaybe<Scalars['geography']>;
  id?: InputMaybe<Scalars['uuid']>;
  latitude?: InputMaybe<Scalars['numeric']>;
  longitude?: InputMaybe<Scalars['numeric']>;
  name?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type CountrySubdivisionsStddevFields = {
  __typename?: 'CountrySubdivisionsStddevFields';
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "country_subdivisions" */
export type CountrySubdivisionsStddevOrderBy = {
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type CountrySubdivisionsStddevPopFields = {
  __typename?: 'CountrySubdivisionsStddevPopFields';
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "country_subdivisions" */
export type CountrySubdivisionsStddevPopOrderBy = {
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type CountrySubdivisionsStddevSampFields = {
  __typename?: 'CountrySubdivisionsStddevSampFields';
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "country_subdivisions" */
export type CountrySubdivisionsStddevSampOrderBy = {
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "country_subdivisions" */
export type CountrySubdivisionsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CountrySubdivisionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CountrySubdivisionsStreamCursorValueInput = {
  code?: InputMaybe<Scalars['String']>;
  countryId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  geometry?: InputMaybe<Scalars['geography']>;
  id?: InputMaybe<Scalars['uuid']>;
  latitude?: InputMaybe<Scalars['numeric']>;
  longitude?: InputMaybe<Scalars['numeric']>;
  name?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type CountrySubdivisionsSumFields = {
  __typename?: 'CountrySubdivisionsSumFields';
  latitude?: Maybe<Scalars['numeric']>;
  longitude?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "country_subdivisions" */
export type CountrySubdivisionsSumOrderBy = {
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
};

/** update columns of table "country_subdivisions" */
export enum CountrySubdivisionsUpdateColumn {
  /** column name */
  Code = 'code',
  /** column name */
  CountryId = 'countryId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Geometry = 'geometry',
  /** column name */
  Id = 'id',
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Longitude = 'longitude',
  /** column name */
  Name = 'name',
  /** column name */
  Slug = 'slug',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type CountrySubdivisionsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<CountrySubdivisionsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CountrySubdivisionsSetInput>;
  /** filter the rows which have to be updated */
  where: CountrySubdivisionsBoolExp;
};

/** aggregate varPop on columns */
export type CountrySubdivisionsVarPopFields = {
  __typename?: 'CountrySubdivisionsVarPopFields';
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "country_subdivisions" */
export type CountrySubdivisionsVarPopOrderBy = {
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type CountrySubdivisionsVarSampFields = {
  __typename?: 'CountrySubdivisionsVarSampFields';
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "country_subdivisions" */
export type CountrySubdivisionsVarSampOrderBy = {
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type CountrySubdivisionsVarianceFields = {
  __typename?: 'CountrySubdivisionsVarianceFields';
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "country_subdivisions" */
export type CountrySubdivisionsVarianceOrderBy = {
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
};

/** columns and relationships of "court_surfaces" */
export type CourtSurfaces = {
  __typename?: 'CourtSurfaces';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "court_surfaces" */
export type CourtSurfacesAggregate = {
  __typename?: 'CourtSurfacesAggregate';
  aggregate?: Maybe<CourtSurfacesAggregateFields>;
  nodes: Array<CourtSurfaces>;
};

/** aggregate fields of "court_surfaces" */
export type CourtSurfacesAggregateFields = {
  __typename?: 'CourtSurfacesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<CourtSurfacesMaxFields>;
  min?: Maybe<CourtSurfacesMinFields>;
};


/** aggregate fields of "court_surfaces" */
export type CourtSurfacesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CourtSurfacesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "court_surfaces". All fields are combined with a logical 'AND'. */
export type CourtSurfacesBoolExp = {
  _and?: InputMaybe<Array<CourtSurfacesBoolExp>>;
  _not?: InputMaybe<CourtSurfacesBoolExp>;
  _or?: InputMaybe<Array<CourtSurfacesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "court_surfaces" */
export enum CourtSurfacesConstraint {
  /** unique or primary key constraint on columns "value" */
  CourtSurfacesPkey = 'court_surfaces_pkey'
}

export enum CourtSurfacesEnum {
  Acrylic = 'ACRYLIC',
  Asphalt = 'ASPHALT',
  Carpet = 'CARPET',
  Clay = 'CLAY',
  Concrete = 'CONCRETE',
  Grass = 'GRASS',
  Hard = 'HARD',
  Wood = 'WOOD'
}

/** Boolean expression to compare columns of type "CourtSurfacesEnum". All fields are combined with logical 'AND'. */
export type CourtSurfacesEnumComparisonExp = {
  _eq?: InputMaybe<CourtSurfacesEnum>;
  _in?: InputMaybe<Array<CourtSurfacesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<CourtSurfacesEnum>;
  _nin?: InputMaybe<Array<CourtSurfacesEnum>>;
};

/** input type for inserting data into table "court_surfaces" */
export type CourtSurfacesInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type CourtSurfacesMaxFields = {
  __typename?: 'CourtSurfacesMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type CourtSurfacesMinFields = {
  __typename?: 'CourtSurfacesMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "court_surfaces" */
export type CourtSurfacesMutationResponse = {
  __typename?: 'CourtSurfacesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CourtSurfaces>;
};

/** on_conflict condition type for table "court_surfaces" */
export type CourtSurfacesOnConflict = {
  constraint: CourtSurfacesConstraint;
  updateColumns?: Array<CourtSurfacesUpdateColumn>;
  where?: InputMaybe<CourtSurfacesBoolExp>;
};

/** Ordering options when selecting data from "court_surfaces". */
export type CourtSurfacesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: court_surfaces */
export type CourtSurfacesPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "court_surfaces" */
export enum CourtSurfacesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "court_surfaces" */
export type CourtSurfacesSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "court_surfaces" */
export type CourtSurfacesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CourtSurfacesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CourtSurfacesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "court_surfaces" */
export enum CourtSurfacesUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type CourtSurfacesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CourtSurfacesSetInput>;
  /** filter the rows which have to be updated */
  where: CourtSurfacesBoolExp;
};

/** ordering argument of a cursor */
export enum CursorOrdering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type DateComparisonExp = {
  _eq?: InputMaybe<Scalars['date']>;
  _gt?: InputMaybe<Scalars['date']>;
  _gte?: InputMaybe<Scalars['date']>;
  _in?: InputMaybe<Array<Scalars['date']>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['date']>;
  _lte?: InputMaybe<Scalars['date']>;
  _neq?: InputMaybe<Scalars['date']>;
  _nin?: InputMaybe<Array<Scalars['date']>>;
};

/** columns and relationships of "day_of_week" */
export type DayOfWeek = {
  __typename?: 'DayOfWeek';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "day_of_week" */
export type DayOfWeekAggregate = {
  __typename?: 'DayOfWeekAggregate';
  aggregate?: Maybe<DayOfWeekAggregateFields>;
  nodes: Array<DayOfWeek>;
};

/** aggregate fields of "day_of_week" */
export type DayOfWeekAggregateFields = {
  __typename?: 'DayOfWeekAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<DayOfWeekMaxFields>;
  min?: Maybe<DayOfWeekMinFields>;
};


/** aggregate fields of "day_of_week" */
export type DayOfWeekAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<DayOfWeekSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "day_of_week". All fields are combined with a logical 'AND'. */
export type DayOfWeekBoolExp = {
  _and?: InputMaybe<Array<DayOfWeekBoolExp>>;
  _not?: InputMaybe<DayOfWeekBoolExp>;
  _or?: InputMaybe<Array<DayOfWeekBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "day_of_week" */
export enum DayOfWeekConstraint {
  /** unique or primary key constraint on columns "value" */
  DayOfWeekPkey = 'day_of_week_pkey'
}

export enum DayOfWeekEnum {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

/** Boolean expression to compare columns of type "DayOfWeekEnum". All fields are combined with logical 'AND'. */
export type DayOfWeekEnumComparisonExp = {
  _eq?: InputMaybe<DayOfWeekEnum>;
  _in?: InputMaybe<Array<DayOfWeekEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<DayOfWeekEnum>;
  _nin?: InputMaybe<Array<DayOfWeekEnum>>;
};

/** input type for inserting data into table "day_of_week" */
export type DayOfWeekInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type DayOfWeekMaxFields = {
  __typename?: 'DayOfWeekMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type DayOfWeekMinFields = {
  __typename?: 'DayOfWeekMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "day_of_week" */
export type DayOfWeekMutationResponse = {
  __typename?: 'DayOfWeekMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<DayOfWeek>;
};

/** on_conflict condition type for table "day_of_week" */
export type DayOfWeekOnConflict = {
  constraint: DayOfWeekConstraint;
  updateColumns?: Array<DayOfWeekUpdateColumn>;
  where?: InputMaybe<DayOfWeekBoolExp>;
};

/** Ordering options when selecting data from "day_of_week". */
export type DayOfWeekOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: day_of_week */
export type DayOfWeekPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "day_of_week" */
export enum DayOfWeekSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "day_of_week" */
export type DayOfWeekSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "day_of_week" */
export type DayOfWeekStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: DayOfWeekStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DayOfWeekStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "day_of_week" */
export enum DayOfWeekUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type DayOfWeekUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DayOfWeekSetInput>;
  /** filter the rows which have to be updated */
  where: DayOfWeekBoolExp;
};

/** columns and relationships of "engagement_analytics" */
export type EngagementAnalytics = {
  __typename?: 'EngagementAnalytics';
  /** An object relationship */
  actor?: Maybe<Users>;
  actorUserId?: Maybe<Scalars['uuid']>;
  anonSessionId?: Maybe<Scalars['String']>;
  createdAt: Scalars['timestamptz'];
  entityType: EngagementEntityTypesEnum;
  /** An object relationship */
  event?: Maybe<Events>;
  eventId?: Maybe<Scalars['uuid']>;
  eventType: EngagementEventTypesEnum;
  id: Scalars['uuid'];
  /** An object relationship */
  lesson?: Maybe<Lessons>;
  lessonId?: Maybe<Scalars['uuid']>;
  occurredAt: Scalars['timestamptz'];
  /** An object relationship */
  owner?: Maybe<Users>;
  ownerUserId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  placement?: Maybe<Boosts>;
  placementId?: Maybe<Scalars['uuid']>;
  source: EngagementSourcesEnum;
  /** An object relationship */
  venue?: Maybe<Venues>;
  venueId?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "engagement_analytics" */
export type EngagementAnalyticsAggregate = {
  __typename?: 'EngagementAnalyticsAggregate';
  aggregate?: Maybe<EngagementAnalyticsAggregateFields>;
  nodes: Array<EngagementAnalytics>;
};

export type EngagementAnalyticsAggregateBoolExp = {
  count?: InputMaybe<EngagementAnalyticsAggregateBoolExpCount>;
};

/** aggregate fields of "engagement_analytics" */
export type EngagementAnalyticsAggregateFields = {
  __typename?: 'EngagementAnalyticsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<EngagementAnalyticsMaxFields>;
  min?: Maybe<EngagementAnalyticsMinFields>;
};


/** aggregate fields of "engagement_analytics" */
export type EngagementAnalyticsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EngagementAnalyticsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "engagement_analytics" */
export type EngagementAnalyticsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EngagementAnalyticsMaxOrderBy>;
  min?: InputMaybe<EngagementAnalyticsMinOrderBy>;
};

/** input type for inserting array relation for remote table "engagement_analytics" */
export type EngagementAnalyticsArrRelInsertInput = {
  data: Array<EngagementAnalyticsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<EngagementAnalyticsOnConflict>;
};

/** Boolean expression to filter rows from the table "engagement_analytics". All fields are combined with a logical 'AND'. */
export type EngagementAnalyticsBoolExp = {
  _and?: InputMaybe<Array<EngagementAnalyticsBoolExp>>;
  _not?: InputMaybe<EngagementAnalyticsBoolExp>;
  _or?: InputMaybe<Array<EngagementAnalyticsBoolExp>>;
  actor?: InputMaybe<UsersBoolExp>;
  actorUserId?: InputMaybe<UuidComparisonExp>;
  anonSessionId?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  entityType?: InputMaybe<EngagementEntityTypesEnumComparisonExp>;
  event?: InputMaybe<EventsBoolExp>;
  eventId?: InputMaybe<UuidComparisonExp>;
  eventType?: InputMaybe<EngagementEventTypesEnumComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  lesson?: InputMaybe<LessonsBoolExp>;
  lessonId?: InputMaybe<UuidComparisonExp>;
  occurredAt?: InputMaybe<TimestamptzComparisonExp>;
  owner?: InputMaybe<UsersBoolExp>;
  ownerUserId?: InputMaybe<UuidComparisonExp>;
  placement?: InputMaybe<BoostsBoolExp>;
  placementId?: InputMaybe<UuidComparisonExp>;
  source?: InputMaybe<EngagementSourcesEnumComparisonExp>;
  venue?: InputMaybe<VenuesBoolExp>;
  venueId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "engagement_analytics" */
export enum EngagementAnalyticsConstraint {
  /** unique or primary key constraint on columns "id" */
  EngagementAnalyticsPkey = 'engagement_analytics_pkey'
}

/** input type for inserting data into table "engagement_analytics" */
export type EngagementAnalyticsInsertInput = {
  actor?: InputMaybe<UsersObjRelInsertInput>;
  actorUserId?: InputMaybe<Scalars['uuid']>;
  anonSessionId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  entityType?: InputMaybe<EngagementEntityTypesEnum>;
  event?: InputMaybe<EventsObjRelInsertInput>;
  eventId?: InputMaybe<Scalars['uuid']>;
  eventType?: InputMaybe<EngagementEventTypesEnum>;
  id?: InputMaybe<Scalars['uuid']>;
  lesson?: InputMaybe<LessonsObjRelInsertInput>;
  lessonId?: InputMaybe<Scalars['uuid']>;
  occurredAt?: InputMaybe<Scalars['timestamptz']>;
  owner?: InputMaybe<UsersObjRelInsertInput>;
  ownerUserId?: InputMaybe<Scalars['uuid']>;
  placement?: InputMaybe<BoostsObjRelInsertInput>;
  placementId?: InputMaybe<Scalars['uuid']>;
  source?: InputMaybe<EngagementSourcesEnum>;
  venue?: InputMaybe<VenuesObjRelInsertInput>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type EngagementAnalyticsMaxFields = {
  __typename?: 'EngagementAnalyticsMaxFields';
  actorUserId?: Maybe<Scalars['uuid']>;
  anonSessionId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  eventId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  lessonId?: Maybe<Scalars['uuid']>;
  occurredAt?: Maybe<Scalars['timestamptz']>;
  ownerUserId?: Maybe<Scalars['uuid']>;
  placementId?: Maybe<Scalars['uuid']>;
  venueId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "engagement_analytics" */
export type EngagementAnalyticsMaxOrderBy = {
  actorUserId?: InputMaybe<OrderBy>;
  anonSessionId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  eventId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lessonId?: InputMaybe<OrderBy>;
  occurredAt?: InputMaybe<OrderBy>;
  ownerUserId?: InputMaybe<OrderBy>;
  placementId?: InputMaybe<OrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type EngagementAnalyticsMinFields = {
  __typename?: 'EngagementAnalyticsMinFields';
  actorUserId?: Maybe<Scalars['uuid']>;
  anonSessionId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  eventId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  lessonId?: Maybe<Scalars['uuid']>;
  occurredAt?: Maybe<Scalars['timestamptz']>;
  ownerUserId?: Maybe<Scalars['uuid']>;
  placementId?: Maybe<Scalars['uuid']>;
  venueId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "engagement_analytics" */
export type EngagementAnalyticsMinOrderBy = {
  actorUserId?: InputMaybe<OrderBy>;
  anonSessionId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  eventId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lessonId?: InputMaybe<OrderBy>;
  occurredAt?: InputMaybe<OrderBy>;
  ownerUserId?: InputMaybe<OrderBy>;
  placementId?: InputMaybe<OrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "engagement_analytics" */
export type EngagementAnalyticsMutationResponse = {
  __typename?: 'EngagementAnalyticsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EngagementAnalytics>;
};

/** on_conflict condition type for table "engagement_analytics" */
export type EngagementAnalyticsOnConflict = {
  constraint: EngagementAnalyticsConstraint;
  updateColumns?: Array<EngagementAnalyticsUpdateColumn>;
  where?: InputMaybe<EngagementAnalyticsBoolExp>;
};

/** Ordering options when selecting data from "engagement_analytics". */
export type EngagementAnalyticsOrderBy = {
  actor?: InputMaybe<UsersOrderBy>;
  actorUserId?: InputMaybe<OrderBy>;
  anonSessionId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  entityType?: InputMaybe<OrderBy>;
  event?: InputMaybe<EventsOrderBy>;
  eventId?: InputMaybe<OrderBy>;
  eventType?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lesson?: InputMaybe<LessonsOrderBy>;
  lessonId?: InputMaybe<OrderBy>;
  occurredAt?: InputMaybe<OrderBy>;
  owner?: InputMaybe<UsersOrderBy>;
  ownerUserId?: InputMaybe<OrderBy>;
  placement?: InputMaybe<BoostsOrderBy>;
  placementId?: InputMaybe<OrderBy>;
  source?: InputMaybe<OrderBy>;
  venue?: InputMaybe<VenuesOrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: engagement_analytics */
export type EngagementAnalyticsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "engagement_analytics" */
export enum EngagementAnalyticsSelectColumn {
  /** column name */
  ActorUserId = 'actorUserId',
  /** column name */
  AnonSessionId = 'anonSessionId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EntityType = 'entityType',
  /** column name */
  EventId = 'eventId',
  /** column name */
  EventType = 'eventType',
  /** column name */
  Id = 'id',
  /** column name */
  LessonId = 'lessonId',
  /** column name */
  OccurredAt = 'occurredAt',
  /** column name */
  OwnerUserId = 'ownerUserId',
  /** column name */
  PlacementId = 'placementId',
  /** column name */
  Source = 'source',
  /** column name */
  VenueId = 'venueId'
}

/** input type for updating data in table "engagement_analytics" */
export type EngagementAnalyticsSetInput = {
  actorUserId?: InputMaybe<Scalars['uuid']>;
  anonSessionId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  entityType?: InputMaybe<EngagementEntityTypesEnum>;
  eventId?: InputMaybe<Scalars['uuid']>;
  eventType?: InputMaybe<EngagementEventTypesEnum>;
  id?: InputMaybe<Scalars['uuid']>;
  lessonId?: InputMaybe<Scalars['uuid']>;
  occurredAt?: InputMaybe<Scalars['timestamptz']>;
  ownerUserId?: InputMaybe<Scalars['uuid']>;
  placementId?: InputMaybe<Scalars['uuid']>;
  source?: InputMaybe<EngagementSourcesEnum>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "engagement_analytics" */
export type EngagementAnalyticsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EngagementAnalyticsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EngagementAnalyticsStreamCursorValueInput = {
  actorUserId?: InputMaybe<Scalars['uuid']>;
  anonSessionId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  entityType?: InputMaybe<EngagementEntityTypesEnum>;
  eventId?: InputMaybe<Scalars['uuid']>;
  eventType?: InputMaybe<EngagementEventTypesEnum>;
  id?: InputMaybe<Scalars['uuid']>;
  lessonId?: InputMaybe<Scalars['uuid']>;
  occurredAt?: InputMaybe<Scalars['timestamptz']>;
  ownerUserId?: InputMaybe<Scalars['uuid']>;
  placementId?: InputMaybe<Scalars['uuid']>;
  source?: InputMaybe<EngagementSourcesEnum>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "engagement_analytics" */
export enum EngagementAnalyticsUpdateColumn {
  /** column name */
  ActorUserId = 'actorUserId',
  /** column name */
  AnonSessionId = 'anonSessionId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EntityType = 'entityType',
  /** column name */
  EventId = 'eventId',
  /** column name */
  EventType = 'eventType',
  /** column name */
  Id = 'id',
  /** column name */
  LessonId = 'lessonId',
  /** column name */
  OccurredAt = 'occurredAt',
  /** column name */
  OwnerUserId = 'ownerUserId',
  /** column name */
  PlacementId = 'placementId',
  /** column name */
  Source = 'source',
  /** column name */
  VenueId = 'venueId'
}

export type EngagementAnalyticsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EngagementAnalyticsSetInput>;
  /** filter the rows which have to be updated */
  where: EngagementAnalyticsBoolExp;
};

/** columns and relationships of "engagement_entity_types" */
export type EngagementEntityTypes = {
  __typename?: 'EngagementEntityTypes';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "engagement_entity_types" */
export type EngagementEntityTypesAggregate = {
  __typename?: 'EngagementEntityTypesAggregate';
  aggregate?: Maybe<EngagementEntityTypesAggregateFields>;
  nodes: Array<EngagementEntityTypes>;
};

/** aggregate fields of "engagement_entity_types" */
export type EngagementEntityTypesAggregateFields = {
  __typename?: 'EngagementEntityTypesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<EngagementEntityTypesMaxFields>;
  min?: Maybe<EngagementEntityTypesMinFields>;
};


/** aggregate fields of "engagement_entity_types" */
export type EngagementEntityTypesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EngagementEntityTypesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "engagement_entity_types". All fields are combined with a logical 'AND'. */
export type EngagementEntityTypesBoolExp = {
  _and?: InputMaybe<Array<EngagementEntityTypesBoolExp>>;
  _not?: InputMaybe<EngagementEntityTypesBoolExp>;
  _or?: InputMaybe<Array<EngagementEntityTypesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "engagement_entity_types" */
export enum EngagementEntityTypesConstraint {
  /** unique or primary key constraint on columns "value" */
  EngagementEntityTypesPkey = 'engagement_entity_types_pkey'
}

export enum EngagementEntityTypesEnum {
  ClubPage = 'CLUB_PAGE',
  CoachProfile = 'COACH_PROFILE',
  Event = 'EVENT',
  Lesson = 'LESSON'
}

/** Boolean expression to compare columns of type "EngagementEntityTypesEnum". All fields are combined with logical 'AND'. */
export type EngagementEntityTypesEnumComparisonExp = {
  _eq?: InputMaybe<EngagementEntityTypesEnum>;
  _in?: InputMaybe<Array<EngagementEntityTypesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<EngagementEntityTypesEnum>;
  _nin?: InputMaybe<Array<EngagementEntityTypesEnum>>;
};

/** input type for inserting data into table "engagement_entity_types" */
export type EngagementEntityTypesInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type EngagementEntityTypesMaxFields = {
  __typename?: 'EngagementEntityTypesMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type EngagementEntityTypesMinFields = {
  __typename?: 'EngagementEntityTypesMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "engagement_entity_types" */
export type EngagementEntityTypesMutationResponse = {
  __typename?: 'EngagementEntityTypesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EngagementEntityTypes>;
};

/** on_conflict condition type for table "engagement_entity_types" */
export type EngagementEntityTypesOnConflict = {
  constraint: EngagementEntityTypesConstraint;
  updateColumns?: Array<EngagementEntityTypesUpdateColumn>;
  where?: InputMaybe<EngagementEntityTypesBoolExp>;
};

/** Ordering options when selecting data from "engagement_entity_types". */
export type EngagementEntityTypesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: engagement_entity_types */
export type EngagementEntityTypesPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "engagement_entity_types" */
export enum EngagementEntityTypesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "engagement_entity_types" */
export type EngagementEntityTypesSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "engagement_entity_types" */
export type EngagementEntityTypesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EngagementEntityTypesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EngagementEntityTypesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "engagement_entity_types" */
export enum EngagementEntityTypesUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type EngagementEntityTypesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EngagementEntityTypesSetInput>;
  /** filter the rows which have to be updated */
  where: EngagementEntityTypesBoolExp;
};

/** columns and relationships of "engagement_event_types" */
export type EngagementEventTypes = {
  __typename?: 'EngagementEventTypes';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "engagement_event_types" */
export type EngagementEventTypesAggregate = {
  __typename?: 'EngagementEventTypesAggregate';
  aggregate?: Maybe<EngagementEventTypesAggregateFields>;
  nodes: Array<EngagementEventTypes>;
};

/** aggregate fields of "engagement_event_types" */
export type EngagementEventTypesAggregateFields = {
  __typename?: 'EngagementEventTypesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<EngagementEventTypesMaxFields>;
  min?: Maybe<EngagementEventTypesMinFields>;
};


/** aggregate fields of "engagement_event_types" */
export type EngagementEventTypesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EngagementEventTypesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "engagement_event_types". All fields are combined with a logical 'AND'. */
export type EngagementEventTypesBoolExp = {
  _and?: InputMaybe<Array<EngagementEventTypesBoolExp>>;
  _not?: InputMaybe<EngagementEventTypesBoolExp>;
  _or?: InputMaybe<Array<EngagementEventTypesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "engagement_event_types" */
export enum EngagementEventTypesConstraint {
  /** unique or primary key constraint on columns "value" */
  EngagementEventTypesPkey = 'engagement_event_types_pkey'
}

export enum EngagementEventTypesEnum {
  CtaClick = 'CTA_CLICK',
  Impression = 'IMPRESSION',
  View = 'VIEW'
}

/** Boolean expression to compare columns of type "EngagementEventTypesEnum". All fields are combined with logical 'AND'. */
export type EngagementEventTypesEnumComparisonExp = {
  _eq?: InputMaybe<EngagementEventTypesEnum>;
  _in?: InputMaybe<Array<EngagementEventTypesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<EngagementEventTypesEnum>;
  _nin?: InputMaybe<Array<EngagementEventTypesEnum>>;
};

/** input type for inserting data into table "engagement_event_types" */
export type EngagementEventTypesInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type EngagementEventTypesMaxFields = {
  __typename?: 'EngagementEventTypesMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type EngagementEventTypesMinFields = {
  __typename?: 'EngagementEventTypesMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "engagement_event_types" */
export type EngagementEventTypesMutationResponse = {
  __typename?: 'EngagementEventTypesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EngagementEventTypes>;
};

/** on_conflict condition type for table "engagement_event_types" */
export type EngagementEventTypesOnConflict = {
  constraint: EngagementEventTypesConstraint;
  updateColumns?: Array<EngagementEventTypesUpdateColumn>;
  where?: InputMaybe<EngagementEventTypesBoolExp>;
};

/** Ordering options when selecting data from "engagement_event_types". */
export type EngagementEventTypesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: engagement_event_types */
export type EngagementEventTypesPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "engagement_event_types" */
export enum EngagementEventTypesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "engagement_event_types" */
export type EngagementEventTypesSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "engagement_event_types" */
export type EngagementEventTypesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EngagementEventTypesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EngagementEventTypesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "engagement_event_types" */
export enum EngagementEventTypesUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type EngagementEventTypesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EngagementEventTypesSetInput>;
  /** filter the rows which have to be updated */
  where: EngagementEventTypesBoolExp;
};

/** columns and relationships of "engagement_sources" */
export type EngagementSources = {
  __typename?: 'EngagementSources';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "engagement_sources" */
export type EngagementSourcesAggregate = {
  __typename?: 'EngagementSourcesAggregate';
  aggregate?: Maybe<EngagementSourcesAggregateFields>;
  nodes: Array<EngagementSources>;
};

/** aggregate fields of "engagement_sources" */
export type EngagementSourcesAggregateFields = {
  __typename?: 'EngagementSourcesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<EngagementSourcesMaxFields>;
  min?: Maybe<EngagementSourcesMinFields>;
};


/** aggregate fields of "engagement_sources" */
export type EngagementSourcesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EngagementSourcesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "engagement_sources". All fields are combined with a logical 'AND'. */
export type EngagementSourcesBoolExp = {
  _and?: InputMaybe<Array<EngagementSourcesBoolExp>>;
  _not?: InputMaybe<EngagementSourcesBoolExp>;
  _or?: InputMaybe<Array<EngagementSourcesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "engagement_sources" */
export enum EngagementSourcesConstraint {
  /** unique or primary key constraint on columns "value" */
  EngagementSourcesPkey = 'engagement_sources_pkey'
}

export enum EngagementSourcesEnum {
  Boost = 'BOOST',
  Browse = 'BROWSE',
  ClubPage = 'CLUB_PAGE',
  Other = 'OTHER',
  Search = 'SEARCH',
  SharedLink = 'SHARED_LINK'
}

/** Boolean expression to compare columns of type "EngagementSourcesEnum". All fields are combined with logical 'AND'. */
export type EngagementSourcesEnumComparisonExp = {
  _eq?: InputMaybe<EngagementSourcesEnum>;
  _in?: InputMaybe<Array<EngagementSourcesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<EngagementSourcesEnum>;
  _nin?: InputMaybe<Array<EngagementSourcesEnum>>;
};

/** input type for inserting data into table "engagement_sources" */
export type EngagementSourcesInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type EngagementSourcesMaxFields = {
  __typename?: 'EngagementSourcesMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type EngagementSourcesMinFields = {
  __typename?: 'EngagementSourcesMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "engagement_sources" */
export type EngagementSourcesMutationResponse = {
  __typename?: 'EngagementSourcesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EngagementSources>;
};

/** on_conflict condition type for table "engagement_sources" */
export type EngagementSourcesOnConflict = {
  constraint: EngagementSourcesConstraint;
  updateColumns?: Array<EngagementSourcesUpdateColumn>;
  where?: InputMaybe<EngagementSourcesBoolExp>;
};

/** Ordering options when selecting data from "engagement_sources". */
export type EngagementSourcesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: engagement_sources */
export type EngagementSourcesPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "engagement_sources" */
export enum EngagementSourcesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "engagement_sources" */
export type EngagementSourcesSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "engagement_sources" */
export type EngagementSourcesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EngagementSourcesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EngagementSourcesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "engagement_sources" */
export enum EngagementSourcesUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type EngagementSourcesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EngagementSourcesSetInput>;
  /** filter the rows which have to be updated */
  where: EngagementSourcesBoolExp;
};

/** columns and relationships of "equipment_availabilities" */
export type EquipmentAvailabilities = {
  __typename?: 'EquipmentAvailabilities';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "equipment_availabilities" */
export type EquipmentAvailabilitiesAggregate = {
  __typename?: 'EquipmentAvailabilitiesAggregate';
  aggregate?: Maybe<EquipmentAvailabilitiesAggregateFields>;
  nodes: Array<EquipmentAvailabilities>;
};

/** aggregate fields of "equipment_availabilities" */
export type EquipmentAvailabilitiesAggregateFields = {
  __typename?: 'EquipmentAvailabilitiesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<EquipmentAvailabilitiesMaxFields>;
  min?: Maybe<EquipmentAvailabilitiesMinFields>;
};


/** aggregate fields of "equipment_availabilities" */
export type EquipmentAvailabilitiesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EquipmentAvailabilitiesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "equipment_availabilities". All fields are combined with a logical 'AND'. */
export type EquipmentAvailabilitiesBoolExp = {
  _and?: InputMaybe<Array<EquipmentAvailabilitiesBoolExp>>;
  _not?: InputMaybe<EquipmentAvailabilitiesBoolExp>;
  _or?: InputMaybe<Array<EquipmentAvailabilitiesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "equipment_availabilities" */
export enum EquipmentAvailabilitiesConstraint {
  /** unique or primary key constraint on columns "value" */
  EquipmentAvailabilitiesPkey = 'equipment_availabilities_pkey'
}

export enum EquipmentAvailabilitiesEnum {
  BringYourOwn = 'BRING_YOUR_OWN',
  ForRent = 'FOR_RENT',
  Provided = 'PROVIDED'
}

/** Boolean expression to compare columns of type "EquipmentAvailabilitiesEnum". All fields are combined with logical 'AND'. */
export type EquipmentAvailabilitiesEnumComparisonExp = {
  _eq?: InputMaybe<EquipmentAvailabilitiesEnum>;
  _in?: InputMaybe<Array<EquipmentAvailabilitiesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<EquipmentAvailabilitiesEnum>;
  _nin?: InputMaybe<Array<EquipmentAvailabilitiesEnum>>;
};

/** input type for inserting data into table "equipment_availabilities" */
export type EquipmentAvailabilitiesInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type EquipmentAvailabilitiesMaxFields = {
  __typename?: 'EquipmentAvailabilitiesMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type EquipmentAvailabilitiesMinFields = {
  __typename?: 'EquipmentAvailabilitiesMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "equipment_availabilities" */
export type EquipmentAvailabilitiesMutationResponse = {
  __typename?: 'EquipmentAvailabilitiesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EquipmentAvailabilities>;
};

/** on_conflict condition type for table "equipment_availabilities" */
export type EquipmentAvailabilitiesOnConflict = {
  constraint: EquipmentAvailabilitiesConstraint;
  updateColumns?: Array<EquipmentAvailabilitiesUpdateColumn>;
  where?: InputMaybe<EquipmentAvailabilitiesBoolExp>;
};

/** Ordering options when selecting data from "equipment_availabilities". */
export type EquipmentAvailabilitiesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: equipment_availabilities */
export type EquipmentAvailabilitiesPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "equipment_availabilities" */
export enum EquipmentAvailabilitiesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "equipment_availabilities" */
export type EquipmentAvailabilitiesSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "equipment_availabilities" */
export type EquipmentAvailabilitiesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EquipmentAvailabilitiesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EquipmentAvailabilitiesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "equipment_availabilities" */
export enum EquipmentAvailabilitiesUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type EquipmentAvailabilitiesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EquipmentAvailabilitiesSetInput>;
  /** filter the rows which have to be updated */
  where: EquipmentAvailabilitiesBoolExp;
};

/** columns and relationships of "event_accepted_play_requests" */
export type EventAcceptedPlayRequests = {
  __typename?: 'EventAcceptedPlayRequests';
  /** An object relationship */
  event?: Maybe<Events>;
  eventId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  requesterProfile?: Maybe<UserProfiles>;
  requesterUserId?: Maybe<Scalars['uuid']>;
  respondedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "event_accepted_play_requests" */
export type EventAcceptedPlayRequestsAggregate = {
  __typename?: 'EventAcceptedPlayRequestsAggregate';
  aggregate?: Maybe<EventAcceptedPlayRequestsAggregateFields>;
  nodes: Array<EventAcceptedPlayRequests>;
};

export type EventAcceptedPlayRequestsAggregateBoolExp = {
  count?: InputMaybe<EventAcceptedPlayRequestsAggregateBoolExpCount>;
};

/** aggregate fields of "event_accepted_play_requests" */
export type EventAcceptedPlayRequestsAggregateFields = {
  __typename?: 'EventAcceptedPlayRequestsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<EventAcceptedPlayRequestsMaxFields>;
  min?: Maybe<EventAcceptedPlayRequestsMinFields>;
};


/** aggregate fields of "event_accepted_play_requests" */
export type EventAcceptedPlayRequestsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EventAcceptedPlayRequestsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "event_accepted_play_requests" */
export type EventAcceptedPlayRequestsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EventAcceptedPlayRequestsMaxOrderBy>;
  min?: InputMaybe<EventAcceptedPlayRequestsMinOrderBy>;
};

/** input type for inserting array relation for remote table "event_accepted_play_requests" */
export type EventAcceptedPlayRequestsArrRelInsertInput = {
  data: Array<EventAcceptedPlayRequestsInsertInput>;
};

/** Boolean expression to filter rows from the table "event_accepted_play_requests". All fields are combined with a logical 'AND'. */
export type EventAcceptedPlayRequestsBoolExp = {
  _and?: InputMaybe<Array<EventAcceptedPlayRequestsBoolExp>>;
  _not?: InputMaybe<EventAcceptedPlayRequestsBoolExp>;
  _or?: InputMaybe<Array<EventAcceptedPlayRequestsBoolExp>>;
  event?: InputMaybe<EventsBoolExp>;
  eventId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  requesterProfile?: InputMaybe<UserProfilesBoolExp>;
  requesterUserId?: InputMaybe<UuidComparisonExp>;
  respondedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** input type for inserting data into table "event_accepted_play_requests" */
export type EventAcceptedPlayRequestsInsertInput = {
  event?: InputMaybe<EventsObjRelInsertInput>;
  eventId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  requesterProfile?: InputMaybe<UserProfilesObjRelInsertInput>;
  requesterUserId?: InputMaybe<Scalars['uuid']>;
  respondedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type EventAcceptedPlayRequestsMaxFields = {
  __typename?: 'EventAcceptedPlayRequestsMaxFields';
  eventId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  requesterUserId?: Maybe<Scalars['uuid']>;
  respondedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "event_accepted_play_requests" */
export type EventAcceptedPlayRequestsMaxOrderBy = {
  eventId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  requesterUserId?: InputMaybe<OrderBy>;
  respondedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type EventAcceptedPlayRequestsMinFields = {
  __typename?: 'EventAcceptedPlayRequestsMinFields';
  eventId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  requesterUserId?: Maybe<Scalars['uuid']>;
  respondedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "event_accepted_play_requests" */
export type EventAcceptedPlayRequestsMinOrderBy = {
  eventId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  requesterUserId?: InputMaybe<OrderBy>;
  respondedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "event_accepted_play_requests" */
export type EventAcceptedPlayRequestsMutationResponse = {
  __typename?: 'EventAcceptedPlayRequestsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventAcceptedPlayRequests>;
};

/** Ordering options when selecting data from "event_accepted_play_requests". */
export type EventAcceptedPlayRequestsOrderBy = {
  event?: InputMaybe<EventsOrderBy>;
  eventId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  requesterProfile?: InputMaybe<UserProfilesOrderBy>;
  requesterUserId?: InputMaybe<OrderBy>;
  respondedAt?: InputMaybe<OrderBy>;
};

/** select columns of table "event_accepted_play_requests" */
export enum EventAcceptedPlayRequestsSelectColumn {
  /** column name */
  EventId = 'eventId',
  /** column name */
  Id = 'id',
  /** column name */
  RequesterUserId = 'requesterUserId',
  /** column name */
  RespondedAt = 'respondedAt'
}

/** input type for updating data in table "event_accepted_play_requests" */
export type EventAcceptedPlayRequestsSetInput = {
  eventId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  requesterUserId?: InputMaybe<Scalars['uuid']>;
  respondedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "event_accepted_play_requests" */
export type EventAcceptedPlayRequestsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventAcceptedPlayRequestsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventAcceptedPlayRequestsStreamCursorValueInput = {
  eventId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  requesterUserId?: InputMaybe<Scalars['uuid']>;
  respondedAt?: InputMaybe<Scalars['timestamptz']>;
};

export type EventAcceptedPlayRequestsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventAcceptedPlayRequestsSetInput>;
  /** filter the rows which have to be updated */
  where: EventAcceptedPlayRequestsBoolExp;
};

/** columns and relationships of "event_age_groups" */
export type EventAgeGroups = {
  __typename?: 'EventAgeGroups';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "event_age_groups" */
export type EventAgeGroupsAggregate = {
  __typename?: 'EventAgeGroupsAggregate';
  aggregate?: Maybe<EventAgeGroupsAggregateFields>;
  nodes: Array<EventAgeGroups>;
};

/** aggregate fields of "event_age_groups" */
export type EventAgeGroupsAggregateFields = {
  __typename?: 'EventAgeGroupsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<EventAgeGroupsMaxFields>;
  min?: Maybe<EventAgeGroupsMinFields>;
};


/** aggregate fields of "event_age_groups" */
export type EventAgeGroupsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EventAgeGroupsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "event_age_groups". All fields are combined with a logical 'AND'. */
export type EventAgeGroupsBoolExp = {
  _and?: InputMaybe<Array<EventAgeGroupsBoolExp>>;
  _not?: InputMaybe<EventAgeGroupsBoolExp>;
  _or?: InputMaybe<Array<EventAgeGroupsBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "event_age_groups" */
export enum EventAgeGroupsConstraint {
  /** unique or primary key constraint on columns "value" */
  EventAgeGroupsPkey = 'event_age_groups_pkey'
}

export enum EventAgeGroupsEnum {
  Adults = 'ADULTS',
  AllAges = 'ALL_AGES',
  Youth = 'YOUTH'
}

/** Boolean expression to compare columns of type "EventAgeGroupsEnum". All fields are combined with logical 'AND'. */
export type EventAgeGroupsEnumComparisonExp = {
  _eq?: InputMaybe<EventAgeGroupsEnum>;
  _in?: InputMaybe<Array<EventAgeGroupsEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<EventAgeGroupsEnum>;
  _nin?: InputMaybe<Array<EventAgeGroupsEnum>>;
};

/** input type for inserting data into table "event_age_groups" */
export type EventAgeGroupsInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type EventAgeGroupsMaxFields = {
  __typename?: 'EventAgeGroupsMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type EventAgeGroupsMinFields = {
  __typename?: 'EventAgeGroupsMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "event_age_groups" */
export type EventAgeGroupsMutationResponse = {
  __typename?: 'EventAgeGroupsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventAgeGroups>;
};

/** on_conflict condition type for table "event_age_groups" */
export type EventAgeGroupsOnConflict = {
  constraint: EventAgeGroupsConstraint;
  updateColumns?: Array<EventAgeGroupsUpdateColumn>;
  where?: InputMaybe<EventAgeGroupsBoolExp>;
};

/** Ordering options when selecting data from "event_age_groups". */
export type EventAgeGroupsOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: event_age_groups */
export type EventAgeGroupsPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "event_age_groups" */
export enum EventAgeGroupsSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "event_age_groups" */
export type EventAgeGroupsSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "event_age_groups" */
export type EventAgeGroupsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventAgeGroupsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventAgeGroupsStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "event_age_groups" */
export enum EventAgeGroupsUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type EventAgeGroupsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventAgeGroupsSetInput>;
  /** filter the rows which have to be updated */
  where: EventAgeGroupsBoolExp;
};

/** columns and relationships of "event_collections" */
export type EventCollections = {
  __typename?: 'EventCollections';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  events: Array<Events>;
  /** An aggregate relationship */
  eventsAggregate: EventsAggregate;
  /** An object relationship */
  hostUser?: Maybe<Users>;
  hostUserId?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  publishedAt?: Maybe<Scalars['timestamptz']>;
  recurrenceKind?: Maybe<RecurrenceKindsEnum>;
  slug: Scalars['String'];
  status: EventStatusesEnum;
  title: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "event_collections" */
export type EventCollectionsEventsArgs = {
  distinctOn?: InputMaybe<Array<EventsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventsOrderBy>>;
  where?: InputMaybe<EventsBoolExp>;
};


/** columns and relationships of "event_collections" */
export type EventCollectionsEventsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventsOrderBy>>;
  where?: InputMaybe<EventsBoolExp>;
};

/** aggregated selection of "event_collections" */
export type EventCollectionsAggregate = {
  __typename?: 'EventCollectionsAggregate';
  aggregate?: Maybe<EventCollectionsAggregateFields>;
  nodes: Array<EventCollections>;
};

/** aggregate fields of "event_collections" */
export type EventCollectionsAggregateFields = {
  __typename?: 'EventCollectionsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<EventCollectionsMaxFields>;
  min?: Maybe<EventCollectionsMinFields>;
};


/** aggregate fields of "event_collections" */
export type EventCollectionsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EventCollectionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "event_collections". All fields are combined with a logical 'AND'. */
export type EventCollectionsBoolExp = {
  _and?: InputMaybe<Array<EventCollectionsBoolExp>>;
  _not?: InputMaybe<EventCollectionsBoolExp>;
  _or?: InputMaybe<Array<EventCollectionsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  events?: InputMaybe<EventsBoolExp>;
  eventsAggregate?: InputMaybe<EventsAggregateBoolExp>;
  hostUser?: InputMaybe<UsersBoolExp>;
  hostUserId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  publishedAt?: InputMaybe<TimestamptzComparisonExp>;
  recurrenceKind?: InputMaybe<RecurrenceKindsEnumComparisonExp>;
  slug?: InputMaybe<StringComparisonExp>;
  status?: InputMaybe<EventStatusesEnumComparisonExp>;
  title?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "event_collections" */
export enum EventCollectionsConstraint {
  /** unique or primary key constraint on columns "id" */
  EventCollectionsPkey = 'event_collections_pkey',
  /** unique or primary key constraint on columns "slug" */
  EventCollectionsSlugKey = 'event_collections_slug_key'
}

/** input type for inserting data into table "event_collections" */
export type EventCollectionsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  events?: InputMaybe<EventsArrRelInsertInput>;
  hostUser?: InputMaybe<UsersObjRelInsertInput>;
  hostUserId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  publishedAt?: InputMaybe<Scalars['timestamptz']>;
  recurrenceKind?: InputMaybe<RecurrenceKindsEnum>;
  slug?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<EventStatusesEnum>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type EventCollectionsMaxFields = {
  __typename?: 'EventCollectionsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  hostUserId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  publishedAt?: Maybe<Scalars['timestamptz']>;
  slug?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type EventCollectionsMinFields = {
  __typename?: 'EventCollectionsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  hostUserId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  publishedAt?: Maybe<Scalars['timestamptz']>;
  slug?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "event_collections" */
export type EventCollectionsMutationResponse = {
  __typename?: 'EventCollectionsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventCollections>;
};

/** input type for inserting object relation for remote table "event_collections" */
export type EventCollectionsObjRelInsertInput = {
  data: EventCollectionsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<EventCollectionsOnConflict>;
};

/** on_conflict condition type for table "event_collections" */
export type EventCollectionsOnConflict = {
  constraint: EventCollectionsConstraint;
  updateColumns?: Array<EventCollectionsUpdateColumn>;
  where?: InputMaybe<EventCollectionsBoolExp>;
};

/** Ordering options when selecting data from "event_collections". */
export type EventCollectionsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  eventsAggregate?: InputMaybe<EventsAggregateOrderBy>;
  hostUser?: InputMaybe<UsersOrderBy>;
  hostUserId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  publishedAt?: InputMaybe<OrderBy>;
  recurrenceKind?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: event_collections */
export type EventCollectionsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "event_collections" */
export enum EventCollectionsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  HostUserId = 'hostUserId',
  /** column name */
  Id = 'id',
  /** column name */
  PublishedAt = 'publishedAt',
  /** column name */
  RecurrenceKind = 'recurrenceKind',
  /** column name */
  Slug = 'slug',
  /** column name */
  Status = 'status',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "event_collections" */
export type EventCollectionsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  hostUserId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  publishedAt?: InputMaybe<Scalars['timestamptz']>;
  recurrenceKind?: InputMaybe<RecurrenceKindsEnum>;
  slug?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<EventStatusesEnum>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "event_collections" */
export type EventCollectionsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventCollectionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventCollectionsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  hostUserId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  publishedAt?: InputMaybe<Scalars['timestamptz']>;
  recurrenceKind?: InputMaybe<RecurrenceKindsEnum>;
  slug?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<EventStatusesEnum>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "event_collections" */
export enum EventCollectionsUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  HostUserId = 'hostUserId',
  /** column name */
  Id = 'id',
  /** column name */
  PublishedAt = 'publishedAt',
  /** column name */
  RecurrenceKind = 'recurrenceKind',
  /** column name */
  Slug = 'slug',
  /** column name */
  Status = 'status',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type EventCollectionsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventCollectionsSetInput>;
  /** filter the rows which have to be updated */
  where: EventCollectionsBoolExp;
};

/** columns and relationships of "event_competitiveness" */
export type EventCompetitiveness = {
  __typename?: 'EventCompetitiveness';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "event_competitiveness" */
export type EventCompetitivenessAggregate = {
  __typename?: 'EventCompetitivenessAggregate';
  aggregate?: Maybe<EventCompetitivenessAggregateFields>;
  nodes: Array<EventCompetitiveness>;
};

/** aggregate fields of "event_competitiveness" */
export type EventCompetitivenessAggregateFields = {
  __typename?: 'EventCompetitivenessAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<EventCompetitivenessMaxFields>;
  min?: Maybe<EventCompetitivenessMinFields>;
};


/** aggregate fields of "event_competitiveness" */
export type EventCompetitivenessAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EventCompetitivenessSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "event_competitiveness". All fields are combined with a logical 'AND'. */
export type EventCompetitivenessBoolExp = {
  _and?: InputMaybe<Array<EventCompetitivenessBoolExp>>;
  _not?: InputMaybe<EventCompetitivenessBoolExp>;
  _or?: InputMaybe<Array<EventCompetitivenessBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "event_competitiveness" */
export enum EventCompetitivenessConstraint {
  /** unique or primary key constraint on columns "value" */
  EventCompetitivenessPkey = 'event_competitiveness_pkey'
}

export enum EventCompetitivenessEnum {
  Any = 'ANY',
  /** Recreational play */
  Casual = 'CASUAL',
  Competitive = 'COMPETITIVE',
  Drill = 'DRILL',
  MatchPrep = 'MATCH_PREP'
}

/** Boolean expression to compare columns of type "EventCompetitivenessEnum". All fields are combined with logical 'AND'. */
export type EventCompetitivenessEnumComparisonExp = {
  _eq?: InputMaybe<EventCompetitivenessEnum>;
  _in?: InputMaybe<Array<EventCompetitivenessEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<EventCompetitivenessEnum>;
  _nin?: InputMaybe<Array<EventCompetitivenessEnum>>;
};

/** input type for inserting data into table "event_competitiveness" */
export type EventCompetitivenessInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type EventCompetitivenessMaxFields = {
  __typename?: 'EventCompetitivenessMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type EventCompetitivenessMinFields = {
  __typename?: 'EventCompetitivenessMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "event_competitiveness" */
export type EventCompetitivenessMutationResponse = {
  __typename?: 'EventCompetitivenessMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventCompetitiveness>;
};

/** on_conflict condition type for table "event_competitiveness" */
export type EventCompetitivenessOnConflict = {
  constraint: EventCompetitivenessConstraint;
  updateColumns?: Array<EventCompetitivenessUpdateColumn>;
  where?: InputMaybe<EventCompetitivenessBoolExp>;
};

/** Ordering options when selecting data from "event_competitiveness". */
export type EventCompetitivenessOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: event_competitiveness */
export type EventCompetitivenessPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "event_competitiveness" */
export enum EventCompetitivenessSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "event_competitiveness" */
export type EventCompetitivenessSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "event_competitiveness" */
export type EventCompetitivenessStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventCompetitivenessStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventCompetitivenessStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "event_competitiveness" */
export enum EventCompetitivenessUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type EventCompetitivenessUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventCompetitivenessSetInput>;
  /** filter the rows which have to be updated */
  where: EventCompetitivenessBoolExp;
};

/** columns and relationships of "event_contact_details" */
export type EventContactDetails = {
  __typename?: 'EventContactDetails';
  contactUrl: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  email: Scalars['String'];
  /** An object relationship */
  event: Events;
  eventId: Scalars['uuid'];
  id: Scalars['uuid'];
  phoneNumber: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "event_contact_details" */
export type EventContactDetailsAggregate = {
  __typename?: 'EventContactDetailsAggregate';
  aggregate?: Maybe<EventContactDetailsAggregateFields>;
  nodes: Array<EventContactDetails>;
};

/** aggregate fields of "event_contact_details" */
export type EventContactDetailsAggregateFields = {
  __typename?: 'EventContactDetailsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<EventContactDetailsMaxFields>;
  min?: Maybe<EventContactDetailsMinFields>;
};


/** aggregate fields of "event_contact_details" */
export type EventContactDetailsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EventContactDetailsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "event_contact_details". All fields are combined with a logical 'AND'. */
export type EventContactDetailsBoolExp = {
  _and?: InputMaybe<Array<EventContactDetailsBoolExp>>;
  _not?: InputMaybe<EventContactDetailsBoolExp>;
  _or?: InputMaybe<Array<EventContactDetailsBoolExp>>;
  contactUrl?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  email?: InputMaybe<StringComparisonExp>;
  event?: InputMaybe<EventsBoolExp>;
  eventId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  phoneNumber?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "event_contact_details" */
export enum EventContactDetailsConstraint {
  /** unique or primary key constraint on columns "event_id" */
  EventContactDetailsEventIdKey = 'event_contact_details_event_id_key',
  /** unique or primary key constraint on columns "id" */
  EventContactDetailsPkey = 'event_contact_details_pkey'
}

/** input type for inserting data into table "event_contact_details" */
export type EventContactDetailsInsertInput = {
  contactUrl?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  event?: InputMaybe<EventsObjRelInsertInput>;
  eventId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type EventContactDetailsMaxFields = {
  __typename?: 'EventContactDetailsMaxFields';
  contactUrl?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  eventId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  phoneNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type EventContactDetailsMinFields = {
  __typename?: 'EventContactDetailsMinFields';
  contactUrl?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  eventId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  phoneNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "event_contact_details" */
export type EventContactDetailsMutationResponse = {
  __typename?: 'EventContactDetailsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventContactDetails>;
};

/** input type for inserting object relation for remote table "event_contact_details" */
export type EventContactDetailsObjRelInsertInput = {
  data: EventContactDetailsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<EventContactDetailsOnConflict>;
};

/** on_conflict condition type for table "event_contact_details" */
export type EventContactDetailsOnConflict = {
  constraint: EventContactDetailsConstraint;
  updateColumns?: Array<EventContactDetailsUpdateColumn>;
  where?: InputMaybe<EventContactDetailsBoolExp>;
};

/** Ordering options when selecting data from "event_contact_details". */
export type EventContactDetailsOrderBy = {
  contactUrl?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  email?: InputMaybe<OrderBy>;
  event?: InputMaybe<EventsOrderBy>;
  eventId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  phoneNumber?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: event_contact_details */
export type EventContactDetailsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "event_contact_details" */
export enum EventContactDetailsSelectColumn {
  /** column name */
  ContactUrl = 'contactUrl',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Email = 'email',
  /** column name */
  EventId = 'eventId',
  /** column name */
  Id = 'id',
  /** column name */
  PhoneNumber = 'phoneNumber',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "event_contact_details" */
export type EventContactDetailsSetInput = {
  contactUrl?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "event_contact_details" */
export type EventContactDetailsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventContactDetailsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventContactDetailsStreamCursorValueInput = {
  contactUrl?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "event_contact_details" */
export enum EventContactDetailsUpdateColumn {
  /** column name */
  ContactUrl = 'contactUrl',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Email = 'email',
  /** column name */
  EventId = 'eventId',
  /** column name */
  Id = 'id',
  /** column name */
  PhoneNumber = 'phoneNumber',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type EventContactDetailsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventContactDetailsSetInput>;
  /** filter the rows which have to be updated */
  where: EventContactDetailsBoolExp;
};

/** columns and relationships of "event_coupon_groups" */
export type EventCouponGroups = {
  __typename?: 'EventCouponGroups';
  /** An object relationship */
  coupon: EventCoupons;
  couponId: Scalars['uuid'];
  /** An object relationship */
  eventGroup: EventGroups;
  eventGroupId: Scalars['uuid'];
  id: Scalars['uuid'];
};

/** aggregated selection of "event_coupon_groups" */
export type EventCouponGroupsAggregate = {
  __typename?: 'EventCouponGroupsAggregate';
  aggregate?: Maybe<EventCouponGroupsAggregateFields>;
  nodes: Array<EventCouponGroups>;
};

export type EventCouponGroupsAggregateBoolExp = {
  count?: InputMaybe<EventCouponGroupsAggregateBoolExpCount>;
};

/** aggregate fields of "event_coupon_groups" */
export type EventCouponGroupsAggregateFields = {
  __typename?: 'EventCouponGroupsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<EventCouponGroupsMaxFields>;
  min?: Maybe<EventCouponGroupsMinFields>;
};


/** aggregate fields of "event_coupon_groups" */
export type EventCouponGroupsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EventCouponGroupsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "event_coupon_groups" */
export type EventCouponGroupsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EventCouponGroupsMaxOrderBy>;
  min?: InputMaybe<EventCouponGroupsMinOrderBy>;
};

/** input type for inserting array relation for remote table "event_coupon_groups" */
export type EventCouponGroupsArrRelInsertInput = {
  data: Array<EventCouponGroupsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<EventCouponGroupsOnConflict>;
};

/** Boolean expression to filter rows from the table "event_coupon_groups". All fields are combined with a logical 'AND'. */
export type EventCouponGroupsBoolExp = {
  _and?: InputMaybe<Array<EventCouponGroupsBoolExp>>;
  _not?: InputMaybe<EventCouponGroupsBoolExp>;
  _or?: InputMaybe<Array<EventCouponGroupsBoolExp>>;
  coupon?: InputMaybe<EventCouponsBoolExp>;
  couponId?: InputMaybe<UuidComparisonExp>;
  eventGroup?: InputMaybe<EventGroupsBoolExp>;
  eventGroupId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "event_coupon_groups" */
export enum EventCouponGroupsConstraint {
  /** unique or primary key constraint on columns "id" */
  EventCouponGroupsPkey = 'event_coupon_groups_pkey'
}

/** input type for inserting data into table "event_coupon_groups" */
export type EventCouponGroupsInsertInput = {
  coupon?: InputMaybe<EventCouponsObjRelInsertInput>;
  couponId?: InputMaybe<Scalars['uuid']>;
  eventGroup?: InputMaybe<EventGroupsObjRelInsertInput>;
  eventGroupId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type EventCouponGroupsMaxFields = {
  __typename?: 'EventCouponGroupsMaxFields';
  couponId?: Maybe<Scalars['uuid']>;
  eventGroupId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "event_coupon_groups" */
export type EventCouponGroupsMaxOrderBy = {
  couponId?: InputMaybe<OrderBy>;
  eventGroupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type EventCouponGroupsMinFields = {
  __typename?: 'EventCouponGroupsMinFields';
  couponId?: Maybe<Scalars['uuid']>;
  eventGroupId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "event_coupon_groups" */
export type EventCouponGroupsMinOrderBy = {
  couponId?: InputMaybe<OrderBy>;
  eventGroupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "event_coupon_groups" */
export type EventCouponGroupsMutationResponse = {
  __typename?: 'EventCouponGroupsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventCouponGroups>;
};

/** on_conflict condition type for table "event_coupon_groups" */
export type EventCouponGroupsOnConflict = {
  constraint: EventCouponGroupsConstraint;
  updateColumns?: Array<EventCouponGroupsUpdateColumn>;
  where?: InputMaybe<EventCouponGroupsBoolExp>;
};

/** Ordering options when selecting data from "event_coupon_groups". */
export type EventCouponGroupsOrderBy = {
  coupon?: InputMaybe<EventCouponsOrderBy>;
  couponId?: InputMaybe<OrderBy>;
  eventGroup?: InputMaybe<EventGroupsOrderBy>;
  eventGroupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: event_coupon_groups */
export type EventCouponGroupsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "event_coupon_groups" */
export enum EventCouponGroupsSelectColumn {
  /** column name */
  CouponId = 'couponId',
  /** column name */
  EventGroupId = 'eventGroupId',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "event_coupon_groups" */
export type EventCouponGroupsSetInput = {
  couponId?: InputMaybe<Scalars['uuid']>;
  eventGroupId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "event_coupon_groups" */
export type EventCouponGroupsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventCouponGroupsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventCouponGroupsStreamCursorValueInput = {
  couponId?: InputMaybe<Scalars['uuid']>;
  eventGroupId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "event_coupon_groups" */
export enum EventCouponGroupsUpdateColumn {
  /** column name */
  CouponId = 'couponId',
  /** column name */
  EventGroupId = 'eventGroupId',
  /** column name */
  Id = 'id'
}

export type EventCouponGroupsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventCouponGroupsSetInput>;
  /** filter the rows which have to be updated */
  where: EventCouponGroupsBoolExp;
};

/** columns and relationships of "event_coupon_redemptions" */
export type EventCouponRedemptions = {
  __typename?: 'EventCouponRedemptions';
  /** An object relationship */
  coupon: EventCoupons;
  couponId: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  discountUnitAmount: Scalars['Int'];
  eventTransactionId?: Maybe<Scalars['uuid']>;
  eventTransactionItemId?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  /** An object relationship */
  transaction?: Maybe<EventTransactions>;
  /** An object relationship */
  transactionItem?: Maybe<EventTransactionItems>;
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid'];
};

/** aggregated selection of "event_coupon_redemptions" */
export type EventCouponRedemptionsAggregate = {
  __typename?: 'EventCouponRedemptionsAggregate';
  aggregate?: Maybe<EventCouponRedemptionsAggregateFields>;
  nodes: Array<EventCouponRedemptions>;
};

export type EventCouponRedemptionsAggregateBoolExp = {
  count?: InputMaybe<EventCouponRedemptionsAggregateBoolExpCount>;
};

/** aggregate fields of "event_coupon_redemptions" */
export type EventCouponRedemptionsAggregateFields = {
  __typename?: 'EventCouponRedemptionsAggregateFields';
  avg?: Maybe<EventCouponRedemptionsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<EventCouponRedemptionsMaxFields>;
  min?: Maybe<EventCouponRedemptionsMinFields>;
  stddev?: Maybe<EventCouponRedemptionsStddevFields>;
  stddevPop?: Maybe<EventCouponRedemptionsStddevPopFields>;
  stddevSamp?: Maybe<EventCouponRedemptionsStddevSampFields>;
  sum?: Maybe<EventCouponRedemptionsSumFields>;
  varPop?: Maybe<EventCouponRedemptionsVarPopFields>;
  varSamp?: Maybe<EventCouponRedemptionsVarSampFields>;
  variance?: Maybe<EventCouponRedemptionsVarianceFields>;
};


/** aggregate fields of "event_coupon_redemptions" */
export type EventCouponRedemptionsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EventCouponRedemptionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "event_coupon_redemptions" */
export type EventCouponRedemptionsAggregateOrderBy = {
  avg?: InputMaybe<EventCouponRedemptionsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EventCouponRedemptionsMaxOrderBy>;
  min?: InputMaybe<EventCouponRedemptionsMinOrderBy>;
  stddev?: InputMaybe<EventCouponRedemptionsStddevOrderBy>;
  stddevPop?: InputMaybe<EventCouponRedemptionsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<EventCouponRedemptionsStddevSampOrderBy>;
  sum?: InputMaybe<EventCouponRedemptionsSumOrderBy>;
  varPop?: InputMaybe<EventCouponRedemptionsVarPopOrderBy>;
  varSamp?: InputMaybe<EventCouponRedemptionsVarSampOrderBy>;
  variance?: InputMaybe<EventCouponRedemptionsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "event_coupon_redemptions" */
export type EventCouponRedemptionsArrRelInsertInput = {
  data: Array<EventCouponRedemptionsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<EventCouponRedemptionsOnConflict>;
};

/** aggregate avg on columns */
export type EventCouponRedemptionsAvgFields = {
  __typename?: 'EventCouponRedemptionsAvgFields';
  discountUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "event_coupon_redemptions" */
export type EventCouponRedemptionsAvgOrderBy = {
  discountUnitAmount?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "event_coupon_redemptions". All fields are combined with a logical 'AND'. */
export type EventCouponRedemptionsBoolExp = {
  _and?: InputMaybe<Array<EventCouponRedemptionsBoolExp>>;
  _not?: InputMaybe<EventCouponRedemptionsBoolExp>;
  _or?: InputMaybe<Array<EventCouponRedemptionsBoolExp>>;
  coupon?: InputMaybe<EventCouponsBoolExp>;
  couponId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  discountUnitAmount?: InputMaybe<IntComparisonExp>;
  eventTransactionId?: InputMaybe<UuidComparisonExp>;
  eventTransactionItemId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  transaction?: InputMaybe<EventTransactionsBoolExp>;
  transactionItem?: InputMaybe<EventTransactionItemsBoolExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "event_coupon_redemptions" */
export enum EventCouponRedemptionsConstraint {
  /** unique or primary key constraint on columns "id" */
  EventCouponRedemptionsPkey = 'event_coupon_redemptions_pkey'
}

/** input type for incrementing numeric columns in table "event_coupon_redemptions" */
export type EventCouponRedemptionsIncInput = {
  discountUnitAmount?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "event_coupon_redemptions" */
export type EventCouponRedemptionsInsertInput = {
  coupon?: InputMaybe<EventCouponsObjRelInsertInput>;
  couponId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  discountUnitAmount?: InputMaybe<Scalars['Int']>;
  eventTransactionId?: InputMaybe<Scalars['uuid']>;
  eventTransactionItemId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  transaction?: InputMaybe<EventTransactionsObjRelInsertInput>;
  transactionItem?: InputMaybe<EventTransactionItemsObjRelInsertInput>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type EventCouponRedemptionsMaxFields = {
  __typename?: 'EventCouponRedemptionsMaxFields';
  couponId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  discountUnitAmount?: Maybe<Scalars['Int']>;
  eventTransactionId?: Maybe<Scalars['uuid']>;
  eventTransactionItemId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "event_coupon_redemptions" */
export type EventCouponRedemptionsMaxOrderBy = {
  couponId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  discountUnitAmount?: InputMaybe<OrderBy>;
  eventTransactionId?: InputMaybe<OrderBy>;
  eventTransactionItemId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type EventCouponRedemptionsMinFields = {
  __typename?: 'EventCouponRedemptionsMinFields';
  couponId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  discountUnitAmount?: Maybe<Scalars['Int']>;
  eventTransactionId?: Maybe<Scalars['uuid']>;
  eventTransactionItemId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "event_coupon_redemptions" */
export type EventCouponRedemptionsMinOrderBy = {
  couponId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  discountUnitAmount?: InputMaybe<OrderBy>;
  eventTransactionId?: InputMaybe<OrderBy>;
  eventTransactionItemId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "event_coupon_redemptions" */
export type EventCouponRedemptionsMutationResponse = {
  __typename?: 'EventCouponRedemptionsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventCouponRedemptions>;
};

/** on_conflict condition type for table "event_coupon_redemptions" */
export type EventCouponRedemptionsOnConflict = {
  constraint: EventCouponRedemptionsConstraint;
  updateColumns?: Array<EventCouponRedemptionsUpdateColumn>;
  where?: InputMaybe<EventCouponRedemptionsBoolExp>;
};

/** Ordering options when selecting data from "event_coupon_redemptions". */
export type EventCouponRedemptionsOrderBy = {
  coupon?: InputMaybe<EventCouponsOrderBy>;
  couponId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  discountUnitAmount?: InputMaybe<OrderBy>;
  eventTransactionId?: InputMaybe<OrderBy>;
  eventTransactionItemId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  transaction?: InputMaybe<EventTransactionsOrderBy>;
  transactionItem?: InputMaybe<EventTransactionItemsOrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: event_coupon_redemptions */
export type EventCouponRedemptionsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "event_coupon_redemptions" */
export enum EventCouponRedemptionsSelectColumn {
  /** column name */
  CouponId = 'couponId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DiscountUnitAmount = 'discountUnitAmount',
  /** column name */
  EventTransactionId = 'eventTransactionId',
  /** column name */
  EventTransactionItemId = 'eventTransactionItemId',
  /** column name */
  Id = 'id',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "event_coupon_redemptions" */
export type EventCouponRedemptionsSetInput = {
  couponId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  discountUnitAmount?: InputMaybe<Scalars['Int']>;
  eventTransactionId?: InputMaybe<Scalars['uuid']>;
  eventTransactionItemId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type EventCouponRedemptionsStddevFields = {
  __typename?: 'EventCouponRedemptionsStddevFields';
  discountUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "event_coupon_redemptions" */
export type EventCouponRedemptionsStddevOrderBy = {
  discountUnitAmount?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type EventCouponRedemptionsStddevPopFields = {
  __typename?: 'EventCouponRedemptionsStddevPopFields';
  discountUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "event_coupon_redemptions" */
export type EventCouponRedemptionsStddevPopOrderBy = {
  discountUnitAmount?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type EventCouponRedemptionsStddevSampFields = {
  __typename?: 'EventCouponRedemptionsStddevSampFields';
  discountUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "event_coupon_redemptions" */
export type EventCouponRedemptionsStddevSampOrderBy = {
  discountUnitAmount?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "event_coupon_redemptions" */
export type EventCouponRedemptionsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventCouponRedemptionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventCouponRedemptionsStreamCursorValueInput = {
  couponId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  discountUnitAmount?: InputMaybe<Scalars['Int']>;
  eventTransactionId?: InputMaybe<Scalars['uuid']>;
  eventTransactionItemId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type EventCouponRedemptionsSumFields = {
  __typename?: 'EventCouponRedemptionsSumFields';
  discountUnitAmount?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "event_coupon_redemptions" */
export type EventCouponRedemptionsSumOrderBy = {
  discountUnitAmount?: InputMaybe<OrderBy>;
};

/** update columns of table "event_coupon_redemptions" */
export enum EventCouponRedemptionsUpdateColumn {
  /** column name */
  CouponId = 'couponId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DiscountUnitAmount = 'discountUnitAmount',
  /** column name */
  EventTransactionId = 'eventTransactionId',
  /** column name */
  EventTransactionItemId = 'eventTransactionItemId',
  /** column name */
  Id = 'id',
  /** column name */
  UserId = 'userId'
}

export type EventCouponRedemptionsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<EventCouponRedemptionsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventCouponRedemptionsSetInput>;
  /** filter the rows which have to be updated */
  where: EventCouponRedemptionsBoolExp;
};

/** aggregate varPop on columns */
export type EventCouponRedemptionsVarPopFields = {
  __typename?: 'EventCouponRedemptionsVarPopFields';
  discountUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "event_coupon_redemptions" */
export type EventCouponRedemptionsVarPopOrderBy = {
  discountUnitAmount?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type EventCouponRedemptionsVarSampFields = {
  __typename?: 'EventCouponRedemptionsVarSampFields';
  discountUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "event_coupon_redemptions" */
export type EventCouponRedemptionsVarSampOrderBy = {
  discountUnitAmount?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type EventCouponRedemptionsVarianceFields = {
  __typename?: 'EventCouponRedemptionsVarianceFields';
  discountUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "event_coupon_redemptions" */
export type EventCouponRedemptionsVarianceOrderBy = {
  discountUnitAmount?: InputMaybe<OrderBy>;
};

/** columns and relationships of "event_coupon_source" */
export type EventCouponSource = {
  __typename?: 'EventCouponSource';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "event_coupon_source" */
export type EventCouponSourceAggregate = {
  __typename?: 'EventCouponSourceAggregate';
  aggregate?: Maybe<EventCouponSourceAggregateFields>;
  nodes: Array<EventCouponSource>;
};

/** aggregate fields of "event_coupon_source" */
export type EventCouponSourceAggregateFields = {
  __typename?: 'EventCouponSourceAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<EventCouponSourceMaxFields>;
  min?: Maybe<EventCouponSourceMinFields>;
};


/** aggregate fields of "event_coupon_source" */
export type EventCouponSourceAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EventCouponSourceSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "event_coupon_source". All fields are combined with a logical 'AND'. */
export type EventCouponSourceBoolExp = {
  _and?: InputMaybe<Array<EventCouponSourceBoolExp>>;
  _not?: InputMaybe<EventCouponSourceBoolExp>;
  _or?: InputMaybe<Array<EventCouponSourceBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "event_coupon_source" */
export enum EventCouponSourceConstraint {
  /** unique or primary key constraint on columns "value" */
  EventCouponSourcePkey = 'event_coupon_source_pkey'
}

export enum EventCouponSourceEnum {
  /** Time-based automatic pricing */
  EarlyBird = 'EARLY_BIRD',
  /** Organizer-created promo code */
  Manual = 'MANUAL'
}

/** Boolean expression to compare columns of type "EventCouponSourceEnum". All fields are combined with logical 'AND'. */
export type EventCouponSourceEnumComparisonExp = {
  _eq?: InputMaybe<EventCouponSourceEnum>;
  _in?: InputMaybe<Array<EventCouponSourceEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<EventCouponSourceEnum>;
  _nin?: InputMaybe<Array<EventCouponSourceEnum>>;
};

/** input type for inserting data into table "event_coupon_source" */
export type EventCouponSourceInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type EventCouponSourceMaxFields = {
  __typename?: 'EventCouponSourceMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type EventCouponSourceMinFields = {
  __typename?: 'EventCouponSourceMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "event_coupon_source" */
export type EventCouponSourceMutationResponse = {
  __typename?: 'EventCouponSourceMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventCouponSource>;
};

/** input type for inserting object relation for remote table "event_coupon_source" */
export type EventCouponSourceObjRelInsertInput = {
  data: EventCouponSourceInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<EventCouponSourceOnConflict>;
};

/** on_conflict condition type for table "event_coupon_source" */
export type EventCouponSourceOnConflict = {
  constraint: EventCouponSourceConstraint;
  updateColumns?: Array<EventCouponSourceUpdateColumn>;
  where?: InputMaybe<EventCouponSourceBoolExp>;
};

/** Ordering options when selecting data from "event_coupon_source". */
export type EventCouponSourceOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: event_coupon_source */
export type EventCouponSourcePkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "event_coupon_source" */
export enum EventCouponSourceSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "event_coupon_source" */
export type EventCouponSourceSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "event_coupon_source" */
export type EventCouponSourceStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventCouponSourceStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventCouponSourceStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "event_coupon_source" */
export enum EventCouponSourceUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type EventCouponSourceUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventCouponSourceSetInput>;
  /** filter the rows which have to be updated */
  where: EventCouponSourceBoolExp;
};

/** columns and relationships of "event_coupon_type" */
export type EventCouponType = {
  __typename?: 'EventCouponType';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "event_coupon_type" */
export type EventCouponTypeAggregate = {
  __typename?: 'EventCouponTypeAggregate';
  aggregate?: Maybe<EventCouponTypeAggregateFields>;
  nodes: Array<EventCouponType>;
};

/** aggregate fields of "event_coupon_type" */
export type EventCouponTypeAggregateFields = {
  __typename?: 'EventCouponTypeAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<EventCouponTypeMaxFields>;
  min?: Maybe<EventCouponTypeMinFields>;
};


/** aggregate fields of "event_coupon_type" */
export type EventCouponTypeAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EventCouponTypeSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "event_coupon_type". All fields are combined with a logical 'AND'. */
export type EventCouponTypeBoolExp = {
  _and?: InputMaybe<Array<EventCouponTypeBoolExp>>;
  _not?: InputMaybe<EventCouponTypeBoolExp>;
  _or?: InputMaybe<Array<EventCouponTypeBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "event_coupon_type" */
export enum EventCouponTypeConstraint {
  /** unique or primary key constraint on columns "value" */
  EventCouponTypePkey = 'event_coupon_type_pkey'
}

export enum EventCouponTypeEnum {
  /** Subtract a fixed amount */
  AmountOff = 'AMOUNT_OFF',
  /** Override the price entirely */
  FixedPrice = 'FIXED_PRICE',
  /** Subtract a percentage */
  PercentOff = 'PERCENT_OFF'
}

/** Boolean expression to compare columns of type "EventCouponTypeEnum". All fields are combined with logical 'AND'. */
export type EventCouponTypeEnumComparisonExp = {
  _eq?: InputMaybe<EventCouponTypeEnum>;
  _in?: InputMaybe<Array<EventCouponTypeEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<EventCouponTypeEnum>;
  _nin?: InputMaybe<Array<EventCouponTypeEnum>>;
};

/** input type for inserting data into table "event_coupon_type" */
export type EventCouponTypeInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type EventCouponTypeMaxFields = {
  __typename?: 'EventCouponTypeMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type EventCouponTypeMinFields = {
  __typename?: 'EventCouponTypeMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "event_coupon_type" */
export type EventCouponTypeMutationResponse = {
  __typename?: 'EventCouponTypeMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventCouponType>;
};

/** input type for inserting object relation for remote table "event_coupon_type" */
export type EventCouponTypeObjRelInsertInput = {
  data: EventCouponTypeInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<EventCouponTypeOnConflict>;
};

/** on_conflict condition type for table "event_coupon_type" */
export type EventCouponTypeOnConflict = {
  constraint: EventCouponTypeConstraint;
  updateColumns?: Array<EventCouponTypeUpdateColumn>;
  where?: InputMaybe<EventCouponTypeBoolExp>;
};

/** Ordering options when selecting data from "event_coupon_type". */
export type EventCouponTypeOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: event_coupon_type */
export type EventCouponTypePkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "event_coupon_type" */
export enum EventCouponTypeSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "event_coupon_type" */
export type EventCouponTypeSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "event_coupon_type" */
export type EventCouponTypeStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventCouponTypeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventCouponTypeStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "event_coupon_type" */
export enum EventCouponTypeUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type EventCouponTypeUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventCouponTypeSetInput>;
  /** filter the rows which have to be updated */
  where: EventCouponTypeBoolExp;
};

/** columns and relationships of "event_coupons" */
export type EventCoupons = {
  __typename?: 'EventCoupons';
  amountOff?: Maybe<Scalars['Int']>;
  code: Scalars['String'];
  /** An array relationship */
  couponGroups: Array<EventCouponGroups>;
  /** An aggregate relationship */
  couponGroupsAggregate: EventCouponGroupsAggregate;
  /** An object relationship */
  couponSourceDetails: EventCouponSource;
  couponType: EventCouponTypeEnum;
  /** An object relationship */
  couponTypeDetails: EventCouponType;
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  event: Events;
  eventId: Scalars['uuid'];
  fixedPrice?: Maybe<Scalars['Int']>;
  id: Scalars['uuid'];
  isActive: Scalars['Boolean'];
  isAutoApply: Scalars['Boolean'];
  maxRedemptions?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  percentOff?: Maybe<Scalars['numeric']>;
  /** An array relationship */
  redemptions: Array<EventCouponRedemptions>;
  /** An aggregate relationship */
  redemptionsAggregate: EventCouponRedemptionsAggregate;
  source: EventCouponSourceEnum;
  tierPriority: Scalars['Int'];
  updatedAt: Scalars['timestamptz'];
  validFrom?: Maybe<Scalars['timestamptz']>;
  validUntil?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "event_coupons" */
export type EventCouponsCouponGroupsArgs = {
  distinctOn?: InputMaybe<Array<EventCouponGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventCouponGroupsOrderBy>>;
  where?: InputMaybe<EventCouponGroupsBoolExp>;
};


/** columns and relationships of "event_coupons" */
export type EventCouponsCouponGroupsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventCouponGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventCouponGroupsOrderBy>>;
  where?: InputMaybe<EventCouponGroupsBoolExp>;
};


/** columns and relationships of "event_coupons" */
export type EventCouponsRedemptionsArgs = {
  distinctOn?: InputMaybe<Array<EventCouponRedemptionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventCouponRedemptionsOrderBy>>;
  where?: InputMaybe<EventCouponRedemptionsBoolExp>;
};


/** columns and relationships of "event_coupons" */
export type EventCouponsRedemptionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventCouponRedemptionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventCouponRedemptionsOrderBy>>;
  where?: InputMaybe<EventCouponRedemptionsBoolExp>;
};

/** aggregated selection of "event_coupons" */
export type EventCouponsAggregate = {
  __typename?: 'EventCouponsAggregate';
  aggregate?: Maybe<EventCouponsAggregateFields>;
  nodes: Array<EventCoupons>;
};

export type EventCouponsAggregateBoolExp = {
  bool_and?: InputMaybe<EventCouponsAggregateBoolExpBool_And>;
  bool_or?: InputMaybe<EventCouponsAggregateBoolExpBool_Or>;
  count?: InputMaybe<EventCouponsAggregateBoolExpCount>;
};

/** aggregate fields of "event_coupons" */
export type EventCouponsAggregateFields = {
  __typename?: 'EventCouponsAggregateFields';
  avg?: Maybe<EventCouponsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<EventCouponsMaxFields>;
  min?: Maybe<EventCouponsMinFields>;
  stddev?: Maybe<EventCouponsStddevFields>;
  stddevPop?: Maybe<EventCouponsStddevPopFields>;
  stddevSamp?: Maybe<EventCouponsStddevSampFields>;
  sum?: Maybe<EventCouponsSumFields>;
  varPop?: Maybe<EventCouponsVarPopFields>;
  varSamp?: Maybe<EventCouponsVarSampFields>;
  variance?: Maybe<EventCouponsVarianceFields>;
};


/** aggregate fields of "event_coupons" */
export type EventCouponsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EventCouponsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "event_coupons" */
export type EventCouponsAggregateOrderBy = {
  avg?: InputMaybe<EventCouponsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EventCouponsMaxOrderBy>;
  min?: InputMaybe<EventCouponsMinOrderBy>;
  stddev?: InputMaybe<EventCouponsStddevOrderBy>;
  stddevPop?: InputMaybe<EventCouponsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<EventCouponsStddevSampOrderBy>;
  sum?: InputMaybe<EventCouponsSumOrderBy>;
  varPop?: InputMaybe<EventCouponsVarPopOrderBy>;
  varSamp?: InputMaybe<EventCouponsVarSampOrderBy>;
  variance?: InputMaybe<EventCouponsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "event_coupons" */
export type EventCouponsArrRelInsertInput = {
  data: Array<EventCouponsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<EventCouponsOnConflict>;
};

/** aggregate avg on columns */
export type EventCouponsAvgFields = {
  __typename?: 'EventCouponsAvgFields';
  amountOff?: Maybe<Scalars['Float']>;
  fixedPrice?: Maybe<Scalars['Float']>;
  maxRedemptions?: Maybe<Scalars['Float']>;
  percentOff?: Maybe<Scalars['Float']>;
  tierPriority?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "event_coupons" */
export type EventCouponsAvgOrderBy = {
  amountOff?: InputMaybe<OrderBy>;
  fixedPrice?: InputMaybe<OrderBy>;
  maxRedemptions?: InputMaybe<OrderBy>;
  percentOff?: InputMaybe<OrderBy>;
  tierPriority?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "event_coupons". All fields are combined with a logical 'AND'. */
export type EventCouponsBoolExp = {
  _and?: InputMaybe<Array<EventCouponsBoolExp>>;
  _not?: InputMaybe<EventCouponsBoolExp>;
  _or?: InputMaybe<Array<EventCouponsBoolExp>>;
  amountOff?: InputMaybe<IntComparisonExp>;
  code?: InputMaybe<StringComparisonExp>;
  couponGroups?: InputMaybe<EventCouponGroupsBoolExp>;
  couponGroupsAggregate?: InputMaybe<EventCouponGroupsAggregateBoolExp>;
  couponSourceDetails?: InputMaybe<EventCouponSourceBoolExp>;
  couponType?: InputMaybe<EventCouponTypeEnumComparisonExp>;
  couponTypeDetails?: InputMaybe<EventCouponTypeBoolExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  event?: InputMaybe<EventsBoolExp>;
  eventId?: InputMaybe<UuidComparisonExp>;
  fixedPrice?: InputMaybe<IntComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isActive?: InputMaybe<BooleanComparisonExp>;
  isAutoApply?: InputMaybe<BooleanComparisonExp>;
  maxRedemptions?: InputMaybe<IntComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  percentOff?: InputMaybe<NumericComparisonExp>;
  redemptions?: InputMaybe<EventCouponRedemptionsBoolExp>;
  redemptionsAggregate?: InputMaybe<EventCouponRedemptionsAggregateBoolExp>;
  source?: InputMaybe<EventCouponSourceEnumComparisonExp>;
  tierPriority?: InputMaybe<IntComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  validFrom?: InputMaybe<TimestamptzComparisonExp>;
  validUntil?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "event_coupons" */
export enum EventCouponsConstraint {
  /** unique or primary key constraint on columns "code", "event_id" */
  EventCouponsEventIdCodeKey = 'event_coupons_event_id_code_key',
  /** unique or primary key constraint on columns "id" */
  EventCouponsPkey = 'event_coupons_pkey'
}

/** input type for incrementing numeric columns in table "event_coupons" */
export type EventCouponsIncInput = {
  amountOff?: InputMaybe<Scalars['Int']>;
  fixedPrice?: InputMaybe<Scalars['Int']>;
  maxRedemptions?: InputMaybe<Scalars['Int']>;
  percentOff?: InputMaybe<Scalars['numeric']>;
  tierPriority?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "event_coupons" */
export type EventCouponsInsertInput = {
  amountOff?: InputMaybe<Scalars['Int']>;
  code?: InputMaybe<Scalars['String']>;
  couponGroups?: InputMaybe<EventCouponGroupsArrRelInsertInput>;
  couponSourceDetails?: InputMaybe<EventCouponSourceObjRelInsertInput>;
  couponType?: InputMaybe<EventCouponTypeEnum>;
  couponTypeDetails?: InputMaybe<EventCouponTypeObjRelInsertInput>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  event?: InputMaybe<EventsObjRelInsertInput>;
  eventId?: InputMaybe<Scalars['uuid']>;
  fixedPrice?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isAutoApply?: InputMaybe<Scalars['Boolean']>;
  maxRedemptions?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  percentOff?: InputMaybe<Scalars['numeric']>;
  redemptions?: InputMaybe<EventCouponRedemptionsArrRelInsertInput>;
  source?: InputMaybe<EventCouponSourceEnum>;
  tierPriority?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  validFrom?: InputMaybe<Scalars['timestamptz']>;
  validUntil?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type EventCouponsMaxFields = {
  __typename?: 'EventCouponsMaxFields';
  amountOff?: Maybe<Scalars['Int']>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  eventId?: Maybe<Scalars['uuid']>;
  fixedPrice?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  maxRedemptions?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  percentOff?: Maybe<Scalars['numeric']>;
  tierPriority?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  validFrom?: Maybe<Scalars['timestamptz']>;
  validUntil?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "event_coupons" */
export type EventCouponsMaxOrderBy = {
  amountOff?: InputMaybe<OrderBy>;
  code?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  eventId?: InputMaybe<OrderBy>;
  fixedPrice?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  maxRedemptions?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  percentOff?: InputMaybe<OrderBy>;
  tierPriority?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  validFrom?: InputMaybe<OrderBy>;
  validUntil?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type EventCouponsMinFields = {
  __typename?: 'EventCouponsMinFields';
  amountOff?: Maybe<Scalars['Int']>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  eventId?: Maybe<Scalars['uuid']>;
  fixedPrice?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  maxRedemptions?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  percentOff?: Maybe<Scalars['numeric']>;
  tierPriority?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  validFrom?: Maybe<Scalars['timestamptz']>;
  validUntil?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "event_coupons" */
export type EventCouponsMinOrderBy = {
  amountOff?: InputMaybe<OrderBy>;
  code?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  eventId?: InputMaybe<OrderBy>;
  fixedPrice?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  maxRedemptions?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  percentOff?: InputMaybe<OrderBy>;
  tierPriority?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  validFrom?: InputMaybe<OrderBy>;
  validUntil?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "event_coupons" */
export type EventCouponsMutationResponse = {
  __typename?: 'EventCouponsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventCoupons>;
};

/** input type for inserting object relation for remote table "event_coupons" */
export type EventCouponsObjRelInsertInput = {
  data: EventCouponsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<EventCouponsOnConflict>;
};

/** on_conflict condition type for table "event_coupons" */
export type EventCouponsOnConflict = {
  constraint: EventCouponsConstraint;
  updateColumns?: Array<EventCouponsUpdateColumn>;
  where?: InputMaybe<EventCouponsBoolExp>;
};

/** Ordering options when selecting data from "event_coupons". */
export type EventCouponsOrderBy = {
  amountOff?: InputMaybe<OrderBy>;
  code?: InputMaybe<OrderBy>;
  couponGroupsAggregate?: InputMaybe<EventCouponGroupsAggregateOrderBy>;
  couponSourceDetails?: InputMaybe<EventCouponSourceOrderBy>;
  couponType?: InputMaybe<OrderBy>;
  couponTypeDetails?: InputMaybe<EventCouponTypeOrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  event?: InputMaybe<EventsOrderBy>;
  eventId?: InputMaybe<OrderBy>;
  fixedPrice?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  isActive?: InputMaybe<OrderBy>;
  isAutoApply?: InputMaybe<OrderBy>;
  maxRedemptions?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  percentOff?: InputMaybe<OrderBy>;
  redemptionsAggregate?: InputMaybe<EventCouponRedemptionsAggregateOrderBy>;
  source?: InputMaybe<OrderBy>;
  tierPriority?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  validFrom?: InputMaybe<OrderBy>;
  validUntil?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: event_coupons */
export type EventCouponsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "event_coupons" */
export enum EventCouponsSelectColumn {
  /** column name */
  AmountOff = 'amountOff',
  /** column name */
  Code = 'code',
  /** column name */
  CouponType = 'couponType',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EventId = 'eventId',
  /** column name */
  FixedPrice = 'fixedPrice',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'isActive',
  /** column name */
  IsAutoApply = 'isAutoApply',
  /** column name */
  MaxRedemptions = 'maxRedemptions',
  /** column name */
  Name = 'name',
  /** column name */
  PercentOff = 'percentOff',
  /** column name */
  Source = 'source',
  /** column name */
  TierPriority = 'tierPriority',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  ValidFrom = 'validFrom',
  /** column name */
  ValidUntil = 'validUntil'
}

/** select "eventCouponsAggregateBoolExpBool_andArgumentsColumns" columns of table "event_coupons" */
export enum EventCouponsSelectColumnEventCouponsAggregateBoolExpBool_AndArgumentsColumns {
  /** column name */
  IsActive = 'isActive',
  /** column name */
  IsAutoApply = 'isAutoApply'
}

/** select "eventCouponsAggregateBoolExpBool_orArgumentsColumns" columns of table "event_coupons" */
export enum EventCouponsSelectColumnEventCouponsAggregateBoolExpBool_OrArgumentsColumns {
  /** column name */
  IsActive = 'isActive',
  /** column name */
  IsAutoApply = 'isAutoApply'
}

/** input type for updating data in table "event_coupons" */
export type EventCouponsSetInput = {
  amountOff?: InputMaybe<Scalars['Int']>;
  code?: InputMaybe<Scalars['String']>;
  couponType?: InputMaybe<EventCouponTypeEnum>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  eventId?: InputMaybe<Scalars['uuid']>;
  fixedPrice?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isAutoApply?: InputMaybe<Scalars['Boolean']>;
  maxRedemptions?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  percentOff?: InputMaybe<Scalars['numeric']>;
  source?: InputMaybe<EventCouponSourceEnum>;
  tierPriority?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  validFrom?: InputMaybe<Scalars['timestamptz']>;
  validUntil?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type EventCouponsStddevFields = {
  __typename?: 'EventCouponsStddevFields';
  amountOff?: Maybe<Scalars['Float']>;
  fixedPrice?: Maybe<Scalars['Float']>;
  maxRedemptions?: Maybe<Scalars['Float']>;
  percentOff?: Maybe<Scalars['Float']>;
  tierPriority?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "event_coupons" */
export type EventCouponsStddevOrderBy = {
  amountOff?: InputMaybe<OrderBy>;
  fixedPrice?: InputMaybe<OrderBy>;
  maxRedemptions?: InputMaybe<OrderBy>;
  percentOff?: InputMaybe<OrderBy>;
  tierPriority?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type EventCouponsStddevPopFields = {
  __typename?: 'EventCouponsStddevPopFields';
  amountOff?: Maybe<Scalars['Float']>;
  fixedPrice?: Maybe<Scalars['Float']>;
  maxRedemptions?: Maybe<Scalars['Float']>;
  percentOff?: Maybe<Scalars['Float']>;
  tierPriority?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "event_coupons" */
export type EventCouponsStddevPopOrderBy = {
  amountOff?: InputMaybe<OrderBy>;
  fixedPrice?: InputMaybe<OrderBy>;
  maxRedemptions?: InputMaybe<OrderBy>;
  percentOff?: InputMaybe<OrderBy>;
  tierPriority?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type EventCouponsStddevSampFields = {
  __typename?: 'EventCouponsStddevSampFields';
  amountOff?: Maybe<Scalars['Float']>;
  fixedPrice?: Maybe<Scalars['Float']>;
  maxRedemptions?: Maybe<Scalars['Float']>;
  percentOff?: Maybe<Scalars['Float']>;
  tierPriority?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "event_coupons" */
export type EventCouponsStddevSampOrderBy = {
  amountOff?: InputMaybe<OrderBy>;
  fixedPrice?: InputMaybe<OrderBy>;
  maxRedemptions?: InputMaybe<OrderBy>;
  percentOff?: InputMaybe<OrderBy>;
  tierPriority?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "event_coupons" */
export type EventCouponsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventCouponsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventCouponsStreamCursorValueInput = {
  amountOff?: InputMaybe<Scalars['Int']>;
  code?: InputMaybe<Scalars['String']>;
  couponType?: InputMaybe<EventCouponTypeEnum>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  eventId?: InputMaybe<Scalars['uuid']>;
  fixedPrice?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isAutoApply?: InputMaybe<Scalars['Boolean']>;
  maxRedemptions?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  percentOff?: InputMaybe<Scalars['numeric']>;
  source?: InputMaybe<EventCouponSourceEnum>;
  tierPriority?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  validFrom?: InputMaybe<Scalars['timestamptz']>;
  validUntil?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type EventCouponsSumFields = {
  __typename?: 'EventCouponsSumFields';
  amountOff?: Maybe<Scalars['Int']>;
  fixedPrice?: Maybe<Scalars['Int']>;
  maxRedemptions?: Maybe<Scalars['Int']>;
  percentOff?: Maybe<Scalars['numeric']>;
  tierPriority?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "event_coupons" */
export type EventCouponsSumOrderBy = {
  amountOff?: InputMaybe<OrderBy>;
  fixedPrice?: InputMaybe<OrderBy>;
  maxRedemptions?: InputMaybe<OrderBy>;
  percentOff?: InputMaybe<OrderBy>;
  tierPriority?: InputMaybe<OrderBy>;
};

/** update columns of table "event_coupons" */
export enum EventCouponsUpdateColumn {
  /** column name */
  AmountOff = 'amountOff',
  /** column name */
  Code = 'code',
  /** column name */
  CouponType = 'couponType',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EventId = 'eventId',
  /** column name */
  FixedPrice = 'fixedPrice',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'isActive',
  /** column name */
  IsAutoApply = 'isAutoApply',
  /** column name */
  MaxRedemptions = 'maxRedemptions',
  /** column name */
  Name = 'name',
  /** column name */
  PercentOff = 'percentOff',
  /** column name */
  Source = 'source',
  /** column name */
  TierPriority = 'tierPriority',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  ValidFrom = 'validFrom',
  /** column name */
  ValidUntil = 'validUntil'
}

export type EventCouponsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<EventCouponsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventCouponsSetInput>;
  /** filter the rows which have to be updated */
  where: EventCouponsBoolExp;
};

/** aggregate varPop on columns */
export type EventCouponsVarPopFields = {
  __typename?: 'EventCouponsVarPopFields';
  amountOff?: Maybe<Scalars['Float']>;
  fixedPrice?: Maybe<Scalars['Float']>;
  maxRedemptions?: Maybe<Scalars['Float']>;
  percentOff?: Maybe<Scalars['Float']>;
  tierPriority?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "event_coupons" */
export type EventCouponsVarPopOrderBy = {
  amountOff?: InputMaybe<OrderBy>;
  fixedPrice?: InputMaybe<OrderBy>;
  maxRedemptions?: InputMaybe<OrderBy>;
  percentOff?: InputMaybe<OrderBy>;
  tierPriority?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type EventCouponsVarSampFields = {
  __typename?: 'EventCouponsVarSampFields';
  amountOff?: Maybe<Scalars['Float']>;
  fixedPrice?: Maybe<Scalars['Float']>;
  maxRedemptions?: Maybe<Scalars['Float']>;
  percentOff?: Maybe<Scalars['Float']>;
  tierPriority?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "event_coupons" */
export type EventCouponsVarSampOrderBy = {
  amountOff?: InputMaybe<OrderBy>;
  fixedPrice?: InputMaybe<OrderBy>;
  maxRedemptions?: InputMaybe<OrderBy>;
  percentOff?: InputMaybe<OrderBy>;
  tierPriority?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type EventCouponsVarianceFields = {
  __typename?: 'EventCouponsVarianceFields';
  amountOff?: Maybe<Scalars['Float']>;
  fixedPrice?: Maybe<Scalars['Float']>;
  maxRedemptions?: Maybe<Scalars['Float']>;
  percentOff?: Maybe<Scalars['Float']>;
  tierPriority?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "event_coupons" */
export type EventCouponsVarianceOrderBy = {
  amountOff?: InputMaybe<OrderBy>;
  fixedPrice?: InputMaybe<OrderBy>;
  maxRedemptions?: InputMaybe<OrderBy>;
  percentOff?: InputMaybe<OrderBy>;
  tierPriority?: InputMaybe<OrderBy>;
};

/** columns and relationships of "event_court_statuses" */
export type EventCourtStatuses = {
  __typename?: 'EventCourtStatuses';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "event_court_statuses" */
export type EventCourtStatusesAggregate = {
  __typename?: 'EventCourtStatusesAggregate';
  aggregate?: Maybe<EventCourtStatusesAggregateFields>;
  nodes: Array<EventCourtStatuses>;
};

/** aggregate fields of "event_court_statuses" */
export type EventCourtStatusesAggregateFields = {
  __typename?: 'EventCourtStatusesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<EventCourtStatusesMaxFields>;
  min?: Maybe<EventCourtStatusesMinFields>;
};


/** aggregate fields of "event_court_statuses" */
export type EventCourtStatusesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EventCourtStatusesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "event_court_statuses". All fields are combined with a logical 'AND'. */
export type EventCourtStatusesBoolExp = {
  _and?: InputMaybe<Array<EventCourtStatusesBoolExp>>;
  _not?: InputMaybe<EventCourtStatusesBoolExp>;
  _or?: InputMaybe<Array<EventCourtStatusesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "event_court_statuses" */
export enum EventCourtStatusesConstraint {
  /** unique or primary key constraint on columns "value" */
  EventCourtStatusesPkey = 'event_court_statuses_pkey'
}

export enum EventCourtStatusesEnum {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

/** Boolean expression to compare columns of type "EventCourtStatusesEnum". All fields are combined with logical 'AND'. */
export type EventCourtStatusesEnumComparisonExp = {
  _eq?: InputMaybe<EventCourtStatusesEnum>;
  _in?: InputMaybe<Array<EventCourtStatusesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<EventCourtStatusesEnum>;
  _nin?: InputMaybe<Array<EventCourtStatusesEnum>>;
};

/** input type for inserting data into table "event_court_statuses" */
export type EventCourtStatusesInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type EventCourtStatusesMaxFields = {
  __typename?: 'EventCourtStatusesMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type EventCourtStatusesMinFields = {
  __typename?: 'EventCourtStatusesMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "event_court_statuses" */
export type EventCourtStatusesMutationResponse = {
  __typename?: 'EventCourtStatusesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventCourtStatuses>;
};

/** on_conflict condition type for table "event_court_statuses" */
export type EventCourtStatusesOnConflict = {
  constraint: EventCourtStatusesConstraint;
  updateColumns?: Array<EventCourtStatusesUpdateColumn>;
  where?: InputMaybe<EventCourtStatusesBoolExp>;
};

/** Ordering options when selecting data from "event_court_statuses". */
export type EventCourtStatusesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: event_court_statuses */
export type EventCourtStatusesPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "event_court_statuses" */
export enum EventCourtStatusesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "event_court_statuses" */
export type EventCourtStatusesSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "event_court_statuses" */
export type EventCourtStatusesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventCourtStatusesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventCourtStatusesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "event_court_statuses" */
export enum EventCourtStatusesUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type EventCourtStatusesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventCourtStatusesSetInput>;
  /** filter the rows which have to be updated */
  where: EventCourtStatusesBoolExp;
};

/** Note: This table may be overly structured with the foreign keys. Consider removing some if they're not needed. */
export type EventCourts = {
  __typename?: 'EventCourts';
  activeEventGroupId?: Maybe<Scalars['uuid']>;
  activeEventGroupPoolId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  activeGroup?: Maybe<EventGroups>;
  /** An object relationship */
  activeMatch?: Maybe<EventMatches>;
  activeMatchId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  activePool?: Maybe<EventGroupPools>;
  courtName?: Maybe<Scalars['String']>;
  courtNumber: Scalars['Int'];
  courtStatus: EventCourtStatusesEnum;
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  event: Events;
  eventId: Scalars['uuid'];
  id: Scalars['uuid'];
  /** An array relationship */
  matches: Array<EventMatches>;
  /** An aggregate relationship */
  matchesAggregate: EventMatchesAggregate;
  updatedAt: Scalars['timestamptz'];
};


/** Note: This table may be overly structured with the foreign keys. Consider removing some if they're not needed. */
export type EventCourtsMatchesArgs = {
  distinctOn?: InputMaybe<Array<EventMatchesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventMatchesOrderBy>>;
  where?: InputMaybe<EventMatchesBoolExp>;
};


/** Note: This table may be overly structured with the foreign keys. Consider removing some if they're not needed. */
export type EventCourtsMatchesAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventMatchesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventMatchesOrderBy>>;
  where?: InputMaybe<EventMatchesBoolExp>;
};

/** aggregated selection of "event_courts" */
export type EventCourtsAggregate = {
  __typename?: 'EventCourtsAggregate';
  aggregate?: Maybe<EventCourtsAggregateFields>;
  nodes: Array<EventCourts>;
};

export type EventCourtsAggregateBoolExp = {
  count?: InputMaybe<EventCourtsAggregateBoolExpCount>;
};

/** aggregate fields of "event_courts" */
export type EventCourtsAggregateFields = {
  __typename?: 'EventCourtsAggregateFields';
  avg?: Maybe<EventCourtsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<EventCourtsMaxFields>;
  min?: Maybe<EventCourtsMinFields>;
  stddev?: Maybe<EventCourtsStddevFields>;
  stddevPop?: Maybe<EventCourtsStddevPopFields>;
  stddevSamp?: Maybe<EventCourtsStddevSampFields>;
  sum?: Maybe<EventCourtsSumFields>;
  varPop?: Maybe<EventCourtsVarPopFields>;
  varSamp?: Maybe<EventCourtsVarSampFields>;
  variance?: Maybe<EventCourtsVarianceFields>;
};


/** aggregate fields of "event_courts" */
export type EventCourtsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EventCourtsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "event_courts" */
export type EventCourtsAggregateOrderBy = {
  avg?: InputMaybe<EventCourtsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EventCourtsMaxOrderBy>;
  min?: InputMaybe<EventCourtsMinOrderBy>;
  stddev?: InputMaybe<EventCourtsStddevOrderBy>;
  stddevPop?: InputMaybe<EventCourtsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<EventCourtsStddevSampOrderBy>;
  sum?: InputMaybe<EventCourtsSumOrderBy>;
  varPop?: InputMaybe<EventCourtsVarPopOrderBy>;
  varSamp?: InputMaybe<EventCourtsVarSampOrderBy>;
  variance?: InputMaybe<EventCourtsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "event_courts" */
export type EventCourtsArrRelInsertInput = {
  data: Array<EventCourtsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<EventCourtsOnConflict>;
};

/** aggregate avg on columns */
export type EventCourtsAvgFields = {
  __typename?: 'EventCourtsAvgFields';
  courtNumber?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "event_courts" */
export type EventCourtsAvgOrderBy = {
  courtNumber?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "event_courts". All fields are combined with a logical 'AND'. */
export type EventCourtsBoolExp = {
  _and?: InputMaybe<Array<EventCourtsBoolExp>>;
  _not?: InputMaybe<EventCourtsBoolExp>;
  _or?: InputMaybe<Array<EventCourtsBoolExp>>;
  activeEventGroupId?: InputMaybe<UuidComparisonExp>;
  activeEventGroupPoolId?: InputMaybe<UuidComparisonExp>;
  activeGroup?: InputMaybe<EventGroupsBoolExp>;
  activeMatch?: InputMaybe<EventMatchesBoolExp>;
  activeMatchId?: InputMaybe<UuidComparisonExp>;
  activePool?: InputMaybe<EventGroupPoolsBoolExp>;
  courtName?: InputMaybe<StringComparisonExp>;
  courtNumber?: InputMaybe<IntComparisonExp>;
  courtStatus?: InputMaybe<EventCourtStatusesEnumComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  event?: InputMaybe<EventsBoolExp>;
  eventId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  matches?: InputMaybe<EventMatchesBoolExp>;
  matchesAggregate?: InputMaybe<EventMatchesAggregateBoolExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "event_courts" */
export enum EventCourtsConstraint {
  /** unique or primary key constraint on columns "court_number", "event_id" */
  EventCourtsEventIdCourtNumberKey = 'event_courts_event_id_court_number_key',
  /** unique or primary key constraint on columns "id" */
  EventCourtsPkey = 'event_courts_pkey'
}

/** input type for incrementing numeric columns in table "event_courts" */
export type EventCourtsIncInput = {
  courtNumber?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "event_courts" */
export type EventCourtsInsertInput = {
  activeEventGroupId?: InputMaybe<Scalars['uuid']>;
  activeEventGroupPoolId?: InputMaybe<Scalars['uuid']>;
  activeGroup?: InputMaybe<EventGroupsObjRelInsertInput>;
  activeMatch?: InputMaybe<EventMatchesObjRelInsertInput>;
  activeMatchId?: InputMaybe<Scalars['uuid']>;
  activePool?: InputMaybe<EventGroupPoolsObjRelInsertInput>;
  courtName?: InputMaybe<Scalars['String']>;
  courtNumber?: InputMaybe<Scalars['Int']>;
  courtStatus?: InputMaybe<EventCourtStatusesEnum>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  event?: InputMaybe<EventsObjRelInsertInput>;
  eventId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  matches?: InputMaybe<EventMatchesArrRelInsertInput>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type EventCourtsMaxFields = {
  __typename?: 'EventCourtsMaxFields';
  activeEventGroupId?: Maybe<Scalars['uuid']>;
  activeEventGroupPoolId?: Maybe<Scalars['uuid']>;
  activeMatchId?: Maybe<Scalars['uuid']>;
  courtName?: Maybe<Scalars['String']>;
  courtNumber?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  eventId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "event_courts" */
export type EventCourtsMaxOrderBy = {
  activeEventGroupId?: InputMaybe<OrderBy>;
  activeEventGroupPoolId?: InputMaybe<OrderBy>;
  activeMatchId?: InputMaybe<OrderBy>;
  courtName?: InputMaybe<OrderBy>;
  courtNumber?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  eventId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type EventCourtsMinFields = {
  __typename?: 'EventCourtsMinFields';
  activeEventGroupId?: Maybe<Scalars['uuid']>;
  activeEventGroupPoolId?: Maybe<Scalars['uuid']>;
  activeMatchId?: Maybe<Scalars['uuid']>;
  courtName?: Maybe<Scalars['String']>;
  courtNumber?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  eventId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "event_courts" */
export type EventCourtsMinOrderBy = {
  activeEventGroupId?: InputMaybe<OrderBy>;
  activeEventGroupPoolId?: InputMaybe<OrderBy>;
  activeMatchId?: InputMaybe<OrderBy>;
  courtName?: InputMaybe<OrderBy>;
  courtNumber?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  eventId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "event_courts" */
export type EventCourtsMutationResponse = {
  __typename?: 'EventCourtsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventCourts>;
};

/** input type for inserting object relation for remote table "event_courts" */
export type EventCourtsObjRelInsertInput = {
  data: EventCourtsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<EventCourtsOnConflict>;
};

/** on_conflict condition type for table "event_courts" */
export type EventCourtsOnConflict = {
  constraint: EventCourtsConstraint;
  updateColumns?: Array<EventCourtsUpdateColumn>;
  where?: InputMaybe<EventCourtsBoolExp>;
};

/** Ordering options when selecting data from "event_courts". */
export type EventCourtsOrderBy = {
  activeEventGroupId?: InputMaybe<OrderBy>;
  activeEventGroupPoolId?: InputMaybe<OrderBy>;
  activeGroup?: InputMaybe<EventGroupsOrderBy>;
  activeMatch?: InputMaybe<EventMatchesOrderBy>;
  activeMatchId?: InputMaybe<OrderBy>;
  activePool?: InputMaybe<EventGroupPoolsOrderBy>;
  courtName?: InputMaybe<OrderBy>;
  courtNumber?: InputMaybe<OrderBy>;
  courtStatus?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  event?: InputMaybe<EventsOrderBy>;
  eventId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  matchesAggregate?: InputMaybe<EventMatchesAggregateOrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: event_courts */
export type EventCourtsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "event_courts" */
export enum EventCourtsSelectColumn {
  /** column name */
  ActiveEventGroupId = 'activeEventGroupId',
  /** column name */
  ActiveEventGroupPoolId = 'activeEventGroupPoolId',
  /** column name */
  ActiveMatchId = 'activeMatchId',
  /** column name */
  CourtName = 'courtName',
  /** column name */
  CourtNumber = 'courtNumber',
  /** column name */
  CourtStatus = 'courtStatus',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EventId = 'eventId',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "event_courts" */
export type EventCourtsSetInput = {
  activeEventGroupId?: InputMaybe<Scalars['uuid']>;
  activeEventGroupPoolId?: InputMaybe<Scalars['uuid']>;
  activeMatchId?: InputMaybe<Scalars['uuid']>;
  courtName?: InputMaybe<Scalars['String']>;
  courtNumber?: InputMaybe<Scalars['Int']>;
  courtStatus?: InputMaybe<EventCourtStatusesEnum>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  eventId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type EventCourtsStddevFields = {
  __typename?: 'EventCourtsStddevFields';
  courtNumber?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "event_courts" */
export type EventCourtsStddevOrderBy = {
  courtNumber?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type EventCourtsStddevPopFields = {
  __typename?: 'EventCourtsStddevPopFields';
  courtNumber?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "event_courts" */
export type EventCourtsStddevPopOrderBy = {
  courtNumber?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type EventCourtsStddevSampFields = {
  __typename?: 'EventCourtsStddevSampFields';
  courtNumber?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "event_courts" */
export type EventCourtsStddevSampOrderBy = {
  courtNumber?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "event_courts" */
export type EventCourtsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventCourtsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventCourtsStreamCursorValueInput = {
  activeEventGroupId?: InputMaybe<Scalars['uuid']>;
  activeEventGroupPoolId?: InputMaybe<Scalars['uuid']>;
  activeMatchId?: InputMaybe<Scalars['uuid']>;
  courtName?: InputMaybe<Scalars['String']>;
  courtNumber?: InputMaybe<Scalars['Int']>;
  courtStatus?: InputMaybe<EventCourtStatusesEnum>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  eventId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type EventCourtsSumFields = {
  __typename?: 'EventCourtsSumFields';
  courtNumber?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "event_courts" */
export type EventCourtsSumOrderBy = {
  courtNumber?: InputMaybe<OrderBy>;
};

/** update columns of table "event_courts" */
export enum EventCourtsUpdateColumn {
  /** column name */
  ActiveEventGroupId = 'activeEventGroupId',
  /** column name */
  ActiveEventGroupPoolId = 'activeEventGroupPoolId',
  /** column name */
  ActiveMatchId = 'activeMatchId',
  /** column name */
  CourtName = 'courtName',
  /** column name */
  CourtNumber = 'courtNumber',
  /** column name */
  CourtStatus = 'courtStatus',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EventId = 'eventId',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type EventCourtsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<EventCourtsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventCourtsSetInput>;
  /** filter the rows which have to be updated */
  where: EventCourtsBoolExp;
};

/** aggregate varPop on columns */
export type EventCourtsVarPopFields = {
  __typename?: 'EventCourtsVarPopFields';
  courtNumber?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "event_courts" */
export type EventCourtsVarPopOrderBy = {
  courtNumber?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type EventCourtsVarSampFields = {
  __typename?: 'EventCourtsVarSampFields';
  courtNumber?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "event_courts" */
export type EventCourtsVarSampOrderBy = {
  courtNumber?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type EventCourtsVarianceFields = {
  __typename?: 'EventCourtsVarianceFields';
  courtNumber?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "event_courts" */
export type EventCourtsVarianceOrderBy = {
  courtNumber?: InputMaybe<OrderBy>;
};

/** columns and relationships of "event_faqs" */
export type EventFaqs = {
  __typename?: 'EventFaqs';
  answer: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  event: Events;
  eventId: Scalars['uuid'];
  id: Scalars['uuid'];
  question: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "event_faqs" */
export type EventFaqsAggregate = {
  __typename?: 'EventFaqsAggregate';
  aggregate?: Maybe<EventFaqsAggregateFields>;
  nodes: Array<EventFaqs>;
};

export type EventFaqsAggregateBoolExp = {
  count?: InputMaybe<EventFaqsAggregateBoolExpCount>;
};

/** aggregate fields of "event_faqs" */
export type EventFaqsAggregateFields = {
  __typename?: 'EventFaqsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<EventFaqsMaxFields>;
  min?: Maybe<EventFaqsMinFields>;
};


/** aggregate fields of "event_faqs" */
export type EventFaqsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EventFaqsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "event_faqs" */
export type EventFaqsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EventFaqsMaxOrderBy>;
  min?: InputMaybe<EventFaqsMinOrderBy>;
};

/** input type for inserting array relation for remote table "event_faqs" */
export type EventFaqsArrRelInsertInput = {
  data: Array<EventFaqsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<EventFaqsOnConflict>;
};

/** Boolean expression to filter rows from the table "event_faqs". All fields are combined with a logical 'AND'. */
export type EventFaqsBoolExp = {
  _and?: InputMaybe<Array<EventFaqsBoolExp>>;
  _not?: InputMaybe<EventFaqsBoolExp>;
  _or?: InputMaybe<Array<EventFaqsBoolExp>>;
  answer?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  event?: InputMaybe<EventsBoolExp>;
  eventId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  question?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "event_faqs" */
export enum EventFaqsConstraint {
  /** unique or primary key constraint on columns "id" */
  EventFaqsPkey = 'event_faqs_pkey'
}

/** input type for inserting data into table "event_faqs" */
export type EventFaqsInsertInput = {
  answer?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  event?: InputMaybe<EventsObjRelInsertInput>;
  eventId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  question?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type EventFaqsMaxFields = {
  __typename?: 'EventFaqsMaxFields';
  answer?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  eventId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  question?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "event_faqs" */
export type EventFaqsMaxOrderBy = {
  answer?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  eventId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  question?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type EventFaqsMinFields = {
  __typename?: 'EventFaqsMinFields';
  answer?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  eventId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  question?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "event_faqs" */
export type EventFaqsMinOrderBy = {
  answer?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  eventId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  question?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "event_faqs" */
export type EventFaqsMutationResponse = {
  __typename?: 'EventFaqsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventFaqs>;
};

/** on_conflict condition type for table "event_faqs" */
export type EventFaqsOnConflict = {
  constraint: EventFaqsConstraint;
  updateColumns?: Array<EventFaqsUpdateColumn>;
  where?: InputMaybe<EventFaqsBoolExp>;
};

/** Ordering options when selecting data from "event_faqs". */
export type EventFaqsOrderBy = {
  answer?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  event?: InputMaybe<EventsOrderBy>;
  eventId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  question?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: event_faqs */
export type EventFaqsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "event_faqs" */
export enum EventFaqsSelectColumn {
  /** column name */
  Answer = 'answer',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EventId = 'eventId',
  /** column name */
  Id = 'id',
  /** column name */
  Question = 'question',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "event_faqs" */
export type EventFaqsSetInput = {
  answer?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  eventId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  question?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "event_faqs" */
export type EventFaqsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventFaqsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventFaqsStreamCursorValueInput = {
  answer?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  eventId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  question?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "event_faqs" */
export enum EventFaqsUpdateColumn {
  /** column name */
  Answer = 'answer',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EventId = 'eventId',
  /** column name */
  Id = 'id',
  /** column name */
  Question = 'question',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type EventFaqsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventFaqsSetInput>;
  /** filter the rows which have to be updated */
  where: EventFaqsBoolExp;
};

/** NOTE: We are currently not using this table, but it was considered as there were many complex game and team structures discussed. For now we are storing scores in event_match_games, but we can backfill this one if needed. */
export type EventGameScores = {
  __typename?: 'EventGameScores';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  game: EventMatchGames;
  gameId: Scalars['uuid'];
  id: Scalars['uuid'];
  score: Scalars['Int'];
  /** An object relationship */
  team: EventTeams;
  teamId: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "event_game_scores" */
export type EventGameScoresAggregate = {
  __typename?: 'EventGameScoresAggregate';
  aggregate?: Maybe<EventGameScoresAggregateFields>;
  nodes: Array<EventGameScores>;
};

export type EventGameScoresAggregateBoolExp = {
  count?: InputMaybe<EventGameScoresAggregateBoolExpCount>;
};

/** aggregate fields of "event_game_scores" */
export type EventGameScoresAggregateFields = {
  __typename?: 'EventGameScoresAggregateFields';
  avg?: Maybe<EventGameScoresAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<EventGameScoresMaxFields>;
  min?: Maybe<EventGameScoresMinFields>;
  stddev?: Maybe<EventGameScoresStddevFields>;
  stddevPop?: Maybe<EventGameScoresStddevPopFields>;
  stddevSamp?: Maybe<EventGameScoresStddevSampFields>;
  sum?: Maybe<EventGameScoresSumFields>;
  varPop?: Maybe<EventGameScoresVarPopFields>;
  varSamp?: Maybe<EventGameScoresVarSampFields>;
  variance?: Maybe<EventGameScoresVarianceFields>;
};


/** aggregate fields of "event_game_scores" */
export type EventGameScoresAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EventGameScoresSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "event_game_scores" */
export type EventGameScoresAggregateOrderBy = {
  avg?: InputMaybe<EventGameScoresAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EventGameScoresMaxOrderBy>;
  min?: InputMaybe<EventGameScoresMinOrderBy>;
  stddev?: InputMaybe<EventGameScoresStddevOrderBy>;
  stddevPop?: InputMaybe<EventGameScoresStddevPopOrderBy>;
  stddevSamp?: InputMaybe<EventGameScoresStddevSampOrderBy>;
  sum?: InputMaybe<EventGameScoresSumOrderBy>;
  varPop?: InputMaybe<EventGameScoresVarPopOrderBy>;
  varSamp?: InputMaybe<EventGameScoresVarSampOrderBy>;
  variance?: InputMaybe<EventGameScoresVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "event_game_scores" */
export type EventGameScoresArrRelInsertInput = {
  data: Array<EventGameScoresInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<EventGameScoresOnConflict>;
};

/** aggregate avg on columns */
export type EventGameScoresAvgFields = {
  __typename?: 'EventGameScoresAvgFields';
  score?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "event_game_scores" */
export type EventGameScoresAvgOrderBy = {
  score?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "event_game_scores". All fields are combined with a logical 'AND'. */
export type EventGameScoresBoolExp = {
  _and?: InputMaybe<Array<EventGameScoresBoolExp>>;
  _not?: InputMaybe<EventGameScoresBoolExp>;
  _or?: InputMaybe<Array<EventGameScoresBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  game?: InputMaybe<EventMatchGamesBoolExp>;
  gameId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  score?: InputMaybe<IntComparisonExp>;
  team?: InputMaybe<EventTeamsBoolExp>;
  teamId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "event_game_scores" */
export enum EventGameScoresConstraint {
  /** unique or primary key constraint on columns "game_id", "team_id" */
  EventGameScoresGameIdTeamIdKey = 'event_game_scores_game_id_team_id_key',
  /** unique or primary key constraint on columns "id" */
  EventGameScoresPkey = 'event_game_scores_pkey'
}

/** input type for incrementing numeric columns in table "event_game_scores" */
export type EventGameScoresIncInput = {
  score?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "event_game_scores" */
export type EventGameScoresInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  game?: InputMaybe<EventMatchGamesObjRelInsertInput>;
  gameId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  score?: InputMaybe<Scalars['Int']>;
  team?: InputMaybe<EventTeamsObjRelInsertInput>;
  teamId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type EventGameScoresMaxFields = {
  __typename?: 'EventGameScoresMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  gameId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  score?: Maybe<Scalars['Int']>;
  teamId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "event_game_scores" */
export type EventGameScoresMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  gameId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  score?: InputMaybe<OrderBy>;
  teamId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type EventGameScoresMinFields = {
  __typename?: 'EventGameScoresMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  gameId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  score?: Maybe<Scalars['Int']>;
  teamId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "event_game_scores" */
export type EventGameScoresMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  gameId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  score?: InputMaybe<OrderBy>;
  teamId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "event_game_scores" */
export type EventGameScoresMutationResponse = {
  __typename?: 'EventGameScoresMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventGameScores>;
};

/** on_conflict condition type for table "event_game_scores" */
export type EventGameScoresOnConflict = {
  constraint: EventGameScoresConstraint;
  updateColumns?: Array<EventGameScoresUpdateColumn>;
  where?: InputMaybe<EventGameScoresBoolExp>;
};

/** Ordering options when selecting data from "event_game_scores". */
export type EventGameScoresOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  game?: InputMaybe<EventMatchGamesOrderBy>;
  gameId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  score?: InputMaybe<OrderBy>;
  team?: InputMaybe<EventTeamsOrderBy>;
  teamId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: event_game_scores */
export type EventGameScoresPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "event_game_scores" */
export enum EventGameScoresSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  GameId = 'gameId',
  /** column name */
  Id = 'id',
  /** column name */
  Score = 'score',
  /** column name */
  TeamId = 'teamId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "event_game_scores" */
export type EventGameScoresSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  gameId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  score?: InputMaybe<Scalars['Int']>;
  teamId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type EventGameScoresStddevFields = {
  __typename?: 'EventGameScoresStddevFields';
  score?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "event_game_scores" */
export type EventGameScoresStddevOrderBy = {
  score?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type EventGameScoresStddevPopFields = {
  __typename?: 'EventGameScoresStddevPopFields';
  score?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "event_game_scores" */
export type EventGameScoresStddevPopOrderBy = {
  score?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type EventGameScoresStddevSampFields = {
  __typename?: 'EventGameScoresStddevSampFields';
  score?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "event_game_scores" */
export type EventGameScoresStddevSampOrderBy = {
  score?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "event_game_scores" */
export type EventGameScoresStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventGameScoresStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventGameScoresStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  gameId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  score?: InputMaybe<Scalars['Int']>;
  teamId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type EventGameScoresSumFields = {
  __typename?: 'EventGameScoresSumFields';
  score?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "event_game_scores" */
export type EventGameScoresSumOrderBy = {
  score?: InputMaybe<OrderBy>;
};

/** update columns of table "event_game_scores" */
export enum EventGameScoresUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  GameId = 'gameId',
  /** column name */
  Id = 'id',
  /** column name */
  Score = 'score',
  /** column name */
  TeamId = 'teamId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type EventGameScoresUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<EventGameScoresIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventGameScoresSetInput>;
  /** filter the rows which have to be updated */
  where: EventGameScoresBoolExp;
};

/** aggregate varPop on columns */
export type EventGameScoresVarPopFields = {
  __typename?: 'EventGameScoresVarPopFields';
  score?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "event_game_scores" */
export type EventGameScoresVarPopOrderBy = {
  score?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type EventGameScoresVarSampFields = {
  __typename?: 'EventGameScoresVarSampFields';
  score?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "event_game_scores" */
export type EventGameScoresVarSampOrderBy = {
  score?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type EventGameScoresVarianceFields = {
  __typename?: 'EventGameScoresVarianceFields';
  score?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "event_game_scores" */
export type EventGameScoresVarianceOrderBy = {
  score?: InputMaybe<OrderBy>;
};

/** columns and relationships of "event_group_formats" */
export type EventGroupFormats = {
  __typename?: 'EventGroupFormats';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "event_group_formats" */
export type EventGroupFormatsAggregate = {
  __typename?: 'EventGroupFormatsAggregate';
  aggregate?: Maybe<EventGroupFormatsAggregateFields>;
  nodes: Array<EventGroupFormats>;
};

/** aggregate fields of "event_group_formats" */
export type EventGroupFormatsAggregateFields = {
  __typename?: 'EventGroupFormatsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<EventGroupFormatsMaxFields>;
  min?: Maybe<EventGroupFormatsMinFields>;
};


/** aggregate fields of "event_group_formats" */
export type EventGroupFormatsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EventGroupFormatsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "event_group_formats". All fields are combined with a logical 'AND'. */
export type EventGroupFormatsBoolExp = {
  _and?: InputMaybe<Array<EventGroupFormatsBoolExp>>;
  _not?: InputMaybe<EventGroupFormatsBoolExp>;
  _or?: InputMaybe<Array<EventGroupFormatsBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "event_group_formats" */
export enum EventGroupFormatsConstraint {
  /** unique or primary key constraint on columns "value" */
  EventGroupFormatsPkey = 'event_group_formats_pkey'
}

export enum EventGroupFormatsEnum {
  Custom = 'CUSTOM',
  League = 'LEAGUE',
  RoundRobin = 'ROUND_ROBIN',
  RoundRobinSingleElimination = 'ROUND_ROBIN_SINGLE_ELIMINATION',
  SingleElimination = 'SINGLE_ELIMINATION',
  VairRoundRobin = 'VAIR_ROUND_ROBIN'
}

/** Boolean expression to compare columns of type "EventGroupFormatsEnum". All fields are combined with logical 'AND'. */
export type EventGroupFormatsEnumComparisonExp = {
  _eq?: InputMaybe<EventGroupFormatsEnum>;
  _in?: InputMaybe<Array<EventGroupFormatsEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<EventGroupFormatsEnum>;
  _nin?: InputMaybe<Array<EventGroupFormatsEnum>>;
};

/** input type for inserting data into table "event_group_formats" */
export type EventGroupFormatsInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type EventGroupFormatsMaxFields = {
  __typename?: 'EventGroupFormatsMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type EventGroupFormatsMinFields = {
  __typename?: 'EventGroupFormatsMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "event_group_formats" */
export type EventGroupFormatsMutationResponse = {
  __typename?: 'EventGroupFormatsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventGroupFormats>;
};

/** on_conflict condition type for table "event_group_formats" */
export type EventGroupFormatsOnConflict = {
  constraint: EventGroupFormatsConstraint;
  updateColumns?: Array<EventGroupFormatsUpdateColumn>;
  where?: InputMaybe<EventGroupFormatsBoolExp>;
};

/** Ordering options when selecting data from "event_group_formats". */
export type EventGroupFormatsOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: event_group_formats */
export type EventGroupFormatsPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "event_group_formats" */
export enum EventGroupFormatsSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "event_group_formats" */
export type EventGroupFormatsSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "event_group_formats" */
export type EventGroupFormatsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventGroupFormatsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventGroupFormatsStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "event_group_formats" */
export enum EventGroupFormatsUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type EventGroupFormatsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventGroupFormatsSetInput>;
  /** filter the rows which have to be updated */
  where: EventGroupFormatsBoolExp;
};

/** columns and relationships of "event_group_merges" */
export type EventGroupMerges = {
  __typename?: 'EventGroupMerges';
  /** An object relationship */
  baseGroup: EventGroups;
  baseGroupId: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  event: Events;
  eventId: Scalars['uuid'];
  /** An array relationship */
  groups: Array<EventGroups>;
  /** An aggregate relationship */
  groupsAggregate: EventGroupsAggregate;
  id: Scalars['uuid'];
  unmergeForKnockout: Scalars['Boolean'];
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "event_group_merges" */
export type EventGroupMergesGroupsArgs = {
  distinctOn?: InputMaybe<Array<EventGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGroupsOrderBy>>;
  where?: InputMaybe<EventGroupsBoolExp>;
};


/** columns and relationships of "event_group_merges" */
export type EventGroupMergesGroupsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGroupsOrderBy>>;
  where?: InputMaybe<EventGroupsBoolExp>;
};

/** aggregated selection of "event_group_merges" */
export type EventGroupMergesAggregate = {
  __typename?: 'EventGroupMergesAggregate';
  aggregate?: Maybe<EventGroupMergesAggregateFields>;
  nodes: Array<EventGroupMerges>;
};

/** aggregate fields of "event_group_merges" */
export type EventGroupMergesAggregateFields = {
  __typename?: 'EventGroupMergesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<EventGroupMergesMaxFields>;
  min?: Maybe<EventGroupMergesMinFields>;
};


/** aggregate fields of "event_group_merges" */
export type EventGroupMergesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EventGroupMergesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "event_group_merges". All fields are combined with a logical 'AND'. */
export type EventGroupMergesBoolExp = {
  _and?: InputMaybe<Array<EventGroupMergesBoolExp>>;
  _not?: InputMaybe<EventGroupMergesBoolExp>;
  _or?: InputMaybe<Array<EventGroupMergesBoolExp>>;
  baseGroup?: InputMaybe<EventGroupsBoolExp>;
  baseGroupId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  event?: InputMaybe<EventsBoolExp>;
  eventId?: InputMaybe<UuidComparisonExp>;
  groups?: InputMaybe<EventGroupsBoolExp>;
  groupsAggregate?: InputMaybe<EventGroupsAggregateBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  unmergeForKnockout?: InputMaybe<BooleanComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "event_group_merges" */
export enum EventGroupMergesConstraint {
  /** unique or primary key constraint on columns "id" */
  EventGroupMergesPkey = 'event_group_merges_pkey'
}

/** input type for inserting data into table "event_group_merges" */
export type EventGroupMergesInsertInput = {
  baseGroup?: InputMaybe<EventGroupsObjRelInsertInput>;
  baseGroupId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  event?: InputMaybe<EventsObjRelInsertInput>;
  eventId?: InputMaybe<Scalars['uuid']>;
  groups?: InputMaybe<EventGroupsArrRelInsertInput>;
  id?: InputMaybe<Scalars['uuid']>;
  unmergeForKnockout?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type EventGroupMergesMaxFields = {
  __typename?: 'EventGroupMergesMaxFields';
  baseGroupId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  eventId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type EventGroupMergesMinFields = {
  __typename?: 'EventGroupMergesMinFields';
  baseGroupId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  eventId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "event_group_merges" */
export type EventGroupMergesMutationResponse = {
  __typename?: 'EventGroupMergesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventGroupMerges>;
};

/** input type for inserting object relation for remote table "event_group_merges" */
export type EventGroupMergesObjRelInsertInput = {
  data: EventGroupMergesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<EventGroupMergesOnConflict>;
};

/** on_conflict condition type for table "event_group_merges" */
export type EventGroupMergesOnConflict = {
  constraint: EventGroupMergesConstraint;
  updateColumns?: Array<EventGroupMergesUpdateColumn>;
  where?: InputMaybe<EventGroupMergesBoolExp>;
};

/** Ordering options when selecting data from "event_group_merges". */
export type EventGroupMergesOrderBy = {
  baseGroup?: InputMaybe<EventGroupsOrderBy>;
  baseGroupId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  event?: InputMaybe<EventsOrderBy>;
  eventId?: InputMaybe<OrderBy>;
  groupsAggregate?: InputMaybe<EventGroupsAggregateOrderBy>;
  id?: InputMaybe<OrderBy>;
  unmergeForKnockout?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: event_group_merges */
export type EventGroupMergesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "event_group_merges" */
export enum EventGroupMergesSelectColumn {
  /** column name */
  BaseGroupId = 'baseGroupId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EventId = 'eventId',
  /** column name */
  Id = 'id',
  /** column name */
  UnmergeForKnockout = 'unmergeForKnockout',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "event_group_merges" */
export type EventGroupMergesSetInput = {
  baseGroupId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  eventId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  unmergeForKnockout?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "event_group_merges" */
export type EventGroupMergesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventGroupMergesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventGroupMergesStreamCursorValueInput = {
  baseGroupId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  eventId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  unmergeForKnockout?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "event_group_merges" */
export enum EventGroupMergesUpdateColumn {
  /** column name */
  BaseGroupId = 'baseGroupId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EventId = 'eventId',
  /** column name */
  Id = 'id',
  /** column name */
  UnmergeForKnockout = 'unmergeForKnockout',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type EventGroupMergesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventGroupMergesSetInput>;
  /** filter the rows which have to be updated */
  where: EventGroupMergesBoolExp;
};

/** columns and relationships of "event_group_pools" */
export type EventGroupPools = {
  __typename?: 'EventGroupPools';
  /** An array relationship */
  courts: Array<EventCourts>;
  /** An aggregate relationship */
  courtsAggregate: EventCourtsAggregate;
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  endsAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  group: EventGroups;
  groupId: Scalars['uuid'];
  id: Scalars['uuid'];
  /** An array relationship */
  matches: Array<EventMatches>;
  /** An aggregate relationship */
  matchesAggregate: EventMatchesAggregate;
  /** An array relationship */
  rounds: Array<EventPoolRounds>;
  /** An aggregate relationship */
  roundsAggregate: EventPoolRoundsAggregate;
  /** An object relationship */
  sequence: EventGroupSequences;
  sequenceId: Scalars['uuid'];
  startsAt?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  teams: Array<EventPoolsTeams>;
  /** An aggregate relationship */
  teamsAggregate: EventPoolsTeamsAggregate;
  title: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "event_group_pools" */
export type EventGroupPoolsCourtsArgs = {
  distinctOn?: InputMaybe<Array<EventCourtsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventCourtsOrderBy>>;
  where?: InputMaybe<EventCourtsBoolExp>;
};


/** columns and relationships of "event_group_pools" */
export type EventGroupPoolsCourtsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventCourtsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventCourtsOrderBy>>;
  where?: InputMaybe<EventCourtsBoolExp>;
};


/** columns and relationships of "event_group_pools" */
export type EventGroupPoolsMatchesArgs = {
  distinctOn?: InputMaybe<Array<EventMatchesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventMatchesOrderBy>>;
  where?: InputMaybe<EventMatchesBoolExp>;
};


/** columns and relationships of "event_group_pools" */
export type EventGroupPoolsMatchesAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventMatchesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventMatchesOrderBy>>;
  where?: InputMaybe<EventMatchesBoolExp>;
};


/** columns and relationships of "event_group_pools" */
export type EventGroupPoolsRoundsArgs = {
  distinctOn?: InputMaybe<Array<EventPoolRoundsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventPoolRoundsOrderBy>>;
  where?: InputMaybe<EventPoolRoundsBoolExp>;
};


/** columns and relationships of "event_group_pools" */
export type EventGroupPoolsRoundsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventPoolRoundsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventPoolRoundsOrderBy>>;
  where?: InputMaybe<EventPoolRoundsBoolExp>;
};


/** columns and relationships of "event_group_pools" */
export type EventGroupPoolsTeamsArgs = {
  distinctOn?: InputMaybe<Array<EventPoolsTeamsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventPoolsTeamsOrderBy>>;
  where?: InputMaybe<EventPoolsTeamsBoolExp>;
};


/** columns and relationships of "event_group_pools" */
export type EventGroupPoolsTeamsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventPoolsTeamsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventPoolsTeamsOrderBy>>;
  where?: InputMaybe<EventPoolsTeamsBoolExp>;
};

/** aggregated selection of "event_group_pools" */
export type EventGroupPoolsAggregate = {
  __typename?: 'EventGroupPoolsAggregate';
  aggregate?: Maybe<EventGroupPoolsAggregateFields>;
  nodes: Array<EventGroupPools>;
};

export type EventGroupPoolsAggregateBoolExp = {
  count?: InputMaybe<EventGroupPoolsAggregateBoolExpCount>;
};

/** aggregate fields of "event_group_pools" */
export type EventGroupPoolsAggregateFields = {
  __typename?: 'EventGroupPoolsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<EventGroupPoolsMaxFields>;
  min?: Maybe<EventGroupPoolsMinFields>;
};


/** aggregate fields of "event_group_pools" */
export type EventGroupPoolsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EventGroupPoolsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "event_group_pools" */
export type EventGroupPoolsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EventGroupPoolsMaxOrderBy>;
  min?: InputMaybe<EventGroupPoolsMinOrderBy>;
};

/** input type for inserting array relation for remote table "event_group_pools" */
export type EventGroupPoolsArrRelInsertInput = {
  data: Array<EventGroupPoolsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<EventGroupPoolsOnConflict>;
};

/** Boolean expression to filter rows from the table "event_group_pools". All fields are combined with a logical 'AND'. */
export type EventGroupPoolsBoolExp = {
  _and?: InputMaybe<Array<EventGroupPoolsBoolExp>>;
  _not?: InputMaybe<EventGroupPoolsBoolExp>;
  _or?: InputMaybe<Array<EventGroupPoolsBoolExp>>;
  courts?: InputMaybe<EventCourtsBoolExp>;
  courtsAggregate?: InputMaybe<EventCourtsAggregateBoolExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  endsAt?: InputMaybe<TimestamptzComparisonExp>;
  group?: InputMaybe<EventGroupsBoolExp>;
  groupId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  matches?: InputMaybe<EventMatchesBoolExp>;
  matchesAggregate?: InputMaybe<EventMatchesAggregateBoolExp>;
  rounds?: InputMaybe<EventPoolRoundsBoolExp>;
  roundsAggregate?: InputMaybe<EventPoolRoundsAggregateBoolExp>;
  sequence?: InputMaybe<EventGroupSequencesBoolExp>;
  sequenceId?: InputMaybe<UuidComparisonExp>;
  startsAt?: InputMaybe<TimestamptzComparisonExp>;
  teams?: InputMaybe<EventPoolsTeamsBoolExp>;
  teamsAggregate?: InputMaybe<EventPoolsTeamsAggregateBoolExp>;
  title?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "event_group_pools" */
export enum EventGroupPoolsConstraint {
  /** unique or primary key constraint on columns "id" */
  EventGroupPoolsPkey = 'event_group_pools_pkey'
}

/** input type for inserting data into table "event_group_pools" */
export type EventGroupPoolsInsertInput = {
  courts?: InputMaybe<EventCourtsArrRelInsertInput>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  endsAt?: InputMaybe<Scalars['timestamptz']>;
  group?: InputMaybe<EventGroupsObjRelInsertInput>;
  groupId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  matches?: InputMaybe<EventMatchesArrRelInsertInput>;
  rounds?: InputMaybe<EventPoolRoundsArrRelInsertInput>;
  sequence?: InputMaybe<EventGroupSequencesObjRelInsertInput>;
  sequenceId?: InputMaybe<Scalars['uuid']>;
  startsAt?: InputMaybe<Scalars['timestamptz']>;
  teams?: InputMaybe<EventPoolsTeamsArrRelInsertInput>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type EventGroupPoolsMaxFields = {
  __typename?: 'EventGroupPoolsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  endsAt?: Maybe<Scalars['timestamptz']>;
  groupId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  sequenceId?: Maybe<Scalars['uuid']>;
  startsAt?: Maybe<Scalars['timestamptz']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "event_group_pools" */
export type EventGroupPoolsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  endsAt?: InputMaybe<OrderBy>;
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  sequenceId?: InputMaybe<OrderBy>;
  startsAt?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type EventGroupPoolsMinFields = {
  __typename?: 'EventGroupPoolsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  endsAt?: Maybe<Scalars['timestamptz']>;
  groupId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  sequenceId?: Maybe<Scalars['uuid']>;
  startsAt?: Maybe<Scalars['timestamptz']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "event_group_pools" */
export type EventGroupPoolsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  endsAt?: InputMaybe<OrderBy>;
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  sequenceId?: InputMaybe<OrderBy>;
  startsAt?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "event_group_pools" */
export type EventGroupPoolsMutationResponse = {
  __typename?: 'EventGroupPoolsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventGroupPools>;
};

/** input type for inserting object relation for remote table "event_group_pools" */
export type EventGroupPoolsObjRelInsertInput = {
  data: EventGroupPoolsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<EventGroupPoolsOnConflict>;
};

/** on_conflict condition type for table "event_group_pools" */
export type EventGroupPoolsOnConflict = {
  constraint: EventGroupPoolsConstraint;
  updateColumns?: Array<EventGroupPoolsUpdateColumn>;
  where?: InputMaybe<EventGroupPoolsBoolExp>;
};

/** Ordering options when selecting data from "event_group_pools". */
export type EventGroupPoolsOrderBy = {
  courtsAggregate?: InputMaybe<EventCourtsAggregateOrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  endsAt?: InputMaybe<OrderBy>;
  group?: InputMaybe<EventGroupsOrderBy>;
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  matchesAggregate?: InputMaybe<EventMatchesAggregateOrderBy>;
  roundsAggregate?: InputMaybe<EventPoolRoundsAggregateOrderBy>;
  sequence?: InputMaybe<EventGroupSequencesOrderBy>;
  sequenceId?: InputMaybe<OrderBy>;
  startsAt?: InputMaybe<OrderBy>;
  teamsAggregate?: InputMaybe<EventPoolsTeamsAggregateOrderBy>;
  title?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: event_group_pools */
export type EventGroupPoolsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "event_group_pools" */
export enum EventGroupPoolsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EndsAt = 'endsAt',
  /** column name */
  GroupId = 'groupId',
  /** column name */
  Id = 'id',
  /** column name */
  SequenceId = 'sequenceId',
  /** column name */
  StartsAt = 'startsAt',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "event_group_pools" */
export type EventGroupPoolsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  endsAt?: InputMaybe<Scalars['timestamptz']>;
  groupId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  sequenceId?: InputMaybe<Scalars['uuid']>;
  startsAt?: InputMaybe<Scalars['timestamptz']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "event_group_pools" */
export type EventGroupPoolsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventGroupPoolsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventGroupPoolsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  endsAt?: InputMaybe<Scalars['timestamptz']>;
  groupId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  sequenceId?: InputMaybe<Scalars['uuid']>;
  startsAt?: InputMaybe<Scalars['timestamptz']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "event_group_pools" */
export enum EventGroupPoolsUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EndsAt = 'endsAt',
  /** column name */
  GroupId = 'groupId',
  /** column name */
  Id = 'id',
  /** column name */
  SequenceId = 'sequenceId',
  /** column name */
  StartsAt = 'startsAt',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type EventGroupPoolsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventGroupPoolsSetInput>;
  /** filter the rows which have to be updated */
  where: EventGroupPoolsBoolExp;
};

/** columns and relationships of "event_group_rating_scales" */
export type EventGroupRatingScales = {
  __typename?: 'EventGroupRatingScales';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  eventGroup: EventGroups;
  eventGroupId: Scalars['uuid'];
  id: Scalars['uuid'];
  maximumRating?: Maybe<Scalars['numeric']>;
  minimumRating?: Maybe<Scalars['numeric']>;
  /** An object relationship */
  padelRatingScale?: Maybe<PadelRatingScales>;
  padelRatingScaleId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  pickleballRatingScale?: Maybe<PickleballRatingScales>;
  pickleballRatingScaleId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  tennisRatingScale?: Maybe<TennisRatingScales>;
  tennisRatingScaleId?: Maybe<Scalars['uuid']>;
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "event_group_rating_scales" */
export type EventGroupRatingScalesAggregate = {
  __typename?: 'EventGroupRatingScalesAggregate';
  aggregate?: Maybe<EventGroupRatingScalesAggregateFields>;
  nodes: Array<EventGroupRatingScales>;
};

export type EventGroupRatingScalesAggregateBoolExp = {
  count?: InputMaybe<EventGroupRatingScalesAggregateBoolExpCount>;
};

/** aggregate fields of "event_group_rating_scales" */
export type EventGroupRatingScalesAggregateFields = {
  __typename?: 'EventGroupRatingScalesAggregateFields';
  avg?: Maybe<EventGroupRatingScalesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<EventGroupRatingScalesMaxFields>;
  min?: Maybe<EventGroupRatingScalesMinFields>;
  stddev?: Maybe<EventGroupRatingScalesStddevFields>;
  stddevPop?: Maybe<EventGroupRatingScalesStddevPopFields>;
  stddevSamp?: Maybe<EventGroupRatingScalesStddevSampFields>;
  sum?: Maybe<EventGroupRatingScalesSumFields>;
  varPop?: Maybe<EventGroupRatingScalesVarPopFields>;
  varSamp?: Maybe<EventGroupRatingScalesVarSampFields>;
  variance?: Maybe<EventGroupRatingScalesVarianceFields>;
};


/** aggregate fields of "event_group_rating_scales" */
export type EventGroupRatingScalesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EventGroupRatingScalesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "event_group_rating_scales" */
export type EventGroupRatingScalesAggregateOrderBy = {
  avg?: InputMaybe<EventGroupRatingScalesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EventGroupRatingScalesMaxOrderBy>;
  min?: InputMaybe<EventGroupRatingScalesMinOrderBy>;
  stddev?: InputMaybe<EventGroupRatingScalesStddevOrderBy>;
  stddevPop?: InputMaybe<EventGroupRatingScalesStddevPopOrderBy>;
  stddevSamp?: InputMaybe<EventGroupRatingScalesStddevSampOrderBy>;
  sum?: InputMaybe<EventGroupRatingScalesSumOrderBy>;
  varPop?: InputMaybe<EventGroupRatingScalesVarPopOrderBy>;
  varSamp?: InputMaybe<EventGroupRatingScalesVarSampOrderBy>;
  variance?: InputMaybe<EventGroupRatingScalesVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "event_group_rating_scales" */
export type EventGroupRatingScalesArrRelInsertInput = {
  data: Array<EventGroupRatingScalesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<EventGroupRatingScalesOnConflict>;
};

/** aggregate avg on columns */
export type EventGroupRatingScalesAvgFields = {
  __typename?: 'EventGroupRatingScalesAvgFields';
  maximumRating?: Maybe<Scalars['Float']>;
  minimumRating?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "event_group_rating_scales" */
export type EventGroupRatingScalesAvgOrderBy = {
  maximumRating?: InputMaybe<OrderBy>;
  minimumRating?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "event_group_rating_scales". All fields are combined with a logical 'AND'. */
export type EventGroupRatingScalesBoolExp = {
  _and?: InputMaybe<Array<EventGroupRatingScalesBoolExp>>;
  _not?: InputMaybe<EventGroupRatingScalesBoolExp>;
  _or?: InputMaybe<Array<EventGroupRatingScalesBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  eventGroup?: InputMaybe<EventGroupsBoolExp>;
  eventGroupId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  maximumRating?: InputMaybe<NumericComparisonExp>;
  minimumRating?: InputMaybe<NumericComparisonExp>;
  padelRatingScale?: InputMaybe<PadelRatingScalesBoolExp>;
  padelRatingScaleId?: InputMaybe<UuidComparisonExp>;
  pickleballRatingScale?: InputMaybe<PickleballRatingScalesBoolExp>;
  pickleballRatingScaleId?: InputMaybe<UuidComparisonExp>;
  tennisRatingScale?: InputMaybe<TennisRatingScalesBoolExp>;
  tennisRatingScaleId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "event_group_rating_scales" */
export enum EventGroupRatingScalesConstraint {
  /** unique or primary key constraint on columns "padel_rating_scale_id", "event_group_id" */
  EventGroupRatingScalesEventGroupIdPadelRatingScaleKey = 'event_group_rating_scales_event_group_id_padel_rating_scale_key',
  /** unique or primary key constraint on columns "pickleball_rating_scale_id", "event_group_id" */
  EventGroupRatingScalesEventGroupIdPickleballRatingKey = 'event_group_rating_scales_event_group_id_pickleball_rating__key',
  /** unique or primary key constraint on columns "tennis_rating_scale_id", "event_group_id" */
  EventGroupRatingScalesEventGroupIdTennisRatingScalKey = 'event_group_rating_scales_event_group_id_tennis_rating_scal_key',
  /** unique or primary key constraint on columns "id" */
  EventGroupRatingScalesPkey = 'event_group_rating_scales_pkey'
}

/** input type for incrementing numeric columns in table "event_group_rating_scales" */
export type EventGroupRatingScalesIncInput = {
  maximumRating?: InputMaybe<Scalars['numeric']>;
  minimumRating?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "event_group_rating_scales" */
export type EventGroupRatingScalesInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  eventGroup?: InputMaybe<EventGroupsObjRelInsertInput>;
  eventGroupId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  maximumRating?: InputMaybe<Scalars['numeric']>;
  minimumRating?: InputMaybe<Scalars['numeric']>;
  padelRatingScale?: InputMaybe<PadelRatingScalesObjRelInsertInput>;
  padelRatingScaleId?: InputMaybe<Scalars['uuid']>;
  pickleballRatingScale?: InputMaybe<PickleballRatingScalesObjRelInsertInput>;
  pickleballRatingScaleId?: InputMaybe<Scalars['uuid']>;
  tennisRatingScale?: InputMaybe<TennisRatingScalesObjRelInsertInput>;
  tennisRatingScaleId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type EventGroupRatingScalesMaxFields = {
  __typename?: 'EventGroupRatingScalesMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  eventGroupId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  maximumRating?: Maybe<Scalars['numeric']>;
  minimumRating?: Maybe<Scalars['numeric']>;
  padelRatingScaleId?: Maybe<Scalars['uuid']>;
  pickleballRatingScaleId?: Maybe<Scalars['uuid']>;
  tennisRatingScaleId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "event_group_rating_scales" */
export type EventGroupRatingScalesMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  eventGroupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  maximumRating?: InputMaybe<OrderBy>;
  minimumRating?: InputMaybe<OrderBy>;
  padelRatingScaleId?: InputMaybe<OrderBy>;
  pickleballRatingScaleId?: InputMaybe<OrderBy>;
  tennisRatingScaleId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type EventGroupRatingScalesMinFields = {
  __typename?: 'EventGroupRatingScalesMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  eventGroupId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  maximumRating?: Maybe<Scalars['numeric']>;
  minimumRating?: Maybe<Scalars['numeric']>;
  padelRatingScaleId?: Maybe<Scalars['uuid']>;
  pickleballRatingScaleId?: Maybe<Scalars['uuid']>;
  tennisRatingScaleId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "event_group_rating_scales" */
export type EventGroupRatingScalesMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  eventGroupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  maximumRating?: InputMaybe<OrderBy>;
  minimumRating?: InputMaybe<OrderBy>;
  padelRatingScaleId?: InputMaybe<OrderBy>;
  pickleballRatingScaleId?: InputMaybe<OrderBy>;
  tennisRatingScaleId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "event_group_rating_scales" */
export type EventGroupRatingScalesMutationResponse = {
  __typename?: 'EventGroupRatingScalesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventGroupRatingScales>;
};

/** on_conflict condition type for table "event_group_rating_scales" */
export type EventGroupRatingScalesOnConflict = {
  constraint: EventGroupRatingScalesConstraint;
  updateColumns?: Array<EventGroupRatingScalesUpdateColumn>;
  where?: InputMaybe<EventGroupRatingScalesBoolExp>;
};

/** Ordering options when selecting data from "event_group_rating_scales". */
export type EventGroupRatingScalesOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  eventGroup?: InputMaybe<EventGroupsOrderBy>;
  eventGroupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  maximumRating?: InputMaybe<OrderBy>;
  minimumRating?: InputMaybe<OrderBy>;
  padelRatingScale?: InputMaybe<PadelRatingScalesOrderBy>;
  padelRatingScaleId?: InputMaybe<OrderBy>;
  pickleballRatingScale?: InputMaybe<PickleballRatingScalesOrderBy>;
  pickleballRatingScaleId?: InputMaybe<OrderBy>;
  tennisRatingScale?: InputMaybe<TennisRatingScalesOrderBy>;
  tennisRatingScaleId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: event_group_rating_scales */
export type EventGroupRatingScalesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "event_group_rating_scales" */
export enum EventGroupRatingScalesSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EventGroupId = 'eventGroupId',
  /** column name */
  Id = 'id',
  /** column name */
  MaximumRating = 'maximumRating',
  /** column name */
  MinimumRating = 'minimumRating',
  /** column name */
  PadelRatingScaleId = 'padelRatingScaleId',
  /** column name */
  PickleballRatingScaleId = 'pickleballRatingScaleId',
  /** column name */
  TennisRatingScaleId = 'tennisRatingScaleId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "event_group_rating_scales" */
export type EventGroupRatingScalesSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  eventGroupId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  maximumRating?: InputMaybe<Scalars['numeric']>;
  minimumRating?: InputMaybe<Scalars['numeric']>;
  padelRatingScaleId?: InputMaybe<Scalars['uuid']>;
  pickleballRatingScaleId?: InputMaybe<Scalars['uuid']>;
  tennisRatingScaleId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type EventGroupRatingScalesStddevFields = {
  __typename?: 'EventGroupRatingScalesStddevFields';
  maximumRating?: Maybe<Scalars['Float']>;
  minimumRating?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "event_group_rating_scales" */
export type EventGroupRatingScalesStddevOrderBy = {
  maximumRating?: InputMaybe<OrderBy>;
  minimumRating?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type EventGroupRatingScalesStddevPopFields = {
  __typename?: 'EventGroupRatingScalesStddevPopFields';
  maximumRating?: Maybe<Scalars['Float']>;
  minimumRating?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "event_group_rating_scales" */
export type EventGroupRatingScalesStddevPopOrderBy = {
  maximumRating?: InputMaybe<OrderBy>;
  minimumRating?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type EventGroupRatingScalesStddevSampFields = {
  __typename?: 'EventGroupRatingScalesStddevSampFields';
  maximumRating?: Maybe<Scalars['Float']>;
  minimumRating?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "event_group_rating_scales" */
export type EventGroupRatingScalesStddevSampOrderBy = {
  maximumRating?: InputMaybe<OrderBy>;
  minimumRating?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "event_group_rating_scales" */
export type EventGroupRatingScalesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventGroupRatingScalesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventGroupRatingScalesStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  eventGroupId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  maximumRating?: InputMaybe<Scalars['numeric']>;
  minimumRating?: InputMaybe<Scalars['numeric']>;
  padelRatingScaleId?: InputMaybe<Scalars['uuid']>;
  pickleballRatingScaleId?: InputMaybe<Scalars['uuid']>;
  tennisRatingScaleId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type EventGroupRatingScalesSumFields = {
  __typename?: 'EventGroupRatingScalesSumFields';
  maximumRating?: Maybe<Scalars['numeric']>;
  minimumRating?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "event_group_rating_scales" */
export type EventGroupRatingScalesSumOrderBy = {
  maximumRating?: InputMaybe<OrderBy>;
  minimumRating?: InputMaybe<OrderBy>;
};

/** update columns of table "event_group_rating_scales" */
export enum EventGroupRatingScalesUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EventGroupId = 'eventGroupId',
  /** column name */
  Id = 'id',
  /** column name */
  MaximumRating = 'maximumRating',
  /** column name */
  MinimumRating = 'minimumRating',
  /** column name */
  PadelRatingScaleId = 'padelRatingScaleId',
  /** column name */
  PickleballRatingScaleId = 'pickleballRatingScaleId',
  /** column name */
  TennisRatingScaleId = 'tennisRatingScaleId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type EventGroupRatingScalesUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<EventGroupRatingScalesIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventGroupRatingScalesSetInput>;
  /** filter the rows which have to be updated */
  where: EventGroupRatingScalesBoolExp;
};

/** aggregate varPop on columns */
export type EventGroupRatingScalesVarPopFields = {
  __typename?: 'EventGroupRatingScalesVarPopFields';
  maximumRating?: Maybe<Scalars['Float']>;
  minimumRating?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "event_group_rating_scales" */
export type EventGroupRatingScalesVarPopOrderBy = {
  maximumRating?: InputMaybe<OrderBy>;
  minimumRating?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type EventGroupRatingScalesVarSampFields = {
  __typename?: 'EventGroupRatingScalesVarSampFields';
  maximumRating?: Maybe<Scalars['Float']>;
  minimumRating?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "event_group_rating_scales" */
export type EventGroupRatingScalesVarSampOrderBy = {
  maximumRating?: InputMaybe<OrderBy>;
  minimumRating?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type EventGroupRatingScalesVarianceFields = {
  __typename?: 'EventGroupRatingScalesVarianceFields';
  maximumRating?: Maybe<Scalars['Float']>;
  minimumRating?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "event_group_rating_scales" */
export type EventGroupRatingScalesVarianceOrderBy = {
  maximumRating?: InputMaybe<OrderBy>;
  minimumRating?: InputMaybe<OrderBy>;
};

/** columns and relationships of "event_group_registration_statuses" */
export type EventGroupRegistrationStatuses = {
  __typename?: 'EventGroupRegistrationStatuses';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "event_group_registration_statuses" */
export type EventGroupRegistrationStatusesAggregate = {
  __typename?: 'EventGroupRegistrationStatusesAggregate';
  aggregate?: Maybe<EventGroupRegistrationStatusesAggregateFields>;
  nodes: Array<EventGroupRegistrationStatuses>;
};

/** aggregate fields of "event_group_registration_statuses" */
export type EventGroupRegistrationStatusesAggregateFields = {
  __typename?: 'EventGroupRegistrationStatusesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<EventGroupRegistrationStatusesMaxFields>;
  min?: Maybe<EventGroupRegistrationStatusesMinFields>;
};


/** aggregate fields of "event_group_registration_statuses" */
export type EventGroupRegistrationStatusesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EventGroupRegistrationStatusesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "event_group_registration_statuses". All fields are combined with a logical 'AND'. */
export type EventGroupRegistrationStatusesBoolExp = {
  _and?: InputMaybe<Array<EventGroupRegistrationStatusesBoolExp>>;
  _not?: InputMaybe<EventGroupRegistrationStatusesBoolExp>;
  _or?: InputMaybe<Array<EventGroupRegistrationStatusesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "event_group_registration_statuses" */
export enum EventGroupRegistrationStatusesConstraint {
  /** unique or primary key constraint on columns "value" */
  EventGroupRegistrationStatusesPkey = 'event_group_registration_statuses_pkey'
}

export enum EventGroupRegistrationStatusesEnum {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Pending = 'PENDING'
}

/** Boolean expression to compare columns of type "EventGroupRegistrationStatusesEnum". All fields are combined with logical 'AND'. */
export type EventGroupRegistrationStatusesEnumComparisonExp = {
  _eq?: InputMaybe<EventGroupRegistrationStatusesEnum>;
  _in?: InputMaybe<Array<EventGroupRegistrationStatusesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<EventGroupRegistrationStatusesEnum>;
  _nin?: InputMaybe<Array<EventGroupRegistrationStatusesEnum>>;
};

/** input type for inserting data into table "event_group_registration_statuses" */
export type EventGroupRegistrationStatusesInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type EventGroupRegistrationStatusesMaxFields = {
  __typename?: 'EventGroupRegistrationStatusesMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type EventGroupRegistrationStatusesMinFields = {
  __typename?: 'EventGroupRegistrationStatusesMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "event_group_registration_statuses" */
export type EventGroupRegistrationStatusesMutationResponse = {
  __typename?: 'EventGroupRegistrationStatusesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventGroupRegistrationStatuses>;
};

/** on_conflict condition type for table "event_group_registration_statuses" */
export type EventGroupRegistrationStatusesOnConflict = {
  constraint: EventGroupRegistrationStatusesConstraint;
  updateColumns?: Array<EventGroupRegistrationStatusesUpdateColumn>;
  where?: InputMaybe<EventGroupRegistrationStatusesBoolExp>;
};

/** Ordering options when selecting data from "event_group_registration_statuses". */
export type EventGroupRegistrationStatusesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: event_group_registration_statuses */
export type EventGroupRegistrationStatusesPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "event_group_registration_statuses" */
export enum EventGroupRegistrationStatusesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "event_group_registration_statuses" */
export type EventGroupRegistrationStatusesSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "event_group_registration_statuses" */
export type EventGroupRegistrationStatusesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventGroupRegistrationStatusesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventGroupRegistrationStatusesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "event_group_registration_statuses" */
export enum EventGroupRegistrationStatusesUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type EventGroupRegistrationStatusesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventGroupRegistrationStatusesSetInput>;
  /** filter the rows which have to be updated */
  where: EventGroupRegistrationStatusesBoolExp;
};

/** columns and relationships of "event_group_registrations" */
export type EventGroupRegistrations = {
  __typename?: 'EventGroupRegistrations';
  checkedInAt?: Maybe<Scalars['timestamptz']>;
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  group: EventGroups;
  groupId: Scalars['uuid'];
  id: Scalars['uuid'];
  /** An array relationship */
  invitations: Array<EventInvitations>;
  /** An aggregate relationship */
  invitationsAggregate: EventInvitationsAggregate;
  invitedPartnerEmail?: Maybe<Scalars['String']>;
  invitedPartnerName?: Maybe<Scalars['String']>;
  paymentFulfillmentChannel?: Maybe<PaymentFulfillmentChannelsEnum>;
  paymentStatus?: Maybe<PaymentStatusesEnum>;
  status: EventGroupRegistrationStatusesEnum;
  /** An object relationship */
  team?: Maybe<EventTeams>;
  teamId?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  transactionItems: Array<EventTransactionItems>;
  /** An aggregate relationship */
  transactionItemsAggregate: EventTransactionItemsAggregate;
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid'];
  /** An object relationship */
  userProfile?: Maybe<UserProfiles>;
};


/** columns and relationships of "event_group_registrations" */
export type EventGroupRegistrationsInvitationsArgs = {
  distinctOn?: InputMaybe<Array<EventInvitationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventInvitationsOrderBy>>;
  where?: InputMaybe<EventInvitationsBoolExp>;
};


/** columns and relationships of "event_group_registrations" */
export type EventGroupRegistrationsInvitationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventInvitationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventInvitationsOrderBy>>;
  where?: InputMaybe<EventInvitationsBoolExp>;
};


/** columns and relationships of "event_group_registrations" */
export type EventGroupRegistrationsTransactionItemsArgs = {
  distinctOn?: InputMaybe<Array<EventTransactionItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventTransactionItemsOrderBy>>;
  where?: InputMaybe<EventTransactionItemsBoolExp>;
};


/** columns and relationships of "event_group_registrations" */
export type EventGroupRegistrationsTransactionItemsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventTransactionItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventTransactionItemsOrderBy>>;
  where?: InputMaybe<EventTransactionItemsBoolExp>;
};

/** aggregated selection of "event_group_registrations" */
export type EventGroupRegistrationsAggregate = {
  __typename?: 'EventGroupRegistrationsAggregate';
  aggregate?: Maybe<EventGroupRegistrationsAggregateFields>;
  nodes: Array<EventGroupRegistrations>;
};

export type EventGroupRegistrationsAggregateBoolExp = {
  count?: InputMaybe<EventGroupRegistrationsAggregateBoolExpCount>;
};

/** aggregate fields of "event_group_registrations" */
export type EventGroupRegistrationsAggregateFields = {
  __typename?: 'EventGroupRegistrationsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<EventGroupRegistrationsMaxFields>;
  min?: Maybe<EventGroupRegistrationsMinFields>;
};


/** aggregate fields of "event_group_registrations" */
export type EventGroupRegistrationsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EventGroupRegistrationsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "event_group_registrations" */
export type EventGroupRegistrationsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EventGroupRegistrationsMaxOrderBy>;
  min?: InputMaybe<EventGroupRegistrationsMinOrderBy>;
};

/** input type for inserting array relation for remote table "event_group_registrations" */
export type EventGroupRegistrationsArrRelInsertInput = {
  data: Array<EventGroupRegistrationsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<EventGroupRegistrationsOnConflict>;
};

/** Boolean expression to filter rows from the table "event_group_registrations". All fields are combined with a logical 'AND'. */
export type EventGroupRegistrationsBoolExp = {
  _and?: InputMaybe<Array<EventGroupRegistrationsBoolExp>>;
  _not?: InputMaybe<EventGroupRegistrationsBoolExp>;
  _or?: InputMaybe<Array<EventGroupRegistrationsBoolExp>>;
  checkedInAt?: InputMaybe<TimestamptzComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  group?: InputMaybe<EventGroupsBoolExp>;
  groupId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  invitations?: InputMaybe<EventInvitationsBoolExp>;
  invitationsAggregate?: InputMaybe<EventInvitationsAggregateBoolExp>;
  invitedPartnerEmail?: InputMaybe<StringComparisonExp>;
  invitedPartnerName?: InputMaybe<StringComparisonExp>;
  paymentFulfillmentChannel?: InputMaybe<PaymentFulfillmentChannelsEnumComparisonExp>;
  paymentStatus?: InputMaybe<PaymentStatusesEnumComparisonExp>;
  status?: InputMaybe<EventGroupRegistrationStatusesEnumComparisonExp>;
  team?: InputMaybe<EventTeamsBoolExp>;
  teamId?: InputMaybe<UuidComparisonExp>;
  transactionItems?: InputMaybe<EventTransactionItemsBoolExp>;
  transactionItemsAggregate?: InputMaybe<EventTransactionItemsAggregateBoolExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
  userProfile?: InputMaybe<UserProfilesBoolExp>;
};

/** unique or primary key constraints on table "event_group_registrations" */
export enum EventGroupRegistrationsConstraint {
  /** unique or primary key constraint on columns "user_id", "group_id" */
  EventGroupRegistrationsGroupIdUserIdKey = 'event_group_registrations_group_id_user_id_key',
  /** unique or primary key constraint on columns "id" */
  EventGroupRegistrationsPkey = 'event_group_registrations_pkey'
}

/** input type for inserting data into table "event_group_registrations" */
export type EventGroupRegistrationsInsertInput = {
  checkedInAt?: InputMaybe<Scalars['timestamptz']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  group?: InputMaybe<EventGroupsObjRelInsertInput>;
  groupId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  invitations?: InputMaybe<EventInvitationsArrRelInsertInput>;
  invitedPartnerEmail?: InputMaybe<Scalars['String']>;
  invitedPartnerName?: InputMaybe<Scalars['String']>;
  paymentFulfillmentChannel?: InputMaybe<PaymentFulfillmentChannelsEnum>;
  paymentStatus?: InputMaybe<PaymentStatusesEnum>;
  status?: InputMaybe<EventGroupRegistrationStatusesEnum>;
  team?: InputMaybe<EventTeamsObjRelInsertInput>;
  teamId?: InputMaybe<Scalars['uuid']>;
  transactionItems?: InputMaybe<EventTransactionItemsArrRelInsertInput>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']>;
  userProfile?: InputMaybe<UserProfilesObjRelInsertInput>;
};

/** aggregate max on columns */
export type EventGroupRegistrationsMaxFields = {
  __typename?: 'EventGroupRegistrationsMaxFields';
  checkedInAt?: Maybe<Scalars['timestamptz']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  groupId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  invitedPartnerEmail?: Maybe<Scalars['String']>;
  invitedPartnerName?: Maybe<Scalars['String']>;
  teamId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "event_group_registrations" */
export type EventGroupRegistrationsMaxOrderBy = {
  checkedInAt?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  invitedPartnerEmail?: InputMaybe<OrderBy>;
  invitedPartnerName?: InputMaybe<OrderBy>;
  teamId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type EventGroupRegistrationsMinFields = {
  __typename?: 'EventGroupRegistrationsMinFields';
  checkedInAt?: Maybe<Scalars['timestamptz']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  groupId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  invitedPartnerEmail?: Maybe<Scalars['String']>;
  invitedPartnerName?: Maybe<Scalars['String']>;
  teamId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "event_group_registrations" */
export type EventGroupRegistrationsMinOrderBy = {
  checkedInAt?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  invitedPartnerEmail?: InputMaybe<OrderBy>;
  invitedPartnerName?: InputMaybe<OrderBy>;
  teamId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "event_group_registrations" */
export type EventGroupRegistrationsMutationResponse = {
  __typename?: 'EventGroupRegistrationsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventGroupRegistrations>;
};

/** input type for inserting object relation for remote table "event_group_registrations" */
export type EventGroupRegistrationsObjRelInsertInput = {
  data: EventGroupRegistrationsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<EventGroupRegistrationsOnConflict>;
};

/** on_conflict condition type for table "event_group_registrations" */
export type EventGroupRegistrationsOnConflict = {
  constraint: EventGroupRegistrationsConstraint;
  updateColumns?: Array<EventGroupRegistrationsUpdateColumn>;
  where?: InputMaybe<EventGroupRegistrationsBoolExp>;
};

/** Ordering options when selecting data from "event_group_registrations". */
export type EventGroupRegistrationsOrderBy = {
  checkedInAt?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  group?: InputMaybe<EventGroupsOrderBy>;
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  invitationsAggregate?: InputMaybe<EventInvitationsAggregateOrderBy>;
  invitedPartnerEmail?: InputMaybe<OrderBy>;
  invitedPartnerName?: InputMaybe<OrderBy>;
  paymentFulfillmentChannel?: InputMaybe<OrderBy>;
  paymentStatus?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  team?: InputMaybe<EventTeamsOrderBy>;
  teamId?: InputMaybe<OrderBy>;
  transactionItemsAggregate?: InputMaybe<EventTransactionItemsAggregateOrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
  userProfile?: InputMaybe<UserProfilesOrderBy>;
};

/** primary key columns input for table: event_group_registrations */
export type EventGroupRegistrationsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "event_group_registrations" */
export enum EventGroupRegistrationsSelectColumn {
  /** column name */
  CheckedInAt = 'checkedInAt',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  GroupId = 'groupId',
  /** column name */
  Id = 'id',
  /** column name */
  InvitedPartnerEmail = 'invitedPartnerEmail',
  /** column name */
  InvitedPartnerName = 'invitedPartnerName',
  /** column name */
  PaymentFulfillmentChannel = 'paymentFulfillmentChannel',
  /** column name */
  PaymentStatus = 'paymentStatus',
  /** column name */
  Status = 'status',
  /** column name */
  TeamId = 'teamId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "event_group_registrations" */
export type EventGroupRegistrationsSetInput = {
  checkedInAt?: InputMaybe<Scalars['timestamptz']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  groupId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  invitedPartnerEmail?: InputMaybe<Scalars['String']>;
  invitedPartnerName?: InputMaybe<Scalars['String']>;
  paymentFulfillmentChannel?: InputMaybe<PaymentFulfillmentChannelsEnum>;
  paymentStatus?: InputMaybe<PaymentStatusesEnum>;
  status?: InputMaybe<EventGroupRegistrationStatusesEnum>;
  teamId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "event_group_registrations" */
export type EventGroupRegistrationsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventGroupRegistrationsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventGroupRegistrationsStreamCursorValueInput = {
  checkedInAt?: InputMaybe<Scalars['timestamptz']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  groupId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  invitedPartnerEmail?: InputMaybe<Scalars['String']>;
  invitedPartnerName?: InputMaybe<Scalars['String']>;
  paymentFulfillmentChannel?: InputMaybe<PaymentFulfillmentChannelsEnum>;
  paymentStatus?: InputMaybe<PaymentStatusesEnum>;
  status?: InputMaybe<EventGroupRegistrationStatusesEnum>;
  teamId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "event_group_registrations" */
export enum EventGroupRegistrationsUpdateColumn {
  /** column name */
  CheckedInAt = 'checkedInAt',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  GroupId = 'groupId',
  /** column name */
  Id = 'id',
  /** column name */
  InvitedPartnerEmail = 'invitedPartnerEmail',
  /** column name */
  InvitedPartnerName = 'invitedPartnerName',
  /** column name */
  PaymentFulfillmentChannel = 'paymentFulfillmentChannel',
  /** column name */
  PaymentStatus = 'paymentStatus',
  /** column name */
  Status = 'status',
  /** column name */
  TeamId = 'teamId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

export type EventGroupRegistrationsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventGroupRegistrationsSetInput>;
  /** filter the rows which have to be updated */
  where: EventGroupRegistrationsBoolExp;
};

/** columns and relationships of "event_group_sequence_seeding" */
export type EventGroupSequenceSeeding = {
  __typename?: 'EventGroupSequenceSeeding';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  eventGroupSequenceId: Scalars['uuid'];
  eventTeamId: Scalars['uuid'];
  id: Scalars['uuid'];
  seed: Scalars['Int'];
  /** An object relationship */
  sequence: EventGroupSequences;
  /** An object relationship */
  team: EventTeams;
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "event_group_sequence_seeding" */
export type EventGroupSequenceSeedingAggregate = {
  __typename?: 'EventGroupSequenceSeedingAggregate';
  aggregate?: Maybe<EventGroupSequenceSeedingAggregateFields>;
  nodes: Array<EventGroupSequenceSeeding>;
};

export type EventGroupSequenceSeedingAggregateBoolExp = {
  count?: InputMaybe<EventGroupSequenceSeedingAggregateBoolExpCount>;
};

/** aggregate fields of "event_group_sequence_seeding" */
export type EventGroupSequenceSeedingAggregateFields = {
  __typename?: 'EventGroupSequenceSeedingAggregateFields';
  avg?: Maybe<EventGroupSequenceSeedingAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<EventGroupSequenceSeedingMaxFields>;
  min?: Maybe<EventGroupSequenceSeedingMinFields>;
  stddev?: Maybe<EventGroupSequenceSeedingStddevFields>;
  stddevPop?: Maybe<EventGroupSequenceSeedingStddevPopFields>;
  stddevSamp?: Maybe<EventGroupSequenceSeedingStddevSampFields>;
  sum?: Maybe<EventGroupSequenceSeedingSumFields>;
  varPop?: Maybe<EventGroupSequenceSeedingVarPopFields>;
  varSamp?: Maybe<EventGroupSequenceSeedingVarSampFields>;
  variance?: Maybe<EventGroupSequenceSeedingVarianceFields>;
};


/** aggregate fields of "event_group_sequence_seeding" */
export type EventGroupSequenceSeedingAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EventGroupSequenceSeedingSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "event_group_sequence_seeding" */
export type EventGroupSequenceSeedingAggregateOrderBy = {
  avg?: InputMaybe<EventGroupSequenceSeedingAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EventGroupSequenceSeedingMaxOrderBy>;
  min?: InputMaybe<EventGroupSequenceSeedingMinOrderBy>;
  stddev?: InputMaybe<EventGroupSequenceSeedingStddevOrderBy>;
  stddevPop?: InputMaybe<EventGroupSequenceSeedingStddevPopOrderBy>;
  stddevSamp?: InputMaybe<EventGroupSequenceSeedingStddevSampOrderBy>;
  sum?: InputMaybe<EventGroupSequenceSeedingSumOrderBy>;
  varPop?: InputMaybe<EventGroupSequenceSeedingVarPopOrderBy>;
  varSamp?: InputMaybe<EventGroupSequenceSeedingVarSampOrderBy>;
  variance?: InputMaybe<EventGroupSequenceSeedingVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "event_group_sequence_seeding" */
export type EventGroupSequenceSeedingArrRelInsertInput = {
  data: Array<EventGroupSequenceSeedingInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<EventGroupSequenceSeedingOnConflict>;
};

/** aggregate avg on columns */
export type EventGroupSequenceSeedingAvgFields = {
  __typename?: 'EventGroupSequenceSeedingAvgFields';
  seed?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "event_group_sequence_seeding" */
export type EventGroupSequenceSeedingAvgOrderBy = {
  seed?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "event_group_sequence_seeding". All fields are combined with a logical 'AND'. */
export type EventGroupSequenceSeedingBoolExp = {
  _and?: InputMaybe<Array<EventGroupSequenceSeedingBoolExp>>;
  _not?: InputMaybe<EventGroupSequenceSeedingBoolExp>;
  _or?: InputMaybe<Array<EventGroupSequenceSeedingBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  eventGroupSequenceId?: InputMaybe<UuidComparisonExp>;
  eventTeamId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  seed?: InputMaybe<IntComparisonExp>;
  sequence?: InputMaybe<EventGroupSequencesBoolExp>;
  team?: InputMaybe<EventTeamsBoolExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "event_group_sequence_seeding" */
export enum EventGroupSequenceSeedingConstraint {
  /** unique or primary key constraint on columns "event_team_id", "event_group_sequence_id" */
  EventGroupSequenceSeedingEventGroupSequenceIdEventKey = 'event_group_sequence_seeding_event_group_sequence_id_event__key',
  /** unique or primary key constraint on columns "seed", "event_group_sequence_id" */
  EventGroupSequenceSeedingEventGroupSequenceIdSeedKey = 'event_group_sequence_seeding_event_group_sequence_id_seed_key',
  /** unique or primary key constraint on columns "id" */
  EventGroupSequenceSeedingPkey = 'event_group_sequence_seeding_pkey'
}

/** input type for incrementing numeric columns in table "event_group_sequence_seeding" */
export type EventGroupSequenceSeedingIncInput = {
  seed?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "event_group_sequence_seeding" */
export type EventGroupSequenceSeedingInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  eventGroupSequenceId?: InputMaybe<Scalars['uuid']>;
  eventTeamId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  seed?: InputMaybe<Scalars['Int']>;
  sequence?: InputMaybe<EventGroupSequencesObjRelInsertInput>;
  team?: InputMaybe<EventTeamsObjRelInsertInput>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type EventGroupSequenceSeedingMaxFields = {
  __typename?: 'EventGroupSequenceSeedingMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  eventGroupSequenceId?: Maybe<Scalars['uuid']>;
  eventTeamId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  seed?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "event_group_sequence_seeding" */
export type EventGroupSequenceSeedingMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  eventGroupSequenceId?: InputMaybe<OrderBy>;
  eventTeamId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  seed?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type EventGroupSequenceSeedingMinFields = {
  __typename?: 'EventGroupSequenceSeedingMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  eventGroupSequenceId?: Maybe<Scalars['uuid']>;
  eventTeamId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  seed?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "event_group_sequence_seeding" */
export type EventGroupSequenceSeedingMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  eventGroupSequenceId?: InputMaybe<OrderBy>;
  eventTeamId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  seed?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "event_group_sequence_seeding" */
export type EventGroupSequenceSeedingMutationResponse = {
  __typename?: 'EventGroupSequenceSeedingMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventGroupSequenceSeeding>;
};

/** on_conflict condition type for table "event_group_sequence_seeding" */
export type EventGroupSequenceSeedingOnConflict = {
  constraint: EventGroupSequenceSeedingConstraint;
  updateColumns?: Array<EventGroupSequenceSeedingUpdateColumn>;
  where?: InputMaybe<EventGroupSequenceSeedingBoolExp>;
};

/** Ordering options when selecting data from "event_group_sequence_seeding". */
export type EventGroupSequenceSeedingOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  eventGroupSequenceId?: InputMaybe<OrderBy>;
  eventTeamId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  seed?: InputMaybe<OrderBy>;
  sequence?: InputMaybe<EventGroupSequencesOrderBy>;
  team?: InputMaybe<EventTeamsOrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: event_group_sequence_seeding */
export type EventGroupSequenceSeedingPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "event_group_sequence_seeding" */
export enum EventGroupSequenceSeedingSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EventGroupSequenceId = 'eventGroupSequenceId',
  /** column name */
  EventTeamId = 'eventTeamId',
  /** column name */
  Id = 'id',
  /** column name */
  Seed = 'seed',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "event_group_sequence_seeding" */
export type EventGroupSequenceSeedingSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  eventGroupSequenceId?: InputMaybe<Scalars['uuid']>;
  eventTeamId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  seed?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type EventGroupSequenceSeedingStddevFields = {
  __typename?: 'EventGroupSequenceSeedingStddevFields';
  seed?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "event_group_sequence_seeding" */
export type EventGroupSequenceSeedingStddevOrderBy = {
  seed?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type EventGroupSequenceSeedingStddevPopFields = {
  __typename?: 'EventGroupSequenceSeedingStddevPopFields';
  seed?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "event_group_sequence_seeding" */
export type EventGroupSequenceSeedingStddevPopOrderBy = {
  seed?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type EventGroupSequenceSeedingStddevSampFields = {
  __typename?: 'EventGroupSequenceSeedingStddevSampFields';
  seed?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "event_group_sequence_seeding" */
export type EventGroupSequenceSeedingStddevSampOrderBy = {
  seed?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "event_group_sequence_seeding" */
export type EventGroupSequenceSeedingStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventGroupSequenceSeedingStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventGroupSequenceSeedingStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  eventGroupSequenceId?: InputMaybe<Scalars['uuid']>;
  eventTeamId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  seed?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type EventGroupSequenceSeedingSumFields = {
  __typename?: 'EventGroupSequenceSeedingSumFields';
  seed?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "event_group_sequence_seeding" */
export type EventGroupSequenceSeedingSumOrderBy = {
  seed?: InputMaybe<OrderBy>;
};

/** update columns of table "event_group_sequence_seeding" */
export enum EventGroupSequenceSeedingUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EventGroupSequenceId = 'eventGroupSequenceId',
  /** column name */
  EventTeamId = 'eventTeamId',
  /** column name */
  Id = 'id',
  /** column name */
  Seed = 'seed',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type EventGroupSequenceSeedingUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<EventGroupSequenceSeedingIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventGroupSequenceSeedingSetInput>;
  /** filter the rows which have to be updated */
  where: EventGroupSequenceSeedingBoolExp;
};

/** aggregate varPop on columns */
export type EventGroupSequenceSeedingVarPopFields = {
  __typename?: 'EventGroupSequenceSeedingVarPopFields';
  seed?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "event_group_sequence_seeding" */
export type EventGroupSequenceSeedingVarPopOrderBy = {
  seed?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type EventGroupSequenceSeedingVarSampFields = {
  __typename?: 'EventGroupSequenceSeedingVarSampFields';
  seed?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "event_group_sequence_seeding" */
export type EventGroupSequenceSeedingVarSampOrderBy = {
  seed?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type EventGroupSequenceSeedingVarianceFields = {
  __typename?: 'EventGroupSequenceSeedingVarianceFields';
  seed?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "event_group_sequence_seeding" */
export type EventGroupSequenceSeedingVarianceOrderBy = {
  seed?: InputMaybe<OrderBy>;
};

/** columns and relationships of "event_group_sequences" */
export type EventGroupSequences = {
  __typename?: 'EventGroupSequences';
  competitionFormat: CompetitionFormatsEnum;
  completeReason: EventSequenceCompleteReasonsEnum;
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  group: EventGroups;
  groupId: Scalars['uuid'];
  id: Scalars['uuid'];
  isSequenceComplete: Scalars['Boolean'];
  /** An object relationship */
  nextSequence?: Maybe<EventGroupSequences>;
  nextSequenceId?: Maybe<Scalars['uuid']>;
  order: Scalars['Int'];
  /** An array relationship */
  pools: Array<EventGroupPools>;
  /** An aggregate relationship */
  poolsAggregate: EventGroupPoolsAggregate;
  /** An array relationship */
  seeding: Array<EventGroupSequenceSeeding>;
  /** An aggregate relationship */
  seedingAggregate: EventGroupSequenceSeedingAggregate;
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "event_group_sequences" */
export type EventGroupSequencesPoolsArgs = {
  distinctOn?: InputMaybe<Array<EventGroupPoolsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGroupPoolsOrderBy>>;
  where?: InputMaybe<EventGroupPoolsBoolExp>;
};


/** columns and relationships of "event_group_sequences" */
export type EventGroupSequencesPoolsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventGroupPoolsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGroupPoolsOrderBy>>;
  where?: InputMaybe<EventGroupPoolsBoolExp>;
};


/** columns and relationships of "event_group_sequences" */
export type EventGroupSequencesSeedingArgs = {
  distinctOn?: InputMaybe<Array<EventGroupSequenceSeedingSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGroupSequenceSeedingOrderBy>>;
  where?: InputMaybe<EventGroupSequenceSeedingBoolExp>;
};


/** columns and relationships of "event_group_sequences" */
export type EventGroupSequencesSeedingAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventGroupSequenceSeedingSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGroupSequenceSeedingOrderBy>>;
  where?: InputMaybe<EventGroupSequenceSeedingBoolExp>;
};

/** aggregated selection of "event_group_sequences" */
export type EventGroupSequencesAggregate = {
  __typename?: 'EventGroupSequencesAggregate';
  aggregate?: Maybe<EventGroupSequencesAggregateFields>;
  nodes: Array<EventGroupSequences>;
};

export type EventGroupSequencesAggregateBoolExp = {
  bool_and?: InputMaybe<EventGroupSequencesAggregateBoolExpBool_And>;
  bool_or?: InputMaybe<EventGroupSequencesAggregateBoolExpBool_Or>;
  count?: InputMaybe<EventGroupSequencesAggregateBoolExpCount>;
};

/** aggregate fields of "event_group_sequences" */
export type EventGroupSequencesAggregateFields = {
  __typename?: 'EventGroupSequencesAggregateFields';
  avg?: Maybe<EventGroupSequencesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<EventGroupSequencesMaxFields>;
  min?: Maybe<EventGroupSequencesMinFields>;
  stddev?: Maybe<EventGroupSequencesStddevFields>;
  stddevPop?: Maybe<EventGroupSequencesStddevPopFields>;
  stddevSamp?: Maybe<EventGroupSequencesStddevSampFields>;
  sum?: Maybe<EventGroupSequencesSumFields>;
  varPop?: Maybe<EventGroupSequencesVarPopFields>;
  varSamp?: Maybe<EventGroupSequencesVarSampFields>;
  variance?: Maybe<EventGroupSequencesVarianceFields>;
};


/** aggregate fields of "event_group_sequences" */
export type EventGroupSequencesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EventGroupSequencesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "event_group_sequences" */
export type EventGroupSequencesAggregateOrderBy = {
  avg?: InputMaybe<EventGroupSequencesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EventGroupSequencesMaxOrderBy>;
  min?: InputMaybe<EventGroupSequencesMinOrderBy>;
  stddev?: InputMaybe<EventGroupSequencesStddevOrderBy>;
  stddevPop?: InputMaybe<EventGroupSequencesStddevPopOrderBy>;
  stddevSamp?: InputMaybe<EventGroupSequencesStddevSampOrderBy>;
  sum?: InputMaybe<EventGroupSequencesSumOrderBy>;
  varPop?: InputMaybe<EventGroupSequencesVarPopOrderBy>;
  varSamp?: InputMaybe<EventGroupSequencesVarSampOrderBy>;
  variance?: InputMaybe<EventGroupSequencesVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "event_group_sequences" */
export type EventGroupSequencesArrRelInsertInput = {
  data: Array<EventGroupSequencesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<EventGroupSequencesOnConflict>;
};

/** aggregate avg on columns */
export type EventGroupSequencesAvgFields = {
  __typename?: 'EventGroupSequencesAvgFields';
  order?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "event_group_sequences" */
export type EventGroupSequencesAvgOrderBy = {
  order?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "event_group_sequences". All fields are combined with a logical 'AND'. */
export type EventGroupSequencesBoolExp = {
  _and?: InputMaybe<Array<EventGroupSequencesBoolExp>>;
  _not?: InputMaybe<EventGroupSequencesBoolExp>;
  _or?: InputMaybe<Array<EventGroupSequencesBoolExp>>;
  competitionFormat?: InputMaybe<CompetitionFormatsEnumComparisonExp>;
  completeReason?: InputMaybe<EventSequenceCompleteReasonsEnumComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  group?: InputMaybe<EventGroupsBoolExp>;
  groupId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isSequenceComplete?: InputMaybe<BooleanComparisonExp>;
  nextSequence?: InputMaybe<EventGroupSequencesBoolExp>;
  nextSequenceId?: InputMaybe<UuidComparisonExp>;
  order?: InputMaybe<IntComparisonExp>;
  pools?: InputMaybe<EventGroupPoolsBoolExp>;
  poolsAggregate?: InputMaybe<EventGroupPoolsAggregateBoolExp>;
  seeding?: InputMaybe<EventGroupSequenceSeedingBoolExp>;
  seedingAggregate?: InputMaybe<EventGroupSequenceSeedingAggregateBoolExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "event_group_sequences" */
export enum EventGroupSequencesConstraint {
  /** unique or primary key constraint on columns "order", "group_id" */
  EventGroupSequencesGroupIdOrderKey = 'event_group_sequences_group_id_order_key',
  /** unique or primary key constraint on columns "id" */
  EventGroupSequencesPkey = 'event_group_sequences_pkey'
}

/** input type for incrementing numeric columns in table "event_group_sequences" */
export type EventGroupSequencesIncInput = {
  order?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "event_group_sequences" */
export type EventGroupSequencesInsertInput = {
  competitionFormat?: InputMaybe<CompetitionFormatsEnum>;
  completeReason?: InputMaybe<EventSequenceCompleteReasonsEnum>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  group?: InputMaybe<EventGroupsObjRelInsertInput>;
  groupId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  isSequenceComplete?: InputMaybe<Scalars['Boolean']>;
  nextSequence?: InputMaybe<EventGroupSequencesObjRelInsertInput>;
  nextSequenceId?: InputMaybe<Scalars['uuid']>;
  order?: InputMaybe<Scalars['Int']>;
  pools?: InputMaybe<EventGroupPoolsArrRelInsertInput>;
  seeding?: InputMaybe<EventGroupSequenceSeedingArrRelInsertInput>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type EventGroupSequencesMaxFields = {
  __typename?: 'EventGroupSequencesMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  groupId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  nextSequenceId?: Maybe<Scalars['uuid']>;
  order?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "event_group_sequences" */
export type EventGroupSequencesMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  nextSequenceId?: InputMaybe<OrderBy>;
  order?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type EventGroupSequencesMinFields = {
  __typename?: 'EventGroupSequencesMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  groupId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  nextSequenceId?: Maybe<Scalars['uuid']>;
  order?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "event_group_sequences" */
export type EventGroupSequencesMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  nextSequenceId?: InputMaybe<OrderBy>;
  order?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "event_group_sequences" */
export type EventGroupSequencesMutationResponse = {
  __typename?: 'EventGroupSequencesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventGroupSequences>;
};

/** input type for inserting object relation for remote table "event_group_sequences" */
export type EventGroupSequencesObjRelInsertInput = {
  data: EventGroupSequencesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<EventGroupSequencesOnConflict>;
};

/** on_conflict condition type for table "event_group_sequences" */
export type EventGroupSequencesOnConflict = {
  constraint: EventGroupSequencesConstraint;
  updateColumns?: Array<EventGroupSequencesUpdateColumn>;
  where?: InputMaybe<EventGroupSequencesBoolExp>;
};

/** Ordering options when selecting data from "event_group_sequences". */
export type EventGroupSequencesOrderBy = {
  competitionFormat?: InputMaybe<OrderBy>;
  completeReason?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  group?: InputMaybe<EventGroupsOrderBy>;
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  isSequenceComplete?: InputMaybe<OrderBy>;
  nextSequence?: InputMaybe<EventGroupSequencesOrderBy>;
  nextSequenceId?: InputMaybe<OrderBy>;
  order?: InputMaybe<OrderBy>;
  poolsAggregate?: InputMaybe<EventGroupPoolsAggregateOrderBy>;
  seedingAggregate?: InputMaybe<EventGroupSequenceSeedingAggregateOrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: event_group_sequences */
export type EventGroupSequencesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "event_group_sequences" */
export enum EventGroupSequencesSelectColumn {
  /** column name */
  CompetitionFormat = 'competitionFormat',
  /** column name */
  CompleteReason = 'completeReason',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  GroupId = 'groupId',
  /** column name */
  Id = 'id',
  /** column name */
  IsSequenceComplete = 'isSequenceComplete',
  /** column name */
  NextSequenceId = 'nextSequenceId',
  /** column name */
  Order = 'order',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** select "eventGroupSequencesAggregateBoolExpBool_andArgumentsColumns" columns of table "event_group_sequences" */
export enum EventGroupSequencesSelectColumnEventGroupSequencesAggregateBoolExpBool_AndArgumentsColumns {
  /** column name */
  IsSequenceComplete = 'isSequenceComplete'
}

/** select "eventGroupSequencesAggregateBoolExpBool_orArgumentsColumns" columns of table "event_group_sequences" */
export enum EventGroupSequencesSelectColumnEventGroupSequencesAggregateBoolExpBool_OrArgumentsColumns {
  /** column name */
  IsSequenceComplete = 'isSequenceComplete'
}

/** input type for updating data in table "event_group_sequences" */
export type EventGroupSequencesSetInput = {
  competitionFormat?: InputMaybe<CompetitionFormatsEnum>;
  completeReason?: InputMaybe<EventSequenceCompleteReasonsEnum>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  groupId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  isSequenceComplete?: InputMaybe<Scalars['Boolean']>;
  nextSequenceId?: InputMaybe<Scalars['uuid']>;
  order?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type EventGroupSequencesStddevFields = {
  __typename?: 'EventGroupSequencesStddevFields';
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "event_group_sequences" */
export type EventGroupSequencesStddevOrderBy = {
  order?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type EventGroupSequencesStddevPopFields = {
  __typename?: 'EventGroupSequencesStddevPopFields';
  order?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "event_group_sequences" */
export type EventGroupSequencesStddevPopOrderBy = {
  order?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type EventGroupSequencesStddevSampFields = {
  __typename?: 'EventGroupSequencesStddevSampFields';
  order?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "event_group_sequences" */
export type EventGroupSequencesStddevSampOrderBy = {
  order?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "event_group_sequences" */
export type EventGroupSequencesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventGroupSequencesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventGroupSequencesStreamCursorValueInput = {
  competitionFormat?: InputMaybe<CompetitionFormatsEnum>;
  completeReason?: InputMaybe<EventSequenceCompleteReasonsEnum>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  groupId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  isSequenceComplete?: InputMaybe<Scalars['Boolean']>;
  nextSequenceId?: InputMaybe<Scalars['uuid']>;
  order?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type EventGroupSequencesSumFields = {
  __typename?: 'EventGroupSequencesSumFields';
  order?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "event_group_sequences" */
export type EventGroupSequencesSumOrderBy = {
  order?: InputMaybe<OrderBy>;
};

/** update columns of table "event_group_sequences" */
export enum EventGroupSequencesUpdateColumn {
  /** column name */
  CompetitionFormat = 'competitionFormat',
  /** column name */
  CompleteReason = 'completeReason',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  GroupId = 'groupId',
  /** column name */
  Id = 'id',
  /** column name */
  IsSequenceComplete = 'isSequenceComplete',
  /** column name */
  NextSequenceId = 'nextSequenceId',
  /** column name */
  Order = 'order',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type EventGroupSequencesUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<EventGroupSequencesIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventGroupSequencesSetInput>;
  /** filter the rows which have to be updated */
  where: EventGroupSequencesBoolExp;
};

/** aggregate varPop on columns */
export type EventGroupSequencesVarPopFields = {
  __typename?: 'EventGroupSequencesVarPopFields';
  order?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "event_group_sequences" */
export type EventGroupSequencesVarPopOrderBy = {
  order?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type EventGroupSequencesVarSampFields = {
  __typename?: 'EventGroupSequencesVarSampFields';
  order?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "event_group_sequences" */
export type EventGroupSequencesVarSampOrderBy = {
  order?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type EventGroupSequencesVarianceFields = {
  __typename?: 'EventGroupSequencesVarianceFields';
  order?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "event_group_sequences" */
export type EventGroupSequencesVarianceOrderBy = {
  order?: InputMaybe<OrderBy>;
};

/** columns and relationships of "event_group_time_slots" */
export type EventGroupTimeSlots = {
  __typename?: 'EventGroupTimeSlots';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  endsAt: Scalars['timestamptz'];
  externalBookingUrl?: Maybe<Scalars['String']>;
  /** An object relationship */
  group: EventGroups;
  groupId: Scalars['uuid'];
  id: Scalars['uuid'];
  startsAt: Scalars['timestamptz'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "event_group_time_slots" */
export type EventGroupTimeSlotsAggregate = {
  __typename?: 'EventGroupTimeSlotsAggregate';
  aggregate?: Maybe<EventGroupTimeSlotsAggregateFields>;
  nodes: Array<EventGroupTimeSlots>;
};

export type EventGroupTimeSlotsAggregateBoolExp = {
  count?: InputMaybe<EventGroupTimeSlotsAggregateBoolExpCount>;
};

/** aggregate fields of "event_group_time_slots" */
export type EventGroupTimeSlotsAggregateFields = {
  __typename?: 'EventGroupTimeSlotsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<EventGroupTimeSlotsMaxFields>;
  min?: Maybe<EventGroupTimeSlotsMinFields>;
};


/** aggregate fields of "event_group_time_slots" */
export type EventGroupTimeSlotsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EventGroupTimeSlotsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "event_group_time_slots" */
export type EventGroupTimeSlotsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EventGroupTimeSlotsMaxOrderBy>;
  min?: InputMaybe<EventGroupTimeSlotsMinOrderBy>;
};

/** input type for inserting array relation for remote table "event_group_time_slots" */
export type EventGroupTimeSlotsArrRelInsertInput = {
  data: Array<EventGroupTimeSlotsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<EventGroupTimeSlotsOnConflict>;
};

/** Boolean expression to filter rows from the table "event_group_time_slots". All fields are combined with a logical 'AND'. */
export type EventGroupTimeSlotsBoolExp = {
  _and?: InputMaybe<Array<EventGroupTimeSlotsBoolExp>>;
  _not?: InputMaybe<EventGroupTimeSlotsBoolExp>;
  _or?: InputMaybe<Array<EventGroupTimeSlotsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  endsAt?: InputMaybe<TimestamptzComparisonExp>;
  externalBookingUrl?: InputMaybe<StringComparisonExp>;
  group?: InputMaybe<EventGroupsBoolExp>;
  groupId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  startsAt?: InputMaybe<TimestamptzComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "event_group_time_slots" */
export enum EventGroupTimeSlotsConstraint {
  /** unique or primary key constraint on columns "id" */
  EventGroupTimeSlotsPkey = 'event_group_time_slots_pkey'
}

/** input type for inserting data into table "event_group_time_slots" */
export type EventGroupTimeSlotsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  endsAt?: InputMaybe<Scalars['timestamptz']>;
  externalBookingUrl?: InputMaybe<Scalars['String']>;
  group?: InputMaybe<EventGroupsObjRelInsertInput>;
  groupId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  startsAt?: InputMaybe<Scalars['timestamptz']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type EventGroupTimeSlotsMaxFields = {
  __typename?: 'EventGroupTimeSlotsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  endsAt?: Maybe<Scalars['timestamptz']>;
  externalBookingUrl?: Maybe<Scalars['String']>;
  groupId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  startsAt?: Maybe<Scalars['timestamptz']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "event_group_time_slots" */
export type EventGroupTimeSlotsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  endsAt?: InputMaybe<OrderBy>;
  externalBookingUrl?: InputMaybe<OrderBy>;
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  startsAt?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type EventGroupTimeSlotsMinFields = {
  __typename?: 'EventGroupTimeSlotsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  endsAt?: Maybe<Scalars['timestamptz']>;
  externalBookingUrl?: Maybe<Scalars['String']>;
  groupId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  startsAt?: Maybe<Scalars['timestamptz']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "event_group_time_slots" */
export type EventGroupTimeSlotsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  endsAt?: InputMaybe<OrderBy>;
  externalBookingUrl?: InputMaybe<OrderBy>;
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  startsAt?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "event_group_time_slots" */
export type EventGroupTimeSlotsMutationResponse = {
  __typename?: 'EventGroupTimeSlotsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventGroupTimeSlots>;
};

/** on_conflict condition type for table "event_group_time_slots" */
export type EventGroupTimeSlotsOnConflict = {
  constraint: EventGroupTimeSlotsConstraint;
  updateColumns?: Array<EventGroupTimeSlotsUpdateColumn>;
  where?: InputMaybe<EventGroupTimeSlotsBoolExp>;
};

/** Ordering options when selecting data from "event_group_time_slots". */
export type EventGroupTimeSlotsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  endsAt?: InputMaybe<OrderBy>;
  externalBookingUrl?: InputMaybe<OrderBy>;
  group?: InputMaybe<EventGroupsOrderBy>;
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  startsAt?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: event_group_time_slots */
export type EventGroupTimeSlotsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "event_group_time_slots" */
export enum EventGroupTimeSlotsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EndsAt = 'endsAt',
  /** column name */
  ExternalBookingUrl = 'externalBookingUrl',
  /** column name */
  GroupId = 'groupId',
  /** column name */
  Id = 'id',
  /** column name */
  StartsAt = 'startsAt',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "event_group_time_slots" */
export type EventGroupTimeSlotsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  endsAt?: InputMaybe<Scalars['timestamptz']>;
  externalBookingUrl?: InputMaybe<Scalars['String']>;
  groupId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  startsAt?: InputMaybe<Scalars['timestamptz']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "event_group_time_slots" */
export type EventGroupTimeSlotsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventGroupTimeSlotsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventGroupTimeSlotsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  endsAt?: InputMaybe<Scalars['timestamptz']>;
  externalBookingUrl?: InputMaybe<Scalars['String']>;
  groupId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  startsAt?: InputMaybe<Scalars['timestamptz']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "event_group_time_slots" */
export enum EventGroupTimeSlotsUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EndsAt = 'endsAt',
  /** column name */
  ExternalBookingUrl = 'externalBookingUrl',
  /** column name */
  GroupId = 'groupId',
  /** column name */
  Id = 'id',
  /** column name */
  StartsAt = 'startsAt',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type EventGroupTimeSlotsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventGroupTimeSlotsSetInput>;
  /** filter the rows which have to be updated */
  where: EventGroupTimeSlotsBoolExp;
};

/** columns and relationships of "event_groups" */
export type EventGroups = {
  __typename?: 'EventGroups';
  bracketRankingMechanism?: Maybe<BracketRankingMechanismEnum>;
  competitiveness?: Maybe<EventCompetitivenessEnum>;
  /** An array relationship */
  couponGroups: Array<EventCouponGroups>;
  /** An aggregate relationship */
  couponGroupsAggregate: EventCouponGroupsAggregate;
  /** An array relationship */
  courts: Array<EventCourts>;
  /** An aggregate relationship */
  courtsAggregate: EventCourtsAggregate;
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  desiredNumberOfPools?: Maybe<Scalars['Int']>;
  endsAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  event: Events;
  eventId: Scalars['uuid'];
  format?: Maybe<EventGroupFormatsEnum>;
  formatCustomName: Scalars['String'];
  gamesPerMatch: Scalars['Int'];
  gender: CompetitionGenderEnum;
  id: Scalars['uuid'];
  isAgeRestricted: Scalars['Boolean'];
  isMoneyBall?: Maybe<Scalars['Boolean']>;
  isRatingRequired: Scalars['Boolean'];
  isVairRatingSession?: Maybe<Scalars['Boolean']>;
  isVairVairifiedRequired?: Maybe<Scalars['Boolean']>;
  isWheelchair?: Maybe<Scalars['Boolean']>;
  maximumAge?: Maybe<Scalars['Int']>;
  maximumRating?: Maybe<Scalars['numeric']>;
  /** An object relationship */
  merge?: Maybe<EventGroupMerges>;
  mergeId?: Maybe<Scalars['uuid']>;
  minimumAge?: Maybe<Scalars['Int']>;
  minimumNumberOfGames: Scalars['Int'];
  minimumRating?: Maybe<Scalars['numeric']>;
  moneyBallRewards?: Maybe<Scalars['jsonb']>;
  netStatus?: Maybe<GameNetStatusesEnum>;
  numberOfEliminationTeams?: Maybe<Scalars['Int']>;
  numberOfEstimatedCourts?: Maybe<Scalars['Int']>;
  /** An array relationship */
  pools: Array<EventGroupPools>;
  /** An aggregate relationship */
  poolsAggregate: EventGroupPoolsAggregate;
  priceUnitAmount: Scalars['Int'];
  /** An array relationship */
  ratingScales: Array<EventGroupRatingScales>;
  /** An aggregate relationship */
  ratingScalesAggregate: EventGroupRatingScalesAggregate;
  /** An array relationship */
  registrations: Array<EventGroupRegistrations>;
  /** An aggregate relationship */
  registrationsAggregate: EventGroupRegistrationsAggregate;
  scoringFormat?: Maybe<ScoringFormatEnum>;
  /** An object relationship */
  selfRatedMaxSkillLevel?: Maybe<SkillLevels>;
  selfRatedMaxSkillLevelId?: Maybe<Scalars['String']>;
  /** An object relationship */
  selfRatedMinSkillLevel?: Maybe<SkillLevels>;
  selfRatedMinSkillLevelId?: Maybe<Scalars['String']>;
  /** An array relationship */
  sequences: Array<EventGroupSequences>;
  /** An aggregate relationship */
  sequencesAggregate: EventGroupSequencesAggregate;
  startsAt?: Maybe<Scalars['timestamptz']>;
  teamLimit?: Maybe<Scalars['Int']>;
  teamType?: Maybe<TeamTypesEnum>;
  /** An array relationship */
  teams: Array<EventTeams>;
  /** An aggregate relationship */
  teamsAggregate: EventTeamsAggregate;
  /** An array relationship */
  timeSlots: Array<EventGroupTimeSlots>;
  /** An aggregate relationship */
  timeSlotsAggregate: EventGroupTimeSlotsAggregate;
  title: Scalars['String'];
  totalPoints?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['timestamptz'];
  winBy?: Maybe<Scalars['Int']>;
};


/** columns and relationships of "event_groups" */
export type EventGroupsCouponGroupsArgs = {
  distinctOn?: InputMaybe<Array<EventCouponGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventCouponGroupsOrderBy>>;
  where?: InputMaybe<EventCouponGroupsBoolExp>;
};


/** columns and relationships of "event_groups" */
export type EventGroupsCouponGroupsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventCouponGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventCouponGroupsOrderBy>>;
  where?: InputMaybe<EventCouponGroupsBoolExp>;
};


/** columns and relationships of "event_groups" */
export type EventGroupsCourtsArgs = {
  distinctOn?: InputMaybe<Array<EventCourtsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventCourtsOrderBy>>;
  where?: InputMaybe<EventCourtsBoolExp>;
};


/** columns and relationships of "event_groups" */
export type EventGroupsCourtsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventCourtsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventCourtsOrderBy>>;
  where?: InputMaybe<EventCourtsBoolExp>;
};


/** columns and relationships of "event_groups" */
export type EventGroupsMoneyBallRewardsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "event_groups" */
export type EventGroupsPoolsArgs = {
  distinctOn?: InputMaybe<Array<EventGroupPoolsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGroupPoolsOrderBy>>;
  where?: InputMaybe<EventGroupPoolsBoolExp>;
};


/** columns and relationships of "event_groups" */
export type EventGroupsPoolsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventGroupPoolsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGroupPoolsOrderBy>>;
  where?: InputMaybe<EventGroupPoolsBoolExp>;
};


/** columns and relationships of "event_groups" */
export type EventGroupsRatingScalesArgs = {
  distinctOn?: InputMaybe<Array<EventGroupRatingScalesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGroupRatingScalesOrderBy>>;
  where?: InputMaybe<EventGroupRatingScalesBoolExp>;
};


/** columns and relationships of "event_groups" */
export type EventGroupsRatingScalesAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventGroupRatingScalesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGroupRatingScalesOrderBy>>;
  where?: InputMaybe<EventGroupRatingScalesBoolExp>;
};


/** columns and relationships of "event_groups" */
export type EventGroupsRegistrationsArgs = {
  distinctOn?: InputMaybe<Array<EventGroupRegistrationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGroupRegistrationsOrderBy>>;
  where?: InputMaybe<EventGroupRegistrationsBoolExp>;
};


/** columns and relationships of "event_groups" */
export type EventGroupsRegistrationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventGroupRegistrationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGroupRegistrationsOrderBy>>;
  where?: InputMaybe<EventGroupRegistrationsBoolExp>;
};


/** columns and relationships of "event_groups" */
export type EventGroupsSequencesArgs = {
  distinctOn?: InputMaybe<Array<EventGroupSequencesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGroupSequencesOrderBy>>;
  where?: InputMaybe<EventGroupSequencesBoolExp>;
};


/** columns and relationships of "event_groups" */
export type EventGroupsSequencesAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventGroupSequencesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGroupSequencesOrderBy>>;
  where?: InputMaybe<EventGroupSequencesBoolExp>;
};


/** columns and relationships of "event_groups" */
export type EventGroupsTeamsArgs = {
  distinctOn?: InputMaybe<Array<EventTeamsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventTeamsOrderBy>>;
  where?: InputMaybe<EventTeamsBoolExp>;
};


/** columns and relationships of "event_groups" */
export type EventGroupsTeamsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventTeamsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventTeamsOrderBy>>;
  where?: InputMaybe<EventTeamsBoolExp>;
};


/** columns and relationships of "event_groups" */
export type EventGroupsTimeSlotsArgs = {
  distinctOn?: InputMaybe<Array<EventGroupTimeSlotsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGroupTimeSlotsOrderBy>>;
  where?: InputMaybe<EventGroupTimeSlotsBoolExp>;
};


/** columns and relationships of "event_groups" */
export type EventGroupsTimeSlotsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventGroupTimeSlotsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGroupTimeSlotsOrderBy>>;
  where?: InputMaybe<EventGroupTimeSlotsBoolExp>;
};

/** aggregated selection of "event_groups" */
export type EventGroupsAggregate = {
  __typename?: 'EventGroupsAggregate';
  aggregate?: Maybe<EventGroupsAggregateFields>;
  nodes: Array<EventGroups>;
};

export type EventGroupsAggregateBoolExp = {
  bool_and?: InputMaybe<EventGroupsAggregateBoolExpBool_And>;
  bool_or?: InputMaybe<EventGroupsAggregateBoolExpBool_Or>;
  count?: InputMaybe<EventGroupsAggregateBoolExpCount>;
};

/** aggregate fields of "event_groups" */
export type EventGroupsAggregateFields = {
  __typename?: 'EventGroupsAggregateFields';
  avg?: Maybe<EventGroupsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<EventGroupsMaxFields>;
  min?: Maybe<EventGroupsMinFields>;
  stddev?: Maybe<EventGroupsStddevFields>;
  stddevPop?: Maybe<EventGroupsStddevPopFields>;
  stddevSamp?: Maybe<EventGroupsStddevSampFields>;
  sum?: Maybe<EventGroupsSumFields>;
  varPop?: Maybe<EventGroupsVarPopFields>;
  varSamp?: Maybe<EventGroupsVarSampFields>;
  variance?: Maybe<EventGroupsVarianceFields>;
};


/** aggregate fields of "event_groups" */
export type EventGroupsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EventGroupsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "event_groups" */
export type EventGroupsAggregateOrderBy = {
  avg?: InputMaybe<EventGroupsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EventGroupsMaxOrderBy>;
  min?: InputMaybe<EventGroupsMinOrderBy>;
  stddev?: InputMaybe<EventGroupsStddevOrderBy>;
  stddevPop?: InputMaybe<EventGroupsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<EventGroupsStddevSampOrderBy>;
  sum?: InputMaybe<EventGroupsSumOrderBy>;
  varPop?: InputMaybe<EventGroupsVarPopOrderBy>;
  varSamp?: InputMaybe<EventGroupsVarSampOrderBy>;
  variance?: InputMaybe<EventGroupsVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type EventGroupsAppendInput = {
  moneyBallRewards?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "event_groups" */
export type EventGroupsArrRelInsertInput = {
  data: Array<EventGroupsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<EventGroupsOnConflict>;
};

/** aggregate avg on columns */
export type EventGroupsAvgFields = {
  __typename?: 'EventGroupsAvgFields';
  desiredNumberOfPools?: Maybe<Scalars['Float']>;
  gamesPerMatch?: Maybe<Scalars['Float']>;
  maximumAge?: Maybe<Scalars['Float']>;
  maximumRating?: Maybe<Scalars['Float']>;
  minimumAge?: Maybe<Scalars['Float']>;
  minimumNumberOfGames?: Maybe<Scalars['Float']>;
  minimumRating?: Maybe<Scalars['Float']>;
  numberOfEliminationTeams?: Maybe<Scalars['Float']>;
  numberOfEstimatedCourts?: Maybe<Scalars['Float']>;
  priceUnitAmount?: Maybe<Scalars['Float']>;
  teamLimit?: Maybe<Scalars['Float']>;
  totalPoints?: Maybe<Scalars['Float']>;
  winBy?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "event_groups" */
export type EventGroupsAvgOrderBy = {
  desiredNumberOfPools?: InputMaybe<OrderBy>;
  gamesPerMatch?: InputMaybe<OrderBy>;
  maximumAge?: InputMaybe<OrderBy>;
  maximumRating?: InputMaybe<OrderBy>;
  minimumAge?: InputMaybe<OrderBy>;
  minimumNumberOfGames?: InputMaybe<OrderBy>;
  minimumRating?: InputMaybe<OrderBy>;
  numberOfEliminationTeams?: InputMaybe<OrderBy>;
  numberOfEstimatedCourts?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  teamLimit?: InputMaybe<OrderBy>;
  totalPoints?: InputMaybe<OrderBy>;
  winBy?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "event_groups". All fields are combined with a logical 'AND'. */
export type EventGroupsBoolExp = {
  _and?: InputMaybe<Array<EventGroupsBoolExp>>;
  _not?: InputMaybe<EventGroupsBoolExp>;
  _or?: InputMaybe<Array<EventGroupsBoolExp>>;
  bracketRankingMechanism?: InputMaybe<BracketRankingMechanismEnumComparisonExp>;
  competitiveness?: InputMaybe<EventCompetitivenessEnumComparisonExp>;
  couponGroups?: InputMaybe<EventCouponGroupsBoolExp>;
  couponGroupsAggregate?: InputMaybe<EventCouponGroupsAggregateBoolExp>;
  courts?: InputMaybe<EventCourtsBoolExp>;
  courtsAggregate?: InputMaybe<EventCourtsAggregateBoolExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  desiredNumberOfPools?: InputMaybe<IntComparisonExp>;
  endsAt?: InputMaybe<TimestamptzComparisonExp>;
  event?: InputMaybe<EventsBoolExp>;
  eventId?: InputMaybe<UuidComparisonExp>;
  format?: InputMaybe<EventGroupFormatsEnumComparisonExp>;
  formatCustomName?: InputMaybe<StringComparisonExp>;
  gamesPerMatch?: InputMaybe<IntComparisonExp>;
  gender?: InputMaybe<CompetitionGenderEnumComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isAgeRestricted?: InputMaybe<BooleanComparisonExp>;
  isMoneyBall?: InputMaybe<BooleanComparisonExp>;
  isRatingRequired?: InputMaybe<BooleanComparisonExp>;
  isVairRatingSession?: InputMaybe<BooleanComparisonExp>;
  isVairVairifiedRequired?: InputMaybe<BooleanComparisonExp>;
  isWheelchair?: InputMaybe<BooleanComparisonExp>;
  maximumAge?: InputMaybe<IntComparisonExp>;
  maximumRating?: InputMaybe<NumericComparisonExp>;
  merge?: InputMaybe<EventGroupMergesBoolExp>;
  mergeId?: InputMaybe<UuidComparisonExp>;
  minimumAge?: InputMaybe<IntComparisonExp>;
  minimumNumberOfGames?: InputMaybe<IntComparisonExp>;
  minimumRating?: InputMaybe<NumericComparisonExp>;
  moneyBallRewards?: InputMaybe<JsonbComparisonExp>;
  netStatus?: InputMaybe<GameNetStatusesEnumComparisonExp>;
  numberOfEliminationTeams?: InputMaybe<IntComparisonExp>;
  numberOfEstimatedCourts?: InputMaybe<IntComparisonExp>;
  pools?: InputMaybe<EventGroupPoolsBoolExp>;
  poolsAggregate?: InputMaybe<EventGroupPoolsAggregateBoolExp>;
  priceUnitAmount?: InputMaybe<IntComparisonExp>;
  ratingScales?: InputMaybe<EventGroupRatingScalesBoolExp>;
  ratingScalesAggregate?: InputMaybe<EventGroupRatingScalesAggregateBoolExp>;
  registrations?: InputMaybe<EventGroupRegistrationsBoolExp>;
  registrationsAggregate?: InputMaybe<EventGroupRegistrationsAggregateBoolExp>;
  scoringFormat?: InputMaybe<ScoringFormatEnumComparisonExp>;
  selfRatedMaxSkillLevel?: InputMaybe<SkillLevelsBoolExp>;
  selfRatedMaxSkillLevelId?: InputMaybe<StringComparisonExp>;
  selfRatedMinSkillLevel?: InputMaybe<SkillLevelsBoolExp>;
  selfRatedMinSkillLevelId?: InputMaybe<StringComparisonExp>;
  sequences?: InputMaybe<EventGroupSequencesBoolExp>;
  sequencesAggregate?: InputMaybe<EventGroupSequencesAggregateBoolExp>;
  startsAt?: InputMaybe<TimestamptzComparisonExp>;
  teamLimit?: InputMaybe<IntComparisonExp>;
  teamType?: InputMaybe<TeamTypesEnumComparisonExp>;
  teams?: InputMaybe<EventTeamsBoolExp>;
  teamsAggregate?: InputMaybe<EventTeamsAggregateBoolExp>;
  timeSlots?: InputMaybe<EventGroupTimeSlotsBoolExp>;
  timeSlotsAggregate?: InputMaybe<EventGroupTimeSlotsAggregateBoolExp>;
  title?: InputMaybe<StringComparisonExp>;
  totalPoints?: InputMaybe<IntComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  winBy?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "event_groups" */
export enum EventGroupsConstraint {
  /** unique or primary key constraint on columns "id" */
  EventGroupsPkey = 'event_groups_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type EventGroupsDeleteAtPathInput = {
  moneyBallRewards?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type EventGroupsDeleteElemInput = {
  moneyBallRewards?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type EventGroupsDeleteKeyInput = {
  moneyBallRewards?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "event_groups" */
export type EventGroupsIncInput = {
  desiredNumberOfPools?: InputMaybe<Scalars['Int']>;
  gamesPerMatch?: InputMaybe<Scalars['Int']>;
  maximumAge?: InputMaybe<Scalars['Int']>;
  maximumRating?: InputMaybe<Scalars['numeric']>;
  minimumAge?: InputMaybe<Scalars['Int']>;
  minimumNumberOfGames?: InputMaybe<Scalars['Int']>;
  minimumRating?: InputMaybe<Scalars['numeric']>;
  numberOfEliminationTeams?: InputMaybe<Scalars['Int']>;
  numberOfEstimatedCourts?: InputMaybe<Scalars['Int']>;
  priceUnitAmount?: InputMaybe<Scalars['Int']>;
  teamLimit?: InputMaybe<Scalars['Int']>;
  totalPoints?: InputMaybe<Scalars['Int']>;
  winBy?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "event_groups" */
export type EventGroupsInsertInput = {
  bracketRankingMechanism?: InputMaybe<BracketRankingMechanismEnum>;
  competitiveness?: InputMaybe<EventCompetitivenessEnum>;
  couponGroups?: InputMaybe<EventCouponGroupsArrRelInsertInput>;
  courts?: InputMaybe<EventCourtsArrRelInsertInput>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  desiredNumberOfPools?: InputMaybe<Scalars['Int']>;
  endsAt?: InputMaybe<Scalars['timestamptz']>;
  event?: InputMaybe<EventsObjRelInsertInput>;
  eventId?: InputMaybe<Scalars['uuid']>;
  format?: InputMaybe<EventGroupFormatsEnum>;
  formatCustomName?: InputMaybe<Scalars['String']>;
  gamesPerMatch?: InputMaybe<Scalars['Int']>;
  gender?: InputMaybe<CompetitionGenderEnum>;
  id?: InputMaybe<Scalars['uuid']>;
  isAgeRestricted?: InputMaybe<Scalars['Boolean']>;
  isMoneyBall?: InputMaybe<Scalars['Boolean']>;
  isRatingRequired?: InputMaybe<Scalars['Boolean']>;
  isVairRatingSession?: InputMaybe<Scalars['Boolean']>;
  isVairVairifiedRequired?: InputMaybe<Scalars['Boolean']>;
  isWheelchair?: InputMaybe<Scalars['Boolean']>;
  maximumAge?: InputMaybe<Scalars['Int']>;
  maximumRating?: InputMaybe<Scalars['numeric']>;
  merge?: InputMaybe<EventGroupMergesObjRelInsertInput>;
  mergeId?: InputMaybe<Scalars['uuid']>;
  minimumAge?: InputMaybe<Scalars['Int']>;
  minimumNumberOfGames?: InputMaybe<Scalars['Int']>;
  minimumRating?: InputMaybe<Scalars['numeric']>;
  moneyBallRewards?: InputMaybe<Scalars['jsonb']>;
  netStatus?: InputMaybe<GameNetStatusesEnum>;
  numberOfEliminationTeams?: InputMaybe<Scalars['Int']>;
  numberOfEstimatedCourts?: InputMaybe<Scalars['Int']>;
  pools?: InputMaybe<EventGroupPoolsArrRelInsertInput>;
  priceUnitAmount?: InputMaybe<Scalars['Int']>;
  ratingScales?: InputMaybe<EventGroupRatingScalesArrRelInsertInput>;
  registrations?: InputMaybe<EventGroupRegistrationsArrRelInsertInput>;
  scoringFormat?: InputMaybe<ScoringFormatEnum>;
  selfRatedMaxSkillLevel?: InputMaybe<SkillLevelsObjRelInsertInput>;
  selfRatedMaxSkillLevelId?: InputMaybe<Scalars['String']>;
  selfRatedMinSkillLevel?: InputMaybe<SkillLevelsObjRelInsertInput>;
  selfRatedMinSkillLevelId?: InputMaybe<Scalars['String']>;
  sequences?: InputMaybe<EventGroupSequencesArrRelInsertInput>;
  startsAt?: InputMaybe<Scalars['timestamptz']>;
  teamLimit?: InputMaybe<Scalars['Int']>;
  teamType?: InputMaybe<TeamTypesEnum>;
  teams?: InputMaybe<EventTeamsArrRelInsertInput>;
  timeSlots?: InputMaybe<EventGroupTimeSlotsArrRelInsertInput>;
  title?: InputMaybe<Scalars['String']>;
  totalPoints?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  winBy?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type EventGroupsMaxFields = {
  __typename?: 'EventGroupsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  desiredNumberOfPools?: Maybe<Scalars['Int']>;
  endsAt?: Maybe<Scalars['timestamptz']>;
  eventId?: Maybe<Scalars['uuid']>;
  formatCustomName?: Maybe<Scalars['String']>;
  gamesPerMatch?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  maximumAge?: Maybe<Scalars['Int']>;
  maximumRating?: Maybe<Scalars['numeric']>;
  mergeId?: Maybe<Scalars['uuid']>;
  minimumAge?: Maybe<Scalars['Int']>;
  minimumNumberOfGames?: Maybe<Scalars['Int']>;
  minimumRating?: Maybe<Scalars['numeric']>;
  numberOfEliminationTeams?: Maybe<Scalars['Int']>;
  numberOfEstimatedCourts?: Maybe<Scalars['Int']>;
  priceUnitAmount?: Maybe<Scalars['Int']>;
  selfRatedMaxSkillLevelId?: Maybe<Scalars['String']>;
  selfRatedMinSkillLevelId?: Maybe<Scalars['String']>;
  startsAt?: Maybe<Scalars['timestamptz']>;
  teamLimit?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  totalPoints?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  winBy?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "event_groups" */
export type EventGroupsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  desiredNumberOfPools?: InputMaybe<OrderBy>;
  endsAt?: InputMaybe<OrderBy>;
  eventId?: InputMaybe<OrderBy>;
  formatCustomName?: InputMaybe<OrderBy>;
  gamesPerMatch?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  maximumAge?: InputMaybe<OrderBy>;
  maximumRating?: InputMaybe<OrderBy>;
  mergeId?: InputMaybe<OrderBy>;
  minimumAge?: InputMaybe<OrderBy>;
  minimumNumberOfGames?: InputMaybe<OrderBy>;
  minimumRating?: InputMaybe<OrderBy>;
  numberOfEliminationTeams?: InputMaybe<OrderBy>;
  numberOfEstimatedCourts?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  selfRatedMaxSkillLevelId?: InputMaybe<OrderBy>;
  selfRatedMinSkillLevelId?: InputMaybe<OrderBy>;
  startsAt?: InputMaybe<OrderBy>;
  teamLimit?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  totalPoints?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  winBy?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type EventGroupsMinFields = {
  __typename?: 'EventGroupsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  desiredNumberOfPools?: Maybe<Scalars['Int']>;
  endsAt?: Maybe<Scalars['timestamptz']>;
  eventId?: Maybe<Scalars['uuid']>;
  formatCustomName?: Maybe<Scalars['String']>;
  gamesPerMatch?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  maximumAge?: Maybe<Scalars['Int']>;
  maximumRating?: Maybe<Scalars['numeric']>;
  mergeId?: Maybe<Scalars['uuid']>;
  minimumAge?: Maybe<Scalars['Int']>;
  minimumNumberOfGames?: Maybe<Scalars['Int']>;
  minimumRating?: Maybe<Scalars['numeric']>;
  numberOfEliminationTeams?: Maybe<Scalars['Int']>;
  numberOfEstimatedCourts?: Maybe<Scalars['Int']>;
  priceUnitAmount?: Maybe<Scalars['Int']>;
  selfRatedMaxSkillLevelId?: Maybe<Scalars['String']>;
  selfRatedMinSkillLevelId?: Maybe<Scalars['String']>;
  startsAt?: Maybe<Scalars['timestamptz']>;
  teamLimit?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  totalPoints?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  winBy?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "event_groups" */
export type EventGroupsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  desiredNumberOfPools?: InputMaybe<OrderBy>;
  endsAt?: InputMaybe<OrderBy>;
  eventId?: InputMaybe<OrderBy>;
  formatCustomName?: InputMaybe<OrderBy>;
  gamesPerMatch?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  maximumAge?: InputMaybe<OrderBy>;
  maximumRating?: InputMaybe<OrderBy>;
  mergeId?: InputMaybe<OrderBy>;
  minimumAge?: InputMaybe<OrderBy>;
  minimumNumberOfGames?: InputMaybe<OrderBy>;
  minimumRating?: InputMaybe<OrderBy>;
  numberOfEliminationTeams?: InputMaybe<OrderBy>;
  numberOfEstimatedCourts?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  selfRatedMaxSkillLevelId?: InputMaybe<OrderBy>;
  selfRatedMinSkillLevelId?: InputMaybe<OrderBy>;
  startsAt?: InputMaybe<OrderBy>;
  teamLimit?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  totalPoints?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  winBy?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "event_groups" */
export type EventGroupsMutationResponse = {
  __typename?: 'EventGroupsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventGroups>;
};

/** input type for inserting object relation for remote table "event_groups" */
export type EventGroupsObjRelInsertInput = {
  data: EventGroupsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<EventGroupsOnConflict>;
};

/** on_conflict condition type for table "event_groups" */
export type EventGroupsOnConflict = {
  constraint: EventGroupsConstraint;
  updateColumns?: Array<EventGroupsUpdateColumn>;
  where?: InputMaybe<EventGroupsBoolExp>;
};

/** Ordering options when selecting data from "event_groups". */
export type EventGroupsOrderBy = {
  bracketRankingMechanism?: InputMaybe<OrderBy>;
  competitiveness?: InputMaybe<OrderBy>;
  couponGroupsAggregate?: InputMaybe<EventCouponGroupsAggregateOrderBy>;
  courtsAggregate?: InputMaybe<EventCourtsAggregateOrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  desiredNumberOfPools?: InputMaybe<OrderBy>;
  endsAt?: InputMaybe<OrderBy>;
  event?: InputMaybe<EventsOrderBy>;
  eventId?: InputMaybe<OrderBy>;
  format?: InputMaybe<OrderBy>;
  formatCustomName?: InputMaybe<OrderBy>;
  gamesPerMatch?: InputMaybe<OrderBy>;
  gender?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  isAgeRestricted?: InputMaybe<OrderBy>;
  isMoneyBall?: InputMaybe<OrderBy>;
  isRatingRequired?: InputMaybe<OrderBy>;
  isVairRatingSession?: InputMaybe<OrderBy>;
  isVairVairifiedRequired?: InputMaybe<OrderBy>;
  isWheelchair?: InputMaybe<OrderBy>;
  maximumAge?: InputMaybe<OrderBy>;
  maximumRating?: InputMaybe<OrderBy>;
  merge?: InputMaybe<EventGroupMergesOrderBy>;
  mergeId?: InputMaybe<OrderBy>;
  minimumAge?: InputMaybe<OrderBy>;
  minimumNumberOfGames?: InputMaybe<OrderBy>;
  minimumRating?: InputMaybe<OrderBy>;
  moneyBallRewards?: InputMaybe<OrderBy>;
  netStatus?: InputMaybe<OrderBy>;
  numberOfEliminationTeams?: InputMaybe<OrderBy>;
  numberOfEstimatedCourts?: InputMaybe<OrderBy>;
  poolsAggregate?: InputMaybe<EventGroupPoolsAggregateOrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  ratingScalesAggregate?: InputMaybe<EventGroupRatingScalesAggregateOrderBy>;
  registrationsAggregate?: InputMaybe<EventGroupRegistrationsAggregateOrderBy>;
  scoringFormat?: InputMaybe<OrderBy>;
  selfRatedMaxSkillLevel?: InputMaybe<SkillLevelsOrderBy>;
  selfRatedMaxSkillLevelId?: InputMaybe<OrderBy>;
  selfRatedMinSkillLevel?: InputMaybe<SkillLevelsOrderBy>;
  selfRatedMinSkillLevelId?: InputMaybe<OrderBy>;
  sequencesAggregate?: InputMaybe<EventGroupSequencesAggregateOrderBy>;
  startsAt?: InputMaybe<OrderBy>;
  teamLimit?: InputMaybe<OrderBy>;
  teamType?: InputMaybe<OrderBy>;
  teamsAggregate?: InputMaybe<EventTeamsAggregateOrderBy>;
  timeSlotsAggregate?: InputMaybe<EventGroupTimeSlotsAggregateOrderBy>;
  title?: InputMaybe<OrderBy>;
  totalPoints?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  winBy?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: event_groups */
export type EventGroupsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type EventGroupsPrependInput = {
  moneyBallRewards?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "event_groups" */
export enum EventGroupsSelectColumn {
  /** column name */
  BracketRankingMechanism = 'bracketRankingMechanism',
  /** column name */
  Competitiveness = 'competitiveness',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  DesiredNumberOfPools = 'desiredNumberOfPools',
  /** column name */
  EndsAt = 'endsAt',
  /** column name */
  EventId = 'eventId',
  /** column name */
  Format = 'format',
  /** column name */
  FormatCustomName = 'formatCustomName',
  /** column name */
  GamesPerMatch = 'gamesPerMatch',
  /** column name */
  Gender = 'gender',
  /** column name */
  Id = 'id',
  /** column name */
  IsAgeRestricted = 'isAgeRestricted',
  /** column name */
  IsMoneyBall = 'isMoneyBall',
  /** column name */
  IsRatingRequired = 'isRatingRequired',
  /** column name */
  IsVairRatingSession = 'isVairRatingSession',
  /** column name */
  IsVairVairifiedRequired = 'isVairVairifiedRequired',
  /** column name */
  IsWheelchair = 'isWheelchair',
  /** column name */
  MaximumAge = 'maximumAge',
  /** column name */
  MaximumRating = 'maximumRating',
  /** column name */
  MergeId = 'mergeId',
  /** column name */
  MinimumAge = 'minimumAge',
  /** column name */
  MinimumNumberOfGames = 'minimumNumberOfGames',
  /** column name */
  MinimumRating = 'minimumRating',
  /** column name */
  MoneyBallRewards = 'moneyBallRewards',
  /** column name */
  NetStatus = 'netStatus',
  /** column name */
  NumberOfEliminationTeams = 'numberOfEliminationTeams',
  /** column name */
  NumberOfEstimatedCourts = 'numberOfEstimatedCourts',
  /** column name */
  PriceUnitAmount = 'priceUnitAmount',
  /** column name */
  ScoringFormat = 'scoringFormat',
  /** column name */
  SelfRatedMaxSkillLevelId = 'selfRatedMaxSkillLevelId',
  /** column name */
  SelfRatedMinSkillLevelId = 'selfRatedMinSkillLevelId',
  /** column name */
  StartsAt = 'startsAt',
  /** column name */
  TeamLimit = 'teamLimit',
  /** column name */
  TeamType = 'teamType',
  /** column name */
  Title = 'title',
  /** column name */
  TotalPoints = 'totalPoints',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  WinBy = 'winBy'
}

/** select "eventGroupsAggregateBoolExpBool_andArgumentsColumns" columns of table "event_groups" */
export enum EventGroupsSelectColumnEventGroupsAggregateBoolExpBool_AndArgumentsColumns {
  /** column name */
  IsAgeRestricted = 'isAgeRestricted',
  /** column name */
  IsMoneyBall = 'isMoneyBall',
  /** column name */
  IsRatingRequired = 'isRatingRequired',
  /** column name */
  IsVairRatingSession = 'isVairRatingSession',
  /** column name */
  IsVairVairifiedRequired = 'isVairVairifiedRequired',
  /** column name */
  IsWheelchair = 'isWheelchair'
}

/** select "eventGroupsAggregateBoolExpBool_orArgumentsColumns" columns of table "event_groups" */
export enum EventGroupsSelectColumnEventGroupsAggregateBoolExpBool_OrArgumentsColumns {
  /** column name */
  IsAgeRestricted = 'isAgeRestricted',
  /** column name */
  IsMoneyBall = 'isMoneyBall',
  /** column name */
  IsRatingRequired = 'isRatingRequired',
  /** column name */
  IsVairRatingSession = 'isVairRatingSession',
  /** column name */
  IsVairVairifiedRequired = 'isVairVairifiedRequired',
  /** column name */
  IsWheelchair = 'isWheelchair'
}

/** input type for updating data in table "event_groups" */
export type EventGroupsSetInput = {
  bracketRankingMechanism?: InputMaybe<BracketRankingMechanismEnum>;
  competitiveness?: InputMaybe<EventCompetitivenessEnum>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  desiredNumberOfPools?: InputMaybe<Scalars['Int']>;
  endsAt?: InputMaybe<Scalars['timestamptz']>;
  eventId?: InputMaybe<Scalars['uuid']>;
  format?: InputMaybe<EventGroupFormatsEnum>;
  formatCustomName?: InputMaybe<Scalars['String']>;
  gamesPerMatch?: InputMaybe<Scalars['Int']>;
  gender?: InputMaybe<CompetitionGenderEnum>;
  id?: InputMaybe<Scalars['uuid']>;
  isAgeRestricted?: InputMaybe<Scalars['Boolean']>;
  isMoneyBall?: InputMaybe<Scalars['Boolean']>;
  isRatingRequired?: InputMaybe<Scalars['Boolean']>;
  isVairRatingSession?: InputMaybe<Scalars['Boolean']>;
  isVairVairifiedRequired?: InputMaybe<Scalars['Boolean']>;
  isWheelchair?: InputMaybe<Scalars['Boolean']>;
  maximumAge?: InputMaybe<Scalars['Int']>;
  maximumRating?: InputMaybe<Scalars['numeric']>;
  mergeId?: InputMaybe<Scalars['uuid']>;
  minimumAge?: InputMaybe<Scalars['Int']>;
  minimumNumberOfGames?: InputMaybe<Scalars['Int']>;
  minimumRating?: InputMaybe<Scalars['numeric']>;
  moneyBallRewards?: InputMaybe<Scalars['jsonb']>;
  netStatus?: InputMaybe<GameNetStatusesEnum>;
  numberOfEliminationTeams?: InputMaybe<Scalars['Int']>;
  numberOfEstimatedCourts?: InputMaybe<Scalars['Int']>;
  priceUnitAmount?: InputMaybe<Scalars['Int']>;
  scoringFormat?: InputMaybe<ScoringFormatEnum>;
  selfRatedMaxSkillLevelId?: InputMaybe<Scalars['String']>;
  selfRatedMinSkillLevelId?: InputMaybe<Scalars['String']>;
  startsAt?: InputMaybe<Scalars['timestamptz']>;
  teamLimit?: InputMaybe<Scalars['Int']>;
  teamType?: InputMaybe<TeamTypesEnum>;
  title?: InputMaybe<Scalars['String']>;
  totalPoints?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  winBy?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type EventGroupsStddevFields = {
  __typename?: 'EventGroupsStddevFields';
  desiredNumberOfPools?: Maybe<Scalars['Float']>;
  gamesPerMatch?: Maybe<Scalars['Float']>;
  maximumAge?: Maybe<Scalars['Float']>;
  maximumRating?: Maybe<Scalars['Float']>;
  minimumAge?: Maybe<Scalars['Float']>;
  minimumNumberOfGames?: Maybe<Scalars['Float']>;
  minimumRating?: Maybe<Scalars['Float']>;
  numberOfEliminationTeams?: Maybe<Scalars['Float']>;
  numberOfEstimatedCourts?: Maybe<Scalars['Float']>;
  priceUnitAmount?: Maybe<Scalars['Float']>;
  teamLimit?: Maybe<Scalars['Float']>;
  totalPoints?: Maybe<Scalars['Float']>;
  winBy?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "event_groups" */
export type EventGroupsStddevOrderBy = {
  desiredNumberOfPools?: InputMaybe<OrderBy>;
  gamesPerMatch?: InputMaybe<OrderBy>;
  maximumAge?: InputMaybe<OrderBy>;
  maximumRating?: InputMaybe<OrderBy>;
  minimumAge?: InputMaybe<OrderBy>;
  minimumNumberOfGames?: InputMaybe<OrderBy>;
  minimumRating?: InputMaybe<OrderBy>;
  numberOfEliminationTeams?: InputMaybe<OrderBy>;
  numberOfEstimatedCourts?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  teamLimit?: InputMaybe<OrderBy>;
  totalPoints?: InputMaybe<OrderBy>;
  winBy?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type EventGroupsStddevPopFields = {
  __typename?: 'EventGroupsStddevPopFields';
  desiredNumberOfPools?: Maybe<Scalars['Float']>;
  gamesPerMatch?: Maybe<Scalars['Float']>;
  maximumAge?: Maybe<Scalars['Float']>;
  maximumRating?: Maybe<Scalars['Float']>;
  minimumAge?: Maybe<Scalars['Float']>;
  minimumNumberOfGames?: Maybe<Scalars['Float']>;
  minimumRating?: Maybe<Scalars['Float']>;
  numberOfEliminationTeams?: Maybe<Scalars['Float']>;
  numberOfEstimatedCourts?: Maybe<Scalars['Float']>;
  priceUnitAmount?: Maybe<Scalars['Float']>;
  teamLimit?: Maybe<Scalars['Float']>;
  totalPoints?: Maybe<Scalars['Float']>;
  winBy?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "event_groups" */
export type EventGroupsStddevPopOrderBy = {
  desiredNumberOfPools?: InputMaybe<OrderBy>;
  gamesPerMatch?: InputMaybe<OrderBy>;
  maximumAge?: InputMaybe<OrderBy>;
  maximumRating?: InputMaybe<OrderBy>;
  minimumAge?: InputMaybe<OrderBy>;
  minimumNumberOfGames?: InputMaybe<OrderBy>;
  minimumRating?: InputMaybe<OrderBy>;
  numberOfEliminationTeams?: InputMaybe<OrderBy>;
  numberOfEstimatedCourts?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  teamLimit?: InputMaybe<OrderBy>;
  totalPoints?: InputMaybe<OrderBy>;
  winBy?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type EventGroupsStddevSampFields = {
  __typename?: 'EventGroupsStddevSampFields';
  desiredNumberOfPools?: Maybe<Scalars['Float']>;
  gamesPerMatch?: Maybe<Scalars['Float']>;
  maximumAge?: Maybe<Scalars['Float']>;
  maximumRating?: Maybe<Scalars['Float']>;
  minimumAge?: Maybe<Scalars['Float']>;
  minimumNumberOfGames?: Maybe<Scalars['Float']>;
  minimumRating?: Maybe<Scalars['Float']>;
  numberOfEliminationTeams?: Maybe<Scalars['Float']>;
  numberOfEstimatedCourts?: Maybe<Scalars['Float']>;
  priceUnitAmount?: Maybe<Scalars['Float']>;
  teamLimit?: Maybe<Scalars['Float']>;
  totalPoints?: Maybe<Scalars['Float']>;
  winBy?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "event_groups" */
export type EventGroupsStddevSampOrderBy = {
  desiredNumberOfPools?: InputMaybe<OrderBy>;
  gamesPerMatch?: InputMaybe<OrderBy>;
  maximumAge?: InputMaybe<OrderBy>;
  maximumRating?: InputMaybe<OrderBy>;
  minimumAge?: InputMaybe<OrderBy>;
  minimumNumberOfGames?: InputMaybe<OrderBy>;
  minimumRating?: InputMaybe<OrderBy>;
  numberOfEliminationTeams?: InputMaybe<OrderBy>;
  numberOfEstimatedCourts?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  teamLimit?: InputMaybe<OrderBy>;
  totalPoints?: InputMaybe<OrderBy>;
  winBy?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "event_groups" */
export type EventGroupsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventGroupsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventGroupsStreamCursorValueInput = {
  bracketRankingMechanism?: InputMaybe<BracketRankingMechanismEnum>;
  competitiveness?: InputMaybe<EventCompetitivenessEnum>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  desiredNumberOfPools?: InputMaybe<Scalars['Int']>;
  endsAt?: InputMaybe<Scalars['timestamptz']>;
  eventId?: InputMaybe<Scalars['uuid']>;
  format?: InputMaybe<EventGroupFormatsEnum>;
  formatCustomName?: InputMaybe<Scalars['String']>;
  gamesPerMatch?: InputMaybe<Scalars['Int']>;
  gender?: InputMaybe<CompetitionGenderEnum>;
  id?: InputMaybe<Scalars['uuid']>;
  isAgeRestricted?: InputMaybe<Scalars['Boolean']>;
  isMoneyBall?: InputMaybe<Scalars['Boolean']>;
  isRatingRequired?: InputMaybe<Scalars['Boolean']>;
  isVairRatingSession?: InputMaybe<Scalars['Boolean']>;
  isVairVairifiedRequired?: InputMaybe<Scalars['Boolean']>;
  isWheelchair?: InputMaybe<Scalars['Boolean']>;
  maximumAge?: InputMaybe<Scalars['Int']>;
  maximumRating?: InputMaybe<Scalars['numeric']>;
  mergeId?: InputMaybe<Scalars['uuid']>;
  minimumAge?: InputMaybe<Scalars['Int']>;
  minimumNumberOfGames?: InputMaybe<Scalars['Int']>;
  minimumRating?: InputMaybe<Scalars['numeric']>;
  moneyBallRewards?: InputMaybe<Scalars['jsonb']>;
  netStatus?: InputMaybe<GameNetStatusesEnum>;
  numberOfEliminationTeams?: InputMaybe<Scalars['Int']>;
  numberOfEstimatedCourts?: InputMaybe<Scalars['Int']>;
  priceUnitAmount?: InputMaybe<Scalars['Int']>;
  scoringFormat?: InputMaybe<ScoringFormatEnum>;
  selfRatedMaxSkillLevelId?: InputMaybe<Scalars['String']>;
  selfRatedMinSkillLevelId?: InputMaybe<Scalars['String']>;
  startsAt?: InputMaybe<Scalars['timestamptz']>;
  teamLimit?: InputMaybe<Scalars['Int']>;
  teamType?: InputMaybe<TeamTypesEnum>;
  title?: InputMaybe<Scalars['String']>;
  totalPoints?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  winBy?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type EventGroupsSumFields = {
  __typename?: 'EventGroupsSumFields';
  desiredNumberOfPools?: Maybe<Scalars['Int']>;
  gamesPerMatch?: Maybe<Scalars['Int']>;
  maximumAge?: Maybe<Scalars['Int']>;
  maximumRating?: Maybe<Scalars['numeric']>;
  minimumAge?: Maybe<Scalars['Int']>;
  minimumNumberOfGames?: Maybe<Scalars['Int']>;
  minimumRating?: Maybe<Scalars['numeric']>;
  numberOfEliminationTeams?: Maybe<Scalars['Int']>;
  numberOfEstimatedCourts?: Maybe<Scalars['Int']>;
  priceUnitAmount?: Maybe<Scalars['Int']>;
  teamLimit?: Maybe<Scalars['Int']>;
  totalPoints?: Maybe<Scalars['Int']>;
  winBy?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "event_groups" */
export type EventGroupsSumOrderBy = {
  desiredNumberOfPools?: InputMaybe<OrderBy>;
  gamesPerMatch?: InputMaybe<OrderBy>;
  maximumAge?: InputMaybe<OrderBy>;
  maximumRating?: InputMaybe<OrderBy>;
  minimumAge?: InputMaybe<OrderBy>;
  minimumNumberOfGames?: InputMaybe<OrderBy>;
  minimumRating?: InputMaybe<OrderBy>;
  numberOfEliminationTeams?: InputMaybe<OrderBy>;
  numberOfEstimatedCourts?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  teamLimit?: InputMaybe<OrderBy>;
  totalPoints?: InputMaybe<OrderBy>;
  winBy?: InputMaybe<OrderBy>;
};

/** update columns of table "event_groups" */
export enum EventGroupsUpdateColumn {
  /** column name */
  BracketRankingMechanism = 'bracketRankingMechanism',
  /** column name */
  Competitiveness = 'competitiveness',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  DesiredNumberOfPools = 'desiredNumberOfPools',
  /** column name */
  EndsAt = 'endsAt',
  /** column name */
  EventId = 'eventId',
  /** column name */
  Format = 'format',
  /** column name */
  FormatCustomName = 'formatCustomName',
  /** column name */
  GamesPerMatch = 'gamesPerMatch',
  /** column name */
  Gender = 'gender',
  /** column name */
  Id = 'id',
  /** column name */
  IsAgeRestricted = 'isAgeRestricted',
  /** column name */
  IsMoneyBall = 'isMoneyBall',
  /** column name */
  IsRatingRequired = 'isRatingRequired',
  /** column name */
  IsVairRatingSession = 'isVairRatingSession',
  /** column name */
  IsVairVairifiedRequired = 'isVairVairifiedRequired',
  /** column name */
  IsWheelchair = 'isWheelchair',
  /** column name */
  MaximumAge = 'maximumAge',
  /** column name */
  MaximumRating = 'maximumRating',
  /** column name */
  MergeId = 'mergeId',
  /** column name */
  MinimumAge = 'minimumAge',
  /** column name */
  MinimumNumberOfGames = 'minimumNumberOfGames',
  /** column name */
  MinimumRating = 'minimumRating',
  /** column name */
  MoneyBallRewards = 'moneyBallRewards',
  /** column name */
  NetStatus = 'netStatus',
  /** column name */
  NumberOfEliminationTeams = 'numberOfEliminationTeams',
  /** column name */
  NumberOfEstimatedCourts = 'numberOfEstimatedCourts',
  /** column name */
  PriceUnitAmount = 'priceUnitAmount',
  /** column name */
  ScoringFormat = 'scoringFormat',
  /** column name */
  SelfRatedMaxSkillLevelId = 'selfRatedMaxSkillLevelId',
  /** column name */
  SelfRatedMinSkillLevelId = 'selfRatedMinSkillLevelId',
  /** column name */
  StartsAt = 'startsAt',
  /** column name */
  TeamLimit = 'teamLimit',
  /** column name */
  TeamType = 'teamType',
  /** column name */
  Title = 'title',
  /** column name */
  TotalPoints = 'totalPoints',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  WinBy = 'winBy'
}

export type EventGroupsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<EventGroupsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _deleteAtPath?: InputMaybe<EventGroupsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _deleteElem?: InputMaybe<EventGroupsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _deleteKey?: InputMaybe<EventGroupsDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<EventGroupsIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<EventGroupsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventGroupsSetInput>;
  /** filter the rows which have to be updated */
  where: EventGroupsBoolExp;
};

/** aggregate varPop on columns */
export type EventGroupsVarPopFields = {
  __typename?: 'EventGroupsVarPopFields';
  desiredNumberOfPools?: Maybe<Scalars['Float']>;
  gamesPerMatch?: Maybe<Scalars['Float']>;
  maximumAge?: Maybe<Scalars['Float']>;
  maximumRating?: Maybe<Scalars['Float']>;
  minimumAge?: Maybe<Scalars['Float']>;
  minimumNumberOfGames?: Maybe<Scalars['Float']>;
  minimumRating?: Maybe<Scalars['Float']>;
  numberOfEliminationTeams?: Maybe<Scalars['Float']>;
  numberOfEstimatedCourts?: Maybe<Scalars['Float']>;
  priceUnitAmount?: Maybe<Scalars['Float']>;
  teamLimit?: Maybe<Scalars['Float']>;
  totalPoints?: Maybe<Scalars['Float']>;
  winBy?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "event_groups" */
export type EventGroupsVarPopOrderBy = {
  desiredNumberOfPools?: InputMaybe<OrderBy>;
  gamesPerMatch?: InputMaybe<OrderBy>;
  maximumAge?: InputMaybe<OrderBy>;
  maximumRating?: InputMaybe<OrderBy>;
  minimumAge?: InputMaybe<OrderBy>;
  minimumNumberOfGames?: InputMaybe<OrderBy>;
  minimumRating?: InputMaybe<OrderBy>;
  numberOfEliminationTeams?: InputMaybe<OrderBy>;
  numberOfEstimatedCourts?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  teamLimit?: InputMaybe<OrderBy>;
  totalPoints?: InputMaybe<OrderBy>;
  winBy?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type EventGroupsVarSampFields = {
  __typename?: 'EventGroupsVarSampFields';
  desiredNumberOfPools?: Maybe<Scalars['Float']>;
  gamesPerMatch?: Maybe<Scalars['Float']>;
  maximumAge?: Maybe<Scalars['Float']>;
  maximumRating?: Maybe<Scalars['Float']>;
  minimumAge?: Maybe<Scalars['Float']>;
  minimumNumberOfGames?: Maybe<Scalars['Float']>;
  minimumRating?: Maybe<Scalars['Float']>;
  numberOfEliminationTeams?: Maybe<Scalars['Float']>;
  numberOfEstimatedCourts?: Maybe<Scalars['Float']>;
  priceUnitAmount?: Maybe<Scalars['Float']>;
  teamLimit?: Maybe<Scalars['Float']>;
  totalPoints?: Maybe<Scalars['Float']>;
  winBy?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "event_groups" */
export type EventGroupsVarSampOrderBy = {
  desiredNumberOfPools?: InputMaybe<OrderBy>;
  gamesPerMatch?: InputMaybe<OrderBy>;
  maximumAge?: InputMaybe<OrderBy>;
  maximumRating?: InputMaybe<OrderBy>;
  minimumAge?: InputMaybe<OrderBy>;
  minimumNumberOfGames?: InputMaybe<OrderBy>;
  minimumRating?: InputMaybe<OrderBy>;
  numberOfEliminationTeams?: InputMaybe<OrderBy>;
  numberOfEstimatedCourts?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  teamLimit?: InputMaybe<OrderBy>;
  totalPoints?: InputMaybe<OrderBy>;
  winBy?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type EventGroupsVarianceFields = {
  __typename?: 'EventGroupsVarianceFields';
  desiredNumberOfPools?: Maybe<Scalars['Float']>;
  gamesPerMatch?: Maybe<Scalars['Float']>;
  maximumAge?: Maybe<Scalars['Float']>;
  maximumRating?: Maybe<Scalars['Float']>;
  minimumAge?: Maybe<Scalars['Float']>;
  minimumNumberOfGames?: Maybe<Scalars['Float']>;
  minimumRating?: Maybe<Scalars['Float']>;
  numberOfEliminationTeams?: Maybe<Scalars['Float']>;
  numberOfEstimatedCourts?: Maybe<Scalars['Float']>;
  priceUnitAmount?: Maybe<Scalars['Float']>;
  teamLimit?: Maybe<Scalars['Float']>;
  totalPoints?: Maybe<Scalars['Float']>;
  winBy?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "event_groups" */
export type EventGroupsVarianceOrderBy = {
  desiredNumberOfPools?: InputMaybe<OrderBy>;
  gamesPerMatch?: InputMaybe<OrderBy>;
  maximumAge?: InputMaybe<OrderBy>;
  maximumRating?: InputMaybe<OrderBy>;
  minimumAge?: InputMaybe<OrderBy>;
  minimumNumberOfGames?: InputMaybe<OrderBy>;
  minimumRating?: InputMaybe<OrderBy>;
  numberOfEliminationTeams?: InputMaybe<OrderBy>;
  numberOfEstimatedCourts?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  teamLimit?: InputMaybe<OrderBy>;
  totalPoints?: InputMaybe<OrderBy>;
  winBy?: InputMaybe<OrderBy>;
};

/** columns and relationships of "event_invitation_statuses" */
export type EventInvitationStatuses = {
  __typename?: 'EventInvitationStatuses';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "event_invitation_statuses" */
export type EventInvitationStatusesAggregate = {
  __typename?: 'EventInvitationStatusesAggregate';
  aggregate?: Maybe<EventInvitationStatusesAggregateFields>;
  nodes: Array<EventInvitationStatuses>;
};

/** aggregate fields of "event_invitation_statuses" */
export type EventInvitationStatusesAggregateFields = {
  __typename?: 'EventInvitationStatusesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<EventInvitationStatusesMaxFields>;
  min?: Maybe<EventInvitationStatusesMinFields>;
};


/** aggregate fields of "event_invitation_statuses" */
export type EventInvitationStatusesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EventInvitationStatusesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "event_invitation_statuses". All fields are combined with a logical 'AND'. */
export type EventInvitationStatusesBoolExp = {
  _and?: InputMaybe<Array<EventInvitationStatusesBoolExp>>;
  _not?: InputMaybe<EventInvitationStatusesBoolExp>;
  _or?: InputMaybe<Array<EventInvitationStatusesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "event_invitation_statuses" */
export enum EventInvitationStatusesConstraint {
  /** unique or primary key constraint on columns "value" */
  EventInvitationStatusesPkey = 'event_invitation_statuses_pkey'
}

export enum EventInvitationStatusesEnum {
  Accepted = 'ACCEPTED',
  Open = 'OPEN',
  Pending = 'PENDING'
}

/** Boolean expression to compare columns of type "EventInvitationStatusesEnum". All fields are combined with logical 'AND'. */
export type EventInvitationStatusesEnumComparisonExp = {
  _eq?: InputMaybe<EventInvitationStatusesEnum>;
  _in?: InputMaybe<Array<EventInvitationStatusesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<EventInvitationStatusesEnum>;
  _nin?: InputMaybe<Array<EventInvitationStatusesEnum>>;
};

/** input type for inserting data into table "event_invitation_statuses" */
export type EventInvitationStatusesInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type EventInvitationStatusesMaxFields = {
  __typename?: 'EventInvitationStatusesMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type EventInvitationStatusesMinFields = {
  __typename?: 'EventInvitationStatusesMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "event_invitation_statuses" */
export type EventInvitationStatusesMutationResponse = {
  __typename?: 'EventInvitationStatusesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventInvitationStatuses>;
};

/** on_conflict condition type for table "event_invitation_statuses" */
export type EventInvitationStatusesOnConflict = {
  constraint: EventInvitationStatusesConstraint;
  updateColumns?: Array<EventInvitationStatusesUpdateColumn>;
  where?: InputMaybe<EventInvitationStatusesBoolExp>;
};

/** Ordering options when selecting data from "event_invitation_statuses". */
export type EventInvitationStatusesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: event_invitation_statuses */
export type EventInvitationStatusesPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "event_invitation_statuses" */
export enum EventInvitationStatusesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "event_invitation_statuses" */
export type EventInvitationStatusesSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "event_invitation_statuses" */
export type EventInvitationStatusesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventInvitationStatusesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventInvitationStatusesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "event_invitation_statuses" */
export enum EventInvitationStatusesUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type EventInvitationStatusesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventInvitationStatusesSetInput>;
  /** filter the rows which have to be updated */
  where: EventInvitationStatusesBoolExp;
};

/** columns and relationships of "event_invitation_types" */
export type EventInvitationTypes = {
  __typename?: 'EventInvitationTypes';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "event_invitation_types" */
export type EventInvitationTypesAggregate = {
  __typename?: 'EventInvitationTypesAggregate';
  aggregate?: Maybe<EventInvitationTypesAggregateFields>;
  nodes: Array<EventInvitationTypes>;
};

/** aggregate fields of "event_invitation_types" */
export type EventInvitationTypesAggregateFields = {
  __typename?: 'EventInvitationTypesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<EventInvitationTypesMaxFields>;
  min?: Maybe<EventInvitationTypesMinFields>;
};


/** aggregate fields of "event_invitation_types" */
export type EventInvitationTypesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EventInvitationTypesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "event_invitation_types". All fields are combined with a logical 'AND'. */
export type EventInvitationTypesBoolExp = {
  _and?: InputMaybe<Array<EventInvitationTypesBoolExp>>;
  _not?: InputMaybe<EventInvitationTypesBoolExp>;
  _or?: InputMaybe<Array<EventInvitationTypesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "event_invitation_types" */
export enum EventInvitationTypesConstraint {
  /** unique or primary key constraint on columns "value" */
  EventInvitationTypesPkey = 'event_invitation_types_pkey'
}

export enum EventInvitationTypesEnum {
  Email = 'EMAIL',
  PartnerRequest = 'PARTNER_REQUEST'
}

/** Boolean expression to compare columns of type "EventInvitationTypesEnum". All fields are combined with logical 'AND'. */
export type EventInvitationTypesEnumComparisonExp = {
  _eq?: InputMaybe<EventInvitationTypesEnum>;
  _in?: InputMaybe<Array<EventInvitationTypesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<EventInvitationTypesEnum>;
  _nin?: InputMaybe<Array<EventInvitationTypesEnum>>;
};

/** input type for inserting data into table "event_invitation_types" */
export type EventInvitationTypesInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type EventInvitationTypesMaxFields = {
  __typename?: 'EventInvitationTypesMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type EventInvitationTypesMinFields = {
  __typename?: 'EventInvitationTypesMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "event_invitation_types" */
export type EventInvitationTypesMutationResponse = {
  __typename?: 'EventInvitationTypesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventInvitationTypes>;
};

/** on_conflict condition type for table "event_invitation_types" */
export type EventInvitationTypesOnConflict = {
  constraint: EventInvitationTypesConstraint;
  updateColumns?: Array<EventInvitationTypesUpdateColumn>;
  where?: InputMaybe<EventInvitationTypesBoolExp>;
};

/** Ordering options when selecting data from "event_invitation_types". */
export type EventInvitationTypesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: event_invitation_types */
export type EventInvitationTypesPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "event_invitation_types" */
export enum EventInvitationTypesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "event_invitation_types" */
export type EventInvitationTypesSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "event_invitation_types" */
export type EventInvitationTypesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventInvitationTypesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventInvitationTypesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "event_invitation_types" */
export enum EventInvitationTypesUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type EventInvitationTypesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventInvitationTypesSetInput>;
  /** filter the rows which have to be updated */
  where: EventInvitationTypesBoolExp;
};

/** columns and relationships of "event_invitations" */
export type EventInvitations = {
  __typename?: 'EventInvitations';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  event: Events;
  eventId: Scalars['uuid'];
  /** An object relationship */
  group: EventGroups;
  groupId: Scalars['uuid'];
  /** An object relationship */
  groupRegistration?: Maybe<EventGroupRegistrations>;
  groupRegistrationId?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  invitationEmail?: Maybe<Scalars['String']>;
  invitationName?: Maybe<Scalars['String']>;
  invitationType: EventInvitationTypesEnum;
  invitedByPersona?: Maybe<AppPersonasEnum>;
  /** An object relationship */
  invitedUser?: Maybe<Users>;
  invitedUserId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  invitedUserProfile?: Maybe<UserProfiles>;
  /** An object relationship */
  senderUser: Users;
  senderUserId: Scalars['uuid'];
  /** An object relationship */
  senderUserProfile?: Maybe<UserProfiles>;
  status: EventInvitationStatusesEnum;
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "event_invitations" */
export type EventInvitationsAggregate = {
  __typename?: 'EventInvitationsAggregate';
  aggregate?: Maybe<EventInvitationsAggregateFields>;
  nodes: Array<EventInvitations>;
};

export type EventInvitationsAggregateBoolExp = {
  count?: InputMaybe<EventInvitationsAggregateBoolExpCount>;
};

/** aggregate fields of "event_invitations" */
export type EventInvitationsAggregateFields = {
  __typename?: 'EventInvitationsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<EventInvitationsMaxFields>;
  min?: Maybe<EventInvitationsMinFields>;
};


/** aggregate fields of "event_invitations" */
export type EventInvitationsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EventInvitationsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "event_invitations" */
export type EventInvitationsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EventInvitationsMaxOrderBy>;
  min?: InputMaybe<EventInvitationsMinOrderBy>;
};

/** input type for inserting array relation for remote table "event_invitations" */
export type EventInvitationsArrRelInsertInput = {
  data: Array<EventInvitationsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<EventInvitationsOnConflict>;
};

/** Boolean expression to filter rows from the table "event_invitations". All fields are combined with a logical 'AND'. */
export type EventInvitationsBoolExp = {
  _and?: InputMaybe<Array<EventInvitationsBoolExp>>;
  _not?: InputMaybe<EventInvitationsBoolExp>;
  _or?: InputMaybe<Array<EventInvitationsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  event?: InputMaybe<EventsBoolExp>;
  eventId?: InputMaybe<UuidComparisonExp>;
  group?: InputMaybe<EventGroupsBoolExp>;
  groupId?: InputMaybe<UuidComparisonExp>;
  groupRegistration?: InputMaybe<EventGroupRegistrationsBoolExp>;
  groupRegistrationId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  invitationEmail?: InputMaybe<StringComparisonExp>;
  invitationName?: InputMaybe<StringComparisonExp>;
  invitationType?: InputMaybe<EventInvitationTypesEnumComparisonExp>;
  invitedByPersona?: InputMaybe<AppPersonasEnumComparisonExp>;
  invitedUser?: InputMaybe<UsersBoolExp>;
  invitedUserId?: InputMaybe<UuidComparisonExp>;
  invitedUserProfile?: InputMaybe<UserProfilesBoolExp>;
  senderUser?: InputMaybe<UsersBoolExp>;
  senderUserId?: InputMaybe<UuidComparisonExp>;
  senderUserProfile?: InputMaybe<UserProfilesBoolExp>;
  status?: InputMaybe<EventInvitationStatusesEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "event_invitations" */
export enum EventInvitationsConstraint {
  /** unique or primary key constraint on columns "id" */
  EventInvitationsPkey = 'event_invitations_pkey'
}

/** input type for inserting data into table "event_invitations" */
export type EventInvitationsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  event?: InputMaybe<EventsObjRelInsertInput>;
  eventId?: InputMaybe<Scalars['uuid']>;
  group?: InputMaybe<EventGroupsObjRelInsertInput>;
  groupId?: InputMaybe<Scalars['uuid']>;
  groupRegistration?: InputMaybe<EventGroupRegistrationsObjRelInsertInput>;
  groupRegistrationId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  invitationEmail?: InputMaybe<Scalars['String']>;
  invitationName?: InputMaybe<Scalars['String']>;
  invitationType?: InputMaybe<EventInvitationTypesEnum>;
  invitedByPersona?: InputMaybe<AppPersonasEnum>;
  invitedUser?: InputMaybe<UsersObjRelInsertInput>;
  invitedUserId?: InputMaybe<Scalars['uuid']>;
  invitedUserProfile?: InputMaybe<UserProfilesObjRelInsertInput>;
  senderUser?: InputMaybe<UsersObjRelInsertInput>;
  senderUserId?: InputMaybe<Scalars['uuid']>;
  senderUserProfile?: InputMaybe<UserProfilesObjRelInsertInput>;
  status?: InputMaybe<EventInvitationStatusesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type EventInvitationsMaxFields = {
  __typename?: 'EventInvitationsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  eventId?: Maybe<Scalars['uuid']>;
  groupId?: Maybe<Scalars['uuid']>;
  groupRegistrationId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  invitationEmail?: Maybe<Scalars['String']>;
  invitationName?: Maybe<Scalars['String']>;
  invitedUserId?: Maybe<Scalars['uuid']>;
  senderUserId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "event_invitations" */
export type EventInvitationsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  eventId?: InputMaybe<OrderBy>;
  groupId?: InputMaybe<OrderBy>;
  groupRegistrationId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  invitationEmail?: InputMaybe<OrderBy>;
  invitationName?: InputMaybe<OrderBy>;
  invitedUserId?: InputMaybe<OrderBy>;
  senderUserId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type EventInvitationsMinFields = {
  __typename?: 'EventInvitationsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  eventId?: Maybe<Scalars['uuid']>;
  groupId?: Maybe<Scalars['uuid']>;
  groupRegistrationId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  invitationEmail?: Maybe<Scalars['String']>;
  invitationName?: Maybe<Scalars['String']>;
  invitedUserId?: Maybe<Scalars['uuid']>;
  senderUserId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "event_invitations" */
export type EventInvitationsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  eventId?: InputMaybe<OrderBy>;
  groupId?: InputMaybe<OrderBy>;
  groupRegistrationId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  invitationEmail?: InputMaybe<OrderBy>;
  invitationName?: InputMaybe<OrderBy>;
  invitedUserId?: InputMaybe<OrderBy>;
  senderUserId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "event_invitations" */
export type EventInvitationsMutationResponse = {
  __typename?: 'EventInvitationsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventInvitations>;
};

/** on_conflict condition type for table "event_invitations" */
export type EventInvitationsOnConflict = {
  constraint: EventInvitationsConstraint;
  updateColumns?: Array<EventInvitationsUpdateColumn>;
  where?: InputMaybe<EventInvitationsBoolExp>;
};

/** Ordering options when selecting data from "event_invitations". */
export type EventInvitationsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  event?: InputMaybe<EventsOrderBy>;
  eventId?: InputMaybe<OrderBy>;
  group?: InputMaybe<EventGroupsOrderBy>;
  groupId?: InputMaybe<OrderBy>;
  groupRegistration?: InputMaybe<EventGroupRegistrationsOrderBy>;
  groupRegistrationId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  invitationEmail?: InputMaybe<OrderBy>;
  invitationName?: InputMaybe<OrderBy>;
  invitationType?: InputMaybe<OrderBy>;
  invitedByPersona?: InputMaybe<OrderBy>;
  invitedUser?: InputMaybe<UsersOrderBy>;
  invitedUserId?: InputMaybe<OrderBy>;
  invitedUserProfile?: InputMaybe<UserProfilesOrderBy>;
  senderUser?: InputMaybe<UsersOrderBy>;
  senderUserId?: InputMaybe<OrderBy>;
  senderUserProfile?: InputMaybe<UserProfilesOrderBy>;
  status?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: event_invitations */
export type EventInvitationsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "event_invitations" */
export enum EventInvitationsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EventId = 'eventId',
  /** column name */
  GroupId = 'groupId',
  /** column name */
  GroupRegistrationId = 'groupRegistrationId',
  /** column name */
  Id = 'id',
  /** column name */
  InvitationEmail = 'invitationEmail',
  /** column name */
  InvitationName = 'invitationName',
  /** column name */
  InvitationType = 'invitationType',
  /** column name */
  InvitedByPersona = 'invitedByPersona',
  /** column name */
  InvitedUserId = 'invitedUserId',
  /** column name */
  SenderUserId = 'senderUserId',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "event_invitations" */
export type EventInvitationsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  eventId?: InputMaybe<Scalars['uuid']>;
  groupId?: InputMaybe<Scalars['uuid']>;
  groupRegistrationId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  invitationEmail?: InputMaybe<Scalars['String']>;
  invitationName?: InputMaybe<Scalars['String']>;
  invitationType?: InputMaybe<EventInvitationTypesEnum>;
  invitedByPersona?: InputMaybe<AppPersonasEnum>;
  invitedUserId?: InputMaybe<Scalars['uuid']>;
  senderUserId?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<EventInvitationStatusesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "event_invitations" */
export type EventInvitationsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventInvitationsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventInvitationsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  eventId?: InputMaybe<Scalars['uuid']>;
  groupId?: InputMaybe<Scalars['uuid']>;
  groupRegistrationId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  invitationEmail?: InputMaybe<Scalars['String']>;
  invitationName?: InputMaybe<Scalars['String']>;
  invitationType?: InputMaybe<EventInvitationTypesEnum>;
  invitedByPersona?: InputMaybe<AppPersonasEnum>;
  invitedUserId?: InputMaybe<Scalars['uuid']>;
  senderUserId?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<EventInvitationStatusesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "event_invitations" */
export enum EventInvitationsUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EventId = 'eventId',
  /** column name */
  GroupId = 'groupId',
  /** column name */
  GroupRegistrationId = 'groupRegistrationId',
  /** column name */
  Id = 'id',
  /** column name */
  InvitationEmail = 'invitationEmail',
  /** column name */
  InvitationName = 'invitationName',
  /** column name */
  InvitationType = 'invitationType',
  /** column name */
  InvitedByPersona = 'invitedByPersona',
  /** column name */
  InvitedUserId = 'invitedUserId',
  /** column name */
  SenderUserId = 'senderUserId',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type EventInvitationsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventInvitationsSetInput>;
  /** filter the rows which have to be updated */
  where: EventInvitationsBoolExp;
};

/** columns and relationships of "event_listing_fees" */
export type EventListingFees = {
  __typename?: 'EventListingFees';
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  creditCard: UserCreditCards;
  /** An object relationship */
  customer: Users;
  /** An object relationship */
  customerProfile?: Maybe<UserProfiles>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  event: Events;
  eventId: Scalars['uuid'];
  externalStripePaymentIntentId: Scalars['String'];
  id: Scalars['uuid'];
  internalStripePaymentIntentId: Scalars['uuid'];
  orderSubtotalUnitAmount: Scalars['Int'];
  orderTotalUnitAmount: Scalars['Int'];
  paidUnitAmount: Scalars['Int'];
  /** An object relationship */
  paymentIntentExternal: StripePaymentIntents;
  /** An object relationship */
  paymentIntentInternal: StripePaymentIntents;
  paymentProcessor: PaymentProcessorsEnum;
  refundUnitAmount: Scalars['Int'];
  refundedAt?: Maybe<Scalars['timestamptz']>;
  refundedByPersona?: Maybe<AppPersonasEnum>;
  status: OrderStatusesEnum;
  stripeCustomerId: Scalars['String'];
  stripePaymentStatus: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  userCreditCardId: Scalars['uuid'];
  userId: Scalars['uuid'];
};

/** aggregated selection of "event_listing_fees" */
export type EventListingFeesAggregate = {
  __typename?: 'EventListingFeesAggregate';
  aggregate?: Maybe<EventListingFeesAggregateFields>;
  nodes: Array<EventListingFees>;
};

export type EventListingFeesAggregateBoolExp = {
  count?: InputMaybe<EventListingFeesAggregateBoolExpCount>;
};

/** aggregate fields of "event_listing_fees" */
export type EventListingFeesAggregateFields = {
  __typename?: 'EventListingFeesAggregateFields';
  avg?: Maybe<EventListingFeesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<EventListingFeesMaxFields>;
  min?: Maybe<EventListingFeesMinFields>;
  stddev?: Maybe<EventListingFeesStddevFields>;
  stddevPop?: Maybe<EventListingFeesStddevPopFields>;
  stddevSamp?: Maybe<EventListingFeesStddevSampFields>;
  sum?: Maybe<EventListingFeesSumFields>;
  varPop?: Maybe<EventListingFeesVarPopFields>;
  varSamp?: Maybe<EventListingFeesVarSampFields>;
  variance?: Maybe<EventListingFeesVarianceFields>;
};


/** aggregate fields of "event_listing_fees" */
export type EventListingFeesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EventListingFeesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "event_listing_fees" */
export type EventListingFeesAggregateOrderBy = {
  avg?: InputMaybe<EventListingFeesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EventListingFeesMaxOrderBy>;
  min?: InputMaybe<EventListingFeesMinOrderBy>;
  stddev?: InputMaybe<EventListingFeesStddevOrderBy>;
  stddevPop?: InputMaybe<EventListingFeesStddevPopOrderBy>;
  stddevSamp?: InputMaybe<EventListingFeesStddevSampOrderBy>;
  sum?: InputMaybe<EventListingFeesSumOrderBy>;
  varPop?: InputMaybe<EventListingFeesVarPopOrderBy>;
  varSamp?: InputMaybe<EventListingFeesVarSampOrderBy>;
  variance?: InputMaybe<EventListingFeesVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "event_listing_fees" */
export type EventListingFeesArrRelInsertInput = {
  data: Array<EventListingFeesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<EventListingFeesOnConflict>;
};

/** aggregate avg on columns */
export type EventListingFeesAvgFields = {
  __typename?: 'EventListingFeesAvgFields';
  orderSubtotalUnitAmount?: Maybe<Scalars['Float']>;
  orderTotalUnitAmount?: Maybe<Scalars['Float']>;
  paidUnitAmount?: Maybe<Scalars['Float']>;
  refundUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "event_listing_fees" */
export type EventListingFeesAvgOrderBy = {
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "event_listing_fees". All fields are combined with a logical 'AND'. */
export type EventListingFeesBoolExp = {
  _and?: InputMaybe<Array<EventListingFeesBoolExp>>;
  _not?: InputMaybe<EventListingFeesBoolExp>;
  _or?: InputMaybe<Array<EventListingFeesBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  creditCard?: InputMaybe<UserCreditCardsBoolExp>;
  customer?: InputMaybe<UsersBoolExp>;
  customerProfile?: InputMaybe<UserProfilesBoolExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  event?: InputMaybe<EventsBoolExp>;
  eventId?: InputMaybe<UuidComparisonExp>;
  externalStripePaymentIntentId?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  internalStripePaymentIntentId?: InputMaybe<UuidComparisonExp>;
  orderSubtotalUnitAmount?: InputMaybe<IntComparisonExp>;
  orderTotalUnitAmount?: InputMaybe<IntComparisonExp>;
  paidUnitAmount?: InputMaybe<IntComparisonExp>;
  paymentIntentExternal?: InputMaybe<StripePaymentIntentsBoolExp>;
  paymentIntentInternal?: InputMaybe<StripePaymentIntentsBoolExp>;
  paymentProcessor?: InputMaybe<PaymentProcessorsEnumComparisonExp>;
  refundUnitAmount?: InputMaybe<IntComparisonExp>;
  refundedAt?: InputMaybe<TimestamptzComparisonExp>;
  refundedByPersona?: InputMaybe<AppPersonasEnumComparisonExp>;
  status?: InputMaybe<OrderStatusesEnumComparisonExp>;
  stripeCustomerId?: InputMaybe<StringComparisonExp>;
  stripePaymentStatus?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  userCreditCardId?: InputMaybe<UuidComparisonExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "event_listing_fees" */
export enum EventListingFeesConstraint {
  /** unique or primary key constraint on columns "external_stripe_payment_intent_id" */
  EventListingFeesExternalStripePaymentIntentIdKey = 'event_listing_fees_external_stripe_payment_intent_id_key',
  /** unique or primary key constraint on columns "internal_stripe_payment_intent_id" */
  EventListingFeesInternalStripePaymentIntentIdKey = 'event_listing_fees_internal_stripe_payment_intent_id_key',
  /** unique or primary key constraint on columns "id" */
  EventListingFeesPkey = 'event_listing_fees_pkey'
}

/** input type for incrementing numeric columns in table "event_listing_fees" */
export type EventListingFeesIncInput = {
  orderSubtotalUnitAmount?: InputMaybe<Scalars['Int']>;
  orderTotalUnitAmount?: InputMaybe<Scalars['Int']>;
  paidUnitAmount?: InputMaybe<Scalars['Int']>;
  refundUnitAmount?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "event_listing_fees" */
export type EventListingFeesInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  creditCard?: InputMaybe<UserCreditCardsObjRelInsertInput>;
  customer?: InputMaybe<UsersObjRelInsertInput>;
  customerProfile?: InputMaybe<UserProfilesObjRelInsertInput>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  event?: InputMaybe<EventsObjRelInsertInput>;
  eventId?: InputMaybe<Scalars['uuid']>;
  externalStripePaymentIntentId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  internalStripePaymentIntentId?: InputMaybe<Scalars['uuid']>;
  orderSubtotalUnitAmount?: InputMaybe<Scalars['Int']>;
  orderTotalUnitAmount?: InputMaybe<Scalars['Int']>;
  paidUnitAmount?: InputMaybe<Scalars['Int']>;
  paymentIntentExternal?: InputMaybe<StripePaymentIntentsObjRelInsertInput>;
  paymentIntentInternal?: InputMaybe<StripePaymentIntentsObjRelInsertInput>;
  paymentProcessor?: InputMaybe<PaymentProcessorsEnum>;
  refundUnitAmount?: InputMaybe<Scalars['Int']>;
  refundedAt?: InputMaybe<Scalars['timestamptz']>;
  refundedByPersona?: InputMaybe<AppPersonasEnum>;
  status?: InputMaybe<OrderStatusesEnum>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  stripePaymentStatus?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userCreditCardId?: InputMaybe<Scalars['uuid']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type EventListingFeesMaxFields = {
  __typename?: 'EventListingFeesMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  eventId?: Maybe<Scalars['uuid']>;
  externalStripePaymentIntentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  internalStripePaymentIntentId?: Maybe<Scalars['uuid']>;
  orderSubtotalUnitAmount?: Maybe<Scalars['Int']>;
  orderTotalUnitAmount?: Maybe<Scalars['Int']>;
  paidUnitAmount?: Maybe<Scalars['Int']>;
  refundUnitAmount?: Maybe<Scalars['Int']>;
  refundedAt?: Maybe<Scalars['timestamptz']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentStatus?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userCreditCardId?: Maybe<Scalars['uuid']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "event_listing_fees" */
export type EventListingFeesMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  eventId?: InputMaybe<OrderBy>;
  externalStripePaymentIntentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  internalStripePaymentIntentId?: InputMaybe<OrderBy>;
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  refundedAt?: InputMaybe<OrderBy>;
  stripeCustomerId?: InputMaybe<OrderBy>;
  stripePaymentStatus?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userCreditCardId?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type EventListingFeesMinFields = {
  __typename?: 'EventListingFeesMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  eventId?: Maybe<Scalars['uuid']>;
  externalStripePaymentIntentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  internalStripePaymentIntentId?: Maybe<Scalars['uuid']>;
  orderSubtotalUnitAmount?: Maybe<Scalars['Int']>;
  orderTotalUnitAmount?: Maybe<Scalars['Int']>;
  paidUnitAmount?: Maybe<Scalars['Int']>;
  refundUnitAmount?: Maybe<Scalars['Int']>;
  refundedAt?: Maybe<Scalars['timestamptz']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentStatus?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userCreditCardId?: Maybe<Scalars['uuid']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "event_listing_fees" */
export type EventListingFeesMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  eventId?: InputMaybe<OrderBy>;
  externalStripePaymentIntentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  internalStripePaymentIntentId?: InputMaybe<OrderBy>;
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  refundedAt?: InputMaybe<OrderBy>;
  stripeCustomerId?: InputMaybe<OrderBy>;
  stripePaymentStatus?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userCreditCardId?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "event_listing_fees" */
export type EventListingFeesMutationResponse = {
  __typename?: 'EventListingFeesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventListingFees>;
};

/** on_conflict condition type for table "event_listing_fees" */
export type EventListingFeesOnConflict = {
  constraint: EventListingFeesConstraint;
  updateColumns?: Array<EventListingFeesUpdateColumn>;
  where?: InputMaybe<EventListingFeesBoolExp>;
};

/** Ordering options when selecting data from "event_listing_fees". */
export type EventListingFeesOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  creditCard?: InputMaybe<UserCreditCardsOrderBy>;
  customer?: InputMaybe<UsersOrderBy>;
  customerProfile?: InputMaybe<UserProfilesOrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  event?: InputMaybe<EventsOrderBy>;
  eventId?: InputMaybe<OrderBy>;
  externalStripePaymentIntentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  internalStripePaymentIntentId?: InputMaybe<OrderBy>;
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  paymentIntentExternal?: InputMaybe<StripePaymentIntentsOrderBy>;
  paymentIntentInternal?: InputMaybe<StripePaymentIntentsOrderBy>;
  paymentProcessor?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  refundedAt?: InputMaybe<OrderBy>;
  refundedByPersona?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  stripeCustomerId?: InputMaybe<OrderBy>;
  stripePaymentStatus?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userCreditCardId?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: event_listing_fees */
export type EventListingFeesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "event_listing_fees" */
export enum EventListingFeesSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EventId = 'eventId',
  /** column name */
  ExternalStripePaymentIntentId = 'externalStripePaymentIntentId',
  /** column name */
  Id = 'id',
  /** column name */
  InternalStripePaymentIntentId = 'internalStripePaymentIntentId',
  /** column name */
  OrderSubtotalUnitAmount = 'orderSubtotalUnitAmount',
  /** column name */
  OrderTotalUnitAmount = 'orderTotalUnitAmount',
  /** column name */
  PaidUnitAmount = 'paidUnitAmount',
  /** column name */
  PaymentProcessor = 'paymentProcessor',
  /** column name */
  RefundUnitAmount = 'refundUnitAmount',
  /** column name */
  RefundedAt = 'refundedAt',
  /** column name */
  RefundedByPersona = 'refundedByPersona',
  /** column name */
  Status = 'status',
  /** column name */
  StripeCustomerId = 'stripeCustomerId',
  /** column name */
  StripePaymentStatus = 'stripePaymentStatus',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserCreditCardId = 'userCreditCardId',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "event_listing_fees" */
export type EventListingFeesSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  eventId?: InputMaybe<Scalars['uuid']>;
  externalStripePaymentIntentId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  internalStripePaymentIntentId?: InputMaybe<Scalars['uuid']>;
  orderSubtotalUnitAmount?: InputMaybe<Scalars['Int']>;
  orderTotalUnitAmount?: InputMaybe<Scalars['Int']>;
  paidUnitAmount?: InputMaybe<Scalars['Int']>;
  paymentProcessor?: InputMaybe<PaymentProcessorsEnum>;
  refundUnitAmount?: InputMaybe<Scalars['Int']>;
  refundedAt?: InputMaybe<Scalars['timestamptz']>;
  refundedByPersona?: InputMaybe<AppPersonasEnum>;
  status?: InputMaybe<OrderStatusesEnum>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  stripePaymentStatus?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userCreditCardId?: InputMaybe<Scalars['uuid']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type EventListingFeesStddevFields = {
  __typename?: 'EventListingFeesStddevFields';
  orderSubtotalUnitAmount?: Maybe<Scalars['Float']>;
  orderTotalUnitAmount?: Maybe<Scalars['Float']>;
  paidUnitAmount?: Maybe<Scalars['Float']>;
  refundUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "event_listing_fees" */
export type EventListingFeesStddevOrderBy = {
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type EventListingFeesStddevPopFields = {
  __typename?: 'EventListingFeesStddevPopFields';
  orderSubtotalUnitAmount?: Maybe<Scalars['Float']>;
  orderTotalUnitAmount?: Maybe<Scalars['Float']>;
  paidUnitAmount?: Maybe<Scalars['Float']>;
  refundUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "event_listing_fees" */
export type EventListingFeesStddevPopOrderBy = {
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type EventListingFeesStddevSampFields = {
  __typename?: 'EventListingFeesStddevSampFields';
  orderSubtotalUnitAmount?: Maybe<Scalars['Float']>;
  orderTotalUnitAmount?: Maybe<Scalars['Float']>;
  paidUnitAmount?: Maybe<Scalars['Float']>;
  refundUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "event_listing_fees" */
export type EventListingFeesStddevSampOrderBy = {
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "event_listing_fees" */
export type EventListingFeesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventListingFeesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventListingFeesStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  eventId?: InputMaybe<Scalars['uuid']>;
  externalStripePaymentIntentId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  internalStripePaymentIntentId?: InputMaybe<Scalars['uuid']>;
  orderSubtotalUnitAmount?: InputMaybe<Scalars['Int']>;
  orderTotalUnitAmount?: InputMaybe<Scalars['Int']>;
  paidUnitAmount?: InputMaybe<Scalars['Int']>;
  paymentProcessor?: InputMaybe<PaymentProcessorsEnum>;
  refundUnitAmount?: InputMaybe<Scalars['Int']>;
  refundedAt?: InputMaybe<Scalars['timestamptz']>;
  refundedByPersona?: InputMaybe<AppPersonasEnum>;
  status?: InputMaybe<OrderStatusesEnum>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  stripePaymentStatus?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userCreditCardId?: InputMaybe<Scalars['uuid']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type EventListingFeesSumFields = {
  __typename?: 'EventListingFeesSumFields';
  orderSubtotalUnitAmount?: Maybe<Scalars['Int']>;
  orderTotalUnitAmount?: Maybe<Scalars['Int']>;
  paidUnitAmount?: Maybe<Scalars['Int']>;
  refundUnitAmount?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "event_listing_fees" */
export type EventListingFeesSumOrderBy = {
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
};

/** update columns of table "event_listing_fees" */
export enum EventListingFeesUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EventId = 'eventId',
  /** column name */
  ExternalStripePaymentIntentId = 'externalStripePaymentIntentId',
  /** column name */
  Id = 'id',
  /** column name */
  InternalStripePaymentIntentId = 'internalStripePaymentIntentId',
  /** column name */
  OrderSubtotalUnitAmount = 'orderSubtotalUnitAmount',
  /** column name */
  OrderTotalUnitAmount = 'orderTotalUnitAmount',
  /** column name */
  PaidUnitAmount = 'paidUnitAmount',
  /** column name */
  PaymentProcessor = 'paymentProcessor',
  /** column name */
  RefundUnitAmount = 'refundUnitAmount',
  /** column name */
  RefundedAt = 'refundedAt',
  /** column name */
  RefundedByPersona = 'refundedByPersona',
  /** column name */
  Status = 'status',
  /** column name */
  StripeCustomerId = 'stripeCustomerId',
  /** column name */
  StripePaymentStatus = 'stripePaymentStatus',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserCreditCardId = 'userCreditCardId',
  /** column name */
  UserId = 'userId'
}

export type EventListingFeesUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<EventListingFeesIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventListingFeesSetInput>;
  /** filter the rows which have to be updated */
  where: EventListingFeesBoolExp;
};

/** aggregate varPop on columns */
export type EventListingFeesVarPopFields = {
  __typename?: 'EventListingFeesVarPopFields';
  orderSubtotalUnitAmount?: Maybe<Scalars['Float']>;
  orderTotalUnitAmount?: Maybe<Scalars['Float']>;
  paidUnitAmount?: Maybe<Scalars['Float']>;
  refundUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "event_listing_fees" */
export type EventListingFeesVarPopOrderBy = {
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type EventListingFeesVarSampFields = {
  __typename?: 'EventListingFeesVarSampFields';
  orderSubtotalUnitAmount?: Maybe<Scalars['Float']>;
  orderTotalUnitAmount?: Maybe<Scalars['Float']>;
  paidUnitAmount?: Maybe<Scalars['Float']>;
  refundUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "event_listing_fees" */
export type EventListingFeesVarSampOrderBy = {
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type EventListingFeesVarianceFields = {
  __typename?: 'EventListingFeesVarianceFields';
  orderSubtotalUnitAmount?: Maybe<Scalars['Float']>;
  orderTotalUnitAmount?: Maybe<Scalars['Float']>;
  paidUnitAmount?: Maybe<Scalars['Float']>;
  refundUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "event_listing_fees" */
export type EventListingFeesVarianceOrderBy = {
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
};

/** columns and relationships of "event_match_games" */
export type EventMatchGames = {
  __typename?: 'EventMatchGames';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  /** An object relationship */
  losingTeam: EventTeams;
  losingTeamId: Scalars['uuid'];
  /** An object relationship */
  match: EventMatches;
  matchId: Scalars['uuid'];
  /** An array relationship */
  scores: Array<EventGameScores>;
  /** An aggregate relationship */
  scoresAggregate: EventGameScoresAggregate;
  /** An object relationship */
  team1: EventTeams;
  team1Id: Scalars['uuid'];
  team1Score: Scalars['numeric'];
  /** An object relationship */
  team2: EventTeams;
  team2Id: Scalars['uuid'];
  team2Score: Scalars['numeric'];
  updatedAt: Scalars['timestamptz'];
  winReason: WinReasonsEnum;
  /** An object relationship */
  winningTeam: EventTeams;
  winningTeamId: Scalars['uuid'];
};


/** columns and relationships of "event_match_games" */
export type EventMatchGamesScoresArgs = {
  distinctOn?: InputMaybe<Array<EventGameScoresSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGameScoresOrderBy>>;
  where?: InputMaybe<EventGameScoresBoolExp>;
};


/** columns and relationships of "event_match_games" */
export type EventMatchGamesScoresAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventGameScoresSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGameScoresOrderBy>>;
  where?: InputMaybe<EventGameScoresBoolExp>;
};

/** aggregated selection of "event_match_games" */
export type EventMatchGamesAggregate = {
  __typename?: 'EventMatchGamesAggregate';
  aggregate?: Maybe<EventMatchGamesAggregateFields>;
  nodes: Array<EventMatchGames>;
};

export type EventMatchGamesAggregateBoolExp = {
  count?: InputMaybe<EventMatchGamesAggregateBoolExpCount>;
};

/** aggregate fields of "event_match_games" */
export type EventMatchGamesAggregateFields = {
  __typename?: 'EventMatchGamesAggregateFields';
  avg?: Maybe<EventMatchGamesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<EventMatchGamesMaxFields>;
  min?: Maybe<EventMatchGamesMinFields>;
  stddev?: Maybe<EventMatchGamesStddevFields>;
  stddevPop?: Maybe<EventMatchGamesStddevPopFields>;
  stddevSamp?: Maybe<EventMatchGamesStddevSampFields>;
  sum?: Maybe<EventMatchGamesSumFields>;
  varPop?: Maybe<EventMatchGamesVarPopFields>;
  varSamp?: Maybe<EventMatchGamesVarSampFields>;
  variance?: Maybe<EventMatchGamesVarianceFields>;
};


/** aggregate fields of "event_match_games" */
export type EventMatchGamesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EventMatchGamesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "event_match_games" */
export type EventMatchGamesAggregateOrderBy = {
  avg?: InputMaybe<EventMatchGamesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EventMatchGamesMaxOrderBy>;
  min?: InputMaybe<EventMatchGamesMinOrderBy>;
  stddev?: InputMaybe<EventMatchGamesStddevOrderBy>;
  stddevPop?: InputMaybe<EventMatchGamesStddevPopOrderBy>;
  stddevSamp?: InputMaybe<EventMatchGamesStddevSampOrderBy>;
  sum?: InputMaybe<EventMatchGamesSumOrderBy>;
  varPop?: InputMaybe<EventMatchGamesVarPopOrderBy>;
  varSamp?: InputMaybe<EventMatchGamesVarSampOrderBy>;
  variance?: InputMaybe<EventMatchGamesVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "event_match_games" */
export type EventMatchGamesArrRelInsertInput = {
  data: Array<EventMatchGamesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<EventMatchGamesOnConflict>;
};

/** aggregate avg on columns */
export type EventMatchGamesAvgFields = {
  __typename?: 'EventMatchGamesAvgFields';
  team1Score?: Maybe<Scalars['Float']>;
  team2Score?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "event_match_games" */
export type EventMatchGamesAvgOrderBy = {
  team1Score?: InputMaybe<OrderBy>;
  team2Score?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "event_match_games". All fields are combined with a logical 'AND'. */
export type EventMatchGamesBoolExp = {
  _and?: InputMaybe<Array<EventMatchGamesBoolExp>>;
  _not?: InputMaybe<EventMatchGamesBoolExp>;
  _or?: InputMaybe<Array<EventMatchGamesBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  losingTeam?: InputMaybe<EventTeamsBoolExp>;
  losingTeamId?: InputMaybe<UuidComparisonExp>;
  match?: InputMaybe<EventMatchesBoolExp>;
  matchId?: InputMaybe<UuidComparisonExp>;
  scores?: InputMaybe<EventGameScoresBoolExp>;
  scoresAggregate?: InputMaybe<EventGameScoresAggregateBoolExp>;
  team1?: InputMaybe<EventTeamsBoolExp>;
  team1Id?: InputMaybe<UuidComparisonExp>;
  team1Score?: InputMaybe<NumericComparisonExp>;
  team2?: InputMaybe<EventTeamsBoolExp>;
  team2Id?: InputMaybe<UuidComparisonExp>;
  team2Score?: InputMaybe<NumericComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  winReason?: InputMaybe<WinReasonsEnumComparisonExp>;
  winningTeam?: InputMaybe<EventTeamsBoolExp>;
  winningTeamId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "event_match_games" */
export enum EventMatchGamesConstraint {
  /** unique or primary key constraint on columns "id" */
  EventMatchGamesPkey = 'event_match_games_pkey'
}

/** input type for incrementing numeric columns in table "event_match_games" */
export type EventMatchGamesIncInput = {
  team1Score?: InputMaybe<Scalars['numeric']>;
  team2Score?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "event_match_games" */
export type EventMatchGamesInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  losingTeam?: InputMaybe<EventTeamsObjRelInsertInput>;
  losingTeamId?: InputMaybe<Scalars['uuid']>;
  match?: InputMaybe<EventMatchesObjRelInsertInput>;
  matchId?: InputMaybe<Scalars['uuid']>;
  scores?: InputMaybe<EventGameScoresArrRelInsertInput>;
  team1?: InputMaybe<EventTeamsObjRelInsertInput>;
  team1Id?: InputMaybe<Scalars['uuid']>;
  team1Score?: InputMaybe<Scalars['numeric']>;
  team2?: InputMaybe<EventTeamsObjRelInsertInput>;
  team2Id?: InputMaybe<Scalars['uuid']>;
  team2Score?: InputMaybe<Scalars['numeric']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  winReason?: InputMaybe<WinReasonsEnum>;
  winningTeam?: InputMaybe<EventTeamsObjRelInsertInput>;
  winningTeamId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type EventMatchGamesMaxFields = {
  __typename?: 'EventMatchGamesMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  losingTeamId?: Maybe<Scalars['uuid']>;
  matchId?: Maybe<Scalars['uuid']>;
  team1Id?: Maybe<Scalars['uuid']>;
  team1Score?: Maybe<Scalars['numeric']>;
  team2Id?: Maybe<Scalars['uuid']>;
  team2Score?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  winningTeamId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "event_match_games" */
export type EventMatchGamesMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  losingTeamId?: InputMaybe<OrderBy>;
  matchId?: InputMaybe<OrderBy>;
  team1Id?: InputMaybe<OrderBy>;
  team1Score?: InputMaybe<OrderBy>;
  team2Id?: InputMaybe<OrderBy>;
  team2Score?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  winningTeamId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type EventMatchGamesMinFields = {
  __typename?: 'EventMatchGamesMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  losingTeamId?: Maybe<Scalars['uuid']>;
  matchId?: Maybe<Scalars['uuid']>;
  team1Id?: Maybe<Scalars['uuid']>;
  team1Score?: Maybe<Scalars['numeric']>;
  team2Id?: Maybe<Scalars['uuid']>;
  team2Score?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  winningTeamId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "event_match_games" */
export type EventMatchGamesMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  losingTeamId?: InputMaybe<OrderBy>;
  matchId?: InputMaybe<OrderBy>;
  team1Id?: InputMaybe<OrderBy>;
  team1Score?: InputMaybe<OrderBy>;
  team2Id?: InputMaybe<OrderBy>;
  team2Score?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  winningTeamId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "event_match_games" */
export type EventMatchGamesMutationResponse = {
  __typename?: 'EventMatchGamesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventMatchGames>;
};

/** input type for inserting object relation for remote table "event_match_games" */
export type EventMatchGamesObjRelInsertInput = {
  data: EventMatchGamesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<EventMatchGamesOnConflict>;
};

/** on_conflict condition type for table "event_match_games" */
export type EventMatchGamesOnConflict = {
  constraint: EventMatchGamesConstraint;
  updateColumns?: Array<EventMatchGamesUpdateColumn>;
  where?: InputMaybe<EventMatchGamesBoolExp>;
};

/** Ordering options when selecting data from "event_match_games". */
export type EventMatchGamesOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  losingTeam?: InputMaybe<EventTeamsOrderBy>;
  losingTeamId?: InputMaybe<OrderBy>;
  match?: InputMaybe<EventMatchesOrderBy>;
  matchId?: InputMaybe<OrderBy>;
  scoresAggregate?: InputMaybe<EventGameScoresAggregateOrderBy>;
  team1?: InputMaybe<EventTeamsOrderBy>;
  team1Id?: InputMaybe<OrderBy>;
  team1Score?: InputMaybe<OrderBy>;
  team2?: InputMaybe<EventTeamsOrderBy>;
  team2Id?: InputMaybe<OrderBy>;
  team2Score?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  winReason?: InputMaybe<OrderBy>;
  winningTeam?: InputMaybe<EventTeamsOrderBy>;
  winningTeamId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: event_match_games */
export type EventMatchGamesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "event_match_games" */
export enum EventMatchGamesSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  LosingTeamId = 'losingTeamId',
  /** column name */
  MatchId = 'matchId',
  /** column name */
  Team1Id = 'team1Id',
  /** column name */
  Team1Score = 'team1Score',
  /** column name */
  Team2Id = 'team2Id',
  /** column name */
  Team2Score = 'team2Score',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  WinReason = 'winReason',
  /** column name */
  WinningTeamId = 'winningTeamId'
}

/** input type for updating data in table "event_match_games" */
export type EventMatchGamesSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  losingTeamId?: InputMaybe<Scalars['uuid']>;
  matchId?: InputMaybe<Scalars['uuid']>;
  team1Id?: InputMaybe<Scalars['uuid']>;
  team1Score?: InputMaybe<Scalars['numeric']>;
  team2Id?: InputMaybe<Scalars['uuid']>;
  team2Score?: InputMaybe<Scalars['numeric']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  winReason?: InputMaybe<WinReasonsEnum>;
  winningTeamId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type EventMatchGamesStddevFields = {
  __typename?: 'EventMatchGamesStddevFields';
  team1Score?: Maybe<Scalars['Float']>;
  team2Score?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "event_match_games" */
export type EventMatchGamesStddevOrderBy = {
  team1Score?: InputMaybe<OrderBy>;
  team2Score?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type EventMatchGamesStddevPopFields = {
  __typename?: 'EventMatchGamesStddevPopFields';
  team1Score?: Maybe<Scalars['Float']>;
  team2Score?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "event_match_games" */
export type EventMatchGamesStddevPopOrderBy = {
  team1Score?: InputMaybe<OrderBy>;
  team2Score?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type EventMatchGamesStddevSampFields = {
  __typename?: 'EventMatchGamesStddevSampFields';
  team1Score?: Maybe<Scalars['Float']>;
  team2Score?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "event_match_games" */
export type EventMatchGamesStddevSampOrderBy = {
  team1Score?: InputMaybe<OrderBy>;
  team2Score?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "event_match_games" */
export type EventMatchGamesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventMatchGamesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventMatchGamesStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  losingTeamId?: InputMaybe<Scalars['uuid']>;
  matchId?: InputMaybe<Scalars['uuid']>;
  team1Id?: InputMaybe<Scalars['uuid']>;
  team1Score?: InputMaybe<Scalars['numeric']>;
  team2Id?: InputMaybe<Scalars['uuid']>;
  team2Score?: InputMaybe<Scalars['numeric']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  winReason?: InputMaybe<WinReasonsEnum>;
  winningTeamId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type EventMatchGamesSumFields = {
  __typename?: 'EventMatchGamesSumFields';
  team1Score?: Maybe<Scalars['numeric']>;
  team2Score?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "event_match_games" */
export type EventMatchGamesSumOrderBy = {
  team1Score?: InputMaybe<OrderBy>;
  team2Score?: InputMaybe<OrderBy>;
};

/** update columns of table "event_match_games" */
export enum EventMatchGamesUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  LosingTeamId = 'losingTeamId',
  /** column name */
  MatchId = 'matchId',
  /** column name */
  Team1Id = 'team1Id',
  /** column name */
  Team1Score = 'team1Score',
  /** column name */
  Team2Id = 'team2Id',
  /** column name */
  Team2Score = 'team2Score',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  WinReason = 'winReason',
  /** column name */
  WinningTeamId = 'winningTeamId'
}

export type EventMatchGamesUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<EventMatchGamesIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventMatchGamesSetInput>;
  /** filter the rows which have to be updated */
  where: EventMatchGamesBoolExp;
};

/** aggregate varPop on columns */
export type EventMatchGamesVarPopFields = {
  __typename?: 'EventMatchGamesVarPopFields';
  team1Score?: Maybe<Scalars['Float']>;
  team2Score?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "event_match_games" */
export type EventMatchGamesVarPopOrderBy = {
  team1Score?: InputMaybe<OrderBy>;
  team2Score?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type EventMatchGamesVarSampFields = {
  __typename?: 'EventMatchGamesVarSampFields';
  team1Score?: Maybe<Scalars['Float']>;
  team2Score?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "event_match_games" */
export type EventMatchGamesVarSampOrderBy = {
  team1Score?: InputMaybe<OrderBy>;
  team2Score?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type EventMatchGamesVarianceFields = {
  __typename?: 'EventMatchGamesVarianceFields';
  team1Score?: Maybe<Scalars['Float']>;
  team2Score?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "event_match_games" */
export type EventMatchGamesVarianceOrderBy = {
  team1Score?: InputMaybe<OrderBy>;
  team2Score?: InputMaybe<OrderBy>;
};

/** NOTE: In the product direction, the concept of a round is becoming less structured. Currently over-structuring this until we understand what columns aren't needing. May add or remove some foreign keys, and potentially tie to and event or group. */
export type EventMatches = {
  __typename?: 'EventMatches';
  /** An object relationship */
  court?: Maybe<EventCourts>;
  courtNumber?: Maybe<Scalars['Int']>;
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  eventCourtId?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  games: Array<EventMatchGames>;
  /** An aggregate relationship */
  gamesAggregate: EventMatchGamesAggregate;
  id: Scalars['uuid'];
  isBye: Scalars['Boolean'];
  isVairScoreSubmitted?: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  losingTeam?: Maybe<EventTeams>;
  losingTeamId?: Maybe<Scalars['uuid']>;
  matchOrder: Scalars['Int'];
  /** An object relationship */
  pool?: Maybe<EventGroupPools>;
  poolId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  previousMatch1?: Maybe<EventMatches>;
  previousMatch1Id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  previousMatch2?: Maybe<EventMatches>;
  previousMatch2Id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  round: EventPoolRounds;
  roundId: Scalars['uuid'];
  selectionCriteriaPreviousMatch1?: Maybe<MatchSelectionCriteriaEnum>;
  selectionCriteriaPreviousMatch2?: Maybe<MatchSelectionCriteriaEnum>;
  /** An object relationship */
  team1?: Maybe<EventTeams>;
  team1Id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  team2?: Maybe<EventTeams>;
  team2Id?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  teams: Array<EventMatchesTeams>;
  /** An aggregate relationship */
  teamsAggregate: EventMatchesTeamsAggregate;
  updatedAt: Scalars['timestamptz'];
  winReason?: Maybe<WinReasonsEnum>;
  /** An object relationship */
  winningTeam?: Maybe<EventTeams>;
  winningTeamId?: Maybe<Scalars['uuid']>;
};


/** NOTE: In the product direction, the concept of a round is becoming less structured. Currently over-structuring this until we understand what columns aren't needing. May add or remove some foreign keys, and potentially tie to and event or group. */
export type EventMatchesGamesArgs = {
  distinctOn?: InputMaybe<Array<EventMatchGamesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventMatchGamesOrderBy>>;
  where?: InputMaybe<EventMatchGamesBoolExp>;
};


/** NOTE: In the product direction, the concept of a round is becoming less structured. Currently over-structuring this until we understand what columns aren't needing. May add or remove some foreign keys, and potentially tie to and event or group. */
export type EventMatchesGamesAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventMatchGamesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventMatchGamesOrderBy>>;
  where?: InputMaybe<EventMatchGamesBoolExp>;
};


/** NOTE: In the product direction, the concept of a round is becoming less structured. Currently over-structuring this until we understand what columns aren't needing. May add or remove some foreign keys, and potentially tie to and event or group. */
export type EventMatchesTeamsArgs = {
  distinctOn?: InputMaybe<Array<EventMatchesTeamsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventMatchesTeamsOrderBy>>;
  where?: InputMaybe<EventMatchesTeamsBoolExp>;
};


/** NOTE: In the product direction, the concept of a round is becoming less structured. Currently over-structuring this until we understand what columns aren't needing. May add or remove some foreign keys, and potentially tie to and event or group. */
export type EventMatchesTeamsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventMatchesTeamsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventMatchesTeamsOrderBy>>;
  where?: InputMaybe<EventMatchesTeamsBoolExp>;
};

/** aggregated selection of "event_matches" */
export type EventMatchesAggregate = {
  __typename?: 'EventMatchesAggregate';
  aggregate?: Maybe<EventMatchesAggregateFields>;
  nodes: Array<EventMatches>;
};

export type EventMatchesAggregateBoolExp = {
  bool_and?: InputMaybe<EventMatchesAggregateBoolExpBool_And>;
  bool_or?: InputMaybe<EventMatchesAggregateBoolExpBool_Or>;
  count?: InputMaybe<EventMatchesAggregateBoolExpCount>;
};

/** aggregate fields of "event_matches" */
export type EventMatchesAggregateFields = {
  __typename?: 'EventMatchesAggregateFields';
  avg?: Maybe<EventMatchesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<EventMatchesMaxFields>;
  min?: Maybe<EventMatchesMinFields>;
  stddev?: Maybe<EventMatchesStddevFields>;
  stddevPop?: Maybe<EventMatchesStddevPopFields>;
  stddevSamp?: Maybe<EventMatchesStddevSampFields>;
  sum?: Maybe<EventMatchesSumFields>;
  varPop?: Maybe<EventMatchesVarPopFields>;
  varSamp?: Maybe<EventMatchesVarSampFields>;
  variance?: Maybe<EventMatchesVarianceFields>;
};


/** aggregate fields of "event_matches" */
export type EventMatchesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EventMatchesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "event_matches" */
export type EventMatchesAggregateOrderBy = {
  avg?: InputMaybe<EventMatchesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EventMatchesMaxOrderBy>;
  min?: InputMaybe<EventMatchesMinOrderBy>;
  stddev?: InputMaybe<EventMatchesStddevOrderBy>;
  stddevPop?: InputMaybe<EventMatchesStddevPopOrderBy>;
  stddevSamp?: InputMaybe<EventMatchesStddevSampOrderBy>;
  sum?: InputMaybe<EventMatchesSumOrderBy>;
  varPop?: InputMaybe<EventMatchesVarPopOrderBy>;
  varSamp?: InputMaybe<EventMatchesVarSampOrderBy>;
  variance?: InputMaybe<EventMatchesVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "event_matches" */
export type EventMatchesArrRelInsertInput = {
  data: Array<EventMatchesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<EventMatchesOnConflict>;
};

/** aggregate avg on columns */
export type EventMatchesAvgFields = {
  __typename?: 'EventMatchesAvgFields';
  courtNumber?: Maybe<Scalars['Float']>;
  matchOrder?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "event_matches" */
export type EventMatchesAvgOrderBy = {
  courtNumber?: InputMaybe<OrderBy>;
  matchOrder?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "event_matches". All fields are combined with a logical 'AND'. */
export type EventMatchesBoolExp = {
  _and?: InputMaybe<Array<EventMatchesBoolExp>>;
  _not?: InputMaybe<EventMatchesBoolExp>;
  _or?: InputMaybe<Array<EventMatchesBoolExp>>;
  court?: InputMaybe<EventCourtsBoolExp>;
  courtNumber?: InputMaybe<IntComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  eventCourtId?: InputMaybe<UuidComparisonExp>;
  games?: InputMaybe<EventMatchGamesBoolExp>;
  gamesAggregate?: InputMaybe<EventMatchGamesAggregateBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isBye?: InputMaybe<BooleanComparisonExp>;
  isVairScoreSubmitted?: InputMaybe<BooleanComparisonExp>;
  losingTeam?: InputMaybe<EventTeamsBoolExp>;
  losingTeamId?: InputMaybe<UuidComparisonExp>;
  matchOrder?: InputMaybe<IntComparisonExp>;
  pool?: InputMaybe<EventGroupPoolsBoolExp>;
  poolId?: InputMaybe<UuidComparisonExp>;
  previousMatch1?: InputMaybe<EventMatchesBoolExp>;
  previousMatch1Id?: InputMaybe<UuidComparisonExp>;
  previousMatch2?: InputMaybe<EventMatchesBoolExp>;
  previousMatch2Id?: InputMaybe<UuidComparisonExp>;
  round?: InputMaybe<EventPoolRoundsBoolExp>;
  roundId?: InputMaybe<UuidComparisonExp>;
  selectionCriteriaPreviousMatch1?: InputMaybe<MatchSelectionCriteriaEnumComparisonExp>;
  selectionCriteriaPreviousMatch2?: InputMaybe<MatchSelectionCriteriaEnumComparisonExp>;
  team1?: InputMaybe<EventTeamsBoolExp>;
  team1Id?: InputMaybe<UuidComparisonExp>;
  team2?: InputMaybe<EventTeamsBoolExp>;
  team2Id?: InputMaybe<UuidComparisonExp>;
  teams?: InputMaybe<EventMatchesTeamsBoolExp>;
  teamsAggregate?: InputMaybe<EventMatchesTeamsAggregateBoolExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  winReason?: InputMaybe<WinReasonsEnumComparisonExp>;
  winningTeam?: InputMaybe<EventTeamsBoolExp>;
  winningTeamId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "event_matches" */
export enum EventMatchesConstraint {
  /** unique or primary key constraint on columns "id" */
  EventMatchesPkey = 'event_matches_pkey'
}

/** input type for incrementing numeric columns in table "event_matches" */
export type EventMatchesIncInput = {
  courtNumber?: InputMaybe<Scalars['Int']>;
  matchOrder?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "event_matches" */
export type EventMatchesInsertInput = {
  court?: InputMaybe<EventCourtsObjRelInsertInput>;
  courtNumber?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  eventCourtId?: InputMaybe<Scalars['uuid']>;
  games?: InputMaybe<EventMatchGamesArrRelInsertInput>;
  id?: InputMaybe<Scalars['uuid']>;
  isBye?: InputMaybe<Scalars['Boolean']>;
  isVairScoreSubmitted?: InputMaybe<Scalars['Boolean']>;
  losingTeam?: InputMaybe<EventTeamsObjRelInsertInput>;
  losingTeamId?: InputMaybe<Scalars['uuid']>;
  matchOrder?: InputMaybe<Scalars['Int']>;
  pool?: InputMaybe<EventGroupPoolsObjRelInsertInput>;
  poolId?: InputMaybe<Scalars['uuid']>;
  previousMatch1?: InputMaybe<EventMatchesObjRelInsertInput>;
  previousMatch1Id?: InputMaybe<Scalars['uuid']>;
  previousMatch2?: InputMaybe<EventMatchesObjRelInsertInput>;
  previousMatch2Id?: InputMaybe<Scalars['uuid']>;
  round?: InputMaybe<EventPoolRoundsObjRelInsertInput>;
  roundId?: InputMaybe<Scalars['uuid']>;
  selectionCriteriaPreviousMatch1?: InputMaybe<MatchSelectionCriteriaEnum>;
  selectionCriteriaPreviousMatch2?: InputMaybe<MatchSelectionCriteriaEnum>;
  team1?: InputMaybe<EventTeamsObjRelInsertInput>;
  team1Id?: InputMaybe<Scalars['uuid']>;
  team2?: InputMaybe<EventTeamsObjRelInsertInput>;
  team2Id?: InputMaybe<Scalars['uuid']>;
  teams?: InputMaybe<EventMatchesTeamsArrRelInsertInput>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  winReason?: InputMaybe<WinReasonsEnum>;
  winningTeam?: InputMaybe<EventTeamsObjRelInsertInput>;
  winningTeamId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type EventMatchesMaxFields = {
  __typename?: 'EventMatchesMaxFields';
  courtNumber?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  eventCourtId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  losingTeamId?: Maybe<Scalars['uuid']>;
  matchOrder?: Maybe<Scalars['Int']>;
  poolId?: Maybe<Scalars['uuid']>;
  previousMatch1Id?: Maybe<Scalars['uuid']>;
  previousMatch2Id?: Maybe<Scalars['uuid']>;
  roundId?: Maybe<Scalars['uuid']>;
  team1Id?: Maybe<Scalars['uuid']>;
  team2Id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  winningTeamId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "event_matches" */
export type EventMatchesMaxOrderBy = {
  courtNumber?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  eventCourtId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  losingTeamId?: InputMaybe<OrderBy>;
  matchOrder?: InputMaybe<OrderBy>;
  poolId?: InputMaybe<OrderBy>;
  previousMatch1Id?: InputMaybe<OrderBy>;
  previousMatch2Id?: InputMaybe<OrderBy>;
  roundId?: InputMaybe<OrderBy>;
  team1Id?: InputMaybe<OrderBy>;
  team2Id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  winningTeamId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type EventMatchesMinFields = {
  __typename?: 'EventMatchesMinFields';
  courtNumber?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  eventCourtId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  losingTeamId?: Maybe<Scalars['uuid']>;
  matchOrder?: Maybe<Scalars['Int']>;
  poolId?: Maybe<Scalars['uuid']>;
  previousMatch1Id?: Maybe<Scalars['uuid']>;
  previousMatch2Id?: Maybe<Scalars['uuid']>;
  roundId?: Maybe<Scalars['uuid']>;
  team1Id?: Maybe<Scalars['uuid']>;
  team2Id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  winningTeamId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "event_matches" */
export type EventMatchesMinOrderBy = {
  courtNumber?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  eventCourtId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  losingTeamId?: InputMaybe<OrderBy>;
  matchOrder?: InputMaybe<OrderBy>;
  poolId?: InputMaybe<OrderBy>;
  previousMatch1Id?: InputMaybe<OrderBy>;
  previousMatch2Id?: InputMaybe<OrderBy>;
  roundId?: InputMaybe<OrderBy>;
  team1Id?: InputMaybe<OrderBy>;
  team2Id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  winningTeamId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "event_matches" */
export type EventMatchesMutationResponse = {
  __typename?: 'EventMatchesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventMatches>;
};

/** input type for inserting object relation for remote table "event_matches" */
export type EventMatchesObjRelInsertInput = {
  data: EventMatchesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<EventMatchesOnConflict>;
};

/** on_conflict condition type for table "event_matches" */
export type EventMatchesOnConflict = {
  constraint: EventMatchesConstraint;
  updateColumns?: Array<EventMatchesUpdateColumn>;
  where?: InputMaybe<EventMatchesBoolExp>;
};

/** Ordering options when selecting data from "event_matches". */
export type EventMatchesOrderBy = {
  court?: InputMaybe<EventCourtsOrderBy>;
  courtNumber?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  eventCourtId?: InputMaybe<OrderBy>;
  gamesAggregate?: InputMaybe<EventMatchGamesAggregateOrderBy>;
  id?: InputMaybe<OrderBy>;
  isBye?: InputMaybe<OrderBy>;
  isVairScoreSubmitted?: InputMaybe<OrderBy>;
  losingTeam?: InputMaybe<EventTeamsOrderBy>;
  losingTeamId?: InputMaybe<OrderBy>;
  matchOrder?: InputMaybe<OrderBy>;
  pool?: InputMaybe<EventGroupPoolsOrderBy>;
  poolId?: InputMaybe<OrderBy>;
  previousMatch1?: InputMaybe<EventMatchesOrderBy>;
  previousMatch1Id?: InputMaybe<OrderBy>;
  previousMatch2?: InputMaybe<EventMatchesOrderBy>;
  previousMatch2Id?: InputMaybe<OrderBy>;
  round?: InputMaybe<EventPoolRoundsOrderBy>;
  roundId?: InputMaybe<OrderBy>;
  selectionCriteriaPreviousMatch1?: InputMaybe<OrderBy>;
  selectionCriteriaPreviousMatch2?: InputMaybe<OrderBy>;
  team1?: InputMaybe<EventTeamsOrderBy>;
  team1Id?: InputMaybe<OrderBy>;
  team2?: InputMaybe<EventTeamsOrderBy>;
  team2Id?: InputMaybe<OrderBy>;
  teamsAggregate?: InputMaybe<EventMatchesTeamsAggregateOrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  winReason?: InputMaybe<OrderBy>;
  winningTeam?: InputMaybe<EventTeamsOrderBy>;
  winningTeamId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: event_matches */
export type EventMatchesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "event_matches" */
export enum EventMatchesSelectColumn {
  /** column name */
  CourtNumber = 'courtNumber',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EventCourtId = 'eventCourtId',
  /** column name */
  Id = 'id',
  /** column name */
  IsBye = 'isBye',
  /** column name */
  IsVairScoreSubmitted = 'isVairScoreSubmitted',
  /** column name */
  LosingTeamId = 'losingTeamId',
  /** column name */
  MatchOrder = 'matchOrder',
  /** column name */
  PoolId = 'poolId',
  /** column name */
  PreviousMatch1Id = 'previousMatch1Id',
  /** column name */
  PreviousMatch2Id = 'previousMatch2Id',
  /** column name */
  RoundId = 'roundId',
  /** column name */
  SelectionCriteriaPreviousMatch1 = 'selectionCriteriaPreviousMatch1',
  /** column name */
  SelectionCriteriaPreviousMatch2 = 'selectionCriteriaPreviousMatch2',
  /** column name */
  Team1Id = 'team1Id',
  /** column name */
  Team2Id = 'team2Id',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  WinReason = 'winReason',
  /** column name */
  WinningTeamId = 'winningTeamId'
}

/** select "eventMatchesAggregateBoolExpBool_andArgumentsColumns" columns of table "event_matches" */
export enum EventMatchesSelectColumnEventMatchesAggregateBoolExpBool_AndArgumentsColumns {
  /** column name */
  IsBye = 'isBye',
  /** column name */
  IsVairScoreSubmitted = 'isVairScoreSubmitted'
}

/** select "eventMatchesAggregateBoolExpBool_orArgumentsColumns" columns of table "event_matches" */
export enum EventMatchesSelectColumnEventMatchesAggregateBoolExpBool_OrArgumentsColumns {
  /** column name */
  IsBye = 'isBye',
  /** column name */
  IsVairScoreSubmitted = 'isVairScoreSubmitted'
}

/** input type for updating data in table "event_matches" */
export type EventMatchesSetInput = {
  courtNumber?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  eventCourtId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  isBye?: InputMaybe<Scalars['Boolean']>;
  isVairScoreSubmitted?: InputMaybe<Scalars['Boolean']>;
  losingTeamId?: InputMaybe<Scalars['uuid']>;
  matchOrder?: InputMaybe<Scalars['Int']>;
  poolId?: InputMaybe<Scalars['uuid']>;
  previousMatch1Id?: InputMaybe<Scalars['uuid']>;
  previousMatch2Id?: InputMaybe<Scalars['uuid']>;
  roundId?: InputMaybe<Scalars['uuid']>;
  selectionCriteriaPreviousMatch1?: InputMaybe<MatchSelectionCriteriaEnum>;
  selectionCriteriaPreviousMatch2?: InputMaybe<MatchSelectionCriteriaEnum>;
  team1Id?: InputMaybe<Scalars['uuid']>;
  team2Id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  winReason?: InputMaybe<WinReasonsEnum>;
  winningTeamId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type EventMatchesStddevFields = {
  __typename?: 'EventMatchesStddevFields';
  courtNumber?: Maybe<Scalars['Float']>;
  matchOrder?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "event_matches" */
export type EventMatchesStddevOrderBy = {
  courtNumber?: InputMaybe<OrderBy>;
  matchOrder?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type EventMatchesStddevPopFields = {
  __typename?: 'EventMatchesStddevPopFields';
  courtNumber?: Maybe<Scalars['Float']>;
  matchOrder?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "event_matches" */
export type EventMatchesStddevPopOrderBy = {
  courtNumber?: InputMaybe<OrderBy>;
  matchOrder?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type EventMatchesStddevSampFields = {
  __typename?: 'EventMatchesStddevSampFields';
  courtNumber?: Maybe<Scalars['Float']>;
  matchOrder?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "event_matches" */
export type EventMatchesStddevSampOrderBy = {
  courtNumber?: InputMaybe<OrderBy>;
  matchOrder?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "event_matches" */
export type EventMatchesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventMatchesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventMatchesStreamCursorValueInput = {
  courtNumber?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  eventCourtId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  isBye?: InputMaybe<Scalars['Boolean']>;
  isVairScoreSubmitted?: InputMaybe<Scalars['Boolean']>;
  losingTeamId?: InputMaybe<Scalars['uuid']>;
  matchOrder?: InputMaybe<Scalars['Int']>;
  poolId?: InputMaybe<Scalars['uuid']>;
  previousMatch1Id?: InputMaybe<Scalars['uuid']>;
  previousMatch2Id?: InputMaybe<Scalars['uuid']>;
  roundId?: InputMaybe<Scalars['uuid']>;
  selectionCriteriaPreviousMatch1?: InputMaybe<MatchSelectionCriteriaEnum>;
  selectionCriteriaPreviousMatch2?: InputMaybe<MatchSelectionCriteriaEnum>;
  team1Id?: InputMaybe<Scalars['uuid']>;
  team2Id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  winReason?: InputMaybe<WinReasonsEnum>;
  winningTeamId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type EventMatchesSumFields = {
  __typename?: 'EventMatchesSumFields';
  courtNumber?: Maybe<Scalars['Int']>;
  matchOrder?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "event_matches" */
export type EventMatchesSumOrderBy = {
  courtNumber?: InputMaybe<OrderBy>;
  matchOrder?: InputMaybe<OrderBy>;
};

/** columns and relationships of "event_matches_teams" */
export type EventMatchesTeams = {
  __typename?: 'EventMatchesTeams';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  /** An object relationship */
  match: EventMatches;
  matchId: Scalars['uuid'];
  order: Scalars['Int'];
  /** An object relationship */
  team: EventTeams;
  teamId: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "event_matches_teams" */
export type EventMatchesTeamsAggregate = {
  __typename?: 'EventMatchesTeamsAggregate';
  aggregate?: Maybe<EventMatchesTeamsAggregateFields>;
  nodes: Array<EventMatchesTeams>;
};

export type EventMatchesTeamsAggregateBoolExp = {
  count?: InputMaybe<EventMatchesTeamsAggregateBoolExpCount>;
};

/** aggregate fields of "event_matches_teams" */
export type EventMatchesTeamsAggregateFields = {
  __typename?: 'EventMatchesTeamsAggregateFields';
  avg?: Maybe<EventMatchesTeamsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<EventMatchesTeamsMaxFields>;
  min?: Maybe<EventMatchesTeamsMinFields>;
  stddev?: Maybe<EventMatchesTeamsStddevFields>;
  stddevPop?: Maybe<EventMatchesTeamsStddevPopFields>;
  stddevSamp?: Maybe<EventMatchesTeamsStddevSampFields>;
  sum?: Maybe<EventMatchesTeamsSumFields>;
  varPop?: Maybe<EventMatchesTeamsVarPopFields>;
  varSamp?: Maybe<EventMatchesTeamsVarSampFields>;
  variance?: Maybe<EventMatchesTeamsVarianceFields>;
};


/** aggregate fields of "event_matches_teams" */
export type EventMatchesTeamsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EventMatchesTeamsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "event_matches_teams" */
export type EventMatchesTeamsAggregateOrderBy = {
  avg?: InputMaybe<EventMatchesTeamsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EventMatchesTeamsMaxOrderBy>;
  min?: InputMaybe<EventMatchesTeamsMinOrderBy>;
  stddev?: InputMaybe<EventMatchesTeamsStddevOrderBy>;
  stddevPop?: InputMaybe<EventMatchesTeamsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<EventMatchesTeamsStddevSampOrderBy>;
  sum?: InputMaybe<EventMatchesTeamsSumOrderBy>;
  varPop?: InputMaybe<EventMatchesTeamsVarPopOrderBy>;
  varSamp?: InputMaybe<EventMatchesTeamsVarSampOrderBy>;
  variance?: InputMaybe<EventMatchesTeamsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "event_matches_teams" */
export type EventMatchesTeamsArrRelInsertInput = {
  data: Array<EventMatchesTeamsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<EventMatchesTeamsOnConflict>;
};

/** aggregate avg on columns */
export type EventMatchesTeamsAvgFields = {
  __typename?: 'EventMatchesTeamsAvgFields';
  order?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "event_matches_teams" */
export type EventMatchesTeamsAvgOrderBy = {
  order?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "event_matches_teams". All fields are combined with a logical 'AND'. */
export type EventMatchesTeamsBoolExp = {
  _and?: InputMaybe<Array<EventMatchesTeamsBoolExp>>;
  _not?: InputMaybe<EventMatchesTeamsBoolExp>;
  _or?: InputMaybe<Array<EventMatchesTeamsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  match?: InputMaybe<EventMatchesBoolExp>;
  matchId?: InputMaybe<UuidComparisonExp>;
  order?: InputMaybe<IntComparisonExp>;
  team?: InputMaybe<EventTeamsBoolExp>;
  teamId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "event_matches_teams" */
export enum EventMatchesTeamsConstraint {
  /** unique or primary key constraint on columns "match_id", "team_id" */
  EventMatchesTeamsMatchIdTeamIdKey = 'event_matches_teams_match_id_team_id_key',
  /** unique or primary key constraint on columns "id" */
  EventMatchesTeamsPkey = 'event_matches_teams_pkey'
}

/** input type for incrementing numeric columns in table "event_matches_teams" */
export type EventMatchesTeamsIncInput = {
  order?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "event_matches_teams" */
export type EventMatchesTeamsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  match?: InputMaybe<EventMatchesObjRelInsertInput>;
  matchId?: InputMaybe<Scalars['uuid']>;
  order?: InputMaybe<Scalars['Int']>;
  team?: InputMaybe<EventTeamsObjRelInsertInput>;
  teamId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type EventMatchesTeamsMaxFields = {
  __typename?: 'EventMatchesTeamsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  matchId?: Maybe<Scalars['uuid']>;
  order?: Maybe<Scalars['Int']>;
  teamId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "event_matches_teams" */
export type EventMatchesTeamsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  matchId?: InputMaybe<OrderBy>;
  order?: InputMaybe<OrderBy>;
  teamId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type EventMatchesTeamsMinFields = {
  __typename?: 'EventMatchesTeamsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  matchId?: Maybe<Scalars['uuid']>;
  order?: Maybe<Scalars['Int']>;
  teamId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "event_matches_teams" */
export type EventMatchesTeamsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  matchId?: InputMaybe<OrderBy>;
  order?: InputMaybe<OrderBy>;
  teamId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "event_matches_teams" */
export type EventMatchesTeamsMutationResponse = {
  __typename?: 'EventMatchesTeamsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventMatchesTeams>;
};

/** on_conflict condition type for table "event_matches_teams" */
export type EventMatchesTeamsOnConflict = {
  constraint: EventMatchesTeamsConstraint;
  updateColumns?: Array<EventMatchesTeamsUpdateColumn>;
  where?: InputMaybe<EventMatchesTeamsBoolExp>;
};

/** Ordering options when selecting data from "event_matches_teams". */
export type EventMatchesTeamsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  match?: InputMaybe<EventMatchesOrderBy>;
  matchId?: InputMaybe<OrderBy>;
  order?: InputMaybe<OrderBy>;
  team?: InputMaybe<EventTeamsOrderBy>;
  teamId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: event_matches_teams */
export type EventMatchesTeamsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "event_matches_teams" */
export enum EventMatchesTeamsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  MatchId = 'matchId',
  /** column name */
  Order = 'order',
  /** column name */
  TeamId = 'teamId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "event_matches_teams" */
export type EventMatchesTeamsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  matchId?: InputMaybe<Scalars['uuid']>;
  order?: InputMaybe<Scalars['Int']>;
  teamId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type EventMatchesTeamsStddevFields = {
  __typename?: 'EventMatchesTeamsStddevFields';
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "event_matches_teams" */
export type EventMatchesTeamsStddevOrderBy = {
  order?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type EventMatchesTeamsStddevPopFields = {
  __typename?: 'EventMatchesTeamsStddevPopFields';
  order?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "event_matches_teams" */
export type EventMatchesTeamsStddevPopOrderBy = {
  order?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type EventMatchesTeamsStddevSampFields = {
  __typename?: 'EventMatchesTeamsStddevSampFields';
  order?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "event_matches_teams" */
export type EventMatchesTeamsStddevSampOrderBy = {
  order?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "event_matches_teams" */
export type EventMatchesTeamsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventMatchesTeamsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventMatchesTeamsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  matchId?: InputMaybe<Scalars['uuid']>;
  order?: InputMaybe<Scalars['Int']>;
  teamId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type EventMatchesTeamsSumFields = {
  __typename?: 'EventMatchesTeamsSumFields';
  order?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "event_matches_teams" */
export type EventMatchesTeamsSumOrderBy = {
  order?: InputMaybe<OrderBy>;
};

/** update columns of table "event_matches_teams" */
export enum EventMatchesTeamsUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  MatchId = 'matchId',
  /** column name */
  Order = 'order',
  /** column name */
  TeamId = 'teamId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type EventMatchesTeamsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<EventMatchesTeamsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventMatchesTeamsSetInput>;
  /** filter the rows which have to be updated */
  where: EventMatchesTeamsBoolExp;
};

/** aggregate varPop on columns */
export type EventMatchesTeamsVarPopFields = {
  __typename?: 'EventMatchesTeamsVarPopFields';
  order?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "event_matches_teams" */
export type EventMatchesTeamsVarPopOrderBy = {
  order?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type EventMatchesTeamsVarSampFields = {
  __typename?: 'EventMatchesTeamsVarSampFields';
  order?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "event_matches_teams" */
export type EventMatchesTeamsVarSampOrderBy = {
  order?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type EventMatchesTeamsVarianceFields = {
  __typename?: 'EventMatchesTeamsVarianceFields';
  order?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "event_matches_teams" */
export type EventMatchesTeamsVarianceOrderBy = {
  order?: InputMaybe<OrderBy>;
};

/** update columns of table "event_matches" */
export enum EventMatchesUpdateColumn {
  /** column name */
  CourtNumber = 'courtNumber',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EventCourtId = 'eventCourtId',
  /** column name */
  Id = 'id',
  /** column name */
  IsBye = 'isBye',
  /** column name */
  IsVairScoreSubmitted = 'isVairScoreSubmitted',
  /** column name */
  LosingTeamId = 'losingTeamId',
  /** column name */
  MatchOrder = 'matchOrder',
  /** column name */
  PoolId = 'poolId',
  /** column name */
  PreviousMatch1Id = 'previousMatch1Id',
  /** column name */
  PreviousMatch2Id = 'previousMatch2Id',
  /** column name */
  RoundId = 'roundId',
  /** column name */
  SelectionCriteriaPreviousMatch1 = 'selectionCriteriaPreviousMatch1',
  /** column name */
  SelectionCriteriaPreviousMatch2 = 'selectionCriteriaPreviousMatch2',
  /** column name */
  Team1Id = 'team1Id',
  /** column name */
  Team2Id = 'team2Id',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  WinReason = 'winReason',
  /** column name */
  WinningTeamId = 'winningTeamId'
}

export type EventMatchesUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<EventMatchesIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventMatchesSetInput>;
  /** filter the rows which have to be updated */
  where: EventMatchesBoolExp;
};

/** aggregate varPop on columns */
export type EventMatchesVarPopFields = {
  __typename?: 'EventMatchesVarPopFields';
  courtNumber?: Maybe<Scalars['Float']>;
  matchOrder?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "event_matches" */
export type EventMatchesVarPopOrderBy = {
  courtNumber?: InputMaybe<OrderBy>;
  matchOrder?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type EventMatchesVarSampFields = {
  __typename?: 'EventMatchesVarSampFields';
  courtNumber?: Maybe<Scalars['Float']>;
  matchOrder?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "event_matches" */
export type EventMatchesVarSampOrderBy = {
  courtNumber?: InputMaybe<OrderBy>;
  matchOrder?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type EventMatchesVarianceFields = {
  __typename?: 'EventMatchesVarianceFields';
  courtNumber?: Maybe<Scalars['Float']>;
  matchOrder?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "event_matches" */
export type EventMatchesVarianceOrderBy = {
  courtNumber?: InputMaybe<OrderBy>;
  matchOrder?: InputMaybe<OrderBy>;
};

/** columns and relationships of "event_organizer_account_types" */
export type EventOrganizerAccountTypes = {
  __typename?: 'EventOrganizerAccountTypes';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "event_organizer_account_types" */
export type EventOrganizerAccountTypesAggregate = {
  __typename?: 'EventOrganizerAccountTypesAggregate';
  aggregate?: Maybe<EventOrganizerAccountTypesAggregateFields>;
  nodes: Array<EventOrganizerAccountTypes>;
};

/** aggregate fields of "event_organizer_account_types" */
export type EventOrganizerAccountTypesAggregateFields = {
  __typename?: 'EventOrganizerAccountTypesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<EventOrganizerAccountTypesMaxFields>;
  min?: Maybe<EventOrganizerAccountTypesMinFields>;
};


/** aggregate fields of "event_organizer_account_types" */
export type EventOrganizerAccountTypesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EventOrganizerAccountTypesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "event_organizer_account_types". All fields are combined with a logical 'AND'. */
export type EventOrganizerAccountTypesBoolExp = {
  _and?: InputMaybe<Array<EventOrganizerAccountTypesBoolExp>>;
  _not?: InputMaybe<EventOrganizerAccountTypesBoolExp>;
  _or?: InputMaybe<Array<EventOrganizerAccountTypesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "event_organizer_account_types" */
export enum EventOrganizerAccountTypesConstraint {
  /** unique or primary key constraint on columns "value" */
  EventOrganizerAccountTypesPkey = 'event_organizer_account_types_pkey'
}

export enum EventOrganizerAccountTypesEnum {
  Club = 'CLUB',
  Inactive = 'INACTIVE',
  Individual = 'INDIVIDUAL',
  Other = 'OTHER',
  Tour = 'TOUR'
}

/** Boolean expression to compare columns of type "EventOrganizerAccountTypesEnum". All fields are combined with logical 'AND'. */
export type EventOrganizerAccountTypesEnumComparisonExp = {
  _eq?: InputMaybe<EventOrganizerAccountTypesEnum>;
  _in?: InputMaybe<Array<EventOrganizerAccountTypesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<EventOrganizerAccountTypesEnum>;
  _nin?: InputMaybe<Array<EventOrganizerAccountTypesEnum>>;
};

/** input type for inserting data into table "event_organizer_account_types" */
export type EventOrganizerAccountTypesInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type EventOrganizerAccountTypesMaxFields = {
  __typename?: 'EventOrganizerAccountTypesMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type EventOrganizerAccountTypesMinFields = {
  __typename?: 'EventOrganizerAccountTypesMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "event_organizer_account_types" */
export type EventOrganizerAccountTypesMutationResponse = {
  __typename?: 'EventOrganizerAccountTypesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventOrganizerAccountTypes>;
};

/** on_conflict condition type for table "event_organizer_account_types" */
export type EventOrganizerAccountTypesOnConflict = {
  constraint: EventOrganizerAccountTypesConstraint;
  updateColumns?: Array<EventOrganizerAccountTypesUpdateColumn>;
  where?: InputMaybe<EventOrganizerAccountTypesBoolExp>;
};

/** Ordering options when selecting data from "event_organizer_account_types". */
export type EventOrganizerAccountTypesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: event_organizer_account_types */
export type EventOrganizerAccountTypesPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "event_organizer_account_types" */
export enum EventOrganizerAccountTypesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "event_organizer_account_types" */
export type EventOrganizerAccountTypesSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "event_organizer_account_types" */
export type EventOrganizerAccountTypesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventOrganizerAccountTypesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventOrganizerAccountTypesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "event_organizer_account_types" */
export enum EventOrganizerAccountTypesUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type EventOrganizerAccountTypesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventOrganizerAccountTypesSetInput>;
  /** filter the rows which have to be updated */
  where: EventOrganizerAccountTypesBoolExp;
};

/** columns and relationships of "event_player_invite_statuses" */
export type EventPlayerInviteStatuses = {
  __typename?: 'EventPlayerInviteStatuses';
  comment?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "event_player_invite_statuses" */
export type EventPlayerInviteStatusesAggregate = {
  __typename?: 'EventPlayerInviteStatusesAggregate';
  aggregate?: Maybe<EventPlayerInviteStatusesAggregateFields>;
  nodes: Array<EventPlayerInviteStatuses>;
};

/** aggregate fields of "event_player_invite_statuses" */
export type EventPlayerInviteStatusesAggregateFields = {
  __typename?: 'EventPlayerInviteStatusesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<EventPlayerInviteStatusesMaxFields>;
  min?: Maybe<EventPlayerInviteStatusesMinFields>;
};


/** aggregate fields of "event_player_invite_statuses" */
export type EventPlayerInviteStatusesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EventPlayerInviteStatusesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "event_player_invite_statuses". All fields are combined with a logical 'AND'. */
export type EventPlayerInviteStatusesBoolExp = {
  _and?: InputMaybe<Array<EventPlayerInviteStatusesBoolExp>>;
  _not?: InputMaybe<EventPlayerInviteStatusesBoolExp>;
  _or?: InputMaybe<Array<EventPlayerInviteStatusesBoolExp>>;
  comment?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "event_player_invite_statuses" */
export enum EventPlayerInviteStatusesConstraint {
  /** unique or primary key constraint on columns "value" */
  EventPlayerInviteStatusesPkey = 'event_player_invite_statuses_pkey'
}

export enum EventPlayerInviteStatusesEnum {
  Accepted = 'ACCEPTED',
  /** host removed the invited player */
  Cancelled = 'CANCELLED',
  Declined = 'DECLINED',
  /** game started or was cancelled before a response */
  Expired = 'EXPIRED',
  /** awaiting the invited player */
  Pending = 'PENDING'
}

/** Boolean expression to compare columns of type "EventPlayerInviteStatusesEnum". All fields are combined with logical 'AND'. */
export type EventPlayerInviteStatusesEnumComparisonExp = {
  _eq?: InputMaybe<EventPlayerInviteStatusesEnum>;
  _in?: InputMaybe<Array<EventPlayerInviteStatusesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<EventPlayerInviteStatusesEnum>;
  _nin?: InputMaybe<Array<EventPlayerInviteStatusesEnum>>;
};

/** input type for inserting data into table "event_player_invite_statuses" */
export type EventPlayerInviteStatusesInsertInput = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type EventPlayerInviteStatusesMaxFields = {
  __typename?: 'EventPlayerInviteStatusesMaxFields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type EventPlayerInviteStatusesMinFields = {
  __typename?: 'EventPlayerInviteStatusesMinFields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "event_player_invite_statuses" */
export type EventPlayerInviteStatusesMutationResponse = {
  __typename?: 'EventPlayerInviteStatusesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventPlayerInviteStatuses>;
};

/** on_conflict condition type for table "event_player_invite_statuses" */
export type EventPlayerInviteStatusesOnConflict = {
  constraint: EventPlayerInviteStatusesConstraint;
  updateColumns?: Array<EventPlayerInviteStatusesUpdateColumn>;
  where?: InputMaybe<EventPlayerInviteStatusesBoolExp>;
};

/** Ordering options when selecting data from "event_player_invite_statuses". */
export type EventPlayerInviteStatusesOrderBy = {
  comment?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: event_player_invite_statuses */
export type EventPlayerInviteStatusesPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "event_player_invite_statuses" */
export enum EventPlayerInviteStatusesSelectColumn {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "event_player_invite_statuses" */
export type EventPlayerInviteStatusesSetInput = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "event_player_invite_statuses" */
export type EventPlayerInviteStatusesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventPlayerInviteStatusesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventPlayerInviteStatusesStreamCursorValueInput = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "event_player_invite_statuses" */
export enum EventPlayerInviteStatusesUpdateColumn {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type EventPlayerInviteStatusesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventPlayerInviteStatusesSetInput>;
  /** filter the rows which have to be updated */
  where: EventPlayerInviteStatusesBoolExp;
};

/** columns and relationships of "event_player_invites" */
export type EventPlayerInvites = {
  __typename?: 'EventPlayerInvites';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  event: Events;
  eventId: Scalars['uuid'];
  id: Scalars['uuid'];
  /** An object relationship */
  invitedUser: Users;
  invitedUserId: Scalars['uuid'];
  /** An object relationship */
  invitedUserProfile?: Maybe<UserProfiles>;
  /** An object relationship */
  inviter: Users;
  /** An object relationship */
  inviterProfile?: Maybe<UserProfiles>;
  inviterUserId: Scalars['uuid'];
  /** An object relationship */
  playRequest?: Maybe<PlayRequests>;
  playRequestId?: Maybe<Scalars['uuid']>;
  respondedAt?: Maybe<Scalars['timestamptz']>;
  status: EventPlayerInviteStatusesEnum;
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "event_player_invites" */
export type EventPlayerInvitesAggregate = {
  __typename?: 'EventPlayerInvitesAggregate';
  aggregate?: Maybe<EventPlayerInvitesAggregateFields>;
  nodes: Array<EventPlayerInvites>;
};

/** aggregate fields of "event_player_invites" */
export type EventPlayerInvitesAggregateFields = {
  __typename?: 'EventPlayerInvitesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<EventPlayerInvitesMaxFields>;
  min?: Maybe<EventPlayerInvitesMinFields>;
};


/** aggregate fields of "event_player_invites" */
export type EventPlayerInvitesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EventPlayerInvitesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "event_player_invites". All fields are combined with a logical 'AND'. */
export type EventPlayerInvitesBoolExp = {
  _and?: InputMaybe<Array<EventPlayerInvitesBoolExp>>;
  _not?: InputMaybe<EventPlayerInvitesBoolExp>;
  _or?: InputMaybe<Array<EventPlayerInvitesBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  event?: InputMaybe<EventsBoolExp>;
  eventId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  invitedUser?: InputMaybe<UsersBoolExp>;
  invitedUserId?: InputMaybe<UuidComparisonExp>;
  invitedUserProfile?: InputMaybe<UserProfilesBoolExp>;
  inviter?: InputMaybe<UsersBoolExp>;
  inviterProfile?: InputMaybe<UserProfilesBoolExp>;
  inviterUserId?: InputMaybe<UuidComparisonExp>;
  playRequest?: InputMaybe<PlayRequestsBoolExp>;
  playRequestId?: InputMaybe<UuidComparisonExp>;
  respondedAt?: InputMaybe<TimestamptzComparisonExp>;
  status?: InputMaybe<EventPlayerInviteStatusesEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "event_player_invites" */
export enum EventPlayerInvitesConstraint {
  /** unique or primary key constraint on columns "invited_user_id", "event_id" */
  EventPlayerInvitesOnePendingPerPlayer = 'event_player_invites_one_pending_per_player',
  /** unique or primary key constraint on columns "id" */
  EventPlayerInvitesPkey = 'event_player_invites_pkey'
}

/** input type for inserting data into table "event_player_invites" */
export type EventPlayerInvitesInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  event?: InputMaybe<EventsObjRelInsertInput>;
  eventId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  invitedUser?: InputMaybe<UsersObjRelInsertInput>;
  invitedUserId?: InputMaybe<Scalars['uuid']>;
  invitedUserProfile?: InputMaybe<UserProfilesObjRelInsertInput>;
  inviter?: InputMaybe<UsersObjRelInsertInput>;
  inviterProfile?: InputMaybe<UserProfilesObjRelInsertInput>;
  inviterUserId?: InputMaybe<Scalars['uuid']>;
  playRequest?: InputMaybe<PlayRequestsObjRelInsertInput>;
  playRequestId?: InputMaybe<Scalars['uuid']>;
  respondedAt?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<EventPlayerInviteStatusesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type EventPlayerInvitesMaxFields = {
  __typename?: 'EventPlayerInvitesMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  eventId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  invitedUserId?: Maybe<Scalars['uuid']>;
  inviterUserId?: Maybe<Scalars['uuid']>;
  playRequestId?: Maybe<Scalars['uuid']>;
  respondedAt?: Maybe<Scalars['timestamptz']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type EventPlayerInvitesMinFields = {
  __typename?: 'EventPlayerInvitesMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  eventId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  invitedUserId?: Maybe<Scalars['uuid']>;
  inviterUserId?: Maybe<Scalars['uuid']>;
  playRequestId?: Maybe<Scalars['uuid']>;
  respondedAt?: Maybe<Scalars['timestamptz']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "event_player_invites" */
export type EventPlayerInvitesMutationResponse = {
  __typename?: 'EventPlayerInvitesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventPlayerInvites>;
};

/** input type for inserting object relation for remote table "event_player_invites" */
export type EventPlayerInvitesObjRelInsertInput = {
  data: EventPlayerInvitesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<EventPlayerInvitesOnConflict>;
};

/** on_conflict condition type for table "event_player_invites" */
export type EventPlayerInvitesOnConflict = {
  constraint: EventPlayerInvitesConstraint;
  updateColumns?: Array<EventPlayerInvitesUpdateColumn>;
  where?: InputMaybe<EventPlayerInvitesBoolExp>;
};

/** Ordering options when selecting data from "event_player_invites". */
export type EventPlayerInvitesOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  event?: InputMaybe<EventsOrderBy>;
  eventId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  invitedUser?: InputMaybe<UsersOrderBy>;
  invitedUserId?: InputMaybe<OrderBy>;
  invitedUserProfile?: InputMaybe<UserProfilesOrderBy>;
  inviter?: InputMaybe<UsersOrderBy>;
  inviterProfile?: InputMaybe<UserProfilesOrderBy>;
  inviterUserId?: InputMaybe<OrderBy>;
  playRequest?: InputMaybe<PlayRequestsOrderBy>;
  playRequestId?: InputMaybe<OrderBy>;
  respondedAt?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: event_player_invites */
export type EventPlayerInvitesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "event_player_invites" */
export enum EventPlayerInvitesSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EventId = 'eventId',
  /** column name */
  Id = 'id',
  /** column name */
  InvitedUserId = 'invitedUserId',
  /** column name */
  InviterUserId = 'inviterUserId',
  /** column name */
  PlayRequestId = 'playRequestId',
  /** column name */
  RespondedAt = 'respondedAt',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "event_player_invites" */
export type EventPlayerInvitesSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  eventId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  invitedUserId?: InputMaybe<Scalars['uuid']>;
  inviterUserId?: InputMaybe<Scalars['uuid']>;
  playRequestId?: InputMaybe<Scalars['uuid']>;
  respondedAt?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<EventPlayerInviteStatusesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "event_player_invites" */
export type EventPlayerInvitesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventPlayerInvitesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventPlayerInvitesStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  eventId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  invitedUserId?: InputMaybe<Scalars['uuid']>;
  inviterUserId?: InputMaybe<Scalars['uuid']>;
  playRequestId?: InputMaybe<Scalars['uuid']>;
  respondedAt?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<EventPlayerInviteStatusesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "event_player_invites" */
export enum EventPlayerInvitesUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EventId = 'eventId',
  /** column name */
  Id = 'id',
  /** column name */
  InvitedUserId = 'invitedUserId',
  /** column name */
  InviterUserId = 'inviterUserId',
  /** column name */
  PlayRequestId = 'playRequestId',
  /** column name */
  RespondedAt = 'respondedAt',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type EventPlayerInvitesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventPlayerInvitesSetInput>;
  /** filter the rows which have to be updated */
  where: EventPlayerInvitesBoolExp;
};

/** columns and relationships of "event_pool_rounds" */
export type EventPoolRounds = {
  __typename?: 'EventPoolRounds';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  /** An array relationship */
  matches: Array<EventMatches>;
  /** An aggregate relationship */
  matchesAggregate: EventMatchesAggregate;
  /** An object relationship */
  pool: EventGroupPools;
  poolId: Scalars['uuid'];
  roundOrder: Scalars['Int'];
  title: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "event_pool_rounds" */
export type EventPoolRoundsMatchesArgs = {
  distinctOn?: InputMaybe<Array<EventMatchesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventMatchesOrderBy>>;
  where?: InputMaybe<EventMatchesBoolExp>;
};


/** columns and relationships of "event_pool_rounds" */
export type EventPoolRoundsMatchesAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventMatchesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventMatchesOrderBy>>;
  where?: InputMaybe<EventMatchesBoolExp>;
};

/** aggregated selection of "event_pool_rounds" */
export type EventPoolRoundsAggregate = {
  __typename?: 'EventPoolRoundsAggregate';
  aggregate?: Maybe<EventPoolRoundsAggregateFields>;
  nodes: Array<EventPoolRounds>;
};

export type EventPoolRoundsAggregateBoolExp = {
  count?: InputMaybe<EventPoolRoundsAggregateBoolExpCount>;
};

/** aggregate fields of "event_pool_rounds" */
export type EventPoolRoundsAggregateFields = {
  __typename?: 'EventPoolRoundsAggregateFields';
  avg?: Maybe<EventPoolRoundsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<EventPoolRoundsMaxFields>;
  min?: Maybe<EventPoolRoundsMinFields>;
  stddev?: Maybe<EventPoolRoundsStddevFields>;
  stddevPop?: Maybe<EventPoolRoundsStddevPopFields>;
  stddevSamp?: Maybe<EventPoolRoundsStddevSampFields>;
  sum?: Maybe<EventPoolRoundsSumFields>;
  varPop?: Maybe<EventPoolRoundsVarPopFields>;
  varSamp?: Maybe<EventPoolRoundsVarSampFields>;
  variance?: Maybe<EventPoolRoundsVarianceFields>;
};


/** aggregate fields of "event_pool_rounds" */
export type EventPoolRoundsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EventPoolRoundsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "event_pool_rounds" */
export type EventPoolRoundsAggregateOrderBy = {
  avg?: InputMaybe<EventPoolRoundsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EventPoolRoundsMaxOrderBy>;
  min?: InputMaybe<EventPoolRoundsMinOrderBy>;
  stddev?: InputMaybe<EventPoolRoundsStddevOrderBy>;
  stddevPop?: InputMaybe<EventPoolRoundsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<EventPoolRoundsStddevSampOrderBy>;
  sum?: InputMaybe<EventPoolRoundsSumOrderBy>;
  varPop?: InputMaybe<EventPoolRoundsVarPopOrderBy>;
  varSamp?: InputMaybe<EventPoolRoundsVarSampOrderBy>;
  variance?: InputMaybe<EventPoolRoundsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "event_pool_rounds" */
export type EventPoolRoundsArrRelInsertInput = {
  data: Array<EventPoolRoundsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<EventPoolRoundsOnConflict>;
};

/** aggregate avg on columns */
export type EventPoolRoundsAvgFields = {
  __typename?: 'EventPoolRoundsAvgFields';
  roundOrder?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "event_pool_rounds" */
export type EventPoolRoundsAvgOrderBy = {
  roundOrder?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "event_pool_rounds". All fields are combined with a logical 'AND'. */
export type EventPoolRoundsBoolExp = {
  _and?: InputMaybe<Array<EventPoolRoundsBoolExp>>;
  _not?: InputMaybe<EventPoolRoundsBoolExp>;
  _or?: InputMaybe<Array<EventPoolRoundsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  matches?: InputMaybe<EventMatchesBoolExp>;
  matchesAggregate?: InputMaybe<EventMatchesAggregateBoolExp>;
  pool?: InputMaybe<EventGroupPoolsBoolExp>;
  poolId?: InputMaybe<UuidComparisonExp>;
  roundOrder?: InputMaybe<IntComparisonExp>;
  title?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "event_pool_rounds" */
export enum EventPoolRoundsConstraint {
  /** unique or primary key constraint on columns "id" */
  EventPoolRoundsPkey = 'event_pool_rounds_pkey',
  /** unique or primary key constraint on columns "pool_id", "round_order" */
  EventPoolRoundsPoolIdRoundOrderKey = 'event_pool_rounds_pool_id_round_order_key'
}

/** input type for incrementing numeric columns in table "event_pool_rounds" */
export type EventPoolRoundsIncInput = {
  roundOrder?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "event_pool_rounds" */
export type EventPoolRoundsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  matches?: InputMaybe<EventMatchesArrRelInsertInput>;
  pool?: InputMaybe<EventGroupPoolsObjRelInsertInput>;
  poolId?: InputMaybe<Scalars['uuid']>;
  roundOrder?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type EventPoolRoundsMaxFields = {
  __typename?: 'EventPoolRoundsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  poolId?: Maybe<Scalars['uuid']>;
  roundOrder?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "event_pool_rounds" */
export type EventPoolRoundsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  poolId?: InputMaybe<OrderBy>;
  roundOrder?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type EventPoolRoundsMinFields = {
  __typename?: 'EventPoolRoundsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  poolId?: Maybe<Scalars['uuid']>;
  roundOrder?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "event_pool_rounds" */
export type EventPoolRoundsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  poolId?: InputMaybe<OrderBy>;
  roundOrder?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "event_pool_rounds" */
export type EventPoolRoundsMutationResponse = {
  __typename?: 'EventPoolRoundsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventPoolRounds>;
};

/** input type for inserting object relation for remote table "event_pool_rounds" */
export type EventPoolRoundsObjRelInsertInput = {
  data: EventPoolRoundsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<EventPoolRoundsOnConflict>;
};

/** on_conflict condition type for table "event_pool_rounds" */
export type EventPoolRoundsOnConflict = {
  constraint: EventPoolRoundsConstraint;
  updateColumns?: Array<EventPoolRoundsUpdateColumn>;
  where?: InputMaybe<EventPoolRoundsBoolExp>;
};

/** Ordering options when selecting data from "event_pool_rounds". */
export type EventPoolRoundsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  matchesAggregate?: InputMaybe<EventMatchesAggregateOrderBy>;
  pool?: InputMaybe<EventGroupPoolsOrderBy>;
  poolId?: InputMaybe<OrderBy>;
  roundOrder?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: event_pool_rounds */
export type EventPoolRoundsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "event_pool_rounds" */
export enum EventPoolRoundsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  PoolId = 'poolId',
  /** column name */
  RoundOrder = 'roundOrder',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "event_pool_rounds" */
export type EventPoolRoundsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  poolId?: InputMaybe<Scalars['uuid']>;
  roundOrder?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type EventPoolRoundsStddevFields = {
  __typename?: 'EventPoolRoundsStddevFields';
  roundOrder?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "event_pool_rounds" */
export type EventPoolRoundsStddevOrderBy = {
  roundOrder?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type EventPoolRoundsStddevPopFields = {
  __typename?: 'EventPoolRoundsStddevPopFields';
  roundOrder?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "event_pool_rounds" */
export type EventPoolRoundsStddevPopOrderBy = {
  roundOrder?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type EventPoolRoundsStddevSampFields = {
  __typename?: 'EventPoolRoundsStddevSampFields';
  roundOrder?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "event_pool_rounds" */
export type EventPoolRoundsStddevSampOrderBy = {
  roundOrder?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "event_pool_rounds" */
export type EventPoolRoundsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventPoolRoundsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventPoolRoundsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  poolId?: InputMaybe<Scalars['uuid']>;
  roundOrder?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type EventPoolRoundsSumFields = {
  __typename?: 'EventPoolRoundsSumFields';
  roundOrder?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "event_pool_rounds" */
export type EventPoolRoundsSumOrderBy = {
  roundOrder?: InputMaybe<OrderBy>;
};

/** update columns of table "event_pool_rounds" */
export enum EventPoolRoundsUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  PoolId = 'poolId',
  /** column name */
  RoundOrder = 'roundOrder',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type EventPoolRoundsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<EventPoolRoundsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventPoolRoundsSetInput>;
  /** filter the rows which have to be updated */
  where: EventPoolRoundsBoolExp;
};

/** aggregate varPop on columns */
export type EventPoolRoundsVarPopFields = {
  __typename?: 'EventPoolRoundsVarPopFields';
  roundOrder?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "event_pool_rounds" */
export type EventPoolRoundsVarPopOrderBy = {
  roundOrder?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type EventPoolRoundsVarSampFields = {
  __typename?: 'EventPoolRoundsVarSampFields';
  roundOrder?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "event_pool_rounds" */
export type EventPoolRoundsVarSampOrderBy = {
  roundOrder?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type EventPoolRoundsVarianceFields = {
  __typename?: 'EventPoolRoundsVarianceFields';
  roundOrder?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "event_pool_rounds" */
export type EventPoolRoundsVarianceOrderBy = {
  roundOrder?: InputMaybe<OrderBy>;
};

/** columns and relationships of "event_pools_teams" */
export type EventPoolsTeams = {
  __typename?: 'EventPoolsTeams';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  /** An object relationship */
  pool: EventGroupPools;
  poolId: Scalars['uuid'];
  /** An object relationship */
  team: EventTeams;
  teamId: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "event_pools_teams" */
export type EventPoolsTeamsAggregate = {
  __typename?: 'EventPoolsTeamsAggregate';
  aggregate?: Maybe<EventPoolsTeamsAggregateFields>;
  nodes: Array<EventPoolsTeams>;
};

export type EventPoolsTeamsAggregateBoolExp = {
  count?: InputMaybe<EventPoolsTeamsAggregateBoolExpCount>;
};

/** aggregate fields of "event_pools_teams" */
export type EventPoolsTeamsAggregateFields = {
  __typename?: 'EventPoolsTeamsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<EventPoolsTeamsMaxFields>;
  min?: Maybe<EventPoolsTeamsMinFields>;
};


/** aggregate fields of "event_pools_teams" */
export type EventPoolsTeamsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EventPoolsTeamsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "event_pools_teams" */
export type EventPoolsTeamsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EventPoolsTeamsMaxOrderBy>;
  min?: InputMaybe<EventPoolsTeamsMinOrderBy>;
};

/** input type for inserting array relation for remote table "event_pools_teams" */
export type EventPoolsTeamsArrRelInsertInput = {
  data: Array<EventPoolsTeamsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<EventPoolsTeamsOnConflict>;
};

/** Boolean expression to filter rows from the table "event_pools_teams". All fields are combined with a logical 'AND'. */
export type EventPoolsTeamsBoolExp = {
  _and?: InputMaybe<Array<EventPoolsTeamsBoolExp>>;
  _not?: InputMaybe<EventPoolsTeamsBoolExp>;
  _or?: InputMaybe<Array<EventPoolsTeamsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  pool?: InputMaybe<EventGroupPoolsBoolExp>;
  poolId?: InputMaybe<UuidComparisonExp>;
  team?: InputMaybe<EventTeamsBoolExp>;
  teamId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "event_pools_teams" */
export enum EventPoolsTeamsConstraint {
  /** unique or primary key constraint on columns "id" */
  EventPoolsTeamsPkey = 'event_pools_teams_pkey',
  /** unique or primary key constraint on columns "pool_id", "team_id" */
  EventPoolsTeamsPoolIdTeamIdKey = 'event_pools_teams_pool_id_team_id_key'
}

/** input type for inserting data into table "event_pools_teams" */
export type EventPoolsTeamsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  pool?: InputMaybe<EventGroupPoolsObjRelInsertInput>;
  poolId?: InputMaybe<Scalars['uuid']>;
  team?: InputMaybe<EventTeamsObjRelInsertInput>;
  teamId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type EventPoolsTeamsMaxFields = {
  __typename?: 'EventPoolsTeamsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  poolId?: Maybe<Scalars['uuid']>;
  teamId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "event_pools_teams" */
export type EventPoolsTeamsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  poolId?: InputMaybe<OrderBy>;
  teamId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type EventPoolsTeamsMinFields = {
  __typename?: 'EventPoolsTeamsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  poolId?: Maybe<Scalars['uuid']>;
  teamId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "event_pools_teams" */
export type EventPoolsTeamsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  poolId?: InputMaybe<OrderBy>;
  teamId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "event_pools_teams" */
export type EventPoolsTeamsMutationResponse = {
  __typename?: 'EventPoolsTeamsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventPoolsTeams>;
};

/** on_conflict condition type for table "event_pools_teams" */
export type EventPoolsTeamsOnConflict = {
  constraint: EventPoolsTeamsConstraint;
  updateColumns?: Array<EventPoolsTeamsUpdateColumn>;
  where?: InputMaybe<EventPoolsTeamsBoolExp>;
};

/** Ordering options when selecting data from "event_pools_teams". */
export type EventPoolsTeamsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  pool?: InputMaybe<EventGroupPoolsOrderBy>;
  poolId?: InputMaybe<OrderBy>;
  team?: InputMaybe<EventTeamsOrderBy>;
  teamId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: event_pools_teams */
export type EventPoolsTeamsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "event_pools_teams" */
export enum EventPoolsTeamsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  PoolId = 'poolId',
  /** column name */
  TeamId = 'teamId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "event_pools_teams" */
export type EventPoolsTeamsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  poolId?: InputMaybe<Scalars['uuid']>;
  teamId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "event_pools_teams" */
export type EventPoolsTeamsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventPoolsTeamsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventPoolsTeamsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  poolId?: InputMaybe<Scalars['uuid']>;
  teamId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "event_pools_teams" */
export enum EventPoolsTeamsUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  PoolId = 'poolId',
  /** column name */
  TeamId = 'teamId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type EventPoolsTeamsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventPoolsTeamsSetInput>;
  /** filter the rows which have to be updated */
  where: EventPoolsTeamsBoolExp;
};

/** columns and relationships of "event_privacy" */
export type EventPrivacy = {
  __typename?: 'EventPrivacy';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "event_privacy" */
export type EventPrivacyAggregate = {
  __typename?: 'EventPrivacyAggregate';
  aggregate?: Maybe<EventPrivacyAggregateFields>;
  nodes: Array<EventPrivacy>;
};

/** aggregate fields of "event_privacy" */
export type EventPrivacyAggregateFields = {
  __typename?: 'EventPrivacyAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<EventPrivacyMaxFields>;
  min?: Maybe<EventPrivacyMinFields>;
};


/** aggregate fields of "event_privacy" */
export type EventPrivacyAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EventPrivacySelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "event_privacy". All fields are combined with a logical 'AND'. */
export type EventPrivacyBoolExp = {
  _and?: InputMaybe<Array<EventPrivacyBoolExp>>;
  _not?: InputMaybe<EventPrivacyBoolExp>;
  _or?: InputMaybe<Array<EventPrivacyBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "event_privacy" */
export enum EventPrivacyConstraint {
  /** unique or primary key constraint on columns "value" */
  EventPrivacyPkey = 'event_privacy_pkey'
}

export enum EventPrivacyEnum {
  Private = 'PRIVATE',
  Public = 'PUBLIC',
  Unlisted = 'UNLISTED'
}

/** Boolean expression to compare columns of type "EventPrivacyEnum". All fields are combined with logical 'AND'. */
export type EventPrivacyEnumComparisonExp = {
  _eq?: InputMaybe<EventPrivacyEnum>;
  _in?: InputMaybe<Array<EventPrivacyEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<EventPrivacyEnum>;
  _nin?: InputMaybe<Array<EventPrivacyEnum>>;
};

/** input type for inserting data into table "event_privacy" */
export type EventPrivacyInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type EventPrivacyMaxFields = {
  __typename?: 'EventPrivacyMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type EventPrivacyMinFields = {
  __typename?: 'EventPrivacyMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "event_privacy" */
export type EventPrivacyMutationResponse = {
  __typename?: 'EventPrivacyMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventPrivacy>;
};

/** on_conflict condition type for table "event_privacy" */
export type EventPrivacyOnConflict = {
  constraint: EventPrivacyConstraint;
  updateColumns?: Array<EventPrivacyUpdateColumn>;
  where?: InputMaybe<EventPrivacyBoolExp>;
};

/** Ordering options when selecting data from "event_privacy". */
export type EventPrivacyOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: event_privacy */
export type EventPrivacyPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "event_privacy" */
export enum EventPrivacySelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "event_privacy" */
export type EventPrivacySetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "event_privacy" */
export type EventPrivacyStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventPrivacyStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventPrivacyStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "event_privacy" */
export enum EventPrivacyUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type EventPrivacyUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventPrivacySetInput>;
  /** filter the rows which have to be updated */
  where: EventPrivacyBoolExp;
};

/** columns and relationships of "event_registration_details" */
export type EventRegistrationDetails = {
  __typename?: 'EventRegistrationDetails';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  duprId?: Maybe<Scalars['String']>;
  eventRegistrationId: Scalars['uuid'];
  id: Scalars['uuid'];
  referredBy?: Maybe<Scalars['String']>;
  /** An object relationship */
  registration: EventRegistrations;
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "event_registration_details" */
export type EventRegistrationDetailsAggregate = {
  __typename?: 'EventRegistrationDetailsAggregate';
  aggregate?: Maybe<EventRegistrationDetailsAggregateFields>;
  nodes: Array<EventRegistrationDetails>;
};

/** aggregate fields of "event_registration_details" */
export type EventRegistrationDetailsAggregateFields = {
  __typename?: 'EventRegistrationDetailsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<EventRegistrationDetailsMaxFields>;
  min?: Maybe<EventRegistrationDetailsMinFields>;
};


/** aggregate fields of "event_registration_details" */
export type EventRegistrationDetailsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EventRegistrationDetailsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "event_registration_details". All fields are combined with a logical 'AND'. */
export type EventRegistrationDetailsBoolExp = {
  _and?: InputMaybe<Array<EventRegistrationDetailsBoolExp>>;
  _not?: InputMaybe<EventRegistrationDetailsBoolExp>;
  _or?: InputMaybe<Array<EventRegistrationDetailsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  duprId?: InputMaybe<StringComparisonExp>;
  eventRegistrationId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  referredBy?: InputMaybe<StringComparisonExp>;
  registration?: InputMaybe<EventRegistrationsBoolExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "event_registration_details" */
export enum EventRegistrationDetailsConstraint {
  /** unique or primary key constraint on columns "event_registration_id" */
  EventRegistrationDetailsEventRegistrationIdKey = 'event_registration_details_event_registration_id_key',
  /** unique or primary key constraint on columns "id" */
  EventRegistrationDetailsPkey = 'event_registration_details_pkey'
}

/** input type for inserting data into table "event_registration_details" */
export type EventRegistrationDetailsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  duprId?: InputMaybe<Scalars['String']>;
  eventRegistrationId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  referredBy?: InputMaybe<Scalars['String']>;
  registration?: InputMaybe<EventRegistrationsObjRelInsertInput>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type EventRegistrationDetailsMaxFields = {
  __typename?: 'EventRegistrationDetailsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  duprId?: Maybe<Scalars['String']>;
  eventRegistrationId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  referredBy?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type EventRegistrationDetailsMinFields = {
  __typename?: 'EventRegistrationDetailsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  duprId?: Maybe<Scalars['String']>;
  eventRegistrationId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  referredBy?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "event_registration_details" */
export type EventRegistrationDetailsMutationResponse = {
  __typename?: 'EventRegistrationDetailsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventRegistrationDetails>;
};

/** input type for inserting object relation for remote table "event_registration_details" */
export type EventRegistrationDetailsObjRelInsertInput = {
  data: EventRegistrationDetailsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<EventRegistrationDetailsOnConflict>;
};

/** on_conflict condition type for table "event_registration_details" */
export type EventRegistrationDetailsOnConflict = {
  constraint: EventRegistrationDetailsConstraint;
  updateColumns?: Array<EventRegistrationDetailsUpdateColumn>;
  where?: InputMaybe<EventRegistrationDetailsBoolExp>;
};

/** Ordering options when selecting data from "event_registration_details". */
export type EventRegistrationDetailsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  duprId?: InputMaybe<OrderBy>;
  eventRegistrationId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  referredBy?: InputMaybe<OrderBy>;
  registration?: InputMaybe<EventRegistrationsOrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: event_registration_details */
export type EventRegistrationDetailsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "event_registration_details" */
export enum EventRegistrationDetailsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  DuprId = 'duprId',
  /** column name */
  EventRegistrationId = 'eventRegistrationId',
  /** column name */
  Id = 'id',
  /** column name */
  ReferredBy = 'referredBy',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "event_registration_details" */
export type EventRegistrationDetailsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  duprId?: InputMaybe<Scalars['String']>;
  eventRegistrationId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  referredBy?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "event_registration_details" */
export type EventRegistrationDetailsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventRegistrationDetailsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventRegistrationDetailsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  duprId?: InputMaybe<Scalars['String']>;
  eventRegistrationId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  referredBy?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "event_registration_details" */
export enum EventRegistrationDetailsUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  DuprId = 'duprId',
  /** column name */
  EventRegistrationId = 'eventRegistrationId',
  /** column name */
  Id = 'id',
  /** column name */
  ReferredBy = 'referredBy',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type EventRegistrationDetailsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventRegistrationDetailsSetInput>;
  /** filter the rows which have to be updated */
  where: EventRegistrationDetailsBoolExp;
};

/** columns and relationships of "event_registrations" */
export type EventRegistrations = {
  __typename?: 'EventRegistrations';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  event: Events;
  eventId: Scalars['uuid'];
  id: Scalars['uuid'];
  /** An object relationship */
  registrationDetails?: Maybe<EventRegistrationDetails>;
  /** An array relationship */
  transactionItems: Array<EventTransactionItems>;
  /** An aggregate relationship */
  transactionItemsAggregate: EventTransactionItemsAggregate;
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid'];
  /** An object relationship */
  userProfile?: Maybe<UserProfiles>;
};


/** columns and relationships of "event_registrations" */
export type EventRegistrationsTransactionItemsArgs = {
  distinctOn?: InputMaybe<Array<EventTransactionItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventTransactionItemsOrderBy>>;
  where?: InputMaybe<EventTransactionItemsBoolExp>;
};


/** columns and relationships of "event_registrations" */
export type EventRegistrationsTransactionItemsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventTransactionItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventTransactionItemsOrderBy>>;
  where?: InputMaybe<EventTransactionItemsBoolExp>;
};

/** aggregated selection of "event_registrations" */
export type EventRegistrationsAggregate = {
  __typename?: 'EventRegistrationsAggregate';
  aggregate?: Maybe<EventRegistrationsAggregateFields>;
  nodes: Array<EventRegistrations>;
};

export type EventRegistrationsAggregateBoolExp = {
  count?: InputMaybe<EventRegistrationsAggregateBoolExpCount>;
};

/** aggregate fields of "event_registrations" */
export type EventRegistrationsAggregateFields = {
  __typename?: 'EventRegistrationsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<EventRegistrationsMaxFields>;
  min?: Maybe<EventRegistrationsMinFields>;
};


/** aggregate fields of "event_registrations" */
export type EventRegistrationsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EventRegistrationsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "event_registrations" */
export type EventRegistrationsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EventRegistrationsMaxOrderBy>;
  min?: InputMaybe<EventRegistrationsMinOrderBy>;
};

/** input type for inserting array relation for remote table "event_registrations" */
export type EventRegistrationsArrRelInsertInput = {
  data: Array<EventRegistrationsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<EventRegistrationsOnConflict>;
};

/** Boolean expression to filter rows from the table "event_registrations". All fields are combined with a logical 'AND'. */
export type EventRegistrationsBoolExp = {
  _and?: InputMaybe<Array<EventRegistrationsBoolExp>>;
  _not?: InputMaybe<EventRegistrationsBoolExp>;
  _or?: InputMaybe<Array<EventRegistrationsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  event?: InputMaybe<EventsBoolExp>;
  eventId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  registrationDetails?: InputMaybe<EventRegistrationDetailsBoolExp>;
  transactionItems?: InputMaybe<EventTransactionItemsBoolExp>;
  transactionItemsAggregate?: InputMaybe<EventTransactionItemsAggregateBoolExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
  userProfile?: InputMaybe<UserProfilesBoolExp>;
};

/** unique or primary key constraints on table "event_registrations" */
export enum EventRegistrationsConstraint {
  /** unique or primary key constraint on columns "user_id", "event_id" */
  EventRegistrationsEventIdUserIdKey = 'event_registrations_event_id_user_id_key',
  /** unique or primary key constraint on columns "id" */
  EventRegistrationsPkey = 'event_registrations_pkey'
}

/** input type for inserting data into table "event_registrations" */
export type EventRegistrationsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  event?: InputMaybe<EventsObjRelInsertInput>;
  eventId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  registrationDetails?: InputMaybe<EventRegistrationDetailsObjRelInsertInput>;
  transactionItems?: InputMaybe<EventTransactionItemsArrRelInsertInput>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']>;
  userProfile?: InputMaybe<UserProfilesObjRelInsertInput>;
};

/** aggregate max on columns */
export type EventRegistrationsMaxFields = {
  __typename?: 'EventRegistrationsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  eventId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "event_registrations" */
export type EventRegistrationsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  eventId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type EventRegistrationsMinFields = {
  __typename?: 'EventRegistrationsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  eventId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "event_registrations" */
export type EventRegistrationsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  eventId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "event_registrations" */
export type EventRegistrationsMutationResponse = {
  __typename?: 'EventRegistrationsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventRegistrations>;
};

/** input type for inserting object relation for remote table "event_registrations" */
export type EventRegistrationsObjRelInsertInput = {
  data: EventRegistrationsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<EventRegistrationsOnConflict>;
};

/** on_conflict condition type for table "event_registrations" */
export type EventRegistrationsOnConflict = {
  constraint: EventRegistrationsConstraint;
  updateColumns?: Array<EventRegistrationsUpdateColumn>;
  where?: InputMaybe<EventRegistrationsBoolExp>;
};

/** Ordering options when selecting data from "event_registrations". */
export type EventRegistrationsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  event?: InputMaybe<EventsOrderBy>;
  eventId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  registrationDetails?: InputMaybe<EventRegistrationDetailsOrderBy>;
  transactionItemsAggregate?: InputMaybe<EventTransactionItemsAggregateOrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
  userProfile?: InputMaybe<UserProfilesOrderBy>;
};

/** primary key columns input for table: event_registrations */
export type EventRegistrationsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "event_registrations" */
export enum EventRegistrationsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EventId = 'eventId',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "event_registrations" */
export type EventRegistrationsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  eventId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "event_registrations" */
export type EventRegistrationsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventRegistrationsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventRegistrationsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  eventId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "event_registrations" */
export enum EventRegistrationsUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EventId = 'eventId',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

export type EventRegistrationsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventRegistrationsSetInput>;
  /** filter the rows which have to be updated */
  where: EventRegistrationsBoolExp;
};

/** columns and relationships of "event_sequence_complete_reasons" */
export type EventSequenceCompleteReasons = {
  __typename?: 'EventSequenceCompleteReasons';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "event_sequence_complete_reasons" */
export type EventSequenceCompleteReasonsAggregate = {
  __typename?: 'EventSequenceCompleteReasonsAggregate';
  aggregate?: Maybe<EventSequenceCompleteReasonsAggregateFields>;
  nodes: Array<EventSequenceCompleteReasons>;
};

/** aggregate fields of "event_sequence_complete_reasons" */
export type EventSequenceCompleteReasonsAggregateFields = {
  __typename?: 'EventSequenceCompleteReasonsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<EventSequenceCompleteReasonsMaxFields>;
  min?: Maybe<EventSequenceCompleteReasonsMinFields>;
};


/** aggregate fields of "event_sequence_complete_reasons" */
export type EventSequenceCompleteReasonsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EventSequenceCompleteReasonsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "event_sequence_complete_reasons". All fields are combined with a logical 'AND'. */
export type EventSequenceCompleteReasonsBoolExp = {
  _and?: InputMaybe<Array<EventSequenceCompleteReasonsBoolExp>>;
  _not?: InputMaybe<EventSequenceCompleteReasonsBoolExp>;
  _or?: InputMaybe<Array<EventSequenceCompleteReasonsBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "event_sequence_complete_reasons" */
export enum EventSequenceCompleteReasonsConstraint {
  /** unique or primary key constraint on columns "value" */
  EventSequenceCompleteReasonsPkey = 'event_sequence_complete_reasons_pkey'
}

export enum EventSequenceCompleteReasonsEnum {
  AllScores = 'ALL_SCORES',
  OrganizerSelected = 'ORGANIZER_SELECTED',
  Pending = 'PENDING'
}

/** Boolean expression to compare columns of type "EventSequenceCompleteReasonsEnum". All fields are combined with logical 'AND'. */
export type EventSequenceCompleteReasonsEnumComparisonExp = {
  _eq?: InputMaybe<EventSequenceCompleteReasonsEnum>;
  _in?: InputMaybe<Array<EventSequenceCompleteReasonsEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<EventSequenceCompleteReasonsEnum>;
  _nin?: InputMaybe<Array<EventSequenceCompleteReasonsEnum>>;
};

/** input type for inserting data into table "event_sequence_complete_reasons" */
export type EventSequenceCompleteReasonsInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type EventSequenceCompleteReasonsMaxFields = {
  __typename?: 'EventSequenceCompleteReasonsMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type EventSequenceCompleteReasonsMinFields = {
  __typename?: 'EventSequenceCompleteReasonsMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "event_sequence_complete_reasons" */
export type EventSequenceCompleteReasonsMutationResponse = {
  __typename?: 'EventSequenceCompleteReasonsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventSequenceCompleteReasons>;
};

/** on_conflict condition type for table "event_sequence_complete_reasons" */
export type EventSequenceCompleteReasonsOnConflict = {
  constraint: EventSequenceCompleteReasonsConstraint;
  updateColumns?: Array<EventSequenceCompleteReasonsUpdateColumn>;
  where?: InputMaybe<EventSequenceCompleteReasonsBoolExp>;
};

/** Ordering options when selecting data from "event_sequence_complete_reasons". */
export type EventSequenceCompleteReasonsOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: event_sequence_complete_reasons */
export type EventSequenceCompleteReasonsPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "event_sequence_complete_reasons" */
export enum EventSequenceCompleteReasonsSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "event_sequence_complete_reasons" */
export type EventSequenceCompleteReasonsSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "event_sequence_complete_reasons" */
export type EventSequenceCompleteReasonsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventSequenceCompleteReasonsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventSequenceCompleteReasonsStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "event_sequence_complete_reasons" */
export enum EventSequenceCompleteReasonsUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type EventSequenceCompleteReasonsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventSequenceCompleteReasonsSetInput>;
  /** filter the rows which have to be updated */
  where: EventSequenceCompleteReasonsBoolExp;
};

/** columns and relationships of "event_skill_levels" */
export type EventSkillLevels = {
  __typename?: 'EventSkillLevels';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  event: Events;
  eventId: Scalars['uuid'];
  id: Scalars['uuid'];
  skillLevel: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "event_skill_levels" */
export type EventSkillLevelsAggregate = {
  __typename?: 'EventSkillLevelsAggregate';
  aggregate?: Maybe<EventSkillLevelsAggregateFields>;
  nodes: Array<EventSkillLevels>;
};

export type EventSkillLevelsAggregateBoolExp = {
  count?: InputMaybe<EventSkillLevelsAggregateBoolExpCount>;
};

/** aggregate fields of "event_skill_levels" */
export type EventSkillLevelsAggregateFields = {
  __typename?: 'EventSkillLevelsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<EventSkillLevelsMaxFields>;
  min?: Maybe<EventSkillLevelsMinFields>;
};


/** aggregate fields of "event_skill_levels" */
export type EventSkillLevelsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EventSkillLevelsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "event_skill_levels" */
export type EventSkillLevelsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EventSkillLevelsMaxOrderBy>;
  min?: InputMaybe<EventSkillLevelsMinOrderBy>;
};

/** input type for inserting array relation for remote table "event_skill_levels" */
export type EventSkillLevelsArrRelInsertInput = {
  data: Array<EventSkillLevelsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<EventSkillLevelsOnConflict>;
};

/** Boolean expression to filter rows from the table "event_skill_levels". All fields are combined with a logical 'AND'. */
export type EventSkillLevelsBoolExp = {
  _and?: InputMaybe<Array<EventSkillLevelsBoolExp>>;
  _not?: InputMaybe<EventSkillLevelsBoolExp>;
  _or?: InputMaybe<Array<EventSkillLevelsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  event?: InputMaybe<EventsBoolExp>;
  eventId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  skillLevel?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "event_skill_levels" */
export enum EventSkillLevelsConstraint {
  /** unique or primary key constraint on columns "skill_level", "event_id" */
  EventSkillLevelsEventIdSkillLevelKey = 'event_skill_levels_event_id_skill_level_key',
  /** unique or primary key constraint on columns "id" */
  EventSkillLevelsPkey = 'event_skill_levels_pkey'
}

/** input type for inserting data into table "event_skill_levels" */
export type EventSkillLevelsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  event?: InputMaybe<EventsObjRelInsertInput>;
  eventId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  skillLevel?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type EventSkillLevelsMaxFields = {
  __typename?: 'EventSkillLevelsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  eventId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  skillLevel?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "event_skill_levels" */
export type EventSkillLevelsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  eventId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  skillLevel?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type EventSkillLevelsMinFields = {
  __typename?: 'EventSkillLevelsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  eventId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  skillLevel?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "event_skill_levels" */
export type EventSkillLevelsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  eventId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  skillLevel?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "event_skill_levels" */
export type EventSkillLevelsMutationResponse = {
  __typename?: 'EventSkillLevelsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventSkillLevels>;
};

/** on_conflict condition type for table "event_skill_levels" */
export type EventSkillLevelsOnConflict = {
  constraint: EventSkillLevelsConstraint;
  updateColumns?: Array<EventSkillLevelsUpdateColumn>;
  where?: InputMaybe<EventSkillLevelsBoolExp>;
};

/** Ordering options when selecting data from "event_skill_levels". */
export type EventSkillLevelsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  event?: InputMaybe<EventsOrderBy>;
  eventId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  skillLevel?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: event_skill_levels */
export type EventSkillLevelsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "event_skill_levels" */
export enum EventSkillLevelsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EventId = 'eventId',
  /** column name */
  Id = 'id',
  /** column name */
  SkillLevel = 'skillLevel',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "event_skill_levels" */
export type EventSkillLevelsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  eventId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  skillLevel?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "event_skill_levels" */
export type EventSkillLevelsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventSkillLevelsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventSkillLevelsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  eventId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  skillLevel?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "event_skill_levels" */
export enum EventSkillLevelsUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EventId = 'eventId',
  /** column name */
  Id = 'id',
  /** column name */
  SkillLevel = 'skillLevel',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type EventSkillLevelsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventSkillLevelsSetInput>;
  /** filter the rows which have to be updated */
  where: EventSkillLevelsBoolExp;
};

/** columns and relationships of "event_sponsors" */
export type EventSponsors = {
  __typename?: 'EventSponsors';
  categoryName: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  event: Events;
  eventId: Scalars['uuid'];
  id: Scalars['uuid'];
  imageFileName: Scalars['String'];
  imageFileType: Scalars['String'];
  imageHost: Scalars['String'];
  imageOriginalFileName?: Maybe<Scalars['String']>;
  imagePath: Scalars['String'];
  imageProvider: Scalars['String'];
  imageProviderUrl: Scalars['String'];
  imageUrl: Scalars['String'];
  isTitleSponsor: Scalars['Boolean'];
  name: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "event_sponsors" */
export type EventSponsorsAggregate = {
  __typename?: 'EventSponsorsAggregate';
  aggregate?: Maybe<EventSponsorsAggregateFields>;
  nodes: Array<EventSponsors>;
};

export type EventSponsorsAggregateBoolExp = {
  bool_and?: InputMaybe<EventSponsorsAggregateBoolExpBool_And>;
  bool_or?: InputMaybe<EventSponsorsAggregateBoolExpBool_Or>;
  count?: InputMaybe<EventSponsorsAggregateBoolExpCount>;
};

/** aggregate fields of "event_sponsors" */
export type EventSponsorsAggregateFields = {
  __typename?: 'EventSponsorsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<EventSponsorsMaxFields>;
  min?: Maybe<EventSponsorsMinFields>;
};


/** aggregate fields of "event_sponsors" */
export type EventSponsorsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EventSponsorsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "event_sponsors" */
export type EventSponsorsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EventSponsorsMaxOrderBy>;
  min?: InputMaybe<EventSponsorsMinOrderBy>;
};

/** input type for inserting array relation for remote table "event_sponsors" */
export type EventSponsorsArrRelInsertInput = {
  data: Array<EventSponsorsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<EventSponsorsOnConflict>;
};

/** Boolean expression to filter rows from the table "event_sponsors". All fields are combined with a logical 'AND'. */
export type EventSponsorsBoolExp = {
  _and?: InputMaybe<Array<EventSponsorsBoolExp>>;
  _not?: InputMaybe<EventSponsorsBoolExp>;
  _or?: InputMaybe<Array<EventSponsorsBoolExp>>;
  categoryName?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  event?: InputMaybe<EventsBoolExp>;
  eventId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  imageFileName?: InputMaybe<StringComparisonExp>;
  imageFileType?: InputMaybe<StringComparisonExp>;
  imageHost?: InputMaybe<StringComparisonExp>;
  imageOriginalFileName?: InputMaybe<StringComparisonExp>;
  imagePath?: InputMaybe<StringComparisonExp>;
  imageProvider?: InputMaybe<StringComparisonExp>;
  imageProviderUrl?: InputMaybe<StringComparisonExp>;
  imageUrl?: InputMaybe<StringComparisonExp>;
  isTitleSponsor?: InputMaybe<BooleanComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "event_sponsors" */
export enum EventSponsorsConstraint {
  /** unique or primary key constraint on columns "id" */
  EventSponsorsPkey = 'event_sponsors_pkey'
}

/** input type for inserting data into table "event_sponsors" */
export type EventSponsorsInsertInput = {
  categoryName?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  event?: InputMaybe<EventsObjRelInsertInput>;
  eventId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  imageFileName?: InputMaybe<Scalars['String']>;
  imageFileType?: InputMaybe<Scalars['String']>;
  imageHost?: InputMaybe<Scalars['String']>;
  imageOriginalFileName?: InputMaybe<Scalars['String']>;
  imagePath?: InputMaybe<Scalars['String']>;
  imageProvider?: InputMaybe<Scalars['String']>;
  imageProviderUrl?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  isTitleSponsor?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type EventSponsorsMaxFields = {
  __typename?: 'EventSponsorsMaxFields';
  categoryName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  eventId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  imageFileName?: Maybe<Scalars['String']>;
  imageFileType?: Maybe<Scalars['String']>;
  imageHost?: Maybe<Scalars['String']>;
  imageOriginalFileName?: Maybe<Scalars['String']>;
  imagePath?: Maybe<Scalars['String']>;
  imageProvider?: Maybe<Scalars['String']>;
  imageProviderUrl?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "event_sponsors" */
export type EventSponsorsMaxOrderBy = {
  categoryName?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  eventId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  imageFileName?: InputMaybe<OrderBy>;
  imageFileType?: InputMaybe<OrderBy>;
  imageHost?: InputMaybe<OrderBy>;
  imageOriginalFileName?: InputMaybe<OrderBy>;
  imagePath?: InputMaybe<OrderBy>;
  imageProvider?: InputMaybe<OrderBy>;
  imageProviderUrl?: InputMaybe<OrderBy>;
  imageUrl?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type EventSponsorsMinFields = {
  __typename?: 'EventSponsorsMinFields';
  categoryName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  eventId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  imageFileName?: Maybe<Scalars['String']>;
  imageFileType?: Maybe<Scalars['String']>;
  imageHost?: Maybe<Scalars['String']>;
  imageOriginalFileName?: Maybe<Scalars['String']>;
  imagePath?: Maybe<Scalars['String']>;
  imageProvider?: Maybe<Scalars['String']>;
  imageProviderUrl?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "event_sponsors" */
export type EventSponsorsMinOrderBy = {
  categoryName?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  eventId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  imageFileName?: InputMaybe<OrderBy>;
  imageFileType?: InputMaybe<OrderBy>;
  imageHost?: InputMaybe<OrderBy>;
  imageOriginalFileName?: InputMaybe<OrderBy>;
  imagePath?: InputMaybe<OrderBy>;
  imageProvider?: InputMaybe<OrderBy>;
  imageProviderUrl?: InputMaybe<OrderBy>;
  imageUrl?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "event_sponsors" */
export type EventSponsorsMutationResponse = {
  __typename?: 'EventSponsorsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventSponsors>;
};

/** on_conflict condition type for table "event_sponsors" */
export type EventSponsorsOnConflict = {
  constraint: EventSponsorsConstraint;
  updateColumns?: Array<EventSponsorsUpdateColumn>;
  where?: InputMaybe<EventSponsorsBoolExp>;
};

/** Ordering options when selecting data from "event_sponsors". */
export type EventSponsorsOrderBy = {
  categoryName?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  event?: InputMaybe<EventsOrderBy>;
  eventId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  imageFileName?: InputMaybe<OrderBy>;
  imageFileType?: InputMaybe<OrderBy>;
  imageHost?: InputMaybe<OrderBy>;
  imageOriginalFileName?: InputMaybe<OrderBy>;
  imagePath?: InputMaybe<OrderBy>;
  imageProvider?: InputMaybe<OrderBy>;
  imageProviderUrl?: InputMaybe<OrderBy>;
  imageUrl?: InputMaybe<OrderBy>;
  isTitleSponsor?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: event_sponsors */
export type EventSponsorsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "event_sponsors" */
export enum EventSponsorsSelectColumn {
  /** column name */
  CategoryName = 'categoryName',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EventId = 'eventId',
  /** column name */
  Id = 'id',
  /** column name */
  ImageFileName = 'imageFileName',
  /** column name */
  ImageFileType = 'imageFileType',
  /** column name */
  ImageHost = 'imageHost',
  /** column name */
  ImageOriginalFileName = 'imageOriginalFileName',
  /** column name */
  ImagePath = 'imagePath',
  /** column name */
  ImageProvider = 'imageProvider',
  /** column name */
  ImageProviderUrl = 'imageProviderUrl',
  /** column name */
  ImageUrl = 'imageUrl',
  /** column name */
  IsTitleSponsor = 'isTitleSponsor',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** select "eventSponsorsAggregateBoolExpBool_andArgumentsColumns" columns of table "event_sponsors" */
export enum EventSponsorsSelectColumnEventSponsorsAggregateBoolExpBool_AndArgumentsColumns {
  /** column name */
  IsTitleSponsor = 'isTitleSponsor'
}

/** select "eventSponsorsAggregateBoolExpBool_orArgumentsColumns" columns of table "event_sponsors" */
export enum EventSponsorsSelectColumnEventSponsorsAggregateBoolExpBool_OrArgumentsColumns {
  /** column name */
  IsTitleSponsor = 'isTitleSponsor'
}

/** input type for updating data in table "event_sponsors" */
export type EventSponsorsSetInput = {
  categoryName?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  eventId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  imageFileName?: InputMaybe<Scalars['String']>;
  imageFileType?: InputMaybe<Scalars['String']>;
  imageHost?: InputMaybe<Scalars['String']>;
  imageOriginalFileName?: InputMaybe<Scalars['String']>;
  imagePath?: InputMaybe<Scalars['String']>;
  imageProvider?: InputMaybe<Scalars['String']>;
  imageProviderUrl?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  isTitleSponsor?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "event_sponsors" */
export type EventSponsorsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventSponsorsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventSponsorsStreamCursorValueInput = {
  categoryName?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  eventId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  imageFileName?: InputMaybe<Scalars['String']>;
  imageFileType?: InputMaybe<Scalars['String']>;
  imageHost?: InputMaybe<Scalars['String']>;
  imageOriginalFileName?: InputMaybe<Scalars['String']>;
  imagePath?: InputMaybe<Scalars['String']>;
  imageProvider?: InputMaybe<Scalars['String']>;
  imageProviderUrl?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  isTitleSponsor?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "event_sponsors" */
export enum EventSponsorsUpdateColumn {
  /** column name */
  CategoryName = 'categoryName',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EventId = 'eventId',
  /** column name */
  Id = 'id',
  /** column name */
  ImageFileName = 'imageFileName',
  /** column name */
  ImageFileType = 'imageFileType',
  /** column name */
  ImageHost = 'imageHost',
  /** column name */
  ImageOriginalFileName = 'imageOriginalFileName',
  /** column name */
  ImagePath = 'imagePath',
  /** column name */
  ImageProvider = 'imageProvider',
  /** column name */
  ImageProviderUrl = 'imageProviderUrl',
  /** column name */
  ImageUrl = 'imageUrl',
  /** column name */
  IsTitleSponsor = 'isTitleSponsor',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type EventSponsorsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventSponsorsSetInput>;
  /** filter the rows which have to be updated */
  where: EventSponsorsBoolExp;
};

/** columns and relationships of "event_statuses" */
export type EventStatuses = {
  __typename?: 'EventStatuses';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "event_statuses" */
export type EventStatusesAggregate = {
  __typename?: 'EventStatusesAggregate';
  aggregate?: Maybe<EventStatusesAggregateFields>;
  nodes: Array<EventStatuses>;
};

/** aggregate fields of "event_statuses" */
export type EventStatusesAggregateFields = {
  __typename?: 'EventStatusesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<EventStatusesMaxFields>;
  min?: Maybe<EventStatusesMinFields>;
};


/** aggregate fields of "event_statuses" */
export type EventStatusesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EventStatusesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "event_statuses". All fields are combined with a logical 'AND'. */
export type EventStatusesBoolExp = {
  _and?: InputMaybe<Array<EventStatusesBoolExp>>;
  _not?: InputMaybe<EventStatusesBoolExp>;
  _or?: InputMaybe<Array<EventStatusesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "event_statuses" */
export enum EventStatusesConstraint {
  /** unique or primary key constraint on columns "value" */
  EventStatusesPkey = 'event_statuses_pkey'
}

export enum EventStatusesEnum {
  Canceled = 'CANCELED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

/** Boolean expression to compare columns of type "EventStatusesEnum". All fields are combined with logical 'AND'. */
export type EventStatusesEnumComparisonExp = {
  _eq?: InputMaybe<EventStatusesEnum>;
  _in?: InputMaybe<Array<EventStatusesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<EventStatusesEnum>;
  _nin?: InputMaybe<Array<EventStatusesEnum>>;
};

/** input type for inserting data into table "event_statuses" */
export type EventStatusesInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type EventStatusesMaxFields = {
  __typename?: 'EventStatusesMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type EventStatusesMinFields = {
  __typename?: 'EventStatusesMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "event_statuses" */
export type EventStatusesMutationResponse = {
  __typename?: 'EventStatusesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventStatuses>;
};

/** on_conflict condition type for table "event_statuses" */
export type EventStatusesOnConflict = {
  constraint: EventStatusesConstraint;
  updateColumns?: Array<EventStatusesUpdateColumn>;
  where?: InputMaybe<EventStatusesBoolExp>;
};

/** Ordering options when selecting data from "event_statuses". */
export type EventStatusesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: event_statuses */
export type EventStatusesPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "event_statuses" */
export enum EventStatusesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "event_statuses" */
export type EventStatusesSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "event_statuses" */
export type EventStatusesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventStatusesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventStatusesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "event_statuses" */
export enum EventStatusesUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type EventStatusesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventStatusesSetInput>;
  /** filter the rows which have to be updated */
  where: EventStatusesBoolExp;
};

/** columns and relationships of "event_team_member_statuses" */
export type EventTeamMemberStatuses = {
  __typename?: 'EventTeamMemberStatuses';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "event_team_member_statuses" */
export type EventTeamMemberStatusesAggregate = {
  __typename?: 'EventTeamMemberStatusesAggregate';
  aggregate?: Maybe<EventTeamMemberStatusesAggregateFields>;
  nodes: Array<EventTeamMemberStatuses>;
};

/** aggregate fields of "event_team_member_statuses" */
export type EventTeamMemberStatusesAggregateFields = {
  __typename?: 'EventTeamMemberStatusesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<EventTeamMemberStatusesMaxFields>;
  min?: Maybe<EventTeamMemberStatusesMinFields>;
};


/** aggregate fields of "event_team_member_statuses" */
export type EventTeamMemberStatusesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EventTeamMemberStatusesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "event_team_member_statuses". All fields are combined with a logical 'AND'. */
export type EventTeamMemberStatusesBoolExp = {
  _and?: InputMaybe<Array<EventTeamMemberStatusesBoolExp>>;
  _not?: InputMaybe<EventTeamMemberStatusesBoolExp>;
  _or?: InputMaybe<Array<EventTeamMemberStatusesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "event_team_member_statuses" */
export enum EventTeamMemberStatusesConstraint {
  /** unique or primary key constraint on columns "value" */
  EventTeamMemberStatusesPkey = 'event_team_member_statuses_pkey'
}

export enum EventTeamMemberStatusesEnum {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Pending = 'PENDING'
}

/** Boolean expression to compare columns of type "EventTeamMemberStatusesEnum". All fields are combined with logical 'AND'. */
export type EventTeamMemberStatusesEnumComparisonExp = {
  _eq?: InputMaybe<EventTeamMemberStatusesEnum>;
  _in?: InputMaybe<Array<EventTeamMemberStatusesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<EventTeamMemberStatusesEnum>;
  _nin?: InputMaybe<Array<EventTeamMemberStatusesEnum>>;
};

/** input type for inserting data into table "event_team_member_statuses" */
export type EventTeamMemberStatusesInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type EventTeamMemberStatusesMaxFields = {
  __typename?: 'EventTeamMemberStatusesMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type EventTeamMemberStatusesMinFields = {
  __typename?: 'EventTeamMemberStatusesMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "event_team_member_statuses" */
export type EventTeamMemberStatusesMutationResponse = {
  __typename?: 'EventTeamMemberStatusesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventTeamMemberStatuses>;
};

/** on_conflict condition type for table "event_team_member_statuses" */
export type EventTeamMemberStatusesOnConflict = {
  constraint: EventTeamMemberStatusesConstraint;
  updateColumns?: Array<EventTeamMemberStatusesUpdateColumn>;
  where?: InputMaybe<EventTeamMemberStatusesBoolExp>;
};

/** Ordering options when selecting data from "event_team_member_statuses". */
export type EventTeamMemberStatusesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: event_team_member_statuses */
export type EventTeamMemberStatusesPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "event_team_member_statuses" */
export enum EventTeamMemberStatusesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "event_team_member_statuses" */
export type EventTeamMemberStatusesSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "event_team_member_statuses" */
export type EventTeamMemberStatusesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventTeamMemberStatusesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventTeamMemberStatusesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "event_team_member_statuses" */
export enum EventTeamMemberStatusesUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type EventTeamMemberStatusesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventTeamMemberStatusesSetInput>;
  /** filter the rows which have to be updated */
  where: EventTeamMemberStatusesBoolExp;
};

/** columns and relationships of "event_team_members" */
export type EventTeamMembers = {
  __typename?: 'EventTeamMembers';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  status: EventTeamMemberStatusesEnum;
  /** An object relationship */
  team: EventTeams;
  teamId: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid'];
  /** An object relationship */
  userProfile?: Maybe<UserProfiles>;
};

/** aggregated selection of "event_team_members" */
export type EventTeamMembersAggregate = {
  __typename?: 'EventTeamMembersAggregate';
  aggregate?: Maybe<EventTeamMembersAggregateFields>;
  nodes: Array<EventTeamMembers>;
};

export type EventTeamMembersAggregateBoolExp = {
  count?: InputMaybe<EventTeamMembersAggregateBoolExpCount>;
};

/** aggregate fields of "event_team_members" */
export type EventTeamMembersAggregateFields = {
  __typename?: 'EventTeamMembersAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<EventTeamMembersMaxFields>;
  min?: Maybe<EventTeamMembersMinFields>;
};


/** aggregate fields of "event_team_members" */
export type EventTeamMembersAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EventTeamMembersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "event_team_members" */
export type EventTeamMembersAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EventTeamMembersMaxOrderBy>;
  min?: InputMaybe<EventTeamMembersMinOrderBy>;
};

/** input type for inserting array relation for remote table "event_team_members" */
export type EventTeamMembersArrRelInsertInput = {
  data: Array<EventTeamMembersInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<EventTeamMembersOnConflict>;
};

/** Boolean expression to filter rows from the table "event_team_members". All fields are combined with a logical 'AND'. */
export type EventTeamMembersBoolExp = {
  _and?: InputMaybe<Array<EventTeamMembersBoolExp>>;
  _not?: InputMaybe<EventTeamMembersBoolExp>;
  _or?: InputMaybe<Array<EventTeamMembersBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  status?: InputMaybe<EventTeamMemberStatusesEnumComparisonExp>;
  team?: InputMaybe<EventTeamsBoolExp>;
  teamId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
  userProfile?: InputMaybe<UserProfilesBoolExp>;
};

/** unique or primary key constraints on table "event_team_members" */
export enum EventTeamMembersConstraint {
  /** unique or primary key constraint on columns "id" */
  EventTeamMembersPkey = 'event_team_members_pkey',
  /** unique or primary key constraint on columns "user_id", "team_id" */
  EventTeamMembersTeamIdUserIdKey = 'event_team_members_team_id_user_id_key'
}

/** input type for inserting data into table "event_team_members" */
export type EventTeamMembersInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<EventTeamMemberStatusesEnum>;
  team?: InputMaybe<EventTeamsObjRelInsertInput>;
  teamId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']>;
  userProfile?: InputMaybe<UserProfilesObjRelInsertInput>;
};

/** aggregate max on columns */
export type EventTeamMembersMaxFields = {
  __typename?: 'EventTeamMembersMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  teamId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "event_team_members" */
export type EventTeamMembersMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  teamId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type EventTeamMembersMinFields = {
  __typename?: 'EventTeamMembersMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  teamId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "event_team_members" */
export type EventTeamMembersMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  teamId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "event_team_members" */
export type EventTeamMembersMutationResponse = {
  __typename?: 'EventTeamMembersMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventTeamMembers>;
};

/** on_conflict condition type for table "event_team_members" */
export type EventTeamMembersOnConflict = {
  constraint: EventTeamMembersConstraint;
  updateColumns?: Array<EventTeamMembersUpdateColumn>;
  where?: InputMaybe<EventTeamMembersBoolExp>;
};

/** Ordering options when selecting data from "event_team_members". */
export type EventTeamMembersOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  team?: InputMaybe<EventTeamsOrderBy>;
  teamId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
  userProfile?: InputMaybe<UserProfilesOrderBy>;
};

/** primary key columns input for table: event_team_members */
export type EventTeamMembersPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "event_team_members" */
export enum EventTeamMembersSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  Status = 'status',
  /** column name */
  TeamId = 'teamId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "event_team_members" */
export type EventTeamMembersSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<EventTeamMemberStatusesEnum>;
  teamId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "event_team_members" */
export type EventTeamMembersStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventTeamMembersStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventTeamMembersStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<EventTeamMemberStatusesEnum>;
  teamId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "event_team_members" */
export enum EventTeamMembersUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  Status = 'status',
  /** column name */
  TeamId = 'teamId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

export type EventTeamMembersUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventTeamMembersSetInput>;
  /** filter the rows which have to be updated */
  where: EventTeamMembersBoolExp;
};

/** columns and relationships of "event_team_statuses" */
export type EventTeamStatuses = {
  __typename?: 'EventTeamStatuses';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "event_team_statuses" */
export type EventTeamStatusesAggregate = {
  __typename?: 'EventTeamStatusesAggregate';
  aggregate?: Maybe<EventTeamStatusesAggregateFields>;
  nodes: Array<EventTeamStatuses>;
};

/** aggregate fields of "event_team_statuses" */
export type EventTeamStatusesAggregateFields = {
  __typename?: 'EventTeamStatusesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<EventTeamStatusesMaxFields>;
  min?: Maybe<EventTeamStatusesMinFields>;
};


/** aggregate fields of "event_team_statuses" */
export type EventTeamStatusesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EventTeamStatusesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "event_team_statuses". All fields are combined with a logical 'AND'. */
export type EventTeamStatusesBoolExp = {
  _and?: InputMaybe<Array<EventTeamStatusesBoolExp>>;
  _not?: InputMaybe<EventTeamStatusesBoolExp>;
  _or?: InputMaybe<Array<EventTeamStatusesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "event_team_statuses" */
export enum EventTeamStatusesConstraint {
  /** unique or primary key constraint on columns "value" */
  EventTeamStatusesPkey = 'event_team_statuses_pkey'
}

export enum EventTeamStatusesEnum {
  Active = 'ACTIVE',
  Forfeited = 'FORFEITED',
  Retired = 'RETIRED'
}

/** Boolean expression to compare columns of type "EventTeamStatusesEnum". All fields are combined with logical 'AND'. */
export type EventTeamStatusesEnumComparisonExp = {
  _eq?: InputMaybe<EventTeamStatusesEnum>;
  _in?: InputMaybe<Array<EventTeamStatusesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<EventTeamStatusesEnum>;
  _nin?: InputMaybe<Array<EventTeamStatusesEnum>>;
};

/** input type for inserting data into table "event_team_statuses" */
export type EventTeamStatusesInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type EventTeamStatusesMaxFields = {
  __typename?: 'EventTeamStatusesMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type EventTeamStatusesMinFields = {
  __typename?: 'EventTeamStatusesMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "event_team_statuses" */
export type EventTeamStatusesMutationResponse = {
  __typename?: 'EventTeamStatusesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventTeamStatuses>;
};

/** input type for inserting object relation for remote table "event_team_statuses" */
export type EventTeamStatusesObjRelInsertInput = {
  data: EventTeamStatusesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<EventTeamStatusesOnConflict>;
};

/** on_conflict condition type for table "event_team_statuses" */
export type EventTeamStatusesOnConflict = {
  constraint: EventTeamStatusesConstraint;
  updateColumns?: Array<EventTeamStatusesUpdateColumn>;
  where?: InputMaybe<EventTeamStatusesBoolExp>;
};

/** Ordering options when selecting data from "event_team_statuses". */
export type EventTeamStatusesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: event_team_statuses */
export type EventTeamStatusesPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "event_team_statuses" */
export enum EventTeamStatusesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "event_team_statuses" */
export type EventTeamStatusesSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "event_team_statuses" */
export type EventTeamStatusesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventTeamStatusesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventTeamStatusesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "event_team_statuses" */
export enum EventTeamStatusesUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type EventTeamStatusesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventTeamStatusesSetInput>;
  /** filter the rows which have to be updated */
  where: EventTeamStatusesBoolExp;
};

/** columns and relationships of "event_teams" */
export type EventTeams = {
  __typename?: 'EventTeams';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  gamesWon: Array<EventMatchGames>;
  /** An aggregate relationship */
  gamesWonAggregate: EventMatchGamesAggregate;
  /** An object relationship */
  group: EventGroups;
  groupId: Scalars['uuid'];
  /** An array relationship */
  groupRegistrations: Array<EventGroupRegistrations>;
  /** An aggregate relationship */
  groupRegistrationsAggregate: EventGroupRegistrationsAggregate;
  id: Scalars['uuid'];
  /** An array relationship */
  matches: Array<EventMatchesTeams>;
  /** An aggregate relationship */
  matchesAggregate: EventMatchesTeamsAggregate;
  /** An array relationship */
  matchesLost: Array<EventMatches>;
  /** An aggregate relationship */
  matchesLostAggregate: EventMatchesAggregate;
  /** An array relationship */
  matchesWon: Array<EventMatches>;
  /** An aggregate relationship */
  matchesWonAggregate: EventMatchesAggregate;
  /** An array relationship */
  members: Array<EventTeamMembers>;
  /** An aggregate relationship */
  membersAggregate: EventTeamMembersAggregate;
  /** An array relationship */
  pools: Array<EventPoolsTeams>;
  /** An aggregate relationship */
  poolsAggregate: EventPoolsTeamsAggregate;
  status: EventTeamStatusesEnum;
  teamName?: Maybe<Scalars['String']>;
  /** An object relationship */
  teamStatus: EventTeamStatuses;
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "event_teams" */
export type EventTeamsGamesWonArgs = {
  distinctOn?: InputMaybe<Array<EventMatchGamesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventMatchGamesOrderBy>>;
  where?: InputMaybe<EventMatchGamesBoolExp>;
};


/** columns and relationships of "event_teams" */
export type EventTeamsGamesWonAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventMatchGamesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventMatchGamesOrderBy>>;
  where?: InputMaybe<EventMatchGamesBoolExp>;
};


/** columns and relationships of "event_teams" */
export type EventTeamsGroupRegistrationsArgs = {
  distinctOn?: InputMaybe<Array<EventGroupRegistrationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGroupRegistrationsOrderBy>>;
  where?: InputMaybe<EventGroupRegistrationsBoolExp>;
};


/** columns and relationships of "event_teams" */
export type EventTeamsGroupRegistrationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventGroupRegistrationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGroupRegistrationsOrderBy>>;
  where?: InputMaybe<EventGroupRegistrationsBoolExp>;
};


/** columns and relationships of "event_teams" */
export type EventTeamsMatchesArgs = {
  distinctOn?: InputMaybe<Array<EventMatchesTeamsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventMatchesTeamsOrderBy>>;
  where?: InputMaybe<EventMatchesTeamsBoolExp>;
};


/** columns and relationships of "event_teams" */
export type EventTeamsMatchesAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventMatchesTeamsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventMatchesTeamsOrderBy>>;
  where?: InputMaybe<EventMatchesTeamsBoolExp>;
};


/** columns and relationships of "event_teams" */
export type EventTeamsMatchesLostArgs = {
  distinctOn?: InputMaybe<Array<EventMatchesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventMatchesOrderBy>>;
  where?: InputMaybe<EventMatchesBoolExp>;
};


/** columns and relationships of "event_teams" */
export type EventTeamsMatchesLostAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventMatchesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventMatchesOrderBy>>;
  where?: InputMaybe<EventMatchesBoolExp>;
};


/** columns and relationships of "event_teams" */
export type EventTeamsMatchesWonArgs = {
  distinctOn?: InputMaybe<Array<EventMatchesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventMatchesOrderBy>>;
  where?: InputMaybe<EventMatchesBoolExp>;
};


/** columns and relationships of "event_teams" */
export type EventTeamsMatchesWonAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventMatchesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventMatchesOrderBy>>;
  where?: InputMaybe<EventMatchesBoolExp>;
};


/** columns and relationships of "event_teams" */
export type EventTeamsMembersArgs = {
  distinctOn?: InputMaybe<Array<EventTeamMembersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventTeamMembersOrderBy>>;
  where?: InputMaybe<EventTeamMembersBoolExp>;
};


/** columns and relationships of "event_teams" */
export type EventTeamsMembersAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventTeamMembersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventTeamMembersOrderBy>>;
  where?: InputMaybe<EventTeamMembersBoolExp>;
};


/** columns and relationships of "event_teams" */
export type EventTeamsPoolsArgs = {
  distinctOn?: InputMaybe<Array<EventPoolsTeamsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventPoolsTeamsOrderBy>>;
  where?: InputMaybe<EventPoolsTeamsBoolExp>;
};


/** columns and relationships of "event_teams" */
export type EventTeamsPoolsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventPoolsTeamsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventPoolsTeamsOrderBy>>;
  where?: InputMaybe<EventPoolsTeamsBoolExp>;
};

/** aggregated selection of "event_teams" */
export type EventTeamsAggregate = {
  __typename?: 'EventTeamsAggregate';
  aggregate?: Maybe<EventTeamsAggregateFields>;
  nodes: Array<EventTeams>;
};

export type EventTeamsAggregateBoolExp = {
  count?: InputMaybe<EventTeamsAggregateBoolExpCount>;
};

/** aggregate fields of "event_teams" */
export type EventTeamsAggregateFields = {
  __typename?: 'EventTeamsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<EventTeamsMaxFields>;
  min?: Maybe<EventTeamsMinFields>;
};


/** aggregate fields of "event_teams" */
export type EventTeamsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EventTeamsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "event_teams" */
export type EventTeamsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EventTeamsMaxOrderBy>;
  min?: InputMaybe<EventTeamsMinOrderBy>;
};

/** input type for inserting array relation for remote table "event_teams" */
export type EventTeamsArrRelInsertInput = {
  data: Array<EventTeamsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<EventTeamsOnConflict>;
};

/** Boolean expression to filter rows from the table "event_teams". All fields are combined with a logical 'AND'. */
export type EventTeamsBoolExp = {
  _and?: InputMaybe<Array<EventTeamsBoolExp>>;
  _not?: InputMaybe<EventTeamsBoolExp>;
  _or?: InputMaybe<Array<EventTeamsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  gamesWon?: InputMaybe<EventMatchGamesBoolExp>;
  gamesWonAggregate?: InputMaybe<EventMatchGamesAggregateBoolExp>;
  group?: InputMaybe<EventGroupsBoolExp>;
  groupId?: InputMaybe<UuidComparisonExp>;
  groupRegistrations?: InputMaybe<EventGroupRegistrationsBoolExp>;
  groupRegistrationsAggregate?: InputMaybe<EventGroupRegistrationsAggregateBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  matches?: InputMaybe<EventMatchesTeamsBoolExp>;
  matchesAggregate?: InputMaybe<EventMatchesTeamsAggregateBoolExp>;
  matchesLost?: InputMaybe<EventMatchesBoolExp>;
  matchesLostAggregate?: InputMaybe<EventMatchesAggregateBoolExp>;
  matchesWon?: InputMaybe<EventMatchesBoolExp>;
  matchesWonAggregate?: InputMaybe<EventMatchesAggregateBoolExp>;
  members?: InputMaybe<EventTeamMembersBoolExp>;
  membersAggregate?: InputMaybe<EventTeamMembersAggregateBoolExp>;
  pools?: InputMaybe<EventPoolsTeamsBoolExp>;
  poolsAggregate?: InputMaybe<EventPoolsTeamsAggregateBoolExp>;
  status?: InputMaybe<EventTeamStatusesEnumComparisonExp>;
  teamName?: InputMaybe<StringComparisonExp>;
  teamStatus?: InputMaybe<EventTeamStatusesBoolExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "event_teams" */
export enum EventTeamsConstraint {
  /** unique or primary key constraint on columns "id" */
  EventTeamsPkey = 'event_teams_pkey'
}

/** input type for inserting data into table "event_teams" */
export type EventTeamsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  gamesWon?: InputMaybe<EventMatchGamesArrRelInsertInput>;
  group?: InputMaybe<EventGroupsObjRelInsertInput>;
  groupId?: InputMaybe<Scalars['uuid']>;
  groupRegistrations?: InputMaybe<EventGroupRegistrationsArrRelInsertInput>;
  id?: InputMaybe<Scalars['uuid']>;
  matches?: InputMaybe<EventMatchesTeamsArrRelInsertInput>;
  matchesLost?: InputMaybe<EventMatchesArrRelInsertInput>;
  matchesWon?: InputMaybe<EventMatchesArrRelInsertInput>;
  members?: InputMaybe<EventTeamMembersArrRelInsertInput>;
  pools?: InputMaybe<EventPoolsTeamsArrRelInsertInput>;
  status?: InputMaybe<EventTeamStatusesEnum>;
  teamName?: InputMaybe<Scalars['String']>;
  teamStatus?: InputMaybe<EventTeamStatusesObjRelInsertInput>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type EventTeamsMaxFields = {
  __typename?: 'EventTeamsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  groupId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  teamName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "event_teams" */
export type EventTeamsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  teamName?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type EventTeamsMinFields = {
  __typename?: 'EventTeamsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  groupId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  teamName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "event_teams" */
export type EventTeamsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  teamName?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "event_teams" */
export type EventTeamsMutationResponse = {
  __typename?: 'EventTeamsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventTeams>;
};

/** input type for inserting object relation for remote table "event_teams" */
export type EventTeamsObjRelInsertInput = {
  data: EventTeamsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<EventTeamsOnConflict>;
};

/** on_conflict condition type for table "event_teams" */
export type EventTeamsOnConflict = {
  constraint: EventTeamsConstraint;
  updateColumns?: Array<EventTeamsUpdateColumn>;
  where?: InputMaybe<EventTeamsBoolExp>;
};

/** Ordering options when selecting data from "event_teams". */
export type EventTeamsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  gamesWonAggregate?: InputMaybe<EventMatchGamesAggregateOrderBy>;
  group?: InputMaybe<EventGroupsOrderBy>;
  groupId?: InputMaybe<OrderBy>;
  groupRegistrationsAggregate?: InputMaybe<EventGroupRegistrationsAggregateOrderBy>;
  id?: InputMaybe<OrderBy>;
  matchesAggregate?: InputMaybe<EventMatchesTeamsAggregateOrderBy>;
  matchesLostAggregate?: InputMaybe<EventMatchesAggregateOrderBy>;
  matchesWonAggregate?: InputMaybe<EventMatchesAggregateOrderBy>;
  membersAggregate?: InputMaybe<EventTeamMembersAggregateOrderBy>;
  poolsAggregate?: InputMaybe<EventPoolsTeamsAggregateOrderBy>;
  status?: InputMaybe<OrderBy>;
  teamName?: InputMaybe<OrderBy>;
  teamStatus?: InputMaybe<EventTeamStatusesOrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: event_teams */
export type EventTeamsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "event_teams" */
export enum EventTeamsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  GroupId = 'groupId',
  /** column name */
  Id = 'id',
  /** column name */
  Status = 'status',
  /** column name */
  TeamName = 'teamName',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "event_teams" */
export type EventTeamsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  groupId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<EventTeamStatusesEnum>;
  teamName?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "event_teams" */
export type EventTeamsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventTeamsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventTeamsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  groupId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<EventTeamStatusesEnum>;
  teamName?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "event_teams" */
export enum EventTeamsUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  GroupId = 'groupId',
  /** column name */
  Id = 'id',
  /** column name */
  Status = 'status',
  /** column name */
  TeamName = 'teamName',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type EventTeamsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventTeamsSetInput>;
  /** filter the rows which have to be updated */
  where: EventTeamsBoolExp;
};

/** columns and relationships of "event_transaction_item_types" */
export type EventTransactionItemTypes = {
  __typename?: 'EventTransactionItemTypes';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "event_transaction_item_types" */
export type EventTransactionItemTypesAggregate = {
  __typename?: 'EventTransactionItemTypesAggregate';
  aggregate?: Maybe<EventTransactionItemTypesAggregateFields>;
  nodes: Array<EventTransactionItemTypes>;
};

/** aggregate fields of "event_transaction_item_types" */
export type EventTransactionItemTypesAggregateFields = {
  __typename?: 'EventTransactionItemTypesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<EventTransactionItemTypesMaxFields>;
  min?: Maybe<EventTransactionItemTypesMinFields>;
};


/** aggregate fields of "event_transaction_item_types" */
export type EventTransactionItemTypesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EventTransactionItemTypesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "event_transaction_item_types". All fields are combined with a logical 'AND'. */
export type EventTransactionItemTypesBoolExp = {
  _and?: InputMaybe<Array<EventTransactionItemTypesBoolExp>>;
  _not?: InputMaybe<EventTransactionItemTypesBoolExp>;
  _or?: InputMaybe<Array<EventTransactionItemTypesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "event_transaction_item_types" */
export enum EventTransactionItemTypesConstraint {
  /** unique or primary key constraint on columns "value" */
  EventTransactionItemTypesPkey = 'event_transaction_item_types_pkey'
}

export enum EventTransactionItemTypesEnum {
  /** Coupon discount applied at checkout */
  Coupon = 'COUPON',
  EventGroupRegistration = 'EVENT_GROUP_REGISTRATION',
  EventRegistration = 'EVENT_REGISTRATION'
}

/** Boolean expression to compare columns of type "EventTransactionItemTypesEnum". All fields are combined with logical 'AND'. */
export type EventTransactionItemTypesEnumComparisonExp = {
  _eq?: InputMaybe<EventTransactionItemTypesEnum>;
  _in?: InputMaybe<Array<EventTransactionItemTypesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<EventTransactionItemTypesEnum>;
  _nin?: InputMaybe<Array<EventTransactionItemTypesEnum>>;
};

/** input type for inserting data into table "event_transaction_item_types" */
export type EventTransactionItemTypesInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type EventTransactionItemTypesMaxFields = {
  __typename?: 'EventTransactionItemTypesMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type EventTransactionItemTypesMinFields = {
  __typename?: 'EventTransactionItemTypesMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "event_transaction_item_types" */
export type EventTransactionItemTypesMutationResponse = {
  __typename?: 'EventTransactionItemTypesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventTransactionItemTypes>;
};

/** on_conflict condition type for table "event_transaction_item_types" */
export type EventTransactionItemTypesOnConflict = {
  constraint: EventTransactionItemTypesConstraint;
  updateColumns?: Array<EventTransactionItemTypesUpdateColumn>;
  where?: InputMaybe<EventTransactionItemTypesBoolExp>;
};

/** Ordering options when selecting data from "event_transaction_item_types". */
export type EventTransactionItemTypesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: event_transaction_item_types */
export type EventTransactionItemTypesPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "event_transaction_item_types" */
export enum EventTransactionItemTypesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "event_transaction_item_types" */
export type EventTransactionItemTypesSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "event_transaction_item_types" */
export type EventTransactionItemTypesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventTransactionItemTypesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventTransactionItemTypesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "event_transaction_item_types" */
export enum EventTransactionItemTypesUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type EventTransactionItemTypesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventTransactionItemTypesSetInput>;
  /** filter the rows which have to be updated */
  where: EventTransactionItemTypesBoolExp;
};

/** columns and relationships of "event_transaction_items" */
export type EventTransactionItems = {
  __typename?: 'EventTransactionItems';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  groupRegistration?: Maybe<EventGroupRegistrations>;
  groupRegistrationId?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  priceUnitAmount: Scalars['Int'];
  refundUnitAmount: Scalars['Int'];
  refundedAt?: Maybe<Scalars['timestamptz']>;
  refundedByPersona?: Maybe<AppPersonasEnum>;
  /** An object relationship */
  registration?: Maybe<EventRegistrations>;
  registrationId?: Maybe<Scalars['uuid']>;
  status: OrderStatusesEnum;
  totalUnitAmount: Scalars['Int'];
  /** An object relationship */
  transaction: EventTransactions;
  transactionId: Scalars['uuid'];
  type: EventTransactionItemTypesEnum;
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "event_transaction_items" */
export type EventTransactionItemsAggregate = {
  __typename?: 'EventTransactionItemsAggregate';
  aggregate?: Maybe<EventTransactionItemsAggregateFields>;
  nodes: Array<EventTransactionItems>;
};

export type EventTransactionItemsAggregateBoolExp = {
  count?: InputMaybe<EventTransactionItemsAggregateBoolExpCount>;
};

/** aggregate fields of "event_transaction_items" */
export type EventTransactionItemsAggregateFields = {
  __typename?: 'EventTransactionItemsAggregateFields';
  avg?: Maybe<EventTransactionItemsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<EventTransactionItemsMaxFields>;
  min?: Maybe<EventTransactionItemsMinFields>;
  stddev?: Maybe<EventTransactionItemsStddevFields>;
  stddevPop?: Maybe<EventTransactionItemsStddevPopFields>;
  stddevSamp?: Maybe<EventTransactionItemsStddevSampFields>;
  sum?: Maybe<EventTransactionItemsSumFields>;
  varPop?: Maybe<EventTransactionItemsVarPopFields>;
  varSamp?: Maybe<EventTransactionItemsVarSampFields>;
  variance?: Maybe<EventTransactionItemsVarianceFields>;
};


/** aggregate fields of "event_transaction_items" */
export type EventTransactionItemsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EventTransactionItemsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "event_transaction_items" */
export type EventTransactionItemsAggregateOrderBy = {
  avg?: InputMaybe<EventTransactionItemsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EventTransactionItemsMaxOrderBy>;
  min?: InputMaybe<EventTransactionItemsMinOrderBy>;
  stddev?: InputMaybe<EventTransactionItemsStddevOrderBy>;
  stddevPop?: InputMaybe<EventTransactionItemsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<EventTransactionItemsStddevSampOrderBy>;
  sum?: InputMaybe<EventTransactionItemsSumOrderBy>;
  varPop?: InputMaybe<EventTransactionItemsVarPopOrderBy>;
  varSamp?: InputMaybe<EventTransactionItemsVarSampOrderBy>;
  variance?: InputMaybe<EventTransactionItemsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "event_transaction_items" */
export type EventTransactionItemsArrRelInsertInput = {
  data: Array<EventTransactionItemsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<EventTransactionItemsOnConflict>;
};

/** aggregate avg on columns */
export type EventTransactionItemsAvgFields = {
  __typename?: 'EventTransactionItemsAvgFields';
  priceUnitAmount?: Maybe<Scalars['Float']>;
  refundUnitAmount?: Maybe<Scalars['Float']>;
  totalUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "event_transaction_items" */
export type EventTransactionItemsAvgOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  totalUnitAmount?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "event_transaction_items". All fields are combined with a logical 'AND'. */
export type EventTransactionItemsBoolExp = {
  _and?: InputMaybe<Array<EventTransactionItemsBoolExp>>;
  _not?: InputMaybe<EventTransactionItemsBoolExp>;
  _or?: InputMaybe<Array<EventTransactionItemsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  groupRegistration?: InputMaybe<EventGroupRegistrationsBoolExp>;
  groupRegistrationId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  priceUnitAmount?: InputMaybe<IntComparisonExp>;
  refundUnitAmount?: InputMaybe<IntComparisonExp>;
  refundedAt?: InputMaybe<TimestamptzComparisonExp>;
  refundedByPersona?: InputMaybe<AppPersonasEnumComparisonExp>;
  registration?: InputMaybe<EventRegistrationsBoolExp>;
  registrationId?: InputMaybe<UuidComparisonExp>;
  status?: InputMaybe<OrderStatusesEnumComparisonExp>;
  totalUnitAmount?: InputMaybe<IntComparisonExp>;
  transaction?: InputMaybe<EventTransactionsBoolExp>;
  transactionId?: InputMaybe<UuidComparisonExp>;
  type?: InputMaybe<EventTransactionItemTypesEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "event_transaction_items" */
export enum EventTransactionItemsConstraint {
  /** unique or primary key constraint on columns "id" */
  EventTransactionItemsPkey = 'event_transaction_items_pkey'
}

/** input type for incrementing numeric columns in table "event_transaction_items" */
export type EventTransactionItemsIncInput = {
  priceUnitAmount?: InputMaybe<Scalars['Int']>;
  refundUnitAmount?: InputMaybe<Scalars['Int']>;
  totalUnitAmount?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "event_transaction_items" */
export type EventTransactionItemsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  groupRegistration?: InputMaybe<EventGroupRegistrationsObjRelInsertInput>;
  groupRegistrationId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  priceUnitAmount?: InputMaybe<Scalars['Int']>;
  refundUnitAmount?: InputMaybe<Scalars['Int']>;
  refundedAt?: InputMaybe<Scalars['timestamptz']>;
  refundedByPersona?: InputMaybe<AppPersonasEnum>;
  registration?: InputMaybe<EventRegistrationsObjRelInsertInput>;
  registrationId?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<OrderStatusesEnum>;
  totalUnitAmount?: InputMaybe<Scalars['Int']>;
  transaction?: InputMaybe<EventTransactionsObjRelInsertInput>;
  transactionId?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<EventTransactionItemTypesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type EventTransactionItemsMaxFields = {
  __typename?: 'EventTransactionItemsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  groupRegistrationId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  priceUnitAmount?: Maybe<Scalars['Int']>;
  refundUnitAmount?: Maybe<Scalars['Int']>;
  refundedAt?: Maybe<Scalars['timestamptz']>;
  registrationId?: Maybe<Scalars['uuid']>;
  totalUnitAmount?: Maybe<Scalars['Int']>;
  transactionId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "event_transaction_items" */
export type EventTransactionItemsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  groupRegistrationId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  refundedAt?: InputMaybe<OrderBy>;
  registrationId?: InputMaybe<OrderBy>;
  totalUnitAmount?: InputMaybe<OrderBy>;
  transactionId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type EventTransactionItemsMinFields = {
  __typename?: 'EventTransactionItemsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  groupRegistrationId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  priceUnitAmount?: Maybe<Scalars['Int']>;
  refundUnitAmount?: Maybe<Scalars['Int']>;
  refundedAt?: Maybe<Scalars['timestamptz']>;
  registrationId?: Maybe<Scalars['uuid']>;
  totalUnitAmount?: Maybe<Scalars['Int']>;
  transactionId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "event_transaction_items" */
export type EventTransactionItemsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  groupRegistrationId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  refundedAt?: InputMaybe<OrderBy>;
  registrationId?: InputMaybe<OrderBy>;
  totalUnitAmount?: InputMaybe<OrderBy>;
  transactionId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "event_transaction_items" */
export type EventTransactionItemsMutationResponse = {
  __typename?: 'EventTransactionItemsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventTransactionItems>;
};

/** input type for inserting object relation for remote table "event_transaction_items" */
export type EventTransactionItemsObjRelInsertInput = {
  data: EventTransactionItemsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<EventTransactionItemsOnConflict>;
};

/** on_conflict condition type for table "event_transaction_items" */
export type EventTransactionItemsOnConflict = {
  constraint: EventTransactionItemsConstraint;
  updateColumns?: Array<EventTransactionItemsUpdateColumn>;
  where?: InputMaybe<EventTransactionItemsBoolExp>;
};

/** Ordering options when selecting data from "event_transaction_items". */
export type EventTransactionItemsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  groupRegistration?: InputMaybe<EventGroupRegistrationsOrderBy>;
  groupRegistrationId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  refundedAt?: InputMaybe<OrderBy>;
  refundedByPersona?: InputMaybe<OrderBy>;
  registration?: InputMaybe<EventRegistrationsOrderBy>;
  registrationId?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  totalUnitAmount?: InputMaybe<OrderBy>;
  transaction?: InputMaybe<EventTransactionsOrderBy>;
  transactionId?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: event_transaction_items */
export type EventTransactionItemsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "event_transaction_items" */
export enum EventTransactionItemsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  GroupRegistrationId = 'groupRegistrationId',
  /** column name */
  Id = 'id',
  /** column name */
  PriceUnitAmount = 'priceUnitAmount',
  /** column name */
  RefundUnitAmount = 'refundUnitAmount',
  /** column name */
  RefundedAt = 'refundedAt',
  /** column name */
  RefundedByPersona = 'refundedByPersona',
  /** column name */
  RegistrationId = 'registrationId',
  /** column name */
  Status = 'status',
  /** column name */
  TotalUnitAmount = 'totalUnitAmount',
  /** column name */
  TransactionId = 'transactionId',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "event_transaction_items" */
export type EventTransactionItemsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  groupRegistrationId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  priceUnitAmount?: InputMaybe<Scalars['Int']>;
  refundUnitAmount?: InputMaybe<Scalars['Int']>;
  refundedAt?: InputMaybe<Scalars['timestamptz']>;
  refundedByPersona?: InputMaybe<AppPersonasEnum>;
  registrationId?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<OrderStatusesEnum>;
  totalUnitAmount?: InputMaybe<Scalars['Int']>;
  transactionId?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<EventTransactionItemTypesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type EventTransactionItemsStddevFields = {
  __typename?: 'EventTransactionItemsStddevFields';
  priceUnitAmount?: Maybe<Scalars['Float']>;
  refundUnitAmount?: Maybe<Scalars['Float']>;
  totalUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "event_transaction_items" */
export type EventTransactionItemsStddevOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  totalUnitAmount?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type EventTransactionItemsStddevPopFields = {
  __typename?: 'EventTransactionItemsStddevPopFields';
  priceUnitAmount?: Maybe<Scalars['Float']>;
  refundUnitAmount?: Maybe<Scalars['Float']>;
  totalUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "event_transaction_items" */
export type EventTransactionItemsStddevPopOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  totalUnitAmount?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type EventTransactionItemsStddevSampFields = {
  __typename?: 'EventTransactionItemsStddevSampFields';
  priceUnitAmount?: Maybe<Scalars['Float']>;
  refundUnitAmount?: Maybe<Scalars['Float']>;
  totalUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "event_transaction_items" */
export type EventTransactionItemsStddevSampOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  totalUnitAmount?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "event_transaction_items" */
export type EventTransactionItemsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventTransactionItemsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventTransactionItemsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  groupRegistrationId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  priceUnitAmount?: InputMaybe<Scalars['Int']>;
  refundUnitAmount?: InputMaybe<Scalars['Int']>;
  refundedAt?: InputMaybe<Scalars['timestamptz']>;
  refundedByPersona?: InputMaybe<AppPersonasEnum>;
  registrationId?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<OrderStatusesEnum>;
  totalUnitAmount?: InputMaybe<Scalars['Int']>;
  transactionId?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<EventTransactionItemTypesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type EventTransactionItemsSumFields = {
  __typename?: 'EventTransactionItemsSumFields';
  priceUnitAmount?: Maybe<Scalars['Int']>;
  refundUnitAmount?: Maybe<Scalars['Int']>;
  totalUnitAmount?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "event_transaction_items" */
export type EventTransactionItemsSumOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  totalUnitAmount?: InputMaybe<OrderBy>;
};

/** update columns of table "event_transaction_items" */
export enum EventTransactionItemsUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  GroupRegistrationId = 'groupRegistrationId',
  /** column name */
  Id = 'id',
  /** column name */
  PriceUnitAmount = 'priceUnitAmount',
  /** column name */
  RefundUnitAmount = 'refundUnitAmount',
  /** column name */
  RefundedAt = 'refundedAt',
  /** column name */
  RefundedByPersona = 'refundedByPersona',
  /** column name */
  RegistrationId = 'registrationId',
  /** column name */
  Status = 'status',
  /** column name */
  TotalUnitAmount = 'totalUnitAmount',
  /** column name */
  TransactionId = 'transactionId',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type EventTransactionItemsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<EventTransactionItemsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventTransactionItemsSetInput>;
  /** filter the rows which have to be updated */
  where: EventTransactionItemsBoolExp;
};

/** aggregate varPop on columns */
export type EventTransactionItemsVarPopFields = {
  __typename?: 'EventTransactionItemsVarPopFields';
  priceUnitAmount?: Maybe<Scalars['Float']>;
  refundUnitAmount?: Maybe<Scalars['Float']>;
  totalUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "event_transaction_items" */
export type EventTransactionItemsVarPopOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  totalUnitAmount?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type EventTransactionItemsVarSampFields = {
  __typename?: 'EventTransactionItemsVarSampFields';
  priceUnitAmount?: Maybe<Scalars['Float']>;
  refundUnitAmount?: Maybe<Scalars['Float']>;
  totalUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "event_transaction_items" */
export type EventTransactionItemsVarSampOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  totalUnitAmount?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type EventTransactionItemsVarianceFields = {
  __typename?: 'EventTransactionItemsVarianceFields';
  priceUnitAmount?: Maybe<Scalars['Float']>;
  refundUnitAmount?: Maybe<Scalars['Float']>;
  totalUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "event_transaction_items" */
export type EventTransactionItemsVarianceOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  totalUnitAmount?: InputMaybe<OrderBy>;
};

/** columns and relationships of "event_transactions" */
export type EventTransactions = {
  __typename?: 'EventTransactions';
  applicationFeeTotalUnitAmount: Scalars['Int'];
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  customer: Users;
  customerApplicationFeeUnitAmount: Scalars['Int'];
  customerPlatformFeeUnitAmount: Scalars['Int'];
  customerProcessingFeeUnitAmount: Scalars['Int'];
  /** An object relationship */
  customerProfile?: Maybe<UserProfiles>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  event: Events;
  eventId: Scalars['uuid'];
  externalStripePaymentIntentId: Scalars['String'];
  id: Scalars['uuid'];
  internalStripePaymentIntentId: Scalars['uuid'];
  orderSubtotalUnitAmount: Scalars['Int'];
  orderTotalUnitAmount: Scalars['Int'];
  paidUnitAmount: Scalars['Int'];
  /** An object relationship */
  paymentIntentExternal: StripePaymentIntents;
  /** An object relationship */
  paymentIntentInternal: StripePaymentIntents;
  /** An object relationship */
  paymentMethodUsed?: Maybe<UserCreditCards>;
  paymentProcessor: PaymentProcessorsEnum;
  refundUnitAmount: Scalars['Int'];
  refundedAt?: Maybe<Scalars['timestamptz']>;
  refundedByPersona?: Maybe<AppPersonasEnum>;
  /** An object relationship */
  seller: Users;
  sellerApplicationFeeUnitAmount: Scalars['Int'];
  sellerPlatformFeeUnitAmount: Scalars['Int'];
  sellerProcessingFeeUnitAmount: Scalars['Int'];
  /** An object relationship */
  sellerProfile?: Maybe<UserProfiles>;
  sellerUserId: Scalars['uuid'];
  status: OrderStatusesEnum;
  stripeCustomerId: Scalars['String'];
  stripeMerchantId?: Maybe<Scalars['String']>;
  stripePaymentStatus: Scalars['String'];
  /** An array relationship */
  transactionItems: Array<EventTransactionItems>;
  /** An aggregate relationship */
  transactionItemsAggregate: EventTransactionItemsAggregate;
  transferUnitAmount: Scalars['Int'];
  updatedAt: Scalars['timestamptz'];
  userCreditCardId?: Maybe<Scalars['uuid']>;
  userId: Scalars['uuid'];
};


/** columns and relationships of "event_transactions" */
export type EventTransactionsTransactionItemsArgs = {
  distinctOn?: InputMaybe<Array<EventTransactionItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventTransactionItemsOrderBy>>;
  where?: InputMaybe<EventTransactionItemsBoolExp>;
};


/** columns and relationships of "event_transactions" */
export type EventTransactionsTransactionItemsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventTransactionItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventTransactionItemsOrderBy>>;
  where?: InputMaybe<EventTransactionItemsBoolExp>;
};

/** aggregated selection of "event_transactions" */
export type EventTransactionsAggregate = {
  __typename?: 'EventTransactionsAggregate';
  aggregate?: Maybe<EventTransactionsAggregateFields>;
  nodes: Array<EventTransactions>;
};

export type EventTransactionsAggregateBoolExp = {
  count?: InputMaybe<EventTransactionsAggregateBoolExpCount>;
};

/** aggregate fields of "event_transactions" */
export type EventTransactionsAggregateFields = {
  __typename?: 'EventTransactionsAggregateFields';
  avg?: Maybe<EventTransactionsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<EventTransactionsMaxFields>;
  min?: Maybe<EventTransactionsMinFields>;
  stddev?: Maybe<EventTransactionsStddevFields>;
  stddevPop?: Maybe<EventTransactionsStddevPopFields>;
  stddevSamp?: Maybe<EventTransactionsStddevSampFields>;
  sum?: Maybe<EventTransactionsSumFields>;
  varPop?: Maybe<EventTransactionsVarPopFields>;
  varSamp?: Maybe<EventTransactionsVarSampFields>;
  variance?: Maybe<EventTransactionsVarianceFields>;
};


/** aggregate fields of "event_transactions" */
export type EventTransactionsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EventTransactionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "event_transactions" */
export type EventTransactionsAggregateOrderBy = {
  avg?: InputMaybe<EventTransactionsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EventTransactionsMaxOrderBy>;
  min?: InputMaybe<EventTransactionsMinOrderBy>;
  stddev?: InputMaybe<EventTransactionsStddevOrderBy>;
  stddevPop?: InputMaybe<EventTransactionsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<EventTransactionsStddevSampOrderBy>;
  sum?: InputMaybe<EventTransactionsSumOrderBy>;
  varPop?: InputMaybe<EventTransactionsVarPopOrderBy>;
  varSamp?: InputMaybe<EventTransactionsVarSampOrderBy>;
  variance?: InputMaybe<EventTransactionsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "event_transactions" */
export type EventTransactionsArrRelInsertInput = {
  data: Array<EventTransactionsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<EventTransactionsOnConflict>;
};

/** aggregate avg on columns */
export type EventTransactionsAvgFields = {
  __typename?: 'EventTransactionsAvgFields';
  applicationFeeTotalUnitAmount?: Maybe<Scalars['Float']>;
  customerApplicationFeeUnitAmount?: Maybe<Scalars['Float']>;
  customerPlatformFeeUnitAmount?: Maybe<Scalars['Float']>;
  customerProcessingFeeUnitAmount?: Maybe<Scalars['Float']>;
  orderSubtotalUnitAmount?: Maybe<Scalars['Float']>;
  orderTotalUnitAmount?: Maybe<Scalars['Float']>;
  paidUnitAmount?: Maybe<Scalars['Float']>;
  refundUnitAmount?: Maybe<Scalars['Float']>;
  sellerApplicationFeeUnitAmount?: Maybe<Scalars['Float']>;
  sellerPlatformFeeUnitAmount?: Maybe<Scalars['Float']>;
  sellerProcessingFeeUnitAmount?: Maybe<Scalars['Float']>;
  transferUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "event_transactions" */
export type EventTransactionsAvgOrderBy = {
  applicationFeeTotalUnitAmount?: InputMaybe<OrderBy>;
  customerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  customerPlatformFeeUnitAmount?: InputMaybe<OrderBy>;
  customerProcessingFeeUnitAmount?: InputMaybe<OrderBy>;
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  sellerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  sellerPlatformFeeUnitAmount?: InputMaybe<OrderBy>;
  sellerProcessingFeeUnitAmount?: InputMaybe<OrderBy>;
  transferUnitAmount?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "event_transactions". All fields are combined with a logical 'AND'. */
export type EventTransactionsBoolExp = {
  _and?: InputMaybe<Array<EventTransactionsBoolExp>>;
  _not?: InputMaybe<EventTransactionsBoolExp>;
  _or?: InputMaybe<Array<EventTransactionsBoolExp>>;
  applicationFeeTotalUnitAmount?: InputMaybe<IntComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  customer?: InputMaybe<UsersBoolExp>;
  customerApplicationFeeUnitAmount?: InputMaybe<IntComparisonExp>;
  customerPlatformFeeUnitAmount?: InputMaybe<IntComparisonExp>;
  customerProcessingFeeUnitAmount?: InputMaybe<IntComparisonExp>;
  customerProfile?: InputMaybe<UserProfilesBoolExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  event?: InputMaybe<EventsBoolExp>;
  eventId?: InputMaybe<UuidComparisonExp>;
  externalStripePaymentIntentId?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  internalStripePaymentIntentId?: InputMaybe<UuidComparisonExp>;
  orderSubtotalUnitAmount?: InputMaybe<IntComparisonExp>;
  orderTotalUnitAmount?: InputMaybe<IntComparisonExp>;
  paidUnitAmount?: InputMaybe<IntComparisonExp>;
  paymentIntentExternal?: InputMaybe<StripePaymentIntentsBoolExp>;
  paymentIntentInternal?: InputMaybe<StripePaymentIntentsBoolExp>;
  paymentMethodUsed?: InputMaybe<UserCreditCardsBoolExp>;
  paymentProcessor?: InputMaybe<PaymentProcessorsEnumComparisonExp>;
  refundUnitAmount?: InputMaybe<IntComparisonExp>;
  refundedAt?: InputMaybe<TimestamptzComparisonExp>;
  refundedByPersona?: InputMaybe<AppPersonasEnumComparisonExp>;
  seller?: InputMaybe<UsersBoolExp>;
  sellerApplicationFeeUnitAmount?: InputMaybe<IntComparisonExp>;
  sellerPlatformFeeUnitAmount?: InputMaybe<IntComparisonExp>;
  sellerProcessingFeeUnitAmount?: InputMaybe<IntComparisonExp>;
  sellerProfile?: InputMaybe<UserProfilesBoolExp>;
  sellerUserId?: InputMaybe<UuidComparisonExp>;
  status?: InputMaybe<OrderStatusesEnumComparisonExp>;
  stripeCustomerId?: InputMaybe<StringComparisonExp>;
  stripeMerchantId?: InputMaybe<StringComparisonExp>;
  stripePaymentStatus?: InputMaybe<StringComparisonExp>;
  transactionItems?: InputMaybe<EventTransactionItemsBoolExp>;
  transactionItemsAggregate?: InputMaybe<EventTransactionItemsAggregateBoolExp>;
  transferUnitAmount?: InputMaybe<IntComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  userCreditCardId?: InputMaybe<UuidComparisonExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "event_transactions" */
export enum EventTransactionsConstraint {
  /** unique or primary key constraint on columns "external_stripe_payment_intent_id" */
  EventTransactionsExternalStripePaymentIntentIdKey = 'event_transactions_external_stripe_payment_intent_id_key',
  /** unique or primary key constraint on columns "internal_stripe_payment_intent_id" */
  EventTransactionsInternalStripePaymentIntentIdKey = 'event_transactions_internal_stripe_payment_intent_id_key',
  /** unique or primary key constraint on columns "id" */
  EventTransactionsPkey = 'event_transactions_pkey'
}

/** input type for incrementing numeric columns in table "event_transactions" */
export type EventTransactionsIncInput = {
  applicationFeeTotalUnitAmount?: InputMaybe<Scalars['Int']>;
  customerApplicationFeeUnitAmount?: InputMaybe<Scalars['Int']>;
  customerPlatformFeeUnitAmount?: InputMaybe<Scalars['Int']>;
  customerProcessingFeeUnitAmount?: InputMaybe<Scalars['Int']>;
  orderSubtotalUnitAmount?: InputMaybe<Scalars['Int']>;
  orderTotalUnitAmount?: InputMaybe<Scalars['Int']>;
  paidUnitAmount?: InputMaybe<Scalars['Int']>;
  refundUnitAmount?: InputMaybe<Scalars['Int']>;
  sellerApplicationFeeUnitAmount?: InputMaybe<Scalars['Int']>;
  sellerPlatformFeeUnitAmount?: InputMaybe<Scalars['Int']>;
  sellerProcessingFeeUnitAmount?: InputMaybe<Scalars['Int']>;
  transferUnitAmount?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "event_transactions" */
export type EventTransactionsInsertInput = {
  applicationFeeTotalUnitAmount?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  customer?: InputMaybe<UsersObjRelInsertInput>;
  customerApplicationFeeUnitAmount?: InputMaybe<Scalars['Int']>;
  customerPlatformFeeUnitAmount?: InputMaybe<Scalars['Int']>;
  customerProcessingFeeUnitAmount?: InputMaybe<Scalars['Int']>;
  customerProfile?: InputMaybe<UserProfilesObjRelInsertInput>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  event?: InputMaybe<EventsObjRelInsertInput>;
  eventId?: InputMaybe<Scalars['uuid']>;
  externalStripePaymentIntentId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  internalStripePaymentIntentId?: InputMaybe<Scalars['uuid']>;
  orderSubtotalUnitAmount?: InputMaybe<Scalars['Int']>;
  orderTotalUnitAmount?: InputMaybe<Scalars['Int']>;
  paidUnitAmount?: InputMaybe<Scalars['Int']>;
  paymentIntentExternal?: InputMaybe<StripePaymentIntentsObjRelInsertInput>;
  paymentIntentInternal?: InputMaybe<StripePaymentIntentsObjRelInsertInput>;
  paymentMethodUsed?: InputMaybe<UserCreditCardsObjRelInsertInput>;
  paymentProcessor?: InputMaybe<PaymentProcessorsEnum>;
  refundUnitAmount?: InputMaybe<Scalars['Int']>;
  refundedAt?: InputMaybe<Scalars['timestamptz']>;
  refundedByPersona?: InputMaybe<AppPersonasEnum>;
  seller?: InputMaybe<UsersObjRelInsertInput>;
  sellerApplicationFeeUnitAmount?: InputMaybe<Scalars['Int']>;
  sellerPlatformFeeUnitAmount?: InputMaybe<Scalars['Int']>;
  sellerProcessingFeeUnitAmount?: InputMaybe<Scalars['Int']>;
  sellerProfile?: InputMaybe<UserProfilesObjRelInsertInput>;
  sellerUserId?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<OrderStatusesEnum>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  stripeMerchantId?: InputMaybe<Scalars['String']>;
  stripePaymentStatus?: InputMaybe<Scalars['String']>;
  transactionItems?: InputMaybe<EventTransactionItemsArrRelInsertInput>;
  transferUnitAmount?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userCreditCardId?: InputMaybe<Scalars['uuid']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type EventTransactionsMaxFields = {
  __typename?: 'EventTransactionsMaxFields';
  applicationFeeTotalUnitAmount?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  customerApplicationFeeUnitAmount?: Maybe<Scalars['Int']>;
  customerPlatformFeeUnitAmount?: Maybe<Scalars['Int']>;
  customerProcessingFeeUnitAmount?: Maybe<Scalars['Int']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  eventId?: Maybe<Scalars['uuid']>;
  externalStripePaymentIntentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  internalStripePaymentIntentId?: Maybe<Scalars['uuid']>;
  orderSubtotalUnitAmount?: Maybe<Scalars['Int']>;
  orderTotalUnitAmount?: Maybe<Scalars['Int']>;
  paidUnitAmount?: Maybe<Scalars['Int']>;
  refundUnitAmount?: Maybe<Scalars['Int']>;
  refundedAt?: Maybe<Scalars['timestamptz']>;
  sellerApplicationFeeUnitAmount?: Maybe<Scalars['Int']>;
  sellerPlatformFeeUnitAmount?: Maybe<Scalars['Int']>;
  sellerProcessingFeeUnitAmount?: Maybe<Scalars['Int']>;
  sellerUserId?: Maybe<Scalars['uuid']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripeMerchantId?: Maybe<Scalars['String']>;
  stripePaymentStatus?: Maybe<Scalars['String']>;
  transferUnitAmount?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userCreditCardId?: Maybe<Scalars['uuid']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "event_transactions" */
export type EventTransactionsMaxOrderBy = {
  applicationFeeTotalUnitAmount?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  customerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  customerPlatformFeeUnitAmount?: InputMaybe<OrderBy>;
  customerProcessingFeeUnitAmount?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  eventId?: InputMaybe<OrderBy>;
  externalStripePaymentIntentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  internalStripePaymentIntentId?: InputMaybe<OrderBy>;
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  refundedAt?: InputMaybe<OrderBy>;
  sellerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  sellerPlatformFeeUnitAmount?: InputMaybe<OrderBy>;
  sellerProcessingFeeUnitAmount?: InputMaybe<OrderBy>;
  sellerUserId?: InputMaybe<OrderBy>;
  stripeCustomerId?: InputMaybe<OrderBy>;
  stripeMerchantId?: InputMaybe<OrderBy>;
  stripePaymentStatus?: InputMaybe<OrderBy>;
  transferUnitAmount?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userCreditCardId?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type EventTransactionsMinFields = {
  __typename?: 'EventTransactionsMinFields';
  applicationFeeTotalUnitAmount?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  customerApplicationFeeUnitAmount?: Maybe<Scalars['Int']>;
  customerPlatformFeeUnitAmount?: Maybe<Scalars['Int']>;
  customerProcessingFeeUnitAmount?: Maybe<Scalars['Int']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  eventId?: Maybe<Scalars['uuid']>;
  externalStripePaymentIntentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  internalStripePaymentIntentId?: Maybe<Scalars['uuid']>;
  orderSubtotalUnitAmount?: Maybe<Scalars['Int']>;
  orderTotalUnitAmount?: Maybe<Scalars['Int']>;
  paidUnitAmount?: Maybe<Scalars['Int']>;
  refundUnitAmount?: Maybe<Scalars['Int']>;
  refundedAt?: Maybe<Scalars['timestamptz']>;
  sellerApplicationFeeUnitAmount?: Maybe<Scalars['Int']>;
  sellerPlatformFeeUnitAmount?: Maybe<Scalars['Int']>;
  sellerProcessingFeeUnitAmount?: Maybe<Scalars['Int']>;
  sellerUserId?: Maybe<Scalars['uuid']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripeMerchantId?: Maybe<Scalars['String']>;
  stripePaymentStatus?: Maybe<Scalars['String']>;
  transferUnitAmount?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userCreditCardId?: Maybe<Scalars['uuid']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "event_transactions" */
export type EventTransactionsMinOrderBy = {
  applicationFeeTotalUnitAmount?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  customerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  customerPlatformFeeUnitAmount?: InputMaybe<OrderBy>;
  customerProcessingFeeUnitAmount?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  eventId?: InputMaybe<OrderBy>;
  externalStripePaymentIntentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  internalStripePaymentIntentId?: InputMaybe<OrderBy>;
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  refundedAt?: InputMaybe<OrderBy>;
  sellerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  sellerPlatformFeeUnitAmount?: InputMaybe<OrderBy>;
  sellerProcessingFeeUnitAmount?: InputMaybe<OrderBy>;
  sellerUserId?: InputMaybe<OrderBy>;
  stripeCustomerId?: InputMaybe<OrderBy>;
  stripeMerchantId?: InputMaybe<OrderBy>;
  stripePaymentStatus?: InputMaybe<OrderBy>;
  transferUnitAmount?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userCreditCardId?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "event_transactions" */
export type EventTransactionsMutationResponse = {
  __typename?: 'EventTransactionsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventTransactions>;
};

/** input type for inserting object relation for remote table "event_transactions" */
export type EventTransactionsObjRelInsertInput = {
  data: EventTransactionsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<EventTransactionsOnConflict>;
};

/** on_conflict condition type for table "event_transactions" */
export type EventTransactionsOnConflict = {
  constraint: EventTransactionsConstraint;
  updateColumns?: Array<EventTransactionsUpdateColumn>;
  where?: InputMaybe<EventTransactionsBoolExp>;
};

/** Ordering options when selecting data from "event_transactions". */
export type EventTransactionsOrderBy = {
  applicationFeeTotalUnitAmount?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  customer?: InputMaybe<UsersOrderBy>;
  customerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  customerPlatformFeeUnitAmount?: InputMaybe<OrderBy>;
  customerProcessingFeeUnitAmount?: InputMaybe<OrderBy>;
  customerProfile?: InputMaybe<UserProfilesOrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  event?: InputMaybe<EventsOrderBy>;
  eventId?: InputMaybe<OrderBy>;
  externalStripePaymentIntentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  internalStripePaymentIntentId?: InputMaybe<OrderBy>;
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  paymentIntentExternal?: InputMaybe<StripePaymentIntentsOrderBy>;
  paymentIntentInternal?: InputMaybe<StripePaymentIntentsOrderBy>;
  paymentMethodUsed?: InputMaybe<UserCreditCardsOrderBy>;
  paymentProcessor?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  refundedAt?: InputMaybe<OrderBy>;
  refundedByPersona?: InputMaybe<OrderBy>;
  seller?: InputMaybe<UsersOrderBy>;
  sellerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  sellerPlatformFeeUnitAmount?: InputMaybe<OrderBy>;
  sellerProcessingFeeUnitAmount?: InputMaybe<OrderBy>;
  sellerProfile?: InputMaybe<UserProfilesOrderBy>;
  sellerUserId?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  stripeCustomerId?: InputMaybe<OrderBy>;
  stripeMerchantId?: InputMaybe<OrderBy>;
  stripePaymentStatus?: InputMaybe<OrderBy>;
  transactionItemsAggregate?: InputMaybe<EventTransactionItemsAggregateOrderBy>;
  transferUnitAmount?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userCreditCardId?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: event_transactions */
export type EventTransactionsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "event_transactions" */
export enum EventTransactionsSelectColumn {
  /** column name */
  ApplicationFeeTotalUnitAmount = 'applicationFeeTotalUnitAmount',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CustomerApplicationFeeUnitAmount = 'customerApplicationFeeUnitAmount',
  /** column name */
  CustomerPlatformFeeUnitAmount = 'customerPlatformFeeUnitAmount',
  /** column name */
  CustomerProcessingFeeUnitAmount = 'customerProcessingFeeUnitAmount',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EventId = 'eventId',
  /** column name */
  ExternalStripePaymentIntentId = 'externalStripePaymentIntentId',
  /** column name */
  Id = 'id',
  /** column name */
  InternalStripePaymentIntentId = 'internalStripePaymentIntentId',
  /** column name */
  OrderSubtotalUnitAmount = 'orderSubtotalUnitAmount',
  /** column name */
  OrderTotalUnitAmount = 'orderTotalUnitAmount',
  /** column name */
  PaidUnitAmount = 'paidUnitAmount',
  /** column name */
  PaymentProcessor = 'paymentProcessor',
  /** column name */
  RefundUnitAmount = 'refundUnitAmount',
  /** column name */
  RefundedAt = 'refundedAt',
  /** column name */
  RefundedByPersona = 'refundedByPersona',
  /** column name */
  SellerApplicationFeeUnitAmount = 'sellerApplicationFeeUnitAmount',
  /** column name */
  SellerPlatformFeeUnitAmount = 'sellerPlatformFeeUnitAmount',
  /** column name */
  SellerProcessingFeeUnitAmount = 'sellerProcessingFeeUnitAmount',
  /** column name */
  SellerUserId = 'sellerUserId',
  /** column name */
  Status = 'status',
  /** column name */
  StripeCustomerId = 'stripeCustomerId',
  /** column name */
  StripeMerchantId = 'stripeMerchantId',
  /** column name */
  StripePaymentStatus = 'stripePaymentStatus',
  /** column name */
  TransferUnitAmount = 'transferUnitAmount',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserCreditCardId = 'userCreditCardId',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "event_transactions" */
export type EventTransactionsSetInput = {
  applicationFeeTotalUnitAmount?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  customerApplicationFeeUnitAmount?: InputMaybe<Scalars['Int']>;
  customerPlatformFeeUnitAmount?: InputMaybe<Scalars['Int']>;
  customerProcessingFeeUnitAmount?: InputMaybe<Scalars['Int']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  eventId?: InputMaybe<Scalars['uuid']>;
  externalStripePaymentIntentId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  internalStripePaymentIntentId?: InputMaybe<Scalars['uuid']>;
  orderSubtotalUnitAmount?: InputMaybe<Scalars['Int']>;
  orderTotalUnitAmount?: InputMaybe<Scalars['Int']>;
  paidUnitAmount?: InputMaybe<Scalars['Int']>;
  paymentProcessor?: InputMaybe<PaymentProcessorsEnum>;
  refundUnitAmount?: InputMaybe<Scalars['Int']>;
  refundedAt?: InputMaybe<Scalars['timestamptz']>;
  refundedByPersona?: InputMaybe<AppPersonasEnum>;
  sellerApplicationFeeUnitAmount?: InputMaybe<Scalars['Int']>;
  sellerPlatformFeeUnitAmount?: InputMaybe<Scalars['Int']>;
  sellerProcessingFeeUnitAmount?: InputMaybe<Scalars['Int']>;
  sellerUserId?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<OrderStatusesEnum>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  stripeMerchantId?: InputMaybe<Scalars['String']>;
  stripePaymentStatus?: InputMaybe<Scalars['String']>;
  transferUnitAmount?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userCreditCardId?: InputMaybe<Scalars['uuid']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type EventTransactionsStddevFields = {
  __typename?: 'EventTransactionsStddevFields';
  applicationFeeTotalUnitAmount?: Maybe<Scalars['Float']>;
  customerApplicationFeeUnitAmount?: Maybe<Scalars['Float']>;
  customerPlatformFeeUnitAmount?: Maybe<Scalars['Float']>;
  customerProcessingFeeUnitAmount?: Maybe<Scalars['Float']>;
  orderSubtotalUnitAmount?: Maybe<Scalars['Float']>;
  orderTotalUnitAmount?: Maybe<Scalars['Float']>;
  paidUnitAmount?: Maybe<Scalars['Float']>;
  refundUnitAmount?: Maybe<Scalars['Float']>;
  sellerApplicationFeeUnitAmount?: Maybe<Scalars['Float']>;
  sellerPlatformFeeUnitAmount?: Maybe<Scalars['Float']>;
  sellerProcessingFeeUnitAmount?: Maybe<Scalars['Float']>;
  transferUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "event_transactions" */
export type EventTransactionsStddevOrderBy = {
  applicationFeeTotalUnitAmount?: InputMaybe<OrderBy>;
  customerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  customerPlatformFeeUnitAmount?: InputMaybe<OrderBy>;
  customerProcessingFeeUnitAmount?: InputMaybe<OrderBy>;
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  sellerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  sellerPlatformFeeUnitAmount?: InputMaybe<OrderBy>;
  sellerProcessingFeeUnitAmount?: InputMaybe<OrderBy>;
  transferUnitAmount?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type EventTransactionsStddevPopFields = {
  __typename?: 'EventTransactionsStddevPopFields';
  applicationFeeTotalUnitAmount?: Maybe<Scalars['Float']>;
  customerApplicationFeeUnitAmount?: Maybe<Scalars['Float']>;
  customerPlatformFeeUnitAmount?: Maybe<Scalars['Float']>;
  customerProcessingFeeUnitAmount?: Maybe<Scalars['Float']>;
  orderSubtotalUnitAmount?: Maybe<Scalars['Float']>;
  orderTotalUnitAmount?: Maybe<Scalars['Float']>;
  paidUnitAmount?: Maybe<Scalars['Float']>;
  refundUnitAmount?: Maybe<Scalars['Float']>;
  sellerApplicationFeeUnitAmount?: Maybe<Scalars['Float']>;
  sellerPlatformFeeUnitAmount?: Maybe<Scalars['Float']>;
  sellerProcessingFeeUnitAmount?: Maybe<Scalars['Float']>;
  transferUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "event_transactions" */
export type EventTransactionsStddevPopOrderBy = {
  applicationFeeTotalUnitAmount?: InputMaybe<OrderBy>;
  customerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  customerPlatformFeeUnitAmount?: InputMaybe<OrderBy>;
  customerProcessingFeeUnitAmount?: InputMaybe<OrderBy>;
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  sellerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  sellerPlatformFeeUnitAmount?: InputMaybe<OrderBy>;
  sellerProcessingFeeUnitAmount?: InputMaybe<OrderBy>;
  transferUnitAmount?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type EventTransactionsStddevSampFields = {
  __typename?: 'EventTransactionsStddevSampFields';
  applicationFeeTotalUnitAmount?: Maybe<Scalars['Float']>;
  customerApplicationFeeUnitAmount?: Maybe<Scalars['Float']>;
  customerPlatformFeeUnitAmount?: Maybe<Scalars['Float']>;
  customerProcessingFeeUnitAmount?: Maybe<Scalars['Float']>;
  orderSubtotalUnitAmount?: Maybe<Scalars['Float']>;
  orderTotalUnitAmount?: Maybe<Scalars['Float']>;
  paidUnitAmount?: Maybe<Scalars['Float']>;
  refundUnitAmount?: Maybe<Scalars['Float']>;
  sellerApplicationFeeUnitAmount?: Maybe<Scalars['Float']>;
  sellerPlatformFeeUnitAmount?: Maybe<Scalars['Float']>;
  sellerProcessingFeeUnitAmount?: Maybe<Scalars['Float']>;
  transferUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "event_transactions" */
export type EventTransactionsStddevSampOrderBy = {
  applicationFeeTotalUnitAmount?: InputMaybe<OrderBy>;
  customerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  customerPlatformFeeUnitAmount?: InputMaybe<OrderBy>;
  customerProcessingFeeUnitAmount?: InputMaybe<OrderBy>;
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  sellerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  sellerPlatformFeeUnitAmount?: InputMaybe<OrderBy>;
  sellerProcessingFeeUnitAmount?: InputMaybe<OrderBy>;
  transferUnitAmount?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "event_transactions" */
export type EventTransactionsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventTransactionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventTransactionsStreamCursorValueInput = {
  applicationFeeTotalUnitAmount?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  customerApplicationFeeUnitAmount?: InputMaybe<Scalars['Int']>;
  customerPlatformFeeUnitAmount?: InputMaybe<Scalars['Int']>;
  customerProcessingFeeUnitAmount?: InputMaybe<Scalars['Int']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  eventId?: InputMaybe<Scalars['uuid']>;
  externalStripePaymentIntentId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  internalStripePaymentIntentId?: InputMaybe<Scalars['uuid']>;
  orderSubtotalUnitAmount?: InputMaybe<Scalars['Int']>;
  orderTotalUnitAmount?: InputMaybe<Scalars['Int']>;
  paidUnitAmount?: InputMaybe<Scalars['Int']>;
  paymentProcessor?: InputMaybe<PaymentProcessorsEnum>;
  refundUnitAmount?: InputMaybe<Scalars['Int']>;
  refundedAt?: InputMaybe<Scalars['timestamptz']>;
  refundedByPersona?: InputMaybe<AppPersonasEnum>;
  sellerApplicationFeeUnitAmount?: InputMaybe<Scalars['Int']>;
  sellerPlatformFeeUnitAmount?: InputMaybe<Scalars['Int']>;
  sellerProcessingFeeUnitAmount?: InputMaybe<Scalars['Int']>;
  sellerUserId?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<OrderStatusesEnum>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  stripeMerchantId?: InputMaybe<Scalars['String']>;
  stripePaymentStatus?: InputMaybe<Scalars['String']>;
  transferUnitAmount?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userCreditCardId?: InputMaybe<Scalars['uuid']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type EventTransactionsSumFields = {
  __typename?: 'EventTransactionsSumFields';
  applicationFeeTotalUnitAmount?: Maybe<Scalars['Int']>;
  customerApplicationFeeUnitAmount?: Maybe<Scalars['Int']>;
  customerPlatformFeeUnitAmount?: Maybe<Scalars['Int']>;
  customerProcessingFeeUnitAmount?: Maybe<Scalars['Int']>;
  orderSubtotalUnitAmount?: Maybe<Scalars['Int']>;
  orderTotalUnitAmount?: Maybe<Scalars['Int']>;
  paidUnitAmount?: Maybe<Scalars['Int']>;
  refundUnitAmount?: Maybe<Scalars['Int']>;
  sellerApplicationFeeUnitAmount?: Maybe<Scalars['Int']>;
  sellerPlatformFeeUnitAmount?: Maybe<Scalars['Int']>;
  sellerProcessingFeeUnitAmount?: Maybe<Scalars['Int']>;
  transferUnitAmount?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "event_transactions" */
export type EventTransactionsSumOrderBy = {
  applicationFeeTotalUnitAmount?: InputMaybe<OrderBy>;
  customerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  customerPlatformFeeUnitAmount?: InputMaybe<OrderBy>;
  customerProcessingFeeUnitAmount?: InputMaybe<OrderBy>;
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  sellerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  sellerPlatformFeeUnitAmount?: InputMaybe<OrderBy>;
  sellerProcessingFeeUnitAmount?: InputMaybe<OrderBy>;
  transferUnitAmount?: InputMaybe<OrderBy>;
};

/** update columns of table "event_transactions" */
export enum EventTransactionsUpdateColumn {
  /** column name */
  ApplicationFeeTotalUnitAmount = 'applicationFeeTotalUnitAmount',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CustomerApplicationFeeUnitAmount = 'customerApplicationFeeUnitAmount',
  /** column name */
  CustomerPlatformFeeUnitAmount = 'customerPlatformFeeUnitAmount',
  /** column name */
  CustomerProcessingFeeUnitAmount = 'customerProcessingFeeUnitAmount',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EventId = 'eventId',
  /** column name */
  ExternalStripePaymentIntentId = 'externalStripePaymentIntentId',
  /** column name */
  Id = 'id',
  /** column name */
  InternalStripePaymentIntentId = 'internalStripePaymentIntentId',
  /** column name */
  OrderSubtotalUnitAmount = 'orderSubtotalUnitAmount',
  /** column name */
  OrderTotalUnitAmount = 'orderTotalUnitAmount',
  /** column name */
  PaidUnitAmount = 'paidUnitAmount',
  /** column name */
  PaymentProcessor = 'paymentProcessor',
  /** column name */
  RefundUnitAmount = 'refundUnitAmount',
  /** column name */
  RefundedAt = 'refundedAt',
  /** column name */
  RefundedByPersona = 'refundedByPersona',
  /** column name */
  SellerApplicationFeeUnitAmount = 'sellerApplicationFeeUnitAmount',
  /** column name */
  SellerPlatformFeeUnitAmount = 'sellerPlatformFeeUnitAmount',
  /** column name */
  SellerProcessingFeeUnitAmount = 'sellerProcessingFeeUnitAmount',
  /** column name */
  SellerUserId = 'sellerUserId',
  /** column name */
  Status = 'status',
  /** column name */
  StripeCustomerId = 'stripeCustomerId',
  /** column name */
  StripeMerchantId = 'stripeMerchantId',
  /** column name */
  StripePaymentStatus = 'stripePaymentStatus',
  /** column name */
  TransferUnitAmount = 'transferUnitAmount',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserCreditCardId = 'userCreditCardId',
  /** column name */
  UserId = 'userId'
}

export type EventTransactionsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<EventTransactionsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventTransactionsSetInput>;
  /** filter the rows which have to be updated */
  where: EventTransactionsBoolExp;
};

/** aggregate varPop on columns */
export type EventTransactionsVarPopFields = {
  __typename?: 'EventTransactionsVarPopFields';
  applicationFeeTotalUnitAmount?: Maybe<Scalars['Float']>;
  customerApplicationFeeUnitAmount?: Maybe<Scalars['Float']>;
  customerPlatformFeeUnitAmount?: Maybe<Scalars['Float']>;
  customerProcessingFeeUnitAmount?: Maybe<Scalars['Float']>;
  orderSubtotalUnitAmount?: Maybe<Scalars['Float']>;
  orderTotalUnitAmount?: Maybe<Scalars['Float']>;
  paidUnitAmount?: Maybe<Scalars['Float']>;
  refundUnitAmount?: Maybe<Scalars['Float']>;
  sellerApplicationFeeUnitAmount?: Maybe<Scalars['Float']>;
  sellerPlatformFeeUnitAmount?: Maybe<Scalars['Float']>;
  sellerProcessingFeeUnitAmount?: Maybe<Scalars['Float']>;
  transferUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "event_transactions" */
export type EventTransactionsVarPopOrderBy = {
  applicationFeeTotalUnitAmount?: InputMaybe<OrderBy>;
  customerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  customerPlatformFeeUnitAmount?: InputMaybe<OrderBy>;
  customerProcessingFeeUnitAmount?: InputMaybe<OrderBy>;
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  sellerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  sellerPlatformFeeUnitAmount?: InputMaybe<OrderBy>;
  sellerProcessingFeeUnitAmount?: InputMaybe<OrderBy>;
  transferUnitAmount?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type EventTransactionsVarSampFields = {
  __typename?: 'EventTransactionsVarSampFields';
  applicationFeeTotalUnitAmount?: Maybe<Scalars['Float']>;
  customerApplicationFeeUnitAmount?: Maybe<Scalars['Float']>;
  customerPlatformFeeUnitAmount?: Maybe<Scalars['Float']>;
  customerProcessingFeeUnitAmount?: Maybe<Scalars['Float']>;
  orderSubtotalUnitAmount?: Maybe<Scalars['Float']>;
  orderTotalUnitAmount?: Maybe<Scalars['Float']>;
  paidUnitAmount?: Maybe<Scalars['Float']>;
  refundUnitAmount?: Maybe<Scalars['Float']>;
  sellerApplicationFeeUnitAmount?: Maybe<Scalars['Float']>;
  sellerPlatformFeeUnitAmount?: Maybe<Scalars['Float']>;
  sellerProcessingFeeUnitAmount?: Maybe<Scalars['Float']>;
  transferUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "event_transactions" */
export type EventTransactionsVarSampOrderBy = {
  applicationFeeTotalUnitAmount?: InputMaybe<OrderBy>;
  customerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  customerPlatformFeeUnitAmount?: InputMaybe<OrderBy>;
  customerProcessingFeeUnitAmount?: InputMaybe<OrderBy>;
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  sellerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  sellerPlatformFeeUnitAmount?: InputMaybe<OrderBy>;
  sellerProcessingFeeUnitAmount?: InputMaybe<OrderBy>;
  transferUnitAmount?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type EventTransactionsVarianceFields = {
  __typename?: 'EventTransactionsVarianceFields';
  applicationFeeTotalUnitAmount?: Maybe<Scalars['Float']>;
  customerApplicationFeeUnitAmount?: Maybe<Scalars['Float']>;
  customerPlatformFeeUnitAmount?: Maybe<Scalars['Float']>;
  customerProcessingFeeUnitAmount?: Maybe<Scalars['Float']>;
  orderSubtotalUnitAmount?: Maybe<Scalars['Float']>;
  orderTotalUnitAmount?: Maybe<Scalars['Float']>;
  paidUnitAmount?: Maybe<Scalars['Float']>;
  refundUnitAmount?: Maybe<Scalars['Float']>;
  sellerApplicationFeeUnitAmount?: Maybe<Scalars['Float']>;
  sellerPlatformFeeUnitAmount?: Maybe<Scalars['Float']>;
  sellerProcessingFeeUnitAmount?: Maybe<Scalars['Float']>;
  transferUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "event_transactions" */
export type EventTransactionsVarianceOrderBy = {
  applicationFeeTotalUnitAmount?: InputMaybe<OrderBy>;
  customerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  customerPlatformFeeUnitAmount?: InputMaybe<OrderBy>;
  customerProcessingFeeUnitAmount?: InputMaybe<OrderBy>;
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  sellerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  sellerPlatformFeeUnitAmount?: InputMaybe<OrderBy>;
  sellerProcessingFeeUnitAmount?: InputMaybe<OrderBy>;
  transferUnitAmount?: InputMaybe<OrderBy>;
};

/** columns and relationships of "event_types" */
export type EventTypes = {
  __typename?: 'EventTypes';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "event_types" */
export type EventTypesAggregate = {
  __typename?: 'EventTypesAggregate';
  aggregate?: Maybe<EventTypesAggregateFields>;
  nodes: Array<EventTypes>;
};

/** aggregate fields of "event_types" */
export type EventTypesAggregateFields = {
  __typename?: 'EventTypesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<EventTypesMaxFields>;
  min?: Maybe<EventTypesMinFields>;
};


/** aggregate fields of "event_types" */
export type EventTypesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EventTypesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "event_types". All fields are combined with a logical 'AND'. */
export type EventTypesBoolExp = {
  _and?: InputMaybe<Array<EventTypesBoolExp>>;
  _not?: InputMaybe<EventTypesBoolExp>;
  _or?: InputMaybe<Array<EventTypesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "event_types" */
export enum EventTypesConstraint {
  /** unique or primary key constraint on columns "value" */
  EventTypesPkey = 'event_types_pkey'
}

export enum EventTypesEnum {
  GeneralEvent = 'GENERAL_EVENT',
  League = 'LEAGUE',
  OpenPlay = 'OPEN_PLAY',
  Social = 'SOCIAL',
  Tournament = 'TOURNAMENT'
}

/** Boolean expression to compare columns of type "EventTypesEnum". All fields are combined with logical 'AND'. */
export type EventTypesEnumComparisonExp = {
  _eq?: InputMaybe<EventTypesEnum>;
  _in?: InputMaybe<Array<EventTypesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<EventTypesEnum>;
  _nin?: InputMaybe<Array<EventTypesEnum>>;
};

/** input type for inserting data into table "event_types" */
export type EventTypesInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type EventTypesMaxFields = {
  __typename?: 'EventTypesMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type EventTypesMinFields = {
  __typename?: 'EventTypesMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "event_types" */
export type EventTypesMutationResponse = {
  __typename?: 'EventTypesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventTypes>;
};

/** on_conflict condition type for table "event_types" */
export type EventTypesOnConflict = {
  constraint: EventTypesConstraint;
  updateColumns?: Array<EventTypesUpdateColumn>;
  where?: InputMaybe<EventTypesBoolExp>;
};

/** Ordering options when selecting data from "event_types". */
export type EventTypesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: event_types */
export type EventTypesPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "event_types" */
export enum EventTypesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "event_types" */
export type EventTypesSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "event_types" */
export type EventTypesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventTypesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventTypesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "event_types" */
export enum EventTypesUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type EventTypesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventTypesSetInput>;
  /** filter the rows which have to be updated */
  where: EventTypesBoolExp;
};

/** columns and relationships of "events" */
export type Events = {
  __typename?: 'Events';
  /** An array relationship */
  acceptedPlayRequests: Array<EventAcceptedPlayRequests>;
  /** An aggregate relationship */
  acceptedPlayRequestsAggregate: EventAcceptedPlayRequestsAggregate;
  addressString?: Maybe<Scalars['String']>;
  archivedAt?: Maybe<Scalars['timestamptz']>;
  ballCustomName: Scalars['String'];
  ballType: BallTypesEnum;
  cancelReason: Scalars['String'];
  canceledAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  city?: Maybe<Cities>;
  cityId?: Maybe<Scalars['uuid']>;
  cityString: Scalars['String'];
  /** An object relationship */
  community?: Maybe<Groups>;
  communityGroupId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  contactDetails?: Maybe<EventContactDetails>;
  /** An array relationship */
  conversations: Array<Conversations>;
  /** An aggregate relationship */
  conversationsAggregate: ConversationsAggregate;
  countryString: Scalars['String'];
  /** An array relationship */
  coupons: Array<EventCoupons>;
  /** An aggregate relationship */
  couponsAggregate: EventCouponsAggregate;
  courtCostPerPlayerUnitAmount?: Maybe<Scalars['Int']>;
  /** An array relationship */
  courts: Array<EventCourts>;
  /** An aggregate relationship */
  courtsAggregate: EventCourtsAggregate;
  coverImageFileName?: Maybe<Scalars['String']>;
  coverImageFileType?: Maybe<Scalars['String']>;
  coverImageHost?: Maybe<Scalars['String']>;
  coverImageOriginalFileName?: Maybe<Scalars['String']>;
  coverImagePath?: Maybe<Scalars['String']>;
  coverImageProvider?: Maybe<Scalars['String']>;
  coverImageProviderUrl?: Maybe<Scalars['String']>;
  coverImageUrl?: Maybe<Scalars['String']>;
  createdAt: Scalars['timestamptz'];
  currency: Scalars['String'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  description: Scalars['String'];
  /** Fallback for when we don't have a city_id */
  displayLocation: Scalars['String'];
  endDate: Scalars['date'];
  endDateTime: Scalars['timestamptz'];
  /** An object relationship */
  eventCollection?: Maybe<EventCollections>;
  eventCollectionId?: Maybe<Scalars['uuid']>;
  externalUrl?: Maybe<Scalars['String']>;
  /** An array relationship */
  faqs: Array<EventFaqs>;
  /** An aggregate relationship */
  faqsAggregate: EventFaqsAggregate;
  geometry?: Maybe<Scalars['geography']>;
  groupFormat?: Maybe<EventGroupFormatsEnum>;
  /** An array relationship */
  groups: Array<EventGroups>;
  /** An aggregate relationship */
  groupsAggregate: EventGroupsAggregate;
  hasPrizes: Scalars['Boolean'];
  /** An object relationship */
  hostUser?: Maybe<Users>;
  hostUserId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  hostUserProfile?: Maybe<UserProfiles>;
  id: Scalars['uuid'];
  intendedAgeGroup?: Maybe<EventAgeGroupsEnum>;
  /** An array relationship */
  invitations: Array<EventInvitations>;
  /** An aggregate relationship */
  invitationsAggregate: EventInvitationsAggregate;
  isCourtBooked?: Maybe<Scalars['Boolean']>;
  isExternal: Scalars['Boolean'];
  isPlayerListed: Scalars['Boolean'];
  isQuickCreate: Scalars['Boolean'];
  isRatingRequired: Scalars['Boolean'];
  isRegisterOffPlatform: Scalars['Boolean'];
  isRfx: Scalars['Boolean'];
  isSanctioned: Scalars['Boolean'];
  isShowCourtAssignments: Scalars['Boolean'];
  isShowPlayersGoing: Scalars['Boolean'];
  isVairRequired?: Maybe<Scalars['Boolean']>;
  latitude?: Maybe<Scalars['numeric']>;
  /** An array relationship */
  listingFees: Array<EventListingFees>;
  /** An aggregate relationship */
  listingFeesAggregate: EventListingFeesAggregate;
  locale: Scalars['String'];
  longitude?: Maybe<Scalars['numeric']>;
  numberOfCourts?: Maybe<Scalars['numeric']>;
  organizerImageFileName?: Maybe<Scalars['String']>;
  organizerImageFileType?: Maybe<Scalars['String']>;
  organizerImageHost?: Maybe<Scalars['String']>;
  organizerImageOriginalFileName?: Maybe<Scalars['String']>;
  organizerImagePath?: Maybe<Scalars['String']>;
  organizerImageProvider?: Maybe<Scalars['String']>;
  organizerImageProviderUrl?: Maybe<Scalars['String']>;
  /** Note: Use this if it exists, otherwise check the organizer's profile to use their logo */
  organizerImageUrl?: Maybe<Scalars['String']>;
  padelRatingScaleId?: Maybe<Scalars['uuid']>;
  participantLimit?: Maybe<Scalars['Int']>;
  paymentFulfillmentChannel: PaymentFulfillmentChannelsEnum;
  /** An object relationship */
  pickleballRatingScale?: Maybe<PickleballRatingScales>;
  pickleballRatingScaleId?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  playRequests: Array<PlayRequests>;
  /** An aggregate relationship */
  playRequestsAggregate: PlayRequestsAggregate;
  privacy: EventPrivacyEnum;
  prizeDescription: Scalars['String'];
  publishedAt?: Maybe<Scalars['timestamptz']>;
  regionString: Scalars['String'];
  registrationClosedAt?: Maybe<Scalars['timestamptz']>;
  registrationDeadlineDate: Scalars['date'];
  registrationDeadlineDateTime?: Maybe<Scalars['timestamptz']>;
  registrationOpenDate?: Maybe<Scalars['date']>;
  registrationOpenDateTime?: Maybe<Scalars['timestamptz']>;
  registrationPriceUnitAmount: Scalars['Int'];
  /** An array relationship */
  registrations: Array<EventRegistrations>;
  /** An aggregate relationship */
  registrationsAggregate: EventRegistrationsAggregate;
  scheduleInfo?: Maybe<Scalars['String']>;
  scoringFormat?: Maybe<ScoringFormatEnum>;
  showInPublicDate?: Maybe<Scalars['date']>;
  showInPublicDateTime?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  skillLevels: Array<EventSkillLevels>;
  /** An aggregate relationship */
  skillLevelsAggregate: EventSkillLevelsAggregate;
  slug: Scalars['String'];
  source?: Maybe<Scalars['String']>;
  sourceEventId?: Maybe<Scalars['String']>;
  sourceId?: Maybe<Scalars['String']>;
  sourceIsAdvertiseOnly: Scalars['Boolean'];
  sourceIsFeatured: Scalars['Boolean'];
  sourceIsFeaturedPlus: Scalars['Boolean'];
  sourceLocationCity?: Maybe<Scalars['String']>;
  sourceLocationCountry?: Maybe<Scalars['String']>;
  sourceLocationState?: Maybe<Scalars['String']>;
  sourceLocationStreetAddress?: Maybe<Scalars['String']>;
  sourceLocationZip?: Maybe<Scalars['String']>;
  sourceLogoUrl?: Maybe<Scalars['String']>;
  sourceOrganizerId?: Maybe<Scalars['String']>;
  sourceOrganizerImageUrl?: Maybe<Scalars['String']>;
  sourceOrganizerTitle?: Maybe<Scalars['String']>;
  sourceRegistrationCount: Scalars['Int'];
  sourceVenueTitle?: Maybe<Scalars['String']>;
  /** An array relationship */
  sponsors: Array<EventSponsors>;
  /** An aggregate relationship */
  sponsorsAggregate: EventSponsorsAggregate;
  sport: SportsEnum;
  startDate: Scalars['date'];
  startDateTime: Scalars['timestamptz'];
  status: EventStatusesEnum;
  streetPrimaryString: Scalars['String'];
  streetSecondaryString: Scalars['String'];
  /** An object relationship */
  tennisRatingScale?: Maybe<TennisRatingScales>;
  tennisRatingScaleId?: Maybe<Scalars['uuid']>;
  timezoneAbbreviation: Scalars['String'];
  timezoneName: Scalars['String'];
  timezoneOffsetMinutes: Scalars['Int'];
  title: Scalars['String'];
  /** An array relationship */
  transactions: Array<EventTransactions>;
  /** An aggregate relationship */
  transactionsAggregate: EventTransactionsAggregate;
  type: EventTypesEnum;
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  venue?: Maybe<Venues>;
  venueId?: Maybe<Scalars['uuid']>;
  zipcodeString: Scalars['String'];
};


/** columns and relationships of "events" */
export type EventsAcceptedPlayRequestsArgs = {
  distinctOn?: InputMaybe<Array<EventAcceptedPlayRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventAcceptedPlayRequestsOrderBy>>;
  where?: InputMaybe<EventAcceptedPlayRequestsBoolExp>;
};


/** columns and relationships of "events" */
export type EventsAcceptedPlayRequestsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventAcceptedPlayRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventAcceptedPlayRequestsOrderBy>>;
  where?: InputMaybe<EventAcceptedPlayRequestsBoolExp>;
};


/** columns and relationships of "events" */
export type EventsConversationsArgs = {
  distinctOn?: InputMaybe<Array<ConversationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ConversationsOrderBy>>;
  where?: InputMaybe<ConversationsBoolExp>;
};


/** columns and relationships of "events" */
export type EventsConversationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ConversationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ConversationsOrderBy>>;
  where?: InputMaybe<ConversationsBoolExp>;
};


/** columns and relationships of "events" */
export type EventsCouponsArgs = {
  distinctOn?: InputMaybe<Array<EventCouponsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventCouponsOrderBy>>;
  where?: InputMaybe<EventCouponsBoolExp>;
};


/** columns and relationships of "events" */
export type EventsCouponsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventCouponsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventCouponsOrderBy>>;
  where?: InputMaybe<EventCouponsBoolExp>;
};


/** columns and relationships of "events" */
export type EventsCourtsArgs = {
  distinctOn?: InputMaybe<Array<EventCourtsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventCourtsOrderBy>>;
  where?: InputMaybe<EventCourtsBoolExp>;
};


/** columns and relationships of "events" */
export type EventsCourtsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventCourtsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventCourtsOrderBy>>;
  where?: InputMaybe<EventCourtsBoolExp>;
};


/** columns and relationships of "events" */
export type EventsFaqsArgs = {
  distinctOn?: InputMaybe<Array<EventFaqsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventFaqsOrderBy>>;
  where?: InputMaybe<EventFaqsBoolExp>;
};


/** columns and relationships of "events" */
export type EventsFaqsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventFaqsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventFaqsOrderBy>>;
  where?: InputMaybe<EventFaqsBoolExp>;
};


/** columns and relationships of "events" */
export type EventsGroupsArgs = {
  distinctOn?: InputMaybe<Array<EventGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGroupsOrderBy>>;
  where?: InputMaybe<EventGroupsBoolExp>;
};


/** columns and relationships of "events" */
export type EventsGroupsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGroupsOrderBy>>;
  where?: InputMaybe<EventGroupsBoolExp>;
};


/** columns and relationships of "events" */
export type EventsInvitationsArgs = {
  distinctOn?: InputMaybe<Array<EventInvitationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventInvitationsOrderBy>>;
  where?: InputMaybe<EventInvitationsBoolExp>;
};


/** columns and relationships of "events" */
export type EventsInvitationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventInvitationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventInvitationsOrderBy>>;
  where?: InputMaybe<EventInvitationsBoolExp>;
};


/** columns and relationships of "events" */
export type EventsListingFeesArgs = {
  distinctOn?: InputMaybe<Array<EventListingFeesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventListingFeesOrderBy>>;
  where?: InputMaybe<EventListingFeesBoolExp>;
};


/** columns and relationships of "events" */
export type EventsListingFeesAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventListingFeesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventListingFeesOrderBy>>;
  where?: InputMaybe<EventListingFeesBoolExp>;
};


/** columns and relationships of "events" */
export type EventsPlayRequestsArgs = {
  distinctOn?: InputMaybe<Array<PlayRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayRequestsOrderBy>>;
  where?: InputMaybe<PlayRequestsBoolExp>;
};


/** columns and relationships of "events" */
export type EventsPlayRequestsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PlayRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayRequestsOrderBy>>;
  where?: InputMaybe<PlayRequestsBoolExp>;
};


/** columns and relationships of "events" */
export type EventsRegistrationsArgs = {
  distinctOn?: InputMaybe<Array<EventRegistrationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventRegistrationsOrderBy>>;
  where?: InputMaybe<EventRegistrationsBoolExp>;
};


/** columns and relationships of "events" */
export type EventsRegistrationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventRegistrationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventRegistrationsOrderBy>>;
  where?: InputMaybe<EventRegistrationsBoolExp>;
};


/** columns and relationships of "events" */
export type EventsSkillLevelsArgs = {
  distinctOn?: InputMaybe<Array<EventSkillLevelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventSkillLevelsOrderBy>>;
  where?: InputMaybe<EventSkillLevelsBoolExp>;
};


/** columns and relationships of "events" */
export type EventsSkillLevelsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventSkillLevelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventSkillLevelsOrderBy>>;
  where?: InputMaybe<EventSkillLevelsBoolExp>;
};


/** columns and relationships of "events" */
export type EventsSponsorsArgs = {
  distinctOn?: InputMaybe<Array<EventSponsorsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventSponsorsOrderBy>>;
  where?: InputMaybe<EventSponsorsBoolExp>;
};


/** columns and relationships of "events" */
export type EventsSponsorsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventSponsorsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventSponsorsOrderBy>>;
  where?: InputMaybe<EventSponsorsBoolExp>;
};


/** columns and relationships of "events" */
export type EventsTransactionsArgs = {
  distinctOn?: InputMaybe<Array<EventTransactionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventTransactionsOrderBy>>;
  where?: InputMaybe<EventTransactionsBoolExp>;
};


/** columns and relationships of "events" */
export type EventsTransactionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventTransactionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventTransactionsOrderBy>>;
  where?: InputMaybe<EventTransactionsBoolExp>;
};

/** aggregated selection of "events" */
export type EventsAggregate = {
  __typename?: 'EventsAggregate';
  aggregate?: Maybe<EventsAggregateFields>;
  nodes: Array<Events>;
};

export type EventsAggregateBoolExp = {
  bool_and?: InputMaybe<EventsAggregateBoolExpBool_And>;
  bool_or?: InputMaybe<EventsAggregateBoolExpBool_Or>;
  count?: InputMaybe<EventsAggregateBoolExpCount>;
};

/** aggregate fields of "events" */
export type EventsAggregateFields = {
  __typename?: 'EventsAggregateFields';
  avg?: Maybe<EventsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<EventsMaxFields>;
  min?: Maybe<EventsMinFields>;
  stddev?: Maybe<EventsStddevFields>;
  stddevPop?: Maybe<EventsStddevPopFields>;
  stddevSamp?: Maybe<EventsStddevSampFields>;
  sum?: Maybe<EventsSumFields>;
  varPop?: Maybe<EventsVarPopFields>;
  varSamp?: Maybe<EventsVarSampFields>;
  variance?: Maybe<EventsVarianceFields>;
};


/** aggregate fields of "events" */
export type EventsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EventsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "events" */
export type EventsAggregateOrderBy = {
  avg?: InputMaybe<EventsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EventsMaxOrderBy>;
  min?: InputMaybe<EventsMinOrderBy>;
  stddev?: InputMaybe<EventsStddevOrderBy>;
  stddevPop?: InputMaybe<EventsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<EventsStddevSampOrderBy>;
  sum?: InputMaybe<EventsSumOrderBy>;
  varPop?: InputMaybe<EventsVarPopOrderBy>;
  varSamp?: InputMaybe<EventsVarSampOrderBy>;
  variance?: InputMaybe<EventsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "events" */
export type EventsArrRelInsertInput = {
  data: Array<EventsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<EventsOnConflict>;
};

/** aggregate avg on columns */
export type EventsAvgFields = {
  __typename?: 'EventsAvgFields';
  courtCostPerPlayerUnitAmount?: Maybe<Scalars['Float']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  numberOfCourts?: Maybe<Scalars['Float']>;
  participantLimit?: Maybe<Scalars['Float']>;
  registrationPriceUnitAmount?: Maybe<Scalars['Float']>;
  sourceRegistrationCount?: Maybe<Scalars['Float']>;
  timezoneOffsetMinutes?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "events" */
export type EventsAvgOrderBy = {
  courtCostPerPlayerUnitAmount?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  numberOfCourts?: InputMaybe<OrderBy>;
  participantLimit?: InputMaybe<OrderBy>;
  registrationPriceUnitAmount?: InputMaybe<OrderBy>;
  sourceRegistrationCount?: InputMaybe<OrderBy>;
  timezoneOffsetMinutes?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "events". All fields are combined with a logical 'AND'. */
export type EventsBoolExp = {
  _and?: InputMaybe<Array<EventsBoolExp>>;
  _not?: InputMaybe<EventsBoolExp>;
  _or?: InputMaybe<Array<EventsBoolExp>>;
  acceptedPlayRequests?: InputMaybe<EventAcceptedPlayRequestsBoolExp>;
  acceptedPlayRequestsAggregate?: InputMaybe<EventAcceptedPlayRequestsAggregateBoolExp>;
  addressString?: InputMaybe<StringComparisonExp>;
  archivedAt?: InputMaybe<TimestamptzComparisonExp>;
  ballCustomName?: InputMaybe<StringComparisonExp>;
  ballType?: InputMaybe<BallTypesEnumComparisonExp>;
  cancelReason?: InputMaybe<StringComparisonExp>;
  canceledAt?: InputMaybe<TimestamptzComparisonExp>;
  city?: InputMaybe<CitiesBoolExp>;
  cityId?: InputMaybe<UuidComparisonExp>;
  cityString?: InputMaybe<StringComparisonExp>;
  community?: InputMaybe<GroupsBoolExp>;
  communityGroupId?: InputMaybe<UuidComparisonExp>;
  contactDetails?: InputMaybe<EventContactDetailsBoolExp>;
  conversations?: InputMaybe<ConversationsBoolExp>;
  conversationsAggregate?: InputMaybe<ConversationsAggregateBoolExp>;
  countryString?: InputMaybe<StringComparisonExp>;
  coupons?: InputMaybe<EventCouponsBoolExp>;
  couponsAggregate?: InputMaybe<EventCouponsAggregateBoolExp>;
  courtCostPerPlayerUnitAmount?: InputMaybe<IntComparisonExp>;
  courts?: InputMaybe<EventCourtsBoolExp>;
  courtsAggregate?: InputMaybe<EventCourtsAggregateBoolExp>;
  coverImageFileName?: InputMaybe<StringComparisonExp>;
  coverImageFileType?: InputMaybe<StringComparisonExp>;
  coverImageHost?: InputMaybe<StringComparisonExp>;
  coverImageOriginalFileName?: InputMaybe<StringComparisonExp>;
  coverImagePath?: InputMaybe<StringComparisonExp>;
  coverImageProvider?: InputMaybe<StringComparisonExp>;
  coverImageProviderUrl?: InputMaybe<StringComparisonExp>;
  coverImageUrl?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  currency?: InputMaybe<StringComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  displayLocation?: InputMaybe<StringComparisonExp>;
  endDate?: InputMaybe<DateComparisonExp>;
  endDateTime?: InputMaybe<TimestamptzComparisonExp>;
  eventCollection?: InputMaybe<EventCollectionsBoolExp>;
  eventCollectionId?: InputMaybe<UuidComparisonExp>;
  externalUrl?: InputMaybe<StringComparisonExp>;
  faqs?: InputMaybe<EventFaqsBoolExp>;
  faqsAggregate?: InputMaybe<EventFaqsAggregateBoolExp>;
  geometry?: InputMaybe<GeographyComparisonExp>;
  groupFormat?: InputMaybe<EventGroupFormatsEnumComparisonExp>;
  groups?: InputMaybe<EventGroupsBoolExp>;
  groupsAggregate?: InputMaybe<EventGroupsAggregateBoolExp>;
  hasPrizes?: InputMaybe<BooleanComparisonExp>;
  hostUser?: InputMaybe<UsersBoolExp>;
  hostUserId?: InputMaybe<UuidComparisonExp>;
  hostUserProfile?: InputMaybe<UserProfilesBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  intendedAgeGroup?: InputMaybe<EventAgeGroupsEnumComparisonExp>;
  invitations?: InputMaybe<EventInvitationsBoolExp>;
  invitationsAggregate?: InputMaybe<EventInvitationsAggregateBoolExp>;
  isCourtBooked?: InputMaybe<BooleanComparisonExp>;
  isExternal?: InputMaybe<BooleanComparisonExp>;
  isPlayerListed?: InputMaybe<BooleanComparisonExp>;
  isQuickCreate?: InputMaybe<BooleanComparisonExp>;
  isRatingRequired?: InputMaybe<BooleanComparisonExp>;
  isRegisterOffPlatform?: InputMaybe<BooleanComparisonExp>;
  isRfx?: InputMaybe<BooleanComparisonExp>;
  isSanctioned?: InputMaybe<BooleanComparisonExp>;
  isShowCourtAssignments?: InputMaybe<BooleanComparisonExp>;
  isShowPlayersGoing?: InputMaybe<BooleanComparisonExp>;
  isVairRequired?: InputMaybe<BooleanComparisonExp>;
  latitude?: InputMaybe<NumericComparisonExp>;
  listingFees?: InputMaybe<EventListingFeesBoolExp>;
  listingFeesAggregate?: InputMaybe<EventListingFeesAggregateBoolExp>;
  locale?: InputMaybe<StringComparisonExp>;
  longitude?: InputMaybe<NumericComparisonExp>;
  numberOfCourts?: InputMaybe<NumericComparisonExp>;
  organizerImageFileName?: InputMaybe<StringComparisonExp>;
  organizerImageFileType?: InputMaybe<StringComparisonExp>;
  organizerImageHost?: InputMaybe<StringComparisonExp>;
  organizerImageOriginalFileName?: InputMaybe<StringComparisonExp>;
  organizerImagePath?: InputMaybe<StringComparisonExp>;
  organizerImageProvider?: InputMaybe<StringComparisonExp>;
  organizerImageProviderUrl?: InputMaybe<StringComparisonExp>;
  organizerImageUrl?: InputMaybe<StringComparisonExp>;
  padelRatingScaleId?: InputMaybe<UuidComparisonExp>;
  participantLimit?: InputMaybe<IntComparisonExp>;
  paymentFulfillmentChannel?: InputMaybe<PaymentFulfillmentChannelsEnumComparisonExp>;
  pickleballRatingScale?: InputMaybe<PickleballRatingScalesBoolExp>;
  pickleballRatingScaleId?: InputMaybe<UuidComparisonExp>;
  playRequests?: InputMaybe<PlayRequestsBoolExp>;
  playRequestsAggregate?: InputMaybe<PlayRequestsAggregateBoolExp>;
  privacy?: InputMaybe<EventPrivacyEnumComparisonExp>;
  prizeDescription?: InputMaybe<StringComparisonExp>;
  publishedAt?: InputMaybe<TimestamptzComparisonExp>;
  regionString?: InputMaybe<StringComparisonExp>;
  registrationClosedAt?: InputMaybe<TimestamptzComparisonExp>;
  registrationDeadlineDate?: InputMaybe<DateComparisonExp>;
  registrationDeadlineDateTime?: InputMaybe<TimestamptzComparisonExp>;
  registrationOpenDate?: InputMaybe<DateComparisonExp>;
  registrationOpenDateTime?: InputMaybe<TimestamptzComparisonExp>;
  registrationPriceUnitAmount?: InputMaybe<IntComparisonExp>;
  registrations?: InputMaybe<EventRegistrationsBoolExp>;
  registrationsAggregate?: InputMaybe<EventRegistrationsAggregateBoolExp>;
  scheduleInfo?: InputMaybe<StringComparisonExp>;
  scoringFormat?: InputMaybe<ScoringFormatEnumComparisonExp>;
  showInPublicDate?: InputMaybe<DateComparisonExp>;
  showInPublicDateTime?: InputMaybe<TimestamptzComparisonExp>;
  skillLevels?: InputMaybe<EventSkillLevelsBoolExp>;
  skillLevelsAggregate?: InputMaybe<EventSkillLevelsAggregateBoolExp>;
  slug?: InputMaybe<StringComparisonExp>;
  source?: InputMaybe<StringComparisonExp>;
  sourceEventId?: InputMaybe<StringComparisonExp>;
  sourceId?: InputMaybe<StringComparisonExp>;
  sourceIsAdvertiseOnly?: InputMaybe<BooleanComparisonExp>;
  sourceIsFeatured?: InputMaybe<BooleanComparisonExp>;
  sourceIsFeaturedPlus?: InputMaybe<BooleanComparisonExp>;
  sourceLocationCity?: InputMaybe<StringComparisonExp>;
  sourceLocationCountry?: InputMaybe<StringComparisonExp>;
  sourceLocationState?: InputMaybe<StringComparisonExp>;
  sourceLocationStreetAddress?: InputMaybe<StringComparisonExp>;
  sourceLocationZip?: InputMaybe<StringComparisonExp>;
  sourceLogoUrl?: InputMaybe<StringComparisonExp>;
  sourceOrganizerId?: InputMaybe<StringComparisonExp>;
  sourceOrganizerImageUrl?: InputMaybe<StringComparisonExp>;
  sourceOrganizerTitle?: InputMaybe<StringComparisonExp>;
  sourceRegistrationCount?: InputMaybe<IntComparisonExp>;
  sourceVenueTitle?: InputMaybe<StringComparisonExp>;
  sponsors?: InputMaybe<EventSponsorsBoolExp>;
  sponsorsAggregate?: InputMaybe<EventSponsorsAggregateBoolExp>;
  sport?: InputMaybe<SportsEnumComparisonExp>;
  startDate?: InputMaybe<DateComparisonExp>;
  startDateTime?: InputMaybe<TimestamptzComparisonExp>;
  status?: InputMaybe<EventStatusesEnumComparisonExp>;
  streetPrimaryString?: InputMaybe<StringComparisonExp>;
  streetSecondaryString?: InputMaybe<StringComparisonExp>;
  tennisRatingScale?: InputMaybe<TennisRatingScalesBoolExp>;
  tennisRatingScaleId?: InputMaybe<UuidComparisonExp>;
  timezoneAbbreviation?: InputMaybe<StringComparisonExp>;
  timezoneName?: InputMaybe<StringComparisonExp>;
  timezoneOffsetMinutes?: InputMaybe<IntComparisonExp>;
  title?: InputMaybe<StringComparisonExp>;
  transactions?: InputMaybe<EventTransactionsBoolExp>;
  transactionsAggregate?: InputMaybe<EventTransactionsAggregateBoolExp>;
  type?: InputMaybe<EventTypesEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  venue?: InputMaybe<VenuesBoolExp>;
  venueId?: InputMaybe<UuidComparisonExp>;
  zipcodeString?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "events" */
export enum EventsConstraint {
  /** unique or primary key constraint on columns "id" */
  EventsPkey = 'events_pkey',
  /** unique or primary key constraint on columns "slug" */
  EventsSlugKey = 'events_slug_key',
  /** unique or primary key constraint on columns "source_id" */
  EventsSourceIdKey = 'events_source_id_key'
}

/** input type for incrementing numeric columns in table "events" */
export type EventsIncInput = {
  courtCostPerPlayerUnitAmount?: InputMaybe<Scalars['Int']>;
  latitude?: InputMaybe<Scalars['numeric']>;
  longitude?: InputMaybe<Scalars['numeric']>;
  numberOfCourts?: InputMaybe<Scalars['numeric']>;
  participantLimit?: InputMaybe<Scalars['Int']>;
  registrationPriceUnitAmount?: InputMaybe<Scalars['Int']>;
  sourceRegistrationCount?: InputMaybe<Scalars['Int']>;
  timezoneOffsetMinutes?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "events" */
export type EventsInsertInput = {
  acceptedPlayRequests?: InputMaybe<EventAcceptedPlayRequestsArrRelInsertInput>;
  addressString?: InputMaybe<Scalars['String']>;
  archivedAt?: InputMaybe<Scalars['timestamptz']>;
  ballCustomName?: InputMaybe<Scalars['String']>;
  ballType?: InputMaybe<BallTypesEnum>;
  cancelReason?: InputMaybe<Scalars['String']>;
  canceledAt?: InputMaybe<Scalars['timestamptz']>;
  city?: InputMaybe<CitiesObjRelInsertInput>;
  cityId?: InputMaybe<Scalars['uuid']>;
  cityString?: InputMaybe<Scalars['String']>;
  community?: InputMaybe<GroupsObjRelInsertInput>;
  communityGroupId?: InputMaybe<Scalars['uuid']>;
  contactDetails?: InputMaybe<EventContactDetailsObjRelInsertInput>;
  conversations?: InputMaybe<ConversationsArrRelInsertInput>;
  countryString?: InputMaybe<Scalars['String']>;
  coupons?: InputMaybe<EventCouponsArrRelInsertInput>;
  courtCostPerPlayerUnitAmount?: InputMaybe<Scalars['Int']>;
  courts?: InputMaybe<EventCourtsArrRelInsertInput>;
  coverImageFileName?: InputMaybe<Scalars['String']>;
  coverImageFileType?: InputMaybe<Scalars['String']>;
  coverImageHost?: InputMaybe<Scalars['String']>;
  coverImageOriginalFileName?: InputMaybe<Scalars['String']>;
  coverImagePath?: InputMaybe<Scalars['String']>;
  coverImageProvider?: InputMaybe<Scalars['String']>;
  coverImageProviderUrl?: InputMaybe<Scalars['String']>;
  coverImageUrl?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  /** Fallback for when we don't have a city_id */
  displayLocation?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['date']>;
  endDateTime?: InputMaybe<Scalars['timestamptz']>;
  eventCollection?: InputMaybe<EventCollectionsObjRelInsertInput>;
  eventCollectionId?: InputMaybe<Scalars['uuid']>;
  externalUrl?: InputMaybe<Scalars['String']>;
  faqs?: InputMaybe<EventFaqsArrRelInsertInput>;
  geometry?: InputMaybe<Scalars['geography']>;
  groupFormat?: InputMaybe<EventGroupFormatsEnum>;
  groups?: InputMaybe<EventGroupsArrRelInsertInput>;
  hasPrizes?: InputMaybe<Scalars['Boolean']>;
  hostUser?: InputMaybe<UsersObjRelInsertInput>;
  hostUserId?: InputMaybe<Scalars['uuid']>;
  hostUserProfile?: InputMaybe<UserProfilesObjRelInsertInput>;
  id?: InputMaybe<Scalars['uuid']>;
  intendedAgeGroup?: InputMaybe<EventAgeGroupsEnum>;
  invitations?: InputMaybe<EventInvitationsArrRelInsertInput>;
  isCourtBooked?: InputMaybe<Scalars['Boolean']>;
  isExternal?: InputMaybe<Scalars['Boolean']>;
  isPlayerListed?: InputMaybe<Scalars['Boolean']>;
  isQuickCreate?: InputMaybe<Scalars['Boolean']>;
  isRatingRequired?: InputMaybe<Scalars['Boolean']>;
  isRegisterOffPlatform?: InputMaybe<Scalars['Boolean']>;
  isRfx?: InputMaybe<Scalars['Boolean']>;
  isSanctioned?: InputMaybe<Scalars['Boolean']>;
  isShowCourtAssignments?: InputMaybe<Scalars['Boolean']>;
  isShowPlayersGoing?: InputMaybe<Scalars['Boolean']>;
  isVairRequired?: InputMaybe<Scalars['Boolean']>;
  latitude?: InputMaybe<Scalars['numeric']>;
  listingFees?: InputMaybe<EventListingFeesArrRelInsertInput>;
  locale?: InputMaybe<Scalars['String']>;
  longitude?: InputMaybe<Scalars['numeric']>;
  numberOfCourts?: InputMaybe<Scalars['numeric']>;
  organizerImageFileName?: InputMaybe<Scalars['String']>;
  organizerImageFileType?: InputMaybe<Scalars['String']>;
  organizerImageHost?: InputMaybe<Scalars['String']>;
  organizerImageOriginalFileName?: InputMaybe<Scalars['String']>;
  organizerImagePath?: InputMaybe<Scalars['String']>;
  organizerImageProvider?: InputMaybe<Scalars['String']>;
  organizerImageProviderUrl?: InputMaybe<Scalars['String']>;
  /** Note: Use this if it exists, otherwise check the organizer's profile to use their logo */
  organizerImageUrl?: InputMaybe<Scalars['String']>;
  padelRatingScaleId?: InputMaybe<Scalars['uuid']>;
  participantLimit?: InputMaybe<Scalars['Int']>;
  paymentFulfillmentChannel?: InputMaybe<PaymentFulfillmentChannelsEnum>;
  pickleballRatingScale?: InputMaybe<PickleballRatingScalesObjRelInsertInput>;
  pickleballRatingScaleId?: InputMaybe<Scalars['uuid']>;
  playRequests?: InputMaybe<PlayRequestsArrRelInsertInput>;
  privacy?: InputMaybe<EventPrivacyEnum>;
  prizeDescription?: InputMaybe<Scalars['String']>;
  publishedAt?: InputMaybe<Scalars['timestamptz']>;
  regionString?: InputMaybe<Scalars['String']>;
  registrationClosedAt?: InputMaybe<Scalars['timestamptz']>;
  registrationDeadlineDate?: InputMaybe<Scalars['date']>;
  registrationDeadlineDateTime?: InputMaybe<Scalars['timestamptz']>;
  registrationOpenDate?: InputMaybe<Scalars['date']>;
  registrationOpenDateTime?: InputMaybe<Scalars['timestamptz']>;
  registrationPriceUnitAmount?: InputMaybe<Scalars['Int']>;
  registrations?: InputMaybe<EventRegistrationsArrRelInsertInput>;
  scheduleInfo?: InputMaybe<Scalars['String']>;
  scoringFormat?: InputMaybe<ScoringFormatEnum>;
  showInPublicDate?: InputMaybe<Scalars['date']>;
  showInPublicDateTime?: InputMaybe<Scalars['timestamptz']>;
  skillLevels?: InputMaybe<EventSkillLevelsArrRelInsertInput>;
  slug?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  sourceEventId?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  sourceIsAdvertiseOnly?: InputMaybe<Scalars['Boolean']>;
  sourceIsFeatured?: InputMaybe<Scalars['Boolean']>;
  sourceIsFeaturedPlus?: InputMaybe<Scalars['Boolean']>;
  sourceLocationCity?: InputMaybe<Scalars['String']>;
  sourceLocationCountry?: InputMaybe<Scalars['String']>;
  sourceLocationState?: InputMaybe<Scalars['String']>;
  sourceLocationStreetAddress?: InputMaybe<Scalars['String']>;
  sourceLocationZip?: InputMaybe<Scalars['String']>;
  sourceLogoUrl?: InputMaybe<Scalars['String']>;
  sourceOrganizerId?: InputMaybe<Scalars['String']>;
  sourceOrganizerImageUrl?: InputMaybe<Scalars['String']>;
  sourceOrganizerTitle?: InputMaybe<Scalars['String']>;
  sourceRegistrationCount?: InputMaybe<Scalars['Int']>;
  sourceVenueTitle?: InputMaybe<Scalars['String']>;
  sponsors?: InputMaybe<EventSponsorsArrRelInsertInput>;
  sport?: InputMaybe<SportsEnum>;
  startDate?: InputMaybe<Scalars['date']>;
  startDateTime?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<EventStatusesEnum>;
  streetPrimaryString?: InputMaybe<Scalars['String']>;
  streetSecondaryString?: InputMaybe<Scalars['String']>;
  tennisRatingScale?: InputMaybe<TennisRatingScalesObjRelInsertInput>;
  tennisRatingScaleId?: InputMaybe<Scalars['uuid']>;
  timezoneAbbreviation?: InputMaybe<Scalars['String']>;
  timezoneName?: InputMaybe<Scalars['String']>;
  timezoneOffsetMinutes?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  transactions?: InputMaybe<EventTransactionsArrRelInsertInput>;
  type?: InputMaybe<EventTypesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  venue?: InputMaybe<VenuesObjRelInsertInput>;
  venueId?: InputMaybe<Scalars['uuid']>;
  zipcodeString?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type EventsMaxFields = {
  __typename?: 'EventsMaxFields';
  addressString?: Maybe<Scalars['String']>;
  archivedAt?: Maybe<Scalars['timestamptz']>;
  ballCustomName?: Maybe<Scalars['String']>;
  cancelReason?: Maybe<Scalars['String']>;
  canceledAt?: Maybe<Scalars['timestamptz']>;
  cityId?: Maybe<Scalars['uuid']>;
  cityString?: Maybe<Scalars['String']>;
  communityGroupId?: Maybe<Scalars['uuid']>;
  countryString?: Maybe<Scalars['String']>;
  courtCostPerPlayerUnitAmount?: Maybe<Scalars['Int']>;
  coverImageFileName?: Maybe<Scalars['String']>;
  coverImageFileType?: Maybe<Scalars['String']>;
  coverImageHost?: Maybe<Scalars['String']>;
  coverImageOriginalFileName?: Maybe<Scalars['String']>;
  coverImagePath?: Maybe<Scalars['String']>;
  coverImageProvider?: Maybe<Scalars['String']>;
  coverImageProviderUrl?: Maybe<Scalars['String']>;
  coverImageUrl?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  /** Fallback for when we don't have a city_id */
  displayLocation?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['date']>;
  endDateTime?: Maybe<Scalars['timestamptz']>;
  eventCollectionId?: Maybe<Scalars['uuid']>;
  externalUrl?: Maybe<Scalars['String']>;
  hostUserId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  latitude?: Maybe<Scalars['numeric']>;
  locale?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['numeric']>;
  numberOfCourts?: Maybe<Scalars['numeric']>;
  organizerImageFileName?: Maybe<Scalars['String']>;
  organizerImageFileType?: Maybe<Scalars['String']>;
  organizerImageHost?: Maybe<Scalars['String']>;
  organizerImageOriginalFileName?: Maybe<Scalars['String']>;
  organizerImagePath?: Maybe<Scalars['String']>;
  organizerImageProvider?: Maybe<Scalars['String']>;
  organizerImageProviderUrl?: Maybe<Scalars['String']>;
  /** Note: Use this if it exists, otherwise check the organizer's profile to use their logo */
  organizerImageUrl?: Maybe<Scalars['String']>;
  padelRatingScaleId?: Maybe<Scalars['uuid']>;
  participantLimit?: Maybe<Scalars['Int']>;
  pickleballRatingScaleId?: Maybe<Scalars['uuid']>;
  prizeDescription?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['timestamptz']>;
  regionString?: Maybe<Scalars['String']>;
  registrationClosedAt?: Maybe<Scalars['timestamptz']>;
  registrationDeadlineDate?: Maybe<Scalars['date']>;
  registrationDeadlineDateTime?: Maybe<Scalars['timestamptz']>;
  registrationOpenDate?: Maybe<Scalars['date']>;
  registrationOpenDateTime?: Maybe<Scalars['timestamptz']>;
  registrationPriceUnitAmount?: Maybe<Scalars['Int']>;
  scheduleInfo?: Maybe<Scalars['String']>;
  showInPublicDate?: Maybe<Scalars['date']>;
  showInPublicDateTime?: Maybe<Scalars['timestamptz']>;
  slug?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  sourceEventId?: Maybe<Scalars['String']>;
  sourceId?: Maybe<Scalars['String']>;
  sourceLocationCity?: Maybe<Scalars['String']>;
  sourceLocationCountry?: Maybe<Scalars['String']>;
  sourceLocationState?: Maybe<Scalars['String']>;
  sourceLocationStreetAddress?: Maybe<Scalars['String']>;
  sourceLocationZip?: Maybe<Scalars['String']>;
  sourceLogoUrl?: Maybe<Scalars['String']>;
  sourceOrganizerId?: Maybe<Scalars['String']>;
  sourceOrganizerImageUrl?: Maybe<Scalars['String']>;
  sourceOrganizerTitle?: Maybe<Scalars['String']>;
  sourceRegistrationCount?: Maybe<Scalars['Int']>;
  sourceVenueTitle?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['date']>;
  startDateTime?: Maybe<Scalars['timestamptz']>;
  streetPrimaryString?: Maybe<Scalars['String']>;
  streetSecondaryString?: Maybe<Scalars['String']>;
  tennisRatingScaleId?: Maybe<Scalars['uuid']>;
  timezoneAbbreviation?: Maybe<Scalars['String']>;
  timezoneName?: Maybe<Scalars['String']>;
  timezoneOffsetMinutes?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  venueId?: Maybe<Scalars['uuid']>;
  zipcodeString?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "events" */
export type EventsMaxOrderBy = {
  addressString?: InputMaybe<OrderBy>;
  archivedAt?: InputMaybe<OrderBy>;
  ballCustomName?: InputMaybe<OrderBy>;
  cancelReason?: InputMaybe<OrderBy>;
  canceledAt?: InputMaybe<OrderBy>;
  cityId?: InputMaybe<OrderBy>;
  cityString?: InputMaybe<OrderBy>;
  communityGroupId?: InputMaybe<OrderBy>;
  countryString?: InputMaybe<OrderBy>;
  courtCostPerPlayerUnitAmount?: InputMaybe<OrderBy>;
  coverImageFileName?: InputMaybe<OrderBy>;
  coverImageFileType?: InputMaybe<OrderBy>;
  coverImageHost?: InputMaybe<OrderBy>;
  coverImageOriginalFileName?: InputMaybe<OrderBy>;
  coverImagePath?: InputMaybe<OrderBy>;
  coverImageProvider?: InputMaybe<OrderBy>;
  coverImageProviderUrl?: InputMaybe<OrderBy>;
  coverImageUrl?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  currency?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  /** Fallback for when we don't have a city_id */
  displayLocation?: InputMaybe<OrderBy>;
  endDate?: InputMaybe<OrderBy>;
  endDateTime?: InputMaybe<OrderBy>;
  eventCollectionId?: InputMaybe<OrderBy>;
  externalUrl?: InputMaybe<OrderBy>;
  hostUserId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  locale?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  numberOfCourts?: InputMaybe<OrderBy>;
  organizerImageFileName?: InputMaybe<OrderBy>;
  organizerImageFileType?: InputMaybe<OrderBy>;
  organizerImageHost?: InputMaybe<OrderBy>;
  organizerImageOriginalFileName?: InputMaybe<OrderBy>;
  organizerImagePath?: InputMaybe<OrderBy>;
  organizerImageProvider?: InputMaybe<OrderBy>;
  organizerImageProviderUrl?: InputMaybe<OrderBy>;
  /** Note: Use this if it exists, otherwise check the organizer's profile to use their logo */
  organizerImageUrl?: InputMaybe<OrderBy>;
  padelRatingScaleId?: InputMaybe<OrderBy>;
  participantLimit?: InputMaybe<OrderBy>;
  pickleballRatingScaleId?: InputMaybe<OrderBy>;
  prizeDescription?: InputMaybe<OrderBy>;
  publishedAt?: InputMaybe<OrderBy>;
  regionString?: InputMaybe<OrderBy>;
  registrationClosedAt?: InputMaybe<OrderBy>;
  registrationDeadlineDate?: InputMaybe<OrderBy>;
  registrationDeadlineDateTime?: InputMaybe<OrderBy>;
  registrationOpenDate?: InputMaybe<OrderBy>;
  registrationOpenDateTime?: InputMaybe<OrderBy>;
  registrationPriceUnitAmount?: InputMaybe<OrderBy>;
  scheduleInfo?: InputMaybe<OrderBy>;
  showInPublicDate?: InputMaybe<OrderBy>;
  showInPublicDateTime?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  source?: InputMaybe<OrderBy>;
  sourceEventId?: InputMaybe<OrderBy>;
  sourceId?: InputMaybe<OrderBy>;
  sourceLocationCity?: InputMaybe<OrderBy>;
  sourceLocationCountry?: InputMaybe<OrderBy>;
  sourceLocationState?: InputMaybe<OrderBy>;
  sourceLocationStreetAddress?: InputMaybe<OrderBy>;
  sourceLocationZip?: InputMaybe<OrderBy>;
  sourceLogoUrl?: InputMaybe<OrderBy>;
  sourceOrganizerId?: InputMaybe<OrderBy>;
  sourceOrganizerImageUrl?: InputMaybe<OrderBy>;
  sourceOrganizerTitle?: InputMaybe<OrderBy>;
  sourceRegistrationCount?: InputMaybe<OrderBy>;
  sourceVenueTitle?: InputMaybe<OrderBy>;
  startDate?: InputMaybe<OrderBy>;
  startDateTime?: InputMaybe<OrderBy>;
  streetPrimaryString?: InputMaybe<OrderBy>;
  streetSecondaryString?: InputMaybe<OrderBy>;
  tennisRatingScaleId?: InputMaybe<OrderBy>;
  timezoneAbbreviation?: InputMaybe<OrderBy>;
  timezoneName?: InputMaybe<OrderBy>;
  timezoneOffsetMinutes?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  venueId?: InputMaybe<OrderBy>;
  zipcodeString?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type EventsMinFields = {
  __typename?: 'EventsMinFields';
  addressString?: Maybe<Scalars['String']>;
  archivedAt?: Maybe<Scalars['timestamptz']>;
  ballCustomName?: Maybe<Scalars['String']>;
  cancelReason?: Maybe<Scalars['String']>;
  canceledAt?: Maybe<Scalars['timestamptz']>;
  cityId?: Maybe<Scalars['uuid']>;
  cityString?: Maybe<Scalars['String']>;
  communityGroupId?: Maybe<Scalars['uuid']>;
  countryString?: Maybe<Scalars['String']>;
  courtCostPerPlayerUnitAmount?: Maybe<Scalars['Int']>;
  coverImageFileName?: Maybe<Scalars['String']>;
  coverImageFileType?: Maybe<Scalars['String']>;
  coverImageHost?: Maybe<Scalars['String']>;
  coverImageOriginalFileName?: Maybe<Scalars['String']>;
  coverImagePath?: Maybe<Scalars['String']>;
  coverImageProvider?: Maybe<Scalars['String']>;
  coverImageProviderUrl?: Maybe<Scalars['String']>;
  coverImageUrl?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  /** Fallback for when we don't have a city_id */
  displayLocation?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['date']>;
  endDateTime?: Maybe<Scalars['timestamptz']>;
  eventCollectionId?: Maybe<Scalars['uuid']>;
  externalUrl?: Maybe<Scalars['String']>;
  hostUserId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  latitude?: Maybe<Scalars['numeric']>;
  locale?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['numeric']>;
  numberOfCourts?: Maybe<Scalars['numeric']>;
  organizerImageFileName?: Maybe<Scalars['String']>;
  organizerImageFileType?: Maybe<Scalars['String']>;
  organizerImageHost?: Maybe<Scalars['String']>;
  organizerImageOriginalFileName?: Maybe<Scalars['String']>;
  organizerImagePath?: Maybe<Scalars['String']>;
  organizerImageProvider?: Maybe<Scalars['String']>;
  organizerImageProviderUrl?: Maybe<Scalars['String']>;
  /** Note: Use this if it exists, otherwise check the organizer's profile to use their logo */
  organizerImageUrl?: Maybe<Scalars['String']>;
  padelRatingScaleId?: Maybe<Scalars['uuid']>;
  participantLimit?: Maybe<Scalars['Int']>;
  pickleballRatingScaleId?: Maybe<Scalars['uuid']>;
  prizeDescription?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['timestamptz']>;
  regionString?: Maybe<Scalars['String']>;
  registrationClosedAt?: Maybe<Scalars['timestamptz']>;
  registrationDeadlineDate?: Maybe<Scalars['date']>;
  registrationDeadlineDateTime?: Maybe<Scalars['timestamptz']>;
  registrationOpenDate?: Maybe<Scalars['date']>;
  registrationOpenDateTime?: Maybe<Scalars['timestamptz']>;
  registrationPriceUnitAmount?: Maybe<Scalars['Int']>;
  scheduleInfo?: Maybe<Scalars['String']>;
  showInPublicDate?: Maybe<Scalars['date']>;
  showInPublicDateTime?: Maybe<Scalars['timestamptz']>;
  slug?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  sourceEventId?: Maybe<Scalars['String']>;
  sourceId?: Maybe<Scalars['String']>;
  sourceLocationCity?: Maybe<Scalars['String']>;
  sourceLocationCountry?: Maybe<Scalars['String']>;
  sourceLocationState?: Maybe<Scalars['String']>;
  sourceLocationStreetAddress?: Maybe<Scalars['String']>;
  sourceLocationZip?: Maybe<Scalars['String']>;
  sourceLogoUrl?: Maybe<Scalars['String']>;
  sourceOrganizerId?: Maybe<Scalars['String']>;
  sourceOrganizerImageUrl?: Maybe<Scalars['String']>;
  sourceOrganizerTitle?: Maybe<Scalars['String']>;
  sourceRegistrationCount?: Maybe<Scalars['Int']>;
  sourceVenueTitle?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['date']>;
  startDateTime?: Maybe<Scalars['timestamptz']>;
  streetPrimaryString?: Maybe<Scalars['String']>;
  streetSecondaryString?: Maybe<Scalars['String']>;
  tennisRatingScaleId?: Maybe<Scalars['uuid']>;
  timezoneAbbreviation?: Maybe<Scalars['String']>;
  timezoneName?: Maybe<Scalars['String']>;
  timezoneOffsetMinutes?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  venueId?: Maybe<Scalars['uuid']>;
  zipcodeString?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "events" */
export type EventsMinOrderBy = {
  addressString?: InputMaybe<OrderBy>;
  archivedAt?: InputMaybe<OrderBy>;
  ballCustomName?: InputMaybe<OrderBy>;
  cancelReason?: InputMaybe<OrderBy>;
  canceledAt?: InputMaybe<OrderBy>;
  cityId?: InputMaybe<OrderBy>;
  cityString?: InputMaybe<OrderBy>;
  communityGroupId?: InputMaybe<OrderBy>;
  countryString?: InputMaybe<OrderBy>;
  courtCostPerPlayerUnitAmount?: InputMaybe<OrderBy>;
  coverImageFileName?: InputMaybe<OrderBy>;
  coverImageFileType?: InputMaybe<OrderBy>;
  coverImageHost?: InputMaybe<OrderBy>;
  coverImageOriginalFileName?: InputMaybe<OrderBy>;
  coverImagePath?: InputMaybe<OrderBy>;
  coverImageProvider?: InputMaybe<OrderBy>;
  coverImageProviderUrl?: InputMaybe<OrderBy>;
  coverImageUrl?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  currency?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  /** Fallback for when we don't have a city_id */
  displayLocation?: InputMaybe<OrderBy>;
  endDate?: InputMaybe<OrderBy>;
  endDateTime?: InputMaybe<OrderBy>;
  eventCollectionId?: InputMaybe<OrderBy>;
  externalUrl?: InputMaybe<OrderBy>;
  hostUserId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  locale?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  numberOfCourts?: InputMaybe<OrderBy>;
  organizerImageFileName?: InputMaybe<OrderBy>;
  organizerImageFileType?: InputMaybe<OrderBy>;
  organizerImageHost?: InputMaybe<OrderBy>;
  organizerImageOriginalFileName?: InputMaybe<OrderBy>;
  organizerImagePath?: InputMaybe<OrderBy>;
  organizerImageProvider?: InputMaybe<OrderBy>;
  organizerImageProviderUrl?: InputMaybe<OrderBy>;
  /** Note: Use this if it exists, otherwise check the organizer's profile to use their logo */
  organizerImageUrl?: InputMaybe<OrderBy>;
  padelRatingScaleId?: InputMaybe<OrderBy>;
  participantLimit?: InputMaybe<OrderBy>;
  pickleballRatingScaleId?: InputMaybe<OrderBy>;
  prizeDescription?: InputMaybe<OrderBy>;
  publishedAt?: InputMaybe<OrderBy>;
  regionString?: InputMaybe<OrderBy>;
  registrationClosedAt?: InputMaybe<OrderBy>;
  registrationDeadlineDate?: InputMaybe<OrderBy>;
  registrationDeadlineDateTime?: InputMaybe<OrderBy>;
  registrationOpenDate?: InputMaybe<OrderBy>;
  registrationOpenDateTime?: InputMaybe<OrderBy>;
  registrationPriceUnitAmount?: InputMaybe<OrderBy>;
  scheduleInfo?: InputMaybe<OrderBy>;
  showInPublicDate?: InputMaybe<OrderBy>;
  showInPublicDateTime?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  source?: InputMaybe<OrderBy>;
  sourceEventId?: InputMaybe<OrderBy>;
  sourceId?: InputMaybe<OrderBy>;
  sourceLocationCity?: InputMaybe<OrderBy>;
  sourceLocationCountry?: InputMaybe<OrderBy>;
  sourceLocationState?: InputMaybe<OrderBy>;
  sourceLocationStreetAddress?: InputMaybe<OrderBy>;
  sourceLocationZip?: InputMaybe<OrderBy>;
  sourceLogoUrl?: InputMaybe<OrderBy>;
  sourceOrganizerId?: InputMaybe<OrderBy>;
  sourceOrganizerImageUrl?: InputMaybe<OrderBy>;
  sourceOrganizerTitle?: InputMaybe<OrderBy>;
  sourceRegistrationCount?: InputMaybe<OrderBy>;
  sourceVenueTitle?: InputMaybe<OrderBy>;
  startDate?: InputMaybe<OrderBy>;
  startDateTime?: InputMaybe<OrderBy>;
  streetPrimaryString?: InputMaybe<OrderBy>;
  streetSecondaryString?: InputMaybe<OrderBy>;
  tennisRatingScaleId?: InputMaybe<OrderBy>;
  timezoneAbbreviation?: InputMaybe<OrderBy>;
  timezoneName?: InputMaybe<OrderBy>;
  timezoneOffsetMinutes?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  venueId?: InputMaybe<OrderBy>;
  zipcodeString?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "events" */
export type EventsMutationResponse = {
  __typename?: 'EventsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Events>;
};

/** input type for inserting object relation for remote table "events" */
export type EventsObjRelInsertInput = {
  data: EventsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<EventsOnConflict>;
};

/** on_conflict condition type for table "events" */
export type EventsOnConflict = {
  constraint: EventsConstraint;
  updateColumns?: Array<EventsUpdateColumn>;
  where?: InputMaybe<EventsBoolExp>;
};

/** Ordering options when selecting data from "events". */
export type EventsOrderBy = {
  acceptedPlayRequestsAggregate?: InputMaybe<EventAcceptedPlayRequestsAggregateOrderBy>;
  addressString?: InputMaybe<OrderBy>;
  archivedAt?: InputMaybe<OrderBy>;
  ballCustomName?: InputMaybe<OrderBy>;
  ballType?: InputMaybe<OrderBy>;
  cancelReason?: InputMaybe<OrderBy>;
  canceledAt?: InputMaybe<OrderBy>;
  city?: InputMaybe<CitiesOrderBy>;
  cityId?: InputMaybe<OrderBy>;
  cityString?: InputMaybe<OrderBy>;
  community?: InputMaybe<GroupsOrderBy>;
  communityGroupId?: InputMaybe<OrderBy>;
  contactDetails?: InputMaybe<EventContactDetailsOrderBy>;
  conversationsAggregate?: InputMaybe<ConversationsAggregateOrderBy>;
  countryString?: InputMaybe<OrderBy>;
  couponsAggregate?: InputMaybe<EventCouponsAggregateOrderBy>;
  courtCostPerPlayerUnitAmount?: InputMaybe<OrderBy>;
  courtsAggregate?: InputMaybe<EventCourtsAggregateOrderBy>;
  coverImageFileName?: InputMaybe<OrderBy>;
  coverImageFileType?: InputMaybe<OrderBy>;
  coverImageHost?: InputMaybe<OrderBy>;
  coverImageOriginalFileName?: InputMaybe<OrderBy>;
  coverImagePath?: InputMaybe<OrderBy>;
  coverImageProvider?: InputMaybe<OrderBy>;
  coverImageProviderUrl?: InputMaybe<OrderBy>;
  coverImageUrl?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  currency?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  displayLocation?: InputMaybe<OrderBy>;
  endDate?: InputMaybe<OrderBy>;
  endDateTime?: InputMaybe<OrderBy>;
  eventCollection?: InputMaybe<EventCollectionsOrderBy>;
  eventCollectionId?: InputMaybe<OrderBy>;
  externalUrl?: InputMaybe<OrderBy>;
  faqsAggregate?: InputMaybe<EventFaqsAggregateOrderBy>;
  geometry?: InputMaybe<OrderBy>;
  groupFormat?: InputMaybe<OrderBy>;
  groupsAggregate?: InputMaybe<EventGroupsAggregateOrderBy>;
  hasPrizes?: InputMaybe<OrderBy>;
  hostUser?: InputMaybe<UsersOrderBy>;
  hostUserId?: InputMaybe<OrderBy>;
  hostUserProfile?: InputMaybe<UserProfilesOrderBy>;
  id?: InputMaybe<OrderBy>;
  intendedAgeGroup?: InputMaybe<OrderBy>;
  invitationsAggregate?: InputMaybe<EventInvitationsAggregateOrderBy>;
  isCourtBooked?: InputMaybe<OrderBy>;
  isExternal?: InputMaybe<OrderBy>;
  isPlayerListed?: InputMaybe<OrderBy>;
  isQuickCreate?: InputMaybe<OrderBy>;
  isRatingRequired?: InputMaybe<OrderBy>;
  isRegisterOffPlatform?: InputMaybe<OrderBy>;
  isRfx?: InputMaybe<OrderBy>;
  isSanctioned?: InputMaybe<OrderBy>;
  isShowCourtAssignments?: InputMaybe<OrderBy>;
  isShowPlayersGoing?: InputMaybe<OrderBy>;
  isVairRequired?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  listingFeesAggregate?: InputMaybe<EventListingFeesAggregateOrderBy>;
  locale?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  numberOfCourts?: InputMaybe<OrderBy>;
  organizerImageFileName?: InputMaybe<OrderBy>;
  organizerImageFileType?: InputMaybe<OrderBy>;
  organizerImageHost?: InputMaybe<OrderBy>;
  organizerImageOriginalFileName?: InputMaybe<OrderBy>;
  organizerImagePath?: InputMaybe<OrderBy>;
  organizerImageProvider?: InputMaybe<OrderBy>;
  organizerImageProviderUrl?: InputMaybe<OrderBy>;
  organizerImageUrl?: InputMaybe<OrderBy>;
  padelRatingScaleId?: InputMaybe<OrderBy>;
  participantLimit?: InputMaybe<OrderBy>;
  paymentFulfillmentChannel?: InputMaybe<OrderBy>;
  pickleballRatingScale?: InputMaybe<PickleballRatingScalesOrderBy>;
  pickleballRatingScaleId?: InputMaybe<OrderBy>;
  playRequestsAggregate?: InputMaybe<PlayRequestsAggregateOrderBy>;
  privacy?: InputMaybe<OrderBy>;
  prizeDescription?: InputMaybe<OrderBy>;
  publishedAt?: InputMaybe<OrderBy>;
  regionString?: InputMaybe<OrderBy>;
  registrationClosedAt?: InputMaybe<OrderBy>;
  registrationDeadlineDate?: InputMaybe<OrderBy>;
  registrationDeadlineDateTime?: InputMaybe<OrderBy>;
  registrationOpenDate?: InputMaybe<OrderBy>;
  registrationOpenDateTime?: InputMaybe<OrderBy>;
  registrationPriceUnitAmount?: InputMaybe<OrderBy>;
  registrationsAggregate?: InputMaybe<EventRegistrationsAggregateOrderBy>;
  scheduleInfo?: InputMaybe<OrderBy>;
  scoringFormat?: InputMaybe<OrderBy>;
  showInPublicDate?: InputMaybe<OrderBy>;
  showInPublicDateTime?: InputMaybe<OrderBy>;
  skillLevelsAggregate?: InputMaybe<EventSkillLevelsAggregateOrderBy>;
  slug?: InputMaybe<OrderBy>;
  source?: InputMaybe<OrderBy>;
  sourceEventId?: InputMaybe<OrderBy>;
  sourceId?: InputMaybe<OrderBy>;
  sourceIsAdvertiseOnly?: InputMaybe<OrderBy>;
  sourceIsFeatured?: InputMaybe<OrderBy>;
  sourceIsFeaturedPlus?: InputMaybe<OrderBy>;
  sourceLocationCity?: InputMaybe<OrderBy>;
  sourceLocationCountry?: InputMaybe<OrderBy>;
  sourceLocationState?: InputMaybe<OrderBy>;
  sourceLocationStreetAddress?: InputMaybe<OrderBy>;
  sourceLocationZip?: InputMaybe<OrderBy>;
  sourceLogoUrl?: InputMaybe<OrderBy>;
  sourceOrganizerId?: InputMaybe<OrderBy>;
  sourceOrganizerImageUrl?: InputMaybe<OrderBy>;
  sourceOrganizerTitle?: InputMaybe<OrderBy>;
  sourceRegistrationCount?: InputMaybe<OrderBy>;
  sourceVenueTitle?: InputMaybe<OrderBy>;
  sponsorsAggregate?: InputMaybe<EventSponsorsAggregateOrderBy>;
  sport?: InputMaybe<OrderBy>;
  startDate?: InputMaybe<OrderBy>;
  startDateTime?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  streetPrimaryString?: InputMaybe<OrderBy>;
  streetSecondaryString?: InputMaybe<OrderBy>;
  tennisRatingScale?: InputMaybe<TennisRatingScalesOrderBy>;
  tennisRatingScaleId?: InputMaybe<OrderBy>;
  timezoneAbbreviation?: InputMaybe<OrderBy>;
  timezoneName?: InputMaybe<OrderBy>;
  timezoneOffsetMinutes?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  transactionsAggregate?: InputMaybe<EventTransactionsAggregateOrderBy>;
  type?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  venue?: InputMaybe<VenuesOrderBy>;
  venueId?: InputMaybe<OrderBy>;
  zipcodeString?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: events */
export type EventsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "events" */
export enum EventsSelectColumn {
  /** column name */
  AddressString = 'addressString',
  /** column name */
  ArchivedAt = 'archivedAt',
  /** column name */
  BallCustomName = 'ballCustomName',
  /** column name */
  BallType = 'ballType',
  /** column name */
  CancelReason = 'cancelReason',
  /** column name */
  CanceledAt = 'canceledAt',
  /** column name */
  CityId = 'cityId',
  /** column name */
  CityString = 'cityString',
  /** column name */
  CommunityGroupId = 'communityGroupId',
  /** column name */
  CountryString = 'countryString',
  /** column name */
  CourtCostPerPlayerUnitAmount = 'courtCostPerPlayerUnitAmount',
  /** column name */
  CoverImageFileName = 'coverImageFileName',
  /** column name */
  CoverImageFileType = 'coverImageFileType',
  /** column name */
  CoverImageHost = 'coverImageHost',
  /** column name */
  CoverImageOriginalFileName = 'coverImageOriginalFileName',
  /** column name */
  CoverImagePath = 'coverImagePath',
  /** column name */
  CoverImageProvider = 'coverImageProvider',
  /** column name */
  CoverImageProviderUrl = 'coverImageProviderUrl',
  /** column name */
  CoverImageUrl = 'coverImageUrl',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Currency = 'currency',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Description = 'description',
  /** column name */
  DisplayLocation = 'displayLocation',
  /** column name */
  EndDate = 'endDate',
  /** column name */
  EndDateTime = 'endDateTime',
  /** column name */
  EventCollectionId = 'eventCollectionId',
  /** column name */
  ExternalUrl = 'externalUrl',
  /** column name */
  Geometry = 'geometry',
  /** column name */
  GroupFormat = 'groupFormat',
  /** column name */
  HasPrizes = 'hasPrizes',
  /** column name */
  HostUserId = 'hostUserId',
  /** column name */
  Id = 'id',
  /** column name */
  IntendedAgeGroup = 'intendedAgeGroup',
  /** column name */
  IsCourtBooked = 'isCourtBooked',
  /** column name */
  IsExternal = 'isExternal',
  /** column name */
  IsPlayerListed = 'isPlayerListed',
  /** column name */
  IsQuickCreate = 'isQuickCreate',
  /** column name */
  IsRatingRequired = 'isRatingRequired',
  /** column name */
  IsRegisterOffPlatform = 'isRegisterOffPlatform',
  /** column name */
  IsRfx = 'isRfx',
  /** column name */
  IsSanctioned = 'isSanctioned',
  /** column name */
  IsShowCourtAssignments = 'isShowCourtAssignments',
  /** column name */
  IsShowPlayersGoing = 'isShowPlayersGoing',
  /** column name */
  IsVairRequired = 'isVairRequired',
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Locale = 'locale',
  /** column name */
  Longitude = 'longitude',
  /** column name */
  NumberOfCourts = 'numberOfCourts',
  /** column name */
  OrganizerImageFileName = 'organizerImageFileName',
  /** column name */
  OrganizerImageFileType = 'organizerImageFileType',
  /** column name */
  OrganizerImageHost = 'organizerImageHost',
  /** column name */
  OrganizerImageOriginalFileName = 'organizerImageOriginalFileName',
  /** column name */
  OrganizerImagePath = 'organizerImagePath',
  /** column name */
  OrganizerImageProvider = 'organizerImageProvider',
  /** column name */
  OrganizerImageProviderUrl = 'organizerImageProviderUrl',
  /** column name */
  OrganizerImageUrl = 'organizerImageUrl',
  /** column name */
  PadelRatingScaleId = 'padelRatingScaleId',
  /** column name */
  ParticipantLimit = 'participantLimit',
  /** column name */
  PaymentFulfillmentChannel = 'paymentFulfillmentChannel',
  /** column name */
  PickleballRatingScaleId = 'pickleballRatingScaleId',
  /** column name */
  Privacy = 'privacy',
  /** column name */
  PrizeDescription = 'prizeDescription',
  /** column name */
  PublishedAt = 'publishedAt',
  /** column name */
  RegionString = 'regionString',
  /** column name */
  RegistrationClosedAt = 'registrationClosedAt',
  /** column name */
  RegistrationDeadlineDate = 'registrationDeadlineDate',
  /** column name */
  RegistrationDeadlineDateTime = 'registrationDeadlineDateTime',
  /** column name */
  RegistrationOpenDate = 'registrationOpenDate',
  /** column name */
  RegistrationOpenDateTime = 'registrationOpenDateTime',
  /** column name */
  RegistrationPriceUnitAmount = 'registrationPriceUnitAmount',
  /** column name */
  ScheduleInfo = 'scheduleInfo',
  /** column name */
  ScoringFormat = 'scoringFormat',
  /** column name */
  ShowInPublicDate = 'showInPublicDate',
  /** column name */
  ShowInPublicDateTime = 'showInPublicDateTime',
  /** column name */
  Slug = 'slug',
  /** column name */
  Source = 'source',
  /** column name */
  SourceEventId = 'sourceEventId',
  /** column name */
  SourceId = 'sourceId',
  /** column name */
  SourceIsAdvertiseOnly = 'sourceIsAdvertiseOnly',
  /** column name */
  SourceIsFeatured = 'sourceIsFeatured',
  /** column name */
  SourceIsFeaturedPlus = 'sourceIsFeaturedPlus',
  /** column name */
  SourceLocationCity = 'sourceLocationCity',
  /** column name */
  SourceLocationCountry = 'sourceLocationCountry',
  /** column name */
  SourceLocationState = 'sourceLocationState',
  /** column name */
  SourceLocationStreetAddress = 'sourceLocationStreetAddress',
  /** column name */
  SourceLocationZip = 'sourceLocationZip',
  /** column name */
  SourceLogoUrl = 'sourceLogoUrl',
  /** column name */
  SourceOrganizerId = 'sourceOrganizerId',
  /** column name */
  SourceOrganizerImageUrl = 'sourceOrganizerImageUrl',
  /** column name */
  SourceOrganizerTitle = 'sourceOrganizerTitle',
  /** column name */
  SourceRegistrationCount = 'sourceRegistrationCount',
  /** column name */
  SourceVenueTitle = 'sourceVenueTitle',
  /** column name */
  Sport = 'sport',
  /** column name */
  StartDate = 'startDate',
  /** column name */
  StartDateTime = 'startDateTime',
  /** column name */
  Status = 'status',
  /** column name */
  StreetPrimaryString = 'streetPrimaryString',
  /** column name */
  StreetSecondaryString = 'streetSecondaryString',
  /** column name */
  TennisRatingScaleId = 'tennisRatingScaleId',
  /** column name */
  TimezoneAbbreviation = 'timezoneAbbreviation',
  /** column name */
  TimezoneName = 'timezoneName',
  /** column name */
  TimezoneOffsetMinutes = 'timezoneOffsetMinutes',
  /** column name */
  Title = 'title',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  VenueId = 'venueId',
  /** column name */
  ZipcodeString = 'zipcodeString'
}

/** select "eventsAggregateBoolExpBool_andArgumentsColumns" columns of table "events" */
export enum EventsSelectColumnEventsAggregateBoolExpBool_AndArgumentsColumns {
  /** column name */
  HasPrizes = 'hasPrizes',
  /** column name */
  IsCourtBooked = 'isCourtBooked',
  /** column name */
  IsExternal = 'isExternal',
  /** column name */
  IsPlayerListed = 'isPlayerListed',
  /** column name */
  IsQuickCreate = 'isQuickCreate',
  /** column name */
  IsRatingRequired = 'isRatingRequired',
  /** column name */
  IsRegisterOffPlatform = 'isRegisterOffPlatform',
  /** column name */
  IsRfx = 'isRfx',
  /** column name */
  IsSanctioned = 'isSanctioned',
  /** column name */
  IsShowCourtAssignments = 'isShowCourtAssignments',
  /** column name */
  IsShowPlayersGoing = 'isShowPlayersGoing',
  /** column name */
  IsVairRequired = 'isVairRequired',
  /** column name */
  SourceIsAdvertiseOnly = 'sourceIsAdvertiseOnly',
  /** column name */
  SourceIsFeatured = 'sourceIsFeatured',
  /** column name */
  SourceIsFeaturedPlus = 'sourceIsFeaturedPlus'
}

/** select "eventsAggregateBoolExpBool_orArgumentsColumns" columns of table "events" */
export enum EventsSelectColumnEventsAggregateBoolExpBool_OrArgumentsColumns {
  /** column name */
  HasPrizes = 'hasPrizes',
  /** column name */
  IsCourtBooked = 'isCourtBooked',
  /** column name */
  IsExternal = 'isExternal',
  /** column name */
  IsPlayerListed = 'isPlayerListed',
  /** column name */
  IsQuickCreate = 'isQuickCreate',
  /** column name */
  IsRatingRequired = 'isRatingRequired',
  /** column name */
  IsRegisterOffPlatform = 'isRegisterOffPlatform',
  /** column name */
  IsRfx = 'isRfx',
  /** column name */
  IsSanctioned = 'isSanctioned',
  /** column name */
  IsShowCourtAssignments = 'isShowCourtAssignments',
  /** column name */
  IsShowPlayersGoing = 'isShowPlayersGoing',
  /** column name */
  IsVairRequired = 'isVairRequired',
  /** column name */
  SourceIsAdvertiseOnly = 'sourceIsAdvertiseOnly',
  /** column name */
  SourceIsFeatured = 'sourceIsFeatured',
  /** column name */
  SourceIsFeaturedPlus = 'sourceIsFeaturedPlus'
}

/** input type for updating data in table "events" */
export type EventsSetInput = {
  addressString?: InputMaybe<Scalars['String']>;
  archivedAt?: InputMaybe<Scalars['timestamptz']>;
  ballCustomName?: InputMaybe<Scalars['String']>;
  ballType?: InputMaybe<BallTypesEnum>;
  cancelReason?: InputMaybe<Scalars['String']>;
  canceledAt?: InputMaybe<Scalars['timestamptz']>;
  cityId?: InputMaybe<Scalars['uuid']>;
  cityString?: InputMaybe<Scalars['String']>;
  communityGroupId?: InputMaybe<Scalars['uuid']>;
  countryString?: InputMaybe<Scalars['String']>;
  courtCostPerPlayerUnitAmount?: InputMaybe<Scalars['Int']>;
  coverImageFileName?: InputMaybe<Scalars['String']>;
  coverImageFileType?: InputMaybe<Scalars['String']>;
  coverImageHost?: InputMaybe<Scalars['String']>;
  coverImageOriginalFileName?: InputMaybe<Scalars['String']>;
  coverImagePath?: InputMaybe<Scalars['String']>;
  coverImageProvider?: InputMaybe<Scalars['String']>;
  coverImageProviderUrl?: InputMaybe<Scalars['String']>;
  coverImageUrl?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  /** Fallback for when we don't have a city_id */
  displayLocation?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['date']>;
  endDateTime?: InputMaybe<Scalars['timestamptz']>;
  eventCollectionId?: InputMaybe<Scalars['uuid']>;
  externalUrl?: InputMaybe<Scalars['String']>;
  geometry?: InputMaybe<Scalars['geography']>;
  groupFormat?: InputMaybe<EventGroupFormatsEnum>;
  hasPrizes?: InputMaybe<Scalars['Boolean']>;
  hostUserId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  intendedAgeGroup?: InputMaybe<EventAgeGroupsEnum>;
  isCourtBooked?: InputMaybe<Scalars['Boolean']>;
  isExternal?: InputMaybe<Scalars['Boolean']>;
  isPlayerListed?: InputMaybe<Scalars['Boolean']>;
  isQuickCreate?: InputMaybe<Scalars['Boolean']>;
  isRatingRequired?: InputMaybe<Scalars['Boolean']>;
  isRegisterOffPlatform?: InputMaybe<Scalars['Boolean']>;
  isRfx?: InputMaybe<Scalars['Boolean']>;
  isSanctioned?: InputMaybe<Scalars['Boolean']>;
  isShowCourtAssignments?: InputMaybe<Scalars['Boolean']>;
  isShowPlayersGoing?: InputMaybe<Scalars['Boolean']>;
  isVairRequired?: InputMaybe<Scalars['Boolean']>;
  latitude?: InputMaybe<Scalars['numeric']>;
  locale?: InputMaybe<Scalars['String']>;
  longitude?: InputMaybe<Scalars['numeric']>;
  numberOfCourts?: InputMaybe<Scalars['numeric']>;
  organizerImageFileName?: InputMaybe<Scalars['String']>;
  organizerImageFileType?: InputMaybe<Scalars['String']>;
  organizerImageHost?: InputMaybe<Scalars['String']>;
  organizerImageOriginalFileName?: InputMaybe<Scalars['String']>;
  organizerImagePath?: InputMaybe<Scalars['String']>;
  organizerImageProvider?: InputMaybe<Scalars['String']>;
  organizerImageProviderUrl?: InputMaybe<Scalars['String']>;
  /** Note: Use this if it exists, otherwise check the organizer's profile to use their logo */
  organizerImageUrl?: InputMaybe<Scalars['String']>;
  padelRatingScaleId?: InputMaybe<Scalars['uuid']>;
  participantLimit?: InputMaybe<Scalars['Int']>;
  paymentFulfillmentChannel?: InputMaybe<PaymentFulfillmentChannelsEnum>;
  pickleballRatingScaleId?: InputMaybe<Scalars['uuid']>;
  privacy?: InputMaybe<EventPrivacyEnum>;
  prizeDescription?: InputMaybe<Scalars['String']>;
  publishedAt?: InputMaybe<Scalars['timestamptz']>;
  regionString?: InputMaybe<Scalars['String']>;
  registrationClosedAt?: InputMaybe<Scalars['timestamptz']>;
  registrationDeadlineDate?: InputMaybe<Scalars['date']>;
  registrationDeadlineDateTime?: InputMaybe<Scalars['timestamptz']>;
  registrationOpenDate?: InputMaybe<Scalars['date']>;
  registrationOpenDateTime?: InputMaybe<Scalars['timestamptz']>;
  registrationPriceUnitAmount?: InputMaybe<Scalars['Int']>;
  scheduleInfo?: InputMaybe<Scalars['String']>;
  scoringFormat?: InputMaybe<ScoringFormatEnum>;
  showInPublicDate?: InputMaybe<Scalars['date']>;
  showInPublicDateTime?: InputMaybe<Scalars['timestamptz']>;
  slug?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  sourceEventId?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  sourceIsAdvertiseOnly?: InputMaybe<Scalars['Boolean']>;
  sourceIsFeatured?: InputMaybe<Scalars['Boolean']>;
  sourceIsFeaturedPlus?: InputMaybe<Scalars['Boolean']>;
  sourceLocationCity?: InputMaybe<Scalars['String']>;
  sourceLocationCountry?: InputMaybe<Scalars['String']>;
  sourceLocationState?: InputMaybe<Scalars['String']>;
  sourceLocationStreetAddress?: InputMaybe<Scalars['String']>;
  sourceLocationZip?: InputMaybe<Scalars['String']>;
  sourceLogoUrl?: InputMaybe<Scalars['String']>;
  sourceOrganizerId?: InputMaybe<Scalars['String']>;
  sourceOrganizerImageUrl?: InputMaybe<Scalars['String']>;
  sourceOrganizerTitle?: InputMaybe<Scalars['String']>;
  sourceRegistrationCount?: InputMaybe<Scalars['Int']>;
  sourceVenueTitle?: InputMaybe<Scalars['String']>;
  sport?: InputMaybe<SportsEnum>;
  startDate?: InputMaybe<Scalars['date']>;
  startDateTime?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<EventStatusesEnum>;
  streetPrimaryString?: InputMaybe<Scalars['String']>;
  streetSecondaryString?: InputMaybe<Scalars['String']>;
  tennisRatingScaleId?: InputMaybe<Scalars['uuid']>;
  timezoneAbbreviation?: InputMaybe<Scalars['String']>;
  timezoneName?: InputMaybe<Scalars['String']>;
  timezoneOffsetMinutes?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<EventTypesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  venueId?: InputMaybe<Scalars['uuid']>;
  zipcodeString?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type EventsStddevFields = {
  __typename?: 'EventsStddevFields';
  courtCostPerPlayerUnitAmount?: Maybe<Scalars['Float']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  numberOfCourts?: Maybe<Scalars['Float']>;
  participantLimit?: Maybe<Scalars['Float']>;
  registrationPriceUnitAmount?: Maybe<Scalars['Float']>;
  sourceRegistrationCount?: Maybe<Scalars['Float']>;
  timezoneOffsetMinutes?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "events" */
export type EventsStddevOrderBy = {
  courtCostPerPlayerUnitAmount?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  numberOfCourts?: InputMaybe<OrderBy>;
  participantLimit?: InputMaybe<OrderBy>;
  registrationPriceUnitAmount?: InputMaybe<OrderBy>;
  sourceRegistrationCount?: InputMaybe<OrderBy>;
  timezoneOffsetMinutes?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type EventsStddevPopFields = {
  __typename?: 'EventsStddevPopFields';
  courtCostPerPlayerUnitAmount?: Maybe<Scalars['Float']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  numberOfCourts?: Maybe<Scalars['Float']>;
  participantLimit?: Maybe<Scalars['Float']>;
  registrationPriceUnitAmount?: Maybe<Scalars['Float']>;
  sourceRegistrationCount?: Maybe<Scalars['Float']>;
  timezoneOffsetMinutes?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "events" */
export type EventsStddevPopOrderBy = {
  courtCostPerPlayerUnitAmount?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  numberOfCourts?: InputMaybe<OrderBy>;
  participantLimit?: InputMaybe<OrderBy>;
  registrationPriceUnitAmount?: InputMaybe<OrderBy>;
  sourceRegistrationCount?: InputMaybe<OrderBy>;
  timezoneOffsetMinutes?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type EventsStddevSampFields = {
  __typename?: 'EventsStddevSampFields';
  courtCostPerPlayerUnitAmount?: Maybe<Scalars['Float']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  numberOfCourts?: Maybe<Scalars['Float']>;
  participantLimit?: Maybe<Scalars['Float']>;
  registrationPriceUnitAmount?: Maybe<Scalars['Float']>;
  sourceRegistrationCount?: Maybe<Scalars['Float']>;
  timezoneOffsetMinutes?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "events" */
export type EventsStddevSampOrderBy = {
  courtCostPerPlayerUnitAmount?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  numberOfCourts?: InputMaybe<OrderBy>;
  participantLimit?: InputMaybe<OrderBy>;
  registrationPriceUnitAmount?: InputMaybe<OrderBy>;
  sourceRegistrationCount?: InputMaybe<OrderBy>;
  timezoneOffsetMinutes?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "events" */
export type EventsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventsStreamCursorValueInput = {
  addressString?: InputMaybe<Scalars['String']>;
  archivedAt?: InputMaybe<Scalars['timestamptz']>;
  ballCustomName?: InputMaybe<Scalars['String']>;
  ballType?: InputMaybe<BallTypesEnum>;
  cancelReason?: InputMaybe<Scalars['String']>;
  canceledAt?: InputMaybe<Scalars['timestamptz']>;
  cityId?: InputMaybe<Scalars['uuid']>;
  cityString?: InputMaybe<Scalars['String']>;
  communityGroupId?: InputMaybe<Scalars['uuid']>;
  countryString?: InputMaybe<Scalars['String']>;
  courtCostPerPlayerUnitAmount?: InputMaybe<Scalars['Int']>;
  coverImageFileName?: InputMaybe<Scalars['String']>;
  coverImageFileType?: InputMaybe<Scalars['String']>;
  coverImageHost?: InputMaybe<Scalars['String']>;
  coverImageOriginalFileName?: InputMaybe<Scalars['String']>;
  coverImagePath?: InputMaybe<Scalars['String']>;
  coverImageProvider?: InputMaybe<Scalars['String']>;
  coverImageProviderUrl?: InputMaybe<Scalars['String']>;
  coverImageUrl?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  /** Fallback for when we don't have a city_id */
  displayLocation?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['date']>;
  endDateTime?: InputMaybe<Scalars['timestamptz']>;
  eventCollectionId?: InputMaybe<Scalars['uuid']>;
  externalUrl?: InputMaybe<Scalars['String']>;
  geometry?: InputMaybe<Scalars['geography']>;
  groupFormat?: InputMaybe<EventGroupFormatsEnum>;
  hasPrizes?: InputMaybe<Scalars['Boolean']>;
  hostUserId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  intendedAgeGroup?: InputMaybe<EventAgeGroupsEnum>;
  isCourtBooked?: InputMaybe<Scalars['Boolean']>;
  isExternal?: InputMaybe<Scalars['Boolean']>;
  isPlayerListed?: InputMaybe<Scalars['Boolean']>;
  isQuickCreate?: InputMaybe<Scalars['Boolean']>;
  isRatingRequired?: InputMaybe<Scalars['Boolean']>;
  isRegisterOffPlatform?: InputMaybe<Scalars['Boolean']>;
  isRfx?: InputMaybe<Scalars['Boolean']>;
  isSanctioned?: InputMaybe<Scalars['Boolean']>;
  isShowCourtAssignments?: InputMaybe<Scalars['Boolean']>;
  isShowPlayersGoing?: InputMaybe<Scalars['Boolean']>;
  isVairRequired?: InputMaybe<Scalars['Boolean']>;
  latitude?: InputMaybe<Scalars['numeric']>;
  locale?: InputMaybe<Scalars['String']>;
  longitude?: InputMaybe<Scalars['numeric']>;
  numberOfCourts?: InputMaybe<Scalars['numeric']>;
  organizerImageFileName?: InputMaybe<Scalars['String']>;
  organizerImageFileType?: InputMaybe<Scalars['String']>;
  organizerImageHost?: InputMaybe<Scalars['String']>;
  organizerImageOriginalFileName?: InputMaybe<Scalars['String']>;
  organizerImagePath?: InputMaybe<Scalars['String']>;
  organizerImageProvider?: InputMaybe<Scalars['String']>;
  organizerImageProviderUrl?: InputMaybe<Scalars['String']>;
  /** Note: Use this if it exists, otherwise check the organizer's profile to use their logo */
  organizerImageUrl?: InputMaybe<Scalars['String']>;
  padelRatingScaleId?: InputMaybe<Scalars['uuid']>;
  participantLimit?: InputMaybe<Scalars['Int']>;
  paymentFulfillmentChannel?: InputMaybe<PaymentFulfillmentChannelsEnum>;
  pickleballRatingScaleId?: InputMaybe<Scalars['uuid']>;
  privacy?: InputMaybe<EventPrivacyEnum>;
  prizeDescription?: InputMaybe<Scalars['String']>;
  publishedAt?: InputMaybe<Scalars['timestamptz']>;
  regionString?: InputMaybe<Scalars['String']>;
  registrationClosedAt?: InputMaybe<Scalars['timestamptz']>;
  registrationDeadlineDate?: InputMaybe<Scalars['date']>;
  registrationDeadlineDateTime?: InputMaybe<Scalars['timestamptz']>;
  registrationOpenDate?: InputMaybe<Scalars['date']>;
  registrationOpenDateTime?: InputMaybe<Scalars['timestamptz']>;
  registrationPriceUnitAmount?: InputMaybe<Scalars['Int']>;
  scheduleInfo?: InputMaybe<Scalars['String']>;
  scoringFormat?: InputMaybe<ScoringFormatEnum>;
  showInPublicDate?: InputMaybe<Scalars['date']>;
  showInPublicDateTime?: InputMaybe<Scalars['timestamptz']>;
  slug?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  sourceEventId?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  sourceIsAdvertiseOnly?: InputMaybe<Scalars['Boolean']>;
  sourceIsFeatured?: InputMaybe<Scalars['Boolean']>;
  sourceIsFeaturedPlus?: InputMaybe<Scalars['Boolean']>;
  sourceLocationCity?: InputMaybe<Scalars['String']>;
  sourceLocationCountry?: InputMaybe<Scalars['String']>;
  sourceLocationState?: InputMaybe<Scalars['String']>;
  sourceLocationStreetAddress?: InputMaybe<Scalars['String']>;
  sourceLocationZip?: InputMaybe<Scalars['String']>;
  sourceLogoUrl?: InputMaybe<Scalars['String']>;
  sourceOrganizerId?: InputMaybe<Scalars['String']>;
  sourceOrganizerImageUrl?: InputMaybe<Scalars['String']>;
  sourceOrganizerTitle?: InputMaybe<Scalars['String']>;
  sourceRegistrationCount?: InputMaybe<Scalars['Int']>;
  sourceVenueTitle?: InputMaybe<Scalars['String']>;
  sport?: InputMaybe<SportsEnum>;
  startDate?: InputMaybe<Scalars['date']>;
  startDateTime?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<EventStatusesEnum>;
  streetPrimaryString?: InputMaybe<Scalars['String']>;
  streetSecondaryString?: InputMaybe<Scalars['String']>;
  tennisRatingScaleId?: InputMaybe<Scalars['uuid']>;
  timezoneAbbreviation?: InputMaybe<Scalars['String']>;
  timezoneName?: InputMaybe<Scalars['String']>;
  timezoneOffsetMinutes?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<EventTypesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  venueId?: InputMaybe<Scalars['uuid']>;
  zipcodeString?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type EventsSumFields = {
  __typename?: 'EventsSumFields';
  courtCostPerPlayerUnitAmount?: Maybe<Scalars['Int']>;
  latitude?: Maybe<Scalars['numeric']>;
  longitude?: Maybe<Scalars['numeric']>;
  numberOfCourts?: Maybe<Scalars['numeric']>;
  participantLimit?: Maybe<Scalars['Int']>;
  registrationPriceUnitAmount?: Maybe<Scalars['Int']>;
  sourceRegistrationCount?: Maybe<Scalars['Int']>;
  timezoneOffsetMinutes?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "events" */
export type EventsSumOrderBy = {
  courtCostPerPlayerUnitAmount?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  numberOfCourts?: InputMaybe<OrderBy>;
  participantLimit?: InputMaybe<OrderBy>;
  registrationPriceUnitAmount?: InputMaybe<OrderBy>;
  sourceRegistrationCount?: InputMaybe<OrderBy>;
  timezoneOffsetMinutes?: InputMaybe<OrderBy>;
};

/** update columns of table "events" */
export enum EventsUpdateColumn {
  /** column name */
  AddressString = 'addressString',
  /** column name */
  ArchivedAt = 'archivedAt',
  /** column name */
  BallCustomName = 'ballCustomName',
  /** column name */
  BallType = 'ballType',
  /** column name */
  CancelReason = 'cancelReason',
  /** column name */
  CanceledAt = 'canceledAt',
  /** column name */
  CityId = 'cityId',
  /** column name */
  CityString = 'cityString',
  /** column name */
  CommunityGroupId = 'communityGroupId',
  /** column name */
  CountryString = 'countryString',
  /** column name */
  CourtCostPerPlayerUnitAmount = 'courtCostPerPlayerUnitAmount',
  /** column name */
  CoverImageFileName = 'coverImageFileName',
  /** column name */
  CoverImageFileType = 'coverImageFileType',
  /** column name */
  CoverImageHost = 'coverImageHost',
  /** column name */
  CoverImageOriginalFileName = 'coverImageOriginalFileName',
  /** column name */
  CoverImagePath = 'coverImagePath',
  /** column name */
  CoverImageProvider = 'coverImageProvider',
  /** column name */
  CoverImageProviderUrl = 'coverImageProviderUrl',
  /** column name */
  CoverImageUrl = 'coverImageUrl',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Currency = 'currency',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Description = 'description',
  /** column name */
  DisplayLocation = 'displayLocation',
  /** column name */
  EndDate = 'endDate',
  /** column name */
  EndDateTime = 'endDateTime',
  /** column name */
  EventCollectionId = 'eventCollectionId',
  /** column name */
  ExternalUrl = 'externalUrl',
  /** column name */
  Geometry = 'geometry',
  /** column name */
  GroupFormat = 'groupFormat',
  /** column name */
  HasPrizes = 'hasPrizes',
  /** column name */
  HostUserId = 'hostUserId',
  /** column name */
  Id = 'id',
  /** column name */
  IntendedAgeGroup = 'intendedAgeGroup',
  /** column name */
  IsCourtBooked = 'isCourtBooked',
  /** column name */
  IsExternal = 'isExternal',
  /** column name */
  IsPlayerListed = 'isPlayerListed',
  /** column name */
  IsQuickCreate = 'isQuickCreate',
  /** column name */
  IsRatingRequired = 'isRatingRequired',
  /** column name */
  IsRegisterOffPlatform = 'isRegisterOffPlatform',
  /** column name */
  IsRfx = 'isRfx',
  /** column name */
  IsSanctioned = 'isSanctioned',
  /** column name */
  IsShowCourtAssignments = 'isShowCourtAssignments',
  /** column name */
  IsShowPlayersGoing = 'isShowPlayersGoing',
  /** column name */
  IsVairRequired = 'isVairRequired',
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Locale = 'locale',
  /** column name */
  Longitude = 'longitude',
  /** column name */
  NumberOfCourts = 'numberOfCourts',
  /** column name */
  OrganizerImageFileName = 'organizerImageFileName',
  /** column name */
  OrganizerImageFileType = 'organizerImageFileType',
  /** column name */
  OrganizerImageHost = 'organizerImageHost',
  /** column name */
  OrganizerImageOriginalFileName = 'organizerImageOriginalFileName',
  /** column name */
  OrganizerImagePath = 'organizerImagePath',
  /** column name */
  OrganizerImageProvider = 'organizerImageProvider',
  /** column name */
  OrganizerImageProviderUrl = 'organizerImageProviderUrl',
  /** column name */
  OrganizerImageUrl = 'organizerImageUrl',
  /** column name */
  PadelRatingScaleId = 'padelRatingScaleId',
  /** column name */
  ParticipantLimit = 'participantLimit',
  /** column name */
  PaymentFulfillmentChannel = 'paymentFulfillmentChannel',
  /** column name */
  PickleballRatingScaleId = 'pickleballRatingScaleId',
  /** column name */
  Privacy = 'privacy',
  /** column name */
  PrizeDescription = 'prizeDescription',
  /** column name */
  PublishedAt = 'publishedAt',
  /** column name */
  RegionString = 'regionString',
  /** column name */
  RegistrationClosedAt = 'registrationClosedAt',
  /** column name */
  RegistrationDeadlineDate = 'registrationDeadlineDate',
  /** column name */
  RegistrationDeadlineDateTime = 'registrationDeadlineDateTime',
  /** column name */
  RegistrationOpenDate = 'registrationOpenDate',
  /** column name */
  RegistrationOpenDateTime = 'registrationOpenDateTime',
  /** column name */
  RegistrationPriceUnitAmount = 'registrationPriceUnitAmount',
  /** column name */
  ScheduleInfo = 'scheduleInfo',
  /** column name */
  ScoringFormat = 'scoringFormat',
  /** column name */
  ShowInPublicDate = 'showInPublicDate',
  /** column name */
  ShowInPublicDateTime = 'showInPublicDateTime',
  /** column name */
  Slug = 'slug',
  /** column name */
  Source = 'source',
  /** column name */
  SourceEventId = 'sourceEventId',
  /** column name */
  SourceId = 'sourceId',
  /** column name */
  SourceIsAdvertiseOnly = 'sourceIsAdvertiseOnly',
  /** column name */
  SourceIsFeatured = 'sourceIsFeatured',
  /** column name */
  SourceIsFeaturedPlus = 'sourceIsFeaturedPlus',
  /** column name */
  SourceLocationCity = 'sourceLocationCity',
  /** column name */
  SourceLocationCountry = 'sourceLocationCountry',
  /** column name */
  SourceLocationState = 'sourceLocationState',
  /** column name */
  SourceLocationStreetAddress = 'sourceLocationStreetAddress',
  /** column name */
  SourceLocationZip = 'sourceLocationZip',
  /** column name */
  SourceLogoUrl = 'sourceLogoUrl',
  /** column name */
  SourceOrganizerId = 'sourceOrganizerId',
  /** column name */
  SourceOrganizerImageUrl = 'sourceOrganizerImageUrl',
  /** column name */
  SourceOrganizerTitle = 'sourceOrganizerTitle',
  /** column name */
  SourceRegistrationCount = 'sourceRegistrationCount',
  /** column name */
  SourceVenueTitle = 'sourceVenueTitle',
  /** column name */
  Sport = 'sport',
  /** column name */
  StartDate = 'startDate',
  /** column name */
  StartDateTime = 'startDateTime',
  /** column name */
  Status = 'status',
  /** column name */
  StreetPrimaryString = 'streetPrimaryString',
  /** column name */
  StreetSecondaryString = 'streetSecondaryString',
  /** column name */
  TennisRatingScaleId = 'tennisRatingScaleId',
  /** column name */
  TimezoneAbbreviation = 'timezoneAbbreviation',
  /** column name */
  TimezoneName = 'timezoneName',
  /** column name */
  TimezoneOffsetMinutes = 'timezoneOffsetMinutes',
  /** column name */
  Title = 'title',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  VenueId = 'venueId',
  /** column name */
  ZipcodeString = 'zipcodeString'
}

export type EventsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<EventsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventsSetInput>;
  /** filter the rows which have to be updated */
  where: EventsBoolExp;
};

/** aggregate varPop on columns */
export type EventsVarPopFields = {
  __typename?: 'EventsVarPopFields';
  courtCostPerPlayerUnitAmount?: Maybe<Scalars['Float']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  numberOfCourts?: Maybe<Scalars['Float']>;
  participantLimit?: Maybe<Scalars['Float']>;
  registrationPriceUnitAmount?: Maybe<Scalars['Float']>;
  sourceRegistrationCount?: Maybe<Scalars['Float']>;
  timezoneOffsetMinutes?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "events" */
export type EventsVarPopOrderBy = {
  courtCostPerPlayerUnitAmount?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  numberOfCourts?: InputMaybe<OrderBy>;
  participantLimit?: InputMaybe<OrderBy>;
  registrationPriceUnitAmount?: InputMaybe<OrderBy>;
  sourceRegistrationCount?: InputMaybe<OrderBy>;
  timezoneOffsetMinutes?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type EventsVarSampFields = {
  __typename?: 'EventsVarSampFields';
  courtCostPerPlayerUnitAmount?: Maybe<Scalars['Float']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  numberOfCourts?: Maybe<Scalars['Float']>;
  participantLimit?: Maybe<Scalars['Float']>;
  registrationPriceUnitAmount?: Maybe<Scalars['Float']>;
  sourceRegistrationCount?: Maybe<Scalars['Float']>;
  timezoneOffsetMinutes?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "events" */
export type EventsVarSampOrderBy = {
  courtCostPerPlayerUnitAmount?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  numberOfCourts?: InputMaybe<OrderBy>;
  participantLimit?: InputMaybe<OrderBy>;
  registrationPriceUnitAmount?: InputMaybe<OrderBy>;
  sourceRegistrationCount?: InputMaybe<OrderBy>;
  timezoneOffsetMinutes?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type EventsVarianceFields = {
  __typename?: 'EventsVarianceFields';
  courtCostPerPlayerUnitAmount?: Maybe<Scalars['Float']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  numberOfCourts?: Maybe<Scalars['Float']>;
  participantLimit?: Maybe<Scalars['Float']>;
  registrationPriceUnitAmount?: Maybe<Scalars['Float']>;
  sourceRegistrationCount?: Maybe<Scalars['Float']>;
  timezoneOffsetMinutes?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "events" */
export type EventsVarianceOrderBy = {
  courtCostPerPlayerUnitAmount?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  numberOfCourts?: InputMaybe<OrderBy>;
  participantLimit?: InputMaybe<OrderBy>;
  registrationPriceUnitAmount?: InputMaybe<OrderBy>;
  sourceRegistrationCount?: InputMaybe<OrderBy>;
  timezoneOffsetMinutes?: InputMaybe<OrderBy>;
};

/** columns and relationships of "feedback_sentiment" */
export type FeedbackSentiment = {
  __typename?: 'FeedbackSentiment';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "feedback_sentiment" */
export type FeedbackSentimentAggregate = {
  __typename?: 'FeedbackSentimentAggregate';
  aggregate?: Maybe<FeedbackSentimentAggregateFields>;
  nodes: Array<FeedbackSentiment>;
};

/** aggregate fields of "feedback_sentiment" */
export type FeedbackSentimentAggregateFields = {
  __typename?: 'FeedbackSentimentAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<FeedbackSentimentMaxFields>;
  min?: Maybe<FeedbackSentimentMinFields>;
};


/** aggregate fields of "feedback_sentiment" */
export type FeedbackSentimentAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<FeedbackSentimentSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "feedback_sentiment". All fields are combined with a logical 'AND'. */
export type FeedbackSentimentBoolExp = {
  _and?: InputMaybe<Array<FeedbackSentimentBoolExp>>;
  _not?: InputMaybe<FeedbackSentimentBoolExp>;
  _or?: InputMaybe<Array<FeedbackSentimentBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "feedback_sentiment" */
export enum FeedbackSentimentConstraint {
  /** unique or primary key constraint on columns "value" */
  FeedbackSentimentPkey = 'feedback_sentiment_pkey'
}

export enum FeedbackSentimentEnum {
  Critical = 'CRITICAL',
  Neutral = 'NEUTRAL',
  Positive = 'POSITIVE'
}

/** Boolean expression to compare columns of type "FeedbackSentimentEnum". All fields are combined with logical 'AND'. */
export type FeedbackSentimentEnumComparisonExp = {
  _eq?: InputMaybe<FeedbackSentimentEnum>;
  _in?: InputMaybe<Array<FeedbackSentimentEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<FeedbackSentimentEnum>;
  _nin?: InputMaybe<Array<FeedbackSentimentEnum>>;
};

/** input type for inserting data into table "feedback_sentiment" */
export type FeedbackSentimentInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type FeedbackSentimentMaxFields = {
  __typename?: 'FeedbackSentimentMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type FeedbackSentimentMinFields = {
  __typename?: 'FeedbackSentimentMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "feedback_sentiment" */
export type FeedbackSentimentMutationResponse = {
  __typename?: 'FeedbackSentimentMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<FeedbackSentiment>;
};

/** on_conflict condition type for table "feedback_sentiment" */
export type FeedbackSentimentOnConflict = {
  constraint: FeedbackSentimentConstraint;
  updateColumns?: Array<FeedbackSentimentUpdateColumn>;
  where?: InputMaybe<FeedbackSentimentBoolExp>;
};

/** Ordering options when selecting data from "feedback_sentiment". */
export type FeedbackSentimentOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: feedback_sentiment */
export type FeedbackSentimentPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "feedback_sentiment" */
export enum FeedbackSentimentSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "feedback_sentiment" */
export type FeedbackSentimentSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "feedback_sentiment" */
export type FeedbackSentimentStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: FeedbackSentimentStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type FeedbackSentimentStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "feedback_sentiment" */
export enum FeedbackSentimentUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type FeedbackSentimentUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<FeedbackSentimentSetInput>;
  /** filter the rows which have to be updated */
  where: FeedbackSentimentBoolExp;
};

/** columns and relationships of "file_category" */
export type FileCategory = {
  __typename?: 'FileCategory';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "file_category" */
export type FileCategoryAggregate = {
  __typename?: 'FileCategoryAggregate';
  aggregate?: Maybe<FileCategoryAggregateFields>;
  nodes: Array<FileCategory>;
};

/** aggregate fields of "file_category" */
export type FileCategoryAggregateFields = {
  __typename?: 'FileCategoryAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<FileCategoryMaxFields>;
  min?: Maybe<FileCategoryMinFields>;
};


/** aggregate fields of "file_category" */
export type FileCategoryAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<FileCategorySelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "file_category". All fields are combined with a logical 'AND'. */
export type FileCategoryBoolExp = {
  _and?: InputMaybe<Array<FileCategoryBoolExp>>;
  _not?: InputMaybe<FileCategoryBoolExp>;
  _or?: InputMaybe<Array<FileCategoryBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "file_category" */
export enum FileCategoryConstraint {
  /** unique or primary key constraint on columns "value" */
  FileCategoryPkey = 'file_category_pkey'
}

export enum FileCategoryEnum {
  Coach = 'COACH',
  Other = 'OTHER',
  PlayerGallery = 'PLAYER_GALLERY',
  Profile = 'PROFILE'
}

/** Boolean expression to compare columns of type "FileCategoryEnum". All fields are combined with logical 'AND'. */
export type FileCategoryEnumComparisonExp = {
  _eq?: InputMaybe<FileCategoryEnum>;
  _in?: InputMaybe<Array<FileCategoryEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<FileCategoryEnum>;
  _nin?: InputMaybe<Array<FileCategoryEnum>>;
};

/** input type for inserting data into table "file_category" */
export type FileCategoryInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type FileCategoryMaxFields = {
  __typename?: 'FileCategoryMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type FileCategoryMinFields = {
  __typename?: 'FileCategoryMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "file_category" */
export type FileCategoryMutationResponse = {
  __typename?: 'FileCategoryMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<FileCategory>;
};

/** on_conflict condition type for table "file_category" */
export type FileCategoryOnConflict = {
  constraint: FileCategoryConstraint;
  updateColumns?: Array<FileCategoryUpdateColumn>;
  where?: InputMaybe<FileCategoryBoolExp>;
};

/** Ordering options when selecting data from "file_category". */
export type FileCategoryOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: file_category */
export type FileCategoryPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "file_category" */
export enum FileCategorySelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "file_category" */
export type FileCategorySetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "file_category" */
export type FileCategoryStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: FileCategoryStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type FileCategoryStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "file_category" */
export enum FileCategoryUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type FileCategoryUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<FileCategorySetInput>;
  /** filter the rows which have to be updated */
  where: FileCategoryBoolExp;
};

/** columns and relationships of "file_format" */
export type FileFormat = {
  __typename?: 'FileFormat';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "file_format" */
export type FileFormatAggregate = {
  __typename?: 'FileFormatAggregate';
  aggregate?: Maybe<FileFormatAggregateFields>;
  nodes: Array<FileFormat>;
};

/** aggregate fields of "file_format" */
export type FileFormatAggregateFields = {
  __typename?: 'FileFormatAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<FileFormatMaxFields>;
  min?: Maybe<FileFormatMinFields>;
};


/** aggregate fields of "file_format" */
export type FileFormatAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<FileFormatSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "file_format". All fields are combined with a logical 'AND'. */
export type FileFormatBoolExp = {
  _and?: InputMaybe<Array<FileFormatBoolExp>>;
  _not?: InputMaybe<FileFormatBoolExp>;
  _or?: InputMaybe<Array<FileFormatBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "file_format" */
export enum FileFormatConstraint {
  /** unique or primary key constraint on columns "value" */
  FileFormatPkey = 'file_format_pkey'
}

export enum FileFormatEnum {
  Audio = 'AUDIO',
  Image = 'IMAGE',
  Video = 'VIDEO'
}

/** Boolean expression to compare columns of type "FileFormatEnum". All fields are combined with logical 'AND'. */
export type FileFormatEnumComparisonExp = {
  _eq?: InputMaybe<FileFormatEnum>;
  _in?: InputMaybe<Array<FileFormatEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<FileFormatEnum>;
  _nin?: InputMaybe<Array<FileFormatEnum>>;
};

/** input type for inserting data into table "file_format" */
export type FileFormatInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type FileFormatMaxFields = {
  __typename?: 'FileFormatMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type FileFormatMinFields = {
  __typename?: 'FileFormatMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "file_format" */
export type FileFormatMutationResponse = {
  __typename?: 'FileFormatMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<FileFormat>;
};

/** on_conflict condition type for table "file_format" */
export type FileFormatOnConflict = {
  constraint: FileFormatConstraint;
  updateColumns?: Array<FileFormatUpdateColumn>;
  where?: InputMaybe<FileFormatBoolExp>;
};

/** Ordering options when selecting data from "file_format". */
export type FileFormatOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: file_format */
export type FileFormatPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "file_format" */
export enum FileFormatSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "file_format" */
export type FileFormatSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "file_format" */
export type FileFormatStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: FileFormatStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type FileFormatStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "file_format" */
export enum FileFormatUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type FileFormatUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<FileFormatSetInput>;
  /** filter the rows which have to be updated */
  where: FileFormatBoolExp;
};

/** columns and relationships of "follow_statuses" */
export type FollowStatuses = {
  __typename?: 'FollowStatuses';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "follow_statuses" */
export type FollowStatusesAggregate = {
  __typename?: 'FollowStatusesAggregate';
  aggregate?: Maybe<FollowStatusesAggregateFields>;
  nodes: Array<FollowStatuses>;
};

/** aggregate fields of "follow_statuses" */
export type FollowStatusesAggregateFields = {
  __typename?: 'FollowStatusesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<FollowStatusesMaxFields>;
  min?: Maybe<FollowStatusesMinFields>;
};


/** aggregate fields of "follow_statuses" */
export type FollowStatusesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<FollowStatusesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "follow_statuses". All fields are combined with a logical 'AND'. */
export type FollowStatusesBoolExp = {
  _and?: InputMaybe<Array<FollowStatusesBoolExp>>;
  _not?: InputMaybe<FollowStatusesBoolExp>;
  _or?: InputMaybe<Array<FollowStatusesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "follow_statuses" */
export enum FollowStatusesConstraint {
  /** unique or primary key constraint on columns "value" */
  FollowStatusesPkey = 'follow_statuses_pkey'
}

export enum FollowStatusesEnum {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

/** Boolean expression to compare columns of type "FollowStatusesEnum". All fields are combined with logical 'AND'. */
export type FollowStatusesEnumComparisonExp = {
  _eq?: InputMaybe<FollowStatusesEnum>;
  _in?: InputMaybe<Array<FollowStatusesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<FollowStatusesEnum>;
  _nin?: InputMaybe<Array<FollowStatusesEnum>>;
};

/** input type for inserting data into table "follow_statuses" */
export type FollowStatusesInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type FollowStatusesMaxFields = {
  __typename?: 'FollowStatusesMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type FollowStatusesMinFields = {
  __typename?: 'FollowStatusesMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "follow_statuses" */
export type FollowStatusesMutationResponse = {
  __typename?: 'FollowStatusesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<FollowStatuses>;
};

/** on_conflict condition type for table "follow_statuses" */
export type FollowStatusesOnConflict = {
  constraint: FollowStatusesConstraint;
  updateColumns?: Array<FollowStatusesUpdateColumn>;
  where?: InputMaybe<FollowStatusesBoolExp>;
};

/** Ordering options when selecting data from "follow_statuses". */
export type FollowStatusesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: follow_statuses */
export type FollowStatusesPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "follow_statuses" */
export enum FollowStatusesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "follow_statuses" */
export type FollowStatusesSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "follow_statuses" */
export type FollowStatusesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: FollowStatusesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type FollowStatusesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "follow_statuses" */
export enum FollowStatusesUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type FollowStatusesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<FollowStatusesSetInput>;
  /** filter the rows which have to be updated */
  where: FollowStatusesBoolExp;
};

/** columns and relationships of "game_net_statuses" */
export type GameNetStatuses = {
  __typename?: 'GameNetStatuses';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "game_net_statuses" */
export type GameNetStatusesAggregate = {
  __typename?: 'GameNetStatusesAggregate';
  aggregate?: Maybe<GameNetStatusesAggregateFields>;
  nodes: Array<GameNetStatuses>;
};

/** aggregate fields of "game_net_statuses" */
export type GameNetStatusesAggregateFields = {
  __typename?: 'GameNetStatusesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<GameNetStatusesMaxFields>;
  min?: Maybe<GameNetStatusesMinFields>;
};


/** aggregate fields of "game_net_statuses" */
export type GameNetStatusesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<GameNetStatusesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "game_net_statuses". All fields are combined with a logical 'AND'. */
export type GameNetStatusesBoolExp = {
  _and?: InputMaybe<Array<GameNetStatusesBoolExp>>;
  _not?: InputMaybe<GameNetStatusesBoolExp>;
  _or?: InputMaybe<Array<GameNetStatusesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "game_net_statuses" */
export enum GameNetStatusesConstraint {
  /** unique or primary key constraint on columns "value" */
  GameNetStatusesPkey = 'game_net_statuses_pkey'
}

export enum GameNetStatusesEnum {
  /** The host is bringing a net */
  HostBrings = 'HOST_BRINGS',
  /** No net available */
  None = 'NONE',
  /** The venue provides a net */
  VenueProvided = 'VENUE_PROVIDED'
}

/** Boolean expression to compare columns of type "GameNetStatusesEnum". All fields are combined with logical 'AND'. */
export type GameNetStatusesEnumComparisonExp = {
  _eq?: InputMaybe<GameNetStatusesEnum>;
  _in?: InputMaybe<Array<GameNetStatusesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<GameNetStatusesEnum>;
  _nin?: InputMaybe<Array<GameNetStatusesEnum>>;
};

/** input type for inserting data into table "game_net_statuses" */
export type GameNetStatusesInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type GameNetStatusesMaxFields = {
  __typename?: 'GameNetStatusesMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type GameNetStatusesMinFields = {
  __typename?: 'GameNetStatusesMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "game_net_statuses" */
export type GameNetStatusesMutationResponse = {
  __typename?: 'GameNetStatusesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<GameNetStatuses>;
};

/** on_conflict condition type for table "game_net_statuses" */
export type GameNetStatusesOnConflict = {
  constraint: GameNetStatusesConstraint;
  updateColumns?: Array<GameNetStatusesUpdateColumn>;
  where?: InputMaybe<GameNetStatusesBoolExp>;
};

/** Ordering options when selecting data from "game_net_statuses". */
export type GameNetStatusesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: game_net_statuses */
export type GameNetStatusesPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "game_net_statuses" */
export enum GameNetStatusesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "game_net_statuses" */
export type GameNetStatusesSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "game_net_statuses" */
export type GameNetStatusesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: GameNetStatusesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type GameNetStatusesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "game_net_statuses" */
export enum GameNetStatusesUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type GameNetStatusesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<GameNetStatusesSetInput>;
  /** filter the rows which have to be updated */
  where: GameNetStatusesBoolExp;
};

/** columns and relationships of "gender" */
export type Gender = {
  __typename?: 'Gender';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "gender" */
export type GenderAggregate = {
  __typename?: 'GenderAggregate';
  aggregate?: Maybe<GenderAggregateFields>;
  nodes: Array<Gender>;
};

/** aggregate fields of "gender" */
export type GenderAggregateFields = {
  __typename?: 'GenderAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<GenderMaxFields>;
  min?: Maybe<GenderMinFields>;
};


/** aggregate fields of "gender" */
export type GenderAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<GenderSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "gender". All fields are combined with a logical 'AND'. */
export type GenderBoolExp = {
  _and?: InputMaybe<Array<GenderBoolExp>>;
  _not?: InputMaybe<GenderBoolExp>;
  _or?: InputMaybe<Array<GenderBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "gender" */
export enum GenderConstraint {
  /** unique or primary key constraint on columns "value" */
  GenderPkey = 'gender_pkey'
}

export enum GenderEnum {
  Female = 'FEMALE',
  Male = 'MALE',
  Nonbinary = 'NONBINARY',
  /** State your preference in a free text field */
  Preferred = 'PREFERRED',
  /** Choose not to disclose any gender */
  Private = 'PRIVATE'
}

/** Boolean expression to compare columns of type "GenderEnum". All fields are combined with logical 'AND'. */
export type GenderEnumComparisonExp = {
  _eq?: InputMaybe<GenderEnum>;
  _in?: InputMaybe<Array<GenderEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<GenderEnum>;
  _nin?: InputMaybe<Array<GenderEnum>>;
};

/** input type for inserting data into table "gender" */
export type GenderInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type GenderMaxFields = {
  __typename?: 'GenderMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type GenderMinFields = {
  __typename?: 'GenderMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "gender" */
export type GenderMutationResponse = {
  __typename?: 'GenderMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Gender>;
};

/** on_conflict condition type for table "gender" */
export type GenderOnConflict = {
  constraint: GenderConstraint;
  updateColumns?: Array<GenderUpdateColumn>;
  where?: InputMaybe<GenderBoolExp>;
};

/** Ordering options when selecting data from "gender". */
export type GenderOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: gender */
export type GenderPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "gender" */
export enum GenderSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "gender" */
export type GenderSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "gender" */
export type GenderStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: GenderStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type GenderStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "gender" */
export enum GenderUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type GenderUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<GenderSetInput>;
  /** filter the rows which have to be updated */
  where: GenderBoolExp;
};

export type GeographyCastExp = {
  geometry?: InputMaybe<GeometryComparisonExp>;
};

/** Boolean expression to compare columns of type "geography". All fields are combined with logical 'AND'. */
export type GeographyComparisonExp = {
  _cast?: InputMaybe<GeographyCastExp>;
  _eq?: InputMaybe<Scalars['geography']>;
  _gt?: InputMaybe<Scalars['geography']>;
  _gte?: InputMaybe<Scalars['geography']>;
  _in?: InputMaybe<Array<Scalars['geography']>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['geography']>;
  _lte?: InputMaybe<Scalars['geography']>;
  _neq?: InputMaybe<Scalars['geography']>;
  _nin?: InputMaybe<Array<Scalars['geography']>>;
  /** is the column within a given distance from the given geography value */
  _stDWithin?: InputMaybe<St_D_Within_Geography_Input>;
  /** does the column spatially intersect the given geography value */
  _stIntersects?: InputMaybe<Scalars['geography']>;
};

export type GeometryCastExp = {
  geography?: InputMaybe<GeographyComparisonExp>;
};

/** Boolean expression to compare columns of type "geometry". All fields are combined with logical 'AND'. */
export type GeometryComparisonExp = {
  _cast?: InputMaybe<GeometryCastExp>;
  _eq?: InputMaybe<Scalars['geometry']>;
  _gt?: InputMaybe<Scalars['geometry']>;
  _gte?: InputMaybe<Scalars['geometry']>;
  _in?: InputMaybe<Array<Scalars['geometry']>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['geometry']>;
  _lte?: InputMaybe<Scalars['geometry']>;
  _neq?: InputMaybe<Scalars['geometry']>;
  _nin?: InputMaybe<Array<Scalars['geometry']>>;
  /** is the column within a given 3D distance from the given geometry value */
  _st3dDWithin?: InputMaybe<St_D_Within_Input>;
  /** does the column spatially intersect the given geometry value in 3D */
  _st3dIntersects?: InputMaybe<Scalars['geometry']>;
  /** does the column contain the given geometry value */
  _stContains?: InputMaybe<Scalars['geometry']>;
  /** does the column cross the given geometry value */
  _stCrosses?: InputMaybe<Scalars['geometry']>;
  /** is the column within a given distance from the given geometry value */
  _stDWithin?: InputMaybe<St_D_Within_Input>;
  /** is the column equal to given geometry value (directionality is ignored) */
  _stEquals?: InputMaybe<Scalars['geometry']>;
  /** does the column spatially intersect the given geometry value */
  _stIntersects?: InputMaybe<Scalars['geometry']>;
  /** does the column 'spatially overlap' (intersect but not completely contain) the given geometry value */
  _stOverlaps?: InputMaybe<Scalars['geometry']>;
  /** does the column have atleast one point in common with the given geometry value */
  _stTouches?: InputMaybe<Scalars['geometry']>;
  /** is the column contained in the given geometry value */
  _stWithin?: InputMaybe<Scalars['geometry']>;
};

/** columns and relationships of "group_comment_votes" */
export type GroupCommentVotes = {
  __typename?: 'GroupCommentVotes';
  /** An object relationship */
  comment: GroupThreadComments;
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  groupThreadCommentId: Scalars['uuid'];
  id: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid'];
  vote: CommentVoteEnum;
};

/** aggregated selection of "group_comment_votes" */
export type GroupCommentVotesAggregate = {
  __typename?: 'GroupCommentVotesAggregate';
  aggregate?: Maybe<GroupCommentVotesAggregateFields>;
  nodes: Array<GroupCommentVotes>;
};

export type GroupCommentVotesAggregateBoolExp = {
  count?: InputMaybe<GroupCommentVotesAggregateBoolExpCount>;
};

/** aggregate fields of "group_comment_votes" */
export type GroupCommentVotesAggregateFields = {
  __typename?: 'GroupCommentVotesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<GroupCommentVotesMaxFields>;
  min?: Maybe<GroupCommentVotesMinFields>;
};


/** aggregate fields of "group_comment_votes" */
export type GroupCommentVotesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<GroupCommentVotesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "group_comment_votes" */
export type GroupCommentVotesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<GroupCommentVotesMaxOrderBy>;
  min?: InputMaybe<GroupCommentVotesMinOrderBy>;
};

/** input type for inserting array relation for remote table "group_comment_votes" */
export type GroupCommentVotesArrRelInsertInput = {
  data: Array<GroupCommentVotesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<GroupCommentVotesOnConflict>;
};

/** Boolean expression to filter rows from the table "group_comment_votes". All fields are combined with a logical 'AND'. */
export type GroupCommentVotesBoolExp = {
  _and?: InputMaybe<Array<GroupCommentVotesBoolExp>>;
  _not?: InputMaybe<GroupCommentVotesBoolExp>;
  _or?: InputMaybe<Array<GroupCommentVotesBoolExp>>;
  comment?: InputMaybe<GroupThreadCommentsBoolExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  groupThreadCommentId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
  vote?: InputMaybe<CommentVoteEnumComparisonExp>;
};

/** unique or primary key constraints on table "group_comment_votes" */
export enum GroupCommentVotesConstraint {
  /** unique or primary key constraint on columns "user_id", "group_thread_comment_id" */
  GroupCommentVotesGroupThreadCommentIdUserIdKey = 'group_comment_votes_group_thread_comment_id_user_id_key',
  /** unique or primary key constraint on columns "id" */
  GroupCommentVotesPkey = 'group_comment_votes_pkey'
}

/** input type for inserting data into table "group_comment_votes" */
export type GroupCommentVotesInsertInput = {
  comment?: InputMaybe<GroupThreadCommentsObjRelInsertInput>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  groupThreadCommentId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']>;
  vote?: InputMaybe<CommentVoteEnum>;
};

/** aggregate max on columns */
export type GroupCommentVotesMaxFields = {
  __typename?: 'GroupCommentVotesMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  groupThreadCommentId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "group_comment_votes" */
export type GroupCommentVotesMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  groupThreadCommentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type GroupCommentVotesMinFields = {
  __typename?: 'GroupCommentVotesMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  groupThreadCommentId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "group_comment_votes" */
export type GroupCommentVotesMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  groupThreadCommentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "group_comment_votes" */
export type GroupCommentVotesMutationResponse = {
  __typename?: 'GroupCommentVotesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<GroupCommentVotes>;
};

/** on_conflict condition type for table "group_comment_votes" */
export type GroupCommentVotesOnConflict = {
  constraint: GroupCommentVotesConstraint;
  updateColumns?: Array<GroupCommentVotesUpdateColumn>;
  where?: InputMaybe<GroupCommentVotesBoolExp>;
};

/** Ordering options when selecting data from "group_comment_votes". */
export type GroupCommentVotesOrderBy = {
  comment?: InputMaybe<GroupThreadCommentsOrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  groupThreadCommentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
  vote?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: group_comment_votes */
export type GroupCommentVotesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "group_comment_votes" */
export enum GroupCommentVotesSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  GroupThreadCommentId = 'groupThreadCommentId',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId',
  /** column name */
  Vote = 'vote'
}

/** input type for updating data in table "group_comment_votes" */
export type GroupCommentVotesSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  groupThreadCommentId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
  vote?: InputMaybe<CommentVoteEnum>;
};

/** Streaming cursor of the table "group_comment_votes" */
export type GroupCommentVotesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: GroupCommentVotesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type GroupCommentVotesStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  groupThreadCommentId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
  vote?: InputMaybe<CommentVoteEnum>;
};

/** update columns of table "group_comment_votes" */
export enum GroupCommentVotesUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  GroupThreadCommentId = 'groupThreadCommentId',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId',
  /** column name */
  Vote = 'vote'
}

export type GroupCommentVotesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<GroupCommentVotesSetInput>;
  /** filter the rows which have to be updated */
  where: GroupCommentVotesBoolExp;
};

/** columns and relationships of "group_members" */
export type GroupMembers = {
  __typename?: 'GroupMembers';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  group: Groups;
  groupId: Scalars['uuid'];
  id: Scalars['uuid'];
  isActive: Scalars['Boolean'];
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid'];
  /** An object relationship */
  userProfile?: Maybe<UserProfiles>;
};

/** aggregated selection of "group_members" */
export type GroupMembersAggregate = {
  __typename?: 'GroupMembersAggregate';
  aggregate?: Maybe<GroupMembersAggregateFields>;
  nodes: Array<GroupMembers>;
};

export type GroupMembersAggregateBoolExp = {
  bool_and?: InputMaybe<GroupMembersAggregateBoolExpBool_And>;
  bool_or?: InputMaybe<GroupMembersAggregateBoolExpBool_Or>;
  count?: InputMaybe<GroupMembersAggregateBoolExpCount>;
};

/** aggregate fields of "group_members" */
export type GroupMembersAggregateFields = {
  __typename?: 'GroupMembersAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<GroupMembersMaxFields>;
  min?: Maybe<GroupMembersMinFields>;
};


/** aggregate fields of "group_members" */
export type GroupMembersAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<GroupMembersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "group_members" */
export type GroupMembersAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<GroupMembersMaxOrderBy>;
  min?: InputMaybe<GroupMembersMinOrderBy>;
};

/** input type for inserting array relation for remote table "group_members" */
export type GroupMembersArrRelInsertInput = {
  data: Array<GroupMembersInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<GroupMembersOnConflict>;
};

/** Boolean expression to filter rows from the table "group_members". All fields are combined with a logical 'AND'. */
export type GroupMembersBoolExp = {
  _and?: InputMaybe<Array<GroupMembersBoolExp>>;
  _not?: InputMaybe<GroupMembersBoolExp>;
  _or?: InputMaybe<Array<GroupMembersBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  group?: InputMaybe<GroupsBoolExp>;
  groupId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isActive?: InputMaybe<BooleanComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
  userProfile?: InputMaybe<UserProfilesBoolExp>;
};

/** unique or primary key constraints on table "group_members" */
export enum GroupMembersConstraint {
  /** unique or primary key constraint on columns "user_id", "group_id" */
  GroupMembersGroupIdUserIdKey = 'group_members_group_id_user_id_key',
  /** unique or primary key constraint on columns "id" */
  GroupMembersPkey = 'group_members_pkey'
}

/** input type for inserting data into table "group_members" */
export type GroupMembersInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  group?: InputMaybe<GroupsObjRelInsertInput>;
  groupId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']>;
  userProfile?: InputMaybe<UserProfilesObjRelInsertInput>;
};

/** aggregate max on columns */
export type GroupMembersMaxFields = {
  __typename?: 'GroupMembersMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  groupId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "group_members" */
export type GroupMembersMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type GroupMembersMinFields = {
  __typename?: 'GroupMembersMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  groupId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "group_members" */
export type GroupMembersMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "group_members" */
export type GroupMembersMutationResponse = {
  __typename?: 'GroupMembersMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<GroupMembers>;
};

/** on_conflict condition type for table "group_members" */
export type GroupMembersOnConflict = {
  constraint: GroupMembersConstraint;
  updateColumns?: Array<GroupMembersUpdateColumn>;
  where?: InputMaybe<GroupMembersBoolExp>;
};

/** Ordering options when selecting data from "group_members". */
export type GroupMembersOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  group?: InputMaybe<GroupsOrderBy>;
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  isActive?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
  userProfile?: InputMaybe<UserProfilesOrderBy>;
};

/** primary key columns input for table: group_members */
export type GroupMembersPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "group_members" */
export enum GroupMembersSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  GroupId = 'groupId',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'isActive',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** select "groupMembersAggregateBoolExpBool_andArgumentsColumns" columns of table "group_members" */
export enum GroupMembersSelectColumnGroupMembersAggregateBoolExpBool_AndArgumentsColumns {
  /** column name */
  IsActive = 'isActive'
}

/** select "groupMembersAggregateBoolExpBool_orArgumentsColumns" columns of table "group_members" */
export enum GroupMembersSelectColumnGroupMembersAggregateBoolExpBool_OrArgumentsColumns {
  /** column name */
  IsActive = 'isActive'
}

/** input type for updating data in table "group_members" */
export type GroupMembersSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  groupId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "group_members" */
export type GroupMembersStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: GroupMembersStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type GroupMembersStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  groupId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "group_members" */
export enum GroupMembersUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  GroupId = 'groupId',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'isActive',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

export type GroupMembersUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<GroupMembersSetInput>;
  /** filter the rows which have to be updated */
  where: GroupMembersBoolExp;
};

/** columns and relationships of "group_thread_comment_files" */
export type GroupThreadCommentFiles = {
  __typename?: 'GroupThreadCommentFiles';
  /** An object relationship */
  comment: GroupThreadComments;
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  fileName: Scalars['String'];
  fileType: Scalars['String'];
  groupThreadCommentId: Scalars['uuid'];
  host: Scalars['String'];
  id: Scalars['uuid'];
  isVisible: Scalars['Boolean'];
  originalFileName?: Maybe<Scalars['String']>;
  path: Scalars['String'];
  provider: Scalars['String'];
  providerUrl: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  url: Scalars['String'];
  userId: Scalars['uuid'];
};

/** aggregated selection of "group_thread_comment_files" */
export type GroupThreadCommentFilesAggregate = {
  __typename?: 'GroupThreadCommentFilesAggregate';
  aggregate?: Maybe<GroupThreadCommentFilesAggregateFields>;
  nodes: Array<GroupThreadCommentFiles>;
};

export type GroupThreadCommentFilesAggregateBoolExp = {
  bool_and?: InputMaybe<GroupThreadCommentFilesAggregateBoolExpBool_And>;
  bool_or?: InputMaybe<GroupThreadCommentFilesAggregateBoolExpBool_Or>;
  count?: InputMaybe<GroupThreadCommentFilesAggregateBoolExpCount>;
};

/** aggregate fields of "group_thread_comment_files" */
export type GroupThreadCommentFilesAggregateFields = {
  __typename?: 'GroupThreadCommentFilesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<GroupThreadCommentFilesMaxFields>;
  min?: Maybe<GroupThreadCommentFilesMinFields>;
};


/** aggregate fields of "group_thread_comment_files" */
export type GroupThreadCommentFilesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<GroupThreadCommentFilesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "group_thread_comment_files" */
export type GroupThreadCommentFilesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<GroupThreadCommentFilesMaxOrderBy>;
  min?: InputMaybe<GroupThreadCommentFilesMinOrderBy>;
};

/** input type for inserting array relation for remote table "group_thread_comment_files" */
export type GroupThreadCommentFilesArrRelInsertInput = {
  data: Array<GroupThreadCommentFilesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<GroupThreadCommentFilesOnConflict>;
};

/** Boolean expression to filter rows from the table "group_thread_comment_files". All fields are combined with a logical 'AND'. */
export type GroupThreadCommentFilesBoolExp = {
  _and?: InputMaybe<Array<GroupThreadCommentFilesBoolExp>>;
  _not?: InputMaybe<GroupThreadCommentFilesBoolExp>;
  _or?: InputMaybe<Array<GroupThreadCommentFilesBoolExp>>;
  comment?: InputMaybe<GroupThreadCommentsBoolExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  fileName?: InputMaybe<StringComparisonExp>;
  fileType?: InputMaybe<StringComparisonExp>;
  groupThreadCommentId?: InputMaybe<UuidComparisonExp>;
  host?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isVisible?: InputMaybe<BooleanComparisonExp>;
  originalFileName?: InputMaybe<StringComparisonExp>;
  path?: InputMaybe<StringComparisonExp>;
  provider?: InputMaybe<StringComparisonExp>;
  providerUrl?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  url?: InputMaybe<StringComparisonExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "group_thread_comment_files" */
export enum GroupThreadCommentFilesConstraint {
  /** unique or primary key constraint on columns "id" */
  GroupThreadCommentFilesPkey = 'group_thread_comment_files_pkey'
}

/** input type for inserting data into table "group_thread_comment_files" */
export type GroupThreadCommentFilesInsertInput = {
  comment?: InputMaybe<GroupThreadCommentsObjRelInsertInput>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  fileName?: InputMaybe<Scalars['String']>;
  fileType?: InputMaybe<Scalars['String']>;
  groupThreadCommentId?: InputMaybe<Scalars['uuid']>;
  host?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  isVisible?: InputMaybe<Scalars['Boolean']>;
  originalFileName?: InputMaybe<Scalars['String']>;
  path?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  providerUrl?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  url?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type GroupThreadCommentFilesMaxFields = {
  __typename?: 'GroupThreadCommentFilesMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  fileName?: Maybe<Scalars['String']>;
  fileType?: Maybe<Scalars['String']>;
  groupThreadCommentId?: Maybe<Scalars['uuid']>;
  host?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  originalFileName?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  providerUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  url?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "group_thread_comment_files" */
export type GroupThreadCommentFilesMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  fileName?: InputMaybe<OrderBy>;
  fileType?: InputMaybe<OrderBy>;
  groupThreadCommentId?: InputMaybe<OrderBy>;
  host?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  originalFileName?: InputMaybe<OrderBy>;
  path?: InputMaybe<OrderBy>;
  provider?: InputMaybe<OrderBy>;
  providerUrl?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  url?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type GroupThreadCommentFilesMinFields = {
  __typename?: 'GroupThreadCommentFilesMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  fileName?: Maybe<Scalars['String']>;
  fileType?: Maybe<Scalars['String']>;
  groupThreadCommentId?: Maybe<Scalars['uuid']>;
  host?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  originalFileName?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  providerUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  url?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "group_thread_comment_files" */
export type GroupThreadCommentFilesMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  fileName?: InputMaybe<OrderBy>;
  fileType?: InputMaybe<OrderBy>;
  groupThreadCommentId?: InputMaybe<OrderBy>;
  host?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  originalFileName?: InputMaybe<OrderBy>;
  path?: InputMaybe<OrderBy>;
  provider?: InputMaybe<OrderBy>;
  providerUrl?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  url?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "group_thread_comment_files" */
export type GroupThreadCommentFilesMutationResponse = {
  __typename?: 'GroupThreadCommentFilesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<GroupThreadCommentFiles>;
};

/** on_conflict condition type for table "group_thread_comment_files" */
export type GroupThreadCommentFilesOnConflict = {
  constraint: GroupThreadCommentFilesConstraint;
  updateColumns?: Array<GroupThreadCommentFilesUpdateColumn>;
  where?: InputMaybe<GroupThreadCommentFilesBoolExp>;
};

/** Ordering options when selecting data from "group_thread_comment_files". */
export type GroupThreadCommentFilesOrderBy = {
  comment?: InputMaybe<GroupThreadCommentsOrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  fileName?: InputMaybe<OrderBy>;
  fileType?: InputMaybe<OrderBy>;
  groupThreadCommentId?: InputMaybe<OrderBy>;
  host?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  isVisible?: InputMaybe<OrderBy>;
  originalFileName?: InputMaybe<OrderBy>;
  path?: InputMaybe<OrderBy>;
  provider?: InputMaybe<OrderBy>;
  providerUrl?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  url?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: group_thread_comment_files */
export type GroupThreadCommentFilesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "group_thread_comment_files" */
export enum GroupThreadCommentFilesSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  FileName = 'fileName',
  /** column name */
  FileType = 'fileType',
  /** column name */
  GroupThreadCommentId = 'groupThreadCommentId',
  /** column name */
  Host = 'host',
  /** column name */
  Id = 'id',
  /** column name */
  IsVisible = 'isVisible',
  /** column name */
  OriginalFileName = 'originalFileName',
  /** column name */
  Path = 'path',
  /** column name */
  Provider = 'provider',
  /** column name */
  ProviderUrl = 'providerUrl',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Url = 'url',
  /** column name */
  UserId = 'userId'
}

/** select "groupThreadCommentFilesAggregateBoolExpBool_andArgumentsColumns" columns of table "group_thread_comment_files" */
export enum GroupThreadCommentFilesSelectColumnGroupThreadCommentFilesAggregateBoolExpBool_AndArgumentsColumns {
  /** column name */
  IsVisible = 'isVisible'
}

/** select "groupThreadCommentFilesAggregateBoolExpBool_orArgumentsColumns" columns of table "group_thread_comment_files" */
export enum GroupThreadCommentFilesSelectColumnGroupThreadCommentFilesAggregateBoolExpBool_OrArgumentsColumns {
  /** column name */
  IsVisible = 'isVisible'
}

/** input type for updating data in table "group_thread_comment_files" */
export type GroupThreadCommentFilesSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  fileName?: InputMaybe<Scalars['String']>;
  fileType?: InputMaybe<Scalars['String']>;
  groupThreadCommentId?: InputMaybe<Scalars['uuid']>;
  host?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  isVisible?: InputMaybe<Scalars['Boolean']>;
  originalFileName?: InputMaybe<Scalars['String']>;
  path?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  providerUrl?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  url?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "group_thread_comment_files" */
export type GroupThreadCommentFilesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: GroupThreadCommentFilesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type GroupThreadCommentFilesStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  fileName?: InputMaybe<Scalars['String']>;
  fileType?: InputMaybe<Scalars['String']>;
  groupThreadCommentId?: InputMaybe<Scalars['uuid']>;
  host?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  isVisible?: InputMaybe<Scalars['Boolean']>;
  originalFileName?: InputMaybe<Scalars['String']>;
  path?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  providerUrl?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  url?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "group_thread_comment_files" */
export enum GroupThreadCommentFilesUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  FileName = 'fileName',
  /** column name */
  FileType = 'fileType',
  /** column name */
  GroupThreadCommentId = 'groupThreadCommentId',
  /** column name */
  Host = 'host',
  /** column name */
  Id = 'id',
  /** column name */
  IsVisible = 'isVisible',
  /** column name */
  OriginalFileName = 'originalFileName',
  /** column name */
  Path = 'path',
  /** column name */
  Provider = 'provider',
  /** column name */
  ProviderUrl = 'providerUrl',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Url = 'url',
  /** column name */
  UserId = 'userId'
}

export type GroupThreadCommentFilesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<GroupThreadCommentFilesSetInput>;
  /** filter the rows which have to be updated */
  where: GroupThreadCommentFilesBoolExp;
};

/** columns and relationships of "group_thread_comments" */
export type GroupThreadComments = {
  __typename?: 'GroupThreadComments';
  /** An array relationship */
  allChildComments: Array<GroupThreadComments>;
  /** An aggregate relationship */
  allChildCommentsAggregate: GroupThreadCommentsAggregate;
  content: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  files: Array<GroupThreadCommentFiles>;
  /** An aggregate relationship */
  filesAggregate: GroupThreadCommentFilesAggregate;
  groupCommentId?: Maybe<Scalars['uuid']>;
  groupRootCommentId?: Maybe<Scalars['uuid']>;
  groupThreadId: Scalars['uuid'];
  id: Scalars['uuid'];
  isOriginalThreadComment: Scalars['Boolean'];
  /** An object relationship */
  parentComment?: Maybe<GroupThreadComments>;
  /** An array relationship */
  replies: Array<GroupThreadComments>;
  /** An aggregate relationship */
  repliesAggregate: GroupThreadCommentsAggregate;
  /** An object relationship */
  rootComment?: Maybe<GroupThreadComments>;
  /** An object relationship */
  thread: GroupThreads;
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user?: Maybe<Users>;
  userId: Scalars['uuid'];
  /** An object relationship */
  userProfile?: Maybe<UserProfiles>;
  /** An array relationship */
  votes: Array<GroupCommentVotes>;
  /** An aggregate relationship */
  votesAggregate: GroupCommentVotesAggregate;
};


/** columns and relationships of "group_thread_comments" */
export type GroupThreadCommentsAllChildCommentsArgs = {
  distinctOn?: InputMaybe<Array<GroupThreadCommentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupThreadCommentsOrderBy>>;
  where?: InputMaybe<GroupThreadCommentsBoolExp>;
};


/** columns and relationships of "group_thread_comments" */
export type GroupThreadCommentsAllChildCommentsAggregateArgs = {
  distinctOn?: InputMaybe<Array<GroupThreadCommentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupThreadCommentsOrderBy>>;
  where?: InputMaybe<GroupThreadCommentsBoolExp>;
};


/** columns and relationships of "group_thread_comments" */
export type GroupThreadCommentsFilesArgs = {
  distinctOn?: InputMaybe<Array<GroupThreadCommentFilesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupThreadCommentFilesOrderBy>>;
  where?: InputMaybe<GroupThreadCommentFilesBoolExp>;
};


/** columns and relationships of "group_thread_comments" */
export type GroupThreadCommentsFilesAggregateArgs = {
  distinctOn?: InputMaybe<Array<GroupThreadCommentFilesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupThreadCommentFilesOrderBy>>;
  where?: InputMaybe<GroupThreadCommentFilesBoolExp>;
};


/** columns and relationships of "group_thread_comments" */
export type GroupThreadCommentsRepliesArgs = {
  distinctOn?: InputMaybe<Array<GroupThreadCommentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupThreadCommentsOrderBy>>;
  where?: InputMaybe<GroupThreadCommentsBoolExp>;
};


/** columns and relationships of "group_thread_comments" */
export type GroupThreadCommentsRepliesAggregateArgs = {
  distinctOn?: InputMaybe<Array<GroupThreadCommentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupThreadCommentsOrderBy>>;
  where?: InputMaybe<GroupThreadCommentsBoolExp>;
};


/** columns and relationships of "group_thread_comments" */
export type GroupThreadCommentsVotesArgs = {
  distinctOn?: InputMaybe<Array<GroupCommentVotesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupCommentVotesOrderBy>>;
  where?: InputMaybe<GroupCommentVotesBoolExp>;
};


/** columns and relationships of "group_thread_comments" */
export type GroupThreadCommentsVotesAggregateArgs = {
  distinctOn?: InputMaybe<Array<GroupCommentVotesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupCommentVotesOrderBy>>;
  where?: InputMaybe<GroupCommentVotesBoolExp>;
};

/** aggregated selection of "group_thread_comments" */
export type GroupThreadCommentsAggregate = {
  __typename?: 'GroupThreadCommentsAggregate';
  aggregate?: Maybe<GroupThreadCommentsAggregateFields>;
  nodes: Array<GroupThreadComments>;
};

export type GroupThreadCommentsAggregateBoolExp = {
  bool_and?: InputMaybe<GroupThreadCommentsAggregateBoolExpBool_And>;
  bool_or?: InputMaybe<GroupThreadCommentsAggregateBoolExpBool_Or>;
  count?: InputMaybe<GroupThreadCommentsAggregateBoolExpCount>;
};

/** aggregate fields of "group_thread_comments" */
export type GroupThreadCommentsAggregateFields = {
  __typename?: 'GroupThreadCommentsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<GroupThreadCommentsMaxFields>;
  min?: Maybe<GroupThreadCommentsMinFields>;
};


/** aggregate fields of "group_thread_comments" */
export type GroupThreadCommentsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<GroupThreadCommentsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "group_thread_comments" */
export type GroupThreadCommentsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<GroupThreadCommentsMaxOrderBy>;
  min?: InputMaybe<GroupThreadCommentsMinOrderBy>;
};

/** input type for inserting array relation for remote table "group_thread_comments" */
export type GroupThreadCommentsArrRelInsertInput = {
  data: Array<GroupThreadCommentsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<GroupThreadCommentsOnConflict>;
};

/** Boolean expression to filter rows from the table "group_thread_comments". All fields are combined with a logical 'AND'. */
export type GroupThreadCommentsBoolExp = {
  _and?: InputMaybe<Array<GroupThreadCommentsBoolExp>>;
  _not?: InputMaybe<GroupThreadCommentsBoolExp>;
  _or?: InputMaybe<Array<GroupThreadCommentsBoolExp>>;
  allChildComments?: InputMaybe<GroupThreadCommentsBoolExp>;
  allChildCommentsAggregate?: InputMaybe<GroupThreadCommentsAggregateBoolExp>;
  content?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  files?: InputMaybe<GroupThreadCommentFilesBoolExp>;
  filesAggregate?: InputMaybe<GroupThreadCommentFilesAggregateBoolExp>;
  groupCommentId?: InputMaybe<UuidComparisonExp>;
  groupRootCommentId?: InputMaybe<UuidComparisonExp>;
  groupThreadId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isOriginalThreadComment?: InputMaybe<BooleanComparisonExp>;
  parentComment?: InputMaybe<GroupThreadCommentsBoolExp>;
  replies?: InputMaybe<GroupThreadCommentsBoolExp>;
  repliesAggregate?: InputMaybe<GroupThreadCommentsAggregateBoolExp>;
  rootComment?: InputMaybe<GroupThreadCommentsBoolExp>;
  thread?: InputMaybe<GroupThreadsBoolExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
  userProfile?: InputMaybe<UserProfilesBoolExp>;
  votes?: InputMaybe<GroupCommentVotesBoolExp>;
  votesAggregate?: InputMaybe<GroupCommentVotesAggregateBoolExp>;
};

/** unique or primary key constraints on table "group_thread_comments" */
export enum GroupThreadCommentsConstraint {
  /** unique or primary key constraint on columns "id" */
  GroupThreadCommentsPkey = 'group_thread_comments_pkey'
}

/** input type for inserting data into table "group_thread_comments" */
export type GroupThreadCommentsInsertInput = {
  allChildComments?: InputMaybe<GroupThreadCommentsArrRelInsertInput>;
  content?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  files?: InputMaybe<GroupThreadCommentFilesArrRelInsertInput>;
  groupCommentId?: InputMaybe<Scalars['uuid']>;
  groupRootCommentId?: InputMaybe<Scalars['uuid']>;
  groupThreadId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  isOriginalThreadComment?: InputMaybe<Scalars['Boolean']>;
  parentComment?: InputMaybe<GroupThreadCommentsObjRelInsertInput>;
  replies?: InputMaybe<GroupThreadCommentsArrRelInsertInput>;
  rootComment?: InputMaybe<GroupThreadCommentsObjRelInsertInput>;
  thread?: InputMaybe<GroupThreadsObjRelInsertInput>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']>;
  userProfile?: InputMaybe<UserProfilesObjRelInsertInput>;
  votes?: InputMaybe<GroupCommentVotesArrRelInsertInput>;
};

/** aggregate max on columns */
export type GroupThreadCommentsMaxFields = {
  __typename?: 'GroupThreadCommentsMaxFields';
  content?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  groupCommentId?: Maybe<Scalars['uuid']>;
  groupRootCommentId?: Maybe<Scalars['uuid']>;
  groupThreadId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "group_thread_comments" */
export type GroupThreadCommentsMaxOrderBy = {
  content?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  groupCommentId?: InputMaybe<OrderBy>;
  groupRootCommentId?: InputMaybe<OrderBy>;
  groupThreadId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type GroupThreadCommentsMinFields = {
  __typename?: 'GroupThreadCommentsMinFields';
  content?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  groupCommentId?: Maybe<Scalars['uuid']>;
  groupRootCommentId?: Maybe<Scalars['uuid']>;
  groupThreadId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "group_thread_comments" */
export type GroupThreadCommentsMinOrderBy = {
  content?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  groupCommentId?: InputMaybe<OrderBy>;
  groupRootCommentId?: InputMaybe<OrderBy>;
  groupThreadId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "group_thread_comments" */
export type GroupThreadCommentsMutationResponse = {
  __typename?: 'GroupThreadCommentsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<GroupThreadComments>;
};

/** input type for inserting object relation for remote table "group_thread_comments" */
export type GroupThreadCommentsObjRelInsertInput = {
  data: GroupThreadCommentsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<GroupThreadCommentsOnConflict>;
};

/** on_conflict condition type for table "group_thread_comments" */
export type GroupThreadCommentsOnConflict = {
  constraint: GroupThreadCommentsConstraint;
  updateColumns?: Array<GroupThreadCommentsUpdateColumn>;
  where?: InputMaybe<GroupThreadCommentsBoolExp>;
};

/** Ordering options when selecting data from "group_thread_comments". */
export type GroupThreadCommentsOrderBy = {
  allChildCommentsAggregate?: InputMaybe<GroupThreadCommentsAggregateOrderBy>;
  content?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  filesAggregate?: InputMaybe<GroupThreadCommentFilesAggregateOrderBy>;
  groupCommentId?: InputMaybe<OrderBy>;
  groupRootCommentId?: InputMaybe<OrderBy>;
  groupThreadId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  isOriginalThreadComment?: InputMaybe<OrderBy>;
  parentComment?: InputMaybe<GroupThreadCommentsOrderBy>;
  repliesAggregate?: InputMaybe<GroupThreadCommentsAggregateOrderBy>;
  rootComment?: InputMaybe<GroupThreadCommentsOrderBy>;
  thread?: InputMaybe<GroupThreadsOrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
  userProfile?: InputMaybe<UserProfilesOrderBy>;
  votesAggregate?: InputMaybe<GroupCommentVotesAggregateOrderBy>;
};

/** primary key columns input for table: group_thread_comments */
export type GroupThreadCommentsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "group_thread_comments" */
export enum GroupThreadCommentsSelectColumn {
  /** column name */
  Content = 'content',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  GroupCommentId = 'groupCommentId',
  /** column name */
  GroupRootCommentId = 'groupRootCommentId',
  /** column name */
  GroupThreadId = 'groupThreadId',
  /** column name */
  Id = 'id',
  /** column name */
  IsOriginalThreadComment = 'isOriginalThreadComment',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** select "groupThreadCommentsAggregateBoolExpBool_andArgumentsColumns" columns of table "group_thread_comments" */
export enum GroupThreadCommentsSelectColumnGroupThreadCommentsAggregateBoolExpBool_AndArgumentsColumns {
  /** column name */
  IsOriginalThreadComment = 'isOriginalThreadComment'
}

/** select "groupThreadCommentsAggregateBoolExpBool_orArgumentsColumns" columns of table "group_thread_comments" */
export enum GroupThreadCommentsSelectColumnGroupThreadCommentsAggregateBoolExpBool_OrArgumentsColumns {
  /** column name */
  IsOriginalThreadComment = 'isOriginalThreadComment'
}

/** input type for updating data in table "group_thread_comments" */
export type GroupThreadCommentsSetInput = {
  content?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  groupCommentId?: InputMaybe<Scalars['uuid']>;
  groupRootCommentId?: InputMaybe<Scalars['uuid']>;
  groupThreadId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  isOriginalThreadComment?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "group_thread_comments" */
export type GroupThreadCommentsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: GroupThreadCommentsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type GroupThreadCommentsStreamCursorValueInput = {
  content?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  groupCommentId?: InputMaybe<Scalars['uuid']>;
  groupRootCommentId?: InputMaybe<Scalars['uuid']>;
  groupThreadId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  isOriginalThreadComment?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "group_thread_comments" */
export enum GroupThreadCommentsUpdateColumn {
  /** column name */
  Content = 'content',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  GroupCommentId = 'groupCommentId',
  /** column name */
  GroupRootCommentId = 'groupRootCommentId',
  /** column name */
  GroupThreadId = 'groupThreadId',
  /** column name */
  Id = 'id',
  /** column name */
  IsOriginalThreadComment = 'isOriginalThreadComment',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

export type GroupThreadCommentsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<GroupThreadCommentsSetInput>;
  /** filter the rows which have to be updated */
  where: GroupThreadCommentsBoolExp;
};

/** columns and relationships of "group_threads" */
export type GroupThreads = {
  __typename?: 'GroupThreads';
  /** An array relationship */
  comments: Array<GroupThreadComments>;
  /** An aggregate relationship */
  commentsAggregate: GroupThreadCommentsAggregate;
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  creator: Users;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  group: Groups;
  groupId: Scalars['uuid'];
  id: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
  userId: Scalars['uuid'];
};


/** columns and relationships of "group_threads" */
export type GroupThreadsCommentsArgs = {
  distinctOn?: InputMaybe<Array<GroupThreadCommentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupThreadCommentsOrderBy>>;
  where?: InputMaybe<GroupThreadCommentsBoolExp>;
};


/** columns and relationships of "group_threads" */
export type GroupThreadsCommentsAggregateArgs = {
  distinctOn?: InputMaybe<Array<GroupThreadCommentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupThreadCommentsOrderBy>>;
  where?: InputMaybe<GroupThreadCommentsBoolExp>;
};

/** aggregated selection of "group_threads" */
export type GroupThreadsAggregate = {
  __typename?: 'GroupThreadsAggregate';
  aggregate?: Maybe<GroupThreadsAggregateFields>;
  nodes: Array<GroupThreads>;
};

export type GroupThreadsAggregateBoolExp = {
  count?: InputMaybe<GroupThreadsAggregateBoolExpCount>;
};

/** aggregate fields of "group_threads" */
export type GroupThreadsAggregateFields = {
  __typename?: 'GroupThreadsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<GroupThreadsMaxFields>;
  min?: Maybe<GroupThreadsMinFields>;
};


/** aggregate fields of "group_threads" */
export type GroupThreadsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<GroupThreadsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "group_threads" */
export type GroupThreadsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<GroupThreadsMaxOrderBy>;
  min?: InputMaybe<GroupThreadsMinOrderBy>;
};

/** input type for inserting array relation for remote table "group_threads" */
export type GroupThreadsArrRelInsertInput = {
  data: Array<GroupThreadsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<GroupThreadsOnConflict>;
};

/** Boolean expression to filter rows from the table "group_threads". All fields are combined with a logical 'AND'. */
export type GroupThreadsBoolExp = {
  _and?: InputMaybe<Array<GroupThreadsBoolExp>>;
  _not?: InputMaybe<GroupThreadsBoolExp>;
  _or?: InputMaybe<Array<GroupThreadsBoolExp>>;
  comments?: InputMaybe<GroupThreadCommentsBoolExp>;
  commentsAggregate?: InputMaybe<GroupThreadCommentsAggregateBoolExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  creator?: InputMaybe<UsersBoolExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  group?: InputMaybe<GroupsBoolExp>;
  groupId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "group_threads" */
export enum GroupThreadsConstraint {
  /** unique or primary key constraint on columns "id" */
  GroupThreadsPkey = 'group_threads_pkey'
}

/** input type for inserting data into table "group_threads" */
export type GroupThreadsInsertInput = {
  comments?: InputMaybe<GroupThreadCommentsArrRelInsertInput>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  creator?: InputMaybe<UsersObjRelInsertInput>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  group?: InputMaybe<GroupsObjRelInsertInput>;
  groupId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type GroupThreadsMaxFields = {
  __typename?: 'GroupThreadsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  groupId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "group_threads" */
export type GroupThreadsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type GroupThreadsMinFields = {
  __typename?: 'GroupThreadsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  groupId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "group_threads" */
export type GroupThreadsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "group_threads" */
export type GroupThreadsMutationResponse = {
  __typename?: 'GroupThreadsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<GroupThreads>;
};

/** input type for inserting object relation for remote table "group_threads" */
export type GroupThreadsObjRelInsertInput = {
  data: GroupThreadsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<GroupThreadsOnConflict>;
};

/** on_conflict condition type for table "group_threads" */
export type GroupThreadsOnConflict = {
  constraint: GroupThreadsConstraint;
  updateColumns?: Array<GroupThreadsUpdateColumn>;
  where?: InputMaybe<GroupThreadsBoolExp>;
};

/** Ordering options when selecting data from "group_threads". */
export type GroupThreadsOrderBy = {
  commentsAggregate?: InputMaybe<GroupThreadCommentsAggregateOrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  creator?: InputMaybe<UsersOrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  group?: InputMaybe<GroupsOrderBy>;
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: group_threads */
export type GroupThreadsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "group_threads" */
export enum GroupThreadsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  GroupId = 'groupId',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "group_threads" */
export type GroupThreadsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  groupId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "group_threads" */
export type GroupThreadsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: GroupThreadsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type GroupThreadsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  groupId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "group_threads" */
export enum GroupThreadsUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  GroupId = 'groupId',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

export type GroupThreadsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<GroupThreadsSetInput>;
  /** filter the rows which have to be updated */
  where: GroupThreadsBoolExp;
};

/** columns and relationships of "group_types" */
export type GroupTypes = {
  __typename?: 'GroupTypes';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "group_types" */
export type GroupTypesAggregate = {
  __typename?: 'GroupTypesAggregate';
  aggregate?: Maybe<GroupTypesAggregateFields>;
  nodes: Array<GroupTypes>;
};

/** aggregate fields of "group_types" */
export type GroupTypesAggregateFields = {
  __typename?: 'GroupTypesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<GroupTypesMaxFields>;
  min?: Maybe<GroupTypesMinFields>;
};


/** aggregate fields of "group_types" */
export type GroupTypesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<GroupTypesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "group_types". All fields are combined with a logical 'AND'. */
export type GroupTypesBoolExp = {
  _and?: InputMaybe<Array<GroupTypesBoolExp>>;
  _not?: InputMaybe<GroupTypesBoolExp>;
  _or?: InputMaybe<Array<GroupTypesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "group_types" */
export enum GroupTypesConstraint {
  /** unique or primary key constraint on columns "value" */
  GroupTypesPkey = 'group_types_pkey'
}

export enum GroupTypesEnum {
  College = 'COLLEGE',
  HighSchool = 'HIGH_SCHOOL',
  LocalCommunity = 'LOCAL_COMMUNITY',
  PrivateClub = 'PRIVATE_CLUB'
}

/** Boolean expression to compare columns of type "GroupTypesEnum". All fields are combined with logical 'AND'. */
export type GroupTypesEnumComparisonExp = {
  _eq?: InputMaybe<GroupTypesEnum>;
  _in?: InputMaybe<Array<GroupTypesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<GroupTypesEnum>;
  _nin?: InputMaybe<Array<GroupTypesEnum>>;
};

/** input type for inserting data into table "group_types" */
export type GroupTypesInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type GroupTypesMaxFields = {
  __typename?: 'GroupTypesMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type GroupTypesMinFields = {
  __typename?: 'GroupTypesMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "group_types" */
export type GroupTypesMutationResponse = {
  __typename?: 'GroupTypesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<GroupTypes>;
};

/** on_conflict condition type for table "group_types" */
export type GroupTypesOnConflict = {
  constraint: GroupTypesConstraint;
  updateColumns?: Array<GroupTypesUpdateColumn>;
  where?: InputMaybe<GroupTypesBoolExp>;
};

/** Ordering options when selecting data from "group_types". */
export type GroupTypesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: group_types */
export type GroupTypesPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "group_types" */
export enum GroupTypesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "group_types" */
export type GroupTypesSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "group_types" */
export type GroupTypesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: GroupTypesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type GroupTypesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "group_types" */
export enum GroupTypesUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type GroupTypesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<GroupTypesSetInput>;
  /** filter the rows which have to be updated */
  where: GroupTypesBoolExp;
};

/** columns and relationships of "group_venues" */
export type GroupVenues = {
  __typename?: 'GroupVenues';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  group: Groups;
  groupId: Scalars['uuid'];
  id: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  venue: Venues;
  venueId: Scalars['uuid'];
};

/** aggregated selection of "group_venues" */
export type GroupVenuesAggregate = {
  __typename?: 'GroupVenuesAggregate';
  aggregate?: Maybe<GroupVenuesAggregateFields>;
  nodes: Array<GroupVenues>;
};

export type GroupVenuesAggregateBoolExp = {
  count?: InputMaybe<GroupVenuesAggregateBoolExpCount>;
};

/** aggregate fields of "group_venues" */
export type GroupVenuesAggregateFields = {
  __typename?: 'GroupVenuesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<GroupVenuesMaxFields>;
  min?: Maybe<GroupVenuesMinFields>;
};


/** aggregate fields of "group_venues" */
export type GroupVenuesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<GroupVenuesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "group_venues" */
export type GroupVenuesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<GroupVenuesMaxOrderBy>;
  min?: InputMaybe<GroupVenuesMinOrderBy>;
};

/** input type for inserting array relation for remote table "group_venues" */
export type GroupVenuesArrRelInsertInput = {
  data: Array<GroupVenuesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<GroupVenuesOnConflict>;
};

/** Boolean expression to filter rows from the table "group_venues". All fields are combined with a logical 'AND'. */
export type GroupVenuesBoolExp = {
  _and?: InputMaybe<Array<GroupVenuesBoolExp>>;
  _not?: InputMaybe<GroupVenuesBoolExp>;
  _or?: InputMaybe<Array<GroupVenuesBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  group?: InputMaybe<GroupsBoolExp>;
  groupId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  venue?: InputMaybe<VenuesBoolExp>;
  venueId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "group_venues" */
export enum GroupVenuesConstraint {
  /** unique or primary key constraint on columns "venue_id", "group_id" */
  GroupVenuesGroupIdVenueIdKey = 'group_venues_group_id_venue_id_key',
  /** unique or primary key constraint on columns "id" */
  GroupVenuesPkey = 'group_venues_pkey'
}

/** input type for inserting data into table "group_venues" */
export type GroupVenuesInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  group?: InputMaybe<GroupsObjRelInsertInput>;
  groupId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  venue?: InputMaybe<VenuesObjRelInsertInput>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type GroupVenuesMaxFields = {
  __typename?: 'GroupVenuesMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  groupId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  venueId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "group_venues" */
export type GroupVenuesMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type GroupVenuesMinFields = {
  __typename?: 'GroupVenuesMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  groupId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  venueId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "group_venues" */
export type GroupVenuesMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "group_venues" */
export type GroupVenuesMutationResponse = {
  __typename?: 'GroupVenuesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<GroupVenues>;
};

/** on_conflict condition type for table "group_venues" */
export type GroupVenuesOnConflict = {
  constraint: GroupVenuesConstraint;
  updateColumns?: Array<GroupVenuesUpdateColumn>;
  where?: InputMaybe<GroupVenuesBoolExp>;
};

/** Ordering options when selecting data from "group_venues". */
export type GroupVenuesOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  group?: InputMaybe<GroupsOrderBy>;
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  venue?: InputMaybe<VenuesOrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: group_venues */
export type GroupVenuesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "group_venues" */
export enum GroupVenuesSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  GroupId = 'groupId',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  VenueId = 'venueId'
}

/** input type for updating data in table "group_venues" */
export type GroupVenuesSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  groupId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "group_venues" */
export type GroupVenuesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: GroupVenuesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type GroupVenuesStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  groupId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "group_venues" */
export enum GroupVenuesUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  GroupId = 'groupId',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  VenueId = 'venueId'
}

export type GroupVenuesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<GroupVenuesSetInput>;
  /** filter the rows which have to be updated */
  where: GroupVenuesBoolExp;
};

/** columns and relationships of "groups" */
export type Groups = {
  __typename?: 'Groups';
  accessCode?: Maybe<Scalars['String']>;
  actionUrl: Scalars['String'];
  addressString: Scalars['String'];
  allowMemberInvites: Scalars['Boolean'];
  allowMemberSessionInvites: Scalars['Boolean'];
  /** An object relationship */
  city?: Maybe<Cities>;
  cityId?: Maybe<Scalars['uuid']>;
  contactEmail?: Maybe<Scalars['String']>;
  contactMessage?: Maybe<Scalars['String']>;
  contactPhoneNumber?: Maybe<Scalars['String']>;
  contactUrl?: Maybe<Scalars['String']>;
  coverPhotoFileName: Scalars['String'];
  coverPhotoFileType?: Maybe<Scalars['String']>;
  coverPhotoHost: Scalars['String'];
  coverPhotoOriginalFileName: Scalars['String'];
  coverPhotoPath: Scalars['String'];
  coverPhotoProvider: Scalars['String'];
  coverPhotoProviderUrl: Scalars['String'];
  coverPhotoUrl: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  description: Scalars['String'];
  directorEmail?: Maybe<Scalars['String']>;
  directorName?: Maybe<Scalars['String']>;
  directorPhoneNumber?: Maybe<Scalars['String']>;
  displayOwnerContactInfo: Scalars['Boolean'];
  duprUrl?: Maybe<Scalars['String']>;
  /** An array relationship */
  events: Array<Events>;
  /** An aggregate relationship */
  eventsAggregate: EventsAggregate;
  facebookUrl: Scalars['String'];
  geometry?: Maybe<Scalars['geography']>;
  /** An array relationship */
  groupsPlaySessions: Array<GroupsPlaySessions>;
  /** An aggregate relationship */
  groupsPlaySessionsAggregate: GroupsPlaySessionsAggregate;
  headline: Scalars['String'];
  id: Scalars['uuid'];
  instagramUrl: Scalars['String'];
  isPrivate: Scalars['Boolean'];
  latitude?: Maybe<Scalars['numeric']>;
  longitude?: Maybe<Scalars['numeric']>;
  memberDisplayCount?: Maybe<Scalars['Int']>;
  /** An array relationship */
  members: Array<GroupMembers>;
  /** An aggregate relationship */
  membersAggregate: GroupMembersAggregate;
  organizerEmail?: Maybe<Scalars['String']>;
  organizerName?: Maybe<Scalars['String']>;
  organizerPhoneNumber?: Maybe<Scalars['String']>;
  /** An object relationship */
  owner?: Maybe<Users>;
  ownerUserId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  ownerUserProfile?: Maybe<UserProfiles>;
  /** An array relationship */
  playSessions: Array<PlaySessions>;
  /** An aggregate relationship */
  playSessionsAggregate: PlaySessionsAggregate;
  preferredContact?: Maybe<Scalars['String']>;
  primarySport?: Maybe<SportsEnum>;
  profilePhotoFileName: Scalars['String'];
  profilePhotoFileType?: Maybe<Scalars['String']>;
  profilePhotoHost: Scalars['String'];
  profilePhotoOriginalFileName: Scalars['String'];
  profilePhotoPath: Scalars['String'];
  profilePhotoProvider: Scalars['String'];
  profilePhotoProviderUrl: Scalars['String'];
  profilePhotoUrl: Scalars['String'];
  skillLevelMaximum?: Maybe<Scalars['numeric']>;
  skillLevelMinimum?: Maybe<Scalars['numeric']>;
  slug: Scalars['String'];
  /** An array relationship */
  threads: Array<GroupThreads>;
  /** An aggregate relationship */
  threadsAggregate: GroupThreadsAggregate;
  tiktokUrl: Scalars['String'];
  title: Scalars['String'];
  type: GroupTypesEnum;
  updatedAt: Scalars['timestamptz'];
  /** An array relationship */
  venues: Array<GroupVenues>;
  /** An aggregate relationship */
  venuesAggregate: GroupVenuesAggregate;
  websiteUrl: Scalars['String'];
  xUrl: Scalars['String'];
  youtubeUrl?: Maybe<Scalars['String']>;
};


/** columns and relationships of "groups" */
export type GroupsEventsArgs = {
  distinctOn?: InputMaybe<Array<EventsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventsOrderBy>>;
  where?: InputMaybe<EventsBoolExp>;
};


/** columns and relationships of "groups" */
export type GroupsEventsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventsOrderBy>>;
  where?: InputMaybe<EventsBoolExp>;
};


/** columns and relationships of "groups" */
export type GroupsGroupsPlaySessionsArgs = {
  distinctOn?: InputMaybe<Array<GroupsPlaySessionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupsPlaySessionsOrderBy>>;
  where?: InputMaybe<GroupsPlaySessionsBoolExp>;
};


/** columns and relationships of "groups" */
export type GroupsGroupsPlaySessionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<GroupsPlaySessionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupsPlaySessionsOrderBy>>;
  where?: InputMaybe<GroupsPlaySessionsBoolExp>;
};


/** columns and relationships of "groups" */
export type GroupsMembersArgs = {
  distinctOn?: InputMaybe<Array<GroupMembersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupMembersOrderBy>>;
  where?: InputMaybe<GroupMembersBoolExp>;
};


/** columns and relationships of "groups" */
export type GroupsMembersAggregateArgs = {
  distinctOn?: InputMaybe<Array<GroupMembersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupMembersOrderBy>>;
  where?: InputMaybe<GroupMembersBoolExp>;
};


/** columns and relationships of "groups" */
export type GroupsPlaySessionsArgs = {
  distinctOn?: InputMaybe<Array<PlaySessionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlaySessionsOrderBy>>;
  where?: InputMaybe<PlaySessionsBoolExp>;
};


/** columns and relationships of "groups" */
export type GroupsPlaySessionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PlaySessionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlaySessionsOrderBy>>;
  where?: InputMaybe<PlaySessionsBoolExp>;
};


/** columns and relationships of "groups" */
export type GroupsThreadsArgs = {
  distinctOn?: InputMaybe<Array<GroupThreadsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupThreadsOrderBy>>;
  where?: InputMaybe<GroupThreadsBoolExp>;
};


/** columns and relationships of "groups" */
export type GroupsThreadsAggregateArgs = {
  distinctOn?: InputMaybe<Array<GroupThreadsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupThreadsOrderBy>>;
  where?: InputMaybe<GroupThreadsBoolExp>;
};


/** columns and relationships of "groups" */
export type GroupsVenuesArgs = {
  distinctOn?: InputMaybe<Array<GroupVenuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupVenuesOrderBy>>;
  where?: InputMaybe<GroupVenuesBoolExp>;
};


/** columns and relationships of "groups" */
export type GroupsVenuesAggregateArgs = {
  distinctOn?: InputMaybe<Array<GroupVenuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupVenuesOrderBy>>;
  where?: InputMaybe<GroupVenuesBoolExp>;
};

/** aggregated selection of "groups" */
export type GroupsAggregate = {
  __typename?: 'GroupsAggregate';
  aggregate?: Maybe<GroupsAggregateFields>;
  nodes: Array<Groups>;
};

export type GroupsAggregateBoolExp = {
  bool_and?: InputMaybe<GroupsAggregateBoolExpBool_And>;
  bool_or?: InputMaybe<GroupsAggregateBoolExpBool_Or>;
  count?: InputMaybe<GroupsAggregateBoolExpCount>;
};

/** aggregate fields of "groups" */
export type GroupsAggregateFields = {
  __typename?: 'GroupsAggregateFields';
  avg?: Maybe<GroupsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<GroupsMaxFields>;
  min?: Maybe<GroupsMinFields>;
  stddev?: Maybe<GroupsStddevFields>;
  stddevPop?: Maybe<GroupsStddevPopFields>;
  stddevSamp?: Maybe<GroupsStddevSampFields>;
  sum?: Maybe<GroupsSumFields>;
  varPop?: Maybe<GroupsVarPopFields>;
  varSamp?: Maybe<GroupsVarSampFields>;
  variance?: Maybe<GroupsVarianceFields>;
};


/** aggregate fields of "groups" */
export type GroupsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<GroupsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "groups" */
export type GroupsAggregateOrderBy = {
  avg?: InputMaybe<GroupsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<GroupsMaxOrderBy>;
  min?: InputMaybe<GroupsMinOrderBy>;
  stddev?: InputMaybe<GroupsStddevOrderBy>;
  stddevPop?: InputMaybe<GroupsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<GroupsStddevSampOrderBy>;
  sum?: InputMaybe<GroupsSumOrderBy>;
  varPop?: InputMaybe<GroupsVarPopOrderBy>;
  varSamp?: InputMaybe<GroupsVarSampOrderBy>;
  variance?: InputMaybe<GroupsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "groups" */
export type GroupsArrRelInsertInput = {
  data: Array<GroupsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<GroupsOnConflict>;
};

/** aggregate avg on columns */
export type GroupsAvgFields = {
  __typename?: 'GroupsAvgFields';
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  memberDisplayCount?: Maybe<Scalars['Float']>;
  skillLevelMaximum?: Maybe<Scalars['Float']>;
  skillLevelMinimum?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "groups" */
export type GroupsAvgOrderBy = {
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  memberDisplayCount?: InputMaybe<OrderBy>;
  skillLevelMaximum?: InputMaybe<OrderBy>;
  skillLevelMinimum?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "groups". All fields are combined with a logical 'AND'. */
export type GroupsBoolExp = {
  _and?: InputMaybe<Array<GroupsBoolExp>>;
  _not?: InputMaybe<GroupsBoolExp>;
  _or?: InputMaybe<Array<GroupsBoolExp>>;
  accessCode?: InputMaybe<StringComparisonExp>;
  actionUrl?: InputMaybe<StringComparisonExp>;
  addressString?: InputMaybe<StringComparisonExp>;
  allowMemberInvites?: InputMaybe<BooleanComparisonExp>;
  allowMemberSessionInvites?: InputMaybe<BooleanComparisonExp>;
  city?: InputMaybe<CitiesBoolExp>;
  cityId?: InputMaybe<UuidComparisonExp>;
  contactEmail?: InputMaybe<StringComparisonExp>;
  contactMessage?: InputMaybe<StringComparisonExp>;
  contactPhoneNumber?: InputMaybe<StringComparisonExp>;
  contactUrl?: InputMaybe<StringComparisonExp>;
  coverPhotoFileName?: InputMaybe<StringComparisonExp>;
  coverPhotoFileType?: InputMaybe<StringComparisonExp>;
  coverPhotoHost?: InputMaybe<StringComparisonExp>;
  coverPhotoOriginalFileName?: InputMaybe<StringComparisonExp>;
  coverPhotoPath?: InputMaybe<StringComparisonExp>;
  coverPhotoProvider?: InputMaybe<StringComparisonExp>;
  coverPhotoProviderUrl?: InputMaybe<StringComparisonExp>;
  coverPhotoUrl?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  directorEmail?: InputMaybe<StringComparisonExp>;
  directorName?: InputMaybe<StringComparisonExp>;
  directorPhoneNumber?: InputMaybe<StringComparisonExp>;
  displayOwnerContactInfo?: InputMaybe<BooleanComparisonExp>;
  duprUrl?: InputMaybe<StringComparisonExp>;
  events?: InputMaybe<EventsBoolExp>;
  eventsAggregate?: InputMaybe<EventsAggregateBoolExp>;
  facebookUrl?: InputMaybe<StringComparisonExp>;
  geometry?: InputMaybe<GeographyComparisonExp>;
  groupsPlaySessions?: InputMaybe<GroupsPlaySessionsBoolExp>;
  groupsPlaySessionsAggregate?: InputMaybe<GroupsPlaySessionsAggregateBoolExp>;
  headline?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  instagramUrl?: InputMaybe<StringComparisonExp>;
  isPrivate?: InputMaybe<BooleanComparisonExp>;
  latitude?: InputMaybe<NumericComparisonExp>;
  longitude?: InputMaybe<NumericComparisonExp>;
  memberDisplayCount?: InputMaybe<IntComparisonExp>;
  members?: InputMaybe<GroupMembersBoolExp>;
  membersAggregate?: InputMaybe<GroupMembersAggregateBoolExp>;
  organizerEmail?: InputMaybe<StringComparisonExp>;
  organizerName?: InputMaybe<StringComparisonExp>;
  organizerPhoneNumber?: InputMaybe<StringComparisonExp>;
  owner?: InputMaybe<UsersBoolExp>;
  ownerUserId?: InputMaybe<UuidComparisonExp>;
  ownerUserProfile?: InputMaybe<UserProfilesBoolExp>;
  playSessions?: InputMaybe<PlaySessionsBoolExp>;
  playSessionsAggregate?: InputMaybe<PlaySessionsAggregateBoolExp>;
  preferredContact?: InputMaybe<StringComparisonExp>;
  primarySport?: InputMaybe<SportsEnumComparisonExp>;
  profilePhotoFileName?: InputMaybe<StringComparisonExp>;
  profilePhotoFileType?: InputMaybe<StringComparisonExp>;
  profilePhotoHost?: InputMaybe<StringComparisonExp>;
  profilePhotoOriginalFileName?: InputMaybe<StringComparisonExp>;
  profilePhotoPath?: InputMaybe<StringComparisonExp>;
  profilePhotoProvider?: InputMaybe<StringComparisonExp>;
  profilePhotoProviderUrl?: InputMaybe<StringComparisonExp>;
  profilePhotoUrl?: InputMaybe<StringComparisonExp>;
  skillLevelMaximum?: InputMaybe<NumericComparisonExp>;
  skillLevelMinimum?: InputMaybe<NumericComparisonExp>;
  slug?: InputMaybe<StringComparisonExp>;
  threads?: InputMaybe<GroupThreadsBoolExp>;
  threadsAggregate?: InputMaybe<GroupThreadsAggregateBoolExp>;
  tiktokUrl?: InputMaybe<StringComparisonExp>;
  title?: InputMaybe<StringComparisonExp>;
  type?: InputMaybe<GroupTypesEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  venues?: InputMaybe<GroupVenuesBoolExp>;
  venuesAggregate?: InputMaybe<GroupVenuesAggregateBoolExp>;
  websiteUrl?: InputMaybe<StringComparisonExp>;
  xUrl?: InputMaybe<StringComparisonExp>;
  youtubeUrl?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "groups" */
export enum GroupsConstraint {
  /** unique or primary key constraint on columns "access_code" */
  GroupsAccessCodeKey = 'groups_access_code_key',
  /** unique or primary key constraint on columns "id" */
  GroupsPkey = 'groups_pkey',
  /** unique or primary key constraint on columns "slug" */
  GroupsSlugKey = 'groups_slug_key'
}

/** input type for incrementing numeric columns in table "groups" */
export type GroupsIncInput = {
  latitude?: InputMaybe<Scalars['numeric']>;
  longitude?: InputMaybe<Scalars['numeric']>;
  memberDisplayCount?: InputMaybe<Scalars['Int']>;
  skillLevelMaximum?: InputMaybe<Scalars['numeric']>;
  skillLevelMinimum?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "groups" */
export type GroupsInsertInput = {
  accessCode?: InputMaybe<Scalars['String']>;
  actionUrl?: InputMaybe<Scalars['String']>;
  addressString?: InputMaybe<Scalars['String']>;
  allowMemberInvites?: InputMaybe<Scalars['Boolean']>;
  allowMemberSessionInvites?: InputMaybe<Scalars['Boolean']>;
  city?: InputMaybe<CitiesObjRelInsertInput>;
  cityId?: InputMaybe<Scalars['uuid']>;
  contactEmail?: InputMaybe<Scalars['String']>;
  contactMessage?: InputMaybe<Scalars['String']>;
  contactPhoneNumber?: InputMaybe<Scalars['String']>;
  contactUrl?: InputMaybe<Scalars['String']>;
  coverPhotoFileName?: InputMaybe<Scalars['String']>;
  coverPhotoFileType?: InputMaybe<Scalars['String']>;
  coverPhotoHost?: InputMaybe<Scalars['String']>;
  coverPhotoOriginalFileName?: InputMaybe<Scalars['String']>;
  coverPhotoPath?: InputMaybe<Scalars['String']>;
  coverPhotoProvider?: InputMaybe<Scalars['String']>;
  coverPhotoProviderUrl?: InputMaybe<Scalars['String']>;
  coverPhotoUrl?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  directorEmail?: InputMaybe<Scalars['String']>;
  directorName?: InputMaybe<Scalars['String']>;
  directorPhoneNumber?: InputMaybe<Scalars['String']>;
  displayOwnerContactInfo?: InputMaybe<Scalars['Boolean']>;
  duprUrl?: InputMaybe<Scalars['String']>;
  events?: InputMaybe<EventsArrRelInsertInput>;
  facebookUrl?: InputMaybe<Scalars['String']>;
  geometry?: InputMaybe<Scalars['geography']>;
  groupsPlaySessions?: InputMaybe<GroupsPlaySessionsArrRelInsertInput>;
  headline?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  instagramUrl?: InputMaybe<Scalars['String']>;
  isPrivate?: InputMaybe<Scalars['Boolean']>;
  latitude?: InputMaybe<Scalars['numeric']>;
  longitude?: InputMaybe<Scalars['numeric']>;
  memberDisplayCount?: InputMaybe<Scalars['Int']>;
  members?: InputMaybe<GroupMembersArrRelInsertInput>;
  organizerEmail?: InputMaybe<Scalars['String']>;
  organizerName?: InputMaybe<Scalars['String']>;
  organizerPhoneNumber?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<UsersObjRelInsertInput>;
  ownerUserId?: InputMaybe<Scalars['uuid']>;
  ownerUserProfile?: InputMaybe<UserProfilesObjRelInsertInput>;
  playSessions?: InputMaybe<PlaySessionsArrRelInsertInput>;
  preferredContact?: InputMaybe<Scalars['String']>;
  primarySport?: InputMaybe<SportsEnum>;
  profilePhotoFileName?: InputMaybe<Scalars['String']>;
  profilePhotoFileType?: InputMaybe<Scalars['String']>;
  profilePhotoHost?: InputMaybe<Scalars['String']>;
  profilePhotoOriginalFileName?: InputMaybe<Scalars['String']>;
  profilePhotoPath?: InputMaybe<Scalars['String']>;
  profilePhotoProvider?: InputMaybe<Scalars['String']>;
  profilePhotoProviderUrl?: InputMaybe<Scalars['String']>;
  profilePhotoUrl?: InputMaybe<Scalars['String']>;
  skillLevelMaximum?: InputMaybe<Scalars['numeric']>;
  skillLevelMinimum?: InputMaybe<Scalars['numeric']>;
  slug?: InputMaybe<Scalars['String']>;
  threads?: InputMaybe<GroupThreadsArrRelInsertInput>;
  tiktokUrl?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<GroupTypesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  venues?: InputMaybe<GroupVenuesArrRelInsertInput>;
  websiteUrl?: InputMaybe<Scalars['String']>;
  xUrl?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type GroupsMaxFields = {
  __typename?: 'GroupsMaxFields';
  accessCode?: Maybe<Scalars['String']>;
  actionUrl?: Maybe<Scalars['String']>;
  addressString?: Maybe<Scalars['String']>;
  cityId?: Maybe<Scalars['uuid']>;
  contactEmail?: Maybe<Scalars['String']>;
  contactMessage?: Maybe<Scalars['String']>;
  contactPhoneNumber?: Maybe<Scalars['String']>;
  contactUrl?: Maybe<Scalars['String']>;
  coverPhotoFileName?: Maybe<Scalars['String']>;
  coverPhotoFileType?: Maybe<Scalars['String']>;
  coverPhotoHost?: Maybe<Scalars['String']>;
  coverPhotoOriginalFileName?: Maybe<Scalars['String']>;
  coverPhotoPath?: Maybe<Scalars['String']>;
  coverPhotoProvider?: Maybe<Scalars['String']>;
  coverPhotoProviderUrl?: Maybe<Scalars['String']>;
  coverPhotoUrl?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  directorEmail?: Maybe<Scalars['String']>;
  directorName?: Maybe<Scalars['String']>;
  directorPhoneNumber?: Maybe<Scalars['String']>;
  duprUrl?: Maybe<Scalars['String']>;
  facebookUrl?: Maybe<Scalars['String']>;
  headline?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  instagramUrl?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['numeric']>;
  longitude?: Maybe<Scalars['numeric']>;
  memberDisplayCount?: Maybe<Scalars['Int']>;
  organizerEmail?: Maybe<Scalars['String']>;
  organizerName?: Maybe<Scalars['String']>;
  organizerPhoneNumber?: Maybe<Scalars['String']>;
  ownerUserId?: Maybe<Scalars['uuid']>;
  preferredContact?: Maybe<Scalars['String']>;
  profilePhotoFileName?: Maybe<Scalars['String']>;
  profilePhotoFileType?: Maybe<Scalars['String']>;
  profilePhotoHost?: Maybe<Scalars['String']>;
  profilePhotoOriginalFileName?: Maybe<Scalars['String']>;
  profilePhotoPath?: Maybe<Scalars['String']>;
  profilePhotoProvider?: Maybe<Scalars['String']>;
  profilePhotoProviderUrl?: Maybe<Scalars['String']>;
  profilePhotoUrl?: Maybe<Scalars['String']>;
  skillLevelMaximum?: Maybe<Scalars['numeric']>;
  skillLevelMinimum?: Maybe<Scalars['numeric']>;
  slug?: Maybe<Scalars['String']>;
  tiktokUrl?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  websiteUrl?: Maybe<Scalars['String']>;
  xUrl?: Maybe<Scalars['String']>;
  youtubeUrl?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "groups" */
export type GroupsMaxOrderBy = {
  accessCode?: InputMaybe<OrderBy>;
  actionUrl?: InputMaybe<OrderBy>;
  addressString?: InputMaybe<OrderBy>;
  cityId?: InputMaybe<OrderBy>;
  contactEmail?: InputMaybe<OrderBy>;
  contactMessage?: InputMaybe<OrderBy>;
  contactPhoneNumber?: InputMaybe<OrderBy>;
  contactUrl?: InputMaybe<OrderBy>;
  coverPhotoFileName?: InputMaybe<OrderBy>;
  coverPhotoFileType?: InputMaybe<OrderBy>;
  coverPhotoHost?: InputMaybe<OrderBy>;
  coverPhotoOriginalFileName?: InputMaybe<OrderBy>;
  coverPhotoPath?: InputMaybe<OrderBy>;
  coverPhotoProvider?: InputMaybe<OrderBy>;
  coverPhotoProviderUrl?: InputMaybe<OrderBy>;
  coverPhotoUrl?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  directorEmail?: InputMaybe<OrderBy>;
  directorName?: InputMaybe<OrderBy>;
  directorPhoneNumber?: InputMaybe<OrderBy>;
  duprUrl?: InputMaybe<OrderBy>;
  facebookUrl?: InputMaybe<OrderBy>;
  headline?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  instagramUrl?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  memberDisplayCount?: InputMaybe<OrderBy>;
  organizerEmail?: InputMaybe<OrderBy>;
  organizerName?: InputMaybe<OrderBy>;
  organizerPhoneNumber?: InputMaybe<OrderBy>;
  ownerUserId?: InputMaybe<OrderBy>;
  preferredContact?: InputMaybe<OrderBy>;
  profilePhotoFileName?: InputMaybe<OrderBy>;
  profilePhotoFileType?: InputMaybe<OrderBy>;
  profilePhotoHost?: InputMaybe<OrderBy>;
  profilePhotoOriginalFileName?: InputMaybe<OrderBy>;
  profilePhotoPath?: InputMaybe<OrderBy>;
  profilePhotoProvider?: InputMaybe<OrderBy>;
  profilePhotoProviderUrl?: InputMaybe<OrderBy>;
  profilePhotoUrl?: InputMaybe<OrderBy>;
  skillLevelMaximum?: InputMaybe<OrderBy>;
  skillLevelMinimum?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  tiktokUrl?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  websiteUrl?: InputMaybe<OrderBy>;
  xUrl?: InputMaybe<OrderBy>;
  youtubeUrl?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type GroupsMinFields = {
  __typename?: 'GroupsMinFields';
  accessCode?: Maybe<Scalars['String']>;
  actionUrl?: Maybe<Scalars['String']>;
  addressString?: Maybe<Scalars['String']>;
  cityId?: Maybe<Scalars['uuid']>;
  contactEmail?: Maybe<Scalars['String']>;
  contactMessage?: Maybe<Scalars['String']>;
  contactPhoneNumber?: Maybe<Scalars['String']>;
  contactUrl?: Maybe<Scalars['String']>;
  coverPhotoFileName?: Maybe<Scalars['String']>;
  coverPhotoFileType?: Maybe<Scalars['String']>;
  coverPhotoHost?: Maybe<Scalars['String']>;
  coverPhotoOriginalFileName?: Maybe<Scalars['String']>;
  coverPhotoPath?: Maybe<Scalars['String']>;
  coverPhotoProvider?: Maybe<Scalars['String']>;
  coverPhotoProviderUrl?: Maybe<Scalars['String']>;
  coverPhotoUrl?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  directorEmail?: Maybe<Scalars['String']>;
  directorName?: Maybe<Scalars['String']>;
  directorPhoneNumber?: Maybe<Scalars['String']>;
  duprUrl?: Maybe<Scalars['String']>;
  facebookUrl?: Maybe<Scalars['String']>;
  headline?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  instagramUrl?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['numeric']>;
  longitude?: Maybe<Scalars['numeric']>;
  memberDisplayCount?: Maybe<Scalars['Int']>;
  organizerEmail?: Maybe<Scalars['String']>;
  organizerName?: Maybe<Scalars['String']>;
  organizerPhoneNumber?: Maybe<Scalars['String']>;
  ownerUserId?: Maybe<Scalars['uuid']>;
  preferredContact?: Maybe<Scalars['String']>;
  profilePhotoFileName?: Maybe<Scalars['String']>;
  profilePhotoFileType?: Maybe<Scalars['String']>;
  profilePhotoHost?: Maybe<Scalars['String']>;
  profilePhotoOriginalFileName?: Maybe<Scalars['String']>;
  profilePhotoPath?: Maybe<Scalars['String']>;
  profilePhotoProvider?: Maybe<Scalars['String']>;
  profilePhotoProviderUrl?: Maybe<Scalars['String']>;
  profilePhotoUrl?: Maybe<Scalars['String']>;
  skillLevelMaximum?: Maybe<Scalars['numeric']>;
  skillLevelMinimum?: Maybe<Scalars['numeric']>;
  slug?: Maybe<Scalars['String']>;
  tiktokUrl?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  websiteUrl?: Maybe<Scalars['String']>;
  xUrl?: Maybe<Scalars['String']>;
  youtubeUrl?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "groups" */
export type GroupsMinOrderBy = {
  accessCode?: InputMaybe<OrderBy>;
  actionUrl?: InputMaybe<OrderBy>;
  addressString?: InputMaybe<OrderBy>;
  cityId?: InputMaybe<OrderBy>;
  contactEmail?: InputMaybe<OrderBy>;
  contactMessage?: InputMaybe<OrderBy>;
  contactPhoneNumber?: InputMaybe<OrderBy>;
  contactUrl?: InputMaybe<OrderBy>;
  coverPhotoFileName?: InputMaybe<OrderBy>;
  coverPhotoFileType?: InputMaybe<OrderBy>;
  coverPhotoHost?: InputMaybe<OrderBy>;
  coverPhotoOriginalFileName?: InputMaybe<OrderBy>;
  coverPhotoPath?: InputMaybe<OrderBy>;
  coverPhotoProvider?: InputMaybe<OrderBy>;
  coverPhotoProviderUrl?: InputMaybe<OrderBy>;
  coverPhotoUrl?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  directorEmail?: InputMaybe<OrderBy>;
  directorName?: InputMaybe<OrderBy>;
  directorPhoneNumber?: InputMaybe<OrderBy>;
  duprUrl?: InputMaybe<OrderBy>;
  facebookUrl?: InputMaybe<OrderBy>;
  headline?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  instagramUrl?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  memberDisplayCount?: InputMaybe<OrderBy>;
  organizerEmail?: InputMaybe<OrderBy>;
  organizerName?: InputMaybe<OrderBy>;
  organizerPhoneNumber?: InputMaybe<OrderBy>;
  ownerUserId?: InputMaybe<OrderBy>;
  preferredContact?: InputMaybe<OrderBy>;
  profilePhotoFileName?: InputMaybe<OrderBy>;
  profilePhotoFileType?: InputMaybe<OrderBy>;
  profilePhotoHost?: InputMaybe<OrderBy>;
  profilePhotoOriginalFileName?: InputMaybe<OrderBy>;
  profilePhotoPath?: InputMaybe<OrderBy>;
  profilePhotoProvider?: InputMaybe<OrderBy>;
  profilePhotoProviderUrl?: InputMaybe<OrderBy>;
  profilePhotoUrl?: InputMaybe<OrderBy>;
  skillLevelMaximum?: InputMaybe<OrderBy>;
  skillLevelMinimum?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  tiktokUrl?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  websiteUrl?: InputMaybe<OrderBy>;
  xUrl?: InputMaybe<OrderBy>;
  youtubeUrl?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "groups" */
export type GroupsMutationResponse = {
  __typename?: 'GroupsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Groups>;
};

/** input type for inserting object relation for remote table "groups" */
export type GroupsObjRelInsertInput = {
  data: GroupsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<GroupsOnConflict>;
};

/** on_conflict condition type for table "groups" */
export type GroupsOnConflict = {
  constraint: GroupsConstraint;
  updateColumns?: Array<GroupsUpdateColumn>;
  where?: InputMaybe<GroupsBoolExp>;
};

/** Ordering options when selecting data from "groups". */
export type GroupsOrderBy = {
  accessCode?: InputMaybe<OrderBy>;
  actionUrl?: InputMaybe<OrderBy>;
  addressString?: InputMaybe<OrderBy>;
  allowMemberInvites?: InputMaybe<OrderBy>;
  allowMemberSessionInvites?: InputMaybe<OrderBy>;
  city?: InputMaybe<CitiesOrderBy>;
  cityId?: InputMaybe<OrderBy>;
  contactEmail?: InputMaybe<OrderBy>;
  contactMessage?: InputMaybe<OrderBy>;
  contactPhoneNumber?: InputMaybe<OrderBy>;
  contactUrl?: InputMaybe<OrderBy>;
  coverPhotoFileName?: InputMaybe<OrderBy>;
  coverPhotoFileType?: InputMaybe<OrderBy>;
  coverPhotoHost?: InputMaybe<OrderBy>;
  coverPhotoOriginalFileName?: InputMaybe<OrderBy>;
  coverPhotoPath?: InputMaybe<OrderBy>;
  coverPhotoProvider?: InputMaybe<OrderBy>;
  coverPhotoProviderUrl?: InputMaybe<OrderBy>;
  coverPhotoUrl?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  directorEmail?: InputMaybe<OrderBy>;
  directorName?: InputMaybe<OrderBy>;
  directorPhoneNumber?: InputMaybe<OrderBy>;
  displayOwnerContactInfo?: InputMaybe<OrderBy>;
  duprUrl?: InputMaybe<OrderBy>;
  eventsAggregate?: InputMaybe<EventsAggregateOrderBy>;
  facebookUrl?: InputMaybe<OrderBy>;
  geometry?: InputMaybe<OrderBy>;
  groupsPlaySessionsAggregate?: InputMaybe<GroupsPlaySessionsAggregateOrderBy>;
  headline?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  instagramUrl?: InputMaybe<OrderBy>;
  isPrivate?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  memberDisplayCount?: InputMaybe<OrderBy>;
  membersAggregate?: InputMaybe<GroupMembersAggregateOrderBy>;
  organizerEmail?: InputMaybe<OrderBy>;
  organizerName?: InputMaybe<OrderBy>;
  organizerPhoneNumber?: InputMaybe<OrderBy>;
  owner?: InputMaybe<UsersOrderBy>;
  ownerUserId?: InputMaybe<OrderBy>;
  ownerUserProfile?: InputMaybe<UserProfilesOrderBy>;
  playSessionsAggregate?: InputMaybe<PlaySessionsAggregateOrderBy>;
  preferredContact?: InputMaybe<OrderBy>;
  primarySport?: InputMaybe<OrderBy>;
  profilePhotoFileName?: InputMaybe<OrderBy>;
  profilePhotoFileType?: InputMaybe<OrderBy>;
  profilePhotoHost?: InputMaybe<OrderBy>;
  profilePhotoOriginalFileName?: InputMaybe<OrderBy>;
  profilePhotoPath?: InputMaybe<OrderBy>;
  profilePhotoProvider?: InputMaybe<OrderBy>;
  profilePhotoProviderUrl?: InputMaybe<OrderBy>;
  profilePhotoUrl?: InputMaybe<OrderBy>;
  skillLevelMaximum?: InputMaybe<OrderBy>;
  skillLevelMinimum?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  threadsAggregate?: InputMaybe<GroupThreadsAggregateOrderBy>;
  tiktokUrl?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  venuesAggregate?: InputMaybe<GroupVenuesAggregateOrderBy>;
  websiteUrl?: InputMaybe<OrderBy>;
  xUrl?: InputMaybe<OrderBy>;
  youtubeUrl?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: groups */
export type GroupsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** columns and relationships of "groups_play_sessions" */
export type GroupsPlaySessions = {
  __typename?: 'GroupsPlaySessions';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  group: Groups;
  groupId: Scalars['uuid'];
  id: Scalars['uuid'];
  /** An object relationship */
  playSession: PlaySessions;
  playSessionId: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "groups_play_sessions" */
export type GroupsPlaySessionsAggregate = {
  __typename?: 'GroupsPlaySessionsAggregate';
  aggregate?: Maybe<GroupsPlaySessionsAggregateFields>;
  nodes: Array<GroupsPlaySessions>;
};

export type GroupsPlaySessionsAggregateBoolExp = {
  count?: InputMaybe<GroupsPlaySessionsAggregateBoolExpCount>;
};

/** aggregate fields of "groups_play_sessions" */
export type GroupsPlaySessionsAggregateFields = {
  __typename?: 'GroupsPlaySessionsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<GroupsPlaySessionsMaxFields>;
  min?: Maybe<GroupsPlaySessionsMinFields>;
};


/** aggregate fields of "groups_play_sessions" */
export type GroupsPlaySessionsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<GroupsPlaySessionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "groups_play_sessions" */
export type GroupsPlaySessionsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<GroupsPlaySessionsMaxOrderBy>;
  min?: InputMaybe<GroupsPlaySessionsMinOrderBy>;
};

/** input type for inserting array relation for remote table "groups_play_sessions" */
export type GroupsPlaySessionsArrRelInsertInput = {
  data: Array<GroupsPlaySessionsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<GroupsPlaySessionsOnConflict>;
};

/** Boolean expression to filter rows from the table "groups_play_sessions". All fields are combined with a logical 'AND'. */
export type GroupsPlaySessionsBoolExp = {
  _and?: InputMaybe<Array<GroupsPlaySessionsBoolExp>>;
  _not?: InputMaybe<GroupsPlaySessionsBoolExp>;
  _or?: InputMaybe<Array<GroupsPlaySessionsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  group?: InputMaybe<GroupsBoolExp>;
  groupId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  playSession?: InputMaybe<PlaySessionsBoolExp>;
  playSessionId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "groups_play_sessions" */
export enum GroupsPlaySessionsConstraint {
  /** unique or primary key constraint on columns "play_session_id", "group_id" */
  GroupsPlaySessionsGroupIdPlaySessionIdKey = 'groups_play_sessions_group_id_play_session_id_key',
  /** unique or primary key constraint on columns "id" */
  GroupsPlaySessionsPkey = 'groups_play_sessions_pkey'
}

/** input type for inserting data into table "groups_play_sessions" */
export type GroupsPlaySessionsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  group?: InputMaybe<GroupsObjRelInsertInput>;
  groupId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  playSession?: InputMaybe<PlaySessionsObjRelInsertInput>;
  playSessionId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type GroupsPlaySessionsMaxFields = {
  __typename?: 'GroupsPlaySessionsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  groupId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  playSessionId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "groups_play_sessions" */
export type GroupsPlaySessionsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  playSessionId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type GroupsPlaySessionsMinFields = {
  __typename?: 'GroupsPlaySessionsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  groupId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  playSessionId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "groups_play_sessions" */
export type GroupsPlaySessionsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  playSessionId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "groups_play_sessions" */
export type GroupsPlaySessionsMutationResponse = {
  __typename?: 'GroupsPlaySessionsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<GroupsPlaySessions>;
};

/** on_conflict condition type for table "groups_play_sessions" */
export type GroupsPlaySessionsOnConflict = {
  constraint: GroupsPlaySessionsConstraint;
  updateColumns?: Array<GroupsPlaySessionsUpdateColumn>;
  where?: InputMaybe<GroupsPlaySessionsBoolExp>;
};

/** Ordering options when selecting data from "groups_play_sessions". */
export type GroupsPlaySessionsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  group?: InputMaybe<GroupsOrderBy>;
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  playSession?: InputMaybe<PlaySessionsOrderBy>;
  playSessionId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: groups_play_sessions */
export type GroupsPlaySessionsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "groups_play_sessions" */
export enum GroupsPlaySessionsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  GroupId = 'groupId',
  /** column name */
  Id = 'id',
  /** column name */
  PlaySessionId = 'playSessionId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "groups_play_sessions" */
export type GroupsPlaySessionsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  groupId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  playSessionId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "groups_play_sessions" */
export type GroupsPlaySessionsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: GroupsPlaySessionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type GroupsPlaySessionsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  groupId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  playSessionId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "groups_play_sessions" */
export enum GroupsPlaySessionsUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  GroupId = 'groupId',
  /** column name */
  Id = 'id',
  /** column name */
  PlaySessionId = 'playSessionId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type GroupsPlaySessionsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<GroupsPlaySessionsSetInput>;
  /** filter the rows which have to be updated */
  where: GroupsPlaySessionsBoolExp;
};

/** select columns of table "groups" */
export enum GroupsSelectColumn {
  /** column name */
  AccessCode = 'accessCode',
  /** column name */
  ActionUrl = 'actionUrl',
  /** column name */
  AddressString = 'addressString',
  /** column name */
  AllowMemberInvites = 'allowMemberInvites',
  /** column name */
  AllowMemberSessionInvites = 'allowMemberSessionInvites',
  /** column name */
  CityId = 'cityId',
  /** column name */
  ContactEmail = 'contactEmail',
  /** column name */
  ContactMessage = 'contactMessage',
  /** column name */
  ContactPhoneNumber = 'contactPhoneNumber',
  /** column name */
  ContactUrl = 'contactUrl',
  /** column name */
  CoverPhotoFileName = 'coverPhotoFileName',
  /** column name */
  CoverPhotoFileType = 'coverPhotoFileType',
  /** column name */
  CoverPhotoHost = 'coverPhotoHost',
  /** column name */
  CoverPhotoOriginalFileName = 'coverPhotoOriginalFileName',
  /** column name */
  CoverPhotoPath = 'coverPhotoPath',
  /** column name */
  CoverPhotoProvider = 'coverPhotoProvider',
  /** column name */
  CoverPhotoProviderUrl = 'coverPhotoProviderUrl',
  /** column name */
  CoverPhotoUrl = 'coverPhotoUrl',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Description = 'description',
  /** column name */
  DirectorEmail = 'directorEmail',
  /** column name */
  DirectorName = 'directorName',
  /** column name */
  DirectorPhoneNumber = 'directorPhoneNumber',
  /** column name */
  DisplayOwnerContactInfo = 'displayOwnerContactInfo',
  /** column name */
  DuprUrl = 'duprUrl',
  /** column name */
  FacebookUrl = 'facebookUrl',
  /** column name */
  Geometry = 'geometry',
  /** column name */
  Headline = 'headline',
  /** column name */
  Id = 'id',
  /** column name */
  InstagramUrl = 'instagramUrl',
  /** column name */
  IsPrivate = 'isPrivate',
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Longitude = 'longitude',
  /** column name */
  MemberDisplayCount = 'memberDisplayCount',
  /** column name */
  OrganizerEmail = 'organizerEmail',
  /** column name */
  OrganizerName = 'organizerName',
  /** column name */
  OrganizerPhoneNumber = 'organizerPhoneNumber',
  /** column name */
  OwnerUserId = 'ownerUserId',
  /** column name */
  PreferredContact = 'preferredContact',
  /** column name */
  PrimarySport = 'primarySport',
  /** column name */
  ProfilePhotoFileName = 'profilePhotoFileName',
  /** column name */
  ProfilePhotoFileType = 'profilePhotoFileType',
  /** column name */
  ProfilePhotoHost = 'profilePhotoHost',
  /** column name */
  ProfilePhotoOriginalFileName = 'profilePhotoOriginalFileName',
  /** column name */
  ProfilePhotoPath = 'profilePhotoPath',
  /** column name */
  ProfilePhotoProvider = 'profilePhotoProvider',
  /** column name */
  ProfilePhotoProviderUrl = 'profilePhotoProviderUrl',
  /** column name */
  ProfilePhotoUrl = 'profilePhotoUrl',
  /** column name */
  SkillLevelMaximum = 'skillLevelMaximum',
  /** column name */
  SkillLevelMinimum = 'skillLevelMinimum',
  /** column name */
  Slug = 'slug',
  /** column name */
  TiktokUrl = 'tiktokUrl',
  /** column name */
  Title = 'title',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  WebsiteUrl = 'websiteUrl',
  /** column name */
  XUrl = 'xUrl',
  /** column name */
  YoutubeUrl = 'youtubeUrl'
}

/** select "groupsAggregateBoolExpBool_andArgumentsColumns" columns of table "groups" */
export enum GroupsSelectColumnGroupsAggregateBoolExpBool_AndArgumentsColumns {
  /** column name */
  AllowMemberInvites = 'allowMemberInvites',
  /** column name */
  AllowMemberSessionInvites = 'allowMemberSessionInvites',
  /** column name */
  DisplayOwnerContactInfo = 'displayOwnerContactInfo',
  /** column name */
  IsPrivate = 'isPrivate'
}

/** select "groupsAggregateBoolExpBool_orArgumentsColumns" columns of table "groups" */
export enum GroupsSelectColumnGroupsAggregateBoolExpBool_OrArgumentsColumns {
  /** column name */
  AllowMemberInvites = 'allowMemberInvites',
  /** column name */
  AllowMemberSessionInvites = 'allowMemberSessionInvites',
  /** column name */
  DisplayOwnerContactInfo = 'displayOwnerContactInfo',
  /** column name */
  IsPrivate = 'isPrivate'
}

/** input type for updating data in table "groups" */
export type GroupsSetInput = {
  accessCode?: InputMaybe<Scalars['String']>;
  actionUrl?: InputMaybe<Scalars['String']>;
  addressString?: InputMaybe<Scalars['String']>;
  allowMemberInvites?: InputMaybe<Scalars['Boolean']>;
  allowMemberSessionInvites?: InputMaybe<Scalars['Boolean']>;
  cityId?: InputMaybe<Scalars['uuid']>;
  contactEmail?: InputMaybe<Scalars['String']>;
  contactMessage?: InputMaybe<Scalars['String']>;
  contactPhoneNumber?: InputMaybe<Scalars['String']>;
  contactUrl?: InputMaybe<Scalars['String']>;
  coverPhotoFileName?: InputMaybe<Scalars['String']>;
  coverPhotoFileType?: InputMaybe<Scalars['String']>;
  coverPhotoHost?: InputMaybe<Scalars['String']>;
  coverPhotoOriginalFileName?: InputMaybe<Scalars['String']>;
  coverPhotoPath?: InputMaybe<Scalars['String']>;
  coverPhotoProvider?: InputMaybe<Scalars['String']>;
  coverPhotoProviderUrl?: InputMaybe<Scalars['String']>;
  coverPhotoUrl?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  directorEmail?: InputMaybe<Scalars['String']>;
  directorName?: InputMaybe<Scalars['String']>;
  directorPhoneNumber?: InputMaybe<Scalars['String']>;
  displayOwnerContactInfo?: InputMaybe<Scalars['Boolean']>;
  duprUrl?: InputMaybe<Scalars['String']>;
  facebookUrl?: InputMaybe<Scalars['String']>;
  geometry?: InputMaybe<Scalars['geography']>;
  headline?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  instagramUrl?: InputMaybe<Scalars['String']>;
  isPrivate?: InputMaybe<Scalars['Boolean']>;
  latitude?: InputMaybe<Scalars['numeric']>;
  longitude?: InputMaybe<Scalars['numeric']>;
  memberDisplayCount?: InputMaybe<Scalars['Int']>;
  organizerEmail?: InputMaybe<Scalars['String']>;
  organizerName?: InputMaybe<Scalars['String']>;
  organizerPhoneNumber?: InputMaybe<Scalars['String']>;
  ownerUserId?: InputMaybe<Scalars['uuid']>;
  preferredContact?: InputMaybe<Scalars['String']>;
  primarySport?: InputMaybe<SportsEnum>;
  profilePhotoFileName?: InputMaybe<Scalars['String']>;
  profilePhotoFileType?: InputMaybe<Scalars['String']>;
  profilePhotoHost?: InputMaybe<Scalars['String']>;
  profilePhotoOriginalFileName?: InputMaybe<Scalars['String']>;
  profilePhotoPath?: InputMaybe<Scalars['String']>;
  profilePhotoProvider?: InputMaybe<Scalars['String']>;
  profilePhotoProviderUrl?: InputMaybe<Scalars['String']>;
  profilePhotoUrl?: InputMaybe<Scalars['String']>;
  skillLevelMaximum?: InputMaybe<Scalars['numeric']>;
  skillLevelMinimum?: InputMaybe<Scalars['numeric']>;
  slug?: InputMaybe<Scalars['String']>;
  tiktokUrl?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<GroupTypesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  websiteUrl?: InputMaybe<Scalars['String']>;
  xUrl?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type GroupsStddevFields = {
  __typename?: 'GroupsStddevFields';
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  memberDisplayCount?: Maybe<Scalars['Float']>;
  skillLevelMaximum?: Maybe<Scalars['Float']>;
  skillLevelMinimum?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "groups" */
export type GroupsStddevOrderBy = {
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  memberDisplayCount?: InputMaybe<OrderBy>;
  skillLevelMaximum?: InputMaybe<OrderBy>;
  skillLevelMinimum?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type GroupsStddevPopFields = {
  __typename?: 'GroupsStddevPopFields';
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  memberDisplayCount?: Maybe<Scalars['Float']>;
  skillLevelMaximum?: Maybe<Scalars['Float']>;
  skillLevelMinimum?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "groups" */
export type GroupsStddevPopOrderBy = {
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  memberDisplayCount?: InputMaybe<OrderBy>;
  skillLevelMaximum?: InputMaybe<OrderBy>;
  skillLevelMinimum?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type GroupsStddevSampFields = {
  __typename?: 'GroupsStddevSampFields';
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  memberDisplayCount?: Maybe<Scalars['Float']>;
  skillLevelMaximum?: Maybe<Scalars['Float']>;
  skillLevelMinimum?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "groups" */
export type GroupsStddevSampOrderBy = {
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  memberDisplayCount?: InputMaybe<OrderBy>;
  skillLevelMaximum?: InputMaybe<OrderBy>;
  skillLevelMinimum?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "groups" */
export type GroupsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: GroupsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type GroupsStreamCursorValueInput = {
  accessCode?: InputMaybe<Scalars['String']>;
  actionUrl?: InputMaybe<Scalars['String']>;
  addressString?: InputMaybe<Scalars['String']>;
  allowMemberInvites?: InputMaybe<Scalars['Boolean']>;
  allowMemberSessionInvites?: InputMaybe<Scalars['Boolean']>;
  cityId?: InputMaybe<Scalars['uuid']>;
  contactEmail?: InputMaybe<Scalars['String']>;
  contactMessage?: InputMaybe<Scalars['String']>;
  contactPhoneNumber?: InputMaybe<Scalars['String']>;
  contactUrl?: InputMaybe<Scalars['String']>;
  coverPhotoFileName?: InputMaybe<Scalars['String']>;
  coverPhotoFileType?: InputMaybe<Scalars['String']>;
  coverPhotoHost?: InputMaybe<Scalars['String']>;
  coverPhotoOriginalFileName?: InputMaybe<Scalars['String']>;
  coverPhotoPath?: InputMaybe<Scalars['String']>;
  coverPhotoProvider?: InputMaybe<Scalars['String']>;
  coverPhotoProviderUrl?: InputMaybe<Scalars['String']>;
  coverPhotoUrl?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  directorEmail?: InputMaybe<Scalars['String']>;
  directorName?: InputMaybe<Scalars['String']>;
  directorPhoneNumber?: InputMaybe<Scalars['String']>;
  displayOwnerContactInfo?: InputMaybe<Scalars['Boolean']>;
  duprUrl?: InputMaybe<Scalars['String']>;
  facebookUrl?: InputMaybe<Scalars['String']>;
  geometry?: InputMaybe<Scalars['geography']>;
  headline?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  instagramUrl?: InputMaybe<Scalars['String']>;
  isPrivate?: InputMaybe<Scalars['Boolean']>;
  latitude?: InputMaybe<Scalars['numeric']>;
  longitude?: InputMaybe<Scalars['numeric']>;
  memberDisplayCount?: InputMaybe<Scalars['Int']>;
  organizerEmail?: InputMaybe<Scalars['String']>;
  organizerName?: InputMaybe<Scalars['String']>;
  organizerPhoneNumber?: InputMaybe<Scalars['String']>;
  ownerUserId?: InputMaybe<Scalars['uuid']>;
  preferredContact?: InputMaybe<Scalars['String']>;
  primarySport?: InputMaybe<SportsEnum>;
  profilePhotoFileName?: InputMaybe<Scalars['String']>;
  profilePhotoFileType?: InputMaybe<Scalars['String']>;
  profilePhotoHost?: InputMaybe<Scalars['String']>;
  profilePhotoOriginalFileName?: InputMaybe<Scalars['String']>;
  profilePhotoPath?: InputMaybe<Scalars['String']>;
  profilePhotoProvider?: InputMaybe<Scalars['String']>;
  profilePhotoProviderUrl?: InputMaybe<Scalars['String']>;
  profilePhotoUrl?: InputMaybe<Scalars['String']>;
  skillLevelMaximum?: InputMaybe<Scalars['numeric']>;
  skillLevelMinimum?: InputMaybe<Scalars['numeric']>;
  slug?: InputMaybe<Scalars['String']>;
  tiktokUrl?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<GroupTypesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  websiteUrl?: InputMaybe<Scalars['String']>;
  xUrl?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type GroupsSumFields = {
  __typename?: 'GroupsSumFields';
  latitude?: Maybe<Scalars['numeric']>;
  longitude?: Maybe<Scalars['numeric']>;
  memberDisplayCount?: Maybe<Scalars['Int']>;
  skillLevelMaximum?: Maybe<Scalars['numeric']>;
  skillLevelMinimum?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "groups" */
export type GroupsSumOrderBy = {
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  memberDisplayCount?: InputMaybe<OrderBy>;
  skillLevelMaximum?: InputMaybe<OrderBy>;
  skillLevelMinimum?: InputMaybe<OrderBy>;
};

/** update columns of table "groups" */
export enum GroupsUpdateColumn {
  /** column name */
  AccessCode = 'accessCode',
  /** column name */
  ActionUrl = 'actionUrl',
  /** column name */
  AddressString = 'addressString',
  /** column name */
  AllowMemberInvites = 'allowMemberInvites',
  /** column name */
  AllowMemberSessionInvites = 'allowMemberSessionInvites',
  /** column name */
  CityId = 'cityId',
  /** column name */
  ContactEmail = 'contactEmail',
  /** column name */
  ContactMessage = 'contactMessage',
  /** column name */
  ContactPhoneNumber = 'contactPhoneNumber',
  /** column name */
  ContactUrl = 'contactUrl',
  /** column name */
  CoverPhotoFileName = 'coverPhotoFileName',
  /** column name */
  CoverPhotoFileType = 'coverPhotoFileType',
  /** column name */
  CoverPhotoHost = 'coverPhotoHost',
  /** column name */
  CoverPhotoOriginalFileName = 'coverPhotoOriginalFileName',
  /** column name */
  CoverPhotoPath = 'coverPhotoPath',
  /** column name */
  CoverPhotoProvider = 'coverPhotoProvider',
  /** column name */
  CoverPhotoProviderUrl = 'coverPhotoProviderUrl',
  /** column name */
  CoverPhotoUrl = 'coverPhotoUrl',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Description = 'description',
  /** column name */
  DirectorEmail = 'directorEmail',
  /** column name */
  DirectorName = 'directorName',
  /** column name */
  DirectorPhoneNumber = 'directorPhoneNumber',
  /** column name */
  DisplayOwnerContactInfo = 'displayOwnerContactInfo',
  /** column name */
  DuprUrl = 'duprUrl',
  /** column name */
  FacebookUrl = 'facebookUrl',
  /** column name */
  Geometry = 'geometry',
  /** column name */
  Headline = 'headline',
  /** column name */
  Id = 'id',
  /** column name */
  InstagramUrl = 'instagramUrl',
  /** column name */
  IsPrivate = 'isPrivate',
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Longitude = 'longitude',
  /** column name */
  MemberDisplayCount = 'memberDisplayCount',
  /** column name */
  OrganizerEmail = 'organizerEmail',
  /** column name */
  OrganizerName = 'organizerName',
  /** column name */
  OrganizerPhoneNumber = 'organizerPhoneNumber',
  /** column name */
  OwnerUserId = 'ownerUserId',
  /** column name */
  PreferredContact = 'preferredContact',
  /** column name */
  PrimarySport = 'primarySport',
  /** column name */
  ProfilePhotoFileName = 'profilePhotoFileName',
  /** column name */
  ProfilePhotoFileType = 'profilePhotoFileType',
  /** column name */
  ProfilePhotoHost = 'profilePhotoHost',
  /** column name */
  ProfilePhotoOriginalFileName = 'profilePhotoOriginalFileName',
  /** column name */
  ProfilePhotoPath = 'profilePhotoPath',
  /** column name */
  ProfilePhotoProvider = 'profilePhotoProvider',
  /** column name */
  ProfilePhotoProviderUrl = 'profilePhotoProviderUrl',
  /** column name */
  ProfilePhotoUrl = 'profilePhotoUrl',
  /** column name */
  SkillLevelMaximum = 'skillLevelMaximum',
  /** column name */
  SkillLevelMinimum = 'skillLevelMinimum',
  /** column name */
  Slug = 'slug',
  /** column name */
  TiktokUrl = 'tiktokUrl',
  /** column name */
  Title = 'title',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  WebsiteUrl = 'websiteUrl',
  /** column name */
  XUrl = 'xUrl',
  /** column name */
  YoutubeUrl = 'youtubeUrl'
}

export type GroupsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<GroupsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<GroupsSetInput>;
  /** filter the rows which have to be updated */
  where: GroupsBoolExp;
};

/** aggregate varPop on columns */
export type GroupsVarPopFields = {
  __typename?: 'GroupsVarPopFields';
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  memberDisplayCount?: Maybe<Scalars['Float']>;
  skillLevelMaximum?: Maybe<Scalars['Float']>;
  skillLevelMinimum?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "groups" */
export type GroupsVarPopOrderBy = {
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  memberDisplayCount?: InputMaybe<OrderBy>;
  skillLevelMaximum?: InputMaybe<OrderBy>;
  skillLevelMinimum?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type GroupsVarSampFields = {
  __typename?: 'GroupsVarSampFields';
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  memberDisplayCount?: Maybe<Scalars['Float']>;
  skillLevelMaximum?: Maybe<Scalars['Float']>;
  skillLevelMinimum?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "groups" */
export type GroupsVarSampOrderBy = {
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  memberDisplayCount?: InputMaybe<OrderBy>;
  skillLevelMaximum?: InputMaybe<OrderBy>;
  skillLevelMinimum?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type GroupsVarianceFields = {
  __typename?: 'GroupsVarianceFields';
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  memberDisplayCount?: Maybe<Scalars['Float']>;
  skillLevelMaximum?: Maybe<Scalars['Float']>;
  skillLevelMinimum?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "groups" */
export type GroupsVarianceOrderBy = {
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  memberDisplayCount?: InputMaybe<OrderBy>;
  skillLevelMaximum?: InputMaybe<OrderBy>;
  skillLevelMinimum?: InputMaybe<OrderBy>;
};

/** columns and relationships of "identity_verification_providers" */
export type IdentityVerificationProviders = {
  __typename?: 'IdentityVerificationProviders';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "identity_verification_providers" */
export type IdentityVerificationProvidersAggregate = {
  __typename?: 'IdentityVerificationProvidersAggregate';
  aggregate?: Maybe<IdentityVerificationProvidersAggregateFields>;
  nodes: Array<IdentityVerificationProviders>;
};

/** aggregate fields of "identity_verification_providers" */
export type IdentityVerificationProvidersAggregateFields = {
  __typename?: 'IdentityVerificationProvidersAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<IdentityVerificationProvidersMaxFields>;
  min?: Maybe<IdentityVerificationProvidersMinFields>;
};


/** aggregate fields of "identity_verification_providers" */
export type IdentityVerificationProvidersAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<IdentityVerificationProvidersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "identity_verification_providers". All fields are combined with a logical 'AND'. */
export type IdentityVerificationProvidersBoolExp = {
  _and?: InputMaybe<Array<IdentityVerificationProvidersBoolExp>>;
  _not?: InputMaybe<IdentityVerificationProvidersBoolExp>;
  _or?: InputMaybe<Array<IdentityVerificationProvidersBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "identity_verification_providers" */
export enum IdentityVerificationProvidersConstraint {
  /** unique or primary key constraint on columns "value" */
  IdentityVerificationProvidersPkey = 'identity_verification_providers_pkey'
}

export enum IdentityVerificationProvidersEnum {
  /** Facebook account linked to the player's Bounce account. */
  Facebook = 'FACEBOOK',
  /** Government ID + selfie, checked by Stripe Identity. */
  StripeIdentity = 'STRIPE_IDENTITY'
}

/** Boolean expression to compare columns of type "IdentityVerificationProvidersEnum". All fields are combined with logical 'AND'. */
export type IdentityVerificationProvidersEnumComparisonExp = {
  _eq?: InputMaybe<IdentityVerificationProvidersEnum>;
  _in?: InputMaybe<Array<IdentityVerificationProvidersEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<IdentityVerificationProvidersEnum>;
  _nin?: InputMaybe<Array<IdentityVerificationProvidersEnum>>;
};

/** input type for inserting data into table "identity_verification_providers" */
export type IdentityVerificationProvidersInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type IdentityVerificationProvidersMaxFields = {
  __typename?: 'IdentityVerificationProvidersMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type IdentityVerificationProvidersMinFields = {
  __typename?: 'IdentityVerificationProvidersMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "identity_verification_providers" */
export type IdentityVerificationProvidersMutationResponse = {
  __typename?: 'IdentityVerificationProvidersMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<IdentityVerificationProviders>;
};

/** on_conflict condition type for table "identity_verification_providers" */
export type IdentityVerificationProvidersOnConflict = {
  constraint: IdentityVerificationProvidersConstraint;
  updateColumns?: Array<IdentityVerificationProvidersUpdateColumn>;
  where?: InputMaybe<IdentityVerificationProvidersBoolExp>;
};

/** Ordering options when selecting data from "identity_verification_providers". */
export type IdentityVerificationProvidersOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: identity_verification_providers */
export type IdentityVerificationProvidersPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "identity_verification_providers" */
export enum IdentityVerificationProvidersSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "identity_verification_providers" */
export type IdentityVerificationProvidersSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "identity_verification_providers" */
export type IdentityVerificationProvidersStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: IdentityVerificationProvidersStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type IdentityVerificationProvidersStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "identity_verification_providers" */
export enum IdentityVerificationProvidersUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type IdentityVerificationProvidersUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<IdentityVerificationProvidersSetInput>;
  /** filter the rows which have to be updated */
  where: IdentityVerificationProvidersBoolExp;
};

/** columns and relationships of "identity_verification_statuses" */
export type IdentityVerificationStatuses = {
  __typename?: 'IdentityVerificationStatuses';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "identity_verification_statuses" */
export type IdentityVerificationStatusesAggregate = {
  __typename?: 'IdentityVerificationStatusesAggregate';
  aggregate?: Maybe<IdentityVerificationStatusesAggregateFields>;
  nodes: Array<IdentityVerificationStatuses>;
};

/** aggregate fields of "identity_verification_statuses" */
export type IdentityVerificationStatusesAggregateFields = {
  __typename?: 'IdentityVerificationStatusesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<IdentityVerificationStatusesMaxFields>;
  min?: Maybe<IdentityVerificationStatusesMinFields>;
};


/** aggregate fields of "identity_verification_statuses" */
export type IdentityVerificationStatusesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<IdentityVerificationStatusesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "identity_verification_statuses". All fields are combined with a logical 'AND'. */
export type IdentityVerificationStatusesBoolExp = {
  _and?: InputMaybe<Array<IdentityVerificationStatusesBoolExp>>;
  _not?: InputMaybe<IdentityVerificationStatusesBoolExp>;
  _or?: InputMaybe<Array<IdentityVerificationStatusesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "identity_verification_statuses" */
export enum IdentityVerificationStatusesConstraint {
  /** unique or primary key constraint on columns "value" */
  IdentityVerificationStatusesPkey = 'identity_verification_statuses_pkey'
}

export enum IdentityVerificationStatusesEnum {
  Failed = 'FAILED',
  NeedsReview = 'NEEDS_REVIEW',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  Verified = 'VERIFIED'
}

/** Boolean expression to compare columns of type "IdentityVerificationStatusesEnum". All fields are combined with logical 'AND'. */
export type IdentityVerificationStatusesEnumComparisonExp = {
  _eq?: InputMaybe<IdentityVerificationStatusesEnum>;
  _in?: InputMaybe<Array<IdentityVerificationStatusesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<IdentityVerificationStatusesEnum>;
  _nin?: InputMaybe<Array<IdentityVerificationStatusesEnum>>;
};

/** input type for inserting data into table "identity_verification_statuses" */
export type IdentityVerificationStatusesInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type IdentityVerificationStatusesMaxFields = {
  __typename?: 'IdentityVerificationStatusesMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type IdentityVerificationStatusesMinFields = {
  __typename?: 'IdentityVerificationStatusesMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "identity_verification_statuses" */
export type IdentityVerificationStatusesMutationResponse = {
  __typename?: 'IdentityVerificationStatusesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<IdentityVerificationStatuses>;
};

/** on_conflict condition type for table "identity_verification_statuses" */
export type IdentityVerificationStatusesOnConflict = {
  constraint: IdentityVerificationStatusesConstraint;
  updateColumns?: Array<IdentityVerificationStatusesUpdateColumn>;
  where?: InputMaybe<IdentityVerificationStatusesBoolExp>;
};

/** Ordering options when selecting data from "identity_verification_statuses". */
export type IdentityVerificationStatusesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: identity_verification_statuses */
export type IdentityVerificationStatusesPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "identity_verification_statuses" */
export enum IdentityVerificationStatusesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "identity_verification_statuses" */
export type IdentityVerificationStatusesSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "identity_verification_statuses" */
export type IdentityVerificationStatusesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: IdentityVerificationStatusesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type IdentityVerificationStatusesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "identity_verification_statuses" */
export enum IdentityVerificationStatusesUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type IdentityVerificationStatusesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<IdentityVerificationStatusesSetInput>;
  /** filter the rows which have to be updated */
  where: IdentityVerificationStatusesBoolExp;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type IntComparisonExp = {
  _eq?: InputMaybe<Scalars['Int']>;
  _gt?: InputMaybe<Scalars['Int']>;
  _gte?: InputMaybe<Scalars['Int']>;
  _in?: InputMaybe<Array<Scalars['Int']>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Int']>;
  _lte?: InputMaybe<Scalars['Int']>;
  _neq?: InputMaybe<Scalars['Int']>;
  _nin?: InputMaybe<Array<Scalars['Int']>>;
};

/** columns and relationships of "invoices" */
export type Invoices = {
  __typename?: 'Invoices';
  amountDue: Scalars['numeric'];
  amountPaid: Scalars['numeric'];
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  externalInvoiceId: Scalars['String'];
  externalSubscriptionId: Scalars['String'];
  id: Scalars['uuid'];
  paid: Scalars['Boolean'];
  peerSubscriptionId?: Maybe<Scalars['uuid']>;
  periodEnd: Scalars['timestamptz'];
  periodStart: Scalars['timestamptz'];
  /** An object relationship */
  platformSubscription?: Maybe<PlatformSubscriptions>;
  platformSubscriptionId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  stripeCustomerId: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid'];
};

/** aggregated selection of "invoices" */
export type InvoicesAggregate = {
  __typename?: 'InvoicesAggregate';
  aggregate?: Maybe<InvoicesAggregateFields>;
  nodes: Array<Invoices>;
};

export type InvoicesAggregateBoolExp = {
  bool_and?: InputMaybe<InvoicesAggregateBoolExpBool_And>;
  bool_or?: InputMaybe<InvoicesAggregateBoolExpBool_Or>;
  count?: InputMaybe<InvoicesAggregateBoolExpCount>;
};

/** aggregate fields of "invoices" */
export type InvoicesAggregateFields = {
  __typename?: 'InvoicesAggregateFields';
  avg?: Maybe<InvoicesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<InvoicesMaxFields>;
  min?: Maybe<InvoicesMinFields>;
  stddev?: Maybe<InvoicesStddevFields>;
  stddevPop?: Maybe<InvoicesStddevPopFields>;
  stddevSamp?: Maybe<InvoicesStddevSampFields>;
  sum?: Maybe<InvoicesSumFields>;
  varPop?: Maybe<InvoicesVarPopFields>;
  varSamp?: Maybe<InvoicesVarSampFields>;
  variance?: Maybe<InvoicesVarianceFields>;
};


/** aggregate fields of "invoices" */
export type InvoicesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<InvoicesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "invoices" */
export type InvoicesAggregateOrderBy = {
  avg?: InputMaybe<InvoicesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<InvoicesMaxOrderBy>;
  min?: InputMaybe<InvoicesMinOrderBy>;
  stddev?: InputMaybe<InvoicesStddevOrderBy>;
  stddevPop?: InputMaybe<InvoicesStddevPopOrderBy>;
  stddevSamp?: InputMaybe<InvoicesStddevSampOrderBy>;
  sum?: InputMaybe<InvoicesSumOrderBy>;
  varPop?: InputMaybe<InvoicesVarPopOrderBy>;
  varSamp?: InputMaybe<InvoicesVarSampOrderBy>;
  variance?: InputMaybe<InvoicesVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "invoices" */
export type InvoicesArrRelInsertInput = {
  data: Array<InvoicesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<InvoicesOnConflict>;
};

/** aggregate avg on columns */
export type InvoicesAvgFields = {
  __typename?: 'InvoicesAvgFields';
  amountDue?: Maybe<Scalars['Float']>;
  amountPaid?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "invoices" */
export type InvoicesAvgOrderBy = {
  amountDue?: InputMaybe<OrderBy>;
  amountPaid?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "invoices". All fields are combined with a logical 'AND'. */
export type InvoicesBoolExp = {
  _and?: InputMaybe<Array<InvoicesBoolExp>>;
  _not?: InputMaybe<InvoicesBoolExp>;
  _or?: InputMaybe<Array<InvoicesBoolExp>>;
  amountDue?: InputMaybe<NumericComparisonExp>;
  amountPaid?: InputMaybe<NumericComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  externalInvoiceId?: InputMaybe<StringComparisonExp>;
  externalSubscriptionId?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  paid?: InputMaybe<BooleanComparisonExp>;
  peerSubscriptionId?: InputMaybe<UuidComparisonExp>;
  periodEnd?: InputMaybe<TimestamptzComparisonExp>;
  periodStart?: InputMaybe<TimestamptzComparisonExp>;
  platformSubscription?: InputMaybe<PlatformSubscriptionsBoolExp>;
  platformSubscriptionId?: InputMaybe<UuidComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  stripeCustomerId?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "invoices" */
export enum InvoicesConstraint {
  /** unique or primary key constraint on columns "external_invoice_id" */
  InvoicesExternalInvoiceIdKey = 'invoices_external_invoice_id_key',
  /** unique or primary key constraint on columns "id" */
  InvoicesPkey = 'invoices_pkey'
}

/** input type for incrementing numeric columns in table "invoices" */
export type InvoicesIncInput = {
  amountDue?: InputMaybe<Scalars['numeric']>;
  amountPaid?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "invoices" */
export type InvoicesInsertInput = {
  amountDue?: InputMaybe<Scalars['numeric']>;
  amountPaid?: InputMaybe<Scalars['numeric']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  externalInvoiceId?: InputMaybe<Scalars['String']>;
  externalSubscriptionId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  paid?: InputMaybe<Scalars['Boolean']>;
  peerSubscriptionId?: InputMaybe<Scalars['uuid']>;
  periodEnd?: InputMaybe<Scalars['timestamptz']>;
  periodStart?: InputMaybe<Scalars['timestamptz']>;
  platformSubscription?: InputMaybe<PlatformSubscriptionsObjRelInsertInput>;
  platformSubscriptionId?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['String']>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type InvoicesMaxFields = {
  __typename?: 'InvoicesMaxFields';
  amountDue?: Maybe<Scalars['numeric']>;
  amountPaid?: Maybe<Scalars['numeric']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  externalInvoiceId?: Maybe<Scalars['String']>;
  externalSubscriptionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  peerSubscriptionId?: Maybe<Scalars['uuid']>;
  periodEnd?: Maybe<Scalars['timestamptz']>;
  periodStart?: Maybe<Scalars['timestamptz']>;
  platformSubscriptionId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "invoices" */
export type InvoicesMaxOrderBy = {
  amountDue?: InputMaybe<OrderBy>;
  amountPaid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  externalInvoiceId?: InputMaybe<OrderBy>;
  externalSubscriptionId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  peerSubscriptionId?: InputMaybe<OrderBy>;
  periodEnd?: InputMaybe<OrderBy>;
  periodStart?: InputMaybe<OrderBy>;
  platformSubscriptionId?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  stripeCustomerId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type InvoicesMinFields = {
  __typename?: 'InvoicesMinFields';
  amountDue?: Maybe<Scalars['numeric']>;
  amountPaid?: Maybe<Scalars['numeric']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  externalInvoiceId?: Maybe<Scalars['String']>;
  externalSubscriptionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  peerSubscriptionId?: Maybe<Scalars['uuid']>;
  periodEnd?: Maybe<Scalars['timestamptz']>;
  periodStart?: Maybe<Scalars['timestamptz']>;
  platformSubscriptionId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "invoices" */
export type InvoicesMinOrderBy = {
  amountDue?: InputMaybe<OrderBy>;
  amountPaid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  externalInvoiceId?: InputMaybe<OrderBy>;
  externalSubscriptionId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  peerSubscriptionId?: InputMaybe<OrderBy>;
  periodEnd?: InputMaybe<OrderBy>;
  periodStart?: InputMaybe<OrderBy>;
  platformSubscriptionId?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  stripeCustomerId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "invoices" */
export type InvoicesMutationResponse = {
  __typename?: 'InvoicesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Invoices>;
};

/** on_conflict condition type for table "invoices" */
export type InvoicesOnConflict = {
  constraint: InvoicesConstraint;
  updateColumns?: Array<InvoicesUpdateColumn>;
  where?: InputMaybe<InvoicesBoolExp>;
};

/** Ordering options when selecting data from "invoices". */
export type InvoicesOrderBy = {
  amountDue?: InputMaybe<OrderBy>;
  amountPaid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  externalInvoiceId?: InputMaybe<OrderBy>;
  externalSubscriptionId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  paid?: InputMaybe<OrderBy>;
  peerSubscriptionId?: InputMaybe<OrderBy>;
  periodEnd?: InputMaybe<OrderBy>;
  periodStart?: InputMaybe<OrderBy>;
  platformSubscription?: InputMaybe<PlatformSubscriptionsOrderBy>;
  platformSubscriptionId?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  stripeCustomerId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: invoices */
export type InvoicesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "invoices" */
export enum InvoicesSelectColumn {
  /** column name */
  AmountDue = 'amountDue',
  /** column name */
  AmountPaid = 'amountPaid',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  ExternalInvoiceId = 'externalInvoiceId',
  /** column name */
  ExternalSubscriptionId = 'externalSubscriptionId',
  /** column name */
  Id = 'id',
  /** column name */
  Paid = 'paid',
  /** column name */
  PeerSubscriptionId = 'peerSubscriptionId',
  /** column name */
  PeriodEnd = 'periodEnd',
  /** column name */
  PeriodStart = 'periodStart',
  /** column name */
  PlatformSubscriptionId = 'platformSubscriptionId',
  /** column name */
  Status = 'status',
  /** column name */
  StripeCustomerId = 'stripeCustomerId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** select "invoicesAggregateBoolExpBool_andArgumentsColumns" columns of table "invoices" */
export enum InvoicesSelectColumnInvoicesAggregateBoolExpBool_AndArgumentsColumns {
  /** column name */
  Paid = 'paid'
}

/** select "invoicesAggregateBoolExpBool_orArgumentsColumns" columns of table "invoices" */
export enum InvoicesSelectColumnInvoicesAggregateBoolExpBool_OrArgumentsColumns {
  /** column name */
  Paid = 'paid'
}

/** input type for updating data in table "invoices" */
export type InvoicesSetInput = {
  amountDue?: InputMaybe<Scalars['numeric']>;
  amountPaid?: InputMaybe<Scalars['numeric']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  externalInvoiceId?: InputMaybe<Scalars['String']>;
  externalSubscriptionId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  paid?: InputMaybe<Scalars['Boolean']>;
  peerSubscriptionId?: InputMaybe<Scalars['uuid']>;
  periodEnd?: InputMaybe<Scalars['timestamptz']>;
  periodStart?: InputMaybe<Scalars['timestamptz']>;
  platformSubscriptionId?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['String']>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type InvoicesStddevFields = {
  __typename?: 'InvoicesStddevFields';
  amountDue?: Maybe<Scalars['Float']>;
  amountPaid?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "invoices" */
export type InvoicesStddevOrderBy = {
  amountDue?: InputMaybe<OrderBy>;
  amountPaid?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type InvoicesStddevPopFields = {
  __typename?: 'InvoicesStddevPopFields';
  amountDue?: Maybe<Scalars['Float']>;
  amountPaid?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "invoices" */
export type InvoicesStddevPopOrderBy = {
  amountDue?: InputMaybe<OrderBy>;
  amountPaid?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type InvoicesStddevSampFields = {
  __typename?: 'InvoicesStddevSampFields';
  amountDue?: Maybe<Scalars['Float']>;
  amountPaid?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "invoices" */
export type InvoicesStddevSampOrderBy = {
  amountDue?: InputMaybe<OrderBy>;
  amountPaid?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "invoices" */
export type InvoicesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: InvoicesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type InvoicesStreamCursorValueInput = {
  amountDue?: InputMaybe<Scalars['numeric']>;
  amountPaid?: InputMaybe<Scalars['numeric']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  externalInvoiceId?: InputMaybe<Scalars['String']>;
  externalSubscriptionId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  paid?: InputMaybe<Scalars['Boolean']>;
  peerSubscriptionId?: InputMaybe<Scalars['uuid']>;
  periodEnd?: InputMaybe<Scalars['timestamptz']>;
  periodStart?: InputMaybe<Scalars['timestamptz']>;
  platformSubscriptionId?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['String']>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type InvoicesSumFields = {
  __typename?: 'InvoicesSumFields';
  amountDue?: Maybe<Scalars['numeric']>;
  amountPaid?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "invoices" */
export type InvoicesSumOrderBy = {
  amountDue?: InputMaybe<OrderBy>;
  amountPaid?: InputMaybe<OrderBy>;
};

/** update columns of table "invoices" */
export enum InvoicesUpdateColumn {
  /** column name */
  AmountDue = 'amountDue',
  /** column name */
  AmountPaid = 'amountPaid',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  ExternalInvoiceId = 'externalInvoiceId',
  /** column name */
  ExternalSubscriptionId = 'externalSubscriptionId',
  /** column name */
  Id = 'id',
  /** column name */
  Paid = 'paid',
  /** column name */
  PeerSubscriptionId = 'peerSubscriptionId',
  /** column name */
  PeriodEnd = 'periodEnd',
  /** column name */
  PeriodStart = 'periodStart',
  /** column name */
  PlatformSubscriptionId = 'platformSubscriptionId',
  /** column name */
  Status = 'status',
  /** column name */
  StripeCustomerId = 'stripeCustomerId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

export type InvoicesUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<InvoicesIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<InvoicesSetInput>;
  /** filter the rows which have to be updated */
  where: InvoicesBoolExp;
};

/** aggregate varPop on columns */
export type InvoicesVarPopFields = {
  __typename?: 'InvoicesVarPopFields';
  amountDue?: Maybe<Scalars['Float']>;
  amountPaid?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "invoices" */
export type InvoicesVarPopOrderBy = {
  amountDue?: InputMaybe<OrderBy>;
  amountPaid?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type InvoicesVarSampFields = {
  __typename?: 'InvoicesVarSampFields';
  amountDue?: Maybe<Scalars['Float']>;
  amountPaid?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "invoices" */
export type InvoicesVarSampOrderBy = {
  amountDue?: InputMaybe<OrderBy>;
  amountPaid?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type InvoicesVarianceFields = {
  __typename?: 'InvoicesVarianceFields';
  amountDue?: Maybe<Scalars['Float']>;
  amountPaid?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "invoices" */
export type InvoicesVarianceOrderBy = {
  amountDue?: InputMaybe<OrderBy>;
  amountPaid?: InputMaybe<OrderBy>;
};

export type JsonbCastExp = {
  String?: InputMaybe<StringComparisonExp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type JsonbComparisonExp = {
  _cast?: InputMaybe<JsonbCastExp>;
  /** is the column contained in the given json value */
  _containedIn?: InputMaybe<Scalars['jsonb']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']>;
  _eq?: InputMaybe<Scalars['jsonb']>;
  _gt?: InputMaybe<Scalars['jsonb']>;
  _gte?: InputMaybe<Scalars['jsonb']>;
  /** does the string exist as a top-level key in the column */
  _hasKey?: InputMaybe<Scalars['String']>;
  /** do all of these strings exist as top-level keys in the column */
  _hasKeysAll?: InputMaybe<Array<Scalars['String']>>;
  /** do any of these strings exist as top-level keys in the column */
  _hasKeysAny?: InputMaybe<Array<Scalars['String']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['jsonb']>;
  _lte?: InputMaybe<Scalars['jsonb']>;
  _neq?: InputMaybe<Scalars['jsonb']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']>>;
};

/** Tracks when a user watched each media category (lesson, drill, etc.) per schedule progress. Row exists with watched_at set = watched. */
export type LearningProgramEnrollmentScheduleMediaWatched = {
  __typename?: 'LearningProgramEnrollmentScheduleMediaWatched';
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  learningProgramEnrollmentScheduleProgress: LearningProgramEnrollmentScheduleProgress;
  learningProgramEnrollmentScheduleProgressId: Scalars['uuid'];
  /** An object relationship */
  mediaCategory: LearningProgramMediaCategories;
  mediaCategoryId: Scalars['uuid'];
  watchedAt: Scalars['timestamptz'];
};

/** aggregated selection of "learning_program_enrollment_schedule_media_watched" */
export type LearningProgramEnrollmentScheduleMediaWatchedAggregate = {
  __typename?: 'LearningProgramEnrollmentScheduleMediaWatchedAggregate';
  aggregate?: Maybe<LearningProgramEnrollmentScheduleMediaWatchedAggregateFields>;
  nodes: Array<LearningProgramEnrollmentScheduleMediaWatched>;
};

export type LearningProgramEnrollmentScheduleMediaWatchedAggregateBoolExp = {
  count?: InputMaybe<LearningProgramEnrollmentScheduleMediaWatchedAggregateBoolExpCount>;
};

/** aggregate fields of "learning_program_enrollment_schedule_media_watched" */
export type LearningProgramEnrollmentScheduleMediaWatchedAggregateFields = {
  __typename?: 'LearningProgramEnrollmentScheduleMediaWatchedAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<LearningProgramEnrollmentScheduleMediaWatchedMaxFields>;
  min?: Maybe<LearningProgramEnrollmentScheduleMediaWatchedMinFields>;
};


/** aggregate fields of "learning_program_enrollment_schedule_media_watched" */
export type LearningProgramEnrollmentScheduleMediaWatchedAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<LearningProgramEnrollmentScheduleMediaWatchedSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "learning_program_enrollment_schedule_media_watched" */
export type LearningProgramEnrollmentScheduleMediaWatchedAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<LearningProgramEnrollmentScheduleMediaWatchedMaxOrderBy>;
  min?: InputMaybe<LearningProgramEnrollmentScheduleMediaWatchedMinOrderBy>;
};

/** input type for inserting array relation for remote table "learning_program_enrollment_schedule_media_watched" */
export type LearningProgramEnrollmentScheduleMediaWatchedArrRelInsertInput = {
  data: Array<LearningProgramEnrollmentScheduleMediaWatchedInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<LearningProgramEnrollmentScheduleMediaWatchedOnConflict>;
};

/** Boolean expression to filter rows from the table "learning_program_enrollment_schedule_media_watched". All fields are combined with a logical 'AND'. */
export type LearningProgramEnrollmentScheduleMediaWatchedBoolExp = {
  _and?: InputMaybe<Array<LearningProgramEnrollmentScheduleMediaWatchedBoolExp>>;
  _not?: InputMaybe<LearningProgramEnrollmentScheduleMediaWatchedBoolExp>;
  _or?: InputMaybe<Array<LearningProgramEnrollmentScheduleMediaWatchedBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  learningProgramEnrollmentScheduleProgress?: InputMaybe<LearningProgramEnrollmentScheduleProgressBoolExp>;
  learningProgramEnrollmentScheduleProgressId?: InputMaybe<UuidComparisonExp>;
  mediaCategory?: InputMaybe<LearningProgramMediaCategoriesBoolExp>;
  mediaCategoryId?: InputMaybe<UuidComparisonExp>;
  watchedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "learning_program_enrollment_schedule_media_watched" */
export enum LearningProgramEnrollmentScheduleMediaWatchedConstraint {
  /** unique or primary key constraint on columns "id" */
  LearningProgramEnrollmentScheduleMediaWatchedPkey = 'learning_program_enrollment_schedule_media_watched_pkey',
  /** unique or primary key constraint on columns "learning_program_enrollment_schedule_progress_id", "media_category_id" */
  UqEnrollmentScheduleMediaWatchedProgressCategory = 'uq_enrollment_schedule_media_watched_progress_category'
}

/** input type for inserting data into table "learning_program_enrollment_schedule_media_watched" */
export type LearningProgramEnrollmentScheduleMediaWatchedInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  learningProgramEnrollmentScheduleProgress?: InputMaybe<LearningProgramEnrollmentScheduleProgressObjRelInsertInput>;
  learningProgramEnrollmentScheduleProgressId?: InputMaybe<Scalars['uuid']>;
  mediaCategory?: InputMaybe<LearningProgramMediaCategoriesObjRelInsertInput>;
  mediaCategoryId?: InputMaybe<Scalars['uuid']>;
  watchedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type LearningProgramEnrollmentScheduleMediaWatchedMaxFields = {
  __typename?: 'LearningProgramEnrollmentScheduleMediaWatchedMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  learningProgramEnrollmentScheduleProgressId?: Maybe<Scalars['uuid']>;
  mediaCategoryId?: Maybe<Scalars['uuid']>;
  watchedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "learning_program_enrollment_schedule_media_watched" */
export type LearningProgramEnrollmentScheduleMediaWatchedMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  learningProgramEnrollmentScheduleProgressId?: InputMaybe<OrderBy>;
  mediaCategoryId?: InputMaybe<OrderBy>;
  watchedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type LearningProgramEnrollmentScheduleMediaWatchedMinFields = {
  __typename?: 'LearningProgramEnrollmentScheduleMediaWatchedMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  learningProgramEnrollmentScheduleProgressId?: Maybe<Scalars['uuid']>;
  mediaCategoryId?: Maybe<Scalars['uuid']>;
  watchedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "learning_program_enrollment_schedule_media_watched" */
export type LearningProgramEnrollmentScheduleMediaWatchedMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  learningProgramEnrollmentScheduleProgressId?: InputMaybe<OrderBy>;
  mediaCategoryId?: InputMaybe<OrderBy>;
  watchedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "learning_program_enrollment_schedule_media_watched" */
export type LearningProgramEnrollmentScheduleMediaWatchedMutationResponse = {
  __typename?: 'LearningProgramEnrollmentScheduleMediaWatchedMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LearningProgramEnrollmentScheduleMediaWatched>;
};

/** on_conflict condition type for table "learning_program_enrollment_schedule_media_watched" */
export type LearningProgramEnrollmentScheduleMediaWatchedOnConflict = {
  constraint: LearningProgramEnrollmentScheduleMediaWatchedConstraint;
  updateColumns?: Array<LearningProgramEnrollmentScheduleMediaWatchedUpdateColumn>;
  where?: InputMaybe<LearningProgramEnrollmentScheduleMediaWatchedBoolExp>;
};

/** Ordering options when selecting data from "learning_program_enrollment_schedule_media_watched". */
export type LearningProgramEnrollmentScheduleMediaWatchedOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  learningProgramEnrollmentScheduleProgress?: InputMaybe<LearningProgramEnrollmentScheduleProgressOrderBy>;
  learningProgramEnrollmentScheduleProgressId?: InputMaybe<OrderBy>;
  mediaCategory?: InputMaybe<LearningProgramMediaCategoriesOrderBy>;
  mediaCategoryId?: InputMaybe<OrderBy>;
  watchedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: learning_program_enrollment_schedule_media_watched */
export type LearningProgramEnrollmentScheduleMediaWatchedPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "learning_program_enrollment_schedule_media_watched" */
export enum LearningProgramEnrollmentScheduleMediaWatchedSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  LearningProgramEnrollmentScheduleProgressId = 'learningProgramEnrollmentScheduleProgressId',
  /** column name */
  MediaCategoryId = 'mediaCategoryId',
  /** column name */
  WatchedAt = 'watchedAt'
}

/** input type for updating data in table "learning_program_enrollment_schedule_media_watched" */
export type LearningProgramEnrollmentScheduleMediaWatchedSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  learningProgramEnrollmentScheduleProgressId?: InputMaybe<Scalars['uuid']>;
  mediaCategoryId?: InputMaybe<Scalars['uuid']>;
  watchedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "learning_program_enrollment_schedule_media_watched" */
export type LearningProgramEnrollmentScheduleMediaWatchedStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: LearningProgramEnrollmentScheduleMediaWatchedStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LearningProgramEnrollmentScheduleMediaWatchedStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  learningProgramEnrollmentScheduleProgressId?: InputMaybe<Scalars['uuid']>;
  mediaCategoryId?: InputMaybe<Scalars['uuid']>;
  watchedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "learning_program_enrollment_schedule_media_watched" */
export enum LearningProgramEnrollmentScheduleMediaWatchedUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  LearningProgramEnrollmentScheduleProgressId = 'learningProgramEnrollmentScheduleProgressId',
  /** column name */
  MediaCategoryId = 'mediaCategoryId',
  /** column name */
  WatchedAt = 'watchedAt'
}

export type LearningProgramEnrollmentScheduleMediaWatchedUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LearningProgramEnrollmentScheduleMediaWatchedSetInput>;
  /** filter the rows which have to be updated */
  where: LearningProgramEnrollmentScheduleMediaWatchedBoolExp;
};

/** Detailed progress tracking for each schedule period of an enrollment */
export type LearningProgramEnrollmentScheduleProgress = {
  __typename?: 'LearningProgramEnrollmentScheduleProgress';
  completedAt?: Maybe<Scalars['date']>;
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  learningProgramEnrollment: LearningProgramEnrollments;
  learningProgramEnrollmentId: Scalars['uuid'];
  /** An object relationship */
  learningProgramSchedule: LearningProgramSchedules;
  learningProgramScheduleId: Scalars['uuid'];
  /** An array relationship */
  mediaWatched: Array<LearningProgramEnrollmentScheduleMediaWatched>;
  /** An aggregate relationship */
  mediaWatchedAggregate: LearningProgramEnrollmentScheduleMediaWatchedAggregate;
  scheduleNumber: Scalars['Int'];
  updatedAt: Scalars['timestamptz'];
};


/** Detailed progress tracking for each schedule period of an enrollment */
export type LearningProgramEnrollmentScheduleProgressMediaWatchedArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramEnrollmentScheduleMediaWatchedSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramEnrollmentScheduleMediaWatchedOrderBy>>;
  where?: InputMaybe<LearningProgramEnrollmentScheduleMediaWatchedBoolExp>;
};


/** Detailed progress tracking for each schedule period of an enrollment */
export type LearningProgramEnrollmentScheduleProgressMediaWatchedAggregateArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramEnrollmentScheduleMediaWatchedSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramEnrollmentScheduleMediaWatchedOrderBy>>;
  where?: InputMaybe<LearningProgramEnrollmentScheduleMediaWatchedBoolExp>;
};

/** aggregated selection of "learning_program_enrollment_schedule_progress" */
export type LearningProgramEnrollmentScheduleProgressAggregate = {
  __typename?: 'LearningProgramEnrollmentScheduleProgressAggregate';
  aggregate?: Maybe<LearningProgramEnrollmentScheduleProgressAggregateFields>;
  nodes: Array<LearningProgramEnrollmentScheduleProgress>;
};

export type LearningProgramEnrollmentScheduleProgressAggregateBoolExp = {
  count?: InputMaybe<LearningProgramEnrollmentScheduleProgressAggregateBoolExpCount>;
};

/** aggregate fields of "learning_program_enrollment_schedule_progress" */
export type LearningProgramEnrollmentScheduleProgressAggregateFields = {
  __typename?: 'LearningProgramEnrollmentScheduleProgressAggregateFields';
  avg?: Maybe<LearningProgramEnrollmentScheduleProgressAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<LearningProgramEnrollmentScheduleProgressMaxFields>;
  min?: Maybe<LearningProgramEnrollmentScheduleProgressMinFields>;
  stddev?: Maybe<LearningProgramEnrollmentScheduleProgressStddevFields>;
  stddevPop?: Maybe<LearningProgramEnrollmentScheduleProgressStddevPopFields>;
  stddevSamp?: Maybe<LearningProgramEnrollmentScheduleProgressStddevSampFields>;
  sum?: Maybe<LearningProgramEnrollmentScheduleProgressSumFields>;
  varPop?: Maybe<LearningProgramEnrollmentScheduleProgressVarPopFields>;
  varSamp?: Maybe<LearningProgramEnrollmentScheduleProgressVarSampFields>;
  variance?: Maybe<LearningProgramEnrollmentScheduleProgressVarianceFields>;
};


/** aggregate fields of "learning_program_enrollment_schedule_progress" */
export type LearningProgramEnrollmentScheduleProgressAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<LearningProgramEnrollmentScheduleProgressSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "learning_program_enrollment_schedule_progress" */
export type LearningProgramEnrollmentScheduleProgressAggregateOrderBy = {
  avg?: InputMaybe<LearningProgramEnrollmentScheduleProgressAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<LearningProgramEnrollmentScheduleProgressMaxOrderBy>;
  min?: InputMaybe<LearningProgramEnrollmentScheduleProgressMinOrderBy>;
  stddev?: InputMaybe<LearningProgramEnrollmentScheduleProgressStddevOrderBy>;
  stddevPop?: InputMaybe<LearningProgramEnrollmentScheduleProgressStddevPopOrderBy>;
  stddevSamp?: InputMaybe<LearningProgramEnrollmentScheduleProgressStddevSampOrderBy>;
  sum?: InputMaybe<LearningProgramEnrollmentScheduleProgressSumOrderBy>;
  varPop?: InputMaybe<LearningProgramEnrollmentScheduleProgressVarPopOrderBy>;
  varSamp?: InputMaybe<LearningProgramEnrollmentScheduleProgressVarSampOrderBy>;
  variance?: InputMaybe<LearningProgramEnrollmentScheduleProgressVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "learning_program_enrollment_schedule_progress" */
export type LearningProgramEnrollmentScheduleProgressArrRelInsertInput = {
  data: Array<LearningProgramEnrollmentScheduleProgressInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<LearningProgramEnrollmentScheduleProgressOnConflict>;
};

/** aggregate avg on columns */
export type LearningProgramEnrollmentScheduleProgressAvgFields = {
  __typename?: 'LearningProgramEnrollmentScheduleProgressAvgFields';
  scheduleNumber?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "learning_program_enrollment_schedule_progress" */
export type LearningProgramEnrollmentScheduleProgressAvgOrderBy = {
  scheduleNumber?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "learning_program_enrollment_schedule_progress". All fields are combined with a logical 'AND'. */
export type LearningProgramEnrollmentScheduleProgressBoolExp = {
  _and?: InputMaybe<Array<LearningProgramEnrollmentScheduleProgressBoolExp>>;
  _not?: InputMaybe<LearningProgramEnrollmentScheduleProgressBoolExp>;
  _or?: InputMaybe<Array<LearningProgramEnrollmentScheduleProgressBoolExp>>;
  completedAt?: InputMaybe<DateComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  learningProgramEnrollment?: InputMaybe<LearningProgramEnrollmentsBoolExp>;
  learningProgramEnrollmentId?: InputMaybe<UuidComparisonExp>;
  learningProgramSchedule?: InputMaybe<LearningProgramSchedulesBoolExp>;
  learningProgramScheduleId?: InputMaybe<UuidComparisonExp>;
  mediaWatched?: InputMaybe<LearningProgramEnrollmentScheduleMediaWatchedBoolExp>;
  mediaWatchedAggregate?: InputMaybe<LearningProgramEnrollmentScheduleMediaWatchedAggregateBoolExp>;
  scheduleNumber?: InputMaybe<IntComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "learning_program_enrollment_schedule_progress" */
export enum LearningProgramEnrollmentScheduleProgressConstraint {
  /** unique or primary key constraint on columns "id" */
  LearningProgramEnrollmentScheduleProgressPkey = 'learning_program_enrollment_schedule_progress_pkey',
  /** unique or primary key constraint on columns "learning_program_enrollment_id", "learning_program_schedule_id" */
  UqEnrollmentScheduleProgressEnrollmentSchedule = 'uq_enrollment_schedule_progress_enrollment_schedule'
}

/** input type for incrementing numeric columns in table "learning_program_enrollment_schedule_progress" */
export type LearningProgramEnrollmentScheduleProgressIncInput = {
  scheduleNumber?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "learning_program_enrollment_schedule_progress" */
export type LearningProgramEnrollmentScheduleProgressInsertInput = {
  completedAt?: InputMaybe<Scalars['date']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  learningProgramEnrollment?: InputMaybe<LearningProgramEnrollmentsObjRelInsertInput>;
  learningProgramEnrollmentId?: InputMaybe<Scalars['uuid']>;
  learningProgramSchedule?: InputMaybe<LearningProgramSchedulesObjRelInsertInput>;
  learningProgramScheduleId?: InputMaybe<Scalars['uuid']>;
  mediaWatched?: InputMaybe<LearningProgramEnrollmentScheduleMediaWatchedArrRelInsertInput>;
  scheduleNumber?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type LearningProgramEnrollmentScheduleProgressMaxFields = {
  __typename?: 'LearningProgramEnrollmentScheduleProgressMaxFields';
  completedAt?: Maybe<Scalars['date']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  learningProgramEnrollmentId?: Maybe<Scalars['uuid']>;
  learningProgramScheduleId?: Maybe<Scalars['uuid']>;
  scheduleNumber?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "learning_program_enrollment_schedule_progress" */
export type LearningProgramEnrollmentScheduleProgressMaxOrderBy = {
  completedAt?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  learningProgramEnrollmentId?: InputMaybe<OrderBy>;
  learningProgramScheduleId?: InputMaybe<OrderBy>;
  scheduleNumber?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type LearningProgramEnrollmentScheduleProgressMinFields = {
  __typename?: 'LearningProgramEnrollmentScheduleProgressMinFields';
  completedAt?: Maybe<Scalars['date']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  learningProgramEnrollmentId?: Maybe<Scalars['uuid']>;
  learningProgramScheduleId?: Maybe<Scalars['uuid']>;
  scheduleNumber?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "learning_program_enrollment_schedule_progress" */
export type LearningProgramEnrollmentScheduleProgressMinOrderBy = {
  completedAt?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  learningProgramEnrollmentId?: InputMaybe<OrderBy>;
  learningProgramScheduleId?: InputMaybe<OrderBy>;
  scheduleNumber?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "learning_program_enrollment_schedule_progress" */
export type LearningProgramEnrollmentScheduleProgressMutationResponse = {
  __typename?: 'LearningProgramEnrollmentScheduleProgressMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LearningProgramEnrollmentScheduleProgress>;
};

/** input type for inserting object relation for remote table "learning_program_enrollment_schedule_progress" */
export type LearningProgramEnrollmentScheduleProgressObjRelInsertInput = {
  data: LearningProgramEnrollmentScheduleProgressInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<LearningProgramEnrollmentScheduleProgressOnConflict>;
};

/** on_conflict condition type for table "learning_program_enrollment_schedule_progress" */
export type LearningProgramEnrollmentScheduleProgressOnConflict = {
  constraint: LearningProgramEnrollmentScheduleProgressConstraint;
  updateColumns?: Array<LearningProgramEnrollmentScheduleProgressUpdateColumn>;
  where?: InputMaybe<LearningProgramEnrollmentScheduleProgressBoolExp>;
};

/** Ordering options when selecting data from "learning_program_enrollment_schedule_progress". */
export type LearningProgramEnrollmentScheduleProgressOrderBy = {
  completedAt?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  learningProgramEnrollment?: InputMaybe<LearningProgramEnrollmentsOrderBy>;
  learningProgramEnrollmentId?: InputMaybe<OrderBy>;
  learningProgramSchedule?: InputMaybe<LearningProgramSchedulesOrderBy>;
  learningProgramScheduleId?: InputMaybe<OrderBy>;
  mediaWatchedAggregate?: InputMaybe<LearningProgramEnrollmentScheduleMediaWatchedAggregateOrderBy>;
  scheduleNumber?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: learning_program_enrollment_schedule_progress */
export type LearningProgramEnrollmentScheduleProgressPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "learning_program_enrollment_schedule_progress" */
export enum LearningProgramEnrollmentScheduleProgressSelectColumn {
  /** column name */
  CompletedAt = 'completedAt',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  LearningProgramEnrollmentId = 'learningProgramEnrollmentId',
  /** column name */
  LearningProgramScheduleId = 'learningProgramScheduleId',
  /** column name */
  ScheduleNumber = 'scheduleNumber',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "learning_program_enrollment_schedule_progress" */
export type LearningProgramEnrollmentScheduleProgressSetInput = {
  completedAt?: InputMaybe<Scalars['date']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  learningProgramEnrollmentId?: InputMaybe<Scalars['uuid']>;
  learningProgramScheduleId?: InputMaybe<Scalars['uuid']>;
  scheduleNumber?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type LearningProgramEnrollmentScheduleProgressStddevFields = {
  __typename?: 'LearningProgramEnrollmentScheduleProgressStddevFields';
  scheduleNumber?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "learning_program_enrollment_schedule_progress" */
export type LearningProgramEnrollmentScheduleProgressStddevOrderBy = {
  scheduleNumber?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type LearningProgramEnrollmentScheduleProgressStddevPopFields = {
  __typename?: 'LearningProgramEnrollmentScheduleProgressStddevPopFields';
  scheduleNumber?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "learning_program_enrollment_schedule_progress" */
export type LearningProgramEnrollmentScheduleProgressStddevPopOrderBy = {
  scheduleNumber?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type LearningProgramEnrollmentScheduleProgressStddevSampFields = {
  __typename?: 'LearningProgramEnrollmentScheduleProgressStddevSampFields';
  scheduleNumber?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "learning_program_enrollment_schedule_progress" */
export type LearningProgramEnrollmentScheduleProgressStddevSampOrderBy = {
  scheduleNumber?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "learning_program_enrollment_schedule_progress" */
export type LearningProgramEnrollmentScheduleProgressStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: LearningProgramEnrollmentScheduleProgressStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LearningProgramEnrollmentScheduleProgressStreamCursorValueInput = {
  completedAt?: InputMaybe<Scalars['date']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  learningProgramEnrollmentId?: InputMaybe<Scalars['uuid']>;
  learningProgramScheduleId?: InputMaybe<Scalars['uuid']>;
  scheduleNumber?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type LearningProgramEnrollmentScheduleProgressSumFields = {
  __typename?: 'LearningProgramEnrollmentScheduleProgressSumFields';
  scheduleNumber?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "learning_program_enrollment_schedule_progress" */
export type LearningProgramEnrollmentScheduleProgressSumOrderBy = {
  scheduleNumber?: InputMaybe<OrderBy>;
};

/** update columns of table "learning_program_enrollment_schedule_progress" */
export enum LearningProgramEnrollmentScheduleProgressUpdateColumn {
  /** column name */
  CompletedAt = 'completedAt',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  LearningProgramEnrollmentId = 'learningProgramEnrollmentId',
  /** column name */
  LearningProgramScheduleId = 'learningProgramScheduleId',
  /** column name */
  ScheduleNumber = 'scheduleNumber',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type LearningProgramEnrollmentScheduleProgressUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<LearningProgramEnrollmentScheduleProgressIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LearningProgramEnrollmentScheduleProgressSetInput>;
  /** filter the rows which have to be updated */
  where: LearningProgramEnrollmentScheduleProgressBoolExp;
};

/** aggregate varPop on columns */
export type LearningProgramEnrollmentScheduleProgressVarPopFields = {
  __typename?: 'LearningProgramEnrollmentScheduleProgressVarPopFields';
  scheduleNumber?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "learning_program_enrollment_schedule_progress" */
export type LearningProgramEnrollmentScheduleProgressVarPopOrderBy = {
  scheduleNumber?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type LearningProgramEnrollmentScheduleProgressVarSampFields = {
  __typename?: 'LearningProgramEnrollmentScheduleProgressVarSampFields';
  scheduleNumber?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "learning_program_enrollment_schedule_progress" */
export type LearningProgramEnrollmentScheduleProgressVarSampOrderBy = {
  scheduleNumber?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type LearningProgramEnrollmentScheduleProgressVarianceFields = {
  __typename?: 'LearningProgramEnrollmentScheduleProgressVarianceFields';
  scheduleNumber?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "learning_program_enrollment_schedule_progress" */
export type LearningProgramEnrollmentScheduleProgressVarianceOrderBy = {
  scheduleNumber?: InputMaybe<OrderBy>;
};

/** Tracks which players are enrolled in which programs */
export type LearningProgramEnrollments = {
  __typename?: 'LearningProgramEnrollments';
  completedAt?: Maybe<Scalars['date']>;
  createdAt: Scalars['timestamptz'];
  /** Current schedule period the player is on */
  currentSchedule: Scalars['Int'];
  enrolledAt: Scalars['date'];
  id: Scalars['uuid'];
  /** An object relationship */
  learningProgram: LearningPrograms;
  learningProgramId: Scalars['uuid'];
  pausedAt?: Maybe<Scalars['date']>;
  /** An array relationship */
  scheduleProgress: Array<LearningProgramEnrollmentScheduleProgress>;
  /** An aggregate relationship */
  scheduleProgressAggregate: LearningProgramEnrollmentScheduleProgressAggregate;
  status: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid'];
  /** An array relationship */
  videoSubmissions: Array<LearningProgramScheduleVideoSubmissions>;
  /** An aggregate relationship */
  videoSubmissionsAggregate: LearningProgramScheduleVideoSubmissionsAggregate;
};


/** Tracks which players are enrolled in which programs */
export type LearningProgramEnrollmentsScheduleProgressArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramEnrollmentScheduleProgressSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramEnrollmentScheduleProgressOrderBy>>;
  where?: InputMaybe<LearningProgramEnrollmentScheduleProgressBoolExp>;
};


/** Tracks which players are enrolled in which programs */
export type LearningProgramEnrollmentsScheduleProgressAggregateArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramEnrollmentScheduleProgressSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramEnrollmentScheduleProgressOrderBy>>;
  where?: InputMaybe<LearningProgramEnrollmentScheduleProgressBoolExp>;
};


/** Tracks which players are enrolled in which programs */
export type LearningProgramEnrollmentsVideoSubmissionsArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramScheduleVideoSubmissionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramScheduleVideoSubmissionsOrderBy>>;
  where?: InputMaybe<LearningProgramScheduleVideoSubmissionsBoolExp>;
};


/** Tracks which players are enrolled in which programs */
export type LearningProgramEnrollmentsVideoSubmissionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramScheduleVideoSubmissionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramScheduleVideoSubmissionsOrderBy>>;
  where?: InputMaybe<LearningProgramScheduleVideoSubmissionsBoolExp>;
};

/** aggregated selection of "learning_program_enrollments" */
export type LearningProgramEnrollmentsAggregate = {
  __typename?: 'LearningProgramEnrollmentsAggregate';
  aggregate?: Maybe<LearningProgramEnrollmentsAggregateFields>;
  nodes: Array<LearningProgramEnrollments>;
};

export type LearningProgramEnrollmentsAggregateBoolExp = {
  count?: InputMaybe<LearningProgramEnrollmentsAggregateBoolExpCount>;
};

/** aggregate fields of "learning_program_enrollments" */
export type LearningProgramEnrollmentsAggregateFields = {
  __typename?: 'LearningProgramEnrollmentsAggregateFields';
  avg?: Maybe<LearningProgramEnrollmentsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<LearningProgramEnrollmentsMaxFields>;
  min?: Maybe<LearningProgramEnrollmentsMinFields>;
  stddev?: Maybe<LearningProgramEnrollmentsStddevFields>;
  stddevPop?: Maybe<LearningProgramEnrollmentsStddevPopFields>;
  stddevSamp?: Maybe<LearningProgramEnrollmentsStddevSampFields>;
  sum?: Maybe<LearningProgramEnrollmentsSumFields>;
  varPop?: Maybe<LearningProgramEnrollmentsVarPopFields>;
  varSamp?: Maybe<LearningProgramEnrollmentsVarSampFields>;
  variance?: Maybe<LearningProgramEnrollmentsVarianceFields>;
};


/** aggregate fields of "learning_program_enrollments" */
export type LearningProgramEnrollmentsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<LearningProgramEnrollmentsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "learning_program_enrollments" */
export type LearningProgramEnrollmentsAggregateOrderBy = {
  avg?: InputMaybe<LearningProgramEnrollmentsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<LearningProgramEnrollmentsMaxOrderBy>;
  min?: InputMaybe<LearningProgramEnrollmentsMinOrderBy>;
  stddev?: InputMaybe<LearningProgramEnrollmentsStddevOrderBy>;
  stddevPop?: InputMaybe<LearningProgramEnrollmentsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<LearningProgramEnrollmentsStddevSampOrderBy>;
  sum?: InputMaybe<LearningProgramEnrollmentsSumOrderBy>;
  varPop?: InputMaybe<LearningProgramEnrollmentsVarPopOrderBy>;
  varSamp?: InputMaybe<LearningProgramEnrollmentsVarSampOrderBy>;
  variance?: InputMaybe<LearningProgramEnrollmentsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "learning_program_enrollments" */
export type LearningProgramEnrollmentsArrRelInsertInput = {
  data: Array<LearningProgramEnrollmentsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<LearningProgramEnrollmentsOnConflict>;
};

/** aggregate avg on columns */
export type LearningProgramEnrollmentsAvgFields = {
  __typename?: 'LearningProgramEnrollmentsAvgFields';
  /** Current schedule period the player is on */
  currentSchedule?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "learning_program_enrollments" */
export type LearningProgramEnrollmentsAvgOrderBy = {
  /** Current schedule period the player is on */
  currentSchedule?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "learning_program_enrollments". All fields are combined with a logical 'AND'. */
export type LearningProgramEnrollmentsBoolExp = {
  _and?: InputMaybe<Array<LearningProgramEnrollmentsBoolExp>>;
  _not?: InputMaybe<LearningProgramEnrollmentsBoolExp>;
  _or?: InputMaybe<Array<LearningProgramEnrollmentsBoolExp>>;
  completedAt?: InputMaybe<DateComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  currentSchedule?: InputMaybe<IntComparisonExp>;
  enrolledAt?: InputMaybe<DateComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  learningProgram?: InputMaybe<LearningProgramsBoolExp>;
  learningProgramId?: InputMaybe<UuidComparisonExp>;
  pausedAt?: InputMaybe<DateComparisonExp>;
  scheduleProgress?: InputMaybe<LearningProgramEnrollmentScheduleProgressBoolExp>;
  scheduleProgressAggregate?: InputMaybe<LearningProgramEnrollmentScheduleProgressAggregateBoolExp>;
  status?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
  videoSubmissions?: InputMaybe<LearningProgramScheduleVideoSubmissionsBoolExp>;
  videoSubmissionsAggregate?: InputMaybe<LearningProgramScheduleVideoSubmissionsAggregateBoolExp>;
};

/** unique or primary key constraints on table "learning_program_enrollments" */
export enum LearningProgramEnrollmentsConstraint {
  /** unique or primary key constraint on columns "id" */
  LearningProgramEnrollmentsPkey = 'learning_program_enrollments_pkey',
  /** unique or primary key constraint on columns "learning_program_id", "user_id" */
  UqLearningProgramEnrollmentsProgramUser = 'uq_learning_program_enrollments_program_user'
}

/** input type for incrementing numeric columns in table "learning_program_enrollments" */
export type LearningProgramEnrollmentsIncInput = {
  /** Current schedule period the player is on */
  currentSchedule?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "learning_program_enrollments" */
export type LearningProgramEnrollmentsInsertInput = {
  completedAt?: InputMaybe<Scalars['date']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** Current schedule period the player is on */
  currentSchedule?: InputMaybe<Scalars['Int']>;
  enrolledAt?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  learningProgram?: InputMaybe<LearningProgramsObjRelInsertInput>;
  learningProgramId?: InputMaybe<Scalars['uuid']>;
  pausedAt?: InputMaybe<Scalars['date']>;
  scheduleProgress?: InputMaybe<LearningProgramEnrollmentScheduleProgressArrRelInsertInput>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']>;
  videoSubmissions?: InputMaybe<LearningProgramScheduleVideoSubmissionsArrRelInsertInput>;
};

/** aggregate max on columns */
export type LearningProgramEnrollmentsMaxFields = {
  __typename?: 'LearningProgramEnrollmentsMaxFields';
  completedAt?: Maybe<Scalars['date']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  /** Current schedule period the player is on */
  currentSchedule?: Maybe<Scalars['Int']>;
  enrolledAt?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  learningProgramId?: Maybe<Scalars['uuid']>;
  pausedAt?: Maybe<Scalars['date']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "learning_program_enrollments" */
export type LearningProgramEnrollmentsMaxOrderBy = {
  completedAt?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  /** Current schedule period the player is on */
  currentSchedule?: InputMaybe<OrderBy>;
  enrolledAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  learningProgramId?: InputMaybe<OrderBy>;
  pausedAt?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type LearningProgramEnrollmentsMinFields = {
  __typename?: 'LearningProgramEnrollmentsMinFields';
  completedAt?: Maybe<Scalars['date']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  /** Current schedule period the player is on */
  currentSchedule?: Maybe<Scalars['Int']>;
  enrolledAt?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  learningProgramId?: Maybe<Scalars['uuid']>;
  pausedAt?: Maybe<Scalars['date']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "learning_program_enrollments" */
export type LearningProgramEnrollmentsMinOrderBy = {
  completedAt?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  /** Current schedule period the player is on */
  currentSchedule?: InputMaybe<OrderBy>;
  enrolledAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  learningProgramId?: InputMaybe<OrderBy>;
  pausedAt?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "learning_program_enrollments" */
export type LearningProgramEnrollmentsMutationResponse = {
  __typename?: 'LearningProgramEnrollmentsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LearningProgramEnrollments>;
};

/** input type for inserting object relation for remote table "learning_program_enrollments" */
export type LearningProgramEnrollmentsObjRelInsertInput = {
  data: LearningProgramEnrollmentsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<LearningProgramEnrollmentsOnConflict>;
};

/** on_conflict condition type for table "learning_program_enrollments" */
export type LearningProgramEnrollmentsOnConflict = {
  constraint: LearningProgramEnrollmentsConstraint;
  updateColumns?: Array<LearningProgramEnrollmentsUpdateColumn>;
  where?: InputMaybe<LearningProgramEnrollmentsBoolExp>;
};

/** Ordering options when selecting data from "learning_program_enrollments". */
export type LearningProgramEnrollmentsOrderBy = {
  completedAt?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  currentSchedule?: InputMaybe<OrderBy>;
  enrolledAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  learningProgram?: InputMaybe<LearningProgramsOrderBy>;
  learningProgramId?: InputMaybe<OrderBy>;
  pausedAt?: InputMaybe<OrderBy>;
  scheduleProgressAggregate?: InputMaybe<LearningProgramEnrollmentScheduleProgressAggregateOrderBy>;
  status?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
  videoSubmissionsAggregate?: InputMaybe<LearningProgramScheduleVideoSubmissionsAggregateOrderBy>;
};

/** primary key columns input for table: learning_program_enrollments */
export type LearningProgramEnrollmentsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "learning_program_enrollments" */
export enum LearningProgramEnrollmentsSelectColumn {
  /** column name */
  CompletedAt = 'completedAt',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CurrentSchedule = 'currentSchedule',
  /** column name */
  EnrolledAt = 'enrolledAt',
  /** column name */
  Id = 'id',
  /** column name */
  LearningProgramId = 'learningProgramId',
  /** column name */
  PausedAt = 'pausedAt',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "learning_program_enrollments" */
export type LearningProgramEnrollmentsSetInput = {
  completedAt?: InputMaybe<Scalars['date']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** Current schedule period the player is on */
  currentSchedule?: InputMaybe<Scalars['Int']>;
  enrolledAt?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  learningProgramId?: InputMaybe<Scalars['uuid']>;
  pausedAt?: InputMaybe<Scalars['date']>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type LearningProgramEnrollmentsStddevFields = {
  __typename?: 'LearningProgramEnrollmentsStddevFields';
  /** Current schedule period the player is on */
  currentSchedule?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "learning_program_enrollments" */
export type LearningProgramEnrollmentsStddevOrderBy = {
  /** Current schedule period the player is on */
  currentSchedule?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type LearningProgramEnrollmentsStddevPopFields = {
  __typename?: 'LearningProgramEnrollmentsStddevPopFields';
  /** Current schedule period the player is on */
  currentSchedule?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "learning_program_enrollments" */
export type LearningProgramEnrollmentsStddevPopOrderBy = {
  /** Current schedule period the player is on */
  currentSchedule?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type LearningProgramEnrollmentsStddevSampFields = {
  __typename?: 'LearningProgramEnrollmentsStddevSampFields';
  /** Current schedule period the player is on */
  currentSchedule?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "learning_program_enrollments" */
export type LearningProgramEnrollmentsStddevSampOrderBy = {
  /** Current schedule period the player is on */
  currentSchedule?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "learning_program_enrollments" */
export type LearningProgramEnrollmentsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: LearningProgramEnrollmentsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LearningProgramEnrollmentsStreamCursorValueInput = {
  completedAt?: InputMaybe<Scalars['date']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** Current schedule period the player is on */
  currentSchedule?: InputMaybe<Scalars['Int']>;
  enrolledAt?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  learningProgramId?: InputMaybe<Scalars['uuid']>;
  pausedAt?: InputMaybe<Scalars['date']>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type LearningProgramEnrollmentsSumFields = {
  __typename?: 'LearningProgramEnrollmentsSumFields';
  /** Current schedule period the player is on */
  currentSchedule?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "learning_program_enrollments" */
export type LearningProgramEnrollmentsSumOrderBy = {
  /** Current schedule period the player is on */
  currentSchedule?: InputMaybe<OrderBy>;
};

/** update columns of table "learning_program_enrollments" */
export enum LearningProgramEnrollmentsUpdateColumn {
  /** column name */
  CompletedAt = 'completedAt',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CurrentSchedule = 'currentSchedule',
  /** column name */
  EnrolledAt = 'enrolledAt',
  /** column name */
  Id = 'id',
  /** column name */
  LearningProgramId = 'learningProgramId',
  /** column name */
  PausedAt = 'pausedAt',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

export type LearningProgramEnrollmentsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<LearningProgramEnrollmentsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LearningProgramEnrollmentsSetInput>;
  /** filter the rows which have to be updated */
  where: LearningProgramEnrollmentsBoolExp;
};

/** aggregate varPop on columns */
export type LearningProgramEnrollmentsVarPopFields = {
  __typename?: 'LearningProgramEnrollmentsVarPopFields';
  /** Current schedule period the player is on */
  currentSchedule?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "learning_program_enrollments" */
export type LearningProgramEnrollmentsVarPopOrderBy = {
  /** Current schedule period the player is on */
  currentSchedule?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type LearningProgramEnrollmentsVarSampFields = {
  __typename?: 'LearningProgramEnrollmentsVarSampFields';
  /** Current schedule period the player is on */
  currentSchedule?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "learning_program_enrollments" */
export type LearningProgramEnrollmentsVarSampOrderBy = {
  /** Current schedule period the player is on */
  currentSchedule?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type LearningProgramEnrollmentsVarianceFields = {
  __typename?: 'LearningProgramEnrollmentsVarianceFields';
  /** Current schedule period the player is on */
  currentSchedule?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "learning_program_enrollments" */
export type LearningProgramEnrollmentsVarianceOrderBy = {
  /** Current schedule period the player is on */
  currentSchedule?: InputMaybe<OrderBy>;
};

/** Media table for storing learning program video and image files */
export type LearningProgramMedia = {
  __typename?: 'LearningProgramMedia';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  fileCategory: Scalars['String'];
  fileFormat: Scalars['String'];
  fileName: Scalars['String'];
  fileType: Scalars['String'];
  host: Scalars['String'];
  id: Scalars['uuid'];
  originalFileName?: Maybe<Scalars['String']>;
  provider: Scalars['String'];
  providerId: Scalars['String'];
  providerUrl: Scalars['String'];
  /** An array relationship */
  scheduleMedia: Array<LearningProgramScheduleMedia>;
  /** An aggregate relationship */
  scheduleMediaAggregate: LearningProgramScheduleMediaAggregate;
  updatedAt: Scalars['timestamptz'];
  url: Scalars['String'];
  /** An object relationship */
  user?: Maybe<Users>;
  userId?: Maybe<Scalars['uuid']>;
};


/** Media table for storing learning program video and image files */
export type LearningProgramMediaScheduleMediaArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramScheduleMediaSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramScheduleMediaOrderBy>>;
  where?: InputMaybe<LearningProgramScheduleMediaBoolExp>;
};


/** Media table for storing learning program video and image files */
export type LearningProgramMediaScheduleMediaAggregateArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramScheduleMediaSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramScheduleMediaOrderBy>>;
  where?: InputMaybe<LearningProgramScheduleMediaBoolExp>;
};

/** aggregated selection of "learning_program_media" */
export type LearningProgramMediaAggregate = {
  __typename?: 'LearningProgramMediaAggregate';
  aggregate?: Maybe<LearningProgramMediaAggregateFields>;
  nodes: Array<LearningProgramMedia>;
};

/** aggregate fields of "learning_program_media" */
export type LearningProgramMediaAggregateFields = {
  __typename?: 'LearningProgramMediaAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<LearningProgramMediaMaxFields>;
  min?: Maybe<LearningProgramMediaMinFields>;
};


/** aggregate fields of "learning_program_media" */
export type LearningProgramMediaAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<LearningProgramMediaSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "learning_program_media". All fields are combined with a logical 'AND'. */
export type LearningProgramMediaBoolExp = {
  _and?: InputMaybe<Array<LearningProgramMediaBoolExp>>;
  _not?: InputMaybe<LearningProgramMediaBoolExp>;
  _or?: InputMaybe<Array<LearningProgramMediaBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  fileCategory?: InputMaybe<StringComparisonExp>;
  fileFormat?: InputMaybe<StringComparisonExp>;
  fileName?: InputMaybe<StringComparisonExp>;
  fileType?: InputMaybe<StringComparisonExp>;
  host?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  originalFileName?: InputMaybe<StringComparisonExp>;
  provider?: InputMaybe<StringComparisonExp>;
  providerId?: InputMaybe<StringComparisonExp>;
  providerUrl?: InputMaybe<StringComparisonExp>;
  scheduleMedia?: InputMaybe<LearningProgramScheduleMediaBoolExp>;
  scheduleMediaAggregate?: InputMaybe<LearningProgramScheduleMediaAggregateBoolExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  url?: InputMaybe<StringComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** Enum table for program schedule media categories (lesson, drill) */
export type LearningProgramMediaCategories = {
  __typename?: 'LearningProgramMediaCategories';
  code: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  name: Scalars['String'];
  orderIndex: Scalars['Int'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "learning_program_media_categories" */
export type LearningProgramMediaCategoriesAggregate = {
  __typename?: 'LearningProgramMediaCategoriesAggregate';
  aggregate?: Maybe<LearningProgramMediaCategoriesAggregateFields>;
  nodes: Array<LearningProgramMediaCategories>;
};

/** aggregate fields of "learning_program_media_categories" */
export type LearningProgramMediaCategoriesAggregateFields = {
  __typename?: 'LearningProgramMediaCategoriesAggregateFields';
  avg?: Maybe<LearningProgramMediaCategoriesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<LearningProgramMediaCategoriesMaxFields>;
  min?: Maybe<LearningProgramMediaCategoriesMinFields>;
  stddev?: Maybe<LearningProgramMediaCategoriesStddevFields>;
  stddevPop?: Maybe<LearningProgramMediaCategoriesStddevPopFields>;
  stddevSamp?: Maybe<LearningProgramMediaCategoriesStddevSampFields>;
  sum?: Maybe<LearningProgramMediaCategoriesSumFields>;
  varPop?: Maybe<LearningProgramMediaCategoriesVarPopFields>;
  varSamp?: Maybe<LearningProgramMediaCategoriesVarSampFields>;
  variance?: Maybe<LearningProgramMediaCategoriesVarianceFields>;
};


/** aggregate fields of "learning_program_media_categories" */
export type LearningProgramMediaCategoriesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<LearningProgramMediaCategoriesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type LearningProgramMediaCategoriesAvgFields = {
  __typename?: 'LearningProgramMediaCategoriesAvgFields';
  orderIndex?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "learning_program_media_categories". All fields are combined with a logical 'AND'. */
export type LearningProgramMediaCategoriesBoolExp = {
  _and?: InputMaybe<Array<LearningProgramMediaCategoriesBoolExp>>;
  _not?: InputMaybe<LearningProgramMediaCategoriesBoolExp>;
  _or?: InputMaybe<Array<LearningProgramMediaCategoriesBoolExp>>;
  code?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  orderIndex?: InputMaybe<IntComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "learning_program_media_categories" */
export enum LearningProgramMediaCategoriesConstraint {
  /** unique or primary key constraint on columns "code" */
  LearningProgramMediaCategoriesCodeKey = 'learning_program_media_categories_code_key',
  /** unique or primary key constraint on columns "id" */
  LearningProgramMediaCategoriesPkey = 'learning_program_media_categories_pkey'
}

/** input type for incrementing numeric columns in table "learning_program_media_categories" */
export type LearningProgramMediaCategoriesIncInput = {
  orderIndex?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "learning_program_media_categories" */
export type LearningProgramMediaCategoriesInsertInput = {
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  orderIndex?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type LearningProgramMediaCategoriesMaxFields = {
  __typename?: 'LearningProgramMediaCategoriesMaxFields';
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  orderIndex?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type LearningProgramMediaCategoriesMinFields = {
  __typename?: 'LearningProgramMediaCategoriesMinFields';
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  orderIndex?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "learning_program_media_categories" */
export type LearningProgramMediaCategoriesMutationResponse = {
  __typename?: 'LearningProgramMediaCategoriesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LearningProgramMediaCategories>;
};

/** input type for inserting object relation for remote table "learning_program_media_categories" */
export type LearningProgramMediaCategoriesObjRelInsertInput = {
  data: LearningProgramMediaCategoriesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<LearningProgramMediaCategoriesOnConflict>;
};

/** on_conflict condition type for table "learning_program_media_categories" */
export type LearningProgramMediaCategoriesOnConflict = {
  constraint: LearningProgramMediaCategoriesConstraint;
  updateColumns?: Array<LearningProgramMediaCategoriesUpdateColumn>;
  where?: InputMaybe<LearningProgramMediaCategoriesBoolExp>;
};

/** Ordering options when selecting data from "learning_program_media_categories". */
export type LearningProgramMediaCategoriesOrderBy = {
  code?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  orderIndex?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: learning_program_media_categories */
export type LearningProgramMediaCategoriesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "learning_program_media_categories" */
export enum LearningProgramMediaCategoriesSelectColumn {
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  OrderIndex = 'orderIndex',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "learning_program_media_categories" */
export type LearningProgramMediaCategoriesSetInput = {
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  orderIndex?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type LearningProgramMediaCategoriesStddevFields = {
  __typename?: 'LearningProgramMediaCategoriesStddevFields';
  orderIndex?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type LearningProgramMediaCategoriesStddevPopFields = {
  __typename?: 'LearningProgramMediaCategoriesStddevPopFields';
  orderIndex?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type LearningProgramMediaCategoriesStddevSampFields = {
  __typename?: 'LearningProgramMediaCategoriesStddevSampFields';
  orderIndex?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "learning_program_media_categories" */
export type LearningProgramMediaCategoriesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: LearningProgramMediaCategoriesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LearningProgramMediaCategoriesStreamCursorValueInput = {
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  orderIndex?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type LearningProgramMediaCategoriesSumFields = {
  __typename?: 'LearningProgramMediaCategoriesSumFields';
  orderIndex?: Maybe<Scalars['Int']>;
};

/** update columns of table "learning_program_media_categories" */
export enum LearningProgramMediaCategoriesUpdateColumn {
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  OrderIndex = 'orderIndex',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type LearningProgramMediaCategoriesUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<LearningProgramMediaCategoriesIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LearningProgramMediaCategoriesSetInput>;
  /** filter the rows which have to be updated */
  where: LearningProgramMediaCategoriesBoolExp;
};

/** aggregate varPop on columns */
export type LearningProgramMediaCategoriesVarPopFields = {
  __typename?: 'LearningProgramMediaCategoriesVarPopFields';
  orderIndex?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type LearningProgramMediaCategoriesVarSampFields = {
  __typename?: 'LearningProgramMediaCategoriesVarSampFields';
  orderIndex?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type LearningProgramMediaCategoriesVarianceFields = {
  __typename?: 'LearningProgramMediaCategoriesVarianceFields';
  orderIndex?: Maybe<Scalars['Float']>;
};

/** unique or primary key constraints on table "learning_program_media" */
export enum LearningProgramMediaConstraint {
  /** unique or primary key constraint on columns "id" */
  LearningProgramMediaPkey = 'learning_program_media_pkey'
}

/** input type for inserting data into table "learning_program_media" */
export type LearningProgramMediaInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  fileCategory?: InputMaybe<Scalars['String']>;
  fileFormat?: InputMaybe<Scalars['String']>;
  fileName?: InputMaybe<Scalars['String']>;
  fileType?: InputMaybe<Scalars['String']>;
  host?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  originalFileName?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  providerId?: InputMaybe<Scalars['String']>;
  providerUrl?: InputMaybe<Scalars['String']>;
  scheduleMedia?: InputMaybe<LearningProgramScheduleMediaArrRelInsertInput>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  url?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type LearningProgramMediaMaxFields = {
  __typename?: 'LearningProgramMediaMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  fileCategory?: Maybe<Scalars['String']>;
  fileFormat?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  fileType?: Maybe<Scalars['String']>;
  host?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  originalFileName?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  providerId?: Maybe<Scalars['String']>;
  providerUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  url?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type LearningProgramMediaMinFields = {
  __typename?: 'LearningProgramMediaMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  fileCategory?: Maybe<Scalars['String']>;
  fileFormat?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  fileType?: Maybe<Scalars['String']>;
  host?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  originalFileName?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  providerId?: Maybe<Scalars['String']>;
  providerUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  url?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "learning_program_media" */
export type LearningProgramMediaMutationResponse = {
  __typename?: 'LearningProgramMediaMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LearningProgramMedia>;
};

/** input type for inserting object relation for remote table "learning_program_media" */
export type LearningProgramMediaObjRelInsertInput = {
  data: LearningProgramMediaInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<LearningProgramMediaOnConflict>;
};

/** on_conflict condition type for table "learning_program_media" */
export type LearningProgramMediaOnConflict = {
  constraint: LearningProgramMediaConstraint;
  updateColumns?: Array<LearningProgramMediaUpdateColumn>;
  where?: InputMaybe<LearningProgramMediaBoolExp>;
};

/** Ordering options when selecting data from "learning_program_media". */
export type LearningProgramMediaOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  fileCategory?: InputMaybe<OrderBy>;
  fileFormat?: InputMaybe<OrderBy>;
  fileName?: InputMaybe<OrderBy>;
  fileType?: InputMaybe<OrderBy>;
  host?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  originalFileName?: InputMaybe<OrderBy>;
  provider?: InputMaybe<OrderBy>;
  providerId?: InputMaybe<OrderBy>;
  providerUrl?: InputMaybe<OrderBy>;
  scheduleMediaAggregate?: InputMaybe<LearningProgramScheduleMediaAggregateOrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  url?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: learning_program_media */
export type LearningProgramMediaPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "learning_program_media" */
export enum LearningProgramMediaSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  FileCategory = 'fileCategory',
  /** column name */
  FileFormat = 'fileFormat',
  /** column name */
  FileName = 'fileName',
  /** column name */
  FileType = 'fileType',
  /** column name */
  Host = 'host',
  /** column name */
  Id = 'id',
  /** column name */
  OriginalFileName = 'originalFileName',
  /** column name */
  Provider = 'provider',
  /** column name */
  ProviderId = 'providerId',
  /** column name */
  ProviderUrl = 'providerUrl',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Url = 'url',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "learning_program_media" */
export type LearningProgramMediaSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  fileCategory?: InputMaybe<Scalars['String']>;
  fileFormat?: InputMaybe<Scalars['String']>;
  fileName?: InputMaybe<Scalars['String']>;
  fileType?: InputMaybe<Scalars['String']>;
  host?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  originalFileName?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  providerId?: InputMaybe<Scalars['String']>;
  providerUrl?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  url?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "learning_program_media" */
export type LearningProgramMediaStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: LearningProgramMediaStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LearningProgramMediaStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  fileCategory?: InputMaybe<Scalars['String']>;
  fileFormat?: InputMaybe<Scalars['String']>;
  fileName?: InputMaybe<Scalars['String']>;
  fileType?: InputMaybe<Scalars['String']>;
  host?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  originalFileName?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  providerId?: InputMaybe<Scalars['String']>;
  providerUrl?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  url?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "learning_program_media" */
export enum LearningProgramMediaUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  FileCategory = 'fileCategory',
  /** column name */
  FileFormat = 'fileFormat',
  /** column name */
  FileName = 'fileName',
  /** column name */
  FileType = 'fileType',
  /** column name */
  Host = 'host',
  /** column name */
  Id = 'id',
  /** column name */
  OriginalFileName = 'originalFileName',
  /** column name */
  Provider = 'provider',
  /** column name */
  ProviderId = 'providerId',
  /** column name */
  ProviderUrl = 'providerUrl',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Url = 'url',
  /** column name */
  UserId = 'userId'
}

export type LearningProgramMediaUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LearningProgramMediaSetInput>;
  /** filter the rows which have to be updated */
  where: LearningProgramMediaBoolExp;
};

/** Links multiple lesson/drill videos to each schedule period */
export type LearningProgramScheduleMedia = {
  __typename?: 'LearningProgramScheduleMedia';
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  learningProgramSchedule: LearningProgramSchedules;
  learningProgramScheduleId: Scalars['uuid'];
  /** An object relationship */
  media: LearningProgramMedia;
  /** An object relationship */
  mediaCategory: LearningProgramMediaCategories;
  mediaCategoryId: Scalars['uuid'];
  mediaId: Scalars['uuid'];
  /** Order within the media category */
  orderIndex: Scalars['Int'];
};

/** aggregated selection of "learning_program_schedule_media" */
export type LearningProgramScheduleMediaAggregate = {
  __typename?: 'LearningProgramScheduleMediaAggregate';
  aggregate?: Maybe<LearningProgramScheduleMediaAggregateFields>;
  nodes: Array<LearningProgramScheduleMedia>;
};

export type LearningProgramScheduleMediaAggregateBoolExp = {
  count?: InputMaybe<LearningProgramScheduleMediaAggregateBoolExpCount>;
};

/** aggregate fields of "learning_program_schedule_media" */
export type LearningProgramScheduleMediaAggregateFields = {
  __typename?: 'LearningProgramScheduleMediaAggregateFields';
  avg?: Maybe<LearningProgramScheduleMediaAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<LearningProgramScheduleMediaMaxFields>;
  min?: Maybe<LearningProgramScheduleMediaMinFields>;
  stddev?: Maybe<LearningProgramScheduleMediaStddevFields>;
  stddevPop?: Maybe<LearningProgramScheduleMediaStddevPopFields>;
  stddevSamp?: Maybe<LearningProgramScheduleMediaStddevSampFields>;
  sum?: Maybe<LearningProgramScheduleMediaSumFields>;
  varPop?: Maybe<LearningProgramScheduleMediaVarPopFields>;
  varSamp?: Maybe<LearningProgramScheduleMediaVarSampFields>;
  variance?: Maybe<LearningProgramScheduleMediaVarianceFields>;
};


/** aggregate fields of "learning_program_schedule_media" */
export type LearningProgramScheduleMediaAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<LearningProgramScheduleMediaSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "learning_program_schedule_media" */
export type LearningProgramScheduleMediaAggregateOrderBy = {
  avg?: InputMaybe<LearningProgramScheduleMediaAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<LearningProgramScheduleMediaMaxOrderBy>;
  min?: InputMaybe<LearningProgramScheduleMediaMinOrderBy>;
  stddev?: InputMaybe<LearningProgramScheduleMediaStddevOrderBy>;
  stddevPop?: InputMaybe<LearningProgramScheduleMediaStddevPopOrderBy>;
  stddevSamp?: InputMaybe<LearningProgramScheduleMediaStddevSampOrderBy>;
  sum?: InputMaybe<LearningProgramScheduleMediaSumOrderBy>;
  varPop?: InputMaybe<LearningProgramScheduleMediaVarPopOrderBy>;
  varSamp?: InputMaybe<LearningProgramScheduleMediaVarSampOrderBy>;
  variance?: InputMaybe<LearningProgramScheduleMediaVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "learning_program_schedule_media" */
export type LearningProgramScheduleMediaArrRelInsertInput = {
  data: Array<LearningProgramScheduleMediaInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<LearningProgramScheduleMediaOnConflict>;
};

/** aggregate avg on columns */
export type LearningProgramScheduleMediaAvgFields = {
  __typename?: 'LearningProgramScheduleMediaAvgFields';
  /** Order within the media category */
  orderIndex?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "learning_program_schedule_media" */
export type LearningProgramScheduleMediaAvgOrderBy = {
  /** Order within the media category */
  orderIndex?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "learning_program_schedule_media". All fields are combined with a logical 'AND'. */
export type LearningProgramScheduleMediaBoolExp = {
  _and?: InputMaybe<Array<LearningProgramScheduleMediaBoolExp>>;
  _not?: InputMaybe<LearningProgramScheduleMediaBoolExp>;
  _or?: InputMaybe<Array<LearningProgramScheduleMediaBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  learningProgramSchedule?: InputMaybe<LearningProgramSchedulesBoolExp>;
  learningProgramScheduleId?: InputMaybe<UuidComparisonExp>;
  media?: InputMaybe<LearningProgramMediaBoolExp>;
  mediaCategory?: InputMaybe<LearningProgramMediaCategoriesBoolExp>;
  mediaCategoryId?: InputMaybe<UuidComparisonExp>;
  mediaId?: InputMaybe<UuidComparisonExp>;
  orderIndex?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "learning_program_schedule_media" */
export enum LearningProgramScheduleMediaConstraint {
  /** unique or primary key constraint on columns "id" */
  LearningProgramScheduleMediaPkey = 'learning_program_schedule_media_pkey',
  /** unique or primary key constraint on columns "learning_program_schedule_id", "media_id" */
  UqLearningProgramScheduleMediaScheduleMedia = 'uq_learning_program_schedule_media_schedule_media'
}

/** input type for incrementing numeric columns in table "learning_program_schedule_media" */
export type LearningProgramScheduleMediaIncInput = {
  /** Order within the media category */
  orderIndex?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "learning_program_schedule_media" */
export type LearningProgramScheduleMediaInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  learningProgramSchedule?: InputMaybe<LearningProgramSchedulesObjRelInsertInput>;
  learningProgramScheduleId?: InputMaybe<Scalars['uuid']>;
  media?: InputMaybe<LearningProgramMediaObjRelInsertInput>;
  mediaCategory?: InputMaybe<LearningProgramMediaCategoriesObjRelInsertInput>;
  mediaCategoryId?: InputMaybe<Scalars['uuid']>;
  mediaId?: InputMaybe<Scalars['uuid']>;
  /** Order within the media category */
  orderIndex?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type LearningProgramScheduleMediaMaxFields = {
  __typename?: 'LearningProgramScheduleMediaMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  learningProgramScheduleId?: Maybe<Scalars['uuid']>;
  mediaCategoryId?: Maybe<Scalars['uuid']>;
  mediaId?: Maybe<Scalars['uuid']>;
  /** Order within the media category */
  orderIndex?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "learning_program_schedule_media" */
export type LearningProgramScheduleMediaMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  learningProgramScheduleId?: InputMaybe<OrderBy>;
  mediaCategoryId?: InputMaybe<OrderBy>;
  mediaId?: InputMaybe<OrderBy>;
  /** Order within the media category */
  orderIndex?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type LearningProgramScheduleMediaMinFields = {
  __typename?: 'LearningProgramScheduleMediaMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  learningProgramScheduleId?: Maybe<Scalars['uuid']>;
  mediaCategoryId?: Maybe<Scalars['uuid']>;
  mediaId?: Maybe<Scalars['uuid']>;
  /** Order within the media category */
  orderIndex?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "learning_program_schedule_media" */
export type LearningProgramScheduleMediaMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  learningProgramScheduleId?: InputMaybe<OrderBy>;
  mediaCategoryId?: InputMaybe<OrderBy>;
  mediaId?: InputMaybe<OrderBy>;
  /** Order within the media category */
  orderIndex?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "learning_program_schedule_media" */
export type LearningProgramScheduleMediaMutationResponse = {
  __typename?: 'LearningProgramScheduleMediaMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LearningProgramScheduleMedia>;
};

/** on_conflict condition type for table "learning_program_schedule_media" */
export type LearningProgramScheduleMediaOnConflict = {
  constraint: LearningProgramScheduleMediaConstraint;
  updateColumns?: Array<LearningProgramScheduleMediaUpdateColumn>;
  where?: InputMaybe<LearningProgramScheduleMediaBoolExp>;
};

/** Ordering options when selecting data from "learning_program_schedule_media". */
export type LearningProgramScheduleMediaOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  learningProgramSchedule?: InputMaybe<LearningProgramSchedulesOrderBy>;
  learningProgramScheduleId?: InputMaybe<OrderBy>;
  media?: InputMaybe<LearningProgramMediaOrderBy>;
  mediaCategory?: InputMaybe<LearningProgramMediaCategoriesOrderBy>;
  mediaCategoryId?: InputMaybe<OrderBy>;
  mediaId?: InputMaybe<OrderBy>;
  orderIndex?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: learning_program_schedule_media */
export type LearningProgramScheduleMediaPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "learning_program_schedule_media" */
export enum LearningProgramScheduleMediaSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  LearningProgramScheduleId = 'learningProgramScheduleId',
  /** column name */
  MediaCategoryId = 'mediaCategoryId',
  /** column name */
  MediaId = 'mediaId',
  /** column name */
  OrderIndex = 'orderIndex'
}

/** input type for updating data in table "learning_program_schedule_media" */
export type LearningProgramScheduleMediaSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  learningProgramScheduleId?: InputMaybe<Scalars['uuid']>;
  mediaCategoryId?: InputMaybe<Scalars['uuid']>;
  mediaId?: InputMaybe<Scalars['uuid']>;
  /** Order within the media category */
  orderIndex?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type LearningProgramScheduleMediaStddevFields = {
  __typename?: 'LearningProgramScheduleMediaStddevFields';
  /** Order within the media category */
  orderIndex?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "learning_program_schedule_media" */
export type LearningProgramScheduleMediaStddevOrderBy = {
  /** Order within the media category */
  orderIndex?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type LearningProgramScheduleMediaStddevPopFields = {
  __typename?: 'LearningProgramScheduleMediaStddevPopFields';
  /** Order within the media category */
  orderIndex?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "learning_program_schedule_media" */
export type LearningProgramScheduleMediaStddevPopOrderBy = {
  /** Order within the media category */
  orderIndex?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type LearningProgramScheduleMediaStddevSampFields = {
  __typename?: 'LearningProgramScheduleMediaStddevSampFields';
  /** Order within the media category */
  orderIndex?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "learning_program_schedule_media" */
export type LearningProgramScheduleMediaStddevSampOrderBy = {
  /** Order within the media category */
  orderIndex?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "learning_program_schedule_media" */
export type LearningProgramScheduleMediaStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: LearningProgramScheduleMediaStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LearningProgramScheduleMediaStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  learningProgramScheduleId?: InputMaybe<Scalars['uuid']>;
  mediaCategoryId?: InputMaybe<Scalars['uuid']>;
  mediaId?: InputMaybe<Scalars['uuid']>;
  /** Order within the media category */
  orderIndex?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type LearningProgramScheduleMediaSumFields = {
  __typename?: 'LearningProgramScheduleMediaSumFields';
  /** Order within the media category */
  orderIndex?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "learning_program_schedule_media" */
export type LearningProgramScheduleMediaSumOrderBy = {
  /** Order within the media category */
  orderIndex?: InputMaybe<OrderBy>;
};

/** update columns of table "learning_program_schedule_media" */
export enum LearningProgramScheduleMediaUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  LearningProgramScheduleId = 'learningProgramScheduleId',
  /** column name */
  MediaCategoryId = 'mediaCategoryId',
  /** column name */
  MediaId = 'mediaId',
  /** column name */
  OrderIndex = 'orderIndex'
}

export type LearningProgramScheduleMediaUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<LearningProgramScheduleMediaIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LearningProgramScheduleMediaSetInput>;
  /** filter the rows which have to be updated */
  where: LearningProgramScheduleMediaBoolExp;
};

/** aggregate varPop on columns */
export type LearningProgramScheduleMediaVarPopFields = {
  __typename?: 'LearningProgramScheduleMediaVarPopFields';
  /** Order within the media category */
  orderIndex?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "learning_program_schedule_media" */
export type LearningProgramScheduleMediaVarPopOrderBy = {
  /** Order within the media category */
  orderIndex?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type LearningProgramScheduleMediaVarSampFields = {
  __typename?: 'LearningProgramScheduleMediaVarSampFields';
  /** Order within the media category */
  orderIndex?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "learning_program_schedule_media" */
export type LearningProgramScheduleMediaVarSampOrderBy = {
  /** Order within the media category */
  orderIndex?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type LearningProgramScheduleMediaVarianceFields = {
  __typename?: 'LearningProgramScheduleMediaVarianceFields';
  /** Order within the media category */
  orderIndex?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "learning_program_schedule_media" */
export type LearningProgramScheduleMediaVarianceOrderBy = {
  /** Order within the media category */
  orderIndex?: InputMaybe<OrderBy>;
};

/** days, weeks, months. */
export type LearningProgramScheduleUnits = {
  __typename?: 'LearningProgramScheduleUnits';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "learning_program_schedule_units" */
export type LearningProgramScheduleUnitsAggregate = {
  __typename?: 'LearningProgramScheduleUnitsAggregate';
  aggregate?: Maybe<LearningProgramScheduleUnitsAggregateFields>;
  nodes: Array<LearningProgramScheduleUnits>;
};

/** aggregate fields of "learning_program_schedule_units" */
export type LearningProgramScheduleUnitsAggregateFields = {
  __typename?: 'LearningProgramScheduleUnitsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<LearningProgramScheduleUnitsMaxFields>;
  min?: Maybe<LearningProgramScheduleUnitsMinFields>;
};


/** aggregate fields of "learning_program_schedule_units" */
export type LearningProgramScheduleUnitsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<LearningProgramScheduleUnitsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "learning_program_schedule_units". All fields are combined with a logical 'AND'. */
export type LearningProgramScheduleUnitsBoolExp = {
  _and?: InputMaybe<Array<LearningProgramScheduleUnitsBoolExp>>;
  _not?: InputMaybe<LearningProgramScheduleUnitsBoolExp>;
  _or?: InputMaybe<Array<LearningProgramScheduleUnitsBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "learning_program_schedule_units" */
export enum LearningProgramScheduleUnitsConstraint {
  /** unique or primary key constraint on columns "value" */
  LearningProgramScheduleUnitsPkey = 'learning_program_schedule_units_pkey'
}

export enum LearningProgramScheduleUnitsEnum {
  /** Daily schedule periods */
  Day = 'DAY',
  /** Monthly schedule periods */
  Month = 'MONTH',
  /** Weekly schedule periods */
  Week = 'WEEK'
}

/** Boolean expression to compare columns of type "LearningProgramScheduleUnitsEnum". All fields are combined with logical 'AND'. */
export type LearningProgramScheduleUnitsEnumComparisonExp = {
  _eq?: InputMaybe<LearningProgramScheduleUnitsEnum>;
  _in?: InputMaybe<Array<LearningProgramScheduleUnitsEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<LearningProgramScheduleUnitsEnum>;
  _nin?: InputMaybe<Array<LearningProgramScheduleUnitsEnum>>;
};

/** input type for inserting data into table "learning_program_schedule_units" */
export type LearningProgramScheduleUnitsInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type LearningProgramScheduleUnitsMaxFields = {
  __typename?: 'LearningProgramScheduleUnitsMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type LearningProgramScheduleUnitsMinFields = {
  __typename?: 'LearningProgramScheduleUnitsMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "learning_program_schedule_units" */
export type LearningProgramScheduleUnitsMutationResponse = {
  __typename?: 'LearningProgramScheduleUnitsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LearningProgramScheduleUnits>;
};

/** on_conflict condition type for table "learning_program_schedule_units" */
export type LearningProgramScheduleUnitsOnConflict = {
  constraint: LearningProgramScheduleUnitsConstraint;
  updateColumns?: Array<LearningProgramScheduleUnitsUpdateColumn>;
  where?: InputMaybe<LearningProgramScheduleUnitsBoolExp>;
};

/** Ordering options when selecting data from "learning_program_schedule_units". */
export type LearningProgramScheduleUnitsOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: learning_program_schedule_units */
export type LearningProgramScheduleUnitsPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "learning_program_schedule_units" */
export enum LearningProgramScheduleUnitsSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "learning_program_schedule_units" */
export type LearningProgramScheduleUnitsSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "learning_program_schedule_units" */
export type LearningProgramScheduleUnitsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: LearningProgramScheduleUnitsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LearningProgramScheduleUnitsStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "learning_program_schedule_units" */
export enum LearningProgramScheduleUnitsUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type LearningProgramScheduleUnitsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LearningProgramScheduleUnitsSetInput>;
  /** filter the rows which have to be updated */
  where: LearningProgramScheduleUnitsBoolExp;
};

/** Player video submissions linked to existing video analysis system */
export type LearningProgramScheduleVideoSubmissions = {
  __typename?: 'LearningProgramScheduleVideoSubmissions';
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  learningProgramEnrollment: LearningProgramEnrollments;
  learningProgramEnrollmentId: Scalars['uuid'];
  /** An object relationship */
  learningProgramSchedule: LearningProgramSchedules;
  learningProgramScheduleId: Scalars['uuid'];
  reviewedAt?: Maybe<Scalars['timestamptz']>;
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  videoAnalysis?: Maybe<VideoAnalysis>;
  /** One-to-one link to video_analysis table */
  videoAnalysisId?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "learning_program_schedule_video_submissions" */
export type LearningProgramScheduleVideoSubmissionsAggregate = {
  __typename?: 'LearningProgramScheduleVideoSubmissionsAggregate';
  aggregate?: Maybe<LearningProgramScheduleVideoSubmissionsAggregateFields>;
  nodes: Array<LearningProgramScheduleVideoSubmissions>;
};

export type LearningProgramScheduleVideoSubmissionsAggregateBoolExp = {
  count?: InputMaybe<LearningProgramScheduleVideoSubmissionsAggregateBoolExpCount>;
};

/** aggregate fields of "learning_program_schedule_video_submissions" */
export type LearningProgramScheduleVideoSubmissionsAggregateFields = {
  __typename?: 'LearningProgramScheduleVideoSubmissionsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<LearningProgramScheduleVideoSubmissionsMaxFields>;
  min?: Maybe<LearningProgramScheduleVideoSubmissionsMinFields>;
};


/** aggregate fields of "learning_program_schedule_video_submissions" */
export type LearningProgramScheduleVideoSubmissionsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<LearningProgramScheduleVideoSubmissionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "learning_program_schedule_video_submissions" */
export type LearningProgramScheduleVideoSubmissionsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<LearningProgramScheduleVideoSubmissionsMaxOrderBy>;
  min?: InputMaybe<LearningProgramScheduleVideoSubmissionsMinOrderBy>;
};

/** input type for inserting array relation for remote table "learning_program_schedule_video_submissions" */
export type LearningProgramScheduleVideoSubmissionsArrRelInsertInput = {
  data: Array<LearningProgramScheduleVideoSubmissionsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<LearningProgramScheduleVideoSubmissionsOnConflict>;
};

/** Boolean expression to filter rows from the table "learning_program_schedule_video_submissions". All fields are combined with a logical 'AND'. */
export type LearningProgramScheduleVideoSubmissionsBoolExp = {
  _and?: InputMaybe<Array<LearningProgramScheduleVideoSubmissionsBoolExp>>;
  _not?: InputMaybe<LearningProgramScheduleVideoSubmissionsBoolExp>;
  _or?: InputMaybe<Array<LearningProgramScheduleVideoSubmissionsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  learningProgramEnrollment?: InputMaybe<LearningProgramEnrollmentsBoolExp>;
  learningProgramEnrollmentId?: InputMaybe<UuidComparisonExp>;
  learningProgramSchedule?: InputMaybe<LearningProgramSchedulesBoolExp>;
  learningProgramScheduleId?: InputMaybe<UuidComparisonExp>;
  reviewedAt?: InputMaybe<TimestamptzComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  videoAnalysis?: InputMaybe<VideoAnalysisBoolExp>;
  videoAnalysisId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "learning_program_schedule_video_submissions" */
export enum LearningProgramScheduleVideoSubmissionsConstraint {
  /** unique or primary key constraint on columns "video_analysis_id" */
  LearningProgramScheduleVideoSubmissioVideoAnalysisIdKey = 'learning_program_schedule_video_submissio_video_analysis_id_key',
  /** unique or primary key constraint on columns "id" */
  LearningProgramScheduleVideoSubmissionsPkey = 'learning_program_schedule_video_submissions_pkey'
}

/** input type for inserting data into table "learning_program_schedule_video_submissions" */
export type LearningProgramScheduleVideoSubmissionsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  learningProgramEnrollment?: InputMaybe<LearningProgramEnrollmentsObjRelInsertInput>;
  learningProgramEnrollmentId?: InputMaybe<Scalars['uuid']>;
  learningProgramSchedule?: InputMaybe<LearningProgramSchedulesObjRelInsertInput>;
  learningProgramScheduleId?: InputMaybe<Scalars['uuid']>;
  reviewedAt?: InputMaybe<Scalars['timestamptz']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  videoAnalysis?: InputMaybe<VideoAnalysisObjRelInsertInput>;
  /** One-to-one link to video_analysis table */
  videoAnalysisId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type LearningProgramScheduleVideoSubmissionsMaxFields = {
  __typename?: 'LearningProgramScheduleVideoSubmissionsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  learningProgramEnrollmentId?: Maybe<Scalars['uuid']>;
  learningProgramScheduleId?: Maybe<Scalars['uuid']>;
  reviewedAt?: Maybe<Scalars['timestamptz']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  /** One-to-one link to video_analysis table */
  videoAnalysisId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "learning_program_schedule_video_submissions" */
export type LearningProgramScheduleVideoSubmissionsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  learningProgramEnrollmentId?: InputMaybe<OrderBy>;
  learningProgramScheduleId?: InputMaybe<OrderBy>;
  reviewedAt?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  /** One-to-one link to video_analysis table */
  videoAnalysisId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type LearningProgramScheduleVideoSubmissionsMinFields = {
  __typename?: 'LearningProgramScheduleVideoSubmissionsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  learningProgramEnrollmentId?: Maybe<Scalars['uuid']>;
  learningProgramScheduleId?: Maybe<Scalars['uuid']>;
  reviewedAt?: Maybe<Scalars['timestamptz']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  /** One-to-one link to video_analysis table */
  videoAnalysisId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "learning_program_schedule_video_submissions" */
export type LearningProgramScheduleVideoSubmissionsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  learningProgramEnrollmentId?: InputMaybe<OrderBy>;
  learningProgramScheduleId?: InputMaybe<OrderBy>;
  reviewedAt?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  /** One-to-one link to video_analysis table */
  videoAnalysisId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "learning_program_schedule_video_submissions" */
export type LearningProgramScheduleVideoSubmissionsMutationResponse = {
  __typename?: 'LearningProgramScheduleVideoSubmissionsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LearningProgramScheduleVideoSubmissions>;
};

/** on_conflict condition type for table "learning_program_schedule_video_submissions" */
export type LearningProgramScheduleVideoSubmissionsOnConflict = {
  constraint: LearningProgramScheduleVideoSubmissionsConstraint;
  updateColumns?: Array<LearningProgramScheduleVideoSubmissionsUpdateColumn>;
  where?: InputMaybe<LearningProgramScheduleVideoSubmissionsBoolExp>;
};

/** Ordering options when selecting data from "learning_program_schedule_video_submissions". */
export type LearningProgramScheduleVideoSubmissionsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  learningProgramEnrollment?: InputMaybe<LearningProgramEnrollmentsOrderBy>;
  learningProgramEnrollmentId?: InputMaybe<OrderBy>;
  learningProgramSchedule?: InputMaybe<LearningProgramSchedulesOrderBy>;
  learningProgramScheduleId?: InputMaybe<OrderBy>;
  reviewedAt?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  videoAnalysis?: InputMaybe<VideoAnalysisOrderBy>;
  videoAnalysisId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: learning_program_schedule_video_submissions */
export type LearningProgramScheduleVideoSubmissionsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "learning_program_schedule_video_submissions" */
export enum LearningProgramScheduleVideoSubmissionsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  LearningProgramEnrollmentId = 'learningProgramEnrollmentId',
  /** column name */
  LearningProgramScheduleId = 'learningProgramScheduleId',
  /** column name */
  ReviewedAt = 'reviewedAt',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  VideoAnalysisId = 'videoAnalysisId'
}

/** input type for updating data in table "learning_program_schedule_video_submissions" */
export type LearningProgramScheduleVideoSubmissionsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  learningProgramEnrollmentId?: InputMaybe<Scalars['uuid']>;
  learningProgramScheduleId?: InputMaybe<Scalars['uuid']>;
  reviewedAt?: InputMaybe<Scalars['timestamptz']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  /** One-to-one link to video_analysis table */
  videoAnalysisId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "learning_program_schedule_video_submissions" */
export type LearningProgramScheduleVideoSubmissionsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: LearningProgramScheduleVideoSubmissionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LearningProgramScheduleVideoSubmissionsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  learningProgramEnrollmentId?: InputMaybe<Scalars['uuid']>;
  learningProgramScheduleId?: InputMaybe<Scalars['uuid']>;
  reviewedAt?: InputMaybe<Scalars['timestamptz']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  /** One-to-one link to video_analysis table */
  videoAnalysisId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "learning_program_schedule_video_submissions" */
export enum LearningProgramScheduleVideoSubmissionsUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  LearningProgramEnrollmentId = 'learningProgramEnrollmentId',
  /** column name */
  LearningProgramScheduleId = 'learningProgramScheduleId',
  /** column name */
  ReviewedAt = 'reviewedAt',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  VideoAnalysisId = 'videoAnalysisId'
}

export type LearningProgramScheduleVideoSubmissionsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LearningProgramScheduleVideoSubmissionsSetInput>;
  /** filter the rows which have to be updated */
  where: LearningProgramScheduleVideoSubmissionsBoolExp;
};

/** Individual schedule periods within a learning program */
export type LearningProgramSchedules = {
  __typename?: 'LearningProgramSchedules';
  commonMistakes?: Maybe<Scalars['String']>;
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  enrollmentProgress: Array<LearningProgramEnrollmentScheduleProgress>;
  /** An aggregate relationship */
  enrollmentProgressAggregate: LearningProgramEnrollmentScheduleProgressAggregate;
  /** Component 1: What technique fundamentals to work on */
  focus?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  /** An object relationship */
  learningProgram: LearningPrograms;
  learningProgramId: Scalars['uuid'];
  /** Component 2: What the player should achieve */
  lessonObjective?: Maybe<Scalars['String']>;
  /** An array relationship */
  media: Array<LearningProgramScheduleMedia>;
  /** An aggregate relationship */
  mediaAggregate: LearningProgramScheduleMediaAggregate;
  /** Component 3: Structured drills and exercises */
  practicePlan?: Maybe<Scalars['String']>;
  /** An object relationship */
  primarySkill?: Maybe<LessonSkills>;
  primarySkillId?: Maybe<LessonSkillsEnum>;
  /** Sequential period number (1, 2, 3, etc.) */
  scheduleNumber: Scalars['Int'];
  title: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  /** An array relationship */
  videoSubmissions: Array<LearningProgramScheduleVideoSubmissions>;
  /** An aggregate relationship */
  videoSubmissionsAggregate: LearningProgramScheduleVideoSubmissionsAggregate;
};


/** Individual schedule periods within a learning program */
export type LearningProgramSchedulesEnrollmentProgressArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramEnrollmentScheduleProgressSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramEnrollmentScheduleProgressOrderBy>>;
  where?: InputMaybe<LearningProgramEnrollmentScheduleProgressBoolExp>;
};


/** Individual schedule periods within a learning program */
export type LearningProgramSchedulesEnrollmentProgressAggregateArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramEnrollmentScheduleProgressSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramEnrollmentScheduleProgressOrderBy>>;
  where?: InputMaybe<LearningProgramEnrollmentScheduleProgressBoolExp>;
};


/** Individual schedule periods within a learning program */
export type LearningProgramSchedulesMediaArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramScheduleMediaSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramScheduleMediaOrderBy>>;
  where?: InputMaybe<LearningProgramScheduleMediaBoolExp>;
};


/** Individual schedule periods within a learning program */
export type LearningProgramSchedulesMediaAggregateArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramScheduleMediaSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramScheduleMediaOrderBy>>;
  where?: InputMaybe<LearningProgramScheduleMediaBoolExp>;
};


/** Individual schedule periods within a learning program */
export type LearningProgramSchedulesVideoSubmissionsArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramScheduleVideoSubmissionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramScheduleVideoSubmissionsOrderBy>>;
  where?: InputMaybe<LearningProgramScheduleVideoSubmissionsBoolExp>;
};


/** Individual schedule periods within a learning program */
export type LearningProgramSchedulesVideoSubmissionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramScheduleVideoSubmissionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramScheduleVideoSubmissionsOrderBy>>;
  where?: InputMaybe<LearningProgramScheduleVideoSubmissionsBoolExp>;
};

/** aggregated selection of "learning_program_schedules" */
export type LearningProgramSchedulesAggregate = {
  __typename?: 'LearningProgramSchedulesAggregate';
  aggregate?: Maybe<LearningProgramSchedulesAggregateFields>;
  nodes: Array<LearningProgramSchedules>;
};

export type LearningProgramSchedulesAggregateBoolExp = {
  count?: InputMaybe<LearningProgramSchedulesAggregateBoolExpCount>;
};

/** aggregate fields of "learning_program_schedules" */
export type LearningProgramSchedulesAggregateFields = {
  __typename?: 'LearningProgramSchedulesAggregateFields';
  avg?: Maybe<LearningProgramSchedulesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<LearningProgramSchedulesMaxFields>;
  min?: Maybe<LearningProgramSchedulesMinFields>;
  stddev?: Maybe<LearningProgramSchedulesStddevFields>;
  stddevPop?: Maybe<LearningProgramSchedulesStddevPopFields>;
  stddevSamp?: Maybe<LearningProgramSchedulesStddevSampFields>;
  sum?: Maybe<LearningProgramSchedulesSumFields>;
  varPop?: Maybe<LearningProgramSchedulesVarPopFields>;
  varSamp?: Maybe<LearningProgramSchedulesVarSampFields>;
  variance?: Maybe<LearningProgramSchedulesVarianceFields>;
};


/** aggregate fields of "learning_program_schedules" */
export type LearningProgramSchedulesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<LearningProgramSchedulesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "learning_program_schedules" */
export type LearningProgramSchedulesAggregateOrderBy = {
  avg?: InputMaybe<LearningProgramSchedulesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<LearningProgramSchedulesMaxOrderBy>;
  min?: InputMaybe<LearningProgramSchedulesMinOrderBy>;
  stddev?: InputMaybe<LearningProgramSchedulesStddevOrderBy>;
  stddevPop?: InputMaybe<LearningProgramSchedulesStddevPopOrderBy>;
  stddevSamp?: InputMaybe<LearningProgramSchedulesStddevSampOrderBy>;
  sum?: InputMaybe<LearningProgramSchedulesSumOrderBy>;
  varPop?: InputMaybe<LearningProgramSchedulesVarPopOrderBy>;
  varSamp?: InputMaybe<LearningProgramSchedulesVarSampOrderBy>;
  variance?: InputMaybe<LearningProgramSchedulesVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "learning_program_schedules" */
export type LearningProgramSchedulesArrRelInsertInput = {
  data: Array<LearningProgramSchedulesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<LearningProgramSchedulesOnConflict>;
};

/** aggregate avg on columns */
export type LearningProgramSchedulesAvgFields = {
  __typename?: 'LearningProgramSchedulesAvgFields';
  /** Sequential period number (1, 2, 3, etc.) */
  scheduleNumber?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "learning_program_schedules" */
export type LearningProgramSchedulesAvgOrderBy = {
  /** Sequential period number (1, 2, 3, etc.) */
  scheduleNumber?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "learning_program_schedules". All fields are combined with a logical 'AND'. */
export type LearningProgramSchedulesBoolExp = {
  _and?: InputMaybe<Array<LearningProgramSchedulesBoolExp>>;
  _not?: InputMaybe<LearningProgramSchedulesBoolExp>;
  _or?: InputMaybe<Array<LearningProgramSchedulesBoolExp>>;
  commonMistakes?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  enrollmentProgress?: InputMaybe<LearningProgramEnrollmentScheduleProgressBoolExp>;
  enrollmentProgressAggregate?: InputMaybe<LearningProgramEnrollmentScheduleProgressAggregateBoolExp>;
  focus?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  learningProgram?: InputMaybe<LearningProgramsBoolExp>;
  learningProgramId?: InputMaybe<UuidComparisonExp>;
  lessonObjective?: InputMaybe<StringComparisonExp>;
  media?: InputMaybe<LearningProgramScheduleMediaBoolExp>;
  mediaAggregate?: InputMaybe<LearningProgramScheduleMediaAggregateBoolExp>;
  practicePlan?: InputMaybe<StringComparisonExp>;
  primarySkill?: InputMaybe<LessonSkillsBoolExp>;
  primarySkillId?: InputMaybe<LessonSkillsEnumComparisonExp>;
  scheduleNumber?: InputMaybe<IntComparisonExp>;
  title?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  videoSubmissions?: InputMaybe<LearningProgramScheduleVideoSubmissionsBoolExp>;
  videoSubmissionsAggregate?: InputMaybe<LearningProgramScheduleVideoSubmissionsAggregateBoolExp>;
};

/** unique or primary key constraints on table "learning_program_schedules" */
export enum LearningProgramSchedulesConstraint {
  /** unique or primary key constraint on columns "id" */
  LearningProgramSchedulesPkey = 'learning_program_schedules_pkey',
  /** unique or primary key constraint on columns "schedule_number", "learning_program_id" */
  UqLearningProgramSchedulesProgramNumber = 'uq_learning_program_schedules_program_number'
}

/** input type for incrementing numeric columns in table "learning_program_schedules" */
export type LearningProgramSchedulesIncInput = {
  /** Sequential period number (1, 2, 3, etc.) */
  scheduleNumber?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "learning_program_schedules" */
export type LearningProgramSchedulesInsertInput = {
  commonMistakes?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  enrollmentProgress?: InputMaybe<LearningProgramEnrollmentScheduleProgressArrRelInsertInput>;
  /** Component 1: What technique fundamentals to work on */
  focus?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  learningProgram?: InputMaybe<LearningProgramsObjRelInsertInput>;
  learningProgramId?: InputMaybe<Scalars['uuid']>;
  /** Component 2: What the player should achieve */
  lessonObjective?: InputMaybe<Scalars['String']>;
  media?: InputMaybe<LearningProgramScheduleMediaArrRelInsertInput>;
  /** Component 3: Structured drills and exercises */
  practicePlan?: InputMaybe<Scalars['String']>;
  primarySkill?: InputMaybe<LessonSkillsObjRelInsertInput>;
  primarySkillId?: InputMaybe<LessonSkillsEnum>;
  /** Sequential period number (1, 2, 3, etc.) */
  scheduleNumber?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  videoSubmissions?: InputMaybe<LearningProgramScheduleVideoSubmissionsArrRelInsertInput>;
};

/** aggregate max on columns */
export type LearningProgramSchedulesMaxFields = {
  __typename?: 'LearningProgramSchedulesMaxFields';
  commonMistakes?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** Component 1: What technique fundamentals to work on */
  focus?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  learningProgramId?: Maybe<Scalars['uuid']>;
  /** Component 2: What the player should achieve */
  lessonObjective?: Maybe<Scalars['String']>;
  /** Component 3: Structured drills and exercises */
  practicePlan?: Maybe<Scalars['String']>;
  /** Sequential period number (1, 2, 3, etc.) */
  scheduleNumber?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "learning_program_schedules" */
export type LearningProgramSchedulesMaxOrderBy = {
  commonMistakes?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  /** Component 1: What technique fundamentals to work on */
  focus?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  learningProgramId?: InputMaybe<OrderBy>;
  /** Component 2: What the player should achieve */
  lessonObjective?: InputMaybe<OrderBy>;
  /** Component 3: Structured drills and exercises */
  practicePlan?: InputMaybe<OrderBy>;
  /** Sequential period number (1, 2, 3, etc.) */
  scheduleNumber?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type LearningProgramSchedulesMinFields = {
  __typename?: 'LearningProgramSchedulesMinFields';
  commonMistakes?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** Component 1: What technique fundamentals to work on */
  focus?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  learningProgramId?: Maybe<Scalars['uuid']>;
  /** Component 2: What the player should achieve */
  lessonObjective?: Maybe<Scalars['String']>;
  /** Component 3: Structured drills and exercises */
  practicePlan?: Maybe<Scalars['String']>;
  /** Sequential period number (1, 2, 3, etc.) */
  scheduleNumber?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "learning_program_schedules" */
export type LearningProgramSchedulesMinOrderBy = {
  commonMistakes?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  /** Component 1: What technique fundamentals to work on */
  focus?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  learningProgramId?: InputMaybe<OrderBy>;
  /** Component 2: What the player should achieve */
  lessonObjective?: InputMaybe<OrderBy>;
  /** Component 3: Structured drills and exercises */
  practicePlan?: InputMaybe<OrderBy>;
  /** Sequential period number (1, 2, 3, etc.) */
  scheduleNumber?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "learning_program_schedules" */
export type LearningProgramSchedulesMutationResponse = {
  __typename?: 'LearningProgramSchedulesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LearningProgramSchedules>;
};

/** input type for inserting object relation for remote table "learning_program_schedules" */
export type LearningProgramSchedulesObjRelInsertInput = {
  data: LearningProgramSchedulesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<LearningProgramSchedulesOnConflict>;
};

/** on_conflict condition type for table "learning_program_schedules" */
export type LearningProgramSchedulesOnConflict = {
  constraint: LearningProgramSchedulesConstraint;
  updateColumns?: Array<LearningProgramSchedulesUpdateColumn>;
  where?: InputMaybe<LearningProgramSchedulesBoolExp>;
};

/** Ordering options when selecting data from "learning_program_schedules". */
export type LearningProgramSchedulesOrderBy = {
  commonMistakes?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  enrollmentProgressAggregate?: InputMaybe<LearningProgramEnrollmentScheduleProgressAggregateOrderBy>;
  focus?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  learningProgram?: InputMaybe<LearningProgramsOrderBy>;
  learningProgramId?: InputMaybe<OrderBy>;
  lessonObjective?: InputMaybe<OrderBy>;
  mediaAggregate?: InputMaybe<LearningProgramScheduleMediaAggregateOrderBy>;
  practicePlan?: InputMaybe<OrderBy>;
  primarySkill?: InputMaybe<LessonSkillsOrderBy>;
  primarySkillId?: InputMaybe<OrderBy>;
  scheduleNumber?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  videoSubmissionsAggregate?: InputMaybe<LearningProgramScheduleVideoSubmissionsAggregateOrderBy>;
};

/** primary key columns input for table: learning_program_schedules */
export type LearningProgramSchedulesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "learning_program_schedules" */
export enum LearningProgramSchedulesSelectColumn {
  /** column name */
  CommonMistakes = 'commonMistakes',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Focus = 'focus',
  /** column name */
  Id = 'id',
  /** column name */
  LearningProgramId = 'learningProgramId',
  /** column name */
  LessonObjective = 'lessonObjective',
  /** column name */
  PracticePlan = 'practicePlan',
  /** column name */
  PrimarySkillId = 'primarySkillId',
  /** column name */
  ScheduleNumber = 'scheduleNumber',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "learning_program_schedules" */
export type LearningProgramSchedulesSetInput = {
  commonMistakes?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  /** Component 1: What technique fundamentals to work on */
  focus?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  learningProgramId?: InputMaybe<Scalars['uuid']>;
  /** Component 2: What the player should achieve */
  lessonObjective?: InputMaybe<Scalars['String']>;
  /** Component 3: Structured drills and exercises */
  practicePlan?: InputMaybe<Scalars['String']>;
  primarySkillId?: InputMaybe<LessonSkillsEnum>;
  /** Sequential period number (1, 2, 3, etc.) */
  scheduleNumber?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type LearningProgramSchedulesStddevFields = {
  __typename?: 'LearningProgramSchedulesStddevFields';
  /** Sequential period number (1, 2, 3, etc.) */
  scheduleNumber?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "learning_program_schedules" */
export type LearningProgramSchedulesStddevOrderBy = {
  /** Sequential period number (1, 2, 3, etc.) */
  scheduleNumber?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type LearningProgramSchedulesStddevPopFields = {
  __typename?: 'LearningProgramSchedulesStddevPopFields';
  /** Sequential period number (1, 2, 3, etc.) */
  scheduleNumber?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "learning_program_schedules" */
export type LearningProgramSchedulesStddevPopOrderBy = {
  /** Sequential period number (1, 2, 3, etc.) */
  scheduleNumber?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type LearningProgramSchedulesStddevSampFields = {
  __typename?: 'LearningProgramSchedulesStddevSampFields';
  /** Sequential period number (1, 2, 3, etc.) */
  scheduleNumber?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "learning_program_schedules" */
export type LearningProgramSchedulesStddevSampOrderBy = {
  /** Sequential period number (1, 2, 3, etc.) */
  scheduleNumber?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "learning_program_schedules" */
export type LearningProgramSchedulesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: LearningProgramSchedulesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LearningProgramSchedulesStreamCursorValueInput = {
  commonMistakes?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  /** Component 1: What technique fundamentals to work on */
  focus?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  learningProgramId?: InputMaybe<Scalars['uuid']>;
  /** Component 2: What the player should achieve */
  lessonObjective?: InputMaybe<Scalars['String']>;
  /** Component 3: Structured drills and exercises */
  practicePlan?: InputMaybe<Scalars['String']>;
  primarySkillId?: InputMaybe<LessonSkillsEnum>;
  /** Sequential period number (1, 2, 3, etc.) */
  scheduleNumber?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type LearningProgramSchedulesSumFields = {
  __typename?: 'LearningProgramSchedulesSumFields';
  /** Sequential period number (1, 2, 3, etc.) */
  scheduleNumber?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "learning_program_schedules" */
export type LearningProgramSchedulesSumOrderBy = {
  /** Sequential period number (1, 2, 3, etc.) */
  scheduleNumber?: InputMaybe<OrderBy>;
};

/** update columns of table "learning_program_schedules" */
export enum LearningProgramSchedulesUpdateColumn {
  /** column name */
  CommonMistakes = 'commonMistakes',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Focus = 'focus',
  /** column name */
  Id = 'id',
  /** column name */
  LearningProgramId = 'learningProgramId',
  /** column name */
  LessonObjective = 'lessonObjective',
  /** column name */
  PracticePlan = 'practicePlan',
  /** column name */
  PrimarySkillId = 'primarySkillId',
  /** column name */
  ScheduleNumber = 'scheduleNumber',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type LearningProgramSchedulesUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<LearningProgramSchedulesIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LearningProgramSchedulesSetInput>;
  /** filter the rows which have to be updated */
  where: LearningProgramSchedulesBoolExp;
};

/** aggregate varPop on columns */
export type LearningProgramSchedulesVarPopFields = {
  __typename?: 'LearningProgramSchedulesVarPopFields';
  /** Sequential period number (1, 2, 3, etc.) */
  scheduleNumber?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "learning_program_schedules" */
export type LearningProgramSchedulesVarPopOrderBy = {
  /** Sequential period number (1, 2, 3, etc.) */
  scheduleNumber?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type LearningProgramSchedulesVarSampFields = {
  __typename?: 'LearningProgramSchedulesVarSampFields';
  /** Sequential period number (1, 2, 3, etc.) */
  scheduleNumber?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "learning_program_schedules" */
export type LearningProgramSchedulesVarSampOrderBy = {
  /** Sequential period number (1, 2, 3, etc.) */
  scheduleNumber?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type LearningProgramSchedulesVarianceFields = {
  __typename?: 'LearningProgramSchedulesVarianceFields';
  /** Sequential period number (1, 2, 3, etc.) */
  scheduleNumber?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "learning_program_schedules" */
export type LearningProgramSchedulesVarianceOrderBy = {
  /** Sequential period number (1, 2, 3, etc.) */
  scheduleNumber?: InputMaybe<OrderBy>;
};

/** columns and relationships of "learning_program_skill_level_values" */
export type LearningProgramSkillLevelValues = {
  __typename?: 'LearningProgramSkillLevelValues';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "learning_program_skill_level_values" */
export type LearningProgramSkillLevelValuesAggregate = {
  __typename?: 'LearningProgramSkillLevelValuesAggregate';
  aggregate?: Maybe<LearningProgramSkillLevelValuesAggregateFields>;
  nodes: Array<LearningProgramSkillLevelValues>;
};

/** aggregate fields of "learning_program_skill_level_values" */
export type LearningProgramSkillLevelValuesAggregateFields = {
  __typename?: 'LearningProgramSkillLevelValuesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<LearningProgramSkillLevelValuesMaxFields>;
  min?: Maybe<LearningProgramSkillLevelValuesMinFields>;
};


/** aggregate fields of "learning_program_skill_level_values" */
export type LearningProgramSkillLevelValuesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<LearningProgramSkillLevelValuesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "learning_program_skill_level_values". All fields are combined with a logical 'AND'. */
export type LearningProgramSkillLevelValuesBoolExp = {
  _and?: InputMaybe<Array<LearningProgramSkillLevelValuesBoolExp>>;
  _not?: InputMaybe<LearningProgramSkillLevelValuesBoolExp>;
  _or?: InputMaybe<Array<LearningProgramSkillLevelValuesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "learning_program_skill_level_values" */
export enum LearningProgramSkillLevelValuesConstraint {
  /** unique or primary key constraint on columns "value" */
  LearningProgramSkillLevelValuesPkey = 'learning_program_skill_level_values_pkey'
}

export enum LearningProgramSkillLevelValuesEnum {
  Advanced = 'ADVANCED',
  AllLevels = 'ALL_LEVELS',
  Beginner = 'BEGINNER',
  Intermediate = 'INTERMEDIATE'
}

/** Boolean expression to compare columns of type "LearningProgramSkillLevelValuesEnum". All fields are combined with logical 'AND'. */
export type LearningProgramSkillLevelValuesEnumComparisonExp = {
  _eq?: InputMaybe<LearningProgramSkillLevelValuesEnum>;
  _in?: InputMaybe<Array<LearningProgramSkillLevelValuesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<LearningProgramSkillLevelValuesEnum>;
  _nin?: InputMaybe<Array<LearningProgramSkillLevelValuesEnum>>;
};

/** input type for inserting data into table "learning_program_skill_level_values" */
export type LearningProgramSkillLevelValuesInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type LearningProgramSkillLevelValuesMaxFields = {
  __typename?: 'LearningProgramSkillLevelValuesMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type LearningProgramSkillLevelValuesMinFields = {
  __typename?: 'LearningProgramSkillLevelValuesMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "learning_program_skill_level_values" */
export type LearningProgramSkillLevelValuesMutationResponse = {
  __typename?: 'LearningProgramSkillLevelValuesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LearningProgramSkillLevelValues>;
};

/** input type for inserting object relation for remote table "learning_program_skill_level_values" */
export type LearningProgramSkillLevelValuesObjRelInsertInput = {
  data: LearningProgramSkillLevelValuesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<LearningProgramSkillLevelValuesOnConflict>;
};

/** on_conflict condition type for table "learning_program_skill_level_values" */
export type LearningProgramSkillLevelValuesOnConflict = {
  constraint: LearningProgramSkillLevelValuesConstraint;
  updateColumns?: Array<LearningProgramSkillLevelValuesUpdateColumn>;
  where?: InputMaybe<LearningProgramSkillLevelValuesBoolExp>;
};

/** Ordering options when selecting data from "learning_program_skill_level_values". */
export type LearningProgramSkillLevelValuesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: learning_program_skill_level_values */
export type LearningProgramSkillLevelValuesPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "learning_program_skill_level_values" */
export enum LearningProgramSkillLevelValuesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "learning_program_skill_level_values" */
export type LearningProgramSkillLevelValuesSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "learning_program_skill_level_values" */
export type LearningProgramSkillLevelValuesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: LearningProgramSkillLevelValuesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LearningProgramSkillLevelValuesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "learning_program_skill_level_values" */
export enum LearningProgramSkillLevelValuesUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type LearningProgramSkillLevelValuesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LearningProgramSkillLevelValuesSetInput>;
  /** filter the rows which have to be updated */
  where: LearningProgramSkillLevelValuesBoolExp;
};

/** Maps programs to the skills they target */
export type LearningProgramSkills = {
  __typename?: 'LearningProgramSkills';
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** Indicates the primary focus skill of the program */
  isPrimary: Scalars['Boolean'];
  /** An object relationship */
  learningProgram: LearningPrograms;
  learningProgramId: Scalars['uuid'];
  /** An object relationship */
  skill: LessonSkills;
  skillId: LessonSkillsEnum;
};

/** aggregated selection of "learning_program_skills" */
export type LearningProgramSkillsAggregate = {
  __typename?: 'LearningProgramSkillsAggregate';
  aggregate?: Maybe<LearningProgramSkillsAggregateFields>;
  nodes: Array<LearningProgramSkills>;
};

export type LearningProgramSkillsAggregateBoolExp = {
  bool_and?: InputMaybe<LearningProgramSkillsAggregateBoolExpBool_And>;
  bool_or?: InputMaybe<LearningProgramSkillsAggregateBoolExpBool_Or>;
  count?: InputMaybe<LearningProgramSkillsAggregateBoolExpCount>;
};

/** aggregate fields of "learning_program_skills" */
export type LearningProgramSkillsAggregateFields = {
  __typename?: 'LearningProgramSkillsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<LearningProgramSkillsMaxFields>;
  min?: Maybe<LearningProgramSkillsMinFields>;
};


/** aggregate fields of "learning_program_skills" */
export type LearningProgramSkillsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<LearningProgramSkillsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "learning_program_skills" */
export type LearningProgramSkillsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<LearningProgramSkillsMaxOrderBy>;
  min?: InputMaybe<LearningProgramSkillsMinOrderBy>;
};

/** input type for inserting array relation for remote table "learning_program_skills" */
export type LearningProgramSkillsArrRelInsertInput = {
  data: Array<LearningProgramSkillsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<LearningProgramSkillsOnConflict>;
};

/** Boolean expression to filter rows from the table "learning_program_skills". All fields are combined with a logical 'AND'. */
export type LearningProgramSkillsBoolExp = {
  _and?: InputMaybe<Array<LearningProgramSkillsBoolExp>>;
  _not?: InputMaybe<LearningProgramSkillsBoolExp>;
  _or?: InputMaybe<Array<LearningProgramSkillsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isPrimary?: InputMaybe<BooleanComparisonExp>;
  learningProgram?: InputMaybe<LearningProgramsBoolExp>;
  learningProgramId?: InputMaybe<UuidComparisonExp>;
  skill?: InputMaybe<LessonSkillsBoolExp>;
  skillId?: InputMaybe<LessonSkillsEnumComparisonExp>;
};

/** unique or primary key constraints on table "learning_program_skills" */
export enum LearningProgramSkillsConstraint {
  /** unique or primary key constraint on columns "id" */
  LearningProgramSkillsPkey = 'learning_program_skills_pkey',
  /** unique or primary key constraint on columns "learning_program_id", "skill_id" */
  UqLearningProgramSkillsProgramSkill = 'uq_learning_program_skills_program_skill'
}

/** input type for inserting data into table "learning_program_skills" */
export type LearningProgramSkillsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** Indicates the primary focus skill of the program */
  isPrimary?: InputMaybe<Scalars['Boolean']>;
  learningProgram?: InputMaybe<LearningProgramsObjRelInsertInput>;
  learningProgramId?: InputMaybe<Scalars['uuid']>;
  skill?: InputMaybe<LessonSkillsObjRelInsertInput>;
  skillId?: InputMaybe<LessonSkillsEnum>;
};

/** aggregate max on columns */
export type LearningProgramSkillsMaxFields = {
  __typename?: 'LearningProgramSkillsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  learningProgramId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "learning_program_skills" */
export type LearningProgramSkillsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  learningProgramId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type LearningProgramSkillsMinFields = {
  __typename?: 'LearningProgramSkillsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  learningProgramId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "learning_program_skills" */
export type LearningProgramSkillsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  learningProgramId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "learning_program_skills" */
export type LearningProgramSkillsMutationResponse = {
  __typename?: 'LearningProgramSkillsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LearningProgramSkills>;
};

/** on_conflict condition type for table "learning_program_skills" */
export type LearningProgramSkillsOnConflict = {
  constraint: LearningProgramSkillsConstraint;
  updateColumns?: Array<LearningProgramSkillsUpdateColumn>;
  where?: InputMaybe<LearningProgramSkillsBoolExp>;
};

/** Ordering options when selecting data from "learning_program_skills". */
export type LearningProgramSkillsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  isPrimary?: InputMaybe<OrderBy>;
  learningProgram?: InputMaybe<LearningProgramsOrderBy>;
  learningProgramId?: InputMaybe<OrderBy>;
  skill?: InputMaybe<LessonSkillsOrderBy>;
  skillId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: learning_program_skills */
export type LearningProgramSkillsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "learning_program_skills" */
export enum LearningProgramSkillsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  IsPrimary = 'isPrimary',
  /** column name */
  LearningProgramId = 'learningProgramId',
  /** column name */
  SkillId = 'skillId'
}

/** select "learningProgramSkillsAggregateBoolExpBool_andArgumentsColumns" columns of table "learning_program_skills" */
export enum LearningProgramSkillsSelectColumnLearningProgramSkillsAggregateBoolExpBool_AndArgumentsColumns {
  /** column name */
  IsPrimary = 'isPrimary'
}

/** select "learningProgramSkillsAggregateBoolExpBool_orArgumentsColumns" columns of table "learning_program_skills" */
export enum LearningProgramSkillsSelectColumnLearningProgramSkillsAggregateBoolExpBool_OrArgumentsColumns {
  /** column name */
  IsPrimary = 'isPrimary'
}

/** input type for updating data in table "learning_program_skills" */
export type LearningProgramSkillsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** Indicates the primary focus skill of the program */
  isPrimary?: InputMaybe<Scalars['Boolean']>;
  learningProgramId?: InputMaybe<Scalars['uuid']>;
  skillId?: InputMaybe<LessonSkillsEnum>;
};

/** Streaming cursor of the table "learning_program_skills" */
export type LearningProgramSkillsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: LearningProgramSkillsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LearningProgramSkillsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** Indicates the primary focus skill of the program */
  isPrimary?: InputMaybe<Scalars['Boolean']>;
  learningProgramId?: InputMaybe<Scalars['uuid']>;
  skillId?: InputMaybe<LessonSkillsEnum>;
};

/** update columns of table "learning_program_skills" */
export enum LearningProgramSkillsUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  IsPrimary = 'isPrimary',
  /** column name */
  LearningProgramId = 'learningProgramId',
  /** column name */
  SkillId = 'skillId'
}

export type LearningProgramSkillsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LearningProgramSkillsSetInput>;
  /** filter the rows which have to be updated */
  where: LearningProgramSkillsBoolExp;
};

/** Main container for all learning programs */
export type LearningPrograms = {
  __typename?: 'LearningPrograms';
  averageRating?: Maybe<Scalars['numeric']>;
  coverImageUrl?: Maybe<Scalars['String']>;
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  /** An array relationship */
  enrollments: Array<LearningProgramEnrollments>;
  /** An aggregate relationship */
  enrollmentsAggregate: LearningProgramEnrollmentsAggregate;
  id: Scalars['uuid'];
  /** Whether the program is published and visible to players */
  isPublished: Scalars['Boolean'];
  /** Whether this program can be used as a template */
  isTemplate: Scalars['Boolean'];
  scheduleUnit: LearningProgramScheduleUnitsEnum;
  /** An array relationship */
  schedules: Array<LearningProgramSchedules>;
  /** An aggregate relationship */
  schedulesAggregate: LearningProgramSchedulesAggregate;
  /** An object relationship */
  skillLevel?: Maybe<LearningProgramSkillLevelValues>;
  skillLevelId?: Maybe<LearningProgramSkillLevelValuesEnum>;
  /** An array relationship */
  skills: Array<LearningProgramSkills>;
  /** An aggregate relationship */
  skillsAggregate: LearningProgramSkillsAggregate;
  /** An object relationship */
  sport: Sports;
  sportId: SportsEnum;
  thumbnailUrl?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  totalEnrollments: Scalars['Int'];
  /** Total number of schedule periods in the program */
  totalSchedules: Scalars['Int'];
  updatedAt: Scalars['timestamptz'];
};


/** Main container for all learning programs */
export type LearningProgramsEnrollmentsArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramEnrollmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramEnrollmentsOrderBy>>;
  where?: InputMaybe<LearningProgramEnrollmentsBoolExp>;
};


/** Main container for all learning programs */
export type LearningProgramsEnrollmentsAggregateArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramEnrollmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramEnrollmentsOrderBy>>;
  where?: InputMaybe<LearningProgramEnrollmentsBoolExp>;
};


/** Main container for all learning programs */
export type LearningProgramsSchedulesArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramSchedulesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramSchedulesOrderBy>>;
  where?: InputMaybe<LearningProgramSchedulesBoolExp>;
};


/** Main container for all learning programs */
export type LearningProgramsSchedulesAggregateArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramSchedulesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramSchedulesOrderBy>>;
  where?: InputMaybe<LearningProgramSchedulesBoolExp>;
};


/** Main container for all learning programs */
export type LearningProgramsSkillsArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramSkillsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramSkillsOrderBy>>;
  where?: InputMaybe<LearningProgramSkillsBoolExp>;
};


/** Main container for all learning programs */
export type LearningProgramsSkillsAggregateArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramSkillsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramSkillsOrderBy>>;
  where?: InputMaybe<LearningProgramSkillsBoolExp>;
};

/** aggregated selection of "learning_programs" */
export type LearningProgramsAggregate = {
  __typename?: 'LearningProgramsAggregate';
  aggregate?: Maybe<LearningProgramsAggregateFields>;
  nodes: Array<LearningPrograms>;
};

/** aggregate fields of "learning_programs" */
export type LearningProgramsAggregateFields = {
  __typename?: 'LearningProgramsAggregateFields';
  avg?: Maybe<LearningProgramsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<LearningProgramsMaxFields>;
  min?: Maybe<LearningProgramsMinFields>;
  stddev?: Maybe<LearningProgramsStddevFields>;
  stddevPop?: Maybe<LearningProgramsStddevPopFields>;
  stddevSamp?: Maybe<LearningProgramsStddevSampFields>;
  sum?: Maybe<LearningProgramsSumFields>;
  varPop?: Maybe<LearningProgramsVarPopFields>;
  varSamp?: Maybe<LearningProgramsVarSampFields>;
  variance?: Maybe<LearningProgramsVarianceFields>;
};


/** aggregate fields of "learning_programs" */
export type LearningProgramsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<LearningProgramsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type LearningProgramsAvgFields = {
  __typename?: 'LearningProgramsAvgFields';
  averageRating?: Maybe<Scalars['Float']>;
  totalEnrollments?: Maybe<Scalars['Float']>;
  /** Total number of schedule periods in the program */
  totalSchedules?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "learning_programs". All fields are combined with a logical 'AND'. */
export type LearningProgramsBoolExp = {
  _and?: InputMaybe<Array<LearningProgramsBoolExp>>;
  _not?: InputMaybe<LearningProgramsBoolExp>;
  _or?: InputMaybe<Array<LearningProgramsBoolExp>>;
  averageRating?: InputMaybe<NumericComparisonExp>;
  coverImageUrl?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  enrollments?: InputMaybe<LearningProgramEnrollmentsBoolExp>;
  enrollmentsAggregate?: InputMaybe<LearningProgramEnrollmentsAggregateBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isPublished?: InputMaybe<BooleanComparisonExp>;
  isTemplate?: InputMaybe<BooleanComparisonExp>;
  scheduleUnit?: InputMaybe<LearningProgramScheduleUnitsEnumComparisonExp>;
  schedules?: InputMaybe<LearningProgramSchedulesBoolExp>;
  schedulesAggregate?: InputMaybe<LearningProgramSchedulesAggregateBoolExp>;
  skillLevel?: InputMaybe<LearningProgramSkillLevelValuesBoolExp>;
  skillLevelId?: InputMaybe<LearningProgramSkillLevelValuesEnumComparisonExp>;
  skills?: InputMaybe<LearningProgramSkillsBoolExp>;
  skillsAggregate?: InputMaybe<LearningProgramSkillsAggregateBoolExp>;
  sport?: InputMaybe<SportsBoolExp>;
  sportId?: InputMaybe<SportsEnumComparisonExp>;
  thumbnailUrl?: InputMaybe<StringComparisonExp>;
  title?: InputMaybe<StringComparisonExp>;
  totalEnrollments?: InputMaybe<IntComparisonExp>;
  totalSchedules?: InputMaybe<IntComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "learning_programs" */
export enum LearningProgramsConstraint {
  /** unique or primary key constraint on columns "id" */
  LearningProgramsPkey = 'learning_programs_pkey'
}

/** input type for incrementing numeric columns in table "learning_programs" */
export type LearningProgramsIncInput = {
  averageRating?: InputMaybe<Scalars['numeric']>;
  totalEnrollments?: InputMaybe<Scalars['Int']>;
  /** Total number of schedule periods in the program */
  totalSchedules?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "learning_programs" */
export type LearningProgramsInsertInput = {
  averageRating?: InputMaybe<Scalars['numeric']>;
  coverImageUrl?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  enrollments?: InputMaybe<LearningProgramEnrollmentsArrRelInsertInput>;
  id?: InputMaybe<Scalars['uuid']>;
  /** Whether the program is published and visible to players */
  isPublished?: InputMaybe<Scalars['Boolean']>;
  /** Whether this program can be used as a template */
  isTemplate?: InputMaybe<Scalars['Boolean']>;
  scheduleUnit?: InputMaybe<LearningProgramScheduleUnitsEnum>;
  schedules?: InputMaybe<LearningProgramSchedulesArrRelInsertInput>;
  skillLevel?: InputMaybe<LearningProgramSkillLevelValuesObjRelInsertInput>;
  skillLevelId?: InputMaybe<LearningProgramSkillLevelValuesEnum>;
  skills?: InputMaybe<LearningProgramSkillsArrRelInsertInput>;
  sport?: InputMaybe<SportsObjRelInsertInput>;
  sportId?: InputMaybe<SportsEnum>;
  thumbnailUrl?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  totalEnrollments?: InputMaybe<Scalars['Int']>;
  /** Total number of schedule periods in the program */
  totalSchedules?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type LearningProgramsMaxFields = {
  __typename?: 'LearningProgramsMaxFields';
  averageRating?: Maybe<Scalars['numeric']>;
  coverImageUrl?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  thumbnailUrl?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  totalEnrollments?: Maybe<Scalars['Int']>;
  /** Total number of schedule periods in the program */
  totalSchedules?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type LearningProgramsMinFields = {
  __typename?: 'LearningProgramsMinFields';
  averageRating?: Maybe<Scalars['numeric']>;
  coverImageUrl?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  thumbnailUrl?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  totalEnrollments?: Maybe<Scalars['Int']>;
  /** Total number of schedule periods in the program */
  totalSchedules?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "learning_programs" */
export type LearningProgramsMutationResponse = {
  __typename?: 'LearningProgramsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LearningPrograms>;
};

/** input type for inserting object relation for remote table "learning_programs" */
export type LearningProgramsObjRelInsertInput = {
  data: LearningProgramsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<LearningProgramsOnConflict>;
};

/** on_conflict condition type for table "learning_programs" */
export type LearningProgramsOnConflict = {
  constraint: LearningProgramsConstraint;
  updateColumns?: Array<LearningProgramsUpdateColumn>;
  where?: InputMaybe<LearningProgramsBoolExp>;
};

/** Ordering options when selecting data from "learning_programs". */
export type LearningProgramsOrderBy = {
  averageRating?: InputMaybe<OrderBy>;
  coverImageUrl?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  enrollmentsAggregate?: InputMaybe<LearningProgramEnrollmentsAggregateOrderBy>;
  id?: InputMaybe<OrderBy>;
  isPublished?: InputMaybe<OrderBy>;
  isTemplate?: InputMaybe<OrderBy>;
  scheduleUnit?: InputMaybe<OrderBy>;
  schedulesAggregate?: InputMaybe<LearningProgramSchedulesAggregateOrderBy>;
  skillLevel?: InputMaybe<LearningProgramSkillLevelValuesOrderBy>;
  skillLevelId?: InputMaybe<OrderBy>;
  skillsAggregate?: InputMaybe<LearningProgramSkillsAggregateOrderBy>;
  sport?: InputMaybe<SportsOrderBy>;
  sportId?: InputMaybe<OrderBy>;
  thumbnailUrl?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  totalEnrollments?: InputMaybe<OrderBy>;
  totalSchedules?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: learning_programs */
export type LearningProgramsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "learning_programs" */
export enum LearningProgramsSelectColumn {
  /** column name */
  AverageRating = 'averageRating',
  /** column name */
  CoverImageUrl = 'coverImageUrl',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsPublished = 'isPublished',
  /** column name */
  IsTemplate = 'isTemplate',
  /** column name */
  ScheduleUnit = 'scheduleUnit',
  /** column name */
  SkillLevelId = 'skillLevelId',
  /** column name */
  SportId = 'sportId',
  /** column name */
  ThumbnailUrl = 'thumbnailUrl',
  /** column name */
  Title = 'title',
  /** column name */
  TotalEnrollments = 'totalEnrollments',
  /** column name */
  TotalSchedules = 'totalSchedules',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "learning_programs" */
export type LearningProgramsSetInput = {
  averageRating?: InputMaybe<Scalars['numeric']>;
  coverImageUrl?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** Whether the program is published and visible to players */
  isPublished?: InputMaybe<Scalars['Boolean']>;
  /** Whether this program can be used as a template */
  isTemplate?: InputMaybe<Scalars['Boolean']>;
  scheduleUnit?: InputMaybe<LearningProgramScheduleUnitsEnum>;
  skillLevelId?: InputMaybe<LearningProgramSkillLevelValuesEnum>;
  sportId?: InputMaybe<SportsEnum>;
  thumbnailUrl?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  totalEnrollments?: InputMaybe<Scalars['Int']>;
  /** Total number of schedule periods in the program */
  totalSchedules?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type LearningProgramsStddevFields = {
  __typename?: 'LearningProgramsStddevFields';
  averageRating?: Maybe<Scalars['Float']>;
  totalEnrollments?: Maybe<Scalars['Float']>;
  /** Total number of schedule periods in the program */
  totalSchedules?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type LearningProgramsStddevPopFields = {
  __typename?: 'LearningProgramsStddevPopFields';
  averageRating?: Maybe<Scalars['Float']>;
  totalEnrollments?: Maybe<Scalars['Float']>;
  /** Total number of schedule periods in the program */
  totalSchedules?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type LearningProgramsStddevSampFields = {
  __typename?: 'LearningProgramsStddevSampFields';
  averageRating?: Maybe<Scalars['Float']>;
  totalEnrollments?: Maybe<Scalars['Float']>;
  /** Total number of schedule periods in the program */
  totalSchedules?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "learning_programs" */
export type LearningProgramsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: LearningProgramsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LearningProgramsStreamCursorValueInput = {
  averageRating?: InputMaybe<Scalars['numeric']>;
  coverImageUrl?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** Whether the program is published and visible to players */
  isPublished?: InputMaybe<Scalars['Boolean']>;
  /** Whether this program can be used as a template */
  isTemplate?: InputMaybe<Scalars['Boolean']>;
  scheduleUnit?: InputMaybe<LearningProgramScheduleUnitsEnum>;
  skillLevelId?: InputMaybe<LearningProgramSkillLevelValuesEnum>;
  sportId?: InputMaybe<SportsEnum>;
  thumbnailUrl?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  totalEnrollments?: InputMaybe<Scalars['Int']>;
  /** Total number of schedule periods in the program */
  totalSchedules?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type LearningProgramsSumFields = {
  __typename?: 'LearningProgramsSumFields';
  averageRating?: Maybe<Scalars['numeric']>;
  totalEnrollments?: Maybe<Scalars['Int']>;
  /** Total number of schedule periods in the program */
  totalSchedules?: Maybe<Scalars['Int']>;
};

/** update columns of table "learning_programs" */
export enum LearningProgramsUpdateColumn {
  /** column name */
  AverageRating = 'averageRating',
  /** column name */
  CoverImageUrl = 'coverImageUrl',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsPublished = 'isPublished',
  /** column name */
  IsTemplate = 'isTemplate',
  /** column name */
  ScheduleUnit = 'scheduleUnit',
  /** column name */
  SkillLevelId = 'skillLevelId',
  /** column name */
  SportId = 'sportId',
  /** column name */
  ThumbnailUrl = 'thumbnailUrl',
  /** column name */
  Title = 'title',
  /** column name */
  TotalEnrollments = 'totalEnrollments',
  /** column name */
  TotalSchedules = 'totalSchedules',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type LearningProgramsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<LearningProgramsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LearningProgramsSetInput>;
  /** filter the rows which have to be updated */
  where: LearningProgramsBoolExp;
};

/** aggregate varPop on columns */
export type LearningProgramsVarPopFields = {
  __typename?: 'LearningProgramsVarPopFields';
  averageRating?: Maybe<Scalars['Float']>;
  totalEnrollments?: Maybe<Scalars['Float']>;
  /** Total number of schedule periods in the program */
  totalSchedules?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type LearningProgramsVarSampFields = {
  __typename?: 'LearningProgramsVarSampFields';
  averageRating?: Maybe<Scalars['Float']>;
  totalEnrollments?: Maybe<Scalars['Float']>;
  /** Total number of schedule periods in the program */
  totalSchedules?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type LearningProgramsVarianceFields = {
  __typename?: 'LearningProgramsVarianceFields';
  averageRating?: Maybe<Scalars['Float']>;
  totalEnrollments?: Maybe<Scalars['Float']>;
  /** Total number of schedule periods in the program */
  totalSchedules?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "lesson_age_groups" */
export type LessonAgeGroups = {
  __typename?: 'LessonAgeGroups';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "lesson_age_groups" */
export type LessonAgeGroupsAggregate = {
  __typename?: 'LessonAgeGroupsAggregate';
  aggregate?: Maybe<LessonAgeGroupsAggregateFields>;
  nodes: Array<LessonAgeGroups>;
};

/** aggregate fields of "lesson_age_groups" */
export type LessonAgeGroupsAggregateFields = {
  __typename?: 'LessonAgeGroupsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<LessonAgeGroupsMaxFields>;
  min?: Maybe<LessonAgeGroupsMinFields>;
};


/** aggregate fields of "lesson_age_groups" */
export type LessonAgeGroupsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<LessonAgeGroupsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "lesson_age_groups". All fields are combined with a logical 'AND'. */
export type LessonAgeGroupsBoolExp = {
  _and?: InputMaybe<Array<LessonAgeGroupsBoolExp>>;
  _not?: InputMaybe<LessonAgeGroupsBoolExp>;
  _or?: InputMaybe<Array<LessonAgeGroupsBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "lesson_age_groups" */
export enum LessonAgeGroupsConstraint {
  /** unique or primary key constraint on columns "value" */
  LessonAgeGroupsPkey = 'lesson_age_groups_pkey'
}

export enum LessonAgeGroupsEnum {
  Adult = 'ADULT',
  Senior = 'SENIOR',
  Youth = 'YOUTH'
}

/** Boolean expression to compare columns of type "LessonAgeGroupsEnum". All fields are combined with logical 'AND'. */
export type LessonAgeGroupsEnumComparisonExp = {
  _eq?: InputMaybe<LessonAgeGroupsEnum>;
  _in?: InputMaybe<Array<LessonAgeGroupsEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<LessonAgeGroupsEnum>;
  _nin?: InputMaybe<Array<LessonAgeGroupsEnum>>;
};

/** input type for inserting data into table "lesson_age_groups" */
export type LessonAgeGroupsInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type LessonAgeGroupsMaxFields = {
  __typename?: 'LessonAgeGroupsMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type LessonAgeGroupsMinFields = {
  __typename?: 'LessonAgeGroupsMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "lesson_age_groups" */
export type LessonAgeGroupsMutationResponse = {
  __typename?: 'LessonAgeGroupsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LessonAgeGroups>;
};

/** on_conflict condition type for table "lesson_age_groups" */
export type LessonAgeGroupsOnConflict = {
  constraint: LessonAgeGroupsConstraint;
  updateColumns?: Array<LessonAgeGroupsUpdateColumn>;
  where?: InputMaybe<LessonAgeGroupsBoolExp>;
};

/** Ordering options when selecting data from "lesson_age_groups". */
export type LessonAgeGroupsOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: lesson_age_groups */
export type LessonAgeGroupsPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "lesson_age_groups" */
export enum LessonAgeGroupsSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "lesson_age_groups" */
export type LessonAgeGroupsSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "lesson_age_groups" */
export type LessonAgeGroupsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: LessonAgeGroupsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LessonAgeGroupsStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "lesson_age_groups" */
export enum LessonAgeGroupsUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type LessonAgeGroupsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LessonAgeGroupsSetInput>;
  /** filter the rows which have to be updated */
  where: LessonAgeGroupsBoolExp;
};

/** columns and relationships of "lesson_collections" */
export type LessonCollections = {
  __typename?: 'LessonCollections';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  /** An array relationship */
  lessons: Array<Lessons>;
  /** An aggregate relationship */
  lessonsAggregate: LessonsAggregate;
  /** An object relationship */
  owner?: Maybe<Users>;
  ownerUserId?: Maybe<Scalars['uuid']>;
  publishedAt?: Maybe<Scalars['timestamptz']>;
  recurrenceKind?: Maybe<RecurrenceKindsEnum>;
  status: LessonStatusesEnum;
  title: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "lesson_collections" */
export type LessonCollectionsLessonsArgs = {
  distinctOn?: InputMaybe<Array<LessonsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonsOrderBy>>;
  where?: InputMaybe<LessonsBoolExp>;
};


/** columns and relationships of "lesson_collections" */
export type LessonCollectionsLessonsAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonsOrderBy>>;
  where?: InputMaybe<LessonsBoolExp>;
};

/** aggregated selection of "lesson_collections" */
export type LessonCollectionsAggregate = {
  __typename?: 'LessonCollectionsAggregate';
  aggregate?: Maybe<LessonCollectionsAggregateFields>;
  nodes: Array<LessonCollections>;
};

/** aggregate fields of "lesson_collections" */
export type LessonCollectionsAggregateFields = {
  __typename?: 'LessonCollectionsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<LessonCollectionsMaxFields>;
  min?: Maybe<LessonCollectionsMinFields>;
};


/** aggregate fields of "lesson_collections" */
export type LessonCollectionsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<LessonCollectionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "lesson_collections". All fields are combined with a logical 'AND'. */
export type LessonCollectionsBoolExp = {
  _and?: InputMaybe<Array<LessonCollectionsBoolExp>>;
  _not?: InputMaybe<LessonCollectionsBoolExp>;
  _or?: InputMaybe<Array<LessonCollectionsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  lessons?: InputMaybe<LessonsBoolExp>;
  lessonsAggregate?: InputMaybe<LessonsAggregateBoolExp>;
  owner?: InputMaybe<UsersBoolExp>;
  ownerUserId?: InputMaybe<UuidComparisonExp>;
  publishedAt?: InputMaybe<TimestamptzComparisonExp>;
  recurrenceKind?: InputMaybe<RecurrenceKindsEnumComparisonExp>;
  status?: InputMaybe<LessonStatusesEnumComparisonExp>;
  title?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "lesson_collections" */
export enum LessonCollectionsConstraint {
  /** unique or primary key constraint on columns "id" */
  LessonCollectionsPkey = 'lesson_collections_pkey'
}

/** input type for inserting data into table "lesson_collections" */
export type LessonCollectionsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  lessons?: InputMaybe<LessonsArrRelInsertInput>;
  owner?: InputMaybe<UsersObjRelInsertInput>;
  ownerUserId?: InputMaybe<Scalars['uuid']>;
  publishedAt?: InputMaybe<Scalars['timestamptz']>;
  recurrenceKind?: InputMaybe<RecurrenceKindsEnum>;
  status?: InputMaybe<LessonStatusesEnum>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type LessonCollectionsMaxFields = {
  __typename?: 'LessonCollectionsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  ownerUserId?: Maybe<Scalars['uuid']>;
  publishedAt?: Maybe<Scalars['timestamptz']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type LessonCollectionsMinFields = {
  __typename?: 'LessonCollectionsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  ownerUserId?: Maybe<Scalars['uuid']>;
  publishedAt?: Maybe<Scalars['timestamptz']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "lesson_collections" */
export type LessonCollectionsMutationResponse = {
  __typename?: 'LessonCollectionsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LessonCollections>;
};

/** input type for inserting object relation for remote table "lesson_collections" */
export type LessonCollectionsObjRelInsertInput = {
  data: LessonCollectionsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<LessonCollectionsOnConflict>;
};

/** on_conflict condition type for table "lesson_collections" */
export type LessonCollectionsOnConflict = {
  constraint: LessonCollectionsConstraint;
  updateColumns?: Array<LessonCollectionsUpdateColumn>;
  where?: InputMaybe<LessonCollectionsBoolExp>;
};

/** Ordering options when selecting data from "lesson_collections". */
export type LessonCollectionsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lessonsAggregate?: InputMaybe<LessonsAggregateOrderBy>;
  owner?: InputMaybe<UsersOrderBy>;
  ownerUserId?: InputMaybe<OrderBy>;
  publishedAt?: InputMaybe<OrderBy>;
  recurrenceKind?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: lesson_collections */
export type LessonCollectionsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "lesson_collections" */
export enum LessonCollectionsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  OwnerUserId = 'ownerUserId',
  /** column name */
  PublishedAt = 'publishedAt',
  /** column name */
  RecurrenceKind = 'recurrenceKind',
  /** column name */
  Status = 'status',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "lesson_collections" */
export type LessonCollectionsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  ownerUserId?: InputMaybe<Scalars['uuid']>;
  publishedAt?: InputMaybe<Scalars['timestamptz']>;
  recurrenceKind?: InputMaybe<RecurrenceKindsEnum>;
  status?: InputMaybe<LessonStatusesEnum>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "lesson_collections" */
export type LessonCollectionsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: LessonCollectionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LessonCollectionsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  ownerUserId?: InputMaybe<Scalars['uuid']>;
  publishedAt?: InputMaybe<Scalars['timestamptz']>;
  recurrenceKind?: InputMaybe<RecurrenceKindsEnum>;
  status?: InputMaybe<LessonStatusesEnum>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "lesson_collections" */
export enum LessonCollectionsUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  OwnerUserId = 'ownerUserId',
  /** column name */
  PublishedAt = 'publishedAt',
  /** column name */
  RecurrenceKind = 'recurrenceKind',
  /** column name */
  Status = 'status',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type LessonCollectionsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LessonCollectionsSetInput>;
  /** filter the rows which have to be updated */
  where: LessonCollectionsBoolExp;
};

/** columns and relationships of "lesson_equipment" */
export type LessonEquipment = {
  __typename?: 'LessonEquipment';
  createdAt: Scalars['timestamptz'];
  customName?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  equipmentOptionId: LessonEquipmentOptionsEnum;
  id: Scalars['uuid'];
  /** An object relationship */
  lesson: Lessons;
  lessonId: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "lesson_equipment" */
export type LessonEquipmentAggregate = {
  __typename?: 'LessonEquipmentAggregate';
  aggregate?: Maybe<LessonEquipmentAggregateFields>;
  nodes: Array<LessonEquipment>;
};

export type LessonEquipmentAggregateBoolExp = {
  count?: InputMaybe<LessonEquipmentAggregateBoolExpCount>;
};

/** aggregate fields of "lesson_equipment" */
export type LessonEquipmentAggregateFields = {
  __typename?: 'LessonEquipmentAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<LessonEquipmentMaxFields>;
  min?: Maybe<LessonEquipmentMinFields>;
};


/** aggregate fields of "lesson_equipment" */
export type LessonEquipmentAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<LessonEquipmentSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "lesson_equipment" */
export type LessonEquipmentAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<LessonEquipmentMaxOrderBy>;
  min?: InputMaybe<LessonEquipmentMinOrderBy>;
};

/** input type for inserting array relation for remote table "lesson_equipment" */
export type LessonEquipmentArrRelInsertInput = {
  data: Array<LessonEquipmentInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<LessonEquipmentOnConflict>;
};

/** Boolean expression to filter rows from the table "lesson_equipment". All fields are combined with a logical 'AND'. */
export type LessonEquipmentBoolExp = {
  _and?: InputMaybe<Array<LessonEquipmentBoolExp>>;
  _not?: InputMaybe<LessonEquipmentBoolExp>;
  _or?: InputMaybe<Array<LessonEquipmentBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  customName?: InputMaybe<StringComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  equipmentOptionId?: InputMaybe<LessonEquipmentOptionsEnumComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  lesson?: InputMaybe<LessonsBoolExp>;
  lessonId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "lesson_equipment" */
export enum LessonEquipmentConstraint {
  /** unique or primary key constraint on columns "lesson_id", "equipment_option_id" */
  LessonEquipmentLessonIdEquipmentOptionIdKey = 'lesson_equipment_lesson_id_equipment_option_id_key',
  /** unique or primary key constraint on columns "id" */
  LessonEquipmentPkey = 'lesson_equipment_pkey'
}

/** input type for inserting data into table "lesson_equipment" */
export type LessonEquipmentInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  customName?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  equipmentOptionId?: InputMaybe<LessonEquipmentOptionsEnum>;
  id?: InputMaybe<Scalars['uuid']>;
  lesson?: InputMaybe<LessonsObjRelInsertInput>;
  lessonId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type LessonEquipmentMaxFields = {
  __typename?: 'LessonEquipmentMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  customName?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  lessonId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "lesson_equipment" */
export type LessonEquipmentMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  customName?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lessonId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type LessonEquipmentMinFields = {
  __typename?: 'LessonEquipmentMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  customName?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  lessonId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "lesson_equipment" */
export type LessonEquipmentMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  customName?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lessonId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "lesson_equipment" */
export type LessonEquipmentMutationResponse = {
  __typename?: 'LessonEquipmentMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LessonEquipment>;
};

/** on_conflict condition type for table "lesson_equipment" */
export type LessonEquipmentOnConflict = {
  constraint: LessonEquipmentConstraint;
  updateColumns?: Array<LessonEquipmentUpdateColumn>;
  where?: InputMaybe<LessonEquipmentBoolExp>;
};

/** columns and relationships of "lesson_equipment_options" */
export type LessonEquipmentOptions = {
  __typename?: 'LessonEquipmentOptions';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "lesson_equipment_options" */
export type LessonEquipmentOptionsAggregate = {
  __typename?: 'LessonEquipmentOptionsAggregate';
  aggregate?: Maybe<LessonEquipmentOptionsAggregateFields>;
  nodes: Array<LessonEquipmentOptions>;
};

/** aggregate fields of "lesson_equipment_options" */
export type LessonEquipmentOptionsAggregateFields = {
  __typename?: 'LessonEquipmentOptionsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<LessonEquipmentOptionsMaxFields>;
  min?: Maybe<LessonEquipmentOptionsMinFields>;
};


/** aggregate fields of "lesson_equipment_options" */
export type LessonEquipmentOptionsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<LessonEquipmentOptionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "lesson_equipment_options". All fields are combined with a logical 'AND'. */
export type LessonEquipmentOptionsBoolExp = {
  _and?: InputMaybe<Array<LessonEquipmentOptionsBoolExp>>;
  _not?: InputMaybe<LessonEquipmentOptionsBoolExp>;
  _or?: InputMaybe<Array<LessonEquipmentOptionsBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "lesson_equipment_options" */
export enum LessonEquipmentOptionsConstraint {
  /** unique or primary key constraint on columns "value" */
  LessonEquipmentOptionsPkey = 'lesson_equipment_options_pkey'
}

export enum LessonEquipmentOptionsEnum {
  CourtShoes = 'COURT_SHOES',
  HeartRateMonitor = 'HEART_RATE_MONITOR',
  Racket = 'RACKET',
  Towel = 'TOWEL',
  WaterBottle = 'WATER_BOTTLE'
}

/** Boolean expression to compare columns of type "LessonEquipmentOptionsEnum". All fields are combined with logical 'AND'. */
export type LessonEquipmentOptionsEnumComparisonExp = {
  _eq?: InputMaybe<LessonEquipmentOptionsEnum>;
  _in?: InputMaybe<Array<LessonEquipmentOptionsEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<LessonEquipmentOptionsEnum>;
  _nin?: InputMaybe<Array<LessonEquipmentOptionsEnum>>;
};

/** input type for inserting data into table "lesson_equipment_options" */
export type LessonEquipmentOptionsInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type LessonEquipmentOptionsMaxFields = {
  __typename?: 'LessonEquipmentOptionsMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type LessonEquipmentOptionsMinFields = {
  __typename?: 'LessonEquipmentOptionsMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "lesson_equipment_options" */
export type LessonEquipmentOptionsMutationResponse = {
  __typename?: 'LessonEquipmentOptionsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LessonEquipmentOptions>;
};

/** on_conflict condition type for table "lesson_equipment_options" */
export type LessonEquipmentOptionsOnConflict = {
  constraint: LessonEquipmentOptionsConstraint;
  updateColumns?: Array<LessonEquipmentOptionsUpdateColumn>;
  where?: InputMaybe<LessonEquipmentOptionsBoolExp>;
};

/** Ordering options when selecting data from "lesson_equipment_options". */
export type LessonEquipmentOptionsOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: lesson_equipment_options */
export type LessonEquipmentOptionsPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "lesson_equipment_options" */
export enum LessonEquipmentOptionsSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "lesson_equipment_options" */
export type LessonEquipmentOptionsSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "lesson_equipment_options" */
export type LessonEquipmentOptionsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: LessonEquipmentOptionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LessonEquipmentOptionsStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "lesson_equipment_options" */
export enum LessonEquipmentOptionsUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type LessonEquipmentOptionsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LessonEquipmentOptionsSetInput>;
  /** filter the rows which have to be updated */
  where: LessonEquipmentOptionsBoolExp;
};

/** Ordering options when selecting data from "lesson_equipment". */
export type LessonEquipmentOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  customName?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  equipmentOptionId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lesson?: InputMaybe<LessonsOrderBy>;
  lessonId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: lesson_equipment */
export type LessonEquipmentPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "lesson_equipment" */
export enum LessonEquipmentSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CustomName = 'customName',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EquipmentOptionId = 'equipmentOptionId',
  /** column name */
  Id = 'id',
  /** column name */
  LessonId = 'lessonId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "lesson_equipment" */
export type LessonEquipmentSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  customName?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  equipmentOptionId?: InputMaybe<LessonEquipmentOptionsEnum>;
  id?: InputMaybe<Scalars['uuid']>;
  lessonId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "lesson_equipment" */
export type LessonEquipmentStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: LessonEquipmentStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LessonEquipmentStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  customName?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  equipmentOptionId?: InputMaybe<LessonEquipmentOptionsEnum>;
  id?: InputMaybe<Scalars['uuid']>;
  lessonId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "lesson_equipment" */
export enum LessonEquipmentUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CustomName = 'customName',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EquipmentOptionId = 'equipmentOptionId',
  /** column name */
  Id = 'id',
  /** column name */
  LessonId = 'lessonId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type LessonEquipmentUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LessonEquipmentSetInput>;
  /** filter the rows which have to be updated */
  where: LessonEquipmentBoolExp;
};

/** columns and relationships of "lesson_order_items" */
export type LessonOrderItems = {
  __typename?: 'LessonOrderItems';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  lessonOrderId: Scalars['uuid'];
  /** An object relationship */
  lessonParticipant: LessonParticipants;
  lessonParticipantId: Scalars['uuid'];
  /** An object relationship */
  order: LessonOrders;
  priceUnitAmount: Scalars['Int'];
  refundUnitAmount: Scalars['Int'];
  refundedAt?: Maybe<Scalars['timestamptz']>;
  refundedByPersona?: Maybe<AppPersonasEnum>;
  status: OrderStatusesEnum;
  totalUnitAmount: Scalars['Int'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "lesson_order_items" */
export type LessonOrderItemsAggregate = {
  __typename?: 'LessonOrderItemsAggregate';
  aggregate?: Maybe<LessonOrderItemsAggregateFields>;
  nodes: Array<LessonOrderItems>;
};

export type LessonOrderItemsAggregateBoolExp = {
  count?: InputMaybe<LessonOrderItemsAggregateBoolExpCount>;
};

/** aggregate fields of "lesson_order_items" */
export type LessonOrderItemsAggregateFields = {
  __typename?: 'LessonOrderItemsAggregateFields';
  avg?: Maybe<LessonOrderItemsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<LessonOrderItemsMaxFields>;
  min?: Maybe<LessonOrderItemsMinFields>;
  stddev?: Maybe<LessonOrderItemsStddevFields>;
  stddevPop?: Maybe<LessonOrderItemsStddevPopFields>;
  stddevSamp?: Maybe<LessonOrderItemsStddevSampFields>;
  sum?: Maybe<LessonOrderItemsSumFields>;
  varPop?: Maybe<LessonOrderItemsVarPopFields>;
  varSamp?: Maybe<LessonOrderItemsVarSampFields>;
  variance?: Maybe<LessonOrderItemsVarianceFields>;
};


/** aggregate fields of "lesson_order_items" */
export type LessonOrderItemsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<LessonOrderItemsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "lesson_order_items" */
export type LessonOrderItemsAggregateOrderBy = {
  avg?: InputMaybe<LessonOrderItemsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<LessonOrderItemsMaxOrderBy>;
  min?: InputMaybe<LessonOrderItemsMinOrderBy>;
  stddev?: InputMaybe<LessonOrderItemsStddevOrderBy>;
  stddevPop?: InputMaybe<LessonOrderItemsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<LessonOrderItemsStddevSampOrderBy>;
  sum?: InputMaybe<LessonOrderItemsSumOrderBy>;
  varPop?: InputMaybe<LessonOrderItemsVarPopOrderBy>;
  varSamp?: InputMaybe<LessonOrderItemsVarSampOrderBy>;
  variance?: InputMaybe<LessonOrderItemsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "lesson_order_items" */
export type LessonOrderItemsArrRelInsertInput = {
  data: Array<LessonOrderItemsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<LessonOrderItemsOnConflict>;
};

/** aggregate avg on columns */
export type LessonOrderItemsAvgFields = {
  __typename?: 'LessonOrderItemsAvgFields';
  priceUnitAmount?: Maybe<Scalars['Float']>;
  refundUnitAmount?: Maybe<Scalars['Float']>;
  totalUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "lesson_order_items" */
export type LessonOrderItemsAvgOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  totalUnitAmount?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "lesson_order_items". All fields are combined with a logical 'AND'. */
export type LessonOrderItemsBoolExp = {
  _and?: InputMaybe<Array<LessonOrderItemsBoolExp>>;
  _not?: InputMaybe<LessonOrderItemsBoolExp>;
  _or?: InputMaybe<Array<LessonOrderItemsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  lessonOrderId?: InputMaybe<UuidComparisonExp>;
  lessonParticipant?: InputMaybe<LessonParticipantsBoolExp>;
  lessonParticipantId?: InputMaybe<UuidComparisonExp>;
  order?: InputMaybe<LessonOrdersBoolExp>;
  priceUnitAmount?: InputMaybe<IntComparisonExp>;
  refundUnitAmount?: InputMaybe<IntComparisonExp>;
  refundedAt?: InputMaybe<TimestamptzComparisonExp>;
  refundedByPersona?: InputMaybe<AppPersonasEnumComparisonExp>;
  status?: InputMaybe<OrderStatusesEnumComparisonExp>;
  totalUnitAmount?: InputMaybe<IntComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "lesson_order_items" */
export enum LessonOrderItemsConstraint {
  /** unique or primary key constraint on columns "id" */
  LessonOrderItemsPkey = 'lesson_order_items_pkey'
}

/** input type for incrementing numeric columns in table "lesson_order_items" */
export type LessonOrderItemsIncInput = {
  priceUnitAmount?: InputMaybe<Scalars['Int']>;
  refundUnitAmount?: InputMaybe<Scalars['Int']>;
  totalUnitAmount?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "lesson_order_items" */
export type LessonOrderItemsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  lessonOrderId?: InputMaybe<Scalars['uuid']>;
  lessonParticipant?: InputMaybe<LessonParticipantsObjRelInsertInput>;
  lessonParticipantId?: InputMaybe<Scalars['uuid']>;
  order?: InputMaybe<LessonOrdersObjRelInsertInput>;
  priceUnitAmount?: InputMaybe<Scalars['Int']>;
  refundUnitAmount?: InputMaybe<Scalars['Int']>;
  refundedAt?: InputMaybe<Scalars['timestamptz']>;
  refundedByPersona?: InputMaybe<AppPersonasEnum>;
  status?: InputMaybe<OrderStatusesEnum>;
  totalUnitAmount?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type LessonOrderItemsMaxFields = {
  __typename?: 'LessonOrderItemsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  lessonOrderId?: Maybe<Scalars['uuid']>;
  lessonParticipantId?: Maybe<Scalars['uuid']>;
  priceUnitAmount?: Maybe<Scalars['Int']>;
  refundUnitAmount?: Maybe<Scalars['Int']>;
  refundedAt?: Maybe<Scalars['timestamptz']>;
  totalUnitAmount?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "lesson_order_items" */
export type LessonOrderItemsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lessonOrderId?: InputMaybe<OrderBy>;
  lessonParticipantId?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  refundedAt?: InputMaybe<OrderBy>;
  totalUnitAmount?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type LessonOrderItemsMinFields = {
  __typename?: 'LessonOrderItemsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  lessonOrderId?: Maybe<Scalars['uuid']>;
  lessonParticipantId?: Maybe<Scalars['uuid']>;
  priceUnitAmount?: Maybe<Scalars['Int']>;
  refundUnitAmount?: Maybe<Scalars['Int']>;
  refundedAt?: Maybe<Scalars['timestamptz']>;
  totalUnitAmount?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "lesson_order_items" */
export type LessonOrderItemsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lessonOrderId?: InputMaybe<OrderBy>;
  lessonParticipantId?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  refundedAt?: InputMaybe<OrderBy>;
  totalUnitAmount?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "lesson_order_items" */
export type LessonOrderItemsMutationResponse = {
  __typename?: 'LessonOrderItemsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LessonOrderItems>;
};

/** on_conflict condition type for table "lesson_order_items" */
export type LessonOrderItemsOnConflict = {
  constraint: LessonOrderItemsConstraint;
  updateColumns?: Array<LessonOrderItemsUpdateColumn>;
  where?: InputMaybe<LessonOrderItemsBoolExp>;
};

/** Ordering options when selecting data from "lesson_order_items". */
export type LessonOrderItemsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lessonOrderId?: InputMaybe<OrderBy>;
  lessonParticipant?: InputMaybe<LessonParticipantsOrderBy>;
  lessonParticipantId?: InputMaybe<OrderBy>;
  order?: InputMaybe<LessonOrdersOrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  refundedAt?: InputMaybe<OrderBy>;
  refundedByPersona?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  totalUnitAmount?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: lesson_order_items */
export type LessonOrderItemsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "lesson_order_items" */
export enum LessonOrderItemsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  LessonOrderId = 'lessonOrderId',
  /** column name */
  LessonParticipantId = 'lessonParticipantId',
  /** column name */
  PriceUnitAmount = 'priceUnitAmount',
  /** column name */
  RefundUnitAmount = 'refundUnitAmount',
  /** column name */
  RefundedAt = 'refundedAt',
  /** column name */
  RefundedByPersona = 'refundedByPersona',
  /** column name */
  Status = 'status',
  /** column name */
  TotalUnitAmount = 'totalUnitAmount',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "lesson_order_items" */
export type LessonOrderItemsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  lessonOrderId?: InputMaybe<Scalars['uuid']>;
  lessonParticipantId?: InputMaybe<Scalars['uuid']>;
  priceUnitAmount?: InputMaybe<Scalars['Int']>;
  refundUnitAmount?: InputMaybe<Scalars['Int']>;
  refundedAt?: InputMaybe<Scalars['timestamptz']>;
  refundedByPersona?: InputMaybe<AppPersonasEnum>;
  status?: InputMaybe<OrderStatusesEnum>;
  totalUnitAmount?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type LessonOrderItemsStddevFields = {
  __typename?: 'LessonOrderItemsStddevFields';
  priceUnitAmount?: Maybe<Scalars['Float']>;
  refundUnitAmount?: Maybe<Scalars['Float']>;
  totalUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "lesson_order_items" */
export type LessonOrderItemsStddevOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  totalUnitAmount?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type LessonOrderItemsStddevPopFields = {
  __typename?: 'LessonOrderItemsStddevPopFields';
  priceUnitAmount?: Maybe<Scalars['Float']>;
  refundUnitAmount?: Maybe<Scalars['Float']>;
  totalUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "lesson_order_items" */
export type LessonOrderItemsStddevPopOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  totalUnitAmount?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type LessonOrderItemsStddevSampFields = {
  __typename?: 'LessonOrderItemsStddevSampFields';
  priceUnitAmount?: Maybe<Scalars['Float']>;
  refundUnitAmount?: Maybe<Scalars['Float']>;
  totalUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "lesson_order_items" */
export type LessonOrderItemsStddevSampOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  totalUnitAmount?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "lesson_order_items" */
export type LessonOrderItemsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: LessonOrderItemsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LessonOrderItemsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  lessonOrderId?: InputMaybe<Scalars['uuid']>;
  lessonParticipantId?: InputMaybe<Scalars['uuid']>;
  priceUnitAmount?: InputMaybe<Scalars['Int']>;
  refundUnitAmount?: InputMaybe<Scalars['Int']>;
  refundedAt?: InputMaybe<Scalars['timestamptz']>;
  refundedByPersona?: InputMaybe<AppPersonasEnum>;
  status?: InputMaybe<OrderStatusesEnum>;
  totalUnitAmount?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type LessonOrderItemsSumFields = {
  __typename?: 'LessonOrderItemsSumFields';
  priceUnitAmount?: Maybe<Scalars['Int']>;
  refundUnitAmount?: Maybe<Scalars['Int']>;
  totalUnitAmount?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "lesson_order_items" */
export type LessonOrderItemsSumOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  totalUnitAmount?: InputMaybe<OrderBy>;
};

/** update columns of table "lesson_order_items" */
export enum LessonOrderItemsUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  LessonOrderId = 'lessonOrderId',
  /** column name */
  LessonParticipantId = 'lessonParticipantId',
  /** column name */
  PriceUnitAmount = 'priceUnitAmount',
  /** column name */
  RefundUnitAmount = 'refundUnitAmount',
  /** column name */
  RefundedAt = 'refundedAt',
  /** column name */
  RefundedByPersona = 'refundedByPersona',
  /** column name */
  Status = 'status',
  /** column name */
  TotalUnitAmount = 'totalUnitAmount',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type LessonOrderItemsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<LessonOrderItemsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LessonOrderItemsSetInput>;
  /** filter the rows which have to be updated */
  where: LessonOrderItemsBoolExp;
};

/** aggregate varPop on columns */
export type LessonOrderItemsVarPopFields = {
  __typename?: 'LessonOrderItemsVarPopFields';
  priceUnitAmount?: Maybe<Scalars['Float']>;
  refundUnitAmount?: Maybe<Scalars['Float']>;
  totalUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "lesson_order_items" */
export type LessonOrderItemsVarPopOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  totalUnitAmount?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type LessonOrderItemsVarSampFields = {
  __typename?: 'LessonOrderItemsVarSampFields';
  priceUnitAmount?: Maybe<Scalars['Float']>;
  refundUnitAmount?: Maybe<Scalars['Float']>;
  totalUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "lesson_order_items" */
export type LessonOrderItemsVarSampOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  totalUnitAmount?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type LessonOrderItemsVarianceFields = {
  __typename?: 'LessonOrderItemsVarianceFields';
  priceUnitAmount?: Maybe<Scalars['Float']>;
  refundUnitAmount?: Maybe<Scalars['Float']>;
  totalUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "lesson_order_items" */
export type LessonOrderItemsVarianceOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  totalUnitAmount?: InputMaybe<OrderBy>;
};

/** columns and relationships of "lesson_orders" */
export type LessonOrders = {
  __typename?: 'LessonOrders';
  applicationFeeTotalUnitAmount: Scalars['Int'];
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  creditCard?: Maybe<UserCreditCards>;
  /** An object relationship */
  customer: Users;
  customerApplicationFeeUnitAmount: Scalars['Int'];
  /** An object relationship */
  customerProfile?: Maybe<UserProfiles>;
  customerUserId: Scalars['uuid'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  externalStripePaymentIntentId: Scalars['String'];
  id: Scalars['uuid'];
  internalStripePaymentIntentId: Scalars['uuid'];
  /** An array relationship */
  items: Array<LessonOrderItems>;
  /** An aggregate relationship */
  itemsAggregate: LessonOrderItemsAggregate;
  lessonId?: Maybe<Scalars['uuid']>;
  /** The sum of the items in the order. This doesn't include any discounts or fees. */
  orderSubtotalUnitAmount: Scalars['Int'];
  /** The total after fees and discounts. Note that the coaches fee is not added in. This is only what the player pays. The coaches fee is subtracted from their payout. */
  orderTotalUnitAmount: Scalars['Int'];
  paidUnitAmount: Scalars['Int'];
  /** An object relationship */
  paymentIntentExternal: StripePaymentIntents;
  /** An object relationship */
  paymentIntentInternal: StripePaymentIntents;
  paymentProcessor: PaymentProcessorsEnum;
  refundUnitAmount: Scalars['Int'];
  refundedAt?: Maybe<Scalars['timestamptz']>;
  refundedByPersona?: Maybe<AppPersonasEnum>;
  /** An object relationship */
  seller: Users;
  sellerApplicationFeeUnitAmount: Scalars['Int'];
  /** An object relationship */
  sellerProfile?: Maybe<UserProfiles>;
  sellerUserId: Scalars['uuid'];
  status: OrderStatusesEnum;
  stripeCustomerId: Scalars['String'];
  stripeMerchantId: Scalars['String'];
  stripePaymentStatus: Scalars['String'];
  /** The amount transferred to the coach as a payout. It is the price of the lesson minus the coaches fee. */
  transferUnitAmount: Scalars['Int'];
  updatedAt: Scalars['timestamptz'];
  userCreditCardId?: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "lesson_orders" */
export type LessonOrdersItemsArgs = {
  distinctOn?: InputMaybe<Array<LessonOrderItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonOrderItemsOrderBy>>;
  where?: InputMaybe<LessonOrderItemsBoolExp>;
};


/** columns and relationships of "lesson_orders" */
export type LessonOrdersItemsAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonOrderItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonOrderItemsOrderBy>>;
  where?: InputMaybe<LessonOrderItemsBoolExp>;
};

/** aggregated selection of "lesson_orders" */
export type LessonOrdersAggregate = {
  __typename?: 'LessonOrdersAggregate';
  aggregate?: Maybe<LessonOrdersAggregateFields>;
  nodes: Array<LessonOrders>;
};

export type LessonOrdersAggregateBoolExp = {
  count?: InputMaybe<LessonOrdersAggregateBoolExpCount>;
};

/** aggregate fields of "lesson_orders" */
export type LessonOrdersAggregateFields = {
  __typename?: 'LessonOrdersAggregateFields';
  avg?: Maybe<LessonOrdersAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<LessonOrdersMaxFields>;
  min?: Maybe<LessonOrdersMinFields>;
  stddev?: Maybe<LessonOrdersStddevFields>;
  stddevPop?: Maybe<LessonOrdersStddevPopFields>;
  stddevSamp?: Maybe<LessonOrdersStddevSampFields>;
  sum?: Maybe<LessonOrdersSumFields>;
  varPop?: Maybe<LessonOrdersVarPopFields>;
  varSamp?: Maybe<LessonOrdersVarSampFields>;
  variance?: Maybe<LessonOrdersVarianceFields>;
};


/** aggregate fields of "lesson_orders" */
export type LessonOrdersAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<LessonOrdersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "lesson_orders" */
export type LessonOrdersAggregateOrderBy = {
  avg?: InputMaybe<LessonOrdersAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<LessonOrdersMaxOrderBy>;
  min?: InputMaybe<LessonOrdersMinOrderBy>;
  stddev?: InputMaybe<LessonOrdersStddevOrderBy>;
  stddevPop?: InputMaybe<LessonOrdersStddevPopOrderBy>;
  stddevSamp?: InputMaybe<LessonOrdersStddevSampOrderBy>;
  sum?: InputMaybe<LessonOrdersSumOrderBy>;
  varPop?: InputMaybe<LessonOrdersVarPopOrderBy>;
  varSamp?: InputMaybe<LessonOrdersVarSampOrderBy>;
  variance?: InputMaybe<LessonOrdersVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "lesson_orders" */
export type LessonOrdersArrRelInsertInput = {
  data: Array<LessonOrdersInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<LessonOrdersOnConflict>;
};

/** aggregate avg on columns */
export type LessonOrdersAvgFields = {
  __typename?: 'LessonOrdersAvgFields';
  applicationFeeTotalUnitAmount?: Maybe<Scalars['Float']>;
  customerApplicationFeeUnitAmount?: Maybe<Scalars['Float']>;
  /** The sum of the items in the order. This doesn't include any discounts or fees. */
  orderSubtotalUnitAmount?: Maybe<Scalars['Float']>;
  /** The total after fees and discounts. Note that the coaches fee is not added in. This is only what the player pays. The coaches fee is subtracted from their payout. */
  orderTotalUnitAmount?: Maybe<Scalars['Float']>;
  paidUnitAmount?: Maybe<Scalars['Float']>;
  refundUnitAmount?: Maybe<Scalars['Float']>;
  sellerApplicationFeeUnitAmount?: Maybe<Scalars['Float']>;
  /** The amount transferred to the coach as a payout. It is the price of the lesson minus the coaches fee. */
  transferUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "lesson_orders" */
export type LessonOrdersAvgOrderBy = {
  applicationFeeTotalUnitAmount?: InputMaybe<OrderBy>;
  customerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  /** The sum of the items in the order. This doesn't include any discounts or fees. */
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  /** The total after fees and discounts. Note that the coaches fee is not added in. This is only what the player pays. The coaches fee is subtracted from their payout. */
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  sellerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  /** The amount transferred to the coach as a payout. It is the price of the lesson minus the coaches fee. */
  transferUnitAmount?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "lesson_orders". All fields are combined with a logical 'AND'. */
export type LessonOrdersBoolExp = {
  _and?: InputMaybe<Array<LessonOrdersBoolExp>>;
  _not?: InputMaybe<LessonOrdersBoolExp>;
  _or?: InputMaybe<Array<LessonOrdersBoolExp>>;
  applicationFeeTotalUnitAmount?: InputMaybe<IntComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  creditCard?: InputMaybe<UserCreditCardsBoolExp>;
  customer?: InputMaybe<UsersBoolExp>;
  customerApplicationFeeUnitAmount?: InputMaybe<IntComparisonExp>;
  customerProfile?: InputMaybe<UserProfilesBoolExp>;
  customerUserId?: InputMaybe<UuidComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  externalStripePaymentIntentId?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  internalStripePaymentIntentId?: InputMaybe<UuidComparisonExp>;
  items?: InputMaybe<LessonOrderItemsBoolExp>;
  itemsAggregate?: InputMaybe<LessonOrderItemsAggregateBoolExp>;
  lessonId?: InputMaybe<UuidComparisonExp>;
  orderSubtotalUnitAmount?: InputMaybe<IntComparisonExp>;
  orderTotalUnitAmount?: InputMaybe<IntComparisonExp>;
  paidUnitAmount?: InputMaybe<IntComparisonExp>;
  paymentIntentExternal?: InputMaybe<StripePaymentIntentsBoolExp>;
  paymentIntentInternal?: InputMaybe<StripePaymentIntentsBoolExp>;
  paymentProcessor?: InputMaybe<PaymentProcessorsEnumComparisonExp>;
  refundUnitAmount?: InputMaybe<IntComparisonExp>;
  refundedAt?: InputMaybe<TimestamptzComparisonExp>;
  refundedByPersona?: InputMaybe<AppPersonasEnumComparisonExp>;
  seller?: InputMaybe<UsersBoolExp>;
  sellerApplicationFeeUnitAmount?: InputMaybe<IntComparisonExp>;
  sellerProfile?: InputMaybe<UserProfilesBoolExp>;
  sellerUserId?: InputMaybe<UuidComparisonExp>;
  status?: InputMaybe<OrderStatusesEnumComparisonExp>;
  stripeCustomerId?: InputMaybe<StringComparisonExp>;
  stripeMerchantId?: InputMaybe<StringComparisonExp>;
  stripePaymentStatus?: InputMaybe<StringComparisonExp>;
  transferUnitAmount?: InputMaybe<IntComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  userCreditCardId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "lesson_orders" */
export enum LessonOrdersConstraint {
  /** unique or primary key constraint on columns "external_stripe_payment_intent_id" */
  LessonOrdersExternalStripePaymentIntentIdKey = 'lesson_orders_external_stripe_payment_intent_id_key',
  /** unique or primary key constraint on columns "internal_stripe_payment_intent_id" */
  LessonOrdersInternalStripePaymentIntentIdKey = 'lesson_orders_internal_stripe_payment_intent_id_key',
  /** unique or primary key constraint on columns "id" */
  LessonOrdersPkey = 'lesson_orders_pkey'
}

/** input type for incrementing numeric columns in table "lesson_orders" */
export type LessonOrdersIncInput = {
  applicationFeeTotalUnitAmount?: InputMaybe<Scalars['Int']>;
  customerApplicationFeeUnitAmount?: InputMaybe<Scalars['Int']>;
  /** The sum of the items in the order. This doesn't include any discounts or fees. */
  orderSubtotalUnitAmount?: InputMaybe<Scalars['Int']>;
  /** The total after fees and discounts. Note that the coaches fee is not added in. This is only what the player pays. The coaches fee is subtracted from their payout. */
  orderTotalUnitAmount?: InputMaybe<Scalars['Int']>;
  paidUnitAmount?: InputMaybe<Scalars['Int']>;
  refundUnitAmount?: InputMaybe<Scalars['Int']>;
  sellerApplicationFeeUnitAmount?: InputMaybe<Scalars['Int']>;
  /** The amount transferred to the coach as a payout. It is the price of the lesson minus the coaches fee. */
  transferUnitAmount?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "lesson_orders" */
export type LessonOrdersInsertInput = {
  applicationFeeTotalUnitAmount?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  creditCard?: InputMaybe<UserCreditCardsObjRelInsertInput>;
  customer?: InputMaybe<UsersObjRelInsertInput>;
  customerApplicationFeeUnitAmount?: InputMaybe<Scalars['Int']>;
  customerProfile?: InputMaybe<UserProfilesObjRelInsertInput>;
  customerUserId?: InputMaybe<Scalars['uuid']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  externalStripePaymentIntentId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  internalStripePaymentIntentId?: InputMaybe<Scalars['uuid']>;
  items?: InputMaybe<LessonOrderItemsArrRelInsertInput>;
  lessonId?: InputMaybe<Scalars['uuid']>;
  /** The sum of the items in the order. This doesn't include any discounts or fees. */
  orderSubtotalUnitAmount?: InputMaybe<Scalars['Int']>;
  /** The total after fees and discounts. Note that the coaches fee is not added in. This is only what the player pays. The coaches fee is subtracted from their payout. */
  orderTotalUnitAmount?: InputMaybe<Scalars['Int']>;
  paidUnitAmount?: InputMaybe<Scalars['Int']>;
  paymentIntentExternal?: InputMaybe<StripePaymentIntentsObjRelInsertInput>;
  paymentIntentInternal?: InputMaybe<StripePaymentIntentsObjRelInsertInput>;
  paymentProcessor?: InputMaybe<PaymentProcessorsEnum>;
  refundUnitAmount?: InputMaybe<Scalars['Int']>;
  refundedAt?: InputMaybe<Scalars['timestamptz']>;
  refundedByPersona?: InputMaybe<AppPersonasEnum>;
  seller?: InputMaybe<UsersObjRelInsertInput>;
  sellerApplicationFeeUnitAmount?: InputMaybe<Scalars['Int']>;
  sellerProfile?: InputMaybe<UserProfilesObjRelInsertInput>;
  sellerUserId?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<OrderStatusesEnum>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  stripeMerchantId?: InputMaybe<Scalars['String']>;
  stripePaymentStatus?: InputMaybe<Scalars['String']>;
  /** The amount transferred to the coach as a payout. It is the price of the lesson minus the coaches fee. */
  transferUnitAmount?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userCreditCardId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type LessonOrdersMaxFields = {
  __typename?: 'LessonOrdersMaxFields';
  applicationFeeTotalUnitAmount?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  customerApplicationFeeUnitAmount?: Maybe<Scalars['Int']>;
  customerUserId?: Maybe<Scalars['uuid']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  externalStripePaymentIntentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  internalStripePaymentIntentId?: Maybe<Scalars['uuid']>;
  lessonId?: Maybe<Scalars['uuid']>;
  /** The sum of the items in the order. This doesn't include any discounts or fees. */
  orderSubtotalUnitAmount?: Maybe<Scalars['Int']>;
  /** The total after fees and discounts. Note that the coaches fee is not added in. This is only what the player pays. The coaches fee is subtracted from their payout. */
  orderTotalUnitAmount?: Maybe<Scalars['Int']>;
  paidUnitAmount?: Maybe<Scalars['Int']>;
  refundUnitAmount?: Maybe<Scalars['Int']>;
  refundedAt?: Maybe<Scalars['timestamptz']>;
  sellerApplicationFeeUnitAmount?: Maybe<Scalars['Int']>;
  sellerUserId?: Maybe<Scalars['uuid']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripeMerchantId?: Maybe<Scalars['String']>;
  stripePaymentStatus?: Maybe<Scalars['String']>;
  /** The amount transferred to the coach as a payout. It is the price of the lesson minus the coaches fee. */
  transferUnitAmount?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userCreditCardId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "lesson_orders" */
export type LessonOrdersMaxOrderBy = {
  applicationFeeTotalUnitAmount?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  customerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  customerUserId?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  externalStripePaymentIntentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  internalStripePaymentIntentId?: InputMaybe<OrderBy>;
  lessonId?: InputMaybe<OrderBy>;
  /** The sum of the items in the order. This doesn't include any discounts or fees. */
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  /** The total after fees and discounts. Note that the coaches fee is not added in. This is only what the player pays. The coaches fee is subtracted from their payout. */
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  refundedAt?: InputMaybe<OrderBy>;
  sellerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  sellerUserId?: InputMaybe<OrderBy>;
  stripeCustomerId?: InputMaybe<OrderBy>;
  stripeMerchantId?: InputMaybe<OrderBy>;
  stripePaymentStatus?: InputMaybe<OrderBy>;
  /** The amount transferred to the coach as a payout. It is the price of the lesson minus the coaches fee. */
  transferUnitAmount?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userCreditCardId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type LessonOrdersMinFields = {
  __typename?: 'LessonOrdersMinFields';
  applicationFeeTotalUnitAmount?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  customerApplicationFeeUnitAmount?: Maybe<Scalars['Int']>;
  customerUserId?: Maybe<Scalars['uuid']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  externalStripePaymentIntentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  internalStripePaymentIntentId?: Maybe<Scalars['uuid']>;
  lessonId?: Maybe<Scalars['uuid']>;
  /** The sum of the items in the order. This doesn't include any discounts or fees. */
  orderSubtotalUnitAmount?: Maybe<Scalars['Int']>;
  /** The total after fees and discounts. Note that the coaches fee is not added in. This is only what the player pays. The coaches fee is subtracted from their payout. */
  orderTotalUnitAmount?: Maybe<Scalars['Int']>;
  paidUnitAmount?: Maybe<Scalars['Int']>;
  refundUnitAmount?: Maybe<Scalars['Int']>;
  refundedAt?: Maybe<Scalars['timestamptz']>;
  sellerApplicationFeeUnitAmount?: Maybe<Scalars['Int']>;
  sellerUserId?: Maybe<Scalars['uuid']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripeMerchantId?: Maybe<Scalars['String']>;
  stripePaymentStatus?: Maybe<Scalars['String']>;
  /** The amount transferred to the coach as a payout. It is the price of the lesson minus the coaches fee. */
  transferUnitAmount?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userCreditCardId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "lesson_orders" */
export type LessonOrdersMinOrderBy = {
  applicationFeeTotalUnitAmount?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  customerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  customerUserId?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  externalStripePaymentIntentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  internalStripePaymentIntentId?: InputMaybe<OrderBy>;
  lessonId?: InputMaybe<OrderBy>;
  /** The sum of the items in the order. This doesn't include any discounts or fees. */
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  /** The total after fees and discounts. Note that the coaches fee is not added in. This is only what the player pays. The coaches fee is subtracted from their payout. */
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  refundedAt?: InputMaybe<OrderBy>;
  sellerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  sellerUserId?: InputMaybe<OrderBy>;
  stripeCustomerId?: InputMaybe<OrderBy>;
  stripeMerchantId?: InputMaybe<OrderBy>;
  stripePaymentStatus?: InputMaybe<OrderBy>;
  /** The amount transferred to the coach as a payout. It is the price of the lesson minus the coaches fee. */
  transferUnitAmount?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userCreditCardId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "lesson_orders" */
export type LessonOrdersMutationResponse = {
  __typename?: 'LessonOrdersMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LessonOrders>;
};

/** input type for inserting object relation for remote table "lesson_orders" */
export type LessonOrdersObjRelInsertInput = {
  data: LessonOrdersInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<LessonOrdersOnConflict>;
};

/** on_conflict condition type for table "lesson_orders" */
export type LessonOrdersOnConflict = {
  constraint: LessonOrdersConstraint;
  updateColumns?: Array<LessonOrdersUpdateColumn>;
  where?: InputMaybe<LessonOrdersBoolExp>;
};

/** Ordering options when selecting data from "lesson_orders". */
export type LessonOrdersOrderBy = {
  applicationFeeTotalUnitAmount?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  creditCard?: InputMaybe<UserCreditCardsOrderBy>;
  customer?: InputMaybe<UsersOrderBy>;
  customerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  customerProfile?: InputMaybe<UserProfilesOrderBy>;
  customerUserId?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  externalStripePaymentIntentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  internalStripePaymentIntentId?: InputMaybe<OrderBy>;
  itemsAggregate?: InputMaybe<LessonOrderItemsAggregateOrderBy>;
  lessonId?: InputMaybe<OrderBy>;
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  paymentIntentExternal?: InputMaybe<StripePaymentIntentsOrderBy>;
  paymentIntentInternal?: InputMaybe<StripePaymentIntentsOrderBy>;
  paymentProcessor?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  refundedAt?: InputMaybe<OrderBy>;
  refundedByPersona?: InputMaybe<OrderBy>;
  seller?: InputMaybe<UsersOrderBy>;
  sellerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  sellerProfile?: InputMaybe<UserProfilesOrderBy>;
  sellerUserId?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  stripeCustomerId?: InputMaybe<OrderBy>;
  stripeMerchantId?: InputMaybe<OrderBy>;
  stripePaymentStatus?: InputMaybe<OrderBy>;
  transferUnitAmount?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userCreditCardId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: lesson_orders */
export type LessonOrdersPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "lesson_orders" */
export enum LessonOrdersSelectColumn {
  /** column name */
  ApplicationFeeTotalUnitAmount = 'applicationFeeTotalUnitAmount',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CustomerApplicationFeeUnitAmount = 'customerApplicationFeeUnitAmount',
  /** column name */
  CustomerUserId = 'customerUserId',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  ExternalStripePaymentIntentId = 'externalStripePaymentIntentId',
  /** column name */
  Id = 'id',
  /** column name */
  InternalStripePaymentIntentId = 'internalStripePaymentIntentId',
  /** column name */
  LessonId = 'lessonId',
  /** column name */
  OrderSubtotalUnitAmount = 'orderSubtotalUnitAmount',
  /** column name */
  OrderTotalUnitAmount = 'orderTotalUnitAmount',
  /** column name */
  PaidUnitAmount = 'paidUnitAmount',
  /** column name */
  PaymentProcessor = 'paymentProcessor',
  /** column name */
  RefundUnitAmount = 'refundUnitAmount',
  /** column name */
  RefundedAt = 'refundedAt',
  /** column name */
  RefundedByPersona = 'refundedByPersona',
  /** column name */
  SellerApplicationFeeUnitAmount = 'sellerApplicationFeeUnitAmount',
  /** column name */
  SellerUserId = 'sellerUserId',
  /** column name */
  Status = 'status',
  /** column name */
  StripeCustomerId = 'stripeCustomerId',
  /** column name */
  StripeMerchantId = 'stripeMerchantId',
  /** column name */
  StripePaymentStatus = 'stripePaymentStatus',
  /** column name */
  TransferUnitAmount = 'transferUnitAmount',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserCreditCardId = 'userCreditCardId'
}

/** input type for updating data in table "lesson_orders" */
export type LessonOrdersSetInput = {
  applicationFeeTotalUnitAmount?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  customerApplicationFeeUnitAmount?: InputMaybe<Scalars['Int']>;
  customerUserId?: InputMaybe<Scalars['uuid']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  externalStripePaymentIntentId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  internalStripePaymentIntentId?: InputMaybe<Scalars['uuid']>;
  lessonId?: InputMaybe<Scalars['uuid']>;
  /** The sum of the items in the order. This doesn't include any discounts or fees. */
  orderSubtotalUnitAmount?: InputMaybe<Scalars['Int']>;
  /** The total after fees and discounts. Note that the coaches fee is not added in. This is only what the player pays. The coaches fee is subtracted from their payout. */
  orderTotalUnitAmount?: InputMaybe<Scalars['Int']>;
  paidUnitAmount?: InputMaybe<Scalars['Int']>;
  paymentProcessor?: InputMaybe<PaymentProcessorsEnum>;
  refundUnitAmount?: InputMaybe<Scalars['Int']>;
  refundedAt?: InputMaybe<Scalars['timestamptz']>;
  refundedByPersona?: InputMaybe<AppPersonasEnum>;
  sellerApplicationFeeUnitAmount?: InputMaybe<Scalars['Int']>;
  sellerUserId?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<OrderStatusesEnum>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  stripeMerchantId?: InputMaybe<Scalars['String']>;
  stripePaymentStatus?: InputMaybe<Scalars['String']>;
  /** The amount transferred to the coach as a payout. It is the price of the lesson minus the coaches fee. */
  transferUnitAmount?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userCreditCardId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type LessonOrdersStddevFields = {
  __typename?: 'LessonOrdersStddevFields';
  applicationFeeTotalUnitAmount?: Maybe<Scalars['Float']>;
  customerApplicationFeeUnitAmount?: Maybe<Scalars['Float']>;
  /** The sum of the items in the order. This doesn't include any discounts or fees. */
  orderSubtotalUnitAmount?: Maybe<Scalars['Float']>;
  /** The total after fees and discounts. Note that the coaches fee is not added in. This is only what the player pays. The coaches fee is subtracted from their payout. */
  orderTotalUnitAmount?: Maybe<Scalars['Float']>;
  paidUnitAmount?: Maybe<Scalars['Float']>;
  refundUnitAmount?: Maybe<Scalars['Float']>;
  sellerApplicationFeeUnitAmount?: Maybe<Scalars['Float']>;
  /** The amount transferred to the coach as a payout. It is the price of the lesson minus the coaches fee. */
  transferUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "lesson_orders" */
export type LessonOrdersStddevOrderBy = {
  applicationFeeTotalUnitAmount?: InputMaybe<OrderBy>;
  customerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  /** The sum of the items in the order. This doesn't include any discounts or fees. */
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  /** The total after fees and discounts. Note that the coaches fee is not added in. This is only what the player pays. The coaches fee is subtracted from their payout. */
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  sellerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  /** The amount transferred to the coach as a payout. It is the price of the lesson minus the coaches fee. */
  transferUnitAmount?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type LessonOrdersStddevPopFields = {
  __typename?: 'LessonOrdersStddevPopFields';
  applicationFeeTotalUnitAmount?: Maybe<Scalars['Float']>;
  customerApplicationFeeUnitAmount?: Maybe<Scalars['Float']>;
  /** The sum of the items in the order. This doesn't include any discounts or fees. */
  orderSubtotalUnitAmount?: Maybe<Scalars['Float']>;
  /** The total after fees and discounts. Note that the coaches fee is not added in. This is only what the player pays. The coaches fee is subtracted from their payout. */
  orderTotalUnitAmount?: Maybe<Scalars['Float']>;
  paidUnitAmount?: Maybe<Scalars['Float']>;
  refundUnitAmount?: Maybe<Scalars['Float']>;
  sellerApplicationFeeUnitAmount?: Maybe<Scalars['Float']>;
  /** The amount transferred to the coach as a payout. It is the price of the lesson minus the coaches fee. */
  transferUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "lesson_orders" */
export type LessonOrdersStddevPopOrderBy = {
  applicationFeeTotalUnitAmount?: InputMaybe<OrderBy>;
  customerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  /** The sum of the items in the order. This doesn't include any discounts or fees. */
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  /** The total after fees and discounts. Note that the coaches fee is not added in. This is only what the player pays. The coaches fee is subtracted from their payout. */
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  sellerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  /** The amount transferred to the coach as a payout. It is the price of the lesson minus the coaches fee. */
  transferUnitAmount?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type LessonOrdersStddevSampFields = {
  __typename?: 'LessonOrdersStddevSampFields';
  applicationFeeTotalUnitAmount?: Maybe<Scalars['Float']>;
  customerApplicationFeeUnitAmount?: Maybe<Scalars['Float']>;
  /** The sum of the items in the order. This doesn't include any discounts or fees. */
  orderSubtotalUnitAmount?: Maybe<Scalars['Float']>;
  /** The total after fees and discounts. Note that the coaches fee is not added in. This is only what the player pays. The coaches fee is subtracted from their payout. */
  orderTotalUnitAmount?: Maybe<Scalars['Float']>;
  paidUnitAmount?: Maybe<Scalars['Float']>;
  refundUnitAmount?: Maybe<Scalars['Float']>;
  sellerApplicationFeeUnitAmount?: Maybe<Scalars['Float']>;
  /** The amount transferred to the coach as a payout. It is the price of the lesson minus the coaches fee. */
  transferUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "lesson_orders" */
export type LessonOrdersStddevSampOrderBy = {
  applicationFeeTotalUnitAmount?: InputMaybe<OrderBy>;
  customerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  /** The sum of the items in the order. This doesn't include any discounts or fees. */
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  /** The total after fees and discounts. Note that the coaches fee is not added in. This is only what the player pays. The coaches fee is subtracted from their payout. */
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  sellerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  /** The amount transferred to the coach as a payout. It is the price of the lesson minus the coaches fee. */
  transferUnitAmount?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "lesson_orders" */
export type LessonOrdersStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: LessonOrdersStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LessonOrdersStreamCursorValueInput = {
  applicationFeeTotalUnitAmount?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  customerApplicationFeeUnitAmount?: InputMaybe<Scalars['Int']>;
  customerUserId?: InputMaybe<Scalars['uuid']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  externalStripePaymentIntentId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  internalStripePaymentIntentId?: InputMaybe<Scalars['uuid']>;
  lessonId?: InputMaybe<Scalars['uuid']>;
  /** The sum of the items in the order. This doesn't include any discounts or fees. */
  orderSubtotalUnitAmount?: InputMaybe<Scalars['Int']>;
  /** The total after fees and discounts. Note that the coaches fee is not added in. This is only what the player pays. The coaches fee is subtracted from their payout. */
  orderTotalUnitAmount?: InputMaybe<Scalars['Int']>;
  paidUnitAmount?: InputMaybe<Scalars['Int']>;
  paymentProcessor?: InputMaybe<PaymentProcessorsEnum>;
  refundUnitAmount?: InputMaybe<Scalars['Int']>;
  refundedAt?: InputMaybe<Scalars['timestamptz']>;
  refundedByPersona?: InputMaybe<AppPersonasEnum>;
  sellerApplicationFeeUnitAmount?: InputMaybe<Scalars['Int']>;
  sellerUserId?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<OrderStatusesEnum>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  stripeMerchantId?: InputMaybe<Scalars['String']>;
  stripePaymentStatus?: InputMaybe<Scalars['String']>;
  /** The amount transferred to the coach as a payout. It is the price of the lesson minus the coaches fee. */
  transferUnitAmount?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userCreditCardId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type LessonOrdersSumFields = {
  __typename?: 'LessonOrdersSumFields';
  applicationFeeTotalUnitAmount?: Maybe<Scalars['Int']>;
  customerApplicationFeeUnitAmount?: Maybe<Scalars['Int']>;
  /** The sum of the items in the order. This doesn't include any discounts or fees. */
  orderSubtotalUnitAmount?: Maybe<Scalars['Int']>;
  /** The total after fees and discounts. Note that the coaches fee is not added in. This is only what the player pays. The coaches fee is subtracted from their payout. */
  orderTotalUnitAmount?: Maybe<Scalars['Int']>;
  paidUnitAmount?: Maybe<Scalars['Int']>;
  refundUnitAmount?: Maybe<Scalars['Int']>;
  sellerApplicationFeeUnitAmount?: Maybe<Scalars['Int']>;
  /** The amount transferred to the coach as a payout. It is the price of the lesson minus the coaches fee. */
  transferUnitAmount?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "lesson_orders" */
export type LessonOrdersSumOrderBy = {
  applicationFeeTotalUnitAmount?: InputMaybe<OrderBy>;
  customerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  /** The sum of the items in the order. This doesn't include any discounts or fees. */
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  /** The total after fees and discounts. Note that the coaches fee is not added in. This is only what the player pays. The coaches fee is subtracted from their payout. */
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  sellerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  /** The amount transferred to the coach as a payout. It is the price of the lesson minus the coaches fee. */
  transferUnitAmount?: InputMaybe<OrderBy>;
};

/** update columns of table "lesson_orders" */
export enum LessonOrdersUpdateColumn {
  /** column name */
  ApplicationFeeTotalUnitAmount = 'applicationFeeTotalUnitAmount',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CustomerApplicationFeeUnitAmount = 'customerApplicationFeeUnitAmount',
  /** column name */
  CustomerUserId = 'customerUserId',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  ExternalStripePaymentIntentId = 'externalStripePaymentIntentId',
  /** column name */
  Id = 'id',
  /** column name */
  InternalStripePaymentIntentId = 'internalStripePaymentIntentId',
  /** column name */
  LessonId = 'lessonId',
  /** column name */
  OrderSubtotalUnitAmount = 'orderSubtotalUnitAmount',
  /** column name */
  OrderTotalUnitAmount = 'orderTotalUnitAmount',
  /** column name */
  PaidUnitAmount = 'paidUnitAmount',
  /** column name */
  PaymentProcessor = 'paymentProcessor',
  /** column name */
  RefundUnitAmount = 'refundUnitAmount',
  /** column name */
  RefundedAt = 'refundedAt',
  /** column name */
  RefundedByPersona = 'refundedByPersona',
  /** column name */
  SellerApplicationFeeUnitAmount = 'sellerApplicationFeeUnitAmount',
  /** column name */
  SellerUserId = 'sellerUserId',
  /** column name */
  Status = 'status',
  /** column name */
  StripeCustomerId = 'stripeCustomerId',
  /** column name */
  StripeMerchantId = 'stripeMerchantId',
  /** column name */
  StripePaymentStatus = 'stripePaymentStatus',
  /** column name */
  TransferUnitAmount = 'transferUnitAmount',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserCreditCardId = 'userCreditCardId'
}

export type LessonOrdersUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<LessonOrdersIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LessonOrdersSetInput>;
  /** filter the rows which have to be updated */
  where: LessonOrdersBoolExp;
};

/** aggregate varPop on columns */
export type LessonOrdersVarPopFields = {
  __typename?: 'LessonOrdersVarPopFields';
  applicationFeeTotalUnitAmount?: Maybe<Scalars['Float']>;
  customerApplicationFeeUnitAmount?: Maybe<Scalars['Float']>;
  /** The sum of the items in the order. This doesn't include any discounts or fees. */
  orderSubtotalUnitAmount?: Maybe<Scalars['Float']>;
  /** The total after fees and discounts. Note that the coaches fee is not added in. This is only what the player pays. The coaches fee is subtracted from their payout. */
  orderTotalUnitAmount?: Maybe<Scalars['Float']>;
  paidUnitAmount?: Maybe<Scalars['Float']>;
  refundUnitAmount?: Maybe<Scalars['Float']>;
  sellerApplicationFeeUnitAmount?: Maybe<Scalars['Float']>;
  /** The amount transferred to the coach as a payout. It is the price of the lesson minus the coaches fee. */
  transferUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "lesson_orders" */
export type LessonOrdersVarPopOrderBy = {
  applicationFeeTotalUnitAmount?: InputMaybe<OrderBy>;
  customerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  /** The sum of the items in the order. This doesn't include any discounts or fees. */
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  /** The total after fees and discounts. Note that the coaches fee is not added in. This is only what the player pays. The coaches fee is subtracted from their payout. */
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  sellerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  /** The amount transferred to the coach as a payout. It is the price of the lesson minus the coaches fee. */
  transferUnitAmount?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type LessonOrdersVarSampFields = {
  __typename?: 'LessonOrdersVarSampFields';
  applicationFeeTotalUnitAmount?: Maybe<Scalars['Float']>;
  customerApplicationFeeUnitAmount?: Maybe<Scalars['Float']>;
  /** The sum of the items in the order. This doesn't include any discounts or fees. */
  orderSubtotalUnitAmount?: Maybe<Scalars['Float']>;
  /** The total after fees and discounts. Note that the coaches fee is not added in. This is only what the player pays. The coaches fee is subtracted from their payout. */
  orderTotalUnitAmount?: Maybe<Scalars['Float']>;
  paidUnitAmount?: Maybe<Scalars['Float']>;
  refundUnitAmount?: Maybe<Scalars['Float']>;
  sellerApplicationFeeUnitAmount?: Maybe<Scalars['Float']>;
  /** The amount transferred to the coach as a payout. It is the price of the lesson minus the coaches fee. */
  transferUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "lesson_orders" */
export type LessonOrdersVarSampOrderBy = {
  applicationFeeTotalUnitAmount?: InputMaybe<OrderBy>;
  customerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  /** The sum of the items in the order. This doesn't include any discounts or fees. */
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  /** The total after fees and discounts. Note that the coaches fee is not added in. This is only what the player pays. The coaches fee is subtracted from their payout. */
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  sellerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  /** The amount transferred to the coach as a payout. It is the price of the lesson minus the coaches fee. */
  transferUnitAmount?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type LessonOrdersVarianceFields = {
  __typename?: 'LessonOrdersVarianceFields';
  applicationFeeTotalUnitAmount?: Maybe<Scalars['Float']>;
  customerApplicationFeeUnitAmount?: Maybe<Scalars['Float']>;
  /** The sum of the items in the order. This doesn't include any discounts or fees. */
  orderSubtotalUnitAmount?: Maybe<Scalars['Float']>;
  /** The total after fees and discounts. Note that the coaches fee is not added in. This is only what the player pays. The coaches fee is subtracted from their payout. */
  orderTotalUnitAmount?: Maybe<Scalars['Float']>;
  paidUnitAmount?: Maybe<Scalars['Float']>;
  refundUnitAmount?: Maybe<Scalars['Float']>;
  sellerApplicationFeeUnitAmount?: Maybe<Scalars['Float']>;
  /** The amount transferred to the coach as a payout. It is the price of the lesson minus the coaches fee. */
  transferUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "lesson_orders" */
export type LessonOrdersVarianceOrderBy = {
  applicationFeeTotalUnitAmount?: InputMaybe<OrderBy>;
  customerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  /** The sum of the items in the order. This doesn't include any discounts or fees. */
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  /** The total after fees and discounts. Note that the coaches fee is not added in. This is only what the player pays. The coaches fee is subtracted from their payout. */
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  sellerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  /** The amount transferred to the coach as a payout. It is the price of the lesson minus the coaches fee. */
  transferUnitAmount?: InputMaybe<OrderBy>;
};

/** columns and relationships of "lesson_participant_statuses" */
export type LessonParticipantStatuses = {
  __typename?: 'LessonParticipantStatuses';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "lesson_participant_statuses" */
export type LessonParticipantStatusesAggregate = {
  __typename?: 'LessonParticipantStatusesAggregate';
  aggregate?: Maybe<LessonParticipantStatusesAggregateFields>;
  nodes: Array<LessonParticipantStatuses>;
};

/** aggregate fields of "lesson_participant_statuses" */
export type LessonParticipantStatusesAggregateFields = {
  __typename?: 'LessonParticipantStatusesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<LessonParticipantStatusesMaxFields>;
  min?: Maybe<LessonParticipantStatusesMinFields>;
};


/** aggregate fields of "lesson_participant_statuses" */
export type LessonParticipantStatusesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<LessonParticipantStatusesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "lesson_participant_statuses". All fields are combined with a logical 'AND'. */
export type LessonParticipantStatusesBoolExp = {
  _and?: InputMaybe<Array<LessonParticipantStatusesBoolExp>>;
  _not?: InputMaybe<LessonParticipantStatusesBoolExp>;
  _or?: InputMaybe<Array<LessonParticipantStatusesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "lesson_participant_statuses" */
export enum LessonParticipantStatusesConstraint {
  /** unique or primary key constraint on columns "value" */
  LessonParticipantStatusesPkey = 'lesson_participant_statuses_pkey'
}

export enum LessonParticipantStatusesEnum {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Pending = 'PENDING'
}

/** Boolean expression to compare columns of type "LessonParticipantStatusesEnum". All fields are combined with logical 'AND'. */
export type LessonParticipantStatusesEnumComparisonExp = {
  _eq?: InputMaybe<LessonParticipantStatusesEnum>;
  _in?: InputMaybe<Array<LessonParticipantStatusesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<LessonParticipantStatusesEnum>;
  _nin?: InputMaybe<Array<LessonParticipantStatusesEnum>>;
};

/** input type for inserting data into table "lesson_participant_statuses" */
export type LessonParticipantStatusesInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type LessonParticipantStatusesMaxFields = {
  __typename?: 'LessonParticipantStatusesMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type LessonParticipantStatusesMinFields = {
  __typename?: 'LessonParticipantStatusesMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "lesson_participant_statuses" */
export type LessonParticipantStatusesMutationResponse = {
  __typename?: 'LessonParticipantStatusesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LessonParticipantStatuses>;
};

/** on_conflict condition type for table "lesson_participant_statuses" */
export type LessonParticipantStatusesOnConflict = {
  constraint: LessonParticipantStatusesConstraint;
  updateColumns?: Array<LessonParticipantStatusesUpdateColumn>;
  where?: InputMaybe<LessonParticipantStatusesBoolExp>;
};

/** Ordering options when selecting data from "lesson_participant_statuses". */
export type LessonParticipantStatusesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: lesson_participant_statuses */
export type LessonParticipantStatusesPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "lesson_participant_statuses" */
export enum LessonParticipantStatusesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "lesson_participant_statuses" */
export type LessonParticipantStatusesSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "lesson_participant_statuses" */
export type LessonParticipantStatusesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: LessonParticipantStatusesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LessonParticipantStatusesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "lesson_participant_statuses" */
export enum LessonParticipantStatusesUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type LessonParticipantStatusesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LessonParticipantStatusesSetInput>;
  /** filter the rows which have to be updated */
  where: LessonParticipantStatusesBoolExp;
};

/** columns and relationships of "lesson_participants" */
export type LessonParticipants = {
  __typename?: 'LessonParticipants';
  addedAt?: Maybe<Scalars['timestamptz']>;
  addedByPersona?: Maybe<AppPersonasEnum>;
  addedByUserId?: Maybe<Scalars['uuid']>;
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  /** An object relationship */
  lesson: Lessons;
  lessonId: Scalars['uuid'];
  /** An array relationship */
  orderItems: Array<LessonOrderItems>;
  /** An aggregate relationship */
  orderItemsAggregate: LessonOrderItemsAggregate;
  paidAt?: Maybe<Scalars['timestamptz']>;
  paymentFulfillmentChannel: PaymentFulfillmentChannelsEnum;
  recapSkippedAt?: Maybe<Scalars['timestamptz']>;
  referralName?: Maybe<Scalars['String']>;
  refundedAt?: Maybe<Scalars['timestamptz']>;
  refundedByPersona?: Maybe<AppPersonasEnum>;
  removedAt?: Maybe<Scalars['timestamptz']>;
  removedByPersona?: Maybe<AppPersonasEnum>;
  status: LessonParticipantStatusesEnum;
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid'];
  /** An object relationship */
  userProfile?: Maybe<UserProfiles>;
};


/** columns and relationships of "lesson_participants" */
export type LessonParticipantsOrderItemsArgs = {
  distinctOn?: InputMaybe<Array<LessonOrderItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonOrderItemsOrderBy>>;
  where?: InputMaybe<LessonOrderItemsBoolExp>;
};


/** columns and relationships of "lesson_participants" */
export type LessonParticipantsOrderItemsAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonOrderItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonOrderItemsOrderBy>>;
  where?: InputMaybe<LessonOrderItemsBoolExp>;
};

/** aggregated selection of "lesson_participants" */
export type LessonParticipantsAggregate = {
  __typename?: 'LessonParticipantsAggregate';
  aggregate?: Maybe<LessonParticipantsAggregateFields>;
  nodes: Array<LessonParticipants>;
};

export type LessonParticipantsAggregateBoolExp = {
  count?: InputMaybe<LessonParticipantsAggregateBoolExpCount>;
};

/** aggregate fields of "lesson_participants" */
export type LessonParticipantsAggregateFields = {
  __typename?: 'LessonParticipantsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<LessonParticipantsMaxFields>;
  min?: Maybe<LessonParticipantsMinFields>;
};


/** aggregate fields of "lesson_participants" */
export type LessonParticipantsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<LessonParticipantsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "lesson_participants" */
export type LessonParticipantsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<LessonParticipantsMaxOrderBy>;
  min?: InputMaybe<LessonParticipantsMinOrderBy>;
};

/** input type for inserting array relation for remote table "lesson_participants" */
export type LessonParticipantsArrRelInsertInput = {
  data: Array<LessonParticipantsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<LessonParticipantsOnConflict>;
};

/** Boolean expression to filter rows from the table "lesson_participants". All fields are combined with a logical 'AND'. */
export type LessonParticipantsBoolExp = {
  _and?: InputMaybe<Array<LessonParticipantsBoolExp>>;
  _not?: InputMaybe<LessonParticipantsBoolExp>;
  _or?: InputMaybe<Array<LessonParticipantsBoolExp>>;
  addedAt?: InputMaybe<TimestamptzComparisonExp>;
  addedByPersona?: InputMaybe<AppPersonasEnumComparisonExp>;
  addedByUserId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  lesson?: InputMaybe<LessonsBoolExp>;
  lessonId?: InputMaybe<UuidComparisonExp>;
  orderItems?: InputMaybe<LessonOrderItemsBoolExp>;
  orderItemsAggregate?: InputMaybe<LessonOrderItemsAggregateBoolExp>;
  paidAt?: InputMaybe<TimestamptzComparisonExp>;
  paymentFulfillmentChannel?: InputMaybe<PaymentFulfillmentChannelsEnumComparisonExp>;
  recapSkippedAt?: InputMaybe<TimestamptzComparisonExp>;
  referralName?: InputMaybe<StringComparisonExp>;
  refundedAt?: InputMaybe<TimestamptzComparisonExp>;
  refundedByPersona?: InputMaybe<AppPersonasEnumComparisonExp>;
  removedAt?: InputMaybe<TimestamptzComparisonExp>;
  removedByPersona?: InputMaybe<AppPersonasEnumComparisonExp>;
  status?: InputMaybe<LessonParticipantStatusesEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
  userProfile?: InputMaybe<UserProfilesBoolExp>;
};

/** unique or primary key constraints on table "lesson_participants" */
export enum LessonParticipantsConstraint {
  /** unique or primary key constraint on columns "lesson_id", "user_id" */
  LessonParticipantsLessonIdUserIdKey = 'lesson_participants_lesson_id_user_id_key',
  /** unique or primary key constraint on columns "id" */
  LessonParticipantsPkey = 'lesson_participants_pkey'
}

/** input type for inserting data into table "lesson_participants" */
export type LessonParticipantsInsertInput = {
  addedAt?: InputMaybe<Scalars['timestamptz']>;
  addedByPersona?: InputMaybe<AppPersonasEnum>;
  addedByUserId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  lesson?: InputMaybe<LessonsObjRelInsertInput>;
  lessonId?: InputMaybe<Scalars['uuid']>;
  orderItems?: InputMaybe<LessonOrderItemsArrRelInsertInput>;
  paidAt?: InputMaybe<Scalars['timestamptz']>;
  paymentFulfillmentChannel?: InputMaybe<PaymentFulfillmentChannelsEnum>;
  recapSkippedAt?: InputMaybe<Scalars['timestamptz']>;
  referralName?: InputMaybe<Scalars['String']>;
  refundedAt?: InputMaybe<Scalars['timestamptz']>;
  refundedByPersona?: InputMaybe<AppPersonasEnum>;
  removedAt?: InputMaybe<Scalars['timestamptz']>;
  removedByPersona?: InputMaybe<AppPersonasEnum>;
  status?: InputMaybe<LessonParticipantStatusesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']>;
  userProfile?: InputMaybe<UserProfilesObjRelInsertInput>;
};

/** aggregate max on columns */
export type LessonParticipantsMaxFields = {
  __typename?: 'LessonParticipantsMaxFields';
  addedAt?: Maybe<Scalars['timestamptz']>;
  addedByUserId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  lessonId?: Maybe<Scalars['uuid']>;
  paidAt?: Maybe<Scalars['timestamptz']>;
  recapSkippedAt?: Maybe<Scalars['timestamptz']>;
  referralName?: Maybe<Scalars['String']>;
  refundedAt?: Maybe<Scalars['timestamptz']>;
  removedAt?: Maybe<Scalars['timestamptz']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "lesson_participants" */
export type LessonParticipantsMaxOrderBy = {
  addedAt?: InputMaybe<OrderBy>;
  addedByUserId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lessonId?: InputMaybe<OrderBy>;
  paidAt?: InputMaybe<OrderBy>;
  recapSkippedAt?: InputMaybe<OrderBy>;
  referralName?: InputMaybe<OrderBy>;
  refundedAt?: InputMaybe<OrderBy>;
  removedAt?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type LessonParticipantsMinFields = {
  __typename?: 'LessonParticipantsMinFields';
  addedAt?: Maybe<Scalars['timestamptz']>;
  addedByUserId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  lessonId?: Maybe<Scalars['uuid']>;
  paidAt?: Maybe<Scalars['timestamptz']>;
  recapSkippedAt?: Maybe<Scalars['timestamptz']>;
  referralName?: Maybe<Scalars['String']>;
  refundedAt?: Maybe<Scalars['timestamptz']>;
  removedAt?: Maybe<Scalars['timestamptz']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "lesson_participants" */
export type LessonParticipantsMinOrderBy = {
  addedAt?: InputMaybe<OrderBy>;
  addedByUserId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lessonId?: InputMaybe<OrderBy>;
  paidAt?: InputMaybe<OrderBy>;
  recapSkippedAt?: InputMaybe<OrderBy>;
  referralName?: InputMaybe<OrderBy>;
  refundedAt?: InputMaybe<OrderBy>;
  removedAt?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "lesson_participants" */
export type LessonParticipantsMutationResponse = {
  __typename?: 'LessonParticipantsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LessonParticipants>;
};

/** input type for inserting object relation for remote table "lesson_participants" */
export type LessonParticipantsObjRelInsertInput = {
  data: LessonParticipantsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<LessonParticipantsOnConflict>;
};

/** on_conflict condition type for table "lesson_participants" */
export type LessonParticipantsOnConflict = {
  constraint: LessonParticipantsConstraint;
  updateColumns?: Array<LessonParticipantsUpdateColumn>;
  where?: InputMaybe<LessonParticipantsBoolExp>;
};

/** Ordering options when selecting data from "lesson_participants". */
export type LessonParticipantsOrderBy = {
  addedAt?: InputMaybe<OrderBy>;
  addedByPersona?: InputMaybe<OrderBy>;
  addedByUserId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lesson?: InputMaybe<LessonsOrderBy>;
  lessonId?: InputMaybe<OrderBy>;
  orderItemsAggregate?: InputMaybe<LessonOrderItemsAggregateOrderBy>;
  paidAt?: InputMaybe<OrderBy>;
  paymentFulfillmentChannel?: InputMaybe<OrderBy>;
  recapSkippedAt?: InputMaybe<OrderBy>;
  referralName?: InputMaybe<OrderBy>;
  refundedAt?: InputMaybe<OrderBy>;
  refundedByPersona?: InputMaybe<OrderBy>;
  removedAt?: InputMaybe<OrderBy>;
  removedByPersona?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
  userProfile?: InputMaybe<UserProfilesOrderBy>;
};

/** primary key columns input for table: lesson_participants */
export type LessonParticipantsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "lesson_participants" */
export enum LessonParticipantsSelectColumn {
  /** column name */
  AddedAt = 'addedAt',
  /** column name */
  AddedByPersona = 'addedByPersona',
  /** column name */
  AddedByUserId = 'addedByUserId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  LessonId = 'lessonId',
  /** column name */
  PaidAt = 'paidAt',
  /** column name */
  PaymentFulfillmentChannel = 'paymentFulfillmentChannel',
  /** column name */
  RecapSkippedAt = 'recapSkippedAt',
  /** column name */
  ReferralName = 'referralName',
  /** column name */
  RefundedAt = 'refundedAt',
  /** column name */
  RefundedByPersona = 'refundedByPersona',
  /** column name */
  RemovedAt = 'removedAt',
  /** column name */
  RemovedByPersona = 'removedByPersona',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "lesson_participants" */
export type LessonParticipantsSetInput = {
  addedAt?: InputMaybe<Scalars['timestamptz']>;
  addedByPersona?: InputMaybe<AppPersonasEnum>;
  addedByUserId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  lessonId?: InputMaybe<Scalars['uuid']>;
  paidAt?: InputMaybe<Scalars['timestamptz']>;
  paymentFulfillmentChannel?: InputMaybe<PaymentFulfillmentChannelsEnum>;
  recapSkippedAt?: InputMaybe<Scalars['timestamptz']>;
  referralName?: InputMaybe<Scalars['String']>;
  refundedAt?: InputMaybe<Scalars['timestamptz']>;
  refundedByPersona?: InputMaybe<AppPersonasEnum>;
  removedAt?: InputMaybe<Scalars['timestamptz']>;
  removedByPersona?: InputMaybe<AppPersonasEnum>;
  status?: InputMaybe<LessonParticipantStatusesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "lesson_participants" */
export type LessonParticipantsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: LessonParticipantsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LessonParticipantsStreamCursorValueInput = {
  addedAt?: InputMaybe<Scalars['timestamptz']>;
  addedByPersona?: InputMaybe<AppPersonasEnum>;
  addedByUserId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  lessonId?: InputMaybe<Scalars['uuid']>;
  paidAt?: InputMaybe<Scalars['timestamptz']>;
  paymentFulfillmentChannel?: InputMaybe<PaymentFulfillmentChannelsEnum>;
  recapSkippedAt?: InputMaybe<Scalars['timestamptz']>;
  referralName?: InputMaybe<Scalars['String']>;
  refundedAt?: InputMaybe<Scalars['timestamptz']>;
  refundedByPersona?: InputMaybe<AppPersonasEnum>;
  removedAt?: InputMaybe<Scalars['timestamptz']>;
  removedByPersona?: InputMaybe<AppPersonasEnum>;
  status?: InputMaybe<LessonParticipantStatusesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "lesson_participants" */
export enum LessonParticipantsUpdateColumn {
  /** column name */
  AddedAt = 'addedAt',
  /** column name */
  AddedByPersona = 'addedByPersona',
  /** column name */
  AddedByUserId = 'addedByUserId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  LessonId = 'lessonId',
  /** column name */
  PaidAt = 'paidAt',
  /** column name */
  PaymentFulfillmentChannel = 'paymentFulfillmentChannel',
  /** column name */
  RecapSkippedAt = 'recapSkippedAt',
  /** column name */
  ReferralName = 'referralName',
  /** column name */
  RefundedAt = 'refundedAt',
  /** column name */
  RefundedByPersona = 'refundedByPersona',
  /** column name */
  RemovedAt = 'removedAt',
  /** column name */
  RemovedByPersona = 'removedByPersona',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

export type LessonParticipantsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LessonParticipantsSetInput>;
  /** filter the rows which have to be updated */
  where: LessonParticipantsBoolExp;
};

/** columns and relationships of "lesson_player_skill_assessment_categories" */
export type LessonPlayerSkillAssessmentCategories = {
  __typename?: 'LessonPlayerSkillAssessmentCategories';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "lesson_player_skill_assessment_categories" */
export type LessonPlayerSkillAssessmentCategoriesAggregate = {
  __typename?: 'LessonPlayerSkillAssessmentCategoriesAggregate';
  aggregate?: Maybe<LessonPlayerSkillAssessmentCategoriesAggregateFields>;
  nodes: Array<LessonPlayerSkillAssessmentCategories>;
};

/** aggregate fields of "lesson_player_skill_assessment_categories" */
export type LessonPlayerSkillAssessmentCategoriesAggregateFields = {
  __typename?: 'LessonPlayerSkillAssessmentCategoriesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<LessonPlayerSkillAssessmentCategoriesMaxFields>;
  min?: Maybe<LessonPlayerSkillAssessmentCategoriesMinFields>;
};


/** aggregate fields of "lesson_player_skill_assessment_categories" */
export type LessonPlayerSkillAssessmentCategoriesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<LessonPlayerSkillAssessmentCategoriesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "lesson_player_skill_assessment_categories". All fields are combined with a logical 'AND'. */
export type LessonPlayerSkillAssessmentCategoriesBoolExp = {
  _and?: InputMaybe<Array<LessonPlayerSkillAssessmentCategoriesBoolExp>>;
  _not?: InputMaybe<LessonPlayerSkillAssessmentCategoriesBoolExp>;
  _or?: InputMaybe<Array<LessonPlayerSkillAssessmentCategoriesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "lesson_player_skill_assessment_categories" */
export enum LessonPlayerSkillAssessmentCategoriesConstraint {
  /** unique or primary key constraint on columns "value" */
  LessonPlayerSkillAssessmentCategoriesPkey = 'lesson_player_skill_assessment_categories_pkey'
}

export enum LessonPlayerSkillAssessmentCategoriesEnum {
  Negative = 'NEGATIVE',
  NextGoal = 'NEXT_GOAL',
  Positive = 'POSITIVE'
}

/** Boolean expression to compare columns of type "LessonPlayerSkillAssessmentCategoriesEnum". All fields are combined with logical 'AND'. */
export type LessonPlayerSkillAssessmentCategoriesEnumComparisonExp = {
  _eq?: InputMaybe<LessonPlayerSkillAssessmentCategoriesEnum>;
  _in?: InputMaybe<Array<LessonPlayerSkillAssessmentCategoriesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<LessonPlayerSkillAssessmentCategoriesEnum>;
  _nin?: InputMaybe<Array<LessonPlayerSkillAssessmentCategoriesEnum>>;
};

/** input type for inserting data into table "lesson_player_skill_assessment_categories" */
export type LessonPlayerSkillAssessmentCategoriesInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type LessonPlayerSkillAssessmentCategoriesMaxFields = {
  __typename?: 'LessonPlayerSkillAssessmentCategoriesMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type LessonPlayerSkillAssessmentCategoriesMinFields = {
  __typename?: 'LessonPlayerSkillAssessmentCategoriesMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "lesson_player_skill_assessment_categories" */
export type LessonPlayerSkillAssessmentCategoriesMutationResponse = {
  __typename?: 'LessonPlayerSkillAssessmentCategoriesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LessonPlayerSkillAssessmentCategories>;
};

/** on_conflict condition type for table "lesson_player_skill_assessment_categories" */
export type LessonPlayerSkillAssessmentCategoriesOnConflict = {
  constraint: LessonPlayerSkillAssessmentCategoriesConstraint;
  updateColumns?: Array<LessonPlayerSkillAssessmentCategoriesUpdateColumn>;
  where?: InputMaybe<LessonPlayerSkillAssessmentCategoriesBoolExp>;
};

/** Ordering options when selecting data from "lesson_player_skill_assessment_categories". */
export type LessonPlayerSkillAssessmentCategoriesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: lesson_player_skill_assessment_categories */
export type LessonPlayerSkillAssessmentCategoriesPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "lesson_player_skill_assessment_categories" */
export enum LessonPlayerSkillAssessmentCategoriesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "lesson_player_skill_assessment_categories" */
export type LessonPlayerSkillAssessmentCategoriesSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "lesson_player_skill_assessment_categories" */
export type LessonPlayerSkillAssessmentCategoriesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: LessonPlayerSkillAssessmentCategoriesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LessonPlayerSkillAssessmentCategoriesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "lesson_player_skill_assessment_categories" */
export enum LessonPlayerSkillAssessmentCategoriesUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type LessonPlayerSkillAssessmentCategoriesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LessonPlayerSkillAssessmentCategoriesSetInput>;
  /** filter the rows which have to be updated */
  where: LessonPlayerSkillAssessmentCategoriesBoolExp;
};

/** columns and relationships of "lesson_player_skill_assessments" */
export type LessonPlayerSkillAssessments = {
  __typename?: 'LessonPlayerSkillAssessments';
  coachUserId: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  /** An object relationship */
  lesson: Lessons;
  /** An object relationship */
  lessonCoach?: Maybe<UserProfiles>;
  lessonId: Scalars['uuid'];
  /** An object relationship */
  lessonPlayer?: Maybe<UserProfiles>;
  /** An array relationship */
  lessonPlayerSkillAssessmentsSkills: Array<LessonPlayerSkillAssessmentsSkills>;
  /** An aggregate relationship */
  lessonPlayerSkillAssessmentsSkillsAggregate: LessonPlayerSkillAssessmentsSkillsAggregate;
  playerUserId: Scalars['uuid'];
  reviewerUserId?: Maybe<Scalars['uuid']>;
  submissionUserId?: Maybe<Scalars['uuid']>;
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "lesson_player_skill_assessments" */
export type LessonPlayerSkillAssessmentsLessonPlayerSkillAssessmentsSkillsArgs = {
  distinctOn?: InputMaybe<Array<LessonPlayerSkillAssessmentsSkillsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonPlayerSkillAssessmentsSkillsOrderBy>>;
  where?: InputMaybe<LessonPlayerSkillAssessmentsSkillsBoolExp>;
};


/** columns and relationships of "lesson_player_skill_assessments" */
export type LessonPlayerSkillAssessmentsLessonPlayerSkillAssessmentsSkillsAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonPlayerSkillAssessmentsSkillsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonPlayerSkillAssessmentsSkillsOrderBy>>;
  where?: InputMaybe<LessonPlayerSkillAssessmentsSkillsBoolExp>;
};

/** aggregated selection of "lesson_player_skill_assessments" */
export type LessonPlayerSkillAssessmentsAggregate = {
  __typename?: 'LessonPlayerSkillAssessmentsAggregate';
  aggregate?: Maybe<LessonPlayerSkillAssessmentsAggregateFields>;
  nodes: Array<LessonPlayerSkillAssessments>;
};

export type LessonPlayerSkillAssessmentsAggregateBoolExp = {
  count?: InputMaybe<LessonPlayerSkillAssessmentsAggregateBoolExpCount>;
};

/** aggregate fields of "lesson_player_skill_assessments" */
export type LessonPlayerSkillAssessmentsAggregateFields = {
  __typename?: 'LessonPlayerSkillAssessmentsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<LessonPlayerSkillAssessmentsMaxFields>;
  min?: Maybe<LessonPlayerSkillAssessmentsMinFields>;
};


/** aggregate fields of "lesson_player_skill_assessments" */
export type LessonPlayerSkillAssessmentsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<LessonPlayerSkillAssessmentsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "lesson_player_skill_assessments" */
export type LessonPlayerSkillAssessmentsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<LessonPlayerSkillAssessmentsMaxOrderBy>;
  min?: InputMaybe<LessonPlayerSkillAssessmentsMinOrderBy>;
};

/** input type for inserting array relation for remote table "lesson_player_skill_assessments" */
export type LessonPlayerSkillAssessmentsArrRelInsertInput = {
  data: Array<LessonPlayerSkillAssessmentsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<LessonPlayerSkillAssessmentsOnConflict>;
};

/** Boolean expression to filter rows from the table "lesson_player_skill_assessments". All fields are combined with a logical 'AND'. */
export type LessonPlayerSkillAssessmentsBoolExp = {
  _and?: InputMaybe<Array<LessonPlayerSkillAssessmentsBoolExp>>;
  _not?: InputMaybe<LessonPlayerSkillAssessmentsBoolExp>;
  _or?: InputMaybe<Array<LessonPlayerSkillAssessmentsBoolExp>>;
  coachUserId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  lesson?: InputMaybe<LessonsBoolExp>;
  lessonCoach?: InputMaybe<UserProfilesBoolExp>;
  lessonId?: InputMaybe<UuidComparisonExp>;
  lessonPlayer?: InputMaybe<UserProfilesBoolExp>;
  lessonPlayerSkillAssessmentsSkills?: InputMaybe<LessonPlayerSkillAssessmentsSkillsBoolExp>;
  lessonPlayerSkillAssessmentsSkillsAggregate?: InputMaybe<LessonPlayerSkillAssessmentsSkillsAggregateBoolExp>;
  playerUserId?: InputMaybe<UuidComparisonExp>;
  reviewerUserId?: InputMaybe<UuidComparisonExp>;
  submissionUserId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "lesson_player_skill_assessments" */
export enum LessonPlayerSkillAssessmentsConstraint {
  /** unique or primary key constraint on columns "id" */
  LessonPlayerSkillAssessmentsPkey = 'lesson_player_skill_assessments_pkey'
}

/** input type for inserting data into table "lesson_player_skill_assessments" */
export type LessonPlayerSkillAssessmentsInsertInput = {
  coachUserId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  lesson?: InputMaybe<LessonsObjRelInsertInput>;
  lessonCoach?: InputMaybe<UserProfilesObjRelInsertInput>;
  lessonId?: InputMaybe<Scalars['uuid']>;
  lessonPlayer?: InputMaybe<UserProfilesObjRelInsertInput>;
  lessonPlayerSkillAssessmentsSkills?: InputMaybe<LessonPlayerSkillAssessmentsSkillsArrRelInsertInput>;
  playerUserId?: InputMaybe<Scalars['uuid']>;
  reviewerUserId?: InputMaybe<Scalars['uuid']>;
  submissionUserId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type LessonPlayerSkillAssessmentsMaxFields = {
  __typename?: 'LessonPlayerSkillAssessmentsMaxFields';
  coachUserId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  lessonId?: Maybe<Scalars['uuid']>;
  playerUserId?: Maybe<Scalars['uuid']>;
  reviewerUserId?: Maybe<Scalars['uuid']>;
  submissionUserId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "lesson_player_skill_assessments" */
export type LessonPlayerSkillAssessmentsMaxOrderBy = {
  coachUserId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lessonId?: InputMaybe<OrderBy>;
  playerUserId?: InputMaybe<OrderBy>;
  reviewerUserId?: InputMaybe<OrderBy>;
  submissionUserId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type LessonPlayerSkillAssessmentsMinFields = {
  __typename?: 'LessonPlayerSkillAssessmentsMinFields';
  coachUserId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  lessonId?: Maybe<Scalars['uuid']>;
  playerUserId?: Maybe<Scalars['uuid']>;
  reviewerUserId?: Maybe<Scalars['uuid']>;
  submissionUserId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "lesson_player_skill_assessments" */
export type LessonPlayerSkillAssessmentsMinOrderBy = {
  coachUserId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lessonId?: InputMaybe<OrderBy>;
  playerUserId?: InputMaybe<OrderBy>;
  reviewerUserId?: InputMaybe<OrderBy>;
  submissionUserId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "lesson_player_skill_assessments" */
export type LessonPlayerSkillAssessmentsMutationResponse = {
  __typename?: 'LessonPlayerSkillAssessmentsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LessonPlayerSkillAssessments>;
};

/** input type for inserting object relation for remote table "lesson_player_skill_assessments" */
export type LessonPlayerSkillAssessmentsObjRelInsertInput = {
  data: LessonPlayerSkillAssessmentsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<LessonPlayerSkillAssessmentsOnConflict>;
};

/** on_conflict condition type for table "lesson_player_skill_assessments" */
export type LessonPlayerSkillAssessmentsOnConflict = {
  constraint: LessonPlayerSkillAssessmentsConstraint;
  updateColumns?: Array<LessonPlayerSkillAssessmentsUpdateColumn>;
  where?: InputMaybe<LessonPlayerSkillAssessmentsBoolExp>;
};

/** Ordering options when selecting data from "lesson_player_skill_assessments". */
export type LessonPlayerSkillAssessmentsOrderBy = {
  coachUserId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lesson?: InputMaybe<LessonsOrderBy>;
  lessonCoach?: InputMaybe<UserProfilesOrderBy>;
  lessonId?: InputMaybe<OrderBy>;
  lessonPlayer?: InputMaybe<UserProfilesOrderBy>;
  lessonPlayerSkillAssessmentsSkillsAggregate?: InputMaybe<LessonPlayerSkillAssessmentsSkillsAggregateOrderBy>;
  playerUserId?: InputMaybe<OrderBy>;
  reviewerUserId?: InputMaybe<OrderBy>;
  submissionUserId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: lesson_player_skill_assessments */
export type LessonPlayerSkillAssessmentsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "lesson_player_skill_assessments" */
export enum LessonPlayerSkillAssessmentsSelectColumn {
  /** column name */
  CoachUserId = 'coachUserId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  LessonId = 'lessonId',
  /** column name */
  PlayerUserId = 'playerUserId',
  /** column name */
  ReviewerUserId = 'reviewerUserId',
  /** column name */
  SubmissionUserId = 'submissionUserId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "lesson_player_skill_assessments" */
export type LessonPlayerSkillAssessmentsSetInput = {
  coachUserId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  lessonId?: InputMaybe<Scalars['uuid']>;
  playerUserId?: InputMaybe<Scalars['uuid']>;
  reviewerUserId?: InputMaybe<Scalars['uuid']>;
  submissionUserId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** columns and relationships of "lesson_player_skill_assessments_skills" */
export type LessonPlayerSkillAssessmentsSkills = {
  __typename?: 'LessonPlayerSkillAssessmentsSkills';
  category: LessonPlayerSkillAssessmentCategoriesEnum;
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  /** An object relationship */
  lessonPlayerSkilAssessment: LessonPlayerSkillAssessments;
  lessonPlayerSkillAssessmentId: Scalars['uuid'];
  skill: LessonSkillsEnum;
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "lesson_player_skill_assessments_skills" */
export type LessonPlayerSkillAssessmentsSkillsAggregate = {
  __typename?: 'LessonPlayerSkillAssessmentsSkillsAggregate';
  aggregate?: Maybe<LessonPlayerSkillAssessmentsSkillsAggregateFields>;
  nodes: Array<LessonPlayerSkillAssessmentsSkills>;
};

export type LessonPlayerSkillAssessmentsSkillsAggregateBoolExp = {
  count?: InputMaybe<LessonPlayerSkillAssessmentsSkillsAggregateBoolExpCount>;
};

/** aggregate fields of "lesson_player_skill_assessments_skills" */
export type LessonPlayerSkillAssessmentsSkillsAggregateFields = {
  __typename?: 'LessonPlayerSkillAssessmentsSkillsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<LessonPlayerSkillAssessmentsSkillsMaxFields>;
  min?: Maybe<LessonPlayerSkillAssessmentsSkillsMinFields>;
};


/** aggregate fields of "lesson_player_skill_assessments_skills" */
export type LessonPlayerSkillAssessmentsSkillsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<LessonPlayerSkillAssessmentsSkillsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "lesson_player_skill_assessments_skills" */
export type LessonPlayerSkillAssessmentsSkillsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<LessonPlayerSkillAssessmentsSkillsMaxOrderBy>;
  min?: InputMaybe<LessonPlayerSkillAssessmentsSkillsMinOrderBy>;
};

/** input type for inserting array relation for remote table "lesson_player_skill_assessments_skills" */
export type LessonPlayerSkillAssessmentsSkillsArrRelInsertInput = {
  data: Array<LessonPlayerSkillAssessmentsSkillsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<LessonPlayerSkillAssessmentsSkillsOnConflict>;
};

/** Boolean expression to filter rows from the table "lesson_player_skill_assessments_skills". All fields are combined with a logical 'AND'. */
export type LessonPlayerSkillAssessmentsSkillsBoolExp = {
  _and?: InputMaybe<Array<LessonPlayerSkillAssessmentsSkillsBoolExp>>;
  _not?: InputMaybe<LessonPlayerSkillAssessmentsSkillsBoolExp>;
  _or?: InputMaybe<Array<LessonPlayerSkillAssessmentsSkillsBoolExp>>;
  category?: InputMaybe<LessonPlayerSkillAssessmentCategoriesEnumComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  lessonPlayerSkilAssessment?: InputMaybe<LessonPlayerSkillAssessmentsBoolExp>;
  lessonPlayerSkillAssessmentId?: InputMaybe<UuidComparisonExp>;
  skill?: InputMaybe<LessonSkillsEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "lesson_player_skill_assessments_skills" */
export enum LessonPlayerSkillAssessmentsSkillsConstraint {
  /** unique or primary key constraint on columns "id" */
  LessonPlayerSkillAssessmentsSkillsPkey = 'lesson_player_skill_assessments_skills_pkey'
}

/** input type for inserting data into table "lesson_player_skill_assessments_skills" */
export type LessonPlayerSkillAssessmentsSkillsInsertInput = {
  category?: InputMaybe<LessonPlayerSkillAssessmentCategoriesEnum>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  lessonPlayerSkilAssessment?: InputMaybe<LessonPlayerSkillAssessmentsObjRelInsertInput>;
  lessonPlayerSkillAssessmentId?: InputMaybe<Scalars['uuid']>;
  skill?: InputMaybe<LessonSkillsEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type LessonPlayerSkillAssessmentsSkillsMaxFields = {
  __typename?: 'LessonPlayerSkillAssessmentsSkillsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  lessonPlayerSkillAssessmentId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "lesson_player_skill_assessments_skills" */
export type LessonPlayerSkillAssessmentsSkillsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lessonPlayerSkillAssessmentId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type LessonPlayerSkillAssessmentsSkillsMinFields = {
  __typename?: 'LessonPlayerSkillAssessmentsSkillsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  lessonPlayerSkillAssessmentId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "lesson_player_skill_assessments_skills" */
export type LessonPlayerSkillAssessmentsSkillsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lessonPlayerSkillAssessmentId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "lesson_player_skill_assessments_skills" */
export type LessonPlayerSkillAssessmentsSkillsMutationResponse = {
  __typename?: 'LessonPlayerSkillAssessmentsSkillsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LessonPlayerSkillAssessmentsSkills>;
};

/** on_conflict condition type for table "lesson_player_skill_assessments_skills" */
export type LessonPlayerSkillAssessmentsSkillsOnConflict = {
  constraint: LessonPlayerSkillAssessmentsSkillsConstraint;
  updateColumns?: Array<LessonPlayerSkillAssessmentsSkillsUpdateColumn>;
  where?: InputMaybe<LessonPlayerSkillAssessmentsSkillsBoolExp>;
};

/** Ordering options when selecting data from "lesson_player_skill_assessments_skills". */
export type LessonPlayerSkillAssessmentsSkillsOrderBy = {
  category?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lessonPlayerSkilAssessment?: InputMaybe<LessonPlayerSkillAssessmentsOrderBy>;
  lessonPlayerSkillAssessmentId?: InputMaybe<OrderBy>;
  skill?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: lesson_player_skill_assessments_skills */
export type LessonPlayerSkillAssessmentsSkillsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "lesson_player_skill_assessments_skills" */
export enum LessonPlayerSkillAssessmentsSkillsSelectColumn {
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  LessonPlayerSkillAssessmentId = 'lessonPlayerSkillAssessmentId',
  /** column name */
  Skill = 'skill',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "lesson_player_skill_assessments_skills" */
export type LessonPlayerSkillAssessmentsSkillsSetInput = {
  category?: InputMaybe<LessonPlayerSkillAssessmentCategoriesEnum>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  lessonPlayerSkillAssessmentId?: InputMaybe<Scalars['uuid']>;
  skill?: InputMaybe<LessonSkillsEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "lesson_player_skill_assessments_skills" */
export type LessonPlayerSkillAssessmentsSkillsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: LessonPlayerSkillAssessmentsSkillsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LessonPlayerSkillAssessmentsSkillsStreamCursorValueInput = {
  category?: InputMaybe<LessonPlayerSkillAssessmentCategoriesEnum>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  lessonPlayerSkillAssessmentId?: InputMaybe<Scalars['uuid']>;
  skill?: InputMaybe<LessonSkillsEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "lesson_player_skill_assessments_skills" */
export enum LessonPlayerSkillAssessmentsSkillsUpdateColumn {
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  LessonPlayerSkillAssessmentId = 'lessonPlayerSkillAssessmentId',
  /** column name */
  Skill = 'skill',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type LessonPlayerSkillAssessmentsSkillsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LessonPlayerSkillAssessmentsSkillsSetInput>;
  /** filter the rows which have to be updated */
  where: LessonPlayerSkillAssessmentsSkillsBoolExp;
};

/** Streaming cursor of the table "lesson_player_skill_assessments" */
export type LessonPlayerSkillAssessmentsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: LessonPlayerSkillAssessmentsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LessonPlayerSkillAssessmentsStreamCursorValueInput = {
  coachUserId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  lessonId?: InputMaybe<Scalars['uuid']>;
  playerUserId?: InputMaybe<Scalars['uuid']>;
  reviewerUserId?: InputMaybe<Scalars['uuid']>;
  submissionUserId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "lesson_player_skill_assessments" */
export enum LessonPlayerSkillAssessmentsUpdateColumn {
  /** column name */
  CoachUserId = 'coachUserId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  LessonId = 'lessonId',
  /** column name */
  PlayerUserId = 'playerUserId',
  /** column name */
  ReviewerUserId = 'reviewerUserId',
  /** column name */
  SubmissionUserId = 'submissionUserId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type LessonPlayerSkillAssessmentsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LessonPlayerSkillAssessmentsSetInput>;
  /** filter the rows which have to be updated */
  where: LessonPlayerSkillAssessmentsBoolExp;
};

/** columns and relationships of "lesson_privacy" */
export type LessonPrivacy = {
  __typename?: 'LessonPrivacy';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "lesson_privacy" */
export type LessonPrivacyAggregate = {
  __typename?: 'LessonPrivacyAggregate';
  aggregate?: Maybe<LessonPrivacyAggregateFields>;
  nodes: Array<LessonPrivacy>;
};

/** aggregate fields of "lesson_privacy" */
export type LessonPrivacyAggregateFields = {
  __typename?: 'LessonPrivacyAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<LessonPrivacyMaxFields>;
  min?: Maybe<LessonPrivacyMinFields>;
};


/** aggregate fields of "lesson_privacy" */
export type LessonPrivacyAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<LessonPrivacySelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "lesson_privacy". All fields are combined with a logical 'AND'. */
export type LessonPrivacyBoolExp = {
  _and?: InputMaybe<Array<LessonPrivacyBoolExp>>;
  _not?: InputMaybe<LessonPrivacyBoolExp>;
  _or?: InputMaybe<Array<LessonPrivacyBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "lesson_privacy" */
export enum LessonPrivacyConstraint {
  /** unique or primary key constraint on columns "value" */
  LessonPrivacyPkey = 'lesson_privacy_pkey'
}

export enum LessonPrivacyEnum {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

/** Boolean expression to compare columns of type "LessonPrivacyEnum". All fields are combined with logical 'AND'. */
export type LessonPrivacyEnumComparisonExp = {
  _eq?: InputMaybe<LessonPrivacyEnum>;
  _in?: InputMaybe<Array<LessonPrivacyEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<LessonPrivacyEnum>;
  _nin?: InputMaybe<Array<LessonPrivacyEnum>>;
};

/** input type for inserting data into table "lesson_privacy" */
export type LessonPrivacyInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type LessonPrivacyMaxFields = {
  __typename?: 'LessonPrivacyMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type LessonPrivacyMinFields = {
  __typename?: 'LessonPrivacyMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "lesson_privacy" */
export type LessonPrivacyMutationResponse = {
  __typename?: 'LessonPrivacyMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LessonPrivacy>;
};

/** on_conflict condition type for table "lesson_privacy" */
export type LessonPrivacyOnConflict = {
  constraint: LessonPrivacyConstraint;
  updateColumns?: Array<LessonPrivacyUpdateColumn>;
  where?: InputMaybe<LessonPrivacyBoolExp>;
};

/** Ordering options when selecting data from "lesson_privacy". */
export type LessonPrivacyOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: lesson_privacy */
export type LessonPrivacyPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "lesson_privacy" */
export enum LessonPrivacySelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "lesson_privacy" */
export type LessonPrivacySetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "lesson_privacy" */
export type LessonPrivacyStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: LessonPrivacyStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LessonPrivacyStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "lesson_privacy" */
export enum LessonPrivacyUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type LessonPrivacyUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LessonPrivacySetInput>;
  /** filter the rows which have to be updated */
  where: LessonPrivacyBoolExp;
};

/** columns and relationships of "lesson_reflection_comment_types" */
export type LessonReflectionCommentTypes = {
  __typename?: 'LessonReflectionCommentTypes';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "lesson_reflection_comment_types" */
export type LessonReflectionCommentTypesAggregate = {
  __typename?: 'LessonReflectionCommentTypesAggregate';
  aggregate?: Maybe<LessonReflectionCommentTypesAggregateFields>;
  nodes: Array<LessonReflectionCommentTypes>;
};

/** aggregate fields of "lesson_reflection_comment_types" */
export type LessonReflectionCommentTypesAggregateFields = {
  __typename?: 'LessonReflectionCommentTypesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<LessonReflectionCommentTypesMaxFields>;
  min?: Maybe<LessonReflectionCommentTypesMinFields>;
};


/** aggregate fields of "lesson_reflection_comment_types" */
export type LessonReflectionCommentTypesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<LessonReflectionCommentTypesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "lesson_reflection_comment_types". All fields are combined with a logical 'AND'. */
export type LessonReflectionCommentTypesBoolExp = {
  _and?: InputMaybe<Array<LessonReflectionCommentTypesBoolExp>>;
  _not?: InputMaybe<LessonReflectionCommentTypesBoolExp>;
  _or?: InputMaybe<Array<LessonReflectionCommentTypesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "lesson_reflection_comment_types" */
export enum LessonReflectionCommentTypesConstraint {
  /** unique or primary key constraint on columns "value" */
  LessonReflectionCommentTypesPkey = 'lesson_reflection_comment_types_pkey'
}

export enum LessonReflectionCommentTypesEnum {
  Assignment = 'ASSIGNMENT',
  Completed = 'COMPLETED',
  Upcoming = 'UPCOMING'
}

/** Boolean expression to compare columns of type "LessonReflectionCommentTypesEnum". All fields are combined with logical 'AND'. */
export type LessonReflectionCommentTypesEnumComparisonExp = {
  _eq?: InputMaybe<LessonReflectionCommentTypesEnum>;
  _in?: InputMaybe<Array<LessonReflectionCommentTypesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<LessonReflectionCommentTypesEnum>;
  _nin?: InputMaybe<Array<LessonReflectionCommentTypesEnum>>;
};

/** input type for inserting data into table "lesson_reflection_comment_types" */
export type LessonReflectionCommentTypesInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type LessonReflectionCommentTypesMaxFields = {
  __typename?: 'LessonReflectionCommentTypesMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type LessonReflectionCommentTypesMinFields = {
  __typename?: 'LessonReflectionCommentTypesMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "lesson_reflection_comment_types" */
export type LessonReflectionCommentTypesMutationResponse = {
  __typename?: 'LessonReflectionCommentTypesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LessonReflectionCommentTypes>;
};

/** on_conflict condition type for table "lesson_reflection_comment_types" */
export type LessonReflectionCommentTypesOnConflict = {
  constraint: LessonReflectionCommentTypesConstraint;
  updateColumns?: Array<LessonReflectionCommentTypesUpdateColumn>;
  where?: InputMaybe<LessonReflectionCommentTypesBoolExp>;
};

/** Ordering options when selecting data from "lesson_reflection_comment_types". */
export type LessonReflectionCommentTypesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: lesson_reflection_comment_types */
export type LessonReflectionCommentTypesPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "lesson_reflection_comment_types" */
export enum LessonReflectionCommentTypesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "lesson_reflection_comment_types" */
export type LessonReflectionCommentTypesSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "lesson_reflection_comment_types" */
export type LessonReflectionCommentTypesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: LessonReflectionCommentTypesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LessonReflectionCommentTypesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "lesson_reflection_comment_types" */
export enum LessonReflectionCommentTypesUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type LessonReflectionCommentTypesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LessonReflectionCommentTypesSetInput>;
  /** filter the rows which have to be updated */
  where: LessonReflectionCommentTypesBoolExp;
};

/** columns and relationships of "lesson_reflection_comments" */
export type LessonReflectionComments = {
  __typename?: 'LessonReflectionComments';
  createdAt: Scalars['timestamptz'];
  customSkill?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['time']>;
  details?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  /** An object relationship */
  lessonReflection: LessonReflections;
  /** An array relationship */
  lessonReflectionFiles: Array<LessonReflectionFiles>;
  /** An aggregate relationship */
  lessonReflectionFilesAggregate: LessonReflectionFilesAggregate;
  lessonReflectionId: Scalars['uuid'];
  order?: Maybe<Scalars['Int']>;
  sentiment?: Maybe<FeedbackSentimentEnum>;
  skill?: Maybe<LessonSkillsEnum>;
  type: LessonReflectionCommentTypesEnum;
  updatedAt: Scalars['timestamptz'];
  userId: Scalars['uuid'];
  /** An object relationship */
  userReflectionComment: Users;
};


/** columns and relationships of "lesson_reflection_comments" */
export type LessonReflectionCommentsLessonReflectionFilesArgs = {
  distinctOn?: InputMaybe<Array<LessonReflectionFilesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonReflectionFilesOrderBy>>;
  where?: InputMaybe<LessonReflectionFilesBoolExp>;
};


/** columns and relationships of "lesson_reflection_comments" */
export type LessonReflectionCommentsLessonReflectionFilesAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonReflectionFilesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonReflectionFilesOrderBy>>;
  where?: InputMaybe<LessonReflectionFilesBoolExp>;
};

/** aggregated selection of "lesson_reflection_comments" */
export type LessonReflectionCommentsAggregate = {
  __typename?: 'LessonReflectionCommentsAggregate';
  aggregate?: Maybe<LessonReflectionCommentsAggregateFields>;
  nodes: Array<LessonReflectionComments>;
};

export type LessonReflectionCommentsAggregateBoolExp = {
  count?: InputMaybe<LessonReflectionCommentsAggregateBoolExpCount>;
};

/** aggregate fields of "lesson_reflection_comments" */
export type LessonReflectionCommentsAggregateFields = {
  __typename?: 'LessonReflectionCommentsAggregateFields';
  avg?: Maybe<LessonReflectionCommentsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<LessonReflectionCommentsMaxFields>;
  min?: Maybe<LessonReflectionCommentsMinFields>;
  stddev?: Maybe<LessonReflectionCommentsStddevFields>;
  stddevPop?: Maybe<LessonReflectionCommentsStddevPopFields>;
  stddevSamp?: Maybe<LessonReflectionCommentsStddevSampFields>;
  sum?: Maybe<LessonReflectionCommentsSumFields>;
  varPop?: Maybe<LessonReflectionCommentsVarPopFields>;
  varSamp?: Maybe<LessonReflectionCommentsVarSampFields>;
  variance?: Maybe<LessonReflectionCommentsVarianceFields>;
};


/** aggregate fields of "lesson_reflection_comments" */
export type LessonReflectionCommentsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<LessonReflectionCommentsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "lesson_reflection_comments" */
export type LessonReflectionCommentsAggregateOrderBy = {
  avg?: InputMaybe<LessonReflectionCommentsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<LessonReflectionCommentsMaxOrderBy>;
  min?: InputMaybe<LessonReflectionCommentsMinOrderBy>;
  stddev?: InputMaybe<LessonReflectionCommentsStddevOrderBy>;
  stddevPop?: InputMaybe<LessonReflectionCommentsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<LessonReflectionCommentsStddevSampOrderBy>;
  sum?: InputMaybe<LessonReflectionCommentsSumOrderBy>;
  varPop?: InputMaybe<LessonReflectionCommentsVarPopOrderBy>;
  varSamp?: InputMaybe<LessonReflectionCommentsVarSampOrderBy>;
  variance?: InputMaybe<LessonReflectionCommentsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "lesson_reflection_comments" */
export type LessonReflectionCommentsArrRelInsertInput = {
  data: Array<LessonReflectionCommentsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<LessonReflectionCommentsOnConflict>;
};

/** aggregate avg on columns */
export type LessonReflectionCommentsAvgFields = {
  __typename?: 'LessonReflectionCommentsAvgFields';
  order?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "lesson_reflection_comments" */
export type LessonReflectionCommentsAvgOrderBy = {
  order?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "lesson_reflection_comments". All fields are combined with a logical 'AND'. */
export type LessonReflectionCommentsBoolExp = {
  _and?: InputMaybe<Array<LessonReflectionCommentsBoolExp>>;
  _not?: InputMaybe<LessonReflectionCommentsBoolExp>;
  _or?: InputMaybe<Array<LessonReflectionCommentsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  customSkill?: InputMaybe<StringComparisonExp>;
  deletedAt?: InputMaybe<TimeComparisonExp>;
  details?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  lessonReflection?: InputMaybe<LessonReflectionsBoolExp>;
  lessonReflectionFiles?: InputMaybe<LessonReflectionFilesBoolExp>;
  lessonReflectionFilesAggregate?: InputMaybe<LessonReflectionFilesAggregateBoolExp>;
  lessonReflectionId?: InputMaybe<UuidComparisonExp>;
  order?: InputMaybe<IntComparisonExp>;
  sentiment?: InputMaybe<FeedbackSentimentEnumComparisonExp>;
  skill?: InputMaybe<LessonSkillsEnumComparisonExp>;
  type?: InputMaybe<LessonReflectionCommentTypesEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  userId?: InputMaybe<UuidComparisonExp>;
  userReflectionComment?: InputMaybe<UsersBoolExp>;
};

/** unique or primary key constraints on table "lesson_reflection_comments" */
export enum LessonReflectionCommentsConstraint {
  /** unique or primary key constraint on columns "id" */
  LessonReflectionCommentsPkey = 'lesson_reflection_comments_pkey'
}

/** input type for incrementing numeric columns in table "lesson_reflection_comments" */
export type LessonReflectionCommentsIncInput = {
  order?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "lesson_reflection_comments" */
export type LessonReflectionCommentsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  customSkill?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['time']>;
  details?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  lessonReflection?: InputMaybe<LessonReflectionsObjRelInsertInput>;
  lessonReflectionFiles?: InputMaybe<LessonReflectionFilesArrRelInsertInput>;
  lessonReflectionId?: InputMaybe<Scalars['uuid']>;
  order?: InputMaybe<Scalars['Int']>;
  sentiment?: InputMaybe<FeedbackSentimentEnum>;
  skill?: InputMaybe<LessonSkillsEnum>;
  type?: InputMaybe<LessonReflectionCommentTypesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
  userReflectionComment?: InputMaybe<UsersObjRelInsertInput>;
};

/** aggregate max on columns */
export type LessonReflectionCommentsMaxFields = {
  __typename?: 'LessonReflectionCommentsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  customSkill?: Maybe<Scalars['String']>;
  details?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  lessonReflectionId?: Maybe<Scalars['uuid']>;
  order?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "lesson_reflection_comments" */
export type LessonReflectionCommentsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  customSkill?: InputMaybe<OrderBy>;
  details?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lessonReflectionId?: InputMaybe<OrderBy>;
  order?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type LessonReflectionCommentsMinFields = {
  __typename?: 'LessonReflectionCommentsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  customSkill?: Maybe<Scalars['String']>;
  details?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  lessonReflectionId?: Maybe<Scalars['uuid']>;
  order?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "lesson_reflection_comments" */
export type LessonReflectionCommentsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  customSkill?: InputMaybe<OrderBy>;
  details?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lessonReflectionId?: InputMaybe<OrderBy>;
  order?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "lesson_reflection_comments" */
export type LessonReflectionCommentsMutationResponse = {
  __typename?: 'LessonReflectionCommentsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LessonReflectionComments>;
};

/** input type for inserting object relation for remote table "lesson_reflection_comments" */
export type LessonReflectionCommentsObjRelInsertInput = {
  data: LessonReflectionCommentsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<LessonReflectionCommentsOnConflict>;
};

/** on_conflict condition type for table "lesson_reflection_comments" */
export type LessonReflectionCommentsOnConflict = {
  constraint: LessonReflectionCommentsConstraint;
  updateColumns?: Array<LessonReflectionCommentsUpdateColumn>;
  where?: InputMaybe<LessonReflectionCommentsBoolExp>;
};

/** Ordering options when selecting data from "lesson_reflection_comments". */
export type LessonReflectionCommentsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  customSkill?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  details?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lessonReflection?: InputMaybe<LessonReflectionsOrderBy>;
  lessonReflectionFilesAggregate?: InputMaybe<LessonReflectionFilesAggregateOrderBy>;
  lessonReflectionId?: InputMaybe<OrderBy>;
  order?: InputMaybe<OrderBy>;
  sentiment?: InputMaybe<OrderBy>;
  skill?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
  userReflectionComment?: InputMaybe<UsersOrderBy>;
};

/** primary key columns input for table: lesson_reflection_comments */
export type LessonReflectionCommentsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "lesson_reflection_comments" */
export enum LessonReflectionCommentsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CustomSkill = 'customSkill',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Details = 'details',
  /** column name */
  Id = 'id',
  /** column name */
  LessonReflectionId = 'lessonReflectionId',
  /** column name */
  Order = 'order',
  /** column name */
  Sentiment = 'sentiment',
  /** column name */
  Skill = 'skill',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "lesson_reflection_comments" */
export type LessonReflectionCommentsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  customSkill?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['time']>;
  details?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  lessonReflectionId?: InputMaybe<Scalars['uuid']>;
  order?: InputMaybe<Scalars['Int']>;
  sentiment?: InputMaybe<FeedbackSentimentEnum>;
  skill?: InputMaybe<LessonSkillsEnum>;
  type?: InputMaybe<LessonReflectionCommentTypesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type LessonReflectionCommentsStddevFields = {
  __typename?: 'LessonReflectionCommentsStddevFields';
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "lesson_reflection_comments" */
export type LessonReflectionCommentsStddevOrderBy = {
  order?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type LessonReflectionCommentsStddevPopFields = {
  __typename?: 'LessonReflectionCommentsStddevPopFields';
  order?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "lesson_reflection_comments" */
export type LessonReflectionCommentsStddevPopOrderBy = {
  order?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type LessonReflectionCommentsStddevSampFields = {
  __typename?: 'LessonReflectionCommentsStddevSampFields';
  order?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "lesson_reflection_comments" */
export type LessonReflectionCommentsStddevSampOrderBy = {
  order?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "lesson_reflection_comments" */
export type LessonReflectionCommentsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: LessonReflectionCommentsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LessonReflectionCommentsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  customSkill?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['time']>;
  details?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  lessonReflectionId?: InputMaybe<Scalars['uuid']>;
  order?: InputMaybe<Scalars['Int']>;
  sentiment?: InputMaybe<FeedbackSentimentEnum>;
  skill?: InputMaybe<LessonSkillsEnum>;
  type?: InputMaybe<LessonReflectionCommentTypesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type LessonReflectionCommentsSumFields = {
  __typename?: 'LessonReflectionCommentsSumFields';
  order?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "lesson_reflection_comments" */
export type LessonReflectionCommentsSumOrderBy = {
  order?: InputMaybe<OrderBy>;
};

/** update columns of table "lesson_reflection_comments" */
export enum LessonReflectionCommentsUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CustomSkill = 'customSkill',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Details = 'details',
  /** column name */
  Id = 'id',
  /** column name */
  LessonReflectionId = 'lessonReflectionId',
  /** column name */
  Order = 'order',
  /** column name */
  Sentiment = 'sentiment',
  /** column name */
  Skill = 'skill',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

export type LessonReflectionCommentsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<LessonReflectionCommentsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LessonReflectionCommentsSetInput>;
  /** filter the rows which have to be updated */
  where: LessonReflectionCommentsBoolExp;
};

/** aggregate varPop on columns */
export type LessonReflectionCommentsVarPopFields = {
  __typename?: 'LessonReflectionCommentsVarPopFields';
  order?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "lesson_reflection_comments" */
export type LessonReflectionCommentsVarPopOrderBy = {
  order?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type LessonReflectionCommentsVarSampFields = {
  __typename?: 'LessonReflectionCommentsVarSampFields';
  order?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "lesson_reflection_comments" */
export type LessonReflectionCommentsVarSampOrderBy = {
  order?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type LessonReflectionCommentsVarianceFields = {
  __typename?: 'LessonReflectionCommentsVarianceFields';
  order?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "lesson_reflection_comments" */
export type LessonReflectionCommentsVarianceOrderBy = {
  order?: InputMaybe<OrderBy>;
};

/** columns and relationships of "lesson_reflection_files" */
export type LessonReflectionFiles = {
  __typename?: 'LessonReflectionFiles';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['time']>;
  fileCategory: Scalars['String'];
  fileFormat: Scalars['String'];
  fileName: Scalars['String'];
  fileType: Scalars['String'];
  host: Scalars['String'];
  id: Scalars['uuid'];
  /** An object relationship */
  lessonReflection?: Maybe<LessonReflections>;
  /** An object relationship */
  lessonReflectionComment?: Maybe<LessonReflectionComments>;
  lessonReflectionCommentId?: Maybe<Scalars['uuid']>;
  lessonReflectionId?: Maybe<Scalars['uuid']>;
  originalFileName: Scalars['String'];
  provider: Scalars['String'];
  providerId: Scalars['String'];
  providerUrl: Scalars['String'];
  transcript: Scalars['String'];
  transcriptEndedAt?: Maybe<Scalars['timestamptz']>;
  transcriptStartedAt?: Maybe<Scalars['timestamptz']>;
  updatedAt: Scalars['timestamptz'];
  url: Scalars['String'];
  /** An object relationship */
  userFiles: Users;
  userId: Scalars['uuid'];
};

/** aggregated selection of "lesson_reflection_files" */
export type LessonReflectionFilesAggregate = {
  __typename?: 'LessonReflectionFilesAggregate';
  aggregate?: Maybe<LessonReflectionFilesAggregateFields>;
  nodes: Array<LessonReflectionFiles>;
};

export type LessonReflectionFilesAggregateBoolExp = {
  count?: InputMaybe<LessonReflectionFilesAggregateBoolExpCount>;
};

/** aggregate fields of "lesson_reflection_files" */
export type LessonReflectionFilesAggregateFields = {
  __typename?: 'LessonReflectionFilesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<LessonReflectionFilesMaxFields>;
  min?: Maybe<LessonReflectionFilesMinFields>;
};


/** aggregate fields of "lesson_reflection_files" */
export type LessonReflectionFilesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<LessonReflectionFilesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "lesson_reflection_files" */
export type LessonReflectionFilesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<LessonReflectionFilesMaxOrderBy>;
  min?: InputMaybe<LessonReflectionFilesMinOrderBy>;
};

/** input type for inserting array relation for remote table "lesson_reflection_files" */
export type LessonReflectionFilesArrRelInsertInput = {
  data: Array<LessonReflectionFilesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<LessonReflectionFilesOnConflict>;
};

/** Boolean expression to filter rows from the table "lesson_reflection_files". All fields are combined with a logical 'AND'. */
export type LessonReflectionFilesBoolExp = {
  _and?: InputMaybe<Array<LessonReflectionFilesBoolExp>>;
  _not?: InputMaybe<LessonReflectionFilesBoolExp>;
  _or?: InputMaybe<Array<LessonReflectionFilesBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimeComparisonExp>;
  fileCategory?: InputMaybe<StringComparisonExp>;
  fileFormat?: InputMaybe<StringComparisonExp>;
  fileName?: InputMaybe<StringComparisonExp>;
  fileType?: InputMaybe<StringComparisonExp>;
  host?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  lessonReflection?: InputMaybe<LessonReflectionsBoolExp>;
  lessonReflectionComment?: InputMaybe<LessonReflectionCommentsBoolExp>;
  lessonReflectionCommentId?: InputMaybe<UuidComparisonExp>;
  lessonReflectionId?: InputMaybe<UuidComparisonExp>;
  originalFileName?: InputMaybe<StringComparisonExp>;
  provider?: InputMaybe<StringComparisonExp>;
  providerId?: InputMaybe<StringComparisonExp>;
  providerUrl?: InputMaybe<StringComparisonExp>;
  transcript?: InputMaybe<StringComparisonExp>;
  transcriptEndedAt?: InputMaybe<TimestamptzComparisonExp>;
  transcriptStartedAt?: InputMaybe<TimestamptzComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  url?: InputMaybe<StringComparisonExp>;
  userFiles?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "lesson_reflection_files" */
export enum LessonReflectionFilesConstraint {
  /** unique or primary key constraint on columns "id" */
  LessonReflectionFilesPkey = 'lesson_reflection_files_pkey'
}

/** input type for inserting data into table "lesson_reflection_files" */
export type LessonReflectionFilesInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['time']>;
  fileCategory?: InputMaybe<Scalars['String']>;
  fileFormat?: InputMaybe<Scalars['String']>;
  fileName?: InputMaybe<Scalars['String']>;
  fileType?: InputMaybe<Scalars['String']>;
  host?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  lessonReflection?: InputMaybe<LessonReflectionsObjRelInsertInput>;
  lessonReflectionComment?: InputMaybe<LessonReflectionCommentsObjRelInsertInput>;
  lessonReflectionCommentId?: InputMaybe<Scalars['uuid']>;
  lessonReflectionId?: InputMaybe<Scalars['uuid']>;
  originalFileName?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  providerId?: InputMaybe<Scalars['String']>;
  providerUrl?: InputMaybe<Scalars['String']>;
  transcript?: InputMaybe<Scalars['String']>;
  transcriptEndedAt?: InputMaybe<Scalars['timestamptz']>;
  transcriptStartedAt?: InputMaybe<Scalars['timestamptz']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  url?: InputMaybe<Scalars['String']>;
  userFiles?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type LessonReflectionFilesMaxFields = {
  __typename?: 'LessonReflectionFilesMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  fileCategory?: Maybe<Scalars['String']>;
  fileFormat?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  fileType?: Maybe<Scalars['String']>;
  host?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  lessonReflectionCommentId?: Maybe<Scalars['uuid']>;
  lessonReflectionId?: Maybe<Scalars['uuid']>;
  originalFileName?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  providerId?: Maybe<Scalars['String']>;
  providerUrl?: Maybe<Scalars['String']>;
  transcript?: Maybe<Scalars['String']>;
  transcriptEndedAt?: Maybe<Scalars['timestamptz']>;
  transcriptStartedAt?: Maybe<Scalars['timestamptz']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  url?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "lesson_reflection_files" */
export type LessonReflectionFilesMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  fileCategory?: InputMaybe<OrderBy>;
  fileFormat?: InputMaybe<OrderBy>;
  fileName?: InputMaybe<OrderBy>;
  fileType?: InputMaybe<OrderBy>;
  host?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lessonReflectionCommentId?: InputMaybe<OrderBy>;
  lessonReflectionId?: InputMaybe<OrderBy>;
  originalFileName?: InputMaybe<OrderBy>;
  provider?: InputMaybe<OrderBy>;
  providerId?: InputMaybe<OrderBy>;
  providerUrl?: InputMaybe<OrderBy>;
  transcript?: InputMaybe<OrderBy>;
  transcriptEndedAt?: InputMaybe<OrderBy>;
  transcriptStartedAt?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  url?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type LessonReflectionFilesMinFields = {
  __typename?: 'LessonReflectionFilesMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  fileCategory?: Maybe<Scalars['String']>;
  fileFormat?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  fileType?: Maybe<Scalars['String']>;
  host?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  lessonReflectionCommentId?: Maybe<Scalars['uuid']>;
  lessonReflectionId?: Maybe<Scalars['uuid']>;
  originalFileName?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  providerId?: Maybe<Scalars['String']>;
  providerUrl?: Maybe<Scalars['String']>;
  transcript?: Maybe<Scalars['String']>;
  transcriptEndedAt?: Maybe<Scalars['timestamptz']>;
  transcriptStartedAt?: Maybe<Scalars['timestamptz']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  url?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "lesson_reflection_files" */
export type LessonReflectionFilesMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  fileCategory?: InputMaybe<OrderBy>;
  fileFormat?: InputMaybe<OrderBy>;
  fileName?: InputMaybe<OrderBy>;
  fileType?: InputMaybe<OrderBy>;
  host?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lessonReflectionCommentId?: InputMaybe<OrderBy>;
  lessonReflectionId?: InputMaybe<OrderBy>;
  originalFileName?: InputMaybe<OrderBy>;
  provider?: InputMaybe<OrderBy>;
  providerId?: InputMaybe<OrderBy>;
  providerUrl?: InputMaybe<OrderBy>;
  transcript?: InputMaybe<OrderBy>;
  transcriptEndedAt?: InputMaybe<OrderBy>;
  transcriptStartedAt?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  url?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "lesson_reflection_files" */
export type LessonReflectionFilesMutationResponse = {
  __typename?: 'LessonReflectionFilesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LessonReflectionFiles>;
};

/** on_conflict condition type for table "lesson_reflection_files" */
export type LessonReflectionFilesOnConflict = {
  constraint: LessonReflectionFilesConstraint;
  updateColumns?: Array<LessonReflectionFilesUpdateColumn>;
  where?: InputMaybe<LessonReflectionFilesBoolExp>;
};

/** Ordering options when selecting data from "lesson_reflection_files". */
export type LessonReflectionFilesOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  fileCategory?: InputMaybe<OrderBy>;
  fileFormat?: InputMaybe<OrderBy>;
  fileName?: InputMaybe<OrderBy>;
  fileType?: InputMaybe<OrderBy>;
  host?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lessonReflection?: InputMaybe<LessonReflectionsOrderBy>;
  lessonReflectionComment?: InputMaybe<LessonReflectionCommentsOrderBy>;
  lessonReflectionCommentId?: InputMaybe<OrderBy>;
  lessonReflectionId?: InputMaybe<OrderBy>;
  originalFileName?: InputMaybe<OrderBy>;
  provider?: InputMaybe<OrderBy>;
  providerId?: InputMaybe<OrderBy>;
  providerUrl?: InputMaybe<OrderBy>;
  transcript?: InputMaybe<OrderBy>;
  transcriptEndedAt?: InputMaybe<OrderBy>;
  transcriptStartedAt?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  url?: InputMaybe<OrderBy>;
  userFiles?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: lesson_reflection_files */
export type LessonReflectionFilesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "lesson_reflection_files" */
export enum LessonReflectionFilesSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  FileCategory = 'fileCategory',
  /** column name */
  FileFormat = 'fileFormat',
  /** column name */
  FileName = 'fileName',
  /** column name */
  FileType = 'fileType',
  /** column name */
  Host = 'host',
  /** column name */
  Id = 'id',
  /** column name */
  LessonReflectionCommentId = 'lessonReflectionCommentId',
  /** column name */
  LessonReflectionId = 'lessonReflectionId',
  /** column name */
  OriginalFileName = 'originalFileName',
  /** column name */
  Provider = 'provider',
  /** column name */
  ProviderId = 'providerId',
  /** column name */
  ProviderUrl = 'providerUrl',
  /** column name */
  Transcript = 'transcript',
  /** column name */
  TranscriptEndedAt = 'transcriptEndedAt',
  /** column name */
  TranscriptStartedAt = 'transcriptStartedAt',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Url = 'url',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "lesson_reflection_files" */
export type LessonReflectionFilesSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['time']>;
  fileCategory?: InputMaybe<Scalars['String']>;
  fileFormat?: InputMaybe<Scalars['String']>;
  fileName?: InputMaybe<Scalars['String']>;
  fileType?: InputMaybe<Scalars['String']>;
  host?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  lessonReflectionCommentId?: InputMaybe<Scalars['uuid']>;
  lessonReflectionId?: InputMaybe<Scalars['uuid']>;
  originalFileName?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  providerId?: InputMaybe<Scalars['String']>;
  providerUrl?: InputMaybe<Scalars['String']>;
  transcript?: InputMaybe<Scalars['String']>;
  transcriptEndedAt?: InputMaybe<Scalars['timestamptz']>;
  transcriptStartedAt?: InputMaybe<Scalars['timestamptz']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  url?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "lesson_reflection_files" */
export type LessonReflectionFilesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: LessonReflectionFilesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LessonReflectionFilesStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['time']>;
  fileCategory?: InputMaybe<Scalars['String']>;
  fileFormat?: InputMaybe<Scalars['String']>;
  fileName?: InputMaybe<Scalars['String']>;
  fileType?: InputMaybe<Scalars['String']>;
  host?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  lessonReflectionCommentId?: InputMaybe<Scalars['uuid']>;
  lessonReflectionId?: InputMaybe<Scalars['uuid']>;
  originalFileName?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  providerId?: InputMaybe<Scalars['String']>;
  providerUrl?: InputMaybe<Scalars['String']>;
  transcript?: InputMaybe<Scalars['String']>;
  transcriptEndedAt?: InputMaybe<Scalars['timestamptz']>;
  transcriptStartedAt?: InputMaybe<Scalars['timestamptz']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  url?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "lesson_reflection_files" */
export enum LessonReflectionFilesUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  FileCategory = 'fileCategory',
  /** column name */
  FileFormat = 'fileFormat',
  /** column name */
  FileName = 'fileName',
  /** column name */
  FileType = 'fileType',
  /** column name */
  Host = 'host',
  /** column name */
  Id = 'id',
  /** column name */
  LessonReflectionCommentId = 'lessonReflectionCommentId',
  /** column name */
  LessonReflectionId = 'lessonReflectionId',
  /** column name */
  OriginalFileName = 'originalFileName',
  /** column name */
  Provider = 'provider',
  /** column name */
  ProviderId = 'providerId',
  /** column name */
  ProviderUrl = 'providerUrl',
  /** column name */
  Transcript = 'transcript',
  /** column name */
  TranscriptEndedAt = 'transcriptEndedAt',
  /** column name */
  TranscriptStartedAt = 'transcriptStartedAt',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Url = 'url',
  /** column name */
  UserId = 'userId'
}

export type LessonReflectionFilesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LessonReflectionFilesSetInput>;
  /** filter the rows which have to be updated */
  where: LessonReflectionFilesBoolExp;
};

/** columns and relationships of "lesson_reflections" */
export type LessonReflections = {
  __typename?: 'LessonReflections';
  assignmentCategory?: Maybe<LessonSkillCategoriesEnum>;
  assignmentSport?: Maybe<SportsEnum>;
  coachUserId: Scalars['uuid'];
  completedCategory?: Maybe<LessonSkillCategoriesEnum>;
  completedSport?: Maybe<SportsEnum>;
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['time']>;
  details?: Maybe<Scalars['String']>;
  /** An array relationship */
  files: Array<LessonReflectionFiles>;
  /** An aggregate relationship */
  filesAggregate: LessonReflectionFilesAggregate;
  id: Scalars['uuid'];
  /** An object relationship */
  lesson: Lessons;
  /** An object relationship */
  lessonCoach?: Maybe<UserProfiles>;
  lessonId: Scalars['uuid'];
  /** An object relationship */
  lessonPlayer?: Maybe<UserProfiles>;
  /** An array relationship */
  lessonReflectionComments: Array<LessonReflectionComments>;
  /** An aggregate relationship */
  lessonReflectionCommentsAggregate: LessonReflectionCommentsAggregate;
  playerDismissedAt?: Maybe<Scalars['timestamptz']>;
  playerUserId: Scalars['uuid'];
  reviewStatus: VideoAnalysisReviewStatusesEnum;
  reviewerUserId?: Maybe<Scalars['uuid']>;
  submissionRequestedFeedback?: Maybe<Scalars['String']>;
  submissionUserId?: Maybe<Scalars['uuid']>;
  upcomingCategory?: Maybe<LessonSkillCategoriesEnum>;
  upcomingSport?: Maybe<SportsEnum>;
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "lesson_reflections" */
export type LessonReflectionsFilesArgs = {
  distinctOn?: InputMaybe<Array<LessonReflectionFilesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonReflectionFilesOrderBy>>;
  where?: InputMaybe<LessonReflectionFilesBoolExp>;
};


/** columns and relationships of "lesson_reflections" */
export type LessonReflectionsFilesAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonReflectionFilesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonReflectionFilesOrderBy>>;
  where?: InputMaybe<LessonReflectionFilesBoolExp>;
};


/** columns and relationships of "lesson_reflections" */
export type LessonReflectionsLessonReflectionCommentsArgs = {
  distinctOn?: InputMaybe<Array<LessonReflectionCommentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonReflectionCommentsOrderBy>>;
  where?: InputMaybe<LessonReflectionCommentsBoolExp>;
};


/** columns and relationships of "lesson_reflections" */
export type LessonReflectionsLessonReflectionCommentsAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonReflectionCommentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonReflectionCommentsOrderBy>>;
  where?: InputMaybe<LessonReflectionCommentsBoolExp>;
};

/** aggregated selection of "lesson_reflections" */
export type LessonReflectionsAggregate = {
  __typename?: 'LessonReflectionsAggregate';
  aggregate?: Maybe<LessonReflectionsAggregateFields>;
  nodes: Array<LessonReflections>;
};

export type LessonReflectionsAggregateBoolExp = {
  count?: InputMaybe<LessonReflectionsAggregateBoolExpCount>;
};

/** aggregate fields of "lesson_reflections" */
export type LessonReflectionsAggregateFields = {
  __typename?: 'LessonReflectionsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<LessonReflectionsMaxFields>;
  min?: Maybe<LessonReflectionsMinFields>;
};


/** aggregate fields of "lesson_reflections" */
export type LessonReflectionsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<LessonReflectionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "lesson_reflections" */
export type LessonReflectionsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<LessonReflectionsMaxOrderBy>;
  min?: InputMaybe<LessonReflectionsMinOrderBy>;
};

/** input type for inserting array relation for remote table "lesson_reflections" */
export type LessonReflectionsArrRelInsertInput = {
  data: Array<LessonReflectionsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<LessonReflectionsOnConflict>;
};

/** Boolean expression to filter rows from the table "lesson_reflections". All fields are combined with a logical 'AND'. */
export type LessonReflectionsBoolExp = {
  _and?: InputMaybe<Array<LessonReflectionsBoolExp>>;
  _not?: InputMaybe<LessonReflectionsBoolExp>;
  _or?: InputMaybe<Array<LessonReflectionsBoolExp>>;
  assignmentCategory?: InputMaybe<LessonSkillCategoriesEnumComparisonExp>;
  assignmentSport?: InputMaybe<SportsEnumComparisonExp>;
  coachUserId?: InputMaybe<UuidComparisonExp>;
  completedCategory?: InputMaybe<LessonSkillCategoriesEnumComparisonExp>;
  completedSport?: InputMaybe<SportsEnumComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimeComparisonExp>;
  details?: InputMaybe<StringComparisonExp>;
  files?: InputMaybe<LessonReflectionFilesBoolExp>;
  filesAggregate?: InputMaybe<LessonReflectionFilesAggregateBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  lesson?: InputMaybe<LessonsBoolExp>;
  lessonCoach?: InputMaybe<UserProfilesBoolExp>;
  lessonId?: InputMaybe<UuidComparisonExp>;
  lessonPlayer?: InputMaybe<UserProfilesBoolExp>;
  lessonReflectionComments?: InputMaybe<LessonReflectionCommentsBoolExp>;
  lessonReflectionCommentsAggregate?: InputMaybe<LessonReflectionCommentsAggregateBoolExp>;
  playerDismissedAt?: InputMaybe<TimestamptzComparisonExp>;
  playerUserId?: InputMaybe<UuidComparisonExp>;
  reviewStatus?: InputMaybe<VideoAnalysisReviewStatusesEnumComparisonExp>;
  reviewerUserId?: InputMaybe<UuidComparisonExp>;
  submissionRequestedFeedback?: InputMaybe<StringComparisonExp>;
  submissionUserId?: InputMaybe<UuidComparisonExp>;
  upcomingCategory?: InputMaybe<LessonSkillCategoriesEnumComparisonExp>;
  upcomingSport?: InputMaybe<SportsEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "lesson_reflections" */
export enum LessonReflectionsConstraint {
  /** unique or primary key constraint on columns "id" */
  LessonReflectionsPkey = 'lesson_reflections_pkey'
}

/** input type for inserting data into table "lesson_reflections" */
export type LessonReflectionsInsertInput = {
  assignmentCategory?: InputMaybe<LessonSkillCategoriesEnum>;
  assignmentSport?: InputMaybe<SportsEnum>;
  coachUserId?: InputMaybe<Scalars['uuid']>;
  completedCategory?: InputMaybe<LessonSkillCategoriesEnum>;
  completedSport?: InputMaybe<SportsEnum>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['time']>;
  details?: InputMaybe<Scalars['String']>;
  files?: InputMaybe<LessonReflectionFilesArrRelInsertInput>;
  id?: InputMaybe<Scalars['uuid']>;
  lesson?: InputMaybe<LessonsObjRelInsertInput>;
  lessonCoach?: InputMaybe<UserProfilesObjRelInsertInput>;
  lessonId?: InputMaybe<Scalars['uuid']>;
  lessonPlayer?: InputMaybe<UserProfilesObjRelInsertInput>;
  lessonReflectionComments?: InputMaybe<LessonReflectionCommentsArrRelInsertInput>;
  playerDismissedAt?: InputMaybe<Scalars['timestamptz']>;
  playerUserId?: InputMaybe<Scalars['uuid']>;
  reviewStatus?: InputMaybe<VideoAnalysisReviewStatusesEnum>;
  reviewerUserId?: InputMaybe<Scalars['uuid']>;
  submissionRequestedFeedback?: InputMaybe<Scalars['String']>;
  submissionUserId?: InputMaybe<Scalars['uuid']>;
  upcomingCategory?: InputMaybe<LessonSkillCategoriesEnum>;
  upcomingSport?: InputMaybe<SportsEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type LessonReflectionsMaxFields = {
  __typename?: 'LessonReflectionsMaxFields';
  coachUserId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  details?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  lessonId?: Maybe<Scalars['uuid']>;
  playerDismissedAt?: Maybe<Scalars['timestamptz']>;
  playerUserId?: Maybe<Scalars['uuid']>;
  reviewerUserId?: Maybe<Scalars['uuid']>;
  submissionRequestedFeedback?: Maybe<Scalars['String']>;
  submissionUserId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "lesson_reflections" */
export type LessonReflectionsMaxOrderBy = {
  coachUserId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  details?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lessonId?: InputMaybe<OrderBy>;
  playerDismissedAt?: InputMaybe<OrderBy>;
  playerUserId?: InputMaybe<OrderBy>;
  reviewerUserId?: InputMaybe<OrderBy>;
  submissionRequestedFeedback?: InputMaybe<OrderBy>;
  submissionUserId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type LessonReflectionsMinFields = {
  __typename?: 'LessonReflectionsMinFields';
  coachUserId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  details?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  lessonId?: Maybe<Scalars['uuid']>;
  playerDismissedAt?: Maybe<Scalars['timestamptz']>;
  playerUserId?: Maybe<Scalars['uuid']>;
  reviewerUserId?: Maybe<Scalars['uuid']>;
  submissionRequestedFeedback?: Maybe<Scalars['String']>;
  submissionUserId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "lesson_reflections" */
export type LessonReflectionsMinOrderBy = {
  coachUserId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  details?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lessonId?: InputMaybe<OrderBy>;
  playerDismissedAt?: InputMaybe<OrderBy>;
  playerUserId?: InputMaybe<OrderBy>;
  reviewerUserId?: InputMaybe<OrderBy>;
  submissionRequestedFeedback?: InputMaybe<OrderBy>;
  submissionUserId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "lesson_reflections" */
export type LessonReflectionsMutationResponse = {
  __typename?: 'LessonReflectionsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LessonReflections>;
};

/** input type for inserting object relation for remote table "lesson_reflections" */
export type LessonReflectionsObjRelInsertInput = {
  data: LessonReflectionsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<LessonReflectionsOnConflict>;
};

/** on_conflict condition type for table "lesson_reflections" */
export type LessonReflectionsOnConflict = {
  constraint: LessonReflectionsConstraint;
  updateColumns?: Array<LessonReflectionsUpdateColumn>;
  where?: InputMaybe<LessonReflectionsBoolExp>;
};

/** Ordering options when selecting data from "lesson_reflections". */
export type LessonReflectionsOrderBy = {
  assignmentCategory?: InputMaybe<OrderBy>;
  assignmentSport?: InputMaybe<OrderBy>;
  coachUserId?: InputMaybe<OrderBy>;
  completedCategory?: InputMaybe<OrderBy>;
  completedSport?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  details?: InputMaybe<OrderBy>;
  filesAggregate?: InputMaybe<LessonReflectionFilesAggregateOrderBy>;
  id?: InputMaybe<OrderBy>;
  lesson?: InputMaybe<LessonsOrderBy>;
  lessonCoach?: InputMaybe<UserProfilesOrderBy>;
  lessonId?: InputMaybe<OrderBy>;
  lessonPlayer?: InputMaybe<UserProfilesOrderBy>;
  lessonReflectionCommentsAggregate?: InputMaybe<LessonReflectionCommentsAggregateOrderBy>;
  playerDismissedAt?: InputMaybe<OrderBy>;
  playerUserId?: InputMaybe<OrderBy>;
  reviewStatus?: InputMaybe<OrderBy>;
  reviewerUserId?: InputMaybe<OrderBy>;
  submissionRequestedFeedback?: InputMaybe<OrderBy>;
  submissionUserId?: InputMaybe<OrderBy>;
  upcomingCategory?: InputMaybe<OrderBy>;
  upcomingSport?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: lesson_reflections */
export type LessonReflectionsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "lesson_reflections" */
export enum LessonReflectionsSelectColumn {
  /** column name */
  AssignmentCategory = 'assignmentCategory',
  /** column name */
  AssignmentSport = 'assignmentSport',
  /** column name */
  CoachUserId = 'coachUserId',
  /** column name */
  CompletedCategory = 'completedCategory',
  /** column name */
  CompletedSport = 'completedSport',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Details = 'details',
  /** column name */
  Id = 'id',
  /** column name */
  LessonId = 'lessonId',
  /** column name */
  PlayerDismissedAt = 'playerDismissedAt',
  /** column name */
  PlayerUserId = 'playerUserId',
  /** column name */
  ReviewStatus = 'reviewStatus',
  /** column name */
  ReviewerUserId = 'reviewerUserId',
  /** column name */
  SubmissionRequestedFeedback = 'submissionRequestedFeedback',
  /** column name */
  SubmissionUserId = 'submissionUserId',
  /** column name */
  UpcomingCategory = 'upcomingCategory',
  /** column name */
  UpcomingSport = 'upcomingSport',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "lesson_reflections" */
export type LessonReflectionsSetInput = {
  assignmentCategory?: InputMaybe<LessonSkillCategoriesEnum>;
  assignmentSport?: InputMaybe<SportsEnum>;
  coachUserId?: InputMaybe<Scalars['uuid']>;
  completedCategory?: InputMaybe<LessonSkillCategoriesEnum>;
  completedSport?: InputMaybe<SportsEnum>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['time']>;
  details?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  lessonId?: InputMaybe<Scalars['uuid']>;
  playerDismissedAt?: InputMaybe<Scalars['timestamptz']>;
  playerUserId?: InputMaybe<Scalars['uuid']>;
  reviewStatus?: InputMaybe<VideoAnalysisReviewStatusesEnum>;
  reviewerUserId?: InputMaybe<Scalars['uuid']>;
  submissionRequestedFeedback?: InputMaybe<Scalars['String']>;
  submissionUserId?: InputMaybe<Scalars['uuid']>;
  upcomingCategory?: InputMaybe<LessonSkillCategoriesEnum>;
  upcomingSport?: InputMaybe<SportsEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "lesson_reflections" */
export type LessonReflectionsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: LessonReflectionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LessonReflectionsStreamCursorValueInput = {
  assignmentCategory?: InputMaybe<LessonSkillCategoriesEnum>;
  assignmentSport?: InputMaybe<SportsEnum>;
  coachUserId?: InputMaybe<Scalars['uuid']>;
  completedCategory?: InputMaybe<LessonSkillCategoriesEnum>;
  completedSport?: InputMaybe<SportsEnum>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['time']>;
  details?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  lessonId?: InputMaybe<Scalars['uuid']>;
  playerDismissedAt?: InputMaybe<Scalars['timestamptz']>;
  playerUserId?: InputMaybe<Scalars['uuid']>;
  reviewStatus?: InputMaybe<VideoAnalysisReviewStatusesEnum>;
  reviewerUserId?: InputMaybe<Scalars['uuid']>;
  submissionRequestedFeedback?: InputMaybe<Scalars['String']>;
  submissionUserId?: InputMaybe<Scalars['uuid']>;
  upcomingCategory?: InputMaybe<LessonSkillCategoriesEnum>;
  upcomingSport?: InputMaybe<SportsEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "lesson_reflections" */
export enum LessonReflectionsUpdateColumn {
  /** column name */
  AssignmentCategory = 'assignmentCategory',
  /** column name */
  AssignmentSport = 'assignmentSport',
  /** column name */
  CoachUserId = 'coachUserId',
  /** column name */
  CompletedCategory = 'completedCategory',
  /** column name */
  CompletedSport = 'completedSport',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Details = 'details',
  /** column name */
  Id = 'id',
  /** column name */
  LessonId = 'lessonId',
  /** column name */
  PlayerDismissedAt = 'playerDismissedAt',
  /** column name */
  PlayerUserId = 'playerUserId',
  /** column name */
  ReviewStatus = 'reviewStatus',
  /** column name */
  ReviewerUserId = 'reviewerUserId',
  /** column name */
  SubmissionRequestedFeedback = 'submissionRequestedFeedback',
  /** column name */
  SubmissionUserId = 'submissionUserId',
  /** column name */
  UpcomingCategory = 'upcomingCategory',
  /** column name */
  UpcomingSport = 'upcomingSport',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type LessonReflectionsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LessonReflectionsSetInput>;
  /** filter the rows which have to be updated */
  where: LessonReflectionsBoolExp;
};

/** columns and relationships of "lesson_skill_categories" */
export type LessonSkillCategories = {
  __typename?: 'LessonSkillCategories';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "lesson_skill_categories" */
export type LessonSkillCategoriesAggregate = {
  __typename?: 'LessonSkillCategoriesAggregate';
  aggregate?: Maybe<LessonSkillCategoriesAggregateFields>;
  nodes: Array<LessonSkillCategories>;
};

/** aggregate fields of "lesson_skill_categories" */
export type LessonSkillCategoriesAggregateFields = {
  __typename?: 'LessonSkillCategoriesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<LessonSkillCategoriesMaxFields>;
  min?: Maybe<LessonSkillCategoriesMinFields>;
};


/** aggregate fields of "lesson_skill_categories" */
export type LessonSkillCategoriesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<LessonSkillCategoriesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "lesson_skill_categories". All fields are combined with a logical 'AND'. */
export type LessonSkillCategoriesBoolExp = {
  _and?: InputMaybe<Array<LessonSkillCategoriesBoolExp>>;
  _not?: InputMaybe<LessonSkillCategoriesBoolExp>;
  _or?: InputMaybe<Array<LessonSkillCategoriesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "lesson_skill_categories" */
export enum LessonSkillCategoriesConstraint {
  /** unique or primary key constraint on columns "value" */
  LessonSkillCategoriesPkey = 'lesson_skill_categories_pkey'
}

export enum LessonSkillCategoriesEnum {
  P4 = 'P4',
  Quatro = 'QUATRO'
}

/** Boolean expression to compare columns of type "LessonSkillCategoriesEnum". All fields are combined with logical 'AND'. */
export type LessonSkillCategoriesEnumComparisonExp = {
  _eq?: InputMaybe<LessonSkillCategoriesEnum>;
  _in?: InputMaybe<Array<LessonSkillCategoriesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<LessonSkillCategoriesEnum>;
  _nin?: InputMaybe<Array<LessonSkillCategoriesEnum>>;
};

/** input type for inserting data into table "lesson_skill_categories" */
export type LessonSkillCategoriesInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type LessonSkillCategoriesMaxFields = {
  __typename?: 'LessonSkillCategoriesMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type LessonSkillCategoriesMinFields = {
  __typename?: 'LessonSkillCategoriesMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "lesson_skill_categories" */
export type LessonSkillCategoriesMutationResponse = {
  __typename?: 'LessonSkillCategoriesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LessonSkillCategories>;
};

/** on_conflict condition type for table "lesson_skill_categories" */
export type LessonSkillCategoriesOnConflict = {
  constraint: LessonSkillCategoriesConstraint;
  updateColumns?: Array<LessonSkillCategoriesUpdateColumn>;
  where?: InputMaybe<LessonSkillCategoriesBoolExp>;
};

/** Ordering options when selecting data from "lesson_skill_categories". */
export type LessonSkillCategoriesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: lesson_skill_categories */
export type LessonSkillCategoriesPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "lesson_skill_categories" */
export enum LessonSkillCategoriesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "lesson_skill_categories" */
export type LessonSkillCategoriesSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "lesson_skill_categories" */
export type LessonSkillCategoriesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: LessonSkillCategoriesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LessonSkillCategoriesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "lesson_skill_categories" */
export enum LessonSkillCategoriesUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type LessonSkillCategoriesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LessonSkillCategoriesSetInput>;
  /** filter the rows which have to be updated */
  where: LessonSkillCategoriesBoolExp;
};

/** columns and relationships of "lesson_skill_display_names" */
export type LessonSkillDisplayNames = {
  __typename?: 'LessonSkillDisplayNames';
  createdAt: Scalars['timestamptz'];
  description: Scalars['String'];
  displayName: Scalars['String'];
  id: LessonSkillsEnum;
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "lesson_skill_display_names" */
export type LessonSkillDisplayNamesAggregate = {
  __typename?: 'LessonSkillDisplayNamesAggregate';
  aggregate?: Maybe<LessonSkillDisplayNamesAggregateFields>;
  nodes: Array<LessonSkillDisplayNames>;
};

/** aggregate fields of "lesson_skill_display_names" */
export type LessonSkillDisplayNamesAggregateFields = {
  __typename?: 'LessonSkillDisplayNamesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<LessonSkillDisplayNamesMaxFields>;
  min?: Maybe<LessonSkillDisplayNamesMinFields>;
};


/** aggregate fields of "lesson_skill_display_names" */
export type LessonSkillDisplayNamesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<LessonSkillDisplayNamesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "lesson_skill_display_names". All fields are combined with a logical 'AND'. */
export type LessonSkillDisplayNamesBoolExp = {
  _and?: InputMaybe<Array<LessonSkillDisplayNamesBoolExp>>;
  _not?: InputMaybe<LessonSkillDisplayNamesBoolExp>;
  _or?: InputMaybe<Array<LessonSkillDisplayNamesBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  displayName?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<LessonSkillsEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "lesson_skill_display_names" */
export enum LessonSkillDisplayNamesConstraint {
  /** unique or primary key constraint on columns "id" */
  LessonSkillDisplayNamesPkey = 'lesson_skill_display_names_pkey'
}

/** input type for inserting data into table "lesson_skill_display_names" */
export type LessonSkillDisplayNamesInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  displayName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<LessonSkillsEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type LessonSkillDisplayNamesMaxFields = {
  __typename?: 'LessonSkillDisplayNamesMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type LessonSkillDisplayNamesMinFields = {
  __typename?: 'LessonSkillDisplayNamesMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "lesson_skill_display_names" */
export type LessonSkillDisplayNamesMutationResponse = {
  __typename?: 'LessonSkillDisplayNamesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LessonSkillDisplayNames>;
};

/** on_conflict condition type for table "lesson_skill_display_names" */
export type LessonSkillDisplayNamesOnConflict = {
  constraint: LessonSkillDisplayNamesConstraint;
  updateColumns?: Array<LessonSkillDisplayNamesUpdateColumn>;
  where?: InputMaybe<LessonSkillDisplayNamesBoolExp>;
};

/** Ordering options when selecting data from "lesson_skill_display_names". */
export type LessonSkillDisplayNamesOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  displayName?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: lesson_skill_display_names */
export type LessonSkillDisplayNamesPkColumnsInput = {
  id: LessonSkillsEnum;
};

/** select columns of table "lesson_skill_display_names" */
export enum LessonSkillDisplayNamesSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  DisplayName = 'displayName',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "lesson_skill_display_names" */
export type LessonSkillDisplayNamesSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  displayName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<LessonSkillsEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "lesson_skill_display_names" */
export type LessonSkillDisplayNamesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: LessonSkillDisplayNamesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LessonSkillDisplayNamesStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  displayName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<LessonSkillsEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "lesson_skill_display_names" */
export enum LessonSkillDisplayNamesUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  DisplayName = 'displayName',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type LessonSkillDisplayNamesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LessonSkillDisplayNamesSetInput>;
  /** filter the rows which have to be updated */
  where: LessonSkillDisplayNamesBoolExp;
};

/** columns and relationships of "lesson_skill_levels" */
export type LessonSkillLevels = {
  __typename?: 'LessonSkillLevels';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  /** An object relationship */
  lesson: Lessons;
  lessonId: Scalars['uuid'];
  skillLevel: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "lesson_skill_levels" */
export type LessonSkillLevelsAggregate = {
  __typename?: 'LessonSkillLevelsAggregate';
  aggregate?: Maybe<LessonSkillLevelsAggregateFields>;
  nodes: Array<LessonSkillLevels>;
};

export type LessonSkillLevelsAggregateBoolExp = {
  count?: InputMaybe<LessonSkillLevelsAggregateBoolExpCount>;
};

/** aggregate fields of "lesson_skill_levels" */
export type LessonSkillLevelsAggregateFields = {
  __typename?: 'LessonSkillLevelsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<LessonSkillLevelsMaxFields>;
  min?: Maybe<LessonSkillLevelsMinFields>;
};


/** aggregate fields of "lesson_skill_levels" */
export type LessonSkillLevelsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<LessonSkillLevelsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "lesson_skill_levels" */
export type LessonSkillLevelsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<LessonSkillLevelsMaxOrderBy>;
  min?: InputMaybe<LessonSkillLevelsMinOrderBy>;
};

/** input type for inserting array relation for remote table "lesson_skill_levels" */
export type LessonSkillLevelsArrRelInsertInput = {
  data: Array<LessonSkillLevelsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<LessonSkillLevelsOnConflict>;
};

/** Boolean expression to filter rows from the table "lesson_skill_levels". All fields are combined with a logical 'AND'. */
export type LessonSkillLevelsBoolExp = {
  _and?: InputMaybe<Array<LessonSkillLevelsBoolExp>>;
  _not?: InputMaybe<LessonSkillLevelsBoolExp>;
  _or?: InputMaybe<Array<LessonSkillLevelsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  lesson?: InputMaybe<LessonsBoolExp>;
  lessonId?: InputMaybe<UuidComparisonExp>;
  skillLevel?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "lesson_skill_levels" */
export enum LessonSkillLevelsConstraint {
  /** unique or primary key constraint on columns "lesson_id", "skill_level" */
  LessonSkillLevelsLessonIdSkillLevelKey = 'lesson_skill_levels_lesson_id_skill_level_key',
  /** unique or primary key constraint on columns "id" */
  LessonSkillLevelsPkey = 'lesson_skill_levels_pkey'
}

/** input type for inserting data into table "lesson_skill_levels" */
export type LessonSkillLevelsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  lesson?: InputMaybe<LessonsObjRelInsertInput>;
  lessonId?: InputMaybe<Scalars['uuid']>;
  skillLevel?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type LessonSkillLevelsMaxFields = {
  __typename?: 'LessonSkillLevelsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  lessonId?: Maybe<Scalars['uuid']>;
  skillLevel?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "lesson_skill_levels" */
export type LessonSkillLevelsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lessonId?: InputMaybe<OrderBy>;
  skillLevel?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type LessonSkillLevelsMinFields = {
  __typename?: 'LessonSkillLevelsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  lessonId?: Maybe<Scalars['uuid']>;
  skillLevel?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "lesson_skill_levels" */
export type LessonSkillLevelsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lessonId?: InputMaybe<OrderBy>;
  skillLevel?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "lesson_skill_levels" */
export type LessonSkillLevelsMutationResponse = {
  __typename?: 'LessonSkillLevelsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LessonSkillLevels>;
};

/** on_conflict condition type for table "lesson_skill_levels" */
export type LessonSkillLevelsOnConflict = {
  constraint: LessonSkillLevelsConstraint;
  updateColumns?: Array<LessonSkillLevelsUpdateColumn>;
  where?: InputMaybe<LessonSkillLevelsBoolExp>;
};

/** Ordering options when selecting data from "lesson_skill_levels". */
export type LessonSkillLevelsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lesson?: InputMaybe<LessonsOrderBy>;
  lessonId?: InputMaybe<OrderBy>;
  skillLevel?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: lesson_skill_levels */
export type LessonSkillLevelsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "lesson_skill_levels" */
export enum LessonSkillLevelsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  LessonId = 'lessonId',
  /** column name */
  SkillLevel = 'skillLevel',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "lesson_skill_levels" */
export type LessonSkillLevelsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  lessonId?: InputMaybe<Scalars['uuid']>;
  skillLevel?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "lesson_skill_levels" */
export type LessonSkillLevelsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: LessonSkillLevelsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LessonSkillLevelsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  lessonId?: InputMaybe<Scalars['uuid']>;
  skillLevel?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "lesson_skill_levels" */
export enum LessonSkillLevelsUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  LessonId = 'lessonId',
  /** column name */
  SkillLevel = 'skillLevel',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type LessonSkillLevelsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LessonSkillLevelsSetInput>;
  /** filter the rows which have to be updated */
  where: LessonSkillLevelsBoolExp;
};

/** columns and relationships of "lesson_skill_mappings" */
export type LessonSkillMappings = {
  __typename?: 'LessonSkillMappings';
  category?: Maybe<LessonSkillCategoriesEnum>;
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  skill: LessonSkillsEnum;
  sport?: Maybe<SportsEnum>;
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "lesson_skill_mappings" */
export type LessonSkillMappingsAggregate = {
  __typename?: 'LessonSkillMappingsAggregate';
  aggregate?: Maybe<LessonSkillMappingsAggregateFields>;
  nodes: Array<LessonSkillMappings>;
};

/** aggregate fields of "lesson_skill_mappings" */
export type LessonSkillMappingsAggregateFields = {
  __typename?: 'LessonSkillMappingsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<LessonSkillMappingsMaxFields>;
  min?: Maybe<LessonSkillMappingsMinFields>;
};


/** aggregate fields of "lesson_skill_mappings" */
export type LessonSkillMappingsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<LessonSkillMappingsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "lesson_skill_mappings". All fields are combined with a logical 'AND'. */
export type LessonSkillMappingsBoolExp = {
  _and?: InputMaybe<Array<LessonSkillMappingsBoolExp>>;
  _not?: InputMaybe<LessonSkillMappingsBoolExp>;
  _or?: InputMaybe<Array<LessonSkillMappingsBoolExp>>;
  category?: InputMaybe<LessonSkillCategoriesEnumComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  skill?: InputMaybe<LessonSkillsEnumComparisonExp>;
  sport?: InputMaybe<SportsEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "lesson_skill_mappings" */
export enum LessonSkillMappingsConstraint {
  /** unique or primary key constraint on columns "id" */
  LessonSkillMappingsPkey = 'lesson_skill_mappings_pkey'
}

/** input type for inserting data into table "lesson_skill_mappings" */
export type LessonSkillMappingsInsertInput = {
  category?: InputMaybe<LessonSkillCategoriesEnum>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  skill?: InputMaybe<LessonSkillsEnum>;
  sport?: InputMaybe<SportsEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type LessonSkillMappingsMaxFields = {
  __typename?: 'LessonSkillMappingsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type LessonSkillMappingsMinFields = {
  __typename?: 'LessonSkillMappingsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "lesson_skill_mappings" */
export type LessonSkillMappingsMutationResponse = {
  __typename?: 'LessonSkillMappingsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LessonSkillMappings>;
};

/** on_conflict condition type for table "lesson_skill_mappings" */
export type LessonSkillMappingsOnConflict = {
  constraint: LessonSkillMappingsConstraint;
  updateColumns?: Array<LessonSkillMappingsUpdateColumn>;
  where?: InputMaybe<LessonSkillMappingsBoolExp>;
};

/** Ordering options when selecting data from "lesson_skill_mappings". */
export type LessonSkillMappingsOrderBy = {
  category?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  skill?: InputMaybe<OrderBy>;
  sport?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: lesson_skill_mappings */
export type LessonSkillMappingsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "lesson_skill_mappings" */
export enum LessonSkillMappingsSelectColumn {
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  Skill = 'skill',
  /** column name */
  Sport = 'sport',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "lesson_skill_mappings" */
export type LessonSkillMappingsSetInput = {
  category?: InputMaybe<LessonSkillCategoriesEnum>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  skill?: InputMaybe<LessonSkillsEnum>;
  sport?: InputMaybe<SportsEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "lesson_skill_mappings" */
export type LessonSkillMappingsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: LessonSkillMappingsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LessonSkillMappingsStreamCursorValueInput = {
  category?: InputMaybe<LessonSkillCategoriesEnum>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  skill?: InputMaybe<LessonSkillsEnum>;
  sport?: InputMaybe<SportsEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "lesson_skill_mappings" */
export enum LessonSkillMappingsUpdateColumn {
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  Skill = 'skill',
  /** column name */
  Sport = 'sport',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type LessonSkillMappingsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LessonSkillMappingsSetInput>;
  /** filter the rows which have to be updated */
  where: LessonSkillMappingsBoolExp;
};

/** columns and relationships of "lesson_skills" */
export type LessonSkills = {
  __typename?: 'LessonSkills';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "lesson_skills" */
export type LessonSkillsAggregate = {
  __typename?: 'LessonSkillsAggregate';
  aggregate?: Maybe<LessonSkillsAggregateFields>;
  nodes: Array<LessonSkills>;
};

/** aggregate fields of "lesson_skills" */
export type LessonSkillsAggregateFields = {
  __typename?: 'LessonSkillsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<LessonSkillsMaxFields>;
  min?: Maybe<LessonSkillsMinFields>;
};


/** aggregate fields of "lesson_skills" */
export type LessonSkillsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<LessonSkillsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "lesson_skills". All fields are combined with a logical 'AND'. */
export type LessonSkillsBoolExp = {
  _and?: InputMaybe<Array<LessonSkillsBoolExp>>;
  _not?: InputMaybe<LessonSkillsBoolExp>;
  _or?: InputMaybe<Array<LessonSkillsBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "lesson_skills" */
export enum LessonSkillsConstraint {
  /** unique or primary key constraint on columns "value" */
  LessonSkillsPkey = 'lesson_skills_pkey'
}

export enum LessonSkillsEnum {
  Atp = 'ATP',
  Backhand = 'BACKHAND',
  BaselineQuad = 'BASELINE_QUAD',
  Communication = 'COMMUNICATION',
  CourtPositioning = 'COURT_POSITIONING',
  DepthQuads = 'DEPTH_QUADS',
  Dink = 'DINK',
  DirectionalQuads = 'DIRECTIONAL_QUADS',
  Drive = 'DRIVE',
  Drop = 'DROP',
  Ernie = 'ERNIE',
  Flick = 'FLICK',
  FootWork = 'FOOT_WORK',
  Forehand = 'FOREHAND',
  HalfVolley = 'HALF_VOLLEY',
  HeatQuad = 'HEAT_QUAD',
  InsideOut = 'INSIDE_OUT',
  KitchenQuad = 'KITCHEN_QUAD',
  Lob = 'LOB',
  MentalSkills = 'MENTAL_SKILLS',
  OutsideIn = 'OUTSIDE_IN',
  P4Atp = 'P4_ATP',
  P4BallSector = 'P4_BALL_SECTOR',
  P4BaselineZone = 'P4_BASELINE_ZONE',
  P4BodyZone = 'P4_BODY_ZONE',
  P4DepthZone = 'P4_DEPTH_ZONE',
  P4Dinks = 'P4_DINKS',
  P4DirectionalZone = 'P4_DIRECTIONAL_ZONE',
  P4Drips = 'P4_DRIPS',
  P4Drives = 'P4_DRIVES',
  P4Drops = 'P4_DROPS',
  P4EnergyBounce = 'P4_ENERGY_BOUNCE',
  P4EnergyTransitionZone = 'P4_ENERGY_TRANSITION_ZONE',
  P4EnergyVolley = 'P4_ENERGY_VOLLEY',
  P4Erne = 'P4_ERNE',
  P4Footwork = 'P4_FOOTWORK',
  P4HeatZone = 'P4_HEAT_ZONE',
  P4KitchenZone = 'P4_KITCHEN_ZONE',
  P4Lobs = 'P4_LOBS',
  P4Mindset = 'P4_MINDSET',
  P4Pod = 'P4_POD',
  P4ReadyPosition = 'P4_READY_POSITION',
  P4Resets = 'P4_RESETS',
  P4Returns = 'P4_RETURNS',
  P4Serves = 'P4_SERVES',
  P4ShallowDinks = 'P4_SHALLOW_DINKS',
  P4ShallowZonePro = 'P4_SHALLOW_ZONE_PRO',
  P4TransitionZone = 'P4_TRANSITION_ZONE',
  P4Volleys = 'P4_VOLLEYS',
  P4VolleyDinks = 'P4_VOLLEY_DINKS',
  QuatroAtp = 'QUATRO_ATP',
  QuatroBallQuads = 'QUATRO_BALL_QUADS',
  QuatroBodyQuads = 'QUATRO_BODY_QUADS',
  QuatroDinks = 'QUATRO_DINKS',
  QuatroDrips = 'QUATRO_DRIPS',
  QuatroDrives = 'QUATRO_DRIVES',
  QuatroDrops = 'QUATRO_DROPS',
  QuatroEnergyBounce = 'QUATRO_ENERGY_BOUNCE',
  QuatroEnergyTransitionQuad = 'QUATRO_ENERGY_TRANSITION_QUAD',
  QuatroEnergyVolley = 'QUATRO_ENERGY_VOLLEY',
  QuatroErne = 'QUATRO_ERNE',
  QuatroFootwork = 'QUATRO_FOOTWORK',
  QuatroLobs = 'QUATRO_LOBS',
  QuatroMindset = 'QUATRO_MINDSET',
  QuatroQuabble = 'QUATRO_QUABBLE',
  QuatroReadyPosition = 'QUATRO_READY_POSITION',
  QuatroResets = 'QUATRO_RESETS',
  QuatroReturns = 'QUATRO_RETURNS',
  QuatroServes = 'QUATRO_SERVES',
  QuatroShallowDinks = 'QUATRO_SHALLOW_DINKS',
  QuatroVolleys = 'QUATRO_VOLLEYS',
  QuatroVolleyDinks = 'QUATRO_VOLLEY_DINKS',
  Reset = 'RESET',
  Return = 'RETURN',
  SecondServe = 'SECOND_SERVE',
  Serve = 'SERVE',
  ShallowQuadPro = 'SHALLOW_QUAD_PRO',
  Slice = 'SLICE',
  Smash = 'SMASH',
  Spin = 'SPIN',
  StrategyAndTactics = 'STRATEGY_AND_TACTICS',
  TransitionQuad = 'TRANSITION_QUAD',
  Volley = 'VOLLEY'
}

/** Boolean expression to compare columns of type "LessonSkillsEnum". All fields are combined with logical 'AND'. */
export type LessonSkillsEnumComparisonExp = {
  _eq?: InputMaybe<LessonSkillsEnum>;
  _in?: InputMaybe<Array<LessonSkillsEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<LessonSkillsEnum>;
  _nin?: InputMaybe<Array<LessonSkillsEnum>>;
};

/** input type for inserting data into table "lesson_skills" */
export type LessonSkillsInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type LessonSkillsMaxFields = {
  __typename?: 'LessonSkillsMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type LessonSkillsMinFields = {
  __typename?: 'LessonSkillsMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "lesson_skills" */
export type LessonSkillsMutationResponse = {
  __typename?: 'LessonSkillsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LessonSkills>;
};

/** input type for inserting object relation for remote table "lesson_skills" */
export type LessonSkillsObjRelInsertInput = {
  data: LessonSkillsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<LessonSkillsOnConflict>;
};

/** on_conflict condition type for table "lesson_skills" */
export type LessonSkillsOnConflict = {
  constraint: LessonSkillsConstraint;
  updateColumns?: Array<LessonSkillsUpdateColumn>;
  where?: InputMaybe<LessonSkillsBoolExp>;
};

/** Ordering options when selecting data from "lesson_skills". */
export type LessonSkillsOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: lesson_skills */
export type LessonSkillsPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "lesson_skills" */
export enum LessonSkillsSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "lesson_skills" */
export type LessonSkillsSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "lesson_skills" */
export type LessonSkillsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: LessonSkillsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LessonSkillsStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "lesson_skills" */
export enum LessonSkillsUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type LessonSkillsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LessonSkillsSetInput>;
  /** filter the rows which have to be updated */
  where: LessonSkillsBoolExp;
};

/** columns and relationships of "lesson_statuses" */
export type LessonStatuses = {
  __typename?: 'LessonStatuses';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "lesson_statuses" */
export type LessonStatusesAggregate = {
  __typename?: 'LessonStatusesAggregate';
  aggregate?: Maybe<LessonStatusesAggregateFields>;
  nodes: Array<LessonStatuses>;
};

/** aggregate fields of "lesson_statuses" */
export type LessonStatusesAggregateFields = {
  __typename?: 'LessonStatusesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<LessonStatusesMaxFields>;
  min?: Maybe<LessonStatusesMinFields>;
};


/** aggregate fields of "lesson_statuses" */
export type LessonStatusesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<LessonStatusesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "lesson_statuses". All fields are combined with a logical 'AND'. */
export type LessonStatusesBoolExp = {
  _and?: InputMaybe<Array<LessonStatusesBoolExp>>;
  _not?: InputMaybe<LessonStatusesBoolExp>;
  _or?: InputMaybe<Array<LessonStatusesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "lesson_statuses" */
export enum LessonStatusesConstraint {
  /** unique or primary key constraint on columns "value" */
  LessonStatusesPkey = 'lesson_statuses_pkey'
}

export enum LessonStatusesEnum {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  Pending = 'PENDING'
}

/** Boolean expression to compare columns of type "LessonStatusesEnum". All fields are combined with logical 'AND'. */
export type LessonStatusesEnumComparisonExp = {
  _eq?: InputMaybe<LessonStatusesEnum>;
  _in?: InputMaybe<Array<LessonStatusesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<LessonStatusesEnum>;
  _nin?: InputMaybe<Array<LessonStatusesEnum>>;
};

/** input type for inserting data into table "lesson_statuses" */
export type LessonStatusesInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type LessonStatusesMaxFields = {
  __typename?: 'LessonStatusesMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type LessonStatusesMinFields = {
  __typename?: 'LessonStatusesMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "lesson_statuses" */
export type LessonStatusesMutationResponse = {
  __typename?: 'LessonStatusesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LessonStatuses>;
};

/** on_conflict condition type for table "lesson_statuses" */
export type LessonStatusesOnConflict = {
  constraint: LessonStatusesConstraint;
  updateColumns?: Array<LessonStatusesUpdateColumn>;
  where?: InputMaybe<LessonStatusesBoolExp>;
};

/** Ordering options when selecting data from "lesson_statuses". */
export type LessonStatusesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: lesson_statuses */
export type LessonStatusesPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "lesson_statuses" */
export enum LessonStatusesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "lesson_statuses" */
export type LessonStatusesSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "lesson_statuses" */
export type LessonStatusesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: LessonStatusesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LessonStatusesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "lesson_statuses" */
export enum LessonStatusesUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type LessonStatusesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LessonStatusesSetInput>;
  /** filter the rows which have to be updated */
  where: LessonStatusesBoolExp;
};

/** columns and relationships of "lesson_template_skill_levels" */
export type LessonTemplateSkillLevels = {
  __typename?: 'LessonTemplateSkillLevels';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  /** An object relationship */
  lessonTemplate: LessonTemplates;
  lessonTemplateId: Scalars['uuid'];
  skillLevel: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "lesson_template_skill_levels" */
export type LessonTemplateSkillLevelsAggregate = {
  __typename?: 'LessonTemplateSkillLevelsAggregate';
  aggregate?: Maybe<LessonTemplateSkillLevelsAggregateFields>;
  nodes: Array<LessonTemplateSkillLevels>;
};

export type LessonTemplateSkillLevelsAggregateBoolExp = {
  count?: InputMaybe<LessonTemplateSkillLevelsAggregateBoolExpCount>;
};

/** aggregate fields of "lesson_template_skill_levels" */
export type LessonTemplateSkillLevelsAggregateFields = {
  __typename?: 'LessonTemplateSkillLevelsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<LessonTemplateSkillLevelsMaxFields>;
  min?: Maybe<LessonTemplateSkillLevelsMinFields>;
};


/** aggregate fields of "lesson_template_skill_levels" */
export type LessonTemplateSkillLevelsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<LessonTemplateSkillLevelsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "lesson_template_skill_levels" */
export type LessonTemplateSkillLevelsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<LessonTemplateSkillLevelsMaxOrderBy>;
  min?: InputMaybe<LessonTemplateSkillLevelsMinOrderBy>;
};

/** input type for inserting array relation for remote table "lesson_template_skill_levels" */
export type LessonTemplateSkillLevelsArrRelInsertInput = {
  data: Array<LessonTemplateSkillLevelsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<LessonTemplateSkillLevelsOnConflict>;
};

/** Boolean expression to filter rows from the table "lesson_template_skill_levels". All fields are combined with a logical 'AND'. */
export type LessonTemplateSkillLevelsBoolExp = {
  _and?: InputMaybe<Array<LessonTemplateSkillLevelsBoolExp>>;
  _not?: InputMaybe<LessonTemplateSkillLevelsBoolExp>;
  _or?: InputMaybe<Array<LessonTemplateSkillLevelsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  lessonTemplate?: InputMaybe<LessonTemplatesBoolExp>;
  lessonTemplateId?: InputMaybe<UuidComparisonExp>;
  skillLevel?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "lesson_template_skill_levels" */
export enum LessonTemplateSkillLevelsConstraint {
  /** unique or primary key constraint on columns "skill_level", "lesson_template_id" */
  LessonTemplateSkillLevelsLessonTemplateIdSkillLevelKey = 'lesson_template_skill_levels_lesson_template_id_skill_level_key',
  /** unique or primary key constraint on columns "id" */
  LessonTemplateSkillLevelsPkey = 'lesson_template_skill_levels_pkey'
}

/** input type for inserting data into table "lesson_template_skill_levels" */
export type LessonTemplateSkillLevelsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  lessonTemplate?: InputMaybe<LessonTemplatesObjRelInsertInput>;
  lessonTemplateId?: InputMaybe<Scalars['uuid']>;
  skillLevel?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type LessonTemplateSkillLevelsMaxFields = {
  __typename?: 'LessonTemplateSkillLevelsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  lessonTemplateId?: Maybe<Scalars['uuid']>;
  skillLevel?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "lesson_template_skill_levels" */
export type LessonTemplateSkillLevelsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lessonTemplateId?: InputMaybe<OrderBy>;
  skillLevel?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type LessonTemplateSkillLevelsMinFields = {
  __typename?: 'LessonTemplateSkillLevelsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  lessonTemplateId?: Maybe<Scalars['uuid']>;
  skillLevel?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "lesson_template_skill_levels" */
export type LessonTemplateSkillLevelsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lessonTemplateId?: InputMaybe<OrderBy>;
  skillLevel?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "lesson_template_skill_levels" */
export type LessonTemplateSkillLevelsMutationResponse = {
  __typename?: 'LessonTemplateSkillLevelsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LessonTemplateSkillLevels>;
};

/** on_conflict condition type for table "lesson_template_skill_levels" */
export type LessonTemplateSkillLevelsOnConflict = {
  constraint: LessonTemplateSkillLevelsConstraint;
  updateColumns?: Array<LessonTemplateSkillLevelsUpdateColumn>;
  where?: InputMaybe<LessonTemplateSkillLevelsBoolExp>;
};

/** Ordering options when selecting data from "lesson_template_skill_levels". */
export type LessonTemplateSkillLevelsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lessonTemplate?: InputMaybe<LessonTemplatesOrderBy>;
  lessonTemplateId?: InputMaybe<OrderBy>;
  skillLevel?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: lesson_template_skill_levels */
export type LessonTemplateSkillLevelsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "lesson_template_skill_levels" */
export enum LessonTemplateSkillLevelsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  LessonTemplateId = 'lessonTemplateId',
  /** column name */
  SkillLevel = 'skillLevel',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "lesson_template_skill_levels" */
export type LessonTemplateSkillLevelsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  lessonTemplateId?: InputMaybe<Scalars['uuid']>;
  skillLevel?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "lesson_template_skill_levels" */
export type LessonTemplateSkillLevelsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: LessonTemplateSkillLevelsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LessonTemplateSkillLevelsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  lessonTemplateId?: InputMaybe<Scalars['uuid']>;
  skillLevel?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "lesson_template_skill_levels" */
export enum LessonTemplateSkillLevelsUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  LessonTemplateId = 'lessonTemplateId',
  /** column name */
  SkillLevel = 'skillLevel',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type LessonTemplateSkillLevelsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LessonTemplateSkillLevelsSetInput>;
  /** filter the rows which have to be updated */
  where: LessonTemplateSkillLevelsBoolExp;
};

/** columns and relationships of "lesson_templates" */
export type LessonTemplates = {
  __typename?: 'LessonTemplates';
  competitiveness?: Maybe<EventCompetitivenessEnum>;
  coverImageUrl: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  currency: Scalars['String'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  description: Scalars['String'];
  eventType?: Maybe<EventTypesEnum>;
  externalUrl?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  intendedAgeGroup?: Maybe<EventAgeGroupsEnum>;
  maximumRating?: Maybe<Scalars['numeric']>;
  minimumRating?: Maybe<Scalars['numeric']>;
  /** An object relationship */
  originalEvent?: Maybe<Events>;
  originalEventId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  originalLesson?: Maybe<Lessons>;
  originalLessonId?: Maybe<Scalars['uuid']>;
  padelRatingScaleId?: Maybe<Scalars['uuid']>;
  participantLimit: Scalars['Int'];
  pickleballRatingScaleId?: Maybe<Scalars['uuid']>;
  priceUnitAmount: Scalars['Int'];
  privacy?: Maybe<LessonPrivacyEnum>;
  singlesDoubles?: Maybe<Scalars['String']>;
  /** An array relationship */
  skillLevels: Array<LessonTemplateSkillLevels>;
  /** An aggregate relationship */
  skillLevelsAggregate: LessonTemplateSkillLevelsAggregate;
  sport?: Maybe<SportsEnum>;
  templateName: Scalars['String'];
  tennisRatingScaleId?: Maybe<Scalars['uuid']>;
  title: Scalars['String'];
  type?: Maybe<LessonTypesEnum>;
  typeCustom: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user?: Maybe<Users>;
  userCustomCourtId?: Maybe<Scalars['uuid']>;
  userId?: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "lesson_templates" */
export type LessonTemplatesSkillLevelsArgs = {
  distinctOn?: InputMaybe<Array<LessonTemplateSkillLevelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonTemplateSkillLevelsOrderBy>>;
  where?: InputMaybe<LessonTemplateSkillLevelsBoolExp>;
};


/** columns and relationships of "lesson_templates" */
export type LessonTemplatesSkillLevelsAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonTemplateSkillLevelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonTemplateSkillLevelsOrderBy>>;
  where?: InputMaybe<LessonTemplateSkillLevelsBoolExp>;
};

/** aggregated selection of "lesson_templates" */
export type LessonTemplatesAggregate = {
  __typename?: 'LessonTemplatesAggregate';
  aggregate?: Maybe<LessonTemplatesAggregateFields>;
  nodes: Array<LessonTemplates>;
};

export type LessonTemplatesAggregateBoolExp = {
  count?: InputMaybe<LessonTemplatesAggregateBoolExpCount>;
};

/** aggregate fields of "lesson_templates" */
export type LessonTemplatesAggregateFields = {
  __typename?: 'LessonTemplatesAggregateFields';
  avg?: Maybe<LessonTemplatesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<LessonTemplatesMaxFields>;
  min?: Maybe<LessonTemplatesMinFields>;
  stddev?: Maybe<LessonTemplatesStddevFields>;
  stddevPop?: Maybe<LessonTemplatesStddevPopFields>;
  stddevSamp?: Maybe<LessonTemplatesStddevSampFields>;
  sum?: Maybe<LessonTemplatesSumFields>;
  varPop?: Maybe<LessonTemplatesVarPopFields>;
  varSamp?: Maybe<LessonTemplatesVarSampFields>;
  variance?: Maybe<LessonTemplatesVarianceFields>;
};


/** aggregate fields of "lesson_templates" */
export type LessonTemplatesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<LessonTemplatesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "lesson_templates" */
export type LessonTemplatesAggregateOrderBy = {
  avg?: InputMaybe<LessonTemplatesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<LessonTemplatesMaxOrderBy>;
  min?: InputMaybe<LessonTemplatesMinOrderBy>;
  stddev?: InputMaybe<LessonTemplatesStddevOrderBy>;
  stddevPop?: InputMaybe<LessonTemplatesStddevPopOrderBy>;
  stddevSamp?: InputMaybe<LessonTemplatesStddevSampOrderBy>;
  sum?: InputMaybe<LessonTemplatesSumOrderBy>;
  varPop?: InputMaybe<LessonTemplatesVarPopOrderBy>;
  varSamp?: InputMaybe<LessonTemplatesVarSampOrderBy>;
  variance?: InputMaybe<LessonTemplatesVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "lesson_templates" */
export type LessonTemplatesArrRelInsertInput = {
  data: Array<LessonTemplatesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<LessonTemplatesOnConflict>;
};

/** aggregate avg on columns */
export type LessonTemplatesAvgFields = {
  __typename?: 'LessonTemplatesAvgFields';
  maximumRating?: Maybe<Scalars['Float']>;
  minimumRating?: Maybe<Scalars['Float']>;
  participantLimit?: Maybe<Scalars['Float']>;
  priceUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "lesson_templates" */
export type LessonTemplatesAvgOrderBy = {
  maximumRating?: InputMaybe<OrderBy>;
  minimumRating?: InputMaybe<OrderBy>;
  participantLimit?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "lesson_templates". All fields are combined with a logical 'AND'. */
export type LessonTemplatesBoolExp = {
  _and?: InputMaybe<Array<LessonTemplatesBoolExp>>;
  _not?: InputMaybe<LessonTemplatesBoolExp>;
  _or?: InputMaybe<Array<LessonTemplatesBoolExp>>;
  competitiveness?: InputMaybe<EventCompetitivenessEnumComparisonExp>;
  coverImageUrl?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  currency?: InputMaybe<StringComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  eventType?: InputMaybe<EventTypesEnumComparisonExp>;
  externalUrl?: InputMaybe<StringComparisonExp>;
  gender?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  intendedAgeGroup?: InputMaybe<EventAgeGroupsEnumComparisonExp>;
  maximumRating?: InputMaybe<NumericComparisonExp>;
  minimumRating?: InputMaybe<NumericComparisonExp>;
  originalEvent?: InputMaybe<EventsBoolExp>;
  originalEventId?: InputMaybe<UuidComparisonExp>;
  originalLesson?: InputMaybe<LessonsBoolExp>;
  originalLessonId?: InputMaybe<UuidComparisonExp>;
  padelRatingScaleId?: InputMaybe<UuidComparisonExp>;
  participantLimit?: InputMaybe<IntComparisonExp>;
  pickleballRatingScaleId?: InputMaybe<UuidComparisonExp>;
  priceUnitAmount?: InputMaybe<IntComparisonExp>;
  privacy?: InputMaybe<LessonPrivacyEnumComparisonExp>;
  singlesDoubles?: InputMaybe<StringComparisonExp>;
  skillLevels?: InputMaybe<LessonTemplateSkillLevelsBoolExp>;
  skillLevelsAggregate?: InputMaybe<LessonTemplateSkillLevelsAggregateBoolExp>;
  sport?: InputMaybe<SportsEnumComparisonExp>;
  templateName?: InputMaybe<StringComparisonExp>;
  tennisRatingScaleId?: InputMaybe<UuidComparisonExp>;
  title?: InputMaybe<StringComparisonExp>;
  type?: InputMaybe<LessonTypesEnumComparisonExp>;
  typeCustom?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userCustomCourtId?: InputMaybe<UuidComparisonExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "lesson_templates" */
export enum LessonTemplatesConstraint {
  /** unique or primary key constraint on columns "id" */
  LessonTemplatesPkey = 'lesson_templates_pkey'
}

/** input type for incrementing numeric columns in table "lesson_templates" */
export type LessonTemplatesIncInput = {
  maximumRating?: InputMaybe<Scalars['numeric']>;
  minimumRating?: InputMaybe<Scalars['numeric']>;
  participantLimit?: InputMaybe<Scalars['Int']>;
  priceUnitAmount?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "lesson_templates" */
export type LessonTemplatesInsertInput = {
  competitiveness?: InputMaybe<EventCompetitivenessEnum>;
  coverImageUrl?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  eventType?: InputMaybe<EventTypesEnum>;
  externalUrl?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  intendedAgeGroup?: InputMaybe<EventAgeGroupsEnum>;
  maximumRating?: InputMaybe<Scalars['numeric']>;
  minimumRating?: InputMaybe<Scalars['numeric']>;
  originalEvent?: InputMaybe<EventsObjRelInsertInput>;
  originalEventId?: InputMaybe<Scalars['uuid']>;
  originalLesson?: InputMaybe<LessonsObjRelInsertInput>;
  originalLessonId?: InputMaybe<Scalars['uuid']>;
  padelRatingScaleId?: InputMaybe<Scalars['uuid']>;
  participantLimit?: InputMaybe<Scalars['Int']>;
  pickleballRatingScaleId?: InputMaybe<Scalars['uuid']>;
  priceUnitAmount?: InputMaybe<Scalars['Int']>;
  privacy?: InputMaybe<LessonPrivacyEnum>;
  singlesDoubles?: InputMaybe<Scalars['String']>;
  skillLevels?: InputMaybe<LessonTemplateSkillLevelsArrRelInsertInput>;
  sport?: InputMaybe<SportsEnum>;
  templateName?: InputMaybe<Scalars['String']>;
  tennisRatingScaleId?: InputMaybe<Scalars['uuid']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<LessonTypesEnum>;
  typeCustom?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userCustomCourtId?: InputMaybe<Scalars['uuid']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type LessonTemplatesMaxFields = {
  __typename?: 'LessonTemplatesMaxFields';
  coverImageUrl?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  externalUrl?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  maximumRating?: Maybe<Scalars['numeric']>;
  minimumRating?: Maybe<Scalars['numeric']>;
  originalEventId?: Maybe<Scalars['uuid']>;
  originalLessonId?: Maybe<Scalars['uuid']>;
  padelRatingScaleId?: Maybe<Scalars['uuid']>;
  participantLimit?: Maybe<Scalars['Int']>;
  pickleballRatingScaleId?: Maybe<Scalars['uuid']>;
  priceUnitAmount?: Maybe<Scalars['Int']>;
  singlesDoubles?: Maybe<Scalars['String']>;
  templateName?: Maybe<Scalars['String']>;
  tennisRatingScaleId?: Maybe<Scalars['uuid']>;
  title?: Maybe<Scalars['String']>;
  typeCustom?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userCustomCourtId?: Maybe<Scalars['uuid']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "lesson_templates" */
export type LessonTemplatesMaxOrderBy = {
  coverImageUrl?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  currency?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  externalUrl?: InputMaybe<OrderBy>;
  gender?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  maximumRating?: InputMaybe<OrderBy>;
  minimumRating?: InputMaybe<OrderBy>;
  originalEventId?: InputMaybe<OrderBy>;
  originalLessonId?: InputMaybe<OrderBy>;
  padelRatingScaleId?: InputMaybe<OrderBy>;
  participantLimit?: InputMaybe<OrderBy>;
  pickleballRatingScaleId?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  singlesDoubles?: InputMaybe<OrderBy>;
  templateName?: InputMaybe<OrderBy>;
  tennisRatingScaleId?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  typeCustom?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userCustomCourtId?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type LessonTemplatesMinFields = {
  __typename?: 'LessonTemplatesMinFields';
  coverImageUrl?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  externalUrl?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  maximumRating?: Maybe<Scalars['numeric']>;
  minimumRating?: Maybe<Scalars['numeric']>;
  originalEventId?: Maybe<Scalars['uuid']>;
  originalLessonId?: Maybe<Scalars['uuid']>;
  padelRatingScaleId?: Maybe<Scalars['uuid']>;
  participantLimit?: Maybe<Scalars['Int']>;
  pickleballRatingScaleId?: Maybe<Scalars['uuid']>;
  priceUnitAmount?: Maybe<Scalars['Int']>;
  singlesDoubles?: Maybe<Scalars['String']>;
  templateName?: Maybe<Scalars['String']>;
  tennisRatingScaleId?: Maybe<Scalars['uuid']>;
  title?: Maybe<Scalars['String']>;
  typeCustom?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userCustomCourtId?: Maybe<Scalars['uuid']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "lesson_templates" */
export type LessonTemplatesMinOrderBy = {
  coverImageUrl?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  currency?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  externalUrl?: InputMaybe<OrderBy>;
  gender?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  maximumRating?: InputMaybe<OrderBy>;
  minimumRating?: InputMaybe<OrderBy>;
  originalEventId?: InputMaybe<OrderBy>;
  originalLessonId?: InputMaybe<OrderBy>;
  padelRatingScaleId?: InputMaybe<OrderBy>;
  participantLimit?: InputMaybe<OrderBy>;
  pickleballRatingScaleId?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  singlesDoubles?: InputMaybe<OrderBy>;
  templateName?: InputMaybe<OrderBy>;
  tennisRatingScaleId?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  typeCustom?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userCustomCourtId?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "lesson_templates" */
export type LessonTemplatesMutationResponse = {
  __typename?: 'LessonTemplatesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LessonTemplates>;
};

/** input type for inserting object relation for remote table "lesson_templates" */
export type LessonTemplatesObjRelInsertInput = {
  data: LessonTemplatesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<LessonTemplatesOnConflict>;
};

/** on_conflict condition type for table "lesson_templates" */
export type LessonTemplatesOnConflict = {
  constraint: LessonTemplatesConstraint;
  updateColumns?: Array<LessonTemplatesUpdateColumn>;
  where?: InputMaybe<LessonTemplatesBoolExp>;
};

/** Ordering options when selecting data from "lesson_templates". */
export type LessonTemplatesOrderBy = {
  competitiveness?: InputMaybe<OrderBy>;
  coverImageUrl?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  currency?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  eventType?: InputMaybe<OrderBy>;
  externalUrl?: InputMaybe<OrderBy>;
  gender?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  intendedAgeGroup?: InputMaybe<OrderBy>;
  maximumRating?: InputMaybe<OrderBy>;
  minimumRating?: InputMaybe<OrderBy>;
  originalEvent?: InputMaybe<EventsOrderBy>;
  originalEventId?: InputMaybe<OrderBy>;
  originalLesson?: InputMaybe<LessonsOrderBy>;
  originalLessonId?: InputMaybe<OrderBy>;
  padelRatingScaleId?: InputMaybe<OrderBy>;
  participantLimit?: InputMaybe<OrderBy>;
  pickleballRatingScaleId?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  privacy?: InputMaybe<OrderBy>;
  singlesDoubles?: InputMaybe<OrderBy>;
  skillLevelsAggregate?: InputMaybe<LessonTemplateSkillLevelsAggregateOrderBy>;
  sport?: InputMaybe<OrderBy>;
  templateName?: InputMaybe<OrderBy>;
  tennisRatingScaleId?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  typeCustom?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userCustomCourtId?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: lesson_templates */
export type LessonTemplatesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "lesson_templates" */
export enum LessonTemplatesSelectColumn {
  /** column name */
  Competitiveness = 'competitiveness',
  /** column name */
  CoverImageUrl = 'coverImageUrl',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Currency = 'currency',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Description = 'description',
  /** column name */
  EventType = 'eventType',
  /** column name */
  ExternalUrl = 'externalUrl',
  /** column name */
  Gender = 'gender',
  /** column name */
  Id = 'id',
  /** column name */
  IntendedAgeGroup = 'intendedAgeGroup',
  /** column name */
  MaximumRating = 'maximumRating',
  /** column name */
  MinimumRating = 'minimumRating',
  /** column name */
  OriginalEventId = 'originalEventId',
  /** column name */
  OriginalLessonId = 'originalLessonId',
  /** column name */
  PadelRatingScaleId = 'padelRatingScaleId',
  /** column name */
  ParticipantLimit = 'participantLimit',
  /** column name */
  PickleballRatingScaleId = 'pickleballRatingScaleId',
  /** column name */
  PriceUnitAmount = 'priceUnitAmount',
  /** column name */
  Privacy = 'privacy',
  /** column name */
  SinglesDoubles = 'singlesDoubles',
  /** column name */
  Sport = 'sport',
  /** column name */
  TemplateName = 'templateName',
  /** column name */
  TennisRatingScaleId = 'tennisRatingScaleId',
  /** column name */
  Title = 'title',
  /** column name */
  Type = 'type',
  /** column name */
  TypeCustom = 'typeCustom',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserCustomCourtId = 'userCustomCourtId',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "lesson_templates" */
export type LessonTemplatesSetInput = {
  competitiveness?: InputMaybe<EventCompetitivenessEnum>;
  coverImageUrl?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  eventType?: InputMaybe<EventTypesEnum>;
  externalUrl?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  intendedAgeGroup?: InputMaybe<EventAgeGroupsEnum>;
  maximumRating?: InputMaybe<Scalars['numeric']>;
  minimumRating?: InputMaybe<Scalars['numeric']>;
  originalEventId?: InputMaybe<Scalars['uuid']>;
  originalLessonId?: InputMaybe<Scalars['uuid']>;
  padelRatingScaleId?: InputMaybe<Scalars['uuid']>;
  participantLimit?: InputMaybe<Scalars['Int']>;
  pickleballRatingScaleId?: InputMaybe<Scalars['uuid']>;
  priceUnitAmount?: InputMaybe<Scalars['Int']>;
  privacy?: InputMaybe<LessonPrivacyEnum>;
  singlesDoubles?: InputMaybe<Scalars['String']>;
  sport?: InputMaybe<SportsEnum>;
  templateName?: InputMaybe<Scalars['String']>;
  tennisRatingScaleId?: InputMaybe<Scalars['uuid']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<LessonTypesEnum>;
  typeCustom?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userCustomCourtId?: InputMaybe<Scalars['uuid']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type LessonTemplatesStddevFields = {
  __typename?: 'LessonTemplatesStddevFields';
  maximumRating?: Maybe<Scalars['Float']>;
  minimumRating?: Maybe<Scalars['Float']>;
  participantLimit?: Maybe<Scalars['Float']>;
  priceUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "lesson_templates" */
export type LessonTemplatesStddevOrderBy = {
  maximumRating?: InputMaybe<OrderBy>;
  minimumRating?: InputMaybe<OrderBy>;
  participantLimit?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type LessonTemplatesStddevPopFields = {
  __typename?: 'LessonTemplatesStddevPopFields';
  maximumRating?: Maybe<Scalars['Float']>;
  minimumRating?: Maybe<Scalars['Float']>;
  participantLimit?: Maybe<Scalars['Float']>;
  priceUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "lesson_templates" */
export type LessonTemplatesStddevPopOrderBy = {
  maximumRating?: InputMaybe<OrderBy>;
  minimumRating?: InputMaybe<OrderBy>;
  participantLimit?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type LessonTemplatesStddevSampFields = {
  __typename?: 'LessonTemplatesStddevSampFields';
  maximumRating?: Maybe<Scalars['Float']>;
  minimumRating?: Maybe<Scalars['Float']>;
  participantLimit?: Maybe<Scalars['Float']>;
  priceUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "lesson_templates" */
export type LessonTemplatesStddevSampOrderBy = {
  maximumRating?: InputMaybe<OrderBy>;
  minimumRating?: InputMaybe<OrderBy>;
  participantLimit?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "lesson_templates" */
export type LessonTemplatesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: LessonTemplatesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LessonTemplatesStreamCursorValueInput = {
  competitiveness?: InputMaybe<EventCompetitivenessEnum>;
  coverImageUrl?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  eventType?: InputMaybe<EventTypesEnum>;
  externalUrl?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  intendedAgeGroup?: InputMaybe<EventAgeGroupsEnum>;
  maximumRating?: InputMaybe<Scalars['numeric']>;
  minimumRating?: InputMaybe<Scalars['numeric']>;
  originalEventId?: InputMaybe<Scalars['uuid']>;
  originalLessonId?: InputMaybe<Scalars['uuid']>;
  padelRatingScaleId?: InputMaybe<Scalars['uuid']>;
  participantLimit?: InputMaybe<Scalars['Int']>;
  pickleballRatingScaleId?: InputMaybe<Scalars['uuid']>;
  priceUnitAmount?: InputMaybe<Scalars['Int']>;
  privacy?: InputMaybe<LessonPrivacyEnum>;
  singlesDoubles?: InputMaybe<Scalars['String']>;
  sport?: InputMaybe<SportsEnum>;
  templateName?: InputMaybe<Scalars['String']>;
  tennisRatingScaleId?: InputMaybe<Scalars['uuid']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<LessonTypesEnum>;
  typeCustom?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userCustomCourtId?: InputMaybe<Scalars['uuid']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type LessonTemplatesSumFields = {
  __typename?: 'LessonTemplatesSumFields';
  maximumRating?: Maybe<Scalars['numeric']>;
  minimumRating?: Maybe<Scalars['numeric']>;
  participantLimit?: Maybe<Scalars['Int']>;
  priceUnitAmount?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "lesson_templates" */
export type LessonTemplatesSumOrderBy = {
  maximumRating?: InputMaybe<OrderBy>;
  minimumRating?: InputMaybe<OrderBy>;
  participantLimit?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
};

/** update columns of table "lesson_templates" */
export enum LessonTemplatesUpdateColumn {
  /** column name */
  Competitiveness = 'competitiveness',
  /** column name */
  CoverImageUrl = 'coverImageUrl',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Currency = 'currency',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Description = 'description',
  /** column name */
  EventType = 'eventType',
  /** column name */
  ExternalUrl = 'externalUrl',
  /** column name */
  Gender = 'gender',
  /** column name */
  Id = 'id',
  /** column name */
  IntendedAgeGroup = 'intendedAgeGroup',
  /** column name */
  MaximumRating = 'maximumRating',
  /** column name */
  MinimumRating = 'minimumRating',
  /** column name */
  OriginalEventId = 'originalEventId',
  /** column name */
  OriginalLessonId = 'originalLessonId',
  /** column name */
  PadelRatingScaleId = 'padelRatingScaleId',
  /** column name */
  ParticipantLimit = 'participantLimit',
  /** column name */
  PickleballRatingScaleId = 'pickleballRatingScaleId',
  /** column name */
  PriceUnitAmount = 'priceUnitAmount',
  /** column name */
  Privacy = 'privacy',
  /** column name */
  SinglesDoubles = 'singlesDoubles',
  /** column name */
  Sport = 'sport',
  /** column name */
  TemplateName = 'templateName',
  /** column name */
  TennisRatingScaleId = 'tennisRatingScaleId',
  /** column name */
  Title = 'title',
  /** column name */
  Type = 'type',
  /** column name */
  TypeCustom = 'typeCustom',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserCustomCourtId = 'userCustomCourtId',
  /** column name */
  UserId = 'userId'
}

export type LessonTemplatesUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<LessonTemplatesIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LessonTemplatesSetInput>;
  /** filter the rows which have to be updated */
  where: LessonTemplatesBoolExp;
};

/** aggregate varPop on columns */
export type LessonTemplatesVarPopFields = {
  __typename?: 'LessonTemplatesVarPopFields';
  maximumRating?: Maybe<Scalars['Float']>;
  minimumRating?: Maybe<Scalars['Float']>;
  participantLimit?: Maybe<Scalars['Float']>;
  priceUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "lesson_templates" */
export type LessonTemplatesVarPopOrderBy = {
  maximumRating?: InputMaybe<OrderBy>;
  minimumRating?: InputMaybe<OrderBy>;
  participantLimit?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type LessonTemplatesVarSampFields = {
  __typename?: 'LessonTemplatesVarSampFields';
  maximumRating?: Maybe<Scalars['Float']>;
  minimumRating?: Maybe<Scalars['Float']>;
  participantLimit?: Maybe<Scalars['Float']>;
  priceUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "lesson_templates" */
export type LessonTemplatesVarSampOrderBy = {
  maximumRating?: InputMaybe<OrderBy>;
  minimumRating?: InputMaybe<OrderBy>;
  participantLimit?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type LessonTemplatesVarianceFields = {
  __typename?: 'LessonTemplatesVarianceFields';
  maximumRating?: Maybe<Scalars['Float']>;
  minimumRating?: Maybe<Scalars['Float']>;
  participantLimit?: Maybe<Scalars['Float']>;
  priceUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "lesson_templates" */
export type LessonTemplatesVarianceOrderBy = {
  maximumRating?: InputMaybe<OrderBy>;
  minimumRating?: InputMaybe<OrderBy>;
  participantLimit?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
};

/** While thinking through how we handle events with multiple dates or times (ie. a camp), this table was made. It will be actively used once that logic has been thought through more. HOWEVER, another option would be to put an FK on lessons that points to a parent lesson that drives it. This would also allow for things like descriptions for each individual lesson. This is a little more complex though. */
export type LessonTimes = {
  __typename?: 'LessonTimes';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  endDateTime: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  lesson: Lessons;
  lessonId: Scalars['uuid'];
  startDateTime: Scalars['timestamptz'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "lesson_times" */
export type LessonTimesAggregate = {
  __typename?: 'LessonTimesAggregate';
  aggregate?: Maybe<LessonTimesAggregateFields>;
  nodes: Array<LessonTimes>;
};

export type LessonTimesAggregateBoolExp = {
  count?: InputMaybe<LessonTimesAggregateBoolExpCount>;
};

/** aggregate fields of "lesson_times" */
export type LessonTimesAggregateFields = {
  __typename?: 'LessonTimesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<LessonTimesMaxFields>;
  min?: Maybe<LessonTimesMinFields>;
};


/** aggregate fields of "lesson_times" */
export type LessonTimesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<LessonTimesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "lesson_times" */
export type LessonTimesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<LessonTimesMaxOrderBy>;
  min?: InputMaybe<LessonTimesMinOrderBy>;
};

/** input type for inserting array relation for remote table "lesson_times" */
export type LessonTimesArrRelInsertInput = {
  data: Array<LessonTimesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<LessonTimesOnConflict>;
};

/** Boolean expression to filter rows from the table "lesson_times". All fields are combined with a logical 'AND'. */
export type LessonTimesBoolExp = {
  _and?: InputMaybe<Array<LessonTimesBoolExp>>;
  _not?: InputMaybe<LessonTimesBoolExp>;
  _or?: InputMaybe<Array<LessonTimesBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  endDateTime?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  lesson?: InputMaybe<LessonsBoolExp>;
  lessonId?: InputMaybe<UuidComparisonExp>;
  startDateTime?: InputMaybe<TimestamptzComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "lesson_times" */
export enum LessonTimesConstraint {
  /** unique or primary key constraint on columns "id" */
  LessonTimesPkey = 'lesson_times_pkey'
}

/** input type for inserting data into table "lesson_times" */
export type LessonTimesInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  endDateTime?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  lesson?: InputMaybe<LessonsObjRelInsertInput>;
  lessonId?: InputMaybe<Scalars['uuid']>;
  startDateTime?: InputMaybe<Scalars['timestamptz']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type LessonTimesMaxFields = {
  __typename?: 'LessonTimesMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  endDateTime?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  lessonId?: Maybe<Scalars['uuid']>;
  startDateTime?: Maybe<Scalars['timestamptz']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "lesson_times" */
export type LessonTimesMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  endDateTime?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lessonId?: InputMaybe<OrderBy>;
  startDateTime?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type LessonTimesMinFields = {
  __typename?: 'LessonTimesMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  endDateTime?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  lessonId?: Maybe<Scalars['uuid']>;
  startDateTime?: Maybe<Scalars['timestamptz']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "lesson_times" */
export type LessonTimesMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  endDateTime?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lessonId?: InputMaybe<OrderBy>;
  startDateTime?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "lesson_times" */
export type LessonTimesMutationResponse = {
  __typename?: 'LessonTimesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LessonTimes>;
};

/** on_conflict condition type for table "lesson_times" */
export type LessonTimesOnConflict = {
  constraint: LessonTimesConstraint;
  updateColumns?: Array<LessonTimesUpdateColumn>;
  where?: InputMaybe<LessonTimesBoolExp>;
};

/** Ordering options when selecting data from "lesson_times". */
export type LessonTimesOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  endDateTime?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lesson?: InputMaybe<LessonsOrderBy>;
  lessonId?: InputMaybe<OrderBy>;
  startDateTime?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: lesson_times */
export type LessonTimesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "lesson_times" */
export enum LessonTimesSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EndDateTime = 'endDateTime',
  /** column name */
  Id = 'id',
  /** column name */
  LessonId = 'lessonId',
  /** column name */
  StartDateTime = 'startDateTime',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "lesson_times" */
export type LessonTimesSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  endDateTime?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  lessonId?: InputMaybe<Scalars['uuid']>;
  startDateTime?: InputMaybe<Scalars['timestamptz']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "lesson_times" */
export type LessonTimesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: LessonTimesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LessonTimesStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  endDateTime?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  lessonId?: InputMaybe<Scalars['uuid']>;
  startDateTime?: InputMaybe<Scalars['timestamptz']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "lesson_times" */
export enum LessonTimesUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EndDateTime = 'endDateTime',
  /** column name */
  Id = 'id',
  /** column name */
  LessonId = 'lessonId',
  /** column name */
  StartDateTime = 'startDateTime',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type LessonTimesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LessonTimesSetInput>;
  /** filter the rows which have to be updated */
  where: LessonTimesBoolExp;
};

/** columns and relationships of "lesson_types" */
export type LessonTypes = {
  __typename?: 'LessonTypes';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "lesson_types" */
export type LessonTypesAggregate = {
  __typename?: 'LessonTypesAggregate';
  aggregate?: Maybe<LessonTypesAggregateFields>;
  nodes: Array<LessonTypes>;
};

/** aggregate fields of "lesson_types" */
export type LessonTypesAggregateFields = {
  __typename?: 'LessonTypesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<LessonTypesMaxFields>;
  min?: Maybe<LessonTypesMinFields>;
};


/** aggregate fields of "lesson_types" */
export type LessonTypesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<LessonTypesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "lesson_types". All fields are combined with a logical 'AND'. */
export type LessonTypesBoolExp = {
  _and?: InputMaybe<Array<LessonTypesBoolExp>>;
  _not?: InputMaybe<LessonTypesBoolExp>;
  _or?: InputMaybe<Array<LessonTypesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "lesson_types" */
export enum LessonTypesConstraint {
  /** unique or primary key constraint on columns "value" */
  LessonTypesPkey = 'lesson_types_pkey'
}

export enum LessonTypesEnum {
  Camp = 'CAMP',
  Cardio = 'CARDIO',
  Clinic = 'CLINIC',
  Custom = 'CUSTOM',
  Individual = 'INDIVIDUAL',
  OpenPlay = 'OPEN_PLAY',
  Retreat = 'RETREAT',
  Rfx = 'RFX'
}

/** Boolean expression to compare columns of type "LessonTypesEnum". All fields are combined with logical 'AND'. */
export type LessonTypesEnumComparisonExp = {
  _eq?: InputMaybe<LessonTypesEnum>;
  _in?: InputMaybe<Array<LessonTypesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<LessonTypesEnum>;
  _nin?: InputMaybe<Array<LessonTypesEnum>>;
};

/** input type for inserting data into table "lesson_types" */
export type LessonTypesInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type LessonTypesMaxFields = {
  __typename?: 'LessonTypesMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type LessonTypesMinFields = {
  __typename?: 'LessonTypesMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "lesson_types" */
export type LessonTypesMutationResponse = {
  __typename?: 'LessonTypesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LessonTypes>;
};

/** on_conflict condition type for table "lesson_types" */
export type LessonTypesOnConflict = {
  constraint: LessonTypesConstraint;
  updateColumns?: Array<LessonTypesUpdateColumn>;
  where?: InputMaybe<LessonTypesBoolExp>;
};

/** Ordering options when selecting data from "lesson_types". */
export type LessonTypesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: lesson_types */
export type LessonTypesPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "lesson_types" */
export enum LessonTypesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "lesson_types" */
export type LessonTypesSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "lesson_types" */
export type LessonTypesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: LessonTypesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LessonTypesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "lesson_types" */
export enum LessonTypesUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type LessonTypesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LessonTypesSetInput>;
  /** filter the rows which have to be updated */
  where: LessonTypesBoolExp;
};

/** columns and relationships of "lesson_waitlist_statuses" */
export type LessonWaitlistStatuses = {
  __typename?: 'LessonWaitlistStatuses';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "lesson_waitlist_statuses" */
export type LessonWaitlistStatusesAggregate = {
  __typename?: 'LessonWaitlistStatusesAggregate';
  aggregate?: Maybe<LessonWaitlistStatusesAggregateFields>;
  nodes: Array<LessonWaitlistStatuses>;
};

/** aggregate fields of "lesson_waitlist_statuses" */
export type LessonWaitlistStatusesAggregateFields = {
  __typename?: 'LessonWaitlistStatusesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<LessonWaitlistStatusesMaxFields>;
  min?: Maybe<LessonWaitlistStatusesMinFields>;
};


/** aggregate fields of "lesson_waitlist_statuses" */
export type LessonWaitlistStatusesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<LessonWaitlistStatusesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "lesson_waitlist_statuses". All fields are combined with a logical 'AND'. */
export type LessonWaitlistStatusesBoolExp = {
  _and?: InputMaybe<Array<LessonWaitlistStatusesBoolExp>>;
  _not?: InputMaybe<LessonWaitlistStatusesBoolExp>;
  _or?: InputMaybe<Array<LessonWaitlistStatusesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "lesson_waitlist_statuses" */
export enum LessonWaitlistStatusesConstraint {
  /** unique or primary key constraint on columns "value" */
  LessonWaitlistStatusesPkey = 'lesson_waitlist_statuses_pkey'
}

export enum LessonWaitlistStatusesEnum {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

/** Boolean expression to compare columns of type "LessonWaitlistStatusesEnum". All fields are combined with logical 'AND'. */
export type LessonWaitlistStatusesEnumComparisonExp = {
  _eq?: InputMaybe<LessonWaitlistStatusesEnum>;
  _in?: InputMaybe<Array<LessonWaitlistStatusesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<LessonWaitlistStatusesEnum>;
  _nin?: InputMaybe<Array<LessonWaitlistStatusesEnum>>;
};

/** input type for inserting data into table "lesson_waitlist_statuses" */
export type LessonWaitlistStatusesInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type LessonWaitlistStatusesMaxFields = {
  __typename?: 'LessonWaitlistStatusesMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type LessonWaitlistStatusesMinFields = {
  __typename?: 'LessonWaitlistStatusesMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "lesson_waitlist_statuses" */
export type LessonWaitlistStatusesMutationResponse = {
  __typename?: 'LessonWaitlistStatusesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LessonWaitlistStatuses>;
};

/** on_conflict condition type for table "lesson_waitlist_statuses" */
export type LessonWaitlistStatusesOnConflict = {
  constraint: LessonWaitlistStatusesConstraint;
  updateColumns?: Array<LessonWaitlistStatusesUpdateColumn>;
  where?: InputMaybe<LessonWaitlistStatusesBoolExp>;
};

/** Ordering options when selecting data from "lesson_waitlist_statuses". */
export type LessonWaitlistStatusesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: lesson_waitlist_statuses */
export type LessonWaitlistStatusesPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "lesson_waitlist_statuses" */
export enum LessonWaitlistStatusesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "lesson_waitlist_statuses" */
export type LessonWaitlistStatusesSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "lesson_waitlist_statuses" */
export type LessonWaitlistStatusesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: LessonWaitlistStatusesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LessonWaitlistStatusesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "lesson_waitlist_statuses" */
export enum LessonWaitlistStatusesUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type LessonWaitlistStatusesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LessonWaitlistStatusesSetInput>;
  /** filter the rows which have to be updated */
  where: LessonWaitlistStatusesBoolExp;
};

/** columns and relationships of "lesson_waitlists" */
export type LessonWaitlists = {
  __typename?: 'LessonWaitlists';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  /** An object relationship */
  lesson: Lessons;
  lessonId: Scalars['uuid'];
  status: LessonWaitlistStatusesEnum;
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid'];
  /** An object relationship */
  userProfile?: Maybe<UserProfiles>;
};

/** aggregated selection of "lesson_waitlists" */
export type LessonWaitlistsAggregate = {
  __typename?: 'LessonWaitlistsAggregate';
  aggregate?: Maybe<LessonWaitlistsAggregateFields>;
  nodes: Array<LessonWaitlists>;
};

export type LessonWaitlistsAggregateBoolExp = {
  count?: InputMaybe<LessonWaitlistsAggregateBoolExpCount>;
};

/** aggregate fields of "lesson_waitlists" */
export type LessonWaitlistsAggregateFields = {
  __typename?: 'LessonWaitlistsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<LessonWaitlistsMaxFields>;
  min?: Maybe<LessonWaitlistsMinFields>;
};


/** aggregate fields of "lesson_waitlists" */
export type LessonWaitlistsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<LessonWaitlistsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "lesson_waitlists" */
export type LessonWaitlistsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<LessonWaitlistsMaxOrderBy>;
  min?: InputMaybe<LessonWaitlistsMinOrderBy>;
};

/** input type for inserting array relation for remote table "lesson_waitlists" */
export type LessonWaitlistsArrRelInsertInput = {
  data: Array<LessonWaitlistsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<LessonWaitlistsOnConflict>;
};

/** Boolean expression to filter rows from the table "lesson_waitlists". All fields are combined with a logical 'AND'. */
export type LessonWaitlistsBoolExp = {
  _and?: InputMaybe<Array<LessonWaitlistsBoolExp>>;
  _not?: InputMaybe<LessonWaitlistsBoolExp>;
  _or?: InputMaybe<Array<LessonWaitlistsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  lesson?: InputMaybe<LessonsBoolExp>;
  lessonId?: InputMaybe<UuidComparisonExp>;
  status?: InputMaybe<LessonWaitlistStatusesEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
  userProfile?: InputMaybe<UserProfilesBoolExp>;
};

/** unique or primary key constraints on table "lesson_waitlists" */
export enum LessonWaitlistsConstraint {
  /** unique or primary key constraint on columns "id" */
  LessonWaitlistsPkey = 'lesson_waitlists_pkey',
  /** unique or primary key constraint on columns "lesson_id", "user_id" */
  LessonWaitlistsUserIdLessonIdKey = 'lesson_waitlists_user_id_lesson_id_key'
}

/** input type for inserting data into table "lesson_waitlists" */
export type LessonWaitlistsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  lesson?: InputMaybe<LessonsObjRelInsertInput>;
  lessonId?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<LessonWaitlistStatusesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']>;
  userProfile?: InputMaybe<UserProfilesObjRelInsertInput>;
};

/** aggregate max on columns */
export type LessonWaitlistsMaxFields = {
  __typename?: 'LessonWaitlistsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  lessonId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "lesson_waitlists" */
export type LessonWaitlistsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lessonId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type LessonWaitlistsMinFields = {
  __typename?: 'LessonWaitlistsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  lessonId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "lesson_waitlists" */
export type LessonWaitlistsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lessonId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "lesson_waitlists" */
export type LessonWaitlistsMutationResponse = {
  __typename?: 'LessonWaitlistsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LessonWaitlists>;
};

/** on_conflict condition type for table "lesson_waitlists" */
export type LessonWaitlistsOnConflict = {
  constraint: LessonWaitlistsConstraint;
  updateColumns?: Array<LessonWaitlistsUpdateColumn>;
  where?: InputMaybe<LessonWaitlistsBoolExp>;
};

/** Ordering options when selecting data from "lesson_waitlists". */
export type LessonWaitlistsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lesson?: InputMaybe<LessonsOrderBy>;
  lessonId?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
  userProfile?: InputMaybe<UserProfilesOrderBy>;
};

/** primary key columns input for table: lesson_waitlists */
export type LessonWaitlistsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "lesson_waitlists" */
export enum LessonWaitlistsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  LessonId = 'lessonId',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "lesson_waitlists" */
export type LessonWaitlistsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  lessonId?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<LessonWaitlistStatusesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "lesson_waitlists" */
export type LessonWaitlistsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: LessonWaitlistsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LessonWaitlistsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  lessonId?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<LessonWaitlistStatusesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "lesson_waitlists" */
export enum LessonWaitlistsUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  LessonId = 'lessonId',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

export type LessonWaitlistsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LessonWaitlistsSetInput>;
  /** filter the rows which have to be updated */
  where: LessonWaitlistsBoolExp;
};

/** columns and relationships of "lessons" */
export type Lessons = {
  __typename?: 'Lessons';
  cancelReason: Scalars['String'];
  canceledAt?: Maybe<Scalars['timestamptz']>;
  completionHasuraEventId?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  conversations: Array<Conversations>;
  /** An aggregate relationship */
  conversationsAggregate: ConversationsAggregate;
  coverImageFileName: Scalars['String'];
  coverImagePath: Scalars['String'];
  coverImageProvider: Scalars['String'];
  coverImageProviderId: Scalars['String'];
  coverImageProviderUrl: Scalars['String'];
  coverImageUrl: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  currency: Scalars['String'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  description: Scalars['String'];
  endDateTime?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  equipment: Array<LessonEquipment>;
  /** An aggregate relationship */
  equipmentAggregate: LessonEquipmentAggregate;
  externalBookingUrl: Scalars['String'];
  externalId?: Maybe<Scalars['String']>;
  externalSource?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  intendedAgeGroup?: Maybe<EventAgeGroupsEnum>;
  /** An object relationship */
  lessonCollection?: Maybe<LessonCollections>;
  lessonCollectionId?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  lessonPlayerSkillAssessments: Array<LessonPlayerSkillAssessments>;
  /** An aggregate relationship */
  lessonPlayerSkillAssessmentsAggregate: LessonPlayerSkillAssessmentsAggregate;
  lessonReflectionId?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  lessonReflections: Array<LessonReflections>;
  /** An aggregate relationship */
  lessonReflectionsAggregate: LessonReflectionsAggregate;
  locale: Scalars['String'];
  /** An array relationship */
  orders: Array<LessonOrders>;
  /** An aggregate relationship */
  ordersAggregate: LessonOrdersAggregate;
  /** An object relationship */
  owner?: Maybe<Users>;
  /** An object relationship */
  ownerProfile?: Maybe<UserProfiles>;
  ownerUserId?: Maybe<Scalars['uuid']>;
  participantLimit?: Maybe<Scalars['Int']>;
  /** An array relationship */
  participants: Array<LessonParticipants>;
  /** An aggregate relationship */
  participantsAggregate: LessonParticipantsAggregate;
  paymentFulfillmentChannel: PaymentFulfillmentChannelsEnum;
  /** This follows the standard from Stripe where a price is stored in its smallest denomination as an integer. In USD, this would be cents. For example, $42.23 is stored as 4223. */
  priceUnitAmount: Scalars['Int'];
  privacy: LessonPrivacyEnum;
  publishedAt?: Maybe<Scalars['timestamptz']>;
  recurrenceKind?: Maybe<RecurrenceKindsEnum>;
  reminderEventId?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  skillLevels: Array<LessonSkillLevels>;
  /** An aggregate relationship */
  skillLevelsAggregate: LessonSkillLevelsAggregate;
  sport: SportsEnum;
  startDateTime?: Maybe<Scalars['timestamptz']>;
  status: LessonStatusesEnum;
  /** An array relationship */
  times: Array<LessonTimes>;
  /** An aggregate relationship */
  timesAggregate: LessonTimesAggregate;
  timezoneAbbreviation: Scalars['String'];
  timezoneName: Scalars['String'];
  timezoneOffsetMinutes: Scalars['Int'];
  title: Scalars['String'];
  type: LessonTypesEnum;
  typeCustom: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  usedTemplate?: Maybe<LessonTemplates>;
  usedTemplateId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  userCustomCourt?: Maybe<UserCustomCourts>;
  userCustomCourtId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  venue?: Maybe<Venues>;
  venueId?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  waitlist: Array<LessonWaitlists>;
  /** An aggregate relationship */
  waitlistAggregate: LessonWaitlistsAggregate;
};


/** columns and relationships of "lessons" */
export type LessonsConversationsArgs = {
  distinctOn?: InputMaybe<Array<ConversationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ConversationsOrderBy>>;
  where?: InputMaybe<ConversationsBoolExp>;
};


/** columns and relationships of "lessons" */
export type LessonsConversationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ConversationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ConversationsOrderBy>>;
  where?: InputMaybe<ConversationsBoolExp>;
};


/** columns and relationships of "lessons" */
export type LessonsEquipmentArgs = {
  distinctOn?: InputMaybe<Array<LessonEquipmentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonEquipmentOrderBy>>;
  where?: InputMaybe<LessonEquipmentBoolExp>;
};


/** columns and relationships of "lessons" */
export type LessonsEquipmentAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonEquipmentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonEquipmentOrderBy>>;
  where?: InputMaybe<LessonEquipmentBoolExp>;
};


/** columns and relationships of "lessons" */
export type LessonsLessonPlayerSkillAssessmentsArgs = {
  distinctOn?: InputMaybe<Array<LessonPlayerSkillAssessmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonPlayerSkillAssessmentsOrderBy>>;
  where?: InputMaybe<LessonPlayerSkillAssessmentsBoolExp>;
};


/** columns and relationships of "lessons" */
export type LessonsLessonPlayerSkillAssessmentsAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonPlayerSkillAssessmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonPlayerSkillAssessmentsOrderBy>>;
  where?: InputMaybe<LessonPlayerSkillAssessmentsBoolExp>;
};


/** columns and relationships of "lessons" */
export type LessonsLessonReflectionsArgs = {
  distinctOn?: InputMaybe<Array<LessonReflectionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonReflectionsOrderBy>>;
  where?: InputMaybe<LessonReflectionsBoolExp>;
};


/** columns and relationships of "lessons" */
export type LessonsLessonReflectionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonReflectionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonReflectionsOrderBy>>;
  where?: InputMaybe<LessonReflectionsBoolExp>;
};


/** columns and relationships of "lessons" */
export type LessonsOrdersArgs = {
  distinctOn?: InputMaybe<Array<LessonOrdersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonOrdersOrderBy>>;
  where?: InputMaybe<LessonOrdersBoolExp>;
};


/** columns and relationships of "lessons" */
export type LessonsOrdersAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonOrdersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonOrdersOrderBy>>;
  where?: InputMaybe<LessonOrdersBoolExp>;
};


/** columns and relationships of "lessons" */
export type LessonsParticipantsArgs = {
  distinctOn?: InputMaybe<Array<LessonParticipantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonParticipantsOrderBy>>;
  where?: InputMaybe<LessonParticipantsBoolExp>;
};


/** columns and relationships of "lessons" */
export type LessonsParticipantsAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonParticipantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonParticipantsOrderBy>>;
  where?: InputMaybe<LessonParticipantsBoolExp>;
};


/** columns and relationships of "lessons" */
export type LessonsSkillLevelsArgs = {
  distinctOn?: InputMaybe<Array<LessonSkillLevelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonSkillLevelsOrderBy>>;
  where?: InputMaybe<LessonSkillLevelsBoolExp>;
};


/** columns and relationships of "lessons" */
export type LessonsSkillLevelsAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonSkillLevelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonSkillLevelsOrderBy>>;
  where?: InputMaybe<LessonSkillLevelsBoolExp>;
};


/** columns and relationships of "lessons" */
export type LessonsTimesArgs = {
  distinctOn?: InputMaybe<Array<LessonTimesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonTimesOrderBy>>;
  where?: InputMaybe<LessonTimesBoolExp>;
};


/** columns and relationships of "lessons" */
export type LessonsTimesAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonTimesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonTimesOrderBy>>;
  where?: InputMaybe<LessonTimesBoolExp>;
};


/** columns and relationships of "lessons" */
export type LessonsWaitlistArgs = {
  distinctOn?: InputMaybe<Array<LessonWaitlistsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonWaitlistsOrderBy>>;
  where?: InputMaybe<LessonWaitlistsBoolExp>;
};


/** columns and relationships of "lessons" */
export type LessonsWaitlistAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonWaitlistsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonWaitlistsOrderBy>>;
  where?: InputMaybe<LessonWaitlistsBoolExp>;
};

/** aggregated selection of "lessons" */
export type LessonsAggregate = {
  __typename?: 'LessonsAggregate';
  aggregate?: Maybe<LessonsAggregateFields>;
  nodes: Array<Lessons>;
};

export type LessonsAggregateBoolExp = {
  count?: InputMaybe<LessonsAggregateBoolExpCount>;
};

/** aggregate fields of "lessons" */
export type LessonsAggregateFields = {
  __typename?: 'LessonsAggregateFields';
  avg?: Maybe<LessonsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<LessonsMaxFields>;
  min?: Maybe<LessonsMinFields>;
  stddev?: Maybe<LessonsStddevFields>;
  stddevPop?: Maybe<LessonsStddevPopFields>;
  stddevSamp?: Maybe<LessonsStddevSampFields>;
  sum?: Maybe<LessonsSumFields>;
  varPop?: Maybe<LessonsVarPopFields>;
  varSamp?: Maybe<LessonsVarSampFields>;
  variance?: Maybe<LessonsVarianceFields>;
};


/** aggregate fields of "lessons" */
export type LessonsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<LessonsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "lessons" */
export type LessonsAggregateOrderBy = {
  avg?: InputMaybe<LessonsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<LessonsMaxOrderBy>;
  min?: InputMaybe<LessonsMinOrderBy>;
  stddev?: InputMaybe<LessonsStddevOrderBy>;
  stddevPop?: InputMaybe<LessonsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<LessonsStddevSampOrderBy>;
  sum?: InputMaybe<LessonsSumOrderBy>;
  varPop?: InputMaybe<LessonsVarPopOrderBy>;
  varSamp?: InputMaybe<LessonsVarSampOrderBy>;
  variance?: InputMaybe<LessonsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "lessons" */
export type LessonsArrRelInsertInput = {
  data: Array<LessonsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<LessonsOnConflict>;
};

/** aggregate avg on columns */
export type LessonsAvgFields = {
  __typename?: 'LessonsAvgFields';
  participantLimit?: Maybe<Scalars['Float']>;
  /** This follows the standard from Stripe where a price is stored in its smallest denomination as an integer. In USD, this would be cents. For example, $42.23 is stored as 4223. */
  priceUnitAmount?: Maybe<Scalars['Float']>;
  timezoneOffsetMinutes?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "lessons" */
export type LessonsAvgOrderBy = {
  participantLimit?: InputMaybe<OrderBy>;
  /** This follows the standard from Stripe where a price is stored in its smallest denomination as an integer. In USD, this would be cents. For example, $42.23 is stored as 4223. */
  priceUnitAmount?: InputMaybe<OrderBy>;
  timezoneOffsetMinutes?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "lessons". All fields are combined with a logical 'AND'. */
export type LessonsBoolExp = {
  _and?: InputMaybe<Array<LessonsBoolExp>>;
  _not?: InputMaybe<LessonsBoolExp>;
  _or?: InputMaybe<Array<LessonsBoolExp>>;
  cancelReason?: InputMaybe<StringComparisonExp>;
  canceledAt?: InputMaybe<TimestamptzComparisonExp>;
  completionHasuraEventId?: InputMaybe<UuidComparisonExp>;
  conversations?: InputMaybe<ConversationsBoolExp>;
  conversationsAggregate?: InputMaybe<ConversationsAggregateBoolExp>;
  coverImageFileName?: InputMaybe<StringComparisonExp>;
  coverImagePath?: InputMaybe<StringComparisonExp>;
  coverImageProvider?: InputMaybe<StringComparisonExp>;
  coverImageProviderId?: InputMaybe<StringComparisonExp>;
  coverImageProviderUrl?: InputMaybe<StringComparisonExp>;
  coverImageUrl?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  currency?: InputMaybe<StringComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  endDateTime?: InputMaybe<TimestamptzComparisonExp>;
  equipment?: InputMaybe<LessonEquipmentBoolExp>;
  equipmentAggregate?: InputMaybe<LessonEquipmentAggregateBoolExp>;
  externalBookingUrl?: InputMaybe<StringComparisonExp>;
  externalId?: InputMaybe<StringComparisonExp>;
  externalSource?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  intendedAgeGroup?: InputMaybe<EventAgeGroupsEnumComparisonExp>;
  lessonCollection?: InputMaybe<LessonCollectionsBoolExp>;
  lessonCollectionId?: InputMaybe<UuidComparisonExp>;
  lessonPlayerSkillAssessments?: InputMaybe<LessonPlayerSkillAssessmentsBoolExp>;
  lessonPlayerSkillAssessmentsAggregate?: InputMaybe<LessonPlayerSkillAssessmentsAggregateBoolExp>;
  lessonReflectionId?: InputMaybe<UuidComparisonExp>;
  lessonReflections?: InputMaybe<LessonReflectionsBoolExp>;
  lessonReflectionsAggregate?: InputMaybe<LessonReflectionsAggregateBoolExp>;
  locale?: InputMaybe<StringComparisonExp>;
  orders?: InputMaybe<LessonOrdersBoolExp>;
  ordersAggregate?: InputMaybe<LessonOrdersAggregateBoolExp>;
  owner?: InputMaybe<UsersBoolExp>;
  ownerProfile?: InputMaybe<UserProfilesBoolExp>;
  ownerUserId?: InputMaybe<UuidComparisonExp>;
  participantLimit?: InputMaybe<IntComparisonExp>;
  participants?: InputMaybe<LessonParticipantsBoolExp>;
  participantsAggregate?: InputMaybe<LessonParticipantsAggregateBoolExp>;
  paymentFulfillmentChannel?: InputMaybe<PaymentFulfillmentChannelsEnumComparisonExp>;
  priceUnitAmount?: InputMaybe<IntComparisonExp>;
  privacy?: InputMaybe<LessonPrivacyEnumComparisonExp>;
  publishedAt?: InputMaybe<TimestamptzComparisonExp>;
  recurrenceKind?: InputMaybe<RecurrenceKindsEnumComparisonExp>;
  reminderEventId?: InputMaybe<UuidComparisonExp>;
  skillLevels?: InputMaybe<LessonSkillLevelsBoolExp>;
  skillLevelsAggregate?: InputMaybe<LessonSkillLevelsAggregateBoolExp>;
  sport?: InputMaybe<SportsEnumComparisonExp>;
  startDateTime?: InputMaybe<TimestamptzComparisonExp>;
  status?: InputMaybe<LessonStatusesEnumComparisonExp>;
  times?: InputMaybe<LessonTimesBoolExp>;
  timesAggregate?: InputMaybe<LessonTimesAggregateBoolExp>;
  timezoneAbbreviation?: InputMaybe<StringComparisonExp>;
  timezoneName?: InputMaybe<StringComparisonExp>;
  timezoneOffsetMinutes?: InputMaybe<IntComparisonExp>;
  title?: InputMaybe<StringComparisonExp>;
  type?: InputMaybe<LessonTypesEnumComparisonExp>;
  typeCustom?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  usedTemplate?: InputMaybe<LessonTemplatesBoolExp>;
  usedTemplateId?: InputMaybe<UuidComparisonExp>;
  userCustomCourt?: InputMaybe<UserCustomCourtsBoolExp>;
  userCustomCourtId?: InputMaybe<UuidComparisonExp>;
  venue?: InputMaybe<VenuesBoolExp>;
  venueId?: InputMaybe<UuidComparisonExp>;
  waitlist?: InputMaybe<LessonWaitlistsBoolExp>;
  waitlistAggregate?: InputMaybe<LessonWaitlistsAggregateBoolExp>;
};

/** unique or primary key constraints on table "lessons" */
export enum LessonsConstraint {
  /** unique or primary key constraint on columns "id" */
  LessonsPkey = 'lessons_pkey'
}

/** input type for incrementing numeric columns in table "lessons" */
export type LessonsIncInput = {
  participantLimit?: InputMaybe<Scalars['Int']>;
  /** This follows the standard from Stripe where a price is stored in its smallest denomination as an integer. In USD, this would be cents. For example, $42.23 is stored as 4223. */
  priceUnitAmount?: InputMaybe<Scalars['Int']>;
  timezoneOffsetMinutes?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "lessons" */
export type LessonsInsertInput = {
  cancelReason?: InputMaybe<Scalars['String']>;
  canceledAt?: InputMaybe<Scalars['timestamptz']>;
  completionHasuraEventId?: InputMaybe<Scalars['uuid']>;
  conversations?: InputMaybe<ConversationsArrRelInsertInput>;
  coverImageFileName?: InputMaybe<Scalars['String']>;
  coverImagePath?: InputMaybe<Scalars['String']>;
  coverImageProvider?: InputMaybe<Scalars['String']>;
  coverImageProviderId?: InputMaybe<Scalars['String']>;
  coverImageProviderUrl?: InputMaybe<Scalars['String']>;
  coverImageUrl?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  endDateTime?: InputMaybe<Scalars['timestamptz']>;
  equipment?: InputMaybe<LessonEquipmentArrRelInsertInput>;
  externalBookingUrl?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  externalSource?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  intendedAgeGroup?: InputMaybe<EventAgeGroupsEnum>;
  lessonCollection?: InputMaybe<LessonCollectionsObjRelInsertInput>;
  lessonCollectionId?: InputMaybe<Scalars['uuid']>;
  lessonPlayerSkillAssessments?: InputMaybe<LessonPlayerSkillAssessmentsArrRelInsertInput>;
  lessonReflectionId?: InputMaybe<Scalars['uuid']>;
  lessonReflections?: InputMaybe<LessonReflectionsArrRelInsertInput>;
  locale?: InputMaybe<Scalars['String']>;
  orders?: InputMaybe<LessonOrdersArrRelInsertInput>;
  owner?: InputMaybe<UsersObjRelInsertInput>;
  ownerProfile?: InputMaybe<UserProfilesObjRelInsertInput>;
  ownerUserId?: InputMaybe<Scalars['uuid']>;
  participantLimit?: InputMaybe<Scalars['Int']>;
  participants?: InputMaybe<LessonParticipantsArrRelInsertInput>;
  paymentFulfillmentChannel?: InputMaybe<PaymentFulfillmentChannelsEnum>;
  /** This follows the standard from Stripe where a price is stored in its smallest denomination as an integer. In USD, this would be cents. For example, $42.23 is stored as 4223. */
  priceUnitAmount?: InputMaybe<Scalars['Int']>;
  privacy?: InputMaybe<LessonPrivacyEnum>;
  publishedAt?: InputMaybe<Scalars['timestamptz']>;
  recurrenceKind?: InputMaybe<RecurrenceKindsEnum>;
  reminderEventId?: InputMaybe<Scalars['uuid']>;
  skillLevels?: InputMaybe<LessonSkillLevelsArrRelInsertInput>;
  sport?: InputMaybe<SportsEnum>;
  startDateTime?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<LessonStatusesEnum>;
  times?: InputMaybe<LessonTimesArrRelInsertInput>;
  timezoneAbbreviation?: InputMaybe<Scalars['String']>;
  timezoneName?: InputMaybe<Scalars['String']>;
  timezoneOffsetMinutes?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<LessonTypesEnum>;
  typeCustom?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  usedTemplate?: InputMaybe<LessonTemplatesObjRelInsertInput>;
  usedTemplateId?: InputMaybe<Scalars['uuid']>;
  userCustomCourt?: InputMaybe<UserCustomCourtsObjRelInsertInput>;
  userCustomCourtId?: InputMaybe<Scalars['uuid']>;
  venue?: InputMaybe<VenuesObjRelInsertInput>;
  venueId?: InputMaybe<Scalars['uuid']>;
  waitlist?: InputMaybe<LessonWaitlistsArrRelInsertInput>;
};

/** aggregate max on columns */
export type LessonsMaxFields = {
  __typename?: 'LessonsMaxFields';
  cancelReason?: Maybe<Scalars['String']>;
  canceledAt?: Maybe<Scalars['timestamptz']>;
  completionHasuraEventId?: Maybe<Scalars['uuid']>;
  coverImageFileName?: Maybe<Scalars['String']>;
  coverImagePath?: Maybe<Scalars['String']>;
  coverImageProvider?: Maybe<Scalars['String']>;
  coverImageProviderId?: Maybe<Scalars['String']>;
  coverImageProviderUrl?: Maybe<Scalars['String']>;
  coverImageUrl?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  endDateTime?: Maybe<Scalars['timestamptz']>;
  externalBookingUrl?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  externalSource?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  lessonCollectionId?: Maybe<Scalars['uuid']>;
  lessonReflectionId?: Maybe<Scalars['uuid']>;
  locale?: Maybe<Scalars['String']>;
  ownerUserId?: Maybe<Scalars['uuid']>;
  participantLimit?: Maybe<Scalars['Int']>;
  /** This follows the standard from Stripe where a price is stored in its smallest denomination as an integer. In USD, this would be cents. For example, $42.23 is stored as 4223. */
  priceUnitAmount?: Maybe<Scalars['Int']>;
  publishedAt?: Maybe<Scalars['timestamptz']>;
  reminderEventId?: Maybe<Scalars['uuid']>;
  startDateTime?: Maybe<Scalars['timestamptz']>;
  timezoneAbbreviation?: Maybe<Scalars['String']>;
  timezoneName?: Maybe<Scalars['String']>;
  timezoneOffsetMinutes?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  typeCustom?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  usedTemplateId?: Maybe<Scalars['uuid']>;
  userCustomCourtId?: Maybe<Scalars['uuid']>;
  venueId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "lessons" */
export type LessonsMaxOrderBy = {
  cancelReason?: InputMaybe<OrderBy>;
  canceledAt?: InputMaybe<OrderBy>;
  completionHasuraEventId?: InputMaybe<OrderBy>;
  coverImageFileName?: InputMaybe<OrderBy>;
  coverImagePath?: InputMaybe<OrderBy>;
  coverImageProvider?: InputMaybe<OrderBy>;
  coverImageProviderId?: InputMaybe<OrderBy>;
  coverImageProviderUrl?: InputMaybe<OrderBy>;
  coverImageUrl?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  currency?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  endDateTime?: InputMaybe<OrderBy>;
  externalBookingUrl?: InputMaybe<OrderBy>;
  externalId?: InputMaybe<OrderBy>;
  externalSource?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lessonCollectionId?: InputMaybe<OrderBy>;
  lessonReflectionId?: InputMaybe<OrderBy>;
  locale?: InputMaybe<OrderBy>;
  ownerUserId?: InputMaybe<OrderBy>;
  participantLimit?: InputMaybe<OrderBy>;
  /** This follows the standard from Stripe where a price is stored in its smallest denomination as an integer. In USD, this would be cents. For example, $42.23 is stored as 4223. */
  priceUnitAmount?: InputMaybe<OrderBy>;
  publishedAt?: InputMaybe<OrderBy>;
  reminderEventId?: InputMaybe<OrderBy>;
  startDateTime?: InputMaybe<OrderBy>;
  timezoneAbbreviation?: InputMaybe<OrderBy>;
  timezoneName?: InputMaybe<OrderBy>;
  timezoneOffsetMinutes?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  typeCustom?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  usedTemplateId?: InputMaybe<OrderBy>;
  userCustomCourtId?: InputMaybe<OrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type LessonsMinFields = {
  __typename?: 'LessonsMinFields';
  cancelReason?: Maybe<Scalars['String']>;
  canceledAt?: Maybe<Scalars['timestamptz']>;
  completionHasuraEventId?: Maybe<Scalars['uuid']>;
  coverImageFileName?: Maybe<Scalars['String']>;
  coverImagePath?: Maybe<Scalars['String']>;
  coverImageProvider?: Maybe<Scalars['String']>;
  coverImageProviderId?: Maybe<Scalars['String']>;
  coverImageProviderUrl?: Maybe<Scalars['String']>;
  coverImageUrl?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  endDateTime?: Maybe<Scalars['timestamptz']>;
  externalBookingUrl?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  externalSource?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  lessonCollectionId?: Maybe<Scalars['uuid']>;
  lessonReflectionId?: Maybe<Scalars['uuid']>;
  locale?: Maybe<Scalars['String']>;
  ownerUserId?: Maybe<Scalars['uuid']>;
  participantLimit?: Maybe<Scalars['Int']>;
  /** This follows the standard from Stripe where a price is stored in its smallest denomination as an integer. In USD, this would be cents. For example, $42.23 is stored as 4223. */
  priceUnitAmount?: Maybe<Scalars['Int']>;
  publishedAt?: Maybe<Scalars['timestamptz']>;
  reminderEventId?: Maybe<Scalars['uuid']>;
  startDateTime?: Maybe<Scalars['timestamptz']>;
  timezoneAbbreviation?: Maybe<Scalars['String']>;
  timezoneName?: Maybe<Scalars['String']>;
  timezoneOffsetMinutes?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  typeCustom?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  usedTemplateId?: Maybe<Scalars['uuid']>;
  userCustomCourtId?: Maybe<Scalars['uuid']>;
  venueId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "lessons" */
export type LessonsMinOrderBy = {
  cancelReason?: InputMaybe<OrderBy>;
  canceledAt?: InputMaybe<OrderBy>;
  completionHasuraEventId?: InputMaybe<OrderBy>;
  coverImageFileName?: InputMaybe<OrderBy>;
  coverImagePath?: InputMaybe<OrderBy>;
  coverImageProvider?: InputMaybe<OrderBy>;
  coverImageProviderId?: InputMaybe<OrderBy>;
  coverImageProviderUrl?: InputMaybe<OrderBy>;
  coverImageUrl?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  currency?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  endDateTime?: InputMaybe<OrderBy>;
  externalBookingUrl?: InputMaybe<OrderBy>;
  externalId?: InputMaybe<OrderBy>;
  externalSource?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lessonCollectionId?: InputMaybe<OrderBy>;
  lessonReflectionId?: InputMaybe<OrderBy>;
  locale?: InputMaybe<OrderBy>;
  ownerUserId?: InputMaybe<OrderBy>;
  participantLimit?: InputMaybe<OrderBy>;
  /** This follows the standard from Stripe where a price is stored in its smallest denomination as an integer. In USD, this would be cents. For example, $42.23 is stored as 4223. */
  priceUnitAmount?: InputMaybe<OrderBy>;
  publishedAt?: InputMaybe<OrderBy>;
  reminderEventId?: InputMaybe<OrderBy>;
  startDateTime?: InputMaybe<OrderBy>;
  timezoneAbbreviation?: InputMaybe<OrderBy>;
  timezoneName?: InputMaybe<OrderBy>;
  timezoneOffsetMinutes?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  typeCustom?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  usedTemplateId?: InputMaybe<OrderBy>;
  userCustomCourtId?: InputMaybe<OrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "lessons" */
export type LessonsMutationResponse = {
  __typename?: 'LessonsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Lessons>;
};

/** input type for inserting object relation for remote table "lessons" */
export type LessonsObjRelInsertInput = {
  data: LessonsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<LessonsOnConflict>;
};

/** on_conflict condition type for table "lessons" */
export type LessonsOnConflict = {
  constraint: LessonsConstraint;
  updateColumns?: Array<LessonsUpdateColumn>;
  where?: InputMaybe<LessonsBoolExp>;
};

/** Ordering options when selecting data from "lessons". */
export type LessonsOrderBy = {
  cancelReason?: InputMaybe<OrderBy>;
  canceledAt?: InputMaybe<OrderBy>;
  completionHasuraEventId?: InputMaybe<OrderBy>;
  conversationsAggregate?: InputMaybe<ConversationsAggregateOrderBy>;
  coverImageFileName?: InputMaybe<OrderBy>;
  coverImagePath?: InputMaybe<OrderBy>;
  coverImageProvider?: InputMaybe<OrderBy>;
  coverImageProviderId?: InputMaybe<OrderBy>;
  coverImageProviderUrl?: InputMaybe<OrderBy>;
  coverImageUrl?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  currency?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  endDateTime?: InputMaybe<OrderBy>;
  equipmentAggregate?: InputMaybe<LessonEquipmentAggregateOrderBy>;
  externalBookingUrl?: InputMaybe<OrderBy>;
  externalId?: InputMaybe<OrderBy>;
  externalSource?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  intendedAgeGroup?: InputMaybe<OrderBy>;
  lessonCollection?: InputMaybe<LessonCollectionsOrderBy>;
  lessonCollectionId?: InputMaybe<OrderBy>;
  lessonPlayerSkillAssessmentsAggregate?: InputMaybe<LessonPlayerSkillAssessmentsAggregateOrderBy>;
  lessonReflectionId?: InputMaybe<OrderBy>;
  lessonReflectionsAggregate?: InputMaybe<LessonReflectionsAggregateOrderBy>;
  locale?: InputMaybe<OrderBy>;
  ordersAggregate?: InputMaybe<LessonOrdersAggregateOrderBy>;
  owner?: InputMaybe<UsersOrderBy>;
  ownerProfile?: InputMaybe<UserProfilesOrderBy>;
  ownerUserId?: InputMaybe<OrderBy>;
  participantLimit?: InputMaybe<OrderBy>;
  participantsAggregate?: InputMaybe<LessonParticipantsAggregateOrderBy>;
  paymentFulfillmentChannel?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  privacy?: InputMaybe<OrderBy>;
  publishedAt?: InputMaybe<OrderBy>;
  recurrenceKind?: InputMaybe<OrderBy>;
  reminderEventId?: InputMaybe<OrderBy>;
  skillLevelsAggregate?: InputMaybe<LessonSkillLevelsAggregateOrderBy>;
  sport?: InputMaybe<OrderBy>;
  startDateTime?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  timesAggregate?: InputMaybe<LessonTimesAggregateOrderBy>;
  timezoneAbbreviation?: InputMaybe<OrderBy>;
  timezoneName?: InputMaybe<OrderBy>;
  timezoneOffsetMinutes?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  typeCustom?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  usedTemplate?: InputMaybe<LessonTemplatesOrderBy>;
  usedTemplateId?: InputMaybe<OrderBy>;
  userCustomCourt?: InputMaybe<UserCustomCourtsOrderBy>;
  userCustomCourtId?: InputMaybe<OrderBy>;
  venue?: InputMaybe<VenuesOrderBy>;
  venueId?: InputMaybe<OrderBy>;
  waitlistAggregate?: InputMaybe<LessonWaitlistsAggregateOrderBy>;
};

/** primary key columns input for table: lessons */
export type LessonsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "lessons" */
export enum LessonsSelectColumn {
  /** column name */
  CancelReason = 'cancelReason',
  /** column name */
  CanceledAt = 'canceledAt',
  /** column name */
  CompletionHasuraEventId = 'completionHasuraEventId',
  /** column name */
  CoverImageFileName = 'coverImageFileName',
  /** column name */
  CoverImagePath = 'coverImagePath',
  /** column name */
  CoverImageProvider = 'coverImageProvider',
  /** column name */
  CoverImageProviderId = 'coverImageProviderId',
  /** column name */
  CoverImageProviderUrl = 'coverImageProviderUrl',
  /** column name */
  CoverImageUrl = 'coverImageUrl',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Currency = 'currency',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Description = 'description',
  /** column name */
  EndDateTime = 'endDateTime',
  /** column name */
  ExternalBookingUrl = 'externalBookingUrl',
  /** column name */
  ExternalId = 'externalId',
  /** column name */
  ExternalSource = 'externalSource',
  /** column name */
  Id = 'id',
  /** column name */
  IntendedAgeGroup = 'intendedAgeGroup',
  /** column name */
  LessonCollectionId = 'lessonCollectionId',
  /** column name */
  LessonReflectionId = 'lessonReflectionId',
  /** column name */
  Locale = 'locale',
  /** column name */
  OwnerUserId = 'ownerUserId',
  /** column name */
  ParticipantLimit = 'participantLimit',
  /** column name */
  PaymentFulfillmentChannel = 'paymentFulfillmentChannel',
  /** column name */
  PriceUnitAmount = 'priceUnitAmount',
  /** column name */
  Privacy = 'privacy',
  /** column name */
  PublishedAt = 'publishedAt',
  /** column name */
  RecurrenceKind = 'recurrenceKind',
  /** column name */
  ReminderEventId = 'reminderEventId',
  /** column name */
  Sport = 'sport',
  /** column name */
  StartDateTime = 'startDateTime',
  /** column name */
  Status = 'status',
  /** column name */
  TimezoneAbbreviation = 'timezoneAbbreviation',
  /** column name */
  TimezoneName = 'timezoneName',
  /** column name */
  TimezoneOffsetMinutes = 'timezoneOffsetMinutes',
  /** column name */
  Title = 'title',
  /** column name */
  Type = 'type',
  /** column name */
  TypeCustom = 'typeCustom',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UsedTemplateId = 'usedTemplateId',
  /** column name */
  UserCustomCourtId = 'userCustomCourtId',
  /** column name */
  VenueId = 'venueId'
}

/** input type for updating data in table "lessons" */
export type LessonsSetInput = {
  cancelReason?: InputMaybe<Scalars['String']>;
  canceledAt?: InputMaybe<Scalars['timestamptz']>;
  completionHasuraEventId?: InputMaybe<Scalars['uuid']>;
  coverImageFileName?: InputMaybe<Scalars['String']>;
  coverImagePath?: InputMaybe<Scalars['String']>;
  coverImageProvider?: InputMaybe<Scalars['String']>;
  coverImageProviderId?: InputMaybe<Scalars['String']>;
  coverImageProviderUrl?: InputMaybe<Scalars['String']>;
  coverImageUrl?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  endDateTime?: InputMaybe<Scalars['timestamptz']>;
  externalBookingUrl?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  externalSource?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  intendedAgeGroup?: InputMaybe<EventAgeGroupsEnum>;
  lessonCollectionId?: InputMaybe<Scalars['uuid']>;
  lessonReflectionId?: InputMaybe<Scalars['uuid']>;
  locale?: InputMaybe<Scalars['String']>;
  ownerUserId?: InputMaybe<Scalars['uuid']>;
  participantLimit?: InputMaybe<Scalars['Int']>;
  paymentFulfillmentChannel?: InputMaybe<PaymentFulfillmentChannelsEnum>;
  /** This follows the standard from Stripe where a price is stored in its smallest denomination as an integer. In USD, this would be cents. For example, $42.23 is stored as 4223. */
  priceUnitAmount?: InputMaybe<Scalars['Int']>;
  privacy?: InputMaybe<LessonPrivacyEnum>;
  publishedAt?: InputMaybe<Scalars['timestamptz']>;
  recurrenceKind?: InputMaybe<RecurrenceKindsEnum>;
  reminderEventId?: InputMaybe<Scalars['uuid']>;
  sport?: InputMaybe<SportsEnum>;
  startDateTime?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<LessonStatusesEnum>;
  timezoneAbbreviation?: InputMaybe<Scalars['String']>;
  timezoneName?: InputMaybe<Scalars['String']>;
  timezoneOffsetMinutes?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<LessonTypesEnum>;
  typeCustom?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  usedTemplateId?: InputMaybe<Scalars['uuid']>;
  userCustomCourtId?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type LessonsStddevFields = {
  __typename?: 'LessonsStddevFields';
  participantLimit?: Maybe<Scalars['Float']>;
  /** This follows the standard from Stripe where a price is stored in its smallest denomination as an integer. In USD, this would be cents. For example, $42.23 is stored as 4223. */
  priceUnitAmount?: Maybe<Scalars['Float']>;
  timezoneOffsetMinutes?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "lessons" */
export type LessonsStddevOrderBy = {
  participantLimit?: InputMaybe<OrderBy>;
  /** This follows the standard from Stripe where a price is stored in its smallest denomination as an integer. In USD, this would be cents. For example, $42.23 is stored as 4223. */
  priceUnitAmount?: InputMaybe<OrderBy>;
  timezoneOffsetMinutes?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type LessonsStddevPopFields = {
  __typename?: 'LessonsStddevPopFields';
  participantLimit?: Maybe<Scalars['Float']>;
  /** This follows the standard from Stripe where a price is stored in its smallest denomination as an integer. In USD, this would be cents. For example, $42.23 is stored as 4223. */
  priceUnitAmount?: Maybe<Scalars['Float']>;
  timezoneOffsetMinutes?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "lessons" */
export type LessonsStddevPopOrderBy = {
  participantLimit?: InputMaybe<OrderBy>;
  /** This follows the standard from Stripe where a price is stored in its smallest denomination as an integer. In USD, this would be cents. For example, $42.23 is stored as 4223. */
  priceUnitAmount?: InputMaybe<OrderBy>;
  timezoneOffsetMinutes?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type LessonsStddevSampFields = {
  __typename?: 'LessonsStddevSampFields';
  participantLimit?: Maybe<Scalars['Float']>;
  /** This follows the standard from Stripe where a price is stored in its smallest denomination as an integer. In USD, this would be cents. For example, $42.23 is stored as 4223. */
  priceUnitAmount?: Maybe<Scalars['Float']>;
  timezoneOffsetMinutes?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "lessons" */
export type LessonsStddevSampOrderBy = {
  participantLimit?: InputMaybe<OrderBy>;
  /** This follows the standard from Stripe where a price is stored in its smallest denomination as an integer. In USD, this would be cents. For example, $42.23 is stored as 4223. */
  priceUnitAmount?: InputMaybe<OrderBy>;
  timezoneOffsetMinutes?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "lessons" */
export type LessonsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: LessonsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LessonsStreamCursorValueInput = {
  cancelReason?: InputMaybe<Scalars['String']>;
  canceledAt?: InputMaybe<Scalars['timestamptz']>;
  completionHasuraEventId?: InputMaybe<Scalars['uuid']>;
  coverImageFileName?: InputMaybe<Scalars['String']>;
  coverImagePath?: InputMaybe<Scalars['String']>;
  coverImageProvider?: InputMaybe<Scalars['String']>;
  coverImageProviderId?: InputMaybe<Scalars['String']>;
  coverImageProviderUrl?: InputMaybe<Scalars['String']>;
  coverImageUrl?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  endDateTime?: InputMaybe<Scalars['timestamptz']>;
  externalBookingUrl?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  externalSource?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  intendedAgeGroup?: InputMaybe<EventAgeGroupsEnum>;
  lessonCollectionId?: InputMaybe<Scalars['uuid']>;
  lessonReflectionId?: InputMaybe<Scalars['uuid']>;
  locale?: InputMaybe<Scalars['String']>;
  ownerUserId?: InputMaybe<Scalars['uuid']>;
  participantLimit?: InputMaybe<Scalars['Int']>;
  paymentFulfillmentChannel?: InputMaybe<PaymentFulfillmentChannelsEnum>;
  /** This follows the standard from Stripe where a price is stored in its smallest denomination as an integer. In USD, this would be cents. For example, $42.23 is stored as 4223. */
  priceUnitAmount?: InputMaybe<Scalars['Int']>;
  privacy?: InputMaybe<LessonPrivacyEnum>;
  publishedAt?: InputMaybe<Scalars['timestamptz']>;
  recurrenceKind?: InputMaybe<RecurrenceKindsEnum>;
  reminderEventId?: InputMaybe<Scalars['uuid']>;
  sport?: InputMaybe<SportsEnum>;
  startDateTime?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<LessonStatusesEnum>;
  timezoneAbbreviation?: InputMaybe<Scalars['String']>;
  timezoneName?: InputMaybe<Scalars['String']>;
  timezoneOffsetMinutes?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<LessonTypesEnum>;
  typeCustom?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  usedTemplateId?: InputMaybe<Scalars['uuid']>;
  userCustomCourtId?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type LessonsSumFields = {
  __typename?: 'LessonsSumFields';
  participantLimit?: Maybe<Scalars['Int']>;
  /** This follows the standard from Stripe where a price is stored in its smallest denomination as an integer. In USD, this would be cents. For example, $42.23 is stored as 4223. */
  priceUnitAmount?: Maybe<Scalars['Int']>;
  timezoneOffsetMinutes?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "lessons" */
export type LessonsSumOrderBy = {
  participantLimit?: InputMaybe<OrderBy>;
  /** This follows the standard from Stripe where a price is stored in its smallest denomination as an integer. In USD, this would be cents. For example, $42.23 is stored as 4223. */
  priceUnitAmount?: InputMaybe<OrderBy>;
  timezoneOffsetMinutes?: InputMaybe<OrderBy>;
};

/** update columns of table "lessons" */
export enum LessonsUpdateColumn {
  /** column name */
  CancelReason = 'cancelReason',
  /** column name */
  CanceledAt = 'canceledAt',
  /** column name */
  CompletionHasuraEventId = 'completionHasuraEventId',
  /** column name */
  CoverImageFileName = 'coverImageFileName',
  /** column name */
  CoverImagePath = 'coverImagePath',
  /** column name */
  CoverImageProvider = 'coverImageProvider',
  /** column name */
  CoverImageProviderId = 'coverImageProviderId',
  /** column name */
  CoverImageProviderUrl = 'coverImageProviderUrl',
  /** column name */
  CoverImageUrl = 'coverImageUrl',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Currency = 'currency',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Description = 'description',
  /** column name */
  EndDateTime = 'endDateTime',
  /** column name */
  ExternalBookingUrl = 'externalBookingUrl',
  /** column name */
  ExternalId = 'externalId',
  /** column name */
  ExternalSource = 'externalSource',
  /** column name */
  Id = 'id',
  /** column name */
  IntendedAgeGroup = 'intendedAgeGroup',
  /** column name */
  LessonCollectionId = 'lessonCollectionId',
  /** column name */
  LessonReflectionId = 'lessonReflectionId',
  /** column name */
  Locale = 'locale',
  /** column name */
  OwnerUserId = 'ownerUserId',
  /** column name */
  ParticipantLimit = 'participantLimit',
  /** column name */
  PaymentFulfillmentChannel = 'paymentFulfillmentChannel',
  /** column name */
  PriceUnitAmount = 'priceUnitAmount',
  /** column name */
  Privacy = 'privacy',
  /** column name */
  PublishedAt = 'publishedAt',
  /** column name */
  RecurrenceKind = 'recurrenceKind',
  /** column name */
  ReminderEventId = 'reminderEventId',
  /** column name */
  Sport = 'sport',
  /** column name */
  StartDateTime = 'startDateTime',
  /** column name */
  Status = 'status',
  /** column name */
  TimezoneAbbreviation = 'timezoneAbbreviation',
  /** column name */
  TimezoneName = 'timezoneName',
  /** column name */
  TimezoneOffsetMinutes = 'timezoneOffsetMinutes',
  /** column name */
  Title = 'title',
  /** column name */
  Type = 'type',
  /** column name */
  TypeCustom = 'typeCustom',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UsedTemplateId = 'usedTemplateId',
  /** column name */
  UserCustomCourtId = 'userCustomCourtId',
  /** column name */
  VenueId = 'venueId'
}

export type LessonsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<LessonsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LessonsSetInput>;
  /** filter the rows which have to be updated */
  where: LessonsBoolExp;
};

/** aggregate varPop on columns */
export type LessonsVarPopFields = {
  __typename?: 'LessonsVarPopFields';
  participantLimit?: Maybe<Scalars['Float']>;
  /** This follows the standard from Stripe where a price is stored in its smallest denomination as an integer. In USD, this would be cents. For example, $42.23 is stored as 4223. */
  priceUnitAmount?: Maybe<Scalars['Float']>;
  timezoneOffsetMinutes?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "lessons" */
export type LessonsVarPopOrderBy = {
  participantLimit?: InputMaybe<OrderBy>;
  /** This follows the standard from Stripe where a price is stored in its smallest denomination as an integer. In USD, this would be cents. For example, $42.23 is stored as 4223. */
  priceUnitAmount?: InputMaybe<OrderBy>;
  timezoneOffsetMinutes?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type LessonsVarSampFields = {
  __typename?: 'LessonsVarSampFields';
  participantLimit?: Maybe<Scalars['Float']>;
  /** This follows the standard from Stripe where a price is stored in its smallest denomination as an integer. In USD, this would be cents. For example, $42.23 is stored as 4223. */
  priceUnitAmount?: Maybe<Scalars['Float']>;
  timezoneOffsetMinutes?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "lessons" */
export type LessonsVarSampOrderBy = {
  participantLimit?: InputMaybe<OrderBy>;
  /** This follows the standard from Stripe where a price is stored in its smallest denomination as an integer. In USD, this would be cents. For example, $42.23 is stored as 4223. */
  priceUnitAmount?: InputMaybe<OrderBy>;
  timezoneOffsetMinutes?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type LessonsVarianceFields = {
  __typename?: 'LessonsVarianceFields';
  participantLimit?: Maybe<Scalars['Float']>;
  /** This follows the standard from Stripe where a price is stored in its smallest denomination as an integer. In USD, this would be cents. For example, $42.23 is stored as 4223. */
  priceUnitAmount?: Maybe<Scalars['Float']>;
  timezoneOffsetMinutes?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "lessons" */
export type LessonsVarianceOrderBy = {
  participantLimit?: InputMaybe<OrderBy>;
  /** This follows the standard from Stripe where a price is stored in its smallest denomination as an integer. In USD, this would be cents. For example, $42.23 is stored as 4223. */
  priceUnitAmount?: InputMaybe<OrderBy>;
  timezoneOffsetMinutes?: InputMaybe<OrderBy>;
};

/** columns and relationships of "match_selection_criteria" */
export type MatchSelectionCriteria = {
  __typename?: 'MatchSelectionCriteria';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "match_selection_criteria" */
export type MatchSelectionCriteriaAggregate = {
  __typename?: 'MatchSelectionCriteriaAggregate';
  aggregate?: Maybe<MatchSelectionCriteriaAggregateFields>;
  nodes: Array<MatchSelectionCriteria>;
};

/** aggregate fields of "match_selection_criteria" */
export type MatchSelectionCriteriaAggregateFields = {
  __typename?: 'MatchSelectionCriteriaAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<MatchSelectionCriteriaMaxFields>;
  min?: Maybe<MatchSelectionCriteriaMinFields>;
};


/** aggregate fields of "match_selection_criteria" */
export type MatchSelectionCriteriaAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<MatchSelectionCriteriaSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "match_selection_criteria". All fields are combined with a logical 'AND'. */
export type MatchSelectionCriteriaBoolExp = {
  _and?: InputMaybe<Array<MatchSelectionCriteriaBoolExp>>;
  _not?: InputMaybe<MatchSelectionCriteriaBoolExp>;
  _or?: InputMaybe<Array<MatchSelectionCriteriaBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "match_selection_criteria" */
export enum MatchSelectionCriteriaConstraint {
  /** unique or primary key constraint on columns "value" */
  MatchSelectionCriteriaPkey = 'match_selection_criteria_pkey'
}

export enum MatchSelectionCriteriaEnum {
  Loser = 'LOSER',
  Winner = 'WINNER'
}

/** Boolean expression to compare columns of type "MatchSelectionCriteriaEnum". All fields are combined with logical 'AND'. */
export type MatchSelectionCriteriaEnumComparisonExp = {
  _eq?: InputMaybe<MatchSelectionCriteriaEnum>;
  _in?: InputMaybe<Array<MatchSelectionCriteriaEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<MatchSelectionCriteriaEnum>;
  _nin?: InputMaybe<Array<MatchSelectionCriteriaEnum>>;
};

/** input type for inserting data into table "match_selection_criteria" */
export type MatchSelectionCriteriaInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type MatchSelectionCriteriaMaxFields = {
  __typename?: 'MatchSelectionCriteriaMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type MatchSelectionCriteriaMinFields = {
  __typename?: 'MatchSelectionCriteriaMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "match_selection_criteria" */
export type MatchSelectionCriteriaMutationResponse = {
  __typename?: 'MatchSelectionCriteriaMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<MatchSelectionCriteria>;
};

/** on_conflict condition type for table "match_selection_criteria" */
export type MatchSelectionCriteriaOnConflict = {
  constraint: MatchSelectionCriteriaConstraint;
  updateColumns?: Array<MatchSelectionCriteriaUpdateColumn>;
  where?: InputMaybe<MatchSelectionCriteriaBoolExp>;
};

/** Ordering options when selecting data from "match_selection_criteria". */
export type MatchSelectionCriteriaOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: match_selection_criteria */
export type MatchSelectionCriteriaPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "match_selection_criteria" */
export enum MatchSelectionCriteriaSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "match_selection_criteria" */
export type MatchSelectionCriteriaSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "match_selection_criteria" */
export type MatchSelectionCriteriaStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: MatchSelectionCriteriaStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type MatchSelectionCriteriaStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "match_selection_criteria" */
export enum MatchSelectionCriteriaUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type MatchSelectionCriteriaUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MatchSelectionCriteriaSetInput>;
  /** filter the rows which have to be updated */
  where: MatchSelectionCriteriaBoolExp;
};

/** columns and relationships of "messages" */
export type Messages = {
  __typename?: 'Messages';
  body: Scalars['String'];
  /** An object relationship */
  conversation: Conversations;
  conversationId: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  editedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  /** An object relationship */
  sender: Users;
  /** An object relationship */
  senderProfile?: Maybe<UserProfiles>;
  senderUserId: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "messages" */
export type MessagesAggregate = {
  __typename?: 'MessagesAggregate';
  aggregate?: Maybe<MessagesAggregateFields>;
  nodes: Array<Messages>;
};

export type MessagesAggregateBoolExp = {
  count?: InputMaybe<MessagesAggregateBoolExpCount>;
};

/** aggregate fields of "messages" */
export type MessagesAggregateFields = {
  __typename?: 'MessagesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<MessagesMaxFields>;
  min?: Maybe<MessagesMinFields>;
};


/** aggregate fields of "messages" */
export type MessagesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<MessagesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "messages" */
export type MessagesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<MessagesMaxOrderBy>;
  min?: InputMaybe<MessagesMinOrderBy>;
};

/** input type for inserting array relation for remote table "messages" */
export type MessagesArrRelInsertInput = {
  data: Array<MessagesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<MessagesOnConflict>;
};

/** Boolean expression to filter rows from the table "messages". All fields are combined with a logical 'AND'. */
export type MessagesBoolExp = {
  _and?: InputMaybe<Array<MessagesBoolExp>>;
  _not?: InputMaybe<MessagesBoolExp>;
  _or?: InputMaybe<Array<MessagesBoolExp>>;
  body?: InputMaybe<StringComparisonExp>;
  conversation?: InputMaybe<ConversationsBoolExp>;
  conversationId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  editedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  sender?: InputMaybe<UsersBoolExp>;
  senderProfile?: InputMaybe<UserProfilesBoolExp>;
  senderUserId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "messages" */
export enum MessagesConstraint {
  /** unique or primary key constraint on columns "id" */
  MessagesPkey = 'messages_pkey'
}

/** input type for inserting data into table "messages" */
export type MessagesInsertInput = {
  body?: InputMaybe<Scalars['String']>;
  conversation?: InputMaybe<ConversationsObjRelInsertInput>;
  conversationId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  editedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  sender?: InputMaybe<UsersObjRelInsertInput>;
  senderProfile?: InputMaybe<UserProfilesObjRelInsertInput>;
  senderUserId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type MessagesMaxFields = {
  __typename?: 'MessagesMaxFields';
  body?: Maybe<Scalars['String']>;
  conversationId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  editedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  senderUserId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "messages" */
export type MessagesMaxOrderBy = {
  body?: InputMaybe<OrderBy>;
  conversationId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  editedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  senderUserId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type MessagesMinFields = {
  __typename?: 'MessagesMinFields';
  body?: Maybe<Scalars['String']>;
  conversationId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  editedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  senderUserId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "messages" */
export type MessagesMinOrderBy = {
  body?: InputMaybe<OrderBy>;
  conversationId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  editedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  senderUserId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "messages" */
export type MessagesMutationResponse = {
  __typename?: 'MessagesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Messages>;
};

/** input type for inserting object relation for remote table "messages" */
export type MessagesObjRelInsertInput = {
  data: MessagesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<MessagesOnConflict>;
};

/** on_conflict condition type for table "messages" */
export type MessagesOnConflict = {
  constraint: MessagesConstraint;
  updateColumns?: Array<MessagesUpdateColumn>;
  where?: InputMaybe<MessagesBoolExp>;
};

/** Ordering options when selecting data from "messages". */
export type MessagesOrderBy = {
  body?: InputMaybe<OrderBy>;
  conversation?: InputMaybe<ConversationsOrderBy>;
  conversationId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  editedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  sender?: InputMaybe<UsersOrderBy>;
  senderProfile?: InputMaybe<UserProfilesOrderBy>;
  senderUserId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: messages */
export type MessagesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "messages" */
export enum MessagesSelectColumn {
  /** column name */
  Body = 'body',
  /** column name */
  ConversationId = 'conversationId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EditedAt = 'editedAt',
  /** column name */
  Id = 'id',
  /** column name */
  SenderUserId = 'senderUserId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "messages" */
export type MessagesSetInput = {
  body?: InputMaybe<Scalars['String']>;
  conversationId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  editedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  senderUserId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "messages" */
export type MessagesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: MessagesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type MessagesStreamCursorValueInput = {
  body?: InputMaybe<Scalars['String']>;
  conversationId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  editedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  senderUserId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "messages" */
export enum MessagesUpdateColumn {
  /** column name */
  Body = 'body',
  /** column name */
  ConversationId = 'conversationId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EditedAt = 'editedAt',
  /** column name */
  Id = 'id',
  /** column name */
  SenderUserId = 'senderUserId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type MessagesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MessagesSetInput>;
  /** filter the rows which have to be updated */
  where: MessagesBoolExp;
};

/** columns and relationships of "neighborhoods" */
export type Neighborhoods = {
  __typename?: 'Neighborhoods';
  /** An object relationship */
  city: Cities;
  cityId: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  geometry?: Maybe<Scalars['geography']>;
  id: Scalars['uuid'];
  isActive: Scalars['Boolean'];
  latitude: Scalars['numeric'];
  longitude: Scalars['numeric'];
  name: Scalars['String'];
  radiusMiles: Scalars['numeric'];
  slug: Scalars['String'];
  sortOrder: Scalars['Int'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "neighborhoods" */
export type NeighborhoodsAggregate = {
  __typename?: 'NeighborhoodsAggregate';
  aggregate?: Maybe<NeighborhoodsAggregateFields>;
  nodes: Array<Neighborhoods>;
};

/** aggregate fields of "neighborhoods" */
export type NeighborhoodsAggregateFields = {
  __typename?: 'NeighborhoodsAggregateFields';
  avg?: Maybe<NeighborhoodsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<NeighborhoodsMaxFields>;
  min?: Maybe<NeighborhoodsMinFields>;
  stddev?: Maybe<NeighborhoodsStddevFields>;
  stddevPop?: Maybe<NeighborhoodsStddevPopFields>;
  stddevSamp?: Maybe<NeighborhoodsStddevSampFields>;
  sum?: Maybe<NeighborhoodsSumFields>;
  varPop?: Maybe<NeighborhoodsVarPopFields>;
  varSamp?: Maybe<NeighborhoodsVarSampFields>;
  variance?: Maybe<NeighborhoodsVarianceFields>;
};


/** aggregate fields of "neighborhoods" */
export type NeighborhoodsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<NeighborhoodsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type NeighborhoodsAvgFields = {
  __typename?: 'NeighborhoodsAvgFields';
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  radiusMiles?: Maybe<Scalars['Float']>;
  sortOrder?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "neighborhoods". All fields are combined with a logical 'AND'. */
export type NeighborhoodsBoolExp = {
  _and?: InputMaybe<Array<NeighborhoodsBoolExp>>;
  _not?: InputMaybe<NeighborhoodsBoolExp>;
  _or?: InputMaybe<Array<NeighborhoodsBoolExp>>;
  city?: InputMaybe<CitiesBoolExp>;
  cityId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  geometry?: InputMaybe<GeographyComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isActive?: InputMaybe<BooleanComparisonExp>;
  latitude?: InputMaybe<NumericComparisonExp>;
  longitude?: InputMaybe<NumericComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  radiusMiles?: InputMaybe<NumericComparisonExp>;
  slug?: InputMaybe<StringComparisonExp>;
  sortOrder?: InputMaybe<IntComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "neighborhoods" */
export enum NeighborhoodsConstraint {
  /** unique or primary key constraint on columns "id" */
  NeighborhoodsPkey = 'neighborhoods_pkey',
  /** unique or primary key constraint on columns "slug" */
  NeighborhoodsSlugKey = 'neighborhoods_slug_key'
}

/** input type for incrementing numeric columns in table "neighborhoods" */
export type NeighborhoodsIncInput = {
  latitude?: InputMaybe<Scalars['numeric']>;
  longitude?: InputMaybe<Scalars['numeric']>;
  radiusMiles?: InputMaybe<Scalars['numeric']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "neighborhoods" */
export type NeighborhoodsInsertInput = {
  city?: InputMaybe<CitiesObjRelInsertInput>;
  cityId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  latitude?: InputMaybe<Scalars['numeric']>;
  longitude?: InputMaybe<Scalars['numeric']>;
  name?: InputMaybe<Scalars['String']>;
  radiusMiles?: InputMaybe<Scalars['numeric']>;
  slug?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type NeighborhoodsMaxFields = {
  __typename?: 'NeighborhoodsMaxFields';
  cityId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  latitude?: Maybe<Scalars['numeric']>;
  longitude?: Maybe<Scalars['numeric']>;
  name?: Maybe<Scalars['String']>;
  radiusMiles?: Maybe<Scalars['numeric']>;
  slug?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type NeighborhoodsMinFields = {
  __typename?: 'NeighborhoodsMinFields';
  cityId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  latitude?: Maybe<Scalars['numeric']>;
  longitude?: Maybe<Scalars['numeric']>;
  name?: Maybe<Scalars['String']>;
  radiusMiles?: Maybe<Scalars['numeric']>;
  slug?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "neighborhoods" */
export type NeighborhoodsMutationResponse = {
  __typename?: 'NeighborhoodsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Neighborhoods>;
};

/** input type for inserting object relation for remote table "neighborhoods" */
export type NeighborhoodsObjRelInsertInput = {
  data: NeighborhoodsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<NeighborhoodsOnConflict>;
};

/** on_conflict condition type for table "neighborhoods" */
export type NeighborhoodsOnConflict = {
  constraint: NeighborhoodsConstraint;
  updateColumns?: Array<NeighborhoodsUpdateColumn>;
  where?: InputMaybe<NeighborhoodsBoolExp>;
};

/** Ordering options when selecting data from "neighborhoods". */
export type NeighborhoodsOrderBy = {
  city?: InputMaybe<CitiesOrderBy>;
  cityId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  geometry?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  isActive?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  radiusMiles?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  sortOrder?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: neighborhoods */
export type NeighborhoodsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "neighborhoods" */
export enum NeighborhoodsSelectColumn {
  /** column name */
  CityId = 'cityId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Geometry = 'geometry',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'isActive',
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Longitude = 'longitude',
  /** column name */
  Name = 'name',
  /** column name */
  RadiusMiles = 'radiusMiles',
  /** column name */
  Slug = 'slug',
  /** column name */
  SortOrder = 'sortOrder',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "neighborhoods" */
export type NeighborhoodsSetInput = {
  cityId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  latitude?: InputMaybe<Scalars['numeric']>;
  longitude?: InputMaybe<Scalars['numeric']>;
  name?: InputMaybe<Scalars['String']>;
  radiusMiles?: InputMaybe<Scalars['numeric']>;
  slug?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type NeighborhoodsStddevFields = {
  __typename?: 'NeighborhoodsStddevFields';
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  radiusMiles?: Maybe<Scalars['Float']>;
  sortOrder?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type NeighborhoodsStddevPopFields = {
  __typename?: 'NeighborhoodsStddevPopFields';
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  radiusMiles?: Maybe<Scalars['Float']>;
  sortOrder?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type NeighborhoodsStddevSampFields = {
  __typename?: 'NeighborhoodsStddevSampFields';
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  radiusMiles?: Maybe<Scalars['Float']>;
  sortOrder?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "neighborhoods" */
export type NeighborhoodsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: NeighborhoodsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type NeighborhoodsStreamCursorValueInput = {
  cityId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  geometry?: InputMaybe<Scalars['geography']>;
  id?: InputMaybe<Scalars['uuid']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  latitude?: InputMaybe<Scalars['numeric']>;
  longitude?: InputMaybe<Scalars['numeric']>;
  name?: InputMaybe<Scalars['String']>;
  radiusMiles?: InputMaybe<Scalars['numeric']>;
  slug?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type NeighborhoodsSumFields = {
  __typename?: 'NeighborhoodsSumFields';
  latitude?: Maybe<Scalars['numeric']>;
  longitude?: Maybe<Scalars['numeric']>;
  radiusMiles?: Maybe<Scalars['numeric']>;
  sortOrder?: Maybe<Scalars['Int']>;
};

/** update columns of table "neighborhoods" */
export enum NeighborhoodsUpdateColumn {
  /** column name */
  CityId = 'cityId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'isActive',
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Longitude = 'longitude',
  /** column name */
  Name = 'name',
  /** column name */
  RadiusMiles = 'radiusMiles',
  /** column name */
  Slug = 'slug',
  /** column name */
  SortOrder = 'sortOrder',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type NeighborhoodsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<NeighborhoodsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<NeighborhoodsSetInput>;
  /** filter the rows which have to be updated */
  where: NeighborhoodsBoolExp;
};

/** aggregate varPop on columns */
export type NeighborhoodsVarPopFields = {
  __typename?: 'NeighborhoodsVarPopFields';
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  radiusMiles?: Maybe<Scalars['Float']>;
  sortOrder?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type NeighborhoodsVarSampFields = {
  __typename?: 'NeighborhoodsVarSampFields';
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  radiusMiles?: Maybe<Scalars['Float']>;
  sortOrder?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type NeighborhoodsVarianceFields = {
  __typename?: 'NeighborhoodsVarianceFields';
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  radiusMiles?: Maybe<Scalars['Float']>;
  sortOrder?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "notification_action_types" */
export type NotificationActionTypes = {
  __typename?: 'NotificationActionTypes';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "notification_action_types" */
export type NotificationActionTypesAggregate = {
  __typename?: 'NotificationActionTypesAggregate';
  aggregate?: Maybe<NotificationActionTypesAggregateFields>;
  nodes: Array<NotificationActionTypes>;
};

/** aggregate fields of "notification_action_types" */
export type NotificationActionTypesAggregateFields = {
  __typename?: 'NotificationActionTypesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<NotificationActionTypesMaxFields>;
  min?: Maybe<NotificationActionTypesMinFields>;
};


/** aggregate fields of "notification_action_types" */
export type NotificationActionTypesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<NotificationActionTypesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "notification_action_types". All fields are combined with a logical 'AND'. */
export type NotificationActionTypesBoolExp = {
  _and?: InputMaybe<Array<NotificationActionTypesBoolExp>>;
  _not?: InputMaybe<NotificationActionTypesBoolExp>;
  _or?: InputMaybe<Array<NotificationActionTypesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "notification_action_types" */
export enum NotificationActionTypesConstraint {
  /** unique or primary key constraint on columns "value" */
  NotificationActionTypesPkey = 'notification_action_types_pkey'
}

export enum NotificationActionTypesEnum {
  CompleteReflectionForCoach = 'COMPLETE_REFLECTION_FOR_COACH',
  /** A player accepted your connection request */
  ConnectionRequestAccepted = 'CONNECTION_REQUEST_ACCEPTED',
  /** A player wants to connect with you */
  ConnectionRequestReceived = 'CONNECTION_REQUEST_RECEIVED',
  /** The club confirmed your court booking */
  CourtBookingConfirmed = 'COURT_BOOKING_CONFIRMED',
  /** Your court could not be booked; the card was not charged */
  CourtBookingFailed = 'COURT_BOOKING_FAILED',
  FollowerUserNew = 'FOLLOWER_USER_NEW',
  /** A player accepted your game invite */
  GameInviteAccepted = 'GAME_INVITE_ACCEPTED',
  /** A player declined your game invite */
  GameInviteDeclined = 'GAME_INVITE_DECLINED',
  /** A host invited you to a game */
  GameInviteReceived = 'GAME_INVITE_RECEIVED',
  GroupCommentReply = 'GROUP_COMMENT_REPLY',
  GroupCommentUpvote = 'GROUP_COMMENT_UPVOTE',
  LessonCoachCancel = 'LESSON_COACH_CANCEL',
  LessonParticipantJoin = 'LESSON_PARTICIPANT_JOIN',
  LessonParticipantLeave = 'LESSON_PARTICIPANT_LEAVE',
  LessonStartReminder = 'LESSON_START_REMINDER',
  /** You received a new chat message */
  MessageReceived = 'MESSAGE_RECEIVED',
  NewReflectionForPlayer = 'NEW_REFLECTION_FOR_PLAYER',
  /** A host accepted your play request */
  PlayRequestAccepted = 'PLAY_REQUEST_ACCEPTED',
  /** Your pending request was cancelled because the game filled up */
  PlayRequestAutoCancelled = 'PLAY_REQUEST_AUTO_CANCELLED',
  /** A host declined your play request */
  PlayRequestDeclined = 'PLAY_REQUEST_DECLINED',
  /** A player sent a request to join your game or play from your availability */
  PlayRequestReceived = 'PLAY_REQUEST_RECEIVED',
  PlaySessionCommentSubmit = 'PLAY_SESSION_COMMENT_SUBMIT',
  PlaySessionDetailsUpdate = 'PLAY_SESSION_DETAILS_UPDATE',
  PlaySessionOrganizerCancel = 'PLAY_SESSION_ORGANIZER_CANCEL',
  PlaySessionParticipantJoin = 'PLAY_SESSION_PARTICIPANT_JOIN',
  PlaySessionParticipantLeave = 'PLAY_SESSION_PARTICIPANT_LEAVE',
  PlaySessionStartReminder = 'PLAY_SESSION_START_REMINDER',
  ReviewCoachNotification = 'REVIEW_COACH_NOTIFICATION',
  TournamentPartnerRequestReceived = 'TOURNAMENT_PARTNER_REQUEST_RECEIVED',
  VideoAnalysisCompletePlayer = 'VIDEO_ANALYSIS_COMPLETE_PLAYER',
  VideoSubmissionConfirmPlayer = 'VIDEO_SUBMISSION_CONFIRM_PLAYER',
  VideoSubmissionNotificationCoach = 'VIDEO_SUBMISSION_NOTIFICATION_COACH'
}

/** Boolean expression to compare columns of type "NotificationActionTypesEnum". All fields are combined with logical 'AND'. */
export type NotificationActionTypesEnumComparisonExp = {
  _eq?: InputMaybe<NotificationActionTypesEnum>;
  _in?: InputMaybe<Array<NotificationActionTypesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<NotificationActionTypesEnum>;
  _nin?: InputMaybe<Array<NotificationActionTypesEnum>>;
};

/** input type for inserting data into table "notification_action_types" */
export type NotificationActionTypesInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type NotificationActionTypesMaxFields = {
  __typename?: 'NotificationActionTypesMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type NotificationActionTypesMinFields = {
  __typename?: 'NotificationActionTypesMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "notification_action_types" */
export type NotificationActionTypesMutationResponse = {
  __typename?: 'NotificationActionTypesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<NotificationActionTypes>;
};

/** on_conflict condition type for table "notification_action_types" */
export type NotificationActionTypesOnConflict = {
  constraint: NotificationActionTypesConstraint;
  updateColumns?: Array<NotificationActionTypesUpdateColumn>;
  where?: InputMaybe<NotificationActionTypesBoolExp>;
};

/** Ordering options when selecting data from "notification_action_types". */
export type NotificationActionTypesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: notification_action_types */
export type NotificationActionTypesPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "notification_action_types" */
export enum NotificationActionTypesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "notification_action_types" */
export type NotificationActionTypesSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "notification_action_types" */
export type NotificationActionTypesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: NotificationActionTypesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type NotificationActionTypesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "notification_action_types" */
export enum NotificationActionTypesUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type NotificationActionTypesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<NotificationActionTypesSetInput>;
  /** filter the rows which have to be updated */
  where: NotificationActionTypesBoolExp;
};

/** columns and relationships of "notification_statuses" */
export type NotificationStatuses = {
  __typename?: 'NotificationStatuses';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "notification_statuses" */
export type NotificationStatusesAggregate = {
  __typename?: 'NotificationStatusesAggregate';
  aggregate?: Maybe<NotificationStatusesAggregateFields>;
  nodes: Array<NotificationStatuses>;
};

/** aggregate fields of "notification_statuses" */
export type NotificationStatusesAggregateFields = {
  __typename?: 'NotificationStatusesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<NotificationStatusesMaxFields>;
  min?: Maybe<NotificationStatusesMinFields>;
};


/** aggregate fields of "notification_statuses" */
export type NotificationStatusesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<NotificationStatusesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "notification_statuses". All fields are combined with a logical 'AND'. */
export type NotificationStatusesBoolExp = {
  _and?: InputMaybe<Array<NotificationStatusesBoolExp>>;
  _not?: InputMaybe<NotificationStatusesBoolExp>;
  _or?: InputMaybe<Array<NotificationStatusesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "notification_statuses" */
export enum NotificationStatusesConstraint {
  /** unique or primary key constraint on columns "value" */
  NotificationStatusesPkey = 'notification_statuses_pkey'
}

export enum NotificationStatusesEnum {
  Read = 'READ',
  Unread = 'UNREAD'
}

/** Boolean expression to compare columns of type "NotificationStatusesEnum". All fields are combined with logical 'AND'. */
export type NotificationStatusesEnumComparisonExp = {
  _eq?: InputMaybe<NotificationStatusesEnum>;
  _in?: InputMaybe<Array<NotificationStatusesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<NotificationStatusesEnum>;
  _nin?: InputMaybe<Array<NotificationStatusesEnum>>;
};

/** input type for inserting data into table "notification_statuses" */
export type NotificationStatusesInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type NotificationStatusesMaxFields = {
  __typename?: 'NotificationStatusesMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type NotificationStatusesMinFields = {
  __typename?: 'NotificationStatusesMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "notification_statuses" */
export type NotificationStatusesMutationResponse = {
  __typename?: 'NotificationStatusesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<NotificationStatuses>;
};

/** on_conflict condition type for table "notification_statuses" */
export type NotificationStatusesOnConflict = {
  constraint: NotificationStatusesConstraint;
  updateColumns?: Array<NotificationStatusesUpdateColumn>;
  where?: InputMaybe<NotificationStatusesBoolExp>;
};

/** Ordering options when selecting data from "notification_statuses". */
export type NotificationStatusesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: notification_statuses */
export type NotificationStatusesPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "notification_statuses" */
export enum NotificationStatusesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "notification_statuses" */
export type NotificationStatusesSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "notification_statuses" */
export type NotificationStatusesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: NotificationStatusesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type NotificationStatusesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "notification_statuses" */
export enum NotificationStatusesUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type NotificationStatusesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<NotificationStatusesSetInput>;
  /** filter the rows which have to be updated */
  where: NotificationStatusesBoolExp;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type NumericComparisonExp = {
  _eq?: InputMaybe<Scalars['numeric']>;
  _gt?: InputMaybe<Scalars['numeric']>;
  _gte?: InputMaybe<Scalars['numeric']>;
  _in?: InputMaybe<Array<Scalars['numeric']>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['numeric']>;
  _lte?: InputMaybe<Scalars['numeric']>;
  _neq?: InputMaybe<Scalars['numeric']>;
  _nin?: InputMaybe<Array<Scalars['numeric']>>;
};

/** column ordering options */
export enum OrderBy {
  /** in ascending order, nulls last */
  Asc = 'ASC',
  /** in ascending order, nulls first */
  AscNullsFirst = 'ASC_NULLS_FIRST',
  /** in ascending order, nulls last */
  AscNullsLast = 'ASC_NULLS_LAST',
  /** in descending order, nulls first */
  Desc = 'DESC',
  /** in descending order, nulls first */
  DescNullsFirst = 'DESC_NULLS_FIRST',
  /** in descending order, nulls last */
  DescNullsLast = 'DESC_NULLS_LAST'
}

/** columns and relationships of "order_statuses" */
export type OrderStatuses = {
  __typename?: 'OrderStatuses';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "order_statuses" */
export type OrderStatusesAggregate = {
  __typename?: 'OrderStatusesAggregate';
  aggregate?: Maybe<OrderStatusesAggregateFields>;
  nodes: Array<OrderStatuses>;
};

/** aggregate fields of "order_statuses" */
export type OrderStatusesAggregateFields = {
  __typename?: 'OrderStatusesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<OrderStatusesMaxFields>;
  min?: Maybe<OrderStatusesMinFields>;
};


/** aggregate fields of "order_statuses" */
export type OrderStatusesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<OrderStatusesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "order_statuses". All fields are combined with a logical 'AND'. */
export type OrderStatusesBoolExp = {
  _and?: InputMaybe<Array<OrderStatusesBoolExp>>;
  _not?: InputMaybe<OrderStatusesBoolExp>;
  _or?: InputMaybe<Array<OrderStatusesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "order_statuses" */
export enum OrderStatusesConstraint {
  /** unique or primary key constraint on columns "value" */
  OrderStatusesPkey = 'order_statuses_pkey'
}

export enum OrderStatusesEnum {
  Canceled = 'CANCELED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Refunded = 'REFUNDED',
  Succeeded = 'SUCCEEDED'
}

/** Boolean expression to compare columns of type "OrderStatusesEnum". All fields are combined with logical 'AND'. */
export type OrderStatusesEnumComparisonExp = {
  _eq?: InputMaybe<OrderStatusesEnum>;
  _in?: InputMaybe<Array<OrderStatusesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<OrderStatusesEnum>;
  _nin?: InputMaybe<Array<OrderStatusesEnum>>;
};

/** input type for inserting data into table "order_statuses" */
export type OrderStatusesInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type OrderStatusesMaxFields = {
  __typename?: 'OrderStatusesMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type OrderStatusesMinFields = {
  __typename?: 'OrderStatusesMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "order_statuses" */
export type OrderStatusesMutationResponse = {
  __typename?: 'OrderStatusesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<OrderStatuses>;
};

/** on_conflict condition type for table "order_statuses" */
export type OrderStatusesOnConflict = {
  constraint: OrderStatusesConstraint;
  updateColumns?: Array<OrderStatusesUpdateColumn>;
  where?: InputMaybe<OrderStatusesBoolExp>;
};

/** Ordering options when selecting data from "order_statuses". */
export type OrderStatusesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: order_statuses */
export type OrderStatusesPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "order_statuses" */
export enum OrderStatusesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "order_statuses" */
export type OrderStatusesSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "order_statuses" */
export type OrderStatusesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: OrderStatusesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type OrderStatusesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "order_statuses" */
export enum OrderStatusesUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type OrderStatusesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<OrderStatusesSetInput>;
  /** filter the rows which have to be updated */
  where: OrderStatusesBoolExp;
};

/** columns and relationships of "padel_rating_scales" */
export type PadelRatingScales = {
  __typename?: 'PadelRatingScales';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  maximum: Scalars['numeric'];
  minimum: Scalars['numeric'];
  name: Scalars['String'];
  order: Scalars['Int'];
  shortName: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "padel_rating_scales" */
export type PadelRatingScalesAggregate = {
  __typename?: 'PadelRatingScalesAggregate';
  aggregate?: Maybe<PadelRatingScalesAggregateFields>;
  nodes: Array<PadelRatingScales>;
};

/** aggregate fields of "padel_rating_scales" */
export type PadelRatingScalesAggregateFields = {
  __typename?: 'PadelRatingScalesAggregateFields';
  avg?: Maybe<PadelRatingScalesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<PadelRatingScalesMaxFields>;
  min?: Maybe<PadelRatingScalesMinFields>;
  stddev?: Maybe<PadelRatingScalesStddevFields>;
  stddevPop?: Maybe<PadelRatingScalesStddevPopFields>;
  stddevSamp?: Maybe<PadelRatingScalesStddevSampFields>;
  sum?: Maybe<PadelRatingScalesSumFields>;
  varPop?: Maybe<PadelRatingScalesVarPopFields>;
  varSamp?: Maybe<PadelRatingScalesVarSampFields>;
  variance?: Maybe<PadelRatingScalesVarianceFields>;
};


/** aggregate fields of "padel_rating_scales" */
export type PadelRatingScalesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PadelRatingScalesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type PadelRatingScalesAvgFields = {
  __typename?: 'PadelRatingScalesAvgFields';
  maximum?: Maybe<Scalars['Float']>;
  minimum?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "padel_rating_scales". All fields are combined with a logical 'AND'. */
export type PadelRatingScalesBoolExp = {
  _and?: InputMaybe<Array<PadelRatingScalesBoolExp>>;
  _not?: InputMaybe<PadelRatingScalesBoolExp>;
  _or?: InputMaybe<Array<PadelRatingScalesBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  maximum?: InputMaybe<NumericComparisonExp>;
  minimum?: InputMaybe<NumericComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  order?: InputMaybe<IntComparisonExp>;
  shortName?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "padel_rating_scales" */
export enum PadelRatingScalesConstraint {
  /** unique or primary key constraint on columns "id" */
  PadelRatingScalesPkey = 'padel_rating_scales_pkey'
}

/** input type for incrementing numeric columns in table "padel_rating_scales" */
export type PadelRatingScalesIncInput = {
  maximum?: InputMaybe<Scalars['numeric']>;
  minimum?: InputMaybe<Scalars['numeric']>;
  order?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "padel_rating_scales" */
export type PadelRatingScalesInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  maximum?: InputMaybe<Scalars['numeric']>;
  minimum?: InputMaybe<Scalars['numeric']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  shortName?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type PadelRatingScalesMaxFields = {
  __typename?: 'PadelRatingScalesMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  maximum?: Maybe<Scalars['numeric']>;
  minimum?: Maybe<Scalars['numeric']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  shortName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type PadelRatingScalesMinFields = {
  __typename?: 'PadelRatingScalesMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  maximum?: Maybe<Scalars['numeric']>;
  minimum?: Maybe<Scalars['numeric']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  shortName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "padel_rating_scales" */
export type PadelRatingScalesMutationResponse = {
  __typename?: 'PadelRatingScalesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PadelRatingScales>;
};

/** input type for inserting object relation for remote table "padel_rating_scales" */
export type PadelRatingScalesObjRelInsertInput = {
  data: PadelRatingScalesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<PadelRatingScalesOnConflict>;
};

/** on_conflict condition type for table "padel_rating_scales" */
export type PadelRatingScalesOnConflict = {
  constraint: PadelRatingScalesConstraint;
  updateColumns?: Array<PadelRatingScalesUpdateColumn>;
  where?: InputMaybe<PadelRatingScalesBoolExp>;
};

/** Ordering options when selecting data from "padel_rating_scales". */
export type PadelRatingScalesOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  maximum?: InputMaybe<OrderBy>;
  minimum?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  order?: InputMaybe<OrderBy>;
  shortName?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: padel_rating_scales */
export type PadelRatingScalesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "padel_rating_scales" */
export enum PadelRatingScalesSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  Maximum = 'maximum',
  /** column name */
  Minimum = 'minimum',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  ShortName = 'shortName',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "padel_rating_scales" */
export type PadelRatingScalesSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  maximum?: InputMaybe<Scalars['numeric']>;
  minimum?: InputMaybe<Scalars['numeric']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  shortName?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type PadelRatingScalesStddevFields = {
  __typename?: 'PadelRatingScalesStddevFields';
  maximum?: Maybe<Scalars['Float']>;
  minimum?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type PadelRatingScalesStddevPopFields = {
  __typename?: 'PadelRatingScalesStddevPopFields';
  maximum?: Maybe<Scalars['Float']>;
  minimum?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type PadelRatingScalesStddevSampFields = {
  __typename?: 'PadelRatingScalesStddevSampFields';
  maximum?: Maybe<Scalars['Float']>;
  minimum?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "padel_rating_scales" */
export type PadelRatingScalesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PadelRatingScalesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PadelRatingScalesStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  maximum?: InputMaybe<Scalars['numeric']>;
  minimum?: InputMaybe<Scalars['numeric']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  shortName?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type PadelRatingScalesSumFields = {
  __typename?: 'PadelRatingScalesSumFields';
  maximum?: Maybe<Scalars['numeric']>;
  minimum?: Maybe<Scalars['numeric']>;
  order?: Maybe<Scalars['Int']>;
};

/** update columns of table "padel_rating_scales" */
export enum PadelRatingScalesUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  Maximum = 'maximum',
  /** column name */
  Minimum = 'minimum',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  ShortName = 'shortName',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type PadelRatingScalesUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<PadelRatingScalesIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PadelRatingScalesSetInput>;
  /** filter the rows which have to be updated */
  where: PadelRatingScalesBoolExp;
};

/** aggregate varPop on columns */
export type PadelRatingScalesVarPopFields = {
  __typename?: 'PadelRatingScalesVarPopFields';
  maximum?: Maybe<Scalars['Float']>;
  minimum?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type PadelRatingScalesVarSampFields = {
  __typename?: 'PadelRatingScalesVarSampFields';
  maximum?: Maybe<Scalars['Float']>;
  minimum?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type PadelRatingScalesVarianceFields = {
  __typename?: 'PadelRatingScalesVarianceFields';
  maximum?: Maybe<Scalars['Float']>;
  minimum?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "participant_roles" */
export type ParticipantRoles = {
  __typename?: 'ParticipantRoles';
  comment?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "participant_roles" */
export type ParticipantRolesAggregate = {
  __typename?: 'ParticipantRolesAggregate';
  aggregate?: Maybe<ParticipantRolesAggregateFields>;
  nodes: Array<ParticipantRoles>;
};

/** aggregate fields of "participant_roles" */
export type ParticipantRolesAggregateFields = {
  __typename?: 'ParticipantRolesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<ParticipantRolesMaxFields>;
  min?: Maybe<ParticipantRolesMinFields>;
};


/** aggregate fields of "participant_roles" */
export type ParticipantRolesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ParticipantRolesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "participant_roles". All fields are combined with a logical 'AND'. */
export type ParticipantRolesBoolExp = {
  _and?: InputMaybe<Array<ParticipantRolesBoolExp>>;
  _not?: InputMaybe<ParticipantRolesBoolExp>;
  _or?: InputMaybe<Array<ParticipantRolesBoolExp>>;
  comment?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "participant_roles" */
export enum ParticipantRolesConstraint {
  /** unique or primary key constraint on columns "value" */
  ParticipantRolesPkey = 'participant_roles_pkey'
}

export enum ParticipantRolesEnum {
  /** can manage the group */
  Admin = 'ADMIN',
  /** standard participant */
  Member = 'MEMBER'
}

/** Boolean expression to compare columns of type "ParticipantRolesEnum". All fields are combined with logical 'AND'. */
export type ParticipantRolesEnumComparisonExp = {
  _eq?: InputMaybe<ParticipantRolesEnum>;
  _in?: InputMaybe<Array<ParticipantRolesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<ParticipantRolesEnum>;
  _nin?: InputMaybe<Array<ParticipantRolesEnum>>;
};

/** input type for inserting data into table "participant_roles" */
export type ParticipantRolesInsertInput = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ParticipantRolesMaxFields = {
  __typename?: 'ParticipantRolesMaxFields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type ParticipantRolesMinFields = {
  __typename?: 'ParticipantRolesMinFields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "participant_roles" */
export type ParticipantRolesMutationResponse = {
  __typename?: 'ParticipantRolesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ParticipantRoles>;
};

/** on_conflict condition type for table "participant_roles" */
export type ParticipantRolesOnConflict = {
  constraint: ParticipantRolesConstraint;
  updateColumns?: Array<ParticipantRolesUpdateColumn>;
  where?: InputMaybe<ParticipantRolesBoolExp>;
};

/** Ordering options when selecting data from "participant_roles". */
export type ParticipantRolesOrderBy = {
  comment?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: participant_roles */
export type ParticipantRolesPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "participant_roles" */
export enum ParticipantRolesSelectColumn {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "participant_roles" */
export type ParticipantRolesSetInput = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "participant_roles" */
export type ParticipantRolesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ParticipantRolesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ParticipantRolesStreamCursorValueInput = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "participant_roles" */
export enum ParticipantRolesUpdateColumn {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type ParticipantRolesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ParticipantRolesSetInput>;
  /** filter the rows which have to be updated */
  where: ParticipantRolesBoolExp;
};

/** columns and relationships of "partner_booking_attempt_events" */
export type PartnerBookingAttemptEvents = {
  __typename?: 'PartnerBookingAttemptEvents';
  /** An object relationship */
  attempt: PartnerBookingAttempts;
  attemptId: Scalars['uuid'];
  body: Scalars['jsonb'];
  createdAt: Scalars['timestamptz'];
  event: Scalars['String'];
  id: Scalars['uuid'];
  source: PartnerBookingEventSourcesEnum;
};


/** columns and relationships of "partner_booking_attempt_events" */
export type PartnerBookingAttemptEventsBodyArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "partner_booking_attempt_events" */
export type PartnerBookingAttemptEventsAggregate = {
  __typename?: 'PartnerBookingAttemptEventsAggregate';
  aggregate?: Maybe<PartnerBookingAttemptEventsAggregateFields>;
  nodes: Array<PartnerBookingAttemptEvents>;
};

export type PartnerBookingAttemptEventsAggregateBoolExp = {
  count?: InputMaybe<PartnerBookingAttemptEventsAggregateBoolExpCount>;
};

/** aggregate fields of "partner_booking_attempt_events" */
export type PartnerBookingAttemptEventsAggregateFields = {
  __typename?: 'PartnerBookingAttemptEventsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<PartnerBookingAttemptEventsMaxFields>;
  min?: Maybe<PartnerBookingAttemptEventsMinFields>;
};


/** aggregate fields of "partner_booking_attempt_events" */
export type PartnerBookingAttemptEventsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PartnerBookingAttemptEventsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "partner_booking_attempt_events" */
export type PartnerBookingAttemptEventsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<PartnerBookingAttemptEventsMaxOrderBy>;
  min?: InputMaybe<PartnerBookingAttemptEventsMinOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type PartnerBookingAttemptEventsAppendInput = {
  body?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "partner_booking_attempt_events" */
export type PartnerBookingAttemptEventsArrRelInsertInput = {
  data: Array<PartnerBookingAttemptEventsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<PartnerBookingAttemptEventsOnConflict>;
};

/** Boolean expression to filter rows from the table "partner_booking_attempt_events". All fields are combined with a logical 'AND'. */
export type PartnerBookingAttemptEventsBoolExp = {
  _and?: InputMaybe<Array<PartnerBookingAttemptEventsBoolExp>>;
  _not?: InputMaybe<PartnerBookingAttemptEventsBoolExp>;
  _or?: InputMaybe<Array<PartnerBookingAttemptEventsBoolExp>>;
  attempt?: InputMaybe<PartnerBookingAttemptsBoolExp>;
  attemptId?: InputMaybe<UuidComparisonExp>;
  body?: InputMaybe<JsonbComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  event?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  source?: InputMaybe<PartnerBookingEventSourcesEnumComparisonExp>;
};

/** unique or primary key constraints on table "partner_booking_attempt_events" */
export enum PartnerBookingAttemptEventsConstraint {
  /** unique or primary key constraint on columns "id" */
  PartnerBookingAttemptEventsPkey = 'partner_booking_attempt_events_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type PartnerBookingAttemptEventsDeleteAtPathInput = {
  body?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type PartnerBookingAttemptEventsDeleteElemInput = {
  body?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type PartnerBookingAttemptEventsDeleteKeyInput = {
  body?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "partner_booking_attempt_events" */
export type PartnerBookingAttemptEventsInsertInput = {
  attempt?: InputMaybe<PartnerBookingAttemptsObjRelInsertInput>;
  attemptId?: InputMaybe<Scalars['uuid']>;
  body?: InputMaybe<Scalars['jsonb']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  event?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  source?: InputMaybe<PartnerBookingEventSourcesEnum>;
};

/** aggregate max on columns */
export type PartnerBookingAttemptEventsMaxFields = {
  __typename?: 'PartnerBookingAttemptEventsMaxFields';
  attemptId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  event?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "partner_booking_attempt_events" */
export type PartnerBookingAttemptEventsMaxOrderBy = {
  attemptId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  event?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type PartnerBookingAttemptEventsMinFields = {
  __typename?: 'PartnerBookingAttemptEventsMinFields';
  attemptId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  event?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "partner_booking_attempt_events" */
export type PartnerBookingAttemptEventsMinOrderBy = {
  attemptId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  event?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "partner_booking_attempt_events" */
export type PartnerBookingAttemptEventsMutationResponse = {
  __typename?: 'PartnerBookingAttemptEventsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PartnerBookingAttemptEvents>;
};

/** on_conflict condition type for table "partner_booking_attempt_events" */
export type PartnerBookingAttemptEventsOnConflict = {
  constraint: PartnerBookingAttemptEventsConstraint;
  updateColumns?: Array<PartnerBookingAttemptEventsUpdateColumn>;
  where?: InputMaybe<PartnerBookingAttemptEventsBoolExp>;
};

/** Ordering options when selecting data from "partner_booking_attempt_events". */
export type PartnerBookingAttemptEventsOrderBy = {
  attempt?: InputMaybe<PartnerBookingAttemptsOrderBy>;
  attemptId?: InputMaybe<OrderBy>;
  body?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  event?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  source?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: partner_booking_attempt_events */
export type PartnerBookingAttemptEventsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type PartnerBookingAttemptEventsPrependInput = {
  body?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "partner_booking_attempt_events" */
export enum PartnerBookingAttemptEventsSelectColumn {
  /** column name */
  AttemptId = 'attemptId',
  /** column name */
  Body = 'body',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Event = 'event',
  /** column name */
  Id = 'id',
  /** column name */
  Source = 'source'
}

/** input type for updating data in table "partner_booking_attempt_events" */
export type PartnerBookingAttemptEventsSetInput = {
  attemptId?: InputMaybe<Scalars['uuid']>;
  body?: InputMaybe<Scalars['jsonb']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  event?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  source?: InputMaybe<PartnerBookingEventSourcesEnum>;
};

/** Streaming cursor of the table "partner_booking_attempt_events" */
export type PartnerBookingAttemptEventsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PartnerBookingAttemptEventsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PartnerBookingAttemptEventsStreamCursorValueInput = {
  attemptId?: InputMaybe<Scalars['uuid']>;
  body?: InputMaybe<Scalars['jsonb']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  event?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  source?: InputMaybe<PartnerBookingEventSourcesEnum>;
};

/** update columns of table "partner_booking_attempt_events" */
export enum PartnerBookingAttemptEventsUpdateColumn {
  /** column name */
  AttemptId = 'attemptId',
  /** column name */
  Body = 'body',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Event = 'event',
  /** column name */
  Id = 'id',
  /** column name */
  Source = 'source'
}

export type PartnerBookingAttemptEventsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<PartnerBookingAttemptEventsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _deleteAtPath?: InputMaybe<PartnerBookingAttemptEventsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _deleteElem?: InputMaybe<PartnerBookingAttemptEventsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _deleteKey?: InputMaybe<PartnerBookingAttemptEventsDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<PartnerBookingAttemptEventsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PartnerBookingAttemptEventsSetInput>;
  /** filter the rows which have to be updated */
  where: PartnerBookingAttemptEventsBoolExp;
};

/** columns and relationships of "partner_booking_attempt_statuses" */
export type PartnerBookingAttemptStatuses = {
  __typename?: 'PartnerBookingAttemptStatuses';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "partner_booking_attempt_statuses" */
export type PartnerBookingAttemptStatusesAggregate = {
  __typename?: 'PartnerBookingAttemptStatusesAggregate';
  aggregate?: Maybe<PartnerBookingAttemptStatusesAggregateFields>;
  nodes: Array<PartnerBookingAttemptStatuses>;
};

/** aggregate fields of "partner_booking_attempt_statuses" */
export type PartnerBookingAttemptStatusesAggregateFields = {
  __typename?: 'PartnerBookingAttemptStatusesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<PartnerBookingAttemptStatusesMaxFields>;
  min?: Maybe<PartnerBookingAttemptStatusesMinFields>;
};


/** aggregate fields of "partner_booking_attempt_statuses" */
export type PartnerBookingAttemptStatusesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PartnerBookingAttemptStatusesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "partner_booking_attempt_statuses". All fields are combined with a logical 'AND'. */
export type PartnerBookingAttemptStatusesBoolExp = {
  _and?: InputMaybe<Array<PartnerBookingAttemptStatusesBoolExp>>;
  _not?: InputMaybe<PartnerBookingAttemptStatusesBoolExp>;
  _or?: InputMaybe<Array<PartnerBookingAttemptStatusesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "partner_booking_attempt_statuses" */
export enum PartnerBookingAttemptStatusesConstraint {
  /** unique or primary key constraint on columns "value" */
  PartnerBookingAttemptStatusesPkey = 'partner_booking_attempt_statuses_pkey'
}

export enum PartnerBookingAttemptStatusesEnum {
  /** Accepted by the engine */
  Dispatched = 'DISPATCHED',
  /** Nothing was booked */
  Failed = 'FAILED',
  /** A booking exists but differs from the order */
  Mismatch = 'MISMATCH',
  /** Created, not yet sent to the engine */
  Queued = 'QUEUED',
  /** Booking found and matches the order */
  Succeeded = 'SUCCEEDED',
  /** No verifiable outcome after the final check */
  Unknown = 'UNKNOWN',
  /** Engine reported a result; checking it on the club's system */
  Verifying = 'VERIFYING'
}

/** Boolean expression to compare columns of type "PartnerBookingAttemptStatusesEnum". All fields are combined with logical 'AND'. */
export type PartnerBookingAttemptStatusesEnumComparisonExp = {
  _eq?: InputMaybe<PartnerBookingAttemptStatusesEnum>;
  _in?: InputMaybe<Array<PartnerBookingAttemptStatusesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<PartnerBookingAttemptStatusesEnum>;
  _nin?: InputMaybe<Array<PartnerBookingAttemptStatusesEnum>>;
};

/** input type for inserting data into table "partner_booking_attempt_statuses" */
export type PartnerBookingAttemptStatusesInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type PartnerBookingAttemptStatusesMaxFields = {
  __typename?: 'PartnerBookingAttemptStatusesMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type PartnerBookingAttemptStatusesMinFields = {
  __typename?: 'PartnerBookingAttemptStatusesMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "partner_booking_attempt_statuses" */
export type PartnerBookingAttemptStatusesMutationResponse = {
  __typename?: 'PartnerBookingAttemptStatusesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PartnerBookingAttemptStatuses>;
};

/** on_conflict condition type for table "partner_booking_attempt_statuses" */
export type PartnerBookingAttemptStatusesOnConflict = {
  constraint: PartnerBookingAttemptStatusesConstraint;
  updateColumns?: Array<PartnerBookingAttemptStatusesUpdateColumn>;
  where?: InputMaybe<PartnerBookingAttemptStatusesBoolExp>;
};

/** Ordering options when selecting data from "partner_booking_attempt_statuses". */
export type PartnerBookingAttemptStatusesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: partner_booking_attempt_statuses */
export type PartnerBookingAttemptStatusesPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "partner_booking_attempt_statuses" */
export enum PartnerBookingAttemptStatusesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "partner_booking_attempt_statuses" */
export type PartnerBookingAttemptStatusesSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "partner_booking_attempt_statuses" */
export type PartnerBookingAttemptStatusesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PartnerBookingAttemptStatusesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PartnerBookingAttemptStatusesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "partner_booking_attempt_statuses" */
export enum PartnerBookingAttemptStatusesUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type PartnerBookingAttemptStatusesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PartnerBookingAttemptStatusesSetInput>;
  /** filter the rows which have to be updated */
  where: PartnerBookingAttemptStatusesBoolExp;
};

/** columns and relationships of "partner_booking_attempts" */
export type PartnerBookingAttempts = {
  __typename?: 'PartnerBookingAttempts';
  claim?: Maybe<Scalars['jsonb']>;
  confirmationNumber?: Maybe<Scalars['String']>;
  createdAt: Scalars['timestamptz'];
  deadlineAt?: Maybe<Scalars['timestamptz']>;
  dispatchedAt?: Maybe<Scalars['timestamptz']>;
  engine: PartnerBookingEnginesEnum;
  /** An array relationship */
  events: Array<PartnerBookingAttemptEvents>;
  /** An aggregate relationship */
  eventsAggregate: PartnerBookingAttemptEventsAggregate;
  id: Scalars['uuid'];
  /** An object relationship */
  order: PartnerBookingOrders;
  orderId: Scalars['uuid'];
  runId?: Maybe<Scalars['String']>;
  status: PartnerBookingAttemptStatusesEnum;
  updatedAt: Scalars['timestamptz'];
  verificationMethod?: Maybe<PartnerBookingVerificationMethodsEnum>;
  verifiedAt?: Maybe<Scalars['timestamptz']>;
  worker?: Maybe<Scalars['String']>;
};


/** columns and relationships of "partner_booking_attempts" */
export type PartnerBookingAttemptsClaimArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "partner_booking_attempts" */
export type PartnerBookingAttemptsEventsArgs = {
  distinctOn?: InputMaybe<Array<PartnerBookingAttemptEventsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PartnerBookingAttemptEventsOrderBy>>;
  where?: InputMaybe<PartnerBookingAttemptEventsBoolExp>;
};


/** columns and relationships of "partner_booking_attempts" */
export type PartnerBookingAttemptsEventsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PartnerBookingAttemptEventsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PartnerBookingAttemptEventsOrderBy>>;
  where?: InputMaybe<PartnerBookingAttemptEventsBoolExp>;
};

/** aggregated selection of "partner_booking_attempts" */
export type PartnerBookingAttemptsAggregate = {
  __typename?: 'PartnerBookingAttemptsAggregate';
  aggregate?: Maybe<PartnerBookingAttemptsAggregateFields>;
  nodes: Array<PartnerBookingAttempts>;
};

export type PartnerBookingAttemptsAggregateBoolExp = {
  count?: InputMaybe<PartnerBookingAttemptsAggregateBoolExpCount>;
};

/** aggregate fields of "partner_booking_attempts" */
export type PartnerBookingAttemptsAggregateFields = {
  __typename?: 'PartnerBookingAttemptsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<PartnerBookingAttemptsMaxFields>;
  min?: Maybe<PartnerBookingAttemptsMinFields>;
};


/** aggregate fields of "partner_booking_attempts" */
export type PartnerBookingAttemptsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PartnerBookingAttemptsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "partner_booking_attempts" */
export type PartnerBookingAttemptsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<PartnerBookingAttemptsMaxOrderBy>;
  min?: InputMaybe<PartnerBookingAttemptsMinOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type PartnerBookingAttemptsAppendInput = {
  claim?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "partner_booking_attempts" */
export type PartnerBookingAttemptsArrRelInsertInput = {
  data: Array<PartnerBookingAttemptsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<PartnerBookingAttemptsOnConflict>;
};

/** Boolean expression to filter rows from the table "partner_booking_attempts". All fields are combined with a logical 'AND'. */
export type PartnerBookingAttemptsBoolExp = {
  _and?: InputMaybe<Array<PartnerBookingAttemptsBoolExp>>;
  _not?: InputMaybe<PartnerBookingAttemptsBoolExp>;
  _or?: InputMaybe<Array<PartnerBookingAttemptsBoolExp>>;
  claim?: InputMaybe<JsonbComparisonExp>;
  confirmationNumber?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deadlineAt?: InputMaybe<TimestamptzComparisonExp>;
  dispatchedAt?: InputMaybe<TimestamptzComparisonExp>;
  engine?: InputMaybe<PartnerBookingEnginesEnumComparisonExp>;
  events?: InputMaybe<PartnerBookingAttemptEventsBoolExp>;
  eventsAggregate?: InputMaybe<PartnerBookingAttemptEventsAggregateBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  order?: InputMaybe<PartnerBookingOrdersBoolExp>;
  orderId?: InputMaybe<UuidComparisonExp>;
  runId?: InputMaybe<StringComparisonExp>;
  status?: InputMaybe<PartnerBookingAttemptStatusesEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  verificationMethod?: InputMaybe<PartnerBookingVerificationMethodsEnumComparisonExp>;
  verifiedAt?: InputMaybe<TimestamptzComparisonExp>;
  worker?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "partner_booking_attempts" */
export enum PartnerBookingAttemptsConstraint {
  /** unique or primary key constraint on columns "order_id" */
  PartnerBookingAttemptsOneLivePerOrder = 'partner_booking_attempts_one_live_per_order',
  /** unique or primary key constraint on columns "id" */
  PartnerBookingAttemptsPkey = 'partner_booking_attempts_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type PartnerBookingAttemptsDeleteAtPathInput = {
  claim?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type PartnerBookingAttemptsDeleteElemInput = {
  claim?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type PartnerBookingAttemptsDeleteKeyInput = {
  claim?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "partner_booking_attempts" */
export type PartnerBookingAttemptsInsertInput = {
  claim?: InputMaybe<Scalars['jsonb']>;
  confirmationNumber?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deadlineAt?: InputMaybe<Scalars['timestamptz']>;
  dispatchedAt?: InputMaybe<Scalars['timestamptz']>;
  engine?: InputMaybe<PartnerBookingEnginesEnum>;
  events?: InputMaybe<PartnerBookingAttemptEventsArrRelInsertInput>;
  id?: InputMaybe<Scalars['uuid']>;
  order?: InputMaybe<PartnerBookingOrdersObjRelInsertInput>;
  orderId?: InputMaybe<Scalars['uuid']>;
  runId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<PartnerBookingAttemptStatusesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  verificationMethod?: InputMaybe<PartnerBookingVerificationMethodsEnum>;
  verifiedAt?: InputMaybe<Scalars['timestamptz']>;
  worker?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type PartnerBookingAttemptsMaxFields = {
  __typename?: 'PartnerBookingAttemptsMaxFields';
  confirmationNumber?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deadlineAt?: Maybe<Scalars['timestamptz']>;
  dispatchedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  orderId?: Maybe<Scalars['uuid']>;
  runId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  verifiedAt?: Maybe<Scalars['timestamptz']>;
  worker?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "partner_booking_attempts" */
export type PartnerBookingAttemptsMaxOrderBy = {
  confirmationNumber?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deadlineAt?: InputMaybe<OrderBy>;
  dispatchedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  orderId?: InputMaybe<OrderBy>;
  runId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  verifiedAt?: InputMaybe<OrderBy>;
  worker?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type PartnerBookingAttemptsMinFields = {
  __typename?: 'PartnerBookingAttemptsMinFields';
  confirmationNumber?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deadlineAt?: Maybe<Scalars['timestamptz']>;
  dispatchedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  orderId?: Maybe<Scalars['uuid']>;
  runId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  verifiedAt?: Maybe<Scalars['timestamptz']>;
  worker?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "partner_booking_attempts" */
export type PartnerBookingAttemptsMinOrderBy = {
  confirmationNumber?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deadlineAt?: InputMaybe<OrderBy>;
  dispatchedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  orderId?: InputMaybe<OrderBy>;
  runId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  verifiedAt?: InputMaybe<OrderBy>;
  worker?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "partner_booking_attempts" */
export type PartnerBookingAttemptsMutationResponse = {
  __typename?: 'PartnerBookingAttemptsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PartnerBookingAttempts>;
};

/** input type for inserting object relation for remote table "partner_booking_attempts" */
export type PartnerBookingAttemptsObjRelInsertInput = {
  data: PartnerBookingAttemptsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<PartnerBookingAttemptsOnConflict>;
};

/** on_conflict condition type for table "partner_booking_attempts" */
export type PartnerBookingAttemptsOnConflict = {
  constraint: PartnerBookingAttemptsConstraint;
  updateColumns?: Array<PartnerBookingAttemptsUpdateColumn>;
  where?: InputMaybe<PartnerBookingAttemptsBoolExp>;
};

/** Ordering options when selecting data from "partner_booking_attempts". */
export type PartnerBookingAttemptsOrderBy = {
  claim?: InputMaybe<OrderBy>;
  confirmationNumber?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deadlineAt?: InputMaybe<OrderBy>;
  dispatchedAt?: InputMaybe<OrderBy>;
  engine?: InputMaybe<OrderBy>;
  eventsAggregate?: InputMaybe<PartnerBookingAttemptEventsAggregateOrderBy>;
  id?: InputMaybe<OrderBy>;
  order?: InputMaybe<PartnerBookingOrdersOrderBy>;
  orderId?: InputMaybe<OrderBy>;
  runId?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  verificationMethod?: InputMaybe<OrderBy>;
  verifiedAt?: InputMaybe<OrderBy>;
  worker?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: partner_booking_attempts */
export type PartnerBookingAttemptsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type PartnerBookingAttemptsPrependInput = {
  claim?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "partner_booking_attempts" */
export enum PartnerBookingAttemptsSelectColumn {
  /** column name */
  Claim = 'claim',
  /** column name */
  ConfirmationNumber = 'confirmationNumber',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeadlineAt = 'deadlineAt',
  /** column name */
  DispatchedAt = 'dispatchedAt',
  /** column name */
  Engine = 'engine',
  /** column name */
  Id = 'id',
  /** column name */
  OrderId = 'orderId',
  /** column name */
  RunId = 'runId',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  VerificationMethod = 'verificationMethod',
  /** column name */
  VerifiedAt = 'verifiedAt',
  /** column name */
  Worker = 'worker'
}

/** input type for updating data in table "partner_booking_attempts" */
export type PartnerBookingAttemptsSetInput = {
  claim?: InputMaybe<Scalars['jsonb']>;
  confirmationNumber?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deadlineAt?: InputMaybe<Scalars['timestamptz']>;
  dispatchedAt?: InputMaybe<Scalars['timestamptz']>;
  engine?: InputMaybe<PartnerBookingEnginesEnum>;
  id?: InputMaybe<Scalars['uuid']>;
  orderId?: InputMaybe<Scalars['uuid']>;
  runId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<PartnerBookingAttemptStatusesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  verificationMethod?: InputMaybe<PartnerBookingVerificationMethodsEnum>;
  verifiedAt?: InputMaybe<Scalars['timestamptz']>;
  worker?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "partner_booking_attempts" */
export type PartnerBookingAttemptsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PartnerBookingAttemptsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PartnerBookingAttemptsStreamCursorValueInput = {
  claim?: InputMaybe<Scalars['jsonb']>;
  confirmationNumber?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deadlineAt?: InputMaybe<Scalars['timestamptz']>;
  dispatchedAt?: InputMaybe<Scalars['timestamptz']>;
  engine?: InputMaybe<PartnerBookingEnginesEnum>;
  id?: InputMaybe<Scalars['uuid']>;
  orderId?: InputMaybe<Scalars['uuid']>;
  runId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<PartnerBookingAttemptStatusesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  verificationMethod?: InputMaybe<PartnerBookingVerificationMethodsEnum>;
  verifiedAt?: InputMaybe<Scalars['timestamptz']>;
  worker?: InputMaybe<Scalars['String']>;
};

/** update columns of table "partner_booking_attempts" */
export enum PartnerBookingAttemptsUpdateColumn {
  /** column name */
  Claim = 'claim',
  /** column name */
  ConfirmationNumber = 'confirmationNumber',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeadlineAt = 'deadlineAt',
  /** column name */
  DispatchedAt = 'dispatchedAt',
  /** column name */
  Engine = 'engine',
  /** column name */
  Id = 'id',
  /** column name */
  OrderId = 'orderId',
  /** column name */
  RunId = 'runId',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  VerificationMethod = 'verificationMethod',
  /** column name */
  VerifiedAt = 'verifiedAt',
  /** column name */
  Worker = 'worker'
}

export type PartnerBookingAttemptsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<PartnerBookingAttemptsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _deleteAtPath?: InputMaybe<PartnerBookingAttemptsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _deleteElem?: InputMaybe<PartnerBookingAttemptsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _deleteKey?: InputMaybe<PartnerBookingAttemptsDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<PartnerBookingAttemptsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PartnerBookingAttemptsSetInput>;
  /** filter the rows which have to be updated */
  where: PartnerBookingAttemptsBoolExp;
};

/** columns and relationships of "partner_booking_engines" */
export type PartnerBookingEngines = {
  __typename?: 'PartnerBookingEngines';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "partner_booking_engines" */
export type PartnerBookingEnginesAggregate = {
  __typename?: 'PartnerBookingEnginesAggregate';
  aggregate?: Maybe<PartnerBookingEnginesAggregateFields>;
  nodes: Array<PartnerBookingEngines>;
};

/** aggregate fields of "partner_booking_engines" */
export type PartnerBookingEnginesAggregateFields = {
  __typename?: 'PartnerBookingEnginesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<PartnerBookingEnginesMaxFields>;
  min?: Maybe<PartnerBookingEnginesMinFields>;
};


/** aggregate fields of "partner_booking_engines" */
export type PartnerBookingEnginesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PartnerBookingEnginesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "partner_booking_engines". All fields are combined with a logical 'AND'. */
export type PartnerBookingEnginesBoolExp = {
  _and?: InputMaybe<Array<PartnerBookingEnginesBoolExp>>;
  _not?: InputMaybe<PartnerBookingEnginesBoolExp>;
  _or?: InputMaybe<Array<PartnerBookingEnginesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "partner_booking_engines" */
export enum PartnerBookingEnginesConstraint {
  /** unique or primary key constraint on columns "value" */
  PartnerBookingEnginesPkey = 'partner_booking_engines_pkey'
}

export enum PartnerBookingEnginesEnum {
  /** Grok Bot routine (dispatcher + workers) */
  GrokBot = 'GROK_BOT'
}

/** Boolean expression to compare columns of type "PartnerBookingEnginesEnum". All fields are combined with logical 'AND'. */
export type PartnerBookingEnginesEnumComparisonExp = {
  _eq?: InputMaybe<PartnerBookingEnginesEnum>;
  _in?: InputMaybe<Array<PartnerBookingEnginesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<PartnerBookingEnginesEnum>;
  _nin?: InputMaybe<Array<PartnerBookingEnginesEnum>>;
};

/** input type for inserting data into table "partner_booking_engines" */
export type PartnerBookingEnginesInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type PartnerBookingEnginesMaxFields = {
  __typename?: 'PartnerBookingEnginesMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type PartnerBookingEnginesMinFields = {
  __typename?: 'PartnerBookingEnginesMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "partner_booking_engines" */
export type PartnerBookingEnginesMutationResponse = {
  __typename?: 'PartnerBookingEnginesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PartnerBookingEngines>;
};

/** on_conflict condition type for table "partner_booking_engines" */
export type PartnerBookingEnginesOnConflict = {
  constraint: PartnerBookingEnginesConstraint;
  updateColumns?: Array<PartnerBookingEnginesUpdateColumn>;
  where?: InputMaybe<PartnerBookingEnginesBoolExp>;
};

/** Ordering options when selecting data from "partner_booking_engines". */
export type PartnerBookingEnginesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: partner_booking_engines */
export type PartnerBookingEnginesPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "partner_booking_engines" */
export enum PartnerBookingEnginesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "partner_booking_engines" */
export type PartnerBookingEnginesSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "partner_booking_engines" */
export type PartnerBookingEnginesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PartnerBookingEnginesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PartnerBookingEnginesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "partner_booking_engines" */
export enum PartnerBookingEnginesUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type PartnerBookingEnginesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PartnerBookingEnginesSetInput>;
  /** filter the rows which have to be updated */
  where: PartnerBookingEnginesBoolExp;
};

/** columns and relationships of "partner_booking_event_sources" */
export type PartnerBookingEventSources = {
  __typename?: 'PartnerBookingEventSources';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "partner_booking_event_sources" */
export type PartnerBookingEventSourcesAggregate = {
  __typename?: 'PartnerBookingEventSourcesAggregate';
  aggregate?: Maybe<PartnerBookingEventSourcesAggregateFields>;
  nodes: Array<PartnerBookingEventSources>;
};

/** aggregate fields of "partner_booking_event_sources" */
export type PartnerBookingEventSourcesAggregateFields = {
  __typename?: 'PartnerBookingEventSourcesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<PartnerBookingEventSourcesMaxFields>;
  min?: Maybe<PartnerBookingEventSourcesMinFields>;
};


/** aggregate fields of "partner_booking_event_sources" */
export type PartnerBookingEventSourcesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PartnerBookingEventSourcesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "partner_booking_event_sources". All fields are combined with a logical 'AND'. */
export type PartnerBookingEventSourcesBoolExp = {
  _and?: InputMaybe<Array<PartnerBookingEventSourcesBoolExp>>;
  _not?: InputMaybe<PartnerBookingEventSourcesBoolExp>;
  _or?: InputMaybe<Array<PartnerBookingEventSourcesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "partner_booking_event_sources" */
export enum PartnerBookingEventSourcesConstraint {
  /** unique or primary key constraint on columns "value" */
  PartnerBookingEventSourcesPkey = 'partner_booking_event_sources_pkey'
}

export enum PartnerBookingEventSourcesEnum {
  /** Callback from the booking engine */
  BotCallback = 'BOT_CALLBACK',
  /** Sending the job to the booking engine */
  Dispatcher = 'DISPATCHER',
  /** Action by a person */
  Ops = 'OPS',
  /** Scheduled check after dispatch */
  Timer = 'TIMER',
  /** Result of checking the club's system */
  Verifier = 'VERIFIER'
}

/** Boolean expression to compare columns of type "PartnerBookingEventSourcesEnum". All fields are combined with logical 'AND'. */
export type PartnerBookingEventSourcesEnumComparisonExp = {
  _eq?: InputMaybe<PartnerBookingEventSourcesEnum>;
  _in?: InputMaybe<Array<PartnerBookingEventSourcesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<PartnerBookingEventSourcesEnum>;
  _nin?: InputMaybe<Array<PartnerBookingEventSourcesEnum>>;
};

/** input type for inserting data into table "partner_booking_event_sources" */
export type PartnerBookingEventSourcesInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type PartnerBookingEventSourcesMaxFields = {
  __typename?: 'PartnerBookingEventSourcesMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type PartnerBookingEventSourcesMinFields = {
  __typename?: 'PartnerBookingEventSourcesMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "partner_booking_event_sources" */
export type PartnerBookingEventSourcesMutationResponse = {
  __typename?: 'PartnerBookingEventSourcesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PartnerBookingEventSources>;
};

/** on_conflict condition type for table "partner_booking_event_sources" */
export type PartnerBookingEventSourcesOnConflict = {
  constraint: PartnerBookingEventSourcesConstraint;
  updateColumns?: Array<PartnerBookingEventSourcesUpdateColumn>;
  where?: InputMaybe<PartnerBookingEventSourcesBoolExp>;
};

/** Ordering options when selecting data from "partner_booking_event_sources". */
export type PartnerBookingEventSourcesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: partner_booking_event_sources */
export type PartnerBookingEventSourcesPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "partner_booking_event_sources" */
export enum PartnerBookingEventSourcesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "partner_booking_event_sources" */
export type PartnerBookingEventSourcesSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "partner_booking_event_sources" */
export type PartnerBookingEventSourcesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PartnerBookingEventSourcesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PartnerBookingEventSourcesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "partner_booking_event_sources" */
export enum PartnerBookingEventSourcesUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type PartnerBookingEventSourcesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PartnerBookingEventSourcesSetInput>;
  /** filter the rows which have to be updated */
  where: PartnerBookingEventSourcesBoolExp;
};

/** columns and relationships of "partner_booking_holds" */
export type PartnerBookingHolds = {
  __typename?: 'PartnerBookingHolds';
  courtsFreeAtHold: Scalars['Int'];
  createdAt: Scalars['timestamptz'];
  during: Scalars['tstzrange'];
  expiresAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  order: PartnerBookingOrders;
  orderId: Scalars['uuid'];
  providerCourtId?: Maybe<Scalars['String']>;
  providerResourceId: Scalars['String'];
  releasedAt?: Maybe<Scalars['timestamptz']>;
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  venue: Venues;
  venueId: Scalars['uuid'];
};

/** aggregated selection of "partner_booking_holds" */
export type PartnerBookingHoldsAggregate = {
  __typename?: 'PartnerBookingHoldsAggregate';
  aggregate?: Maybe<PartnerBookingHoldsAggregateFields>;
  nodes: Array<PartnerBookingHolds>;
};

/** aggregate fields of "partner_booking_holds" */
export type PartnerBookingHoldsAggregateFields = {
  __typename?: 'PartnerBookingHoldsAggregateFields';
  avg?: Maybe<PartnerBookingHoldsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<PartnerBookingHoldsMaxFields>;
  min?: Maybe<PartnerBookingHoldsMinFields>;
  stddev?: Maybe<PartnerBookingHoldsStddevFields>;
  stddevPop?: Maybe<PartnerBookingHoldsStddevPopFields>;
  stddevSamp?: Maybe<PartnerBookingHoldsStddevSampFields>;
  sum?: Maybe<PartnerBookingHoldsSumFields>;
  varPop?: Maybe<PartnerBookingHoldsVarPopFields>;
  varSamp?: Maybe<PartnerBookingHoldsVarSampFields>;
  variance?: Maybe<PartnerBookingHoldsVarianceFields>;
};


/** aggregate fields of "partner_booking_holds" */
export type PartnerBookingHoldsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PartnerBookingHoldsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type PartnerBookingHoldsAvgFields = {
  __typename?: 'PartnerBookingHoldsAvgFields';
  courtsFreeAtHold?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "partner_booking_holds". All fields are combined with a logical 'AND'. */
export type PartnerBookingHoldsBoolExp = {
  _and?: InputMaybe<Array<PartnerBookingHoldsBoolExp>>;
  _not?: InputMaybe<PartnerBookingHoldsBoolExp>;
  _or?: InputMaybe<Array<PartnerBookingHoldsBoolExp>>;
  courtsFreeAtHold?: InputMaybe<IntComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  during?: InputMaybe<TstzrangeComparisonExp>;
  expiresAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  order?: InputMaybe<PartnerBookingOrdersBoolExp>;
  orderId?: InputMaybe<UuidComparisonExp>;
  providerCourtId?: InputMaybe<StringComparisonExp>;
  providerResourceId?: InputMaybe<StringComparisonExp>;
  releasedAt?: InputMaybe<TimestamptzComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  venue?: InputMaybe<VenuesBoolExp>;
  venueId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "partner_booking_holds" */
export enum PartnerBookingHoldsConstraint {
  /** unique or primary key constraint on columns "order_id" */
  PartnerBookingHoldsOrderIdKey = 'partner_booking_holds_order_id_key',
  /** unique or primary key constraint on columns "id" */
  PartnerBookingHoldsPkey = 'partner_booking_holds_pkey'
}

/** input type for incrementing numeric columns in table "partner_booking_holds" */
export type PartnerBookingHoldsIncInput = {
  courtsFreeAtHold?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "partner_booking_holds" */
export type PartnerBookingHoldsInsertInput = {
  courtsFreeAtHold?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  during?: InputMaybe<Scalars['tstzrange']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  order?: InputMaybe<PartnerBookingOrdersObjRelInsertInput>;
  orderId?: InputMaybe<Scalars['uuid']>;
  providerCourtId?: InputMaybe<Scalars['String']>;
  providerResourceId?: InputMaybe<Scalars['String']>;
  releasedAt?: InputMaybe<Scalars['timestamptz']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  venue?: InputMaybe<VenuesObjRelInsertInput>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type PartnerBookingHoldsMaxFields = {
  __typename?: 'PartnerBookingHoldsMaxFields';
  courtsFreeAtHold?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  expiresAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  orderId?: Maybe<Scalars['uuid']>;
  providerCourtId?: Maybe<Scalars['String']>;
  providerResourceId?: Maybe<Scalars['String']>;
  releasedAt?: Maybe<Scalars['timestamptz']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  venueId?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type PartnerBookingHoldsMinFields = {
  __typename?: 'PartnerBookingHoldsMinFields';
  courtsFreeAtHold?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  expiresAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  orderId?: Maybe<Scalars['uuid']>;
  providerCourtId?: Maybe<Scalars['String']>;
  providerResourceId?: Maybe<Scalars['String']>;
  releasedAt?: Maybe<Scalars['timestamptz']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  venueId?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "partner_booking_holds" */
export type PartnerBookingHoldsMutationResponse = {
  __typename?: 'PartnerBookingHoldsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PartnerBookingHolds>;
};

/** input type for inserting object relation for remote table "partner_booking_holds" */
export type PartnerBookingHoldsObjRelInsertInput = {
  data: PartnerBookingHoldsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<PartnerBookingHoldsOnConflict>;
};

/** on_conflict condition type for table "partner_booking_holds" */
export type PartnerBookingHoldsOnConflict = {
  constraint: PartnerBookingHoldsConstraint;
  updateColumns?: Array<PartnerBookingHoldsUpdateColumn>;
  where?: InputMaybe<PartnerBookingHoldsBoolExp>;
};

/** Ordering options when selecting data from "partner_booking_holds". */
export type PartnerBookingHoldsOrderBy = {
  courtsFreeAtHold?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  during?: InputMaybe<OrderBy>;
  expiresAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  order?: InputMaybe<PartnerBookingOrdersOrderBy>;
  orderId?: InputMaybe<OrderBy>;
  providerCourtId?: InputMaybe<OrderBy>;
  providerResourceId?: InputMaybe<OrderBy>;
  releasedAt?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  venue?: InputMaybe<VenuesOrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: partner_booking_holds */
export type PartnerBookingHoldsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "partner_booking_holds" */
export enum PartnerBookingHoldsSelectColumn {
  /** column name */
  CourtsFreeAtHold = 'courtsFreeAtHold',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  During = 'during',
  /** column name */
  ExpiresAt = 'expiresAt',
  /** column name */
  Id = 'id',
  /** column name */
  OrderId = 'orderId',
  /** column name */
  ProviderCourtId = 'providerCourtId',
  /** column name */
  ProviderResourceId = 'providerResourceId',
  /** column name */
  ReleasedAt = 'releasedAt',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  VenueId = 'venueId'
}

/** input type for updating data in table "partner_booking_holds" */
export type PartnerBookingHoldsSetInput = {
  courtsFreeAtHold?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  during?: InputMaybe<Scalars['tstzrange']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  orderId?: InputMaybe<Scalars['uuid']>;
  providerCourtId?: InputMaybe<Scalars['String']>;
  providerResourceId?: InputMaybe<Scalars['String']>;
  releasedAt?: InputMaybe<Scalars['timestamptz']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type PartnerBookingHoldsStddevFields = {
  __typename?: 'PartnerBookingHoldsStddevFields';
  courtsFreeAtHold?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type PartnerBookingHoldsStddevPopFields = {
  __typename?: 'PartnerBookingHoldsStddevPopFields';
  courtsFreeAtHold?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type PartnerBookingHoldsStddevSampFields = {
  __typename?: 'PartnerBookingHoldsStddevSampFields';
  courtsFreeAtHold?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "partner_booking_holds" */
export type PartnerBookingHoldsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PartnerBookingHoldsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PartnerBookingHoldsStreamCursorValueInput = {
  courtsFreeAtHold?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  during?: InputMaybe<Scalars['tstzrange']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  orderId?: InputMaybe<Scalars['uuid']>;
  providerCourtId?: InputMaybe<Scalars['String']>;
  providerResourceId?: InputMaybe<Scalars['String']>;
  releasedAt?: InputMaybe<Scalars['timestamptz']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type PartnerBookingHoldsSumFields = {
  __typename?: 'PartnerBookingHoldsSumFields';
  courtsFreeAtHold?: Maybe<Scalars['Int']>;
};

/** update columns of table "partner_booking_holds" */
export enum PartnerBookingHoldsUpdateColumn {
  /** column name */
  CourtsFreeAtHold = 'courtsFreeAtHold',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  During = 'during',
  /** column name */
  ExpiresAt = 'expiresAt',
  /** column name */
  Id = 'id',
  /** column name */
  OrderId = 'orderId',
  /** column name */
  ProviderCourtId = 'providerCourtId',
  /** column name */
  ProviderResourceId = 'providerResourceId',
  /** column name */
  ReleasedAt = 'releasedAt',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  VenueId = 'venueId'
}

export type PartnerBookingHoldsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<PartnerBookingHoldsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PartnerBookingHoldsSetInput>;
  /** filter the rows which have to be updated */
  where: PartnerBookingHoldsBoolExp;
};

/** aggregate varPop on columns */
export type PartnerBookingHoldsVarPopFields = {
  __typename?: 'PartnerBookingHoldsVarPopFields';
  courtsFreeAtHold?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type PartnerBookingHoldsVarSampFields = {
  __typename?: 'PartnerBookingHoldsVarSampFields';
  courtsFreeAtHold?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type PartnerBookingHoldsVarianceFields = {
  __typename?: 'PartnerBookingHoldsVarianceFields';
  courtsFreeAtHold?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "partner_booking_order_statuses" */
export type PartnerBookingOrderStatuses = {
  __typename?: 'PartnerBookingOrderStatuses';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "partner_booking_order_statuses" */
export type PartnerBookingOrderStatusesAggregate = {
  __typename?: 'PartnerBookingOrderStatusesAggregate';
  aggregate?: Maybe<PartnerBookingOrderStatusesAggregateFields>;
  nodes: Array<PartnerBookingOrderStatuses>;
};

/** aggregate fields of "partner_booking_order_statuses" */
export type PartnerBookingOrderStatusesAggregateFields = {
  __typename?: 'PartnerBookingOrderStatusesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<PartnerBookingOrderStatusesMaxFields>;
  min?: Maybe<PartnerBookingOrderStatusesMinFields>;
};


/** aggregate fields of "partner_booking_order_statuses" */
export type PartnerBookingOrderStatusesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PartnerBookingOrderStatusesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "partner_booking_order_statuses". All fields are combined with a logical 'AND'. */
export type PartnerBookingOrderStatusesBoolExp = {
  _and?: InputMaybe<Array<PartnerBookingOrderStatusesBoolExp>>;
  _not?: InputMaybe<PartnerBookingOrderStatusesBoolExp>;
  _or?: InputMaybe<Array<PartnerBookingOrderStatusesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "partner_booking_order_statuses" */
export enum PartnerBookingOrderStatusesConstraint {
  /** unique or primary key constraint on columns "value" */
  PartnerBookingOrderStatusesPkey = 'partner_booking_order_statuses_pkey'
}

export enum PartnerBookingOrderStatusesEnum {
  /** Cancelled by the player or ops */
  Cancelled = 'CANCELLED',
  /** Booking verified on the club's system */
  Confirmed = 'CONFIRMED',
  /** Could not be booked; nothing exists at the club */
  Failed = 'FAILED',
  /** Being booked on the club's system */
  Fulfilling = 'FULFILLING',
  /** Slot held at checkout, no booking attempt yet */
  Held = 'HELD',
  /** Outcome unclear or mismatched; ops must resolve */
  NeedsReview = 'NEEDS_REVIEW'
}

/** Boolean expression to compare columns of type "PartnerBookingOrderStatusesEnum". All fields are combined with logical 'AND'. */
export type PartnerBookingOrderStatusesEnumComparisonExp = {
  _eq?: InputMaybe<PartnerBookingOrderStatusesEnum>;
  _in?: InputMaybe<Array<PartnerBookingOrderStatusesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<PartnerBookingOrderStatusesEnum>;
  _nin?: InputMaybe<Array<PartnerBookingOrderStatusesEnum>>;
};

/** input type for inserting data into table "partner_booking_order_statuses" */
export type PartnerBookingOrderStatusesInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type PartnerBookingOrderStatusesMaxFields = {
  __typename?: 'PartnerBookingOrderStatusesMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type PartnerBookingOrderStatusesMinFields = {
  __typename?: 'PartnerBookingOrderStatusesMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "partner_booking_order_statuses" */
export type PartnerBookingOrderStatusesMutationResponse = {
  __typename?: 'PartnerBookingOrderStatusesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PartnerBookingOrderStatuses>;
};

/** on_conflict condition type for table "partner_booking_order_statuses" */
export type PartnerBookingOrderStatusesOnConflict = {
  constraint: PartnerBookingOrderStatusesConstraint;
  updateColumns?: Array<PartnerBookingOrderStatusesUpdateColumn>;
  where?: InputMaybe<PartnerBookingOrderStatusesBoolExp>;
};

/** Ordering options when selecting data from "partner_booking_order_statuses". */
export type PartnerBookingOrderStatusesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: partner_booking_order_statuses */
export type PartnerBookingOrderStatusesPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "partner_booking_order_statuses" */
export enum PartnerBookingOrderStatusesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "partner_booking_order_statuses" */
export type PartnerBookingOrderStatusesSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "partner_booking_order_statuses" */
export type PartnerBookingOrderStatusesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PartnerBookingOrderStatusesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PartnerBookingOrderStatusesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "partner_booking_order_statuses" */
export enum PartnerBookingOrderStatusesUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type PartnerBookingOrderStatusesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PartnerBookingOrderStatusesSetInput>;
  /** filter the rows which have to be updated */
  where: PartnerBookingOrderStatusesBoolExp;
};

/** columns and relationships of "partner_booking_orders" */
export type PartnerBookingOrders = {
  __typename?: 'PartnerBookingOrders';
  /** An array relationship */
  attempts: Array<PartnerBookingAttempts>;
  /** An aggregate relationship */
  attemptsAggregate: PartnerBookingAttemptsAggregate;
  authorizedAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  bookingConfigVersion?: Maybe<VenueBookingConfigVersions>;
  bounceCostUnitAmount?: Maybe<Scalars['Int']>;
  capturedAt?: Maybe<Scalars['timestamptz']>;
  clubPriceUnitAmount?: Maybe<Scalars['Int']>;
  configVersion: Scalars['Int'];
  createdAt: Scalars['timestamptz'];
  currency: Scalars['String'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  endAt: Scalars['timestamptz'];
  endLocal: Scalars['time'];
  /** An object relationship */
  externalStripePaymentIntent?: Maybe<StripePaymentIntents>;
  externalStripePaymentIntentId?: Maybe<Scalars['String']>;
  failureReason?: Maybe<Scalars['String']>;
  /** An object relationship */
  hold?: Maybe<PartnerBookingHolds>;
  id: Scalars['uuid'];
  /** An object relationship */
  integration: VenueBookingIntegrations;
  integrationId: Scalars['uuid'];
  /** An object relationship */
  internalStripePaymentIntent?: Maybe<StripePaymentIntents>;
  internalStripePaymentIntentId?: Maybe<Scalars['uuid']>;
  inventoryType: BookingInventoryTypesEnum;
  localDate: Scalars['date'];
  marker: Scalars['String'];
  maxPriceUnitAmount: Scalars['Int'];
  orderSubtotalUnitAmount: Scalars['Int'];
  orderTotalUnitAmount: Scalars['Int'];
  paidUnitAmount: Scalars['Int'];
  partnerDiscountPercent?: Maybe<Scalars['numeric']>;
  partnerDiscountUnitAmount?: Maybe<Scalars['Int']>;
  paymentProcessor?: Maybe<PaymentProcessorsEnum>;
  /** An object relationship */
  player: Users;
  playerCount: Scalars['Int'];
  playerUserId: Scalars['uuid'];
  providerCourtId?: Maybe<Scalars['String']>;
  providerResourceId: Scalars['String'];
  referralFeeUnitAmount?: Maybe<Scalars['Int']>;
  refundUnitAmount: Scalars['Int'];
  refundedAt?: Maybe<Scalars['timestamptz']>;
  refundedByPersona?: Maybe<AppPersonasEnum>;
  releasedAt?: Maybe<Scalars['timestamptz']>;
  startAt: Scalars['timestamptz'];
  startLocal: Scalars['time'];
  status: PartnerBookingOrderStatusesEnum;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentStatus?: Maybe<Scalars['String']>;
  timezone: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  userCreditCard?: Maybe<UserCreditCards>;
  userCreditCardId?: Maybe<Scalars['uuid']>;
  utmCampaign?: Maybe<Scalars['String']>;
  utmContent?: Maybe<Scalars['String']>;
  utmMedium?: Maybe<Scalars['String']>;
  utmSource?: Maybe<Scalars['String']>;
  /** An object relationship */
  venue: Venues;
  venueId: Scalars['uuid'];
};


/** columns and relationships of "partner_booking_orders" */
export type PartnerBookingOrdersAttemptsArgs = {
  distinctOn?: InputMaybe<Array<PartnerBookingAttemptsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PartnerBookingAttemptsOrderBy>>;
  where?: InputMaybe<PartnerBookingAttemptsBoolExp>;
};


/** columns and relationships of "partner_booking_orders" */
export type PartnerBookingOrdersAttemptsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PartnerBookingAttemptsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PartnerBookingAttemptsOrderBy>>;
  where?: InputMaybe<PartnerBookingAttemptsBoolExp>;
};

/** aggregated selection of "partner_booking_orders" */
export type PartnerBookingOrdersAggregate = {
  __typename?: 'PartnerBookingOrdersAggregate';
  aggregate?: Maybe<PartnerBookingOrdersAggregateFields>;
  nodes: Array<PartnerBookingOrders>;
};

/** aggregate fields of "partner_booking_orders" */
export type PartnerBookingOrdersAggregateFields = {
  __typename?: 'PartnerBookingOrdersAggregateFields';
  avg?: Maybe<PartnerBookingOrdersAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<PartnerBookingOrdersMaxFields>;
  min?: Maybe<PartnerBookingOrdersMinFields>;
  stddev?: Maybe<PartnerBookingOrdersStddevFields>;
  stddevPop?: Maybe<PartnerBookingOrdersStddevPopFields>;
  stddevSamp?: Maybe<PartnerBookingOrdersStddevSampFields>;
  sum?: Maybe<PartnerBookingOrdersSumFields>;
  varPop?: Maybe<PartnerBookingOrdersVarPopFields>;
  varSamp?: Maybe<PartnerBookingOrdersVarSampFields>;
  variance?: Maybe<PartnerBookingOrdersVarianceFields>;
};


/** aggregate fields of "partner_booking_orders" */
export type PartnerBookingOrdersAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PartnerBookingOrdersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type PartnerBookingOrdersAvgFields = {
  __typename?: 'PartnerBookingOrdersAvgFields';
  bounceCostUnitAmount?: Maybe<Scalars['Float']>;
  clubPriceUnitAmount?: Maybe<Scalars['Float']>;
  configVersion?: Maybe<Scalars['Float']>;
  maxPriceUnitAmount?: Maybe<Scalars['Float']>;
  orderSubtotalUnitAmount?: Maybe<Scalars['Float']>;
  orderTotalUnitAmount?: Maybe<Scalars['Float']>;
  paidUnitAmount?: Maybe<Scalars['Float']>;
  partnerDiscountPercent?: Maybe<Scalars['Float']>;
  partnerDiscountUnitAmount?: Maybe<Scalars['Float']>;
  playerCount?: Maybe<Scalars['Float']>;
  referralFeeUnitAmount?: Maybe<Scalars['Float']>;
  refundUnitAmount?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "partner_booking_orders". All fields are combined with a logical 'AND'. */
export type PartnerBookingOrdersBoolExp = {
  _and?: InputMaybe<Array<PartnerBookingOrdersBoolExp>>;
  _not?: InputMaybe<PartnerBookingOrdersBoolExp>;
  _or?: InputMaybe<Array<PartnerBookingOrdersBoolExp>>;
  attempts?: InputMaybe<PartnerBookingAttemptsBoolExp>;
  attemptsAggregate?: InputMaybe<PartnerBookingAttemptsAggregateBoolExp>;
  authorizedAt?: InputMaybe<TimestamptzComparisonExp>;
  bookingConfigVersion?: InputMaybe<VenueBookingConfigVersionsBoolExp>;
  bounceCostUnitAmount?: InputMaybe<IntComparisonExp>;
  capturedAt?: InputMaybe<TimestamptzComparisonExp>;
  clubPriceUnitAmount?: InputMaybe<IntComparisonExp>;
  configVersion?: InputMaybe<IntComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  currency?: InputMaybe<StringComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  endAt?: InputMaybe<TimestamptzComparisonExp>;
  endLocal?: InputMaybe<TimeComparisonExp>;
  externalStripePaymentIntent?: InputMaybe<StripePaymentIntentsBoolExp>;
  externalStripePaymentIntentId?: InputMaybe<StringComparisonExp>;
  failureReason?: InputMaybe<StringComparisonExp>;
  hold?: InputMaybe<PartnerBookingHoldsBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  integration?: InputMaybe<VenueBookingIntegrationsBoolExp>;
  integrationId?: InputMaybe<UuidComparisonExp>;
  internalStripePaymentIntent?: InputMaybe<StripePaymentIntentsBoolExp>;
  internalStripePaymentIntentId?: InputMaybe<UuidComparisonExp>;
  inventoryType?: InputMaybe<BookingInventoryTypesEnumComparisonExp>;
  localDate?: InputMaybe<DateComparisonExp>;
  marker?: InputMaybe<StringComparisonExp>;
  maxPriceUnitAmount?: InputMaybe<IntComparisonExp>;
  orderSubtotalUnitAmount?: InputMaybe<IntComparisonExp>;
  orderTotalUnitAmount?: InputMaybe<IntComparisonExp>;
  paidUnitAmount?: InputMaybe<IntComparisonExp>;
  partnerDiscountPercent?: InputMaybe<NumericComparisonExp>;
  partnerDiscountUnitAmount?: InputMaybe<IntComparisonExp>;
  paymentProcessor?: InputMaybe<PaymentProcessorsEnumComparisonExp>;
  player?: InputMaybe<UsersBoolExp>;
  playerCount?: InputMaybe<IntComparisonExp>;
  playerUserId?: InputMaybe<UuidComparisonExp>;
  providerCourtId?: InputMaybe<StringComparisonExp>;
  providerResourceId?: InputMaybe<StringComparisonExp>;
  referralFeeUnitAmount?: InputMaybe<IntComparisonExp>;
  refundUnitAmount?: InputMaybe<IntComparisonExp>;
  refundedAt?: InputMaybe<TimestamptzComparisonExp>;
  refundedByPersona?: InputMaybe<AppPersonasEnumComparisonExp>;
  releasedAt?: InputMaybe<TimestamptzComparisonExp>;
  startAt?: InputMaybe<TimestamptzComparisonExp>;
  startLocal?: InputMaybe<TimeComparisonExp>;
  status?: InputMaybe<PartnerBookingOrderStatusesEnumComparisonExp>;
  stripeCustomerId?: InputMaybe<StringComparisonExp>;
  stripePaymentStatus?: InputMaybe<StringComparisonExp>;
  timezone?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  userCreditCard?: InputMaybe<UserCreditCardsBoolExp>;
  userCreditCardId?: InputMaybe<UuidComparisonExp>;
  utmCampaign?: InputMaybe<StringComparisonExp>;
  utmContent?: InputMaybe<StringComparisonExp>;
  utmMedium?: InputMaybe<StringComparisonExp>;
  utmSource?: InputMaybe<StringComparisonExp>;
  venue?: InputMaybe<VenuesBoolExp>;
  venueId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "partner_booking_orders" */
export enum PartnerBookingOrdersConstraint {
  /** unique or primary key constraint on columns "external_stripe_payment_intent_id" */
  PartnerBookingOrdersExternalStripePaymentIntentIdKey = 'partner_booking_orders_external_stripe_payment_intent_id_key',
  /** unique or primary key constraint on columns "internal_stripe_payment_intent_id" */
  PartnerBookingOrdersInternalStripePaymentIntentIdKey = 'partner_booking_orders_internal_stripe_payment_intent_id_key',
  /** unique or primary key constraint on columns "marker" */
  PartnerBookingOrdersMarkerKey = 'partner_booking_orders_marker_key',
  /** unique or primary key constraint on columns "id" */
  PartnerBookingOrdersPkey = 'partner_booking_orders_pkey'
}

/** input type for incrementing numeric columns in table "partner_booking_orders" */
export type PartnerBookingOrdersIncInput = {
  bounceCostUnitAmount?: InputMaybe<Scalars['Int']>;
  clubPriceUnitAmount?: InputMaybe<Scalars['Int']>;
  configVersion?: InputMaybe<Scalars['Int']>;
  maxPriceUnitAmount?: InputMaybe<Scalars['Int']>;
  orderSubtotalUnitAmount?: InputMaybe<Scalars['Int']>;
  orderTotalUnitAmount?: InputMaybe<Scalars['Int']>;
  paidUnitAmount?: InputMaybe<Scalars['Int']>;
  partnerDiscountPercent?: InputMaybe<Scalars['numeric']>;
  partnerDiscountUnitAmount?: InputMaybe<Scalars['Int']>;
  playerCount?: InputMaybe<Scalars['Int']>;
  referralFeeUnitAmount?: InputMaybe<Scalars['Int']>;
  refundUnitAmount?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "partner_booking_orders" */
export type PartnerBookingOrdersInsertInput = {
  attempts?: InputMaybe<PartnerBookingAttemptsArrRelInsertInput>;
  authorizedAt?: InputMaybe<Scalars['timestamptz']>;
  bookingConfigVersion?: InputMaybe<VenueBookingConfigVersionsObjRelInsertInput>;
  bounceCostUnitAmount?: InputMaybe<Scalars['Int']>;
  capturedAt?: InputMaybe<Scalars['timestamptz']>;
  clubPriceUnitAmount?: InputMaybe<Scalars['Int']>;
  configVersion?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  endAt?: InputMaybe<Scalars['timestamptz']>;
  endLocal?: InputMaybe<Scalars['time']>;
  externalStripePaymentIntent?: InputMaybe<StripePaymentIntentsObjRelInsertInput>;
  externalStripePaymentIntentId?: InputMaybe<Scalars['String']>;
  failureReason?: InputMaybe<Scalars['String']>;
  hold?: InputMaybe<PartnerBookingHoldsObjRelInsertInput>;
  id?: InputMaybe<Scalars['uuid']>;
  integration?: InputMaybe<VenueBookingIntegrationsObjRelInsertInput>;
  integrationId?: InputMaybe<Scalars['uuid']>;
  internalStripePaymentIntent?: InputMaybe<StripePaymentIntentsObjRelInsertInput>;
  internalStripePaymentIntentId?: InputMaybe<Scalars['uuid']>;
  inventoryType?: InputMaybe<BookingInventoryTypesEnum>;
  localDate?: InputMaybe<Scalars['date']>;
  marker?: InputMaybe<Scalars['String']>;
  maxPriceUnitAmount?: InputMaybe<Scalars['Int']>;
  orderSubtotalUnitAmount?: InputMaybe<Scalars['Int']>;
  orderTotalUnitAmount?: InputMaybe<Scalars['Int']>;
  paidUnitAmount?: InputMaybe<Scalars['Int']>;
  partnerDiscountPercent?: InputMaybe<Scalars['numeric']>;
  partnerDiscountUnitAmount?: InputMaybe<Scalars['Int']>;
  paymentProcessor?: InputMaybe<PaymentProcessorsEnum>;
  player?: InputMaybe<UsersObjRelInsertInput>;
  playerCount?: InputMaybe<Scalars['Int']>;
  playerUserId?: InputMaybe<Scalars['uuid']>;
  providerCourtId?: InputMaybe<Scalars['String']>;
  providerResourceId?: InputMaybe<Scalars['String']>;
  referralFeeUnitAmount?: InputMaybe<Scalars['Int']>;
  refundUnitAmount?: InputMaybe<Scalars['Int']>;
  refundedAt?: InputMaybe<Scalars['timestamptz']>;
  refundedByPersona?: InputMaybe<AppPersonasEnum>;
  releasedAt?: InputMaybe<Scalars['timestamptz']>;
  startAt?: InputMaybe<Scalars['timestamptz']>;
  startLocal?: InputMaybe<Scalars['time']>;
  status?: InputMaybe<PartnerBookingOrderStatusesEnum>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  stripePaymentStatus?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userCreditCard?: InputMaybe<UserCreditCardsObjRelInsertInput>;
  userCreditCardId?: InputMaybe<Scalars['uuid']>;
  utmCampaign?: InputMaybe<Scalars['String']>;
  utmContent?: InputMaybe<Scalars['String']>;
  utmMedium?: InputMaybe<Scalars['String']>;
  utmSource?: InputMaybe<Scalars['String']>;
  venue?: InputMaybe<VenuesObjRelInsertInput>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type PartnerBookingOrdersMaxFields = {
  __typename?: 'PartnerBookingOrdersMaxFields';
  authorizedAt?: Maybe<Scalars['timestamptz']>;
  bounceCostUnitAmount?: Maybe<Scalars['Int']>;
  capturedAt?: Maybe<Scalars['timestamptz']>;
  clubPriceUnitAmount?: Maybe<Scalars['Int']>;
  configVersion?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  endAt?: Maybe<Scalars['timestamptz']>;
  externalStripePaymentIntentId?: Maybe<Scalars['String']>;
  failureReason?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  integrationId?: Maybe<Scalars['uuid']>;
  internalStripePaymentIntentId?: Maybe<Scalars['uuid']>;
  localDate?: Maybe<Scalars['date']>;
  marker?: Maybe<Scalars['String']>;
  maxPriceUnitAmount?: Maybe<Scalars['Int']>;
  orderSubtotalUnitAmount?: Maybe<Scalars['Int']>;
  orderTotalUnitAmount?: Maybe<Scalars['Int']>;
  paidUnitAmount?: Maybe<Scalars['Int']>;
  partnerDiscountPercent?: Maybe<Scalars['numeric']>;
  partnerDiscountUnitAmount?: Maybe<Scalars['Int']>;
  playerCount?: Maybe<Scalars['Int']>;
  playerUserId?: Maybe<Scalars['uuid']>;
  providerCourtId?: Maybe<Scalars['String']>;
  providerResourceId?: Maybe<Scalars['String']>;
  referralFeeUnitAmount?: Maybe<Scalars['Int']>;
  refundUnitAmount?: Maybe<Scalars['Int']>;
  refundedAt?: Maybe<Scalars['timestamptz']>;
  releasedAt?: Maybe<Scalars['timestamptz']>;
  startAt?: Maybe<Scalars['timestamptz']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentStatus?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userCreditCardId?: Maybe<Scalars['uuid']>;
  utmCampaign?: Maybe<Scalars['String']>;
  utmContent?: Maybe<Scalars['String']>;
  utmMedium?: Maybe<Scalars['String']>;
  utmSource?: Maybe<Scalars['String']>;
  venueId?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type PartnerBookingOrdersMinFields = {
  __typename?: 'PartnerBookingOrdersMinFields';
  authorizedAt?: Maybe<Scalars['timestamptz']>;
  bounceCostUnitAmount?: Maybe<Scalars['Int']>;
  capturedAt?: Maybe<Scalars['timestamptz']>;
  clubPriceUnitAmount?: Maybe<Scalars['Int']>;
  configVersion?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  endAt?: Maybe<Scalars['timestamptz']>;
  externalStripePaymentIntentId?: Maybe<Scalars['String']>;
  failureReason?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  integrationId?: Maybe<Scalars['uuid']>;
  internalStripePaymentIntentId?: Maybe<Scalars['uuid']>;
  localDate?: Maybe<Scalars['date']>;
  marker?: Maybe<Scalars['String']>;
  maxPriceUnitAmount?: Maybe<Scalars['Int']>;
  orderSubtotalUnitAmount?: Maybe<Scalars['Int']>;
  orderTotalUnitAmount?: Maybe<Scalars['Int']>;
  paidUnitAmount?: Maybe<Scalars['Int']>;
  partnerDiscountPercent?: Maybe<Scalars['numeric']>;
  partnerDiscountUnitAmount?: Maybe<Scalars['Int']>;
  playerCount?: Maybe<Scalars['Int']>;
  playerUserId?: Maybe<Scalars['uuid']>;
  providerCourtId?: Maybe<Scalars['String']>;
  providerResourceId?: Maybe<Scalars['String']>;
  referralFeeUnitAmount?: Maybe<Scalars['Int']>;
  refundUnitAmount?: Maybe<Scalars['Int']>;
  refundedAt?: Maybe<Scalars['timestamptz']>;
  releasedAt?: Maybe<Scalars['timestamptz']>;
  startAt?: Maybe<Scalars['timestamptz']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentStatus?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userCreditCardId?: Maybe<Scalars['uuid']>;
  utmCampaign?: Maybe<Scalars['String']>;
  utmContent?: Maybe<Scalars['String']>;
  utmMedium?: Maybe<Scalars['String']>;
  utmSource?: Maybe<Scalars['String']>;
  venueId?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "partner_booking_orders" */
export type PartnerBookingOrdersMutationResponse = {
  __typename?: 'PartnerBookingOrdersMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PartnerBookingOrders>;
};

/** input type for inserting object relation for remote table "partner_booking_orders" */
export type PartnerBookingOrdersObjRelInsertInput = {
  data: PartnerBookingOrdersInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<PartnerBookingOrdersOnConflict>;
};

/** on_conflict condition type for table "partner_booking_orders" */
export type PartnerBookingOrdersOnConflict = {
  constraint: PartnerBookingOrdersConstraint;
  updateColumns?: Array<PartnerBookingOrdersUpdateColumn>;
  where?: InputMaybe<PartnerBookingOrdersBoolExp>;
};

/** Ordering options when selecting data from "partner_booking_orders". */
export type PartnerBookingOrdersOrderBy = {
  attemptsAggregate?: InputMaybe<PartnerBookingAttemptsAggregateOrderBy>;
  authorizedAt?: InputMaybe<OrderBy>;
  bookingConfigVersion?: InputMaybe<VenueBookingConfigVersionsOrderBy>;
  bounceCostUnitAmount?: InputMaybe<OrderBy>;
  capturedAt?: InputMaybe<OrderBy>;
  clubPriceUnitAmount?: InputMaybe<OrderBy>;
  configVersion?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  currency?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  endAt?: InputMaybe<OrderBy>;
  endLocal?: InputMaybe<OrderBy>;
  externalStripePaymentIntent?: InputMaybe<StripePaymentIntentsOrderBy>;
  externalStripePaymentIntentId?: InputMaybe<OrderBy>;
  failureReason?: InputMaybe<OrderBy>;
  hold?: InputMaybe<PartnerBookingHoldsOrderBy>;
  id?: InputMaybe<OrderBy>;
  integration?: InputMaybe<VenueBookingIntegrationsOrderBy>;
  integrationId?: InputMaybe<OrderBy>;
  internalStripePaymentIntent?: InputMaybe<StripePaymentIntentsOrderBy>;
  internalStripePaymentIntentId?: InputMaybe<OrderBy>;
  inventoryType?: InputMaybe<OrderBy>;
  localDate?: InputMaybe<OrderBy>;
  marker?: InputMaybe<OrderBy>;
  maxPriceUnitAmount?: InputMaybe<OrderBy>;
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  partnerDiscountPercent?: InputMaybe<OrderBy>;
  partnerDiscountUnitAmount?: InputMaybe<OrderBy>;
  paymentProcessor?: InputMaybe<OrderBy>;
  player?: InputMaybe<UsersOrderBy>;
  playerCount?: InputMaybe<OrderBy>;
  playerUserId?: InputMaybe<OrderBy>;
  providerCourtId?: InputMaybe<OrderBy>;
  providerResourceId?: InputMaybe<OrderBy>;
  referralFeeUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  refundedAt?: InputMaybe<OrderBy>;
  refundedByPersona?: InputMaybe<OrderBy>;
  releasedAt?: InputMaybe<OrderBy>;
  startAt?: InputMaybe<OrderBy>;
  startLocal?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  stripeCustomerId?: InputMaybe<OrderBy>;
  stripePaymentStatus?: InputMaybe<OrderBy>;
  timezone?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userCreditCard?: InputMaybe<UserCreditCardsOrderBy>;
  userCreditCardId?: InputMaybe<OrderBy>;
  utmCampaign?: InputMaybe<OrderBy>;
  utmContent?: InputMaybe<OrderBy>;
  utmMedium?: InputMaybe<OrderBy>;
  utmSource?: InputMaybe<OrderBy>;
  venue?: InputMaybe<VenuesOrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: partner_booking_orders */
export type PartnerBookingOrdersPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "partner_booking_orders" */
export enum PartnerBookingOrdersSelectColumn {
  /** column name */
  AuthorizedAt = 'authorizedAt',
  /** column name */
  BounceCostUnitAmount = 'bounceCostUnitAmount',
  /** column name */
  CapturedAt = 'capturedAt',
  /** column name */
  ClubPriceUnitAmount = 'clubPriceUnitAmount',
  /** column name */
  ConfigVersion = 'configVersion',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Currency = 'currency',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EndAt = 'endAt',
  /** column name */
  EndLocal = 'endLocal',
  /** column name */
  ExternalStripePaymentIntentId = 'externalStripePaymentIntentId',
  /** column name */
  FailureReason = 'failureReason',
  /** column name */
  Id = 'id',
  /** column name */
  IntegrationId = 'integrationId',
  /** column name */
  InternalStripePaymentIntentId = 'internalStripePaymentIntentId',
  /** column name */
  InventoryType = 'inventoryType',
  /** column name */
  LocalDate = 'localDate',
  /** column name */
  Marker = 'marker',
  /** column name */
  MaxPriceUnitAmount = 'maxPriceUnitAmount',
  /** column name */
  OrderSubtotalUnitAmount = 'orderSubtotalUnitAmount',
  /** column name */
  OrderTotalUnitAmount = 'orderTotalUnitAmount',
  /** column name */
  PaidUnitAmount = 'paidUnitAmount',
  /** column name */
  PartnerDiscountPercent = 'partnerDiscountPercent',
  /** column name */
  PartnerDiscountUnitAmount = 'partnerDiscountUnitAmount',
  /** column name */
  PaymentProcessor = 'paymentProcessor',
  /** column name */
  PlayerCount = 'playerCount',
  /** column name */
  PlayerUserId = 'playerUserId',
  /** column name */
  ProviderCourtId = 'providerCourtId',
  /** column name */
  ProviderResourceId = 'providerResourceId',
  /** column name */
  ReferralFeeUnitAmount = 'referralFeeUnitAmount',
  /** column name */
  RefundUnitAmount = 'refundUnitAmount',
  /** column name */
  RefundedAt = 'refundedAt',
  /** column name */
  RefundedByPersona = 'refundedByPersona',
  /** column name */
  ReleasedAt = 'releasedAt',
  /** column name */
  StartAt = 'startAt',
  /** column name */
  StartLocal = 'startLocal',
  /** column name */
  Status = 'status',
  /** column name */
  StripeCustomerId = 'stripeCustomerId',
  /** column name */
  StripePaymentStatus = 'stripePaymentStatus',
  /** column name */
  Timezone = 'timezone',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserCreditCardId = 'userCreditCardId',
  /** column name */
  UtmCampaign = 'utmCampaign',
  /** column name */
  UtmContent = 'utmContent',
  /** column name */
  UtmMedium = 'utmMedium',
  /** column name */
  UtmSource = 'utmSource',
  /** column name */
  VenueId = 'venueId'
}

/** input type for updating data in table "partner_booking_orders" */
export type PartnerBookingOrdersSetInput = {
  authorizedAt?: InputMaybe<Scalars['timestamptz']>;
  bounceCostUnitAmount?: InputMaybe<Scalars['Int']>;
  capturedAt?: InputMaybe<Scalars['timestamptz']>;
  clubPriceUnitAmount?: InputMaybe<Scalars['Int']>;
  configVersion?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  endAt?: InputMaybe<Scalars['timestamptz']>;
  endLocal?: InputMaybe<Scalars['time']>;
  externalStripePaymentIntentId?: InputMaybe<Scalars['String']>;
  failureReason?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  integrationId?: InputMaybe<Scalars['uuid']>;
  internalStripePaymentIntentId?: InputMaybe<Scalars['uuid']>;
  inventoryType?: InputMaybe<BookingInventoryTypesEnum>;
  localDate?: InputMaybe<Scalars['date']>;
  marker?: InputMaybe<Scalars['String']>;
  maxPriceUnitAmount?: InputMaybe<Scalars['Int']>;
  orderSubtotalUnitAmount?: InputMaybe<Scalars['Int']>;
  orderTotalUnitAmount?: InputMaybe<Scalars['Int']>;
  paidUnitAmount?: InputMaybe<Scalars['Int']>;
  partnerDiscountPercent?: InputMaybe<Scalars['numeric']>;
  partnerDiscountUnitAmount?: InputMaybe<Scalars['Int']>;
  paymentProcessor?: InputMaybe<PaymentProcessorsEnum>;
  playerCount?: InputMaybe<Scalars['Int']>;
  playerUserId?: InputMaybe<Scalars['uuid']>;
  providerCourtId?: InputMaybe<Scalars['String']>;
  providerResourceId?: InputMaybe<Scalars['String']>;
  referralFeeUnitAmount?: InputMaybe<Scalars['Int']>;
  refundUnitAmount?: InputMaybe<Scalars['Int']>;
  refundedAt?: InputMaybe<Scalars['timestamptz']>;
  refundedByPersona?: InputMaybe<AppPersonasEnum>;
  releasedAt?: InputMaybe<Scalars['timestamptz']>;
  startAt?: InputMaybe<Scalars['timestamptz']>;
  startLocal?: InputMaybe<Scalars['time']>;
  status?: InputMaybe<PartnerBookingOrderStatusesEnum>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  stripePaymentStatus?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userCreditCardId?: InputMaybe<Scalars['uuid']>;
  utmCampaign?: InputMaybe<Scalars['String']>;
  utmContent?: InputMaybe<Scalars['String']>;
  utmMedium?: InputMaybe<Scalars['String']>;
  utmSource?: InputMaybe<Scalars['String']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type PartnerBookingOrdersStddevFields = {
  __typename?: 'PartnerBookingOrdersStddevFields';
  bounceCostUnitAmount?: Maybe<Scalars['Float']>;
  clubPriceUnitAmount?: Maybe<Scalars['Float']>;
  configVersion?: Maybe<Scalars['Float']>;
  maxPriceUnitAmount?: Maybe<Scalars['Float']>;
  orderSubtotalUnitAmount?: Maybe<Scalars['Float']>;
  orderTotalUnitAmount?: Maybe<Scalars['Float']>;
  paidUnitAmount?: Maybe<Scalars['Float']>;
  partnerDiscountPercent?: Maybe<Scalars['Float']>;
  partnerDiscountUnitAmount?: Maybe<Scalars['Float']>;
  playerCount?: Maybe<Scalars['Float']>;
  referralFeeUnitAmount?: Maybe<Scalars['Float']>;
  refundUnitAmount?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type PartnerBookingOrdersStddevPopFields = {
  __typename?: 'PartnerBookingOrdersStddevPopFields';
  bounceCostUnitAmount?: Maybe<Scalars['Float']>;
  clubPriceUnitAmount?: Maybe<Scalars['Float']>;
  configVersion?: Maybe<Scalars['Float']>;
  maxPriceUnitAmount?: Maybe<Scalars['Float']>;
  orderSubtotalUnitAmount?: Maybe<Scalars['Float']>;
  orderTotalUnitAmount?: Maybe<Scalars['Float']>;
  paidUnitAmount?: Maybe<Scalars['Float']>;
  partnerDiscountPercent?: Maybe<Scalars['Float']>;
  partnerDiscountUnitAmount?: Maybe<Scalars['Float']>;
  playerCount?: Maybe<Scalars['Float']>;
  referralFeeUnitAmount?: Maybe<Scalars['Float']>;
  refundUnitAmount?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type PartnerBookingOrdersStddevSampFields = {
  __typename?: 'PartnerBookingOrdersStddevSampFields';
  bounceCostUnitAmount?: Maybe<Scalars['Float']>;
  clubPriceUnitAmount?: Maybe<Scalars['Float']>;
  configVersion?: Maybe<Scalars['Float']>;
  maxPriceUnitAmount?: Maybe<Scalars['Float']>;
  orderSubtotalUnitAmount?: Maybe<Scalars['Float']>;
  orderTotalUnitAmount?: Maybe<Scalars['Float']>;
  paidUnitAmount?: Maybe<Scalars['Float']>;
  partnerDiscountPercent?: Maybe<Scalars['Float']>;
  partnerDiscountUnitAmount?: Maybe<Scalars['Float']>;
  playerCount?: Maybe<Scalars['Float']>;
  referralFeeUnitAmount?: Maybe<Scalars['Float']>;
  refundUnitAmount?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "partner_booking_orders" */
export type PartnerBookingOrdersStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PartnerBookingOrdersStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PartnerBookingOrdersStreamCursorValueInput = {
  authorizedAt?: InputMaybe<Scalars['timestamptz']>;
  bounceCostUnitAmount?: InputMaybe<Scalars['Int']>;
  capturedAt?: InputMaybe<Scalars['timestamptz']>;
  clubPriceUnitAmount?: InputMaybe<Scalars['Int']>;
  configVersion?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  endAt?: InputMaybe<Scalars['timestamptz']>;
  endLocal?: InputMaybe<Scalars['time']>;
  externalStripePaymentIntentId?: InputMaybe<Scalars['String']>;
  failureReason?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  integrationId?: InputMaybe<Scalars['uuid']>;
  internalStripePaymentIntentId?: InputMaybe<Scalars['uuid']>;
  inventoryType?: InputMaybe<BookingInventoryTypesEnum>;
  localDate?: InputMaybe<Scalars['date']>;
  marker?: InputMaybe<Scalars['String']>;
  maxPriceUnitAmount?: InputMaybe<Scalars['Int']>;
  orderSubtotalUnitAmount?: InputMaybe<Scalars['Int']>;
  orderTotalUnitAmount?: InputMaybe<Scalars['Int']>;
  paidUnitAmount?: InputMaybe<Scalars['Int']>;
  partnerDiscountPercent?: InputMaybe<Scalars['numeric']>;
  partnerDiscountUnitAmount?: InputMaybe<Scalars['Int']>;
  paymentProcessor?: InputMaybe<PaymentProcessorsEnum>;
  playerCount?: InputMaybe<Scalars['Int']>;
  playerUserId?: InputMaybe<Scalars['uuid']>;
  providerCourtId?: InputMaybe<Scalars['String']>;
  providerResourceId?: InputMaybe<Scalars['String']>;
  referralFeeUnitAmount?: InputMaybe<Scalars['Int']>;
  refundUnitAmount?: InputMaybe<Scalars['Int']>;
  refundedAt?: InputMaybe<Scalars['timestamptz']>;
  refundedByPersona?: InputMaybe<AppPersonasEnum>;
  releasedAt?: InputMaybe<Scalars['timestamptz']>;
  startAt?: InputMaybe<Scalars['timestamptz']>;
  startLocal?: InputMaybe<Scalars['time']>;
  status?: InputMaybe<PartnerBookingOrderStatusesEnum>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  stripePaymentStatus?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userCreditCardId?: InputMaybe<Scalars['uuid']>;
  utmCampaign?: InputMaybe<Scalars['String']>;
  utmContent?: InputMaybe<Scalars['String']>;
  utmMedium?: InputMaybe<Scalars['String']>;
  utmSource?: InputMaybe<Scalars['String']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type PartnerBookingOrdersSumFields = {
  __typename?: 'PartnerBookingOrdersSumFields';
  bounceCostUnitAmount?: Maybe<Scalars['Int']>;
  clubPriceUnitAmount?: Maybe<Scalars['Int']>;
  configVersion?: Maybe<Scalars['Int']>;
  maxPriceUnitAmount?: Maybe<Scalars['Int']>;
  orderSubtotalUnitAmount?: Maybe<Scalars['Int']>;
  orderTotalUnitAmount?: Maybe<Scalars['Int']>;
  paidUnitAmount?: Maybe<Scalars['Int']>;
  partnerDiscountPercent?: Maybe<Scalars['numeric']>;
  partnerDiscountUnitAmount?: Maybe<Scalars['Int']>;
  playerCount?: Maybe<Scalars['Int']>;
  referralFeeUnitAmount?: Maybe<Scalars['Int']>;
  refundUnitAmount?: Maybe<Scalars['Int']>;
};

/** update columns of table "partner_booking_orders" */
export enum PartnerBookingOrdersUpdateColumn {
  /** column name */
  AuthorizedAt = 'authorizedAt',
  /** column name */
  BounceCostUnitAmount = 'bounceCostUnitAmount',
  /** column name */
  CapturedAt = 'capturedAt',
  /** column name */
  ClubPriceUnitAmount = 'clubPriceUnitAmount',
  /** column name */
  ConfigVersion = 'configVersion',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Currency = 'currency',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EndAt = 'endAt',
  /** column name */
  EndLocal = 'endLocal',
  /** column name */
  ExternalStripePaymentIntentId = 'externalStripePaymentIntentId',
  /** column name */
  FailureReason = 'failureReason',
  /** column name */
  Id = 'id',
  /** column name */
  IntegrationId = 'integrationId',
  /** column name */
  InternalStripePaymentIntentId = 'internalStripePaymentIntentId',
  /** column name */
  InventoryType = 'inventoryType',
  /** column name */
  LocalDate = 'localDate',
  /** column name */
  Marker = 'marker',
  /** column name */
  MaxPriceUnitAmount = 'maxPriceUnitAmount',
  /** column name */
  OrderSubtotalUnitAmount = 'orderSubtotalUnitAmount',
  /** column name */
  OrderTotalUnitAmount = 'orderTotalUnitAmount',
  /** column name */
  PaidUnitAmount = 'paidUnitAmount',
  /** column name */
  PartnerDiscountPercent = 'partnerDiscountPercent',
  /** column name */
  PartnerDiscountUnitAmount = 'partnerDiscountUnitAmount',
  /** column name */
  PaymentProcessor = 'paymentProcessor',
  /** column name */
  PlayerCount = 'playerCount',
  /** column name */
  PlayerUserId = 'playerUserId',
  /** column name */
  ProviderCourtId = 'providerCourtId',
  /** column name */
  ProviderResourceId = 'providerResourceId',
  /** column name */
  ReferralFeeUnitAmount = 'referralFeeUnitAmount',
  /** column name */
  RefundUnitAmount = 'refundUnitAmount',
  /** column name */
  RefundedAt = 'refundedAt',
  /** column name */
  RefundedByPersona = 'refundedByPersona',
  /** column name */
  ReleasedAt = 'releasedAt',
  /** column name */
  StartAt = 'startAt',
  /** column name */
  StartLocal = 'startLocal',
  /** column name */
  Status = 'status',
  /** column name */
  StripeCustomerId = 'stripeCustomerId',
  /** column name */
  StripePaymentStatus = 'stripePaymentStatus',
  /** column name */
  Timezone = 'timezone',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserCreditCardId = 'userCreditCardId',
  /** column name */
  UtmCampaign = 'utmCampaign',
  /** column name */
  UtmContent = 'utmContent',
  /** column name */
  UtmMedium = 'utmMedium',
  /** column name */
  UtmSource = 'utmSource',
  /** column name */
  VenueId = 'venueId'
}

export type PartnerBookingOrdersUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<PartnerBookingOrdersIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PartnerBookingOrdersSetInput>;
  /** filter the rows which have to be updated */
  where: PartnerBookingOrdersBoolExp;
};

/** aggregate varPop on columns */
export type PartnerBookingOrdersVarPopFields = {
  __typename?: 'PartnerBookingOrdersVarPopFields';
  bounceCostUnitAmount?: Maybe<Scalars['Float']>;
  clubPriceUnitAmount?: Maybe<Scalars['Float']>;
  configVersion?: Maybe<Scalars['Float']>;
  maxPriceUnitAmount?: Maybe<Scalars['Float']>;
  orderSubtotalUnitAmount?: Maybe<Scalars['Float']>;
  orderTotalUnitAmount?: Maybe<Scalars['Float']>;
  paidUnitAmount?: Maybe<Scalars['Float']>;
  partnerDiscountPercent?: Maybe<Scalars['Float']>;
  partnerDiscountUnitAmount?: Maybe<Scalars['Float']>;
  playerCount?: Maybe<Scalars['Float']>;
  referralFeeUnitAmount?: Maybe<Scalars['Float']>;
  refundUnitAmount?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type PartnerBookingOrdersVarSampFields = {
  __typename?: 'PartnerBookingOrdersVarSampFields';
  bounceCostUnitAmount?: Maybe<Scalars['Float']>;
  clubPriceUnitAmount?: Maybe<Scalars['Float']>;
  configVersion?: Maybe<Scalars['Float']>;
  maxPriceUnitAmount?: Maybe<Scalars['Float']>;
  orderSubtotalUnitAmount?: Maybe<Scalars['Float']>;
  orderTotalUnitAmount?: Maybe<Scalars['Float']>;
  paidUnitAmount?: Maybe<Scalars['Float']>;
  partnerDiscountPercent?: Maybe<Scalars['Float']>;
  partnerDiscountUnitAmount?: Maybe<Scalars['Float']>;
  playerCount?: Maybe<Scalars['Float']>;
  referralFeeUnitAmount?: Maybe<Scalars['Float']>;
  refundUnitAmount?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type PartnerBookingOrdersVarianceFields = {
  __typename?: 'PartnerBookingOrdersVarianceFields';
  bounceCostUnitAmount?: Maybe<Scalars['Float']>;
  clubPriceUnitAmount?: Maybe<Scalars['Float']>;
  configVersion?: Maybe<Scalars['Float']>;
  maxPriceUnitAmount?: Maybe<Scalars['Float']>;
  orderSubtotalUnitAmount?: Maybe<Scalars['Float']>;
  orderTotalUnitAmount?: Maybe<Scalars['Float']>;
  paidUnitAmount?: Maybe<Scalars['Float']>;
  partnerDiscountPercent?: Maybe<Scalars['Float']>;
  partnerDiscountUnitAmount?: Maybe<Scalars['Float']>;
  playerCount?: Maybe<Scalars['Float']>;
  referralFeeUnitAmount?: Maybe<Scalars['Float']>;
  refundUnitAmount?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "partner_booking_verification_methods" */
export type PartnerBookingVerificationMethods = {
  __typename?: 'PartnerBookingVerificationMethods';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "partner_booking_verification_methods" */
export type PartnerBookingVerificationMethodsAggregate = {
  __typename?: 'PartnerBookingVerificationMethodsAggregate';
  aggregate?: Maybe<PartnerBookingVerificationMethodsAggregateFields>;
  nodes: Array<PartnerBookingVerificationMethods>;
};

/** aggregate fields of "partner_booking_verification_methods" */
export type PartnerBookingVerificationMethodsAggregateFields = {
  __typename?: 'PartnerBookingVerificationMethodsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<PartnerBookingVerificationMethodsMaxFields>;
  min?: Maybe<PartnerBookingVerificationMethodsMinFields>;
};


/** aggregate fields of "partner_booking_verification_methods" */
export type PartnerBookingVerificationMethodsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PartnerBookingVerificationMethodsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "partner_booking_verification_methods". All fields are combined with a logical 'AND'. */
export type PartnerBookingVerificationMethodsBoolExp = {
  _and?: InputMaybe<Array<PartnerBookingVerificationMethodsBoolExp>>;
  _not?: InputMaybe<PartnerBookingVerificationMethodsBoolExp>;
  _or?: InputMaybe<Array<PartnerBookingVerificationMethodsBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "partner_booking_verification_methods" */
export enum PartnerBookingVerificationMethodsConstraint {
  /** unique or primary key constraint on columns "value" */
  PartnerBookingVerificationMethodsPkey = 'partner_booking_verification_methods_pkey'
}

export enum PartnerBookingVerificationMethodsEnum {
  /** Matched against the club's confirmation email */
  ConfirmationEmail = 'CONFIRMATION_EMAIL',
  /** Checked by a person */
  Manual = 'MANUAL',
  /** Looked up through the club system's API */
  PortalApi = 'PORTAL_API'
}

/** Boolean expression to compare columns of type "PartnerBookingVerificationMethodsEnum". All fields are combined with logical 'AND'. */
export type PartnerBookingVerificationMethodsEnumComparisonExp = {
  _eq?: InputMaybe<PartnerBookingVerificationMethodsEnum>;
  _in?: InputMaybe<Array<PartnerBookingVerificationMethodsEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<PartnerBookingVerificationMethodsEnum>;
  _nin?: InputMaybe<Array<PartnerBookingVerificationMethodsEnum>>;
};

/** input type for inserting data into table "partner_booking_verification_methods" */
export type PartnerBookingVerificationMethodsInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type PartnerBookingVerificationMethodsMaxFields = {
  __typename?: 'PartnerBookingVerificationMethodsMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type PartnerBookingVerificationMethodsMinFields = {
  __typename?: 'PartnerBookingVerificationMethodsMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "partner_booking_verification_methods" */
export type PartnerBookingVerificationMethodsMutationResponse = {
  __typename?: 'PartnerBookingVerificationMethodsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PartnerBookingVerificationMethods>;
};

/** on_conflict condition type for table "partner_booking_verification_methods" */
export type PartnerBookingVerificationMethodsOnConflict = {
  constraint: PartnerBookingVerificationMethodsConstraint;
  updateColumns?: Array<PartnerBookingVerificationMethodsUpdateColumn>;
  where?: InputMaybe<PartnerBookingVerificationMethodsBoolExp>;
};

/** Ordering options when selecting data from "partner_booking_verification_methods". */
export type PartnerBookingVerificationMethodsOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: partner_booking_verification_methods */
export type PartnerBookingVerificationMethodsPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "partner_booking_verification_methods" */
export enum PartnerBookingVerificationMethodsSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "partner_booking_verification_methods" */
export type PartnerBookingVerificationMethodsSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "partner_booking_verification_methods" */
export type PartnerBookingVerificationMethodsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PartnerBookingVerificationMethodsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PartnerBookingVerificationMethodsStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "partner_booking_verification_methods" */
export enum PartnerBookingVerificationMethodsUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type PartnerBookingVerificationMethodsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PartnerBookingVerificationMethodsSetInput>;
  /** filter the rows which have to be updated */
  where: PartnerBookingVerificationMethodsBoolExp;
};

/** columns and relationships of "payment_fulfillment_channels" */
export type PaymentFulfillmentChannels = {
  __typename?: 'PaymentFulfillmentChannels';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "payment_fulfillment_channels" */
export type PaymentFulfillmentChannelsAggregate = {
  __typename?: 'PaymentFulfillmentChannelsAggregate';
  aggregate?: Maybe<PaymentFulfillmentChannelsAggregateFields>;
  nodes: Array<PaymentFulfillmentChannels>;
};

/** aggregate fields of "payment_fulfillment_channels" */
export type PaymentFulfillmentChannelsAggregateFields = {
  __typename?: 'PaymentFulfillmentChannelsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<PaymentFulfillmentChannelsMaxFields>;
  min?: Maybe<PaymentFulfillmentChannelsMinFields>;
};


/** aggregate fields of "payment_fulfillment_channels" */
export type PaymentFulfillmentChannelsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PaymentFulfillmentChannelsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "payment_fulfillment_channels". All fields are combined with a logical 'AND'. */
export type PaymentFulfillmentChannelsBoolExp = {
  _and?: InputMaybe<Array<PaymentFulfillmentChannelsBoolExp>>;
  _not?: InputMaybe<PaymentFulfillmentChannelsBoolExp>;
  _or?: InputMaybe<Array<PaymentFulfillmentChannelsBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "payment_fulfillment_channels" */
export enum PaymentFulfillmentChannelsConstraint {
  /** unique or primary key constraint on columns "value" */
  PaymentFulfillmentChannelsPkey = 'payment_fulfillment_channels_pkey'
}

export enum PaymentFulfillmentChannelsEnum {
  OffPlatform = 'OFF_PLATFORM',
  OnPlatform = 'ON_PLATFORM',
  ParticipantsChoice = 'PARTICIPANTS_CHOICE'
}

/** Boolean expression to compare columns of type "PaymentFulfillmentChannelsEnum". All fields are combined with logical 'AND'. */
export type PaymentFulfillmentChannelsEnumComparisonExp = {
  _eq?: InputMaybe<PaymentFulfillmentChannelsEnum>;
  _in?: InputMaybe<Array<PaymentFulfillmentChannelsEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<PaymentFulfillmentChannelsEnum>;
  _nin?: InputMaybe<Array<PaymentFulfillmentChannelsEnum>>;
};

/** input type for inserting data into table "payment_fulfillment_channels" */
export type PaymentFulfillmentChannelsInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type PaymentFulfillmentChannelsMaxFields = {
  __typename?: 'PaymentFulfillmentChannelsMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type PaymentFulfillmentChannelsMinFields = {
  __typename?: 'PaymentFulfillmentChannelsMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "payment_fulfillment_channels" */
export type PaymentFulfillmentChannelsMutationResponse = {
  __typename?: 'PaymentFulfillmentChannelsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PaymentFulfillmentChannels>;
};

/** on_conflict condition type for table "payment_fulfillment_channels" */
export type PaymentFulfillmentChannelsOnConflict = {
  constraint: PaymentFulfillmentChannelsConstraint;
  updateColumns?: Array<PaymentFulfillmentChannelsUpdateColumn>;
  where?: InputMaybe<PaymentFulfillmentChannelsBoolExp>;
};

/** Ordering options when selecting data from "payment_fulfillment_channels". */
export type PaymentFulfillmentChannelsOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: payment_fulfillment_channels */
export type PaymentFulfillmentChannelsPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "payment_fulfillment_channels" */
export enum PaymentFulfillmentChannelsSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "payment_fulfillment_channels" */
export type PaymentFulfillmentChannelsSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "payment_fulfillment_channels" */
export type PaymentFulfillmentChannelsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PaymentFulfillmentChannelsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PaymentFulfillmentChannelsStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "payment_fulfillment_channels" */
export enum PaymentFulfillmentChannelsUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type PaymentFulfillmentChannelsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PaymentFulfillmentChannelsSetInput>;
  /** filter the rows which have to be updated */
  where: PaymentFulfillmentChannelsBoolExp;
};

/** columns and relationships of "payment_processors" */
export type PaymentProcessors = {
  __typename?: 'PaymentProcessors';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "payment_processors" */
export type PaymentProcessorsAggregate = {
  __typename?: 'PaymentProcessorsAggregate';
  aggregate?: Maybe<PaymentProcessorsAggregateFields>;
  nodes: Array<PaymentProcessors>;
};

/** aggregate fields of "payment_processors" */
export type PaymentProcessorsAggregateFields = {
  __typename?: 'PaymentProcessorsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<PaymentProcessorsMaxFields>;
  min?: Maybe<PaymentProcessorsMinFields>;
};


/** aggregate fields of "payment_processors" */
export type PaymentProcessorsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PaymentProcessorsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "payment_processors". All fields are combined with a logical 'AND'. */
export type PaymentProcessorsBoolExp = {
  _and?: InputMaybe<Array<PaymentProcessorsBoolExp>>;
  _not?: InputMaybe<PaymentProcessorsBoolExp>;
  _or?: InputMaybe<Array<PaymentProcessorsBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "payment_processors" */
export enum PaymentProcessorsConstraint {
  /** unique or primary key constraint on columns "value" */
  PaymentProcessorsPkey = 'payment_processors_pkey'
}

export enum PaymentProcessorsEnum {
  Stripe = 'STRIPE'
}

/** Boolean expression to compare columns of type "PaymentProcessorsEnum". All fields are combined with logical 'AND'. */
export type PaymentProcessorsEnumComparisonExp = {
  _eq?: InputMaybe<PaymentProcessorsEnum>;
  _in?: InputMaybe<Array<PaymentProcessorsEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<PaymentProcessorsEnum>;
  _nin?: InputMaybe<Array<PaymentProcessorsEnum>>;
};

/** input type for inserting data into table "payment_processors" */
export type PaymentProcessorsInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type PaymentProcessorsMaxFields = {
  __typename?: 'PaymentProcessorsMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type PaymentProcessorsMinFields = {
  __typename?: 'PaymentProcessorsMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "payment_processors" */
export type PaymentProcessorsMutationResponse = {
  __typename?: 'PaymentProcessorsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PaymentProcessors>;
};

/** on_conflict condition type for table "payment_processors" */
export type PaymentProcessorsOnConflict = {
  constraint: PaymentProcessorsConstraint;
  updateColumns?: Array<PaymentProcessorsUpdateColumn>;
  where?: InputMaybe<PaymentProcessorsBoolExp>;
};

/** Ordering options when selecting data from "payment_processors". */
export type PaymentProcessorsOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: payment_processors */
export type PaymentProcessorsPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "payment_processors" */
export enum PaymentProcessorsSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "payment_processors" */
export type PaymentProcessorsSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "payment_processors" */
export type PaymentProcessorsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PaymentProcessorsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PaymentProcessorsStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "payment_processors" */
export enum PaymentProcessorsUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type PaymentProcessorsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PaymentProcessorsSetInput>;
  /** filter the rows which have to be updated */
  where: PaymentProcessorsBoolExp;
};

/** columns and relationships of "payment_statuses" */
export type PaymentStatuses = {
  __typename?: 'PaymentStatuses';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "payment_statuses" */
export type PaymentStatusesAggregate = {
  __typename?: 'PaymentStatusesAggregate';
  aggregate?: Maybe<PaymentStatusesAggregateFields>;
  nodes: Array<PaymentStatuses>;
};

/** aggregate fields of "payment_statuses" */
export type PaymentStatusesAggregateFields = {
  __typename?: 'PaymentStatusesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<PaymentStatusesMaxFields>;
  min?: Maybe<PaymentStatusesMinFields>;
};


/** aggregate fields of "payment_statuses" */
export type PaymentStatusesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PaymentStatusesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "payment_statuses". All fields are combined with a logical 'AND'. */
export type PaymentStatusesBoolExp = {
  _and?: InputMaybe<Array<PaymentStatusesBoolExp>>;
  _not?: InputMaybe<PaymentStatusesBoolExp>;
  _or?: InputMaybe<Array<PaymentStatusesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "payment_statuses" */
export enum PaymentStatusesConstraint {
  /** unique or primary key constraint on columns "value" */
  PaymentStatusesPkey = 'payment_statuses_pkey'
}

export enum PaymentStatusesEnum {
  Paid = 'PAID',
  Unpaid = 'UNPAID'
}

/** Boolean expression to compare columns of type "PaymentStatusesEnum". All fields are combined with logical 'AND'. */
export type PaymentStatusesEnumComparisonExp = {
  _eq?: InputMaybe<PaymentStatusesEnum>;
  _in?: InputMaybe<Array<PaymentStatusesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<PaymentStatusesEnum>;
  _nin?: InputMaybe<Array<PaymentStatusesEnum>>;
};

/** input type for inserting data into table "payment_statuses" */
export type PaymentStatusesInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type PaymentStatusesMaxFields = {
  __typename?: 'PaymentStatusesMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type PaymentStatusesMinFields = {
  __typename?: 'PaymentStatusesMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "payment_statuses" */
export type PaymentStatusesMutationResponse = {
  __typename?: 'PaymentStatusesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PaymentStatuses>;
};

/** on_conflict condition type for table "payment_statuses" */
export type PaymentStatusesOnConflict = {
  constraint: PaymentStatusesConstraint;
  updateColumns?: Array<PaymentStatusesUpdateColumn>;
  where?: InputMaybe<PaymentStatusesBoolExp>;
};

/** Ordering options when selecting data from "payment_statuses". */
export type PaymentStatusesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: payment_statuses */
export type PaymentStatusesPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "payment_statuses" */
export enum PaymentStatusesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "payment_statuses" */
export type PaymentStatusesSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "payment_statuses" */
export type PaymentStatusesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PaymentStatusesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PaymentStatusesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "payment_statuses" */
export enum PaymentStatusesUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type PaymentStatusesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PaymentStatusesSetInput>;
  /** filter the rows which have to be updated */
  where: PaymentStatusesBoolExp;
};

/** columns and relationships of "pickleball_rating_scales" */
export type PickleballRatingScales = {
  __typename?: 'PickleballRatingScales';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  maximum: Scalars['numeric'];
  minimum: Scalars['numeric'];
  name: Scalars['String'];
  order: Scalars['Int'];
  shortName: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "pickleball_rating_scales" */
export type PickleballRatingScalesAggregate = {
  __typename?: 'PickleballRatingScalesAggregate';
  aggregate?: Maybe<PickleballRatingScalesAggregateFields>;
  nodes: Array<PickleballRatingScales>;
};

/** aggregate fields of "pickleball_rating_scales" */
export type PickleballRatingScalesAggregateFields = {
  __typename?: 'PickleballRatingScalesAggregateFields';
  avg?: Maybe<PickleballRatingScalesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<PickleballRatingScalesMaxFields>;
  min?: Maybe<PickleballRatingScalesMinFields>;
  stddev?: Maybe<PickleballRatingScalesStddevFields>;
  stddevPop?: Maybe<PickleballRatingScalesStddevPopFields>;
  stddevSamp?: Maybe<PickleballRatingScalesStddevSampFields>;
  sum?: Maybe<PickleballRatingScalesSumFields>;
  varPop?: Maybe<PickleballRatingScalesVarPopFields>;
  varSamp?: Maybe<PickleballRatingScalesVarSampFields>;
  variance?: Maybe<PickleballRatingScalesVarianceFields>;
};


/** aggregate fields of "pickleball_rating_scales" */
export type PickleballRatingScalesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PickleballRatingScalesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type PickleballRatingScalesAvgFields = {
  __typename?: 'PickleballRatingScalesAvgFields';
  maximum?: Maybe<Scalars['Float']>;
  minimum?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "pickleball_rating_scales". All fields are combined with a logical 'AND'. */
export type PickleballRatingScalesBoolExp = {
  _and?: InputMaybe<Array<PickleballRatingScalesBoolExp>>;
  _not?: InputMaybe<PickleballRatingScalesBoolExp>;
  _or?: InputMaybe<Array<PickleballRatingScalesBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  maximum?: InputMaybe<NumericComparisonExp>;
  minimum?: InputMaybe<NumericComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  order?: InputMaybe<IntComparisonExp>;
  shortName?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "pickleball_rating_scales" */
export enum PickleballRatingScalesConstraint {
  /** unique or primary key constraint on columns "id" */
  PickleballRatingScalesPkey = 'pickleball_rating_scales_pkey'
}

/** input type for incrementing numeric columns in table "pickleball_rating_scales" */
export type PickleballRatingScalesIncInput = {
  maximum?: InputMaybe<Scalars['numeric']>;
  minimum?: InputMaybe<Scalars['numeric']>;
  order?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "pickleball_rating_scales" */
export type PickleballRatingScalesInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  maximum?: InputMaybe<Scalars['numeric']>;
  minimum?: InputMaybe<Scalars['numeric']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  shortName?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type PickleballRatingScalesMaxFields = {
  __typename?: 'PickleballRatingScalesMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  maximum?: Maybe<Scalars['numeric']>;
  minimum?: Maybe<Scalars['numeric']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  shortName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type PickleballRatingScalesMinFields = {
  __typename?: 'PickleballRatingScalesMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  maximum?: Maybe<Scalars['numeric']>;
  minimum?: Maybe<Scalars['numeric']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  shortName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "pickleball_rating_scales" */
export type PickleballRatingScalesMutationResponse = {
  __typename?: 'PickleballRatingScalesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PickleballRatingScales>;
};

/** input type for inserting object relation for remote table "pickleball_rating_scales" */
export type PickleballRatingScalesObjRelInsertInput = {
  data: PickleballRatingScalesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<PickleballRatingScalesOnConflict>;
};

/** on_conflict condition type for table "pickleball_rating_scales" */
export type PickleballRatingScalesOnConflict = {
  constraint: PickleballRatingScalesConstraint;
  updateColumns?: Array<PickleballRatingScalesUpdateColumn>;
  where?: InputMaybe<PickleballRatingScalesBoolExp>;
};

/** Ordering options when selecting data from "pickleball_rating_scales". */
export type PickleballRatingScalesOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  maximum?: InputMaybe<OrderBy>;
  minimum?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  order?: InputMaybe<OrderBy>;
  shortName?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: pickleball_rating_scales */
export type PickleballRatingScalesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "pickleball_rating_scales" */
export enum PickleballRatingScalesSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  Maximum = 'maximum',
  /** column name */
  Minimum = 'minimum',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  ShortName = 'shortName',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "pickleball_rating_scales" */
export type PickleballRatingScalesSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  maximum?: InputMaybe<Scalars['numeric']>;
  minimum?: InputMaybe<Scalars['numeric']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  shortName?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type PickleballRatingScalesStddevFields = {
  __typename?: 'PickleballRatingScalesStddevFields';
  maximum?: Maybe<Scalars['Float']>;
  minimum?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type PickleballRatingScalesStddevPopFields = {
  __typename?: 'PickleballRatingScalesStddevPopFields';
  maximum?: Maybe<Scalars['Float']>;
  minimum?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type PickleballRatingScalesStddevSampFields = {
  __typename?: 'PickleballRatingScalesStddevSampFields';
  maximum?: Maybe<Scalars['Float']>;
  minimum?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "pickleball_rating_scales" */
export type PickleballRatingScalesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PickleballRatingScalesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PickleballRatingScalesStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  maximum?: InputMaybe<Scalars['numeric']>;
  minimum?: InputMaybe<Scalars['numeric']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  shortName?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type PickleballRatingScalesSumFields = {
  __typename?: 'PickleballRatingScalesSumFields';
  maximum?: Maybe<Scalars['numeric']>;
  minimum?: Maybe<Scalars['numeric']>;
  order?: Maybe<Scalars['Int']>;
};

/** update columns of table "pickleball_rating_scales" */
export enum PickleballRatingScalesUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  Maximum = 'maximum',
  /** column name */
  Minimum = 'minimum',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  ShortName = 'shortName',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type PickleballRatingScalesUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<PickleballRatingScalesIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PickleballRatingScalesSetInput>;
  /** filter the rows which have to be updated */
  where: PickleballRatingScalesBoolExp;
};

/** aggregate varPop on columns */
export type PickleballRatingScalesVarPopFields = {
  __typename?: 'PickleballRatingScalesVarPopFields';
  maximum?: Maybe<Scalars['Float']>;
  minimum?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type PickleballRatingScalesVarSampFields = {
  __typename?: 'PickleballRatingScalesVarSampFields';
  maximum?: Maybe<Scalars['Float']>;
  minimum?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type PickleballRatingScalesVarianceFields = {
  __typename?: 'PickleballRatingScalesVarianceFields';
  maximum?: Maybe<Scalars['Float']>;
  minimum?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "platform_subscription_intervals" */
export type PlatformSubscriptionIntervals = {
  __typename?: 'PlatformSubscriptionIntervals';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "platform_subscription_intervals" */
export type PlatformSubscriptionIntervalsAggregate = {
  __typename?: 'PlatformSubscriptionIntervalsAggregate';
  aggregate?: Maybe<PlatformSubscriptionIntervalsAggregateFields>;
  nodes: Array<PlatformSubscriptionIntervals>;
};

/** aggregate fields of "platform_subscription_intervals" */
export type PlatformSubscriptionIntervalsAggregateFields = {
  __typename?: 'PlatformSubscriptionIntervalsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<PlatformSubscriptionIntervalsMaxFields>;
  min?: Maybe<PlatformSubscriptionIntervalsMinFields>;
};


/** aggregate fields of "platform_subscription_intervals" */
export type PlatformSubscriptionIntervalsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PlatformSubscriptionIntervalsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "platform_subscription_intervals". All fields are combined with a logical 'AND'. */
export type PlatformSubscriptionIntervalsBoolExp = {
  _and?: InputMaybe<Array<PlatformSubscriptionIntervalsBoolExp>>;
  _not?: InputMaybe<PlatformSubscriptionIntervalsBoolExp>;
  _or?: InputMaybe<Array<PlatformSubscriptionIntervalsBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "platform_subscription_intervals" */
export enum PlatformSubscriptionIntervalsConstraint {
  /** unique or primary key constraint on columns "value" */
  PlatformSubscriptionIntervalsPkey = 'platform_subscription_intervals_pkey'
}

export enum PlatformSubscriptionIntervalsEnum {
  Month = 'MONTH',
  Quarter = 'QUARTER',
  Year = 'YEAR'
}

/** Boolean expression to compare columns of type "PlatformSubscriptionIntervalsEnum". All fields are combined with logical 'AND'. */
export type PlatformSubscriptionIntervalsEnumComparisonExp = {
  _eq?: InputMaybe<PlatformSubscriptionIntervalsEnum>;
  _in?: InputMaybe<Array<PlatformSubscriptionIntervalsEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<PlatformSubscriptionIntervalsEnum>;
  _nin?: InputMaybe<Array<PlatformSubscriptionIntervalsEnum>>;
};

/** input type for inserting data into table "platform_subscription_intervals" */
export type PlatformSubscriptionIntervalsInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type PlatformSubscriptionIntervalsMaxFields = {
  __typename?: 'PlatformSubscriptionIntervalsMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type PlatformSubscriptionIntervalsMinFields = {
  __typename?: 'PlatformSubscriptionIntervalsMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "platform_subscription_intervals" */
export type PlatformSubscriptionIntervalsMutationResponse = {
  __typename?: 'PlatformSubscriptionIntervalsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PlatformSubscriptionIntervals>;
};

/** on_conflict condition type for table "platform_subscription_intervals" */
export type PlatformSubscriptionIntervalsOnConflict = {
  constraint: PlatformSubscriptionIntervalsConstraint;
  updateColumns?: Array<PlatformSubscriptionIntervalsUpdateColumn>;
  where?: InputMaybe<PlatformSubscriptionIntervalsBoolExp>;
};

/** Ordering options when selecting data from "platform_subscription_intervals". */
export type PlatformSubscriptionIntervalsOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: platform_subscription_intervals */
export type PlatformSubscriptionIntervalsPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "platform_subscription_intervals" */
export enum PlatformSubscriptionIntervalsSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "platform_subscription_intervals" */
export type PlatformSubscriptionIntervalsSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "platform_subscription_intervals" */
export type PlatformSubscriptionIntervalsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PlatformSubscriptionIntervalsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PlatformSubscriptionIntervalsStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "platform_subscription_intervals" */
export enum PlatformSubscriptionIntervalsUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type PlatformSubscriptionIntervalsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PlatformSubscriptionIntervalsSetInput>;
  /** filter the rows which have to be updated */
  where: PlatformSubscriptionIntervalsBoolExp;
};

/** columns and relationships of "platform_subscription_personas" */
export type PlatformSubscriptionPersonas = {
  __typename?: 'PlatformSubscriptionPersonas';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "platform_subscription_personas" */
export type PlatformSubscriptionPersonasAggregate = {
  __typename?: 'PlatformSubscriptionPersonasAggregate';
  aggregate?: Maybe<PlatformSubscriptionPersonasAggregateFields>;
  nodes: Array<PlatformSubscriptionPersonas>;
};

/** aggregate fields of "platform_subscription_personas" */
export type PlatformSubscriptionPersonasAggregateFields = {
  __typename?: 'PlatformSubscriptionPersonasAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<PlatformSubscriptionPersonasMaxFields>;
  min?: Maybe<PlatformSubscriptionPersonasMinFields>;
};


/** aggregate fields of "platform_subscription_personas" */
export type PlatformSubscriptionPersonasAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PlatformSubscriptionPersonasSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "platform_subscription_personas". All fields are combined with a logical 'AND'. */
export type PlatformSubscriptionPersonasBoolExp = {
  _and?: InputMaybe<Array<PlatformSubscriptionPersonasBoolExp>>;
  _not?: InputMaybe<PlatformSubscriptionPersonasBoolExp>;
  _or?: InputMaybe<Array<PlatformSubscriptionPersonasBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "platform_subscription_personas" */
export enum PlatformSubscriptionPersonasConstraint {
  /** unique or primary key constraint on columns "value" */
  PlatformSubscriptionPersonasPkey = 'platform_subscription_personas_pkey'
}

export enum PlatformSubscriptionPersonasEnum {
  Coach = 'COACH',
  Player = 'PLAYER'
}

/** Boolean expression to compare columns of type "PlatformSubscriptionPersonasEnum". All fields are combined with logical 'AND'. */
export type PlatformSubscriptionPersonasEnumComparisonExp = {
  _eq?: InputMaybe<PlatformSubscriptionPersonasEnum>;
  _in?: InputMaybe<Array<PlatformSubscriptionPersonasEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<PlatformSubscriptionPersonasEnum>;
  _nin?: InputMaybe<Array<PlatformSubscriptionPersonasEnum>>;
};

/** input type for inserting data into table "platform_subscription_personas" */
export type PlatformSubscriptionPersonasInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type PlatformSubscriptionPersonasMaxFields = {
  __typename?: 'PlatformSubscriptionPersonasMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type PlatformSubscriptionPersonasMinFields = {
  __typename?: 'PlatformSubscriptionPersonasMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "platform_subscription_personas" */
export type PlatformSubscriptionPersonasMutationResponse = {
  __typename?: 'PlatformSubscriptionPersonasMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PlatformSubscriptionPersonas>;
};

/** on_conflict condition type for table "platform_subscription_personas" */
export type PlatformSubscriptionPersonasOnConflict = {
  constraint: PlatformSubscriptionPersonasConstraint;
  updateColumns?: Array<PlatformSubscriptionPersonasUpdateColumn>;
  where?: InputMaybe<PlatformSubscriptionPersonasBoolExp>;
};

/** Ordering options when selecting data from "platform_subscription_personas". */
export type PlatformSubscriptionPersonasOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: platform_subscription_personas */
export type PlatformSubscriptionPersonasPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "platform_subscription_personas" */
export enum PlatformSubscriptionPersonasSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "platform_subscription_personas" */
export type PlatformSubscriptionPersonasSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "platform_subscription_personas" */
export type PlatformSubscriptionPersonasStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PlatformSubscriptionPersonasStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PlatformSubscriptionPersonasStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "platform_subscription_personas" */
export enum PlatformSubscriptionPersonasUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type PlatformSubscriptionPersonasUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PlatformSubscriptionPersonasSetInput>;
  /** filter the rows which have to be updated */
  where: PlatformSubscriptionPersonasBoolExp;
};

/** columns and relationships of "platform_subscription_plan_prices" */
export type PlatformSubscriptionPlanPrices = {
  __typename?: 'PlatformSubscriptionPlanPrices';
  archivedAt?: Maybe<Scalars['timestamptz']>;
  createdAt: Scalars['timestamptz'];
  currency: Scalars['String'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  interval: PlatformSubscriptionIntervalsEnum;
  persona: PlatformSubscriptionPersonasEnum;
  /** An object relationship */
  plan: PlatformSubscriptionPlans;
  platformSubscriptionPlanId: Scalars['uuid'];
  priceUnitAmount: Scalars['Int'];
  stripePriceId: Scalars['String'];
  /** An array relationship */
  subscriptions: Array<PlatformSubscriptions>;
  /** An aggregate relationship */
  subscriptionsAggregate: PlatformSubscriptionsAggregate;
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "platform_subscription_plan_prices" */
export type PlatformSubscriptionPlanPricesSubscriptionsArgs = {
  distinctOn?: InputMaybe<Array<PlatformSubscriptionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlatformSubscriptionsOrderBy>>;
  where?: InputMaybe<PlatformSubscriptionsBoolExp>;
};


/** columns and relationships of "platform_subscription_plan_prices" */
export type PlatformSubscriptionPlanPricesSubscriptionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PlatformSubscriptionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlatformSubscriptionsOrderBy>>;
  where?: InputMaybe<PlatformSubscriptionsBoolExp>;
};

/** aggregated selection of "platform_subscription_plan_prices" */
export type PlatformSubscriptionPlanPricesAggregate = {
  __typename?: 'PlatformSubscriptionPlanPricesAggregate';
  aggregate?: Maybe<PlatformSubscriptionPlanPricesAggregateFields>;
  nodes: Array<PlatformSubscriptionPlanPrices>;
};

export type PlatformSubscriptionPlanPricesAggregateBoolExp = {
  count?: InputMaybe<PlatformSubscriptionPlanPricesAggregateBoolExpCount>;
};

/** aggregate fields of "platform_subscription_plan_prices" */
export type PlatformSubscriptionPlanPricesAggregateFields = {
  __typename?: 'PlatformSubscriptionPlanPricesAggregateFields';
  avg?: Maybe<PlatformSubscriptionPlanPricesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<PlatformSubscriptionPlanPricesMaxFields>;
  min?: Maybe<PlatformSubscriptionPlanPricesMinFields>;
  stddev?: Maybe<PlatformSubscriptionPlanPricesStddevFields>;
  stddevPop?: Maybe<PlatformSubscriptionPlanPricesStddevPopFields>;
  stddevSamp?: Maybe<PlatformSubscriptionPlanPricesStddevSampFields>;
  sum?: Maybe<PlatformSubscriptionPlanPricesSumFields>;
  varPop?: Maybe<PlatformSubscriptionPlanPricesVarPopFields>;
  varSamp?: Maybe<PlatformSubscriptionPlanPricesVarSampFields>;
  variance?: Maybe<PlatformSubscriptionPlanPricesVarianceFields>;
};


/** aggregate fields of "platform_subscription_plan_prices" */
export type PlatformSubscriptionPlanPricesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PlatformSubscriptionPlanPricesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "platform_subscription_plan_prices" */
export type PlatformSubscriptionPlanPricesAggregateOrderBy = {
  avg?: InputMaybe<PlatformSubscriptionPlanPricesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<PlatformSubscriptionPlanPricesMaxOrderBy>;
  min?: InputMaybe<PlatformSubscriptionPlanPricesMinOrderBy>;
  stddev?: InputMaybe<PlatformSubscriptionPlanPricesStddevOrderBy>;
  stddevPop?: InputMaybe<PlatformSubscriptionPlanPricesStddevPopOrderBy>;
  stddevSamp?: InputMaybe<PlatformSubscriptionPlanPricesStddevSampOrderBy>;
  sum?: InputMaybe<PlatformSubscriptionPlanPricesSumOrderBy>;
  varPop?: InputMaybe<PlatformSubscriptionPlanPricesVarPopOrderBy>;
  varSamp?: InputMaybe<PlatformSubscriptionPlanPricesVarSampOrderBy>;
  variance?: InputMaybe<PlatformSubscriptionPlanPricesVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "platform_subscription_plan_prices" */
export type PlatformSubscriptionPlanPricesArrRelInsertInput = {
  data: Array<PlatformSubscriptionPlanPricesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<PlatformSubscriptionPlanPricesOnConflict>;
};

/** aggregate avg on columns */
export type PlatformSubscriptionPlanPricesAvgFields = {
  __typename?: 'PlatformSubscriptionPlanPricesAvgFields';
  priceUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "platform_subscription_plan_prices" */
export type PlatformSubscriptionPlanPricesAvgOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "platform_subscription_plan_prices". All fields are combined with a logical 'AND'. */
export type PlatformSubscriptionPlanPricesBoolExp = {
  _and?: InputMaybe<Array<PlatformSubscriptionPlanPricesBoolExp>>;
  _not?: InputMaybe<PlatformSubscriptionPlanPricesBoolExp>;
  _or?: InputMaybe<Array<PlatformSubscriptionPlanPricesBoolExp>>;
  archivedAt?: InputMaybe<TimestamptzComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  currency?: InputMaybe<StringComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  interval?: InputMaybe<PlatformSubscriptionIntervalsEnumComparisonExp>;
  persona?: InputMaybe<PlatformSubscriptionPersonasEnumComparisonExp>;
  plan?: InputMaybe<PlatformSubscriptionPlansBoolExp>;
  platformSubscriptionPlanId?: InputMaybe<UuidComparisonExp>;
  priceUnitAmount?: InputMaybe<IntComparisonExp>;
  stripePriceId?: InputMaybe<StringComparisonExp>;
  subscriptions?: InputMaybe<PlatformSubscriptionsBoolExp>;
  subscriptionsAggregate?: InputMaybe<PlatformSubscriptionsAggregateBoolExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "platform_subscription_plan_prices" */
export enum PlatformSubscriptionPlanPricesConstraint {
  /** unique or primary key constraint on columns "id" */
  PlatformSubscriptionPlanPricesPkey = 'platform_subscription_plan_prices_pkey',
  /** unique or primary key constraint on columns "stripe_price_id" */
  PlatformSubscriptionPlanPricesStripePriceIdKey = 'platform_subscription_plan_prices_stripe_price_id_key'
}

/** input type for incrementing numeric columns in table "platform_subscription_plan_prices" */
export type PlatformSubscriptionPlanPricesIncInput = {
  priceUnitAmount?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "platform_subscription_plan_prices" */
export type PlatformSubscriptionPlanPricesInsertInput = {
  archivedAt?: InputMaybe<Scalars['timestamptz']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  interval?: InputMaybe<PlatformSubscriptionIntervalsEnum>;
  persona?: InputMaybe<PlatformSubscriptionPersonasEnum>;
  plan?: InputMaybe<PlatformSubscriptionPlansObjRelInsertInput>;
  platformSubscriptionPlanId?: InputMaybe<Scalars['uuid']>;
  priceUnitAmount?: InputMaybe<Scalars['Int']>;
  stripePriceId?: InputMaybe<Scalars['String']>;
  subscriptions?: InputMaybe<PlatformSubscriptionsArrRelInsertInput>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type PlatformSubscriptionPlanPricesMaxFields = {
  __typename?: 'PlatformSubscriptionPlanPricesMaxFields';
  archivedAt?: Maybe<Scalars['timestamptz']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  platformSubscriptionPlanId?: Maybe<Scalars['uuid']>;
  priceUnitAmount?: Maybe<Scalars['Int']>;
  stripePriceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "platform_subscription_plan_prices" */
export type PlatformSubscriptionPlanPricesMaxOrderBy = {
  archivedAt?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  currency?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  platformSubscriptionPlanId?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  stripePriceId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type PlatformSubscriptionPlanPricesMinFields = {
  __typename?: 'PlatformSubscriptionPlanPricesMinFields';
  archivedAt?: Maybe<Scalars['timestamptz']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  platformSubscriptionPlanId?: Maybe<Scalars['uuid']>;
  priceUnitAmount?: Maybe<Scalars['Int']>;
  stripePriceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "platform_subscription_plan_prices" */
export type PlatformSubscriptionPlanPricesMinOrderBy = {
  archivedAt?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  currency?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  platformSubscriptionPlanId?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  stripePriceId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "platform_subscription_plan_prices" */
export type PlatformSubscriptionPlanPricesMutationResponse = {
  __typename?: 'PlatformSubscriptionPlanPricesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PlatformSubscriptionPlanPrices>;
};

/** input type for inserting object relation for remote table "platform_subscription_plan_prices" */
export type PlatformSubscriptionPlanPricesObjRelInsertInput = {
  data: PlatformSubscriptionPlanPricesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<PlatformSubscriptionPlanPricesOnConflict>;
};

/** on_conflict condition type for table "platform_subscription_plan_prices" */
export type PlatformSubscriptionPlanPricesOnConflict = {
  constraint: PlatformSubscriptionPlanPricesConstraint;
  updateColumns?: Array<PlatformSubscriptionPlanPricesUpdateColumn>;
  where?: InputMaybe<PlatformSubscriptionPlanPricesBoolExp>;
};

/** Ordering options when selecting data from "platform_subscription_plan_prices". */
export type PlatformSubscriptionPlanPricesOrderBy = {
  archivedAt?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  currency?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  interval?: InputMaybe<OrderBy>;
  persona?: InputMaybe<OrderBy>;
  plan?: InputMaybe<PlatformSubscriptionPlansOrderBy>;
  platformSubscriptionPlanId?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  stripePriceId?: InputMaybe<OrderBy>;
  subscriptionsAggregate?: InputMaybe<PlatformSubscriptionsAggregateOrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: platform_subscription_plan_prices */
export type PlatformSubscriptionPlanPricesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "platform_subscription_plan_prices" */
export enum PlatformSubscriptionPlanPricesSelectColumn {
  /** column name */
  ArchivedAt = 'archivedAt',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Currency = 'currency',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  Interval = 'interval',
  /** column name */
  Persona = 'persona',
  /** column name */
  PlatformSubscriptionPlanId = 'platformSubscriptionPlanId',
  /** column name */
  PriceUnitAmount = 'priceUnitAmount',
  /** column name */
  StripePriceId = 'stripePriceId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "platform_subscription_plan_prices" */
export type PlatformSubscriptionPlanPricesSetInput = {
  archivedAt?: InputMaybe<Scalars['timestamptz']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  interval?: InputMaybe<PlatformSubscriptionIntervalsEnum>;
  persona?: InputMaybe<PlatformSubscriptionPersonasEnum>;
  platformSubscriptionPlanId?: InputMaybe<Scalars['uuid']>;
  priceUnitAmount?: InputMaybe<Scalars['Int']>;
  stripePriceId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type PlatformSubscriptionPlanPricesStddevFields = {
  __typename?: 'PlatformSubscriptionPlanPricesStddevFields';
  priceUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "platform_subscription_plan_prices" */
export type PlatformSubscriptionPlanPricesStddevOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type PlatformSubscriptionPlanPricesStddevPopFields = {
  __typename?: 'PlatformSubscriptionPlanPricesStddevPopFields';
  priceUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "platform_subscription_plan_prices" */
export type PlatformSubscriptionPlanPricesStddevPopOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type PlatformSubscriptionPlanPricesStddevSampFields = {
  __typename?: 'PlatformSubscriptionPlanPricesStddevSampFields';
  priceUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "platform_subscription_plan_prices" */
export type PlatformSubscriptionPlanPricesStddevSampOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "platform_subscription_plan_prices" */
export type PlatformSubscriptionPlanPricesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PlatformSubscriptionPlanPricesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PlatformSubscriptionPlanPricesStreamCursorValueInput = {
  archivedAt?: InputMaybe<Scalars['timestamptz']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  interval?: InputMaybe<PlatformSubscriptionIntervalsEnum>;
  persona?: InputMaybe<PlatformSubscriptionPersonasEnum>;
  platformSubscriptionPlanId?: InputMaybe<Scalars['uuid']>;
  priceUnitAmount?: InputMaybe<Scalars['Int']>;
  stripePriceId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type PlatformSubscriptionPlanPricesSumFields = {
  __typename?: 'PlatformSubscriptionPlanPricesSumFields';
  priceUnitAmount?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "platform_subscription_plan_prices" */
export type PlatformSubscriptionPlanPricesSumOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
};

/** update columns of table "platform_subscription_plan_prices" */
export enum PlatformSubscriptionPlanPricesUpdateColumn {
  /** column name */
  ArchivedAt = 'archivedAt',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Currency = 'currency',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  Interval = 'interval',
  /** column name */
  Persona = 'persona',
  /** column name */
  PlatformSubscriptionPlanId = 'platformSubscriptionPlanId',
  /** column name */
  PriceUnitAmount = 'priceUnitAmount',
  /** column name */
  StripePriceId = 'stripePriceId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type PlatformSubscriptionPlanPricesUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<PlatformSubscriptionPlanPricesIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PlatformSubscriptionPlanPricesSetInput>;
  /** filter the rows which have to be updated */
  where: PlatformSubscriptionPlanPricesBoolExp;
};

/** aggregate varPop on columns */
export type PlatformSubscriptionPlanPricesVarPopFields = {
  __typename?: 'PlatformSubscriptionPlanPricesVarPopFields';
  priceUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "platform_subscription_plan_prices" */
export type PlatformSubscriptionPlanPricesVarPopOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type PlatformSubscriptionPlanPricesVarSampFields = {
  __typename?: 'PlatformSubscriptionPlanPricesVarSampFields';
  priceUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "platform_subscription_plan_prices" */
export type PlatformSubscriptionPlanPricesVarSampOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type PlatformSubscriptionPlanPricesVarianceFields = {
  __typename?: 'PlatformSubscriptionPlanPricesVarianceFields';
  priceUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "platform_subscription_plan_prices" */
export type PlatformSubscriptionPlanPricesVarianceOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
};

/** columns and relationships of "platform_subscription_plans" */
export type PlatformSubscriptionPlans = {
  __typename?: 'PlatformSubscriptionPlans';
  archivedAt?: Maybe<Scalars['timestamptz']>;
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  description: Scalars['String'];
  id: Scalars['uuid'];
  name: Scalars['String'];
  /** An array relationship */
  prices: Array<PlatformSubscriptionPlanPrices>;
  /** An aggregate relationship */
  pricesAggregate: PlatformSubscriptionPlanPricesAggregate;
  stripeProductId: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "platform_subscription_plans" */
export type PlatformSubscriptionPlansPricesArgs = {
  distinctOn?: InputMaybe<Array<PlatformSubscriptionPlanPricesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlatformSubscriptionPlanPricesOrderBy>>;
  where?: InputMaybe<PlatformSubscriptionPlanPricesBoolExp>;
};


/** columns and relationships of "platform_subscription_plans" */
export type PlatformSubscriptionPlansPricesAggregateArgs = {
  distinctOn?: InputMaybe<Array<PlatformSubscriptionPlanPricesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlatformSubscriptionPlanPricesOrderBy>>;
  where?: InputMaybe<PlatformSubscriptionPlanPricesBoolExp>;
};

/** aggregated selection of "platform_subscription_plans" */
export type PlatformSubscriptionPlansAggregate = {
  __typename?: 'PlatformSubscriptionPlansAggregate';
  aggregate?: Maybe<PlatformSubscriptionPlansAggregateFields>;
  nodes: Array<PlatformSubscriptionPlans>;
};

/** aggregate fields of "platform_subscription_plans" */
export type PlatformSubscriptionPlansAggregateFields = {
  __typename?: 'PlatformSubscriptionPlansAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<PlatformSubscriptionPlansMaxFields>;
  min?: Maybe<PlatformSubscriptionPlansMinFields>;
};


/** aggregate fields of "platform_subscription_plans" */
export type PlatformSubscriptionPlansAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PlatformSubscriptionPlansSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "platform_subscription_plans". All fields are combined with a logical 'AND'. */
export type PlatformSubscriptionPlansBoolExp = {
  _and?: InputMaybe<Array<PlatformSubscriptionPlansBoolExp>>;
  _not?: InputMaybe<PlatformSubscriptionPlansBoolExp>;
  _or?: InputMaybe<Array<PlatformSubscriptionPlansBoolExp>>;
  archivedAt?: InputMaybe<TimestamptzComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  prices?: InputMaybe<PlatformSubscriptionPlanPricesBoolExp>;
  pricesAggregate?: InputMaybe<PlatformSubscriptionPlanPricesAggregateBoolExp>;
  stripeProductId?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "platform_subscription_plans" */
export enum PlatformSubscriptionPlansConstraint {
  /** unique or primary key constraint on columns "id" */
  PlatformSubscriptionPlansPkey = 'platform_subscription_plans_pkey',
  /** unique or primary key constraint on columns "stripe_product_id" */
  PlatformSubscriptionPlansStripeProductIdKey = 'platform_subscription_plans_stripe_product_id_key'
}

/** input type for inserting data into table "platform_subscription_plans" */
export type PlatformSubscriptionPlansInsertInput = {
  archivedAt?: InputMaybe<Scalars['timestamptz']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  prices?: InputMaybe<PlatformSubscriptionPlanPricesArrRelInsertInput>;
  stripeProductId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type PlatformSubscriptionPlansMaxFields = {
  __typename?: 'PlatformSubscriptionPlansMaxFields';
  archivedAt?: Maybe<Scalars['timestamptz']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  stripeProductId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type PlatformSubscriptionPlansMinFields = {
  __typename?: 'PlatformSubscriptionPlansMinFields';
  archivedAt?: Maybe<Scalars['timestamptz']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  stripeProductId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "platform_subscription_plans" */
export type PlatformSubscriptionPlansMutationResponse = {
  __typename?: 'PlatformSubscriptionPlansMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PlatformSubscriptionPlans>;
};

/** input type for inserting object relation for remote table "platform_subscription_plans" */
export type PlatformSubscriptionPlansObjRelInsertInput = {
  data: PlatformSubscriptionPlansInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<PlatformSubscriptionPlansOnConflict>;
};

/** on_conflict condition type for table "platform_subscription_plans" */
export type PlatformSubscriptionPlansOnConflict = {
  constraint: PlatformSubscriptionPlansConstraint;
  updateColumns?: Array<PlatformSubscriptionPlansUpdateColumn>;
  where?: InputMaybe<PlatformSubscriptionPlansBoolExp>;
};

/** Ordering options when selecting data from "platform_subscription_plans". */
export type PlatformSubscriptionPlansOrderBy = {
  archivedAt?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  pricesAggregate?: InputMaybe<PlatformSubscriptionPlanPricesAggregateOrderBy>;
  stripeProductId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: platform_subscription_plans */
export type PlatformSubscriptionPlansPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "platform_subscription_plans" */
export enum PlatformSubscriptionPlansSelectColumn {
  /** column name */
  ArchivedAt = 'archivedAt',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  StripeProductId = 'stripeProductId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "platform_subscription_plans" */
export type PlatformSubscriptionPlansSetInput = {
  archivedAt?: InputMaybe<Scalars['timestamptz']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  stripeProductId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "platform_subscription_plans" */
export type PlatformSubscriptionPlansStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PlatformSubscriptionPlansStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PlatformSubscriptionPlansStreamCursorValueInput = {
  archivedAt?: InputMaybe<Scalars['timestamptz']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  stripeProductId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "platform_subscription_plans" */
export enum PlatformSubscriptionPlansUpdateColumn {
  /** column name */
  ArchivedAt = 'archivedAt',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  StripeProductId = 'stripeProductId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type PlatformSubscriptionPlansUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PlatformSubscriptionPlansSetInput>;
  /** filter the rows which have to be updated */
  where: PlatformSubscriptionPlansBoolExp;
};

/** columns and relationships of "platform_subscriptions" */
export type PlatformSubscriptions = {
  __typename?: 'PlatformSubscriptions';
  cancelAtPeriodEnd?: Maybe<Scalars['Boolean']>;
  canceledAt?: Maybe<Scalars['timestamptz']>;
  createdAt: Scalars['timestamptz'];
  currentPeriodEndAt?: Maybe<Scalars['timestamptz']>;
  currentPeriodStartAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  endedAt?: Maybe<Scalars['timestamptz']>;
  externalSubscriptionId: Scalars['String'];
  externalSubscriptionProvider: PaymentProcessorsEnum;
  id: Scalars['uuid'];
  /** An array relationship */
  invoices: Array<Invoices>;
  /** An aggregate relationship */
  invoicesAggregate: InvoicesAggregate;
  /** An object relationship */
  planPrice: PlatformSubscriptionPlanPrices;
  platformSubscriptionPlanPriceId: Scalars['uuid'];
  /** An array relationship */
  sales: Array<Sales>;
  /** An aggregate relationship */
  salesAggregate: SalesAggregate;
  startDate?: Maybe<Scalars['timestamptz']>;
  status: SubscriptionStatusesEnum;
  statusChangedAt: Scalars['timestamptz'];
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePriceId?: Maybe<Scalars['String']>;
  stripeProductId?: Maybe<Scalars['String']>;
  stripeStatus?: Maybe<Scalars['String']>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  trialEndAt?: Maybe<Scalars['timestamptz']>;
  trialStartAt?: Maybe<Scalars['timestamptz']>;
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid'];
};


/** columns and relationships of "platform_subscriptions" */
export type PlatformSubscriptionsInvoicesArgs = {
  distinctOn?: InputMaybe<Array<InvoicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoicesOrderBy>>;
  where?: InputMaybe<InvoicesBoolExp>;
};


/** columns and relationships of "platform_subscriptions" */
export type PlatformSubscriptionsInvoicesAggregateArgs = {
  distinctOn?: InputMaybe<Array<InvoicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoicesOrderBy>>;
  where?: InputMaybe<InvoicesBoolExp>;
};


/** columns and relationships of "platform_subscriptions" */
export type PlatformSubscriptionsSalesArgs = {
  distinctOn?: InputMaybe<Array<SalesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SalesOrderBy>>;
  where?: InputMaybe<SalesBoolExp>;
};


/** columns and relationships of "platform_subscriptions" */
export type PlatformSubscriptionsSalesAggregateArgs = {
  distinctOn?: InputMaybe<Array<SalesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SalesOrderBy>>;
  where?: InputMaybe<SalesBoolExp>;
};

/** aggregated selection of "platform_subscriptions" */
export type PlatformSubscriptionsAggregate = {
  __typename?: 'PlatformSubscriptionsAggregate';
  aggregate?: Maybe<PlatformSubscriptionsAggregateFields>;
  nodes: Array<PlatformSubscriptions>;
};

export type PlatformSubscriptionsAggregateBoolExp = {
  bool_and?: InputMaybe<PlatformSubscriptionsAggregateBoolExpBool_And>;
  bool_or?: InputMaybe<PlatformSubscriptionsAggregateBoolExpBool_Or>;
  count?: InputMaybe<PlatformSubscriptionsAggregateBoolExpCount>;
};

/** aggregate fields of "platform_subscriptions" */
export type PlatformSubscriptionsAggregateFields = {
  __typename?: 'PlatformSubscriptionsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<PlatformSubscriptionsMaxFields>;
  min?: Maybe<PlatformSubscriptionsMinFields>;
};


/** aggregate fields of "platform_subscriptions" */
export type PlatformSubscriptionsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PlatformSubscriptionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "platform_subscriptions" */
export type PlatformSubscriptionsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<PlatformSubscriptionsMaxOrderBy>;
  min?: InputMaybe<PlatformSubscriptionsMinOrderBy>;
};

/** input type for inserting array relation for remote table "platform_subscriptions" */
export type PlatformSubscriptionsArrRelInsertInput = {
  data: Array<PlatformSubscriptionsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<PlatformSubscriptionsOnConflict>;
};

/** Boolean expression to filter rows from the table "platform_subscriptions". All fields are combined with a logical 'AND'. */
export type PlatformSubscriptionsBoolExp = {
  _and?: InputMaybe<Array<PlatformSubscriptionsBoolExp>>;
  _not?: InputMaybe<PlatformSubscriptionsBoolExp>;
  _or?: InputMaybe<Array<PlatformSubscriptionsBoolExp>>;
  cancelAtPeriodEnd?: InputMaybe<BooleanComparisonExp>;
  canceledAt?: InputMaybe<TimestamptzComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  currentPeriodEndAt?: InputMaybe<TimestamptzComparisonExp>;
  currentPeriodStartAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  endedAt?: InputMaybe<TimestamptzComparisonExp>;
  externalSubscriptionId?: InputMaybe<StringComparisonExp>;
  externalSubscriptionProvider?: InputMaybe<PaymentProcessorsEnumComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  invoices?: InputMaybe<InvoicesBoolExp>;
  invoicesAggregate?: InputMaybe<InvoicesAggregateBoolExp>;
  planPrice?: InputMaybe<PlatformSubscriptionPlanPricesBoolExp>;
  platformSubscriptionPlanPriceId?: InputMaybe<UuidComparisonExp>;
  sales?: InputMaybe<SalesBoolExp>;
  salesAggregate?: InputMaybe<SalesAggregateBoolExp>;
  startDate?: InputMaybe<TimestamptzComparisonExp>;
  status?: InputMaybe<SubscriptionStatusesEnumComparisonExp>;
  statusChangedAt?: InputMaybe<TimestamptzComparisonExp>;
  stripeCustomerId?: InputMaybe<StringComparisonExp>;
  stripePriceId?: InputMaybe<StringComparisonExp>;
  stripeProductId?: InputMaybe<StringComparisonExp>;
  stripeStatus?: InputMaybe<StringComparisonExp>;
  stripeSubscriptionId?: InputMaybe<StringComparisonExp>;
  trialEndAt?: InputMaybe<TimestamptzComparisonExp>;
  trialStartAt?: InputMaybe<TimestamptzComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "platform_subscriptions" */
export enum PlatformSubscriptionsConstraint {
  /** unique or primary key constraint on columns "external_subscription_id" */
  PlatformSubscriptionsExternalSubscriptionIdKey = 'platform_subscriptions_external_subscription_id_key',
  /** unique or primary key constraint on columns "id" */
  PlatformSubscriptionsPkey = 'platform_subscriptions_pkey'
}

/** input type for inserting data into table "platform_subscriptions" */
export type PlatformSubscriptionsInsertInput = {
  cancelAtPeriodEnd?: InputMaybe<Scalars['Boolean']>;
  canceledAt?: InputMaybe<Scalars['timestamptz']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currentPeriodEndAt?: InputMaybe<Scalars['timestamptz']>;
  currentPeriodStartAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  endedAt?: InputMaybe<Scalars['timestamptz']>;
  externalSubscriptionId?: InputMaybe<Scalars['String']>;
  externalSubscriptionProvider?: InputMaybe<PaymentProcessorsEnum>;
  id?: InputMaybe<Scalars['uuid']>;
  invoices?: InputMaybe<InvoicesArrRelInsertInput>;
  planPrice?: InputMaybe<PlatformSubscriptionPlanPricesObjRelInsertInput>;
  platformSubscriptionPlanPriceId?: InputMaybe<Scalars['uuid']>;
  sales?: InputMaybe<SalesArrRelInsertInput>;
  startDate?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<SubscriptionStatusesEnum>;
  statusChangedAt?: InputMaybe<Scalars['timestamptz']>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  stripePriceId?: InputMaybe<Scalars['String']>;
  stripeProductId?: InputMaybe<Scalars['String']>;
  stripeStatus?: InputMaybe<Scalars['String']>;
  stripeSubscriptionId?: InputMaybe<Scalars['String']>;
  trialEndAt?: InputMaybe<Scalars['timestamptz']>;
  trialStartAt?: InputMaybe<Scalars['timestamptz']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type PlatformSubscriptionsMaxFields = {
  __typename?: 'PlatformSubscriptionsMaxFields';
  canceledAt?: Maybe<Scalars['timestamptz']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currentPeriodEndAt?: Maybe<Scalars['timestamptz']>;
  currentPeriodStartAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  endedAt?: Maybe<Scalars['timestamptz']>;
  externalSubscriptionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  platformSubscriptionPlanPriceId?: Maybe<Scalars['uuid']>;
  startDate?: Maybe<Scalars['timestamptz']>;
  statusChangedAt?: Maybe<Scalars['timestamptz']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePriceId?: Maybe<Scalars['String']>;
  stripeProductId?: Maybe<Scalars['String']>;
  stripeStatus?: Maybe<Scalars['String']>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  trialEndAt?: Maybe<Scalars['timestamptz']>;
  trialStartAt?: Maybe<Scalars['timestamptz']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "platform_subscriptions" */
export type PlatformSubscriptionsMaxOrderBy = {
  canceledAt?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  currentPeriodEndAt?: InputMaybe<OrderBy>;
  currentPeriodStartAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  endedAt?: InputMaybe<OrderBy>;
  externalSubscriptionId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  platformSubscriptionPlanPriceId?: InputMaybe<OrderBy>;
  startDate?: InputMaybe<OrderBy>;
  statusChangedAt?: InputMaybe<OrderBy>;
  stripeCustomerId?: InputMaybe<OrderBy>;
  stripePriceId?: InputMaybe<OrderBy>;
  stripeProductId?: InputMaybe<OrderBy>;
  stripeStatus?: InputMaybe<OrderBy>;
  stripeSubscriptionId?: InputMaybe<OrderBy>;
  trialEndAt?: InputMaybe<OrderBy>;
  trialStartAt?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type PlatformSubscriptionsMinFields = {
  __typename?: 'PlatformSubscriptionsMinFields';
  canceledAt?: Maybe<Scalars['timestamptz']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currentPeriodEndAt?: Maybe<Scalars['timestamptz']>;
  currentPeriodStartAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  endedAt?: Maybe<Scalars['timestamptz']>;
  externalSubscriptionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  platformSubscriptionPlanPriceId?: Maybe<Scalars['uuid']>;
  startDate?: Maybe<Scalars['timestamptz']>;
  statusChangedAt?: Maybe<Scalars['timestamptz']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePriceId?: Maybe<Scalars['String']>;
  stripeProductId?: Maybe<Scalars['String']>;
  stripeStatus?: Maybe<Scalars['String']>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  trialEndAt?: Maybe<Scalars['timestamptz']>;
  trialStartAt?: Maybe<Scalars['timestamptz']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "platform_subscriptions" */
export type PlatformSubscriptionsMinOrderBy = {
  canceledAt?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  currentPeriodEndAt?: InputMaybe<OrderBy>;
  currentPeriodStartAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  endedAt?: InputMaybe<OrderBy>;
  externalSubscriptionId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  platformSubscriptionPlanPriceId?: InputMaybe<OrderBy>;
  startDate?: InputMaybe<OrderBy>;
  statusChangedAt?: InputMaybe<OrderBy>;
  stripeCustomerId?: InputMaybe<OrderBy>;
  stripePriceId?: InputMaybe<OrderBy>;
  stripeProductId?: InputMaybe<OrderBy>;
  stripeStatus?: InputMaybe<OrderBy>;
  stripeSubscriptionId?: InputMaybe<OrderBy>;
  trialEndAt?: InputMaybe<OrderBy>;
  trialStartAt?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "platform_subscriptions" */
export type PlatformSubscriptionsMutationResponse = {
  __typename?: 'PlatformSubscriptionsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PlatformSubscriptions>;
};

/** input type for inserting object relation for remote table "platform_subscriptions" */
export type PlatformSubscriptionsObjRelInsertInput = {
  data: PlatformSubscriptionsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<PlatformSubscriptionsOnConflict>;
};

/** on_conflict condition type for table "platform_subscriptions" */
export type PlatformSubscriptionsOnConflict = {
  constraint: PlatformSubscriptionsConstraint;
  updateColumns?: Array<PlatformSubscriptionsUpdateColumn>;
  where?: InputMaybe<PlatformSubscriptionsBoolExp>;
};

/** Ordering options when selecting data from "platform_subscriptions". */
export type PlatformSubscriptionsOrderBy = {
  cancelAtPeriodEnd?: InputMaybe<OrderBy>;
  canceledAt?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  currentPeriodEndAt?: InputMaybe<OrderBy>;
  currentPeriodStartAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  endedAt?: InputMaybe<OrderBy>;
  externalSubscriptionId?: InputMaybe<OrderBy>;
  externalSubscriptionProvider?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  invoicesAggregate?: InputMaybe<InvoicesAggregateOrderBy>;
  planPrice?: InputMaybe<PlatformSubscriptionPlanPricesOrderBy>;
  platformSubscriptionPlanPriceId?: InputMaybe<OrderBy>;
  salesAggregate?: InputMaybe<SalesAggregateOrderBy>;
  startDate?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  statusChangedAt?: InputMaybe<OrderBy>;
  stripeCustomerId?: InputMaybe<OrderBy>;
  stripePriceId?: InputMaybe<OrderBy>;
  stripeProductId?: InputMaybe<OrderBy>;
  stripeStatus?: InputMaybe<OrderBy>;
  stripeSubscriptionId?: InputMaybe<OrderBy>;
  trialEndAt?: InputMaybe<OrderBy>;
  trialStartAt?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: platform_subscriptions */
export type PlatformSubscriptionsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "platform_subscriptions" */
export enum PlatformSubscriptionsSelectColumn {
  /** column name */
  CancelAtPeriodEnd = 'cancelAtPeriodEnd',
  /** column name */
  CanceledAt = 'canceledAt',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CurrentPeriodEndAt = 'currentPeriodEndAt',
  /** column name */
  CurrentPeriodStartAt = 'currentPeriodStartAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EndedAt = 'endedAt',
  /** column name */
  ExternalSubscriptionId = 'externalSubscriptionId',
  /** column name */
  ExternalSubscriptionProvider = 'externalSubscriptionProvider',
  /** column name */
  Id = 'id',
  /** column name */
  PlatformSubscriptionPlanPriceId = 'platformSubscriptionPlanPriceId',
  /** column name */
  StartDate = 'startDate',
  /** column name */
  Status = 'status',
  /** column name */
  StatusChangedAt = 'statusChangedAt',
  /** column name */
  StripeCustomerId = 'stripeCustomerId',
  /** column name */
  StripePriceId = 'stripePriceId',
  /** column name */
  StripeProductId = 'stripeProductId',
  /** column name */
  StripeStatus = 'stripeStatus',
  /** column name */
  StripeSubscriptionId = 'stripeSubscriptionId',
  /** column name */
  TrialEndAt = 'trialEndAt',
  /** column name */
  TrialStartAt = 'trialStartAt',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** select "platformSubscriptionsAggregateBoolExpBool_andArgumentsColumns" columns of table "platform_subscriptions" */
export enum PlatformSubscriptionsSelectColumnPlatformSubscriptionsAggregateBoolExpBool_AndArgumentsColumns {
  /** column name */
  CancelAtPeriodEnd = 'cancelAtPeriodEnd'
}

/** select "platformSubscriptionsAggregateBoolExpBool_orArgumentsColumns" columns of table "platform_subscriptions" */
export enum PlatformSubscriptionsSelectColumnPlatformSubscriptionsAggregateBoolExpBool_OrArgumentsColumns {
  /** column name */
  CancelAtPeriodEnd = 'cancelAtPeriodEnd'
}

/** input type for updating data in table "platform_subscriptions" */
export type PlatformSubscriptionsSetInput = {
  cancelAtPeriodEnd?: InputMaybe<Scalars['Boolean']>;
  canceledAt?: InputMaybe<Scalars['timestamptz']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currentPeriodEndAt?: InputMaybe<Scalars['timestamptz']>;
  currentPeriodStartAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  endedAt?: InputMaybe<Scalars['timestamptz']>;
  externalSubscriptionId?: InputMaybe<Scalars['String']>;
  externalSubscriptionProvider?: InputMaybe<PaymentProcessorsEnum>;
  id?: InputMaybe<Scalars['uuid']>;
  platformSubscriptionPlanPriceId?: InputMaybe<Scalars['uuid']>;
  startDate?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<SubscriptionStatusesEnum>;
  statusChangedAt?: InputMaybe<Scalars['timestamptz']>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  stripePriceId?: InputMaybe<Scalars['String']>;
  stripeProductId?: InputMaybe<Scalars['String']>;
  stripeStatus?: InputMaybe<Scalars['String']>;
  stripeSubscriptionId?: InputMaybe<Scalars['String']>;
  trialEndAt?: InputMaybe<Scalars['timestamptz']>;
  trialStartAt?: InputMaybe<Scalars['timestamptz']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "platform_subscriptions" */
export type PlatformSubscriptionsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PlatformSubscriptionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PlatformSubscriptionsStreamCursorValueInput = {
  cancelAtPeriodEnd?: InputMaybe<Scalars['Boolean']>;
  canceledAt?: InputMaybe<Scalars['timestamptz']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currentPeriodEndAt?: InputMaybe<Scalars['timestamptz']>;
  currentPeriodStartAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  endedAt?: InputMaybe<Scalars['timestamptz']>;
  externalSubscriptionId?: InputMaybe<Scalars['String']>;
  externalSubscriptionProvider?: InputMaybe<PaymentProcessorsEnum>;
  id?: InputMaybe<Scalars['uuid']>;
  platformSubscriptionPlanPriceId?: InputMaybe<Scalars['uuid']>;
  startDate?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<SubscriptionStatusesEnum>;
  statusChangedAt?: InputMaybe<Scalars['timestamptz']>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  stripePriceId?: InputMaybe<Scalars['String']>;
  stripeProductId?: InputMaybe<Scalars['String']>;
  stripeStatus?: InputMaybe<Scalars['String']>;
  stripeSubscriptionId?: InputMaybe<Scalars['String']>;
  trialEndAt?: InputMaybe<Scalars['timestamptz']>;
  trialStartAt?: InputMaybe<Scalars['timestamptz']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "platform_subscriptions" */
export enum PlatformSubscriptionsUpdateColumn {
  /** column name */
  CancelAtPeriodEnd = 'cancelAtPeriodEnd',
  /** column name */
  CanceledAt = 'canceledAt',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CurrentPeriodEndAt = 'currentPeriodEndAt',
  /** column name */
  CurrentPeriodStartAt = 'currentPeriodStartAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EndedAt = 'endedAt',
  /** column name */
  ExternalSubscriptionId = 'externalSubscriptionId',
  /** column name */
  ExternalSubscriptionProvider = 'externalSubscriptionProvider',
  /** column name */
  Id = 'id',
  /** column name */
  PlatformSubscriptionPlanPriceId = 'platformSubscriptionPlanPriceId',
  /** column name */
  StartDate = 'startDate',
  /** column name */
  Status = 'status',
  /** column name */
  StatusChangedAt = 'statusChangedAt',
  /** column name */
  StripeCustomerId = 'stripeCustomerId',
  /** column name */
  StripePriceId = 'stripePriceId',
  /** column name */
  StripeProductId = 'stripeProductId',
  /** column name */
  StripeStatus = 'stripeStatus',
  /** column name */
  StripeSubscriptionId = 'stripeSubscriptionId',
  /** column name */
  TrialEndAt = 'trialEndAt',
  /** column name */
  TrialStartAt = 'trialStartAt',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

export type PlatformSubscriptionsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PlatformSubscriptionsSetInput>;
  /** filter the rows which have to be updated */
  where: PlatformSubscriptionsBoolExp;
};

/** columns and relationships of "play_request_neighborhoods" */
export type PlayRequestNeighborhoods = {
  __typename?: 'PlayRequestNeighborhoods';
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  neighborhood: Neighborhoods;
  neighborhoodId: Scalars['uuid'];
  /** An object relationship */
  playRequest: PlayRequests;
  playRequestId: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "play_request_neighborhoods" */
export type PlayRequestNeighborhoodsAggregate = {
  __typename?: 'PlayRequestNeighborhoodsAggregate';
  aggregate?: Maybe<PlayRequestNeighborhoodsAggregateFields>;
  nodes: Array<PlayRequestNeighborhoods>;
};

export type PlayRequestNeighborhoodsAggregateBoolExp = {
  count?: InputMaybe<PlayRequestNeighborhoodsAggregateBoolExpCount>;
};

/** aggregate fields of "play_request_neighborhoods" */
export type PlayRequestNeighborhoodsAggregateFields = {
  __typename?: 'PlayRequestNeighborhoodsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<PlayRequestNeighborhoodsMaxFields>;
  min?: Maybe<PlayRequestNeighborhoodsMinFields>;
};


/** aggregate fields of "play_request_neighborhoods" */
export type PlayRequestNeighborhoodsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PlayRequestNeighborhoodsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "play_request_neighborhoods" */
export type PlayRequestNeighborhoodsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<PlayRequestNeighborhoodsMaxOrderBy>;
  min?: InputMaybe<PlayRequestNeighborhoodsMinOrderBy>;
};

/** input type for inserting array relation for remote table "play_request_neighborhoods" */
export type PlayRequestNeighborhoodsArrRelInsertInput = {
  data: Array<PlayRequestNeighborhoodsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<PlayRequestNeighborhoodsOnConflict>;
};

/** Boolean expression to filter rows from the table "play_request_neighborhoods". All fields are combined with a logical 'AND'. */
export type PlayRequestNeighborhoodsBoolExp = {
  _and?: InputMaybe<Array<PlayRequestNeighborhoodsBoolExp>>;
  _not?: InputMaybe<PlayRequestNeighborhoodsBoolExp>;
  _or?: InputMaybe<Array<PlayRequestNeighborhoodsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  neighborhood?: InputMaybe<NeighborhoodsBoolExp>;
  neighborhoodId?: InputMaybe<UuidComparisonExp>;
  playRequest?: InputMaybe<PlayRequestsBoolExp>;
  playRequestId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "play_request_neighborhoods" */
export enum PlayRequestNeighborhoodsConstraint {
  /** unique or primary key constraint on columns "id" */
  PlayRequestNeighborhoodsPkey = 'play_request_neighborhoods_pkey',
  /** unique or primary key constraint on columns "neighborhood_id", "play_request_id" */
  PlayRequestNeighborhoodsPlayRequestIdNeighborhoodIdKey = 'play_request_neighborhoods_play_request_id_neighborhood_id_key'
}

/** input type for inserting data into table "play_request_neighborhoods" */
export type PlayRequestNeighborhoodsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  neighborhood?: InputMaybe<NeighborhoodsObjRelInsertInput>;
  neighborhoodId?: InputMaybe<Scalars['uuid']>;
  playRequest?: InputMaybe<PlayRequestsObjRelInsertInput>;
  playRequestId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type PlayRequestNeighborhoodsMaxFields = {
  __typename?: 'PlayRequestNeighborhoodsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  neighborhoodId?: Maybe<Scalars['uuid']>;
  playRequestId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "play_request_neighborhoods" */
export type PlayRequestNeighborhoodsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  neighborhoodId?: InputMaybe<OrderBy>;
  playRequestId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type PlayRequestNeighborhoodsMinFields = {
  __typename?: 'PlayRequestNeighborhoodsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  neighborhoodId?: Maybe<Scalars['uuid']>;
  playRequestId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "play_request_neighborhoods" */
export type PlayRequestNeighborhoodsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  neighborhoodId?: InputMaybe<OrderBy>;
  playRequestId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "play_request_neighborhoods" */
export type PlayRequestNeighborhoodsMutationResponse = {
  __typename?: 'PlayRequestNeighborhoodsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PlayRequestNeighborhoods>;
};

/** on_conflict condition type for table "play_request_neighborhoods" */
export type PlayRequestNeighborhoodsOnConflict = {
  constraint: PlayRequestNeighborhoodsConstraint;
  updateColumns?: Array<PlayRequestNeighborhoodsUpdateColumn>;
  where?: InputMaybe<PlayRequestNeighborhoodsBoolExp>;
};

/** Ordering options when selecting data from "play_request_neighborhoods". */
export type PlayRequestNeighborhoodsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  neighborhood?: InputMaybe<NeighborhoodsOrderBy>;
  neighborhoodId?: InputMaybe<OrderBy>;
  playRequest?: InputMaybe<PlayRequestsOrderBy>;
  playRequestId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: play_request_neighborhoods */
export type PlayRequestNeighborhoodsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "play_request_neighborhoods" */
export enum PlayRequestNeighborhoodsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  NeighborhoodId = 'neighborhoodId',
  /** column name */
  PlayRequestId = 'playRequestId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "play_request_neighborhoods" */
export type PlayRequestNeighborhoodsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  neighborhoodId?: InputMaybe<Scalars['uuid']>;
  playRequestId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "play_request_neighborhoods" */
export type PlayRequestNeighborhoodsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PlayRequestNeighborhoodsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PlayRequestNeighborhoodsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  neighborhoodId?: InputMaybe<Scalars['uuid']>;
  playRequestId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "play_request_neighborhoods" */
export enum PlayRequestNeighborhoodsUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  NeighborhoodId = 'neighborhoodId',
  /** column name */
  PlayRequestId = 'playRequestId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type PlayRequestNeighborhoodsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PlayRequestNeighborhoodsSetInput>;
  /** filter the rows which have to be updated */
  where: PlayRequestNeighborhoodsBoolExp;
};

/** columns and relationships of "play_request_slots" */
export type PlayRequestSlots = {
  __typename?: 'PlayRequestSlots';
  /** An object relationship */
  availabilitySlot: PlayerAvailabilitySlots;
  availabilitySlotId: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  playRequest: PlayRequests;
  playRequestId: Scalars['uuid'];
  requestedEndAt?: Maybe<Scalars['timestamptz']>;
  requestedStartAt?: Maybe<Scalars['timestamptz']>;
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "play_request_slots" */
export type PlayRequestSlotsAggregate = {
  __typename?: 'PlayRequestSlotsAggregate';
  aggregate?: Maybe<PlayRequestSlotsAggregateFields>;
  nodes: Array<PlayRequestSlots>;
};

export type PlayRequestSlotsAggregateBoolExp = {
  count?: InputMaybe<PlayRequestSlotsAggregateBoolExpCount>;
};

/** aggregate fields of "play_request_slots" */
export type PlayRequestSlotsAggregateFields = {
  __typename?: 'PlayRequestSlotsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<PlayRequestSlotsMaxFields>;
  min?: Maybe<PlayRequestSlotsMinFields>;
};


/** aggregate fields of "play_request_slots" */
export type PlayRequestSlotsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PlayRequestSlotsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "play_request_slots" */
export type PlayRequestSlotsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<PlayRequestSlotsMaxOrderBy>;
  min?: InputMaybe<PlayRequestSlotsMinOrderBy>;
};

/** input type for inserting array relation for remote table "play_request_slots" */
export type PlayRequestSlotsArrRelInsertInput = {
  data: Array<PlayRequestSlotsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<PlayRequestSlotsOnConflict>;
};

/** Boolean expression to filter rows from the table "play_request_slots". All fields are combined with a logical 'AND'. */
export type PlayRequestSlotsBoolExp = {
  _and?: InputMaybe<Array<PlayRequestSlotsBoolExp>>;
  _not?: InputMaybe<PlayRequestSlotsBoolExp>;
  _or?: InputMaybe<Array<PlayRequestSlotsBoolExp>>;
  availabilitySlot?: InputMaybe<PlayerAvailabilitySlotsBoolExp>;
  availabilitySlotId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  playRequest?: InputMaybe<PlayRequestsBoolExp>;
  playRequestId?: InputMaybe<UuidComparisonExp>;
  requestedEndAt?: InputMaybe<TimestamptzComparisonExp>;
  requestedStartAt?: InputMaybe<TimestamptzComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "play_request_slots" */
export enum PlayRequestSlotsConstraint {
  /** unique or primary key constraint on columns "id" */
  PlayRequestSlotsPkey = 'play_request_slots_pkey',
  /** unique or primary key constraint on columns "play_request_id", "availability_slot_id" */
  PlayRequestSlotsPlayRequestIdAvailabilitySlotIdKey = 'play_request_slots_play_request_id_availability_slot_id_key'
}

/** input type for inserting data into table "play_request_slots" */
export type PlayRequestSlotsInsertInput = {
  availabilitySlot?: InputMaybe<PlayerAvailabilitySlotsObjRelInsertInput>;
  availabilitySlotId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  playRequest?: InputMaybe<PlayRequestsObjRelInsertInput>;
  playRequestId?: InputMaybe<Scalars['uuid']>;
  requestedEndAt?: InputMaybe<Scalars['timestamptz']>;
  requestedStartAt?: InputMaybe<Scalars['timestamptz']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type PlayRequestSlotsMaxFields = {
  __typename?: 'PlayRequestSlotsMaxFields';
  availabilitySlotId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  playRequestId?: Maybe<Scalars['uuid']>;
  requestedEndAt?: Maybe<Scalars['timestamptz']>;
  requestedStartAt?: Maybe<Scalars['timestamptz']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "play_request_slots" */
export type PlayRequestSlotsMaxOrderBy = {
  availabilitySlotId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  playRequestId?: InputMaybe<OrderBy>;
  requestedEndAt?: InputMaybe<OrderBy>;
  requestedStartAt?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type PlayRequestSlotsMinFields = {
  __typename?: 'PlayRequestSlotsMinFields';
  availabilitySlotId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  playRequestId?: Maybe<Scalars['uuid']>;
  requestedEndAt?: Maybe<Scalars['timestamptz']>;
  requestedStartAt?: Maybe<Scalars['timestamptz']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "play_request_slots" */
export type PlayRequestSlotsMinOrderBy = {
  availabilitySlotId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  playRequestId?: InputMaybe<OrderBy>;
  requestedEndAt?: InputMaybe<OrderBy>;
  requestedStartAt?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "play_request_slots" */
export type PlayRequestSlotsMutationResponse = {
  __typename?: 'PlayRequestSlotsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PlayRequestSlots>;
};

/** on_conflict condition type for table "play_request_slots" */
export type PlayRequestSlotsOnConflict = {
  constraint: PlayRequestSlotsConstraint;
  updateColumns?: Array<PlayRequestSlotsUpdateColumn>;
  where?: InputMaybe<PlayRequestSlotsBoolExp>;
};

/** Ordering options when selecting data from "play_request_slots". */
export type PlayRequestSlotsOrderBy = {
  availabilitySlot?: InputMaybe<PlayerAvailabilitySlotsOrderBy>;
  availabilitySlotId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  playRequest?: InputMaybe<PlayRequestsOrderBy>;
  playRequestId?: InputMaybe<OrderBy>;
  requestedEndAt?: InputMaybe<OrderBy>;
  requestedStartAt?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: play_request_slots */
export type PlayRequestSlotsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "play_request_slots" */
export enum PlayRequestSlotsSelectColumn {
  /** column name */
  AvailabilitySlotId = 'availabilitySlotId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  PlayRequestId = 'playRequestId',
  /** column name */
  RequestedEndAt = 'requestedEndAt',
  /** column name */
  RequestedStartAt = 'requestedStartAt',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "play_request_slots" */
export type PlayRequestSlotsSetInput = {
  availabilitySlotId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  playRequestId?: InputMaybe<Scalars['uuid']>;
  requestedEndAt?: InputMaybe<Scalars['timestamptz']>;
  requestedStartAt?: InputMaybe<Scalars['timestamptz']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "play_request_slots" */
export type PlayRequestSlotsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PlayRequestSlotsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PlayRequestSlotsStreamCursorValueInput = {
  availabilitySlotId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  playRequestId?: InputMaybe<Scalars['uuid']>;
  requestedEndAt?: InputMaybe<Scalars['timestamptz']>;
  requestedStartAt?: InputMaybe<Scalars['timestamptz']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "play_request_slots" */
export enum PlayRequestSlotsUpdateColumn {
  /** column name */
  AvailabilitySlotId = 'availabilitySlotId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  PlayRequestId = 'playRequestId',
  /** column name */
  RequestedEndAt = 'requestedEndAt',
  /** column name */
  RequestedStartAt = 'requestedStartAt',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type PlayRequestSlotsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PlayRequestSlotsSetInput>;
  /** filter the rows which have to be updated */
  where: PlayRequestSlotsBoolExp;
};

/** columns and relationships of "play_request_statuses" */
export type PlayRequestStatuses = {
  __typename?: 'PlayRequestStatuses';
  comment?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "play_request_statuses" */
export type PlayRequestStatusesAggregate = {
  __typename?: 'PlayRequestStatusesAggregate';
  aggregate?: Maybe<PlayRequestStatusesAggregateFields>;
  nodes: Array<PlayRequestStatuses>;
};

/** aggregate fields of "play_request_statuses" */
export type PlayRequestStatusesAggregateFields = {
  __typename?: 'PlayRequestStatusesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<PlayRequestStatusesMaxFields>;
  min?: Maybe<PlayRequestStatusesMinFields>;
};


/** aggregate fields of "play_request_statuses" */
export type PlayRequestStatusesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PlayRequestStatusesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "play_request_statuses". All fields are combined with a logical 'AND'. */
export type PlayRequestStatusesBoolExp = {
  _and?: InputMaybe<Array<PlayRequestStatusesBoolExp>>;
  _not?: InputMaybe<PlayRequestStatusesBoolExp>;
  _or?: InputMaybe<Array<PlayRequestStatusesBoolExp>>;
  comment?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "play_request_statuses" */
export enum PlayRequestStatusesConstraint {
  /** unique or primary key constraint on columns "value" */
  PlayRequestStatusesPkey = 'play_request_statuses_pkey'
}

export enum PlayRequestStatusesEnum {
  Accepted = 'ACCEPTED',
  /** auto-cancelled when the game filled up (all spots taken) */
  AutoCancelled = 'AUTO_CANCELLED',
  /** withdrawn by requester */
  Cancelled = 'CANCELLED',
  Declined = 'DECLINED',
  /** no longer valid (e.g. time lapsed) */
  Expired = 'EXPIRED',
  /** awaiting host/player response */
  Pending = 'PENDING'
}

/** Boolean expression to compare columns of type "PlayRequestStatusesEnum". All fields are combined with logical 'AND'. */
export type PlayRequestStatusesEnumComparisonExp = {
  _eq?: InputMaybe<PlayRequestStatusesEnum>;
  _in?: InputMaybe<Array<PlayRequestStatusesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<PlayRequestStatusesEnum>;
  _nin?: InputMaybe<Array<PlayRequestStatusesEnum>>;
};

/** input type for inserting data into table "play_request_statuses" */
export type PlayRequestStatusesInsertInput = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type PlayRequestStatusesMaxFields = {
  __typename?: 'PlayRequestStatusesMaxFields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type PlayRequestStatusesMinFields = {
  __typename?: 'PlayRequestStatusesMinFields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "play_request_statuses" */
export type PlayRequestStatusesMutationResponse = {
  __typename?: 'PlayRequestStatusesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PlayRequestStatuses>;
};

/** on_conflict condition type for table "play_request_statuses" */
export type PlayRequestStatusesOnConflict = {
  constraint: PlayRequestStatusesConstraint;
  updateColumns?: Array<PlayRequestStatusesUpdateColumn>;
  where?: InputMaybe<PlayRequestStatusesBoolExp>;
};

/** Ordering options when selecting data from "play_request_statuses". */
export type PlayRequestStatusesOrderBy = {
  comment?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: play_request_statuses */
export type PlayRequestStatusesPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "play_request_statuses" */
export enum PlayRequestStatusesSelectColumn {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "play_request_statuses" */
export type PlayRequestStatusesSetInput = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "play_request_statuses" */
export type PlayRequestStatusesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PlayRequestStatusesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PlayRequestStatusesStreamCursorValueInput = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "play_request_statuses" */
export enum PlayRequestStatusesUpdateColumn {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type PlayRequestStatusesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PlayRequestStatusesSetInput>;
  /** filter the rows which have to be updated */
  where: PlayRequestStatusesBoolExp;
};

/** columns and relationships of "play_request_venues" */
export type PlayRequestVenues = {
  __typename?: 'PlayRequestVenues';
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  playRequest: PlayRequests;
  playRequestId: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  venue: Venues;
  venueId: Scalars['uuid'];
};

/** aggregated selection of "play_request_venues" */
export type PlayRequestVenuesAggregate = {
  __typename?: 'PlayRequestVenuesAggregate';
  aggregate?: Maybe<PlayRequestVenuesAggregateFields>;
  nodes: Array<PlayRequestVenues>;
};

export type PlayRequestVenuesAggregateBoolExp = {
  count?: InputMaybe<PlayRequestVenuesAggregateBoolExpCount>;
};

/** aggregate fields of "play_request_venues" */
export type PlayRequestVenuesAggregateFields = {
  __typename?: 'PlayRequestVenuesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<PlayRequestVenuesMaxFields>;
  min?: Maybe<PlayRequestVenuesMinFields>;
};


/** aggregate fields of "play_request_venues" */
export type PlayRequestVenuesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PlayRequestVenuesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "play_request_venues" */
export type PlayRequestVenuesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<PlayRequestVenuesMaxOrderBy>;
  min?: InputMaybe<PlayRequestVenuesMinOrderBy>;
};

/** input type for inserting array relation for remote table "play_request_venues" */
export type PlayRequestVenuesArrRelInsertInput = {
  data: Array<PlayRequestVenuesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<PlayRequestVenuesOnConflict>;
};

/** Boolean expression to filter rows from the table "play_request_venues". All fields are combined with a logical 'AND'. */
export type PlayRequestVenuesBoolExp = {
  _and?: InputMaybe<Array<PlayRequestVenuesBoolExp>>;
  _not?: InputMaybe<PlayRequestVenuesBoolExp>;
  _or?: InputMaybe<Array<PlayRequestVenuesBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  playRequest?: InputMaybe<PlayRequestsBoolExp>;
  playRequestId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  venue?: InputMaybe<VenuesBoolExp>;
  venueId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "play_request_venues" */
export enum PlayRequestVenuesConstraint {
  /** unique or primary key constraint on columns "id" */
  PlayRequestVenuesPkey = 'play_request_venues_pkey',
  /** unique or primary key constraint on columns "venue_id", "play_request_id" */
  PlayRequestVenuesPlayRequestIdVenueIdKey = 'play_request_venues_play_request_id_venue_id_key'
}

/** input type for inserting data into table "play_request_venues" */
export type PlayRequestVenuesInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  playRequest?: InputMaybe<PlayRequestsObjRelInsertInput>;
  playRequestId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  venue?: InputMaybe<VenuesObjRelInsertInput>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type PlayRequestVenuesMaxFields = {
  __typename?: 'PlayRequestVenuesMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  playRequestId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  venueId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "play_request_venues" */
export type PlayRequestVenuesMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  playRequestId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type PlayRequestVenuesMinFields = {
  __typename?: 'PlayRequestVenuesMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  playRequestId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  venueId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "play_request_venues" */
export type PlayRequestVenuesMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  playRequestId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "play_request_venues" */
export type PlayRequestVenuesMutationResponse = {
  __typename?: 'PlayRequestVenuesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PlayRequestVenues>;
};

/** on_conflict condition type for table "play_request_venues" */
export type PlayRequestVenuesOnConflict = {
  constraint: PlayRequestVenuesConstraint;
  updateColumns?: Array<PlayRequestVenuesUpdateColumn>;
  where?: InputMaybe<PlayRequestVenuesBoolExp>;
};

/** Ordering options when selecting data from "play_request_venues". */
export type PlayRequestVenuesOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  playRequest?: InputMaybe<PlayRequestsOrderBy>;
  playRequestId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  venue?: InputMaybe<VenuesOrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: play_request_venues */
export type PlayRequestVenuesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "play_request_venues" */
export enum PlayRequestVenuesSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  PlayRequestId = 'playRequestId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  VenueId = 'venueId'
}

/** input type for updating data in table "play_request_venues" */
export type PlayRequestVenuesSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  playRequestId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "play_request_venues" */
export type PlayRequestVenuesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PlayRequestVenuesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PlayRequestVenuesStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  playRequestId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "play_request_venues" */
export enum PlayRequestVenuesUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  PlayRequestId = 'playRequestId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  VenueId = 'venueId'
}

export type PlayRequestVenuesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PlayRequestVenuesSetInput>;
  /** filter the rows which have to be updated */
  where: PlayRequestVenuesBoolExp;
};

/** columns and relationships of "play_requests" */
export type PlayRequests = {
  __typename?: 'PlayRequests';
  /** An object relationship */
  availability?: Maybe<PlayerAvailabilities>;
  availabilityId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  conversation?: Maybe<Conversations>;
  conversationId?: Maybe<Scalars['uuid']>;
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  event?: Maybe<Events>;
  eventId?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  /** An array relationship */
  neighborhoods: Array<PlayRequestNeighborhoods>;
  /** An aggregate relationship */
  neighborhoodsAggregate: PlayRequestNeighborhoodsAggregate;
  /** An object relationship */
  recipient: Users;
  /** An object relationship */
  recipientProfile?: Maybe<UserProfiles>;
  recipientUserId: Scalars['uuid'];
  requestMessage?: Maybe<Scalars['String']>;
  /** An object relationship */
  requester: Users;
  /** An object relationship */
  requesterProfile?: Maybe<UserProfiles>;
  requesterUserId: Scalars['uuid'];
  respondedAt?: Maybe<Scalars['timestamptz']>;
  responseMessage?: Maybe<Scalars['String']>;
  /** An object relationship */
  selectedVenue?: Maybe<Venues>;
  selectedVenueId?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  slots: Array<PlayRequestSlots>;
  /** An aggregate relationship */
  slotsAggregate: PlayRequestSlotsAggregate;
  status: PlayRequestStatusesEnum;
  updatedAt: Scalars['timestamptz'];
  /** An array relationship */
  venues: Array<PlayRequestVenues>;
  /** An aggregate relationship */
  venuesAggregate: PlayRequestVenuesAggregate;
};


/** columns and relationships of "play_requests" */
export type PlayRequestsNeighborhoodsArgs = {
  distinctOn?: InputMaybe<Array<PlayRequestNeighborhoodsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayRequestNeighborhoodsOrderBy>>;
  where?: InputMaybe<PlayRequestNeighborhoodsBoolExp>;
};


/** columns and relationships of "play_requests" */
export type PlayRequestsNeighborhoodsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PlayRequestNeighborhoodsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayRequestNeighborhoodsOrderBy>>;
  where?: InputMaybe<PlayRequestNeighborhoodsBoolExp>;
};


/** columns and relationships of "play_requests" */
export type PlayRequestsSlotsArgs = {
  distinctOn?: InputMaybe<Array<PlayRequestSlotsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayRequestSlotsOrderBy>>;
  where?: InputMaybe<PlayRequestSlotsBoolExp>;
};


/** columns and relationships of "play_requests" */
export type PlayRequestsSlotsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PlayRequestSlotsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayRequestSlotsOrderBy>>;
  where?: InputMaybe<PlayRequestSlotsBoolExp>;
};


/** columns and relationships of "play_requests" */
export type PlayRequestsVenuesArgs = {
  distinctOn?: InputMaybe<Array<PlayRequestVenuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayRequestVenuesOrderBy>>;
  where?: InputMaybe<PlayRequestVenuesBoolExp>;
};


/** columns and relationships of "play_requests" */
export type PlayRequestsVenuesAggregateArgs = {
  distinctOn?: InputMaybe<Array<PlayRequestVenuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayRequestVenuesOrderBy>>;
  where?: InputMaybe<PlayRequestVenuesBoolExp>;
};

/** aggregated selection of "play_requests" */
export type PlayRequestsAggregate = {
  __typename?: 'PlayRequestsAggregate';
  aggregate?: Maybe<PlayRequestsAggregateFields>;
  nodes: Array<PlayRequests>;
};

export type PlayRequestsAggregateBoolExp = {
  count?: InputMaybe<PlayRequestsAggregateBoolExpCount>;
};

/** aggregate fields of "play_requests" */
export type PlayRequestsAggregateFields = {
  __typename?: 'PlayRequestsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<PlayRequestsMaxFields>;
  min?: Maybe<PlayRequestsMinFields>;
};


/** aggregate fields of "play_requests" */
export type PlayRequestsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PlayRequestsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "play_requests" */
export type PlayRequestsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<PlayRequestsMaxOrderBy>;
  min?: InputMaybe<PlayRequestsMinOrderBy>;
};

/** input type for inserting array relation for remote table "play_requests" */
export type PlayRequestsArrRelInsertInput = {
  data: Array<PlayRequestsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<PlayRequestsOnConflict>;
};

/** Boolean expression to filter rows from the table "play_requests". All fields are combined with a logical 'AND'. */
export type PlayRequestsBoolExp = {
  _and?: InputMaybe<Array<PlayRequestsBoolExp>>;
  _not?: InputMaybe<PlayRequestsBoolExp>;
  _or?: InputMaybe<Array<PlayRequestsBoolExp>>;
  availability?: InputMaybe<PlayerAvailabilitiesBoolExp>;
  availabilityId?: InputMaybe<UuidComparisonExp>;
  conversation?: InputMaybe<ConversationsBoolExp>;
  conversationId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  event?: InputMaybe<EventsBoolExp>;
  eventId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  neighborhoods?: InputMaybe<PlayRequestNeighborhoodsBoolExp>;
  neighborhoodsAggregate?: InputMaybe<PlayRequestNeighborhoodsAggregateBoolExp>;
  recipient?: InputMaybe<UsersBoolExp>;
  recipientProfile?: InputMaybe<UserProfilesBoolExp>;
  recipientUserId?: InputMaybe<UuidComparisonExp>;
  requestMessage?: InputMaybe<StringComparisonExp>;
  requester?: InputMaybe<UsersBoolExp>;
  requesterProfile?: InputMaybe<UserProfilesBoolExp>;
  requesterUserId?: InputMaybe<UuidComparisonExp>;
  respondedAt?: InputMaybe<TimestamptzComparisonExp>;
  responseMessage?: InputMaybe<StringComparisonExp>;
  selectedVenue?: InputMaybe<VenuesBoolExp>;
  selectedVenueId?: InputMaybe<UuidComparisonExp>;
  slots?: InputMaybe<PlayRequestSlotsBoolExp>;
  slotsAggregate?: InputMaybe<PlayRequestSlotsAggregateBoolExp>;
  status?: InputMaybe<PlayRequestStatusesEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  venues?: InputMaybe<PlayRequestVenuesBoolExp>;
  venuesAggregate?: InputMaybe<PlayRequestVenuesAggregateBoolExp>;
};

/** unique or primary key constraints on table "play_requests" */
export enum PlayRequestsConstraint {
  /** unique or primary key constraint on columns "id" */
  PlayRequestsPkey = 'play_requests_pkey'
}

/** input type for inserting data into table "play_requests" */
export type PlayRequestsInsertInput = {
  availability?: InputMaybe<PlayerAvailabilitiesObjRelInsertInput>;
  availabilityId?: InputMaybe<Scalars['uuid']>;
  conversation?: InputMaybe<ConversationsObjRelInsertInput>;
  conversationId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  event?: InputMaybe<EventsObjRelInsertInput>;
  eventId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  neighborhoods?: InputMaybe<PlayRequestNeighborhoodsArrRelInsertInput>;
  recipient?: InputMaybe<UsersObjRelInsertInput>;
  recipientProfile?: InputMaybe<UserProfilesObjRelInsertInput>;
  recipientUserId?: InputMaybe<Scalars['uuid']>;
  requestMessage?: InputMaybe<Scalars['String']>;
  requester?: InputMaybe<UsersObjRelInsertInput>;
  requesterProfile?: InputMaybe<UserProfilesObjRelInsertInput>;
  requesterUserId?: InputMaybe<Scalars['uuid']>;
  respondedAt?: InputMaybe<Scalars['timestamptz']>;
  responseMessage?: InputMaybe<Scalars['String']>;
  selectedVenue?: InputMaybe<VenuesObjRelInsertInput>;
  selectedVenueId?: InputMaybe<Scalars['uuid']>;
  slots?: InputMaybe<PlayRequestSlotsArrRelInsertInput>;
  status?: InputMaybe<PlayRequestStatusesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  venues?: InputMaybe<PlayRequestVenuesArrRelInsertInput>;
};

/** aggregate max on columns */
export type PlayRequestsMaxFields = {
  __typename?: 'PlayRequestsMaxFields';
  availabilityId?: Maybe<Scalars['uuid']>;
  conversationId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  eventId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  recipientUserId?: Maybe<Scalars['uuid']>;
  requestMessage?: Maybe<Scalars['String']>;
  requesterUserId?: Maybe<Scalars['uuid']>;
  respondedAt?: Maybe<Scalars['timestamptz']>;
  responseMessage?: Maybe<Scalars['String']>;
  selectedVenueId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "play_requests" */
export type PlayRequestsMaxOrderBy = {
  availabilityId?: InputMaybe<OrderBy>;
  conversationId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  eventId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  recipientUserId?: InputMaybe<OrderBy>;
  requestMessage?: InputMaybe<OrderBy>;
  requesterUserId?: InputMaybe<OrderBy>;
  respondedAt?: InputMaybe<OrderBy>;
  responseMessage?: InputMaybe<OrderBy>;
  selectedVenueId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type PlayRequestsMinFields = {
  __typename?: 'PlayRequestsMinFields';
  availabilityId?: Maybe<Scalars['uuid']>;
  conversationId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  eventId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  recipientUserId?: Maybe<Scalars['uuid']>;
  requestMessage?: Maybe<Scalars['String']>;
  requesterUserId?: Maybe<Scalars['uuid']>;
  respondedAt?: Maybe<Scalars['timestamptz']>;
  responseMessage?: Maybe<Scalars['String']>;
  selectedVenueId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "play_requests" */
export type PlayRequestsMinOrderBy = {
  availabilityId?: InputMaybe<OrderBy>;
  conversationId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  eventId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  recipientUserId?: InputMaybe<OrderBy>;
  requestMessage?: InputMaybe<OrderBy>;
  requesterUserId?: InputMaybe<OrderBy>;
  respondedAt?: InputMaybe<OrderBy>;
  responseMessage?: InputMaybe<OrderBy>;
  selectedVenueId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "play_requests" */
export type PlayRequestsMutationResponse = {
  __typename?: 'PlayRequestsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PlayRequests>;
};

/** input type for inserting object relation for remote table "play_requests" */
export type PlayRequestsObjRelInsertInput = {
  data: PlayRequestsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<PlayRequestsOnConflict>;
};

/** on_conflict condition type for table "play_requests" */
export type PlayRequestsOnConflict = {
  constraint: PlayRequestsConstraint;
  updateColumns?: Array<PlayRequestsUpdateColumn>;
  where?: InputMaybe<PlayRequestsBoolExp>;
};

/** Ordering options when selecting data from "play_requests". */
export type PlayRequestsOrderBy = {
  availability?: InputMaybe<PlayerAvailabilitiesOrderBy>;
  availabilityId?: InputMaybe<OrderBy>;
  conversation?: InputMaybe<ConversationsOrderBy>;
  conversationId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  event?: InputMaybe<EventsOrderBy>;
  eventId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  neighborhoodsAggregate?: InputMaybe<PlayRequestNeighborhoodsAggregateOrderBy>;
  recipient?: InputMaybe<UsersOrderBy>;
  recipientProfile?: InputMaybe<UserProfilesOrderBy>;
  recipientUserId?: InputMaybe<OrderBy>;
  requestMessage?: InputMaybe<OrderBy>;
  requester?: InputMaybe<UsersOrderBy>;
  requesterProfile?: InputMaybe<UserProfilesOrderBy>;
  requesterUserId?: InputMaybe<OrderBy>;
  respondedAt?: InputMaybe<OrderBy>;
  responseMessage?: InputMaybe<OrderBy>;
  selectedVenue?: InputMaybe<VenuesOrderBy>;
  selectedVenueId?: InputMaybe<OrderBy>;
  slotsAggregate?: InputMaybe<PlayRequestSlotsAggregateOrderBy>;
  status?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  venuesAggregate?: InputMaybe<PlayRequestVenuesAggregateOrderBy>;
};

/** primary key columns input for table: play_requests */
export type PlayRequestsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "play_requests" */
export enum PlayRequestsSelectColumn {
  /** column name */
  AvailabilityId = 'availabilityId',
  /** column name */
  ConversationId = 'conversationId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EventId = 'eventId',
  /** column name */
  Id = 'id',
  /** column name */
  RecipientUserId = 'recipientUserId',
  /** column name */
  RequestMessage = 'requestMessage',
  /** column name */
  RequesterUserId = 'requesterUserId',
  /** column name */
  RespondedAt = 'respondedAt',
  /** column name */
  ResponseMessage = 'responseMessage',
  /** column name */
  SelectedVenueId = 'selectedVenueId',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "play_requests" */
export type PlayRequestsSetInput = {
  availabilityId?: InputMaybe<Scalars['uuid']>;
  conversationId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  eventId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  recipientUserId?: InputMaybe<Scalars['uuid']>;
  requestMessage?: InputMaybe<Scalars['String']>;
  requesterUserId?: InputMaybe<Scalars['uuid']>;
  respondedAt?: InputMaybe<Scalars['timestamptz']>;
  responseMessage?: InputMaybe<Scalars['String']>;
  selectedVenueId?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<PlayRequestStatusesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "play_requests" */
export type PlayRequestsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PlayRequestsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PlayRequestsStreamCursorValueInput = {
  availabilityId?: InputMaybe<Scalars['uuid']>;
  conversationId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  eventId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  recipientUserId?: InputMaybe<Scalars['uuid']>;
  requestMessage?: InputMaybe<Scalars['String']>;
  requesterUserId?: InputMaybe<Scalars['uuid']>;
  respondedAt?: InputMaybe<Scalars['timestamptz']>;
  responseMessage?: InputMaybe<Scalars['String']>;
  selectedVenueId?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<PlayRequestStatusesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "play_requests" */
export enum PlayRequestsUpdateColumn {
  /** column name */
  AvailabilityId = 'availabilityId',
  /** column name */
  ConversationId = 'conversationId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EventId = 'eventId',
  /** column name */
  Id = 'id',
  /** column name */
  RecipientUserId = 'recipientUserId',
  /** column name */
  RequestMessage = 'requestMessage',
  /** column name */
  RequesterUserId = 'requesterUserId',
  /** column name */
  RespondedAt = 'respondedAt',
  /** column name */
  ResponseMessage = 'responseMessage',
  /** column name */
  SelectedVenueId = 'selectedVenueId',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type PlayRequestsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PlayRequestsSetInput>;
  /** filter the rows which have to be updated */
  where: PlayRequestsBoolExp;
};

/** columns and relationships of "play_session_comments" */
export type PlaySessionComments = {
  __typename?: 'PlaySessionComments';
  /** An array relationship */
  allChildComments: Array<PlaySessionComments>;
  /** An aggregate relationship */
  allChildCommentsAggregate: PlaySessionCommentsAggregate;
  content: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  /** An object relationship */
  playSession: PlaySessions;
  playSessionCommentId?: Maybe<Scalars['uuid']>;
  playSessionId: Scalars['uuid'];
  playSessionRootCommentId?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  replies: Array<PlaySessionComments>;
  /** An aggregate relationship */
  repliesAggregate: PlaySessionCommentsAggregate;
  updatedAt: Scalars['timestamptz'];
  userId: Scalars['uuid'];
  /** An object relationship */
  userProfile?: Maybe<UserProfiles>;
};


/** columns and relationships of "play_session_comments" */
export type PlaySessionCommentsAllChildCommentsArgs = {
  distinctOn?: InputMaybe<Array<PlaySessionCommentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlaySessionCommentsOrderBy>>;
  where?: InputMaybe<PlaySessionCommentsBoolExp>;
};


/** columns and relationships of "play_session_comments" */
export type PlaySessionCommentsAllChildCommentsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PlaySessionCommentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlaySessionCommentsOrderBy>>;
  where?: InputMaybe<PlaySessionCommentsBoolExp>;
};


/** columns and relationships of "play_session_comments" */
export type PlaySessionCommentsRepliesArgs = {
  distinctOn?: InputMaybe<Array<PlaySessionCommentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlaySessionCommentsOrderBy>>;
  where?: InputMaybe<PlaySessionCommentsBoolExp>;
};


/** columns and relationships of "play_session_comments" */
export type PlaySessionCommentsRepliesAggregateArgs = {
  distinctOn?: InputMaybe<Array<PlaySessionCommentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlaySessionCommentsOrderBy>>;
  where?: InputMaybe<PlaySessionCommentsBoolExp>;
};

/** aggregated selection of "play_session_comments" */
export type PlaySessionCommentsAggregate = {
  __typename?: 'PlaySessionCommentsAggregate';
  aggregate?: Maybe<PlaySessionCommentsAggregateFields>;
  nodes: Array<PlaySessionComments>;
};

export type PlaySessionCommentsAggregateBoolExp = {
  count?: InputMaybe<PlaySessionCommentsAggregateBoolExpCount>;
};

/** aggregate fields of "play_session_comments" */
export type PlaySessionCommentsAggregateFields = {
  __typename?: 'PlaySessionCommentsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<PlaySessionCommentsMaxFields>;
  min?: Maybe<PlaySessionCommentsMinFields>;
};


/** aggregate fields of "play_session_comments" */
export type PlaySessionCommentsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PlaySessionCommentsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "play_session_comments" */
export type PlaySessionCommentsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<PlaySessionCommentsMaxOrderBy>;
  min?: InputMaybe<PlaySessionCommentsMinOrderBy>;
};

/** input type for inserting array relation for remote table "play_session_comments" */
export type PlaySessionCommentsArrRelInsertInput = {
  data: Array<PlaySessionCommentsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<PlaySessionCommentsOnConflict>;
};

/** Boolean expression to filter rows from the table "play_session_comments". All fields are combined with a logical 'AND'. */
export type PlaySessionCommentsBoolExp = {
  _and?: InputMaybe<Array<PlaySessionCommentsBoolExp>>;
  _not?: InputMaybe<PlaySessionCommentsBoolExp>;
  _or?: InputMaybe<Array<PlaySessionCommentsBoolExp>>;
  allChildComments?: InputMaybe<PlaySessionCommentsBoolExp>;
  allChildCommentsAggregate?: InputMaybe<PlaySessionCommentsAggregateBoolExp>;
  content?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  playSession?: InputMaybe<PlaySessionsBoolExp>;
  playSessionCommentId?: InputMaybe<UuidComparisonExp>;
  playSessionId?: InputMaybe<UuidComparisonExp>;
  playSessionRootCommentId?: InputMaybe<UuidComparisonExp>;
  replies?: InputMaybe<PlaySessionCommentsBoolExp>;
  repliesAggregate?: InputMaybe<PlaySessionCommentsAggregateBoolExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  userId?: InputMaybe<UuidComparisonExp>;
  userProfile?: InputMaybe<UserProfilesBoolExp>;
};

/** unique or primary key constraints on table "play_session_comments" */
export enum PlaySessionCommentsConstraint {
  /** unique or primary key constraint on columns "id" */
  PlaySessionCommentsPkey = 'play_session_comments_pkey'
}

/** input type for inserting data into table "play_session_comments" */
export type PlaySessionCommentsInsertInput = {
  allChildComments?: InputMaybe<PlaySessionCommentsArrRelInsertInput>;
  content?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  playSession?: InputMaybe<PlaySessionsObjRelInsertInput>;
  playSessionCommentId?: InputMaybe<Scalars['uuid']>;
  playSessionId?: InputMaybe<Scalars['uuid']>;
  playSessionRootCommentId?: InputMaybe<Scalars['uuid']>;
  replies?: InputMaybe<PlaySessionCommentsArrRelInsertInput>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
  userProfile?: InputMaybe<UserProfilesObjRelInsertInput>;
};

/** aggregate max on columns */
export type PlaySessionCommentsMaxFields = {
  __typename?: 'PlaySessionCommentsMaxFields';
  content?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  playSessionCommentId?: Maybe<Scalars['uuid']>;
  playSessionId?: Maybe<Scalars['uuid']>;
  playSessionRootCommentId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "play_session_comments" */
export type PlaySessionCommentsMaxOrderBy = {
  content?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  playSessionCommentId?: InputMaybe<OrderBy>;
  playSessionId?: InputMaybe<OrderBy>;
  playSessionRootCommentId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type PlaySessionCommentsMinFields = {
  __typename?: 'PlaySessionCommentsMinFields';
  content?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  playSessionCommentId?: Maybe<Scalars['uuid']>;
  playSessionId?: Maybe<Scalars['uuid']>;
  playSessionRootCommentId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "play_session_comments" */
export type PlaySessionCommentsMinOrderBy = {
  content?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  playSessionCommentId?: InputMaybe<OrderBy>;
  playSessionId?: InputMaybe<OrderBy>;
  playSessionRootCommentId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "play_session_comments" */
export type PlaySessionCommentsMutationResponse = {
  __typename?: 'PlaySessionCommentsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PlaySessionComments>;
};

/** input type for inserting object relation for remote table "play_session_comments" */
export type PlaySessionCommentsObjRelInsertInput = {
  data: PlaySessionCommentsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<PlaySessionCommentsOnConflict>;
};

/** on_conflict condition type for table "play_session_comments" */
export type PlaySessionCommentsOnConflict = {
  constraint: PlaySessionCommentsConstraint;
  updateColumns?: Array<PlaySessionCommentsUpdateColumn>;
  where?: InputMaybe<PlaySessionCommentsBoolExp>;
};

/** Ordering options when selecting data from "play_session_comments". */
export type PlaySessionCommentsOrderBy = {
  allChildCommentsAggregate?: InputMaybe<PlaySessionCommentsAggregateOrderBy>;
  content?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  playSession?: InputMaybe<PlaySessionsOrderBy>;
  playSessionCommentId?: InputMaybe<OrderBy>;
  playSessionId?: InputMaybe<OrderBy>;
  playSessionRootCommentId?: InputMaybe<OrderBy>;
  repliesAggregate?: InputMaybe<PlaySessionCommentsAggregateOrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
  userProfile?: InputMaybe<UserProfilesOrderBy>;
};

/** primary key columns input for table: play_session_comments */
export type PlaySessionCommentsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "play_session_comments" */
export enum PlaySessionCommentsSelectColumn {
  /** column name */
  Content = 'content',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  PlaySessionCommentId = 'playSessionCommentId',
  /** column name */
  PlaySessionId = 'playSessionId',
  /** column name */
  PlaySessionRootCommentId = 'playSessionRootCommentId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "play_session_comments" */
export type PlaySessionCommentsSetInput = {
  content?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  playSessionCommentId?: InputMaybe<Scalars['uuid']>;
  playSessionId?: InputMaybe<Scalars['uuid']>;
  playSessionRootCommentId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "play_session_comments" */
export type PlaySessionCommentsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PlaySessionCommentsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PlaySessionCommentsStreamCursorValueInput = {
  content?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  playSessionCommentId?: InputMaybe<Scalars['uuid']>;
  playSessionId?: InputMaybe<Scalars['uuid']>;
  playSessionRootCommentId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "play_session_comments" */
export enum PlaySessionCommentsUpdateColumn {
  /** column name */
  Content = 'content',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  PlaySessionCommentId = 'playSessionCommentId',
  /** column name */
  PlaySessionId = 'playSessionId',
  /** column name */
  PlaySessionRootCommentId = 'playSessionRootCommentId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

export type PlaySessionCommentsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PlaySessionCommentsSetInput>;
  /** filter the rows which have to be updated */
  where: PlaySessionCommentsBoolExp;
};

/** columns and relationships of "play_session_court_booking_statuses" */
export type PlaySessionCourtBookingStatuses = {
  __typename?: 'PlaySessionCourtBookingStatuses';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "play_session_court_booking_statuses" */
export type PlaySessionCourtBookingStatusesAggregate = {
  __typename?: 'PlaySessionCourtBookingStatusesAggregate';
  aggregate?: Maybe<PlaySessionCourtBookingStatusesAggregateFields>;
  nodes: Array<PlaySessionCourtBookingStatuses>;
};

/** aggregate fields of "play_session_court_booking_statuses" */
export type PlaySessionCourtBookingStatusesAggregateFields = {
  __typename?: 'PlaySessionCourtBookingStatusesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<PlaySessionCourtBookingStatusesMaxFields>;
  min?: Maybe<PlaySessionCourtBookingStatusesMinFields>;
};


/** aggregate fields of "play_session_court_booking_statuses" */
export type PlaySessionCourtBookingStatusesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PlaySessionCourtBookingStatusesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "play_session_court_booking_statuses". All fields are combined with a logical 'AND'. */
export type PlaySessionCourtBookingStatusesBoolExp = {
  _and?: InputMaybe<Array<PlaySessionCourtBookingStatusesBoolExp>>;
  _not?: InputMaybe<PlaySessionCourtBookingStatusesBoolExp>;
  _or?: InputMaybe<Array<PlaySessionCourtBookingStatusesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "play_session_court_booking_statuses" */
export enum PlaySessionCourtBookingStatusesConstraint {
  /** unique or primary key constraint on columns "value" */
  PlaySessionCourtBookingStatusesPkey = 'play_session_court_booking_statuses_pkey'
}

export enum PlaySessionCourtBookingStatusesEnum {
  Booked = 'BOOKED',
  NotBooked = 'NOT_BOOKED'
}

/** Boolean expression to compare columns of type "PlaySessionCourtBookingStatusesEnum". All fields are combined with logical 'AND'. */
export type PlaySessionCourtBookingStatusesEnumComparisonExp = {
  _eq?: InputMaybe<PlaySessionCourtBookingStatusesEnum>;
  _in?: InputMaybe<Array<PlaySessionCourtBookingStatusesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<PlaySessionCourtBookingStatusesEnum>;
  _nin?: InputMaybe<Array<PlaySessionCourtBookingStatusesEnum>>;
};

/** input type for inserting data into table "play_session_court_booking_statuses" */
export type PlaySessionCourtBookingStatusesInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type PlaySessionCourtBookingStatusesMaxFields = {
  __typename?: 'PlaySessionCourtBookingStatusesMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type PlaySessionCourtBookingStatusesMinFields = {
  __typename?: 'PlaySessionCourtBookingStatusesMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "play_session_court_booking_statuses" */
export type PlaySessionCourtBookingStatusesMutationResponse = {
  __typename?: 'PlaySessionCourtBookingStatusesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PlaySessionCourtBookingStatuses>;
};

/** on_conflict condition type for table "play_session_court_booking_statuses" */
export type PlaySessionCourtBookingStatusesOnConflict = {
  constraint: PlaySessionCourtBookingStatusesConstraint;
  updateColumns?: Array<PlaySessionCourtBookingStatusesUpdateColumn>;
  where?: InputMaybe<PlaySessionCourtBookingStatusesBoolExp>;
};

/** Ordering options when selecting data from "play_session_court_booking_statuses". */
export type PlaySessionCourtBookingStatusesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: play_session_court_booking_statuses */
export type PlaySessionCourtBookingStatusesPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "play_session_court_booking_statuses" */
export enum PlaySessionCourtBookingStatusesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "play_session_court_booking_statuses" */
export type PlaySessionCourtBookingStatusesSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "play_session_court_booking_statuses" */
export type PlaySessionCourtBookingStatusesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PlaySessionCourtBookingStatusesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PlaySessionCourtBookingStatusesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "play_session_court_booking_statuses" */
export enum PlaySessionCourtBookingStatusesUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type PlaySessionCourtBookingStatusesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PlaySessionCourtBookingStatusesSetInput>;
  /** filter the rows which have to be updated */
  where: PlaySessionCourtBookingStatusesBoolExp;
};

/** columns and relationships of "play_session_formats" */
export type PlaySessionFormats = {
  __typename?: 'PlaySessionFormats';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "play_session_formats" */
export type PlaySessionFormatsAggregate = {
  __typename?: 'PlaySessionFormatsAggregate';
  aggregate?: Maybe<PlaySessionFormatsAggregateFields>;
  nodes: Array<PlaySessionFormats>;
};

/** aggregate fields of "play_session_formats" */
export type PlaySessionFormatsAggregateFields = {
  __typename?: 'PlaySessionFormatsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<PlaySessionFormatsMaxFields>;
  min?: Maybe<PlaySessionFormatsMinFields>;
};


/** aggregate fields of "play_session_formats" */
export type PlaySessionFormatsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PlaySessionFormatsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "play_session_formats". All fields are combined with a logical 'AND'. */
export type PlaySessionFormatsBoolExp = {
  _and?: InputMaybe<Array<PlaySessionFormatsBoolExp>>;
  _not?: InputMaybe<PlaySessionFormatsBoolExp>;
  _or?: InputMaybe<Array<PlaySessionFormatsBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "play_session_formats" */
export enum PlaySessionFormatsConstraint {
  /** unique or primary key constraint on columns "value" */
  PlaySessionFormatsPkey = 'play_session_formats_pkey'
}

export enum PlaySessionFormatsEnum {
  Doubles = 'DOUBLES',
  OpenPlay = 'OPEN_PLAY',
  Singles = 'SINGLES'
}

/** Boolean expression to compare columns of type "PlaySessionFormatsEnum". All fields are combined with logical 'AND'. */
export type PlaySessionFormatsEnumComparisonExp = {
  _eq?: InputMaybe<PlaySessionFormatsEnum>;
  _in?: InputMaybe<Array<PlaySessionFormatsEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<PlaySessionFormatsEnum>;
  _nin?: InputMaybe<Array<PlaySessionFormatsEnum>>;
};

/** input type for inserting data into table "play_session_formats" */
export type PlaySessionFormatsInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type PlaySessionFormatsMaxFields = {
  __typename?: 'PlaySessionFormatsMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type PlaySessionFormatsMinFields = {
  __typename?: 'PlaySessionFormatsMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "play_session_formats" */
export type PlaySessionFormatsMutationResponse = {
  __typename?: 'PlaySessionFormatsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PlaySessionFormats>;
};

/** on_conflict condition type for table "play_session_formats" */
export type PlaySessionFormatsOnConflict = {
  constraint: PlaySessionFormatsConstraint;
  updateColumns?: Array<PlaySessionFormatsUpdateColumn>;
  where?: InputMaybe<PlaySessionFormatsBoolExp>;
};

/** Ordering options when selecting data from "play_session_formats". */
export type PlaySessionFormatsOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: play_session_formats */
export type PlaySessionFormatsPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "play_session_formats" */
export enum PlaySessionFormatsSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "play_session_formats" */
export type PlaySessionFormatsSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "play_session_formats" */
export type PlaySessionFormatsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PlaySessionFormatsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PlaySessionFormatsStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "play_session_formats" */
export enum PlaySessionFormatsUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type PlaySessionFormatsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PlaySessionFormatsSetInput>;
  /** filter the rows which have to be updated */
  where: PlaySessionFormatsBoolExp;
};

/** columns and relationships of "play_session_match_competitiveness" */
export type PlaySessionMatchCompetitiveness = {
  __typename?: 'PlaySessionMatchCompetitiveness';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "play_session_match_competitiveness" */
export type PlaySessionMatchCompetitivenessAggregate = {
  __typename?: 'PlaySessionMatchCompetitivenessAggregate';
  aggregate?: Maybe<PlaySessionMatchCompetitivenessAggregateFields>;
  nodes: Array<PlaySessionMatchCompetitiveness>;
};

/** aggregate fields of "play_session_match_competitiveness" */
export type PlaySessionMatchCompetitivenessAggregateFields = {
  __typename?: 'PlaySessionMatchCompetitivenessAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<PlaySessionMatchCompetitivenessMaxFields>;
  min?: Maybe<PlaySessionMatchCompetitivenessMinFields>;
};


/** aggregate fields of "play_session_match_competitiveness" */
export type PlaySessionMatchCompetitivenessAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PlaySessionMatchCompetitivenessSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "play_session_match_competitiveness". All fields are combined with a logical 'AND'. */
export type PlaySessionMatchCompetitivenessBoolExp = {
  _and?: InputMaybe<Array<PlaySessionMatchCompetitivenessBoolExp>>;
  _not?: InputMaybe<PlaySessionMatchCompetitivenessBoolExp>;
  _or?: InputMaybe<Array<PlaySessionMatchCompetitivenessBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "play_session_match_competitiveness" */
export enum PlaySessionMatchCompetitivenessConstraint {
  /** unique or primary key constraint on columns "value" */
  PlaySessionMatchCompetitivenessPkey = 'play_session_match_competitiveness_pkey'
}

export enum PlaySessionMatchCompetitivenessEnum {
  /** Recreational play */
  Casual = 'CASUAL',
  Match = 'MATCH',
  Practice = 'PRACTICE'
}

/** Boolean expression to compare columns of type "PlaySessionMatchCompetitivenessEnum". All fields are combined with logical 'AND'. */
export type PlaySessionMatchCompetitivenessEnumComparisonExp = {
  _eq?: InputMaybe<PlaySessionMatchCompetitivenessEnum>;
  _in?: InputMaybe<Array<PlaySessionMatchCompetitivenessEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<PlaySessionMatchCompetitivenessEnum>;
  _nin?: InputMaybe<Array<PlaySessionMatchCompetitivenessEnum>>;
};

/** input type for inserting data into table "play_session_match_competitiveness" */
export type PlaySessionMatchCompetitivenessInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type PlaySessionMatchCompetitivenessMaxFields = {
  __typename?: 'PlaySessionMatchCompetitivenessMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type PlaySessionMatchCompetitivenessMinFields = {
  __typename?: 'PlaySessionMatchCompetitivenessMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "play_session_match_competitiveness" */
export type PlaySessionMatchCompetitivenessMutationResponse = {
  __typename?: 'PlaySessionMatchCompetitivenessMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PlaySessionMatchCompetitiveness>;
};

/** on_conflict condition type for table "play_session_match_competitiveness" */
export type PlaySessionMatchCompetitivenessOnConflict = {
  constraint: PlaySessionMatchCompetitivenessConstraint;
  updateColumns?: Array<PlaySessionMatchCompetitivenessUpdateColumn>;
  where?: InputMaybe<PlaySessionMatchCompetitivenessBoolExp>;
};

/** Ordering options when selecting data from "play_session_match_competitiveness". */
export type PlaySessionMatchCompetitivenessOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: play_session_match_competitiveness */
export type PlaySessionMatchCompetitivenessPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "play_session_match_competitiveness" */
export enum PlaySessionMatchCompetitivenessSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "play_session_match_competitiveness" */
export type PlaySessionMatchCompetitivenessSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "play_session_match_competitiveness" */
export type PlaySessionMatchCompetitivenessStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PlaySessionMatchCompetitivenessStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PlaySessionMatchCompetitivenessStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "play_session_match_competitiveness" */
export enum PlaySessionMatchCompetitivenessUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type PlaySessionMatchCompetitivenessUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PlaySessionMatchCompetitivenessSetInput>;
  /** filter the rows which have to be updated */
  where: PlaySessionMatchCompetitivenessBoolExp;
};

/** columns and relationships of "play_session_participant_statuses" */
export type PlaySessionParticipantStatuses = {
  __typename?: 'PlaySessionParticipantStatuses';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "play_session_participant_statuses" */
export type PlaySessionParticipantStatusesAggregate = {
  __typename?: 'PlaySessionParticipantStatusesAggregate';
  aggregate?: Maybe<PlaySessionParticipantStatusesAggregateFields>;
  nodes: Array<PlaySessionParticipantStatuses>;
};

/** aggregate fields of "play_session_participant_statuses" */
export type PlaySessionParticipantStatusesAggregateFields = {
  __typename?: 'PlaySessionParticipantStatusesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<PlaySessionParticipantStatusesMaxFields>;
  min?: Maybe<PlaySessionParticipantStatusesMinFields>;
};


/** aggregate fields of "play_session_participant_statuses" */
export type PlaySessionParticipantStatusesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PlaySessionParticipantStatusesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "play_session_participant_statuses". All fields are combined with a logical 'AND'. */
export type PlaySessionParticipantStatusesBoolExp = {
  _and?: InputMaybe<Array<PlaySessionParticipantStatusesBoolExp>>;
  _not?: InputMaybe<PlaySessionParticipantStatusesBoolExp>;
  _or?: InputMaybe<Array<PlaySessionParticipantStatusesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "play_session_participant_statuses" */
export enum PlaySessionParticipantStatusesConstraint {
  /** unique or primary key constraint on columns "value" */
  PlaySessionParticipantStatusesPkey = 'play_session_participant_statuses_pkey'
}

export enum PlaySessionParticipantStatusesEnum {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Pending = 'PENDING'
}

/** Boolean expression to compare columns of type "PlaySessionParticipantStatusesEnum". All fields are combined with logical 'AND'. */
export type PlaySessionParticipantStatusesEnumComparisonExp = {
  _eq?: InputMaybe<PlaySessionParticipantStatusesEnum>;
  _in?: InputMaybe<Array<PlaySessionParticipantStatusesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<PlaySessionParticipantStatusesEnum>;
  _nin?: InputMaybe<Array<PlaySessionParticipantStatusesEnum>>;
};

/** input type for inserting data into table "play_session_participant_statuses" */
export type PlaySessionParticipantStatusesInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type PlaySessionParticipantStatusesMaxFields = {
  __typename?: 'PlaySessionParticipantStatusesMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type PlaySessionParticipantStatusesMinFields = {
  __typename?: 'PlaySessionParticipantStatusesMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "play_session_participant_statuses" */
export type PlaySessionParticipantStatusesMutationResponse = {
  __typename?: 'PlaySessionParticipantStatusesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PlaySessionParticipantStatuses>;
};

/** on_conflict condition type for table "play_session_participant_statuses" */
export type PlaySessionParticipantStatusesOnConflict = {
  constraint: PlaySessionParticipantStatusesConstraint;
  updateColumns?: Array<PlaySessionParticipantStatusesUpdateColumn>;
  where?: InputMaybe<PlaySessionParticipantStatusesBoolExp>;
};

/** Ordering options when selecting data from "play_session_participant_statuses". */
export type PlaySessionParticipantStatusesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: play_session_participant_statuses */
export type PlaySessionParticipantStatusesPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "play_session_participant_statuses" */
export enum PlaySessionParticipantStatusesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "play_session_participant_statuses" */
export type PlaySessionParticipantStatusesSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "play_session_participant_statuses" */
export type PlaySessionParticipantStatusesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PlaySessionParticipantStatusesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PlaySessionParticipantStatusesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "play_session_participant_statuses" */
export enum PlaySessionParticipantStatusesUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type PlaySessionParticipantStatusesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PlaySessionParticipantStatusesSetInput>;
  /** filter the rows which have to be updated */
  where: PlaySessionParticipantStatusesBoolExp;
};

/** columns and relationships of "play_session_participants" */
export type PlaySessionParticipants = {
  __typename?: 'PlaySessionParticipants';
  addedAt?: Maybe<Scalars['timestamptz']>;
  addedByPersona?: Maybe<AppPersonasEnum>;
  addedByUserId?: Maybe<Scalars['uuid']>;
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  /** An object relationship */
  playSession: PlaySessions;
  playSessionId: Scalars['uuid'];
  removedAt?: Maybe<Scalars['timestamptz']>;
  removedByPersona?: Maybe<AppPersonasEnum>;
  status: PlaySessionParticipantStatusesEnum;
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid'];
  /** An object relationship */
  userProfile?: Maybe<UserProfiles>;
};

/** aggregated selection of "play_session_participants" */
export type PlaySessionParticipantsAggregate = {
  __typename?: 'PlaySessionParticipantsAggregate';
  aggregate?: Maybe<PlaySessionParticipantsAggregateFields>;
  nodes: Array<PlaySessionParticipants>;
};

export type PlaySessionParticipantsAggregateBoolExp = {
  count?: InputMaybe<PlaySessionParticipantsAggregateBoolExpCount>;
};

/** aggregate fields of "play_session_participants" */
export type PlaySessionParticipantsAggregateFields = {
  __typename?: 'PlaySessionParticipantsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<PlaySessionParticipantsMaxFields>;
  min?: Maybe<PlaySessionParticipantsMinFields>;
};


/** aggregate fields of "play_session_participants" */
export type PlaySessionParticipantsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PlaySessionParticipantsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "play_session_participants" */
export type PlaySessionParticipantsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<PlaySessionParticipantsMaxOrderBy>;
  min?: InputMaybe<PlaySessionParticipantsMinOrderBy>;
};

/** input type for inserting array relation for remote table "play_session_participants" */
export type PlaySessionParticipantsArrRelInsertInput = {
  data: Array<PlaySessionParticipantsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<PlaySessionParticipantsOnConflict>;
};

/** Boolean expression to filter rows from the table "play_session_participants". All fields are combined with a logical 'AND'. */
export type PlaySessionParticipantsBoolExp = {
  _and?: InputMaybe<Array<PlaySessionParticipantsBoolExp>>;
  _not?: InputMaybe<PlaySessionParticipantsBoolExp>;
  _or?: InputMaybe<Array<PlaySessionParticipantsBoolExp>>;
  addedAt?: InputMaybe<TimestamptzComparisonExp>;
  addedByPersona?: InputMaybe<AppPersonasEnumComparisonExp>;
  addedByUserId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  playSession?: InputMaybe<PlaySessionsBoolExp>;
  playSessionId?: InputMaybe<UuidComparisonExp>;
  removedAt?: InputMaybe<TimestamptzComparisonExp>;
  removedByPersona?: InputMaybe<AppPersonasEnumComparisonExp>;
  status?: InputMaybe<PlaySessionParticipantStatusesEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
  userProfile?: InputMaybe<UserProfilesBoolExp>;
};

/** unique or primary key constraints on table "play_session_participants" */
export enum PlaySessionParticipantsConstraint {
  /** unique or primary key constraint on columns "id" */
  PlaySessionParticipantsPkey = 'play_session_participants_pkey',
  /** unique or primary key constraint on columns "user_id", "play_session_id" */
  PlaySessionParticipantsPlaySessionIdUserIdKey = 'play_session_participants_play_session_id_user_id_key'
}

/** input type for inserting data into table "play_session_participants" */
export type PlaySessionParticipantsInsertInput = {
  addedAt?: InputMaybe<Scalars['timestamptz']>;
  addedByPersona?: InputMaybe<AppPersonasEnum>;
  addedByUserId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  playSession?: InputMaybe<PlaySessionsObjRelInsertInput>;
  playSessionId?: InputMaybe<Scalars['uuid']>;
  removedAt?: InputMaybe<Scalars['timestamptz']>;
  removedByPersona?: InputMaybe<AppPersonasEnum>;
  status?: InputMaybe<PlaySessionParticipantStatusesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']>;
  userProfile?: InputMaybe<UserProfilesObjRelInsertInput>;
};

/** aggregate max on columns */
export type PlaySessionParticipantsMaxFields = {
  __typename?: 'PlaySessionParticipantsMaxFields';
  addedAt?: Maybe<Scalars['timestamptz']>;
  addedByUserId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  playSessionId?: Maybe<Scalars['uuid']>;
  removedAt?: Maybe<Scalars['timestamptz']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "play_session_participants" */
export type PlaySessionParticipantsMaxOrderBy = {
  addedAt?: InputMaybe<OrderBy>;
  addedByUserId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  playSessionId?: InputMaybe<OrderBy>;
  removedAt?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type PlaySessionParticipantsMinFields = {
  __typename?: 'PlaySessionParticipantsMinFields';
  addedAt?: Maybe<Scalars['timestamptz']>;
  addedByUserId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  playSessionId?: Maybe<Scalars['uuid']>;
  removedAt?: Maybe<Scalars['timestamptz']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "play_session_participants" */
export type PlaySessionParticipantsMinOrderBy = {
  addedAt?: InputMaybe<OrderBy>;
  addedByUserId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  playSessionId?: InputMaybe<OrderBy>;
  removedAt?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "play_session_participants" */
export type PlaySessionParticipantsMutationResponse = {
  __typename?: 'PlaySessionParticipantsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PlaySessionParticipants>;
};

/** on_conflict condition type for table "play_session_participants" */
export type PlaySessionParticipantsOnConflict = {
  constraint: PlaySessionParticipantsConstraint;
  updateColumns?: Array<PlaySessionParticipantsUpdateColumn>;
  where?: InputMaybe<PlaySessionParticipantsBoolExp>;
};

/** Ordering options when selecting data from "play_session_participants". */
export type PlaySessionParticipantsOrderBy = {
  addedAt?: InputMaybe<OrderBy>;
  addedByPersona?: InputMaybe<OrderBy>;
  addedByUserId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  playSession?: InputMaybe<PlaySessionsOrderBy>;
  playSessionId?: InputMaybe<OrderBy>;
  removedAt?: InputMaybe<OrderBy>;
  removedByPersona?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
  userProfile?: InputMaybe<UserProfilesOrderBy>;
};

/** primary key columns input for table: play_session_participants */
export type PlaySessionParticipantsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "play_session_participants" */
export enum PlaySessionParticipantsSelectColumn {
  /** column name */
  AddedAt = 'addedAt',
  /** column name */
  AddedByPersona = 'addedByPersona',
  /** column name */
  AddedByUserId = 'addedByUserId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  PlaySessionId = 'playSessionId',
  /** column name */
  RemovedAt = 'removedAt',
  /** column name */
  RemovedByPersona = 'removedByPersona',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "play_session_participants" */
export type PlaySessionParticipantsSetInput = {
  addedAt?: InputMaybe<Scalars['timestamptz']>;
  addedByPersona?: InputMaybe<AppPersonasEnum>;
  addedByUserId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  playSessionId?: InputMaybe<Scalars['uuid']>;
  removedAt?: InputMaybe<Scalars['timestamptz']>;
  removedByPersona?: InputMaybe<AppPersonasEnum>;
  status?: InputMaybe<PlaySessionParticipantStatusesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "play_session_participants" */
export type PlaySessionParticipantsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PlaySessionParticipantsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PlaySessionParticipantsStreamCursorValueInput = {
  addedAt?: InputMaybe<Scalars['timestamptz']>;
  addedByPersona?: InputMaybe<AppPersonasEnum>;
  addedByUserId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  playSessionId?: InputMaybe<Scalars['uuid']>;
  removedAt?: InputMaybe<Scalars['timestamptz']>;
  removedByPersona?: InputMaybe<AppPersonasEnum>;
  status?: InputMaybe<PlaySessionParticipantStatusesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "play_session_participants" */
export enum PlaySessionParticipantsUpdateColumn {
  /** column name */
  AddedAt = 'addedAt',
  /** column name */
  AddedByPersona = 'addedByPersona',
  /** column name */
  AddedByUserId = 'addedByUserId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  PlaySessionId = 'playSessionId',
  /** column name */
  RemovedAt = 'removedAt',
  /** column name */
  RemovedByPersona = 'removedByPersona',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

export type PlaySessionParticipantsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PlaySessionParticipantsSetInput>;
  /** filter the rows which have to be updated */
  where: PlaySessionParticipantsBoolExp;
};

/** columns and relationships of "play_session_privacy" */
export type PlaySessionPrivacy = {
  __typename?: 'PlaySessionPrivacy';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "play_session_privacy" */
export type PlaySessionPrivacyAggregate = {
  __typename?: 'PlaySessionPrivacyAggregate';
  aggregate?: Maybe<PlaySessionPrivacyAggregateFields>;
  nodes: Array<PlaySessionPrivacy>;
};

/** aggregate fields of "play_session_privacy" */
export type PlaySessionPrivacyAggregateFields = {
  __typename?: 'PlaySessionPrivacyAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<PlaySessionPrivacyMaxFields>;
  min?: Maybe<PlaySessionPrivacyMinFields>;
};


/** aggregate fields of "play_session_privacy" */
export type PlaySessionPrivacyAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PlaySessionPrivacySelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "play_session_privacy". All fields are combined with a logical 'AND'. */
export type PlaySessionPrivacyBoolExp = {
  _and?: InputMaybe<Array<PlaySessionPrivacyBoolExp>>;
  _not?: InputMaybe<PlaySessionPrivacyBoolExp>;
  _or?: InputMaybe<Array<PlaySessionPrivacyBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "play_session_privacy" */
export enum PlaySessionPrivacyConstraint {
  /** unique or primary key constraint on columns "value" */
  PlaySessionPrivacyPkey = 'play_session_privacy_pkey'
}

export enum PlaySessionPrivacyEnum {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

/** Boolean expression to compare columns of type "PlaySessionPrivacyEnum". All fields are combined with logical 'AND'. */
export type PlaySessionPrivacyEnumComparisonExp = {
  _eq?: InputMaybe<PlaySessionPrivacyEnum>;
  _in?: InputMaybe<Array<PlaySessionPrivacyEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<PlaySessionPrivacyEnum>;
  _nin?: InputMaybe<Array<PlaySessionPrivacyEnum>>;
};

/** input type for inserting data into table "play_session_privacy" */
export type PlaySessionPrivacyInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type PlaySessionPrivacyMaxFields = {
  __typename?: 'PlaySessionPrivacyMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type PlaySessionPrivacyMinFields = {
  __typename?: 'PlaySessionPrivacyMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "play_session_privacy" */
export type PlaySessionPrivacyMutationResponse = {
  __typename?: 'PlaySessionPrivacyMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PlaySessionPrivacy>;
};

/** on_conflict condition type for table "play_session_privacy" */
export type PlaySessionPrivacyOnConflict = {
  constraint: PlaySessionPrivacyConstraint;
  updateColumns?: Array<PlaySessionPrivacyUpdateColumn>;
  where?: InputMaybe<PlaySessionPrivacyBoolExp>;
};

/** Ordering options when selecting data from "play_session_privacy". */
export type PlaySessionPrivacyOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: play_session_privacy */
export type PlaySessionPrivacyPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "play_session_privacy" */
export enum PlaySessionPrivacySelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "play_session_privacy" */
export type PlaySessionPrivacySetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "play_session_privacy" */
export type PlaySessionPrivacyStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PlaySessionPrivacyStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PlaySessionPrivacyStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "play_session_privacy" */
export enum PlaySessionPrivacyUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type PlaySessionPrivacyUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PlaySessionPrivacySetInput>;
  /** filter the rows which have to be updated */
  where: PlaySessionPrivacyBoolExp;
};

/** columns and relationships of "play_session_statuses" */
export type PlaySessionStatuses = {
  __typename?: 'PlaySessionStatuses';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "play_session_statuses" */
export type PlaySessionStatusesAggregate = {
  __typename?: 'PlaySessionStatusesAggregate';
  aggregate?: Maybe<PlaySessionStatusesAggregateFields>;
  nodes: Array<PlaySessionStatuses>;
};

/** aggregate fields of "play_session_statuses" */
export type PlaySessionStatusesAggregateFields = {
  __typename?: 'PlaySessionStatusesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<PlaySessionStatusesMaxFields>;
  min?: Maybe<PlaySessionStatusesMinFields>;
};


/** aggregate fields of "play_session_statuses" */
export type PlaySessionStatusesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PlaySessionStatusesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "play_session_statuses". All fields are combined with a logical 'AND'. */
export type PlaySessionStatusesBoolExp = {
  _and?: InputMaybe<Array<PlaySessionStatusesBoolExp>>;
  _not?: InputMaybe<PlaySessionStatusesBoolExp>;
  _or?: InputMaybe<Array<PlaySessionStatusesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "play_session_statuses" */
export enum PlaySessionStatusesConstraint {
  /** unique or primary key constraint on columns "value" */
  PlaySessionStatusesPkey = 'play_session_statuses_pkey'
}

export enum PlaySessionStatusesEnum {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  Pending = 'PENDING'
}

/** Boolean expression to compare columns of type "PlaySessionStatusesEnum". All fields are combined with logical 'AND'. */
export type PlaySessionStatusesEnumComparisonExp = {
  _eq?: InputMaybe<PlaySessionStatusesEnum>;
  _in?: InputMaybe<Array<PlaySessionStatusesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<PlaySessionStatusesEnum>;
  _nin?: InputMaybe<Array<PlaySessionStatusesEnum>>;
};

/** input type for inserting data into table "play_session_statuses" */
export type PlaySessionStatusesInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type PlaySessionStatusesMaxFields = {
  __typename?: 'PlaySessionStatusesMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type PlaySessionStatusesMinFields = {
  __typename?: 'PlaySessionStatusesMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "play_session_statuses" */
export type PlaySessionStatusesMutationResponse = {
  __typename?: 'PlaySessionStatusesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PlaySessionStatuses>;
};

/** on_conflict condition type for table "play_session_statuses" */
export type PlaySessionStatusesOnConflict = {
  constraint: PlaySessionStatusesConstraint;
  updateColumns?: Array<PlaySessionStatusesUpdateColumn>;
  where?: InputMaybe<PlaySessionStatusesBoolExp>;
};

/** Ordering options when selecting data from "play_session_statuses". */
export type PlaySessionStatusesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: play_session_statuses */
export type PlaySessionStatusesPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "play_session_statuses" */
export enum PlaySessionStatusesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "play_session_statuses" */
export type PlaySessionStatusesSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "play_session_statuses" */
export type PlaySessionStatusesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PlaySessionStatusesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PlaySessionStatusesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "play_session_statuses" */
export enum PlaySessionStatusesUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type PlaySessionStatusesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PlaySessionStatusesSetInput>;
  /** filter the rows which have to be updated */
  where: PlaySessionStatusesBoolExp;
};

/** columns and relationships of "play_sessions" */
export type PlaySessions = {
  __typename?: 'PlaySessions';
  cancelReason: Scalars['String'];
  canceledAt?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  comments: Array<PlaySessionComments>;
  /** An aggregate relationship */
  commentsAggregate: PlaySessionCommentsAggregate;
  competitiveness?: Maybe<PlaySessionMatchCompetitivenessEnum>;
  courtBookingStatus: PlaySessionCourtBookingStatusesEnum;
  createdAt: Scalars['timestamptz'];
  currency: Scalars['String'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  description: Scalars['String'];
  endDateTime?: Maybe<Scalars['timestamptz']>;
  extraRacketCount?: Maybe<Scalars['Int']>;
  format: PlaySessionFormatsEnum;
  /** An object relationship */
  group?: Maybe<Groups>;
  groupId?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  groupsPlaySessions: Array<GroupsPlaySessions>;
  /** An aggregate relationship */
  groupsPlaySessionsAggregate: GroupsPlaySessionsAggregate;
  id: Scalars['uuid'];
  isBringingNet: Scalars['Boolean'];
  locale: Scalars['String'];
  /** An object relationship */
  organizer?: Maybe<Users>;
  /** An object relationship */
  organizerProfile?: Maybe<UserProfiles>;
  organizerUserId?: Maybe<Scalars['uuid']>;
  participantLimit?: Maybe<Scalars['Int']>;
  /** An array relationship */
  participants: Array<PlaySessionParticipants>;
  /** An aggregate relationship */
  participantsAggregate: PlaySessionParticipantsAggregate;
  /** An object relationship */
  pickleballRatingScale?: Maybe<PickleballRatingScales>;
  pickleballRatingScaleId?: Maybe<Scalars['uuid']>;
  priceUnitAmount: Scalars['Int'];
  privacy: PlaySessionPrivacyEnum;
  publishedAt?: Maybe<Scalars['timestamptz']>;
  reminderEventId?: Maybe<Scalars['uuid']>;
  skillRatingMaximum?: Maybe<Scalars['numeric']>;
  skillRatingMinimum?: Maybe<Scalars['numeric']>;
  sport: SportsEnum;
  startDateTime?: Maybe<Scalars['timestamptz']>;
  status: PlaySessionStatusesEnum;
  targetSkillLevel?: Maybe<Scalars['String']>;
  /** An object relationship */
  tennisRatingScale?: Maybe<TennisRatingScales>;
  tennisRatingScaleId?: Maybe<Scalars['uuid']>;
  timezoneAbbreviation: Scalars['String'];
  timezoneName: Scalars['String'];
  timezoneOffsetMinutes: Scalars['Int'];
  title: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  userCustomCourt?: Maybe<UserCustomCourts>;
  userCustomCourtId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  venue?: Maybe<Venues>;
  venueId?: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "play_sessions" */
export type PlaySessionsCommentsArgs = {
  distinctOn?: InputMaybe<Array<PlaySessionCommentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlaySessionCommentsOrderBy>>;
  where?: InputMaybe<PlaySessionCommentsBoolExp>;
};


/** columns and relationships of "play_sessions" */
export type PlaySessionsCommentsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PlaySessionCommentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlaySessionCommentsOrderBy>>;
  where?: InputMaybe<PlaySessionCommentsBoolExp>;
};


/** columns and relationships of "play_sessions" */
export type PlaySessionsGroupsPlaySessionsArgs = {
  distinctOn?: InputMaybe<Array<GroupsPlaySessionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupsPlaySessionsOrderBy>>;
  where?: InputMaybe<GroupsPlaySessionsBoolExp>;
};


/** columns and relationships of "play_sessions" */
export type PlaySessionsGroupsPlaySessionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<GroupsPlaySessionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupsPlaySessionsOrderBy>>;
  where?: InputMaybe<GroupsPlaySessionsBoolExp>;
};


/** columns and relationships of "play_sessions" */
export type PlaySessionsParticipantsArgs = {
  distinctOn?: InputMaybe<Array<PlaySessionParticipantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlaySessionParticipantsOrderBy>>;
  where?: InputMaybe<PlaySessionParticipantsBoolExp>;
};


/** columns and relationships of "play_sessions" */
export type PlaySessionsParticipantsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PlaySessionParticipantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlaySessionParticipantsOrderBy>>;
  where?: InputMaybe<PlaySessionParticipantsBoolExp>;
};

/** aggregated selection of "play_sessions" */
export type PlaySessionsAggregate = {
  __typename?: 'PlaySessionsAggregate';
  aggregate?: Maybe<PlaySessionsAggregateFields>;
  nodes: Array<PlaySessions>;
};

export type PlaySessionsAggregateBoolExp = {
  bool_and?: InputMaybe<PlaySessionsAggregateBoolExpBool_And>;
  bool_or?: InputMaybe<PlaySessionsAggregateBoolExpBool_Or>;
  count?: InputMaybe<PlaySessionsAggregateBoolExpCount>;
};

/** aggregate fields of "play_sessions" */
export type PlaySessionsAggregateFields = {
  __typename?: 'PlaySessionsAggregateFields';
  avg?: Maybe<PlaySessionsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<PlaySessionsMaxFields>;
  min?: Maybe<PlaySessionsMinFields>;
  stddev?: Maybe<PlaySessionsStddevFields>;
  stddevPop?: Maybe<PlaySessionsStddevPopFields>;
  stddevSamp?: Maybe<PlaySessionsStddevSampFields>;
  sum?: Maybe<PlaySessionsSumFields>;
  varPop?: Maybe<PlaySessionsVarPopFields>;
  varSamp?: Maybe<PlaySessionsVarSampFields>;
  variance?: Maybe<PlaySessionsVarianceFields>;
};


/** aggregate fields of "play_sessions" */
export type PlaySessionsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PlaySessionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "play_sessions" */
export type PlaySessionsAggregateOrderBy = {
  avg?: InputMaybe<PlaySessionsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<PlaySessionsMaxOrderBy>;
  min?: InputMaybe<PlaySessionsMinOrderBy>;
  stddev?: InputMaybe<PlaySessionsStddevOrderBy>;
  stddevPop?: InputMaybe<PlaySessionsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<PlaySessionsStddevSampOrderBy>;
  sum?: InputMaybe<PlaySessionsSumOrderBy>;
  varPop?: InputMaybe<PlaySessionsVarPopOrderBy>;
  varSamp?: InputMaybe<PlaySessionsVarSampOrderBy>;
  variance?: InputMaybe<PlaySessionsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "play_sessions" */
export type PlaySessionsArrRelInsertInput = {
  data: Array<PlaySessionsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<PlaySessionsOnConflict>;
};

/** aggregate avg on columns */
export type PlaySessionsAvgFields = {
  __typename?: 'PlaySessionsAvgFields';
  extraRacketCount?: Maybe<Scalars['Float']>;
  participantLimit?: Maybe<Scalars['Float']>;
  priceUnitAmount?: Maybe<Scalars['Float']>;
  skillRatingMaximum?: Maybe<Scalars['Float']>;
  skillRatingMinimum?: Maybe<Scalars['Float']>;
  timezoneOffsetMinutes?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "play_sessions" */
export type PlaySessionsAvgOrderBy = {
  extraRacketCount?: InputMaybe<OrderBy>;
  participantLimit?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  skillRatingMaximum?: InputMaybe<OrderBy>;
  skillRatingMinimum?: InputMaybe<OrderBy>;
  timezoneOffsetMinutes?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "play_sessions". All fields are combined with a logical 'AND'. */
export type PlaySessionsBoolExp = {
  _and?: InputMaybe<Array<PlaySessionsBoolExp>>;
  _not?: InputMaybe<PlaySessionsBoolExp>;
  _or?: InputMaybe<Array<PlaySessionsBoolExp>>;
  cancelReason?: InputMaybe<StringComparisonExp>;
  canceledAt?: InputMaybe<TimestamptzComparisonExp>;
  comments?: InputMaybe<PlaySessionCommentsBoolExp>;
  commentsAggregate?: InputMaybe<PlaySessionCommentsAggregateBoolExp>;
  competitiveness?: InputMaybe<PlaySessionMatchCompetitivenessEnumComparisonExp>;
  courtBookingStatus?: InputMaybe<PlaySessionCourtBookingStatusesEnumComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  currency?: InputMaybe<StringComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  endDateTime?: InputMaybe<TimestamptzComparisonExp>;
  extraRacketCount?: InputMaybe<IntComparisonExp>;
  format?: InputMaybe<PlaySessionFormatsEnumComparisonExp>;
  group?: InputMaybe<GroupsBoolExp>;
  groupId?: InputMaybe<UuidComparisonExp>;
  groupsPlaySessions?: InputMaybe<GroupsPlaySessionsBoolExp>;
  groupsPlaySessionsAggregate?: InputMaybe<GroupsPlaySessionsAggregateBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isBringingNet?: InputMaybe<BooleanComparisonExp>;
  locale?: InputMaybe<StringComparisonExp>;
  organizer?: InputMaybe<UsersBoolExp>;
  organizerProfile?: InputMaybe<UserProfilesBoolExp>;
  organizerUserId?: InputMaybe<UuidComparisonExp>;
  participantLimit?: InputMaybe<IntComparisonExp>;
  participants?: InputMaybe<PlaySessionParticipantsBoolExp>;
  participantsAggregate?: InputMaybe<PlaySessionParticipantsAggregateBoolExp>;
  pickleballRatingScale?: InputMaybe<PickleballRatingScalesBoolExp>;
  pickleballRatingScaleId?: InputMaybe<UuidComparisonExp>;
  priceUnitAmount?: InputMaybe<IntComparisonExp>;
  privacy?: InputMaybe<PlaySessionPrivacyEnumComparisonExp>;
  publishedAt?: InputMaybe<TimestamptzComparisonExp>;
  reminderEventId?: InputMaybe<UuidComparisonExp>;
  skillRatingMaximum?: InputMaybe<NumericComparisonExp>;
  skillRatingMinimum?: InputMaybe<NumericComparisonExp>;
  sport?: InputMaybe<SportsEnumComparisonExp>;
  startDateTime?: InputMaybe<TimestamptzComparisonExp>;
  status?: InputMaybe<PlaySessionStatusesEnumComparisonExp>;
  targetSkillLevel?: InputMaybe<StringComparisonExp>;
  tennisRatingScale?: InputMaybe<TennisRatingScalesBoolExp>;
  tennisRatingScaleId?: InputMaybe<UuidComparisonExp>;
  timezoneAbbreviation?: InputMaybe<StringComparisonExp>;
  timezoneName?: InputMaybe<StringComparisonExp>;
  timezoneOffsetMinutes?: InputMaybe<IntComparisonExp>;
  title?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  userCustomCourt?: InputMaybe<UserCustomCourtsBoolExp>;
  userCustomCourtId?: InputMaybe<UuidComparisonExp>;
  venue?: InputMaybe<VenuesBoolExp>;
  venueId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "play_sessions" */
export enum PlaySessionsConstraint {
  /** unique or primary key constraint on columns "id" */
  PlaySessionsPkey = 'play_sessions_pkey'
}

/** input type for incrementing numeric columns in table "play_sessions" */
export type PlaySessionsIncInput = {
  extraRacketCount?: InputMaybe<Scalars['Int']>;
  participantLimit?: InputMaybe<Scalars['Int']>;
  priceUnitAmount?: InputMaybe<Scalars['Int']>;
  skillRatingMaximum?: InputMaybe<Scalars['numeric']>;
  skillRatingMinimum?: InputMaybe<Scalars['numeric']>;
  timezoneOffsetMinutes?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "play_sessions" */
export type PlaySessionsInsertInput = {
  cancelReason?: InputMaybe<Scalars['String']>;
  canceledAt?: InputMaybe<Scalars['timestamptz']>;
  comments?: InputMaybe<PlaySessionCommentsArrRelInsertInput>;
  competitiveness?: InputMaybe<PlaySessionMatchCompetitivenessEnum>;
  courtBookingStatus?: InputMaybe<PlaySessionCourtBookingStatusesEnum>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  endDateTime?: InputMaybe<Scalars['timestamptz']>;
  extraRacketCount?: InputMaybe<Scalars['Int']>;
  format?: InputMaybe<PlaySessionFormatsEnum>;
  group?: InputMaybe<GroupsObjRelInsertInput>;
  groupId?: InputMaybe<Scalars['uuid']>;
  groupsPlaySessions?: InputMaybe<GroupsPlaySessionsArrRelInsertInput>;
  id?: InputMaybe<Scalars['uuid']>;
  isBringingNet?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
  organizer?: InputMaybe<UsersObjRelInsertInput>;
  organizerProfile?: InputMaybe<UserProfilesObjRelInsertInput>;
  organizerUserId?: InputMaybe<Scalars['uuid']>;
  participantLimit?: InputMaybe<Scalars['Int']>;
  participants?: InputMaybe<PlaySessionParticipantsArrRelInsertInput>;
  pickleballRatingScale?: InputMaybe<PickleballRatingScalesObjRelInsertInput>;
  pickleballRatingScaleId?: InputMaybe<Scalars['uuid']>;
  priceUnitAmount?: InputMaybe<Scalars['Int']>;
  privacy?: InputMaybe<PlaySessionPrivacyEnum>;
  publishedAt?: InputMaybe<Scalars['timestamptz']>;
  reminderEventId?: InputMaybe<Scalars['uuid']>;
  skillRatingMaximum?: InputMaybe<Scalars['numeric']>;
  skillRatingMinimum?: InputMaybe<Scalars['numeric']>;
  sport?: InputMaybe<SportsEnum>;
  startDateTime?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<PlaySessionStatusesEnum>;
  targetSkillLevel?: InputMaybe<Scalars['String']>;
  tennisRatingScale?: InputMaybe<TennisRatingScalesObjRelInsertInput>;
  tennisRatingScaleId?: InputMaybe<Scalars['uuid']>;
  timezoneAbbreviation?: InputMaybe<Scalars['String']>;
  timezoneName?: InputMaybe<Scalars['String']>;
  timezoneOffsetMinutes?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userCustomCourt?: InputMaybe<UserCustomCourtsObjRelInsertInput>;
  userCustomCourtId?: InputMaybe<Scalars['uuid']>;
  venue?: InputMaybe<VenuesObjRelInsertInput>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type PlaySessionsMaxFields = {
  __typename?: 'PlaySessionsMaxFields';
  cancelReason?: Maybe<Scalars['String']>;
  canceledAt?: Maybe<Scalars['timestamptz']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  endDateTime?: Maybe<Scalars['timestamptz']>;
  extraRacketCount?: Maybe<Scalars['Int']>;
  groupId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  locale?: Maybe<Scalars['String']>;
  organizerUserId?: Maybe<Scalars['uuid']>;
  participantLimit?: Maybe<Scalars['Int']>;
  pickleballRatingScaleId?: Maybe<Scalars['uuid']>;
  priceUnitAmount?: Maybe<Scalars['Int']>;
  publishedAt?: Maybe<Scalars['timestamptz']>;
  reminderEventId?: Maybe<Scalars['uuid']>;
  skillRatingMaximum?: Maybe<Scalars['numeric']>;
  skillRatingMinimum?: Maybe<Scalars['numeric']>;
  startDateTime?: Maybe<Scalars['timestamptz']>;
  targetSkillLevel?: Maybe<Scalars['String']>;
  tennisRatingScaleId?: Maybe<Scalars['uuid']>;
  timezoneAbbreviation?: Maybe<Scalars['String']>;
  timezoneName?: Maybe<Scalars['String']>;
  timezoneOffsetMinutes?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userCustomCourtId?: Maybe<Scalars['uuid']>;
  venueId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "play_sessions" */
export type PlaySessionsMaxOrderBy = {
  cancelReason?: InputMaybe<OrderBy>;
  canceledAt?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  currency?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  endDateTime?: InputMaybe<OrderBy>;
  extraRacketCount?: InputMaybe<OrderBy>;
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  locale?: InputMaybe<OrderBy>;
  organizerUserId?: InputMaybe<OrderBy>;
  participantLimit?: InputMaybe<OrderBy>;
  pickleballRatingScaleId?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  publishedAt?: InputMaybe<OrderBy>;
  reminderEventId?: InputMaybe<OrderBy>;
  skillRatingMaximum?: InputMaybe<OrderBy>;
  skillRatingMinimum?: InputMaybe<OrderBy>;
  startDateTime?: InputMaybe<OrderBy>;
  targetSkillLevel?: InputMaybe<OrderBy>;
  tennisRatingScaleId?: InputMaybe<OrderBy>;
  timezoneAbbreviation?: InputMaybe<OrderBy>;
  timezoneName?: InputMaybe<OrderBy>;
  timezoneOffsetMinutes?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userCustomCourtId?: InputMaybe<OrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type PlaySessionsMinFields = {
  __typename?: 'PlaySessionsMinFields';
  cancelReason?: Maybe<Scalars['String']>;
  canceledAt?: Maybe<Scalars['timestamptz']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  endDateTime?: Maybe<Scalars['timestamptz']>;
  extraRacketCount?: Maybe<Scalars['Int']>;
  groupId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  locale?: Maybe<Scalars['String']>;
  organizerUserId?: Maybe<Scalars['uuid']>;
  participantLimit?: Maybe<Scalars['Int']>;
  pickleballRatingScaleId?: Maybe<Scalars['uuid']>;
  priceUnitAmount?: Maybe<Scalars['Int']>;
  publishedAt?: Maybe<Scalars['timestamptz']>;
  reminderEventId?: Maybe<Scalars['uuid']>;
  skillRatingMaximum?: Maybe<Scalars['numeric']>;
  skillRatingMinimum?: Maybe<Scalars['numeric']>;
  startDateTime?: Maybe<Scalars['timestamptz']>;
  targetSkillLevel?: Maybe<Scalars['String']>;
  tennisRatingScaleId?: Maybe<Scalars['uuid']>;
  timezoneAbbreviation?: Maybe<Scalars['String']>;
  timezoneName?: Maybe<Scalars['String']>;
  timezoneOffsetMinutes?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userCustomCourtId?: Maybe<Scalars['uuid']>;
  venueId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "play_sessions" */
export type PlaySessionsMinOrderBy = {
  cancelReason?: InputMaybe<OrderBy>;
  canceledAt?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  currency?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  endDateTime?: InputMaybe<OrderBy>;
  extraRacketCount?: InputMaybe<OrderBy>;
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  locale?: InputMaybe<OrderBy>;
  organizerUserId?: InputMaybe<OrderBy>;
  participantLimit?: InputMaybe<OrderBy>;
  pickleballRatingScaleId?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  publishedAt?: InputMaybe<OrderBy>;
  reminderEventId?: InputMaybe<OrderBy>;
  skillRatingMaximum?: InputMaybe<OrderBy>;
  skillRatingMinimum?: InputMaybe<OrderBy>;
  startDateTime?: InputMaybe<OrderBy>;
  targetSkillLevel?: InputMaybe<OrderBy>;
  tennisRatingScaleId?: InputMaybe<OrderBy>;
  timezoneAbbreviation?: InputMaybe<OrderBy>;
  timezoneName?: InputMaybe<OrderBy>;
  timezoneOffsetMinutes?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userCustomCourtId?: InputMaybe<OrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "play_sessions" */
export type PlaySessionsMutationResponse = {
  __typename?: 'PlaySessionsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PlaySessions>;
};

/** input type for inserting object relation for remote table "play_sessions" */
export type PlaySessionsObjRelInsertInput = {
  data: PlaySessionsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<PlaySessionsOnConflict>;
};

/** on_conflict condition type for table "play_sessions" */
export type PlaySessionsOnConflict = {
  constraint: PlaySessionsConstraint;
  updateColumns?: Array<PlaySessionsUpdateColumn>;
  where?: InputMaybe<PlaySessionsBoolExp>;
};

/** Ordering options when selecting data from "play_sessions". */
export type PlaySessionsOrderBy = {
  cancelReason?: InputMaybe<OrderBy>;
  canceledAt?: InputMaybe<OrderBy>;
  commentsAggregate?: InputMaybe<PlaySessionCommentsAggregateOrderBy>;
  competitiveness?: InputMaybe<OrderBy>;
  courtBookingStatus?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  currency?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  endDateTime?: InputMaybe<OrderBy>;
  extraRacketCount?: InputMaybe<OrderBy>;
  format?: InputMaybe<OrderBy>;
  group?: InputMaybe<GroupsOrderBy>;
  groupId?: InputMaybe<OrderBy>;
  groupsPlaySessionsAggregate?: InputMaybe<GroupsPlaySessionsAggregateOrderBy>;
  id?: InputMaybe<OrderBy>;
  isBringingNet?: InputMaybe<OrderBy>;
  locale?: InputMaybe<OrderBy>;
  organizer?: InputMaybe<UsersOrderBy>;
  organizerProfile?: InputMaybe<UserProfilesOrderBy>;
  organizerUserId?: InputMaybe<OrderBy>;
  participantLimit?: InputMaybe<OrderBy>;
  participantsAggregate?: InputMaybe<PlaySessionParticipantsAggregateOrderBy>;
  pickleballRatingScale?: InputMaybe<PickleballRatingScalesOrderBy>;
  pickleballRatingScaleId?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  privacy?: InputMaybe<OrderBy>;
  publishedAt?: InputMaybe<OrderBy>;
  reminderEventId?: InputMaybe<OrderBy>;
  skillRatingMaximum?: InputMaybe<OrderBy>;
  skillRatingMinimum?: InputMaybe<OrderBy>;
  sport?: InputMaybe<OrderBy>;
  startDateTime?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  targetSkillLevel?: InputMaybe<OrderBy>;
  tennisRatingScale?: InputMaybe<TennisRatingScalesOrderBy>;
  tennisRatingScaleId?: InputMaybe<OrderBy>;
  timezoneAbbreviation?: InputMaybe<OrderBy>;
  timezoneName?: InputMaybe<OrderBy>;
  timezoneOffsetMinutes?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userCustomCourt?: InputMaybe<UserCustomCourtsOrderBy>;
  userCustomCourtId?: InputMaybe<OrderBy>;
  venue?: InputMaybe<VenuesOrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: play_sessions */
export type PlaySessionsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "play_sessions" */
export enum PlaySessionsSelectColumn {
  /** column name */
  CancelReason = 'cancelReason',
  /** column name */
  CanceledAt = 'canceledAt',
  /** column name */
  Competitiveness = 'competitiveness',
  /** column name */
  CourtBookingStatus = 'courtBookingStatus',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Currency = 'currency',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Description = 'description',
  /** column name */
  EndDateTime = 'endDateTime',
  /** column name */
  ExtraRacketCount = 'extraRacketCount',
  /** column name */
  Format = 'format',
  /** column name */
  GroupId = 'groupId',
  /** column name */
  Id = 'id',
  /** column name */
  IsBringingNet = 'isBringingNet',
  /** column name */
  Locale = 'locale',
  /** column name */
  OrganizerUserId = 'organizerUserId',
  /** column name */
  ParticipantLimit = 'participantLimit',
  /** column name */
  PickleballRatingScaleId = 'pickleballRatingScaleId',
  /** column name */
  PriceUnitAmount = 'priceUnitAmount',
  /** column name */
  Privacy = 'privacy',
  /** column name */
  PublishedAt = 'publishedAt',
  /** column name */
  ReminderEventId = 'reminderEventId',
  /** column name */
  SkillRatingMaximum = 'skillRatingMaximum',
  /** column name */
  SkillRatingMinimum = 'skillRatingMinimum',
  /** column name */
  Sport = 'sport',
  /** column name */
  StartDateTime = 'startDateTime',
  /** column name */
  Status = 'status',
  /** column name */
  TargetSkillLevel = 'targetSkillLevel',
  /** column name */
  TennisRatingScaleId = 'tennisRatingScaleId',
  /** column name */
  TimezoneAbbreviation = 'timezoneAbbreviation',
  /** column name */
  TimezoneName = 'timezoneName',
  /** column name */
  TimezoneOffsetMinutes = 'timezoneOffsetMinutes',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserCustomCourtId = 'userCustomCourtId',
  /** column name */
  VenueId = 'venueId'
}

/** select "playSessionsAggregateBoolExpBool_andArgumentsColumns" columns of table "play_sessions" */
export enum PlaySessionsSelectColumnPlaySessionsAggregateBoolExpBool_AndArgumentsColumns {
  /** column name */
  IsBringingNet = 'isBringingNet'
}

/** select "playSessionsAggregateBoolExpBool_orArgumentsColumns" columns of table "play_sessions" */
export enum PlaySessionsSelectColumnPlaySessionsAggregateBoolExpBool_OrArgumentsColumns {
  /** column name */
  IsBringingNet = 'isBringingNet'
}

/** input type for updating data in table "play_sessions" */
export type PlaySessionsSetInput = {
  cancelReason?: InputMaybe<Scalars['String']>;
  canceledAt?: InputMaybe<Scalars['timestamptz']>;
  competitiveness?: InputMaybe<PlaySessionMatchCompetitivenessEnum>;
  courtBookingStatus?: InputMaybe<PlaySessionCourtBookingStatusesEnum>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  endDateTime?: InputMaybe<Scalars['timestamptz']>;
  extraRacketCount?: InputMaybe<Scalars['Int']>;
  format?: InputMaybe<PlaySessionFormatsEnum>;
  groupId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  isBringingNet?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
  organizerUserId?: InputMaybe<Scalars['uuid']>;
  participantLimit?: InputMaybe<Scalars['Int']>;
  pickleballRatingScaleId?: InputMaybe<Scalars['uuid']>;
  priceUnitAmount?: InputMaybe<Scalars['Int']>;
  privacy?: InputMaybe<PlaySessionPrivacyEnum>;
  publishedAt?: InputMaybe<Scalars['timestamptz']>;
  reminderEventId?: InputMaybe<Scalars['uuid']>;
  skillRatingMaximum?: InputMaybe<Scalars['numeric']>;
  skillRatingMinimum?: InputMaybe<Scalars['numeric']>;
  sport?: InputMaybe<SportsEnum>;
  startDateTime?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<PlaySessionStatusesEnum>;
  targetSkillLevel?: InputMaybe<Scalars['String']>;
  tennisRatingScaleId?: InputMaybe<Scalars['uuid']>;
  timezoneAbbreviation?: InputMaybe<Scalars['String']>;
  timezoneName?: InputMaybe<Scalars['String']>;
  timezoneOffsetMinutes?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userCustomCourtId?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type PlaySessionsStddevFields = {
  __typename?: 'PlaySessionsStddevFields';
  extraRacketCount?: Maybe<Scalars['Float']>;
  participantLimit?: Maybe<Scalars['Float']>;
  priceUnitAmount?: Maybe<Scalars['Float']>;
  skillRatingMaximum?: Maybe<Scalars['Float']>;
  skillRatingMinimum?: Maybe<Scalars['Float']>;
  timezoneOffsetMinutes?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "play_sessions" */
export type PlaySessionsStddevOrderBy = {
  extraRacketCount?: InputMaybe<OrderBy>;
  participantLimit?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  skillRatingMaximum?: InputMaybe<OrderBy>;
  skillRatingMinimum?: InputMaybe<OrderBy>;
  timezoneOffsetMinutes?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type PlaySessionsStddevPopFields = {
  __typename?: 'PlaySessionsStddevPopFields';
  extraRacketCount?: Maybe<Scalars['Float']>;
  participantLimit?: Maybe<Scalars['Float']>;
  priceUnitAmount?: Maybe<Scalars['Float']>;
  skillRatingMaximum?: Maybe<Scalars['Float']>;
  skillRatingMinimum?: Maybe<Scalars['Float']>;
  timezoneOffsetMinutes?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "play_sessions" */
export type PlaySessionsStddevPopOrderBy = {
  extraRacketCount?: InputMaybe<OrderBy>;
  participantLimit?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  skillRatingMaximum?: InputMaybe<OrderBy>;
  skillRatingMinimum?: InputMaybe<OrderBy>;
  timezoneOffsetMinutes?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type PlaySessionsStddevSampFields = {
  __typename?: 'PlaySessionsStddevSampFields';
  extraRacketCount?: Maybe<Scalars['Float']>;
  participantLimit?: Maybe<Scalars['Float']>;
  priceUnitAmount?: Maybe<Scalars['Float']>;
  skillRatingMaximum?: Maybe<Scalars['Float']>;
  skillRatingMinimum?: Maybe<Scalars['Float']>;
  timezoneOffsetMinutes?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "play_sessions" */
export type PlaySessionsStddevSampOrderBy = {
  extraRacketCount?: InputMaybe<OrderBy>;
  participantLimit?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  skillRatingMaximum?: InputMaybe<OrderBy>;
  skillRatingMinimum?: InputMaybe<OrderBy>;
  timezoneOffsetMinutes?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "play_sessions" */
export type PlaySessionsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PlaySessionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PlaySessionsStreamCursorValueInput = {
  cancelReason?: InputMaybe<Scalars['String']>;
  canceledAt?: InputMaybe<Scalars['timestamptz']>;
  competitiveness?: InputMaybe<PlaySessionMatchCompetitivenessEnum>;
  courtBookingStatus?: InputMaybe<PlaySessionCourtBookingStatusesEnum>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  endDateTime?: InputMaybe<Scalars['timestamptz']>;
  extraRacketCount?: InputMaybe<Scalars['Int']>;
  format?: InputMaybe<PlaySessionFormatsEnum>;
  groupId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  isBringingNet?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
  organizerUserId?: InputMaybe<Scalars['uuid']>;
  participantLimit?: InputMaybe<Scalars['Int']>;
  pickleballRatingScaleId?: InputMaybe<Scalars['uuid']>;
  priceUnitAmount?: InputMaybe<Scalars['Int']>;
  privacy?: InputMaybe<PlaySessionPrivacyEnum>;
  publishedAt?: InputMaybe<Scalars['timestamptz']>;
  reminderEventId?: InputMaybe<Scalars['uuid']>;
  skillRatingMaximum?: InputMaybe<Scalars['numeric']>;
  skillRatingMinimum?: InputMaybe<Scalars['numeric']>;
  sport?: InputMaybe<SportsEnum>;
  startDateTime?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<PlaySessionStatusesEnum>;
  targetSkillLevel?: InputMaybe<Scalars['String']>;
  tennisRatingScaleId?: InputMaybe<Scalars['uuid']>;
  timezoneAbbreviation?: InputMaybe<Scalars['String']>;
  timezoneName?: InputMaybe<Scalars['String']>;
  timezoneOffsetMinutes?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userCustomCourtId?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type PlaySessionsSumFields = {
  __typename?: 'PlaySessionsSumFields';
  extraRacketCount?: Maybe<Scalars['Int']>;
  participantLimit?: Maybe<Scalars['Int']>;
  priceUnitAmount?: Maybe<Scalars['Int']>;
  skillRatingMaximum?: Maybe<Scalars['numeric']>;
  skillRatingMinimum?: Maybe<Scalars['numeric']>;
  timezoneOffsetMinutes?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "play_sessions" */
export type PlaySessionsSumOrderBy = {
  extraRacketCount?: InputMaybe<OrderBy>;
  participantLimit?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  skillRatingMaximum?: InputMaybe<OrderBy>;
  skillRatingMinimum?: InputMaybe<OrderBy>;
  timezoneOffsetMinutes?: InputMaybe<OrderBy>;
};

/** update columns of table "play_sessions" */
export enum PlaySessionsUpdateColumn {
  /** column name */
  CancelReason = 'cancelReason',
  /** column name */
  CanceledAt = 'canceledAt',
  /** column name */
  Competitiveness = 'competitiveness',
  /** column name */
  CourtBookingStatus = 'courtBookingStatus',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Currency = 'currency',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Description = 'description',
  /** column name */
  EndDateTime = 'endDateTime',
  /** column name */
  ExtraRacketCount = 'extraRacketCount',
  /** column name */
  Format = 'format',
  /** column name */
  GroupId = 'groupId',
  /** column name */
  Id = 'id',
  /** column name */
  IsBringingNet = 'isBringingNet',
  /** column name */
  Locale = 'locale',
  /** column name */
  OrganizerUserId = 'organizerUserId',
  /** column name */
  ParticipantLimit = 'participantLimit',
  /** column name */
  PickleballRatingScaleId = 'pickleballRatingScaleId',
  /** column name */
  PriceUnitAmount = 'priceUnitAmount',
  /** column name */
  Privacy = 'privacy',
  /** column name */
  PublishedAt = 'publishedAt',
  /** column name */
  ReminderEventId = 'reminderEventId',
  /** column name */
  SkillRatingMaximum = 'skillRatingMaximum',
  /** column name */
  SkillRatingMinimum = 'skillRatingMinimum',
  /** column name */
  Sport = 'sport',
  /** column name */
  StartDateTime = 'startDateTime',
  /** column name */
  Status = 'status',
  /** column name */
  TargetSkillLevel = 'targetSkillLevel',
  /** column name */
  TennisRatingScaleId = 'tennisRatingScaleId',
  /** column name */
  TimezoneAbbreviation = 'timezoneAbbreviation',
  /** column name */
  TimezoneName = 'timezoneName',
  /** column name */
  TimezoneOffsetMinutes = 'timezoneOffsetMinutes',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserCustomCourtId = 'userCustomCourtId',
  /** column name */
  VenueId = 'venueId'
}

export type PlaySessionsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<PlaySessionsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PlaySessionsSetInput>;
  /** filter the rows which have to be updated */
  where: PlaySessionsBoolExp;
};

/** aggregate varPop on columns */
export type PlaySessionsVarPopFields = {
  __typename?: 'PlaySessionsVarPopFields';
  extraRacketCount?: Maybe<Scalars['Float']>;
  participantLimit?: Maybe<Scalars['Float']>;
  priceUnitAmount?: Maybe<Scalars['Float']>;
  skillRatingMaximum?: Maybe<Scalars['Float']>;
  skillRatingMinimum?: Maybe<Scalars['Float']>;
  timezoneOffsetMinutes?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "play_sessions" */
export type PlaySessionsVarPopOrderBy = {
  extraRacketCount?: InputMaybe<OrderBy>;
  participantLimit?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  skillRatingMaximum?: InputMaybe<OrderBy>;
  skillRatingMinimum?: InputMaybe<OrderBy>;
  timezoneOffsetMinutes?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type PlaySessionsVarSampFields = {
  __typename?: 'PlaySessionsVarSampFields';
  extraRacketCount?: Maybe<Scalars['Float']>;
  participantLimit?: Maybe<Scalars['Float']>;
  priceUnitAmount?: Maybe<Scalars['Float']>;
  skillRatingMaximum?: Maybe<Scalars['Float']>;
  skillRatingMinimum?: Maybe<Scalars['Float']>;
  timezoneOffsetMinutes?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "play_sessions" */
export type PlaySessionsVarSampOrderBy = {
  extraRacketCount?: InputMaybe<OrderBy>;
  participantLimit?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  skillRatingMaximum?: InputMaybe<OrderBy>;
  skillRatingMinimum?: InputMaybe<OrderBy>;
  timezoneOffsetMinutes?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type PlaySessionsVarianceFields = {
  __typename?: 'PlaySessionsVarianceFields';
  extraRacketCount?: Maybe<Scalars['Float']>;
  participantLimit?: Maybe<Scalars['Float']>;
  priceUnitAmount?: Maybe<Scalars['Float']>;
  skillRatingMaximum?: Maybe<Scalars['Float']>;
  skillRatingMinimum?: Maybe<Scalars['Float']>;
  timezoneOffsetMinutes?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "play_sessions" */
export type PlaySessionsVarianceOrderBy = {
  extraRacketCount?: InputMaybe<OrderBy>;
  participantLimit?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  skillRatingMaximum?: InputMaybe<OrderBy>;
  skillRatingMinimum?: InputMaybe<OrderBy>;
  timezoneOffsetMinutes?: InputMaybe<OrderBy>;
};

/** columns and relationships of "player_availabilities" */
export type PlayerAvailabilities = {
  __typename?: 'PlayerAvailabilities';
  competitiveness: EventCompetitivenessEnum;
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  description: Scalars['String'];
  gender: CompetitionGenderEnum;
  id: Scalars['uuid'];
  isActive: Scalars['Boolean'];
  /** An array relationship */
  neighborhoods: Array<PlayerAvailabilityNeighborhoods>;
  /** An aggregate relationship */
  neighborhoodsAggregate: PlayerAvailabilityNeighborhoodsAggregate;
  /** An array relationship */
  ratingScales: Array<PlayerAvailabilityRatingScales>;
  /** An aggregate relationship */
  ratingScalesAggregate: PlayerAvailabilityRatingScalesAggregate;
  /** An object relationship */
  selfRatedMaxSkillLevel?: Maybe<SkillLevels>;
  selfRatedMaxSkillLevelId?: Maybe<Scalars['String']>;
  /** An object relationship */
  selfRatedMinSkillLevel?: Maybe<SkillLevels>;
  selfRatedMinSkillLevelId?: Maybe<Scalars['String']>;
  /** An array relationship */
  slots: Array<PlayerAvailabilitySlots>;
  /** An aggregate relationship */
  slotsAggregate: PlayerAvailabilitySlotsAggregate;
  sport: SportsEnum;
  teamType: TeamTypesEnum;
  travelRadiusMiles: Scalars['Int'];
  updatedAt: Scalars['timestamptz'];
  userId: Scalars['uuid'];
  /** An object relationship */
  userProfile?: Maybe<UserProfiles>;
  /** An array relationship */
  venues: Array<PlayerAvailabilityVenues>;
  /** An aggregate relationship */
  venuesAggregate: PlayerAvailabilityVenuesAggregate;
  wantsRegularPartner: Scalars['Boolean'];
};


/** columns and relationships of "player_availabilities" */
export type PlayerAvailabilitiesNeighborhoodsArgs = {
  distinctOn?: InputMaybe<Array<PlayerAvailabilityNeighborhoodsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayerAvailabilityNeighborhoodsOrderBy>>;
  where?: InputMaybe<PlayerAvailabilityNeighborhoodsBoolExp>;
};


/** columns and relationships of "player_availabilities" */
export type PlayerAvailabilitiesNeighborhoodsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PlayerAvailabilityNeighborhoodsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayerAvailabilityNeighborhoodsOrderBy>>;
  where?: InputMaybe<PlayerAvailabilityNeighborhoodsBoolExp>;
};


/** columns and relationships of "player_availabilities" */
export type PlayerAvailabilitiesRatingScalesArgs = {
  distinctOn?: InputMaybe<Array<PlayerAvailabilityRatingScalesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayerAvailabilityRatingScalesOrderBy>>;
  where?: InputMaybe<PlayerAvailabilityRatingScalesBoolExp>;
};


/** columns and relationships of "player_availabilities" */
export type PlayerAvailabilitiesRatingScalesAggregateArgs = {
  distinctOn?: InputMaybe<Array<PlayerAvailabilityRatingScalesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayerAvailabilityRatingScalesOrderBy>>;
  where?: InputMaybe<PlayerAvailabilityRatingScalesBoolExp>;
};


/** columns and relationships of "player_availabilities" */
export type PlayerAvailabilitiesSlotsArgs = {
  distinctOn?: InputMaybe<Array<PlayerAvailabilitySlotsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayerAvailabilitySlotsOrderBy>>;
  where?: InputMaybe<PlayerAvailabilitySlotsBoolExp>;
};


/** columns and relationships of "player_availabilities" */
export type PlayerAvailabilitiesSlotsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PlayerAvailabilitySlotsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayerAvailabilitySlotsOrderBy>>;
  where?: InputMaybe<PlayerAvailabilitySlotsBoolExp>;
};


/** columns and relationships of "player_availabilities" */
export type PlayerAvailabilitiesVenuesArgs = {
  distinctOn?: InputMaybe<Array<PlayerAvailabilityVenuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayerAvailabilityVenuesOrderBy>>;
  where?: InputMaybe<PlayerAvailabilityVenuesBoolExp>;
};


/** columns and relationships of "player_availabilities" */
export type PlayerAvailabilitiesVenuesAggregateArgs = {
  distinctOn?: InputMaybe<Array<PlayerAvailabilityVenuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayerAvailabilityVenuesOrderBy>>;
  where?: InputMaybe<PlayerAvailabilityVenuesBoolExp>;
};

/** aggregated selection of "player_availabilities" */
export type PlayerAvailabilitiesAggregate = {
  __typename?: 'PlayerAvailabilitiesAggregate';
  aggregate?: Maybe<PlayerAvailabilitiesAggregateFields>;
  nodes: Array<PlayerAvailabilities>;
};

/** aggregate fields of "player_availabilities" */
export type PlayerAvailabilitiesAggregateFields = {
  __typename?: 'PlayerAvailabilitiesAggregateFields';
  avg?: Maybe<PlayerAvailabilitiesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<PlayerAvailabilitiesMaxFields>;
  min?: Maybe<PlayerAvailabilitiesMinFields>;
  stddev?: Maybe<PlayerAvailabilitiesStddevFields>;
  stddevPop?: Maybe<PlayerAvailabilitiesStddevPopFields>;
  stddevSamp?: Maybe<PlayerAvailabilitiesStddevSampFields>;
  sum?: Maybe<PlayerAvailabilitiesSumFields>;
  varPop?: Maybe<PlayerAvailabilitiesVarPopFields>;
  varSamp?: Maybe<PlayerAvailabilitiesVarSampFields>;
  variance?: Maybe<PlayerAvailabilitiesVarianceFields>;
};


/** aggregate fields of "player_availabilities" */
export type PlayerAvailabilitiesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PlayerAvailabilitiesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type PlayerAvailabilitiesAvgFields = {
  __typename?: 'PlayerAvailabilitiesAvgFields';
  travelRadiusMiles?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "player_availabilities". All fields are combined with a logical 'AND'. */
export type PlayerAvailabilitiesBoolExp = {
  _and?: InputMaybe<Array<PlayerAvailabilitiesBoolExp>>;
  _not?: InputMaybe<PlayerAvailabilitiesBoolExp>;
  _or?: InputMaybe<Array<PlayerAvailabilitiesBoolExp>>;
  competitiveness?: InputMaybe<EventCompetitivenessEnumComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  gender?: InputMaybe<CompetitionGenderEnumComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isActive?: InputMaybe<BooleanComparisonExp>;
  neighborhoods?: InputMaybe<PlayerAvailabilityNeighborhoodsBoolExp>;
  neighborhoodsAggregate?: InputMaybe<PlayerAvailabilityNeighborhoodsAggregateBoolExp>;
  ratingScales?: InputMaybe<PlayerAvailabilityRatingScalesBoolExp>;
  ratingScalesAggregate?: InputMaybe<PlayerAvailabilityRatingScalesAggregateBoolExp>;
  selfRatedMaxSkillLevel?: InputMaybe<SkillLevelsBoolExp>;
  selfRatedMaxSkillLevelId?: InputMaybe<StringComparisonExp>;
  selfRatedMinSkillLevel?: InputMaybe<SkillLevelsBoolExp>;
  selfRatedMinSkillLevelId?: InputMaybe<StringComparisonExp>;
  slots?: InputMaybe<PlayerAvailabilitySlotsBoolExp>;
  slotsAggregate?: InputMaybe<PlayerAvailabilitySlotsAggregateBoolExp>;
  sport?: InputMaybe<SportsEnumComparisonExp>;
  teamType?: InputMaybe<TeamTypesEnumComparisonExp>;
  travelRadiusMiles?: InputMaybe<IntComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  userId?: InputMaybe<UuidComparisonExp>;
  userProfile?: InputMaybe<UserProfilesBoolExp>;
  venues?: InputMaybe<PlayerAvailabilityVenuesBoolExp>;
  venuesAggregate?: InputMaybe<PlayerAvailabilityVenuesAggregateBoolExp>;
  wantsRegularPartner?: InputMaybe<BooleanComparisonExp>;
};

/** unique or primary key constraints on table "player_availabilities" */
export enum PlayerAvailabilitiesConstraint {
  /** unique or primary key constraint on columns "sport", "user_id" */
  PlayerAvailabilitiesOneActivePerUserPerSport = 'player_availabilities_one_active_per_user_per_sport',
  /** unique or primary key constraint on columns "id" */
  PlayerAvailabilitiesPkey = 'player_availabilities_pkey'
}

/** input type for incrementing numeric columns in table "player_availabilities" */
export type PlayerAvailabilitiesIncInput = {
  travelRadiusMiles?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "player_availabilities" */
export type PlayerAvailabilitiesInsertInput = {
  competitiveness?: InputMaybe<EventCompetitivenessEnum>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<CompetitionGenderEnum>;
  id?: InputMaybe<Scalars['uuid']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  neighborhoods?: InputMaybe<PlayerAvailabilityNeighborhoodsArrRelInsertInput>;
  ratingScales?: InputMaybe<PlayerAvailabilityRatingScalesArrRelInsertInput>;
  selfRatedMaxSkillLevel?: InputMaybe<SkillLevelsObjRelInsertInput>;
  selfRatedMaxSkillLevelId?: InputMaybe<Scalars['String']>;
  selfRatedMinSkillLevel?: InputMaybe<SkillLevelsObjRelInsertInput>;
  selfRatedMinSkillLevelId?: InputMaybe<Scalars['String']>;
  slots?: InputMaybe<PlayerAvailabilitySlotsArrRelInsertInput>;
  sport?: InputMaybe<SportsEnum>;
  teamType?: InputMaybe<TeamTypesEnum>;
  travelRadiusMiles?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
  userProfile?: InputMaybe<UserProfilesObjRelInsertInput>;
  venues?: InputMaybe<PlayerAvailabilityVenuesArrRelInsertInput>;
  wantsRegularPartner?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate max on columns */
export type PlayerAvailabilitiesMaxFields = {
  __typename?: 'PlayerAvailabilitiesMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  selfRatedMaxSkillLevelId?: Maybe<Scalars['String']>;
  selfRatedMinSkillLevelId?: Maybe<Scalars['String']>;
  travelRadiusMiles?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type PlayerAvailabilitiesMinFields = {
  __typename?: 'PlayerAvailabilitiesMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  selfRatedMaxSkillLevelId?: Maybe<Scalars['String']>;
  selfRatedMinSkillLevelId?: Maybe<Scalars['String']>;
  travelRadiusMiles?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "player_availabilities" */
export type PlayerAvailabilitiesMutationResponse = {
  __typename?: 'PlayerAvailabilitiesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PlayerAvailabilities>;
};

/** input type for inserting object relation for remote table "player_availabilities" */
export type PlayerAvailabilitiesObjRelInsertInput = {
  data: PlayerAvailabilitiesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<PlayerAvailabilitiesOnConflict>;
};

/** on_conflict condition type for table "player_availabilities" */
export type PlayerAvailabilitiesOnConflict = {
  constraint: PlayerAvailabilitiesConstraint;
  updateColumns?: Array<PlayerAvailabilitiesUpdateColumn>;
  where?: InputMaybe<PlayerAvailabilitiesBoolExp>;
};

/** Ordering options when selecting data from "player_availabilities". */
export type PlayerAvailabilitiesOrderBy = {
  competitiveness?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  gender?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  isActive?: InputMaybe<OrderBy>;
  neighborhoodsAggregate?: InputMaybe<PlayerAvailabilityNeighborhoodsAggregateOrderBy>;
  ratingScalesAggregate?: InputMaybe<PlayerAvailabilityRatingScalesAggregateOrderBy>;
  selfRatedMaxSkillLevel?: InputMaybe<SkillLevelsOrderBy>;
  selfRatedMaxSkillLevelId?: InputMaybe<OrderBy>;
  selfRatedMinSkillLevel?: InputMaybe<SkillLevelsOrderBy>;
  selfRatedMinSkillLevelId?: InputMaybe<OrderBy>;
  slotsAggregate?: InputMaybe<PlayerAvailabilitySlotsAggregateOrderBy>;
  sport?: InputMaybe<OrderBy>;
  teamType?: InputMaybe<OrderBy>;
  travelRadiusMiles?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
  userProfile?: InputMaybe<UserProfilesOrderBy>;
  venuesAggregate?: InputMaybe<PlayerAvailabilityVenuesAggregateOrderBy>;
  wantsRegularPartner?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: player_availabilities */
export type PlayerAvailabilitiesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "player_availabilities" */
export enum PlayerAvailabilitiesSelectColumn {
  /** column name */
  Competitiveness = 'competitiveness',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Description = 'description',
  /** column name */
  Gender = 'gender',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'isActive',
  /** column name */
  SelfRatedMaxSkillLevelId = 'selfRatedMaxSkillLevelId',
  /** column name */
  SelfRatedMinSkillLevelId = 'selfRatedMinSkillLevelId',
  /** column name */
  Sport = 'sport',
  /** column name */
  TeamType = 'teamType',
  /** column name */
  TravelRadiusMiles = 'travelRadiusMiles',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId',
  /** column name */
  WantsRegularPartner = 'wantsRegularPartner'
}

/** input type for updating data in table "player_availabilities" */
export type PlayerAvailabilitiesSetInput = {
  competitiveness?: InputMaybe<EventCompetitivenessEnum>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<CompetitionGenderEnum>;
  id?: InputMaybe<Scalars['uuid']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  selfRatedMaxSkillLevelId?: InputMaybe<Scalars['String']>;
  selfRatedMinSkillLevelId?: InputMaybe<Scalars['String']>;
  sport?: InputMaybe<SportsEnum>;
  teamType?: InputMaybe<TeamTypesEnum>;
  travelRadiusMiles?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
  wantsRegularPartner?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate stddev on columns */
export type PlayerAvailabilitiesStddevFields = {
  __typename?: 'PlayerAvailabilitiesStddevFields';
  travelRadiusMiles?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type PlayerAvailabilitiesStddevPopFields = {
  __typename?: 'PlayerAvailabilitiesStddevPopFields';
  travelRadiusMiles?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type PlayerAvailabilitiesStddevSampFields = {
  __typename?: 'PlayerAvailabilitiesStddevSampFields';
  travelRadiusMiles?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "player_availabilities" */
export type PlayerAvailabilitiesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PlayerAvailabilitiesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PlayerAvailabilitiesStreamCursorValueInput = {
  competitiveness?: InputMaybe<EventCompetitivenessEnum>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<CompetitionGenderEnum>;
  id?: InputMaybe<Scalars['uuid']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  selfRatedMaxSkillLevelId?: InputMaybe<Scalars['String']>;
  selfRatedMinSkillLevelId?: InputMaybe<Scalars['String']>;
  sport?: InputMaybe<SportsEnum>;
  teamType?: InputMaybe<TeamTypesEnum>;
  travelRadiusMiles?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
  wantsRegularPartner?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate sum on columns */
export type PlayerAvailabilitiesSumFields = {
  __typename?: 'PlayerAvailabilitiesSumFields';
  travelRadiusMiles?: Maybe<Scalars['Int']>;
};

/** update columns of table "player_availabilities" */
export enum PlayerAvailabilitiesUpdateColumn {
  /** column name */
  Competitiveness = 'competitiveness',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Description = 'description',
  /** column name */
  Gender = 'gender',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'isActive',
  /** column name */
  SelfRatedMaxSkillLevelId = 'selfRatedMaxSkillLevelId',
  /** column name */
  SelfRatedMinSkillLevelId = 'selfRatedMinSkillLevelId',
  /** column name */
  Sport = 'sport',
  /** column name */
  TeamType = 'teamType',
  /** column name */
  TravelRadiusMiles = 'travelRadiusMiles',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId',
  /** column name */
  WantsRegularPartner = 'wantsRegularPartner'
}

export type PlayerAvailabilitiesUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<PlayerAvailabilitiesIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PlayerAvailabilitiesSetInput>;
  /** filter the rows which have to be updated */
  where: PlayerAvailabilitiesBoolExp;
};

/** aggregate varPop on columns */
export type PlayerAvailabilitiesVarPopFields = {
  __typename?: 'PlayerAvailabilitiesVarPopFields';
  travelRadiusMiles?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type PlayerAvailabilitiesVarSampFields = {
  __typename?: 'PlayerAvailabilitiesVarSampFields';
  travelRadiusMiles?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type PlayerAvailabilitiesVarianceFields = {
  __typename?: 'PlayerAvailabilitiesVarianceFields';
  travelRadiusMiles?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "player_availability_neighborhoods" */
export type PlayerAvailabilityNeighborhoods = {
  __typename?: 'PlayerAvailabilityNeighborhoods';
  /** An object relationship */
  availability: PlayerAvailabilities;
  availabilityId: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  neighborhood: Neighborhoods;
  neighborhoodId: Scalars['uuid'];
};

/** aggregated selection of "player_availability_neighborhoods" */
export type PlayerAvailabilityNeighborhoodsAggregate = {
  __typename?: 'PlayerAvailabilityNeighborhoodsAggregate';
  aggregate?: Maybe<PlayerAvailabilityNeighborhoodsAggregateFields>;
  nodes: Array<PlayerAvailabilityNeighborhoods>;
};

export type PlayerAvailabilityNeighborhoodsAggregateBoolExp = {
  count?: InputMaybe<PlayerAvailabilityNeighborhoodsAggregateBoolExpCount>;
};

/** aggregate fields of "player_availability_neighborhoods" */
export type PlayerAvailabilityNeighborhoodsAggregateFields = {
  __typename?: 'PlayerAvailabilityNeighborhoodsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<PlayerAvailabilityNeighborhoodsMaxFields>;
  min?: Maybe<PlayerAvailabilityNeighborhoodsMinFields>;
};


/** aggregate fields of "player_availability_neighborhoods" */
export type PlayerAvailabilityNeighborhoodsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PlayerAvailabilityNeighborhoodsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "player_availability_neighborhoods" */
export type PlayerAvailabilityNeighborhoodsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<PlayerAvailabilityNeighborhoodsMaxOrderBy>;
  min?: InputMaybe<PlayerAvailabilityNeighborhoodsMinOrderBy>;
};

/** input type for inserting array relation for remote table "player_availability_neighborhoods" */
export type PlayerAvailabilityNeighborhoodsArrRelInsertInput = {
  data: Array<PlayerAvailabilityNeighborhoodsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<PlayerAvailabilityNeighborhoodsOnConflict>;
};

/** Boolean expression to filter rows from the table "player_availability_neighborhoods". All fields are combined with a logical 'AND'. */
export type PlayerAvailabilityNeighborhoodsBoolExp = {
  _and?: InputMaybe<Array<PlayerAvailabilityNeighborhoodsBoolExp>>;
  _not?: InputMaybe<PlayerAvailabilityNeighborhoodsBoolExp>;
  _or?: InputMaybe<Array<PlayerAvailabilityNeighborhoodsBoolExp>>;
  availability?: InputMaybe<PlayerAvailabilitiesBoolExp>;
  availabilityId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  neighborhood?: InputMaybe<NeighborhoodsBoolExp>;
  neighborhoodId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "player_availability_neighborhoods" */
export enum PlayerAvailabilityNeighborhoodsConstraint {
  /** unique or primary key constraint on columns "neighborhood_id", "availability_id" */
  PlayerAvailabilityNeighborhoodsPkey = 'player_availability_neighborhoods_pkey'
}

/** input type for inserting data into table "player_availability_neighborhoods" */
export type PlayerAvailabilityNeighborhoodsInsertInput = {
  availability?: InputMaybe<PlayerAvailabilitiesObjRelInsertInput>;
  availabilityId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  neighborhood?: InputMaybe<NeighborhoodsObjRelInsertInput>;
  neighborhoodId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type PlayerAvailabilityNeighborhoodsMaxFields = {
  __typename?: 'PlayerAvailabilityNeighborhoodsMaxFields';
  availabilityId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  neighborhoodId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "player_availability_neighborhoods" */
export type PlayerAvailabilityNeighborhoodsMaxOrderBy = {
  availabilityId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  neighborhoodId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type PlayerAvailabilityNeighborhoodsMinFields = {
  __typename?: 'PlayerAvailabilityNeighborhoodsMinFields';
  availabilityId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  neighborhoodId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "player_availability_neighborhoods" */
export type PlayerAvailabilityNeighborhoodsMinOrderBy = {
  availabilityId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  neighborhoodId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "player_availability_neighborhoods" */
export type PlayerAvailabilityNeighborhoodsMutationResponse = {
  __typename?: 'PlayerAvailabilityNeighborhoodsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PlayerAvailabilityNeighborhoods>;
};

/** on_conflict condition type for table "player_availability_neighborhoods" */
export type PlayerAvailabilityNeighborhoodsOnConflict = {
  constraint: PlayerAvailabilityNeighborhoodsConstraint;
  updateColumns?: Array<PlayerAvailabilityNeighborhoodsUpdateColumn>;
  where?: InputMaybe<PlayerAvailabilityNeighborhoodsBoolExp>;
};

/** Ordering options when selecting data from "player_availability_neighborhoods". */
export type PlayerAvailabilityNeighborhoodsOrderBy = {
  availability?: InputMaybe<PlayerAvailabilitiesOrderBy>;
  availabilityId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  neighborhood?: InputMaybe<NeighborhoodsOrderBy>;
  neighborhoodId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: player_availability_neighborhoods */
export type PlayerAvailabilityNeighborhoodsPkColumnsInput = {
  availabilityId: Scalars['uuid'];
  neighborhoodId: Scalars['uuid'];
};

/** select columns of table "player_availability_neighborhoods" */
export enum PlayerAvailabilityNeighborhoodsSelectColumn {
  /** column name */
  AvailabilityId = 'availabilityId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  NeighborhoodId = 'neighborhoodId'
}

/** input type for updating data in table "player_availability_neighborhoods" */
export type PlayerAvailabilityNeighborhoodsSetInput = {
  availabilityId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  neighborhoodId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "player_availability_neighborhoods" */
export type PlayerAvailabilityNeighborhoodsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PlayerAvailabilityNeighborhoodsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PlayerAvailabilityNeighborhoodsStreamCursorValueInput = {
  availabilityId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  neighborhoodId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "player_availability_neighborhoods" */
export enum PlayerAvailabilityNeighborhoodsUpdateColumn {
  /** column name */
  AvailabilityId = 'availabilityId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  NeighborhoodId = 'neighborhoodId'
}

export type PlayerAvailabilityNeighborhoodsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PlayerAvailabilityNeighborhoodsSetInput>;
  /** filter the rows which have to be updated */
  where: PlayerAvailabilityNeighborhoodsBoolExp;
};

/** columns and relationships of "player_availability_rating_scales" */
export type PlayerAvailabilityRatingScales = {
  __typename?: 'PlayerAvailabilityRatingScales';
  /** An object relationship */
  availability: PlayerAvailabilities;
  availabilityId: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  maximumRating?: Maybe<Scalars['numeric']>;
  minimumRating?: Maybe<Scalars['numeric']>;
  /** An object relationship */
  padelRatingScale?: Maybe<PadelRatingScales>;
  padelRatingScaleId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  pickleballRatingScale?: Maybe<PickleballRatingScales>;
  pickleballRatingScaleId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  tennisRatingScale?: Maybe<TennisRatingScales>;
  tennisRatingScaleId?: Maybe<Scalars['uuid']>;
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "player_availability_rating_scales" */
export type PlayerAvailabilityRatingScalesAggregate = {
  __typename?: 'PlayerAvailabilityRatingScalesAggregate';
  aggregate?: Maybe<PlayerAvailabilityRatingScalesAggregateFields>;
  nodes: Array<PlayerAvailabilityRatingScales>;
};

export type PlayerAvailabilityRatingScalesAggregateBoolExp = {
  count?: InputMaybe<PlayerAvailabilityRatingScalesAggregateBoolExpCount>;
};

/** aggregate fields of "player_availability_rating_scales" */
export type PlayerAvailabilityRatingScalesAggregateFields = {
  __typename?: 'PlayerAvailabilityRatingScalesAggregateFields';
  avg?: Maybe<PlayerAvailabilityRatingScalesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<PlayerAvailabilityRatingScalesMaxFields>;
  min?: Maybe<PlayerAvailabilityRatingScalesMinFields>;
  stddev?: Maybe<PlayerAvailabilityRatingScalesStddevFields>;
  stddevPop?: Maybe<PlayerAvailabilityRatingScalesStddevPopFields>;
  stddevSamp?: Maybe<PlayerAvailabilityRatingScalesStddevSampFields>;
  sum?: Maybe<PlayerAvailabilityRatingScalesSumFields>;
  varPop?: Maybe<PlayerAvailabilityRatingScalesVarPopFields>;
  varSamp?: Maybe<PlayerAvailabilityRatingScalesVarSampFields>;
  variance?: Maybe<PlayerAvailabilityRatingScalesVarianceFields>;
};


/** aggregate fields of "player_availability_rating_scales" */
export type PlayerAvailabilityRatingScalesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PlayerAvailabilityRatingScalesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "player_availability_rating_scales" */
export type PlayerAvailabilityRatingScalesAggregateOrderBy = {
  avg?: InputMaybe<PlayerAvailabilityRatingScalesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<PlayerAvailabilityRatingScalesMaxOrderBy>;
  min?: InputMaybe<PlayerAvailabilityRatingScalesMinOrderBy>;
  stddev?: InputMaybe<PlayerAvailabilityRatingScalesStddevOrderBy>;
  stddevPop?: InputMaybe<PlayerAvailabilityRatingScalesStddevPopOrderBy>;
  stddevSamp?: InputMaybe<PlayerAvailabilityRatingScalesStddevSampOrderBy>;
  sum?: InputMaybe<PlayerAvailabilityRatingScalesSumOrderBy>;
  varPop?: InputMaybe<PlayerAvailabilityRatingScalesVarPopOrderBy>;
  varSamp?: InputMaybe<PlayerAvailabilityRatingScalesVarSampOrderBy>;
  variance?: InputMaybe<PlayerAvailabilityRatingScalesVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "player_availability_rating_scales" */
export type PlayerAvailabilityRatingScalesArrRelInsertInput = {
  data: Array<PlayerAvailabilityRatingScalesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<PlayerAvailabilityRatingScalesOnConflict>;
};

/** aggregate avg on columns */
export type PlayerAvailabilityRatingScalesAvgFields = {
  __typename?: 'PlayerAvailabilityRatingScalesAvgFields';
  maximumRating?: Maybe<Scalars['Float']>;
  minimumRating?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "player_availability_rating_scales" */
export type PlayerAvailabilityRatingScalesAvgOrderBy = {
  maximumRating?: InputMaybe<OrderBy>;
  minimumRating?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "player_availability_rating_scales". All fields are combined with a logical 'AND'. */
export type PlayerAvailabilityRatingScalesBoolExp = {
  _and?: InputMaybe<Array<PlayerAvailabilityRatingScalesBoolExp>>;
  _not?: InputMaybe<PlayerAvailabilityRatingScalesBoolExp>;
  _or?: InputMaybe<Array<PlayerAvailabilityRatingScalesBoolExp>>;
  availability?: InputMaybe<PlayerAvailabilitiesBoolExp>;
  availabilityId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  maximumRating?: InputMaybe<NumericComparisonExp>;
  minimumRating?: InputMaybe<NumericComparisonExp>;
  padelRatingScale?: InputMaybe<PadelRatingScalesBoolExp>;
  padelRatingScaleId?: InputMaybe<UuidComparisonExp>;
  pickleballRatingScale?: InputMaybe<PickleballRatingScalesBoolExp>;
  pickleballRatingScaleId?: InputMaybe<UuidComparisonExp>;
  tennisRatingScale?: InputMaybe<TennisRatingScalesBoolExp>;
  tennisRatingScaleId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "player_availability_rating_scales" */
export enum PlayerAvailabilityRatingScalesConstraint {
  /** unique or primary key constraint on columns "availability_id", "padel_rating_scale_id" */
  PlayerAvailabilityRatingScAvailabilityIdPadelRatingKey = 'player_availability_rating_sc_availability_id_padel_rating__key',
  /** unique or primary key constraint on columns "pickleball_rating_scale_id", "availability_id" */
  PlayerAvailabilityRatingScAvailabilityIdPickleballRaKey = 'player_availability_rating_sc_availability_id_pickleball_ra_key',
  /** unique or primary key constraint on columns "tennis_rating_scale_id", "availability_id" */
  PlayerAvailabilityRatingScAvailabilityIdTennisRatingKey = 'player_availability_rating_sc_availability_id_tennis_rating_key',
  /** unique or primary key constraint on columns "id" */
  PlayerAvailabilityRatingScalesPkey = 'player_availability_rating_scales_pkey'
}

/** input type for incrementing numeric columns in table "player_availability_rating_scales" */
export type PlayerAvailabilityRatingScalesIncInput = {
  maximumRating?: InputMaybe<Scalars['numeric']>;
  minimumRating?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "player_availability_rating_scales" */
export type PlayerAvailabilityRatingScalesInsertInput = {
  availability?: InputMaybe<PlayerAvailabilitiesObjRelInsertInput>;
  availabilityId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  maximumRating?: InputMaybe<Scalars['numeric']>;
  minimumRating?: InputMaybe<Scalars['numeric']>;
  padelRatingScale?: InputMaybe<PadelRatingScalesObjRelInsertInput>;
  padelRatingScaleId?: InputMaybe<Scalars['uuid']>;
  pickleballRatingScale?: InputMaybe<PickleballRatingScalesObjRelInsertInput>;
  pickleballRatingScaleId?: InputMaybe<Scalars['uuid']>;
  tennisRatingScale?: InputMaybe<TennisRatingScalesObjRelInsertInput>;
  tennisRatingScaleId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type PlayerAvailabilityRatingScalesMaxFields = {
  __typename?: 'PlayerAvailabilityRatingScalesMaxFields';
  availabilityId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  maximumRating?: Maybe<Scalars['numeric']>;
  minimumRating?: Maybe<Scalars['numeric']>;
  padelRatingScaleId?: Maybe<Scalars['uuid']>;
  pickleballRatingScaleId?: Maybe<Scalars['uuid']>;
  tennisRatingScaleId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "player_availability_rating_scales" */
export type PlayerAvailabilityRatingScalesMaxOrderBy = {
  availabilityId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  maximumRating?: InputMaybe<OrderBy>;
  minimumRating?: InputMaybe<OrderBy>;
  padelRatingScaleId?: InputMaybe<OrderBy>;
  pickleballRatingScaleId?: InputMaybe<OrderBy>;
  tennisRatingScaleId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type PlayerAvailabilityRatingScalesMinFields = {
  __typename?: 'PlayerAvailabilityRatingScalesMinFields';
  availabilityId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  maximumRating?: Maybe<Scalars['numeric']>;
  minimumRating?: Maybe<Scalars['numeric']>;
  padelRatingScaleId?: Maybe<Scalars['uuid']>;
  pickleballRatingScaleId?: Maybe<Scalars['uuid']>;
  tennisRatingScaleId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "player_availability_rating_scales" */
export type PlayerAvailabilityRatingScalesMinOrderBy = {
  availabilityId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  maximumRating?: InputMaybe<OrderBy>;
  minimumRating?: InputMaybe<OrderBy>;
  padelRatingScaleId?: InputMaybe<OrderBy>;
  pickleballRatingScaleId?: InputMaybe<OrderBy>;
  tennisRatingScaleId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "player_availability_rating_scales" */
export type PlayerAvailabilityRatingScalesMutationResponse = {
  __typename?: 'PlayerAvailabilityRatingScalesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PlayerAvailabilityRatingScales>;
};

/** on_conflict condition type for table "player_availability_rating_scales" */
export type PlayerAvailabilityRatingScalesOnConflict = {
  constraint: PlayerAvailabilityRatingScalesConstraint;
  updateColumns?: Array<PlayerAvailabilityRatingScalesUpdateColumn>;
  where?: InputMaybe<PlayerAvailabilityRatingScalesBoolExp>;
};

/** Ordering options when selecting data from "player_availability_rating_scales". */
export type PlayerAvailabilityRatingScalesOrderBy = {
  availability?: InputMaybe<PlayerAvailabilitiesOrderBy>;
  availabilityId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  maximumRating?: InputMaybe<OrderBy>;
  minimumRating?: InputMaybe<OrderBy>;
  padelRatingScale?: InputMaybe<PadelRatingScalesOrderBy>;
  padelRatingScaleId?: InputMaybe<OrderBy>;
  pickleballRatingScale?: InputMaybe<PickleballRatingScalesOrderBy>;
  pickleballRatingScaleId?: InputMaybe<OrderBy>;
  tennisRatingScale?: InputMaybe<TennisRatingScalesOrderBy>;
  tennisRatingScaleId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: player_availability_rating_scales */
export type PlayerAvailabilityRatingScalesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "player_availability_rating_scales" */
export enum PlayerAvailabilityRatingScalesSelectColumn {
  /** column name */
  AvailabilityId = 'availabilityId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  MaximumRating = 'maximumRating',
  /** column name */
  MinimumRating = 'minimumRating',
  /** column name */
  PadelRatingScaleId = 'padelRatingScaleId',
  /** column name */
  PickleballRatingScaleId = 'pickleballRatingScaleId',
  /** column name */
  TennisRatingScaleId = 'tennisRatingScaleId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "player_availability_rating_scales" */
export type PlayerAvailabilityRatingScalesSetInput = {
  availabilityId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  maximumRating?: InputMaybe<Scalars['numeric']>;
  minimumRating?: InputMaybe<Scalars['numeric']>;
  padelRatingScaleId?: InputMaybe<Scalars['uuid']>;
  pickleballRatingScaleId?: InputMaybe<Scalars['uuid']>;
  tennisRatingScaleId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type PlayerAvailabilityRatingScalesStddevFields = {
  __typename?: 'PlayerAvailabilityRatingScalesStddevFields';
  maximumRating?: Maybe<Scalars['Float']>;
  minimumRating?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "player_availability_rating_scales" */
export type PlayerAvailabilityRatingScalesStddevOrderBy = {
  maximumRating?: InputMaybe<OrderBy>;
  minimumRating?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type PlayerAvailabilityRatingScalesStddevPopFields = {
  __typename?: 'PlayerAvailabilityRatingScalesStddevPopFields';
  maximumRating?: Maybe<Scalars['Float']>;
  minimumRating?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "player_availability_rating_scales" */
export type PlayerAvailabilityRatingScalesStddevPopOrderBy = {
  maximumRating?: InputMaybe<OrderBy>;
  minimumRating?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type PlayerAvailabilityRatingScalesStddevSampFields = {
  __typename?: 'PlayerAvailabilityRatingScalesStddevSampFields';
  maximumRating?: Maybe<Scalars['Float']>;
  minimumRating?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "player_availability_rating_scales" */
export type PlayerAvailabilityRatingScalesStddevSampOrderBy = {
  maximumRating?: InputMaybe<OrderBy>;
  minimumRating?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "player_availability_rating_scales" */
export type PlayerAvailabilityRatingScalesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PlayerAvailabilityRatingScalesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PlayerAvailabilityRatingScalesStreamCursorValueInput = {
  availabilityId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  maximumRating?: InputMaybe<Scalars['numeric']>;
  minimumRating?: InputMaybe<Scalars['numeric']>;
  padelRatingScaleId?: InputMaybe<Scalars['uuid']>;
  pickleballRatingScaleId?: InputMaybe<Scalars['uuid']>;
  tennisRatingScaleId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type PlayerAvailabilityRatingScalesSumFields = {
  __typename?: 'PlayerAvailabilityRatingScalesSumFields';
  maximumRating?: Maybe<Scalars['numeric']>;
  minimumRating?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "player_availability_rating_scales" */
export type PlayerAvailabilityRatingScalesSumOrderBy = {
  maximumRating?: InputMaybe<OrderBy>;
  minimumRating?: InputMaybe<OrderBy>;
};

/** update columns of table "player_availability_rating_scales" */
export enum PlayerAvailabilityRatingScalesUpdateColumn {
  /** column name */
  AvailabilityId = 'availabilityId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  MaximumRating = 'maximumRating',
  /** column name */
  MinimumRating = 'minimumRating',
  /** column name */
  PadelRatingScaleId = 'padelRatingScaleId',
  /** column name */
  PickleballRatingScaleId = 'pickleballRatingScaleId',
  /** column name */
  TennisRatingScaleId = 'tennisRatingScaleId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type PlayerAvailabilityRatingScalesUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<PlayerAvailabilityRatingScalesIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PlayerAvailabilityRatingScalesSetInput>;
  /** filter the rows which have to be updated */
  where: PlayerAvailabilityRatingScalesBoolExp;
};

/** aggregate varPop on columns */
export type PlayerAvailabilityRatingScalesVarPopFields = {
  __typename?: 'PlayerAvailabilityRatingScalesVarPopFields';
  maximumRating?: Maybe<Scalars['Float']>;
  minimumRating?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "player_availability_rating_scales" */
export type PlayerAvailabilityRatingScalesVarPopOrderBy = {
  maximumRating?: InputMaybe<OrderBy>;
  minimumRating?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type PlayerAvailabilityRatingScalesVarSampFields = {
  __typename?: 'PlayerAvailabilityRatingScalesVarSampFields';
  maximumRating?: Maybe<Scalars['Float']>;
  minimumRating?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "player_availability_rating_scales" */
export type PlayerAvailabilityRatingScalesVarSampOrderBy = {
  maximumRating?: InputMaybe<OrderBy>;
  minimumRating?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type PlayerAvailabilityRatingScalesVarianceFields = {
  __typename?: 'PlayerAvailabilityRatingScalesVarianceFields';
  maximumRating?: Maybe<Scalars['Float']>;
  minimumRating?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "player_availability_rating_scales" */
export type PlayerAvailabilityRatingScalesVarianceOrderBy = {
  maximumRating?: InputMaybe<OrderBy>;
  minimumRating?: InputMaybe<OrderBy>;
};

/** columns and relationships of "player_availability_slots" */
export type PlayerAvailabilitySlots = {
  __typename?: 'PlayerAvailabilitySlots';
  /** An object relationship */
  availability: PlayerAvailabilities;
  availabilityId: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  dayOfWeek: Scalars['String'];
  endTime: Scalars['time'];
  id: Scalars['uuid'];
  startTime: Scalars['time'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "player_availability_slots" */
export type PlayerAvailabilitySlotsAggregate = {
  __typename?: 'PlayerAvailabilitySlotsAggregate';
  aggregate?: Maybe<PlayerAvailabilitySlotsAggregateFields>;
  nodes: Array<PlayerAvailabilitySlots>;
};

export type PlayerAvailabilitySlotsAggregateBoolExp = {
  count?: InputMaybe<PlayerAvailabilitySlotsAggregateBoolExpCount>;
};

/** aggregate fields of "player_availability_slots" */
export type PlayerAvailabilitySlotsAggregateFields = {
  __typename?: 'PlayerAvailabilitySlotsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<PlayerAvailabilitySlotsMaxFields>;
  min?: Maybe<PlayerAvailabilitySlotsMinFields>;
};


/** aggregate fields of "player_availability_slots" */
export type PlayerAvailabilitySlotsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PlayerAvailabilitySlotsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "player_availability_slots" */
export type PlayerAvailabilitySlotsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<PlayerAvailabilitySlotsMaxOrderBy>;
  min?: InputMaybe<PlayerAvailabilitySlotsMinOrderBy>;
};

/** input type for inserting array relation for remote table "player_availability_slots" */
export type PlayerAvailabilitySlotsArrRelInsertInput = {
  data: Array<PlayerAvailabilitySlotsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<PlayerAvailabilitySlotsOnConflict>;
};

/** Boolean expression to filter rows from the table "player_availability_slots". All fields are combined with a logical 'AND'. */
export type PlayerAvailabilitySlotsBoolExp = {
  _and?: InputMaybe<Array<PlayerAvailabilitySlotsBoolExp>>;
  _not?: InputMaybe<PlayerAvailabilitySlotsBoolExp>;
  _or?: InputMaybe<Array<PlayerAvailabilitySlotsBoolExp>>;
  availability?: InputMaybe<PlayerAvailabilitiesBoolExp>;
  availabilityId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  dayOfWeek?: InputMaybe<StringComparisonExp>;
  endTime?: InputMaybe<TimeComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  startTime?: InputMaybe<TimeComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "player_availability_slots" */
export enum PlayerAvailabilitySlotsConstraint {
  /** unique or primary key constraint on columns "id" */
  PlayerAvailabilitySlotsPkey = 'player_availability_slots_pkey'
}

/** input type for inserting data into table "player_availability_slots" */
export type PlayerAvailabilitySlotsInsertInput = {
  availability?: InputMaybe<PlayerAvailabilitiesObjRelInsertInput>;
  availabilityId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  dayOfWeek?: InputMaybe<Scalars['String']>;
  endTime?: InputMaybe<Scalars['time']>;
  id?: InputMaybe<Scalars['uuid']>;
  startTime?: InputMaybe<Scalars['time']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type PlayerAvailabilitySlotsMaxFields = {
  __typename?: 'PlayerAvailabilitySlotsMaxFields';
  availabilityId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  dayOfWeek?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "player_availability_slots" */
export type PlayerAvailabilitySlotsMaxOrderBy = {
  availabilityId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  dayOfWeek?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type PlayerAvailabilitySlotsMinFields = {
  __typename?: 'PlayerAvailabilitySlotsMinFields';
  availabilityId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  dayOfWeek?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "player_availability_slots" */
export type PlayerAvailabilitySlotsMinOrderBy = {
  availabilityId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  dayOfWeek?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "player_availability_slots" */
export type PlayerAvailabilitySlotsMutationResponse = {
  __typename?: 'PlayerAvailabilitySlotsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PlayerAvailabilitySlots>;
};

/** input type for inserting object relation for remote table "player_availability_slots" */
export type PlayerAvailabilitySlotsObjRelInsertInput = {
  data: PlayerAvailabilitySlotsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<PlayerAvailabilitySlotsOnConflict>;
};

/** on_conflict condition type for table "player_availability_slots" */
export type PlayerAvailabilitySlotsOnConflict = {
  constraint: PlayerAvailabilitySlotsConstraint;
  updateColumns?: Array<PlayerAvailabilitySlotsUpdateColumn>;
  where?: InputMaybe<PlayerAvailabilitySlotsBoolExp>;
};

/** Ordering options when selecting data from "player_availability_slots". */
export type PlayerAvailabilitySlotsOrderBy = {
  availability?: InputMaybe<PlayerAvailabilitiesOrderBy>;
  availabilityId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  dayOfWeek?: InputMaybe<OrderBy>;
  endTime?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  startTime?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: player_availability_slots */
export type PlayerAvailabilitySlotsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "player_availability_slots" */
export enum PlayerAvailabilitySlotsSelectColumn {
  /** column name */
  AvailabilityId = 'availabilityId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DayOfWeek = 'dayOfWeek',
  /** column name */
  EndTime = 'endTime',
  /** column name */
  Id = 'id',
  /** column name */
  StartTime = 'startTime',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "player_availability_slots" */
export type PlayerAvailabilitySlotsSetInput = {
  availabilityId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  dayOfWeek?: InputMaybe<Scalars['String']>;
  endTime?: InputMaybe<Scalars['time']>;
  id?: InputMaybe<Scalars['uuid']>;
  startTime?: InputMaybe<Scalars['time']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "player_availability_slots" */
export type PlayerAvailabilitySlotsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PlayerAvailabilitySlotsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PlayerAvailabilitySlotsStreamCursorValueInput = {
  availabilityId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  dayOfWeek?: InputMaybe<Scalars['String']>;
  endTime?: InputMaybe<Scalars['time']>;
  id?: InputMaybe<Scalars['uuid']>;
  startTime?: InputMaybe<Scalars['time']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "player_availability_slots" */
export enum PlayerAvailabilitySlotsUpdateColumn {
  /** column name */
  AvailabilityId = 'availabilityId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DayOfWeek = 'dayOfWeek',
  /** column name */
  EndTime = 'endTime',
  /** column name */
  Id = 'id',
  /** column name */
  StartTime = 'startTime',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type PlayerAvailabilitySlotsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PlayerAvailabilitySlotsSetInput>;
  /** filter the rows which have to be updated */
  where: PlayerAvailabilitySlotsBoolExp;
};

/** columns and relationships of "player_availability_venues" */
export type PlayerAvailabilityVenues = {
  __typename?: 'PlayerAvailabilityVenues';
  /** An object relationship */
  availability: PlayerAvailabilities;
  availabilityId: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  userCustomCourt?: Maybe<UserCustomCourts>;
  userCustomCourtId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  venue?: Maybe<Venues>;
  venueId?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "player_availability_venues" */
export type PlayerAvailabilityVenuesAggregate = {
  __typename?: 'PlayerAvailabilityVenuesAggregate';
  aggregate?: Maybe<PlayerAvailabilityVenuesAggregateFields>;
  nodes: Array<PlayerAvailabilityVenues>;
};

export type PlayerAvailabilityVenuesAggregateBoolExp = {
  count?: InputMaybe<PlayerAvailabilityVenuesAggregateBoolExpCount>;
};

/** aggregate fields of "player_availability_venues" */
export type PlayerAvailabilityVenuesAggregateFields = {
  __typename?: 'PlayerAvailabilityVenuesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<PlayerAvailabilityVenuesMaxFields>;
  min?: Maybe<PlayerAvailabilityVenuesMinFields>;
};


/** aggregate fields of "player_availability_venues" */
export type PlayerAvailabilityVenuesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PlayerAvailabilityVenuesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "player_availability_venues" */
export type PlayerAvailabilityVenuesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<PlayerAvailabilityVenuesMaxOrderBy>;
  min?: InputMaybe<PlayerAvailabilityVenuesMinOrderBy>;
};

/** input type for inserting array relation for remote table "player_availability_venues" */
export type PlayerAvailabilityVenuesArrRelInsertInput = {
  data: Array<PlayerAvailabilityVenuesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<PlayerAvailabilityVenuesOnConflict>;
};

/** Boolean expression to filter rows from the table "player_availability_venues". All fields are combined with a logical 'AND'. */
export type PlayerAvailabilityVenuesBoolExp = {
  _and?: InputMaybe<Array<PlayerAvailabilityVenuesBoolExp>>;
  _not?: InputMaybe<PlayerAvailabilityVenuesBoolExp>;
  _or?: InputMaybe<Array<PlayerAvailabilityVenuesBoolExp>>;
  availability?: InputMaybe<PlayerAvailabilitiesBoolExp>;
  availabilityId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  userCustomCourt?: InputMaybe<UserCustomCourtsBoolExp>;
  userCustomCourtId?: InputMaybe<UuidComparisonExp>;
  venue?: InputMaybe<VenuesBoolExp>;
  venueId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "player_availability_venues" */
export enum PlayerAvailabilityVenuesConstraint {
  /** unique or primary key constraint on columns "availability_id", "user_custom_court_id" */
  PlayerAvailabilityVenuesAvailabilityIdCustomCourtKey = 'player_availability_venues_availability_id_custom_court_key',
  /** unique or primary key constraint on columns "venue_id", "availability_id" */
  PlayerAvailabilityVenuesAvailabilityIdVenueIdKey = 'player_availability_venues_availability_id_venue_id_key',
  /** unique or primary key constraint on columns "id" */
  PlayerAvailabilityVenuesPkey = 'player_availability_venues_pkey'
}

/** input type for inserting data into table "player_availability_venues" */
export type PlayerAvailabilityVenuesInsertInput = {
  availability?: InputMaybe<PlayerAvailabilitiesObjRelInsertInput>;
  availabilityId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  userCustomCourt?: InputMaybe<UserCustomCourtsObjRelInsertInput>;
  userCustomCourtId?: InputMaybe<Scalars['uuid']>;
  venue?: InputMaybe<VenuesObjRelInsertInput>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type PlayerAvailabilityVenuesMaxFields = {
  __typename?: 'PlayerAvailabilityVenuesMaxFields';
  availabilityId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  userCustomCourtId?: Maybe<Scalars['uuid']>;
  venueId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "player_availability_venues" */
export type PlayerAvailabilityVenuesMaxOrderBy = {
  availabilityId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  userCustomCourtId?: InputMaybe<OrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type PlayerAvailabilityVenuesMinFields = {
  __typename?: 'PlayerAvailabilityVenuesMinFields';
  availabilityId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  userCustomCourtId?: Maybe<Scalars['uuid']>;
  venueId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "player_availability_venues" */
export type PlayerAvailabilityVenuesMinOrderBy = {
  availabilityId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  userCustomCourtId?: InputMaybe<OrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "player_availability_venues" */
export type PlayerAvailabilityVenuesMutationResponse = {
  __typename?: 'PlayerAvailabilityVenuesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PlayerAvailabilityVenues>;
};

/** on_conflict condition type for table "player_availability_venues" */
export type PlayerAvailabilityVenuesOnConflict = {
  constraint: PlayerAvailabilityVenuesConstraint;
  updateColumns?: Array<PlayerAvailabilityVenuesUpdateColumn>;
  where?: InputMaybe<PlayerAvailabilityVenuesBoolExp>;
};

/** Ordering options when selecting data from "player_availability_venues". */
export type PlayerAvailabilityVenuesOrderBy = {
  availability?: InputMaybe<PlayerAvailabilitiesOrderBy>;
  availabilityId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  userCustomCourt?: InputMaybe<UserCustomCourtsOrderBy>;
  userCustomCourtId?: InputMaybe<OrderBy>;
  venue?: InputMaybe<VenuesOrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: player_availability_venues */
export type PlayerAvailabilityVenuesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "player_availability_venues" */
export enum PlayerAvailabilityVenuesSelectColumn {
  /** column name */
  AvailabilityId = 'availabilityId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  UserCustomCourtId = 'userCustomCourtId',
  /** column name */
  VenueId = 'venueId'
}

/** input type for updating data in table "player_availability_venues" */
export type PlayerAvailabilityVenuesSetInput = {
  availabilityId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  userCustomCourtId?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "player_availability_venues" */
export type PlayerAvailabilityVenuesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PlayerAvailabilityVenuesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PlayerAvailabilityVenuesStreamCursorValueInput = {
  availabilityId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  userCustomCourtId?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "player_availability_venues" */
export enum PlayerAvailabilityVenuesUpdateColumn {
  /** column name */
  AvailabilityId = 'availabilityId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  UserCustomCourtId = 'userCustomCourtId',
  /** column name */
  VenueId = 'venueId'
}

export type PlayerAvailabilityVenuesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PlayerAvailabilityVenuesSetInput>;
  /** filter the rows which have to be updated */
  where: PlayerAvailabilityVenuesBoolExp;
};

/** columns and relationships of "player_finder_goals" */
export type PlayerFinderGoals = {
  __typename?: 'PlayerFinderGoals';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "player_finder_goals" */
export type PlayerFinderGoalsAggregate = {
  __typename?: 'PlayerFinderGoalsAggregate';
  aggregate?: Maybe<PlayerFinderGoalsAggregateFields>;
  nodes: Array<PlayerFinderGoals>;
};

/** aggregate fields of "player_finder_goals" */
export type PlayerFinderGoalsAggregateFields = {
  __typename?: 'PlayerFinderGoalsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<PlayerFinderGoalsMaxFields>;
  min?: Maybe<PlayerFinderGoalsMinFields>;
};


/** aggregate fields of "player_finder_goals" */
export type PlayerFinderGoalsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PlayerFinderGoalsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "player_finder_goals". All fields are combined with a logical 'AND'. */
export type PlayerFinderGoalsBoolExp = {
  _and?: InputMaybe<Array<PlayerFinderGoalsBoolExp>>;
  _not?: InputMaybe<PlayerFinderGoalsBoolExp>;
  _or?: InputMaybe<Array<PlayerFinderGoalsBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "player_finder_goals" */
export enum PlayerFinderGoalsConstraint {
  /** unique or primary key constraint on columns "value" */
  PlayerFinderGoalsPkey = 'player_finder_goals_pkey'
}

export enum PlayerFinderGoalsEnum {
  CasualPlay = 'CASUAL_PLAY',
  CompetitivePlay = 'COMPETITIVE_PLAY',
  MeetNewPeople = 'MEET_NEW_PEOPLE'
}

/** Boolean expression to compare columns of type "PlayerFinderGoalsEnum". All fields are combined with logical 'AND'. */
export type PlayerFinderGoalsEnumComparisonExp = {
  _eq?: InputMaybe<PlayerFinderGoalsEnum>;
  _in?: InputMaybe<Array<PlayerFinderGoalsEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<PlayerFinderGoalsEnum>;
  _nin?: InputMaybe<Array<PlayerFinderGoalsEnum>>;
};

/** input type for inserting data into table "player_finder_goals" */
export type PlayerFinderGoalsInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type PlayerFinderGoalsMaxFields = {
  __typename?: 'PlayerFinderGoalsMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type PlayerFinderGoalsMinFields = {
  __typename?: 'PlayerFinderGoalsMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "player_finder_goals" */
export type PlayerFinderGoalsMutationResponse = {
  __typename?: 'PlayerFinderGoalsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PlayerFinderGoals>;
};

/** on_conflict condition type for table "player_finder_goals" */
export type PlayerFinderGoalsOnConflict = {
  constraint: PlayerFinderGoalsConstraint;
  updateColumns?: Array<PlayerFinderGoalsUpdateColumn>;
  where?: InputMaybe<PlayerFinderGoalsBoolExp>;
};

/** Ordering options when selecting data from "player_finder_goals". */
export type PlayerFinderGoalsOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: player_finder_goals */
export type PlayerFinderGoalsPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "player_finder_goals" */
export enum PlayerFinderGoalsSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "player_finder_goals" */
export type PlayerFinderGoalsSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "player_finder_goals" */
export type PlayerFinderGoalsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PlayerFinderGoalsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PlayerFinderGoalsStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "player_finder_goals" */
export enum PlayerFinderGoalsUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type PlayerFinderGoalsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PlayerFinderGoalsSetInput>;
  /** filter the rows which have to be updated */
  where: PlayerFinderGoalsBoolExp;
};

/** columns and relationships of "player_finder_time_of_day" */
export type PlayerFinderTimeOfDay = {
  __typename?: 'PlayerFinderTimeOfDay';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "player_finder_time_of_day" */
export type PlayerFinderTimeOfDayAggregate = {
  __typename?: 'PlayerFinderTimeOfDayAggregate';
  aggregate?: Maybe<PlayerFinderTimeOfDayAggregateFields>;
  nodes: Array<PlayerFinderTimeOfDay>;
};

/** aggregate fields of "player_finder_time_of_day" */
export type PlayerFinderTimeOfDayAggregateFields = {
  __typename?: 'PlayerFinderTimeOfDayAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<PlayerFinderTimeOfDayMaxFields>;
  min?: Maybe<PlayerFinderTimeOfDayMinFields>;
};


/** aggregate fields of "player_finder_time_of_day" */
export type PlayerFinderTimeOfDayAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PlayerFinderTimeOfDaySelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "player_finder_time_of_day". All fields are combined with a logical 'AND'. */
export type PlayerFinderTimeOfDayBoolExp = {
  _and?: InputMaybe<Array<PlayerFinderTimeOfDayBoolExp>>;
  _not?: InputMaybe<PlayerFinderTimeOfDayBoolExp>;
  _or?: InputMaybe<Array<PlayerFinderTimeOfDayBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "player_finder_time_of_day" */
export enum PlayerFinderTimeOfDayConstraint {
  /** unique or primary key constraint on columns "value" */
  PlayerFinderTimeOfDayPkey = 'player_finder_time_of_day_pkey'
}

export enum PlayerFinderTimeOfDayEnum {
  Afternoon = 'AFTERNOON',
  Evening = 'EVENING',
  Flexible = 'FLEXIBLE',
  Morning = 'MORNING'
}

/** Boolean expression to compare columns of type "PlayerFinderTimeOfDayEnum". All fields are combined with logical 'AND'. */
export type PlayerFinderTimeOfDayEnumComparisonExp = {
  _eq?: InputMaybe<PlayerFinderTimeOfDayEnum>;
  _in?: InputMaybe<Array<PlayerFinderTimeOfDayEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<PlayerFinderTimeOfDayEnum>;
  _nin?: InputMaybe<Array<PlayerFinderTimeOfDayEnum>>;
};

/** input type for inserting data into table "player_finder_time_of_day" */
export type PlayerFinderTimeOfDayInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type PlayerFinderTimeOfDayMaxFields = {
  __typename?: 'PlayerFinderTimeOfDayMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type PlayerFinderTimeOfDayMinFields = {
  __typename?: 'PlayerFinderTimeOfDayMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "player_finder_time_of_day" */
export type PlayerFinderTimeOfDayMutationResponse = {
  __typename?: 'PlayerFinderTimeOfDayMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PlayerFinderTimeOfDay>;
};

/** on_conflict condition type for table "player_finder_time_of_day" */
export type PlayerFinderTimeOfDayOnConflict = {
  constraint: PlayerFinderTimeOfDayConstraint;
  updateColumns?: Array<PlayerFinderTimeOfDayUpdateColumn>;
  where?: InputMaybe<PlayerFinderTimeOfDayBoolExp>;
};

/** Ordering options when selecting data from "player_finder_time_of_day". */
export type PlayerFinderTimeOfDayOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: player_finder_time_of_day */
export type PlayerFinderTimeOfDayPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "player_finder_time_of_day" */
export enum PlayerFinderTimeOfDaySelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "player_finder_time_of_day" */
export type PlayerFinderTimeOfDaySetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "player_finder_time_of_day" */
export type PlayerFinderTimeOfDayStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PlayerFinderTimeOfDayStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PlayerFinderTimeOfDayStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "player_finder_time_of_day" */
export enum PlayerFinderTimeOfDayUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type PlayerFinderTimeOfDayUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PlayerFinderTimeOfDaySetInput>;
  /** filter the rows which have to be updated */
  where: PlayerFinderTimeOfDayBoolExp;
};

/** columns and relationships of "recurrence_kinds" */
export type RecurrenceKinds = {
  __typename?: 'RecurrenceKinds';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "recurrence_kinds" */
export type RecurrenceKindsAggregate = {
  __typename?: 'RecurrenceKindsAggregate';
  aggregate?: Maybe<RecurrenceKindsAggregateFields>;
  nodes: Array<RecurrenceKinds>;
};

/** aggregate fields of "recurrence_kinds" */
export type RecurrenceKindsAggregateFields = {
  __typename?: 'RecurrenceKindsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<RecurrenceKindsMaxFields>;
  min?: Maybe<RecurrenceKindsMinFields>;
};


/** aggregate fields of "recurrence_kinds" */
export type RecurrenceKindsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<RecurrenceKindsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "recurrence_kinds". All fields are combined with a logical 'AND'. */
export type RecurrenceKindsBoolExp = {
  _and?: InputMaybe<Array<RecurrenceKindsBoolExp>>;
  _not?: InputMaybe<RecurrenceKindsBoolExp>;
  _or?: InputMaybe<Array<RecurrenceKindsBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "recurrence_kinds" */
export enum RecurrenceKindsConstraint {
  /** unique or primary key constraint on columns "value" */
  RecurrenceKindsPkey = 'recurrence_kinds_pkey'
}

export enum RecurrenceKindsEnum {
  Custom = 'CUSTOM',
  OneTime = 'ONE_TIME',
  Weekly = 'WEEKLY'
}

/** Boolean expression to compare columns of type "RecurrenceKindsEnum". All fields are combined with logical 'AND'. */
export type RecurrenceKindsEnumComparisonExp = {
  _eq?: InputMaybe<RecurrenceKindsEnum>;
  _in?: InputMaybe<Array<RecurrenceKindsEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<RecurrenceKindsEnum>;
  _nin?: InputMaybe<Array<RecurrenceKindsEnum>>;
};

/** input type for inserting data into table "recurrence_kinds" */
export type RecurrenceKindsInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type RecurrenceKindsMaxFields = {
  __typename?: 'RecurrenceKindsMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type RecurrenceKindsMinFields = {
  __typename?: 'RecurrenceKindsMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "recurrence_kinds" */
export type RecurrenceKindsMutationResponse = {
  __typename?: 'RecurrenceKindsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<RecurrenceKinds>;
};

/** on_conflict condition type for table "recurrence_kinds" */
export type RecurrenceKindsOnConflict = {
  constraint: RecurrenceKindsConstraint;
  updateColumns?: Array<RecurrenceKindsUpdateColumn>;
  where?: InputMaybe<RecurrenceKindsBoolExp>;
};

/** Ordering options when selecting data from "recurrence_kinds". */
export type RecurrenceKindsOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: recurrence_kinds */
export type RecurrenceKindsPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "recurrence_kinds" */
export enum RecurrenceKindsSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "recurrence_kinds" */
export type RecurrenceKindsSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "recurrence_kinds" */
export type RecurrenceKindsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: RecurrenceKindsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type RecurrenceKindsStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "recurrence_kinds" */
export enum RecurrenceKindsUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type RecurrenceKindsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RecurrenceKindsSetInput>;
  /** filter the rows which have to be updated */
  where: RecurrenceKindsBoolExp;
};

/** columns and relationships of "report_reasons" */
export type ReportReasons = {
  __typename?: 'ReportReasons';
  comment?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "report_reasons" */
export type ReportReasonsAggregate = {
  __typename?: 'ReportReasonsAggregate';
  aggregate?: Maybe<ReportReasonsAggregateFields>;
  nodes: Array<ReportReasons>;
};

/** aggregate fields of "report_reasons" */
export type ReportReasonsAggregateFields = {
  __typename?: 'ReportReasonsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<ReportReasonsMaxFields>;
  min?: Maybe<ReportReasonsMinFields>;
};


/** aggregate fields of "report_reasons" */
export type ReportReasonsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ReportReasonsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "report_reasons". All fields are combined with a logical 'AND'. */
export type ReportReasonsBoolExp = {
  _and?: InputMaybe<Array<ReportReasonsBoolExp>>;
  _not?: InputMaybe<ReportReasonsBoolExp>;
  _or?: InputMaybe<Array<ReportReasonsBoolExp>>;
  comment?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "report_reasons" */
export enum ReportReasonsConstraint {
  /** unique or primary key constraint on columns "value" */
  ReportReasonsPkey = 'report_reasons_pkey'
}

export enum ReportReasonsEnum {
  Harassment = 'HARASSMENT',
  /** inappropriate or offensive content */
  Inappropriate = 'INAPPROPRIATE',
  /** see description */
  Other = 'OTHER',
  /** safety concern */
  Safety = 'SAFETY',
  Spam = 'SPAM'
}

/** Boolean expression to compare columns of type "ReportReasonsEnum". All fields are combined with logical 'AND'. */
export type ReportReasonsEnumComparisonExp = {
  _eq?: InputMaybe<ReportReasonsEnum>;
  _in?: InputMaybe<Array<ReportReasonsEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<ReportReasonsEnum>;
  _nin?: InputMaybe<Array<ReportReasonsEnum>>;
};

/** input type for inserting data into table "report_reasons" */
export type ReportReasonsInsertInput = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ReportReasonsMaxFields = {
  __typename?: 'ReportReasonsMaxFields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type ReportReasonsMinFields = {
  __typename?: 'ReportReasonsMinFields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "report_reasons" */
export type ReportReasonsMutationResponse = {
  __typename?: 'ReportReasonsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ReportReasons>;
};

/** on_conflict condition type for table "report_reasons" */
export type ReportReasonsOnConflict = {
  constraint: ReportReasonsConstraint;
  updateColumns?: Array<ReportReasonsUpdateColumn>;
  where?: InputMaybe<ReportReasonsBoolExp>;
};

/** Ordering options when selecting data from "report_reasons". */
export type ReportReasonsOrderBy = {
  comment?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: report_reasons */
export type ReportReasonsPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "report_reasons" */
export enum ReportReasonsSelectColumn {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "report_reasons" */
export type ReportReasonsSetInput = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "report_reasons" */
export type ReportReasonsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ReportReasonsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ReportReasonsStreamCursorValueInput = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "report_reasons" */
export enum ReportReasonsUpdateColumn {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type ReportReasonsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ReportReasonsSetInput>;
  /** filter the rows which have to be updated */
  where: ReportReasonsBoolExp;
};

/** columns and relationships of "report_statuses" */
export type ReportStatuses = {
  __typename?: 'ReportStatuses';
  comment?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "report_statuses" */
export type ReportStatusesAggregate = {
  __typename?: 'ReportStatusesAggregate';
  aggregate?: Maybe<ReportStatusesAggregateFields>;
  nodes: Array<ReportStatuses>;
};

/** aggregate fields of "report_statuses" */
export type ReportStatusesAggregateFields = {
  __typename?: 'ReportStatusesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<ReportStatusesMaxFields>;
  min?: Maybe<ReportStatusesMinFields>;
};


/** aggregate fields of "report_statuses" */
export type ReportStatusesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ReportStatusesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "report_statuses". All fields are combined with a logical 'AND'. */
export type ReportStatusesBoolExp = {
  _and?: InputMaybe<Array<ReportStatusesBoolExp>>;
  _not?: InputMaybe<ReportStatusesBoolExp>;
  _or?: InputMaybe<Array<ReportStatusesBoolExp>>;
  comment?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "report_statuses" */
export enum ReportStatusesConstraint {
  /** unique or primary key constraint on columns "value" */
  ReportStatusesPkey = 'report_statuses_pkey'
}

export enum ReportStatusesEnum {
  /** action taken */
  Actioned = 'ACTIONED',
  /** no action needed */
  Dismissed = 'DISMISSED',
  /** awaiting review */
  Pending = 'PENDING',
  Reviewing = 'REVIEWING'
}

/** Boolean expression to compare columns of type "ReportStatusesEnum". All fields are combined with logical 'AND'. */
export type ReportStatusesEnumComparisonExp = {
  _eq?: InputMaybe<ReportStatusesEnum>;
  _in?: InputMaybe<Array<ReportStatusesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<ReportStatusesEnum>;
  _nin?: InputMaybe<Array<ReportStatusesEnum>>;
};

/** input type for inserting data into table "report_statuses" */
export type ReportStatusesInsertInput = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ReportStatusesMaxFields = {
  __typename?: 'ReportStatusesMaxFields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type ReportStatusesMinFields = {
  __typename?: 'ReportStatusesMinFields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "report_statuses" */
export type ReportStatusesMutationResponse = {
  __typename?: 'ReportStatusesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ReportStatuses>;
};

/** on_conflict condition type for table "report_statuses" */
export type ReportStatusesOnConflict = {
  constraint: ReportStatusesConstraint;
  updateColumns?: Array<ReportStatusesUpdateColumn>;
  where?: InputMaybe<ReportStatusesBoolExp>;
};

/** Ordering options when selecting data from "report_statuses". */
export type ReportStatusesOrderBy = {
  comment?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: report_statuses */
export type ReportStatusesPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "report_statuses" */
export enum ReportStatusesSelectColumn {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "report_statuses" */
export type ReportStatusesSetInput = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "report_statuses" */
export type ReportStatusesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ReportStatusesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ReportStatusesStreamCursorValueInput = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "report_statuses" */
export enum ReportStatusesUpdateColumn {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type ReportStatusesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ReportStatusesSetInput>;
  /** filter the rows which have to be updated */
  where: ReportStatusesBoolExp;
};

/** columns and relationships of "reviews" */
export type Reviews = {
  __typename?: 'Reviews';
  /** An object relationship */
  coach?: Maybe<UserProfiles>;
  coachUserId?: Maybe<Scalars['uuid']>;
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamp']>;
  externalDomain?: Maybe<Scalars['String']>;
  externalFullName?: Maybe<Scalars['String']>;
  externalImageFileName?: Maybe<Scalars['String']>;
  externalImageUrl?: Maybe<Scalars['String']>;
  externalSource?: Maybe<CoachExternalReviewSourcesEnum>;
  externalUrl?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  isPlayerSkillLevelAccurate?: Maybe<Scalars['Boolean']>;
  lessonId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  player?: Maybe<UserProfiles>;
  playerUserId?: Maybe<Scalars['uuid']>;
  rating: Scalars['Int'];
  review?: Maybe<Scalars['String']>;
  /** An object relationship */
  reviewer?: Maybe<UserProfiles>;
  reviewerUserId?: Maybe<Scalars['uuid']>;
  type?: Maybe<CoachReviewTypesEnum>;
  updatedAt: Scalars['timestamptz'];
  videoAnalysisId?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "reviews" */
export type ReviewsAggregate = {
  __typename?: 'ReviewsAggregate';
  aggregate?: Maybe<ReviewsAggregateFields>;
  nodes: Array<Reviews>;
};

export type ReviewsAggregateBoolExp = {
  bool_and?: InputMaybe<ReviewsAggregateBoolExpBool_And>;
  bool_or?: InputMaybe<ReviewsAggregateBoolExpBool_Or>;
  count?: InputMaybe<ReviewsAggregateBoolExpCount>;
};

/** aggregate fields of "reviews" */
export type ReviewsAggregateFields = {
  __typename?: 'ReviewsAggregateFields';
  avg?: Maybe<ReviewsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ReviewsMaxFields>;
  min?: Maybe<ReviewsMinFields>;
  stddev?: Maybe<ReviewsStddevFields>;
  stddevPop?: Maybe<ReviewsStddevPopFields>;
  stddevSamp?: Maybe<ReviewsStddevSampFields>;
  sum?: Maybe<ReviewsSumFields>;
  varPop?: Maybe<ReviewsVarPopFields>;
  varSamp?: Maybe<ReviewsVarSampFields>;
  variance?: Maybe<ReviewsVarianceFields>;
};


/** aggregate fields of "reviews" */
export type ReviewsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ReviewsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "reviews" */
export type ReviewsAggregateOrderBy = {
  avg?: InputMaybe<ReviewsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ReviewsMaxOrderBy>;
  min?: InputMaybe<ReviewsMinOrderBy>;
  stddev?: InputMaybe<ReviewsStddevOrderBy>;
  stddevPop?: InputMaybe<ReviewsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<ReviewsStddevSampOrderBy>;
  sum?: InputMaybe<ReviewsSumOrderBy>;
  varPop?: InputMaybe<ReviewsVarPopOrderBy>;
  varSamp?: InputMaybe<ReviewsVarSampOrderBy>;
  variance?: InputMaybe<ReviewsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "reviews" */
export type ReviewsArrRelInsertInput = {
  data: Array<ReviewsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<ReviewsOnConflict>;
};

/** aggregate avg on columns */
export type ReviewsAvgFields = {
  __typename?: 'ReviewsAvgFields';
  rating?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "reviews" */
export type ReviewsAvgOrderBy = {
  rating?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "reviews". All fields are combined with a logical 'AND'. */
export type ReviewsBoolExp = {
  _and?: InputMaybe<Array<ReviewsBoolExp>>;
  _not?: InputMaybe<ReviewsBoolExp>;
  _or?: InputMaybe<Array<ReviewsBoolExp>>;
  coach?: InputMaybe<UserProfilesBoolExp>;
  coachUserId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestampComparisonExp>;
  externalDomain?: InputMaybe<StringComparisonExp>;
  externalFullName?: InputMaybe<StringComparisonExp>;
  externalImageFileName?: InputMaybe<StringComparisonExp>;
  externalImageUrl?: InputMaybe<StringComparisonExp>;
  externalSource?: InputMaybe<CoachExternalReviewSourcesEnumComparisonExp>;
  externalUrl?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isPlayerSkillLevelAccurate?: InputMaybe<BooleanComparisonExp>;
  lessonId?: InputMaybe<UuidComparisonExp>;
  player?: InputMaybe<UserProfilesBoolExp>;
  playerUserId?: InputMaybe<UuidComparisonExp>;
  rating?: InputMaybe<IntComparisonExp>;
  review?: InputMaybe<StringComparisonExp>;
  reviewer?: InputMaybe<UserProfilesBoolExp>;
  reviewerUserId?: InputMaybe<UuidComparisonExp>;
  type?: InputMaybe<CoachReviewTypesEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  videoAnalysisId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "reviews" */
export enum ReviewsConstraint {
  /** unique or primary key constraint on columns "id" */
  ReviewsPkey = 'reviews_pkey'
}

/** input type for incrementing numeric columns in table "reviews" */
export type ReviewsIncInput = {
  rating?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "reviews" */
export type ReviewsInsertInput = {
  coach?: InputMaybe<UserProfilesObjRelInsertInput>;
  coachUserId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamp']>;
  externalDomain?: InputMaybe<Scalars['String']>;
  externalFullName?: InputMaybe<Scalars['String']>;
  externalImageFileName?: InputMaybe<Scalars['String']>;
  externalImageUrl?: InputMaybe<Scalars['String']>;
  externalSource?: InputMaybe<CoachExternalReviewSourcesEnum>;
  externalUrl?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  isPlayerSkillLevelAccurate?: InputMaybe<Scalars['Boolean']>;
  lessonId?: InputMaybe<Scalars['uuid']>;
  player?: InputMaybe<UserProfilesObjRelInsertInput>;
  playerUserId?: InputMaybe<Scalars['uuid']>;
  rating?: InputMaybe<Scalars['Int']>;
  review?: InputMaybe<Scalars['String']>;
  reviewer?: InputMaybe<UserProfilesObjRelInsertInput>;
  reviewerUserId?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<CoachReviewTypesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  videoAnalysisId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type ReviewsMaxFields = {
  __typename?: 'ReviewsMaxFields';
  coachUserId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamp']>;
  externalDomain?: Maybe<Scalars['String']>;
  externalFullName?: Maybe<Scalars['String']>;
  externalImageFileName?: Maybe<Scalars['String']>;
  externalImageUrl?: Maybe<Scalars['String']>;
  externalUrl?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  lessonId?: Maybe<Scalars['uuid']>;
  playerUserId?: Maybe<Scalars['uuid']>;
  rating?: Maybe<Scalars['Int']>;
  review?: Maybe<Scalars['String']>;
  reviewerUserId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  videoAnalysisId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "reviews" */
export type ReviewsMaxOrderBy = {
  coachUserId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  externalDomain?: InputMaybe<OrderBy>;
  externalFullName?: InputMaybe<OrderBy>;
  externalImageFileName?: InputMaybe<OrderBy>;
  externalImageUrl?: InputMaybe<OrderBy>;
  externalUrl?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lessonId?: InputMaybe<OrderBy>;
  playerUserId?: InputMaybe<OrderBy>;
  rating?: InputMaybe<OrderBy>;
  review?: InputMaybe<OrderBy>;
  reviewerUserId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  videoAnalysisId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type ReviewsMinFields = {
  __typename?: 'ReviewsMinFields';
  coachUserId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamp']>;
  externalDomain?: Maybe<Scalars['String']>;
  externalFullName?: Maybe<Scalars['String']>;
  externalImageFileName?: Maybe<Scalars['String']>;
  externalImageUrl?: Maybe<Scalars['String']>;
  externalUrl?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  lessonId?: Maybe<Scalars['uuid']>;
  playerUserId?: Maybe<Scalars['uuid']>;
  rating?: Maybe<Scalars['Int']>;
  review?: Maybe<Scalars['String']>;
  reviewerUserId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  videoAnalysisId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "reviews" */
export type ReviewsMinOrderBy = {
  coachUserId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  externalDomain?: InputMaybe<OrderBy>;
  externalFullName?: InputMaybe<OrderBy>;
  externalImageFileName?: InputMaybe<OrderBy>;
  externalImageUrl?: InputMaybe<OrderBy>;
  externalUrl?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lessonId?: InputMaybe<OrderBy>;
  playerUserId?: InputMaybe<OrderBy>;
  rating?: InputMaybe<OrderBy>;
  review?: InputMaybe<OrderBy>;
  reviewerUserId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  videoAnalysisId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "reviews" */
export type ReviewsMutationResponse = {
  __typename?: 'ReviewsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Reviews>;
};

/** on_conflict condition type for table "reviews" */
export type ReviewsOnConflict = {
  constraint: ReviewsConstraint;
  updateColumns?: Array<ReviewsUpdateColumn>;
  where?: InputMaybe<ReviewsBoolExp>;
};

/** Ordering options when selecting data from "reviews". */
export type ReviewsOrderBy = {
  coach?: InputMaybe<UserProfilesOrderBy>;
  coachUserId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  externalDomain?: InputMaybe<OrderBy>;
  externalFullName?: InputMaybe<OrderBy>;
  externalImageFileName?: InputMaybe<OrderBy>;
  externalImageUrl?: InputMaybe<OrderBy>;
  externalSource?: InputMaybe<OrderBy>;
  externalUrl?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  isPlayerSkillLevelAccurate?: InputMaybe<OrderBy>;
  lessonId?: InputMaybe<OrderBy>;
  player?: InputMaybe<UserProfilesOrderBy>;
  playerUserId?: InputMaybe<OrderBy>;
  rating?: InputMaybe<OrderBy>;
  review?: InputMaybe<OrderBy>;
  reviewer?: InputMaybe<UserProfilesOrderBy>;
  reviewerUserId?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  videoAnalysisId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: reviews */
export type ReviewsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "reviews" */
export enum ReviewsSelectColumn {
  /** column name */
  CoachUserId = 'coachUserId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  ExternalDomain = 'externalDomain',
  /** column name */
  ExternalFullName = 'externalFullName',
  /** column name */
  ExternalImageFileName = 'externalImageFileName',
  /** column name */
  ExternalImageUrl = 'externalImageUrl',
  /** column name */
  ExternalSource = 'externalSource',
  /** column name */
  ExternalUrl = 'externalUrl',
  /** column name */
  Id = 'id',
  /** column name */
  IsPlayerSkillLevelAccurate = 'isPlayerSkillLevelAccurate',
  /** column name */
  LessonId = 'lessonId',
  /** column name */
  PlayerUserId = 'playerUserId',
  /** column name */
  Rating = 'rating',
  /** column name */
  Review = 'review',
  /** column name */
  ReviewerUserId = 'reviewerUserId',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  VideoAnalysisId = 'videoAnalysisId'
}

/** select "reviewsAggregateBoolExpBool_andArgumentsColumns" columns of table "reviews" */
export enum ReviewsSelectColumnReviewsAggregateBoolExpBool_AndArgumentsColumns {
  /** column name */
  IsPlayerSkillLevelAccurate = 'isPlayerSkillLevelAccurate'
}

/** select "reviewsAggregateBoolExpBool_orArgumentsColumns" columns of table "reviews" */
export enum ReviewsSelectColumnReviewsAggregateBoolExpBool_OrArgumentsColumns {
  /** column name */
  IsPlayerSkillLevelAccurate = 'isPlayerSkillLevelAccurate'
}

/** input type for updating data in table "reviews" */
export type ReviewsSetInput = {
  coachUserId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamp']>;
  externalDomain?: InputMaybe<Scalars['String']>;
  externalFullName?: InputMaybe<Scalars['String']>;
  externalImageFileName?: InputMaybe<Scalars['String']>;
  externalImageUrl?: InputMaybe<Scalars['String']>;
  externalSource?: InputMaybe<CoachExternalReviewSourcesEnum>;
  externalUrl?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  isPlayerSkillLevelAccurate?: InputMaybe<Scalars['Boolean']>;
  lessonId?: InputMaybe<Scalars['uuid']>;
  playerUserId?: InputMaybe<Scalars['uuid']>;
  rating?: InputMaybe<Scalars['Int']>;
  review?: InputMaybe<Scalars['String']>;
  reviewerUserId?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<CoachReviewTypesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  videoAnalysisId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type ReviewsStddevFields = {
  __typename?: 'ReviewsStddevFields';
  rating?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "reviews" */
export type ReviewsStddevOrderBy = {
  rating?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type ReviewsStddevPopFields = {
  __typename?: 'ReviewsStddevPopFields';
  rating?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "reviews" */
export type ReviewsStddevPopOrderBy = {
  rating?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type ReviewsStddevSampFields = {
  __typename?: 'ReviewsStddevSampFields';
  rating?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "reviews" */
export type ReviewsStddevSampOrderBy = {
  rating?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "reviews" */
export type ReviewsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ReviewsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ReviewsStreamCursorValueInput = {
  coachUserId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamp']>;
  externalDomain?: InputMaybe<Scalars['String']>;
  externalFullName?: InputMaybe<Scalars['String']>;
  externalImageFileName?: InputMaybe<Scalars['String']>;
  externalImageUrl?: InputMaybe<Scalars['String']>;
  externalSource?: InputMaybe<CoachExternalReviewSourcesEnum>;
  externalUrl?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  isPlayerSkillLevelAccurate?: InputMaybe<Scalars['Boolean']>;
  lessonId?: InputMaybe<Scalars['uuid']>;
  playerUserId?: InputMaybe<Scalars['uuid']>;
  rating?: InputMaybe<Scalars['Int']>;
  review?: InputMaybe<Scalars['String']>;
  reviewerUserId?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<CoachReviewTypesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  videoAnalysisId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type ReviewsSumFields = {
  __typename?: 'ReviewsSumFields';
  rating?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "reviews" */
export type ReviewsSumOrderBy = {
  rating?: InputMaybe<OrderBy>;
};

/** update columns of table "reviews" */
export enum ReviewsUpdateColumn {
  /** column name */
  CoachUserId = 'coachUserId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  ExternalDomain = 'externalDomain',
  /** column name */
  ExternalFullName = 'externalFullName',
  /** column name */
  ExternalImageFileName = 'externalImageFileName',
  /** column name */
  ExternalImageUrl = 'externalImageUrl',
  /** column name */
  ExternalSource = 'externalSource',
  /** column name */
  ExternalUrl = 'externalUrl',
  /** column name */
  Id = 'id',
  /** column name */
  IsPlayerSkillLevelAccurate = 'isPlayerSkillLevelAccurate',
  /** column name */
  LessonId = 'lessonId',
  /** column name */
  PlayerUserId = 'playerUserId',
  /** column name */
  Rating = 'rating',
  /** column name */
  Review = 'review',
  /** column name */
  ReviewerUserId = 'reviewerUserId',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  VideoAnalysisId = 'videoAnalysisId'
}

export type ReviewsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ReviewsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ReviewsSetInput>;
  /** filter the rows which have to be updated */
  where: ReviewsBoolExp;
};

/** aggregate varPop on columns */
export type ReviewsVarPopFields = {
  __typename?: 'ReviewsVarPopFields';
  rating?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "reviews" */
export type ReviewsVarPopOrderBy = {
  rating?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type ReviewsVarSampFields = {
  __typename?: 'ReviewsVarSampFields';
  rating?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "reviews" */
export type ReviewsVarSampOrderBy = {
  rating?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type ReviewsVarianceFields = {
  __typename?: 'ReviewsVarianceFields';
  rating?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "reviews" */
export type ReviewsVarianceOrderBy = {
  rating?: InputMaybe<OrderBy>;
};

/** columns and relationships of "sales" */
export type Sales = {
  __typename?: 'Sales';
  amountPaid: Scalars['numeric'];
  createdAt: Scalars['timestamptz'];
  currency: Scalars['String'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  originalPrice?: Maybe<Scalars['numeric']>;
  paymentProcessor: PaymentProcessorsEnum;
  peerSubscriptionId?: Maybe<Scalars['uuid']>;
  peerSubscriptionPlanPriceId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  platformSubscription?: Maybe<PlatformSubscriptions>;
  platformSubscriptionId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  platformSubscriptionPlanPrice?: Maybe<PlatformSubscriptionPlanPrices>;
  platformSubscriptionPlanPriceId?: Maybe<Scalars['uuid']>;
  status: PaymentStatusesEnum;
  stripeCustomerId: Scalars['String'];
  stripePaymentStatus: Scalars['String'];
  stripePriceId?: Maybe<Scalars['String']>;
  stripeProductId?: Maybe<Scalars['String']>;
  stripeSessionId: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid'];
};

/** aggregated selection of "sales" */
export type SalesAggregate = {
  __typename?: 'SalesAggregate';
  aggregate?: Maybe<SalesAggregateFields>;
  nodes: Array<Sales>;
};

export type SalesAggregateBoolExp = {
  count?: InputMaybe<SalesAggregateBoolExpCount>;
};

/** aggregate fields of "sales" */
export type SalesAggregateFields = {
  __typename?: 'SalesAggregateFields';
  avg?: Maybe<SalesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<SalesMaxFields>;
  min?: Maybe<SalesMinFields>;
  stddev?: Maybe<SalesStddevFields>;
  stddevPop?: Maybe<SalesStddevPopFields>;
  stddevSamp?: Maybe<SalesStddevSampFields>;
  sum?: Maybe<SalesSumFields>;
  varPop?: Maybe<SalesVarPopFields>;
  varSamp?: Maybe<SalesVarSampFields>;
  variance?: Maybe<SalesVarianceFields>;
};


/** aggregate fields of "sales" */
export type SalesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<SalesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "sales" */
export type SalesAggregateOrderBy = {
  avg?: InputMaybe<SalesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<SalesMaxOrderBy>;
  min?: InputMaybe<SalesMinOrderBy>;
  stddev?: InputMaybe<SalesStddevOrderBy>;
  stddevPop?: InputMaybe<SalesStddevPopOrderBy>;
  stddevSamp?: InputMaybe<SalesStddevSampOrderBy>;
  sum?: InputMaybe<SalesSumOrderBy>;
  varPop?: InputMaybe<SalesVarPopOrderBy>;
  varSamp?: InputMaybe<SalesVarSampOrderBy>;
  variance?: InputMaybe<SalesVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "sales" */
export type SalesArrRelInsertInput = {
  data: Array<SalesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<SalesOnConflict>;
};

/** aggregate avg on columns */
export type SalesAvgFields = {
  __typename?: 'SalesAvgFields';
  amountPaid?: Maybe<Scalars['Float']>;
  originalPrice?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "sales" */
export type SalesAvgOrderBy = {
  amountPaid?: InputMaybe<OrderBy>;
  originalPrice?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "sales". All fields are combined with a logical 'AND'. */
export type SalesBoolExp = {
  _and?: InputMaybe<Array<SalesBoolExp>>;
  _not?: InputMaybe<SalesBoolExp>;
  _or?: InputMaybe<Array<SalesBoolExp>>;
  amountPaid?: InputMaybe<NumericComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  currency?: InputMaybe<StringComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  originalPrice?: InputMaybe<NumericComparisonExp>;
  paymentProcessor?: InputMaybe<PaymentProcessorsEnumComparisonExp>;
  peerSubscriptionId?: InputMaybe<UuidComparisonExp>;
  peerSubscriptionPlanPriceId?: InputMaybe<UuidComparisonExp>;
  platformSubscription?: InputMaybe<PlatformSubscriptionsBoolExp>;
  platformSubscriptionId?: InputMaybe<UuidComparisonExp>;
  platformSubscriptionPlanPrice?: InputMaybe<PlatformSubscriptionPlanPricesBoolExp>;
  platformSubscriptionPlanPriceId?: InputMaybe<UuidComparisonExp>;
  status?: InputMaybe<PaymentStatusesEnumComparisonExp>;
  stripeCustomerId?: InputMaybe<StringComparisonExp>;
  stripePaymentStatus?: InputMaybe<StringComparisonExp>;
  stripePriceId?: InputMaybe<StringComparisonExp>;
  stripeProductId?: InputMaybe<StringComparisonExp>;
  stripeSessionId?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "sales" */
export enum SalesConstraint {
  /** unique or primary key constraint on columns "id" */
  SalesPkey = 'sales_pkey',
  /** unique or primary key constraint on columns "stripe_session_id" */
  SalesStripeSessionIdKey = 'sales_stripe_session_id_key'
}

/** input type for incrementing numeric columns in table "sales" */
export type SalesIncInput = {
  amountPaid?: InputMaybe<Scalars['numeric']>;
  originalPrice?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "sales" */
export type SalesInsertInput = {
  amountPaid?: InputMaybe<Scalars['numeric']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  originalPrice?: InputMaybe<Scalars['numeric']>;
  paymentProcessor?: InputMaybe<PaymentProcessorsEnum>;
  peerSubscriptionId?: InputMaybe<Scalars['uuid']>;
  peerSubscriptionPlanPriceId?: InputMaybe<Scalars['uuid']>;
  platformSubscription?: InputMaybe<PlatformSubscriptionsObjRelInsertInput>;
  platformSubscriptionId?: InputMaybe<Scalars['uuid']>;
  platformSubscriptionPlanPrice?: InputMaybe<PlatformSubscriptionPlanPricesObjRelInsertInput>;
  platformSubscriptionPlanPriceId?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<PaymentStatusesEnum>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  stripePaymentStatus?: InputMaybe<Scalars['String']>;
  stripePriceId?: InputMaybe<Scalars['String']>;
  stripeProductId?: InputMaybe<Scalars['String']>;
  stripeSessionId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type SalesMaxFields = {
  __typename?: 'SalesMaxFields';
  amountPaid?: Maybe<Scalars['numeric']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  originalPrice?: Maybe<Scalars['numeric']>;
  peerSubscriptionId?: Maybe<Scalars['uuid']>;
  peerSubscriptionPlanPriceId?: Maybe<Scalars['uuid']>;
  platformSubscriptionId?: Maybe<Scalars['uuid']>;
  platformSubscriptionPlanPriceId?: Maybe<Scalars['uuid']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentStatus?: Maybe<Scalars['String']>;
  stripePriceId?: Maybe<Scalars['String']>;
  stripeProductId?: Maybe<Scalars['String']>;
  stripeSessionId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "sales" */
export type SalesMaxOrderBy = {
  amountPaid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  currency?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  originalPrice?: InputMaybe<OrderBy>;
  peerSubscriptionId?: InputMaybe<OrderBy>;
  peerSubscriptionPlanPriceId?: InputMaybe<OrderBy>;
  platformSubscriptionId?: InputMaybe<OrderBy>;
  platformSubscriptionPlanPriceId?: InputMaybe<OrderBy>;
  stripeCustomerId?: InputMaybe<OrderBy>;
  stripePaymentStatus?: InputMaybe<OrderBy>;
  stripePriceId?: InputMaybe<OrderBy>;
  stripeProductId?: InputMaybe<OrderBy>;
  stripeSessionId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type SalesMinFields = {
  __typename?: 'SalesMinFields';
  amountPaid?: Maybe<Scalars['numeric']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  originalPrice?: Maybe<Scalars['numeric']>;
  peerSubscriptionId?: Maybe<Scalars['uuid']>;
  peerSubscriptionPlanPriceId?: Maybe<Scalars['uuid']>;
  platformSubscriptionId?: Maybe<Scalars['uuid']>;
  platformSubscriptionPlanPriceId?: Maybe<Scalars['uuid']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentStatus?: Maybe<Scalars['String']>;
  stripePriceId?: Maybe<Scalars['String']>;
  stripeProductId?: Maybe<Scalars['String']>;
  stripeSessionId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "sales" */
export type SalesMinOrderBy = {
  amountPaid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  currency?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  originalPrice?: InputMaybe<OrderBy>;
  peerSubscriptionId?: InputMaybe<OrderBy>;
  peerSubscriptionPlanPriceId?: InputMaybe<OrderBy>;
  platformSubscriptionId?: InputMaybe<OrderBy>;
  platformSubscriptionPlanPriceId?: InputMaybe<OrderBy>;
  stripeCustomerId?: InputMaybe<OrderBy>;
  stripePaymentStatus?: InputMaybe<OrderBy>;
  stripePriceId?: InputMaybe<OrderBy>;
  stripeProductId?: InputMaybe<OrderBy>;
  stripeSessionId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "sales" */
export type SalesMutationResponse = {
  __typename?: 'SalesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Sales>;
};

/** on_conflict condition type for table "sales" */
export type SalesOnConflict = {
  constraint: SalesConstraint;
  updateColumns?: Array<SalesUpdateColumn>;
  where?: InputMaybe<SalesBoolExp>;
};

/** Ordering options when selecting data from "sales". */
export type SalesOrderBy = {
  amountPaid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  currency?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  originalPrice?: InputMaybe<OrderBy>;
  paymentProcessor?: InputMaybe<OrderBy>;
  peerSubscriptionId?: InputMaybe<OrderBy>;
  peerSubscriptionPlanPriceId?: InputMaybe<OrderBy>;
  platformSubscription?: InputMaybe<PlatformSubscriptionsOrderBy>;
  platformSubscriptionId?: InputMaybe<OrderBy>;
  platformSubscriptionPlanPrice?: InputMaybe<PlatformSubscriptionPlanPricesOrderBy>;
  platformSubscriptionPlanPriceId?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  stripeCustomerId?: InputMaybe<OrderBy>;
  stripePaymentStatus?: InputMaybe<OrderBy>;
  stripePriceId?: InputMaybe<OrderBy>;
  stripeProductId?: InputMaybe<OrderBy>;
  stripeSessionId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: sales */
export type SalesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "sales" */
export enum SalesSelectColumn {
  /** column name */
  AmountPaid = 'amountPaid',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Currency = 'currency',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  OriginalPrice = 'originalPrice',
  /** column name */
  PaymentProcessor = 'paymentProcessor',
  /** column name */
  PeerSubscriptionId = 'peerSubscriptionId',
  /** column name */
  PeerSubscriptionPlanPriceId = 'peerSubscriptionPlanPriceId',
  /** column name */
  PlatformSubscriptionId = 'platformSubscriptionId',
  /** column name */
  PlatformSubscriptionPlanPriceId = 'platformSubscriptionPlanPriceId',
  /** column name */
  Status = 'status',
  /** column name */
  StripeCustomerId = 'stripeCustomerId',
  /** column name */
  StripePaymentStatus = 'stripePaymentStatus',
  /** column name */
  StripePriceId = 'stripePriceId',
  /** column name */
  StripeProductId = 'stripeProductId',
  /** column name */
  StripeSessionId = 'stripeSessionId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "sales" */
export type SalesSetInput = {
  amountPaid?: InputMaybe<Scalars['numeric']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  originalPrice?: InputMaybe<Scalars['numeric']>;
  paymentProcessor?: InputMaybe<PaymentProcessorsEnum>;
  peerSubscriptionId?: InputMaybe<Scalars['uuid']>;
  peerSubscriptionPlanPriceId?: InputMaybe<Scalars['uuid']>;
  platformSubscriptionId?: InputMaybe<Scalars['uuid']>;
  platformSubscriptionPlanPriceId?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<PaymentStatusesEnum>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  stripePaymentStatus?: InputMaybe<Scalars['String']>;
  stripePriceId?: InputMaybe<Scalars['String']>;
  stripeProductId?: InputMaybe<Scalars['String']>;
  stripeSessionId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type SalesStddevFields = {
  __typename?: 'SalesStddevFields';
  amountPaid?: Maybe<Scalars['Float']>;
  originalPrice?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "sales" */
export type SalesStddevOrderBy = {
  amountPaid?: InputMaybe<OrderBy>;
  originalPrice?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type SalesStddevPopFields = {
  __typename?: 'SalesStddevPopFields';
  amountPaid?: Maybe<Scalars['Float']>;
  originalPrice?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "sales" */
export type SalesStddevPopOrderBy = {
  amountPaid?: InputMaybe<OrderBy>;
  originalPrice?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type SalesStddevSampFields = {
  __typename?: 'SalesStddevSampFields';
  amountPaid?: Maybe<Scalars['Float']>;
  originalPrice?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "sales" */
export type SalesStddevSampOrderBy = {
  amountPaid?: InputMaybe<OrderBy>;
  originalPrice?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "sales" */
export type SalesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: SalesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type SalesStreamCursorValueInput = {
  amountPaid?: InputMaybe<Scalars['numeric']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  originalPrice?: InputMaybe<Scalars['numeric']>;
  paymentProcessor?: InputMaybe<PaymentProcessorsEnum>;
  peerSubscriptionId?: InputMaybe<Scalars['uuid']>;
  peerSubscriptionPlanPriceId?: InputMaybe<Scalars['uuid']>;
  platformSubscriptionId?: InputMaybe<Scalars['uuid']>;
  platformSubscriptionPlanPriceId?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<PaymentStatusesEnum>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  stripePaymentStatus?: InputMaybe<Scalars['String']>;
  stripePriceId?: InputMaybe<Scalars['String']>;
  stripeProductId?: InputMaybe<Scalars['String']>;
  stripeSessionId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type SalesSumFields = {
  __typename?: 'SalesSumFields';
  amountPaid?: Maybe<Scalars['numeric']>;
  originalPrice?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "sales" */
export type SalesSumOrderBy = {
  amountPaid?: InputMaybe<OrderBy>;
  originalPrice?: InputMaybe<OrderBy>;
};

/** update columns of table "sales" */
export enum SalesUpdateColumn {
  /** column name */
  AmountPaid = 'amountPaid',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Currency = 'currency',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  OriginalPrice = 'originalPrice',
  /** column name */
  PaymentProcessor = 'paymentProcessor',
  /** column name */
  PeerSubscriptionId = 'peerSubscriptionId',
  /** column name */
  PeerSubscriptionPlanPriceId = 'peerSubscriptionPlanPriceId',
  /** column name */
  PlatformSubscriptionId = 'platformSubscriptionId',
  /** column name */
  PlatformSubscriptionPlanPriceId = 'platformSubscriptionPlanPriceId',
  /** column name */
  Status = 'status',
  /** column name */
  StripeCustomerId = 'stripeCustomerId',
  /** column name */
  StripePaymentStatus = 'stripePaymentStatus',
  /** column name */
  StripePriceId = 'stripePriceId',
  /** column name */
  StripeProductId = 'stripeProductId',
  /** column name */
  StripeSessionId = 'stripeSessionId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

export type SalesUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<SalesIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<SalesSetInput>;
  /** filter the rows which have to be updated */
  where: SalesBoolExp;
};

/** aggregate varPop on columns */
export type SalesVarPopFields = {
  __typename?: 'SalesVarPopFields';
  amountPaid?: Maybe<Scalars['Float']>;
  originalPrice?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "sales" */
export type SalesVarPopOrderBy = {
  amountPaid?: InputMaybe<OrderBy>;
  originalPrice?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type SalesVarSampFields = {
  __typename?: 'SalesVarSampFields';
  amountPaid?: Maybe<Scalars['Float']>;
  originalPrice?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "sales" */
export type SalesVarSampOrderBy = {
  amountPaid?: InputMaybe<OrderBy>;
  originalPrice?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type SalesVarianceFields = {
  __typename?: 'SalesVarianceFields';
  amountPaid?: Maybe<Scalars['Float']>;
  originalPrice?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "sales" */
export type SalesVarianceOrderBy = {
  amountPaid?: InputMaybe<OrderBy>;
  originalPrice?: InputMaybe<OrderBy>;
};

/** columns and relationships of "scoring_format" */
export type ScoringFormat = {
  __typename?: 'ScoringFormat';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "scoring_format" */
export type ScoringFormatAggregate = {
  __typename?: 'ScoringFormatAggregate';
  aggregate?: Maybe<ScoringFormatAggregateFields>;
  nodes: Array<ScoringFormat>;
};

/** aggregate fields of "scoring_format" */
export type ScoringFormatAggregateFields = {
  __typename?: 'ScoringFormatAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<ScoringFormatMaxFields>;
  min?: Maybe<ScoringFormatMinFields>;
};


/** aggregate fields of "scoring_format" */
export type ScoringFormatAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ScoringFormatSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "scoring_format". All fields are combined with a logical 'AND'. */
export type ScoringFormatBoolExp = {
  _and?: InputMaybe<Array<ScoringFormatBoolExp>>;
  _not?: InputMaybe<ScoringFormatBoolExp>;
  _or?: InputMaybe<Array<ScoringFormatBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "scoring_format" */
export enum ScoringFormatConstraint {
  /** unique or primary key constraint on columns "value" */
  ScoringFormatPkey = 'scoring_format_pkey'
}

export enum ScoringFormatEnum {
  Rally = 'RALLY',
  Traditional = 'TRADITIONAL'
}

/** Boolean expression to compare columns of type "ScoringFormatEnum". All fields are combined with logical 'AND'. */
export type ScoringFormatEnumComparisonExp = {
  _eq?: InputMaybe<ScoringFormatEnum>;
  _in?: InputMaybe<Array<ScoringFormatEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<ScoringFormatEnum>;
  _nin?: InputMaybe<Array<ScoringFormatEnum>>;
};

/** input type for inserting data into table "scoring_format" */
export type ScoringFormatInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ScoringFormatMaxFields = {
  __typename?: 'ScoringFormatMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type ScoringFormatMinFields = {
  __typename?: 'ScoringFormatMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "scoring_format" */
export type ScoringFormatMutationResponse = {
  __typename?: 'ScoringFormatMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ScoringFormat>;
};

/** on_conflict condition type for table "scoring_format" */
export type ScoringFormatOnConflict = {
  constraint: ScoringFormatConstraint;
  updateColumns?: Array<ScoringFormatUpdateColumn>;
  where?: InputMaybe<ScoringFormatBoolExp>;
};

/** Ordering options when selecting data from "scoring_format". */
export type ScoringFormatOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: scoring_format */
export type ScoringFormatPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "scoring_format" */
export enum ScoringFormatSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "scoring_format" */
export type ScoringFormatSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "scoring_format" */
export type ScoringFormatStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ScoringFormatStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ScoringFormatStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "scoring_format" */
export enum ScoringFormatUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type ScoringFormatUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ScoringFormatSetInput>;
  /** filter the rows which have to be updated */
  where: ScoringFormatBoolExp;
};

/** columns and relationships of "signup_requests" */
export type SignupRequests = {
  __typename?: 'SignupRequests';
  accountType: Scalars['String'];
  city: Scalars['String'];
  cityId?: Maybe<Scalars['uuid']>;
  country: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  email: Scalars['String'];
  eventOrganizerAccountType?: Maybe<EventOrganizerAccountTypesEnum>;
  fullDetails?: Maybe<Scalars['jsonb']>;
  fullName: Scalars['String'];
  id: Scalars['uuid'];
  ip: Scalars['String'];
  latitude?: Maybe<Scalars['numeric']>;
  longitude?: Maybe<Scalars['numeric']>;
  phoneNumber?: Maybe<Scalars['String']>;
  platform: Scalars['String'];
  preferredName: Scalars['String'];
  region: Scalars['String'];
  timezone: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  username: Scalars['String'];
  utmCampaign?: Maybe<Scalars['String']>;
  utmContent?: Maybe<Scalars['String']>;
  utmMedium?: Maybe<Scalars['String']>;
  utmSource?: Maybe<Scalars['String']>;
  zip: Scalars['String'];
};


/** columns and relationships of "signup_requests" */
export type SignupRequestsFullDetailsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "signup_requests" */
export type SignupRequestsAggregate = {
  __typename?: 'SignupRequestsAggregate';
  aggregate?: Maybe<SignupRequestsAggregateFields>;
  nodes: Array<SignupRequests>;
};

/** aggregate fields of "signup_requests" */
export type SignupRequestsAggregateFields = {
  __typename?: 'SignupRequestsAggregateFields';
  avg?: Maybe<SignupRequestsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<SignupRequestsMaxFields>;
  min?: Maybe<SignupRequestsMinFields>;
  stddev?: Maybe<SignupRequestsStddevFields>;
  stddevPop?: Maybe<SignupRequestsStddevPopFields>;
  stddevSamp?: Maybe<SignupRequestsStddevSampFields>;
  sum?: Maybe<SignupRequestsSumFields>;
  varPop?: Maybe<SignupRequestsVarPopFields>;
  varSamp?: Maybe<SignupRequestsVarSampFields>;
  variance?: Maybe<SignupRequestsVarianceFields>;
};


/** aggregate fields of "signup_requests" */
export type SignupRequestsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<SignupRequestsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type SignupRequestsAppendInput = {
  fullDetails?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type SignupRequestsAvgFields = {
  __typename?: 'SignupRequestsAvgFields';
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "signup_requests". All fields are combined with a logical 'AND'. */
export type SignupRequestsBoolExp = {
  _and?: InputMaybe<Array<SignupRequestsBoolExp>>;
  _not?: InputMaybe<SignupRequestsBoolExp>;
  _or?: InputMaybe<Array<SignupRequestsBoolExp>>;
  accountType?: InputMaybe<StringComparisonExp>;
  city?: InputMaybe<StringComparisonExp>;
  cityId?: InputMaybe<UuidComparisonExp>;
  country?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  email?: InputMaybe<StringComparisonExp>;
  eventOrganizerAccountType?: InputMaybe<EventOrganizerAccountTypesEnumComparisonExp>;
  fullDetails?: InputMaybe<JsonbComparisonExp>;
  fullName?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  ip?: InputMaybe<StringComparisonExp>;
  latitude?: InputMaybe<NumericComparisonExp>;
  longitude?: InputMaybe<NumericComparisonExp>;
  phoneNumber?: InputMaybe<StringComparisonExp>;
  platform?: InputMaybe<StringComparisonExp>;
  preferredName?: InputMaybe<StringComparisonExp>;
  region?: InputMaybe<StringComparisonExp>;
  timezone?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  username?: InputMaybe<StringComparisonExp>;
  utmCampaign?: InputMaybe<StringComparisonExp>;
  utmContent?: InputMaybe<StringComparisonExp>;
  utmMedium?: InputMaybe<StringComparisonExp>;
  utmSource?: InputMaybe<StringComparisonExp>;
  zip?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "signup_requests" */
export enum SignupRequestsConstraint {
  /** unique or primary key constraint on columns "id" */
  SignupRequestsPkey = 'signup_requests_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type SignupRequestsDeleteAtPathInput = {
  fullDetails?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type SignupRequestsDeleteElemInput = {
  fullDetails?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type SignupRequestsDeleteKeyInput = {
  fullDetails?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "signup_requests" */
export type SignupRequestsIncInput = {
  latitude?: InputMaybe<Scalars['numeric']>;
  longitude?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "signup_requests" */
export type SignupRequestsInsertInput = {
  accountType?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  cityId?: InputMaybe<Scalars['uuid']>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  eventOrganizerAccountType?: InputMaybe<EventOrganizerAccountTypesEnum>;
  fullDetails?: InputMaybe<Scalars['jsonb']>;
  fullName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  ip?: InputMaybe<Scalars['String']>;
  latitude?: InputMaybe<Scalars['numeric']>;
  longitude?: InputMaybe<Scalars['numeric']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<Scalars['String']>;
  preferredName?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  username?: InputMaybe<Scalars['String']>;
  utmCampaign?: InputMaybe<Scalars['String']>;
  utmContent?: InputMaybe<Scalars['String']>;
  utmMedium?: InputMaybe<Scalars['String']>;
  utmSource?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type SignupRequestsMaxFields = {
  __typename?: 'SignupRequestsMaxFields';
  accountType?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  cityId?: Maybe<Scalars['uuid']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  ip?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['numeric']>;
  longitude?: Maybe<Scalars['numeric']>;
  phoneNumber?: Maybe<Scalars['String']>;
  platform?: Maybe<Scalars['String']>;
  preferredName?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  username?: Maybe<Scalars['String']>;
  utmCampaign?: Maybe<Scalars['String']>;
  utmContent?: Maybe<Scalars['String']>;
  utmMedium?: Maybe<Scalars['String']>;
  utmSource?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type SignupRequestsMinFields = {
  __typename?: 'SignupRequestsMinFields';
  accountType?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  cityId?: Maybe<Scalars['uuid']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  ip?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['numeric']>;
  longitude?: Maybe<Scalars['numeric']>;
  phoneNumber?: Maybe<Scalars['String']>;
  platform?: Maybe<Scalars['String']>;
  preferredName?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  username?: Maybe<Scalars['String']>;
  utmCampaign?: Maybe<Scalars['String']>;
  utmContent?: Maybe<Scalars['String']>;
  utmMedium?: Maybe<Scalars['String']>;
  utmSource?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "signup_requests" */
export type SignupRequestsMutationResponse = {
  __typename?: 'SignupRequestsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<SignupRequests>;
};

/** on_conflict condition type for table "signup_requests" */
export type SignupRequestsOnConflict = {
  constraint: SignupRequestsConstraint;
  updateColumns?: Array<SignupRequestsUpdateColumn>;
  where?: InputMaybe<SignupRequestsBoolExp>;
};

/** Ordering options when selecting data from "signup_requests". */
export type SignupRequestsOrderBy = {
  accountType?: InputMaybe<OrderBy>;
  city?: InputMaybe<OrderBy>;
  cityId?: InputMaybe<OrderBy>;
  country?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  email?: InputMaybe<OrderBy>;
  eventOrganizerAccountType?: InputMaybe<OrderBy>;
  fullDetails?: InputMaybe<OrderBy>;
  fullName?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  ip?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  phoneNumber?: InputMaybe<OrderBy>;
  platform?: InputMaybe<OrderBy>;
  preferredName?: InputMaybe<OrderBy>;
  region?: InputMaybe<OrderBy>;
  timezone?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  username?: InputMaybe<OrderBy>;
  utmCampaign?: InputMaybe<OrderBy>;
  utmContent?: InputMaybe<OrderBy>;
  utmMedium?: InputMaybe<OrderBy>;
  utmSource?: InputMaybe<OrderBy>;
  zip?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: signup_requests */
export type SignupRequestsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type SignupRequestsPrependInput = {
  fullDetails?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "signup_requests" */
export enum SignupRequestsSelectColumn {
  /** column name */
  AccountType = 'accountType',
  /** column name */
  City = 'city',
  /** column name */
  CityId = 'cityId',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Email = 'email',
  /** column name */
  EventOrganizerAccountType = 'eventOrganizerAccountType',
  /** column name */
  FullDetails = 'fullDetails',
  /** column name */
  FullName = 'fullName',
  /** column name */
  Id = 'id',
  /** column name */
  Ip = 'ip',
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Longitude = 'longitude',
  /** column name */
  PhoneNumber = 'phoneNumber',
  /** column name */
  Platform = 'platform',
  /** column name */
  PreferredName = 'preferredName',
  /** column name */
  Region = 'region',
  /** column name */
  Timezone = 'timezone',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Username = 'username',
  /** column name */
  UtmCampaign = 'utmCampaign',
  /** column name */
  UtmContent = 'utmContent',
  /** column name */
  UtmMedium = 'utmMedium',
  /** column name */
  UtmSource = 'utmSource',
  /** column name */
  Zip = 'zip'
}

/** input type for updating data in table "signup_requests" */
export type SignupRequestsSetInput = {
  accountType?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  cityId?: InputMaybe<Scalars['uuid']>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  eventOrganizerAccountType?: InputMaybe<EventOrganizerAccountTypesEnum>;
  fullDetails?: InputMaybe<Scalars['jsonb']>;
  fullName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  ip?: InputMaybe<Scalars['String']>;
  latitude?: InputMaybe<Scalars['numeric']>;
  longitude?: InputMaybe<Scalars['numeric']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<Scalars['String']>;
  preferredName?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  username?: InputMaybe<Scalars['String']>;
  utmCampaign?: InputMaybe<Scalars['String']>;
  utmContent?: InputMaybe<Scalars['String']>;
  utmMedium?: InputMaybe<Scalars['String']>;
  utmSource?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type SignupRequestsStddevFields = {
  __typename?: 'SignupRequestsStddevFields';
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type SignupRequestsStddevPopFields = {
  __typename?: 'SignupRequestsStddevPopFields';
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type SignupRequestsStddevSampFields = {
  __typename?: 'SignupRequestsStddevSampFields';
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "signup_requests" */
export type SignupRequestsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: SignupRequestsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type SignupRequestsStreamCursorValueInput = {
  accountType?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  cityId?: InputMaybe<Scalars['uuid']>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  eventOrganizerAccountType?: InputMaybe<EventOrganizerAccountTypesEnum>;
  fullDetails?: InputMaybe<Scalars['jsonb']>;
  fullName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  ip?: InputMaybe<Scalars['String']>;
  latitude?: InputMaybe<Scalars['numeric']>;
  longitude?: InputMaybe<Scalars['numeric']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<Scalars['String']>;
  preferredName?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  username?: InputMaybe<Scalars['String']>;
  utmCampaign?: InputMaybe<Scalars['String']>;
  utmContent?: InputMaybe<Scalars['String']>;
  utmMedium?: InputMaybe<Scalars['String']>;
  utmSource?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type SignupRequestsSumFields = {
  __typename?: 'SignupRequestsSumFields';
  latitude?: Maybe<Scalars['numeric']>;
  longitude?: Maybe<Scalars['numeric']>;
};

/** update columns of table "signup_requests" */
export enum SignupRequestsUpdateColumn {
  /** column name */
  AccountType = 'accountType',
  /** column name */
  City = 'city',
  /** column name */
  CityId = 'cityId',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Email = 'email',
  /** column name */
  EventOrganizerAccountType = 'eventOrganizerAccountType',
  /** column name */
  FullDetails = 'fullDetails',
  /** column name */
  FullName = 'fullName',
  /** column name */
  Id = 'id',
  /** column name */
  Ip = 'ip',
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Longitude = 'longitude',
  /** column name */
  PhoneNumber = 'phoneNumber',
  /** column name */
  Platform = 'platform',
  /** column name */
  PreferredName = 'preferredName',
  /** column name */
  Region = 'region',
  /** column name */
  Timezone = 'timezone',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Username = 'username',
  /** column name */
  UtmCampaign = 'utmCampaign',
  /** column name */
  UtmContent = 'utmContent',
  /** column name */
  UtmMedium = 'utmMedium',
  /** column name */
  UtmSource = 'utmSource',
  /** column name */
  Zip = 'zip'
}

export type SignupRequestsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<SignupRequestsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _deleteAtPath?: InputMaybe<SignupRequestsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _deleteElem?: InputMaybe<SignupRequestsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _deleteKey?: InputMaybe<SignupRequestsDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<SignupRequestsIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<SignupRequestsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<SignupRequestsSetInput>;
  /** filter the rows which have to be updated */
  where: SignupRequestsBoolExp;
};

/** aggregate varPop on columns */
export type SignupRequestsVarPopFields = {
  __typename?: 'SignupRequestsVarPopFields';
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type SignupRequestsVarSampFields = {
  __typename?: 'SignupRequestsVarSampFields';
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type SignupRequestsVarianceFields = {
  __typename?: 'SignupRequestsVarianceFields';
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "skill_level_values" */
export type SkillLevelValues = {
  __typename?: 'SkillLevelValues';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "skill_level_values" */
export type SkillLevelValuesAggregate = {
  __typename?: 'SkillLevelValuesAggregate';
  aggregate?: Maybe<SkillLevelValuesAggregateFields>;
  nodes: Array<SkillLevelValues>;
};

/** aggregate fields of "skill_level_values" */
export type SkillLevelValuesAggregateFields = {
  __typename?: 'SkillLevelValuesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<SkillLevelValuesMaxFields>;
  min?: Maybe<SkillLevelValuesMinFields>;
};


/** aggregate fields of "skill_level_values" */
export type SkillLevelValuesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<SkillLevelValuesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "skill_level_values". All fields are combined with a logical 'AND'. */
export type SkillLevelValuesBoolExp = {
  _and?: InputMaybe<Array<SkillLevelValuesBoolExp>>;
  _not?: InputMaybe<SkillLevelValuesBoolExp>;
  _or?: InputMaybe<Array<SkillLevelValuesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "skill_level_values" */
export enum SkillLevelValuesConstraint {
  /** unique or primary key constraint on columns "value" */
  SkillLevelValuesPkey = 'skill_level_values_pkey'
}

export enum SkillLevelValuesEnum {
  Advanced = 'ADVANCED',
  Beginner = 'BEGINNER',
  BrandNew = 'BRAND_NEW',
  DoNotPlay = 'DO_NOT_PLAY',
  Intermediate = 'INTERMEDIATE',
  NoResponse = 'NO_RESPONSE',
  Pro = 'PRO'
}

/** Boolean expression to compare columns of type "SkillLevelValuesEnum". All fields are combined with logical 'AND'. */
export type SkillLevelValuesEnumComparisonExp = {
  _eq?: InputMaybe<SkillLevelValuesEnum>;
  _in?: InputMaybe<Array<SkillLevelValuesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<SkillLevelValuesEnum>;
  _nin?: InputMaybe<Array<SkillLevelValuesEnum>>;
};

/** input type for inserting data into table "skill_level_values" */
export type SkillLevelValuesInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type SkillLevelValuesMaxFields = {
  __typename?: 'SkillLevelValuesMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type SkillLevelValuesMinFields = {
  __typename?: 'SkillLevelValuesMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "skill_level_values" */
export type SkillLevelValuesMutationResponse = {
  __typename?: 'SkillLevelValuesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<SkillLevelValues>;
};

/** on_conflict condition type for table "skill_level_values" */
export type SkillLevelValuesOnConflict = {
  constraint: SkillLevelValuesConstraint;
  updateColumns?: Array<SkillLevelValuesUpdateColumn>;
  where?: InputMaybe<SkillLevelValuesBoolExp>;
};

/** Ordering options when selecting data from "skill_level_values". */
export type SkillLevelValuesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: skill_level_values */
export type SkillLevelValuesPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "skill_level_values" */
export enum SkillLevelValuesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "skill_level_values" */
export type SkillLevelValuesSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "skill_level_values" */
export type SkillLevelValuesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: SkillLevelValuesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type SkillLevelValuesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "skill_level_values" */
export enum SkillLevelValuesUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type SkillLevelValuesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<SkillLevelValuesSetInput>;
  /** filter the rows which have to be updated */
  where: SkillLevelValuesBoolExp;
};

/** columns and relationships of "skill_levels" */
export type SkillLevels = {
  __typename?: 'SkillLevels';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  displayName: Scalars['String'];
  id: SkillLevelValuesEnum;
  isDisplayed: Scalars['Boolean'];
  rank: Scalars['Int'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "skill_levels" */
export type SkillLevelsAggregate = {
  __typename?: 'SkillLevelsAggregate';
  aggregate?: Maybe<SkillLevelsAggregateFields>;
  nodes: Array<SkillLevels>;
};

/** aggregate fields of "skill_levels" */
export type SkillLevelsAggregateFields = {
  __typename?: 'SkillLevelsAggregateFields';
  avg?: Maybe<SkillLevelsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<SkillLevelsMaxFields>;
  min?: Maybe<SkillLevelsMinFields>;
  stddev?: Maybe<SkillLevelsStddevFields>;
  stddevPop?: Maybe<SkillLevelsStddevPopFields>;
  stddevSamp?: Maybe<SkillLevelsStddevSampFields>;
  sum?: Maybe<SkillLevelsSumFields>;
  varPop?: Maybe<SkillLevelsVarPopFields>;
  varSamp?: Maybe<SkillLevelsVarSampFields>;
  variance?: Maybe<SkillLevelsVarianceFields>;
};


/** aggregate fields of "skill_levels" */
export type SkillLevelsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<SkillLevelsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type SkillLevelsAvgFields = {
  __typename?: 'SkillLevelsAvgFields';
  rank?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "skill_levels". All fields are combined with a logical 'AND'. */
export type SkillLevelsBoolExp = {
  _and?: InputMaybe<Array<SkillLevelsBoolExp>>;
  _not?: InputMaybe<SkillLevelsBoolExp>;
  _or?: InputMaybe<Array<SkillLevelsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  displayName?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<SkillLevelValuesEnumComparisonExp>;
  isDisplayed?: InputMaybe<BooleanComparisonExp>;
  rank?: InputMaybe<IntComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "skill_levels" */
export enum SkillLevelsConstraint {
  /** unique or primary key constraint on columns "id" */
  SkillLevelsPkey = 'skill_levels_pkey',
  /** unique or primary key constraint on columns "rank" */
  SkillLevelsRankKey = 'skill_levels_rank_key'
}

/** input type for incrementing numeric columns in table "skill_levels" */
export type SkillLevelsIncInput = {
  rank?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "skill_levels" */
export type SkillLevelsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  displayName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<SkillLevelValuesEnum>;
  isDisplayed?: InputMaybe<Scalars['Boolean']>;
  rank?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type SkillLevelsMaxFields = {
  __typename?: 'SkillLevelsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  displayName?: Maybe<Scalars['String']>;
  rank?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type SkillLevelsMinFields = {
  __typename?: 'SkillLevelsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  displayName?: Maybe<Scalars['String']>;
  rank?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "skill_levels" */
export type SkillLevelsMutationResponse = {
  __typename?: 'SkillLevelsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<SkillLevels>;
};

/** input type for inserting object relation for remote table "skill_levels" */
export type SkillLevelsObjRelInsertInput = {
  data: SkillLevelsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<SkillLevelsOnConflict>;
};

/** on_conflict condition type for table "skill_levels" */
export type SkillLevelsOnConflict = {
  constraint: SkillLevelsConstraint;
  updateColumns?: Array<SkillLevelsUpdateColumn>;
  where?: InputMaybe<SkillLevelsBoolExp>;
};

/** Ordering options when selecting data from "skill_levels". */
export type SkillLevelsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  displayName?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  isDisplayed?: InputMaybe<OrderBy>;
  rank?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: skill_levels */
export type SkillLevelsPkColumnsInput = {
  id: SkillLevelValuesEnum;
};

/** select columns of table "skill_levels" */
export enum SkillLevelsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  DisplayName = 'displayName',
  /** column name */
  Id = 'id',
  /** column name */
  IsDisplayed = 'isDisplayed',
  /** column name */
  Rank = 'rank',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "skill_levels" */
export type SkillLevelsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  displayName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<SkillLevelValuesEnum>;
  isDisplayed?: InputMaybe<Scalars['Boolean']>;
  rank?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type SkillLevelsStddevFields = {
  __typename?: 'SkillLevelsStddevFields';
  rank?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type SkillLevelsStddevPopFields = {
  __typename?: 'SkillLevelsStddevPopFields';
  rank?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type SkillLevelsStddevSampFields = {
  __typename?: 'SkillLevelsStddevSampFields';
  rank?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "skill_levels" */
export type SkillLevelsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: SkillLevelsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type SkillLevelsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  displayName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<SkillLevelValuesEnum>;
  isDisplayed?: InputMaybe<Scalars['Boolean']>;
  rank?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type SkillLevelsSumFields = {
  __typename?: 'SkillLevelsSumFields';
  rank?: Maybe<Scalars['Int']>;
};

/** update columns of table "skill_levels" */
export enum SkillLevelsUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  DisplayName = 'displayName',
  /** column name */
  Id = 'id',
  /** column name */
  IsDisplayed = 'isDisplayed',
  /** column name */
  Rank = 'rank',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type SkillLevelsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<SkillLevelsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<SkillLevelsSetInput>;
  /** filter the rows which have to be updated */
  where: SkillLevelsBoolExp;
};

/** aggregate varPop on columns */
export type SkillLevelsVarPopFields = {
  __typename?: 'SkillLevelsVarPopFields';
  rank?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type SkillLevelsVarSampFields = {
  __typename?: 'SkillLevelsVarSampFields';
  rank?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type SkillLevelsVarianceFields = {
  __typename?: 'SkillLevelsVarianceFields';
  rank?: Maybe<Scalars['Float']>;
};

/** Boolean expression to compare columns of type "smallint". All fields are combined with logical 'AND'. */
export type SmallintComparisonExp = {
  _eq?: InputMaybe<Scalars['smallint']>;
  _gt?: InputMaybe<Scalars['smallint']>;
  _gte?: InputMaybe<Scalars['smallint']>;
  _in?: InputMaybe<Array<Scalars['smallint']>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['smallint']>;
  _lte?: InputMaybe<Scalars['smallint']>;
  _neq?: InputMaybe<Scalars['smallint']>;
  _nin?: InputMaybe<Array<Scalars['smallint']>>;
};

/** columns and relationships of "sports" */
export type Sports = {
  __typename?: 'Sports';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "sports" */
export type SportsAggregate = {
  __typename?: 'SportsAggregate';
  aggregate?: Maybe<SportsAggregateFields>;
  nodes: Array<Sports>;
};

/** aggregate fields of "sports" */
export type SportsAggregateFields = {
  __typename?: 'SportsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<SportsMaxFields>;
  min?: Maybe<SportsMinFields>;
};


/** aggregate fields of "sports" */
export type SportsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<SportsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "sports". All fields are combined with a logical 'AND'. */
export type SportsBoolExp = {
  _and?: InputMaybe<Array<SportsBoolExp>>;
  _not?: InputMaybe<SportsBoolExp>;
  _or?: InputMaybe<Array<SportsBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "sports" */
export enum SportsConstraint {
  /** unique or primary key constraint on columns "value" */
  SportsPkey = 'sports_pkey'
}

export enum SportsEnum {
  Padel = 'PADEL',
  Pickleball = 'PICKLEBALL',
  PlatformTennis = 'PLATFORM_TENNIS',
  Tennis = 'TENNIS'
}

/** Boolean expression to compare columns of type "SportsEnum". All fields are combined with logical 'AND'. */
export type SportsEnumComparisonExp = {
  _eq?: InputMaybe<SportsEnum>;
  _in?: InputMaybe<Array<SportsEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<SportsEnum>;
  _nin?: InputMaybe<Array<SportsEnum>>;
};

/** input type for inserting data into table "sports" */
export type SportsInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type SportsMaxFields = {
  __typename?: 'SportsMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type SportsMinFields = {
  __typename?: 'SportsMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "sports" */
export type SportsMutationResponse = {
  __typename?: 'SportsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Sports>;
};

/** input type for inserting object relation for remote table "sports" */
export type SportsObjRelInsertInput = {
  data: SportsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<SportsOnConflict>;
};

/** on_conflict condition type for table "sports" */
export type SportsOnConflict = {
  constraint: SportsConstraint;
  updateColumns?: Array<SportsUpdateColumn>;
  where?: InputMaybe<SportsBoolExp>;
};

/** Ordering options when selecting data from "sports". */
export type SportsOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: sports */
export type SportsPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "sports" */
export enum SportsSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "sports" */
export type SportsSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "sports" */
export type SportsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: SportsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type SportsStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "sports" */
export enum SportsUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type SportsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<SportsSetInput>;
  /** filter the rows which have to be updated */
  where: SportsBoolExp;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type StringComparisonExp = {
  _eq?: InputMaybe<Scalars['String']>;
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "stripe_charges" */
export type StripeCharges = {
  __typename?: 'StripeCharges';
  amount: Scalars['Int'];
  amountCaptured: Scalars['Int'];
  amountRefunded: Scalars['Int'];
  application?: Maybe<Scalars['String']>;
  applicationFee?: Maybe<Scalars['String']>;
  applicationFeeAmount?: Maybe<Scalars['Int']>;
  calculatedStatementDescriptor?: Maybe<Scalars['String']>;
  captured: Scalars['Boolean'];
  chargeId: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  currency: Scalars['String'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  disputed: Scalars['Boolean'];
  externalStripePaymentIntentId: Scalars['String'];
  id: Scalars['uuid'];
  internalStripePaymentIntentId: Scalars['uuid'];
  paid: Scalars['Boolean'];
  /** An object relationship */
  paymentIntentExternal: StripePaymentIntents;
  /** An object relationship */
  paymentIntentInternal: StripePaymentIntents;
  paymentMethod?: Maybe<Scalars['String']>;
  /** An object relationship */
  paymentMethodUsed?: Maybe<UserCreditCards>;
  refunded: Scalars['Boolean'];
  sourceTransfer?: Maybe<Scalars['String']>;
  stripeCustomerId: Scalars['String'];
  transferDataAmount?: Maybe<Scalars['Int']>;
  transferDataDestination?: Maybe<Scalars['String']>;
  transferId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "stripe_charges" */
export type StripeChargesAggregate = {
  __typename?: 'StripeChargesAggregate';
  aggregate?: Maybe<StripeChargesAggregateFields>;
  nodes: Array<StripeCharges>;
};

export type StripeChargesAggregateBoolExp = {
  bool_and?: InputMaybe<StripeChargesAggregateBoolExpBool_And>;
  bool_or?: InputMaybe<StripeChargesAggregateBoolExpBool_Or>;
  count?: InputMaybe<StripeChargesAggregateBoolExpCount>;
};

/** aggregate fields of "stripe_charges" */
export type StripeChargesAggregateFields = {
  __typename?: 'StripeChargesAggregateFields';
  avg?: Maybe<StripeChargesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<StripeChargesMaxFields>;
  min?: Maybe<StripeChargesMinFields>;
  stddev?: Maybe<StripeChargesStddevFields>;
  stddevPop?: Maybe<StripeChargesStddevPopFields>;
  stddevSamp?: Maybe<StripeChargesStddevSampFields>;
  sum?: Maybe<StripeChargesSumFields>;
  varPop?: Maybe<StripeChargesVarPopFields>;
  varSamp?: Maybe<StripeChargesVarSampFields>;
  variance?: Maybe<StripeChargesVarianceFields>;
};


/** aggregate fields of "stripe_charges" */
export type StripeChargesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<StripeChargesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "stripe_charges" */
export type StripeChargesAggregateOrderBy = {
  avg?: InputMaybe<StripeChargesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<StripeChargesMaxOrderBy>;
  min?: InputMaybe<StripeChargesMinOrderBy>;
  stddev?: InputMaybe<StripeChargesStddevOrderBy>;
  stddevPop?: InputMaybe<StripeChargesStddevPopOrderBy>;
  stddevSamp?: InputMaybe<StripeChargesStddevSampOrderBy>;
  sum?: InputMaybe<StripeChargesSumOrderBy>;
  varPop?: InputMaybe<StripeChargesVarPopOrderBy>;
  varSamp?: InputMaybe<StripeChargesVarSampOrderBy>;
  variance?: InputMaybe<StripeChargesVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "stripe_charges" */
export type StripeChargesArrRelInsertInput = {
  data: Array<StripeChargesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<StripeChargesOnConflict>;
};

/** aggregate avg on columns */
export type StripeChargesAvgFields = {
  __typename?: 'StripeChargesAvgFields';
  amount?: Maybe<Scalars['Float']>;
  amountCaptured?: Maybe<Scalars['Float']>;
  amountRefunded?: Maybe<Scalars['Float']>;
  applicationFeeAmount?: Maybe<Scalars['Float']>;
  transferDataAmount?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "stripe_charges" */
export type StripeChargesAvgOrderBy = {
  amount?: InputMaybe<OrderBy>;
  amountCaptured?: InputMaybe<OrderBy>;
  amountRefunded?: InputMaybe<OrderBy>;
  applicationFeeAmount?: InputMaybe<OrderBy>;
  transferDataAmount?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "stripe_charges". All fields are combined with a logical 'AND'. */
export type StripeChargesBoolExp = {
  _and?: InputMaybe<Array<StripeChargesBoolExp>>;
  _not?: InputMaybe<StripeChargesBoolExp>;
  _or?: InputMaybe<Array<StripeChargesBoolExp>>;
  amount?: InputMaybe<IntComparisonExp>;
  amountCaptured?: InputMaybe<IntComparisonExp>;
  amountRefunded?: InputMaybe<IntComparisonExp>;
  application?: InputMaybe<StringComparisonExp>;
  applicationFee?: InputMaybe<StringComparisonExp>;
  applicationFeeAmount?: InputMaybe<IntComparisonExp>;
  calculatedStatementDescriptor?: InputMaybe<StringComparisonExp>;
  captured?: InputMaybe<BooleanComparisonExp>;
  chargeId?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  currency?: InputMaybe<StringComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  disputed?: InputMaybe<BooleanComparisonExp>;
  externalStripePaymentIntentId?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  internalStripePaymentIntentId?: InputMaybe<UuidComparisonExp>;
  paid?: InputMaybe<BooleanComparisonExp>;
  paymentIntentExternal?: InputMaybe<StripePaymentIntentsBoolExp>;
  paymentIntentInternal?: InputMaybe<StripePaymentIntentsBoolExp>;
  paymentMethod?: InputMaybe<StringComparisonExp>;
  paymentMethodUsed?: InputMaybe<UserCreditCardsBoolExp>;
  refunded?: InputMaybe<BooleanComparisonExp>;
  sourceTransfer?: InputMaybe<StringComparisonExp>;
  stripeCustomerId?: InputMaybe<StringComparisonExp>;
  transferDataAmount?: InputMaybe<IntComparisonExp>;
  transferDataDestination?: InputMaybe<StringComparisonExp>;
  transferId?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "stripe_charges" */
export enum StripeChargesConstraint {
  /** unique or primary key constraint on columns "charge_id" */
  StripeChargesChargeIdKey = 'stripe_charges_charge_id_key',
  /** unique or primary key constraint on columns "id" */
  StripeChargesPkey = 'stripe_charges_pkey'
}

/** input type for incrementing numeric columns in table "stripe_charges" */
export type StripeChargesIncInput = {
  amount?: InputMaybe<Scalars['Int']>;
  amountCaptured?: InputMaybe<Scalars['Int']>;
  amountRefunded?: InputMaybe<Scalars['Int']>;
  applicationFeeAmount?: InputMaybe<Scalars['Int']>;
  transferDataAmount?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "stripe_charges" */
export type StripeChargesInsertInput = {
  amount?: InputMaybe<Scalars['Int']>;
  amountCaptured?: InputMaybe<Scalars['Int']>;
  amountRefunded?: InputMaybe<Scalars['Int']>;
  application?: InputMaybe<Scalars['String']>;
  applicationFee?: InputMaybe<Scalars['String']>;
  applicationFeeAmount?: InputMaybe<Scalars['Int']>;
  calculatedStatementDescriptor?: InputMaybe<Scalars['String']>;
  captured?: InputMaybe<Scalars['Boolean']>;
  chargeId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  disputed?: InputMaybe<Scalars['Boolean']>;
  externalStripePaymentIntentId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  internalStripePaymentIntentId?: InputMaybe<Scalars['uuid']>;
  paid?: InputMaybe<Scalars['Boolean']>;
  paymentIntentExternal?: InputMaybe<StripePaymentIntentsObjRelInsertInput>;
  paymentIntentInternal?: InputMaybe<StripePaymentIntentsObjRelInsertInput>;
  paymentMethod?: InputMaybe<Scalars['String']>;
  paymentMethodUsed?: InputMaybe<UserCreditCardsObjRelInsertInput>;
  refunded?: InputMaybe<Scalars['Boolean']>;
  sourceTransfer?: InputMaybe<Scalars['String']>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  transferDataAmount?: InputMaybe<Scalars['Int']>;
  transferDataDestination?: InputMaybe<Scalars['String']>;
  transferId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type StripeChargesMaxFields = {
  __typename?: 'StripeChargesMaxFields';
  amount?: Maybe<Scalars['Int']>;
  amountCaptured?: Maybe<Scalars['Int']>;
  amountRefunded?: Maybe<Scalars['Int']>;
  application?: Maybe<Scalars['String']>;
  applicationFee?: Maybe<Scalars['String']>;
  applicationFeeAmount?: Maybe<Scalars['Int']>;
  calculatedStatementDescriptor?: Maybe<Scalars['String']>;
  chargeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  externalStripePaymentIntentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  internalStripePaymentIntentId?: Maybe<Scalars['uuid']>;
  paymentMethod?: Maybe<Scalars['String']>;
  sourceTransfer?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  transferDataAmount?: Maybe<Scalars['Int']>;
  transferDataDestination?: Maybe<Scalars['String']>;
  transferId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "stripe_charges" */
export type StripeChargesMaxOrderBy = {
  amount?: InputMaybe<OrderBy>;
  amountCaptured?: InputMaybe<OrderBy>;
  amountRefunded?: InputMaybe<OrderBy>;
  application?: InputMaybe<OrderBy>;
  applicationFee?: InputMaybe<OrderBy>;
  applicationFeeAmount?: InputMaybe<OrderBy>;
  calculatedStatementDescriptor?: InputMaybe<OrderBy>;
  chargeId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  currency?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  externalStripePaymentIntentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  internalStripePaymentIntentId?: InputMaybe<OrderBy>;
  paymentMethod?: InputMaybe<OrderBy>;
  sourceTransfer?: InputMaybe<OrderBy>;
  stripeCustomerId?: InputMaybe<OrderBy>;
  transferDataAmount?: InputMaybe<OrderBy>;
  transferDataDestination?: InputMaybe<OrderBy>;
  transferId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type StripeChargesMinFields = {
  __typename?: 'StripeChargesMinFields';
  amount?: Maybe<Scalars['Int']>;
  amountCaptured?: Maybe<Scalars['Int']>;
  amountRefunded?: Maybe<Scalars['Int']>;
  application?: Maybe<Scalars['String']>;
  applicationFee?: Maybe<Scalars['String']>;
  applicationFeeAmount?: Maybe<Scalars['Int']>;
  calculatedStatementDescriptor?: Maybe<Scalars['String']>;
  chargeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  externalStripePaymentIntentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  internalStripePaymentIntentId?: Maybe<Scalars['uuid']>;
  paymentMethod?: Maybe<Scalars['String']>;
  sourceTransfer?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  transferDataAmount?: Maybe<Scalars['Int']>;
  transferDataDestination?: Maybe<Scalars['String']>;
  transferId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "stripe_charges" */
export type StripeChargesMinOrderBy = {
  amount?: InputMaybe<OrderBy>;
  amountCaptured?: InputMaybe<OrderBy>;
  amountRefunded?: InputMaybe<OrderBy>;
  application?: InputMaybe<OrderBy>;
  applicationFee?: InputMaybe<OrderBy>;
  applicationFeeAmount?: InputMaybe<OrderBy>;
  calculatedStatementDescriptor?: InputMaybe<OrderBy>;
  chargeId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  currency?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  externalStripePaymentIntentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  internalStripePaymentIntentId?: InputMaybe<OrderBy>;
  paymentMethod?: InputMaybe<OrderBy>;
  sourceTransfer?: InputMaybe<OrderBy>;
  stripeCustomerId?: InputMaybe<OrderBy>;
  transferDataAmount?: InputMaybe<OrderBy>;
  transferDataDestination?: InputMaybe<OrderBy>;
  transferId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "stripe_charges" */
export type StripeChargesMutationResponse = {
  __typename?: 'StripeChargesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<StripeCharges>;
};

/** on_conflict condition type for table "stripe_charges" */
export type StripeChargesOnConflict = {
  constraint: StripeChargesConstraint;
  updateColumns?: Array<StripeChargesUpdateColumn>;
  where?: InputMaybe<StripeChargesBoolExp>;
};

/** Ordering options when selecting data from "stripe_charges". */
export type StripeChargesOrderBy = {
  amount?: InputMaybe<OrderBy>;
  amountCaptured?: InputMaybe<OrderBy>;
  amountRefunded?: InputMaybe<OrderBy>;
  application?: InputMaybe<OrderBy>;
  applicationFee?: InputMaybe<OrderBy>;
  applicationFeeAmount?: InputMaybe<OrderBy>;
  calculatedStatementDescriptor?: InputMaybe<OrderBy>;
  captured?: InputMaybe<OrderBy>;
  chargeId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  currency?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  disputed?: InputMaybe<OrderBy>;
  externalStripePaymentIntentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  internalStripePaymentIntentId?: InputMaybe<OrderBy>;
  paid?: InputMaybe<OrderBy>;
  paymentIntentExternal?: InputMaybe<StripePaymentIntentsOrderBy>;
  paymentIntentInternal?: InputMaybe<StripePaymentIntentsOrderBy>;
  paymentMethod?: InputMaybe<OrderBy>;
  paymentMethodUsed?: InputMaybe<UserCreditCardsOrderBy>;
  refunded?: InputMaybe<OrderBy>;
  sourceTransfer?: InputMaybe<OrderBy>;
  stripeCustomerId?: InputMaybe<OrderBy>;
  transferDataAmount?: InputMaybe<OrderBy>;
  transferDataDestination?: InputMaybe<OrderBy>;
  transferId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: stripe_charges */
export type StripeChargesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "stripe_charges" */
export enum StripeChargesSelectColumn {
  /** column name */
  Amount = 'amount',
  /** column name */
  AmountCaptured = 'amountCaptured',
  /** column name */
  AmountRefunded = 'amountRefunded',
  /** column name */
  Application = 'application',
  /** column name */
  ApplicationFee = 'applicationFee',
  /** column name */
  ApplicationFeeAmount = 'applicationFeeAmount',
  /** column name */
  CalculatedStatementDescriptor = 'calculatedStatementDescriptor',
  /** column name */
  Captured = 'captured',
  /** column name */
  ChargeId = 'chargeId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Currency = 'currency',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Disputed = 'disputed',
  /** column name */
  ExternalStripePaymentIntentId = 'externalStripePaymentIntentId',
  /** column name */
  Id = 'id',
  /** column name */
  InternalStripePaymentIntentId = 'internalStripePaymentIntentId',
  /** column name */
  Paid = 'paid',
  /** column name */
  PaymentMethod = 'paymentMethod',
  /** column name */
  Refunded = 'refunded',
  /** column name */
  SourceTransfer = 'sourceTransfer',
  /** column name */
  StripeCustomerId = 'stripeCustomerId',
  /** column name */
  TransferDataAmount = 'transferDataAmount',
  /** column name */
  TransferDataDestination = 'transferDataDestination',
  /** column name */
  TransferId = 'transferId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** select "stripeChargesAggregateBoolExpBool_andArgumentsColumns" columns of table "stripe_charges" */
export enum StripeChargesSelectColumnStripeChargesAggregateBoolExpBool_AndArgumentsColumns {
  /** column name */
  Captured = 'captured',
  /** column name */
  Disputed = 'disputed',
  /** column name */
  Paid = 'paid',
  /** column name */
  Refunded = 'refunded'
}

/** select "stripeChargesAggregateBoolExpBool_orArgumentsColumns" columns of table "stripe_charges" */
export enum StripeChargesSelectColumnStripeChargesAggregateBoolExpBool_OrArgumentsColumns {
  /** column name */
  Captured = 'captured',
  /** column name */
  Disputed = 'disputed',
  /** column name */
  Paid = 'paid',
  /** column name */
  Refunded = 'refunded'
}

/** input type for updating data in table "stripe_charges" */
export type StripeChargesSetInput = {
  amount?: InputMaybe<Scalars['Int']>;
  amountCaptured?: InputMaybe<Scalars['Int']>;
  amountRefunded?: InputMaybe<Scalars['Int']>;
  application?: InputMaybe<Scalars['String']>;
  applicationFee?: InputMaybe<Scalars['String']>;
  applicationFeeAmount?: InputMaybe<Scalars['Int']>;
  calculatedStatementDescriptor?: InputMaybe<Scalars['String']>;
  captured?: InputMaybe<Scalars['Boolean']>;
  chargeId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  disputed?: InputMaybe<Scalars['Boolean']>;
  externalStripePaymentIntentId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  internalStripePaymentIntentId?: InputMaybe<Scalars['uuid']>;
  paid?: InputMaybe<Scalars['Boolean']>;
  paymentMethod?: InputMaybe<Scalars['String']>;
  refunded?: InputMaybe<Scalars['Boolean']>;
  sourceTransfer?: InputMaybe<Scalars['String']>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  transferDataAmount?: InputMaybe<Scalars['Int']>;
  transferDataDestination?: InputMaybe<Scalars['String']>;
  transferId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type StripeChargesStddevFields = {
  __typename?: 'StripeChargesStddevFields';
  amount?: Maybe<Scalars['Float']>;
  amountCaptured?: Maybe<Scalars['Float']>;
  amountRefunded?: Maybe<Scalars['Float']>;
  applicationFeeAmount?: Maybe<Scalars['Float']>;
  transferDataAmount?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "stripe_charges" */
export type StripeChargesStddevOrderBy = {
  amount?: InputMaybe<OrderBy>;
  amountCaptured?: InputMaybe<OrderBy>;
  amountRefunded?: InputMaybe<OrderBy>;
  applicationFeeAmount?: InputMaybe<OrderBy>;
  transferDataAmount?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type StripeChargesStddevPopFields = {
  __typename?: 'StripeChargesStddevPopFields';
  amount?: Maybe<Scalars['Float']>;
  amountCaptured?: Maybe<Scalars['Float']>;
  amountRefunded?: Maybe<Scalars['Float']>;
  applicationFeeAmount?: Maybe<Scalars['Float']>;
  transferDataAmount?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "stripe_charges" */
export type StripeChargesStddevPopOrderBy = {
  amount?: InputMaybe<OrderBy>;
  amountCaptured?: InputMaybe<OrderBy>;
  amountRefunded?: InputMaybe<OrderBy>;
  applicationFeeAmount?: InputMaybe<OrderBy>;
  transferDataAmount?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type StripeChargesStddevSampFields = {
  __typename?: 'StripeChargesStddevSampFields';
  amount?: Maybe<Scalars['Float']>;
  amountCaptured?: Maybe<Scalars['Float']>;
  amountRefunded?: Maybe<Scalars['Float']>;
  applicationFeeAmount?: Maybe<Scalars['Float']>;
  transferDataAmount?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "stripe_charges" */
export type StripeChargesStddevSampOrderBy = {
  amount?: InputMaybe<OrderBy>;
  amountCaptured?: InputMaybe<OrderBy>;
  amountRefunded?: InputMaybe<OrderBy>;
  applicationFeeAmount?: InputMaybe<OrderBy>;
  transferDataAmount?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "stripe_charges" */
export type StripeChargesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: StripeChargesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type StripeChargesStreamCursorValueInput = {
  amount?: InputMaybe<Scalars['Int']>;
  amountCaptured?: InputMaybe<Scalars['Int']>;
  amountRefunded?: InputMaybe<Scalars['Int']>;
  application?: InputMaybe<Scalars['String']>;
  applicationFee?: InputMaybe<Scalars['String']>;
  applicationFeeAmount?: InputMaybe<Scalars['Int']>;
  calculatedStatementDescriptor?: InputMaybe<Scalars['String']>;
  captured?: InputMaybe<Scalars['Boolean']>;
  chargeId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  disputed?: InputMaybe<Scalars['Boolean']>;
  externalStripePaymentIntentId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  internalStripePaymentIntentId?: InputMaybe<Scalars['uuid']>;
  paid?: InputMaybe<Scalars['Boolean']>;
  paymentMethod?: InputMaybe<Scalars['String']>;
  refunded?: InputMaybe<Scalars['Boolean']>;
  sourceTransfer?: InputMaybe<Scalars['String']>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  transferDataAmount?: InputMaybe<Scalars['Int']>;
  transferDataDestination?: InputMaybe<Scalars['String']>;
  transferId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type StripeChargesSumFields = {
  __typename?: 'StripeChargesSumFields';
  amount?: Maybe<Scalars['Int']>;
  amountCaptured?: Maybe<Scalars['Int']>;
  amountRefunded?: Maybe<Scalars['Int']>;
  applicationFeeAmount?: Maybe<Scalars['Int']>;
  transferDataAmount?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "stripe_charges" */
export type StripeChargesSumOrderBy = {
  amount?: InputMaybe<OrderBy>;
  amountCaptured?: InputMaybe<OrderBy>;
  amountRefunded?: InputMaybe<OrderBy>;
  applicationFeeAmount?: InputMaybe<OrderBy>;
  transferDataAmount?: InputMaybe<OrderBy>;
};

/** update columns of table "stripe_charges" */
export enum StripeChargesUpdateColumn {
  /** column name */
  Amount = 'amount',
  /** column name */
  AmountCaptured = 'amountCaptured',
  /** column name */
  AmountRefunded = 'amountRefunded',
  /** column name */
  Application = 'application',
  /** column name */
  ApplicationFee = 'applicationFee',
  /** column name */
  ApplicationFeeAmount = 'applicationFeeAmount',
  /** column name */
  CalculatedStatementDescriptor = 'calculatedStatementDescriptor',
  /** column name */
  Captured = 'captured',
  /** column name */
  ChargeId = 'chargeId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Currency = 'currency',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Disputed = 'disputed',
  /** column name */
  ExternalStripePaymentIntentId = 'externalStripePaymentIntentId',
  /** column name */
  Id = 'id',
  /** column name */
  InternalStripePaymentIntentId = 'internalStripePaymentIntentId',
  /** column name */
  Paid = 'paid',
  /** column name */
  PaymentMethod = 'paymentMethod',
  /** column name */
  Refunded = 'refunded',
  /** column name */
  SourceTransfer = 'sourceTransfer',
  /** column name */
  StripeCustomerId = 'stripeCustomerId',
  /** column name */
  TransferDataAmount = 'transferDataAmount',
  /** column name */
  TransferDataDestination = 'transferDataDestination',
  /** column name */
  TransferId = 'transferId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type StripeChargesUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<StripeChargesIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<StripeChargesSetInput>;
  /** filter the rows which have to be updated */
  where: StripeChargesBoolExp;
};

/** aggregate varPop on columns */
export type StripeChargesVarPopFields = {
  __typename?: 'StripeChargesVarPopFields';
  amount?: Maybe<Scalars['Float']>;
  amountCaptured?: Maybe<Scalars['Float']>;
  amountRefunded?: Maybe<Scalars['Float']>;
  applicationFeeAmount?: Maybe<Scalars['Float']>;
  transferDataAmount?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "stripe_charges" */
export type StripeChargesVarPopOrderBy = {
  amount?: InputMaybe<OrderBy>;
  amountCaptured?: InputMaybe<OrderBy>;
  amountRefunded?: InputMaybe<OrderBy>;
  applicationFeeAmount?: InputMaybe<OrderBy>;
  transferDataAmount?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type StripeChargesVarSampFields = {
  __typename?: 'StripeChargesVarSampFields';
  amount?: Maybe<Scalars['Float']>;
  amountCaptured?: Maybe<Scalars['Float']>;
  amountRefunded?: Maybe<Scalars['Float']>;
  applicationFeeAmount?: Maybe<Scalars['Float']>;
  transferDataAmount?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "stripe_charges" */
export type StripeChargesVarSampOrderBy = {
  amount?: InputMaybe<OrderBy>;
  amountCaptured?: InputMaybe<OrderBy>;
  amountRefunded?: InputMaybe<OrderBy>;
  applicationFeeAmount?: InputMaybe<OrderBy>;
  transferDataAmount?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type StripeChargesVarianceFields = {
  __typename?: 'StripeChargesVarianceFields';
  amount?: Maybe<Scalars['Float']>;
  amountCaptured?: Maybe<Scalars['Float']>;
  amountRefunded?: Maybe<Scalars['Float']>;
  applicationFeeAmount?: Maybe<Scalars['Float']>;
  transferDataAmount?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "stripe_charges" */
export type StripeChargesVarianceOrderBy = {
  amount?: InputMaybe<OrderBy>;
  amountCaptured?: InputMaybe<OrderBy>;
  amountRefunded?: InputMaybe<OrderBy>;
  applicationFeeAmount?: InputMaybe<OrderBy>;
  transferDataAmount?: InputMaybe<OrderBy>;
};

/** columns and relationships of "stripe_payment_intents" */
export type StripePaymentIntents = {
  __typename?: 'StripePaymentIntents';
  amount: Scalars['Int'];
  amountCapturable: Scalars['Int'];
  amountReceived: Scalars['Int'];
  application?: Maybe<Scalars['String']>;
  applicationFeeAmount?: Maybe<Scalars['Int']>;
  cancellationReason?: Maybe<Scalars['String']>;
  createdAt: Scalars['timestamptz'];
  currency: Scalars['String'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  onBehalfOf?: Maybe<Scalars['String']>;
  paymentIntentId: Scalars['String'];
  paymentMethod?: Maybe<Scalars['String']>;
  /** An object relationship */
  paymentMethodUsed?: Maybe<UserCreditCards>;
  statementDescriptor?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  /** An array relationship */
  stripeCharges: Array<StripeCharges>;
  /** An aggregate relationship */
  stripeChargesAggregate: StripeChargesAggregate;
  stripeCustomerId: Scalars['String'];
  transferDataAmount?: Maybe<Scalars['Int']>;
  transferDataDestination?: Maybe<Scalars['String']>;
  transferGroup?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "stripe_payment_intents" */
export type StripePaymentIntentsStripeChargesArgs = {
  distinctOn?: InputMaybe<Array<StripeChargesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<StripeChargesOrderBy>>;
  where?: InputMaybe<StripeChargesBoolExp>;
};


/** columns and relationships of "stripe_payment_intents" */
export type StripePaymentIntentsStripeChargesAggregateArgs = {
  distinctOn?: InputMaybe<Array<StripeChargesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<StripeChargesOrderBy>>;
  where?: InputMaybe<StripeChargesBoolExp>;
};

/** aggregated selection of "stripe_payment_intents" */
export type StripePaymentIntentsAggregate = {
  __typename?: 'StripePaymentIntentsAggregate';
  aggregate?: Maybe<StripePaymentIntentsAggregateFields>;
  nodes: Array<StripePaymentIntents>;
};

/** aggregate fields of "stripe_payment_intents" */
export type StripePaymentIntentsAggregateFields = {
  __typename?: 'StripePaymentIntentsAggregateFields';
  avg?: Maybe<StripePaymentIntentsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<StripePaymentIntentsMaxFields>;
  min?: Maybe<StripePaymentIntentsMinFields>;
  stddev?: Maybe<StripePaymentIntentsStddevFields>;
  stddevPop?: Maybe<StripePaymentIntentsStddevPopFields>;
  stddevSamp?: Maybe<StripePaymentIntentsStddevSampFields>;
  sum?: Maybe<StripePaymentIntentsSumFields>;
  varPop?: Maybe<StripePaymentIntentsVarPopFields>;
  varSamp?: Maybe<StripePaymentIntentsVarSampFields>;
  variance?: Maybe<StripePaymentIntentsVarianceFields>;
};


/** aggregate fields of "stripe_payment_intents" */
export type StripePaymentIntentsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<StripePaymentIntentsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type StripePaymentIntentsAvgFields = {
  __typename?: 'StripePaymentIntentsAvgFields';
  amount?: Maybe<Scalars['Float']>;
  amountCapturable?: Maybe<Scalars['Float']>;
  amountReceived?: Maybe<Scalars['Float']>;
  applicationFeeAmount?: Maybe<Scalars['Float']>;
  transferDataAmount?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "stripe_payment_intents". All fields are combined with a logical 'AND'. */
export type StripePaymentIntentsBoolExp = {
  _and?: InputMaybe<Array<StripePaymentIntentsBoolExp>>;
  _not?: InputMaybe<StripePaymentIntentsBoolExp>;
  _or?: InputMaybe<Array<StripePaymentIntentsBoolExp>>;
  amount?: InputMaybe<IntComparisonExp>;
  amountCapturable?: InputMaybe<IntComparisonExp>;
  amountReceived?: InputMaybe<IntComparisonExp>;
  application?: InputMaybe<StringComparisonExp>;
  applicationFeeAmount?: InputMaybe<IntComparisonExp>;
  cancellationReason?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  currency?: InputMaybe<StringComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  onBehalfOf?: InputMaybe<StringComparisonExp>;
  paymentIntentId?: InputMaybe<StringComparisonExp>;
  paymentMethod?: InputMaybe<StringComparisonExp>;
  paymentMethodUsed?: InputMaybe<UserCreditCardsBoolExp>;
  statementDescriptor?: InputMaybe<StringComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  stripeCharges?: InputMaybe<StripeChargesBoolExp>;
  stripeChargesAggregate?: InputMaybe<StripeChargesAggregateBoolExp>;
  stripeCustomerId?: InputMaybe<StringComparisonExp>;
  transferDataAmount?: InputMaybe<IntComparisonExp>;
  transferDataDestination?: InputMaybe<StringComparisonExp>;
  transferGroup?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "stripe_payment_intents" */
export enum StripePaymentIntentsConstraint {
  /** unique or primary key constraint on columns "payment_intent_id" */
  StripePaymentIntentsPaymentIntentIdKey = 'stripe_payment_intents_payment_intent_id_key',
  /** unique or primary key constraint on columns "id" */
  StripePaymentIntentsPkey = 'stripe_payment_intents_pkey'
}

/** input type for incrementing numeric columns in table "stripe_payment_intents" */
export type StripePaymentIntentsIncInput = {
  amount?: InputMaybe<Scalars['Int']>;
  amountCapturable?: InputMaybe<Scalars['Int']>;
  amountReceived?: InputMaybe<Scalars['Int']>;
  applicationFeeAmount?: InputMaybe<Scalars['Int']>;
  transferDataAmount?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "stripe_payment_intents" */
export type StripePaymentIntentsInsertInput = {
  amount?: InputMaybe<Scalars['Int']>;
  amountCapturable?: InputMaybe<Scalars['Int']>;
  amountReceived?: InputMaybe<Scalars['Int']>;
  application?: InputMaybe<Scalars['String']>;
  applicationFeeAmount?: InputMaybe<Scalars['Int']>;
  cancellationReason?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  onBehalfOf?: InputMaybe<Scalars['String']>;
  paymentIntentId?: InputMaybe<Scalars['String']>;
  paymentMethod?: InputMaybe<Scalars['String']>;
  paymentMethodUsed?: InputMaybe<UserCreditCardsObjRelInsertInput>;
  statementDescriptor?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  stripeCharges?: InputMaybe<StripeChargesArrRelInsertInput>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  transferDataAmount?: InputMaybe<Scalars['Int']>;
  transferDataDestination?: InputMaybe<Scalars['String']>;
  transferGroup?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type StripePaymentIntentsMaxFields = {
  __typename?: 'StripePaymentIntentsMaxFields';
  amount?: Maybe<Scalars['Int']>;
  amountCapturable?: Maybe<Scalars['Int']>;
  amountReceived?: Maybe<Scalars['Int']>;
  application?: Maybe<Scalars['String']>;
  applicationFeeAmount?: Maybe<Scalars['Int']>;
  cancellationReason?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  onBehalfOf?: Maybe<Scalars['String']>;
  paymentIntentId?: Maybe<Scalars['String']>;
  paymentMethod?: Maybe<Scalars['String']>;
  statementDescriptor?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  transferDataAmount?: Maybe<Scalars['Int']>;
  transferDataDestination?: Maybe<Scalars['String']>;
  transferGroup?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type StripePaymentIntentsMinFields = {
  __typename?: 'StripePaymentIntentsMinFields';
  amount?: Maybe<Scalars['Int']>;
  amountCapturable?: Maybe<Scalars['Int']>;
  amountReceived?: Maybe<Scalars['Int']>;
  application?: Maybe<Scalars['String']>;
  applicationFeeAmount?: Maybe<Scalars['Int']>;
  cancellationReason?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  onBehalfOf?: Maybe<Scalars['String']>;
  paymentIntentId?: Maybe<Scalars['String']>;
  paymentMethod?: Maybe<Scalars['String']>;
  statementDescriptor?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  transferDataAmount?: Maybe<Scalars['Int']>;
  transferDataDestination?: Maybe<Scalars['String']>;
  transferGroup?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "stripe_payment_intents" */
export type StripePaymentIntentsMutationResponse = {
  __typename?: 'StripePaymentIntentsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<StripePaymentIntents>;
};

/** input type for inserting object relation for remote table "stripe_payment_intents" */
export type StripePaymentIntentsObjRelInsertInput = {
  data: StripePaymentIntentsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<StripePaymentIntentsOnConflict>;
};

/** on_conflict condition type for table "stripe_payment_intents" */
export type StripePaymentIntentsOnConflict = {
  constraint: StripePaymentIntentsConstraint;
  updateColumns?: Array<StripePaymentIntentsUpdateColumn>;
  where?: InputMaybe<StripePaymentIntentsBoolExp>;
};

/** Ordering options when selecting data from "stripe_payment_intents". */
export type StripePaymentIntentsOrderBy = {
  amount?: InputMaybe<OrderBy>;
  amountCapturable?: InputMaybe<OrderBy>;
  amountReceived?: InputMaybe<OrderBy>;
  application?: InputMaybe<OrderBy>;
  applicationFeeAmount?: InputMaybe<OrderBy>;
  cancellationReason?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  currency?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  onBehalfOf?: InputMaybe<OrderBy>;
  paymentIntentId?: InputMaybe<OrderBy>;
  paymentMethod?: InputMaybe<OrderBy>;
  paymentMethodUsed?: InputMaybe<UserCreditCardsOrderBy>;
  statementDescriptor?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  stripeChargesAggregate?: InputMaybe<StripeChargesAggregateOrderBy>;
  stripeCustomerId?: InputMaybe<OrderBy>;
  transferDataAmount?: InputMaybe<OrderBy>;
  transferDataDestination?: InputMaybe<OrderBy>;
  transferGroup?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: stripe_payment_intents */
export type StripePaymentIntentsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "stripe_payment_intents" */
export enum StripePaymentIntentsSelectColumn {
  /** column name */
  Amount = 'amount',
  /** column name */
  AmountCapturable = 'amountCapturable',
  /** column name */
  AmountReceived = 'amountReceived',
  /** column name */
  Application = 'application',
  /** column name */
  ApplicationFeeAmount = 'applicationFeeAmount',
  /** column name */
  CancellationReason = 'cancellationReason',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Currency = 'currency',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  OnBehalfOf = 'onBehalfOf',
  /** column name */
  PaymentIntentId = 'paymentIntentId',
  /** column name */
  PaymentMethod = 'paymentMethod',
  /** column name */
  StatementDescriptor = 'statementDescriptor',
  /** column name */
  Status = 'status',
  /** column name */
  StripeCustomerId = 'stripeCustomerId',
  /** column name */
  TransferDataAmount = 'transferDataAmount',
  /** column name */
  TransferDataDestination = 'transferDataDestination',
  /** column name */
  TransferGroup = 'transferGroup',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "stripe_payment_intents" */
export type StripePaymentIntentsSetInput = {
  amount?: InputMaybe<Scalars['Int']>;
  amountCapturable?: InputMaybe<Scalars['Int']>;
  amountReceived?: InputMaybe<Scalars['Int']>;
  application?: InputMaybe<Scalars['String']>;
  applicationFeeAmount?: InputMaybe<Scalars['Int']>;
  cancellationReason?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  onBehalfOf?: InputMaybe<Scalars['String']>;
  paymentIntentId?: InputMaybe<Scalars['String']>;
  paymentMethod?: InputMaybe<Scalars['String']>;
  statementDescriptor?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  transferDataAmount?: InputMaybe<Scalars['Int']>;
  transferDataDestination?: InputMaybe<Scalars['String']>;
  transferGroup?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type StripePaymentIntentsStddevFields = {
  __typename?: 'StripePaymentIntentsStddevFields';
  amount?: Maybe<Scalars['Float']>;
  amountCapturable?: Maybe<Scalars['Float']>;
  amountReceived?: Maybe<Scalars['Float']>;
  applicationFeeAmount?: Maybe<Scalars['Float']>;
  transferDataAmount?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type StripePaymentIntentsStddevPopFields = {
  __typename?: 'StripePaymentIntentsStddevPopFields';
  amount?: Maybe<Scalars['Float']>;
  amountCapturable?: Maybe<Scalars['Float']>;
  amountReceived?: Maybe<Scalars['Float']>;
  applicationFeeAmount?: Maybe<Scalars['Float']>;
  transferDataAmount?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type StripePaymentIntentsStddevSampFields = {
  __typename?: 'StripePaymentIntentsStddevSampFields';
  amount?: Maybe<Scalars['Float']>;
  amountCapturable?: Maybe<Scalars['Float']>;
  amountReceived?: Maybe<Scalars['Float']>;
  applicationFeeAmount?: Maybe<Scalars['Float']>;
  transferDataAmount?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "stripe_payment_intents" */
export type StripePaymentIntentsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: StripePaymentIntentsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type StripePaymentIntentsStreamCursorValueInput = {
  amount?: InputMaybe<Scalars['Int']>;
  amountCapturable?: InputMaybe<Scalars['Int']>;
  amountReceived?: InputMaybe<Scalars['Int']>;
  application?: InputMaybe<Scalars['String']>;
  applicationFeeAmount?: InputMaybe<Scalars['Int']>;
  cancellationReason?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  onBehalfOf?: InputMaybe<Scalars['String']>;
  paymentIntentId?: InputMaybe<Scalars['String']>;
  paymentMethod?: InputMaybe<Scalars['String']>;
  statementDescriptor?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  transferDataAmount?: InputMaybe<Scalars['Int']>;
  transferDataDestination?: InputMaybe<Scalars['String']>;
  transferGroup?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type StripePaymentIntentsSumFields = {
  __typename?: 'StripePaymentIntentsSumFields';
  amount?: Maybe<Scalars['Int']>;
  amountCapturable?: Maybe<Scalars['Int']>;
  amountReceived?: Maybe<Scalars['Int']>;
  applicationFeeAmount?: Maybe<Scalars['Int']>;
  transferDataAmount?: Maybe<Scalars['Int']>;
};

/** update columns of table "stripe_payment_intents" */
export enum StripePaymentIntentsUpdateColumn {
  /** column name */
  Amount = 'amount',
  /** column name */
  AmountCapturable = 'amountCapturable',
  /** column name */
  AmountReceived = 'amountReceived',
  /** column name */
  Application = 'application',
  /** column name */
  ApplicationFeeAmount = 'applicationFeeAmount',
  /** column name */
  CancellationReason = 'cancellationReason',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Currency = 'currency',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  OnBehalfOf = 'onBehalfOf',
  /** column name */
  PaymentIntentId = 'paymentIntentId',
  /** column name */
  PaymentMethod = 'paymentMethod',
  /** column name */
  StatementDescriptor = 'statementDescriptor',
  /** column name */
  Status = 'status',
  /** column name */
  StripeCustomerId = 'stripeCustomerId',
  /** column name */
  TransferDataAmount = 'transferDataAmount',
  /** column name */
  TransferDataDestination = 'transferDataDestination',
  /** column name */
  TransferGroup = 'transferGroup',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type StripePaymentIntentsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<StripePaymentIntentsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<StripePaymentIntentsSetInput>;
  /** filter the rows which have to be updated */
  where: StripePaymentIntentsBoolExp;
};

/** aggregate varPop on columns */
export type StripePaymentIntentsVarPopFields = {
  __typename?: 'StripePaymentIntentsVarPopFields';
  amount?: Maybe<Scalars['Float']>;
  amountCapturable?: Maybe<Scalars['Float']>;
  amountReceived?: Maybe<Scalars['Float']>;
  applicationFeeAmount?: Maybe<Scalars['Float']>;
  transferDataAmount?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type StripePaymentIntentsVarSampFields = {
  __typename?: 'StripePaymentIntentsVarSampFields';
  amount?: Maybe<Scalars['Float']>;
  amountCapturable?: Maybe<Scalars['Float']>;
  amountReceived?: Maybe<Scalars['Float']>;
  applicationFeeAmount?: Maybe<Scalars['Float']>;
  transferDataAmount?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type StripePaymentIntentsVarianceFields = {
  __typename?: 'StripePaymentIntentsVarianceFields';
  amount?: Maybe<Scalars['Float']>;
  amountCapturable?: Maybe<Scalars['Float']>;
  amountReceived?: Maybe<Scalars['Float']>;
  applicationFeeAmount?: Maybe<Scalars['Float']>;
  transferDataAmount?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "subscription_statuses" */
export type SubscriptionStatuses = {
  __typename?: 'SubscriptionStatuses';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "subscription_statuses" */
export type SubscriptionStatusesAggregate = {
  __typename?: 'SubscriptionStatusesAggregate';
  aggregate?: Maybe<SubscriptionStatusesAggregateFields>;
  nodes: Array<SubscriptionStatuses>;
};

/** aggregate fields of "subscription_statuses" */
export type SubscriptionStatusesAggregateFields = {
  __typename?: 'SubscriptionStatusesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<SubscriptionStatusesMaxFields>;
  min?: Maybe<SubscriptionStatusesMinFields>;
};


/** aggregate fields of "subscription_statuses" */
export type SubscriptionStatusesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<SubscriptionStatusesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "subscription_statuses". All fields are combined with a logical 'AND'. */
export type SubscriptionStatusesBoolExp = {
  _and?: InputMaybe<Array<SubscriptionStatusesBoolExp>>;
  _not?: InputMaybe<SubscriptionStatusesBoolExp>;
  _or?: InputMaybe<Array<SubscriptionStatusesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "subscription_statuses" */
export enum SubscriptionStatusesConstraint {
  /** unique or primary key constraint on columns "value" */
  SubscriptionStatusesPkey = 'subscription_statuses_pkey'
}

export enum SubscriptionStatusesEnum {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

/** Boolean expression to compare columns of type "SubscriptionStatusesEnum". All fields are combined with logical 'AND'. */
export type SubscriptionStatusesEnumComparisonExp = {
  _eq?: InputMaybe<SubscriptionStatusesEnum>;
  _in?: InputMaybe<Array<SubscriptionStatusesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<SubscriptionStatusesEnum>;
  _nin?: InputMaybe<Array<SubscriptionStatusesEnum>>;
};

/** input type for inserting data into table "subscription_statuses" */
export type SubscriptionStatusesInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type SubscriptionStatusesMaxFields = {
  __typename?: 'SubscriptionStatusesMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type SubscriptionStatusesMinFields = {
  __typename?: 'SubscriptionStatusesMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "subscription_statuses" */
export type SubscriptionStatusesMutationResponse = {
  __typename?: 'SubscriptionStatusesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<SubscriptionStatuses>;
};

/** on_conflict condition type for table "subscription_statuses" */
export type SubscriptionStatusesOnConflict = {
  constraint: SubscriptionStatusesConstraint;
  updateColumns?: Array<SubscriptionStatusesUpdateColumn>;
  where?: InputMaybe<SubscriptionStatusesBoolExp>;
};

/** Ordering options when selecting data from "subscription_statuses". */
export type SubscriptionStatusesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: subscription_statuses */
export type SubscriptionStatusesPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "subscription_statuses" */
export enum SubscriptionStatusesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "subscription_statuses" */
export type SubscriptionStatusesSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "subscription_statuses" */
export type SubscriptionStatusesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: SubscriptionStatusesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type SubscriptionStatusesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "subscription_statuses" */
export enum SubscriptionStatusesUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type SubscriptionStatusesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<SubscriptionStatusesSetInput>;
  /** filter the rows which have to be updated */
  where: SubscriptionStatusesBoolExp;
};

/** columns and relationships of "team_types" */
export type TeamTypes = {
  __typename?: 'TeamTypes';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "team_types" */
export type TeamTypesAggregate = {
  __typename?: 'TeamTypesAggregate';
  aggregate?: Maybe<TeamTypesAggregateFields>;
  nodes: Array<TeamTypes>;
};

/** aggregate fields of "team_types" */
export type TeamTypesAggregateFields = {
  __typename?: 'TeamTypesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<TeamTypesMaxFields>;
  min?: Maybe<TeamTypesMinFields>;
};


/** aggregate fields of "team_types" */
export type TeamTypesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TeamTypesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "team_types". All fields are combined with a logical 'AND'. */
export type TeamTypesBoolExp = {
  _and?: InputMaybe<Array<TeamTypesBoolExp>>;
  _not?: InputMaybe<TeamTypesBoolExp>;
  _or?: InputMaybe<Array<TeamTypesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "team_types" */
export enum TeamTypesConstraint {
  /** unique or primary key constraint on columns "value" */
  TeamTypesPkey = 'team_types_pkey'
}

export enum TeamTypesEnum {
  Doubles = 'DOUBLES',
  Singles = 'SINGLES'
}

/** Boolean expression to compare columns of type "TeamTypesEnum". All fields are combined with logical 'AND'. */
export type TeamTypesEnumComparisonExp = {
  _eq?: InputMaybe<TeamTypesEnum>;
  _in?: InputMaybe<Array<TeamTypesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<TeamTypesEnum>;
  _nin?: InputMaybe<Array<TeamTypesEnum>>;
};

/** input type for inserting data into table "team_types" */
export type TeamTypesInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type TeamTypesMaxFields = {
  __typename?: 'TeamTypesMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type TeamTypesMinFields = {
  __typename?: 'TeamTypesMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "team_types" */
export type TeamTypesMutationResponse = {
  __typename?: 'TeamTypesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TeamTypes>;
};

/** on_conflict condition type for table "team_types" */
export type TeamTypesOnConflict = {
  constraint: TeamTypesConstraint;
  updateColumns?: Array<TeamTypesUpdateColumn>;
  where?: InputMaybe<TeamTypesBoolExp>;
};

/** Ordering options when selecting data from "team_types". */
export type TeamTypesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: team_types */
export type TeamTypesPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "team_types" */
export enum TeamTypesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "team_types" */
export type TeamTypesSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "team_types" */
export type TeamTypesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: TeamTypesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TeamTypesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "team_types" */
export enum TeamTypesUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type TeamTypesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TeamTypesSetInput>;
  /** filter the rows which have to be updated */
  where: TeamTypesBoolExp;
};

/** columns and relationships of "tennis_rating_scales" */
export type TennisRatingScales = {
  __typename?: 'TennisRatingScales';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  maximum: Scalars['numeric'];
  minimum: Scalars['numeric'];
  name: Scalars['String'];
  order: Scalars['Int'];
  shortName: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "tennis_rating_scales" */
export type TennisRatingScalesAggregate = {
  __typename?: 'TennisRatingScalesAggregate';
  aggregate?: Maybe<TennisRatingScalesAggregateFields>;
  nodes: Array<TennisRatingScales>;
};

/** aggregate fields of "tennis_rating_scales" */
export type TennisRatingScalesAggregateFields = {
  __typename?: 'TennisRatingScalesAggregateFields';
  avg?: Maybe<TennisRatingScalesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<TennisRatingScalesMaxFields>;
  min?: Maybe<TennisRatingScalesMinFields>;
  stddev?: Maybe<TennisRatingScalesStddevFields>;
  stddevPop?: Maybe<TennisRatingScalesStddevPopFields>;
  stddevSamp?: Maybe<TennisRatingScalesStddevSampFields>;
  sum?: Maybe<TennisRatingScalesSumFields>;
  varPop?: Maybe<TennisRatingScalesVarPopFields>;
  varSamp?: Maybe<TennisRatingScalesVarSampFields>;
  variance?: Maybe<TennisRatingScalesVarianceFields>;
};


/** aggregate fields of "tennis_rating_scales" */
export type TennisRatingScalesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TennisRatingScalesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type TennisRatingScalesAvgFields = {
  __typename?: 'TennisRatingScalesAvgFields';
  maximum?: Maybe<Scalars['Float']>;
  minimum?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "tennis_rating_scales". All fields are combined with a logical 'AND'. */
export type TennisRatingScalesBoolExp = {
  _and?: InputMaybe<Array<TennisRatingScalesBoolExp>>;
  _not?: InputMaybe<TennisRatingScalesBoolExp>;
  _or?: InputMaybe<Array<TennisRatingScalesBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  maximum?: InputMaybe<NumericComparisonExp>;
  minimum?: InputMaybe<NumericComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  order?: InputMaybe<IntComparisonExp>;
  shortName?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "tennis_rating_scales" */
export enum TennisRatingScalesConstraint {
  /** unique or primary key constraint on columns "id" */
  TennisRatingScalesPkey = 'tennis_rating_scales_pkey'
}

/** input type for incrementing numeric columns in table "tennis_rating_scales" */
export type TennisRatingScalesIncInput = {
  maximum?: InputMaybe<Scalars['numeric']>;
  minimum?: InputMaybe<Scalars['numeric']>;
  order?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "tennis_rating_scales" */
export type TennisRatingScalesInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  maximum?: InputMaybe<Scalars['numeric']>;
  minimum?: InputMaybe<Scalars['numeric']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  shortName?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type TennisRatingScalesMaxFields = {
  __typename?: 'TennisRatingScalesMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  maximum?: Maybe<Scalars['numeric']>;
  minimum?: Maybe<Scalars['numeric']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  shortName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type TennisRatingScalesMinFields = {
  __typename?: 'TennisRatingScalesMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  maximum?: Maybe<Scalars['numeric']>;
  minimum?: Maybe<Scalars['numeric']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  shortName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "tennis_rating_scales" */
export type TennisRatingScalesMutationResponse = {
  __typename?: 'TennisRatingScalesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TennisRatingScales>;
};

/** input type for inserting object relation for remote table "tennis_rating_scales" */
export type TennisRatingScalesObjRelInsertInput = {
  data: TennisRatingScalesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<TennisRatingScalesOnConflict>;
};

/** on_conflict condition type for table "tennis_rating_scales" */
export type TennisRatingScalesOnConflict = {
  constraint: TennisRatingScalesConstraint;
  updateColumns?: Array<TennisRatingScalesUpdateColumn>;
  where?: InputMaybe<TennisRatingScalesBoolExp>;
};

/** Ordering options when selecting data from "tennis_rating_scales". */
export type TennisRatingScalesOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  maximum?: InputMaybe<OrderBy>;
  minimum?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  order?: InputMaybe<OrderBy>;
  shortName?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: tennis_rating_scales */
export type TennisRatingScalesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "tennis_rating_scales" */
export enum TennisRatingScalesSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  Maximum = 'maximum',
  /** column name */
  Minimum = 'minimum',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  ShortName = 'shortName',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "tennis_rating_scales" */
export type TennisRatingScalesSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  maximum?: InputMaybe<Scalars['numeric']>;
  minimum?: InputMaybe<Scalars['numeric']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  shortName?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type TennisRatingScalesStddevFields = {
  __typename?: 'TennisRatingScalesStddevFields';
  maximum?: Maybe<Scalars['Float']>;
  minimum?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type TennisRatingScalesStddevPopFields = {
  __typename?: 'TennisRatingScalesStddevPopFields';
  maximum?: Maybe<Scalars['Float']>;
  minimum?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type TennisRatingScalesStddevSampFields = {
  __typename?: 'TennisRatingScalesStddevSampFields';
  maximum?: Maybe<Scalars['Float']>;
  minimum?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "tennis_rating_scales" */
export type TennisRatingScalesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: TennisRatingScalesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TennisRatingScalesStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  maximum?: InputMaybe<Scalars['numeric']>;
  minimum?: InputMaybe<Scalars['numeric']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  shortName?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type TennisRatingScalesSumFields = {
  __typename?: 'TennisRatingScalesSumFields';
  maximum?: Maybe<Scalars['numeric']>;
  minimum?: Maybe<Scalars['numeric']>;
  order?: Maybe<Scalars['Int']>;
};

/** update columns of table "tennis_rating_scales" */
export enum TennisRatingScalesUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  Maximum = 'maximum',
  /** column name */
  Minimum = 'minimum',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  ShortName = 'shortName',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type TennisRatingScalesUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<TennisRatingScalesIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TennisRatingScalesSetInput>;
  /** filter the rows which have to be updated */
  where: TennisRatingScalesBoolExp;
};

/** aggregate varPop on columns */
export type TennisRatingScalesVarPopFields = {
  __typename?: 'TennisRatingScalesVarPopFields';
  maximum?: Maybe<Scalars['Float']>;
  minimum?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type TennisRatingScalesVarSampFields = {
  __typename?: 'TennisRatingScalesVarSampFields';
  maximum?: Maybe<Scalars['Float']>;
  minimum?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type TennisRatingScalesVarianceFields = {
  __typename?: 'TennisRatingScalesVarianceFields';
  maximum?: Maybe<Scalars['Float']>;
  minimum?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** Boolean expression to compare columns of type "time". All fields are combined with logical 'AND'. */
export type TimeComparisonExp = {
  _eq?: InputMaybe<Scalars['time']>;
  _gt?: InputMaybe<Scalars['time']>;
  _gte?: InputMaybe<Scalars['time']>;
  _in?: InputMaybe<Array<Scalars['time']>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['time']>;
  _lte?: InputMaybe<Scalars['time']>;
  _neq?: InputMaybe<Scalars['time']>;
  _nin?: InputMaybe<Array<Scalars['time']>>;
};

/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export type TimestampComparisonExp = {
  _eq?: InputMaybe<Scalars['timestamp']>;
  _gt?: InputMaybe<Scalars['timestamp']>;
  _gte?: InputMaybe<Scalars['timestamp']>;
  _in?: InputMaybe<Array<Scalars['timestamp']>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['timestamp']>;
  _lte?: InputMaybe<Scalars['timestamp']>;
  _neq?: InputMaybe<Scalars['timestamp']>;
  _nin?: InputMaybe<Array<Scalars['timestamp']>>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type TimestamptzComparisonExp = {
  _eq?: InputMaybe<Scalars['timestamptz']>;
  _gt?: InputMaybe<Scalars['timestamptz']>;
  _gte?: InputMaybe<Scalars['timestamptz']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['timestamptz']>;
  _lte?: InputMaybe<Scalars['timestamptz']>;
  _neq?: InputMaybe<Scalars['timestamptz']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']>>;
};

/** Boolean expression to compare columns of type "tstzrange". All fields are combined with logical 'AND'. */
export type TstzrangeComparisonExp = {
  _eq?: InputMaybe<Scalars['tstzrange']>;
  _gt?: InputMaybe<Scalars['tstzrange']>;
  _gte?: InputMaybe<Scalars['tstzrange']>;
  _in?: InputMaybe<Array<Scalars['tstzrange']>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['tstzrange']>;
  _lte?: InputMaybe<Scalars['tstzrange']>;
  _neq?: InputMaybe<Scalars['tstzrange']>;
  _nin?: InputMaybe<Array<Scalars['tstzrange']>>;
};

/** columns and relationships of "twilio_group_texts" */
export type TwilioGroupTexts = {
  __typename?: 'TwilioGroupTexts';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['time']>;
  id: Scalars['uuid'];
  participantsKey: Scalars['String'];
  twilioConversationSid: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "twilio_group_texts" */
export type TwilioGroupTextsAggregate = {
  __typename?: 'TwilioGroupTextsAggregate';
  aggregate?: Maybe<TwilioGroupTextsAggregateFields>;
  nodes: Array<TwilioGroupTexts>;
};

/** aggregate fields of "twilio_group_texts" */
export type TwilioGroupTextsAggregateFields = {
  __typename?: 'TwilioGroupTextsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<TwilioGroupTextsMaxFields>;
  min?: Maybe<TwilioGroupTextsMinFields>;
};


/** aggregate fields of "twilio_group_texts" */
export type TwilioGroupTextsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TwilioGroupTextsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "twilio_group_texts". All fields are combined with a logical 'AND'. */
export type TwilioGroupTextsBoolExp = {
  _and?: InputMaybe<Array<TwilioGroupTextsBoolExp>>;
  _not?: InputMaybe<TwilioGroupTextsBoolExp>;
  _or?: InputMaybe<Array<TwilioGroupTextsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimeComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  participantsKey?: InputMaybe<StringComparisonExp>;
  twilioConversationSid?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "twilio_group_texts" */
export enum TwilioGroupTextsConstraint {
  /** unique or primary key constraint on columns "participants_key" */
  TwilioGroupTextsParticipantsIdKey = 'twilio_group_texts_participants_id_key',
  /** unique or primary key constraint on columns "id" */
  TwilioGroupTextsPkey = 'twilio_group_texts_pkey'
}

/** input type for inserting data into table "twilio_group_texts" */
export type TwilioGroupTextsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['time']>;
  id?: InputMaybe<Scalars['uuid']>;
  participantsKey?: InputMaybe<Scalars['String']>;
  twilioConversationSid?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type TwilioGroupTextsMaxFields = {
  __typename?: 'TwilioGroupTextsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  participantsKey?: Maybe<Scalars['String']>;
  twilioConversationSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type TwilioGroupTextsMinFields = {
  __typename?: 'TwilioGroupTextsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  participantsKey?: Maybe<Scalars['String']>;
  twilioConversationSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "twilio_group_texts" */
export type TwilioGroupTextsMutationResponse = {
  __typename?: 'TwilioGroupTextsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TwilioGroupTexts>;
};

/** on_conflict condition type for table "twilio_group_texts" */
export type TwilioGroupTextsOnConflict = {
  constraint: TwilioGroupTextsConstraint;
  updateColumns?: Array<TwilioGroupTextsUpdateColumn>;
  where?: InputMaybe<TwilioGroupTextsBoolExp>;
};

/** Ordering options when selecting data from "twilio_group_texts". */
export type TwilioGroupTextsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  participantsKey?: InputMaybe<OrderBy>;
  twilioConversationSid?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: twilio_group_texts */
export type TwilioGroupTextsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "twilio_group_texts" */
export enum TwilioGroupTextsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  ParticipantsKey = 'participantsKey',
  /** column name */
  TwilioConversationSid = 'twilioConversationSid',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "twilio_group_texts" */
export type TwilioGroupTextsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['time']>;
  id?: InputMaybe<Scalars['uuid']>;
  participantsKey?: InputMaybe<Scalars['String']>;
  twilioConversationSid?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "twilio_group_texts" */
export type TwilioGroupTextsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: TwilioGroupTextsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TwilioGroupTextsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['time']>;
  id?: InputMaybe<Scalars['uuid']>;
  participantsKey?: InputMaybe<Scalars['String']>;
  twilioConversationSid?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "twilio_group_texts" */
export enum TwilioGroupTextsUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  ParticipantsKey = 'participantsKey',
  /** column name */
  TwilioConversationSid = 'twilioConversationSid',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type TwilioGroupTextsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TwilioGroupTextsSetInput>;
  /** filter the rows which have to be updated */
  where: TwilioGroupTextsBoolExp;
};

/** columns and relationships of "upload_review_requests" */
export type UploadReviewRequests = {
  __typename?: 'UploadReviewRequests';
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
  url: Scalars['String'];
  userId: Scalars['uuid'];
};

/** aggregated selection of "upload_review_requests" */
export type UploadReviewRequestsAggregate = {
  __typename?: 'UploadReviewRequestsAggregate';
  aggregate?: Maybe<UploadReviewRequestsAggregateFields>;
  nodes: Array<UploadReviewRequests>;
};

/** aggregate fields of "upload_review_requests" */
export type UploadReviewRequestsAggregateFields = {
  __typename?: 'UploadReviewRequestsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<UploadReviewRequestsMaxFields>;
  min?: Maybe<UploadReviewRequestsMinFields>;
};


/** aggregate fields of "upload_review_requests" */
export type UploadReviewRequestsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<UploadReviewRequestsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "upload_review_requests". All fields are combined with a logical 'AND'. */
export type UploadReviewRequestsBoolExp = {
  _and?: InputMaybe<Array<UploadReviewRequestsBoolExp>>;
  _not?: InputMaybe<UploadReviewRequestsBoolExp>;
  _or?: InputMaybe<Array<UploadReviewRequestsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  url?: InputMaybe<StringComparisonExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "upload_review_requests" */
export enum UploadReviewRequestsConstraint {
  /** unique or primary key constraint on columns "id" */
  UploadReviewRequestsPkey = 'upload_review_requests_pkey'
}

/** input type for inserting data into table "upload_review_requests" */
export type UploadReviewRequestsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  url?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type UploadReviewRequestsMaxFields = {
  __typename?: 'UploadReviewRequestsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  url?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type UploadReviewRequestsMinFields = {
  __typename?: 'UploadReviewRequestsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  url?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "upload_review_requests" */
export type UploadReviewRequestsMutationResponse = {
  __typename?: 'UploadReviewRequestsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UploadReviewRequests>;
};

/** on_conflict condition type for table "upload_review_requests" */
export type UploadReviewRequestsOnConflict = {
  constraint: UploadReviewRequestsConstraint;
  updateColumns?: Array<UploadReviewRequestsUpdateColumn>;
  where?: InputMaybe<UploadReviewRequestsBoolExp>;
};

/** Ordering options when selecting data from "upload_review_requests". */
export type UploadReviewRequestsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  url?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: upload_review_requests */
export type UploadReviewRequestsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "upload_review_requests" */
export enum UploadReviewRequestsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Url = 'url',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "upload_review_requests" */
export type UploadReviewRequestsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  url?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "upload_review_requests" */
export type UploadReviewRequestsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UploadReviewRequestsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UploadReviewRequestsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  url?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "upload_review_requests" */
export enum UploadReviewRequestsUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Url = 'url',
  /** column name */
  UserId = 'userId'
}

export type UploadReviewRequestsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UploadReviewRequestsSetInput>;
  /** filter the rows which have to be updated */
  where: UploadReviewRequestsBoolExp;
};

/** columns and relationships of "user_auth_identities" */
export type UserAuthIdentities = {
  __typename?: 'UserAuthIdentities';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  displayName?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  id: Scalars['uuid'];
  phoneNumber?: Maybe<Scalars['String']>;
  provider: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  userId: Scalars['uuid'];
};

/** aggregated selection of "user_auth_identities" */
export type UserAuthIdentitiesAggregate = {
  __typename?: 'UserAuthIdentitiesAggregate';
  aggregate?: Maybe<UserAuthIdentitiesAggregateFields>;
  nodes: Array<UserAuthIdentities>;
};

export type UserAuthIdentitiesAggregateBoolExp = {
  count?: InputMaybe<UserAuthIdentitiesAggregateBoolExpCount>;
};

/** aggregate fields of "user_auth_identities" */
export type UserAuthIdentitiesAggregateFields = {
  __typename?: 'UserAuthIdentitiesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<UserAuthIdentitiesMaxFields>;
  min?: Maybe<UserAuthIdentitiesMinFields>;
};


/** aggregate fields of "user_auth_identities" */
export type UserAuthIdentitiesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<UserAuthIdentitiesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_auth_identities" */
export type UserAuthIdentitiesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<UserAuthIdentitiesMaxOrderBy>;
  min?: InputMaybe<UserAuthIdentitiesMinOrderBy>;
};

/** input type for inserting array relation for remote table "user_auth_identities" */
export type UserAuthIdentitiesArrRelInsertInput = {
  data: Array<UserAuthIdentitiesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<UserAuthIdentitiesOnConflict>;
};

/** Boolean expression to filter rows from the table "user_auth_identities". All fields are combined with a logical 'AND'. */
export type UserAuthIdentitiesBoolExp = {
  _and?: InputMaybe<Array<UserAuthIdentitiesBoolExp>>;
  _not?: InputMaybe<UserAuthIdentitiesBoolExp>;
  _or?: InputMaybe<Array<UserAuthIdentitiesBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  displayName?: InputMaybe<StringComparisonExp>;
  email?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  phoneNumber?: InputMaybe<StringComparisonExp>;
  provider?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "user_auth_identities" */
export enum UserAuthIdentitiesConstraint {
  /** unique or primary key constraint on columns "id" */
  UserAuthIdentitiesPkey = 'user_auth_identities_pkey',
  /** unique or primary key constraint on columns "provider", "user_id", "email" */
  UserAuthIdentitiesProviderEmailUserIdKey = 'user_auth_identities_provider_email_user_id_key'
}

/** input type for inserting data into table "user_auth_identities" */
export type UserAuthIdentitiesInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  displayName?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type UserAuthIdentitiesMaxFields = {
  __typename?: 'UserAuthIdentitiesMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  displayName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  phoneNumber?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "user_auth_identities" */
export type UserAuthIdentitiesMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  displayName?: InputMaybe<OrderBy>;
  email?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  phoneNumber?: InputMaybe<OrderBy>;
  provider?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type UserAuthIdentitiesMinFields = {
  __typename?: 'UserAuthIdentitiesMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  displayName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  phoneNumber?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "user_auth_identities" */
export type UserAuthIdentitiesMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  displayName?: InputMaybe<OrderBy>;
  email?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  phoneNumber?: InputMaybe<OrderBy>;
  provider?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "user_auth_identities" */
export type UserAuthIdentitiesMutationResponse = {
  __typename?: 'UserAuthIdentitiesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UserAuthIdentities>;
};

/** on_conflict condition type for table "user_auth_identities" */
export type UserAuthIdentitiesOnConflict = {
  constraint: UserAuthIdentitiesConstraint;
  updateColumns?: Array<UserAuthIdentitiesUpdateColumn>;
  where?: InputMaybe<UserAuthIdentitiesBoolExp>;
};

/** Ordering options when selecting data from "user_auth_identities". */
export type UserAuthIdentitiesOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  displayName?: InputMaybe<OrderBy>;
  email?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  phoneNumber?: InputMaybe<OrderBy>;
  provider?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: user_auth_identities */
export type UserAuthIdentitiesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "user_auth_identities" */
export enum UserAuthIdentitiesSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  DisplayName = 'displayName',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  PhoneNumber = 'phoneNumber',
  /** column name */
  Provider = 'provider',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "user_auth_identities" */
export type UserAuthIdentitiesSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  displayName?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "user_auth_identities" */
export type UserAuthIdentitiesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UserAuthIdentitiesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserAuthIdentitiesStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  displayName?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "user_auth_identities" */
export enum UserAuthIdentitiesUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  DisplayName = 'displayName',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  PhoneNumber = 'phoneNumber',
  /** column name */
  Provider = 'provider',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

export type UserAuthIdentitiesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserAuthIdentitiesSetInput>;
  /** filter the rows which have to be updated */
  where: UserAuthIdentitiesBoolExp;
};

/** columns and relationships of "user_blocks" */
export type UserBlocks = {
  __typename?: 'UserBlocks';
  /** An object relationship */
  blocked: Users;
  /** An object relationship */
  blockedProfile?: Maybe<UserProfiles>;
  blockedUserId: Scalars['uuid'];
  /** An object relationship */
  blocker: Users;
  blockerUserId: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "user_blocks" */
export type UserBlocksAggregate = {
  __typename?: 'UserBlocksAggregate';
  aggregate?: Maybe<UserBlocksAggregateFields>;
  nodes: Array<UserBlocks>;
};

/** aggregate fields of "user_blocks" */
export type UserBlocksAggregateFields = {
  __typename?: 'UserBlocksAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<UserBlocksMaxFields>;
  min?: Maybe<UserBlocksMinFields>;
};


/** aggregate fields of "user_blocks" */
export type UserBlocksAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<UserBlocksSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "user_blocks". All fields are combined with a logical 'AND'. */
export type UserBlocksBoolExp = {
  _and?: InputMaybe<Array<UserBlocksBoolExp>>;
  _not?: InputMaybe<UserBlocksBoolExp>;
  _or?: InputMaybe<Array<UserBlocksBoolExp>>;
  blocked?: InputMaybe<UsersBoolExp>;
  blockedProfile?: InputMaybe<UserProfilesBoolExp>;
  blockedUserId?: InputMaybe<UuidComparisonExp>;
  blocker?: InputMaybe<UsersBoolExp>;
  blockerUserId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "user_blocks" */
export enum UserBlocksConstraint {
  /** unique or primary key constraint on columns "blocker_user_id", "blocked_user_id" */
  UserBlocksOneActivePerPair = 'user_blocks_one_active_per_pair',
  /** unique or primary key constraint on columns "id" */
  UserBlocksPkey = 'user_blocks_pkey'
}

/** input type for inserting data into table "user_blocks" */
export type UserBlocksInsertInput = {
  blocked?: InputMaybe<UsersObjRelInsertInput>;
  blockedProfile?: InputMaybe<UserProfilesObjRelInsertInput>;
  blockedUserId?: InputMaybe<Scalars['uuid']>;
  blocker?: InputMaybe<UsersObjRelInsertInput>;
  blockerUserId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type UserBlocksMaxFields = {
  __typename?: 'UserBlocksMaxFields';
  blockedUserId?: Maybe<Scalars['uuid']>;
  blockerUserId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type UserBlocksMinFields = {
  __typename?: 'UserBlocksMinFields';
  blockedUserId?: Maybe<Scalars['uuid']>;
  blockerUserId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "user_blocks" */
export type UserBlocksMutationResponse = {
  __typename?: 'UserBlocksMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UserBlocks>;
};

/** on_conflict condition type for table "user_blocks" */
export type UserBlocksOnConflict = {
  constraint: UserBlocksConstraint;
  updateColumns?: Array<UserBlocksUpdateColumn>;
  where?: InputMaybe<UserBlocksBoolExp>;
};

/** Ordering options when selecting data from "user_blocks". */
export type UserBlocksOrderBy = {
  blocked?: InputMaybe<UsersOrderBy>;
  blockedProfile?: InputMaybe<UserProfilesOrderBy>;
  blockedUserId?: InputMaybe<OrderBy>;
  blocker?: InputMaybe<UsersOrderBy>;
  blockerUserId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: user_blocks */
export type UserBlocksPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "user_blocks" */
export enum UserBlocksSelectColumn {
  /** column name */
  BlockedUserId = 'blockedUserId',
  /** column name */
  BlockerUserId = 'blockerUserId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "user_blocks" */
export type UserBlocksSetInput = {
  blockedUserId?: InputMaybe<Scalars['uuid']>;
  blockerUserId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "user_blocks" */
export type UserBlocksStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UserBlocksStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserBlocksStreamCursorValueInput = {
  blockedUserId?: InputMaybe<Scalars['uuid']>;
  blockerUserId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "user_blocks" */
export enum UserBlocksUpdateColumn {
  /** column name */
  BlockedUserId = 'blockedUserId',
  /** column name */
  BlockerUserId = 'blockerUserId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type UserBlocksUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserBlocksSetInput>;
  /** filter the rows which have to be updated */
  where: UserBlocksBoolExp;
};

/** columns and relationships of "user_coach_services" */
export type UserCoachServices = {
  __typename?: 'UserCoachServices';
  coverImageFileName: Scalars['String'];
  coverImagePath: Scalars['String'];
  coverImageProvider: Scalars['String'];
  coverImageProviderId: Scalars['String'];
  coverImageProviderUrl: Scalars['String'];
  coverImageUrl: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  currency: Scalars['String'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  description: Scalars['String'];
  id: Scalars['uuid'];
  priceUnitAmount: Scalars['Int'];
  title: Scalars['String'];
  type?: Maybe<LessonTypesEnum>;
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid'];
  /** An object relationship */
  userProfile?: Maybe<UserProfiles>;
};

/** aggregated selection of "user_coach_services" */
export type UserCoachServicesAggregate = {
  __typename?: 'UserCoachServicesAggregate';
  aggregate?: Maybe<UserCoachServicesAggregateFields>;
  nodes: Array<UserCoachServices>;
};

export type UserCoachServicesAggregateBoolExp = {
  count?: InputMaybe<UserCoachServicesAggregateBoolExpCount>;
};

/** aggregate fields of "user_coach_services" */
export type UserCoachServicesAggregateFields = {
  __typename?: 'UserCoachServicesAggregateFields';
  avg?: Maybe<UserCoachServicesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<UserCoachServicesMaxFields>;
  min?: Maybe<UserCoachServicesMinFields>;
  stddev?: Maybe<UserCoachServicesStddevFields>;
  stddevPop?: Maybe<UserCoachServicesStddevPopFields>;
  stddevSamp?: Maybe<UserCoachServicesStddevSampFields>;
  sum?: Maybe<UserCoachServicesSumFields>;
  varPop?: Maybe<UserCoachServicesVarPopFields>;
  varSamp?: Maybe<UserCoachServicesVarSampFields>;
  variance?: Maybe<UserCoachServicesVarianceFields>;
};


/** aggregate fields of "user_coach_services" */
export type UserCoachServicesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<UserCoachServicesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_coach_services" */
export type UserCoachServicesAggregateOrderBy = {
  avg?: InputMaybe<UserCoachServicesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<UserCoachServicesMaxOrderBy>;
  min?: InputMaybe<UserCoachServicesMinOrderBy>;
  stddev?: InputMaybe<UserCoachServicesStddevOrderBy>;
  stddevPop?: InputMaybe<UserCoachServicesStddevPopOrderBy>;
  stddevSamp?: InputMaybe<UserCoachServicesStddevSampOrderBy>;
  sum?: InputMaybe<UserCoachServicesSumOrderBy>;
  varPop?: InputMaybe<UserCoachServicesVarPopOrderBy>;
  varSamp?: InputMaybe<UserCoachServicesVarSampOrderBy>;
  variance?: InputMaybe<UserCoachServicesVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "user_coach_services" */
export type UserCoachServicesArrRelInsertInput = {
  data: Array<UserCoachServicesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<UserCoachServicesOnConflict>;
};

/** aggregate avg on columns */
export type UserCoachServicesAvgFields = {
  __typename?: 'UserCoachServicesAvgFields';
  priceUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "user_coach_services" */
export type UserCoachServicesAvgOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "user_coach_services". All fields are combined with a logical 'AND'. */
export type UserCoachServicesBoolExp = {
  _and?: InputMaybe<Array<UserCoachServicesBoolExp>>;
  _not?: InputMaybe<UserCoachServicesBoolExp>;
  _or?: InputMaybe<Array<UserCoachServicesBoolExp>>;
  coverImageFileName?: InputMaybe<StringComparisonExp>;
  coverImagePath?: InputMaybe<StringComparisonExp>;
  coverImageProvider?: InputMaybe<StringComparisonExp>;
  coverImageProviderId?: InputMaybe<StringComparisonExp>;
  coverImageProviderUrl?: InputMaybe<StringComparisonExp>;
  coverImageUrl?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  currency?: InputMaybe<StringComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  priceUnitAmount?: InputMaybe<IntComparisonExp>;
  title?: InputMaybe<StringComparisonExp>;
  type?: InputMaybe<LessonTypesEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
  userProfile?: InputMaybe<UserProfilesBoolExp>;
};

/** unique or primary key constraints on table "user_coach_services" */
export enum UserCoachServicesConstraint {
  /** unique or primary key constraint on columns "id" */
  UserCoachServicesPkey = 'user_coach_services_pkey'
}

/** input type for incrementing numeric columns in table "user_coach_services" */
export type UserCoachServicesIncInput = {
  priceUnitAmount?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "user_coach_services" */
export type UserCoachServicesInsertInput = {
  coverImageFileName?: InputMaybe<Scalars['String']>;
  coverImagePath?: InputMaybe<Scalars['String']>;
  coverImageProvider?: InputMaybe<Scalars['String']>;
  coverImageProviderId?: InputMaybe<Scalars['String']>;
  coverImageProviderUrl?: InputMaybe<Scalars['String']>;
  coverImageUrl?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  priceUnitAmount?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<LessonTypesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']>;
  userProfile?: InputMaybe<UserProfilesObjRelInsertInput>;
};

/** aggregate max on columns */
export type UserCoachServicesMaxFields = {
  __typename?: 'UserCoachServicesMaxFields';
  coverImageFileName?: Maybe<Scalars['String']>;
  coverImagePath?: Maybe<Scalars['String']>;
  coverImageProvider?: Maybe<Scalars['String']>;
  coverImageProviderId?: Maybe<Scalars['String']>;
  coverImageProviderUrl?: Maybe<Scalars['String']>;
  coverImageUrl?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  priceUnitAmount?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "user_coach_services" */
export type UserCoachServicesMaxOrderBy = {
  coverImageFileName?: InputMaybe<OrderBy>;
  coverImagePath?: InputMaybe<OrderBy>;
  coverImageProvider?: InputMaybe<OrderBy>;
  coverImageProviderId?: InputMaybe<OrderBy>;
  coverImageProviderUrl?: InputMaybe<OrderBy>;
  coverImageUrl?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  currency?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type UserCoachServicesMinFields = {
  __typename?: 'UserCoachServicesMinFields';
  coverImageFileName?: Maybe<Scalars['String']>;
  coverImagePath?: Maybe<Scalars['String']>;
  coverImageProvider?: Maybe<Scalars['String']>;
  coverImageProviderId?: Maybe<Scalars['String']>;
  coverImageProviderUrl?: Maybe<Scalars['String']>;
  coverImageUrl?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  priceUnitAmount?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "user_coach_services" */
export type UserCoachServicesMinOrderBy = {
  coverImageFileName?: InputMaybe<OrderBy>;
  coverImagePath?: InputMaybe<OrderBy>;
  coverImageProvider?: InputMaybe<OrderBy>;
  coverImageProviderId?: InputMaybe<OrderBy>;
  coverImageProviderUrl?: InputMaybe<OrderBy>;
  coverImageUrl?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  currency?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "user_coach_services" */
export type UserCoachServicesMutationResponse = {
  __typename?: 'UserCoachServicesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UserCoachServices>;
};

/** on_conflict condition type for table "user_coach_services" */
export type UserCoachServicesOnConflict = {
  constraint: UserCoachServicesConstraint;
  updateColumns?: Array<UserCoachServicesUpdateColumn>;
  where?: InputMaybe<UserCoachServicesBoolExp>;
};

/** Ordering options when selecting data from "user_coach_services". */
export type UserCoachServicesOrderBy = {
  coverImageFileName?: InputMaybe<OrderBy>;
  coverImagePath?: InputMaybe<OrderBy>;
  coverImageProvider?: InputMaybe<OrderBy>;
  coverImageProviderId?: InputMaybe<OrderBy>;
  coverImageProviderUrl?: InputMaybe<OrderBy>;
  coverImageUrl?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  currency?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
  userProfile?: InputMaybe<UserProfilesOrderBy>;
};

/** primary key columns input for table: user_coach_services */
export type UserCoachServicesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "user_coach_services" */
export enum UserCoachServicesSelectColumn {
  /** column name */
  CoverImageFileName = 'coverImageFileName',
  /** column name */
  CoverImagePath = 'coverImagePath',
  /** column name */
  CoverImageProvider = 'coverImageProvider',
  /** column name */
  CoverImageProviderId = 'coverImageProviderId',
  /** column name */
  CoverImageProviderUrl = 'coverImageProviderUrl',
  /** column name */
  CoverImageUrl = 'coverImageUrl',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Currency = 'currency',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  PriceUnitAmount = 'priceUnitAmount',
  /** column name */
  Title = 'title',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "user_coach_services" */
export type UserCoachServicesSetInput = {
  coverImageFileName?: InputMaybe<Scalars['String']>;
  coverImagePath?: InputMaybe<Scalars['String']>;
  coverImageProvider?: InputMaybe<Scalars['String']>;
  coverImageProviderId?: InputMaybe<Scalars['String']>;
  coverImageProviderUrl?: InputMaybe<Scalars['String']>;
  coverImageUrl?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  priceUnitAmount?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<LessonTypesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type UserCoachServicesStddevFields = {
  __typename?: 'UserCoachServicesStddevFields';
  priceUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "user_coach_services" */
export type UserCoachServicesStddevOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type UserCoachServicesStddevPopFields = {
  __typename?: 'UserCoachServicesStddevPopFields';
  priceUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "user_coach_services" */
export type UserCoachServicesStddevPopOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type UserCoachServicesStddevSampFields = {
  __typename?: 'UserCoachServicesStddevSampFields';
  priceUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "user_coach_services" */
export type UserCoachServicesStddevSampOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "user_coach_services" */
export type UserCoachServicesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UserCoachServicesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserCoachServicesStreamCursorValueInput = {
  coverImageFileName?: InputMaybe<Scalars['String']>;
  coverImagePath?: InputMaybe<Scalars['String']>;
  coverImageProvider?: InputMaybe<Scalars['String']>;
  coverImageProviderId?: InputMaybe<Scalars['String']>;
  coverImageProviderUrl?: InputMaybe<Scalars['String']>;
  coverImageUrl?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  priceUnitAmount?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<LessonTypesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type UserCoachServicesSumFields = {
  __typename?: 'UserCoachServicesSumFields';
  priceUnitAmount?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "user_coach_services" */
export type UserCoachServicesSumOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
};

/** update columns of table "user_coach_services" */
export enum UserCoachServicesUpdateColumn {
  /** column name */
  CoverImageFileName = 'coverImageFileName',
  /** column name */
  CoverImagePath = 'coverImagePath',
  /** column name */
  CoverImageProvider = 'coverImageProvider',
  /** column name */
  CoverImageProviderId = 'coverImageProviderId',
  /** column name */
  CoverImageProviderUrl = 'coverImageProviderUrl',
  /** column name */
  CoverImageUrl = 'coverImageUrl',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Currency = 'currency',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  PriceUnitAmount = 'priceUnitAmount',
  /** column name */
  Title = 'title',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

export type UserCoachServicesUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<UserCoachServicesIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserCoachServicesSetInput>;
  /** filter the rows which have to be updated */
  where: UserCoachServicesBoolExp;
};

/** aggregate varPop on columns */
export type UserCoachServicesVarPopFields = {
  __typename?: 'UserCoachServicesVarPopFields';
  priceUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "user_coach_services" */
export type UserCoachServicesVarPopOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type UserCoachServicesVarSampFields = {
  __typename?: 'UserCoachServicesVarSampFields';
  priceUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "user_coach_services" */
export type UserCoachServicesVarSampOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type UserCoachServicesVarianceFields = {
  __typename?: 'UserCoachServicesVarianceFields';
  priceUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "user_coach_services" */
export type UserCoachServicesVarianceOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
};

/** columns and relationships of "user_communication_preferences" */
export type UserCommunicationPreferences = {
  __typename?: 'UserCommunicationPreferences';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** This will match the users UUID since it's 1-1 relationship */
  id: Scalars['uuid'];
  lessonBookedEmail: CommunicationPreferenceStatusesEnum;
  lessonBookedPush: CommunicationPreferenceStatusesEnum;
  lessonCanceledEmail: CommunicationPreferenceStatusesEnum;
  lessonCanceledPushed: CommunicationPreferenceStatusesEnum;
  lessonReminderEmail: CommunicationPreferenceStatusesEnum;
  lessonReminderPush: CommunicationPreferenceStatusesEnum;
  marketingEmail: CommunicationPreferenceStatusesEnum;
  marketingPush: CommunicationPreferenceStatusesEnum;
  newFollowerEmail: CommunicationPreferenceStatusesEnum;
  newFollowerPush: CommunicationPreferenceStatusesEnum;
  newLessonPublishedEmail: CommunicationPreferenceStatusesEnum;
  newLessonPublishedPush: CommunicationPreferenceStatusesEnum;
  participantLeftLessonEmail: CommunicationPreferenceStatusesEnum;
  participantLeftLessonPush: CommunicationPreferenceStatusesEnum;
  payoutEmail: CommunicationPreferenceStatusesEnum;
  payoutPush: CommunicationPreferenceStatusesEnum;
  playSessionCanceledEmail: CommunicationPreferenceStatusesEnum;
  playSessionCanceledPush: CommunicationPreferenceStatusesEnum;
  playSessionParticipantJoinedEmail: CommunicationPreferenceStatusesEnum;
  playSessionParticipantJoinedPush: CommunicationPreferenceStatusesEnum;
  playSessionParticipantLeftEmail: CommunicationPreferenceStatusesEnum;
  playSessionParticipantLeftPush: CommunicationPreferenceStatusesEnum;
  playSessionReminderEmail: CommunicationPreferenceStatusesEnum;
  playSessionReminderPush: CommunicationPreferenceStatusesEnum;
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
};

/** aggregated selection of "user_communication_preferences" */
export type UserCommunicationPreferencesAggregate = {
  __typename?: 'UserCommunicationPreferencesAggregate';
  aggregate?: Maybe<UserCommunicationPreferencesAggregateFields>;
  nodes: Array<UserCommunicationPreferences>;
};

/** aggregate fields of "user_communication_preferences" */
export type UserCommunicationPreferencesAggregateFields = {
  __typename?: 'UserCommunicationPreferencesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<UserCommunicationPreferencesMaxFields>;
  min?: Maybe<UserCommunicationPreferencesMinFields>;
};


/** aggregate fields of "user_communication_preferences" */
export type UserCommunicationPreferencesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<UserCommunicationPreferencesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "user_communication_preferences". All fields are combined with a logical 'AND'. */
export type UserCommunicationPreferencesBoolExp = {
  _and?: InputMaybe<Array<UserCommunicationPreferencesBoolExp>>;
  _not?: InputMaybe<UserCommunicationPreferencesBoolExp>;
  _or?: InputMaybe<Array<UserCommunicationPreferencesBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  lessonBookedEmail?: InputMaybe<CommunicationPreferenceStatusesEnumComparisonExp>;
  lessonBookedPush?: InputMaybe<CommunicationPreferenceStatusesEnumComparisonExp>;
  lessonCanceledEmail?: InputMaybe<CommunicationPreferenceStatusesEnumComparisonExp>;
  lessonCanceledPushed?: InputMaybe<CommunicationPreferenceStatusesEnumComparisonExp>;
  lessonReminderEmail?: InputMaybe<CommunicationPreferenceStatusesEnumComparisonExp>;
  lessonReminderPush?: InputMaybe<CommunicationPreferenceStatusesEnumComparisonExp>;
  marketingEmail?: InputMaybe<CommunicationPreferenceStatusesEnumComparisonExp>;
  marketingPush?: InputMaybe<CommunicationPreferenceStatusesEnumComparisonExp>;
  newFollowerEmail?: InputMaybe<CommunicationPreferenceStatusesEnumComparisonExp>;
  newFollowerPush?: InputMaybe<CommunicationPreferenceStatusesEnumComparisonExp>;
  newLessonPublishedEmail?: InputMaybe<CommunicationPreferenceStatusesEnumComparisonExp>;
  newLessonPublishedPush?: InputMaybe<CommunicationPreferenceStatusesEnumComparisonExp>;
  participantLeftLessonEmail?: InputMaybe<CommunicationPreferenceStatusesEnumComparisonExp>;
  participantLeftLessonPush?: InputMaybe<CommunicationPreferenceStatusesEnumComparisonExp>;
  payoutEmail?: InputMaybe<CommunicationPreferenceStatusesEnumComparisonExp>;
  payoutPush?: InputMaybe<CommunicationPreferenceStatusesEnumComparisonExp>;
  playSessionCanceledEmail?: InputMaybe<CommunicationPreferenceStatusesEnumComparisonExp>;
  playSessionCanceledPush?: InputMaybe<CommunicationPreferenceStatusesEnumComparisonExp>;
  playSessionParticipantJoinedEmail?: InputMaybe<CommunicationPreferenceStatusesEnumComparisonExp>;
  playSessionParticipantJoinedPush?: InputMaybe<CommunicationPreferenceStatusesEnumComparisonExp>;
  playSessionParticipantLeftEmail?: InputMaybe<CommunicationPreferenceStatusesEnumComparisonExp>;
  playSessionParticipantLeftPush?: InputMaybe<CommunicationPreferenceStatusesEnumComparisonExp>;
  playSessionReminderEmail?: InputMaybe<CommunicationPreferenceStatusesEnumComparisonExp>;
  playSessionReminderPush?: InputMaybe<CommunicationPreferenceStatusesEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
};

/** unique or primary key constraints on table "user_communication_preferences" */
export enum UserCommunicationPreferencesConstraint {
  /** unique or primary key constraint on columns "id" */
  UserCommunicationPreferencesPkey = 'user_communication_preferences_pkey'
}

/** input type for inserting data into table "user_communication_preferences" */
export type UserCommunicationPreferencesInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  /** This will match the users UUID since it's 1-1 relationship */
  id?: InputMaybe<Scalars['uuid']>;
  lessonBookedEmail?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  lessonBookedPush?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  lessonCanceledEmail?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  lessonCanceledPushed?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  lessonReminderEmail?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  lessonReminderPush?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  marketingEmail?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  marketingPush?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  newFollowerEmail?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  newFollowerPush?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  newLessonPublishedEmail?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  newLessonPublishedPush?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  participantLeftLessonEmail?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  participantLeftLessonPush?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  payoutEmail?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  payoutPush?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  playSessionCanceledEmail?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  playSessionCanceledPush?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  playSessionParticipantJoinedEmail?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  playSessionParticipantJoinedPush?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  playSessionParticipantLeftEmail?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  playSessionParticipantLeftPush?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  playSessionReminderEmail?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  playSessionReminderPush?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
};

/** aggregate max on columns */
export type UserCommunicationPreferencesMaxFields = {
  __typename?: 'UserCommunicationPreferencesMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** This will match the users UUID since it's 1-1 relationship */
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type UserCommunicationPreferencesMinFields = {
  __typename?: 'UserCommunicationPreferencesMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** This will match the users UUID since it's 1-1 relationship */
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "user_communication_preferences" */
export type UserCommunicationPreferencesMutationResponse = {
  __typename?: 'UserCommunicationPreferencesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UserCommunicationPreferences>;
};

/** input type for inserting object relation for remote table "user_communication_preferences" */
export type UserCommunicationPreferencesObjRelInsertInput = {
  data: UserCommunicationPreferencesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<UserCommunicationPreferencesOnConflict>;
};

/** on_conflict condition type for table "user_communication_preferences" */
export type UserCommunicationPreferencesOnConflict = {
  constraint: UserCommunicationPreferencesConstraint;
  updateColumns?: Array<UserCommunicationPreferencesUpdateColumn>;
  where?: InputMaybe<UserCommunicationPreferencesBoolExp>;
};

/** Ordering options when selecting data from "user_communication_preferences". */
export type UserCommunicationPreferencesOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lessonBookedEmail?: InputMaybe<OrderBy>;
  lessonBookedPush?: InputMaybe<OrderBy>;
  lessonCanceledEmail?: InputMaybe<OrderBy>;
  lessonCanceledPushed?: InputMaybe<OrderBy>;
  lessonReminderEmail?: InputMaybe<OrderBy>;
  lessonReminderPush?: InputMaybe<OrderBy>;
  marketingEmail?: InputMaybe<OrderBy>;
  marketingPush?: InputMaybe<OrderBy>;
  newFollowerEmail?: InputMaybe<OrderBy>;
  newFollowerPush?: InputMaybe<OrderBy>;
  newLessonPublishedEmail?: InputMaybe<OrderBy>;
  newLessonPublishedPush?: InputMaybe<OrderBy>;
  participantLeftLessonEmail?: InputMaybe<OrderBy>;
  participantLeftLessonPush?: InputMaybe<OrderBy>;
  payoutEmail?: InputMaybe<OrderBy>;
  payoutPush?: InputMaybe<OrderBy>;
  playSessionCanceledEmail?: InputMaybe<OrderBy>;
  playSessionCanceledPush?: InputMaybe<OrderBy>;
  playSessionParticipantJoinedEmail?: InputMaybe<OrderBy>;
  playSessionParticipantJoinedPush?: InputMaybe<OrderBy>;
  playSessionParticipantLeftEmail?: InputMaybe<OrderBy>;
  playSessionParticipantLeftPush?: InputMaybe<OrderBy>;
  playSessionReminderEmail?: InputMaybe<OrderBy>;
  playSessionReminderPush?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
};

/** primary key columns input for table: user_communication_preferences */
export type UserCommunicationPreferencesPkColumnsInput = {
  /** This will match the users UUID since it's 1-1 relationship */
  id: Scalars['uuid'];
};

/** select columns of table "user_communication_preferences" */
export enum UserCommunicationPreferencesSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  LessonBookedEmail = 'lessonBookedEmail',
  /** column name */
  LessonBookedPush = 'lessonBookedPush',
  /** column name */
  LessonCanceledEmail = 'lessonCanceledEmail',
  /** column name */
  LessonCanceledPushed = 'lessonCanceledPushed',
  /** column name */
  LessonReminderEmail = 'lessonReminderEmail',
  /** column name */
  LessonReminderPush = 'lessonReminderPush',
  /** column name */
  MarketingEmail = 'marketingEmail',
  /** column name */
  MarketingPush = 'marketingPush',
  /** column name */
  NewFollowerEmail = 'newFollowerEmail',
  /** column name */
  NewFollowerPush = 'newFollowerPush',
  /** column name */
  NewLessonPublishedEmail = 'newLessonPublishedEmail',
  /** column name */
  NewLessonPublishedPush = 'newLessonPublishedPush',
  /** column name */
  ParticipantLeftLessonEmail = 'participantLeftLessonEmail',
  /** column name */
  ParticipantLeftLessonPush = 'participantLeftLessonPush',
  /** column name */
  PayoutEmail = 'payoutEmail',
  /** column name */
  PayoutPush = 'payoutPush',
  /** column name */
  PlaySessionCanceledEmail = 'playSessionCanceledEmail',
  /** column name */
  PlaySessionCanceledPush = 'playSessionCanceledPush',
  /** column name */
  PlaySessionParticipantJoinedEmail = 'playSessionParticipantJoinedEmail',
  /** column name */
  PlaySessionParticipantJoinedPush = 'playSessionParticipantJoinedPush',
  /** column name */
  PlaySessionParticipantLeftEmail = 'playSessionParticipantLeftEmail',
  /** column name */
  PlaySessionParticipantLeftPush = 'playSessionParticipantLeftPush',
  /** column name */
  PlaySessionReminderEmail = 'playSessionReminderEmail',
  /** column name */
  PlaySessionReminderPush = 'playSessionReminderPush',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "user_communication_preferences" */
export type UserCommunicationPreferencesSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  /** This will match the users UUID since it's 1-1 relationship */
  id?: InputMaybe<Scalars['uuid']>;
  lessonBookedEmail?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  lessonBookedPush?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  lessonCanceledEmail?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  lessonCanceledPushed?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  lessonReminderEmail?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  lessonReminderPush?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  marketingEmail?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  marketingPush?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  newFollowerEmail?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  newFollowerPush?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  newLessonPublishedEmail?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  newLessonPublishedPush?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  participantLeftLessonEmail?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  participantLeftLessonPush?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  payoutEmail?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  payoutPush?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  playSessionCanceledEmail?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  playSessionCanceledPush?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  playSessionParticipantJoinedEmail?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  playSessionParticipantJoinedPush?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  playSessionParticipantLeftEmail?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  playSessionParticipantLeftPush?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  playSessionReminderEmail?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  playSessionReminderPush?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "user_communication_preferences" */
export type UserCommunicationPreferencesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UserCommunicationPreferencesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserCommunicationPreferencesStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  /** This will match the users UUID since it's 1-1 relationship */
  id?: InputMaybe<Scalars['uuid']>;
  lessonBookedEmail?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  lessonBookedPush?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  lessonCanceledEmail?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  lessonCanceledPushed?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  lessonReminderEmail?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  lessonReminderPush?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  marketingEmail?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  marketingPush?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  newFollowerEmail?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  newFollowerPush?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  newLessonPublishedEmail?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  newLessonPublishedPush?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  participantLeftLessonEmail?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  participantLeftLessonPush?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  payoutEmail?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  payoutPush?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  playSessionCanceledEmail?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  playSessionCanceledPush?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  playSessionParticipantJoinedEmail?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  playSessionParticipantJoinedPush?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  playSessionParticipantLeftEmail?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  playSessionParticipantLeftPush?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  playSessionReminderEmail?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  playSessionReminderPush?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "user_communication_preferences" */
export enum UserCommunicationPreferencesUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  LessonBookedEmail = 'lessonBookedEmail',
  /** column name */
  LessonBookedPush = 'lessonBookedPush',
  /** column name */
  LessonCanceledEmail = 'lessonCanceledEmail',
  /** column name */
  LessonCanceledPushed = 'lessonCanceledPushed',
  /** column name */
  LessonReminderEmail = 'lessonReminderEmail',
  /** column name */
  LessonReminderPush = 'lessonReminderPush',
  /** column name */
  MarketingEmail = 'marketingEmail',
  /** column name */
  MarketingPush = 'marketingPush',
  /** column name */
  NewFollowerEmail = 'newFollowerEmail',
  /** column name */
  NewFollowerPush = 'newFollowerPush',
  /** column name */
  NewLessonPublishedEmail = 'newLessonPublishedEmail',
  /** column name */
  NewLessonPublishedPush = 'newLessonPublishedPush',
  /** column name */
  ParticipantLeftLessonEmail = 'participantLeftLessonEmail',
  /** column name */
  ParticipantLeftLessonPush = 'participantLeftLessonPush',
  /** column name */
  PayoutEmail = 'payoutEmail',
  /** column name */
  PayoutPush = 'payoutPush',
  /** column name */
  PlaySessionCanceledEmail = 'playSessionCanceledEmail',
  /** column name */
  PlaySessionCanceledPush = 'playSessionCanceledPush',
  /** column name */
  PlaySessionParticipantJoinedEmail = 'playSessionParticipantJoinedEmail',
  /** column name */
  PlaySessionParticipantJoinedPush = 'playSessionParticipantJoinedPush',
  /** column name */
  PlaySessionParticipantLeftEmail = 'playSessionParticipantLeftEmail',
  /** column name */
  PlaySessionParticipantLeftPush = 'playSessionParticipantLeftPush',
  /** column name */
  PlaySessionReminderEmail = 'playSessionReminderEmail',
  /** column name */
  PlaySessionReminderPush = 'playSessionReminderPush',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type UserCommunicationPreferencesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserCommunicationPreferencesSetInput>;
  /** filter the rows which have to be updated */
  where: UserCommunicationPreferencesBoolExp;
};

/** columns and relationships of "user_connection_request_statuses" */
export type UserConnectionRequestStatuses = {
  __typename?: 'UserConnectionRequestStatuses';
  comment?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "user_connection_request_statuses" */
export type UserConnectionRequestStatusesAggregate = {
  __typename?: 'UserConnectionRequestStatusesAggregate';
  aggregate?: Maybe<UserConnectionRequestStatusesAggregateFields>;
  nodes: Array<UserConnectionRequestStatuses>;
};

/** aggregate fields of "user_connection_request_statuses" */
export type UserConnectionRequestStatusesAggregateFields = {
  __typename?: 'UserConnectionRequestStatusesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<UserConnectionRequestStatusesMaxFields>;
  min?: Maybe<UserConnectionRequestStatusesMinFields>;
};


/** aggregate fields of "user_connection_request_statuses" */
export type UserConnectionRequestStatusesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<UserConnectionRequestStatusesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "user_connection_request_statuses". All fields are combined with a logical 'AND'. */
export type UserConnectionRequestStatusesBoolExp = {
  _and?: InputMaybe<Array<UserConnectionRequestStatusesBoolExp>>;
  _not?: InputMaybe<UserConnectionRequestStatusesBoolExp>;
  _or?: InputMaybe<Array<UserConnectionRequestStatusesBoolExp>>;
  comment?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "user_connection_request_statuses" */
export enum UserConnectionRequestStatusesConstraint {
  /** unique or primary key constraint on columns "value" */
  UserConnectionRequestStatusesPkey = 'user_connection_request_statuses_pkey'
}

export enum UserConnectionRequestStatusesEnum {
  Accepted = 'ACCEPTED',
  /** withdrawn by the requester */
  Cancelled = 'CANCELLED',
  Declined = 'DECLINED',
  /** awaiting the recipient */
  Pending = 'PENDING'
}

/** Boolean expression to compare columns of type "UserConnectionRequestStatusesEnum". All fields are combined with logical 'AND'. */
export type UserConnectionRequestStatusesEnumComparisonExp = {
  _eq?: InputMaybe<UserConnectionRequestStatusesEnum>;
  _in?: InputMaybe<Array<UserConnectionRequestStatusesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<UserConnectionRequestStatusesEnum>;
  _nin?: InputMaybe<Array<UserConnectionRequestStatusesEnum>>;
};

/** input type for inserting data into table "user_connection_request_statuses" */
export type UserConnectionRequestStatusesInsertInput = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type UserConnectionRequestStatusesMaxFields = {
  __typename?: 'UserConnectionRequestStatusesMaxFields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type UserConnectionRequestStatusesMinFields = {
  __typename?: 'UserConnectionRequestStatusesMinFields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "user_connection_request_statuses" */
export type UserConnectionRequestStatusesMutationResponse = {
  __typename?: 'UserConnectionRequestStatusesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UserConnectionRequestStatuses>;
};

/** on_conflict condition type for table "user_connection_request_statuses" */
export type UserConnectionRequestStatusesOnConflict = {
  constraint: UserConnectionRequestStatusesConstraint;
  updateColumns?: Array<UserConnectionRequestStatusesUpdateColumn>;
  where?: InputMaybe<UserConnectionRequestStatusesBoolExp>;
};

/** Ordering options when selecting data from "user_connection_request_statuses". */
export type UserConnectionRequestStatusesOrderBy = {
  comment?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: user_connection_request_statuses */
export type UserConnectionRequestStatusesPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "user_connection_request_statuses" */
export enum UserConnectionRequestStatusesSelectColumn {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "user_connection_request_statuses" */
export type UserConnectionRequestStatusesSetInput = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "user_connection_request_statuses" */
export type UserConnectionRequestStatusesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UserConnectionRequestStatusesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserConnectionRequestStatusesStreamCursorValueInput = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "user_connection_request_statuses" */
export enum UserConnectionRequestStatusesUpdateColumn {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type UserConnectionRequestStatusesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserConnectionRequestStatusesSetInput>;
  /** filter the rows which have to be updated */
  where: UserConnectionRequestStatusesBoolExp;
};

/** columns and relationships of "user_connection_requests" */
export type UserConnectionRequests = {
  __typename?: 'UserConnectionRequests';
  attemptNumber: Scalars['smallint'];
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  message?: Maybe<Scalars['String']>;
  /** An object relationship */
  recipient: Users;
  /** An object relationship */
  recipientProfile?: Maybe<UserProfiles>;
  recipientUserId: Scalars['uuid'];
  /** An object relationship */
  requester: Users;
  /** An object relationship */
  requesterProfile?: Maybe<UserProfiles>;
  requesterUserId: Scalars['uuid'];
  respondedAt?: Maybe<Scalars['timestamptz']>;
  status: UserConnectionRequestStatusesEnum;
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "user_connection_requests" */
export type UserConnectionRequestsAggregate = {
  __typename?: 'UserConnectionRequestsAggregate';
  aggregate?: Maybe<UserConnectionRequestsAggregateFields>;
  nodes: Array<UserConnectionRequests>;
};

/** aggregate fields of "user_connection_requests" */
export type UserConnectionRequestsAggregateFields = {
  __typename?: 'UserConnectionRequestsAggregateFields';
  avg?: Maybe<UserConnectionRequestsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<UserConnectionRequestsMaxFields>;
  min?: Maybe<UserConnectionRequestsMinFields>;
  stddev?: Maybe<UserConnectionRequestsStddevFields>;
  stddevPop?: Maybe<UserConnectionRequestsStddevPopFields>;
  stddevSamp?: Maybe<UserConnectionRequestsStddevSampFields>;
  sum?: Maybe<UserConnectionRequestsSumFields>;
  varPop?: Maybe<UserConnectionRequestsVarPopFields>;
  varSamp?: Maybe<UserConnectionRequestsVarSampFields>;
  variance?: Maybe<UserConnectionRequestsVarianceFields>;
};


/** aggregate fields of "user_connection_requests" */
export type UserConnectionRequestsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<UserConnectionRequestsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type UserConnectionRequestsAvgFields = {
  __typename?: 'UserConnectionRequestsAvgFields';
  attemptNumber?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "user_connection_requests". All fields are combined with a logical 'AND'. */
export type UserConnectionRequestsBoolExp = {
  _and?: InputMaybe<Array<UserConnectionRequestsBoolExp>>;
  _not?: InputMaybe<UserConnectionRequestsBoolExp>;
  _or?: InputMaybe<Array<UserConnectionRequestsBoolExp>>;
  attemptNumber?: InputMaybe<SmallintComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  message?: InputMaybe<StringComparisonExp>;
  recipient?: InputMaybe<UsersBoolExp>;
  recipientProfile?: InputMaybe<UserProfilesBoolExp>;
  recipientUserId?: InputMaybe<UuidComparisonExp>;
  requester?: InputMaybe<UsersBoolExp>;
  requesterProfile?: InputMaybe<UserProfilesBoolExp>;
  requesterUserId?: InputMaybe<UuidComparisonExp>;
  respondedAt?: InputMaybe<TimestamptzComparisonExp>;
  status?: InputMaybe<UserConnectionRequestStatusesEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "user_connection_requests" */
export enum UserConnectionRequestsConstraint {
  /** unique or primary key constraint on columns "recipient_user_id", "requester_user_id" */
  UserConnectionRequestsOnePendingPerPair = 'user_connection_requests_one_pending_per_pair',
  /** unique or primary key constraint on columns "id" */
  UserConnectionRequestsPkey = 'user_connection_requests_pkey'
}

/** input type for incrementing numeric columns in table "user_connection_requests" */
export type UserConnectionRequestsIncInput = {
  attemptNumber?: InputMaybe<Scalars['smallint']>;
};

/** input type for inserting data into table "user_connection_requests" */
export type UserConnectionRequestsInsertInput = {
  attemptNumber?: InputMaybe<Scalars['smallint']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  message?: InputMaybe<Scalars['String']>;
  recipient?: InputMaybe<UsersObjRelInsertInput>;
  recipientProfile?: InputMaybe<UserProfilesObjRelInsertInput>;
  recipientUserId?: InputMaybe<Scalars['uuid']>;
  requester?: InputMaybe<UsersObjRelInsertInput>;
  requesterProfile?: InputMaybe<UserProfilesObjRelInsertInput>;
  requesterUserId?: InputMaybe<Scalars['uuid']>;
  respondedAt?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<UserConnectionRequestStatusesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type UserConnectionRequestsMaxFields = {
  __typename?: 'UserConnectionRequestsMaxFields';
  attemptNumber?: Maybe<Scalars['smallint']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  message?: Maybe<Scalars['String']>;
  recipientUserId?: Maybe<Scalars['uuid']>;
  requesterUserId?: Maybe<Scalars['uuid']>;
  respondedAt?: Maybe<Scalars['timestamptz']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type UserConnectionRequestsMinFields = {
  __typename?: 'UserConnectionRequestsMinFields';
  attemptNumber?: Maybe<Scalars['smallint']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  message?: Maybe<Scalars['String']>;
  recipientUserId?: Maybe<Scalars['uuid']>;
  requesterUserId?: Maybe<Scalars['uuid']>;
  respondedAt?: Maybe<Scalars['timestamptz']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "user_connection_requests" */
export type UserConnectionRequestsMutationResponse = {
  __typename?: 'UserConnectionRequestsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UserConnectionRequests>;
};

/** input type for inserting object relation for remote table "user_connection_requests" */
export type UserConnectionRequestsObjRelInsertInput = {
  data: UserConnectionRequestsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<UserConnectionRequestsOnConflict>;
};

/** on_conflict condition type for table "user_connection_requests" */
export type UserConnectionRequestsOnConflict = {
  constraint: UserConnectionRequestsConstraint;
  updateColumns?: Array<UserConnectionRequestsUpdateColumn>;
  where?: InputMaybe<UserConnectionRequestsBoolExp>;
};

/** Ordering options when selecting data from "user_connection_requests". */
export type UserConnectionRequestsOrderBy = {
  attemptNumber?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  message?: InputMaybe<OrderBy>;
  recipient?: InputMaybe<UsersOrderBy>;
  recipientProfile?: InputMaybe<UserProfilesOrderBy>;
  recipientUserId?: InputMaybe<OrderBy>;
  requester?: InputMaybe<UsersOrderBy>;
  requesterProfile?: InputMaybe<UserProfilesOrderBy>;
  requesterUserId?: InputMaybe<OrderBy>;
  respondedAt?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: user_connection_requests */
export type UserConnectionRequestsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "user_connection_requests" */
export enum UserConnectionRequestsSelectColumn {
  /** column name */
  AttemptNumber = 'attemptNumber',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  Message = 'message',
  /** column name */
  RecipientUserId = 'recipientUserId',
  /** column name */
  RequesterUserId = 'requesterUserId',
  /** column name */
  RespondedAt = 'respondedAt',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "user_connection_requests" */
export type UserConnectionRequestsSetInput = {
  attemptNumber?: InputMaybe<Scalars['smallint']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  message?: InputMaybe<Scalars['String']>;
  recipientUserId?: InputMaybe<Scalars['uuid']>;
  requesterUserId?: InputMaybe<Scalars['uuid']>;
  respondedAt?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<UserConnectionRequestStatusesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type UserConnectionRequestsStddevFields = {
  __typename?: 'UserConnectionRequestsStddevFields';
  attemptNumber?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type UserConnectionRequestsStddevPopFields = {
  __typename?: 'UserConnectionRequestsStddevPopFields';
  attemptNumber?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type UserConnectionRequestsStddevSampFields = {
  __typename?: 'UserConnectionRequestsStddevSampFields';
  attemptNumber?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "user_connection_requests" */
export type UserConnectionRequestsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UserConnectionRequestsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserConnectionRequestsStreamCursorValueInput = {
  attemptNumber?: InputMaybe<Scalars['smallint']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  message?: InputMaybe<Scalars['String']>;
  recipientUserId?: InputMaybe<Scalars['uuid']>;
  requesterUserId?: InputMaybe<Scalars['uuid']>;
  respondedAt?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<UserConnectionRequestStatusesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type UserConnectionRequestsSumFields = {
  __typename?: 'UserConnectionRequestsSumFields';
  attemptNumber?: Maybe<Scalars['smallint']>;
};

/** update columns of table "user_connection_requests" */
export enum UserConnectionRequestsUpdateColumn {
  /** column name */
  AttemptNumber = 'attemptNumber',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  Message = 'message',
  /** column name */
  RecipientUserId = 'recipientUserId',
  /** column name */
  RequesterUserId = 'requesterUserId',
  /** column name */
  RespondedAt = 'respondedAt',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type UserConnectionRequestsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<UserConnectionRequestsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserConnectionRequestsSetInput>;
  /** filter the rows which have to be updated */
  where: UserConnectionRequestsBoolExp;
};

/** aggregate varPop on columns */
export type UserConnectionRequestsVarPopFields = {
  __typename?: 'UserConnectionRequestsVarPopFields';
  attemptNumber?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type UserConnectionRequestsVarSampFields = {
  __typename?: 'UserConnectionRequestsVarSampFields';
  attemptNumber?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type UserConnectionRequestsVarianceFields = {
  __typename?: 'UserConnectionRequestsVarianceFields';
  attemptNumber?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "user_connections" */
export type UserConnections = {
  __typename?: 'UserConnections';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  removedByUserId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  request?: Maybe<UserConnectionRequests>;
  requestId?: Maybe<Scalars['uuid']>;
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  userA: Users;
  userAId: Scalars['uuid'];
  /** An object relationship */
  userAProfile?: Maybe<UserProfiles>;
  /** An object relationship */
  userB: Users;
  userBId: Scalars['uuid'];
  /** An object relationship */
  userBProfile?: Maybe<UserProfiles>;
};

/** aggregated selection of "user_connections" */
export type UserConnectionsAggregate = {
  __typename?: 'UserConnectionsAggregate';
  aggregate?: Maybe<UserConnectionsAggregateFields>;
  nodes: Array<UserConnections>;
};

/** aggregate fields of "user_connections" */
export type UserConnectionsAggregateFields = {
  __typename?: 'UserConnectionsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<UserConnectionsMaxFields>;
  min?: Maybe<UserConnectionsMinFields>;
};


/** aggregate fields of "user_connections" */
export type UserConnectionsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<UserConnectionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "user_connections". All fields are combined with a logical 'AND'. */
export type UserConnectionsBoolExp = {
  _and?: InputMaybe<Array<UserConnectionsBoolExp>>;
  _not?: InputMaybe<UserConnectionsBoolExp>;
  _or?: InputMaybe<Array<UserConnectionsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  removedByUserId?: InputMaybe<UuidComparisonExp>;
  request?: InputMaybe<UserConnectionRequestsBoolExp>;
  requestId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  userA?: InputMaybe<UsersBoolExp>;
  userAId?: InputMaybe<UuidComparisonExp>;
  userAProfile?: InputMaybe<UserProfilesBoolExp>;
  userB?: InputMaybe<UsersBoolExp>;
  userBId?: InputMaybe<UuidComparisonExp>;
  userBProfile?: InputMaybe<UserProfilesBoolExp>;
};

/** unique or primary key constraints on table "user_connections" */
export enum UserConnectionsConstraint {
  /** unique or primary key constraint on columns "user_a_id", "user_b_id" */
  UserConnectionsOneActivePerPair = 'user_connections_one_active_per_pair',
  /** unique or primary key constraint on columns "id" */
  UserConnectionsPkey = 'user_connections_pkey'
}

/** input type for inserting data into table "user_connections" */
export type UserConnectionsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  removedByUserId?: InputMaybe<Scalars['uuid']>;
  request?: InputMaybe<UserConnectionRequestsObjRelInsertInput>;
  requestId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userA?: InputMaybe<UsersObjRelInsertInput>;
  userAId?: InputMaybe<Scalars['uuid']>;
  userAProfile?: InputMaybe<UserProfilesObjRelInsertInput>;
  userB?: InputMaybe<UsersObjRelInsertInput>;
  userBId?: InputMaybe<Scalars['uuid']>;
  userBProfile?: InputMaybe<UserProfilesObjRelInsertInput>;
};

/** aggregate max on columns */
export type UserConnectionsMaxFields = {
  __typename?: 'UserConnectionsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  removedByUserId?: Maybe<Scalars['uuid']>;
  requestId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userAId?: Maybe<Scalars['uuid']>;
  userBId?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type UserConnectionsMinFields = {
  __typename?: 'UserConnectionsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  removedByUserId?: Maybe<Scalars['uuid']>;
  requestId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userAId?: Maybe<Scalars['uuid']>;
  userBId?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "user_connections" */
export type UserConnectionsMutationResponse = {
  __typename?: 'UserConnectionsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UserConnections>;
};

/** on_conflict condition type for table "user_connections" */
export type UserConnectionsOnConflict = {
  constraint: UserConnectionsConstraint;
  updateColumns?: Array<UserConnectionsUpdateColumn>;
  where?: InputMaybe<UserConnectionsBoolExp>;
};

/** Ordering options when selecting data from "user_connections". */
export type UserConnectionsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  removedByUserId?: InputMaybe<OrderBy>;
  request?: InputMaybe<UserConnectionRequestsOrderBy>;
  requestId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userA?: InputMaybe<UsersOrderBy>;
  userAId?: InputMaybe<OrderBy>;
  userAProfile?: InputMaybe<UserProfilesOrderBy>;
  userB?: InputMaybe<UsersOrderBy>;
  userBId?: InputMaybe<OrderBy>;
  userBProfile?: InputMaybe<UserProfilesOrderBy>;
};

/** primary key columns input for table: user_connections */
export type UserConnectionsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "user_connections" */
export enum UserConnectionsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  RemovedByUserId = 'removedByUserId',
  /** column name */
  RequestId = 'requestId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserAId = 'userAId',
  /** column name */
  UserBId = 'userBId'
}

/** input type for updating data in table "user_connections" */
export type UserConnectionsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  removedByUserId?: InputMaybe<Scalars['uuid']>;
  requestId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userAId?: InputMaybe<Scalars['uuid']>;
  userBId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "user_connections" */
export type UserConnectionsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UserConnectionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserConnectionsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  removedByUserId?: InputMaybe<Scalars['uuid']>;
  requestId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userAId?: InputMaybe<Scalars['uuid']>;
  userBId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "user_connections" */
export enum UserConnectionsUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  RemovedByUserId = 'removedByUserId',
  /** column name */
  RequestId = 'requestId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserAId = 'userAId',
  /** column name */
  UserBId = 'userBId'
}

export type UserConnectionsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserConnectionsSetInput>;
  /** filter the rows which have to be updated */
  where: UserConnectionsBoolExp;
};

/** columns and relationships of "user_content_beta_subscriptions" */
export type UserContentBetaSubscriptions = {
  __typename?: 'UserContentBetaSubscriptions';
  applicationFeeTotalUnitAmount: Scalars['Int'];
  createdAt: Scalars['timestamptz'];
  customerApplicationFeeUnitAmount: Scalars['Int'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  externalStripePaymentIntentId: Scalars['String'];
  id: Scalars['uuid'];
  internalStripePaymentIntentId: Scalars['uuid'];
  orderSubtotalUnitAmount: Scalars['Int'];
  orderTotalUnitAmount: Scalars['Int'];
  /** An object relationship */
  owner: Users;
  /** An object relationship */
  ownerProfile?: Maybe<UserProfiles>;
  ownerUserId: Scalars['uuid'];
  paidUnitAmount: Scalars['Int'];
  /** An object relationship */
  paymentIntentExternal: StripePaymentIntents;
  /** An object relationship */
  paymentIntentInternal: StripePaymentIntents;
  paymentProcessor: PaymentProcessorsEnum;
  refundUnitAmount: Scalars['Int'];
  refundedAt?: Maybe<Scalars['timestamptz']>;
  refundedByPersona?: Maybe<AppPersonasEnum>;
  sellerApplicationFeeUnitAmount: Scalars['Int'];
  status: OrderStatusesEnum;
  stripeCustomerId: Scalars['String'];
  stripeMerchantId: Scalars['String'];
  stripePaymentStatus: Scalars['String'];
  /** An object relationship */
  subscriber: Users;
  subscriberUserId: Scalars['uuid'];
  transferUnitAmount: Scalars['Int'];
  updatedAt: Scalars['timestamptz'];
  userCreditCardId: Scalars['uuid'];
};

/** aggregated selection of "user_content_beta_subscriptions" */
export type UserContentBetaSubscriptionsAggregate = {
  __typename?: 'UserContentBetaSubscriptionsAggregate';
  aggregate?: Maybe<UserContentBetaSubscriptionsAggregateFields>;
  nodes: Array<UserContentBetaSubscriptions>;
};

/** aggregate fields of "user_content_beta_subscriptions" */
export type UserContentBetaSubscriptionsAggregateFields = {
  __typename?: 'UserContentBetaSubscriptionsAggregateFields';
  avg?: Maybe<UserContentBetaSubscriptionsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<UserContentBetaSubscriptionsMaxFields>;
  min?: Maybe<UserContentBetaSubscriptionsMinFields>;
  stddev?: Maybe<UserContentBetaSubscriptionsStddevFields>;
  stddevPop?: Maybe<UserContentBetaSubscriptionsStddevPopFields>;
  stddevSamp?: Maybe<UserContentBetaSubscriptionsStddevSampFields>;
  sum?: Maybe<UserContentBetaSubscriptionsSumFields>;
  varPop?: Maybe<UserContentBetaSubscriptionsVarPopFields>;
  varSamp?: Maybe<UserContentBetaSubscriptionsVarSampFields>;
  variance?: Maybe<UserContentBetaSubscriptionsVarianceFields>;
};


/** aggregate fields of "user_content_beta_subscriptions" */
export type UserContentBetaSubscriptionsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<UserContentBetaSubscriptionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type UserContentBetaSubscriptionsAvgFields = {
  __typename?: 'UserContentBetaSubscriptionsAvgFields';
  applicationFeeTotalUnitAmount?: Maybe<Scalars['Float']>;
  customerApplicationFeeUnitAmount?: Maybe<Scalars['Float']>;
  orderSubtotalUnitAmount?: Maybe<Scalars['Float']>;
  orderTotalUnitAmount?: Maybe<Scalars['Float']>;
  paidUnitAmount?: Maybe<Scalars['Float']>;
  refundUnitAmount?: Maybe<Scalars['Float']>;
  sellerApplicationFeeUnitAmount?: Maybe<Scalars['Float']>;
  transferUnitAmount?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "user_content_beta_subscriptions". All fields are combined with a logical 'AND'. */
export type UserContentBetaSubscriptionsBoolExp = {
  _and?: InputMaybe<Array<UserContentBetaSubscriptionsBoolExp>>;
  _not?: InputMaybe<UserContentBetaSubscriptionsBoolExp>;
  _or?: InputMaybe<Array<UserContentBetaSubscriptionsBoolExp>>;
  applicationFeeTotalUnitAmount?: InputMaybe<IntComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  customerApplicationFeeUnitAmount?: InputMaybe<IntComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  externalStripePaymentIntentId?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  internalStripePaymentIntentId?: InputMaybe<UuidComparisonExp>;
  orderSubtotalUnitAmount?: InputMaybe<IntComparisonExp>;
  orderTotalUnitAmount?: InputMaybe<IntComparisonExp>;
  owner?: InputMaybe<UsersBoolExp>;
  ownerProfile?: InputMaybe<UserProfilesBoolExp>;
  ownerUserId?: InputMaybe<UuidComparisonExp>;
  paidUnitAmount?: InputMaybe<IntComparisonExp>;
  paymentIntentExternal?: InputMaybe<StripePaymentIntentsBoolExp>;
  paymentIntentInternal?: InputMaybe<StripePaymentIntentsBoolExp>;
  paymentProcessor?: InputMaybe<PaymentProcessorsEnumComparisonExp>;
  refundUnitAmount?: InputMaybe<IntComparisonExp>;
  refundedAt?: InputMaybe<TimestamptzComparisonExp>;
  refundedByPersona?: InputMaybe<AppPersonasEnumComparisonExp>;
  sellerApplicationFeeUnitAmount?: InputMaybe<IntComparisonExp>;
  status?: InputMaybe<OrderStatusesEnumComparisonExp>;
  stripeCustomerId?: InputMaybe<StringComparisonExp>;
  stripeMerchantId?: InputMaybe<StringComparisonExp>;
  stripePaymentStatus?: InputMaybe<StringComparisonExp>;
  subscriber?: InputMaybe<UsersBoolExp>;
  subscriberUserId?: InputMaybe<UuidComparisonExp>;
  transferUnitAmount?: InputMaybe<IntComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  userCreditCardId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "user_content_beta_subscriptions" */
export enum UserContentBetaSubscriptionsConstraint {
  /** unique or primary key constraint on columns "external_stripe_payment_intent_id" */
  UserContentBetaSubscriptioExternalStripePaymentIntenKey = 'user_content_beta_subscriptio_external_stripe_payment_inten_key',
  /** unique or primary key constraint on columns "internal_stripe_payment_intent_id" */
  UserContentBetaSubscriptioInternalStripePaymentIntenKey = 'user_content_beta_subscriptio_internal_stripe_payment_inten_key',
  /** unique or primary key constraint on columns "id" */
  UserContentBetaSubscriptionsPkey = 'user_content_beta_subscriptions_pkey'
}

/** input type for incrementing numeric columns in table "user_content_beta_subscriptions" */
export type UserContentBetaSubscriptionsIncInput = {
  applicationFeeTotalUnitAmount?: InputMaybe<Scalars['Int']>;
  customerApplicationFeeUnitAmount?: InputMaybe<Scalars['Int']>;
  orderSubtotalUnitAmount?: InputMaybe<Scalars['Int']>;
  orderTotalUnitAmount?: InputMaybe<Scalars['Int']>;
  paidUnitAmount?: InputMaybe<Scalars['Int']>;
  refundUnitAmount?: InputMaybe<Scalars['Int']>;
  sellerApplicationFeeUnitAmount?: InputMaybe<Scalars['Int']>;
  transferUnitAmount?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "user_content_beta_subscriptions" */
export type UserContentBetaSubscriptionsInsertInput = {
  applicationFeeTotalUnitAmount?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  customerApplicationFeeUnitAmount?: InputMaybe<Scalars['Int']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  externalStripePaymentIntentId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  internalStripePaymentIntentId?: InputMaybe<Scalars['uuid']>;
  orderSubtotalUnitAmount?: InputMaybe<Scalars['Int']>;
  orderTotalUnitAmount?: InputMaybe<Scalars['Int']>;
  owner?: InputMaybe<UsersObjRelInsertInput>;
  ownerProfile?: InputMaybe<UserProfilesObjRelInsertInput>;
  ownerUserId?: InputMaybe<Scalars['uuid']>;
  paidUnitAmount?: InputMaybe<Scalars['Int']>;
  paymentIntentExternal?: InputMaybe<StripePaymentIntentsObjRelInsertInput>;
  paymentIntentInternal?: InputMaybe<StripePaymentIntentsObjRelInsertInput>;
  paymentProcessor?: InputMaybe<PaymentProcessorsEnum>;
  refundUnitAmount?: InputMaybe<Scalars['Int']>;
  refundedAt?: InputMaybe<Scalars['timestamptz']>;
  refundedByPersona?: InputMaybe<AppPersonasEnum>;
  sellerApplicationFeeUnitAmount?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<OrderStatusesEnum>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  stripeMerchantId?: InputMaybe<Scalars['String']>;
  stripePaymentStatus?: InputMaybe<Scalars['String']>;
  subscriber?: InputMaybe<UsersObjRelInsertInput>;
  subscriberUserId?: InputMaybe<Scalars['uuid']>;
  transferUnitAmount?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userCreditCardId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type UserContentBetaSubscriptionsMaxFields = {
  __typename?: 'UserContentBetaSubscriptionsMaxFields';
  applicationFeeTotalUnitAmount?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  customerApplicationFeeUnitAmount?: Maybe<Scalars['Int']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  externalStripePaymentIntentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  internalStripePaymentIntentId?: Maybe<Scalars['uuid']>;
  orderSubtotalUnitAmount?: Maybe<Scalars['Int']>;
  orderTotalUnitAmount?: Maybe<Scalars['Int']>;
  ownerUserId?: Maybe<Scalars['uuid']>;
  paidUnitAmount?: Maybe<Scalars['Int']>;
  refundUnitAmount?: Maybe<Scalars['Int']>;
  refundedAt?: Maybe<Scalars['timestamptz']>;
  sellerApplicationFeeUnitAmount?: Maybe<Scalars['Int']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripeMerchantId?: Maybe<Scalars['String']>;
  stripePaymentStatus?: Maybe<Scalars['String']>;
  subscriberUserId?: Maybe<Scalars['uuid']>;
  transferUnitAmount?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userCreditCardId?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type UserContentBetaSubscriptionsMinFields = {
  __typename?: 'UserContentBetaSubscriptionsMinFields';
  applicationFeeTotalUnitAmount?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  customerApplicationFeeUnitAmount?: Maybe<Scalars['Int']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  externalStripePaymentIntentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  internalStripePaymentIntentId?: Maybe<Scalars['uuid']>;
  orderSubtotalUnitAmount?: Maybe<Scalars['Int']>;
  orderTotalUnitAmount?: Maybe<Scalars['Int']>;
  ownerUserId?: Maybe<Scalars['uuid']>;
  paidUnitAmount?: Maybe<Scalars['Int']>;
  refundUnitAmount?: Maybe<Scalars['Int']>;
  refundedAt?: Maybe<Scalars['timestamptz']>;
  sellerApplicationFeeUnitAmount?: Maybe<Scalars['Int']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripeMerchantId?: Maybe<Scalars['String']>;
  stripePaymentStatus?: Maybe<Scalars['String']>;
  subscriberUserId?: Maybe<Scalars['uuid']>;
  transferUnitAmount?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userCreditCardId?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "user_content_beta_subscriptions" */
export type UserContentBetaSubscriptionsMutationResponse = {
  __typename?: 'UserContentBetaSubscriptionsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UserContentBetaSubscriptions>;
};

/** on_conflict condition type for table "user_content_beta_subscriptions" */
export type UserContentBetaSubscriptionsOnConflict = {
  constraint: UserContentBetaSubscriptionsConstraint;
  updateColumns?: Array<UserContentBetaSubscriptionsUpdateColumn>;
  where?: InputMaybe<UserContentBetaSubscriptionsBoolExp>;
};

/** Ordering options when selecting data from "user_content_beta_subscriptions". */
export type UserContentBetaSubscriptionsOrderBy = {
  applicationFeeTotalUnitAmount?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  customerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  externalStripePaymentIntentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  internalStripePaymentIntentId?: InputMaybe<OrderBy>;
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  owner?: InputMaybe<UsersOrderBy>;
  ownerProfile?: InputMaybe<UserProfilesOrderBy>;
  ownerUserId?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  paymentIntentExternal?: InputMaybe<StripePaymentIntentsOrderBy>;
  paymentIntentInternal?: InputMaybe<StripePaymentIntentsOrderBy>;
  paymentProcessor?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  refundedAt?: InputMaybe<OrderBy>;
  refundedByPersona?: InputMaybe<OrderBy>;
  sellerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  stripeCustomerId?: InputMaybe<OrderBy>;
  stripeMerchantId?: InputMaybe<OrderBy>;
  stripePaymentStatus?: InputMaybe<OrderBy>;
  subscriber?: InputMaybe<UsersOrderBy>;
  subscriberUserId?: InputMaybe<OrderBy>;
  transferUnitAmount?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userCreditCardId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: user_content_beta_subscriptions */
export type UserContentBetaSubscriptionsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "user_content_beta_subscriptions" */
export enum UserContentBetaSubscriptionsSelectColumn {
  /** column name */
  ApplicationFeeTotalUnitAmount = 'applicationFeeTotalUnitAmount',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CustomerApplicationFeeUnitAmount = 'customerApplicationFeeUnitAmount',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  ExternalStripePaymentIntentId = 'externalStripePaymentIntentId',
  /** column name */
  Id = 'id',
  /** column name */
  InternalStripePaymentIntentId = 'internalStripePaymentIntentId',
  /** column name */
  OrderSubtotalUnitAmount = 'orderSubtotalUnitAmount',
  /** column name */
  OrderTotalUnitAmount = 'orderTotalUnitAmount',
  /** column name */
  OwnerUserId = 'ownerUserId',
  /** column name */
  PaidUnitAmount = 'paidUnitAmount',
  /** column name */
  PaymentProcessor = 'paymentProcessor',
  /** column name */
  RefundUnitAmount = 'refundUnitAmount',
  /** column name */
  RefundedAt = 'refundedAt',
  /** column name */
  RefundedByPersona = 'refundedByPersona',
  /** column name */
  SellerApplicationFeeUnitAmount = 'sellerApplicationFeeUnitAmount',
  /** column name */
  Status = 'status',
  /** column name */
  StripeCustomerId = 'stripeCustomerId',
  /** column name */
  StripeMerchantId = 'stripeMerchantId',
  /** column name */
  StripePaymentStatus = 'stripePaymentStatus',
  /** column name */
  SubscriberUserId = 'subscriberUserId',
  /** column name */
  TransferUnitAmount = 'transferUnitAmount',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserCreditCardId = 'userCreditCardId'
}

/** input type for updating data in table "user_content_beta_subscriptions" */
export type UserContentBetaSubscriptionsSetInput = {
  applicationFeeTotalUnitAmount?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  customerApplicationFeeUnitAmount?: InputMaybe<Scalars['Int']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  externalStripePaymentIntentId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  internalStripePaymentIntentId?: InputMaybe<Scalars['uuid']>;
  orderSubtotalUnitAmount?: InputMaybe<Scalars['Int']>;
  orderTotalUnitAmount?: InputMaybe<Scalars['Int']>;
  ownerUserId?: InputMaybe<Scalars['uuid']>;
  paidUnitAmount?: InputMaybe<Scalars['Int']>;
  paymentProcessor?: InputMaybe<PaymentProcessorsEnum>;
  refundUnitAmount?: InputMaybe<Scalars['Int']>;
  refundedAt?: InputMaybe<Scalars['timestamptz']>;
  refundedByPersona?: InputMaybe<AppPersonasEnum>;
  sellerApplicationFeeUnitAmount?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<OrderStatusesEnum>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  stripeMerchantId?: InputMaybe<Scalars['String']>;
  stripePaymentStatus?: InputMaybe<Scalars['String']>;
  subscriberUserId?: InputMaybe<Scalars['uuid']>;
  transferUnitAmount?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userCreditCardId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type UserContentBetaSubscriptionsStddevFields = {
  __typename?: 'UserContentBetaSubscriptionsStddevFields';
  applicationFeeTotalUnitAmount?: Maybe<Scalars['Float']>;
  customerApplicationFeeUnitAmount?: Maybe<Scalars['Float']>;
  orderSubtotalUnitAmount?: Maybe<Scalars['Float']>;
  orderTotalUnitAmount?: Maybe<Scalars['Float']>;
  paidUnitAmount?: Maybe<Scalars['Float']>;
  refundUnitAmount?: Maybe<Scalars['Float']>;
  sellerApplicationFeeUnitAmount?: Maybe<Scalars['Float']>;
  transferUnitAmount?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type UserContentBetaSubscriptionsStddevPopFields = {
  __typename?: 'UserContentBetaSubscriptionsStddevPopFields';
  applicationFeeTotalUnitAmount?: Maybe<Scalars['Float']>;
  customerApplicationFeeUnitAmount?: Maybe<Scalars['Float']>;
  orderSubtotalUnitAmount?: Maybe<Scalars['Float']>;
  orderTotalUnitAmount?: Maybe<Scalars['Float']>;
  paidUnitAmount?: Maybe<Scalars['Float']>;
  refundUnitAmount?: Maybe<Scalars['Float']>;
  sellerApplicationFeeUnitAmount?: Maybe<Scalars['Float']>;
  transferUnitAmount?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type UserContentBetaSubscriptionsStddevSampFields = {
  __typename?: 'UserContentBetaSubscriptionsStddevSampFields';
  applicationFeeTotalUnitAmount?: Maybe<Scalars['Float']>;
  customerApplicationFeeUnitAmount?: Maybe<Scalars['Float']>;
  orderSubtotalUnitAmount?: Maybe<Scalars['Float']>;
  orderTotalUnitAmount?: Maybe<Scalars['Float']>;
  paidUnitAmount?: Maybe<Scalars['Float']>;
  refundUnitAmount?: Maybe<Scalars['Float']>;
  sellerApplicationFeeUnitAmount?: Maybe<Scalars['Float']>;
  transferUnitAmount?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "user_content_beta_subscriptions" */
export type UserContentBetaSubscriptionsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UserContentBetaSubscriptionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserContentBetaSubscriptionsStreamCursorValueInput = {
  applicationFeeTotalUnitAmount?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  customerApplicationFeeUnitAmount?: InputMaybe<Scalars['Int']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  externalStripePaymentIntentId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  internalStripePaymentIntentId?: InputMaybe<Scalars['uuid']>;
  orderSubtotalUnitAmount?: InputMaybe<Scalars['Int']>;
  orderTotalUnitAmount?: InputMaybe<Scalars['Int']>;
  ownerUserId?: InputMaybe<Scalars['uuid']>;
  paidUnitAmount?: InputMaybe<Scalars['Int']>;
  paymentProcessor?: InputMaybe<PaymentProcessorsEnum>;
  refundUnitAmount?: InputMaybe<Scalars['Int']>;
  refundedAt?: InputMaybe<Scalars['timestamptz']>;
  refundedByPersona?: InputMaybe<AppPersonasEnum>;
  sellerApplicationFeeUnitAmount?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<OrderStatusesEnum>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  stripeMerchantId?: InputMaybe<Scalars['String']>;
  stripePaymentStatus?: InputMaybe<Scalars['String']>;
  subscriberUserId?: InputMaybe<Scalars['uuid']>;
  transferUnitAmount?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userCreditCardId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type UserContentBetaSubscriptionsSumFields = {
  __typename?: 'UserContentBetaSubscriptionsSumFields';
  applicationFeeTotalUnitAmount?: Maybe<Scalars['Int']>;
  customerApplicationFeeUnitAmount?: Maybe<Scalars['Int']>;
  orderSubtotalUnitAmount?: Maybe<Scalars['Int']>;
  orderTotalUnitAmount?: Maybe<Scalars['Int']>;
  paidUnitAmount?: Maybe<Scalars['Int']>;
  refundUnitAmount?: Maybe<Scalars['Int']>;
  sellerApplicationFeeUnitAmount?: Maybe<Scalars['Int']>;
  transferUnitAmount?: Maybe<Scalars['Int']>;
};

/** update columns of table "user_content_beta_subscriptions" */
export enum UserContentBetaSubscriptionsUpdateColumn {
  /** column name */
  ApplicationFeeTotalUnitAmount = 'applicationFeeTotalUnitAmount',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CustomerApplicationFeeUnitAmount = 'customerApplicationFeeUnitAmount',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  ExternalStripePaymentIntentId = 'externalStripePaymentIntentId',
  /** column name */
  Id = 'id',
  /** column name */
  InternalStripePaymentIntentId = 'internalStripePaymentIntentId',
  /** column name */
  OrderSubtotalUnitAmount = 'orderSubtotalUnitAmount',
  /** column name */
  OrderTotalUnitAmount = 'orderTotalUnitAmount',
  /** column name */
  OwnerUserId = 'ownerUserId',
  /** column name */
  PaidUnitAmount = 'paidUnitAmount',
  /** column name */
  PaymentProcessor = 'paymentProcessor',
  /** column name */
  RefundUnitAmount = 'refundUnitAmount',
  /** column name */
  RefundedAt = 'refundedAt',
  /** column name */
  RefundedByPersona = 'refundedByPersona',
  /** column name */
  SellerApplicationFeeUnitAmount = 'sellerApplicationFeeUnitAmount',
  /** column name */
  Status = 'status',
  /** column name */
  StripeCustomerId = 'stripeCustomerId',
  /** column name */
  StripeMerchantId = 'stripeMerchantId',
  /** column name */
  StripePaymentStatus = 'stripePaymentStatus',
  /** column name */
  SubscriberUserId = 'subscriberUserId',
  /** column name */
  TransferUnitAmount = 'transferUnitAmount',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserCreditCardId = 'userCreditCardId'
}

export type UserContentBetaSubscriptionsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<UserContentBetaSubscriptionsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserContentBetaSubscriptionsSetInput>;
  /** filter the rows which have to be updated */
  where: UserContentBetaSubscriptionsBoolExp;
};

/** aggregate varPop on columns */
export type UserContentBetaSubscriptionsVarPopFields = {
  __typename?: 'UserContentBetaSubscriptionsVarPopFields';
  applicationFeeTotalUnitAmount?: Maybe<Scalars['Float']>;
  customerApplicationFeeUnitAmount?: Maybe<Scalars['Float']>;
  orderSubtotalUnitAmount?: Maybe<Scalars['Float']>;
  orderTotalUnitAmount?: Maybe<Scalars['Float']>;
  paidUnitAmount?: Maybe<Scalars['Float']>;
  refundUnitAmount?: Maybe<Scalars['Float']>;
  sellerApplicationFeeUnitAmount?: Maybe<Scalars['Float']>;
  transferUnitAmount?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type UserContentBetaSubscriptionsVarSampFields = {
  __typename?: 'UserContentBetaSubscriptionsVarSampFields';
  applicationFeeTotalUnitAmount?: Maybe<Scalars['Float']>;
  customerApplicationFeeUnitAmount?: Maybe<Scalars['Float']>;
  orderSubtotalUnitAmount?: Maybe<Scalars['Float']>;
  orderTotalUnitAmount?: Maybe<Scalars['Float']>;
  paidUnitAmount?: Maybe<Scalars['Float']>;
  refundUnitAmount?: Maybe<Scalars['Float']>;
  sellerApplicationFeeUnitAmount?: Maybe<Scalars['Float']>;
  transferUnitAmount?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type UserContentBetaSubscriptionsVarianceFields = {
  __typename?: 'UserContentBetaSubscriptionsVarianceFields';
  applicationFeeTotalUnitAmount?: Maybe<Scalars['Float']>;
  customerApplicationFeeUnitAmount?: Maybe<Scalars['Float']>;
  orderSubtotalUnitAmount?: Maybe<Scalars['Float']>;
  orderTotalUnitAmount?: Maybe<Scalars['Float']>;
  paidUnitAmount?: Maybe<Scalars['Float']>;
  refundUnitAmount?: Maybe<Scalars['Float']>;
  sellerApplicationFeeUnitAmount?: Maybe<Scalars['Float']>;
  transferUnitAmount?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "user_content_files" */
export type UserContentFiles = {
  __typename?: 'UserContentFiles';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  description: Scalars['String'];
  fileCategory: FileCategoryEnum;
  fileFormat: FileFormatEnum;
  fileName: Scalars['String'];
  fileType: Scalars['String'];
  host: Scalars['String'];
  id: Scalars['uuid'];
  originalFileName?: Maybe<Scalars['String']>;
  provider: Scalars['String'];
  providerId: Scalars['String'];
  providerUrl: Scalars['String'];
  tier: UserContentTiersEnum;
  title: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  url: Scalars['String'];
  /** An object relationship */
  user?: Maybe<UserProfiles>;
  /** An array relationship */
  userContentFilesSkills: Array<UserContentFilesSkills>;
  /** An aggregate relationship */
  userContentFilesSkillsAggregate: UserContentFilesSkillsAggregate;
  userId: Scalars['uuid'];
};


/** columns and relationships of "user_content_files" */
export type UserContentFilesUserContentFilesSkillsArgs = {
  distinctOn?: InputMaybe<Array<UserContentFilesSkillsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserContentFilesSkillsOrderBy>>;
  where?: InputMaybe<UserContentFilesSkillsBoolExp>;
};


/** columns and relationships of "user_content_files" */
export type UserContentFilesUserContentFilesSkillsAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserContentFilesSkillsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserContentFilesSkillsOrderBy>>;
  where?: InputMaybe<UserContentFilesSkillsBoolExp>;
};

/** aggregated selection of "user_content_files" */
export type UserContentFilesAggregate = {
  __typename?: 'UserContentFilesAggregate';
  aggregate?: Maybe<UserContentFilesAggregateFields>;
  nodes: Array<UserContentFiles>;
};

/** aggregate fields of "user_content_files" */
export type UserContentFilesAggregateFields = {
  __typename?: 'UserContentFilesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<UserContentFilesMaxFields>;
  min?: Maybe<UserContentFilesMinFields>;
};


/** aggregate fields of "user_content_files" */
export type UserContentFilesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<UserContentFilesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "user_content_files". All fields are combined with a logical 'AND'. */
export type UserContentFilesBoolExp = {
  _and?: InputMaybe<Array<UserContentFilesBoolExp>>;
  _not?: InputMaybe<UserContentFilesBoolExp>;
  _or?: InputMaybe<Array<UserContentFilesBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  fileCategory?: InputMaybe<FileCategoryEnumComparisonExp>;
  fileFormat?: InputMaybe<FileFormatEnumComparisonExp>;
  fileName?: InputMaybe<StringComparisonExp>;
  fileType?: InputMaybe<StringComparisonExp>;
  host?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  originalFileName?: InputMaybe<StringComparisonExp>;
  provider?: InputMaybe<StringComparisonExp>;
  providerId?: InputMaybe<StringComparisonExp>;
  providerUrl?: InputMaybe<StringComparisonExp>;
  tier?: InputMaybe<UserContentTiersEnumComparisonExp>;
  title?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  url?: InputMaybe<StringComparisonExp>;
  user?: InputMaybe<UserProfilesBoolExp>;
  userContentFilesSkills?: InputMaybe<UserContentFilesSkillsBoolExp>;
  userContentFilesSkillsAggregate?: InputMaybe<UserContentFilesSkillsAggregateBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "user_content_files" */
export enum UserContentFilesConstraint {
  /** unique or primary key constraint on columns "id" */
  UserContentFilesPkey = 'user_content_files_pkey'
}

/** input type for inserting data into table "user_content_files" */
export type UserContentFilesInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  fileCategory?: InputMaybe<FileCategoryEnum>;
  fileFormat?: InputMaybe<FileFormatEnum>;
  fileName?: InputMaybe<Scalars['String']>;
  fileType?: InputMaybe<Scalars['String']>;
  host?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  originalFileName?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  providerId?: InputMaybe<Scalars['String']>;
  providerUrl?: InputMaybe<Scalars['String']>;
  tier?: InputMaybe<UserContentTiersEnum>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  url?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<UserProfilesObjRelInsertInput>;
  userContentFilesSkills?: InputMaybe<UserContentFilesSkillsArrRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type UserContentFilesMaxFields = {
  __typename?: 'UserContentFilesMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  fileType?: Maybe<Scalars['String']>;
  host?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  originalFileName?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  providerId?: Maybe<Scalars['String']>;
  providerUrl?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  url?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type UserContentFilesMinFields = {
  __typename?: 'UserContentFilesMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  fileType?: Maybe<Scalars['String']>;
  host?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  originalFileName?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  providerId?: Maybe<Scalars['String']>;
  providerUrl?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  url?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "user_content_files" */
export type UserContentFilesMutationResponse = {
  __typename?: 'UserContentFilesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UserContentFiles>;
};

/** input type for inserting object relation for remote table "user_content_files" */
export type UserContentFilesObjRelInsertInput = {
  data: UserContentFilesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<UserContentFilesOnConflict>;
};

/** on_conflict condition type for table "user_content_files" */
export type UserContentFilesOnConflict = {
  constraint: UserContentFilesConstraint;
  updateColumns?: Array<UserContentFilesUpdateColumn>;
  where?: InputMaybe<UserContentFilesBoolExp>;
};

/** Ordering options when selecting data from "user_content_files". */
export type UserContentFilesOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  fileCategory?: InputMaybe<OrderBy>;
  fileFormat?: InputMaybe<OrderBy>;
  fileName?: InputMaybe<OrderBy>;
  fileType?: InputMaybe<OrderBy>;
  host?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  originalFileName?: InputMaybe<OrderBy>;
  provider?: InputMaybe<OrderBy>;
  providerId?: InputMaybe<OrderBy>;
  providerUrl?: InputMaybe<OrderBy>;
  tier?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  url?: InputMaybe<OrderBy>;
  user?: InputMaybe<UserProfilesOrderBy>;
  userContentFilesSkillsAggregate?: InputMaybe<UserContentFilesSkillsAggregateOrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: user_content_files */
export type UserContentFilesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "user_content_files" */
export enum UserContentFilesSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Description = 'description',
  /** column name */
  FileCategory = 'fileCategory',
  /** column name */
  FileFormat = 'fileFormat',
  /** column name */
  FileName = 'fileName',
  /** column name */
  FileType = 'fileType',
  /** column name */
  Host = 'host',
  /** column name */
  Id = 'id',
  /** column name */
  OriginalFileName = 'originalFileName',
  /** column name */
  Provider = 'provider',
  /** column name */
  ProviderId = 'providerId',
  /** column name */
  ProviderUrl = 'providerUrl',
  /** column name */
  Tier = 'tier',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Url = 'url',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "user_content_files" */
export type UserContentFilesSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  fileCategory?: InputMaybe<FileCategoryEnum>;
  fileFormat?: InputMaybe<FileFormatEnum>;
  fileName?: InputMaybe<Scalars['String']>;
  fileType?: InputMaybe<Scalars['String']>;
  host?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  originalFileName?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  providerId?: InputMaybe<Scalars['String']>;
  providerUrl?: InputMaybe<Scalars['String']>;
  tier?: InputMaybe<UserContentTiersEnum>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  url?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** columns and relationships of "user_content_files_skills" */
export type UserContentFilesSkills = {
  __typename?: 'UserContentFilesSkills';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
  userContentFileId: Scalars['uuid'];
  /** An object relationship */
  userContentFiles: UserContentFiles;
  userContentSkillId: Scalars['uuid'];
  /** An object relationship */
  userContentSkills: UserContentSkills;
};

/** aggregated selection of "user_content_files_skills" */
export type UserContentFilesSkillsAggregate = {
  __typename?: 'UserContentFilesSkillsAggregate';
  aggregate?: Maybe<UserContentFilesSkillsAggregateFields>;
  nodes: Array<UserContentFilesSkills>;
};

export type UserContentFilesSkillsAggregateBoolExp = {
  count?: InputMaybe<UserContentFilesSkillsAggregateBoolExpCount>;
};

/** aggregate fields of "user_content_files_skills" */
export type UserContentFilesSkillsAggregateFields = {
  __typename?: 'UserContentFilesSkillsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<UserContentFilesSkillsMaxFields>;
  min?: Maybe<UserContentFilesSkillsMinFields>;
};


/** aggregate fields of "user_content_files_skills" */
export type UserContentFilesSkillsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<UserContentFilesSkillsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_content_files_skills" */
export type UserContentFilesSkillsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<UserContentFilesSkillsMaxOrderBy>;
  min?: InputMaybe<UserContentFilesSkillsMinOrderBy>;
};

/** input type for inserting array relation for remote table "user_content_files_skills" */
export type UserContentFilesSkillsArrRelInsertInput = {
  data: Array<UserContentFilesSkillsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<UserContentFilesSkillsOnConflict>;
};

/** Boolean expression to filter rows from the table "user_content_files_skills". All fields are combined with a logical 'AND'. */
export type UserContentFilesSkillsBoolExp = {
  _and?: InputMaybe<Array<UserContentFilesSkillsBoolExp>>;
  _not?: InputMaybe<UserContentFilesSkillsBoolExp>;
  _or?: InputMaybe<Array<UserContentFilesSkillsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  userContentFileId?: InputMaybe<UuidComparisonExp>;
  userContentFiles?: InputMaybe<UserContentFilesBoolExp>;
  userContentSkillId?: InputMaybe<UuidComparisonExp>;
  userContentSkills?: InputMaybe<UserContentSkillsBoolExp>;
};

/** unique or primary key constraints on table "user_content_files_skills" */
export enum UserContentFilesSkillsConstraint {
  /** unique or primary key constraint on columns "id" */
  UserContentFilesSkillsPkey = 'user_content_files_skills_pkey'
}

/** input type for inserting data into table "user_content_files_skills" */
export type UserContentFilesSkillsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userContentFileId?: InputMaybe<Scalars['uuid']>;
  userContentFiles?: InputMaybe<UserContentFilesObjRelInsertInput>;
  userContentSkillId?: InputMaybe<Scalars['uuid']>;
  userContentSkills?: InputMaybe<UserContentSkillsObjRelInsertInput>;
};

/** aggregate max on columns */
export type UserContentFilesSkillsMaxFields = {
  __typename?: 'UserContentFilesSkillsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userContentFileId?: Maybe<Scalars['uuid']>;
  userContentSkillId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "user_content_files_skills" */
export type UserContentFilesSkillsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userContentFileId?: InputMaybe<OrderBy>;
  userContentSkillId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type UserContentFilesSkillsMinFields = {
  __typename?: 'UserContentFilesSkillsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userContentFileId?: Maybe<Scalars['uuid']>;
  userContentSkillId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "user_content_files_skills" */
export type UserContentFilesSkillsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userContentFileId?: InputMaybe<OrderBy>;
  userContentSkillId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "user_content_files_skills" */
export type UserContentFilesSkillsMutationResponse = {
  __typename?: 'UserContentFilesSkillsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UserContentFilesSkills>;
};

/** on_conflict condition type for table "user_content_files_skills" */
export type UserContentFilesSkillsOnConflict = {
  constraint: UserContentFilesSkillsConstraint;
  updateColumns?: Array<UserContentFilesSkillsUpdateColumn>;
  where?: InputMaybe<UserContentFilesSkillsBoolExp>;
};

/** Ordering options when selecting data from "user_content_files_skills". */
export type UserContentFilesSkillsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userContentFileId?: InputMaybe<OrderBy>;
  userContentFiles?: InputMaybe<UserContentFilesOrderBy>;
  userContentSkillId?: InputMaybe<OrderBy>;
  userContentSkills?: InputMaybe<UserContentSkillsOrderBy>;
};

/** primary key columns input for table: user_content_files_skills */
export type UserContentFilesSkillsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "user_content_files_skills" */
export enum UserContentFilesSkillsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserContentFileId = 'userContentFileId',
  /** column name */
  UserContentSkillId = 'userContentSkillId'
}

/** input type for updating data in table "user_content_files_skills" */
export type UserContentFilesSkillsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userContentFileId?: InputMaybe<Scalars['uuid']>;
  userContentSkillId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "user_content_files_skills" */
export type UserContentFilesSkillsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UserContentFilesSkillsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserContentFilesSkillsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userContentFileId?: InputMaybe<Scalars['uuid']>;
  userContentSkillId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "user_content_files_skills" */
export enum UserContentFilesSkillsUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserContentFileId = 'userContentFileId',
  /** column name */
  UserContentSkillId = 'userContentSkillId'
}

export type UserContentFilesSkillsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserContentFilesSkillsSetInput>;
  /** filter the rows which have to be updated */
  where: UserContentFilesSkillsBoolExp;
};

/** Streaming cursor of the table "user_content_files" */
export type UserContentFilesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UserContentFilesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserContentFilesStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  fileCategory?: InputMaybe<FileCategoryEnum>;
  fileFormat?: InputMaybe<FileFormatEnum>;
  fileName?: InputMaybe<Scalars['String']>;
  fileType?: InputMaybe<Scalars['String']>;
  host?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  originalFileName?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  providerId?: InputMaybe<Scalars['String']>;
  providerUrl?: InputMaybe<Scalars['String']>;
  tier?: InputMaybe<UserContentTiersEnum>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  url?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "user_content_files" */
export enum UserContentFilesUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Description = 'description',
  /** column name */
  FileCategory = 'fileCategory',
  /** column name */
  FileFormat = 'fileFormat',
  /** column name */
  FileName = 'fileName',
  /** column name */
  FileType = 'fileType',
  /** column name */
  Host = 'host',
  /** column name */
  Id = 'id',
  /** column name */
  OriginalFileName = 'originalFileName',
  /** column name */
  Provider = 'provider',
  /** column name */
  ProviderId = 'providerId',
  /** column name */
  ProviderUrl = 'providerUrl',
  /** column name */
  Tier = 'tier',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Url = 'url',
  /** column name */
  UserId = 'userId'
}

export type UserContentFilesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserContentFilesSetInput>;
  /** filter the rows which have to be updated */
  where: UserContentFilesBoolExp;
};

/** columns and relationships of "user_content_skills" */
export type UserContentSkills = {
  __typename?: 'UserContentSkills';
  createdAt: Scalars['timestamptz'];
  customSkill?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  skill?: Maybe<LessonSkillsEnum>;
  updatedAt: Scalars['timestamptz'];
  userId: Scalars['uuid'];
};

/** aggregated selection of "user_content_skills" */
export type UserContentSkillsAggregate = {
  __typename?: 'UserContentSkillsAggregate';
  aggregate?: Maybe<UserContentSkillsAggregateFields>;
  nodes: Array<UserContentSkills>;
};

/** aggregate fields of "user_content_skills" */
export type UserContentSkillsAggregateFields = {
  __typename?: 'UserContentSkillsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<UserContentSkillsMaxFields>;
  min?: Maybe<UserContentSkillsMinFields>;
};


/** aggregate fields of "user_content_skills" */
export type UserContentSkillsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<UserContentSkillsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "user_content_skills". All fields are combined with a logical 'AND'. */
export type UserContentSkillsBoolExp = {
  _and?: InputMaybe<Array<UserContentSkillsBoolExp>>;
  _not?: InputMaybe<UserContentSkillsBoolExp>;
  _or?: InputMaybe<Array<UserContentSkillsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  customSkill?: InputMaybe<StringComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  skill?: InputMaybe<LessonSkillsEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "user_content_skills" */
export enum UserContentSkillsConstraint {
  /** unique or primary key constraint on columns "id" */
  UserContentSkillsPkey = 'user_content_skills_pkey'
}

/** input type for inserting data into table "user_content_skills" */
export type UserContentSkillsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  customSkill?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  skill?: InputMaybe<LessonSkillsEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type UserContentSkillsMaxFields = {
  __typename?: 'UserContentSkillsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  customSkill?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type UserContentSkillsMinFields = {
  __typename?: 'UserContentSkillsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  customSkill?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "user_content_skills" */
export type UserContentSkillsMutationResponse = {
  __typename?: 'UserContentSkillsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UserContentSkills>;
};

/** input type for inserting object relation for remote table "user_content_skills" */
export type UserContentSkillsObjRelInsertInput = {
  data: UserContentSkillsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<UserContentSkillsOnConflict>;
};

/** on_conflict condition type for table "user_content_skills" */
export type UserContentSkillsOnConflict = {
  constraint: UserContentSkillsConstraint;
  updateColumns?: Array<UserContentSkillsUpdateColumn>;
  where?: InputMaybe<UserContentSkillsBoolExp>;
};

/** Ordering options when selecting data from "user_content_skills". */
export type UserContentSkillsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  customSkill?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  skill?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: user_content_skills */
export type UserContentSkillsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "user_content_skills" */
export enum UserContentSkillsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CustomSkill = 'customSkill',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  Skill = 'skill',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "user_content_skills" */
export type UserContentSkillsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  customSkill?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  skill?: InputMaybe<LessonSkillsEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "user_content_skills" */
export type UserContentSkillsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UserContentSkillsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserContentSkillsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  customSkill?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  skill?: InputMaybe<LessonSkillsEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "user_content_skills" */
export enum UserContentSkillsUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CustomSkill = 'customSkill',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  Skill = 'skill',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

export type UserContentSkillsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserContentSkillsSetInput>;
  /** filter the rows which have to be updated */
  where: UserContentSkillsBoolExp;
};

/** columns and relationships of "user_content_tiers" */
export type UserContentTiers = {
  __typename?: 'UserContentTiers';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "user_content_tiers" */
export type UserContentTiersAggregate = {
  __typename?: 'UserContentTiersAggregate';
  aggregate?: Maybe<UserContentTiersAggregateFields>;
  nodes: Array<UserContentTiers>;
};

/** aggregate fields of "user_content_tiers" */
export type UserContentTiersAggregateFields = {
  __typename?: 'UserContentTiersAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<UserContentTiersMaxFields>;
  min?: Maybe<UserContentTiersMinFields>;
};


/** aggregate fields of "user_content_tiers" */
export type UserContentTiersAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<UserContentTiersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "user_content_tiers". All fields are combined with a logical 'AND'. */
export type UserContentTiersBoolExp = {
  _and?: InputMaybe<Array<UserContentTiersBoolExp>>;
  _not?: InputMaybe<UserContentTiersBoolExp>;
  _or?: InputMaybe<Array<UserContentTiersBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "user_content_tiers" */
export enum UserContentTiersConstraint {
  /** unique or primary key constraint on columns "value" */
  UserContentTiersPkey = 'user_content_tiers_pkey'
}

export enum UserContentTiersEnum {
  Free = 'FREE',
  Premium = 'PREMIUM'
}

/** Boolean expression to compare columns of type "UserContentTiersEnum". All fields are combined with logical 'AND'. */
export type UserContentTiersEnumComparisonExp = {
  _eq?: InputMaybe<UserContentTiersEnum>;
  _in?: InputMaybe<Array<UserContentTiersEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<UserContentTiersEnum>;
  _nin?: InputMaybe<Array<UserContentTiersEnum>>;
};

/** input type for inserting data into table "user_content_tiers" */
export type UserContentTiersInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type UserContentTiersMaxFields = {
  __typename?: 'UserContentTiersMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type UserContentTiersMinFields = {
  __typename?: 'UserContentTiersMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "user_content_tiers" */
export type UserContentTiersMutationResponse = {
  __typename?: 'UserContentTiersMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UserContentTiers>;
};

/** on_conflict condition type for table "user_content_tiers" */
export type UserContentTiersOnConflict = {
  constraint: UserContentTiersConstraint;
  updateColumns?: Array<UserContentTiersUpdateColumn>;
  where?: InputMaybe<UserContentTiersBoolExp>;
};

/** Ordering options when selecting data from "user_content_tiers". */
export type UserContentTiersOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: user_content_tiers */
export type UserContentTiersPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "user_content_tiers" */
export enum UserContentTiersSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "user_content_tiers" */
export type UserContentTiersSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "user_content_tiers" */
export type UserContentTiersStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UserContentTiersStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserContentTiersStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "user_content_tiers" */
export enum UserContentTiersUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type UserContentTiersUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserContentTiersSetInput>;
  /** filter the rows which have to be updated */
  where: UserContentTiersBoolExp;
};

/** columns and relationships of "user_credit_cards" */
export type UserCreditCards = {
  __typename?: 'UserCreditCards';
  archivedAt?: Maybe<Scalars['timestamptz']>;
  billingCity?: Maybe<Scalars['String']>;
  billingCountry?: Maybe<Scalars['String']>;
  billingEmail?: Maybe<Scalars['String']>;
  billingLine1?: Maybe<Scalars['String']>;
  billingLine2?: Maybe<Scalars['String']>;
  billingName?: Maybe<Scalars['String']>;
  billingPhone?: Maybe<Scalars['String']>;
  billingPostalCode?: Maybe<Scalars['String']>;
  billingState?: Maybe<Scalars['String']>;
  brand: Scalars['String'];
  country: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  expireMonth: Scalars['Int'];
  expireYear: Scalars['Int'];
  fingerprint: Scalars['String'];
  funding: Scalars['String'];
  id: Scalars['uuid'];
  last4: Scalars['String'];
  provider: Scalars['String'];
  providerCardId: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid'];
};

/** aggregated selection of "user_credit_cards" */
export type UserCreditCardsAggregate = {
  __typename?: 'UserCreditCardsAggregate';
  aggregate?: Maybe<UserCreditCardsAggregateFields>;
  nodes: Array<UserCreditCards>;
};

export type UserCreditCardsAggregateBoolExp = {
  count?: InputMaybe<UserCreditCardsAggregateBoolExpCount>;
};

/** aggregate fields of "user_credit_cards" */
export type UserCreditCardsAggregateFields = {
  __typename?: 'UserCreditCardsAggregateFields';
  avg?: Maybe<UserCreditCardsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<UserCreditCardsMaxFields>;
  min?: Maybe<UserCreditCardsMinFields>;
  stddev?: Maybe<UserCreditCardsStddevFields>;
  stddevPop?: Maybe<UserCreditCardsStddevPopFields>;
  stddevSamp?: Maybe<UserCreditCardsStddevSampFields>;
  sum?: Maybe<UserCreditCardsSumFields>;
  varPop?: Maybe<UserCreditCardsVarPopFields>;
  varSamp?: Maybe<UserCreditCardsVarSampFields>;
  variance?: Maybe<UserCreditCardsVarianceFields>;
};


/** aggregate fields of "user_credit_cards" */
export type UserCreditCardsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<UserCreditCardsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_credit_cards" */
export type UserCreditCardsAggregateOrderBy = {
  avg?: InputMaybe<UserCreditCardsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<UserCreditCardsMaxOrderBy>;
  min?: InputMaybe<UserCreditCardsMinOrderBy>;
  stddev?: InputMaybe<UserCreditCardsStddevOrderBy>;
  stddevPop?: InputMaybe<UserCreditCardsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<UserCreditCardsStddevSampOrderBy>;
  sum?: InputMaybe<UserCreditCardsSumOrderBy>;
  varPop?: InputMaybe<UserCreditCardsVarPopOrderBy>;
  varSamp?: InputMaybe<UserCreditCardsVarSampOrderBy>;
  variance?: InputMaybe<UserCreditCardsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "user_credit_cards" */
export type UserCreditCardsArrRelInsertInput = {
  data: Array<UserCreditCardsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<UserCreditCardsOnConflict>;
};

/** aggregate avg on columns */
export type UserCreditCardsAvgFields = {
  __typename?: 'UserCreditCardsAvgFields';
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "user_credit_cards" */
export type UserCreditCardsAvgOrderBy = {
  expireMonth?: InputMaybe<OrderBy>;
  expireYear?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "user_credit_cards". All fields are combined with a logical 'AND'. */
export type UserCreditCardsBoolExp = {
  _and?: InputMaybe<Array<UserCreditCardsBoolExp>>;
  _not?: InputMaybe<UserCreditCardsBoolExp>;
  _or?: InputMaybe<Array<UserCreditCardsBoolExp>>;
  archivedAt?: InputMaybe<TimestamptzComparisonExp>;
  billingCity?: InputMaybe<StringComparisonExp>;
  billingCountry?: InputMaybe<StringComparisonExp>;
  billingEmail?: InputMaybe<StringComparisonExp>;
  billingLine1?: InputMaybe<StringComparisonExp>;
  billingLine2?: InputMaybe<StringComparisonExp>;
  billingName?: InputMaybe<StringComparisonExp>;
  billingPhone?: InputMaybe<StringComparisonExp>;
  billingPostalCode?: InputMaybe<StringComparisonExp>;
  billingState?: InputMaybe<StringComparisonExp>;
  brand?: InputMaybe<StringComparisonExp>;
  country?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  expireMonth?: InputMaybe<IntComparisonExp>;
  expireYear?: InputMaybe<IntComparisonExp>;
  fingerprint?: InputMaybe<StringComparisonExp>;
  funding?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  last4?: InputMaybe<StringComparisonExp>;
  provider?: InputMaybe<StringComparisonExp>;
  providerCardId?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "user_credit_cards" */
export enum UserCreditCardsConstraint {
  /** unique or primary key constraint on columns "id" */
  UserCreditCardsPkey = 'user_credit_cards_pkey',
  /** unique or primary key constraint on columns "provider_card_id" */
  UserCreditCardsProviderCardIdKey = 'user_credit_cards_provider_card_id_key'
}

/** input type for incrementing numeric columns in table "user_credit_cards" */
export type UserCreditCardsIncInput = {
  expireMonth?: InputMaybe<Scalars['Int']>;
  expireYear?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "user_credit_cards" */
export type UserCreditCardsInsertInput = {
  archivedAt?: InputMaybe<Scalars['timestamptz']>;
  billingCity?: InputMaybe<Scalars['String']>;
  billingCountry?: InputMaybe<Scalars['String']>;
  billingEmail?: InputMaybe<Scalars['String']>;
  billingLine1?: InputMaybe<Scalars['String']>;
  billingLine2?: InputMaybe<Scalars['String']>;
  billingName?: InputMaybe<Scalars['String']>;
  billingPhone?: InputMaybe<Scalars['String']>;
  billingPostalCode?: InputMaybe<Scalars['String']>;
  billingState?: InputMaybe<Scalars['String']>;
  brand?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  expireMonth?: InputMaybe<Scalars['Int']>;
  expireYear?: InputMaybe<Scalars['Int']>;
  fingerprint?: InputMaybe<Scalars['String']>;
  funding?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  last4?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  providerCardId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type UserCreditCardsMaxFields = {
  __typename?: 'UserCreditCardsMaxFields';
  archivedAt?: Maybe<Scalars['timestamptz']>;
  billingCity?: Maybe<Scalars['String']>;
  billingCountry?: Maybe<Scalars['String']>;
  billingEmail?: Maybe<Scalars['String']>;
  billingLine1?: Maybe<Scalars['String']>;
  billingLine2?: Maybe<Scalars['String']>;
  billingName?: Maybe<Scalars['String']>;
  billingPhone?: Maybe<Scalars['String']>;
  billingPostalCode?: Maybe<Scalars['String']>;
  billingState?: Maybe<Scalars['String']>;
  brand?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  expireMonth?: Maybe<Scalars['Int']>;
  expireYear?: Maybe<Scalars['Int']>;
  fingerprint?: Maybe<Scalars['String']>;
  funding?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  last4?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  providerCardId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "user_credit_cards" */
export type UserCreditCardsMaxOrderBy = {
  archivedAt?: InputMaybe<OrderBy>;
  billingCity?: InputMaybe<OrderBy>;
  billingCountry?: InputMaybe<OrderBy>;
  billingEmail?: InputMaybe<OrderBy>;
  billingLine1?: InputMaybe<OrderBy>;
  billingLine2?: InputMaybe<OrderBy>;
  billingName?: InputMaybe<OrderBy>;
  billingPhone?: InputMaybe<OrderBy>;
  billingPostalCode?: InputMaybe<OrderBy>;
  billingState?: InputMaybe<OrderBy>;
  brand?: InputMaybe<OrderBy>;
  country?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  expireMonth?: InputMaybe<OrderBy>;
  expireYear?: InputMaybe<OrderBy>;
  fingerprint?: InputMaybe<OrderBy>;
  funding?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  last4?: InputMaybe<OrderBy>;
  provider?: InputMaybe<OrderBy>;
  providerCardId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type UserCreditCardsMinFields = {
  __typename?: 'UserCreditCardsMinFields';
  archivedAt?: Maybe<Scalars['timestamptz']>;
  billingCity?: Maybe<Scalars['String']>;
  billingCountry?: Maybe<Scalars['String']>;
  billingEmail?: Maybe<Scalars['String']>;
  billingLine1?: Maybe<Scalars['String']>;
  billingLine2?: Maybe<Scalars['String']>;
  billingName?: Maybe<Scalars['String']>;
  billingPhone?: Maybe<Scalars['String']>;
  billingPostalCode?: Maybe<Scalars['String']>;
  billingState?: Maybe<Scalars['String']>;
  brand?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  expireMonth?: Maybe<Scalars['Int']>;
  expireYear?: Maybe<Scalars['Int']>;
  fingerprint?: Maybe<Scalars['String']>;
  funding?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  last4?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  providerCardId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "user_credit_cards" */
export type UserCreditCardsMinOrderBy = {
  archivedAt?: InputMaybe<OrderBy>;
  billingCity?: InputMaybe<OrderBy>;
  billingCountry?: InputMaybe<OrderBy>;
  billingEmail?: InputMaybe<OrderBy>;
  billingLine1?: InputMaybe<OrderBy>;
  billingLine2?: InputMaybe<OrderBy>;
  billingName?: InputMaybe<OrderBy>;
  billingPhone?: InputMaybe<OrderBy>;
  billingPostalCode?: InputMaybe<OrderBy>;
  billingState?: InputMaybe<OrderBy>;
  brand?: InputMaybe<OrderBy>;
  country?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  expireMonth?: InputMaybe<OrderBy>;
  expireYear?: InputMaybe<OrderBy>;
  fingerprint?: InputMaybe<OrderBy>;
  funding?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  last4?: InputMaybe<OrderBy>;
  provider?: InputMaybe<OrderBy>;
  providerCardId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "user_credit_cards" */
export type UserCreditCardsMutationResponse = {
  __typename?: 'UserCreditCardsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UserCreditCards>;
};

/** input type for inserting object relation for remote table "user_credit_cards" */
export type UserCreditCardsObjRelInsertInput = {
  data: UserCreditCardsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<UserCreditCardsOnConflict>;
};

/** on_conflict condition type for table "user_credit_cards" */
export type UserCreditCardsOnConflict = {
  constraint: UserCreditCardsConstraint;
  updateColumns?: Array<UserCreditCardsUpdateColumn>;
  where?: InputMaybe<UserCreditCardsBoolExp>;
};

/** Ordering options when selecting data from "user_credit_cards". */
export type UserCreditCardsOrderBy = {
  archivedAt?: InputMaybe<OrderBy>;
  billingCity?: InputMaybe<OrderBy>;
  billingCountry?: InputMaybe<OrderBy>;
  billingEmail?: InputMaybe<OrderBy>;
  billingLine1?: InputMaybe<OrderBy>;
  billingLine2?: InputMaybe<OrderBy>;
  billingName?: InputMaybe<OrderBy>;
  billingPhone?: InputMaybe<OrderBy>;
  billingPostalCode?: InputMaybe<OrderBy>;
  billingState?: InputMaybe<OrderBy>;
  brand?: InputMaybe<OrderBy>;
  country?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  expireMonth?: InputMaybe<OrderBy>;
  expireYear?: InputMaybe<OrderBy>;
  fingerprint?: InputMaybe<OrderBy>;
  funding?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  last4?: InputMaybe<OrderBy>;
  provider?: InputMaybe<OrderBy>;
  providerCardId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: user_credit_cards */
export type UserCreditCardsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "user_credit_cards" */
export enum UserCreditCardsSelectColumn {
  /** column name */
  ArchivedAt = 'archivedAt',
  /** column name */
  BillingCity = 'billingCity',
  /** column name */
  BillingCountry = 'billingCountry',
  /** column name */
  BillingEmail = 'billingEmail',
  /** column name */
  BillingLine1 = 'billingLine1',
  /** column name */
  BillingLine2 = 'billingLine2',
  /** column name */
  BillingName = 'billingName',
  /** column name */
  BillingPhone = 'billingPhone',
  /** column name */
  BillingPostalCode = 'billingPostalCode',
  /** column name */
  BillingState = 'billingState',
  /** column name */
  Brand = 'brand',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  ExpireMonth = 'expireMonth',
  /** column name */
  ExpireYear = 'expireYear',
  /** column name */
  Fingerprint = 'fingerprint',
  /** column name */
  Funding = 'funding',
  /** column name */
  Id = 'id',
  /** column name */
  Last4 = 'last4',
  /** column name */
  Provider = 'provider',
  /** column name */
  ProviderCardId = 'providerCardId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "user_credit_cards" */
export type UserCreditCardsSetInput = {
  archivedAt?: InputMaybe<Scalars['timestamptz']>;
  billingCity?: InputMaybe<Scalars['String']>;
  billingCountry?: InputMaybe<Scalars['String']>;
  billingEmail?: InputMaybe<Scalars['String']>;
  billingLine1?: InputMaybe<Scalars['String']>;
  billingLine2?: InputMaybe<Scalars['String']>;
  billingName?: InputMaybe<Scalars['String']>;
  billingPhone?: InputMaybe<Scalars['String']>;
  billingPostalCode?: InputMaybe<Scalars['String']>;
  billingState?: InputMaybe<Scalars['String']>;
  brand?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  expireMonth?: InputMaybe<Scalars['Int']>;
  expireYear?: InputMaybe<Scalars['Int']>;
  fingerprint?: InputMaybe<Scalars['String']>;
  funding?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  last4?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  providerCardId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type UserCreditCardsStddevFields = {
  __typename?: 'UserCreditCardsStddevFields';
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "user_credit_cards" */
export type UserCreditCardsStddevOrderBy = {
  expireMonth?: InputMaybe<OrderBy>;
  expireYear?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type UserCreditCardsStddevPopFields = {
  __typename?: 'UserCreditCardsStddevPopFields';
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "user_credit_cards" */
export type UserCreditCardsStddevPopOrderBy = {
  expireMonth?: InputMaybe<OrderBy>;
  expireYear?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type UserCreditCardsStddevSampFields = {
  __typename?: 'UserCreditCardsStddevSampFields';
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "user_credit_cards" */
export type UserCreditCardsStddevSampOrderBy = {
  expireMonth?: InputMaybe<OrderBy>;
  expireYear?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "user_credit_cards" */
export type UserCreditCardsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UserCreditCardsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserCreditCardsStreamCursorValueInput = {
  archivedAt?: InputMaybe<Scalars['timestamptz']>;
  billingCity?: InputMaybe<Scalars['String']>;
  billingCountry?: InputMaybe<Scalars['String']>;
  billingEmail?: InputMaybe<Scalars['String']>;
  billingLine1?: InputMaybe<Scalars['String']>;
  billingLine2?: InputMaybe<Scalars['String']>;
  billingName?: InputMaybe<Scalars['String']>;
  billingPhone?: InputMaybe<Scalars['String']>;
  billingPostalCode?: InputMaybe<Scalars['String']>;
  billingState?: InputMaybe<Scalars['String']>;
  brand?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  expireMonth?: InputMaybe<Scalars['Int']>;
  expireYear?: InputMaybe<Scalars['Int']>;
  fingerprint?: InputMaybe<Scalars['String']>;
  funding?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  last4?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  providerCardId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type UserCreditCardsSumFields = {
  __typename?: 'UserCreditCardsSumFields';
  expireMonth?: Maybe<Scalars['Int']>;
  expireYear?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "user_credit_cards" */
export type UserCreditCardsSumOrderBy = {
  expireMonth?: InputMaybe<OrderBy>;
  expireYear?: InputMaybe<OrderBy>;
};

/** update columns of table "user_credit_cards" */
export enum UserCreditCardsUpdateColumn {
  /** column name */
  ArchivedAt = 'archivedAt',
  /** column name */
  BillingCity = 'billingCity',
  /** column name */
  BillingCountry = 'billingCountry',
  /** column name */
  BillingEmail = 'billingEmail',
  /** column name */
  BillingLine1 = 'billingLine1',
  /** column name */
  BillingLine2 = 'billingLine2',
  /** column name */
  BillingName = 'billingName',
  /** column name */
  BillingPhone = 'billingPhone',
  /** column name */
  BillingPostalCode = 'billingPostalCode',
  /** column name */
  BillingState = 'billingState',
  /** column name */
  Brand = 'brand',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  ExpireMonth = 'expireMonth',
  /** column name */
  ExpireYear = 'expireYear',
  /** column name */
  Fingerprint = 'fingerprint',
  /** column name */
  Funding = 'funding',
  /** column name */
  Id = 'id',
  /** column name */
  Last4 = 'last4',
  /** column name */
  Provider = 'provider',
  /** column name */
  ProviderCardId = 'providerCardId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

export type UserCreditCardsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<UserCreditCardsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserCreditCardsSetInput>;
  /** filter the rows which have to be updated */
  where: UserCreditCardsBoolExp;
};

/** aggregate varPop on columns */
export type UserCreditCardsVarPopFields = {
  __typename?: 'UserCreditCardsVarPopFields';
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "user_credit_cards" */
export type UserCreditCardsVarPopOrderBy = {
  expireMonth?: InputMaybe<OrderBy>;
  expireYear?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type UserCreditCardsVarSampFields = {
  __typename?: 'UserCreditCardsVarSampFields';
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "user_credit_cards" */
export type UserCreditCardsVarSampOrderBy = {
  expireMonth?: InputMaybe<OrderBy>;
  expireYear?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type UserCreditCardsVarianceFields = {
  __typename?: 'UserCreditCardsVarianceFields';
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "user_credit_cards" */
export type UserCreditCardsVarianceOrderBy = {
  expireMonth?: InputMaybe<OrderBy>;
  expireYear?: InputMaybe<OrderBy>;
};

/** columns and relationships of "user_custom_courts" */
export type UserCustomCourts = {
  __typename?: 'UserCustomCourts';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  fullAddress: Scalars['String'];
  geometry?: Maybe<Scalars['geography']>;
  id: Scalars['uuid'];
  latitude?: Maybe<Scalars['numeric']>;
  /** An array relationship */
  lessons: Array<Lessons>;
  /** An aggregate relationship */
  lessonsAggregate: LessonsAggregate;
  longitude?: Maybe<Scalars['numeric']>;
  title: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid'];
};


/** columns and relationships of "user_custom_courts" */
export type UserCustomCourtsLessonsArgs = {
  distinctOn?: InputMaybe<Array<LessonsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonsOrderBy>>;
  where?: InputMaybe<LessonsBoolExp>;
};


/** columns and relationships of "user_custom_courts" */
export type UserCustomCourtsLessonsAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonsOrderBy>>;
  where?: InputMaybe<LessonsBoolExp>;
};

/** aggregated selection of "user_custom_courts" */
export type UserCustomCourtsAggregate = {
  __typename?: 'UserCustomCourtsAggregate';
  aggregate?: Maybe<UserCustomCourtsAggregateFields>;
  nodes: Array<UserCustomCourts>;
};

export type UserCustomCourtsAggregateBoolExp = {
  count?: InputMaybe<UserCustomCourtsAggregateBoolExpCount>;
};

/** aggregate fields of "user_custom_courts" */
export type UserCustomCourtsAggregateFields = {
  __typename?: 'UserCustomCourtsAggregateFields';
  avg?: Maybe<UserCustomCourtsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<UserCustomCourtsMaxFields>;
  min?: Maybe<UserCustomCourtsMinFields>;
  stddev?: Maybe<UserCustomCourtsStddevFields>;
  stddevPop?: Maybe<UserCustomCourtsStddevPopFields>;
  stddevSamp?: Maybe<UserCustomCourtsStddevSampFields>;
  sum?: Maybe<UserCustomCourtsSumFields>;
  varPop?: Maybe<UserCustomCourtsVarPopFields>;
  varSamp?: Maybe<UserCustomCourtsVarSampFields>;
  variance?: Maybe<UserCustomCourtsVarianceFields>;
};


/** aggregate fields of "user_custom_courts" */
export type UserCustomCourtsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<UserCustomCourtsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_custom_courts" */
export type UserCustomCourtsAggregateOrderBy = {
  avg?: InputMaybe<UserCustomCourtsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<UserCustomCourtsMaxOrderBy>;
  min?: InputMaybe<UserCustomCourtsMinOrderBy>;
  stddev?: InputMaybe<UserCustomCourtsStddevOrderBy>;
  stddevPop?: InputMaybe<UserCustomCourtsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<UserCustomCourtsStddevSampOrderBy>;
  sum?: InputMaybe<UserCustomCourtsSumOrderBy>;
  varPop?: InputMaybe<UserCustomCourtsVarPopOrderBy>;
  varSamp?: InputMaybe<UserCustomCourtsVarSampOrderBy>;
  variance?: InputMaybe<UserCustomCourtsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "user_custom_courts" */
export type UserCustomCourtsArrRelInsertInput = {
  data: Array<UserCustomCourtsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<UserCustomCourtsOnConflict>;
};

/** aggregate avg on columns */
export type UserCustomCourtsAvgFields = {
  __typename?: 'UserCustomCourtsAvgFields';
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "user_custom_courts" */
export type UserCustomCourtsAvgOrderBy = {
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "user_custom_courts". All fields are combined with a logical 'AND'. */
export type UserCustomCourtsBoolExp = {
  _and?: InputMaybe<Array<UserCustomCourtsBoolExp>>;
  _not?: InputMaybe<UserCustomCourtsBoolExp>;
  _or?: InputMaybe<Array<UserCustomCourtsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  fullAddress?: InputMaybe<StringComparisonExp>;
  geometry?: InputMaybe<GeographyComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  latitude?: InputMaybe<NumericComparisonExp>;
  lessons?: InputMaybe<LessonsBoolExp>;
  lessonsAggregate?: InputMaybe<LessonsAggregateBoolExp>;
  longitude?: InputMaybe<NumericComparisonExp>;
  title?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "user_custom_courts" */
export enum UserCustomCourtsConstraint {
  /** unique or primary key constraint on columns "id" */
  UserCustomCourtsPkey = 'user_custom_courts_pkey'
}

/** input type for incrementing numeric columns in table "user_custom_courts" */
export type UserCustomCourtsIncInput = {
  latitude?: InputMaybe<Scalars['numeric']>;
  longitude?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "user_custom_courts" */
export type UserCustomCourtsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  fullAddress?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  latitude?: InputMaybe<Scalars['numeric']>;
  lessons?: InputMaybe<LessonsArrRelInsertInput>;
  longitude?: InputMaybe<Scalars['numeric']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type UserCustomCourtsMaxFields = {
  __typename?: 'UserCustomCourtsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  fullAddress?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  latitude?: Maybe<Scalars['numeric']>;
  longitude?: Maybe<Scalars['numeric']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "user_custom_courts" */
export type UserCustomCourtsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  fullAddress?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type UserCustomCourtsMinFields = {
  __typename?: 'UserCustomCourtsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  fullAddress?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  latitude?: Maybe<Scalars['numeric']>;
  longitude?: Maybe<Scalars['numeric']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "user_custom_courts" */
export type UserCustomCourtsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  fullAddress?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "user_custom_courts" */
export type UserCustomCourtsMutationResponse = {
  __typename?: 'UserCustomCourtsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UserCustomCourts>;
};

/** input type for inserting object relation for remote table "user_custom_courts" */
export type UserCustomCourtsObjRelInsertInput = {
  data: UserCustomCourtsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<UserCustomCourtsOnConflict>;
};

/** on_conflict condition type for table "user_custom_courts" */
export type UserCustomCourtsOnConflict = {
  constraint: UserCustomCourtsConstraint;
  updateColumns?: Array<UserCustomCourtsUpdateColumn>;
  where?: InputMaybe<UserCustomCourtsBoolExp>;
};

/** Ordering options when selecting data from "user_custom_courts". */
export type UserCustomCourtsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  fullAddress?: InputMaybe<OrderBy>;
  geometry?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  lessonsAggregate?: InputMaybe<LessonsAggregateOrderBy>;
  longitude?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: user_custom_courts */
export type UserCustomCourtsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "user_custom_courts" */
export enum UserCustomCourtsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  FullAddress = 'fullAddress',
  /** column name */
  Geometry = 'geometry',
  /** column name */
  Id = 'id',
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Longitude = 'longitude',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "user_custom_courts" */
export type UserCustomCourtsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  fullAddress?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  latitude?: InputMaybe<Scalars['numeric']>;
  longitude?: InputMaybe<Scalars['numeric']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type UserCustomCourtsStddevFields = {
  __typename?: 'UserCustomCourtsStddevFields';
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "user_custom_courts" */
export type UserCustomCourtsStddevOrderBy = {
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type UserCustomCourtsStddevPopFields = {
  __typename?: 'UserCustomCourtsStddevPopFields';
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "user_custom_courts" */
export type UserCustomCourtsStddevPopOrderBy = {
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type UserCustomCourtsStddevSampFields = {
  __typename?: 'UserCustomCourtsStddevSampFields';
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "user_custom_courts" */
export type UserCustomCourtsStddevSampOrderBy = {
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "user_custom_courts" */
export type UserCustomCourtsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UserCustomCourtsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserCustomCourtsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  fullAddress?: InputMaybe<Scalars['String']>;
  geometry?: InputMaybe<Scalars['geography']>;
  id?: InputMaybe<Scalars['uuid']>;
  latitude?: InputMaybe<Scalars['numeric']>;
  longitude?: InputMaybe<Scalars['numeric']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type UserCustomCourtsSumFields = {
  __typename?: 'UserCustomCourtsSumFields';
  latitude?: Maybe<Scalars['numeric']>;
  longitude?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "user_custom_courts" */
export type UserCustomCourtsSumOrderBy = {
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
};

/** update columns of table "user_custom_courts" */
export enum UserCustomCourtsUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  FullAddress = 'fullAddress',
  /** column name */
  Id = 'id',
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Longitude = 'longitude',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

export type UserCustomCourtsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<UserCustomCourtsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserCustomCourtsSetInput>;
  /** filter the rows which have to be updated */
  where: UserCustomCourtsBoolExp;
};

/** aggregate varPop on columns */
export type UserCustomCourtsVarPopFields = {
  __typename?: 'UserCustomCourtsVarPopFields';
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "user_custom_courts" */
export type UserCustomCourtsVarPopOrderBy = {
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type UserCustomCourtsVarSampFields = {
  __typename?: 'UserCustomCourtsVarSampFields';
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "user_custom_courts" */
export type UserCustomCourtsVarSampOrderBy = {
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type UserCustomCourtsVarianceFields = {
  __typename?: 'UserCustomCourtsVarianceFields';
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "user_custom_courts" */
export type UserCustomCourtsVarianceOrderBy = {
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
};

/** columns and relationships of "user_files" */
export type UserFiles = {
  __typename?: 'UserFiles';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  fileCategory: FileCategoryEnum;
  fileFormat: FileFormatEnum;
  fileName: Scalars['String'];
  fileType: Scalars['String'];
  host: Scalars['String'];
  id: Scalars['uuid'];
  originalFileName?: Maybe<Scalars['String']>;
  path: Scalars['String'];
  provider: Scalars['String'];
  providerId: Scalars['String'];
  providerUrl: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  url: Scalars['String'];
  userId: Scalars['uuid'];
};

/** aggregated selection of "user_files" */
export type UserFilesAggregate = {
  __typename?: 'UserFilesAggregate';
  aggregate?: Maybe<UserFilesAggregateFields>;
  nodes: Array<UserFiles>;
};

export type UserFilesAggregateBoolExp = {
  count?: InputMaybe<UserFilesAggregateBoolExpCount>;
};

/** aggregate fields of "user_files" */
export type UserFilesAggregateFields = {
  __typename?: 'UserFilesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<UserFilesMaxFields>;
  min?: Maybe<UserFilesMinFields>;
};


/** aggregate fields of "user_files" */
export type UserFilesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<UserFilesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_files" */
export type UserFilesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<UserFilesMaxOrderBy>;
  min?: InputMaybe<UserFilesMinOrderBy>;
};

/** input type for inserting array relation for remote table "user_files" */
export type UserFilesArrRelInsertInput = {
  data: Array<UserFilesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<UserFilesOnConflict>;
};

/** Boolean expression to filter rows from the table "user_files". All fields are combined with a logical 'AND'. */
export type UserFilesBoolExp = {
  _and?: InputMaybe<Array<UserFilesBoolExp>>;
  _not?: InputMaybe<UserFilesBoolExp>;
  _or?: InputMaybe<Array<UserFilesBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  fileCategory?: InputMaybe<FileCategoryEnumComparisonExp>;
  fileFormat?: InputMaybe<FileFormatEnumComparisonExp>;
  fileName?: InputMaybe<StringComparisonExp>;
  fileType?: InputMaybe<StringComparisonExp>;
  host?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  originalFileName?: InputMaybe<StringComparisonExp>;
  path?: InputMaybe<StringComparisonExp>;
  provider?: InputMaybe<StringComparisonExp>;
  providerId?: InputMaybe<StringComparisonExp>;
  providerUrl?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  url?: InputMaybe<StringComparisonExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "user_files" */
export enum UserFilesConstraint {
  /** unique or primary key constraint on columns "id" */
  UserFilesPkey = 'user_files_pkey'
}

/** input type for inserting data into table "user_files" */
export type UserFilesInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  fileCategory?: InputMaybe<FileCategoryEnum>;
  fileFormat?: InputMaybe<FileFormatEnum>;
  fileName?: InputMaybe<Scalars['String']>;
  fileType?: InputMaybe<Scalars['String']>;
  host?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  originalFileName?: InputMaybe<Scalars['String']>;
  path?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  providerId?: InputMaybe<Scalars['String']>;
  providerUrl?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  url?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type UserFilesMaxFields = {
  __typename?: 'UserFilesMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  fileName?: Maybe<Scalars['String']>;
  fileType?: Maybe<Scalars['String']>;
  host?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  originalFileName?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  providerId?: Maybe<Scalars['String']>;
  providerUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  url?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "user_files" */
export type UserFilesMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  fileName?: InputMaybe<OrderBy>;
  fileType?: InputMaybe<OrderBy>;
  host?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  originalFileName?: InputMaybe<OrderBy>;
  path?: InputMaybe<OrderBy>;
  provider?: InputMaybe<OrderBy>;
  providerId?: InputMaybe<OrderBy>;
  providerUrl?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  url?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type UserFilesMinFields = {
  __typename?: 'UserFilesMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  fileName?: Maybe<Scalars['String']>;
  fileType?: Maybe<Scalars['String']>;
  host?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  originalFileName?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  providerId?: Maybe<Scalars['String']>;
  providerUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  url?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "user_files" */
export type UserFilesMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  fileName?: InputMaybe<OrderBy>;
  fileType?: InputMaybe<OrderBy>;
  host?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  originalFileName?: InputMaybe<OrderBy>;
  path?: InputMaybe<OrderBy>;
  provider?: InputMaybe<OrderBy>;
  providerId?: InputMaybe<OrderBy>;
  providerUrl?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  url?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "user_files" */
export type UserFilesMutationResponse = {
  __typename?: 'UserFilesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UserFiles>;
};

/** on_conflict condition type for table "user_files" */
export type UserFilesOnConflict = {
  constraint: UserFilesConstraint;
  updateColumns?: Array<UserFilesUpdateColumn>;
  where?: InputMaybe<UserFilesBoolExp>;
};

/** Ordering options when selecting data from "user_files". */
export type UserFilesOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  fileCategory?: InputMaybe<OrderBy>;
  fileFormat?: InputMaybe<OrderBy>;
  fileName?: InputMaybe<OrderBy>;
  fileType?: InputMaybe<OrderBy>;
  host?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  originalFileName?: InputMaybe<OrderBy>;
  path?: InputMaybe<OrderBy>;
  provider?: InputMaybe<OrderBy>;
  providerId?: InputMaybe<OrderBy>;
  providerUrl?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  url?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: user_files */
export type UserFilesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "user_files" */
export enum UserFilesSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  FileCategory = 'fileCategory',
  /** column name */
  FileFormat = 'fileFormat',
  /** column name */
  FileName = 'fileName',
  /** column name */
  FileType = 'fileType',
  /** column name */
  Host = 'host',
  /** column name */
  Id = 'id',
  /** column name */
  OriginalFileName = 'originalFileName',
  /** column name */
  Path = 'path',
  /** column name */
  Provider = 'provider',
  /** column name */
  ProviderId = 'providerId',
  /** column name */
  ProviderUrl = 'providerUrl',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Url = 'url',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "user_files" */
export type UserFilesSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  fileCategory?: InputMaybe<FileCategoryEnum>;
  fileFormat?: InputMaybe<FileFormatEnum>;
  fileName?: InputMaybe<Scalars['String']>;
  fileType?: InputMaybe<Scalars['String']>;
  host?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  originalFileName?: InputMaybe<Scalars['String']>;
  path?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  providerId?: InputMaybe<Scalars['String']>;
  providerUrl?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  url?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "user_files" */
export type UserFilesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UserFilesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserFilesStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  fileCategory?: InputMaybe<FileCategoryEnum>;
  fileFormat?: InputMaybe<FileFormatEnum>;
  fileName?: InputMaybe<Scalars['String']>;
  fileType?: InputMaybe<Scalars['String']>;
  host?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  originalFileName?: InputMaybe<Scalars['String']>;
  path?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  providerId?: InputMaybe<Scalars['String']>;
  providerUrl?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  url?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "user_files" */
export enum UserFilesUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  FileCategory = 'fileCategory',
  /** column name */
  FileFormat = 'fileFormat',
  /** column name */
  FileName = 'fileName',
  /** column name */
  FileType = 'fileType',
  /** column name */
  Host = 'host',
  /** column name */
  Id = 'id',
  /** column name */
  OriginalFileName = 'originalFileName',
  /** column name */
  Path = 'path',
  /** column name */
  Provider = 'provider',
  /** column name */
  ProviderId = 'providerId',
  /** column name */
  ProviderUrl = 'providerUrl',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Url = 'url',
  /** column name */
  UserId = 'userId'
}

export type UserFilesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserFilesSetInput>;
  /** filter the rows which have to be updated */
  where: UserFilesBoolExp;
};

/** columns and relationships of "user_follows" */
export type UserFollows = {
  __typename?: 'UserFollows';
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  followedProfile?: Maybe<UserProfiles>;
  followedUserId: Scalars['uuid'];
  /** An object relationship */
  followerProfile?: Maybe<UserProfiles>;
  followerUserId: Scalars['uuid'];
  id: Scalars['uuid'];
  status: FollowStatusesEnum;
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  userFollowerProfile: Users;
};

/** aggregated selection of "user_follows" */
export type UserFollowsAggregate = {
  __typename?: 'UserFollowsAggregate';
  aggregate?: Maybe<UserFollowsAggregateFields>;
  nodes: Array<UserFollows>;
};

export type UserFollowsAggregateBoolExp = {
  count?: InputMaybe<UserFollowsAggregateBoolExpCount>;
};

/** aggregate fields of "user_follows" */
export type UserFollowsAggregateFields = {
  __typename?: 'UserFollowsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<UserFollowsMaxFields>;
  min?: Maybe<UserFollowsMinFields>;
};


/** aggregate fields of "user_follows" */
export type UserFollowsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<UserFollowsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_follows" */
export type UserFollowsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<UserFollowsMaxOrderBy>;
  min?: InputMaybe<UserFollowsMinOrderBy>;
};

/** input type for inserting array relation for remote table "user_follows" */
export type UserFollowsArrRelInsertInput = {
  data: Array<UserFollowsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<UserFollowsOnConflict>;
};

/** Boolean expression to filter rows from the table "user_follows". All fields are combined with a logical 'AND'. */
export type UserFollowsBoolExp = {
  _and?: InputMaybe<Array<UserFollowsBoolExp>>;
  _not?: InputMaybe<UserFollowsBoolExp>;
  _or?: InputMaybe<Array<UserFollowsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  followedProfile?: InputMaybe<UserProfilesBoolExp>;
  followedUserId?: InputMaybe<UuidComparisonExp>;
  followerProfile?: InputMaybe<UserProfilesBoolExp>;
  followerUserId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  status?: InputMaybe<FollowStatusesEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  userFollowerProfile?: InputMaybe<UsersBoolExp>;
};

/** unique or primary key constraints on table "user_follows" */
export enum UserFollowsConstraint {
  /** unique or primary key constraint on columns "followed_user_id", "follower_user_id" */
  UserFollowsFollowedUserIdFollowerUserIdKey = 'user_follows_followed_user_id_follower_user_id_key',
  /** unique or primary key constraint on columns "id" */
  UserFollowsPkey = 'user_follows_pkey'
}

/** input type for inserting data into table "user_follows" */
export type UserFollowsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  followedProfile?: InputMaybe<UserProfilesObjRelInsertInput>;
  followedUserId?: InputMaybe<Scalars['uuid']>;
  followerProfile?: InputMaybe<UserProfilesObjRelInsertInput>;
  followerUserId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<FollowStatusesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userFollowerProfile?: InputMaybe<UsersObjRelInsertInput>;
};

/** aggregate max on columns */
export type UserFollowsMaxFields = {
  __typename?: 'UserFollowsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  followedUserId?: Maybe<Scalars['uuid']>;
  followerUserId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "user_follows" */
export type UserFollowsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  followedUserId?: InputMaybe<OrderBy>;
  followerUserId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type UserFollowsMinFields = {
  __typename?: 'UserFollowsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  followedUserId?: Maybe<Scalars['uuid']>;
  followerUserId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "user_follows" */
export type UserFollowsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  followedUserId?: InputMaybe<OrderBy>;
  followerUserId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "user_follows" */
export type UserFollowsMutationResponse = {
  __typename?: 'UserFollowsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UserFollows>;
};

/** on_conflict condition type for table "user_follows" */
export type UserFollowsOnConflict = {
  constraint: UserFollowsConstraint;
  updateColumns?: Array<UserFollowsUpdateColumn>;
  where?: InputMaybe<UserFollowsBoolExp>;
};

/** Ordering options when selecting data from "user_follows". */
export type UserFollowsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  followedProfile?: InputMaybe<UserProfilesOrderBy>;
  followedUserId?: InputMaybe<OrderBy>;
  followerProfile?: InputMaybe<UserProfilesOrderBy>;
  followerUserId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userFollowerProfile?: InputMaybe<UsersOrderBy>;
};

/** primary key columns input for table: user_follows */
export type UserFollowsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "user_follows" */
export enum UserFollowsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  FollowedUserId = 'followedUserId',
  /** column name */
  FollowerUserId = 'followerUserId',
  /** column name */
  Id = 'id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "user_follows" */
export type UserFollowsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  followedUserId?: InputMaybe<Scalars['uuid']>;
  followerUserId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<FollowStatusesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "user_follows" */
export type UserFollowsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UserFollowsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserFollowsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  followedUserId?: InputMaybe<Scalars['uuid']>;
  followerUserId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<FollowStatusesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "user_follows" */
export enum UserFollowsUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  FollowedUserId = 'followedUserId',
  /** column name */
  FollowerUserId = 'followerUserId',
  /** column name */
  Id = 'id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type UserFollowsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserFollowsSetInput>;
  /** filter the rows which have to be updated */
  where: UserFollowsBoolExp;
};

/** columns and relationships of "user_identity_verifications" */
export type UserIdentityVerifications = {
  __typename?: 'UserIdentityVerifications';
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  provider: IdentityVerificationProvidersEnum;
  providerSessionId?: Maybe<Scalars['String']>;
  status: IdentityVerificationStatusesEnum;
  updatedAt: Scalars['timestamptz'];
  userId: Scalars['uuid'];
  verifiedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "user_identity_verifications" */
export type UserIdentityVerificationsAggregate = {
  __typename?: 'UserIdentityVerificationsAggregate';
  aggregate?: Maybe<UserIdentityVerificationsAggregateFields>;
  nodes: Array<UserIdentityVerifications>;
};

export type UserIdentityVerificationsAggregateBoolExp = {
  count?: InputMaybe<UserIdentityVerificationsAggregateBoolExpCount>;
};

/** aggregate fields of "user_identity_verifications" */
export type UserIdentityVerificationsAggregateFields = {
  __typename?: 'UserIdentityVerificationsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<UserIdentityVerificationsMaxFields>;
  min?: Maybe<UserIdentityVerificationsMinFields>;
};


/** aggregate fields of "user_identity_verifications" */
export type UserIdentityVerificationsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<UserIdentityVerificationsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_identity_verifications" */
export type UserIdentityVerificationsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<UserIdentityVerificationsMaxOrderBy>;
  min?: InputMaybe<UserIdentityVerificationsMinOrderBy>;
};

/** input type for inserting array relation for remote table "user_identity_verifications" */
export type UserIdentityVerificationsArrRelInsertInput = {
  data: Array<UserIdentityVerificationsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<UserIdentityVerificationsOnConflict>;
};

/** Boolean expression to filter rows from the table "user_identity_verifications". All fields are combined with a logical 'AND'. */
export type UserIdentityVerificationsBoolExp = {
  _and?: InputMaybe<Array<UserIdentityVerificationsBoolExp>>;
  _not?: InputMaybe<UserIdentityVerificationsBoolExp>;
  _or?: InputMaybe<Array<UserIdentityVerificationsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  provider?: InputMaybe<IdentityVerificationProvidersEnumComparisonExp>;
  providerSessionId?: InputMaybe<StringComparisonExp>;
  status?: InputMaybe<IdentityVerificationStatusesEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  userId?: InputMaybe<UuidComparisonExp>;
  verifiedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "user_identity_verifications" */
export enum UserIdentityVerificationsConstraint {
  /** unique or primary key constraint on columns "id" */
  UserIdentityVerificationsPkey = 'user_identity_verifications_pkey'
}

/** input type for inserting data into table "user_identity_verifications" */
export type UserIdentityVerificationsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  provider?: InputMaybe<IdentityVerificationProvidersEnum>;
  providerSessionId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<IdentityVerificationStatusesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
  verifiedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type UserIdentityVerificationsMaxFields = {
  __typename?: 'UserIdentityVerificationsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  providerSessionId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
  verifiedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "user_identity_verifications" */
export type UserIdentityVerificationsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  providerSessionId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
  verifiedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type UserIdentityVerificationsMinFields = {
  __typename?: 'UserIdentityVerificationsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  providerSessionId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
  verifiedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "user_identity_verifications" */
export type UserIdentityVerificationsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  providerSessionId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
  verifiedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "user_identity_verifications" */
export type UserIdentityVerificationsMutationResponse = {
  __typename?: 'UserIdentityVerificationsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UserIdentityVerifications>;
};

/** on_conflict condition type for table "user_identity_verifications" */
export type UserIdentityVerificationsOnConflict = {
  constraint: UserIdentityVerificationsConstraint;
  updateColumns?: Array<UserIdentityVerificationsUpdateColumn>;
  where?: InputMaybe<UserIdentityVerificationsBoolExp>;
};

/** Ordering options when selecting data from "user_identity_verifications". */
export type UserIdentityVerificationsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  provider?: InputMaybe<OrderBy>;
  providerSessionId?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
  verifiedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: user_identity_verifications */
export type UserIdentityVerificationsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "user_identity_verifications" */
export enum UserIdentityVerificationsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Provider = 'provider',
  /** column name */
  ProviderSessionId = 'providerSessionId',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId',
  /** column name */
  VerifiedAt = 'verifiedAt'
}

/** input type for updating data in table "user_identity_verifications" */
export type UserIdentityVerificationsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  provider?: InputMaybe<IdentityVerificationProvidersEnum>;
  providerSessionId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<IdentityVerificationStatusesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
  verifiedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "user_identity_verifications" */
export type UserIdentityVerificationsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UserIdentityVerificationsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserIdentityVerificationsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  provider?: InputMaybe<IdentityVerificationProvidersEnum>;
  providerSessionId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<IdentityVerificationStatusesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
  verifiedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "user_identity_verifications" */
export enum UserIdentityVerificationsUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Provider = 'provider',
  /** column name */
  ProviderSessionId = 'providerSessionId',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId',
  /** column name */
  VerifiedAt = 'verifiedAt'
}

export type UserIdentityVerificationsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserIdentityVerificationsSetInput>;
  /** filter the rows which have to be updated */
  where: UserIdentityVerificationsBoolExp;
};

/** columns and relationships of "user_image_log" */
export type UserImageLog = {
  __typename?: 'UserImageLog';
  createdAt: Scalars['timestamptz'];
  fileName: Scalars['String'];
  id: Scalars['uuid'];
  path: Scalars['String'];
  provider: Scalars['String'];
  providerId: Scalars['String'];
  providerUrl: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  userId?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "user_image_log" */
export type UserImageLogAggregate = {
  __typename?: 'UserImageLogAggregate';
  aggregate?: Maybe<UserImageLogAggregateFields>;
  nodes: Array<UserImageLog>;
};

/** aggregate fields of "user_image_log" */
export type UserImageLogAggregateFields = {
  __typename?: 'UserImageLogAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<UserImageLogMaxFields>;
  min?: Maybe<UserImageLogMinFields>;
};


/** aggregate fields of "user_image_log" */
export type UserImageLogAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<UserImageLogSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "user_image_log". All fields are combined with a logical 'AND'. */
export type UserImageLogBoolExp = {
  _and?: InputMaybe<Array<UserImageLogBoolExp>>;
  _not?: InputMaybe<UserImageLogBoolExp>;
  _or?: InputMaybe<Array<UserImageLogBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  fileName?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  path?: InputMaybe<StringComparisonExp>;
  provider?: InputMaybe<StringComparisonExp>;
  providerId?: InputMaybe<StringComparisonExp>;
  providerUrl?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "user_image_log" */
export enum UserImageLogConstraint {
  /** unique or primary key constraint on columns "id" */
  UserImageLogPkey = 'user_image_log_pkey'
}

/** input type for inserting data into table "user_image_log" */
export type UserImageLogInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  fileName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  path?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  providerId?: InputMaybe<Scalars['String']>;
  providerUrl?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type UserImageLogMaxFields = {
  __typename?: 'UserImageLogMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  fileName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  path?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  providerId?: Maybe<Scalars['String']>;
  providerUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type UserImageLogMinFields = {
  __typename?: 'UserImageLogMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  fileName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  path?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  providerId?: Maybe<Scalars['String']>;
  providerUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "user_image_log" */
export type UserImageLogMutationResponse = {
  __typename?: 'UserImageLogMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UserImageLog>;
};

/** on_conflict condition type for table "user_image_log" */
export type UserImageLogOnConflict = {
  constraint: UserImageLogConstraint;
  updateColumns?: Array<UserImageLogUpdateColumn>;
  where?: InputMaybe<UserImageLogBoolExp>;
};

/** Ordering options when selecting data from "user_image_log". */
export type UserImageLogOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  fileName?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  path?: InputMaybe<OrderBy>;
  provider?: InputMaybe<OrderBy>;
  providerId?: InputMaybe<OrderBy>;
  providerUrl?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: user_image_log */
export type UserImageLogPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "user_image_log" */
export enum UserImageLogSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  FileName = 'fileName',
  /** column name */
  Id = 'id',
  /** column name */
  Path = 'path',
  /** column name */
  Provider = 'provider',
  /** column name */
  ProviderId = 'providerId',
  /** column name */
  ProviderUrl = 'providerUrl',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "user_image_log" */
export type UserImageLogSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  fileName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  path?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  providerId?: InputMaybe<Scalars['String']>;
  providerUrl?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "user_image_log" */
export type UserImageLogStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UserImageLogStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserImageLogStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  fileName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  path?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  providerId?: InputMaybe<Scalars['String']>;
  providerUrl?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "user_image_log" */
export enum UserImageLogUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  FileName = 'fileName',
  /** column name */
  Id = 'id',
  /** column name */
  Path = 'path',
  /** column name */
  Provider = 'provider',
  /** column name */
  ProviderId = 'providerId',
  /** column name */
  ProviderUrl = 'providerUrl',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

export type UserImageLogUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserImageLogSetInput>;
  /** filter the rows which have to be updated */
  where: UserImageLogBoolExp;
};

/** columns and relationships of "user_notification_details" */
export type UserNotificationDetails = {
  __typename?: 'UserNotificationDetails';
  actionType: NotificationActionTypesEnum;
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  /** An object relationship */
  primaryEntity: UserNotificationEntities;
  updatedAt: Scalars['timestamptz'];
  userNotificationEntityId: Scalars['uuid'];
  /** An array relationship */
  userNotifications: Array<UserNotifications>;
  /** An aggregate relationship */
  userNotificationsAggregate: UserNotificationsAggregate;
};


/** columns and relationships of "user_notification_details" */
export type UserNotificationDetailsUserNotificationsArgs = {
  distinctOn?: InputMaybe<Array<UserNotificationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserNotificationsOrderBy>>;
  where?: InputMaybe<UserNotificationsBoolExp>;
};


/** columns and relationships of "user_notification_details" */
export type UserNotificationDetailsUserNotificationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserNotificationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserNotificationsOrderBy>>;
  where?: InputMaybe<UserNotificationsBoolExp>;
};

/** aggregated selection of "user_notification_details" */
export type UserNotificationDetailsAggregate = {
  __typename?: 'UserNotificationDetailsAggregate';
  aggregate?: Maybe<UserNotificationDetailsAggregateFields>;
  nodes: Array<UserNotificationDetails>;
};

/** aggregate fields of "user_notification_details" */
export type UserNotificationDetailsAggregateFields = {
  __typename?: 'UserNotificationDetailsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<UserNotificationDetailsMaxFields>;
  min?: Maybe<UserNotificationDetailsMinFields>;
};


/** aggregate fields of "user_notification_details" */
export type UserNotificationDetailsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<UserNotificationDetailsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "user_notification_details". All fields are combined with a logical 'AND'. */
export type UserNotificationDetailsBoolExp = {
  _and?: InputMaybe<Array<UserNotificationDetailsBoolExp>>;
  _not?: InputMaybe<UserNotificationDetailsBoolExp>;
  _or?: InputMaybe<Array<UserNotificationDetailsBoolExp>>;
  actionType?: InputMaybe<NotificationActionTypesEnumComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  primaryEntity?: InputMaybe<UserNotificationEntitiesBoolExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  userNotificationEntityId?: InputMaybe<UuidComparisonExp>;
  userNotifications?: InputMaybe<UserNotificationsBoolExp>;
  userNotificationsAggregate?: InputMaybe<UserNotificationsAggregateBoolExp>;
};

/** unique or primary key constraints on table "user_notification_details" */
export enum UserNotificationDetailsConstraint {
  /** unique or primary key constraint on columns "id" */
  UserNotificationDetailsPkey = 'user_notification_details_pkey',
  /** unique or primary key constraint on columns "user_notification_entity_id" */
  UserNotificationDetailsUserNotificationEntityIdKey = 'user_notification_details_user_notification_entity_id_key'
}

/** input type for inserting data into table "user_notification_details" */
export type UserNotificationDetailsInsertInput = {
  actionType?: InputMaybe<NotificationActionTypesEnum>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  primaryEntity?: InputMaybe<UserNotificationEntitiesObjRelInsertInput>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userNotificationEntityId?: InputMaybe<Scalars['uuid']>;
  userNotifications?: InputMaybe<UserNotificationsArrRelInsertInput>;
};

/** aggregate max on columns */
export type UserNotificationDetailsMaxFields = {
  __typename?: 'UserNotificationDetailsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userNotificationEntityId?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type UserNotificationDetailsMinFields = {
  __typename?: 'UserNotificationDetailsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userNotificationEntityId?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "user_notification_details" */
export type UserNotificationDetailsMutationResponse = {
  __typename?: 'UserNotificationDetailsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UserNotificationDetails>;
};

/** input type for inserting object relation for remote table "user_notification_details" */
export type UserNotificationDetailsObjRelInsertInput = {
  data: UserNotificationDetailsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<UserNotificationDetailsOnConflict>;
};

/** on_conflict condition type for table "user_notification_details" */
export type UserNotificationDetailsOnConflict = {
  constraint: UserNotificationDetailsConstraint;
  updateColumns?: Array<UserNotificationDetailsUpdateColumn>;
  where?: InputMaybe<UserNotificationDetailsBoolExp>;
};

/** Ordering options when selecting data from "user_notification_details". */
export type UserNotificationDetailsOrderBy = {
  actionType?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  primaryEntity?: InputMaybe<UserNotificationEntitiesOrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userNotificationEntityId?: InputMaybe<OrderBy>;
  userNotificationsAggregate?: InputMaybe<UserNotificationsAggregateOrderBy>;
};

/** primary key columns input for table: user_notification_details */
export type UserNotificationDetailsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "user_notification_details" */
export enum UserNotificationDetailsSelectColumn {
  /** column name */
  ActionType = 'actionType',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserNotificationEntityId = 'userNotificationEntityId'
}

/** input type for updating data in table "user_notification_details" */
export type UserNotificationDetailsSetInput = {
  actionType?: InputMaybe<NotificationActionTypesEnum>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userNotificationEntityId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "user_notification_details" */
export type UserNotificationDetailsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UserNotificationDetailsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserNotificationDetailsStreamCursorValueInput = {
  actionType?: InputMaybe<NotificationActionTypesEnum>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userNotificationEntityId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "user_notification_details" */
export enum UserNotificationDetailsUpdateColumn {
  /** column name */
  ActionType = 'actionType',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserNotificationEntityId = 'userNotificationEntityId'
}

export type UserNotificationDetailsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserNotificationDetailsSetInput>;
  /** filter the rows which have to be updated */
  where: UserNotificationDetailsBoolExp;
};

/** columns and relationships of "user_notification_entities" */
export type UserNotificationEntities = {
  __typename?: 'UserNotificationEntities';
  /** An object relationship */
  actingUser?: Maybe<Users>;
  actingUserId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  actingUserProfile?: Maybe<UserProfiles>;
  /** An object relationship */
  connectionRequest?: Maybe<UserConnectionRequests>;
  connectionRequestId?: Maybe<Scalars['uuid']>;
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  eventGroup?: Maybe<EventGroups>;
  eventGroupId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  eventPlayerInvite?: Maybe<EventPlayerInvites>;
  eventPlayerInviteId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  group?: Maybe<Groups>;
  groupId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  groupThread?: Maybe<GroupThreads>;
  /** An object relationship */
  groupThreadComment?: Maybe<GroupThreadComments>;
  groupThreadCommentId?: Maybe<Scalars['uuid']>;
  groupThreadId?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  /** An object relationship */
  lesson?: Maybe<Lessons>;
  lessonId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  message?: Maybe<Messages>;
  messageId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  notificationDetails?: Maybe<UserNotificationDetails>;
  /** An object relationship */
  partnerBookingOrder?: Maybe<PartnerBookingOrders>;
  partnerBookingOrderId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  playRequest?: Maybe<PlayRequests>;
  playRequestId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  playSession?: Maybe<PlaySessions>;
  /** An object relationship */
  playSessionComment?: Maybe<PlaySessionComments>;
  playSessionCommentId?: Maybe<Scalars['uuid']>;
  playSessionId?: Maybe<Scalars['uuid']>;
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  videoAnalysis?: Maybe<VideoAnalysis>;
  videoAnalysisId?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "user_notification_entities" */
export type UserNotificationEntitiesAggregate = {
  __typename?: 'UserNotificationEntitiesAggregate';
  aggregate?: Maybe<UserNotificationEntitiesAggregateFields>;
  nodes: Array<UserNotificationEntities>;
};

/** aggregate fields of "user_notification_entities" */
export type UserNotificationEntitiesAggregateFields = {
  __typename?: 'UserNotificationEntitiesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<UserNotificationEntitiesMaxFields>;
  min?: Maybe<UserNotificationEntitiesMinFields>;
};


/** aggregate fields of "user_notification_entities" */
export type UserNotificationEntitiesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<UserNotificationEntitiesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "user_notification_entities". All fields are combined with a logical 'AND'. */
export type UserNotificationEntitiesBoolExp = {
  _and?: InputMaybe<Array<UserNotificationEntitiesBoolExp>>;
  _not?: InputMaybe<UserNotificationEntitiesBoolExp>;
  _or?: InputMaybe<Array<UserNotificationEntitiesBoolExp>>;
  actingUser?: InputMaybe<UsersBoolExp>;
  actingUserId?: InputMaybe<UuidComparisonExp>;
  actingUserProfile?: InputMaybe<UserProfilesBoolExp>;
  connectionRequest?: InputMaybe<UserConnectionRequestsBoolExp>;
  connectionRequestId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  eventGroup?: InputMaybe<EventGroupsBoolExp>;
  eventGroupId?: InputMaybe<UuidComparisonExp>;
  eventPlayerInvite?: InputMaybe<EventPlayerInvitesBoolExp>;
  eventPlayerInviteId?: InputMaybe<UuidComparisonExp>;
  group?: InputMaybe<GroupsBoolExp>;
  groupId?: InputMaybe<UuidComparisonExp>;
  groupThread?: InputMaybe<GroupThreadsBoolExp>;
  groupThreadComment?: InputMaybe<GroupThreadCommentsBoolExp>;
  groupThreadCommentId?: InputMaybe<UuidComparisonExp>;
  groupThreadId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  lesson?: InputMaybe<LessonsBoolExp>;
  lessonId?: InputMaybe<UuidComparisonExp>;
  message?: InputMaybe<MessagesBoolExp>;
  messageId?: InputMaybe<UuidComparisonExp>;
  notificationDetails?: InputMaybe<UserNotificationDetailsBoolExp>;
  partnerBookingOrder?: InputMaybe<PartnerBookingOrdersBoolExp>;
  partnerBookingOrderId?: InputMaybe<UuidComparisonExp>;
  playRequest?: InputMaybe<PlayRequestsBoolExp>;
  playRequestId?: InputMaybe<UuidComparisonExp>;
  playSession?: InputMaybe<PlaySessionsBoolExp>;
  playSessionComment?: InputMaybe<PlaySessionCommentsBoolExp>;
  playSessionCommentId?: InputMaybe<UuidComparisonExp>;
  playSessionId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  videoAnalysis?: InputMaybe<VideoAnalysisBoolExp>;
  videoAnalysisId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "user_notification_entities" */
export enum UserNotificationEntitiesConstraint {
  /** unique or primary key constraint on columns "id" */
  UserNotificationEntitiesPkey = 'user_notification_entities_pkey'
}

/** input type for inserting data into table "user_notification_entities" */
export type UserNotificationEntitiesInsertInput = {
  actingUser?: InputMaybe<UsersObjRelInsertInput>;
  actingUserId?: InputMaybe<Scalars['uuid']>;
  actingUserProfile?: InputMaybe<UserProfilesObjRelInsertInput>;
  connectionRequest?: InputMaybe<UserConnectionRequestsObjRelInsertInput>;
  connectionRequestId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  eventGroup?: InputMaybe<EventGroupsObjRelInsertInput>;
  eventGroupId?: InputMaybe<Scalars['uuid']>;
  eventPlayerInvite?: InputMaybe<EventPlayerInvitesObjRelInsertInput>;
  eventPlayerInviteId?: InputMaybe<Scalars['uuid']>;
  group?: InputMaybe<GroupsObjRelInsertInput>;
  groupId?: InputMaybe<Scalars['uuid']>;
  groupThread?: InputMaybe<GroupThreadsObjRelInsertInput>;
  groupThreadComment?: InputMaybe<GroupThreadCommentsObjRelInsertInput>;
  groupThreadCommentId?: InputMaybe<Scalars['uuid']>;
  groupThreadId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  lesson?: InputMaybe<LessonsObjRelInsertInput>;
  lessonId?: InputMaybe<Scalars['uuid']>;
  message?: InputMaybe<MessagesObjRelInsertInput>;
  messageId?: InputMaybe<Scalars['uuid']>;
  notificationDetails?: InputMaybe<UserNotificationDetailsObjRelInsertInput>;
  partnerBookingOrder?: InputMaybe<PartnerBookingOrdersObjRelInsertInput>;
  partnerBookingOrderId?: InputMaybe<Scalars['uuid']>;
  playRequest?: InputMaybe<PlayRequestsObjRelInsertInput>;
  playRequestId?: InputMaybe<Scalars['uuid']>;
  playSession?: InputMaybe<PlaySessionsObjRelInsertInput>;
  playSessionComment?: InputMaybe<PlaySessionCommentsObjRelInsertInput>;
  playSessionCommentId?: InputMaybe<Scalars['uuid']>;
  playSessionId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  videoAnalysis?: InputMaybe<VideoAnalysisObjRelInsertInput>;
  videoAnalysisId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type UserNotificationEntitiesMaxFields = {
  __typename?: 'UserNotificationEntitiesMaxFields';
  actingUserId?: Maybe<Scalars['uuid']>;
  connectionRequestId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  eventGroupId?: Maybe<Scalars['uuid']>;
  eventPlayerInviteId?: Maybe<Scalars['uuid']>;
  groupId?: Maybe<Scalars['uuid']>;
  groupThreadCommentId?: Maybe<Scalars['uuid']>;
  groupThreadId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  lessonId?: Maybe<Scalars['uuid']>;
  messageId?: Maybe<Scalars['uuid']>;
  partnerBookingOrderId?: Maybe<Scalars['uuid']>;
  playRequestId?: Maybe<Scalars['uuid']>;
  playSessionCommentId?: Maybe<Scalars['uuid']>;
  playSessionId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  videoAnalysisId?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type UserNotificationEntitiesMinFields = {
  __typename?: 'UserNotificationEntitiesMinFields';
  actingUserId?: Maybe<Scalars['uuid']>;
  connectionRequestId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  eventGroupId?: Maybe<Scalars['uuid']>;
  eventPlayerInviteId?: Maybe<Scalars['uuid']>;
  groupId?: Maybe<Scalars['uuid']>;
  groupThreadCommentId?: Maybe<Scalars['uuid']>;
  groupThreadId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  lessonId?: Maybe<Scalars['uuid']>;
  messageId?: Maybe<Scalars['uuid']>;
  partnerBookingOrderId?: Maybe<Scalars['uuid']>;
  playRequestId?: Maybe<Scalars['uuid']>;
  playSessionCommentId?: Maybe<Scalars['uuid']>;
  playSessionId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  videoAnalysisId?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "user_notification_entities" */
export type UserNotificationEntitiesMutationResponse = {
  __typename?: 'UserNotificationEntitiesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UserNotificationEntities>;
};

/** input type for inserting object relation for remote table "user_notification_entities" */
export type UserNotificationEntitiesObjRelInsertInput = {
  data: UserNotificationEntitiesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<UserNotificationEntitiesOnConflict>;
};

/** on_conflict condition type for table "user_notification_entities" */
export type UserNotificationEntitiesOnConflict = {
  constraint: UserNotificationEntitiesConstraint;
  updateColumns?: Array<UserNotificationEntitiesUpdateColumn>;
  where?: InputMaybe<UserNotificationEntitiesBoolExp>;
};

/** Ordering options when selecting data from "user_notification_entities". */
export type UserNotificationEntitiesOrderBy = {
  actingUser?: InputMaybe<UsersOrderBy>;
  actingUserId?: InputMaybe<OrderBy>;
  actingUserProfile?: InputMaybe<UserProfilesOrderBy>;
  connectionRequest?: InputMaybe<UserConnectionRequestsOrderBy>;
  connectionRequestId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  eventGroup?: InputMaybe<EventGroupsOrderBy>;
  eventGroupId?: InputMaybe<OrderBy>;
  eventPlayerInvite?: InputMaybe<EventPlayerInvitesOrderBy>;
  eventPlayerInviteId?: InputMaybe<OrderBy>;
  group?: InputMaybe<GroupsOrderBy>;
  groupId?: InputMaybe<OrderBy>;
  groupThread?: InputMaybe<GroupThreadsOrderBy>;
  groupThreadComment?: InputMaybe<GroupThreadCommentsOrderBy>;
  groupThreadCommentId?: InputMaybe<OrderBy>;
  groupThreadId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lesson?: InputMaybe<LessonsOrderBy>;
  lessonId?: InputMaybe<OrderBy>;
  message?: InputMaybe<MessagesOrderBy>;
  messageId?: InputMaybe<OrderBy>;
  notificationDetails?: InputMaybe<UserNotificationDetailsOrderBy>;
  partnerBookingOrder?: InputMaybe<PartnerBookingOrdersOrderBy>;
  partnerBookingOrderId?: InputMaybe<OrderBy>;
  playRequest?: InputMaybe<PlayRequestsOrderBy>;
  playRequestId?: InputMaybe<OrderBy>;
  playSession?: InputMaybe<PlaySessionsOrderBy>;
  playSessionComment?: InputMaybe<PlaySessionCommentsOrderBy>;
  playSessionCommentId?: InputMaybe<OrderBy>;
  playSessionId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  videoAnalysis?: InputMaybe<VideoAnalysisOrderBy>;
  videoAnalysisId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: user_notification_entities */
export type UserNotificationEntitiesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "user_notification_entities" */
export enum UserNotificationEntitiesSelectColumn {
  /** column name */
  ActingUserId = 'actingUserId',
  /** column name */
  ConnectionRequestId = 'connectionRequestId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EventGroupId = 'eventGroupId',
  /** column name */
  EventPlayerInviteId = 'eventPlayerInviteId',
  /** column name */
  GroupId = 'groupId',
  /** column name */
  GroupThreadCommentId = 'groupThreadCommentId',
  /** column name */
  GroupThreadId = 'groupThreadId',
  /** column name */
  Id = 'id',
  /** column name */
  LessonId = 'lessonId',
  /** column name */
  MessageId = 'messageId',
  /** column name */
  PartnerBookingOrderId = 'partnerBookingOrderId',
  /** column name */
  PlayRequestId = 'playRequestId',
  /** column name */
  PlaySessionCommentId = 'playSessionCommentId',
  /** column name */
  PlaySessionId = 'playSessionId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  VideoAnalysisId = 'videoAnalysisId'
}

/** input type for updating data in table "user_notification_entities" */
export type UserNotificationEntitiesSetInput = {
  actingUserId?: InputMaybe<Scalars['uuid']>;
  connectionRequestId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  eventGroupId?: InputMaybe<Scalars['uuid']>;
  eventPlayerInviteId?: InputMaybe<Scalars['uuid']>;
  groupId?: InputMaybe<Scalars['uuid']>;
  groupThreadCommentId?: InputMaybe<Scalars['uuid']>;
  groupThreadId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  lessonId?: InputMaybe<Scalars['uuid']>;
  messageId?: InputMaybe<Scalars['uuid']>;
  partnerBookingOrderId?: InputMaybe<Scalars['uuid']>;
  playRequestId?: InputMaybe<Scalars['uuid']>;
  playSessionCommentId?: InputMaybe<Scalars['uuid']>;
  playSessionId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  videoAnalysisId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "user_notification_entities" */
export type UserNotificationEntitiesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UserNotificationEntitiesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserNotificationEntitiesStreamCursorValueInput = {
  actingUserId?: InputMaybe<Scalars['uuid']>;
  connectionRequestId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  eventGroupId?: InputMaybe<Scalars['uuid']>;
  eventPlayerInviteId?: InputMaybe<Scalars['uuid']>;
  groupId?: InputMaybe<Scalars['uuid']>;
  groupThreadCommentId?: InputMaybe<Scalars['uuid']>;
  groupThreadId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  lessonId?: InputMaybe<Scalars['uuid']>;
  messageId?: InputMaybe<Scalars['uuid']>;
  partnerBookingOrderId?: InputMaybe<Scalars['uuid']>;
  playRequestId?: InputMaybe<Scalars['uuid']>;
  playSessionCommentId?: InputMaybe<Scalars['uuid']>;
  playSessionId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  videoAnalysisId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "user_notification_entities" */
export enum UserNotificationEntitiesUpdateColumn {
  /** column name */
  ActingUserId = 'actingUserId',
  /** column name */
  ConnectionRequestId = 'connectionRequestId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EventGroupId = 'eventGroupId',
  /** column name */
  EventPlayerInviteId = 'eventPlayerInviteId',
  /** column name */
  GroupId = 'groupId',
  /** column name */
  GroupThreadCommentId = 'groupThreadCommentId',
  /** column name */
  GroupThreadId = 'groupThreadId',
  /** column name */
  Id = 'id',
  /** column name */
  LessonId = 'lessonId',
  /** column name */
  MessageId = 'messageId',
  /** column name */
  PartnerBookingOrderId = 'partnerBookingOrderId',
  /** column name */
  PlayRequestId = 'playRequestId',
  /** column name */
  PlaySessionCommentId = 'playSessionCommentId',
  /** column name */
  PlaySessionId = 'playSessionId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  VideoAnalysisId = 'videoAnalysisId'
}

export type UserNotificationEntitiesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserNotificationEntitiesSetInput>;
  /** filter the rows which have to be updated */
  where: UserNotificationEntitiesBoolExp;
};

/** columns and relationships of "user_notifications" */
export type UserNotifications = {
  __typename?: 'UserNotifications';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  /** An object relationship */
  notificationDetails: UserNotificationDetails;
  readAt?: Maybe<Scalars['timestamptz']>;
  status: NotificationStatusesEnum;
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid'];
  userNotificationDetailId: Scalars['uuid'];
  videoAnalysisId?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "user_notifications" */
export type UserNotificationsAggregate = {
  __typename?: 'UserNotificationsAggregate';
  aggregate?: Maybe<UserNotificationsAggregateFields>;
  nodes: Array<UserNotifications>;
};

export type UserNotificationsAggregateBoolExp = {
  count?: InputMaybe<UserNotificationsAggregateBoolExpCount>;
};

/** aggregate fields of "user_notifications" */
export type UserNotificationsAggregateFields = {
  __typename?: 'UserNotificationsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<UserNotificationsMaxFields>;
  min?: Maybe<UserNotificationsMinFields>;
};


/** aggregate fields of "user_notifications" */
export type UserNotificationsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<UserNotificationsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_notifications" */
export type UserNotificationsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<UserNotificationsMaxOrderBy>;
  min?: InputMaybe<UserNotificationsMinOrderBy>;
};

/** input type for inserting array relation for remote table "user_notifications" */
export type UserNotificationsArrRelInsertInput = {
  data: Array<UserNotificationsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<UserNotificationsOnConflict>;
};

/** Boolean expression to filter rows from the table "user_notifications". All fields are combined with a logical 'AND'. */
export type UserNotificationsBoolExp = {
  _and?: InputMaybe<Array<UserNotificationsBoolExp>>;
  _not?: InputMaybe<UserNotificationsBoolExp>;
  _or?: InputMaybe<Array<UserNotificationsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  notificationDetails?: InputMaybe<UserNotificationDetailsBoolExp>;
  readAt?: InputMaybe<TimestamptzComparisonExp>;
  status?: InputMaybe<NotificationStatusesEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
  userNotificationDetailId?: InputMaybe<UuidComparisonExp>;
  videoAnalysisId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "user_notifications" */
export enum UserNotificationsConstraint {
  /** unique or primary key constraint on columns "id" */
  UserNotificationsPkey = 'user_notifications_pkey'
}

/** input type for inserting data into table "user_notifications" */
export type UserNotificationsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  notificationDetails?: InputMaybe<UserNotificationDetailsObjRelInsertInput>;
  readAt?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<NotificationStatusesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']>;
  userNotificationDetailId?: InputMaybe<Scalars['uuid']>;
  videoAnalysisId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type UserNotificationsMaxFields = {
  __typename?: 'UserNotificationsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  readAt?: Maybe<Scalars['timestamptz']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
  userNotificationDetailId?: Maybe<Scalars['uuid']>;
  videoAnalysisId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "user_notifications" */
export type UserNotificationsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  readAt?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
  userNotificationDetailId?: InputMaybe<OrderBy>;
  videoAnalysisId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type UserNotificationsMinFields = {
  __typename?: 'UserNotificationsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  readAt?: Maybe<Scalars['timestamptz']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
  userNotificationDetailId?: Maybe<Scalars['uuid']>;
  videoAnalysisId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "user_notifications" */
export type UserNotificationsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  readAt?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
  userNotificationDetailId?: InputMaybe<OrderBy>;
  videoAnalysisId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "user_notifications" */
export type UserNotificationsMutationResponse = {
  __typename?: 'UserNotificationsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UserNotifications>;
};

/** on_conflict condition type for table "user_notifications" */
export type UserNotificationsOnConflict = {
  constraint: UserNotificationsConstraint;
  updateColumns?: Array<UserNotificationsUpdateColumn>;
  where?: InputMaybe<UserNotificationsBoolExp>;
};

/** Ordering options when selecting data from "user_notifications". */
export type UserNotificationsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  notificationDetails?: InputMaybe<UserNotificationDetailsOrderBy>;
  readAt?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
  userNotificationDetailId?: InputMaybe<OrderBy>;
  videoAnalysisId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: user_notifications */
export type UserNotificationsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "user_notifications" */
export enum UserNotificationsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  ReadAt = 'readAt',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId',
  /** column name */
  UserNotificationDetailId = 'userNotificationDetailId',
  /** column name */
  VideoAnalysisId = 'videoAnalysisId'
}

/** input type for updating data in table "user_notifications" */
export type UserNotificationsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  readAt?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<NotificationStatusesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
  userNotificationDetailId?: InputMaybe<Scalars['uuid']>;
  videoAnalysisId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "user_notifications" */
export type UserNotificationsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UserNotificationsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserNotificationsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  readAt?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<NotificationStatusesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
  userNotificationDetailId?: InputMaybe<Scalars['uuid']>;
  videoAnalysisId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "user_notifications" */
export enum UserNotificationsUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  ReadAt = 'readAt',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId',
  /** column name */
  UserNotificationDetailId = 'userNotificationDetailId',
  /** column name */
  VideoAnalysisId = 'videoAnalysisId'
}

export type UserNotificationsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserNotificationsSetInput>;
  /** filter the rows which have to be updated */
  where: UserNotificationsBoolExp;
};

/** columns and relationships of "user_padel_rating_scales" */
export type UserPadelRatingScales = {
  __typename?: 'UserPadelRatingScales';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  padelRatingScaleId: Scalars['uuid'];
  rating: Scalars['numeric'];
  /** An object relationship */
  scale: PadelRatingScales;
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid'];
};

/** aggregated selection of "user_padel_rating_scales" */
export type UserPadelRatingScalesAggregate = {
  __typename?: 'UserPadelRatingScalesAggregate';
  aggregate?: Maybe<UserPadelRatingScalesAggregateFields>;
  nodes: Array<UserPadelRatingScales>;
};

export type UserPadelRatingScalesAggregateBoolExp = {
  count?: InputMaybe<UserPadelRatingScalesAggregateBoolExpCount>;
};

/** aggregate fields of "user_padel_rating_scales" */
export type UserPadelRatingScalesAggregateFields = {
  __typename?: 'UserPadelRatingScalesAggregateFields';
  avg?: Maybe<UserPadelRatingScalesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<UserPadelRatingScalesMaxFields>;
  min?: Maybe<UserPadelRatingScalesMinFields>;
  stddev?: Maybe<UserPadelRatingScalesStddevFields>;
  stddevPop?: Maybe<UserPadelRatingScalesStddevPopFields>;
  stddevSamp?: Maybe<UserPadelRatingScalesStddevSampFields>;
  sum?: Maybe<UserPadelRatingScalesSumFields>;
  varPop?: Maybe<UserPadelRatingScalesVarPopFields>;
  varSamp?: Maybe<UserPadelRatingScalesVarSampFields>;
  variance?: Maybe<UserPadelRatingScalesVarianceFields>;
};


/** aggregate fields of "user_padel_rating_scales" */
export type UserPadelRatingScalesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<UserPadelRatingScalesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_padel_rating_scales" */
export type UserPadelRatingScalesAggregateOrderBy = {
  avg?: InputMaybe<UserPadelRatingScalesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<UserPadelRatingScalesMaxOrderBy>;
  min?: InputMaybe<UserPadelRatingScalesMinOrderBy>;
  stddev?: InputMaybe<UserPadelRatingScalesStddevOrderBy>;
  stddevPop?: InputMaybe<UserPadelRatingScalesStddevPopOrderBy>;
  stddevSamp?: InputMaybe<UserPadelRatingScalesStddevSampOrderBy>;
  sum?: InputMaybe<UserPadelRatingScalesSumOrderBy>;
  varPop?: InputMaybe<UserPadelRatingScalesVarPopOrderBy>;
  varSamp?: InputMaybe<UserPadelRatingScalesVarSampOrderBy>;
  variance?: InputMaybe<UserPadelRatingScalesVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "user_padel_rating_scales" */
export type UserPadelRatingScalesArrRelInsertInput = {
  data: Array<UserPadelRatingScalesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<UserPadelRatingScalesOnConflict>;
};

/** aggregate avg on columns */
export type UserPadelRatingScalesAvgFields = {
  __typename?: 'UserPadelRatingScalesAvgFields';
  rating?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "user_padel_rating_scales" */
export type UserPadelRatingScalesAvgOrderBy = {
  rating?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "user_padel_rating_scales". All fields are combined with a logical 'AND'. */
export type UserPadelRatingScalesBoolExp = {
  _and?: InputMaybe<Array<UserPadelRatingScalesBoolExp>>;
  _not?: InputMaybe<UserPadelRatingScalesBoolExp>;
  _or?: InputMaybe<Array<UserPadelRatingScalesBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  padelRatingScaleId?: InputMaybe<UuidComparisonExp>;
  rating?: InputMaybe<NumericComparisonExp>;
  scale?: InputMaybe<PadelRatingScalesBoolExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "user_padel_rating_scales" */
export enum UserPadelRatingScalesConstraint {
  /** unique or primary key constraint on columns "id" */
  UserPadelRatingScalesPkey = 'user_padel_rating_scales_pkey',
  /** unique or primary key constraint on columns "user_id", "padel_rating_scale_id" */
  UserPadelRatingScalesUserIdPadelRatingScaleIdKey = 'user_padel_rating_scales_user_id_padel_rating_scale_id_key'
}

/** input type for incrementing numeric columns in table "user_padel_rating_scales" */
export type UserPadelRatingScalesIncInput = {
  rating?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "user_padel_rating_scales" */
export type UserPadelRatingScalesInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  padelRatingScaleId?: InputMaybe<Scalars['uuid']>;
  rating?: InputMaybe<Scalars['numeric']>;
  scale?: InputMaybe<PadelRatingScalesObjRelInsertInput>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type UserPadelRatingScalesMaxFields = {
  __typename?: 'UserPadelRatingScalesMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  padelRatingScaleId?: Maybe<Scalars['uuid']>;
  rating?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "user_padel_rating_scales" */
export type UserPadelRatingScalesMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  padelRatingScaleId?: InputMaybe<OrderBy>;
  rating?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type UserPadelRatingScalesMinFields = {
  __typename?: 'UserPadelRatingScalesMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  padelRatingScaleId?: Maybe<Scalars['uuid']>;
  rating?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "user_padel_rating_scales" */
export type UserPadelRatingScalesMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  padelRatingScaleId?: InputMaybe<OrderBy>;
  rating?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "user_padel_rating_scales" */
export type UserPadelRatingScalesMutationResponse = {
  __typename?: 'UserPadelRatingScalesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UserPadelRatingScales>;
};

/** on_conflict condition type for table "user_padel_rating_scales" */
export type UserPadelRatingScalesOnConflict = {
  constraint: UserPadelRatingScalesConstraint;
  updateColumns?: Array<UserPadelRatingScalesUpdateColumn>;
  where?: InputMaybe<UserPadelRatingScalesBoolExp>;
};

/** Ordering options when selecting data from "user_padel_rating_scales". */
export type UserPadelRatingScalesOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  padelRatingScaleId?: InputMaybe<OrderBy>;
  rating?: InputMaybe<OrderBy>;
  scale?: InputMaybe<PadelRatingScalesOrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: user_padel_rating_scales */
export type UserPadelRatingScalesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "user_padel_rating_scales" */
export enum UserPadelRatingScalesSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  PadelRatingScaleId = 'padelRatingScaleId',
  /** column name */
  Rating = 'rating',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "user_padel_rating_scales" */
export type UserPadelRatingScalesSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  padelRatingScaleId?: InputMaybe<Scalars['uuid']>;
  rating?: InputMaybe<Scalars['numeric']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type UserPadelRatingScalesStddevFields = {
  __typename?: 'UserPadelRatingScalesStddevFields';
  rating?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "user_padel_rating_scales" */
export type UserPadelRatingScalesStddevOrderBy = {
  rating?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type UserPadelRatingScalesStddevPopFields = {
  __typename?: 'UserPadelRatingScalesStddevPopFields';
  rating?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "user_padel_rating_scales" */
export type UserPadelRatingScalesStddevPopOrderBy = {
  rating?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type UserPadelRatingScalesStddevSampFields = {
  __typename?: 'UserPadelRatingScalesStddevSampFields';
  rating?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "user_padel_rating_scales" */
export type UserPadelRatingScalesStddevSampOrderBy = {
  rating?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "user_padel_rating_scales" */
export type UserPadelRatingScalesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UserPadelRatingScalesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserPadelRatingScalesStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  padelRatingScaleId?: InputMaybe<Scalars['uuid']>;
  rating?: InputMaybe<Scalars['numeric']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type UserPadelRatingScalesSumFields = {
  __typename?: 'UserPadelRatingScalesSumFields';
  rating?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "user_padel_rating_scales" */
export type UserPadelRatingScalesSumOrderBy = {
  rating?: InputMaybe<OrderBy>;
};

/** update columns of table "user_padel_rating_scales" */
export enum UserPadelRatingScalesUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  PadelRatingScaleId = 'padelRatingScaleId',
  /** column name */
  Rating = 'rating',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

export type UserPadelRatingScalesUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<UserPadelRatingScalesIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserPadelRatingScalesSetInput>;
  /** filter the rows which have to be updated */
  where: UserPadelRatingScalesBoolExp;
};

/** aggregate varPop on columns */
export type UserPadelRatingScalesVarPopFields = {
  __typename?: 'UserPadelRatingScalesVarPopFields';
  rating?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "user_padel_rating_scales" */
export type UserPadelRatingScalesVarPopOrderBy = {
  rating?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type UserPadelRatingScalesVarSampFields = {
  __typename?: 'UserPadelRatingScalesVarSampFields';
  rating?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "user_padel_rating_scales" */
export type UserPadelRatingScalesVarSampOrderBy = {
  rating?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type UserPadelRatingScalesVarianceFields = {
  __typename?: 'UserPadelRatingScalesVarianceFields';
  rating?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "user_padel_rating_scales" */
export type UserPadelRatingScalesVarianceOrderBy = {
  rating?: InputMaybe<OrderBy>;
};

/** columns and relationships of "user_pickleball_rating_scales" */
export type UserPickleballRatingScales = {
  __typename?: 'UserPickleballRatingScales';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  pickleballRatingScaleId: Scalars['uuid'];
  rating: Scalars['numeric'];
  /** An object relationship */
  scale: PickleballRatingScales;
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid'];
};

/** aggregated selection of "user_pickleball_rating_scales" */
export type UserPickleballRatingScalesAggregate = {
  __typename?: 'UserPickleballRatingScalesAggregate';
  aggregate?: Maybe<UserPickleballRatingScalesAggregateFields>;
  nodes: Array<UserPickleballRatingScales>;
};

export type UserPickleballRatingScalesAggregateBoolExp = {
  count?: InputMaybe<UserPickleballRatingScalesAggregateBoolExpCount>;
};

/** aggregate fields of "user_pickleball_rating_scales" */
export type UserPickleballRatingScalesAggregateFields = {
  __typename?: 'UserPickleballRatingScalesAggregateFields';
  avg?: Maybe<UserPickleballRatingScalesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<UserPickleballRatingScalesMaxFields>;
  min?: Maybe<UserPickleballRatingScalesMinFields>;
  stddev?: Maybe<UserPickleballRatingScalesStddevFields>;
  stddevPop?: Maybe<UserPickleballRatingScalesStddevPopFields>;
  stddevSamp?: Maybe<UserPickleballRatingScalesStddevSampFields>;
  sum?: Maybe<UserPickleballRatingScalesSumFields>;
  varPop?: Maybe<UserPickleballRatingScalesVarPopFields>;
  varSamp?: Maybe<UserPickleballRatingScalesVarSampFields>;
  variance?: Maybe<UserPickleballRatingScalesVarianceFields>;
};


/** aggregate fields of "user_pickleball_rating_scales" */
export type UserPickleballRatingScalesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<UserPickleballRatingScalesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_pickleball_rating_scales" */
export type UserPickleballRatingScalesAggregateOrderBy = {
  avg?: InputMaybe<UserPickleballRatingScalesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<UserPickleballRatingScalesMaxOrderBy>;
  min?: InputMaybe<UserPickleballRatingScalesMinOrderBy>;
  stddev?: InputMaybe<UserPickleballRatingScalesStddevOrderBy>;
  stddevPop?: InputMaybe<UserPickleballRatingScalesStddevPopOrderBy>;
  stddevSamp?: InputMaybe<UserPickleballRatingScalesStddevSampOrderBy>;
  sum?: InputMaybe<UserPickleballRatingScalesSumOrderBy>;
  varPop?: InputMaybe<UserPickleballRatingScalesVarPopOrderBy>;
  varSamp?: InputMaybe<UserPickleballRatingScalesVarSampOrderBy>;
  variance?: InputMaybe<UserPickleballRatingScalesVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "user_pickleball_rating_scales" */
export type UserPickleballRatingScalesArrRelInsertInput = {
  data: Array<UserPickleballRatingScalesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<UserPickleballRatingScalesOnConflict>;
};

/** aggregate avg on columns */
export type UserPickleballRatingScalesAvgFields = {
  __typename?: 'UserPickleballRatingScalesAvgFields';
  rating?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "user_pickleball_rating_scales" */
export type UserPickleballRatingScalesAvgOrderBy = {
  rating?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "user_pickleball_rating_scales". All fields are combined with a logical 'AND'. */
export type UserPickleballRatingScalesBoolExp = {
  _and?: InputMaybe<Array<UserPickleballRatingScalesBoolExp>>;
  _not?: InputMaybe<UserPickleballRatingScalesBoolExp>;
  _or?: InputMaybe<Array<UserPickleballRatingScalesBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  pickleballRatingScaleId?: InputMaybe<UuidComparisonExp>;
  rating?: InputMaybe<NumericComparisonExp>;
  scale?: InputMaybe<PickleballRatingScalesBoolExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "user_pickleball_rating_scales" */
export enum UserPickleballRatingScalesConstraint {
  /** unique or primary key constraint on columns "id" */
  UserPickleballRatingScalesPkey = 'user_pickleball_rating_scales_pkey',
  /** unique or primary key constraint on columns "pickleball_rating_scale_id", "user_id" */
  UserPickleballRatingScalesUserIdPickleballRatingScaKey = 'user_pickleball_rating_scales_user_id_pickleball_rating_sca_key'
}

/** input type for incrementing numeric columns in table "user_pickleball_rating_scales" */
export type UserPickleballRatingScalesIncInput = {
  rating?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "user_pickleball_rating_scales" */
export type UserPickleballRatingScalesInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  pickleballRatingScaleId?: InputMaybe<Scalars['uuid']>;
  rating?: InputMaybe<Scalars['numeric']>;
  scale?: InputMaybe<PickleballRatingScalesObjRelInsertInput>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type UserPickleballRatingScalesMaxFields = {
  __typename?: 'UserPickleballRatingScalesMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  pickleballRatingScaleId?: Maybe<Scalars['uuid']>;
  rating?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "user_pickleball_rating_scales" */
export type UserPickleballRatingScalesMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  pickleballRatingScaleId?: InputMaybe<OrderBy>;
  rating?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type UserPickleballRatingScalesMinFields = {
  __typename?: 'UserPickleballRatingScalesMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  pickleballRatingScaleId?: Maybe<Scalars['uuid']>;
  rating?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "user_pickleball_rating_scales" */
export type UserPickleballRatingScalesMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  pickleballRatingScaleId?: InputMaybe<OrderBy>;
  rating?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "user_pickleball_rating_scales" */
export type UserPickleballRatingScalesMutationResponse = {
  __typename?: 'UserPickleballRatingScalesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UserPickleballRatingScales>;
};

/** on_conflict condition type for table "user_pickleball_rating_scales" */
export type UserPickleballRatingScalesOnConflict = {
  constraint: UserPickleballRatingScalesConstraint;
  updateColumns?: Array<UserPickleballRatingScalesUpdateColumn>;
  where?: InputMaybe<UserPickleballRatingScalesBoolExp>;
};

/** Ordering options when selecting data from "user_pickleball_rating_scales". */
export type UserPickleballRatingScalesOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  pickleballRatingScaleId?: InputMaybe<OrderBy>;
  rating?: InputMaybe<OrderBy>;
  scale?: InputMaybe<PickleballRatingScalesOrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: user_pickleball_rating_scales */
export type UserPickleballRatingScalesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "user_pickleball_rating_scales" */
export enum UserPickleballRatingScalesSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  PickleballRatingScaleId = 'pickleballRatingScaleId',
  /** column name */
  Rating = 'rating',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "user_pickleball_rating_scales" */
export type UserPickleballRatingScalesSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  pickleballRatingScaleId?: InputMaybe<Scalars['uuid']>;
  rating?: InputMaybe<Scalars['numeric']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type UserPickleballRatingScalesStddevFields = {
  __typename?: 'UserPickleballRatingScalesStddevFields';
  rating?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "user_pickleball_rating_scales" */
export type UserPickleballRatingScalesStddevOrderBy = {
  rating?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type UserPickleballRatingScalesStddevPopFields = {
  __typename?: 'UserPickleballRatingScalesStddevPopFields';
  rating?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "user_pickleball_rating_scales" */
export type UserPickleballRatingScalesStddevPopOrderBy = {
  rating?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type UserPickleballRatingScalesStddevSampFields = {
  __typename?: 'UserPickleballRatingScalesStddevSampFields';
  rating?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "user_pickleball_rating_scales" */
export type UserPickleballRatingScalesStddevSampOrderBy = {
  rating?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "user_pickleball_rating_scales" */
export type UserPickleballRatingScalesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UserPickleballRatingScalesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserPickleballRatingScalesStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  pickleballRatingScaleId?: InputMaybe<Scalars['uuid']>;
  rating?: InputMaybe<Scalars['numeric']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type UserPickleballRatingScalesSumFields = {
  __typename?: 'UserPickleballRatingScalesSumFields';
  rating?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "user_pickleball_rating_scales" */
export type UserPickleballRatingScalesSumOrderBy = {
  rating?: InputMaybe<OrderBy>;
};

/** update columns of table "user_pickleball_rating_scales" */
export enum UserPickleballRatingScalesUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  PickleballRatingScaleId = 'pickleballRatingScaleId',
  /** column name */
  Rating = 'rating',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

export type UserPickleballRatingScalesUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<UserPickleballRatingScalesIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserPickleballRatingScalesSetInput>;
  /** filter the rows which have to be updated */
  where: UserPickleballRatingScalesBoolExp;
};

/** aggregate varPop on columns */
export type UserPickleballRatingScalesVarPopFields = {
  __typename?: 'UserPickleballRatingScalesVarPopFields';
  rating?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "user_pickleball_rating_scales" */
export type UserPickleballRatingScalesVarPopOrderBy = {
  rating?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type UserPickleballRatingScalesVarSampFields = {
  __typename?: 'UserPickleballRatingScalesVarSampFields';
  rating?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "user_pickleball_rating_scales" */
export type UserPickleballRatingScalesVarSampOrderBy = {
  rating?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type UserPickleballRatingScalesVarianceFields = {
  __typename?: 'UserPickleballRatingScalesVarianceFields';
  rating?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "user_pickleball_rating_scales" */
export type UserPickleballRatingScalesVarianceOrderBy = {
  rating?: InputMaybe<OrderBy>;
};

/** columns and relationships of "user_played_with" */
export type UserPlayedWith = {
  __typename?: 'UserPlayedWith';
  /** An array relationship */
  games: Array<UserPlayedWithGames>;
  /** An aggregate relationship */
  gamesAggregate: UserPlayedWithGamesAggregate;
  gamesTogether?: Maybe<Scalars['Int']>;
  lastPlayedAt?: Maybe<Scalars['timestamptz']>;
  otherUserId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  otherUserProfile?: Maybe<UserProfiles>;
  userId?: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "user_played_with" */
export type UserPlayedWithGamesArgs = {
  distinctOn?: InputMaybe<Array<UserPlayedWithGamesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPlayedWithGamesOrderBy>>;
  where?: InputMaybe<UserPlayedWithGamesBoolExp>;
};


/** columns and relationships of "user_played_with" */
export type UserPlayedWithGamesAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserPlayedWithGamesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPlayedWithGamesOrderBy>>;
  where?: InputMaybe<UserPlayedWithGamesBoolExp>;
};

/** aggregated selection of "user_played_with" */
export type UserPlayedWithAggregate = {
  __typename?: 'UserPlayedWithAggregate';
  aggregate?: Maybe<UserPlayedWithAggregateFields>;
  nodes: Array<UserPlayedWith>;
};

/** aggregate fields of "user_played_with" */
export type UserPlayedWithAggregateFields = {
  __typename?: 'UserPlayedWithAggregateFields';
  avg?: Maybe<UserPlayedWithAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<UserPlayedWithMaxFields>;
  min?: Maybe<UserPlayedWithMinFields>;
  stddev?: Maybe<UserPlayedWithStddevFields>;
  stddevPop?: Maybe<UserPlayedWithStddevPopFields>;
  stddevSamp?: Maybe<UserPlayedWithStddevSampFields>;
  sum?: Maybe<UserPlayedWithSumFields>;
  varPop?: Maybe<UserPlayedWithVarPopFields>;
  varSamp?: Maybe<UserPlayedWithVarSampFields>;
  variance?: Maybe<UserPlayedWithVarianceFields>;
};


/** aggregate fields of "user_played_with" */
export type UserPlayedWithAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<UserPlayedWithSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type UserPlayedWithAvgFields = {
  __typename?: 'UserPlayedWithAvgFields';
  gamesTogether?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "user_played_with". All fields are combined with a logical 'AND'. */
export type UserPlayedWithBoolExp = {
  _and?: InputMaybe<Array<UserPlayedWithBoolExp>>;
  _not?: InputMaybe<UserPlayedWithBoolExp>;
  _or?: InputMaybe<Array<UserPlayedWithBoolExp>>;
  games?: InputMaybe<UserPlayedWithGamesBoolExp>;
  gamesAggregate?: InputMaybe<UserPlayedWithGamesAggregateBoolExp>;
  gamesTogether?: InputMaybe<IntComparisonExp>;
  lastPlayedAt?: InputMaybe<TimestamptzComparisonExp>;
  otherUserId?: InputMaybe<UuidComparisonExp>;
  otherUserProfile?: InputMaybe<UserProfilesBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** columns and relationships of "user_played_with_dismissals" */
export type UserPlayedWithDismissals = {
  __typename?: 'UserPlayedWithDismissals';
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  dismissedUser: Users;
  dismissedUserId: Scalars['uuid'];
  id: Scalars['uuid'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid'];
};

/** aggregated selection of "user_played_with_dismissals" */
export type UserPlayedWithDismissalsAggregate = {
  __typename?: 'UserPlayedWithDismissalsAggregate';
  aggregate?: Maybe<UserPlayedWithDismissalsAggregateFields>;
  nodes: Array<UserPlayedWithDismissals>;
};

/** aggregate fields of "user_played_with_dismissals" */
export type UserPlayedWithDismissalsAggregateFields = {
  __typename?: 'UserPlayedWithDismissalsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<UserPlayedWithDismissalsMaxFields>;
  min?: Maybe<UserPlayedWithDismissalsMinFields>;
};


/** aggregate fields of "user_played_with_dismissals" */
export type UserPlayedWithDismissalsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<UserPlayedWithDismissalsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "user_played_with_dismissals". All fields are combined with a logical 'AND'. */
export type UserPlayedWithDismissalsBoolExp = {
  _and?: InputMaybe<Array<UserPlayedWithDismissalsBoolExp>>;
  _not?: InputMaybe<UserPlayedWithDismissalsBoolExp>;
  _or?: InputMaybe<Array<UserPlayedWithDismissalsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  dismissedUser?: InputMaybe<UsersBoolExp>;
  dismissedUserId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "user_played_with_dismissals" */
export enum UserPlayedWithDismissalsConstraint {
  /** unique or primary key constraint on columns "id" */
  UserPlayedWithDismissalsPkey = 'user_played_with_dismissals_pkey',
  /** unique or primary key constraint on columns "user_id", "dismissed_user_id" */
  UserPlayedWithDismissalsUserIdDismissedUserIdKey = 'user_played_with_dismissals_user_id_dismissed_user_id_key'
}

/** input type for inserting data into table "user_played_with_dismissals" */
export type UserPlayedWithDismissalsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  dismissedUser?: InputMaybe<UsersObjRelInsertInput>;
  dismissedUserId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type UserPlayedWithDismissalsMaxFields = {
  __typename?: 'UserPlayedWithDismissalsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  dismissedUserId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type UserPlayedWithDismissalsMinFields = {
  __typename?: 'UserPlayedWithDismissalsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  dismissedUserId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "user_played_with_dismissals" */
export type UserPlayedWithDismissalsMutationResponse = {
  __typename?: 'UserPlayedWithDismissalsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UserPlayedWithDismissals>;
};

/** on_conflict condition type for table "user_played_with_dismissals" */
export type UserPlayedWithDismissalsOnConflict = {
  constraint: UserPlayedWithDismissalsConstraint;
  updateColumns?: Array<UserPlayedWithDismissalsUpdateColumn>;
  where?: InputMaybe<UserPlayedWithDismissalsBoolExp>;
};

/** Ordering options when selecting data from "user_played_with_dismissals". */
export type UserPlayedWithDismissalsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  dismissedUser?: InputMaybe<UsersOrderBy>;
  dismissedUserId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: user_played_with_dismissals */
export type UserPlayedWithDismissalsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "user_played_with_dismissals" */
export enum UserPlayedWithDismissalsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DismissedUserId = 'dismissedUserId',
  /** column name */
  Id = 'id',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "user_played_with_dismissals" */
export type UserPlayedWithDismissalsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  dismissedUserId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "user_played_with_dismissals" */
export type UserPlayedWithDismissalsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UserPlayedWithDismissalsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserPlayedWithDismissalsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  dismissedUserId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "user_played_with_dismissals" */
export enum UserPlayedWithDismissalsUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DismissedUserId = 'dismissedUserId',
  /** column name */
  Id = 'id',
  /** column name */
  UserId = 'userId'
}

export type UserPlayedWithDismissalsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserPlayedWithDismissalsSetInput>;
  /** filter the rows which have to be updated */
  where: UserPlayedWithDismissalsBoolExp;
};

/** columns and relationships of "user_played_with_games" */
export type UserPlayedWithGames = {
  __typename?: 'UserPlayedWithGames';
  /** An object relationship */
  event?: Maybe<Events>;
  eventId?: Maybe<Scalars['uuid']>;
  otherUserId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  otherUserProfile?: Maybe<UserProfiles>;
  startDateTime?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "user_played_with_games" */
export type UserPlayedWithGamesAggregate = {
  __typename?: 'UserPlayedWithGamesAggregate';
  aggregate?: Maybe<UserPlayedWithGamesAggregateFields>;
  nodes: Array<UserPlayedWithGames>;
};

export type UserPlayedWithGamesAggregateBoolExp = {
  count?: InputMaybe<UserPlayedWithGamesAggregateBoolExpCount>;
};

/** aggregate fields of "user_played_with_games" */
export type UserPlayedWithGamesAggregateFields = {
  __typename?: 'UserPlayedWithGamesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<UserPlayedWithGamesMaxFields>;
  min?: Maybe<UserPlayedWithGamesMinFields>;
};


/** aggregate fields of "user_played_with_games" */
export type UserPlayedWithGamesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<UserPlayedWithGamesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_played_with_games" */
export type UserPlayedWithGamesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<UserPlayedWithGamesMaxOrderBy>;
  min?: InputMaybe<UserPlayedWithGamesMinOrderBy>;
};

/** Boolean expression to filter rows from the table "user_played_with_games". All fields are combined with a logical 'AND'. */
export type UserPlayedWithGamesBoolExp = {
  _and?: InputMaybe<Array<UserPlayedWithGamesBoolExp>>;
  _not?: InputMaybe<UserPlayedWithGamesBoolExp>;
  _or?: InputMaybe<Array<UserPlayedWithGamesBoolExp>>;
  event?: InputMaybe<EventsBoolExp>;
  eventId?: InputMaybe<UuidComparisonExp>;
  otherUserId?: InputMaybe<UuidComparisonExp>;
  otherUserProfile?: InputMaybe<UserProfilesBoolExp>;
  startDateTime?: InputMaybe<TimestamptzComparisonExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** aggregate max on columns */
export type UserPlayedWithGamesMaxFields = {
  __typename?: 'UserPlayedWithGamesMaxFields';
  eventId?: Maybe<Scalars['uuid']>;
  otherUserId?: Maybe<Scalars['uuid']>;
  startDateTime?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "user_played_with_games" */
export type UserPlayedWithGamesMaxOrderBy = {
  eventId?: InputMaybe<OrderBy>;
  otherUserId?: InputMaybe<OrderBy>;
  startDateTime?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type UserPlayedWithGamesMinFields = {
  __typename?: 'UserPlayedWithGamesMinFields';
  eventId?: Maybe<Scalars['uuid']>;
  otherUserId?: Maybe<Scalars['uuid']>;
  startDateTime?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "user_played_with_games" */
export type UserPlayedWithGamesMinOrderBy = {
  eventId?: InputMaybe<OrderBy>;
  otherUserId?: InputMaybe<OrderBy>;
  startDateTime?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "user_played_with_games". */
export type UserPlayedWithGamesOrderBy = {
  event?: InputMaybe<EventsOrderBy>;
  eventId?: InputMaybe<OrderBy>;
  otherUserId?: InputMaybe<OrderBy>;
  otherUserProfile?: InputMaybe<UserProfilesOrderBy>;
  startDateTime?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** select columns of table "user_played_with_games" */
export enum UserPlayedWithGamesSelectColumn {
  /** column name */
  EventId = 'eventId',
  /** column name */
  OtherUserId = 'otherUserId',
  /** column name */
  StartDateTime = 'startDateTime',
  /** column name */
  UserId = 'userId'
}

/** Streaming cursor of the table "user_played_with_games" */
export type UserPlayedWithGamesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UserPlayedWithGamesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserPlayedWithGamesStreamCursorValueInput = {
  eventId?: InputMaybe<Scalars['uuid']>;
  otherUserId?: InputMaybe<Scalars['uuid']>;
  startDateTime?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type UserPlayedWithMaxFields = {
  __typename?: 'UserPlayedWithMaxFields';
  gamesTogether?: Maybe<Scalars['Int']>;
  lastPlayedAt?: Maybe<Scalars['timestamptz']>;
  otherUserId?: Maybe<Scalars['uuid']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type UserPlayedWithMinFields = {
  __typename?: 'UserPlayedWithMinFields';
  gamesTogether?: Maybe<Scalars['Int']>;
  lastPlayedAt?: Maybe<Scalars['timestamptz']>;
  otherUserId?: Maybe<Scalars['uuid']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** Ordering options when selecting data from "user_played_with". */
export type UserPlayedWithOrderBy = {
  gamesAggregate?: InputMaybe<UserPlayedWithGamesAggregateOrderBy>;
  gamesTogether?: InputMaybe<OrderBy>;
  lastPlayedAt?: InputMaybe<OrderBy>;
  otherUserId?: InputMaybe<OrderBy>;
  otherUserProfile?: InputMaybe<UserProfilesOrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** select columns of table "user_played_with" */
export enum UserPlayedWithSelectColumn {
  /** column name */
  GamesTogether = 'gamesTogether',
  /** column name */
  LastPlayedAt = 'lastPlayedAt',
  /** column name */
  OtherUserId = 'otherUserId',
  /** column name */
  UserId = 'userId'
}

/** aggregate stddev on columns */
export type UserPlayedWithStddevFields = {
  __typename?: 'UserPlayedWithStddevFields';
  gamesTogether?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type UserPlayedWithStddevPopFields = {
  __typename?: 'UserPlayedWithStddevPopFields';
  gamesTogether?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type UserPlayedWithStddevSampFields = {
  __typename?: 'UserPlayedWithStddevSampFields';
  gamesTogether?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "user_played_with" */
export type UserPlayedWithStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UserPlayedWithStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserPlayedWithStreamCursorValueInput = {
  gamesTogether?: InputMaybe<Scalars['Int']>;
  lastPlayedAt?: InputMaybe<Scalars['timestamptz']>;
  otherUserId?: InputMaybe<Scalars['uuid']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type UserPlayedWithSumFields = {
  __typename?: 'UserPlayedWithSumFields';
  gamesTogether?: Maybe<Scalars['Int']>;
};

/** aggregate varPop on columns */
export type UserPlayedWithVarPopFields = {
  __typename?: 'UserPlayedWithVarPopFields';
  gamesTogether?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type UserPlayedWithVarSampFields = {
  __typename?: 'UserPlayedWithVarSampFields';
  gamesTogether?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type UserPlayedWithVarianceFields = {
  __typename?: 'UserPlayedWithVarianceFields';
  gamesTogether?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "user_player_finder_availability" */
export type UserPlayerFinderAvailability = {
  __typename?: 'UserPlayerFinderAvailability';
  createdAt: Scalars['timestamptz'];
  dayOfWeek: DayOfWeekEnum;
  timeOfDay: PlayerFinderTimeOfDayEnum;
  userId: Scalars['uuid'];
};

/** aggregated selection of "user_player_finder_availability" */
export type UserPlayerFinderAvailabilityAggregate = {
  __typename?: 'UserPlayerFinderAvailabilityAggregate';
  aggregate?: Maybe<UserPlayerFinderAvailabilityAggregateFields>;
  nodes: Array<UserPlayerFinderAvailability>;
};

export type UserPlayerFinderAvailabilityAggregateBoolExp = {
  count?: InputMaybe<UserPlayerFinderAvailabilityAggregateBoolExpCount>;
};

/** aggregate fields of "user_player_finder_availability" */
export type UserPlayerFinderAvailabilityAggregateFields = {
  __typename?: 'UserPlayerFinderAvailabilityAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<UserPlayerFinderAvailabilityMaxFields>;
  min?: Maybe<UserPlayerFinderAvailabilityMinFields>;
};


/** aggregate fields of "user_player_finder_availability" */
export type UserPlayerFinderAvailabilityAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<UserPlayerFinderAvailabilitySelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_player_finder_availability" */
export type UserPlayerFinderAvailabilityAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<UserPlayerFinderAvailabilityMaxOrderBy>;
  min?: InputMaybe<UserPlayerFinderAvailabilityMinOrderBy>;
};

/** input type for inserting array relation for remote table "user_player_finder_availability" */
export type UserPlayerFinderAvailabilityArrRelInsertInput = {
  data: Array<UserPlayerFinderAvailabilityInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<UserPlayerFinderAvailabilityOnConflict>;
};

/** Boolean expression to filter rows from the table "user_player_finder_availability". All fields are combined with a logical 'AND'. */
export type UserPlayerFinderAvailabilityBoolExp = {
  _and?: InputMaybe<Array<UserPlayerFinderAvailabilityBoolExp>>;
  _not?: InputMaybe<UserPlayerFinderAvailabilityBoolExp>;
  _or?: InputMaybe<Array<UserPlayerFinderAvailabilityBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  dayOfWeek?: InputMaybe<DayOfWeekEnumComparisonExp>;
  timeOfDay?: InputMaybe<PlayerFinderTimeOfDayEnumComparisonExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "user_player_finder_availability" */
export enum UserPlayerFinderAvailabilityConstraint {
  /** unique or primary key constraint on columns "day_of_week", "user_id", "time_of_day" */
  UserPlayerFinderAvailabilityPkey = 'user_player_finder_availability_pkey'
}

/** input type for inserting data into table "user_player_finder_availability" */
export type UserPlayerFinderAvailabilityInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  dayOfWeek?: InputMaybe<DayOfWeekEnum>;
  timeOfDay?: InputMaybe<PlayerFinderTimeOfDayEnum>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type UserPlayerFinderAvailabilityMaxFields = {
  __typename?: 'UserPlayerFinderAvailabilityMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "user_player_finder_availability" */
export type UserPlayerFinderAvailabilityMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type UserPlayerFinderAvailabilityMinFields = {
  __typename?: 'UserPlayerFinderAvailabilityMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "user_player_finder_availability" */
export type UserPlayerFinderAvailabilityMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "user_player_finder_availability" */
export type UserPlayerFinderAvailabilityMutationResponse = {
  __typename?: 'UserPlayerFinderAvailabilityMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UserPlayerFinderAvailability>;
};

/** on_conflict condition type for table "user_player_finder_availability" */
export type UserPlayerFinderAvailabilityOnConflict = {
  constraint: UserPlayerFinderAvailabilityConstraint;
  updateColumns?: Array<UserPlayerFinderAvailabilityUpdateColumn>;
  where?: InputMaybe<UserPlayerFinderAvailabilityBoolExp>;
};

/** Ordering options when selecting data from "user_player_finder_availability". */
export type UserPlayerFinderAvailabilityOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  dayOfWeek?: InputMaybe<OrderBy>;
  timeOfDay?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: user_player_finder_availability */
export type UserPlayerFinderAvailabilityPkColumnsInput = {
  dayOfWeek: DayOfWeekEnum;
  timeOfDay: PlayerFinderTimeOfDayEnum;
  userId: Scalars['uuid'];
};

/** select columns of table "user_player_finder_availability" */
export enum UserPlayerFinderAvailabilitySelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DayOfWeek = 'dayOfWeek',
  /** column name */
  TimeOfDay = 'timeOfDay',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "user_player_finder_availability" */
export type UserPlayerFinderAvailabilitySetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  dayOfWeek?: InputMaybe<DayOfWeekEnum>;
  timeOfDay?: InputMaybe<PlayerFinderTimeOfDayEnum>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "user_player_finder_availability" */
export type UserPlayerFinderAvailabilityStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UserPlayerFinderAvailabilityStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserPlayerFinderAvailabilityStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  dayOfWeek?: InputMaybe<DayOfWeekEnum>;
  timeOfDay?: InputMaybe<PlayerFinderTimeOfDayEnum>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "user_player_finder_availability" */
export enum UserPlayerFinderAvailabilityUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DayOfWeek = 'dayOfWeek',
  /** column name */
  TimeOfDay = 'timeOfDay',
  /** column name */
  UserId = 'userId'
}

export type UserPlayerFinderAvailabilityUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserPlayerFinderAvailabilitySetInput>;
  /** filter the rows which have to be updated */
  where: UserPlayerFinderAvailabilityBoolExp;
};

/** columns and relationships of "user_player_finder_goals" */
export type UserPlayerFinderGoals = {
  __typename?: 'UserPlayerFinderGoals';
  createdAt: Scalars['timestamptz'];
  goal: PlayerFinderGoalsEnum;
  userId: Scalars['uuid'];
};

/** aggregated selection of "user_player_finder_goals" */
export type UserPlayerFinderGoalsAggregate = {
  __typename?: 'UserPlayerFinderGoalsAggregate';
  aggregate?: Maybe<UserPlayerFinderGoalsAggregateFields>;
  nodes: Array<UserPlayerFinderGoals>;
};

/** aggregate fields of "user_player_finder_goals" */
export type UserPlayerFinderGoalsAggregateFields = {
  __typename?: 'UserPlayerFinderGoalsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<UserPlayerFinderGoalsMaxFields>;
  min?: Maybe<UserPlayerFinderGoalsMinFields>;
};


/** aggregate fields of "user_player_finder_goals" */
export type UserPlayerFinderGoalsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<UserPlayerFinderGoalsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "user_player_finder_goals". All fields are combined with a logical 'AND'. */
export type UserPlayerFinderGoalsBoolExp = {
  _and?: InputMaybe<Array<UserPlayerFinderGoalsBoolExp>>;
  _not?: InputMaybe<UserPlayerFinderGoalsBoolExp>;
  _or?: InputMaybe<Array<UserPlayerFinderGoalsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  goal?: InputMaybe<PlayerFinderGoalsEnumComparisonExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "user_player_finder_goals" */
export enum UserPlayerFinderGoalsConstraint {
  /** unique or primary key constraint on columns "user_id", "goal" */
  UserPlayerFinderGoalsPkey = 'user_player_finder_goals_pkey'
}

/** input type for inserting data into table "user_player_finder_goals" */
export type UserPlayerFinderGoalsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  goal?: InputMaybe<PlayerFinderGoalsEnum>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type UserPlayerFinderGoalsMaxFields = {
  __typename?: 'UserPlayerFinderGoalsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type UserPlayerFinderGoalsMinFields = {
  __typename?: 'UserPlayerFinderGoalsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "user_player_finder_goals" */
export type UserPlayerFinderGoalsMutationResponse = {
  __typename?: 'UserPlayerFinderGoalsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UserPlayerFinderGoals>;
};

/** on_conflict condition type for table "user_player_finder_goals" */
export type UserPlayerFinderGoalsOnConflict = {
  constraint: UserPlayerFinderGoalsConstraint;
  updateColumns?: Array<UserPlayerFinderGoalsUpdateColumn>;
  where?: InputMaybe<UserPlayerFinderGoalsBoolExp>;
};

/** Ordering options when selecting data from "user_player_finder_goals". */
export type UserPlayerFinderGoalsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  goal?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: user_player_finder_goals */
export type UserPlayerFinderGoalsPkColumnsInput = {
  goal: PlayerFinderGoalsEnum;
  userId: Scalars['uuid'];
};

/** select columns of table "user_player_finder_goals" */
export enum UserPlayerFinderGoalsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Goal = 'goal',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "user_player_finder_goals" */
export type UserPlayerFinderGoalsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  goal?: InputMaybe<PlayerFinderGoalsEnum>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "user_player_finder_goals" */
export type UserPlayerFinderGoalsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UserPlayerFinderGoalsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserPlayerFinderGoalsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  goal?: InputMaybe<PlayerFinderGoalsEnum>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "user_player_finder_goals" */
export enum UserPlayerFinderGoalsUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Goal = 'goal',
  /** column name */
  UserId = 'userId'
}

export type UserPlayerFinderGoalsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserPlayerFinderGoalsSetInput>;
  /** filter the rows which have to be updated */
  where: UserPlayerFinderGoalsBoolExp;
};

/** columns and relationships of "user_profiles" */
export type UserProfiles = {
  __typename?: 'UserProfiles';
  aboutMe?: Maybe<Scalars['String']>;
  aboutMeVideoUrl?: Maybe<Scalars['String']>;
  /** An object relationship */
  activeCity?: Maybe<Cities>;
  activeCityId?: Maybe<Scalars['uuid']>;
  birthdayDay?: Maybe<Scalars['Int']>;
  birthdayMonth?: Maybe<Scalars['Int']>;
  birthdayVisibility?: Maybe<Scalars['String']>;
  birthdayYear?: Maybe<Scalars['Int']>;
  cityName?: Maybe<Scalars['String']>;
  /** An array relationship */
  coachAvailability: Array<CoachAvailability>;
  /** An aggregate relationship */
  coachAvailabilityAggregate: CoachAvailabilityAggregate;
  coachExternalBookingUrl?: Maybe<Scalars['String']>;
  /** An array relationship */
  coachFaqs: Array<CoachFaqs>;
  /** An aggregate relationship */
  coachFaqsAggregate: CoachFaqsAggregate;
  /** An array relationship */
  coachLessonAgeGroups: Array<CoachLessonAgeGroups>;
  /** An aggregate relationship */
  coachLessonAgeGroupsAggregate: CoachLessonAgeGroupsAggregate;
  coachLessonDescription?: Maybe<Scalars['String']>;
  coachLessonHowToPrepare?: Maybe<Scalars['String']>;
  /** An array relationship */
  coachLessonReflections: Array<LessonReflections>;
  /** An aggregate relationship */
  coachLessonReflectionsAggregate: LessonReflectionsAggregate;
  /** An array relationship */
  coachLessonSkillLevels: Array<CoachLessonSkillLevels>;
  /** An aggregate relationship */
  coachLessonSkillLevelsAggregate: CoachLessonSkillLevelsAggregate;
  /** An array relationship */
  coachLessons: Array<Lessons>;
  /** An aggregate relationship */
  coachLessonsAggregate: LessonsAggregate;
  /** An array relationship */
  coachQualifications: Array<UsersCoachQualifications>;
  /** An aggregate relationship */
  coachQualificationsAggregate: UsersCoachQualificationsAggregate;
  /** An array relationship */
  coachReviews: Array<Reviews>;
  /** An aggregate relationship */
  coachReviewsAggregate: ReviewsAggregate;
  /** An array relationship */
  coachServices: Array<UserCoachServices>;
  /** An aggregate relationship */
  coachServicesAggregate: UserCoachServicesAggregate;
  /** An array relationship */
  coachSports: Array<CoachSports>;
  /** An aggregate relationship */
  coachSportsAggregate: CoachSportsAggregate;
  coachStatus?: Maybe<Scalars['String']>;
  coachingStartYear?: Maybe<Scalars['Int']>;
  /** An object relationship */
  country?: Maybe<Countries>;
  countryId?: Maybe<Scalars['String']>;
  /** An object relationship */
  countrySubdivision?: Maybe<CountrySubdivisions>;
  countrySubdivisionId?: Maybe<Scalars['uuid']>;
  coverImageFileName?: Maybe<Scalars['String']>;
  coverImagePath?: Maybe<Scalars['String']>;
  coverImageProvider?: Maybe<Scalars['String']>;
  coverImageProviderUrl?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currencyCoachDefault?: Maybe<Scalars['String']>;
  /** An object relationship */
  defaultCoachCustomCourt?: Maybe<UserCustomCourts>;
  defaultCoachUserCustomCourtId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  defaultCoachVenue?: Maybe<Venues>;
  defaultCoachVenueId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  defaultPickleballRatingScale?: Maybe<PickleballRatingScales>;
  defaultPickleballRatingScaleId?: Maybe<Scalars['uuid']>;
  defaultSport?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  duprId?: Maybe<Scalars['String']>;
  eventOrganizerAccountType?: Maybe<Scalars['String']>;
  facebookUrl?: Maybe<Scalars['String']>;
  /** An array relationship */
  followers: Array<UserFollows>;
  /** An aggregate relationship */
  followersAggregate: UserFollowsAggregate;
  /** An array relationship */
  following: Array<UserFollows>;
  /** An aggregate relationship */
  followingAggregate: UserFollowsAggregate;
  fullName?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  genderPreference?: Maybe<Scalars['String']>;
  geometry?: Maybe<Scalars['geography']>;
  id?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  identityVerifications: Array<UserIdentityVerifications>;
  /** An aggregate relationship */
  identityVerificationsAggregate: UserIdentityVerificationsAggregate;
  instagramUrl?: Maybe<Scalars['String']>;
  iptpaId?: Maybe<Scalars['String']>;
  isIptpaMember?: Maybe<Scalars['Boolean']>;
  isPciMember?: Maybe<Scalars['Boolean']>;
  isPicklrP4Member?: Maybe<Scalars['Boolean']>;
  isPprMember?: Maybe<Scalars['Boolean']>;
  isProfessionalRacquetRegistryActive?: Maybe<Scalars['Boolean']>;
  isQuatroPickleballMember?: Maybe<Scalars['Boolean']>;
  linkedinUrl?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
  normalizedTennisRating?: Maybe<Scalars['numeric']>;
  /** An object relationship */
  normalizedTennisRatingScale?: Maybe<TennisRatingScales>;
  normalizedTennisRatingScaleId?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  padelRatingScales: Array<UserPadelRatingScales>;
  /** An aggregate relationship */
  padelRatingScalesAggregate: UserPadelRatingScalesAggregate;
  /** An object relationship */
  padelSkillLevel?: Maybe<SkillLevels>;
  padelSkillLevelId?: Maybe<Scalars['String']>;
  pciId?: Maybe<Scalars['String']>;
  /** An array relationship */
  pickleballRatingScales: Array<UserPickleballRatingScales>;
  /** An aggregate relationship */
  pickleballRatingScalesAggregate: UserPickleballRatingScalesAggregate;
  /** An object relationship */
  pickleballSkillLevel?: Maybe<SkillLevels>;
  pickleballSkillLevelId?: Maybe<Scalars['String']>;
  /** An array relationship */
  playerFinderAvailability: Array<UserPlayerFinderAvailability>;
  /** An aggregate relationship */
  playerFinderAvailabilityAggregate: UserPlayerFinderAvailabilityAggregate;
  /** An array relationship */
  playerLessonReflections: Array<LessonReflections>;
  /** An aggregate relationship */
  playerLessonReflectionsAggregate: LessonReflectionsAggregate;
  /** An array relationship */
  playerReviews: Array<Reviews>;
  /** An aggregate relationship */
  playerReviewsAggregate: ReviewsAggregate;
  pprId?: Maybe<Scalars['String']>;
  preferredName?: Maybe<Scalars['String']>;
  premiumContentDescription?: Maybe<Scalars['String']>;
  priceUnitAmountCoachDefault?: Maybe<Scalars['Int']>;
  priceUnitAmountPremiumContentDefault?: Maybe<Scalars['Int']>;
  priceUnitAmountRemoteCoachDefault?: Maybe<Scalars['Int']>;
  profileImageFileName?: Maybe<Scalars['String']>;
  profileImagePath?: Maybe<Scalars['String']>;
  profileImageProvider?: Maybe<Scalars['String']>;
  profileImageProviderId?: Maybe<Scalars['String']>;
  profileImageProviderUrl?: Maybe<Scalars['String']>;
  profileImageUrl?: Maybe<Scalars['String']>;
  quatroPickleballMemberId?: Maybe<Scalars['String']>;
  /** An array relationship */
  sports: Array<UserSports>;
  /** An aggregate relationship */
  sportsAggregate: UserSportsAggregate;
  stripeMerchantChargesEnabled?: Maybe<Scalars['Boolean']>;
  stripeMerchantCurrency?: Maybe<Scalars['String']>;
  stripeMerchantDetailsSubmitted?: Maybe<Scalars['Boolean']>;
  tennisRating?: Maybe<Scalars['numeric']>;
  /** An object relationship */
  tennisRatingScale?: Maybe<TennisRatingScales>;
  tennisRatingScaleId?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  tennisRatingScales: Array<UserTennisRatingScales>;
  /** An aggregate relationship */
  tennisRatingScalesAggregate: UserTennisRatingScalesAggregate;
  /** An object relationship */
  tennisSkillLevel?: Maybe<SkillLevels>;
  tennisSkillLevelId?: Maybe<Scalars['String']>;
  tiktokUrl?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  userFiles: Array<UserFiles>;
  /** An aggregate relationship */
  userFilesAggregate: UserFilesAggregate;
  username?: Maybe<Scalars['String']>;
  /** An array relationship */
  venueFollows: Array<VenueFollows>;
  /** An aggregate relationship */
  venueFollowsAggregate: VenueFollowsAggregate;
  websiteUrl?: Maybe<Scalars['String']>;
  xUrl?: Maybe<Scalars['String']>;
  youtubeUrl?: Maybe<Scalars['String']>;
};


/** columns and relationships of "user_profiles" */
export type UserProfilesCoachAvailabilityArgs = {
  distinctOn?: InputMaybe<Array<CoachAvailabilitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachAvailabilityOrderBy>>;
  where?: InputMaybe<CoachAvailabilityBoolExp>;
};


/** columns and relationships of "user_profiles" */
export type UserProfilesCoachAvailabilityAggregateArgs = {
  distinctOn?: InputMaybe<Array<CoachAvailabilitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachAvailabilityOrderBy>>;
  where?: InputMaybe<CoachAvailabilityBoolExp>;
};


/** columns and relationships of "user_profiles" */
export type UserProfilesCoachFaqsArgs = {
  distinctOn?: InputMaybe<Array<CoachFaqsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachFaqsOrderBy>>;
  where?: InputMaybe<CoachFaqsBoolExp>;
};


/** columns and relationships of "user_profiles" */
export type UserProfilesCoachFaqsAggregateArgs = {
  distinctOn?: InputMaybe<Array<CoachFaqsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachFaqsOrderBy>>;
  where?: InputMaybe<CoachFaqsBoolExp>;
};


/** columns and relationships of "user_profiles" */
export type UserProfilesCoachLessonAgeGroupsArgs = {
  distinctOn?: InputMaybe<Array<CoachLessonAgeGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachLessonAgeGroupsOrderBy>>;
  where?: InputMaybe<CoachLessonAgeGroupsBoolExp>;
};


/** columns and relationships of "user_profiles" */
export type UserProfilesCoachLessonAgeGroupsAggregateArgs = {
  distinctOn?: InputMaybe<Array<CoachLessonAgeGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachLessonAgeGroupsOrderBy>>;
  where?: InputMaybe<CoachLessonAgeGroupsBoolExp>;
};


/** columns and relationships of "user_profiles" */
export type UserProfilesCoachLessonReflectionsArgs = {
  distinctOn?: InputMaybe<Array<LessonReflectionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonReflectionsOrderBy>>;
  where?: InputMaybe<LessonReflectionsBoolExp>;
};


/** columns and relationships of "user_profiles" */
export type UserProfilesCoachLessonReflectionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonReflectionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonReflectionsOrderBy>>;
  where?: InputMaybe<LessonReflectionsBoolExp>;
};


/** columns and relationships of "user_profiles" */
export type UserProfilesCoachLessonSkillLevelsArgs = {
  distinctOn?: InputMaybe<Array<CoachLessonSkillLevelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachLessonSkillLevelsOrderBy>>;
  where?: InputMaybe<CoachLessonSkillLevelsBoolExp>;
};


/** columns and relationships of "user_profiles" */
export type UserProfilesCoachLessonSkillLevelsAggregateArgs = {
  distinctOn?: InputMaybe<Array<CoachLessonSkillLevelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachLessonSkillLevelsOrderBy>>;
  where?: InputMaybe<CoachLessonSkillLevelsBoolExp>;
};


/** columns and relationships of "user_profiles" */
export type UserProfilesCoachLessonsArgs = {
  distinctOn?: InputMaybe<Array<LessonsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonsOrderBy>>;
  where?: InputMaybe<LessonsBoolExp>;
};


/** columns and relationships of "user_profiles" */
export type UserProfilesCoachLessonsAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonsOrderBy>>;
  where?: InputMaybe<LessonsBoolExp>;
};


/** columns and relationships of "user_profiles" */
export type UserProfilesCoachQualificationsArgs = {
  distinctOn?: InputMaybe<Array<UsersCoachQualificationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersCoachQualificationsOrderBy>>;
  where?: InputMaybe<UsersCoachQualificationsBoolExp>;
};


/** columns and relationships of "user_profiles" */
export type UserProfilesCoachQualificationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<UsersCoachQualificationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersCoachQualificationsOrderBy>>;
  where?: InputMaybe<UsersCoachQualificationsBoolExp>;
};


/** columns and relationships of "user_profiles" */
export type UserProfilesCoachReviewsArgs = {
  distinctOn?: InputMaybe<Array<ReviewsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReviewsOrderBy>>;
  where?: InputMaybe<ReviewsBoolExp>;
};


/** columns and relationships of "user_profiles" */
export type UserProfilesCoachReviewsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ReviewsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReviewsOrderBy>>;
  where?: InputMaybe<ReviewsBoolExp>;
};


/** columns and relationships of "user_profiles" */
export type UserProfilesCoachServicesArgs = {
  distinctOn?: InputMaybe<Array<UserCoachServicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserCoachServicesOrderBy>>;
  where?: InputMaybe<UserCoachServicesBoolExp>;
};


/** columns and relationships of "user_profiles" */
export type UserProfilesCoachServicesAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserCoachServicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserCoachServicesOrderBy>>;
  where?: InputMaybe<UserCoachServicesBoolExp>;
};


/** columns and relationships of "user_profiles" */
export type UserProfilesCoachSportsArgs = {
  distinctOn?: InputMaybe<Array<CoachSportsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachSportsOrderBy>>;
  where?: InputMaybe<CoachSportsBoolExp>;
};


/** columns and relationships of "user_profiles" */
export type UserProfilesCoachSportsAggregateArgs = {
  distinctOn?: InputMaybe<Array<CoachSportsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachSportsOrderBy>>;
  where?: InputMaybe<CoachSportsBoolExp>;
};


/** columns and relationships of "user_profiles" */
export type UserProfilesFollowersArgs = {
  distinctOn?: InputMaybe<Array<UserFollowsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserFollowsOrderBy>>;
  where?: InputMaybe<UserFollowsBoolExp>;
};


/** columns and relationships of "user_profiles" */
export type UserProfilesFollowersAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserFollowsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserFollowsOrderBy>>;
  where?: InputMaybe<UserFollowsBoolExp>;
};


/** columns and relationships of "user_profiles" */
export type UserProfilesFollowingArgs = {
  distinctOn?: InputMaybe<Array<UserFollowsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserFollowsOrderBy>>;
  where?: InputMaybe<UserFollowsBoolExp>;
};


/** columns and relationships of "user_profiles" */
export type UserProfilesFollowingAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserFollowsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserFollowsOrderBy>>;
  where?: InputMaybe<UserFollowsBoolExp>;
};


/** columns and relationships of "user_profiles" */
export type UserProfilesIdentityVerificationsArgs = {
  distinctOn?: InputMaybe<Array<UserIdentityVerificationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserIdentityVerificationsOrderBy>>;
  where?: InputMaybe<UserIdentityVerificationsBoolExp>;
};


/** columns and relationships of "user_profiles" */
export type UserProfilesIdentityVerificationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserIdentityVerificationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserIdentityVerificationsOrderBy>>;
  where?: InputMaybe<UserIdentityVerificationsBoolExp>;
};


/** columns and relationships of "user_profiles" */
export type UserProfilesPadelRatingScalesArgs = {
  distinctOn?: InputMaybe<Array<UserPadelRatingScalesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPadelRatingScalesOrderBy>>;
  where?: InputMaybe<UserPadelRatingScalesBoolExp>;
};


/** columns and relationships of "user_profiles" */
export type UserProfilesPadelRatingScalesAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserPadelRatingScalesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPadelRatingScalesOrderBy>>;
  where?: InputMaybe<UserPadelRatingScalesBoolExp>;
};


/** columns and relationships of "user_profiles" */
export type UserProfilesPickleballRatingScalesArgs = {
  distinctOn?: InputMaybe<Array<UserPickleballRatingScalesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPickleballRatingScalesOrderBy>>;
  where?: InputMaybe<UserPickleballRatingScalesBoolExp>;
};


/** columns and relationships of "user_profiles" */
export type UserProfilesPickleballRatingScalesAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserPickleballRatingScalesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPickleballRatingScalesOrderBy>>;
  where?: InputMaybe<UserPickleballRatingScalesBoolExp>;
};


/** columns and relationships of "user_profiles" */
export type UserProfilesPlayerFinderAvailabilityArgs = {
  distinctOn?: InputMaybe<Array<UserPlayerFinderAvailabilitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPlayerFinderAvailabilityOrderBy>>;
  where?: InputMaybe<UserPlayerFinderAvailabilityBoolExp>;
};


/** columns and relationships of "user_profiles" */
export type UserProfilesPlayerFinderAvailabilityAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserPlayerFinderAvailabilitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPlayerFinderAvailabilityOrderBy>>;
  where?: InputMaybe<UserPlayerFinderAvailabilityBoolExp>;
};


/** columns and relationships of "user_profiles" */
export type UserProfilesPlayerLessonReflectionsArgs = {
  distinctOn?: InputMaybe<Array<LessonReflectionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonReflectionsOrderBy>>;
  where?: InputMaybe<LessonReflectionsBoolExp>;
};


/** columns and relationships of "user_profiles" */
export type UserProfilesPlayerLessonReflectionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonReflectionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonReflectionsOrderBy>>;
  where?: InputMaybe<LessonReflectionsBoolExp>;
};


/** columns and relationships of "user_profiles" */
export type UserProfilesPlayerReviewsArgs = {
  distinctOn?: InputMaybe<Array<ReviewsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReviewsOrderBy>>;
  where?: InputMaybe<ReviewsBoolExp>;
};


/** columns and relationships of "user_profiles" */
export type UserProfilesPlayerReviewsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ReviewsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReviewsOrderBy>>;
  where?: InputMaybe<ReviewsBoolExp>;
};


/** columns and relationships of "user_profiles" */
export type UserProfilesSportsArgs = {
  distinctOn?: InputMaybe<Array<UserSportsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserSportsOrderBy>>;
  where?: InputMaybe<UserSportsBoolExp>;
};


/** columns and relationships of "user_profiles" */
export type UserProfilesSportsAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserSportsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserSportsOrderBy>>;
  where?: InputMaybe<UserSportsBoolExp>;
};


/** columns and relationships of "user_profiles" */
export type UserProfilesTennisRatingScalesArgs = {
  distinctOn?: InputMaybe<Array<UserTennisRatingScalesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserTennisRatingScalesOrderBy>>;
  where?: InputMaybe<UserTennisRatingScalesBoolExp>;
};


/** columns and relationships of "user_profiles" */
export type UserProfilesTennisRatingScalesAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserTennisRatingScalesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserTennisRatingScalesOrderBy>>;
  where?: InputMaybe<UserTennisRatingScalesBoolExp>;
};


/** columns and relationships of "user_profiles" */
export type UserProfilesUserFilesArgs = {
  distinctOn?: InputMaybe<Array<UserFilesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserFilesOrderBy>>;
  where?: InputMaybe<UserFilesBoolExp>;
};


/** columns and relationships of "user_profiles" */
export type UserProfilesUserFilesAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserFilesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserFilesOrderBy>>;
  where?: InputMaybe<UserFilesBoolExp>;
};


/** columns and relationships of "user_profiles" */
export type UserProfilesVenueFollowsArgs = {
  distinctOn?: InputMaybe<Array<VenueFollowsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueFollowsOrderBy>>;
  where?: InputMaybe<VenueFollowsBoolExp>;
};


/** columns and relationships of "user_profiles" */
export type UserProfilesVenueFollowsAggregateArgs = {
  distinctOn?: InputMaybe<Array<VenueFollowsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueFollowsOrderBy>>;
  where?: InputMaybe<VenueFollowsBoolExp>;
};

/** aggregated selection of "user_profiles" */
export type UserProfilesAggregate = {
  __typename?: 'UserProfilesAggregate';
  aggregate?: Maybe<UserProfilesAggregateFields>;
  nodes: Array<UserProfiles>;
};

/** aggregate fields of "user_profiles" */
export type UserProfilesAggregateFields = {
  __typename?: 'UserProfilesAggregateFields';
  avg?: Maybe<UserProfilesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<UserProfilesMaxFields>;
  min?: Maybe<UserProfilesMinFields>;
  stddev?: Maybe<UserProfilesStddevFields>;
  stddevPop?: Maybe<UserProfilesStddevPopFields>;
  stddevSamp?: Maybe<UserProfilesStddevSampFields>;
  sum?: Maybe<UserProfilesSumFields>;
  varPop?: Maybe<UserProfilesVarPopFields>;
  varSamp?: Maybe<UserProfilesVarSampFields>;
  variance?: Maybe<UserProfilesVarianceFields>;
};


/** aggregate fields of "user_profiles" */
export type UserProfilesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<UserProfilesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type UserProfilesAvgFields = {
  __typename?: 'UserProfilesAvgFields';
  birthdayDay?: Maybe<Scalars['Float']>;
  birthdayMonth?: Maybe<Scalars['Float']>;
  birthdayYear?: Maybe<Scalars['Float']>;
  coachingStartYear?: Maybe<Scalars['Float']>;
  normalizedTennisRating?: Maybe<Scalars['Float']>;
  priceUnitAmountCoachDefault?: Maybe<Scalars['Float']>;
  priceUnitAmountPremiumContentDefault?: Maybe<Scalars['Float']>;
  priceUnitAmountRemoteCoachDefault?: Maybe<Scalars['Float']>;
  tennisRating?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "user_profiles". All fields are combined with a logical 'AND'. */
export type UserProfilesBoolExp = {
  _and?: InputMaybe<Array<UserProfilesBoolExp>>;
  _not?: InputMaybe<UserProfilesBoolExp>;
  _or?: InputMaybe<Array<UserProfilesBoolExp>>;
  aboutMe?: InputMaybe<StringComparisonExp>;
  aboutMeVideoUrl?: InputMaybe<StringComparisonExp>;
  activeCity?: InputMaybe<CitiesBoolExp>;
  activeCityId?: InputMaybe<UuidComparisonExp>;
  birthdayDay?: InputMaybe<IntComparisonExp>;
  birthdayMonth?: InputMaybe<IntComparisonExp>;
  birthdayVisibility?: InputMaybe<StringComparisonExp>;
  birthdayYear?: InputMaybe<IntComparisonExp>;
  cityName?: InputMaybe<StringComparisonExp>;
  coachAvailability?: InputMaybe<CoachAvailabilityBoolExp>;
  coachAvailabilityAggregate?: InputMaybe<CoachAvailabilityAggregateBoolExp>;
  coachExternalBookingUrl?: InputMaybe<StringComparisonExp>;
  coachFaqs?: InputMaybe<CoachFaqsBoolExp>;
  coachFaqsAggregate?: InputMaybe<CoachFaqsAggregateBoolExp>;
  coachLessonAgeGroups?: InputMaybe<CoachLessonAgeGroupsBoolExp>;
  coachLessonAgeGroupsAggregate?: InputMaybe<CoachLessonAgeGroupsAggregateBoolExp>;
  coachLessonDescription?: InputMaybe<StringComparisonExp>;
  coachLessonHowToPrepare?: InputMaybe<StringComparisonExp>;
  coachLessonReflections?: InputMaybe<LessonReflectionsBoolExp>;
  coachLessonReflectionsAggregate?: InputMaybe<LessonReflectionsAggregateBoolExp>;
  coachLessonSkillLevels?: InputMaybe<CoachLessonSkillLevelsBoolExp>;
  coachLessonSkillLevelsAggregate?: InputMaybe<CoachLessonSkillLevelsAggregateBoolExp>;
  coachLessons?: InputMaybe<LessonsBoolExp>;
  coachLessonsAggregate?: InputMaybe<LessonsAggregateBoolExp>;
  coachQualifications?: InputMaybe<UsersCoachQualificationsBoolExp>;
  coachQualificationsAggregate?: InputMaybe<UsersCoachQualificationsAggregateBoolExp>;
  coachReviews?: InputMaybe<ReviewsBoolExp>;
  coachReviewsAggregate?: InputMaybe<ReviewsAggregateBoolExp>;
  coachServices?: InputMaybe<UserCoachServicesBoolExp>;
  coachServicesAggregate?: InputMaybe<UserCoachServicesAggregateBoolExp>;
  coachSports?: InputMaybe<CoachSportsBoolExp>;
  coachSportsAggregate?: InputMaybe<CoachSportsAggregateBoolExp>;
  coachStatus?: InputMaybe<StringComparisonExp>;
  coachingStartYear?: InputMaybe<IntComparisonExp>;
  country?: InputMaybe<CountriesBoolExp>;
  countryId?: InputMaybe<StringComparisonExp>;
  countrySubdivision?: InputMaybe<CountrySubdivisionsBoolExp>;
  countrySubdivisionId?: InputMaybe<UuidComparisonExp>;
  coverImageFileName?: InputMaybe<StringComparisonExp>;
  coverImagePath?: InputMaybe<StringComparisonExp>;
  coverImageProvider?: InputMaybe<StringComparisonExp>;
  coverImageProviderUrl?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  currencyCoachDefault?: InputMaybe<StringComparisonExp>;
  defaultCoachCustomCourt?: InputMaybe<UserCustomCourtsBoolExp>;
  defaultCoachUserCustomCourtId?: InputMaybe<UuidComparisonExp>;
  defaultCoachVenue?: InputMaybe<VenuesBoolExp>;
  defaultCoachVenueId?: InputMaybe<UuidComparisonExp>;
  defaultPickleballRatingScale?: InputMaybe<PickleballRatingScalesBoolExp>;
  defaultPickleballRatingScaleId?: InputMaybe<UuidComparisonExp>;
  defaultSport?: InputMaybe<StringComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  duprId?: InputMaybe<StringComparisonExp>;
  eventOrganizerAccountType?: InputMaybe<StringComparisonExp>;
  facebookUrl?: InputMaybe<StringComparisonExp>;
  followers?: InputMaybe<UserFollowsBoolExp>;
  followersAggregate?: InputMaybe<UserFollowsAggregateBoolExp>;
  following?: InputMaybe<UserFollowsBoolExp>;
  followingAggregate?: InputMaybe<UserFollowsAggregateBoolExp>;
  fullName?: InputMaybe<StringComparisonExp>;
  gender?: InputMaybe<StringComparisonExp>;
  genderPreference?: InputMaybe<StringComparisonExp>;
  geometry?: InputMaybe<GeographyComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  identityVerifications?: InputMaybe<UserIdentityVerificationsBoolExp>;
  identityVerificationsAggregate?: InputMaybe<UserIdentityVerificationsAggregateBoolExp>;
  instagramUrl?: InputMaybe<StringComparisonExp>;
  iptpaId?: InputMaybe<StringComparisonExp>;
  isIptpaMember?: InputMaybe<BooleanComparisonExp>;
  isPciMember?: InputMaybe<BooleanComparisonExp>;
  isPicklrP4Member?: InputMaybe<BooleanComparisonExp>;
  isPprMember?: InputMaybe<BooleanComparisonExp>;
  isProfessionalRacquetRegistryActive?: InputMaybe<BooleanComparisonExp>;
  isQuatroPickleballMember?: InputMaybe<BooleanComparisonExp>;
  linkedinUrl?: InputMaybe<StringComparisonExp>;
  locale?: InputMaybe<StringComparisonExp>;
  normalizedTennisRating?: InputMaybe<NumericComparisonExp>;
  normalizedTennisRatingScale?: InputMaybe<TennisRatingScalesBoolExp>;
  normalizedTennisRatingScaleId?: InputMaybe<UuidComparisonExp>;
  padelRatingScales?: InputMaybe<UserPadelRatingScalesBoolExp>;
  padelRatingScalesAggregate?: InputMaybe<UserPadelRatingScalesAggregateBoolExp>;
  padelSkillLevel?: InputMaybe<SkillLevelsBoolExp>;
  padelSkillLevelId?: InputMaybe<StringComparisonExp>;
  pciId?: InputMaybe<StringComparisonExp>;
  pickleballRatingScales?: InputMaybe<UserPickleballRatingScalesBoolExp>;
  pickleballRatingScalesAggregate?: InputMaybe<UserPickleballRatingScalesAggregateBoolExp>;
  pickleballSkillLevel?: InputMaybe<SkillLevelsBoolExp>;
  pickleballSkillLevelId?: InputMaybe<StringComparisonExp>;
  playerFinderAvailability?: InputMaybe<UserPlayerFinderAvailabilityBoolExp>;
  playerFinderAvailabilityAggregate?: InputMaybe<UserPlayerFinderAvailabilityAggregateBoolExp>;
  playerLessonReflections?: InputMaybe<LessonReflectionsBoolExp>;
  playerLessonReflectionsAggregate?: InputMaybe<LessonReflectionsAggregateBoolExp>;
  playerReviews?: InputMaybe<ReviewsBoolExp>;
  playerReviewsAggregate?: InputMaybe<ReviewsAggregateBoolExp>;
  pprId?: InputMaybe<StringComparisonExp>;
  preferredName?: InputMaybe<StringComparisonExp>;
  premiumContentDescription?: InputMaybe<StringComparisonExp>;
  priceUnitAmountCoachDefault?: InputMaybe<IntComparisonExp>;
  priceUnitAmountPremiumContentDefault?: InputMaybe<IntComparisonExp>;
  priceUnitAmountRemoteCoachDefault?: InputMaybe<IntComparisonExp>;
  profileImageFileName?: InputMaybe<StringComparisonExp>;
  profileImagePath?: InputMaybe<StringComparisonExp>;
  profileImageProvider?: InputMaybe<StringComparisonExp>;
  profileImageProviderId?: InputMaybe<StringComparisonExp>;
  profileImageProviderUrl?: InputMaybe<StringComparisonExp>;
  profileImageUrl?: InputMaybe<StringComparisonExp>;
  quatroPickleballMemberId?: InputMaybe<StringComparisonExp>;
  sports?: InputMaybe<UserSportsBoolExp>;
  sportsAggregate?: InputMaybe<UserSportsAggregateBoolExp>;
  stripeMerchantChargesEnabled?: InputMaybe<BooleanComparisonExp>;
  stripeMerchantCurrency?: InputMaybe<StringComparisonExp>;
  stripeMerchantDetailsSubmitted?: InputMaybe<BooleanComparisonExp>;
  tennisRating?: InputMaybe<NumericComparisonExp>;
  tennisRatingScale?: InputMaybe<TennisRatingScalesBoolExp>;
  tennisRatingScaleId?: InputMaybe<UuidComparisonExp>;
  tennisRatingScales?: InputMaybe<UserTennisRatingScalesBoolExp>;
  tennisRatingScalesAggregate?: InputMaybe<UserTennisRatingScalesAggregateBoolExp>;
  tennisSkillLevel?: InputMaybe<SkillLevelsBoolExp>;
  tennisSkillLevelId?: InputMaybe<StringComparisonExp>;
  tiktokUrl?: InputMaybe<StringComparisonExp>;
  timezone?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  userFiles?: InputMaybe<UserFilesBoolExp>;
  userFilesAggregate?: InputMaybe<UserFilesAggregateBoolExp>;
  username?: InputMaybe<StringComparisonExp>;
  venueFollows?: InputMaybe<VenueFollowsBoolExp>;
  venueFollowsAggregate?: InputMaybe<VenueFollowsAggregateBoolExp>;
  websiteUrl?: InputMaybe<StringComparisonExp>;
  xUrl?: InputMaybe<StringComparisonExp>;
  youtubeUrl?: InputMaybe<StringComparisonExp>;
};

/** input type for incrementing numeric columns in table "user_profiles" */
export type UserProfilesIncInput = {
  birthdayDay?: InputMaybe<Scalars['Int']>;
  birthdayMonth?: InputMaybe<Scalars['Int']>;
  birthdayYear?: InputMaybe<Scalars['Int']>;
  coachingStartYear?: InputMaybe<Scalars['Int']>;
  normalizedTennisRating?: InputMaybe<Scalars['numeric']>;
  priceUnitAmountCoachDefault?: InputMaybe<Scalars['Int']>;
  priceUnitAmountPremiumContentDefault?: InputMaybe<Scalars['Int']>;
  priceUnitAmountRemoteCoachDefault?: InputMaybe<Scalars['Int']>;
  tennisRating?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "user_profiles" */
export type UserProfilesInsertInput = {
  aboutMe?: InputMaybe<Scalars['String']>;
  aboutMeVideoUrl?: InputMaybe<Scalars['String']>;
  activeCity?: InputMaybe<CitiesObjRelInsertInput>;
  activeCityId?: InputMaybe<Scalars['uuid']>;
  birthdayDay?: InputMaybe<Scalars['Int']>;
  birthdayMonth?: InputMaybe<Scalars['Int']>;
  birthdayVisibility?: InputMaybe<Scalars['String']>;
  birthdayYear?: InputMaybe<Scalars['Int']>;
  cityName?: InputMaybe<Scalars['String']>;
  coachAvailability?: InputMaybe<CoachAvailabilityArrRelInsertInput>;
  coachExternalBookingUrl?: InputMaybe<Scalars['String']>;
  coachFaqs?: InputMaybe<CoachFaqsArrRelInsertInput>;
  coachLessonAgeGroups?: InputMaybe<CoachLessonAgeGroupsArrRelInsertInput>;
  coachLessonDescription?: InputMaybe<Scalars['String']>;
  coachLessonHowToPrepare?: InputMaybe<Scalars['String']>;
  coachLessonReflections?: InputMaybe<LessonReflectionsArrRelInsertInput>;
  coachLessonSkillLevels?: InputMaybe<CoachLessonSkillLevelsArrRelInsertInput>;
  coachLessons?: InputMaybe<LessonsArrRelInsertInput>;
  coachQualifications?: InputMaybe<UsersCoachQualificationsArrRelInsertInput>;
  coachReviews?: InputMaybe<ReviewsArrRelInsertInput>;
  coachServices?: InputMaybe<UserCoachServicesArrRelInsertInput>;
  coachSports?: InputMaybe<CoachSportsArrRelInsertInput>;
  coachStatus?: InputMaybe<Scalars['String']>;
  coachingStartYear?: InputMaybe<Scalars['Int']>;
  country?: InputMaybe<CountriesObjRelInsertInput>;
  countryId?: InputMaybe<Scalars['String']>;
  countrySubdivision?: InputMaybe<CountrySubdivisionsObjRelInsertInput>;
  countrySubdivisionId?: InputMaybe<Scalars['uuid']>;
  coverImageFileName?: InputMaybe<Scalars['String']>;
  coverImagePath?: InputMaybe<Scalars['String']>;
  coverImageProvider?: InputMaybe<Scalars['String']>;
  coverImageProviderUrl?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currencyCoachDefault?: InputMaybe<Scalars['String']>;
  defaultCoachCustomCourt?: InputMaybe<UserCustomCourtsObjRelInsertInput>;
  defaultCoachUserCustomCourtId?: InputMaybe<Scalars['uuid']>;
  defaultCoachVenue?: InputMaybe<VenuesObjRelInsertInput>;
  defaultCoachVenueId?: InputMaybe<Scalars['uuid']>;
  defaultPickleballRatingScale?: InputMaybe<PickleballRatingScalesObjRelInsertInput>;
  defaultPickleballRatingScaleId?: InputMaybe<Scalars['uuid']>;
  defaultSport?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  duprId?: InputMaybe<Scalars['String']>;
  eventOrganizerAccountType?: InputMaybe<Scalars['String']>;
  facebookUrl?: InputMaybe<Scalars['String']>;
  followers?: InputMaybe<UserFollowsArrRelInsertInput>;
  following?: InputMaybe<UserFollowsArrRelInsertInput>;
  fullName?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  genderPreference?: InputMaybe<Scalars['String']>;
  geometry?: InputMaybe<Scalars['geography']>;
  id?: InputMaybe<Scalars['uuid']>;
  identityVerifications?: InputMaybe<UserIdentityVerificationsArrRelInsertInput>;
  instagramUrl?: InputMaybe<Scalars['String']>;
  iptpaId?: InputMaybe<Scalars['String']>;
  isIptpaMember?: InputMaybe<Scalars['Boolean']>;
  isPciMember?: InputMaybe<Scalars['Boolean']>;
  isPicklrP4Member?: InputMaybe<Scalars['Boolean']>;
  isPprMember?: InputMaybe<Scalars['Boolean']>;
  isProfessionalRacquetRegistryActive?: InputMaybe<Scalars['Boolean']>;
  isQuatroPickleballMember?: InputMaybe<Scalars['Boolean']>;
  linkedinUrl?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  normalizedTennisRating?: InputMaybe<Scalars['numeric']>;
  normalizedTennisRatingScale?: InputMaybe<TennisRatingScalesObjRelInsertInput>;
  normalizedTennisRatingScaleId?: InputMaybe<Scalars['uuid']>;
  padelRatingScales?: InputMaybe<UserPadelRatingScalesArrRelInsertInput>;
  padelSkillLevel?: InputMaybe<SkillLevelsObjRelInsertInput>;
  padelSkillLevelId?: InputMaybe<Scalars['String']>;
  pciId?: InputMaybe<Scalars['String']>;
  pickleballRatingScales?: InputMaybe<UserPickleballRatingScalesArrRelInsertInput>;
  pickleballSkillLevel?: InputMaybe<SkillLevelsObjRelInsertInput>;
  pickleballSkillLevelId?: InputMaybe<Scalars['String']>;
  playerFinderAvailability?: InputMaybe<UserPlayerFinderAvailabilityArrRelInsertInput>;
  playerLessonReflections?: InputMaybe<LessonReflectionsArrRelInsertInput>;
  playerReviews?: InputMaybe<ReviewsArrRelInsertInput>;
  pprId?: InputMaybe<Scalars['String']>;
  preferredName?: InputMaybe<Scalars['String']>;
  premiumContentDescription?: InputMaybe<Scalars['String']>;
  priceUnitAmountCoachDefault?: InputMaybe<Scalars['Int']>;
  priceUnitAmountPremiumContentDefault?: InputMaybe<Scalars['Int']>;
  priceUnitAmountRemoteCoachDefault?: InputMaybe<Scalars['Int']>;
  profileImageFileName?: InputMaybe<Scalars['String']>;
  profileImagePath?: InputMaybe<Scalars['String']>;
  profileImageProvider?: InputMaybe<Scalars['String']>;
  profileImageProviderId?: InputMaybe<Scalars['String']>;
  profileImageProviderUrl?: InputMaybe<Scalars['String']>;
  profileImageUrl?: InputMaybe<Scalars['String']>;
  quatroPickleballMemberId?: InputMaybe<Scalars['String']>;
  sports?: InputMaybe<UserSportsArrRelInsertInput>;
  stripeMerchantChargesEnabled?: InputMaybe<Scalars['Boolean']>;
  stripeMerchantCurrency?: InputMaybe<Scalars['String']>;
  stripeMerchantDetailsSubmitted?: InputMaybe<Scalars['Boolean']>;
  tennisRating?: InputMaybe<Scalars['numeric']>;
  tennisRatingScale?: InputMaybe<TennisRatingScalesObjRelInsertInput>;
  tennisRatingScaleId?: InputMaybe<Scalars['uuid']>;
  tennisRatingScales?: InputMaybe<UserTennisRatingScalesArrRelInsertInput>;
  tennisSkillLevel?: InputMaybe<SkillLevelsObjRelInsertInput>;
  tennisSkillLevelId?: InputMaybe<Scalars['String']>;
  tiktokUrl?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userFiles?: InputMaybe<UserFilesArrRelInsertInput>;
  username?: InputMaybe<Scalars['String']>;
  venueFollows?: InputMaybe<VenueFollowsArrRelInsertInput>;
  websiteUrl?: InputMaybe<Scalars['String']>;
  xUrl?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type UserProfilesMaxFields = {
  __typename?: 'UserProfilesMaxFields';
  aboutMe?: Maybe<Scalars['String']>;
  aboutMeVideoUrl?: Maybe<Scalars['String']>;
  activeCityId?: Maybe<Scalars['uuid']>;
  birthdayDay?: Maybe<Scalars['Int']>;
  birthdayMonth?: Maybe<Scalars['Int']>;
  birthdayVisibility?: Maybe<Scalars['String']>;
  birthdayYear?: Maybe<Scalars['Int']>;
  cityName?: Maybe<Scalars['String']>;
  coachExternalBookingUrl?: Maybe<Scalars['String']>;
  coachLessonDescription?: Maybe<Scalars['String']>;
  coachLessonHowToPrepare?: Maybe<Scalars['String']>;
  coachStatus?: Maybe<Scalars['String']>;
  coachingStartYear?: Maybe<Scalars['Int']>;
  countryId?: Maybe<Scalars['String']>;
  countrySubdivisionId?: Maybe<Scalars['uuid']>;
  coverImageFileName?: Maybe<Scalars['String']>;
  coverImagePath?: Maybe<Scalars['String']>;
  coverImageProvider?: Maybe<Scalars['String']>;
  coverImageProviderUrl?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currencyCoachDefault?: Maybe<Scalars['String']>;
  defaultCoachUserCustomCourtId?: Maybe<Scalars['uuid']>;
  defaultCoachVenueId?: Maybe<Scalars['uuid']>;
  defaultPickleballRatingScaleId?: Maybe<Scalars['uuid']>;
  defaultSport?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  duprId?: Maybe<Scalars['String']>;
  eventOrganizerAccountType?: Maybe<Scalars['String']>;
  facebookUrl?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  genderPreference?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  instagramUrl?: Maybe<Scalars['String']>;
  iptpaId?: Maybe<Scalars['String']>;
  linkedinUrl?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
  normalizedTennisRating?: Maybe<Scalars['numeric']>;
  normalizedTennisRatingScaleId?: Maybe<Scalars['uuid']>;
  padelSkillLevelId?: Maybe<Scalars['String']>;
  pciId?: Maybe<Scalars['String']>;
  pickleballSkillLevelId?: Maybe<Scalars['String']>;
  pprId?: Maybe<Scalars['String']>;
  preferredName?: Maybe<Scalars['String']>;
  premiumContentDescription?: Maybe<Scalars['String']>;
  priceUnitAmountCoachDefault?: Maybe<Scalars['Int']>;
  priceUnitAmountPremiumContentDefault?: Maybe<Scalars['Int']>;
  priceUnitAmountRemoteCoachDefault?: Maybe<Scalars['Int']>;
  profileImageFileName?: Maybe<Scalars['String']>;
  profileImagePath?: Maybe<Scalars['String']>;
  profileImageProvider?: Maybe<Scalars['String']>;
  profileImageProviderId?: Maybe<Scalars['String']>;
  profileImageProviderUrl?: Maybe<Scalars['String']>;
  profileImageUrl?: Maybe<Scalars['String']>;
  quatroPickleballMemberId?: Maybe<Scalars['String']>;
  stripeMerchantCurrency?: Maybe<Scalars['String']>;
  tennisRating?: Maybe<Scalars['numeric']>;
  tennisRatingScaleId?: Maybe<Scalars['uuid']>;
  tennisSkillLevelId?: Maybe<Scalars['String']>;
  tiktokUrl?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  username?: Maybe<Scalars['String']>;
  websiteUrl?: Maybe<Scalars['String']>;
  xUrl?: Maybe<Scalars['String']>;
  youtubeUrl?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type UserProfilesMinFields = {
  __typename?: 'UserProfilesMinFields';
  aboutMe?: Maybe<Scalars['String']>;
  aboutMeVideoUrl?: Maybe<Scalars['String']>;
  activeCityId?: Maybe<Scalars['uuid']>;
  birthdayDay?: Maybe<Scalars['Int']>;
  birthdayMonth?: Maybe<Scalars['Int']>;
  birthdayVisibility?: Maybe<Scalars['String']>;
  birthdayYear?: Maybe<Scalars['Int']>;
  cityName?: Maybe<Scalars['String']>;
  coachExternalBookingUrl?: Maybe<Scalars['String']>;
  coachLessonDescription?: Maybe<Scalars['String']>;
  coachLessonHowToPrepare?: Maybe<Scalars['String']>;
  coachStatus?: Maybe<Scalars['String']>;
  coachingStartYear?: Maybe<Scalars['Int']>;
  countryId?: Maybe<Scalars['String']>;
  countrySubdivisionId?: Maybe<Scalars['uuid']>;
  coverImageFileName?: Maybe<Scalars['String']>;
  coverImagePath?: Maybe<Scalars['String']>;
  coverImageProvider?: Maybe<Scalars['String']>;
  coverImageProviderUrl?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currencyCoachDefault?: Maybe<Scalars['String']>;
  defaultCoachUserCustomCourtId?: Maybe<Scalars['uuid']>;
  defaultCoachVenueId?: Maybe<Scalars['uuid']>;
  defaultPickleballRatingScaleId?: Maybe<Scalars['uuid']>;
  defaultSport?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  duprId?: Maybe<Scalars['String']>;
  eventOrganizerAccountType?: Maybe<Scalars['String']>;
  facebookUrl?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  genderPreference?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  instagramUrl?: Maybe<Scalars['String']>;
  iptpaId?: Maybe<Scalars['String']>;
  linkedinUrl?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
  normalizedTennisRating?: Maybe<Scalars['numeric']>;
  normalizedTennisRatingScaleId?: Maybe<Scalars['uuid']>;
  padelSkillLevelId?: Maybe<Scalars['String']>;
  pciId?: Maybe<Scalars['String']>;
  pickleballSkillLevelId?: Maybe<Scalars['String']>;
  pprId?: Maybe<Scalars['String']>;
  preferredName?: Maybe<Scalars['String']>;
  premiumContentDescription?: Maybe<Scalars['String']>;
  priceUnitAmountCoachDefault?: Maybe<Scalars['Int']>;
  priceUnitAmountPremiumContentDefault?: Maybe<Scalars['Int']>;
  priceUnitAmountRemoteCoachDefault?: Maybe<Scalars['Int']>;
  profileImageFileName?: Maybe<Scalars['String']>;
  profileImagePath?: Maybe<Scalars['String']>;
  profileImageProvider?: Maybe<Scalars['String']>;
  profileImageProviderId?: Maybe<Scalars['String']>;
  profileImageProviderUrl?: Maybe<Scalars['String']>;
  profileImageUrl?: Maybe<Scalars['String']>;
  quatroPickleballMemberId?: Maybe<Scalars['String']>;
  stripeMerchantCurrency?: Maybe<Scalars['String']>;
  tennisRating?: Maybe<Scalars['numeric']>;
  tennisRatingScaleId?: Maybe<Scalars['uuid']>;
  tennisSkillLevelId?: Maybe<Scalars['String']>;
  tiktokUrl?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  username?: Maybe<Scalars['String']>;
  websiteUrl?: Maybe<Scalars['String']>;
  xUrl?: Maybe<Scalars['String']>;
  youtubeUrl?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "user_profiles" */
export type UserProfilesMutationResponse = {
  __typename?: 'UserProfilesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UserProfiles>;
};

/** input type for inserting object relation for remote table "user_profiles" */
export type UserProfilesObjRelInsertInput = {
  data: UserProfilesInsertInput;
};

/** Ordering options when selecting data from "user_profiles". */
export type UserProfilesOrderBy = {
  aboutMe?: InputMaybe<OrderBy>;
  aboutMeVideoUrl?: InputMaybe<OrderBy>;
  activeCity?: InputMaybe<CitiesOrderBy>;
  activeCityId?: InputMaybe<OrderBy>;
  birthdayDay?: InputMaybe<OrderBy>;
  birthdayMonth?: InputMaybe<OrderBy>;
  birthdayVisibility?: InputMaybe<OrderBy>;
  birthdayYear?: InputMaybe<OrderBy>;
  cityName?: InputMaybe<OrderBy>;
  coachAvailabilityAggregate?: InputMaybe<CoachAvailabilityAggregateOrderBy>;
  coachExternalBookingUrl?: InputMaybe<OrderBy>;
  coachFaqsAggregate?: InputMaybe<CoachFaqsAggregateOrderBy>;
  coachLessonAgeGroupsAggregate?: InputMaybe<CoachLessonAgeGroupsAggregateOrderBy>;
  coachLessonDescription?: InputMaybe<OrderBy>;
  coachLessonHowToPrepare?: InputMaybe<OrderBy>;
  coachLessonReflectionsAggregate?: InputMaybe<LessonReflectionsAggregateOrderBy>;
  coachLessonSkillLevelsAggregate?: InputMaybe<CoachLessonSkillLevelsAggregateOrderBy>;
  coachLessonsAggregate?: InputMaybe<LessonsAggregateOrderBy>;
  coachQualificationsAggregate?: InputMaybe<UsersCoachQualificationsAggregateOrderBy>;
  coachReviewsAggregate?: InputMaybe<ReviewsAggregateOrderBy>;
  coachServicesAggregate?: InputMaybe<UserCoachServicesAggregateOrderBy>;
  coachSportsAggregate?: InputMaybe<CoachSportsAggregateOrderBy>;
  coachStatus?: InputMaybe<OrderBy>;
  coachingStartYear?: InputMaybe<OrderBy>;
  country?: InputMaybe<CountriesOrderBy>;
  countryId?: InputMaybe<OrderBy>;
  countrySubdivision?: InputMaybe<CountrySubdivisionsOrderBy>;
  countrySubdivisionId?: InputMaybe<OrderBy>;
  coverImageFileName?: InputMaybe<OrderBy>;
  coverImagePath?: InputMaybe<OrderBy>;
  coverImageProvider?: InputMaybe<OrderBy>;
  coverImageProviderUrl?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  currencyCoachDefault?: InputMaybe<OrderBy>;
  defaultCoachCustomCourt?: InputMaybe<UserCustomCourtsOrderBy>;
  defaultCoachUserCustomCourtId?: InputMaybe<OrderBy>;
  defaultCoachVenue?: InputMaybe<VenuesOrderBy>;
  defaultCoachVenueId?: InputMaybe<OrderBy>;
  defaultPickleballRatingScale?: InputMaybe<PickleballRatingScalesOrderBy>;
  defaultPickleballRatingScaleId?: InputMaybe<OrderBy>;
  defaultSport?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  duprId?: InputMaybe<OrderBy>;
  eventOrganizerAccountType?: InputMaybe<OrderBy>;
  facebookUrl?: InputMaybe<OrderBy>;
  followersAggregate?: InputMaybe<UserFollowsAggregateOrderBy>;
  followingAggregate?: InputMaybe<UserFollowsAggregateOrderBy>;
  fullName?: InputMaybe<OrderBy>;
  gender?: InputMaybe<OrderBy>;
  genderPreference?: InputMaybe<OrderBy>;
  geometry?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  identityVerificationsAggregate?: InputMaybe<UserIdentityVerificationsAggregateOrderBy>;
  instagramUrl?: InputMaybe<OrderBy>;
  iptpaId?: InputMaybe<OrderBy>;
  isIptpaMember?: InputMaybe<OrderBy>;
  isPciMember?: InputMaybe<OrderBy>;
  isPicklrP4Member?: InputMaybe<OrderBy>;
  isPprMember?: InputMaybe<OrderBy>;
  isProfessionalRacquetRegistryActive?: InputMaybe<OrderBy>;
  isQuatroPickleballMember?: InputMaybe<OrderBy>;
  linkedinUrl?: InputMaybe<OrderBy>;
  locale?: InputMaybe<OrderBy>;
  normalizedTennisRating?: InputMaybe<OrderBy>;
  normalizedTennisRatingScale?: InputMaybe<TennisRatingScalesOrderBy>;
  normalizedTennisRatingScaleId?: InputMaybe<OrderBy>;
  padelRatingScalesAggregate?: InputMaybe<UserPadelRatingScalesAggregateOrderBy>;
  padelSkillLevel?: InputMaybe<SkillLevelsOrderBy>;
  padelSkillLevelId?: InputMaybe<OrderBy>;
  pciId?: InputMaybe<OrderBy>;
  pickleballRatingScalesAggregate?: InputMaybe<UserPickleballRatingScalesAggregateOrderBy>;
  pickleballSkillLevel?: InputMaybe<SkillLevelsOrderBy>;
  pickleballSkillLevelId?: InputMaybe<OrderBy>;
  playerFinderAvailabilityAggregate?: InputMaybe<UserPlayerFinderAvailabilityAggregateOrderBy>;
  playerLessonReflectionsAggregate?: InputMaybe<LessonReflectionsAggregateOrderBy>;
  playerReviewsAggregate?: InputMaybe<ReviewsAggregateOrderBy>;
  pprId?: InputMaybe<OrderBy>;
  preferredName?: InputMaybe<OrderBy>;
  premiumContentDescription?: InputMaybe<OrderBy>;
  priceUnitAmountCoachDefault?: InputMaybe<OrderBy>;
  priceUnitAmountPremiumContentDefault?: InputMaybe<OrderBy>;
  priceUnitAmountRemoteCoachDefault?: InputMaybe<OrderBy>;
  profileImageFileName?: InputMaybe<OrderBy>;
  profileImagePath?: InputMaybe<OrderBy>;
  profileImageProvider?: InputMaybe<OrderBy>;
  profileImageProviderId?: InputMaybe<OrderBy>;
  profileImageProviderUrl?: InputMaybe<OrderBy>;
  profileImageUrl?: InputMaybe<OrderBy>;
  quatroPickleballMemberId?: InputMaybe<OrderBy>;
  sportsAggregate?: InputMaybe<UserSportsAggregateOrderBy>;
  stripeMerchantChargesEnabled?: InputMaybe<OrderBy>;
  stripeMerchantCurrency?: InputMaybe<OrderBy>;
  stripeMerchantDetailsSubmitted?: InputMaybe<OrderBy>;
  tennisRating?: InputMaybe<OrderBy>;
  tennisRatingScale?: InputMaybe<TennisRatingScalesOrderBy>;
  tennisRatingScaleId?: InputMaybe<OrderBy>;
  tennisRatingScalesAggregate?: InputMaybe<UserTennisRatingScalesAggregateOrderBy>;
  tennisSkillLevel?: InputMaybe<SkillLevelsOrderBy>;
  tennisSkillLevelId?: InputMaybe<OrderBy>;
  tiktokUrl?: InputMaybe<OrderBy>;
  timezone?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userFilesAggregate?: InputMaybe<UserFilesAggregateOrderBy>;
  username?: InputMaybe<OrderBy>;
  venueFollowsAggregate?: InputMaybe<VenueFollowsAggregateOrderBy>;
  websiteUrl?: InputMaybe<OrderBy>;
  xUrl?: InputMaybe<OrderBy>;
  youtubeUrl?: InputMaybe<OrderBy>;
};

/** select columns of table "user_profiles" */
export enum UserProfilesSelectColumn {
  /** column name */
  AboutMe = 'aboutMe',
  /** column name */
  AboutMeVideoUrl = 'aboutMeVideoUrl',
  /** column name */
  ActiveCityId = 'activeCityId',
  /** column name */
  BirthdayDay = 'birthdayDay',
  /** column name */
  BirthdayMonth = 'birthdayMonth',
  /** column name */
  BirthdayVisibility = 'birthdayVisibility',
  /** column name */
  BirthdayYear = 'birthdayYear',
  /** column name */
  CityName = 'cityName',
  /** column name */
  CoachExternalBookingUrl = 'coachExternalBookingUrl',
  /** column name */
  CoachLessonDescription = 'coachLessonDescription',
  /** column name */
  CoachLessonHowToPrepare = 'coachLessonHowToPrepare',
  /** column name */
  CoachStatus = 'coachStatus',
  /** column name */
  CoachingStartYear = 'coachingStartYear',
  /** column name */
  CountryId = 'countryId',
  /** column name */
  CountrySubdivisionId = 'countrySubdivisionId',
  /** column name */
  CoverImageFileName = 'coverImageFileName',
  /** column name */
  CoverImagePath = 'coverImagePath',
  /** column name */
  CoverImageProvider = 'coverImageProvider',
  /** column name */
  CoverImageProviderUrl = 'coverImageProviderUrl',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CurrencyCoachDefault = 'currencyCoachDefault',
  /** column name */
  DefaultCoachUserCustomCourtId = 'defaultCoachUserCustomCourtId',
  /** column name */
  DefaultCoachVenueId = 'defaultCoachVenueId',
  /** column name */
  DefaultPickleballRatingScaleId = 'defaultPickleballRatingScaleId',
  /** column name */
  DefaultSport = 'defaultSport',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  DuprId = 'duprId',
  /** column name */
  EventOrganizerAccountType = 'eventOrganizerAccountType',
  /** column name */
  FacebookUrl = 'facebookUrl',
  /** column name */
  FullName = 'fullName',
  /** column name */
  Gender = 'gender',
  /** column name */
  GenderPreference = 'genderPreference',
  /** column name */
  Geometry = 'geometry',
  /** column name */
  Id = 'id',
  /** column name */
  InstagramUrl = 'instagramUrl',
  /** column name */
  IptpaId = 'iptpaId',
  /** column name */
  IsIptpaMember = 'isIptpaMember',
  /** column name */
  IsPciMember = 'isPciMember',
  /** column name */
  IsPicklrP4Member = 'isPicklrP4Member',
  /** column name */
  IsPprMember = 'isPprMember',
  /** column name */
  IsProfessionalRacquetRegistryActive = 'isProfessionalRacquetRegistryActive',
  /** column name */
  IsQuatroPickleballMember = 'isQuatroPickleballMember',
  /** column name */
  LinkedinUrl = 'linkedinUrl',
  /** column name */
  Locale = 'locale',
  /** column name */
  NormalizedTennisRating = 'normalizedTennisRating',
  /** column name */
  NormalizedTennisRatingScaleId = 'normalizedTennisRatingScaleId',
  /** column name */
  PadelSkillLevelId = 'padelSkillLevelId',
  /** column name */
  PciId = 'pciId',
  /** column name */
  PickleballSkillLevelId = 'pickleballSkillLevelId',
  /** column name */
  PprId = 'pprId',
  /** column name */
  PreferredName = 'preferredName',
  /** column name */
  PremiumContentDescription = 'premiumContentDescription',
  /** column name */
  PriceUnitAmountCoachDefault = 'priceUnitAmountCoachDefault',
  /** column name */
  PriceUnitAmountPremiumContentDefault = 'priceUnitAmountPremiumContentDefault',
  /** column name */
  PriceUnitAmountRemoteCoachDefault = 'priceUnitAmountRemoteCoachDefault',
  /** column name */
  ProfileImageFileName = 'profileImageFileName',
  /** column name */
  ProfileImagePath = 'profileImagePath',
  /** column name */
  ProfileImageProvider = 'profileImageProvider',
  /** column name */
  ProfileImageProviderId = 'profileImageProviderId',
  /** column name */
  ProfileImageProviderUrl = 'profileImageProviderUrl',
  /** column name */
  ProfileImageUrl = 'profileImageUrl',
  /** column name */
  QuatroPickleballMemberId = 'quatroPickleballMemberId',
  /** column name */
  StripeMerchantChargesEnabled = 'stripeMerchantChargesEnabled',
  /** column name */
  StripeMerchantCurrency = 'stripeMerchantCurrency',
  /** column name */
  StripeMerchantDetailsSubmitted = 'stripeMerchantDetailsSubmitted',
  /** column name */
  TennisRating = 'tennisRating',
  /** column name */
  TennisRatingScaleId = 'tennisRatingScaleId',
  /** column name */
  TennisSkillLevelId = 'tennisSkillLevelId',
  /** column name */
  TiktokUrl = 'tiktokUrl',
  /** column name */
  Timezone = 'timezone',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Username = 'username',
  /** column name */
  WebsiteUrl = 'websiteUrl',
  /** column name */
  XUrl = 'xUrl',
  /** column name */
  YoutubeUrl = 'youtubeUrl'
}

/** input type for updating data in table "user_profiles" */
export type UserProfilesSetInput = {
  aboutMe?: InputMaybe<Scalars['String']>;
  aboutMeVideoUrl?: InputMaybe<Scalars['String']>;
  activeCityId?: InputMaybe<Scalars['uuid']>;
  birthdayDay?: InputMaybe<Scalars['Int']>;
  birthdayMonth?: InputMaybe<Scalars['Int']>;
  birthdayVisibility?: InputMaybe<Scalars['String']>;
  birthdayYear?: InputMaybe<Scalars['Int']>;
  cityName?: InputMaybe<Scalars['String']>;
  coachExternalBookingUrl?: InputMaybe<Scalars['String']>;
  coachLessonDescription?: InputMaybe<Scalars['String']>;
  coachLessonHowToPrepare?: InputMaybe<Scalars['String']>;
  coachStatus?: InputMaybe<Scalars['String']>;
  coachingStartYear?: InputMaybe<Scalars['Int']>;
  countryId?: InputMaybe<Scalars['String']>;
  countrySubdivisionId?: InputMaybe<Scalars['uuid']>;
  coverImageFileName?: InputMaybe<Scalars['String']>;
  coverImagePath?: InputMaybe<Scalars['String']>;
  coverImageProvider?: InputMaybe<Scalars['String']>;
  coverImageProviderUrl?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currencyCoachDefault?: InputMaybe<Scalars['String']>;
  defaultCoachUserCustomCourtId?: InputMaybe<Scalars['uuid']>;
  defaultCoachVenueId?: InputMaybe<Scalars['uuid']>;
  defaultPickleballRatingScaleId?: InputMaybe<Scalars['uuid']>;
  defaultSport?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  duprId?: InputMaybe<Scalars['String']>;
  eventOrganizerAccountType?: InputMaybe<Scalars['String']>;
  facebookUrl?: InputMaybe<Scalars['String']>;
  fullName?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  genderPreference?: InputMaybe<Scalars['String']>;
  geometry?: InputMaybe<Scalars['geography']>;
  id?: InputMaybe<Scalars['uuid']>;
  instagramUrl?: InputMaybe<Scalars['String']>;
  iptpaId?: InputMaybe<Scalars['String']>;
  isIptpaMember?: InputMaybe<Scalars['Boolean']>;
  isPciMember?: InputMaybe<Scalars['Boolean']>;
  isPicklrP4Member?: InputMaybe<Scalars['Boolean']>;
  isPprMember?: InputMaybe<Scalars['Boolean']>;
  isProfessionalRacquetRegistryActive?: InputMaybe<Scalars['Boolean']>;
  isQuatroPickleballMember?: InputMaybe<Scalars['Boolean']>;
  linkedinUrl?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  normalizedTennisRating?: InputMaybe<Scalars['numeric']>;
  normalizedTennisRatingScaleId?: InputMaybe<Scalars['uuid']>;
  padelSkillLevelId?: InputMaybe<Scalars['String']>;
  pciId?: InputMaybe<Scalars['String']>;
  pickleballSkillLevelId?: InputMaybe<Scalars['String']>;
  pprId?: InputMaybe<Scalars['String']>;
  preferredName?: InputMaybe<Scalars['String']>;
  premiumContentDescription?: InputMaybe<Scalars['String']>;
  priceUnitAmountCoachDefault?: InputMaybe<Scalars['Int']>;
  priceUnitAmountPremiumContentDefault?: InputMaybe<Scalars['Int']>;
  priceUnitAmountRemoteCoachDefault?: InputMaybe<Scalars['Int']>;
  profileImageFileName?: InputMaybe<Scalars['String']>;
  profileImagePath?: InputMaybe<Scalars['String']>;
  profileImageProvider?: InputMaybe<Scalars['String']>;
  profileImageProviderId?: InputMaybe<Scalars['String']>;
  profileImageProviderUrl?: InputMaybe<Scalars['String']>;
  profileImageUrl?: InputMaybe<Scalars['String']>;
  quatroPickleballMemberId?: InputMaybe<Scalars['String']>;
  stripeMerchantChargesEnabled?: InputMaybe<Scalars['Boolean']>;
  stripeMerchantCurrency?: InputMaybe<Scalars['String']>;
  stripeMerchantDetailsSubmitted?: InputMaybe<Scalars['Boolean']>;
  tennisRating?: InputMaybe<Scalars['numeric']>;
  tennisRatingScaleId?: InputMaybe<Scalars['uuid']>;
  tennisSkillLevelId?: InputMaybe<Scalars['String']>;
  tiktokUrl?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  username?: InputMaybe<Scalars['String']>;
  websiteUrl?: InputMaybe<Scalars['String']>;
  xUrl?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type UserProfilesStddevFields = {
  __typename?: 'UserProfilesStddevFields';
  birthdayDay?: Maybe<Scalars['Float']>;
  birthdayMonth?: Maybe<Scalars['Float']>;
  birthdayYear?: Maybe<Scalars['Float']>;
  coachingStartYear?: Maybe<Scalars['Float']>;
  normalizedTennisRating?: Maybe<Scalars['Float']>;
  priceUnitAmountCoachDefault?: Maybe<Scalars['Float']>;
  priceUnitAmountPremiumContentDefault?: Maybe<Scalars['Float']>;
  priceUnitAmountRemoteCoachDefault?: Maybe<Scalars['Float']>;
  tennisRating?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type UserProfilesStddevPopFields = {
  __typename?: 'UserProfilesStddevPopFields';
  birthdayDay?: Maybe<Scalars['Float']>;
  birthdayMonth?: Maybe<Scalars['Float']>;
  birthdayYear?: Maybe<Scalars['Float']>;
  coachingStartYear?: Maybe<Scalars['Float']>;
  normalizedTennisRating?: Maybe<Scalars['Float']>;
  priceUnitAmountCoachDefault?: Maybe<Scalars['Float']>;
  priceUnitAmountPremiumContentDefault?: Maybe<Scalars['Float']>;
  priceUnitAmountRemoteCoachDefault?: Maybe<Scalars['Float']>;
  tennisRating?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type UserProfilesStddevSampFields = {
  __typename?: 'UserProfilesStddevSampFields';
  birthdayDay?: Maybe<Scalars['Float']>;
  birthdayMonth?: Maybe<Scalars['Float']>;
  birthdayYear?: Maybe<Scalars['Float']>;
  coachingStartYear?: Maybe<Scalars['Float']>;
  normalizedTennisRating?: Maybe<Scalars['Float']>;
  priceUnitAmountCoachDefault?: Maybe<Scalars['Float']>;
  priceUnitAmountPremiumContentDefault?: Maybe<Scalars['Float']>;
  priceUnitAmountRemoteCoachDefault?: Maybe<Scalars['Float']>;
  tennisRating?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "user_profiles" */
export type UserProfilesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UserProfilesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserProfilesStreamCursorValueInput = {
  aboutMe?: InputMaybe<Scalars['String']>;
  aboutMeVideoUrl?: InputMaybe<Scalars['String']>;
  activeCityId?: InputMaybe<Scalars['uuid']>;
  birthdayDay?: InputMaybe<Scalars['Int']>;
  birthdayMonth?: InputMaybe<Scalars['Int']>;
  birthdayVisibility?: InputMaybe<Scalars['String']>;
  birthdayYear?: InputMaybe<Scalars['Int']>;
  cityName?: InputMaybe<Scalars['String']>;
  coachExternalBookingUrl?: InputMaybe<Scalars['String']>;
  coachLessonDescription?: InputMaybe<Scalars['String']>;
  coachLessonHowToPrepare?: InputMaybe<Scalars['String']>;
  coachStatus?: InputMaybe<Scalars['String']>;
  coachingStartYear?: InputMaybe<Scalars['Int']>;
  countryId?: InputMaybe<Scalars['String']>;
  countrySubdivisionId?: InputMaybe<Scalars['uuid']>;
  coverImageFileName?: InputMaybe<Scalars['String']>;
  coverImagePath?: InputMaybe<Scalars['String']>;
  coverImageProvider?: InputMaybe<Scalars['String']>;
  coverImageProviderUrl?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currencyCoachDefault?: InputMaybe<Scalars['String']>;
  defaultCoachUserCustomCourtId?: InputMaybe<Scalars['uuid']>;
  defaultCoachVenueId?: InputMaybe<Scalars['uuid']>;
  defaultPickleballRatingScaleId?: InputMaybe<Scalars['uuid']>;
  defaultSport?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  duprId?: InputMaybe<Scalars['String']>;
  eventOrganizerAccountType?: InputMaybe<Scalars['String']>;
  facebookUrl?: InputMaybe<Scalars['String']>;
  fullName?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  genderPreference?: InputMaybe<Scalars['String']>;
  geometry?: InputMaybe<Scalars['geography']>;
  id?: InputMaybe<Scalars['uuid']>;
  instagramUrl?: InputMaybe<Scalars['String']>;
  iptpaId?: InputMaybe<Scalars['String']>;
  isIptpaMember?: InputMaybe<Scalars['Boolean']>;
  isPciMember?: InputMaybe<Scalars['Boolean']>;
  isPicklrP4Member?: InputMaybe<Scalars['Boolean']>;
  isPprMember?: InputMaybe<Scalars['Boolean']>;
  isProfessionalRacquetRegistryActive?: InputMaybe<Scalars['Boolean']>;
  isQuatroPickleballMember?: InputMaybe<Scalars['Boolean']>;
  linkedinUrl?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  normalizedTennisRating?: InputMaybe<Scalars['numeric']>;
  normalizedTennisRatingScaleId?: InputMaybe<Scalars['uuid']>;
  padelSkillLevelId?: InputMaybe<Scalars['String']>;
  pciId?: InputMaybe<Scalars['String']>;
  pickleballSkillLevelId?: InputMaybe<Scalars['String']>;
  pprId?: InputMaybe<Scalars['String']>;
  preferredName?: InputMaybe<Scalars['String']>;
  premiumContentDescription?: InputMaybe<Scalars['String']>;
  priceUnitAmountCoachDefault?: InputMaybe<Scalars['Int']>;
  priceUnitAmountPremiumContentDefault?: InputMaybe<Scalars['Int']>;
  priceUnitAmountRemoteCoachDefault?: InputMaybe<Scalars['Int']>;
  profileImageFileName?: InputMaybe<Scalars['String']>;
  profileImagePath?: InputMaybe<Scalars['String']>;
  profileImageProvider?: InputMaybe<Scalars['String']>;
  profileImageProviderId?: InputMaybe<Scalars['String']>;
  profileImageProviderUrl?: InputMaybe<Scalars['String']>;
  profileImageUrl?: InputMaybe<Scalars['String']>;
  quatroPickleballMemberId?: InputMaybe<Scalars['String']>;
  stripeMerchantChargesEnabled?: InputMaybe<Scalars['Boolean']>;
  stripeMerchantCurrency?: InputMaybe<Scalars['String']>;
  stripeMerchantDetailsSubmitted?: InputMaybe<Scalars['Boolean']>;
  tennisRating?: InputMaybe<Scalars['numeric']>;
  tennisRatingScaleId?: InputMaybe<Scalars['uuid']>;
  tennisSkillLevelId?: InputMaybe<Scalars['String']>;
  tiktokUrl?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  username?: InputMaybe<Scalars['String']>;
  websiteUrl?: InputMaybe<Scalars['String']>;
  xUrl?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type UserProfilesSumFields = {
  __typename?: 'UserProfilesSumFields';
  birthdayDay?: Maybe<Scalars['Int']>;
  birthdayMonth?: Maybe<Scalars['Int']>;
  birthdayYear?: Maybe<Scalars['Int']>;
  coachingStartYear?: Maybe<Scalars['Int']>;
  normalizedTennisRating?: Maybe<Scalars['numeric']>;
  priceUnitAmountCoachDefault?: Maybe<Scalars['Int']>;
  priceUnitAmountPremiumContentDefault?: Maybe<Scalars['Int']>;
  priceUnitAmountRemoteCoachDefault?: Maybe<Scalars['Int']>;
  tennisRating?: Maybe<Scalars['numeric']>;
};

export type UserProfilesUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<UserProfilesIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserProfilesSetInput>;
  /** filter the rows which have to be updated */
  where: UserProfilesBoolExp;
};

/** aggregate varPop on columns */
export type UserProfilesVarPopFields = {
  __typename?: 'UserProfilesVarPopFields';
  birthdayDay?: Maybe<Scalars['Float']>;
  birthdayMonth?: Maybe<Scalars['Float']>;
  birthdayYear?: Maybe<Scalars['Float']>;
  coachingStartYear?: Maybe<Scalars['Float']>;
  normalizedTennisRating?: Maybe<Scalars['Float']>;
  priceUnitAmountCoachDefault?: Maybe<Scalars['Float']>;
  priceUnitAmountPremiumContentDefault?: Maybe<Scalars['Float']>;
  priceUnitAmountRemoteCoachDefault?: Maybe<Scalars['Float']>;
  tennisRating?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type UserProfilesVarSampFields = {
  __typename?: 'UserProfilesVarSampFields';
  birthdayDay?: Maybe<Scalars['Float']>;
  birthdayMonth?: Maybe<Scalars['Float']>;
  birthdayYear?: Maybe<Scalars['Float']>;
  coachingStartYear?: Maybe<Scalars['Float']>;
  normalizedTennisRating?: Maybe<Scalars['Float']>;
  priceUnitAmountCoachDefault?: Maybe<Scalars['Float']>;
  priceUnitAmountPremiumContentDefault?: Maybe<Scalars['Float']>;
  priceUnitAmountRemoteCoachDefault?: Maybe<Scalars['Float']>;
  tennisRating?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type UserProfilesVarianceFields = {
  __typename?: 'UserProfilesVarianceFields';
  birthdayDay?: Maybe<Scalars['Float']>;
  birthdayMonth?: Maybe<Scalars['Float']>;
  birthdayYear?: Maybe<Scalars['Float']>;
  coachingStartYear?: Maybe<Scalars['Float']>;
  normalizedTennisRating?: Maybe<Scalars['Float']>;
  priceUnitAmountCoachDefault?: Maybe<Scalars['Float']>;
  priceUnitAmountPremiumContentDefault?: Maybe<Scalars['Float']>;
  priceUnitAmountRemoteCoachDefault?: Maybe<Scalars['Float']>;
  tennisRating?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "user_registration_details" */
export type UserRegistrationDetails = {
  __typename?: 'UserRegistrationDetails';
  city: Scalars['String'];
  country: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  fullDetails?: Maybe<Scalars['jsonb']>;
  id: Scalars['uuid'];
  ip: Scalars['String'];
  platform: Scalars['String'];
  region: Scalars['String'];
  timezone: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user?: Maybe<Users>;
  userId?: Maybe<Scalars['uuid']>;
  zip: Scalars['String'];
};


/** columns and relationships of "user_registration_details" */
export type UserRegistrationDetailsFullDetailsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "user_registration_details" */
export type UserRegistrationDetailsAggregate = {
  __typename?: 'UserRegistrationDetailsAggregate';
  aggregate?: Maybe<UserRegistrationDetailsAggregateFields>;
  nodes: Array<UserRegistrationDetails>;
};

/** aggregate fields of "user_registration_details" */
export type UserRegistrationDetailsAggregateFields = {
  __typename?: 'UserRegistrationDetailsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<UserRegistrationDetailsMaxFields>;
  min?: Maybe<UserRegistrationDetailsMinFields>;
};


/** aggregate fields of "user_registration_details" */
export type UserRegistrationDetailsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<UserRegistrationDetailsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type UserRegistrationDetailsAppendInput = {
  fullDetails?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "user_registration_details". All fields are combined with a logical 'AND'. */
export type UserRegistrationDetailsBoolExp = {
  _and?: InputMaybe<Array<UserRegistrationDetailsBoolExp>>;
  _not?: InputMaybe<UserRegistrationDetailsBoolExp>;
  _or?: InputMaybe<Array<UserRegistrationDetailsBoolExp>>;
  city?: InputMaybe<StringComparisonExp>;
  country?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  fullDetails?: InputMaybe<JsonbComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  ip?: InputMaybe<StringComparisonExp>;
  platform?: InputMaybe<StringComparisonExp>;
  region?: InputMaybe<StringComparisonExp>;
  timezone?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
  zip?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "user_registration_details" */
export enum UserRegistrationDetailsConstraint {
  /** unique or primary key constraint on columns "id" */
  UserRegistrationDetailsPkey = 'user_registration_details_pkey',
  /** unique or primary key constraint on columns "user_id" */
  UserRegistrationDetailsUserIdKey = 'user_registration_details_user_id_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type UserRegistrationDetailsDeleteAtPathInput = {
  fullDetails?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type UserRegistrationDetailsDeleteElemInput = {
  fullDetails?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type UserRegistrationDetailsDeleteKeyInput = {
  fullDetails?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "user_registration_details" */
export type UserRegistrationDetailsInsertInput = {
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  fullDetails?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  ip?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']>;
  zip?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type UserRegistrationDetailsMaxFields = {
  __typename?: 'UserRegistrationDetailsMaxFields';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  ip?: Maybe<Scalars['String']>;
  platform?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
  zip?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type UserRegistrationDetailsMinFields = {
  __typename?: 'UserRegistrationDetailsMinFields';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  ip?: Maybe<Scalars['String']>;
  platform?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
  zip?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "user_registration_details" */
export type UserRegistrationDetailsMutationResponse = {
  __typename?: 'UserRegistrationDetailsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UserRegistrationDetails>;
};

/** input type for inserting object relation for remote table "user_registration_details" */
export type UserRegistrationDetailsObjRelInsertInput = {
  data: UserRegistrationDetailsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<UserRegistrationDetailsOnConflict>;
};

/** on_conflict condition type for table "user_registration_details" */
export type UserRegistrationDetailsOnConflict = {
  constraint: UserRegistrationDetailsConstraint;
  updateColumns?: Array<UserRegistrationDetailsUpdateColumn>;
  where?: InputMaybe<UserRegistrationDetailsBoolExp>;
};

/** Ordering options when selecting data from "user_registration_details". */
export type UserRegistrationDetailsOrderBy = {
  city?: InputMaybe<OrderBy>;
  country?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  fullDetails?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  ip?: InputMaybe<OrderBy>;
  platform?: InputMaybe<OrderBy>;
  region?: InputMaybe<OrderBy>;
  timezone?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
  zip?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: user_registration_details */
export type UserRegistrationDetailsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type UserRegistrationDetailsPrependInput = {
  fullDetails?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "user_registration_details" */
export enum UserRegistrationDetailsSelectColumn {
  /** column name */
  City = 'city',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  FullDetails = 'fullDetails',
  /** column name */
  Id = 'id',
  /** column name */
  Ip = 'ip',
  /** column name */
  Platform = 'platform',
  /** column name */
  Region = 'region',
  /** column name */
  Timezone = 'timezone',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId',
  /** column name */
  Zip = 'zip'
}

/** input type for updating data in table "user_registration_details" */
export type UserRegistrationDetailsSetInput = {
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  fullDetails?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  ip?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
  zip?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "user_registration_details" */
export type UserRegistrationDetailsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UserRegistrationDetailsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserRegistrationDetailsStreamCursorValueInput = {
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  fullDetails?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  ip?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
  zip?: InputMaybe<Scalars['String']>;
};

/** update columns of table "user_registration_details" */
export enum UserRegistrationDetailsUpdateColumn {
  /** column name */
  City = 'city',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  FullDetails = 'fullDetails',
  /** column name */
  Id = 'id',
  /** column name */
  Ip = 'ip',
  /** column name */
  Platform = 'platform',
  /** column name */
  Region = 'region',
  /** column name */
  Timezone = 'timezone',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId',
  /** column name */
  Zip = 'zip'
}

export type UserRegistrationDetailsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<UserRegistrationDetailsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _deleteAtPath?: InputMaybe<UserRegistrationDetailsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _deleteElem?: InputMaybe<UserRegistrationDetailsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _deleteKey?: InputMaybe<UserRegistrationDetailsDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<UserRegistrationDetailsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserRegistrationDetailsSetInput>;
  /** filter the rows which have to be updated */
  where: UserRegistrationDetailsBoolExp;
};

/** columns and relationships of "user_sports" */
export type UserSports = {
  __typename?: 'UserSports';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  sport: SportsEnum;
  updatedAt: Scalars['timestamptz'];
  userId: Scalars['uuid'];
};

/** aggregated selection of "user_sports" */
export type UserSportsAggregate = {
  __typename?: 'UserSportsAggregate';
  aggregate?: Maybe<UserSportsAggregateFields>;
  nodes: Array<UserSports>;
};

export type UserSportsAggregateBoolExp = {
  count?: InputMaybe<UserSportsAggregateBoolExpCount>;
};

/** aggregate fields of "user_sports" */
export type UserSportsAggregateFields = {
  __typename?: 'UserSportsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<UserSportsMaxFields>;
  min?: Maybe<UserSportsMinFields>;
};


/** aggregate fields of "user_sports" */
export type UserSportsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<UserSportsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_sports" */
export type UserSportsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<UserSportsMaxOrderBy>;
  min?: InputMaybe<UserSportsMinOrderBy>;
};

/** input type for inserting array relation for remote table "user_sports" */
export type UserSportsArrRelInsertInput = {
  data: Array<UserSportsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<UserSportsOnConflict>;
};

/** Boolean expression to filter rows from the table "user_sports". All fields are combined with a logical 'AND'. */
export type UserSportsBoolExp = {
  _and?: InputMaybe<Array<UserSportsBoolExp>>;
  _not?: InputMaybe<UserSportsBoolExp>;
  _or?: InputMaybe<Array<UserSportsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  sport?: InputMaybe<SportsEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "user_sports" */
export enum UserSportsConstraint {
  /** unique or primary key constraint on columns "id" */
  UserSportsPkey = 'user_sports_pkey',
  /** unique or primary key constraint on columns "sport", "user_id" */
  UserSportsUserIdSportKey = 'user_sports_user_id_sport_key'
}

/** input type for inserting data into table "user_sports" */
export type UserSportsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  sport?: InputMaybe<SportsEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type UserSportsMaxFields = {
  __typename?: 'UserSportsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "user_sports" */
export type UserSportsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type UserSportsMinFields = {
  __typename?: 'UserSportsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "user_sports" */
export type UserSportsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "user_sports" */
export type UserSportsMutationResponse = {
  __typename?: 'UserSportsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UserSports>;
};

/** on_conflict condition type for table "user_sports" */
export type UserSportsOnConflict = {
  constraint: UserSportsConstraint;
  updateColumns?: Array<UserSportsUpdateColumn>;
  where?: InputMaybe<UserSportsBoolExp>;
};

/** Ordering options when selecting data from "user_sports". */
export type UserSportsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  sport?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: user_sports */
export type UserSportsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "user_sports" */
export enum UserSportsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  Sport = 'sport',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "user_sports" */
export type UserSportsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  sport?: InputMaybe<SportsEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "user_sports" */
export type UserSportsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UserSportsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserSportsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  sport?: InputMaybe<SportsEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "user_sports" */
export enum UserSportsUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  Sport = 'sport',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

export type UserSportsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserSportsSetInput>;
  /** filter the rows which have to be updated */
  where: UserSportsBoolExp;
};

/** columns and relationships of "user_tennis_rating_scales" */
export type UserTennisRatingScales = {
  __typename?: 'UserTennisRatingScales';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  rating: Scalars['numeric'];
  /** An object relationship */
  scale: TennisRatingScales;
  tennisRatingScaleId: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid'];
};

/** aggregated selection of "user_tennis_rating_scales" */
export type UserTennisRatingScalesAggregate = {
  __typename?: 'UserTennisRatingScalesAggregate';
  aggregate?: Maybe<UserTennisRatingScalesAggregateFields>;
  nodes: Array<UserTennisRatingScales>;
};

export type UserTennisRatingScalesAggregateBoolExp = {
  count?: InputMaybe<UserTennisRatingScalesAggregateBoolExpCount>;
};

/** aggregate fields of "user_tennis_rating_scales" */
export type UserTennisRatingScalesAggregateFields = {
  __typename?: 'UserTennisRatingScalesAggregateFields';
  avg?: Maybe<UserTennisRatingScalesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<UserTennisRatingScalesMaxFields>;
  min?: Maybe<UserTennisRatingScalesMinFields>;
  stddev?: Maybe<UserTennisRatingScalesStddevFields>;
  stddevPop?: Maybe<UserTennisRatingScalesStddevPopFields>;
  stddevSamp?: Maybe<UserTennisRatingScalesStddevSampFields>;
  sum?: Maybe<UserTennisRatingScalesSumFields>;
  varPop?: Maybe<UserTennisRatingScalesVarPopFields>;
  varSamp?: Maybe<UserTennisRatingScalesVarSampFields>;
  variance?: Maybe<UserTennisRatingScalesVarianceFields>;
};


/** aggregate fields of "user_tennis_rating_scales" */
export type UserTennisRatingScalesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<UserTennisRatingScalesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_tennis_rating_scales" */
export type UserTennisRatingScalesAggregateOrderBy = {
  avg?: InputMaybe<UserTennisRatingScalesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<UserTennisRatingScalesMaxOrderBy>;
  min?: InputMaybe<UserTennisRatingScalesMinOrderBy>;
  stddev?: InputMaybe<UserTennisRatingScalesStddevOrderBy>;
  stddevPop?: InputMaybe<UserTennisRatingScalesStddevPopOrderBy>;
  stddevSamp?: InputMaybe<UserTennisRatingScalesStddevSampOrderBy>;
  sum?: InputMaybe<UserTennisRatingScalesSumOrderBy>;
  varPop?: InputMaybe<UserTennisRatingScalesVarPopOrderBy>;
  varSamp?: InputMaybe<UserTennisRatingScalesVarSampOrderBy>;
  variance?: InputMaybe<UserTennisRatingScalesVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "user_tennis_rating_scales" */
export type UserTennisRatingScalesArrRelInsertInput = {
  data: Array<UserTennisRatingScalesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<UserTennisRatingScalesOnConflict>;
};

/** aggregate avg on columns */
export type UserTennisRatingScalesAvgFields = {
  __typename?: 'UserTennisRatingScalesAvgFields';
  rating?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "user_tennis_rating_scales" */
export type UserTennisRatingScalesAvgOrderBy = {
  rating?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "user_tennis_rating_scales". All fields are combined with a logical 'AND'. */
export type UserTennisRatingScalesBoolExp = {
  _and?: InputMaybe<Array<UserTennisRatingScalesBoolExp>>;
  _not?: InputMaybe<UserTennisRatingScalesBoolExp>;
  _or?: InputMaybe<Array<UserTennisRatingScalesBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  rating?: InputMaybe<NumericComparisonExp>;
  scale?: InputMaybe<TennisRatingScalesBoolExp>;
  tennisRatingScaleId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "user_tennis_rating_scales" */
export enum UserTennisRatingScalesConstraint {
  /** unique or primary key constraint on columns "id" */
  UserTennisRatingScalesPkey = 'user_tennis_rating_scales_pkey',
  /** unique or primary key constraint on columns "tennis_rating_scale_id", "user_id" */
  UserTennisRatingScalesUserIdTennisRatingScaleIdKey = 'user_tennis_rating_scales_user_id_tennis_rating_scale_id_key'
}

/** input type for incrementing numeric columns in table "user_tennis_rating_scales" */
export type UserTennisRatingScalesIncInput = {
  rating?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "user_tennis_rating_scales" */
export type UserTennisRatingScalesInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  rating?: InputMaybe<Scalars['numeric']>;
  scale?: InputMaybe<TennisRatingScalesObjRelInsertInput>;
  tennisRatingScaleId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type UserTennisRatingScalesMaxFields = {
  __typename?: 'UserTennisRatingScalesMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  rating?: Maybe<Scalars['numeric']>;
  tennisRatingScaleId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "user_tennis_rating_scales" */
export type UserTennisRatingScalesMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  rating?: InputMaybe<OrderBy>;
  tennisRatingScaleId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type UserTennisRatingScalesMinFields = {
  __typename?: 'UserTennisRatingScalesMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  rating?: Maybe<Scalars['numeric']>;
  tennisRatingScaleId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "user_tennis_rating_scales" */
export type UserTennisRatingScalesMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  rating?: InputMaybe<OrderBy>;
  tennisRatingScaleId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "user_tennis_rating_scales" */
export type UserTennisRatingScalesMutationResponse = {
  __typename?: 'UserTennisRatingScalesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UserTennisRatingScales>;
};

/** on_conflict condition type for table "user_tennis_rating_scales" */
export type UserTennisRatingScalesOnConflict = {
  constraint: UserTennisRatingScalesConstraint;
  updateColumns?: Array<UserTennisRatingScalesUpdateColumn>;
  where?: InputMaybe<UserTennisRatingScalesBoolExp>;
};

/** Ordering options when selecting data from "user_tennis_rating_scales". */
export type UserTennisRatingScalesOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  rating?: InputMaybe<OrderBy>;
  scale?: InputMaybe<TennisRatingScalesOrderBy>;
  tennisRatingScaleId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: user_tennis_rating_scales */
export type UserTennisRatingScalesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "user_tennis_rating_scales" */
export enum UserTennisRatingScalesSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  Rating = 'rating',
  /** column name */
  TennisRatingScaleId = 'tennisRatingScaleId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "user_tennis_rating_scales" */
export type UserTennisRatingScalesSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  rating?: InputMaybe<Scalars['numeric']>;
  tennisRatingScaleId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type UserTennisRatingScalesStddevFields = {
  __typename?: 'UserTennisRatingScalesStddevFields';
  rating?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "user_tennis_rating_scales" */
export type UserTennisRatingScalesStddevOrderBy = {
  rating?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type UserTennisRatingScalesStddevPopFields = {
  __typename?: 'UserTennisRatingScalesStddevPopFields';
  rating?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "user_tennis_rating_scales" */
export type UserTennisRatingScalesStddevPopOrderBy = {
  rating?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type UserTennisRatingScalesStddevSampFields = {
  __typename?: 'UserTennisRatingScalesStddevSampFields';
  rating?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "user_tennis_rating_scales" */
export type UserTennisRatingScalesStddevSampOrderBy = {
  rating?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "user_tennis_rating_scales" */
export type UserTennisRatingScalesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UserTennisRatingScalesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserTennisRatingScalesStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  rating?: InputMaybe<Scalars['numeric']>;
  tennisRatingScaleId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type UserTennisRatingScalesSumFields = {
  __typename?: 'UserTennisRatingScalesSumFields';
  rating?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "user_tennis_rating_scales" */
export type UserTennisRatingScalesSumOrderBy = {
  rating?: InputMaybe<OrderBy>;
};

/** update columns of table "user_tennis_rating_scales" */
export enum UserTennisRatingScalesUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  Rating = 'rating',
  /** column name */
  TennisRatingScaleId = 'tennisRatingScaleId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

export type UserTennisRatingScalesUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<UserTennisRatingScalesIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserTennisRatingScalesSetInput>;
  /** filter the rows which have to be updated */
  where: UserTennisRatingScalesBoolExp;
};

/** aggregate varPop on columns */
export type UserTennisRatingScalesVarPopFields = {
  __typename?: 'UserTennisRatingScalesVarPopFields';
  rating?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "user_tennis_rating_scales" */
export type UserTennisRatingScalesVarPopOrderBy = {
  rating?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type UserTennisRatingScalesVarSampFields = {
  __typename?: 'UserTennisRatingScalesVarSampFields';
  rating?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "user_tennis_rating_scales" */
export type UserTennisRatingScalesVarSampOrderBy = {
  rating?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type UserTennisRatingScalesVarianceFields = {
  __typename?: 'UserTennisRatingScalesVarianceFields';
  rating?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "user_tennis_rating_scales" */
export type UserTennisRatingScalesVarianceOrderBy = {
  rating?: InputMaybe<OrderBy>;
};

/** columns and relationships of "user_terms_of_service" */
export type UserTermsOfService = {
  __typename?: 'UserTermsOfService';
  acceptedAt: Scalars['timestamptz'];
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  ip: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  userAgent: Scalars['String'];
  userId: Scalars['uuid'];
};

/** aggregated selection of "user_terms_of_service" */
export type UserTermsOfServiceAggregate = {
  __typename?: 'UserTermsOfServiceAggregate';
  aggregate?: Maybe<UserTermsOfServiceAggregateFields>;
  nodes: Array<UserTermsOfService>;
};

export type UserTermsOfServiceAggregateBoolExp = {
  count?: InputMaybe<UserTermsOfServiceAggregateBoolExpCount>;
};

/** aggregate fields of "user_terms_of_service" */
export type UserTermsOfServiceAggregateFields = {
  __typename?: 'UserTermsOfServiceAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<UserTermsOfServiceMaxFields>;
  min?: Maybe<UserTermsOfServiceMinFields>;
};


/** aggregate fields of "user_terms_of_service" */
export type UserTermsOfServiceAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<UserTermsOfServiceSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_terms_of_service" */
export type UserTermsOfServiceAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<UserTermsOfServiceMaxOrderBy>;
  min?: InputMaybe<UserTermsOfServiceMinOrderBy>;
};

/** input type for inserting array relation for remote table "user_terms_of_service" */
export type UserTermsOfServiceArrRelInsertInput = {
  data: Array<UserTermsOfServiceInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<UserTermsOfServiceOnConflict>;
};

/** Boolean expression to filter rows from the table "user_terms_of_service". All fields are combined with a logical 'AND'. */
export type UserTermsOfServiceBoolExp = {
  _and?: InputMaybe<Array<UserTermsOfServiceBoolExp>>;
  _not?: InputMaybe<UserTermsOfServiceBoolExp>;
  _or?: InputMaybe<Array<UserTermsOfServiceBoolExp>>;
  acceptedAt?: InputMaybe<TimestamptzComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  ip?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userAgent?: InputMaybe<StringComparisonExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "user_terms_of_service" */
export enum UserTermsOfServiceConstraint {
  /** unique or primary key constraint on columns "id" */
  UserTermsOfServicePkey = 'user_terms_of_service_pkey'
}

/** input type for inserting data into table "user_terms_of_service" */
export type UserTermsOfServiceInsertInput = {
  acceptedAt?: InputMaybe<Scalars['timestamptz']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  ip?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userAgent?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type UserTermsOfServiceMaxFields = {
  __typename?: 'UserTermsOfServiceMaxFields';
  acceptedAt?: Maybe<Scalars['timestamptz']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  ip?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userAgent?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "user_terms_of_service" */
export type UserTermsOfServiceMaxOrderBy = {
  acceptedAt?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  ip?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userAgent?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type UserTermsOfServiceMinFields = {
  __typename?: 'UserTermsOfServiceMinFields';
  acceptedAt?: Maybe<Scalars['timestamptz']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  ip?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userAgent?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "user_terms_of_service" */
export type UserTermsOfServiceMinOrderBy = {
  acceptedAt?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  ip?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userAgent?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "user_terms_of_service" */
export type UserTermsOfServiceMutationResponse = {
  __typename?: 'UserTermsOfServiceMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UserTermsOfService>;
};

/** on_conflict condition type for table "user_terms_of_service" */
export type UserTermsOfServiceOnConflict = {
  constraint: UserTermsOfServiceConstraint;
  updateColumns?: Array<UserTermsOfServiceUpdateColumn>;
  where?: InputMaybe<UserTermsOfServiceBoolExp>;
};

/** Ordering options when selecting data from "user_terms_of_service". */
export type UserTermsOfServiceOrderBy = {
  acceptedAt?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  ip?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userAgent?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: user_terms_of_service */
export type UserTermsOfServicePkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "user_terms_of_service" */
export enum UserTermsOfServiceSelectColumn {
  /** column name */
  AcceptedAt = 'acceptedAt',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  Ip = 'ip',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserAgent = 'userAgent',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "user_terms_of_service" */
export type UserTermsOfServiceSetInput = {
  acceptedAt?: InputMaybe<Scalars['timestamptz']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  ip?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userAgent?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "user_terms_of_service" */
export type UserTermsOfServiceStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UserTermsOfServiceStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserTermsOfServiceStreamCursorValueInput = {
  acceptedAt?: InputMaybe<Scalars['timestamptz']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  ip?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userAgent?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "user_terms_of_service" */
export enum UserTermsOfServiceUpdateColumn {
  /** column name */
  AcceptedAt = 'acceptedAt',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  Ip = 'ip',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserAgent = 'userAgent',
  /** column name */
  UserId = 'userId'
}

export type UserTermsOfServiceUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserTermsOfServiceSetInput>;
  /** filter the rows which have to be updated */
  where: UserTermsOfServiceBoolExp;
};

/** columns and relationships of "user_vair_connections" */
export type UserVairConnections = {
  __typename?: 'UserVairConnections';
  accessToken: Scalars['String'];
  clerkId?: Maybe<Scalars['String']>;
  connectedAt: Scalars['timestamptz'];
  email: Scalars['String'];
  id: Scalars['uuid'];
  lastSyncedAt: Scalars['timestamptz'];
  memberId: Scalars['String'];
  name: Scalars['String'];
  refreshToken: Scalars['String'];
  tokenExpiry: Scalars['timestamptz'];
  userId: Scalars['uuid'];
};

/** aggregated selection of "user_vair_connections" */
export type UserVairConnectionsAggregate = {
  __typename?: 'UserVairConnectionsAggregate';
  aggregate?: Maybe<UserVairConnectionsAggregateFields>;
  nodes: Array<UserVairConnections>;
};

/** aggregate fields of "user_vair_connections" */
export type UserVairConnectionsAggregateFields = {
  __typename?: 'UserVairConnectionsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<UserVairConnectionsMaxFields>;
  min?: Maybe<UserVairConnectionsMinFields>;
};


/** aggregate fields of "user_vair_connections" */
export type UserVairConnectionsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<UserVairConnectionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "user_vair_connections". All fields are combined with a logical 'AND'. */
export type UserVairConnectionsBoolExp = {
  _and?: InputMaybe<Array<UserVairConnectionsBoolExp>>;
  _not?: InputMaybe<UserVairConnectionsBoolExp>;
  _or?: InputMaybe<Array<UserVairConnectionsBoolExp>>;
  accessToken?: InputMaybe<StringComparisonExp>;
  clerkId?: InputMaybe<StringComparisonExp>;
  connectedAt?: InputMaybe<TimestamptzComparisonExp>;
  email?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  lastSyncedAt?: InputMaybe<TimestamptzComparisonExp>;
  memberId?: InputMaybe<StringComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  refreshToken?: InputMaybe<StringComparisonExp>;
  tokenExpiry?: InputMaybe<TimestamptzComparisonExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "user_vair_connections" */
export enum UserVairConnectionsConstraint {
  /** unique or primary key constraint on columns "clerk_id" */
  UserVairConnectionsClerkIdKey = 'user_vair_connections_clerk_id_key',
  /** unique or primary key constraint on columns "member_id" */
  UserVairConnectionsMemberIdKey = 'user_vair_connections_member_id_key',
  /** unique or primary key constraint on columns "id" */
  UserVairConnectionsPkey = 'user_vair_connections_pkey',
  /** unique or primary key constraint on columns "user_id" */
  UserVairConnectionsUserIdKey = 'user_vair_connections_user_id_key'
}

/** input type for inserting data into table "user_vair_connections" */
export type UserVairConnectionsInsertInput = {
  accessToken?: InputMaybe<Scalars['String']>;
  clerkId?: InputMaybe<Scalars['String']>;
  connectedAt?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  lastSyncedAt?: InputMaybe<Scalars['timestamptz']>;
  memberId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  refreshToken?: InputMaybe<Scalars['String']>;
  tokenExpiry?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type UserVairConnectionsMaxFields = {
  __typename?: 'UserVairConnectionsMaxFields';
  accessToken?: Maybe<Scalars['String']>;
  clerkId?: Maybe<Scalars['String']>;
  connectedAt?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  lastSyncedAt?: Maybe<Scalars['timestamptz']>;
  memberId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  refreshToken?: Maybe<Scalars['String']>;
  tokenExpiry?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type UserVairConnectionsMinFields = {
  __typename?: 'UserVairConnectionsMinFields';
  accessToken?: Maybe<Scalars['String']>;
  clerkId?: Maybe<Scalars['String']>;
  connectedAt?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  lastSyncedAt?: Maybe<Scalars['timestamptz']>;
  memberId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  refreshToken?: Maybe<Scalars['String']>;
  tokenExpiry?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "user_vair_connections" */
export type UserVairConnectionsMutationResponse = {
  __typename?: 'UserVairConnectionsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UserVairConnections>;
};

/** input type for inserting object relation for remote table "user_vair_connections" */
export type UserVairConnectionsObjRelInsertInput = {
  data: UserVairConnectionsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<UserVairConnectionsOnConflict>;
};

/** on_conflict condition type for table "user_vair_connections" */
export type UserVairConnectionsOnConflict = {
  constraint: UserVairConnectionsConstraint;
  updateColumns?: Array<UserVairConnectionsUpdateColumn>;
  where?: InputMaybe<UserVairConnectionsBoolExp>;
};

/** Ordering options when selecting data from "user_vair_connections". */
export type UserVairConnectionsOrderBy = {
  accessToken?: InputMaybe<OrderBy>;
  clerkId?: InputMaybe<OrderBy>;
  connectedAt?: InputMaybe<OrderBy>;
  email?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lastSyncedAt?: InputMaybe<OrderBy>;
  memberId?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  refreshToken?: InputMaybe<OrderBy>;
  tokenExpiry?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: user_vair_connections */
export type UserVairConnectionsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "user_vair_connections" */
export enum UserVairConnectionsSelectColumn {
  /** column name */
  AccessToken = 'accessToken',
  /** column name */
  ClerkId = 'clerkId',
  /** column name */
  ConnectedAt = 'connectedAt',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  LastSyncedAt = 'lastSyncedAt',
  /** column name */
  MemberId = 'memberId',
  /** column name */
  Name = 'name',
  /** column name */
  RefreshToken = 'refreshToken',
  /** column name */
  TokenExpiry = 'tokenExpiry',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "user_vair_connections" */
export type UserVairConnectionsSetInput = {
  accessToken?: InputMaybe<Scalars['String']>;
  clerkId?: InputMaybe<Scalars['String']>;
  connectedAt?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  lastSyncedAt?: InputMaybe<Scalars['timestamptz']>;
  memberId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  refreshToken?: InputMaybe<Scalars['String']>;
  tokenExpiry?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "user_vair_connections" */
export type UserVairConnectionsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UserVairConnectionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserVairConnectionsStreamCursorValueInput = {
  accessToken?: InputMaybe<Scalars['String']>;
  clerkId?: InputMaybe<Scalars['String']>;
  connectedAt?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  lastSyncedAt?: InputMaybe<Scalars['timestamptz']>;
  memberId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  refreshToken?: InputMaybe<Scalars['String']>;
  tokenExpiry?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "user_vair_connections" */
export enum UserVairConnectionsUpdateColumn {
  /** column name */
  AccessToken = 'accessToken',
  /** column name */
  ClerkId = 'clerkId',
  /** column name */
  ConnectedAt = 'connectedAt',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  LastSyncedAt = 'lastSyncedAt',
  /** column name */
  MemberId = 'memberId',
  /** column name */
  Name = 'name',
  /** column name */
  RefreshToken = 'refreshToken',
  /** column name */
  TokenExpiry = 'tokenExpiry',
  /** column name */
  UserId = 'userId'
}

export type UserVairConnectionsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserVairConnectionsSetInput>;
  /** filter the rows which have to be updated */
  where: UserVairConnectionsBoolExp;
};

/** columns and relationships of "username_logs" */
export type UsernameLogs = {
  __typename?: 'UsernameLogs';
  /** ADD or UPDATE to determine what occurred */
  action: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  currentUsername: Scalars['String'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  previousUsername?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamptz'];
  userId?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "username_logs" */
export type UsernameLogsAggregate = {
  __typename?: 'UsernameLogsAggregate';
  aggregate?: Maybe<UsernameLogsAggregateFields>;
  nodes: Array<UsernameLogs>;
};

export type UsernameLogsAggregateBoolExp = {
  count?: InputMaybe<UsernameLogsAggregateBoolExpCount>;
};

/** aggregate fields of "username_logs" */
export type UsernameLogsAggregateFields = {
  __typename?: 'UsernameLogsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<UsernameLogsMaxFields>;
  min?: Maybe<UsernameLogsMinFields>;
};


/** aggregate fields of "username_logs" */
export type UsernameLogsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<UsernameLogsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "username_logs" */
export type UsernameLogsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<UsernameLogsMaxOrderBy>;
  min?: InputMaybe<UsernameLogsMinOrderBy>;
};

/** input type for inserting array relation for remote table "username_logs" */
export type UsernameLogsArrRelInsertInput = {
  data: Array<UsernameLogsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<UsernameLogsOnConflict>;
};

/** Boolean expression to filter rows from the table "username_logs". All fields are combined with a logical 'AND'. */
export type UsernameLogsBoolExp = {
  _and?: InputMaybe<Array<UsernameLogsBoolExp>>;
  _not?: InputMaybe<UsernameLogsBoolExp>;
  _or?: InputMaybe<Array<UsernameLogsBoolExp>>;
  action?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  currentUsername?: InputMaybe<StringComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  previousUsername?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "username_logs" */
export enum UsernameLogsConstraint {
  /** unique or primary key constraint on columns "id" */
  UsernameLogsPkey = 'username_logs_pkey'
}

/** input type for inserting data into table "username_logs" */
export type UsernameLogsInsertInput = {
  /** ADD or UPDATE to determine what occurred */
  action?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currentUsername?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  previousUsername?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type UsernameLogsMaxFields = {
  __typename?: 'UsernameLogsMaxFields';
  /** ADD or UPDATE to determine what occurred */
  action?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currentUsername?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  previousUsername?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "username_logs" */
export type UsernameLogsMaxOrderBy = {
  /** ADD or UPDATE to determine what occurred */
  action?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  currentUsername?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  previousUsername?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type UsernameLogsMinFields = {
  __typename?: 'UsernameLogsMinFields';
  /** ADD or UPDATE to determine what occurred */
  action?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currentUsername?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  previousUsername?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "username_logs" */
export type UsernameLogsMinOrderBy = {
  /** ADD or UPDATE to determine what occurred */
  action?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  currentUsername?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  previousUsername?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "username_logs" */
export type UsernameLogsMutationResponse = {
  __typename?: 'UsernameLogsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UsernameLogs>;
};

/** on_conflict condition type for table "username_logs" */
export type UsernameLogsOnConflict = {
  constraint: UsernameLogsConstraint;
  updateColumns?: Array<UsernameLogsUpdateColumn>;
  where?: InputMaybe<UsernameLogsBoolExp>;
};

/** Ordering options when selecting data from "username_logs". */
export type UsernameLogsOrderBy = {
  action?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  currentUsername?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  previousUsername?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: username_logs */
export type UsernameLogsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "username_logs" */
export enum UsernameLogsSelectColumn {
  /** column name */
  Action = 'action',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CurrentUsername = 'currentUsername',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  PreviousUsername = 'previousUsername',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "username_logs" */
export type UsernameLogsSetInput = {
  /** ADD or UPDATE to determine what occurred */
  action?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currentUsername?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  previousUsername?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "username_logs" */
export type UsernameLogsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UsernameLogsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UsernameLogsStreamCursorValueInput = {
  /** ADD or UPDATE to determine what occurred */
  action?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currentUsername?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  previousUsername?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "username_logs" */
export enum UsernameLogsUpdateColumn {
  /** column name */
  Action = 'action',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CurrentUsername = 'currentUsername',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  PreviousUsername = 'previousUsername',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

export type UsernameLogsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UsernameLogsSetInput>;
  /** filter the rows which have to be updated */
  where: UsernameLogsBoolExp;
};

/** columns and relationships of "usernames_active" */
export type UsernamesActive = {
  __typename?: 'UsernamesActive';
  username?: Maybe<Scalars['String']>;
};

/** aggregated selection of "usernames_active" */
export type UsernamesActiveAggregate = {
  __typename?: 'UsernamesActiveAggregate';
  aggregate?: Maybe<UsernamesActiveAggregateFields>;
  nodes: Array<UsernamesActive>;
};

/** aggregate fields of "usernames_active" */
export type UsernamesActiveAggregateFields = {
  __typename?: 'UsernamesActiveAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<UsernamesActiveMaxFields>;
  min?: Maybe<UsernamesActiveMinFields>;
};


/** aggregate fields of "usernames_active" */
export type UsernamesActiveAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<UsernamesActiveSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "usernames_active". All fields are combined with a logical 'AND'. */
export type UsernamesActiveBoolExp = {
  _and?: InputMaybe<Array<UsernamesActiveBoolExp>>;
  _not?: InputMaybe<UsernamesActiveBoolExp>;
  _or?: InputMaybe<Array<UsernamesActiveBoolExp>>;
  username?: InputMaybe<StringComparisonExp>;
};

/** input type for inserting data into table "usernames_active" */
export type UsernamesActiveInsertInput = {
  username?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type UsernamesActiveMaxFields = {
  __typename?: 'UsernamesActiveMaxFields';
  username?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type UsernamesActiveMinFields = {
  __typename?: 'UsernamesActiveMinFields';
  username?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "usernames_active" */
export type UsernamesActiveMutationResponse = {
  __typename?: 'UsernamesActiveMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UsernamesActive>;
};

/** Ordering options when selecting data from "usernames_active". */
export type UsernamesActiveOrderBy = {
  username?: InputMaybe<OrderBy>;
};

/** select columns of table "usernames_active" */
export enum UsernamesActiveSelectColumn {
  /** column name */
  Username = 'username'
}

/** input type for updating data in table "usernames_active" */
export type UsernamesActiveSetInput = {
  username?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "usernames_active" */
export type UsernamesActiveStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UsernamesActiveStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UsernamesActiveStreamCursorValueInput = {
  username?: InputMaybe<Scalars['String']>;
};

export type UsernamesActiveUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UsernamesActiveSetInput>;
  /** filter the rows which have to be updated */
  where: UsernamesActiveBoolExp;
};

/** This table prevents reserved words from being used or old usernames being claimed for where identity takeover can happen */
export type UsernamesClaimed = {
  __typename?: 'UsernamesClaimed';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  /** KEYWORD or USER or FORBIDDEN (more options may be needed) */
  reason: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  userId?: Maybe<Scalars['uuid']>;
  username: Scalars['String'];
};

/** aggregated selection of "usernames_claimed" */
export type UsernamesClaimedAggregate = {
  __typename?: 'UsernamesClaimedAggregate';
  aggregate?: Maybe<UsernamesClaimedAggregateFields>;
  nodes: Array<UsernamesClaimed>;
};

export type UsernamesClaimedAggregateBoolExp = {
  count?: InputMaybe<UsernamesClaimedAggregateBoolExpCount>;
};

/** aggregate fields of "usernames_claimed" */
export type UsernamesClaimedAggregateFields = {
  __typename?: 'UsernamesClaimedAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<UsernamesClaimedMaxFields>;
  min?: Maybe<UsernamesClaimedMinFields>;
};


/** aggregate fields of "usernames_claimed" */
export type UsernamesClaimedAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<UsernamesClaimedSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "usernames_claimed" */
export type UsernamesClaimedAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<UsernamesClaimedMaxOrderBy>;
  min?: InputMaybe<UsernamesClaimedMinOrderBy>;
};

/** input type for inserting array relation for remote table "usernames_claimed" */
export type UsernamesClaimedArrRelInsertInput = {
  data: Array<UsernamesClaimedInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<UsernamesClaimedOnConflict>;
};

/** Boolean expression to filter rows from the table "usernames_claimed". All fields are combined with a logical 'AND'. */
export type UsernamesClaimedBoolExp = {
  _and?: InputMaybe<Array<UsernamesClaimedBoolExp>>;
  _not?: InputMaybe<UsernamesClaimedBoolExp>;
  _or?: InputMaybe<Array<UsernamesClaimedBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  reason?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  userId?: InputMaybe<UuidComparisonExp>;
  username?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "usernames_claimed" */
export enum UsernamesClaimedConstraint {
  /** unique or primary key constraint on columns "id" */
  UsernamesClaimedPkey = 'usernames_claimed_pkey',
  /** unique or primary key constraint on columns "username" */
  UsernamesClaimedUsernameKey = 'usernames_claimed_username_key'
}

/** input type for inserting data into table "usernames_claimed" */
export type UsernamesClaimedInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** KEYWORD or USER or FORBIDDEN (more options may be needed) */
  reason?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
  username?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type UsernamesClaimedMaxFields = {
  __typename?: 'UsernamesClaimedMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  /** KEYWORD or USER or FORBIDDEN (more options may be needed) */
  reason?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
  username?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "usernames_claimed" */
export type UsernamesClaimedMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  /** KEYWORD or USER or FORBIDDEN (more options may be needed) */
  reason?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
  username?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type UsernamesClaimedMinFields = {
  __typename?: 'UsernamesClaimedMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  /** KEYWORD or USER or FORBIDDEN (more options may be needed) */
  reason?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
  username?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "usernames_claimed" */
export type UsernamesClaimedMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  /** KEYWORD or USER or FORBIDDEN (more options may be needed) */
  reason?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
  username?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "usernames_claimed" */
export type UsernamesClaimedMutationResponse = {
  __typename?: 'UsernamesClaimedMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UsernamesClaimed>;
};

/** on_conflict condition type for table "usernames_claimed" */
export type UsernamesClaimedOnConflict = {
  constraint: UsernamesClaimedConstraint;
  updateColumns?: Array<UsernamesClaimedUpdateColumn>;
  where?: InputMaybe<UsernamesClaimedBoolExp>;
};

/** Ordering options when selecting data from "usernames_claimed". */
export type UsernamesClaimedOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  reason?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
  username?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: usernames_claimed */
export type UsernamesClaimedPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "usernames_claimed" */
export enum UsernamesClaimedSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  Reason = 'reason',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId',
  /** column name */
  Username = 'username'
}

/** input type for updating data in table "usernames_claimed" */
export type UsernamesClaimedSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** KEYWORD or USER or FORBIDDEN (more options may be needed) */
  reason?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
  username?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "usernames_claimed" */
export type UsernamesClaimedStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UsernamesClaimedStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UsernamesClaimedStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** KEYWORD or USER or FORBIDDEN (more options may be needed) */
  reason?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
  username?: InputMaybe<Scalars['String']>;
};

/** update columns of table "usernames_claimed" */
export enum UsernamesClaimedUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  Reason = 'reason',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId',
  /** column name */
  Username = 'username'
}

export type UsernamesClaimedUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UsernamesClaimedSetInput>;
  /** filter the rows which have to be updated */
  where: UsernamesClaimedBoolExp;
};

/** columns and relationships of "users" */
export type Users = {
  __typename?: 'Users';
  aboutMe?: Maybe<Scalars['String']>;
  aboutMeVideoUrl: Scalars['String'];
  /** An object relationship */
  activeCity?: Maybe<Cities>;
  activeCityId?: Maybe<Scalars['uuid']>;
  adminVenueId?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  authIdentities: Array<UserAuthIdentities>;
  /** An aggregate relationship */
  authIdentitiesAggregate: UserAuthIdentitiesAggregate;
  birthday?: Maybe<Scalars['date']>;
  birthdayVisibility: BirthdayVisibilityEnum;
  cityName: Scalars['String'];
  /** An array relationship */
  coachAvailability: Array<CoachAvailability>;
  /** An aggregate relationship */
  coachAvailabilityAggregate: CoachAvailabilityAggregate;
  coachExternalBookingUrl?: Maybe<Scalars['String']>;
  /** An array relationship */
  coachFaqs: Array<CoachFaqs>;
  /** An aggregate relationship */
  coachFaqsAggregate: CoachFaqsAggregate;
  /** An array relationship */
  coachLessonAgeGroups: Array<CoachLessonAgeGroups>;
  /** An aggregate relationship */
  coachLessonAgeGroupsAggregate: CoachLessonAgeGroupsAggregate;
  coachLessonDescription?: Maybe<Scalars['String']>;
  coachLessonHowToPrepare?: Maybe<Scalars['String']>;
  /** An array relationship */
  coachLessonReflections: Array<LessonReflections>;
  /** An aggregate relationship */
  coachLessonReflectionsAggregate: LessonReflectionsAggregate;
  /** An array relationship */
  coachLessonSkillLevels: Array<CoachLessonSkillLevels>;
  /** An aggregate relationship */
  coachLessonSkillLevelsAggregate: CoachLessonSkillLevelsAggregate;
  /** An array relationship */
  coachLessons: Array<Lessons>;
  /** An aggregate relationship */
  coachLessonsAggregate: LessonsAggregate;
  /** An array relationship */
  coachQualifications: Array<UsersCoachQualifications>;
  /** An aggregate relationship */
  coachQualificationsAggregate: UsersCoachQualificationsAggregate;
  /** An array relationship */
  coachServices: Array<UserCoachServices>;
  /** An aggregate relationship */
  coachServicesAggregate: UserCoachServicesAggregate;
  /** An array relationship */
  coachSports: Array<CoachSports>;
  /** An aggregate relationship */
  coachSportsAggregate: CoachSportsAggregate;
  coachStatus?: Maybe<CoachStatusEnum>;
  coachStatusUpdatedAt?: Maybe<Scalars['timestamptz']>;
  coachingStartYear?: Maybe<Scalars['Int']>;
  /** An object relationship */
  communicationPreferences?: Maybe<UserCommunicationPreferences>;
  /** An object relationship */
  country?: Maybe<Countries>;
  countryId?: Maybe<Scalars['String']>;
  /** An object relationship */
  countrySubdivision?: Maybe<CountrySubdivisions>;
  countrySubdivisionId?: Maybe<Scalars['uuid']>;
  coverImageFileName: Scalars['String'];
  coverImagePath: Scalars['String'];
  coverImageProvider: Scalars['String'];
  coverImageProviderId: Scalars['String'];
  coverImageProviderUrl: Scalars['String'];
  /** NOTE: Keeping this field empty for now until we serve from our own custom domain */
  coverImageUrl: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  /** An array relationship */
  creditCards: Array<UserCreditCards>;
  /** An aggregate relationship */
  creditCardsAggregate: UserCreditCardsAggregate;
  currencyCoachDefault: Scalars['String'];
  /** An array relationship */
  customCourts: Array<UserCustomCourts>;
  /** An aggregate relationship */
  customCourtsAggregate: UserCustomCourtsAggregate;
  /** An object relationship */
  defaultCoachCustomCourt?: Maybe<UserCustomCourts>;
  defaultCoachPaymentFulfillmentChannel?: Maybe<PaymentFulfillmentChannelsEnum>;
  defaultCoachUserCustomCourtId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  defaultCoachVenue?: Maybe<Venues>;
  defaultCoachVenueId?: Maybe<Scalars['uuid']>;
  defaultCreditCardId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  defaultPickleballRatingScale?: Maybe<PickleballRatingScales>;
  defaultPickleballRatingScaleId?: Maybe<Scalars['uuid']>;
  defaultSport?: Maybe<SportsEnum>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  derfaultCreditCard?: Maybe<UserCreditCards>;
  didSkipStripeSetup: Scalars['Boolean'];
  duprId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  eventOrganizerAccountType: EventOrganizerAccountTypesEnum;
  facebookUrl?: Maybe<Scalars['String']>;
  firebaseId: Scalars['String'];
  /** An array relationship */
  followers: Array<UserFollows>;
  /** An aggregate relationship */
  followersAggregate: UserFollowsAggregate;
  /** An array relationship */
  following: Array<UserFollows>;
  /** An aggregate relationship */
  followingAggregate: UserFollowsAggregate;
  fullName: Scalars['String'];
  gender?: Maybe<GenderEnum>;
  genderPreference: Scalars['String'];
  geometry?: Maybe<Scalars['geography']>;
  /** An array relationship */
  groups: Array<GroupMembers>;
  /** An aggregate relationship */
  groupsAggregate: GroupMembersAggregate;
  id: Scalars['uuid'];
  instagramUrl?: Maybe<Scalars['String']>;
  invitedByUserId?: Maybe<Scalars['uuid']>;
  iptpaId?: Maybe<Scalars['String']>;
  isIptpaMember: Scalars['Boolean'];
  isMarketingRegistered?: Maybe<Scalars['Boolean']>;
  isOnboardComplete: Scalars['Boolean'];
  isPciMember: Scalars['Boolean'];
  isPendingAccountDetails?: Maybe<Scalars['Boolean']>;
  isPicklrP4Member: Scalars['Boolean'];
  isPprMember: Scalars['Boolean'];
  isProfessionalRacquetRegistryActive: Scalars['Boolean'];
  isProfessionalRacquetRegistryInvite: Scalars['Boolean'];
  isQuatroPickleballMember: Scalars['Boolean'];
  isRemoteCoachingEnabled?: Maybe<Scalars['Boolean']>;
  isSafePlayCertified?: Maybe<Scalars['Boolean']>;
  isUpdatedAfterInvite: Scalars['Boolean'];
  lastLoginAt?: Maybe<Scalars['timestamptz']>;
  lastSessionAt?: Maybe<Scalars['timestamptz']>;
  latestAuthProvider: Scalars['String'];
  latitude?: Maybe<Scalars['numeric']>;
  /** An array relationship */
  lessonTemplates: Array<LessonTemplates>;
  /** An aggregate relationship */
  lessonTemplatesAggregate: LessonTemplatesAggregate;
  linkedinUrl?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['numeric']>;
  normalizedTennisRating?: Maybe<Scalars['numeric']>;
  /** An object relationship */
  normalizedTennisRatingScale?: Maybe<TennisRatingScales>;
  normalizedTennisRatingScaleId?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  notifications: Array<UserNotifications>;
  /** An aggregate relationship */
  notificationsAggregate: UserNotificationsAggregate;
  originalAuthProvider: Scalars['String'];
  padelSkillLevelId?: Maybe<Scalars['String']>;
  /** An array relationship */
  paidInvoices: Array<Invoices>;
  /** An aggregate relationship */
  paidInvoicesAggregate: InvoicesAggregate;
  /** An array relationship */
  participantLessons: Array<LessonParticipants>;
  /** An aggregate relationship */
  participantLessonsAggregate: LessonParticipantsAggregate;
  pciId?: Maybe<Scalars['String']>;
  phoneCountryCode?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneVerifiedAt?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  pickleballRatingScales: Array<UserPickleballRatingScales>;
  /** An aggregate relationship */
  pickleballRatingScalesAggregate: UserPickleballRatingScalesAggregate;
  /** An object relationship */
  pickleballSkillLevel?: Maybe<SkillLevels>;
  pickleballSkillLevelId?: Maybe<Scalars['String']>;
  /** An array relationship */
  platformSubscriptions: Array<PlatformSubscriptions>;
  /** An aggregate relationship */
  platformSubscriptionsAggregate: PlatformSubscriptionsAggregate;
  playerFinderOnboardedAt?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  playerLessonReflections: Array<LessonReflections>;
  /** An aggregate relationship */
  playerLessonReflectionsAggregate: LessonReflectionsAggregate;
  pprId?: Maybe<Scalars['String']>;
  preferredName: Scalars['String'];
  premiumContentDescription?: Maybe<Scalars['String']>;
  priceUnitAmountCoachDefault?: Maybe<Scalars['Int']>;
  priceUnitAmountPremiumContentDefault?: Maybe<Scalars['Int']>;
  priceUnitAmountRemoteCoachDefault?: Maybe<Scalars['Int']>;
  professionalRacquetRegistryId?: Maybe<Scalars['Int']>;
  professionalRacquetRegistryLastModifiedAt?: Maybe<Scalars['timestamptz']>;
  professionalRacquetRegistryPk?: Maybe<Scalars['Int']>;
  /** An object relationship */
  profile?: Maybe<UserProfiles>;
  profileImageFileName: Scalars['String'];
  profileImagePath: Scalars['String'];
  profileImageProvider: Scalars['String'];
  profileImageProviderId: Scalars['String'];
  profileImageProviderUrl: Scalars['String'];
  /** NOTE: Keeping this field empty for now until we serve from our own custom domain */
  profileImageUrl: Scalars['String'];
  /** An array relationship */
  purchases: Array<Sales>;
  /** An aggregate relationship */
  purchasesAggregate: SalesAggregate;
  quatroPickleballMemberId?: Maybe<Scalars['String']>;
  /** An object relationship */
  registrationDetails?: Maybe<UserRegistrationDetails>;
  stripeCustomerId: Scalars['String'];
  stripeMerchantBusinessType?: Maybe<Scalars['String']>;
  stripeMerchantChargesEnabled: Scalars['Boolean'];
  stripeMerchantCountry?: Maybe<Scalars['String']>;
  stripeMerchantCurrency?: Maybe<Scalars['String']>;
  stripeMerchantCurrentlyDue?: Maybe<Scalars['jsonb']>;
  stripeMerchantDetailsSubmitted: Scalars['Boolean'];
  stripeMerchantEventuallyDue?: Maybe<Scalars['jsonb']>;
  stripeMerchantId?: Maybe<Scalars['String']>;
  stripeMerchantPastDue?: Maybe<Scalars['jsonb']>;
  stripeMerchantPayoutsEnabled: Scalars['Boolean'];
  tennisRating?: Maybe<Scalars['numeric']>;
  /** An object relationship */
  tennisRatingScale?: Maybe<TennisRatingScales>;
  tennisRatingScaleId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  tennisSkillLevel?: Maybe<SkillLevels>;
  tennisSkillLevelId?: Maybe<Scalars['String']>;
  /** An array relationship */
  termsOfService: Array<UserTermsOfService>;
  /** An aggregate relationship */
  termsOfServiceAggregate: UserTermsOfServiceAggregate;
  tiktokUrl: Scalars['String'];
  timezone?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamptz'];
  /** An array relationship */
  userFiles: Array<UserFiles>;
  /** An aggregate relationship */
  userFilesAggregate: UserFilesAggregate;
  /** An object relationship */
  userVairConnection?: Maybe<UserVairConnections>;
  username?: Maybe<Scalars['String']>;
  /** An array relationship */
  usernameLogs: Array<UsernameLogs>;
  /** An aggregate relationship */
  usernameLogsAggregate: UsernameLogsAggregate;
  /** An array relationship */
  usernamesClaimed: Array<UsernamesClaimed>;
  /** An aggregate relationship */
  usernamesClaimedAggregate: UsernamesClaimedAggregate;
  /** An array relationship */
  venueStaffRosters: Array<VenueStaffCoaches>;
  /** An aggregate relationship */
  venueStaffRostersAggregate: VenueStaffCoachesAggregate;
  /** An array relationship */
  videoAnalysisFiles: Array<VideoAnalysisFiles>;
  /** An aggregate relationship */
  videoAnalysisFilesAggregate: VideoAnalysisFilesAggregate;
  /** An array relationship */
  videoAnalysisReviewer: Array<VideoAnalysis>;
  /** An aggregate relationship */
  videoAnalysisReviewerAggregate: VideoAnalysisAggregate;
  /** An array relationship */
  videoAnalysisSubmission: Array<VideoAnalysis>;
  /** An aggregate relationship */
  videoAnalysisSubmissionAggregate: VideoAnalysisAggregate;
  websiteUrl?: Maybe<Scalars['String']>;
  xUrl?: Maybe<Scalars['String']>;
  youtubeUrl?: Maybe<Scalars['String']>;
};


/** columns and relationships of "users" */
export type UsersAuthIdentitiesArgs = {
  distinctOn?: InputMaybe<Array<UserAuthIdentitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserAuthIdentitiesOrderBy>>;
  where?: InputMaybe<UserAuthIdentitiesBoolExp>;
};


/** columns and relationships of "users" */
export type UsersAuthIdentitiesAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserAuthIdentitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserAuthIdentitiesOrderBy>>;
  where?: InputMaybe<UserAuthIdentitiesBoolExp>;
};


/** columns and relationships of "users" */
export type UsersCoachAvailabilityArgs = {
  distinctOn?: InputMaybe<Array<CoachAvailabilitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachAvailabilityOrderBy>>;
  where?: InputMaybe<CoachAvailabilityBoolExp>;
};


/** columns and relationships of "users" */
export type UsersCoachAvailabilityAggregateArgs = {
  distinctOn?: InputMaybe<Array<CoachAvailabilitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachAvailabilityOrderBy>>;
  where?: InputMaybe<CoachAvailabilityBoolExp>;
};


/** columns and relationships of "users" */
export type UsersCoachFaqsArgs = {
  distinctOn?: InputMaybe<Array<CoachFaqsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachFaqsOrderBy>>;
  where?: InputMaybe<CoachFaqsBoolExp>;
};


/** columns and relationships of "users" */
export type UsersCoachFaqsAggregateArgs = {
  distinctOn?: InputMaybe<Array<CoachFaqsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachFaqsOrderBy>>;
  where?: InputMaybe<CoachFaqsBoolExp>;
};


/** columns and relationships of "users" */
export type UsersCoachLessonAgeGroupsArgs = {
  distinctOn?: InputMaybe<Array<CoachLessonAgeGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachLessonAgeGroupsOrderBy>>;
  where?: InputMaybe<CoachLessonAgeGroupsBoolExp>;
};


/** columns and relationships of "users" */
export type UsersCoachLessonAgeGroupsAggregateArgs = {
  distinctOn?: InputMaybe<Array<CoachLessonAgeGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachLessonAgeGroupsOrderBy>>;
  where?: InputMaybe<CoachLessonAgeGroupsBoolExp>;
};


/** columns and relationships of "users" */
export type UsersCoachLessonReflectionsArgs = {
  distinctOn?: InputMaybe<Array<LessonReflectionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonReflectionsOrderBy>>;
  where?: InputMaybe<LessonReflectionsBoolExp>;
};


/** columns and relationships of "users" */
export type UsersCoachLessonReflectionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonReflectionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonReflectionsOrderBy>>;
  where?: InputMaybe<LessonReflectionsBoolExp>;
};


/** columns and relationships of "users" */
export type UsersCoachLessonSkillLevelsArgs = {
  distinctOn?: InputMaybe<Array<CoachLessonSkillLevelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachLessonSkillLevelsOrderBy>>;
  where?: InputMaybe<CoachLessonSkillLevelsBoolExp>;
};


/** columns and relationships of "users" */
export type UsersCoachLessonSkillLevelsAggregateArgs = {
  distinctOn?: InputMaybe<Array<CoachLessonSkillLevelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachLessonSkillLevelsOrderBy>>;
  where?: InputMaybe<CoachLessonSkillLevelsBoolExp>;
};


/** columns and relationships of "users" */
export type UsersCoachLessonsArgs = {
  distinctOn?: InputMaybe<Array<LessonsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonsOrderBy>>;
  where?: InputMaybe<LessonsBoolExp>;
};


/** columns and relationships of "users" */
export type UsersCoachLessonsAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonsOrderBy>>;
  where?: InputMaybe<LessonsBoolExp>;
};


/** columns and relationships of "users" */
export type UsersCoachQualificationsArgs = {
  distinctOn?: InputMaybe<Array<UsersCoachQualificationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersCoachQualificationsOrderBy>>;
  where?: InputMaybe<UsersCoachQualificationsBoolExp>;
};


/** columns and relationships of "users" */
export type UsersCoachQualificationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<UsersCoachQualificationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersCoachQualificationsOrderBy>>;
  where?: InputMaybe<UsersCoachQualificationsBoolExp>;
};


/** columns and relationships of "users" */
export type UsersCoachServicesArgs = {
  distinctOn?: InputMaybe<Array<UserCoachServicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserCoachServicesOrderBy>>;
  where?: InputMaybe<UserCoachServicesBoolExp>;
};


/** columns and relationships of "users" */
export type UsersCoachServicesAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserCoachServicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserCoachServicesOrderBy>>;
  where?: InputMaybe<UserCoachServicesBoolExp>;
};


/** columns and relationships of "users" */
export type UsersCoachSportsArgs = {
  distinctOn?: InputMaybe<Array<CoachSportsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachSportsOrderBy>>;
  where?: InputMaybe<CoachSportsBoolExp>;
};


/** columns and relationships of "users" */
export type UsersCoachSportsAggregateArgs = {
  distinctOn?: InputMaybe<Array<CoachSportsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachSportsOrderBy>>;
  where?: InputMaybe<CoachSportsBoolExp>;
};


/** columns and relationships of "users" */
export type UsersCreditCardsArgs = {
  distinctOn?: InputMaybe<Array<UserCreditCardsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserCreditCardsOrderBy>>;
  where?: InputMaybe<UserCreditCardsBoolExp>;
};


/** columns and relationships of "users" */
export type UsersCreditCardsAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserCreditCardsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserCreditCardsOrderBy>>;
  where?: InputMaybe<UserCreditCardsBoolExp>;
};


/** columns and relationships of "users" */
export type UsersCustomCourtsArgs = {
  distinctOn?: InputMaybe<Array<UserCustomCourtsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserCustomCourtsOrderBy>>;
  where?: InputMaybe<UserCustomCourtsBoolExp>;
};


/** columns and relationships of "users" */
export type UsersCustomCourtsAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserCustomCourtsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserCustomCourtsOrderBy>>;
  where?: InputMaybe<UserCustomCourtsBoolExp>;
};


/** columns and relationships of "users" */
export type UsersFollowersArgs = {
  distinctOn?: InputMaybe<Array<UserFollowsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserFollowsOrderBy>>;
  where?: InputMaybe<UserFollowsBoolExp>;
};


/** columns and relationships of "users" */
export type UsersFollowersAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserFollowsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserFollowsOrderBy>>;
  where?: InputMaybe<UserFollowsBoolExp>;
};


/** columns and relationships of "users" */
export type UsersFollowingArgs = {
  distinctOn?: InputMaybe<Array<UserFollowsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserFollowsOrderBy>>;
  where?: InputMaybe<UserFollowsBoolExp>;
};


/** columns and relationships of "users" */
export type UsersFollowingAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserFollowsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserFollowsOrderBy>>;
  where?: InputMaybe<UserFollowsBoolExp>;
};


/** columns and relationships of "users" */
export type UsersGroupsArgs = {
  distinctOn?: InputMaybe<Array<GroupMembersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupMembersOrderBy>>;
  where?: InputMaybe<GroupMembersBoolExp>;
};


/** columns and relationships of "users" */
export type UsersGroupsAggregateArgs = {
  distinctOn?: InputMaybe<Array<GroupMembersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupMembersOrderBy>>;
  where?: InputMaybe<GroupMembersBoolExp>;
};


/** columns and relationships of "users" */
export type UsersLessonTemplatesArgs = {
  distinctOn?: InputMaybe<Array<LessonTemplatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonTemplatesOrderBy>>;
  where?: InputMaybe<LessonTemplatesBoolExp>;
};


/** columns and relationships of "users" */
export type UsersLessonTemplatesAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonTemplatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonTemplatesOrderBy>>;
  where?: InputMaybe<LessonTemplatesBoolExp>;
};


/** columns and relationships of "users" */
export type UsersNotificationsArgs = {
  distinctOn?: InputMaybe<Array<UserNotificationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserNotificationsOrderBy>>;
  where?: InputMaybe<UserNotificationsBoolExp>;
};


/** columns and relationships of "users" */
export type UsersNotificationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserNotificationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserNotificationsOrderBy>>;
  where?: InputMaybe<UserNotificationsBoolExp>;
};


/** columns and relationships of "users" */
export type UsersPaidInvoicesArgs = {
  distinctOn?: InputMaybe<Array<InvoicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoicesOrderBy>>;
  where?: InputMaybe<InvoicesBoolExp>;
};


/** columns and relationships of "users" */
export type UsersPaidInvoicesAggregateArgs = {
  distinctOn?: InputMaybe<Array<InvoicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoicesOrderBy>>;
  where?: InputMaybe<InvoicesBoolExp>;
};


/** columns and relationships of "users" */
export type UsersParticipantLessonsArgs = {
  distinctOn?: InputMaybe<Array<LessonParticipantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonParticipantsOrderBy>>;
  where?: InputMaybe<LessonParticipantsBoolExp>;
};


/** columns and relationships of "users" */
export type UsersParticipantLessonsAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonParticipantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonParticipantsOrderBy>>;
  where?: InputMaybe<LessonParticipantsBoolExp>;
};


/** columns and relationships of "users" */
export type UsersPickleballRatingScalesArgs = {
  distinctOn?: InputMaybe<Array<UserPickleballRatingScalesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPickleballRatingScalesOrderBy>>;
  where?: InputMaybe<UserPickleballRatingScalesBoolExp>;
};


/** columns and relationships of "users" */
export type UsersPickleballRatingScalesAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserPickleballRatingScalesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPickleballRatingScalesOrderBy>>;
  where?: InputMaybe<UserPickleballRatingScalesBoolExp>;
};


/** columns and relationships of "users" */
export type UsersPlatformSubscriptionsArgs = {
  distinctOn?: InputMaybe<Array<PlatformSubscriptionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlatformSubscriptionsOrderBy>>;
  where?: InputMaybe<PlatformSubscriptionsBoolExp>;
};


/** columns and relationships of "users" */
export type UsersPlatformSubscriptionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PlatformSubscriptionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlatformSubscriptionsOrderBy>>;
  where?: InputMaybe<PlatformSubscriptionsBoolExp>;
};


/** columns and relationships of "users" */
export type UsersPlayerLessonReflectionsArgs = {
  distinctOn?: InputMaybe<Array<LessonReflectionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonReflectionsOrderBy>>;
  where?: InputMaybe<LessonReflectionsBoolExp>;
};


/** columns and relationships of "users" */
export type UsersPlayerLessonReflectionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonReflectionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonReflectionsOrderBy>>;
  where?: InputMaybe<LessonReflectionsBoolExp>;
};


/** columns and relationships of "users" */
export type UsersPurchasesArgs = {
  distinctOn?: InputMaybe<Array<SalesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SalesOrderBy>>;
  where?: InputMaybe<SalesBoolExp>;
};


/** columns and relationships of "users" */
export type UsersPurchasesAggregateArgs = {
  distinctOn?: InputMaybe<Array<SalesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SalesOrderBy>>;
  where?: InputMaybe<SalesBoolExp>;
};


/** columns and relationships of "users" */
export type UsersStripeMerchantCurrentlyDueArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "users" */
export type UsersStripeMerchantEventuallyDueArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "users" */
export type UsersStripeMerchantPastDueArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "users" */
export type UsersTermsOfServiceArgs = {
  distinctOn?: InputMaybe<Array<UserTermsOfServiceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserTermsOfServiceOrderBy>>;
  where?: InputMaybe<UserTermsOfServiceBoolExp>;
};


/** columns and relationships of "users" */
export type UsersTermsOfServiceAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserTermsOfServiceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserTermsOfServiceOrderBy>>;
  where?: InputMaybe<UserTermsOfServiceBoolExp>;
};


/** columns and relationships of "users" */
export type UsersUserFilesArgs = {
  distinctOn?: InputMaybe<Array<UserFilesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserFilesOrderBy>>;
  where?: InputMaybe<UserFilesBoolExp>;
};


/** columns and relationships of "users" */
export type UsersUserFilesAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserFilesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserFilesOrderBy>>;
  where?: InputMaybe<UserFilesBoolExp>;
};


/** columns and relationships of "users" */
export type UsersUsernameLogsArgs = {
  distinctOn?: InputMaybe<Array<UsernameLogsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsernameLogsOrderBy>>;
  where?: InputMaybe<UsernameLogsBoolExp>;
};


/** columns and relationships of "users" */
export type UsersUsernameLogsAggregateArgs = {
  distinctOn?: InputMaybe<Array<UsernameLogsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsernameLogsOrderBy>>;
  where?: InputMaybe<UsernameLogsBoolExp>;
};


/** columns and relationships of "users" */
export type UsersUsernamesClaimedArgs = {
  distinctOn?: InputMaybe<Array<UsernamesClaimedSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsernamesClaimedOrderBy>>;
  where?: InputMaybe<UsernamesClaimedBoolExp>;
};


/** columns and relationships of "users" */
export type UsersUsernamesClaimedAggregateArgs = {
  distinctOn?: InputMaybe<Array<UsernamesClaimedSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsernamesClaimedOrderBy>>;
  where?: InputMaybe<UsernamesClaimedBoolExp>;
};


/** columns and relationships of "users" */
export type UsersVenueStaffRostersArgs = {
  distinctOn?: InputMaybe<Array<VenueStaffCoachesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueStaffCoachesOrderBy>>;
  where?: InputMaybe<VenueStaffCoachesBoolExp>;
};


/** columns and relationships of "users" */
export type UsersVenueStaffRostersAggregateArgs = {
  distinctOn?: InputMaybe<Array<VenueStaffCoachesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueStaffCoachesOrderBy>>;
  where?: InputMaybe<VenueStaffCoachesBoolExp>;
};


/** columns and relationships of "users" */
export type UsersVideoAnalysisFilesArgs = {
  distinctOn?: InputMaybe<Array<VideoAnalysisFilesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoAnalysisFilesOrderBy>>;
  where?: InputMaybe<VideoAnalysisFilesBoolExp>;
};


/** columns and relationships of "users" */
export type UsersVideoAnalysisFilesAggregateArgs = {
  distinctOn?: InputMaybe<Array<VideoAnalysisFilesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoAnalysisFilesOrderBy>>;
  where?: InputMaybe<VideoAnalysisFilesBoolExp>;
};


/** columns and relationships of "users" */
export type UsersVideoAnalysisReviewerArgs = {
  distinctOn?: InputMaybe<Array<VideoAnalysisSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoAnalysisOrderBy>>;
  where?: InputMaybe<VideoAnalysisBoolExp>;
};


/** columns and relationships of "users" */
export type UsersVideoAnalysisReviewerAggregateArgs = {
  distinctOn?: InputMaybe<Array<VideoAnalysisSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoAnalysisOrderBy>>;
  where?: InputMaybe<VideoAnalysisBoolExp>;
};


/** columns and relationships of "users" */
export type UsersVideoAnalysisSubmissionArgs = {
  distinctOn?: InputMaybe<Array<VideoAnalysisSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoAnalysisOrderBy>>;
  where?: InputMaybe<VideoAnalysisBoolExp>;
};


/** columns and relationships of "users" */
export type UsersVideoAnalysisSubmissionAggregateArgs = {
  distinctOn?: InputMaybe<Array<VideoAnalysisSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoAnalysisOrderBy>>;
  where?: InputMaybe<VideoAnalysisBoolExp>;
};

/** aggregated selection of "users" */
export type UsersAggregate = {
  __typename?: 'UsersAggregate';
  aggregate?: Maybe<UsersAggregateFields>;
  nodes: Array<Users>;
};

export type UsersAggregateBoolExp = {
  bool_and?: InputMaybe<UsersAggregateBoolExpBool_And>;
  bool_or?: InputMaybe<UsersAggregateBoolExpBool_Or>;
  count?: InputMaybe<UsersAggregateBoolExpCount>;
};

/** aggregate fields of "users" */
export type UsersAggregateFields = {
  __typename?: 'UsersAggregateFields';
  avg?: Maybe<UsersAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<UsersMaxFields>;
  min?: Maybe<UsersMinFields>;
  stddev?: Maybe<UsersStddevFields>;
  stddevPop?: Maybe<UsersStddevPopFields>;
  stddevSamp?: Maybe<UsersStddevSampFields>;
  sum?: Maybe<UsersSumFields>;
  varPop?: Maybe<UsersVarPopFields>;
  varSamp?: Maybe<UsersVarSampFields>;
  variance?: Maybe<UsersVarianceFields>;
};


/** aggregate fields of "users" */
export type UsersAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<UsersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "users" */
export type UsersAggregateOrderBy = {
  avg?: InputMaybe<UsersAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<UsersMaxOrderBy>;
  min?: InputMaybe<UsersMinOrderBy>;
  stddev?: InputMaybe<UsersStddevOrderBy>;
  stddevPop?: InputMaybe<UsersStddevPopOrderBy>;
  stddevSamp?: InputMaybe<UsersStddevSampOrderBy>;
  sum?: InputMaybe<UsersSumOrderBy>;
  varPop?: InputMaybe<UsersVarPopOrderBy>;
  varSamp?: InputMaybe<UsersVarSampOrderBy>;
  variance?: InputMaybe<UsersVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type UsersAppendInput = {
  stripeMerchantCurrentlyDue?: InputMaybe<Scalars['jsonb']>;
  stripeMerchantEventuallyDue?: InputMaybe<Scalars['jsonb']>;
  stripeMerchantPastDue?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "users" */
export type UsersArrRelInsertInput = {
  data: Array<UsersInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<UsersOnConflict>;
};

/** aggregate avg on columns */
export type UsersAvgFields = {
  __typename?: 'UsersAvgFields';
  coachingStartYear?: Maybe<Scalars['Float']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  normalizedTennisRating?: Maybe<Scalars['Float']>;
  priceUnitAmountCoachDefault?: Maybe<Scalars['Float']>;
  priceUnitAmountPremiumContentDefault?: Maybe<Scalars['Float']>;
  priceUnitAmountRemoteCoachDefault?: Maybe<Scalars['Float']>;
  professionalRacquetRegistryId?: Maybe<Scalars['Float']>;
  professionalRacquetRegistryPk?: Maybe<Scalars['Float']>;
  tennisRating?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "users" */
export type UsersAvgOrderBy = {
  coachingStartYear?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  normalizedTennisRating?: InputMaybe<OrderBy>;
  priceUnitAmountCoachDefault?: InputMaybe<OrderBy>;
  priceUnitAmountPremiumContentDefault?: InputMaybe<OrderBy>;
  priceUnitAmountRemoteCoachDefault?: InputMaybe<OrderBy>;
  professionalRacquetRegistryId?: InputMaybe<OrderBy>;
  professionalRacquetRegistryPk?: InputMaybe<OrderBy>;
  tennisRating?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "users". All fields are combined with a logical 'AND'. */
export type UsersBoolExp = {
  _and?: InputMaybe<Array<UsersBoolExp>>;
  _not?: InputMaybe<UsersBoolExp>;
  _or?: InputMaybe<Array<UsersBoolExp>>;
  aboutMe?: InputMaybe<StringComparisonExp>;
  aboutMeVideoUrl?: InputMaybe<StringComparisonExp>;
  activeCity?: InputMaybe<CitiesBoolExp>;
  activeCityId?: InputMaybe<UuidComparisonExp>;
  adminVenueId?: InputMaybe<UuidComparisonExp>;
  authIdentities?: InputMaybe<UserAuthIdentitiesBoolExp>;
  authIdentitiesAggregate?: InputMaybe<UserAuthIdentitiesAggregateBoolExp>;
  birthday?: InputMaybe<DateComparisonExp>;
  birthdayVisibility?: InputMaybe<BirthdayVisibilityEnumComparisonExp>;
  cityName?: InputMaybe<StringComparisonExp>;
  coachAvailability?: InputMaybe<CoachAvailabilityBoolExp>;
  coachAvailabilityAggregate?: InputMaybe<CoachAvailabilityAggregateBoolExp>;
  coachExternalBookingUrl?: InputMaybe<StringComparisonExp>;
  coachFaqs?: InputMaybe<CoachFaqsBoolExp>;
  coachFaqsAggregate?: InputMaybe<CoachFaqsAggregateBoolExp>;
  coachLessonAgeGroups?: InputMaybe<CoachLessonAgeGroupsBoolExp>;
  coachLessonAgeGroupsAggregate?: InputMaybe<CoachLessonAgeGroupsAggregateBoolExp>;
  coachLessonDescription?: InputMaybe<StringComparisonExp>;
  coachLessonHowToPrepare?: InputMaybe<StringComparisonExp>;
  coachLessonReflections?: InputMaybe<LessonReflectionsBoolExp>;
  coachLessonReflectionsAggregate?: InputMaybe<LessonReflectionsAggregateBoolExp>;
  coachLessonSkillLevels?: InputMaybe<CoachLessonSkillLevelsBoolExp>;
  coachLessonSkillLevelsAggregate?: InputMaybe<CoachLessonSkillLevelsAggregateBoolExp>;
  coachLessons?: InputMaybe<LessonsBoolExp>;
  coachLessonsAggregate?: InputMaybe<LessonsAggregateBoolExp>;
  coachQualifications?: InputMaybe<UsersCoachQualificationsBoolExp>;
  coachQualificationsAggregate?: InputMaybe<UsersCoachQualificationsAggregateBoolExp>;
  coachServices?: InputMaybe<UserCoachServicesBoolExp>;
  coachServicesAggregate?: InputMaybe<UserCoachServicesAggregateBoolExp>;
  coachSports?: InputMaybe<CoachSportsBoolExp>;
  coachSportsAggregate?: InputMaybe<CoachSportsAggregateBoolExp>;
  coachStatus?: InputMaybe<CoachStatusEnumComparisonExp>;
  coachStatusUpdatedAt?: InputMaybe<TimestamptzComparisonExp>;
  coachingStartYear?: InputMaybe<IntComparisonExp>;
  communicationPreferences?: InputMaybe<UserCommunicationPreferencesBoolExp>;
  country?: InputMaybe<CountriesBoolExp>;
  countryId?: InputMaybe<StringComparisonExp>;
  countrySubdivision?: InputMaybe<CountrySubdivisionsBoolExp>;
  countrySubdivisionId?: InputMaybe<UuidComparisonExp>;
  coverImageFileName?: InputMaybe<StringComparisonExp>;
  coverImagePath?: InputMaybe<StringComparisonExp>;
  coverImageProvider?: InputMaybe<StringComparisonExp>;
  coverImageProviderId?: InputMaybe<StringComparisonExp>;
  coverImageProviderUrl?: InputMaybe<StringComparisonExp>;
  coverImageUrl?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  creditCards?: InputMaybe<UserCreditCardsBoolExp>;
  creditCardsAggregate?: InputMaybe<UserCreditCardsAggregateBoolExp>;
  currencyCoachDefault?: InputMaybe<StringComparisonExp>;
  customCourts?: InputMaybe<UserCustomCourtsBoolExp>;
  customCourtsAggregate?: InputMaybe<UserCustomCourtsAggregateBoolExp>;
  defaultCoachCustomCourt?: InputMaybe<UserCustomCourtsBoolExp>;
  defaultCoachPaymentFulfillmentChannel?: InputMaybe<PaymentFulfillmentChannelsEnumComparisonExp>;
  defaultCoachUserCustomCourtId?: InputMaybe<UuidComparisonExp>;
  defaultCoachVenue?: InputMaybe<VenuesBoolExp>;
  defaultCoachVenueId?: InputMaybe<UuidComparisonExp>;
  defaultCreditCardId?: InputMaybe<UuidComparisonExp>;
  defaultPickleballRatingScale?: InputMaybe<PickleballRatingScalesBoolExp>;
  defaultPickleballRatingScaleId?: InputMaybe<UuidComparisonExp>;
  defaultSport?: InputMaybe<SportsEnumComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  derfaultCreditCard?: InputMaybe<UserCreditCardsBoolExp>;
  didSkipStripeSetup?: InputMaybe<BooleanComparisonExp>;
  duprId?: InputMaybe<StringComparisonExp>;
  email?: InputMaybe<StringComparisonExp>;
  eventOrganizerAccountType?: InputMaybe<EventOrganizerAccountTypesEnumComparisonExp>;
  facebookUrl?: InputMaybe<StringComparisonExp>;
  firebaseId?: InputMaybe<StringComparisonExp>;
  followers?: InputMaybe<UserFollowsBoolExp>;
  followersAggregate?: InputMaybe<UserFollowsAggregateBoolExp>;
  following?: InputMaybe<UserFollowsBoolExp>;
  followingAggregate?: InputMaybe<UserFollowsAggregateBoolExp>;
  fullName?: InputMaybe<StringComparisonExp>;
  gender?: InputMaybe<GenderEnumComparisonExp>;
  genderPreference?: InputMaybe<StringComparisonExp>;
  geometry?: InputMaybe<GeographyComparisonExp>;
  groups?: InputMaybe<GroupMembersBoolExp>;
  groupsAggregate?: InputMaybe<GroupMembersAggregateBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  instagramUrl?: InputMaybe<StringComparisonExp>;
  invitedByUserId?: InputMaybe<UuidComparisonExp>;
  iptpaId?: InputMaybe<StringComparisonExp>;
  isIptpaMember?: InputMaybe<BooleanComparisonExp>;
  isMarketingRegistered?: InputMaybe<BooleanComparisonExp>;
  isOnboardComplete?: InputMaybe<BooleanComparisonExp>;
  isPciMember?: InputMaybe<BooleanComparisonExp>;
  isPendingAccountDetails?: InputMaybe<BooleanComparisonExp>;
  isPicklrP4Member?: InputMaybe<BooleanComparisonExp>;
  isPprMember?: InputMaybe<BooleanComparisonExp>;
  isProfessionalRacquetRegistryActive?: InputMaybe<BooleanComparisonExp>;
  isProfessionalRacquetRegistryInvite?: InputMaybe<BooleanComparisonExp>;
  isQuatroPickleballMember?: InputMaybe<BooleanComparisonExp>;
  isRemoteCoachingEnabled?: InputMaybe<BooleanComparisonExp>;
  isSafePlayCertified?: InputMaybe<BooleanComparisonExp>;
  isUpdatedAfterInvite?: InputMaybe<BooleanComparisonExp>;
  lastLoginAt?: InputMaybe<TimestamptzComparisonExp>;
  lastSessionAt?: InputMaybe<TimestamptzComparisonExp>;
  latestAuthProvider?: InputMaybe<StringComparisonExp>;
  latitude?: InputMaybe<NumericComparisonExp>;
  lessonTemplates?: InputMaybe<LessonTemplatesBoolExp>;
  lessonTemplatesAggregate?: InputMaybe<LessonTemplatesAggregateBoolExp>;
  linkedinUrl?: InputMaybe<StringComparisonExp>;
  locale?: InputMaybe<StringComparisonExp>;
  longitude?: InputMaybe<NumericComparisonExp>;
  normalizedTennisRating?: InputMaybe<NumericComparisonExp>;
  normalizedTennisRatingScale?: InputMaybe<TennisRatingScalesBoolExp>;
  normalizedTennisRatingScaleId?: InputMaybe<UuidComparisonExp>;
  notifications?: InputMaybe<UserNotificationsBoolExp>;
  notificationsAggregate?: InputMaybe<UserNotificationsAggregateBoolExp>;
  originalAuthProvider?: InputMaybe<StringComparisonExp>;
  padelSkillLevelId?: InputMaybe<StringComparisonExp>;
  paidInvoices?: InputMaybe<InvoicesBoolExp>;
  paidInvoicesAggregate?: InputMaybe<InvoicesAggregateBoolExp>;
  participantLessons?: InputMaybe<LessonParticipantsBoolExp>;
  participantLessonsAggregate?: InputMaybe<LessonParticipantsAggregateBoolExp>;
  pciId?: InputMaybe<StringComparisonExp>;
  phoneCountryCode?: InputMaybe<StringComparisonExp>;
  phoneNumber?: InputMaybe<StringComparisonExp>;
  phoneVerifiedAt?: InputMaybe<TimestamptzComparisonExp>;
  pickleballRatingScales?: InputMaybe<UserPickleballRatingScalesBoolExp>;
  pickleballRatingScalesAggregate?: InputMaybe<UserPickleballRatingScalesAggregateBoolExp>;
  pickleballSkillLevel?: InputMaybe<SkillLevelsBoolExp>;
  pickleballSkillLevelId?: InputMaybe<StringComparisonExp>;
  platformSubscriptions?: InputMaybe<PlatformSubscriptionsBoolExp>;
  platformSubscriptionsAggregate?: InputMaybe<PlatformSubscriptionsAggregateBoolExp>;
  playerFinderOnboardedAt?: InputMaybe<TimestamptzComparisonExp>;
  playerLessonReflections?: InputMaybe<LessonReflectionsBoolExp>;
  playerLessonReflectionsAggregate?: InputMaybe<LessonReflectionsAggregateBoolExp>;
  pprId?: InputMaybe<StringComparisonExp>;
  preferredName?: InputMaybe<StringComparisonExp>;
  premiumContentDescription?: InputMaybe<StringComparisonExp>;
  priceUnitAmountCoachDefault?: InputMaybe<IntComparisonExp>;
  priceUnitAmountPremiumContentDefault?: InputMaybe<IntComparisonExp>;
  priceUnitAmountRemoteCoachDefault?: InputMaybe<IntComparisonExp>;
  professionalRacquetRegistryId?: InputMaybe<IntComparisonExp>;
  professionalRacquetRegistryLastModifiedAt?: InputMaybe<TimestamptzComparisonExp>;
  professionalRacquetRegistryPk?: InputMaybe<IntComparisonExp>;
  profile?: InputMaybe<UserProfilesBoolExp>;
  profileImageFileName?: InputMaybe<StringComparisonExp>;
  profileImagePath?: InputMaybe<StringComparisonExp>;
  profileImageProvider?: InputMaybe<StringComparisonExp>;
  profileImageProviderId?: InputMaybe<StringComparisonExp>;
  profileImageProviderUrl?: InputMaybe<StringComparisonExp>;
  profileImageUrl?: InputMaybe<StringComparisonExp>;
  purchases?: InputMaybe<SalesBoolExp>;
  purchasesAggregate?: InputMaybe<SalesAggregateBoolExp>;
  quatroPickleballMemberId?: InputMaybe<StringComparisonExp>;
  registrationDetails?: InputMaybe<UserRegistrationDetailsBoolExp>;
  stripeCustomerId?: InputMaybe<StringComparisonExp>;
  stripeMerchantBusinessType?: InputMaybe<StringComparisonExp>;
  stripeMerchantChargesEnabled?: InputMaybe<BooleanComparisonExp>;
  stripeMerchantCountry?: InputMaybe<StringComparisonExp>;
  stripeMerchantCurrency?: InputMaybe<StringComparisonExp>;
  stripeMerchantCurrentlyDue?: InputMaybe<JsonbComparisonExp>;
  stripeMerchantDetailsSubmitted?: InputMaybe<BooleanComparisonExp>;
  stripeMerchantEventuallyDue?: InputMaybe<JsonbComparisonExp>;
  stripeMerchantId?: InputMaybe<StringComparisonExp>;
  stripeMerchantPastDue?: InputMaybe<JsonbComparisonExp>;
  stripeMerchantPayoutsEnabled?: InputMaybe<BooleanComparisonExp>;
  tennisRating?: InputMaybe<NumericComparisonExp>;
  tennisRatingScale?: InputMaybe<TennisRatingScalesBoolExp>;
  tennisRatingScaleId?: InputMaybe<UuidComparisonExp>;
  tennisSkillLevel?: InputMaybe<SkillLevelsBoolExp>;
  tennisSkillLevelId?: InputMaybe<StringComparisonExp>;
  termsOfService?: InputMaybe<UserTermsOfServiceBoolExp>;
  termsOfServiceAggregate?: InputMaybe<UserTermsOfServiceAggregateBoolExp>;
  tiktokUrl?: InputMaybe<StringComparisonExp>;
  timezone?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  userFiles?: InputMaybe<UserFilesBoolExp>;
  userFilesAggregate?: InputMaybe<UserFilesAggregateBoolExp>;
  userVairConnection?: InputMaybe<UserVairConnectionsBoolExp>;
  username?: InputMaybe<StringComparisonExp>;
  usernameLogs?: InputMaybe<UsernameLogsBoolExp>;
  usernameLogsAggregate?: InputMaybe<UsernameLogsAggregateBoolExp>;
  usernamesClaimed?: InputMaybe<UsernamesClaimedBoolExp>;
  usernamesClaimedAggregate?: InputMaybe<UsernamesClaimedAggregateBoolExp>;
  venueStaffRosters?: InputMaybe<VenueStaffCoachesBoolExp>;
  venueStaffRostersAggregate?: InputMaybe<VenueStaffCoachesAggregateBoolExp>;
  videoAnalysisFiles?: InputMaybe<VideoAnalysisFilesBoolExp>;
  videoAnalysisFilesAggregate?: InputMaybe<VideoAnalysisFilesAggregateBoolExp>;
  videoAnalysisReviewer?: InputMaybe<VideoAnalysisBoolExp>;
  videoAnalysisReviewerAggregate?: InputMaybe<VideoAnalysisAggregateBoolExp>;
  videoAnalysisSubmission?: InputMaybe<VideoAnalysisBoolExp>;
  videoAnalysisSubmissionAggregate?: InputMaybe<VideoAnalysisAggregateBoolExp>;
  websiteUrl?: InputMaybe<StringComparisonExp>;
  xUrl?: InputMaybe<StringComparisonExp>;
  youtubeUrl?: InputMaybe<StringComparisonExp>;
};

/** columns and relationships of "users_coach_qualifications" */
export type UsersCoachQualifications = {
  __typename?: 'UsersCoachQualifications';
  coachQualificationId: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  /** An object relationship */
  qualification: CoachQualifications;
  status: CoachQualificationStatusesEnum;
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid'];
};

/** aggregated selection of "users_coach_qualifications" */
export type UsersCoachQualificationsAggregate = {
  __typename?: 'UsersCoachQualificationsAggregate';
  aggregate?: Maybe<UsersCoachQualificationsAggregateFields>;
  nodes: Array<UsersCoachQualifications>;
};

export type UsersCoachQualificationsAggregateBoolExp = {
  count?: InputMaybe<UsersCoachQualificationsAggregateBoolExpCount>;
};

/** aggregate fields of "users_coach_qualifications" */
export type UsersCoachQualificationsAggregateFields = {
  __typename?: 'UsersCoachQualificationsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<UsersCoachQualificationsMaxFields>;
  min?: Maybe<UsersCoachQualificationsMinFields>;
};


/** aggregate fields of "users_coach_qualifications" */
export type UsersCoachQualificationsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<UsersCoachQualificationsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "users_coach_qualifications" */
export type UsersCoachQualificationsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<UsersCoachQualificationsMaxOrderBy>;
  min?: InputMaybe<UsersCoachQualificationsMinOrderBy>;
};

/** input type for inserting array relation for remote table "users_coach_qualifications" */
export type UsersCoachQualificationsArrRelInsertInput = {
  data: Array<UsersCoachQualificationsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<UsersCoachQualificationsOnConflict>;
};

/** Boolean expression to filter rows from the table "users_coach_qualifications". All fields are combined with a logical 'AND'. */
export type UsersCoachQualificationsBoolExp = {
  _and?: InputMaybe<Array<UsersCoachQualificationsBoolExp>>;
  _not?: InputMaybe<UsersCoachQualificationsBoolExp>;
  _or?: InputMaybe<Array<UsersCoachQualificationsBoolExp>>;
  coachQualificationId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  qualification?: InputMaybe<CoachQualificationsBoolExp>;
  status?: InputMaybe<CoachQualificationStatusesEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "users_coach_qualifications" */
export enum UsersCoachQualificationsConstraint {
  /** unique or primary key constraint on columns "id" */
  UsersCoachQualificationsPkey = 'users_coach_qualifications_pkey',
  /** unique or primary key constraint on columns "user_id", "coach_qualification_id" */
  UsersCoachQualificationsUserIdCoachQualificationIdKey = 'users_coach_qualifications_user_id_coach_qualification_id_key'
}

/** input type for inserting data into table "users_coach_qualifications" */
export type UsersCoachQualificationsInsertInput = {
  coachQualificationId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  qualification?: InputMaybe<CoachQualificationsObjRelInsertInput>;
  status?: InputMaybe<CoachQualificationStatusesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type UsersCoachQualificationsMaxFields = {
  __typename?: 'UsersCoachQualificationsMaxFields';
  coachQualificationId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "users_coach_qualifications" */
export type UsersCoachQualificationsMaxOrderBy = {
  coachQualificationId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type UsersCoachQualificationsMinFields = {
  __typename?: 'UsersCoachQualificationsMinFields';
  coachQualificationId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "users_coach_qualifications" */
export type UsersCoachQualificationsMinOrderBy = {
  coachQualificationId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "users_coach_qualifications" */
export type UsersCoachQualificationsMutationResponse = {
  __typename?: 'UsersCoachQualificationsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UsersCoachQualifications>;
};

/** on_conflict condition type for table "users_coach_qualifications" */
export type UsersCoachQualificationsOnConflict = {
  constraint: UsersCoachQualificationsConstraint;
  updateColumns?: Array<UsersCoachQualificationsUpdateColumn>;
  where?: InputMaybe<UsersCoachQualificationsBoolExp>;
};

/** Ordering options when selecting data from "users_coach_qualifications". */
export type UsersCoachQualificationsOrderBy = {
  coachQualificationId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  qualification?: InputMaybe<CoachQualificationsOrderBy>;
  status?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: users_coach_qualifications */
export type UsersCoachQualificationsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "users_coach_qualifications" */
export enum UsersCoachQualificationsSelectColumn {
  /** column name */
  CoachQualificationId = 'coachQualificationId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "users_coach_qualifications" */
export type UsersCoachQualificationsSetInput = {
  coachQualificationId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<CoachQualificationStatusesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "users_coach_qualifications" */
export type UsersCoachQualificationsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UsersCoachQualificationsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UsersCoachQualificationsStreamCursorValueInput = {
  coachQualificationId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<CoachQualificationStatusesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "users_coach_qualifications" */
export enum UsersCoachQualificationsUpdateColumn {
  /** column name */
  CoachQualificationId = 'coachQualificationId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

export type UsersCoachQualificationsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UsersCoachQualificationsSetInput>;
  /** filter the rows which have to be updated */
  where: UsersCoachQualificationsBoolExp;
};

/** unique or primary key constraints on table "users" */
export enum UsersConstraint {
  /** unique or primary key constraint on columns "admin_venue_id" */
  UsersAdminVenueIdKey = 'users_admin_venue_id_key',
  /** unique or primary key constraint on columns "email" */
  UsersEmailKey = 'users_email_key',
  /** unique or primary key constraint on columns "firebase_id" */
  UsersFirebaseIdKey = 'users_firebase_id_key',
  /** unique or primary key constraint on columns "id" */
  UsersPkey = 'users_pkey',
  /** unique or primary key constraint on columns "professional_racquet_registry_pk" */
  UsersProfessionalRacquetRegistryPkKey = 'users_professional_racquet_registry_pk_key',
  /** unique or primary key constraint on columns "stripe_customer_id" */
  UsersStripeCustomerIdKey = 'users_stripe_customer_id_key',
  /** unique or primary key constraint on columns "stripe_merchant_id" */
  UsersStripeMerchantIdKey = 'users_stripe_merchant_id_key',
  /** unique or primary key constraint on columns "username" */
  UsersUsernameKey = 'users_username_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type UsersDeleteAtPathInput = {
  stripeMerchantCurrentlyDue?: InputMaybe<Array<Scalars['String']>>;
  stripeMerchantEventuallyDue?: InputMaybe<Array<Scalars['String']>>;
  stripeMerchantPastDue?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type UsersDeleteElemInput = {
  stripeMerchantCurrentlyDue?: InputMaybe<Scalars['Int']>;
  stripeMerchantEventuallyDue?: InputMaybe<Scalars['Int']>;
  stripeMerchantPastDue?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type UsersDeleteKeyInput = {
  stripeMerchantCurrentlyDue?: InputMaybe<Scalars['String']>;
  stripeMerchantEventuallyDue?: InputMaybe<Scalars['String']>;
  stripeMerchantPastDue?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "users" */
export type UsersIncInput = {
  coachingStartYear?: InputMaybe<Scalars['Int']>;
  latitude?: InputMaybe<Scalars['numeric']>;
  longitude?: InputMaybe<Scalars['numeric']>;
  normalizedTennisRating?: InputMaybe<Scalars['numeric']>;
  priceUnitAmountCoachDefault?: InputMaybe<Scalars['Int']>;
  priceUnitAmountPremiumContentDefault?: InputMaybe<Scalars['Int']>;
  priceUnitAmountRemoteCoachDefault?: InputMaybe<Scalars['Int']>;
  professionalRacquetRegistryId?: InputMaybe<Scalars['Int']>;
  professionalRacquetRegistryPk?: InputMaybe<Scalars['Int']>;
  tennisRating?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "users" */
export type UsersInsertInput = {
  aboutMe?: InputMaybe<Scalars['String']>;
  aboutMeVideoUrl?: InputMaybe<Scalars['String']>;
  activeCity?: InputMaybe<CitiesObjRelInsertInput>;
  activeCityId?: InputMaybe<Scalars['uuid']>;
  adminVenueId?: InputMaybe<Scalars['uuid']>;
  authIdentities?: InputMaybe<UserAuthIdentitiesArrRelInsertInput>;
  birthday?: InputMaybe<Scalars['date']>;
  birthdayVisibility?: InputMaybe<BirthdayVisibilityEnum>;
  cityName?: InputMaybe<Scalars['String']>;
  coachAvailability?: InputMaybe<CoachAvailabilityArrRelInsertInput>;
  coachExternalBookingUrl?: InputMaybe<Scalars['String']>;
  coachFaqs?: InputMaybe<CoachFaqsArrRelInsertInput>;
  coachLessonAgeGroups?: InputMaybe<CoachLessonAgeGroupsArrRelInsertInput>;
  coachLessonDescription?: InputMaybe<Scalars['String']>;
  coachLessonHowToPrepare?: InputMaybe<Scalars['String']>;
  coachLessonReflections?: InputMaybe<LessonReflectionsArrRelInsertInput>;
  coachLessonSkillLevels?: InputMaybe<CoachLessonSkillLevelsArrRelInsertInput>;
  coachLessons?: InputMaybe<LessonsArrRelInsertInput>;
  coachQualifications?: InputMaybe<UsersCoachQualificationsArrRelInsertInput>;
  coachServices?: InputMaybe<UserCoachServicesArrRelInsertInput>;
  coachSports?: InputMaybe<CoachSportsArrRelInsertInput>;
  coachStatus?: InputMaybe<CoachStatusEnum>;
  coachStatusUpdatedAt?: InputMaybe<Scalars['timestamptz']>;
  coachingStartYear?: InputMaybe<Scalars['Int']>;
  communicationPreferences?: InputMaybe<UserCommunicationPreferencesObjRelInsertInput>;
  country?: InputMaybe<CountriesObjRelInsertInput>;
  countryId?: InputMaybe<Scalars['String']>;
  countrySubdivision?: InputMaybe<CountrySubdivisionsObjRelInsertInput>;
  countrySubdivisionId?: InputMaybe<Scalars['uuid']>;
  coverImageFileName?: InputMaybe<Scalars['String']>;
  coverImagePath?: InputMaybe<Scalars['String']>;
  coverImageProvider?: InputMaybe<Scalars['String']>;
  coverImageProviderId?: InputMaybe<Scalars['String']>;
  coverImageProviderUrl?: InputMaybe<Scalars['String']>;
  /** NOTE: Keeping this field empty for now until we serve from our own custom domain */
  coverImageUrl?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  creditCards?: InputMaybe<UserCreditCardsArrRelInsertInput>;
  currencyCoachDefault?: InputMaybe<Scalars['String']>;
  customCourts?: InputMaybe<UserCustomCourtsArrRelInsertInput>;
  defaultCoachCustomCourt?: InputMaybe<UserCustomCourtsObjRelInsertInput>;
  defaultCoachPaymentFulfillmentChannel?: InputMaybe<PaymentFulfillmentChannelsEnum>;
  defaultCoachUserCustomCourtId?: InputMaybe<Scalars['uuid']>;
  defaultCoachVenue?: InputMaybe<VenuesObjRelInsertInput>;
  defaultCoachVenueId?: InputMaybe<Scalars['uuid']>;
  defaultCreditCardId?: InputMaybe<Scalars['uuid']>;
  defaultPickleballRatingScale?: InputMaybe<PickleballRatingScalesObjRelInsertInput>;
  defaultPickleballRatingScaleId?: InputMaybe<Scalars['uuid']>;
  defaultSport?: InputMaybe<SportsEnum>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  derfaultCreditCard?: InputMaybe<UserCreditCardsObjRelInsertInput>;
  didSkipStripeSetup?: InputMaybe<Scalars['Boolean']>;
  duprId?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  eventOrganizerAccountType?: InputMaybe<EventOrganizerAccountTypesEnum>;
  facebookUrl?: InputMaybe<Scalars['String']>;
  firebaseId?: InputMaybe<Scalars['String']>;
  followers?: InputMaybe<UserFollowsArrRelInsertInput>;
  following?: InputMaybe<UserFollowsArrRelInsertInput>;
  fullName?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<GenderEnum>;
  genderPreference?: InputMaybe<Scalars['String']>;
  geometry?: InputMaybe<Scalars['geography']>;
  groups?: InputMaybe<GroupMembersArrRelInsertInput>;
  id?: InputMaybe<Scalars['uuid']>;
  instagramUrl?: InputMaybe<Scalars['String']>;
  invitedByUserId?: InputMaybe<Scalars['uuid']>;
  iptpaId?: InputMaybe<Scalars['String']>;
  isIptpaMember?: InputMaybe<Scalars['Boolean']>;
  isMarketingRegistered?: InputMaybe<Scalars['Boolean']>;
  isOnboardComplete?: InputMaybe<Scalars['Boolean']>;
  isPciMember?: InputMaybe<Scalars['Boolean']>;
  isPendingAccountDetails?: InputMaybe<Scalars['Boolean']>;
  isPicklrP4Member?: InputMaybe<Scalars['Boolean']>;
  isPprMember?: InputMaybe<Scalars['Boolean']>;
  isProfessionalRacquetRegistryActive?: InputMaybe<Scalars['Boolean']>;
  isProfessionalRacquetRegistryInvite?: InputMaybe<Scalars['Boolean']>;
  isQuatroPickleballMember?: InputMaybe<Scalars['Boolean']>;
  isRemoteCoachingEnabled?: InputMaybe<Scalars['Boolean']>;
  isSafePlayCertified?: InputMaybe<Scalars['Boolean']>;
  isUpdatedAfterInvite?: InputMaybe<Scalars['Boolean']>;
  lastLoginAt?: InputMaybe<Scalars['timestamptz']>;
  lastSessionAt?: InputMaybe<Scalars['timestamptz']>;
  latestAuthProvider?: InputMaybe<Scalars['String']>;
  latitude?: InputMaybe<Scalars['numeric']>;
  lessonTemplates?: InputMaybe<LessonTemplatesArrRelInsertInput>;
  linkedinUrl?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  longitude?: InputMaybe<Scalars['numeric']>;
  normalizedTennisRating?: InputMaybe<Scalars['numeric']>;
  normalizedTennisRatingScale?: InputMaybe<TennisRatingScalesObjRelInsertInput>;
  normalizedTennisRatingScaleId?: InputMaybe<Scalars['uuid']>;
  notifications?: InputMaybe<UserNotificationsArrRelInsertInput>;
  originalAuthProvider?: InputMaybe<Scalars['String']>;
  padelSkillLevelId?: InputMaybe<Scalars['String']>;
  paidInvoices?: InputMaybe<InvoicesArrRelInsertInput>;
  participantLessons?: InputMaybe<LessonParticipantsArrRelInsertInput>;
  pciId?: InputMaybe<Scalars['String']>;
  phoneCountryCode?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  phoneVerifiedAt?: InputMaybe<Scalars['timestamptz']>;
  pickleballRatingScales?: InputMaybe<UserPickleballRatingScalesArrRelInsertInput>;
  pickleballSkillLevel?: InputMaybe<SkillLevelsObjRelInsertInput>;
  pickleballSkillLevelId?: InputMaybe<Scalars['String']>;
  platformSubscriptions?: InputMaybe<PlatformSubscriptionsArrRelInsertInput>;
  playerFinderOnboardedAt?: InputMaybe<Scalars['timestamptz']>;
  playerLessonReflections?: InputMaybe<LessonReflectionsArrRelInsertInput>;
  pprId?: InputMaybe<Scalars['String']>;
  preferredName?: InputMaybe<Scalars['String']>;
  premiumContentDescription?: InputMaybe<Scalars['String']>;
  priceUnitAmountCoachDefault?: InputMaybe<Scalars['Int']>;
  priceUnitAmountPremiumContentDefault?: InputMaybe<Scalars['Int']>;
  priceUnitAmountRemoteCoachDefault?: InputMaybe<Scalars['Int']>;
  professionalRacquetRegistryId?: InputMaybe<Scalars['Int']>;
  professionalRacquetRegistryLastModifiedAt?: InputMaybe<Scalars['timestamptz']>;
  professionalRacquetRegistryPk?: InputMaybe<Scalars['Int']>;
  profile?: InputMaybe<UserProfilesObjRelInsertInput>;
  profileImageFileName?: InputMaybe<Scalars['String']>;
  profileImagePath?: InputMaybe<Scalars['String']>;
  profileImageProvider?: InputMaybe<Scalars['String']>;
  profileImageProviderId?: InputMaybe<Scalars['String']>;
  profileImageProviderUrl?: InputMaybe<Scalars['String']>;
  /** NOTE: Keeping this field empty for now until we serve from our own custom domain */
  profileImageUrl?: InputMaybe<Scalars['String']>;
  purchases?: InputMaybe<SalesArrRelInsertInput>;
  quatroPickleballMemberId?: InputMaybe<Scalars['String']>;
  registrationDetails?: InputMaybe<UserRegistrationDetailsObjRelInsertInput>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  stripeMerchantBusinessType?: InputMaybe<Scalars['String']>;
  stripeMerchantChargesEnabled?: InputMaybe<Scalars['Boolean']>;
  stripeMerchantCountry?: InputMaybe<Scalars['String']>;
  stripeMerchantCurrency?: InputMaybe<Scalars['String']>;
  stripeMerchantCurrentlyDue?: InputMaybe<Scalars['jsonb']>;
  stripeMerchantDetailsSubmitted?: InputMaybe<Scalars['Boolean']>;
  stripeMerchantEventuallyDue?: InputMaybe<Scalars['jsonb']>;
  stripeMerchantId?: InputMaybe<Scalars['String']>;
  stripeMerchantPastDue?: InputMaybe<Scalars['jsonb']>;
  stripeMerchantPayoutsEnabled?: InputMaybe<Scalars['Boolean']>;
  tennisRating?: InputMaybe<Scalars['numeric']>;
  tennisRatingScale?: InputMaybe<TennisRatingScalesObjRelInsertInput>;
  tennisRatingScaleId?: InputMaybe<Scalars['uuid']>;
  tennisSkillLevel?: InputMaybe<SkillLevelsObjRelInsertInput>;
  tennisSkillLevelId?: InputMaybe<Scalars['String']>;
  termsOfService?: InputMaybe<UserTermsOfServiceArrRelInsertInput>;
  tiktokUrl?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userFiles?: InputMaybe<UserFilesArrRelInsertInput>;
  userVairConnection?: InputMaybe<UserVairConnectionsObjRelInsertInput>;
  username?: InputMaybe<Scalars['String']>;
  usernameLogs?: InputMaybe<UsernameLogsArrRelInsertInput>;
  usernamesClaimed?: InputMaybe<UsernamesClaimedArrRelInsertInput>;
  venueStaffRosters?: InputMaybe<VenueStaffCoachesArrRelInsertInput>;
  videoAnalysisFiles?: InputMaybe<VideoAnalysisFilesArrRelInsertInput>;
  videoAnalysisReviewer?: InputMaybe<VideoAnalysisArrRelInsertInput>;
  videoAnalysisSubmission?: InputMaybe<VideoAnalysisArrRelInsertInput>;
  websiteUrl?: InputMaybe<Scalars['String']>;
  xUrl?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type UsersMaxFields = {
  __typename?: 'UsersMaxFields';
  aboutMe?: Maybe<Scalars['String']>;
  aboutMeVideoUrl?: Maybe<Scalars['String']>;
  activeCityId?: Maybe<Scalars['uuid']>;
  adminVenueId?: Maybe<Scalars['uuid']>;
  birthday?: Maybe<Scalars['date']>;
  cityName?: Maybe<Scalars['String']>;
  coachExternalBookingUrl?: Maybe<Scalars['String']>;
  coachLessonDescription?: Maybe<Scalars['String']>;
  coachLessonHowToPrepare?: Maybe<Scalars['String']>;
  coachStatusUpdatedAt?: Maybe<Scalars['timestamptz']>;
  coachingStartYear?: Maybe<Scalars['Int']>;
  countryId?: Maybe<Scalars['String']>;
  countrySubdivisionId?: Maybe<Scalars['uuid']>;
  coverImageFileName?: Maybe<Scalars['String']>;
  coverImagePath?: Maybe<Scalars['String']>;
  coverImageProvider?: Maybe<Scalars['String']>;
  coverImageProviderId?: Maybe<Scalars['String']>;
  coverImageProviderUrl?: Maybe<Scalars['String']>;
  /** NOTE: Keeping this field empty for now until we serve from our own custom domain */
  coverImageUrl?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currencyCoachDefault?: Maybe<Scalars['String']>;
  defaultCoachUserCustomCourtId?: Maybe<Scalars['uuid']>;
  defaultCoachVenueId?: Maybe<Scalars['uuid']>;
  defaultCreditCardId?: Maybe<Scalars['uuid']>;
  defaultPickleballRatingScaleId?: Maybe<Scalars['uuid']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  duprId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  facebookUrl?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  genderPreference?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  instagramUrl?: Maybe<Scalars['String']>;
  invitedByUserId?: Maybe<Scalars['uuid']>;
  iptpaId?: Maybe<Scalars['String']>;
  lastLoginAt?: Maybe<Scalars['timestamptz']>;
  lastSessionAt?: Maybe<Scalars['timestamptz']>;
  latestAuthProvider?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['numeric']>;
  linkedinUrl?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['numeric']>;
  normalizedTennisRating?: Maybe<Scalars['numeric']>;
  normalizedTennisRatingScaleId?: Maybe<Scalars['uuid']>;
  originalAuthProvider?: Maybe<Scalars['String']>;
  padelSkillLevelId?: Maybe<Scalars['String']>;
  pciId?: Maybe<Scalars['String']>;
  phoneCountryCode?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneVerifiedAt?: Maybe<Scalars['timestamptz']>;
  pickleballSkillLevelId?: Maybe<Scalars['String']>;
  playerFinderOnboardedAt?: Maybe<Scalars['timestamptz']>;
  pprId?: Maybe<Scalars['String']>;
  preferredName?: Maybe<Scalars['String']>;
  premiumContentDescription?: Maybe<Scalars['String']>;
  priceUnitAmountCoachDefault?: Maybe<Scalars['Int']>;
  priceUnitAmountPremiumContentDefault?: Maybe<Scalars['Int']>;
  priceUnitAmountRemoteCoachDefault?: Maybe<Scalars['Int']>;
  professionalRacquetRegistryId?: Maybe<Scalars['Int']>;
  professionalRacquetRegistryLastModifiedAt?: Maybe<Scalars['timestamptz']>;
  professionalRacquetRegistryPk?: Maybe<Scalars['Int']>;
  profileImageFileName?: Maybe<Scalars['String']>;
  profileImagePath?: Maybe<Scalars['String']>;
  profileImageProvider?: Maybe<Scalars['String']>;
  profileImageProviderId?: Maybe<Scalars['String']>;
  profileImageProviderUrl?: Maybe<Scalars['String']>;
  /** NOTE: Keeping this field empty for now until we serve from our own custom domain */
  profileImageUrl?: Maybe<Scalars['String']>;
  quatroPickleballMemberId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripeMerchantBusinessType?: Maybe<Scalars['String']>;
  stripeMerchantCountry?: Maybe<Scalars['String']>;
  stripeMerchantCurrency?: Maybe<Scalars['String']>;
  stripeMerchantId?: Maybe<Scalars['String']>;
  tennisRating?: Maybe<Scalars['numeric']>;
  tennisRatingScaleId?: Maybe<Scalars['uuid']>;
  tennisSkillLevelId?: Maybe<Scalars['String']>;
  tiktokUrl?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  username?: Maybe<Scalars['String']>;
  websiteUrl?: Maybe<Scalars['String']>;
  xUrl?: Maybe<Scalars['String']>;
  youtubeUrl?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "users" */
export type UsersMaxOrderBy = {
  aboutMe?: InputMaybe<OrderBy>;
  aboutMeVideoUrl?: InputMaybe<OrderBy>;
  activeCityId?: InputMaybe<OrderBy>;
  adminVenueId?: InputMaybe<OrderBy>;
  birthday?: InputMaybe<OrderBy>;
  cityName?: InputMaybe<OrderBy>;
  coachExternalBookingUrl?: InputMaybe<OrderBy>;
  coachLessonDescription?: InputMaybe<OrderBy>;
  coachLessonHowToPrepare?: InputMaybe<OrderBy>;
  coachStatusUpdatedAt?: InputMaybe<OrderBy>;
  coachingStartYear?: InputMaybe<OrderBy>;
  countryId?: InputMaybe<OrderBy>;
  countrySubdivisionId?: InputMaybe<OrderBy>;
  coverImageFileName?: InputMaybe<OrderBy>;
  coverImagePath?: InputMaybe<OrderBy>;
  coverImageProvider?: InputMaybe<OrderBy>;
  coverImageProviderId?: InputMaybe<OrderBy>;
  coverImageProviderUrl?: InputMaybe<OrderBy>;
  /** NOTE: Keeping this field empty for now until we serve from our own custom domain */
  coverImageUrl?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  currencyCoachDefault?: InputMaybe<OrderBy>;
  defaultCoachUserCustomCourtId?: InputMaybe<OrderBy>;
  defaultCoachVenueId?: InputMaybe<OrderBy>;
  defaultCreditCardId?: InputMaybe<OrderBy>;
  defaultPickleballRatingScaleId?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  duprId?: InputMaybe<OrderBy>;
  email?: InputMaybe<OrderBy>;
  facebookUrl?: InputMaybe<OrderBy>;
  firebaseId?: InputMaybe<OrderBy>;
  fullName?: InputMaybe<OrderBy>;
  genderPreference?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  instagramUrl?: InputMaybe<OrderBy>;
  invitedByUserId?: InputMaybe<OrderBy>;
  iptpaId?: InputMaybe<OrderBy>;
  lastLoginAt?: InputMaybe<OrderBy>;
  lastSessionAt?: InputMaybe<OrderBy>;
  latestAuthProvider?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  linkedinUrl?: InputMaybe<OrderBy>;
  locale?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  normalizedTennisRating?: InputMaybe<OrderBy>;
  normalizedTennisRatingScaleId?: InputMaybe<OrderBy>;
  originalAuthProvider?: InputMaybe<OrderBy>;
  padelSkillLevelId?: InputMaybe<OrderBy>;
  pciId?: InputMaybe<OrderBy>;
  phoneCountryCode?: InputMaybe<OrderBy>;
  phoneNumber?: InputMaybe<OrderBy>;
  phoneVerifiedAt?: InputMaybe<OrderBy>;
  pickleballSkillLevelId?: InputMaybe<OrderBy>;
  playerFinderOnboardedAt?: InputMaybe<OrderBy>;
  pprId?: InputMaybe<OrderBy>;
  preferredName?: InputMaybe<OrderBy>;
  premiumContentDescription?: InputMaybe<OrderBy>;
  priceUnitAmountCoachDefault?: InputMaybe<OrderBy>;
  priceUnitAmountPremiumContentDefault?: InputMaybe<OrderBy>;
  priceUnitAmountRemoteCoachDefault?: InputMaybe<OrderBy>;
  professionalRacquetRegistryId?: InputMaybe<OrderBy>;
  professionalRacquetRegistryLastModifiedAt?: InputMaybe<OrderBy>;
  professionalRacquetRegistryPk?: InputMaybe<OrderBy>;
  profileImageFileName?: InputMaybe<OrderBy>;
  profileImagePath?: InputMaybe<OrderBy>;
  profileImageProvider?: InputMaybe<OrderBy>;
  profileImageProviderId?: InputMaybe<OrderBy>;
  profileImageProviderUrl?: InputMaybe<OrderBy>;
  /** NOTE: Keeping this field empty for now until we serve from our own custom domain */
  profileImageUrl?: InputMaybe<OrderBy>;
  quatroPickleballMemberId?: InputMaybe<OrderBy>;
  stripeCustomerId?: InputMaybe<OrderBy>;
  stripeMerchantBusinessType?: InputMaybe<OrderBy>;
  stripeMerchantCountry?: InputMaybe<OrderBy>;
  stripeMerchantCurrency?: InputMaybe<OrderBy>;
  stripeMerchantId?: InputMaybe<OrderBy>;
  tennisRating?: InputMaybe<OrderBy>;
  tennisRatingScaleId?: InputMaybe<OrderBy>;
  tennisSkillLevelId?: InputMaybe<OrderBy>;
  tiktokUrl?: InputMaybe<OrderBy>;
  timezone?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  username?: InputMaybe<OrderBy>;
  websiteUrl?: InputMaybe<OrderBy>;
  xUrl?: InputMaybe<OrderBy>;
  youtubeUrl?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type UsersMinFields = {
  __typename?: 'UsersMinFields';
  aboutMe?: Maybe<Scalars['String']>;
  aboutMeVideoUrl?: Maybe<Scalars['String']>;
  activeCityId?: Maybe<Scalars['uuid']>;
  adminVenueId?: Maybe<Scalars['uuid']>;
  birthday?: Maybe<Scalars['date']>;
  cityName?: Maybe<Scalars['String']>;
  coachExternalBookingUrl?: Maybe<Scalars['String']>;
  coachLessonDescription?: Maybe<Scalars['String']>;
  coachLessonHowToPrepare?: Maybe<Scalars['String']>;
  coachStatusUpdatedAt?: Maybe<Scalars['timestamptz']>;
  coachingStartYear?: Maybe<Scalars['Int']>;
  countryId?: Maybe<Scalars['String']>;
  countrySubdivisionId?: Maybe<Scalars['uuid']>;
  coverImageFileName?: Maybe<Scalars['String']>;
  coverImagePath?: Maybe<Scalars['String']>;
  coverImageProvider?: Maybe<Scalars['String']>;
  coverImageProviderId?: Maybe<Scalars['String']>;
  coverImageProviderUrl?: Maybe<Scalars['String']>;
  /** NOTE: Keeping this field empty for now until we serve from our own custom domain */
  coverImageUrl?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currencyCoachDefault?: Maybe<Scalars['String']>;
  defaultCoachUserCustomCourtId?: Maybe<Scalars['uuid']>;
  defaultCoachVenueId?: Maybe<Scalars['uuid']>;
  defaultCreditCardId?: Maybe<Scalars['uuid']>;
  defaultPickleballRatingScaleId?: Maybe<Scalars['uuid']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  duprId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  facebookUrl?: Maybe<Scalars['String']>;
  firebaseId?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  genderPreference?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  instagramUrl?: Maybe<Scalars['String']>;
  invitedByUserId?: Maybe<Scalars['uuid']>;
  iptpaId?: Maybe<Scalars['String']>;
  lastLoginAt?: Maybe<Scalars['timestamptz']>;
  lastSessionAt?: Maybe<Scalars['timestamptz']>;
  latestAuthProvider?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['numeric']>;
  linkedinUrl?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['numeric']>;
  normalizedTennisRating?: Maybe<Scalars['numeric']>;
  normalizedTennisRatingScaleId?: Maybe<Scalars['uuid']>;
  originalAuthProvider?: Maybe<Scalars['String']>;
  padelSkillLevelId?: Maybe<Scalars['String']>;
  pciId?: Maybe<Scalars['String']>;
  phoneCountryCode?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneVerifiedAt?: Maybe<Scalars['timestamptz']>;
  pickleballSkillLevelId?: Maybe<Scalars['String']>;
  playerFinderOnboardedAt?: Maybe<Scalars['timestamptz']>;
  pprId?: Maybe<Scalars['String']>;
  preferredName?: Maybe<Scalars['String']>;
  premiumContentDescription?: Maybe<Scalars['String']>;
  priceUnitAmountCoachDefault?: Maybe<Scalars['Int']>;
  priceUnitAmountPremiumContentDefault?: Maybe<Scalars['Int']>;
  priceUnitAmountRemoteCoachDefault?: Maybe<Scalars['Int']>;
  professionalRacquetRegistryId?: Maybe<Scalars['Int']>;
  professionalRacquetRegistryLastModifiedAt?: Maybe<Scalars['timestamptz']>;
  professionalRacquetRegistryPk?: Maybe<Scalars['Int']>;
  profileImageFileName?: Maybe<Scalars['String']>;
  profileImagePath?: Maybe<Scalars['String']>;
  profileImageProvider?: Maybe<Scalars['String']>;
  profileImageProviderId?: Maybe<Scalars['String']>;
  profileImageProviderUrl?: Maybe<Scalars['String']>;
  /** NOTE: Keeping this field empty for now until we serve from our own custom domain */
  profileImageUrl?: Maybe<Scalars['String']>;
  quatroPickleballMemberId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripeMerchantBusinessType?: Maybe<Scalars['String']>;
  stripeMerchantCountry?: Maybe<Scalars['String']>;
  stripeMerchantCurrency?: Maybe<Scalars['String']>;
  stripeMerchantId?: Maybe<Scalars['String']>;
  tennisRating?: Maybe<Scalars['numeric']>;
  tennisRatingScaleId?: Maybe<Scalars['uuid']>;
  tennisSkillLevelId?: Maybe<Scalars['String']>;
  tiktokUrl?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  username?: Maybe<Scalars['String']>;
  websiteUrl?: Maybe<Scalars['String']>;
  xUrl?: Maybe<Scalars['String']>;
  youtubeUrl?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "users" */
export type UsersMinOrderBy = {
  aboutMe?: InputMaybe<OrderBy>;
  aboutMeVideoUrl?: InputMaybe<OrderBy>;
  activeCityId?: InputMaybe<OrderBy>;
  adminVenueId?: InputMaybe<OrderBy>;
  birthday?: InputMaybe<OrderBy>;
  cityName?: InputMaybe<OrderBy>;
  coachExternalBookingUrl?: InputMaybe<OrderBy>;
  coachLessonDescription?: InputMaybe<OrderBy>;
  coachLessonHowToPrepare?: InputMaybe<OrderBy>;
  coachStatusUpdatedAt?: InputMaybe<OrderBy>;
  coachingStartYear?: InputMaybe<OrderBy>;
  countryId?: InputMaybe<OrderBy>;
  countrySubdivisionId?: InputMaybe<OrderBy>;
  coverImageFileName?: InputMaybe<OrderBy>;
  coverImagePath?: InputMaybe<OrderBy>;
  coverImageProvider?: InputMaybe<OrderBy>;
  coverImageProviderId?: InputMaybe<OrderBy>;
  coverImageProviderUrl?: InputMaybe<OrderBy>;
  /** NOTE: Keeping this field empty for now until we serve from our own custom domain */
  coverImageUrl?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  currencyCoachDefault?: InputMaybe<OrderBy>;
  defaultCoachUserCustomCourtId?: InputMaybe<OrderBy>;
  defaultCoachVenueId?: InputMaybe<OrderBy>;
  defaultCreditCardId?: InputMaybe<OrderBy>;
  defaultPickleballRatingScaleId?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  duprId?: InputMaybe<OrderBy>;
  email?: InputMaybe<OrderBy>;
  facebookUrl?: InputMaybe<OrderBy>;
  firebaseId?: InputMaybe<OrderBy>;
  fullName?: InputMaybe<OrderBy>;
  genderPreference?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  instagramUrl?: InputMaybe<OrderBy>;
  invitedByUserId?: InputMaybe<OrderBy>;
  iptpaId?: InputMaybe<OrderBy>;
  lastLoginAt?: InputMaybe<OrderBy>;
  lastSessionAt?: InputMaybe<OrderBy>;
  latestAuthProvider?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  linkedinUrl?: InputMaybe<OrderBy>;
  locale?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  normalizedTennisRating?: InputMaybe<OrderBy>;
  normalizedTennisRatingScaleId?: InputMaybe<OrderBy>;
  originalAuthProvider?: InputMaybe<OrderBy>;
  padelSkillLevelId?: InputMaybe<OrderBy>;
  pciId?: InputMaybe<OrderBy>;
  phoneCountryCode?: InputMaybe<OrderBy>;
  phoneNumber?: InputMaybe<OrderBy>;
  phoneVerifiedAt?: InputMaybe<OrderBy>;
  pickleballSkillLevelId?: InputMaybe<OrderBy>;
  playerFinderOnboardedAt?: InputMaybe<OrderBy>;
  pprId?: InputMaybe<OrderBy>;
  preferredName?: InputMaybe<OrderBy>;
  premiumContentDescription?: InputMaybe<OrderBy>;
  priceUnitAmountCoachDefault?: InputMaybe<OrderBy>;
  priceUnitAmountPremiumContentDefault?: InputMaybe<OrderBy>;
  priceUnitAmountRemoteCoachDefault?: InputMaybe<OrderBy>;
  professionalRacquetRegistryId?: InputMaybe<OrderBy>;
  professionalRacquetRegistryLastModifiedAt?: InputMaybe<OrderBy>;
  professionalRacquetRegistryPk?: InputMaybe<OrderBy>;
  profileImageFileName?: InputMaybe<OrderBy>;
  profileImagePath?: InputMaybe<OrderBy>;
  profileImageProvider?: InputMaybe<OrderBy>;
  profileImageProviderId?: InputMaybe<OrderBy>;
  profileImageProviderUrl?: InputMaybe<OrderBy>;
  /** NOTE: Keeping this field empty for now until we serve from our own custom domain */
  profileImageUrl?: InputMaybe<OrderBy>;
  quatroPickleballMemberId?: InputMaybe<OrderBy>;
  stripeCustomerId?: InputMaybe<OrderBy>;
  stripeMerchantBusinessType?: InputMaybe<OrderBy>;
  stripeMerchantCountry?: InputMaybe<OrderBy>;
  stripeMerchantCurrency?: InputMaybe<OrderBy>;
  stripeMerchantId?: InputMaybe<OrderBy>;
  tennisRating?: InputMaybe<OrderBy>;
  tennisRatingScaleId?: InputMaybe<OrderBy>;
  tennisSkillLevelId?: InputMaybe<OrderBy>;
  tiktokUrl?: InputMaybe<OrderBy>;
  timezone?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  username?: InputMaybe<OrderBy>;
  websiteUrl?: InputMaybe<OrderBy>;
  xUrl?: InputMaybe<OrderBy>;
  youtubeUrl?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "users" */
export type UsersMutationResponse = {
  __typename?: 'UsersMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Users>;
};

/** input type for inserting object relation for remote table "users" */
export type UsersObjRelInsertInput = {
  data: UsersInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<UsersOnConflict>;
};

/** on_conflict condition type for table "users" */
export type UsersOnConflict = {
  constraint: UsersConstraint;
  updateColumns?: Array<UsersUpdateColumn>;
  where?: InputMaybe<UsersBoolExp>;
};

/** Ordering options when selecting data from "users". */
export type UsersOrderBy = {
  aboutMe?: InputMaybe<OrderBy>;
  aboutMeVideoUrl?: InputMaybe<OrderBy>;
  activeCity?: InputMaybe<CitiesOrderBy>;
  activeCityId?: InputMaybe<OrderBy>;
  adminVenueId?: InputMaybe<OrderBy>;
  authIdentitiesAggregate?: InputMaybe<UserAuthIdentitiesAggregateOrderBy>;
  birthday?: InputMaybe<OrderBy>;
  birthdayVisibility?: InputMaybe<OrderBy>;
  cityName?: InputMaybe<OrderBy>;
  coachAvailabilityAggregate?: InputMaybe<CoachAvailabilityAggregateOrderBy>;
  coachExternalBookingUrl?: InputMaybe<OrderBy>;
  coachFaqsAggregate?: InputMaybe<CoachFaqsAggregateOrderBy>;
  coachLessonAgeGroupsAggregate?: InputMaybe<CoachLessonAgeGroupsAggregateOrderBy>;
  coachLessonDescription?: InputMaybe<OrderBy>;
  coachLessonHowToPrepare?: InputMaybe<OrderBy>;
  coachLessonReflectionsAggregate?: InputMaybe<LessonReflectionsAggregateOrderBy>;
  coachLessonSkillLevelsAggregate?: InputMaybe<CoachLessonSkillLevelsAggregateOrderBy>;
  coachLessonsAggregate?: InputMaybe<LessonsAggregateOrderBy>;
  coachQualificationsAggregate?: InputMaybe<UsersCoachQualificationsAggregateOrderBy>;
  coachServicesAggregate?: InputMaybe<UserCoachServicesAggregateOrderBy>;
  coachSportsAggregate?: InputMaybe<CoachSportsAggregateOrderBy>;
  coachStatus?: InputMaybe<OrderBy>;
  coachStatusUpdatedAt?: InputMaybe<OrderBy>;
  coachingStartYear?: InputMaybe<OrderBy>;
  communicationPreferences?: InputMaybe<UserCommunicationPreferencesOrderBy>;
  country?: InputMaybe<CountriesOrderBy>;
  countryId?: InputMaybe<OrderBy>;
  countrySubdivision?: InputMaybe<CountrySubdivisionsOrderBy>;
  countrySubdivisionId?: InputMaybe<OrderBy>;
  coverImageFileName?: InputMaybe<OrderBy>;
  coverImagePath?: InputMaybe<OrderBy>;
  coverImageProvider?: InputMaybe<OrderBy>;
  coverImageProviderId?: InputMaybe<OrderBy>;
  coverImageProviderUrl?: InputMaybe<OrderBy>;
  coverImageUrl?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  creditCardsAggregate?: InputMaybe<UserCreditCardsAggregateOrderBy>;
  currencyCoachDefault?: InputMaybe<OrderBy>;
  customCourtsAggregate?: InputMaybe<UserCustomCourtsAggregateOrderBy>;
  defaultCoachCustomCourt?: InputMaybe<UserCustomCourtsOrderBy>;
  defaultCoachPaymentFulfillmentChannel?: InputMaybe<OrderBy>;
  defaultCoachUserCustomCourtId?: InputMaybe<OrderBy>;
  defaultCoachVenue?: InputMaybe<VenuesOrderBy>;
  defaultCoachVenueId?: InputMaybe<OrderBy>;
  defaultCreditCardId?: InputMaybe<OrderBy>;
  defaultPickleballRatingScale?: InputMaybe<PickleballRatingScalesOrderBy>;
  defaultPickleballRatingScaleId?: InputMaybe<OrderBy>;
  defaultSport?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  derfaultCreditCard?: InputMaybe<UserCreditCardsOrderBy>;
  didSkipStripeSetup?: InputMaybe<OrderBy>;
  duprId?: InputMaybe<OrderBy>;
  email?: InputMaybe<OrderBy>;
  eventOrganizerAccountType?: InputMaybe<OrderBy>;
  facebookUrl?: InputMaybe<OrderBy>;
  firebaseId?: InputMaybe<OrderBy>;
  followersAggregate?: InputMaybe<UserFollowsAggregateOrderBy>;
  followingAggregate?: InputMaybe<UserFollowsAggregateOrderBy>;
  fullName?: InputMaybe<OrderBy>;
  gender?: InputMaybe<OrderBy>;
  genderPreference?: InputMaybe<OrderBy>;
  geometry?: InputMaybe<OrderBy>;
  groupsAggregate?: InputMaybe<GroupMembersAggregateOrderBy>;
  id?: InputMaybe<OrderBy>;
  instagramUrl?: InputMaybe<OrderBy>;
  invitedByUserId?: InputMaybe<OrderBy>;
  iptpaId?: InputMaybe<OrderBy>;
  isIptpaMember?: InputMaybe<OrderBy>;
  isMarketingRegistered?: InputMaybe<OrderBy>;
  isOnboardComplete?: InputMaybe<OrderBy>;
  isPciMember?: InputMaybe<OrderBy>;
  isPendingAccountDetails?: InputMaybe<OrderBy>;
  isPicklrP4Member?: InputMaybe<OrderBy>;
  isPprMember?: InputMaybe<OrderBy>;
  isProfessionalRacquetRegistryActive?: InputMaybe<OrderBy>;
  isProfessionalRacquetRegistryInvite?: InputMaybe<OrderBy>;
  isQuatroPickleballMember?: InputMaybe<OrderBy>;
  isRemoteCoachingEnabled?: InputMaybe<OrderBy>;
  isSafePlayCertified?: InputMaybe<OrderBy>;
  isUpdatedAfterInvite?: InputMaybe<OrderBy>;
  lastLoginAt?: InputMaybe<OrderBy>;
  lastSessionAt?: InputMaybe<OrderBy>;
  latestAuthProvider?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  lessonTemplatesAggregate?: InputMaybe<LessonTemplatesAggregateOrderBy>;
  linkedinUrl?: InputMaybe<OrderBy>;
  locale?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  normalizedTennisRating?: InputMaybe<OrderBy>;
  normalizedTennisRatingScale?: InputMaybe<TennisRatingScalesOrderBy>;
  normalizedTennisRatingScaleId?: InputMaybe<OrderBy>;
  notificationsAggregate?: InputMaybe<UserNotificationsAggregateOrderBy>;
  originalAuthProvider?: InputMaybe<OrderBy>;
  padelSkillLevelId?: InputMaybe<OrderBy>;
  paidInvoicesAggregate?: InputMaybe<InvoicesAggregateOrderBy>;
  participantLessonsAggregate?: InputMaybe<LessonParticipantsAggregateOrderBy>;
  pciId?: InputMaybe<OrderBy>;
  phoneCountryCode?: InputMaybe<OrderBy>;
  phoneNumber?: InputMaybe<OrderBy>;
  phoneVerifiedAt?: InputMaybe<OrderBy>;
  pickleballRatingScalesAggregate?: InputMaybe<UserPickleballRatingScalesAggregateOrderBy>;
  pickleballSkillLevel?: InputMaybe<SkillLevelsOrderBy>;
  pickleballSkillLevelId?: InputMaybe<OrderBy>;
  platformSubscriptionsAggregate?: InputMaybe<PlatformSubscriptionsAggregateOrderBy>;
  playerFinderOnboardedAt?: InputMaybe<OrderBy>;
  playerLessonReflectionsAggregate?: InputMaybe<LessonReflectionsAggregateOrderBy>;
  pprId?: InputMaybe<OrderBy>;
  preferredName?: InputMaybe<OrderBy>;
  premiumContentDescription?: InputMaybe<OrderBy>;
  priceUnitAmountCoachDefault?: InputMaybe<OrderBy>;
  priceUnitAmountPremiumContentDefault?: InputMaybe<OrderBy>;
  priceUnitAmountRemoteCoachDefault?: InputMaybe<OrderBy>;
  professionalRacquetRegistryId?: InputMaybe<OrderBy>;
  professionalRacquetRegistryLastModifiedAt?: InputMaybe<OrderBy>;
  professionalRacquetRegistryPk?: InputMaybe<OrderBy>;
  profile?: InputMaybe<UserProfilesOrderBy>;
  profileImageFileName?: InputMaybe<OrderBy>;
  profileImagePath?: InputMaybe<OrderBy>;
  profileImageProvider?: InputMaybe<OrderBy>;
  profileImageProviderId?: InputMaybe<OrderBy>;
  profileImageProviderUrl?: InputMaybe<OrderBy>;
  profileImageUrl?: InputMaybe<OrderBy>;
  purchasesAggregate?: InputMaybe<SalesAggregateOrderBy>;
  quatroPickleballMemberId?: InputMaybe<OrderBy>;
  registrationDetails?: InputMaybe<UserRegistrationDetailsOrderBy>;
  stripeCustomerId?: InputMaybe<OrderBy>;
  stripeMerchantBusinessType?: InputMaybe<OrderBy>;
  stripeMerchantChargesEnabled?: InputMaybe<OrderBy>;
  stripeMerchantCountry?: InputMaybe<OrderBy>;
  stripeMerchantCurrency?: InputMaybe<OrderBy>;
  stripeMerchantCurrentlyDue?: InputMaybe<OrderBy>;
  stripeMerchantDetailsSubmitted?: InputMaybe<OrderBy>;
  stripeMerchantEventuallyDue?: InputMaybe<OrderBy>;
  stripeMerchantId?: InputMaybe<OrderBy>;
  stripeMerchantPastDue?: InputMaybe<OrderBy>;
  stripeMerchantPayoutsEnabled?: InputMaybe<OrderBy>;
  tennisRating?: InputMaybe<OrderBy>;
  tennisRatingScale?: InputMaybe<TennisRatingScalesOrderBy>;
  tennisRatingScaleId?: InputMaybe<OrderBy>;
  tennisSkillLevel?: InputMaybe<SkillLevelsOrderBy>;
  tennisSkillLevelId?: InputMaybe<OrderBy>;
  termsOfServiceAggregate?: InputMaybe<UserTermsOfServiceAggregateOrderBy>;
  tiktokUrl?: InputMaybe<OrderBy>;
  timezone?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userFilesAggregate?: InputMaybe<UserFilesAggregateOrderBy>;
  userVairConnection?: InputMaybe<UserVairConnectionsOrderBy>;
  username?: InputMaybe<OrderBy>;
  usernameLogsAggregate?: InputMaybe<UsernameLogsAggregateOrderBy>;
  usernamesClaimedAggregate?: InputMaybe<UsernamesClaimedAggregateOrderBy>;
  venueStaffRostersAggregate?: InputMaybe<VenueStaffCoachesAggregateOrderBy>;
  videoAnalysisFilesAggregate?: InputMaybe<VideoAnalysisFilesAggregateOrderBy>;
  videoAnalysisReviewerAggregate?: InputMaybe<VideoAnalysisAggregateOrderBy>;
  videoAnalysisSubmissionAggregate?: InputMaybe<VideoAnalysisAggregateOrderBy>;
  websiteUrl?: InputMaybe<OrderBy>;
  xUrl?: InputMaybe<OrderBy>;
  youtubeUrl?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: users */
export type UsersPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type UsersPrependInput = {
  stripeMerchantCurrentlyDue?: InputMaybe<Scalars['jsonb']>;
  stripeMerchantEventuallyDue?: InputMaybe<Scalars['jsonb']>;
  stripeMerchantPastDue?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "users" */
export enum UsersSelectColumn {
  /** column name */
  AboutMe = 'aboutMe',
  /** column name */
  AboutMeVideoUrl = 'aboutMeVideoUrl',
  /** column name */
  ActiveCityId = 'activeCityId',
  /** column name */
  AdminVenueId = 'adminVenueId',
  /** column name */
  Birthday = 'birthday',
  /** column name */
  BirthdayVisibility = 'birthdayVisibility',
  /** column name */
  CityName = 'cityName',
  /** column name */
  CoachExternalBookingUrl = 'coachExternalBookingUrl',
  /** column name */
  CoachLessonDescription = 'coachLessonDescription',
  /** column name */
  CoachLessonHowToPrepare = 'coachLessonHowToPrepare',
  /** column name */
  CoachStatus = 'coachStatus',
  /** column name */
  CoachStatusUpdatedAt = 'coachStatusUpdatedAt',
  /** column name */
  CoachingStartYear = 'coachingStartYear',
  /** column name */
  CountryId = 'countryId',
  /** column name */
  CountrySubdivisionId = 'countrySubdivisionId',
  /** column name */
  CoverImageFileName = 'coverImageFileName',
  /** column name */
  CoverImagePath = 'coverImagePath',
  /** column name */
  CoverImageProvider = 'coverImageProvider',
  /** column name */
  CoverImageProviderId = 'coverImageProviderId',
  /** column name */
  CoverImageProviderUrl = 'coverImageProviderUrl',
  /** column name */
  CoverImageUrl = 'coverImageUrl',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CurrencyCoachDefault = 'currencyCoachDefault',
  /** column name */
  DefaultCoachPaymentFulfillmentChannel = 'defaultCoachPaymentFulfillmentChannel',
  /** column name */
  DefaultCoachUserCustomCourtId = 'defaultCoachUserCustomCourtId',
  /** column name */
  DefaultCoachVenueId = 'defaultCoachVenueId',
  /** column name */
  DefaultCreditCardId = 'defaultCreditCardId',
  /** column name */
  DefaultPickleballRatingScaleId = 'defaultPickleballRatingScaleId',
  /** column name */
  DefaultSport = 'defaultSport',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  DidSkipStripeSetup = 'didSkipStripeSetup',
  /** column name */
  DuprId = 'duprId',
  /** column name */
  Email = 'email',
  /** column name */
  EventOrganizerAccountType = 'eventOrganizerAccountType',
  /** column name */
  FacebookUrl = 'facebookUrl',
  /** column name */
  FirebaseId = 'firebaseId',
  /** column name */
  FullName = 'fullName',
  /** column name */
  Gender = 'gender',
  /** column name */
  GenderPreference = 'genderPreference',
  /** column name */
  Geometry = 'geometry',
  /** column name */
  Id = 'id',
  /** column name */
  InstagramUrl = 'instagramUrl',
  /** column name */
  InvitedByUserId = 'invitedByUserId',
  /** column name */
  IptpaId = 'iptpaId',
  /** column name */
  IsIptpaMember = 'isIptpaMember',
  /** column name */
  IsMarketingRegistered = 'isMarketingRegistered',
  /** column name */
  IsOnboardComplete = 'isOnboardComplete',
  /** column name */
  IsPciMember = 'isPciMember',
  /** column name */
  IsPendingAccountDetails = 'isPendingAccountDetails',
  /** column name */
  IsPicklrP4Member = 'isPicklrP4Member',
  /** column name */
  IsPprMember = 'isPprMember',
  /** column name */
  IsProfessionalRacquetRegistryActive = 'isProfessionalRacquetRegistryActive',
  /** column name */
  IsProfessionalRacquetRegistryInvite = 'isProfessionalRacquetRegistryInvite',
  /** column name */
  IsQuatroPickleballMember = 'isQuatroPickleballMember',
  /** column name */
  IsRemoteCoachingEnabled = 'isRemoteCoachingEnabled',
  /** column name */
  IsSafePlayCertified = 'isSafePlayCertified',
  /** column name */
  IsUpdatedAfterInvite = 'isUpdatedAfterInvite',
  /** column name */
  LastLoginAt = 'lastLoginAt',
  /** column name */
  LastSessionAt = 'lastSessionAt',
  /** column name */
  LatestAuthProvider = 'latestAuthProvider',
  /** column name */
  Latitude = 'latitude',
  /** column name */
  LinkedinUrl = 'linkedinUrl',
  /** column name */
  Locale = 'locale',
  /** column name */
  Longitude = 'longitude',
  /** column name */
  NormalizedTennisRating = 'normalizedTennisRating',
  /** column name */
  NormalizedTennisRatingScaleId = 'normalizedTennisRatingScaleId',
  /** column name */
  OriginalAuthProvider = 'originalAuthProvider',
  /** column name */
  PadelSkillLevelId = 'padelSkillLevelId',
  /** column name */
  PciId = 'pciId',
  /** column name */
  PhoneCountryCode = 'phoneCountryCode',
  /** column name */
  PhoneNumber = 'phoneNumber',
  /** column name */
  PhoneVerifiedAt = 'phoneVerifiedAt',
  /** column name */
  PickleballSkillLevelId = 'pickleballSkillLevelId',
  /** column name */
  PlayerFinderOnboardedAt = 'playerFinderOnboardedAt',
  /** column name */
  PprId = 'pprId',
  /** column name */
  PreferredName = 'preferredName',
  /** column name */
  PremiumContentDescription = 'premiumContentDescription',
  /** column name */
  PriceUnitAmountCoachDefault = 'priceUnitAmountCoachDefault',
  /** column name */
  PriceUnitAmountPremiumContentDefault = 'priceUnitAmountPremiumContentDefault',
  /** column name */
  PriceUnitAmountRemoteCoachDefault = 'priceUnitAmountRemoteCoachDefault',
  /** column name */
  ProfessionalRacquetRegistryId = 'professionalRacquetRegistryId',
  /** column name */
  ProfessionalRacquetRegistryLastModifiedAt = 'professionalRacquetRegistryLastModifiedAt',
  /** column name */
  ProfessionalRacquetRegistryPk = 'professionalRacquetRegistryPk',
  /** column name */
  ProfileImageFileName = 'profileImageFileName',
  /** column name */
  ProfileImagePath = 'profileImagePath',
  /** column name */
  ProfileImageProvider = 'profileImageProvider',
  /** column name */
  ProfileImageProviderId = 'profileImageProviderId',
  /** column name */
  ProfileImageProviderUrl = 'profileImageProviderUrl',
  /** column name */
  ProfileImageUrl = 'profileImageUrl',
  /** column name */
  QuatroPickleballMemberId = 'quatroPickleballMemberId',
  /** column name */
  StripeCustomerId = 'stripeCustomerId',
  /** column name */
  StripeMerchantBusinessType = 'stripeMerchantBusinessType',
  /** column name */
  StripeMerchantChargesEnabled = 'stripeMerchantChargesEnabled',
  /** column name */
  StripeMerchantCountry = 'stripeMerchantCountry',
  /** column name */
  StripeMerchantCurrency = 'stripeMerchantCurrency',
  /** column name */
  StripeMerchantCurrentlyDue = 'stripeMerchantCurrentlyDue',
  /** column name */
  StripeMerchantDetailsSubmitted = 'stripeMerchantDetailsSubmitted',
  /** column name */
  StripeMerchantEventuallyDue = 'stripeMerchantEventuallyDue',
  /** column name */
  StripeMerchantId = 'stripeMerchantId',
  /** column name */
  StripeMerchantPastDue = 'stripeMerchantPastDue',
  /** column name */
  StripeMerchantPayoutsEnabled = 'stripeMerchantPayoutsEnabled',
  /** column name */
  TennisRating = 'tennisRating',
  /** column name */
  TennisRatingScaleId = 'tennisRatingScaleId',
  /** column name */
  TennisSkillLevelId = 'tennisSkillLevelId',
  /** column name */
  TiktokUrl = 'tiktokUrl',
  /** column name */
  Timezone = 'timezone',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Username = 'username',
  /** column name */
  WebsiteUrl = 'websiteUrl',
  /** column name */
  XUrl = 'xUrl',
  /** column name */
  YoutubeUrl = 'youtubeUrl'
}

/** select "usersAggregateBoolExpBool_andArgumentsColumns" columns of table "users" */
export enum UsersSelectColumnUsersAggregateBoolExpBool_AndArgumentsColumns {
  /** column name */
  DidSkipStripeSetup = 'didSkipStripeSetup',
  /** column name */
  IsIptpaMember = 'isIptpaMember',
  /** column name */
  IsMarketingRegistered = 'isMarketingRegistered',
  /** column name */
  IsOnboardComplete = 'isOnboardComplete',
  /** column name */
  IsPciMember = 'isPciMember',
  /** column name */
  IsPendingAccountDetails = 'isPendingAccountDetails',
  /** column name */
  IsPicklrP4Member = 'isPicklrP4Member',
  /** column name */
  IsPprMember = 'isPprMember',
  /** column name */
  IsProfessionalRacquetRegistryActive = 'isProfessionalRacquetRegistryActive',
  /** column name */
  IsProfessionalRacquetRegistryInvite = 'isProfessionalRacquetRegistryInvite',
  /** column name */
  IsQuatroPickleballMember = 'isQuatroPickleballMember',
  /** column name */
  IsRemoteCoachingEnabled = 'isRemoteCoachingEnabled',
  /** column name */
  IsSafePlayCertified = 'isSafePlayCertified',
  /** column name */
  IsUpdatedAfterInvite = 'isUpdatedAfterInvite',
  /** column name */
  StripeMerchantChargesEnabled = 'stripeMerchantChargesEnabled',
  /** column name */
  StripeMerchantDetailsSubmitted = 'stripeMerchantDetailsSubmitted',
  /** column name */
  StripeMerchantPayoutsEnabled = 'stripeMerchantPayoutsEnabled'
}

/** select "usersAggregateBoolExpBool_orArgumentsColumns" columns of table "users" */
export enum UsersSelectColumnUsersAggregateBoolExpBool_OrArgumentsColumns {
  /** column name */
  DidSkipStripeSetup = 'didSkipStripeSetup',
  /** column name */
  IsIptpaMember = 'isIptpaMember',
  /** column name */
  IsMarketingRegistered = 'isMarketingRegistered',
  /** column name */
  IsOnboardComplete = 'isOnboardComplete',
  /** column name */
  IsPciMember = 'isPciMember',
  /** column name */
  IsPendingAccountDetails = 'isPendingAccountDetails',
  /** column name */
  IsPicklrP4Member = 'isPicklrP4Member',
  /** column name */
  IsPprMember = 'isPprMember',
  /** column name */
  IsProfessionalRacquetRegistryActive = 'isProfessionalRacquetRegistryActive',
  /** column name */
  IsProfessionalRacquetRegistryInvite = 'isProfessionalRacquetRegistryInvite',
  /** column name */
  IsQuatroPickleballMember = 'isQuatroPickleballMember',
  /** column name */
  IsRemoteCoachingEnabled = 'isRemoteCoachingEnabled',
  /** column name */
  IsSafePlayCertified = 'isSafePlayCertified',
  /** column name */
  IsUpdatedAfterInvite = 'isUpdatedAfterInvite',
  /** column name */
  StripeMerchantChargesEnabled = 'stripeMerchantChargesEnabled',
  /** column name */
  StripeMerchantDetailsSubmitted = 'stripeMerchantDetailsSubmitted',
  /** column name */
  StripeMerchantPayoutsEnabled = 'stripeMerchantPayoutsEnabled'
}

/** input type for updating data in table "users" */
export type UsersSetInput = {
  aboutMe?: InputMaybe<Scalars['String']>;
  aboutMeVideoUrl?: InputMaybe<Scalars['String']>;
  activeCityId?: InputMaybe<Scalars['uuid']>;
  adminVenueId?: InputMaybe<Scalars['uuid']>;
  birthday?: InputMaybe<Scalars['date']>;
  birthdayVisibility?: InputMaybe<BirthdayVisibilityEnum>;
  cityName?: InputMaybe<Scalars['String']>;
  coachExternalBookingUrl?: InputMaybe<Scalars['String']>;
  coachLessonDescription?: InputMaybe<Scalars['String']>;
  coachLessonHowToPrepare?: InputMaybe<Scalars['String']>;
  coachStatus?: InputMaybe<CoachStatusEnum>;
  coachStatusUpdatedAt?: InputMaybe<Scalars['timestamptz']>;
  coachingStartYear?: InputMaybe<Scalars['Int']>;
  countryId?: InputMaybe<Scalars['String']>;
  countrySubdivisionId?: InputMaybe<Scalars['uuid']>;
  coverImageFileName?: InputMaybe<Scalars['String']>;
  coverImagePath?: InputMaybe<Scalars['String']>;
  coverImageProvider?: InputMaybe<Scalars['String']>;
  coverImageProviderId?: InputMaybe<Scalars['String']>;
  coverImageProviderUrl?: InputMaybe<Scalars['String']>;
  /** NOTE: Keeping this field empty for now until we serve from our own custom domain */
  coverImageUrl?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currencyCoachDefault?: InputMaybe<Scalars['String']>;
  defaultCoachPaymentFulfillmentChannel?: InputMaybe<PaymentFulfillmentChannelsEnum>;
  defaultCoachUserCustomCourtId?: InputMaybe<Scalars['uuid']>;
  defaultCoachVenueId?: InputMaybe<Scalars['uuid']>;
  defaultCreditCardId?: InputMaybe<Scalars['uuid']>;
  defaultPickleballRatingScaleId?: InputMaybe<Scalars['uuid']>;
  defaultSport?: InputMaybe<SportsEnum>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  didSkipStripeSetup?: InputMaybe<Scalars['Boolean']>;
  duprId?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  eventOrganizerAccountType?: InputMaybe<EventOrganizerAccountTypesEnum>;
  facebookUrl?: InputMaybe<Scalars['String']>;
  firebaseId?: InputMaybe<Scalars['String']>;
  fullName?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<GenderEnum>;
  genderPreference?: InputMaybe<Scalars['String']>;
  geometry?: InputMaybe<Scalars['geography']>;
  id?: InputMaybe<Scalars['uuid']>;
  instagramUrl?: InputMaybe<Scalars['String']>;
  invitedByUserId?: InputMaybe<Scalars['uuid']>;
  iptpaId?: InputMaybe<Scalars['String']>;
  isIptpaMember?: InputMaybe<Scalars['Boolean']>;
  isMarketingRegistered?: InputMaybe<Scalars['Boolean']>;
  isOnboardComplete?: InputMaybe<Scalars['Boolean']>;
  isPciMember?: InputMaybe<Scalars['Boolean']>;
  isPendingAccountDetails?: InputMaybe<Scalars['Boolean']>;
  isPicklrP4Member?: InputMaybe<Scalars['Boolean']>;
  isPprMember?: InputMaybe<Scalars['Boolean']>;
  isProfessionalRacquetRegistryActive?: InputMaybe<Scalars['Boolean']>;
  isProfessionalRacquetRegistryInvite?: InputMaybe<Scalars['Boolean']>;
  isQuatroPickleballMember?: InputMaybe<Scalars['Boolean']>;
  isRemoteCoachingEnabled?: InputMaybe<Scalars['Boolean']>;
  isSafePlayCertified?: InputMaybe<Scalars['Boolean']>;
  isUpdatedAfterInvite?: InputMaybe<Scalars['Boolean']>;
  lastLoginAt?: InputMaybe<Scalars['timestamptz']>;
  lastSessionAt?: InputMaybe<Scalars['timestamptz']>;
  latestAuthProvider?: InputMaybe<Scalars['String']>;
  latitude?: InputMaybe<Scalars['numeric']>;
  linkedinUrl?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  longitude?: InputMaybe<Scalars['numeric']>;
  normalizedTennisRating?: InputMaybe<Scalars['numeric']>;
  normalizedTennisRatingScaleId?: InputMaybe<Scalars['uuid']>;
  originalAuthProvider?: InputMaybe<Scalars['String']>;
  padelSkillLevelId?: InputMaybe<Scalars['String']>;
  pciId?: InputMaybe<Scalars['String']>;
  phoneCountryCode?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  phoneVerifiedAt?: InputMaybe<Scalars['timestamptz']>;
  pickleballSkillLevelId?: InputMaybe<Scalars['String']>;
  playerFinderOnboardedAt?: InputMaybe<Scalars['timestamptz']>;
  pprId?: InputMaybe<Scalars['String']>;
  preferredName?: InputMaybe<Scalars['String']>;
  premiumContentDescription?: InputMaybe<Scalars['String']>;
  priceUnitAmountCoachDefault?: InputMaybe<Scalars['Int']>;
  priceUnitAmountPremiumContentDefault?: InputMaybe<Scalars['Int']>;
  priceUnitAmountRemoteCoachDefault?: InputMaybe<Scalars['Int']>;
  professionalRacquetRegistryId?: InputMaybe<Scalars['Int']>;
  professionalRacquetRegistryLastModifiedAt?: InputMaybe<Scalars['timestamptz']>;
  professionalRacquetRegistryPk?: InputMaybe<Scalars['Int']>;
  profileImageFileName?: InputMaybe<Scalars['String']>;
  profileImagePath?: InputMaybe<Scalars['String']>;
  profileImageProvider?: InputMaybe<Scalars['String']>;
  profileImageProviderId?: InputMaybe<Scalars['String']>;
  profileImageProviderUrl?: InputMaybe<Scalars['String']>;
  /** NOTE: Keeping this field empty for now until we serve from our own custom domain */
  profileImageUrl?: InputMaybe<Scalars['String']>;
  quatroPickleballMemberId?: InputMaybe<Scalars['String']>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  stripeMerchantBusinessType?: InputMaybe<Scalars['String']>;
  stripeMerchantChargesEnabled?: InputMaybe<Scalars['Boolean']>;
  stripeMerchantCountry?: InputMaybe<Scalars['String']>;
  stripeMerchantCurrency?: InputMaybe<Scalars['String']>;
  stripeMerchantCurrentlyDue?: InputMaybe<Scalars['jsonb']>;
  stripeMerchantDetailsSubmitted?: InputMaybe<Scalars['Boolean']>;
  stripeMerchantEventuallyDue?: InputMaybe<Scalars['jsonb']>;
  stripeMerchantId?: InputMaybe<Scalars['String']>;
  stripeMerchantPastDue?: InputMaybe<Scalars['jsonb']>;
  stripeMerchantPayoutsEnabled?: InputMaybe<Scalars['Boolean']>;
  tennisRating?: InputMaybe<Scalars['numeric']>;
  tennisRatingScaleId?: InputMaybe<Scalars['uuid']>;
  tennisSkillLevelId?: InputMaybe<Scalars['String']>;
  tiktokUrl?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  username?: InputMaybe<Scalars['String']>;
  websiteUrl?: InputMaybe<Scalars['String']>;
  xUrl?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type UsersStddevFields = {
  __typename?: 'UsersStddevFields';
  coachingStartYear?: Maybe<Scalars['Float']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  normalizedTennisRating?: Maybe<Scalars['Float']>;
  priceUnitAmountCoachDefault?: Maybe<Scalars['Float']>;
  priceUnitAmountPremiumContentDefault?: Maybe<Scalars['Float']>;
  priceUnitAmountRemoteCoachDefault?: Maybe<Scalars['Float']>;
  professionalRacquetRegistryId?: Maybe<Scalars['Float']>;
  professionalRacquetRegistryPk?: Maybe<Scalars['Float']>;
  tennisRating?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "users" */
export type UsersStddevOrderBy = {
  coachingStartYear?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  normalizedTennisRating?: InputMaybe<OrderBy>;
  priceUnitAmountCoachDefault?: InputMaybe<OrderBy>;
  priceUnitAmountPremiumContentDefault?: InputMaybe<OrderBy>;
  priceUnitAmountRemoteCoachDefault?: InputMaybe<OrderBy>;
  professionalRacquetRegistryId?: InputMaybe<OrderBy>;
  professionalRacquetRegistryPk?: InputMaybe<OrderBy>;
  tennisRating?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type UsersStddevPopFields = {
  __typename?: 'UsersStddevPopFields';
  coachingStartYear?: Maybe<Scalars['Float']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  normalizedTennisRating?: Maybe<Scalars['Float']>;
  priceUnitAmountCoachDefault?: Maybe<Scalars['Float']>;
  priceUnitAmountPremiumContentDefault?: Maybe<Scalars['Float']>;
  priceUnitAmountRemoteCoachDefault?: Maybe<Scalars['Float']>;
  professionalRacquetRegistryId?: Maybe<Scalars['Float']>;
  professionalRacquetRegistryPk?: Maybe<Scalars['Float']>;
  tennisRating?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "users" */
export type UsersStddevPopOrderBy = {
  coachingStartYear?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  normalizedTennisRating?: InputMaybe<OrderBy>;
  priceUnitAmountCoachDefault?: InputMaybe<OrderBy>;
  priceUnitAmountPremiumContentDefault?: InputMaybe<OrderBy>;
  priceUnitAmountRemoteCoachDefault?: InputMaybe<OrderBy>;
  professionalRacquetRegistryId?: InputMaybe<OrderBy>;
  professionalRacquetRegistryPk?: InputMaybe<OrderBy>;
  tennisRating?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type UsersStddevSampFields = {
  __typename?: 'UsersStddevSampFields';
  coachingStartYear?: Maybe<Scalars['Float']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  normalizedTennisRating?: Maybe<Scalars['Float']>;
  priceUnitAmountCoachDefault?: Maybe<Scalars['Float']>;
  priceUnitAmountPremiumContentDefault?: Maybe<Scalars['Float']>;
  priceUnitAmountRemoteCoachDefault?: Maybe<Scalars['Float']>;
  professionalRacquetRegistryId?: Maybe<Scalars['Float']>;
  professionalRacquetRegistryPk?: Maybe<Scalars['Float']>;
  tennisRating?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "users" */
export type UsersStddevSampOrderBy = {
  coachingStartYear?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  normalizedTennisRating?: InputMaybe<OrderBy>;
  priceUnitAmountCoachDefault?: InputMaybe<OrderBy>;
  priceUnitAmountPremiumContentDefault?: InputMaybe<OrderBy>;
  priceUnitAmountRemoteCoachDefault?: InputMaybe<OrderBy>;
  professionalRacquetRegistryId?: InputMaybe<OrderBy>;
  professionalRacquetRegistryPk?: InputMaybe<OrderBy>;
  tennisRating?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "users" */
export type UsersStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UsersStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UsersStreamCursorValueInput = {
  aboutMe?: InputMaybe<Scalars['String']>;
  aboutMeVideoUrl?: InputMaybe<Scalars['String']>;
  activeCityId?: InputMaybe<Scalars['uuid']>;
  adminVenueId?: InputMaybe<Scalars['uuid']>;
  birthday?: InputMaybe<Scalars['date']>;
  birthdayVisibility?: InputMaybe<BirthdayVisibilityEnum>;
  cityName?: InputMaybe<Scalars['String']>;
  coachExternalBookingUrl?: InputMaybe<Scalars['String']>;
  coachLessonDescription?: InputMaybe<Scalars['String']>;
  coachLessonHowToPrepare?: InputMaybe<Scalars['String']>;
  coachStatus?: InputMaybe<CoachStatusEnum>;
  coachStatusUpdatedAt?: InputMaybe<Scalars['timestamptz']>;
  coachingStartYear?: InputMaybe<Scalars['Int']>;
  countryId?: InputMaybe<Scalars['String']>;
  countrySubdivisionId?: InputMaybe<Scalars['uuid']>;
  coverImageFileName?: InputMaybe<Scalars['String']>;
  coverImagePath?: InputMaybe<Scalars['String']>;
  coverImageProvider?: InputMaybe<Scalars['String']>;
  coverImageProviderId?: InputMaybe<Scalars['String']>;
  coverImageProviderUrl?: InputMaybe<Scalars['String']>;
  /** NOTE: Keeping this field empty for now until we serve from our own custom domain */
  coverImageUrl?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currencyCoachDefault?: InputMaybe<Scalars['String']>;
  defaultCoachPaymentFulfillmentChannel?: InputMaybe<PaymentFulfillmentChannelsEnum>;
  defaultCoachUserCustomCourtId?: InputMaybe<Scalars['uuid']>;
  defaultCoachVenueId?: InputMaybe<Scalars['uuid']>;
  defaultCreditCardId?: InputMaybe<Scalars['uuid']>;
  defaultPickleballRatingScaleId?: InputMaybe<Scalars['uuid']>;
  defaultSport?: InputMaybe<SportsEnum>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  didSkipStripeSetup?: InputMaybe<Scalars['Boolean']>;
  duprId?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  eventOrganizerAccountType?: InputMaybe<EventOrganizerAccountTypesEnum>;
  facebookUrl?: InputMaybe<Scalars['String']>;
  firebaseId?: InputMaybe<Scalars['String']>;
  fullName?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<GenderEnum>;
  genderPreference?: InputMaybe<Scalars['String']>;
  geometry?: InputMaybe<Scalars['geography']>;
  id?: InputMaybe<Scalars['uuid']>;
  instagramUrl?: InputMaybe<Scalars['String']>;
  invitedByUserId?: InputMaybe<Scalars['uuid']>;
  iptpaId?: InputMaybe<Scalars['String']>;
  isIptpaMember?: InputMaybe<Scalars['Boolean']>;
  isMarketingRegistered?: InputMaybe<Scalars['Boolean']>;
  isOnboardComplete?: InputMaybe<Scalars['Boolean']>;
  isPciMember?: InputMaybe<Scalars['Boolean']>;
  isPendingAccountDetails?: InputMaybe<Scalars['Boolean']>;
  isPicklrP4Member?: InputMaybe<Scalars['Boolean']>;
  isPprMember?: InputMaybe<Scalars['Boolean']>;
  isProfessionalRacquetRegistryActive?: InputMaybe<Scalars['Boolean']>;
  isProfessionalRacquetRegistryInvite?: InputMaybe<Scalars['Boolean']>;
  isQuatroPickleballMember?: InputMaybe<Scalars['Boolean']>;
  isRemoteCoachingEnabled?: InputMaybe<Scalars['Boolean']>;
  isSafePlayCertified?: InputMaybe<Scalars['Boolean']>;
  isUpdatedAfterInvite?: InputMaybe<Scalars['Boolean']>;
  lastLoginAt?: InputMaybe<Scalars['timestamptz']>;
  lastSessionAt?: InputMaybe<Scalars['timestamptz']>;
  latestAuthProvider?: InputMaybe<Scalars['String']>;
  latitude?: InputMaybe<Scalars['numeric']>;
  linkedinUrl?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  longitude?: InputMaybe<Scalars['numeric']>;
  normalizedTennisRating?: InputMaybe<Scalars['numeric']>;
  normalizedTennisRatingScaleId?: InputMaybe<Scalars['uuid']>;
  originalAuthProvider?: InputMaybe<Scalars['String']>;
  padelSkillLevelId?: InputMaybe<Scalars['String']>;
  pciId?: InputMaybe<Scalars['String']>;
  phoneCountryCode?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  phoneVerifiedAt?: InputMaybe<Scalars['timestamptz']>;
  pickleballSkillLevelId?: InputMaybe<Scalars['String']>;
  playerFinderOnboardedAt?: InputMaybe<Scalars['timestamptz']>;
  pprId?: InputMaybe<Scalars['String']>;
  preferredName?: InputMaybe<Scalars['String']>;
  premiumContentDescription?: InputMaybe<Scalars['String']>;
  priceUnitAmountCoachDefault?: InputMaybe<Scalars['Int']>;
  priceUnitAmountPremiumContentDefault?: InputMaybe<Scalars['Int']>;
  priceUnitAmountRemoteCoachDefault?: InputMaybe<Scalars['Int']>;
  professionalRacquetRegistryId?: InputMaybe<Scalars['Int']>;
  professionalRacquetRegistryLastModifiedAt?: InputMaybe<Scalars['timestamptz']>;
  professionalRacquetRegistryPk?: InputMaybe<Scalars['Int']>;
  profileImageFileName?: InputMaybe<Scalars['String']>;
  profileImagePath?: InputMaybe<Scalars['String']>;
  profileImageProvider?: InputMaybe<Scalars['String']>;
  profileImageProviderId?: InputMaybe<Scalars['String']>;
  profileImageProviderUrl?: InputMaybe<Scalars['String']>;
  /** NOTE: Keeping this field empty for now until we serve from our own custom domain */
  profileImageUrl?: InputMaybe<Scalars['String']>;
  quatroPickleballMemberId?: InputMaybe<Scalars['String']>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  stripeMerchantBusinessType?: InputMaybe<Scalars['String']>;
  stripeMerchantChargesEnabled?: InputMaybe<Scalars['Boolean']>;
  stripeMerchantCountry?: InputMaybe<Scalars['String']>;
  stripeMerchantCurrency?: InputMaybe<Scalars['String']>;
  stripeMerchantCurrentlyDue?: InputMaybe<Scalars['jsonb']>;
  stripeMerchantDetailsSubmitted?: InputMaybe<Scalars['Boolean']>;
  stripeMerchantEventuallyDue?: InputMaybe<Scalars['jsonb']>;
  stripeMerchantId?: InputMaybe<Scalars['String']>;
  stripeMerchantPastDue?: InputMaybe<Scalars['jsonb']>;
  stripeMerchantPayoutsEnabled?: InputMaybe<Scalars['Boolean']>;
  tennisRating?: InputMaybe<Scalars['numeric']>;
  tennisRatingScaleId?: InputMaybe<Scalars['uuid']>;
  tennisSkillLevelId?: InputMaybe<Scalars['String']>;
  tiktokUrl?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  username?: InputMaybe<Scalars['String']>;
  websiteUrl?: InputMaybe<Scalars['String']>;
  xUrl?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type UsersSumFields = {
  __typename?: 'UsersSumFields';
  coachingStartYear?: Maybe<Scalars['Int']>;
  latitude?: Maybe<Scalars['numeric']>;
  longitude?: Maybe<Scalars['numeric']>;
  normalizedTennisRating?: Maybe<Scalars['numeric']>;
  priceUnitAmountCoachDefault?: Maybe<Scalars['Int']>;
  priceUnitAmountPremiumContentDefault?: Maybe<Scalars['Int']>;
  priceUnitAmountRemoteCoachDefault?: Maybe<Scalars['Int']>;
  professionalRacquetRegistryId?: Maybe<Scalars['Int']>;
  professionalRacquetRegistryPk?: Maybe<Scalars['Int']>;
  tennisRating?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "users" */
export type UsersSumOrderBy = {
  coachingStartYear?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  normalizedTennisRating?: InputMaybe<OrderBy>;
  priceUnitAmountCoachDefault?: InputMaybe<OrderBy>;
  priceUnitAmountPremiumContentDefault?: InputMaybe<OrderBy>;
  priceUnitAmountRemoteCoachDefault?: InputMaybe<OrderBy>;
  professionalRacquetRegistryId?: InputMaybe<OrderBy>;
  professionalRacquetRegistryPk?: InputMaybe<OrderBy>;
  tennisRating?: InputMaybe<OrderBy>;
};

/** update columns of table "users" */
export enum UsersUpdateColumn {
  /** column name */
  AboutMe = 'aboutMe',
  /** column name */
  AboutMeVideoUrl = 'aboutMeVideoUrl',
  /** column name */
  ActiveCityId = 'activeCityId',
  /** column name */
  AdminVenueId = 'adminVenueId',
  /** column name */
  Birthday = 'birthday',
  /** column name */
  BirthdayVisibility = 'birthdayVisibility',
  /** column name */
  CityName = 'cityName',
  /** column name */
  CoachExternalBookingUrl = 'coachExternalBookingUrl',
  /** column name */
  CoachLessonDescription = 'coachLessonDescription',
  /** column name */
  CoachLessonHowToPrepare = 'coachLessonHowToPrepare',
  /** column name */
  CoachStatus = 'coachStatus',
  /** column name */
  CoachStatusUpdatedAt = 'coachStatusUpdatedAt',
  /** column name */
  CoachingStartYear = 'coachingStartYear',
  /** column name */
  CountryId = 'countryId',
  /** column name */
  CountrySubdivisionId = 'countrySubdivisionId',
  /** column name */
  CoverImageFileName = 'coverImageFileName',
  /** column name */
  CoverImagePath = 'coverImagePath',
  /** column name */
  CoverImageProvider = 'coverImageProvider',
  /** column name */
  CoverImageProviderId = 'coverImageProviderId',
  /** column name */
  CoverImageProviderUrl = 'coverImageProviderUrl',
  /** column name */
  CoverImageUrl = 'coverImageUrl',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CurrencyCoachDefault = 'currencyCoachDefault',
  /** column name */
  DefaultCoachPaymentFulfillmentChannel = 'defaultCoachPaymentFulfillmentChannel',
  /** column name */
  DefaultCoachUserCustomCourtId = 'defaultCoachUserCustomCourtId',
  /** column name */
  DefaultCoachVenueId = 'defaultCoachVenueId',
  /** column name */
  DefaultCreditCardId = 'defaultCreditCardId',
  /** column name */
  DefaultPickleballRatingScaleId = 'defaultPickleballRatingScaleId',
  /** column name */
  DefaultSport = 'defaultSport',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  DidSkipStripeSetup = 'didSkipStripeSetup',
  /** column name */
  DuprId = 'duprId',
  /** column name */
  Email = 'email',
  /** column name */
  EventOrganizerAccountType = 'eventOrganizerAccountType',
  /** column name */
  FacebookUrl = 'facebookUrl',
  /** column name */
  FirebaseId = 'firebaseId',
  /** column name */
  FullName = 'fullName',
  /** column name */
  Gender = 'gender',
  /** column name */
  GenderPreference = 'genderPreference',
  /** column name */
  Geometry = 'geometry',
  /** column name */
  Id = 'id',
  /** column name */
  InstagramUrl = 'instagramUrl',
  /** column name */
  InvitedByUserId = 'invitedByUserId',
  /** column name */
  IptpaId = 'iptpaId',
  /** column name */
  IsIptpaMember = 'isIptpaMember',
  /** column name */
  IsMarketingRegistered = 'isMarketingRegistered',
  /** column name */
  IsOnboardComplete = 'isOnboardComplete',
  /** column name */
  IsPciMember = 'isPciMember',
  /** column name */
  IsPendingAccountDetails = 'isPendingAccountDetails',
  /** column name */
  IsPicklrP4Member = 'isPicklrP4Member',
  /** column name */
  IsPprMember = 'isPprMember',
  /** column name */
  IsProfessionalRacquetRegistryActive = 'isProfessionalRacquetRegistryActive',
  /** column name */
  IsProfessionalRacquetRegistryInvite = 'isProfessionalRacquetRegistryInvite',
  /** column name */
  IsQuatroPickleballMember = 'isQuatroPickleballMember',
  /** column name */
  IsRemoteCoachingEnabled = 'isRemoteCoachingEnabled',
  /** column name */
  IsSafePlayCertified = 'isSafePlayCertified',
  /** column name */
  IsUpdatedAfterInvite = 'isUpdatedAfterInvite',
  /** column name */
  LastLoginAt = 'lastLoginAt',
  /** column name */
  LastSessionAt = 'lastSessionAt',
  /** column name */
  LatestAuthProvider = 'latestAuthProvider',
  /** column name */
  Latitude = 'latitude',
  /** column name */
  LinkedinUrl = 'linkedinUrl',
  /** column name */
  Locale = 'locale',
  /** column name */
  Longitude = 'longitude',
  /** column name */
  NormalizedTennisRating = 'normalizedTennisRating',
  /** column name */
  NormalizedTennisRatingScaleId = 'normalizedTennisRatingScaleId',
  /** column name */
  OriginalAuthProvider = 'originalAuthProvider',
  /** column name */
  PadelSkillLevelId = 'padelSkillLevelId',
  /** column name */
  PciId = 'pciId',
  /** column name */
  PhoneCountryCode = 'phoneCountryCode',
  /** column name */
  PhoneNumber = 'phoneNumber',
  /** column name */
  PhoneVerifiedAt = 'phoneVerifiedAt',
  /** column name */
  PickleballSkillLevelId = 'pickleballSkillLevelId',
  /** column name */
  PlayerFinderOnboardedAt = 'playerFinderOnboardedAt',
  /** column name */
  PprId = 'pprId',
  /** column name */
  PreferredName = 'preferredName',
  /** column name */
  PremiumContentDescription = 'premiumContentDescription',
  /** column name */
  PriceUnitAmountCoachDefault = 'priceUnitAmountCoachDefault',
  /** column name */
  PriceUnitAmountPremiumContentDefault = 'priceUnitAmountPremiumContentDefault',
  /** column name */
  PriceUnitAmountRemoteCoachDefault = 'priceUnitAmountRemoteCoachDefault',
  /** column name */
  ProfessionalRacquetRegistryId = 'professionalRacquetRegistryId',
  /** column name */
  ProfessionalRacquetRegistryLastModifiedAt = 'professionalRacquetRegistryLastModifiedAt',
  /** column name */
  ProfessionalRacquetRegistryPk = 'professionalRacquetRegistryPk',
  /** column name */
  ProfileImageFileName = 'profileImageFileName',
  /** column name */
  ProfileImagePath = 'profileImagePath',
  /** column name */
  ProfileImageProvider = 'profileImageProvider',
  /** column name */
  ProfileImageProviderId = 'profileImageProviderId',
  /** column name */
  ProfileImageProviderUrl = 'profileImageProviderUrl',
  /** column name */
  ProfileImageUrl = 'profileImageUrl',
  /** column name */
  QuatroPickleballMemberId = 'quatroPickleballMemberId',
  /** column name */
  StripeCustomerId = 'stripeCustomerId',
  /** column name */
  StripeMerchantBusinessType = 'stripeMerchantBusinessType',
  /** column name */
  StripeMerchantChargesEnabled = 'stripeMerchantChargesEnabled',
  /** column name */
  StripeMerchantCountry = 'stripeMerchantCountry',
  /** column name */
  StripeMerchantCurrency = 'stripeMerchantCurrency',
  /** column name */
  StripeMerchantCurrentlyDue = 'stripeMerchantCurrentlyDue',
  /** column name */
  StripeMerchantDetailsSubmitted = 'stripeMerchantDetailsSubmitted',
  /** column name */
  StripeMerchantEventuallyDue = 'stripeMerchantEventuallyDue',
  /** column name */
  StripeMerchantId = 'stripeMerchantId',
  /** column name */
  StripeMerchantPastDue = 'stripeMerchantPastDue',
  /** column name */
  StripeMerchantPayoutsEnabled = 'stripeMerchantPayoutsEnabled',
  /** column name */
  TennisRating = 'tennisRating',
  /** column name */
  TennisRatingScaleId = 'tennisRatingScaleId',
  /** column name */
  TennisSkillLevelId = 'tennisSkillLevelId',
  /** column name */
  TiktokUrl = 'tiktokUrl',
  /** column name */
  Timezone = 'timezone',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Username = 'username',
  /** column name */
  WebsiteUrl = 'websiteUrl',
  /** column name */
  XUrl = 'xUrl',
  /** column name */
  YoutubeUrl = 'youtubeUrl'
}

export type UsersUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<UsersAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _deleteAtPath?: InputMaybe<UsersDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _deleteElem?: InputMaybe<UsersDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _deleteKey?: InputMaybe<UsersDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<UsersIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<UsersPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UsersSetInput>;
  /** filter the rows which have to be updated */
  where: UsersBoolExp;
};

/** aggregate varPop on columns */
export type UsersVarPopFields = {
  __typename?: 'UsersVarPopFields';
  coachingStartYear?: Maybe<Scalars['Float']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  normalizedTennisRating?: Maybe<Scalars['Float']>;
  priceUnitAmountCoachDefault?: Maybe<Scalars['Float']>;
  priceUnitAmountPremiumContentDefault?: Maybe<Scalars['Float']>;
  priceUnitAmountRemoteCoachDefault?: Maybe<Scalars['Float']>;
  professionalRacquetRegistryId?: Maybe<Scalars['Float']>;
  professionalRacquetRegistryPk?: Maybe<Scalars['Float']>;
  tennisRating?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "users" */
export type UsersVarPopOrderBy = {
  coachingStartYear?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  normalizedTennisRating?: InputMaybe<OrderBy>;
  priceUnitAmountCoachDefault?: InputMaybe<OrderBy>;
  priceUnitAmountPremiumContentDefault?: InputMaybe<OrderBy>;
  priceUnitAmountRemoteCoachDefault?: InputMaybe<OrderBy>;
  professionalRacquetRegistryId?: InputMaybe<OrderBy>;
  professionalRacquetRegistryPk?: InputMaybe<OrderBy>;
  tennisRating?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type UsersVarSampFields = {
  __typename?: 'UsersVarSampFields';
  coachingStartYear?: Maybe<Scalars['Float']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  normalizedTennisRating?: Maybe<Scalars['Float']>;
  priceUnitAmountCoachDefault?: Maybe<Scalars['Float']>;
  priceUnitAmountPremiumContentDefault?: Maybe<Scalars['Float']>;
  priceUnitAmountRemoteCoachDefault?: Maybe<Scalars['Float']>;
  professionalRacquetRegistryId?: Maybe<Scalars['Float']>;
  professionalRacquetRegistryPk?: Maybe<Scalars['Float']>;
  tennisRating?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "users" */
export type UsersVarSampOrderBy = {
  coachingStartYear?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  normalizedTennisRating?: InputMaybe<OrderBy>;
  priceUnitAmountCoachDefault?: InputMaybe<OrderBy>;
  priceUnitAmountPremiumContentDefault?: InputMaybe<OrderBy>;
  priceUnitAmountRemoteCoachDefault?: InputMaybe<OrderBy>;
  professionalRacquetRegistryId?: InputMaybe<OrderBy>;
  professionalRacquetRegistryPk?: InputMaybe<OrderBy>;
  tennisRating?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type UsersVarianceFields = {
  __typename?: 'UsersVarianceFields';
  coachingStartYear?: Maybe<Scalars['Float']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  normalizedTennisRating?: Maybe<Scalars['Float']>;
  priceUnitAmountCoachDefault?: Maybe<Scalars['Float']>;
  priceUnitAmountPremiumContentDefault?: Maybe<Scalars['Float']>;
  priceUnitAmountRemoteCoachDefault?: Maybe<Scalars['Float']>;
  professionalRacquetRegistryId?: Maybe<Scalars['Float']>;
  professionalRacquetRegistryPk?: Maybe<Scalars['Float']>;
  tennisRating?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "users" */
export type UsersVarianceOrderBy = {
  coachingStartYear?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  normalizedTennisRating?: InputMaybe<OrderBy>;
  priceUnitAmountCoachDefault?: InputMaybe<OrderBy>;
  priceUnitAmountPremiumContentDefault?: InputMaybe<OrderBy>;
  priceUnitAmountRemoteCoachDefault?: InputMaybe<OrderBy>;
  professionalRacquetRegistryId?: InputMaybe<OrderBy>;
  professionalRacquetRegistryPk?: InputMaybe<OrderBy>;
  tennisRating?: InputMaybe<OrderBy>;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type UuidComparisonExp = {
  _eq?: InputMaybe<Scalars['uuid']>;
  _gt?: InputMaybe<Scalars['uuid']>;
  _gte?: InputMaybe<Scalars['uuid']>;
  _in?: InputMaybe<Array<Scalars['uuid']>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['uuid']>;
  _lte?: InputMaybe<Scalars['uuid']>;
  _neq?: InputMaybe<Scalars['uuid']>;
  _nin?: InputMaybe<Array<Scalars['uuid']>>;
};

/** columns and relationships of "venue_access_types" */
export type VenueAccessTypes = {
  __typename?: 'VenueAccessTypes';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "venue_access_types" */
export type VenueAccessTypesAggregate = {
  __typename?: 'VenueAccessTypesAggregate';
  aggregate?: Maybe<VenueAccessTypesAggregateFields>;
  nodes: Array<VenueAccessTypes>;
};

/** aggregate fields of "venue_access_types" */
export type VenueAccessTypesAggregateFields = {
  __typename?: 'VenueAccessTypesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<VenueAccessTypesMaxFields>;
  min?: Maybe<VenueAccessTypesMinFields>;
};


/** aggregate fields of "venue_access_types" */
export type VenueAccessTypesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<VenueAccessTypesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "venue_access_types". All fields are combined with a logical 'AND'. */
export type VenueAccessTypesBoolExp = {
  _and?: InputMaybe<Array<VenueAccessTypesBoolExp>>;
  _not?: InputMaybe<VenueAccessTypesBoolExp>;
  _or?: InputMaybe<Array<VenueAccessTypesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "venue_access_types" */
export enum VenueAccessTypesConstraint {
  /** unique or primary key constraint on columns "value" */
  VenueAccessTypesPkey = 'venue_access_types_pkey'
}

export enum VenueAccessTypesEnum {
  Free = 'FREE',
  Membership = 'MEMBERSHIP',
  NeedsAudit = 'NEEDS_AUDIT',
  OneTime = 'ONE_TIME',
  Private = 'PRIVATE'
}

/** Boolean expression to compare columns of type "VenueAccessTypesEnum". All fields are combined with logical 'AND'. */
export type VenueAccessTypesEnumComparisonExp = {
  _eq?: InputMaybe<VenueAccessTypesEnum>;
  _in?: InputMaybe<Array<VenueAccessTypesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<VenueAccessTypesEnum>;
  _nin?: InputMaybe<Array<VenueAccessTypesEnum>>;
};

/** input type for inserting data into table "venue_access_types" */
export type VenueAccessTypesInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type VenueAccessTypesMaxFields = {
  __typename?: 'VenueAccessTypesMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type VenueAccessTypesMinFields = {
  __typename?: 'VenueAccessTypesMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "venue_access_types" */
export type VenueAccessTypesMutationResponse = {
  __typename?: 'VenueAccessTypesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<VenueAccessTypes>;
};

/** on_conflict condition type for table "venue_access_types" */
export type VenueAccessTypesOnConflict = {
  constraint: VenueAccessTypesConstraint;
  updateColumns?: Array<VenueAccessTypesUpdateColumn>;
  where?: InputMaybe<VenueAccessTypesBoolExp>;
};

/** Ordering options when selecting data from "venue_access_types". */
export type VenueAccessTypesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: venue_access_types */
export type VenueAccessTypesPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "venue_access_types" */
export enum VenueAccessTypesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "venue_access_types" */
export type VenueAccessTypesSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "venue_access_types" */
export type VenueAccessTypesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: VenueAccessTypesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type VenueAccessTypesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "venue_access_types" */
export enum VenueAccessTypesUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type VenueAccessTypesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<VenueAccessTypesSetInput>;
  /** filter the rows which have to be updated */
  where: VenueAccessTypesBoolExp;
};

/** columns and relationships of "venue_admin_claim_statuses" */
export type VenueAdminClaimStatuses = {
  __typename?: 'VenueAdminClaimStatuses';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "venue_admin_claim_statuses" */
export type VenueAdminClaimStatusesAggregate = {
  __typename?: 'VenueAdminClaimStatusesAggregate';
  aggregate?: Maybe<VenueAdminClaimStatusesAggregateFields>;
  nodes: Array<VenueAdminClaimStatuses>;
};

/** aggregate fields of "venue_admin_claim_statuses" */
export type VenueAdminClaimStatusesAggregateFields = {
  __typename?: 'VenueAdminClaimStatusesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<VenueAdminClaimStatusesMaxFields>;
  min?: Maybe<VenueAdminClaimStatusesMinFields>;
};


/** aggregate fields of "venue_admin_claim_statuses" */
export type VenueAdminClaimStatusesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<VenueAdminClaimStatusesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "venue_admin_claim_statuses". All fields are combined with a logical 'AND'. */
export type VenueAdminClaimStatusesBoolExp = {
  _and?: InputMaybe<Array<VenueAdminClaimStatusesBoolExp>>;
  _not?: InputMaybe<VenueAdminClaimStatusesBoolExp>;
  _or?: InputMaybe<Array<VenueAdminClaimStatusesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "venue_admin_claim_statuses" */
export enum VenueAdminClaimStatusesConstraint {
  /** unique or primary key constraint on columns "value" */
  VenueAdminClaimStatusesPkey = 'venue_admin_claim_statuses_pkey'
}

export enum VenueAdminClaimStatusesEnum {
  Approved = 'APPROVED',
  Denied = 'DENIED',
  Pending = 'PENDING'
}

/** Boolean expression to compare columns of type "VenueAdminClaimStatusesEnum". All fields are combined with logical 'AND'. */
export type VenueAdminClaimStatusesEnumComparisonExp = {
  _eq?: InputMaybe<VenueAdminClaimStatusesEnum>;
  _in?: InputMaybe<Array<VenueAdminClaimStatusesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<VenueAdminClaimStatusesEnum>;
  _nin?: InputMaybe<Array<VenueAdminClaimStatusesEnum>>;
};

/** input type for inserting data into table "venue_admin_claim_statuses" */
export type VenueAdminClaimStatusesInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type VenueAdminClaimStatusesMaxFields = {
  __typename?: 'VenueAdminClaimStatusesMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type VenueAdminClaimStatusesMinFields = {
  __typename?: 'VenueAdminClaimStatusesMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "venue_admin_claim_statuses" */
export type VenueAdminClaimStatusesMutationResponse = {
  __typename?: 'VenueAdminClaimStatusesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<VenueAdminClaimStatuses>;
};

/** on_conflict condition type for table "venue_admin_claim_statuses" */
export type VenueAdminClaimStatusesOnConflict = {
  constraint: VenueAdminClaimStatusesConstraint;
  updateColumns?: Array<VenueAdminClaimStatusesUpdateColumn>;
  where?: InputMaybe<VenueAdminClaimStatusesBoolExp>;
};

/** Ordering options when selecting data from "venue_admin_claim_statuses". */
export type VenueAdminClaimStatusesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: venue_admin_claim_statuses */
export type VenueAdminClaimStatusesPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "venue_admin_claim_statuses" */
export enum VenueAdminClaimStatusesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "venue_admin_claim_statuses" */
export type VenueAdminClaimStatusesSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "venue_admin_claim_statuses" */
export type VenueAdminClaimStatusesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: VenueAdminClaimStatusesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type VenueAdminClaimStatusesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "venue_admin_claim_statuses" */
export enum VenueAdminClaimStatusesUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type VenueAdminClaimStatusesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<VenueAdminClaimStatusesSetInput>;
  /** filter the rows which have to be updated */
  where: VenueAdminClaimStatusesBoolExp;
};

/** columns and relationships of "venue_admin_claims" */
export type VenueAdminClaims = {
  __typename?: 'VenueAdminClaims';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  notes?: Maybe<Scalars['String']>;
  reviewedAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  reviewedByUser?: Maybe<Users>;
  reviewedByUserId?: Maybe<Scalars['uuid']>;
  status: VenueAdminClaimStatusesEnum;
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid'];
  /** An object relationship */
  venue: Venues;
  venueId: Scalars['uuid'];
};

/** aggregated selection of "venue_admin_claims" */
export type VenueAdminClaimsAggregate = {
  __typename?: 'VenueAdminClaimsAggregate';
  aggregate?: Maybe<VenueAdminClaimsAggregateFields>;
  nodes: Array<VenueAdminClaims>;
};

/** aggregate fields of "venue_admin_claims" */
export type VenueAdminClaimsAggregateFields = {
  __typename?: 'VenueAdminClaimsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<VenueAdminClaimsMaxFields>;
  min?: Maybe<VenueAdminClaimsMinFields>;
};


/** aggregate fields of "venue_admin_claims" */
export type VenueAdminClaimsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<VenueAdminClaimsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "venue_admin_claims". All fields are combined with a logical 'AND'. */
export type VenueAdminClaimsBoolExp = {
  _and?: InputMaybe<Array<VenueAdminClaimsBoolExp>>;
  _not?: InputMaybe<VenueAdminClaimsBoolExp>;
  _or?: InputMaybe<Array<VenueAdminClaimsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  notes?: InputMaybe<StringComparisonExp>;
  reviewedAt?: InputMaybe<TimestamptzComparisonExp>;
  reviewedByUser?: InputMaybe<UsersBoolExp>;
  reviewedByUserId?: InputMaybe<UuidComparisonExp>;
  status?: InputMaybe<VenueAdminClaimStatusesEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
  venue?: InputMaybe<VenuesBoolExp>;
  venueId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "venue_admin_claims" */
export enum VenueAdminClaimsConstraint {
  /** unique or primary key constraint on columns "id" */
  VenueAdminClaimsPkey = 'venue_admin_claims_pkey',
  /** unique or primary key constraint on columns "venue_id", "user_id" */
  VenueAdminClaimsVenueIdUserIdActiveKey = 'venue_admin_claims_venue_id_user_id_active_key'
}

/** input type for inserting data into table "venue_admin_claims" */
export type VenueAdminClaimsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  notes?: InputMaybe<Scalars['String']>;
  reviewedAt?: InputMaybe<Scalars['timestamptz']>;
  reviewedByUser?: InputMaybe<UsersObjRelInsertInput>;
  reviewedByUserId?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<VenueAdminClaimStatusesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']>;
  venue?: InputMaybe<VenuesObjRelInsertInput>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type VenueAdminClaimsMaxFields = {
  __typename?: 'VenueAdminClaimsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  notes?: Maybe<Scalars['String']>;
  reviewedAt?: Maybe<Scalars['timestamptz']>;
  reviewedByUserId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
  venueId?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type VenueAdminClaimsMinFields = {
  __typename?: 'VenueAdminClaimsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  notes?: Maybe<Scalars['String']>;
  reviewedAt?: Maybe<Scalars['timestamptz']>;
  reviewedByUserId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
  venueId?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "venue_admin_claims" */
export type VenueAdminClaimsMutationResponse = {
  __typename?: 'VenueAdminClaimsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<VenueAdminClaims>;
};

/** on_conflict condition type for table "venue_admin_claims" */
export type VenueAdminClaimsOnConflict = {
  constraint: VenueAdminClaimsConstraint;
  updateColumns?: Array<VenueAdminClaimsUpdateColumn>;
  where?: InputMaybe<VenueAdminClaimsBoolExp>;
};

/** Ordering options when selecting data from "venue_admin_claims". */
export type VenueAdminClaimsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  notes?: InputMaybe<OrderBy>;
  reviewedAt?: InputMaybe<OrderBy>;
  reviewedByUser?: InputMaybe<UsersOrderBy>;
  reviewedByUserId?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
  venue?: InputMaybe<VenuesOrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: venue_admin_claims */
export type VenueAdminClaimsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "venue_admin_claims" */
export enum VenueAdminClaimsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  Notes = 'notes',
  /** column name */
  ReviewedAt = 'reviewedAt',
  /** column name */
  ReviewedByUserId = 'reviewedByUserId',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId',
  /** column name */
  VenueId = 'venueId'
}

/** input type for updating data in table "venue_admin_claims" */
export type VenueAdminClaimsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  notes?: InputMaybe<Scalars['String']>;
  reviewedAt?: InputMaybe<Scalars['timestamptz']>;
  reviewedByUserId?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<VenueAdminClaimStatusesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "venue_admin_claims" */
export type VenueAdminClaimsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: VenueAdminClaimsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type VenueAdminClaimsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  notes?: InputMaybe<Scalars['String']>;
  reviewedAt?: InputMaybe<Scalars['timestamptz']>;
  reviewedByUserId?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<VenueAdminClaimStatusesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "venue_admin_claims" */
export enum VenueAdminClaimsUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  Notes = 'notes',
  /** column name */
  ReviewedAt = 'reviewedAt',
  /** column name */
  ReviewedByUserId = 'reviewedByUserId',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId',
  /** column name */
  VenueId = 'venueId'
}

export type VenueAdminClaimsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<VenueAdminClaimsSetInput>;
  /** filter the rows which have to be updated */
  where: VenueAdminClaimsBoolExp;
};

/** columns and relationships of "venue_amenities" */
export type VenueAmenities = {
  __typename?: 'VenueAmenities';
  amenity: AmenitiesEnum;
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  venue: Venues;
  venueId: Scalars['uuid'];
};

/** aggregated selection of "venue_amenities" */
export type VenueAmenitiesAggregate = {
  __typename?: 'VenueAmenitiesAggregate';
  aggregate?: Maybe<VenueAmenitiesAggregateFields>;
  nodes: Array<VenueAmenities>;
};

export type VenueAmenitiesAggregateBoolExp = {
  count?: InputMaybe<VenueAmenitiesAggregateBoolExpCount>;
};

/** aggregate fields of "venue_amenities" */
export type VenueAmenitiesAggregateFields = {
  __typename?: 'VenueAmenitiesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<VenueAmenitiesMaxFields>;
  min?: Maybe<VenueAmenitiesMinFields>;
};


/** aggregate fields of "venue_amenities" */
export type VenueAmenitiesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<VenueAmenitiesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "venue_amenities" */
export type VenueAmenitiesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<VenueAmenitiesMaxOrderBy>;
  min?: InputMaybe<VenueAmenitiesMinOrderBy>;
};

/** input type for inserting array relation for remote table "venue_amenities" */
export type VenueAmenitiesArrRelInsertInput = {
  data: Array<VenueAmenitiesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<VenueAmenitiesOnConflict>;
};

/** Boolean expression to filter rows from the table "venue_amenities". All fields are combined with a logical 'AND'. */
export type VenueAmenitiesBoolExp = {
  _and?: InputMaybe<Array<VenueAmenitiesBoolExp>>;
  _not?: InputMaybe<VenueAmenitiesBoolExp>;
  _or?: InputMaybe<Array<VenueAmenitiesBoolExp>>;
  amenity?: InputMaybe<AmenitiesEnumComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  venue?: InputMaybe<VenuesBoolExp>;
  venueId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "venue_amenities" */
export enum VenueAmenitiesConstraint {
  /** unique or primary key constraint on columns "id" */
  VenueAmenitiesPkey = 'venue_amenities_pkey',
  /** unique or primary key constraint on columns "venue_id", "amenity" */
  VenueAmenitiesVenueIdAmenityKey = 'venue_amenities_venue_id_amenity_key'
}

/** input type for inserting data into table "venue_amenities" */
export type VenueAmenitiesInsertInput = {
  amenity?: InputMaybe<AmenitiesEnum>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  venue?: InputMaybe<VenuesObjRelInsertInput>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type VenueAmenitiesMaxFields = {
  __typename?: 'VenueAmenitiesMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  venueId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "venue_amenities" */
export type VenueAmenitiesMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type VenueAmenitiesMinFields = {
  __typename?: 'VenueAmenitiesMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  venueId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "venue_amenities" */
export type VenueAmenitiesMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "venue_amenities" */
export type VenueAmenitiesMutationResponse = {
  __typename?: 'VenueAmenitiesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<VenueAmenities>;
};

/** on_conflict condition type for table "venue_amenities" */
export type VenueAmenitiesOnConflict = {
  constraint: VenueAmenitiesConstraint;
  updateColumns?: Array<VenueAmenitiesUpdateColumn>;
  where?: InputMaybe<VenueAmenitiesBoolExp>;
};

/** Ordering options when selecting data from "venue_amenities". */
export type VenueAmenitiesOrderBy = {
  amenity?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  venue?: InputMaybe<VenuesOrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: venue_amenities */
export type VenueAmenitiesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "venue_amenities" */
export enum VenueAmenitiesSelectColumn {
  /** column name */
  Amenity = 'amenity',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  VenueId = 'venueId'
}

/** input type for updating data in table "venue_amenities" */
export type VenueAmenitiesSetInput = {
  amenity?: InputMaybe<AmenitiesEnum>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "venue_amenities" */
export type VenueAmenitiesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: VenueAmenitiesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type VenueAmenitiesStreamCursorValueInput = {
  amenity?: InputMaybe<AmenitiesEnum>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "venue_amenities" */
export enum VenueAmenitiesUpdateColumn {
  /** column name */
  Amenity = 'amenity',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  VenueId = 'venueId'
}

export type VenueAmenitiesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<VenueAmenitiesSetInput>;
  /** filter the rows which have to be updated */
  where: VenueAmenitiesBoolExp;
};

/** columns and relationships of "venue_booking_config_versions" */
export type VenueBookingConfigVersions = {
  __typename?: 'VenueBookingConfigVersions';
  changeType: BookingConfigChangeTypesEnum;
  changedAt: Scalars['timestamptz'];
  changedBy: Scalars['uuid'];
  /** An object relationship */
  changedByUser: Users;
  id: Scalars['uuid'];
  /** An object relationship */
  integration: VenueBookingIntegrations;
  integrationId: Scalars['uuid'];
  snapshot: Scalars['jsonb'];
  termsVersion?: Maybe<Scalars['String']>;
  version: Scalars['Int'];
};


/** columns and relationships of "venue_booking_config_versions" */
export type VenueBookingConfigVersionsSnapshotArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "venue_booking_config_versions" */
export type VenueBookingConfigVersionsAggregate = {
  __typename?: 'VenueBookingConfigVersionsAggregate';
  aggregate?: Maybe<VenueBookingConfigVersionsAggregateFields>;
  nodes: Array<VenueBookingConfigVersions>;
};

export type VenueBookingConfigVersionsAggregateBoolExp = {
  count?: InputMaybe<VenueBookingConfigVersionsAggregateBoolExpCount>;
};

/** aggregate fields of "venue_booking_config_versions" */
export type VenueBookingConfigVersionsAggregateFields = {
  __typename?: 'VenueBookingConfigVersionsAggregateFields';
  avg?: Maybe<VenueBookingConfigVersionsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<VenueBookingConfigVersionsMaxFields>;
  min?: Maybe<VenueBookingConfigVersionsMinFields>;
  stddev?: Maybe<VenueBookingConfigVersionsStddevFields>;
  stddevPop?: Maybe<VenueBookingConfigVersionsStddevPopFields>;
  stddevSamp?: Maybe<VenueBookingConfigVersionsStddevSampFields>;
  sum?: Maybe<VenueBookingConfigVersionsSumFields>;
  varPop?: Maybe<VenueBookingConfigVersionsVarPopFields>;
  varSamp?: Maybe<VenueBookingConfigVersionsVarSampFields>;
  variance?: Maybe<VenueBookingConfigVersionsVarianceFields>;
};


/** aggregate fields of "venue_booking_config_versions" */
export type VenueBookingConfigVersionsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<VenueBookingConfigVersionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "venue_booking_config_versions" */
export type VenueBookingConfigVersionsAggregateOrderBy = {
  avg?: InputMaybe<VenueBookingConfigVersionsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<VenueBookingConfigVersionsMaxOrderBy>;
  min?: InputMaybe<VenueBookingConfigVersionsMinOrderBy>;
  stddev?: InputMaybe<VenueBookingConfigVersionsStddevOrderBy>;
  stddevPop?: InputMaybe<VenueBookingConfigVersionsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<VenueBookingConfigVersionsStddevSampOrderBy>;
  sum?: InputMaybe<VenueBookingConfigVersionsSumOrderBy>;
  varPop?: InputMaybe<VenueBookingConfigVersionsVarPopOrderBy>;
  varSamp?: InputMaybe<VenueBookingConfigVersionsVarSampOrderBy>;
  variance?: InputMaybe<VenueBookingConfigVersionsVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type VenueBookingConfigVersionsAppendInput = {
  snapshot?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "venue_booking_config_versions" */
export type VenueBookingConfigVersionsArrRelInsertInput = {
  data: Array<VenueBookingConfigVersionsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<VenueBookingConfigVersionsOnConflict>;
};

/** aggregate avg on columns */
export type VenueBookingConfigVersionsAvgFields = {
  __typename?: 'VenueBookingConfigVersionsAvgFields';
  version?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "venue_booking_config_versions" */
export type VenueBookingConfigVersionsAvgOrderBy = {
  version?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "venue_booking_config_versions". All fields are combined with a logical 'AND'. */
export type VenueBookingConfigVersionsBoolExp = {
  _and?: InputMaybe<Array<VenueBookingConfigVersionsBoolExp>>;
  _not?: InputMaybe<VenueBookingConfigVersionsBoolExp>;
  _or?: InputMaybe<Array<VenueBookingConfigVersionsBoolExp>>;
  changeType?: InputMaybe<BookingConfigChangeTypesEnumComparisonExp>;
  changedAt?: InputMaybe<TimestamptzComparisonExp>;
  changedBy?: InputMaybe<UuidComparisonExp>;
  changedByUser?: InputMaybe<UsersBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  integration?: InputMaybe<VenueBookingIntegrationsBoolExp>;
  integrationId?: InputMaybe<UuidComparisonExp>;
  snapshot?: InputMaybe<JsonbComparisonExp>;
  termsVersion?: InputMaybe<StringComparisonExp>;
  version?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "venue_booking_config_versions" */
export enum VenueBookingConfigVersionsConstraint {
  /** unique or primary key constraint on columns "integration_id", "version" */
  VenueBookingConfigVersionsIntegrationIdVersionKey = 'venue_booking_config_versions_integration_id_version_key',
  /** unique or primary key constraint on columns "id" */
  VenueBookingConfigVersionsPkey = 'venue_booking_config_versions_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type VenueBookingConfigVersionsDeleteAtPathInput = {
  snapshot?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type VenueBookingConfigVersionsDeleteElemInput = {
  snapshot?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type VenueBookingConfigVersionsDeleteKeyInput = {
  snapshot?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "venue_booking_config_versions" */
export type VenueBookingConfigVersionsIncInput = {
  version?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "venue_booking_config_versions" */
export type VenueBookingConfigVersionsInsertInput = {
  changeType?: InputMaybe<BookingConfigChangeTypesEnum>;
  changedAt?: InputMaybe<Scalars['timestamptz']>;
  changedBy?: InputMaybe<Scalars['uuid']>;
  changedByUser?: InputMaybe<UsersObjRelInsertInput>;
  id?: InputMaybe<Scalars['uuid']>;
  integration?: InputMaybe<VenueBookingIntegrationsObjRelInsertInput>;
  integrationId?: InputMaybe<Scalars['uuid']>;
  snapshot?: InputMaybe<Scalars['jsonb']>;
  termsVersion?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type VenueBookingConfigVersionsMaxFields = {
  __typename?: 'VenueBookingConfigVersionsMaxFields';
  changedAt?: Maybe<Scalars['timestamptz']>;
  changedBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  integrationId?: Maybe<Scalars['uuid']>;
  termsVersion?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "venue_booking_config_versions" */
export type VenueBookingConfigVersionsMaxOrderBy = {
  changedAt?: InputMaybe<OrderBy>;
  changedBy?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  integrationId?: InputMaybe<OrderBy>;
  termsVersion?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type VenueBookingConfigVersionsMinFields = {
  __typename?: 'VenueBookingConfigVersionsMinFields';
  changedAt?: Maybe<Scalars['timestamptz']>;
  changedBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  integrationId?: Maybe<Scalars['uuid']>;
  termsVersion?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "venue_booking_config_versions" */
export type VenueBookingConfigVersionsMinOrderBy = {
  changedAt?: InputMaybe<OrderBy>;
  changedBy?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  integrationId?: InputMaybe<OrderBy>;
  termsVersion?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "venue_booking_config_versions" */
export type VenueBookingConfigVersionsMutationResponse = {
  __typename?: 'VenueBookingConfigVersionsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<VenueBookingConfigVersions>;
};

/** input type for inserting object relation for remote table "venue_booking_config_versions" */
export type VenueBookingConfigVersionsObjRelInsertInput = {
  data: VenueBookingConfigVersionsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<VenueBookingConfigVersionsOnConflict>;
};

/** on_conflict condition type for table "venue_booking_config_versions" */
export type VenueBookingConfigVersionsOnConflict = {
  constraint: VenueBookingConfigVersionsConstraint;
  updateColumns?: Array<VenueBookingConfigVersionsUpdateColumn>;
  where?: InputMaybe<VenueBookingConfigVersionsBoolExp>;
};

/** Ordering options when selecting data from "venue_booking_config_versions". */
export type VenueBookingConfigVersionsOrderBy = {
  changeType?: InputMaybe<OrderBy>;
  changedAt?: InputMaybe<OrderBy>;
  changedBy?: InputMaybe<OrderBy>;
  changedByUser?: InputMaybe<UsersOrderBy>;
  id?: InputMaybe<OrderBy>;
  integration?: InputMaybe<VenueBookingIntegrationsOrderBy>;
  integrationId?: InputMaybe<OrderBy>;
  snapshot?: InputMaybe<OrderBy>;
  termsVersion?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: venue_booking_config_versions */
export type VenueBookingConfigVersionsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type VenueBookingConfigVersionsPrependInput = {
  snapshot?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "venue_booking_config_versions" */
export enum VenueBookingConfigVersionsSelectColumn {
  /** column name */
  ChangeType = 'changeType',
  /** column name */
  ChangedAt = 'changedAt',
  /** column name */
  ChangedBy = 'changedBy',
  /** column name */
  Id = 'id',
  /** column name */
  IntegrationId = 'integrationId',
  /** column name */
  Snapshot = 'snapshot',
  /** column name */
  TermsVersion = 'termsVersion',
  /** column name */
  Version = 'version'
}

/** input type for updating data in table "venue_booking_config_versions" */
export type VenueBookingConfigVersionsSetInput = {
  changeType?: InputMaybe<BookingConfigChangeTypesEnum>;
  changedAt?: InputMaybe<Scalars['timestamptz']>;
  changedBy?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  integrationId?: InputMaybe<Scalars['uuid']>;
  snapshot?: InputMaybe<Scalars['jsonb']>;
  termsVersion?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type VenueBookingConfigVersionsStddevFields = {
  __typename?: 'VenueBookingConfigVersionsStddevFields';
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "venue_booking_config_versions" */
export type VenueBookingConfigVersionsStddevOrderBy = {
  version?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type VenueBookingConfigVersionsStddevPopFields = {
  __typename?: 'VenueBookingConfigVersionsStddevPopFields';
  version?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "venue_booking_config_versions" */
export type VenueBookingConfigVersionsStddevPopOrderBy = {
  version?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type VenueBookingConfigVersionsStddevSampFields = {
  __typename?: 'VenueBookingConfigVersionsStddevSampFields';
  version?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "venue_booking_config_versions" */
export type VenueBookingConfigVersionsStddevSampOrderBy = {
  version?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "venue_booking_config_versions" */
export type VenueBookingConfigVersionsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: VenueBookingConfigVersionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type VenueBookingConfigVersionsStreamCursorValueInput = {
  changeType?: InputMaybe<BookingConfigChangeTypesEnum>;
  changedAt?: InputMaybe<Scalars['timestamptz']>;
  changedBy?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  integrationId?: InputMaybe<Scalars['uuid']>;
  snapshot?: InputMaybe<Scalars['jsonb']>;
  termsVersion?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type VenueBookingConfigVersionsSumFields = {
  __typename?: 'VenueBookingConfigVersionsSumFields';
  version?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "venue_booking_config_versions" */
export type VenueBookingConfigVersionsSumOrderBy = {
  version?: InputMaybe<OrderBy>;
};

/** update columns of table "venue_booking_config_versions" */
export enum VenueBookingConfigVersionsUpdateColumn {
  /** column name */
  ChangeType = 'changeType',
  /** column name */
  ChangedAt = 'changedAt',
  /** column name */
  ChangedBy = 'changedBy',
  /** column name */
  Id = 'id',
  /** column name */
  IntegrationId = 'integrationId',
  /** column name */
  Snapshot = 'snapshot',
  /** column name */
  TermsVersion = 'termsVersion',
  /** column name */
  Version = 'version'
}

export type VenueBookingConfigVersionsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<VenueBookingConfigVersionsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _deleteAtPath?: InputMaybe<VenueBookingConfigVersionsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _deleteElem?: InputMaybe<VenueBookingConfigVersionsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _deleteKey?: InputMaybe<VenueBookingConfigVersionsDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<VenueBookingConfigVersionsIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<VenueBookingConfigVersionsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<VenueBookingConfigVersionsSetInput>;
  /** filter the rows which have to be updated */
  where: VenueBookingConfigVersionsBoolExp;
};

/** aggregate varPop on columns */
export type VenueBookingConfigVersionsVarPopFields = {
  __typename?: 'VenueBookingConfigVersionsVarPopFields';
  version?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "venue_booking_config_versions" */
export type VenueBookingConfigVersionsVarPopOrderBy = {
  version?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type VenueBookingConfigVersionsVarSampFields = {
  __typename?: 'VenueBookingConfigVersionsVarSampFields';
  version?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "venue_booking_config_versions" */
export type VenueBookingConfigVersionsVarSampOrderBy = {
  version?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type VenueBookingConfigVersionsVarianceFields = {
  __typename?: 'VenueBookingConfigVersionsVarianceFields';
  version?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "venue_booking_config_versions" */
export type VenueBookingConfigVersionsVarianceOrderBy = {
  version?: InputMaybe<OrderBy>;
};

/** columns and relationships of "venue_booking_connection_check_statuses" */
export type VenueBookingConnectionCheckStatuses = {
  __typename?: 'VenueBookingConnectionCheckStatuses';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "venue_booking_connection_check_statuses" */
export type VenueBookingConnectionCheckStatusesAggregate = {
  __typename?: 'VenueBookingConnectionCheckStatusesAggregate';
  aggregate?: Maybe<VenueBookingConnectionCheckStatusesAggregateFields>;
  nodes: Array<VenueBookingConnectionCheckStatuses>;
};

/** aggregate fields of "venue_booking_connection_check_statuses" */
export type VenueBookingConnectionCheckStatusesAggregateFields = {
  __typename?: 'VenueBookingConnectionCheckStatusesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<VenueBookingConnectionCheckStatusesMaxFields>;
  min?: Maybe<VenueBookingConnectionCheckStatusesMinFields>;
};


/** aggregate fields of "venue_booking_connection_check_statuses" */
export type VenueBookingConnectionCheckStatusesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<VenueBookingConnectionCheckStatusesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "venue_booking_connection_check_statuses". All fields are combined with a logical 'AND'. */
export type VenueBookingConnectionCheckStatusesBoolExp = {
  _and?: InputMaybe<Array<VenueBookingConnectionCheckStatusesBoolExp>>;
  _not?: InputMaybe<VenueBookingConnectionCheckStatusesBoolExp>;
  _or?: InputMaybe<Array<VenueBookingConnectionCheckStatusesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "venue_booking_connection_check_statuses" */
export enum VenueBookingConnectionCheckStatusesConstraint {
  /** unique or primary key constraint on columns "value" */
  VenueBookingConnectionCheckStatusesPkey = 'venue_booking_connection_check_statuses_pkey'
}

export enum VenueBookingConnectionCheckStatusesEnum {
  /** Sent; waiting for the engine to report */
  Dispatched = 'DISPATCHED',
  /** The engine could not sign in or could not see courts */
  Failed = 'FAILED',
  /** Waiting to be sent to the booking engine */
  Queued = 'QUEUED',
  /** The engine never reported */
  Unknown = 'UNKNOWN',
  /** The engine signed in as the booking account and saw the club's courts */
  Verified = 'VERIFIED'
}

/** Boolean expression to compare columns of type "VenueBookingConnectionCheckStatusesEnum". All fields are combined with logical 'AND'. */
export type VenueBookingConnectionCheckStatusesEnumComparisonExp = {
  _eq?: InputMaybe<VenueBookingConnectionCheckStatusesEnum>;
  _in?: InputMaybe<Array<VenueBookingConnectionCheckStatusesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<VenueBookingConnectionCheckStatusesEnum>;
  _nin?: InputMaybe<Array<VenueBookingConnectionCheckStatusesEnum>>;
};

/** input type for inserting data into table "venue_booking_connection_check_statuses" */
export type VenueBookingConnectionCheckStatusesInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type VenueBookingConnectionCheckStatusesMaxFields = {
  __typename?: 'VenueBookingConnectionCheckStatusesMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type VenueBookingConnectionCheckStatusesMinFields = {
  __typename?: 'VenueBookingConnectionCheckStatusesMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "venue_booking_connection_check_statuses" */
export type VenueBookingConnectionCheckStatusesMutationResponse = {
  __typename?: 'VenueBookingConnectionCheckStatusesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<VenueBookingConnectionCheckStatuses>;
};

/** on_conflict condition type for table "venue_booking_connection_check_statuses" */
export type VenueBookingConnectionCheckStatusesOnConflict = {
  constraint: VenueBookingConnectionCheckStatusesConstraint;
  updateColumns?: Array<VenueBookingConnectionCheckStatusesUpdateColumn>;
  where?: InputMaybe<VenueBookingConnectionCheckStatusesBoolExp>;
};

/** Ordering options when selecting data from "venue_booking_connection_check_statuses". */
export type VenueBookingConnectionCheckStatusesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: venue_booking_connection_check_statuses */
export type VenueBookingConnectionCheckStatusesPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "venue_booking_connection_check_statuses" */
export enum VenueBookingConnectionCheckStatusesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "venue_booking_connection_check_statuses" */
export type VenueBookingConnectionCheckStatusesSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "venue_booking_connection_check_statuses" */
export type VenueBookingConnectionCheckStatusesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: VenueBookingConnectionCheckStatusesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type VenueBookingConnectionCheckStatusesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "venue_booking_connection_check_statuses" */
export enum VenueBookingConnectionCheckStatusesUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type VenueBookingConnectionCheckStatusesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<VenueBookingConnectionCheckStatusesSetInput>;
  /** filter the rows which have to be updated */
  where: VenueBookingConnectionCheckStatusesBoolExp;
};

/** columns and relationships of "venue_booking_connection_checks" */
export type VenueBookingConnectionChecks = {
  __typename?: 'VenueBookingConnectionChecks';
  completedAt?: Maybe<Scalars['timestamptz']>;
  createdAt: Scalars['timestamptz'];
  dispatchedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  /** An object relationship */
  integration: VenueBookingIntegrations;
  integrationId: Scalars['uuid'];
  report?: Maybe<Scalars['jsonb']>;
  requestedBy?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  requestedByUser?: Maybe<Users>;
  runId?: Maybe<Scalars['String']>;
  status: VenueBookingConnectionCheckStatusesEnum;
  trigger: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "venue_booking_connection_checks" */
export type VenueBookingConnectionChecksReportArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "venue_booking_connection_checks" */
export type VenueBookingConnectionChecksAggregate = {
  __typename?: 'VenueBookingConnectionChecksAggregate';
  aggregate?: Maybe<VenueBookingConnectionChecksAggregateFields>;
  nodes: Array<VenueBookingConnectionChecks>;
};

export type VenueBookingConnectionChecksAggregateBoolExp = {
  count?: InputMaybe<VenueBookingConnectionChecksAggregateBoolExpCount>;
};

/** aggregate fields of "venue_booking_connection_checks" */
export type VenueBookingConnectionChecksAggregateFields = {
  __typename?: 'VenueBookingConnectionChecksAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<VenueBookingConnectionChecksMaxFields>;
  min?: Maybe<VenueBookingConnectionChecksMinFields>;
};


/** aggregate fields of "venue_booking_connection_checks" */
export type VenueBookingConnectionChecksAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<VenueBookingConnectionChecksSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "venue_booking_connection_checks" */
export type VenueBookingConnectionChecksAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<VenueBookingConnectionChecksMaxOrderBy>;
  min?: InputMaybe<VenueBookingConnectionChecksMinOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type VenueBookingConnectionChecksAppendInput = {
  report?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "venue_booking_connection_checks" */
export type VenueBookingConnectionChecksArrRelInsertInput = {
  data: Array<VenueBookingConnectionChecksInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<VenueBookingConnectionChecksOnConflict>;
};

/** Boolean expression to filter rows from the table "venue_booking_connection_checks". All fields are combined with a logical 'AND'. */
export type VenueBookingConnectionChecksBoolExp = {
  _and?: InputMaybe<Array<VenueBookingConnectionChecksBoolExp>>;
  _not?: InputMaybe<VenueBookingConnectionChecksBoolExp>;
  _or?: InputMaybe<Array<VenueBookingConnectionChecksBoolExp>>;
  completedAt?: InputMaybe<TimestamptzComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  dispatchedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  integration?: InputMaybe<VenueBookingIntegrationsBoolExp>;
  integrationId?: InputMaybe<UuidComparisonExp>;
  report?: InputMaybe<JsonbComparisonExp>;
  requestedBy?: InputMaybe<UuidComparisonExp>;
  requestedByUser?: InputMaybe<UsersBoolExp>;
  runId?: InputMaybe<StringComparisonExp>;
  status?: InputMaybe<VenueBookingConnectionCheckStatusesEnumComparisonExp>;
  trigger?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "venue_booking_connection_checks" */
export enum VenueBookingConnectionChecksConstraint {
  /** unique or primary key constraint on columns "integration_id" */
  VenueBookingConnectionChecksOneLivePerIntegration = 'venue_booking_connection_checks_one_live_per_integration',
  /** unique or primary key constraint on columns "id" */
  VenueBookingConnectionChecksPkey = 'venue_booking_connection_checks_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type VenueBookingConnectionChecksDeleteAtPathInput = {
  report?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type VenueBookingConnectionChecksDeleteElemInput = {
  report?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type VenueBookingConnectionChecksDeleteKeyInput = {
  report?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "venue_booking_connection_checks" */
export type VenueBookingConnectionChecksInsertInput = {
  completedAt?: InputMaybe<Scalars['timestamptz']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  dispatchedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  integration?: InputMaybe<VenueBookingIntegrationsObjRelInsertInput>;
  integrationId?: InputMaybe<Scalars['uuid']>;
  report?: InputMaybe<Scalars['jsonb']>;
  requestedBy?: InputMaybe<Scalars['uuid']>;
  requestedByUser?: InputMaybe<UsersObjRelInsertInput>;
  runId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<VenueBookingConnectionCheckStatusesEnum>;
  trigger?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type VenueBookingConnectionChecksMaxFields = {
  __typename?: 'VenueBookingConnectionChecksMaxFields';
  completedAt?: Maybe<Scalars['timestamptz']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  dispatchedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  integrationId?: Maybe<Scalars['uuid']>;
  requestedBy?: Maybe<Scalars['uuid']>;
  runId?: Maybe<Scalars['String']>;
  trigger?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "venue_booking_connection_checks" */
export type VenueBookingConnectionChecksMaxOrderBy = {
  completedAt?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  dispatchedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  integrationId?: InputMaybe<OrderBy>;
  requestedBy?: InputMaybe<OrderBy>;
  runId?: InputMaybe<OrderBy>;
  trigger?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type VenueBookingConnectionChecksMinFields = {
  __typename?: 'VenueBookingConnectionChecksMinFields';
  completedAt?: Maybe<Scalars['timestamptz']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  dispatchedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  integrationId?: Maybe<Scalars['uuid']>;
  requestedBy?: Maybe<Scalars['uuid']>;
  runId?: Maybe<Scalars['String']>;
  trigger?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "venue_booking_connection_checks" */
export type VenueBookingConnectionChecksMinOrderBy = {
  completedAt?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  dispatchedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  integrationId?: InputMaybe<OrderBy>;
  requestedBy?: InputMaybe<OrderBy>;
  runId?: InputMaybe<OrderBy>;
  trigger?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "venue_booking_connection_checks" */
export type VenueBookingConnectionChecksMutationResponse = {
  __typename?: 'VenueBookingConnectionChecksMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<VenueBookingConnectionChecks>;
};

/** on_conflict condition type for table "venue_booking_connection_checks" */
export type VenueBookingConnectionChecksOnConflict = {
  constraint: VenueBookingConnectionChecksConstraint;
  updateColumns?: Array<VenueBookingConnectionChecksUpdateColumn>;
  where?: InputMaybe<VenueBookingConnectionChecksBoolExp>;
};

/** Ordering options when selecting data from "venue_booking_connection_checks". */
export type VenueBookingConnectionChecksOrderBy = {
  completedAt?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  dispatchedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  integration?: InputMaybe<VenueBookingIntegrationsOrderBy>;
  integrationId?: InputMaybe<OrderBy>;
  report?: InputMaybe<OrderBy>;
  requestedBy?: InputMaybe<OrderBy>;
  requestedByUser?: InputMaybe<UsersOrderBy>;
  runId?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  trigger?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: venue_booking_connection_checks */
export type VenueBookingConnectionChecksPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type VenueBookingConnectionChecksPrependInput = {
  report?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "venue_booking_connection_checks" */
export enum VenueBookingConnectionChecksSelectColumn {
  /** column name */
  CompletedAt = 'completedAt',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DispatchedAt = 'dispatchedAt',
  /** column name */
  Id = 'id',
  /** column name */
  IntegrationId = 'integrationId',
  /** column name */
  Report = 'report',
  /** column name */
  RequestedBy = 'requestedBy',
  /** column name */
  RunId = 'runId',
  /** column name */
  Status = 'status',
  /** column name */
  Trigger = 'trigger',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "venue_booking_connection_checks" */
export type VenueBookingConnectionChecksSetInput = {
  completedAt?: InputMaybe<Scalars['timestamptz']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  dispatchedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  integrationId?: InputMaybe<Scalars['uuid']>;
  report?: InputMaybe<Scalars['jsonb']>;
  requestedBy?: InputMaybe<Scalars['uuid']>;
  runId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<VenueBookingConnectionCheckStatusesEnum>;
  trigger?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "venue_booking_connection_checks" */
export type VenueBookingConnectionChecksStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: VenueBookingConnectionChecksStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type VenueBookingConnectionChecksStreamCursorValueInput = {
  completedAt?: InputMaybe<Scalars['timestamptz']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  dispatchedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  integrationId?: InputMaybe<Scalars['uuid']>;
  report?: InputMaybe<Scalars['jsonb']>;
  requestedBy?: InputMaybe<Scalars['uuid']>;
  runId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<VenueBookingConnectionCheckStatusesEnum>;
  trigger?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "venue_booking_connection_checks" */
export enum VenueBookingConnectionChecksUpdateColumn {
  /** column name */
  CompletedAt = 'completedAt',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DispatchedAt = 'dispatchedAt',
  /** column name */
  Id = 'id',
  /** column name */
  IntegrationId = 'integrationId',
  /** column name */
  Report = 'report',
  /** column name */
  RequestedBy = 'requestedBy',
  /** column name */
  RunId = 'runId',
  /** column name */
  Status = 'status',
  /** column name */
  Trigger = 'trigger',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type VenueBookingConnectionChecksUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<VenueBookingConnectionChecksAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _deleteAtPath?: InputMaybe<VenueBookingConnectionChecksDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _deleteElem?: InputMaybe<VenueBookingConnectionChecksDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _deleteKey?: InputMaybe<VenueBookingConnectionChecksDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<VenueBookingConnectionChecksPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<VenueBookingConnectionChecksSetInput>;
  /** filter the rows which have to be updated */
  where: VenueBookingConnectionChecksBoolExp;
};

/** columns and relationships of "venue_booking_court_rates" */
export type VenueBookingCourtRates = {
  __typename?: 'VenueBookingCourtRates';
  createdAt: Scalars['timestamptz'];
  currency: Scalars['String'];
  hourlyUnitAmount: Scalars['Int'];
  id: Scalars['uuid'];
  /** An object relationship */
  integration: VenueBookingIntegrations;
  integrationId: Scalars['uuid'];
  peakHourlyUnitAmount?: Maybe<Scalars['Int']>;
  sport?: Maybe<SportsEnum>;
  updatedAt: Scalars['timestamptz'];
  updatedBy?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  updatedByUser?: Maybe<Users>;
};

/** aggregated selection of "venue_booking_court_rates" */
export type VenueBookingCourtRatesAggregate = {
  __typename?: 'VenueBookingCourtRatesAggregate';
  aggregate?: Maybe<VenueBookingCourtRatesAggregateFields>;
  nodes: Array<VenueBookingCourtRates>;
};

export type VenueBookingCourtRatesAggregateBoolExp = {
  count?: InputMaybe<VenueBookingCourtRatesAggregateBoolExpCount>;
};

/** aggregate fields of "venue_booking_court_rates" */
export type VenueBookingCourtRatesAggregateFields = {
  __typename?: 'VenueBookingCourtRatesAggregateFields';
  avg?: Maybe<VenueBookingCourtRatesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<VenueBookingCourtRatesMaxFields>;
  min?: Maybe<VenueBookingCourtRatesMinFields>;
  stddev?: Maybe<VenueBookingCourtRatesStddevFields>;
  stddevPop?: Maybe<VenueBookingCourtRatesStddevPopFields>;
  stddevSamp?: Maybe<VenueBookingCourtRatesStddevSampFields>;
  sum?: Maybe<VenueBookingCourtRatesSumFields>;
  varPop?: Maybe<VenueBookingCourtRatesVarPopFields>;
  varSamp?: Maybe<VenueBookingCourtRatesVarSampFields>;
  variance?: Maybe<VenueBookingCourtRatesVarianceFields>;
};


/** aggregate fields of "venue_booking_court_rates" */
export type VenueBookingCourtRatesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<VenueBookingCourtRatesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "venue_booking_court_rates" */
export type VenueBookingCourtRatesAggregateOrderBy = {
  avg?: InputMaybe<VenueBookingCourtRatesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<VenueBookingCourtRatesMaxOrderBy>;
  min?: InputMaybe<VenueBookingCourtRatesMinOrderBy>;
  stddev?: InputMaybe<VenueBookingCourtRatesStddevOrderBy>;
  stddevPop?: InputMaybe<VenueBookingCourtRatesStddevPopOrderBy>;
  stddevSamp?: InputMaybe<VenueBookingCourtRatesStddevSampOrderBy>;
  sum?: InputMaybe<VenueBookingCourtRatesSumOrderBy>;
  varPop?: InputMaybe<VenueBookingCourtRatesVarPopOrderBy>;
  varSamp?: InputMaybe<VenueBookingCourtRatesVarSampOrderBy>;
  variance?: InputMaybe<VenueBookingCourtRatesVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "venue_booking_court_rates" */
export type VenueBookingCourtRatesArrRelInsertInput = {
  data: Array<VenueBookingCourtRatesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<VenueBookingCourtRatesOnConflict>;
};

/** aggregate avg on columns */
export type VenueBookingCourtRatesAvgFields = {
  __typename?: 'VenueBookingCourtRatesAvgFields';
  hourlyUnitAmount?: Maybe<Scalars['Float']>;
  peakHourlyUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "venue_booking_court_rates" */
export type VenueBookingCourtRatesAvgOrderBy = {
  hourlyUnitAmount?: InputMaybe<OrderBy>;
  peakHourlyUnitAmount?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "venue_booking_court_rates". All fields are combined with a logical 'AND'. */
export type VenueBookingCourtRatesBoolExp = {
  _and?: InputMaybe<Array<VenueBookingCourtRatesBoolExp>>;
  _not?: InputMaybe<VenueBookingCourtRatesBoolExp>;
  _or?: InputMaybe<Array<VenueBookingCourtRatesBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  currency?: InputMaybe<StringComparisonExp>;
  hourlyUnitAmount?: InputMaybe<IntComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  integration?: InputMaybe<VenueBookingIntegrationsBoolExp>;
  integrationId?: InputMaybe<UuidComparisonExp>;
  peakHourlyUnitAmount?: InputMaybe<IntComparisonExp>;
  sport?: InputMaybe<SportsEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  updatedBy?: InputMaybe<UuidComparisonExp>;
  updatedByUser?: InputMaybe<UsersBoolExp>;
};

/** unique or primary key constraints on table "venue_booking_court_rates" */
export enum VenueBookingCourtRatesConstraint {
  /** unique or primary key constraint on columns "integration_id" */
  VenueBookingCourtRatesIntegrationSportKey = 'venue_booking_court_rates_integration_sport_key',
  /** unique or primary key constraint on columns "id" */
  VenueBookingCourtRatesPkey = 'venue_booking_court_rates_pkey'
}

/** input type for incrementing numeric columns in table "venue_booking_court_rates" */
export type VenueBookingCourtRatesIncInput = {
  hourlyUnitAmount?: InputMaybe<Scalars['Int']>;
  peakHourlyUnitAmount?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "venue_booking_court_rates" */
export type VenueBookingCourtRatesInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  hourlyUnitAmount?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  integration?: InputMaybe<VenueBookingIntegrationsObjRelInsertInput>;
  integrationId?: InputMaybe<Scalars['uuid']>;
  peakHourlyUnitAmount?: InputMaybe<Scalars['Int']>;
  sport?: InputMaybe<SportsEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  updatedByUser?: InputMaybe<UsersObjRelInsertInput>;
};

/** aggregate max on columns */
export type VenueBookingCourtRatesMaxFields = {
  __typename?: 'VenueBookingCourtRatesMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  hourlyUnitAmount?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  integrationId?: Maybe<Scalars['uuid']>;
  peakHourlyUnitAmount?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "venue_booking_court_rates" */
export type VenueBookingCourtRatesMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  currency?: InputMaybe<OrderBy>;
  hourlyUnitAmount?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  integrationId?: InputMaybe<OrderBy>;
  peakHourlyUnitAmount?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  updatedBy?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type VenueBookingCourtRatesMinFields = {
  __typename?: 'VenueBookingCourtRatesMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  hourlyUnitAmount?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  integrationId?: Maybe<Scalars['uuid']>;
  peakHourlyUnitAmount?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "venue_booking_court_rates" */
export type VenueBookingCourtRatesMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  currency?: InputMaybe<OrderBy>;
  hourlyUnitAmount?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  integrationId?: InputMaybe<OrderBy>;
  peakHourlyUnitAmount?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  updatedBy?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "venue_booking_court_rates" */
export type VenueBookingCourtRatesMutationResponse = {
  __typename?: 'VenueBookingCourtRatesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<VenueBookingCourtRates>;
};

/** on_conflict condition type for table "venue_booking_court_rates" */
export type VenueBookingCourtRatesOnConflict = {
  constraint: VenueBookingCourtRatesConstraint;
  updateColumns?: Array<VenueBookingCourtRatesUpdateColumn>;
  where?: InputMaybe<VenueBookingCourtRatesBoolExp>;
};

/** Ordering options when selecting data from "venue_booking_court_rates". */
export type VenueBookingCourtRatesOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  currency?: InputMaybe<OrderBy>;
  hourlyUnitAmount?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  integration?: InputMaybe<VenueBookingIntegrationsOrderBy>;
  integrationId?: InputMaybe<OrderBy>;
  peakHourlyUnitAmount?: InputMaybe<OrderBy>;
  sport?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  updatedBy?: InputMaybe<OrderBy>;
  updatedByUser?: InputMaybe<UsersOrderBy>;
};

/** primary key columns input for table: venue_booking_court_rates */
export type VenueBookingCourtRatesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "venue_booking_court_rates" */
export enum VenueBookingCourtRatesSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Currency = 'currency',
  /** column name */
  HourlyUnitAmount = 'hourlyUnitAmount',
  /** column name */
  Id = 'id',
  /** column name */
  IntegrationId = 'integrationId',
  /** column name */
  PeakHourlyUnitAmount = 'peakHourlyUnitAmount',
  /** column name */
  Sport = 'sport',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "venue_booking_court_rates" */
export type VenueBookingCourtRatesSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  hourlyUnitAmount?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  integrationId?: InputMaybe<Scalars['uuid']>;
  peakHourlyUnitAmount?: InputMaybe<Scalars['Int']>;
  sport?: InputMaybe<SportsEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type VenueBookingCourtRatesStddevFields = {
  __typename?: 'VenueBookingCourtRatesStddevFields';
  hourlyUnitAmount?: Maybe<Scalars['Float']>;
  peakHourlyUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "venue_booking_court_rates" */
export type VenueBookingCourtRatesStddevOrderBy = {
  hourlyUnitAmount?: InputMaybe<OrderBy>;
  peakHourlyUnitAmount?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type VenueBookingCourtRatesStddevPopFields = {
  __typename?: 'VenueBookingCourtRatesStddevPopFields';
  hourlyUnitAmount?: Maybe<Scalars['Float']>;
  peakHourlyUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "venue_booking_court_rates" */
export type VenueBookingCourtRatesStddevPopOrderBy = {
  hourlyUnitAmount?: InputMaybe<OrderBy>;
  peakHourlyUnitAmount?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type VenueBookingCourtRatesStddevSampFields = {
  __typename?: 'VenueBookingCourtRatesStddevSampFields';
  hourlyUnitAmount?: Maybe<Scalars['Float']>;
  peakHourlyUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "venue_booking_court_rates" */
export type VenueBookingCourtRatesStddevSampOrderBy = {
  hourlyUnitAmount?: InputMaybe<OrderBy>;
  peakHourlyUnitAmount?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "venue_booking_court_rates" */
export type VenueBookingCourtRatesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: VenueBookingCourtRatesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type VenueBookingCourtRatesStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  hourlyUnitAmount?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  integrationId?: InputMaybe<Scalars['uuid']>;
  peakHourlyUnitAmount?: InputMaybe<Scalars['Int']>;
  sport?: InputMaybe<SportsEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type VenueBookingCourtRatesSumFields = {
  __typename?: 'VenueBookingCourtRatesSumFields';
  hourlyUnitAmount?: Maybe<Scalars['Int']>;
  peakHourlyUnitAmount?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "venue_booking_court_rates" */
export type VenueBookingCourtRatesSumOrderBy = {
  hourlyUnitAmount?: InputMaybe<OrderBy>;
  peakHourlyUnitAmount?: InputMaybe<OrderBy>;
};

/** update columns of table "venue_booking_court_rates" */
export enum VenueBookingCourtRatesUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Currency = 'currency',
  /** column name */
  HourlyUnitAmount = 'hourlyUnitAmount',
  /** column name */
  Id = 'id',
  /** column name */
  IntegrationId = 'integrationId',
  /** column name */
  PeakHourlyUnitAmount = 'peakHourlyUnitAmount',
  /** column name */
  Sport = 'sport',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

export type VenueBookingCourtRatesUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<VenueBookingCourtRatesIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<VenueBookingCourtRatesSetInput>;
  /** filter the rows which have to be updated */
  where: VenueBookingCourtRatesBoolExp;
};

/** aggregate varPop on columns */
export type VenueBookingCourtRatesVarPopFields = {
  __typename?: 'VenueBookingCourtRatesVarPopFields';
  hourlyUnitAmount?: Maybe<Scalars['Float']>;
  peakHourlyUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "venue_booking_court_rates" */
export type VenueBookingCourtRatesVarPopOrderBy = {
  hourlyUnitAmount?: InputMaybe<OrderBy>;
  peakHourlyUnitAmount?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type VenueBookingCourtRatesVarSampFields = {
  __typename?: 'VenueBookingCourtRatesVarSampFields';
  hourlyUnitAmount?: Maybe<Scalars['Float']>;
  peakHourlyUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "venue_booking_court_rates" */
export type VenueBookingCourtRatesVarSampOrderBy = {
  hourlyUnitAmount?: InputMaybe<OrderBy>;
  peakHourlyUnitAmount?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type VenueBookingCourtRatesVarianceFields = {
  __typename?: 'VenueBookingCourtRatesVarianceFields';
  hourlyUnitAmount?: Maybe<Scalars['Float']>;
  peakHourlyUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "venue_booking_court_rates" */
export type VenueBookingCourtRatesVarianceOrderBy = {
  hourlyUnitAmount?: InputMaybe<OrderBy>;
  peakHourlyUnitAmount?: InputMaybe<OrderBy>;
};

/** columns and relationships of "venue_booking_integrations" */
export type VenueBookingIntegrations = {
  __typename?: 'VenueBookingIntegrations';
  accountAddedConfirmedAt?: Maybe<Scalars['timestamptz']>;
  accountAddedConfirmedBy?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  accountAddedConfirmedByUser?: Maybe<Users>;
  activatedAt?: Maybe<Scalars['timestamptz']>;
  bookingAccountEmail: Scalars['String'];
  bookingSystem: BookingSystemsEnum;
  /** An array relationship */
  configVersions: Array<VenueBookingConfigVersions>;
  /** An aggregate relationship */
  configVersionsAggregate: VenueBookingConfigVersionsAggregate;
  confirmationNote?: Maybe<Scalars['String']>;
  /** An array relationship */
  connectionChecks: Array<VenueBookingConnectionChecks>;
  /** An aggregate relationship */
  connectionChecksAggregate: VenueBookingConnectionChecksAggregate;
  connectionStatus: BookingConnectionStatusesEnum;
  /** An array relationship */
  courtRates: Array<VenueBookingCourtRates>;
  /** An aggregate relationship */
  courtRatesAggregate: VenueBookingCourtRatesAggregate;
  createdAt: Scalars['timestamptz'];
  currentVersion: Scalars['Int'];
  externalOrgId?: Maybe<Scalars['String']>;
  helpRequestedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  isPreferredPartner: Scalars['Boolean'];
  maxAdvanceBookingDays?: Maybe<Scalars['Int']>;
  partnerPricingEnabled: Scalars['Boolean'];
  pausedAt?: Maybe<Scalars['timestamptz']>;
  promoCode?: Maybe<Scalars['String']>;
  providerApiKeyEncrypted?: Maybe<Scalars['String']>;
  readVerifiedAt?: Maybe<Scalars['timestamptz']>;
  referralFeeCents: Scalars['Int'];
  referralFeeEnabled: Scalars['Boolean'];
  /** An array relationship */
  rules: Array<VenueBookingRules>;
  /** An aggregate relationship */
  rulesAggregate: VenueBookingRulesAggregate;
  status: BookingIntegrationStatusesEnum;
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  venue: Venues;
  venueId: Scalars['uuid'];
  verifiedAt?: Maybe<Scalars['timestamptz']>;
  verifiedBy?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  verifiedByUser?: Maybe<Users>;
  /** An array relationship */
  windows: Array<VenueBookingWindows>;
  /** An aggregate relationship */
  windowsAggregate: VenueBookingWindowsAggregate;
};


/** columns and relationships of "venue_booking_integrations" */
export type VenueBookingIntegrationsConfigVersionsArgs = {
  distinctOn?: InputMaybe<Array<VenueBookingConfigVersionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueBookingConfigVersionsOrderBy>>;
  where?: InputMaybe<VenueBookingConfigVersionsBoolExp>;
};


/** columns and relationships of "venue_booking_integrations" */
export type VenueBookingIntegrationsConfigVersionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<VenueBookingConfigVersionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueBookingConfigVersionsOrderBy>>;
  where?: InputMaybe<VenueBookingConfigVersionsBoolExp>;
};


/** columns and relationships of "venue_booking_integrations" */
export type VenueBookingIntegrationsConnectionChecksArgs = {
  distinctOn?: InputMaybe<Array<VenueBookingConnectionChecksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueBookingConnectionChecksOrderBy>>;
  where?: InputMaybe<VenueBookingConnectionChecksBoolExp>;
};


/** columns and relationships of "venue_booking_integrations" */
export type VenueBookingIntegrationsConnectionChecksAggregateArgs = {
  distinctOn?: InputMaybe<Array<VenueBookingConnectionChecksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueBookingConnectionChecksOrderBy>>;
  where?: InputMaybe<VenueBookingConnectionChecksBoolExp>;
};


/** columns and relationships of "venue_booking_integrations" */
export type VenueBookingIntegrationsCourtRatesArgs = {
  distinctOn?: InputMaybe<Array<VenueBookingCourtRatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueBookingCourtRatesOrderBy>>;
  where?: InputMaybe<VenueBookingCourtRatesBoolExp>;
};


/** columns and relationships of "venue_booking_integrations" */
export type VenueBookingIntegrationsCourtRatesAggregateArgs = {
  distinctOn?: InputMaybe<Array<VenueBookingCourtRatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueBookingCourtRatesOrderBy>>;
  where?: InputMaybe<VenueBookingCourtRatesBoolExp>;
};


/** columns and relationships of "venue_booking_integrations" */
export type VenueBookingIntegrationsRulesArgs = {
  distinctOn?: InputMaybe<Array<VenueBookingRulesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueBookingRulesOrderBy>>;
  where?: InputMaybe<VenueBookingRulesBoolExp>;
};


/** columns and relationships of "venue_booking_integrations" */
export type VenueBookingIntegrationsRulesAggregateArgs = {
  distinctOn?: InputMaybe<Array<VenueBookingRulesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueBookingRulesOrderBy>>;
  where?: InputMaybe<VenueBookingRulesBoolExp>;
};


/** columns and relationships of "venue_booking_integrations" */
export type VenueBookingIntegrationsWindowsArgs = {
  distinctOn?: InputMaybe<Array<VenueBookingWindowsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueBookingWindowsOrderBy>>;
  where?: InputMaybe<VenueBookingWindowsBoolExp>;
};


/** columns and relationships of "venue_booking_integrations" */
export type VenueBookingIntegrationsWindowsAggregateArgs = {
  distinctOn?: InputMaybe<Array<VenueBookingWindowsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueBookingWindowsOrderBy>>;
  where?: InputMaybe<VenueBookingWindowsBoolExp>;
};

/** aggregated selection of "venue_booking_integrations" */
export type VenueBookingIntegrationsAggregate = {
  __typename?: 'VenueBookingIntegrationsAggregate';
  aggregate?: Maybe<VenueBookingIntegrationsAggregateFields>;
  nodes: Array<VenueBookingIntegrations>;
};

/** aggregate fields of "venue_booking_integrations" */
export type VenueBookingIntegrationsAggregateFields = {
  __typename?: 'VenueBookingIntegrationsAggregateFields';
  avg?: Maybe<VenueBookingIntegrationsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<VenueBookingIntegrationsMaxFields>;
  min?: Maybe<VenueBookingIntegrationsMinFields>;
  stddev?: Maybe<VenueBookingIntegrationsStddevFields>;
  stddevPop?: Maybe<VenueBookingIntegrationsStddevPopFields>;
  stddevSamp?: Maybe<VenueBookingIntegrationsStddevSampFields>;
  sum?: Maybe<VenueBookingIntegrationsSumFields>;
  varPop?: Maybe<VenueBookingIntegrationsVarPopFields>;
  varSamp?: Maybe<VenueBookingIntegrationsVarSampFields>;
  variance?: Maybe<VenueBookingIntegrationsVarianceFields>;
};


/** aggregate fields of "venue_booking_integrations" */
export type VenueBookingIntegrationsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<VenueBookingIntegrationsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type VenueBookingIntegrationsAvgFields = {
  __typename?: 'VenueBookingIntegrationsAvgFields';
  currentVersion?: Maybe<Scalars['Float']>;
  maxAdvanceBookingDays?: Maybe<Scalars['Float']>;
  referralFeeCents?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "venue_booking_integrations". All fields are combined with a logical 'AND'. */
export type VenueBookingIntegrationsBoolExp = {
  _and?: InputMaybe<Array<VenueBookingIntegrationsBoolExp>>;
  _not?: InputMaybe<VenueBookingIntegrationsBoolExp>;
  _or?: InputMaybe<Array<VenueBookingIntegrationsBoolExp>>;
  accountAddedConfirmedAt?: InputMaybe<TimestamptzComparisonExp>;
  accountAddedConfirmedBy?: InputMaybe<UuidComparisonExp>;
  accountAddedConfirmedByUser?: InputMaybe<UsersBoolExp>;
  activatedAt?: InputMaybe<TimestamptzComparisonExp>;
  bookingAccountEmail?: InputMaybe<StringComparisonExp>;
  bookingSystem?: InputMaybe<BookingSystemsEnumComparisonExp>;
  configVersions?: InputMaybe<VenueBookingConfigVersionsBoolExp>;
  configVersionsAggregate?: InputMaybe<VenueBookingConfigVersionsAggregateBoolExp>;
  confirmationNote?: InputMaybe<StringComparisonExp>;
  connectionChecks?: InputMaybe<VenueBookingConnectionChecksBoolExp>;
  connectionChecksAggregate?: InputMaybe<VenueBookingConnectionChecksAggregateBoolExp>;
  connectionStatus?: InputMaybe<BookingConnectionStatusesEnumComparisonExp>;
  courtRates?: InputMaybe<VenueBookingCourtRatesBoolExp>;
  courtRatesAggregate?: InputMaybe<VenueBookingCourtRatesAggregateBoolExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  currentVersion?: InputMaybe<IntComparisonExp>;
  externalOrgId?: InputMaybe<StringComparisonExp>;
  helpRequestedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isPreferredPartner?: InputMaybe<BooleanComparisonExp>;
  maxAdvanceBookingDays?: InputMaybe<IntComparisonExp>;
  partnerPricingEnabled?: InputMaybe<BooleanComparisonExp>;
  pausedAt?: InputMaybe<TimestamptzComparisonExp>;
  promoCode?: InputMaybe<StringComparisonExp>;
  providerApiKeyEncrypted?: InputMaybe<StringComparisonExp>;
  readVerifiedAt?: InputMaybe<TimestamptzComparisonExp>;
  referralFeeCents?: InputMaybe<IntComparisonExp>;
  referralFeeEnabled?: InputMaybe<BooleanComparisonExp>;
  rules?: InputMaybe<VenueBookingRulesBoolExp>;
  rulesAggregate?: InputMaybe<VenueBookingRulesAggregateBoolExp>;
  status?: InputMaybe<BookingIntegrationStatusesEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  venue?: InputMaybe<VenuesBoolExp>;
  venueId?: InputMaybe<UuidComparisonExp>;
  verifiedAt?: InputMaybe<TimestamptzComparisonExp>;
  verifiedBy?: InputMaybe<UuidComparisonExp>;
  verifiedByUser?: InputMaybe<UsersBoolExp>;
  windows?: InputMaybe<VenueBookingWindowsBoolExp>;
  windowsAggregate?: InputMaybe<VenueBookingWindowsAggregateBoolExp>;
};

/** unique or primary key constraints on table "venue_booking_integrations" */
export enum VenueBookingIntegrationsConstraint {
  /** unique or primary key constraint on columns "id" */
  VenueBookingIntegrationsPkey = 'venue_booking_integrations_pkey',
  /** unique or primary key constraint on columns "venue_id" */
  VenueBookingIntegrationsVenueIdKey = 'venue_booking_integrations_venue_id_key'
}

/** input type for incrementing numeric columns in table "venue_booking_integrations" */
export type VenueBookingIntegrationsIncInput = {
  currentVersion?: InputMaybe<Scalars['Int']>;
  maxAdvanceBookingDays?: InputMaybe<Scalars['Int']>;
  referralFeeCents?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "venue_booking_integrations" */
export type VenueBookingIntegrationsInsertInput = {
  accountAddedConfirmedAt?: InputMaybe<Scalars['timestamptz']>;
  accountAddedConfirmedBy?: InputMaybe<Scalars['uuid']>;
  accountAddedConfirmedByUser?: InputMaybe<UsersObjRelInsertInput>;
  activatedAt?: InputMaybe<Scalars['timestamptz']>;
  bookingAccountEmail?: InputMaybe<Scalars['String']>;
  bookingSystem?: InputMaybe<BookingSystemsEnum>;
  configVersions?: InputMaybe<VenueBookingConfigVersionsArrRelInsertInput>;
  confirmationNote?: InputMaybe<Scalars['String']>;
  connectionChecks?: InputMaybe<VenueBookingConnectionChecksArrRelInsertInput>;
  connectionStatus?: InputMaybe<BookingConnectionStatusesEnum>;
  courtRates?: InputMaybe<VenueBookingCourtRatesArrRelInsertInput>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currentVersion?: InputMaybe<Scalars['Int']>;
  externalOrgId?: InputMaybe<Scalars['String']>;
  helpRequestedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  isPreferredPartner?: InputMaybe<Scalars['Boolean']>;
  maxAdvanceBookingDays?: InputMaybe<Scalars['Int']>;
  partnerPricingEnabled?: InputMaybe<Scalars['Boolean']>;
  pausedAt?: InputMaybe<Scalars['timestamptz']>;
  promoCode?: InputMaybe<Scalars['String']>;
  providerApiKeyEncrypted?: InputMaybe<Scalars['String']>;
  readVerifiedAt?: InputMaybe<Scalars['timestamptz']>;
  referralFeeCents?: InputMaybe<Scalars['Int']>;
  referralFeeEnabled?: InputMaybe<Scalars['Boolean']>;
  rules?: InputMaybe<VenueBookingRulesArrRelInsertInput>;
  status?: InputMaybe<BookingIntegrationStatusesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  venue?: InputMaybe<VenuesObjRelInsertInput>;
  venueId?: InputMaybe<Scalars['uuid']>;
  verifiedAt?: InputMaybe<Scalars['timestamptz']>;
  verifiedBy?: InputMaybe<Scalars['uuid']>;
  verifiedByUser?: InputMaybe<UsersObjRelInsertInput>;
  windows?: InputMaybe<VenueBookingWindowsArrRelInsertInput>;
};

/** aggregate max on columns */
export type VenueBookingIntegrationsMaxFields = {
  __typename?: 'VenueBookingIntegrationsMaxFields';
  accountAddedConfirmedAt?: Maybe<Scalars['timestamptz']>;
  accountAddedConfirmedBy?: Maybe<Scalars['uuid']>;
  activatedAt?: Maybe<Scalars['timestamptz']>;
  bookingAccountEmail?: Maybe<Scalars['String']>;
  confirmationNote?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currentVersion?: Maybe<Scalars['Int']>;
  externalOrgId?: Maybe<Scalars['String']>;
  helpRequestedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  maxAdvanceBookingDays?: Maybe<Scalars['Int']>;
  pausedAt?: Maybe<Scalars['timestamptz']>;
  promoCode?: Maybe<Scalars['String']>;
  providerApiKeyEncrypted?: Maybe<Scalars['String']>;
  readVerifiedAt?: Maybe<Scalars['timestamptz']>;
  referralFeeCents?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  venueId?: Maybe<Scalars['uuid']>;
  verifiedAt?: Maybe<Scalars['timestamptz']>;
  verifiedBy?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type VenueBookingIntegrationsMinFields = {
  __typename?: 'VenueBookingIntegrationsMinFields';
  accountAddedConfirmedAt?: Maybe<Scalars['timestamptz']>;
  accountAddedConfirmedBy?: Maybe<Scalars['uuid']>;
  activatedAt?: Maybe<Scalars['timestamptz']>;
  bookingAccountEmail?: Maybe<Scalars['String']>;
  confirmationNote?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currentVersion?: Maybe<Scalars['Int']>;
  externalOrgId?: Maybe<Scalars['String']>;
  helpRequestedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  maxAdvanceBookingDays?: Maybe<Scalars['Int']>;
  pausedAt?: Maybe<Scalars['timestamptz']>;
  promoCode?: Maybe<Scalars['String']>;
  providerApiKeyEncrypted?: Maybe<Scalars['String']>;
  readVerifiedAt?: Maybe<Scalars['timestamptz']>;
  referralFeeCents?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  venueId?: Maybe<Scalars['uuid']>;
  verifiedAt?: Maybe<Scalars['timestamptz']>;
  verifiedBy?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "venue_booking_integrations" */
export type VenueBookingIntegrationsMutationResponse = {
  __typename?: 'VenueBookingIntegrationsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<VenueBookingIntegrations>;
};

/** input type for inserting object relation for remote table "venue_booking_integrations" */
export type VenueBookingIntegrationsObjRelInsertInput = {
  data: VenueBookingIntegrationsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<VenueBookingIntegrationsOnConflict>;
};

/** on_conflict condition type for table "venue_booking_integrations" */
export type VenueBookingIntegrationsOnConflict = {
  constraint: VenueBookingIntegrationsConstraint;
  updateColumns?: Array<VenueBookingIntegrationsUpdateColumn>;
  where?: InputMaybe<VenueBookingIntegrationsBoolExp>;
};

/** Ordering options when selecting data from "venue_booking_integrations". */
export type VenueBookingIntegrationsOrderBy = {
  accountAddedConfirmedAt?: InputMaybe<OrderBy>;
  accountAddedConfirmedBy?: InputMaybe<OrderBy>;
  accountAddedConfirmedByUser?: InputMaybe<UsersOrderBy>;
  activatedAt?: InputMaybe<OrderBy>;
  bookingAccountEmail?: InputMaybe<OrderBy>;
  bookingSystem?: InputMaybe<OrderBy>;
  configVersionsAggregate?: InputMaybe<VenueBookingConfigVersionsAggregateOrderBy>;
  confirmationNote?: InputMaybe<OrderBy>;
  connectionChecksAggregate?: InputMaybe<VenueBookingConnectionChecksAggregateOrderBy>;
  connectionStatus?: InputMaybe<OrderBy>;
  courtRatesAggregate?: InputMaybe<VenueBookingCourtRatesAggregateOrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  currentVersion?: InputMaybe<OrderBy>;
  externalOrgId?: InputMaybe<OrderBy>;
  helpRequestedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  isPreferredPartner?: InputMaybe<OrderBy>;
  maxAdvanceBookingDays?: InputMaybe<OrderBy>;
  partnerPricingEnabled?: InputMaybe<OrderBy>;
  pausedAt?: InputMaybe<OrderBy>;
  promoCode?: InputMaybe<OrderBy>;
  providerApiKeyEncrypted?: InputMaybe<OrderBy>;
  readVerifiedAt?: InputMaybe<OrderBy>;
  referralFeeCents?: InputMaybe<OrderBy>;
  referralFeeEnabled?: InputMaybe<OrderBy>;
  rulesAggregate?: InputMaybe<VenueBookingRulesAggregateOrderBy>;
  status?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  venue?: InputMaybe<VenuesOrderBy>;
  venueId?: InputMaybe<OrderBy>;
  verifiedAt?: InputMaybe<OrderBy>;
  verifiedBy?: InputMaybe<OrderBy>;
  verifiedByUser?: InputMaybe<UsersOrderBy>;
  windowsAggregate?: InputMaybe<VenueBookingWindowsAggregateOrderBy>;
};

/** primary key columns input for table: venue_booking_integrations */
export type VenueBookingIntegrationsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "venue_booking_integrations" */
export enum VenueBookingIntegrationsSelectColumn {
  /** column name */
  AccountAddedConfirmedAt = 'accountAddedConfirmedAt',
  /** column name */
  AccountAddedConfirmedBy = 'accountAddedConfirmedBy',
  /** column name */
  ActivatedAt = 'activatedAt',
  /** column name */
  BookingAccountEmail = 'bookingAccountEmail',
  /** column name */
  BookingSystem = 'bookingSystem',
  /** column name */
  ConfirmationNote = 'confirmationNote',
  /** column name */
  ConnectionStatus = 'connectionStatus',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CurrentVersion = 'currentVersion',
  /** column name */
  ExternalOrgId = 'externalOrgId',
  /** column name */
  HelpRequestedAt = 'helpRequestedAt',
  /** column name */
  Id = 'id',
  /** column name */
  IsPreferredPartner = 'isPreferredPartner',
  /** column name */
  MaxAdvanceBookingDays = 'maxAdvanceBookingDays',
  /** column name */
  PartnerPricingEnabled = 'partnerPricingEnabled',
  /** column name */
  PausedAt = 'pausedAt',
  /** column name */
  PromoCode = 'promoCode',
  /** column name */
  ProviderApiKeyEncrypted = 'providerApiKeyEncrypted',
  /** column name */
  ReadVerifiedAt = 'readVerifiedAt',
  /** column name */
  ReferralFeeCents = 'referralFeeCents',
  /** column name */
  ReferralFeeEnabled = 'referralFeeEnabled',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  VenueId = 'venueId',
  /** column name */
  VerifiedAt = 'verifiedAt',
  /** column name */
  VerifiedBy = 'verifiedBy'
}

/** input type for updating data in table "venue_booking_integrations" */
export type VenueBookingIntegrationsSetInput = {
  accountAddedConfirmedAt?: InputMaybe<Scalars['timestamptz']>;
  accountAddedConfirmedBy?: InputMaybe<Scalars['uuid']>;
  activatedAt?: InputMaybe<Scalars['timestamptz']>;
  bookingAccountEmail?: InputMaybe<Scalars['String']>;
  bookingSystem?: InputMaybe<BookingSystemsEnum>;
  confirmationNote?: InputMaybe<Scalars['String']>;
  connectionStatus?: InputMaybe<BookingConnectionStatusesEnum>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currentVersion?: InputMaybe<Scalars['Int']>;
  externalOrgId?: InputMaybe<Scalars['String']>;
  helpRequestedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  isPreferredPartner?: InputMaybe<Scalars['Boolean']>;
  maxAdvanceBookingDays?: InputMaybe<Scalars['Int']>;
  partnerPricingEnabled?: InputMaybe<Scalars['Boolean']>;
  pausedAt?: InputMaybe<Scalars['timestamptz']>;
  promoCode?: InputMaybe<Scalars['String']>;
  providerApiKeyEncrypted?: InputMaybe<Scalars['String']>;
  readVerifiedAt?: InputMaybe<Scalars['timestamptz']>;
  referralFeeCents?: InputMaybe<Scalars['Int']>;
  referralFeeEnabled?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<BookingIntegrationStatusesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  venueId?: InputMaybe<Scalars['uuid']>;
  verifiedAt?: InputMaybe<Scalars['timestamptz']>;
  verifiedBy?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type VenueBookingIntegrationsStddevFields = {
  __typename?: 'VenueBookingIntegrationsStddevFields';
  currentVersion?: Maybe<Scalars['Float']>;
  maxAdvanceBookingDays?: Maybe<Scalars['Float']>;
  referralFeeCents?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type VenueBookingIntegrationsStddevPopFields = {
  __typename?: 'VenueBookingIntegrationsStddevPopFields';
  currentVersion?: Maybe<Scalars['Float']>;
  maxAdvanceBookingDays?: Maybe<Scalars['Float']>;
  referralFeeCents?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type VenueBookingIntegrationsStddevSampFields = {
  __typename?: 'VenueBookingIntegrationsStddevSampFields';
  currentVersion?: Maybe<Scalars['Float']>;
  maxAdvanceBookingDays?: Maybe<Scalars['Float']>;
  referralFeeCents?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "venue_booking_integrations" */
export type VenueBookingIntegrationsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: VenueBookingIntegrationsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type VenueBookingIntegrationsStreamCursorValueInput = {
  accountAddedConfirmedAt?: InputMaybe<Scalars['timestamptz']>;
  accountAddedConfirmedBy?: InputMaybe<Scalars['uuid']>;
  activatedAt?: InputMaybe<Scalars['timestamptz']>;
  bookingAccountEmail?: InputMaybe<Scalars['String']>;
  bookingSystem?: InputMaybe<BookingSystemsEnum>;
  confirmationNote?: InputMaybe<Scalars['String']>;
  connectionStatus?: InputMaybe<BookingConnectionStatusesEnum>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currentVersion?: InputMaybe<Scalars['Int']>;
  externalOrgId?: InputMaybe<Scalars['String']>;
  helpRequestedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  isPreferredPartner?: InputMaybe<Scalars['Boolean']>;
  maxAdvanceBookingDays?: InputMaybe<Scalars['Int']>;
  partnerPricingEnabled?: InputMaybe<Scalars['Boolean']>;
  pausedAt?: InputMaybe<Scalars['timestamptz']>;
  promoCode?: InputMaybe<Scalars['String']>;
  providerApiKeyEncrypted?: InputMaybe<Scalars['String']>;
  readVerifiedAt?: InputMaybe<Scalars['timestamptz']>;
  referralFeeCents?: InputMaybe<Scalars['Int']>;
  referralFeeEnabled?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<BookingIntegrationStatusesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  venueId?: InputMaybe<Scalars['uuid']>;
  verifiedAt?: InputMaybe<Scalars['timestamptz']>;
  verifiedBy?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type VenueBookingIntegrationsSumFields = {
  __typename?: 'VenueBookingIntegrationsSumFields';
  currentVersion?: Maybe<Scalars['Int']>;
  maxAdvanceBookingDays?: Maybe<Scalars['Int']>;
  referralFeeCents?: Maybe<Scalars['Int']>;
};

/** update columns of table "venue_booking_integrations" */
export enum VenueBookingIntegrationsUpdateColumn {
  /** column name */
  AccountAddedConfirmedAt = 'accountAddedConfirmedAt',
  /** column name */
  AccountAddedConfirmedBy = 'accountAddedConfirmedBy',
  /** column name */
  ActivatedAt = 'activatedAt',
  /** column name */
  BookingAccountEmail = 'bookingAccountEmail',
  /** column name */
  BookingSystem = 'bookingSystem',
  /** column name */
  ConfirmationNote = 'confirmationNote',
  /** column name */
  ConnectionStatus = 'connectionStatus',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CurrentVersion = 'currentVersion',
  /** column name */
  ExternalOrgId = 'externalOrgId',
  /** column name */
  HelpRequestedAt = 'helpRequestedAt',
  /** column name */
  Id = 'id',
  /** column name */
  IsPreferredPartner = 'isPreferredPartner',
  /** column name */
  MaxAdvanceBookingDays = 'maxAdvanceBookingDays',
  /** column name */
  PartnerPricingEnabled = 'partnerPricingEnabled',
  /** column name */
  PausedAt = 'pausedAt',
  /** column name */
  PromoCode = 'promoCode',
  /** column name */
  ProviderApiKeyEncrypted = 'providerApiKeyEncrypted',
  /** column name */
  ReadVerifiedAt = 'readVerifiedAt',
  /** column name */
  ReferralFeeCents = 'referralFeeCents',
  /** column name */
  ReferralFeeEnabled = 'referralFeeEnabled',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  VenueId = 'venueId',
  /** column name */
  VerifiedAt = 'verifiedAt',
  /** column name */
  VerifiedBy = 'verifiedBy'
}

export type VenueBookingIntegrationsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<VenueBookingIntegrationsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<VenueBookingIntegrationsSetInput>;
  /** filter the rows which have to be updated */
  where: VenueBookingIntegrationsBoolExp;
};

/** aggregate varPop on columns */
export type VenueBookingIntegrationsVarPopFields = {
  __typename?: 'VenueBookingIntegrationsVarPopFields';
  currentVersion?: Maybe<Scalars['Float']>;
  maxAdvanceBookingDays?: Maybe<Scalars['Float']>;
  referralFeeCents?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type VenueBookingIntegrationsVarSampFields = {
  __typename?: 'VenueBookingIntegrationsVarSampFields';
  currentVersion?: Maybe<Scalars['Float']>;
  maxAdvanceBookingDays?: Maybe<Scalars['Float']>;
  referralFeeCents?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type VenueBookingIntegrationsVarianceFields = {
  __typename?: 'VenueBookingIntegrationsVarianceFields';
  currentVersion?: Maybe<Scalars['Float']>;
  maxAdvanceBookingDays?: Maybe<Scalars['Float']>;
  referralFeeCents?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "venue_booking_rule_tiers" */
export type VenueBookingRuleTiers = {
  __typename?: 'VenueBookingRuleTiers';
  createdAt: Scalars['timestamptz'];
  discountPercent: Scalars['numeric'];
  id: Scalars['uuid'];
  isEnabled: Scalars['Boolean'];
  leadTimeHours: Scalars['Int'];
  /** An object relationship */
  rule: VenueBookingRules;
  ruleId: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "venue_booking_rule_tiers" */
export type VenueBookingRuleTiersAggregate = {
  __typename?: 'VenueBookingRuleTiersAggregate';
  aggregate?: Maybe<VenueBookingRuleTiersAggregateFields>;
  nodes: Array<VenueBookingRuleTiers>;
};

export type VenueBookingRuleTiersAggregateBoolExp = {
  bool_and?: InputMaybe<VenueBookingRuleTiersAggregateBoolExpBool_And>;
  bool_or?: InputMaybe<VenueBookingRuleTiersAggregateBoolExpBool_Or>;
  count?: InputMaybe<VenueBookingRuleTiersAggregateBoolExpCount>;
};

/** aggregate fields of "venue_booking_rule_tiers" */
export type VenueBookingRuleTiersAggregateFields = {
  __typename?: 'VenueBookingRuleTiersAggregateFields';
  avg?: Maybe<VenueBookingRuleTiersAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<VenueBookingRuleTiersMaxFields>;
  min?: Maybe<VenueBookingRuleTiersMinFields>;
  stddev?: Maybe<VenueBookingRuleTiersStddevFields>;
  stddevPop?: Maybe<VenueBookingRuleTiersStddevPopFields>;
  stddevSamp?: Maybe<VenueBookingRuleTiersStddevSampFields>;
  sum?: Maybe<VenueBookingRuleTiersSumFields>;
  varPop?: Maybe<VenueBookingRuleTiersVarPopFields>;
  varSamp?: Maybe<VenueBookingRuleTiersVarSampFields>;
  variance?: Maybe<VenueBookingRuleTiersVarianceFields>;
};


/** aggregate fields of "venue_booking_rule_tiers" */
export type VenueBookingRuleTiersAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<VenueBookingRuleTiersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "venue_booking_rule_tiers" */
export type VenueBookingRuleTiersAggregateOrderBy = {
  avg?: InputMaybe<VenueBookingRuleTiersAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<VenueBookingRuleTiersMaxOrderBy>;
  min?: InputMaybe<VenueBookingRuleTiersMinOrderBy>;
  stddev?: InputMaybe<VenueBookingRuleTiersStddevOrderBy>;
  stddevPop?: InputMaybe<VenueBookingRuleTiersStddevPopOrderBy>;
  stddevSamp?: InputMaybe<VenueBookingRuleTiersStddevSampOrderBy>;
  sum?: InputMaybe<VenueBookingRuleTiersSumOrderBy>;
  varPop?: InputMaybe<VenueBookingRuleTiersVarPopOrderBy>;
  varSamp?: InputMaybe<VenueBookingRuleTiersVarSampOrderBy>;
  variance?: InputMaybe<VenueBookingRuleTiersVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "venue_booking_rule_tiers" */
export type VenueBookingRuleTiersArrRelInsertInput = {
  data: Array<VenueBookingRuleTiersInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<VenueBookingRuleTiersOnConflict>;
};

/** aggregate avg on columns */
export type VenueBookingRuleTiersAvgFields = {
  __typename?: 'VenueBookingRuleTiersAvgFields';
  discountPercent?: Maybe<Scalars['Float']>;
  leadTimeHours?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "venue_booking_rule_tiers" */
export type VenueBookingRuleTiersAvgOrderBy = {
  discountPercent?: InputMaybe<OrderBy>;
  leadTimeHours?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "venue_booking_rule_tiers". All fields are combined with a logical 'AND'. */
export type VenueBookingRuleTiersBoolExp = {
  _and?: InputMaybe<Array<VenueBookingRuleTiersBoolExp>>;
  _not?: InputMaybe<VenueBookingRuleTiersBoolExp>;
  _or?: InputMaybe<Array<VenueBookingRuleTiersBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  discountPercent?: InputMaybe<NumericComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isEnabled?: InputMaybe<BooleanComparisonExp>;
  leadTimeHours?: InputMaybe<IntComparisonExp>;
  rule?: InputMaybe<VenueBookingRulesBoolExp>;
  ruleId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "venue_booking_rule_tiers" */
export enum VenueBookingRuleTiersConstraint {
  /** unique or primary key constraint on columns "id" */
  VenueBookingRuleTiersPkey = 'venue_booking_rule_tiers_pkey',
  /** unique or primary key constraint on columns "rule_id", "lead_time_hours" */
  VenueBookingRuleTiersRuleIdLeadTimeHoursKey = 'venue_booking_rule_tiers_rule_id_lead_time_hours_key'
}

/** input type for incrementing numeric columns in table "venue_booking_rule_tiers" */
export type VenueBookingRuleTiersIncInput = {
  discountPercent?: InputMaybe<Scalars['numeric']>;
  leadTimeHours?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "venue_booking_rule_tiers" */
export type VenueBookingRuleTiersInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  discountPercent?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  isEnabled?: InputMaybe<Scalars['Boolean']>;
  leadTimeHours?: InputMaybe<Scalars['Int']>;
  rule?: InputMaybe<VenueBookingRulesObjRelInsertInput>;
  ruleId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type VenueBookingRuleTiersMaxFields = {
  __typename?: 'VenueBookingRuleTiersMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  discountPercent?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  leadTimeHours?: Maybe<Scalars['Int']>;
  ruleId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "venue_booking_rule_tiers" */
export type VenueBookingRuleTiersMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  discountPercent?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  leadTimeHours?: InputMaybe<OrderBy>;
  ruleId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type VenueBookingRuleTiersMinFields = {
  __typename?: 'VenueBookingRuleTiersMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  discountPercent?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  leadTimeHours?: Maybe<Scalars['Int']>;
  ruleId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "venue_booking_rule_tiers" */
export type VenueBookingRuleTiersMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  discountPercent?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  leadTimeHours?: InputMaybe<OrderBy>;
  ruleId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "venue_booking_rule_tiers" */
export type VenueBookingRuleTiersMutationResponse = {
  __typename?: 'VenueBookingRuleTiersMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<VenueBookingRuleTiers>;
};

/** on_conflict condition type for table "venue_booking_rule_tiers" */
export type VenueBookingRuleTiersOnConflict = {
  constraint: VenueBookingRuleTiersConstraint;
  updateColumns?: Array<VenueBookingRuleTiersUpdateColumn>;
  where?: InputMaybe<VenueBookingRuleTiersBoolExp>;
};

/** Ordering options when selecting data from "venue_booking_rule_tiers". */
export type VenueBookingRuleTiersOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  discountPercent?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  isEnabled?: InputMaybe<OrderBy>;
  leadTimeHours?: InputMaybe<OrderBy>;
  rule?: InputMaybe<VenueBookingRulesOrderBy>;
  ruleId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: venue_booking_rule_tiers */
export type VenueBookingRuleTiersPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "venue_booking_rule_tiers" */
export enum VenueBookingRuleTiersSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DiscountPercent = 'discountPercent',
  /** column name */
  Id = 'id',
  /** column name */
  IsEnabled = 'isEnabled',
  /** column name */
  LeadTimeHours = 'leadTimeHours',
  /** column name */
  RuleId = 'ruleId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** select "venueBookingRuleTiersAggregateBoolExpBool_andArgumentsColumns" columns of table "venue_booking_rule_tiers" */
export enum VenueBookingRuleTiersSelectColumnVenueBookingRuleTiersAggregateBoolExpBool_AndArgumentsColumns {
  /** column name */
  IsEnabled = 'isEnabled'
}

/** select "venueBookingRuleTiersAggregateBoolExpBool_orArgumentsColumns" columns of table "venue_booking_rule_tiers" */
export enum VenueBookingRuleTiersSelectColumnVenueBookingRuleTiersAggregateBoolExpBool_OrArgumentsColumns {
  /** column name */
  IsEnabled = 'isEnabled'
}

/** input type for updating data in table "venue_booking_rule_tiers" */
export type VenueBookingRuleTiersSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  discountPercent?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  isEnabled?: InputMaybe<Scalars['Boolean']>;
  leadTimeHours?: InputMaybe<Scalars['Int']>;
  ruleId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type VenueBookingRuleTiersStddevFields = {
  __typename?: 'VenueBookingRuleTiersStddevFields';
  discountPercent?: Maybe<Scalars['Float']>;
  leadTimeHours?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "venue_booking_rule_tiers" */
export type VenueBookingRuleTiersStddevOrderBy = {
  discountPercent?: InputMaybe<OrderBy>;
  leadTimeHours?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type VenueBookingRuleTiersStddevPopFields = {
  __typename?: 'VenueBookingRuleTiersStddevPopFields';
  discountPercent?: Maybe<Scalars['Float']>;
  leadTimeHours?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "venue_booking_rule_tiers" */
export type VenueBookingRuleTiersStddevPopOrderBy = {
  discountPercent?: InputMaybe<OrderBy>;
  leadTimeHours?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type VenueBookingRuleTiersStddevSampFields = {
  __typename?: 'VenueBookingRuleTiersStddevSampFields';
  discountPercent?: Maybe<Scalars['Float']>;
  leadTimeHours?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "venue_booking_rule_tiers" */
export type VenueBookingRuleTiersStddevSampOrderBy = {
  discountPercent?: InputMaybe<OrderBy>;
  leadTimeHours?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "venue_booking_rule_tiers" */
export type VenueBookingRuleTiersStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: VenueBookingRuleTiersStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type VenueBookingRuleTiersStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  discountPercent?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  isEnabled?: InputMaybe<Scalars['Boolean']>;
  leadTimeHours?: InputMaybe<Scalars['Int']>;
  ruleId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type VenueBookingRuleTiersSumFields = {
  __typename?: 'VenueBookingRuleTiersSumFields';
  discountPercent?: Maybe<Scalars['numeric']>;
  leadTimeHours?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "venue_booking_rule_tiers" */
export type VenueBookingRuleTiersSumOrderBy = {
  discountPercent?: InputMaybe<OrderBy>;
  leadTimeHours?: InputMaybe<OrderBy>;
};

/** update columns of table "venue_booking_rule_tiers" */
export enum VenueBookingRuleTiersUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DiscountPercent = 'discountPercent',
  /** column name */
  Id = 'id',
  /** column name */
  IsEnabled = 'isEnabled',
  /** column name */
  LeadTimeHours = 'leadTimeHours',
  /** column name */
  RuleId = 'ruleId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type VenueBookingRuleTiersUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<VenueBookingRuleTiersIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<VenueBookingRuleTiersSetInput>;
  /** filter the rows which have to be updated */
  where: VenueBookingRuleTiersBoolExp;
};

/** aggregate varPop on columns */
export type VenueBookingRuleTiersVarPopFields = {
  __typename?: 'VenueBookingRuleTiersVarPopFields';
  discountPercent?: Maybe<Scalars['Float']>;
  leadTimeHours?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "venue_booking_rule_tiers" */
export type VenueBookingRuleTiersVarPopOrderBy = {
  discountPercent?: InputMaybe<OrderBy>;
  leadTimeHours?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type VenueBookingRuleTiersVarSampFields = {
  __typename?: 'VenueBookingRuleTiersVarSampFields';
  discountPercent?: Maybe<Scalars['Float']>;
  leadTimeHours?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "venue_booking_rule_tiers" */
export type VenueBookingRuleTiersVarSampOrderBy = {
  discountPercent?: InputMaybe<OrderBy>;
  leadTimeHours?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type VenueBookingRuleTiersVarianceFields = {
  __typename?: 'VenueBookingRuleTiersVarianceFields';
  discountPercent?: Maybe<Scalars['Float']>;
  leadTimeHours?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "venue_booking_rule_tiers" */
export type VenueBookingRuleTiersVarianceOrderBy = {
  discountPercent?: InputMaybe<OrderBy>;
  leadTimeHours?: InputMaybe<OrderBy>;
};

/** columns and relationships of "venue_booking_rules" */
export type VenueBookingRules = {
  __typename?: 'VenueBookingRules';
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  integration: VenueBookingIntegrations;
  integrationId: Scalars['uuid'];
  inventoryType: BookingInventoryTypesEnum;
  isCustomPricing: Scalars['Boolean'];
  scheduleMode: BookingScheduleModesEnum;
  /** An array relationship */
  tiers: Array<VenueBookingRuleTiers>;
  /** An aggregate relationship */
  tiersAggregate: VenueBookingRuleTiersAggregate;
  updatedAt: Scalars['timestamptz'];
  /** An array relationship */
  windows: Array<VenueBookingWindows>;
  /** An aggregate relationship */
  windowsAggregate: VenueBookingWindowsAggregate;
};


/** columns and relationships of "venue_booking_rules" */
export type VenueBookingRulesTiersArgs = {
  distinctOn?: InputMaybe<Array<VenueBookingRuleTiersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueBookingRuleTiersOrderBy>>;
  where?: InputMaybe<VenueBookingRuleTiersBoolExp>;
};


/** columns and relationships of "venue_booking_rules" */
export type VenueBookingRulesTiersAggregateArgs = {
  distinctOn?: InputMaybe<Array<VenueBookingRuleTiersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueBookingRuleTiersOrderBy>>;
  where?: InputMaybe<VenueBookingRuleTiersBoolExp>;
};


/** columns and relationships of "venue_booking_rules" */
export type VenueBookingRulesWindowsArgs = {
  distinctOn?: InputMaybe<Array<VenueBookingWindowsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueBookingWindowsOrderBy>>;
  where?: InputMaybe<VenueBookingWindowsBoolExp>;
};


/** columns and relationships of "venue_booking_rules" */
export type VenueBookingRulesWindowsAggregateArgs = {
  distinctOn?: InputMaybe<Array<VenueBookingWindowsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueBookingWindowsOrderBy>>;
  where?: InputMaybe<VenueBookingWindowsBoolExp>;
};

/** aggregated selection of "venue_booking_rules" */
export type VenueBookingRulesAggregate = {
  __typename?: 'VenueBookingRulesAggregate';
  aggregate?: Maybe<VenueBookingRulesAggregateFields>;
  nodes: Array<VenueBookingRules>;
};

export type VenueBookingRulesAggregateBoolExp = {
  bool_and?: InputMaybe<VenueBookingRulesAggregateBoolExpBool_And>;
  bool_or?: InputMaybe<VenueBookingRulesAggregateBoolExpBool_Or>;
  count?: InputMaybe<VenueBookingRulesAggregateBoolExpCount>;
};

/** aggregate fields of "venue_booking_rules" */
export type VenueBookingRulesAggregateFields = {
  __typename?: 'VenueBookingRulesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<VenueBookingRulesMaxFields>;
  min?: Maybe<VenueBookingRulesMinFields>;
};


/** aggregate fields of "venue_booking_rules" */
export type VenueBookingRulesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<VenueBookingRulesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "venue_booking_rules" */
export type VenueBookingRulesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<VenueBookingRulesMaxOrderBy>;
  min?: InputMaybe<VenueBookingRulesMinOrderBy>;
};

/** input type for inserting array relation for remote table "venue_booking_rules" */
export type VenueBookingRulesArrRelInsertInput = {
  data: Array<VenueBookingRulesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<VenueBookingRulesOnConflict>;
};

/** Boolean expression to filter rows from the table "venue_booking_rules". All fields are combined with a logical 'AND'. */
export type VenueBookingRulesBoolExp = {
  _and?: InputMaybe<Array<VenueBookingRulesBoolExp>>;
  _not?: InputMaybe<VenueBookingRulesBoolExp>;
  _or?: InputMaybe<Array<VenueBookingRulesBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  integration?: InputMaybe<VenueBookingIntegrationsBoolExp>;
  integrationId?: InputMaybe<UuidComparisonExp>;
  inventoryType?: InputMaybe<BookingInventoryTypesEnumComparisonExp>;
  isCustomPricing?: InputMaybe<BooleanComparisonExp>;
  scheduleMode?: InputMaybe<BookingScheduleModesEnumComparisonExp>;
  tiers?: InputMaybe<VenueBookingRuleTiersBoolExp>;
  tiersAggregate?: InputMaybe<VenueBookingRuleTiersAggregateBoolExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  windows?: InputMaybe<VenueBookingWindowsBoolExp>;
  windowsAggregate?: InputMaybe<VenueBookingWindowsAggregateBoolExp>;
};

/** unique or primary key constraints on table "venue_booking_rules" */
export enum VenueBookingRulesConstraint {
  /** unique or primary key constraint on columns "inventory_type", "integration_id" */
  VenueBookingRulesIntegrationIdInventoryTypeKey = 'venue_booking_rules_integration_id_inventory_type_key',
  /** unique or primary key constraint on columns "id" */
  VenueBookingRulesPkey = 'venue_booking_rules_pkey'
}

/** input type for inserting data into table "venue_booking_rules" */
export type VenueBookingRulesInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  integration?: InputMaybe<VenueBookingIntegrationsObjRelInsertInput>;
  integrationId?: InputMaybe<Scalars['uuid']>;
  inventoryType?: InputMaybe<BookingInventoryTypesEnum>;
  isCustomPricing?: InputMaybe<Scalars['Boolean']>;
  scheduleMode?: InputMaybe<BookingScheduleModesEnum>;
  tiers?: InputMaybe<VenueBookingRuleTiersArrRelInsertInput>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  windows?: InputMaybe<VenueBookingWindowsArrRelInsertInput>;
};

/** aggregate max on columns */
export type VenueBookingRulesMaxFields = {
  __typename?: 'VenueBookingRulesMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  integrationId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "venue_booking_rules" */
export type VenueBookingRulesMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  integrationId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type VenueBookingRulesMinFields = {
  __typename?: 'VenueBookingRulesMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  integrationId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "venue_booking_rules" */
export type VenueBookingRulesMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  integrationId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "venue_booking_rules" */
export type VenueBookingRulesMutationResponse = {
  __typename?: 'VenueBookingRulesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<VenueBookingRules>;
};

/** input type for inserting object relation for remote table "venue_booking_rules" */
export type VenueBookingRulesObjRelInsertInput = {
  data: VenueBookingRulesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<VenueBookingRulesOnConflict>;
};

/** on_conflict condition type for table "venue_booking_rules" */
export type VenueBookingRulesOnConflict = {
  constraint: VenueBookingRulesConstraint;
  updateColumns?: Array<VenueBookingRulesUpdateColumn>;
  where?: InputMaybe<VenueBookingRulesBoolExp>;
};

/** Ordering options when selecting data from "venue_booking_rules". */
export type VenueBookingRulesOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  integration?: InputMaybe<VenueBookingIntegrationsOrderBy>;
  integrationId?: InputMaybe<OrderBy>;
  inventoryType?: InputMaybe<OrderBy>;
  isCustomPricing?: InputMaybe<OrderBy>;
  scheduleMode?: InputMaybe<OrderBy>;
  tiersAggregate?: InputMaybe<VenueBookingRuleTiersAggregateOrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  windowsAggregate?: InputMaybe<VenueBookingWindowsAggregateOrderBy>;
};

/** primary key columns input for table: venue_booking_rules */
export type VenueBookingRulesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "venue_booking_rules" */
export enum VenueBookingRulesSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  IntegrationId = 'integrationId',
  /** column name */
  InventoryType = 'inventoryType',
  /** column name */
  IsCustomPricing = 'isCustomPricing',
  /** column name */
  ScheduleMode = 'scheduleMode',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** select "venueBookingRulesAggregateBoolExpBool_andArgumentsColumns" columns of table "venue_booking_rules" */
export enum VenueBookingRulesSelectColumnVenueBookingRulesAggregateBoolExpBool_AndArgumentsColumns {
  /** column name */
  IsCustomPricing = 'isCustomPricing'
}

/** select "venueBookingRulesAggregateBoolExpBool_orArgumentsColumns" columns of table "venue_booking_rules" */
export enum VenueBookingRulesSelectColumnVenueBookingRulesAggregateBoolExpBool_OrArgumentsColumns {
  /** column name */
  IsCustomPricing = 'isCustomPricing'
}

/** input type for updating data in table "venue_booking_rules" */
export type VenueBookingRulesSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  integrationId?: InputMaybe<Scalars['uuid']>;
  inventoryType?: InputMaybe<BookingInventoryTypesEnum>;
  isCustomPricing?: InputMaybe<Scalars['Boolean']>;
  scheduleMode?: InputMaybe<BookingScheduleModesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "venue_booking_rules" */
export type VenueBookingRulesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: VenueBookingRulesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type VenueBookingRulesStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  integrationId?: InputMaybe<Scalars['uuid']>;
  inventoryType?: InputMaybe<BookingInventoryTypesEnum>;
  isCustomPricing?: InputMaybe<Scalars['Boolean']>;
  scheduleMode?: InputMaybe<BookingScheduleModesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "venue_booking_rules" */
export enum VenueBookingRulesUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  IntegrationId = 'integrationId',
  /** column name */
  InventoryType = 'inventoryType',
  /** column name */
  IsCustomPricing = 'isCustomPricing',
  /** column name */
  ScheduleMode = 'scheduleMode',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type VenueBookingRulesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<VenueBookingRulesSetInput>;
  /** filter the rows which have to be updated */
  where: VenueBookingRulesBoolExp;
};

/** columns and relationships of "venue_booking_windows" */
export type VenueBookingWindows = {
  __typename?: 'VenueBookingWindows';
  createdAt: Scalars['timestamptz'];
  dayOfWeek: DayOfWeekEnum;
  endTime: Scalars['time'];
  id: Scalars['uuid'];
  /** An object relationship */
  integration: VenueBookingIntegrations;
  integrationId: Scalars['uuid'];
  inventoryType?: Maybe<BookingInventoryTypesEnum>;
  kind: BookingWindowKindsEnum;
  sport?: Maybe<SportsEnum>;
  startTime: Scalars['time'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "venue_booking_windows" */
export type VenueBookingWindowsAggregate = {
  __typename?: 'VenueBookingWindowsAggregate';
  aggregate?: Maybe<VenueBookingWindowsAggregateFields>;
  nodes: Array<VenueBookingWindows>;
};

export type VenueBookingWindowsAggregateBoolExp = {
  count?: InputMaybe<VenueBookingWindowsAggregateBoolExpCount>;
};

/** aggregate fields of "venue_booking_windows" */
export type VenueBookingWindowsAggregateFields = {
  __typename?: 'VenueBookingWindowsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<VenueBookingWindowsMaxFields>;
  min?: Maybe<VenueBookingWindowsMinFields>;
};


/** aggregate fields of "venue_booking_windows" */
export type VenueBookingWindowsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<VenueBookingWindowsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "venue_booking_windows" */
export type VenueBookingWindowsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<VenueBookingWindowsMaxOrderBy>;
  min?: InputMaybe<VenueBookingWindowsMinOrderBy>;
};

/** input type for inserting array relation for remote table "venue_booking_windows" */
export type VenueBookingWindowsArrRelInsertInput = {
  data: Array<VenueBookingWindowsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<VenueBookingWindowsOnConflict>;
};

/** Boolean expression to filter rows from the table "venue_booking_windows". All fields are combined with a logical 'AND'. */
export type VenueBookingWindowsBoolExp = {
  _and?: InputMaybe<Array<VenueBookingWindowsBoolExp>>;
  _not?: InputMaybe<VenueBookingWindowsBoolExp>;
  _or?: InputMaybe<Array<VenueBookingWindowsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  dayOfWeek?: InputMaybe<DayOfWeekEnumComparisonExp>;
  endTime?: InputMaybe<TimeComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  integration?: InputMaybe<VenueBookingIntegrationsBoolExp>;
  integrationId?: InputMaybe<UuidComparisonExp>;
  inventoryType?: InputMaybe<BookingInventoryTypesEnumComparisonExp>;
  kind?: InputMaybe<BookingWindowKindsEnumComparisonExp>;
  sport?: InputMaybe<SportsEnumComparisonExp>;
  startTime?: InputMaybe<TimeComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "venue_booking_windows" */
export enum VenueBookingWindowsConstraint {
  /** unique or primary key constraint on columns "day_of_week", "kind", "integration_id", "end_time", "start_time" */
  VenueBookingWindowsOnePerSlot = 'venue_booking_windows_one_per_slot',
  /** unique or primary key constraint on columns "id" */
  VenueBookingWindowsPkey = 'venue_booking_windows_pkey'
}

/** input type for inserting data into table "venue_booking_windows" */
export type VenueBookingWindowsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  dayOfWeek?: InputMaybe<DayOfWeekEnum>;
  endTime?: InputMaybe<Scalars['time']>;
  id?: InputMaybe<Scalars['uuid']>;
  integration?: InputMaybe<VenueBookingIntegrationsObjRelInsertInput>;
  integrationId?: InputMaybe<Scalars['uuid']>;
  inventoryType?: InputMaybe<BookingInventoryTypesEnum>;
  kind?: InputMaybe<BookingWindowKindsEnum>;
  sport?: InputMaybe<SportsEnum>;
  startTime?: InputMaybe<Scalars['time']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type VenueBookingWindowsMaxFields = {
  __typename?: 'VenueBookingWindowsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  integrationId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "venue_booking_windows" */
export type VenueBookingWindowsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  integrationId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type VenueBookingWindowsMinFields = {
  __typename?: 'VenueBookingWindowsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  integrationId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "venue_booking_windows" */
export type VenueBookingWindowsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  integrationId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "venue_booking_windows" */
export type VenueBookingWindowsMutationResponse = {
  __typename?: 'VenueBookingWindowsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<VenueBookingWindows>;
};

/** on_conflict condition type for table "venue_booking_windows" */
export type VenueBookingWindowsOnConflict = {
  constraint: VenueBookingWindowsConstraint;
  updateColumns?: Array<VenueBookingWindowsUpdateColumn>;
  where?: InputMaybe<VenueBookingWindowsBoolExp>;
};

/** Ordering options when selecting data from "venue_booking_windows". */
export type VenueBookingWindowsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  dayOfWeek?: InputMaybe<OrderBy>;
  endTime?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  integration?: InputMaybe<VenueBookingIntegrationsOrderBy>;
  integrationId?: InputMaybe<OrderBy>;
  inventoryType?: InputMaybe<OrderBy>;
  kind?: InputMaybe<OrderBy>;
  sport?: InputMaybe<OrderBy>;
  startTime?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: venue_booking_windows */
export type VenueBookingWindowsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "venue_booking_windows" */
export enum VenueBookingWindowsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DayOfWeek = 'dayOfWeek',
  /** column name */
  EndTime = 'endTime',
  /** column name */
  Id = 'id',
  /** column name */
  IntegrationId = 'integrationId',
  /** column name */
  InventoryType = 'inventoryType',
  /** column name */
  Kind = 'kind',
  /** column name */
  Sport = 'sport',
  /** column name */
  StartTime = 'startTime',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "venue_booking_windows" */
export type VenueBookingWindowsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  dayOfWeek?: InputMaybe<DayOfWeekEnum>;
  endTime?: InputMaybe<Scalars['time']>;
  id?: InputMaybe<Scalars['uuid']>;
  integrationId?: InputMaybe<Scalars['uuid']>;
  inventoryType?: InputMaybe<BookingInventoryTypesEnum>;
  kind?: InputMaybe<BookingWindowKindsEnum>;
  sport?: InputMaybe<SportsEnum>;
  startTime?: InputMaybe<Scalars['time']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "venue_booking_windows" */
export type VenueBookingWindowsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: VenueBookingWindowsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type VenueBookingWindowsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  dayOfWeek?: InputMaybe<DayOfWeekEnum>;
  endTime?: InputMaybe<Scalars['time']>;
  id?: InputMaybe<Scalars['uuid']>;
  integrationId?: InputMaybe<Scalars['uuid']>;
  inventoryType?: InputMaybe<BookingInventoryTypesEnum>;
  kind?: InputMaybe<BookingWindowKindsEnum>;
  sport?: InputMaybe<SportsEnum>;
  startTime?: InputMaybe<Scalars['time']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "venue_booking_windows" */
export enum VenueBookingWindowsUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DayOfWeek = 'dayOfWeek',
  /** column name */
  EndTime = 'endTime',
  /** column name */
  Id = 'id',
  /** column name */
  IntegrationId = 'integrationId',
  /** column name */
  InventoryType = 'inventoryType',
  /** column name */
  Kind = 'kind',
  /** column name */
  Sport = 'sport',
  /** column name */
  StartTime = 'startTime',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type VenueBookingWindowsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<VenueBookingWindowsSetInput>;
  /** filter the rows which have to be updated */
  where: VenueBookingWindowsBoolExp;
};

/** columns and relationships of "venue_court_surfaces" */
export type VenueCourtSurfaces = {
  __typename?: 'VenueCourtSurfaces';
  courtSurface: CourtSurfacesEnum;
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  venue: Venues;
  venueId: Scalars['uuid'];
};

/** aggregated selection of "venue_court_surfaces" */
export type VenueCourtSurfacesAggregate = {
  __typename?: 'VenueCourtSurfacesAggregate';
  aggregate?: Maybe<VenueCourtSurfacesAggregateFields>;
  nodes: Array<VenueCourtSurfaces>;
};

export type VenueCourtSurfacesAggregateBoolExp = {
  count?: InputMaybe<VenueCourtSurfacesAggregateBoolExpCount>;
};

/** aggregate fields of "venue_court_surfaces" */
export type VenueCourtSurfacesAggregateFields = {
  __typename?: 'VenueCourtSurfacesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<VenueCourtSurfacesMaxFields>;
  min?: Maybe<VenueCourtSurfacesMinFields>;
};


/** aggregate fields of "venue_court_surfaces" */
export type VenueCourtSurfacesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<VenueCourtSurfacesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "venue_court_surfaces" */
export type VenueCourtSurfacesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<VenueCourtSurfacesMaxOrderBy>;
  min?: InputMaybe<VenueCourtSurfacesMinOrderBy>;
};

/** input type for inserting array relation for remote table "venue_court_surfaces" */
export type VenueCourtSurfacesArrRelInsertInput = {
  data: Array<VenueCourtSurfacesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<VenueCourtSurfacesOnConflict>;
};

/** Boolean expression to filter rows from the table "venue_court_surfaces". All fields are combined with a logical 'AND'. */
export type VenueCourtSurfacesBoolExp = {
  _and?: InputMaybe<Array<VenueCourtSurfacesBoolExp>>;
  _not?: InputMaybe<VenueCourtSurfacesBoolExp>;
  _or?: InputMaybe<Array<VenueCourtSurfacesBoolExp>>;
  courtSurface?: InputMaybe<CourtSurfacesEnumComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  venue?: InputMaybe<VenuesBoolExp>;
  venueId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "venue_court_surfaces" */
export enum VenueCourtSurfacesConstraint {
  /** unique or primary key constraint on columns "id" */
  VenueCourtSurfacesPkey = 'venue_court_surfaces_pkey',
  /** unique or primary key constraint on columns "venue_id", "court_surface" */
  VenueCourtSurfacesVenueIdCourtSurfaceKey = 'venue_court_surfaces_venue_id_court_surface_key'
}

/** input type for inserting data into table "venue_court_surfaces" */
export type VenueCourtSurfacesInsertInput = {
  courtSurface?: InputMaybe<CourtSurfacesEnum>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  venue?: InputMaybe<VenuesObjRelInsertInput>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type VenueCourtSurfacesMaxFields = {
  __typename?: 'VenueCourtSurfacesMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  venueId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "venue_court_surfaces" */
export type VenueCourtSurfacesMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type VenueCourtSurfacesMinFields = {
  __typename?: 'VenueCourtSurfacesMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  venueId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "venue_court_surfaces" */
export type VenueCourtSurfacesMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "venue_court_surfaces" */
export type VenueCourtSurfacesMutationResponse = {
  __typename?: 'VenueCourtSurfacesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<VenueCourtSurfaces>;
};

/** on_conflict condition type for table "venue_court_surfaces" */
export type VenueCourtSurfacesOnConflict = {
  constraint: VenueCourtSurfacesConstraint;
  updateColumns?: Array<VenueCourtSurfacesUpdateColumn>;
  where?: InputMaybe<VenueCourtSurfacesBoolExp>;
};

/** Ordering options when selecting data from "venue_court_surfaces". */
export type VenueCourtSurfacesOrderBy = {
  courtSurface?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  venue?: InputMaybe<VenuesOrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: venue_court_surfaces */
export type VenueCourtSurfacesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "venue_court_surfaces" */
export enum VenueCourtSurfacesSelectColumn {
  /** column name */
  CourtSurface = 'courtSurface',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  VenueId = 'venueId'
}

/** input type for updating data in table "venue_court_surfaces" */
export type VenueCourtSurfacesSetInput = {
  courtSurface?: InputMaybe<CourtSurfacesEnum>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "venue_court_surfaces" */
export type VenueCourtSurfacesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: VenueCourtSurfacesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type VenueCourtSurfacesStreamCursorValueInput = {
  courtSurface?: InputMaybe<CourtSurfacesEnum>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "venue_court_surfaces" */
export enum VenueCourtSurfacesUpdateColumn {
  /** column name */
  CourtSurface = 'courtSurface',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  VenueId = 'venueId'
}

export type VenueCourtSurfacesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<VenueCourtSurfacesSetInput>;
  /** filter the rows which have to be updated */
  where: VenueCourtSurfacesBoolExp;
};

/** columns and relationships of "venue_custom_amenities" */
export type VenueCustomAmenities = {
  __typename?: 'VenueCustomAmenities';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  name: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  venue: Venues;
  venueId: Scalars['uuid'];
};

/** aggregated selection of "venue_custom_amenities" */
export type VenueCustomAmenitiesAggregate = {
  __typename?: 'VenueCustomAmenitiesAggregate';
  aggregate?: Maybe<VenueCustomAmenitiesAggregateFields>;
  nodes: Array<VenueCustomAmenities>;
};

export type VenueCustomAmenitiesAggregateBoolExp = {
  count?: InputMaybe<VenueCustomAmenitiesAggregateBoolExpCount>;
};

/** aggregate fields of "venue_custom_amenities" */
export type VenueCustomAmenitiesAggregateFields = {
  __typename?: 'VenueCustomAmenitiesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<VenueCustomAmenitiesMaxFields>;
  min?: Maybe<VenueCustomAmenitiesMinFields>;
};


/** aggregate fields of "venue_custom_amenities" */
export type VenueCustomAmenitiesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<VenueCustomAmenitiesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "venue_custom_amenities" */
export type VenueCustomAmenitiesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<VenueCustomAmenitiesMaxOrderBy>;
  min?: InputMaybe<VenueCustomAmenitiesMinOrderBy>;
};

/** input type for inserting array relation for remote table "venue_custom_amenities" */
export type VenueCustomAmenitiesArrRelInsertInput = {
  data: Array<VenueCustomAmenitiesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<VenueCustomAmenitiesOnConflict>;
};

/** Boolean expression to filter rows from the table "venue_custom_amenities". All fields are combined with a logical 'AND'. */
export type VenueCustomAmenitiesBoolExp = {
  _and?: InputMaybe<Array<VenueCustomAmenitiesBoolExp>>;
  _not?: InputMaybe<VenueCustomAmenitiesBoolExp>;
  _or?: InputMaybe<Array<VenueCustomAmenitiesBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  venue?: InputMaybe<VenuesBoolExp>;
  venueId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "venue_custom_amenities" */
export enum VenueCustomAmenitiesConstraint {
  /** unique or primary key constraint on columns "id" */
  VenueCustomAmenitiesPkey = 'venue_custom_amenities_pkey'
}

/** input type for inserting data into table "venue_custom_amenities" */
export type VenueCustomAmenitiesInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  venue?: InputMaybe<VenuesObjRelInsertInput>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type VenueCustomAmenitiesMaxFields = {
  __typename?: 'VenueCustomAmenitiesMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  venueId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "venue_custom_amenities" */
export type VenueCustomAmenitiesMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type VenueCustomAmenitiesMinFields = {
  __typename?: 'VenueCustomAmenitiesMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  venueId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "venue_custom_amenities" */
export type VenueCustomAmenitiesMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "venue_custom_amenities" */
export type VenueCustomAmenitiesMutationResponse = {
  __typename?: 'VenueCustomAmenitiesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<VenueCustomAmenities>;
};

/** on_conflict condition type for table "venue_custom_amenities" */
export type VenueCustomAmenitiesOnConflict = {
  constraint: VenueCustomAmenitiesConstraint;
  updateColumns?: Array<VenueCustomAmenitiesUpdateColumn>;
  where?: InputMaybe<VenueCustomAmenitiesBoolExp>;
};

/** Ordering options when selecting data from "venue_custom_amenities". */
export type VenueCustomAmenitiesOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  venue?: InputMaybe<VenuesOrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: venue_custom_amenities */
export type VenueCustomAmenitiesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "venue_custom_amenities" */
export enum VenueCustomAmenitiesSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  VenueId = 'venueId'
}

/** input type for updating data in table "venue_custom_amenities" */
export type VenueCustomAmenitiesSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "venue_custom_amenities" */
export type VenueCustomAmenitiesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: VenueCustomAmenitiesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type VenueCustomAmenitiesStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "venue_custom_amenities" */
export enum VenueCustomAmenitiesUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  VenueId = 'venueId'
}

export type VenueCustomAmenitiesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<VenueCustomAmenitiesSetInput>;
  /** filter the rows which have to be updated */
  where: VenueCustomAmenitiesBoolExp;
};

/** columns and relationships of "venue_equipment" */
export type VenueEquipment = {
  __typename?: 'VenueEquipment';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  equipment: EquipmentAvailabilitiesEnum;
  id: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  venue: Venues;
  venueId: Scalars['uuid'];
};

/** aggregated selection of "venue_equipment" */
export type VenueEquipmentAggregate = {
  __typename?: 'VenueEquipmentAggregate';
  aggregate?: Maybe<VenueEquipmentAggregateFields>;
  nodes: Array<VenueEquipment>;
};

export type VenueEquipmentAggregateBoolExp = {
  count?: InputMaybe<VenueEquipmentAggregateBoolExpCount>;
};

/** aggregate fields of "venue_equipment" */
export type VenueEquipmentAggregateFields = {
  __typename?: 'VenueEquipmentAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<VenueEquipmentMaxFields>;
  min?: Maybe<VenueEquipmentMinFields>;
};


/** aggregate fields of "venue_equipment" */
export type VenueEquipmentAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<VenueEquipmentSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "venue_equipment" */
export type VenueEquipmentAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<VenueEquipmentMaxOrderBy>;
  min?: InputMaybe<VenueEquipmentMinOrderBy>;
};

/** input type for inserting array relation for remote table "venue_equipment" */
export type VenueEquipmentArrRelInsertInput = {
  data: Array<VenueEquipmentInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<VenueEquipmentOnConflict>;
};

/** Boolean expression to filter rows from the table "venue_equipment". All fields are combined with a logical 'AND'. */
export type VenueEquipmentBoolExp = {
  _and?: InputMaybe<Array<VenueEquipmentBoolExp>>;
  _not?: InputMaybe<VenueEquipmentBoolExp>;
  _or?: InputMaybe<Array<VenueEquipmentBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  equipment?: InputMaybe<EquipmentAvailabilitiesEnumComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  venue?: InputMaybe<VenuesBoolExp>;
  venueId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "venue_equipment" */
export enum VenueEquipmentConstraint {
  /** unique or primary key constraint on columns "id" */
  VenueEquipmentPkey = 'venue_equipment_pkey'
}

/** input type for inserting data into table "venue_equipment" */
export type VenueEquipmentInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  equipment?: InputMaybe<EquipmentAvailabilitiesEnum>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  venue?: InputMaybe<VenuesObjRelInsertInput>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type VenueEquipmentMaxFields = {
  __typename?: 'VenueEquipmentMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  venueId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "venue_equipment" */
export type VenueEquipmentMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type VenueEquipmentMinFields = {
  __typename?: 'VenueEquipmentMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  venueId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "venue_equipment" */
export type VenueEquipmentMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "venue_equipment" */
export type VenueEquipmentMutationResponse = {
  __typename?: 'VenueEquipmentMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<VenueEquipment>;
};

/** on_conflict condition type for table "venue_equipment" */
export type VenueEquipmentOnConflict = {
  constraint: VenueEquipmentConstraint;
  updateColumns?: Array<VenueEquipmentUpdateColumn>;
  where?: InputMaybe<VenueEquipmentBoolExp>;
};

/** Ordering options when selecting data from "venue_equipment". */
export type VenueEquipmentOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  equipment?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  venue?: InputMaybe<VenuesOrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: venue_equipment */
export type VenueEquipmentPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "venue_equipment" */
export enum VenueEquipmentSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Equipment = 'equipment',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  VenueId = 'venueId'
}

/** input type for updating data in table "venue_equipment" */
export type VenueEquipmentSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  equipment?: InputMaybe<EquipmentAvailabilitiesEnum>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "venue_equipment" */
export type VenueEquipmentStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: VenueEquipmentStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type VenueEquipmentStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  equipment?: InputMaybe<EquipmentAvailabilitiesEnum>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "venue_equipment" */
export enum VenueEquipmentUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Equipment = 'equipment',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  VenueId = 'venueId'
}

export type VenueEquipmentUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<VenueEquipmentSetInput>;
  /** filter the rows which have to be updated */
  where: VenueEquipmentBoolExp;
};

/** columns and relationships of "venue_facility_types" */
export type VenueFacilityTypes = {
  __typename?: 'VenueFacilityTypes';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "venue_facility_types" */
export type VenueFacilityTypesAggregate = {
  __typename?: 'VenueFacilityTypesAggregate';
  aggregate?: Maybe<VenueFacilityTypesAggregateFields>;
  nodes: Array<VenueFacilityTypes>;
};

/** aggregate fields of "venue_facility_types" */
export type VenueFacilityTypesAggregateFields = {
  __typename?: 'VenueFacilityTypesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<VenueFacilityTypesMaxFields>;
  min?: Maybe<VenueFacilityTypesMinFields>;
};


/** aggregate fields of "venue_facility_types" */
export type VenueFacilityTypesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<VenueFacilityTypesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "venue_facility_types". All fields are combined with a logical 'AND'. */
export type VenueFacilityTypesBoolExp = {
  _and?: InputMaybe<Array<VenueFacilityTypesBoolExp>>;
  _not?: InputMaybe<VenueFacilityTypesBoolExp>;
  _or?: InputMaybe<Array<VenueFacilityTypesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "venue_facility_types" */
export enum VenueFacilityTypesConstraint {
  /** unique or primary key constraint on columns "value" */
  VenueFacilityTypesPkey = 'venue_facility_types_pkey'
}

export enum VenueFacilityTypesEnum {
  Club = 'CLUB',
  Private = 'PRIVATE',
  Public = 'PUBLIC',
  School = 'SCHOOL'
}

/** Boolean expression to compare columns of type "VenueFacilityTypesEnum". All fields are combined with logical 'AND'. */
export type VenueFacilityTypesEnumComparisonExp = {
  _eq?: InputMaybe<VenueFacilityTypesEnum>;
  _in?: InputMaybe<Array<VenueFacilityTypesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<VenueFacilityTypesEnum>;
  _nin?: InputMaybe<Array<VenueFacilityTypesEnum>>;
};

/** input type for inserting data into table "venue_facility_types" */
export type VenueFacilityTypesInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type VenueFacilityTypesMaxFields = {
  __typename?: 'VenueFacilityTypesMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type VenueFacilityTypesMinFields = {
  __typename?: 'VenueFacilityTypesMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "venue_facility_types" */
export type VenueFacilityTypesMutationResponse = {
  __typename?: 'VenueFacilityTypesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<VenueFacilityTypes>;
};

/** on_conflict condition type for table "venue_facility_types" */
export type VenueFacilityTypesOnConflict = {
  constraint: VenueFacilityTypesConstraint;
  updateColumns?: Array<VenueFacilityTypesUpdateColumn>;
  where?: InputMaybe<VenueFacilityTypesBoolExp>;
};

/** Ordering options when selecting data from "venue_facility_types". */
export type VenueFacilityTypesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: venue_facility_types */
export type VenueFacilityTypesPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "venue_facility_types" */
export enum VenueFacilityTypesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "venue_facility_types" */
export type VenueFacilityTypesSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "venue_facility_types" */
export type VenueFacilityTypesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: VenueFacilityTypesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type VenueFacilityTypesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "venue_facility_types" */
export enum VenueFacilityTypesUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type VenueFacilityTypesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<VenueFacilityTypesSetInput>;
  /** filter the rows which have to be updated */
  where: VenueFacilityTypesBoolExp;
};

/** columns and relationships of "venue_faqs" */
export type VenueFaqs = {
  __typename?: 'VenueFaqs';
  answer: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  position: Scalars['Int'];
  question: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  venue: Venues;
  venueId: Scalars['uuid'];
};

/** aggregated selection of "venue_faqs" */
export type VenueFaqsAggregate = {
  __typename?: 'VenueFaqsAggregate';
  aggregate?: Maybe<VenueFaqsAggregateFields>;
  nodes: Array<VenueFaqs>;
};

export type VenueFaqsAggregateBoolExp = {
  count?: InputMaybe<VenueFaqsAggregateBoolExpCount>;
};

/** aggregate fields of "venue_faqs" */
export type VenueFaqsAggregateFields = {
  __typename?: 'VenueFaqsAggregateFields';
  avg?: Maybe<VenueFaqsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<VenueFaqsMaxFields>;
  min?: Maybe<VenueFaqsMinFields>;
  stddev?: Maybe<VenueFaqsStddevFields>;
  stddevPop?: Maybe<VenueFaqsStddevPopFields>;
  stddevSamp?: Maybe<VenueFaqsStddevSampFields>;
  sum?: Maybe<VenueFaqsSumFields>;
  varPop?: Maybe<VenueFaqsVarPopFields>;
  varSamp?: Maybe<VenueFaqsVarSampFields>;
  variance?: Maybe<VenueFaqsVarianceFields>;
};


/** aggregate fields of "venue_faqs" */
export type VenueFaqsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<VenueFaqsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "venue_faqs" */
export type VenueFaqsAggregateOrderBy = {
  avg?: InputMaybe<VenueFaqsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<VenueFaqsMaxOrderBy>;
  min?: InputMaybe<VenueFaqsMinOrderBy>;
  stddev?: InputMaybe<VenueFaqsStddevOrderBy>;
  stddevPop?: InputMaybe<VenueFaqsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<VenueFaqsStddevSampOrderBy>;
  sum?: InputMaybe<VenueFaqsSumOrderBy>;
  varPop?: InputMaybe<VenueFaqsVarPopOrderBy>;
  varSamp?: InputMaybe<VenueFaqsVarSampOrderBy>;
  variance?: InputMaybe<VenueFaqsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "venue_faqs" */
export type VenueFaqsArrRelInsertInput = {
  data: Array<VenueFaqsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<VenueFaqsOnConflict>;
};

/** aggregate avg on columns */
export type VenueFaqsAvgFields = {
  __typename?: 'VenueFaqsAvgFields';
  position?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "venue_faqs" */
export type VenueFaqsAvgOrderBy = {
  position?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "venue_faqs". All fields are combined with a logical 'AND'. */
export type VenueFaqsBoolExp = {
  _and?: InputMaybe<Array<VenueFaqsBoolExp>>;
  _not?: InputMaybe<VenueFaqsBoolExp>;
  _or?: InputMaybe<Array<VenueFaqsBoolExp>>;
  answer?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  position?: InputMaybe<IntComparisonExp>;
  question?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  venue?: InputMaybe<VenuesBoolExp>;
  venueId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "venue_faqs" */
export enum VenueFaqsConstraint {
  /** unique or primary key constraint on columns "id" */
  VenueFaqsPkey = 'venue_faqs_pkey'
}

/** input type for incrementing numeric columns in table "venue_faqs" */
export type VenueFaqsIncInput = {
  position?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "venue_faqs" */
export type VenueFaqsInsertInput = {
  answer?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  position?: InputMaybe<Scalars['Int']>;
  question?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  venue?: InputMaybe<VenuesObjRelInsertInput>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type VenueFaqsMaxFields = {
  __typename?: 'VenueFaqsMaxFields';
  answer?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  position?: Maybe<Scalars['Int']>;
  question?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  venueId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "venue_faqs" */
export type VenueFaqsMaxOrderBy = {
  answer?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  position?: InputMaybe<OrderBy>;
  question?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type VenueFaqsMinFields = {
  __typename?: 'VenueFaqsMinFields';
  answer?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  position?: Maybe<Scalars['Int']>;
  question?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  venueId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "venue_faqs" */
export type VenueFaqsMinOrderBy = {
  answer?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  position?: InputMaybe<OrderBy>;
  question?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "venue_faqs" */
export type VenueFaqsMutationResponse = {
  __typename?: 'VenueFaqsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<VenueFaqs>;
};

/** on_conflict condition type for table "venue_faqs" */
export type VenueFaqsOnConflict = {
  constraint: VenueFaqsConstraint;
  updateColumns?: Array<VenueFaqsUpdateColumn>;
  where?: InputMaybe<VenueFaqsBoolExp>;
};

/** Ordering options when selecting data from "venue_faqs". */
export type VenueFaqsOrderBy = {
  answer?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  position?: InputMaybe<OrderBy>;
  question?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  venue?: InputMaybe<VenuesOrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: venue_faqs */
export type VenueFaqsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "venue_faqs" */
export enum VenueFaqsSelectColumn {
  /** column name */
  Answer = 'answer',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  Position = 'position',
  /** column name */
  Question = 'question',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  VenueId = 'venueId'
}

/** input type for updating data in table "venue_faqs" */
export type VenueFaqsSetInput = {
  answer?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  position?: InputMaybe<Scalars['Int']>;
  question?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type VenueFaqsStddevFields = {
  __typename?: 'VenueFaqsStddevFields';
  position?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "venue_faqs" */
export type VenueFaqsStddevOrderBy = {
  position?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type VenueFaqsStddevPopFields = {
  __typename?: 'VenueFaqsStddevPopFields';
  position?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "venue_faqs" */
export type VenueFaqsStddevPopOrderBy = {
  position?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type VenueFaqsStddevSampFields = {
  __typename?: 'VenueFaqsStddevSampFields';
  position?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "venue_faqs" */
export type VenueFaqsStddevSampOrderBy = {
  position?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "venue_faqs" */
export type VenueFaqsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: VenueFaqsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type VenueFaqsStreamCursorValueInput = {
  answer?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  position?: InputMaybe<Scalars['Int']>;
  question?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type VenueFaqsSumFields = {
  __typename?: 'VenueFaqsSumFields';
  position?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "venue_faqs" */
export type VenueFaqsSumOrderBy = {
  position?: InputMaybe<OrderBy>;
};

/** update columns of table "venue_faqs" */
export enum VenueFaqsUpdateColumn {
  /** column name */
  Answer = 'answer',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  Position = 'position',
  /** column name */
  Question = 'question',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  VenueId = 'venueId'
}

export type VenueFaqsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<VenueFaqsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<VenueFaqsSetInput>;
  /** filter the rows which have to be updated */
  where: VenueFaqsBoolExp;
};

/** aggregate varPop on columns */
export type VenueFaqsVarPopFields = {
  __typename?: 'VenueFaqsVarPopFields';
  position?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "venue_faqs" */
export type VenueFaqsVarPopOrderBy = {
  position?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type VenueFaqsVarSampFields = {
  __typename?: 'VenueFaqsVarSampFields';
  position?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "venue_faqs" */
export type VenueFaqsVarSampOrderBy = {
  position?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type VenueFaqsVarianceFields = {
  __typename?: 'VenueFaqsVarianceFields';
  position?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "venue_faqs" */
export type VenueFaqsVarianceOrderBy = {
  position?: InputMaybe<OrderBy>;
};

/** columns and relationships of "venue_follows" */
export type VenueFollows = {
  __typename?: 'VenueFollows';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  status: FollowStatusesEnum;
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid'];
  /** An object relationship */
  userProfile?: Maybe<UserProfiles>;
  /** An object relationship */
  venue: Venues;
  venueId: Scalars['uuid'];
};

/** aggregated selection of "venue_follows" */
export type VenueFollowsAggregate = {
  __typename?: 'VenueFollowsAggregate';
  aggregate?: Maybe<VenueFollowsAggregateFields>;
  nodes: Array<VenueFollows>;
};

export type VenueFollowsAggregateBoolExp = {
  count?: InputMaybe<VenueFollowsAggregateBoolExpCount>;
};

/** aggregate fields of "venue_follows" */
export type VenueFollowsAggregateFields = {
  __typename?: 'VenueFollowsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<VenueFollowsMaxFields>;
  min?: Maybe<VenueFollowsMinFields>;
};


/** aggregate fields of "venue_follows" */
export type VenueFollowsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<VenueFollowsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "venue_follows" */
export type VenueFollowsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<VenueFollowsMaxOrderBy>;
  min?: InputMaybe<VenueFollowsMinOrderBy>;
};

/** input type for inserting array relation for remote table "venue_follows" */
export type VenueFollowsArrRelInsertInput = {
  data: Array<VenueFollowsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<VenueFollowsOnConflict>;
};

/** Boolean expression to filter rows from the table "venue_follows". All fields are combined with a logical 'AND'. */
export type VenueFollowsBoolExp = {
  _and?: InputMaybe<Array<VenueFollowsBoolExp>>;
  _not?: InputMaybe<VenueFollowsBoolExp>;
  _or?: InputMaybe<Array<VenueFollowsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  status?: InputMaybe<FollowStatusesEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
  userProfile?: InputMaybe<UserProfilesBoolExp>;
  venue?: InputMaybe<VenuesBoolExp>;
  venueId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "venue_follows" */
export enum VenueFollowsConstraint {
  /** unique or primary key constraint on columns "id" */
  VenueFollowsPkey = 'venue_follows_pkey',
  /** unique or primary key constraint on columns "venue_id", "user_id" */
  VenueFollowsVenueIdUserIdKey = 'venue_follows_venue_id_user_id_key'
}

/** input type for inserting data into table "venue_follows" */
export type VenueFollowsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<FollowStatusesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']>;
  userProfile?: InputMaybe<UserProfilesObjRelInsertInput>;
  venue?: InputMaybe<VenuesObjRelInsertInput>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type VenueFollowsMaxFields = {
  __typename?: 'VenueFollowsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
  venueId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "venue_follows" */
export type VenueFollowsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type VenueFollowsMinFields = {
  __typename?: 'VenueFollowsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
  venueId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "venue_follows" */
export type VenueFollowsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "venue_follows" */
export type VenueFollowsMutationResponse = {
  __typename?: 'VenueFollowsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<VenueFollows>;
};

/** on_conflict condition type for table "venue_follows" */
export type VenueFollowsOnConflict = {
  constraint: VenueFollowsConstraint;
  updateColumns?: Array<VenueFollowsUpdateColumn>;
  where?: InputMaybe<VenueFollowsBoolExp>;
};

/** Ordering options when selecting data from "venue_follows". */
export type VenueFollowsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
  userProfile?: InputMaybe<UserProfilesOrderBy>;
  venue?: InputMaybe<VenuesOrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: venue_follows */
export type VenueFollowsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "venue_follows" */
export enum VenueFollowsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId',
  /** column name */
  VenueId = 'venueId'
}

/** input type for updating data in table "venue_follows" */
export type VenueFollowsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<FollowStatusesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "venue_follows" */
export type VenueFollowsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: VenueFollowsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type VenueFollowsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<FollowStatusesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "venue_follows" */
export enum VenueFollowsUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId',
  /** column name */
  VenueId = 'venueId'
}

export type VenueFollowsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<VenueFollowsSetInput>;
  /** filter the rows which have to be updated */
  where: VenueFollowsBoolExp;
};

/** columns and relationships of "venue_images" */
export type VenueImages = {
  __typename?: 'VenueImages';
  attributionHtml: Scalars['String'];
  attributionName: Scalars['String'];
  attributionUrl: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  fileName: Scalars['String'];
  fileType?: Maybe<Scalars['String']>;
  host: Scalars['String'];
  id: Scalars['uuid'];
  isCover: Scalars['Boolean'];
  isScraped: Scalars['Boolean'];
  isVisible: Scalars['Boolean'];
  path: Scalars['String'];
  provider: Scalars['String'];
  providerId: Scalars['String'];
  providerUrl: Scalars['String'];
  source?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamptz'];
  url: Scalars['String'];
  /** An object relationship */
  venue: Venues;
  venueId: Scalars['uuid'];
};

/** aggregated selection of "venue_images" */
export type VenueImagesAggregate = {
  __typename?: 'VenueImagesAggregate';
  aggregate?: Maybe<VenueImagesAggregateFields>;
  nodes: Array<VenueImages>;
};

export type VenueImagesAggregateBoolExp = {
  bool_and?: InputMaybe<VenueImagesAggregateBoolExpBool_And>;
  bool_or?: InputMaybe<VenueImagesAggregateBoolExpBool_Or>;
  count?: InputMaybe<VenueImagesAggregateBoolExpCount>;
};

/** aggregate fields of "venue_images" */
export type VenueImagesAggregateFields = {
  __typename?: 'VenueImagesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<VenueImagesMaxFields>;
  min?: Maybe<VenueImagesMinFields>;
};


/** aggregate fields of "venue_images" */
export type VenueImagesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<VenueImagesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "venue_images" */
export type VenueImagesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<VenueImagesMaxOrderBy>;
  min?: InputMaybe<VenueImagesMinOrderBy>;
};

/** input type for inserting array relation for remote table "venue_images" */
export type VenueImagesArrRelInsertInput = {
  data: Array<VenueImagesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<VenueImagesOnConflict>;
};

/** Boolean expression to filter rows from the table "venue_images". All fields are combined with a logical 'AND'. */
export type VenueImagesBoolExp = {
  _and?: InputMaybe<Array<VenueImagesBoolExp>>;
  _not?: InputMaybe<VenueImagesBoolExp>;
  _or?: InputMaybe<Array<VenueImagesBoolExp>>;
  attributionHtml?: InputMaybe<StringComparisonExp>;
  attributionName?: InputMaybe<StringComparisonExp>;
  attributionUrl?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  fileName?: InputMaybe<StringComparisonExp>;
  fileType?: InputMaybe<StringComparisonExp>;
  host?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isCover?: InputMaybe<BooleanComparisonExp>;
  isScraped?: InputMaybe<BooleanComparisonExp>;
  isVisible?: InputMaybe<BooleanComparisonExp>;
  path?: InputMaybe<StringComparisonExp>;
  provider?: InputMaybe<StringComparisonExp>;
  providerId?: InputMaybe<StringComparisonExp>;
  providerUrl?: InputMaybe<StringComparisonExp>;
  source?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  url?: InputMaybe<StringComparisonExp>;
  venue?: InputMaybe<VenuesBoolExp>;
  venueId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "venue_images" */
export enum VenueImagesConstraint {
  /** unique or primary key constraint on columns "id" */
  VenueImagesPkey = 'venue_images_pkey',
  /** unique or primary key constraint on columns "venue_id", "file_name" */
  VenueImagesVenueIdFileNameKey = 'venue_images_venue_id_file_name_key'
}

/** input type for inserting data into table "venue_images" */
export type VenueImagesInsertInput = {
  attributionHtml?: InputMaybe<Scalars['String']>;
  attributionName?: InputMaybe<Scalars['String']>;
  attributionUrl?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  fileName?: InputMaybe<Scalars['String']>;
  fileType?: InputMaybe<Scalars['String']>;
  host?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  isCover?: InputMaybe<Scalars['Boolean']>;
  isScraped?: InputMaybe<Scalars['Boolean']>;
  isVisible?: InputMaybe<Scalars['Boolean']>;
  path?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  providerId?: InputMaybe<Scalars['String']>;
  providerUrl?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  url?: InputMaybe<Scalars['String']>;
  venue?: InputMaybe<VenuesObjRelInsertInput>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type VenueImagesMaxFields = {
  __typename?: 'VenueImagesMaxFields';
  attributionHtml?: Maybe<Scalars['String']>;
  attributionName?: Maybe<Scalars['String']>;
  attributionUrl?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  fileName?: Maybe<Scalars['String']>;
  fileType?: Maybe<Scalars['String']>;
  host?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  path?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  providerId?: Maybe<Scalars['String']>;
  providerUrl?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  url?: Maybe<Scalars['String']>;
  venueId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "venue_images" */
export type VenueImagesMaxOrderBy = {
  attributionHtml?: InputMaybe<OrderBy>;
  attributionName?: InputMaybe<OrderBy>;
  attributionUrl?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  fileName?: InputMaybe<OrderBy>;
  fileType?: InputMaybe<OrderBy>;
  host?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  path?: InputMaybe<OrderBy>;
  provider?: InputMaybe<OrderBy>;
  providerId?: InputMaybe<OrderBy>;
  providerUrl?: InputMaybe<OrderBy>;
  source?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  url?: InputMaybe<OrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type VenueImagesMinFields = {
  __typename?: 'VenueImagesMinFields';
  attributionHtml?: Maybe<Scalars['String']>;
  attributionName?: Maybe<Scalars['String']>;
  attributionUrl?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  fileName?: Maybe<Scalars['String']>;
  fileType?: Maybe<Scalars['String']>;
  host?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  path?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  providerId?: Maybe<Scalars['String']>;
  providerUrl?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  url?: Maybe<Scalars['String']>;
  venueId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "venue_images" */
export type VenueImagesMinOrderBy = {
  attributionHtml?: InputMaybe<OrderBy>;
  attributionName?: InputMaybe<OrderBy>;
  attributionUrl?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  fileName?: InputMaybe<OrderBy>;
  fileType?: InputMaybe<OrderBy>;
  host?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  path?: InputMaybe<OrderBy>;
  provider?: InputMaybe<OrderBy>;
  providerId?: InputMaybe<OrderBy>;
  providerUrl?: InputMaybe<OrderBy>;
  source?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  url?: InputMaybe<OrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "venue_images" */
export type VenueImagesMutationResponse = {
  __typename?: 'VenueImagesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<VenueImages>;
};

/** on_conflict condition type for table "venue_images" */
export type VenueImagesOnConflict = {
  constraint: VenueImagesConstraint;
  updateColumns?: Array<VenueImagesUpdateColumn>;
  where?: InputMaybe<VenueImagesBoolExp>;
};

/** Ordering options when selecting data from "venue_images". */
export type VenueImagesOrderBy = {
  attributionHtml?: InputMaybe<OrderBy>;
  attributionName?: InputMaybe<OrderBy>;
  attributionUrl?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  fileName?: InputMaybe<OrderBy>;
  fileType?: InputMaybe<OrderBy>;
  host?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  isCover?: InputMaybe<OrderBy>;
  isScraped?: InputMaybe<OrderBy>;
  isVisible?: InputMaybe<OrderBy>;
  path?: InputMaybe<OrderBy>;
  provider?: InputMaybe<OrderBy>;
  providerId?: InputMaybe<OrderBy>;
  providerUrl?: InputMaybe<OrderBy>;
  source?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  url?: InputMaybe<OrderBy>;
  venue?: InputMaybe<VenuesOrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: venue_images */
export type VenueImagesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "venue_images" */
export enum VenueImagesSelectColumn {
  /** column name */
  AttributionHtml = 'attributionHtml',
  /** column name */
  AttributionName = 'attributionName',
  /** column name */
  AttributionUrl = 'attributionUrl',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  FileName = 'fileName',
  /** column name */
  FileType = 'fileType',
  /** column name */
  Host = 'host',
  /** column name */
  Id = 'id',
  /** column name */
  IsCover = 'isCover',
  /** column name */
  IsScraped = 'isScraped',
  /** column name */
  IsVisible = 'isVisible',
  /** column name */
  Path = 'path',
  /** column name */
  Provider = 'provider',
  /** column name */
  ProviderId = 'providerId',
  /** column name */
  ProviderUrl = 'providerUrl',
  /** column name */
  Source = 'source',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Url = 'url',
  /** column name */
  VenueId = 'venueId'
}

/** select "venueImagesAggregateBoolExpBool_andArgumentsColumns" columns of table "venue_images" */
export enum VenueImagesSelectColumnVenueImagesAggregateBoolExpBool_AndArgumentsColumns {
  /** column name */
  IsCover = 'isCover',
  /** column name */
  IsScraped = 'isScraped',
  /** column name */
  IsVisible = 'isVisible'
}

/** select "venueImagesAggregateBoolExpBool_orArgumentsColumns" columns of table "venue_images" */
export enum VenueImagesSelectColumnVenueImagesAggregateBoolExpBool_OrArgumentsColumns {
  /** column name */
  IsCover = 'isCover',
  /** column name */
  IsScraped = 'isScraped',
  /** column name */
  IsVisible = 'isVisible'
}

/** input type for updating data in table "venue_images" */
export type VenueImagesSetInput = {
  attributionHtml?: InputMaybe<Scalars['String']>;
  attributionName?: InputMaybe<Scalars['String']>;
  attributionUrl?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  fileName?: InputMaybe<Scalars['String']>;
  fileType?: InputMaybe<Scalars['String']>;
  host?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  isCover?: InputMaybe<Scalars['Boolean']>;
  isScraped?: InputMaybe<Scalars['Boolean']>;
  isVisible?: InputMaybe<Scalars['Boolean']>;
  path?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  providerId?: InputMaybe<Scalars['String']>;
  providerUrl?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  url?: InputMaybe<Scalars['String']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "venue_images" */
export type VenueImagesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: VenueImagesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type VenueImagesStreamCursorValueInput = {
  attributionHtml?: InputMaybe<Scalars['String']>;
  attributionName?: InputMaybe<Scalars['String']>;
  attributionUrl?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  fileName?: InputMaybe<Scalars['String']>;
  fileType?: InputMaybe<Scalars['String']>;
  host?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  isCover?: InputMaybe<Scalars['Boolean']>;
  isScraped?: InputMaybe<Scalars['Boolean']>;
  isVisible?: InputMaybe<Scalars['Boolean']>;
  path?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  providerId?: InputMaybe<Scalars['String']>;
  providerUrl?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  url?: InputMaybe<Scalars['String']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "venue_images" */
export enum VenueImagesUpdateColumn {
  /** column name */
  AttributionHtml = 'attributionHtml',
  /** column name */
  AttributionName = 'attributionName',
  /** column name */
  AttributionUrl = 'attributionUrl',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  FileName = 'fileName',
  /** column name */
  FileType = 'fileType',
  /** column name */
  Host = 'host',
  /** column name */
  Id = 'id',
  /** column name */
  IsCover = 'isCover',
  /** column name */
  IsScraped = 'isScraped',
  /** column name */
  IsVisible = 'isVisible',
  /** column name */
  Path = 'path',
  /** column name */
  Provider = 'provider',
  /** column name */
  ProviderId = 'providerId',
  /** column name */
  ProviderUrl = 'providerUrl',
  /** column name */
  Source = 'source',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Url = 'url',
  /** column name */
  VenueId = 'venueId'
}

export type VenueImagesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<VenueImagesSetInput>;
  /** filter the rows which have to be updated */
  where: VenueImagesBoolExp;
};

/** columns and relationships of "venue_lines" */
export type VenueLines = {
  __typename?: 'VenueLines';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "venue_lines" */
export type VenueLinesAggregate = {
  __typename?: 'VenueLinesAggregate';
  aggregate?: Maybe<VenueLinesAggregateFields>;
  nodes: Array<VenueLines>;
};

/** aggregate fields of "venue_lines" */
export type VenueLinesAggregateFields = {
  __typename?: 'VenueLinesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<VenueLinesMaxFields>;
  min?: Maybe<VenueLinesMinFields>;
};


/** aggregate fields of "venue_lines" */
export type VenueLinesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<VenueLinesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "venue_lines". All fields are combined with a logical 'AND'. */
export type VenueLinesBoolExp = {
  _and?: InputMaybe<Array<VenueLinesBoolExp>>;
  _not?: InputMaybe<VenueLinesBoolExp>;
  _or?: InputMaybe<Array<VenueLinesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "venue_lines" */
export enum VenueLinesConstraint {
  /** unique or primary key constraint on columns "value" */
  VenueLinesPkey = 'venue_lines_pkey'
}

export enum VenueLinesEnum {
  Chalk = 'CHALK',
  Permanent = 'PERMANENT',
  Tape = 'TAPE',
  Temporary = 'TEMPORARY'
}

/** Boolean expression to compare columns of type "VenueLinesEnum". All fields are combined with logical 'AND'. */
export type VenueLinesEnumComparisonExp = {
  _eq?: InputMaybe<VenueLinesEnum>;
  _in?: InputMaybe<Array<VenueLinesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<VenueLinesEnum>;
  _nin?: InputMaybe<Array<VenueLinesEnum>>;
};

/** input type for inserting data into table "venue_lines" */
export type VenueLinesInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type VenueLinesMaxFields = {
  __typename?: 'VenueLinesMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type VenueLinesMinFields = {
  __typename?: 'VenueLinesMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "venue_lines" */
export type VenueLinesMutationResponse = {
  __typename?: 'VenueLinesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<VenueLines>;
};

/** on_conflict condition type for table "venue_lines" */
export type VenueLinesOnConflict = {
  constraint: VenueLinesConstraint;
  updateColumns?: Array<VenueLinesUpdateColumn>;
  where?: InputMaybe<VenueLinesBoolExp>;
};

/** Ordering options when selecting data from "venue_lines". */
export type VenueLinesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: venue_lines */
export type VenueLinesPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "venue_lines" */
export enum VenueLinesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "venue_lines" */
export type VenueLinesSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "venue_lines" */
export type VenueLinesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: VenueLinesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type VenueLinesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "venue_lines" */
export enum VenueLinesUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type VenueLinesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<VenueLinesSetInput>;
  /** filter the rows which have to be updated */
  where: VenueLinesBoolExp;
};

/** columns and relationships of "venue_nets" */
export type VenueNets = {
  __typename?: 'VenueNets';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "venue_nets" */
export type VenueNetsAggregate = {
  __typename?: 'VenueNetsAggregate';
  aggregate?: Maybe<VenueNetsAggregateFields>;
  nodes: Array<VenueNets>;
};

/** aggregate fields of "venue_nets" */
export type VenueNetsAggregateFields = {
  __typename?: 'VenueNetsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<VenueNetsMaxFields>;
  min?: Maybe<VenueNetsMinFields>;
};


/** aggregate fields of "venue_nets" */
export type VenueNetsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<VenueNetsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "venue_nets". All fields are combined with a logical 'AND'. */
export type VenueNetsBoolExp = {
  _and?: InputMaybe<Array<VenueNetsBoolExp>>;
  _not?: InputMaybe<VenueNetsBoolExp>;
  _or?: InputMaybe<Array<VenueNetsBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "venue_nets" */
export enum VenueNetsConstraint {
  /** unique or primary key constraint on columns "value" */
  VenueNetsPkey = 'venue_nets_pkey'
}

export enum VenueNetsEnum {
  BringYourOwn = 'BRING_YOUR_OWN',
  Permanent = 'PERMANENT',
  Portable = 'PORTABLE',
  Tennis = 'TENNIS'
}

/** Boolean expression to compare columns of type "VenueNetsEnum". All fields are combined with logical 'AND'. */
export type VenueNetsEnumComparisonExp = {
  _eq?: InputMaybe<VenueNetsEnum>;
  _in?: InputMaybe<Array<VenueNetsEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<VenueNetsEnum>;
  _nin?: InputMaybe<Array<VenueNetsEnum>>;
};

/** input type for inserting data into table "venue_nets" */
export type VenueNetsInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type VenueNetsMaxFields = {
  __typename?: 'VenueNetsMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type VenueNetsMinFields = {
  __typename?: 'VenueNetsMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "venue_nets" */
export type VenueNetsMutationResponse = {
  __typename?: 'VenueNetsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<VenueNets>;
};

/** on_conflict condition type for table "venue_nets" */
export type VenueNetsOnConflict = {
  constraint: VenueNetsConstraint;
  updateColumns?: Array<VenueNetsUpdateColumn>;
  where?: InputMaybe<VenueNetsBoolExp>;
};

/** Ordering options when selecting data from "venue_nets". */
export type VenueNetsOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: venue_nets */
export type VenueNetsPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "venue_nets" */
export enum VenueNetsSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "venue_nets" */
export type VenueNetsSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "venue_nets" */
export type VenueNetsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: VenueNetsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type VenueNetsStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "venue_nets" */
export enum VenueNetsUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type VenueNetsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<VenueNetsSetInput>;
  /** filter the rows which have to be updated */
  where: VenueNetsBoolExp;
};

/** columns and relationships of "venue_partner_booking_statuses" */
export type VenuePartnerBookingStatuses = {
  __typename?: 'VenuePartnerBookingStatuses';
  integrationId?: Maybe<Scalars['uuid']>;
  isBookable?: Maybe<Scalars['Boolean']>;
  venueId?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "venue_partner_booking_statuses" */
export type VenuePartnerBookingStatusesAggregate = {
  __typename?: 'VenuePartnerBookingStatusesAggregate';
  aggregate?: Maybe<VenuePartnerBookingStatusesAggregateFields>;
  nodes: Array<VenuePartnerBookingStatuses>;
};

/** aggregate fields of "venue_partner_booking_statuses" */
export type VenuePartnerBookingStatusesAggregateFields = {
  __typename?: 'VenuePartnerBookingStatusesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<VenuePartnerBookingStatusesMaxFields>;
  min?: Maybe<VenuePartnerBookingStatusesMinFields>;
};


/** aggregate fields of "venue_partner_booking_statuses" */
export type VenuePartnerBookingStatusesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<VenuePartnerBookingStatusesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "venue_partner_booking_statuses". All fields are combined with a logical 'AND'. */
export type VenuePartnerBookingStatusesBoolExp = {
  _and?: InputMaybe<Array<VenuePartnerBookingStatusesBoolExp>>;
  _not?: InputMaybe<VenuePartnerBookingStatusesBoolExp>;
  _or?: InputMaybe<Array<VenuePartnerBookingStatusesBoolExp>>;
  integrationId?: InputMaybe<UuidComparisonExp>;
  isBookable?: InputMaybe<BooleanComparisonExp>;
  venueId?: InputMaybe<UuidComparisonExp>;
};

/** input type for inserting data into table "venue_partner_booking_statuses" */
export type VenuePartnerBookingStatusesInsertInput = {
  integrationId?: InputMaybe<Scalars['uuid']>;
  isBookable?: InputMaybe<Scalars['Boolean']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type VenuePartnerBookingStatusesMaxFields = {
  __typename?: 'VenuePartnerBookingStatusesMaxFields';
  integrationId?: Maybe<Scalars['uuid']>;
  venueId?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type VenuePartnerBookingStatusesMinFields = {
  __typename?: 'VenuePartnerBookingStatusesMinFields';
  integrationId?: Maybe<Scalars['uuid']>;
  venueId?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "venue_partner_booking_statuses" */
export type VenuePartnerBookingStatusesMutationResponse = {
  __typename?: 'VenuePartnerBookingStatusesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<VenuePartnerBookingStatuses>;
};

/** input type for inserting object relation for remote table "venue_partner_booking_statuses" */
export type VenuePartnerBookingStatusesObjRelInsertInput = {
  data: VenuePartnerBookingStatusesInsertInput;
};

/** Ordering options when selecting data from "venue_partner_booking_statuses". */
export type VenuePartnerBookingStatusesOrderBy = {
  integrationId?: InputMaybe<OrderBy>;
  isBookable?: InputMaybe<OrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** select columns of table "venue_partner_booking_statuses" */
export enum VenuePartnerBookingStatusesSelectColumn {
  /** column name */
  IntegrationId = 'integrationId',
  /** column name */
  IsBookable = 'isBookable',
  /** column name */
  VenueId = 'venueId'
}

/** input type for updating data in table "venue_partner_booking_statuses" */
export type VenuePartnerBookingStatusesSetInput = {
  integrationId?: InputMaybe<Scalars['uuid']>;
  isBookable?: InputMaybe<Scalars['Boolean']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "venue_partner_booking_statuses" */
export type VenuePartnerBookingStatusesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: VenuePartnerBookingStatusesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type VenuePartnerBookingStatusesStreamCursorValueInput = {
  integrationId?: InputMaybe<Scalars['uuid']>;
  isBookable?: InputMaybe<Scalars['Boolean']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

export type VenuePartnerBookingStatusesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<VenuePartnerBookingStatusesSetInput>;
  /** filter the rows which have to be updated */
  where: VenuePartnerBookingStatusesBoolExp;
};

/** columns and relationships of "venue_staff_coaches" */
export type VenueStaffCoaches = {
  __typename?: 'VenueStaffCoaches';
  addedByUserId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  addedByUserProfile?: Maybe<UserProfiles>;
  /** An object relationship */
  coachProfile?: Maybe<UserProfiles>;
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
  userId: Scalars['uuid'];
  /** An object relationship */
  venue: Venues;
  venueId: Scalars['uuid'];
};

/** aggregated selection of "venue_staff_coaches" */
export type VenueStaffCoachesAggregate = {
  __typename?: 'VenueStaffCoachesAggregate';
  aggregate?: Maybe<VenueStaffCoachesAggregateFields>;
  nodes: Array<VenueStaffCoaches>;
};

export type VenueStaffCoachesAggregateBoolExp = {
  count?: InputMaybe<VenueStaffCoachesAggregateBoolExpCount>;
};

/** aggregate fields of "venue_staff_coaches" */
export type VenueStaffCoachesAggregateFields = {
  __typename?: 'VenueStaffCoachesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<VenueStaffCoachesMaxFields>;
  min?: Maybe<VenueStaffCoachesMinFields>;
};


/** aggregate fields of "venue_staff_coaches" */
export type VenueStaffCoachesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<VenueStaffCoachesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "venue_staff_coaches" */
export type VenueStaffCoachesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<VenueStaffCoachesMaxOrderBy>;
  min?: InputMaybe<VenueStaffCoachesMinOrderBy>;
};

/** input type for inserting array relation for remote table "venue_staff_coaches" */
export type VenueStaffCoachesArrRelInsertInput = {
  data: Array<VenueStaffCoachesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<VenueStaffCoachesOnConflict>;
};

/** Boolean expression to filter rows from the table "venue_staff_coaches". All fields are combined with a logical 'AND'. */
export type VenueStaffCoachesBoolExp = {
  _and?: InputMaybe<Array<VenueStaffCoachesBoolExp>>;
  _not?: InputMaybe<VenueStaffCoachesBoolExp>;
  _or?: InputMaybe<Array<VenueStaffCoachesBoolExp>>;
  addedByUserId?: InputMaybe<UuidComparisonExp>;
  addedByUserProfile?: InputMaybe<UserProfilesBoolExp>;
  coachProfile?: InputMaybe<UserProfilesBoolExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  userId?: InputMaybe<UuidComparisonExp>;
  venue?: InputMaybe<VenuesBoolExp>;
  venueId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "venue_staff_coaches" */
export enum VenueStaffCoachesConstraint {
  /** unique or primary key constraint on columns "id" */
  VenueStaffCoachesPkey = 'venue_staff_coaches_pkey',
  /** unique or primary key constraint on columns "venue_id", "user_id" */
  VenueStaffCoachesVenueIdUserIdActiveIdx = 'venue_staff_coaches_venue_id_user_id_active_idx'
}

/** input type for inserting data into table "venue_staff_coaches" */
export type VenueStaffCoachesInsertInput = {
  addedByUserId?: InputMaybe<Scalars['uuid']>;
  addedByUserProfile?: InputMaybe<UserProfilesObjRelInsertInput>;
  coachProfile?: InputMaybe<UserProfilesObjRelInsertInput>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
  venue?: InputMaybe<VenuesObjRelInsertInput>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type VenueStaffCoachesMaxFields = {
  __typename?: 'VenueStaffCoachesMaxFields';
  addedByUserId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
  venueId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "venue_staff_coaches" */
export type VenueStaffCoachesMaxOrderBy = {
  addedByUserId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type VenueStaffCoachesMinFields = {
  __typename?: 'VenueStaffCoachesMinFields';
  addedByUserId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
  venueId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "venue_staff_coaches" */
export type VenueStaffCoachesMinOrderBy = {
  addedByUserId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "venue_staff_coaches" */
export type VenueStaffCoachesMutationResponse = {
  __typename?: 'VenueStaffCoachesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<VenueStaffCoaches>;
};

/** on_conflict condition type for table "venue_staff_coaches" */
export type VenueStaffCoachesOnConflict = {
  constraint: VenueStaffCoachesConstraint;
  updateColumns?: Array<VenueStaffCoachesUpdateColumn>;
  where?: InputMaybe<VenueStaffCoachesBoolExp>;
};

/** Ordering options when selecting data from "venue_staff_coaches". */
export type VenueStaffCoachesOrderBy = {
  addedByUserId?: InputMaybe<OrderBy>;
  addedByUserProfile?: InputMaybe<UserProfilesOrderBy>;
  coachProfile?: InputMaybe<UserProfilesOrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
  venue?: InputMaybe<VenuesOrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: venue_staff_coaches */
export type VenueStaffCoachesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "venue_staff_coaches" */
export enum VenueStaffCoachesSelectColumn {
  /** column name */
  AddedByUserId = 'addedByUserId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId',
  /** column name */
  VenueId = 'venueId'
}

/** input type for updating data in table "venue_staff_coaches" */
export type VenueStaffCoachesSetInput = {
  addedByUserId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "venue_staff_coaches" */
export type VenueStaffCoachesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: VenueStaffCoachesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type VenueStaffCoachesStreamCursorValueInput = {
  addedByUserId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "venue_staff_coaches" */
export enum VenueStaffCoachesUpdateColumn {
  /** column name */
  AddedByUserId = 'addedByUserId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId',
  /** column name */
  VenueId = 'venueId'
}

export type VenueStaffCoachesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<VenueStaffCoachesSetInput>;
  /** filter the rows which have to be updated */
  where: VenueStaffCoachesBoolExp;
};

/** columns and relationships of "venues" */
export type Venues = {
  __typename?: 'Venues';
  accessDetails: Scalars['String'];
  accessType?: Maybe<VenueAccessTypesEnum>;
  addressString: Scalars['String'];
  /** An object relationship */
  adminUser?: Maybe<Users>;
  /** An array relationship */
  amenities: Array<VenueAmenities>;
  /** An aggregate relationship */
  amenitiesAggregate: VenueAmenitiesAggregate;
  /** An object relationship */
  city?: Maybe<Cities>;
  cityId?: Maybe<Scalars['uuid']>;
  coordinatesWkb: Scalars['String'];
  /** An array relationship */
  courtSurfaces: Array<VenueCourtSurfaces>;
  /** An aggregate relationship */
  courtSurfacesAggregate: VenueCourtSurfacesAggregate;
  createdAt: Scalars['timestamptz'];
  /** An array relationship */
  customAmenities: Array<VenueCustomAmenities>;
  /** An aggregate relationship */
  customAmenitiesAggregate: VenueCustomAmenitiesAggregate;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  description: Scalars['String'];
  email: Scalars['String'];
  /** An array relationship */
  equipment: Array<VenueEquipment>;
  /** An aggregate relationship */
  equipmentAggregate: VenueEquipmentAggregate;
  facebookUrl?: Maybe<Scalars['String']>;
  facilityType?: Maybe<VenueFacilityTypesEnum>;
  /** An array relationship */
  faqs: Array<VenueFaqs>;
  /** An aggregate relationship */
  faqsAggregate: VenueFaqsAggregate;
  featuredPriority?: Maybe<Scalars['Int']>;
  geometry?: Maybe<Scalars['geography']>;
  googlePlaceId?: Maybe<Scalars['String']>;
  /** An array relationship */
  groups: Array<GroupVenues>;
  /** An aggregate relationship */
  groupsAggregate: GroupVenuesAggregate;
  gtnId?: Maybe<Scalars['Int']>;
  hasPadel: Scalars['Boolean'];
  hasPickleball: Scalars['Boolean'];
  hasPlatformTennis: Scalars['Boolean'];
  hasReservations?: Maybe<Scalars['Boolean']>;
  hasTennis: Scalars['Boolean'];
  id: Scalars['uuid'];
  /** An array relationship */
  images: Array<VenueImages>;
  /** An aggregate relationship */
  imagesAggregate: VenueImagesAggregate;
  indoorCourtCount: Scalars['Int'];
  instagramUrl?: Maybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  latitude: Scalars['numeric'];
  /** An array relationship */
  lessons: Array<Lessons>;
  /** An aggregate relationship */
  lessonsAggregate: LessonsAggregate;
  linkedinUrl?: Maybe<Scalars['String']>;
  longitude: Scalars['numeric'];
  outdoorCourtCount: Scalars['Int'];
  /** An object relationship */
  partnerBookingStatus?: Maybe<VenuePartnerBookingStatuses>;
  phoneNumber: Scalars['String'];
  pickleballLines?: Maybe<VenueLinesEnum>;
  pickleballNets?: Maybe<VenueNetsEnum>;
  playByPointId?: Maybe<Scalars['Int']>;
  /** An array relationship */
  playSessions: Array<PlaySessions>;
  /** An aggregate relationship */
  playSessionsAggregate: PlaySessionsAggregate;
  scheduleDetails: Scalars['String'];
  shouldAutofillProgramming?: Maybe<Scalars['Boolean']>;
  shouldHideDefaultDescription: Scalars['Boolean'];
  slug: Scalars['String'];
  source?: Maybe<Scalars['String']>;
  sourceCity?: Maybe<Scalars['String']>;
  sourceCityId?: Maybe<Scalars['String']>;
  sourceCitySlug?: Maybe<Scalars['String']>;
  sourceCountry?: Maybe<Scalars['String']>;
  sourceCountrySlug?: Maybe<Scalars['String']>;
  sourceId?: Maybe<Scalars['String']>;
  sourceLastFetchedAt?: Maybe<Scalars['timestamptz']>;
  sourceLastUpdatedAt?: Maybe<Scalars['timestamptz']>;
  sourceName?: Maybe<Scalars['String']>;
  sourceStateName?: Maybe<Scalars['String']>;
  sourceStateShort?: Maybe<Scalars['String']>;
  sourceStateSlug?: Maybe<Scalars['String']>;
  /** An array relationship */
  staffCoaches: Array<VenueStaffCoaches>;
  /** An aggregate relationship */
  staffCoachesAggregate: VenueStaffCoachesAggregate;
  timezone: Scalars['String'];
  title: Scalars['String'];
  totalCourtCount: Scalars['Int'];
  twitterUrl?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamptz'];
  venueSlug: Scalars['String'];
  websiteUrl: Scalars['String'];
  youtubeUrl?: Maybe<Scalars['String']>;
};


/** columns and relationships of "venues" */
export type VenuesAmenitiesArgs = {
  distinctOn?: InputMaybe<Array<VenueAmenitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueAmenitiesOrderBy>>;
  where?: InputMaybe<VenueAmenitiesBoolExp>;
};


/** columns and relationships of "venues" */
export type VenuesAmenitiesAggregateArgs = {
  distinctOn?: InputMaybe<Array<VenueAmenitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueAmenitiesOrderBy>>;
  where?: InputMaybe<VenueAmenitiesBoolExp>;
};


/** columns and relationships of "venues" */
export type VenuesCourtSurfacesArgs = {
  distinctOn?: InputMaybe<Array<VenueCourtSurfacesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueCourtSurfacesOrderBy>>;
  where?: InputMaybe<VenueCourtSurfacesBoolExp>;
};


/** columns and relationships of "venues" */
export type VenuesCourtSurfacesAggregateArgs = {
  distinctOn?: InputMaybe<Array<VenueCourtSurfacesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueCourtSurfacesOrderBy>>;
  where?: InputMaybe<VenueCourtSurfacesBoolExp>;
};


/** columns and relationships of "venues" */
export type VenuesCustomAmenitiesArgs = {
  distinctOn?: InputMaybe<Array<VenueCustomAmenitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueCustomAmenitiesOrderBy>>;
  where?: InputMaybe<VenueCustomAmenitiesBoolExp>;
};


/** columns and relationships of "venues" */
export type VenuesCustomAmenitiesAggregateArgs = {
  distinctOn?: InputMaybe<Array<VenueCustomAmenitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueCustomAmenitiesOrderBy>>;
  where?: InputMaybe<VenueCustomAmenitiesBoolExp>;
};


/** columns and relationships of "venues" */
export type VenuesEquipmentArgs = {
  distinctOn?: InputMaybe<Array<VenueEquipmentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueEquipmentOrderBy>>;
  where?: InputMaybe<VenueEquipmentBoolExp>;
};


/** columns and relationships of "venues" */
export type VenuesEquipmentAggregateArgs = {
  distinctOn?: InputMaybe<Array<VenueEquipmentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueEquipmentOrderBy>>;
  where?: InputMaybe<VenueEquipmentBoolExp>;
};


/** columns and relationships of "venues" */
export type VenuesFaqsArgs = {
  distinctOn?: InputMaybe<Array<VenueFaqsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueFaqsOrderBy>>;
  where?: InputMaybe<VenueFaqsBoolExp>;
};


/** columns and relationships of "venues" */
export type VenuesFaqsAggregateArgs = {
  distinctOn?: InputMaybe<Array<VenueFaqsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueFaqsOrderBy>>;
  where?: InputMaybe<VenueFaqsBoolExp>;
};


/** columns and relationships of "venues" */
export type VenuesGroupsArgs = {
  distinctOn?: InputMaybe<Array<GroupVenuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupVenuesOrderBy>>;
  where?: InputMaybe<GroupVenuesBoolExp>;
};


/** columns and relationships of "venues" */
export type VenuesGroupsAggregateArgs = {
  distinctOn?: InputMaybe<Array<GroupVenuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupVenuesOrderBy>>;
  where?: InputMaybe<GroupVenuesBoolExp>;
};


/** columns and relationships of "venues" */
export type VenuesImagesArgs = {
  distinctOn?: InputMaybe<Array<VenueImagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueImagesOrderBy>>;
  where?: InputMaybe<VenueImagesBoolExp>;
};


/** columns and relationships of "venues" */
export type VenuesImagesAggregateArgs = {
  distinctOn?: InputMaybe<Array<VenueImagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueImagesOrderBy>>;
  where?: InputMaybe<VenueImagesBoolExp>;
};


/** columns and relationships of "venues" */
export type VenuesLessonsArgs = {
  distinctOn?: InputMaybe<Array<LessonsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonsOrderBy>>;
  where?: InputMaybe<LessonsBoolExp>;
};


/** columns and relationships of "venues" */
export type VenuesLessonsAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonsOrderBy>>;
  where?: InputMaybe<LessonsBoolExp>;
};


/** columns and relationships of "venues" */
export type VenuesPlaySessionsArgs = {
  distinctOn?: InputMaybe<Array<PlaySessionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlaySessionsOrderBy>>;
  where?: InputMaybe<PlaySessionsBoolExp>;
};


/** columns and relationships of "venues" */
export type VenuesPlaySessionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PlaySessionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlaySessionsOrderBy>>;
  where?: InputMaybe<PlaySessionsBoolExp>;
};


/** columns and relationships of "venues" */
export type VenuesStaffCoachesArgs = {
  distinctOn?: InputMaybe<Array<VenueStaffCoachesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueStaffCoachesOrderBy>>;
  where?: InputMaybe<VenueStaffCoachesBoolExp>;
};


/** columns and relationships of "venues" */
export type VenuesStaffCoachesAggregateArgs = {
  distinctOn?: InputMaybe<Array<VenueStaffCoachesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueStaffCoachesOrderBy>>;
  where?: InputMaybe<VenueStaffCoachesBoolExp>;
};

/** aggregated selection of "venues" */
export type VenuesAggregate = {
  __typename?: 'VenuesAggregate';
  aggregate?: Maybe<VenuesAggregateFields>;
  nodes: Array<Venues>;
};

export type VenuesAggregateBoolExp = {
  bool_and?: InputMaybe<VenuesAggregateBoolExpBool_And>;
  bool_or?: InputMaybe<VenuesAggregateBoolExpBool_Or>;
  count?: InputMaybe<VenuesAggregateBoolExpCount>;
};

/** aggregate fields of "venues" */
export type VenuesAggregateFields = {
  __typename?: 'VenuesAggregateFields';
  avg?: Maybe<VenuesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<VenuesMaxFields>;
  min?: Maybe<VenuesMinFields>;
  stddev?: Maybe<VenuesStddevFields>;
  stddevPop?: Maybe<VenuesStddevPopFields>;
  stddevSamp?: Maybe<VenuesStddevSampFields>;
  sum?: Maybe<VenuesSumFields>;
  varPop?: Maybe<VenuesVarPopFields>;
  varSamp?: Maybe<VenuesVarSampFields>;
  variance?: Maybe<VenuesVarianceFields>;
};


/** aggregate fields of "venues" */
export type VenuesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<VenuesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "venues" */
export type VenuesAggregateOrderBy = {
  avg?: InputMaybe<VenuesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<VenuesMaxOrderBy>;
  min?: InputMaybe<VenuesMinOrderBy>;
  stddev?: InputMaybe<VenuesStddevOrderBy>;
  stddevPop?: InputMaybe<VenuesStddevPopOrderBy>;
  stddevSamp?: InputMaybe<VenuesStddevSampOrderBy>;
  sum?: InputMaybe<VenuesSumOrderBy>;
  varPop?: InputMaybe<VenuesVarPopOrderBy>;
  varSamp?: InputMaybe<VenuesVarSampOrderBy>;
  variance?: InputMaybe<VenuesVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "venues" */
export type VenuesArrRelInsertInput = {
  data: Array<VenuesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<VenuesOnConflict>;
};

/** aggregate avg on columns */
export type VenuesAvgFields = {
  __typename?: 'VenuesAvgFields';
  featuredPriority?: Maybe<Scalars['Float']>;
  gtnId?: Maybe<Scalars['Float']>;
  indoorCourtCount?: Maybe<Scalars['Float']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  outdoorCourtCount?: Maybe<Scalars['Float']>;
  playByPointId?: Maybe<Scalars['Float']>;
  totalCourtCount?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "venues" */
export type VenuesAvgOrderBy = {
  featuredPriority?: InputMaybe<OrderBy>;
  gtnId?: InputMaybe<OrderBy>;
  indoorCourtCount?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  outdoorCourtCount?: InputMaybe<OrderBy>;
  playByPointId?: InputMaybe<OrderBy>;
  totalCourtCount?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "venues". All fields are combined with a logical 'AND'. */
export type VenuesBoolExp = {
  _and?: InputMaybe<Array<VenuesBoolExp>>;
  _not?: InputMaybe<VenuesBoolExp>;
  _or?: InputMaybe<Array<VenuesBoolExp>>;
  accessDetails?: InputMaybe<StringComparisonExp>;
  accessType?: InputMaybe<VenueAccessTypesEnumComparisonExp>;
  addressString?: InputMaybe<StringComparisonExp>;
  adminUser?: InputMaybe<UsersBoolExp>;
  amenities?: InputMaybe<VenueAmenitiesBoolExp>;
  amenitiesAggregate?: InputMaybe<VenueAmenitiesAggregateBoolExp>;
  city?: InputMaybe<CitiesBoolExp>;
  cityId?: InputMaybe<UuidComparisonExp>;
  coordinatesWkb?: InputMaybe<StringComparisonExp>;
  courtSurfaces?: InputMaybe<VenueCourtSurfacesBoolExp>;
  courtSurfacesAggregate?: InputMaybe<VenueCourtSurfacesAggregateBoolExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  customAmenities?: InputMaybe<VenueCustomAmenitiesBoolExp>;
  customAmenitiesAggregate?: InputMaybe<VenueCustomAmenitiesAggregateBoolExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  email?: InputMaybe<StringComparisonExp>;
  equipment?: InputMaybe<VenueEquipmentBoolExp>;
  equipmentAggregate?: InputMaybe<VenueEquipmentAggregateBoolExp>;
  facebookUrl?: InputMaybe<StringComparisonExp>;
  facilityType?: InputMaybe<VenueFacilityTypesEnumComparisonExp>;
  faqs?: InputMaybe<VenueFaqsBoolExp>;
  faqsAggregate?: InputMaybe<VenueFaqsAggregateBoolExp>;
  featuredPriority?: InputMaybe<IntComparisonExp>;
  geometry?: InputMaybe<GeographyComparisonExp>;
  googlePlaceId?: InputMaybe<StringComparisonExp>;
  groups?: InputMaybe<GroupVenuesBoolExp>;
  groupsAggregate?: InputMaybe<GroupVenuesAggregateBoolExp>;
  gtnId?: InputMaybe<IntComparisonExp>;
  hasPadel?: InputMaybe<BooleanComparisonExp>;
  hasPickleball?: InputMaybe<BooleanComparisonExp>;
  hasPlatformTennis?: InputMaybe<BooleanComparisonExp>;
  hasReservations?: InputMaybe<BooleanComparisonExp>;
  hasTennis?: InputMaybe<BooleanComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  images?: InputMaybe<VenueImagesBoolExp>;
  imagesAggregate?: InputMaybe<VenueImagesAggregateBoolExp>;
  indoorCourtCount?: InputMaybe<IntComparisonExp>;
  instagramUrl?: InputMaybe<StringComparisonExp>;
  isActive?: InputMaybe<BooleanComparisonExp>;
  latitude?: InputMaybe<NumericComparisonExp>;
  lessons?: InputMaybe<LessonsBoolExp>;
  lessonsAggregate?: InputMaybe<LessonsAggregateBoolExp>;
  linkedinUrl?: InputMaybe<StringComparisonExp>;
  longitude?: InputMaybe<NumericComparisonExp>;
  outdoorCourtCount?: InputMaybe<IntComparisonExp>;
  partnerBookingStatus?: InputMaybe<VenuePartnerBookingStatusesBoolExp>;
  phoneNumber?: InputMaybe<StringComparisonExp>;
  pickleballLines?: InputMaybe<VenueLinesEnumComparisonExp>;
  pickleballNets?: InputMaybe<VenueNetsEnumComparisonExp>;
  playByPointId?: InputMaybe<IntComparisonExp>;
  playSessions?: InputMaybe<PlaySessionsBoolExp>;
  playSessionsAggregate?: InputMaybe<PlaySessionsAggregateBoolExp>;
  scheduleDetails?: InputMaybe<StringComparisonExp>;
  shouldAutofillProgramming?: InputMaybe<BooleanComparisonExp>;
  shouldHideDefaultDescription?: InputMaybe<BooleanComparisonExp>;
  slug?: InputMaybe<StringComparisonExp>;
  source?: InputMaybe<StringComparisonExp>;
  sourceCity?: InputMaybe<StringComparisonExp>;
  sourceCityId?: InputMaybe<StringComparisonExp>;
  sourceCitySlug?: InputMaybe<StringComparisonExp>;
  sourceCountry?: InputMaybe<StringComparisonExp>;
  sourceCountrySlug?: InputMaybe<StringComparisonExp>;
  sourceId?: InputMaybe<StringComparisonExp>;
  sourceLastFetchedAt?: InputMaybe<TimestamptzComparisonExp>;
  sourceLastUpdatedAt?: InputMaybe<TimestamptzComparisonExp>;
  sourceName?: InputMaybe<StringComparisonExp>;
  sourceStateName?: InputMaybe<StringComparisonExp>;
  sourceStateShort?: InputMaybe<StringComparisonExp>;
  sourceStateSlug?: InputMaybe<StringComparisonExp>;
  staffCoaches?: InputMaybe<VenueStaffCoachesBoolExp>;
  staffCoachesAggregate?: InputMaybe<VenueStaffCoachesAggregateBoolExp>;
  timezone?: InputMaybe<StringComparisonExp>;
  title?: InputMaybe<StringComparisonExp>;
  totalCourtCount?: InputMaybe<IntComparisonExp>;
  twitterUrl?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  venueSlug?: InputMaybe<StringComparisonExp>;
  websiteUrl?: InputMaybe<StringComparisonExp>;
  youtubeUrl?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "venues" */
export enum VenuesConstraint {
  /** unique or primary key constraint on columns "google_place_id" */
  VenuesGooglePlaceIdKey = 'venues_google_place_id_key',
  /** unique or primary key constraint on columns "gtn_id" */
  VenuesGtnIdKey = 'venues_gtn_id_key',
  /** unique or primary key constraint on columns "id" */
  VenuesPkey = 'venues_pkey',
  /** unique or primary key constraint on columns "play_by_point_id" */
  VenuesPlayByPointIdKey = 'venues_play_by_point_id_key',
  /** unique or primary key constraint on columns "slug" */
  VenuesSlugKey = 'venues_slug_key'
}

/** input type for incrementing numeric columns in table "venues" */
export type VenuesIncInput = {
  featuredPriority?: InputMaybe<Scalars['Int']>;
  gtnId?: InputMaybe<Scalars['Int']>;
  indoorCourtCount?: InputMaybe<Scalars['Int']>;
  latitude?: InputMaybe<Scalars['numeric']>;
  longitude?: InputMaybe<Scalars['numeric']>;
  outdoorCourtCount?: InputMaybe<Scalars['Int']>;
  playByPointId?: InputMaybe<Scalars['Int']>;
  totalCourtCount?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "venues" */
export type VenuesInsertInput = {
  accessDetails?: InputMaybe<Scalars['String']>;
  accessType?: InputMaybe<VenueAccessTypesEnum>;
  addressString?: InputMaybe<Scalars['String']>;
  adminUser?: InputMaybe<UsersObjRelInsertInput>;
  amenities?: InputMaybe<VenueAmenitiesArrRelInsertInput>;
  city?: InputMaybe<CitiesObjRelInsertInput>;
  cityId?: InputMaybe<Scalars['uuid']>;
  coordinatesWkb?: InputMaybe<Scalars['String']>;
  courtSurfaces?: InputMaybe<VenueCourtSurfacesArrRelInsertInput>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  customAmenities?: InputMaybe<VenueCustomAmenitiesArrRelInsertInput>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  equipment?: InputMaybe<VenueEquipmentArrRelInsertInput>;
  facebookUrl?: InputMaybe<Scalars['String']>;
  facilityType?: InputMaybe<VenueFacilityTypesEnum>;
  faqs?: InputMaybe<VenueFaqsArrRelInsertInput>;
  featuredPriority?: InputMaybe<Scalars['Int']>;
  geometry?: InputMaybe<Scalars['geography']>;
  googlePlaceId?: InputMaybe<Scalars['String']>;
  groups?: InputMaybe<GroupVenuesArrRelInsertInput>;
  gtnId?: InputMaybe<Scalars['Int']>;
  hasPadel?: InputMaybe<Scalars['Boolean']>;
  hasPickleball?: InputMaybe<Scalars['Boolean']>;
  hasPlatformTennis?: InputMaybe<Scalars['Boolean']>;
  hasReservations?: InputMaybe<Scalars['Boolean']>;
  hasTennis?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  images?: InputMaybe<VenueImagesArrRelInsertInput>;
  indoorCourtCount?: InputMaybe<Scalars['Int']>;
  instagramUrl?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  latitude?: InputMaybe<Scalars['numeric']>;
  lessons?: InputMaybe<LessonsArrRelInsertInput>;
  linkedinUrl?: InputMaybe<Scalars['String']>;
  longitude?: InputMaybe<Scalars['numeric']>;
  outdoorCourtCount?: InputMaybe<Scalars['Int']>;
  partnerBookingStatus?: InputMaybe<VenuePartnerBookingStatusesObjRelInsertInput>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  pickleballLines?: InputMaybe<VenueLinesEnum>;
  pickleballNets?: InputMaybe<VenueNetsEnum>;
  playByPointId?: InputMaybe<Scalars['Int']>;
  playSessions?: InputMaybe<PlaySessionsArrRelInsertInput>;
  scheduleDetails?: InputMaybe<Scalars['String']>;
  shouldAutofillProgramming?: InputMaybe<Scalars['Boolean']>;
  shouldHideDefaultDescription?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  sourceCity?: InputMaybe<Scalars['String']>;
  sourceCityId?: InputMaybe<Scalars['String']>;
  sourceCitySlug?: InputMaybe<Scalars['String']>;
  sourceCountry?: InputMaybe<Scalars['String']>;
  sourceCountrySlug?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  sourceLastFetchedAt?: InputMaybe<Scalars['timestamptz']>;
  sourceLastUpdatedAt?: InputMaybe<Scalars['timestamptz']>;
  sourceName?: InputMaybe<Scalars['String']>;
  sourceStateName?: InputMaybe<Scalars['String']>;
  sourceStateShort?: InputMaybe<Scalars['String']>;
  sourceStateSlug?: InputMaybe<Scalars['String']>;
  staffCoaches?: InputMaybe<VenueStaffCoachesArrRelInsertInput>;
  timezone?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  totalCourtCount?: InputMaybe<Scalars['Int']>;
  twitterUrl?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  venueSlug?: InputMaybe<Scalars['String']>;
  websiteUrl?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type VenuesMaxFields = {
  __typename?: 'VenuesMaxFields';
  accessDetails?: Maybe<Scalars['String']>;
  addressString?: Maybe<Scalars['String']>;
  cityId?: Maybe<Scalars['uuid']>;
  coordinatesWkb?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  facebookUrl?: Maybe<Scalars['String']>;
  featuredPriority?: Maybe<Scalars['Int']>;
  googlePlaceId?: Maybe<Scalars['String']>;
  gtnId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  indoorCourtCount?: Maybe<Scalars['Int']>;
  instagramUrl?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['numeric']>;
  linkedinUrl?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['numeric']>;
  outdoorCourtCount?: Maybe<Scalars['Int']>;
  phoneNumber?: Maybe<Scalars['String']>;
  playByPointId?: Maybe<Scalars['Int']>;
  scheduleDetails?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  sourceCity?: Maybe<Scalars['String']>;
  sourceCityId?: Maybe<Scalars['String']>;
  sourceCitySlug?: Maybe<Scalars['String']>;
  sourceCountry?: Maybe<Scalars['String']>;
  sourceCountrySlug?: Maybe<Scalars['String']>;
  sourceId?: Maybe<Scalars['String']>;
  sourceLastFetchedAt?: Maybe<Scalars['timestamptz']>;
  sourceLastUpdatedAt?: Maybe<Scalars['timestamptz']>;
  sourceName?: Maybe<Scalars['String']>;
  sourceStateName?: Maybe<Scalars['String']>;
  sourceStateShort?: Maybe<Scalars['String']>;
  sourceStateSlug?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  totalCourtCount?: Maybe<Scalars['Int']>;
  twitterUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  venueSlug?: Maybe<Scalars['String']>;
  websiteUrl?: Maybe<Scalars['String']>;
  youtubeUrl?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "venues" */
export type VenuesMaxOrderBy = {
  accessDetails?: InputMaybe<OrderBy>;
  addressString?: InputMaybe<OrderBy>;
  cityId?: InputMaybe<OrderBy>;
  coordinatesWkb?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  email?: InputMaybe<OrderBy>;
  facebookUrl?: InputMaybe<OrderBy>;
  featuredPriority?: InputMaybe<OrderBy>;
  googlePlaceId?: InputMaybe<OrderBy>;
  gtnId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  indoorCourtCount?: InputMaybe<OrderBy>;
  instagramUrl?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  linkedinUrl?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  outdoorCourtCount?: InputMaybe<OrderBy>;
  phoneNumber?: InputMaybe<OrderBy>;
  playByPointId?: InputMaybe<OrderBy>;
  scheduleDetails?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  source?: InputMaybe<OrderBy>;
  sourceCity?: InputMaybe<OrderBy>;
  sourceCityId?: InputMaybe<OrderBy>;
  sourceCitySlug?: InputMaybe<OrderBy>;
  sourceCountry?: InputMaybe<OrderBy>;
  sourceCountrySlug?: InputMaybe<OrderBy>;
  sourceId?: InputMaybe<OrderBy>;
  sourceLastFetchedAt?: InputMaybe<OrderBy>;
  sourceLastUpdatedAt?: InputMaybe<OrderBy>;
  sourceName?: InputMaybe<OrderBy>;
  sourceStateName?: InputMaybe<OrderBy>;
  sourceStateShort?: InputMaybe<OrderBy>;
  sourceStateSlug?: InputMaybe<OrderBy>;
  timezone?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  totalCourtCount?: InputMaybe<OrderBy>;
  twitterUrl?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  venueSlug?: InputMaybe<OrderBy>;
  websiteUrl?: InputMaybe<OrderBy>;
  youtubeUrl?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type VenuesMinFields = {
  __typename?: 'VenuesMinFields';
  accessDetails?: Maybe<Scalars['String']>;
  addressString?: Maybe<Scalars['String']>;
  cityId?: Maybe<Scalars['uuid']>;
  coordinatesWkb?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  facebookUrl?: Maybe<Scalars['String']>;
  featuredPriority?: Maybe<Scalars['Int']>;
  googlePlaceId?: Maybe<Scalars['String']>;
  gtnId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  indoorCourtCount?: Maybe<Scalars['Int']>;
  instagramUrl?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['numeric']>;
  linkedinUrl?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['numeric']>;
  outdoorCourtCount?: Maybe<Scalars['Int']>;
  phoneNumber?: Maybe<Scalars['String']>;
  playByPointId?: Maybe<Scalars['Int']>;
  scheduleDetails?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  sourceCity?: Maybe<Scalars['String']>;
  sourceCityId?: Maybe<Scalars['String']>;
  sourceCitySlug?: Maybe<Scalars['String']>;
  sourceCountry?: Maybe<Scalars['String']>;
  sourceCountrySlug?: Maybe<Scalars['String']>;
  sourceId?: Maybe<Scalars['String']>;
  sourceLastFetchedAt?: Maybe<Scalars['timestamptz']>;
  sourceLastUpdatedAt?: Maybe<Scalars['timestamptz']>;
  sourceName?: Maybe<Scalars['String']>;
  sourceStateName?: Maybe<Scalars['String']>;
  sourceStateShort?: Maybe<Scalars['String']>;
  sourceStateSlug?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  totalCourtCount?: Maybe<Scalars['Int']>;
  twitterUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  venueSlug?: Maybe<Scalars['String']>;
  websiteUrl?: Maybe<Scalars['String']>;
  youtubeUrl?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "venues" */
export type VenuesMinOrderBy = {
  accessDetails?: InputMaybe<OrderBy>;
  addressString?: InputMaybe<OrderBy>;
  cityId?: InputMaybe<OrderBy>;
  coordinatesWkb?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  email?: InputMaybe<OrderBy>;
  facebookUrl?: InputMaybe<OrderBy>;
  featuredPriority?: InputMaybe<OrderBy>;
  googlePlaceId?: InputMaybe<OrderBy>;
  gtnId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  indoorCourtCount?: InputMaybe<OrderBy>;
  instagramUrl?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  linkedinUrl?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  outdoorCourtCount?: InputMaybe<OrderBy>;
  phoneNumber?: InputMaybe<OrderBy>;
  playByPointId?: InputMaybe<OrderBy>;
  scheduleDetails?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  source?: InputMaybe<OrderBy>;
  sourceCity?: InputMaybe<OrderBy>;
  sourceCityId?: InputMaybe<OrderBy>;
  sourceCitySlug?: InputMaybe<OrderBy>;
  sourceCountry?: InputMaybe<OrderBy>;
  sourceCountrySlug?: InputMaybe<OrderBy>;
  sourceId?: InputMaybe<OrderBy>;
  sourceLastFetchedAt?: InputMaybe<OrderBy>;
  sourceLastUpdatedAt?: InputMaybe<OrderBy>;
  sourceName?: InputMaybe<OrderBy>;
  sourceStateName?: InputMaybe<OrderBy>;
  sourceStateShort?: InputMaybe<OrderBy>;
  sourceStateSlug?: InputMaybe<OrderBy>;
  timezone?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  totalCourtCount?: InputMaybe<OrderBy>;
  twitterUrl?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  venueSlug?: InputMaybe<OrderBy>;
  websiteUrl?: InputMaybe<OrderBy>;
  youtubeUrl?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "venues" */
export type VenuesMutationResponse = {
  __typename?: 'VenuesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Venues>;
};

/** input type for inserting object relation for remote table "venues" */
export type VenuesObjRelInsertInput = {
  data: VenuesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<VenuesOnConflict>;
};

/** on_conflict condition type for table "venues" */
export type VenuesOnConflict = {
  constraint: VenuesConstraint;
  updateColumns?: Array<VenuesUpdateColumn>;
  where?: InputMaybe<VenuesBoolExp>;
};

/** Ordering options when selecting data from "venues". */
export type VenuesOrderBy = {
  accessDetails?: InputMaybe<OrderBy>;
  accessType?: InputMaybe<OrderBy>;
  addressString?: InputMaybe<OrderBy>;
  adminUser?: InputMaybe<UsersOrderBy>;
  amenitiesAggregate?: InputMaybe<VenueAmenitiesAggregateOrderBy>;
  city?: InputMaybe<CitiesOrderBy>;
  cityId?: InputMaybe<OrderBy>;
  coordinatesWkb?: InputMaybe<OrderBy>;
  courtSurfacesAggregate?: InputMaybe<VenueCourtSurfacesAggregateOrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  customAmenitiesAggregate?: InputMaybe<VenueCustomAmenitiesAggregateOrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  email?: InputMaybe<OrderBy>;
  equipmentAggregate?: InputMaybe<VenueEquipmentAggregateOrderBy>;
  facebookUrl?: InputMaybe<OrderBy>;
  facilityType?: InputMaybe<OrderBy>;
  faqsAggregate?: InputMaybe<VenueFaqsAggregateOrderBy>;
  featuredPriority?: InputMaybe<OrderBy>;
  geometry?: InputMaybe<OrderBy>;
  googlePlaceId?: InputMaybe<OrderBy>;
  groupsAggregate?: InputMaybe<GroupVenuesAggregateOrderBy>;
  gtnId?: InputMaybe<OrderBy>;
  hasPadel?: InputMaybe<OrderBy>;
  hasPickleball?: InputMaybe<OrderBy>;
  hasPlatformTennis?: InputMaybe<OrderBy>;
  hasReservations?: InputMaybe<OrderBy>;
  hasTennis?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  imagesAggregate?: InputMaybe<VenueImagesAggregateOrderBy>;
  indoorCourtCount?: InputMaybe<OrderBy>;
  instagramUrl?: InputMaybe<OrderBy>;
  isActive?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  lessonsAggregate?: InputMaybe<LessonsAggregateOrderBy>;
  linkedinUrl?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  outdoorCourtCount?: InputMaybe<OrderBy>;
  partnerBookingStatus?: InputMaybe<VenuePartnerBookingStatusesOrderBy>;
  phoneNumber?: InputMaybe<OrderBy>;
  pickleballLines?: InputMaybe<OrderBy>;
  pickleballNets?: InputMaybe<OrderBy>;
  playByPointId?: InputMaybe<OrderBy>;
  playSessionsAggregate?: InputMaybe<PlaySessionsAggregateOrderBy>;
  scheduleDetails?: InputMaybe<OrderBy>;
  shouldAutofillProgramming?: InputMaybe<OrderBy>;
  shouldHideDefaultDescription?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  source?: InputMaybe<OrderBy>;
  sourceCity?: InputMaybe<OrderBy>;
  sourceCityId?: InputMaybe<OrderBy>;
  sourceCitySlug?: InputMaybe<OrderBy>;
  sourceCountry?: InputMaybe<OrderBy>;
  sourceCountrySlug?: InputMaybe<OrderBy>;
  sourceId?: InputMaybe<OrderBy>;
  sourceLastFetchedAt?: InputMaybe<OrderBy>;
  sourceLastUpdatedAt?: InputMaybe<OrderBy>;
  sourceName?: InputMaybe<OrderBy>;
  sourceStateName?: InputMaybe<OrderBy>;
  sourceStateShort?: InputMaybe<OrderBy>;
  sourceStateSlug?: InputMaybe<OrderBy>;
  staffCoachesAggregate?: InputMaybe<VenueStaffCoachesAggregateOrderBy>;
  timezone?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  totalCourtCount?: InputMaybe<OrderBy>;
  twitterUrl?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  venueSlug?: InputMaybe<OrderBy>;
  websiteUrl?: InputMaybe<OrderBy>;
  youtubeUrl?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: venues */
export type VenuesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "venues" */
export enum VenuesSelectColumn {
  /** column name */
  AccessDetails = 'accessDetails',
  /** column name */
  AccessType = 'accessType',
  /** column name */
  AddressString = 'addressString',
  /** column name */
  CityId = 'cityId',
  /** column name */
  CoordinatesWkb = 'coordinatesWkb',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Description = 'description',
  /** column name */
  Email = 'email',
  /** column name */
  FacebookUrl = 'facebookUrl',
  /** column name */
  FacilityType = 'facilityType',
  /** column name */
  FeaturedPriority = 'featuredPriority',
  /** column name */
  Geometry = 'geometry',
  /** column name */
  GooglePlaceId = 'googlePlaceId',
  /** column name */
  GtnId = 'gtnId',
  /** column name */
  HasPadel = 'hasPadel',
  /** column name */
  HasPickleball = 'hasPickleball',
  /** column name */
  HasPlatformTennis = 'hasPlatformTennis',
  /** column name */
  HasReservations = 'hasReservations',
  /** column name */
  HasTennis = 'hasTennis',
  /** column name */
  Id = 'id',
  /** column name */
  IndoorCourtCount = 'indoorCourtCount',
  /** column name */
  InstagramUrl = 'instagramUrl',
  /** column name */
  IsActive = 'isActive',
  /** column name */
  Latitude = 'latitude',
  /** column name */
  LinkedinUrl = 'linkedinUrl',
  /** column name */
  Longitude = 'longitude',
  /** column name */
  OutdoorCourtCount = 'outdoorCourtCount',
  /** column name */
  PhoneNumber = 'phoneNumber',
  /** column name */
  PickleballLines = 'pickleballLines',
  /** column name */
  PickleballNets = 'pickleballNets',
  /** column name */
  PlayByPointId = 'playByPointId',
  /** column name */
  ScheduleDetails = 'scheduleDetails',
  /** column name */
  ShouldAutofillProgramming = 'shouldAutofillProgramming',
  /** column name */
  ShouldHideDefaultDescription = 'shouldHideDefaultDescription',
  /** column name */
  Slug = 'slug',
  /** column name */
  Source = 'source',
  /** column name */
  SourceCity = 'sourceCity',
  /** column name */
  SourceCityId = 'sourceCityId',
  /** column name */
  SourceCitySlug = 'sourceCitySlug',
  /** column name */
  SourceCountry = 'sourceCountry',
  /** column name */
  SourceCountrySlug = 'sourceCountrySlug',
  /** column name */
  SourceId = 'sourceId',
  /** column name */
  SourceLastFetchedAt = 'sourceLastFetchedAt',
  /** column name */
  SourceLastUpdatedAt = 'sourceLastUpdatedAt',
  /** column name */
  SourceName = 'sourceName',
  /** column name */
  SourceStateName = 'sourceStateName',
  /** column name */
  SourceStateShort = 'sourceStateShort',
  /** column name */
  SourceStateSlug = 'sourceStateSlug',
  /** column name */
  Timezone = 'timezone',
  /** column name */
  Title = 'title',
  /** column name */
  TotalCourtCount = 'totalCourtCount',
  /** column name */
  TwitterUrl = 'twitterUrl',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  VenueSlug = 'venueSlug',
  /** column name */
  WebsiteUrl = 'websiteUrl',
  /** column name */
  YoutubeUrl = 'youtubeUrl'
}

/** select "venuesAggregateBoolExpBool_andArgumentsColumns" columns of table "venues" */
export enum VenuesSelectColumnVenuesAggregateBoolExpBool_AndArgumentsColumns {
  /** column name */
  HasPadel = 'hasPadel',
  /** column name */
  HasPickleball = 'hasPickleball',
  /** column name */
  HasPlatformTennis = 'hasPlatformTennis',
  /** column name */
  HasReservations = 'hasReservations',
  /** column name */
  HasTennis = 'hasTennis',
  /** column name */
  IsActive = 'isActive',
  /** column name */
  ShouldAutofillProgramming = 'shouldAutofillProgramming',
  /** column name */
  ShouldHideDefaultDescription = 'shouldHideDefaultDescription'
}

/** select "venuesAggregateBoolExpBool_orArgumentsColumns" columns of table "venues" */
export enum VenuesSelectColumnVenuesAggregateBoolExpBool_OrArgumentsColumns {
  /** column name */
  HasPadel = 'hasPadel',
  /** column name */
  HasPickleball = 'hasPickleball',
  /** column name */
  HasPlatformTennis = 'hasPlatformTennis',
  /** column name */
  HasReservations = 'hasReservations',
  /** column name */
  HasTennis = 'hasTennis',
  /** column name */
  IsActive = 'isActive',
  /** column name */
  ShouldAutofillProgramming = 'shouldAutofillProgramming',
  /** column name */
  ShouldHideDefaultDescription = 'shouldHideDefaultDescription'
}

/** input type for updating data in table "venues" */
export type VenuesSetInput = {
  accessDetails?: InputMaybe<Scalars['String']>;
  accessType?: InputMaybe<VenueAccessTypesEnum>;
  addressString?: InputMaybe<Scalars['String']>;
  cityId?: InputMaybe<Scalars['uuid']>;
  coordinatesWkb?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  facebookUrl?: InputMaybe<Scalars['String']>;
  facilityType?: InputMaybe<VenueFacilityTypesEnum>;
  featuredPriority?: InputMaybe<Scalars['Int']>;
  geometry?: InputMaybe<Scalars['geography']>;
  googlePlaceId?: InputMaybe<Scalars['String']>;
  gtnId?: InputMaybe<Scalars['Int']>;
  hasPadel?: InputMaybe<Scalars['Boolean']>;
  hasPickleball?: InputMaybe<Scalars['Boolean']>;
  hasPlatformTennis?: InputMaybe<Scalars['Boolean']>;
  hasReservations?: InputMaybe<Scalars['Boolean']>;
  hasTennis?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  indoorCourtCount?: InputMaybe<Scalars['Int']>;
  instagramUrl?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  latitude?: InputMaybe<Scalars['numeric']>;
  linkedinUrl?: InputMaybe<Scalars['String']>;
  longitude?: InputMaybe<Scalars['numeric']>;
  outdoorCourtCount?: InputMaybe<Scalars['Int']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  pickleballLines?: InputMaybe<VenueLinesEnum>;
  pickleballNets?: InputMaybe<VenueNetsEnum>;
  playByPointId?: InputMaybe<Scalars['Int']>;
  scheduleDetails?: InputMaybe<Scalars['String']>;
  shouldAutofillProgramming?: InputMaybe<Scalars['Boolean']>;
  shouldHideDefaultDescription?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  sourceCity?: InputMaybe<Scalars['String']>;
  sourceCityId?: InputMaybe<Scalars['String']>;
  sourceCitySlug?: InputMaybe<Scalars['String']>;
  sourceCountry?: InputMaybe<Scalars['String']>;
  sourceCountrySlug?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  sourceLastFetchedAt?: InputMaybe<Scalars['timestamptz']>;
  sourceLastUpdatedAt?: InputMaybe<Scalars['timestamptz']>;
  sourceName?: InputMaybe<Scalars['String']>;
  sourceStateName?: InputMaybe<Scalars['String']>;
  sourceStateShort?: InputMaybe<Scalars['String']>;
  sourceStateSlug?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  totalCourtCount?: InputMaybe<Scalars['Int']>;
  twitterUrl?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  venueSlug?: InputMaybe<Scalars['String']>;
  websiteUrl?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type VenuesStddevFields = {
  __typename?: 'VenuesStddevFields';
  featuredPriority?: Maybe<Scalars['Float']>;
  gtnId?: Maybe<Scalars['Float']>;
  indoorCourtCount?: Maybe<Scalars['Float']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  outdoorCourtCount?: Maybe<Scalars['Float']>;
  playByPointId?: Maybe<Scalars['Float']>;
  totalCourtCount?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "venues" */
export type VenuesStddevOrderBy = {
  featuredPriority?: InputMaybe<OrderBy>;
  gtnId?: InputMaybe<OrderBy>;
  indoorCourtCount?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  outdoorCourtCount?: InputMaybe<OrderBy>;
  playByPointId?: InputMaybe<OrderBy>;
  totalCourtCount?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type VenuesStddevPopFields = {
  __typename?: 'VenuesStddevPopFields';
  featuredPriority?: Maybe<Scalars['Float']>;
  gtnId?: Maybe<Scalars['Float']>;
  indoorCourtCount?: Maybe<Scalars['Float']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  outdoorCourtCount?: Maybe<Scalars['Float']>;
  playByPointId?: Maybe<Scalars['Float']>;
  totalCourtCount?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "venues" */
export type VenuesStddevPopOrderBy = {
  featuredPriority?: InputMaybe<OrderBy>;
  gtnId?: InputMaybe<OrderBy>;
  indoorCourtCount?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  outdoorCourtCount?: InputMaybe<OrderBy>;
  playByPointId?: InputMaybe<OrderBy>;
  totalCourtCount?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type VenuesStddevSampFields = {
  __typename?: 'VenuesStddevSampFields';
  featuredPriority?: Maybe<Scalars['Float']>;
  gtnId?: Maybe<Scalars['Float']>;
  indoorCourtCount?: Maybe<Scalars['Float']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  outdoorCourtCount?: Maybe<Scalars['Float']>;
  playByPointId?: Maybe<Scalars['Float']>;
  totalCourtCount?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "venues" */
export type VenuesStddevSampOrderBy = {
  featuredPriority?: InputMaybe<OrderBy>;
  gtnId?: InputMaybe<OrderBy>;
  indoorCourtCount?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  outdoorCourtCount?: InputMaybe<OrderBy>;
  playByPointId?: InputMaybe<OrderBy>;
  totalCourtCount?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "venues" */
export type VenuesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: VenuesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type VenuesStreamCursorValueInput = {
  accessDetails?: InputMaybe<Scalars['String']>;
  accessType?: InputMaybe<VenueAccessTypesEnum>;
  addressString?: InputMaybe<Scalars['String']>;
  cityId?: InputMaybe<Scalars['uuid']>;
  coordinatesWkb?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  facebookUrl?: InputMaybe<Scalars['String']>;
  facilityType?: InputMaybe<VenueFacilityTypesEnum>;
  featuredPriority?: InputMaybe<Scalars['Int']>;
  geometry?: InputMaybe<Scalars['geography']>;
  googlePlaceId?: InputMaybe<Scalars['String']>;
  gtnId?: InputMaybe<Scalars['Int']>;
  hasPadel?: InputMaybe<Scalars['Boolean']>;
  hasPickleball?: InputMaybe<Scalars['Boolean']>;
  hasPlatformTennis?: InputMaybe<Scalars['Boolean']>;
  hasReservations?: InputMaybe<Scalars['Boolean']>;
  hasTennis?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  indoorCourtCount?: InputMaybe<Scalars['Int']>;
  instagramUrl?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  latitude?: InputMaybe<Scalars['numeric']>;
  linkedinUrl?: InputMaybe<Scalars['String']>;
  longitude?: InputMaybe<Scalars['numeric']>;
  outdoorCourtCount?: InputMaybe<Scalars['Int']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  pickleballLines?: InputMaybe<VenueLinesEnum>;
  pickleballNets?: InputMaybe<VenueNetsEnum>;
  playByPointId?: InputMaybe<Scalars['Int']>;
  scheduleDetails?: InputMaybe<Scalars['String']>;
  shouldAutofillProgramming?: InputMaybe<Scalars['Boolean']>;
  shouldHideDefaultDescription?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  sourceCity?: InputMaybe<Scalars['String']>;
  sourceCityId?: InputMaybe<Scalars['String']>;
  sourceCitySlug?: InputMaybe<Scalars['String']>;
  sourceCountry?: InputMaybe<Scalars['String']>;
  sourceCountrySlug?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  sourceLastFetchedAt?: InputMaybe<Scalars['timestamptz']>;
  sourceLastUpdatedAt?: InputMaybe<Scalars['timestamptz']>;
  sourceName?: InputMaybe<Scalars['String']>;
  sourceStateName?: InputMaybe<Scalars['String']>;
  sourceStateShort?: InputMaybe<Scalars['String']>;
  sourceStateSlug?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  totalCourtCount?: InputMaybe<Scalars['Int']>;
  twitterUrl?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  venueSlug?: InputMaybe<Scalars['String']>;
  websiteUrl?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type VenuesSumFields = {
  __typename?: 'VenuesSumFields';
  featuredPriority?: Maybe<Scalars['Int']>;
  gtnId?: Maybe<Scalars['Int']>;
  indoorCourtCount?: Maybe<Scalars['Int']>;
  latitude?: Maybe<Scalars['numeric']>;
  longitude?: Maybe<Scalars['numeric']>;
  outdoorCourtCount?: Maybe<Scalars['Int']>;
  playByPointId?: Maybe<Scalars['Int']>;
  totalCourtCount?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "venues" */
export type VenuesSumOrderBy = {
  featuredPriority?: InputMaybe<OrderBy>;
  gtnId?: InputMaybe<OrderBy>;
  indoorCourtCount?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  outdoorCourtCount?: InputMaybe<OrderBy>;
  playByPointId?: InputMaybe<OrderBy>;
  totalCourtCount?: InputMaybe<OrderBy>;
};

/** update columns of table "venues" */
export enum VenuesUpdateColumn {
  /** column name */
  AccessDetails = 'accessDetails',
  /** column name */
  AccessType = 'accessType',
  /** column name */
  AddressString = 'addressString',
  /** column name */
  CityId = 'cityId',
  /** column name */
  CoordinatesWkb = 'coordinatesWkb',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Description = 'description',
  /** column name */
  Email = 'email',
  /** column name */
  FacebookUrl = 'facebookUrl',
  /** column name */
  FacilityType = 'facilityType',
  /** column name */
  FeaturedPriority = 'featuredPriority',
  /** column name */
  Geometry = 'geometry',
  /** column name */
  GooglePlaceId = 'googlePlaceId',
  /** column name */
  GtnId = 'gtnId',
  /** column name */
  HasPadel = 'hasPadel',
  /** column name */
  HasPickleball = 'hasPickleball',
  /** column name */
  HasPlatformTennis = 'hasPlatformTennis',
  /** column name */
  HasReservations = 'hasReservations',
  /** column name */
  HasTennis = 'hasTennis',
  /** column name */
  Id = 'id',
  /** column name */
  IndoorCourtCount = 'indoorCourtCount',
  /** column name */
  InstagramUrl = 'instagramUrl',
  /** column name */
  IsActive = 'isActive',
  /** column name */
  Latitude = 'latitude',
  /** column name */
  LinkedinUrl = 'linkedinUrl',
  /** column name */
  Longitude = 'longitude',
  /** column name */
  OutdoorCourtCount = 'outdoorCourtCount',
  /** column name */
  PhoneNumber = 'phoneNumber',
  /** column name */
  PickleballLines = 'pickleballLines',
  /** column name */
  PickleballNets = 'pickleballNets',
  /** column name */
  PlayByPointId = 'playByPointId',
  /** column name */
  ScheduleDetails = 'scheduleDetails',
  /** column name */
  ShouldAutofillProgramming = 'shouldAutofillProgramming',
  /** column name */
  ShouldHideDefaultDescription = 'shouldHideDefaultDescription',
  /** column name */
  Slug = 'slug',
  /** column name */
  Source = 'source',
  /** column name */
  SourceCity = 'sourceCity',
  /** column name */
  SourceCityId = 'sourceCityId',
  /** column name */
  SourceCitySlug = 'sourceCitySlug',
  /** column name */
  SourceCountry = 'sourceCountry',
  /** column name */
  SourceCountrySlug = 'sourceCountrySlug',
  /** column name */
  SourceId = 'sourceId',
  /** column name */
  SourceLastFetchedAt = 'sourceLastFetchedAt',
  /** column name */
  SourceLastUpdatedAt = 'sourceLastUpdatedAt',
  /** column name */
  SourceName = 'sourceName',
  /** column name */
  SourceStateName = 'sourceStateName',
  /** column name */
  SourceStateShort = 'sourceStateShort',
  /** column name */
  SourceStateSlug = 'sourceStateSlug',
  /** column name */
  Timezone = 'timezone',
  /** column name */
  Title = 'title',
  /** column name */
  TotalCourtCount = 'totalCourtCount',
  /** column name */
  TwitterUrl = 'twitterUrl',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  VenueSlug = 'venueSlug',
  /** column name */
  WebsiteUrl = 'websiteUrl',
  /** column name */
  YoutubeUrl = 'youtubeUrl'
}

export type VenuesUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<VenuesIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<VenuesSetInput>;
  /** filter the rows which have to be updated */
  where: VenuesBoolExp;
};

/** aggregate varPop on columns */
export type VenuesVarPopFields = {
  __typename?: 'VenuesVarPopFields';
  featuredPriority?: Maybe<Scalars['Float']>;
  gtnId?: Maybe<Scalars['Float']>;
  indoorCourtCount?: Maybe<Scalars['Float']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  outdoorCourtCount?: Maybe<Scalars['Float']>;
  playByPointId?: Maybe<Scalars['Float']>;
  totalCourtCount?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "venues" */
export type VenuesVarPopOrderBy = {
  featuredPriority?: InputMaybe<OrderBy>;
  gtnId?: InputMaybe<OrderBy>;
  indoorCourtCount?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  outdoorCourtCount?: InputMaybe<OrderBy>;
  playByPointId?: InputMaybe<OrderBy>;
  totalCourtCount?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type VenuesVarSampFields = {
  __typename?: 'VenuesVarSampFields';
  featuredPriority?: Maybe<Scalars['Float']>;
  gtnId?: Maybe<Scalars['Float']>;
  indoorCourtCount?: Maybe<Scalars['Float']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  outdoorCourtCount?: Maybe<Scalars['Float']>;
  playByPointId?: Maybe<Scalars['Float']>;
  totalCourtCount?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "venues" */
export type VenuesVarSampOrderBy = {
  featuredPriority?: InputMaybe<OrderBy>;
  gtnId?: InputMaybe<OrderBy>;
  indoorCourtCount?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  outdoorCourtCount?: InputMaybe<OrderBy>;
  playByPointId?: InputMaybe<OrderBy>;
  totalCourtCount?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type VenuesVarianceFields = {
  __typename?: 'VenuesVarianceFields';
  featuredPriority?: Maybe<Scalars['Float']>;
  gtnId?: Maybe<Scalars['Float']>;
  indoorCourtCount?: Maybe<Scalars['Float']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  outdoorCourtCount?: Maybe<Scalars['Float']>;
  playByPointId?: Maybe<Scalars['Float']>;
  totalCourtCount?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "venues" */
export type VenuesVarianceOrderBy = {
  featuredPriority?: InputMaybe<OrderBy>;
  gtnId?: InputMaybe<OrderBy>;
  indoorCourtCount?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  outdoorCourtCount?: InputMaybe<OrderBy>;
  playByPointId?: InputMaybe<OrderBy>;
  totalCourtCount?: InputMaybe<OrderBy>;
};

/** table for coach video content analysis from player */
export type VideoAnalysis = {
  __typename?: 'VideoAnalysis';
  createdAt: Scalars['timestamptz'];
  currency: Scalars['String'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  locale: Scalars['String'];
  /** An array relationship */
  orders: Array<VideoAnalysisOrders>;
  /** An aggregate relationship */
  ordersAggregate: VideoAnalysisOrdersAggregate;
  paymentFulfillmentChannel?: Maybe<PaymentFulfillmentChannelsEnum>;
  priceUnitAmount: Scalars['Int'];
  reviewStatus?: Maybe<VideoAnalysisReviewStatusesEnum>;
  reviewerUserId: Scalars['uuid'];
  submissionRequestedFeedback: Scalars['String'];
  submissionUserId: Scalars['uuid'];
  timezoneAbbreviation: Scalars['String'];
  timezoneName: Scalars['String'];
  timezoneOffsetMinutes: Scalars['Int'];
  updatedAt: Scalars['timestamptz'];
  /** An array relationship */
  videoAnalysisComments: Array<VideoAnalysisComments>;
  /** An aggregate relationship */
  videoAnalysisCommentsAggregate: VideoAnalysisCommentsAggregate;
  videoAnalysisFileId: Scalars['uuid'];
  /** An object relationship */
  videoAnalysisFiles: VideoAnalysisFiles;
  /** An array relationship */
  videoAnalysisRequestedSkillsReviews: Array<VideoAnalysisRequestedSkillsReview>;
  /** An aggregate relationship */
  videoAnalysisRequestedSkillsReviewsAggregate: VideoAnalysisRequestedSkillsReviewAggregate;
  /** An object relationship */
  videoAnalysisReviewer?: Maybe<UserProfiles>;
  /** An object relationship */
  videoAnalysisSubmission?: Maybe<UserProfiles>;
  /** An object relationship */
  videoAnalysisUserReview?: Maybe<Users>;
  /** An object relationship */
  videoAnalysisUserSubmitter?: Maybe<Users>;
};


/** table for coach video content analysis from player */
export type VideoAnalysisOrdersArgs = {
  distinctOn?: InputMaybe<Array<VideoAnalysisOrdersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoAnalysisOrdersOrderBy>>;
  where?: InputMaybe<VideoAnalysisOrdersBoolExp>;
};


/** table for coach video content analysis from player */
export type VideoAnalysisOrdersAggregateArgs = {
  distinctOn?: InputMaybe<Array<VideoAnalysisOrdersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoAnalysisOrdersOrderBy>>;
  where?: InputMaybe<VideoAnalysisOrdersBoolExp>;
};


/** table for coach video content analysis from player */
export type VideoAnalysisVideoAnalysisCommentsArgs = {
  distinctOn?: InputMaybe<Array<VideoAnalysisCommentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoAnalysisCommentsOrderBy>>;
  where?: InputMaybe<VideoAnalysisCommentsBoolExp>;
};


/** table for coach video content analysis from player */
export type VideoAnalysisVideoAnalysisCommentsAggregateArgs = {
  distinctOn?: InputMaybe<Array<VideoAnalysisCommentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoAnalysisCommentsOrderBy>>;
  where?: InputMaybe<VideoAnalysisCommentsBoolExp>;
};


/** table for coach video content analysis from player */
export type VideoAnalysisVideoAnalysisRequestedSkillsReviewsArgs = {
  distinctOn?: InputMaybe<Array<VideoAnalysisRequestedSkillsReviewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoAnalysisRequestedSkillsReviewOrderBy>>;
  where?: InputMaybe<VideoAnalysisRequestedSkillsReviewBoolExp>;
};


/** table for coach video content analysis from player */
export type VideoAnalysisVideoAnalysisRequestedSkillsReviewsAggregateArgs = {
  distinctOn?: InputMaybe<Array<VideoAnalysisRequestedSkillsReviewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoAnalysisRequestedSkillsReviewOrderBy>>;
  where?: InputMaybe<VideoAnalysisRequestedSkillsReviewBoolExp>;
};

/** aggregated selection of "video_analysis" */
export type VideoAnalysisAggregate = {
  __typename?: 'VideoAnalysisAggregate';
  aggregate?: Maybe<VideoAnalysisAggregateFields>;
  nodes: Array<VideoAnalysis>;
};

export type VideoAnalysisAggregateBoolExp = {
  count?: InputMaybe<VideoAnalysisAggregateBoolExpCount>;
};

/** aggregate fields of "video_analysis" */
export type VideoAnalysisAggregateFields = {
  __typename?: 'VideoAnalysisAggregateFields';
  avg?: Maybe<VideoAnalysisAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<VideoAnalysisMaxFields>;
  min?: Maybe<VideoAnalysisMinFields>;
  stddev?: Maybe<VideoAnalysisStddevFields>;
  stddevPop?: Maybe<VideoAnalysisStddevPopFields>;
  stddevSamp?: Maybe<VideoAnalysisStddevSampFields>;
  sum?: Maybe<VideoAnalysisSumFields>;
  varPop?: Maybe<VideoAnalysisVarPopFields>;
  varSamp?: Maybe<VideoAnalysisVarSampFields>;
  variance?: Maybe<VideoAnalysisVarianceFields>;
};


/** aggregate fields of "video_analysis" */
export type VideoAnalysisAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<VideoAnalysisSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "video_analysis" */
export type VideoAnalysisAggregateOrderBy = {
  avg?: InputMaybe<VideoAnalysisAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<VideoAnalysisMaxOrderBy>;
  min?: InputMaybe<VideoAnalysisMinOrderBy>;
  stddev?: InputMaybe<VideoAnalysisStddevOrderBy>;
  stddevPop?: InputMaybe<VideoAnalysisStddevPopOrderBy>;
  stddevSamp?: InputMaybe<VideoAnalysisStddevSampOrderBy>;
  sum?: InputMaybe<VideoAnalysisSumOrderBy>;
  varPop?: InputMaybe<VideoAnalysisVarPopOrderBy>;
  varSamp?: InputMaybe<VideoAnalysisVarSampOrderBy>;
  variance?: InputMaybe<VideoAnalysisVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "video_analysis" */
export type VideoAnalysisArrRelInsertInput = {
  data: Array<VideoAnalysisInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<VideoAnalysisOnConflict>;
};

/** aggregate avg on columns */
export type VideoAnalysisAvgFields = {
  __typename?: 'VideoAnalysisAvgFields';
  priceUnitAmount?: Maybe<Scalars['Float']>;
  timezoneOffsetMinutes?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "video_analysis" */
export type VideoAnalysisAvgOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
  timezoneOffsetMinutes?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "video_analysis". All fields are combined with a logical 'AND'. */
export type VideoAnalysisBoolExp = {
  _and?: InputMaybe<Array<VideoAnalysisBoolExp>>;
  _not?: InputMaybe<VideoAnalysisBoolExp>;
  _or?: InputMaybe<Array<VideoAnalysisBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  currency?: InputMaybe<StringComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  locale?: InputMaybe<StringComparisonExp>;
  orders?: InputMaybe<VideoAnalysisOrdersBoolExp>;
  ordersAggregate?: InputMaybe<VideoAnalysisOrdersAggregateBoolExp>;
  paymentFulfillmentChannel?: InputMaybe<PaymentFulfillmentChannelsEnumComparisonExp>;
  priceUnitAmount?: InputMaybe<IntComparisonExp>;
  reviewStatus?: InputMaybe<VideoAnalysisReviewStatusesEnumComparisonExp>;
  reviewerUserId?: InputMaybe<UuidComparisonExp>;
  submissionRequestedFeedback?: InputMaybe<StringComparisonExp>;
  submissionUserId?: InputMaybe<UuidComparisonExp>;
  timezoneAbbreviation?: InputMaybe<StringComparisonExp>;
  timezoneName?: InputMaybe<StringComparisonExp>;
  timezoneOffsetMinutes?: InputMaybe<IntComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  videoAnalysisComments?: InputMaybe<VideoAnalysisCommentsBoolExp>;
  videoAnalysisCommentsAggregate?: InputMaybe<VideoAnalysisCommentsAggregateBoolExp>;
  videoAnalysisFileId?: InputMaybe<UuidComparisonExp>;
  videoAnalysisFiles?: InputMaybe<VideoAnalysisFilesBoolExp>;
  videoAnalysisRequestedSkillsReviews?: InputMaybe<VideoAnalysisRequestedSkillsReviewBoolExp>;
  videoAnalysisRequestedSkillsReviewsAggregate?: InputMaybe<VideoAnalysisRequestedSkillsReviewAggregateBoolExp>;
  videoAnalysisReviewer?: InputMaybe<UserProfilesBoolExp>;
  videoAnalysisSubmission?: InputMaybe<UserProfilesBoolExp>;
  videoAnalysisUserReview?: InputMaybe<UsersBoolExp>;
  videoAnalysisUserSubmitter?: InputMaybe<UsersBoolExp>;
};

/** columns and relationships of "video_analysis_comments" */
export type VideoAnalysisComments = {
  __typename?: 'VideoAnalysisComments';
  /** An object relationship */
  commenterUserId: Users;
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  details: Scalars['String'];
  endTimestamp?: Maybe<Scalars['String']>;
  endTimestampSeconds?: Maybe<Scalars['numeric']>;
  id: Scalars['uuid'];
  sentiment: FeedbackSentimentEnum;
  startTimestamp?: Maybe<Scalars['String']>;
  startTimestampSeconds?: Maybe<Scalars['numeric']>;
  updatedAt: Scalars['timestamptz'];
  userId: Scalars['uuid'];
  /** An object relationship */
  videoAnalysis: VideoAnalysis;
  videoAnalysisFileId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  videoAnalysisFiles?: Maybe<VideoAnalysisFiles>;
  videoAnalysisId: Scalars['uuid'];
  /** An array relationship */
  videoAnalysisSkillsComments: Array<VideoAnalysisSkillsComments>;
  /** An aggregate relationship */
  videoAnalysisSkillsCommentsAggregate: VideoAnalysisSkillsCommentsAggregate;
};


/** columns and relationships of "video_analysis_comments" */
export type VideoAnalysisCommentsVideoAnalysisSkillsCommentsArgs = {
  distinctOn?: InputMaybe<Array<VideoAnalysisSkillsCommentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoAnalysisSkillsCommentsOrderBy>>;
  where?: InputMaybe<VideoAnalysisSkillsCommentsBoolExp>;
};


/** columns and relationships of "video_analysis_comments" */
export type VideoAnalysisCommentsVideoAnalysisSkillsCommentsAggregateArgs = {
  distinctOn?: InputMaybe<Array<VideoAnalysisSkillsCommentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoAnalysisSkillsCommentsOrderBy>>;
  where?: InputMaybe<VideoAnalysisSkillsCommentsBoolExp>;
};

/** aggregated selection of "video_analysis_comments" */
export type VideoAnalysisCommentsAggregate = {
  __typename?: 'VideoAnalysisCommentsAggregate';
  aggregate?: Maybe<VideoAnalysisCommentsAggregateFields>;
  nodes: Array<VideoAnalysisComments>;
};

export type VideoAnalysisCommentsAggregateBoolExp = {
  count?: InputMaybe<VideoAnalysisCommentsAggregateBoolExpCount>;
};

/** aggregate fields of "video_analysis_comments" */
export type VideoAnalysisCommentsAggregateFields = {
  __typename?: 'VideoAnalysisCommentsAggregateFields';
  avg?: Maybe<VideoAnalysisCommentsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<VideoAnalysisCommentsMaxFields>;
  min?: Maybe<VideoAnalysisCommentsMinFields>;
  stddev?: Maybe<VideoAnalysisCommentsStddevFields>;
  stddevPop?: Maybe<VideoAnalysisCommentsStddevPopFields>;
  stddevSamp?: Maybe<VideoAnalysisCommentsStddevSampFields>;
  sum?: Maybe<VideoAnalysisCommentsSumFields>;
  varPop?: Maybe<VideoAnalysisCommentsVarPopFields>;
  varSamp?: Maybe<VideoAnalysisCommentsVarSampFields>;
  variance?: Maybe<VideoAnalysisCommentsVarianceFields>;
};


/** aggregate fields of "video_analysis_comments" */
export type VideoAnalysisCommentsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<VideoAnalysisCommentsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "video_analysis_comments" */
export type VideoAnalysisCommentsAggregateOrderBy = {
  avg?: InputMaybe<VideoAnalysisCommentsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<VideoAnalysisCommentsMaxOrderBy>;
  min?: InputMaybe<VideoAnalysisCommentsMinOrderBy>;
  stddev?: InputMaybe<VideoAnalysisCommentsStddevOrderBy>;
  stddevPop?: InputMaybe<VideoAnalysisCommentsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<VideoAnalysisCommentsStddevSampOrderBy>;
  sum?: InputMaybe<VideoAnalysisCommentsSumOrderBy>;
  varPop?: InputMaybe<VideoAnalysisCommentsVarPopOrderBy>;
  varSamp?: InputMaybe<VideoAnalysisCommentsVarSampOrderBy>;
  variance?: InputMaybe<VideoAnalysisCommentsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "video_analysis_comments" */
export type VideoAnalysisCommentsArrRelInsertInput = {
  data: Array<VideoAnalysisCommentsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<VideoAnalysisCommentsOnConflict>;
};

/** aggregate avg on columns */
export type VideoAnalysisCommentsAvgFields = {
  __typename?: 'VideoAnalysisCommentsAvgFields';
  endTimestampSeconds?: Maybe<Scalars['Float']>;
  startTimestampSeconds?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "video_analysis_comments" */
export type VideoAnalysisCommentsAvgOrderBy = {
  endTimestampSeconds?: InputMaybe<OrderBy>;
  startTimestampSeconds?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "video_analysis_comments". All fields are combined with a logical 'AND'. */
export type VideoAnalysisCommentsBoolExp = {
  _and?: InputMaybe<Array<VideoAnalysisCommentsBoolExp>>;
  _not?: InputMaybe<VideoAnalysisCommentsBoolExp>;
  _or?: InputMaybe<Array<VideoAnalysisCommentsBoolExp>>;
  commenterUserId?: InputMaybe<UsersBoolExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  details?: InputMaybe<StringComparisonExp>;
  endTimestamp?: InputMaybe<StringComparisonExp>;
  endTimestampSeconds?: InputMaybe<NumericComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  sentiment?: InputMaybe<FeedbackSentimentEnumComparisonExp>;
  startTimestamp?: InputMaybe<StringComparisonExp>;
  startTimestampSeconds?: InputMaybe<NumericComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  userId?: InputMaybe<UuidComparisonExp>;
  videoAnalysis?: InputMaybe<VideoAnalysisBoolExp>;
  videoAnalysisFileId?: InputMaybe<UuidComparisonExp>;
  videoAnalysisFiles?: InputMaybe<VideoAnalysisFilesBoolExp>;
  videoAnalysisId?: InputMaybe<UuidComparisonExp>;
  videoAnalysisSkillsComments?: InputMaybe<VideoAnalysisSkillsCommentsBoolExp>;
  videoAnalysisSkillsCommentsAggregate?: InputMaybe<VideoAnalysisSkillsCommentsAggregateBoolExp>;
};

/** unique or primary key constraints on table "video_analysis_comments" */
export enum VideoAnalysisCommentsConstraint {
  /** unique or primary key constraint on columns "id" */
  VideoAnalysisCommentsPkey = 'video_analysis_comments_pkey'
}

/** input type for incrementing numeric columns in table "video_analysis_comments" */
export type VideoAnalysisCommentsIncInput = {
  endTimestampSeconds?: InputMaybe<Scalars['numeric']>;
  startTimestampSeconds?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "video_analysis_comments" */
export type VideoAnalysisCommentsInsertInput = {
  commenterUserId?: InputMaybe<UsersObjRelInsertInput>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  details?: InputMaybe<Scalars['String']>;
  endTimestamp?: InputMaybe<Scalars['String']>;
  endTimestampSeconds?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  sentiment?: InputMaybe<FeedbackSentimentEnum>;
  startTimestamp?: InputMaybe<Scalars['String']>;
  startTimestampSeconds?: InputMaybe<Scalars['numeric']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
  videoAnalysis?: InputMaybe<VideoAnalysisObjRelInsertInput>;
  videoAnalysisFileId?: InputMaybe<Scalars['uuid']>;
  videoAnalysisFiles?: InputMaybe<VideoAnalysisFilesObjRelInsertInput>;
  videoAnalysisId?: InputMaybe<Scalars['uuid']>;
  videoAnalysisSkillsComments?: InputMaybe<VideoAnalysisSkillsCommentsArrRelInsertInput>;
};

/** aggregate max on columns */
export type VideoAnalysisCommentsMaxFields = {
  __typename?: 'VideoAnalysisCommentsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  details?: Maybe<Scalars['String']>;
  endTimestamp?: Maybe<Scalars['String']>;
  endTimestampSeconds?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  startTimestamp?: Maybe<Scalars['String']>;
  startTimestampSeconds?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
  videoAnalysisFileId?: Maybe<Scalars['uuid']>;
  videoAnalysisId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "video_analysis_comments" */
export type VideoAnalysisCommentsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  details?: InputMaybe<OrderBy>;
  endTimestamp?: InputMaybe<OrderBy>;
  endTimestampSeconds?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  startTimestamp?: InputMaybe<OrderBy>;
  startTimestampSeconds?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
  videoAnalysisFileId?: InputMaybe<OrderBy>;
  videoAnalysisId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type VideoAnalysisCommentsMinFields = {
  __typename?: 'VideoAnalysisCommentsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  details?: Maybe<Scalars['String']>;
  endTimestamp?: Maybe<Scalars['String']>;
  endTimestampSeconds?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  startTimestamp?: Maybe<Scalars['String']>;
  startTimestampSeconds?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
  videoAnalysisFileId?: Maybe<Scalars['uuid']>;
  videoAnalysisId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "video_analysis_comments" */
export type VideoAnalysisCommentsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  details?: InputMaybe<OrderBy>;
  endTimestamp?: InputMaybe<OrderBy>;
  endTimestampSeconds?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  startTimestamp?: InputMaybe<OrderBy>;
  startTimestampSeconds?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
  videoAnalysisFileId?: InputMaybe<OrderBy>;
  videoAnalysisId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "video_analysis_comments" */
export type VideoAnalysisCommentsMutationResponse = {
  __typename?: 'VideoAnalysisCommentsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<VideoAnalysisComments>;
};

/** input type for inserting object relation for remote table "video_analysis_comments" */
export type VideoAnalysisCommentsObjRelInsertInput = {
  data: VideoAnalysisCommentsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<VideoAnalysisCommentsOnConflict>;
};

/** on_conflict condition type for table "video_analysis_comments" */
export type VideoAnalysisCommentsOnConflict = {
  constraint: VideoAnalysisCommentsConstraint;
  updateColumns?: Array<VideoAnalysisCommentsUpdateColumn>;
  where?: InputMaybe<VideoAnalysisCommentsBoolExp>;
};

/** Ordering options when selecting data from "video_analysis_comments". */
export type VideoAnalysisCommentsOrderBy = {
  commenterUserId?: InputMaybe<UsersOrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  details?: InputMaybe<OrderBy>;
  endTimestamp?: InputMaybe<OrderBy>;
  endTimestampSeconds?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  sentiment?: InputMaybe<OrderBy>;
  startTimestamp?: InputMaybe<OrderBy>;
  startTimestampSeconds?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
  videoAnalysis?: InputMaybe<VideoAnalysisOrderBy>;
  videoAnalysisFileId?: InputMaybe<OrderBy>;
  videoAnalysisFiles?: InputMaybe<VideoAnalysisFilesOrderBy>;
  videoAnalysisId?: InputMaybe<OrderBy>;
  videoAnalysisSkillsCommentsAggregate?: InputMaybe<VideoAnalysisSkillsCommentsAggregateOrderBy>;
};

/** primary key columns input for table: video_analysis_comments */
export type VideoAnalysisCommentsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "video_analysis_comments" */
export enum VideoAnalysisCommentsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Details = 'details',
  /** column name */
  EndTimestamp = 'endTimestamp',
  /** column name */
  EndTimestampSeconds = 'endTimestampSeconds',
  /** column name */
  Id = 'id',
  /** column name */
  Sentiment = 'sentiment',
  /** column name */
  StartTimestamp = 'startTimestamp',
  /** column name */
  StartTimestampSeconds = 'startTimestampSeconds',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId',
  /** column name */
  VideoAnalysisFileId = 'videoAnalysisFileId',
  /** column name */
  VideoAnalysisId = 'videoAnalysisId'
}

/** input type for updating data in table "video_analysis_comments" */
export type VideoAnalysisCommentsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  details?: InputMaybe<Scalars['String']>;
  endTimestamp?: InputMaybe<Scalars['String']>;
  endTimestampSeconds?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  sentiment?: InputMaybe<FeedbackSentimentEnum>;
  startTimestamp?: InputMaybe<Scalars['String']>;
  startTimestampSeconds?: InputMaybe<Scalars['numeric']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
  videoAnalysisFileId?: InputMaybe<Scalars['uuid']>;
  videoAnalysisId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type VideoAnalysisCommentsStddevFields = {
  __typename?: 'VideoAnalysisCommentsStddevFields';
  endTimestampSeconds?: Maybe<Scalars['Float']>;
  startTimestampSeconds?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "video_analysis_comments" */
export type VideoAnalysisCommentsStddevOrderBy = {
  endTimestampSeconds?: InputMaybe<OrderBy>;
  startTimestampSeconds?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type VideoAnalysisCommentsStddevPopFields = {
  __typename?: 'VideoAnalysisCommentsStddevPopFields';
  endTimestampSeconds?: Maybe<Scalars['Float']>;
  startTimestampSeconds?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "video_analysis_comments" */
export type VideoAnalysisCommentsStddevPopOrderBy = {
  endTimestampSeconds?: InputMaybe<OrderBy>;
  startTimestampSeconds?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type VideoAnalysisCommentsStddevSampFields = {
  __typename?: 'VideoAnalysisCommentsStddevSampFields';
  endTimestampSeconds?: Maybe<Scalars['Float']>;
  startTimestampSeconds?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "video_analysis_comments" */
export type VideoAnalysisCommentsStddevSampOrderBy = {
  endTimestampSeconds?: InputMaybe<OrderBy>;
  startTimestampSeconds?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "video_analysis_comments" */
export type VideoAnalysisCommentsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: VideoAnalysisCommentsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type VideoAnalysisCommentsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  details?: InputMaybe<Scalars['String']>;
  endTimestamp?: InputMaybe<Scalars['String']>;
  endTimestampSeconds?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  sentiment?: InputMaybe<FeedbackSentimentEnum>;
  startTimestamp?: InputMaybe<Scalars['String']>;
  startTimestampSeconds?: InputMaybe<Scalars['numeric']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
  videoAnalysisFileId?: InputMaybe<Scalars['uuid']>;
  videoAnalysisId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type VideoAnalysisCommentsSumFields = {
  __typename?: 'VideoAnalysisCommentsSumFields';
  endTimestampSeconds?: Maybe<Scalars['numeric']>;
  startTimestampSeconds?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "video_analysis_comments" */
export type VideoAnalysisCommentsSumOrderBy = {
  endTimestampSeconds?: InputMaybe<OrderBy>;
  startTimestampSeconds?: InputMaybe<OrderBy>;
};

/** update columns of table "video_analysis_comments" */
export enum VideoAnalysisCommentsUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Details = 'details',
  /** column name */
  EndTimestamp = 'endTimestamp',
  /** column name */
  EndTimestampSeconds = 'endTimestampSeconds',
  /** column name */
  Id = 'id',
  /** column name */
  Sentiment = 'sentiment',
  /** column name */
  StartTimestamp = 'startTimestamp',
  /** column name */
  StartTimestampSeconds = 'startTimestampSeconds',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId',
  /** column name */
  VideoAnalysisFileId = 'videoAnalysisFileId',
  /** column name */
  VideoAnalysisId = 'videoAnalysisId'
}

export type VideoAnalysisCommentsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<VideoAnalysisCommentsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<VideoAnalysisCommentsSetInput>;
  /** filter the rows which have to be updated */
  where: VideoAnalysisCommentsBoolExp;
};

/** aggregate varPop on columns */
export type VideoAnalysisCommentsVarPopFields = {
  __typename?: 'VideoAnalysisCommentsVarPopFields';
  endTimestampSeconds?: Maybe<Scalars['Float']>;
  startTimestampSeconds?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "video_analysis_comments" */
export type VideoAnalysisCommentsVarPopOrderBy = {
  endTimestampSeconds?: InputMaybe<OrderBy>;
  startTimestampSeconds?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type VideoAnalysisCommentsVarSampFields = {
  __typename?: 'VideoAnalysisCommentsVarSampFields';
  endTimestampSeconds?: Maybe<Scalars['Float']>;
  startTimestampSeconds?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "video_analysis_comments" */
export type VideoAnalysisCommentsVarSampOrderBy = {
  endTimestampSeconds?: InputMaybe<OrderBy>;
  startTimestampSeconds?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type VideoAnalysisCommentsVarianceFields = {
  __typename?: 'VideoAnalysisCommentsVarianceFields';
  endTimestampSeconds?: Maybe<Scalars['Float']>;
  startTimestampSeconds?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "video_analysis_comments" */
export type VideoAnalysisCommentsVarianceOrderBy = {
  endTimestampSeconds?: InputMaybe<OrderBy>;
  startTimestampSeconds?: InputMaybe<OrderBy>;
};

/** unique or primary key constraints on table "video_analysis" */
export enum VideoAnalysisConstraint {
  /** unique or primary key constraint on columns "id" */
  VideoAnalysisPkey = 'video_analysis_pkey'
}

/** columns and relationships of "video_analysis_files" */
export type VideoAnalysisFiles = {
  __typename?: 'VideoAnalysisFiles';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  fileCategory: FileCategoryEnum;
  fileFormat: FileFormatEnum;
  fileName: Scalars['String'];
  fileType: Scalars['String'];
  host: Scalars['String'];
  id: Scalars['uuid'];
  originalFileName?: Maybe<Scalars['String']>;
  provider: Scalars['String'];
  providerId: Scalars['String'];
  providerUrl: Scalars['String'];
  transcript: Scalars['String'];
  transcriptionCompletedAt?: Maybe<Scalars['timestamptz']>;
  transcriptionStartedAt?: Maybe<Scalars['timestamptz']>;
  updatedAt: Scalars['timestamptz'];
  uploadStatus: VideoAnalysisFilesUploadStatusesEnum;
  url: Scalars['String'];
  userId: Scalars['uuid'];
};

/** aggregated selection of "video_analysis_files" */
export type VideoAnalysisFilesAggregate = {
  __typename?: 'VideoAnalysisFilesAggregate';
  aggregate?: Maybe<VideoAnalysisFilesAggregateFields>;
  nodes: Array<VideoAnalysisFiles>;
};

export type VideoAnalysisFilesAggregateBoolExp = {
  count?: InputMaybe<VideoAnalysisFilesAggregateBoolExpCount>;
};

/** aggregate fields of "video_analysis_files" */
export type VideoAnalysisFilesAggregateFields = {
  __typename?: 'VideoAnalysisFilesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<VideoAnalysisFilesMaxFields>;
  min?: Maybe<VideoAnalysisFilesMinFields>;
};


/** aggregate fields of "video_analysis_files" */
export type VideoAnalysisFilesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<VideoAnalysisFilesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "video_analysis_files" */
export type VideoAnalysisFilesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<VideoAnalysisFilesMaxOrderBy>;
  min?: InputMaybe<VideoAnalysisFilesMinOrderBy>;
};

/** input type for inserting array relation for remote table "video_analysis_files" */
export type VideoAnalysisFilesArrRelInsertInput = {
  data: Array<VideoAnalysisFilesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<VideoAnalysisFilesOnConflict>;
};

/** Boolean expression to filter rows from the table "video_analysis_files". All fields are combined with a logical 'AND'. */
export type VideoAnalysisFilesBoolExp = {
  _and?: InputMaybe<Array<VideoAnalysisFilesBoolExp>>;
  _not?: InputMaybe<VideoAnalysisFilesBoolExp>;
  _or?: InputMaybe<Array<VideoAnalysisFilesBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  fileCategory?: InputMaybe<FileCategoryEnumComparisonExp>;
  fileFormat?: InputMaybe<FileFormatEnumComparisonExp>;
  fileName?: InputMaybe<StringComparisonExp>;
  fileType?: InputMaybe<StringComparisonExp>;
  host?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  originalFileName?: InputMaybe<StringComparisonExp>;
  provider?: InputMaybe<StringComparisonExp>;
  providerId?: InputMaybe<StringComparisonExp>;
  providerUrl?: InputMaybe<StringComparisonExp>;
  transcript?: InputMaybe<StringComparisonExp>;
  transcriptionCompletedAt?: InputMaybe<TimestamptzComparisonExp>;
  transcriptionStartedAt?: InputMaybe<TimestamptzComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  uploadStatus?: InputMaybe<VideoAnalysisFilesUploadStatusesEnumComparisonExp>;
  url?: InputMaybe<StringComparisonExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "video_analysis_files" */
export enum VideoAnalysisFilesConstraint {
  /** unique or primary key constraint on columns "id" */
  VideoAnalysisFilesPkey = 'video_analysis_files_pkey'
}

/** input type for inserting data into table "video_analysis_files" */
export type VideoAnalysisFilesInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  fileCategory?: InputMaybe<FileCategoryEnum>;
  fileFormat?: InputMaybe<FileFormatEnum>;
  fileName?: InputMaybe<Scalars['String']>;
  fileType?: InputMaybe<Scalars['String']>;
  host?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  originalFileName?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  providerId?: InputMaybe<Scalars['String']>;
  providerUrl?: InputMaybe<Scalars['String']>;
  transcript?: InputMaybe<Scalars['String']>;
  transcriptionCompletedAt?: InputMaybe<Scalars['timestamptz']>;
  transcriptionStartedAt?: InputMaybe<Scalars['timestamptz']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  uploadStatus?: InputMaybe<VideoAnalysisFilesUploadStatusesEnum>;
  url?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type VideoAnalysisFilesMaxFields = {
  __typename?: 'VideoAnalysisFilesMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  fileName?: Maybe<Scalars['String']>;
  fileType?: Maybe<Scalars['String']>;
  host?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  originalFileName?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  providerId?: Maybe<Scalars['String']>;
  providerUrl?: Maybe<Scalars['String']>;
  transcript?: Maybe<Scalars['String']>;
  transcriptionCompletedAt?: Maybe<Scalars['timestamptz']>;
  transcriptionStartedAt?: Maybe<Scalars['timestamptz']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  url?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "video_analysis_files" */
export type VideoAnalysisFilesMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  fileName?: InputMaybe<OrderBy>;
  fileType?: InputMaybe<OrderBy>;
  host?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  originalFileName?: InputMaybe<OrderBy>;
  provider?: InputMaybe<OrderBy>;
  providerId?: InputMaybe<OrderBy>;
  providerUrl?: InputMaybe<OrderBy>;
  transcript?: InputMaybe<OrderBy>;
  transcriptionCompletedAt?: InputMaybe<OrderBy>;
  transcriptionStartedAt?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  url?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type VideoAnalysisFilesMinFields = {
  __typename?: 'VideoAnalysisFilesMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  fileName?: Maybe<Scalars['String']>;
  fileType?: Maybe<Scalars['String']>;
  host?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  originalFileName?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  providerId?: Maybe<Scalars['String']>;
  providerUrl?: Maybe<Scalars['String']>;
  transcript?: Maybe<Scalars['String']>;
  transcriptionCompletedAt?: Maybe<Scalars['timestamptz']>;
  transcriptionStartedAt?: Maybe<Scalars['timestamptz']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  url?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "video_analysis_files" */
export type VideoAnalysisFilesMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  fileName?: InputMaybe<OrderBy>;
  fileType?: InputMaybe<OrderBy>;
  host?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  originalFileName?: InputMaybe<OrderBy>;
  provider?: InputMaybe<OrderBy>;
  providerId?: InputMaybe<OrderBy>;
  providerUrl?: InputMaybe<OrderBy>;
  transcript?: InputMaybe<OrderBy>;
  transcriptionCompletedAt?: InputMaybe<OrderBy>;
  transcriptionStartedAt?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  url?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "video_analysis_files" */
export type VideoAnalysisFilesMutationResponse = {
  __typename?: 'VideoAnalysisFilesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<VideoAnalysisFiles>;
};

/** input type for inserting object relation for remote table "video_analysis_files" */
export type VideoAnalysisFilesObjRelInsertInput = {
  data: VideoAnalysisFilesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<VideoAnalysisFilesOnConflict>;
};

/** on_conflict condition type for table "video_analysis_files" */
export type VideoAnalysisFilesOnConflict = {
  constraint: VideoAnalysisFilesConstraint;
  updateColumns?: Array<VideoAnalysisFilesUpdateColumn>;
  where?: InputMaybe<VideoAnalysisFilesBoolExp>;
};

/** Ordering options when selecting data from "video_analysis_files". */
export type VideoAnalysisFilesOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  fileCategory?: InputMaybe<OrderBy>;
  fileFormat?: InputMaybe<OrderBy>;
  fileName?: InputMaybe<OrderBy>;
  fileType?: InputMaybe<OrderBy>;
  host?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  originalFileName?: InputMaybe<OrderBy>;
  provider?: InputMaybe<OrderBy>;
  providerId?: InputMaybe<OrderBy>;
  providerUrl?: InputMaybe<OrderBy>;
  transcript?: InputMaybe<OrderBy>;
  transcriptionCompletedAt?: InputMaybe<OrderBy>;
  transcriptionStartedAt?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  uploadStatus?: InputMaybe<OrderBy>;
  url?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: video_analysis_files */
export type VideoAnalysisFilesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "video_analysis_files" */
export enum VideoAnalysisFilesSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  FileCategory = 'fileCategory',
  /** column name */
  FileFormat = 'fileFormat',
  /** column name */
  FileName = 'fileName',
  /** column name */
  FileType = 'fileType',
  /** column name */
  Host = 'host',
  /** column name */
  Id = 'id',
  /** column name */
  OriginalFileName = 'originalFileName',
  /** column name */
  Provider = 'provider',
  /** column name */
  ProviderId = 'providerId',
  /** column name */
  ProviderUrl = 'providerUrl',
  /** column name */
  Transcript = 'transcript',
  /** column name */
  TranscriptionCompletedAt = 'transcriptionCompletedAt',
  /** column name */
  TranscriptionStartedAt = 'transcriptionStartedAt',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UploadStatus = 'uploadStatus',
  /** column name */
  Url = 'url',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "video_analysis_files" */
export type VideoAnalysisFilesSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  fileCategory?: InputMaybe<FileCategoryEnum>;
  fileFormat?: InputMaybe<FileFormatEnum>;
  fileName?: InputMaybe<Scalars['String']>;
  fileType?: InputMaybe<Scalars['String']>;
  host?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  originalFileName?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  providerId?: InputMaybe<Scalars['String']>;
  providerUrl?: InputMaybe<Scalars['String']>;
  transcript?: InputMaybe<Scalars['String']>;
  transcriptionCompletedAt?: InputMaybe<Scalars['timestamptz']>;
  transcriptionStartedAt?: InputMaybe<Scalars['timestamptz']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  uploadStatus?: InputMaybe<VideoAnalysisFilesUploadStatusesEnum>;
  url?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "video_analysis_files" */
export type VideoAnalysisFilesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: VideoAnalysisFilesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type VideoAnalysisFilesStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  fileCategory?: InputMaybe<FileCategoryEnum>;
  fileFormat?: InputMaybe<FileFormatEnum>;
  fileName?: InputMaybe<Scalars['String']>;
  fileType?: InputMaybe<Scalars['String']>;
  host?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  originalFileName?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  providerId?: InputMaybe<Scalars['String']>;
  providerUrl?: InputMaybe<Scalars['String']>;
  transcript?: InputMaybe<Scalars['String']>;
  transcriptionCompletedAt?: InputMaybe<Scalars['timestamptz']>;
  transcriptionStartedAt?: InputMaybe<Scalars['timestamptz']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  uploadStatus?: InputMaybe<VideoAnalysisFilesUploadStatusesEnum>;
  url?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "video_analysis_files" */
export enum VideoAnalysisFilesUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  FileCategory = 'fileCategory',
  /** column name */
  FileFormat = 'fileFormat',
  /** column name */
  FileName = 'fileName',
  /** column name */
  FileType = 'fileType',
  /** column name */
  Host = 'host',
  /** column name */
  Id = 'id',
  /** column name */
  OriginalFileName = 'originalFileName',
  /** column name */
  Provider = 'provider',
  /** column name */
  ProviderId = 'providerId',
  /** column name */
  ProviderUrl = 'providerUrl',
  /** column name */
  Transcript = 'transcript',
  /** column name */
  TranscriptionCompletedAt = 'transcriptionCompletedAt',
  /** column name */
  TranscriptionStartedAt = 'transcriptionStartedAt',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UploadStatus = 'uploadStatus',
  /** column name */
  Url = 'url',
  /** column name */
  UserId = 'userId'
}

export type VideoAnalysisFilesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<VideoAnalysisFilesSetInput>;
  /** filter the rows which have to be updated */
  where: VideoAnalysisFilesBoolExp;
};

/** columns and relationships of "video_analysis_files_upload_statuses" */
export type VideoAnalysisFilesUploadStatuses = {
  __typename?: 'VideoAnalysisFilesUploadStatuses';
  description: Scalars['String'];
  value: Scalars['String'];
};

/** aggregated selection of "video_analysis_files_upload_statuses" */
export type VideoAnalysisFilesUploadStatusesAggregate = {
  __typename?: 'VideoAnalysisFilesUploadStatusesAggregate';
  aggregate?: Maybe<VideoAnalysisFilesUploadStatusesAggregateFields>;
  nodes: Array<VideoAnalysisFilesUploadStatuses>;
};

/** aggregate fields of "video_analysis_files_upload_statuses" */
export type VideoAnalysisFilesUploadStatusesAggregateFields = {
  __typename?: 'VideoAnalysisFilesUploadStatusesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<VideoAnalysisFilesUploadStatusesMaxFields>;
  min?: Maybe<VideoAnalysisFilesUploadStatusesMinFields>;
};


/** aggregate fields of "video_analysis_files_upload_statuses" */
export type VideoAnalysisFilesUploadStatusesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<VideoAnalysisFilesUploadStatusesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "video_analysis_files_upload_statuses". All fields are combined with a logical 'AND'. */
export type VideoAnalysisFilesUploadStatusesBoolExp = {
  _and?: InputMaybe<Array<VideoAnalysisFilesUploadStatusesBoolExp>>;
  _not?: InputMaybe<VideoAnalysisFilesUploadStatusesBoolExp>;
  _or?: InputMaybe<Array<VideoAnalysisFilesUploadStatusesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "video_analysis_files_upload_statuses" */
export enum VideoAnalysisFilesUploadStatusesConstraint {
  /** unique or primary key constraint on columns "value" */
  VideoAnalysisFilesUploadStatusesPkey = 'video_analysis_files_upload_statuses_pkey'
}

export enum VideoAnalysisFilesUploadStatusesEnum {
  Complete = 'COMPLETE',
  Failed = 'FAILED',
  Pending = 'PENDING'
}

/** Boolean expression to compare columns of type "VideoAnalysisFilesUploadStatusesEnum". All fields are combined with logical 'AND'. */
export type VideoAnalysisFilesUploadStatusesEnumComparisonExp = {
  _eq?: InputMaybe<VideoAnalysisFilesUploadStatusesEnum>;
  _in?: InputMaybe<Array<VideoAnalysisFilesUploadStatusesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<VideoAnalysisFilesUploadStatusesEnum>;
  _nin?: InputMaybe<Array<VideoAnalysisFilesUploadStatusesEnum>>;
};

/** input type for inserting data into table "video_analysis_files_upload_statuses" */
export type VideoAnalysisFilesUploadStatusesInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type VideoAnalysisFilesUploadStatusesMaxFields = {
  __typename?: 'VideoAnalysisFilesUploadStatusesMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type VideoAnalysisFilesUploadStatusesMinFields = {
  __typename?: 'VideoAnalysisFilesUploadStatusesMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "video_analysis_files_upload_statuses" */
export type VideoAnalysisFilesUploadStatusesMutationResponse = {
  __typename?: 'VideoAnalysisFilesUploadStatusesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<VideoAnalysisFilesUploadStatuses>;
};

/** on_conflict condition type for table "video_analysis_files_upload_statuses" */
export type VideoAnalysisFilesUploadStatusesOnConflict = {
  constraint: VideoAnalysisFilesUploadStatusesConstraint;
  updateColumns?: Array<VideoAnalysisFilesUploadStatusesUpdateColumn>;
  where?: InputMaybe<VideoAnalysisFilesUploadStatusesBoolExp>;
};

/** Ordering options when selecting data from "video_analysis_files_upload_statuses". */
export type VideoAnalysisFilesUploadStatusesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: video_analysis_files_upload_statuses */
export type VideoAnalysisFilesUploadStatusesPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "video_analysis_files_upload_statuses" */
export enum VideoAnalysisFilesUploadStatusesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "video_analysis_files_upload_statuses" */
export type VideoAnalysisFilesUploadStatusesSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "video_analysis_files_upload_statuses" */
export type VideoAnalysisFilesUploadStatusesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: VideoAnalysisFilesUploadStatusesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type VideoAnalysisFilesUploadStatusesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "video_analysis_files_upload_statuses" */
export enum VideoAnalysisFilesUploadStatusesUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type VideoAnalysisFilesUploadStatusesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<VideoAnalysisFilesUploadStatusesSetInput>;
  /** filter the rows which have to be updated */
  where: VideoAnalysisFilesUploadStatusesBoolExp;
};

/** input type for incrementing numeric columns in table "video_analysis" */
export type VideoAnalysisIncInput = {
  priceUnitAmount?: InputMaybe<Scalars['Int']>;
  timezoneOffsetMinutes?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "video_analysis" */
export type VideoAnalysisInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  locale?: InputMaybe<Scalars['String']>;
  orders?: InputMaybe<VideoAnalysisOrdersArrRelInsertInput>;
  paymentFulfillmentChannel?: InputMaybe<PaymentFulfillmentChannelsEnum>;
  priceUnitAmount?: InputMaybe<Scalars['Int']>;
  reviewStatus?: InputMaybe<VideoAnalysisReviewStatusesEnum>;
  reviewerUserId?: InputMaybe<Scalars['uuid']>;
  submissionRequestedFeedback?: InputMaybe<Scalars['String']>;
  submissionUserId?: InputMaybe<Scalars['uuid']>;
  timezoneAbbreviation?: InputMaybe<Scalars['String']>;
  timezoneName?: InputMaybe<Scalars['String']>;
  timezoneOffsetMinutes?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  videoAnalysisComments?: InputMaybe<VideoAnalysisCommentsArrRelInsertInput>;
  videoAnalysisFileId?: InputMaybe<Scalars['uuid']>;
  videoAnalysisFiles?: InputMaybe<VideoAnalysisFilesObjRelInsertInput>;
  videoAnalysisRequestedSkillsReviews?: InputMaybe<VideoAnalysisRequestedSkillsReviewArrRelInsertInput>;
  videoAnalysisReviewer?: InputMaybe<UserProfilesObjRelInsertInput>;
  videoAnalysisSubmission?: InputMaybe<UserProfilesObjRelInsertInput>;
  videoAnalysisUserReview?: InputMaybe<UsersObjRelInsertInput>;
  videoAnalysisUserSubmitter?: InputMaybe<UsersObjRelInsertInput>;
};

/** aggregate max on columns */
export type VideoAnalysisMaxFields = {
  __typename?: 'VideoAnalysisMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  locale?: Maybe<Scalars['String']>;
  priceUnitAmount?: Maybe<Scalars['Int']>;
  reviewerUserId?: Maybe<Scalars['uuid']>;
  submissionRequestedFeedback?: Maybe<Scalars['String']>;
  submissionUserId?: Maybe<Scalars['uuid']>;
  timezoneAbbreviation?: Maybe<Scalars['String']>;
  timezoneName?: Maybe<Scalars['String']>;
  timezoneOffsetMinutes?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  videoAnalysisFileId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "video_analysis" */
export type VideoAnalysisMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  currency?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  locale?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  reviewerUserId?: InputMaybe<OrderBy>;
  submissionRequestedFeedback?: InputMaybe<OrderBy>;
  submissionUserId?: InputMaybe<OrderBy>;
  timezoneAbbreviation?: InputMaybe<OrderBy>;
  timezoneName?: InputMaybe<OrderBy>;
  timezoneOffsetMinutes?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  videoAnalysisFileId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type VideoAnalysisMinFields = {
  __typename?: 'VideoAnalysisMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  locale?: Maybe<Scalars['String']>;
  priceUnitAmount?: Maybe<Scalars['Int']>;
  reviewerUserId?: Maybe<Scalars['uuid']>;
  submissionRequestedFeedback?: Maybe<Scalars['String']>;
  submissionUserId?: Maybe<Scalars['uuid']>;
  timezoneAbbreviation?: Maybe<Scalars['String']>;
  timezoneName?: Maybe<Scalars['String']>;
  timezoneOffsetMinutes?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  videoAnalysisFileId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "video_analysis" */
export type VideoAnalysisMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  currency?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  locale?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  reviewerUserId?: InputMaybe<OrderBy>;
  submissionRequestedFeedback?: InputMaybe<OrderBy>;
  submissionUserId?: InputMaybe<OrderBy>;
  timezoneAbbreviation?: InputMaybe<OrderBy>;
  timezoneName?: InputMaybe<OrderBy>;
  timezoneOffsetMinutes?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  videoAnalysisFileId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "video_analysis" */
export type VideoAnalysisMutationResponse = {
  __typename?: 'VideoAnalysisMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<VideoAnalysis>;
};

/** input type for inserting object relation for remote table "video_analysis" */
export type VideoAnalysisObjRelInsertInput = {
  data: VideoAnalysisInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<VideoAnalysisOnConflict>;
};

/** on_conflict condition type for table "video_analysis" */
export type VideoAnalysisOnConflict = {
  constraint: VideoAnalysisConstraint;
  updateColumns?: Array<VideoAnalysisUpdateColumn>;
  where?: InputMaybe<VideoAnalysisBoolExp>;
};

/** Ordering options when selecting data from "video_analysis". */
export type VideoAnalysisOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  currency?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  locale?: InputMaybe<OrderBy>;
  ordersAggregate?: InputMaybe<VideoAnalysisOrdersAggregateOrderBy>;
  paymentFulfillmentChannel?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  reviewStatus?: InputMaybe<OrderBy>;
  reviewerUserId?: InputMaybe<OrderBy>;
  submissionRequestedFeedback?: InputMaybe<OrderBy>;
  submissionUserId?: InputMaybe<OrderBy>;
  timezoneAbbreviation?: InputMaybe<OrderBy>;
  timezoneName?: InputMaybe<OrderBy>;
  timezoneOffsetMinutes?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  videoAnalysisCommentsAggregate?: InputMaybe<VideoAnalysisCommentsAggregateOrderBy>;
  videoAnalysisFileId?: InputMaybe<OrderBy>;
  videoAnalysisFiles?: InputMaybe<VideoAnalysisFilesOrderBy>;
  videoAnalysisRequestedSkillsReviewsAggregate?: InputMaybe<VideoAnalysisRequestedSkillsReviewAggregateOrderBy>;
  videoAnalysisReviewer?: InputMaybe<UserProfilesOrderBy>;
  videoAnalysisSubmission?: InputMaybe<UserProfilesOrderBy>;
  videoAnalysisUserReview?: InputMaybe<UsersOrderBy>;
  videoAnalysisUserSubmitter?: InputMaybe<UsersOrderBy>;
};

/** columns and relationships of "video_analysis_order_items" */
export type VideoAnalysisOrderItems = {
  __typename?: 'VideoAnalysisOrderItems';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  /** An object relationship */
  order?: Maybe<VideoAnalysisOrders>;
  priceUnitAmount: Scalars['Int'];
  refundUnitAmount: Scalars['Int'];
  refundedAt?: Maybe<Scalars['timestamptz']>;
  refundedByPersona?: Maybe<AppPersonasEnum>;
  status: OrderStatusesEnum;
  totalUnitAmount: Scalars['Int'];
  updatedAt: Scalars['timestamptz'];
  videoAnalysisOrderId: Scalars['uuid'];
};

/** aggregated selection of "video_analysis_order_items" */
export type VideoAnalysisOrderItemsAggregate = {
  __typename?: 'VideoAnalysisOrderItemsAggregate';
  aggregate?: Maybe<VideoAnalysisOrderItemsAggregateFields>;
  nodes: Array<VideoAnalysisOrderItems>;
};

export type VideoAnalysisOrderItemsAggregateBoolExp = {
  count?: InputMaybe<VideoAnalysisOrderItemsAggregateBoolExpCount>;
};

/** aggregate fields of "video_analysis_order_items" */
export type VideoAnalysisOrderItemsAggregateFields = {
  __typename?: 'VideoAnalysisOrderItemsAggregateFields';
  avg?: Maybe<VideoAnalysisOrderItemsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<VideoAnalysisOrderItemsMaxFields>;
  min?: Maybe<VideoAnalysisOrderItemsMinFields>;
  stddev?: Maybe<VideoAnalysisOrderItemsStddevFields>;
  stddevPop?: Maybe<VideoAnalysisOrderItemsStddevPopFields>;
  stddevSamp?: Maybe<VideoAnalysisOrderItemsStddevSampFields>;
  sum?: Maybe<VideoAnalysisOrderItemsSumFields>;
  varPop?: Maybe<VideoAnalysisOrderItemsVarPopFields>;
  varSamp?: Maybe<VideoAnalysisOrderItemsVarSampFields>;
  variance?: Maybe<VideoAnalysisOrderItemsVarianceFields>;
};


/** aggregate fields of "video_analysis_order_items" */
export type VideoAnalysisOrderItemsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<VideoAnalysisOrderItemsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "video_analysis_order_items" */
export type VideoAnalysisOrderItemsAggregateOrderBy = {
  avg?: InputMaybe<VideoAnalysisOrderItemsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<VideoAnalysisOrderItemsMaxOrderBy>;
  min?: InputMaybe<VideoAnalysisOrderItemsMinOrderBy>;
  stddev?: InputMaybe<VideoAnalysisOrderItemsStddevOrderBy>;
  stddevPop?: InputMaybe<VideoAnalysisOrderItemsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<VideoAnalysisOrderItemsStddevSampOrderBy>;
  sum?: InputMaybe<VideoAnalysisOrderItemsSumOrderBy>;
  varPop?: InputMaybe<VideoAnalysisOrderItemsVarPopOrderBy>;
  varSamp?: InputMaybe<VideoAnalysisOrderItemsVarSampOrderBy>;
  variance?: InputMaybe<VideoAnalysisOrderItemsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "video_analysis_order_items" */
export type VideoAnalysisOrderItemsArrRelInsertInput = {
  data: Array<VideoAnalysisOrderItemsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<VideoAnalysisOrderItemsOnConflict>;
};

/** aggregate avg on columns */
export type VideoAnalysisOrderItemsAvgFields = {
  __typename?: 'VideoAnalysisOrderItemsAvgFields';
  priceUnitAmount?: Maybe<Scalars['Float']>;
  refundUnitAmount?: Maybe<Scalars['Float']>;
  totalUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "video_analysis_order_items" */
export type VideoAnalysisOrderItemsAvgOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  totalUnitAmount?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "video_analysis_order_items". All fields are combined with a logical 'AND'. */
export type VideoAnalysisOrderItemsBoolExp = {
  _and?: InputMaybe<Array<VideoAnalysisOrderItemsBoolExp>>;
  _not?: InputMaybe<VideoAnalysisOrderItemsBoolExp>;
  _or?: InputMaybe<Array<VideoAnalysisOrderItemsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  order?: InputMaybe<VideoAnalysisOrdersBoolExp>;
  priceUnitAmount?: InputMaybe<IntComparisonExp>;
  refundUnitAmount?: InputMaybe<IntComparisonExp>;
  refundedAt?: InputMaybe<TimestamptzComparisonExp>;
  refundedByPersona?: InputMaybe<AppPersonasEnumComparisonExp>;
  status?: InputMaybe<OrderStatusesEnumComparisonExp>;
  totalUnitAmount?: InputMaybe<IntComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  videoAnalysisOrderId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "video_analysis_order_items" */
export enum VideoAnalysisOrderItemsConstraint {
  /** unique or primary key constraint on columns "id" */
  VideoAnalysisOrderItemsPkey = 'video_analysis_order_items_pkey'
}

/** input type for incrementing numeric columns in table "video_analysis_order_items" */
export type VideoAnalysisOrderItemsIncInput = {
  priceUnitAmount?: InputMaybe<Scalars['Int']>;
  refundUnitAmount?: InputMaybe<Scalars['Int']>;
  totalUnitAmount?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "video_analysis_order_items" */
export type VideoAnalysisOrderItemsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  order?: InputMaybe<VideoAnalysisOrdersObjRelInsertInput>;
  priceUnitAmount?: InputMaybe<Scalars['Int']>;
  refundUnitAmount?: InputMaybe<Scalars['Int']>;
  refundedAt?: InputMaybe<Scalars['timestamptz']>;
  refundedByPersona?: InputMaybe<AppPersonasEnum>;
  status?: InputMaybe<OrderStatusesEnum>;
  totalUnitAmount?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  videoAnalysisOrderId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type VideoAnalysisOrderItemsMaxFields = {
  __typename?: 'VideoAnalysisOrderItemsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  priceUnitAmount?: Maybe<Scalars['Int']>;
  refundUnitAmount?: Maybe<Scalars['Int']>;
  refundedAt?: Maybe<Scalars['timestamptz']>;
  totalUnitAmount?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  videoAnalysisOrderId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "video_analysis_order_items" */
export type VideoAnalysisOrderItemsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  refundedAt?: InputMaybe<OrderBy>;
  totalUnitAmount?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  videoAnalysisOrderId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type VideoAnalysisOrderItemsMinFields = {
  __typename?: 'VideoAnalysisOrderItemsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  priceUnitAmount?: Maybe<Scalars['Int']>;
  refundUnitAmount?: Maybe<Scalars['Int']>;
  refundedAt?: Maybe<Scalars['timestamptz']>;
  totalUnitAmount?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  videoAnalysisOrderId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "video_analysis_order_items" */
export type VideoAnalysisOrderItemsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  refundedAt?: InputMaybe<OrderBy>;
  totalUnitAmount?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  videoAnalysisOrderId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "video_analysis_order_items" */
export type VideoAnalysisOrderItemsMutationResponse = {
  __typename?: 'VideoAnalysisOrderItemsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<VideoAnalysisOrderItems>;
};

/** on_conflict condition type for table "video_analysis_order_items" */
export type VideoAnalysisOrderItemsOnConflict = {
  constraint: VideoAnalysisOrderItemsConstraint;
  updateColumns?: Array<VideoAnalysisOrderItemsUpdateColumn>;
  where?: InputMaybe<VideoAnalysisOrderItemsBoolExp>;
};

/** Ordering options when selecting data from "video_analysis_order_items". */
export type VideoAnalysisOrderItemsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  order?: InputMaybe<VideoAnalysisOrdersOrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  refundedAt?: InputMaybe<OrderBy>;
  refundedByPersona?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  totalUnitAmount?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  videoAnalysisOrderId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: video_analysis_order_items */
export type VideoAnalysisOrderItemsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "video_analysis_order_items" */
export enum VideoAnalysisOrderItemsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  PriceUnitAmount = 'priceUnitAmount',
  /** column name */
  RefundUnitAmount = 'refundUnitAmount',
  /** column name */
  RefundedAt = 'refundedAt',
  /** column name */
  RefundedByPersona = 'refundedByPersona',
  /** column name */
  Status = 'status',
  /** column name */
  TotalUnitAmount = 'totalUnitAmount',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  VideoAnalysisOrderId = 'videoAnalysisOrderId'
}

/** input type for updating data in table "video_analysis_order_items" */
export type VideoAnalysisOrderItemsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  priceUnitAmount?: InputMaybe<Scalars['Int']>;
  refundUnitAmount?: InputMaybe<Scalars['Int']>;
  refundedAt?: InputMaybe<Scalars['timestamptz']>;
  refundedByPersona?: InputMaybe<AppPersonasEnum>;
  status?: InputMaybe<OrderStatusesEnum>;
  totalUnitAmount?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  videoAnalysisOrderId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type VideoAnalysisOrderItemsStddevFields = {
  __typename?: 'VideoAnalysisOrderItemsStddevFields';
  priceUnitAmount?: Maybe<Scalars['Float']>;
  refundUnitAmount?: Maybe<Scalars['Float']>;
  totalUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "video_analysis_order_items" */
export type VideoAnalysisOrderItemsStddevOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  totalUnitAmount?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type VideoAnalysisOrderItemsStddevPopFields = {
  __typename?: 'VideoAnalysisOrderItemsStddevPopFields';
  priceUnitAmount?: Maybe<Scalars['Float']>;
  refundUnitAmount?: Maybe<Scalars['Float']>;
  totalUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "video_analysis_order_items" */
export type VideoAnalysisOrderItemsStddevPopOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  totalUnitAmount?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type VideoAnalysisOrderItemsStddevSampFields = {
  __typename?: 'VideoAnalysisOrderItemsStddevSampFields';
  priceUnitAmount?: Maybe<Scalars['Float']>;
  refundUnitAmount?: Maybe<Scalars['Float']>;
  totalUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "video_analysis_order_items" */
export type VideoAnalysisOrderItemsStddevSampOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  totalUnitAmount?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "video_analysis_order_items" */
export type VideoAnalysisOrderItemsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: VideoAnalysisOrderItemsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type VideoAnalysisOrderItemsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  priceUnitAmount?: InputMaybe<Scalars['Int']>;
  refundUnitAmount?: InputMaybe<Scalars['Int']>;
  refundedAt?: InputMaybe<Scalars['timestamptz']>;
  refundedByPersona?: InputMaybe<AppPersonasEnum>;
  status?: InputMaybe<OrderStatusesEnum>;
  totalUnitAmount?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  videoAnalysisOrderId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type VideoAnalysisOrderItemsSumFields = {
  __typename?: 'VideoAnalysisOrderItemsSumFields';
  priceUnitAmount?: Maybe<Scalars['Int']>;
  refundUnitAmount?: Maybe<Scalars['Int']>;
  totalUnitAmount?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "video_analysis_order_items" */
export type VideoAnalysisOrderItemsSumOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  totalUnitAmount?: InputMaybe<OrderBy>;
};

/** update columns of table "video_analysis_order_items" */
export enum VideoAnalysisOrderItemsUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  PriceUnitAmount = 'priceUnitAmount',
  /** column name */
  RefundUnitAmount = 'refundUnitAmount',
  /** column name */
  RefundedAt = 'refundedAt',
  /** column name */
  RefundedByPersona = 'refundedByPersona',
  /** column name */
  Status = 'status',
  /** column name */
  TotalUnitAmount = 'totalUnitAmount',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  VideoAnalysisOrderId = 'videoAnalysisOrderId'
}

export type VideoAnalysisOrderItemsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<VideoAnalysisOrderItemsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<VideoAnalysisOrderItemsSetInput>;
  /** filter the rows which have to be updated */
  where: VideoAnalysisOrderItemsBoolExp;
};

/** aggregate varPop on columns */
export type VideoAnalysisOrderItemsVarPopFields = {
  __typename?: 'VideoAnalysisOrderItemsVarPopFields';
  priceUnitAmount?: Maybe<Scalars['Float']>;
  refundUnitAmount?: Maybe<Scalars['Float']>;
  totalUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "video_analysis_order_items" */
export type VideoAnalysisOrderItemsVarPopOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  totalUnitAmount?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type VideoAnalysisOrderItemsVarSampFields = {
  __typename?: 'VideoAnalysisOrderItemsVarSampFields';
  priceUnitAmount?: Maybe<Scalars['Float']>;
  refundUnitAmount?: Maybe<Scalars['Float']>;
  totalUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "video_analysis_order_items" */
export type VideoAnalysisOrderItemsVarSampOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  totalUnitAmount?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type VideoAnalysisOrderItemsVarianceFields = {
  __typename?: 'VideoAnalysisOrderItemsVarianceFields';
  priceUnitAmount?: Maybe<Scalars['Float']>;
  refundUnitAmount?: Maybe<Scalars['Float']>;
  totalUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "video_analysis_order_items" */
export type VideoAnalysisOrderItemsVarianceOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  totalUnitAmount?: InputMaybe<OrderBy>;
};

/** columns and relationships of "video_analysis_orders" */
export type VideoAnalysisOrders = {
  __typename?: 'VideoAnalysisOrders';
  applicationFeeTotalUnitAmount: Scalars['Int'];
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  creditCard?: Maybe<UserCreditCards>;
  /** An object relationship */
  customer: Users;
  customerApplicationFeeUnitAmount: Scalars['Int'];
  customerUserId: Scalars['uuid'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  externalStripePaymentIntentId: Scalars['String'];
  id: Scalars['uuid'];
  internalStripePaymentIntentId: Scalars['uuid'];
  /** An array relationship */
  items: Array<VideoAnalysisOrderItems>;
  /** An aggregate relationship */
  itemsAggregate: VideoAnalysisOrderItemsAggregate;
  orderSubtotalUnitAmount: Scalars['Int'];
  orderTotalUnitAmount: Scalars['Int'];
  paidUnitAmount: Scalars['Int'];
  /** An object relationship */
  paymentIntentExternal: StripePaymentIntents;
  /** An object relationship */
  paymentIntentInternal: StripePaymentIntents;
  paymentProcessor: PaymentProcessorsEnum;
  refundUnitAmount: Scalars['Int'];
  refundedAt?: Maybe<Scalars['timestamptz']>;
  refundedByPersona?: Maybe<AppPersonasEnum>;
  /** An object relationship */
  seller: Users;
  sellerApplicationFeeUnitAmount: Scalars['Int'];
  sellerUserId: Scalars['uuid'];
  status: OrderStatusesEnum;
  stripeCustomerId: Scalars['String'];
  stripeMerchantId: Scalars['String'];
  stripePaymentStatus: Scalars['String'];
  transferUnitAmount: Scalars['Int'];
  updatedAt: Scalars['timestamptz'];
  userCreditCardId?: Maybe<Scalars['uuid']>;
  videoAnalysisId: Scalars['uuid'];
};


/** columns and relationships of "video_analysis_orders" */
export type VideoAnalysisOrdersItemsArgs = {
  distinctOn?: InputMaybe<Array<VideoAnalysisOrderItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoAnalysisOrderItemsOrderBy>>;
  where?: InputMaybe<VideoAnalysisOrderItemsBoolExp>;
};


/** columns and relationships of "video_analysis_orders" */
export type VideoAnalysisOrdersItemsAggregateArgs = {
  distinctOn?: InputMaybe<Array<VideoAnalysisOrderItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoAnalysisOrderItemsOrderBy>>;
  where?: InputMaybe<VideoAnalysisOrderItemsBoolExp>;
};

/** aggregated selection of "video_analysis_orders" */
export type VideoAnalysisOrdersAggregate = {
  __typename?: 'VideoAnalysisOrdersAggregate';
  aggregate?: Maybe<VideoAnalysisOrdersAggregateFields>;
  nodes: Array<VideoAnalysisOrders>;
};

export type VideoAnalysisOrdersAggregateBoolExp = {
  count?: InputMaybe<VideoAnalysisOrdersAggregateBoolExpCount>;
};

/** aggregate fields of "video_analysis_orders" */
export type VideoAnalysisOrdersAggregateFields = {
  __typename?: 'VideoAnalysisOrdersAggregateFields';
  avg?: Maybe<VideoAnalysisOrdersAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<VideoAnalysisOrdersMaxFields>;
  min?: Maybe<VideoAnalysisOrdersMinFields>;
  stddev?: Maybe<VideoAnalysisOrdersStddevFields>;
  stddevPop?: Maybe<VideoAnalysisOrdersStddevPopFields>;
  stddevSamp?: Maybe<VideoAnalysisOrdersStddevSampFields>;
  sum?: Maybe<VideoAnalysisOrdersSumFields>;
  varPop?: Maybe<VideoAnalysisOrdersVarPopFields>;
  varSamp?: Maybe<VideoAnalysisOrdersVarSampFields>;
  variance?: Maybe<VideoAnalysisOrdersVarianceFields>;
};


/** aggregate fields of "video_analysis_orders" */
export type VideoAnalysisOrdersAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<VideoAnalysisOrdersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "video_analysis_orders" */
export type VideoAnalysisOrdersAggregateOrderBy = {
  avg?: InputMaybe<VideoAnalysisOrdersAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<VideoAnalysisOrdersMaxOrderBy>;
  min?: InputMaybe<VideoAnalysisOrdersMinOrderBy>;
  stddev?: InputMaybe<VideoAnalysisOrdersStddevOrderBy>;
  stddevPop?: InputMaybe<VideoAnalysisOrdersStddevPopOrderBy>;
  stddevSamp?: InputMaybe<VideoAnalysisOrdersStddevSampOrderBy>;
  sum?: InputMaybe<VideoAnalysisOrdersSumOrderBy>;
  varPop?: InputMaybe<VideoAnalysisOrdersVarPopOrderBy>;
  varSamp?: InputMaybe<VideoAnalysisOrdersVarSampOrderBy>;
  variance?: InputMaybe<VideoAnalysisOrdersVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "video_analysis_orders" */
export type VideoAnalysisOrdersArrRelInsertInput = {
  data: Array<VideoAnalysisOrdersInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<VideoAnalysisOrdersOnConflict>;
};

/** aggregate avg on columns */
export type VideoAnalysisOrdersAvgFields = {
  __typename?: 'VideoAnalysisOrdersAvgFields';
  applicationFeeTotalUnitAmount?: Maybe<Scalars['Float']>;
  customerApplicationFeeUnitAmount?: Maybe<Scalars['Float']>;
  orderSubtotalUnitAmount?: Maybe<Scalars['Float']>;
  orderTotalUnitAmount?: Maybe<Scalars['Float']>;
  paidUnitAmount?: Maybe<Scalars['Float']>;
  refundUnitAmount?: Maybe<Scalars['Float']>;
  sellerApplicationFeeUnitAmount?: Maybe<Scalars['Float']>;
  transferUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "video_analysis_orders" */
export type VideoAnalysisOrdersAvgOrderBy = {
  applicationFeeTotalUnitAmount?: InputMaybe<OrderBy>;
  customerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  sellerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  transferUnitAmount?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "video_analysis_orders". All fields are combined with a logical 'AND'. */
export type VideoAnalysisOrdersBoolExp = {
  _and?: InputMaybe<Array<VideoAnalysisOrdersBoolExp>>;
  _not?: InputMaybe<VideoAnalysisOrdersBoolExp>;
  _or?: InputMaybe<Array<VideoAnalysisOrdersBoolExp>>;
  applicationFeeTotalUnitAmount?: InputMaybe<IntComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  creditCard?: InputMaybe<UserCreditCardsBoolExp>;
  customer?: InputMaybe<UsersBoolExp>;
  customerApplicationFeeUnitAmount?: InputMaybe<IntComparisonExp>;
  customerUserId?: InputMaybe<UuidComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  externalStripePaymentIntentId?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  internalStripePaymentIntentId?: InputMaybe<UuidComparisonExp>;
  items?: InputMaybe<VideoAnalysisOrderItemsBoolExp>;
  itemsAggregate?: InputMaybe<VideoAnalysisOrderItemsAggregateBoolExp>;
  orderSubtotalUnitAmount?: InputMaybe<IntComparisonExp>;
  orderTotalUnitAmount?: InputMaybe<IntComparisonExp>;
  paidUnitAmount?: InputMaybe<IntComparisonExp>;
  paymentIntentExternal?: InputMaybe<StripePaymentIntentsBoolExp>;
  paymentIntentInternal?: InputMaybe<StripePaymentIntentsBoolExp>;
  paymentProcessor?: InputMaybe<PaymentProcessorsEnumComparisonExp>;
  refundUnitAmount?: InputMaybe<IntComparisonExp>;
  refundedAt?: InputMaybe<TimestamptzComparisonExp>;
  refundedByPersona?: InputMaybe<AppPersonasEnumComparisonExp>;
  seller?: InputMaybe<UsersBoolExp>;
  sellerApplicationFeeUnitAmount?: InputMaybe<IntComparisonExp>;
  sellerUserId?: InputMaybe<UuidComparisonExp>;
  status?: InputMaybe<OrderStatusesEnumComparisonExp>;
  stripeCustomerId?: InputMaybe<StringComparisonExp>;
  stripeMerchantId?: InputMaybe<StringComparisonExp>;
  stripePaymentStatus?: InputMaybe<StringComparisonExp>;
  transferUnitAmount?: InputMaybe<IntComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  userCreditCardId?: InputMaybe<UuidComparisonExp>;
  videoAnalysisId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "video_analysis_orders" */
export enum VideoAnalysisOrdersConstraint {
  /** unique or primary key constraint on columns "external_stripe_payment_intent_id" */
  VideoAnalysisOrdersExternalStripePaymentIntentIdKey = 'video_analysis_orders_external_stripe_payment_intent_id_key',
  /** unique or primary key constraint on columns "internal_stripe_payment_intent_id" */
  VideoAnalysisOrdersInternalStripePaymentIntentIdKey = 'video_analysis_orders_internal_stripe_payment_intent_id_key',
  /** unique or primary key constraint on columns "id" */
  VideoAnalysisOrdersPkey = 'video_analysis_orders_pkey'
}

/** input type for incrementing numeric columns in table "video_analysis_orders" */
export type VideoAnalysisOrdersIncInput = {
  applicationFeeTotalUnitAmount?: InputMaybe<Scalars['Int']>;
  customerApplicationFeeUnitAmount?: InputMaybe<Scalars['Int']>;
  orderSubtotalUnitAmount?: InputMaybe<Scalars['Int']>;
  orderTotalUnitAmount?: InputMaybe<Scalars['Int']>;
  paidUnitAmount?: InputMaybe<Scalars['Int']>;
  refundUnitAmount?: InputMaybe<Scalars['Int']>;
  sellerApplicationFeeUnitAmount?: InputMaybe<Scalars['Int']>;
  transferUnitAmount?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "video_analysis_orders" */
export type VideoAnalysisOrdersInsertInput = {
  applicationFeeTotalUnitAmount?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  creditCard?: InputMaybe<UserCreditCardsObjRelInsertInput>;
  customer?: InputMaybe<UsersObjRelInsertInput>;
  customerApplicationFeeUnitAmount?: InputMaybe<Scalars['Int']>;
  customerUserId?: InputMaybe<Scalars['uuid']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  externalStripePaymentIntentId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  internalStripePaymentIntentId?: InputMaybe<Scalars['uuid']>;
  items?: InputMaybe<VideoAnalysisOrderItemsArrRelInsertInput>;
  orderSubtotalUnitAmount?: InputMaybe<Scalars['Int']>;
  orderTotalUnitAmount?: InputMaybe<Scalars['Int']>;
  paidUnitAmount?: InputMaybe<Scalars['Int']>;
  paymentIntentExternal?: InputMaybe<StripePaymentIntentsObjRelInsertInput>;
  paymentIntentInternal?: InputMaybe<StripePaymentIntentsObjRelInsertInput>;
  paymentProcessor?: InputMaybe<PaymentProcessorsEnum>;
  refundUnitAmount?: InputMaybe<Scalars['Int']>;
  refundedAt?: InputMaybe<Scalars['timestamptz']>;
  refundedByPersona?: InputMaybe<AppPersonasEnum>;
  seller?: InputMaybe<UsersObjRelInsertInput>;
  sellerApplicationFeeUnitAmount?: InputMaybe<Scalars['Int']>;
  sellerUserId?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<OrderStatusesEnum>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  stripeMerchantId?: InputMaybe<Scalars['String']>;
  stripePaymentStatus?: InputMaybe<Scalars['String']>;
  transferUnitAmount?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userCreditCardId?: InputMaybe<Scalars['uuid']>;
  videoAnalysisId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type VideoAnalysisOrdersMaxFields = {
  __typename?: 'VideoAnalysisOrdersMaxFields';
  applicationFeeTotalUnitAmount?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  customerApplicationFeeUnitAmount?: Maybe<Scalars['Int']>;
  customerUserId?: Maybe<Scalars['uuid']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  externalStripePaymentIntentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  internalStripePaymentIntentId?: Maybe<Scalars['uuid']>;
  orderSubtotalUnitAmount?: Maybe<Scalars['Int']>;
  orderTotalUnitAmount?: Maybe<Scalars['Int']>;
  paidUnitAmount?: Maybe<Scalars['Int']>;
  refundUnitAmount?: Maybe<Scalars['Int']>;
  refundedAt?: Maybe<Scalars['timestamptz']>;
  sellerApplicationFeeUnitAmount?: Maybe<Scalars['Int']>;
  sellerUserId?: Maybe<Scalars['uuid']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripeMerchantId?: Maybe<Scalars['String']>;
  stripePaymentStatus?: Maybe<Scalars['String']>;
  transferUnitAmount?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userCreditCardId?: Maybe<Scalars['uuid']>;
  videoAnalysisId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "video_analysis_orders" */
export type VideoAnalysisOrdersMaxOrderBy = {
  applicationFeeTotalUnitAmount?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  customerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  customerUserId?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  externalStripePaymentIntentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  internalStripePaymentIntentId?: InputMaybe<OrderBy>;
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  refundedAt?: InputMaybe<OrderBy>;
  sellerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  sellerUserId?: InputMaybe<OrderBy>;
  stripeCustomerId?: InputMaybe<OrderBy>;
  stripeMerchantId?: InputMaybe<OrderBy>;
  stripePaymentStatus?: InputMaybe<OrderBy>;
  transferUnitAmount?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userCreditCardId?: InputMaybe<OrderBy>;
  videoAnalysisId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type VideoAnalysisOrdersMinFields = {
  __typename?: 'VideoAnalysisOrdersMinFields';
  applicationFeeTotalUnitAmount?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  customerApplicationFeeUnitAmount?: Maybe<Scalars['Int']>;
  customerUserId?: Maybe<Scalars['uuid']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  externalStripePaymentIntentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  internalStripePaymentIntentId?: Maybe<Scalars['uuid']>;
  orderSubtotalUnitAmount?: Maybe<Scalars['Int']>;
  orderTotalUnitAmount?: Maybe<Scalars['Int']>;
  paidUnitAmount?: Maybe<Scalars['Int']>;
  refundUnitAmount?: Maybe<Scalars['Int']>;
  refundedAt?: Maybe<Scalars['timestamptz']>;
  sellerApplicationFeeUnitAmount?: Maybe<Scalars['Int']>;
  sellerUserId?: Maybe<Scalars['uuid']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripeMerchantId?: Maybe<Scalars['String']>;
  stripePaymentStatus?: Maybe<Scalars['String']>;
  transferUnitAmount?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userCreditCardId?: Maybe<Scalars['uuid']>;
  videoAnalysisId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "video_analysis_orders" */
export type VideoAnalysisOrdersMinOrderBy = {
  applicationFeeTotalUnitAmount?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  customerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  customerUserId?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  externalStripePaymentIntentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  internalStripePaymentIntentId?: InputMaybe<OrderBy>;
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  refundedAt?: InputMaybe<OrderBy>;
  sellerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  sellerUserId?: InputMaybe<OrderBy>;
  stripeCustomerId?: InputMaybe<OrderBy>;
  stripeMerchantId?: InputMaybe<OrderBy>;
  stripePaymentStatus?: InputMaybe<OrderBy>;
  transferUnitAmount?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userCreditCardId?: InputMaybe<OrderBy>;
  videoAnalysisId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "video_analysis_orders" */
export type VideoAnalysisOrdersMutationResponse = {
  __typename?: 'VideoAnalysisOrdersMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<VideoAnalysisOrders>;
};

/** input type for inserting object relation for remote table "video_analysis_orders" */
export type VideoAnalysisOrdersObjRelInsertInput = {
  data: VideoAnalysisOrdersInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<VideoAnalysisOrdersOnConflict>;
};

/** on_conflict condition type for table "video_analysis_orders" */
export type VideoAnalysisOrdersOnConflict = {
  constraint: VideoAnalysisOrdersConstraint;
  updateColumns?: Array<VideoAnalysisOrdersUpdateColumn>;
  where?: InputMaybe<VideoAnalysisOrdersBoolExp>;
};

/** Ordering options when selecting data from "video_analysis_orders". */
export type VideoAnalysisOrdersOrderBy = {
  applicationFeeTotalUnitAmount?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  creditCard?: InputMaybe<UserCreditCardsOrderBy>;
  customer?: InputMaybe<UsersOrderBy>;
  customerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  customerUserId?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  externalStripePaymentIntentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  internalStripePaymentIntentId?: InputMaybe<OrderBy>;
  itemsAggregate?: InputMaybe<VideoAnalysisOrderItemsAggregateOrderBy>;
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  paymentIntentExternal?: InputMaybe<StripePaymentIntentsOrderBy>;
  paymentIntentInternal?: InputMaybe<StripePaymentIntentsOrderBy>;
  paymentProcessor?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  refundedAt?: InputMaybe<OrderBy>;
  refundedByPersona?: InputMaybe<OrderBy>;
  seller?: InputMaybe<UsersOrderBy>;
  sellerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  sellerUserId?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  stripeCustomerId?: InputMaybe<OrderBy>;
  stripeMerchantId?: InputMaybe<OrderBy>;
  stripePaymentStatus?: InputMaybe<OrderBy>;
  transferUnitAmount?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userCreditCardId?: InputMaybe<OrderBy>;
  videoAnalysisId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: video_analysis_orders */
export type VideoAnalysisOrdersPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "video_analysis_orders" */
export enum VideoAnalysisOrdersSelectColumn {
  /** column name */
  ApplicationFeeTotalUnitAmount = 'applicationFeeTotalUnitAmount',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CustomerApplicationFeeUnitAmount = 'customerApplicationFeeUnitAmount',
  /** column name */
  CustomerUserId = 'customerUserId',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  ExternalStripePaymentIntentId = 'externalStripePaymentIntentId',
  /** column name */
  Id = 'id',
  /** column name */
  InternalStripePaymentIntentId = 'internalStripePaymentIntentId',
  /** column name */
  OrderSubtotalUnitAmount = 'orderSubtotalUnitAmount',
  /** column name */
  OrderTotalUnitAmount = 'orderTotalUnitAmount',
  /** column name */
  PaidUnitAmount = 'paidUnitAmount',
  /** column name */
  PaymentProcessor = 'paymentProcessor',
  /** column name */
  RefundUnitAmount = 'refundUnitAmount',
  /** column name */
  RefundedAt = 'refundedAt',
  /** column name */
  RefundedByPersona = 'refundedByPersona',
  /** column name */
  SellerApplicationFeeUnitAmount = 'sellerApplicationFeeUnitAmount',
  /** column name */
  SellerUserId = 'sellerUserId',
  /** column name */
  Status = 'status',
  /** column name */
  StripeCustomerId = 'stripeCustomerId',
  /** column name */
  StripeMerchantId = 'stripeMerchantId',
  /** column name */
  StripePaymentStatus = 'stripePaymentStatus',
  /** column name */
  TransferUnitAmount = 'transferUnitAmount',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserCreditCardId = 'userCreditCardId',
  /** column name */
  VideoAnalysisId = 'videoAnalysisId'
}

/** input type for updating data in table "video_analysis_orders" */
export type VideoAnalysisOrdersSetInput = {
  applicationFeeTotalUnitAmount?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  customerApplicationFeeUnitAmount?: InputMaybe<Scalars['Int']>;
  customerUserId?: InputMaybe<Scalars['uuid']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  externalStripePaymentIntentId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  internalStripePaymentIntentId?: InputMaybe<Scalars['uuid']>;
  orderSubtotalUnitAmount?: InputMaybe<Scalars['Int']>;
  orderTotalUnitAmount?: InputMaybe<Scalars['Int']>;
  paidUnitAmount?: InputMaybe<Scalars['Int']>;
  paymentProcessor?: InputMaybe<PaymentProcessorsEnum>;
  refundUnitAmount?: InputMaybe<Scalars['Int']>;
  refundedAt?: InputMaybe<Scalars['timestamptz']>;
  refundedByPersona?: InputMaybe<AppPersonasEnum>;
  sellerApplicationFeeUnitAmount?: InputMaybe<Scalars['Int']>;
  sellerUserId?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<OrderStatusesEnum>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  stripeMerchantId?: InputMaybe<Scalars['String']>;
  stripePaymentStatus?: InputMaybe<Scalars['String']>;
  transferUnitAmount?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userCreditCardId?: InputMaybe<Scalars['uuid']>;
  videoAnalysisId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type VideoAnalysisOrdersStddevFields = {
  __typename?: 'VideoAnalysisOrdersStddevFields';
  applicationFeeTotalUnitAmount?: Maybe<Scalars['Float']>;
  customerApplicationFeeUnitAmount?: Maybe<Scalars['Float']>;
  orderSubtotalUnitAmount?: Maybe<Scalars['Float']>;
  orderTotalUnitAmount?: Maybe<Scalars['Float']>;
  paidUnitAmount?: Maybe<Scalars['Float']>;
  refundUnitAmount?: Maybe<Scalars['Float']>;
  sellerApplicationFeeUnitAmount?: Maybe<Scalars['Float']>;
  transferUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "video_analysis_orders" */
export type VideoAnalysisOrdersStddevOrderBy = {
  applicationFeeTotalUnitAmount?: InputMaybe<OrderBy>;
  customerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  sellerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  transferUnitAmount?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type VideoAnalysisOrdersStddevPopFields = {
  __typename?: 'VideoAnalysisOrdersStddevPopFields';
  applicationFeeTotalUnitAmount?: Maybe<Scalars['Float']>;
  customerApplicationFeeUnitAmount?: Maybe<Scalars['Float']>;
  orderSubtotalUnitAmount?: Maybe<Scalars['Float']>;
  orderTotalUnitAmount?: Maybe<Scalars['Float']>;
  paidUnitAmount?: Maybe<Scalars['Float']>;
  refundUnitAmount?: Maybe<Scalars['Float']>;
  sellerApplicationFeeUnitAmount?: Maybe<Scalars['Float']>;
  transferUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "video_analysis_orders" */
export type VideoAnalysisOrdersStddevPopOrderBy = {
  applicationFeeTotalUnitAmount?: InputMaybe<OrderBy>;
  customerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  sellerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  transferUnitAmount?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type VideoAnalysisOrdersStddevSampFields = {
  __typename?: 'VideoAnalysisOrdersStddevSampFields';
  applicationFeeTotalUnitAmount?: Maybe<Scalars['Float']>;
  customerApplicationFeeUnitAmount?: Maybe<Scalars['Float']>;
  orderSubtotalUnitAmount?: Maybe<Scalars['Float']>;
  orderTotalUnitAmount?: Maybe<Scalars['Float']>;
  paidUnitAmount?: Maybe<Scalars['Float']>;
  refundUnitAmount?: Maybe<Scalars['Float']>;
  sellerApplicationFeeUnitAmount?: Maybe<Scalars['Float']>;
  transferUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "video_analysis_orders" */
export type VideoAnalysisOrdersStddevSampOrderBy = {
  applicationFeeTotalUnitAmount?: InputMaybe<OrderBy>;
  customerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  sellerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  transferUnitAmount?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "video_analysis_orders" */
export type VideoAnalysisOrdersStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: VideoAnalysisOrdersStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type VideoAnalysisOrdersStreamCursorValueInput = {
  applicationFeeTotalUnitAmount?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  customerApplicationFeeUnitAmount?: InputMaybe<Scalars['Int']>;
  customerUserId?: InputMaybe<Scalars['uuid']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  externalStripePaymentIntentId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  internalStripePaymentIntentId?: InputMaybe<Scalars['uuid']>;
  orderSubtotalUnitAmount?: InputMaybe<Scalars['Int']>;
  orderTotalUnitAmount?: InputMaybe<Scalars['Int']>;
  paidUnitAmount?: InputMaybe<Scalars['Int']>;
  paymentProcessor?: InputMaybe<PaymentProcessorsEnum>;
  refundUnitAmount?: InputMaybe<Scalars['Int']>;
  refundedAt?: InputMaybe<Scalars['timestamptz']>;
  refundedByPersona?: InputMaybe<AppPersonasEnum>;
  sellerApplicationFeeUnitAmount?: InputMaybe<Scalars['Int']>;
  sellerUserId?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<OrderStatusesEnum>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  stripeMerchantId?: InputMaybe<Scalars['String']>;
  stripePaymentStatus?: InputMaybe<Scalars['String']>;
  transferUnitAmount?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userCreditCardId?: InputMaybe<Scalars['uuid']>;
  videoAnalysisId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type VideoAnalysisOrdersSumFields = {
  __typename?: 'VideoAnalysisOrdersSumFields';
  applicationFeeTotalUnitAmount?: Maybe<Scalars['Int']>;
  customerApplicationFeeUnitAmount?: Maybe<Scalars['Int']>;
  orderSubtotalUnitAmount?: Maybe<Scalars['Int']>;
  orderTotalUnitAmount?: Maybe<Scalars['Int']>;
  paidUnitAmount?: Maybe<Scalars['Int']>;
  refundUnitAmount?: Maybe<Scalars['Int']>;
  sellerApplicationFeeUnitAmount?: Maybe<Scalars['Int']>;
  transferUnitAmount?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "video_analysis_orders" */
export type VideoAnalysisOrdersSumOrderBy = {
  applicationFeeTotalUnitAmount?: InputMaybe<OrderBy>;
  customerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  sellerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  transferUnitAmount?: InputMaybe<OrderBy>;
};

/** update columns of table "video_analysis_orders" */
export enum VideoAnalysisOrdersUpdateColumn {
  /** column name */
  ApplicationFeeTotalUnitAmount = 'applicationFeeTotalUnitAmount',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CustomerApplicationFeeUnitAmount = 'customerApplicationFeeUnitAmount',
  /** column name */
  CustomerUserId = 'customerUserId',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  ExternalStripePaymentIntentId = 'externalStripePaymentIntentId',
  /** column name */
  Id = 'id',
  /** column name */
  InternalStripePaymentIntentId = 'internalStripePaymentIntentId',
  /** column name */
  OrderSubtotalUnitAmount = 'orderSubtotalUnitAmount',
  /** column name */
  OrderTotalUnitAmount = 'orderTotalUnitAmount',
  /** column name */
  PaidUnitAmount = 'paidUnitAmount',
  /** column name */
  PaymentProcessor = 'paymentProcessor',
  /** column name */
  RefundUnitAmount = 'refundUnitAmount',
  /** column name */
  RefundedAt = 'refundedAt',
  /** column name */
  RefundedByPersona = 'refundedByPersona',
  /** column name */
  SellerApplicationFeeUnitAmount = 'sellerApplicationFeeUnitAmount',
  /** column name */
  SellerUserId = 'sellerUserId',
  /** column name */
  Status = 'status',
  /** column name */
  StripeCustomerId = 'stripeCustomerId',
  /** column name */
  StripeMerchantId = 'stripeMerchantId',
  /** column name */
  StripePaymentStatus = 'stripePaymentStatus',
  /** column name */
  TransferUnitAmount = 'transferUnitAmount',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserCreditCardId = 'userCreditCardId',
  /** column name */
  VideoAnalysisId = 'videoAnalysisId'
}

export type VideoAnalysisOrdersUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<VideoAnalysisOrdersIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<VideoAnalysisOrdersSetInput>;
  /** filter the rows which have to be updated */
  where: VideoAnalysisOrdersBoolExp;
};

/** aggregate varPop on columns */
export type VideoAnalysisOrdersVarPopFields = {
  __typename?: 'VideoAnalysisOrdersVarPopFields';
  applicationFeeTotalUnitAmount?: Maybe<Scalars['Float']>;
  customerApplicationFeeUnitAmount?: Maybe<Scalars['Float']>;
  orderSubtotalUnitAmount?: Maybe<Scalars['Float']>;
  orderTotalUnitAmount?: Maybe<Scalars['Float']>;
  paidUnitAmount?: Maybe<Scalars['Float']>;
  refundUnitAmount?: Maybe<Scalars['Float']>;
  sellerApplicationFeeUnitAmount?: Maybe<Scalars['Float']>;
  transferUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "video_analysis_orders" */
export type VideoAnalysisOrdersVarPopOrderBy = {
  applicationFeeTotalUnitAmount?: InputMaybe<OrderBy>;
  customerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  sellerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  transferUnitAmount?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type VideoAnalysisOrdersVarSampFields = {
  __typename?: 'VideoAnalysisOrdersVarSampFields';
  applicationFeeTotalUnitAmount?: Maybe<Scalars['Float']>;
  customerApplicationFeeUnitAmount?: Maybe<Scalars['Float']>;
  orderSubtotalUnitAmount?: Maybe<Scalars['Float']>;
  orderTotalUnitAmount?: Maybe<Scalars['Float']>;
  paidUnitAmount?: Maybe<Scalars['Float']>;
  refundUnitAmount?: Maybe<Scalars['Float']>;
  sellerApplicationFeeUnitAmount?: Maybe<Scalars['Float']>;
  transferUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "video_analysis_orders" */
export type VideoAnalysisOrdersVarSampOrderBy = {
  applicationFeeTotalUnitAmount?: InputMaybe<OrderBy>;
  customerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  sellerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  transferUnitAmount?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type VideoAnalysisOrdersVarianceFields = {
  __typename?: 'VideoAnalysisOrdersVarianceFields';
  applicationFeeTotalUnitAmount?: Maybe<Scalars['Float']>;
  customerApplicationFeeUnitAmount?: Maybe<Scalars['Float']>;
  orderSubtotalUnitAmount?: Maybe<Scalars['Float']>;
  orderTotalUnitAmount?: Maybe<Scalars['Float']>;
  paidUnitAmount?: Maybe<Scalars['Float']>;
  refundUnitAmount?: Maybe<Scalars['Float']>;
  sellerApplicationFeeUnitAmount?: Maybe<Scalars['Float']>;
  transferUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "video_analysis_orders" */
export type VideoAnalysisOrdersVarianceOrderBy = {
  applicationFeeTotalUnitAmount?: InputMaybe<OrderBy>;
  customerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  sellerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  transferUnitAmount?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: video_analysis */
export type VideoAnalysisPkColumnsInput = {
  id: Scalars['uuid'];
};

/** columns and relationships of "video_analysis_requested_skills_review" */
export type VideoAnalysisRequestedSkillsReview = {
  __typename?: 'VideoAnalysisRequestedSkillsReview';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  updatedAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  videoAnalysis: VideoAnalysis;
  videoAnalysisId: Scalars['uuid'];
  videoLessonSkillId: Scalars['uuid'];
  /** An object relationship */
  videoLessonSkills: VideoLessonSkills;
};

/** aggregated selection of "video_analysis_requested_skills_review" */
export type VideoAnalysisRequestedSkillsReviewAggregate = {
  __typename?: 'VideoAnalysisRequestedSkillsReviewAggregate';
  aggregate?: Maybe<VideoAnalysisRequestedSkillsReviewAggregateFields>;
  nodes: Array<VideoAnalysisRequestedSkillsReview>;
};

export type VideoAnalysisRequestedSkillsReviewAggregateBoolExp = {
  count?: InputMaybe<VideoAnalysisRequestedSkillsReviewAggregateBoolExpCount>;
};

/** aggregate fields of "video_analysis_requested_skills_review" */
export type VideoAnalysisRequestedSkillsReviewAggregateFields = {
  __typename?: 'VideoAnalysisRequestedSkillsReviewAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<VideoAnalysisRequestedSkillsReviewMaxFields>;
  min?: Maybe<VideoAnalysisRequestedSkillsReviewMinFields>;
};


/** aggregate fields of "video_analysis_requested_skills_review" */
export type VideoAnalysisRequestedSkillsReviewAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<VideoAnalysisRequestedSkillsReviewSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "video_analysis_requested_skills_review" */
export type VideoAnalysisRequestedSkillsReviewAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<VideoAnalysisRequestedSkillsReviewMaxOrderBy>;
  min?: InputMaybe<VideoAnalysisRequestedSkillsReviewMinOrderBy>;
};

/** input type for inserting array relation for remote table "video_analysis_requested_skills_review" */
export type VideoAnalysisRequestedSkillsReviewArrRelInsertInput = {
  data: Array<VideoAnalysisRequestedSkillsReviewInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<VideoAnalysisRequestedSkillsReviewOnConflict>;
};

/** Boolean expression to filter rows from the table "video_analysis_requested_skills_review". All fields are combined with a logical 'AND'. */
export type VideoAnalysisRequestedSkillsReviewBoolExp = {
  _and?: InputMaybe<Array<VideoAnalysisRequestedSkillsReviewBoolExp>>;
  _not?: InputMaybe<VideoAnalysisRequestedSkillsReviewBoolExp>;
  _or?: InputMaybe<Array<VideoAnalysisRequestedSkillsReviewBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  videoAnalysis?: InputMaybe<VideoAnalysisBoolExp>;
  videoAnalysisId?: InputMaybe<UuidComparisonExp>;
  videoLessonSkillId?: InputMaybe<UuidComparisonExp>;
  videoLessonSkills?: InputMaybe<VideoLessonSkillsBoolExp>;
};

/** unique or primary key constraints on table "video_analysis_requested_skills_review" */
export enum VideoAnalysisRequestedSkillsReviewConstraint {
  /** unique or primary key constraint on columns "id" */
  VideoAnalysisRequestedSkillsReviewPkey = 'video_analysis_requested_skills_review_pkey'
}

/** input type for inserting data into table "video_analysis_requested_skills_review" */
export type VideoAnalysisRequestedSkillsReviewInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  videoAnalysis?: InputMaybe<VideoAnalysisObjRelInsertInput>;
  videoAnalysisId?: InputMaybe<Scalars['uuid']>;
  videoLessonSkillId?: InputMaybe<Scalars['uuid']>;
  videoLessonSkills?: InputMaybe<VideoLessonSkillsObjRelInsertInput>;
};

/** aggregate max on columns */
export type VideoAnalysisRequestedSkillsReviewMaxFields = {
  __typename?: 'VideoAnalysisRequestedSkillsReviewMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  videoAnalysisId?: Maybe<Scalars['uuid']>;
  videoLessonSkillId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "video_analysis_requested_skills_review" */
export type VideoAnalysisRequestedSkillsReviewMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  videoAnalysisId?: InputMaybe<OrderBy>;
  videoLessonSkillId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type VideoAnalysisRequestedSkillsReviewMinFields = {
  __typename?: 'VideoAnalysisRequestedSkillsReviewMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  videoAnalysisId?: Maybe<Scalars['uuid']>;
  videoLessonSkillId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "video_analysis_requested_skills_review" */
export type VideoAnalysisRequestedSkillsReviewMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  videoAnalysisId?: InputMaybe<OrderBy>;
  videoLessonSkillId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "video_analysis_requested_skills_review" */
export type VideoAnalysisRequestedSkillsReviewMutationResponse = {
  __typename?: 'VideoAnalysisRequestedSkillsReviewMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<VideoAnalysisRequestedSkillsReview>;
};

/** on_conflict condition type for table "video_analysis_requested_skills_review" */
export type VideoAnalysisRequestedSkillsReviewOnConflict = {
  constraint: VideoAnalysisRequestedSkillsReviewConstraint;
  updateColumns?: Array<VideoAnalysisRequestedSkillsReviewUpdateColumn>;
  where?: InputMaybe<VideoAnalysisRequestedSkillsReviewBoolExp>;
};

/** Ordering options when selecting data from "video_analysis_requested_skills_review". */
export type VideoAnalysisRequestedSkillsReviewOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  videoAnalysis?: InputMaybe<VideoAnalysisOrderBy>;
  videoAnalysisId?: InputMaybe<OrderBy>;
  videoLessonSkillId?: InputMaybe<OrderBy>;
  videoLessonSkills?: InputMaybe<VideoLessonSkillsOrderBy>;
};

/** primary key columns input for table: video_analysis_requested_skills_review */
export type VideoAnalysisRequestedSkillsReviewPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "video_analysis_requested_skills_review" */
export enum VideoAnalysisRequestedSkillsReviewSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  VideoAnalysisId = 'videoAnalysisId',
  /** column name */
  VideoLessonSkillId = 'videoLessonSkillId'
}

/** input type for updating data in table "video_analysis_requested_skills_review" */
export type VideoAnalysisRequestedSkillsReviewSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  videoAnalysisId?: InputMaybe<Scalars['uuid']>;
  videoLessonSkillId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "video_analysis_requested_skills_review" */
export type VideoAnalysisRequestedSkillsReviewStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: VideoAnalysisRequestedSkillsReviewStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type VideoAnalysisRequestedSkillsReviewStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  videoAnalysisId?: InputMaybe<Scalars['uuid']>;
  videoLessonSkillId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "video_analysis_requested_skills_review" */
export enum VideoAnalysisRequestedSkillsReviewUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  VideoAnalysisId = 'videoAnalysisId',
  /** column name */
  VideoLessonSkillId = 'videoLessonSkillId'
}

export type VideoAnalysisRequestedSkillsReviewUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<VideoAnalysisRequestedSkillsReviewSetInput>;
  /** filter the rows which have to be updated */
  where: VideoAnalysisRequestedSkillsReviewBoolExp;
};

/** columns and relationships of "video_analysis_review_statuses" */
export type VideoAnalysisReviewStatuses = {
  __typename?: 'VideoAnalysisReviewStatuses';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "video_analysis_review_statuses" */
export type VideoAnalysisReviewStatusesAggregate = {
  __typename?: 'VideoAnalysisReviewStatusesAggregate';
  aggregate?: Maybe<VideoAnalysisReviewStatusesAggregateFields>;
  nodes: Array<VideoAnalysisReviewStatuses>;
};

/** aggregate fields of "video_analysis_review_statuses" */
export type VideoAnalysisReviewStatusesAggregateFields = {
  __typename?: 'VideoAnalysisReviewStatusesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<VideoAnalysisReviewStatusesMaxFields>;
  min?: Maybe<VideoAnalysisReviewStatusesMinFields>;
};


/** aggregate fields of "video_analysis_review_statuses" */
export type VideoAnalysisReviewStatusesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<VideoAnalysisReviewStatusesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "video_analysis_review_statuses". All fields are combined with a logical 'AND'. */
export type VideoAnalysisReviewStatusesBoolExp = {
  _and?: InputMaybe<Array<VideoAnalysisReviewStatusesBoolExp>>;
  _not?: InputMaybe<VideoAnalysisReviewStatusesBoolExp>;
  _or?: InputMaybe<Array<VideoAnalysisReviewStatusesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "video_analysis_review_statuses" */
export enum VideoAnalysisReviewStatusesConstraint {
  /** unique or primary key constraint on columns "value" */
  VideoAnalysisReviewStatusesPkey = 'video_analysis_review_statuses_pkey'
}

export enum VideoAnalysisReviewStatusesEnum {
  Complete = 'COMPLETE',
  Draft = 'DRAFT',
  Pending = 'PENDING',
  Reviewed = 'REVIEWED'
}

/** Boolean expression to compare columns of type "VideoAnalysisReviewStatusesEnum". All fields are combined with logical 'AND'. */
export type VideoAnalysisReviewStatusesEnumComparisonExp = {
  _eq?: InputMaybe<VideoAnalysisReviewStatusesEnum>;
  _in?: InputMaybe<Array<VideoAnalysisReviewStatusesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<VideoAnalysisReviewStatusesEnum>;
  _nin?: InputMaybe<Array<VideoAnalysisReviewStatusesEnum>>;
};

/** input type for inserting data into table "video_analysis_review_statuses" */
export type VideoAnalysisReviewStatusesInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type VideoAnalysisReviewStatusesMaxFields = {
  __typename?: 'VideoAnalysisReviewStatusesMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type VideoAnalysisReviewStatusesMinFields = {
  __typename?: 'VideoAnalysisReviewStatusesMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "video_analysis_review_statuses" */
export type VideoAnalysisReviewStatusesMutationResponse = {
  __typename?: 'VideoAnalysisReviewStatusesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<VideoAnalysisReviewStatuses>;
};

/** on_conflict condition type for table "video_analysis_review_statuses" */
export type VideoAnalysisReviewStatusesOnConflict = {
  constraint: VideoAnalysisReviewStatusesConstraint;
  updateColumns?: Array<VideoAnalysisReviewStatusesUpdateColumn>;
  where?: InputMaybe<VideoAnalysisReviewStatusesBoolExp>;
};

/** Ordering options when selecting data from "video_analysis_review_statuses". */
export type VideoAnalysisReviewStatusesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: video_analysis_review_statuses */
export type VideoAnalysisReviewStatusesPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "video_analysis_review_statuses" */
export enum VideoAnalysisReviewStatusesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "video_analysis_review_statuses" */
export type VideoAnalysisReviewStatusesSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "video_analysis_review_statuses" */
export type VideoAnalysisReviewStatusesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: VideoAnalysisReviewStatusesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type VideoAnalysisReviewStatusesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "video_analysis_review_statuses" */
export enum VideoAnalysisReviewStatusesUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type VideoAnalysisReviewStatusesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<VideoAnalysisReviewStatusesSetInput>;
  /** filter the rows which have to be updated */
  where: VideoAnalysisReviewStatusesBoolExp;
};

/** select columns of table "video_analysis" */
export enum VideoAnalysisSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Currency = 'currency',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  Locale = 'locale',
  /** column name */
  PaymentFulfillmentChannel = 'paymentFulfillmentChannel',
  /** column name */
  PriceUnitAmount = 'priceUnitAmount',
  /** column name */
  ReviewStatus = 'reviewStatus',
  /** column name */
  ReviewerUserId = 'reviewerUserId',
  /** column name */
  SubmissionRequestedFeedback = 'submissionRequestedFeedback',
  /** column name */
  SubmissionUserId = 'submissionUserId',
  /** column name */
  TimezoneAbbreviation = 'timezoneAbbreviation',
  /** column name */
  TimezoneName = 'timezoneName',
  /** column name */
  TimezoneOffsetMinutes = 'timezoneOffsetMinutes',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  VideoAnalysisFileId = 'videoAnalysisFileId'
}

/** input type for updating data in table "video_analysis" */
export type VideoAnalysisSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  locale?: InputMaybe<Scalars['String']>;
  paymentFulfillmentChannel?: InputMaybe<PaymentFulfillmentChannelsEnum>;
  priceUnitAmount?: InputMaybe<Scalars['Int']>;
  reviewStatus?: InputMaybe<VideoAnalysisReviewStatusesEnum>;
  reviewerUserId?: InputMaybe<Scalars['uuid']>;
  submissionRequestedFeedback?: InputMaybe<Scalars['String']>;
  submissionUserId?: InputMaybe<Scalars['uuid']>;
  timezoneAbbreviation?: InputMaybe<Scalars['String']>;
  timezoneName?: InputMaybe<Scalars['String']>;
  timezoneOffsetMinutes?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  videoAnalysisFileId?: InputMaybe<Scalars['uuid']>;
};

/** columns and relationships of "video_analysis_skills_comments" */
export type VideoAnalysisSkillsComments = {
  __typename?: 'VideoAnalysisSkillsComments';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  updatedAt?: Maybe<Scalars['timestamptz']>;
  videoAnalysisCommentId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  videoAnalysisComments?: Maybe<VideoAnalysisComments>;
  videoLessonSkillId: Scalars['uuid'];
  /** An object relationship */
  videoLessonSkills: VideoLessonSkills;
};

/** aggregated selection of "video_analysis_skills_comments" */
export type VideoAnalysisSkillsCommentsAggregate = {
  __typename?: 'VideoAnalysisSkillsCommentsAggregate';
  aggregate?: Maybe<VideoAnalysisSkillsCommentsAggregateFields>;
  nodes: Array<VideoAnalysisSkillsComments>;
};

export type VideoAnalysisSkillsCommentsAggregateBoolExp = {
  count?: InputMaybe<VideoAnalysisSkillsCommentsAggregateBoolExpCount>;
};

/** aggregate fields of "video_analysis_skills_comments" */
export type VideoAnalysisSkillsCommentsAggregateFields = {
  __typename?: 'VideoAnalysisSkillsCommentsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<VideoAnalysisSkillsCommentsMaxFields>;
  min?: Maybe<VideoAnalysisSkillsCommentsMinFields>;
};


/** aggregate fields of "video_analysis_skills_comments" */
export type VideoAnalysisSkillsCommentsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<VideoAnalysisSkillsCommentsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "video_analysis_skills_comments" */
export type VideoAnalysisSkillsCommentsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<VideoAnalysisSkillsCommentsMaxOrderBy>;
  min?: InputMaybe<VideoAnalysisSkillsCommentsMinOrderBy>;
};

/** input type for inserting array relation for remote table "video_analysis_skills_comments" */
export type VideoAnalysisSkillsCommentsArrRelInsertInput = {
  data: Array<VideoAnalysisSkillsCommentsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<VideoAnalysisSkillsCommentsOnConflict>;
};

/** Boolean expression to filter rows from the table "video_analysis_skills_comments". All fields are combined with a logical 'AND'. */
export type VideoAnalysisSkillsCommentsBoolExp = {
  _and?: InputMaybe<Array<VideoAnalysisSkillsCommentsBoolExp>>;
  _not?: InputMaybe<VideoAnalysisSkillsCommentsBoolExp>;
  _or?: InputMaybe<Array<VideoAnalysisSkillsCommentsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  videoAnalysisCommentId?: InputMaybe<UuidComparisonExp>;
  videoAnalysisComments?: InputMaybe<VideoAnalysisCommentsBoolExp>;
  videoLessonSkillId?: InputMaybe<UuidComparisonExp>;
  videoLessonSkills?: InputMaybe<VideoLessonSkillsBoolExp>;
};

/** unique or primary key constraints on table "video_analysis_skills_comments" */
export enum VideoAnalysisSkillsCommentsConstraint {
  /** unique or primary key constraint on columns "id" */
  VideoAnalysisSkillsCommentsPkey = 'video_analysis_skills_comments_pkey',
  /** unique or primary key constraint on columns "video_lesson_skill_id", "video_analysis_comment_id" */
  VideoAnalysisSkillsCommentsVideoLessonSkillIdVideoAnay = 'video_analysis_skills_comments_video_lesson_skill_id_video_anay'
}

/** input type for inserting data into table "video_analysis_skills_comments" */
export type VideoAnalysisSkillsCommentsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  videoAnalysisCommentId?: InputMaybe<Scalars['uuid']>;
  videoAnalysisComments?: InputMaybe<VideoAnalysisCommentsObjRelInsertInput>;
  videoLessonSkillId?: InputMaybe<Scalars['uuid']>;
  videoLessonSkills?: InputMaybe<VideoLessonSkillsObjRelInsertInput>;
};

/** aggregate max on columns */
export type VideoAnalysisSkillsCommentsMaxFields = {
  __typename?: 'VideoAnalysisSkillsCommentsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  videoAnalysisCommentId?: Maybe<Scalars['uuid']>;
  videoLessonSkillId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "video_analysis_skills_comments" */
export type VideoAnalysisSkillsCommentsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  videoAnalysisCommentId?: InputMaybe<OrderBy>;
  videoLessonSkillId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type VideoAnalysisSkillsCommentsMinFields = {
  __typename?: 'VideoAnalysisSkillsCommentsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  videoAnalysisCommentId?: Maybe<Scalars['uuid']>;
  videoLessonSkillId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "video_analysis_skills_comments" */
export type VideoAnalysisSkillsCommentsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  videoAnalysisCommentId?: InputMaybe<OrderBy>;
  videoLessonSkillId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "video_analysis_skills_comments" */
export type VideoAnalysisSkillsCommentsMutationResponse = {
  __typename?: 'VideoAnalysisSkillsCommentsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<VideoAnalysisSkillsComments>;
};

/** on_conflict condition type for table "video_analysis_skills_comments" */
export type VideoAnalysisSkillsCommentsOnConflict = {
  constraint: VideoAnalysisSkillsCommentsConstraint;
  updateColumns?: Array<VideoAnalysisSkillsCommentsUpdateColumn>;
  where?: InputMaybe<VideoAnalysisSkillsCommentsBoolExp>;
};

/** Ordering options when selecting data from "video_analysis_skills_comments". */
export type VideoAnalysisSkillsCommentsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  videoAnalysisCommentId?: InputMaybe<OrderBy>;
  videoAnalysisComments?: InputMaybe<VideoAnalysisCommentsOrderBy>;
  videoLessonSkillId?: InputMaybe<OrderBy>;
  videoLessonSkills?: InputMaybe<VideoLessonSkillsOrderBy>;
};

/** primary key columns input for table: video_analysis_skills_comments */
export type VideoAnalysisSkillsCommentsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "video_analysis_skills_comments" */
export enum VideoAnalysisSkillsCommentsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  VideoAnalysisCommentId = 'videoAnalysisCommentId',
  /** column name */
  VideoLessonSkillId = 'videoLessonSkillId'
}

/** input type for updating data in table "video_analysis_skills_comments" */
export type VideoAnalysisSkillsCommentsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  videoAnalysisCommentId?: InputMaybe<Scalars['uuid']>;
  videoLessonSkillId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "video_analysis_skills_comments" */
export type VideoAnalysisSkillsCommentsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: VideoAnalysisSkillsCommentsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type VideoAnalysisSkillsCommentsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  videoAnalysisCommentId?: InputMaybe<Scalars['uuid']>;
  videoLessonSkillId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "video_analysis_skills_comments" */
export enum VideoAnalysisSkillsCommentsUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  VideoAnalysisCommentId = 'videoAnalysisCommentId',
  /** column name */
  VideoLessonSkillId = 'videoLessonSkillId'
}

export type VideoAnalysisSkillsCommentsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<VideoAnalysisSkillsCommentsSetInput>;
  /** filter the rows which have to be updated */
  where: VideoAnalysisSkillsCommentsBoolExp;
};

/** aggregate stddev on columns */
export type VideoAnalysisStddevFields = {
  __typename?: 'VideoAnalysisStddevFields';
  priceUnitAmount?: Maybe<Scalars['Float']>;
  timezoneOffsetMinutes?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "video_analysis" */
export type VideoAnalysisStddevOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
  timezoneOffsetMinutes?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type VideoAnalysisStddevPopFields = {
  __typename?: 'VideoAnalysisStddevPopFields';
  priceUnitAmount?: Maybe<Scalars['Float']>;
  timezoneOffsetMinutes?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "video_analysis" */
export type VideoAnalysisStddevPopOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
  timezoneOffsetMinutes?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type VideoAnalysisStddevSampFields = {
  __typename?: 'VideoAnalysisStddevSampFields';
  priceUnitAmount?: Maybe<Scalars['Float']>;
  timezoneOffsetMinutes?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "video_analysis" */
export type VideoAnalysisStddevSampOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
  timezoneOffsetMinutes?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "video_analysis" */
export type VideoAnalysisStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: VideoAnalysisStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type VideoAnalysisStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  locale?: InputMaybe<Scalars['String']>;
  paymentFulfillmentChannel?: InputMaybe<PaymentFulfillmentChannelsEnum>;
  priceUnitAmount?: InputMaybe<Scalars['Int']>;
  reviewStatus?: InputMaybe<VideoAnalysisReviewStatusesEnum>;
  reviewerUserId?: InputMaybe<Scalars['uuid']>;
  submissionRequestedFeedback?: InputMaybe<Scalars['String']>;
  submissionUserId?: InputMaybe<Scalars['uuid']>;
  timezoneAbbreviation?: InputMaybe<Scalars['String']>;
  timezoneName?: InputMaybe<Scalars['String']>;
  timezoneOffsetMinutes?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  videoAnalysisFileId?: InputMaybe<Scalars['uuid']>;
};

/** columns and relationships of "video_analysis_submission_log" */
export type VideoAnalysisSubmissionLog = {
  __typename?: 'VideoAnalysisSubmissionLog';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
  userId?: Maybe<Scalars['uuid']>;
  videoAnalysisId?: Maybe<Scalars['uuid']>;
  videoName: Scalars['String'];
  videoPath: Scalars['String'];
};

/** aggregated selection of "video_analysis_submission_log" */
export type VideoAnalysisSubmissionLogAggregate = {
  __typename?: 'VideoAnalysisSubmissionLogAggregate';
  aggregate?: Maybe<VideoAnalysisSubmissionLogAggregateFields>;
  nodes: Array<VideoAnalysisSubmissionLog>;
};

/** aggregate fields of "video_analysis_submission_log" */
export type VideoAnalysisSubmissionLogAggregateFields = {
  __typename?: 'VideoAnalysisSubmissionLogAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<VideoAnalysisSubmissionLogMaxFields>;
  min?: Maybe<VideoAnalysisSubmissionLogMinFields>;
};


/** aggregate fields of "video_analysis_submission_log" */
export type VideoAnalysisSubmissionLogAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<VideoAnalysisSubmissionLogSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "video_analysis_submission_log". All fields are combined with a logical 'AND'. */
export type VideoAnalysisSubmissionLogBoolExp = {
  _and?: InputMaybe<Array<VideoAnalysisSubmissionLogBoolExp>>;
  _not?: InputMaybe<VideoAnalysisSubmissionLogBoolExp>;
  _or?: InputMaybe<Array<VideoAnalysisSubmissionLogBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  userId?: InputMaybe<UuidComparisonExp>;
  videoAnalysisId?: InputMaybe<UuidComparisonExp>;
  videoName?: InputMaybe<StringComparisonExp>;
  videoPath?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "video_analysis_submission_log" */
export enum VideoAnalysisSubmissionLogConstraint {
  /** unique or primary key constraint on columns "id" */
  VideoAnalysisSubmissionLogPkey = 'video_analysis_submission_log_pkey'
}

/** input type for inserting data into table "video_analysis_submission_log" */
export type VideoAnalysisSubmissionLogInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
  videoAnalysisId?: InputMaybe<Scalars['uuid']>;
  videoName?: InputMaybe<Scalars['String']>;
  videoPath?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type VideoAnalysisSubmissionLogMaxFields = {
  __typename?: 'VideoAnalysisSubmissionLogMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
  videoAnalysisId?: Maybe<Scalars['uuid']>;
  videoName?: Maybe<Scalars['String']>;
  videoPath?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type VideoAnalysisSubmissionLogMinFields = {
  __typename?: 'VideoAnalysisSubmissionLogMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
  videoAnalysisId?: Maybe<Scalars['uuid']>;
  videoName?: Maybe<Scalars['String']>;
  videoPath?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "video_analysis_submission_log" */
export type VideoAnalysisSubmissionLogMutationResponse = {
  __typename?: 'VideoAnalysisSubmissionLogMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<VideoAnalysisSubmissionLog>;
};

/** on_conflict condition type for table "video_analysis_submission_log" */
export type VideoAnalysisSubmissionLogOnConflict = {
  constraint: VideoAnalysisSubmissionLogConstraint;
  updateColumns?: Array<VideoAnalysisSubmissionLogUpdateColumn>;
  where?: InputMaybe<VideoAnalysisSubmissionLogBoolExp>;
};

/** Ordering options when selecting data from "video_analysis_submission_log". */
export type VideoAnalysisSubmissionLogOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
  videoAnalysisId?: InputMaybe<OrderBy>;
  videoName?: InputMaybe<OrderBy>;
  videoPath?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: video_analysis_submission_log */
export type VideoAnalysisSubmissionLogPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "video_analysis_submission_log" */
export enum VideoAnalysisSubmissionLogSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId',
  /** column name */
  VideoAnalysisId = 'videoAnalysisId',
  /** column name */
  VideoName = 'videoName',
  /** column name */
  VideoPath = 'videoPath'
}

/** input type for updating data in table "video_analysis_submission_log" */
export type VideoAnalysisSubmissionLogSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
  videoAnalysisId?: InputMaybe<Scalars['uuid']>;
  videoName?: InputMaybe<Scalars['String']>;
  videoPath?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "video_analysis_submission_log" */
export type VideoAnalysisSubmissionLogStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: VideoAnalysisSubmissionLogStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type VideoAnalysisSubmissionLogStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
  videoAnalysisId?: InputMaybe<Scalars['uuid']>;
  videoName?: InputMaybe<Scalars['String']>;
  videoPath?: InputMaybe<Scalars['String']>;
};

/** update columns of table "video_analysis_submission_log" */
export enum VideoAnalysisSubmissionLogUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId',
  /** column name */
  VideoAnalysisId = 'videoAnalysisId',
  /** column name */
  VideoName = 'videoName',
  /** column name */
  VideoPath = 'videoPath'
}

export type VideoAnalysisSubmissionLogUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<VideoAnalysisSubmissionLogSetInput>;
  /** filter the rows which have to be updated */
  where: VideoAnalysisSubmissionLogBoolExp;
};

/** aggregate sum on columns */
export type VideoAnalysisSumFields = {
  __typename?: 'VideoAnalysisSumFields';
  priceUnitAmount?: Maybe<Scalars['Int']>;
  timezoneOffsetMinutes?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "video_analysis" */
export type VideoAnalysisSumOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
  timezoneOffsetMinutes?: InputMaybe<OrderBy>;
};

/** update columns of table "video_analysis" */
export enum VideoAnalysisUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Currency = 'currency',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  Locale = 'locale',
  /** column name */
  PaymentFulfillmentChannel = 'paymentFulfillmentChannel',
  /** column name */
  PriceUnitAmount = 'priceUnitAmount',
  /** column name */
  ReviewStatus = 'reviewStatus',
  /** column name */
  ReviewerUserId = 'reviewerUserId',
  /** column name */
  SubmissionRequestedFeedback = 'submissionRequestedFeedback',
  /** column name */
  SubmissionUserId = 'submissionUserId',
  /** column name */
  TimezoneAbbreviation = 'timezoneAbbreviation',
  /** column name */
  TimezoneName = 'timezoneName',
  /** column name */
  TimezoneOffsetMinutes = 'timezoneOffsetMinutes',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  VideoAnalysisFileId = 'videoAnalysisFileId'
}

export type VideoAnalysisUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<VideoAnalysisIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<VideoAnalysisSetInput>;
  /** filter the rows which have to be updated */
  where: VideoAnalysisBoolExp;
};

/** aggregate varPop on columns */
export type VideoAnalysisVarPopFields = {
  __typename?: 'VideoAnalysisVarPopFields';
  priceUnitAmount?: Maybe<Scalars['Float']>;
  timezoneOffsetMinutes?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "video_analysis" */
export type VideoAnalysisVarPopOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
  timezoneOffsetMinutes?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type VideoAnalysisVarSampFields = {
  __typename?: 'VideoAnalysisVarSampFields';
  priceUnitAmount?: Maybe<Scalars['Float']>;
  timezoneOffsetMinutes?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "video_analysis" */
export type VideoAnalysisVarSampOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
  timezoneOffsetMinutes?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type VideoAnalysisVarianceFields = {
  __typename?: 'VideoAnalysisVarianceFields';
  priceUnitAmount?: Maybe<Scalars['Float']>;
  timezoneOffsetMinutes?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "video_analysis" */
export type VideoAnalysisVarianceOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
  timezoneOffsetMinutes?: InputMaybe<OrderBy>;
};

/** columns and relationships of "video_lesson_skills" */
export type VideoLessonSkills = {
  __typename?: 'VideoLessonSkills';
  createdAt: Scalars['timestamptz'];
  customSkill?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  skill?: Maybe<LessonSkillsEnum>;
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid'];
  /** An array relationship */
  videoAnalysisSkillsComments: Array<VideoAnalysisSkillsComments>;
  /** An aggregate relationship */
  videoAnalysisSkillsCommentsAggregate: VideoAnalysisSkillsCommentsAggregate;
};


/** columns and relationships of "video_lesson_skills" */
export type VideoLessonSkillsVideoAnalysisSkillsCommentsArgs = {
  distinctOn?: InputMaybe<Array<VideoAnalysisSkillsCommentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoAnalysisSkillsCommentsOrderBy>>;
  where?: InputMaybe<VideoAnalysisSkillsCommentsBoolExp>;
};


/** columns and relationships of "video_lesson_skills" */
export type VideoLessonSkillsVideoAnalysisSkillsCommentsAggregateArgs = {
  distinctOn?: InputMaybe<Array<VideoAnalysisSkillsCommentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoAnalysisSkillsCommentsOrderBy>>;
  where?: InputMaybe<VideoAnalysisSkillsCommentsBoolExp>;
};

/** aggregated selection of "video_lesson_skills" */
export type VideoLessonSkillsAggregate = {
  __typename?: 'VideoLessonSkillsAggregate';
  aggregate?: Maybe<VideoLessonSkillsAggregateFields>;
  nodes: Array<VideoLessonSkills>;
};

/** aggregate fields of "video_lesson_skills" */
export type VideoLessonSkillsAggregateFields = {
  __typename?: 'VideoLessonSkillsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<VideoLessonSkillsMaxFields>;
  min?: Maybe<VideoLessonSkillsMinFields>;
};


/** aggregate fields of "video_lesson_skills" */
export type VideoLessonSkillsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<VideoLessonSkillsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "video_lesson_skills". All fields are combined with a logical 'AND'. */
export type VideoLessonSkillsBoolExp = {
  _and?: InputMaybe<Array<VideoLessonSkillsBoolExp>>;
  _not?: InputMaybe<VideoLessonSkillsBoolExp>;
  _or?: InputMaybe<Array<VideoLessonSkillsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  customSkill?: InputMaybe<StringComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  skill?: InputMaybe<LessonSkillsEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
  videoAnalysisSkillsComments?: InputMaybe<VideoAnalysisSkillsCommentsBoolExp>;
  videoAnalysisSkillsCommentsAggregate?: InputMaybe<VideoAnalysisSkillsCommentsAggregateBoolExp>;
};

/** unique or primary key constraints on table "video_lesson_skills" */
export enum VideoLessonSkillsConstraint {
  /** unique or primary key constraint on columns "id" */
  VideoLessonSkillsPkey = 'video_lesson_skills_pkey'
}

/** input type for inserting data into table "video_lesson_skills" */
export type VideoLessonSkillsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  customSkill?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  skill?: InputMaybe<LessonSkillsEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']>;
  videoAnalysisSkillsComments?: InputMaybe<VideoAnalysisSkillsCommentsArrRelInsertInput>;
};

/** aggregate max on columns */
export type VideoLessonSkillsMaxFields = {
  __typename?: 'VideoLessonSkillsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  customSkill?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type VideoLessonSkillsMinFields = {
  __typename?: 'VideoLessonSkillsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  customSkill?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "video_lesson_skills" */
export type VideoLessonSkillsMutationResponse = {
  __typename?: 'VideoLessonSkillsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<VideoLessonSkills>;
};

/** input type for inserting object relation for remote table "video_lesson_skills" */
export type VideoLessonSkillsObjRelInsertInput = {
  data: VideoLessonSkillsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<VideoLessonSkillsOnConflict>;
};

/** on_conflict condition type for table "video_lesson_skills" */
export type VideoLessonSkillsOnConflict = {
  constraint: VideoLessonSkillsConstraint;
  updateColumns?: Array<VideoLessonSkillsUpdateColumn>;
  where?: InputMaybe<VideoLessonSkillsBoolExp>;
};

/** Ordering options when selecting data from "video_lesson_skills". */
export type VideoLessonSkillsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  customSkill?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  skill?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
  videoAnalysisSkillsCommentsAggregate?: InputMaybe<VideoAnalysisSkillsCommentsAggregateOrderBy>;
};

/** primary key columns input for table: video_lesson_skills */
export type VideoLessonSkillsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "video_lesson_skills" */
export enum VideoLessonSkillsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CustomSkill = 'customSkill',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  Skill = 'skill',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "video_lesson_skills" */
export type VideoLessonSkillsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  customSkill?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  skill?: InputMaybe<LessonSkillsEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "video_lesson_skills" */
export type VideoLessonSkillsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: VideoLessonSkillsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type VideoLessonSkillsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  customSkill?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  skill?: InputMaybe<LessonSkillsEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "video_lesson_skills" */
export enum VideoLessonSkillsUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CustomSkill = 'customSkill',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  Skill = 'skill',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

export type VideoLessonSkillsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<VideoLessonSkillsSetInput>;
  /** filter the rows which have to be updated */
  where: VideoLessonSkillsBoolExp;
};

/** Make template an enum later. Also maybe make a jsonb field if we ever want multiple emails during welcome. */
export type WelcomeEmailConfiguration = {
  __typename?: 'WelcomeEmailConfiguration';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  email: Scalars['String'];
  id: Scalars['uuid'];
  template?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "welcome_email_configuration" */
export type WelcomeEmailConfigurationAggregate = {
  __typename?: 'WelcomeEmailConfigurationAggregate';
  aggregate?: Maybe<WelcomeEmailConfigurationAggregateFields>;
  nodes: Array<WelcomeEmailConfiguration>;
};

/** aggregate fields of "welcome_email_configuration" */
export type WelcomeEmailConfigurationAggregateFields = {
  __typename?: 'WelcomeEmailConfigurationAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<WelcomeEmailConfigurationMaxFields>;
  min?: Maybe<WelcomeEmailConfigurationMinFields>;
};


/** aggregate fields of "welcome_email_configuration" */
export type WelcomeEmailConfigurationAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<WelcomeEmailConfigurationSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "welcome_email_configuration". All fields are combined with a logical 'AND'. */
export type WelcomeEmailConfigurationBoolExp = {
  _and?: InputMaybe<Array<WelcomeEmailConfigurationBoolExp>>;
  _not?: InputMaybe<WelcomeEmailConfigurationBoolExp>;
  _or?: InputMaybe<Array<WelcomeEmailConfigurationBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  email?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  template?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "welcome_email_configuration" */
export enum WelcomeEmailConfigurationConstraint {
  /** unique or primary key constraint on columns "email" */
  WelcomeEmailConfigurationEmailKey = 'welcome_email_configuration_email_key',
  /** unique or primary key constraint on columns "id" */
  WelcomeEmailConfigurationPkey = 'welcome_email_configuration_pkey'
}

/** input type for inserting data into table "welcome_email_configuration" */
export type WelcomeEmailConfigurationInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  template?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type WelcomeEmailConfigurationMaxFields = {
  __typename?: 'WelcomeEmailConfigurationMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  template?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type WelcomeEmailConfigurationMinFields = {
  __typename?: 'WelcomeEmailConfigurationMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  template?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "welcome_email_configuration" */
export type WelcomeEmailConfigurationMutationResponse = {
  __typename?: 'WelcomeEmailConfigurationMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<WelcomeEmailConfiguration>;
};

/** on_conflict condition type for table "welcome_email_configuration" */
export type WelcomeEmailConfigurationOnConflict = {
  constraint: WelcomeEmailConfigurationConstraint;
  updateColumns?: Array<WelcomeEmailConfigurationUpdateColumn>;
  where?: InputMaybe<WelcomeEmailConfigurationBoolExp>;
};

/** Ordering options when selecting data from "welcome_email_configuration". */
export type WelcomeEmailConfigurationOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  email?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  template?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: welcome_email_configuration */
export type WelcomeEmailConfigurationPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "welcome_email_configuration" */
export enum WelcomeEmailConfigurationSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  Template = 'template',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "welcome_email_configuration" */
export type WelcomeEmailConfigurationSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  template?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "welcome_email_configuration" */
export type WelcomeEmailConfigurationStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: WelcomeEmailConfigurationStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type WelcomeEmailConfigurationStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  template?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "welcome_email_configuration" */
export enum WelcomeEmailConfigurationUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  Template = 'template',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type WelcomeEmailConfigurationUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<WelcomeEmailConfigurationSetInput>;
  /** filter the rows which have to be updated */
  where: WelcomeEmailConfigurationBoolExp;
};

/** columns and relationships of "win_reasons" */
export type WinReasons = {
  __typename?: 'WinReasons';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "win_reasons" */
export type WinReasonsAggregate = {
  __typename?: 'WinReasonsAggregate';
  aggregate?: Maybe<WinReasonsAggregateFields>;
  nodes: Array<WinReasons>;
};

/** aggregate fields of "win_reasons" */
export type WinReasonsAggregateFields = {
  __typename?: 'WinReasonsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<WinReasonsMaxFields>;
  min?: Maybe<WinReasonsMinFields>;
};


/** aggregate fields of "win_reasons" */
export type WinReasonsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<WinReasonsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "win_reasons". All fields are combined with a logical 'AND'. */
export type WinReasonsBoolExp = {
  _and?: InputMaybe<Array<WinReasonsBoolExp>>;
  _not?: InputMaybe<WinReasonsBoolExp>;
  _or?: InputMaybe<Array<WinReasonsBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "win_reasons" */
export enum WinReasonsConstraint {
  /** unique or primary key constraint on columns "value" */
  WinReasonsPkey = 'win_reasons_pkey'
}

export enum WinReasonsEnum {
  Forfeit = 'FORFEIT',
  OrganizerSelected = 'ORGANIZER_SELECTED',
  Retire = 'RETIRE',
  Score = 'SCORE'
}

/** Boolean expression to compare columns of type "WinReasonsEnum". All fields are combined with logical 'AND'. */
export type WinReasonsEnumComparisonExp = {
  _eq?: InputMaybe<WinReasonsEnum>;
  _in?: InputMaybe<Array<WinReasonsEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<WinReasonsEnum>;
  _nin?: InputMaybe<Array<WinReasonsEnum>>;
};

/** input type for inserting data into table "win_reasons" */
export type WinReasonsInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type WinReasonsMaxFields = {
  __typename?: 'WinReasonsMaxFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type WinReasonsMinFields = {
  __typename?: 'WinReasonsMinFields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "win_reasons" */
export type WinReasonsMutationResponse = {
  __typename?: 'WinReasonsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<WinReasons>;
};

/** on_conflict condition type for table "win_reasons" */
export type WinReasonsOnConflict = {
  constraint: WinReasonsConstraint;
  updateColumns?: Array<WinReasonsUpdateColumn>;
  where?: InputMaybe<WinReasonsBoolExp>;
};

/** Ordering options when selecting data from "win_reasons". */
export type WinReasonsOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: win_reasons */
export type WinReasonsPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "win_reasons" */
export enum WinReasonsSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "win_reasons" */
export type WinReasonsSetInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "win_reasons" */
export type WinReasonsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: WinReasonsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type WinReasonsStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "win_reasons" */
export enum WinReasonsUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type WinReasonsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<WinReasonsSetInput>;
  /** filter the rows which have to be updated */
  where: WinReasonsBoolExp;
};

export type BoostsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<BoostsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<BoostsBoolExp>;
  predicate: IntComparisonExp;
};

export type CalendarPreferencesAggregateBoolExpBool_And = {
  arguments: CalendarPreferencesSelectColumnCalendarPreferencesAggregateBoolExpBool_AndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CalendarPreferencesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type CalendarPreferencesAggregateBoolExpBool_Or = {
  arguments: CalendarPreferencesSelectColumnCalendarPreferencesAggregateBoolExpBool_OrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CalendarPreferencesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type CalendarPreferencesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<CalendarPreferencesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CalendarPreferencesBoolExp>;
  predicate: IntComparisonExp;
};

export type CitiesAggregateBoolExpBool_And = {
  arguments: CitiesSelectColumnCitiesAggregateBoolExpBool_AndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CitiesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type CitiesAggregateBoolExpBool_Or = {
  arguments: CitiesSelectColumnCitiesAggregateBoolExpBool_OrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CitiesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type CitiesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<CitiesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CitiesBoolExp>;
  predicate: IntComparisonExp;
};

export type CoachAvailabilityAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<CoachAvailabilitySelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CoachAvailabilityBoolExp>;
  predicate: IntComparisonExp;
};

export type CoachFaqsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<CoachFaqsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CoachFaqsBoolExp>;
  predicate: IntComparisonExp;
};

export type CoachLessonAgeGroupsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<CoachLessonAgeGroupsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CoachLessonAgeGroupsBoolExp>;
  predicate: IntComparisonExp;
};

export type CoachLessonSkillLevelsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<CoachLessonSkillLevelsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CoachLessonSkillLevelsBoolExp>;
  predicate: IntComparisonExp;
};

export type CoachSportsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<CoachSportsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CoachSportsBoolExp>;
  predicate: IntComparisonExp;
};

export type CoachStarterProfilesAggregateBoolExpBool_And = {
  arguments: CoachStarterProfilesSelectColumnCoachStarterProfilesAggregateBoolExpBool_AndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CoachStarterProfilesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type CoachStarterProfilesAggregateBoolExpBool_Or = {
  arguments: CoachStarterProfilesSelectColumnCoachStarterProfilesAggregateBoolExpBool_OrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CoachStarterProfilesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type CoachStarterProfilesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<CoachStarterProfilesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CoachStarterProfilesBoolExp>;
  predicate: IntComparisonExp;
};

export type ConversationParticipantsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<ConversationParticipantsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ConversationParticipantsBoolExp>;
  predicate: IntComparisonExp;
};

export type ConversationsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<ConversationsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ConversationsBoolExp>;
  predicate: IntComparisonExp;
};

export type CountrySubdivisionsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<CountrySubdivisionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CountrySubdivisionsBoolExp>;
  predicate: IntComparisonExp;
};

export type EngagementAnalyticsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<EngagementAnalyticsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EngagementAnalyticsBoolExp>;
  predicate: IntComparisonExp;
};

export type EventAcceptedPlayRequestsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<EventAcceptedPlayRequestsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EventAcceptedPlayRequestsBoolExp>;
  predicate: IntComparisonExp;
};

export type EventCouponGroupsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<EventCouponGroupsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EventCouponGroupsBoolExp>;
  predicate: IntComparisonExp;
};

export type EventCouponRedemptionsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<EventCouponRedemptionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EventCouponRedemptionsBoolExp>;
  predicate: IntComparisonExp;
};

export type EventCouponsAggregateBoolExpBool_And = {
  arguments: EventCouponsSelectColumnEventCouponsAggregateBoolExpBool_AndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EventCouponsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type EventCouponsAggregateBoolExpBool_Or = {
  arguments: EventCouponsSelectColumnEventCouponsAggregateBoolExpBool_OrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EventCouponsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type EventCouponsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<EventCouponsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EventCouponsBoolExp>;
  predicate: IntComparisonExp;
};

export type EventCourtsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<EventCourtsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EventCourtsBoolExp>;
  predicate: IntComparisonExp;
};

export type EventFaqsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<EventFaqsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EventFaqsBoolExp>;
  predicate: IntComparisonExp;
};

export type EventGameScoresAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<EventGameScoresSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EventGameScoresBoolExp>;
  predicate: IntComparisonExp;
};

export type EventGroupPoolsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<EventGroupPoolsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EventGroupPoolsBoolExp>;
  predicate: IntComparisonExp;
};

export type EventGroupRatingScalesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<EventGroupRatingScalesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EventGroupRatingScalesBoolExp>;
  predicate: IntComparisonExp;
};

export type EventGroupRegistrationsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<EventGroupRegistrationsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EventGroupRegistrationsBoolExp>;
  predicate: IntComparisonExp;
};

export type EventGroupSequenceSeedingAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<EventGroupSequenceSeedingSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EventGroupSequenceSeedingBoolExp>;
  predicate: IntComparisonExp;
};

export type EventGroupSequencesAggregateBoolExpBool_And = {
  arguments: EventGroupSequencesSelectColumnEventGroupSequencesAggregateBoolExpBool_AndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EventGroupSequencesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type EventGroupSequencesAggregateBoolExpBool_Or = {
  arguments: EventGroupSequencesSelectColumnEventGroupSequencesAggregateBoolExpBool_OrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EventGroupSequencesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type EventGroupSequencesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<EventGroupSequencesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EventGroupSequencesBoolExp>;
  predicate: IntComparisonExp;
};

export type EventGroupTimeSlotsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<EventGroupTimeSlotsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EventGroupTimeSlotsBoolExp>;
  predicate: IntComparisonExp;
};

export type EventGroupsAggregateBoolExpBool_And = {
  arguments: EventGroupsSelectColumnEventGroupsAggregateBoolExpBool_AndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EventGroupsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type EventGroupsAggregateBoolExpBool_Or = {
  arguments: EventGroupsSelectColumnEventGroupsAggregateBoolExpBool_OrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EventGroupsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type EventGroupsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<EventGroupsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EventGroupsBoolExp>;
  predicate: IntComparisonExp;
};

export type EventInvitationsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<EventInvitationsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EventInvitationsBoolExp>;
  predicate: IntComparisonExp;
};

export type EventListingFeesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<EventListingFeesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EventListingFeesBoolExp>;
  predicate: IntComparisonExp;
};

export type EventMatchGamesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<EventMatchGamesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EventMatchGamesBoolExp>;
  predicate: IntComparisonExp;
};

export type EventMatchesAggregateBoolExpBool_And = {
  arguments: EventMatchesSelectColumnEventMatchesAggregateBoolExpBool_AndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EventMatchesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type EventMatchesAggregateBoolExpBool_Or = {
  arguments: EventMatchesSelectColumnEventMatchesAggregateBoolExpBool_OrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EventMatchesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type EventMatchesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<EventMatchesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EventMatchesBoolExp>;
  predicate: IntComparisonExp;
};

export type EventMatchesTeamsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<EventMatchesTeamsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EventMatchesTeamsBoolExp>;
  predicate: IntComparisonExp;
};

export type EventPoolRoundsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<EventPoolRoundsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EventPoolRoundsBoolExp>;
  predicate: IntComparisonExp;
};

export type EventPoolsTeamsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<EventPoolsTeamsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EventPoolsTeamsBoolExp>;
  predicate: IntComparisonExp;
};

export type EventRegistrationsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<EventRegistrationsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EventRegistrationsBoolExp>;
  predicate: IntComparisonExp;
};

export type EventSkillLevelsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<EventSkillLevelsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EventSkillLevelsBoolExp>;
  predicate: IntComparisonExp;
};

export type EventSponsorsAggregateBoolExpBool_And = {
  arguments: EventSponsorsSelectColumnEventSponsorsAggregateBoolExpBool_AndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EventSponsorsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type EventSponsorsAggregateBoolExpBool_Or = {
  arguments: EventSponsorsSelectColumnEventSponsorsAggregateBoolExpBool_OrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EventSponsorsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type EventSponsorsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<EventSponsorsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EventSponsorsBoolExp>;
  predicate: IntComparisonExp;
};

export type EventTeamMembersAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<EventTeamMembersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EventTeamMembersBoolExp>;
  predicate: IntComparisonExp;
};

export type EventTeamsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<EventTeamsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EventTeamsBoolExp>;
  predicate: IntComparisonExp;
};

export type EventTransactionItemsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<EventTransactionItemsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EventTransactionItemsBoolExp>;
  predicate: IntComparisonExp;
};

export type EventTransactionsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<EventTransactionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EventTransactionsBoolExp>;
  predicate: IntComparisonExp;
};

export type EventsAggregateBoolExpBool_And = {
  arguments: EventsSelectColumnEventsAggregateBoolExpBool_AndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EventsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type EventsAggregateBoolExpBool_Or = {
  arguments: EventsSelectColumnEventsAggregateBoolExpBool_OrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EventsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type EventsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<EventsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EventsBoolExp>;
  predicate: IntComparisonExp;
};

export type GroupCommentVotesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<GroupCommentVotesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<GroupCommentVotesBoolExp>;
  predicate: IntComparisonExp;
};

export type GroupMembersAggregateBoolExpBool_And = {
  arguments: GroupMembersSelectColumnGroupMembersAggregateBoolExpBool_AndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<GroupMembersBoolExp>;
  predicate: BooleanComparisonExp;
};

export type GroupMembersAggregateBoolExpBool_Or = {
  arguments: GroupMembersSelectColumnGroupMembersAggregateBoolExpBool_OrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<GroupMembersBoolExp>;
  predicate: BooleanComparisonExp;
};

export type GroupMembersAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<GroupMembersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<GroupMembersBoolExp>;
  predicate: IntComparisonExp;
};

export type GroupThreadCommentFilesAggregateBoolExpBool_And = {
  arguments: GroupThreadCommentFilesSelectColumnGroupThreadCommentFilesAggregateBoolExpBool_AndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<GroupThreadCommentFilesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type GroupThreadCommentFilesAggregateBoolExpBool_Or = {
  arguments: GroupThreadCommentFilesSelectColumnGroupThreadCommentFilesAggregateBoolExpBool_OrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<GroupThreadCommentFilesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type GroupThreadCommentFilesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<GroupThreadCommentFilesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<GroupThreadCommentFilesBoolExp>;
  predicate: IntComparisonExp;
};

export type GroupThreadCommentsAggregateBoolExpBool_And = {
  arguments: GroupThreadCommentsSelectColumnGroupThreadCommentsAggregateBoolExpBool_AndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<GroupThreadCommentsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type GroupThreadCommentsAggregateBoolExpBool_Or = {
  arguments: GroupThreadCommentsSelectColumnGroupThreadCommentsAggregateBoolExpBool_OrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<GroupThreadCommentsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type GroupThreadCommentsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<GroupThreadCommentsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<GroupThreadCommentsBoolExp>;
  predicate: IntComparisonExp;
};

export type GroupThreadsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<GroupThreadsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<GroupThreadsBoolExp>;
  predicate: IntComparisonExp;
};

export type GroupVenuesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<GroupVenuesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<GroupVenuesBoolExp>;
  predicate: IntComparisonExp;
};

export type GroupsAggregateBoolExpBool_And = {
  arguments: GroupsSelectColumnGroupsAggregateBoolExpBool_AndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<GroupsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type GroupsAggregateBoolExpBool_Or = {
  arguments: GroupsSelectColumnGroupsAggregateBoolExpBool_OrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<GroupsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type GroupsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<GroupsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<GroupsBoolExp>;
  predicate: IntComparisonExp;
};

export type GroupsPlaySessionsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<GroupsPlaySessionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<GroupsPlaySessionsBoolExp>;
  predicate: IntComparisonExp;
};

export type InvoicesAggregateBoolExpBool_And = {
  arguments: InvoicesSelectColumnInvoicesAggregateBoolExpBool_AndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<InvoicesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type InvoicesAggregateBoolExpBool_Or = {
  arguments: InvoicesSelectColumnInvoicesAggregateBoolExpBool_OrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<InvoicesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type InvoicesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InvoicesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<InvoicesBoolExp>;
  predicate: IntComparisonExp;
};

export type LearningProgramEnrollmentScheduleMediaWatchedAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<LearningProgramEnrollmentScheduleMediaWatchedSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<LearningProgramEnrollmentScheduleMediaWatchedBoolExp>;
  predicate: IntComparisonExp;
};

export type LearningProgramEnrollmentScheduleProgressAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<LearningProgramEnrollmentScheduleProgressSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<LearningProgramEnrollmentScheduleProgressBoolExp>;
  predicate: IntComparisonExp;
};

export type LearningProgramEnrollmentsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<LearningProgramEnrollmentsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<LearningProgramEnrollmentsBoolExp>;
  predicate: IntComparisonExp;
};

export type LearningProgramScheduleMediaAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<LearningProgramScheduleMediaSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<LearningProgramScheduleMediaBoolExp>;
  predicate: IntComparisonExp;
};

export type LearningProgramScheduleVideoSubmissionsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<LearningProgramScheduleVideoSubmissionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<LearningProgramScheduleVideoSubmissionsBoolExp>;
  predicate: IntComparisonExp;
};

export type LearningProgramSchedulesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<LearningProgramSchedulesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<LearningProgramSchedulesBoolExp>;
  predicate: IntComparisonExp;
};

export type LearningProgramSkillsAggregateBoolExpBool_And = {
  arguments: LearningProgramSkillsSelectColumnLearningProgramSkillsAggregateBoolExpBool_AndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<LearningProgramSkillsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type LearningProgramSkillsAggregateBoolExpBool_Or = {
  arguments: LearningProgramSkillsSelectColumnLearningProgramSkillsAggregateBoolExpBool_OrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<LearningProgramSkillsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type LearningProgramSkillsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<LearningProgramSkillsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<LearningProgramSkillsBoolExp>;
  predicate: IntComparisonExp;
};

export type LessonEquipmentAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<LessonEquipmentSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<LessonEquipmentBoolExp>;
  predicate: IntComparisonExp;
};

export type LessonOrderItemsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<LessonOrderItemsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<LessonOrderItemsBoolExp>;
  predicate: IntComparisonExp;
};

export type LessonOrdersAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<LessonOrdersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<LessonOrdersBoolExp>;
  predicate: IntComparisonExp;
};

export type LessonParticipantsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<LessonParticipantsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<LessonParticipantsBoolExp>;
  predicate: IntComparisonExp;
};

export type LessonPlayerSkillAssessmentsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<LessonPlayerSkillAssessmentsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<LessonPlayerSkillAssessmentsBoolExp>;
  predicate: IntComparisonExp;
};

export type LessonPlayerSkillAssessmentsSkillsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<LessonPlayerSkillAssessmentsSkillsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<LessonPlayerSkillAssessmentsSkillsBoolExp>;
  predicate: IntComparisonExp;
};

export type LessonReflectionCommentsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<LessonReflectionCommentsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<LessonReflectionCommentsBoolExp>;
  predicate: IntComparisonExp;
};

export type LessonReflectionFilesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<LessonReflectionFilesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<LessonReflectionFilesBoolExp>;
  predicate: IntComparisonExp;
};

export type LessonReflectionsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<LessonReflectionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<LessonReflectionsBoolExp>;
  predicate: IntComparisonExp;
};

export type LessonSkillLevelsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<LessonSkillLevelsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<LessonSkillLevelsBoolExp>;
  predicate: IntComparisonExp;
};

export type LessonTemplateSkillLevelsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<LessonTemplateSkillLevelsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<LessonTemplateSkillLevelsBoolExp>;
  predicate: IntComparisonExp;
};

export type LessonTemplatesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<LessonTemplatesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<LessonTemplatesBoolExp>;
  predicate: IntComparisonExp;
};

export type LessonTimesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<LessonTimesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<LessonTimesBoolExp>;
  predicate: IntComparisonExp;
};

export type LessonWaitlistsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<LessonWaitlistsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<LessonWaitlistsBoolExp>;
  predicate: IntComparisonExp;
};

export type LessonsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<LessonsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<LessonsBoolExp>;
  predicate: IntComparisonExp;
};

export type MessagesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<MessagesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<MessagesBoolExp>;
  predicate: IntComparisonExp;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  /** delete data from the table: "amenities" */
  deleteAmenities?: Maybe<AmenitiesMutationResponse>;
  /** delete single row from the table: "amenities" */
  deleteAmenitiesByPk?: Maybe<Amenities>;
  /** delete data from the table: "app_personas" */
  deleteAppPersonas?: Maybe<AppPersonasMutationResponse>;
  /** delete single row from the table: "app_personas" */
  deleteAppPersonasByPk?: Maybe<AppPersonas>;
  /** delete data from the table: "app_pings" */
  deleteAppPings?: Maybe<AppPingsMutationResponse>;
  /** delete single row from the table: "app_pings" */
  deleteAppPingsByPk?: Maybe<AppPings>;
  /** delete data from the table: "ball_types" */
  deleteBallTypes?: Maybe<BallTypesMutationResponse>;
  /** delete single row from the table: "ball_types" */
  deleteBallTypesByPk?: Maybe<BallTypes>;
  /** delete data from the table: "birthday_visibility" */
  deleteBirthdayVisibility?: Maybe<BirthdayVisibilityMutationResponse>;
  /** delete single row from the table: "birthday_visibility" */
  deleteBirthdayVisibilityByPk?: Maybe<BirthdayVisibility>;
  /** delete data from the table: "booking_config_change_types" */
  deleteBookingConfigChangeTypes?: Maybe<BookingConfigChangeTypesMutationResponse>;
  /** delete single row from the table: "booking_config_change_types" */
  deleteBookingConfigChangeTypesByPk?: Maybe<BookingConfigChangeTypes>;
  /** delete data from the table: "booking_connection_statuses" */
  deleteBookingConnectionStatuses?: Maybe<BookingConnectionStatusesMutationResponse>;
  /** delete single row from the table: "booking_connection_statuses" */
  deleteBookingConnectionStatusesByPk?: Maybe<BookingConnectionStatuses>;
  /** delete data from the table: "booking_integration_statuses" */
  deleteBookingIntegrationStatuses?: Maybe<BookingIntegrationStatusesMutationResponse>;
  /** delete single row from the table: "booking_integration_statuses" */
  deleteBookingIntegrationStatusesByPk?: Maybe<BookingIntegrationStatuses>;
  /** delete data from the table: "booking_inventory_types" */
  deleteBookingInventoryTypes?: Maybe<BookingInventoryTypesMutationResponse>;
  /** delete single row from the table: "booking_inventory_types" */
  deleteBookingInventoryTypesByPk?: Maybe<BookingInventoryTypes>;
  /** delete data from the table: "booking_schedule_modes" */
  deleteBookingScheduleModes?: Maybe<BookingScheduleModesMutationResponse>;
  /** delete single row from the table: "booking_schedule_modes" */
  deleteBookingScheduleModesByPk?: Maybe<BookingScheduleModes>;
  /** delete data from the table: "booking_systems" */
  deleteBookingSystems?: Maybe<BookingSystemsMutationResponse>;
  /** delete single row from the table: "booking_systems" */
  deleteBookingSystemsByPk?: Maybe<BookingSystems>;
  /** delete data from the table: "booking_window_kinds" */
  deleteBookingWindowKinds?: Maybe<BookingWindowKindsMutationResponse>;
  /** delete single row from the table: "booking_window_kinds" */
  deleteBookingWindowKindsByPk?: Maybe<BookingWindowKinds>;
  /** delete data from the table: "boost_channels" */
  deleteBoostChannels?: Maybe<BoostChannelsMutationResponse>;
  /** delete single row from the table: "boost_channels" */
  deleteBoostChannelsByPk?: Maybe<BoostChannels>;
  /** delete data from the table: "boost_orders" */
  deleteBoostOrders?: Maybe<BoostOrdersMutationResponse>;
  /** delete single row from the table: "boost_orders" */
  deleteBoostOrdersByPk?: Maybe<BoostOrders>;
  /** delete data from the table: "boost_statuses" */
  deleteBoostStatuses?: Maybe<BoostStatusesMutationResponse>;
  /** delete single row from the table: "boost_statuses" */
  deleteBoostStatusesByPk?: Maybe<BoostStatuses>;
  /** delete data from the table: "boosts" */
  deleteBoosts?: Maybe<BoostsMutationResponse>;
  /** delete single row from the table: "boosts" */
  deleteBoostsByPk?: Maybe<Boosts>;
  /** delete data from the table: "bracket_ranking_mechanism" */
  deleteBracketRankingMechanism?: Maybe<BracketRankingMechanismMutationResponse>;
  /** delete single row from the table: "bracket_ranking_mechanism" */
  deleteBracketRankingMechanismByPk?: Maybe<BracketRankingMechanism>;
  /** delete data from the table: "calendar_accounts" */
  deleteCalendarAccounts?: Maybe<CalendarAccountsMutationResponse>;
  /** delete single row from the table: "calendar_accounts" */
  deleteCalendarAccountsByPk?: Maybe<CalendarAccounts>;
  /** delete data from the table: "calendar_auth_provider" */
  deleteCalendarAuthProvider?: Maybe<CalendarAuthProviderMutationResponse>;
  /** delete single row from the table: "calendar_auth_provider" */
  deleteCalendarAuthProviderByPk?: Maybe<CalendarAuthProvider>;
  /** delete data from the table: "calendar_event_mappings" */
  deleteCalendarEventMappings?: Maybe<CalendarEventMappingsMutationResponse>;
  /** delete single row from the table: "calendar_event_mappings" */
  deleteCalendarEventMappingsByPk?: Maybe<CalendarEventMappings>;
  /** delete data from the table: "calendar_preferences" */
  deleteCalendarPreferences?: Maybe<CalendarPreferencesMutationResponse>;
  /** delete single row from the table: "calendar_preferences" */
  deleteCalendarPreferencesByPk?: Maybe<CalendarPreferences>;
  /** delete data from the table: "cities" */
  deleteCities?: Maybe<CitiesMutationResponse>;
  /** delete single row from the table: "cities" */
  deleteCitiesByPk?: Maybe<Cities>;
  /** delete data from the table: "coach_availability" */
  deleteCoachAvailability?: Maybe<CoachAvailabilityMutationResponse>;
  /** delete single row from the table: "coach_availability" */
  deleteCoachAvailabilityByPk?: Maybe<CoachAvailability>;
  /** delete data from the table: "coach_availability_statuses" */
  deleteCoachAvailabilityStatuses?: Maybe<CoachAvailabilityStatusesMutationResponse>;
  /** delete single row from the table: "coach_availability_statuses" */
  deleteCoachAvailabilityStatusesByPk?: Maybe<CoachAvailabilityStatuses>;
  /** delete data from the table: "coach_booking_requests" */
  deleteCoachBookingRequests?: Maybe<CoachBookingRequestsMutationResponse>;
  /** delete single row from the table: "coach_booking_requests" */
  deleteCoachBookingRequestsByPk?: Maybe<CoachBookingRequests>;
  /** delete data from the table: "coach_external_review_sources" */
  deleteCoachExternalReviewSources?: Maybe<CoachExternalReviewSourcesMutationResponse>;
  /** delete single row from the table: "coach_external_review_sources" */
  deleteCoachExternalReviewSourcesByPk?: Maybe<CoachExternalReviewSources>;
  /** delete data from the table: "coach_faqs" */
  deleteCoachFaqs?: Maybe<CoachFaqsMutationResponse>;
  /** delete single row from the table: "coach_faqs" */
  deleteCoachFaqsByPk?: Maybe<CoachFaqs>;
  /** delete data from the table: "coach_lesson_age_groups" */
  deleteCoachLessonAgeGroups?: Maybe<CoachLessonAgeGroupsMutationResponse>;
  /** delete single row from the table: "coach_lesson_age_groups" */
  deleteCoachLessonAgeGroupsByPk?: Maybe<CoachLessonAgeGroups>;
  /** delete data from the table: "coach_lesson_skill_levels" */
  deleteCoachLessonSkillLevels?: Maybe<CoachLessonSkillLevelsMutationResponse>;
  /** delete single row from the table: "coach_lesson_skill_levels" */
  deleteCoachLessonSkillLevelsByPk?: Maybe<CoachLessonSkillLevels>;
  /** delete data from the table: "coach_qualification_groups" */
  deleteCoachQualificationGroups?: Maybe<CoachQualificationGroupsMutationResponse>;
  /** delete single row from the table: "coach_qualification_groups" */
  deleteCoachQualificationGroupsByPk?: Maybe<CoachQualificationGroups>;
  /** delete data from the table: "coach_qualification_statuses" */
  deleteCoachQualificationStatuses?: Maybe<CoachQualificationStatusesMutationResponse>;
  /** delete single row from the table: "coach_qualification_statuses" */
  deleteCoachQualificationStatusesByPk?: Maybe<CoachQualificationStatuses>;
  /** delete data from the table: "coach_qualifications" */
  deleteCoachQualifications?: Maybe<CoachQualificationsMutationResponse>;
  /** delete single row from the table: "coach_qualifications" */
  deleteCoachQualificationsByPk?: Maybe<CoachQualifications>;
  /** delete data from the table: "coach_review_types" */
  deleteCoachReviewTypes?: Maybe<CoachReviewTypesMutationResponse>;
  /** delete single row from the table: "coach_review_types" */
  deleteCoachReviewTypesByPk?: Maybe<CoachReviewTypes>;
  /** delete data from the table: "coach_sport_statuses" */
  deleteCoachSportStatuses?: Maybe<CoachSportStatusesMutationResponse>;
  /** delete single row from the table: "coach_sport_statuses" */
  deleteCoachSportStatusesByPk?: Maybe<CoachSportStatuses>;
  /** delete data from the table: "coach_sports" */
  deleteCoachSports?: Maybe<CoachSportsMutationResponse>;
  /** delete single row from the table: "coach_sports" */
  deleteCoachSportsByPk?: Maybe<CoachSports>;
  /** delete data from the table: "coach_starter_profiles" */
  deleteCoachStarterProfiles?: Maybe<CoachStarterProfilesMutationResponse>;
  /** delete single row from the table: "coach_starter_profiles" */
  deleteCoachStarterProfilesByPk?: Maybe<CoachStarterProfiles>;
  /** delete data from the table: "coach_status" */
  deleteCoachStatus?: Maybe<CoachStatusMutationResponse>;
  /** delete single row from the table: "coach_status" */
  deleteCoachStatusByPk?: Maybe<CoachStatus>;
  /** delete data from the table: "coach_tips" */
  deleteCoachTips?: Maybe<CoachTipsMutationResponse>;
  /** delete single row from the table: "coach_tips" */
  deleteCoachTipsByPk?: Maybe<CoachTips>;
  /** delete data from the table: "comment_vote" */
  deleteCommentVote?: Maybe<CommentVoteMutationResponse>;
  /** delete single row from the table: "comment_vote" */
  deleteCommentVoteByPk?: Maybe<CommentVote>;
  /** delete data from the table: "communication_preference_statuses" */
  deleteCommunicationPreferenceStatuses?: Maybe<CommunicationPreferenceStatusesMutationResponse>;
  /** delete single row from the table: "communication_preference_statuses" */
  deleteCommunicationPreferenceStatusesByPk?: Maybe<CommunicationPreferenceStatuses>;
  /** delete data from the table: "competition_formats" */
  deleteCompetitionFormats?: Maybe<CompetitionFormatsMutationResponse>;
  /** delete single row from the table: "competition_formats" */
  deleteCompetitionFormatsByPk?: Maybe<CompetitionFormats>;
  /** delete data from the table: "competition_gender" */
  deleteCompetitionGender?: Maybe<CompetitionGenderMutationResponse>;
  /** delete single row from the table: "competition_gender" */
  deleteCompetitionGenderByPk?: Maybe<CompetitionGender>;
  /** delete data from the table: "content_reports" */
  deleteContentReports?: Maybe<ContentReportsMutationResponse>;
  /** delete single row from the table: "content_reports" */
  deleteContentReportsByPk?: Maybe<ContentReports>;
  /** delete data from the table: "conversation_participants" */
  deleteConversationParticipants?: Maybe<ConversationParticipantsMutationResponse>;
  /** delete single row from the table: "conversation_participants" */
  deleteConversationParticipantsByPk?: Maybe<ConversationParticipants>;
  /** delete data from the table: "conversation_types" */
  deleteConversationTypes?: Maybe<ConversationTypesMutationResponse>;
  /** delete single row from the table: "conversation_types" */
  deleteConversationTypesByPk?: Maybe<ConversationTypes>;
  /** delete data from the table: "conversations" */
  deleteConversations?: Maybe<ConversationsMutationResponse>;
  /** delete single row from the table: "conversations" */
  deleteConversationsByPk?: Maybe<Conversations>;
  /** delete data from the table: "countries" */
  deleteCountries?: Maybe<CountriesMutationResponse>;
  /** delete single row from the table: "countries" */
  deleteCountriesByPk?: Maybe<Countries>;
  /** delete data from the table: "country_subdivisions" */
  deleteCountrySubdivisions?: Maybe<CountrySubdivisionsMutationResponse>;
  /** delete single row from the table: "country_subdivisions" */
  deleteCountrySubdivisionsByPk?: Maybe<CountrySubdivisions>;
  /** delete data from the table: "court_surfaces" */
  deleteCourtSurfaces?: Maybe<CourtSurfacesMutationResponse>;
  /** delete single row from the table: "court_surfaces" */
  deleteCourtSurfacesByPk?: Maybe<CourtSurfaces>;
  /** delete data from the table: "day_of_week" */
  deleteDayOfWeek?: Maybe<DayOfWeekMutationResponse>;
  /** delete single row from the table: "day_of_week" */
  deleteDayOfWeekByPk?: Maybe<DayOfWeek>;
  /** delete data from the table: "engagement_analytics" */
  deleteEngagementAnalytics?: Maybe<EngagementAnalyticsMutationResponse>;
  /** delete single row from the table: "engagement_analytics" */
  deleteEngagementAnalyticsByPk?: Maybe<EngagementAnalytics>;
  /** delete data from the table: "engagement_entity_types" */
  deleteEngagementEntityTypes?: Maybe<EngagementEntityTypesMutationResponse>;
  /** delete single row from the table: "engagement_entity_types" */
  deleteEngagementEntityTypesByPk?: Maybe<EngagementEntityTypes>;
  /** delete data from the table: "engagement_event_types" */
  deleteEngagementEventTypes?: Maybe<EngagementEventTypesMutationResponse>;
  /** delete single row from the table: "engagement_event_types" */
  deleteEngagementEventTypesByPk?: Maybe<EngagementEventTypes>;
  /** delete data from the table: "engagement_sources" */
  deleteEngagementSources?: Maybe<EngagementSourcesMutationResponse>;
  /** delete single row from the table: "engagement_sources" */
  deleteEngagementSourcesByPk?: Maybe<EngagementSources>;
  /** delete data from the table: "equipment_availabilities" */
  deleteEquipmentAvailabilities?: Maybe<EquipmentAvailabilitiesMutationResponse>;
  /** delete single row from the table: "equipment_availabilities" */
  deleteEquipmentAvailabilitiesByPk?: Maybe<EquipmentAvailabilities>;
  /** delete data from the table: "event_accepted_play_requests" */
  deleteEventAcceptedPlayRequests?: Maybe<EventAcceptedPlayRequestsMutationResponse>;
  /** delete data from the table: "event_age_groups" */
  deleteEventAgeGroups?: Maybe<EventAgeGroupsMutationResponse>;
  /** delete single row from the table: "event_age_groups" */
  deleteEventAgeGroupsByPk?: Maybe<EventAgeGroups>;
  /** delete data from the table: "event_collections" */
  deleteEventCollections?: Maybe<EventCollectionsMutationResponse>;
  /** delete single row from the table: "event_collections" */
  deleteEventCollectionsByPk?: Maybe<EventCollections>;
  /** delete data from the table: "event_competitiveness" */
  deleteEventCompetitiveness?: Maybe<EventCompetitivenessMutationResponse>;
  /** delete single row from the table: "event_competitiveness" */
  deleteEventCompetitivenessByPk?: Maybe<EventCompetitiveness>;
  /** delete data from the table: "event_contact_details" */
  deleteEventContactDetails?: Maybe<EventContactDetailsMutationResponse>;
  /** delete single row from the table: "event_contact_details" */
  deleteEventContactDetailsByPk?: Maybe<EventContactDetails>;
  /** delete data from the table: "event_coupon_groups" */
  deleteEventCouponGroups?: Maybe<EventCouponGroupsMutationResponse>;
  /** delete single row from the table: "event_coupon_groups" */
  deleteEventCouponGroupsByPk?: Maybe<EventCouponGroups>;
  /** delete data from the table: "event_coupon_redemptions" */
  deleteEventCouponRedemptions?: Maybe<EventCouponRedemptionsMutationResponse>;
  /** delete single row from the table: "event_coupon_redemptions" */
  deleteEventCouponRedemptionsByPk?: Maybe<EventCouponRedemptions>;
  /** delete data from the table: "event_coupon_source" */
  deleteEventCouponSource?: Maybe<EventCouponSourceMutationResponse>;
  /** delete single row from the table: "event_coupon_source" */
  deleteEventCouponSourceByPk?: Maybe<EventCouponSource>;
  /** delete data from the table: "event_coupon_type" */
  deleteEventCouponType?: Maybe<EventCouponTypeMutationResponse>;
  /** delete single row from the table: "event_coupon_type" */
  deleteEventCouponTypeByPk?: Maybe<EventCouponType>;
  /** delete data from the table: "event_coupons" */
  deleteEventCoupons?: Maybe<EventCouponsMutationResponse>;
  /** delete single row from the table: "event_coupons" */
  deleteEventCouponsByPk?: Maybe<EventCoupons>;
  /** delete data from the table: "event_court_statuses" */
  deleteEventCourtStatuses?: Maybe<EventCourtStatusesMutationResponse>;
  /** delete single row from the table: "event_court_statuses" */
  deleteEventCourtStatusesByPk?: Maybe<EventCourtStatuses>;
  /** delete data from the table: "event_courts" */
  deleteEventCourts?: Maybe<EventCourtsMutationResponse>;
  /** delete single row from the table: "event_courts" */
  deleteEventCourtsByPk?: Maybe<EventCourts>;
  /** delete data from the table: "event_faqs" */
  deleteEventFaqs?: Maybe<EventFaqsMutationResponse>;
  /** delete single row from the table: "event_faqs" */
  deleteEventFaqsByPk?: Maybe<EventFaqs>;
  /** delete data from the table: "event_game_scores" */
  deleteEventGameScores?: Maybe<EventGameScoresMutationResponse>;
  /** delete single row from the table: "event_game_scores" */
  deleteEventGameScoresByPk?: Maybe<EventGameScores>;
  /** delete data from the table: "event_group_formats" */
  deleteEventGroupFormats?: Maybe<EventGroupFormatsMutationResponse>;
  /** delete single row from the table: "event_group_formats" */
  deleteEventGroupFormatsByPk?: Maybe<EventGroupFormats>;
  /** delete data from the table: "event_group_merges" */
  deleteEventGroupMerges?: Maybe<EventGroupMergesMutationResponse>;
  /** delete single row from the table: "event_group_merges" */
  deleteEventGroupMergesByPk?: Maybe<EventGroupMerges>;
  /** delete data from the table: "event_group_pools" */
  deleteEventGroupPools?: Maybe<EventGroupPoolsMutationResponse>;
  /** delete single row from the table: "event_group_pools" */
  deleteEventGroupPoolsByPk?: Maybe<EventGroupPools>;
  /** delete data from the table: "event_group_rating_scales" */
  deleteEventGroupRatingScales?: Maybe<EventGroupRatingScalesMutationResponse>;
  /** delete single row from the table: "event_group_rating_scales" */
  deleteEventGroupRatingScalesByPk?: Maybe<EventGroupRatingScales>;
  /** delete data from the table: "event_group_registration_statuses" */
  deleteEventGroupRegistrationStatuses?: Maybe<EventGroupRegistrationStatusesMutationResponse>;
  /** delete single row from the table: "event_group_registration_statuses" */
  deleteEventGroupRegistrationStatusesByPk?: Maybe<EventGroupRegistrationStatuses>;
  /** delete data from the table: "event_group_registrations" */
  deleteEventGroupRegistrations?: Maybe<EventGroupRegistrationsMutationResponse>;
  /** delete single row from the table: "event_group_registrations" */
  deleteEventGroupRegistrationsByPk?: Maybe<EventGroupRegistrations>;
  /** delete data from the table: "event_group_sequence_seeding" */
  deleteEventGroupSequenceSeeding?: Maybe<EventGroupSequenceSeedingMutationResponse>;
  /** delete single row from the table: "event_group_sequence_seeding" */
  deleteEventGroupSequenceSeedingByPk?: Maybe<EventGroupSequenceSeeding>;
  /** delete data from the table: "event_group_sequences" */
  deleteEventGroupSequences?: Maybe<EventGroupSequencesMutationResponse>;
  /** delete single row from the table: "event_group_sequences" */
  deleteEventGroupSequencesByPk?: Maybe<EventGroupSequences>;
  /** delete data from the table: "event_group_time_slots" */
  deleteEventGroupTimeSlots?: Maybe<EventGroupTimeSlotsMutationResponse>;
  /** delete single row from the table: "event_group_time_slots" */
  deleteEventGroupTimeSlotsByPk?: Maybe<EventGroupTimeSlots>;
  /** delete data from the table: "event_groups" */
  deleteEventGroups?: Maybe<EventGroupsMutationResponse>;
  /** delete single row from the table: "event_groups" */
  deleteEventGroupsByPk?: Maybe<EventGroups>;
  /** delete data from the table: "event_invitation_statuses" */
  deleteEventInvitationStatuses?: Maybe<EventInvitationStatusesMutationResponse>;
  /** delete single row from the table: "event_invitation_statuses" */
  deleteEventInvitationStatusesByPk?: Maybe<EventInvitationStatuses>;
  /** delete data from the table: "event_invitation_types" */
  deleteEventInvitationTypes?: Maybe<EventInvitationTypesMutationResponse>;
  /** delete single row from the table: "event_invitation_types" */
  deleteEventInvitationTypesByPk?: Maybe<EventInvitationTypes>;
  /** delete data from the table: "event_invitations" */
  deleteEventInvitations?: Maybe<EventInvitationsMutationResponse>;
  /** delete single row from the table: "event_invitations" */
  deleteEventInvitationsByPk?: Maybe<EventInvitations>;
  /** delete data from the table: "event_listing_fees" */
  deleteEventListingFees?: Maybe<EventListingFeesMutationResponse>;
  /** delete single row from the table: "event_listing_fees" */
  deleteEventListingFeesByPk?: Maybe<EventListingFees>;
  /** delete data from the table: "event_match_games" */
  deleteEventMatchGames?: Maybe<EventMatchGamesMutationResponse>;
  /** delete single row from the table: "event_match_games" */
  deleteEventMatchGamesByPk?: Maybe<EventMatchGames>;
  /** delete data from the table: "event_matches" */
  deleteEventMatches?: Maybe<EventMatchesMutationResponse>;
  /** delete single row from the table: "event_matches" */
  deleteEventMatchesByPk?: Maybe<EventMatches>;
  /** delete data from the table: "event_matches_teams" */
  deleteEventMatchesTeams?: Maybe<EventMatchesTeamsMutationResponse>;
  /** delete single row from the table: "event_matches_teams" */
  deleteEventMatchesTeamsByPk?: Maybe<EventMatchesTeams>;
  /** delete data from the table: "event_organizer_account_types" */
  deleteEventOrganizerAccountTypes?: Maybe<EventOrganizerAccountTypesMutationResponse>;
  /** delete single row from the table: "event_organizer_account_types" */
  deleteEventOrganizerAccountTypesByPk?: Maybe<EventOrganizerAccountTypes>;
  /** delete data from the table: "event_player_invite_statuses" */
  deleteEventPlayerInviteStatuses?: Maybe<EventPlayerInviteStatusesMutationResponse>;
  /** delete single row from the table: "event_player_invite_statuses" */
  deleteEventPlayerInviteStatusesByPk?: Maybe<EventPlayerInviteStatuses>;
  /** delete data from the table: "event_player_invites" */
  deleteEventPlayerInvites?: Maybe<EventPlayerInvitesMutationResponse>;
  /** delete single row from the table: "event_player_invites" */
  deleteEventPlayerInvitesByPk?: Maybe<EventPlayerInvites>;
  /** delete data from the table: "event_pool_rounds" */
  deleteEventPoolRounds?: Maybe<EventPoolRoundsMutationResponse>;
  /** delete single row from the table: "event_pool_rounds" */
  deleteEventPoolRoundsByPk?: Maybe<EventPoolRounds>;
  /** delete data from the table: "event_pools_teams" */
  deleteEventPoolsTeams?: Maybe<EventPoolsTeamsMutationResponse>;
  /** delete single row from the table: "event_pools_teams" */
  deleteEventPoolsTeamsByPk?: Maybe<EventPoolsTeams>;
  /** delete data from the table: "event_privacy" */
  deleteEventPrivacy?: Maybe<EventPrivacyMutationResponse>;
  /** delete single row from the table: "event_privacy" */
  deleteEventPrivacyByPk?: Maybe<EventPrivacy>;
  /** delete data from the table: "event_registration_details" */
  deleteEventRegistrationDetails?: Maybe<EventRegistrationDetailsMutationResponse>;
  /** delete single row from the table: "event_registration_details" */
  deleteEventRegistrationDetailsByPk?: Maybe<EventRegistrationDetails>;
  /** delete data from the table: "event_registrations" */
  deleteEventRegistrations?: Maybe<EventRegistrationsMutationResponse>;
  /** delete single row from the table: "event_registrations" */
  deleteEventRegistrationsByPk?: Maybe<EventRegistrations>;
  /** delete data from the table: "event_sequence_complete_reasons" */
  deleteEventSequenceCompleteReasons?: Maybe<EventSequenceCompleteReasonsMutationResponse>;
  /** delete single row from the table: "event_sequence_complete_reasons" */
  deleteEventSequenceCompleteReasonsByPk?: Maybe<EventSequenceCompleteReasons>;
  /** delete data from the table: "event_skill_levels" */
  deleteEventSkillLevels?: Maybe<EventSkillLevelsMutationResponse>;
  /** delete single row from the table: "event_skill_levels" */
  deleteEventSkillLevelsByPk?: Maybe<EventSkillLevels>;
  /** delete data from the table: "event_sponsors" */
  deleteEventSponsors?: Maybe<EventSponsorsMutationResponse>;
  /** delete single row from the table: "event_sponsors" */
  deleteEventSponsorsByPk?: Maybe<EventSponsors>;
  /** delete data from the table: "event_statuses" */
  deleteEventStatuses?: Maybe<EventStatusesMutationResponse>;
  /** delete single row from the table: "event_statuses" */
  deleteEventStatusesByPk?: Maybe<EventStatuses>;
  /** delete data from the table: "event_team_member_statuses" */
  deleteEventTeamMemberStatuses?: Maybe<EventTeamMemberStatusesMutationResponse>;
  /** delete single row from the table: "event_team_member_statuses" */
  deleteEventTeamMemberStatusesByPk?: Maybe<EventTeamMemberStatuses>;
  /** delete data from the table: "event_team_members" */
  deleteEventTeamMembers?: Maybe<EventTeamMembersMutationResponse>;
  /** delete single row from the table: "event_team_members" */
  deleteEventTeamMembersByPk?: Maybe<EventTeamMembers>;
  /** delete data from the table: "event_team_statuses" */
  deleteEventTeamStatuses?: Maybe<EventTeamStatusesMutationResponse>;
  /** delete single row from the table: "event_team_statuses" */
  deleteEventTeamStatusesByPk?: Maybe<EventTeamStatuses>;
  /** delete data from the table: "event_teams" */
  deleteEventTeams?: Maybe<EventTeamsMutationResponse>;
  /** delete single row from the table: "event_teams" */
  deleteEventTeamsByPk?: Maybe<EventTeams>;
  /** delete data from the table: "event_transaction_item_types" */
  deleteEventTransactionItemTypes?: Maybe<EventTransactionItemTypesMutationResponse>;
  /** delete single row from the table: "event_transaction_item_types" */
  deleteEventTransactionItemTypesByPk?: Maybe<EventTransactionItemTypes>;
  /** delete data from the table: "event_transaction_items" */
  deleteEventTransactionItems?: Maybe<EventTransactionItemsMutationResponse>;
  /** delete single row from the table: "event_transaction_items" */
  deleteEventTransactionItemsByPk?: Maybe<EventTransactionItems>;
  /** delete data from the table: "event_transactions" */
  deleteEventTransactions?: Maybe<EventTransactionsMutationResponse>;
  /** delete single row from the table: "event_transactions" */
  deleteEventTransactionsByPk?: Maybe<EventTransactions>;
  /** delete data from the table: "event_types" */
  deleteEventTypes?: Maybe<EventTypesMutationResponse>;
  /** delete single row from the table: "event_types" */
  deleteEventTypesByPk?: Maybe<EventTypes>;
  /** delete data from the table: "events" */
  deleteEvents?: Maybe<EventsMutationResponse>;
  /** delete single row from the table: "events" */
  deleteEventsByPk?: Maybe<Events>;
  /** delete data from the table: "feedback_sentiment" */
  deleteFeedbackSentiment?: Maybe<FeedbackSentimentMutationResponse>;
  /** delete single row from the table: "feedback_sentiment" */
  deleteFeedbackSentimentByPk?: Maybe<FeedbackSentiment>;
  /** delete data from the table: "file_category" */
  deleteFileCategory?: Maybe<FileCategoryMutationResponse>;
  /** delete single row from the table: "file_category" */
  deleteFileCategoryByPk?: Maybe<FileCategory>;
  /** delete data from the table: "file_format" */
  deleteFileFormat?: Maybe<FileFormatMutationResponse>;
  /** delete single row from the table: "file_format" */
  deleteFileFormatByPk?: Maybe<FileFormat>;
  /** delete data from the table: "follow_statuses" */
  deleteFollowStatuses?: Maybe<FollowStatusesMutationResponse>;
  /** delete single row from the table: "follow_statuses" */
  deleteFollowStatusesByPk?: Maybe<FollowStatuses>;
  /** delete data from the table: "game_net_statuses" */
  deleteGameNetStatuses?: Maybe<GameNetStatusesMutationResponse>;
  /** delete single row from the table: "game_net_statuses" */
  deleteGameNetStatusesByPk?: Maybe<GameNetStatuses>;
  /** delete data from the table: "gender" */
  deleteGender?: Maybe<GenderMutationResponse>;
  /** delete single row from the table: "gender" */
  deleteGenderByPk?: Maybe<Gender>;
  /** delete data from the table: "group_comment_votes" */
  deleteGroupCommentVotes?: Maybe<GroupCommentVotesMutationResponse>;
  /** delete single row from the table: "group_comment_votes" */
  deleteGroupCommentVotesByPk?: Maybe<GroupCommentVotes>;
  /** delete data from the table: "group_members" */
  deleteGroupMembers?: Maybe<GroupMembersMutationResponse>;
  /** delete single row from the table: "group_members" */
  deleteGroupMembersByPk?: Maybe<GroupMembers>;
  /** delete data from the table: "group_thread_comment_files" */
  deleteGroupThreadCommentFiles?: Maybe<GroupThreadCommentFilesMutationResponse>;
  /** delete single row from the table: "group_thread_comment_files" */
  deleteGroupThreadCommentFilesByPk?: Maybe<GroupThreadCommentFiles>;
  /** delete data from the table: "group_thread_comments" */
  deleteGroupThreadComments?: Maybe<GroupThreadCommentsMutationResponse>;
  /** delete single row from the table: "group_thread_comments" */
  deleteGroupThreadCommentsByPk?: Maybe<GroupThreadComments>;
  /** delete data from the table: "group_threads" */
  deleteGroupThreads?: Maybe<GroupThreadsMutationResponse>;
  /** delete single row from the table: "group_threads" */
  deleteGroupThreadsByPk?: Maybe<GroupThreads>;
  /** delete data from the table: "group_types" */
  deleteGroupTypes?: Maybe<GroupTypesMutationResponse>;
  /** delete single row from the table: "group_types" */
  deleteGroupTypesByPk?: Maybe<GroupTypes>;
  /** delete data from the table: "group_venues" */
  deleteGroupVenues?: Maybe<GroupVenuesMutationResponse>;
  /** delete single row from the table: "group_venues" */
  deleteGroupVenuesByPk?: Maybe<GroupVenues>;
  /** delete data from the table: "groups" */
  deleteGroups?: Maybe<GroupsMutationResponse>;
  /** delete single row from the table: "groups" */
  deleteGroupsByPk?: Maybe<Groups>;
  /** delete data from the table: "groups_play_sessions" */
  deleteGroupsPlaySessions?: Maybe<GroupsPlaySessionsMutationResponse>;
  /** delete single row from the table: "groups_play_sessions" */
  deleteGroupsPlaySessionsByPk?: Maybe<GroupsPlaySessions>;
  /** delete data from the table: "identity_verification_providers" */
  deleteIdentityVerificationProviders?: Maybe<IdentityVerificationProvidersMutationResponse>;
  /** delete single row from the table: "identity_verification_providers" */
  deleteIdentityVerificationProvidersByPk?: Maybe<IdentityVerificationProviders>;
  /** delete data from the table: "identity_verification_statuses" */
  deleteIdentityVerificationStatuses?: Maybe<IdentityVerificationStatusesMutationResponse>;
  /** delete single row from the table: "identity_verification_statuses" */
  deleteIdentityVerificationStatusesByPk?: Maybe<IdentityVerificationStatuses>;
  /** delete data from the table: "invoices" */
  deleteInvoices?: Maybe<InvoicesMutationResponse>;
  /** delete single row from the table: "invoices" */
  deleteInvoicesByPk?: Maybe<Invoices>;
  /** delete data from the table: "learning_program_enrollment_schedule_media_watched" */
  deleteLearningProgramEnrollmentScheduleMediaWatched?: Maybe<LearningProgramEnrollmentScheduleMediaWatchedMutationResponse>;
  /** delete single row from the table: "learning_program_enrollment_schedule_media_watched" */
  deleteLearningProgramEnrollmentScheduleMediaWatchedByPk?: Maybe<LearningProgramEnrollmentScheduleMediaWatched>;
  /** delete data from the table: "learning_program_enrollment_schedule_progress" */
  deleteLearningProgramEnrollmentScheduleProgress?: Maybe<LearningProgramEnrollmentScheduleProgressMutationResponse>;
  /** delete single row from the table: "learning_program_enrollment_schedule_progress" */
  deleteLearningProgramEnrollmentScheduleProgressByPk?: Maybe<LearningProgramEnrollmentScheduleProgress>;
  /** delete data from the table: "learning_program_enrollments" */
  deleteLearningProgramEnrollments?: Maybe<LearningProgramEnrollmentsMutationResponse>;
  /** delete single row from the table: "learning_program_enrollments" */
  deleteLearningProgramEnrollmentsByPk?: Maybe<LearningProgramEnrollments>;
  /** delete data from the table: "learning_program_media" */
  deleteLearningProgramMedia?: Maybe<LearningProgramMediaMutationResponse>;
  /** delete single row from the table: "learning_program_media" */
  deleteLearningProgramMediaByPk?: Maybe<LearningProgramMedia>;
  /** delete data from the table: "learning_program_media_categories" */
  deleteLearningProgramMediaCategories?: Maybe<LearningProgramMediaCategoriesMutationResponse>;
  /** delete single row from the table: "learning_program_media_categories" */
  deleteLearningProgramMediaCategoriesByPk?: Maybe<LearningProgramMediaCategories>;
  /** delete data from the table: "learning_program_schedule_media" */
  deleteLearningProgramScheduleMedia?: Maybe<LearningProgramScheduleMediaMutationResponse>;
  /** delete single row from the table: "learning_program_schedule_media" */
  deleteLearningProgramScheduleMediaByPk?: Maybe<LearningProgramScheduleMedia>;
  /** delete data from the table: "learning_program_schedule_units" */
  deleteLearningProgramScheduleUnits?: Maybe<LearningProgramScheduleUnitsMutationResponse>;
  /** delete single row from the table: "learning_program_schedule_units" */
  deleteLearningProgramScheduleUnitsByPk?: Maybe<LearningProgramScheduleUnits>;
  /** delete data from the table: "learning_program_schedule_video_submissions" */
  deleteLearningProgramScheduleVideoSubmissions?: Maybe<LearningProgramScheduleVideoSubmissionsMutationResponse>;
  /** delete single row from the table: "learning_program_schedule_video_submissions" */
  deleteLearningProgramScheduleVideoSubmissionsByPk?: Maybe<LearningProgramScheduleVideoSubmissions>;
  /** delete data from the table: "learning_program_schedules" */
  deleteLearningProgramSchedules?: Maybe<LearningProgramSchedulesMutationResponse>;
  /** delete single row from the table: "learning_program_schedules" */
  deleteLearningProgramSchedulesByPk?: Maybe<LearningProgramSchedules>;
  /** delete data from the table: "learning_program_skill_level_values" */
  deleteLearningProgramSkillLevelValues?: Maybe<LearningProgramSkillLevelValuesMutationResponse>;
  /** delete single row from the table: "learning_program_skill_level_values" */
  deleteLearningProgramSkillLevelValuesByPk?: Maybe<LearningProgramSkillLevelValues>;
  /** delete data from the table: "learning_program_skills" */
  deleteLearningProgramSkills?: Maybe<LearningProgramSkillsMutationResponse>;
  /** delete single row from the table: "learning_program_skills" */
  deleteLearningProgramSkillsByPk?: Maybe<LearningProgramSkills>;
  /** delete data from the table: "learning_programs" */
  deleteLearningPrograms?: Maybe<LearningProgramsMutationResponse>;
  /** delete single row from the table: "learning_programs" */
  deleteLearningProgramsByPk?: Maybe<LearningPrograms>;
  /** delete data from the table: "lesson_age_groups" */
  deleteLessonAgeGroups?: Maybe<LessonAgeGroupsMutationResponse>;
  /** delete single row from the table: "lesson_age_groups" */
  deleteLessonAgeGroupsByPk?: Maybe<LessonAgeGroups>;
  /** delete data from the table: "lesson_collections" */
  deleteLessonCollections?: Maybe<LessonCollectionsMutationResponse>;
  /** delete single row from the table: "lesson_collections" */
  deleteLessonCollectionsByPk?: Maybe<LessonCollections>;
  /** delete data from the table: "lesson_equipment" */
  deleteLessonEquipment?: Maybe<LessonEquipmentMutationResponse>;
  /** delete single row from the table: "lesson_equipment" */
  deleteLessonEquipmentByPk?: Maybe<LessonEquipment>;
  /** delete data from the table: "lesson_equipment_options" */
  deleteLessonEquipmentOptions?: Maybe<LessonEquipmentOptionsMutationResponse>;
  /** delete single row from the table: "lesson_equipment_options" */
  deleteLessonEquipmentOptionsByPk?: Maybe<LessonEquipmentOptions>;
  /** delete data from the table: "lesson_order_items" */
  deleteLessonOrderItems?: Maybe<LessonOrderItemsMutationResponse>;
  /** delete single row from the table: "lesson_order_items" */
  deleteLessonOrderItemsByPk?: Maybe<LessonOrderItems>;
  /** delete data from the table: "lesson_orders" */
  deleteLessonOrders?: Maybe<LessonOrdersMutationResponse>;
  /** delete single row from the table: "lesson_orders" */
  deleteLessonOrdersByPk?: Maybe<LessonOrders>;
  /** delete data from the table: "lesson_participant_statuses" */
  deleteLessonParticipantStatuses?: Maybe<LessonParticipantStatusesMutationResponse>;
  /** delete single row from the table: "lesson_participant_statuses" */
  deleteLessonParticipantStatusesByPk?: Maybe<LessonParticipantStatuses>;
  /** delete data from the table: "lesson_participants" */
  deleteLessonParticipants?: Maybe<LessonParticipantsMutationResponse>;
  /** delete single row from the table: "lesson_participants" */
  deleteLessonParticipantsByPk?: Maybe<LessonParticipants>;
  /** delete data from the table: "lesson_player_skill_assessment_categories" */
  deleteLessonPlayerSkillAssessmentCategories?: Maybe<LessonPlayerSkillAssessmentCategoriesMutationResponse>;
  /** delete single row from the table: "lesson_player_skill_assessment_categories" */
  deleteLessonPlayerSkillAssessmentCategoriesByPk?: Maybe<LessonPlayerSkillAssessmentCategories>;
  /** delete data from the table: "lesson_player_skill_assessments" */
  deleteLessonPlayerSkillAssessments?: Maybe<LessonPlayerSkillAssessmentsMutationResponse>;
  /** delete single row from the table: "lesson_player_skill_assessments" */
  deleteLessonPlayerSkillAssessmentsByPk?: Maybe<LessonPlayerSkillAssessments>;
  /** delete data from the table: "lesson_player_skill_assessments_skills" */
  deleteLessonPlayerSkillAssessmentsSkills?: Maybe<LessonPlayerSkillAssessmentsSkillsMutationResponse>;
  /** delete single row from the table: "lesson_player_skill_assessments_skills" */
  deleteLessonPlayerSkillAssessmentsSkillsByPk?: Maybe<LessonPlayerSkillAssessmentsSkills>;
  /** delete data from the table: "lesson_privacy" */
  deleteLessonPrivacy?: Maybe<LessonPrivacyMutationResponse>;
  /** delete single row from the table: "lesson_privacy" */
  deleteLessonPrivacyByPk?: Maybe<LessonPrivacy>;
  /** delete data from the table: "lesson_reflection_comment_types" */
  deleteLessonReflectionCommentTypes?: Maybe<LessonReflectionCommentTypesMutationResponse>;
  /** delete single row from the table: "lesson_reflection_comment_types" */
  deleteLessonReflectionCommentTypesByPk?: Maybe<LessonReflectionCommentTypes>;
  /** delete data from the table: "lesson_reflection_comments" */
  deleteLessonReflectionComments?: Maybe<LessonReflectionCommentsMutationResponse>;
  /** delete single row from the table: "lesson_reflection_comments" */
  deleteLessonReflectionCommentsByPk?: Maybe<LessonReflectionComments>;
  /** delete data from the table: "lesson_reflection_files" */
  deleteLessonReflectionFiles?: Maybe<LessonReflectionFilesMutationResponse>;
  /** delete single row from the table: "lesson_reflection_files" */
  deleteLessonReflectionFilesByPk?: Maybe<LessonReflectionFiles>;
  /** delete data from the table: "lesson_reflections" */
  deleteLessonReflections?: Maybe<LessonReflectionsMutationResponse>;
  /** delete single row from the table: "lesson_reflections" */
  deleteLessonReflectionsByPk?: Maybe<LessonReflections>;
  /** delete data from the table: "lesson_skill_categories" */
  deleteLessonSkillCategories?: Maybe<LessonSkillCategoriesMutationResponse>;
  /** delete single row from the table: "lesson_skill_categories" */
  deleteLessonSkillCategoriesByPk?: Maybe<LessonSkillCategories>;
  /** delete data from the table: "lesson_skill_display_names" */
  deleteLessonSkillDisplayNames?: Maybe<LessonSkillDisplayNamesMutationResponse>;
  /** delete single row from the table: "lesson_skill_display_names" */
  deleteLessonSkillDisplayNamesByPk?: Maybe<LessonSkillDisplayNames>;
  /** delete data from the table: "lesson_skill_levels" */
  deleteLessonSkillLevels?: Maybe<LessonSkillLevelsMutationResponse>;
  /** delete single row from the table: "lesson_skill_levels" */
  deleteLessonSkillLevelsByPk?: Maybe<LessonSkillLevels>;
  /** delete data from the table: "lesson_skill_mappings" */
  deleteLessonSkillMappings?: Maybe<LessonSkillMappingsMutationResponse>;
  /** delete single row from the table: "lesson_skill_mappings" */
  deleteLessonSkillMappingsByPk?: Maybe<LessonSkillMappings>;
  /** delete data from the table: "lesson_skills" */
  deleteLessonSkills?: Maybe<LessonSkillsMutationResponse>;
  /** delete single row from the table: "lesson_skills" */
  deleteLessonSkillsByPk?: Maybe<LessonSkills>;
  /** delete data from the table: "lesson_statuses" */
  deleteLessonStatuses?: Maybe<LessonStatusesMutationResponse>;
  /** delete single row from the table: "lesson_statuses" */
  deleteLessonStatusesByPk?: Maybe<LessonStatuses>;
  /** delete data from the table: "lesson_template_skill_levels" */
  deleteLessonTemplateSkillLevels?: Maybe<LessonTemplateSkillLevelsMutationResponse>;
  /** delete single row from the table: "lesson_template_skill_levels" */
  deleteLessonTemplateSkillLevelsByPk?: Maybe<LessonTemplateSkillLevels>;
  /** delete data from the table: "lesson_templates" */
  deleteLessonTemplates?: Maybe<LessonTemplatesMutationResponse>;
  /** delete single row from the table: "lesson_templates" */
  deleteLessonTemplatesByPk?: Maybe<LessonTemplates>;
  /** delete data from the table: "lesson_times" */
  deleteLessonTimes?: Maybe<LessonTimesMutationResponse>;
  /** delete single row from the table: "lesson_times" */
  deleteLessonTimesByPk?: Maybe<LessonTimes>;
  /** delete data from the table: "lesson_types" */
  deleteLessonTypes?: Maybe<LessonTypesMutationResponse>;
  /** delete single row from the table: "lesson_types" */
  deleteLessonTypesByPk?: Maybe<LessonTypes>;
  /** delete data from the table: "lesson_waitlist_statuses" */
  deleteLessonWaitlistStatuses?: Maybe<LessonWaitlistStatusesMutationResponse>;
  /** delete single row from the table: "lesson_waitlist_statuses" */
  deleteLessonWaitlistStatusesByPk?: Maybe<LessonWaitlistStatuses>;
  /** delete data from the table: "lesson_waitlists" */
  deleteLessonWaitlists?: Maybe<LessonWaitlistsMutationResponse>;
  /** delete single row from the table: "lesson_waitlists" */
  deleteLessonWaitlistsByPk?: Maybe<LessonWaitlists>;
  /** delete data from the table: "lessons" */
  deleteLessons?: Maybe<LessonsMutationResponse>;
  /** delete single row from the table: "lessons" */
  deleteLessonsByPk?: Maybe<Lessons>;
  /** delete data from the table: "match_selection_criteria" */
  deleteMatchSelectionCriteria?: Maybe<MatchSelectionCriteriaMutationResponse>;
  /** delete single row from the table: "match_selection_criteria" */
  deleteMatchSelectionCriteriaByPk?: Maybe<MatchSelectionCriteria>;
  /** delete data from the table: "messages" */
  deleteMessages?: Maybe<MessagesMutationResponse>;
  /** delete single row from the table: "messages" */
  deleteMessagesByPk?: Maybe<Messages>;
  /** delete data from the table: "neighborhoods" */
  deleteNeighborhoods?: Maybe<NeighborhoodsMutationResponse>;
  /** delete single row from the table: "neighborhoods" */
  deleteNeighborhoodsByPk?: Maybe<Neighborhoods>;
  /** delete data from the table: "notification_action_types" */
  deleteNotificationActionTypes?: Maybe<NotificationActionTypesMutationResponse>;
  /** delete single row from the table: "notification_action_types" */
  deleteNotificationActionTypesByPk?: Maybe<NotificationActionTypes>;
  /** delete data from the table: "notification_statuses" */
  deleteNotificationStatuses?: Maybe<NotificationStatusesMutationResponse>;
  /** delete single row from the table: "notification_statuses" */
  deleteNotificationStatusesByPk?: Maybe<NotificationStatuses>;
  /** delete data from the table: "order_statuses" */
  deleteOrderStatuses?: Maybe<OrderStatusesMutationResponse>;
  /** delete single row from the table: "order_statuses" */
  deleteOrderStatusesByPk?: Maybe<OrderStatuses>;
  /** delete data from the table: "padel_rating_scales" */
  deletePadelRatingScales?: Maybe<PadelRatingScalesMutationResponse>;
  /** delete single row from the table: "padel_rating_scales" */
  deletePadelRatingScalesByPk?: Maybe<PadelRatingScales>;
  /** delete data from the table: "participant_roles" */
  deleteParticipantRoles?: Maybe<ParticipantRolesMutationResponse>;
  /** delete single row from the table: "participant_roles" */
  deleteParticipantRolesByPk?: Maybe<ParticipantRoles>;
  /** delete data from the table: "partner_booking_attempt_events" */
  deletePartnerBookingAttemptEvents?: Maybe<PartnerBookingAttemptEventsMutationResponse>;
  /** delete single row from the table: "partner_booking_attempt_events" */
  deletePartnerBookingAttemptEventsByPk?: Maybe<PartnerBookingAttemptEvents>;
  /** delete data from the table: "partner_booking_attempt_statuses" */
  deletePartnerBookingAttemptStatuses?: Maybe<PartnerBookingAttemptStatusesMutationResponse>;
  /** delete single row from the table: "partner_booking_attempt_statuses" */
  deletePartnerBookingAttemptStatusesByPk?: Maybe<PartnerBookingAttemptStatuses>;
  /** delete data from the table: "partner_booking_attempts" */
  deletePartnerBookingAttempts?: Maybe<PartnerBookingAttemptsMutationResponse>;
  /** delete single row from the table: "partner_booking_attempts" */
  deletePartnerBookingAttemptsByPk?: Maybe<PartnerBookingAttempts>;
  /** delete data from the table: "partner_booking_engines" */
  deletePartnerBookingEngines?: Maybe<PartnerBookingEnginesMutationResponse>;
  /** delete single row from the table: "partner_booking_engines" */
  deletePartnerBookingEnginesByPk?: Maybe<PartnerBookingEngines>;
  /** delete data from the table: "partner_booking_event_sources" */
  deletePartnerBookingEventSources?: Maybe<PartnerBookingEventSourcesMutationResponse>;
  /** delete single row from the table: "partner_booking_event_sources" */
  deletePartnerBookingEventSourcesByPk?: Maybe<PartnerBookingEventSources>;
  /** delete data from the table: "partner_booking_holds" */
  deletePartnerBookingHolds?: Maybe<PartnerBookingHoldsMutationResponse>;
  /** delete single row from the table: "partner_booking_holds" */
  deletePartnerBookingHoldsByPk?: Maybe<PartnerBookingHolds>;
  /** delete data from the table: "partner_booking_order_statuses" */
  deletePartnerBookingOrderStatuses?: Maybe<PartnerBookingOrderStatusesMutationResponse>;
  /** delete single row from the table: "partner_booking_order_statuses" */
  deletePartnerBookingOrderStatusesByPk?: Maybe<PartnerBookingOrderStatuses>;
  /** delete data from the table: "partner_booking_orders" */
  deletePartnerBookingOrders?: Maybe<PartnerBookingOrdersMutationResponse>;
  /** delete single row from the table: "partner_booking_orders" */
  deletePartnerBookingOrdersByPk?: Maybe<PartnerBookingOrders>;
  /** delete data from the table: "partner_booking_verification_methods" */
  deletePartnerBookingVerificationMethods?: Maybe<PartnerBookingVerificationMethodsMutationResponse>;
  /** delete single row from the table: "partner_booking_verification_methods" */
  deletePartnerBookingVerificationMethodsByPk?: Maybe<PartnerBookingVerificationMethods>;
  /** delete data from the table: "payment_fulfillment_channels" */
  deletePaymentFulfillmentChannels?: Maybe<PaymentFulfillmentChannelsMutationResponse>;
  /** delete single row from the table: "payment_fulfillment_channels" */
  deletePaymentFulfillmentChannelsByPk?: Maybe<PaymentFulfillmentChannels>;
  /** delete data from the table: "payment_processors" */
  deletePaymentProcessors?: Maybe<PaymentProcessorsMutationResponse>;
  /** delete single row from the table: "payment_processors" */
  deletePaymentProcessorsByPk?: Maybe<PaymentProcessors>;
  /** delete data from the table: "payment_statuses" */
  deletePaymentStatuses?: Maybe<PaymentStatusesMutationResponse>;
  /** delete single row from the table: "payment_statuses" */
  deletePaymentStatusesByPk?: Maybe<PaymentStatuses>;
  /** delete data from the table: "pickleball_rating_scales" */
  deletePickleballRatingScales?: Maybe<PickleballRatingScalesMutationResponse>;
  /** delete single row from the table: "pickleball_rating_scales" */
  deletePickleballRatingScalesByPk?: Maybe<PickleballRatingScales>;
  /** delete data from the table: "platform_subscription_intervals" */
  deletePlatformSubscriptionIntervals?: Maybe<PlatformSubscriptionIntervalsMutationResponse>;
  /** delete single row from the table: "platform_subscription_intervals" */
  deletePlatformSubscriptionIntervalsByPk?: Maybe<PlatformSubscriptionIntervals>;
  /** delete data from the table: "platform_subscription_personas" */
  deletePlatformSubscriptionPersonas?: Maybe<PlatformSubscriptionPersonasMutationResponse>;
  /** delete single row from the table: "platform_subscription_personas" */
  deletePlatformSubscriptionPersonasByPk?: Maybe<PlatformSubscriptionPersonas>;
  /** delete data from the table: "platform_subscription_plan_prices" */
  deletePlatformSubscriptionPlanPrices?: Maybe<PlatformSubscriptionPlanPricesMutationResponse>;
  /** delete single row from the table: "platform_subscription_plan_prices" */
  deletePlatformSubscriptionPlanPricesByPk?: Maybe<PlatformSubscriptionPlanPrices>;
  /** delete data from the table: "platform_subscription_plans" */
  deletePlatformSubscriptionPlans?: Maybe<PlatformSubscriptionPlansMutationResponse>;
  /** delete single row from the table: "platform_subscription_plans" */
  deletePlatformSubscriptionPlansByPk?: Maybe<PlatformSubscriptionPlans>;
  /** delete data from the table: "platform_subscriptions" */
  deletePlatformSubscriptions?: Maybe<PlatformSubscriptionsMutationResponse>;
  /** delete single row from the table: "platform_subscriptions" */
  deletePlatformSubscriptionsByPk?: Maybe<PlatformSubscriptions>;
  /** delete data from the table: "play_request_neighborhoods" */
  deletePlayRequestNeighborhoods?: Maybe<PlayRequestNeighborhoodsMutationResponse>;
  /** delete single row from the table: "play_request_neighborhoods" */
  deletePlayRequestNeighborhoodsByPk?: Maybe<PlayRequestNeighborhoods>;
  /** delete data from the table: "play_request_slots" */
  deletePlayRequestSlots?: Maybe<PlayRequestSlotsMutationResponse>;
  /** delete single row from the table: "play_request_slots" */
  deletePlayRequestSlotsByPk?: Maybe<PlayRequestSlots>;
  /** delete data from the table: "play_request_statuses" */
  deletePlayRequestStatuses?: Maybe<PlayRequestStatusesMutationResponse>;
  /** delete single row from the table: "play_request_statuses" */
  deletePlayRequestStatusesByPk?: Maybe<PlayRequestStatuses>;
  /** delete data from the table: "play_request_venues" */
  deletePlayRequestVenues?: Maybe<PlayRequestVenuesMutationResponse>;
  /** delete single row from the table: "play_request_venues" */
  deletePlayRequestVenuesByPk?: Maybe<PlayRequestVenues>;
  /** delete data from the table: "play_requests" */
  deletePlayRequests?: Maybe<PlayRequestsMutationResponse>;
  /** delete single row from the table: "play_requests" */
  deletePlayRequestsByPk?: Maybe<PlayRequests>;
  /** delete data from the table: "play_session_comments" */
  deletePlaySessionComments?: Maybe<PlaySessionCommentsMutationResponse>;
  /** delete single row from the table: "play_session_comments" */
  deletePlaySessionCommentsByPk?: Maybe<PlaySessionComments>;
  /** delete data from the table: "play_session_court_booking_statuses" */
  deletePlaySessionCourtBookingStatuses?: Maybe<PlaySessionCourtBookingStatusesMutationResponse>;
  /** delete single row from the table: "play_session_court_booking_statuses" */
  deletePlaySessionCourtBookingStatusesByPk?: Maybe<PlaySessionCourtBookingStatuses>;
  /** delete data from the table: "play_session_formats" */
  deletePlaySessionFormats?: Maybe<PlaySessionFormatsMutationResponse>;
  /** delete single row from the table: "play_session_formats" */
  deletePlaySessionFormatsByPk?: Maybe<PlaySessionFormats>;
  /** delete data from the table: "play_session_match_competitiveness" */
  deletePlaySessionMatchCompetitiveness?: Maybe<PlaySessionMatchCompetitivenessMutationResponse>;
  /** delete single row from the table: "play_session_match_competitiveness" */
  deletePlaySessionMatchCompetitivenessByPk?: Maybe<PlaySessionMatchCompetitiveness>;
  /** delete data from the table: "play_session_participant_statuses" */
  deletePlaySessionParticipantStatuses?: Maybe<PlaySessionParticipantStatusesMutationResponse>;
  /** delete single row from the table: "play_session_participant_statuses" */
  deletePlaySessionParticipantStatusesByPk?: Maybe<PlaySessionParticipantStatuses>;
  /** delete data from the table: "play_session_participants" */
  deletePlaySessionParticipants?: Maybe<PlaySessionParticipantsMutationResponse>;
  /** delete single row from the table: "play_session_participants" */
  deletePlaySessionParticipantsByPk?: Maybe<PlaySessionParticipants>;
  /** delete data from the table: "play_session_privacy" */
  deletePlaySessionPrivacy?: Maybe<PlaySessionPrivacyMutationResponse>;
  /** delete single row from the table: "play_session_privacy" */
  deletePlaySessionPrivacyByPk?: Maybe<PlaySessionPrivacy>;
  /** delete data from the table: "play_session_statuses" */
  deletePlaySessionStatuses?: Maybe<PlaySessionStatusesMutationResponse>;
  /** delete single row from the table: "play_session_statuses" */
  deletePlaySessionStatusesByPk?: Maybe<PlaySessionStatuses>;
  /** delete data from the table: "play_sessions" */
  deletePlaySessions?: Maybe<PlaySessionsMutationResponse>;
  /** delete single row from the table: "play_sessions" */
  deletePlaySessionsByPk?: Maybe<PlaySessions>;
  /** delete data from the table: "player_availabilities" */
  deletePlayerAvailabilities?: Maybe<PlayerAvailabilitiesMutationResponse>;
  /** delete single row from the table: "player_availabilities" */
  deletePlayerAvailabilitiesByPk?: Maybe<PlayerAvailabilities>;
  /** delete data from the table: "player_availability_neighborhoods" */
  deletePlayerAvailabilityNeighborhoods?: Maybe<PlayerAvailabilityNeighborhoodsMutationResponse>;
  /** delete single row from the table: "player_availability_neighborhoods" */
  deletePlayerAvailabilityNeighborhoodsByPk?: Maybe<PlayerAvailabilityNeighborhoods>;
  /** delete data from the table: "player_availability_rating_scales" */
  deletePlayerAvailabilityRatingScales?: Maybe<PlayerAvailabilityRatingScalesMutationResponse>;
  /** delete single row from the table: "player_availability_rating_scales" */
  deletePlayerAvailabilityRatingScalesByPk?: Maybe<PlayerAvailabilityRatingScales>;
  /** delete data from the table: "player_availability_slots" */
  deletePlayerAvailabilitySlots?: Maybe<PlayerAvailabilitySlotsMutationResponse>;
  /** delete single row from the table: "player_availability_slots" */
  deletePlayerAvailabilitySlotsByPk?: Maybe<PlayerAvailabilitySlots>;
  /** delete data from the table: "player_availability_venues" */
  deletePlayerAvailabilityVenues?: Maybe<PlayerAvailabilityVenuesMutationResponse>;
  /** delete single row from the table: "player_availability_venues" */
  deletePlayerAvailabilityVenuesByPk?: Maybe<PlayerAvailabilityVenues>;
  /** delete data from the table: "player_finder_goals" */
  deletePlayerFinderGoals?: Maybe<PlayerFinderGoalsMutationResponse>;
  /** delete single row from the table: "player_finder_goals" */
  deletePlayerFinderGoalsByPk?: Maybe<PlayerFinderGoals>;
  /** delete data from the table: "player_finder_time_of_day" */
  deletePlayerFinderTimeOfDay?: Maybe<PlayerFinderTimeOfDayMutationResponse>;
  /** delete single row from the table: "player_finder_time_of_day" */
  deletePlayerFinderTimeOfDayByPk?: Maybe<PlayerFinderTimeOfDay>;
  /** delete data from the table: "recurrence_kinds" */
  deleteRecurrenceKinds?: Maybe<RecurrenceKindsMutationResponse>;
  /** delete single row from the table: "recurrence_kinds" */
  deleteRecurrenceKindsByPk?: Maybe<RecurrenceKinds>;
  /** delete data from the table: "report_reasons" */
  deleteReportReasons?: Maybe<ReportReasonsMutationResponse>;
  /** delete single row from the table: "report_reasons" */
  deleteReportReasonsByPk?: Maybe<ReportReasons>;
  /** delete data from the table: "report_statuses" */
  deleteReportStatuses?: Maybe<ReportStatusesMutationResponse>;
  /** delete single row from the table: "report_statuses" */
  deleteReportStatusesByPk?: Maybe<ReportStatuses>;
  /** delete data from the table: "reviews" */
  deleteReviews?: Maybe<ReviewsMutationResponse>;
  /** delete single row from the table: "reviews" */
  deleteReviewsByPk?: Maybe<Reviews>;
  /** delete data from the table: "sales" */
  deleteSales?: Maybe<SalesMutationResponse>;
  /** delete single row from the table: "sales" */
  deleteSalesByPk?: Maybe<Sales>;
  /** delete data from the table: "scoring_format" */
  deleteScoringFormat?: Maybe<ScoringFormatMutationResponse>;
  /** delete single row from the table: "scoring_format" */
  deleteScoringFormatByPk?: Maybe<ScoringFormat>;
  /** delete data from the table: "signup_requests" */
  deleteSignupRequests?: Maybe<SignupRequestsMutationResponse>;
  /** delete single row from the table: "signup_requests" */
  deleteSignupRequestsByPk?: Maybe<SignupRequests>;
  /** delete data from the table: "skill_level_values" */
  deleteSkillLevelValues?: Maybe<SkillLevelValuesMutationResponse>;
  /** delete single row from the table: "skill_level_values" */
  deleteSkillLevelValuesByPk?: Maybe<SkillLevelValues>;
  /** delete data from the table: "skill_levels" */
  deleteSkillLevels?: Maybe<SkillLevelsMutationResponse>;
  /** delete single row from the table: "skill_levels" */
  deleteSkillLevelsByPk?: Maybe<SkillLevels>;
  /** delete data from the table: "sports" */
  deleteSports?: Maybe<SportsMutationResponse>;
  /** delete single row from the table: "sports" */
  deleteSportsByPk?: Maybe<Sports>;
  /** delete data from the table: "stripe_charges" */
  deleteStripeCharges?: Maybe<StripeChargesMutationResponse>;
  /** delete single row from the table: "stripe_charges" */
  deleteStripeChargesByPk?: Maybe<StripeCharges>;
  /** delete data from the table: "stripe_payment_intents" */
  deleteStripePaymentIntents?: Maybe<StripePaymentIntentsMutationResponse>;
  /** delete single row from the table: "stripe_payment_intents" */
  deleteStripePaymentIntentsByPk?: Maybe<StripePaymentIntents>;
  /** delete data from the table: "subscription_statuses" */
  deleteSubscriptionStatuses?: Maybe<SubscriptionStatusesMutationResponse>;
  /** delete single row from the table: "subscription_statuses" */
  deleteSubscriptionStatusesByPk?: Maybe<SubscriptionStatuses>;
  /** delete data from the table: "team_types" */
  deleteTeamTypes?: Maybe<TeamTypesMutationResponse>;
  /** delete single row from the table: "team_types" */
  deleteTeamTypesByPk?: Maybe<TeamTypes>;
  /** delete data from the table: "tennis_rating_scales" */
  deleteTennisRatingScales?: Maybe<TennisRatingScalesMutationResponse>;
  /** delete single row from the table: "tennis_rating_scales" */
  deleteTennisRatingScalesByPk?: Maybe<TennisRatingScales>;
  /** delete data from the table: "twilio_group_texts" */
  deleteTwilioGroupTexts?: Maybe<TwilioGroupTextsMutationResponse>;
  /** delete single row from the table: "twilio_group_texts" */
  deleteTwilioGroupTextsByPk?: Maybe<TwilioGroupTexts>;
  /** delete data from the table: "upload_review_requests" */
  deleteUploadReviewRequests?: Maybe<UploadReviewRequestsMutationResponse>;
  /** delete single row from the table: "upload_review_requests" */
  deleteUploadReviewRequestsByPk?: Maybe<UploadReviewRequests>;
  /** delete data from the table: "user_auth_identities" */
  deleteUserAuthIdentities?: Maybe<UserAuthIdentitiesMutationResponse>;
  /** delete single row from the table: "user_auth_identities" */
  deleteUserAuthIdentitiesByPk?: Maybe<UserAuthIdentities>;
  /** delete data from the table: "user_blocks" */
  deleteUserBlocks?: Maybe<UserBlocksMutationResponse>;
  /** delete single row from the table: "user_blocks" */
  deleteUserBlocksByPk?: Maybe<UserBlocks>;
  /** delete data from the table: "user_coach_services" */
  deleteUserCoachServices?: Maybe<UserCoachServicesMutationResponse>;
  /** delete single row from the table: "user_coach_services" */
  deleteUserCoachServicesByPk?: Maybe<UserCoachServices>;
  /** delete data from the table: "user_communication_preferences" */
  deleteUserCommunicationPreferences?: Maybe<UserCommunicationPreferencesMutationResponse>;
  /** delete single row from the table: "user_communication_preferences" */
  deleteUserCommunicationPreferencesByPk?: Maybe<UserCommunicationPreferences>;
  /** delete data from the table: "user_connection_request_statuses" */
  deleteUserConnectionRequestStatuses?: Maybe<UserConnectionRequestStatusesMutationResponse>;
  /** delete single row from the table: "user_connection_request_statuses" */
  deleteUserConnectionRequestStatusesByPk?: Maybe<UserConnectionRequestStatuses>;
  /** delete data from the table: "user_connection_requests" */
  deleteUserConnectionRequests?: Maybe<UserConnectionRequestsMutationResponse>;
  /** delete single row from the table: "user_connection_requests" */
  deleteUserConnectionRequestsByPk?: Maybe<UserConnectionRequests>;
  /** delete data from the table: "user_connections" */
  deleteUserConnections?: Maybe<UserConnectionsMutationResponse>;
  /** delete single row from the table: "user_connections" */
  deleteUserConnectionsByPk?: Maybe<UserConnections>;
  /** delete data from the table: "user_content_beta_subscriptions" */
  deleteUserContentBetaSubscriptions?: Maybe<UserContentBetaSubscriptionsMutationResponse>;
  /** delete single row from the table: "user_content_beta_subscriptions" */
  deleteUserContentBetaSubscriptionsByPk?: Maybe<UserContentBetaSubscriptions>;
  /** delete data from the table: "user_content_files" */
  deleteUserContentFiles?: Maybe<UserContentFilesMutationResponse>;
  /** delete single row from the table: "user_content_files" */
  deleteUserContentFilesByPk?: Maybe<UserContentFiles>;
  /** delete data from the table: "user_content_files_skills" */
  deleteUserContentFilesSkills?: Maybe<UserContentFilesSkillsMutationResponse>;
  /** delete single row from the table: "user_content_files_skills" */
  deleteUserContentFilesSkillsByPk?: Maybe<UserContentFilesSkills>;
  /** delete data from the table: "user_content_skills" */
  deleteUserContentSkills?: Maybe<UserContentSkillsMutationResponse>;
  /** delete single row from the table: "user_content_skills" */
  deleteUserContentSkillsByPk?: Maybe<UserContentSkills>;
  /** delete data from the table: "user_content_tiers" */
  deleteUserContentTiers?: Maybe<UserContentTiersMutationResponse>;
  /** delete single row from the table: "user_content_tiers" */
  deleteUserContentTiersByPk?: Maybe<UserContentTiers>;
  /** delete data from the table: "user_credit_cards" */
  deleteUserCreditCards?: Maybe<UserCreditCardsMutationResponse>;
  /** delete single row from the table: "user_credit_cards" */
  deleteUserCreditCardsByPk?: Maybe<UserCreditCards>;
  /** delete data from the table: "user_custom_courts" */
  deleteUserCustomCourts?: Maybe<UserCustomCourtsMutationResponse>;
  /** delete single row from the table: "user_custom_courts" */
  deleteUserCustomCourtsByPk?: Maybe<UserCustomCourts>;
  /** delete data from the table: "user_files" */
  deleteUserFiles?: Maybe<UserFilesMutationResponse>;
  /** delete single row from the table: "user_files" */
  deleteUserFilesByPk?: Maybe<UserFiles>;
  /** delete data from the table: "user_follows" */
  deleteUserFollows?: Maybe<UserFollowsMutationResponse>;
  /** delete single row from the table: "user_follows" */
  deleteUserFollowsByPk?: Maybe<UserFollows>;
  /** delete data from the table: "user_identity_verifications" */
  deleteUserIdentityVerifications?: Maybe<UserIdentityVerificationsMutationResponse>;
  /** delete single row from the table: "user_identity_verifications" */
  deleteUserIdentityVerificationsByPk?: Maybe<UserIdentityVerifications>;
  /** delete data from the table: "user_image_log" */
  deleteUserImageLog?: Maybe<UserImageLogMutationResponse>;
  /** delete single row from the table: "user_image_log" */
  deleteUserImageLogByPk?: Maybe<UserImageLog>;
  /** delete data from the table: "user_notification_details" */
  deleteUserNotificationDetails?: Maybe<UserNotificationDetailsMutationResponse>;
  /** delete single row from the table: "user_notification_details" */
  deleteUserNotificationDetailsByPk?: Maybe<UserNotificationDetails>;
  /** delete data from the table: "user_notification_entities" */
  deleteUserNotificationEntities?: Maybe<UserNotificationEntitiesMutationResponse>;
  /** delete single row from the table: "user_notification_entities" */
  deleteUserNotificationEntitiesByPk?: Maybe<UserNotificationEntities>;
  /** delete data from the table: "user_notifications" */
  deleteUserNotifications?: Maybe<UserNotificationsMutationResponse>;
  /** delete single row from the table: "user_notifications" */
  deleteUserNotificationsByPk?: Maybe<UserNotifications>;
  /** delete data from the table: "user_padel_rating_scales" */
  deleteUserPadelRatingScales?: Maybe<UserPadelRatingScalesMutationResponse>;
  /** delete single row from the table: "user_padel_rating_scales" */
  deleteUserPadelRatingScalesByPk?: Maybe<UserPadelRatingScales>;
  /** delete data from the table: "user_pickleball_rating_scales" */
  deleteUserPickleballRatingScales?: Maybe<UserPickleballRatingScalesMutationResponse>;
  /** delete single row from the table: "user_pickleball_rating_scales" */
  deleteUserPickleballRatingScalesByPk?: Maybe<UserPickleballRatingScales>;
  /** delete data from the table: "user_played_with_dismissals" */
  deleteUserPlayedWithDismissals?: Maybe<UserPlayedWithDismissalsMutationResponse>;
  /** delete single row from the table: "user_played_with_dismissals" */
  deleteUserPlayedWithDismissalsByPk?: Maybe<UserPlayedWithDismissals>;
  /** delete data from the table: "user_player_finder_availability" */
  deleteUserPlayerFinderAvailability?: Maybe<UserPlayerFinderAvailabilityMutationResponse>;
  /** delete single row from the table: "user_player_finder_availability" */
  deleteUserPlayerFinderAvailabilityByPk?: Maybe<UserPlayerFinderAvailability>;
  /** delete data from the table: "user_player_finder_goals" */
  deleteUserPlayerFinderGoals?: Maybe<UserPlayerFinderGoalsMutationResponse>;
  /** delete single row from the table: "user_player_finder_goals" */
  deleteUserPlayerFinderGoalsByPk?: Maybe<UserPlayerFinderGoals>;
  /** delete data from the table: "user_profiles" */
  deleteUserProfiles?: Maybe<UserProfilesMutationResponse>;
  /** delete data from the table: "user_registration_details" */
  deleteUserRegistrationDetails?: Maybe<UserRegistrationDetailsMutationResponse>;
  /** delete single row from the table: "user_registration_details" */
  deleteUserRegistrationDetailsByPk?: Maybe<UserRegistrationDetails>;
  /** delete data from the table: "user_sports" */
  deleteUserSports?: Maybe<UserSportsMutationResponse>;
  /** delete single row from the table: "user_sports" */
  deleteUserSportsByPk?: Maybe<UserSports>;
  /** delete data from the table: "user_tennis_rating_scales" */
  deleteUserTennisRatingScales?: Maybe<UserTennisRatingScalesMutationResponse>;
  /** delete single row from the table: "user_tennis_rating_scales" */
  deleteUserTennisRatingScalesByPk?: Maybe<UserTennisRatingScales>;
  /** delete data from the table: "user_terms_of_service" */
  deleteUserTermsOfService?: Maybe<UserTermsOfServiceMutationResponse>;
  /** delete single row from the table: "user_terms_of_service" */
  deleteUserTermsOfServiceByPk?: Maybe<UserTermsOfService>;
  /** delete data from the table: "user_vair_connections" */
  deleteUserVairConnections?: Maybe<UserVairConnectionsMutationResponse>;
  /** delete single row from the table: "user_vair_connections" */
  deleteUserVairConnectionsByPk?: Maybe<UserVairConnections>;
  /** delete data from the table: "username_logs" */
  deleteUsernameLogs?: Maybe<UsernameLogsMutationResponse>;
  /** delete single row from the table: "username_logs" */
  deleteUsernameLogsByPk?: Maybe<UsernameLogs>;
  /** delete data from the table: "usernames_active" */
  deleteUsernamesActive?: Maybe<UsernamesActiveMutationResponse>;
  /** delete data from the table: "usernames_claimed" */
  deleteUsernamesClaimed?: Maybe<UsernamesClaimedMutationResponse>;
  /** delete single row from the table: "usernames_claimed" */
  deleteUsernamesClaimedByPk?: Maybe<UsernamesClaimed>;
  /** delete data from the table: "users" */
  deleteUsers?: Maybe<UsersMutationResponse>;
  /** delete single row from the table: "users" */
  deleteUsersByPk?: Maybe<Users>;
  /** delete data from the table: "users_coach_qualifications" */
  deleteUsersCoachQualifications?: Maybe<UsersCoachQualificationsMutationResponse>;
  /** delete single row from the table: "users_coach_qualifications" */
  deleteUsersCoachQualificationsByPk?: Maybe<UsersCoachQualifications>;
  /** delete data from the table: "venue_access_types" */
  deleteVenueAccessTypes?: Maybe<VenueAccessTypesMutationResponse>;
  /** delete single row from the table: "venue_access_types" */
  deleteVenueAccessTypesByPk?: Maybe<VenueAccessTypes>;
  /** delete data from the table: "venue_admin_claim_statuses" */
  deleteVenueAdminClaimStatuses?: Maybe<VenueAdminClaimStatusesMutationResponse>;
  /** delete single row from the table: "venue_admin_claim_statuses" */
  deleteVenueAdminClaimStatusesByPk?: Maybe<VenueAdminClaimStatuses>;
  /** delete data from the table: "venue_admin_claims" */
  deleteVenueAdminClaims?: Maybe<VenueAdminClaimsMutationResponse>;
  /** delete single row from the table: "venue_admin_claims" */
  deleteVenueAdminClaimsByPk?: Maybe<VenueAdminClaims>;
  /** delete data from the table: "venue_amenities" */
  deleteVenueAmenities?: Maybe<VenueAmenitiesMutationResponse>;
  /** delete single row from the table: "venue_amenities" */
  deleteVenueAmenitiesByPk?: Maybe<VenueAmenities>;
  /** delete data from the table: "venue_booking_config_versions" */
  deleteVenueBookingConfigVersions?: Maybe<VenueBookingConfigVersionsMutationResponse>;
  /** delete single row from the table: "venue_booking_config_versions" */
  deleteVenueBookingConfigVersionsByPk?: Maybe<VenueBookingConfigVersions>;
  /** delete data from the table: "venue_booking_connection_check_statuses" */
  deleteVenueBookingConnectionCheckStatuses?: Maybe<VenueBookingConnectionCheckStatusesMutationResponse>;
  /** delete single row from the table: "venue_booking_connection_check_statuses" */
  deleteVenueBookingConnectionCheckStatusesByPk?: Maybe<VenueBookingConnectionCheckStatuses>;
  /** delete data from the table: "venue_booking_connection_checks" */
  deleteVenueBookingConnectionChecks?: Maybe<VenueBookingConnectionChecksMutationResponse>;
  /** delete single row from the table: "venue_booking_connection_checks" */
  deleteVenueBookingConnectionChecksByPk?: Maybe<VenueBookingConnectionChecks>;
  /** delete data from the table: "venue_booking_court_rates" */
  deleteVenueBookingCourtRates?: Maybe<VenueBookingCourtRatesMutationResponse>;
  /** delete single row from the table: "venue_booking_court_rates" */
  deleteVenueBookingCourtRatesByPk?: Maybe<VenueBookingCourtRates>;
  /** delete data from the table: "venue_booking_integrations" */
  deleteVenueBookingIntegrations?: Maybe<VenueBookingIntegrationsMutationResponse>;
  /** delete single row from the table: "venue_booking_integrations" */
  deleteVenueBookingIntegrationsByPk?: Maybe<VenueBookingIntegrations>;
  /** delete data from the table: "venue_booking_rule_tiers" */
  deleteVenueBookingRuleTiers?: Maybe<VenueBookingRuleTiersMutationResponse>;
  /** delete single row from the table: "venue_booking_rule_tiers" */
  deleteVenueBookingRuleTiersByPk?: Maybe<VenueBookingRuleTiers>;
  /** delete data from the table: "venue_booking_rules" */
  deleteVenueBookingRules?: Maybe<VenueBookingRulesMutationResponse>;
  /** delete single row from the table: "venue_booking_rules" */
  deleteVenueBookingRulesByPk?: Maybe<VenueBookingRules>;
  /** delete data from the table: "venue_booking_windows" */
  deleteVenueBookingWindows?: Maybe<VenueBookingWindowsMutationResponse>;
  /** delete single row from the table: "venue_booking_windows" */
  deleteVenueBookingWindowsByPk?: Maybe<VenueBookingWindows>;
  /** delete data from the table: "venue_court_surfaces" */
  deleteVenueCourtSurfaces?: Maybe<VenueCourtSurfacesMutationResponse>;
  /** delete single row from the table: "venue_court_surfaces" */
  deleteVenueCourtSurfacesByPk?: Maybe<VenueCourtSurfaces>;
  /** delete data from the table: "venue_custom_amenities" */
  deleteVenueCustomAmenities?: Maybe<VenueCustomAmenitiesMutationResponse>;
  /** delete single row from the table: "venue_custom_amenities" */
  deleteVenueCustomAmenitiesByPk?: Maybe<VenueCustomAmenities>;
  /** delete data from the table: "venue_equipment" */
  deleteVenueEquipment?: Maybe<VenueEquipmentMutationResponse>;
  /** delete single row from the table: "venue_equipment" */
  deleteVenueEquipmentByPk?: Maybe<VenueEquipment>;
  /** delete data from the table: "venue_facility_types" */
  deleteVenueFacilityTypes?: Maybe<VenueFacilityTypesMutationResponse>;
  /** delete single row from the table: "venue_facility_types" */
  deleteVenueFacilityTypesByPk?: Maybe<VenueFacilityTypes>;
  /** delete data from the table: "venue_faqs" */
  deleteVenueFaqs?: Maybe<VenueFaqsMutationResponse>;
  /** delete single row from the table: "venue_faqs" */
  deleteVenueFaqsByPk?: Maybe<VenueFaqs>;
  /** delete data from the table: "venue_follows" */
  deleteVenueFollows?: Maybe<VenueFollowsMutationResponse>;
  /** delete single row from the table: "venue_follows" */
  deleteVenueFollowsByPk?: Maybe<VenueFollows>;
  /** delete data from the table: "venue_images" */
  deleteVenueImages?: Maybe<VenueImagesMutationResponse>;
  /** delete single row from the table: "venue_images" */
  deleteVenueImagesByPk?: Maybe<VenueImages>;
  /** delete data from the table: "venue_lines" */
  deleteVenueLines?: Maybe<VenueLinesMutationResponse>;
  /** delete single row from the table: "venue_lines" */
  deleteVenueLinesByPk?: Maybe<VenueLines>;
  /** delete data from the table: "venue_nets" */
  deleteVenueNets?: Maybe<VenueNetsMutationResponse>;
  /** delete single row from the table: "venue_nets" */
  deleteVenueNetsByPk?: Maybe<VenueNets>;
  /** delete data from the table: "venue_partner_booking_statuses" */
  deleteVenuePartnerBookingStatuses?: Maybe<VenuePartnerBookingStatusesMutationResponse>;
  /** delete data from the table: "venue_staff_coaches" */
  deleteVenueStaffCoaches?: Maybe<VenueStaffCoachesMutationResponse>;
  /** delete single row from the table: "venue_staff_coaches" */
  deleteVenueStaffCoachesByPk?: Maybe<VenueStaffCoaches>;
  /** delete data from the table: "venues" */
  deleteVenues?: Maybe<VenuesMutationResponse>;
  /** delete single row from the table: "venues" */
  deleteVenuesByPk?: Maybe<Venues>;
  /** delete data from the table: "video_analysis" */
  deleteVideoAnalysis?: Maybe<VideoAnalysisMutationResponse>;
  /** delete single row from the table: "video_analysis" */
  deleteVideoAnalysisByPk?: Maybe<VideoAnalysis>;
  /** delete data from the table: "video_analysis_comments" */
  deleteVideoAnalysisComments?: Maybe<VideoAnalysisCommentsMutationResponse>;
  /** delete single row from the table: "video_analysis_comments" */
  deleteVideoAnalysisCommentsByPk?: Maybe<VideoAnalysisComments>;
  /** delete data from the table: "video_analysis_files" */
  deleteVideoAnalysisFiles?: Maybe<VideoAnalysisFilesMutationResponse>;
  /** delete single row from the table: "video_analysis_files" */
  deleteVideoAnalysisFilesByPk?: Maybe<VideoAnalysisFiles>;
  /** delete data from the table: "video_analysis_files_upload_statuses" */
  deleteVideoAnalysisFilesUploadStatuses?: Maybe<VideoAnalysisFilesUploadStatusesMutationResponse>;
  /** delete single row from the table: "video_analysis_files_upload_statuses" */
  deleteVideoAnalysisFilesUploadStatusesByPk?: Maybe<VideoAnalysisFilesUploadStatuses>;
  /** delete data from the table: "video_analysis_order_items" */
  deleteVideoAnalysisOrderItems?: Maybe<VideoAnalysisOrderItemsMutationResponse>;
  /** delete single row from the table: "video_analysis_order_items" */
  deleteVideoAnalysisOrderItemsByPk?: Maybe<VideoAnalysisOrderItems>;
  /** delete data from the table: "video_analysis_orders" */
  deleteVideoAnalysisOrders?: Maybe<VideoAnalysisOrdersMutationResponse>;
  /** delete single row from the table: "video_analysis_orders" */
  deleteVideoAnalysisOrdersByPk?: Maybe<VideoAnalysisOrders>;
  /** delete data from the table: "video_analysis_requested_skills_review" */
  deleteVideoAnalysisRequestedSkillsReview?: Maybe<VideoAnalysisRequestedSkillsReviewMutationResponse>;
  /** delete single row from the table: "video_analysis_requested_skills_review" */
  deleteVideoAnalysisRequestedSkillsReviewByPk?: Maybe<VideoAnalysisRequestedSkillsReview>;
  /** delete data from the table: "video_analysis_review_statuses" */
  deleteVideoAnalysisReviewStatuses?: Maybe<VideoAnalysisReviewStatusesMutationResponse>;
  /** delete single row from the table: "video_analysis_review_statuses" */
  deleteVideoAnalysisReviewStatusesByPk?: Maybe<VideoAnalysisReviewStatuses>;
  /** delete data from the table: "video_analysis_skills_comments" */
  deleteVideoAnalysisSkillsComments?: Maybe<VideoAnalysisSkillsCommentsMutationResponse>;
  /** delete single row from the table: "video_analysis_skills_comments" */
  deleteVideoAnalysisSkillsCommentsByPk?: Maybe<VideoAnalysisSkillsComments>;
  /** delete data from the table: "video_analysis_submission_log" */
  deleteVideoAnalysisSubmissionLog?: Maybe<VideoAnalysisSubmissionLogMutationResponse>;
  /** delete single row from the table: "video_analysis_submission_log" */
  deleteVideoAnalysisSubmissionLogByPk?: Maybe<VideoAnalysisSubmissionLog>;
  /** delete data from the table: "video_lesson_skills" */
  deleteVideoLessonSkills?: Maybe<VideoLessonSkillsMutationResponse>;
  /** delete single row from the table: "video_lesson_skills" */
  deleteVideoLessonSkillsByPk?: Maybe<VideoLessonSkills>;
  /** delete data from the table: "welcome_email_configuration" */
  deleteWelcomeEmailConfiguration?: Maybe<WelcomeEmailConfigurationMutationResponse>;
  /** delete single row from the table: "welcome_email_configuration" */
  deleteWelcomeEmailConfigurationByPk?: Maybe<WelcomeEmailConfiguration>;
  /** delete data from the table: "win_reasons" */
  deleteWinReasons?: Maybe<WinReasonsMutationResponse>;
  /** delete single row from the table: "win_reasons" */
  deleteWinReasonsByPk?: Maybe<WinReasons>;
  /** insert data into the table: "amenities" */
  insertAmenities?: Maybe<AmenitiesMutationResponse>;
  /** insert a single row into the table: "amenities" */
  insertAmenitiesOne?: Maybe<Amenities>;
  /** insert data into the table: "app_personas" */
  insertAppPersonas?: Maybe<AppPersonasMutationResponse>;
  /** insert a single row into the table: "app_personas" */
  insertAppPersonasOne?: Maybe<AppPersonas>;
  /** insert data into the table: "app_pings" */
  insertAppPings?: Maybe<AppPingsMutationResponse>;
  /** insert a single row into the table: "app_pings" */
  insertAppPingsOne?: Maybe<AppPings>;
  /** insert data into the table: "ball_types" */
  insertBallTypes?: Maybe<BallTypesMutationResponse>;
  /** insert a single row into the table: "ball_types" */
  insertBallTypesOne?: Maybe<BallTypes>;
  /** insert data into the table: "birthday_visibility" */
  insertBirthdayVisibility?: Maybe<BirthdayVisibilityMutationResponse>;
  /** insert a single row into the table: "birthday_visibility" */
  insertBirthdayVisibilityOne?: Maybe<BirthdayVisibility>;
  /** insert data into the table: "booking_config_change_types" */
  insertBookingConfigChangeTypes?: Maybe<BookingConfigChangeTypesMutationResponse>;
  /** insert a single row into the table: "booking_config_change_types" */
  insertBookingConfigChangeTypesOne?: Maybe<BookingConfigChangeTypes>;
  /** insert data into the table: "booking_connection_statuses" */
  insertBookingConnectionStatuses?: Maybe<BookingConnectionStatusesMutationResponse>;
  /** insert a single row into the table: "booking_connection_statuses" */
  insertBookingConnectionStatusesOne?: Maybe<BookingConnectionStatuses>;
  /** insert data into the table: "booking_integration_statuses" */
  insertBookingIntegrationStatuses?: Maybe<BookingIntegrationStatusesMutationResponse>;
  /** insert a single row into the table: "booking_integration_statuses" */
  insertBookingIntegrationStatusesOne?: Maybe<BookingIntegrationStatuses>;
  /** insert data into the table: "booking_inventory_types" */
  insertBookingInventoryTypes?: Maybe<BookingInventoryTypesMutationResponse>;
  /** insert a single row into the table: "booking_inventory_types" */
  insertBookingInventoryTypesOne?: Maybe<BookingInventoryTypes>;
  /** insert data into the table: "booking_schedule_modes" */
  insertBookingScheduleModes?: Maybe<BookingScheduleModesMutationResponse>;
  /** insert a single row into the table: "booking_schedule_modes" */
  insertBookingScheduleModesOne?: Maybe<BookingScheduleModes>;
  /** insert data into the table: "booking_systems" */
  insertBookingSystems?: Maybe<BookingSystemsMutationResponse>;
  /** insert a single row into the table: "booking_systems" */
  insertBookingSystemsOne?: Maybe<BookingSystems>;
  /** insert data into the table: "booking_window_kinds" */
  insertBookingWindowKinds?: Maybe<BookingWindowKindsMutationResponse>;
  /** insert a single row into the table: "booking_window_kinds" */
  insertBookingWindowKindsOne?: Maybe<BookingWindowKinds>;
  /** insert data into the table: "boost_channels" */
  insertBoostChannels?: Maybe<BoostChannelsMutationResponse>;
  /** insert a single row into the table: "boost_channels" */
  insertBoostChannelsOne?: Maybe<BoostChannels>;
  /** insert data into the table: "boost_orders" */
  insertBoostOrders?: Maybe<BoostOrdersMutationResponse>;
  /** insert a single row into the table: "boost_orders" */
  insertBoostOrdersOne?: Maybe<BoostOrders>;
  /** insert data into the table: "boost_statuses" */
  insertBoostStatuses?: Maybe<BoostStatusesMutationResponse>;
  /** insert a single row into the table: "boost_statuses" */
  insertBoostStatusesOne?: Maybe<BoostStatuses>;
  /** insert data into the table: "boosts" */
  insertBoosts?: Maybe<BoostsMutationResponse>;
  /** insert a single row into the table: "boosts" */
  insertBoostsOne?: Maybe<Boosts>;
  /** insert data into the table: "bracket_ranking_mechanism" */
  insertBracketRankingMechanism?: Maybe<BracketRankingMechanismMutationResponse>;
  /** insert a single row into the table: "bracket_ranking_mechanism" */
  insertBracketRankingMechanismOne?: Maybe<BracketRankingMechanism>;
  /** insert data into the table: "calendar_accounts" */
  insertCalendarAccounts?: Maybe<CalendarAccountsMutationResponse>;
  /** insert a single row into the table: "calendar_accounts" */
  insertCalendarAccountsOne?: Maybe<CalendarAccounts>;
  /** insert data into the table: "calendar_auth_provider" */
  insertCalendarAuthProvider?: Maybe<CalendarAuthProviderMutationResponse>;
  /** insert a single row into the table: "calendar_auth_provider" */
  insertCalendarAuthProviderOne?: Maybe<CalendarAuthProvider>;
  /** insert data into the table: "calendar_event_mappings" */
  insertCalendarEventMappings?: Maybe<CalendarEventMappingsMutationResponse>;
  /** insert a single row into the table: "calendar_event_mappings" */
  insertCalendarEventMappingsOne?: Maybe<CalendarEventMappings>;
  /** insert data into the table: "calendar_preferences" */
  insertCalendarPreferences?: Maybe<CalendarPreferencesMutationResponse>;
  /** insert a single row into the table: "calendar_preferences" */
  insertCalendarPreferencesOne?: Maybe<CalendarPreferences>;
  /** insert data into the table: "cities" */
  insertCities?: Maybe<CitiesMutationResponse>;
  /** insert a single row into the table: "cities" */
  insertCitiesOne?: Maybe<Cities>;
  /** insert data into the table: "coach_availability" */
  insertCoachAvailability?: Maybe<CoachAvailabilityMutationResponse>;
  /** insert a single row into the table: "coach_availability" */
  insertCoachAvailabilityOne?: Maybe<CoachAvailability>;
  /** insert data into the table: "coach_availability_statuses" */
  insertCoachAvailabilityStatuses?: Maybe<CoachAvailabilityStatusesMutationResponse>;
  /** insert a single row into the table: "coach_availability_statuses" */
  insertCoachAvailabilityStatusesOne?: Maybe<CoachAvailabilityStatuses>;
  /** insert data into the table: "coach_booking_requests" */
  insertCoachBookingRequests?: Maybe<CoachBookingRequestsMutationResponse>;
  /** insert a single row into the table: "coach_booking_requests" */
  insertCoachBookingRequestsOne?: Maybe<CoachBookingRequests>;
  /** insert data into the table: "coach_external_review_sources" */
  insertCoachExternalReviewSources?: Maybe<CoachExternalReviewSourcesMutationResponse>;
  /** insert a single row into the table: "coach_external_review_sources" */
  insertCoachExternalReviewSourcesOne?: Maybe<CoachExternalReviewSources>;
  /** insert data into the table: "coach_faqs" */
  insertCoachFaqs?: Maybe<CoachFaqsMutationResponse>;
  /** insert a single row into the table: "coach_faqs" */
  insertCoachFaqsOne?: Maybe<CoachFaqs>;
  /** insert data into the table: "coach_lesson_age_groups" */
  insertCoachLessonAgeGroups?: Maybe<CoachLessonAgeGroupsMutationResponse>;
  /** insert a single row into the table: "coach_lesson_age_groups" */
  insertCoachLessonAgeGroupsOne?: Maybe<CoachLessonAgeGroups>;
  /** insert data into the table: "coach_lesson_skill_levels" */
  insertCoachLessonSkillLevels?: Maybe<CoachLessonSkillLevelsMutationResponse>;
  /** insert a single row into the table: "coach_lesson_skill_levels" */
  insertCoachLessonSkillLevelsOne?: Maybe<CoachLessonSkillLevels>;
  /** insert data into the table: "coach_qualification_groups" */
  insertCoachQualificationGroups?: Maybe<CoachQualificationGroupsMutationResponse>;
  /** insert a single row into the table: "coach_qualification_groups" */
  insertCoachQualificationGroupsOne?: Maybe<CoachQualificationGroups>;
  /** insert data into the table: "coach_qualification_statuses" */
  insertCoachQualificationStatuses?: Maybe<CoachQualificationStatusesMutationResponse>;
  /** insert a single row into the table: "coach_qualification_statuses" */
  insertCoachQualificationStatusesOne?: Maybe<CoachQualificationStatuses>;
  /** insert data into the table: "coach_qualifications" */
  insertCoachQualifications?: Maybe<CoachQualificationsMutationResponse>;
  /** insert a single row into the table: "coach_qualifications" */
  insertCoachQualificationsOne?: Maybe<CoachQualifications>;
  /** insert data into the table: "coach_review_types" */
  insertCoachReviewTypes?: Maybe<CoachReviewTypesMutationResponse>;
  /** insert a single row into the table: "coach_review_types" */
  insertCoachReviewTypesOne?: Maybe<CoachReviewTypes>;
  /** insert data into the table: "coach_sport_statuses" */
  insertCoachSportStatuses?: Maybe<CoachSportStatusesMutationResponse>;
  /** insert a single row into the table: "coach_sport_statuses" */
  insertCoachSportStatusesOne?: Maybe<CoachSportStatuses>;
  /** insert data into the table: "coach_sports" */
  insertCoachSports?: Maybe<CoachSportsMutationResponse>;
  /** insert a single row into the table: "coach_sports" */
  insertCoachSportsOne?: Maybe<CoachSports>;
  /** insert data into the table: "coach_starter_profiles" */
  insertCoachStarterProfiles?: Maybe<CoachStarterProfilesMutationResponse>;
  /** insert a single row into the table: "coach_starter_profiles" */
  insertCoachStarterProfilesOne?: Maybe<CoachStarterProfiles>;
  /** insert data into the table: "coach_status" */
  insertCoachStatus?: Maybe<CoachStatusMutationResponse>;
  /** insert a single row into the table: "coach_status" */
  insertCoachStatusOne?: Maybe<CoachStatus>;
  /** insert data into the table: "coach_tips" */
  insertCoachTips?: Maybe<CoachTipsMutationResponse>;
  /** insert a single row into the table: "coach_tips" */
  insertCoachTipsOne?: Maybe<CoachTips>;
  /** insert data into the table: "comment_vote" */
  insertCommentVote?: Maybe<CommentVoteMutationResponse>;
  /** insert a single row into the table: "comment_vote" */
  insertCommentVoteOne?: Maybe<CommentVote>;
  /** insert data into the table: "communication_preference_statuses" */
  insertCommunicationPreferenceStatuses?: Maybe<CommunicationPreferenceStatusesMutationResponse>;
  /** insert a single row into the table: "communication_preference_statuses" */
  insertCommunicationPreferenceStatusesOne?: Maybe<CommunicationPreferenceStatuses>;
  /** insert data into the table: "competition_formats" */
  insertCompetitionFormats?: Maybe<CompetitionFormatsMutationResponse>;
  /** insert a single row into the table: "competition_formats" */
  insertCompetitionFormatsOne?: Maybe<CompetitionFormats>;
  /** insert data into the table: "competition_gender" */
  insertCompetitionGender?: Maybe<CompetitionGenderMutationResponse>;
  /** insert a single row into the table: "competition_gender" */
  insertCompetitionGenderOne?: Maybe<CompetitionGender>;
  /** insert data into the table: "content_reports" */
  insertContentReports?: Maybe<ContentReportsMutationResponse>;
  /** insert a single row into the table: "content_reports" */
  insertContentReportsOne?: Maybe<ContentReports>;
  /** insert data into the table: "conversation_participants" */
  insertConversationParticipants?: Maybe<ConversationParticipantsMutationResponse>;
  /** insert a single row into the table: "conversation_participants" */
  insertConversationParticipantsOne?: Maybe<ConversationParticipants>;
  /** insert data into the table: "conversation_types" */
  insertConversationTypes?: Maybe<ConversationTypesMutationResponse>;
  /** insert a single row into the table: "conversation_types" */
  insertConversationTypesOne?: Maybe<ConversationTypes>;
  /** insert data into the table: "conversations" */
  insertConversations?: Maybe<ConversationsMutationResponse>;
  /** insert a single row into the table: "conversations" */
  insertConversationsOne?: Maybe<Conversations>;
  /** insert data into the table: "countries" */
  insertCountries?: Maybe<CountriesMutationResponse>;
  /** insert a single row into the table: "countries" */
  insertCountriesOne?: Maybe<Countries>;
  /** insert data into the table: "country_subdivisions" */
  insertCountrySubdivisions?: Maybe<CountrySubdivisionsMutationResponse>;
  /** insert a single row into the table: "country_subdivisions" */
  insertCountrySubdivisionsOne?: Maybe<CountrySubdivisions>;
  /** insert data into the table: "court_surfaces" */
  insertCourtSurfaces?: Maybe<CourtSurfacesMutationResponse>;
  /** insert a single row into the table: "court_surfaces" */
  insertCourtSurfacesOne?: Maybe<CourtSurfaces>;
  /** insert data into the table: "day_of_week" */
  insertDayOfWeek?: Maybe<DayOfWeekMutationResponse>;
  /** insert a single row into the table: "day_of_week" */
  insertDayOfWeekOne?: Maybe<DayOfWeek>;
  /** insert data into the table: "engagement_analytics" */
  insertEngagementAnalytics?: Maybe<EngagementAnalyticsMutationResponse>;
  /** insert a single row into the table: "engagement_analytics" */
  insertEngagementAnalyticsOne?: Maybe<EngagementAnalytics>;
  /** insert data into the table: "engagement_entity_types" */
  insertEngagementEntityTypes?: Maybe<EngagementEntityTypesMutationResponse>;
  /** insert a single row into the table: "engagement_entity_types" */
  insertEngagementEntityTypesOne?: Maybe<EngagementEntityTypes>;
  /** insert data into the table: "engagement_event_types" */
  insertEngagementEventTypes?: Maybe<EngagementEventTypesMutationResponse>;
  /** insert a single row into the table: "engagement_event_types" */
  insertEngagementEventTypesOne?: Maybe<EngagementEventTypes>;
  /** insert data into the table: "engagement_sources" */
  insertEngagementSources?: Maybe<EngagementSourcesMutationResponse>;
  /** insert a single row into the table: "engagement_sources" */
  insertEngagementSourcesOne?: Maybe<EngagementSources>;
  /** insert data into the table: "equipment_availabilities" */
  insertEquipmentAvailabilities?: Maybe<EquipmentAvailabilitiesMutationResponse>;
  /** insert a single row into the table: "equipment_availabilities" */
  insertEquipmentAvailabilitiesOne?: Maybe<EquipmentAvailabilities>;
  /** insert data into the table: "event_accepted_play_requests" */
  insertEventAcceptedPlayRequests?: Maybe<EventAcceptedPlayRequestsMutationResponse>;
  /** insert a single row into the table: "event_accepted_play_requests" */
  insertEventAcceptedPlayRequestsOne?: Maybe<EventAcceptedPlayRequests>;
  /** insert data into the table: "event_age_groups" */
  insertEventAgeGroups?: Maybe<EventAgeGroupsMutationResponse>;
  /** insert a single row into the table: "event_age_groups" */
  insertEventAgeGroupsOne?: Maybe<EventAgeGroups>;
  /** insert data into the table: "event_collections" */
  insertEventCollections?: Maybe<EventCollectionsMutationResponse>;
  /** insert a single row into the table: "event_collections" */
  insertEventCollectionsOne?: Maybe<EventCollections>;
  /** insert data into the table: "event_competitiveness" */
  insertEventCompetitiveness?: Maybe<EventCompetitivenessMutationResponse>;
  /** insert a single row into the table: "event_competitiveness" */
  insertEventCompetitivenessOne?: Maybe<EventCompetitiveness>;
  /** insert data into the table: "event_contact_details" */
  insertEventContactDetails?: Maybe<EventContactDetailsMutationResponse>;
  /** insert a single row into the table: "event_contact_details" */
  insertEventContactDetailsOne?: Maybe<EventContactDetails>;
  /** insert data into the table: "event_coupon_groups" */
  insertEventCouponGroups?: Maybe<EventCouponGroupsMutationResponse>;
  /** insert a single row into the table: "event_coupon_groups" */
  insertEventCouponGroupsOne?: Maybe<EventCouponGroups>;
  /** insert data into the table: "event_coupon_redemptions" */
  insertEventCouponRedemptions?: Maybe<EventCouponRedemptionsMutationResponse>;
  /** insert a single row into the table: "event_coupon_redemptions" */
  insertEventCouponRedemptionsOne?: Maybe<EventCouponRedemptions>;
  /** insert data into the table: "event_coupon_source" */
  insertEventCouponSource?: Maybe<EventCouponSourceMutationResponse>;
  /** insert a single row into the table: "event_coupon_source" */
  insertEventCouponSourceOne?: Maybe<EventCouponSource>;
  /** insert data into the table: "event_coupon_type" */
  insertEventCouponType?: Maybe<EventCouponTypeMutationResponse>;
  /** insert a single row into the table: "event_coupon_type" */
  insertEventCouponTypeOne?: Maybe<EventCouponType>;
  /** insert data into the table: "event_coupons" */
  insertEventCoupons?: Maybe<EventCouponsMutationResponse>;
  /** insert a single row into the table: "event_coupons" */
  insertEventCouponsOne?: Maybe<EventCoupons>;
  /** insert data into the table: "event_court_statuses" */
  insertEventCourtStatuses?: Maybe<EventCourtStatusesMutationResponse>;
  /** insert a single row into the table: "event_court_statuses" */
  insertEventCourtStatusesOne?: Maybe<EventCourtStatuses>;
  /** insert data into the table: "event_courts" */
  insertEventCourts?: Maybe<EventCourtsMutationResponse>;
  /** insert a single row into the table: "event_courts" */
  insertEventCourtsOne?: Maybe<EventCourts>;
  /** insert data into the table: "event_faqs" */
  insertEventFaqs?: Maybe<EventFaqsMutationResponse>;
  /** insert a single row into the table: "event_faqs" */
  insertEventFaqsOne?: Maybe<EventFaqs>;
  /** insert data into the table: "event_game_scores" */
  insertEventGameScores?: Maybe<EventGameScoresMutationResponse>;
  /** insert a single row into the table: "event_game_scores" */
  insertEventGameScoresOne?: Maybe<EventGameScores>;
  /** insert data into the table: "event_group_formats" */
  insertEventGroupFormats?: Maybe<EventGroupFormatsMutationResponse>;
  /** insert a single row into the table: "event_group_formats" */
  insertEventGroupFormatsOne?: Maybe<EventGroupFormats>;
  /** insert data into the table: "event_group_merges" */
  insertEventGroupMerges?: Maybe<EventGroupMergesMutationResponse>;
  /** insert a single row into the table: "event_group_merges" */
  insertEventGroupMergesOne?: Maybe<EventGroupMerges>;
  /** insert data into the table: "event_group_pools" */
  insertEventGroupPools?: Maybe<EventGroupPoolsMutationResponse>;
  /** insert a single row into the table: "event_group_pools" */
  insertEventGroupPoolsOne?: Maybe<EventGroupPools>;
  /** insert data into the table: "event_group_rating_scales" */
  insertEventGroupRatingScales?: Maybe<EventGroupRatingScalesMutationResponse>;
  /** insert a single row into the table: "event_group_rating_scales" */
  insertEventGroupRatingScalesOne?: Maybe<EventGroupRatingScales>;
  /** insert data into the table: "event_group_registration_statuses" */
  insertEventGroupRegistrationStatuses?: Maybe<EventGroupRegistrationStatusesMutationResponse>;
  /** insert a single row into the table: "event_group_registration_statuses" */
  insertEventGroupRegistrationStatusesOne?: Maybe<EventGroupRegistrationStatuses>;
  /** insert data into the table: "event_group_registrations" */
  insertEventGroupRegistrations?: Maybe<EventGroupRegistrationsMutationResponse>;
  /** insert a single row into the table: "event_group_registrations" */
  insertEventGroupRegistrationsOne?: Maybe<EventGroupRegistrations>;
  /** insert data into the table: "event_group_sequence_seeding" */
  insertEventGroupSequenceSeeding?: Maybe<EventGroupSequenceSeedingMutationResponse>;
  /** insert a single row into the table: "event_group_sequence_seeding" */
  insertEventGroupSequenceSeedingOne?: Maybe<EventGroupSequenceSeeding>;
  /** insert data into the table: "event_group_sequences" */
  insertEventGroupSequences?: Maybe<EventGroupSequencesMutationResponse>;
  /** insert a single row into the table: "event_group_sequences" */
  insertEventGroupSequencesOne?: Maybe<EventGroupSequences>;
  /** insert data into the table: "event_group_time_slots" */
  insertEventGroupTimeSlots?: Maybe<EventGroupTimeSlotsMutationResponse>;
  /** insert a single row into the table: "event_group_time_slots" */
  insertEventGroupTimeSlotsOne?: Maybe<EventGroupTimeSlots>;
  /** insert data into the table: "event_groups" */
  insertEventGroups?: Maybe<EventGroupsMutationResponse>;
  /** insert a single row into the table: "event_groups" */
  insertEventGroupsOne?: Maybe<EventGroups>;
  /** insert data into the table: "event_invitation_statuses" */
  insertEventInvitationStatuses?: Maybe<EventInvitationStatusesMutationResponse>;
  /** insert a single row into the table: "event_invitation_statuses" */
  insertEventInvitationStatusesOne?: Maybe<EventInvitationStatuses>;
  /** insert data into the table: "event_invitation_types" */
  insertEventInvitationTypes?: Maybe<EventInvitationTypesMutationResponse>;
  /** insert a single row into the table: "event_invitation_types" */
  insertEventInvitationTypesOne?: Maybe<EventInvitationTypes>;
  /** insert data into the table: "event_invitations" */
  insertEventInvitations?: Maybe<EventInvitationsMutationResponse>;
  /** insert a single row into the table: "event_invitations" */
  insertEventInvitationsOne?: Maybe<EventInvitations>;
  /** insert data into the table: "event_listing_fees" */
  insertEventListingFees?: Maybe<EventListingFeesMutationResponse>;
  /** insert a single row into the table: "event_listing_fees" */
  insertEventListingFeesOne?: Maybe<EventListingFees>;
  /** insert data into the table: "event_match_games" */
  insertEventMatchGames?: Maybe<EventMatchGamesMutationResponse>;
  /** insert a single row into the table: "event_match_games" */
  insertEventMatchGamesOne?: Maybe<EventMatchGames>;
  /** insert data into the table: "event_matches" */
  insertEventMatches?: Maybe<EventMatchesMutationResponse>;
  /** insert a single row into the table: "event_matches" */
  insertEventMatchesOne?: Maybe<EventMatches>;
  /** insert data into the table: "event_matches_teams" */
  insertEventMatchesTeams?: Maybe<EventMatchesTeamsMutationResponse>;
  /** insert a single row into the table: "event_matches_teams" */
  insertEventMatchesTeamsOne?: Maybe<EventMatchesTeams>;
  /** insert data into the table: "event_organizer_account_types" */
  insertEventOrganizerAccountTypes?: Maybe<EventOrganizerAccountTypesMutationResponse>;
  /** insert a single row into the table: "event_organizer_account_types" */
  insertEventOrganizerAccountTypesOne?: Maybe<EventOrganizerAccountTypes>;
  /** insert data into the table: "event_player_invite_statuses" */
  insertEventPlayerInviteStatuses?: Maybe<EventPlayerInviteStatusesMutationResponse>;
  /** insert a single row into the table: "event_player_invite_statuses" */
  insertEventPlayerInviteStatusesOne?: Maybe<EventPlayerInviteStatuses>;
  /** insert data into the table: "event_player_invites" */
  insertEventPlayerInvites?: Maybe<EventPlayerInvitesMutationResponse>;
  /** insert a single row into the table: "event_player_invites" */
  insertEventPlayerInvitesOne?: Maybe<EventPlayerInvites>;
  /** insert data into the table: "event_pool_rounds" */
  insertEventPoolRounds?: Maybe<EventPoolRoundsMutationResponse>;
  /** insert a single row into the table: "event_pool_rounds" */
  insertEventPoolRoundsOne?: Maybe<EventPoolRounds>;
  /** insert data into the table: "event_pools_teams" */
  insertEventPoolsTeams?: Maybe<EventPoolsTeamsMutationResponse>;
  /** insert a single row into the table: "event_pools_teams" */
  insertEventPoolsTeamsOne?: Maybe<EventPoolsTeams>;
  /** insert data into the table: "event_privacy" */
  insertEventPrivacy?: Maybe<EventPrivacyMutationResponse>;
  /** insert a single row into the table: "event_privacy" */
  insertEventPrivacyOne?: Maybe<EventPrivacy>;
  /** insert data into the table: "event_registration_details" */
  insertEventRegistrationDetails?: Maybe<EventRegistrationDetailsMutationResponse>;
  /** insert a single row into the table: "event_registration_details" */
  insertEventRegistrationDetailsOne?: Maybe<EventRegistrationDetails>;
  /** insert data into the table: "event_registrations" */
  insertEventRegistrations?: Maybe<EventRegistrationsMutationResponse>;
  /** insert a single row into the table: "event_registrations" */
  insertEventRegistrationsOne?: Maybe<EventRegistrations>;
  /** insert data into the table: "event_sequence_complete_reasons" */
  insertEventSequenceCompleteReasons?: Maybe<EventSequenceCompleteReasonsMutationResponse>;
  /** insert a single row into the table: "event_sequence_complete_reasons" */
  insertEventSequenceCompleteReasonsOne?: Maybe<EventSequenceCompleteReasons>;
  /** insert data into the table: "event_skill_levels" */
  insertEventSkillLevels?: Maybe<EventSkillLevelsMutationResponse>;
  /** insert a single row into the table: "event_skill_levels" */
  insertEventSkillLevelsOne?: Maybe<EventSkillLevels>;
  /** insert data into the table: "event_sponsors" */
  insertEventSponsors?: Maybe<EventSponsorsMutationResponse>;
  /** insert a single row into the table: "event_sponsors" */
  insertEventSponsorsOne?: Maybe<EventSponsors>;
  /** insert data into the table: "event_statuses" */
  insertEventStatuses?: Maybe<EventStatusesMutationResponse>;
  /** insert a single row into the table: "event_statuses" */
  insertEventStatusesOne?: Maybe<EventStatuses>;
  /** insert data into the table: "event_team_member_statuses" */
  insertEventTeamMemberStatuses?: Maybe<EventTeamMemberStatusesMutationResponse>;
  /** insert a single row into the table: "event_team_member_statuses" */
  insertEventTeamMemberStatusesOne?: Maybe<EventTeamMemberStatuses>;
  /** insert data into the table: "event_team_members" */
  insertEventTeamMembers?: Maybe<EventTeamMembersMutationResponse>;
  /** insert a single row into the table: "event_team_members" */
  insertEventTeamMembersOne?: Maybe<EventTeamMembers>;
  /** insert data into the table: "event_team_statuses" */
  insertEventTeamStatuses?: Maybe<EventTeamStatusesMutationResponse>;
  /** insert a single row into the table: "event_team_statuses" */
  insertEventTeamStatusesOne?: Maybe<EventTeamStatuses>;
  /** insert data into the table: "event_teams" */
  insertEventTeams?: Maybe<EventTeamsMutationResponse>;
  /** insert a single row into the table: "event_teams" */
  insertEventTeamsOne?: Maybe<EventTeams>;
  /** insert data into the table: "event_transaction_item_types" */
  insertEventTransactionItemTypes?: Maybe<EventTransactionItemTypesMutationResponse>;
  /** insert a single row into the table: "event_transaction_item_types" */
  insertEventTransactionItemTypesOne?: Maybe<EventTransactionItemTypes>;
  /** insert data into the table: "event_transaction_items" */
  insertEventTransactionItems?: Maybe<EventTransactionItemsMutationResponse>;
  /** insert a single row into the table: "event_transaction_items" */
  insertEventTransactionItemsOne?: Maybe<EventTransactionItems>;
  /** insert data into the table: "event_transactions" */
  insertEventTransactions?: Maybe<EventTransactionsMutationResponse>;
  /** insert a single row into the table: "event_transactions" */
  insertEventTransactionsOne?: Maybe<EventTransactions>;
  /** insert data into the table: "event_types" */
  insertEventTypes?: Maybe<EventTypesMutationResponse>;
  /** insert a single row into the table: "event_types" */
  insertEventTypesOne?: Maybe<EventTypes>;
  /** insert data into the table: "events" */
  insertEvents?: Maybe<EventsMutationResponse>;
  /** insert a single row into the table: "events" */
  insertEventsOne?: Maybe<Events>;
  /** insert data into the table: "feedback_sentiment" */
  insertFeedbackSentiment?: Maybe<FeedbackSentimentMutationResponse>;
  /** insert a single row into the table: "feedback_sentiment" */
  insertFeedbackSentimentOne?: Maybe<FeedbackSentiment>;
  /** insert data into the table: "file_category" */
  insertFileCategory?: Maybe<FileCategoryMutationResponse>;
  /** insert a single row into the table: "file_category" */
  insertFileCategoryOne?: Maybe<FileCategory>;
  /** insert data into the table: "file_format" */
  insertFileFormat?: Maybe<FileFormatMutationResponse>;
  /** insert a single row into the table: "file_format" */
  insertFileFormatOne?: Maybe<FileFormat>;
  /** insert data into the table: "follow_statuses" */
  insertFollowStatuses?: Maybe<FollowStatusesMutationResponse>;
  /** insert a single row into the table: "follow_statuses" */
  insertFollowStatusesOne?: Maybe<FollowStatuses>;
  /** insert data into the table: "game_net_statuses" */
  insertGameNetStatuses?: Maybe<GameNetStatusesMutationResponse>;
  /** insert a single row into the table: "game_net_statuses" */
  insertGameNetStatusesOne?: Maybe<GameNetStatuses>;
  /** insert data into the table: "gender" */
  insertGender?: Maybe<GenderMutationResponse>;
  /** insert a single row into the table: "gender" */
  insertGenderOne?: Maybe<Gender>;
  /** insert data into the table: "group_comment_votes" */
  insertGroupCommentVotes?: Maybe<GroupCommentVotesMutationResponse>;
  /** insert a single row into the table: "group_comment_votes" */
  insertGroupCommentVotesOne?: Maybe<GroupCommentVotes>;
  /** insert data into the table: "group_members" */
  insertGroupMembers?: Maybe<GroupMembersMutationResponse>;
  /** insert a single row into the table: "group_members" */
  insertGroupMembersOne?: Maybe<GroupMembers>;
  /** insert data into the table: "group_thread_comment_files" */
  insertGroupThreadCommentFiles?: Maybe<GroupThreadCommentFilesMutationResponse>;
  /** insert a single row into the table: "group_thread_comment_files" */
  insertGroupThreadCommentFilesOne?: Maybe<GroupThreadCommentFiles>;
  /** insert data into the table: "group_thread_comments" */
  insertGroupThreadComments?: Maybe<GroupThreadCommentsMutationResponse>;
  /** insert a single row into the table: "group_thread_comments" */
  insertGroupThreadCommentsOne?: Maybe<GroupThreadComments>;
  /** insert data into the table: "group_threads" */
  insertGroupThreads?: Maybe<GroupThreadsMutationResponse>;
  /** insert a single row into the table: "group_threads" */
  insertGroupThreadsOne?: Maybe<GroupThreads>;
  /** insert data into the table: "group_types" */
  insertGroupTypes?: Maybe<GroupTypesMutationResponse>;
  /** insert a single row into the table: "group_types" */
  insertGroupTypesOne?: Maybe<GroupTypes>;
  /** insert data into the table: "group_venues" */
  insertGroupVenues?: Maybe<GroupVenuesMutationResponse>;
  /** insert a single row into the table: "group_venues" */
  insertGroupVenuesOne?: Maybe<GroupVenues>;
  /** insert data into the table: "groups" */
  insertGroups?: Maybe<GroupsMutationResponse>;
  /** insert a single row into the table: "groups" */
  insertGroupsOne?: Maybe<Groups>;
  /** insert data into the table: "groups_play_sessions" */
  insertGroupsPlaySessions?: Maybe<GroupsPlaySessionsMutationResponse>;
  /** insert a single row into the table: "groups_play_sessions" */
  insertGroupsPlaySessionsOne?: Maybe<GroupsPlaySessions>;
  /** insert data into the table: "identity_verification_providers" */
  insertIdentityVerificationProviders?: Maybe<IdentityVerificationProvidersMutationResponse>;
  /** insert a single row into the table: "identity_verification_providers" */
  insertIdentityVerificationProvidersOne?: Maybe<IdentityVerificationProviders>;
  /** insert data into the table: "identity_verification_statuses" */
  insertIdentityVerificationStatuses?: Maybe<IdentityVerificationStatusesMutationResponse>;
  /** insert a single row into the table: "identity_verification_statuses" */
  insertIdentityVerificationStatusesOne?: Maybe<IdentityVerificationStatuses>;
  /** insert data into the table: "invoices" */
  insertInvoices?: Maybe<InvoicesMutationResponse>;
  /** insert a single row into the table: "invoices" */
  insertInvoicesOne?: Maybe<Invoices>;
  /** insert data into the table: "learning_program_enrollment_schedule_media_watched" */
  insertLearningProgramEnrollmentScheduleMediaWatched?: Maybe<LearningProgramEnrollmentScheduleMediaWatchedMutationResponse>;
  /** insert a single row into the table: "learning_program_enrollment_schedule_media_watched" */
  insertLearningProgramEnrollmentScheduleMediaWatchedOne?: Maybe<LearningProgramEnrollmentScheduleMediaWatched>;
  /** insert data into the table: "learning_program_enrollment_schedule_progress" */
  insertLearningProgramEnrollmentScheduleProgress?: Maybe<LearningProgramEnrollmentScheduleProgressMutationResponse>;
  /** insert a single row into the table: "learning_program_enrollment_schedule_progress" */
  insertLearningProgramEnrollmentScheduleProgressOne?: Maybe<LearningProgramEnrollmentScheduleProgress>;
  /** insert data into the table: "learning_program_enrollments" */
  insertLearningProgramEnrollments?: Maybe<LearningProgramEnrollmentsMutationResponse>;
  /** insert a single row into the table: "learning_program_enrollments" */
  insertLearningProgramEnrollmentsOne?: Maybe<LearningProgramEnrollments>;
  /** insert data into the table: "learning_program_media" */
  insertLearningProgramMedia?: Maybe<LearningProgramMediaMutationResponse>;
  /** insert data into the table: "learning_program_media_categories" */
  insertLearningProgramMediaCategories?: Maybe<LearningProgramMediaCategoriesMutationResponse>;
  /** insert a single row into the table: "learning_program_media_categories" */
  insertLearningProgramMediaCategoriesOne?: Maybe<LearningProgramMediaCategories>;
  /** insert a single row into the table: "learning_program_media" */
  insertLearningProgramMediaOne?: Maybe<LearningProgramMedia>;
  /** insert data into the table: "learning_program_schedule_media" */
  insertLearningProgramScheduleMedia?: Maybe<LearningProgramScheduleMediaMutationResponse>;
  /** insert a single row into the table: "learning_program_schedule_media" */
  insertLearningProgramScheduleMediaOne?: Maybe<LearningProgramScheduleMedia>;
  /** insert data into the table: "learning_program_schedule_units" */
  insertLearningProgramScheduleUnits?: Maybe<LearningProgramScheduleUnitsMutationResponse>;
  /** insert a single row into the table: "learning_program_schedule_units" */
  insertLearningProgramScheduleUnitsOne?: Maybe<LearningProgramScheduleUnits>;
  /** insert data into the table: "learning_program_schedule_video_submissions" */
  insertLearningProgramScheduleVideoSubmissions?: Maybe<LearningProgramScheduleVideoSubmissionsMutationResponse>;
  /** insert a single row into the table: "learning_program_schedule_video_submissions" */
  insertLearningProgramScheduleVideoSubmissionsOne?: Maybe<LearningProgramScheduleVideoSubmissions>;
  /** insert data into the table: "learning_program_schedules" */
  insertLearningProgramSchedules?: Maybe<LearningProgramSchedulesMutationResponse>;
  /** insert a single row into the table: "learning_program_schedules" */
  insertLearningProgramSchedulesOne?: Maybe<LearningProgramSchedules>;
  /** insert data into the table: "learning_program_skill_level_values" */
  insertLearningProgramSkillLevelValues?: Maybe<LearningProgramSkillLevelValuesMutationResponse>;
  /** insert a single row into the table: "learning_program_skill_level_values" */
  insertLearningProgramSkillLevelValuesOne?: Maybe<LearningProgramSkillLevelValues>;
  /** insert data into the table: "learning_program_skills" */
  insertLearningProgramSkills?: Maybe<LearningProgramSkillsMutationResponse>;
  /** insert a single row into the table: "learning_program_skills" */
  insertLearningProgramSkillsOne?: Maybe<LearningProgramSkills>;
  /** insert data into the table: "learning_programs" */
  insertLearningPrograms?: Maybe<LearningProgramsMutationResponse>;
  /** insert a single row into the table: "learning_programs" */
  insertLearningProgramsOne?: Maybe<LearningPrograms>;
  /** insert data into the table: "lesson_age_groups" */
  insertLessonAgeGroups?: Maybe<LessonAgeGroupsMutationResponse>;
  /** insert a single row into the table: "lesson_age_groups" */
  insertLessonAgeGroupsOne?: Maybe<LessonAgeGroups>;
  /** insert data into the table: "lesson_collections" */
  insertLessonCollections?: Maybe<LessonCollectionsMutationResponse>;
  /** insert a single row into the table: "lesson_collections" */
  insertLessonCollectionsOne?: Maybe<LessonCollections>;
  /** insert data into the table: "lesson_equipment" */
  insertLessonEquipment?: Maybe<LessonEquipmentMutationResponse>;
  /** insert a single row into the table: "lesson_equipment" */
  insertLessonEquipmentOne?: Maybe<LessonEquipment>;
  /** insert data into the table: "lesson_equipment_options" */
  insertLessonEquipmentOptions?: Maybe<LessonEquipmentOptionsMutationResponse>;
  /** insert a single row into the table: "lesson_equipment_options" */
  insertLessonEquipmentOptionsOne?: Maybe<LessonEquipmentOptions>;
  /** insert data into the table: "lesson_order_items" */
  insertLessonOrderItems?: Maybe<LessonOrderItemsMutationResponse>;
  /** insert a single row into the table: "lesson_order_items" */
  insertLessonOrderItemsOne?: Maybe<LessonOrderItems>;
  /** insert data into the table: "lesson_orders" */
  insertLessonOrders?: Maybe<LessonOrdersMutationResponse>;
  /** insert a single row into the table: "lesson_orders" */
  insertLessonOrdersOne?: Maybe<LessonOrders>;
  /** insert data into the table: "lesson_participant_statuses" */
  insertLessonParticipantStatuses?: Maybe<LessonParticipantStatusesMutationResponse>;
  /** insert a single row into the table: "lesson_participant_statuses" */
  insertLessonParticipantStatusesOne?: Maybe<LessonParticipantStatuses>;
  /** insert data into the table: "lesson_participants" */
  insertLessonParticipants?: Maybe<LessonParticipantsMutationResponse>;
  /** insert a single row into the table: "lesson_participants" */
  insertLessonParticipantsOne?: Maybe<LessonParticipants>;
  /** insert data into the table: "lesson_player_skill_assessment_categories" */
  insertLessonPlayerSkillAssessmentCategories?: Maybe<LessonPlayerSkillAssessmentCategoriesMutationResponse>;
  /** insert a single row into the table: "lesson_player_skill_assessment_categories" */
  insertLessonPlayerSkillAssessmentCategoriesOne?: Maybe<LessonPlayerSkillAssessmentCategories>;
  /** insert data into the table: "lesson_player_skill_assessments" */
  insertLessonPlayerSkillAssessments?: Maybe<LessonPlayerSkillAssessmentsMutationResponse>;
  /** insert a single row into the table: "lesson_player_skill_assessments" */
  insertLessonPlayerSkillAssessmentsOne?: Maybe<LessonPlayerSkillAssessments>;
  /** insert data into the table: "lesson_player_skill_assessments_skills" */
  insertLessonPlayerSkillAssessmentsSkills?: Maybe<LessonPlayerSkillAssessmentsSkillsMutationResponse>;
  /** insert a single row into the table: "lesson_player_skill_assessments_skills" */
  insertLessonPlayerSkillAssessmentsSkillsOne?: Maybe<LessonPlayerSkillAssessmentsSkills>;
  /** insert data into the table: "lesson_privacy" */
  insertLessonPrivacy?: Maybe<LessonPrivacyMutationResponse>;
  /** insert a single row into the table: "lesson_privacy" */
  insertLessonPrivacyOne?: Maybe<LessonPrivacy>;
  /** insert data into the table: "lesson_reflection_comment_types" */
  insertLessonReflectionCommentTypes?: Maybe<LessonReflectionCommentTypesMutationResponse>;
  /** insert a single row into the table: "lesson_reflection_comment_types" */
  insertLessonReflectionCommentTypesOne?: Maybe<LessonReflectionCommentTypes>;
  /** insert data into the table: "lesson_reflection_comments" */
  insertLessonReflectionComments?: Maybe<LessonReflectionCommentsMutationResponse>;
  /** insert a single row into the table: "lesson_reflection_comments" */
  insertLessonReflectionCommentsOne?: Maybe<LessonReflectionComments>;
  /** insert data into the table: "lesson_reflection_files" */
  insertLessonReflectionFiles?: Maybe<LessonReflectionFilesMutationResponse>;
  /** insert a single row into the table: "lesson_reflection_files" */
  insertLessonReflectionFilesOne?: Maybe<LessonReflectionFiles>;
  /** insert data into the table: "lesson_reflections" */
  insertLessonReflections?: Maybe<LessonReflectionsMutationResponse>;
  /** insert a single row into the table: "lesson_reflections" */
  insertLessonReflectionsOne?: Maybe<LessonReflections>;
  /** insert data into the table: "lesson_skill_categories" */
  insertLessonSkillCategories?: Maybe<LessonSkillCategoriesMutationResponse>;
  /** insert a single row into the table: "lesson_skill_categories" */
  insertLessonSkillCategoriesOne?: Maybe<LessonSkillCategories>;
  /** insert data into the table: "lesson_skill_display_names" */
  insertLessonSkillDisplayNames?: Maybe<LessonSkillDisplayNamesMutationResponse>;
  /** insert a single row into the table: "lesson_skill_display_names" */
  insertLessonSkillDisplayNamesOne?: Maybe<LessonSkillDisplayNames>;
  /** insert data into the table: "lesson_skill_levels" */
  insertLessonSkillLevels?: Maybe<LessonSkillLevelsMutationResponse>;
  /** insert a single row into the table: "lesson_skill_levels" */
  insertLessonSkillLevelsOne?: Maybe<LessonSkillLevels>;
  /** insert data into the table: "lesson_skill_mappings" */
  insertLessonSkillMappings?: Maybe<LessonSkillMappingsMutationResponse>;
  /** insert a single row into the table: "lesson_skill_mappings" */
  insertLessonSkillMappingsOne?: Maybe<LessonSkillMappings>;
  /** insert data into the table: "lesson_skills" */
  insertLessonSkills?: Maybe<LessonSkillsMutationResponse>;
  /** insert a single row into the table: "lesson_skills" */
  insertLessonSkillsOne?: Maybe<LessonSkills>;
  /** insert data into the table: "lesson_statuses" */
  insertLessonStatuses?: Maybe<LessonStatusesMutationResponse>;
  /** insert a single row into the table: "lesson_statuses" */
  insertLessonStatusesOne?: Maybe<LessonStatuses>;
  /** insert data into the table: "lesson_template_skill_levels" */
  insertLessonTemplateSkillLevels?: Maybe<LessonTemplateSkillLevelsMutationResponse>;
  /** insert a single row into the table: "lesson_template_skill_levels" */
  insertLessonTemplateSkillLevelsOne?: Maybe<LessonTemplateSkillLevels>;
  /** insert data into the table: "lesson_templates" */
  insertLessonTemplates?: Maybe<LessonTemplatesMutationResponse>;
  /** insert a single row into the table: "lesson_templates" */
  insertLessonTemplatesOne?: Maybe<LessonTemplates>;
  /** insert data into the table: "lesson_times" */
  insertLessonTimes?: Maybe<LessonTimesMutationResponse>;
  /** insert a single row into the table: "lesson_times" */
  insertLessonTimesOne?: Maybe<LessonTimes>;
  /** insert data into the table: "lesson_types" */
  insertLessonTypes?: Maybe<LessonTypesMutationResponse>;
  /** insert a single row into the table: "lesson_types" */
  insertLessonTypesOne?: Maybe<LessonTypes>;
  /** insert data into the table: "lesson_waitlist_statuses" */
  insertLessonWaitlistStatuses?: Maybe<LessonWaitlistStatusesMutationResponse>;
  /** insert a single row into the table: "lesson_waitlist_statuses" */
  insertLessonWaitlistStatusesOne?: Maybe<LessonWaitlistStatuses>;
  /** insert data into the table: "lesson_waitlists" */
  insertLessonWaitlists?: Maybe<LessonWaitlistsMutationResponse>;
  /** insert a single row into the table: "lesson_waitlists" */
  insertLessonWaitlistsOne?: Maybe<LessonWaitlists>;
  /** insert data into the table: "lessons" */
  insertLessons?: Maybe<LessonsMutationResponse>;
  /** insert a single row into the table: "lessons" */
  insertLessonsOne?: Maybe<Lessons>;
  /** insert data into the table: "match_selection_criteria" */
  insertMatchSelectionCriteria?: Maybe<MatchSelectionCriteriaMutationResponse>;
  /** insert a single row into the table: "match_selection_criteria" */
  insertMatchSelectionCriteriaOne?: Maybe<MatchSelectionCriteria>;
  /** insert data into the table: "messages" */
  insertMessages?: Maybe<MessagesMutationResponse>;
  /** insert a single row into the table: "messages" */
  insertMessagesOne?: Maybe<Messages>;
  /** insert data into the table: "neighborhoods" */
  insertNeighborhoods?: Maybe<NeighborhoodsMutationResponse>;
  /** insert a single row into the table: "neighborhoods" */
  insertNeighborhoodsOne?: Maybe<Neighborhoods>;
  /** insert data into the table: "notification_action_types" */
  insertNotificationActionTypes?: Maybe<NotificationActionTypesMutationResponse>;
  /** insert a single row into the table: "notification_action_types" */
  insertNotificationActionTypesOne?: Maybe<NotificationActionTypes>;
  /** insert data into the table: "notification_statuses" */
  insertNotificationStatuses?: Maybe<NotificationStatusesMutationResponse>;
  /** insert a single row into the table: "notification_statuses" */
  insertNotificationStatusesOne?: Maybe<NotificationStatuses>;
  /** insert data into the table: "order_statuses" */
  insertOrderStatuses?: Maybe<OrderStatusesMutationResponse>;
  /** insert a single row into the table: "order_statuses" */
  insertOrderStatusesOne?: Maybe<OrderStatuses>;
  /** insert data into the table: "padel_rating_scales" */
  insertPadelRatingScales?: Maybe<PadelRatingScalesMutationResponse>;
  /** insert a single row into the table: "padel_rating_scales" */
  insertPadelRatingScalesOne?: Maybe<PadelRatingScales>;
  /** insert data into the table: "participant_roles" */
  insertParticipantRoles?: Maybe<ParticipantRolesMutationResponse>;
  /** insert a single row into the table: "participant_roles" */
  insertParticipantRolesOne?: Maybe<ParticipantRoles>;
  /** insert data into the table: "partner_booking_attempt_events" */
  insertPartnerBookingAttemptEvents?: Maybe<PartnerBookingAttemptEventsMutationResponse>;
  /** insert a single row into the table: "partner_booking_attempt_events" */
  insertPartnerBookingAttemptEventsOne?: Maybe<PartnerBookingAttemptEvents>;
  /** insert data into the table: "partner_booking_attempt_statuses" */
  insertPartnerBookingAttemptStatuses?: Maybe<PartnerBookingAttemptStatusesMutationResponse>;
  /** insert a single row into the table: "partner_booking_attempt_statuses" */
  insertPartnerBookingAttemptStatusesOne?: Maybe<PartnerBookingAttemptStatuses>;
  /** insert data into the table: "partner_booking_attempts" */
  insertPartnerBookingAttempts?: Maybe<PartnerBookingAttemptsMutationResponse>;
  /** insert a single row into the table: "partner_booking_attempts" */
  insertPartnerBookingAttemptsOne?: Maybe<PartnerBookingAttempts>;
  /** insert data into the table: "partner_booking_engines" */
  insertPartnerBookingEngines?: Maybe<PartnerBookingEnginesMutationResponse>;
  /** insert a single row into the table: "partner_booking_engines" */
  insertPartnerBookingEnginesOne?: Maybe<PartnerBookingEngines>;
  /** insert data into the table: "partner_booking_event_sources" */
  insertPartnerBookingEventSources?: Maybe<PartnerBookingEventSourcesMutationResponse>;
  /** insert a single row into the table: "partner_booking_event_sources" */
  insertPartnerBookingEventSourcesOne?: Maybe<PartnerBookingEventSources>;
  /** insert data into the table: "partner_booking_holds" */
  insertPartnerBookingHolds?: Maybe<PartnerBookingHoldsMutationResponse>;
  /** insert a single row into the table: "partner_booking_holds" */
  insertPartnerBookingHoldsOne?: Maybe<PartnerBookingHolds>;
  /** insert data into the table: "partner_booking_order_statuses" */
  insertPartnerBookingOrderStatuses?: Maybe<PartnerBookingOrderStatusesMutationResponse>;
  /** insert a single row into the table: "partner_booking_order_statuses" */
  insertPartnerBookingOrderStatusesOne?: Maybe<PartnerBookingOrderStatuses>;
  /** insert data into the table: "partner_booking_orders" */
  insertPartnerBookingOrders?: Maybe<PartnerBookingOrdersMutationResponse>;
  /** insert a single row into the table: "partner_booking_orders" */
  insertPartnerBookingOrdersOne?: Maybe<PartnerBookingOrders>;
  /** insert data into the table: "partner_booking_verification_methods" */
  insertPartnerBookingVerificationMethods?: Maybe<PartnerBookingVerificationMethodsMutationResponse>;
  /** insert a single row into the table: "partner_booking_verification_methods" */
  insertPartnerBookingVerificationMethodsOne?: Maybe<PartnerBookingVerificationMethods>;
  /** insert data into the table: "payment_fulfillment_channels" */
  insertPaymentFulfillmentChannels?: Maybe<PaymentFulfillmentChannelsMutationResponse>;
  /** insert a single row into the table: "payment_fulfillment_channels" */
  insertPaymentFulfillmentChannelsOne?: Maybe<PaymentFulfillmentChannels>;
  /** insert data into the table: "payment_processors" */
  insertPaymentProcessors?: Maybe<PaymentProcessorsMutationResponse>;
  /** insert a single row into the table: "payment_processors" */
  insertPaymentProcessorsOne?: Maybe<PaymentProcessors>;
  /** insert data into the table: "payment_statuses" */
  insertPaymentStatuses?: Maybe<PaymentStatusesMutationResponse>;
  /** insert a single row into the table: "payment_statuses" */
  insertPaymentStatusesOne?: Maybe<PaymentStatuses>;
  /** insert data into the table: "pickleball_rating_scales" */
  insertPickleballRatingScales?: Maybe<PickleballRatingScalesMutationResponse>;
  /** insert a single row into the table: "pickleball_rating_scales" */
  insertPickleballRatingScalesOne?: Maybe<PickleballRatingScales>;
  /** insert data into the table: "platform_subscription_intervals" */
  insertPlatformSubscriptionIntervals?: Maybe<PlatformSubscriptionIntervalsMutationResponse>;
  /** insert a single row into the table: "platform_subscription_intervals" */
  insertPlatformSubscriptionIntervalsOne?: Maybe<PlatformSubscriptionIntervals>;
  /** insert data into the table: "platform_subscription_personas" */
  insertPlatformSubscriptionPersonas?: Maybe<PlatformSubscriptionPersonasMutationResponse>;
  /** insert a single row into the table: "platform_subscription_personas" */
  insertPlatformSubscriptionPersonasOne?: Maybe<PlatformSubscriptionPersonas>;
  /** insert data into the table: "platform_subscription_plan_prices" */
  insertPlatformSubscriptionPlanPrices?: Maybe<PlatformSubscriptionPlanPricesMutationResponse>;
  /** insert a single row into the table: "platform_subscription_plan_prices" */
  insertPlatformSubscriptionPlanPricesOne?: Maybe<PlatformSubscriptionPlanPrices>;
  /** insert data into the table: "platform_subscription_plans" */
  insertPlatformSubscriptionPlans?: Maybe<PlatformSubscriptionPlansMutationResponse>;
  /** insert a single row into the table: "platform_subscription_plans" */
  insertPlatformSubscriptionPlansOne?: Maybe<PlatformSubscriptionPlans>;
  /** insert data into the table: "platform_subscriptions" */
  insertPlatformSubscriptions?: Maybe<PlatformSubscriptionsMutationResponse>;
  /** insert a single row into the table: "platform_subscriptions" */
  insertPlatformSubscriptionsOne?: Maybe<PlatformSubscriptions>;
  /** insert data into the table: "play_request_neighborhoods" */
  insertPlayRequestNeighborhoods?: Maybe<PlayRequestNeighborhoodsMutationResponse>;
  /** insert a single row into the table: "play_request_neighborhoods" */
  insertPlayRequestNeighborhoodsOne?: Maybe<PlayRequestNeighborhoods>;
  /** insert data into the table: "play_request_slots" */
  insertPlayRequestSlots?: Maybe<PlayRequestSlotsMutationResponse>;
  /** insert a single row into the table: "play_request_slots" */
  insertPlayRequestSlotsOne?: Maybe<PlayRequestSlots>;
  /** insert data into the table: "play_request_statuses" */
  insertPlayRequestStatuses?: Maybe<PlayRequestStatusesMutationResponse>;
  /** insert a single row into the table: "play_request_statuses" */
  insertPlayRequestStatusesOne?: Maybe<PlayRequestStatuses>;
  /** insert data into the table: "play_request_venues" */
  insertPlayRequestVenues?: Maybe<PlayRequestVenuesMutationResponse>;
  /** insert a single row into the table: "play_request_venues" */
  insertPlayRequestVenuesOne?: Maybe<PlayRequestVenues>;
  /** insert data into the table: "play_requests" */
  insertPlayRequests?: Maybe<PlayRequestsMutationResponse>;
  /** insert a single row into the table: "play_requests" */
  insertPlayRequestsOne?: Maybe<PlayRequests>;
  /** insert data into the table: "play_session_comments" */
  insertPlaySessionComments?: Maybe<PlaySessionCommentsMutationResponse>;
  /** insert a single row into the table: "play_session_comments" */
  insertPlaySessionCommentsOne?: Maybe<PlaySessionComments>;
  /** insert data into the table: "play_session_court_booking_statuses" */
  insertPlaySessionCourtBookingStatuses?: Maybe<PlaySessionCourtBookingStatusesMutationResponse>;
  /** insert a single row into the table: "play_session_court_booking_statuses" */
  insertPlaySessionCourtBookingStatusesOne?: Maybe<PlaySessionCourtBookingStatuses>;
  /** insert data into the table: "play_session_formats" */
  insertPlaySessionFormats?: Maybe<PlaySessionFormatsMutationResponse>;
  /** insert a single row into the table: "play_session_formats" */
  insertPlaySessionFormatsOne?: Maybe<PlaySessionFormats>;
  /** insert data into the table: "play_session_match_competitiveness" */
  insertPlaySessionMatchCompetitiveness?: Maybe<PlaySessionMatchCompetitivenessMutationResponse>;
  /** insert a single row into the table: "play_session_match_competitiveness" */
  insertPlaySessionMatchCompetitivenessOne?: Maybe<PlaySessionMatchCompetitiveness>;
  /** insert data into the table: "play_session_participant_statuses" */
  insertPlaySessionParticipantStatuses?: Maybe<PlaySessionParticipantStatusesMutationResponse>;
  /** insert a single row into the table: "play_session_participant_statuses" */
  insertPlaySessionParticipantStatusesOne?: Maybe<PlaySessionParticipantStatuses>;
  /** insert data into the table: "play_session_participants" */
  insertPlaySessionParticipants?: Maybe<PlaySessionParticipantsMutationResponse>;
  /** insert a single row into the table: "play_session_participants" */
  insertPlaySessionParticipantsOne?: Maybe<PlaySessionParticipants>;
  /** insert data into the table: "play_session_privacy" */
  insertPlaySessionPrivacy?: Maybe<PlaySessionPrivacyMutationResponse>;
  /** insert a single row into the table: "play_session_privacy" */
  insertPlaySessionPrivacyOne?: Maybe<PlaySessionPrivacy>;
  /** insert data into the table: "play_session_statuses" */
  insertPlaySessionStatuses?: Maybe<PlaySessionStatusesMutationResponse>;
  /** insert a single row into the table: "play_session_statuses" */
  insertPlaySessionStatusesOne?: Maybe<PlaySessionStatuses>;
  /** insert data into the table: "play_sessions" */
  insertPlaySessions?: Maybe<PlaySessionsMutationResponse>;
  /** insert a single row into the table: "play_sessions" */
  insertPlaySessionsOne?: Maybe<PlaySessions>;
  /** insert data into the table: "player_availabilities" */
  insertPlayerAvailabilities?: Maybe<PlayerAvailabilitiesMutationResponse>;
  /** insert a single row into the table: "player_availabilities" */
  insertPlayerAvailabilitiesOne?: Maybe<PlayerAvailabilities>;
  /** insert data into the table: "player_availability_neighborhoods" */
  insertPlayerAvailabilityNeighborhoods?: Maybe<PlayerAvailabilityNeighborhoodsMutationResponse>;
  /** insert a single row into the table: "player_availability_neighborhoods" */
  insertPlayerAvailabilityNeighborhoodsOne?: Maybe<PlayerAvailabilityNeighborhoods>;
  /** insert data into the table: "player_availability_rating_scales" */
  insertPlayerAvailabilityRatingScales?: Maybe<PlayerAvailabilityRatingScalesMutationResponse>;
  /** insert a single row into the table: "player_availability_rating_scales" */
  insertPlayerAvailabilityRatingScalesOne?: Maybe<PlayerAvailabilityRatingScales>;
  /** insert data into the table: "player_availability_slots" */
  insertPlayerAvailabilitySlots?: Maybe<PlayerAvailabilitySlotsMutationResponse>;
  /** insert a single row into the table: "player_availability_slots" */
  insertPlayerAvailabilitySlotsOne?: Maybe<PlayerAvailabilitySlots>;
  /** insert data into the table: "player_availability_venues" */
  insertPlayerAvailabilityVenues?: Maybe<PlayerAvailabilityVenuesMutationResponse>;
  /** insert a single row into the table: "player_availability_venues" */
  insertPlayerAvailabilityVenuesOne?: Maybe<PlayerAvailabilityVenues>;
  /** insert data into the table: "player_finder_goals" */
  insertPlayerFinderGoals?: Maybe<PlayerFinderGoalsMutationResponse>;
  /** insert a single row into the table: "player_finder_goals" */
  insertPlayerFinderGoalsOne?: Maybe<PlayerFinderGoals>;
  /** insert data into the table: "player_finder_time_of_day" */
  insertPlayerFinderTimeOfDay?: Maybe<PlayerFinderTimeOfDayMutationResponse>;
  /** insert a single row into the table: "player_finder_time_of_day" */
  insertPlayerFinderTimeOfDayOne?: Maybe<PlayerFinderTimeOfDay>;
  /** insert data into the table: "recurrence_kinds" */
  insertRecurrenceKinds?: Maybe<RecurrenceKindsMutationResponse>;
  /** insert a single row into the table: "recurrence_kinds" */
  insertRecurrenceKindsOne?: Maybe<RecurrenceKinds>;
  /** insert data into the table: "report_reasons" */
  insertReportReasons?: Maybe<ReportReasonsMutationResponse>;
  /** insert a single row into the table: "report_reasons" */
  insertReportReasonsOne?: Maybe<ReportReasons>;
  /** insert data into the table: "report_statuses" */
  insertReportStatuses?: Maybe<ReportStatusesMutationResponse>;
  /** insert a single row into the table: "report_statuses" */
  insertReportStatusesOne?: Maybe<ReportStatuses>;
  /** insert data into the table: "reviews" */
  insertReviews?: Maybe<ReviewsMutationResponse>;
  /** insert a single row into the table: "reviews" */
  insertReviewsOne?: Maybe<Reviews>;
  /** insert data into the table: "sales" */
  insertSales?: Maybe<SalesMutationResponse>;
  /** insert a single row into the table: "sales" */
  insertSalesOne?: Maybe<Sales>;
  /** insert data into the table: "scoring_format" */
  insertScoringFormat?: Maybe<ScoringFormatMutationResponse>;
  /** insert a single row into the table: "scoring_format" */
  insertScoringFormatOne?: Maybe<ScoringFormat>;
  /** insert data into the table: "signup_requests" */
  insertSignupRequests?: Maybe<SignupRequestsMutationResponse>;
  /** insert a single row into the table: "signup_requests" */
  insertSignupRequestsOne?: Maybe<SignupRequests>;
  /** insert data into the table: "skill_level_values" */
  insertSkillLevelValues?: Maybe<SkillLevelValuesMutationResponse>;
  /** insert a single row into the table: "skill_level_values" */
  insertSkillLevelValuesOne?: Maybe<SkillLevelValues>;
  /** insert data into the table: "skill_levels" */
  insertSkillLevels?: Maybe<SkillLevelsMutationResponse>;
  /** insert a single row into the table: "skill_levels" */
  insertSkillLevelsOne?: Maybe<SkillLevels>;
  /** insert data into the table: "sports" */
  insertSports?: Maybe<SportsMutationResponse>;
  /** insert a single row into the table: "sports" */
  insertSportsOne?: Maybe<Sports>;
  /** insert data into the table: "stripe_charges" */
  insertStripeCharges?: Maybe<StripeChargesMutationResponse>;
  /** insert a single row into the table: "stripe_charges" */
  insertStripeChargesOne?: Maybe<StripeCharges>;
  /** insert data into the table: "stripe_payment_intents" */
  insertStripePaymentIntents?: Maybe<StripePaymentIntentsMutationResponse>;
  /** insert a single row into the table: "stripe_payment_intents" */
  insertStripePaymentIntentsOne?: Maybe<StripePaymentIntents>;
  /** insert data into the table: "subscription_statuses" */
  insertSubscriptionStatuses?: Maybe<SubscriptionStatusesMutationResponse>;
  /** insert a single row into the table: "subscription_statuses" */
  insertSubscriptionStatusesOne?: Maybe<SubscriptionStatuses>;
  /** insert data into the table: "team_types" */
  insertTeamTypes?: Maybe<TeamTypesMutationResponse>;
  /** insert a single row into the table: "team_types" */
  insertTeamTypesOne?: Maybe<TeamTypes>;
  /** insert data into the table: "tennis_rating_scales" */
  insertTennisRatingScales?: Maybe<TennisRatingScalesMutationResponse>;
  /** insert a single row into the table: "tennis_rating_scales" */
  insertTennisRatingScalesOne?: Maybe<TennisRatingScales>;
  /** insert data into the table: "twilio_group_texts" */
  insertTwilioGroupTexts?: Maybe<TwilioGroupTextsMutationResponse>;
  /** insert a single row into the table: "twilio_group_texts" */
  insertTwilioGroupTextsOne?: Maybe<TwilioGroupTexts>;
  /** insert data into the table: "upload_review_requests" */
  insertUploadReviewRequests?: Maybe<UploadReviewRequestsMutationResponse>;
  /** insert a single row into the table: "upload_review_requests" */
  insertUploadReviewRequestsOne?: Maybe<UploadReviewRequests>;
  /** insert data into the table: "user_auth_identities" */
  insertUserAuthIdentities?: Maybe<UserAuthIdentitiesMutationResponse>;
  /** insert a single row into the table: "user_auth_identities" */
  insertUserAuthIdentitiesOne?: Maybe<UserAuthIdentities>;
  /** insert data into the table: "user_blocks" */
  insertUserBlocks?: Maybe<UserBlocksMutationResponse>;
  /** insert a single row into the table: "user_blocks" */
  insertUserBlocksOne?: Maybe<UserBlocks>;
  /** insert data into the table: "user_coach_services" */
  insertUserCoachServices?: Maybe<UserCoachServicesMutationResponse>;
  /** insert a single row into the table: "user_coach_services" */
  insertUserCoachServicesOne?: Maybe<UserCoachServices>;
  /** insert data into the table: "user_communication_preferences" */
  insertUserCommunicationPreferences?: Maybe<UserCommunicationPreferencesMutationResponse>;
  /** insert a single row into the table: "user_communication_preferences" */
  insertUserCommunicationPreferencesOne?: Maybe<UserCommunicationPreferences>;
  /** insert data into the table: "user_connection_request_statuses" */
  insertUserConnectionRequestStatuses?: Maybe<UserConnectionRequestStatusesMutationResponse>;
  /** insert a single row into the table: "user_connection_request_statuses" */
  insertUserConnectionRequestStatusesOne?: Maybe<UserConnectionRequestStatuses>;
  /** insert data into the table: "user_connection_requests" */
  insertUserConnectionRequests?: Maybe<UserConnectionRequestsMutationResponse>;
  /** insert a single row into the table: "user_connection_requests" */
  insertUserConnectionRequestsOne?: Maybe<UserConnectionRequests>;
  /** insert data into the table: "user_connections" */
  insertUserConnections?: Maybe<UserConnectionsMutationResponse>;
  /** insert a single row into the table: "user_connections" */
  insertUserConnectionsOne?: Maybe<UserConnections>;
  /** insert data into the table: "user_content_beta_subscriptions" */
  insertUserContentBetaSubscriptions?: Maybe<UserContentBetaSubscriptionsMutationResponse>;
  /** insert a single row into the table: "user_content_beta_subscriptions" */
  insertUserContentBetaSubscriptionsOne?: Maybe<UserContentBetaSubscriptions>;
  /** insert data into the table: "user_content_files" */
  insertUserContentFiles?: Maybe<UserContentFilesMutationResponse>;
  /** insert a single row into the table: "user_content_files" */
  insertUserContentFilesOne?: Maybe<UserContentFiles>;
  /** insert data into the table: "user_content_files_skills" */
  insertUserContentFilesSkills?: Maybe<UserContentFilesSkillsMutationResponse>;
  /** insert a single row into the table: "user_content_files_skills" */
  insertUserContentFilesSkillsOne?: Maybe<UserContentFilesSkills>;
  /** insert data into the table: "user_content_skills" */
  insertUserContentSkills?: Maybe<UserContentSkillsMutationResponse>;
  /** insert a single row into the table: "user_content_skills" */
  insertUserContentSkillsOne?: Maybe<UserContentSkills>;
  /** insert data into the table: "user_content_tiers" */
  insertUserContentTiers?: Maybe<UserContentTiersMutationResponse>;
  /** insert a single row into the table: "user_content_tiers" */
  insertUserContentTiersOne?: Maybe<UserContentTiers>;
  /** insert data into the table: "user_credit_cards" */
  insertUserCreditCards?: Maybe<UserCreditCardsMutationResponse>;
  /** insert a single row into the table: "user_credit_cards" */
  insertUserCreditCardsOne?: Maybe<UserCreditCards>;
  /** insert data into the table: "user_custom_courts" */
  insertUserCustomCourts?: Maybe<UserCustomCourtsMutationResponse>;
  /** insert a single row into the table: "user_custom_courts" */
  insertUserCustomCourtsOne?: Maybe<UserCustomCourts>;
  /** insert data into the table: "user_files" */
  insertUserFiles?: Maybe<UserFilesMutationResponse>;
  /** insert a single row into the table: "user_files" */
  insertUserFilesOne?: Maybe<UserFiles>;
  /** insert data into the table: "user_follows" */
  insertUserFollows?: Maybe<UserFollowsMutationResponse>;
  /** insert a single row into the table: "user_follows" */
  insertUserFollowsOne?: Maybe<UserFollows>;
  /** insert data into the table: "user_identity_verifications" */
  insertUserIdentityVerifications?: Maybe<UserIdentityVerificationsMutationResponse>;
  /** insert a single row into the table: "user_identity_verifications" */
  insertUserIdentityVerificationsOne?: Maybe<UserIdentityVerifications>;
  /** insert data into the table: "user_image_log" */
  insertUserImageLog?: Maybe<UserImageLogMutationResponse>;
  /** insert a single row into the table: "user_image_log" */
  insertUserImageLogOne?: Maybe<UserImageLog>;
  /** insert data into the table: "user_notification_details" */
  insertUserNotificationDetails?: Maybe<UserNotificationDetailsMutationResponse>;
  /** insert a single row into the table: "user_notification_details" */
  insertUserNotificationDetailsOne?: Maybe<UserNotificationDetails>;
  /** insert data into the table: "user_notification_entities" */
  insertUserNotificationEntities?: Maybe<UserNotificationEntitiesMutationResponse>;
  /** insert a single row into the table: "user_notification_entities" */
  insertUserNotificationEntitiesOne?: Maybe<UserNotificationEntities>;
  /** insert data into the table: "user_notifications" */
  insertUserNotifications?: Maybe<UserNotificationsMutationResponse>;
  /** insert a single row into the table: "user_notifications" */
  insertUserNotificationsOne?: Maybe<UserNotifications>;
  /** insert data into the table: "user_padel_rating_scales" */
  insertUserPadelRatingScales?: Maybe<UserPadelRatingScalesMutationResponse>;
  /** insert a single row into the table: "user_padel_rating_scales" */
  insertUserPadelRatingScalesOne?: Maybe<UserPadelRatingScales>;
  /** insert data into the table: "user_pickleball_rating_scales" */
  insertUserPickleballRatingScales?: Maybe<UserPickleballRatingScalesMutationResponse>;
  /** insert a single row into the table: "user_pickleball_rating_scales" */
  insertUserPickleballRatingScalesOne?: Maybe<UserPickleballRatingScales>;
  /** insert data into the table: "user_played_with_dismissals" */
  insertUserPlayedWithDismissals?: Maybe<UserPlayedWithDismissalsMutationResponse>;
  /** insert a single row into the table: "user_played_with_dismissals" */
  insertUserPlayedWithDismissalsOne?: Maybe<UserPlayedWithDismissals>;
  /** insert data into the table: "user_player_finder_availability" */
  insertUserPlayerFinderAvailability?: Maybe<UserPlayerFinderAvailabilityMutationResponse>;
  /** insert a single row into the table: "user_player_finder_availability" */
  insertUserPlayerFinderAvailabilityOne?: Maybe<UserPlayerFinderAvailability>;
  /** insert data into the table: "user_player_finder_goals" */
  insertUserPlayerFinderGoals?: Maybe<UserPlayerFinderGoalsMutationResponse>;
  /** insert a single row into the table: "user_player_finder_goals" */
  insertUserPlayerFinderGoalsOne?: Maybe<UserPlayerFinderGoals>;
  /** insert data into the table: "user_profiles" */
  insertUserProfiles?: Maybe<UserProfilesMutationResponse>;
  /** insert a single row into the table: "user_profiles" */
  insertUserProfilesOne?: Maybe<UserProfiles>;
  /** insert data into the table: "user_registration_details" */
  insertUserRegistrationDetails?: Maybe<UserRegistrationDetailsMutationResponse>;
  /** insert a single row into the table: "user_registration_details" */
  insertUserRegistrationDetailsOne?: Maybe<UserRegistrationDetails>;
  /** insert data into the table: "user_sports" */
  insertUserSports?: Maybe<UserSportsMutationResponse>;
  /** insert a single row into the table: "user_sports" */
  insertUserSportsOne?: Maybe<UserSports>;
  /** insert data into the table: "user_tennis_rating_scales" */
  insertUserTennisRatingScales?: Maybe<UserTennisRatingScalesMutationResponse>;
  /** insert a single row into the table: "user_tennis_rating_scales" */
  insertUserTennisRatingScalesOne?: Maybe<UserTennisRatingScales>;
  /** insert data into the table: "user_terms_of_service" */
  insertUserTermsOfService?: Maybe<UserTermsOfServiceMutationResponse>;
  /** insert a single row into the table: "user_terms_of_service" */
  insertUserTermsOfServiceOne?: Maybe<UserTermsOfService>;
  /** insert data into the table: "user_vair_connections" */
  insertUserVairConnections?: Maybe<UserVairConnectionsMutationResponse>;
  /** insert a single row into the table: "user_vair_connections" */
  insertUserVairConnectionsOne?: Maybe<UserVairConnections>;
  /** insert data into the table: "username_logs" */
  insertUsernameLogs?: Maybe<UsernameLogsMutationResponse>;
  /** insert a single row into the table: "username_logs" */
  insertUsernameLogsOne?: Maybe<UsernameLogs>;
  /** insert data into the table: "usernames_active" */
  insertUsernamesActive?: Maybe<UsernamesActiveMutationResponse>;
  /** insert a single row into the table: "usernames_active" */
  insertUsernamesActiveOne?: Maybe<UsernamesActive>;
  /** insert data into the table: "usernames_claimed" */
  insertUsernamesClaimed?: Maybe<UsernamesClaimedMutationResponse>;
  /** insert a single row into the table: "usernames_claimed" */
  insertUsernamesClaimedOne?: Maybe<UsernamesClaimed>;
  /** insert data into the table: "users" */
  insertUsers?: Maybe<UsersMutationResponse>;
  /** insert data into the table: "users_coach_qualifications" */
  insertUsersCoachQualifications?: Maybe<UsersCoachQualificationsMutationResponse>;
  /** insert a single row into the table: "users_coach_qualifications" */
  insertUsersCoachQualificationsOne?: Maybe<UsersCoachQualifications>;
  /** insert a single row into the table: "users" */
  insertUsersOne?: Maybe<Users>;
  /** insert data into the table: "venue_access_types" */
  insertVenueAccessTypes?: Maybe<VenueAccessTypesMutationResponse>;
  /** insert a single row into the table: "venue_access_types" */
  insertVenueAccessTypesOne?: Maybe<VenueAccessTypes>;
  /** insert data into the table: "venue_admin_claim_statuses" */
  insertVenueAdminClaimStatuses?: Maybe<VenueAdminClaimStatusesMutationResponse>;
  /** insert a single row into the table: "venue_admin_claim_statuses" */
  insertVenueAdminClaimStatusesOne?: Maybe<VenueAdminClaimStatuses>;
  /** insert data into the table: "venue_admin_claims" */
  insertVenueAdminClaims?: Maybe<VenueAdminClaimsMutationResponse>;
  /** insert a single row into the table: "venue_admin_claims" */
  insertVenueAdminClaimsOne?: Maybe<VenueAdminClaims>;
  /** insert data into the table: "venue_amenities" */
  insertVenueAmenities?: Maybe<VenueAmenitiesMutationResponse>;
  /** insert a single row into the table: "venue_amenities" */
  insertVenueAmenitiesOne?: Maybe<VenueAmenities>;
  /** insert data into the table: "venue_booking_config_versions" */
  insertVenueBookingConfigVersions?: Maybe<VenueBookingConfigVersionsMutationResponse>;
  /** insert a single row into the table: "venue_booking_config_versions" */
  insertVenueBookingConfigVersionsOne?: Maybe<VenueBookingConfigVersions>;
  /** insert data into the table: "venue_booking_connection_check_statuses" */
  insertVenueBookingConnectionCheckStatuses?: Maybe<VenueBookingConnectionCheckStatusesMutationResponse>;
  /** insert a single row into the table: "venue_booking_connection_check_statuses" */
  insertVenueBookingConnectionCheckStatusesOne?: Maybe<VenueBookingConnectionCheckStatuses>;
  /** insert data into the table: "venue_booking_connection_checks" */
  insertVenueBookingConnectionChecks?: Maybe<VenueBookingConnectionChecksMutationResponse>;
  /** insert a single row into the table: "venue_booking_connection_checks" */
  insertVenueBookingConnectionChecksOne?: Maybe<VenueBookingConnectionChecks>;
  /** insert data into the table: "venue_booking_court_rates" */
  insertVenueBookingCourtRates?: Maybe<VenueBookingCourtRatesMutationResponse>;
  /** insert a single row into the table: "venue_booking_court_rates" */
  insertVenueBookingCourtRatesOne?: Maybe<VenueBookingCourtRates>;
  /** insert data into the table: "venue_booking_integrations" */
  insertVenueBookingIntegrations?: Maybe<VenueBookingIntegrationsMutationResponse>;
  /** insert a single row into the table: "venue_booking_integrations" */
  insertVenueBookingIntegrationsOne?: Maybe<VenueBookingIntegrations>;
  /** insert data into the table: "venue_booking_rule_tiers" */
  insertVenueBookingRuleTiers?: Maybe<VenueBookingRuleTiersMutationResponse>;
  /** insert a single row into the table: "venue_booking_rule_tiers" */
  insertVenueBookingRuleTiersOne?: Maybe<VenueBookingRuleTiers>;
  /** insert data into the table: "venue_booking_rules" */
  insertVenueBookingRules?: Maybe<VenueBookingRulesMutationResponse>;
  /** insert a single row into the table: "venue_booking_rules" */
  insertVenueBookingRulesOne?: Maybe<VenueBookingRules>;
  /** insert data into the table: "venue_booking_windows" */
  insertVenueBookingWindows?: Maybe<VenueBookingWindowsMutationResponse>;
  /** insert a single row into the table: "venue_booking_windows" */
  insertVenueBookingWindowsOne?: Maybe<VenueBookingWindows>;
  /** insert data into the table: "venue_court_surfaces" */
  insertVenueCourtSurfaces?: Maybe<VenueCourtSurfacesMutationResponse>;
  /** insert a single row into the table: "venue_court_surfaces" */
  insertVenueCourtSurfacesOne?: Maybe<VenueCourtSurfaces>;
  /** insert data into the table: "venue_custom_amenities" */
  insertVenueCustomAmenities?: Maybe<VenueCustomAmenitiesMutationResponse>;
  /** insert a single row into the table: "venue_custom_amenities" */
  insertVenueCustomAmenitiesOne?: Maybe<VenueCustomAmenities>;
  /** insert data into the table: "venue_equipment" */
  insertVenueEquipment?: Maybe<VenueEquipmentMutationResponse>;
  /** insert a single row into the table: "venue_equipment" */
  insertVenueEquipmentOne?: Maybe<VenueEquipment>;
  /** insert data into the table: "venue_facility_types" */
  insertVenueFacilityTypes?: Maybe<VenueFacilityTypesMutationResponse>;
  /** insert a single row into the table: "venue_facility_types" */
  insertVenueFacilityTypesOne?: Maybe<VenueFacilityTypes>;
  /** insert data into the table: "venue_faqs" */
  insertVenueFaqs?: Maybe<VenueFaqsMutationResponse>;
  /** insert a single row into the table: "venue_faqs" */
  insertVenueFaqsOne?: Maybe<VenueFaqs>;
  /** insert data into the table: "venue_follows" */
  insertVenueFollows?: Maybe<VenueFollowsMutationResponse>;
  /** insert a single row into the table: "venue_follows" */
  insertVenueFollowsOne?: Maybe<VenueFollows>;
  /** insert data into the table: "venue_images" */
  insertVenueImages?: Maybe<VenueImagesMutationResponse>;
  /** insert a single row into the table: "venue_images" */
  insertVenueImagesOne?: Maybe<VenueImages>;
  /** insert data into the table: "venue_lines" */
  insertVenueLines?: Maybe<VenueLinesMutationResponse>;
  /** insert a single row into the table: "venue_lines" */
  insertVenueLinesOne?: Maybe<VenueLines>;
  /** insert data into the table: "venue_nets" */
  insertVenueNets?: Maybe<VenueNetsMutationResponse>;
  /** insert a single row into the table: "venue_nets" */
  insertVenueNetsOne?: Maybe<VenueNets>;
  /** insert data into the table: "venue_partner_booking_statuses" */
  insertVenuePartnerBookingStatuses?: Maybe<VenuePartnerBookingStatusesMutationResponse>;
  /** insert a single row into the table: "venue_partner_booking_statuses" */
  insertVenuePartnerBookingStatusesOne?: Maybe<VenuePartnerBookingStatuses>;
  /** insert data into the table: "venue_staff_coaches" */
  insertVenueStaffCoaches?: Maybe<VenueStaffCoachesMutationResponse>;
  /** insert a single row into the table: "venue_staff_coaches" */
  insertVenueStaffCoachesOne?: Maybe<VenueStaffCoaches>;
  /** insert data into the table: "venues" */
  insertVenues?: Maybe<VenuesMutationResponse>;
  /** insert a single row into the table: "venues" */
  insertVenuesOne?: Maybe<Venues>;
  /** insert data into the table: "video_analysis" */
  insertVideoAnalysis?: Maybe<VideoAnalysisMutationResponse>;
  /** insert data into the table: "video_analysis_comments" */
  insertVideoAnalysisComments?: Maybe<VideoAnalysisCommentsMutationResponse>;
  /** insert a single row into the table: "video_analysis_comments" */
  insertVideoAnalysisCommentsOne?: Maybe<VideoAnalysisComments>;
  /** insert data into the table: "video_analysis_files" */
  insertVideoAnalysisFiles?: Maybe<VideoAnalysisFilesMutationResponse>;
  /** insert a single row into the table: "video_analysis_files" */
  insertVideoAnalysisFilesOne?: Maybe<VideoAnalysisFiles>;
  /** insert data into the table: "video_analysis_files_upload_statuses" */
  insertVideoAnalysisFilesUploadStatuses?: Maybe<VideoAnalysisFilesUploadStatusesMutationResponse>;
  /** insert a single row into the table: "video_analysis_files_upload_statuses" */
  insertVideoAnalysisFilesUploadStatusesOne?: Maybe<VideoAnalysisFilesUploadStatuses>;
  /** insert a single row into the table: "video_analysis" */
  insertVideoAnalysisOne?: Maybe<VideoAnalysis>;
  /** insert data into the table: "video_analysis_order_items" */
  insertVideoAnalysisOrderItems?: Maybe<VideoAnalysisOrderItemsMutationResponse>;
  /** insert a single row into the table: "video_analysis_order_items" */
  insertVideoAnalysisOrderItemsOne?: Maybe<VideoAnalysisOrderItems>;
  /** insert data into the table: "video_analysis_orders" */
  insertVideoAnalysisOrders?: Maybe<VideoAnalysisOrdersMutationResponse>;
  /** insert a single row into the table: "video_analysis_orders" */
  insertVideoAnalysisOrdersOne?: Maybe<VideoAnalysisOrders>;
  /** insert data into the table: "video_analysis_requested_skills_review" */
  insertVideoAnalysisRequestedSkillsReview?: Maybe<VideoAnalysisRequestedSkillsReviewMutationResponse>;
  /** insert a single row into the table: "video_analysis_requested_skills_review" */
  insertVideoAnalysisRequestedSkillsReviewOne?: Maybe<VideoAnalysisRequestedSkillsReview>;
  /** insert data into the table: "video_analysis_review_statuses" */
  insertVideoAnalysisReviewStatuses?: Maybe<VideoAnalysisReviewStatusesMutationResponse>;
  /** insert a single row into the table: "video_analysis_review_statuses" */
  insertVideoAnalysisReviewStatusesOne?: Maybe<VideoAnalysisReviewStatuses>;
  /** insert data into the table: "video_analysis_skills_comments" */
  insertVideoAnalysisSkillsComments?: Maybe<VideoAnalysisSkillsCommentsMutationResponse>;
  /** insert a single row into the table: "video_analysis_skills_comments" */
  insertVideoAnalysisSkillsCommentsOne?: Maybe<VideoAnalysisSkillsComments>;
  /** insert data into the table: "video_analysis_submission_log" */
  insertVideoAnalysisSubmissionLog?: Maybe<VideoAnalysisSubmissionLogMutationResponse>;
  /** insert a single row into the table: "video_analysis_submission_log" */
  insertVideoAnalysisSubmissionLogOne?: Maybe<VideoAnalysisSubmissionLog>;
  /** insert data into the table: "video_lesson_skills" */
  insertVideoLessonSkills?: Maybe<VideoLessonSkillsMutationResponse>;
  /** insert a single row into the table: "video_lesson_skills" */
  insertVideoLessonSkillsOne?: Maybe<VideoLessonSkills>;
  /** insert data into the table: "welcome_email_configuration" */
  insertWelcomeEmailConfiguration?: Maybe<WelcomeEmailConfigurationMutationResponse>;
  /** insert a single row into the table: "welcome_email_configuration" */
  insertWelcomeEmailConfigurationOne?: Maybe<WelcomeEmailConfiguration>;
  /** insert data into the table: "win_reasons" */
  insertWinReasons?: Maybe<WinReasonsMutationResponse>;
  /** insert a single row into the table: "win_reasons" */
  insertWinReasonsOne?: Maybe<WinReasons>;
  /** update data of the table: "amenities" */
  updateAmenities?: Maybe<AmenitiesMutationResponse>;
  /** update single row of the table: "amenities" */
  updateAmenitiesByPk?: Maybe<Amenities>;
  /** update multiples rows of table: "amenities" */
  updateAmenitiesMany?: Maybe<Array<Maybe<AmenitiesMutationResponse>>>;
  /** update data of the table: "app_personas" */
  updateAppPersonas?: Maybe<AppPersonasMutationResponse>;
  /** update single row of the table: "app_personas" */
  updateAppPersonasByPk?: Maybe<AppPersonas>;
  /** update multiples rows of table: "app_personas" */
  updateAppPersonasMany?: Maybe<Array<Maybe<AppPersonasMutationResponse>>>;
  /** update data of the table: "app_pings" */
  updateAppPings?: Maybe<AppPingsMutationResponse>;
  /** update single row of the table: "app_pings" */
  updateAppPingsByPk?: Maybe<AppPings>;
  /** update multiples rows of table: "app_pings" */
  updateAppPingsMany?: Maybe<Array<Maybe<AppPingsMutationResponse>>>;
  /** update data of the table: "ball_types" */
  updateBallTypes?: Maybe<BallTypesMutationResponse>;
  /** update single row of the table: "ball_types" */
  updateBallTypesByPk?: Maybe<BallTypes>;
  /** update multiples rows of table: "ball_types" */
  updateBallTypesMany?: Maybe<Array<Maybe<BallTypesMutationResponse>>>;
  /** update data of the table: "birthday_visibility" */
  updateBirthdayVisibility?: Maybe<BirthdayVisibilityMutationResponse>;
  /** update single row of the table: "birthday_visibility" */
  updateBirthdayVisibilityByPk?: Maybe<BirthdayVisibility>;
  /** update multiples rows of table: "birthday_visibility" */
  updateBirthdayVisibilityMany?: Maybe<Array<Maybe<BirthdayVisibilityMutationResponse>>>;
  /** update data of the table: "booking_config_change_types" */
  updateBookingConfigChangeTypes?: Maybe<BookingConfigChangeTypesMutationResponse>;
  /** update single row of the table: "booking_config_change_types" */
  updateBookingConfigChangeTypesByPk?: Maybe<BookingConfigChangeTypes>;
  /** update multiples rows of table: "booking_config_change_types" */
  updateBookingConfigChangeTypesMany?: Maybe<Array<Maybe<BookingConfigChangeTypesMutationResponse>>>;
  /** update data of the table: "booking_connection_statuses" */
  updateBookingConnectionStatuses?: Maybe<BookingConnectionStatusesMutationResponse>;
  /** update single row of the table: "booking_connection_statuses" */
  updateBookingConnectionStatusesByPk?: Maybe<BookingConnectionStatuses>;
  /** update multiples rows of table: "booking_connection_statuses" */
  updateBookingConnectionStatusesMany?: Maybe<Array<Maybe<BookingConnectionStatusesMutationResponse>>>;
  /** update data of the table: "booking_integration_statuses" */
  updateBookingIntegrationStatuses?: Maybe<BookingIntegrationStatusesMutationResponse>;
  /** update single row of the table: "booking_integration_statuses" */
  updateBookingIntegrationStatusesByPk?: Maybe<BookingIntegrationStatuses>;
  /** update multiples rows of table: "booking_integration_statuses" */
  updateBookingIntegrationStatusesMany?: Maybe<Array<Maybe<BookingIntegrationStatusesMutationResponse>>>;
  /** update data of the table: "booking_inventory_types" */
  updateBookingInventoryTypes?: Maybe<BookingInventoryTypesMutationResponse>;
  /** update single row of the table: "booking_inventory_types" */
  updateBookingInventoryTypesByPk?: Maybe<BookingInventoryTypes>;
  /** update multiples rows of table: "booking_inventory_types" */
  updateBookingInventoryTypesMany?: Maybe<Array<Maybe<BookingInventoryTypesMutationResponse>>>;
  /** update data of the table: "booking_schedule_modes" */
  updateBookingScheduleModes?: Maybe<BookingScheduleModesMutationResponse>;
  /** update single row of the table: "booking_schedule_modes" */
  updateBookingScheduleModesByPk?: Maybe<BookingScheduleModes>;
  /** update multiples rows of table: "booking_schedule_modes" */
  updateBookingScheduleModesMany?: Maybe<Array<Maybe<BookingScheduleModesMutationResponse>>>;
  /** update data of the table: "booking_systems" */
  updateBookingSystems?: Maybe<BookingSystemsMutationResponse>;
  /** update single row of the table: "booking_systems" */
  updateBookingSystemsByPk?: Maybe<BookingSystems>;
  /** update multiples rows of table: "booking_systems" */
  updateBookingSystemsMany?: Maybe<Array<Maybe<BookingSystemsMutationResponse>>>;
  /** update data of the table: "booking_window_kinds" */
  updateBookingWindowKinds?: Maybe<BookingWindowKindsMutationResponse>;
  /** update single row of the table: "booking_window_kinds" */
  updateBookingWindowKindsByPk?: Maybe<BookingWindowKinds>;
  /** update multiples rows of table: "booking_window_kinds" */
  updateBookingWindowKindsMany?: Maybe<Array<Maybe<BookingWindowKindsMutationResponse>>>;
  /** update data of the table: "boost_channels" */
  updateBoostChannels?: Maybe<BoostChannelsMutationResponse>;
  /** update single row of the table: "boost_channels" */
  updateBoostChannelsByPk?: Maybe<BoostChannels>;
  /** update multiples rows of table: "boost_channels" */
  updateBoostChannelsMany?: Maybe<Array<Maybe<BoostChannelsMutationResponse>>>;
  /** update data of the table: "boost_orders" */
  updateBoostOrders?: Maybe<BoostOrdersMutationResponse>;
  /** update single row of the table: "boost_orders" */
  updateBoostOrdersByPk?: Maybe<BoostOrders>;
  /** update multiples rows of table: "boost_orders" */
  updateBoostOrdersMany?: Maybe<Array<Maybe<BoostOrdersMutationResponse>>>;
  /** update data of the table: "boost_statuses" */
  updateBoostStatuses?: Maybe<BoostStatusesMutationResponse>;
  /** update single row of the table: "boost_statuses" */
  updateBoostStatusesByPk?: Maybe<BoostStatuses>;
  /** update multiples rows of table: "boost_statuses" */
  updateBoostStatusesMany?: Maybe<Array<Maybe<BoostStatusesMutationResponse>>>;
  /** update data of the table: "boosts" */
  updateBoosts?: Maybe<BoostsMutationResponse>;
  /** update single row of the table: "boosts" */
  updateBoostsByPk?: Maybe<Boosts>;
  /** update multiples rows of table: "boosts" */
  updateBoostsMany?: Maybe<Array<Maybe<BoostsMutationResponse>>>;
  /** update data of the table: "bracket_ranking_mechanism" */
  updateBracketRankingMechanism?: Maybe<BracketRankingMechanismMutationResponse>;
  /** update single row of the table: "bracket_ranking_mechanism" */
  updateBracketRankingMechanismByPk?: Maybe<BracketRankingMechanism>;
  /** update multiples rows of table: "bracket_ranking_mechanism" */
  updateBracketRankingMechanismMany?: Maybe<Array<Maybe<BracketRankingMechanismMutationResponse>>>;
  /** update data of the table: "calendar_accounts" */
  updateCalendarAccounts?: Maybe<CalendarAccountsMutationResponse>;
  /** update single row of the table: "calendar_accounts" */
  updateCalendarAccountsByPk?: Maybe<CalendarAccounts>;
  /** update multiples rows of table: "calendar_accounts" */
  updateCalendarAccountsMany?: Maybe<Array<Maybe<CalendarAccountsMutationResponse>>>;
  /** update data of the table: "calendar_auth_provider" */
  updateCalendarAuthProvider?: Maybe<CalendarAuthProviderMutationResponse>;
  /** update single row of the table: "calendar_auth_provider" */
  updateCalendarAuthProviderByPk?: Maybe<CalendarAuthProvider>;
  /** update multiples rows of table: "calendar_auth_provider" */
  updateCalendarAuthProviderMany?: Maybe<Array<Maybe<CalendarAuthProviderMutationResponse>>>;
  /** update data of the table: "calendar_event_mappings" */
  updateCalendarEventMappings?: Maybe<CalendarEventMappingsMutationResponse>;
  /** update single row of the table: "calendar_event_mappings" */
  updateCalendarEventMappingsByPk?: Maybe<CalendarEventMappings>;
  /** update multiples rows of table: "calendar_event_mappings" */
  updateCalendarEventMappingsMany?: Maybe<Array<Maybe<CalendarEventMappingsMutationResponse>>>;
  /** update data of the table: "calendar_preferences" */
  updateCalendarPreferences?: Maybe<CalendarPreferencesMutationResponse>;
  /** update single row of the table: "calendar_preferences" */
  updateCalendarPreferencesByPk?: Maybe<CalendarPreferences>;
  /** update multiples rows of table: "calendar_preferences" */
  updateCalendarPreferencesMany?: Maybe<Array<Maybe<CalendarPreferencesMutationResponse>>>;
  /** update data of the table: "cities" */
  updateCities?: Maybe<CitiesMutationResponse>;
  /** update single row of the table: "cities" */
  updateCitiesByPk?: Maybe<Cities>;
  /** update multiples rows of table: "cities" */
  updateCitiesMany?: Maybe<Array<Maybe<CitiesMutationResponse>>>;
  /** update data of the table: "coach_availability" */
  updateCoachAvailability?: Maybe<CoachAvailabilityMutationResponse>;
  /** update single row of the table: "coach_availability" */
  updateCoachAvailabilityByPk?: Maybe<CoachAvailability>;
  /** update multiples rows of table: "coach_availability" */
  updateCoachAvailabilityMany?: Maybe<Array<Maybe<CoachAvailabilityMutationResponse>>>;
  /** update data of the table: "coach_availability_statuses" */
  updateCoachAvailabilityStatuses?: Maybe<CoachAvailabilityStatusesMutationResponse>;
  /** update single row of the table: "coach_availability_statuses" */
  updateCoachAvailabilityStatusesByPk?: Maybe<CoachAvailabilityStatuses>;
  /** update multiples rows of table: "coach_availability_statuses" */
  updateCoachAvailabilityStatusesMany?: Maybe<Array<Maybe<CoachAvailabilityStatusesMutationResponse>>>;
  /** update data of the table: "coach_booking_requests" */
  updateCoachBookingRequests?: Maybe<CoachBookingRequestsMutationResponse>;
  /** update single row of the table: "coach_booking_requests" */
  updateCoachBookingRequestsByPk?: Maybe<CoachBookingRequests>;
  /** update multiples rows of table: "coach_booking_requests" */
  updateCoachBookingRequestsMany?: Maybe<Array<Maybe<CoachBookingRequestsMutationResponse>>>;
  /** update data of the table: "coach_external_review_sources" */
  updateCoachExternalReviewSources?: Maybe<CoachExternalReviewSourcesMutationResponse>;
  /** update single row of the table: "coach_external_review_sources" */
  updateCoachExternalReviewSourcesByPk?: Maybe<CoachExternalReviewSources>;
  /** update multiples rows of table: "coach_external_review_sources" */
  updateCoachExternalReviewSourcesMany?: Maybe<Array<Maybe<CoachExternalReviewSourcesMutationResponse>>>;
  /** update data of the table: "coach_faqs" */
  updateCoachFaqs?: Maybe<CoachFaqsMutationResponse>;
  /** update single row of the table: "coach_faqs" */
  updateCoachFaqsByPk?: Maybe<CoachFaqs>;
  /** update multiples rows of table: "coach_faqs" */
  updateCoachFaqsMany?: Maybe<Array<Maybe<CoachFaqsMutationResponse>>>;
  /** update data of the table: "coach_lesson_age_groups" */
  updateCoachLessonAgeGroups?: Maybe<CoachLessonAgeGroupsMutationResponse>;
  /** update single row of the table: "coach_lesson_age_groups" */
  updateCoachLessonAgeGroupsByPk?: Maybe<CoachLessonAgeGroups>;
  /** update multiples rows of table: "coach_lesson_age_groups" */
  updateCoachLessonAgeGroupsMany?: Maybe<Array<Maybe<CoachLessonAgeGroupsMutationResponse>>>;
  /** update data of the table: "coach_lesson_skill_levels" */
  updateCoachLessonSkillLevels?: Maybe<CoachLessonSkillLevelsMutationResponse>;
  /** update single row of the table: "coach_lesson_skill_levels" */
  updateCoachLessonSkillLevelsByPk?: Maybe<CoachLessonSkillLevels>;
  /** update multiples rows of table: "coach_lesson_skill_levels" */
  updateCoachLessonSkillLevelsMany?: Maybe<Array<Maybe<CoachLessonSkillLevelsMutationResponse>>>;
  /** update data of the table: "coach_qualification_groups" */
  updateCoachQualificationGroups?: Maybe<CoachQualificationGroupsMutationResponse>;
  /** update single row of the table: "coach_qualification_groups" */
  updateCoachQualificationGroupsByPk?: Maybe<CoachQualificationGroups>;
  /** update multiples rows of table: "coach_qualification_groups" */
  updateCoachQualificationGroupsMany?: Maybe<Array<Maybe<CoachQualificationGroupsMutationResponse>>>;
  /** update data of the table: "coach_qualification_statuses" */
  updateCoachQualificationStatuses?: Maybe<CoachQualificationStatusesMutationResponse>;
  /** update single row of the table: "coach_qualification_statuses" */
  updateCoachQualificationStatusesByPk?: Maybe<CoachQualificationStatuses>;
  /** update multiples rows of table: "coach_qualification_statuses" */
  updateCoachQualificationStatusesMany?: Maybe<Array<Maybe<CoachQualificationStatusesMutationResponse>>>;
  /** update data of the table: "coach_qualifications" */
  updateCoachQualifications?: Maybe<CoachQualificationsMutationResponse>;
  /** update single row of the table: "coach_qualifications" */
  updateCoachQualificationsByPk?: Maybe<CoachQualifications>;
  /** update multiples rows of table: "coach_qualifications" */
  updateCoachQualificationsMany?: Maybe<Array<Maybe<CoachQualificationsMutationResponse>>>;
  /** update data of the table: "coach_review_types" */
  updateCoachReviewTypes?: Maybe<CoachReviewTypesMutationResponse>;
  /** update single row of the table: "coach_review_types" */
  updateCoachReviewTypesByPk?: Maybe<CoachReviewTypes>;
  /** update multiples rows of table: "coach_review_types" */
  updateCoachReviewTypesMany?: Maybe<Array<Maybe<CoachReviewTypesMutationResponse>>>;
  /** update data of the table: "coach_sport_statuses" */
  updateCoachSportStatuses?: Maybe<CoachSportStatusesMutationResponse>;
  /** update single row of the table: "coach_sport_statuses" */
  updateCoachSportStatusesByPk?: Maybe<CoachSportStatuses>;
  /** update multiples rows of table: "coach_sport_statuses" */
  updateCoachSportStatusesMany?: Maybe<Array<Maybe<CoachSportStatusesMutationResponse>>>;
  /** update data of the table: "coach_sports" */
  updateCoachSports?: Maybe<CoachSportsMutationResponse>;
  /** update single row of the table: "coach_sports" */
  updateCoachSportsByPk?: Maybe<CoachSports>;
  /** update multiples rows of table: "coach_sports" */
  updateCoachSportsMany?: Maybe<Array<Maybe<CoachSportsMutationResponse>>>;
  /** update data of the table: "coach_starter_profiles" */
  updateCoachStarterProfiles?: Maybe<CoachStarterProfilesMutationResponse>;
  /** update single row of the table: "coach_starter_profiles" */
  updateCoachStarterProfilesByPk?: Maybe<CoachStarterProfiles>;
  /** update multiples rows of table: "coach_starter_profiles" */
  updateCoachStarterProfilesMany?: Maybe<Array<Maybe<CoachStarterProfilesMutationResponse>>>;
  /** update data of the table: "coach_status" */
  updateCoachStatus?: Maybe<CoachStatusMutationResponse>;
  /** update single row of the table: "coach_status" */
  updateCoachStatusByPk?: Maybe<CoachStatus>;
  /** update multiples rows of table: "coach_status" */
  updateCoachStatusMany?: Maybe<Array<Maybe<CoachStatusMutationResponse>>>;
  /** update data of the table: "coach_tips" */
  updateCoachTips?: Maybe<CoachTipsMutationResponse>;
  /** update single row of the table: "coach_tips" */
  updateCoachTipsByPk?: Maybe<CoachTips>;
  /** update multiples rows of table: "coach_tips" */
  updateCoachTipsMany?: Maybe<Array<Maybe<CoachTipsMutationResponse>>>;
  /** update data of the table: "comment_vote" */
  updateCommentVote?: Maybe<CommentVoteMutationResponse>;
  /** update single row of the table: "comment_vote" */
  updateCommentVoteByPk?: Maybe<CommentVote>;
  /** update multiples rows of table: "comment_vote" */
  updateCommentVoteMany?: Maybe<Array<Maybe<CommentVoteMutationResponse>>>;
  /** update data of the table: "communication_preference_statuses" */
  updateCommunicationPreferenceStatuses?: Maybe<CommunicationPreferenceStatusesMutationResponse>;
  /** update single row of the table: "communication_preference_statuses" */
  updateCommunicationPreferenceStatusesByPk?: Maybe<CommunicationPreferenceStatuses>;
  /** update multiples rows of table: "communication_preference_statuses" */
  updateCommunicationPreferenceStatusesMany?: Maybe<Array<Maybe<CommunicationPreferenceStatusesMutationResponse>>>;
  /** update data of the table: "competition_formats" */
  updateCompetitionFormats?: Maybe<CompetitionFormatsMutationResponse>;
  /** update single row of the table: "competition_formats" */
  updateCompetitionFormatsByPk?: Maybe<CompetitionFormats>;
  /** update multiples rows of table: "competition_formats" */
  updateCompetitionFormatsMany?: Maybe<Array<Maybe<CompetitionFormatsMutationResponse>>>;
  /** update data of the table: "competition_gender" */
  updateCompetitionGender?: Maybe<CompetitionGenderMutationResponse>;
  /** update single row of the table: "competition_gender" */
  updateCompetitionGenderByPk?: Maybe<CompetitionGender>;
  /** update multiples rows of table: "competition_gender" */
  updateCompetitionGenderMany?: Maybe<Array<Maybe<CompetitionGenderMutationResponse>>>;
  /** update data of the table: "content_reports" */
  updateContentReports?: Maybe<ContentReportsMutationResponse>;
  /** update single row of the table: "content_reports" */
  updateContentReportsByPk?: Maybe<ContentReports>;
  /** update multiples rows of table: "content_reports" */
  updateContentReportsMany?: Maybe<Array<Maybe<ContentReportsMutationResponse>>>;
  /** update data of the table: "conversation_participants" */
  updateConversationParticipants?: Maybe<ConversationParticipantsMutationResponse>;
  /** update single row of the table: "conversation_participants" */
  updateConversationParticipantsByPk?: Maybe<ConversationParticipants>;
  /** update multiples rows of table: "conversation_participants" */
  updateConversationParticipantsMany?: Maybe<Array<Maybe<ConversationParticipantsMutationResponse>>>;
  /** update data of the table: "conversation_types" */
  updateConversationTypes?: Maybe<ConversationTypesMutationResponse>;
  /** update single row of the table: "conversation_types" */
  updateConversationTypesByPk?: Maybe<ConversationTypes>;
  /** update multiples rows of table: "conversation_types" */
  updateConversationTypesMany?: Maybe<Array<Maybe<ConversationTypesMutationResponse>>>;
  /** update data of the table: "conversations" */
  updateConversations?: Maybe<ConversationsMutationResponse>;
  /** update single row of the table: "conversations" */
  updateConversationsByPk?: Maybe<Conversations>;
  /** update multiples rows of table: "conversations" */
  updateConversationsMany?: Maybe<Array<Maybe<ConversationsMutationResponse>>>;
  /** update data of the table: "countries" */
  updateCountries?: Maybe<CountriesMutationResponse>;
  /** update single row of the table: "countries" */
  updateCountriesByPk?: Maybe<Countries>;
  /** update multiples rows of table: "countries" */
  updateCountriesMany?: Maybe<Array<Maybe<CountriesMutationResponse>>>;
  /** update data of the table: "country_subdivisions" */
  updateCountrySubdivisions?: Maybe<CountrySubdivisionsMutationResponse>;
  /** update single row of the table: "country_subdivisions" */
  updateCountrySubdivisionsByPk?: Maybe<CountrySubdivisions>;
  /** update multiples rows of table: "country_subdivisions" */
  updateCountrySubdivisionsMany?: Maybe<Array<Maybe<CountrySubdivisionsMutationResponse>>>;
  /** update data of the table: "court_surfaces" */
  updateCourtSurfaces?: Maybe<CourtSurfacesMutationResponse>;
  /** update single row of the table: "court_surfaces" */
  updateCourtSurfacesByPk?: Maybe<CourtSurfaces>;
  /** update multiples rows of table: "court_surfaces" */
  updateCourtSurfacesMany?: Maybe<Array<Maybe<CourtSurfacesMutationResponse>>>;
  /** update data of the table: "day_of_week" */
  updateDayOfWeek?: Maybe<DayOfWeekMutationResponse>;
  /** update single row of the table: "day_of_week" */
  updateDayOfWeekByPk?: Maybe<DayOfWeek>;
  /** update multiples rows of table: "day_of_week" */
  updateDayOfWeekMany?: Maybe<Array<Maybe<DayOfWeekMutationResponse>>>;
  /** update data of the table: "engagement_analytics" */
  updateEngagementAnalytics?: Maybe<EngagementAnalyticsMutationResponse>;
  /** update single row of the table: "engagement_analytics" */
  updateEngagementAnalyticsByPk?: Maybe<EngagementAnalytics>;
  /** update multiples rows of table: "engagement_analytics" */
  updateEngagementAnalyticsMany?: Maybe<Array<Maybe<EngagementAnalyticsMutationResponse>>>;
  /** update data of the table: "engagement_entity_types" */
  updateEngagementEntityTypes?: Maybe<EngagementEntityTypesMutationResponse>;
  /** update single row of the table: "engagement_entity_types" */
  updateEngagementEntityTypesByPk?: Maybe<EngagementEntityTypes>;
  /** update multiples rows of table: "engagement_entity_types" */
  updateEngagementEntityTypesMany?: Maybe<Array<Maybe<EngagementEntityTypesMutationResponse>>>;
  /** update data of the table: "engagement_event_types" */
  updateEngagementEventTypes?: Maybe<EngagementEventTypesMutationResponse>;
  /** update single row of the table: "engagement_event_types" */
  updateEngagementEventTypesByPk?: Maybe<EngagementEventTypes>;
  /** update multiples rows of table: "engagement_event_types" */
  updateEngagementEventTypesMany?: Maybe<Array<Maybe<EngagementEventTypesMutationResponse>>>;
  /** update data of the table: "engagement_sources" */
  updateEngagementSources?: Maybe<EngagementSourcesMutationResponse>;
  /** update single row of the table: "engagement_sources" */
  updateEngagementSourcesByPk?: Maybe<EngagementSources>;
  /** update multiples rows of table: "engagement_sources" */
  updateEngagementSourcesMany?: Maybe<Array<Maybe<EngagementSourcesMutationResponse>>>;
  /** update data of the table: "equipment_availabilities" */
  updateEquipmentAvailabilities?: Maybe<EquipmentAvailabilitiesMutationResponse>;
  /** update single row of the table: "equipment_availabilities" */
  updateEquipmentAvailabilitiesByPk?: Maybe<EquipmentAvailabilities>;
  /** update multiples rows of table: "equipment_availabilities" */
  updateEquipmentAvailabilitiesMany?: Maybe<Array<Maybe<EquipmentAvailabilitiesMutationResponse>>>;
  /** update data of the table: "event_accepted_play_requests" */
  updateEventAcceptedPlayRequests?: Maybe<EventAcceptedPlayRequestsMutationResponse>;
  /** update multiples rows of table: "event_accepted_play_requests" */
  updateEventAcceptedPlayRequestsMany?: Maybe<Array<Maybe<EventAcceptedPlayRequestsMutationResponse>>>;
  /** update data of the table: "event_age_groups" */
  updateEventAgeGroups?: Maybe<EventAgeGroupsMutationResponse>;
  /** update single row of the table: "event_age_groups" */
  updateEventAgeGroupsByPk?: Maybe<EventAgeGroups>;
  /** update multiples rows of table: "event_age_groups" */
  updateEventAgeGroupsMany?: Maybe<Array<Maybe<EventAgeGroupsMutationResponse>>>;
  /** update data of the table: "event_collections" */
  updateEventCollections?: Maybe<EventCollectionsMutationResponse>;
  /** update single row of the table: "event_collections" */
  updateEventCollectionsByPk?: Maybe<EventCollections>;
  /** update multiples rows of table: "event_collections" */
  updateEventCollectionsMany?: Maybe<Array<Maybe<EventCollectionsMutationResponse>>>;
  /** update data of the table: "event_competitiveness" */
  updateEventCompetitiveness?: Maybe<EventCompetitivenessMutationResponse>;
  /** update single row of the table: "event_competitiveness" */
  updateEventCompetitivenessByPk?: Maybe<EventCompetitiveness>;
  /** update multiples rows of table: "event_competitiveness" */
  updateEventCompetitivenessMany?: Maybe<Array<Maybe<EventCompetitivenessMutationResponse>>>;
  /** update data of the table: "event_contact_details" */
  updateEventContactDetails?: Maybe<EventContactDetailsMutationResponse>;
  /** update single row of the table: "event_contact_details" */
  updateEventContactDetailsByPk?: Maybe<EventContactDetails>;
  /** update multiples rows of table: "event_contact_details" */
  updateEventContactDetailsMany?: Maybe<Array<Maybe<EventContactDetailsMutationResponse>>>;
  /** update data of the table: "event_coupon_groups" */
  updateEventCouponGroups?: Maybe<EventCouponGroupsMutationResponse>;
  /** update single row of the table: "event_coupon_groups" */
  updateEventCouponGroupsByPk?: Maybe<EventCouponGroups>;
  /** update multiples rows of table: "event_coupon_groups" */
  updateEventCouponGroupsMany?: Maybe<Array<Maybe<EventCouponGroupsMutationResponse>>>;
  /** update data of the table: "event_coupon_redemptions" */
  updateEventCouponRedemptions?: Maybe<EventCouponRedemptionsMutationResponse>;
  /** update single row of the table: "event_coupon_redemptions" */
  updateEventCouponRedemptionsByPk?: Maybe<EventCouponRedemptions>;
  /** update multiples rows of table: "event_coupon_redemptions" */
  updateEventCouponRedemptionsMany?: Maybe<Array<Maybe<EventCouponRedemptionsMutationResponse>>>;
  /** update data of the table: "event_coupon_source" */
  updateEventCouponSource?: Maybe<EventCouponSourceMutationResponse>;
  /** update single row of the table: "event_coupon_source" */
  updateEventCouponSourceByPk?: Maybe<EventCouponSource>;
  /** update multiples rows of table: "event_coupon_source" */
  updateEventCouponSourceMany?: Maybe<Array<Maybe<EventCouponSourceMutationResponse>>>;
  /** update data of the table: "event_coupon_type" */
  updateEventCouponType?: Maybe<EventCouponTypeMutationResponse>;
  /** update single row of the table: "event_coupon_type" */
  updateEventCouponTypeByPk?: Maybe<EventCouponType>;
  /** update multiples rows of table: "event_coupon_type" */
  updateEventCouponTypeMany?: Maybe<Array<Maybe<EventCouponTypeMutationResponse>>>;
  /** update data of the table: "event_coupons" */
  updateEventCoupons?: Maybe<EventCouponsMutationResponse>;
  /** update single row of the table: "event_coupons" */
  updateEventCouponsByPk?: Maybe<EventCoupons>;
  /** update multiples rows of table: "event_coupons" */
  updateEventCouponsMany?: Maybe<Array<Maybe<EventCouponsMutationResponse>>>;
  /** update data of the table: "event_court_statuses" */
  updateEventCourtStatuses?: Maybe<EventCourtStatusesMutationResponse>;
  /** update single row of the table: "event_court_statuses" */
  updateEventCourtStatusesByPk?: Maybe<EventCourtStatuses>;
  /** update multiples rows of table: "event_court_statuses" */
  updateEventCourtStatusesMany?: Maybe<Array<Maybe<EventCourtStatusesMutationResponse>>>;
  /** update data of the table: "event_courts" */
  updateEventCourts?: Maybe<EventCourtsMutationResponse>;
  /** update single row of the table: "event_courts" */
  updateEventCourtsByPk?: Maybe<EventCourts>;
  /** update multiples rows of table: "event_courts" */
  updateEventCourtsMany?: Maybe<Array<Maybe<EventCourtsMutationResponse>>>;
  /** update data of the table: "event_faqs" */
  updateEventFaqs?: Maybe<EventFaqsMutationResponse>;
  /** update single row of the table: "event_faqs" */
  updateEventFaqsByPk?: Maybe<EventFaqs>;
  /** update multiples rows of table: "event_faqs" */
  updateEventFaqsMany?: Maybe<Array<Maybe<EventFaqsMutationResponse>>>;
  /** update data of the table: "event_game_scores" */
  updateEventGameScores?: Maybe<EventGameScoresMutationResponse>;
  /** update single row of the table: "event_game_scores" */
  updateEventGameScoresByPk?: Maybe<EventGameScores>;
  /** update multiples rows of table: "event_game_scores" */
  updateEventGameScoresMany?: Maybe<Array<Maybe<EventGameScoresMutationResponse>>>;
  /** update data of the table: "event_group_formats" */
  updateEventGroupFormats?: Maybe<EventGroupFormatsMutationResponse>;
  /** update single row of the table: "event_group_formats" */
  updateEventGroupFormatsByPk?: Maybe<EventGroupFormats>;
  /** update multiples rows of table: "event_group_formats" */
  updateEventGroupFormatsMany?: Maybe<Array<Maybe<EventGroupFormatsMutationResponse>>>;
  /** update data of the table: "event_group_merges" */
  updateEventGroupMerges?: Maybe<EventGroupMergesMutationResponse>;
  /** update single row of the table: "event_group_merges" */
  updateEventGroupMergesByPk?: Maybe<EventGroupMerges>;
  /** update multiples rows of table: "event_group_merges" */
  updateEventGroupMergesMany?: Maybe<Array<Maybe<EventGroupMergesMutationResponse>>>;
  /** update data of the table: "event_group_pools" */
  updateEventGroupPools?: Maybe<EventGroupPoolsMutationResponse>;
  /** update single row of the table: "event_group_pools" */
  updateEventGroupPoolsByPk?: Maybe<EventGroupPools>;
  /** update multiples rows of table: "event_group_pools" */
  updateEventGroupPoolsMany?: Maybe<Array<Maybe<EventGroupPoolsMutationResponse>>>;
  /** update data of the table: "event_group_rating_scales" */
  updateEventGroupRatingScales?: Maybe<EventGroupRatingScalesMutationResponse>;
  /** update single row of the table: "event_group_rating_scales" */
  updateEventGroupRatingScalesByPk?: Maybe<EventGroupRatingScales>;
  /** update multiples rows of table: "event_group_rating_scales" */
  updateEventGroupRatingScalesMany?: Maybe<Array<Maybe<EventGroupRatingScalesMutationResponse>>>;
  /** update data of the table: "event_group_registration_statuses" */
  updateEventGroupRegistrationStatuses?: Maybe<EventGroupRegistrationStatusesMutationResponse>;
  /** update single row of the table: "event_group_registration_statuses" */
  updateEventGroupRegistrationStatusesByPk?: Maybe<EventGroupRegistrationStatuses>;
  /** update multiples rows of table: "event_group_registration_statuses" */
  updateEventGroupRegistrationStatusesMany?: Maybe<Array<Maybe<EventGroupRegistrationStatusesMutationResponse>>>;
  /** update data of the table: "event_group_registrations" */
  updateEventGroupRegistrations?: Maybe<EventGroupRegistrationsMutationResponse>;
  /** update single row of the table: "event_group_registrations" */
  updateEventGroupRegistrationsByPk?: Maybe<EventGroupRegistrations>;
  /** update multiples rows of table: "event_group_registrations" */
  updateEventGroupRegistrationsMany?: Maybe<Array<Maybe<EventGroupRegistrationsMutationResponse>>>;
  /** update data of the table: "event_group_sequence_seeding" */
  updateEventGroupSequenceSeeding?: Maybe<EventGroupSequenceSeedingMutationResponse>;
  /** update single row of the table: "event_group_sequence_seeding" */
  updateEventGroupSequenceSeedingByPk?: Maybe<EventGroupSequenceSeeding>;
  /** update multiples rows of table: "event_group_sequence_seeding" */
  updateEventGroupSequenceSeedingMany?: Maybe<Array<Maybe<EventGroupSequenceSeedingMutationResponse>>>;
  /** update data of the table: "event_group_sequences" */
  updateEventGroupSequences?: Maybe<EventGroupSequencesMutationResponse>;
  /** update single row of the table: "event_group_sequences" */
  updateEventGroupSequencesByPk?: Maybe<EventGroupSequences>;
  /** update multiples rows of table: "event_group_sequences" */
  updateEventGroupSequencesMany?: Maybe<Array<Maybe<EventGroupSequencesMutationResponse>>>;
  /** update data of the table: "event_group_time_slots" */
  updateEventGroupTimeSlots?: Maybe<EventGroupTimeSlotsMutationResponse>;
  /** update single row of the table: "event_group_time_slots" */
  updateEventGroupTimeSlotsByPk?: Maybe<EventGroupTimeSlots>;
  /** update multiples rows of table: "event_group_time_slots" */
  updateEventGroupTimeSlotsMany?: Maybe<Array<Maybe<EventGroupTimeSlotsMutationResponse>>>;
  /** update data of the table: "event_groups" */
  updateEventGroups?: Maybe<EventGroupsMutationResponse>;
  /** update single row of the table: "event_groups" */
  updateEventGroupsByPk?: Maybe<EventGroups>;
  /** update multiples rows of table: "event_groups" */
  updateEventGroupsMany?: Maybe<Array<Maybe<EventGroupsMutationResponse>>>;
  /** update data of the table: "event_invitation_statuses" */
  updateEventInvitationStatuses?: Maybe<EventInvitationStatusesMutationResponse>;
  /** update single row of the table: "event_invitation_statuses" */
  updateEventInvitationStatusesByPk?: Maybe<EventInvitationStatuses>;
  /** update multiples rows of table: "event_invitation_statuses" */
  updateEventInvitationStatusesMany?: Maybe<Array<Maybe<EventInvitationStatusesMutationResponse>>>;
  /** update data of the table: "event_invitation_types" */
  updateEventInvitationTypes?: Maybe<EventInvitationTypesMutationResponse>;
  /** update single row of the table: "event_invitation_types" */
  updateEventInvitationTypesByPk?: Maybe<EventInvitationTypes>;
  /** update multiples rows of table: "event_invitation_types" */
  updateEventInvitationTypesMany?: Maybe<Array<Maybe<EventInvitationTypesMutationResponse>>>;
  /** update data of the table: "event_invitations" */
  updateEventInvitations?: Maybe<EventInvitationsMutationResponse>;
  /** update single row of the table: "event_invitations" */
  updateEventInvitationsByPk?: Maybe<EventInvitations>;
  /** update multiples rows of table: "event_invitations" */
  updateEventInvitationsMany?: Maybe<Array<Maybe<EventInvitationsMutationResponse>>>;
  /** update data of the table: "event_listing_fees" */
  updateEventListingFees?: Maybe<EventListingFeesMutationResponse>;
  /** update single row of the table: "event_listing_fees" */
  updateEventListingFeesByPk?: Maybe<EventListingFees>;
  /** update multiples rows of table: "event_listing_fees" */
  updateEventListingFeesMany?: Maybe<Array<Maybe<EventListingFeesMutationResponse>>>;
  /** update data of the table: "event_match_games" */
  updateEventMatchGames?: Maybe<EventMatchGamesMutationResponse>;
  /** update single row of the table: "event_match_games" */
  updateEventMatchGamesByPk?: Maybe<EventMatchGames>;
  /** update multiples rows of table: "event_match_games" */
  updateEventMatchGamesMany?: Maybe<Array<Maybe<EventMatchGamesMutationResponse>>>;
  /** update data of the table: "event_matches" */
  updateEventMatches?: Maybe<EventMatchesMutationResponse>;
  /** update single row of the table: "event_matches" */
  updateEventMatchesByPk?: Maybe<EventMatches>;
  /** update multiples rows of table: "event_matches" */
  updateEventMatchesMany?: Maybe<Array<Maybe<EventMatchesMutationResponse>>>;
  /** update data of the table: "event_matches_teams" */
  updateEventMatchesTeams?: Maybe<EventMatchesTeamsMutationResponse>;
  /** update single row of the table: "event_matches_teams" */
  updateEventMatchesTeamsByPk?: Maybe<EventMatchesTeams>;
  /** update multiples rows of table: "event_matches_teams" */
  updateEventMatchesTeamsMany?: Maybe<Array<Maybe<EventMatchesTeamsMutationResponse>>>;
  /** update data of the table: "event_organizer_account_types" */
  updateEventOrganizerAccountTypes?: Maybe<EventOrganizerAccountTypesMutationResponse>;
  /** update single row of the table: "event_organizer_account_types" */
  updateEventOrganizerAccountTypesByPk?: Maybe<EventOrganizerAccountTypes>;
  /** update multiples rows of table: "event_organizer_account_types" */
  updateEventOrganizerAccountTypesMany?: Maybe<Array<Maybe<EventOrganizerAccountTypesMutationResponse>>>;
  /** update data of the table: "event_player_invite_statuses" */
  updateEventPlayerInviteStatuses?: Maybe<EventPlayerInviteStatusesMutationResponse>;
  /** update single row of the table: "event_player_invite_statuses" */
  updateEventPlayerInviteStatusesByPk?: Maybe<EventPlayerInviteStatuses>;
  /** update multiples rows of table: "event_player_invite_statuses" */
  updateEventPlayerInviteStatusesMany?: Maybe<Array<Maybe<EventPlayerInviteStatusesMutationResponse>>>;
  /** update data of the table: "event_player_invites" */
  updateEventPlayerInvites?: Maybe<EventPlayerInvitesMutationResponse>;
  /** update single row of the table: "event_player_invites" */
  updateEventPlayerInvitesByPk?: Maybe<EventPlayerInvites>;
  /** update multiples rows of table: "event_player_invites" */
  updateEventPlayerInvitesMany?: Maybe<Array<Maybe<EventPlayerInvitesMutationResponse>>>;
  /** update data of the table: "event_pool_rounds" */
  updateEventPoolRounds?: Maybe<EventPoolRoundsMutationResponse>;
  /** update single row of the table: "event_pool_rounds" */
  updateEventPoolRoundsByPk?: Maybe<EventPoolRounds>;
  /** update multiples rows of table: "event_pool_rounds" */
  updateEventPoolRoundsMany?: Maybe<Array<Maybe<EventPoolRoundsMutationResponse>>>;
  /** update data of the table: "event_pools_teams" */
  updateEventPoolsTeams?: Maybe<EventPoolsTeamsMutationResponse>;
  /** update single row of the table: "event_pools_teams" */
  updateEventPoolsTeamsByPk?: Maybe<EventPoolsTeams>;
  /** update multiples rows of table: "event_pools_teams" */
  updateEventPoolsTeamsMany?: Maybe<Array<Maybe<EventPoolsTeamsMutationResponse>>>;
  /** update data of the table: "event_privacy" */
  updateEventPrivacy?: Maybe<EventPrivacyMutationResponse>;
  /** update single row of the table: "event_privacy" */
  updateEventPrivacyByPk?: Maybe<EventPrivacy>;
  /** update multiples rows of table: "event_privacy" */
  updateEventPrivacyMany?: Maybe<Array<Maybe<EventPrivacyMutationResponse>>>;
  /** update data of the table: "event_registration_details" */
  updateEventRegistrationDetails?: Maybe<EventRegistrationDetailsMutationResponse>;
  /** update single row of the table: "event_registration_details" */
  updateEventRegistrationDetailsByPk?: Maybe<EventRegistrationDetails>;
  /** update multiples rows of table: "event_registration_details" */
  updateEventRegistrationDetailsMany?: Maybe<Array<Maybe<EventRegistrationDetailsMutationResponse>>>;
  /** update data of the table: "event_registrations" */
  updateEventRegistrations?: Maybe<EventRegistrationsMutationResponse>;
  /** update single row of the table: "event_registrations" */
  updateEventRegistrationsByPk?: Maybe<EventRegistrations>;
  /** update multiples rows of table: "event_registrations" */
  updateEventRegistrationsMany?: Maybe<Array<Maybe<EventRegistrationsMutationResponse>>>;
  /** update data of the table: "event_sequence_complete_reasons" */
  updateEventSequenceCompleteReasons?: Maybe<EventSequenceCompleteReasonsMutationResponse>;
  /** update single row of the table: "event_sequence_complete_reasons" */
  updateEventSequenceCompleteReasonsByPk?: Maybe<EventSequenceCompleteReasons>;
  /** update multiples rows of table: "event_sequence_complete_reasons" */
  updateEventSequenceCompleteReasonsMany?: Maybe<Array<Maybe<EventSequenceCompleteReasonsMutationResponse>>>;
  /** update data of the table: "event_skill_levels" */
  updateEventSkillLevels?: Maybe<EventSkillLevelsMutationResponse>;
  /** update single row of the table: "event_skill_levels" */
  updateEventSkillLevelsByPk?: Maybe<EventSkillLevels>;
  /** update multiples rows of table: "event_skill_levels" */
  updateEventSkillLevelsMany?: Maybe<Array<Maybe<EventSkillLevelsMutationResponse>>>;
  /** update data of the table: "event_sponsors" */
  updateEventSponsors?: Maybe<EventSponsorsMutationResponse>;
  /** update single row of the table: "event_sponsors" */
  updateEventSponsorsByPk?: Maybe<EventSponsors>;
  /** update multiples rows of table: "event_sponsors" */
  updateEventSponsorsMany?: Maybe<Array<Maybe<EventSponsorsMutationResponse>>>;
  /** update data of the table: "event_statuses" */
  updateEventStatuses?: Maybe<EventStatusesMutationResponse>;
  /** update single row of the table: "event_statuses" */
  updateEventStatusesByPk?: Maybe<EventStatuses>;
  /** update multiples rows of table: "event_statuses" */
  updateEventStatusesMany?: Maybe<Array<Maybe<EventStatusesMutationResponse>>>;
  /** update data of the table: "event_team_member_statuses" */
  updateEventTeamMemberStatuses?: Maybe<EventTeamMemberStatusesMutationResponse>;
  /** update single row of the table: "event_team_member_statuses" */
  updateEventTeamMemberStatusesByPk?: Maybe<EventTeamMemberStatuses>;
  /** update multiples rows of table: "event_team_member_statuses" */
  updateEventTeamMemberStatusesMany?: Maybe<Array<Maybe<EventTeamMemberStatusesMutationResponse>>>;
  /** update data of the table: "event_team_members" */
  updateEventTeamMembers?: Maybe<EventTeamMembersMutationResponse>;
  /** update single row of the table: "event_team_members" */
  updateEventTeamMembersByPk?: Maybe<EventTeamMembers>;
  /** update multiples rows of table: "event_team_members" */
  updateEventTeamMembersMany?: Maybe<Array<Maybe<EventTeamMembersMutationResponse>>>;
  /** update data of the table: "event_team_statuses" */
  updateEventTeamStatuses?: Maybe<EventTeamStatusesMutationResponse>;
  /** update single row of the table: "event_team_statuses" */
  updateEventTeamStatusesByPk?: Maybe<EventTeamStatuses>;
  /** update multiples rows of table: "event_team_statuses" */
  updateEventTeamStatusesMany?: Maybe<Array<Maybe<EventTeamStatusesMutationResponse>>>;
  /** update data of the table: "event_teams" */
  updateEventTeams?: Maybe<EventTeamsMutationResponse>;
  /** update single row of the table: "event_teams" */
  updateEventTeamsByPk?: Maybe<EventTeams>;
  /** update multiples rows of table: "event_teams" */
  updateEventTeamsMany?: Maybe<Array<Maybe<EventTeamsMutationResponse>>>;
  /** update data of the table: "event_transaction_item_types" */
  updateEventTransactionItemTypes?: Maybe<EventTransactionItemTypesMutationResponse>;
  /** update single row of the table: "event_transaction_item_types" */
  updateEventTransactionItemTypesByPk?: Maybe<EventTransactionItemTypes>;
  /** update multiples rows of table: "event_transaction_item_types" */
  updateEventTransactionItemTypesMany?: Maybe<Array<Maybe<EventTransactionItemTypesMutationResponse>>>;
  /** update data of the table: "event_transaction_items" */
  updateEventTransactionItems?: Maybe<EventTransactionItemsMutationResponse>;
  /** update single row of the table: "event_transaction_items" */
  updateEventTransactionItemsByPk?: Maybe<EventTransactionItems>;
  /** update multiples rows of table: "event_transaction_items" */
  updateEventTransactionItemsMany?: Maybe<Array<Maybe<EventTransactionItemsMutationResponse>>>;
  /** update data of the table: "event_transactions" */
  updateEventTransactions?: Maybe<EventTransactionsMutationResponse>;
  /** update single row of the table: "event_transactions" */
  updateEventTransactionsByPk?: Maybe<EventTransactions>;
  /** update multiples rows of table: "event_transactions" */
  updateEventTransactionsMany?: Maybe<Array<Maybe<EventTransactionsMutationResponse>>>;
  /** update data of the table: "event_types" */
  updateEventTypes?: Maybe<EventTypesMutationResponse>;
  /** update single row of the table: "event_types" */
  updateEventTypesByPk?: Maybe<EventTypes>;
  /** update multiples rows of table: "event_types" */
  updateEventTypesMany?: Maybe<Array<Maybe<EventTypesMutationResponse>>>;
  /** update data of the table: "events" */
  updateEvents?: Maybe<EventsMutationResponse>;
  /** update single row of the table: "events" */
  updateEventsByPk?: Maybe<Events>;
  /** update multiples rows of table: "events" */
  updateEventsMany?: Maybe<Array<Maybe<EventsMutationResponse>>>;
  /** update data of the table: "feedback_sentiment" */
  updateFeedbackSentiment?: Maybe<FeedbackSentimentMutationResponse>;
  /** update single row of the table: "feedback_sentiment" */
  updateFeedbackSentimentByPk?: Maybe<FeedbackSentiment>;
  /** update multiples rows of table: "feedback_sentiment" */
  updateFeedbackSentimentMany?: Maybe<Array<Maybe<FeedbackSentimentMutationResponse>>>;
  /** update data of the table: "file_category" */
  updateFileCategory?: Maybe<FileCategoryMutationResponse>;
  /** update single row of the table: "file_category" */
  updateFileCategoryByPk?: Maybe<FileCategory>;
  /** update multiples rows of table: "file_category" */
  updateFileCategoryMany?: Maybe<Array<Maybe<FileCategoryMutationResponse>>>;
  /** update data of the table: "file_format" */
  updateFileFormat?: Maybe<FileFormatMutationResponse>;
  /** update single row of the table: "file_format" */
  updateFileFormatByPk?: Maybe<FileFormat>;
  /** update multiples rows of table: "file_format" */
  updateFileFormatMany?: Maybe<Array<Maybe<FileFormatMutationResponse>>>;
  /** update data of the table: "follow_statuses" */
  updateFollowStatuses?: Maybe<FollowStatusesMutationResponse>;
  /** update single row of the table: "follow_statuses" */
  updateFollowStatusesByPk?: Maybe<FollowStatuses>;
  /** update multiples rows of table: "follow_statuses" */
  updateFollowStatusesMany?: Maybe<Array<Maybe<FollowStatusesMutationResponse>>>;
  /** update data of the table: "game_net_statuses" */
  updateGameNetStatuses?: Maybe<GameNetStatusesMutationResponse>;
  /** update single row of the table: "game_net_statuses" */
  updateGameNetStatusesByPk?: Maybe<GameNetStatuses>;
  /** update multiples rows of table: "game_net_statuses" */
  updateGameNetStatusesMany?: Maybe<Array<Maybe<GameNetStatusesMutationResponse>>>;
  /** update data of the table: "gender" */
  updateGender?: Maybe<GenderMutationResponse>;
  /** update single row of the table: "gender" */
  updateGenderByPk?: Maybe<Gender>;
  /** update multiples rows of table: "gender" */
  updateGenderMany?: Maybe<Array<Maybe<GenderMutationResponse>>>;
  /** update data of the table: "group_comment_votes" */
  updateGroupCommentVotes?: Maybe<GroupCommentVotesMutationResponse>;
  /** update single row of the table: "group_comment_votes" */
  updateGroupCommentVotesByPk?: Maybe<GroupCommentVotes>;
  /** update multiples rows of table: "group_comment_votes" */
  updateGroupCommentVotesMany?: Maybe<Array<Maybe<GroupCommentVotesMutationResponse>>>;
  /** update data of the table: "group_members" */
  updateGroupMembers?: Maybe<GroupMembersMutationResponse>;
  /** update single row of the table: "group_members" */
  updateGroupMembersByPk?: Maybe<GroupMembers>;
  /** update multiples rows of table: "group_members" */
  updateGroupMembersMany?: Maybe<Array<Maybe<GroupMembersMutationResponse>>>;
  /** update data of the table: "group_thread_comment_files" */
  updateGroupThreadCommentFiles?: Maybe<GroupThreadCommentFilesMutationResponse>;
  /** update single row of the table: "group_thread_comment_files" */
  updateGroupThreadCommentFilesByPk?: Maybe<GroupThreadCommentFiles>;
  /** update multiples rows of table: "group_thread_comment_files" */
  updateGroupThreadCommentFilesMany?: Maybe<Array<Maybe<GroupThreadCommentFilesMutationResponse>>>;
  /** update data of the table: "group_thread_comments" */
  updateGroupThreadComments?: Maybe<GroupThreadCommentsMutationResponse>;
  /** update single row of the table: "group_thread_comments" */
  updateGroupThreadCommentsByPk?: Maybe<GroupThreadComments>;
  /** update multiples rows of table: "group_thread_comments" */
  updateGroupThreadCommentsMany?: Maybe<Array<Maybe<GroupThreadCommentsMutationResponse>>>;
  /** update data of the table: "group_threads" */
  updateGroupThreads?: Maybe<GroupThreadsMutationResponse>;
  /** update single row of the table: "group_threads" */
  updateGroupThreadsByPk?: Maybe<GroupThreads>;
  /** update multiples rows of table: "group_threads" */
  updateGroupThreadsMany?: Maybe<Array<Maybe<GroupThreadsMutationResponse>>>;
  /** update data of the table: "group_types" */
  updateGroupTypes?: Maybe<GroupTypesMutationResponse>;
  /** update single row of the table: "group_types" */
  updateGroupTypesByPk?: Maybe<GroupTypes>;
  /** update multiples rows of table: "group_types" */
  updateGroupTypesMany?: Maybe<Array<Maybe<GroupTypesMutationResponse>>>;
  /** update data of the table: "group_venues" */
  updateGroupVenues?: Maybe<GroupVenuesMutationResponse>;
  /** update single row of the table: "group_venues" */
  updateGroupVenuesByPk?: Maybe<GroupVenues>;
  /** update multiples rows of table: "group_venues" */
  updateGroupVenuesMany?: Maybe<Array<Maybe<GroupVenuesMutationResponse>>>;
  /** update data of the table: "groups" */
  updateGroups?: Maybe<GroupsMutationResponse>;
  /** update single row of the table: "groups" */
  updateGroupsByPk?: Maybe<Groups>;
  /** update multiples rows of table: "groups" */
  updateGroupsMany?: Maybe<Array<Maybe<GroupsMutationResponse>>>;
  /** update data of the table: "groups_play_sessions" */
  updateGroupsPlaySessions?: Maybe<GroupsPlaySessionsMutationResponse>;
  /** update single row of the table: "groups_play_sessions" */
  updateGroupsPlaySessionsByPk?: Maybe<GroupsPlaySessions>;
  /** update multiples rows of table: "groups_play_sessions" */
  updateGroupsPlaySessionsMany?: Maybe<Array<Maybe<GroupsPlaySessionsMutationResponse>>>;
  /** update data of the table: "identity_verification_providers" */
  updateIdentityVerificationProviders?: Maybe<IdentityVerificationProvidersMutationResponse>;
  /** update single row of the table: "identity_verification_providers" */
  updateIdentityVerificationProvidersByPk?: Maybe<IdentityVerificationProviders>;
  /** update multiples rows of table: "identity_verification_providers" */
  updateIdentityVerificationProvidersMany?: Maybe<Array<Maybe<IdentityVerificationProvidersMutationResponse>>>;
  /** update data of the table: "identity_verification_statuses" */
  updateIdentityVerificationStatuses?: Maybe<IdentityVerificationStatusesMutationResponse>;
  /** update single row of the table: "identity_verification_statuses" */
  updateIdentityVerificationStatusesByPk?: Maybe<IdentityVerificationStatuses>;
  /** update multiples rows of table: "identity_verification_statuses" */
  updateIdentityVerificationStatusesMany?: Maybe<Array<Maybe<IdentityVerificationStatusesMutationResponse>>>;
  /** update data of the table: "invoices" */
  updateInvoices?: Maybe<InvoicesMutationResponse>;
  /** update single row of the table: "invoices" */
  updateInvoicesByPk?: Maybe<Invoices>;
  /** update multiples rows of table: "invoices" */
  updateInvoicesMany?: Maybe<Array<Maybe<InvoicesMutationResponse>>>;
  /** update data of the table: "learning_program_enrollment_schedule_media_watched" */
  updateLearningProgramEnrollmentScheduleMediaWatched?: Maybe<LearningProgramEnrollmentScheduleMediaWatchedMutationResponse>;
  /** update single row of the table: "learning_program_enrollment_schedule_media_watched" */
  updateLearningProgramEnrollmentScheduleMediaWatchedByPk?: Maybe<LearningProgramEnrollmentScheduleMediaWatched>;
  /** update multiples rows of table: "learning_program_enrollment_schedule_media_watched" */
  updateLearningProgramEnrollmentScheduleMediaWatchedMany?: Maybe<Array<Maybe<LearningProgramEnrollmentScheduleMediaWatchedMutationResponse>>>;
  /** update data of the table: "learning_program_enrollment_schedule_progress" */
  updateLearningProgramEnrollmentScheduleProgress?: Maybe<LearningProgramEnrollmentScheduleProgressMutationResponse>;
  /** update single row of the table: "learning_program_enrollment_schedule_progress" */
  updateLearningProgramEnrollmentScheduleProgressByPk?: Maybe<LearningProgramEnrollmentScheduleProgress>;
  /** update multiples rows of table: "learning_program_enrollment_schedule_progress" */
  updateLearningProgramEnrollmentScheduleProgressMany?: Maybe<Array<Maybe<LearningProgramEnrollmentScheduleProgressMutationResponse>>>;
  /** update data of the table: "learning_program_enrollments" */
  updateLearningProgramEnrollments?: Maybe<LearningProgramEnrollmentsMutationResponse>;
  /** update single row of the table: "learning_program_enrollments" */
  updateLearningProgramEnrollmentsByPk?: Maybe<LearningProgramEnrollments>;
  /** update multiples rows of table: "learning_program_enrollments" */
  updateLearningProgramEnrollmentsMany?: Maybe<Array<Maybe<LearningProgramEnrollmentsMutationResponse>>>;
  /** update data of the table: "learning_program_media" */
  updateLearningProgramMedia?: Maybe<LearningProgramMediaMutationResponse>;
  /** update single row of the table: "learning_program_media" */
  updateLearningProgramMediaByPk?: Maybe<LearningProgramMedia>;
  /** update data of the table: "learning_program_media_categories" */
  updateLearningProgramMediaCategories?: Maybe<LearningProgramMediaCategoriesMutationResponse>;
  /** update single row of the table: "learning_program_media_categories" */
  updateLearningProgramMediaCategoriesByPk?: Maybe<LearningProgramMediaCategories>;
  /** update multiples rows of table: "learning_program_media_categories" */
  updateLearningProgramMediaCategoriesMany?: Maybe<Array<Maybe<LearningProgramMediaCategoriesMutationResponse>>>;
  /** update multiples rows of table: "learning_program_media" */
  updateLearningProgramMediaMany?: Maybe<Array<Maybe<LearningProgramMediaMutationResponse>>>;
  /** update data of the table: "learning_program_schedule_media" */
  updateLearningProgramScheduleMedia?: Maybe<LearningProgramScheduleMediaMutationResponse>;
  /** update single row of the table: "learning_program_schedule_media" */
  updateLearningProgramScheduleMediaByPk?: Maybe<LearningProgramScheduleMedia>;
  /** update multiples rows of table: "learning_program_schedule_media" */
  updateLearningProgramScheduleMediaMany?: Maybe<Array<Maybe<LearningProgramScheduleMediaMutationResponse>>>;
  /** update data of the table: "learning_program_schedule_units" */
  updateLearningProgramScheduleUnits?: Maybe<LearningProgramScheduleUnitsMutationResponse>;
  /** update single row of the table: "learning_program_schedule_units" */
  updateLearningProgramScheduleUnitsByPk?: Maybe<LearningProgramScheduleUnits>;
  /** update multiples rows of table: "learning_program_schedule_units" */
  updateLearningProgramScheduleUnitsMany?: Maybe<Array<Maybe<LearningProgramScheduleUnitsMutationResponse>>>;
  /** update data of the table: "learning_program_schedule_video_submissions" */
  updateLearningProgramScheduleVideoSubmissions?: Maybe<LearningProgramScheduleVideoSubmissionsMutationResponse>;
  /** update single row of the table: "learning_program_schedule_video_submissions" */
  updateLearningProgramScheduleVideoSubmissionsByPk?: Maybe<LearningProgramScheduleVideoSubmissions>;
  /** update multiples rows of table: "learning_program_schedule_video_submissions" */
  updateLearningProgramScheduleVideoSubmissionsMany?: Maybe<Array<Maybe<LearningProgramScheduleVideoSubmissionsMutationResponse>>>;
  /** update data of the table: "learning_program_schedules" */
  updateLearningProgramSchedules?: Maybe<LearningProgramSchedulesMutationResponse>;
  /** update single row of the table: "learning_program_schedules" */
  updateLearningProgramSchedulesByPk?: Maybe<LearningProgramSchedules>;
  /** update multiples rows of table: "learning_program_schedules" */
  updateLearningProgramSchedulesMany?: Maybe<Array<Maybe<LearningProgramSchedulesMutationResponse>>>;
  /** update data of the table: "learning_program_skill_level_values" */
  updateLearningProgramSkillLevelValues?: Maybe<LearningProgramSkillLevelValuesMutationResponse>;
  /** update single row of the table: "learning_program_skill_level_values" */
  updateLearningProgramSkillLevelValuesByPk?: Maybe<LearningProgramSkillLevelValues>;
  /** update multiples rows of table: "learning_program_skill_level_values" */
  updateLearningProgramSkillLevelValuesMany?: Maybe<Array<Maybe<LearningProgramSkillLevelValuesMutationResponse>>>;
  /** update data of the table: "learning_program_skills" */
  updateLearningProgramSkills?: Maybe<LearningProgramSkillsMutationResponse>;
  /** update single row of the table: "learning_program_skills" */
  updateLearningProgramSkillsByPk?: Maybe<LearningProgramSkills>;
  /** update multiples rows of table: "learning_program_skills" */
  updateLearningProgramSkillsMany?: Maybe<Array<Maybe<LearningProgramSkillsMutationResponse>>>;
  /** update data of the table: "learning_programs" */
  updateLearningPrograms?: Maybe<LearningProgramsMutationResponse>;
  /** update single row of the table: "learning_programs" */
  updateLearningProgramsByPk?: Maybe<LearningPrograms>;
  /** update multiples rows of table: "learning_programs" */
  updateLearningProgramsMany?: Maybe<Array<Maybe<LearningProgramsMutationResponse>>>;
  /** update data of the table: "lesson_age_groups" */
  updateLessonAgeGroups?: Maybe<LessonAgeGroupsMutationResponse>;
  /** update single row of the table: "lesson_age_groups" */
  updateLessonAgeGroupsByPk?: Maybe<LessonAgeGroups>;
  /** update multiples rows of table: "lesson_age_groups" */
  updateLessonAgeGroupsMany?: Maybe<Array<Maybe<LessonAgeGroupsMutationResponse>>>;
  /** update data of the table: "lesson_collections" */
  updateLessonCollections?: Maybe<LessonCollectionsMutationResponse>;
  /** update single row of the table: "lesson_collections" */
  updateLessonCollectionsByPk?: Maybe<LessonCollections>;
  /** update multiples rows of table: "lesson_collections" */
  updateLessonCollectionsMany?: Maybe<Array<Maybe<LessonCollectionsMutationResponse>>>;
  /** update data of the table: "lesson_equipment" */
  updateLessonEquipment?: Maybe<LessonEquipmentMutationResponse>;
  /** update single row of the table: "lesson_equipment" */
  updateLessonEquipmentByPk?: Maybe<LessonEquipment>;
  /** update multiples rows of table: "lesson_equipment" */
  updateLessonEquipmentMany?: Maybe<Array<Maybe<LessonEquipmentMutationResponse>>>;
  /** update data of the table: "lesson_equipment_options" */
  updateLessonEquipmentOptions?: Maybe<LessonEquipmentOptionsMutationResponse>;
  /** update single row of the table: "lesson_equipment_options" */
  updateLessonEquipmentOptionsByPk?: Maybe<LessonEquipmentOptions>;
  /** update multiples rows of table: "lesson_equipment_options" */
  updateLessonEquipmentOptionsMany?: Maybe<Array<Maybe<LessonEquipmentOptionsMutationResponse>>>;
  /** update data of the table: "lesson_order_items" */
  updateLessonOrderItems?: Maybe<LessonOrderItemsMutationResponse>;
  /** update single row of the table: "lesson_order_items" */
  updateLessonOrderItemsByPk?: Maybe<LessonOrderItems>;
  /** update multiples rows of table: "lesson_order_items" */
  updateLessonOrderItemsMany?: Maybe<Array<Maybe<LessonOrderItemsMutationResponse>>>;
  /** update data of the table: "lesson_orders" */
  updateLessonOrders?: Maybe<LessonOrdersMutationResponse>;
  /** update single row of the table: "lesson_orders" */
  updateLessonOrdersByPk?: Maybe<LessonOrders>;
  /** update multiples rows of table: "lesson_orders" */
  updateLessonOrdersMany?: Maybe<Array<Maybe<LessonOrdersMutationResponse>>>;
  /** update data of the table: "lesson_participant_statuses" */
  updateLessonParticipantStatuses?: Maybe<LessonParticipantStatusesMutationResponse>;
  /** update single row of the table: "lesson_participant_statuses" */
  updateLessonParticipantStatusesByPk?: Maybe<LessonParticipantStatuses>;
  /** update multiples rows of table: "lesson_participant_statuses" */
  updateLessonParticipantStatusesMany?: Maybe<Array<Maybe<LessonParticipantStatusesMutationResponse>>>;
  /** update data of the table: "lesson_participants" */
  updateLessonParticipants?: Maybe<LessonParticipantsMutationResponse>;
  /** update single row of the table: "lesson_participants" */
  updateLessonParticipantsByPk?: Maybe<LessonParticipants>;
  /** update multiples rows of table: "lesson_participants" */
  updateLessonParticipantsMany?: Maybe<Array<Maybe<LessonParticipantsMutationResponse>>>;
  /** update data of the table: "lesson_player_skill_assessment_categories" */
  updateLessonPlayerSkillAssessmentCategories?: Maybe<LessonPlayerSkillAssessmentCategoriesMutationResponse>;
  /** update single row of the table: "lesson_player_skill_assessment_categories" */
  updateLessonPlayerSkillAssessmentCategoriesByPk?: Maybe<LessonPlayerSkillAssessmentCategories>;
  /** update multiples rows of table: "lesson_player_skill_assessment_categories" */
  updateLessonPlayerSkillAssessmentCategoriesMany?: Maybe<Array<Maybe<LessonPlayerSkillAssessmentCategoriesMutationResponse>>>;
  /** update data of the table: "lesson_player_skill_assessments" */
  updateLessonPlayerSkillAssessments?: Maybe<LessonPlayerSkillAssessmentsMutationResponse>;
  /** update single row of the table: "lesson_player_skill_assessments" */
  updateLessonPlayerSkillAssessmentsByPk?: Maybe<LessonPlayerSkillAssessments>;
  /** update multiples rows of table: "lesson_player_skill_assessments" */
  updateLessonPlayerSkillAssessmentsMany?: Maybe<Array<Maybe<LessonPlayerSkillAssessmentsMutationResponse>>>;
  /** update data of the table: "lesson_player_skill_assessments_skills" */
  updateLessonPlayerSkillAssessmentsSkills?: Maybe<LessonPlayerSkillAssessmentsSkillsMutationResponse>;
  /** update single row of the table: "lesson_player_skill_assessments_skills" */
  updateLessonPlayerSkillAssessmentsSkillsByPk?: Maybe<LessonPlayerSkillAssessmentsSkills>;
  /** update multiples rows of table: "lesson_player_skill_assessments_skills" */
  updateLessonPlayerSkillAssessmentsSkillsMany?: Maybe<Array<Maybe<LessonPlayerSkillAssessmentsSkillsMutationResponse>>>;
  /** update data of the table: "lesson_privacy" */
  updateLessonPrivacy?: Maybe<LessonPrivacyMutationResponse>;
  /** update single row of the table: "lesson_privacy" */
  updateLessonPrivacyByPk?: Maybe<LessonPrivacy>;
  /** update multiples rows of table: "lesson_privacy" */
  updateLessonPrivacyMany?: Maybe<Array<Maybe<LessonPrivacyMutationResponse>>>;
  /** update data of the table: "lesson_reflection_comment_types" */
  updateLessonReflectionCommentTypes?: Maybe<LessonReflectionCommentTypesMutationResponse>;
  /** update single row of the table: "lesson_reflection_comment_types" */
  updateLessonReflectionCommentTypesByPk?: Maybe<LessonReflectionCommentTypes>;
  /** update multiples rows of table: "lesson_reflection_comment_types" */
  updateLessonReflectionCommentTypesMany?: Maybe<Array<Maybe<LessonReflectionCommentTypesMutationResponse>>>;
  /** update data of the table: "lesson_reflection_comments" */
  updateLessonReflectionComments?: Maybe<LessonReflectionCommentsMutationResponse>;
  /** update single row of the table: "lesson_reflection_comments" */
  updateLessonReflectionCommentsByPk?: Maybe<LessonReflectionComments>;
  /** update multiples rows of table: "lesson_reflection_comments" */
  updateLessonReflectionCommentsMany?: Maybe<Array<Maybe<LessonReflectionCommentsMutationResponse>>>;
  /** update data of the table: "lesson_reflection_files" */
  updateLessonReflectionFiles?: Maybe<LessonReflectionFilesMutationResponse>;
  /** update single row of the table: "lesson_reflection_files" */
  updateLessonReflectionFilesByPk?: Maybe<LessonReflectionFiles>;
  /** update multiples rows of table: "lesson_reflection_files" */
  updateLessonReflectionFilesMany?: Maybe<Array<Maybe<LessonReflectionFilesMutationResponse>>>;
  /** update data of the table: "lesson_reflections" */
  updateLessonReflections?: Maybe<LessonReflectionsMutationResponse>;
  /** update single row of the table: "lesson_reflections" */
  updateLessonReflectionsByPk?: Maybe<LessonReflections>;
  /** update multiples rows of table: "lesson_reflections" */
  updateLessonReflectionsMany?: Maybe<Array<Maybe<LessonReflectionsMutationResponse>>>;
  /** update data of the table: "lesson_skill_categories" */
  updateLessonSkillCategories?: Maybe<LessonSkillCategoriesMutationResponse>;
  /** update single row of the table: "lesson_skill_categories" */
  updateLessonSkillCategoriesByPk?: Maybe<LessonSkillCategories>;
  /** update multiples rows of table: "lesson_skill_categories" */
  updateLessonSkillCategoriesMany?: Maybe<Array<Maybe<LessonSkillCategoriesMutationResponse>>>;
  /** update data of the table: "lesson_skill_display_names" */
  updateLessonSkillDisplayNames?: Maybe<LessonSkillDisplayNamesMutationResponse>;
  /** update single row of the table: "lesson_skill_display_names" */
  updateLessonSkillDisplayNamesByPk?: Maybe<LessonSkillDisplayNames>;
  /** update multiples rows of table: "lesson_skill_display_names" */
  updateLessonSkillDisplayNamesMany?: Maybe<Array<Maybe<LessonSkillDisplayNamesMutationResponse>>>;
  /** update data of the table: "lesson_skill_levels" */
  updateLessonSkillLevels?: Maybe<LessonSkillLevelsMutationResponse>;
  /** update single row of the table: "lesson_skill_levels" */
  updateLessonSkillLevelsByPk?: Maybe<LessonSkillLevels>;
  /** update multiples rows of table: "lesson_skill_levels" */
  updateLessonSkillLevelsMany?: Maybe<Array<Maybe<LessonSkillLevelsMutationResponse>>>;
  /** update data of the table: "lesson_skill_mappings" */
  updateLessonSkillMappings?: Maybe<LessonSkillMappingsMutationResponse>;
  /** update single row of the table: "lesson_skill_mappings" */
  updateLessonSkillMappingsByPk?: Maybe<LessonSkillMappings>;
  /** update multiples rows of table: "lesson_skill_mappings" */
  updateLessonSkillMappingsMany?: Maybe<Array<Maybe<LessonSkillMappingsMutationResponse>>>;
  /** update data of the table: "lesson_skills" */
  updateLessonSkills?: Maybe<LessonSkillsMutationResponse>;
  /** update single row of the table: "lesson_skills" */
  updateLessonSkillsByPk?: Maybe<LessonSkills>;
  /** update multiples rows of table: "lesson_skills" */
  updateLessonSkillsMany?: Maybe<Array<Maybe<LessonSkillsMutationResponse>>>;
  /** update data of the table: "lesson_statuses" */
  updateLessonStatuses?: Maybe<LessonStatusesMutationResponse>;
  /** update single row of the table: "lesson_statuses" */
  updateLessonStatusesByPk?: Maybe<LessonStatuses>;
  /** update multiples rows of table: "lesson_statuses" */
  updateLessonStatusesMany?: Maybe<Array<Maybe<LessonStatusesMutationResponse>>>;
  /** update data of the table: "lesson_template_skill_levels" */
  updateLessonTemplateSkillLevels?: Maybe<LessonTemplateSkillLevelsMutationResponse>;
  /** update single row of the table: "lesson_template_skill_levels" */
  updateLessonTemplateSkillLevelsByPk?: Maybe<LessonTemplateSkillLevels>;
  /** update multiples rows of table: "lesson_template_skill_levels" */
  updateLessonTemplateSkillLevelsMany?: Maybe<Array<Maybe<LessonTemplateSkillLevelsMutationResponse>>>;
  /** update data of the table: "lesson_templates" */
  updateLessonTemplates?: Maybe<LessonTemplatesMutationResponse>;
  /** update single row of the table: "lesson_templates" */
  updateLessonTemplatesByPk?: Maybe<LessonTemplates>;
  /** update multiples rows of table: "lesson_templates" */
  updateLessonTemplatesMany?: Maybe<Array<Maybe<LessonTemplatesMutationResponse>>>;
  /** update data of the table: "lesson_times" */
  updateLessonTimes?: Maybe<LessonTimesMutationResponse>;
  /** update single row of the table: "lesson_times" */
  updateLessonTimesByPk?: Maybe<LessonTimes>;
  /** update multiples rows of table: "lesson_times" */
  updateLessonTimesMany?: Maybe<Array<Maybe<LessonTimesMutationResponse>>>;
  /** update data of the table: "lesson_types" */
  updateLessonTypes?: Maybe<LessonTypesMutationResponse>;
  /** update single row of the table: "lesson_types" */
  updateLessonTypesByPk?: Maybe<LessonTypes>;
  /** update multiples rows of table: "lesson_types" */
  updateLessonTypesMany?: Maybe<Array<Maybe<LessonTypesMutationResponse>>>;
  /** update data of the table: "lesson_waitlist_statuses" */
  updateLessonWaitlistStatuses?: Maybe<LessonWaitlistStatusesMutationResponse>;
  /** update single row of the table: "lesson_waitlist_statuses" */
  updateLessonWaitlistStatusesByPk?: Maybe<LessonWaitlistStatuses>;
  /** update multiples rows of table: "lesson_waitlist_statuses" */
  updateLessonWaitlistStatusesMany?: Maybe<Array<Maybe<LessonWaitlistStatusesMutationResponse>>>;
  /** update data of the table: "lesson_waitlists" */
  updateLessonWaitlists?: Maybe<LessonWaitlistsMutationResponse>;
  /** update single row of the table: "lesson_waitlists" */
  updateLessonWaitlistsByPk?: Maybe<LessonWaitlists>;
  /** update multiples rows of table: "lesson_waitlists" */
  updateLessonWaitlistsMany?: Maybe<Array<Maybe<LessonWaitlistsMutationResponse>>>;
  /** update data of the table: "lessons" */
  updateLessons?: Maybe<LessonsMutationResponse>;
  /** update single row of the table: "lessons" */
  updateLessonsByPk?: Maybe<Lessons>;
  /** update multiples rows of table: "lessons" */
  updateLessonsMany?: Maybe<Array<Maybe<LessonsMutationResponse>>>;
  /** update data of the table: "match_selection_criteria" */
  updateMatchSelectionCriteria?: Maybe<MatchSelectionCriteriaMutationResponse>;
  /** update single row of the table: "match_selection_criteria" */
  updateMatchSelectionCriteriaByPk?: Maybe<MatchSelectionCriteria>;
  /** update multiples rows of table: "match_selection_criteria" */
  updateMatchSelectionCriteriaMany?: Maybe<Array<Maybe<MatchSelectionCriteriaMutationResponse>>>;
  /** update data of the table: "messages" */
  updateMessages?: Maybe<MessagesMutationResponse>;
  /** update single row of the table: "messages" */
  updateMessagesByPk?: Maybe<Messages>;
  /** update multiples rows of table: "messages" */
  updateMessagesMany?: Maybe<Array<Maybe<MessagesMutationResponse>>>;
  /** update data of the table: "neighborhoods" */
  updateNeighborhoods?: Maybe<NeighborhoodsMutationResponse>;
  /** update single row of the table: "neighborhoods" */
  updateNeighborhoodsByPk?: Maybe<Neighborhoods>;
  /** update multiples rows of table: "neighborhoods" */
  updateNeighborhoodsMany?: Maybe<Array<Maybe<NeighborhoodsMutationResponse>>>;
  /** update data of the table: "notification_action_types" */
  updateNotificationActionTypes?: Maybe<NotificationActionTypesMutationResponse>;
  /** update single row of the table: "notification_action_types" */
  updateNotificationActionTypesByPk?: Maybe<NotificationActionTypes>;
  /** update multiples rows of table: "notification_action_types" */
  updateNotificationActionTypesMany?: Maybe<Array<Maybe<NotificationActionTypesMutationResponse>>>;
  /** update data of the table: "notification_statuses" */
  updateNotificationStatuses?: Maybe<NotificationStatusesMutationResponse>;
  /** update single row of the table: "notification_statuses" */
  updateNotificationStatusesByPk?: Maybe<NotificationStatuses>;
  /** update multiples rows of table: "notification_statuses" */
  updateNotificationStatusesMany?: Maybe<Array<Maybe<NotificationStatusesMutationResponse>>>;
  /** update data of the table: "order_statuses" */
  updateOrderStatuses?: Maybe<OrderStatusesMutationResponse>;
  /** update single row of the table: "order_statuses" */
  updateOrderStatusesByPk?: Maybe<OrderStatuses>;
  /** update multiples rows of table: "order_statuses" */
  updateOrderStatusesMany?: Maybe<Array<Maybe<OrderStatusesMutationResponse>>>;
  /** update data of the table: "padel_rating_scales" */
  updatePadelRatingScales?: Maybe<PadelRatingScalesMutationResponse>;
  /** update single row of the table: "padel_rating_scales" */
  updatePadelRatingScalesByPk?: Maybe<PadelRatingScales>;
  /** update multiples rows of table: "padel_rating_scales" */
  updatePadelRatingScalesMany?: Maybe<Array<Maybe<PadelRatingScalesMutationResponse>>>;
  /** update data of the table: "participant_roles" */
  updateParticipantRoles?: Maybe<ParticipantRolesMutationResponse>;
  /** update single row of the table: "participant_roles" */
  updateParticipantRolesByPk?: Maybe<ParticipantRoles>;
  /** update multiples rows of table: "participant_roles" */
  updateParticipantRolesMany?: Maybe<Array<Maybe<ParticipantRolesMutationResponse>>>;
  /** update data of the table: "partner_booking_attempt_events" */
  updatePartnerBookingAttemptEvents?: Maybe<PartnerBookingAttemptEventsMutationResponse>;
  /** update single row of the table: "partner_booking_attempt_events" */
  updatePartnerBookingAttemptEventsByPk?: Maybe<PartnerBookingAttemptEvents>;
  /** update multiples rows of table: "partner_booking_attempt_events" */
  updatePartnerBookingAttemptEventsMany?: Maybe<Array<Maybe<PartnerBookingAttemptEventsMutationResponse>>>;
  /** update data of the table: "partner_booking_attempt_statuses" */
  updatePartnerBookingAttemptStatuses?: Maybe<PartnerBookingAttemptStatusesMutationResponse>;
  /** update single row of the table: "partner_booking_attempt_statuses" */
  updatePartnerBookingAttemptStatusesByPk?: Maybe<PartnerBookingAttemptStatuses>;
  /** update multiples rows of table: "partner_booking_attempt_statuses" */
  updatePartnerBookingAttemptStatusesMany?: Maybe<Array<Maybe<PartnerBookingAttemptStatusesMutationResponse>>>;
  /** update data of the table: "partner_booking_attempts" */
  updatePartnerBookingAttempts?: Maybe<PartnerBookingAttemptsMutationResponse>;
  /** update single row of the table: "partner_booking_attempts" */
  updatePartnerBookingAttemptsByPk?: Maybe<PartnerBookingAttempts>;
  /** update multiples rows of table: "partner_booking_attempts" */
  updatePartnerBookingAttemptsMany?: Maybe<Array<Maybe<PartnerBookingAttemptsMutationResponse>>>;
  /** update data of the table: "partner_booking_engines" */
  updatePartnerBookingEngines?: Maybe<PartnerBookingEnginesMutationResponse>;
  /** update single row of the table: "partner_booking_engines" */
  updatePartnerBookingEnginesByPk?: Maybe<PartnerBookingEngines>;
  /** update multiples rows of table: "partner_booking_engines" */
  updatePartnerBookingEnginesMany?: Maybe<Array<Maybe<PartnerBookingEnginesMutationResponse>>>;
  /** update data of the table: "partner_booking_event_sources" */
  updatePartnerBookingEventSources?: Maybe<PartnerBookingEventSourcesMutationResponse>;
  /** update single row of the table: "partner_booking_event_sources" */
  updatePartnerBookingEventSourcesByPk?: Maybe<PartnerBookingEventSources>;
  /** update multiples rows of table: "partner_booking_event_sources" */
  updatePartnerBookingEventSourcesMany?: Maybe<Array<Maybe<PartnerBookingEventSourcesMutationResponse>>>;
  /** update data of the table: "partner_booking_holds" */
  updatePartnerBookingHolds?: Maybe<PartnerBookingHoldsMutationResponse>;
  /** update single row of the table: "partner_booking_holds" */
  updatePartnerBookingHoldsByPk?: Maybe<PartnerBookingHolds>;
  /** update multiples rows of table: "partner_booking_holds" */
  updatePartnerBookingHoldsMany?: Maybe<Array<Maybe<PartnerBookingHoldsMutationResponse>>>;
  /** update data of the table: "partner_booking_order_statuses" */
  updatePartnerBookingOrderStatuses?: Maybe<PartnerBookingOrderStatusesMutationResponse>;
  /** update single row of the table: "partner_booking_order_statuses" */
  updatePartnerBookingOrderStatusesByPk?: Maybe<PartnerBookingOrderStatuses>;
  /** update multiples rows of table: "partner_booking_order_statuses" */
  updatePartnerBookingOrderStatusesMany?: Maybe<Array<Maybe<PartnerBookingOrderStatusesMutationResponse>>>;
  /** update data of the table: "partner_booking_orders" */
  updatePartnerBookingOrders?: Maybe<PartnerBookingOrdersMutationResponse>;
  /** update single row of the table: "partner_booking_orders" */
  updatePartnerBookingOrdersByPk?: Maybe<PartnerBookingOrders>;
  /** update multiples rows of table: "partner_booking_orders" */
  updatePartnerBookingOrdersMany?: Maybe<Array<Maybe<PartnerBookingOrdersMutationResponse>>>;
  /** update data of the table: "partner_booking_verification_methods" */
  updatePartnerBookingVerificationMethods?: Maybe<PartnerBookingVerificationMethodsMutationResponse>;
  /** update single row of the table: "partner_booking_verification_methods" */
  updatePartnerBookingVerificationMethodsByPk?: Maybe<PartnerBookingVerificationMethods>;
  /** update multiples rows of table: "partner_booking_verification_methods" */
  updatePartnerBookingVerificationMethodsMany?: Maybe<Array<Maybe<PartnerBookingVerificationMethodsMutationResponse>>>;
  /** update data of the table: "payment_fulfillment_channels" */
  updatePaymentFulfillmentChannels?: Maybe<PaymentFulfillmentChannelsMutationResponse>;
  /** update single row of the table: "payment_fulfillment_channels" */
  updatePaymentFulfillmentChannelsByPk?: Maybe<PaymentFulfillmentChannels>;
  /** update multiples rows of table: "payment_fulfillment_channels" */
  updatePaymentFulfillmentChannelsMany?: Maybe<Array<Maybe<PaymentFulfillmentChannelsMutationResponse>>>;
  /** update data of the table: "payment_processors" */
  updatePaymentProcessors?: Maybe<PaymentProcessorsMutationResponse>;
  /** update single row of the table: "payment_processors" */
  updatePaymentProcessorsByPk?: Maybe<PaymentProcessors>;
  /** update multiples rows of table: "payment_processors" */
  updatePaymentProcessorsMany?: Maybe<Array<Maybe<PaymentProcessorsMutationResponse>>>;
  /** update data of the table: "payment_statuses" */
  updatePaymentStatuses?: Maybe<PaymentStatusesMutationResponse>;
  /** update single row of the table: "payment_statuses" */
  updatePaymentStatusesByPk?: Maybe<PaymentStatuses>;
  /** update multiples rows of table: "payment_statuses" */
  updatePaymentStatusesMany?: Maybe<Array<Maybe<PaymentStatusesMutationResponse>>>;
  /** update data of the table: "pickleball_rating_scales" */
  updatePickleballRatingScales?: Maybe<PickleballRatingScalesMutationResponse>;
  /** update single row of the table: "pickleball_rating_scales" */
  updatePickleballRatingScalesByPk?: Maybe<PickleballRatingScales>;
  /** update multiples rows of table: "pickleball_rating_scales" */
  updatePickleballRatingScalesMany?: Maybe<Array<Maybe<PickleballRatingScalesMutationResponse>>>;
  /** update data of the table: "platform_subscription_intervals" */
  updatePlatformSubscriptionIntervals?: Maybe<PlatformSubscriptionIntervalsMutationResponse>;
  /** update single row of the table: "platform_subscription_intervals" */
  updatePlatformSubscriptionIntervalsByPk?: Maybe<PlatformSubscriptionIntervals>;
  /** update multiples rows of table: "platform_subscription_intervals" */
  updatePlatformSubscriptionIntervalsMany?: Maybe<Array<Maybe<PlatformSubscriptionIntervalsMutationResponse>>>;
  /** update data of the table: "platform_subscription_personas" */
  updatePlatformSubscriptionPersonas?: Maybe<PlatformSubscriptionPersonasMutationResponse>;
  /** update single row of the table: "platform_subscription_personas" */
  updatePlatformSubscriptionPersonasByPk?: Maybe<PlatformSubscriptionPersonas>;
  /** update multiples rows of table: "platform_subscription_personas" */
  updatePlatformSubscriptionPersonasMany?: Maybe<Array<Maybe<PlatformSubscriptionPersonasMutationResponse>>>;
  /** update data of the table: "platform_subscription_plan_prices" */
  updatePlatformSubscriptionPlanPrices?: Maybe<PlatformSubscriptionPlanPricesMutationResponse>;
  /** update single row of the table: "platform_subscription_plan_prices" */
  updatePlatformSubscriptionPlanPricesByPk?: Maybe<PlatformSubscriptionPlanPrices>;
  /** update multiples rows of table: "platform_subscription_plan_prices" */
  updatePlatformSubscriptionPlanPricesMany?: Maybe<Array<Maybe<PlatformSubscriptionPlanPricesMutationResponse>>>;
  /** update data of the table: "platform_subscription_plans" */
  updatePlatformSubscriptionPlans?: Maybe<PlatformSubscriptionPlansMutationResponse>;
  /** update single row of the table: "platform_subscription_plans" */
  updatePlatformSubscriptionPlansByPk?: Maybe<PlatformSubscriptionPlans>;
  /** update multiples rows of table: "platform_subscription_plans" */
  updatePlatformSubscriptionPlansMany?: Maybe<Array<Maybe<PlatformSubscriptionPlansMutationResponse>>>;
  /** update data of the table: "platform_subscriptions" */
  updatePlatformSubscriptions?: Maybe<PlatformSubscriptionsMutationResponse>;
  /** update single row of the table: "platform_subscriptions" */
  updatePlatformSubscriptionsByPk?: Maybe<PlatformSubscriptions>;
  /** update multiples rows of table: "platform_subscriptions" */
  updatePlatformSubscriptionsMany?: Maybe<Array<Maybe<PlatformSubscriptionsMutationResponse>>>;
  /** update data of the table: "play_request_neighborhoods" */
  updatePlayRequestNeighborhoods?: Maybe<PlayRequestNeighborhoodsMutationResponse>;
  /** update single row of the table: "play_request_neighborhoods" */
  updatePlayRequestNeighborhoodsByPk?: Maybe<PlayRequestNeighborhoods>;
  /** update multiples rows of table: "play_request_neighborhoods" */
  updatePlayRequestNeighborhoodsMany?: Maybe<Array<Maybe<PlayRequestNeighborhoodsMutationResponse>>>;
  /** update data of the table: "play_request_slots" */
  updatePlayRequestSlots?: Maybe<PlayRequestSlotsMutationResponse>;
  /** update single row of the table: "play_request_slots" */
  updatePlayRequestSlotsByPk?: Maybe<PlayRequestSlots>;
  /** update multiples rows of table: "play_request_slots" */
  updatePlayRequestSlotsMany?: Maybe<Array<Maybe<PlayRequestSlotsMutationResponse>>>;
  /** update data of the table: "play_request_statuses" */
  updatePlayRequestStatuses?: Maybe<PlayRequestStatusesMutationResponse>;
  /** update single row of the table: "play_request_statuses" */
  updatePlayRequestStatusesByPk?: Maybe<PlayRequestStatuses>;
  /** update multiples rows of table: "play_request_statuses" */
  updatePlayRequestStatusesMany?: Maybe<Array<Maybe<PlayRequestStatusesMutationResponse>>>;
  /** update data of the table: "play_request_venues" */
  updatePlayRequestVenues?: Maybe<PlayRequestVenuesMutationResponse>;
  /** update single row of the table: "play_request_venues" */
  updatePlayRequestVenuesByPk?: Maybe<PlayRequestVenues>;
  /** update multiples rows of table: "play_request_venues" */
  updatePlayRequestVenuesMany?: Maybe<Array<Maybe<PlayRequestVenuesMutationResponse>>>;
  /** update data of the table: "play_requests" */
  updatePlayRequests?: Maybe<PlayRequestsMutationResponse>;
  /** update single row of the table: "play_requests" */
  updatePlayRequestsByPk?: Maybe<PlayRequests>;
  /** update multiples rows of table: "play_requests" */
  updatePlayRequestsMany?: Maybe<Array<Maybe<PlayRequestsMutationResponse>>>;
  /** update data of the table: "play_session_comments" */
  updatePlaySessionComments?: Maybe<PlaySessionCommentsMutationResponse>;
  /** update single row of the table: "play_session_comments" */
  updatePlaySessionCommentsByPk?: Maybe<PlaySessionComments>;
  /** update multiples rows of table: "play_session_comments" */
  updatePlaySessionCommentsMany?: Maybe<Array<Maybe<PlaySessionCommentsMutationResponse>>>;
  /** update data of the table: "play_session_court_booking_statuses" */
  updatePlaySessionCourtBookingStatuses?: Maybe<PlaySessionCourtBookingStatusesMutationResponse>;
  /** update single row of the table: "play_session_court_booking_statuses" */
  updatePlaySessionCourtBookingStatusesByPk?: Maybe<PlaySessionCourtBookingStatuses>;
  /** update multiples rows of table: "play_session_court_booking_statuses" */
  updatePlaySessionCourtBookingStatusesMany?: Maybe<Array<Maybe<PlaySessionCourtBookingStatusesMutationResponse>>>;
  /** update data of the table: "play_session_formats" */
  updatePlaySessionFormats?: Maybe<PlaySessionFormatsMutationResponse>;
  /** update single row of the table: "play_session_formats" */
  updatePlaySessionFormatsByPk?: Maybe<PlaySessionFormats>;
  /** update multiples rows of table: "play_session_formats" */
  updatePlaySessionFormatsMany?: Maybe<Array<Maybe<PlaySessionFormatsMutationResponse>>>;
  /** update data of the table: "play_session_match_competitiveness" */
  updatePlaySessionMatchCompetitiveness?: Maybe<PlaySessionMatchCompetitivenessMutationResponse>;
  /** update single row of the table: "play_session_match_competitiveness" */
  updatePlaySessionMatchCompetitivenessByPk?: Maybe<PlaySessionMatchCompetitiveness>;
  /** update multiples rows of table: "play_session_match_competitiveness" */
  updatePlaySessionMatchCompetitivenessMany?: Maybe<Array<Maybe<PlaySessionMatchCompetitivenessMutationResponse>>>;
  /** update data of the table: "play_session_participant_statuses" */
  updatePlaySessionParticipantStatuses?: Maybe<PlaySessionParticipantStatusesMutationResponse>;
  /** update single row of the table: "play_session_participant_statuses" */
  updatePlaySessionParticipantStatusesByPk?: Maybe<PlaySessionParticipantStatuses>;
  /** update multiples rows of table: "play_session_participant_statuses" */
  updatePlaySessionParticipantStatusesMany?: Maybe<Array<Maybe<PlaySessionParticipantStatusesMutationResponse>>>;
  /** update data of the table: "play_session_participants" */
  updatePlaySessionParticipants?: Maybe<PlaySessionParticipantsMutationResponse>;
  /** update single row of the table: "play_session_participants" */
  updatePlaySessionParticipantsByPk?: Maybe<PlaySessionParticipants>;
  /** update multiples rows of table: "play_session_participants" */
  updatePlaySessionParticipantsMany?: Maybe<Array<Maybe<PlaySessionParticipantsMutationResponse>>>;
  /** update data of the table: "play_session_privacy" */
  updatePlaySessionPrivacy?: Maybe<PlaySessionPrivacyMutationResponse>;
  /** update single row of the table: "play_session_privacy" */
  updatePlaySessionPrivacyByPk?: Maybe<PlaySessionPrivacy>;
  /** update multiples rows of table: "play_session_privacy" */
  updatePlaySessionPrivacyMany?: Maybe<Array<Maybe<PlaySessionPrivacyMutationResponse>>>;
  /** update data of the table: "play_session_statuses" */
  updatePlaySessionStatuses?: Maybe<PlaySessionStatusesMutationResponse>;
  /** update single row of the table: "play_session_statuses" */
  updatePlaySessionStatusesByPk?: Maybe<PlaySessionStatuses>;
  /** update multiples rows of table: "play_session_statuses" */
  updatePlaySessionStatusesMany?: Maybe<Array<Maybe<PlaySessionStatusesMutationResponse>>>;
  /** update data of the table: "play_sessions" */
  updatePlaySessions?: Maybe<PlaySessionsMutationResponse>;
  /** update single row of the table: "play_sessions" */
  updatePlaySessionsByPk?: Maybe<PlaySessions>;
  /** update multiples rows of table: "play_sessions" */
  updatePlaySessionsMany?: Maybe<Array<Maybe<PlaySessionsMutationResponse>>>;
  /** update data of the table: "player_availabilities" */
  updatePlayerAvailabilities?: Maybe<PlayerAvailabilitiesMutationResponse>;
  /** update single row of the table: "player_availabilities" */
  updatePlayerAvailabilitiesByPk?: Maybe<PlayerAvailabilities>;
  /** update multiples rows of table: "player_availabilities" */
  updatePlayerAvailabilitiesMany?: Maybe<Array<Maybe<PlayerAvailabilitiesMutationResponse>>>;
  /** update data of the table: "player_availability_neighborhoods" */
  updatePlayerAvailabilityNeighborhoods?: Maybe<PlayerAvailabilityNeighborhoodsMutationResponse>;
  /** update single row of the table: "player_availability_neighborhoods" */
  updatePlayerAvailabilityNeighborhoodsByPk?: Maybe<PlayerAvailabilityNeighborhoods>;
  /** update multiples rows of table: "player_availability_neighborhoods" */
  updatePlayerAvailabilityNeighborhoodsMany?: Maybe<Array<Maybe<PlayerAvailabilityNeighborhoodsMutationResponse>>>;
  /** update data of the table: "player_availability_rating_scales" */
  updatePlayerAvailabilityRatingScales?: Maybe<PlayerAvailabilityRatingScalesMutationResponse>;
  /** update single row of the table: "player_availability_rating_scales" */
  updatePlayerAvailabilityRatingScalesByPk?: Maybe<PlayerAvailabilityRatingScales>;
  /** update multiples rows of table: "player_availability_rating_scales" */
  updatePlayerAvailabilityRatingScalesMany?: Maybe<Array<Maybe<PlayerAvailabilityRatingScalesMutationResponse>>>;
  /** update data of the table: "player_availability_slots" */
  updatePlayerAvailabilitySlots?: Maybe<PlayerAvailabilitySlotsMutationResponse>;
  /** update single row of the table: "player_availability_slots" */
  updatePlayerAvailabilitySlotsByPk?: Maybe<PlayerAvailabilitySlots>;
  /** update multiples rows of table: "player_availability_slots" */
  updatePlayerAvailabilitySlotsMany?: Maybe<Array<Maybe<PlayerAvailabilitySlotsMutationResponse>>>;
  /** update data of the table: "player_availability_venues" */
  updatePlayerAvailabilityVenues?: Maybe<PlayerAvailabilityVenuesMutationResponse>;
  /** update single row of the table: "player_availability_venues" */
  updatePlayerAvailabilityVenuesByPk?: Maybe<PlayerAvailabilityVenues>;
  /** update multiples rows of table: "player_availability_venues" */
  updatePlayerAvailabilityVenuesMany?: Maybe<Array<Maybe<PlayerAvailabilityVenuesMutationResponse>>>;
  /** update data of the table: "player_finder_goals" */
  updatePlayerFinderGoals?: Maybe<PlayerFinderGoalsMutationResponse>;
  /** update single row of the table: "player_finder_goals" */
  updatePlayerFinderGoalsByPk?: Maybe<PlayerFinderGoals>;
  /** update multiples rows of table: "player_finder_goals" */
  updatePlayerFinderGoalsMany?: Maybe<Array<Maybe<PlayerFinderGoalsMutationResponse>>>;
  /** update data of the table: "player_finder_time_of_day" */
  updatePlayerFinderTimeOfDay?: Maybe<PlayerFinderTimeOfDayMutationResponse>;
  /** update single row of the table: "player_finder_time_of_day" */
  updatePlayerFinderTimeOfDayByPk?: Maybe<PlayerFinderTimeOfDay>;
  /** update multiples rows of table: "player_finder_time_of_day" */
  updatePlayerFinderTimeOfDayMany?: Maybe<Array<Maybe<PlayerFinderTimeOfDayMutationResponse>>>;
  /** update data of the table: "recurrence_kinds" */
  updateRecurrenceKinds?: Maybe<RecurrenceKindsMutationResponse>;
  /** update single row of the table: "recurrence_kinds" */
  updateRecurrenceKindsByPk?: Maybe<RecurrenceKinds>;
  /** update multiples rows of table: "recurrence_kinds" */
  updateRecurrenceKindsMany?: Maybe<Array<Maybe<RecurrenceKindsMutationResponse>>>;
  /** update data of the table: "report_reasons" */
  updateReportReasons?: Maybe<ReportReasonsMutationResponse>;
  /** update single row of the table: "report_reasons" */
  updateReportReasonsByPk?: Maybe<ReportReasons>;
  /** update multiples rows of table: "report_reasons" */
  updateReportReasonsMany?: Maybe<Array<Maybe<ReportReasonsMutationResponse>>>;
  /** update data of the table: "report_statuses" */
  updateReportStatuses?: Maybe<ReportStatusesMutationResponse>;
  /** update single row of the table: "report_statuses" */
  updateReportStatusesByPk?: Maybe<ReportStatuses>;
  /** update multiples rows of table: "report_statuses" */
  updateReportStatusesMany?: Maybe<Array<Maybe<ReportStatusesMutationResponse>>>;
  /** update data of the table: "reviews" */
  updateReviews?: Maybe<ReviewsMutationResponse>;
  /** update single row of the table: "reviews" */
  updateReviewsByPk?: Maybe<Reviews>;
  /** update multiples rows of table: "reviews" */
  updateReviewsMany?: Maybe<Array<Maybe<ReviewsMutationResponse>>>;
  /** update data of the table: "sales" */
  updateSales?: Maybe<SalesMutationResponse>;
  /** update single row of the table: "sales" */
  updateSalesByPk?: Maybe<Sales>;
  /** update multiples rows of table: "sales" */
  updateSalesMany?: Maybe<Array<Maybe<SalesMutationResponse>>>;
  /** update data of the table: "scoring_format" */
  updateScoringFormat?: Maybe<ScoringFormatMutationResponse>;
  /** update single row of the table: "scoring_format" */
  updateScoringFormatByPk?: Maybe<ScoringFormat>;
  /** update multiples rows of table: "scoring_format" */
  updateScoringFormatMany?: Maybe<Array<Maybe<ScoringFormatMutationResponse>>>;
  /** update data of the table: "signup_requests" */
  updateSignupRequests?: Maybe<SignupRequestsMutationResponse>;
  /** update single row of the table: "signup_requests" */
  updateSignupRequestsByPk?: Maybe<SignupRequests>;
  /** update multiples rows of table: "signup_requests" */
  updateSignupRequestsMany?: Maybe<Array<Maybe<SignupRequestsMutationResponse>>>;
  /** update data of the table: "skill_level_values" */
  updateSkillLevelValues?: Maybe<SkillLevelValuesMutationResponse>;
  /** update single row of the table: "skill_level_values" */
  updateSkillLevelValuesByPk?: Maybe<SkillLevelValues>;
  /** update multiples rows of table: "skill_level_values" */
  updateSkillLevelValuesMany?: Maybe<Array<Maybe<SkillLevelValuesMutationResponse>>>;
  /** update data of the table: "skill_levels" */
  updateSkillLevels?: Maybe<SkillLevelsMutationResponse>;
  /** update single row of the table: "skill_levels" */
  updateSkillLevelsByPk?: Maybe<SkillLevels>;
  /** update multiples rows of table: "skill_levels" */
  updateSkillLevelsMany?: Maybe<Array<Maybe<SkillLevelsMutationResponse>>>;
  /** update data of the table: "sports" */
  updateSports?: Maybe<SportsMutationResponse>;
  /** update single row of the table: "sports" */
  updateSportsByPk?: Maybe<Sports>;
  /** update multiples rows of table: "sports" */
  updateSportsMany?: Maybe<Array<Maybe<SportsMutationResponse>>>;
  /** update data of the table: "stripe_charges" */
  updateStripeCharges?: Maybe<StripeChargesMutationResponse>;
  /** update single row of the table: "stripe_charges" */
  updateStripeChargesByPk?: Maybe<StripeCharges>;
  /** update multiples rows of table: "stripe_charges" */
  updateStripeChargesMany?: Maybe<Array<Maybe<StripeChargesMutationResponse>>>;
  /** update data of the table: "stripe_payment_intents" */
  updateStripePaymentIntents?: Maybe<StripePaymentIntentsMutationResponse>;
  /** update single row of the table: "stripe_payment_intents" */
  updateStripePaymentIntentsByPk?: Maybe<StripePaymentIntents>;
  /** update multiples rows of table: "stripe_payment_intents" */
  updateStripePaymentIntentsMany?: Maybe<Array<Maybe<StripePaymentIntentsMutationResponse>>>;
  /** update data of the table: "subscription_statuses" */
  updateSubscriptionStatuses?: Maybe<SubscriptionStatusesMutationResponse>;
  /** update single row of the table: "subscription_statuses" */
  updateSubscriptionStatusesByPk?: Maybe<SubscriptionStatuses>;
  /** update multiples rows of table: "subscription_statuses" */
  updateSubscriptionStatusesMany?: Maybe<Array<Maybe<SubscriptionStatusesMutationResponse>>>;
  /** update data of the table: "team_types" */
  updateTeamTypes?: Maybe<TeamTypesMutationResponse>;
  /** update single row of the table: "team_types" */
  updateTeamTypesByPk?: Maybe<TeamTypes>;
  /** update multiples rows of table: "team_types" */
  updateTeamTypesMany?: Maybe<Array<Maybe<TeamTypesMutationResponse>>>;
  /** update data of the table: "tennis_rating_scales" */
  updateTennisRatingScales?: Maybe<TennisRatingScalesMutationResponse>;
  /** update single row of the table: "tennis_rating_scales" */
  updateTennisRatingScalesByPk?: Maybe<TennisRatingScales>;
  /** update multiples rows of table: "tennis_rating_scales" */
  updateTennisRatingScalesMany?: Maybe<Array<Maybe<TennisRatingScalesMutationResponse>>>;
  /** update data of the table: "twilio_group_texts" */
  updateTwilioGroupTexts?: Maybe<TwilioGroupTextsMutationResponse>;
  /** update single row of the table: "twilio_group_texts" */
  updateTwilioGroupTextsByPk?: Maybe<TwilioGroupTexts>;
  /** update multiples rows of table: "twilio_group_texts" */
  updateTwilioGroupTextsMany?: Maybe<Array<Maybe<TwilioGroupTextsMutationResponse>>>;
  /** update data of the table: "upload_review_requests" */
  updateUploadReviewRequests?: Maybe<UploadReviewRequestsMutationResponse>;
  /** update single row of the table: "upload_review_requests" */
  updateUploadReviewRequestsByPk?: Maybe<UploadReviewRequests>;
  /** update multiples rows of table: "upload_review_requests" */
  updateUploadReviewRequestsMany?: Maybe<Array<Maybe<UploadReviewRequestsMutationResponse>>>;
  /** update data of the table: "user_auth_identities" */
  updateUserAuthIdentities?: Maybe<UserAuthIdentitiesMutationResponse>;
  /** update single row of the table: "user_auth_identities" */
  updateUserAuthIdentitiesByPk?: Maybe<UserAuthIdentities>;
  /** update multiples rows of table: "user_auth_identities" */
  updateUserAuthIdentitiesMany?: Maybe<Array<Maybe<UserAuthIdentitiesMutationResponse>>>;
  /** update data of the table: "user_blocks" */
  updateUserBlocks?: Maybe<UserBlocksMutationResponse>;
  /** update single row of the table: "user_blocks" */
  updateUserBlocksByPk?: Maybe<UserBlocks>;
  /** update multiples rows of table: "user_blocks" */
  updateUserBlocksMany?: Maybe<Array<Maybe<UserBlocksMutationResponse>>>;
  /** update data of the table: "user_coach_services" */
  updateUserCoachServices?: Maybe<UserCoachServicesMutationResponse>;
  /** update single row of the table: "user_coach_services" */
  updateUserCoachServicesByPk?: Maybe<UserCoachServices>;
  /** update multiples rows of table: "user_coach_services" */
  updateUserCoachServicesMany?: Maybe<Array<Maybe<UserCoachServicesMutationResponse>>>;
  /** update data of the table: "user_communication_preferences" */
  updateUserCommunicationPreferences?: Maybe<UserCommunicationPreferencesMutationResponse>;
  /** update single row of the table: "user_communication_preferences" */
  updateUserCommunicationPreferencesByPk?: Maybe<UserCommunicationPreferences>;
  /** update multiples rows of table: "user_communication_preferences" */
  updateUserCommunicationPreferencesMany?: Maybe<Array<Maybe<UserCommunicationPreferencesMutationResponse>>>;
  /** update data of the table: "user_connection_request_statuses" */
  updateUserConnectionRequestStatuses?: Maybe<UserConnectionRequestStatusesMutationResponse>;
  /** update single row of the table: "user_connection_request_statuses" */
  updateUserConnectionRequestStatusesByPk?: Maybe<UserConnectionRequestStatuses>;
  /** update multiples rows of table: "user_connection_request_statuses" */
  updateUserConnectionRequestStatusesMany?: Maybe<Array<Maybe<UserConnectionRequestStatusesMutationResponse>>>;
  /** update data of the table: "user_connection_requests" */
  updateUserConnectionRequests?: Maybe<UserConnectionRequestsMutationResponse>;
  /** update single row of the table: "user_connection_requests" */
  updateUserConnectionRequestsByPk?: Maybe<UserConnectionRequests>;
  /** update multiples rows of table: "user_connection_requests" */
  updateUserConnectionRequestsMany?: Maybe<Array<Maybe<UserConnectionRequestsMutationResponse>>>;
  /** update data of the table: "user_connections" */
  updateUserConnections?: Maybe<UserConnectionsMutationResponse>;
  /** update single row of the table: "user_connections" */
  updateUserConnectionsByPk?: Maybe<UserConnections>;
  /** update multiples rows of table: "user_connections" */
  updateUserConnectionsMany?: Maybe<Array<Maybe<UserConnectionsMutationResponse>>>;
  /** update data of the table: "user_content_beta_subscriptions" */
  updateUserContentBetaSubscriptions?: Maybe<UserContentBetaSubscriptionsMutationResponse>;
  /** update single row of the table: "user_content_beta_subscriptions" */
  updateUserContentBetaSubscriptionsByPk?: Maybe<UserContentBetaSubscriptions>;
  /** update multiples rows of table: "user_content_beta_subscriptions" */
  updateUserContentBetaSubscriptionsMany?: Maybe<Array<Maybe<UserContentBetaSubscriptionsMutationResponse>>>;
  /** update data of the table: "user_content_files" */
  updateUserContentFiles?: Maybe<UserContentFilesMutationResponse>;
  /** update single row of the table: "user_content_files" */
  updateUserContentFilesByPk?: Maybe<UserContentFiles>;
  /** update multiples rows of table: "user_content_files" */
  updateUserContentFilesMany?: Maybe<Array<Maybe<UserContentFilesMutationResponse>>>;
  /** update data of the table: "user_content_files_skills" */
  updateUserContentFilesSkills?: Maybe<UserContentFilesSkillsMutationResponse>;
  /** update single row of the table: "user_content_files_skills" */
  updateUserContentFilesSkillsByPk?: Maybe<UserContentFilesSkills>;
  /** update multiples rows of table: "user_content_files_skills" */
  updateUserContentFilesSkillsMany?: Maybe<Array<Maybe<UserContentFilesSkillsMutationResponse>>>;
  /** update data of the table: "user_content_skills" */
  updateUserContentSkills?: Maybe<UserContentSkillsMutationResponse>;
  /** update single row of the table: "user_content_skills" */
  updateUserContentSkillsByPk?: Maybe<UserContentSkills>;
  /** update multiples rows of table: "user_content_skills" */
  updateUserContentSkillsMany?: Maybe<Array<Maybe<UserContentSkillsMutationResponse>>>;
  /** update data of the table: "user_content_tiers" */
  updateUserContentTiers?: Maybe<UserContentTiersMutationResponse>;
  /** update single row of the table: "user_content_tiers" */
  updateUserContentTiersByPk?: Maybe<UserContentTiers>;
  /** update multiples rows of table: "user_content_tiers" */
  updateUserContentTiersMany?: Maybe<Array<Maybe<UserContentTiersMutationResponse>>>;
  /** update data of the table: "user_credit_cards" */
  updateUserCreditCards?: Maybe<UserCreditCardsMutationResponse>;
  /** update single row of the table: "user_credit_cards" */
  updateUserCreditCardsByPk?: Maybe<UserCreditCards>;
  /** update multiples rows of table: "user_credit_cards" */
  updateUserCreditCardsMany?: Maybe<Array<Maybe<UserCreditCardsMutationResponse>>>;
  /** update data of the table: "user_custom_courts" */
  updateUserCustomCourts?: Maybe<UserCustomCourtsMutationResponse>;
  /** update single row of the table: "user_custom_courts" */
  updateUserCustomCourtsByPk?: Maybe<UserCustomCourts>;
  /** update multiples rows of table: "user_custom_courts" */
  updateUserCustomCourtsMany?: Maybe<Array<Maybe<UserCustomCourtsMutationResponse>>>;
  /** update data of the table: "user_files" */
  updateUserFiles?: Maybe<UserFilesMutationResponse>;
  /** update single row of the table: "user_files" */
  updateUserFilesByPk?: Maybe<UserFiles>;
  /** update multiples rows of table: "user_files" */
  updateUserFilesMany?: Maybe<Array<Maybe<UserFilesMutationResponse>>>;
  /** update data of the table: "user_follows" */
  updateUserFollows?: Maybe<UserFollowsMutationResponse>;
  /** update single row of the table: "user_follows" */
  updateUserFollowsByPk?: Maybe<UserFollows>;
  /** update multiples rows of table: "user_follows" */
  updateUserFollowsMany?: Maybe<Array<Maybe<UserFollowsMutationResponse>>>;
  /** update data of the table: "user_identity_verifications" */
  updateUserIdentityVerifications?: Maybe<UserIdentityVerificationsMutationResponse>;
  /** update single row of the table: "user_identity_verifications" */
  updateUserIdentityVerificationsByPk?: Maybe<UserIdentityVerifications>;
  /** update multiples rows of table: "user_identity_verifications" */
  updateUserIdentityVerificationsMany?: Maybe<Array<Maybe<UserIdentityVerificationsMutationResponse>>>;
  /** update data of the table: "user_image_log" */
  updateUserImageLog?: Maybe<UserImageLogMutationResponse>;
  /** update single row of the table: "user_image_log" */
  updateUserImageLogByPk?: Maybe<UserImageLog>;
  /** update multiples rows of table: "user_image_log" */
  updateUserImageLogMany?: Maybe<Array<Maybe<UserImageLogMutationResponse>>>;
  /** update data of the table: "user_notification_details" */
  updateUserNotificationDetails?: Maybe<UserNotificationDetailsMutationResponse>;
  /** update single row of the table: "user_notification_details" */
  updateUserNotificationDetailsByPk?: Maybe<UserNotificationDetails>;
  /** update multiples rows of table: "user_notification_details" */
  updateUserNotificationDetailsMany?: Maybe<Array<Maybe<UserNotificationDetailsMutationResponse>>>;
  /** update data of the table: "user_notification_entities" */
  updateUserNotificationEntities?: Maybe<UserNotificationEntitiesMutationResponse>;
  /** update single row of the table: "user_notification_entities" */
  updateUserNotificationEntitiesByPk?: Maybe<UserNotificationEntities>;
  /** update multiples rows of table: "user_notification_entities" */
  updateUserNotificationEntitiesMany?: Maybe<Array<Maybe<UserNotificationEntitiesMutationResponse>>>;
  /** update data of the table: "user_notifications" */
  updateUserNotifications?: Maybe<UserNotificationsMutationResponse>;
  /** update single row of the table: "user_notifications" */
  updateUserNotificationsByPk?: Maybe<UserNotifications>;
  /** update multiples rows of table: "user_notifications" */
  updateUserNotificationsMany?: Maybe<Array<Maybe<UserNotificationsMutationResponse>>>;
  /** update data of the table: "user_padel_rating_scales" */
  updateUserPadelRatingScales?: Maybe<UserPadelRatingScalesMutationResponse>;
  /** update single row of the table: "user_padel_rating_scales" */
  updateUserPadelRatingScalesByPk?: Maybe<UserPadelRatingScales>;
  /** update multiples rows of table: "user_padel_rating_scales" */
  updateUserPadelRatingScalesMany?: Maybe<Array<Maybe<UserPadelRatingScalesMutationResponse>>>;
  /** update data of the table: "user_pickleball_rating_scales" */
  updateUserPickleballRatingScales?: Maybe<UserPickleballRatingScalesMutationResponse>;
  /** update single row of the table: "user_pickleball_rating_scales" */
  updateUserPickleballRatingScalesByPk?: Maybe<UserPickleballRatingScales>;
  /** update multiples rows of table: "user_pickleball_rating_scales" */
  updateUserPickleballRatingScalesMany?: Maybe<Array<Maybe<UserPickleballRatingScalesMutationResponse>>>;
  /** update data of the table: "user_played_with_dismissals" */
  updateUserPlayedWithDismissals?: Maybe<UserPlayedWithDismissalsMutationResponse>;
  /** update single row of the table: "user_played_with_dismissals" */
  updateUserPlayedWithDismissalsByPk?: Maybe<UserPlayedWithDismissals>;
  /** update multiples rows of table: "user_played_with_dismissals" */
  updateUserPlayedWithDismissalsMany?: Maybe<Array<Maybe<UserPlayedWithDismissalsMutationResponse>>>;
  /** update data of the table: "user_player_finder_availability" */
  updateUserPlayerFinderAvailability?: Maybe<UserPlayerFinderAvailabilityMutationResponse>;
  /** update single row of the table: "user_player_finder_availability" */
  updateUserPlayerFinderAvailabilityByPk?: Maybe<UserPlayerFinderAvailability>;
  /** update multiples rows of table: "user_player_finder_availability" */
  updateUserPlayerFinderAvailabilityMany?: Maybe<Array<Maybe<UserPlayerFinderAvailabilityMutationResponse>>>;
  /** update data of the table: "user_player_finder_goals" */
  updateUserPlayerFinderGoals?: Maybe<UserPlayerFinderGoalsMutationResponse>;
  /** update single row of the table: "user_player_finder_goals" */
  updateUserPlayerFinderGoalsByPk?: Maybe<UserPlayerFinderGoals>;
  /** update multiples rows of table: "user_player_finder_goals" */
  updateUserPlayerFinderGoalsMany?: Maybe<Array<Maybe<UserPlayerFinderGoalsMutationResponse>>>;
  /** update data of the table: "user_profiles" */
  updateUserProfiles?: Maybe<UserProfilesMutationResponse>;
  /** update multiples rows of table: "user_profiles" */
  updateUserProfilesMany?: Maybe<Array<Maybe<UserProfilesMutationResponse>>>;
  /** update data of the table: "user_registration_details" */
  updateUserRegistrationDetails?: Maybe<UserRegistrationDetailsMutationResponse>;
  /** update single row of the table: "user_registration_details" */
  updateUserRegistrationDetailsByPk?: Maybe<UserRegistrationDetails>;
  /** update multiples rows of table: "user_registration_details" */
  updateUserRegistrationDetailsMany?: Maybe<Array<Maybe<UserRegistrationDetailsMutationResponse>>>;
  /** update data of the table: "user_sports" */
  updateUserSports?: Maybe<UserSportsMutationResponse>;
  /** update single row of the table: "user_sports" */
  updateUserSportsByPk?: Maybe<UserSports>;
  /** update multiples rows of table: "user_sports" */
  updateUserSportsMany?: Maybe<Array<Maybe<UserSportsMutationResponse>>>;
  /** update data of the table: "user_tennis_rating_scales" */
  updateUserTennisRatingScales?: Maybe<UserTennisRatingScalesMutationResponse>;
  /** update single row of the table: "user_tennis_rating_scales" */
  updateUserTennisRatingScalesByPk?: Maybe<UserTennisRatingScales>;
  /** update multiples rows of table: "user_tennis_rating_scales" */
  updateUserTennisRatingScalesMany?: Maybe<Array<Maybe<UserTennisRatingScalesMutationResponse>>>;
  /** update data of the table: "user_terms_of_service" */
  updateUserTermsOfService?: Maybe<UserTermsOfServiceMutationResponse>;
  /** update single row of the table: "user_terms_of_service" */
  updateUserTermsOfServiceByPk?: Maybe<UserTermsOfService>;
  /** update multiples rows of table: "user_terms_of_service" */
  updateUserTermsOfServiceMany?: Maybe<Array<Maybe<UserTermsOfServiceMutationResponse>>>;
  /** update data of the table: "user_vair_connections" */
  updateUserVairConnections?: Maybe<UserVairConnectionsMutationResponse>;
  /** update single row of the table: "user_vair_connections" */
  updateUserVairConnectionsByPk?: Maybe<UserVairConnections>;
  /** update multiples rows of table: "user_vair_connections" */
  updateUserVairConnectionsMany?: Maybe<Array<Maybe<UserVairConnectionsMutationResponse>>>;
  /** update data of the table: "username_logs" */
  updateUsernameLogs?: Maybe<UsernameLogsMutationResponse>;
  /** update single row of the table: "username_logs" */
  updateUsernameLogsByPk?: Maybe<UsernameLogs>;
  /** update multiples rows of table: "username_logs" */
  updateUsernameLogsMany?: Maybe<Array<Maybe<UsernameLogsMutationResponse>>>;
  /** update data of the table: "usernames_active" */
  updateUsernamesActive?: Maybe<UsernamesActiveMutationResponse>;
  /** update multiples rows of table: "usernames_active" */
  updateUsernamesActiveMany?: Maybe<Array<Maybe<UsernamesActiveMutationResponse>>>;
  /** update data of the table: "usernames_claimed" */
  updateUsernamesClaimed?: Maybe<UsernamesClaimedMutationResponse>;
  /** update single row of the table: "usernames_claimed" */
  updateUsernamesClaimedByPk?: Maybe<UsernamesClaimed>;
  /** update multiples rows of table: "usernames_claimed" */
  updateUsernamesClaimedMany?: Maybe<Array<Maybe<UsernamesClaimedMutationResponse>>>;
  /** update data of the table: "users" */
  updateUsers?: Maybe<UsersMutationResponse>;
  /** update single row of the table: "users" */
  updateUsersByPk?: Maybe<Users>;
  /** update data of the table: "users_coach_qualifications" */
  updateUsersCoachQualifications?: Maybe<UsersCoachQualificationsMutationResponse>;
  /** update single row of the table: "users_coach_qualifications" */
  updateUsersCoachQualificationsByPk?: Maybe<UsersCoachQualifications>;
  /** update multiples rows of table: "users_coach_qualifications" */
  updateUsersCoachQualificationsMany?: Maybe<Array<Maybe<UsersCoachQualificationsMutationResponse>>>;
  /** update multiples rows of table: "users" */
  updateUsersMany?: Maybe<Array<Maybe<UsersMutationResponse>>>;
  /** update data of the table: "venue_access_types" */
  updateVenueAccessTypes?: Maybe<VenueAccessTypesMutationResponse>;
  /** update single row of the table: "venue_access_types" */
  updateVenueAccessTypesByPk?: Maybe<VenueAccessTypes>;
  /** update multiples rows of table: "venue_access_types" */
  updateVenueAccessTypesMany?: Maybe<Array<Maybe<VenueAccessTypesMutationResponse>>>;
  /** update data of the table: "venue_admin_claim_statuses" */
  updateVenueAdminClaimStatuses?: Maybe<VenueAdminClaimStatusesMutationResponse>;
  /** update single row of the table: "venue_admin_claim_statuses" */
  updateVenueAdminClaimStatusesByPk?: Maybe<VenueAdminClaimStatuses>;
  /** update multiples rows of table: "venue_admin_claim_statuses" */
  updateVenueAdminClaimStatusesMany?: Maybe<Array<Maybe<VenueAdminClaimStatusesMutationResponse>>>;
  /** update data of the table: "venue_admin_claims" */
  updateVenueAdminClaims?: Maybe<VenueAdminClaimsMutationResponse>;
  /** update single row of the table: "venue_admin_claims" */
  updateVenueAdminClaimsByPk?: Maybe<VenueAdminClaims>;
  /** update multiples rows of table: "venue_admin_claims" */
  updateVenueAdminClaimsMany?: Maybe<Array<Maybe<VenueAdminClaimsMutationResponse>>>;
  /** update data of the table: "venue_amenities" */
  updateVenueAmenities?: Maybe<VenueAmenitiesMutationResponse>;
  /** update single row of the table: "venue_amenities" */
  updateVenueAmenitiesByPk?: Maybe<VenueAmenities>;
  /** update multiples rows of table: "venue_amenities" */
  updateVenueAmenitiesMany?: Maybe<Array<Maybe<VenueAmenitiesMutationResponse>>>;
  /** update data of the table: "venue_booking_config_versions" */
  updateVenueBookingConfigVersions?: Maybe<VenueBookingConfigVersionsMutationResponse>;
  /** update single row of the table: "venue_booking_config_versions" */
  updateVenueBookingConfigVersionsByPk?: Maybe<VenueBookingConfigVersions>;
  /** update multiples rows of table: "venue_booking_config_versions" */
  updateVenueBookingConfigVersionsMany?: Maybe<Array<Maybe<VenueBookingConfigVersionsMutationResponse>>>;
  /** update data of the table: "venue_booking_connection_check_statuses" */
  updateVenueBookingConnectionCheckStatuses?: Maybe<VenueBookingConnectionCheckStatusesMutationResponse>;
  /** update single row of the table: "venue_booking_connection_check_statuses" */
  updateVenueBookingConnectionCheckStatusesByPk?: Maybe<VenueBookingConnectionCheckStatuses>;
  /** update multiples rows of table: "venue_booking_connection_check_statuses" */
  updateVenueBookingConnectionCheckStatusesMany?: Maybe<Array<Maybe<VenueBookingConnectionCheckStatusesMutationResponse>>>;
  /** update data of the table: "venue_booking_connection_checks" */
  updateVenueBookingConnectionChecks?: Maybe<VenueBookingConnectionChecksMutationResponse>;
  /** update single row of the table: "venue_booking_connection_checks" */
  updateVenueBookingConnectionChecksByPk?: Maybe<VenueBookingConnectionChecks>;
  /** update multiples rows of table: "venue_booking_connection_checks" */
  updateVenueBookingConnectionChecksMany?: Maybe<Array<Maybe<VenueBookingConnectionChecksMutationResponse>>>;
  /** update data of the table: "venue_booking_court_rates" */
  updateVenueBookingCourtRates?: Maybe<VenueBookingCourtRatesMutationResponse>;
  /** update single row of the table: "venue_booking_court_rates" */
  updateVenueBookingCourtRatesByPk?: Maybe<VenueBookingCourtRates>;
  /** update multiples rows of table: "venue_booking_court_rates" */
  updateVenueBookingCourtRatesMany?: Maybe<Array<Maybe<VenueBookingCourtRatesMutationResponse>>>;
  /** update data of the table: "venue_booking_integrations" */
  updateVenueBookingIntegrations?: Maybe<VenueBookingIntegrationsMutationResponse>;
  /** update single row of the table: "venue_booking_integrations" */
  updateVenueBookingIntegrationsByPk?: Maybe<VenueBookingIntegrations>;
  /** update multiples rows of table: "venue_booking_integrations" */
  updateVenueBookingIntegrationsMany?: Maybe<Array<Maybe<VenueBookingIntegrationsMutationResponse>>>;
  /** update data of the table: "venue_booking_rule_tiers" */
  updateVenueBookingRuleTiers?: Maybe<VenueBookingRuleTiersMutationResponse>;
  /** update single row of the table: "venue_booking_rule_tiers" */
  updateVenueBookingRuleTiersByPk?: Maybe<VenueBookingRuleTiers>;
  /** update multiples rows of table: "venue_booking_rule_tiers" */
  updateVenueBookingRuleTiersMany?: Maybe<Array<Maybe<VenueBookingRuleTiersMutationResponse>>>;
  /** update data of the table: "venue_booking_rules" */
  updateVenueBookingRules?: Maybe<VenueBookingRulesMutationResponse>;
  /** update single row of the table: "venue_booking_rules" */
  updateVenueBookingRulesByPk?: Maybe<VenueBookingRules>;
  /** update multiples rows of table: "venue_booking_rules" */
  updateVenueBookingRulesMany?: Maybe<Array<Maybe<VenueBookingRulesMutationResponse>>>;
  /** update data of the table: "venue_booking_windows" */
  updateVenueBookingWindows?: Maybe<VenueBookingWindowsMutationResponse>;
  /** update single row of the table: "venue_booking_windows" */
  updateVenueBookingWindowsByPk?: Maybe<VenueBookingWindows>;
  /** update multiples rows of table: "venue_booking_windows" */
  updateVenueBookingWindowsMany?: Maybe<Array<Maybe<VenueBookingWindowsMutationResponse>>>;
  /** update data of the table: "venue_court_surfaces" */
  updateVenueCourtSurfaces?: Maybe<VenueCourtSurfacesMutationResponse>;
  /** update single row of the table: "venue_court_surfaces" */
  updateVenueCourtSurfacesByPk?: Maybe<VenueCourtSurfaces>;
  /** update multiples rows of table: "venue_court_surfaces" */
  updateVenueCourtSurfacesMany?: Maybe<Array<Maybe<VenueCourtSurfacesMutationResponse>>>;
  /** update data of the table: "venue_custom_amenities" */
  updateVenueCustomAmenities?: Maybe<VenueCustomAmenitiesMutationResponse>;
  /** update single row of the table: "venue_custom_amenities" */
  updateVenueCustomAmenitiesByPk?: Maybe<VenueCustomAmenities>;
  /** update multiples rows of table: "venue_custom_amenities" */
  updateVenueCustomAmenitiesMany?: Maybe<Array<Maybe<VenueCustomAmenitiesMutationResponse>>>;
  /** update data of the table: "venue_equipment" */
  updateVenueEquipment?: Maybe<VenueEquipmentMutationResponse>;
  /** update single row of the table: "venue_equipment" */
  updateVenueEquipmentByPk?: Maybe<VenueEquipment>;
  /** update multiples rows of table: "venue_equipment" */
  updateVenueEquipmentMany?: Maybe<Array<Maybe<VenueEquipmentMutationResponse>>>;
  /** update data of the table: "venue_facility_types" */
  updateVenueFacilityTypes?: Maybe<VenueFacilityTypesMutationResponse>;
  /** update single row of the table: "venue_facility_types" */
  updateVenueFacilityTypesByPk?: Maybe<VenueFacilityTypes>;
  /** update multiples rows of table: "venue_facility_types" */
  updateVenueFacilityTypesMany?: Maybe<Array<Maybe<VenueFacilityTypesMutationResponse>>>;
  /** update data of the table: "venue_faqs" */
  updateVenueFaqs?: Maybe<VenueFaqsMutationResponse>;
  /** update single row of the table: "venue_faqs" */
  updateVenueFaqsByPk?: Maybe<VenueFaqs>;
  /** update multiples rows of table: "venue_faqs" */
  updateVenueFaqsMany?: Maybe<Array<Maybe<VenueFaqsMutationResponse>>>;
  /** update data of the table: "venue_follows" */
  updateVenueFollows?: Maybe<VenueFollowsMutationResponse>;
  /** update single row of the table: "venue_follows" */
  updateVenueFollowsByPk?: Maybe<VenueFollows>;
  /** update multiples rows of table: "venue_follows" */
  updateVenueFollowsMany?: Maybe<Array<Maybe<VenueFollowsMutationResponse>>>;
  /** update data of the table: "venue_images" */
  updateVenueImages?: Maybe<VenueImagesMutationResponse>;
  /** update single row of the table: "venue_images" */
  updateVenueImagesByPk?: Maybe<VenueImages>;
  /** update multiples rows of table: "venue_images" */
  updateVenueImagesMany?: Maybe<Array<Maybe<VenueImagesMutationResponse>>>;
  /** update data of the table: "venue_lines" */
  updateVenueLines?: Maybe<VenueLinesMutationResponse>;
  /** update single row of the table: "venue_lines" */
  updateVenueLinesByPk?: Maybe<VenueLines>;
  /** update multiples rows of table: "venue_lines" */
  updateVenueLinesMany?: Maybe<Array<Maybe<VenueLinesMutationResponse>>>;
  /** update data of the table: "venue_nets" */
  updateVenueNets?: Maybe<VenueNetsMutationResponse>;
  /** update single row of the table: "venue_nets" */
  updateVenueNetsByPk?: Maybe<VenueNets>;
  /** update multiples rows of table: "venue_nets" */
  updateVenueNetsMany?: Maybe<Array<Maybe<VenueNetsMutationResponse>>>;
  /** update data of the table: "venue_partner_booking_statuses" */
  updateVenuePartnerBookingStatuses?: Maybe<VenuePartnerBookingStatusesMutationResponse>;
  /** update multiples rows of table: "venue_partner_booking_statuses" */
  updateVenuePartnerBookingStatusesMany?: Maybe<Array<Maybe<VenuePartnerBookingStatusesMutationResponse>>>;
  /** update data of the table: "venue_staff_coaches" */
  updateVenueStaffCoaches?: Maybe<VenueStaffCoachesMutationResponse>;
  /** update single row of the table: "venue_staff_coaches" */
  updateVenueStaffCoachesByPk?: Maybe<VenueStaffCoaches>;
  /** update multiples rows of table: "venue_staff_coaches" */
  updateVenueStaffCoachesMany?: Maybe<Array<Maybe<VenueStaffCoachesMutationResponse>>>;
  /** update data of the table: "venues" */
  updateVenues?: Maybe<VenuesMutationResponse>;
  /** update single row of the table: "venues" */
  updateVenuesByPk?: Maybe<Venues>;
  /** update multiples rows of table: "venues" */
  updateVenuesMany?: Maybe<Array<Maybe<VenuesMutationResponse>>>;
  /** update data of the table: "video_analysis" */
  updateVideoAnalysis?: Maybe<VideoAnalysisMutationResponse>;
  /** update single row of the table: "video_analysis" */
  updateVideoAnalysisByPk?: Maybe<VideoAnalysis>;
  /** update data of the table: "video_analysis_comments" */
  updateVideoAnalysisComments?: Maybe<VideoAnalysisCommentsMutationResponse>;
  /** update single row of the table: "video_analysis_comments" */
  updateVideoAnalysisCommentsByPk?: Maybe<VideoAnalysisComments>;
  /** update multiples rows of table: "video_analysis_comments" */
  updateVideoAnalysisCommentsMany?: Maybe<Array<Maybe<VideoAnalysisCommentsMutationResponse>>>;
  /** update data of the table: "video_analysis_files" */
  updateVideoAnalysisFiles?: Maybe<VideoAnalysisFilesMutationResponse>;
  /** update single row of the table: "video_analysis_files" */
  updateVideoAnalysisFilesByPk?: Maybe<VideoAnalysisFiles>;
  /** update multiples rows of table: "video_analysis_files" */
  updateVideoAnalysisFilesMany?: Maybe<Array<Maybe<VideoAnalysisFilesMutationResponse>>>;
  /** update data of the table: "video_analysis_files_upload_statuses" */
  updateVideoAnalysisFilesUploadStatuses?: Maybe<VideoAnalysisFilesUploadStatusesMutationResponse>;
  /** update single row of the table: "video_analysis_files_upload_statuses" */
  updateVideoAnalysisFilesUploadStatusesByPk?: Maybe<VideoAnalysisFilesUploadStatuses>;
  /** update multiples rows of table: "video_analysis_files_upload_statuses" */
  updateVideoAnalysisFilesUploadStatusesMany?: Maybe<Array<Maybe<VideoAnalysisFilesUploadStatusesMutationResponse>>>;
  /** update multiples rows of table: "video_analysis" */
  updateVideoAnalysisMany?: Maybe<Array<Maybe<VideoAnalysisMutationResponse>>>;
  /** update data of the table: "video_analysis_order_items" */
  updateVideoAnalysisOrderItems?: Maybe<VideoAnalysisOrderItemsMutationResponse>;
  /** update single row of the table: "video_analysis_order_items" */
  updateVideoAnalysisOrderItemsByPk?: Maybe<VideoAnalysisOrderItems>;
  /** update multiples rows of table: "video_analysis_order_items" */
  updateVideoAnalysisOrderItemsMany?: Maybe<Array<Maybe<VideoAnalysisOrderItemsMutationResponse>>>;
  /** update data of the table: "video_analysis_orders" */
  updateVideoAnalysisOrders?: Maybe<VideoAnalysisOrdersMutationResponse>;
  /** update single row of the table: "video_analysis_orders" */
  updateVideoAnalysisOrdersByPk?: Maybe<VideoAnalysisOrders>;
  /** update multiples rows of table: "video_analysis_orders" */
  updateVideoAnalysisOrdersMany?: Maybe<Array<Maybe<VideoAnalysisOrdersMutationResponse>>>;
  /** update data of the table: "video_analysis_requested_skills_review" */
  updateVideoAnalysisRequestedSkillsReview?: Maybe<VideoAnalysisRequestedSkillsReviewMutationResponse>;
  /** update single row of the table: "video_analysis_requested_skills_review" */
  updateVideoAnalysisRequestedSkillsReviewByPk?: Maybe<VideoAnalysisRequestedSkillsReview>;
  /** update multiples rows of table: "video_analysis_requested_skills_review" */
  updateVideoAnalysisRequestedSkillsReviewMany?: Maybe<Array<Maybe<VideoAnalysisRequestedSkillsReviewMutationResponse>>>;
  /** update data of the table: "video_analysis_review_statuses" */
  updateVideoAnalysisReviewStatuses?: Maybe<VideoAnalysisReviewStatusesMutationResponse>;
  /** update single row of the table: "video_analysis_review_statuses" */
  updateVideoAnalysisReviewStatusesByPk?: Maybe<VideoAnalysisReviewStatuses>;
  /** update multiples rows of table: "video_analysis_review_statuses" */
  updateVideoAnalysisReviewStatusesMany?: Maybe<Array<Maybe<VideoAnalysisReviewStatusesMutationResponse>>>;
  /** update data of the table: "video_analysis_skills_comments" */
  updateVideoAnalysisSkillsComments?: Maybe<VideoAnalysisSkillsCommentsMutationResponse>;
  /** update single row of the table: "video_analysis_skills_comments" */
  updateVideoAnalysisSkillsCommentsByPk?: Maybe<VideoAnalysisSkillsComments>;
  /** update multiples rows of table: "video_analysis_skills_comments" */
  updateVideoAnalysisSkillsCommentsMany?: Maybe<Array<Maybe<VideoAnalysisSkillsCommentsMutationResponse>>>;
  /** update data of the table: "video_analysis_submission_log" */
  updateVideoAnalysisSubmissionLog?: Maybe<VideoAnalysisSubmissionLogMutationResponse>;
  /** update single row of the table: "video_analysis_submission_log" */
  updateVideoAnalysisSubmissionLogByPk?: Maybe<VideoAnalysisSubmissionLog>;
  /** update multiples rows of table: "video_analysis_submission_log" */
  updateVideoAnalysisSubmissionLogMany?: Maybe<Array<Maybe<VideoAnalysisSubmissionLogMutationResponse>>>;
  /** update data of the table: "video_lesson_skills" */
  updateVideoLessonSkills?: Maybe<VideoLessonSkillsMutationResponse>;
  /** update single row of the table: "video_lesson_skills" */
  updateVideoLessonSkillsByPk?: Maybe<VideoLessonSkills>;
  /** update multiples rows of table: "video_lesson_skills" */
  updateVideoLessonSkillsMany?: Maybe<Array<Maybe<VideoLessonSkillsMutationResponse>>>;
  /** update data of the table: "welcome_email_configuration" */
  updateWelcomeEmailConfiguration?: Maybe<WelcomeEmailConfigurationMutationResponse>;
  /** update single row of the table: "welcome_email_configuration" */
  updateWelcomeEmailConfigurationByPk?: Maybe<WelcomeEmailConfiguration>;
  /** update multiples rows of table: "welcome_email_configuration" */
  updateWelcomeEmailConfigurationMany?: Maybe<Array<Maybe<WelcomeEmailConfigurationMutationResponse>>>;
  /** update data of the table: "win_reasons" */
  updateWinReasons?: Maybe<WinReasonsMutationResponse>;
  /** update single row of the table: "win_reasons" */
  updateWinReasonsByPk?: Maybe<WinReasons>;
  /** update multiples rows of table: "win_reasons" */
  updateWinReasonsMany?: Maybe<Array<Maybe<WinReasonsMutationResponse>>>;
};


/** mutation root */
export type Mutation_RootDeleteAmenitiesArgs = {
  where: AmenitiesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteAmenitiesByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteAppPersonasArgs = {
  where: AppPersonasBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteAppPersonasByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteAppPingsArgs = {
  where: AppPingsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteAppPingsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteBallTypesArgs = {
  where: BallTypesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteBallTypesByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteBirthdayVisibilityArgs = {
  where: BirthdayVisibilityBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteBirthdayVisibilityByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteBookingConfigChangeTypesArgs = {
  where: BookingConfigChangeTypesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteBookingConfigChangeTypesByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteBookingConnectionStatusesArgs = {
  where: BookingConnectionStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteBookingConnectionStatusesByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteBookingIntegrationStatusesArgs = {
  where: BookingIntegrationStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteBookingIntegrationStatusesByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteBookingInventoryTypesArgs = {
  where: BookingInventoryTypesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteBookingInventoryTypesByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteBookingScheduleModesArgs = {
  where: BookingScheduleModesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteBookingScheduleModesByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteBookingSystemsArgs = {
  where: BookingSystemsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteBookingSystemsByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteBookingWindowKindsArgs = {
  where: BookingWindowKindsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteBookingWindowKindsByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteBoostChannelsArgs = {
  where: BoostChannelsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteBoostChannelsByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteBoostOrdersArgs = {
  where: BoostOrdersBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteBoostOrdersByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteBoostStatusesArgs = {
  where: BoostStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteBoostStatusesByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteBoostsArgs = {
  where: BoostsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteBoostsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteBracketRankingMechanismArgs = {
  where: BracketRankingMechanismBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteBracketRankingMechanismByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteCalendarAccountsArgs = {
  where: CalendarAccountsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteCalendarAccountsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteCalendarAuthProviderArgs = {
  where: CalendarAuthProviderBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteCalendarAuthProviderByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteCalendarEventMappingsArgs = {
  where: CalendarEventMappingsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteCalendarEventMappingsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteCalendarPreferencesArgs = {
  where: CalendarPreferencesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteCalendarPreferencesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteCitiesArgs = {
  where: CitiesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteCitiesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteCoachAvailabilityArgs = {
  where: CoachAvailabilityBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteCoachAvailabilityByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteCoachAvailabilityStatusesArgs = {
  where: CoachAvailabilityStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteCoachAvailabilityStatusesByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteCoachBookingRequestsArgs = {
  where: CoachBookingRequestsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteCoachBookingRequestsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteCoachExternalReviewSourcesArgs = {
  where: CoachExternalReviewSourcesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteCoachExternalReviewSourcesByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteCoachFaqsArgs = {
  where: CoachFaqsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteCoachFaqsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteCoachLessonAgeGroupsArgs = {
  where: CoachLessonAgeGroupsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteCoachLessonAgeGroupsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteCoachLessonSkillLevelsArgs = {
  where: CoachLessonSkillLevelsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteCoachLessonSkillLevelsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteCoachQualificationGroupsArgs = {
  where: CoachQualificationGroupsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteCoachQualificationGroupsByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteCoachQualificationStatusesArgs = {
  where: CoachQualificationStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteCoachQualificationStatusesByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteCoachQualificationsArgs = {
  where: CoachQualificationsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteCoachQualificationsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteCoachReviewTypesArgs = {
  where: CoachReviewTypesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteCoachReviewTypesByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteCoachSportStatusesArgs = {
  where: CoachSportStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteCoachSportStatusesByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteCoachSportsArgs = {
  where: CoachSportsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteCoachSportsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteCoachStarterProfilesArgs = {
  where: CoachStarterProfilesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteCoachStarterProfilesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteCoachStatusArgs = {
  where: CoachStatusBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteCoachStatusByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteCoachTipsArgs = {
  where: CoachTipsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteCoachTipsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteCommentVoteArgs = {
  where: CommentVoteBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteCommentVoteByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteCommunicationPreferenceStatusesArgs = {
  where: CommunicationPreferenceStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteCommunicationPreferenceStatusesByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteCompetitionFormatsArgs = {
  where: CompetitionFormatsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteCompetitionFormatsByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteCompetitionGenderArgs = {
  where: CompetitionGenderBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteCompetitionGenderByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteContentReportsArgs = {
  where: ContentReportsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteContentReportsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteConversationParticipantsArgs = {
  where: ConversationParticipantsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteConversationParticipantsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteConversationTypesArgs = {
  where: ConversationTypesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteConversationTypesByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteConversationsArgs = {
  where: ConversationsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteConversationsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteCountriesArgs = {
  where: CountriesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteCountriesByPkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteCountrySubdivisionsArgs = {
  where: CountrySubdivisionsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteCountrySubdivisionsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteCourtSurfacesArgs = {
  where: CourtSurfacesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteCourtSurfacesByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteDayOfWeekArgs = {
  where: DayOfWeekBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteDayOfWeekByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteEngagementAnalyticsArgs = {
  where: EngagementAnalyticsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteEngagementAnalyticsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteEngagementEntityTypesArgs = {
  where: EngagementEntityTypesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteEngagementEntityTypesByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteEngagementEventTypesArgs = {
  where: EngagementEventTypesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteEngagementEventTypesByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteEngagementSourcesArgs = {
  where: EngagementSourcesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteEngagementSourcesByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteEquipmentAvailabilitiesArgs = {
  where: EquipmentAvailabilitiesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteEquipmentAvailabilitiesByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteEventAcceptedPlayRequestsArgs = {
  where: EventAcceptedPlayRequestsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteEventAgeGroupsArgs = {
  where: EventAgeGroupsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteEventAgeGroupsByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteEventCollectionsArgs = {
  where: EventCollectionsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteEventCollectionsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteEventCompetitivenessArgs = {
  where: EventCompetitivenessBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteEventCompetitivenessByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteEventContactDetailsArgs = {
  where: EventContactDetailsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteEventContactDetailsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteEventCouponGroupsArgs = {
  where: EventCouponGroupsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteEventCouponGroupsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteEventCouponRedemptionsArgs = {
  where: EventCouponRedemptionsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteEventCouponRedemptionsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteEventCouponSourceArgs = {
  where: EventCouponSourceBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteEventCouponSourceByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteEventCouponTypeArgs = {
  where: EventCouponTypeBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteEventCouponTypeByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteEventCouponsArgs = {
  where: EventCouponsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteEventCouponsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteEventCourtStatusesArgs = {
  where: EventCourtStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteEventCourtStatusesByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteEventCourtsArgs = {
  where: EventCourtsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteEventCourtsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteEventFaqsArgs = {
  where: EventFaqsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteEventFaqsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteEventGameScoresArgs = {
  where: EventGameScoresBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteEventGameScoresByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteEventGroupFormatsArgs = {
  where: EventGroupFormatsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteEventGroupFormatsByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteEventGroupMergesArgs = {
  where: EventGroupMergesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteEventGroupMergesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteEventGroupPoolsArgs = {
  where: EventGroupPoolsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteEventGroupPoolsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteEventGroupRatingScalesArgs = {
  where: EventGroupRatingScalesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteEventGroupRatingScalesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteEventGroupRegistrationStatusesArgs = {
  where: EventGroupRegistrationStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteEventGroupRegistrationStatusesByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteEventGroupRegistrationsArgs = {
  where: EventGroupRegistrationsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteEventGroupRegistrationsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteEventGroupSequenceSeedingArgs = {
  where: EventGroupSequenceSeedingBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteEventGroupSequenceSeedingByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteEventGroupSequencesArgs = {
  where: EventGroupSequencesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteEventGroupSequencesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteEventGroupTimeSlotsArgs = {
  where: EventGroupTimeSlotsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteEventGroupTimeSlotsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteEventGroupsArgs = {
  where: EventGroupsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteEventGroupsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteEventInvitationStatusesArgs = {
  where: EventInvitationStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteEventInvitationStatusesByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteEventInvitationTypesArgs = {
  where: EventInvitationTypesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteEventInvitationTypesByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteEventInvitationsArgs = {
  where: EventInvitationsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteEventInvitationsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteEventListingFeesArgs = {
  where: EventListingFeesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteEventListingFeesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteEventMatchGamesArgs = {
  where: EventMatchGamesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteEventMatchGamesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteEventMatchesArgs = {
  where: EventMatchesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteEventMatchesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteEventMatchesTeamsArgs = {
  where: EventMatchesTeamsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteEventMatchesTeamsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteEventOrganizerAccountTypesArgs = {
  where: EventOrganizerAccountTypesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteEventOrganizerAccountTypesByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteEventPlayerInviteStatusesArgs = {
  where: EventPlayerInviteStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteEventPlayerInviteStatusesByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteEventPlayerInvitesArgs = {
  where: EventPlayerInvitesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteEventPlayerInvitesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteEventPoolRoundsArgs = {
  where: EventPoolRoundsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteEventPoolRoundsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteEventPoolsTeamsArgs = {
  where: EventPoolsTeamsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteEventPoolsTeamsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteEventPrivacyArgs = {
  where: EventPrivacyBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteEventPrivacyByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteEventRegistrationDetailsArgs = {
  where: EventRegistrationDetailsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteEventRegistrationDetailsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteEventRegistrationsArgs = {
  where: EventRegistrationsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteEventRegistrationsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteEventSequenceCompleteReasonsArgs = {
  where: EventSequenceCompleteReasonsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteEventSequenceCompleteReasonsByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteEventSkillLevelsArgs = {
  where: EventSkillLevelsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteEventSkillLevelsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteEventSponsorsArgs = {
  where: EventSponsorsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteEventSponsorsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteEventStatusesArgs = {
  where: EventStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteEventStatusesByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteEventTeamMemberStatusesArgs = {
  where: EventTeamMemberStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteEventTeamMemberStatusesByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteEventTeamMembersArgs = {
  where: EventTeamMembersBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteEventTeamMembersByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteEventTeamStatusesArgs = {
  where: EventTeamStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteEventTeamStatusesByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteEventTeamsArgs = {
  where: EventTeamsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteEventTeamsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteEventTransactionItemTypesArgs = {
  where: EventTransactionItemTypesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteEventTransactionItemTypesByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteEventTransactionItemsArgs = {
  where: EventTransactionItemsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteEventTransactionItemsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteEventTransactionsArgs = {
  where: EventTransactionsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteEventTransactionsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteEventTypesArgs = {
  where: EventTypesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteEventTypesByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteEventsArgs = {
  where: EventsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteEventsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteFeedbackSentimentArgs = {
  where: FeedbackSentimentBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteFeedbackSentimentByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteFileCategoryArgs = {
  where: FileCategoryBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteFileCategoryByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteFileFormatArgs = {
  where: FileFormatBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteFileFormatByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteFollowStatusesArgs = {
  where: FollowStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteFollowStatusesByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteGameNetStatusesArgs = {
  where: GameNetStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteGameNetStatusesByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteGenderArgs = {
  where: GenderBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteGenderByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteGroupCommentVotesArgs = {
  where: GroupCommentVotesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteGroupCommentVotesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteGroupMembersArgs = {
  where: GroupMembersBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteGroupMembersByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteGroupThreadCommentFilesArgs = {
  where: GroupThreadCommentFilesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteGroupThreadCommentFilesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteGroupThreadCommentsArgs = {
  where: GroupThreadCommentsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteGroupThreadCommentsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteGroupThreadsArgs = {
  where: GroupThreadsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteGroupThreadsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteGroupTypesArgs = {
  where: GroupTypesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteGroupTypesByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteGroupVenuesArgs = {
  where: GroupVenuesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteGroupVenuesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteGroupsArgs = {
  where: GroupsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteGroupsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteGroupsPlaySessionsArgs = {
  where: GroupsPlaySessionsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteGroupsPlaySessionsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteIdentityVerificationProvidersArgs = {
  where: IdentityVerificationProvidersBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteIdentityVerificationProvidersByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteIdentityVerificationStatusesArgs = {
  where: IdentityVerificationStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteIdentityVerificationStatusesByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteInvoicesArgs = {
  where: InvoicesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteInvoicesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteLearningProgramEnrollmentScheduleMediaWatchedArgs = {
  where: LearningProgramEnrollmentScheduleMediaWatchedBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteLearningProgramEnrollmentScheduleMediaWatchedByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteLearningProgramEnrollmentScheduleProgressArgs = {
  where: LearningProgramEnrollmentScheduleProgressBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteLearningProgramEnrollmentScheduleProgressByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteLearningProgramEnrollmentsArgs = {
  where: LearningProgramEnrollmentsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteLearningProgramEnrollmentsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteLearningProgramMediaArgs = {
  where: LearningProgramMediaBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteLearningProgramMediaByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteLearningProgramMediaCategoriesArgs = {
  where: LearningProgramMediaCategoriesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteLearningProgramMediaCategoriesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteLearningProgramScheduleMediaArgs = {
  where: LearningProgramScheduleMediaBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteLearningProgramScheduleMediaByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteLearningProgramScheduleUnitsArgs = {
  where: LearningProgramScheduleUnitsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteLearningProgramScheduleUnitsByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteLearningProgramScheduleVideoSubmissionsArgs = {
  where: LearningProgramScheduleVideoSubmissionsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteLearningProgramScheduleVideoSubmissionsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteLearningProgramSchedulesArgs = {
  where: LearningProgramSchedulesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteLearningProgramSchedulesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteLearningProgramSkillLevelValuesArgs = {
  where: LearningProgramSkillLevelValuesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteLearningProgramSkillLevelValuesByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteLearningProgramSkillsArgs = {
  where: LearningProgramSkillsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteLearningProgramSkillsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteLearningProgramsArgs = {
  where: LearningProgramsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteLearningProgramsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteLessonAgeGroupsArgs = {
  where: LessonAgeGroupsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteLessonAgeGroupsByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteLessonCollectionsArgs = {
  where: LessonCollectionsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteLessonCollectionsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteLessonEquipmentArgs = {
  where: LessonEquipmentBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteLessonEquipmentByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteLessonEquipmentOptionsArgs = {
  where: LessonEquipmentOptionsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteLessonEquipmentOptionsByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteLessonOrderItemsArgs = {
  where: LessonOrderItemsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteLessonOrderItemsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteLessonOrdersArgs = {
  where: LessonOrdersBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteLessonOrdersByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteLessonParticipantStatusesArgs = {
  where: LessonParticipantStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteLessonParticipantStatusesByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteLessonParticipantsArgs = {
  where: LessonParticipantsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteLessonParticipantsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteLessonPlayerSkillAssessmentCategoriesArgs = {
  where: LessonPlayerSkillAssessmentCategoriesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteLessonPlayerSkillAssessmentCategoriesByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteLessonPlayerSkillAssessmentsArgs = {
  where: LessonPlayerSkillAssessmentsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteLessonPlayerSkillAssessmentsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteLessonPlayerSkillAssessmentsSkillsArgs = {
  where: LessonPlayerSkillAssessmentsSkillsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteLessonPlayerSkillAssessmentsSkillsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteLessonPrivacyArgs = {
  where: LessonPrivacyBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteLessonPrivacyByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteLessonReflectionCommentTypesArgs = {
  where: LessonReflectionCommentTypesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteLessonReflectionCommentTypesByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteLessonReflectionCommentsArgs = {
  where: LessonReflectionCommentsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteLessonReflectionCommentsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteLessonReflectionFilesArgs = {
  where: LessonReflectionFilesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteLessonReflectionFilesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteLessonReflectionsArgs = {
  where: LessonReflectionsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteLessonReflectionsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteLessonSkillCategoriesArgs = {
  where: LessonSkillCategoriesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteLessonSkillCategoriesByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteLessonSkillDisplayNamesArgs = {
  where: LessonSkillDisplayNamesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteLessonSkillDisplayNamesByPkArgs = {
  id: LessonSkillsEnum;
};


/** mutation root */
export type Mutation_RootDeleteLessonSkillLevelsArgs = {
  where: LessonSkillLevelsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteLessonSkillLevelsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteLessonSkillMappingsArgs = {
  where: LessonSkillMappingsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteLessonSkillMappingsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteLessonSkillsArgs = {
  where: LessonSkillsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteLessonSkillsByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteLessonStatusesArgs = {
  where: LessonStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteLessonStatusesByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteLessonTemplateSkillLevelsArgs = {
  where: LessonTemplateSkillLevelsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteLessonTemplateSkillLevelsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteLessonTemplatesArgs = {
  where: LessonTemplatesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteLessonTemplatesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteLessonTimesArgs = {
  where: LessonTimesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteLessonTimesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteLessonTypesArgs = {
  where: LessonTypesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteLessonTypesByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteLessonWaitlistStatusesArgs = {
  where: LessonWaitlistStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteLessonWaitlistStatusesByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteLessonWaitlistsArgs = {
  where: LessonWaitlistsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteLessonWaitlistsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteLessonsArgs = {
  where: LessonsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteLessonsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteMatchSelectionCriteriaArgs = {
  where: MatchSelectionCriteriaBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteMatchSelectionCriteriaByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteMessagesArgs = {
  where: MessagesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteMessagesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteNeighborhoodsArgs = {
  where: NeighborhoodsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteNeighborhoodsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteNotificationActionTypesArgs = {
  where: NotificationActionTypesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteNotificationActionTypesByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteNotificationStatusesArgs = {
  where: NotificationStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteNotificationStatusesByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteOrderStatusesArgs = {
  where: OrderStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteOrderStatusesByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeletePadelRatingScalesArgs = {
  where: PadelRatingScalesBoolExp;
};


/** mutation root */
export type Mutation_RootDeletePadelRatingScalesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteParticipantRolesArgs = {
  where: ParticipantRolesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteParticipantRolesByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeletePartnerBookingAttemptEventsArgs = {
  where: PartnerBookingAttemptEventsBoolExp;
};


/** mutation root */
export type Mutation_RootDeletePartnerBookingAttemptEventsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeletePartnerBookingAttemptStatusesArgs = {
  where: PartnerBookingAttemptStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootDeletePartnerBookingAttemptStatusesByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeletePartnerBookingAttemptsArgs = {
  where: PartnerBookingAttemptsBoolExp;
};


/** mutation root */
export type Mutation_RootDeletePartnerBookingAttemptsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeletePartnerBookingEnginesArgs = {
  where: PartnerBookingEnginesBoolExp;
};


/** mutation root */
export type Mutation_RootDeletePartnerBookingEnginesByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeletePartnerBookingEventSourcesArgs = {
  where: PartnerBookingEventSourcesBoolExp;
};


/** mutation root */
export type Mutation_RootDeletePartnerBookingEventSourcesByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeletePartnerBookingHoldsArgs = {
  where: PartnerBookingHoldsBoolExp;
};


/** mutation root */
export type Mutation_RootDeletePartnerBookingHoldsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeletePartnerBookingOrderStatusesArgs = {
  where: PartnerBookingOrderStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootDeletePartnerBookingOrderStatusesByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeletePartnerBookingOrdersArgs = {
  where: PartnerBookingOrdersBoolExp;
};


/** mutation root */
export type Mutation_RootDeletePartnerBookingOrdersByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeletePartnerBookingVerificationMethodsArgs = {
  where: PartnerBookingVerificationMethodsBoolExp;
};


/** mutation root */
export type Mutation_RootDeletePartnerBookingVerificationMethodsByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeletePaymentFulfillmentChannelsArgs = {
  where: PaymentFulfillmentChannelsBoolExp;
};


/** mutation root */
export type Mutation_RootDeletePaymentFulfillmentChannelsByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeletePaymentProcessorsArgs = {
  where: PaymentProcessorsBoolExp;
};


/** mutation root */
export type Mutation_RootDeletePaymentProcessorsByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeletePaymentStatusesArgs = {
  where: PaymentStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootDeletePaymentStatusesByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeletePickleballRatingScalesArgs = {
  where: PickleballRatingScalesBoolExp;
};


/** mutation root */
export type Mutation_RootDeletePickleballRatingScalesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeletePlatformSubscriptionIntervalsArgs = {
  where: PlatformSubscriptionIntervalsBoolExp;
};


/** mutation root */
export type Mutation_RootDeletePlatformSubscriptionIntervalsByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeletePlatformSubscriptionPersonasArgs = {
  where: PlatformSubscriptionPersonasBoolExp;
};


/** mutation root */
export type Mutation_RootDeletePlatformSubscriptionPersonasByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeletePlatformSubscriptionPlanPricesArgs = {
  where: PlatformSubscriptionPlanPricesBoolExp;
};


/** mutation root */
export type Mutation_RootDeletePlatformSubscriptionPlanPricesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeletePlatformSubscriptionPlansArgs = {
  where: PlatformSubscriptionPlansBoolExp;
};


/** mutation root */
export type Mutation_RootDeletePlatformSubscriptionPlansByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeletePlatformSubscriptionsArgs = {
  where: PlatformSubscriptionsBoolExp;
};


/** mutation root */
export type Mutation_RootDeletePlatformSubscriptionsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeletePlayRequestNeighborhoodsArgs = {
  where: PlayRequestNeighborhoodsBoolExp;
};


/** mutation root */
export type Mutation_RootDeletePlayRequestNeighborhoodsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeletePlayRequestSlotsArgs = {
  where: PlayRequestSlotsBoolExp;
};


/** mutation root */
export type Mutation_RootDeletePlayRequestSlotsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeletePlayRequestStatusesArgs = {
  where: PlayRequestStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootDeletePlayRequestStatusesByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeletePlayRequestVenuesArgs = {
  where: PlayRequestVenuesBoolExp;
};


/** mutation root */
export type Mutation_RootDeletePlayRequestVenuesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeletePlayRequestsArgs = {
  where: PlayRequestsBoolExp;
};


/** mutation root */
export type Mutation_RootDeletePlayRequestsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeletePlaySessionCommentsArgs = {
  where: PlaySessionCommentsBoolExp;
};


/** mutation root */
export type Mutation_RootDeletePlaySessionCommentsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeletePlaySessionCourtBookingStatusesArgs = {
  where: PlaySessionCourtBookingStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootDeletePlaySessionCourtBookingStatusesByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeletePlaySessionFormatsArgs = {
  where: PlaySessionFormatsBoolExp;
};


/** mutation root */
export type Mutation_RootDeletePlaySessionFormatsByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeletePlaySessionMatchCompetitivenessArgs = {
  where: PlaySessionMatchCompetitivenessBoolExp;
};


/** mutation root */
export type Mutation_RootDeletePlaySessionMatchCompetitivenessByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeletePlaySessionParticipantStatusesArgs = {
  where: PlaySessionParticipantStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootDeletePlaySessionParticipantStatusesByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeletePlaySessionParticipantsArgs = {
  where: PlaySessionParticipantsBoolExp;
};


/** mutation root */
export type Mutation_RootDeletePlaySessionParticipantsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeletePlaySessionPrivacyArgs = {
  where: PlaySessionPrivacyBoolExp;
};


/** mutation root */
export type Mutation_RootDeletePlaySessionPrivacyByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeletePlaySessionStatusesArgs = {
  where: PlaySessionStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootDeletePlaySessionStatusesByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeletePlaySessionsArgs = {
  where: PlaySessionsBoolExp;
};


/** mutation root */
export type Mutation_RootDeletePlaySessionsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeletePlayerAvailabilitiesArgs = {
  where: PlayerAvailabilitiesBoolExp;
};


/** mutation root */
export type Mutation_RootDeletePlayerAvailabilitiesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeletePlayerAvailabilityNeighborhoodsArgs = {
  where: PlayerAvailabilityNeighborhoodsBoolExp;
};


/** mutation root */
export type Mutation_RootDeletePlayerAvailabilityNeighborhoodsByPkArgs = {
  availabilityId: Scalars['uuid'];
  neighborhoodId: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeletePlayerAvailabilityRatingScalesArgs = {
  where: PlayerAvailabilityRatingScalesBoolExp;
};


/** mutation root */
export type Mutation_RootDeletePlayerAvailabilityRatingScalesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeletePlayerAvailabilitySlotsArgs = {
  where: PlayerAvailabilitySlotsBoolExp;
};


/** mutation root */
export type Mutation_RootDeletePlayerAvailabilitySlotsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeletePlayerAvailabilityVenuesArgs = {
  where: PlayerAvailabilityVenuesBoolExp;
};


/** mutation root */
export type Mutation_RootDeletePlayerAvailabilityVenuesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeletePlayerFinderGoalsArgs = {
  where: PlayerFinderGoalsBoolExp;
};


/** mutation root */
export type Mutation_RootDeletePlayerFinderGoalsByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeletePlayerFinderTimeOfDayArgs = {
  where: PlayerFinderTimeOfDayBoolExp;
};


/** mutation root */
export type Mutation_RootDeletePlayerFinderTimeOfDayByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteRecurrenceKindsArgs = {
  where: RecurrenceKindsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteRecurrenceKindsByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteReportReasonsArgs = {
  where: ReportReasonsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteReportReasonsByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteReportStatusesArgs = {
  where: ReportStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteReportStatusesByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteReviewsArgs = {
  where: ReviewsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteReviewsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteSalesArgs = {
  where: SalesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteSalesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteScoringFormatArgs = {
  where: ScoringFormatBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteScoringFormatByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteSignupRequestsArgs = {
  where: SignupRequestsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteSignupRequestsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteSkillLevelValuesArgs = {
  where: SkillLevelValuesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteSkillLevelValuesByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteSkillLevelsArgs = {
  where: SkillLevelsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteSkillLevelsByPkArgs = {
  id: SkillLevelValuesEnum;
};


/** mutation root */
export type Mutation_RootDeleteSportsArgs = {
  where: SportsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteSportsByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteStripeChargesArgs = {
  where: StripeChargesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteStripeChargesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteStripePaymentIntentsArgs = {
  where: StripePaymentIntentsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteStripePaymentIntentsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteSubscriptionStatusesArgs = {
  where: SubscriptionStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteSubscriptionStatusesByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteTeamTypesArgs = {
  where: TeamTypesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteTeamTypesByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteTennisRatingScalesArgs = {
  where: TennisRatingScalesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteTennisRatingScalesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteTwilioGroupTextsArgs = {
  where: TwilioGroupTextsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteTwilioGroupTextsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteUploadReviewRequestsArgs = {
  where: UploadReviewRequestsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteUploadReviewRequestsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteUserAuthIdentitiesArgs = {
  where: UserAuthIdentitiesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteUserAuthIdentitiesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteUserBlocksArgs = {
  where: UserBlocksBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteUserBlocksByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteUserCoachServicesArgs = {
  where: UserCoachServicesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteUserCoachServicesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteUserCommunicationPreferencesArgs = {
  where: UserCommunicationPreferencesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteUserCommunicationPreferencesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteUserConnectionRequestStatusesArgs = {
  where: UserConnectionRequestStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteUserConnectionRequestStatusesByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteUserConnectionRequestsArgs = {
  where: UserConnectionRequestsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteUserConnectionRequestsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteUserConnectionsArgs = {
  where: UserConnectionsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteUserConnectionsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteUserContentBetaSubscriptionsArgs = {
  where: UserContentBetaSubscriptionsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteUserContentBetaSubscriptionsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteUserContentFilesArgs = {
  where: UserContentFilesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteUserContentFilesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteUserContentFilesSkillsArgs = {
  where: UserContentFilesSkillsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteUserContentFilesSkillsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteUserContentSkillsArgs = {
  where: UserContentSkillsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteUserContentSkillsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteUserContentTiersArgs = {
  where: UserContentTiersBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteUserContentTiersByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteUserCreditCardsArgs = {
  where: UserCreditCardsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteUserCreditCardsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteUserCustomCourtsArgs = {
  where: UserCustomCourtsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteUserCustomCourtsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteUserFilesArgs = {
  where: UserFilesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteUserFilesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteUserFollowsArgs = {
  where: UserFollowsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteUserFollowsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteUserIdentityVerificationsArgs = {
  where: UserIdentityVerificationsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteUserIdentityVerificationsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteUserImageLogArgs = {
  where: UserImageLogBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteUserImageLogByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteUserNotificationDetailsArgs = {
  where: UserNotificationDetailsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteUserNotificationDetailsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteUserNotificationEntitiesArgs = {
  where: UserNotificationEntitiesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteUserNotificationEntitiesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteUserNotificationsArgs = {
  where: UserNotificationsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteUserNotificationsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteUserPadelRatingScalesArgs = {
  where: UserPadelRatingScalesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteUserPadelRatingScalesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteUserPickleballRatingScalesArgs = {
  where: UserPickleballRatingScalesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteUserPickleballRatingScalesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteUserPlayedWithDismissalsArgs = {
  where: UserPlayedWithDismissalsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteUserPlayedWithDismissalsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteUserPlayerFinderAvailabilityArgs = {
  where: UserPlayerFinderAvailabilityBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteUserPlayerFinderAvailabilityByPkArgs = {
  dayOfWeek: DayOfWeekEnum;
  timeOfDay: PlayerFinderTimeOfDayEnum;
  userId: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteUserPlayerFinderGoalsArgs = {
  where: UserPlayerFinderGoalsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteUserPlayerFinderGoalsByPkArgs = {
  goal: PlayerFinderGoalsEnum;
  userId: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteUserProfilesArgs = {
  where: UserProfilesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteUserRegistrationDetailsArgs = {
  where: UserRegistrationDetailsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteUserRegistrationDetailsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteUserSportsArgs = {
  where: UserSportsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteUserSportsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteUserTennisRatingScalesArgs = {
  where: UserTennisRatingScalesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteUserTennisRatingScalesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteUserTermsOfServiceArgs = {
  where: UserTermsOfServiceBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteUserTermsOfServiceByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteUserVairConnectionsArgs = {
  where: UserVairConnectionsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteUserVairConnectionsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteUsernameLogsArgs = {
  where: UsernameLogsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteUsernameLogsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteUsernamesActiveArgs = {
  where: UsernamesActiveBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteUsernamesClaimedArgs = {
  where: UsernamesClaimedBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteUsernamesClaimedByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteUsersArgs = {
  where: UsersBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteUsersByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteUsersCoachQualificationsArgs = {
  where: UsersCoachQualificationsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteUsersCoachQualificationsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteVenueAccessTypesArgs = {
  where: VenueAccessTypesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteVenueAccessTypesByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteVenueAdminClaimStatusesArgs = {
  where: VenueAdminClaimStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteVenueAdminClaimStatusesByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteVenueAdminClaimsArgs = {
  where: VenueAdminClaimsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteVenueAdminClaimsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteVenueAmenitiesArgs = {
  where: VenueAmenitiesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteVenueAmenitiesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteVenueBookingConfigVersionsArgs = {
  where: VenueBookingConfigVersionsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteVenueBookingConfigVersionsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteVenueBookingConnectionCheckStatusesArgs = {
  where: VenueBookingConnectionCheckStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteVenueBookingConnectionCheckStatusesByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteVenueBookingConnectionChecksArgs = {
  where: VenueBookingConnectionChecksBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteVenueBookingConnectionChecksByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteVenueBookingCourtRatesArgs = {
  where: VenueBookingCourtRatesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteVenueBookingCourtRatesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteVenueBookingIntegrationsArgs = {
  where: VenueBookingIntegrationsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteVenueBookingIntegrationsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteVenueBookingRuleTiersArgs = {
  where: VenueBookingRuleTiersBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteVenueBookingRuleTiersByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteVenueBookingRulesArgs = {
  where: VenueBookingRulesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteVenueBookingRulesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteVenueBookingWindowsArgs = {
  where: VenueBookingWindowsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteVenueBookingWindowsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteVenueCourtSurfacesArgs = {
  where: VenueCourtSurfacesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteVenueCourtSurfacesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteVenueCustomAmenitiesArgs = {
  where: VenueCustomAmenitiesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteVenueCustomAmenitiesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteVenueEquipmentArgs = {
  where: VenueEquipmentBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteVenueEquipmentByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteVenueFacilityTypesArgs = {
  where: VenueFacilityTypesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteVenueFacilityTypesByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteVenueFaqsArgs = {
  where: VenueFaqsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteVenueFaqsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteVenueFollowsArgs = {
  where: VenueFollowsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteVenueFollowsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteVenueImagesArgs = {
  where: VenueImagesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteVenueImagesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteVenueLinesArgs = {
  where: VenueLinesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteVenueLinesByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteVenueNetsArgs = {
  where: VenueNetsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteVenueNetsByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteVenuePartnerBookingStatusesArgs = {
  where: VenuePartnerBookingStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteVenueStaffCoachesArgs = {
  where: VenueStaffCoachesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteVenueStaffCoachesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteVenuesArgs = {
  where: VenuesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteVenuesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteVideoAnalysisArgs = {
  where: VideoAnalysisBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteVideoAnalysisByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteVideoAnalysisCommentsArgs = {
  where: VideoAnalysisCommentsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteVideoAnalysisCommentsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteVideoAnalysisFilesArgs = {
  where: VideoAnalysisFilesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteVideoAnalysisFilesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteVideoAnalysisFilesUploadStatusesArgs = {
  where: VideoAnalysisFilesUploadStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteVideoAnalysisFilesUploadStatusesByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteVideoAnalysisOrderItemsArgs = {
  where: VideoAnalysisOrderItemsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteVideoAnalysisOrderItemsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteVideoAnalysisOrdersArgs = {
  where: VideoAnalysisOrdersBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteVideoAnalysisOrdersByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteVideoAnalysisRequestedSkillsReviewArgs = {
  where: VideoAnalysisRequestedSkillsReviewBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteVideoAnalysisRequestedSkillsReviewByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteVideoAnalysisReviewStatusesArgs = {
  where: VideoAnalysisReviewStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteVideoAnalysisReviewStatusesByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteVideoAnalysisSkillsCommentsArgs = {
  where: VideoAnalysisSkillsCommentsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteVideoAnalysisSkillsCommentsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteVideoAnalysisSubmissionLogArgs = {
  where: VideoAnalysisSubmissionLogBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteVideoAnalysisSubmissionLogByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteVideoLessonSkillsArgs = {
  where: VideoLessonSkillsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteVideoLessonSkillsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteWelcomeEmailConfigurationArgs = {
  where: WelcomeEmailConfigurationBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteWelcomeEmailConfigurationByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteWinReasonsArgs = {
  where: WinReasonsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteWinReasonsByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootInsertAmenitiesArgs = {
  objects: Array<AmenitiesInsertInput>;
  onConflict?: InputMaybe<AmenitiesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertAmenitiesOneArgs = {
  object: AmenitiesInsertInput;
  onConflict?: InputMaybe<AmenitiesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertAppPersonasArgs = {
  objects: Array<AppPersonasInsertInput>;
  onConflict?: InputMaybe<AppPersonasOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertAppPersonasOneArgs = {
  object: AppPersonasInsertInput;
  onConflict?: InputMaybe<AppPersonasOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertAppPingsArgs = {
  objects: Array<AppPingsInsertInput>;
  onConflict?: InputMaybe<AppPingsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertAppPingsOneArgs = {
  object: AppPingsInsertInput;
  onConflict?: InputMaybe<AppPingsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertBallTypesArgs = {
  objects: Array<BallTypesInsertInput>;
  onConflict?: InputMaybe<BallTypesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertBallTypesOneArgs = {
  object: BallTypesInsertInput;
  onConflict?: InputMaybe<BallTypesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertBirthdayVisibilityArgs = {
  objects: Array<BirthdayVisibilityInsertInput>;
  onConflict?: InputMaybe<BirthdayVisibilityOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertBirthdayVisibilityOneArgs = {
  object: BirthdayVisibilityInsertInput;
  onConflict?: InputMaybe<BirthdayVisibilityOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertBookingConfigChangeTypesArgs = {
  objects: Array<BookingConfigChangeTypesInsertInput>;
  onConflict?: InputMaybe<BookingConfigChangeTypesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertBookingConfigChangeTypesOneArgs = {
  object: BookingConfigChangeTypesInsertInput;
  onConflict?: InputMaybe<BookingConfigChangeTypesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertBookingConnectionStatusesArgs = {
  objects: Array<BookingConnectionStatusesInsertInput>;
  onConflict?: InputMaybe<BookingConnectionStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertBookingConnectionStatusesOneArgs = {
  object: BookingConnectionStatusesInsertInput;
  onConflict?: InputMaybe<BookingConnectionStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertBookingIntegrationStatusesArgs = {
  objects: Array<BookingIntegrationStatusesInsertInput>;
  onConflict?: InputMaybe<BookingIntegrationStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertBookingIntegrationStatusesOneArgs = {
  object: BookingIntegrationStatusesInsertInput;
  onConflict?: InputMaybe<BookingIntegrationStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertBookingInventoryTypesArgs = {
  objects: Array<BookingInventoryTypesInsertInput>;
  onConflict?: InputMaybe<BookingInventoryTypesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertBookingInventoryTypesOneArgs = {
  object: BookingInventoryTypesInsertInput;
  onConflict?: InputMaybe<BookingInventoryTypesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertBookingScheduleModesArgs = {
  objects: Array<BookingScheduleModesInsertInput>;
  onConflict?: InputMaybe<BookingScheduleModesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertBookingScheduleModesOneArgs = {
  object: BookingScheduleModesInsertInput;
  onConflict?: InputMaybe<BookingScheduleModesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertBookingSystemsArgs = {
  objects: Array<BookingSystemsInsertInput>;
  onConflict?: InputMaybe<BookingSystemsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertBookingSystemsOneArgs = {
  object: BookingSystemsInsertInput;
  onConflict?: InputMaybe<BookingSystemsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertBookingWindowKindsArgs = {
  objects: Array<BookingWindowKindsInsertInput>;
  onConflict?: InputMaybe<BookingWindowKindsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertBookingWindowKindsOneArgs = {
  object: BookingWindowKindsInsertInput;
  onConflict?: InputMaybe<BookingWindowKindsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertBoostChannelsArgs = {
  objects: Array<BoostChannelsInsertInput>;
  onConflict?: InputMaybe<BoostChannelsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertBoostChannelsOneArgs = {
  object: BoostChannelsInsertInput;
  onConflict?: InputMaybe<BoostChannelsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertBoostOrdersArgs = {
  objects: Array<BoostOrdersInsertInput>;
  onConflict?: InputMaybe<BoostOrdersOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertBoostOrdersOneArgs = {
  object: BoostOrdersInsertInput;
  onConflict?: InputMaybe<BoostOrdersOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertBoostStatusesArgs = {
  objects: Array<BoostStatusesInsertInput>;
  onConflict?: InputMaybe<BoostStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertBoostStatusesOneArgs = {
  object: BoostStatusesInsertInput;
  onConflict?: InputMaybe<BoostStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertBoostsArgs = {
  objects: Array<BoostsInsertInput>;
  onConflict?: InputMaybe<BoostsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertBoostsOneArgs = {
  object: BoostsInsertInput;
  onConflict?: InputMaybe<BoostsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertBracketRankingMechanismArgs = {
  objects: Array<BracketRankingMechanismInsertInput>;
  onConflict?: InputMaybe<BracketRankingMechanismOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertBracketRankingMechanismOneArgs = {
  object: BracketRankingMechanismInsertInput;
  onConflict?: InputMaybe<BracketRankingMechanismOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCalendarAccountsArgs = {
  objects: Array<CalendarAccountsInsertInput>;
  onConflict?: InputMaybe<CalendarAccountsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCalendarAccountsOneArgs = {
  object: CalendarAccountsInsertInput;
  onConflict?: InputMaybe<CalendarAccountsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCalendarAuthProviderArgs = {
  objects: Array<CalendarAuthProviderInsertInput>;
  onConflict?: InputMaybe<CalendarAuthProviderOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCalendarAuthProviderOneArgs = {
  object: CalendarAuthProviderInsertInput;
  onConflict?: InputMaybe<CalendarAuthProviderOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCalendarEventMappingsArgs = {
  objects: Array<CalendarEventMappingsInsertInput>;
  onConflict?: InputMaybe<CalendarEventMappingsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCalendarEventMappingsOneArgs = {
  object: CalendarEventMappingsInsertInput;
  onConflict?: InputMaybe<CalendarEventMappingsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCalendarPreferencesArgs = {
  objects: Array<CalendarPreferencesInsertInput>;
  onConflict?: InputMaybe<CalendarPreferencesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCalendarPreferencesOneArgs = {
  object: CalendarPreferencesInsertInput;
  onConflict?: InputMaybe<CalendarPreferencesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCitiesArgs = {
  objects: Array<CitiesInsertInput>;
  onConflict?: InputMaybe<CitiesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCitiesOneArgs = {
  object: CitiesInsertInput;
  onConflict?: InputMaybe<CitiesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCoachAvailabilityArgs = {
  objects: Array<CoachAvailabilityInsertInput>;
  onConflict?: InputMaybe<CoachAvailabilityOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCoachAvailabilityOneArgs = {
  object: CoachAvailabilityInsertInput;
  onConflict?: InputMaybe<CoachAvailabilityOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCoachAvailabilityStatusesArgs = {
  objects: Array<CoachAvailabilityStatusesInsertInput>;
  onConflict?: InputMaybe<CoachAvailabilityStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCoachAvailabilityStatusesOneArgs = {
  object: CoachAvailabilityStatusesInsertInput;
  onConflict?: InputMaybe<CoachAvailabilityStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCoachBookingRequestsArgs = {
  objects: Array<CoachBookingRequestsInsertInput>;
  onConflict?: InputMaybe<CoachBookingRequestsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCoachBookingRequestsOneArgs = {
  object: CoachBookingRequestsInsertInput;
  onConflict?: InputMaybe<CoachBookingRequestsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCoachExternalReviewSourcesArgs = {
  objects: Array<CoachExternalReviewSourcesInsertInput>;
  onConflict?: InputMaybe<CoachExternalReviewSourcesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCoachExternalReviewSourcesOneArgs = {
  object: CoachExternalReviewSourcesInsertInput;
  onConflict?: InputMaybe<CoachExternalReviewSourcesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCoachFaqsArgs = {
  objects: Array<CoachFaqsInsertInput>;
  onConflict?: InputMaybe<CoachFaqsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCoachFaqsOneArgs = {
  object: CoachFaqsInsertInput;
  onConflict?: InputMaybe<CoachFaqsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCoachLessonAgeGroupsArgs = {
  objects: Array<CoachLessonAgeGroupsInsertInput>;
  onConflict?: InputMaybe<CoachLessonAgeGroupsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCoachLessonAgeGroupsOneArgs = {
  object: CoachLessonAgeGroupsInsertInput;
  onConflict?: InputMaybe<CoachLessonAgeGroupsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCoachLessonSkillLevelsArgs = {
  objects: Array<CoachLessonSkillLevelsInsertInput>;
  onConflict?: InputMaybe<CoachLessonSkillLevelsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCoachLessonSkillLevelsOneArgs = {
  object: CoachLessonSkillLevelsInsertInput;
  onConflict?: InputMaybe<CoachLessonSkillLevelsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCoachQualificationGroupsArgs = {
  objects: Array<CoachQualificationGroupsInsertInput>;
  onConflict?: InputMaybe<CoachQualificationGroupsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCoachQualificationGroupsOneArgs = {
  object: CoachQualificationGroupsInsertInput;
  onConflict?: InputMaybe<CoachQualificationGroupsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCoachQualificationStatusesArgs = {
  objects: Array<CoachQualificationStatusesInsertInput>;
  onConflict?: InputMaybe<CoachQualificationStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCoachQualificationStatusesOneArgs = {
  object: CoachQualificationStatusesInsertInput;
  onConflict?: InputMaybe<CoachQualificationStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCoachQualificationsArgs = {
  objects: Array<CoachQualificationsInsertInput>;
  onConflict?: InputMaybe<CoachQualificationsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCoachQualificationsOneArgs = {
  object: CoachQualificationsInsertInput;
  onConflict?: InputMaybe<CoachQualificationsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCoachReviewTypesArgs = {
  objects: Array<CoachReviewTypesInsertInput>;
  onConflict?: InputMaybe<CoachReviewTypesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCoachReviewTypesOneArgs = {
  object: CoachReviewTypesInsertInput;
  onConflict?: InputMaybe<CoachReviewTypesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCoachSportStatusesArgs = {
  objects: Array<CoachSportStatusesInsertInput>;
  onConflict?: InputMaybe<CoachSportStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCoachSportStatusesOneArgs = {
  object: CoachSportStatusesInsertInput;
  onConflict?: InputMaybe<CoachSportStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCoachSportsArgs = {
  objects: Array<CoachSportsInsertInput>;
  onConflict?: InputMaybe<CoachSportsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCoachSportsOneArgs = {
  object: CoachSportsInsertInput;
  onConflict?: InputMaybe<CoachSportsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCoachStarterProfilesArgs = {
  objects: Array<CoachStarterProfilesInsertInput>;
  onConflict?: InputMaybe<CoachStarterProfilesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCoachStarterProfilesOneArgs = {
  object: CoachStarterProfilesInsertInput;
  onConflict?: InputMaybe<CoachStarterProfilesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCoachStatusArgs = {
  objects: Array<CoachStatusInsertInput>;
  onConflict?: InputMaybe<CoachStatusOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCoachStatusOneArgs = {
  object: CoachStatusInsertInput;
  onConflict?: InputMaybe<CoachStatusOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCoachTipsArgs = {
  objects: Array<CoachTipsInsertInput>;
  onConflict?: InputMaybe<CoachTipsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCoachTipsOneArgs = {
  object: CoachTipsInsertInput;
  onConflict?: InputMaybe<CoachTipsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCommentVoteArgs = {
  objects: Array<CommentVoteInsertInput>;
  onConflict?: InputMaybe<CommentVoteOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCommentVoteOneArgs = {
  object: CommentVoteInsertInput;
  onConflict?: InputMaybe<CommentVoteOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCommunicationPreferenceStatusesArgs = {
  objects: Array<CommunicationPreferenceStatusesInsertInput>;
  onConflict?: InputMaybe<CommunicationPreferenceStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCommunicationPreferenceStatusesOneArgs = {
  object: CommunicationPreferenceStatusesInsertInput;
  onConflict?: InputMaybe<CommunicationPreferenceStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCompetitionFormatsArgs = {
  objects: Array<CompetitionFormatsInsertInput>;
  onConflict?: InputMaybe<CompetitionFormatsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCompetitionFormatsOneArgs = {
  object: CompetitionFormatsInsertInput;
  onConflict?: InputMaybe<CompetitionFormatsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCompetitionGenderArgs = {
  objects: Array<CompetitionGenderInsertInput>;
  onConflict?: InputMaybe<CompetitionGenderOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCompetitionGenderOneArgs = {
  object: CompetitionGenderInsertInput;
  onConflict?: InputMaybe<CompetitionGenderOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertContentReportsArgs = {
  objects: Array<ContentReportsInsertInput>;
  onConflict?: InputMaybe<ContentReportsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertContentReportsOneArgs = {
  object: ContentReportsInsertInput;
  onConflict?: InputMaybe<ContentReportsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertConversationParticipantsArgs = {
  objects: Array<ConversationParticipantsInsertInput>;
  onConflict?: InputMaybe<ConversationParticipantsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertConversationParticipantsOneArgs = {
  object: ConversationParticipantsInsertInput;
  onConflict?: InputMaybe<ConversationParticipantsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertConversationTypesArgs = {
  objects: Array<ConversationTypesInsertInput>;
  onConflict?: InputMaybe<ConversationTypesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertConversationTypesOneArgs = {
  object: ConversationTypesInsertInput;
  onConflict?: InputMaybe<ConversationTypesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertConversationsArgs = {
  objects: Array<ConversationsInsertInput>;
  onConflict?: InputMaybe<ConversationsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertConversationsOneArgs = {
  object: ConversationsInsertInput;
  onConflict?: InputMaybe<ConversationsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCountriesArgs = {
  objects: Array<CountriesInsertInput>;
  onConflict?: InputMaybe<CountriesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCountriesOneArgs = {
  object: CountriesInsertInput;
  onConflict?: InputMaybe<CountriesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCountrySubdivisionsArgs = {
  objects: Array<CountrySubdivisionsInsertInput>;
  onConflict?: InputMaybe<CountrySubdivisionsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCountrySubdivisionsOneArgs = {
  object: CountrySubdivisionsInsertInput;
  onConflict?: InputMaybe<CountrySubdivisionsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCourtSurfacesArgs = {
  objects: Array<CourtSurfacesInsertInput>;
  onConflict?: InputMaybe<CourtSurfacesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCourtSurfacesOneArgs = {
  object: CourtSurfacesInsertInput;
  onConflict?: InputMaybe<CourtSurfacesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertDayOfWeekArgs = {
  objects: Array<DayOfWeekInsertInput>;
  onConflict?: InputMaybe<DayOfWeekOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertDayOfWeekOneArgs = {
  object: DayOfWeekInsertInput;
  onConflict?: InputMaybe<DayOfWeekOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEngagementAnalyticsArgs = {
  objects: Array<EngagementAnalyticsInsertInput>;
  onConflict?: InputMaybe<EngagementAnalyticsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEngagementAnalyticsOneArgs = {
  object: EngagementAnalyticsInsertInput;
  onConflict?: InputMaybe<EngagementAnalyticsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEngagementEntityTypesArgs = {
  objects: Array<EngagementEntityTypesInsertInput>;
  onConflict?: InputMaybe<EngagementEntityTypesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEngagementEntityTypesOneArgs = {
  object: EngagementEntityTypesInsertInput;
  onConflict?: InputMaybe<EngagementEntityTypesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEngagementEventTypesArgs = {
  objects: Array<EngagementEventTypesInsertInput>;
  onConflict?: InputMaybe<EngagementEventTypesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEngagementEventTypesOneArgs = {
  object: EngagementEventTypesInsertInput;
  onConflict?: InputMaybe<EngagementEventTypesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEngagementSourcesArgs = {
  objects: Array<EngagementSourcesInsertInput>;
  onConflict?: InputMaybe<EngagementSourcesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEngagementSourcesOneArgs = {
  object: EngagementSourcesInsertInput;
  onConflict?: InputMaybe<EngagementSourcesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEquipmentAvailabilitiesArgs = {
  objects: Array<EquipmentAvailabilitiesInsertInput>;
  onConflict?: InputMaybe<EquipmentAvailabilitiesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEquipmentAvailabilitiesOneArgs = {
  object: EquipmentAvailabilitiesInsertInput;
  onConflict?: InputMaybe<EquipmentAvailabilitiesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventAcceptedPlayRequestsArgs = {
  objects: Array<EventAcceptedPlayRequestsInsertInput>;
};


/** mutation root */
export type Mutation_RootInsertEventAcceptedPlayRequestsOneArgs = {
  object: EventAcceptedPlayRequestsInsertInput;
};


/** mutation root */
export type Mutation_RootInsertEventAgeGroupsArgs = {
  objects: Array<EventAgeGroupsInsertInput>;
  onConflict?: InputMaybe<EventAgeGroupsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventAgeGroupsOneArgs = {
  object: EventAgeGroupsInsertInput;
  onConflict?: InputMaybe<EventAgeGroupsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventCollectionsArgs = {
  objects: Array<EventCollectionsInsertInput>;
  onConflict?: InputMaybe<EventCollectionsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventCollectionsOneArgs = {
  object: EventCollectionsInsertInput;
  onConflict?: InputMaybe<EventCollectionsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventCompetitivenessArgs = {
  objects: Array<EventCompetitivenessInsertInput>;
  onConflict?: InputMaybe<EventCompetitivenessOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventCompetitivenessOneArgs = {
  object: EventCompetitivenessInsertInput;
  onConflict?: InputMaybe<EventCompetitivenessOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventContactDetailsArgs = {
  objects: Array<EventContactDetailsInsertInput>;
  onConflict?: InputMaybe<EventContactDetailsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventContactDetailsOneArgs = {
  object: EventContactDetailsInsertInput;
  onConflict?: InputMaybe<EventContactDetailsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventCouponGroupsArgs = {
  objects: Array<EventCouponGroupsInsertInput>;
  onConflict?: InputMaybe<EventCouponGroupsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventCouponGroupsOneArgs = {
  object: EventCouponGroupsInsertInput;
  onConflict?: InputMaybe<EventCouponGroupsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventCouponRedemptionsArgs = {
  objects: Array<EventCouponRedemptionsInsertInput>;
  onConflict?: InputMaybe<EventCouponRedemptionsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventCouponRedemptionsOneArgs = {
  object: EventCouponRedemptionsInsertInput;
  onConflict?: InputMaybe<EventCouponRedemptionsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventCouponSourceArgs = {
  objects: Array<EventCouponSourceInsertInput>;
  onConflict?: InputMaybe<EventCouponSourceOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventCouponSourceOneArgs = {
  object: EventCouponSourceInsertInput;
  onConflict?: InputMaybe<EventCouponSourceOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventCouponTypeArgs = {
  objects: Array<EventCouponTypeInsertInput>;
  onConflict?: InputMaybe<EventCouponTypeOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventCouponTypeOneArgs = {
  object: EventCouponTypeInsertInput;
  onConflict?: InputMaybe<EventCouponTypeOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventCouponsArgs = {
  objects: Array<EventCouponsInsertInput>;
  onConflict?: InputMaybe<EventCouponsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventCouponsOneArgs = {
  object: EventCouponsInsertInput;
  onConflict?: InputMaybe<EventCouponsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventCourtStatusesArgs = {
  objects: Array<EventCourtStatusesInsertInput>;
  onConflict?: InputMaybe<EventCourtStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventCourtStatusesOneArgs = {
  object: EventCourtStatusesInsertInput;
  onConflict?: InputMaybe<EventCourtStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventCourtsArgs = {
  objects: Array<EventCourtsInsertInput>;
  onConflict?: InputMaybe<EventCourtsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventCourtsOneArgs = {
  object: EventCourtsInsertInput;
  onConflict?: InputMaybe<EventCourtsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventFaqsArgs = {
  objects: Array<EventFaqsInsertInput>;
  onConflict?: InputMaybe<EventFaqsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventFaqsOneArgs = {
  object: EventFaqsInsertInput;
  onConflict?: InputMaybe<EventFaqsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventGameScoresArgs = {
  objects: Array<EventGameScoresInsertInput>;
  onConflict?: InputMaybe<EventGameScoresOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventGameScoresOneArgs = {
  object: EventGameScoresInsertInput;
  onConflict?: InputMaybe<EventGameScoresOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventGroupFormatsArgs = {
  objects: Array<EventGroupFormatsInsertInput>;
  onConflict?: InputMaybe<EventGroupFormatsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventGroupFormatsOneArgs = {
  object: EventGroupFormatsInsertInput;
  onConflict?: InputMaybe<EventGroupFormatsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventGroupMergesArgs = {
  objects: Array<EventGroupMergesInsertInput>;
  onConflict?: InputMaybe<EventGroupMergesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventGroupMergesOneArgs = {
  object: EventGroupMergesInsertInput;
  onConflict?: InputMaybe<EventGroupMergesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventGroupPoolsArgs = {
  objects: Array<EventGroupPoolsInsertInput>;
  onConflict?: InputMaybe<EventGroupPoolsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventGroupPoolsOneArgs = {
  object: EventGroupPoolsInsertInput;
  onConflict?: InputMaybe<EventGroupPoolsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventGroupRatingScalesArgs = {
  objects: Array<EventGroupRatingScalesInsertInput>;
  onConflict?: InputMaybe<EventGroupRatingScalesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventGroupRatingScalesOneArgs = {
  object: EventGroupRatingScalesInsertInput;
  onConflict?: InputMaybe<EventGroupRatingScalesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventGroupRegistrationStatusesArgs = {
  objects: Array<EventGroupRegistrationStatusesInsertInput>;
  onConflict?: InputMaybe<EventGroupRegistrationStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventGroupRegistrationStatusesOneArgs = {
  object: EventGroupRegistrationStatusesInsertInput;
  onConflict?: InputMaybe<EventGroupRegistrationStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventGroupRegistrationsArgs = {
  objects: Array<EventGroupRegistrationsInsertInput>;
  onConflict?: InputMaybe<EventGroupRegistrationsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventGroupRegistrationsOneArgs = {
  object: EventGroupRegistrationsInsertInput;
  onConflict?: InputMaybe<EventGroupRegistrationsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventGroupSequenceSeedingArgs = {
  objects: Array<EventGroupSequenceSeedingInsertInput>;
  onConflict?: InputMaybe<EventGroupSequenceSeedingOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventGroupSequenceSeedingOneArgs = {
  object: EventGroupSequenceSeedingInsertInput;
  onConflict?: InputMaybe<EventGroupSequenceSeedingOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventGroupSequencesArgs = {
  objects: Array<EventGroupSequencesInsertInput>;
  onConflict?: InputMaybe<EventGroupSequencesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventGroupSequencesOneArgs = {
  object: EventGroupSequencesInsertInput;
  onConflict?: InputMaybe<EventGroupSequencesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventGroupTimeSlotsArgs = {
  objects: Array<EventGroupTimeSlotsInsertInput>;
  onConflict?: InputMaybe<EventGroupTimeSlotsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventGroupTimeSlotsOneArgs = {
  object: EventGroupTimeSlotsInsertInput;
  onConflict?: InputMaybe<EventGroupTimeSlotsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventGroupsArgs = {
  objects: Array<EventGroupsInsertInput>;
  onConflict?: InputMaybe<EventGroupsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventGroupsOneArgs = {
  object: EventGroupsInsertInput;
  onConflict?: InputMaybe<EventGroupsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventInvitationStatusesArgs = {
  objects: Array<EventInvitationStatusesInsertInput>;
  onConflict?: InputMaybe<EventInvitationStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventInvitationStatusesOneArgs = {
  object: EventInvitationStatusesInsertInput;
  onConflict?: InputMaybe<EventInvitationStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventInvitationTypesArgs = {
  objects: Array<EventInvitationTypesInsertInput>;
  onConflict?: InputMaybe<EventInvitationTypesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventInvitationTypesOneArgs = {
  object: EventInvitationTypesInsertInput;
  onConflict?: InputMaybe<EventInvitationTypesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventInvitationsArgs = {
  objects: Array<EventInvitationsInsertInput>;
  onConflict?: InputMaybe<EventInvitationsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventInvitationsOneArgs = {
  object: EventInvitationsInsertInput;
  onConflict?: InputMaybe<EventInvitationsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventListingFeesArgs = {
  objects: Array<EventListingFeesInsertInput>;
  onConflict?: InputMaybe<EventListingFeesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventListingFeesOneArgs = {
  object: EventListingFeesInsertInput;
  onConflict?: InputMaybe<EventListingFeesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventMatchGamesArgs = {
  objects: Array<EventMatchGamesInsertInput>;
  onConflict?: InputMaybe<EventMatchGamesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventMatchGamesOneArgs = {
  object: EventMatchGamesInsertInput;
  onConflict?: InputMaybe<EventMatchGamesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventMatchesArgs = {
  objects: Array<EventMatchesInsertInput>;
  onConflict?: InputMaybe<EventMatchesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventMatchesOneArgs = {
  object: EventMatchesInsertInput;
  onConflict?: InputMaybe<EventMatchesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventMatchesTeamsArgs = {
  objects: Array<EventMatchesTeamsInsertInput>;
  onConflict?: InputMaybe<EventMatchesTeamsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventMatchesTeamsOneArgs = {
  object: EventMatchesTeamsInsertInput;
  onConflict?: InputMaybe<EventMatchesTeamsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventOrganizerAccountTypesArgs = {
  objects: Array<EventOrganizerAccountTypesInsertInput>;
  onConflict?: InputMaybe<EventOrganizerAccountTypesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventOrganizerAccountTypesOneArgs = {
  object: EventOrganizerAccountTypesInsertInput;
  onConflict?: InputMaybe<EventOrganizerAccountTypesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventPlayerInviteStatusesArgs = {
  objects: Array<EventPlayerInviteStatusesInsertInput>;
  onConflict?: InputMaybe<EventPlayerInviteStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventPlayerInviteStatusesOneArgs = {
  object: EventPlayerInviteStatusesInsertInput;
  onConflict?: InputMaybe<EventPlayerInviteStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventPlayerInvitesArgs = {
  objects: Array<EventPlayerInvitesInsertInput>;
  onConflict?: InputMaybe<EventPlayerInvitesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventPlayerInvitesOneArgs = {
  object: EventPlayerInvitesInsertInput;
  onConflict?: InputMaybe<EventPlayerInvitesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventPoolRoundsArgs = {
  objects: Array<EventPoolRoundsInsertInput>;
  onConflict?: InputMaybe<EventPoolRoundsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventPoolRoundsOneArgs = {
  object: EventPoolRoundsInsertInput;
  onConflict?: InputMaybe<EventPoolRoundsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventPoolsTeamsArgs = {
  objects: Array<EventPoolsTeamsInsertInput>;
  onConflict?: InputMaybe<EventPoolsTeamsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventPoolsTeamsOneArgs = {
  object: EventPoolsTeamsInsertInput;
  onConflict?: InputMaybe<EventPoolsTeamsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventPrivacyArgs = {
  objects: Array<EventPrivacyInsertInput>;
  onConflict?: InputMaybe<EventPrivacyOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventPrivacyOneArgs = {
  object: EventPrivacyInsertInput;
  onConflict?: InputMaybe<EventPrivacyOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventRegistrationDetailsArgs = {
  objects: Array<EventRegistrationDetailsInsertInput>;
  onConflict?: InputMaybe<EventRegistrationDetailsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventRegistrationDetailsOneArgs = {
  object: EventRegistrationDetailsInsertInput;
  onConflict?: InputMaybe<EventRegistrationDetailsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventRegistrationsArgs = {
  objects: Array<EventRegistrationsInsertInput>;
  onConflict?: InputMaybe<EventRegistrationsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventRegistrationsOneArgs = {
  object: EventRegistrationsInsertInput;
  onConflict?: InputMaybe<EventRegistrationsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventSequenceCompleteReasonsArgs = {
  objects: Array<EventSequenceCompleteReasonsInsertInput>;
  onConflict?: InputMaybe<EventSequenceCompleteReasonsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventSequenceCompleteReasonsOneArgs = {
  object: EventSequenceCompleteReasonsInsertInput;
  onConflict?: InputMaybe<EventSequenceCompleteReasonsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventSkillLevelsArgs = {
  objects: Array<EventSkillLevelsInsertInput>;
  onConflict?: InputMaybe<EventSkillLevelsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventSkillLevelsOneArgs = {
  object: EventSkillLevelsInsertInput;
  onConflict?: InputMaybe<EventSkillLevelsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventSponsorsArgs = {
  objects: Array<EventSponsorsInsertInput>;
  onConflict?: InputMaybe<EventSponsorsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventSponsorsOneArgs = {
  object: EventSponsorsInsertInput;
  onConflict?: InputMaybe<EventSponsorsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventStatusesArgs = {
  objects: Array<EventStatusesInsertInput>;
  onConflict?: InputMaybe<EventStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventStatusesOneArgs = {
  object: EventStatusesInsertInput;
  onConflict?: InputMaybe<EventStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventTeamMemberStatusesArgs = {
  objects: Array<EventTeamMemberStatusesInsertInput>;
  onConflict?: InputMaybe<EventTeamMemberStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventTeamMemberStatusesOneArgs = {
  object: EventTeamMemberStatusesInsertInput;
  onConflict?: InputMaybe<EventTeamMemberStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventTeamMembersArgs = {
  objects: Array<EventTeamMembersInsertInput>;
  onConflict?: InputMaybe<EventTeamMembersOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventTeamMembersOneArgs = {
  object: EventTeamMembersInsertInput;
  onConflict?: InputMaybe<EventTeamMembersOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventTeamStatusesArgs = {
  objects: Array<EventTeamStatusesInsertInput>;
  onConflict?: InputMaybe<EventTeamStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventTeamStatusesOneArgs = {
  object: EventTeamStatusesInsertInput;
  onConflict?: InputMaybe<EventTeamStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventTeamsArgs = {
  objects: Array<EventTeamsInsertInput>;
  onConflict?: InputMaybe<EventTeamsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventTeamsOneArgs = {
  object: EventTeamsInsertInput;
  onConflict?: InputMaybe<EventTeamsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventTransactionItemTypesArgs = {
  objects: Array<EventTransactionItemTypesInsertInput>;
  onConflict?: InputMaybe<EventTransactionItemTypesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventTransactionItemTypesOneArgs = {
  object: EventTransactionItemTypesInsertInput;
  onConflict?: InputMaybe<EventTransactionItemTypesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventTransactionItemsArgs = {
  objects: Array<EventTransactionItemsInsertInput>;
  onConflict?: InputMaybe<EventTransactionItemsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventTransactionItemsOneArgs = {
  object: EventTransactionItemsInsertInput;
  onConflict?: InputMaybe<EventTransactionItemsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventTransactionsArgs = {
  objects: Array<EventTransactionsInsertInput>;
  onConflict?: InputMaybe<EventTransactionsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventTransactionsOneArgs = {
  object: EventTransactionsInsertInput;
  onConflict?: InputMaybe<EventTransactionsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventTypesArgs = {
  objects: Array<EventTypesInsertInput>;
  onConflict?: InputMaybe<EventTypesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventTypesOneArgs = {
  object: EventTypesInsertInput;
  onConflict?: InputMaybe<EventTypesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventsArgs = {
  objects: Array<EventsInsertInput>;
  onConflict?: InputMaybe<EventsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventsOneArgs = {
  object: EventsInsertInput;
  onConflict?: InputMaybe<EventsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertFeedbackSentimentArgs = {
  objects: Array<FeedbackSentimentInsertInput>;
  onConflict?: InputMaybe<FeedbackSentimentOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertFeedbackSentimentOneArgs = {
  object: FeedbackSentimentInsertInput;
  onConflict?: InputMaybe<FeedbackSentimentOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertFileCategoryArgs = {
  objects: Array<FileCategoryInsertInput>;
  onConflict?: InputMaybe<FileCategoryOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertFileCategoryOneArgs = {
  object: FileCategoryInsertInput;
  onConflict?: InputMaybe<FileCategoryOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertFileFormatArgs = {
  objects: Array<FileFormatInsertInput>;
  onConflict?: InputMaybe<FileFormatOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertFileFormatOneArgs = {
  object: FileFormatInsertInput;
  onConflict?: InputMaybe<FileFormatOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertFollowStatusesArgs = {
  objects: Array<FollowStatusesInsertInput>;
  onConflict?: InputMaybe<FollowStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertFollowStatusesOneArgs = {
  object: FollowStatusesInsertInput;
  onConflict?: InputMaybe<FollowStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertGameNetStatusesArgs = {
  objects: Array<GameNetStatusesInsertInput>;
  onConflict?: InputMaybe<GameNetStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertGameNetStatusesOneArgs = {
  object: GameNetStatusesInsertInput;
  onConflict?: InputMaybe<GameNetStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertGenderArgs = {
  objects: Array<GenderInsertInput>;
  onConflict?: InputMaybe<GenderOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertGenderOneArgs = {
  object: GenderInsertInput;
  onConflict?: InputMaybe<GenderOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertGroupCommentVotesArgs = {
  objects: Array<GroupCommentVotesInsertInput>;
  onConflict?: InputMaybe<GroupCommentVotesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertGroupCommentVotesOneArgs = {
  object: GroupCommentVotesInsertInput;
  onConflict?: InputMaybe<GroupCommentVotesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertGroupMembersArgs = {
  objects: Array<GroupMembersInsertInput>;
  onConflict?: InputMaybe<GroupMembersOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertGroupMembersOneArgs = {
  object: GroupMembersInsertInput;
  onConflict?: InputMaybe<GroupMembersOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertGroupThreadCommentFilesArgs = {
  objects: Array<GroupThreadCommentFilesInsertInput>;
  onConflict?: InputMaybe<GroupThreadCommentFilesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertGroupThreadCommentFilesOneArgs = {
  object: GroupThreadCommentFilesInsertInput;
  onConflict?: InputMaybe<GroupThreadCommentFilesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertGroupThreadCommentsArgs = {
  objects: Array<GroupThreadCommentsInsertInput>;
  onConflict?: InputMaybe<GroupThreadCommentsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertGroupThreadCommentsOneArgs = {
  object: GroupThreadCommentsInsertInput;
  onConflict?: InputMaybe<GroupThreadCommentsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertGroupThreadsArgs = {
  objects: Array<GroupThreadsInsertInput>;
  onConflict?: InputMaybe<GroupThreadsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertGroupThreadsOneArgs = {
  object: GroupThreadsInsertInput;
  onConflict?: InputMaybe<GroupThreadsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertGroupTypesArgs = {
  objects: Array<GroupTypesInsertInput>;
  onConflict?: InputMaybe<GroupTypesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertGroupTypesOneArgs = {
  object: GroupTypesInsertInput;
  onConflict?: InputMaybe<GroupTypesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertGroupVenuesArgs = {
  objects: Array<GroupVenuesInsertInput>;
  onConflict?: InputMaybe<GroupVenuesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertGroupVenuesOneArgs = {
  object: GroupVenuesInsertInput;
  onConflict?: InputMaybe<GroupVenuesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertGroupsArgs = {
  objects: Array<GroupsInsertInput>;
  onConflict?: InputMaybe<GroupsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertGroupsOneArgs = {
  object: GroupsInsertInput;
  onConflict?: InputMaybe<GroupsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertGroupsPlaySessionsArgs = {
  objects: Array<GroupsPlaySessionsInsertInput>;
  onConflict?: InputMaybe<GroupsPlaySessionsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertGroupsPlaySessionsOneArgs = {
  object: GroupsPlaySessionsInsertInput;
  onConflict?: InputMaybe<GroupsPlaySessionsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertIdentityVerificationProvidersArgs = {
  objects: Array<IdentityVerificationProvidersInsertInput>;
  onConflict?: InputMaybe<IdentityVerificationProvidersOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertIdentityVerificationProvidersOneArgs = {
  object: IdentityVerificationProvidersInsertInput;
  onConflict?: InputMaybe<IdentityVerificationProvidersOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertIdentityVerificationStatusesArgs = {
  objects: Array<IdentityVerificationStatusesInsertInput>;
  onConflict?: InputMaybe<IdentityVerificationStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertIdentityVerificationStatusesOneArgs = {
  object: IdentityVerificationStatusesInsertInput;
  onConflict?: InputMaybe<IdentityVerificationStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertInvoicesArgs = {
  objects: Array<InvoicesInsertInput>;
  onConflict?: InputMaybe<InvoicesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertInvoicesOneArgs = {
  object: InvoicesInsertInput;
  onConflict?: InputMaybe<InvoicesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLearningProgramEnrollmentScheduleMediaWatchedArgs = {
  objects: Array<LearningProgramEnrollmentScheduleMediaWatchedInsertInput>;
  onConflict?: InputMaybe<LearningProgramEnrollmentScheduleMediaWatchedOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLearningProgramEnrollmentScheduleMediaWatchedOneArgs = {
  object: LearningProgramEnrollmentScheduleMediaWatchedInsertInput;
  onConflict?: InputMaybe<LearningProgramEnrollmentScheduleMediaWatchedOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLearningProgramEnrollmentScheduleProgressArgs = {
  objects: Array<LearningProgramEnrollmentScheduleProgressInsertInput>;
  onConflict?: InputMaybe<LearningProgramEnrollmentScheduleProgressOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLearningProgramEnrollmentScheduleProgressOneArgs = {
  object: LearningProgramEnrollmentScheduleProgressInsertInput;
  onConflict?: InputMaybe<LearningProgramEnrollmentScheduleProgressOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLearningProgramEnrollmentsArgs = {
  objects: Array<LearningProgramEnrollmentsInsertInput>;
  onConflict?: InputMaybe<LearningProgramEnrollmentsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLearningProgramEnrollmentsOneArgs = {
  object: LearningProgramEnrollmentsInsertInput;
  onConflict?: InputMaybe<LearningProgramEnrollmentsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLearningProgramMediaArgs = {
  objects: Array<LearningProgramMediaInsertInput>;
  onConflict?: InputMaybe<LearningProgramMediaOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLearningProgramMediaCategoriesArgs = {
  objects: Array<LearningProgramMediaCategoriesInsertInput>;
  onConflict?: InputMaybe<LearningProgramMediaCategoriesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLearningProgramMediaCategoriesOneArgs = {
  object: LearningProgramMediaCategoriesInsertInput;
  onConflict?: InputMaybe<LearningProgramMediaCategoriesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLearningProgramMediaOneArgs = {
  object: LearningProgramMediaInsertInput;
  onConflict?: InputMaybe<LearningProgramMediaOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLearningProgramScheduleMediaArgs = {
  objects: Array<LearningProgramScheduleMediaInsertInput>;
  onConflict?: InputMaybe<LearningProgramScheduleMediaOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLearningProgramScheduleMediaOneArgs = {
  object: LearningProgramScheduleMediaInsertInput;
  onConflict?: InputMaybe<LearningProgramScheduleMediaOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLearningProgramScheduleUnitsArgs = {
  objects: Array<LearningProgramScheduleUnitsInsertInput>;
  onConflict?: InputMaybe<LearningProgramScheduleUnitsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLearningProgramScheduleUnitsOneArgs = {
  object: LearningProgramScheduleUnitsInsertInput;
  onConflict?: InputMaybe<LearningProgramScheduleUnitsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLearningProgramScheduleVideoSubmissionsArgs = {
  objects: Array<LearningProgramScheduleVideoSubmissionsInsertInput>;
  onConflict?: InputMaybe<LearningProgramScheduleVideoSubmissionsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLearningProgramScheduleVideoSubmissionsOneArgs = {
  object: LearningProgramScheduleVideoSubmissionsInsertInput;
  onConflict?: InputMaybe<LearningProgramScheduleVideoSubmissionsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLearningProgramSchedulesArgs = {
  objects: Array<LearningProgramSchedulesInsertInput>;
  onConflict?: InputMaybe<LearningProgramSchedulesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLearningProgramSchedulesOneArgs = {
  object: LearningProgramSchedulesInsertInput;
  onConflict?: InputMaybe<LearningProgramSchedulesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLearningProgramSkillLevelValuesArgs = {
  objects: Array<LearningProgramSkillLevelValuesInsertInput>;
  onConflict?: InputMaybe<LearningProgramSkillLevelValuesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLearningProgramSkillLevelValuesOneArgs = {
  object: LearningProgramSkillLevelValuesInsertInput;
  onConflict?: InputMaybe<LearningProgramSkillLevelValuesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLearningProgramSkillsArgs = {
  objects: Array<LearningProgramSkillsInsertInput>;
  onConflict?: InputMaybe<LearningProgramSkillsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLearningProgramSkillsOneArgs = {
  object: LearningProgramSkillsInsertInput;
  onConflict?: InputMaybe<LearningProgramSkillsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLearningProgramsArgs = {
  objects: Array<LearningProgramsInsertInput>;
  onConflict?: InputMaybe<LearningProgramsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLearningProgramsOneArgs = {
  object: LearningProgramsInsertInput;
  onConflict?: InputMaybe<LearningProgramsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLessonAgeGroupsArgs = {
  objects: Array<LessonAgeGroupsInsertInput>;
  onConflict?: InputMaybe<LessonAgeGroupsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLessonAgeGroupsOneArgs = {
  object: LessonAgeGroupsInsertInput;
  onConflict?: InputMaybe<LessonAgeGroupsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLessonCollectionsArgs = {
  objects: Array<LessonCollectionsInsertInput>;
  onConflict?: InputMaybe<LessonCollectionsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLessonCollectionsOneArgs = {
  object: LessonCollectionsInsertInput;
  onConflict?: InputMaybe<LessonCollectionsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLessonEquipmentArgs = {
  objects: Array<LessonEquipmentInsertInput>;
  onConflict?: InputMaybe<LessonEquipmentOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLessonEquipmentOneArgs = {
  object: LessonEquipmentInsertInput;
  onConflict?: InputMaybe<LessonEquipmentOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLessonEquipmentOptionsArgs = {
  objects: Array<LessonEquipmentOptionsInsertInput>;
  onConflict?: InputMaybe<LessonEquipmentOptionsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLessonEquipmentOptionsOneArgs = {
  object: LessonEquipmentOptionsInsertInput;
  onConflict?: InputMaybe<LessonEquipmentOptionsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLessonOrderItemsArgs = {
  objects: Array<LessonOrderItemsInsertInput>;
  onConflict?: InputMaybe<LessonOrderItemsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLessonOrderItemsOneArgs = {
  object: LessonOrderItemsInsertInput;
  onConflict?: InputMaybe<LessonOrderItemsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLessonOrdersArgs = {
  objects: Array<LessonOrdersInsertInput>;
  onConflict?: InputMaybe<LessonOrdersOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLessonOrdersOneArgs = {
  object: LessonOrdersInsertInput;
  onConflict?: InputMaybe<LessonOrdersOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLessonParticipantStatusesArgs = {
  objects: Array<LessonParticipantStatusesInsertInput>;
  onConflict?: InputMaybe<LessonParticipantStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLessonParticipantStatusesOneArgs = {
  object: LessonParticipantStatusesInsertInput;
  onConflict?: InputMaybe<LessonParticipantStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLessonParticipantsArgs = {
  objects: Array<LessonParticipantsInsertInput>;
  onConflict?: InputMaybe<LessonParticipantsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLessonParticipantsOneArgs = {
  object: LessonParticipantsInsertInput;
  onConflict?: InputMaybe<LessonParticipantsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLessonPlayerSkillAssessmentCategoriesArgs = {
  objects: Array<LessonPlayerSkillAssessmentCategoriesInsertInput>;
  onConflict?: InputMaybe<LessonPlayerSkillAssessmentCategoriesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLessonPlayerSkillAssessmentCategoriesOneArgs = {
  object: LessonPlayerSkillAssessmentCategoriesInsertInput;
  onConflict?: InputMaybe<LessonPlayerSkillAssessmentCategoriesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLessonPlayerSkillAssessmentsArgs = {
  objects: Array<LessonPlayerSkillAssessmentsInsertInput>;
  onConflict?: InputMaybe<LessonPlayerSkillAssessmentsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLessonPlayerSkillAssessmentsOneArgs = {
  object: LessonPlayerSkillAssessmentsInsertInput;
  onConflict?: InputMaybe<LessonPlayerSkillAssessmentsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLessonPlayerSkillAssessmentsSkillsArgs = {
  objects: Array<LessonPlayerSkillAssessmentsSkillsInsertInput>;
  onConflict?: InputMaybe<LessonPlayerSkillAssessmentsSkillsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLessonPlayerSkillAssessmentsSkillsOneArgs = {
  object: LessonPlayerSkillAssessmentsSkillsInsertInput;
  onConflict?: InputMaybe<LessonPlayerSkillAssessmentsSkillsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLessonPrivacyArgs = {
  objects: Array<LessonPrivacyInsertInput>;
  onConflict?: InputMaybe<LessonPrivacyOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLessonPrivacyOneArgs = {
  object: LessonPrivacyInsertInput;
  onConflict?: InputMaybe<LessonPrivacyOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLessonReflectionCommentTypesArgs = {
  objects: Array<LessonReflectionCommentTypesInsertInput>;
  onConflict?: InputMaybe<LessonReflectionCommentTypesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLessonReflectionCommentTypesOneArgs = {
  object: LessonReflectionCommentTypesInsertInput;
  onConflict?: InputMaybe<LessonReflectionCommentTypesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLessonReflectionCommentsArgs = {
  objects: Array<LessonReflectionCommentsInsertInput>;
  onConflict?: InputMaybe<LessonReflectionCommentsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLessonReflectionCommentsOneArgs = {
  object: LessonReflectionCommentsInsertInput;
  onConflict?: InputMaybe<LessonReflectionCommentsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLessonReflectionFilesArgs = {
  objects: Array<LessonReflectionFilesInsertInput>;
  onConflict?: InputMaybe<LessonReflectionFilesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLessonReflectionFilesOneArgs = {
  object: LessonReflectionFilesInsertInput;
  onConflict?: InputMaybe<LessonReflectionFilesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLessonReflectionsArgs = {
  objects: Array<LessonReflectionsInsertInput>;
  onConflict?: InputMaybe<LessonReflectionsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLessonReflectionsOneArgs = {
  object: LessonReflectionsInsertInput;
  onConflict?: InputMaybe<LessonReflectionsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLessonSkillCategoriesArgs = {
  objects: Array<LessonSkillCategoriesInsertInput>;
  onConflict?: InputMaybe<LessonSkillCategoriesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLessonSkillCategoriesOneArgs = {
  object: LessonSkillCategoriesInsertInput;
  onConflict?: InputMaybe<LessonSkillCategoriesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLessonSkillDisplayNamesArgs = {
  objects: Array<LessonSkillDisplayNamesInsertInput>;
  onConflict?: InputMaybe<LessonSkillDisplayNamesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLessonSkillDisplayNamesOneArgs = {
  object: LessonSkillDisplayNamesInsertInput;
  onConflict?: InputMaybe<LessonSkillDisplayNamesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLessonSkillLevelsArgs = {
  objects: Array<LessonSkillLevelsInsertInput>;
  onConflict?: InputMaybe<LessonSkillLevelsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLessonSkillLevelsOneArgs = {
  object: LessonSkillLevelsInsertInput;
  onConflict?: InputMaybe<LessonSkillLevelsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLessonSkillMappingsArgs = {
  objects: Array<LessonSkillMappingsInsertInput>;
  onConflict?: InputMaybe<LessonSkillMappingsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLessonSkillMappingsOneArgs = {
  object: LessonSkillMappingsInsertInput;
  onConflict?: InputMaybe<LessonSkillMappingsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLessonSkillsArgs = {
  objects: Array<LessonSkillsInsertInput>;
  onConflict?: InputMaybe<LessonSkillsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLessonSkillsOneArgs = {
  object: LessonSkillsInsertInput;
  onConflict?: InputMaybe<LessonSkillsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLessonStatusesArgs = {
  objects: Array<LessonStatusesInsertInput>;
  onConflict?: InputMaybe<LessonStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLessonStatusesOneArgs = {
  object: LessonStatusesInsertInput;
  onConflict?: InputMaybe<LessonStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLessonTemplateSkillLevelsArgs = {
  objects: Array<LessonTemplateSkillLevelsInsertInput>;
  onConflict?: InputMaybe<LessonTemplateSkillLevelsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLessonTemplateSkillLevelsOneArgs = {
  object: LessonTemplateSkillLevelsInsertInput;
  onConflict?: InputMaybe<LessonTemplateSkillLevelsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLessonTemplatesArgs = {
  objects: Array<LessonTemplatesInsertInput>;
  onConflict?: InputMaybe<LessonTemplatesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLessonTemplatesOneArgs = {
  object: LessonTemplatesInsertInput;
  onConflict?: InputMaybe<LessonTemplatesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLessonTimesArgs = {
  objects: Array<LessonTimesInsertInput>;
  onConflict?: InputMaybe<LessonTimesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLessonTimesOneArgs = {
  object: LessonTimesInsertInput;
  onConflict?: InputMaybe<LessonTimesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLessonTypesArgs = {
  objects: Array<LessonTypesInsertInput>;
  onConflict?: InputMaybe<LessonTypesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLessonTypesOneArgs = {
  object: LessonTypesInsertInput;
  onConflict?: InputMaybe<LessonTypesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLessonWaitlistStatusesArgs = {
  objects: Array<LessonWaitlistStatusesInsertInput>;
  onConflict?: InputMaybe<LessonWaitlistStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLessonWaitlistStatusesOneArgs = {
  object: LessonWaitlistStatusesInsertInput;
  onConflict?: InputMaybe<LessonWaitlistStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLessonWaitlistsArgs = {
  objects: Array<LessonWaitlistsInsertInput>;
  onConflict?: InputMaybe<LessonWaitlistsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLessonWaitlistsOneArgs = {
  object: LessonWaitlistsInsertInput;
  onConflict?: InputMaybe<LessonWaitlistsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLessonsArgs = {
  objects: Array<LessonsInsertInput>;
  onConflict?: InputMaybe<LessonsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLessonsOneArgs = {
  object: LessonsInsertInput;
  onConflict?: InputMaybe<LessonsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertMatchSelectionCriteriaArgs = {
  objects: Array<MatchSelectionCriteriaInsertInput>;
  onConflict?: InputMaybe<MatchSelectionCriteriaOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertMatchSelectionCriteriaOneArgs = {
  object: MatchSelectionCriteriaInsertInput;
  onConflict?: InputMaybe<MatchSelectionCriteriaOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertMessagesArgs = {
  objects: Array<MessagesInsertInput>;
  onConflict?: InputMaybe<MessagesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertMessagesOneArgs = {
  object: MessagesInsertInput;
  onConflict?: InputMaybe<MessagesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertNeighborhoodsArgs = {
  objects: Array<NeighborhoodsInsertInput>;
  onConflict?: InputMaybe<NeighborhoodsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertNeighborhoodsOneArgs = {
  object: NeighborhoodsInsertInput;
  onConflict?: InputMaybe<NeighborhoodsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertNotificationActionTypesArgs = {
  objects: Array<NotificationActionTypesInsertInput>;
  onConflict?: InputMaybe<NotificationActionTypesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertNotificationActionTypesOneArgs = {
  object: NotificationActionTypesInsertInput;
  onConflict?: InputMaybe<NotificationActionTypesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertNotificationStatusesArgs = {
  objects: Array<NotificationStatusesInsertInput>;
  onConflict?: InputMaybe<NotificationStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertNotificationStatusesOneArgs = {
  object: NotificationStatusesInsertInput;
  onConflict?: InputMaybe<NotificationStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertOrderStatusesArgs = {
  objects: Array<OrderStatusesInsertInput>;
  onConflict?: InputMaybe<OrderStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertOrderStatusesOneArgs = {
  object: OrderStatusesInsertInput;
  onConflict?: InputMaybe<OrderStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPadelRatingScalesArgs = {
  objects: Array<PadelRatingScalesInsertInput>;
  onConflict?: InputMaybe<PadelRatingScalesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPadelRatingScalesOneArgs = {
  object: PadelRatingScalesInsertInput;
  onConflict?: InputMaybe<PadelRatingScalesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertParticipantRolesArgs = {
  objects: Array<ParticipantRolesInsertInput>;
  onConflict?: InputMaybe<ParticipantRolesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertParticipantRolesOneArgs = {
  object: ParticipantRolesInsertInput;
  onConflict?: InputMaybe<ParticipantRolesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPartnerBookingAttemptEventsArgs = {
  objects: Array<PartnerBookingAttemptEventsInsertInput>;
  onConflict?: InputMaybe<PartnerBookingAttemptEventsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPartnerBookingAttemptEventsOneArgs = {
  object: PartnerBookingAttemptEventsInsertInput;
  onConflict?: InputMaybe<PartnerBookingAttemptEventsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPartnerBookingAttemptStatusesArgs = {
  objects: Array<PartnerBookingAttemptStatusesInsertInput>;
  onConflict?: InputMaybe<PartnerBookingAttemptStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPartnerBookingAttemptStatusesOneArgs = {
  object: PartnerBookingAttemptStatusesInsertInput;
  onConflict?: InputMaybe<PartnerBookingAttemptStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPartnerBookingAttemptsArgs = {
  objects: Array<PartnerBookingAttemptsInsertInput>;
  onConflict?: InputMaybe<PartnerBookingAttemptsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPartnerBookingAttemptsOneArgs = {
  object: PartnerBookingAttemptsInsertInput;
  onConflict?: InputMaybe<PartnerBookingAttemptsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPartnerBookingEnginesArgs = {
  objects: Array<PartnerBookingEnginesInsertInput>;
  onConflict?: InputMaybe<PartnerBookingEnginesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPartnerBookingEnginesOneArgs = {
  object: PartnerBookingEnginesInsertInput;
  onConflict?: InputMaybe<PartnerBookingEnginesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPartnerBookingEventSourcesArgs = {
  objects: Array<PartnerBookingEventSourcesInsertInput>;
  onConflict?: InputMaybe<PartnerBookingEventSourcesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPartnerBookingEventSourcesOneArgs = {
  object: PartnerBookingEventSourcesInsertInput;
  onConflict?: InputMaybe<PartnerBookingEventSourcesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPartnerBookingHoldsArgs = {
  objects: Array<PartnerBookingHoldsInsertInput>;
  onConflict?: InputMaybe<PartnerBookingHoldsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPartnerBookingHoldsOneArgs = {
  object: PartnerBookingHoldsInsertInput;
  onConflict?: InputMaybe<PartnerBookingHoldsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPartnerBookingOrderStatusesArgs = {
  objects: Array<PartnerBookingOrderStatusesInsertInput>;
  onConflict?: InputMaybe<PartnerBookingOrderStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPartnerBookingOrderStatusesOneArgs = {
  object: PartnerBookingOrderStatusesInsertInput;
  onConflict?: InputMaybe<PartnerBookingOrderStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPartnerBookingOrdersArgs = {
  objects: Array<PartnerBookingOrdersInsertInput>;
  onConflict?: InputMaybe<PartnerBookingOrdersOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPartnerBookingOrdersOneArgs = {
  object: PartnerBookingOrdersInsertInput;
  onConflict?: InputMaybe<PartnerBookingOrdersOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPartnerBookingVerificationMethodsArgs = {
  objects: Array<PartnerBookingVerificationMethodsInsertInput>;
  onConflict?: InputMaybe<PartnerBookingVerificationMethodsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPartnerBookingVerificationMethodsOneArgs = {
  object: PartnerBookingVerificationMethodsInsertInput;
  onConflict?: InputMaybe<PartnerBookingVerificationMethodsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPaymentFulfillmentChannelsArgs = {
  objects: Array<PaymentFulfillmentChannelsInsertInput>;
  onConflict?: InputMaybe<PaymentFulfillmentChannelsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPaymentFulfillmentChannelsOneArgs = {
  object: PaymentFulfillmentChannelsInsertInput;
  onConflict?: InputMaybe<PaymentFulfillmentChannelsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPaymentProcessorsArgs = {
  objects: Array<PaymentProcessorsInsertInput>;
  onConflict?: InputMaybe<PaymentProcessorsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPaymentProcessorsOneArgs = {
  object: PaymentProcessorsInsertInput;
  onConflict?: InputMaybe<PaymentProcessorsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPaymentStatusesArgs = {
  objects: Array<PaymentStatusesInsertInput>;
  onConflict?: InputMaybe<PaymentStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPaymentStatusesOneArgs = {
  object: PaymentStatusesInsertInput;
  onConflict?: InputMaybe<PaymentStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPickleballRatingScalesArgs = {
  objects: Array<PickleballRatingScalesInsertInput>;
  onConflict?: InputMaybe<PickleballRatingScalesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPickleballRatingScalesOneArgs = {
  object: PickleballRatingScalesInsertInput;
  onConflict?: InputMaybe<PickleballRatingScalesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPlatformSubscriptionIntervalsArgs = {
  objects: Array<PlatformSubscriptionIntervalsInsertInput>;
  onConflict?: InputMaybe<PlatformSubscriptionIntervalsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPlatformSubscriptionIntervalsOneArgs = {
  object: PlatformSubscriptionIntervalsInsertInput;
  onConflict?: InputMaybe<PlatformSubscriptionIntervalsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPlatformSubscriptionPersonasArgs = {
  objects: Array<PlatformSubscriptionPersonasInsertInput>;
  onConflict?: InputMaybe<PlatformSubscriptionPersonasOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPlatformSubscriptionPersonasOneArgs = {
  object: PlatformSubscriptionPersonasInsertInput;
  onConflict?: InputMaybe<PlatformSubscriptionPersonasOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPlatformSubscriptionPlanPricesArgs = {
  objects: Array<PlatformSubscriptionPlanPricesInsertInput>;
  onConflict?: InputMaybe<PlatformSubscriptionPlanPricesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPlatformSubscriptionPlanPricesOneArgs = {
  object: PlatformSubscriptionPlanPricesInsertInput;
  onConflict?: InputMaybe<PlatformSubscriptionPlanPricesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPlatformSubscriptionPlansArgs = {
  objects: Array<PlatformSubscriptionPlansInsertInput>;
  onConflict?: InputMaybe<PlatformSubscriptionPlansOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPlatformSubscriptionPlansOneArgs = {
  object: PlatformSubscriptionPlansInsertInput;
  onConflict?: InputMaybe<PlatformSubscriptionPlansOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPlatformSubscriptionsArgs = {
  objects: Array<PlatformSubscriptionsInsertInput>;
  onConflict?: InputMaybe<PlatformSubscriptionsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPlatformSubscriptionsOneArgs = {
  object: PlatformSubscriptionsInsertInput;
  onConflict?: InputMaybe<PlatformSubscriptionsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPlayRequestNeighborhoodsArgs = {
  objects: Array<PlayRequestNeighborhoodsInsertInput>;
  onConflict?: InputMaybe<PlayRequestNeighborhoodsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPlayRequestNeighborhoodsOneArgs = {
  object: PlayRequestNeighborhoodsInsertInput;
  onConflict?: InputMaybe<PlayRequestNeighborhoodsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPlayRequestSlotsArgs = {
  objects: Array<PlayRequestSlotsInsertInput>;
  onConflict?: InputMaybe<PlayRequestSlotsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPlayRequestSlotsOneArgs = {
  object: PlayRequestSlotsInsertInput;
  onConflict?: InputMaybe<PlayRequestSlotsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPlayRequestStatusesArgs = {
  objects: Array<PlayRequestStatusesInsertInput>;
  onConflict?: InputMaybe<PlayRequestStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPlayRequestStatusesOneArgs = {
  object: PlayRequestStatusesInsertInput;
  onConflict?: InputMaybe<PlayRequestStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPlayRequestVenuesArgs = {
  objects: Array<PlayRequestVenuesInsertInput>;
  onConflict?: InputMaybe<PlayRequestVenuesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPlayRequestVenuesOneArgs = {
  object: PlayRequestVenuesInsertInput;
  onConflict?: InputMaybe<PlayRequestVenuesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPlayRequestsArgs = {
  objects: Array<PlayRequestsInsertInput>;
  onConflict?: InputMaybe<PlayRequestsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPlayRequestsOneArgs = {
  object: PlayRequestsInsertInput;
  onConflict?: InputMaybe<PlayRequestsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPlaySessionCommentsArgs = {
  objects: Array<PlaySessionCommentsInsertInput>;
  onConflict?: InputMaybe<PlaySessionCommentsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPlaySessionCommentsOneArgs = {
  object: PlaySessionCommentsInsertInput;
  onConflict?: InputMaybe<PlaySessionCommentsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPlaySessionCourtBookingStatusesArgs = {
  objects: Array<PlaySessionCourtBookingStatusesInsertInput>;
  onConflict?: InputMaybe<PlaySessionCourtBookingStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPlaySessionCourtBookingStatusesOneArgs = {
  object: PlaySessionCourtBookingStatusesInsertInput;
  onConflict?: InputMaybe<PlaySessionCourtBookingStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPlaySessionFormatsArgs = {
  objects: Array<PlaySessionFormatsInsertInput>;
  onConflict?: InputMaybe<PlaySessionFormatsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPlaySessionFormatsOneArgs = {
  object: PlaySessionFormatsInsertInput;
  onConflict?: InputMaybe<PlaySessionFormatsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPlaySessionMatchCompetitivenessArgs = {
  objects: Array<PlaySessionMatchCompetitivenessInsertInput>;
  onConflict?: InputMaybe<PlaySessionMatchCompetitivenessOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPlaySessionMatchCompetitivenessOneArgs = {
  object: PlaySessionMatchCompetitivenessInsertInput;
  onConflict?: InputMaybe<PlaySessionMatchCompetitivenessOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPlaySessionParticipantStatusesArgs = {
  objects: Array<PlaySessionParticipantStatusesInsertInput>;
  onConflict?: InputMaybe<PlaySessionParticipantStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPlaySessionParticipantStatusesOneArgs = {
  object: PlaySessionParticipantStatusesInsertInput;
  onConflict?: InputMaybe<PlaySessionParticipantStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPlaySessionParticipantsArgs = {
  objects: Array<PlaySessionParticipantsInsertInput>;
  onConflict?: InputMaybe<PlaySessionParticipantsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPlaySessionParticipantsOneArgs = {
  object: PlaySessionParticipantsInsertInput;
  onConflict?: InputMaybe<PlaySessionParticipantsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPlaySessionPrivacyArgs = {
  objects: Array<PlaySessionPrivacyInsertInput>;
  onConflict?: InputMaybe<PlaySessionPrivacyOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPlaySessionPrivacyOneArgs = {
  object: PlaySessionPrivacyInsertInput;
  onConflict?: InputMaybe<PlaySessionPrivacyOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPlaySessionStatusesArgs = {
  objects: Array<PlaySessionStatusesInsertInput>;
  onConflict?: InputMaybe<PlaySessionStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPlaySessionStatusesOneArgs = {
  object: PlaySessionStatusesInsertInput;
  onConflict?: InputMaybe<PlaySessionStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPlaySessionsArgs = {
  objects: Array<PlaySessionsInsertInput>;
  onConflict?: InputMaybe<PlaySessionsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPlaySessionsOneArgs = {
  object: PlaySessionsInsertInput;
  onConflict?: InputMaybe<PlaySessionsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPlayerAvailabilitiesArgs = {
  objects: Array<PlayerAvailabilitiesInsertInput>;
  onConflict?: InputMaybe<PlayerAvailabilitiesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPlayerAvailabilitiesOneArgs = {
  object: PlayerAvailabilitiesInsertInput;
  onConflict?: InputMaybe<PlayerAvailabilitiesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPlayerAvailabilityNeighborhoodsArgs = {
  objects: Array<PlayerAvailabilityNeighborhoodsInsertInput>;
  onConflict?: InputMaybe<PlayerAvailabilityNeighborhoodsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPlayerAvailabilityNeighborhoodsOneArgs = {
  object: PlayerAvailabilityNeighborhoodsInsertInput;
  onConflict?: InputMaybe<PlayerAvailabilityNeighborhoodsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPlayerAvailabilityRatingScalesArgs = {
  objects: Array<PlayerAvailabilityRatingScalesInsertInput>;
  onConflict?: InputMaybe<PlayerAvailabilityRatingScalesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPlayerAvailabilityRatingScalesOneArgs = {
  object: PlayerAvailabilityRatingScalesInsertInput;
  onConflict?: InputMaybe<PlayerAvailabilityRatingScalesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPlayerAvailabilitySlotsArgs = {
  objects: Array<PlayerAvailabilitySlotsInsertInput>;
  onConflict?: InputMaybe<PlayerAvailabilitySlotsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPlayerAvailabilitySlotsOneArgs = {
  object: PlayerAvailabilitySlotsInsertInput;
  onConflict?: InputMaybe<PlayerAvailabilitySlotsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPlayerAvailabilityVenuesArgs = {
  objects: Array<PlayerAvailabilityVenuesInsertInput>;
  onConflict?: InputMaybe<PlayerAvailabilityVenuesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPlayerAvailabilityVenuesOneArgs = {
  object: PlayerAvailabilityVenuesInsertInput;
  onConflict?: InputMaybe<PlayerAvailabilityVenuesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPlayerFinderGoalsArgs = {
  objects: Array<PlayerFinderGoalsInsertInput>;
  onConflict?: InputMaybe<PlayerFinderGoalsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPlayerFinderGoalsOneArgs = {
  object: PlayerFinderGoalsInsertInput;
  onConflict?: InputMaybe<PlayerFinderGoalsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPlayerFinderTimeOfDayArgs = {
  objects: Array<PlayerFinderTimeOfDayInsertInput>;
  onConflict?: InputMaybe<PlayerFinderTimeOfDayOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPlayerFinderTimeOfDayOneArgs = {
  object: PlayerFinderTimeOfDayInsertInput;
  onConflict?: InputMaybe<PlayerFinderTimeOfDayOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertRecurrenceKindsArgs = {
  objects: Array<RecurrenceKindsInsertInput>;
  onConflict?: InputMaybe<RecurrenceKindsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertRecurrenceKindsOneArgs = {
  object: RecurrenceKindsInsertInput;
  onConflict?: InputMaybe<RecurrenceKindsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertReportReasonsArgs = {
  objects: Array<ReportReasonsInsertInput>;
  onConflict?: InputMaybe<ReportReasonsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertReportReasonsOneArgs = {
  object: ReportReasonsInsertInput;
  onConflict?: InputMaybe<ReportReasonsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertReportStatusesArgs = {
  objects: Array<ReportStatusesInsertInput>;
  onConflict?: InputMaybe<ReportStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertReportStatusesOneArgs = {
  object: ReportStatusesInsertInput;
  onConflict?: InputMaybe<ReportStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertReviewsArgs = {
  objects: Array<ReviewsInsertInput>;
  onConflict?: InputMaybe<ReviewsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertReviewsOneArgs = {
  object: ReviewsInsertInput;
  onConflict?: InputMaybe<ReviewsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertSalesArgs = {
  objects: Array<SalesInsertInput>;
  onConflict?: InputMaybe<SalesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertSalesOneArgs = {
  object: SalesInsertInput;
  onConflict?: InputMaybe<SalesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertScoringFormatArgs = {
  objects: Array<ScoringFormatInsertInput>;
  onConflict?: InputMaybe<ScoringFormatOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertScoringFormatOneArgs = {
  object: ScoringFormatInsertInput;
  onConflict?: InputMaybe<ScoringFormatOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertSignupRequestsArgs = {
  objects: Array<SignupRequestsInsertInput>;
  onConflict?: InputMaybe<SignupRequestsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertSignupRequestsOneArgs = {
  object: SignupRequestsInsertInput;
  onConflict?: InputMaybe<SignupRequestsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertSkillLevelValuesArgs = {
  objects: Array<SkillLevelValuesInsertInput>;
  onConflict?: InputMaybe<SkillLevelValuesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertSkillLevelValuesOneArgs = {
  object: SkillLevelValuesInsertInput;
  onConflict?: InputMaybe<SkillLevelValuesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertSkillLevelsArgs = {
  objects: Array<SkillLevelsInsertInput>;
  onConflict?: InputMaybe<SkillLevelsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertSkillLevelsOneArgs = {
  object: SkillLevelsInsertInput;
  onConflict?: InputMaybe<SkillLevelsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertSportsArgs = {
  objects: Array<SportsInsertInput>;
  onConflict?: InputMaybe<SportsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertSportsOneArgs = {
  object: SportsInsertInput;
  onConflict?: InputMaybe<SportsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertStripeChargesArgs = {
  objects: Array<StripeChargesInsertInput>;
  onConflict?: InputMaybe<StripeChargesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertStripeChargesOneArgs = {
  object: StripeChargesInsertInput;
  onConflict?: InputMaybe<StripeChargesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertStripePaymentIntentsArgs = {
  objects: Array<StripePaymentIntentsInsertInput>;
  onConflict?: InputMaybe<StripePaymentIntentsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertStripePaymentIntentsOneArgs = {
  object: StripePaymentIntentsInsertInput;
  onConflict?: InputMaybe<StripePaymentIntentsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertSubscriptionStatusesArgs = {
  objects: Array<SubscriptionStatusesInsertInput>;
  onConflict?: InputMaybe<SubscriptionStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertSubscriptionStatusesOneArgs = {
  object: SubscriptionStatusesInsertInput;
  onConflict?: InputMaybe<SubscriptionStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertTeamTypesArgs = {
  objects: Array<TeamTypesInsertInput>;
  onConflict?: InputMaybe<TeamTypesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertTeamTypesOneArgs = {
  object: TeamTypesInsertInput;
  onConflict?: InputMaybe<TeamTypesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertTennisRatingScalesArgs = {
  objects: Array<TennisRatingScalesInsertInput>;
  onConflict?: InputMaybe<TennisRatingScalesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertTennisRatingScalesOneArgs = {
  object: TennisRatingScalesInsertInput;
  onConflict?: InputMaybe<TennisRatingScalesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertTwilioGroupTextsArgs = {
  objects: Array<TwilioGroupTextsInsertInput>;
  onConflict?: InputMaybe<TwilioGroupTextsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertTwilioGroupTextsOneArgs = {
  object: TwilioGroupTextsInsertInput;
  onConflict?: InputMaybe<TwilioGroupTextsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUploadReviewRequestsArgs = {
  objects: Array<UploadReviewRequestsInsertInput>;
  onConflict?: InputMaybe<UploadReviewRequestsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUploadReviewRequestsOneArgs = {
  object: UploadReviewRequestsInsertInput;
  onConflict?: InputMaybe<UploadReviewRequestsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserAuthIdentitiesArgs = {
  objects: Array<UserAuthIdentitiesInsertInput>;
  onConflict?: InputMaybe<UserAuthIdentitiesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserAuthIdentitiesOneArgs = {
  object: UserAuthIdentitiesInsertInput;
  onConflict?: InputMaybe<UserAuthIdentitiesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserBlocksArgs = {
  objects: Array<UserBlocksInsertInput>;
  onConflict?: InputMaybe<UserBlocksOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserBlocksOneArgs = {
  object: UserBlocksInsertInput;
  onConflict?: InputMaybe<UserBlocksOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserCoachServicesArgs = {
  objects: Array<UserCoachServicesInsertInput>;
  onConflict?: InputMaybe<UserCoachServicesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserCoachServicesOneArgs = {
  object: UserCoachServicesInsertInput;
  onConflict?: InputMaybe<UserCoachServicesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserCommunicationPreferencesArgs = {
  objects: Array<UserCommunicationPreferencesInsertInput>;
  onConflict?: InputMaybe<UserCommunicationPreferencesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserCommunicationPreferencesOneArgs = {
  object: UserCommunicationPreferencesInsertInput;
  onConflict?: InputMaybe<UserCommunicationPreferencesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserConnectionRequestStatusesArgs = {
  objects: Array<UserConnectionRequestStatusesInsertInput>;
  onConflict?: InputMaybe<UserConnectionRequestStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserConnectionRequestStatusesOneArgs = {
  object: UserConnectionRequestStatusesInsertInput;
  onConflict?: InputMaybe<UserConnectionRequestStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserConnectionRequestsArgs = {
  objects: Array<UserConnectionRequestsInsertInput>;
  onConflict?: InputMaybe<UserConnectionRequestsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserConnectionRequestsOneArgs = {
  object: UserConnectionRequestsInsertInput;
  onConflict?: InputMaybe<UserConnectionRequestsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserConnectionsArgs = {
  objects: Array<UserConnectionsInsertInput>;
  onConflict?: InputMaybe<UserConnectionsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserConnectionsOneArgs = {
  object: UserConnectionsInsertInput;
  onConflict?: InputMaybe<UserConnectionsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserContentBetaSubscriptionsArgs = {
  objects: Array<UserContentBetaSubscriptionsInsertInput>;
  onConflict?: InputMaybe<UserContentBetaSubscriptionsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserContentBetaSubscriptionsOneArgs = {
  object: UserContentBetaSubscriptionsInsertInput;
  onConflict?: InputMaybe<UserContentBetaSubscriptionsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserContentFilesArgs = {
  objects: Array<UserContentFilesInsertInput>;
  onConflict?: InputMaybe<UserContentFilesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserContentFilesOneArgs = {
  object: UserContentFilesInsertInput;
  onConflict?: InputMaybe<UserContentFilesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserContentFilesSkillsArgs = {
  objects: Array<UserContentFilesSkillsInsertInput>;
  onConflict?: InputMaybe<UserContentFilesSkillsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserContentFilesSkillsOneArgs = {
  object: UserContentFilesSkillsInsertInput;
  onConflict?: InputMaybe<UserContentFilesSkillsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserContentSkillsArgs = {
  objects: Array<UserContentSkillsInsertInput>;
  onConflict?: InputMaybe<UserContentSkillsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserContentSkillsOneArgs = {
  object: UserContentSkillsInsertInput;
  onConflict?: InputMaybe<UserContentSkillsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserContentTiersArgs = {
  objects: Array<UserContentTiersInsertInput>;
  onConflict?: InputMaybe<UserContentTiersOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserContentTiersOneArgs = {
  object: UserContentTiersInsertInput;
  onConflict?: InputMaybe<UserContentTiersOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserCreditCardsArgs = {
  objects: Array<UserCreditCardsInsertInput>;
  onConflict?: InputMaybe<UserCreditCardsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserCreditCardsOneArgs = {
  object: UserCreditCardsInsertInput;
  onConflict?: InputMaybe<UserCreditCardsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserCustomCourtsArgs = {
  objects: Array<UserCustomCourtsInsertInput>;
  onConflict?: InputMaybe<UserCustomCourtsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserCustomCourtsOneArgs = {
  object: UserCustomCourtsInsertInput;
  onConflict?: InputMaybe<UserCustomCourtsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserFilesArgs = {
  objects: Array<UserFilesInsertInput>;
  onConflict?: InputMaybe<UserFilesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserFilesOneArgs = {
  object: UserFilesInsertInput;
  onConflict?: InputMaybe<UserFilesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserFollowsArgs = {
  objects: Array<UserFollowsInsertInput>;
  onConflict?: InputMaybe<UserFollowsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserFollowsOneArgs = {
  object: UserFollowsInsertInput;
  onConflict?: InputMaybe<UserFollowsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserIdentityVerificationsArgs = {
  objects: Array<UserIdentityVerificationsInsertInput>;
  onConflict?: InputMaybe<UserIdentityVerificationsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserIdentityVerificationsOneArgs = {
  object: UserIdentityVerificationsInsertInput;
  onConflict?: InputMaybe<UserIdentityVerificationsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserImageLogArgs = {
  objects: Array<UserImageLogInsertInput>;
  onConflict?: InputMaybe<UserImageLogOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserImageLogOneArgs = {
  object: UserImageLogInsertInput;
  onConflict?: InputMaybe<UserImageLogOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserNotificationDetailsArgs = {
  objects: Array<UserNotificationDetailsInsertInput>;
  onConflict?: InputMaybe<UserNotificationDetailsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserNotificationDetailsOneArgs = {
  object: UserNotificationDetailsInsertInput;
  onConflict?: InputMaybe<UserNotificationDetailsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserNotificationEntitiesArgs = {
  objects: Array<UserNotificationEntitiesInsertInput>;
  onConflict?: InputMaybe<UserNotificationEntitiesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserNotificationEntitiesOneArgs = {
  object: UserNotificationEntitiesInsertInput;
  onConflict?: InputMaybe<UserNotificationEntitiesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserNotificationsArgs = {
  objects: Array<UserNotificationsInsertInput>;
  onConflict?: InputMaybe<UserNotificationsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserNotificationsOneArgs = {
  object: UserNotificationsInsertInput;
  onConflict?: InputMaybe<UserNotificationsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserPadelRatingScalesArgs = {
  objects: Array<UserPadelRatingScalesInsertInput>;
  onConflict?: InputMaybe<UserPadelRatingScalesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserPadelRatingScalesOneArgs = {
  object: UserPadelRatingScalesInsertInput;
  onConflict?: InputMaybe<UserPadelRatingScalesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserPickleballRatingScalesArgs = {
  objects: Array<UserPickleballRatingScalesInsertInput>;
  onConflict?: InputMaybe<UserPickleballRatingScalesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserPickleballRatingScalesOneArgs = {
  object: UserPickleballRatingScalesInsertInput;
  onConflict?: InputMaybe<UserPickleballRatingScalesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserPlayedWithDismissalsArgs = {
  objects: Array<UserPlayedWithDismissalsInsertInput>;
  onConflict?: InputMaybe<UserPlayedWithDismissalsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserPlayedWithDismissalsOneArgs = {
  object: UserPlayedWithDismissalsInsertInput;
  onConflict?: InputMaybe<UserPlayedWithDismissalsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserPlayerFinderAvailabilityArgs = {
  objects: Array<UserPlayerFinderAvailabilityInsertInput>;
  onConflict?: InputMaybe<UserPlayerFinderAvailabilityOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserPlayerFinderAvailabilityOneArgs = {
  object: UserPlayerFinderAvailabilityInsertInput;
  onConflict?: InputMaybe<UserPlayerFinderAvailabilityOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserPlayerFinderGoalsArgs = {
  objects: Array<UserPlayerFinderGoalsInsertInput>;
  onConflict?: InputMaybe<UserPlayerFinderGoalsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserPlayerFinderGoalsOneArgs = {
  object: UserPlayerFinderGoalsInsertInput;
  onConflict?: InputMaybe<UserPlayerFinderGoalsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserProfilesArgs = {
  objects: Array<UserProfilesInsertInput>;
};


/** mutation root */
export type Mutation_RootInsertUserProfilesOneArgs = {
  object: UserProfilesInsertInput;
};


/** mutation root */
export type Mutation_RootInsertUserRegistrationDetailsArgs = {
  objects: Array<UserRegistrationDetailsInsertInput>;
  onConflict?: InputMaybe<UserRegistrationDetailsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserRegistrationDetailsOneArgs = {
  object: UserRegistrationDetailsInsertInput;
  onConflict?: InputMaybe<UserRegistrationDetailsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserSportsArgs = {
  objects: Array<UserSportsInsertInput>;
  onConflict?: InputMaybe<UserSportsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserSportsOneArgs = {
  object: UserSportsInsertInput;
  onConflict?: InputMaybe<UserSportsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserTennisRatingScalesArgs = {
  objects: Array<UserTennisRatingScalesInsertInput>;
  onConflict?: InputMaybe<UserTennisRatingScalesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserTennisRatingScalesOneArgs = {
  object: UserTennisRatingScalesInsertInput;
  onConflict?: InputMaybe<UserTennisRatingScalesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserTermsOfServiceArgs = {
  objects: Array<UserTermsOfServiceInsertInput>;
  onConflict?: InputMaybe<UserTermsOfServiceOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserTermsOfServiceOneArgs = {
  object: UserTermsOfServiceInsertInput;
  onConflict?: InputMaybe<UserTermsOfServiceOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserVairConnectionsArgs = {
  objects: Array<UserVairConnectionsInsertInput>;
  onConflict?: InputMaybe<UserVairConnectionsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserVairConnectionsOneArgs = {
  object: UserVairConnectionsInsertInput;
  onConflict?: InputMaybe<UserVairConnectionsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUsernameLogsArgs = {
  objects: Array<UsernameLogsInsertInput>;
  onConflict?: InputMaybe<UsernameLogsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUsernameLogsOneArgs = {
  object: UsernameLogsInsertInput;
  onConflict?: InputMaybe<UsernameLogsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUsernamesActiveArgs = {
  objects: Array<UsernamesActiveInsertInput>;
};


/** mutation root */
export type Mutation_RootInsertUsernamesActiveOneArgs = {
  object: UsernamesActiveInsertInput;
};


/** mutation root */
export type Mutation_RootInsertUsernamesClaimedArgs = {
  objects: Array<UsernamesClaimedInsertInput>;
  onConflict?: InputMaybe<UsernamesClaimedOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUsernamesClaimedOneArgs = {
  object: UsernamesClaimedInsertInput;
  onConflict?: InputMaybe<UsernamesClaimedOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUsersArgs = {
  objects: Array<UsersInsertInput>;
  onConflict?: InputMaybe<UsersOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUsersCoachQualificationsArgs = {
  objects: Array<UsersCoachQualificationsInsertInput>;
  onConflict?: InputMaybe<UsersCoachQualificationsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUsersCoachQualificationsOneArgs = {
  object: UsersCoachQualificationsInsertInput;
  onConflict?: InputMaybe<UsersCoachQualificationsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUsersOneArgs = {
  object: UsersInsertInput;
  onConflict?: InputMaybe<UsersOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertVenueAccessTypesArgs = {
  objects: Array<VenueAccessTypesInsertInput>;
  onConflict?: InputMaybe<VenueAccessTypesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertVenueAccessTypesOneArgs = {
  object: VenueAccessTypesInsertInput;
  onConflict?: InputMaybe<VenueAccessTypesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertVenueAdminClaimStatusesArgs = {
  objects: Array<VenueAdminClaimStatusesInsertInput>;
  onConflict?: InputMaybe<VenueAdminClaimStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertVenueAdminClaimStatusesOneArgs = {
  object: VenueAdminClaimStatusesInsertInput;
  onConflict?: InputMaybe<VenueAdminClaimStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertVenueAdminClaimsArgs = {
  objects: Array<VenueAdminClaimsInsertInput>;
  onConflict?: InputMaybe<VenueAdminClaimsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertVenueAdminClaimsOneArgs = {
  object: VenueAdminClaimsInsertInput;
  onConflict?: InputMaybe<VenueAdminClaimsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertVenueAmenitiesArgs = {
  objects: Array<VenueAmenitiesInsertInput>;
  onConflict?: InputMaybe<VenueAmenitiesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertVenueAmenitiesOneArgs = {
  object: VenueAmenitiesInsertInput;
  onConflict?: InputMaybe<VenueAmenitiesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertVenueBookingConfigVersionsArgs = {
  objects: Array<VenueBookingConfigVersionsInsertInput>;
  onConflict?: InputMaybe<VenueBookingConfigVersionsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertVenueBookingConfigVersionsOneArgs = {
  object: VenueBookingConfigVersionsInsertInput;
  onConflict?: InputMaybe<VenueBookingConfigVersionsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertVenueBookingConnectionCheckStatusesArgs = {
  objects: Array<VenueBookingConnectionCheckStatusesInsertInput>;
  onConflict?: InputMaybe<VenueBookingConnectionCheckStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertVenueBookingConnectionCheckStatusesOneArgs = {
  object: VenueBookingConnectionCheckStatusesInsertInput;
  onConflict?: InputMaybe<VenueBookingConnectionCheckStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertVenueBookingConnectionChecksArgs = {
  objects: Array<VenueBookingConnectionChecksInsertInput>;
  onConflict?: InputMaybe<VenueBookingConnectionChecksOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertVenueBookingConnectionChecksOneArgs = {
  object: VenueBookingConnectionChecksInsertInput;
  onConflict?: InputMaybe<VenueBookingConnectionChecksOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertVenueBookingCourtRatesArgs = {
  objects: Array<VenueBookingCourtRatesInsertInput>;
  onConflict?: InputMaybe<VenueBookingCourtRatesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertVenueBookingCourtRatesOneArgs = {
  object: VenueBookingCourtRatesInsertInput;
  onConflict?: InputMaybe<VenueBookingCourtRatesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertVenueBookingIntegrationsArgs = {
  objects: Array<VenueBookingIntegrationsInsertInput>;
  onConflict?: InputMaybe<VenueBookingIntegrationsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertVenueBookingIntegrationsOneArgs = {
  object: VenueBookingIntegrationsInsertInput;
  onConflict?: InputMaybe<VenueBookingIntegrationsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertVenueBookingRuleTiersArgs = {
  objects: Array<VenueBookingRuleTiersInsertInput>;
  onConflict?: InputMaybe<VenueBookingRuleTiersOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertVenueBookingRuleTiersOneArgs = {
  object: VenueBookingRuleTiersInsertInput;
  onConflict?: InputMaybe<VenueBookingRuleTiersOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertVenueBookingRulesArgs = {
  objects: Array<VenueBookingRulesInsertInput>;
  onConflict?: InputMaybe<VenueBookingRulesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertVenueBookingRulesOneArgs = {
  object: VenueBookingRulesInsertInput;
  onConflict?: InputMaybe<VenueBookingRulesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertVenueBookingWindowsArgs = {
  objects: Array<VenueBookingWindowsInsertInput>;
  onConflict?: InputMaybe<VenueBookingWindowsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertVenueBookingWindowsOneArgs = {
  object: VenueBookingWindowsInsertInput;
  onConflict?: InputMaybe<VenueBookingWindowsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertVenueCourtSurfacesArgs = {
  objects: Array<VenueCourtSurfacesInsertInput>;
  onConflict?: InputMaybe<VenueCourtSurfacesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertVenueCourtSurfacesOneArgs = {
  object: VenueCourtSurfacesInsertInput;
  onConflict?: InputMaybe<VenueCourtSurfacesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertVenueCustomAmenitiesArgs = {
  objects: Array<VenueCustomAmenitiesInsertInput>;
  onConflict?: InputMaybe<VenueCustomAmenitiesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertVenueCustomAmenitiesOneArgs = {
  object: VenueCustomAmenitiesInsertInput;
  onConflict?: InputMaybe<VenueCustomAmenitiesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertVenueEquipmentArgs = {
  objects: Array<VenueEquipmentInsertInput>;
  onConflict?: InputMaybe<VenueEquipmentOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertVenueEquipmentOneArgs = {
  object: VenueEquipmentInsertInput;
  onConflict?: InputMaybe<VenueEquipmentOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertVenueFacilityTypesArgs = {
  objects: Array<VenueFacilityTypesInsertInput>;
  onConflict?: InputMaybe<VenueFacilityTypesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertVenueFacilityTypesOneArgs = {
  object: VenueFacilityTypesInsertInput;
  onConflict?: InputMaybe<VenueFacilityTypesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertVenueFaqsArgs = {
  objects: Array<VenueFaqsInsertInput>;
  onConflict?: InputMaybe<VenueFaqsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertVenueFaqsOneArgs = {
  object: VenueFaqsInsertInput;
  onConflict?: InputMaybe<VenueFaqsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertVenueFollowsArgs = {
  objects: Array<VenueFollowsInsertInput>;
  onConflict?: InputMaybe<VenueFollowsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertVenueFollowsOneArgs = {
  object: VenueFollowsInsertInput;
  onConflict?: InputMaybe<VenueFollowsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertVenueImagesArgs = {
  objects: Array<VenueImagesInsertInput>;
  onConflict?: InputMaybe<VenueImagesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertVenueImagesOneArgs = {
  object: VenueImagesInsertInput;
  onConflict?: InputMaybe<VenueImagesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertVenueLinesArgs = {
  objects: Array<VenueLinesInsertInput>;
  onConflict?: InputMaybe<VenueLinesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertVenueLinesOneArgs = {
  object: VenueLinesInsertInput;
  onConflict?: InputMaybe<VenueLinesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertVenueNetsArgs = {
  objects: Array<VenueNetsInsertInput>;
  onConflict?: InputMaybe<VenueNetsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertVenueNetsOneArgs = {
  object: VenueNetsInsertInput;
  onConflict?: InputMaybe<VenueNetsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertVenuePartnerBookingStatusesArgs = {
  objects: Array<VenuePartnerBookingStatusesInsertInput>;
};


/** mutation root */
export type Mutation_RootInsertVenuePartnerBookingStatusesOneArgs = {
  object: VenuePartnerBookingStatusesInsertInput;
};


/** mutation root */
export type Mutation_RootInsertVenueStaffCoachesArgs = {
  objects: Array<VenueStaffCoachesInsertInput>;
  onConflict?: InputMaybe<VenueStaffCoachesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertVenueStaffCoachesOneArgs = {
  object: VenueStaffCoachesInsertInput;
  onConflict?: InputMaybe<VenueStaffCoachesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertVenuesArgs = {
  objects: Array<VenuesInsertInput>;
  onConflict?: InputMaybe<VenuesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertVenuesOneArgs = {
  object: VenuesInsertInput;
  onConflict?: InputMaybe<VenuesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertVideoAnalysisArgs = {
  objects: Array<VideoAnalysisInsertInput>;
  onConflict?: InputMaybe<VideoAnalysisOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertVideoAnalysisCommentsArgs = {
  objects: Array<VideoAnalysisCommentsInsertInput>;
  onConflict?: InputMaybe<VideoAnalysisCommentsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertVideoAnalysisCommentsOneArgs = {
  object: VideoAnalysisCommentsInsertInput;
  onConflict?: InputMaybe<VideoAnalysisCommentsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertVideoAnalysisFilesArgs = {
  objects: Array<VideoAnalysisFilesInsertInput>;
  onConflict?: InputMaybe<VideoAnalysisFilesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertVideoAnalysisFilesOneArgs = {
  object: VideoAnalysisFilesInsertInput;
  onConflict?: InputMaybe<VideoAnalysisFilesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertVideoAnalysisFilesUploadStatusesArgs = {
  objects: Array<VideoAnalysisFilesUploadStatusesInsertInput>;
  onConflict?: InputMaybe<VideoAnalysisFilesUploadStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertVideoAnalysisFilesUploadStatusesOneArgs = {
  object: VideoAnalysisFilesUploadStatusesInsertInput;
  onConflict?: InputMaybe<VideoAnalysisFilesUploadStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertVideoAnalysisOneArgs = {
  object: VideoAnalysisInsertInput;
  onConflict?: InputMaybe<VideoAnalysisOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertVideoAnalysisOrderItemsArgs = {
  objects: Array<VideoAnalysisOrderItemsInsertInput>;
  onConflict?: InputMaybe<VideoAnalysisOrderItemsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertVideoAnalysisOrderItemsOneArgs = {
  object: VideoAnalysisOrderItemsInsertInput;
  onConflict?: InputMaybe<VideoAnalysisOrderItemsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertVideoAnalysisOrdersArgs = {
  objects: Array<VideoAnalysisOrdersInsertInput>;
  onConflict?: InputMaybe<VideoAnalysisOrdersOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertVideoAnalysisOrdersOneArgs = {
  object: VideoAnalysisOrdersInsertInput;
  onConflict?: InputMaybe<VideoAnalysisOrdersOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertVideoAnalysisRequestedSkillsReviewArgs = {
  objects: Array<VideoAnalysisRequestedSkillsReviewInsertInput>;
  onConflict?: InputMaybe<VideoAnalysisRequestedSkillsReviewOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertVideoAnalysisRequestedSkillsReviewOneArgs = {
  object: VideoAnalysisRequestedSkillsReviewInsertInput;
  onConflict?: InputMaybe<VideoAnalysisRequestedSkillsReviewOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertVideoAnalysisReviewStatusesArgs = {
  objects: Array<VideoAnalysisReviewStatusesInsertInput>;
  onConflict?: InputMaybe<VideoAnalysisReviewStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertVideoAnalysisReviewStatusesOneArgs = {
  object: VideoAnalysisReviewStatusesInsertInput;
  onConflict?: InputMaybe<VideoAnalysisReviewStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertVideoAnalysisSkillsCommentsArgs = {
  objects: Array<VideoAnalysisSkillsCommentsInsertInput>;
  onConflict?: InputMaybe<VideoAnalysisSkillsCommentsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertVideoAnalysisSkillsCommentsOneArgs = {
  object: VideoAnalysisSkillsCommentsInsertInput;
  onConflict?: InputMaybe<VideoAnalysisSkillsCommentsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertVideoAnalysisSubmissionLogArgs = {
  objects: Array<VideoAnalysisSubmissionLogInsertInput>;
  onConflict?: InputMaybe<VideoAnalysisSubmissionLogOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertVideoAnalysisSubmissionLogOneArgs = {
  object: VideoAnalysisSubmissionLogInsertInput;
  onConflict?: InputMaybe<VideoAnalysisSubmissionLogOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertVideoLessonSkillsArgs = {
  objects: Array<VideoLessonSkillsInsertInput>;
  onConflict?: InputMaybe<VideoLessonSkillsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertVideoLessonSkillsOneArgs = {
  object: VideoLessonSkillsInsertInput;
  onConflict?: InputMaybe<VideoLessonSkillsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertWelcomeEmailConfigurationArgs = {
  objects: Array<WelcomeEmailConfigurationInsertInput>;
  onConflict?: InputMaybe<WelcomeEmailConfigurationOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertWelcomeEmailConfigurationOneArgs = {
  object: WelcomeEmailConfigurationInsertInput;
  onConflict?: InputMaybe<WelcomeEmailConfigurationOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertWinReasonsArgs = {
  objects: Array<WinReasonsInsertInput>;
  onConflict?: InputMaybe<WinReasonsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertWinReasonsOneArgs = {
  object: WinReasonsInsertInput;
  onConflict?: InputMaybe<WinReasonsOnConflict>;
};


/** mutation root */
export type Mutation_RootUpdateAmenitiesArgs = {
  _set?: InputMaybe<AmenitiesSetInput>;
  where: AmenitiesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateAmenitiesByPkArgs = {
  _set?: InputMaybe<AmenitiesSetInput>;
  pkColumns: AmenitiesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateAmenitiesManyArgs = {
  updates: Array<AmenitiesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateAppPersonasArgs = {
  _set?: InputMaybe<AppPersonasSetInput>;
  where: AppPersonasBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateAppPersonasByPkArgs = {
  _set?: InputMaybe<AppPersonasSetInput>;
  pkColumns: AppPersonasPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateAppPersonasManyArgs = {
  updates: Array<AppPersonasUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateAppPingsArgs = {
  _append?: InputMaybe<AppPingsAppendInput>;
  _deleteAtPath?: InputMaybe<AppPingsDeleteAtPathInput>;
  _deleteElem?: InputMaybe<AppPingsDeleteElemInput>;
  _deleteKey?: InputMaybe<AppPingsDeleteKeyInput>;
  _prepend?: InputMaybe<AppPingsPrependInput>;
  _set?: InputMaybe<AppPingsSetInput>;
  where: AppPingsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateAppPingsByPkArgs = {
  _append?: InputMaybe<AppPingsAppendInput>;
  _deleteAtPath?: InputMaybe<AppPingsDeleteAtPathInput>;
  _deleteElem?: InputMaybe<AppPingsDeleteElemInput>;
  _deleteKey?: InputMaybe<AppPingsDeleteKeyInput>;
  _prepend?: InputMaybe<AppPingsPrependInput>;
  _set?: InputMaybe<AppPingsSetInput>;
  pkColumns: AppPingsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateAppPingsManyArgs = {
  updates: Array<AppPingsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateBallTypesArgs = {
  _set?: InputMaybe<BallTypesSetInput>;
  where: BallTypesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateBallTypesByPkArgs = {
  _set?: InputMaybe<BallTypesSetInput>;
  pkColumns: BallTypesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateBallTypesManyArgs = {
  updates: Array<BallTypesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateBirthdayVisibilityArgs = {
  _set?: InputMaybe<BirthdayVisibilitySetInput>;
  where: BirthdayVisibilityBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateBirthdayVisibilityByPkArgs = {
  _set?: InputMaybe<BirthdayVisibilitySetInput>;
  pkColumns: BirthdayVisibilityPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateBirthdayVisibilityManyArgs = {
  updates: Array<BirthdayVisibilityUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateBookingConfigChangeTypesArgs = {
  _set?: InputMaybe<BookingConfigChangeTypesSetInput>;
  where: BookingConfigChangeTypesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateBookingConfigChangeTypesByPkArgs = {
  _set?: InputMaybe<BookingConfigChangeTypesSetInput>;
  pkColumns: BookingConfigChangeTypesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateBookingConfigChangeTypesManyArgs = {
  updates: Array<BookingConfigChangeTypesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateBookingConnectionStatusesArgs = {
  _set?: InputMaybe<BookingConnectionStatusesSetInput>;
  where: BookingConnectionStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateBookingConnectionStatusesByPkArgs = {
  _set?: InputMaybe<BookingConnectionStatusesSetInput>;
  pkColumns: BookingConnectionStatusesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateBookingConnectionStatusesManyArgs = {
  updates: Array<BookingConnectionStatusesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateBookingIntegrationStatusesArgs = {
  _set?: InputMaybe<BookingIntegrationStatusesSetInput>;
  where: BookingIntegrationStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateBookingIntegrationStatusesByPkArgs = {
  _set?: InputMaybe<BookingIntegrationStatusesSetInput>;
  pkColumns: BookingIntegrationStatusesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateBookingIntegrationStatusesManyArgs = {
  updates: Array<BookingIntegrationStatusesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateBookingInventoryTypesArgs = {
  _set?: InputMaybe<BookingInventoryTypesSetInput>;
  where: BookingInventoryTypesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateBookingInventoryTypesByPkArgs = {
  _set?: InputMaybe<BookingInventoryTypesSetInput>;
  pkColumns: BookingInventoryTypesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateBookingInventoryTypesManyArgs = {
  updates: Array<BookingInventoryTypesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateBookingScheduleModesArgs = {
  _set?: InputMaybe<BookingScheduleModesSetInput>;
  where: BookingScheduleModesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateBookingScheduleModesByPkArgs = {
  _set?: InputMaybe<BookingScheduleModesSetInput>;
  pkColumns: BookingScheduleModesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateBookingScheduleModesManyArgs = {
  updates: Array<BookingScheduleModesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateBookingSystemsArgs = {
  _set?: InputMaybe<BookingSystemsSetInput>;
  where: BookingSystemsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateBookingSystemsByPkArgs = {
  _set?: InputMaybe<BookingSystemsSetInput>;
  pkColumns: BookingSystemsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateBookingSystemsManyArgs = {
  updates: Array<BookingSystemsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateBookingWindowKindsArgs = {
  _set?: InputMaybe<BookingWindowKindsSetInput>;
  where: BookingWindowKindsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateBookingWindowKindsByPkArgs = {
  _set?: InputMaybe<BookingWindowKindsSetInput>;
  pkColumns: BookingWindowKindsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateBookingWindowKindsManyArgs = {
  updates: Array<BookingWindowKindsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateBoostChannelsArgs = {
  _set?: InputMaybe<BoostChannelsSetInput>;
  where: BoostChannelsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateBoostChannelsByPkArgs = {
  _set?: InputMaybe<BoostChannelsSetInput>;
  pkColumns: BoostChannelsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateBoostChannelsManyArgs = {
  updates: Array<BoostChannelsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateBoostOrdersArgs = {
  _inc?: InputMaybe<BoostOrdersIncInput>;
  _set?: InputMaybe<BoostOrdersSetInput>;
  where: BoostOrdersBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateBoostOrdersByPkArgs = {
  _inc?: InputMaybe<BoostOrdersIncInput>;
  _set?: InputMaybe<BoostOrdersSetInput>;
  pkColumns: BoostOrdersPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateBoostOrdersManyArgs = {
  updates: Array<BoostOrdersUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateBoostStatusesArgs = {
  _set?: InputMaybe<BoostStatusesSetInput>;
  where: BoostStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateBoostStatusesByPkArgs = {
  _set?: InputMaybe<BoostStatusesSetInput>;
  pkColumns: BoostStatusesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateBoostStatusesManyArgs = {
  updates: Array<BoostStatusesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateBoostsArgs = {
  _inc?: InputMaybe<BoostsIncInput>;
  _set?: InputMaybe<BoostsSetInput>;
  where: BoostsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateBoostsByPkArgs = {
  _inc?: InputMaybe<BoostsIncInput>;
  _set?: InputMaybe<BoostsSetInput>;
  pkColumns: BoostsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateBoostsManyArgs = {
  updates: Array<BoostsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateBracketRankingMechanismArgs = {
  _set?: InputMaybe<BracketRankingMechanismSetInput>;
  where: BracketRankingMechanismBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateBracketRankingMechanismByPkArgs = {
  _set?: InputMaybe<BracketRankingMechanismSetInput>;
  pkColumns: BracketRankingMechanismPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateBracketRankingMechanismManyArgs = {
  updates: Array<BracketRankingMechanismUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateCalendarAccountsArgs = {
  _set?: InputMaybe<CalendarAccountsSetInput>;
  where: CalendarAccountsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateCalendarAccountsByPkArgs = {
  _set?: InputMaybe<CalendarAccountsSetInput>;
  pkColumns: CalendarAccountsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateCalendarAccountsManyArgs = {
  updates: Array<CalendarAccountsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateCalendarAuthProviderArgs = {
  _set?: InputMaybe<CalendarAuthProviderSetInput>;
  where: CalendarAuthProviderBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateCalendarAuthProviderByPkArgs = {
  _set?: InputMaybe<CalendarAuthProviderSetInput>;
  pkColumns: CalendarAuthProviderPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateCalendarAuthProviderManyArgs = {
  updates: Array<CalendarAuthProviderUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateCalendarEventMappingsArgs = {
  _set?: InputMaybe<CalendarEventMappingsSetInput>;
  where: CalendarEventMappingsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateCalendarEventMappingsByPkArgs = {
  _set?: InputMaybe<CalendarEventMappingsSetInput>;
  pkColumns: CalendarEventMappingsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateCalendarEventMappingsManyArgs = {
  updates: Array<CalendarEventMappingsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateCalendarPreferencesArgs = {
  _set?: InputMaybe<CalendarPreferencesSetInput>;
  where: CalendarPreferencesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateCalendarPreferencesByPkArgs = {
  _set?: InputMaybe<CalendarPreferencesSetInput>;
  pkColumns: CalendarPreferencesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateCalendarPreferencesManyArgs = {
  updates: Array<CalendarPreferencesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateCitiesArgs = {
  _inc?: InputMaybe<CitiesIncInput>;
  _set?: InputMaybe<CitiesSetInput>;
  where: CitiesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateCitiesByPkArgs = {
  _inc?: InputMaybe<CitiesIncInput>;
  _set?: InputMaybe<CitiesSetInput>;
  pkColumns: CitiesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateCitiesManyArgs = {
  updates: Array<CitiesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateCoachAvailabilityArgs = {
  _inc?: InputMaybe<CoachAvailabilityIncInput>;
  _set?: InputMaybe<CoachAvailabilitySetInput>;
  where: CoachAvailabilityBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateCoachAvailabilityByPkArgs = {
  _inc?: InputMaybe<CoachAvailabilityIncInput>;
  _set?: InputMaybe<CoachAvailabilitySetInput>;
  pkColumns: CoachAvailabilityPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateCoachAvailabilityManyArgs = {
  updates: Array<CoachAvailabilityUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateCoachAvailabilityStatusesArgs = {
  _set?: InputMaybe<CoachAvailabilityStatusesSetInput>;
  where: CoachAvailabilityStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateCoachAvailabilityStatusesByPkArgs = {
  _set?: InputMaybe<CoachAvailabilityStatusesSetInput>;
  pkColumns: CoachAvailabilityStatusesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateCoachAvailabilityStatusesManyArgs = {
  updates: Array<CoachAvailabilityStatusesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateCoachBookingRequestsArgs = {
  _set?: InputMaybe<CoachBookingRequestsSetInput>;
  where: CoachBookingRequestsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateCoachBookingRequestsByPkArgs = {
  _set?: InputMaybe<CoachBookingRequestsSetInput>;
  pkColumns: CoachBookingRequestsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateCoachBookingRequestsManyArgs = {
  updates: Array<CoachBookingRequestsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateCoachExternalReviewSourcesArgs = {
  _set?: InputMaybe<CoachExternalReviewSourcesSetInput>;
  where: CoachExternalReviewSourcesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateCoachExternalReviewSourcesByPkArgs = {
  _set?: InputMaybe<CoachExternalReviewSourcesSetInput>;
  pkColumns: CoachExternalReviewSourcesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateCoachExternalReviewSourcesManyArgs = {
  updates: Array<CoachExternalReviewSourcesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateCoachFaqsArgs = {
  _set?: InputMaybe<CoachFaqsSetInput>;
  where: CoachFaqsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateCoachFaqsByPkArgs = {
  _set?: InputMaybe<CoachFaqsSetInput>;
  pkColumns: CoachFaqsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateCoachFaqsManyArgs = {
  updates: Array<CoachFaqsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateCoachLessonAgeGroupsArgs = {
  _set?: InputMaybe<CoachLessonAgeGroupsSetInput>;
  where: CoachLessonAgeGroupsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateCoachLessonAgeGroupsByPkArgs = {
  _set?: InputMaybe<CoachLessonAgeGroupsSetInput>;
  pkColumns: CoachLessonAgeGroupsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateCoachLessonAgeGroupsManyArgs = {
  updates: Array<CoachLessonAgeGroupsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateCoachLessonSkillLevelsArgs = {
  _set?: InputMaybe<CoachLessonSkillLevelsSetInput>;
  where: CoachLessonSkillLevelsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateCoachLessonSkillLevelsByPkArgs = {
  _set?: InputMaybe<CoachLessonSkillLevelsSetInput>;
  pkColumns: CoachLessonSkillLevelsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateCoachLessonSkillLevelsManyArgs = {
  updates: Array<CoachLessonSkillLevelsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateCoachQualificationGroupsArgs = {
  _set?: InputMaybe<CoachQualificationGroupsSetInput>;
  where: CoachQualificationGroupsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateCoachQualificationGroupsByPkArgs = {
  _set?: InputMaybe<CoachQualificationGroupsSetInput>;
  pkColumns: CoachQualificationGroupsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateCoachQualificationGroupsManyArgs = {
  updates: Array<CoachQualificationGroupsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateCoachQualificationStatusesArgs = {
  _set?: InputMaybe<CoachQualificationStatusesSetInput>;
  where: CoachQualificationStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateCoachQualificationStatusesByPkArgs = {
  _set?: InputMaybe<CoachQualificationStatusesSetInput>;
  pkColumns: CoachQualificationStatusesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateCoachQualificationStatusesManyArgs = {
  updates: Array<CoachQualificationStatusesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateCoachQualificationsArgs = {
  _inc?: InputMaybe<CoachQualificationsIncInput>;
  _set?: InputMaybe<CoachQualificationsSetInput>;
  where: CoachQualificationsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateCoachQualificationsByPkArgs = {
  _inc?: InputMaybe<CoachQualificationsIncInput>;
  _set?: InputMaybe<CoachQualificationsSetInput>;
  pkColumns: CoachQualificationsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateCoachQualificationsManyArgs = {
  updates: Array<CoachQualificationsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateCoachReviewTypesArgs = {
  _set?: InputMaybe<CoachReviewTypesSetInput>;
  where: CoachReviewTypesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateCoachReviewTypesByPkArgs = {
  _set?: InputMaybe<CoachReviewTypesSetInput>;
  pkColumns: CoachReviewTypesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateCoachReviewTypesManyArgs = {
  updates: Array<CoachReviewTypesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateCoachSportStatusesArgs = {
  _set?: InputMaybe<CoachSportStatusesSetInput>;
  where: CoachSportStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateCoachSportStatusesByPkArgs = {
  _set?: InputMaybe<CoachSportStatusesSetInput>;
  pkColumns: CoachSportStatusesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateCoachSportStatusesManyArgs = {
  updates: Array<CoachSportStatusesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateCoachSportsArgs = {
  _set?: InputMaybe<CoachSportsSetInput>;
  where: CoachSportsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateCoachSportsByPkArgs = {
  _set?: InputMaybe<CoachSportsSetInput>;
  pkColumns: CoachSportsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateCoachSportsManyArgs = {
  updates: Array<CoachSportsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateCoachStarterProfilesArgs = {
  _append?: InputMaybe<CoachStarterProfilesAppendInput>;
  _deleteAtPath?: InputMaybe<CoachStarterProfilesDeleteAtPathInput>;
  _deleteElem?: InputMaybe<CoachStarterProfilesDeleteElemInput>;
  _deleteKey?: InputMaybe<CoachStarterProfilesDeleteKeyInput>;
  _inc?: InputMaybe<CoachStarterProfilesIncInput>;
  _prepend?: InputMaybe<CoachStarterProfilesPrependInput>;
  _set?: InputMaybe<CoachStarterProfilesSetInput>;
  where: CoachStarterProfilesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateCoachStarterProfilesByPkArgs = {
  _append?: InputMaybe<CoachStarterProfilesAppendInput>;
  _deleteAtPath?: InputMaybe<CoachStarterProfilesDeleteAtPathInput>;
  _deleteElem?: InputMaybe<CoachStarterProfilesDeleteElemInput>;
  _deleteKey?: InputMaybe<CoachStarterProfilesDeleteKeyInput>;
  _inc?: InputMaybe<CoachStarterProfilesIncInput>;
  _prepend?: InputMaybe<CoachStarterProfilesPrependInput>;
  _set?: InputMaybe<CoachStarterProfilesSetInput>;
  pkColumns: CoachStarterProfilesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateCoachStarterProfilesManyArgs = {
  updates: Array<CoachStarterProfilesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateCoachStatusArgs = {
  _set?: InputMaybe<CoachStatusSetInput>;
  where: CoachStatusBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateCoachStatusByPkArgs = {
  _set?: InputMaybe<CoachStatusSetInput>;
  pkColumns: CoachStatusPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateCoachStatusManyArgs = {
  updates: Array<CoachStatusUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateCoachTipsArgs = {
  _inc?: InputMaybe<CoachTipsIncInput>;
  _set?: InputMaybe<CoachTipsSetInput>;
  where: CoachTipsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateCoachTipsByPkArgs = {
  _inc?: InputMaybe<CoachTipsIncInput>;
  _set?: InputMaybe<CoachTipsSetInput>;
  pkColumns: CoachTipsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateCoachTipsManyArgs = {
  updates: Array<CoachTipsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateCommentVoteArgs = {
  _set?: InputMaybe<CommentVoteSetInput>;
  where: CommentVoteBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateCommentVoteByPkArgs = {
  _set?: InputMaybe<CommentVoteSetInput>;
  pkColumns: CommentVotePkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateCommentVoteManyArgs = {
  updates: Array<CommentVoteUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateCommunicationPreferenceStatusesArgs = {
  _set?: InputMaybe<CommunicationPreferenceStatusesSetInput>;
  where: CommunicationPreferenceStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateCommunicationPreferenceStatusesByPkArgs = {
  _set?: InputMaybe<CommunicationPreferenceStatusesSetInput>;
  pkColumns: CommunicationPreferenceStatusesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateCommunicationPreferenceStatusesManyArgs = {
  updates: Array<CommunicationPreferenceStatusesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateCompetitionFormatsArgs = {
  _set?: InputMaybe<CompetitionFormatsSetInput>;
  where: CompetitionFormatsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateCompetitionFormatsByPkArgs = {
  _set?: InputMaybe<CompetitionFormatsSetInput>;
  pkColumns: CompetitionFormatsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateCompetitionFormatsManyArgs = {
  updates: Array<CompetitionFormatsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateCompetitionGenderArgs = {
  _set?: InputMaybe<CompetitionGenderSetInput>;
  where: CompetitionGenderBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateCompetitionGenderByPkArgs = {
  _set?: InputMaybe<CompetitionGenderSetInput>;
  pkColumns: CompetitionGenderPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateCompetitionGenderManyArgs = {
  updates: Array<CompetitionGenderUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateContentReportsArgs = {
  _set?: InputMaybe<ContentReportsSetInput>;
  where: ContentReportsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateContentReportsByPkArgs = {
  _set?: InputMaybe<ContentReportsSetInput>;
  pkColumns: ContentReportsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateContentReportsManyArgs = {
  updates: Array<ContentReportsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateConversationParticipantsArgs = {
  _set?: InputMaybe<ConversationParticipantsSetInput>;
  where: ConversationParticipantsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateConversationParticipantsByPkArgs = {
  _set?: InputMaybe<ConversationParticipantsSetInput>;
  pkColumns: ConversationParticipantsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateConversationParticipantsManyArgs = {
  updates: Array<ConversationParticipantsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateConversationTypesArgs = {
  _set?: InputMaybe<ConversationTypesSetInput>;
  where: ConversationTypesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateConversationTypesByPkArgs = {
  _set?: InputMaybe<ConversationTypesSetInput>;
  pkColumns: ConversationTypesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateConversationTypesManyArgs = {
  updates: Array<ConversationTypesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateConversationsArgs = {
  _set?: InputMaybe<ConversationsSetInput>;
  where: ConversationsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateConversationsByPkArgs = {
  _set?: InputMaybe<ConversationsSetInput>;
  pkColumns: ConversationsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateConversationsManyArgs = {
  updates: Array<ConversationsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateCountriesArgs = {
  _inc?: InputMaybe<CountriesIncInput>;
  _set?: InputMaybe<CountriesSetInput>;
  where: CountriesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateCountriesByPkArgs = {
  _inc?: InputMaybe<CountriesIncInput>;
  _set?: InputMaybe<CountriesSetInput>;
  pkColumns: CountriesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateCountriesManyArgs = {
  updates: Array<CountriesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateCountrySubdivisionsArgs = {
  _inc?: InputMaybe<CountrySubdivisionsIncInput>;
  _set?: InputMaybe<CountrySubdivisionsSetInput>;
  where: CountrySubdivisionsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateCountrySubdivisionsByPkArgs = {
  _inc?: InputMaybe<CountrySubdivisionsIncInput>;
  _set?: InputMaybe<CountrySubdivisionsSetInput>;
  pkColumns: CountrySubdivisionsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateCountrySubdivisionsManyArgs = {
  updates: Array<CountrySubdivisionsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateCourtSurfacesArgs = {
  _set?: InputMaybe<CourtSurfacesSetInput>;
  where: CourtSurfacesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateCourtSurfacesByPkArgs = {
  _set?: InputMaybe<CourtSurfacesSetInput>;
  pkColumns: CourtSurfacesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateCourtSurfacesManyArgs = {
  updates: Array<CourtSurfacesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateDayOfWeekArgs = {
  _set?: InputMaybe<DayOfWeekSetInput>;
  where: DayOfWeekBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateDayOfWeekByPkArgs = {
  _set?: InputMaybe<DayOfWeekSetInput>;
  pkColumns: DayOfWeekPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateDayOfWeekManyArgs = {
  updates: Array<DayOfWeekUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEngagementAnalyticsArgs = {
  _set?: InputMaybe<EngagementAnalyticsSetInput>;
  where: EngagementAnalyticsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEngagementAnalyticsByPkArgs = {
  _set?: InputMaybe<EngagementAnalyticsSetInput>;
  pkColumns: EngagementAnalyticsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEngagementAnalyticsManyArgs = {
  updates: Array<EngagementAnalyticsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEngagementEntityTypesArgs = {
  _set?: InputMaybe<EngagementEntityTypesSetInput>;
  where: EngagementEntityTypesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEngagementEntityTypesByPkArgs = {
  _set?: InputMaybe<EngagementEntityTypesSetInput>;
  pkColumns: EngagementEntityTypesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEngagementEntityTypesManyArgs = {
  updates: Array<EngagementEntityTypesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEngagementEventTypesArgs = {
  _set?: InputMaybe<EngagementEventTypesSetInput>;
  where: EngagementEventTypesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEngagementEventTypesByPkArgs = {
  _set?: InputMaybe<EngagementEventTypesSetInput>;
  pkColumns: EngagementEventTypesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEngagementEventTypesManyArgs = {
  updates: Array<EngagementEventTypesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEngagementSourcesArgs = {
  _set?: InputMaybe<EngagementSourcesSetInput>;
  where: EngagementSourcesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEngagementSourcesByPkArgs = {
  _set?: InputMaybe<EngagementSourcesSetInput>;
  pkColumns: EngagementSourcesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEngagementSourcesManyArgs = {
  updates: Array<EngagementSourcesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEquipmentAvailabilitiesArgs = {
  _set?: InputMaybe<EquipmentAvailabilitiesSetInput>;
  where: EquipmentAvailabilitiesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEquipmentAvailabilitiesByPkArgs = {
  _set?: InputMaybe<EquipmentAvailabilitiesSetInput>;
  pkColumns: EquipmentAvailabilitiesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEquipmentAvailabilitiesManyArgs = {
  updates: Array<EquipmentAvailabilitiesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEventAcceptedPlayRequestsArgs = {
  _set?: InputMaybe<EventAcceptedPlayRequestsSetInput>;
  where: EventAcceptedPlayRequestsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEventAcceptedPlayRequestsManyArgs = {
  updates: Array<EventAcceptedPlayRequestsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEventAgeGroupsArgs = {
  _set?: InputMaybe<EventAgeGroupsSetInput>;
  where: EventAgeGroupsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEventAgeGroupsByPkArgs = {
  _set?: InputMaybe<EventAgeGroupsSetInput>;
  pkColumns: EventAgeGroupsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEventAgeGroupsManyArgs = {
  updates: Array<EventAgeGroupsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEventCollectionsArgs = {
  _set?: InputMaybe<EventCollectionsSetInput>;
  where: EventCollectionsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEventCollectionsByPkArgs = {
  _set?: InputMaybe<EventCollectionsSetInput>;
  pkColumns: EventCollectionsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEventCollectionsManyArgs = {
  updates: Array<EventCollectionsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEventCompetitivenessArgs = {
  _set?: InputMaybe<EventCompetitivenessSetInput>;
  where: EventCompetitivenessBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEventCompetitivenessByPkArgs = {
  _set?: InputMaybe<EventCompetitivenessSetInput>;
  pkColumns: EventCompetitivenessPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEventCompetitivenessManyArgs = {
  updates: Array<EventCompetitivenessUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEventContactDetailsArgs = {
  _set?: InputMaybe<EventContactDetailsSetInput>;
  where: EventContactDetailsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEventContactDetailsByPkArgs = {
  _set?: InputMaybe<EventContactDetailsSetInput>;
  pkColumns: EventContactDetailsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEventContactDetailsManyArgs = {
  updates: Array<EventContactDetailsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEventCouponGroupsArgs = {
  _set?: InputMaybe<EventCouponGroupsSetInput>;
  where: EventCouponGroupsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEventCouponGroupsByPkArgs = {
  _set?: InputMaybe<EventCouponGroupsSetInput>;
  pkColumns: EventCouponGroupsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEventCouponGroupsManyArgs = {
  updates: Array<EventCouponGroupsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEventCouponRedemptionsArgs = {
  _inc?: InputMaybe<EventCouponRedemptionsIncInput>;
  _set?: InputMaybe<EventCouponRedemptionsSetInput>;
  where: EventCouponRedemptionsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEventCouponRedemptionsByPkArgs = {
  _inc?: InputMaybe<EventCouponRedemptionsIncInput>;
  _set?: InputMaybe<EventCouponRedemptionsSetInput>;
  pkColumns: EventCouponRedemptionsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEventCouponRedemptionsManyArgs = {
  updates: Array<EventCouponRedemptionsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEventCouponSourceArgs = {
  _set?: InputMaybe<EventCouponSourceSetInput>;
  where: EventCouponSourceBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEventCouponSourceByPkArgs = {
  _set?: InputMaybe<EventCouponSourceSetInput>;
  pkColumns: EventCouponSourcePkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEventCouponSourceManyArgs = {
  updates: Array<EventCouponSourceUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEventCouponTypeArgs = {
  _set?: InputMaybe<EventCouponTypeSetInput>;
  where: EventCouponTypeBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEventCouponTypeByPkArgs = {
  _set?: InputMaybe<EventCouponTypeSetInput>;
  pkColumns: EventCouponTypePkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEventCouponTypeManyArgs = {
  updates: Array<EventCouponTypeUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEventCouponsArgs = {
  _inc?: InputMaybe<EventCouponsIncInput>;
  _set?: InputMaybe<EventCouponsSetInput>;
  where: EventCouponsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEventCouponsByPkArgs = {
  _inc?: InputMaybe<EventCouponsIncInput>;
  _set?: InputMaybe<EventCouponsSetInput>;
  pkColumns: EventCouponsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEventCouponsManyArgs = {
  updates: Array<EventCouponsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEventCourtStatusesArgs = {
  _set?: InputMaybe<EventCourtStatusesSetInput>;
  where: EventCourtStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEventCourtStatusesByPkArgs = {
  _set?: InputMaybe<EventCourtStatusesSetInput>;
  pkColumns: EventCourtStatusesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEventCourtStatusesManyArgs = {
  updates: Array<EventCourtStatusesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEventCourtsArgs = {
  _inc?: InputMaybe<EventCourtsIncInput>;
  _set?: InputMaybe<EventCourtsSetInput>;
  where: EventCourtsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEventCourtsByPkArgs = {
  _inc?: InputMaybe<EventCourtsIncInput>;
  _set?: InputMaybe<EventCourtsSetInput>;
  pkColumns: EventCourtsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEventCourtsManyArgs = {
  updates: Array<EventCourtsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEventFaqsArgs = {
  _set?: InputMaybe<EventFaqsSetInput>;
  where: EventFaqsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEventFaqsByPkArgs = {
  _set?: InputMaybe<EventFaqsSetInput>;
  pkColumns: EventFaqsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEventFaqsManyArgs = {
  updates: Array<EventFaqsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEventGameScoresArgs = {
  _inc?: InputMaybe<EventGameScoresIncInput>;
  _set?: InputMaybe<EventGameScoresSetInput>;
  where: EventGameScoresBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEventGameScoresByPkArgs = {
  _inc?: InputMaybe<EventGameScoresIncInput>;
  _set?: InputMaybe<EventGameScoresSetInput>;
  pkColumns: EventGameScoresPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEventGameScoresManyArgs = {
  updates: Array<EventGameScoresUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEventGroupFormatsArgs = {
  _set?: InputMaybe<EventGroupFormatsSetInput>;
  where: EventGroupFormatsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEventGroupFormatsByPkArgs = {
  _set?: InputMaybe<EventGroupFormatsSetInput>;
  pkColumns: EventGroupFormatsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEventGroupFormatsManyArgs = {
  updates: Array<EventGroupFormatsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEventGroupMergesArgs = {
  _set?: InputMaybe<EventGroupMergesSetInput>;
  where: EventGroupMergesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEventGroupMergesByPkArgs = {
  _set?: InputMaybe<EventGroupMergesSetInput>;
  pkColumns: EventGroupMergesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEventGroupMergesManyArgs = {
  updates: Array<EventGroupMergesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEventGroupPoolsArgs = {
  _set?: InputMaybe<EventGroupPoolsSetInput>;
  where: EventGroupPoolsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEventGroupPoolsByPkArgs = {
  _set?: InputMaybe<EventGroupPoolsSetInput>;
  pkColumns: EventGroupPoolsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEventGroupPoolsManyArgs = {
  updates: Array<EventGroupPoolsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEventGroupRatingScalesArgs = {
  _inc?: InputMaybe<EventGroupRatingScalesIncInput>;
  _set?: InputMaybe<EventGroupRatingScalesSetInput>;
  where: EventGroupRatingScalesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEventGroupRatingScalesByPkArgs = {
  _inc?: InputMaybe<EventGroupRatingScalesIncInput>;
  _set?: InputMaybe<EventGroupRatingScalesSetInput>;
  pkColumns: EventGroupRatingScalesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEventGroupRatingScalesManyArgs = {
  updates: Array<EventGroupRatingScalesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEventGroupRegistrationStatusesArgs = {
  _set?: InputMaybe<EventGroupRegistrationStatusesSetInput>;
  where: EventGroupRegistrationStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEventGroupRegistrationStatusesByPkArgs = {
  _set?: InputMaybe<EventGroupRegistrationStatusesSetInput>;
  pkColumns: EventGroupRegistrationStatusesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEventGroupRegistrationStatusesManyArgs = {
  updates: Array<EventGroupRegistrationStatusesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEventGroupRegistrationsArgs = {
  _set?: InputMaybe<EventGroupRegistrationsSetInput>;
  where: EventGroupRegistrationsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEventGroupRegistrationsByPkArgs = {
  _set?: InputMaybe<EventGroupRegistrationsSetInput>;
  pkColumns: EventGroupRegistrationsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEventGroupRegistrationsManyArgs = {
  updates: Array<EventGroupRegistrationsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEventGroupSequenceSeedingArgs = {
  _inc?: InputMaybe<EventGroupSequenceSeedingIncInput>;
  _set?: InputMaybe<EventGroupSequenceSeedingSetInput>;
  where: EventGroupSequenceSeedingBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEventGroupSequenceSeedingByPkArgs = {
  _inc?: InputMaybe<EventGroupSequenceSeedingIncInput>;
  _set?: InputMaybe<EventGroupSequenceSeedingSetInput>;
  pkColumns: EventGroupSequenceSeedingPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEventGroupSequenceSeedingManyArgs = {
  updates: Array<EventGroupSequenceSeedingUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEventGroupSequencesArgs = {
  _inc?: InputMaybe<EventGroupSequencesIncInput>;
  _set?: InputMaybe<EventGroupSequencesSetInput>;
  where: EventGroupSequencesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEventGroupSequencesByPkArgs = {
  _inc?: InputMaybe<EventGroupSequencesIncInput>;
  _set?: InputMaybe<EventGroupSequencesSetInput>;
  pkColumns: EventGroupSequencesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEventGroupSequencesManyArgs = {
  updates: Array<EventGroupSequencesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEventGroupTimeSlotsArgs = {
  _set?: InputMaybe<EventGroupTimeSlotsSetInput>;
  where: EventGroupTimeSlotsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEventGroupTimeSlotsByPkArgs = {
  _set?: InputMaybe<EventGroupTimeSlotsSetInput>;
  pkColumns: EventGroupTimeSlotsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEventGroupTimeSlotsManyArgs = {
  updates: Array<EventGroupTimeSlotsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEventGroupsArgs = {
  _append?: InputMaybe<EventGroupsAppendInput>;
  _deleteAtPath?: InputMaybe<EventGroupsDeleteAtPathInput>;
  _deleteElem?: InputMaybe<EventGroupsDeleteElemInput>;
  _deleteKey?: InputMaybe<EventGroupsDeleteKeyInput>;
  _inc?: InputMaybe<EventGroupsIncInput>;
  _prepend?: InputMaybe<EventGroupsPrependInput>;
  _set?: InputMaybe<EventGroupsSetInput>;
  where: EventGroupsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEventGroupsByPkArgs = {
  _append?: InputMaybe<EventGroupsAppendInput>;
  _deleteAtPath?: InputMaybe<EventGroupsDeleteAtPathInput>;
  _deleteElem?: InputMaybe<EventGroupsDeleteElemInput>;
  _deleteKey?: InputMaybe<EventGroupsDeleteKeyInput>;
  _inc?: InputMaybe<EventGroupsIncInput>;
  _prepend?: InputMaybe<EventGroupsPrependInput>;
  _set?: InputMaybe<EventGroupsSetInput>;
  pkColumns: EventGroupsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEventGroupsManyArgs = {
  updates: Array<EventGroupsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEventInvitationStatusesArgs = {
  _set?: InputMaybe<EventInvitationStatusesSetInput>;
  where: EventInvitationStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEventInvitationStatusesByPkArgs = {
  _set?: InputMaybe<EventInvitationStatusesSetInput>;
  pkColumns: EventInvitationStatusesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEventInvitationStatusesManyArgs = {
  updates: Array<EventInvitationStatusesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEventInvitationTypesArgs = {
  _set?: InputMaybe<EventInvitationTypesSetInput>;
  where: EventInvitationTypesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEventInvitationTypesByPkArgs = {
  _set?: InputMaybe<EventInvitationTypesSetInput>;
  pkColumns: EventInvitationTypesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEventInvitationTypesManyArgs = {
  updates: Array<EventInvitationTypesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEventInvitationsArgs = {
  _set?: InputMaybe<EventInvitationsSetInput>;
  where: EventInvitationsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEventInvitationsByPkArgs = {
  _set?: InputMaybe<EventInvitationsSetInput>;
  pkColumns: EventInvitationsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEventInvitationsManyArgs = {
  updates: Array<EventInvitationsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEventListingFeesArgs = {
  _inc?: InputMaybe<EventListingFeesIncInput>;
  _set?: InputMaybe<EventListingFeesSetInput>;
  where: EventListingFeesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEventListingFeesByPkArgs = {
  _inc?: InputMaybe<EventListingFeesIncInput>;
  _set?: InputMaybe<EventListingFeesSetInput>;
  pkColumns: EventListingFeesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEventListingFeesManyArgs = {
  updates: Array<EventListingFeesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEventMatchGamesArgs = {
  _inc?: InputMaybe<EventMatchGamesIncInput>;
  _set?: InputMaybe<EventMatchGamesSetInput>;
  where: EventMatchGamesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEventMatchGamesByPkArgs = {
  _inc?: InputMaybe<EventMatchGamesIncInput>;
  _set?: InputMaybe<EventMatchGamesSetInput>;
  pkColumns: EventMatchGamesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEventMatchGamesManyArgs = {
  updates: Array<EventMatchGamesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEventMatchesArgs = {
  _inc?: InputMaybe<EventMatchesIncInput>;
  _set?: InputMaybe<EventMatchesSetInput>;
  where: EventMatchesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEventMatchesByPkArgs = {
  _inc?: InputMaybe<EventMatchesIncInput>;
  _set?: InputMaybe<EventMatchesSetInput>;
  pkColumns: EventMatchesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEventMatchesManyArgs = {
  updates: Array<EventMatchesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEventMatchesTeamsArgs = {
  _inc?: InputMaybe<EventMatchesTeamsIncInput>;
  _set?: InputMaybe<EventMatchesTeamsSetInput>;
  where: EventMatchesTeamsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEventMatchesTeamsByPkArgs = {
  _inc?: InputMaybe<EventMatchesTeamsIncInput>;
  _set?: InputMaybe<EventMatchesTeamsSetInput>;
  pkColumns: EventMatchesTeamsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEventMatchesTeamsManyArgs = {
  updates: Array<EventMatchesTeamsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEventOrganizerAccountTypesArgs = {
  _set?: InputMaybe<EventOrganizerAccountTypesSetInput>;
  where: EventOrganizerAccountTypesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEventOrganizerAccountTypesByPkArgs = {
  _set?: InputMaybe<EventOrganizerAccountTypesSetInput>;
  pkColumns: EventOrganizerAccountTypesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEventOrganizerAccountTypesManyArgs = {
  updates: Array<EventOrganizerAccountTypesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEventPlayerInviteStatusesArgs = {
  _set?: InputMaybe<EventPlayerInviteStatusesSetInput>;
  where: EventPlayerInviteStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEventPlayerInviteStatusesByPkArgs = {
  _set?: InputMaybe<EventPlayerInviteStatusesSetInput>;
  pkColumns: EventPlayerInviteStatusesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEventPlayerInviteStatusesManyArgs = {
  updates: Array<EventPlayerInviteStatusesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEventPlayerInvitesArgs = {
  _set?: InputMaybe<EventPlayerInvitesSetInput>;
  where: EventPlayerInvitesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEventPlayerInvitesByPkArgs = {
  _set?: InputMaybe<EventPlayerInvitesSetInput>;
  pkColumns: EventPlayerInvitesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEventPlayerInvitesManyArgs = {
  updates: Array<EventPlayerInvitesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEventPoolRoundsArgs = {
  _inc?: InputMaybe<EventPoolRoundsIncInput>;
  _set?: InputMaybe<EventPoolRoundsSetInput>;
  where: EventPoolRoundsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEventPoolRoundsByPkArgs = {
  _inc?: InputMaybe<EventPoolRoundsIncInput>;
  _set?: InputMaybe<EventPoolRoundsSetInput>;
  pkColumns: EventPoolRoundsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEventPoolRoundsManyArgs = {
  updates: Array<EventPoolRoundsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEventPoolsTeamsArgs = {
  _set?: InputMaybe<EventPoolsTeamsSetInput>;
  where: EventPoolsTeamsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEventPoolsTeamsByPkArgs = {
  _set?: InputMaybe<EventPoolsTeamsSetInput>;
  pkColumns: EventPoolsTeamsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEventPoolsTeamsManyArgs = {
  updates: Array<EventPoolsTeamsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEventPrivacyArgs = {
  _set?: InputMaybe<EventPrivacySetInput>;
  where: EventPrivacyBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEventPrivacyByPkArgs = {
  _set?: InputMaybe<EventPrivacySetInput>;
  pkColumns: EventPrivacyPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEventPrivacyManyArgs = {
  updates: Array<EventPrivacyUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEventRegistrationDetailsArgs = {
  _set?: InputMaybe<EventRegistrationDetailsSetInput>;
  where: EventRegistrationDetailsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEventRegistrationDetailsByPkArgs = {
  _set?: InputMaybe<EventRegistrationDetailsSetInput>;
  pkColumns: EventRegistrationDetailsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEventRegistrationDetailsManyArgs = {
  updates: Array<EventRegistrationDetailsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEventRegistrationsArgs = {
  _set?: InputMaybe<EventRegistrationsSetInput>;
  where: EventRegistrationsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEventRegistrationsByPkArgs = {
  _set?: InputMaybe<EventRegistrationsSetInput>;
  pkColumns: EventRegistrationsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEventRegistrationsManyArgs = {
  updates: Array<EventRegistrationsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEventSequenceCompleteReasonsArgs = {
  _set?: InputMaybe<EventSequenceCompleteReasonsSetInput>;
  where: EventSequenceCompleteReasonsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEventSequenceCompleteReasonsByPkArgs = {
  _set?: InputMaybe<EventSequenceCompleteReasonsSetInput>;
  pkColumns: EventSequenceCompleteReasonsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEventSequenceCompleteReasonsManyArgs = {
  updates: Array<EventSequenceCompleteReasonsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEventSkillLevelsArgs = {
  _set?: InputMaybe<EventSkillLevelsSetInput>;
  where: EventSkillLevelsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEventSkillLevelsByPkArgs = {
  _set?: InputMaybe<EventSkillLevelsSetInput>;
  pkColumns: EventSkillLevelsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEventSkillLevelsManyArgs = {
  updates: Array<EventSkillLevelsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEventSponsorsArgs = {
  _set?: InputMaybe<EventSponsorsSetInput>;
  where: EventSponsorsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEventSponsorsByPkArgs = {
  _set?: InputMaybe<EventSponsorsSetInput>;
  pkColumns: EventSponsorsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEventSponsorsManyArgs = {
  updates: Array<EventSponsorsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEventStatusesArgs = {
  _set?: InputMaybe<EventStatusesSetInput>;
  where: EventStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEventStatusesByPkArgs = {
  _set?: InputMaybe<EventStatusesSetInput>;
  pkColumns: EventStatusesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEventStatusesManyArgs = {
  updates: Array<EventStatusesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEventTeamMemberStatusesArgs = {
  _set?: InputMaybe<EventTeamMemberStatusesSetInput>;
  where: EventTeamMemberStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEventTeamMemberStatusesByPkArgs = {
  _set?: InputMaybe<EventTeamMemberStatusesSetInput>;
  pkColumns: EventTeamMemberStatusesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEventTeamMemberStatusesManyArgs = {
  updates: Array<EventTeamMemberStatusesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEventTeamMembersArgs = {
  _set?: InputMaybe<EventTeamMembersSetInput>;
  where: EventTeamMembersBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEventTeamMembersByPkArgs = {
  _set?: InputMaybe<EventTeamMembersSetInput>;
  pkColumns: EventTeamMembersPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEventTeamMembersManyArgs = {
  updates: Array<EventTeamMembersUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEventTeamStatusesArgs = {
  _set?: InputMaybe<EventTeamStatusesSetInput>;
  where: EventTeamStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEventTeamStatusesByPkArgs = {
  _set?: InputMaybe<EventTeamStatusesSetInput>;
  pkColumns: EventTeamStatusesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEventTeamStatusesManyArgs = {
  updates: Array<EventTeamStatusesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEventTeamsArgs = {
  _set?: InputMaybe<EventTeamsSetInput>;
  where: EventTeamsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEventTeamsByPkArgs = {
  _set?: InputMaybe<EventTeamsSetInput>;
  pkColumns: EventTeamsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEventTeamsManyArgs = {
  updates: Array<EventTeamsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEventTransactionItemTypesArgs = {
  _set?: InputMaybe<EventTransactionItemTypesSetInput>;
  where: EventTransactionItemTypesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEventTransactionItemTypesByPkArgs = {
  _set?: InputMaybe<EventTransactionItemTypesSetInput>;
  pkColumns: EventTransactionItemTypesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEventTransactionItemTypesManyArgs = {
  updates: Array<EventTransactionItemTypesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEventTransactionItemsArgs = {
  _inc?: InputMaybe<EventTransactionItemsIncInput>;
  _set?: InputMaybe<EventTransactionItemsSetInput>;
  where: EventTransactionItemsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEventTransactionItemsByPkArgs = {
  _inc?: InputMaybe<EventTransactionItemsIncInput>;
  _set?: InputMaybe<EventTransactionItemsSetInput>;
  pkColumns: EventTransactionItemsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEventTransactionItemsManyArgs = {
  updates: Array<EventTransactionItemsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEventTransactionsArgs = {
  _inc?: InputMaybe<EventTransactionsIncInput>;
  _set?: InputMaybe<EventTransactionsSetInput>;
  where: EventTransactionsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEventTransactionsByPkArgs = {
  _inc?: InputMaybe<EventTransactionsIncInput>;
  _set?: InputMaybe<EventTransactionsSetInput>;
  pkColumns: EventTransactionsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEventTransactionsManyArgs = {
  updates: Array<EventTransactionsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEventTypesArgs = {
  _set?: InputMaybe<EventTypesSetInput>;
  where: EventTypesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEventTypesByPkArgs = {
  _set?: InputMaybe<EventTypesSetInput>;
  pkColumns: EventTypesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEventTypesManyArgs = {
  updates: Array<EventTypesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEventsArgs = {
  _inc?: InputMaybe<EventsIncInput>;
  _set?: InputMaybe<EventsSetInput>;
  where: EventsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEventsByPkArgs = {
  _inc?: InputMaybe<EventsIncInput>;
  _set?: InputMaybe<EventsSetInput>;
  pkColumns: EventsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEventsManyArgs = {
  updates: Array<EventsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateFeedbackSentimentArgs = {
  _set?: InputMaybe<FeedbackSentimentSetInput>;
  where: FeedbackSentimentBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateFeedbackSentimentByPkArgs = {
  _set?: InputMaybe<FeedbackSentimentSetInput>;
  pkColumns: FeedbackSentimentPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateFeedbackSentimentManyArgs = {
  updates: Array<FeedbackSentimentUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateFileCategoryArgs = {
  _set?: InputMaybe<FileCategorySetInput>;
  where: FileCategoryBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateFileCategoryByPkArgs = {
  _set?: InputMaybe<FileCategorySetInput>;
  pkColumns: FileCategoryPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateFileCategoryManyArgs = {
  updates: Array<FileCategoryUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateFileFormatArgs = {
  _set?: InputMaybe<FileFormatSetInput>;
  where: FileFormatBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateFileFormatByPkArgs = {
  _set?: InputMaybe<FileFormatSetInput>;
  pkColumns: FileFormatPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateFileFormatManyArgs = {
  updates: Array<FileFormatUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateFollowStatusesArgs = {
  _set?: InputMaybe<FollowStatusesSetInput>;
  where: FollowStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateFollowStatusesByPkArgs = {
  _set?: InputMaybe<FollowStatusesSetInput>;
  pkColumns: FollowStatusesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateFollowStatusesManyArgs = {
  updates: Array<FollowStatusesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateGameNetStatusesArgs = {
  _set?: InputMaybe<GameNetStatusesSetInput>;
  where: GameNetStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateGameNetStatusesByPkArgs = {
  _set?: InputMaybe<GameNetStatusesSetInput>;
  pkColumns: GameNetStatusesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateGameNetStatusesManyArgs = {
  updates: Array<GameNetStatusesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateGenderArgs = {
  _set?: InputMaybe<GenderSetInput>;
  where: GenderBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateGenderByPkArgs = {
  _set?: InputMaybe<GenderSetInput>;
  pkColumns: GenderPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateGenderManyArgs = {
  updates: Array<GenderUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateGroupCommentVotesArgs = {
  _set?: InputMaybe<GroupCommentVotesSetInput>;
  where: GroupCommentVotesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateGroupCommentVotesByPkArgs = {
  _set?: InputMaybe<GroupCommentVotesSetInput>;
  pkColumns: GroupCommentVotesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateGroupCommentVotesManyArgs = {
  updates: Array<GroupCommentVotesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateGroupMembersArgs = {
  _set?: InputMaybe<GroupMembersSetInput>;
  where: GroupMembersBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateGroupMembersByPkArgs = {
  _set?: InputMaybe<GroupMembersSetInput>;
  pkColumns: GroupMembersPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateGroupMembersManyArgs = {
  updates: Array<GroupMembersUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateGroupThreadCommentFilesArgs = {
  _set?: InputMaybe<GroupThreadCommentFilesSetInput>;
  where: GroupThreadCommentFilesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateGroupThreadCommentFilesByPkArgs = {
  _set?: InputMaybe<GroupThreadCommentFilesSetInput>;
  pkColumns: GroupThreadCommentFilesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateGroupThreadCommentFilesManyArgs = {
  updates: Array<GroupThreadCommentFilesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateGroupThreadCommentsArgs = {
  _set?: InputMaybe<GroupThreadCommentsSetInput>;
  where: GroupThreadCommentsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateGroupThreadCommentsByPkArgs = {
  _set?: InputMaybe<GroupThreadCommentsSetInput>;
  pkColumns: GroupThreadCommentsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateGroupThreadCommentsManyArgs = {
  updates: Array<GroupThreadCommentsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateGroupThreadsArgs = {
  _set?: InputMaybe<GroupThreadsSetInput>;
  where: GroupThreadsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateGroupThreadsByPkArgs = {
  _set?: InputMaybe<GroupThreadsSetInput>;
  pkColumns: GroupThreadsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateGroupThreadsManyArgs = {
  updates: Array<GroupThreadsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateGroupTypesArgs = {
  _set?: InputMaybe<GroupTypesSetInput>;
  where: GroupTypesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateGroupTypesByPkArgs = {
  _set?: InputMaybe<GroupTypesSetInput>;
  pkColumns: GroupTypesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateGroupTypesManyArgs = {
  updates: Array<GroupTypesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateGroupVenuesArgs = {
  _set?: InputMaybe<GroupVenuesSetInput>;
  where: GroupVenuesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateGroupVenuesByPkArgs = {
  _set?: InputMaybe<GroupVenuesSetInput>;
  pkColumns: GroupVenuesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateGroupVenuesManyArgs = {
  updates: Array<GroupVenuesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateGroupsArgs = {
  _inc?: InputMaybe<GroupsIncInput>;
  _set?: InputMaybe<GroupsSetInput>;
  where: GroupsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateGroupsByPkArgs = {
  _inc?: InputMaybe<GroupsIncInput>;
  _set?: InputMaybe<GroupsSetInput>;
  pkColumns: GroupsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateGroupsManyArgs = {
  updates: Array<GroupsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateGroupsPlaySessionsArgs = {
  _set?: InputMaybe<GroupsPlaySessionsSetInput>;
  where: GroupsPlaySessionsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateGroupsPlaySessionsByPkArgs = {
  _set?: InputMaybe<GroupsPlaySessionsSetInput>;
  pkColumns: GroupsPlaySessionsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateGroupsPlaySessionsManyArgs = {
  updates: Array<GroupsPlaySessionsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateIdentityVerificationProvidersArgs = {
  _set?: InputMaybe<IdentityVerificationProvidersSetInput>;
  where: IdentityVerificationProvidersBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateIdentityVerificationProvidersByPkArgs = {
  _set?: InputMaybe<IdentityVerificationProvidersSetInput>;
  pkColumns: IdentityVerificationProvidersPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateIdentityVerificationProvidersManyArgs = {
  updates: Array<IdentityVerificationProvidersUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateIdentityVerificationStatusesArgs = {
  _set?: InputMaybe<IdentityVerificationStatusesSetInput>;
  where: IdentityVerificationStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateIdentityVerificationStatusesByPkArgs = {
  _set?: InputMaybe<IdentityVerificationStatusesSetInput>;
  pkColumns: IdentityVerificationStatusesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateIdentityVerificationStatusesManyArgs = {
  updates: Array<IdentityVerificationStatusesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateInvoicesArgs = {
  _inc?: InputMaybe<InvoicesIncInput>;
  _set?: InputMaybe<InvoicesSetInput>;
  where: InvoicesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateInvoicesByPkArgs = {
  _inc?: InputMaybe<InvoicesIncInput>;
  _set?: InputMaybe<InvoicesSetInput>;
  pkColumns: InvoicesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateInvoicesManyArgs = {
  updates: Array<InvoicesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateLearningProgramEnrollmentScheduleMediaWatchedArgs = {
  _set?: InputMaybe<LearningProgramEnrollmentScheduleMediaWatchedSetInput>;
  where: LearningProgramEnrollmentScheduleMediaWatchedBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateLearningProgramEnrollmentScheduleMediaWatchedByPkArgs = {
  _set?: InputMaybe<LearningProgramEnrollmentScheduleMediaWatchedSetInput>;
  pkColumns: LearningProgramEnrollmentScheduleMediaWatchedPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateLearningProgramEnrollmentScheduleMediaWatchedManyArgs = {
  updates: Array<LearningProgramEnrollmentScheduleMediaWatchedUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateLearningProgramEnrollmentScheduleProgressArgs = {
  _inc?: InputMaybe<LearningProgramEnrollmentScheduleProgressIncInput>;
  _set?: InputMaybe<LearningProgramEnrollmentScheduleProgressSetInput>;
  where: LearningProgramEnrollmentScheduleProgressBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateLearningProgramEnrollmentScheduleProgressByPkArgs = {
  _inc?: InputMaybe<LearningProgramEnrollmentScheduleProgressIncInput>;
  _set?: InputMaybe<LearningProgramEnrollmentScheduleProgressSetInput>;
  pkColumns: LearningProgramEnrollmentScheduleProgressPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateLearningProgramEnrollmentScheduleProgressManyArgs = {
  updates: Array<LearningProgramEnrollmentScheduleProgressUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateLearningProgramEnrollmentsArgs = {
  _inc?: InputMaybe<LearningProgramEnrollmentsIncInput>;
  _set?: InputMaybe<LearningProgramEnrollmentsSetInput>;
  where: LearningProgramEnrollmentsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateLearningProgramEnrollmentsByPkArgs = {
  _inc?: InputMaybe<LearningProgramEnrollmentsIncInput>;
  _set?: InputMaybe<LearningProgramEnrollmentsSetInput>;
  pkColumns: LearningProgramEnrollmentsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateLearningProgramEnrollmentsManyArgs = {
  updates: Array<LearningProgramEnrollmentsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateLearningProgramMediaArgs = {
  _set?: InputMaybe<LearningProgramMediaSetInput>;
  where: LearningProgramMediaBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateLearningProgramMediaByPkArgs = {
  _set?: InputMaybe<LearningProgramMediaSetInput>;
  pkColumns: LearningProgramMediaPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateLearningProgramMediaCategoriesArgs = {
  _inc?: InputMaybe<LearningProgramMediaCategoriesIncInput>;
  _set?: InputMaybe<LearningProgramMediaCategoriesSetInput>;
  where: LearningProgramMediaCategoriesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateLearningProgramMediaCategoriesByPkArgs = {
  _inc?: InputMaybe<LearningProgramMediaCategoriesIncInput>;
  _set?: InputMaybe<LearningProgramMediaCategoriesSetInput>;
  pkColumns: LearningProgramMediaCategoriesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateLearningProgramMediaCategoriesManyArgs = {
  updates: Array<LearningProgramMediaCategoriesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateLearningProgramMediaManyArgs = {
  updates: Array<LearningProgramMediaUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateLearningProgramScheduleMediaArgs = {
  _inc?: InputMaybe<LearningProgramScheduleMediaIncInput>;
  _set?: InputMaybe<LearningProgramScheduleMediaSetInput>;
  where: LearningProgramScheduleMediaBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateLearningProgramScheduleMediaByPkArgs = {
  _inc?: InputMaybe<LearningProgramScheduleMediaIncInput>;
  _set?: InputMaybe<LearningProgramScheduleMediaSetInput>;
  pkColumns: LearningProgramScheduleMediaPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateLearningProgramScheduleMediaManyArgs = {
  updates: Array<LearningProgramScheduleMediaUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateLearningProgramScheduleUnitsArgs = {
  _set?: InputMaybe<LearningProgramScheduleUnitsSetInput>;
  where: LearningProgramScheduleUnitsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateLearningProgramScheduleUnitsByPkArgs = {
  _set?: InputMaybe<LearningProgramScheduleUnitsSetInput>;
  pkColumns: LearningProgramScheduleUnitsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateLearningProgramScheduleUnitsManyArgs = {
  updates: Array<LearningProgramScheduleUnitsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateLearningProgramScheduleVideoSubmissionsArgs = {
  _set?: InputMaybe<LearningProgramScheduleVideoSubmissionsSetInput>;
  where: LearningProgramScheduleVideoSubmissionsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateLearningProgramScheduleVideoSubmissionsByPkArgs = {
  _set?: InputMaybe<LearningProgramScheduleVideoSubmissionsSetInput>;
  pkColumns: LearningProgramScheduleVideoSubmissionsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateLearningProgramScheduleVideoSubmissionsManyArgs = {
  updates: Array<LearningProgramScheduleVideoSubmissionsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateLearningProgramSchedulesArgs = {
  _inc?: InputMaybe<LearningProgramSchedulesIncInput>;
  _set?: InputMaybe<LearningProgramSchedulesSetInput>;
  where: LearningProgramSchedulesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateLearningProgramSchedulesByPkArgs = {
  _inc?: InputMaybe<LearningProgramSchedulesIncInput>;
  _set?: InputMaybe<LearningProgramSchedulesSetInput>;
  pkColumns: LearningProgramSchedulesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateLearningProgramSchedulesManyArgs = {
  updates: Array<LearningProgramSchedulesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateLearningProgramSkillLevelValuesArgs = {
  _set?: InputMaybe<LearningProgramSkillLevelValuesSetInput>;
  where: LearningProgramSkillLevelValuesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateLearningProgramSkillLevelValuesByPkArgs = {
  _set?: InputMaybe<LearningProgramSkillLevelValuesSetInput>;
  pkColumns: LearningProgramSkillLevelValuesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateLearningProgramSkillLevelValuesManyArgs = {
  updates: Array<LearningProgramSkillLevelValuesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateLearningProgramSkillsArgs = {
  _set?: InputMaybe<LearningProgramSkillsSetInput>;
  where: LearningProgramSkillsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateLearningProgramSkillsByPkArgs = {
  _set?: InputMaybe<LearningProgramSkillsSetInput>;
  pkColumns: LearningProgramSkillsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateLearningProgramSkillsManyArgs = {
  updates: Array<LearningProgramSkillsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateLearningProgramsArgs = {
  _inc?: InputMaybe<LearningProgramsIncInput>;
  _set?: InputMaybe<LearningProgramsSetInput>;
  where: LearningProgramsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateLearningProgramsByPkArgs = {
  _inc?: InputMaybe<LearningProgramsIncInput>;
  _set?: InputMaybe<LearningProgramsSetInput>;
  pkColumns: LearningProgramsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateLearningProgramsManyArgs = {
  updates: Array<LearningProgramsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateLessonAgeGroupsArgs = {
  _set?: InputMaybe<LessonAgeGroupsSetInput>;
  where: LessonAgeGroupsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateLessonAgeGroupsByPkArgs = {
  _set?: InputMaybe<LessonAgeGroupsSetInput>;
  pkColumns: LessonAgeGroupsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateLessonAgeGroupsManyArgs = {
  updates: Array<LessonAgeGroupsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateLessonCollectionsArgs = {
  _set?: InputMaybe<LessonCollectionsSetInput>;
  where: LessonCollectionsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateLessonCollectionsByPkArgs = {
  _set?: InputMaybe<LessonCollectionsSetInput>;
  pkColumns: LessonCollectionsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateLessonCollectionsManyArgs = {
  updates: Array<LessonCollectionsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateLessonEquipmentArgs = {
  _set?: InputMaybe<LessonEquipmentSetInput>;
  where: LessonEquipmentBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateLessonEquipmentByPkArgs = {
  _set?: InputMaybe<LessonEquipmentSetInput>;
  pkColumns: LessonEquipmentPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateLessonEquipmentManyArgs = {
  updates: Array<LessonEquipmentUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateLessonEquipmentOptionsArgs = {
  _set?: InputMaybe<LessonEquipmentOptionsSetInput>;
  where: LessonEquipmentOptionsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateLessonEquipmentOptionsByPkArgs = {
  _set?: InputMaybe<LessonEquipmentOptionsSetInput>;
  pkColumns: LessonEquipmentOptionsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateLessonEquipmentOptionsManyArgs = {
  updates: Array<LessonEquipmentOptionsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateLessonOrderItemsArgs = {
  _inc?: InputMaybe<LessonOrderItemsIncInput>;
  _set?: InputMaybe<LessonOrderItemsSetInput>;
  where: LessonOrderItemsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateLessonOrderItemsByPkArgs = {
  _inc?: InputMaybe<LessonOrderItemsIncInput>;
  _set?: InputMaybe<LessonOrderItemsSetInput>;
  pkColumns: LessonOrderItemsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateLessonOrderItemsManyArgs = {
  updates: Array<LessonOrderItemsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateLessonOrdersArgs = {
  _inc?: InputMaybe<LessonOrdersIncInput>;
  _set?: InputMaybe<LessonOrdersSetInput>;
  where: LessonOrdersBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateLessonOrdersByPkArgs = {
  _inc?: InputMaybe<LessonOrdersIncInput>;
  _set?: InputMaybe<LessonOrdersSetInput>;
  pkColumns: LessonOrdersPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateLessonOrdersManyArgs = {
  updates: Array<LessonOrdersUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateLessonParticipantStatusesArgs = {
  _set?: InputMaybe<LessonParticipantStatusesSetInput>;
  where: LessonParticipantStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateLessonParticipantStatusesByPkArgs = {
  _set?: InputMaybe<LessonParticipantStatusesSetInput>;
  pkColumns: LessonParticipantStatusesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateLessonParticipantStatusesManyArgs = {
  updates: Array<LessonParticipantStatusesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateLessonParticipantsArgs = {
  _set?: InputMaybe<LessonParticipantsSetInput>;
  where: LessonParticipantsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateLessonParticipantsByPkArgs = {
  _set?: InputMaybe<LessonParticipantsSetInput>;
  pkColumns: LessonParticipantsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateLessonParticipantsManyArgs = {
  updates: Array<LessonParticipantsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateLessonPlayerSkillAssessmentCategoriesArgs = {
  _set?: InputMaybe<LessonPlayerSkillAssessmentCategoriesSetInput>;
  where: LessonPlayerSkillAssessmentCategoriesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateLessonPlayerSkillAssessmentCategoriesByPkArgs = {
  _set?: InputMaybe<LessonPlayerSkillAssessmentCategoriesSetInput>;
  pkColumns: LessonPlayerSkillAssessmentCategoriesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateLessonPlayerSkillAssessmentCategoriesManyArgs = {
  updates: Array<LessonPlayerSkillAssessmentCategoriesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateLessonPlayerSkillAssessmentsArgs = {
  _set?: InputMaybe<LessonPlayerSkillAssessmentsSetInput>;
  where: LessonPlayerSkillAssessmentsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateLessonPlayerSkillAssessmentsByPkArgs = {
  _set?: InputMaybe<LessonPlayerSkillAssessmentsSetInput>;
  pkColumns: LessonPlayerSkillAssessmentsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateLessonPlayerSkillAssessmentsManyArgs = {
  updates: Array<LessonPlayerSkillAssessmentsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateLessonPlayerSkillAssessmentsSkillsArgs = {
  _set?: InputMaybe<LessonPlayerSkillAssessmentsSkillsSetInput>;
  where: LessonPlayerSkillAssessmentsSkillsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateLessonPlayerSkillAssessmentsSkillsByPkArgs = {
  _set?: InputMaybe<LessonPlayerSkillAssessmentsSkillsSetInput>;
  pkColumns: LessonPlayerSkillAssessmentsSkillsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateLessonPlayerSkillAssessmentsSkillsManyArgs = {
  updates: Array<LessonPlayerSkillAssessmentsSkillsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateLessonPrivacyArgs = {
  _set?: InputMaybe<LessonPrivacySetInput>;
  where: LessonPrivacyBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateLessonPrivacyByPkArgs = {
  _set?: InputMaybe<LessonPrivacySetInput>;
  pkColumns: LessonPrivacyPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateLessonPrivacyManyArgs = {
  updates: Array<LessonPrivacyUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateLessonReflectionCommentTypesArgs = {
  _set?: InputMaybe<LessonReflectionCommentTypesSetInput>;
  where: LessonReflectionCommentTypesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateLessonReflectionCommentTypesByPkArgs = {
  _set?: InputMaybe<LessonReflectionCommentTypesSetInput>;
  pkColumns: LessonReflectionCommentTypesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateLessonReflectionCommentTypesManyArgs = {
  updates: Array<LessonReflectionCommentTypesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateLessonReflectionCommentsArgs = {
  _inc?: InputMaybe<LessonReflectionCommentsIncInput>;
  _set?: InputMaybe<LessonReflectionCommentsSetInput>;
  where: LessonReflectionCommentsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateLessonReflectionCommentsByPkArgs = {
  _inc?: InputMaybe<LessonReflectionCommentsIncInput>;
  _set?: InputMaybe<LessonReflectionCommentsSetInput>;
  pkColumns: LessonReflectionCommentsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateLessonReflectionCommentsManyArgs = {
  updates: Array<LessonReflectionCommentsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateLessonReflectionFilesArgs = {
  _set?: InputMaybe<LessonReflectionFilesSetInput>;
  where: LessonReflectionFilesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateLessonReflectionFilesByPkArgs = {
  _set?: InputMaybe<LessonReflectionFilesSetInput>;
  pkColumns: LessonReflectionFilesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateLessonReflectionFilesManyArgs = {
  updates: Array<LessonReflectionFilesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateLessonReflectionsArgs = {
  _set?: InputMaybe<LessonReflectionsSetInput>;
  where: LessonReflectionsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateLessonReflectionsByPkArgs = {
  _set?: InputMaybe<LessonReflectionsSetInput>;
  pkColumns: LessonReflectionsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateLessonReflectionsManyArgs = {
  updates: Array<LessonReflectionsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateLessonSkillCategoriesArgs = {
  _set?: InputMaybe<LessonSkillCategoriesSetInput>;
  where: LessonSkillCategoriesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateLessonSkillCategoriesByPkArgs = {
  _set?: InputMaybe<LessonSkillCategoriesSetInput>;
  pkColumns: LessonSkillCategoriesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateLessonSkillCategoriesManyArgs = {
  updates: Array<LessonSkillCategoriesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateLessonSkillDisplayNamesArgs = {
  _set?: InputMaybe<LessonSkillDisplayNamesSetInput>;
  where: LessonSkillDisplayNamesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateLessonSkillDisplayNamesByPkArgs = {
  _set?: InputMaybe<LessonSkillDisplayNamesSetInput>;
  pkColumns: LessonSkillDisplayNamesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateLessonSkillDisplayNamesManyArgs = {
  updates: Array<LessonSkillDisplayNamesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateLessonSkillLevelsArgs = {
  _set?: InputMaybe<LessonSkillLevelsSetInput>;
  where: LessonSkillLevelsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateLessonSkillLevelsByPkArgs = {
  _set?: InputMaybe<LessonSkillLevelsSetInput>;
  pkColumns: LessonSkillLevelsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateLessonSkillLevelsManyArgs = {
  updates: Array<LessonSkillLevelsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateLessonSkillMappingsArgs = {
  _set?: InputMaybe<LessonSkillMappingsSetInput>;
  where: LessonSkillMappingsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateLessonSkillMappingsByPkArgs = {
  _set?: InputMaybe<LessonSkillMappingsSetInput>;
  pkColumns: LessonSkillMappingsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateLessonSkillMappingsManyArgs = {
  updates: Array<LessonSkillMappingsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateLessonSkillsArgs = {
  _set?: InputMaybe<LessonSkillsSetInput>;
  where: LessonSkillsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateLessonSkillsByPkArgs = {
  _set?: InputMaybe<LessonSkillsSetInput>;
  pkColumns: LessonSkillsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateLessonSkillsManyArgs = {
  updates: Array<LessonSkillsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateLessonStatusesArgs = {
  _set?: InputMaybe<LessonStatusesSetInput>;
  where: LessonStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateLessonStatusesByPkArgs = {
  _set?: InputMaybe<LessonStatusesSetInput>;
  pkColumns: LessonStatusesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateLessonStatusesManyArgs = {
  updates: Array<LessonStatusesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateLessonTemplateSkillLevelsArgs = {
  _set?: InputMaybe<LessonTemplateSkillLevelsSetInput>;
  where: LessonTemplateSkillLevelsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateLessonTemplateSkillLevelsByPkArgs = {
  _set?: InputMaybe<LessonTemplateSkillLevelsSetInput>;
  pkColumns: LessonTemplateSkillLevelsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateLessonTemplateSkillLevelsManyArgs = {
  updates: Array<LessonTemplateSkillLevelsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateLessonTemplatesArgs = {
  _inc?: InputMaybe<LessonTemplatesIncInput>;
  _set?: InputMaybe<LessonTemplatesSetInput>;
  where: LessonTemplatesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateLessonTemplatesByPkArgs = {
  _inc?: InputMaybe<LessonTemplatesIncInput>;
  _set?: InputMaybe<LessonTemplatesSetInput>;
  pkColumns: LessonTemplatesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateLessonTemplatesManyArgs = {
  updates: Array<LessonTemplatesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateLessonTimesArgs = {
  _set?: InputMaybe<LessonTimesSetInput>;
  where: LessonTimesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateLessonTimesByPkArgs = {
  _set?: InputMaybe<LessonTimesSetInput>;
  pkColumns: LessonTimesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateLessonTimesManyArgs = {
  updates: Array<LessonTimesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateLessonTypesArgs = {
  _set?: InputMaybe<LessonTypesSetInput>;
  where: LessonTypesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateLessonTypesByPkArgs = {
  _set?: InputMaybe<LessonTypesSetInput>;
  pkColumns: LessonTypesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateLessonTypesManyArgs = {
  updates: Array<LessonTypesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateLessonWaitlistStatusesArgs = {
  _set?: InputMaybe<LessonWaitlistStatusesSetInput>;
  where: LessonWaitlistStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateLessonWaitlistStatusesByPkArgs = {
  _set?: InputMaybe<LessonWaitlistStatusesSetInput>;
  pkColumns: LessonWaitlistStatusesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateLessonWaitlistStatusesManyArgs = {
  updates: Array<LessonWaitlistStatusesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateLessonWaitlistsArgs = {
  _set?: InputMaybe<LessonWaitlistsSetInput>;
  where: LessonWaitlistsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateLessonWaitlistsByPkArgs = {
  _set?: InputMaybe<LessonWaitlistsSetInput>;
  pkColumns: LessonWaitlistsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateLessonWaitlistsManyArgs = {
  updates: Array<LessonWaitlistsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateLessonsArgs = {
  _inc?: InputMaybe<LessonsIncInput>;
  _set?: InputMaybe<LessonsSetInput>;
  where: LessonsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateLessonsByPkArgs = {
  _inc?: InputMaybe<LessonsIncInput>;
  _set?: InputMaybe<LessonsSetInput>;
  pkColumns: LessonsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateLessonsManyArgs = {
  updates: Array<LessonsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateMatchSelectionCriteriaArgs = {
  _set?: InputMaybe<MatchSelectionCriteriaSetInput>;
  where: MatchSelectionCriteriaBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateMatchSelectionCriteriaByPkArgs = {
  _set?: InputMaybe<MatchSelectionCriteriaSetInput>;
  pkColumns: MatchSelectionCriteriaPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateMatchSelectionCriteriaManyArgs = {
  updates: Array<MatchSelectionCriteriaUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateMessagesArgs = {
  _set?: InputMaybe<MessagesSetInput>;
  where: MessagesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateMessagesByPkArgs = {
  _set?: InputMaybe<MessagesSetInput>;
  pkColumns: MessagesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateMessagesManyArgs = {
  updates: Array<MessagesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateNeighborhoodsArgs = {
  _inc?: InputMaybe<NeighborhoodsIncInput>;
  _set?: InputMaybe<NeighborhoodsSetInput>;
  where: NeighborhoodsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateNeighborhoodsByPkArgs = {
  _inc?: InputMaybe<NeighborhoodsIncInput>;
  _set?: InputMaybe<NeighborhoodsSetInput>;
  pkColumns: NeighborhoodsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateNeighborhoodsManyArgs = {
  updates: Array<NeighborhoodsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateNotificationActionTypesArgs = {
  _set?: InputMaybe<NotificationActionTypesSetInput>;
  where: NotificationActionTypesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateNotificationActionTypesByPkArgs = {
  _set?: InputMaybe<NotificationActionTypesSetInput>;
  pkColumns: NotificationActionTypesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateNotificationActionTypesManyArgs = {
  updates: Array<NotificationActionTypesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateNotificationStatusesArgs = {
  _set?: InputMaybe<NotificationStatusesSetInput>;
  where: NotificationStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateNotificationStatusesByPkArgs = {
  _set?: InputMaybe<NotificationStatusesSetInput>;
  pkColumns: NotificationStatusesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateNotificationStatusesManyArgs = {
  updates: Array<NotificationStatusesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateOrderStatusesArgs = {
  _set?: InputMaybe<OrderStatusesSetInput>;
  where: OrderStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateOrderStatusesByPkArgs = {
  _set?: InputMaybe<OrderStatusesSetInput>;
  pkColumns: OrderStatusesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateOrderStatusesManyArgs = {
  updates: Array<OrderStatusesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdatePadelRatingScalesArgs = {
  _inc?: InputMaybe<PadelRatingScalesIncInput>;
  _set?: InputMaybe<PadelRatingScalesSetInput>;
  where: PadelRatingScalesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdatePadelRatingScalesByPkArgs = {
  _inc?: InputMaybe<PadelRatingScalesIncInput>;
  _set?: InputMaybe<PadelRatingScalesSetInput>;
  pkColumns: PadelRatingScalesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdatePadelRatingScalesManyArgs = {
  updates: Array<PadelRatingScalesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateParticipantRolesArgs = {
  _set?: InputMaybe<ParticipantRolesSetInput>;
  where: ParticipantRolesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateParticipantRolesByPkArgs = {
  _set?: InputMaybe<ParticipantRolesSetInput>;
  pkColumns: ParticipantRolesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateParticipantRolesManyArgs = {
  updates: Array<ParticipantRolesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdatePartnerBookingAttemptEventsArgs = {
  _append?: InputMaybe<PartnerBookingAttemptEventsAppendInput>;
  _deleteAtPath?: InputMaybe<PartnerBookingAttemptEventsDeleteAtPathInput>;
  _deleteElem?: InputMaybe<PartnerBookingAttemptEventsDeleteElemInput>;
  _deleteKey?: InputMaybe<PartnerBookingAttemptEventsDeleteKeyInput>;
  _prepend?: InputMaybe<PartnerBookingAttemptEventsPrependInput>;
  _set?: InputMaybe<PartnerBookingAttemptEventsSetInput>;
  where: PartnerBookingAttemptEventsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdatePartnerBookingAttemptEventsByPkArgs = {
  _append?: InputMaybe<PartnerBookingAttemptEventsAppendInput>;
  _deleteAtPath?: InputMaybe<PartnerBookingAttemptEventsDeleteAtPathInput>;
  _deleteElem?: InputMaybe<PartnerBookingAttemptEventsDeleteElemInput>;
  _deleteKey?: InputMaybe<PartnerBookingAttemptEventsDeleteKeyInput>;
  _prepend?: InputMaybe<PartnerBookingAttemptEventsPrependInput>;
  _set?: InputMaybe<PartnerBookingAttemptEventsSetInput>;
  pkColumns: PartnerBookingAttemptEventsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdatePartnerBookingAttemptEventsManyArgs = {
  updates: Array<PartnerBookingAttemptEventsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdatePartnerBookingAttemptStatusesArgs = {
  _set?: InputMaybe<PartnerBookingAttemptStatusesSetInput>;
  where: PartnerBookingAttemptStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdatePartnerBookingAttemptStatusesByPkArgs = {
  _set?: InputMaybe<PartnerBookingAttemptStatusesSetInput>;
  pkColumns: PartnerBookingAttemptStatusesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdatePartnerBookingAttemptStatusesManyArgs = {
  updates: Array<PartnerBookingAttemptStatusesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdatePartnerBookingAttemptsArgs = {
  _append?: InputMaybe<PartnerBookingAttemptsAppendInput>;
  _deleteAtPath?: InputMaybe<PartnerBookingAttemptsDeleteAtPathInput>;
  _deleteElem?: InputMaybe<PartnerBookingAttemptsDeleteElemInput>;
  _deleteKey?: InputMaybe<PartnerBookingAttemptsDeleteKeyInput>;
  _prepend?: InputMaybe<PartnerBookingAttemptsPrependInput>;
  _set?: InputMaybe<PartnerBookingAttemptsSetInput>;
  where: PartnerBookingAttemptsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdatePartnerBookingAttemptsByPkArgs = {
  _append?: InputMaybe<PartnerBookingAttemptsAppendInput>;
  _deleteAtPath?: InputMaybe<PartnerBookingAttemptsDeleteAtPathInput>;
  _deleteElem?: InputMaybe<PartnerBookingAttemptsDeleteElemInput>;
  _deleteKey?: InputMaybe<PartnerBookingAttemptsDeleteKeyInput>;
  _prepend?: InputMaybe<PartnerBookingAttemptsPrependInput>;
  _set?: InputMaybe<PartnerBookingAttemptsSetInput>;
  pkColumns: PartnerBookingAttemptsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdatePartnerBookingAttemptsManyArgs = {
  updates: Array<PartnerBookingAttemptsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdatePartnerBookingEnginesArgs = {
  _set?: InputMaybe<PartnerBookingEnginesSetInput>;
  where: PartnerBookingEnginesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdatePartnerBookingEnginesByPkArgs = {
  _set?: InputMaybe<PartnerBookingEnginesSetInput>;
  pkColumns: PartnerBookingEnginesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdatePartnerBookingEnginesManyArgs = {
  updates: Array<PartnerBookingEnginesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdatePartnerBookingEventSourcesArgs = {
  _set?: InputMaybe<PartnerBookingEventSourcesSetInput>;
  where: PartnerBookingEventSourcesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdatePartnerBookingEventSourcesByPkArgs = {
  _set?: InputMaybe<PartnerBookingEventSourcesSetInput>;
  pkColumns: PartnerBookingEventSourcesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdatePartnerBookingEventSourcesManyArgs = {
  updates: Array<PartnerBookingEventSourcesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdatePartnerBookingHoldsArgs = {
  _inc?: InputMaybe<PartnerBookingHoldsIncInput>;
  _set?: InputMaybe<PartnerBookingHoldsSetInput>;
  where: PartnerBookingHoldsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdatePartnerBookingHoldsByPkArgs = {
  _inc?: InputMaybe<PartnerBookingHoldsIncInput>;
  _set?: InputMaybe<PartnerBookingHoldsSetInput>;
  pkColumns: PartnerBookingHoldsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdatePartnerBookingHoldsManyArgs = {
  updates: Array<PartnerBookingHoldsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdatePartnerBookingOrderStatusesArgs = {
  _set?: InputMaybe<PartnerBookingOrderStatusesSetInput>;
  where: PartnerBookingOrderStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdatePartnerBookingOrderStatusesByPkArgs = {
  _set?: InputMaybe<PartnerBookingOrderStatusesSetInput>;
  pkColumns: PartnerBookingOrderStatusesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdatePartnerBookingOrderStatusesManyArgs = {
  updates: Array<PartnerBookingOrderStatusesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdatePartnerBookingOrdersArgs = {
  _inc?: InputMaybe<PartnerBookingOrdersIncInput>;
  _set?: InputMaybe<PartnerBookingOrdersSetInput>;
  where: PartnerBookingOrdersBoolExp;
};


/** mutation root */
export type Mutation_RootUpdatePartnerBookingOrdersByPkArgs = {
  _inc?: InputMaybe<PartnerBookingOrdersIncInput>;
  _set?: InputMaybe<PartnerBookingOrdersSetInput>;
  pkColumns: PartnerBookingOrdersPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdatePartnerBookingOrdersManyArgs = {
  updates: Array<PartnerBookingOrdersUpdates>;
};


/** mutation root */
export type Mutation_RootUpdatePartnerBookingVerificationMethodsArgs = {
  _set?: InputMaybe<PartnerBookingVerificationMethodsSetInput>;
  where: PartnerBookingVerificationMethodsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdatePartnerBookingVerificationMethodsByPkArgs = {
  _set?: InputMaybe<PartnerBookingVerificationMethodsSetInput>;
  pkColumns: PartnerBookingVerificationMethodsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdatePartnerBookingVerificationMethodsManyArgs = {
  updates: Array<PartnerBookingVerificationMethodsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdatePaymentFulfillmentChannelsArgs = {
  _set?: InputMaybe<PaymentFulfillmentChannelsSetInput>;
  where: PaymentFulfillmentChannelsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdatePaymentFulfillmentChannelsByPkArgs = {
  _set?: InputMaybe<PaymentFulfillmentChannelsSetInput>;
  pkColumns: PaymentFulfillmentChannelsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdatePaymentFulfillmentChannelsManyArgs = {
  updates: Array<PaymentFulfillmentChannelsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdatePaymentProcessorsArgs = {
  _set?: InputMaybe<PaymentProcessorsSetInput>;
  where: PaymentProcessorsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdatePaymentProcessorsByPkArgs = {
  _set?: InputMaybe<PaymentProcessorsSetInput>;
  pkColumns: PaymentProcessorsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdatePaymentProcessorsManyArgs = {
  updates: Array<PaymentProcessorsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdatePaymentStatusesArgs = {
  _set?: InputMaybe<PaymentStatusesSetInput>;
  where: PaymentStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdatePaymentStatusesByPkArgs = {
  _set?: InputMaybe<PaymentStatusesSetInput>;
  pkColumns: PaymentStatusesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdatePaymentStatusesManyArgs = {
  updates: Array<PaymentStatusesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdatePickleballRatingScalesArgs = {
  _inc?: InputMaybe<PickleballRatingScalesIncInput>;
  _set?: InputMaybe<PickleballRatingScalesSetInput>;
  where: PickleballRatingScalesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdatePickleballRatingScalesByPkArgs = {
  _inc?: InputMaybe<PickleballRatingScalesIncInput>;
  _set?: InputMaybe<PickleballRatingScalesSetInput>;
  pkColumns: PickleballRatingScalesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdatePickleballRatingScalesManyArgs = {
  updates: Array<PickleballRatingScalesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdatePlatformSubscriptionIntervalsArgs = {
  _set?: InputMaybe<PlatformSubscriptionIntervalsSetInput>;
  where: PlatformSubscriptionIntervalsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdatePlatformSubscriptionIntervalsByPkArgs = {
  _set?: InputMaybe<PlatformSubscriptionIntervalsSetInput>;
  pkColumns: PlatformSubscriptionIntervalsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdatePlatformSubscriptionIntervalsManyArgs = {
  updates: Array<PlatformSubscriptionIntervalsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdatePlatformSubscriptionPersonasArgs = {
  _set?: InputMaybe<PlatformSubscriptionPersonasSetInput>;
  where: PlatformSubscriptionPersonasBoolExp;
};


/** mutation root */
export type Mutation_RootUpdatePlatformSubscriptionPersonasByPkArgs = {
  _set?: InputMaybe<PlatformSubscriptionPersonasSetInput>;
  pkColumns: PlatformSubscriptionPersonasPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdatePlatformSubscriptionPersonasManyArgs = {
  updates: Array<PlatformSubscriptionPersonasUpdates>;
};


/** mutation root */
export type Mutation_RootUpdatePlatformSubscriptionPlanPricesArgs = {
  _inc?: InputMaybe<PlatformSubscriptionPlanPricesIncInput>;
  _set?: InputMaybe<PlatformSubscriptionPlanPricesSetInput>;
  where: PlatformSubscriptionPlanPricesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdatePlatformSubscriptionPlanPricesByPkArgs = {
  _inc?: InputMaybe<PlatformSubscriptionPlanPricesIncInput>;
  _set?: InputMaybe<PlatformSubscriptionPlanPricesSetInput>;
  pkColumns: PlatformSubscriptionPlanPricesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdatePlatformSubscriptionPlanPricesManyArgs = {
  updates: Array<PlatformSubscriptionPlanPricesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdatePlatformSubscriptionPlansArgs = {
  _set?: InputMaybe<PlatformSubscriptionPlansSetInput>;
  where: PlatformSubscriptionPlansBoolExp;
};


/** mutation root */
export type Mutation_RootUpdatePlatformSubscriptionPlansByPkArgs = {
  _set?: InputMaybe<PlatformSubscriptionPlansSetInput>;
  pkColumns: PlatformSubscriptionPlansPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdatePlatformSubscriptionPlansManyArgs = {
  updates: Array<PlatformSubscriptionPlansUpdates>;
};


/** mutation root */
export type Mutation_RootUpdatePlatformSubscriptionsArgs = {
  _set?: InputMaybe<PlatformSubscriptionsSetInput>;
  where: PlatformSubscriptionsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdatePlatformSubscriptionsByPkArgs = {
  _set?: InputMaybe<PlatformSubscriptionsSetInput>;
  pkColumns: PlatformSubscriptionsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdatePlatformSubscriptionsManyArgs = {
  updates: Array<PlatformSubscriptionsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdatePlayRequestNeighborhoodsArgs = {
  _set?: InputMaybe<PlayRequestNeighborhoodsSetInput>;
  where: PlayRequestNeighborhoodsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdatePlayRequestNeighborhoodsByPkArgs = {
  _set?: InputMaybe<PlayRequestNeighborhoodsSetInput>;
  pkColumns: PlayRequestNeighborhoodsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdatePlayRequestNeighborhoodsManyArgs = {
  updates: Array<PlayRequestNeighborhoodsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdatePlayRequestSlotsArgs = {
  _set?: InputMaybe<PlayRequestSlotsSetInput>;
  where: PlayRequestSlotsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdatePlayRequestSlotsByPkArgs = {
  _set?: InputMaybe<PlayRequestSlotsSetInput>;
  pkColumns: PlayRequestSlotsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdatePlayRequestSlotsManyArgs = {
  updates: Array<PlayRequestSlotsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdatePlayRequestStatusesArgs = {
  _set?: InputMaybe<PlayRequestStatusesSetInput>;
  where: PlayRequestStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdatePlayRequestStatusesByPkArgs = {
  _set?: InputMaybe<PlayRequestStatusesSetInput>;
  pkColumns: PlayRequestStatusesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdatePlayRequestStatusesManyArgs = {
  updates: Array<PlayRequestStatusesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdatePlayRequestVenuesArgs = {
  _set?: InputMaybe<PlayRequestVenuesSetInput>;
  where: PlayRequestVenuesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdatePlayRequestVenuesByPkArgs = {
  _set?: InputMaybe<PlayRequestVenuesSetInput>;
  pkColumns: PlayRequestVenuesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdatePlayRequestVenuesManyArgs = {
  updates: Array<PlayRequestVenuesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdatePlayRequestsArgs = {
  _set?: InputMaybe<PlayRequestsSetInput>;
  where: PlayRequestsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdatePlayRequestsByPkArgs = {
  _set?: InputMaybe<PlayRequestsSetInput>;
  pkColumns: PlayRequestsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdatePlayRequestsManyArgs = {
  updates: Array<PlayRequestsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdatePlaySessionCommentsArgs = {
  _set?: InputMaybe<PlaySessionCommentsSetInput>;
  where: PlaySessionCommentsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdatePlaySessionCommentsByPkArgs = {
  _set?: InputMaybe<PlaySessionCommentsSetInput>;
  pkColumns: PlaySessionCommentsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdatePlaySessionCommentsManyArgs = {
  updates: Array<PlaySessionCommentsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdatePlaySessionCourtBookingStatusesArgs = {
  _set?: InputMaybe<PlaySessionCourtBookingStatusesSetInput>;
  where: PlaySessionCourtBookingStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdatePlaySessionCourtBookingStatusesByPkArgs = {
  _set?: InputMaybe<PlaySessionCourtBookingStatusesSetInput>;
  pkColumns: PlaySessionCourtBookingStatusesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdatePlaySessionCourtBookingStatusesManyArgs = {
  updates: Array<PlaySessionCourtBookingStatusesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdatePlaySessionFormatsArgs = {
  _set?: InputMaybe<PlaySessionFormatsSetInput>;
  where: PlaySessionFormatsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdatePlaySessionFormatsByPkArgs = {
  _set?: InputMaybe<PlaySessionFormatsSetInput>;
  pkColumns: PlaySessionFormatsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdatePlaySessionFormatsManyArgs = {
  updates: Array<PlaySessionFormatsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdatePlaySessionMatchCompetitivenessArgs = {
  _set?: InputMaybe<PlaySessionMatchCompetitivenessSetInput>;
  where: PlaySessionMatchCompetitivenessBoolExp;
};


/** mutation root */
export type Mutation_RootUpdatePlaySessionMatchCompetitivenessByPkArgs = {
  _set?: InputMaybe<PlaySessionMatchCompetitivenessSetInput>;
  pkColumns: PlaySessionMatchCompetitivenessPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdatePlaySessionMatchCompetitivenessManyArgs = {
  updates: Array<PlaySessionMatchCompetitivenessUpdates>;
};


/** mutation root */
export type Mutation_RootUpdatePlaySessionParticipantStatusesArgs = {
  _set?: InputMaybe<PlaySessionParticipantStatusesSetInput>;
  where: PlaySessionParticipantStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdatePlaySessionParticipantStatusesByPkArgs = {
  _set?: InputMaybe<PlaySessionParticipantStatusesSetInput>;
  pkColumns: PlaySessionParticipantStatusesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdatePlaySessionParticipantStatusesManyArgs = {
  updates: Array<PlaySessionParticipantStatusesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdatePlaySessionParticipantsArgs = {
  _set?: InputMaybe<PlaySessionParticipantsSetInput>;
  where: PlaySessionParticipantsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdatePlaySessionParticipantsByPkArgs = {
  _set?: InputMaybe<PlaySessionParticipantsSetInput>;
  pkColumns: PlaySessionParticipantsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdatePlaySessionParticipantsManyArgs = {
  updates: Array<PlaySessionParticipantsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdatePlaySessionPrivacyArgs = {
  _set?: InputMaybe<PlaySessionPrivacySetInput>;
  where: PlaySessionPrivacyBoolExp;
};


/** mutation root */
export type Mutation_RootUpdatePlaySessionPrivacyByPkArgs = {
  _set?: InputMaybe<PlaySessionPrivacySetInput>;
  pkColumns: PlaySessionPrivacyPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdatePlaySessionPrivacyManyArgs = {
  updates: Array<PlaySessionPrivacyUpdates>;
};


/** mutation root */
export type Mutation_RootUpdatePlaySessionStatusesArgs = {
  _set?: InputMaybe<PlaySessionStatusesSetInput>;
  where: PlaySessionStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdatePlaySessionStatusesByPkArgs = {
  _set?: InputMaybe<PlaySessionStatusesSetInput>;
  pkColumns: PlaySessionStatusesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdatePlaySessionStatusesManyArgs = {
  updates: Array<PlaySessionStatusesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdatePlaySessionsArgs = {
  _inc?: InputMaybe<PlaySessionsIncInput>;
  _set?: InputMaybe<PlaySessionsSetInput>;
  where: PlaySessionsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdatePlaySessionsByPkArgs = {
  _inc?: InputMaybe<PlaySessionsIncInput>;
  _set?: InputMaybe<PlaySessionsSetInput>;
  pkColumns: PlaySessionsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdatePlaySessionsManyArgs = {
  updates: Array<PlaySessionsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdatePlayerAvailabilitiesArgs = {
  _inc?: InputMaybe<PlayerAvailabilitiesIncInput>;
  _set?: InputMaybe<PlayerAvailabilitiesSetInput>;
  where: PlayerAvailabilitiesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdatePlayerAvailabilitiesByPkArgs = {
  _inc?: InputMaybe<PlayerAvailabilitiesIncInput>;
  _set?: InputMaybe<PlayerAvailabilitiesSetInput>;
  pkColumns: PlayerAvailabilitiesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdatePlayerAvailabilitiesManyArgs = {
  updates: Array<PlayerAvailabilitiesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdatePlayerAvailabilityNeighborhoodsArgs = {
  _set?: InputMaybe<PlayerAvailabilityNeighborhoodsSetInput>;
  where: PlayerAvailabilityNeighborhoodsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdatePlayerAvailabilityNeighborhoodsByPkArgs = {
  _set?: InputMaybe<PlayerAvailabilityNeighborhoodsSetInput>;
  pkColumns: PlayerAvailabilityNeighborhoodsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdatePlayerAvailabilityNeighborhoodsManyArgs = {
  updates: Array<PlayerAvailabilityNeighborhoodsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdatePlayerAvailabilityRatingScalesArgs = {
  _inc?: InputMaybe<PlayerAvailabilityRatingScalesIncInput>;
  _set?: InputMaybe<PlayerAvailabilityRatingScalesSetInput>;
  where: PlayerAvailabilityRatingScalesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdatePlayerAvailabilityRatingScalesByPkArgs = {
  _inc?: InputMaybe<PlayerAvailabilityRatingScalesIncInput>;
  _set?: InputMaybe<PlayerAvailabilityRatingScalesSetInput>;
  pkColumns: PlayerAvailabilityRatingScalesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdatePlayerAvailabilityRatingScalesManyArgs = {
  updates: Array<PlayerAvailabilityRatingScalesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdatePlayerAvailabilitySlotsArgs = {
  _set?: InputMaybe<PlayerAvailabilitySlotsSetInput>;
  where: PlayerAvailabilitySlotsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdatePlayerAvailabilitySlotsByPkArgs = {
  _set?: InputMaybe<PlayerAvailabilitySlotsSetInput>;
  pkColumns: PlayerAvailabilitySlotsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdatePlayerAvailabilitySlotsManyArgs = {
  updates: Array<PlayerAvailabilitySlotsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdatePlayerAvailabilityVenuesArgs = {
  _set?: InputMaybe<PlayerAvailabilityVenuesSetInput>;
  where: PlayerAvailabilityVenuesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdatePlayerAvailabilityVenuesByPkArgs = {
  _set?: InputMaybe<PlayerAvailabilityVenuesSetInput>;
  pkColumns: PlayerAvailabilityVenuesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdatePlayerAvailabilityVenuesManyArgs = {
  updates: Array<PlayerAvailabilityVenuesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdatePlayerFinderGoalsArgs = {
  _set?: InputMaybe<PlayerFinderGoalsSetInput>;
  where: PlayerFinderGoalsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdatePlayerFinderGoalsByPkArgs = {
  _set?: InputMaybe<PlayerFinderGoalsSetInput>;
  pkColumns: PlayerFinderGoalsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdatePlayerFinderGoalsManyArgs = {
  updates: Array<PlayerFinderGoalsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdatePlayerFinderTimeOfDayArgs = {
  _set?: InputMaybe<PlayerFinderTimeOfDaySetInput>;
  where: PlayerFinderTimeOfDayBoolExp;
};


/** mutation root */
export type Mutation_RootUpdatePlayerFinderTimeOfDayByPkArgs = {
  _set?: InputMaybe<PlayerFinderTimeOfDaySetInput>;
  pkColumns: PlayerFinderTimeOfDayPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdatePlayerFinderTimeOfDayManyArgs = {
  updates: Array<PlayerFinderTimeOfDayUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateRecurrenceKindsArgs = {
  _set?: InputMaybe<RecurrenceKindsSetInput>;
  where: RecurrenceKindsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateRecurrenceKindsByPkArgs = {
  _set?: InputMaybe<RecurrenceKindsSetInput>;
  pkColumns: RecurrenceKindsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateRecurrenceKindsManyArgs = {
  updates: Array<RecurrenceKindsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateReportReasonsArgs = {
  _set?: InputMaybe<ReportReasonsSetInput>;
  where: ReportReasonsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateReportReasonsByPkArgs = {
  _set?: InputMaybe<ReportReasonsSetInput>;
  pkColumns: ReportReasonsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateReportReasonsManyArgs = {
  updates: Array<ReportReasonsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateReportStatusesArgs = {
  _set?: InputMaybe<ReportStatusesSetInput>;
  where: ReportStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateReportStatusesByPkArgs = {
  _set?: InputMaybe<ReportStatusesSetInput>;
  pkColumns: ReportStatusesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateReportStatusesManyArgs = {
  updates: Array<ReportStatusesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateReviewsArgs = {
  _inc?: InputMaybe<ReviewsIncInput>;
  _set?: InputMaybe<ReviewsSetInput>;
  where: ReviewsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateReviewsByPkArgs = {
  _inc?: InputMaybe<ReviewsIncInput>;
  _set?: InputMaybe<ReviewsSetInput>;
  pkColumns: ReviewsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateReviewsManyArgs = {
  updates: Array<ReviewsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateSalesArgs = {
  _inc?: InputMaybe<SalesIncInput>;
  _set?: InputMaybe<SalesSetInput>;
  where: SalesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateSalesByPkArgs = {
  _inc?: InputMaybe<SalesIncInput>;
  _set?: InputMaybe<SalesSetInput>;
  pkColumns: SalesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateSalesManyArgs = {
  updates: Array<SalesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateScoringFormatArgs = {
  _set?: InputMaybe<ScoringFormatSetInput>;
  where: ScoringFormatBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateScoringFormatByPkArgs = {
  _set?: InputMaybe<ScoringFormatSetInput>;
  pkColumns: ScoringFormatPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateScoringFormatManyArgs = {
  updates: Array<ScoringFormatUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateSignupRequestsArgs = {
  _append?: InputMaybe<SignupRequestsAppendInput>;
  _deleteAtPath?: InputMaybe<SignupRequestsDeleteAtPathInput>;
  _deleteElem?: InputMaybe<SignupRequestsDeleteElemInput>;
  _deleteKey?: InputMaybe<SignupRequestsDeleteKeyInput>;
  _inc?: InputMaybe<SignupRequestsIncInput>;
  _prepend?: InputMaybe<SignupRequestsPrependInput>;
  _set?: InputMaybe<SignupRequestsSetInput>;
  where: SignupRequestsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateSignupRequestsByPkArgs = {
  _append?: InputMaybe<SignupRequestsAppendInput>;
  _deleteAtPath?: InputMaybe<SignupRequestsDeleteAtPathInput>;
  _deleteElem?: InputMaybe<SignupRequestsDeleteElemInput>;
  _deleteKey?: InputMaybe<SignupRequestsDeleteKeyInput>;
  _inc?: InputMaybe<SignupRequestsIncInput>;
  _prepend?: InputMaybe<SignupRequestsPrependInput>;
  _set?: InputMaybe<SignupRequestsSetInput>;
  pkColumns: SignupRequestsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateSignupRequestsManyArgs = {
  updates: Array<SignupRequestsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateSkillLevelValuesArgs = {
  _set?: InputMaybe<SkillLevelValuesSetInput>;
  where: SkillLevelValuesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateSkillLevelValuesByPkArgs = {
  _set?: InputMaybe<SkillLevelValuesSetInput>;
  pkColumns: SkillLevelValuesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateSkillLevelValuesManyArgs = {
  updates: Array<SkillLevelValuesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateSkillLevelsArgs = {
  _inc?: InputMaybe<SkillLevelsIncInput>;
  _set?: InputMaybe<SkillLevelsSetInput>;
  where: SkillLevelsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateSkillLevelsByPkArgs = {
  _inc?: InputMaybe<SkillLevelsIncInput>;
  _set?: InputMaybe<SkillLevelsSetInput>;
  pkColumns: SkillLevelsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateSkillLevelsManyArgs = {
  updates: Array<SkillLevelsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateSportsArgs = {
  _set?: InputMaybe<SportsSetInput>;
  where: SportsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateSportsByPkArgs = {
  _set?: InputMaybe<SportsSetInput>;
  pkColumns: SportsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateSportsManyArgs = {
  updates: Array<SportsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateStripeChargesArgs = {
  _inc?: InputMaybe<StripeChargesIncInput>;
  _set?: InputMaybe<StripeChargesSetInput>;
  where: StripeChargesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateStripeChargesByPkArgs = {
  _inc?: InputMaybe<StripeChargesIncInput>;
  _set?: InputMaybe<StripeChargesSetInput>;
  pkColumns: StripeChargesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateStripeChargesManyArgs = {
  updates: Array<StripeChargesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateStripePaymentIntentsArgs = {
  _inc?: InputMaybe<StripePaymentIntentsIncInput>;
  _set?: InputMaybe<StripePaymentIntentsSetInput>;
  where: StripePaymentIntentsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateStripePaymentIntentsByPkArgs = {
  _inc?: InputMaybe<StripePaymentIntentsIncInput>;
  _set?: InputMaybe<StripePaymentIntentsSetInput>;
  pkColumns: StripePaymentIntentsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateStripePaymentIntentsManyArgs = {
  updates: Array<StripePaymentIntentsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateSubscriptionStatusesArgs = {
  _set?: InputMaybe<SubscriptionStatusesSetInput>;
  where: SubscriptionStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateSubscriptionStatusesByPkArgs = {
  _set?: InputMaybe<SubscriptionStatusesSetInput>;
  pkColumns: SubscriptionStatusesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateSubscriptionStatusesManyArgs = {
  updates: Array<SubscriptionStatusesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateTeamTypesArgs = {
  _set?: InputMaybe<TeamTypesSetInput>;
  where: TeamTypesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateTeamTypesByPkArgs = {
  _set?: InputMaybe<TeamTypesSetInput>;
  pkColumns: TeamTypesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateTeamTypesManyArgs = {
  updates: Array<TeamTypesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateTennisRatingScalesArgs = {
  _inc?: InputMaybe<TennisRatingScalesIncInput>;
  _set?: InputMaybe<TennisRatingScalesSetInput>;
  where: TennisRatingScalesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateTennisRatingScalesByPkArgs = {
  _inc?: InputMaybe<TennisRatingScalesIncInput>;
  _set?: InputMaybe<TennisRatingScalesSetInput>;
  pkColumns: TennisRatingScalesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateTennisRatingScalesManyArgs = {
  updates: Array<TennisRatingScalesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateTwilioGroupTextsArgs = {
  _set?: InputMaybe<TwilioGroupTextsSetInput>;
  where: TwilioGroupTextsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateTwilioGroupTextsByPkArgs = {
  _set?: InputMaybe<TwilioGroupTextsSetInput>;
  pkColumns: TwilioGroupTextsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateTwilioGroupTextsManyArgs = {
  updates: Array<TwilioGroupTextsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateUploadReviewRequestsArgs = {
  _set?: InputMaybe<UploadReviewRequestsSetInput>;
  where: UploadReviewRequestsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateUploadReviewRequestsByPkArgs = {
  _set?: InputMaybe<UploadReviewRequestsSetInput>;
  pkColumns: UploadReviewRequestsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateUploadReviewRequestsManyArgs = {
  updates: Array<UploadReviewRequestsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateUserAuthIdentitiesArgs = {
  _set?: InputMaybe<UserAuthIdentitiesSetInput>;
  where: UserAuthIdentitiesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateUserAuthIdentitiesByPkArgs = {
  _set?: InputMaybe<UserAuthIdentitiesSetInput>;
  pkColumns: UserAuthIdentitiesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateUserAuthIdentitiesManyArgs = {
  updates: Array<UserAuthIdentitiesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateUserBlocksArgs = {
  _set?: InputMaybe<UserBlocksSetInput>;
  where: UserBlocksBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateUserBlocksByPkArgs = {
  _set?: InputMaybe<UserBlocksSetInput>;
  pkColumns: UserBlocksPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateUserBlocksManyArgs = {
  updates: Array<UserBlocksUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateUserCoachServicesArgs = {
  _inc?: InputMaybe<UserCoachServicesIncInput>;
  _set?: InputMaybe<UserCoachServicesSetInput>;
  where: UserCoachServicesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateUserCoachServicesByPkArgs = {
  _inc?: InputMaybe<UserCoachServicesIncInput>;
  _set?: InputMaybe<UserCoachServicesSetInput>;
  pkColumns: UserCoachServicesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateUserCoachServicesManyArgs = {
  updates: Array<UserCoachServicesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateUserCommunicationPreferencesArgs = {
  _set?: InputMaybe<UserCommunicationPreferencesSetInput>;
  where: UserCommunicationPreferencesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateUserCommunicationPreferencesByPkArgs = {
  _set?: InputMaybe<UserCommunicationPreferencesSetInput>;
  pkColumns: UserCommunicationPreferencesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateUserCommunicationPreferencesManyArgs = {
  updates: Array<UserCommunicationPreferencesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateUserConnectionRequestStatusesArgs = {
  _set?: InputMaybe<UserConnectionRequestStatusesSetInput>;
  where: UserConnectionRequestStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateUserConnectionRequestStatusesByPkArgs = {
  _set?: InputMaybe<UserConnectionRequestStatusesSetInput>;
  pkColumns: UserConnectionRequestStatusesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateUserConnectionRequestStatusesManyArgs = {
  updates: Array<UserConnectionRequestStatusesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateUserConnectionRequestsArgs = {
  _inc?: InputMaybe<UserConnectionRequestsIncInput>;
  _set?: InputMaybe<UserConnectionRequestsSetInput>;
  where: UserConnectionRequestsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateUserConnectionRequestsByPkArgs = {
  _inc?: InputMaybe<UserConnectionRequestsIncInput>;
  _set?: InputMaybe<UserConnectionRequestsSetInput>;
  pkColumns: UserConnectionRequestsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateUserConnectionRequestsManyArgs = {
  updates: Array<UserConnectionRequestsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateUserConnectionsArgs = {
  _set?: InputMaybe<UserConnectionsSetInput>;
  where: UserConnectionsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateUserConnectionsByPkArgs = {
  _set?: InputMaybe<UserConnectionsSetInput>;
  pkColumns: UserConnectionsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateUserConnectionsManyArgs = {
  updates: Array<UserConnectionsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateUserContentBetaSubscriptionsArgs = {
  _inc?: InputMaybe<UserContentBetaSubscriptionsIncInput>;
  _set?: InputMaybe<UserContentBetaSubscriptionsSetInput>;
  where: UserContentBetaSubscriptionsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateUserContentBetaSubscriptionsByPkArgs = {
  _inc?: InputMaybe<UserContentBetaSubscriptionsIncInput>;
  _set?: InputMaybe<UserContentBetaSubscriptionsSetInput>;
  pkColumns: UserContentBetaSubscriptionsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateUserContentBetaSubscriptionsManyArgs = {
  updates: Array<UserContentBetaSubscriptionsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateUserContentFilesArgs = {
  _set?: InputMaybe<UserContentFilesSetInput>;
  where: UserContentFilesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateUserContentFilesByPkArgs = {
  _set?: InputMaybe<UserContentFilesSetInput>;
  pkColumns: UserContentFilesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateUserContentFilesManyArgs = {
  updates: Array<UserContentFilesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateUserContentFilesSkillsArgs = {
  _set?: InputMaybe<UserContentFilesSkillsSetInput>;
  where: UserContentFilesSkillsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateUserContentFilesSkillsByPkArgs = {
  _set?: InputMaybe<UserContentFilesSkillsSetInput>;
  pkColumns: UserContentFilesSkillsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateUserContentFilesSkillsManyArgs = {
  updates: Array<UserContentFilesSkillsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateUserContentSkillsArgs = {
  _set?: InputMaybe<UserContentSkillsSetInput>;
  where: UserContentSkillsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateUserContentSkillsByPkArgs = {
  _set?: InputMaybe<UserContentSkillsSetInput>;
  pkColumns: UserContentSkillsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateUserContentSkillsManyArgs = {
  updates: Array<UserContentSkillsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateUserContentTiersArgs = {
  _set?: InputMaybe<UserContentTiersSetInput>;
  where: UserContentTiersBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateUserContentTiersByPkArgs = {
  _set?: InputMaybe<UserContentTiersSetInput>;
  pkColumns: UserContentTiersPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateUserContentTiersManyArgs = {
  updates: Array<UserContentTiersUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateUserCreditCardsArgs = {
  _inc?: InputMaybe<UserCreditCardsIncInput>;
  _set?: InputMaybe<UserCreditCardsSetInput>;
  where: UserCreditCardsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateUserCreditCardsByPkArgs = {
  _inc?: InputMaybe<UserCreditCardsIncInput>;
  _set?: InputMaybe<UserCreditCardsSetInput>;
  pkColumns: UserCreditCardsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateUserCreditCardsManyArgs = {
  updates: Array<UserCreditCardsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateUserCustomCourtsArgs = {
  _inc?: InputMaybe<UserCustomCourtsIncInput>;
  _set?: InputMaybe<UserCustomCourtsSetInput>;
  where: UserCustomCourtsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateUserCustomCourtsByPkArgs = {
  _inc?: InputMaybe<UserCustomCourtsIncInput>;
  _set?: InputMaybe<UserCustomCourtsSetInput>;
  pkColumns: UserCustomCourtsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateUserCustomCourtsManyArgs = {
  updates: Array<UserCustomCourtsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateUserFilesArgs = {
  _set?: InputMaybe<UserFilesSetInput>;
  where: UserFilesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateUserFilesByPkArgs = {
  _set?: InputMaybe<UserFilesSetInput>;
  pkColumns: UserFilesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateUserFilesManyArgs = {
  updates: Array<UserFilesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateUserFollowsArgs = {
  _set?: InputMaybe<UserFollowsSetInput>;
  where: UserFollowsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateUserFollowsByPkArgs = {
  _set?: InputMaybe<UserFollowsSetInput>;
  pkColumns: UserFollowsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateUserFollowsManyArgs = {
  updates: Array<UserFollowsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateUserIdentityVerificationsArgs = {
  _set?: InputMaybe<UserIdentityVerificationsSetInput>;
  where: UserIdentityVerificationsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateUserIdentityVerificationsByPkArgs = {
  _set?: InputMaybe<UserIdentityVerificationsSetInput>;
  pkColumns: UserIdentityVerificationsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateUserIdentityVerificationsManyArgs = {
  updates: Array<UserIdentityVerificationsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateUserImageLogArgs = {
  _set?: InputMaybe<UserImageLogSetInput>;
  where: UserImageLogBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateUserImageLogByPkArgs = {
  _set?: InputMaybe<UserImageLogSetInput>;
  pkColumns: UserImageLogPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateUserImageLogManyArgs = {
  updates: Array<UserImageLogUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateUserNotificationDetailsArgs = {
  _set?: InputMaybe<UserNotificationDetailsSetInput>;
  where: UserNotificationDetailsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateUserNotificationDetailsByPkArgs = {
  _set?: InputMaybe<UserNotificationDetailsSetInput>;
  pkColumns: UserNotificationDetailsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateUserNotificationDetailsManyArgs = {
  updates: Array<UserNotificationDetailsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateUserNotificationEntitiesArgs = {
  _set?: InputMaybe<UserNotificationEntitiesSetInput>;
  where: UserNotificationEntitiesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateUserNotificationEntitiesByPkArgs = {
  _set?: InputMaybe<UserNotificationEntitiesSetInput>;
  pkColumns: UserNotificationEntitiesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateUserNotificationEntitiesManyArgs = {
  updates: Array<UserNotificationEntitiesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateUserNotificationsArgs = {
  _set?: InputMaybe<UserNotificationsSetInput>;
  where: UserNotificationsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateUserNotificationsByPkArgs = {
  _set?: InputMaybe<UserNotificationsSetInput>;
  pkColumns: UserNotificationsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateUserNotificationsManyArgs = {
  updates: Array<UserNotificationsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateUserPadelRatingScalesArgs = {
  _inc?: InputMaybe<UserPadelRatingScalesIncInput>;
  _set?: InputMaybe<UserPadelRatingScalesSetInput>;
  where: UserPadelRatingScalesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateUserPadelRatingScalesByPkArgs = {
  _inc?: InputMaybe<UserPadelRatingScalesIncInput>;
  _set?: InputMaybe<UserPadelRatingScalesSetInput>;
  pkColumns: UserPadelRatingScalesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateUserPadelRatingScalesManyArgs = {
  updates: Array<UserPadelRatingScalesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateUserPickleballRatingScalesArgs = {
  _inc?: InputMaybe<UserPickleballRatingScalesIncInput>;
  _set?: InputMaybe<UserPickleballRatingScalesSetInput>;
  where: UserPickleballRatingScalesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateUserPickleballRatingScalesByPkArgs = {
  _inc?: InputMaybe<UserPickleballRatingScalesIncInput>;
  _set?: InputMaybe<UserPickleballRatingScalesSetInput>;
  pkColumns: UserPickleballRatingScalesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateUserPickleballRatingScalesManyArgs = {
  updates: Array<UserPickleballRatingScalesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateUserPlayedWithDismissalsArgs = {
  _set?: InputMaybe<UserPlayedWithDismissalsSetInput>;
  where: UserPlayedWithDismissalsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateUserPlayedWithDismissalsByPkArgs = {
  _set?: InputMaybe<UserPlayedWithDismissalsSetInput>;
  pkColumns: UserPlayedWithDismissalsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateUserPlayedWithDismissalsManyArgs = {
  updates: Array<UserPlayedWithDismissalsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateUserPlayerFinderAvailabilityArgs = {
  _set?: InputMaybe<UserPlayerFinderAvailabilitySetInput>;
  where: UserPlayerFinderAvailabilityBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateUserPlayerFinderAvailabilityByPkArgs = {
  _set?: InputMaybe<UserPlayerFinderAvailabilitySetInput>;
  pkColumns: UserPlayerFinderAvailabilityPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateUserPlayerFinderAvailabilityManyArgs = {
  updates: Array<UserPlayerFinderAvailabilityUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateUserPlayerFinderGoalsArgs = {
  _set?: InputMaybe<UserPlayerFinderGoalsSetInput>;
  where: UserPlayerFinderGoalsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateUserPlayerFinderGoalsByPkArgs = {
  _set?: InputMaybe<UserPlayerFinderGoalsSetInput>;
  pkColumns: UserPlayerFinderGoalsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateUserPlayerFinderGoalsManyArgs = {
  updates: Array<UserPlayerFinderGoalsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateUserProfilesArgs = {
  _inc?: InputMaybe<UserProfilesIncInput>;
  _set?: InputMaybe<UserProfilesSetInput>;
  where: UserProfilesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateUserProfilesManyArgs = {
  updates: Array<UserProfilesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateUserRegistrationDetailsArgs = {
  _append?: InputMaybe<UserRegistrationDetailsAppendInput>;
  _deleteAtPath?: InputMaybe<UserRegistrationDetailsDeleteAtPathInput>;
  _deleteElem?: InputMaybe<UserRegistrationDetailsDeleteElemInput>;
  _deleteKey?: InputMaybe<UserRegistrationDetailsDeleteKeyInput>;
  _prepend?: InputMaybe<UserRegistrationDetailsPrependInput>;
  _set?: InputMaybe<UserRegistrationDetailsSetInput>;
  where: UserRegistrationDetailsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateUserRegistrationDetailsByPkArgs = {
  _append?: InputMaybe<UserRegistrationDetailsAppendInput>;
  _deleteAtPath?: InputMaybe<UserRegistrationDetailsDeleteAtPathInput>;
  _deleteElem?: InputMaybe<UserRegistrationDetailsDeleteElemInput>;
  _deleteKey?: InputMaybe<UserRegistrationDetailsDeleteKeyInput>;
  _prepend?: InputMaybe<UserRegistrationDetailsPrependInput>;
  _set?: InputMaybe<UserRegistrationDetailsSetInput>;
  pkColumns: UserRegistrationDetailsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateUserRegistrationDetailsManyArgs = {
  updates: Array<UserRegistrationDetailsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateUserSportsArgs = {
  _set?: InputMaybe<UserSportsSetInput>;
  where: UserSportsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateUserSportsByPkArgs = {
  _set?: InputMaybe<UserSportsSetInput>;
  pkColumns: UserSportsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateUserSportsManyArgs = {
  updates: Array<UserSportsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateUserTennisRatingScalesArgs = {
  _inc?: InputMaybe<UserTennisRatingScalesIncInput>;
  _set?: InputMaybe<UserTennisRatingScalesSetInput>;
  where: UserTennisRatingScalesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateUserTennisRatingScalesByPkArgs = {
  _inc?: InputMaybe<UserTennisRatingScalesIncInput>;
  _set?: InputMaybe<UserTennisRatingScalesSetInput>;
  pkColumns: UserTennisRatingScalesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateUserTennisRatingScalesManyArgs = {
  updates: Array<UserTennisRatingScalesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateUserTermsOfServiceArgs = {
  _set?: InputMaybe<UserTermsOfServiceSetInput>;
  where: UserTermsOfServiceBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateUserTermsOfServiceByPkArgs = {
  _set?: InputMaybe<UserTermsOfServiceSetInput>;
  pkColumns: UserTermsOfServicePkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateUserTermsOfServiceManyArgs = {
  updates: Array<UserTermsOfServiceUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateUserVairConnectionsArgs = {
  _set?: InputMaybe<UserVairConnectionsSetInput>;
  where: UserVairConnectionsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateUserVairConnectionsByPkArgs = {
  _set?: InputMaybe<UserVairConnectionsSetInput>;
  pkColumns: UserVairConnectionsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateUserVairConnectionsManyArgs = {
  updates: Array<UserVairConnectionsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateUsernameLogsArgs = {
  _set?: InputMaybe<UsernameLogsSetInput>;
  where: UsernameLogsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateUsernameLogsByPkArgs = {
  _set?: InputMaybe<UsernameLogsSetInput>;
  pkColumns: UsernameLogsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateUsernameLogsManyArgs = {
  updates: Array<UsernameLogsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateUsernamesActiveArgs = {
  _set?: InputMaybe<UsernamesActiveSetInput>;
  where: UsernamesActiveBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateUsernamesActiveManyArgs = {
  updates: Array<UsernamesActiveUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateUsernamesClaimedArgs = {
  _set?: InputMaybe<UsernamesClaimedSetInput>;
  where: UsernamesClaimedBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateUsernamesClaimedByPkArgs = {
  _set?: InputMaybe<UsernamesClaimedSetInput>;
  pkColumns: UsernamesClaimedPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateUsernamesClaimedManyArgs = {
  updates: Array<UsernamesClaimedUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateUsersArgs = {
  _append?: InputMaybe<UsersAppendInput>;
  _deleteAtPath?: InputMaybe<UsersDeleteAtPathInput>;
  _deleteElem?: InputMaybe<UsersDeleteElemInput>;
  _deleteKey?: InputMaybe<UsersDeleteKeyInput>;
  _inc?: InputMaybe<UsersIncInput>;
  _prepend?: InputMaybe<UsersPrependInput>;
  _set?: InputMaybe<UsersSetInput>;
  where: UsersBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateUsersByPkArgs = {
  _append?: InputMaybe<UsersAppendInput>;
  _deleteAtPath?: InputMaybe<UsersDeleteAtPathInput>;
  _deleteElem?: InputMaybe<UsersDeleteElemInput>;
  _deleteKey?: InputMaybe<UsersDeleteKeyInput>;
  _inc?: InputMaybe<UsersIncInput>;
  _prepend?: InputMaybe<UsersPrependInput>;
  _set?: InputMaybe<UsersSetInput>;
  pkColumns: UsersPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateUsersCoachQualificationsArgs = {
  _set?: InputMaybe<UsersCoachQualificationsSetInput>;
  where: UsersCoachQualificationsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateUsersCoachQualificationsByPkArgs = {
  _set?: InputMaybe<UsersCoachQualificationsSetInput>;
  pkColumns: UsersCoachQualificationsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateUsersCoachQualificationsManyArgs = {
  updates: Array<UsersCoachQualificationsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateUsersManyArgs = {
  updates: Array<UsersUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateVenueAccessTypesArgs = {
  _set?: InputMaybe<VenueAccessTypesSetInput>;
  where: VenueAccessTypesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateVenueAccessTypesByPkArgs = {
  _set?: InputMaybe<VenueAccessTypesSetInput>;
  pkColumns: VenueAccessTypesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateVenueAccessTypesManyArgs = {
  updates: Array<VenueAccessTypesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateVenueAdminClaimStatusesArgs = {
  _set?: InputMaybe<VenueAdminClaimStatusesSetInput>;
  where: VenueAdminClaimStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateVenueAdminClaimStatusesByPkArgs = {
  _set?: InputMaybe<VenueAdminClaimStatusesSetInput>;
  pkColumns: VenueAdminClaimStatusesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateVenueAdminClaimStatusesManyArgs = {
  updates: Array<VenueAdminClaimStatusesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateVenueAdminClaimsArgs = {
  _set?: InputMaybe<VenueAdminClaimsSetInput>;
  where: VenueAdminClaimsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateVenueAdminClaimsByPkArgs = {
  _set?: InputMaybe<VenueAdminClaimsSetInput>;
  pkColumns: VenueAdminClaimsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateVenueAdminClaimsManyArgs = {
  updates: Array<VenueAdminClaimsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateVenueAmenitiesArgs = {
  _set?: InputMaybe<VenueAmenitiesSetInput>;
  where: VenueAmenitiesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateVenueAmenitiesByPkArgs = {
  _set?: InputMaybe<VenueAmenitiesSetInput>;
  pkColumns: VenueAmenitiesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateVenueAmenitiesManyArgs = {
  updates: Array<VenueAmenitiesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateVenueBookingConfigVersionsArgs = {
  _append?: InputMaybe<VenueBookingConfigVersionsAppendInput>;
  _deleteAtPath?: InputMaybe<VenueBookingConfigVersionsDeleteAtPathInput>;
  _deleteElem?: InputMaybe<VenueBookingConfigVersionsDeleteElemInput>;
  _deleteKey?: InputMaybe<VenueBookingConfigVersionsDeleteKeyInput>;
  _inc?: InputMaybe<VenueBookingConfigVersionsIncInput>;
  _prepend?: InputMaybe<VenueBookingConfigVersionsPrependInput>;
  _set?: InputMaybe<VenueBookingConfigVersionsSetInput>;
  where: VenueBookingConfigVersionsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateVenueBookingConfigVersionsByPkArgs = {
  _append?: InputMaybe<VenueBookingConfigVersionsAppendInput>;
  _deleteAtPath?: InputMaybe<VenueBookingConfigVersionsDeleteAtPathInput>;
  _deleteElem?: InputMaybe<VenueBookingConfigVersionsDeleteElemInput>;
  _deleteKey?: InputMaybe<VenueBookingConfigVersionsDeleteKeyInput>;
  _inc?: InputMaybe<VenueBookingConfigVersionsIncInput>;
  _prepend?: InputMaybe<VenueBookingConfigVersionsPrependInput>;
  _set?: InputMaybe<VenueBookingConfigVersionsSetInput>;
  pkColumns: VenueBookingConfigVersionsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateVenueBookingConfigVersionsManyArgs = {
  updates: Array<VenueBookingConfigVersionsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateVenueBookingConnectionCheckStatusesArgs = {
  _set?: InputMaybe<VenueBookingConnectionCheckStatusesSetInput>;
  where: VenueBookingConnectionCheckStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateVenueBookingConnectionCheckStatusesByPkArgs = {
  _set?: InputMaybe<VenueBookingConnectionCheckStatusesSetInput>;
  pkColumns: VenueBookingConnectionCheckStatusesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateVenueBookingConnectionCheckStatusesManyArgs = {
  updates: Array<VenueBookingConnectionCheckStatusesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateVenueBookingConnectionChecksArgs = {
  _append?: InputMaybe<VenueBookingConnectionChecksAppendInput>;
  _deleteAtPath?: InputMaybe<VenueBookingConnectionChecksDeleteAtPathInput>;
  _deleteElem?: InputMaybe<VenueBookingConnectionChecksDeleteElemInput>;
  _deleteKey?: InputMaybe<VenueBookingConnectionChecksDeleteKeyInput>;
  _prepend?: InputMaybe<VenueBookingConnectionChecksPrependInput>;
  _set?: InputMaybe<VenueBookingConnectionChecksSetInput>;
  where: VenueBookingConnectionChecksBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateVenueBookingConnectionChecksByPkArgs = {
  _append?: InputMaybe<VenueBookingConnectionChecksAppendInput>;
  _deleteAtPath?: InputMaybe<VenueBookingConnectionChecksDeleteAtPathInput>;
  _deleteElem?: InputMaybe<VenueBookingConnectionChecksDeleteElemInput>;
  _deleteKey?: InputMaybe<VenueBookingConnectionChecksDeleteKeyInput>;
  _prepend?: InputMaybe<VenueBookingConnectionChecksPrependInput>;
  _set?: InputMaybe<VenueBookingConnectionChecksSetInput>;
  pkColumns: VenueBookingConnectionChecksPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateVenueBookingConnectionChecksManyArgs = {
  updates: Array<VenueBookingConnectionChecksUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateVenueBookingCourtRatesArgs = {
  _inc?: InputMaybe<VenueBookingCourtRatesIncInput>;
  _set?: InputMaybe<VenueBookingCourtRatesSetInput>;
  where: VenueBookingCourtRatesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateVenueBookingCourtRatesByPkArgs = {
  _inc?: InputMaybe<VenueBookingCourtRatesIncInput>;
  _set?: InputMaybe<VenueBookingCourtRatesSetInput>;
  pkColumns: VenueBookingCourtRatesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateVenueBookingCourtRatesManyArgs = {
  updates: Array<VenueBookingCourtRatesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateVenueBookingIntegrationsArgs = {
  _inc?: InputMaybe<VenueBookingIntegrationsIncInput>;
  _set?: InputMaybe<VenueBookingIntegrationsSetInput>;
  where: VenueBookingIntegrationsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateVenueBookingIntegrationsByPkArgs = {
  _inc?: InputMaybe<VenueBookingIntegrationsIncInput>;
  _set?: InputMaybe<VenueBookingIntegrationsSetInput>;
  pkColumns: VenueBookingIntegrationsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateVenueBookingIntegrationsManyArgs = {
  updates: Array<VenueBookingIntegrationsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateVenueBookingRuleTiersArgs = {
  _inc?: InputMaybe<VenueBookingRuleTiersIncInput>;
  _set?: InputMaybe<VenueBookingRuleTiersSetInput>;
  where: VenueBookingRuleTiersBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateVenueBookingRuleTiersByPkArgs = {
  _inc?: InputMaybe<VenueBookingRuleTiersIncInput>;
  _set?: InputMaybe<VenueBookingRuleTiersSetInput>;
  pkColumns: VenueBookingRuleTiersPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateVenueBookingRuleTiersManyArgs = {
  updates: Array<VenueBookingRuleTiersUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateVenueBookingRulesArgs = {
  _set?: InputMaybe<VenueBookingRulesSetInput>;
  where: VenueBookingRulesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateVenueBookingRulesByPkArgs = {
  _set?: InputMaybe<VenueBookingRulesSetInput>;
  pkColumns: VenueBookingRulesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateVenueBookingRulesManyArgs = {
  updates: Array<VenueBookingRulesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateVenueBookingWindowsArgs = {
  _set?: InputMaybe<VenueBookingWindowsSetInput>;
  where: VenueBookingWindowsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateVenueBookingWindowsByPkArgs = {
  _set?: InputMaybe<VenueBookingWindowsSetInput>;
  pkColumns: VenueBookingWindowsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateVenueBookingWindowsManyArgs = {
  updates: Array<VenueBookingWindowsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateVenueCourtSurfacesArgs = {
  _set?: InputMaybe<VenueCourtSurfacesSetInput>;
  where: VenueCourtSurfacesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateVenueCourtSurfacesByPkArgs = {
  _set?: InputMaybe<VenueCourtSurfacesSetInput>;
  pkColumns: VenueCourtSurfacesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateVenueCourtSurfacesManyArgs = {
  updates: Array<VenueCourtSurfacesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateVenueCustomAmenitiesArgs = {
  _set?: InputMaybe<VenueCustomAmenitiesSetInput>;
  where: VenueCustomAmenitiesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateVenueCustomAmenitiesByPkArgs = {
  _set?: InputMaybe<VenueCustomAmenitiesSetInput>;
  pkColumns: VenueCustomAmenitiesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateVenueCustomAmenitiesManyArgs = {
  updates: Array<VenueCustomAmenitiesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateVenueEquipmentArgs = {
  _set?: InputMaybe<VenueEquipmentSetInput>;
  where: VenueEquipmentBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateVenueEquipmentByPkArgs = {
  _set?: InputMaybe<VenueEquipmentSetInput>;
  pkColumns: VenueEquipmentPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateVenueEquipmentManyArgs = {
  updates: Array<VenueEquipmentUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateVenueFacilityTypesArgs = {
  _set?: InputMaybe<VenueFacilityTypesSetInput>;
  where: VenueFacilityTypesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateVenueFacilityTypesByPkArgs = {
  _set?: InputMaybe<VenueFacilityTypesSetInput>;
  pkColumns: VenueFacilityTypesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateVenueFacilityTypesManyArgs = {
  updates: Array<VenueFacilityTypesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateVenueFaqsArgs = {
  _inc?: InputMaybe<VenueFaqsIncInput>;
  _set?: InputMaybe<VenueFaqsSetInput>;
  where: VenueFaqsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateVenueFaqsByPkArgs = {
  _inc?: InputMaybe<VenueFaqsIncInput>;
  _set?: InputMaybe<VenueFaqsSetInput>;
  pkColumns: VenueFaqsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateVenueFaqsManyArgs = {
  updates: Array<VenueFaqsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateVenueFollowsArgs = {
  _set?: InputMaybe<VenueFollowsSetInput>;
  where: VenueFollowsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateVenueFollowsByPkArgs = {
  _set?: InputMaybe<VenueFollowsSetInput>;
  pkColumns: VenueFollowsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateVenueFollowsManyArgs = {
  updates: Array<VenueFollowsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateVenueImagesArgs = {
  _set?: InputMaybe<VenueImagesSetInput>;
  where: VenueImagesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateVenueImagesByPkArgs = {
  _set?: InputMaybe<VenueImagesSetInput>;
  pkColumns: VenueImagesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateVenueImagesManyArgs = {
  updates: Array<VenueImagesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateVenueLinesArgs = {
  _set?: InputMaybe<VenueLinesSetInput>;
  where: VenueLinesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateVenueLinesByPkArgs = {
  _set?: InputMaybe<VenueLinesSetInput>;
  pkColumns: VenueLinesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateVenueLinesManyArgs = {
  updates: Array<VenueLinesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateVenueNetsArgs = {
  _set?: InputMaybe<VenueNetsSetInput>;
  where: VenueNetsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateVenueNetsByPkArgs = {
  _set?: InputMaybe<VenueNetsSetInput>;
  pkColumns: VenueNetsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateVenueNetsManyArgs = {
  updates: Array<VenueNetsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateVenuePartnerBookingStatusesArgs = {
  _set?: InputMaybe<VenuePartnerBookingStatusesSetInput>;
  where: VenuePartnerBookingStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateVenuePartnerBookingStatusesManyArgs = {
  updates: Array<VenuePartnerBookingStatusesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateVenueStaffCoachesArgs = {
  _set?: InputMaybe<VenueStaffCoachesSetInput>;
  where: VenueStaffCoachesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateVenueStaffCoachesByPkArgs = {
  _set?: InputMaybe<VenueStaffCoachesSetInput>;
  pkColumns: VenueStaffCoachesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateVenueStaffCoachesManyArgs = {
  updates: Array<VenueStaffCoachesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateVenuesArgs = {
  _inc?: InputMaybe<VenuesIncInput>;
  _set?: InputMaybe<VenuesSetInput>;
  where: VenuesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateVenuesByPkArgs = {
  _inc?: InputMaybe<VenuesIncInput>;
  _set?: InputMaybe<VenuesSetInput>;
  pkColumns: VenuesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateVenuesManyArgs = {
  updates: Array<VenuesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateVideoAnalysisArgs = {
  _inc?: InputMaybe<VideoAnalysisIncInput>;
  _set?: InputMaybe<VideoAnalysisSetInput>;
  where: VideoAnalysisBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateVideoAnalysisByPkArgs = {
  _inc?: InputMaybe<VideoAnalysisIncInput>;
  _set?: InputMaybe<VideoAnalysisSetInput>;
  pkColumns: VideoAnalysisPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateVideoAnalysisCommentsArgs = {
  _inc?: InputMaybe<VideoAnalysisCommentsIncInput>;
  _set?: InputMaybe<VideoAnalysisCommentsSetInput>;
  where: VideoAnalysisCommentsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateVideoAnalysisCommentsByPkArgs = {
  _inc?: InputMaybe<VideoAnalysisCommentsIncInput>;
  _set?: InputMaybe<VideoAnalysisCommentsSetInput>;
  pkColumns: VideoAnalysisCommentsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateVideoAnalysisCommentsManyArgs = {
  updates: Array<VideoAnalysisCommentsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateVideoAnalysisFilesArgs = {
  _set?: InputMaybe<VideoAnalysisFilesSetInput>;
  where: VideoAnalysisFilesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateVideoAnalysisFilesByPkArgs = {
  _set?: InputMaybe<VideoAnalysisFilesSetInput>;
  pkColumns: VideoAnalysisFilesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateVideoAnalysisFilesManyArgs = {
  updates: Array<VideoAnalysisFilesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateVideoAnalysisFilesUploadStatusesArgs = {
  _set?: InputMaybe<VideoAnalysisFilesUploadStatusesSetInput>;
  where: VideoAnalysisFilesUploadStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateVideoAnalysisFilesUploadStatusesByPkArgs = {
  _set?: InputMaybe<VideoAnalysisFilesUploadStatusesSetInput>;
  pkColumns: VideoAnalysisFilesUploadStatusesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateVideoAnalysisFilesUploadStatusesManyArgs = {
  updates: Array<VideoAnalysisFilesUploadStatusesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateVideoAnalysisManyArgs = {
  updates: Array<VideoAnalysisUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateVideoAnalysisOrderItemsArgs = {
  _inc?: InputMaybe<VideoAnalysisOrderItemsIncInput>;
  _set?: InputMaybe<VideoAnalysisOrderItemsSetInput>;
  where: VideoAnalysisOrderItemsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateVideoAnalysisOrderItemsByPkArgs = {
  _inc?: InputMaybe<VideoAnalysisOrderItemsIncInput>;
  _set?: InputMaybe<VideoAnalysisOrderItemsSetInput>;
  pkColumns: VideoAnalysisOrderItemsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateVideoAnalysisOrderItemsManyArgs = {
  updates: Array<VideoAnalysisOrderItemsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateVideoAnalysisOrdersArgs = {
  _inc?: InputMaybe<VideoAnalysisOrdersIncInput>;
  _set?: InputMaybe<VideoAnalysisOrdersSetInput>;
  where: VideoAnalysisOrdersBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateVideoAnalysisOrdersByPkArgs = {
  _inc?: InputMaybe<VideoAnalysisOrdersIncInput>;
  _set?: InputMaybe<VideoAnalysisOrdersSetInput>;
  pkColumns: VideoAnalysisOrdersPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateVideoAnalysisOrdersManyArgs = {
  updates: Array<VideoAnalysisOrdersUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateVideoAnalysisRequestedSkillsReviewArgs = {
  _set?: InputMaybe<VideoAnalysisRequestedSkillsReviewSetInput>;
  where: VideoAnalysisRequestedSkillsReviewBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateVideoAnalysisRequestedSkillsReviewByPkArgs = {
  _set?: InputMaybe<VideoAnalysisRequestedSkillsReviewSetInput>;
  pkColumns: VideoAnalysisRequestedSkillsReviewPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateVideoAnalysisRequestedSkillsReviewManyArgs = {
  updates: Array<VideoAnalysisRequestedSkillsReviewUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateVideoAnalysisReviewStatusesArgs = {
  _set?: InputMaybe<VideoAnalysisReviewStatusesSetInput>;
  where: VideoAnalysisReviewStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateVideoAnalysisReviewStatusesByPkArgs = {
  _set?: InputMaybe<VideoAnalysisReviewStatusesSetInput>;
  pkColumns: VideoAnalysisReviewStatusesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateVideoAnalysisReviewStatusesManyArgs = {
  updates: Array<VideoAnalysisReviewStatusesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateVideoAnalysisSkillsCommentsArgs = {
  _set?: InputMaybe<VideoAnalysisSkillsCommentsSetInput>;
  where: VideoAnalysisSkillsCommentsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateVideoAnalysisSkillsCommentsByPkArgs = {
  _set?: InputMaybe<VideoAnalysisSkillsCommentsSetInput>;
  pkColumns: VideoAnalysisSkillsCommentsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateVideoAnalysisSkillsCommentsManyArgs = {
  updates: Array<VideoAnalysisSkillsCommentsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateVideoAnalysisSubmissionLogArgs = {
  _set?: InputMaybe<VideoAnalysisSubmissionLogSetInput>;
  where: VideoAnalysisSubmissionLogBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateVideoAnalysisSubmissionLogByPkArgs = {
  _set?: InputMaybe<VideoAnalysisSubmissionLogSetInput>;
  pkColumns: VideoAnalysisSubmissionLogPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateVideoAnalysisSubmissionLogManyArgs = {
  updates: Array<VideoAnalysisSubmissionLogUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateVideoLessonSkillsArgs = {
  _set?: InputMaybe<VideoLessonSkillsSetInput>;
  where: VideoLessonSkillsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateVideoLessonSkillsByPkArgs = {
  _set?: InputMaybe<VideoLessonSkillsSetInput>;
  pkColumns: VideoLessonSkillsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateVideoLessonSkillsManyArgs = {
  updates: Array<VideoLessonSkillsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateWelcomeEmailConfigurationArgs = {
  _set?: InputMaybe<WelcomeEmailConfigurationSetInput>;
  where: WelcomeEmailConfigurationBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateWelcomeEmailConfigurationByPkArgs = {
  _set?: InputMaybe<WelcomeEmailConfigurationSetInput>;
  pkColumns: WelcomeEmailConfigurationPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateWelcomeEmailConfigurationManyArgs = {
  updates: Array<WelcomeEmailConfigurationUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateWinReasonsArgs = {
  _set?: InputMaybe<WinReasonsSetInput>;
  where: WinReasonsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateWinReasonsByPkArgs = {
  _set?: InputMaybe<WinReasonsSetInput>;
  pkColumns: WinReasonsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateWinReasonsManyArgs = {
  updates: Array<WinReasonsUpdates>;
};

export type PartnerBookingAttemptEventsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<PartnerBookingAttemptEventsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PartnerBookingAttemptEventsBoolExp>;
  predicate: IntComparisonExp;
};

export type PartnerBookingAttemptsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<PartnerBookingAttemptsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PartnerBookingAttemptsBoolExp>;
  predicate: IntComparisonExp;
};

export type PlatformSubscriptionPlanPricesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<PlatformSubscriptionPlanPricesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PlatformSubscriptionPlanPricesBoolExp>;
  predicate: IntComparisonExp;
};

export type PlatformSubscriptionsAggregateBoolExpBool_And = {
  arguments: PlatformSubscriptionsSelectColumnPlatformSubscriptionsAggregateBoolExpBool_AndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PlatformSubscriptionsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type PlatformSubscriptionsAggregateBoolExpBool_Or = {
  arguments: PlatformSubscriptionsSelectColumnPlatformSubscriptionsAggregateBoolExpBool_OrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PlatformSubscriptionsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type PlatformSubscriptionsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<PlatformSubscriptionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PlatformSubscriptionsBoolExp>;
  predicate: IntComparisonExp;
};

export type PlayRequestNeighborhoodsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<PlayRequestNeighborhoodsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PlayRequestNeighborhoodsBoolExp>;
  predicate: IntComparisonExp;
};

export type PlayRequestSlotsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<PlayRequestSlotsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PlayRequestSlotsBoolExp>;
  predicate: IntComparisonExp;
};

export type PlayRequestVenuesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<PlayRequestVenuesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PlayRequestVenuesBoolExp>;
  predicate: IntComparisonExp;
};

export type PlayRequestsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<PlayRequestsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PlayRequestsBoolExp>;
  predicate: IntComparisonExp;
};

export type PlaySessionCommentsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<PlaySessionCommentsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PlaySessionCommentsBoolExp>;
  predicate: IntComparisonExp;
};

export type PlaySessionParticipantsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<PlaySessionParticipantsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PlaySessionParticipantsBoolExp>;
  predicate: IntComparisonExp;
};

export type PlaySessionsAggregateBoolExpBool_And = {
  arguments: PlaySessionsSelectColumnPlaySessionsAggregateBoolExpBool_AndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PlaySessionsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type PlaySessionsAggregateBoolExpBool_Or = {
  arguments: PlaySessionsSelectColumnPlaySessionsAggregateBoolExpBool_OrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PlaySessionsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type PlaySessionsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<PlaySessionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PlaySessionsBoolExp>;
  predicate: IntComparisonExp;
};

export type PlayerAvailabilityNeighborhoodsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<PlayerAvailabilityNeighborhoodsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PlayerAvailabilityNeighborhoodsBoolExp>;
  predicate: IntComparisonExp;
};

export type PlayerAvailabilityRatingScalesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<PlayerAvailabilityRatingScalesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PlayerAvailabilityRatingScalesBoolExp>;
  predicate: IntComparisonExp;
};

export type PlayerAvailabilitySlotsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<PlayerAvailabilitySlotsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PlayerAvailabilitySlotsBoolExp>;
  predicate: IntComparisonExp;
};

export type PlayerAvailabilityVenuesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<PlayerAvailabilityVenuesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PlayerAvailabilityVenuesBoolExp>;
  predicate: IntComparisonExp;
};

export type Query_Root = {
  __typename?: 'query_root';
  /** fetch data from the table: "amenities" */
  amenities: Array<Amenities>;
  /** fetch aggregated fields from the table: "amenities" */
  amenitiesAggregate: AmenitiesAggregate;
  /** fetch data from the table: "amenities" using primary key columns */
  amenitiesByPk?: Maybe<Amenities>;
  /** fetch data from the table: "app_personas" */
  appPersonas: Array<AppPersonas>;
  /** fetch aggregated fields from the table: "app_personas" */
  appPersonasAggregate: AppPersonasAggregate;
  /** fetch data from the table: "app_personas" using primary key columns */
  appPersonasByPk?: Maybe<AppPersonas>;
  /** fetch data from the table: "app_pings" */
  appPings: Array<AppPings>;
  /** fetch aggregated fields from the table: "app_pings" */
  appPingsAggregate: AppPingsAggregate;
  /** fetch data from the table: "app_pings" using primary key columns */
  appPingsByPk?: Maybe<AppPings>;
  /** fetch data from the table: "ball_types" */
  ballTypes: Array<BallTypes>;
  /** fetch aggregated fields from the table: "ball_types" */
  ballTypesAggregate: BallTypesAggregate;
  /** fetch data from the table: "ball_types" using primary key columns */
  ballTypesByPk?: Maybe<BallTypes>;
  /** fetch data from the table: "birthday_visibility" */
  birthdayVisibility: Array<BirthdayVisibility>;
  /** fetch aggregated fields from the table: "birthday_visibility" */
  birthdayVisibilityAggregate: BirthdayVisibilityAggregate;
  /** fetch data from the table: "birthday_visibility" using primary key columns */
  birthdayVisibilityByPk?: Maybe<BirthdayVisibility>;
  /** fetch data from the table: "booking_config_change_types" */
  bookingConfigChangeTypes: Array<BookingConfigChangeTypes>;
  /** fetch aggregated fields from the table: "booking_config_change_types" */
  bookingConfigChangeTypesAggregate: BookingConfigChangeTypesAggregate;
  /** fetch data from the table: "booking_config_change_types" using primary key columns */
  bookingConfigChangeTypesByPk?: Maybe<BookingConfigChangeTypes>;
  /** fetch data from the table: "booking_connection_statuses" */
  bookingConnectionStatuses: Array<BookingConnectionStatuses>;
  /** fetch aggregated fields from the table: "booking_connection_statuses" */
  bookingConnectionStatusesAggregate: BookingConnectionStatusesAggregate;
  /** fetch data from the table: "booking_connection_statuses" using primary key columns */
  bookingConnectionStatusesByPk?: Maybe<BookingConnectionStatuses>;
  /** fetch data from the table: "booking_integration_statuses" */
  bookingIntegrationStatuses: Array<BookingIntegrationStatuses>;
  /** fetch aggregated fields from the table: "booking_integration_statuses" */
  bookingIntegrationStatusesAggregate: BookingIntegrationStatusesAggregate;
  /** fetch data from the table: "booking_integration_statuses" using primary key columns */
  bookingIntegrationStatusesByPk?: Maybe<BookingIntegrationStatuses>;
  /** fetch data from the table: "booking_inventory_types" */
  bookingInventoryTypes: Array<BookingInventoryTypes>;
  /** fetch aggregated fields from the table: "booking_inventory_types" */
  bookingInventoryTypesAggregate: BookingInventoryTypesAggregate;
  /** fetch data from the table: "booking_inventory_types" using primary key columns */
  bookingInventoryTypesByPk?: Maybe<BookingInventoryTypes>;
  /** fetch data from the table: "booking_schedule_modes" */
  bookingScheduleModes: Array<BookingScheduleModes>;
  /** fetch aggregated fields from the table: "booking_schedule_modes" */
  bookingScheduleModesAggregate: BookingScheduleModesAggregate;
  /** fetch data from the table: "booking_schedule_modes" using primary key columns */
  bookingScheduleModesByPk?: Maybe<BookingScheduleModes>;
  /** fetch data from the table: "booking_systems" */
  bookingSystems: Array<BookingSystems>;
  /** fetch aggregated fields from the table: "booking_systems" */
  bookingSystemsAggregate: BookingSystemsAggregate;
  /** fetch data from the table: "booking_systems" using primary key columns */
  bookingSystemsByPk?: Maybe<BookingSystems>;
  /** fetch data from the table: "booking_window_kinds" */
  bookingWindowKinds: Array<BookingWindowKinds>;
  /** fetch aggregated fields from the table: "booking_window_kinds" */
  bookingWindowKindsAggregate: BookingWindowKindsAggregate;
  /** fetch data from the table: "booking_window_kinds" using primary key columns */
  bookingWindowKindsByPk?: Maybe<BookingWindowKinds>;
  /** fetch data from the table: "boost_channels" */
  boostChannels: Array<BoostChannels>;
  /** fetch aggregated fields from the table: "boost_channels" */
  boostChannelsAggregate: BoostChannelsAggregate;
  /** fetch data from the table: "boost_channels" using primary key columns */
  boostChannelsByPk?: Maybe<BoostChannels>;
  /** fetch data from the table: "boost_orders" */
  boostOrders: Array<BoostOrders>;
  /** fetch aggregated fields from the table: "boost_orders" */
  boostOrdersAggregate: BoostOrdersAggregate;
  /** fetch data from the table: "boost_orders" using primary key columns */
  boostOrdersByPk?: Maybe<BoostOrders>;
  /** fetch data from the table: "boost_statuses" */
  boostStatuses: Array<BoostStatuses>;
  /** fetch aggregated fields from the table: "boost_statuses" */
  boostStatusesAggregate: BoostStatusesAggregate;
  /** fetch data from the table: "boost_statuses" using primary key columns */
  boostStatusesByPk?: Maybe<BoostStatuses>;
  /** An array relationship */
  boosts: Array<Boosts>;
  /** An aggregate relationship */
  boostsAggregate: BoostsAggregate;
  /** fetch data from the table: "boosts" using primary key columns */
  boostsByPk?: Maybe<Boosts>;
  /** fetch data from the table: "bracket_ranking_mechanism" */
  bracketRankingMechanism: Array<BracketRankingMechanism>;
  /** fetch aggregated fields from the table: "bracket_ranking_mechanism" */
  bracketRankingMechanismAggregate: BracketRankingMechanismAggregate;
  /** fetch data from the table: "bracket_ranking_mechanism" using primary key columns */
  bracketRankingMechanismByPk?: Maybe<BracketRankingMechanism>;
  /** fetch data from the table: "calendar_accounts" */
  calendarAccounts: Array<CalendarAccounts>;
  /** fetch aggregated fields from the table: "calendar_accounts" */
  calendarAccountsAggregate: CalendarAccountsAggregate;
  /** fetch data from the table: "calendar_accounts" using primary key columns */
  calendarAccountsByPk?: Maybe<CalendarAccounts>;
  /** fetch data from the table: "calendar_auth_provider" */
  calendarAuthProvider: Array<CalendarAuthProvider>;
  /** fetch aggregated fields from the table: "calendar_auth_provider" */
  calendarAuthProviderAggregate: CalendarAuthProviderAggregate;
  /** fetch data from the table: "calendar_auth_provider" using primary key columns */
  calendarAuthProviderByPk?: Maybe<CalendarAuthProvider>;
  /** fetch data from the table: "calendar_event_mappings" */
  calendarEventMappings: Array<CalendarEventMappings>;
  /** fetch aggregated fields from the table: "calendar_event_mappings" */
  calendarEventMappingsAggregate: CalendarEventMappingsAggregate;
  /** fetch data from the table: "calendar_event_mappings" using primary key columns */
  calendarEventMappingsByPk?: Maybe<CalendarEventMappings>;
  /** An array relationship */
  calendarPreferences: Array<CalendarPreferences>;
  /** An aggregate relationship */
  calendarPreferencesAggregate: CalendarPreferencesAggregate;
  /** fetch data from the table: "calendar_preferences" using primary key columns */
  calendarPreferencesByPk?: Maybe<CalendarPreferences>;
  /** An array relationship */
  cities: Array<Cities>;
  /** An aggregate relationship */
  citiesAggregate: CitiesAggregate;
  /** fetch data from the table: "cities" using primary key columns */
  citiesByPk?: Maybe<Cities>;
  /** An array relationship */
  coachAvailability: Array<CoachAvailability>;
  /** An aggregate relationship */
  coachAvailabilityAggregate: CoachAvailabilityAggregate;
  /** fetch data from the table: "coach_availability" using primary key columns */
  coachAvailabilityByPk?: Maybe<CoachAvailability>;
  /** fetch data from the table: "coach_availability_statuses" */
  coachAvailabilityStatuses: Array<CoachAvailabilityStatuses>;
  /** fetch aggregated fields from the table: "coach_availability_statuses" */
  coachAvailabilityStatusesAggregate: CoachAvailabilityStatusesAggregate;
  /** fetch data from the table: "coach_availability_statuses" using primary key columns */
  coachAvailabilityStatusesByPk?: Maybe<CoachAvailabilityStatuses>;
  /** fetch data from the table: "coach_booking_requests" */
  coachBookingRequests: Array<CoachBookingRequests>;
  /** fetch aggregated fields from the table: "coach_booking_requests" */
  coachBookingRequestsAggregate: CoachBookingRequestsAggregate;
  /** fetch data from the table: "coach_booking_requests" using primary key columns */
  coachBookingRequestsByPk?: Maybe<CoachBookingRequests>;
  /** fetch data from the table: "coach_external_review_sources" */
  coachExternalReviewSources: Array<CoachExternalReviewSources>;
  /** fetch aggregated fields from the table: "coach_external_review_sources" */
  coachExternalReviewSourcesAggregate: CoachExternalReviewSourcesAggregate;
  /** fetch data from the table: "coach_external_review_sources" using primary key columns */
  coachExternalReviewSourcesByPk?: Maybe<CoachExternalReviewSources>;
  /** An array relationship */
  coachFaqs: Array<CoachFaqs>;
  /** An aggregate relationship */
  coachFaqsAggregate: CoachFaqsAggregate;
  /** fetch data from the table: "coach_faqs" using primary key columns */
  coachFaqsByPk?: Maybe<CoachFaqs>;
  /** An array relationship */
  coachLessonAgeGroups: Array<CoachLessonAgeGroups>;
  /** An aggregate relationship */
  coachLessonAgeGroupsAggregate: CoachLessonAgeGroupsAggregate;
  /** fetch data from the table: "coach_lesson_age_groups" using primary key columns */
  coachLessonAgeGroupsByPk?: Maybe<CoachLessonAgeGroups>;
  /** An array relationship */
  coachLessonSkillLevels: Array<CoachLessonSkillLevels>;
  /** An aggregate relationship */
  coachLessonSkillLevelsAggregate: CoachLessonSkillLevelsAggregate;
  /** fetch data from the table: "coach_lesson_skill_levels" using primary key columns */
  coachLessonSkillLevelsByPk?: Maybe<CoachLessonSkillLevels>;
  /** fetch data from the table: "coach_qualification_groups" */
  coachQualificationGroups: Array<CoachQualificationGroups>;
  /** fetch aggregated fields from the table: "coach_qualification_groups" */
  coachQualificationGroupsAggregate: CoachQualificationGroupsAggregate;
  /** fetch data from the table: "coach_qualification_groups" using primary key columns */
  coachQualificationGroupsByPk?: Maybe<CoachQualificationGroups>;
  /** fetch data from the table: "coach_qualification_statuses" */
  coachQualificationStatuses: Array<CoachQualificationStatuses>;
  /** fetch aggregated fields from the table: "coach_qualification_statuses" */
  coachQualificationStatusesAggregate: CoachQualificationStatusesAggregate;
  /** fetch data from the table: "coach_qualification_statuses" using primary key columns */
  coachQualificationStatusesByPk?: Maybe<CoachQualificationStatuses>;
  /** fetch data from the table: "coach_qualifications" */
  coachQualifications: Array<CoachQualifications>;
  /** fetch aggregated fields from the table: "coach_qualifications" */
  coachQualificationsAggregate: CoachQualificationsAggregate;
  /** fetch data from the table: "coach_qualifications" using primary key columns */
  coachQualificationsByPk?: Maybe<CoachQualifications>;
  /** fetch data from the table: "coach_review_types" */
  coachReviewTypes: Array<CoachReviewTypes>;
  /** fetch aggregated fields from the table: "coach_review_types" */
  coachReviewTypesAggregate: CoachReviewTypesAggregate;
  /** fetch data from the table: "coach_review_types" using primary key columns */
  coachReviewTypesByPk?: Maybe<CoachReviewTypes>;
  /** fetch data from the table: "coach_sport_statuses" */
  coachSportStatuses: Array<CoachSportStatuses>;
  /** fetch aggregated fields from the table: "coach_sport_statuses" */
  coachSportStatusesAggregate: CoachSportStatusesAggregate;
  /** fetch data from the table: "coach_sport_statuses" using primary key columns */
  coachSportStatusesByPk?: Maybe<CoachSportStatuses>;
  /** An array relationship */
  coachSports: Array<CoachSports>;
  /** An aggregate relationship */
  coachSportsAggregate: CoachSportsAggregate;
  /** fetch data from the table: "coach_sports" using primary key columns */
  coachSportsByPk?: Maybe<CoachSports>;
  /** An array relationship */
  coachStarterProfiles: Array<CoachStarterProfiles>;
  /** An aggregate relationship */
  coachStarterProfilesAggregate: CoachStarterProfilesAggregate;
  /** fetch data from the table: "coach_starter_profiles" using primary key columns */
  coachStarterProfilesByPk?: Maybe<CoachStarterProfiles>;
  /** fetch data from the table: "coach_status" */
  coachStatus: Array<CoachStatus>;
  /** fetch aggregated fields from the table: "coach_status" */
  coachStatusAggregate: CoachStatusAggregate;
  /** fetch data from the table: "coach_status" using primary key columns */
  coachStatusByPk?: Maybe<CoachStatus>;
  /** fetch data from the table: "coach_tips" */
  coachTips: Array<CoachTips>;
  /** fetch aggregated fields from the table: "coach_tips" */
  coachTipsAggregate: CoachTipsAggregate;
  /** fetch data from the table: "coach_tips" using primary key columns */
  coachTipsByPk?: Maybe<CoachTips>;
  /** fetch data from the table: "comment_vote" */
  commentVote: Array<CommentVote>;
  /** fetch aggregated fields from the table: "comment_vote" */
  commentVoteAggregate: CommentVoteAggregate;
  /** fetch data from the table: "comment_vote" using primary key columns */
  commentVoteByPk?: Maybe<CommentVote>;
  /** fetch data from the table: "communication_preference_statuses" */
  communicationPreferenceStatuses: Array<CommunicationPreferenceStatuses>;
  /** fetch aggregated fields from the table: "communication_preference_statuses" */
  communicationPreferenceStatusesAggregate: CommunicationPreferenceStatusesAggregate;
  /** fetch data from the table: "communication_preference_statuses" using primary key columns */
  communicationPreferenceStatusesByPk?: Maybe<CommunicationPreferenceStatuses>;
  /** fetch data from the table: "competition_formats" */
  competitionFormats: Array<CompetitionFormats>;
  /** fetch aggregated fields from the table: "competition_formats" */
  competitionFormatsAggregate: CompetitionFormatsAggregate;
  /** fetch data from the table: "competition_formats" using primary key columns */
  competitionFormatsByPk?: Maybe<CompetitionFormats>;
  /** fetch data from the table: "competition_gender" */
  competitionGender: Array<CompetitionGender>;
  /** fetch aggregated fields from the table: "competition_gender" */
  competitionGenderAggregate: CompetitionGenderAggregate;
  /** fetch data from the table: "competition_gender" using primary key columns */
  competitionGenderByPk?: Maybe<CompetitionGender>;
  /** fetch data from the table: "content_reports" */
  contentReports: Array<ContentReports>;
  /** fetch aggregated fields from the table: "content_reports" */
  contentReportsAggregate: ContentReportsAggregate;
  /** fetch data from the table: "content_reports" using primary key columns */
  contentReportsByPk?: Maybe<ContentReports>;
  /** fetch data from the table: "conversation_participants" */
  conversationParticipants: Array<ConversationParticipants>;
  /** fetch aggregated fields from the table: "conversation_participants" */
  conversationParticipantsAggregate: ConversationParticipantsAggregate;
  /** fetch data from the table: "conversation_participants" using primary key columns */
  conversationParticipantsByPk?: Maybe<ConversationParticipants>;
  /** fetch data from the table: "conversation_types" */
  conversationTypes: Array<ConversationTypes>;
  /** fetch aggregated fields from the table: "conversation_types" */
  conversationTypesAggregate: ConversationTypesAggregate;
  /** fetch data from the table: "conversation_types" using primary key columns */
  conversationTypesByPk?: Maybe<ConversationTypes>;
  /** An array relationship */
  conversations: Array<Conversations>;
  /** An aggregate relationship */
  conversationsAggregate: ConversationsAggregate;
  /** fetch data from the table: "conversations" using primary key columns */
  conversationsByPk?: Maybe<Conversations>;
  /** fetch data from the table: "countries" */
  countries: Array<Countries>;
  /** fetch aggregated fields from the table: "countries" */
  countriesAggregate: CountriesAggregate;
  /** fetch data from the table: "countries" using primary key columns */
  countriesByPk?: Maybe<Countries>;
  /** fetch data from the table: "country_subdivisions" */
  countrySubdivisions: Array<CountrySubdivisions>;
  /** fetch aggregated fields from the table: "country_subdivisions" */
  countrySubdivisionsAggregate: CountrySubdivisionsAggregate;
  /** fetch data from the table: "country_subdivisions" using primary key columns */
  countrySubdivisionsByPk?: Maybe<CountrySubdivisions>;
  /** fetch data from the table: "court_surfaces" */
  courtSurfaces: Array<CourtSurfaces>;
  /** fetch aggregated fields from the table: "court_surfaces" */
  courtSurfacesAggregate: CourtSurfacesAggregate;
  /** fetch data from the table: "court_surfaces" using primary key columns */
  courtSurfacesByPk?: Maybe<CourtSurfaces>;
  /** fetch data from the table: "day_of_week" */
  dayOfWeek: Array<DayOfWeek>;
  /** fetch aggregated fields from the table: "day_of_week" */
  dayOfWeekAggregate: DayOfWeekAggregate;
  /** fetch data from the table: "day_of_week" using primary key columns */
  dayOfWeekByPk?: Maybe<DayOfWeek>;
  /** fetch data from the table: "engagement_analytics" */
  engagementAnalytics: Array<EngagementAnalytics>;
  /** fetch aggregated fields from the table: "engagement_analytics" */
  engagementAnalyticsAggregate: EngagementAnalyticsAggregate;
  /** fetch data from the table: "engagement_analytics" using primary key columns */
  engagementAnalyticsByPk?: Maybe<EngagementAnalytics>;
  /** fetch data from the table: "engagement_entity_types" */
  engagementEntityTypes: Array<EngagementEntityTypes>;
  /** fetch aggregated fields from the table: "engagement_entity_types" */
  engagementEntityTypesAggregate: EngagementEntityTypesAggregate;
  /** fetch data from the table: "engagement_entity_types" using primary key columns */
  engagementEntityTypesByPk?: Maybe<EngagementEntityTypes>;
  /** fetch data from the table: "engagement_event_types" */
  engagementEventTypes: Array<EngagementEventTypes>;
  /** fetch aggregated fields from the table: "engagement_event_types" */
  engagementEventTypesAggregate: EngagementEventTypesAggregate;
  /** fetch data from the table: "engagement_event_types" using primary key columns */
  engagementEventTypesByPk?: Maybe<EngagementEventTypes>;
  /** fetch data from the table: "engagement_sources" */
  engagementSources: Array<EngagementSources>;
  /** fetch aggregated fields from the table: "engagement_sources" */
  engagementSourcesAggregate: EngagementSourcesAggregate;
  /** fetch data from the table: "engagement_sources" using primary key columns */
  engagementSourcesByPk?: Maybe<EngagementSources>;
  /** fetch data from the table: "equipment_availabilities" */
  equipmentAvailabilities: Array<EquipmentAvailabilities>;
  /** fetch aggregated fields from the table: "equipment_availabilities" */
  equipmentAvailabilitiesAggregate: EquipmentAvailabilitiesAggregate;
  /** fetch data from the table: "equipment_availabilities" using primary key columns */
  equipmentAvailabilitiesByPk?: Maybe<EquipmentAvailabilities>;
  /** fetch data from the table: "event_accepted_play_requests" */
  eventAcceptedPlayRequests: Array<EventAcceptedPlayRequests>;
  /** fetch aggregated fields from the table: "event_accepted_play_requests" */
  eventAcceptedPlayRequestsAggregate: EventAcceptedPlayRequestsAggregate;
  /** fetch data from the table: "event_age_groups" */
  eventAgeGroups: Array<EventAgeGroups>;
  /** fetch aggregated fields from the table: "event_age_groups" */
  eventAgeGroupsAggregate: EventAgeGroupsAggregate;
  /** fetch data from the table: "event_age_groups" using primary key columns */
  eventAgeGroupsByPk?: Maybe<EventAgeGroups>;
  /** fetch data from the table: "event_collections" */
  eventCollections: Array<EventCollections>;
  /** fetch aggregated fields from the table: "event_collections" */
  eventCollectionsAggregate: EventCollectionsAggregate;
  /** fetch data from the table: "event_collections" using primary key columns */
  eventCollectionsByPk?: Maybe<EventCollections>;
  /** fetch data from the table: "event_competitiveness" */
  eventCompetitiveness: Array<EventCompetitiveness>;
  /** fetch aggregated fields from the table: "event_competitiveness" */
  eventCompetitivenessAggregate: EventCompetitivenessAggregate;
  /** fetch data from the table: "event_competitiveness" using primary key columns */
  eventCompetitivenessByPk?: Maybe<EventCompetitiveness>;
  /** fetch data from the table: "event_contact_details" */
  eventContactDetails: Array<EventContactDetails>;
  /** fetch aggregated fields from the table: "event_contact_details" */
  eventContactDetailsAggregate: EventContactDetailsAggregate;
  /** fetch data from the table: "event_contact_details" using primary key columns */
  eventContactDetailsByPk?: Maybe<EventContactDetails>;
  /** fetch data from the table: "event_coupon_groups" */
  eventCouponGroups: Array<EventCouponGroups>;
  /** fetch aggregated fields from the table: "event_coupon_groups" */
  eventCouponGroupsAggregate: EventCouponGroupsAggregate;
  /** fetch data from the table: "event_coupon_groups" using primary key columns */
  eventCouponGroupsByPk?: Maybe<EventCouponGroups>;
  /** fetch data from the table: "event_coupon_redemptions" */
  eventCouponRedemptions: Array<EventCouponRedemptions>;
  /** fetch aggregated fields from the table: "event_coupon_redemptions" */
  eventCouponRedemptionsAggregate: EventCouponRedemptionsAggregate;
  /** fetch data from the table: "event_coupon_redemptions" using primary key columns */
  eventCouponRedemptionsByPk?: Maybe<EventCouponRedemptions>;
  /** fetch data from the table: "event_coupon_source" */
  eventCouponSource: Array<EventCouponSource>;
  /** fetch aggregated fields from the table: "event_coupon_source" */
  eventCouponSourceAggregate: EventCouponSourceAggregate;
  /** fetch data from the table: "event_coupon_source" using primary key columns */
  eventCouponSourceByPk?: Maybe<EventCouponSource>;
  /** fetch data from the table: "event_coupon_type" */
  eventCouponType: Array<EventCouponType>;
  /** fetch aggregated fields from the table: "event_coupon_type" */
  eventCouponTypeAggregate: EventCouponTypeAggregate;
  /** fetch data from the table: "event_coupon_type" using primary key columns */
  eventCouponTypeByPk?: Maybe<EventCouponType>;
  /** fetch data from the table: "event_coupons" */
  eventCoupons: Array<EventCoupons>;
  /** fetch aggregated fields from the table: "event_coupons" */
  eventCouponsAggregate: EventCouponsAggregate;
  /** fetch data from the table: "event_coupons" using primary key columns */
  eventCouponsByPk?: Maybe<EventCoupons>;
  /** fetch data from the table: "event_court_statuses" */
  eventCourtStatuses: Array<EventCourtStatuses>;
  /** fetch aggregated fields from the table: "event_court_statuses" */
  eventCourtStatusesAggregate: EventCourtStatusesAggregate;
  /** fetch data from the table: "event_court_statuses" using primary key columns */
  eventCourtStatusesByPk?: Maybe<EventCourtStatuses>;
  /** fetch data from the table: "event_courts" */
  eventCourts: Array<EventCourts>;
  /** fetch aggregated fields from the table: "event_courts" */
  eventCourtsAggregate: EventCourtsAggregate;
  /** fetch data from the table: "event_courts" using primary key columns */
  eventCourtsByPk?: Maybe<EventCourts>;
  /** fetch data from the table: "event_faqs" */
  eventFaqs: Array<EventFaqs>;
  /** fetch aggregated fields from the table: "event_faqs" */
  eventFaqsAggregate: EventFaqsAggregate;
  /** fetch data from the table: "event_faqs" using primary key columns */
  eventFaqsByPk?: Maybe<EventFaqs>;
  /** fetch data from the table: "event_game_scores" */
  eventGameScores: Array<EventGameScores>;
  /** fetch aggregated fields from the table: "event_game_scores" */
  eventGameScoresAggregate: EventGameScoresAggregate;
  /** fetch data from the table: "event_game_scores" using primary key columns */
  eventGameScoresByPk?: Maybe<EventGameScores>;
  /** fetch data from the table: "event_group_formats" */
  eventGroupFormats: Array<EventGroupFormats>;
  /** fetch aggregated fields from the table: "event_group_formats" */
  eventGroupFormatsAggregate: EventGroupFormatsAggregate;
  /** fetch data from the table: "event_group_formats" using primary key columns */
  eventGroupFormatsByPk?: Maybe<EventGroupFormats>;
  /** fetch data from the table: "event_group_merges" */
  eventGroupMerges: Array<EventGroupMerges>;
  /** fetch aggregated fields from the table: "event_group_merges" */
  eventGroupMergesAggregate: EventGroupMergesAggregate;
  /** fetch data from the table: "event_group_merges" using primary key columns */
  eventGroupMergesByPk?: Maybe<EventGroupMerges>;
  /** fetch data from the table: "event_group_pools" */
  eventGroupPools: Array<EventGroupPools>;
  /** fetch aggregated fields from the table: "event_group_pools" */
  eventGroupPoolsAggregate: EventGroupPoolsAggregate;
  /** fetch data from the table: "event_group_pools" using primary key columns */
  eventGroupPoolsByPk?: Maybe<EventGroupPools>;
  /** fetch data from the table: "event_group_rating_scales" */
  eventGroupRatingScales: Array<EventGroupRatingScales>;
  /** fetch aggregated fields from the table: "event_group_rating_scales" */
  eventGroupRatingScalesAggregate: EventGroupRatingScalesAggregate;
  /** fetch data from the table: "event_group_rating_scales" using primary key columns */
  eventGroupRatingScalesByPk?: Maybe<EventGroupRatingScales>;
  /** fetch data from the table: "event_group_registration_statuses" */
  eventGroupRegistrationStatuses: Array<EventGroupRegistrationStatuses>;
  /** fetch aggregated fields from the table: "event_group_registration_statuses" */
  eventGroupRegistrationStatusesAggregate: EventGroupRegistrationStatusesAggregate;
  /** fetch data from the table: "event_group_registration_statuses" using primary key columns */
  eventGroupRegistrationStatusesByPk?: Maybe<EventGroupRegistrationStatuses>;
  /** fetch data from the table: "event_group_registrations" */
  eventGroupRegistrations: Array<EventGroupRegistrations>;
  /** fetch aggregated fields from the table: "event_group_registrations" */
  eventGroupRegistrationsAggregate: EventGroupRegistrationsAggregate;
  /** fetch data from the table: "event_group_registrations" using primary key columns */
  eventGroupRegistrationsByPk?: Maybe<EventGroupRegistrations>;
  /** fetch data from the table: "event_group_sequence_seeding" */
  eventGroupSequenceSeeding: Array<EventGroupSequenceSeeding>;
  /** fetch aggregated fields from the table: "event_group_sequence_seeding" */
  eventGroupSequenceSeedingAggregate: EventGroupSequenceSeedingAggregate;
  /** fetch data from the table: "event_group_sequence_seeding" using primary key columns */
  eventGroupSequenceSeedingByPk?: Maybe<EventGroupSequenceSeeding>;
  /** fetch data from the table: "event_group_sequences" */
  eventGroupSequences: Array<EventGroupSequences>;
  /** fetch aggregated fields from the table: "event_group_sequences" */
  eventGroupSequencesAggregate: EventGroupSequencesAggregate;
  /** fetch data from the table: "event_group_sequences" using primary key columns */
  eventGroupSequencesByPk?: Maybe<EventGroupSequences>;
  /** fetch data from the table: "event_group_time_slots" */
  eventGroupTimeSlots: Array<EventGroupTimeSlots>;
  /** fetch aggregated fields from the table: "event_group_time_slots" */
  eventGroupTimeSlotsAggregate: EventGroupTimeSlotsAggregate;
  /** fetch data from the table: "event_group_time_slots" using primary key columns */
  eventGroupTimeSlotsByPk?: Maybe<EventGroupTimeSlots>;
  /** fetch data from the table: "event_groups" */
  eventGroups: Array<EventGroups>;
  /** fetch aggregated fields from the table: "event_groups" */
  eventGroupsAggregate: EventGroupsAggregate;
  /** fetch data from the table: "event_groups" using primary key columns */
  eventGroupsByPk?: Maybe<EventGroups>;
  /** fetch data from the table: "event_invitation_statuses" */
  eventInvitationStatuses: Array<EventInvitationStatuses>;
  /** fetch aggregated fields from the table: "event_invitation_statuses" */
  eventInvitationStatusesAggregate: EventInvitationStatusesAggregate;
  /** fetch data from the table: "event_invitation_statuses" using primary key columns */
  eventInvitationStatusesByPk?: Maybe<EventInvitationStatuses>;
  /** fetch data from the table: "event_invitation_types" */
  eventInvitationTypes: Array<EventInvitationTypes>;
  /** fetch aggregated fields from the table: "event_invitation_types" */
  eventInvitationTypesAggregate: EventInvitationTypesAggregate;
  /** fetch data from the table: "event_invitation_types" using primary key columns */
  eventInvitationTypesByPk?: Maybe<EventInvitationTypes>;
  /** fetch data from the table: "event_invitations" */
  eventInvitations: Array<EventInvitations>;
  /** fetch aggregated fields from the table: "event_invitations" */
  eventInvitationsAggregate: EventInvitationsAggregate;
  /** fetch data from the table: "event_invitations" using primary key columns */
  eventInvitationsByPk?: Maybe<EventInvitations>;
  /** fetch data from the table: "event_listing_fees" */
  eventListingFees: Array<EventListingFees>;
  /** fetch aggregated fields from the table: "event_listing_fees" */
  eventListingFeesAggregate: EventListingFeesAggregate;
  /** fetch data from the table: "event_listing_fees" using primary key columns */
  eventListingFeesByPk?: Maybe<EventListingFees>;
  /** fetch data from the table: "event_match_games" */
  eventMatchGames: Array<EventMatchGames>;
  /** fetch aggregated fields from the table: "event_match_games" */
  eventMatchGamesAggregate: EventMatchGamesAggregate;
  /** fetch data from the table: "event_match_games" using primary key columns */
  eventMatchGamesByPk?: Maybe<EventMatchGames>;
  /** fetch data from the table: "event_matches" */
  eventMatches: Array<EventMatches>;
  /** fetch aggregated fields from the table: "event_matches" */
  eventMatchesAggregate: EventMatchesAggregate;
  /** fetch data from the table: "event_matches" using primary key columns */
  eventMatchesByPk?: Maybe<EventMatches>;
  /** fetch data from the table: "event_matches_teams" */
  eventMatchesTeams: Array<EventMatchesTeams>;
  /** fetch aggregated fields from the table: "event_matches_teams" */
  eventMatchesTeamsAggregate: EventMatchesTeamsAggregate;
  /** fetch data from the table: "event_matches_teams" using primary key columns */
  eventMatchesTeamsByPk?: Maybe<EventMatchesTeams>;
  /** fetch data from the table: "event_organizer_account_types" */
  eventOrganizerAccountTypes: Array<EventOrganizerAccountTypes>;
  /** fetch aggregated fields from the table: "event_organizer_account_types" */
  eventOrganizerAccountTypesAggregate: EventOrganizerAccountTypesAggregate;
  /** fetch data from the table: "event_organizer_account_types" using primary key columns */
  eventOrganizerAccountTypesByPk?: Maybe<EventOrganizerAccountTypes>;
  /** fetch data from the table: "event_player_invite_statuses" */
  eventPlayerInviteStatuses: Array<EventPlayerInviteStatuses>;
  /** fetch aggregated fields from the table: "event_player_invite_statuses" */
  eventPlayerInviteStatusesAggregate: EventPlayerInviteStatusesAggregate;
  /** fetch data from the table: "event_player_invite_statuses" using primary key columns */
  eventPlayerInviteStatusesByPk?: Maybe<EventPlayerInviteStatuses>;
  /** fetch data from the table: "event_player_invites" */
  eventPlayerInvites: Array<EventPlayerInvites>;
  /** fetch aggregated fields from the table: "event_player_invites" */
  eventPlayerInvitesAggregate: EventPlayerInvitesAggregate;
  /** fetch data from the table: "event_player_invites" using primary key columns */
  eventPlayerInvitesByPk?: Maybe<EventPlayerInvites>;
  /** fetch data from the table: "event_pool_rounds" */
  eventPoolRounds: Array<EventPoolRounds>;
  /** fetch aggregated fields from the table: "event_pool_rounds" */
  eventPoolRoundsAggregate: EventPoolRoundsAggregate;
  /** fetch data from the table: "event_pool_rounds" using primary key columns */
  eventPoolRoundsByPk?: Maybe<EventPoolRounds>;
  /** fetch data from the table: "event_pools_teams" */
  eventPoolsTeams: Array<EventPoolsTeams>;
  /** fetch aggregated fields from the table: "event_pools_teams" */
  eventPoolsTeamsAggregate: EventPoolsTeamsAggregate;
  /** fetch data from the table: "event_pools_teams" using primary key columns */
  eventPoolsTeamsByPk?: Maybe<EventPoolsTeams>;
  /** fetch data from the table: "event_privacy" */
  eventPrivacy: Array<EventPrivacy>;
  /** fetch aggregated fields from the table: "event_privacy" */
  eventPrivacyAggregate: EventPrivacyAggregate;
  /** fetch data from the table: "event_privacy" using primary key columns */
  eventPrivacyByPk?: Maybe<EventPrivacy>;
  /** fetch data from the table: "event_registration_details" */
  eventRegistrationDetails: Array<EventRegistrationDetails>;
  /** fetch aggregated fields from the table: "event_registration_details" */
  eventRegistrationDetailsAggregate: EventRegistrationDetailsAggregate;
  /** fetch data from the table: "event_registration_details" using primary key columns */
  eventRegistrationDetailsByPk?: Maybe<EventRegistrationDetails>;
  /** fetch data from the table: "event_registrations" */
  eventRegistrations: Array<EventRegistrations>;
  /** fetch aggregated fields from the table: "event_registrations" */
  eventRegistrationsAggregate: EventRegistrationsAggregate;
  /** fetch data from the table: "event_registrations" using primary key columns */
  eventRegistrationsByPk?: Maybe<EventRegistrations>;
  /** fetch data from the table: "event_sequence_complete_reasons" */
  eventSequenceCompleteReasons: Array<EventSequenceCompleteReasons>;
  /** fetch aggregated fields from the table: "event_sequence_complete_reasons" */
  eventSequenceCompleteReasonsAggregate: EventSequenceCompleteReasonsAggregate;
  /** fetch data from the table: "event_sequence_complete_reasons" using primary key columns */
  eventSequenceCompleteReasonsByPk?: Maybe<EventSequenceCompleteReasons>;
  /** fetch data from the table: "event_skill_levels" */
  eventSkillLevels: Array<EventSkillLevels>;
  /** fetch aggregated fields from the table: "event_skill_levels" */
  eventSkillLevelsAggregate: EventSkillLevelsAggregate;
  /** fetch data from the table: "event_skill_levels" using primary key columns */
  eventSkillLevelsByPk?: Maybe<EventSkillLevels>;
  /** fetch data from the table: "event_sponsors" */
  eventSponsors: Array<EventSponsors>;
  /** fetch aggregated fields from the table: "event_sponsors" */
  eventSponsorsAggregate: EventSponsorsAggregate;
  /** fetch data from the table: "event_sponsors" using primary key columns */
  eventSponsorsByPk?: Maybe<EventSponsors>;
  /** fetch data from the table: "event_statuses" */
  eventStatuses: Array<EventStatuses>;
  /** fetch aggregated fields from the table: "event_statuses" */
  eventStatusesAggregate: EventStatusesAggregate;
  /** fetch data from the table: "event_statuses" using primary key columns */
  eventStatusesByPk?: Maybe<EventStatuses>;
  /** fetch data from the table: "event_team_member_statuses" */
  eventTeamMemberStatuses: Array<EventTeamMemberStatuses>;
  /** fetch aggregated fields from the table: "event_team_member_statuses" */
  eventTeamMemberStatusesAggregate: EventTeamMemberStatusesAggregate;
  /** fetch data from the table: "event_team_member_statuses" using primary key columns */
  eventTeamMemberStatusesByPk?: Maybe<EventTeamMemberStatuses>;
  /** fetch data from the table: "event_team_members" */
  eventTeamMembers: Array<EventTeamMembers>;
  /** fetch aggregated fields from the table: "event_team_members" */
  eventTeamMembersAggregate: EventTeamMembersAggregate;
  /** fetch data from the table: "event_team_members" using primary key columns */
  eventTeamMembersByPk?: Maybe<EventTeamMembers>;
  /** fetch data from the table: "event_team_statuses" */
  eventTeamStatuses: Array<EventTeamStatuses>;
  /** fetch aggregated fields from the table: "event_team_statuses" */
  eventTeamStatusesAggregate: EventTeamStatusesAggregate;
  /** fetch data from the table: "event_team_statuses" using primary key columns */
  eventTeamStatusesByPk?: Maybe<EventTeamStatuses>;
  /** fetch data from the table: "event_teams" */
  eventTeams: Array<EventTeams>;
  /** fetch aggregated fields from the table: "event_teams" */
  eventTeamsAggregate: EventTeamsAggregate;
  /** fetch data from the table: "event_teams" using primary key columns */
  eventTeamsByPk?: Maybe<EventTeams>;
  /** fetch data from the table: "event_transaction_item_types" */
  eventTransactionItemTypes: Array<EventTransactionItemTypes>;
  /** fetch aggregated fields from the table: "event_transaction_item_types" */
  eventTransactionItemTypesAggregate: EventTransactionItemTypesAggregate;
  /** fetch data from the table: "event_transaction_item_types" using primary key columns */
  eventTransactionItemTypesByPk?: Maybe<EventTransactionItemTypes>;
  /** fetch data from the table: "event_transaction_items" */
  eventTransactionItems: Array<EventTransactionItems>;
  /** fetch aggregated fields from the table: "event_transaction_items" */
  eventTransactionItemsAggregate: EventTransactionItemsAggregate;
  /** fetch data from the table: "event_transaction_items" using primary key columns */
  eventTransactionItemsByPk?: Maybe<EventTransactionItems>;
  /** fetch data from the table: "event_transactions" */
  eventTransactions: Array<EventTransactions>;
  /** fetch aggregated fields from the table: "event_transactions" */
  eventTransactionsAggregate: EventTransactionsAggregate;
  /** fetch data from the table: "event_transactions" using primary key columns */
  eventTransactionsByPk?: Maybe<EventTransactions>;
  /** fetch data from the table: "event_types" */
  eventTypes: Array<EventTypes>;
  /** fetch aggregated fields from the table: "event_types" */
  eventTypesAggregate: EventTypesAggregate;
  /** fetch data from the table: "event_types" using primary key columns */
  eventTypesByPk?: Maybe<EventTypes>;
  /** An array relationship */
  events: Array<Events>;
  /** An aggregate relationship */
  eventsAggregate: EventsAggregate;
  /** fetch data from the table: "events" using primary key columns */
  eventsByPk?: Maybe<Events>;
  /** fetch data from the table: "feedback_sentiment" */
  feedbackSentiment: Array<FeedbackSentiment>;
  /** fetch aggregated fields from the table: "feedback_sentiment" */
  feedbackSentimentAggregate: FeedbackSentimentAggregate;
  /** fetch data from the table: "feedback_sentiment" using primary key columns */
  feedbackSentimentByPk?: Maybe<FeedbackSentiment>;
  /** fetch data from the table: "file_category" */
  fileCategory: Array<FileCategory>;
  /** fetch aggregated fields from the table: "file_category" */
  fileCategoryAggregate: FileCategoryAggregate;
  /** fetch data from the table: "file_category" using primary key columns */
  fileCategoryByPk?: Maybe<FileCategory>;
  /** fetch data from the table: "file_format" */
  fileFormat: Array<FileFormat>;
  /** fetch aggregated fields from the table: "file_format" */
  fileFormatAggregate: FileFormatAggregate;
  /** fetch data from the table: "file_format" using primary key columns */
  fileFormatByPk?: Maybe<FileFormat>;
  /** fetch data from the table: "follow_statuses" */
  followStatuses: Array<FollowStatuses>;
  /** fetch aggregated fields from the table: "follow_statuses" */
  followStatusesAggregate: FollowStatusesAggregate;
  /** fetch data from the table: "follow_statuses" using primary key columns */
  followStatusesByPk?: Maybe<FollowStatuses>;
  /** fetch data from the table: "game_net_statuses" */
  gameNetStatuses: Array<GameNetStatuses>;
  /** fetch aggregated fields from the table: "game_net_statuses" */
  gameNetStatusesAggregate: GameNetStatusesAggregate;
  /** fetch data from the table: "game_net_statuses" using primary key columns */
  gameNetStatusesByPk?: Maybe<GameNetStatuses>;
  /** fetch data from the table: "gender" */
  gender: Array<Gender>;
  /** fetch aggregated fields from the table: "gender" */
  genderAggregate: GenderAggregate;
  /** fetch data from the table: "gender" using primary key columns */
  genderByPk?: Maybe<Gender>;
  /** fetch data from the table: "group_comment_votes" */
  groupCommentVotes: Array<GroupCommentVotes>;
  /** fetch aggregated fields from the table: "group_comment_votes" */
  groupCommentVotesAggregate: GroupCommentVotesAggregate;
  /** fetch data from the table: "group_comment_votes" using primary key columns */
  groupCommentVotesByPk?: Maybe<GroupCommentVotes>;
  /** fetch data from the table: "group_members" */
  groupMembers: Array<GroupMembers>;
  /** fetch aggregated fields from the table: "group_members" */
  groupMembersAggregate: GroupMembersAggregate;
  /** fetch data from the table: "group_members" using primary key columns */
  groupMembersByPk?: Maybe<GroupMembers>;
  /** fetch data from the table: "group_thread_comment_files" */
  groupThreadCommentFiles: Array<GroupThreadCommentFiles>;
  /** fetch aggregated fields from the table: "group_thread_comment_files" */
  groupThreadCommentFilesAggregate: GroupThreadCommentFilesAggregate;
  /** fetch data from the table: "group_thread_comment_files" using primary key columns */
  groupThreadCommentFilesByPk?: Maybe<GroupThreadCommentFiles>;
  /** fetch data from the table: "group_thread_comments" */
  groupThreadComments: Array<GroupThreadComments>;
  /** fetch aggregated fields from the table: "group_thread_comments" */
  groupThreadCommentsAggregate: GroupThreadCommentsAggregate;
  /** fetch data from the table: "group_thread_comments" using primary key columns */
  groupThreadCommentsByPk?: Maybe<GroupThreadComments>;
  /** fetch data from the table: "group_threads" */
  groupThreads: Array<GroupThreads>;
  /** fetch aggregated fields from the table: "group_threads" */
  groupThreadsAggregate: GroupThreadsAggregate;
  /** fetch data from the table: "group_threads" using primary key columns */
  groupThreadsByPk?: Maybe<GroupThreads>;
  /** fetch data from the table: "group_types" */
  groupTypes: Array<GroupTypes>;
  /** fetch aggregated fields from the table: "group_types" */
  groupTypesAggregate: GroupTypesAggregate;
  /** fetch data from the table: "group_types" using primary key columns */
  groupTypesByPk?: Maybe<GroupTypes>;
  /** fetch data from the table: "group_venues" */
  groupVenues: Array<GroupVenues>;
  /** fetch aggregated fields from the table: "group_venues" */
  groupVenuesAggregate: GroupVenuesAggregate;
  /** fetch data from the table: "group_venues" using primary key columns */
  groupVenuesByPk?: Maybe<GroupVenues>;
  /** An array relationship */
  groups: Array<Groups>;
  /** An aggregate relationship */
  groupsAggregate: GroupsAggregate;
  /** fetch data from the table: "groups" using primary key columns */
  groupsByPk?: Maybe<Groups>;
  /** An array relationship */
  groupsPlaySessions: Array<GroupsPlaySessions>;
  /** An aggregate relationship */
  groupsPlaySessionsAggregate: GroupsPlaySessionsAggregate;
  /** fetch data from the table: "groups_play_sessions" using primary key columns */
  groupsPlaySessionsByPk?: Maybe<GroupsPlaySessions>;
  /** fetch data from the table: "identity_verification_providers" */
  identityVerificationProviders: Array<IdentityVerificationProviders>;
  /** fetch aggregated fields from the table: "identity_verification_providers" */
  identityVerificationProvidersAggregate: IdentityVerificationProvidersAggregate;
  /** fetch data from the table: "identity_verification_providers" using primary key columns */
  identityVerificationProvidersByPk?: Maybe<IdentityVerificationProviders>;
  /** fetch data from the table: "identity_verification_statuses" */
  identityVerificationStatuses: Array<IdentityVerificationStatuses>;
  /** fetch aggregated fields from the table: "identity_verification_statuses" */
  identityVerificationStatusesAggregate: IdentityVerificationStatusesAggregate;
  /** fetch data from the table: "identity_verification_statuses" using primary key columns */
  identityVerificationStatusesByPk?: Maybe<IdentityVerificationStatuses>;
  /** An array relationship */
  invoices: Array<Invoices>;
  /** An aggregate relationship */
  invoicesAggregate: InvoicesAggregate;
  /** fetch data from the table: "invoices" using primary key columns */
  invoicesByPk?: Maybe<Invoices>;
  /** fetch data from the table: "learning_program_enrollment_schedule_media_watched" */
  learningProgramEnrollmentScheduleMediaWatched: Array<LearningProgramEnrollmentScheduleMediaWatched>;
  /** fetch aggregated fields from the table: "learning_program_enrollment_schedule_media_watched" */
  learningProgramEnrollmentScheduleMediaWatchedAggregate: LearningProgramEnrollmentScheduleMediaWatchedAggregate;
  /** fetch data from the table: "learning_program_enrollment_schedule_media_watched" using primary key columns */
  learningProgramEnrollmentScheduleMediaWatchedByPk?: Maybe<LearningProgramEnrollmentScheduleMediaWatched>;
  /** fetch data from the table: "learning_program_enrollment_schedule_progress" */
  learningProgramEnrollmentScheduleProgress: Array<LearningProgramEnrollmentScheduleProgress>;
  /** fetch aggregated fields from the table: "learning_program_enrollment_schedule_progress" */
  learningProgramEnrollmentScheduleProgressAggregate: LearningProgramEnrollmentScheduleProgressAggregate;
  /** fetch data from the table: "learning_program_enrollment_schedule_progress" using primary key columns */
  learningProgramEnrollmentScheduleProgressByPk?: Maybe<LearningProgramEnrollmentScheduleProgress>;
  /** fetch data from the table: "learning_program_enrollments" */
  learningProgramEnrollments: Array<LearningProgramEnrollments>;
  /** fetch aggregated fields from the table: "learning_program_enrollments" */
  learningProgramEnrollmentsAggregate: LearningProgramEnrollmentsAggregate;
  /** fetch data from the table: "learning_program_enrollments" using primary key columns */
  learningProgramEnrollmentsByPk?: Maybe<LearningProgramEnrollments>;
  /** fetch data from the table: "learning_program_media" */
  learningProgramMedia: Array<LearningProgramMedia>;
  /** fetch aggregated fields from the table: "learning_program_media" */
  learningProgramMediaAggregate: LearningProgramMediaAggregate;
  /** fetch data from the table: "learning_program_media" using primary key columns */
  learningProgramMediaByPk?: Maybe<LearningProgramMedia>;
  /** fetch data from the table: "learning_program_media_categories" */
  learningProgramMediaCategories: Array<LearningProgramMediaCategories>;
  /** fetch aggregated fields from the table: "learning_program_media_categories" */
  learningProgramMediaCategoriesAggregate: LearningProgramMediaCategoriesAggregate;
  /** fetch data from the table: "learning_program_media_categories" using primary key columns */
  learningProgramMediaCategoriesByPk?: Maybe<LearningProgramMediaCategories>;
  /** fetch data from the table: "learning_program_schedule_media" */
  learningProgramScheduleMedia: Array<LearningProgramScheduleMedia>;
  /** fetch aggregated fields from the table: "learning_program_schedule_media" */
  learningProgramScheduleMediaAggregate: LearningProgramScheduleMediaAggregate;
  /** fetch data from the table: "learning_program_schedule_media" using primary key columns */
  learningProgramScheduleMediaByPk?: Maybe<LearningProgramScheduleMedia>;
  /** fetch data from the table: "learning_program_schedule_units" */
  learningProgramScheduleUnits: Array<LearningProgramScheduleUnits>;
  /** fetch aggregated fields from the table: "learning_program_schedule_units" */
  learningProgramScheduleUnitsAggregate: LearningProgramScheduleUnitsAggregate;
  /** fetch data from the table: "learning_program_schedule_units" using primary key columns */
  learningProgramScheduleUnitsByPk?: Maybe<LearningProgramScheduleUnits>;
  /** fetch data from the table: "learning_program_schedule_video_submissions" */
  learningProgramScheduleVideoSubmissions: Array<LearningProgramScheduleVideoSubmissions>;
  /** fetch aggregated fields from the table: "learning_program_schedule_video_submissions" */
  learningProgramScheduleVideoSubmissionsAggregate: LearningProgramScheduleVideoSubmissionsAggregate;
  /** fetch data from the table: "learning_program_schedule_video_submissions" using primary key columns */
  learningProgramScheduleVideoSubmissionsByPk?: Maybe<LearningProgramScheduleVideoSubmissions>;
  /** fetch data from the table: "learning_program_schedules" */
  learningProgramSchedules: Array<LearningProgramSchedules>;
  /** fetch aggregated fields from the table: "learning_program_schedules" */
  learningProgramSchedulesAggregate: LearningProgramSchedulesAggregate;
  /** fetch data from the table: "learning_program_schedules" using primary key columns */
  learningProgramSchedulesByPk?: Maybe<LearningProgramSchedules>;
  /** fetch data from the table: "learning_program_skill_level_values" */
  learningProgramSkillLevelValues: Array<LearningProgramSkillLevelValues>;
  /** fetch aggregated fields from the table: "learning_program_skill_level_values" */
  learningProgramSkillLevelValuesAggregate: LearningProgramSkillLevelValuesAggregate;
  /** fetch data from the table: "learning_program_skill_level_values" using primary key columns */
  learningProgramSkillLevelValuesByPk?: Maybe<LearningProgramSkillLevelValues>;
  /** fetch data from the table: "learning_program_skills" */
  learningProgramSkills: Array<LearningProgramSkills>;
  /** fetch aggregated fields from the table: "learning_program_skills" */
  learningProgramSkillsAggregate: LearningProgramSkillsAggregate;
  /** fetch data from the table: "learning_program_skills" using primary key columns */
  learningProgramSkillsByPk?: Maybe<LearningProgramSkills>;
  /** fetch data from the table: "learning_programs" */
  learningPrograms: Array<LearningPrograms>;
  /** fetch aggregated fields from the table: "learning_programs" */
  learningProgramsAggregate: LearningProgramsAggregate;
  /** fetch data from the table: "learning_programs" using primary key columns */
  learningProgramsByPk?: Maybe<LearningPrograms>;
  /** fetch data from the table: "lesson_age_groups" */
  lessonAgeGroups: Array<LessonAgeGroups>;
  /** fetch aggregated fields from the table: "lesson_age_groups" */
  lessonAgeGroupsAggregate: LessonAgeGroupsAggregate;
  /** fetch data from the table: "lesson_age_groups" using primary key columns */
  lessonAgeGroupsByPk?: Maybe<LessonAgeGroups>;
  /** fetch data from the table: "lesson_collections" */
  lessonCollections: Array<LessonCollections>;
  /** fetch aggregated fields from the table: "lesson_collections" */
  lessonCollectionsAggregate: LessonCollectionsAggregate;
  /** fetch data from the table: "lesson_collections" using primary key columns */
  lessonCollectionsByPk?: Maybe<LessonCollections>;
  /** fetch data from the table: "lesson_equipment" */
  lessonEquipment: Array<LessonEquipment>;
  /** fetch aggregated fields from the table: "lesson_equipment" */
  lessonEquipmentAggregate: LessonEquipmentAggregate;
  /** fetch data from the table: "lesson_equipment" using primary key columns */
  lessonEquipmentByPk?: Maybe<LessonEquipment>;
  /** fetch data from the table: "lesson_equipment_options" */
  lessonEquipmentOptions: Array<LessonEquipmentOptions>;
  /** fetch aggregated fields from the table: "lesson_equipment_options" */
  lessonEquipmentOptionsAggregate: LessonEquipmentOptionsAggregate;
  /** fetch data from the table: "lesson_equipment_options" using primary key columns */
  lessonEquipmentOptionsByPk?: Maybe<LessonEquipmentOptions>;
  /** fetch data from the table: "lesson_order_items" */
  lessonOrderItems: Array<LessonOrderItems>;
  /** fetch aggregated fields from the table: "lesson_order_items" */
  lessonOrderItemsAggregate: LessonOrderItemsAggregate;
  /** fetch data from the table: "lesson_order_items" using primary key columns */
  lessonOrderItemsByPk?: Maybe<LessonOrderItems>;
  /** fetch data from the table: "lesson_orders" */
  lessonOrders: Array<LessonOrders>;
  /** fetch aggregated fields from the table: "lesson_orders" */
  lessonOrdersAggregate: LessonOrdersAggregate;
  /** fetch data from the table: "lesson_orders" using primary key columns */
  lessonOrdersByPk?: Maybe<LessonOrders>;
  /** fetch data from the table: "lesson_participant_statuses" */
  lessonParticipantStatuses: Array<LessonParticipantStatuses>;
  /** fetch aggregated fields from the table: "lesson_participant_statuses" */
  lessonParticipantStatusesAggregate: LessonParticipantStatusesAggregate;
  /** fetch data from the table: "lesson_participant_statuses" using primary key columns */
  lessonParticipantStatusesByPk?: Maybe<LessonParticipantStatuses>;
  /** fetch data from the table: "lesson_participants" */
  lessonParticipants: Array<LessonParticipants>;
  /** fetch aggregated fields from the table: "lesson_participants" */
  lessonParticipantsAggregate: LessonParticipantsAggregate;
  /** fetch data from the table: "lesson_participants" using primary key columns */
  lessonParticipantsByPk?: Maybe<LessonParticipants>;
  /** fetch data from the table: "lesson_player_skill_assessment_categories" */
  lessonPlayerSkillAssessmentCategories: Array<LessonPlayerSkillAssessmentCategories>;
  /** fetch aggregated fields from the table: "lesson_player_skill_assessment_categories" */
  lessonPlayerSkillAssessmentCategoriesAggregate: LessonPlayerSkillAssessmentCategoriesAggregate;
  /** fetch data from the table: "lesson_player_skill_assessment_categories" using primary key columns */
  lessonPlayerSkillAssessmentCategoriesByPk?: Maybe<LessonPlayerSkillAssessmentCategories>;
  /** An array relationship */
  lessonPlayerSkillAssessments: Array<LessonPlayerSkillAssessments>;
  /** An aggregate relationship */
  lessonPlayerSkillAssessmentsAggregate: LessonPlayerSkillAssessmentsAggregate;
  /** fetch data from the table: "lesson_player_skill_assessments" using primary key columns */
  lessonPlayerSkillAssessmentsByPk?: Maybe<LessonPlayerSkillAssessments>;
  /** An array relationship */
  lessonPlayerSkillAssessmentsSkills: Array<LessonPlayerSkillAssessmentsSkills>;
  /** An aggregate relationship */
  lessonPlayerSkillAssessmentsSkillsAggregate: LessonPlayerSkillAssessmentsSkillsAggregate;
  /** fetch data from the table: "lesson_player_skill_assessments_skills" using primary key columns */
  lessonPlayerSkillAssessmentsSkillsByPk?: Maybe<LessonPlayerSkillAssessmentsSkills>;
  /** fetch data from the table: "lesson_privacy" */
  lessonPrivacy: Array<LessonPrivacy>;
  /** fetch aggregated fields from the table: "lesson_privacy" */
  lessonPrivacyAggregate: LessonPrivacyAggregate;
  /** fetch data from the table: "lesson_privacy" using primary key columns */
  lessonPrivacyByPk?: Maybe<LessonPrivacy>;
  /** fetch data from the table: "lesson_reflection_comment_types" */
  lessonReflectionCommentTypes: Array<LessonReflectionCommentTypes>;
  /** fetch aggregated fields from the table: "lesson_reflection_comment_types" */
  lessonReflectionCommentTypesAggregate: LessonReflectionCommentTypesAggregate;
  /** fetch data from the table: "lesson_reflection_comment_types" using primary key columns */
  lessonReflectionCommentTypesByPk?: Maybe<LessonReflectionCommentTypes>;
  /** An array relationship */
  lessonReflectionComments: Array<LessonReflectionComments>;
  /** An aggregate relationship */
  lessonReflectionCommentsAggregate: LessonReflectionCommentsAggregate;
  /** fetch data from the table: "lesson_reflection_comments" using primary key columns */
  lessonReflectionCommentsByPk?: Maybe<LessonReflectionComments>;
  /** An array relationship */
  lessonReflectionFiles: Array<LessonReflectionFiles>;
  /** An aggregate relationship */
  lessonReflectionFilesAggregate: LessonReflectionFilesAggregate;
  /** fetch data from the table: "lesson_reflection_files" using primary key columns */
  lessonReflectionFilesByPk?: Maybe<LessonReflectionFiles>;
  /** An array relationship */
  lessonReflections: Array<LessonReflections>;
  /** An aggregate relationship */
  lessonReflectionsAggregate: LessonReflectionsAggregate;
  /** fetch data from the table: "lesson_reflections" using primary key columns */
  lessonReflectionsByPk?: Maybe<LessonReflections>;
  /** fetch data from the table: "lesson_skill_categories" */
  lessonSkillCategories: Array<LessonSkillCategories>;
  /** fetch aggregated fields from the table: "lesson_skill_categories" */
  lessonSkillCategoriesAggregate: LessonSkillCategoriesAggregate;
  /** fetch data from the table: "lesson_skill_categories" using primary key columns */
  lessonSkillCategoriesByPk?: Maybe<LessonSkillCategories>;
  /** fetch data from the table: "lesson_skill_display_names" */
  lessonSkillDisplayNames: Array<LessonSkillDisplayNames>;
  /** fetch aggregated fields from the table: "lesson_skill_display_names" */
  lessonSkillDisplayNamesAggregate: LessonSkillDisplayNamesAggregate;
  /** fetch data from the table: "lesson_skill_display_names" using primary key columns */
  lessonSkillDisplayNamesByPk?: Maybe<LessonSkillDisplayNames>;
  /** fetch data from the table: "lesson_skill_levels" */
  lessonSkillLevels: Array<LessonSkillLevels>;
  /** fetch aggregated fields from the table: "lesson_skill_levels" */
  lessonSkillLevelsAggregate: LessonSkillLevelsAggregate;
  /** fetch data from the table: "lesson_skill_levels" using primary key columns */
  lessonSkillLevelsByPk?: Maybe<LessonSkillLevels>;
  /** fetch data from the table: "lesson_skill_mappings" */
  lessonSkillMappings: Array<LessonSkillMappings>;
  /** fetch aggregated fields from the table: "lesson_skill_mappings" */
  lessonSkillMappingsAggregate: LessonSkillMappingsAggregate;
  /** fetch data from the table: "lesson_skill_mappings" using primary key columns */
  lessonSkillMappingsByPk?: Maybe<LessonSkillMappings>;
  /** fetch data from the table: "lesson_skills" */
  lessonSkills: Array<LessonSkills>;
  /** fetch aggregated fields from the table: "lesson_skills" */
  lessonSkillsAggregate: LessonSkillsAggregate;
  /** fetch data from the table: "lesson_skills" using primary key columns */
  lessonSkillsByPk?: Maybe<LessonSkills>;
  /** fetch data from the table: "lesson_statuses" */
  lessonStatuses: Array<LessonStatuses>;
  /** fetch aggregated fields from the table: "lesson_statuses" */
  lessonStatusesAggregate: LessonStatusesAggregate;
  /** fetch data from the table: "lesson_statuses" using primary key columns */
  lessonStatusesByPk?: Maybe<LessonStatuses>;
  /** fetch data from the table: "lesson_template_skill_levels" */
  lessonTemplateSkillLevels: Array<LessonTemplateSkillLevels>;
  /** fetch aggregated fields from the table: "lesson_template_skill_levels" */
  lessonTemplateSkillLevelsAggregate: LessonTemplateSkillLevelsAggregate;
  /** fetch data from the table: "lesson_template_skill_levels" using primary key columns */
  lessonTemplateSkillLevelsByPk?: Maybe<LessonTemplateSkillLevels>;
  /** An array relationship */
  lessonTemplates: Array<LessonTemplates>;
  /** An aggregate relationship */
  lessonTemplatesAggregate: LessonTemplatesAggregate;
  /** fetch data from the table: "lesson_templates" using primary key columns */
  lessonTemplatesByPk?: Maybe<LessonTemplates>;
  /** fetch data from the table: "lesson_times" */
  lessonTimes: Array<LessonTimes>;
  /** fetch aggregated fields from the table: "lesson_times" */
  lessonTimesAggregate: LessonTimesAggregate;
  /** fetch data from the table: "lesson_times" using primary key columns */
  lessonTimesByPk?: Maybe<LessonTimes>;
  /** fetch data from the table: "lesson_types" */
  lessonTypes: Array<LessonTypes>;
  /** fetch aggregated fields from the table: "lesson_types" */
  lessonTypesAggregate: LessonTypesAggregate;
  /** fetch data from the table: "lesson_types" using primary key columns */
  lessonTypesByPk?: Maybe<LessonTypes>;
  /** fetch data from the table: "lesson_waitlist_statuses" */
  lessonWaitlistStatuses: Array<LessonWaitlistStatuses>;
  /** fetch aggregated fields from the table: "lesson_waitlist_statuses" */
  lessonWaitlistStatusesAggregate: LessonWaitlistStatusesAggregate;
  /** fetch data from the table: "lesson_waitlist_statuses" using primary key columns */
  lessonWaitlistStatusesByPk?: Maybe<LessonWaitlistStatuses>;
  /** fetch data from the table: "lesson_waitlists" */
  lessonWaitlists: Array<LessonWaitlists>;
  /** fetch aggregated fields from the table: "lesson_waitlists" */
  lessonWaitlistsAggregate: LessonWaitlistsAggregate;
  /** fetch data from the table: "lesson_waitlists" using primary key columns */
  lessonWaitlistsByPk?: Maybe<LessonWaitlists>;
  /** An array relationship */
  lessons: Array<Lessons>;
  /** An aggregate relationship */
  lessonsAggregate: LessonsAggregate;
  /** fetch data from the table: "lessons" using primary key columns */
  lessonsByPk?: Maybe<Lessons>;
  /** fetch data from the table: "match_selection_criteria" */
  matchSelectionCriteria: Array<MatchSelectionCriteria>;
  /** fetch aggregated fields from the table: "match_selection_criteria" */
  matchSelectionCriteriaAggregate: MatchSelectionCriteriaAggregate;
  /** fetch data from the table: "match_selection_criteria" using primary key columns */
  matchSelectionCriteriaByPk?: Maybe<MatchSelectionCriteria>;
  /** An array relationship */
  messages: Array<Messages>;
  /** An aggregate relationship */
  messagesAggregate: MessagesAggregate;
  /** fetch data from the table: "messages" using primary key columns */
  messagesByPk?: Maybe<Messages>;
  /** fetch data from the table: "neighborhoods" */
  neighborhoods: Array<Neighborhoods>;
  /** fetch aggregated fields from the table: "neighborhoods" */
  neighborhoodsAggregate: NeighborhoodsAggregate;
  /** fetch data from the table: "neighborhoods" using primary key columns */
  neighborhoodsByPk?: Maybe<Neighborhoods>;
  /** fetch data from the table: "notification_action_types" */
  notificationActionTypes: Array<NotificationActionTypes>;
  /** fetch aggregated fields from the table: "notification_action_types" */
  notificationActionTypesAggregate: NotificationActionTypesAggregate;
  /** fetch data from the table: "notification_action_types" using primary key columns */
  notificationActionTypesByPk?: Maybe<NotificationActionTypes>;
  /** fetch data from the table: "notification_statuses" */
  notificationStatuses: Array<NotificationStatuses>;
  /** fetch aggregated fields from the table: "notification_statuses" */
  notificationStatusesAggregate: NotificationStatusesAggregate;
  /** fetch data from the table: "notification_statuses" using primary key columns */
  notificationStatusesByPk?: Maybe<NotificationStatuses>;
  /** fetch data from the table: "order_statuses" */
  orderStatuses: Array<OrderStatuses>;
  /** fetch aggregated fields from the table: "order_statuses" */
  orderStatusesAggregate: OrderStatusesAggregate;
  /** fetch data from the table: "order_statuses" using primary key columns */
  orderStatusesByPk?: Maybe<OrderStatuses>;
  /** fetch data from the table: "padel_rating_scales" */
  padelRatingScales: Array<PadelRatingScales>;
  /** fetch aggregated fields from the table: "padel_rating_scales" */
  padelRatingScalesAggregate: PadelRatingScalesAggregate;
  /** fetch data from the table: "padel_rating_scales" using primary key columns */
  padelRatingScalesByPk?: Maybe<PadelRatingScales>;
  /** fetch data from the table: "participant_roles" */
  participantRoles: Array<ParticipantRoles>;
  /** fetch aggregated fields from the table: "participant_roles" */
  participantRolesAggregate: ParticipantRolesAggregate;
  /** fetch data from the table: "participant_roles" using primary key columns */
  participantRolesByPk?: Maybe<ParticipantRoles>;
  /** fetch data from the table: "partner_booking_attempt_events" */
  partnerBookingAttemptEvents: Array<PartnerBookingAttemptEvents>;
  /** fetch aggregated fields from the table: "partner_booking_attempt_events" */
  partnerBookingAttemptEventsAggregate: PartnerBookingAttemptEventsAggregate;
  /** fetch data from the table: "partner_booking_attempt_events" using primary key columns */
  partnerBookingAttemptEventsByPk?: Maybe<PartnerBookingAttemptEvents>;
  /** fetch data from the table: "partner_booking_attempt_statuses" */
  partnerBookingAttemptStatuses: Array<PartnerBookingAttemptStatuses>;
  /** fetch aggregated fields from the table: "partner_booking_attempt_statuses" */
  partnerBookingAttemptStatusesAggregate: PartnerBookingAttemptStatusesAggregate;
  /** fetch data from the table: "partner_booking_attempt_statuses" using primary key columns */
  partnerBookingAttemptStatusesByPk?: Maybe<PartnerBookingAttemptStatuses>;
  /** fetch data from the table: "partner_booking_attempts" */
  partnerBookingAttempts: Array<PartnerBookingAttempts>;
  /** fetch aggregated fields from the table: "partner_booking_attempts" */
  partnerBookingAttemptsAggregate: PartnerBookingAttemptsAggregate;
  /** fetch data from the table: "partner_booking_attempts" using primary key columns */
  partnerBookingAttemptsByPk?: Maybe<PartnerBookingAttempts>;
  /** fetch data from the table: "partner_booking_engines" */
  partnerBookingEngines: Array<PartnerBookingEngines>;
  /** fetch aggregated fields from the table: "partner_booking_engines" */
  partnerBookingEnginesAggregate: PartnerBookingEnginesAggregate;
  /** fetch data from the table: "partner_booking_engines" using primary key columns */
  partnerBookingEnginesByPk?: Maybe<PartnerBookingEngines>;
  /** fetch data from the table: "partner_booking_event_sources" */
  partnerBookingEventSources: Array<PartnerBookingEventSources>;
  /** fetch aggregated fields from the table: "partner_booking_event_sources" */
  partnerBookingEventSourcesAggregate: PartnerBookingEventSourcesAggregate;
  /** fetch data from the table: "partner_booking_event_sources" using primary key columns */
  partnerBookingEventSourcesByPk?: Maybe<PartnerBookingEventSources>;
  /** fetch data from the table: "partner_booking_holds" */
  partnerBookingHolds: Array<PartnerBookingHolds>;
  /** fetch aggregated fields from the table: "partner_booking_holds" */
  partnerBookingHoldsAggregate: PartnerBookingHoldsAggregate;
  /** fetch data from the table: "partner_booking_holds" using primary key columns */
  partnerBookingHoldsByPk?: Maybe<PartnerBookingHolds>;
  /** fetch data from the table: "partner_booking_order_statuses" */
  partnerBookingOrderStatuses: Array<PartnerBookingOrderStatuses>;
  /** fetch aggregated fields from the table: "partner_booking_order_statuses" */
  partnerBookingOrderStatusesAggregate: PartnerBookingOrderStatusesAggregate;
  /** fetch data from the table: "partner_booking_order_statuses" using primary key columns */
  partnerBookingOrderStatusesByPk?: Maybe<PartnerBookingOrderStatuses>;
  /** fetch data from the table: "partner_booking_orders" */
  partnerBookingOrders: Array<PartnerBookingOrders>;
  /** fetch aggregated fields from the table: "partner_booking_orders" */
  partnerBookingOrdersAggregate: PartnerBookingOrdersAggregate;
  /** fetch data from the table: "partner_booking_orders" using primary key columns */
  partnerBookingOrdersByPk?: Maybe<PartnerBookingOrders>;
  /** fetch data from the table: "partner_booking_verification_methods" */
  partnerBookingVerificationMethods: Array<PartnerBookingVerificationMethods>;
  /** fetch aggregated fields from the table: "partner_booking_verification_methods" */
  partnerBookingVerificationMethodsAggregate: PartnerBookingVerificationMethodsAggregate;
  /** fetch data from the table: "partner_booking_verification_methods" using primary key columns */
  partnerBookingVerificationMethodsByPk?: Maybe<PartnerBookingVerificationMethods>;
  /** fetch data from the table: "payment_fulfillment_channels" */
  paymentFulfillmentChannels: Array<PaymentFulfillmentChannels>;
  /** fetch aggregated fields from the table: "payment_fulfillment_channels" */
  paymentFulfillmentChannelsAggregate: PaymentFulfillmentChannelsAggregate;
  /** fetch data from the table: "payment_fulfillment_channels" using primary key columns */
  paymentFulfillmentChannelsByPk?: Maybe<PaymentFulfillmentChannels>;
  /** fetch data from the table: "payment_processors" */
  paymentProcessors: Array<PaymentProcessors>;
  /** fetch aggregated fields from the table: "payment_processors" */
  paymentProcessorsAggregate: PaymentProcessorsAggregate;
  /** fetch data from the table: "payment_processors" using primary key columns */
  paymentProcessorsByPk?: Maybe<PaymentProcessors>;
  /** fetch data from the table: "payment_statuses" */
  paymentStatuses: Array<PaymentStatuses>;
  /** fetch aggregated fields from the table: "payment_statuses" */
  paymentStatusesAggregate: PaymentStatusesAggregate;
  /** fetch data from the table: "payment_statuses" using primary key columns */
  paymentStatusesByPk?: Maybe<PaymentStatuses>;
  /** fetch data from the table: "pickleball_rating_scales" */
  pickleballRatingScales: Array<PickleballRatingScales>;
  /** fetch aggregated fields from the table: "pickleball_rating_scales" */
  pickleballRatingScalesAggregate: PickleballRatingScalesAggregate;
  /** fetch data from the table: "pickleball_rating_scales" using primary key columns */
  pickleballRatingScalesByPk?: Maybe<PickleballRatingScales>;
  /** fetch data from the table: "platform_subscription_intervals" */
  platformSubscriptionIntervals: Array<PlatformSubscriptionIntervals>;
  /** fetch aggregated fields from the table: "platform_subscription_intervals" */
  platformSubscriptionIntervalsAggregate: PlatformSubscriptionIntervalsAggregate;
  /** fetch data from the table: "platform_subscription_intervals" using primary key columns */
  platformSubscriptionIntervalsByPk?: Maybe<PlatformSubscriptionIntervals>;
  /** fetch data from the table: "platform_subscription_personas" */
  platformSubscriptionPersonas: Array<PlatformSubscriptionPersonas>;
  /** fetch aggregated fields from the table: "platform_subscription_personas" */
  platformSubscriptionPersonasAggregate: PlatformSubscriptionPersonasAggregate;
  /** fetch data from the table: "platform_subscription_personas" using primary key columns */
  platformSubscriptionPersonasByPk?: Maybe<PlatformSubscriptionPersonas>;
  /** fetch data from the table: "platform_subscription_plan_prices" */
  platformSubscriptionPlanPrices: Array<PlatformSubscriptionPlanPrices>;
  /** fetch aggregated fields from the table: "platform_subscription_plan_prices" */
  platformSubscriptionPlanPricesAggregate: PlatformSubscriptionPlanPricesAggregate;
  /** fetch data from the table: "platform_subscription_plan_prices" using primary key columns */
  platformSubscriptionPlanPricesByPk?: Maybe<PlatformSubscriptionPlanPrices>;
  /** fetch data from the table: "platform_subscription_plans" */
  platformSubscriptionPlans: Array<PlatformSubscriptionPlans>;
  /** fetch aggregated fields from the table: "platform_subscription_plans" */
  platformSubscriptionPlansAggregate: PlatformSubscriptionPlansAggregate;
  /** fetch data from the table: "platform_subscription_plans" using primary key columns */
  platformSubscriptionPlansByPk?: Maybe<PlatformSubscriptionPlans>;
  /** An array relationship */
  platformSubscriptions: Array<PlatformSubscriptions>;
  /** An aggregate relationship */
  platformSubscriptionsAggregate: PlatformSubscriptionsAggregate;
  /** fetch data from the table: "platform_subscriptions" using primary key columns */
  platformSubscriptionsByPk?: Maybe<PlatformSubscriptions>;
  /** fetch data from the table: "play_request_neighborhoods" */
  playRequestNeighborhoods: Array<PlayRequestNeighborhoods>;
  /** fetch aggregated fields from the table: "play_request_neighborhoods" */
  playRequestNeighborhoodsAggregate: PlayRequestNeighborhoodsAggregate;
  /** fetch data from the table: "play_request_neighborhoods" using primary key columns */
  playRequestNeighborhoodsByPk?: Maybe<PlayRequestNeighborhoods>;
  /** fetch data from the table: "play_request_slots" */
  playRequestSlots: Array<PlayRequestSlots>;
  /** fetch aggregated fields from the table: "play_request_slots" */
  playRequestSlotsAggregate: PlayRequestSlotsAggregate;
  /** fetch data from the table: "play_request_slots" using primary key columns */
  playRequestSlotsByPk?: Maybe<PlayRequestSlots>;
  /** fetch data from the table: "play_request_statuses" */
  playRequestStatuses: Array<PlayRequestStatuses>;
  /** fetch aggregated fields from the table: "play_request_statuses" */
  playRequestStatusesAggregate: PlayRequestStatusesAggregate;
  /** fetch data from the table: "play_request_statuses" using primary key columns */
  playRequestStatusesByPk?: Maybe<PlayRequestStatuses>;
  /** fetch data from the table: "play_request_venues" */
  playRequestVenues: Array<PlayRequestVenues>;
  /** fetch aggregated fields from the table: "play_request_venues" */
  playRequestVenuesAggregate: PlayRequestVenuesAggregate;
  /** fetch data from the table: "play_request_venues" using primary key columns */
  playRequestVenuesByPk?: Maybe<PlayRequestVenues>;
  /** An array relationship */
  playRequests: Array<PlayRequests>;
  /** An aggregate relationship */
  playRequestsAggregate: PlayRequestsAggregate;
  /** fetch data from the table: "play_requests" using primary key columns */
  playRequestsByPk?: Maybe<PlayRequests>;
  /** fetch data from the table: "play_session_comments" */
  playSessionComments: Array<PlaySessionComments>;
  /** fetch aggregated fields from the table: "play_session_comments" */
  playSessionCommentsAggregate: PlaySessionCommentsAggregate;
  /** fetch data from the table: "play_session_comments" using primary key columns */
  playSessionCommentsByPk?: Maybe<PlaySessionComments>;
  /** fetch data from the table: "play_session_court_booking_statuses" */
  playSessionCourtBookingStatuses: Array<PlaySessionCourtBookingStatuses>;
  /** fetch aggregated fields from the table: "play_session_court_booking_statuses" */
  playSessionCourtBookingStatusesAggregate: PlaySessionCourtBookingStatusesAggregate;
  /** fetch data from the table: "play_session_court_booking_statuses" using primary key columns */
  playSessionCourtBookingStatusesByPk?: Maybe<PlaySessionCourtBookingStatuses>;
  /** fetch data from the table: "play_session_formats" */
  playSessionFormats: Array<PlaySessionFormats>;
  /** fetch aggregated fields from the table: "play_session_formats" */
  playSessionFormatsAggregate: PlaySessionFormatsAggregate;
  /** fetch data from the table: "play_session_formats" using primary key columns */
  playSessionFormatsByPk?: Maybe<PlaySessionFormats>;
  /** fetch data from the table: "play_session_match_competitiveness" */
  playSessionMatchCompetitiveness: Array<PlaySessionMatchCompetitiveness>;
  /** fetch aggregated fields from the table: "play_session_match_competitiveness" */
  playSessionMatchCompetitivenessAggregate: PlaySessionMatchCompetitivenessAggregate;
  /** fetch data from the table: "play_session_match_competitiveness" using primary key columns */
  playSessionMatchCompetitivenessByPk?: Maybe<PlaySessionMatchCompetitiveness>;
  /** fetch data from the table: "play_session_participant_statuses" */
  playSessionParticipantStatuses: Array<PlaySessionParticipantStatuses>;
  /** fetch aggregated fields from the table: "play_session_participant_statuses" */
  playSessionParticipantStatusesAggregate: PlaySessionParticipantStatusesAggregate;
  /** fetch data from the table: "play_session_participant_statuses" using primary key columns */
  playSessionParticipantStatusesByPk?: Maybe<PlaySessionParticipantStatuses>;
  /** fetch data from the table: "play_session_participants" */
  playSessionParticipants: Array<PlaySessionParticipants>;
  /** fetch aggregated fields from the table: "play_session_participants" */
  playSessionParticipantsAggregate: PlaySessionParticipantsAggregate;
  /** fetch data from the table: "play_session_participants" using primary key columns */
  playSessionParticipantsByPk?: Maybe<PlaySessionParticipants>;
  /** fetch data from the table: "play_session_privacy" */
  playSessionPrivacy: Array<PlaySessionPrivacy>;
  /** fetch aggregated fields from the table: "play_session_privacy" */
  playSessionPrivacyAggregate: PlaySessionPrivacyAggregate;
  /** fetch data from the table: "play_session_privacy" using primary key columns */
  playSessionPrivacyByPk?: Maybe<PlaySessionPrivacy>;
  /** fetch data from the table: "play_session_statuses" */
  playSessionStatuses: Array<PlaySessionStatuses>;
  /** fetch aggregated fields from the table: "play_session_statuses" */
  playSessionStatusesAggregate: PlaySessionStatusesAggregate;
  /** fetch data from the table: "play_session_statuses" using primary key columns */
  playSessionStatusesByPk?: Maybe<PlaySessionStatuses>;
  /** An array relationship */
  playSessions: Array<PlaySessions>;
  /** An aggregate relationship */
  playSessionsAggregate: PlaySessionsAggregate;
  /** fetch data from the table: "play_sessions" using primary key columns */
  playSessionsByPk?: Maybe<PlaySessions>;
  /** fetch data from the table: "player_availabilities" */
  playerAvailabilities: Array<PlayerAvailabilities>;
  /** fetch aggregated fields from the table: "player_availabilities" */
  playerAvailabilitiesAggregate: PlayerAvailabilitiesAggregate;
  /** fetch data from the table: "player_availabilities" using primary key columns */
  playerAvailabilitiesByPk?: Maybe<PlayerAvailabilities>;
  /** fetch data from the table: "player_availability_neighborhoods" */
  playerAvailabilityNeighborhoods: Array<PlayerAvailabilityNeighborhoods>;
  /** fetch aggregated fields from the table: "player_availability_neighborhoods" */
  playerAvailabilityNeighborhoodsAggregate: PlayerAvailabilityNeighborhoodsAggregate;
  /** fetch data from the table: "player_availability_neighborhoods" using primary key columns */
  playerAvailabilityNeighborhoodsByPk?: Maybe<PlayerAvailabilityNeighborhoods>;
  /** fetch data from the table: "player_availability_rating_scales" */
  playerAvailabilityRatingScales: Array<PlayerAvailabilityRatingScales>;
  /** fetch aggregated fields from the table: "player_availability_rating_scales" */
  playerAvailabilityRatingScalesAggregate: PlayerAvailabilityRatingScalesAggregate;
  /** fetch data from the table: "player_availability_rating_scales" using primary key columns */
  playerAvailabilityRatingScalesByPk?: Maybe<PlayerAvailabilityRatingScales>;
  /** fetch data from the table: "player_availability_slots" */
  playerAvailabilitySlots: Array<PlayerAvailabilitySlots>;
  /** fetch aggregated fields from the table: "player_availability_slots" */
  playerAvailabilitySlotsAggregate: PlayerAvailabilitySlotsAggregate;
  /** fetch data from the table: "player_availability_slots" using primary key columns */
  playerAvailabilitySlotsByPk?: Maybe<PlayerAvailabilitySlots>;
  /** fetch data from the table: "player_availability_venues" */
  playerAvailabilityVenues: Array<PlayerAvailabilityVenues>;
  /** fetch aggregated fields from the table: "player_availability_venues" */
  playerAvailabilityVenuesAggregate: PlayerAvailabilityVenuesAggregate;
  /** fetch data from the table: "player_availability_venues" using primary key columns */
  playerAvailabilityVenuesByPk?: Maybe<PlayerAvailabilityVenues>;
  /** fetch data from the table: "player_finder_goals" */
  playerFinderGoals: Array<PlayerFinderGoals>;
  /** fetch aggregated fields from the table: "player_finder_goals" */
  playerFinderGoalsAggregate: PlayerFinderGoalsAggregate;
  /** fetch data from the table: "player_finder_goals" using primary key columns */
  playerFinderGoalsByPk?: Maybe<PlayerFinderGoals>;
  /** fetch data from the table: "player_finder_time_of_day" */
  playerFinderTimeOfDay: Array<PlayerFinderTimeOfDay>;
  /** fetch aggregated fields from the table: "player_finder_time_of_day" */
  playerFinderTimeOfDayAggregate: PlayerFinderTimeOfDayAggregate;
  /** fetch data from the table: "player_finder_time_of_day" using primary key columns */
  playerFinderTimeOfDayByPk?: Maybe<PlayerFinderTimeOfDay>;
  /** fetch data from the table: "recurrence_kinds" */
  recurrenceKinds: Array<RecurrenceKinds>;
  /** fetch aggregated fields from the table: "recurrence_kinds" */
  recurrenceKindsAggregate: RecurrenceKindsAggregate;
  /** fetch data from the table: "recurrence_kinds" using primary key columns */
  recurrenceKindsByPk?: Maybe<RecurrenceKinds>;
  /** fetch data from the table: "report_reasons" */
  reportReasons: Array<ReportReasons>;
  /** fetch aggregated fields from the table: "report_reasons" */
  reportReasonsAggregate: ReportReasonsAggregate;
  /** fetch data from the table: "report_reasons" using primary key columns */
  reportReasonsByPk?: Maybe<ReportReasons>;
  /** fetch data from the table: "report_statuses" */
  reportStatuses: Array<ReportStatuses>;
  /** fetch aggregated fields from the table: "report_statuses" */
  reportStatusesAggregate: ReportStatusesAggregate;
  /** fetch data from the table: "report_statuses" using primary key columns */
  reportStatusesByPk?: Maybe<ReportStatuses>;
  /** fetch data from the table: "reviews" */
  reviews: Array<Reviews>;
  /** fetch aggregated fields from the table: "reviews" */
  reviewsAggregate: ReviewsAggregate;
  /** fetch data from the table: "reviews" using primary key columns */
  reviewsByPk?: Maybe<Reviews>;
  /** An array relationship */
  sales: Array<Sales>;
  /** An aggregate relationship */
  salesAggregate: SalesAggregate;
  /** fetch data from the table: "sales" using primary key columns */
  salesByPk?: Maybe<Sales>;
  /** fetch data from the table: "scoring_format" */
  scoringFormat: Array<ScoringFormat>;
  /** fetch aggregated fields from the table: "scoring_format" */
  scoringFormatAggregate: ScoringFormatAggregate;
  /** fetch data from the table: "scoring_format" using primary key columns */
  scoringFormatByPk?: Maybe<ScoringFormat>;
  /** fetch data from the table: "signup_requests" */
  signupRequests: Array<SignupRequests>;
  /** fetch aggregated fields from the table: "signup_requests" */
  signupRequestsAggregate: SignupRequestsAggregate;
  /** fetch data from the table: "signup_requests" using primary key columns */
  signupRequestsByPk?: Maybe<SignupRequests>;
  /** fetch data from the table: "skill_level_values" */
  skillLevelValues: Array<SkillLevelValues>;
  /** fetch aggregated fields from the table: "skill_level_values" */
  skillLevelValuesAggregate: SkillLevelValuesAggregate;
  /** fetch data from the table: "skill_level_values" using primary key columns */
  skillLevelValuesByPk?: Maybe<SkillLevelValues>;
  /** fetch data from the table: "skill_levels" */
  skillLevels: Array<SkillLevels>;
  /** fetch aggregated fields from the table: "skill_levels" */
  skillLevelsAggregate: SkillLevelsAggregate;
  /** fetch data from the table: "skill_levels" using primary key columns */
  skillLevelsByPk?: Maybe<SkillLevels>;
  /** fetch data from the table: "sports" */
  sports: Array<Sports>;
  /** fetch aggregated fields from the table: "sports" */
  sportsAggregate: SportsAggregate;
  /** fetch data from the table: "sports" using primary key columns */
  sportsByPk?: Maybe<Sports>;
  /** An array relationship */
  stripeCharges: Array<StripeCharges>;
  /** An aggregate relationship */
  stripeChargesAggregate: StripeChargesAggregate;
  /** fetch data from the table: "stripe_charges" using primary key columns */
  stripeChargesByPk?: Maybe<StripeCharges>;
  /** fetch data from the table: "stripe_payment_intents" */
  stripePaymentIntents: Array<StripePaymentIntents>;
  /** fetch aggregated fields from the table: "stripe_payment_intents" */
  stripePaymentIntentsAggregate: StripePaymentIntentsAggregate;
  /** fetch data from the table: "stripe_payment_intents" using primary key columns */
  stripePaymentIntentsByPk?: Maybe<StripePaymentIntents>;
  /** fetch data from the table: "subscription_statuses" */
  subscriptionStatuses: Array<SubscriptionStatuses>;
  /** fetch aggregated fields from the table: "subscription_statuses" */
  subscriptionStatusesAggregate: SubscriptionStatusesAggregate;
  /** fetch data from the table: "subscription_statuses" using primary key columns */
  subscriptionStatusesByPk?: Maybe<SubscriptionStatuses>;
  /** fetch data from the table: "team_types" */
  teamTypes: Array<TeamTypes>;
  /** fetch aggregated fields from the table: "team_types" */
  teamTypesAggregate: TeamTypesAggregate;
  /** fetch data from the table: "team_types" using primary key columns */
  teamTypesByPk?: Maybe<TeamTypes>;
  /** fetch data from the table: "tennis_rating_scales" */
  tennisRatingScales: Array<TennisRatingScales>;
  /** fetch aggregated fields from the table: "tennis_rating_scales" */
  tennisRatingScalesAggregate: TennisRatingScalesAggregate;
  /** fetch data from the table: "tennis_rating_scales" using primary key columns */
  tennisRatingScalesByPk?: Maybe<TennisRatingScales>;
  /** fetch data from the table: "twilio_group_texts" */
  twilioGroupTexts: Array<TwilioGroupTexts>;
  /** fetch aggregated fields from the table: "twilio_group_texts" */
  twilioGroupTextsAggregate: TwilioGroupTextsAggregate;
  /** fetch data from the table: "twilio_group_texts" using primary key columns */
  twilioGroupTextsByPk?: Maybe<TwilioGroupTexts>;
  /** fetch data from the table: "upload_review_requests" */
  uploadReviewRequests: Array<UploadReviewRequests>;
  /** fetch aggregated fields from the table: "upload_review_requests" */
  uploadReviewRequestsAggregate: UploadReviewRequestsAggregate;
  /** fetch data from the table: "upload_review_requests" using primary key columns */
  uploadReviewRequestsByPk?: Maybe<UploadReviewRequests>;
  /** fetch data from the table: "user_auth_identities" */
  userAuthIdentities: Array<UserAuthIdentities>;
  /** fetch aggregated fields from the table: "user_auth_identities" */
  userAuthIdentitiesAggregate: UserAuthIdentitiesAggregate;
  /** fetch data from the table: "user_auth_identities" using primary key columns */
  userAuthIdentitiesByPk?: Maybe<UserAuthIdentities>;
  /** fetch data from the table: "user_blocks" */
  userBlocks: Array<UserBlocks>;
  /** fetch aggregated fields from the table: "user_blocks" */
  userBlocksAggregate: UserBlocksAggregate;
  /** fetch data from the table: "user_blocks" using primary key columns */
  userBlocksByPk?: Maybe<UserBlocks>;
  /** fetch data from the table: "user_coach_services" */
  userCoachServices: Array<UserCoachServices>;
  /** fetch aggregated fields from the table: "user_coach_services" */
  userCoachServicesAggregate: UserCoachServicesAggregate;
  /** fetch data from the table: "user_coach_services" using primary key columns */
  userCoachServicesByPk?: Maybe<UserCoachServices>;
  /** fetch data from the table: "user_communication_preferences" */
  userCommunicationPreferences: Array<UserCommunicationPreferences>;
  /** fetch aggregated fields from the table: "user_communication_preferences" */
  userCommunicationPreferencesAggregate: UserCommunicationPreferencesAggregate;
  /** fetch data from the table: "user_communication_preferences" using primary key columns */
  userCommunicationPreferencesByPk?: Maybe<UserCommunicationPreferences>;
  /** fetch data from the table: "user_connection_request_statuses" */
  userConnectionRequestStatuses: Array<UserConnectionRequestStatuses>;
  /** fetch aggregated fields from the table: "user_connection_request_statuses" */
  userConnectionRequestStatusesAggregate: UserConnectionRequestStatusesAggregate;
  /** fetch data from the table: "user_connection_request_statuses" using primary key columns */
  userConnectionRequestStatusesByPk?: Maybe<UserConnectionRequestStatuses>;
  /** fetch data from the table: "user_connection_requests" */
  userConnectionRequests: Array<UserConnectionRequests>;
  /** fetch aggregated fields from the table: "user_connection_requests" */
  userConnectionRequestsAggregate: UserConnectionRequestsAggregate;
  /** fetch data from the table: "user_connection_requests" using primary key columns */
  userConnectionRequestsByPk?: Maybe<UserConnectionRequests>;
  /** fetch data from the table: "user_connections" */
  userConnections: Array<UserConnections>;
  /** fetch aggregated fields from the table: "user_connections" */
  userConnectionsAggregate: UserConnectionsAggregate;
  /** fetch data from the table: "user_connections" using primary key columns */
  userConnectionsByPk?: Maybe<UserConnections>;
  /** fetch data from the table: "user_content_beta_subscriptions" */
  userContentBetaSubscriptions: Array<UserContentBetaSubscriptions>;
  /** fetch aggregated fields from the table: "user_content_beta_subscriptions" */
  userContentBetaSubscriptionsAggregate: UserContentBetaSubscriptionsAggregate;
  /** fetch data from the table: "user_content_beta_subscriptions" using primary key columns */
  userContentBetaSubscriptionsByPk?: Maybe<UserContentBetaSubscriptions>;
  /** fetch data from the table: "user_content_files" */
  userContentFiles: Array<UserContentFiles>;
  /** fetch aggregated fields from the table: "user_content_files" */
  userContentFilesAggregate: UserContentFilesAggregate;
  /** fetch data from the table: "user_content_files" using primary key columns */
  userContentFilesByPk?: Maybe<UserContentFiles>;
  /** An array relationship */
  userContentFilesSkills: Array<UserContentFilesSkills>;
  /** An aggregate relationship */
  userContentFilesSkillsAggregate: UserContentFilesSkillsAggregate;
  /** fetch data from the table: "user_content_files_skills" using primary key columns */
  userContentFilesSkillsByPk?: Maybe<UserContentFilesSkills>;
  /** fetch data from the table: "user_content_skills" */
  userContentSkills: Array<UserContentSkills>;
  /** fetch aggregated fields from the table: "user_content_skills" */
  userContentSkillsAggregate: UserContentSkillsAggregate;
  /** fetch data from the table: "user_content_skills" using primary key columns */
  userContentSkillsByPk?: Maybe<UserContentSkills>;
  /** fetch data from the table: "user_content_tiers" */
  userContentTiers: Array<UserContentTiers>;
  /** fetch aggregated fields from the table: "user_content_tiers" */
  userContentTiersAggregate: UserContentTiersAggregate;
  /** fetch data from the table: "user_content_tiers" using primary key columns */
  userContentTiersByPk?: Maybe<UserContentTiers>;
  /** fetch data from the table: "user_credit_cards" */
  userCreditCards: Array<UserCreditCards>;
  /** fetch aggregated fields from the table: "user_credit_cards" */
  userCreditCardsAggregate: UserCreditCardsAggregate;
  /** fetch data from the table: "user_credit_cards" using primary key columns */
  userCreditCardsByPk?: Maybe<UserCreditCards>;
  /** fetch data from the table: "user_custom_courts" */
  userCustomCourts: Array<UserCustomCourts>;
  /** fetch aggregated fields from the table: "user_custom_courts" */
  userCustomCourtsAggregate: UserCustomCourtsAggregate;
  /** fetch data from the table: "user_custom_courts" using primary key columns */
  userCustomCourtsByPk?: Maybe<UserCustomCourts>;
  /** An array relationship */
  userFiles: Array<UserFiles>;
  /** An aggregate relationship */
  userFilesAggregate: UserFilesAggregate;
  /** fetch data from the table: "user_files" using primary key columns */
  userFilesByPk?: Maybe<UserFiles>;
  /** fetch data from the table: "user_follows" */
  userFollows: Array<UserFollows>;
  /** fetch aggregated fields from the table: "user_follows" */
  userFollowsAggregate: UserFollowsAggregate;
  /** fetch data from the table: "user_follows" using primary key columns */
  userFollowsByPk?: Maybe<UserFollows>;
  /** fetch data from the table: "user_identity_verifications" */
  userIdentityVerifications: Array<UserIdentityVerifications>;
  /** fetch aggregated fields from the table: "user_identity_verifications" */
  userIdentityVerificationsAggregate: UserIdentityVerificationsAggregate;
  /** fetch data from the table: "user_identity_verifications" using primary key columns */
  userIdentityVerificationsByPk?: Maybe<UserIdentityVerifications>;
  /** fetch data from the table: "user_image_log" */
  userImageLog: Array<UserImageLog>;
  /** fetch aggregated fields from the table: "user_image_log" */
  userImageLogAggregate: UserImageLogAggregate;
  /** fetch data from the table: "user_image_log" using primary key columns */
  userImageLogByPk?: Maybe<UserImageLog>;
  /** fetch data from the table: "user_notification_details" */
  userNotificationDetails: Array<UserNotificationDetails>;
  /** fetch aggregated fields from the table: "user_notification_details" */
  userNotificationDetailsAggregate: UserNotificationDetailsAggregate;
  /** fetch data from the table: "user_notification_details" using primary key columns */
  userNotificationDetailsByPk?: Maybe<UserNotificationDetails>;
  /** fetch data from the table: "user_notification_entities" */
  userNotificationEntities: Array<UserNotificationEntities>;
  /** fetch aggregated fields from the table: "user_notification_entities" */
  userNotificationEntitiesAggregate: UserNotificationEntitiesAggregate;
  /** fetch data from the table: "user_notification_entities" using primary key columns */
  userNotificationEntitiesByPk?: Maybe<UserNotificationEntities>;
  /** An array relationship */
  userNotifications: Array<UserNotifications>;
  /** An aggregate relationship */
  userNotificationsAggregate: UserNotificationsAggregate;
  /** fetch data from the table: "user_notifications" using primary key columns */
  userNotificationsByPk?: Maybe<UserNotifications>;
  /** fetch data from the table: "user_padel_rating_scales" */
  userPadelRatingScales: Array<UserPadelRatingScales>;
  /** fetch aggregated fields from the table: "user_padel_rating_scales" */
  userPadelRatingScalesAggregate: UserPadelRatingScalesAggregate;
  /** fetch data from the table: "user_padel_rating_scales" using primary key columns */
  userPadelRatingScalesByPk?: Maybe<UserPadelRatingScales>;
  /** fetch data from the table: "user_pickleball_rating_scales" */
  userPickleballRatingScales: Array<UserPickleballRatingScales>;
  /** fetch aggregated fields from the table: "user_pickleball_rating_scales" */
  userPickleballRatingScalesAggregate: UserPickleballRatingScalesAggregate;
  /** fetch data from the table: "user_pickleball_rating_scales" using primary key columns */
  userPickleballRatingScalesByPk?: Maybe<UserPickleballRatingScales>;
  /** fetch data from the table: "user_played_with" */
  userPlayedWith: Array<UserPlayedWith>;
  /** fetch aggregated fields from the table: "user_played_with" */
  userPlayedWithAggregate: UserPlayedWithAggregate;
  /** fetch data from the table: "user_played_with_dismissals" */
  userPlayedWithDismissals: Array<UserPlayedWithDismissals>;
  /** fetch aggregated fields from the table: "user_played_with_dismissals" */
  userPlayedWithDismissalsAggregate: UserPlayedWithDismissalsAggregate;
  /** fetch data from the table: "user_played_with_dismissals" using primary key columns */
  userPlayedWithDismissalsByPk?: Maybe<UserPlayedWithDismissals>;
  /** fetch data from the table: "user_played_with_games" */
  userPlayedWithGames: Array<UserPlayedWithGames>;
  /** fetch aggregated fields from the table: "user_played_with_games" */
  userPlayedWithGamesAggregate: UserPlayedWithGamesAggregate;
  /** fetch data from the table: "user_player_finder_availability" */
  userPlayerFinderAvailability: Array<UserPlayerFinderAvailability>;
  /** fetch aggregated fields from the table: "user_player_finder_availability" */
  userPlayerFinderAvailabilityAggregate: UserPlayerFinderAvailabilityAggregate;
  /** fetch data from the table: "user_player_finder_availability" using primary key columns */
  userPlayerFinderAvailabilityByPk?: Maybe<UserPlayerFinderAvailability>;
  /** fetch data from the table: "user_player_finder_goals" */
  userPlayerFinderGoals: Array<UserPlayerFinderGoals>;
  /** fetch aggregated fields from the table: "user_player_finder_goals" */
  userPlayerFinderGoalsAggregate: UserPlayerFinderGoalsAggregate;
  /** fetch data from the table: "user_player_finder_goals" using primary key columns */
  userPlayerFinderGoalsByPk?: Maybe<UserPlayerFinderGoals>;
  /** fetch data from the table: "user_profiles" */
  userProfiles: Array<UserProfiles>;
  /** fetch aggregated fields from the table: "user_profiles" */
  userProfilesAggregate: UserProfilesAggregate;
  /** fetch data from the table: "user_registration_details" */
  userRegistrationDetails: Array<UserRegistrationDetails>;
  /** fetch aggregated fields from the table: "user_registration_details" */
  userRegistrationDetailsAggregate: UserRegistrationDetailsAggregate;
  /** fetch data from the table: "user_registration_details" using primary key columns */
  userRegistrationDetailsByPk?: Maybe<UserRegistrationDetails>;
  /** fetch data from the table: "user_sports" */
  userSports: Array<UserSports>;
  /** fetch aggregated fields from the table: "user_sports" */
  userSportsAggregate: UserSportsAggregate;
  /** fetch data from the table: "user_sports" using primary key columns */
  userSportsByPk?: Maybe<UserSports>;
  /** fetch data from the table: "user_tennis_rating_scales" */
  userTennisRatingScales: Array<UserTennisRatingScales>;
  /** fetch aggregated fields from the table: "user_tennis_rating_scales" */
  userTennisRatingScalesAggregate: UserTennisRatingScalesAggregate;
  /** fetch data from the table: "user_tennis_rating_scales" using primary key columns */
  userTennisRatingScalesByPk?: Maybe<UserTennisRatingScales>;
  /** fetch data from the table: "user_terms_of_service" */
  userTermsOfService: Array<UserTermsOfService>;
  /** fetch aggregated fields from the table: "user_terms_of_service" */
  userTermsOfServiceAggregate: UserTermsOfServiceAggregate;
  /** fetch data from the table: "user_terms_of_service" using primary key columns */
  userTermsOfServiceByPk?: Maybe<UserTermsOfService>;
  /** fetch data from the table: "user_vair_connections" */
  userVairConnections: Array<UserVairConnections>;
  /** fetch aggregated fields from the table: "user_vair_connections" */
  userVairConnectionsAggregate: UserVairConnectionsAggregate;
  /** fetch data from the table: "user_vair_connections" using primary key columns */
  userVairConnectionsByPk?: Maybe<UserVairConnections>;
  /** An array relationship */
  usernameLogs: Array<UsernameLogs>;
  /** An aggregate relationship */
  usernameLogsAggregate: UsernameLogsAggregate;
  /** fetch data from the table: "username_logs" using primary key columns */
  usernameLogsByPk?: Maybe<UsernameLogs>;
  /** fetch data from the table: "usernames_active" */
  usernamesActive: Array<UsernamesActive>;
  /** fetch aggregated fields from the table: "usernames_active" */
  usernamesActiveAggregate: UsernamesActiveAggregate;
  /** An array relationship */
  usernamesClaimed: Array<UsernamesClaimed>;
  /** An aggregate relationship */
  usernamesClaimedAggregate: UsernamesClaimedAggregate;
  /** fetch data from the table: "usernames_claimed" using primary key columns */
  usernamesClaimedByPk?: Maybe<UsernamesClaimed>;
  /** An array relationship */
  users: Array<Users>;
  /** An aggregate relationship */
  usersAggregate: UsersAggregate;
  /** fetch data from the table: "users" using primary key columns */
  usersByPk?: Maybe<Users>;
  /** fetch data from the table: "users_coach_qualifications" */
  usersCoachQualifications: Array<UsersCoachQualifications>;
  /** fetch aggregated fields from the table: "users_coach_qualifications" */
  usersCoachQualificationsAggregate: UsersCoachQualificationsAggregate;
  /** fetch data from the table: "users_coach_qualifications" using primary key columns */
  usersCoachQualificationsByPk?: Maybe<UsersCoachQualifications>;
  /** fetch data from the table: "venue_access_types" */
  venueAccessTypes: Array<VenueAccessTypes>;
  /** fetch aggregated fields from the table: "venue_access_types" */
  venueAccessTypesAggregate: VenueAccessTypesAggregate;
  /** fetch data from the table: "venue_access_types" using primary key columns */
  venueAccessTypesByPk?: Maybe<VenueAccessTypes>;
  /** fetch data from the table: "venue_admin_claim_statuses" */
  venueAdminClaimStatuses: Array<VenueAdminClaimStatuses>;
  /** fetch aggregated fields from the table: "venue_admin_claim_statuses" */
  venueAdminClaimStatusesAggregate: VenueAdminClaimStatusesAggregate;
  /** fetch data from the table: "venue_admin_claim_statuses" using primary key columns */
  venueAdminClaimStatusesByPk?: Maybe<VenueAdminClaimStatuses>;
  /** fetch data from the table: "venue_admin_claims" */
  venueAdminClaims: Array<VenueAdminClaims>;
  /** fetch aggregated fields from the table: "venue_admin_claims" */
  venueAdminClaimsAggregate: VenueAdminClaimsAggregate;
  /** fetch data from the table: "venue_admin_claims" using primary key columns */
  venueAdminClaimsByPk?: Maybe<VenueAdminClaims>;
  /** fetch data from the table: "venue_amenities" */
  venueAmenities: Array<VenueAmenities>;
  /** fetch aggregated fields from the table: "venue_amenities" */
  venueAmenitiesAggregate: VenueAmenitiesAggregate;
  /** fetch data from the table: "venue_amenities" using primary key columns */
  venueAmenitiesByPk?: Maybe<VenueAmenities>;
  /** fetch data from the table: "venue_booking_config_versions" */
  venueBookingConfigVersions: Array<VenueBookingConfigVersions>;
  /** fetch aggregated fields from the table: "venue_booking_config_versions" */
  venueBookingConfigVersionsAggregate: VenueBookingConfigVersionsAggregate;
  /** fetch data from the table: "venue_booking_config_versions" using primary key columns */
  venueBookingConfigVersionsByPk?: Maybe<VenueBookingConfigVersions>;
  /** fetch data from the table: "venue_booking_connection_check_statuses" */
  venueBookingConnectionCheckStatuses: Array<VenueBookingConnectionCheckStatuses>;
  /** fetch aggregated fields from the table: "venue_booking_connection_check_statuses" */
  venueBookingConnectionCheckStatusesAggregate: VenueBookingConnectionCheckStatusesAggregate;
  /** fetch data from the table: "venue_booking_connection_check_statuses" using primary key columns */
  venueBookingConnectionCheckStatusesByPk?: Maybe<VenueBookingConnectionCheckStatuses>;
  /** fetch data from the table: "venue_booking_connection_checks" */
  venueBookingConnectionChecks: Array<VenueBookingConnectionChecks>;
  /** fetch aggregated fields from the table: "venue_booking_connection_checks" */
  venueBookingConnectionChecksAggregate: VenueBookingConnectionChecksAggregate;
  /** fetch data from the table: "venue_booking_connection_checks" using primary key columns */
  venueBookingConnectionChecksByPk?: Maybe<VenueBookingConnectionChecks>;
  /** fetch data from the table: "venue_booking_court_rates" */
  venueBookingCourtRates: Array<VenueBookingCourtRates>;
  /** fetch aggregated fields from the table: "venue_booking_court_rates" */
  venueBookingCourtRatesAggregate: VenueBookingCourtRatesAggregate;
  /** fetch data from the table: "venue_booking_court_rates" using primary key columns */
  venueBookingCourtRatesByPk?: Maybe<VenueBookingCourtRates>;
  /** fetch data from the table: "venue_booking_integrations" */
  venueBookingIntegrations: Array<VenueBookingIntegrations>;
  /** fetch aggregated fields from the table: "venue_booking_integrations" */
  venueBookingIntegrationsAggregate: VenueBookingIntegrationsAggregate;
  /** fetch data from the table: "venue_booking_integrations" using primary key columns */
  venueBookingIntegrationsByPk?: Maybe<VenueBookingIntegrations>;
  /** fetch data from the table: "venue_booking_rule_tiers" */
  venueBookingRuleTiers: Array<VenueBookingRuleTiers>;
  /** fetch aggregated fields from the table: "venue_booking_rule_tiers" */
  venueBookingRuleTiersAggregate: VenueBookingRuleTiersAggregate;
  /** fetch data from the table: "venue_booking_rule_tiers" using primary key columns */
  venueBookingRuleTiersByPk?: Maybe<VenueBookingRuleTiers>;
  /** fetch data from the table: "venue_booking_rules" */
  venueBookingRules: Array<VenueBookingRules>;
  /** fetch aggregated fields from the table: "venue_booking_rules" */
  venueBookingRulesAggregate: VenueBookingRulesAggregate;
  /** fetch data from the table: "venue_booking_rules" using primary key columns */
  venueBookingRulesByPk?: Maybe<VenueBookingRules>;
  /** fetch data from the table: "venue_booking_windows" */
  venueBookingWindows: Array<VenueBookingWindows>;
  /** fetch aggregated fields from the table: "venue_booking_windows" */
  venueBookingWindowsAggregate: VenueBookingWindowsAggregate;
  /** fetch data from the table: "venue_booking_windows" using primary key columns */
  venueBookingWindowsByPk?: Maybe<VenueBookingWindows>;
  /** fetch data from the table: "venue_court_surfaces" */
  venueCourtSurfaces: Array<VenueCourtSurfaces>;
  /** fetch aggregated fields from the table: "venue_court_surfaces" */
  venueCourtSurfacesAggregate: VenueCourtSurfacesAggregate;
  /** fetch data from the table: "venue_court_surfaces" using primary key columns */
  venueCourtSurfacesByPk?: Maybe<VenueCourtSurfaces>;
  /** fetch data from the table: "venue_custom_amenities" */
  venueCustomAmenities: Array<VenueCustomAmenities>;
  /** fetch aggregated fields from the table: "venue_custom_amenities" */
  venueCustomAmenitiesAggregate: VenueCustomAmenitiesAggregate;
  /** fetch data from the table: "venue_custom_amenities" using primary key columns */
  venueCustomAmenitiesByPk?: Maybe<VenueCustomAmenities>;
  /** fetch data from the table: "venue_equipment" */
  venueEquipment: Array<VenueEquipment>;
  /** fetch aggregated fields from the table: "venue_equipment" */
  venueEquipmentAggregate: VenueEquipmentAggregate;
  /** fetch data from the table: "venue_equipment" using primary key columns */
  venueEquipmentByPk?: Maybe<VenueEquipment>;
  /** fetch data from the table: "venue_facility_types" */
  venueFacilityTypes: Array<VenueFacilityTypes>;
  /** fetch aggregated fields from the table: "venue_facility_types" */
  venueFacilityTypesAggregate: VenueFacilityTypesAggregate;
  /** fetch data from the table: "venue_facility_types" using primary key columns */
  venueFacilityTypesByPk?: Maybe<VenueFacilityTypes>;
  /** fetch data from the table: "venue_faqs" */
  venueFaqs: Array<VenueFaqs>;
  /** fetch aggregated fields from the table: "venue_faqs" */
  venueFaqsAggregate: VenueFaqsAggregate;
  /** fetch data from the table: "venue_faqs" using primary key columns */
  venueFaqsByPk?: Maybe<VenueFaqs>;
  /** An array relationship */
  venueFollows: Array<VenueFollows>;
  /** An aggregate relationship */
  venueFollowsAggregate: VenueFollowsAggregate;
  /** fetch data from the table: "venue_follows" using primary key columns */
  venueFollowsByPk?: Maybe<VenueFollows>;
  /** fetch data from the table: "venue_images" */
  venueImages: Array<VenueImages>;
  /** fetch aggregated fields from the table: "venue_images" */
  venueImagesAggregate: VenueImagesAggregate;
  /** fetch data from the table: "venue_images" using primary key columns */
  venueImagesByPk?: Maybe<VenueImages>;
  /** fetch data from the table: "venue_lines" */
  venueLines: Array<VenueLines>;
  /** fetch aggregated fields from the table: "venue_lines" */
  venueLinesAggregate: VenueLinesAggregate;
  /** fetch data from the table: "venue_lines" using primary key columns */
  venueLinesByPk?: Maybe<VenueLines>;
  /** fetch data from the table: "venue_nets" */
  venueNets: Array<VenueNets>;
  /** fetch aggregated fields from the table: "venue_nets" */
  venueNetsAggregate: VenueNetsAggregate;
  /** fetch data from the table: "venue_nets" using primary key columns */
  venueNetsByPk?: Maybe<VenueNets>;
  /** fetch data from the table: "venue_partner_booking_statuses" */
  venuePartnerBookingStatuses: Array<VenuePartnerBookingStatuses>;
  /** fetch aggregated fields from the table: "venue_partner_booking_statuses" */
  venuePartnerBookingStatusesAggregate: VenuePartnerBookingStatusesAggregate;
  /** fetch data from the table: "venue_staff_coaches" */
  venueStaffCoaches: Array<VenueStaffCoaches>;
  /** fetch aggregated fields from the table: "venue_staff_coaches" */
  venueStaffCoachesAggregate: VenueStaffCoachesAggregate;
  /** fetch data from the table: "venue_staff_coaches" using primary key columns */
  venueStaffCoachesByPk?: Maybe<VenueStaffCoaches>;
  /** An array relationship */
  venues: Array<Venues>;
  /** An aggregate relationship */
  venuesAggregate: VenuesAggregate;
  /** fetch data from the table: "venues" using primary key columns */
  venuesByPk?: Maybe<Venues>;
  /** fetch data from the table: "video_analysis" */
  videoAnalysis: Array<VideoAnalysis>;
  /** fetch aggregated fields from the table: "video_analysis" */
  videoAnalysisAggregate: VideoAnalysisAggregate;
  /** fetch data from the table: "video_analysis" using primary key columns */
  videoAnalysisByPk?: Maybe<VideoAnalysis>;
  /** An array relationship */
  videoAnalysisComments: Array<VideoAnalysisComments>;
  /** An aggregate relationship */
  videoAnalysisCommentsAggregate: VideoAnalysisCommentsAggregate;
  /** fetch data from the table: "video_analysis_comments" using primary key columns */
  videoAnalysisCommentsByPk?: Maybe<VideoAnalysisComments>;
  /** An array relationship */
  videoAnalysisFiles: Array<VideoAnalysisFiles>;
  /** An aggregate relationship */
  videoAnalysisFilesAggregate: VideoAnalysisFilesAggregate;
  /** fetch data from the table: "video_analysis_files" using primary key columns */
  videoAnalysisFilesByPk?: Maybe<VideoAnalysisFiles>;
  /** fetch data from the table: "video_analysis_files_upload_statuses" */
  videoAnalysisFilesUploadStatuses: Array<VideoAnalysisFilesUploadStatuses>;
  /** fetch aggregated fields from the table: "video_analysis_files_upload_statuses" */
  videoAnalysisFilesUploadStatusesAggregate: VideoAnalysisFilesUploadStatusesAggregate;
  /** fetch data from the table: "video_analysis_files_upload_statuses" using primary key columns */
  videoAnalysisFilesUploadStatusesByPk?: Maybe<VideoAnalysisFilesUploadStatuses>;
  /** fetch data from the table: "video_analysis_order_items" */
  videoAnalysisOrderItems: Array<VideoAnalysisOrderItems>;
  /** fetch aggregated fields from the table: "video_analysis_order_items" */
  videoAnalysisOrderItemsAggregate: VideoAnalysisOrderItemsAggregate;
  /** fetch data from the table: "video_analysis_order_items" using primary key columns */
  videoAnalysisOrderItemsByPk?: Maybe<VideoAnalysisOrderItems>;
  /** fetch data from the table: "video_analysis_orders" */
  videoAnalysisOrders: Array<VideoAnalysisOrders>;
  /** fetch aggregated fields from the table: "video_analysis_orders" */
  videoAnalysisOrdersAggregate: VideoAnalysisOrdersAggregate;
  /** fetch data from the table: "video_analysis_orders" using primary key columns */
  videoAnalysisOrdersByPk?: Maybe<VideoAnalysisOrders>;
  /** fetch data from the table: "video_analysis_requested_skills_review" */
  videoAnalysisRequestedSkillsReview: Array<VideoAnalysisRequestedSkillsReview>;
  /** fetch aggregated fields from the table: "video_analysis_requested_skills_review" */
  videoAnalysisRequestedSkillsReviewAggregate: VideoAnalysisRequestedSkillsReviewAggregate;
  /** fetch data from the table: "video_analysis_requested_skills_review" using primary key columns */
  videoAnalysisRequestedSkillsReviewByPk?: Maybe<VideoAnalysisRequestedSkillsReview>;
  /** fetch data from the table: "video_analysis_review_statuses" */
  videoAnalysisReviewStatuses: Array<VideoAnalysisReviewStatuses>;
  /** fetch aggregated fields from the table: "video_analysis_review_statuses" */
  videoAnalysisReviewStatusesAggregate: VideoAnalysisReviewStatusesAggregate;
  /** fetch data from the table: "video_analysis_review_statuses" using primary key columns */
  videoAnalysisReviewStatusesByPk?: Maybe<VideoAnalysisReviewStatuses>;
  /** An array relationship */
  videoAnalysisSkillsComments: Array<VideoAnalysisSkillsComments>;
  /** An aggregate relationship */
  videoAnalysisSkillsCommentsAggregate: VideoAnalysisSkillsCommentsAggregate;
  /** fetch data from the table: "video_analysis_skills_comments" using primary key columns */
  videoAnalysisSkillsCommentsByPk?: Maybe<VideoAnalysisSkillsComments>;
  /** fetch data from the table: "video_analysis_submission_log" */
  videoAnalysisSubmissionLog: Array<VideoAnalysisSubmissionLog>;
  /** fetch aggregated fields from the table: "video_analysis_submission_log" */
  videoAnalysisSubmissionLogAggregate: VideoAnalysisSubmissionLogAggregate;
  /** fetch data from the table: "video_analysis_submission_log" using primary key columns */
  videoAnalysisSubmissionLogByPk?: Maybe<VideoAnalysisSubmissionLog>;
  /** fetch data from the table: "video_lesson_skills" */
  videoLessonSkills: Array<VideoLessonSkills>;
  /** fetch aggregated fields from the table: "video_lesson_skills" */
  videoLessonSkillsAggregate: VideoLessonSkillsAggregate;
  /** fetch data from the table: "video_lesson_skills" using primary key columns */
  videoLessonSkillsByPk?: Maybe<VideoLessonSkills>;
  /** fetch data from the table: "welcome_email_configuration" */
  welcomeEmailConfiguration: Array<WelcomeEmailConfiguration>;
  /** fetch aggregated fields from the table: "welcome_email_configuration" */
  welcomeEmailConfigurationAggregate: WelcomeEmailConfigurationAggregate;
  /** fetch data from the table: "welcome_email_configuration" using primary key columns */
  welcomeEmailConfigurationByPk?: Maybe<WelcomeEmailConfiguration>;
  /** fetch data from the table: "win_reasons" */
  winReasons: Array<WinReasons>;
  /** fetch aggregated fields from the table: "win_reasons" */
  winReasonsAggregate: WinReasonsAggregate;
  /** fetch data from the table: "win_reasons" using primary key columns */
  winReasonsByPk?: Maybe<WinReasons>;
};


export type Query_RootAmenitiesArgs = {
  distinctOn?: InputMaybe<Array<AmenitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AmenitiesOrderBy>>;
  where?: InputMaybe<AmenitiesBoolExp>;
};


export type Query_RootAmenitiesAggregateArgs = {
  distinctOn?: InputMaybe<Array<AmenitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AmenitiesOrderBy>>;
  where?: InputMaybe<AmenitiesBoolExp>;
};


export type Query_RootAmenitiesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootAppPersonasArgs = {
  distinctOn?: InputMaybe<Array<AppPersonasSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AppPersonasOrderBy>>;
  where?: InputMaybe<AppPersonasBoolExp>;
};


export type Query_RootAppPersonasAggregateArgs = {
  distinctOn?: InputMaybe<Array<AppPersonasSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AppPersonasOrderBy>>;
  where?: InputMaybe<AppPersonasBoolExp>;
};


export type Query_RootAppPersonasByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootAppPingsArgs = {
  distinctOn?: InputMaybe<Array<AppPingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AppPingsOrderBy>>;
  where?: InputMaybe<AppPingsBoolExp>;
};


export type Query_RootAppPingsAggregateArgs = {
  distinctOn?: InputMaybe<Array<AppPingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AppPingsOrderBy>>;
  where?: InputMaybe<AppPingsBoolExp>;
};


export type Query_RootAppPingsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootBallTypesArgs = {
  distinctOn?: InputMaybe<Array<BallTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BallTypesOrderBy>>;
  where?: InputMaybe<BallTypesBoolExp>;
};


export type Query_RootBallTypesAggregateArgs = {
  distinctOn?: InputMaybe<Array<BallTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BallTypesOrderBy>>;
  where?: InputMaybe<BallTypesBoolExp>;
};


export type Query_RootBallTypesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootBirthdayVisibilityArgs = {
  distinctOn?: InputMaybe<Array<BirthdayVisibilitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BirthdayVisibilityOrderBy>>;
  where?: InputMaybe<BirthdayVisibilityBoolExp>;
};


export type Query_RootBirthdayVisibilityAggregateArgs = {
  distinctOn?: InputMaybe<Array<BirthdayVisibilitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BirthdayVisibilityOrderBy>>;
  where?: InputMaybe<BirthdayVisibilityBoolExp>;
};


export type Query_RootBirthdayVisibilityByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootBookingConfigChangeTypesArgs = {
  distinctOn?: InputMaybe<Array<BookingConfigChangeTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BookingConfigChangeTypesOrderBy>>;
  where?: InputMaybe<BookingConfigChangeTypesBoolExp>;
};


export type Query_RootBookingConfigChangeTypesAggregateArgs = {
  distinctOn?: InputMaybe<Array<BookingConfigChangeTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BookingConfigChangeTypesOrderBy>>;
  where?: InputMaybe<BookingConfigChangeTypesBoolExp>;
};


export type Query_RootBookingConfigChangeTypesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootBookingConnectionStatusesArgs = {
  distinctOn?: InputMaybe<Array<BookingConnectionStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BookingConnectionStatusesOrderBy>>;
  where?: InputMaybe<BookingConnectionStatusesBoolExp>;
};


export type Query_RootBookingConnectionStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<BookingConnectionStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BookingConnectionStatusesOrderBy>>;
  where?: InputMaybe<BookingConnectionStatusesBoolExp>;
};


export type Query_RootBookingConnectionStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootBookingIntegrationStatusesArgs = {
  distinctOn?: InputMaybe<Array<BookingIntegrationStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BookingIntegrationStatusesOrderBy>>;
  where?: InputMaybe<BookingIntegrationStatusesBoolExp>;
};


export type Query_RootBookingIntegrationStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<BookingIntegrationStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BookingIntegrationStatusesOrderBy>>;
  where?: InputMaybe<BookingIntegrationStatusesBoolExp>;
};


export type Query_RootBookingIntegrationStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootBookingInventoryTypesArgs = {
  distinctOn?: InputMaybe<Array<BookingInventoryTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BookingInventoryTypesOrderBy>>;
  where?: InputMaybe<BookingInventoryTypesBoolExp>;
};


export type Query_RootBookingInventoryTypesAggregateArgs = {
  distinctOn?: InputMaybe<Array<BookingInventoryTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BookingInventoryTypesOrderBy>>;
  where?: InputMaybe<BookingInventoryTypesBoolExp>;
};


export type Query_RootBookingInventoryTypesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootBookingScheduleModesArgs = {
  distinctOn?: InputMaybe<Array<BookingScheduleModesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BookingScheduleModesOrderBy>>;
  where?: InputMaybe<BookingScheduleModesBoolExp>;
};


export type Query_RootBookingScheduleModesAggregateArgs = {
  distinctOn?: InputMaybe<Array<BookingScheduleModesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BookingScheduleModesOrderBy>>;
  where?: InputMaybe<BookingScheduleModesBoolExp>;
};


export type Query_RootBookingScheduleModesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootBookingSystemsArgs = {
  distinctOn?: InputMaybe<Array<BookingSystemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BookingSystemsOrderBy>>;
  where?: InputMaybe<BookingSystemsBoolExp>;
};


export type Query_RootBookingSystemsAggregateArgs = {
  distinctOn?: InputMaybe<Array<BookingSystemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BookingSystemsOrderBy>>;
  where?: InputMaybe<BookingSystemsBoolExp>;
};


export type Query_RootBookingSystemsByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootBookingWindowKindsArgs = {
  distinctOn?: InputMaybe<Array<BookingWindowKindsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BookingWindowKindsOrderBy>>;
  where?: InputMaybe<BookingWindowKindsBoolExp>;
};


export type Query_RootBookingWindowKindsAggregateArgs = {
  distinctOn?: InputMaybe<Array<BookingWindowKindsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BookingWindowKindsOrderBy>>;
  where?: InputMaybe<BookingWindowKindsBoolExp>;
};


export type Query_RootBookingWindowKindsByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootBoostChannelsArgs = {
  distinctOn?: InputMaybe<Array<BoostChannelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BoostChannelsOrderBy>>;
  where?: InputMaybe<BoostChannelsBoolExp>;
};


export type Query_RootBoostChannelsAggregateArgs = {
  distinctOn?: InputMaybe<Array<BoostChannelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BoostChannelsOrderBy>>;
  where?: InputMaybe<BoostChannelsBoolExp>;
};


export type Query_RootBoostChannelsByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootBoostOrdersArgs = {
  distinctOn?: InputMaybe<Array<BoostOrdersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BoostOrdersOrderBy>>;
  where?: InputMaybe<BoostOrdersBoolExp>;
};


export type Query_RootBoostOrdersAggregateArgs = {
  distinctOn?: InputMaybe<Array<BoostOrdersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BoostOrdersOrderBy>>;
  where?: InputMaybe<BoostOrdersBoolExp>;
};


export type Query_RootBoostOrdersByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootBoostStatusesArgs = {
  distinctOn?: InputMaybe<Array<BoostStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BoostStatusesOrderBy>>;
  where?: InputMaybe<BoostStatusesBoolExp>;
};


export type Query_RootBoostStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<BoostStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BoostStatusesOrderBy>>;
  where?: InputMaybe<BoostStatusesBoolExp>;
};


export type Query_RootBoostStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootBoostsArgs = {
  distinctOn?: InputMaybe<Array<BoostsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BoostsOrderBy>>;
  where?: InputMaybe<BoostsBoolExp>;
};


export type Query_RootBoostsAggregateArgs = {
  distinctOn?: InputMaybe<Array<BoostsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BoostsOrderBy>>;
  where?: InputMaybe<BoostsBoolExp>;
};


export type Query_RootBoostsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootBracketRankingMechanismArgs = {
  distinctOn?: InputMaybe<Array<BracketRankingMechanismSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BracketRankingMechanismOrderBy>>;
  where?: InputMaybe<BracketRankingMechanismBoolExp>;
};


export type Query_RootBracketRankingMechanismAggregateArgs = {
  distinctOn?: InputMaybe<Array<BracketRankingMechanismSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BracketRankingMechanismOrderBy>>;
  where?: InputMaybe<BracketRankingMechanismBoolExp>;
};


export type Query_RootBracketRankingMechanismByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootCalendarAccountsArgs = {
  distinctOn?: InputMaybe<Array<CalendarAccountsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CalendarAccountsOrderBy>>;
  where?: InputMaybe<CalendarAccountsBoolExp>;
};


export type Query_RootCalendarAccountsAggregateArgs = {
  distinctOn?: InputMaybe<Array<CalendarAccountsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CalendarAccountsOrderBy>>;
  where?: InputMaybe<CalendarAccountsBoolExp>;
};


export type Query_RootCalendarAccountsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCalendarAuthProviderArgs = {
  distinctOn?: InputMaybe<Array<CalendarAuthProviderSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CalendarAuthProviderOrderBy>>;
  where?: InputMaybe<CalendarAuthProviderBoolExp>;
};


export type Query_RootCalendarAuthProviderAggregateArgs = {
  distinctOn?: InputMaybe<Array<CalendarAuthProviderSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CalendarAuthProviderOrderBy>>;
  where?: InputMaybe<CalendarAuthProviderBoolExp>;
};


export type Query_RootCalendarAuthProviderByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootCalendarEventMappingsArgs = {
  distinctOn?: InputMaybe<Array<CalendarEventMappingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CalendarEventMappingsOrderBy>>;
  where?: InputMaybe<CalendarEventMappingsBoolExp>;
};


export type Query_RootCalendarEventMappingsAggregateArgs = {
  distinctOn?: InputMaybe<Array<CalendarEventMappingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CalendarEventMappingsOrderBy>>;
  where?: InputMaybe<CalendarEventMappingsBoolExp>;
};


export type Query_RootCalendarEventMappingsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCalendarPreferencesArgs = {
  distinctOn?: InputMaybe<Array<CalendarPreferencesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CalendarPreferencesOrderBy>>;
  where?: InputMaybe<CalendarPreferencesBoolExp>;
};


export type Query_RootCalendarPreferencesAggregateArgs = {
  distinctOn?: InputMaybe<Array<CalendarPreferencesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CalendarPreferencesOrderBy>>;
  where?: InputMaybe<CalendarPreferencesBoolExp>;
};


export type Query_RootCalendarPreferencesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCitiesArgs = {
  distinctOn?: InputMaybe<Array<CitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CitiesOrderBy>>;
  where?: InputMaybe<CitiesBoolExp>;
};


export type Query_RootCitiesAggregateArgs = {
  distinctOn?: InputMaybe<Array<CitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CitiesOrderBy>>;
  where?: InputMaybe<CitiesBoolExp>;
};


export type Query_RootCitiesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCoachAvailabilityArgs = {
  distinctOn?: InputMaybe<Array<CoachAvailabilitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachAvailabilityOrderBy>>;
  where?: InputMaybe<CoachAvailabilityBoolExp>;
};


export type Query_RootCoachAvailabilityAggregateArgs = {
  distinctOn?: InputMaybe<Array<CoachAvailabilitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachAvailabilityOrderBy>>;
  where?: InputMaybe<CoachAvailabilityBoolExp>;
};


export type Query_RootCoachAvailabilityByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCoachAvailabilityStatusesArgs = {
  distinctOn?: InputMaybe<Array<CoachAvailabilityStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachAvailabilityStatusesOrderBy>>;
  where?: InputMaybe<CoachAvailabilityStatusesBoolExp>;
};


export type Query_RootCoachAvailabilityStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<CoachAvailabilityStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachAvailabilityStatusesOrderBy>>;
  where?: InputMaybe<CoachAvailabilityStatusesBoolExp>;
};


export type Query_RootCoachAvailabilityStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootCoachBookingRequestsArgs = {
  distinctOn?: InputMaybe<Array<CoachBookingRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachBookingRequestsOrderBy>>;
  where?: InputMaybe<CoachBookingRequestsBoolExp>;
};


export type Query_RootCoachBookingRequestsAggregateArgs = {
  distinctOn?: InputMaybe<Array<CoachBookingRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachBookingRequestsOrderBy>>;
  where?: InputMaybe<CoachBookingRequestsBoolExp>;
};


export type Query_RootCoachBookingRequestsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCoachExternalReviewSourcesArgs = {
  distinctOn?: InputMaybe<Array<CoachExternalReviewSourcesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachExternalReviewSourcesOrderBy>>;
  where?: InputMaybe<CoachExternalReviewSourcesBoolExp>;
};


export type Query_RootCoachExternalReviewSourcesAggregateArgs = {
  distinctOn?: InputMaybe<Array<CoachExternalReviewSourcesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachExternalReviewSourcesOrderBy>>;
  where?: InputMaybe<CoachExternalReviewSourcesBoolExp>;
};


export type Query_RootCoachExternalReviewSourcesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootCoachFaqsArgs = {
  distinctOn?: InputMaybe<Array<CoachFaqsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachFaqsOrderBy>>;
  where?: InputMaybe<CoachFaqsBoolExp>;
};


export type Query_RootCoachFaqsAggregateArgs = {
  distinctOn?: InputMaybe<Array<CoachFaqsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachFaqsOrderBy>>;
  where?: InputMaybe<CoachFaqsBoolExp>;
};


export type Query_RootCoachFaqsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCoachLessonAgeGroupsArgs = {
  distinctOn?: InputMaybe<Array<CoachLessonAgeGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachLessonAgeGroupsOrderBy>>;
  where?: InputMaybe<CoachLessonAgeGroupsBoolExp>;
};


export type Query_RootCoachLessonAgeGroupsAggregateArgs = {
  distinctOn?: InputMaybe<Array<CoachLessonAgeGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachLessonAgeGroupsOrderBy>>;
  where?: InputMaybe<CoachLessonAgeGroupsBoolExp>;
};


export type Query_RootCoachLessonAgeGroupsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCoachLessonSkillLevelsArgs = {
  distinctOn?: InputMaybe<Array<CoachLessonSkillLevelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachLessonSkillLevelsOrderBy>>;
  where?: InputMaybe<CoachLessonSkillLevelsBoolExp>;
};


export type Query_RootCoachLessonSkillLevelsAggregateArgs = {
  distinctOn?: InputMaybe<Array<CoachLessonSkillLevelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachLessonSkillLevelsOrderBy>>;
  where?: InputMaybe<CoachLessonSkillLevelsBoolExp>;
};


export type Query_RootCoachLessonSkillLevelsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCoachQualificationGroupsArgs = {
  distinctOn?: InputMaybe<Array<CoachQualificationGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachQualificationGroupsOrderBy>>;
  where?: InputMaybe<CoachQualificationGroupsBoolExp>;
};


export type Query_RootCoachQualificationGroupsAggregateArgs = {
  distinctOn?: InputMaybe<Array<CoachQualificationGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachQualificationGroupsOrderBy>>;
  where?: InputMaybe<CoachQualificationGroupsBoolExp>;
};


export type Query_RootCoachQualificationGroupsByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootCoachQualificationStatusesArgs = {
  distinctOn?: InputMaybe<Array<CoachQualificationStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachQualificationStatusesOrderBy>>;
  where?: InputMaybe<CoachQualificationStatusesBoolExp>;
};


export type Query_RootCoachQualificationStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<CoachQualificationStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachQualificationStatusesOrderBy>>;
  where?: InputMaybe<CoachQualificationStatusesBoolExp>;
};


export type Query_RootCoachQualificationStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootCoachQualificationsArgs = {
  distinctOn?: InputMaybe<Array<CoachQualificationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachQualificationsOrderBy>>;
  where?: InputMaybe<CoachQualificationsBoolExp>;
};


export type Query_RootCoachQualificationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<CoachQualificationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachQualificationsOrderBy>>;
  where?: InputMaybe<CoachQualificationsBoolExp>;
};


export type Query_RootCoachQualificationsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCoachReviewTypesArgs = {
  distinctOn?: InputMaybe<Array<CoachReviewTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachReviewTypesOrderBy>>;
  where?: InputMaybe<CoachReviewTypesBoolExp>;
};


export type Query_RootCoachReviewTypesAggregateArgs = {
  distinctOn?: InputMaybe<Array<CoachReviewTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachReviewTypesOrderBy>>;
  where?: InputMaybe<CoachReviewTypesBoolExp>;
};


export type Query_RootCoachReviewTypesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootCoachSportStatusesArgs = {
  distinctOn?: InputMaybe<Array<CoachSportStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachSportStatusesOrderBy>>;
  where?: InputMaybe<CoachSportStatusesBoolExp>;
};


export type Query_RootCoachSportStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<CoachSportStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachSportStatusesOrderBy>>;
  where?: InputMaybe<CoachSportStatusesBoolExp>;
};


export type Query_RootCoachSportStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootCoachSportsArgs = {
  distinctOn?: InputMaybe<Array<CoachSportsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachSportsOrderBy>>;
  where?: InputMaybe<CoachSportsBoolExp>;
};


export type Query_RootCoachSportsAggregateArgs = {
  distinctOn?: InputMaybe<Array<CoachSportsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachSportsOrderBy>>;
  where?: InputMaybe<CoachSportsBoolExp>;
};


export type Query_RootCoachSportsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCoachStarterProfilesArgs = {
  distinctOn?: InputMaybe<Array<CoachStarterProfilesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachStarterProfilesOrderBy>>;
  where?: InputMaybe<CoachStarterProfilesBoolExp>;
};


export type Query_RootCoachStarterProfilesAggregateArgs = {
  distinctOn?: InputMaybe<Array<CoachStarterProfilesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachStarterProfilesOrderBy>>;
  where?: InputMaybe<CoachStarterProfilesBoolExp>;
};


export type Query_RootCoachStarterProfilesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCoachStatusArgs = {
  distinctOn?: InputMaybe<Array<CoachStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachStatusOrderBy>>;
  where?: InputMaybe<CoachStatusBoolExp>;
};


export type Query_RootCoachStatusAggregateArgs = {
  distinctOn?: InputMaybe<Array<CoachStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachStatusOrderBy>>;
  where?: InputMaybe<CoachStatusBoolExp>;
};


export type Query_RootCoachStatusByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootCoachTipsArgs = {
  distinctOn?: InputMaybe<Array<CoachTipsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachTipsOrderBy>>;
  where?: InputMaybe<CoachTipsBoolExp>;
};


export type Query_RootCoachTipsAggregateArgs = {
  distinctOn?: InputMaybe<Array<CoachTipsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachTipsOrderBy>>;
  where?: InputMaybe<CoachTipsBoolExp>;
};


export type Query_RootCoachTipsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCommentVoteArgs = {
  distinctOn?: InputMaybe<Array<CommentVoteSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CommentVoteOrderBy>>;
  where?: InputMaybe<CommentVoteBoolExp>;
};


export type Query_RootCommentVoteAggregateArgs = {
  distinctOn?: InputMaybe<Array<CommentVoteSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CommentVoteOrderBy>>;
  where?: InputMaybe<CommentVoteBoolExp>;
};


export type Query_RootCommentVoteByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootCommunicationPreferenceStatusesArgs = {
  distinctOn?: InputMaybe<Array<CommunicationPreferenceStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CommunicationPreferenceStatusesOrderBy>>;
  where?: InputMaybe<CommunicationPreferenceStatusesBoolExp>;
};


export type Query_RootCommunicationPreferenceStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<CommunicationPreferenceStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CommunicationPreferenceStatusesOrderBy>>;
  where?: InputMaybe<CommunicationPreferenceStatusesBoolExp>;
};


export type Query_RootCommunicationPreferenceStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootCompetitionFormatsArgs = {
  distinctOn?: InputMaybe<Array<CompetitionFormatsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompetitionFormatsOrderBy>>;
  where?: InputMaybe<CompetitionFormatsBoolExp>;
};


export type Query_RootCompetitionFormatsAggregateArgs = {
  distinctOn?: InputMaybe<Array<CompetitionFormatsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompetitionFormatsOrderBy>>;
  where?: InputMaybe<CompetitionFormatsBoolExp>;
};


export type Query_RootCompetitionFormatsByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootCompetitionGenderArgs = {
  distinctOn?: InputMaybe<Array<CompetitionGenderSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompetitionGenderOrderBy>>;
  where?: InputMaybe<CompetitionGenderBoolExp>;
};


export type Query_RootCompetitionGenderAggregateArgs = {
  distinctOn?: InputMaybe<Array<CompetitionGenderSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompetitionGenderOrderBy>>;
  where?: InputMaybe<CompetitionGenderBoolExp>;
};


export type Query_RootCompetitionGenderByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootContentReportsArgs = {
  distinctOn?: InputMaybe<Array<ContentReportsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContentReportsOrderBy>>;
  where?: InputMaybe<ContentReportsBoolExp>;
};


export type Query_RootContentReportsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ContentReportsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContentReportsOrderBy>>;
  where?: InputMaybe<ContentReportsBoolExp>;
};


export type Query_RootContentReportsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootConversationParticipantsArgs = {
  distinctOn?: InputMaybe<Array<ConversationParticipantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ConversationParticipantsOrderBy>>;
  where?: InputMaybe<ConversationParticipantsBoolExp>;
};


export type Query_RootConversationParticipantsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ConversationParticipantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ConversationParticipantsOrderBy>>;
  where?: InputMaybe<ConversationParticipantsBoolExp>;
};


export type Query_RootConversationParticipantsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootConversationTypesArgs = {
  distinctOn?: InputMaybe<Array<ConversationTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ConversationTypesOrderBy>>;
  where?: InputMaybe<ConversationTypesBoolExp>;
};


export type Query_RootConversationTypesAggregateArgs = {
  distinctOn?: InputMaybe<Array<ConversationTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ConversationTypesOrderBy>>;
  where?: InputMaybe<ConversationTypesBoolExp>;
};


export type Query_RootConversationTypesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootConversationsArgs = {
  distinctOn?: InputMaybe<Array<ConversationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ConversationsOrderBy>>;
  where?: InputMaybe<ConversationsBoolExp>;
};


export type Query_RootConversationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ConversationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ConversationsOrderBy>>;
  where?: InputMaybe<ConversationsBoolExp>;
};


export type Query_RootConversationsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCountriesArgs = {
  distinctOn?: InputMaybe<Array<CountriesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CountriesOrderBy>>;
  where?: InputMaybe<CountriesBoolExp>;
};


export type Query_RootCountriesAggregateArgs = {
  distinctOn?: InputMaybe<Array<CountriesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CountriesOrderBy>>;
  where?: InputMaybe<CountriesBoolExp>;
};


export type Query_RootCountriesByPkArgs = {
  id: Scalars['String'];
};


export type Query_RootCountrySubdivisionsArgs = {
  distinctOn?: InputMaybe<Array<CountrySubdivisionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CountrySubdivisionsOrderBy>>;
  where?: InputMaybe<CountrySubdivisionsBoolExp>;
};


export type Query_RootCountrySubdivisionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<CountrySubdivisionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CountrySubdivisionsOrderBy>>;
  where?: InputMaybe<CountrySubdivisionsBoolExp>;
};


export type Query_RootCountrySubdivisionsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCourtSurfacesArgs = {
  distinctOn?: InputMaybe<Array<CourtSurfacesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CourtSurfacesOrderBy>>;
  where?: InputMaybe<CourtSurfacesBoolExp>;
};


export type Query_RootCourtSurfacesAggregateArgs = {
  distinctOn?: InputMaybe<Array<CourtSurfacesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CourtSurfacesOrderBy>>;
  where?: InputMaybe<CourtSurfacesBoolExp>;
};


export type Query_RootCourtSurfacesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootDayOfWeekArgs = {
  distinctOn?: InputMaybe<Array<DayOfWeekSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DayOfWeekOrderBy>>;
  where?: InputMaybe<DayOfWeekBoolExp>;
};


export type Query_RootDayOfWeekAggregateArgs = {
  distinctOn?: InputMaybe<Array<DayOfWeekSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DayOfWeekOrderBy>>;
  where?: InputMaybe<DayOfWeekBoolExp>;
};


export type Query_RootDayOfWeekByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootEngagementAnalyticsArgs = {
  distinctOn?: InputMaybe<Array<EngagementAnalyticsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EngagementAnalyticsOrderBy>>;
  where?: InputMaybe<EngagementAnalyticsBoolExp>;
};


export type Query_RootEngagementAnalyticsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EngagementAnalyticsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EngagementAnalyticsOrderBy>>;
  where?: InputMaybe<EngagementAnalyticsBoolExp>;
};


export type Query_RootEngagementAnalyticsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEngagementEntityTypesArgs = {
  distinctOn?: InputMaybe<Array<EngagementEntityTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EngagementEntityTypesOrderBy>>;
  where?: InputMaybe<EngagementEntityTypesBoolExp>;
};


export type Query_RootEngagementEntityTypesAggregateArgs = {
  distinctOn?: InputMaybe<Array<EngagementEntityTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EngagementEntityTypesOrderBy>>;
  where?: InputMaybe<EngagementEntityTypesBoolExp>;
};


export type Query_RootEngagementEntityTypesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootEngagementEventTypesArgs = {
  distinctOn?: InputMaybe<Array<EngagementEventTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EngagementEventTypesOrderBy>>;
  where?: InputMaybe<EngagementEventTypesBoolExp>;
};


export type Query_RootEngagementEventTypesAggregateArgs = {
  distinctOn?: InputMaybe<Array<EngagementEventTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EngagementEventTypesOrderBy>>;
  where?: InputMaybe<EngagementEventTypesBoolExp>;
};


export type Query_RootEngagementEventTypesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootEngagementSourcesArgs = {
  distinctOn?: InputMaybe<Array<EngagementSourcesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EngagementSourcesOrderBy>>;
  where?: InputMaybe<EngagementSourcesBoolExp>;
};


export type Query_RootEngagementSourcesAggregateArgs = {
  distinctOn?: InputMaybe<Array<EngagementSourcesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EngagementSourcesOrderBy>>;
  where?: InputMaybe<EngagementSourcesBoolExp>;
};


export type Query_RootEngagementSourcesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootEquipmentAvailabilitiesArgs = {
  distinctOn?: InputMaybe<Array<EquipmentAvailabilitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EquipmentAvailabilitiesOrderBy>>;
  where?: InputMaybe<EquipmentAvailabilitiesBoolExp>;
};


export type Query_RootEquipmentAvailabilitiesAggregateArgs = {
  distinctOn?: InputMaybe<Array<EquipmentAvailabilitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EquipmentAvailabilitiesOrderBy>>;
  where?: InputMaybe<EquipmentAvailabilitiesBoolExp>;
};


export type Query_RootEquipmentAvailabilitiesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootEventAcceptedPlayRequestsArgs = {
  distinctOn?: InputMaybe<Array<EventAcceptedPlayRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventAcceptedPlayRequestsOrderBy>>;
  where?: InputMaybe<EventAcceptedPlayRequestsBoolExp>;
};


export type Query_RootEventAcceptedPlayRequestsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventAcceptedPlayRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventAcceptedPlayRequestsOrderBy>>;
  where?: InputMaybe<EventAcceptedPlayRequestsBoolExp>;
};


export type Query_RootEventAgeGroupsArgs = {
  distinctOn?: InputMaybe<Array<EventAgeGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventAgeGroupsOrderBy>>;
  where?: InputMaybe<EventAgeGroupsBoolExp>;
};


export type Query_RootEventAgeGroupsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventAgeGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventAgeGroupsOrderBy>>;
  where?: InputMaybe<EventAgeGroupsBoolExp>;
};


export type Query_RootEventAgeGroupsByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootEventCollectionsArgs = {
  distinctOn?: InputMaybe<Array<EventCollectionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventCollectionsOrderBy>>;
  where?: InputMaybe<EventCollectionsBoolExp>;
};


export type Query_RootEventCollectionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventCollectionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventCollectionsOrderBy>>;
  where?: InputMaybe<EventCollectionsBoolExp>;
};


export type Query_RootEventCollectionsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEventCompetitivenessArgs = {
  distinctOn?: InputMaybe<Array<EventCompetitivenessSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventCompetitivenessOrderBy>>;
  where?: InputMaybe<EventCompetitivenessBoolExp>;
};


export type Query_RootEventCompetitivenessAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventCompetitivenessSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventCompetitivenessOrderBy>>;
  where?: InputMaybe<EventCompetitivenessBoolExp>;
};


export type Query_RootEventCompetitivenessByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootEventContactDetailsArgs = {
  distinctOn?: InputMaybe<Array<EventContactDetailsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventContactDetailsOrderBy>>;
  where?: InputMaybe<EventContactDetailsBoolExp>;
};


export type Query_RootEventContactDetailsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventContactDetailsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventContactDetailsOrderBy>>;
  where?: InputMaybe<EventContactDetailsBoolExp>;
};


export type Query_RootEventContactDetailsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEventCouponGroupsArgs = {
  distinctOn?: InputMaybe<Array<EventCouponGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventCouponGroupsOrderBy>>;
  where?: InputMaybe<EventCouponGroupsBoolExp>;
};


export type Query_RootEventCouponGroupsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventCouponGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventCouponGroupsOrderBy>>;
  where?: InputMaybe<EventCouponGroupsBoolExp>;
};


export type Query_RootEventCouponGroupsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEventCouponRedemptionsArgs = {
  distinctOn?: InputMaybe<Array<EventCouponRedemptionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventCouponRedemptionsOrderBy>>;
  where?: InputMaybe<EventCouponRedemptionsBoolExp>;
};


export type Query_RootEventCouponRedemptionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventCouponRedemptionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventCouponRedemptionsOrderBy>>;
  where?: InputMaybe<EventCouponRedemptionsBoolExp>;
};


export type Query_RootEventCouponRedemptionsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEventCouponSourceArgs = {
  distinctOn?: InputMaybe<Array<EventCouponSourceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventCouponSourceOrderBy>>;
  where?: InputMaybe<EventCouponSourceBoolExp>;
};


export type Query_RootEventCouponSourceAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventCouponSourceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventCouponSourceOrderBy>>;
  where?: InputMaybe<EventCouponSourceBoolExp>;
};


export type Query_RootEventCouponSourceByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootEventCouponTypeArgs = {
  distinctOn?: InputMaybe<Array<EventCouponTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventCouponTypeOrderBy>>;
  where?: InputMaybe<EventCouponTypeBoolExp>;
};


export type Query_RootEventCouponTypeAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventCouponTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventCouponTypeOrderBy>>;
  where?: InputMaybe<EventCouponTypeBoolExp>;
};


export type Query_RootEventCouponTypeByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootEventCouponsArgs = {
  distinctOn?: InputMaybe<Array<EventCouponsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventCouponsOrderBy>>;
  where?: InputMaybe<EventCouponsBoolExp>;
};


export type Query_RootEventCouponsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventCouponsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventCouponsOrderBy>>;
  where?: InputMaybe<EventCouponsBoolExp>;
};


export type Query_RootEventCouponsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEventCourtStatusesArgs = {
  distinctOn?: InputMaybe<Array<EventCourtStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventCourtStatusesOrderBy>>;
  where?: InputMaybe<EventCourtStatusesBoolExp>;
};


export type Query_RootEventCourtStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventCourtStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventCourtStatusesOrderBy>>;
  where?: InputMaybe<EventCourtStatusesBoolExp>;
};


export type Query_RootEventCourtStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootEventCourtsArgs = {
  distinctOn?: InputMaybe<Array<EventCourtsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventCourtsOrderBy>>;
  where?: InputMaybe<EventCourtsBoolExp>;
};


export type Query_RootEventCourtsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventCourtsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventCourtsOrderBy>>;
  where?: InputMaybe<EventCourtsBoolExp>;
};


export type Query_RootEventCourtsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEventFaqsArgs = {
  distinctOn?: InputMaybe<Array<EventFaqsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventFaqsOrderBy>>;
  where?: InputMaybe<EventFaqsBoolExp>;
};


export type Query_RootEventFaqsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventFaqsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventFaqsOrderBy>>;
  where?: InputMaybe<EventFaqsBoolExp>;
};


export type Query_RootEventFaqsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEventGameScoresArgs = {
  distinctOn?: InputMaybe<Array<EventGameScoresSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGameScoresOrderBy>>;
  where?: InputMaybe<EventGameScoresBoolExp>;
};


export type Query_RootEventGameScoresAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventGameScoresSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGameScoresOrderBy>>;
  where?: InputMaybe<EventGameScoresBoolExp>;
};


export type Query_RootEventGameScoresByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEventGroupFormatsArgs = {
  distinctOn?: InputMaybe<Array<EventGroupFormatsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGroupFormatsOrderBy>>;
  where?: InputMaybe<EventGroupFormatsBoolExp>;
};


export type Query_RootEventGroupFormatsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventGroupFormatsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGroupFormatsOrderBy>>;
  where?: InputMaybe<EventGroupFormatsBoolExp>;
};


export type Query_RootEventGroupFormatsByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootEventGroupMergesArgs = {
  distinctOn?: InputMaybe<Array<EventGroupMergesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGroupMergesOrderBy>>;
  where?: InputMaybe<EventGroupMergesBoolExp>;
};


export type Query_RootEventGroupMergesAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventGroupMergesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGroupMergesOrderBy>>;
  where?: InputMaybe<EventGroupMergesBoolExp>;
};


export type Query_RootEventGroupMergesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEventGroupPoolsArgs = {
  distinctOn?: InputMaybe<Array<EventGroupPoolsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGroupPoolsOrderBy>>;
  where?: InputMaybe<EventGroupPoolsBoolExp>;
};


export type Query_RootEventGroupPoolsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventGroupPoolsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGroupPoolsOrderBy>>;
  where?: InputMaybe<EventGroupPoolsBoolExp>;
};


export type Query_RootEventGroupPoolsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEventGroupRatingScalesArgs = {
  distinctOn?: InputMaybe<Array<EventGroupRatingScalesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGroupRatingScalesOrderBy>>;
  where?: InputMaybe<EventGroupRatingScalesBoolExp>;
};


export type Query_RootEventGroupRatingScalesAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventGroupRatingScalesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGroupRatingScalesOrderBy>>;
  where?: InputMaybe<EventGroupRatingScalesBoolExp>;
};


export type Query_RootEventGroupRatingScalesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEventGroupRegistrationStatusesArgs = {
  distinctOn?: InputMaybe<Array<EventGroupRegistrationStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGroupRegistrationStatusesOrderBy>>;
  where?: InputMaybe<EventGroupRegistrationStatusesBoolExp>;
};


export type Query_RootEventGroupRegistrationStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventGroupRegistrationStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGroupRegistrationStatusesOrderBy>>;
  where?: InputMaybe<EventGroupRegistrationStatusesBoolExp>;
};


export type Query_RootEventGroupRegistrationStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootEventGroupRegistrationsArgs = {
  distinctOn?: InputMaybe<Array<EventGroupRegistrationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGroupRegistrationsOrderBy>>;
  where?: InputMaybe<EventGroupRegistrationsBoolExp>;
};


export type Query_RootEventGroupRegistrationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventGroupRegistrationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGroupRegistrationsOrderBy>>;
  where?: InputMaybe<EventGroupRegistrationsBoolExp>;
};


export type Query_RootEventGroupRegistrationsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEventGroupSequenceSeedingArgs = {
  distinctOn?: InputMaybe<Array<EventGroupSequenceSeedingSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGroupSequenceSeedingOrderBy>>;
  where?: InputMaybe<EventGroupSequenceSeedingBoolExp>;
};


export type Query_RootEventGroupSequenceSeedingAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventGroupSequenceSeedingSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGroupSequenceSeedingOrderBy>>;
  where?: InputMaybe<EventGroupSequenceSeedingBoolExp>;
};


export type Query_RootEventGroupSequenceSeedingByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEventGroupSequencesArgs = {
  distinctOn?: InputMaybe<Array<EventGroupSequencesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGroupSequencesOrderBy>>;
  where?: InputMaybe<EventGroupSequencesBoolExp>;
};


export type Query_RootEventGroupSequencesAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventGroupSequencesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGroupSequencesOrderBy>>;
  where?: InputMaybe<EventGroupSequencesBoolExp>;
};


export type Query_RootEventGroupSequencesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEventGroupTimeSlotsArgs = {
  distinctOn?: InputMaybe<Array<EventGroupTimeSlotsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGroupTimeSlotsOrderBy>>;
  where?: InputMaybe<EventGroupTimeSlotsBoolExp>;
};


export type Query_RootEventGroupTimeSlotsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventGroupTimeSlotsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGroupTimeSlotsOrderBy>>;
  where?: InputMaybe<EventGroupTimeSlotsBoolExp>;
};


export type Query_RootEventGroupTimeSlotsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEventGroupsArgs = {
  distinctOn?: InputMaybe<Array<EventGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGroupsOrderBy>>;
  where?: InputMaybe<EventGroupsBoolExp>;
};


export type Query_RootEventGroupsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGroupsOrderBy>>;
  where?: InputMaybe<EventGroupsBoolExp>;
};


export type Query_RootEventGroupsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEventInvitationStatusesArgs = {
  distinctOn?: InputMaybe<Array<EventInvitationStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventInvitationStatusesOrderBy>>;
  where?: InputMaybe<EventInvitationStatusesBoolExp>;
};


export type Query_RootEventInvitationStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventInvitationStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventInvitationStatusesOrderBy>>;
  where?: InputMaybe<EventInvitationStatusesBoolExp>;
};


export type Query_RootEventInvitationStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootEventInvitationTypesArgs = {
  distinctOn?: InputMaybe<Array<EventInvitationTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventInvitationTypesOrderBy>>;
  where?: InputMaybe<EventInvitationTypesBoolExp>;
};


export type Query_RootEventInvitationTypesAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventInvitationTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventInvitationTypesOrderBy>>;
  where?: InputMaybe<EventInvitationTypesBoolExp>;
};


export type Query_RootEventInvitationTypesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootEventInvitationsArgs = {
  distinctOn?: InputMaybe<Array<EventInvitationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventInvitationsOrderBy>>;
  where?: InputMaybe<EventInvitationsBoolExp>;
};


export type Query_RootEventInvitationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventInvitationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventInvitationsOrderBy>>;
  where?: InputMaybe<EventInvitationsBoolExp>;
};


export type Query_RootEventInvitationsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEventListingFeesArgs = {
  distinctOn?: InputMaybe<Array<EventListingFeesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventListingFeesOrderBy>>;
  where?: InputMaybe<EventListingFeesBoolExp>;
};


export type Query_RootEventListingFeesAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventListingFeesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventListingFeesOrderBy>>;
  where?: InputMaybe<EventListingFeesBoolExp>;
};


export type Query_RootEventListingFeesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEventMatchGamesArgs = {
  distinctOn?: InputMaybe<Array<EventMatchGamesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventMatchGamesOrderBy>>;
  where?: InputMaybe<EventMatchGamesBoolExp>;
};


export type Query_RootEventMatchGamesAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventMatchGamesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventMatchGamesOrderBy>>;
  where?: InputMaybe<EventMatchGamesBoolExp>;
};


export type Query_RootEventMatchGamesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEventMatchesArgs = {
  distinctOn?: InputMaybe<Array<EventMatchesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventMatchesOrderBy>>;
  where?: InputMaybe<EventMatchesBoolExp>;
};


export type Query_RootEventMatchesAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventMatchesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventMatchesOrderBy>>;
  where?: InputMaybe<EventMatchesBoolExp>;
};


export type Query_RootEventMatchesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEventMatchesTeamsArgs = {
  distinctOn?: InputMaybe<Array<EventMatchesTeamsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventMatchesTeamsOrderBy>>;
  where?: InputMaybe<EventMatchesTeamsBoolExp>;
};


export type Query_RootEventMatchesTeamsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventMatchesTeamsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventMatchesTeamsOrderBy>>;
  where?: InputMaybe<EventMatchesTeamsBoolExp>;
};


export type Query_RootEventMatchesTeamsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEventOrganizerAccountTypesArgs = {
  distinctOn?: InputMaybe<Array<EventOrganizerAccountTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventOrganizerAccountTypesOrderBy>>;
  where?: InputMaybe<EventOrganizerAccountTypesBoolExp>;
};


export type Query_RootEventOrganizerAccountTypesAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventOrganizerAccountTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventOrganizerAccountTypesOrderBy>>;
  where?: InputMaybe<EventOrganizerAccountTypesBoolExp>;
};


export type Query_RootEventOrganizerAccountTypesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootEventPlayerInviteStatusesArgs = {
  distinctOn?: InputMaybe<Array<EventPlayerInviteStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventPlayerInviteStatusesOrderBy>>;
  where?: InputMaybe<EventPlayerInviteStatusesBoolExp>;
};


export type Query_RootEventPlayerInviteStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventPlayerInviteStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventPlayerInviteStatusesOrderBy>>;
  where?: InputMaybe<EventPlayerInviteStatusesBoolExp>;
};


export type Query_RootEventPlayerInviteStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootEventPlayerInvitesArgs = {
  distinctOn?: InputMaybe<Array<EventPlayerInvitesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventPlayerInvitesOrderBy>>;
  where?: InputMaybe<EventPlayerInvitesBoolExp>;
};


export type Query_RootEventPlayerInvitesAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventPlayerInvitesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventPlayerInvitesOrderBy>>;
  where?: InputMaybe<EventPlayerInvitesBoolExp>;
};


export type Query_RootEventPlayerInvitesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEventPoolRoundsArgs = {
  distinctOn?: InputMaybe<Array<EventPoolRoundsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventPoolRoundsOrderBy>>;
  where?: InputMaybe<EventPoolRoundsBoolExp>;
};


export type Query_RootEventPoolRoundsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventPoolRoundsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventPoolRoundsOrderBy>>;
  where?: InputMaybe<EventPoolRoundsBoolExp>;
};


export type Query_RootEventPoolRoundsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEventPoolsTeamsArgs = {
  distinctOn?: InputMaybe<Array<EventPoolsTeamsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventPoolsTeamsOrderBy>>;
  where?: InputMaybe<EventPoolsTeamsBoolExp>;
};


export type Query_RootEventPoolsTeamsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventPoolsTeamsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventPoolsTeamsOrderBy>>;
  where?: InputMaybe<EventPoolsTeamsBoolExp>;
};


export type Query_RootEventPoolsTeamsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEventPrivacyArgs = {
  distinctOn?: InputMaybe<Array<EventPrivacySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventPrivacyOrderBy>>;
  where?: InputMaybe<EventPrivacyBoolExp>;
};


export type Query_RootEventPrivacyAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventPrivacySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventPrivacyOrderBy>>;
  where?: InputMaybe<EventPrivacyBoolExp>;
};


export type Query_RootEventPrivacyByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootEventRegistrationDetailsArgs = {
  distinctOn?: InputMaybe<Array<EventRegistrationDetailsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventRegistrationDetailsOrderBy>>;
  where?: InputMaybe<EventRegistrationDetailsBoolExp>;
};


export type Query_RootEventRegistrationDetailsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventRegistrationDetailsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventRegistrationDetailsOrderBy>>;
  where?: InputMaybe<EventRegistrationDetailsBoolExp>;
};


export type Query_RootEventRegistrationDetailsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEventRegistrationsArgs = {
  distinctOn?: InputMaybe<Array<EventRegistrationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventRegistrationsOrderBy>>;
  where?: InputMaybe<EventRegistrationsBoolExp>;
};


export type Query_RootEventRegistrationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventRegistrationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventRegistrationsOrderBy>>;
  where?: InputMaybe<EventRegistrationsBoolExp>;
};


export type Query_RootEventRegistrationsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEventSequenceCompleteReasonsArgs = {
  distinctOn?: InputMaybe<Array<EventSequenceCompleteReasonsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventSequenceCompleteReasonsOrderBy>>;
  where?: InputMaybe<EventSequenceCompleteReasonsBoolExp>;
};


export type Query_RootEventSequenceCompleteReasonsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventSequenceCompleteReasonsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventSequenceCompleteReasonsOrderBy>>;
  where?: InputMaybe<EventSequenceCompleteReasonsBoolExp>;
};


export type Query_RootEventSequenceCompleteReasonsByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootEventSkillLevelsArgs = {
  distinctOn?: InputMaybe<Array<EventSkillLevelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventSkillLevelsOrderBy>>;
  where?: InputMaybe<EventSkillLevelsBoolExp>;
};


export type Query_RootEventSkillLevelsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventSkillLevelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventSkillLevelsOrderBy>>;
  where?: InputMaybe<EventSkillLevelsBoolExp>;
};


export type Query_RootEventSkillLevelsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEventSponsorsArgs = {
  distinctOn?: InputMaybe<Array<EventSponsorsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventSponsorsOrderBy>>;
  where?: InputMaybe<EventSponsorsBoolExp>;
};


export type Query_RootEventSponsorsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventSponsorsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventSponsorsOrderBy>>;
  where?: InputMaybe<EventSponsorsBoolExp>;
};


export type Query_RootEventSponsorsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEventStatusesArgs = {
  distinctOn?: InputMaybe<Array<EventStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventStatusesOrderBy>>;
  where?: InputMaybe<EventStatusesBoolExp>;
};


export type Query_RootEventStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventStatusesOrderBy>>;
  where?: InputMaybe<EventStatusesBoolExp>;
};


export type Query_RootEventStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootEventTeamMemberStatusesArgs = {
  distinctOn?: InputMaybe<Array<EventTeamMemberStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventTeamMemberStatusesOrderBy>>;
  where?: InputMaybe<EventTeamMemberStatusesBoolExp>;
};


export type Query_RootEventTeamMemberStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventTeamMemberStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventTeamMemberStatusesOrderBy>>;
  where?: InputMaybe<EventTeamMemberStatusesBoolExp>;
};


export type Query_RootEventTeamMemberStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootEventTeamMembersArgs = {
  distinctOn?: InputMaybe<Array<EventTeamMembersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventTeamMembersOrderBy>>;
  where?: InputMaybe<EventTeamMembersBoolExp>;
};


export type Query_RootEventTeamMembersAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventTeamMembersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventTeamMembersOrderBy>>;
  where?: InputMaybe<EventTeamMembersBoolExp>;
};


export type Query_RootEventTeamMembersByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEventTeamStatusesArgs = {
  distinctOn?: InputMaybe<Array<EventTeamStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventTeamStatusesOrderBy>>;
  where?: InputMaybe<EventTeamStatusesBoolExp>;
};


export type Query_RootEventTeamStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventTeamStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventTeamStatusesOrderBy>>;
  where?: InputMaybe<EventTeamStatusesBoolExp>;
};


export type Query_RootEventTeamStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootEventTeamsArgs = {
  distinctOn?: InputMaybe<Array<EventTeamsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventTeamsOrderBy>>;
  where?: InputMaybe<EventTeamsBoolExp>;
};


export type Query_RootEventTeamsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventTeamsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventTeamsOrderBy>>;
  where?: InputMaybe<EventTeamsBoolExp>;
};


export type Query_RootEventTeamsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEventTransactionItemTypesArgs = {
  distinctOn?: InputMaybe<Array<EventTransactionItemTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventTransactionItemTypesOrderBy>>;
  where?: InputMaybe<EventTransactionItemTypesBoolExp>;
};


export type Query_RootEventTransactionItemTypesAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventTransactionItemTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventTransactionItemTypesOrderBy>>;
  where?: InputMaybe<EventTransactionItemTypesBoolExp>;
};


export type Query_RootEventTransactionItemTypesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootEventTransactionItemsArgs = {
  distinctOn?: InputMaybe<Array<EventTransactionItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventTransactionItemsOrderBy>>;
  where?: InputMaybe<EventTransactionItemsBoolExp>;
};


export type Query_RootEventTransactionItemsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventTransactionItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventTransactionItemsOrderBy>>;
  where?: InputMaybe<EventTransactionItemsBoolExp>;
};


export type Query_RootEventTransactionItemsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEventTransactionsArgs = {
  distinctOn?: InputMaybe<Array<EventTransactionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventTransactionsOrderBy>>;
  where?: InputMaybe<EventTransactionsBoolExp>;
};


export type Query_RootEventTransactionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventTransactionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventTransactionsOrderBy>>;
  where?: InputMaybe<EventTransactionsBoolExp>;
};


export type Query_RootEventTransactionsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEventTypesArgs = {
  distinctOn?: InputMaybe<Array<EventTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventTypesOrderBy>>;
  where?: InputMaybe<EventTypesBoolExp>;
};


export type Query_RootEventTypesAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventTypesOrderBy>>;
  where?: InputMaybe<EventTypesBoolExp>;
};


export type Query_RootEventTypesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootEventsArgs = {
  distinctOn?: InputMaybe<Array<EventsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventsOrderBy>>;
  where?: InputMaybe<EventsBoolExp>;
};


export type Query_RootEventsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventsOrderBy>>;
  where?: InputMaybe<EventsBoolExp>;
};


export type Query_RootEventsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootFeedbackSentimentArgs = {
  distinctOn?: InputMaybe<Array<FeedbackSentimentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FeedbackSentimentOrderBy>>;
  where?: InputMaybe<FeedbackSentimentBoolExp>;
};


export type Query_RootFeedbackSentimentAggregateArgs = {
  distinctOn?: InputMaybe<Array<FeedbackSentimentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FeedbackSentimentOrderBy>>;
  where?: InputMaybe<FeedbackSentimentBoolExp>;
};


export type Query_RootFeedbackSentimentByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootFileCategoryArgs = {
  distinctOn?: InputMaybe<Array<FileCategorySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FileCategoryOrderBy>>;
  where?: InputMaybe<FileCategoryBoolExp>;
};


export type Query_RootFileCategoryAggregateArgs = {
  distinctOn?: InputMaybe<Array<FileCategorySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FileCategoryOrderBy>>;
  where?: InputMaybe<FileCategoryBoolExp>;
};


export type Query_RootFileCategoryByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootFileFormatArgs = {
  distinctOn?: InputMaybe<Array<FileFormatSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FileFormatOrderBy>>;
  where?: InputMaybe<FileFormatBoolExp>;
};


export type Query_RootFileFormatAggregateArgs = {
  distinctOn?: InputMaybe<Array<FileFormatSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FileFormatOrderBy>>;
  where?: InputMaybe<FileFormatBoolExp>;
};


export type Query_RootFileFormatByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootFollowStatusesArgs = {
  distinctOn?: InputMaybe<Array<FollowStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FollowStatusesOrderBy>>;
  where?: InputMaybe<FollowStatusesBoolExp>;
};


export type Query_RootFollowStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<FollowStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FollowStatusesOrderBy>>;
  where?: InputMaybe<FollowStatusesBoolExp>;
};


export type Query_RootFollowStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootGameNetStatusesArgs = {
  distinctOn?: InputMaybe<Array<GameNetStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GameNetStatusesOrderBy>>;
  where?: InputMaybe<GameNetStatusesBoolExp>;
};


export type Query_RootGameNetStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<GameNetStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GameNetStatusesOrderBy>>;
  where?: InputMaybe<GameNetStatusesBoolExp>;
};


export type Query_RootGameNetStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootGenderArgs = {
  distinctOn?: InputMaybe<Array<GenderSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GenderOrderBy>>;
  where?: InputMaybe<GenderBoolExp>;
};


export type Query_RootGenderAggregateArgs = {
  distinctOn?: InputMaybe<Array<GenderSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GenderOrderBy>>;
  where?: InputMaybe<GenderBoolExp>;
};


export type Query_RootGenderByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootGroupCommentVotesArgs = {
  distinctOn?: InputMaybe<Array<GroupCommentVotesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupCommentVotesOrderBy>>;
  where?: InputMaybe<GroupCommentVotesBoolExp>;
};


export type Query_RootGroupCommentVotesAggregateArgs = {
  distinctOn?: InputMaybe<Array<GroupCommentVotesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupCommentVotesOrderBy>>;
  where?: InputMaybe<GroupCommentVotesBoolExp>;
};


export type Query_RootGroupCommentVotesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootGroupMembersArgs = {
  distinctOn?: InputMaybe<Array<GroupMembersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupMembersOrderBy>>;
  where?: InputMaybe<GroupMembersBoolExp>;
};


export type Query_RootGroupMembersAggregateArgs = {
  distinctOn?: InputMaybe<Array<GroupMembersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupMembersOrderBy>>;
  where?: InputMaybe<GroupMembersBoolExp>;
};


export type Query_RootGroupMembersByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootGroupThreadCommentFilesArgs = {
  distinctOn?: InputMaybe<Array<GroupThreadCommentFilesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupThreadCommentFilesOrderBy>>;
  where?: InputMaybe<GroupThreadCommentFilesBoolExp>;
};


export type Query_RootGroupThreadCommentFilesAggregateArgs = {
  distinctOn?: InputMaybe<Array<GroupThreadCommentFilesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupThreadCommentFilesOrderBy>>;
  where?: InputMaybe<GroupThreadCommentFilesBoolExp>;
};


export type Query_RootGroupThreadCommentFilesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootGroupThreadCommentsArgs = {
  distinctOn?: InputMaybe<Array<GroupThreadCommentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupThreadCommentsOrderBy>>;
  where?: InputMaybe<GroupThreadCommentsBoolExp>;
};


export type Query_RootGroupThreadCommentsAggregateArgs = {
  distinctOn?: InputMaybe<Array<GroupThreadCommentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupThreadCommentsOrderBy>>;
  where?: InputMaybe<GroupThreadCommentsBoolExp>;
};


export type Query_RootGroupThreadCommentsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootGroupThreadsArgs = {
  distinctOn?: InputMaybe<Array<GroupThreadsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupThreadsOrderBy>>;
  where?: InputMaybe<GroupThreadsBoolExp>;
};


export type Query_RootGroupThreadsAggregateArgs = {
  distinctOn?: InputMaybe<Array<GroupThreadsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupThreadsOrderBy>>;
  where?: InputMaybe<GroupThreadsBoolExp>;
};


export type Query_RootGroupThreadsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootGroupTypesArgs = {
  distinctOn?: InputMaybe<Array<GroupTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupTypesOrderBy>>;
  where?: InputMaybe<GroupTypesBoolExp>;
};


export type Query_RootGroupTypesAggregateArgs = {
  distinctOn?: InputMaybe<Array<GroupTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupTypesOrderBy>>;
  where?: InputMaybe<GroupTypesBoolExp>;
};


export type Query_RootGroupTypesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootGroupVenuesArgs = {
  distinctOn?: InputMaybe<Array<GroupVenuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupVenuesOrderBy>>;
  where?: InputMaybe<GroupVenuesBoolExp>;
};


export type Query_RootGroupVenuesAggregateArgs = {
  distinctOn?: InputMaybe<Array<GroupVenuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupVenuesOrderBy>>;
  where?: InputMaybe<GroupVenuesBoolExp>;
};


export type Query_RootGroupVenuesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootGroupsArgs = {
  distinctOn?: InputMaybe<Array<GroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupsOrderBy>>;
  where?: InputMaybe<GroupsBoolExp>;
};


export type Query_RootGroupsAggregateArgs = {
  distinctOn?: InputMaybe<Array<GroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupsOrderBy>>;
  where?: InputMaybe<GroupsBoolExp>;
};


export type Query_RootGroupsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootGroupsPlaySessionsArgs = {
  distinctOn?: InputMaybe<Array<GroupsPlaySessionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupsPlaySessionsOrderBy>>;
  where?: InputMaybe<GroupsPlaySessionsBoolExp>;
};


export type Query_RootGroupsPlaySessionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<GroupsPlaySessionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupsPlaySessionsOrderBy>>;
  where?: InputMaybe<GroupsPlaySessionsBoolExp>;
};


export type Query_RootGroupsPlaySessionsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootIdentityVerificationProvidersArgs = {
  distinctOn?: InputMaybe<Array<IdentityVerificationProvidersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IdentityVerificationProvidersOrderBy>>;
  where?: InputMaybe<IdentityVerificationProvidersBoolExp>;
};


export type Query_RootIdentityVerificationProvidersAggregateArgs = {
  distinctOn?: InputMaybe<Array<IdentityVerificationProvidersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IdentityVerificationProvidersOrderBy>>;
  where?: InputMaybe<IdentityVerificationProvidersBoolExp>;
};


export type Query_RootIdentityVerificationProvidersByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootIdentityVerificationStatusesArgs = {
  distinctOn?: InputMaybe<Array<IdentityVerificationStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IdentityVerificationStatusesOrderBy>>;
  where?: InputMaybe<IdentityVerificationStatusesBoolExp>;
};


export type Query_RootIdentityVerificationStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<IdentityVerificationStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IdentityVerificationStatusesOrderBy>>;
  where?: InputMaybe<IdentityVerificationStatusesBoolExp>;
};


export type Query_RootIdentityVerificationStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootInvoicesArgs = {
  distinctOn?: InputMaybe<Array<InvoicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoicesOrderBy>>;
  where?: InputMaybe<InvoicesBoolExp>;
};


export type Query_RootInvoicesAggregateArgs = {
  distinctOn?: InputMaybe<Array<InvoicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoicesOrderBy>>;
  where?: InputMaybe<InvoicesBoolExp>;
};


export type Query_RootInvoicesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootLearningProgramEnrollmentScheduleMediaWatchedArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramEnrollmentScheduleMediaWatchedSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramEnrollmentScheduleMediaWatchedOrderBy>>;
  where?: InputMaybe<LearningProgramEnrollmentScheduleMediaWatchedBoolExp>;
};


export type Query_RootLearningProgramEnrollmentScheduleMediaWatchedAggregateArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramEnrollmentScheduleMediaWatchedSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramEnrollmentScheduleMediaWatchedOrderBy>>;
  where?: InputMaybe<LearningProgramEnrollmentScheduleMediaWatchedBoolExp>;
};


export type Query_RootLearningProgramEnrollmentScheduleMediaWatchedByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootLearningProgramEnrollmentScheduleProgressArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramEnrollmentScheduleProgressSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramEnrollmentScheduleProgressOrderBy>>;
  where?: InputMaybe<LearningProgramEnrollmentScheduleProgressBoolExp>;
};


export type Query_RootLearningProgramEnrollmentScheduleProgressAggregateArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramEnrollmentScheduleProgressSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramEnrollmentScheduleProgressOrderBy>>;
  where?: InputMaybe<LearningProgramEnrollmentScheduleProgressBoolExp>;
};


export type Query_RootLearningProgramEnrollmentScheduleProgressByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootLearningProgramEnrollmentsArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramEnrollmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramEnrollmentsOrderBy>>;
  where?: InputMaybe<LearningProgramEnrollmentsBoolExp>;
};


export type Query_RootLearningProgramEnrollmentsAggregateArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramEnrollmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramEnrollmentsOrderBy>>;
  where?: InputMaybe<LearningProgramEnrollmentsBoolExp>;
};


export type Query_RootLearningProgramEnrollmentsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootLearningProgramMediaArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramMediaSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramMediaOrderBy>>;
  where?: InputMaybe<LearningProgramMediaBoolExp>;
};


export type Query_RootLearningProgramMediaAggregateArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramMediaSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramMediaOrderBy>>;
  where?: InputMaybe<LearningProgramMediaBoolExp>;
};


export type Query_RootLearningProgramMediaByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootLearningProgramMediaCategoriesArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramMediaCategoriesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramMediaCategoriesOrderBy>>;
  where?: InputMaybe<LearningProgramMediaCategoriesBoolExp>;
};


export type Query_RootLearningProgramMediaCategoriesAggregateArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramMediaCategoriesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramMediaCategoriesOrderBy>>;
  where?: InputMaybe<LearningProgramMediaCategoriesBoolExp>;
};


export type Query_RootLearningProgramMediaCategoriesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootLearningProgramScheduleMediaArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramScheduleMediaSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramScheduleMediaOrderBy>>;
  where?: InputMaybe<LearningProgramScheduleMediaBoolExp>;
};


export type Query_RootLearningProgramScheduleMediaAggregateArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramScheduleMediaSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramScheduleMediaOrderBy>>;
  where?: InputMaybe<LearningProgramScheduleMediaBoolExp>;
};


export type Query_RootLearningProgramScheduleMediaByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootLearningProgramScheduleUnitsArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramScheduleUnitsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramScheduleUnitsOrderBy>>;
  where?: InputMaybe<LearningProgramScheduleUnitsBoolExp>;
};


export type Query_RootLearningProgramScheduleUnitsAggregateArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramScheduleUnitsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramScheduleUnitsOrderBy>>;
  where?: InputMaybe<LearningProgramScheduleUnitsBoolExp>;
};


export type Query_RootLearningProgramScheduleUnitsByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootLearningProgramScheduleVideoSubmissionsArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramScheduleVideoSubmissionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramScheduleVideoSubmissionsOrderBy>>;
  where?: InputMaybe<LearningProgramScheduleVideoSubmissionsBoolExp>;
};


export type Query_RootLearningProgramScheduleVideoSubmissionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramScheduleVideoSubmissionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramScheduleVideoSubmissionsOrderBy>>;
  where?: InputMaybe<LearningProgramScheduleVideoSubmissionsBoolExp>;
};


export type Query_RootLearningProgramScheduleVideoSubmissionsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootLearningProgramSchedulesArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramSchedulesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramSchedulesOrderBy>>;
  where?: InputMaybe<LearningProgramSchedulesBoolExp>;
};


export type Query_RootLearningProgramSchedulesAggregateArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramSchedulesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramSchedulesOrderBy>>;
  where?: InputMaybe<LearningProgramSchedulesBoolExp>;
};


export type Query_RootLearningProgramSchedulesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootLearningProgramSkillLevelValuesArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramSkillLevelValuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramSkillLevelValuesOrderBy>>;
  where?: InputMaybe<LearningProgramSkillLevelValuesBoolExp>;
};


export type Query_RootLearningProgramSkillLevelValuesAggregateArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramSkillLevelValuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramSkillLevelValuesOrderBy>>;
  where?: InputMaybe<LearningProgramSkillLevelValuesBoolExp>;
};


export type Query_RootLearningProgramSkillLevelValuesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootLearningProgramSkillsArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramSkillsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramSkillsOrderBy>>;
  where?: InputMaybe<LearningProgramSkillsBoolExp>;
};


export type Query_RootLearningProgramSkillsAggregateArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramSkillsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramSkillsOrderBy>>;
  where?: InputMaybe<LearningProgramSkillsBoolExp>;
};


export type Query_RootLearningProgramSkillsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootLearningProgramsArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramsOrderBy>>;
  where?: InputMaybe<LearningProgramsBoolExp>;
};


export type Query_RootLearningProgramsAggregateArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramsOrderBy>>;
  where?: InputMaybe<LearningProgramsBoolExp>;
};


export type Query_RootLearningProgramsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootLessonAgeGroupsArgs = {
  distinctOn?: InputMaybe<Array<LessonAgeGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonAgeGroupsOrderBy>>;
  where?: InputMaybe<LessonAgeGroupsBoolExp>;
};


export type Query_RootLessonAgeGroupsAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonAgeGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonAgeGroupsOrderBy>>;
  where?: InputMaybe<LessonAgeGroupsBoolExp>;
};


export type Query_RootLessonAgeGroupsByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootLessonCollectionsArgs = {
  distinctOn?: InputMaybe<Array<LessonCollectionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonCollectionsOrderBy>>;
  where?: InputMaybe<LessonCollectionsBoolExp>;
};


export type Query_RootLessonCollectionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonCollectionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonCollectionsOrderBy>>;
  where?: InputMaybe<LessonCollectionsBoolExp>;
};


export type Query_RootLessonCollectionsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootLessonEquipmentArgs = {
  distinctOn?: InputMaybe<Array<LessonEquipmentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonEquipmentOrderBy>>;
  where?: InputMaybe<LessonEquipmentBoolExp>;
};


export type Query_RootLessonEquipmentAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonEquipmentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonEquipmentOrderBy>>;
  where?: InputMaybe<LessonEquipmentBoolExp>;
};


export type Query_RootLessonEquipmentByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootLessonEquipmentOptionsArgs = {
  distinctOn?: InputMaybe<Array<LessonEquipmentOptionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonEquipmentOptionsOrderBy>>;
  where?: InputMaybe<LessonEquipmentOptionsBoolExp>;
};


export type Query_RootLessonEquipmentOptionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonEquipmentOptionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonEquipmentOptionsOrderBy>>;
  where?: InputMaybe<LessonEquipmentOptionsBoolExp>;
};


export type Query_RootLessonEquipmentOptionsByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootLessonOrderItemsArgs = {
  distinctOn?: InputMaybe<Array<LessonOrderItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonOrderItemsOrderBy>>;
  where?: InputMaybe<LessonOrderItemsBoolExp>;
};


export type Query_RootLessonOrderItemsAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonOrderItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonOrderItemsOrderBy>>;
  where?: InputMaybe<LessonOrderItemsBoolExp>;
};


export type Query_RootLessonOrderItemsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootLessonOrdersArgs = {
  distinctOn?: InputMaybe<Array<LessonOrdersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonOrdersOrderBy>>;
  where?: InputMaybe<LessonOrdersBoolExp>;
};


export type Query_RootLessonOrdersAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonOrdersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonOrdersOrderBy>>;
  where?: InputMaybe<LessonOrdersBoolExp>;
};


export type Query_RootLessonOrdersByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootLessonParticipantStatusesArgs = {
  distinctOn?: InputMaybe<Array<LessonParticipantStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonParticipantStatusesOrderBy>>;
  where?: InputMaybe<LessonParticipantStatusesBoolExp>;
};


export type Query_RootLessonParticipantStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonParticipantStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonParticipantStatusesOrderBy>>;
  where?: InputMaybe<LessonParticipantStatusesBoolExp>;
};


export type Query_RootLessonParticipantStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootLessonParticipantsArgs = {
  distinctOn?: InputMaybe<Array<LessonParticipantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonParticipantsOrderBy>>;
  where?: InputMaybe<LessonParticipantsBoolExp>;
};


export type Query_RootLessonParticipantsAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonParticipantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonParticipantsOrderBy>>;
  where?: InputMaybe<LessonParticipantsBoolExp>;
};


export type Query_RootLessonParticipantsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootLessonPlayerSkillAssessmentCategoriesArgs = {
  distinctOn?: InputMaybe<Array<LessonPlayerSkillAssessmentCategoriesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonPlayerSkillAssessmentCategoriesOrderBy>>;
  where?: InputMaybe<LessonPlayerSkillAssessmentCategoriesBoolExp>;
};


export type Query_RootLessonPlayerSkillAssessmentCategoriesAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonPlayerSkillAssessmentCategoriesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonPlayerSkillAssessmentCategoriesOrderBy>>;
  where?: InputMaybe<LessonPlayerSkillAssessmentCategoriesBoolExp>;
};


export type Query_RootLessonPlayerSkillAssessmentCategoriesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootLessonPlayerSkillAssessmentsArgs = {
  distinctOn?: InputMaybe<Array<LessonPlayerSkillAssessmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonPlayerSkillAssessmentsOrderBy>>;
  where?: InputMaybe<LessonPlayerSkillAssessmentsBoolExp>;
};


export type Query_RootLessonPlayerSkillAssessmentsAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonPlayerSkillAssessmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonPlayerSkillAssessmentsOrderBy>>;
  where?: InputMaybe<LessonPlayerSkillAssessmentsBoolExp>;
};


export type Query_RootLessonPlayerSkillAssessmentsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootLessonPlayerSkillAssessmentsSkillsArgs = {
  distinctOn?: InputMaybe<Array<LessonPlayerSkillAssessmentsSkillsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonPlayerSkillAssessmentsSkillsOrderBy>>;
  where?: InputMaybe<LessonPlayerSkillAssessmentsSkillsBoolExp>;
};


export type Query_RootLessonPlayerSkillAssessmentsSkillsAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonPlayerSkillAssessmentsSkillsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonPlayerSkillAssessmentsSkillsOrderBy>>;
  where?: InputMaybe<LessonPlayerSkillAssessmentsSkillsBoolExp>;
};


export type Query_RootLessonPlayerSkillAssessmentsSkillsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootLessonPrivacyArgs = {
  distinctOn?: InputMaybe<Array<LessonPrivacySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonPrivacyOrderBy>>;
  where?: InputMaybe<LessonPrivacyBoolExp>;
};


export type Query_RootLessonPrivacyAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonPrivacySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonPrivacyOrderBy>>;
  where?: InputMaybe<LessonPrivacyBoolExp>;
};


export type Query_RootLessonPrivacyByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootLessonReflectionCommentTypesArgs = {
  distinctOn?: InputMaybe<Array<LessonReflectionCommentTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonReflectionCommentTypesOrderBy>>;
  where?: InputMaybe<LessonReflectionCommentTypesBoolExp>;
};


export type Query_RootLessonReflectionCommentTypesAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonReflectionCommentTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonReflectionCommentTypesOrderBy>>;
  where?: InputMaybe<LessonReflectionCommentTypesBoolExp>;
};


export type Query_RootLessonReflectionCommentTypesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootLessonReflectionCommentsArgs = {
  distinctOn?: InputMaybe<Array<LessonReflectionCommentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonReflectionCommentsOrderBy>>;
  where?: InputMaybe<LessonReflectionCommentsBoolExp>;
};


export type Query_RootLessonReflectionCommentsAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonReflectionCommentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonReflectionCommentsOrderBy>>;
  where?: InputMaybe<LessonReflectionCommentsBoolExp>;
};


export type Query_RootLessonReflectionCommentsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootLessonReflectionFilesArgs = {
  distinctOn?: InputMaybe<Array<LessonReflectionFilesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonReflectionFilesOrderBy>>;
  where?: InputMaybe<LessonReflectionFilesBoolExp>;
};


export type Query_RootLessonReflectionFilesAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonReflectionFilesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonReflectionFilesOrderBy>>;
  where?: InputMaybe<LessonReflectionFilesBoolExp>;
};


export type Query_RootLessonReflectionFilesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootLessonReflectionsArgs = {
  distinctOn?: InputMaybe<Array<LessonReflectionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonReflectionsOrderBy>>;
  where?: InputMaybe<LessonReflectionsBoolExp>;
};


export type Query_RootLessonReflectionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonReflectionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonReflectionsOrderBy>>;
  where?: InputMaybe<LessonReflectionsBoolExp>;
};


export type Query_RootLessonReflectionsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootLessonSkillCategoriesArgs = {
  distinctOn?: InputMaybe<Array<LessonSkillCategoriesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonSkillCategoriesOrderBy>>;
  where?: InputMaybe<LessonSkillCategoriesBoolExp>;
};


export type Query_RootLessonSkillCategoriesAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonSkillCategoriesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonSkillCategoriesOrderBy>>;
  where?: InputMaybe<LessonSkillCategoriesBoolExp>;
};


export type Query_RootLessonSkillCategoriesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootLessonSkillDisplayNamesArgs = {
  distinctOn?: InputMaybe<Array<LessonSkillDisplayNamesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonSkillDisplayNamesOrderBy>>;
  where?: InputMaybe<LessonSkillDisplayNamesBoolExp>;
};


export type Query_RootLessonSkillDisplayNamesAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonSkillDisplayNamesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonSkillDisplayNamesOrderBy>>;
  where?: InputMaybe<LessonSkillDisplayNamesBoolExp>;
};


export type Query_RootLessonSkillDisplayNamesByPkArgs = {
  id: LessonSkillsEnum;
};


export type Query_RootLessonSkillLevelsArgs = {
  distinctOn?: InputMaybe<Array<LessonSkillLevelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonSkillLevelsOrderBy>>;
  where?: InputMaybe<LessonSkillLevelsBoolExp>;
};


export type Query_RootLessonSkillLevelsAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonSkillLevelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonSkillLevelsOrderBy>>;
  where?: InputMaybe<LessonSkillLevelsBoolExp>;
};


export type Query_RootLessonSkillLevelsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootLessonSkillMappingsArgs = {
  distinctOn?: InputMaybe<Array<LessonSkillMappingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonSkillMappingsOrderBy>>;
  where?: InputMaybe<LessonSkillMappingsBoolExp>;
};


export type Query_RootLessonSkillMappingsAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonSkillMappingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonSkillMappingsOrderBy>>;
  where?: InputMaybe<LessonSkillMappingsBoolExp>;
};


export type Query_RootLessonSkillMappingsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootLessonSkillsArgs = {
  distinctOn?: InputMaybe<Array<LessonSkillsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonSkillsOrderBy>>;
  where?: InputMaybe<LessonSkillsBoolExp>;
};


export type Query_RootLessonSkillsAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonSkillsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonSkillsOrderBy>>;
  where?: InputMaybe<LessonSkillsBoolExp>;
};


export type Query_RootLessonSkillsByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootLessonStatusesArgs = {
  distinctOn?: InputMaybe<Array<LessonStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonStatusesOrderBy>>;
  where?: InputMaybe<LessonStatusesBoolExp>;
};


export type Query_RootLessonStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonStatusesOrderBy>>;
  where?: InputMaybe<LessonStatusesBoolExp>;
};


export type Query_RootLessonStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootLessonTemplateSkillLevelsArgs = {
  distinctOn?: InputMaybe<Array<LessonTemplateSkillLevelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonTemplateSkillLevelsOrderBy>>;
  where?: InputMaybe<LessonTemplateSkillLevelsBoolExp>;
};


export type Query_RootLessonTemplateSkillLevelsAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonTemplateSkillLevelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonTemplateSkillLevelsOrderBy>>;
  where?: InputMaybe<LessonTemplateSkillLevelsBoolExp>;
};


export type Query_RootLessonTemplateSkillLevelsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootLessonTemplatesArgs = {
  distinctOn?: InputMaybe<Array<LessonTemplatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonTemplatesOrderBy>>;
  where?: InputMaybe<LessonTemplatesBoolExp>;
};


export type Query_RootLessonTemplatesAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonTemplatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonTemplatesOrderBy>>;
  where?: InputMaybe<LessonTemplatesBoolExp>;
};


export type Query_RootLessonTemplatesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootLessonTimesArgs = {
  distinctOn?: InputMaybe<Array<LessonTimesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonTimesOrderBy>>;
  where?: InputMaybe<LessonTimesBoolExp>;
};


export type Query_RootLessonTimesAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonTimesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonTimesOrderBy>>;
  where?: InputMaybe<LessonTimesBoolExp>;
};


export type Query_RootLessonTimesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootLessonTypesArgs = {
  distinctOn?: InputMaybe<Array<LessonTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonTypesOrderBy>>;
  where?: InputMaybe<LessonTypesBoolExp>;
};


export type Query_RootLessonTypesAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonTypesOrderBy>>;
  where?: InputMaybe<LessonTypesBoolExp>;
};


export type Query_RootLessonTypesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootLessonWaitlistStatusesArgs = {
  distinctOn?: InputMaybe<Array<LessonWaitlistStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonWaitlistStatusesOrderBy>>;
  where?: InputMaybe<LessonWaitlistStatusesBoolExp>;
};


export type Query_RootLessonWaitlistStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonWaitlistStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonWaitlistStatusesOrderBy>>;
  where?: InputMaybe<LessonWaitlistStatusesBoolExp>;
};


export type Query_RootLessonWaitlistStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootLessonWaitlistsArgs = {
  distinctOn?: InputMaybe<Array<LessonWaitlistsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonWaitlistsOrderBy>>;
  where?: InputMaybe<LessonWaitlistsBoolExp>;
};


export type Query_RootLessonWaitlistsAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonWaitlistsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonWaitlistsOrderBy>>;
  where?: InputMaybe<LessonWaitlistsBoolExp>;
};


export type Query_RootLessonWaitlistsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootLessonsArgs = {
  distinctOn?: InputMaybe<Array<LessonsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonsOrderBy>>;
  where?: InputMaybe<LessonsBoolExp>;
};


export type Query_RootLessonsAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonsOrderBy>>;
  where?: InputMaybe<LessonsBoolExp>;
};


export type Query_RootLessonsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootMatchSelectionCriteriaArgs = {
  distinctOn?: InputMaybe<Array<MatchSelectionCriteriaSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MatchSelectionCriteriaOrderBy>>;
  where?: InputMaybe<MatchSelectionCriteriaBoolExp>;
};


export type Query_RootMatchSelectionCriteriaAggregateArgs = {
  distinctOn?: InputMaybe<Array<MatchSelectionCriteriaSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MatchSelectionCriteriaOrderBy>>;
  where?: InputMaybe<MatchSelectionCriteriaBoolExp>;
};


export type Query_RootMatchSelectionCriteriaByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootMessagesArgs = {
  distinctOn?: InputMaybe<Array<MessagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MessagesOrderBy>>;
  where?: InputMaybe<MessagesBoolExp>;
};


export type Query_RootMessagesAggregateArgs = {
  distinctOn?: InputMaybe<Array<MessagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MessagesOrderBy>>;
  where?: InputMaybe<MessagesBoolExp>;
};


export type Query_RootMessagesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootNeighborhoodsArgs = {
  distinctOn?: InputMaybe<Array<NeighborhoodsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NeighborhoodsOrderBy>>;
  where?: InputMaybe<NeighborhoodsBoolExp>;
};


export type Query_RootNeighborhoodsAggregateArgs = {
  distinctOn?: InputMaybe<Array<NeighborhoodsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NeighborhoodsOrderBy>>;
  where?: InputMaybe<NeighborhoodsBoolExp>;
};


export type Query_RootNeighborhoodsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootNotificationActionTypesArgs = {
  distinctOn?: InputMaybe<Array<NotificationActionTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NotificationActionTypesOrderBy>>;
  where?: InputMaybe<NotificationActionTypesBoolExp>;
};


export type Query_RootNotificationActionTypesAggregateArgs = {
  distinctOn?: InputMaybe<Array<NotificationActionTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NotificationActionTypesOrderBy>>;
  where?: InputMaybe<NotificationActionTypesBoolExp>;
};


export type Query_RootNotificationActionTypesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootNotificationStatusesArgs = {
  distinctOn?: InputMaybe<Array<NotificationStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NotificationStatusesOrderBy>>;
  where?: InputMaybe<NotificationStatusesBoolExp>;
};


export type Query_RootNotificationStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<NotificationStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NotificationStatusesOrderBy>>;
  where?: InputMaybe<NotificationStatusesBoolExp>;
};


export type Query_RootNotificationStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootOrderStatusesArgs = {
  distinctOn?: InputMaybe<Array<OrderStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrderStatusesOrderBy>>;
  where?: InputMaybe<OrderStatusesBoolExp>;
};


export type Query_RootOrderStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<OrderStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrderStatusesOrderBy>>;
  where?: InputMaybe<OrderStatusesBoolExp>;
};


export type Query_RootOrderStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootPadelRatingScalesArgs = {
  distinctOn?: InputMaybe<Array<PadelRatingScalesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PadelRatingScalesOrderBy>>;
  where?: InputMaybe<PadelRatingScalesBoolExp>;
};


export type Query_RootPadelRatingScalesAggregateArgs = {
  distinctOn?: InputMaybe<Array<PadelRatingScalesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PadelRatingScalesOrderBy>>;
  where?: InputMaybe<PadelRatingScalesBoolExp>;
};


export type Query_RootPadelRatingScalesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootParticipantRolesArgs = {
  distinctOn?: InputMaybe<Array<ParticipantRolesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ParticipantRolesOrderBy>>;
  where?: InputMaybe<ParticipantRolesBoolExp>;
};


export type Query_RootParticipantRolesAggregateArgs = {
  distinctOn?: InputMaybe<Array<ParticipantRolesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ParticipantRolesOrderBy>>;
  where?: InputMaybe<ParticipantRolesBoolExp>;
};


export type Query_RootParticipantRolesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootPartnerBookingAttemptEventsArgs = {
  distinctOn?: InputMaybe<Array<PartnerBookingAttemptEventsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PartnerBookingAttemptEventsOrderBy>>;
  where?: InputMaybe<PartnerBookingAttemptEventsBoolExp>;
};


export type Query_RootPartnerBookingAttemptEventsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PartnerBookingAttemptEventsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PartnerBookingAttemptEventsOrderBy>>;
  where?: InputMaybe<PartnerBookingAttemptEventsBoolExp>;
};


export type Query_RootPartnerBookingAttemptEventsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPartnerBookingAttemptStatusesArgs = {
  distinctOn?: InputMaybe<Array<PartnerBookingAttemptStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PartnerBookingAttemptStatusesOrderBy>>;
  where?: InputMaybe<PartnerBookingAttemptStatusesBoolExp>;
};


export type Query_RootPartnerBookingAttemptStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<PartnerBookingAttemptStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PartnerBookingAttemptStatusesOrderBy>>;
  where?: InputMaybe<PartnerBookingAttemptStatusesBoolExp>;
};


export type Query_RootPartnerBookingAttemptStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootPartnerBookingAttemptsArgs = {
  distinctOn?: InputMaybe<Array<PartnerBookingAttemptsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PartnerBookingAttemptsOrderBy>>;
  where?: InputMaybe<PartnerBookingAttemptsBoolExp>;
};


export type Query_RootPartnerBookingAttemptsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PartnerBookingAttemptsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PartnerBookingAttemptsOrderBy>>;
  where?: InputMaybe<PartnerBookingAttemptsBoolExp>;
};


export type Query_RootPartnerBookingAttemptsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPartnerBookingEnginesArgs = {
  distinctOn?: InputMaybe<Array<PartnerBookingEnginesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PartnerBookingEnginesOrderBy>>;
  where?: InputMaybe<PartnerBookingEnginesBoolExp>;
};


export type Query_RootPartnerBookingEnginesAggregateArgs = {
  distinctOn?: InputMaybe<Array<PartnerBookingEnginesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PartnerBookingEnginesOrderBy>>;
  where?: InputMaybe<PartnerBookingEnginesBoolExp>;
};


export type Query_RootPartnerBookingEnginesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootPartnerBookingEventSourcesArgs = {
  distinctOn?: InputMaybe<Array<PartnerBookingEventSourcesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PartnerBookingEventSourcesOrderBy>>;
  where?: InputMaybe<PartnerBookingEventSourcesBoolExp>;
};


export type Query_RootPartnerBookingEventSourcesAggregateArgs = {
  distinctOn?: InputMaybe<Array<PartnerBookingEventSourcesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PartnerBookingEventSourcesOrderBy>>;
  where?: InputMaybe<PartnerBookingEventSourcesBoolExp>;
};


export type Query_RootPartnerBookingEventSourcesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootPartnerBookingHoldsArgs = {
  distinctOn?: InputMaybe<Array<PartnerBookingHoldsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PartnerBookingHoldsOrderBy>>;
  where?: InputMaybe<PartnerBookingHoldsBoolExp>;
};


export type Query_RootPartnerBookingHoldsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PartnerBookingHoldsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PartnerBookingHoldsOrderBy>>;
  where?: InputMaybe<PartnerBookingHoldsBoolExp>;
};


export type Query_RootPartnerBookingHoldsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPartnerBookingOrderStatusesArgs = {
  distinctOn?: InputMaybe<Array<PartnerBookingOrderStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PartnerBookingOrderStatusesOrderBy>>;
  where?: InputMaybe<PartnerBookingOrderStatusesBoolExp>;
};


export type Query_RootPartnerBookingOrderStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<PartnerBookingOrderStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PartnerBookingOrderStatusesOrderBy>>;
  where?: InputMaybe<PartnerBookingOrderStatusesBoolExp>;
};


export type Query_RootPartnerBookingOrderStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootPartnerBookingOrdersArgs = {
  distinctOn?: InputMaybe<Array<PartnerBookingOrdersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PartnerBookingOrdersOrderBy>>;
  where?: InputMaybe<PartnerBookingOrdersBoolExp>;
};


export type Query_RootPartnerBookingOrdersAggregateArgs = {
  distinctOn?: InputMaybe<Array<PartnerBookingOrdersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PartnerBookingOrdersOrderBy>>;
  where?: InputMaybe<PartnerBookingOrdersBoolExp>;
};


export type Query_RootPartnerBookingOrdersByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPartnerBookingVerificationMethodsArgs = {
  distinctOn?: InputMaybe<Array<PartnerBookingVerificationMethodsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PartnerBookingVerificationMethodsOrderBy>>;
  where?: InputMaybe<PartnerBookingVerificationMethodsBoolExp>;
};


export type Query_RootPartnerBookingVerificationMethodsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PartnerBookingVerificationMethodsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PartnerBookingVerificationMethodsOrderBy>>;
  where?: InputMaybe<PartnerBookingVerificationMethodsBoolExp>;
};


export type Query_RootPartnerBookingVerificationMethodsByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootPaymentFulfillmentChannelsArgs = {
  distinctOn?: InputMaybe<Array<PaymentFulfillmentChannelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentFulfillmentChannelsOrderBy>>;
  where?: InputMaybe<PaymentFulfillmentChannelsBoolExp>;
};


export type Query_RootPaymentFulfillmentChannelsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PaymentFulfillmentChannelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentFulfillmentChannelsOrderBy>>;
  where?: InputMaybe<PaymentFulfillmentChannelsBoolExp>;
};


export type Query_RootPaymentFulfillmentChannelsByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootPaymentProcessorsArgs = {
  distinctOn?: InputMaybe<Array<PaymentProcessorsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentProcessorsOrderBy>>;
  where?: InputMaybe<PaymentProcessorsBoolExp>;
};


export type Query_RootPaymentProcessorsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PaymentProcessorsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentProcessorsOrderBy>>;
  where?: InputMaybe<PaymentProcessorsBoolExp>;
};


export type Query_RootPaymentProcessorsByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootPaymentStatusesArgs = {
  distinctOn?: InputMaybe<Array<PaymentStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentStatusesOrderBy>>;
  where?: InputMaybe<PaymentStatusesBoolExp>;
};


export type Query_RootPaymentStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<PaymentStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentStatusesOrderBy>>;
  where?: InputMaybe<PaymentStatusesBoolExp>;
};


export type Query_RootPaymentStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootPickleballRatingScalesArgs = {
  distinctOn?: InputMaybe<Array<PickleballRatingScalesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PickleballRatingScalesOrderBy>>;
  where?: InputMaybe<PickleballRatingScalesBoolExp>;
};


export type Query_RootPickleballRatingScalesAggregateArgs = {
  distinctOn?: InputMaybe<Array<PickleballRatingScalesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PickleballRatingScalesOrderBy>>;
  where?: InputMaybe<PickleballRatingScalesBoolExp>;
};


export type Query_RootPickleballRatingScalesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPlatformSubscriptionIntervalsArgs = {
  distinctOn?: InputMaybe<Array<PlatformSubscriptionIntervalsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlatformSubscriptionIntervalsOrderBy>>;
  where?: InputMaybe<PlatformSubscriptionIntervalsBoolExp>;
};


export type Query_RootPlatformSubscriptionIntervalsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PlatformSubscriptionIntervalsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlatformSubscriptionIntervalsOrderBy>>;
  where?: InputMaybe<PlatformSubscriptionIntervalsBoolExp>;
};


export type Query_RootPlatformSubscriptionIntervalsByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootPlatformSubscriptionPersonasArgs = {
  distinctOn?: InputMaybe<Array<PlatformSubscriptionPersonasSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlatformSubscriptionPersonasOrderBy>>;
  where?: InputMaybe<PlatformSubscriptionPersonasBoolExp>;
};


export type Query_RootPlatformSubscriptionPersonasAggregateArgs = {
  distinctOn?: InputMaybe<Array<PlatformSubscriptionPersonasSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlatformSubscriptionPersonasOrderBy>>;
  where?: InputMaybe<PlatformSubscriptionPersonasBoolExp>;
};


export type Query_RootPlatformSubscriptionPersonasByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootPlatformSubscriptionPlanPricesArgs = {
  distinctOn?: InputMaybe<Array<PlatformSubscriptionPlanPricesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlatformSubscriptionPlanPricesOrderBy>>;
  where?: InputMaybe<PlatformSubscriptionPlanPricesBoolExp>;
};


export type Query_RootPlatformSubscriptionPlanPricesAggregateArgs = {
  distinctOn?: InputMaybe<Array<PlatformSubscriptionPlanPricesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlatformSubscriptionPlanPricesOrderBy>>;
  where?: InputMaybe<PlatformSubscriptionPlanPricesBoolExp>;
};


export type Query_RootPlatformSubscriptionPlanPricesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPlatformSubscriptionPlansArgs = {
  distinctOn?: InputMaybe<Array<PlatformSubscriptionPlansSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlatformSubscriptionPlansOrderBy>>;
  where?: InputMaybe<PlatformSubscriptionPlansBoolExp>;
};


export type Query_RootPlatformSubscriptionPlansAggregateArgs = {
  distinctOn?: InputMaybe<Array<PlatformSubscriptionPlansSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlatformSubscriptionPlansOrderBy>>;
  where?: InputMaybe<PlatformSubscriptionPlansBoolExp>;
};


export type Query_RootPlatformSubscriptionPlansByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPlatformSubscriptionsArgs = {
  distinctOn?: InputMaybe<Array<PlatformSubscriptionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlatformSubscriptionsOrderBy>>;
  where?: InputMaybe<PlatformSubscriptionsBoolExp>;
};


export type Query_RootPlatformSubscriptionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PlatformSubscriptionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlatformSubscriptionsOrderBy>>;
  where?: InputMaybe<PlatformSubscriptionsBoolExp>;
};


export type Query_RootPlatformSubscriptionsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPlayRequestNeighborhoodsArgs = {
  distinctOn?: InputMaybe<Array<PlayRequestNeighborhoodsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayRequestNeighborhoodsOrderBy>>;
  where?: InputMaybe<PlayRequestNeighborhoodsBoolExp>;
};


export type Query_RootPlayRequestNeighborhoodsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PlayRequestNeighborhoodsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayRequestNeighborhoodsOrderBy>>;
  where?: InputMaybe<PlayRequestNeighborhoodsBoolExp>;
};


export type Query_RootPlayRequestNeighborhoodsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPlayRequestSlotsArgs = {
  distinctOn?: InputMaybe<Array<PlayRequestSlotsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayRequestSlotsOrderBy>>;
  where?: InputMaybe<PlayRequestSlotsBoolExp>;
};


export type Query_RootPlayRequestSlotsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PlayRequestSlotsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayRequestSlotsOrderBy>>;
  where?: InputMaybe<PlayRequestSlotsBoolExp>;
};


export type Query_RootPlayRequestSlotsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPlayRequestStatusesArgs = {
  distinctOn?: InputMaybe<Array<PlayRequestStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayRequestStatusesOrderBy>>;
  where?: InputMaybe<PlayRequestStatusesBoolExp>;
};


export type Query_RootPlayRequestStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<PlayRequestStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayRequestStatusesOrderBy>>;
  where?: InputMaybe<PlayRequestStatusesBoolExp>;
};


export type Query_RootPlayRequestStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootPlayRequestVenuesArgs = {
  distinctOn?: InputMaybe<Array<PlayRequestVenuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayRequestVenuesOrderBy>>;
  where?: InputMaybe<PlayRequestVenuesBoolExp>;
};


export type Query_RootPlayRequestVenuesAggregateArgs = {
  distinctOn?: InputMaybe<Array<PlayRequestVenuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayRequestVenuesOrderBy>>;
  where?: InputMaybe<PlayRequestVenuesBoolExp>;
};


export type Query_RootPlayRequestVenuesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPlayRequestsArgs = {
  distinctOn?: InputMaybe<Array<PlayRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayRequestsOrderBy>>;
  where?: InputMaybe<PlayRequestsBoolExp>;
};


export type Query_RootPlayRequestsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PlayRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayRequestsOrderBy>>;
  where?: InputMaybe<PlayRequestsBoolExp>;
};


export type Query_RootPlayRequestsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPlaySessionCommentsArgs = {
  distinctOn?: InputMaybe<Array<PlaySessionCommentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlaySessionCommentsOrderBy>>;
  where?: InputMaybe<PlaySessionCommentsBoolExp>;
};


export type Query_RootPlaySessionCommentsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PlaySessionCommentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlaySessionCommentsOrderBy>>;
  where?: InputMaybe<PlaySessionCommentsBoolExp>;
};


export type Query_RootPlaySessionCommentsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPlaySessionCourtBookingStatusesArgs = {
  distinctOn?: InputMaybe<Array<PlaySessionCourtBookingStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlaySessionCourtBookingStatusesOrderBy>>;
  where?: InputMaybe<PlaySessionCourtBookingStatusesBoolExp>;
};


export type Query_RootPlaySessionCourtBookingStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<PlaySessionCourtBookingStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlaySessionCourtBookingStatusesOrderBy>>;
  where?: InputMaybe<PlaySessionCourtBookingStatusesBoolExp>;
};


export type Query_RootPlaySessionCourtBookingStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootPlaySessionFormatsArgs = {
  distinctOn?: InputMaybe<Array<PlaySessionFormatsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlaySessionFormatsOrderBy>>;
  where?: InputMaybe<PlaySessionFormatsBoolExp>;
};


export type Query_RootPlaySessionFormatsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PlaySessionFormatsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlaySessionFormatsOrderBy>>;
  where?: InputMaybe<PlaySessionFormatsBoolExp>;
};


export type Query_RootPlaySessionFormatsByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootPlaySessionMatchCompetitivenessArgs = {
  distinctOn?: InputMaybe<Array<PlaySessionMatchCompetitivenessSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlaySessionMatchCompetitivenessOrderBy>>;
  where?: InputMaybe<PlaySessionMatchCompetitivenessBoolExp>;
};


export type Query_RootPlaySessionMatchCompetitivenessAggregateArgs = {
  distinctOn?: InputMaybe<Array<PlaySessionMatchCompetitivenessSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlaySessionMatchCompetitivenessOrderBy>>;
  where?: InputMaybe<PlaySessionMatchCompetitivenessBoolExp>;
};


export type Query_RootPlaySessionMatchCompetitivenessByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootPlaySessionParticipantStatusesArgs = {
  distinctOn?: InputMaybe<Array<PlaySessionParticipantStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlaySessionParticipantStatusesOrderBy>>;
  where?: InputMaybe<PlaySessionParticipantStatusesBoolExp>;
};


export type Query_RootPlaySessionParticipantStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<PlaySessionParticipantStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlaySessionParticipantStatusesOrderBy>>;
  where?: InputMaybe<PlaySessionParticipantStatusesBoolExp>;
};


export type Query_RootPlaySessionParticipantStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootPlaySessionParticipantsArgs = {
  distinctOn?: InputMaybe<Array<PlaySessionParticipantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlaySessionParticipantsOrderBy>>;
  where?: InputMaybe<PlaySessionParticipantsBoolExp>;
};


export type Query_RootPlaySessionParticipantsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PlaySessionParticipantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlaySessionParticipantsOrderBy>>;
  where?: InputMaybe<PlaySessionParticipantsBoolExp>;
};


export type Query_RootPlaySessionParticipantsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPlaySessionPrivacyArgs = {
  distinctOn?: InputMaybe<Array<PlaySessionPrivacySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlaySessionPrivacyOrderBy>>;
  where?: InputMaybe<PlaySessionPrivacyBoolExp>;
};


export type Query_RootPlaySessionPrivacyAggregateArgs = {
  distinctOn?: InputMaybe<Array<PlaySessionPrivacySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlaySessionPrivacyOrderBy>>;
  where?: InputMaybe<PlaySessionPrivacyBoolExp>;
};


export type Query_RootPlaySessionPrivacyByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootPlaySessionStatusesArgs = {
  distinctOn?: InputMaybe<Array<PlaySessionStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlaySessionStatusesOrderBy>>;
  where?: InputMaybe<PlaySessionStatusesBoolExp>;
};


export type Query_RootPlaySessionStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<PlaySessionStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlaySessionStatusesOrderBy>>;
  where?: InputMaybe<PlaySessionStatusesBoolExp>;
};


export type Query_RootPlaySessionStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootPlaySessionsArgs = {
  distinctOn?: InputMaybe<Array<PlaySessionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlaySessionsOrderBy>>;
  where?: InputMaybe<PlaySessionsBoolExp>;
};


export type Query_RootPlaySessionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PlaySessionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlaySessionsOrderBy>>;
  where?: InputMaybe<PlaySessionsBoolExp>;
};


export type Query_RootPlaySessionsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPlayerAvailabilitiesArgs = {
  distinctOn?: InputMaybe<Array<PlayerAvailabilitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayerAvailabilitiesOrderBy>>;
  where?: InputMaybe<PlayerAvailabilitiesBoolExp>;
};


export type Query_RootPlayerAvailabilitiesAggregateArgs = {
  distinctOn?: InputMaybe<Array<PlayerAvailabilitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayerAvailabilitiesOrderBy>>;
  where?: InputMaybe<PlayerAvailabilitiesBoolExp>;
};


export type Query_RootPlayerAvailabilitiesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPlayerAvailabilityNeighborhoodsArgs = {
  distinctOn?: InputMaybe<Array<PlayerAvailabilityNeighborhoodsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayerAvailabilityNeighborhoodsOrderBy>>;
  where?: InputMaybe<PlayerAvailabilityNeighborhoodsBoolExp>;
};


export type Query_RootPlayerAvailabilityNeighborhoodsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PlayerAvailabilityNeighborhoodsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayerAvailabilityNeighborhoodsOrderBy>>;
  where?: InputMaybe<PlayerAvailabilityNeighborhoodsBoolExp>;
};


export type Query_RootPlayerAvailabilityNeighborhoodsByPkArgs = {
  availabilityId: Scalars['uuid'];
  neighborhoodId: Scalars['uuid'];
};


export type Query_RootPlayerAvailabilityRatingScalesArgs = {
  distinctOn?: InputMaybe<Array<PlayerAvailabilityRatingScalesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayerAvailabilityRatingScalesOrderBy>>;
  where?: InputMaybe<PlayerAvailabilityRatingScalesBoolExp>;
};


export type Query_RootPlayerAvailabilityRatingScalesAggregateArgs = {
  distinctOn?: InputMaybe<Array<PlayerAvailabilityRatingScalesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayerAvailabilityRatingScalesOrderBy>>;
  where?: InputMaybe<PlayerAvailabilityRatingScalesBoolExp>;
};


export type Query_RootPlayerAvailabilityRatingScalesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPlayerAvailabilitySlotsArgs = {
  distinctOn?: InputMaybe<Array<PlayerAvailabilitySlotsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayerAvailabilitySlotsOrderBy>>;
  where?: InputMaybe<PlayerAvailabilitySlotsBoolExp>;
};


export type Query_RootPlayerAvailabilitySlotsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PlayerAvailabilitySlotsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayerAvailabilitySlotsOrderBy>>;
  where?: InputMaybe<PlayerAvailabilitySlotsBoolExp>;
};


export type Query_RootPlayerAvailabilitySlotsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPlayerAvailabilityVenuesArgs = {
  distinctOn?: InputMaybe<Array<PlayerAvailabilityVenuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayerAvailabilityVenuesOrderBy>>;
  where?: InputMaybe<PlayerAvailabilityVenuesBoolExp>;
};


export type Query_RootPlayerAvailabilityVenuesAggregateArgs = {
  distinctOn?: InputMaybe<Array<PlayerAvailabilityVenuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayerAvailabilityVenuesOrderBy>>;
  where?: InputMaybe<PlayerAvailabilityVenuesBoolExp>;
};


export type Query_RootPlayerAvailabilityVenuesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPlayerFinderGoalsArgs = {
  distinctOn?: InputMaybe<Array<PlayerFinderGoalsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayerFinderGoalsOrderBy>>;
  where?: InputMaybe<PlayerFinderGoalsBoolExp>;
};


export type Query_RootPlayerFinderGoalsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PlayerFinderGoalsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayerFinderGoalsOrderBy>>;
  where?: InputMaybe<PlayerFinderGoalsBoolExp>;
};


export type Query_RootPlayerFinderGoalsByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootPlayerFinderTimeOfDayArgs = {
  distinctOn?: InputMaybe<Array<PlayerFinderTimeOfDaySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayerFinderTimeOfDayOrderBy>>;
  where?: InputMaybe<PlayerFinderTimeOfDayBoolExp>;
};


export type Query_RootPlayerFinderTimeOfDayAggregateArgs = {
  distinctOn?: InputMaybe<Array<PlayerFinderTimeOfDaySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayerFinderTimeOfDayOrderBy>>;
  where?: InputMaybe<PlayerFinderTimeOfDayBoolExp>;
};


export type Query_RootPlayerFinderTimeOfDayByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootRecurrenceKindsArgs = {
  distinctOn?: InputMaybe<Array<RecurrenceKindsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RecurrenceKindsOrderBy>>;
  where?: InputMaybe<RecurrenceKindsBoolExp>;
};


export type Query_RootRecurrenceKindsAggregateArgs = {
  distinctOn?: InputMaybe<Array<RecurrenceKindsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RecurrenceKindsOrderBy>>;
  where?: InputMaybe<RecurrenceKindsBoolExp>;
};


export type Query_RootRecurrenceKindsByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootReportReasonsArgs = {
  distinctOn?: InputMaybe<Array<ReportReasonsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReportReasonsOrderBy>>;
  where?: InputMaybe<ReportReasonsBoolExp>;
};


export type Query_RootReportReasonsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ReportReasonsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReportReasonsOrderBy>>;
  where?: InputMaybe<ReportReasonsBoolExp>;
};


export type Query_RootReportReasonsByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootReportStatusesArgs = {
  distinctOn?: InputMaybe<Array<ReportStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReportStatusesOrderBy>>;
  where?: InputMaybe<ReportStatusesBoolExp>;
};


export type Query_RootReportStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<ReportStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReportStatusesOrderBy>>;
  where?: InputMaybe<ReportStatusesBoolExp>;
};


export type Query_RootReportStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootReviewsArgs = {
  distinctOn?: InputMaybe<Array<ReviewsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReviewsOrderBy>>;
  where?: InputMaybe<ReviewsBoolExp>;
};


export type Query_RootReviewsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ReviewsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReviewsOrderBy>>;
  where?: InputMaybe<ReviewsBoolExp>;
};


export type Query_RootReviewsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSalesArgs = {
  distinctOn?: InputMaybe<Array<SalesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SalesOrderBy>>;
  where?: InputMaybe<SalesBoolExp>;
};


export type Query_RootSalesAggregateArgs = {
  distinctOn?: InputMaybe<Array<SalesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SalesOrderBy>>;
  where?: InputMaybe<SalesBoolExp>;
};


export type Query_RootSalesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootScoringFormatArgs = {
  distinctOn?: InputMaybe<Array<ScoringFormatSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScoringFormatOrderBy>>;
  where?: InputMaybe<ScoringFormatBoolExp>;
};


export type Query_RootScoringFormatAggregateArgs = {
  distinctOn?: InputMaybe<Array<ScoringFormatSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScoringFormatOrderBy>>;
  where?: InputMaybe<ScoringFormatBoolExp>;
};


export type Query_RootScoringFormatByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootSignupRequestsArgs = {
  distinctOn?: InputMaybe<Array<SignupRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SignupRequestsOrderBy>>;
  where?: InputMaybe<SignupRequestsBoolExp>;
};


export type Query_RootSignupRequestsAggregateArgs = {
  distinctOn?: InputMaybe<Array<SignupRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SignupRequestsOrderBy>>;
  where?: InputMaybe<SignupRequestsBoolExp>;
};


export type Query_RootSignupRequestsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSkillLevelValuesArgs = {
  distinctOn?: InputMaybe<Array<SkillLevelValuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SkillLevelValuesOrderBy>>;
  where?: InputMaybe<SkillLevelValuesBoolExp>;
};


export type Query_RootSkillLevelValuesAggregateArgs = {
  distinctOn?: InputMaybe<Array<SkillLevelValuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SkillLevelValuesOrderBy>>;
  where?: InputMaybe<SkillLevelValuesBoolExp>;
};


export type Query_RootSkillLevelValuesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootSkillLevelsArgs = {
  distinctOn?: InputMaybe<Array<SkillLevelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SkillLevelsOrderBy>>;
  where?: InputMaybe<SkillLevelsBoolExp>;
};


export type Query_RootSkillLevelsAggregateArgs = {
  distinctOn?: InputMaybe<Array<SkillLevelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SkillLevelsOrderBy>>;
  where?: InputMaybe<SkillLevelsBoolExp>;
};


export type Query_RootSkillLevelsByPkArgs = {
  id: SkillLevelValuesEnum;
};


export type Query_RootSportsArgs = {
  distinctOn?: InputMaybe<Array<SportsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SportsOrderBy>>;
  where?: InputMaybe<SportsBoolExp>;
};


export type Query_RootSportsAggregateArgs = {
  distinctOn?: InputMaybe<Array<SportsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SportsOrderBy>>;
  where?: InputMaybe<SportsBoolExp>;
};


export type Query_RootSportsByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootStripeChargesArgs = {
  distinctOn?: InputMaybe<Array<StripeChargesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<StripeChargesOrderBy>>;
  where?: InputMaybe<StripeChargesBoolExp>;
};


export type Query_RootStripeChargesAggregateArgs = {
  distinctOn?: InputMaybe<Array<StripeChargesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<StripeChargesOrderBy>>;
  where?: InputMaybe<StripeChargesBoolExp>;
};


export type Query_RootStripeChargesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootStripePaymentIntentsArgs = {
  distinctOn?: InputMaybe<Array<StripePaymentIntentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<StripePaymentIntentsOrderBy>>;
  where?: InputMaybe<StripePaymentIntentsBoolExp>;
};


export type Query_RootStripePaymentIntentsAggregateArgs = {
  distinctOn?: InputMaybe<Array<StripePaymentIntentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<StripePaymentIntentsOrderBy>>;
  where?: InputMaybe<StripePaymentIntentsBoolExp>;
};


export type Query_RootStripePaymentIntentsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSubscriptionStatusesArgs = {
  distinctOn?: InputMaybe<Array<SubscriptionStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SubscriptionStatusesOrderBy>>;
  where?: InputMaybe<SubscriptionStatusesBoolExp>;
};


export type Query_RootSubscriptionStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<SubscriptionStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SubscriptionStatusesOrderBy>>;
  where?: InputMaybe<SubscriptionStatusesBoolExp>;
};


export type Query_RootSubscriptionStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootTeamTypesArgs = {
  distinctOn?: InputMaybe<Array<TeamTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TeamTypesOrderBy>>;
  where?: InputMaybe<TeamTypesBoolExp>;
};


export type Query_RootTeamTypesAggregateArgs = {
  distinctOn?: InputMaybe<Array<TeamTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TeamTypesOrderBy>>;
  where?: InputMaybe<TeamTypesBoolExp>;
};


export type Query_RootTeamTypesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootTennisRatingScalesArgs = {
  distinctOn?: InputMaybe<Array<TennisRatingScalesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TennisRatingScalesOrderBy>>;
  where?: InputMaybe<TennisRatingScalesBoolExp>;
};


export type Query_RootTennisRatingScalesAggregateArgs = {
  distinctOn?: InputMaybe<Array<TennisRatingScalesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TennisRatingScalesOrderBy>>;
  where?: InputMaybe<TennisRatingScalesBoolExp>;
};


export type Query_RootTennisRatingScalesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootTwilioGroupTextsArgs = {
  distinctOn?: InputMaybe<Array<TwilioGroupTextsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TwilioGroupTextsOrderBy>>;
  where?: InputMaybe<TwilioGroupTextsBoolExp>;
};


export type Query_RootTwilioGroupTextsAggregateArgs = {
  distinctOn?: InputMaybe<Array<TwilioGroupTextsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TwilioGroupTextsOrderBy>>;
  where?: InputMaybe<TwilioGroupTextsBoolExp>;
};


export type Query_RootTwilioGroupTextsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUploadReviewRequestsArgs = {
  distinctOn?: InputMaybe<Array<UploadReviewRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UploadReviewRequestsOrderBy>>;
  where?: InputMaybe<UploadReviewRequestsBoolExp>;
};


export type Query_RootUploadReviewRequestsAggregateArgs = {
  distinctOn?: InputMaybe<Array<UploadReviewRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UploadReviewRequestsOrderBy>>;
  where?: InputMaybe<UploadReviewRequestsBoolExp>;
};


export type Query_RootUploadReviewRequestsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUserAuthIdentitiesArgs = {
  distinctOn?: InputMaybe<Array<UserAuthIdentitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserAuthIdentitiesOrderBy>>;
  where?: InputMaybe<UserAuthIdentitiesBoolExp>;
};


export type Query_RootUserAuthIdentitiesAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserAuthIdentitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserAuthIdentitiesOrderBy>>;
  where?: InputMaybe<UserAuthIdentitiesBoolExp>;
};


export type Query_RootUserAuthIdentitiesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUserBlocksArgs = {
  distinctOn?: InputMaybe<Array<UserBlocksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserBlocksOrderBy>>;
  where?: InputMaybe<UserBlocksBoolExp>;
};


export type Query_RootUserBlocksAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserBlocksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserBlocksOrderBy>>;
  where?: InputMaybe<UserBlocksBoolExp>;
};


export type Query_RootUserBlocksByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUserCoachServicesArgs = {
  distinctOn?: InputMaybe<Array<UserCoachServicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserCoachServicesOrderBy>>;
  where?: InputMaybe<UserCoachServicesBoolExp>;
};


export type Query_RootUserCoachServicesAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserCoachServicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserCoachServicesOrderBy>>;
  where?: InputMaybe<UserCoachServicesBoolExp>;
};


export type Query_RootUserCoachServicesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUserCommunicationPreferencesArgs = {
  distinctOn?: InputMaybe<Array<UserCommunicationPreferencesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserCommunicationPreferencesOrderBy>>;
  where?: InputMaybe<UserCommunicationPreferencesBoolExp>;
};


export type Query_RootUserCommunicationPreferencesAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserCommunicationPreferencesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserCommunicationPreferencesOrderBy>>;
  where?: InputMaybe<UserCommunicationPreferencesBoolExp>;
};


export type Query_RootUserCommunicationPreferencesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUserConnectionRequestStatusesArgs = {
  distinctOn?: InputMaybe<Array<UserConnectionRequestStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserConnectionRequestStatusesOrderBy>>;
  where?: InputMaybe<UserConnectionRequestStatusesBoolExp>;
};


export type Query_RootUserConnectionRequestStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserConnectionRequestStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserConnectionRequestStatusesOrderBy>>;
  where?: InputMaybe<UserConnectionRequestStatusesBoolExp>;
};


export type Query_RootUserConnectionRequestStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootUserConnectionRequestsArgs = {
  distinctOn?: InputMaybe<Array<UserConnectionRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserConnectionRequestsOrderBy>>;
  where?: InputMaybe<UserConnectionRequestsBoolExp>;
};


export type Query_RootUserConnectionRequestsAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserConnectionRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserConnectionRequestsOrderBy>>;
  where?: InputMaybe<UserConnectionRequestsBoolExp>;
};


export type Query_RootUserConnectionRequestsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUserConnectionsArgs = {
  distinctOn?: InputMaybe<Array<UserConnectionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserConnectionsOrderBy>>;
  where?: InputMaybe<UserConnectionsBoolExp>;
};


export type Query_RootUserConnectionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserConnectionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserConnectionsOrderBy>>;
  where?: InputMaybe<UserConnectionsBoolExp>;
};


export type Query_RootUserConnectionsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUserContentBetaSubscriptionsArgs = {
  distinctOn?: InputMaybe<Array<UserContentBetaSubscriptionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserContentBetaSubscriptionsOrderBy>>;
  where?: InputMaybe<UserContentBetaSubscriptionsBoolExp>;
};


export type Query_RootUserContentBetaSubscriptionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserContentBetaSubscriptionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserContentBetaSubscriptionsOrderBy>>;
  where?: InputMaybe<UserContentBetaSubscriptionsBoolExp>;
};


export type Query_RootUserContentBetaSubscriptionsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUserContentFilesArgs = {
  distinctOn?: InputMaybe<Array<UserContentFilesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserContentFilesOrderBy>>;
  where?: InputMaybe<UserContentFilesBoolExp>;
};


export type Query_RootUserContentFilesAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserContentFilesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserContentFilesOrderBy>>;
  where?: InputMaybe<UserContentFilesBoolExp>;
};


export type Query_RootUserContentFilesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUserContentFilesSkillsArgs = {
  distinctOn?: InputMaybe<Array<UserContentFilesSkillsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserContentFilesSkillsOrderBy>>;
  where?: InputMaybe<UserContentFilesSkillsBoolExp>;
};


export type Query_RootUserContentFilesSkillsAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserContentFilesSkillsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserContentFilesSkillsOrderBy>>;
  where?: InputMaybe<UserContentFilesSkillsBoolExp>;
};


export type Query_RootUserContentFilesSkillsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUserContentSkillsArgs = {
  distinctOn?: InputMaybe<Array<UserContentSkillsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserContentSkillsOrderBy>>;
  where?: InputMaybe<UserContentSkillsBoolExp>;
};


export type Query_RootUserContentSkillsAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserContentSkillsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserContentSkillsOrderBy>>;
  where?: InputMaybe<UserContentSkillsBoolExp>;
};


export type Query_RootUserContentSkillsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUserContentTiersArgs = {
  distinctOn?: InputMaybe<Array<UserContentTiersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserContentTiersOrderBy>>;
  where?: InputMaybe<UserContentTiersBoolExp>;
};


export type Query_RootUserContentTiersAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserContentTiersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserContentTiersOrderBy>>;
  where?: InputMaybe<UserContentTiersBoolExp>;
};


export type Query_RootUserContentTiersByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootUserCreditCardsArgs = {
  distinctOn?: InputMaybe<Array<UserCreditCardsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserCreditCardsOrderBy>>;
  where?: InputMaybe<UserCreditCardsBoolExp>;
};


export type Query_RootUserCreditCardsAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserCreditCardsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserCreditCardsOrderBy>>;
  where?: InputMaybe<UserCreditCardsBoolExp>;
};


export type Query_RootUserCreditCardsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUserCustomCourtsArgs = {
  distinctOn?: InputMaybe<Array<UserCustomCourtsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserCustomCourtsOrderBy>>;
  where?: InputMaybe<UserCustomCourtsBoolExp>;
};


export type Query_RootUserCustomCourtsAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserCustomCourtsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserCustomCourtsOrderBy>>;
  where?: InputMaybe<UserCustomCourtsBoolExp>;
};


export type Query_RootUserCustomCourtsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUserFilesArgs = {
  distinctOn?: InputMaybe<Array<UserFilesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserFilesOrderBy>>;
  where?: InputMaybe<UserFilesBoolExp>;
};


export type Query_RootUserFilesAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserFilesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserFilesOrderBy>>;
  where?: InputMaybe<UserFilesBoolExp>;
};


export type Query_RootUserFilesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUserFollowsArgs = {
  distinctOn?: InputMaybe<Array<UserFollowsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserFollowsOrderBy>>;
  where?: InputMaybe<UserFollowsBoolExp>;
};


export type Query_RootUserFollowsAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserFollowsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserFollowsOrderBy>>;
  where?: InputMaybe<UserFollowsBoolExp>;
};


export type Query_RootUserFollowsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUserIdentityVerificationsArgs = {
  distinctOn?: InputMaybe<Array<UserIdentityVerificationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserIdentityVerificationsOrderBy>>;
  where?: InputMaybe<UserIdentityVerificationsBoolExp>;
};


export type Query_RootUserIdentityVerificationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserIdentityVerificationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserIdentityVerificationsOrderBy>>;
  where?: InputMaybe<UserIdentityVerificationsBoolExp>;
};


export type Query_RootUserIdentityVerificationsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUserImageLogArgs = {
  distinctOn?: InputMaybe<Array<UserImageLogSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserImageLogOrderBy>>;
  where?: InputMaybe<UserImageLogBoolExp>;
};


export type Query_RootUserImageLogAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserImageLogSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserImageLogOrderBy>>;
  where?: InputMaybe<UserImageLogBoolExp>;
};


export type Query_RootUserImageLogByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUserNotificationDetailsArgs = {
  distinctOn?: InputMaybe<Array<UserNotificationDetailsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserNotificationDetailsOrderBy>>;
  where?: InputMaybe<UserNotificationDetailsBoolExp>;
};


export type Query_RootUserNotificationDetailsAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserNotificationDetailsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserNotificationDetailsOrderBy>>;
  where?: InputMaybe<UserNotificationDetailsBoolExp>;
};


export type Query_RootUserNotificationDetailsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUserNotificationEntitiesArgs = {
  distinctOn?: InputMaybe<Array<UserNotificationEntitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserNotificationEntitiesOrderBy>>;
  where?: InputMaybe<UserNotificationEntitiesBoolExp>;
};


export type Query_RootUserNotificationEntitiesAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserNotificationEntitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserNotificationEntitiesOrderBy>>;
  where?: InputMaybe<UserNotificationEntitiesBoolExp>;
};


export type Query_RootUserNotificationEntitiesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUserNotificationsArgs = {
  distinctOn?: InputMaybe<Array<UserNotificationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserNotificationsOrderBy>>;
  where?: InputMaybe<UserNotificationsBoolExp>;
};


export type Query_RootUserNotificationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserNotificationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserNotificationsOrderBy>>;
  where?: InputMaybe<UserNotificationsBoolExp>;
};


export type Query_RootUserNotificationsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUserPadelRatingScalesArgs = {
  distinctOn?: InputMaybe<Array<UserPadelRatingScalesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPadelRatingScalesOrderBy>>;
  where?: InputMaybe<UserPadelRatingScalesBoolExp>;
};


export type Query_RootUserPadelRatingScalesAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserPadelRatingScalesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPadelRatingScalesOrderBy>>;
  where?: InputMaybe<UserPadelRatingScalesBoolExp>;
};


export type Query_RootUserPadelRatingScalesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUserPickleballRatingScalesArgs = {
  distinctOn?: InputMaybe<Array<UserPickleballRatingScalesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPickleballRatingScalesOrderBy>>;
  where?: InputMaybe<UserPickleballRatingScalesBoolExp>;
};


export type Query_RootUserPickleballRatingScalesAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserPickleballRatingScalesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPickleballRatingScalesOrderBy>>;
  where?: InputMaybe<UserPickleballRatingScalesBoolExp>;
};


export type Query_RootUserPickleballRatingScalesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUserPlayedWithArgs = {
  distinctOn?: InputMaybe<Array<UserPlayedWithSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPlayedWithOrderBy>>;
  where?: InputMaybe<UserPlayedWithBoolExp>;
};


export type Query_RootUserPlayedWithAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserPlayedWithSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPlayedWithOrderBy>>;
  where?: InputMaybe<UserPlayedWithBoolExp>;
};


export type Query_RootUserPlayedWithDismissalsArgs = {
  distinctOn?: InputMaybe<Array<UserPlayedWithDismissalsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPlayedWithDismissalsOrderBy>>;
  where?: InputMaybe<UserPlayedWithDismissalsBoolExp>;
};


export type Query_RootUserPlayedWithDismissalsAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserPlayedWithDismissalsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPlayedWithDismissalsOrderBy>>;
  where?: InputMaybe<UserPlayedWithDismissalsBoolExp>;
};


export type Query_RootUserPlayedWithDismissalsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUserPlayedWithGamesArgs = {
  distinctOn?: InputMaybe<Array<UserPlayedWithGamesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPlayedWithGamesOrderBy>>;
  where?: InputMaybe<UserPlayedWithGamesBoolExp>;
};


export type Query_RootUserPlayedWithGamesAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserPlayedWithGamesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPlayedWithGamesOrderBy>>;
  where?: InputMaybe<UserPlayedWithGamesBoolExp>;
};


export type Query_RootUserPlayerFinderAvailabilityArgs = {
  distinctOn?: InputMaybe<Array<UserPlayerFinderAvailabilitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPlayerFinderAvailabilityOrderBy>>;
  where?: InputMaybe<UserPlayerFinderAvailabilityBoolExp>;
};


export type Query_RootUserPlayerFinderAvailabilityAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserPlayerFinderAvailabilitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPlayerFinderAvailabilityOrderBy>>;
  where?: InputMaybe<UserPlayerFinderAvailabilityBoolExp>;
};


export type Query_RootUserPlayerFinderAvailabilityByPkArgs = {
  dayOfWeek: DayOfWeekEnum;
  timeOfDay: PlayerFinderTimeOfDayEnum;
  userId: Scalars['uuid'];
};


export type Query_RootUserPlayerFinderGoalsArgs = {
  distinctOn?: InputMaybe<Array<UserPlayerFinderGoalsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPlayerFinderGoalsOrderBy>>;
  where?: InputMaybe<UserPlayerFinderGoalsBoolExp>;
};


export type Query_RootUserPlayerFinderGoalsAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserPlayerFinderGoalsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPlayerFinderGoalsOrderBy>>;
  where?: InputMaybe<UserPlayerFinderGoalsBoolExp>;
};


export type Query_RootUserPlayerFinderGoalsByPkArgs = {
  goal: PlayerFinderGoalsEnum;
  userId: Scalars['uuid'];
};


export type Query_RootUserProfilesArgs = {
  distinctOn?: InputMaybe<Array<UserProfilesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserProfilesOrderBy>>;
  where?: InputMaybe<UserProfilesBoolExp>;
};


export type Query_RootUserProfilesAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserProfilesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserProfilesOrderBy>>;
  where?: InputMaybe<UserProfilesBoolExp>;
};


export type Query_RootUserRegistrationDetailsArgs = {
  distinctOn?: InputMaybe<Array<UserRegistrationDetailsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserRegistrationDetailsOrderBy>>;
  where?: InputMaybe<UserRegistrationDetailsBoolExp>;
};


export type Query_RootUserRegistrationDetailsAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserRegistrationDetailsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserRegistrationDetailsOrderBy>>;
  where?: InputMaybe<UserRegistrationDetailsBoolExp>;
};


export type Query_RootUserRegistrationDetailsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUserSportsArgs = {
  distinctOn?: InputMaybe<Array<UserSportsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserSportsOrderBy>>;
  where?: InputMaybe<UserSportsBoolExp>;
};


export type Query_RootUserSportsAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserSportsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserSportsOrderBy>>;
  where?: InputMaybe<UserSportsBoolExp>;
};


export type Query_RootUserSportsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUserTennisRatingScalesArgs = {
  distinctOn?: InputMaybe<Array<UserTennisRatingScalesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserTennisRatingScalesOrderBy>>;
  where?: InputMaybe<UserTennisRatingScalesBoolExp>;
};


export type Query_RootUserTennisRatingScalesAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserTennisRatingScalesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserTennisRatingScalesOrderBy>>;
  where?: InputMaybe<UserTennisRatingScalesBoolExp>;
};


export type Query_RootUserTennisRatingScalesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUserTermsOfServiceArgs = {
  distinctOn?: InputMaybe<Array<UserTermsOfServiceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserTermsOfServiceOrderBy>>;
  where?: InputMaybe<UserTermsOfServiceBoolExp>;
};


export type Query_RootUserTermsOfServiceAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserTermsOfServiceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserTermsOfServiceOrderBy>>;
  where?: InputMaybe<UserTermsOfServiceBoolExp>;
};


export type Query_RootUserTermsOfServiceByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUserVairConnectionsArgs = {
  distinctOn?: InputMaybe<Array<UserVairConnectionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserVairConnectionsOrderBy>>;
  where?: InputMaybe<UserVairConnectionsBoolExp>;
};


export type Query_RootUserVairConnectionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserVairConnectionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserVairConnectionsOrderBy>>;
  where?: InputMaybe<UserVairConnectionsBoolExp>;
};


export type Query_RootUserVairConnectionsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUsernameLogsArgs = {
  distinctOn?: InputMaybe<Array<UsernameLogsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsernameLogsOrderBy>>;
  where?: InputMaybe<UsernameLogsBoolExp>;
};


export type Query_RootUsernameLogsAggregateArgs = {
  distinctOn?: InputMaybe<Array<UsernameLogsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsernameLogsOrderBy>>;
  where?: InputMaybe<UsernameLogsBoolExp>;
};


export type Query_RootUsernameLogsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUsernamesActiveArgs = {
  distinctOn?: InputMaybe<Array<UsernamesActiveSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsernamesActiveOrderBy>>;
  where?: InputMaybe<UsernamesActiveBoolExp>;
};


export type Query_RootUsernamesActiveAggregateArgs = {
  distinctOn?: InputMaybe<Array<UsernamesActiveSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsernamesActiveOrderBy>>;
  where?: InputMaybe<UsernamesActiveBoolExp>;
};


export type Query_RootUsernamesClaimedArgs = {
  distinctOn?: InputMaybe<Array<UsernamesClaimedSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsernamesClaimedOrderBy>>;
  where?: InputMaybe<UsernamesClaimedBoolExp>;
};


export type Query_RootUsernamesClaimedAggregateArgs = {
  distinctOn?: InputMaybe<Array<UsernamesClaimedSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsernamesClaimedOrderBy>>;
  where?: InputMaybe<UsernamesClaimedBoolExp>;
};


export type Query_RootUsernamesClaimedByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUsersArgs = {
  distinctOn?: InputMaybe<Array<UsersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
  where?: InputMaybe<UsersBoolExp>;
};


export type Query_RootUsersAggregateArgs = {
  distinctOn?: InputMaybe<Array<UsersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
  where?: InputMaybe<UsersBoolExp>;
};


export type Query_RootUsersByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUsersCoachQualificationsArgs = {
  distinctOn?: InputMaybe<Array<UsersCoachQualificationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersCoachQualificationsOrderBy>>;
  where?: InputMaybe<UsersCoachQualificationsBoolExp>;
};


export type Query_RootUsersCoachQualificationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<UsersCoachQualificationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersCoachQualificationsOrderBy>>;
  where?: InputMaybe<UsersCoachQualificationsBoolExp>;
};


export type Query_RootUsersCoachQualificationsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootVenueAccessTypesArgs = {
  distinctOn?: InputMaybe<Array<VenueAccessTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueAccessTypesOrderBy>>;
  where?: InputMaybe<VenueAccessTypesBoolExp>;
};


export type Query_RootVenueAccessTypesAggregateArgs = {
  distinctOn?: InputMaybe<Array<VenueAccessTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueAccessTypesOrderBy>>;
  where?: InputMaybe<VenueAccessTypesBoolExp>;
};


export type Query_RootVenueAccessTypesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootVenueAdminClaimStatusesArgs = {
  distinctOn?: InputMaybe<Array<VenueAdminClaimStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueAdminClaimStatusesOrderBy>>;
  where?: InputMaybe<VenueAdminClaimStatusesBoolExp>;
};


export type Query_RootVenueAdminClaimStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<VenueAdminClaimStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueAdminClaimStatusesOrderBy>>;
  where?: InputMaybe<VenueAdminClaimStatusesBoolExp>;
};


export type Query_RootVenueAdminClaimStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootVenueAdminClaimsArgs = {
  distinctOn?: InputMaybe<Array<VenueAdminClaimsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueAdminClaimsOrderBy>>;
  where?: InputMaybe<VenueAdminClaimsBoolExp>;
};


export type Query_RootVenueAdminClaimsAggregateArgs = {
  distinctOn?: InputMaybe<Array<VenueAdminClaimsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueAdminClaimsOrderBy>>;
  where?: InputMaybe<VenueAdminClaimsBoolExp>;
};


export type Query_RootVenueAdminClaimsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootVenueAmenitiesArgs = {
  distinctOn?: InputMaybe<Array<VenueAmenitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueAmenitiesOrderBy>>;
  where?: InputMaybe<VenueAmenitiesBoolExp>;
};


export type Query_RootVenueAmenitiesAggregateArgs = {
  distinctOn?: InputMaybe<Array<VenueAmenitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueAmenitiesOrderBy>>;
  where?: InputMaybe<VenueAmenitiesBoolExp>;
};


export type Query_RootVenueAmenitiesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootVenueBookingConfigVersionsArgs = {
  distinctOn?: InputMaybe<Array<VenueBookingConfigVersionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueBookingConfigVersionsOrderBy>>;
  where?: InputMaybe<VenueBookingConfigVersionsBoolExp>;
};


export type Query_RootVenueBookingConfigVersionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<VenueBookingConfigVersionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueBookingConfigVersionsOrderBy>>;
  where?: InputMaybe<VenueBookingConfigVersionsBoolExp>;
};


export type Query_RootVenueBookingConfigVersionsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootVenueBookingConnectionCheckStatusesArgs = {
  distinctOn?: InputMaybe<Array<VenueBookingConnectionCheckStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueBookingConnectionCheckStatusesOrderBy>>;
  where?: InputMaybe<VenueBookingConnectionCheckStatusesBoolExp>;
};


export type Query_RootVenueBookingConnectionCheckStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<VenueBookingConnectionCheckStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueBookingConnectionCheckStatusesOrderBy>>;
  where?: InputMaybe<VenueBookingConnectionCheckStatusesBoolExp>;
};


export type Query_RootVenueBookingConnectionCheckStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootVenueBookingConnectionChecksArgs = {
  distinctOn?: InputMaybe<Array<VenueBookingConnectionChecksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueBookingConnectionChecksOrderBy>>;
  where?: InputMaybe<VenueBookingConnectionChecksBoolExp>;
};


export type Query_RootVenueBookingConnectionChecksAggregateArgs = {
  distinctOn?: InputMaybe<Array<VenueBookingConnectionChecksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueBookingConnectionChecksOrderBy>>;
  where?: InputMaybe<VenueBookingConnectionChecksBoolExp>;
};


export type Query_RootVenueBookingConnectionChecksByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootVenueBookingCourtRatesArgs = {
  distinctOn?: InputMaybe<Array<VenueBookingCourtRatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueBookingCourtRatesOrderBy>>;
  where?: InputMaybe<VenueBookingCourtRatesBoolExp>;
};


export type Query_RootVenueBookingCourtRatesAggregateArgs = {
  distinctOn?: InputMaybe<Array<VenueBookingCourtRatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueBookingCourtRatesOrderBy>>;
  where?: InputMaybe<VenueBookingCourtRatesBoolExp>;
};


export type Query_RootVenueBookingCourtRatesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootVenueBookingIntegrationsArgs = {
  distinctOn?: InputMaybe<Array<VenueBookingIntegrationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueBookingIntegrationsOrderBy>>;
  where?: InputMaybe<VenueBookingIntegrationsBoolExp>;
};


export type Query_RootVenueBookingIntegrationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<VenueBookingIntegrationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueBookingIntegrationsOrderBy>>;
  where?: InputMaybe<VenueBookingIntegrationsBoolExp>;
};


export type Query_RootVenueBookingIntegrationsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootVenueBookingRuleTiersArgs = {
  distinctOn?: InputMaybe<Array<VenueBookingRuleTiersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueBookingRuleTiersOrderBy>>;
  where?: InputMaybe<VenueBookingRuleTiersBoolExp>;
};


export type Query_RootVenueBookingRuleTiersAggregateArgs = {
  distinctOn?: InputMaybe<Array<VenueBookingRuleTiersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueBookingRuleTiersOrderBy>>;
  where?: InputMaybe<VenueBookingRuleTiersBoolExp>;
};


export type Query_RootVenueBookingRuleTiersByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootVenueBookingRulesArgs = {
  distinctOn?: InputMaybe<Array<VenueBookingRulesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueBookingRulesOrderBy>>;
  where?: InputMaybe<VenueBookingRulesBoolExp>;
};


export type Query_RootVenueBookingRulesAggregateArgs = {
  distinctOn?: InputMaybe<Array<VenueBookingRulesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueBookingRulesOrderBy>>;
  where?: InputMaybe<VenueBookingRulesBoolExp>;
};


export type Query_RootVenueBookingRulesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootVenueBookingWindowsArgs = {
  distinctOn?: InputMaybe<Array<VenueBookingWindowsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueBookingWindowsOrderBy>>;
  where?: InputMaybe<VenueBookingWindowsBoolExp>;
};


export type Query_RootVenueBookingWindowsAggregateArgs = {
  distinctOn?: InputMaybe<Array<VenueBookingWindowsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueBookingWindowsOrderBy>>;
  where?: InputMaybe<VenueBookingWindowsBoolExp>;
};


export type Query_RootVenueBookingWindowsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootVenueCourtSurfacesArgs = {
  distinctOn?: InputMaybe<Array<VenueCourtSurfacesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueCourtSurfacesOrderBy>>;
  where?: InputMaybe<VenueCourtSurfacesBoolExp>;
};


export type Query_RootVenueCourtSurfacesAggregateArgs = {
  distinctOn?: InputMaybe<Array<VenueCourtSurfacesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueCourtSurfacesOrderBy>>;
  where?: InputMaybe<VenueCourtSurfacesBoolExp>;
};


export type Query_RootVenueCourtSurfacesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootVenueCustomAmenitiesArgs = {
  distinctOn?: InputMaybe<Array<VenueCustomAmenitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueCustomAmenitiesOrderBy>>;
  where?: InputMaybe<VenueCustomAmenitiesBoolExp>;
};


export type Query_RootVenueCustomAmenitiesAggregateArgs = {
  distinctOn?: InputMaybe<Array<VenueCustomAmenitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueCustomAmenitiesOrderBy>>;
  where?: InputMaybe<VenueCustomAmenitiesBoolExp>;
};


export type Query_RootVenueCustomAmenitiesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootVenueEquipmentArgs = {
  distinctOn?: InputMaybe<Array<VenueEquipmentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueEquipmentOrderBy>>;
  where?: InputMaybe<VenueEquipmentBoolExp>;
};


export type Query_RootVenueEquipmentAggregateArgs = {
  distinctOn?: InputMaybe<Array<VenueEquipmentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueEquipmentOrderBy>>;
  where?: InputMaybe<VenueEquipmentBoolExp>;
};


export type Query_RootVenueEquipmentByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootVenueFacilityTypesArgs = {
  distinctOn?: InputMaybe<Array<VenueFacilityTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueFacilityTypesOrderBy>>;
  where?: InputMaybe<VenueFacilityTypesBoolExp>;
};


export type Query_RootVenueFacilityTypesAggregateArgs = {
  distinctOn?: InputMaybe<Array<VenueFacilityTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueFacilityTypesOrderBy>>;
  where?: InputMaybe<VenueFacilityTypesBoolExp>;
};


export type Query_RootVenueFacilityTypesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootVenueFaqsArgs = {
  distinctOn?: InputMaybe<Array<VenueFaqsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueFaqsOrderBy>>;
  where?: InputMaybe<VenueFaqsBoolExp>;
};


export type Query_RootVenueFaqsAggregateArgs = {
  distinctOn?: InputMaybe<Array<VenueFaqsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueFaqsOrderBy>>;
  where?: InputMaybe<VenueFaqsBoolExp>;
};


export type Query_RootVenueFaqsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootVenueFollowsArgs = {
  distinctOn?: InputMaybe<Array<VenueFollowsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueFollowsOrderBy>>;
  where?: InputMaybe<VenueFollowsBoolExp>;
};


export type Query_RootVenueFollowsAggregateArgs = {
  distinctOn?: InputMaybe<Array<VenueFollowsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueFollowsOrderBy>>;
  where?: InputMaybe<VenueFollowsBoolExp>;
};


export type Query_RootVenueFollowsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootVenueImagesArgs = {
  distinctOn?: InputMaybe<Array<VenueImagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueImagesOrderBy>>;
  where?: InputMaybe<VenueImagesBoolExp>;
};


export type Query_RootVenueImagesAggregateArgs = {
  distinctOn?: InputMaybe<Array<VenueImagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueImagesOrderBy>>;
  where?: InputMaybe<VenueImagesBoolExp>;
};


export type Query_RootVenueImagesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootVenueLinesArgs = {
  distinctOn?: InputMaybe<Array<VenueLinesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueLinesOrderBy>>;
  where?: InputMaybe<VenueLinesBoolExp>;
};


export type Query_RootVenueLinesAggregateArgs = {
  distinctOn?: InputMaybe<Array<VenueLinesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueLinesOrderBy>>;
  where?: InputMaybe<VenueLinesBoolExp>;
};


export type Query_RootVenueLinesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootVenueNetsArgs = {
  distinctOn?: InputMaybe<Array<VenueNetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueNetsOrderBy>>;
  where?: InputMaybe<VenueNetsBoolExp>;
};


export type Query_RootVenueNetsAggregateArgs = {
  distinctOn?: InputMaybe<Array<VenueNetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueNetsOrderBy>>;
  where?: InputMaybe<VenueNetsBoolExp>;
};


export type Query_RootVenueNetsByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootVenuePartnerBookingStatusesArgs = {
  distinctOn?: InputMaybe<Array<VenuePartnerBookingStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenuePartnerBookingStatusesOrderBy>>;
  where?: InputMaybe<VenuePartnerBookingStatusesBoolExp>;
};


export type Query_RootVenuePartnerBookingStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<VenuePartnerBookingStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenuePartnerBookingStatusesOrderBy>>;
  where?: InputMaybe<VenuePartnerBookingStatusesBoolExp>;
};


export type Query_RootVenueStaffCoachesArgs = {
  distinctOn?: InputMaybe<Array<VenueStaffCoachesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueStaffCoachesOrderBy>>;
  where?: InputMaybe<VenueStaffCoachesBoolExp>;
};


export type Query_RootVenueStaffCoachesAggregateArgs = {
  distinctOn?: InputMaybe<Array<VenueStaffCoachesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueStaffCoachesOrderBy>>;
  where?: InputMaybe<VenueStaffCoachesBoolExp>;
};


export type Query_RootVenueStaffCoachesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootVenuesArgs = {
  distinctOn?: InputMaybe<Array<VenuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenuesOrderBy>>;
  where?: InputMaybe<VenuesBoolExp>;
};


export type Query_RootVenuesAggregateArgs = {
  distinctOn?: InputMaybe<Array<VenuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenuesOrderBy>>;
  where?: InputMaybe<VenuesBoolExp>;
};


export type Query_RootVenuesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootVideoAnalysisArgs = {
  distinctOn?: InputMaybe<Array<VideoAnalysisSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoAnalysisOrderBy>>;
  where?: InputMaybe<VideoAnalysisBoolExp>;
};


export type Query_RootVideoAnalysisAggregateArgs = {
  distinctOn?: InputMaybe<Array<VideoAnalysisSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoAnalysisOrderBy>>;
  where?: InputMaybe<VideoAnalysisBoolExp>;
};


export type Query_RootVideoAnalysisByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootVideoAnalysisCommentsArgs = {
  distinctOn?: InputMaybe<Array<VideoAnalysisCommentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoAnalysisCommentsOrderBy>>;
  where?: InputMaybe<VideoAnalysisCommentsBoolExp>;
};


export type Query_RootVideoAnalysisCommentsAggregateArgs = {
  distinctOn?: InputMaybe<Array<VideoAnalysisCommentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoAnalysisCommentsOrderBy>>;
  where?: InputMaybe<VideoAnalysisCommentsBoolExp>;
};


export type Query_RootVideoAnalysisCommentsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootVideoAnalysisFilesArgs = {
  distinctOn?: InputMaybe<Array<VideoAnalysisFilesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoAnalysisFilesOrderBy>>;
  where?: InputMaybe<VideoAnalysisFilesBoolExp>;
};


export type Query_RootVideoAnalysisFilesAggregateArgs = {
  distinctOn?: InputMaybe<Array<VideoAnalysisFilesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoAnalysisFilesOrderBy>>;
  where?: InputMaybe<VideoAnalysisFilesBoolExp>;
};


export type Query_RootVideoAnalysisFilesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootVideoAnalysisFilesUploadStatusesArgs = {
  distinctOn?: InputMaybe<Array<VideoAnalysisFilesUploadStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoAnalysisFilesUploadStatusesOrderBy>>;
  where?: InputMaybe<VideoAnalysisFilesUploadStatusesBoolExp>;
};


export type Query_RootVideoAnalysisFilesUploadStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<VideoAnalysisFilesUploadStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoAnalysisFilesUploadStatusesOrderBy>>;
  where?: InputMaybe<VideoAnalysisFilesUploadStatusesBoolExp>;
};


export type Query_RootVideoAnalysisFilesUploadStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootVideoAnalysisOrderItemsArgs = {
  distinctOn?: InputMaybe<Array<VideoAnalysisOrderItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoAnalysisOrderItemsOrderBy>>;
  where?: InputMaybe<VideoAnalysisOrderItemsBoolExp>;
};


export type Query_RootVideoAnalysisOrderItemsAggregateArgs = {
  distinctOn?: InputMaybe<Array<VideoAnalysisOrderItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoAnalysisOrderItemsOrderBy>>;
  where?: InputMaybe<VideoAnalysisOrderItemsBoolExp>;
};


export type Query_RootVideoAnalysisOrderItemsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootVideoAnalysisOrdersArgs = {
  distinctOn?: InputMaybe<Array<VideoAnalysisOrdersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoAnalysisOrdersOrderBy>>;
  where?: InputMaybe<VideoAnalysisOrdersBoolExp>;
};


export type Query_RootVideoAnalysisOrdersAggregateArgs = {
  distinctOn?: InputMaybe<Array<VideoAnalysisOrdersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoAnalysisOrdersOrderBy>>;
  where?: InputMaybe<VideoAnalysisOrdersBoolExp>;
};


export type Query_RootVideoAnalysisOrdersByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootVideoAnalysisRequestedSkillsReviewArgs = {
  distinctOn?: InputMaybe<Array<VideoAnalysisRequestedSkillsReviewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoAnalysisRequestedSkillsReviewOrderBy>>;
  where?: InputMaybe<VideoAnalysisRequestedSkillsReviewBoolExp>;
};


export type Query_RootVideoAnalysisRequestedSkillsReviewAggregateArgs = {
  distinctOn?: InputMaybe<Array<VideoAnalysisRequestedSkillsReviewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoAnalysisRequestedSkillsReviewOrderBy>>;
  where?: InputMaybe<VideoAnalysisRequestedSkillsReviewBoolExp>;
};


export type Query_RootVideoAnalysisRequestedSkillsReviewByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootVideoAnalysisReviewStatusesArgs = {
  distinctOn?: InputMaybe<Array<VideoAnalysisReviewStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoAnalysisReviewStatusesOrderBy>>;
  where?: InputMaybe<VideoAnalysisReviewStatusesBoolExp>;
};


export type Query_RootVideoAnalysisReviewStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<VideoAnalysisReviewStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoAnalysisReviewStatusesOrderBy>>;
  where?: InputMaybe<VideoAnalysisReviewStatusesBoolExp>;
};


export type Query_RootVideoAnalysisReviewStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootVideoAnalysisSkillsCommentsArgs = {
  distinctOn?: InputMaybe<Array<VideoAnalysisSkillsCommentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoAnalysisSkillsCommentsOrderBy>>;
  where?: InputMaybe<VideoAnalysisSkillsCommentsBoolExp>;
};


export type Query_RootVideoAnalysisSkillsCommentsAggregateArgs = {
  distinctOn?: InputMaybe<Array<VideoAnalysisSkillsCommentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoAnalysisSkillsCommentsOrderBy>>;
  where?: InputMaybe<VideoAnalysisSkillsCommentsBoolExp>;
};


export type Query_RootVideoAnalysisSkillsCommentsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootVideoAnalysisSubmissionLogArgs = {
  distinctOn?: InputMaybe<Array<VideoAnalysisSubmissionLogSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoAnalysisSubmissionLogOrderBy>>;
  where?: InputMaybe<VideoAnalysisSubmissionLogBoolExp>;
};


export type Query_RootVideoAnalysisSubmissionLogAggregateArgs = {
  distinctOn?: InputMaybe<Array<VideoAnalysisSubmissionLogSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoAnalysisSubmissionLogOrderBy>>;
  where?: InputMaybe<VideoAnalysisSubmissionLogBoolExp>;
};


export type Query_RootVideoAnalysisSubmissionLogByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootVideoLessonSkillsArgs = {
  distinctOn?: InputMaybe<Array<VideoLessonSkillsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoLessonSkillsOrderBy>>;
  where?: InputMaybe<VideoLessonSkillsBoolExp>;
};


export type Query_RootVideoLessonSkillsAggregateArgs = {
  distinctOn?: InputMaybe<Array<VideoLessonSkillsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoLessonSkillsOrderBy>>;
  where?: InputMaybe<VideoLessonSkillsBoolExp>;
};


export type Query_RootVideoLessonSkillsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootWelcomeEmailConfigurationArgs = {
  distinctOn?: InputMaybe<Array<WelcomeEmailConfigurationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<WelcomeEmailConfigurationOrderBy>>;
  where?: InputMaybe<WelcomeEmailConfigurationBoolExp>;
};


export type Query_RootWelcomeEmailConfigurationAggregateArgs = {
  distinctOn?: InputMaybe<Array<WelcomeEmailConfigurationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<WelcomeEmailConfigurationOrderBy>>;
  where?: InputMaybe<WelcomeEmailConfigurationBoolExp>;
};


export type Query_RootWelcomeEmailConfigurationByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootWinReasonsArgs = {
  distinctOn?: InputMaybe<Array<WinReasonsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<WinReasonsOrderBy>>;
  where?: InputMaybe<WinReasonsBoolExp>;
};


export type Query_RootWinReasonsAggregateArgs = {
  distinctOn?: InputMaybe<Array<WinReasonsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<WinReasonsOrderBy>>;
  where?: InputMaybe<WinReasonsBoolExp>;
};


export type Query_RootWinReasonsByPkArgs = {
  value: Scalars['String'];
};

export type ReviewsAggregateBoolExpBool_And = {
  arguments: ReviewsSelectColumnReviewsAggregateBoolExpBool_AndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ReviewsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type ReviewsAggregateBoolExpBool_Or = {
  arguments: ReviewsSelectColumnReviewsAggregateBoolExpBool_OrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ReviewsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type ReviewsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<ReviewsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ReviewsBoolExp>;
  predicate: IntComparisonExp;
};

export type SalesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<SalesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<SalesBoolExp>;
  predicate: IntComparisonExp;
};

export type St_D_Within_Geography_Input = {
  distance: Scalars['Float'];
  from: Scalars['geography'];
  use_spheroid?: InputMaybe<Scalars['Boolean']>;
};

export type St_D_Within_Input = {
  distance: Scalars['Float'];
  from: Scalars['geometry'];
};

export type StripeChargesAggregateBoolExpBool_And = {
  arguments: StripeChargesSelectColumnStripeChargesAggregateBoolExpBool_AndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<StripeChargesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type StripeChargesAggregateBoolExpBool_Or = {
  arguments: StripeChargesSelectColumnStripeChargesAggregateBoolExpBool_OrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<StripeChargesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type StripeChargesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<StripeChargesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<StripeChargesBoolExp>;
  predicate: IntComparisonExp;
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "amenities" */
  amenities: Array<Amenities>;
  /** fetch aggregated fields from the table: "amenities" */
  amenitiesAggregate: AmenitiesAggregate;
  /** fetch data from the table: "amenities" using primary key columns */
  amenitiesByPk?: Maybe<Amenities>;
  /** fetch data from the table in a streaming manner: "amenities" */
  amenitiesStream: Array<Amenities>;
  /** fetch data from the table: "app_personas" */
  appPersonas: Array<AppPersonas>;
  /** fetch aggregated fields from the table: "app_personas" */
  appPersonasAggregate: AppPersonasAggregate;
  /** fetch data from the table: "app_personas" using primary key columns */
  appPersonasByPk?: Maybe<AppPersonas>;
  /** fetch data from the table in a streaming manner: "app_personas" */
  appPersonasStream: Array<AppPersonas>;
  /** fetch data from the table: "app_pings" */
  appPings: Array<AppPings>;
  /** fetch aggregated fields from the table: "app_pings" */
  appPingsAggregate: AppPingsAggregate;
  /** fetch data from the table: "app_pings" using primary key columns */
  appPingsByPk?: Maybe<AppPings>;
  /** fetch data from the table in a streaming manner: "app_pings" */
  appPingsStream: Array<AppPings>;
  /** fetch data from the table: "ball_types" */
  ballTypes: Array<BallTypes>;
  /** fetch aggregated fields from the table: "ball_types" */
  ballTypesAggregate: BallTypesAggregate;
  /** fetch data from the table: "ball_types" using primary key columns */
  ballTypesByPk?: Maybe<BallTypes>;
  /** fetch data from the table in a streaming manner: "ball_types" */
  ballTypesStream: Array<BallTypes>;
  /** fetch data from the table: "birthday_visibility" */
  birthdayVisibility: Array<BirthdayVisibility>;
  /** fetch aggregated fields from the table: "birthday_visibility" */
  birthdayVisibilityAggregate: BirthdayVisibilityAggregate;
  /** fetch data from the table: "birthday_visibility" using primary key columns */
  birthdayVisibilityByPk?: Maybe<BirthdayVisibility>;
  /** fetch data from the table in a streaming manner: "birthday_visibility" */
  birthdayVisibilityStream: Array<BirthdayVisibility>;
  /** fetch data from the table: "booking_config_change_types" */
  bookingConfigChangeTypes: Array<BookingConfigChangeTypes>;
  /** fetch aggregated fields from the table: "booking_config_change_types" */
  bookingConfigChangeTypesAggregate: BookingConfigChangeTypesAggregate;
  /** fetch data from the table: "booking_config_change_types" using primary key columns */
  bookingConfigChangeTypesByPk?: Maybe<BookingConfigChangeTypes>;
  /** fetch data from the table in a streaming manner: "booking_config_change_types" */
  bookingConfigChangeTypesStream: Array<BookingConfigChangeTypes>;
  /** fetch data from the table: "booking_connection_statuses" */
  bookingConnectionStatuses: Array<BookingConnectionStatuses>;
  /** fetch aggregated fields from the table: "booking_connection_statuses" */
  bookingConnectionStatusesAggregate: BookingConnectionStatusesAggregate;
  /** fetch data from the table: "booking_connection_statuses" using primary key columns */
  bookingConnectionStatusesByPk?: Maybe<BookingConnectionStatuses>;
  /** fetch data from the table in a streaming manner: "booking_connection_statuses" */
  bookingConnectionStatusesStream: Array<BookingConnectionStatuses>;
  /** fetch data from the table: "booking_integration_statuses" */
  bookingIntegrationStatuses: Array<BookingIntegrationStatuses>;
  /** fetch aggregated fields from the table: "booking_integration_statuses" */
  bookingIntegrationStatusesAggregate: BookingIntegrationStatusesAggregate;
  /** fetch data from the table: "booking_integration_statuses" using primary key columns */
  bookingIntegrationStatusesByPk?: Maybe<BookingIntegrationStatuses>;
  /** fetch data from the table in a streaming manner: "booking_integration_statuses" */
  bookingIntegrationStatusesStream: Array<BookingIntegrationStatuses>;
  /** fetch data from the table: "booking_inventory_types" */
  bookingInventoryTypes: Array<BookingInventoryTypes>;
  /** fetch aggregated fields from the table: "booking_inventory_types" */
  bookingInventoryTypesAggregate: BookingInventoryTypesAggregate;
  /** fetch data from the table: "booking_inventory_types" using primary key columns */
  bookingInventoryTypesByPk?: Maybe<BookingInventoryTypes>;
  /** fetch data from the table in a streaming manner: "booking_inventory_types" */
  bookingInventoryTypesStream: Array<BookingInventoryTypes>;
  /** fetch data from the table: "booking_schedule_modes" */
  bookingScheduleModes: Array<BookingScheduleModes>;
  /** fetch aggregated fields from the table: "booking_schedule_modes" */
  bookingScheduleModesAggregate: BookingScheduleModesAggregate;
  /** fetch data from the table: "booking_schedule_modes" using primary key columns */
  bookingScheduleModesByPk?: Maybe<BookingScheduleModes>;
  /** fetch data from the table in a streaming manner: "booking_schedule_modes" */
  bookingScheduleModesStream: Array<BookingScheduleModes>;
  /** fetch data from the table: "booking_systems" */
  bookingSystems: Array<BookingSystems>;
  /** fetch aggregated fields from the table: "booking_systems" */
  bookingSystemsAggregate: BookingSystemsAggregate;
  /** fetch data from the table: "booking_systems" using primary key columns */
  bookingSystemsByPk?: Maybe<BookingSystems>;
  /** fetch data from the table in a streaming manner: "booking_systems" */
  bookingSystemsStream: Array<BookingSystems>;
  /** fetch data from the table: "booking_window_kinds" */
  bookingWindowKinds: Array<BookingWindowKinds>;
  /** fetch aggregated fields from the table: "booking_window_kinds" */
  bookingWindowKindsAggregate: BookingWindowKindsAggregate;
  /** fetch data from the table: "booking_window_kinds" using primary key columns */
  bookingWindowKindsByPk?: Maybe<BookingWindowKinds>;
  /** fetch data from the table in a streaming manner: "booking_window_kinds" */
  bookingWindowKindsStream: Array<BookingWindowKinds>;
  /** fetch data from the table: "boost_channels" */
  boostChannels: Array<BoostChannels>;
  /** fetch aggregated fields from the table: "boost_channels" */
  boostChannelsAggregate: BoostChannelsAggregate;
  /** fetch data from the table: "boost_channels" using primary key columns */
  boostChannelsByPk?: Maybe<BoostChannels>;
  /** fetch data from the table in a streaming manner: "boost_channels" */
  boostChannelsStream: Array<BoostChannels>;
  /** fetch data from the table: "boost_orders" */
  boostOrders: Array<BoostOrders>;
  /** fetch aggregated fields from the table: "boost_orders" */
  boostOrdersAggregate: BoostOrdersAggregate;
  /** fetch data from the table: "boost_orders" using primary key columns */
  boostOrdersByPk?: Maybe<BoostOrders>;
  /** fetch data from the table in a streaming manner: "boost_orders" */
  boostOrdersStream: Array<BoostOrders>;
  /** fetch data from the table: "boost_statuses" */
  boostStatuses: Array<BoostStatuses>;
  /** fetch aggregated fields from the table: "boost_statuses" */
  boostStatusesAggregate: BoostStatusesAggregate;
  /** fetch data from the table: "boost_statuses" using primary key columns */
  boostStatusesByPk?: Maybe<BoostStatuses>;
  /** fetch data from the table in a streaming manner: "boost_statuses" */
  boostStatusesStream: Array<BoostStatuses>;
  /** An array relationship */
  boosts: Array<Boosts>;
  /** An aggregate relationship */
  boostsAggregate: BoostsAggregate;
  /** fetch data from the table: "boosts" using primary key columns */
  boostsByPk?: Maybe<Boosts>;
  /** fetch data from the table in a streaming manner: "boosts" */
  boostsStream: Array<Boosts>;
  /** fetch data from the table: "bracket_ranking_mechanism" */
  bracketRankingMechanism: Array<BracketRankingMechanism>;
  /** fetch aggregated fields from the table: "bracket_ranking_mechanism" */
  bracketRankingMechanismAggregate: BracketRankingMechanismAggregate;
  /** fetch data from the table: "bracket_ranking_mechanism" using primary key columns */
  bracketRankingMechanismByPk?: Maybe<BracketRankingMechanism>;
  /** fetch data from the table in a streaming manner: "bracket_ranking_mechanism" */
  bracketRankingMechanismStream: Array<BracketRankingMechanism>;
  /** fetch data from the table: "calendar_accounts" */
  calendarAccounts: Array<CalendarAccounts>;
  /** fetch aggregated fields from the table: "calendar_accounts" */
  calendarAccountsAggregate: CalendarAccountsAggregate;
  /** fetch data from the table: "calendar_accounts" using primary key columns */
  calendarAccountsByPk?: Maybe<CalendarAccounts>;
  /** fetch data from the table in a streaming manner: "calendar_accounts" */
  calendarAccountsStream: Array<CalendarAccounts>;
  /** fetch data from the table: "calendar_auth_provider" */
  calendarAuthProvider: Array<CalendarAuthProvider>;
  /** fetch aggregated fields from the table: "calendar_auth_provider" */
  calendarAuthProviderAggregate: CalendarAuthProviderAggregate;
  /** fetch data from the table: "calendar_auth_provider" using primary key columns */
  calendarAuthProviderByPk?: Maybe<CalendarAuthProvider>;
  /** fetch data from the table in a streaming manner: "calendar_auth_provider" */
  calendarAuthProviderStream: Array<CalendarAuthProvider>;
  /** fetch data from the table: "calendar_event_mappings" */
  calendarEventMappings: Array<CalendarEventMappings>;
  /** fetch aggregated fields from the table: "calendar_event_mappings" */
  calendarEventMappingsAggregate: CalendarEventMappingsAggregate;
  /** fetch data from the table: "calendar_event_mappings" using primary key columns */
  calendarEventMappingsByPk?: Maybe<CalendarEventMappings>;
  /** fetch data from the table in a streaming manner: "calendar_event_mappings" */
  calendarEventMappingsStream: Array<CalendarEventMappings>;
  /** An array relationship */
  calendarPreferences: Array<CalendarPreferences>;
  /** An aggregate relationship */
  calendarPreferencesAggregate: CalendarPreferencesAggregate;
  /** fetch data from the table: "calendar_preferences" using primary key columns */
  calendarPreferencesByPk?: Maybe<CalendarPreferences>;
  /** fetch data from the table in a streaming manner: "calendar_preferences" */
  calendarPreferencesStream: Array<CalendarPreferences>;
  /** An array relationship */
  cities: Array<Cities>;
  /** An aggregate relationship */
  citiesAggregate: CitiesAggregate;
  /** fetch data from the table: "cities" using primary key columns */
  citiesByPk?: Maybe<Cities>;
  /** fetch data from the table in a streaming manner: "cities" */
  citiesStream: Array<Cities>;
  /** An array relationship */
  coachAvailability: Array<CoachAvailability>;
  /** An aggregate relationship */
  coachAvailabilityAggregate: CoachAvailabilityAggregate;
  /** fetch data from the table: "coach_availability" using primary key columns */
  coachAvailabilityByPk?: Maybe<CoachAvailability>;
  /** fetch data from the table: "coach_availability_statuses" */
  coachAvailabilityStatuses: Array<CoachAvailabilityStatuses>;
  /** fetch aggregated fields from the table: "coach_availability_statuses" */
  coachAvailabilityStatusesAggregate: CoachAvailabilityStatusesAggregate;
  /** fetch data from the table: "coach_availability_statuses" using primary key columns */
  coachAvailabilityStatusesByPk?: Maybe<CoachAvailabilityStatuses>;
  /** fetch data from the table in a streaming manner: "coach_availability_statuses" */
  coachAvailabilityStatusesStream: Array<CoachAvailabilityStatuses>;
  /** fetch data from the table in a streaming manner: "coach_availability" */
  coachAvailabilityStream: Array<CoachAvailability>;
  /** fetch data from the table: "coach_booking_requests" */
  coachBookingRequests: Array<CoachBookingRequests>;
  /** fetch aggregated fields from the table: "coach_booking_requests" */
  coachBookingRequestsAggregate: CoachBookingRequestsAggregate;
  /** fetch data from the table: "coach_booking_requests" using primary key columns */
  coachBookingRequestsByPk?: Maybe<CoachBookingRequests>;
  /** fetch data from the table in a streaming manner: "coach_booking_requests" */
  coachBookingRequestsStream: Array<CoachBookingRequests>;
  /** fetch data from the table: "coach_external_review_sources" */
  coachExternalReviewSources: Array<CoachExternalReviewSources>;
  /** fetch aggregated fields from the table: "coach_external_review_sources" */
  coachExternalReviewSourcesAggregate: CoachExternalReviewSourcesAggregate;
  /** fetch data from the table: "coach_external_review_sources" using primary key columns */
  coachExternalReviewSourcesByPk?: Maybe<CoachExternalReviewSources>;
  /** fetch data from the table in a streaming manner: "coach_external_review_sources" */
  coachExternalReviewSourcesStream: Array<CoachExternalReviewSources>;
  /** An array relationship */
  coachFaqs: Array<CoachFaqs>;
  /** An aggregate relationship */
  coachFaqsAggregate: CoachFaqsAggregate;
  /** fetch data from the table: "coach_faqs" using primary key columns */
  coachFaqsByPk?: Maybe<CoachFaqs>;
  /** fetch data from the table in a streaming manner: "coach_faqs" */
  coachFaqsStream: Array<CoachFaqs>;
  /** An array relationship */
  coachLessonAgeGroups: Array<CoachLessonAgeGroups>;
  /** An aggregate relationship */
  coachLessonAgeGroupsAggregate: CoachLessonAgeGroupsAggregate;
  /** fetch data from the table: "coach_lesson_age_groups" using primary key columns */
  coachLessonAgeGroupsByPk?: Maybe<CoachLessonAgeGroups>;
  /** fetch data from the table in a streaming manner: "coach_lesson_age_groups" */
  coachLessonAgeGroupsStream: Array<CoachLessonAgeGroups>;
  /** An array relationship */
  coachLessonSkillLevels: Array<CoachLessonSkillLevels>;
  /** An aggregate relationship */
  coachLessonSkillLevelsAggregate: CoachLessonSkillLevelsAggregate;
  /** fetch data from the table: "coach_lesson_skill_levels" using primary key columns */
  coachLessonSkillLevelsByPk?: Maybe<CoachLessonSkillLevels>;
  /** fetch data from the table in a streaming manner: "coach_lesson_skill_levels" */
  coachLessonSkillLevelsStream: Array<CoachLessonSkillLevels>;
  /** fetch data from the table: "coach_qualification_groups" */
  coachQualificationGroups: Array<CoachQualificationGroups>;
  /** fetch aggregated fields from the table: "coach_qualification_groups" */
  coachQualificationGroupsAggregate: CoachQualificationGroupsAggregate;
  /** fetch data from the table: "coach_qualification_groups" using primary key columns */
  coachQualificationGroupsByPk?: Maybe<CoachQualificationGroups>;
  /** fetch data from the table in a streaming manner: "coach_qualification_groups" */
  coachQualificationGroupsStream: Array<CoachQualificationGroups>;
  /** fetch data from the table: "coach_qualification_statuses" */
  coachQualificationStatuses: Array<CoachQualificationStatuses>;
  /** fetch aggregated fields from the table: "coach_qualification_statuses" */
  coachQualificationStatusesAggregate: CoachQualificationStatusesAggregate;
  /** fetch data from the table: "coach_qualification_statuses" using primary key columns */
  coachQualificationStatusesByPk?: Maybe<CoachQualificationStatuses>;
  /** fetch data from the table in a streaming manner: "coach_qualification_statuses" */
  coachQualificationStatusesStream: Array<CoachQualificationStatuses>;
  /** fetch data from the table: "coach_qualifications" */
  coachQualifications: Array<CoachQualifications>;
  /** fetch aggregated fields from the table: "coach_qualifications" */
  coachQualificationsAggregate: CoachQualificationsAggregate;
  /** fetch data from the table: "coach_qualifications" using primary key columns */
  coachQualificationsByPk?: Maybe<CoachQualifications>;
  /** fetch data from the table in a streaming manner: "coach_qualifications" */
  coachQualificationsStream: Array<CoachQualifications>;
  /** fetch data from the table: "coach_review_types" */
  coachReviewTypes: Array<CoachReviewTypes>;
  /** fetch aggregated fields from the table: "coach_review_types" */
  coachReviewTypesAggregate: CoachReviewTypesAggregate;
  /** fetch data from the table: "coach_review_types" using primary key columns */
  coachReviewTypesByPk?: Maybe<CoachReviewTypes>;
  /** fetch data from the table in a streaming manner: "coach_review_types" */
  coachReviewTypesStream: Array<CoachReviewTypes>;
  /** fetch data from the table: "coach_sport_statuses" */
  coachSportStatuses: Array<CoachSportStatuses>;
  /** fetch aggregated fields from the table: "coach_sport_statuses" */
  coachSportStatusesAggregate: CoachSportStatusesAggregate;
  /** fetch data from the table: "coach_sport_statuses" using primary key columns */
  coachSportStatusesByPk?: Maybe<CoachSportStatuses>;
  /** fetch data from the table in a streaming manner: "coach_sport_statuses" */
  coachSportStatusesStream: Array<CoachSportStatuses>;
  /** An array relationship */
  coachSports: Array<CoachSports>;
  /** An aggregate relationship */
  coachSportsAggregate: CoachSportsAggregate;
  /** fetch data from the table: "coach_sports" using primary key columns */
  coachSportsByPk?: Maybe<CoachSports>;
  /** fetch data from the table in a streaming manner: "coach_sports" */
  coachSportsStream: Array<CoachSports>;
  /** An array relationship */
  coachStarterProfiles: Array<CoachStarterProfiles>;
  /** An aggregate relationship */
  coachStarterProfilesAggregate: CoachStarterProfilesAggregate;
  /** fetch data from the table: "coach_starter_profiles" using primary key columns */
  coachStarterProfilesByPk?: Maybe<CoachStarterProfiles>;
  /** fetch data from the table in a streaming manner: "coach_starter_profiles" */
  coachStarterProfilesStream: Array<CoachStarterProfiles>;
  /** fetch data from the table: "coach_status" */
  coachStatus: Array<CoachStatus>;
  /** fetch aggregated fields from the table: "coach_status" */
  coachStatusAggregate: CoachStatusAggregate;
  /** fetch data from the table: "coach_status" using primary key columns */
  coachStatusByPk?: Maybe<CoachStatus>;
  /** fetch data from the table in a streaming manner: "coach_status" */
  coachStatusStream: Array<CoachStatus>;
  /** fetch data from the table: "coach_tips" */
  coachTips: Array<CoachTips>;
  /** fetch aggregated fields from the table: "coach_tips" */
  coachTipsAggregate: CoachTipsAggregate;
  /** fetch data from the table: "coach_tips" using primary key columns */
  coachTipsByPk?: Maybe<CoachTips>;
  /** fetch data from the table in a streaming manner: "coach_tips" */
  coachTipsStream: Array<CoachTips>;
  /** fetch data from the table: "comment_vote" */
  commentVote: Array<CommentVote>;
  /** fetch aggregated fields from the table: "comment_vote" */
  commentVoteAggregate: CommentVoteAggregate;
  /** fetch data from the table: "comment_vote" using primary key columns */
  commentVoteByPk?: Maybe<CommentVote>;
  /** fetch data from the table in a streaming manner: "comment_vote" */
  commentVoteStream: Array<CommentVote>;
  /** fetch data from the table: "communication_preference_statuses" */
  communicationPreferenceStatuses: Array<CommunicationPreferenceStatuses>;
  /** fetch aggregated fields from the table: "communication_preference_statuses" */
  communicationPreferenceStatusesAggregate: CommunicationPreferenceStatusesAggregate;
  /** fetch data from the table: "communication_preference_statuses" using primary key columns */
  communicationPreferenceStatusesByPk?: Maybe<CommunicationPreferenceStatuses>;
  /** fetch data from the table in a streaming manner: "communication_preference_statuses" */
  communicationPreferenceStatusesStream: Array<CommunicationPreferenceStatuses>;
  /** fetch data from the table: "competition_formats" */
  competitionFormats: Array<CompetitionFormats>;
  /** fetch aggregated fields from the table: "competition_formats" */
  competitionFormatsAggregate: CompetitionFormatsAggregate;
  /** fetch data from the table: "competition_formats" using primary key columns */
  competitionFormatsByPk?: Maybe<CompetitionFormats>;
  /** fetch data from the table in a streaming manner: "competition_formats" */
  competitionFormatsStream: Array<CompetitionFormats>;
  /** fetch data from the table: "competition_gender" */
  competitionGender: Array<CompetitionGender>;
  /** fetch aggregated fields from the table: "competition_gender" */
  competitionGenderAggregate: CompetitionGenderAggregate;
  /** fetch data from the table: "competition_gender" using primary key columns */
  competitionGenderByPk?: Maybe<CompetitionGender>;
  /** fetch data from the table in a streaming manner: "competition_gender" */
  competitionGenderStream: Array<CompetitionGender>;
  /** fetch data from the table: "content_reports" */
  contentReports: Array<ContentReports>;
  /** fetch aggregated fields from the table: "content_reports" */
  contentReportsAggregate: ContentReportsAggregate;
  /** fetch data from the table: "content_reports" using primary key columns */
  contentReportsByPk?: Maybe<ContentReports>;
  /** fetch data from the table in a streaming manner: "content_reports" */
  contentReportsStream: Array<ContentReports>;
  /** fetch data from the table: "conversation_participants" */
  conversationParticipants: Array<ConversationParticipants>;
  /** fetch aggregated fields from the table: "conversation_participants" */
  conversationParticipantsAggregate: ConversationParticipantsAggregate;
  /** fetch data from the table: "conversation_participants" using primary key columns */
  conversationParticipantsByPk?: Maybe<ConversationParticipants>;
  /** fetch data from the table in a streaming manner: "conversation_participants" */
  conversationParticipantsStream: Array<ConversationParticipants>;
  /** fetch data from the table: "conversation_types" */
  conversationTypes: Array<ConversationTypes>;
  /** fetch aggregated fields from the table: "conversation_types" */
  conversationTypesAggregate: ConversationTypesAggregate;
  /** fetch data from the table: "conversation_types" using primary key columns */
  conversationTypesByPk?: Maybe<ConversationTypes>;
  /** fetch data from the table in a streaming manner: "conversation_types" */
  conversationTypesStream: Array<ConversationTypes>;
  /** An array relationship */
  conversations: Array<Conversations>;
  /** An aggregate relationship */
  conversationsAggregate: ConversationsAggregate;
  /** fetch data from the table: "conversations" using primary key columns */
  conversationsByPk?: Maybe<Conversations>;
  /** fetch data from the table in a streaming manner: "conversations" */
  conversationsStream: Array<Conversations>;
  /** fetch data from the table: "countries" */
  countries: Array<Countries>;
  /** fetch aggregated fields from the table: "countries" */
  countriesAggregate: CountriesAggregate;
  /** fetch data from the table: "countries" using primary key columns */
  countriesByPk?: Maybe<Countries>;
  /** fetch data from the table in a streaming manner: "countries" */
  countriesStream: Array<Countries>;
  /** fetch data from the table: "country_subdivisions" */
  countrySubdivisions: Array<CountrySubdivisions>;
  /** fetch aggregated fields from the table: "country_subdivisions" */
  countrySubdivisionsAggregate: CountrySubdivisionsAggregate;
  /** fetch data from the table: "country_subdivisions" using primary key columns */
  countrySubdivisionsByPk?: Maybe<CountrySubdivisions>;
  /** fetch data from the table in a streaming manner: "country_subdivisions" */
  countrySubdivisionsStream: Array<CountrySubdivisions>;
  /** fetch data from the table: "court_surfaces" */
  courtSurfaces: Array<CourtSurfaces>;
  /** fetch aggregated fields from the table: "court_surfaces" */
  courtSurfacesAggregate: CourtSurfacesAggregate;
  /** fetch data from the table: "court_surfaces" using primary key columns */
  courtSurfacesByPk?: Maybe<CourtSurfaces>;
  /** fetch data from the table in a streaming manner: "court_surfaces" */
  courtSurfacesStream: Array<CourtSurfaces>;
  /** fetch data from the table: "day_of_week" */
  dayOfWeek: Array<DayOfWeek>;
  /** fetch aggregated fields from the table: "day_of_week" */
  dayOfWeekAggregate: DayOfWeekAggregate;
  /** fetch data from the table: "day_of_week" using primary key columns */
  dayOfWeekByPk?: Maybe<DayOfWeek>;
  /** fetch data from the table in a streaming manner: "day_of_week" */
  dayOfWeekStream: Array<DayOfWeek>;
  /** fetch data from the table: "engagement_analytics" */
  engagementAnalytics: Array<EngagementAnalytics>;
  /** fetch aggregated fields from the table: "engagement_analytics" */
  engagementAnalyticsAggregate: EngagementAnalyticsAggregate;
  /** fetch data from the table: "engagement_analytics" using primary key columns */
  engagementAnalyticsByPk?: Maybe<EngagementAnalytics>;
  /** fetch data from the table in a streaming manner: "engagement_analytics" */
  engagementAnalyticsStream: Array<EngagementAnalytics>;
  /** fetch data from the table: "engagement_entity_types" */
  engagementEntityTypes: Array<EngagementEntityTypes>;
  /** fetch aggregated fields from the table: "engagement_entity_types" */
  engagementEntityTypesAggregate: EngagementEntityTypesAggregate;
  /** fetch data from the table: "engagement_entity_types" using primary key columns */
  engagementEntityTypesByPk?: Maybe<EngagementEntityTypes>;
  /** fetch data from the table in a streaming manner: "engagement_entity_types" */
  engagementEntityTypesStream: Array<EngagementEntityTypes>;
  /** fetch data from the table: "engagement_event_types" */
  engagementEventTypes: Array<EngagementEventTypes>;
  /** fetch aggregated fields from the table: "engagement_event_types" */
  engagementEventTypesAggregate: EngagementEventTypesAggregate;
  /** fetch data from the table: "engagement_event_types" using primary key columns */
  engagementEventTypesByPk?: Maybe<EngagementEventTypes>;
  /** fetch data from the table in a streaming manner: "engagement_event_types" */
  engagementEventTypesStream: Array<EngagementEventTypes>;
  /** fetch data from the table: "engagement_sources" */
  engagementSources: Array<EngagementSources>;
  /** fetch aggregated fields from the table: "engagement_sources" */
  engagementSourcesAggregate: EngagementSourcesAggregate;
  /** fetch data from the table: "engagement_sources" using primary key columns */
  engagementSourcesByPk?: Maybe<EngagementSources>;
  /** fetch data from the table in a streaming manner: "engagement_sources" */
  engagementSourcesStream: Array<EngagementSources>;
  /** fetch data from the table: "equipment_availabilities" */
  equipmentAvailabilities: Array<EquipmentAvailabilities>;
  /** fetch aggregated fields from the table: "equipment_availabilities" */
  equipmentAvailabilitiesAggregate: EquipmentAvailabilitiesAggregate;
  /** fetch data from the table: "equipment_availabilities" using primary key columns */
  equipmentAvailabilitiesByPk?: Maybe<EquipmentAvailabilities>;
  /** fetch data from the table in a streaming manner: "equipment_availabilities" */
  equipmentAvailabilitiesStream: Array<EquipmentAvailabilities>;
  /** fetch data from the table: "event_accepted_play_requests" */
  eventAcceptedPlayRequests: Array<EventAcceptedPlayRequests>;
  /** fetch aggregated fields from the table: "event_accepted_play_requests" */
  eventAcceptedPlayRequestsAggregate: EventAcceptedPlayRequestsAggregate;
  /** fetch data from the table in a streaming manner: "event_accepted_play_requests" */
  eventAcceptedPlayRequestsStream: Array<EventAcceptedPlayRequests>;
  /** fetch data from the table: "event_age_groups" */
  eventAgeGroups: Array<EventAgeGroups>;
  /** fetch aggregated fields from the table: "event_age_groups" */
  eventAgeGroupsAggregate: EventAgeGroupsAggregate;
  /** fetch data from the table: "event_age_groups" using primary key columns */
  eventAgeGroupsByPk?: Maybe<EventAgeGroups>;
  /** fetch data from the table in a streaming manner: "event_age_groups" */
  eventAgeGroupsStream: Array<EventAgeGroups>;
  /** fetch data from the table: "event_collections" */
  eventCollections: Array<EventCollections>;
  /** fetch aggregated fields from the table: "event_collections" */
  eventCollectionsAggregate: EventCollectionsAggregate;
  /** fetch data from the table: "event_collections" using primary key columns */
  eventCollectionsByPk?: Maybe<EventCollections>;
  /** fetch data from the table in a streaming manner: "event_collections" */
  eventCollectionsStream: Array<EventCollections>;
  /** fetch data from the table: "event_competitiveness" */
  eventCompetitiveness: Array<EventCompetitiveness>;
  /** fetch aggregated fields from the table: "event_competitiveness" */
  eventCompetitivenessAggregate: EventCompetitivenessAggregate;
  /** fetch data from the table: "event_competitiveness" using primary key columns */
  eventCompetitivenessByPk?: Maybe<EventCompetitiveness>;
  /** fetch data from the table in a streaming manner: "event_competitiveness" */
  eventCompetitivenessStream: Array<EventCompetitiveness>;
  /** fetch data from the table: "event_contact_details" */
  eventContactDetails: Array<EventContactDetails>;
  /** fetch aggregated fields from the table: "event_contact_details" */
  eventContactDetailsAggregate: EventContactDetailsAggregate;
  /** fetch data from the table: "event_contact_details" using primary key columns */
  eventContactDetailsByPk?: Maybe<EventContactDetails>;
  /** fetch data from the table in a streaming manner: "event_contact_details" */
  eventContactDetailsStream: Array<EventContactDetails>;
  /** fetch data from the table: "event_coupon_groups" */
  eventCouponGroups: Array<EventCouponGroups>;
  /** fetch aggregated fields from the table: "event_coupon_groups" */
  eventCouponGroupsAggregate: EventCouponGroupsAggregate;
  /** fetch data from the table: "event_coupon_groups" using primary key columns */
  eventCouponGroupsByPk?: Maybe<EventCouponGroups>;
  /** fetch data from the table in a streaming manner: "event_coupon_groups" */
  eventCouponGroupsStream: Array<EventCouponGroups>;
  /** fetch data from the table: "event_coupon_redemptions" */
  eventCouponRedemptions: Array<EventCouponRedemptions>;
  /** fetch aggregated fields from the table: "event_coupon_redemptions" */
  eventCouponRedemptionsAggregate: EventCouponRedemptionsAggregate;
  /** fetch data from the table: "event_coupon_redemptions" using primary key columns */
  eventCouponRedemptionsByPk?: Maybe<EventCouponRedemptions>;
  /** fetch data from the table in a streaming manner: "event_coupon_redemptions" */
  eventCouponRedemptionsStream: Array<EventCouponRedemptions>;
  /** fetch data from the table: "event_coupon_source" */
  eventCouponSource: Array<EventCouponSource>;
  /** fetch aggregated fields from the table: "event_coupon_source" */
  eventCouponSourceAggregate: EventCouponSourceAggregate;
  /** fetch data from the table: "event_coupon_source" using primary key columns */
  eventCouponSourceByPk?: Maybe<EventCouponSource>;
  /** fetch data from the table in a streaming manner: "event_coupon_source" */
  eventCouponSourceStream: Array<EventCouponSource>;
  /** fetch data from the table: "event_coupon_type" */
  eventCouponType: Array<EventCouponType>;
  /** fetch aggregated fields from the table: "event_coupon_type" */
  eventCouponTypeAggregate: EventCouponTypeAggregate;
  /** fetch data from the table: "event_coupon_type" using primary key columns */
  eventCouponTypeByPk?: Maybe<EventCouponType>;
  /** fetch data from the table in a streaming manner: "event_coupon_type" */
  eventCouponTypeStream: Array<EventCouponType>;
  /** fetch data from the table: "event_coupons" */
  eventCoupons: Array<EventCoupons>;
  /** fetch aggregated fields from the table: "event_coupons" */
  eventCouponsAggregate: EventCouponsAggregate;
  /** fetch data from the table: "event_coupons" using primary key columns */
  eventCouponsByPk?: Maybe<EventCoupons>;
  /** fetch data from the table in a streaming manner: "event_coupons" */
  eventCouponsStream: Array<EventCoupons>;
  /** fetch data from the table: "event_court_statuses" */
  eventCourtStatuses: Array<EventCourtStatuses>;
  /** fetch aggregated fields from the table: "event_court_statuses" */
  eventCourtStatusesAggregate: EventCourtStatusesAggregate;
  /** fetch data from the table: "event_court_statuses" using primary key columns */
  eventCourtStatusesByPk?: Maybe<EventCourtStatuses>;
  /** fetch data from the table in a streaming manner: "event_court_statuses" */
  eventCourtStatusesStream: Array<EventCourtStatuses>;
  /** fetch data from the table: "event_courts" */
  eventCourts: Array<EventCourts>;
  /** fetch aggregated fields from the table: "event_courts" */
  eventCourtsAggregate: EventCourtsAggregate;
  /** fetch data from the table: "event_courts" using primary key columns */
  eventCourtsByPk?: Maybe<EventCourts>;
  /** fetch data from the table in a streaming manner: "event_courts" */
  eventCourtsStream: Array<EventCourts>;
  /** fetch data from the table: "event_faqs" */
  eventFaqs: Array<EventFaqs>;
  /** fetch aggregated fields from the table: "event_faqs" */
  eventFaqsAggregate: EventFaqsAggregate;
  /** fetch data from the table: "event_faqs" using primary key columns */
  eventFaqsByPk?: Maybe<EventFaqs>;
  /** fetch data from the table in a streaming manner: "event_faqs" */
  eventFaqsStream: Array<EventFaqs>;
  /** fetch data from the table: "event_game_scores" */
  eventGameScores: Array<EventGameScores>;
  /** fetch aggregated fields from the table: "event_game_scores" */
  eventGameScoresAggregate: EventGameScoresAggregate;
  /** fetch data from the table: "event_game_scores" using primary key columns */
  eventGameScoresByPk?: Maybe<EventGameScores>;
  /** fetch data from the table in a streaming manner: "event_game_scores" */
  eventGameScoresStream: Array<EventGameScores>;
  /** fetch data from the table: "event_group_formats" */
  eventGroupFormats: Array<EventGroupFormats>;
  /** fetch aggregated fields from the table: "event_group_formats" */
  eventGroupFormatsAggregate: EventGroupFormatsAggregate;
  /** fetch data from the table: "event_group_formats" using primary key columns */
  eventGroupFormatsByPk?: Maybe<EventGroupFormats>;
  /** fetch data from the table in a streaming manner: "event_group_formats" */
  eventGroupFormatsStream: Array<EventGroupFormats>;
  /** fetch data from the table: "event_group_merges" */
  eventGroupMerges: Array<EventGroupMerges>;
  /** fetch aggregated fields from the table: "event_group_merges" */
  eventGroupMergesAggregate: EventGroupMergesAggregate;
  /** fetch data from the table: "event_group_merges" using primary key columns */
  eventGroupMergesByPk?: Maybe<EventGroupMerges>;
  /** fetch data from the table in a streaming manner: "event_group_merges" */
  eventGroupMergesStream: Array<EventGroupMerges>;
  /** fetch data from the table: "event_group_pools" */
  eventGroupPools: Array<EventGroupPools>;
  /** fetch aggregated fields from the table: "event_group_pools" */
  eventGroupPoolsAggregate: EventGroupPoolsAggregate;
  /** fetch data from the table: "event_group_pools" using primary key columns */
  eventGroupPoolsByPk?: Maybe<EventGroupPools>;
  /** fetch data from the table in a streaming manner: "event_group_pools" */
  eventGroupPoolsStream: Array<EventGroupPools>;
  /** fetch data from the table: "event_group_rating_scales" */
  eventGroupRatingScales: Array<EventGroupRatingScales>;
  /** fetch aggregated fields from the table: "event_group_rating_scales" */
  eventGroupRatingScalesAggregate: EventGroupRatingScalesAggregate;
  /** fetch data from the table: "event_group_rating_scales" using primary key columns */
  eventGroupRatingScalesByPk?: Maybe<EventGroupRatingScales>;
  /** fetch data from the table in a streaming manner: "event_group_rating_scales" */
  eventGroupRatingScalesStream: Array<EventGroupRatingScales>;
  /** fetch data from the table: "event_group_registration_statuses" */
  eventGroupRegistrationStatuses: Array<EventGroupRegistrationStatuses>;
  /** fetch aggregated fields from the table: "event_group_registration_statuses" */
  eventGroupRegistrationStatusesAggregate: EventGroupRegistrationStatusesAggregate;
  /** fetch data from the table: "event_group_registration_statuses" using primary key columns */
  eventGroupRegistrationStatusesByPk?: Maybe<EventGroupRegistrationStatuses>;
  /** fetch data from the table in a streaming manner: "event_group_registration_statuses" */
  eventGroupRegistrationStatusesStream: Array<EventGroupRegistrationStatuses>;
  /** fetch data from the table: "event_group_registrations" */
  eventGroupRegistrations: Array<EventGroupRegistrations>;
  /** fetch aggregated fields from the table: "event_group_registrations" */
  eventGroupRegistrationsAggregate: EventGroupRegistrationsAggregate;
  /** fetch data from the table: "event_group_registrations" using primary key columns */
  eventGroupRegistrationsByPk?: Maybe<EventGroupRegistrations>;
  /** fetch data from the table in a streaming manner: "event_group_registrations" */
  eventGroupRegistrationsStream: Array<EventGroupRegistrations>;
  /** fetch data from the table: "event_group_sequence_seeding" */
  eventGroupSequenceSeeding: Array<EventGroupSequenceSeeding>;
  /** fetch aggregated fields from the table: "event_group_sequence_seeding" */
  eventGroupSequenceSeedingAggregate: EventGroupSequenceSeedingAggregate;
  /** fetch data from the table: "event_group_sequence_seeding" using primary key columns */
  eventGroupSequenceSeedingByPk?: Maybe<EventGroupSequenceSeeding>;
  /** fetch data from the table in a streaming manner: "event_group_sequence_seeding" */
  eventGroupSequenceSeedingStream: Array<EventGroupSequenceSeeding>;
  /** fetch data from the table: "event_group_sequences" */
  eventGroupSequences: Array<EventGroupSequences>;
  /** fetch aggregated fields from the table: "event_group_sequences" */
  eventGroupSequencesAggregate: EventGroupSequencesAggregate;
  /** fetch data from the table: "event_group_sequences" using primary key columns */
  eventGroupSequencesByPk?: Maybe<EventGroupSequences>;
  /** fetch data from the table in a streaming manner: "event_group_sequences" */
  eventGroupSequencesStream: Array<EventGroupSequences>;
  /** fetch data from the table: "event_group_time_slots" */
  eventGroupTimeSlots: Array<EventGroupTimeSlots>;
  /** fetch aggregated fields from the table: "event_group_time_slots" */
  eventGroupTimeSlotsAggregate: EventGroupTimeSlotsAggregate;
  /** fetch data from the table: "event_group_time_slots" using primary key columns */
  eventGroupTimeSlotsByPk?: Maybe<EventGroupTimeSlots>;
  /** fetch data from the table in a streaming manner: "event_group_time_slots" */
  eventGroupTimeSlotsStream: Array<EventGroupTimeSlots>;
  /** fetch data from the table: "event_groups" */
  eventGroups: Array<EventGroups>;
  /** fetch aggregated fields from the table: "event_groups" */
  eventGroupsAggregate: EventGroupsAggregate;
  /** fetch data from the table: "event_groups" using primary key columns */
  eventGroupsByPk?: Maybe<EventGroups>;
  /** fetch data from the table in a streaming manner: "event_groups" */
  eventGroupsStream: Array<EventGroups>;
  /** fetch data from the table: "event_invitation_statuses" */
  eventInvitationStatuses: Array<EventInvitationStatuses>;
  /** fetch aggregated fields from the table: "event_invitation_statuses" */
  eventInvitationStatusesAggregate: EventInvitationStatusesAggregate;
  /** fetch data from the table: "event_invitation_statuses" using primary key columns */
  eventInvitationStatusesByPk?: Maybe<EventInvitationStatuses>;
  /** fetch data from the table in a streaming manner: "event_invitation_statuses" */
  eventInvitationStatusesStream: Array<EventInvitationStatuses>;
  /** fetch data from the table: "event_invitation_types" */
  eventInvitationTypes: Array<EventInvitationTypes>;
  /** fetch aggregated fields from the table: "event_invitation_types" */
  eventInvitationTypesAggregate: EventInvitationTypesAggregate;
  /** fetch data from the table: "event_invitation_types" using primary key columns */
  eventInvitationTypesByPk?: Maybe<EventInvitationTypes>;
  /** fetch data from the table in a streaming manner: "event_invitation_types" */
  eventInvitationTypesStream: Array<EventInvitationTypes>;
  /** fetch data from the table: "event_invitations" */
  eventInvitations: Array<EventInvitations>;
  /** fetch aggregated fields from the table: "event_invitations" */
  eventInvitationsAggregate: EventInvitationsAggregate;
  /** fetch data from the table: "event_invitations" using primary key columns */
  eventInvitationsByPk?: Maybe<EventInvitations>;
  /** fetch data from the table in a streaming manner: "event_invitations" */
  eventInvitationsStream: Array<EventInvitations>;
  /** fetch data from the table: "event_listing_fees" */
  eventListingFees: Array<EventListingFees>;
  /** fetch aggregated fields from the table: "event_listing_fees" */
  eventListingFeesAggregate: EventListingFeesAggregate;
  /** fetch data from the table: "event_listing_fees" using primary key columns */
  eventListingFeesByPk?: Maybe<EventListingFees>;
  /** fetch data from the table in a streaming manner: "event_listing_fees" */
  eventListingFeesStream: Array<EventListingFees>;
  /** fetch data from the table: "event_match_games" */
  eventMatchGames: Array<EventMatchGames>;
  /** fetch aggregated fields from the table: "event_match_games" */
  eventMatchGamesAggregate: EventMatchGamesAggregate;
  /** fetch data from the table: "event_match_games" using primary key columns */
  eventMatchGamesByPk?: Maybe<EventMatchGames>;
  /** fetch data from the table in a streaming manner: "event_match_games" */
  eventMatchGamesStream: Array<EventMatchGames>;
  /** fetch data from the table: "event_matches" */
  eventMatches: Array<EventMatches>;
  /** fetch aggregated fields from the table: "event_matches" */
  eventMatchesAggregate: EventMatchesAggregate;
  /** fetch data from the table: "event_matches" using primary key columns */
  eventMatchesByPk?: Maybe<EventMatches>;
  /** fetch data from the table in a streaming manner: "event_matches" */
  eventMatchesStream: Array<EventMatches>;
  /** fetch data from the table: "event_matches_teams" */
  eventMatchesTeams: Array<EventMatchesTeams>;
  /** fetch aggregated fields from the table: "event_matches_teams" */
  eventMatchesTeamsAggregate: EventMatchesTeamsAggregate;
  /** fetch data from the table: "event_matches_teams" using primary key columns */
  eventMatchesTeamsByPk?: Maybe<EventMatchesTeams>;
  /** fetch data from the table in a streaming manner: "event_matches_teams" */
  eventMatchesTeamsStream: Array<EventMatchesTeams>;
  /** fetch data from the table: "event_organizer_account_types" */
  eventOrganizerAccountTypes: Array<EventOrganizerAccountTypes>;
  /** fetch aggregated fields from the table: "event_organizer_account_types" */
  eventOrganizerAccountTypesAggregate: EventOrganizerAccountTypesAggregate;
  /** fetch data from the table: "event_organizer_account_types" using primary key columns */
  eventOrganizerAccountTypesByPk?: Maybe<EventOrganizerAccountTypes>;
  /** fetch data from the table in a streaming manner: "event_organizer_account_types" */
  eventOrganizerAccountTypesStream: Array<EventOrganizerAccountTypes>;
  /** fetch data from the table: "event_player_invite_statuses" */
  eventPlayerInviteStatuses: Array<EventPlayerInviteStatuses>;
  /** fetch aggregated fields from the table: "event_player_invite_statuses" */
  eventPlayerInviteStatusesAggregate: EventPlayerInviteStatusesAggregate;
  /** fetch data from the table: "event_player_invite_statuses" using primary key columns */
  eventPlayerInviteStatusesByPk?: Maybe<EventPlayerInviteStatuses>;
  /** fetch data from the table in a streaming manner: "event_player_invite_statuses" */
  eventPlayerInviteStatusesStream: Array<EventPlayerInviteStatuses>;
  /** fetch data from the table: "event_player_invites" */
  eventPlayerInvites: Array<EventPlayerInvites>;
  /** fetch aggregated fields from the table: "event_player_invites" */
  eventPlayerInvitesAggregate: EventPlayerInvitesAggregate;
  /** fetch data from the table: "event_player_invites" using primary key columns */
  eventPlayerInvitesByPk?: Maybe<EventPlayerInvites>;
  /** fetch data from the table in a streaming manner: "event_player_invites" */
  eventPlayerInvitesStream: Array<EventPlayerInvites>;
  /** fetch data from the table: "event_pool_rounds" */
  eventPoolRounds: Array<EventPoolRounds>;
  /** fetch aggregated fields from the table: "event_pool_rounds" */
  eventPoolRoundsAggregate: EventPoolRoundsAggregate;
  /** fetch data from the table: "event_pool_rounds" using primary key columns */
  eventPoolRoundsByPk?: Maybe<EventPoolRounds>;
  /** fetch data from the table in a streaming manner: "event_pool_rounds" */
  eventPoolRoundsStream: Array<EventPoolRounds>;
  /** fetch data from the table: "event_pools_teams" */
  eventPoolsTeams: Array<EventPoolsTeams>;
  /** fetch aggregated fields from the table: "event_pools_teams" */
  eventPoolsTeamsAggregate: EventPoolsTeamsAggregate;
  /** fetch data from the table: "event_pools_teams" using primary key columns */
  eventPoolsTeamsByPk?: Maybe<EventPoolsTeams>;
  /** fetch data from the table in a streaming manner: "event_pools_teams" */
  eventPoolsTeamsStream: Array<EventPoolsTeams>;
  /** fetch data from the table: "event_privacy" */
  eventPrivacy: Array<EventPrivacy>;
  /** fetch aggregated fields from the table: "event_privacy" */
  eventPrivacyAggregate: EventPrivacyAggregate;
  /** fetch data from the table: "event_privacy" using primary key columns */
  eventPrivacyByPk?: Maybe<EventPrivacy>;
  /** fetch data from the table in a streaming manner: "event_privacy" */
  eventPrivacyStream: Array<EventPrivacy>;
  /** fetch data from the table: "event_registration_details" */
  eventRegistrationDetails: Array<EventRegistrationDetails>;
  /** fetch aggregated fields from the table: "event_registration_details" */
  eventRegistrationDetailsAggregate: EventRegistrationDetailsAggregate;
  /** fetch data from the table: "event_registration_details" using primary key columns */
  eventRegistrationDetailsByPk?: Maybe<EventRegistrationDetails>;
  /** fetch data from the table in a streaming manner: "event_registration_details" */
  eventRegistrationDetailsStream: Array<EventRegistrationDetails>;
  /** fetch data from the table: "event_registrations" */
  eventRegistrations: Array<EventRegistrations>;
  /** fetch aggregated fields from the table: "event_registrations" */
  eventRegistrationsAggregate: EventRegistrationsAggregate;
  /** fetch data from the table: "event_registrations" using primary key columns */
  eventRegistrationsByPk?: Maybe<EventRegistrations>;
  /** fetch data from the table in a streaming manner: "event_registrations" */
  eventRegistrationsStream: Array<EventRegistrations>;
  /** fetch data from the table: "event_sequence_complete_reasons" */
  eventSequenceCompleteReasons: Array<EventSequenceCompleteReasons>;
  /** fetch aggregated fields from the table: "event_sequence_complete_reasons" */
  eventSequenceCompleteReasonsAggregate: EventSequenceCompleteReasonsAggregate;
  /** fetch data from the table: "event_sequence_complete_reasons" using primary key columns */
  eventSequenceCompleteReasonsByPk?: Maybe<EventSequenceCompleteReasons>;
  /** fetch data from the table in a streaming manner: "event_sequence_complete_reasons" */
  eventSequenceCompleteReasonsStream: Array<EventSequenceCompleteReasons>;
  /** fetch data from the table: "event_skill_levels" */
  eventSkillLevels: Array<EventSkillLevels>;
  /** fetch aggregated fields from the table: "event_skill_levels" */
  eventSkillLevelsAggregate: EventSkillLevelsAggregate;
  /** fetch data from the table: "event_skill_levels" using primary key columns */
  eventSkillLevelsByPk?: Maybe<EventSkillLevels>;
  /** fetch data from the table in a streaming manner: "event_skill_levels" */
  eventSkillLevelsStream: Array<EventSkillLevels>;
  /** fetch data from the table: "event_sponsors" */
  eventSponsors: Array<EventSponsors>;
  /** fetch aggregated fields from the table: "event_sponsors" */
  eventSponsorsAggregate: EventSponsorsAggregate;
  /** fetch data from the table: "event_sponsors" using primary key columns */
  eventSponsorsByPk?: Maybe<EventSponsors>;
  /** fetch data from the table in a streaming manner: "event_sponsors" */
  eventSponsorsStream: Array<EventSponsors>;
  /** fetch data from the table: "event_statuses" */
  eventStatuses: Array<EventStatuses>;
  /** fetch aggregated fields from the table: "event_statuses" */
  eventStatusesAggregate: EventStatusesAggregate;
  /** fetch data from the table: "event_statuses" using primary key columns */
  eventStatusesByPk?: Maybe<EventStatuses>;
  /** fetch data from the table in a streaming manner: "event_statuses" */
  eventStatusesStream: Array<EventStatuses>;
  /** fetch data from the table: "event_team_member_statuses" */
  eventTeamMemberStatuses: Array<EventTeamMemberStatuses>;
  /** fetch aggregated fields from the table: "event_team_member_statuses" */
  eventTeamMemberStatusesAggregate: EventTeamMemberStatusesAggregate;
  /** fetch data from the table: "event_team_member_statuses" using primary key columns */
  eventTeamMemberStatusesByPk?: Maybe<EventTeamMemberStatuses>;
  /** fetch data from the table in a streaming manner: "event_team_member_statuses" */
  eventTeamMemberStatusesStream: Array<EventTeamMemberStatuses>;
  /** fetch data from the table: "event_team_members" */
  eventTeamMembers: Array<EventTeamMembers>;
  /** fetch aggregated fields from the table: "event_team_members" */
  eventTeamMembersAggregate: EventTeamMembersAggregate;
  /** fetch data from the table: "event_team_members" using primary key columns */
  eventTeamMembersByPk?: Maybe<EventTeamMembers>;
  /** fetch data from the table in a streaming manner: "event_team_members" */
  eventTeamMembersStream: Array<EventTeamMembers>;
  /** fetch data from the table: "event_team_statuses" */
  eventTeamStatuses: Array<EventTeamStatuses>;
  /** fetch aggregated fields from the table: "event_team_statuses" */
  eventTeamStatusesAggregate: EventTeamStatusesAggregate;
  /** fetch data from the table: "event_team_statuses" using primary key columns */
  eventTeamStatusesByPk?: Maybe<EventTeamStatuses>;
  /** fetch data from the table in a streaming manner: "event_team_statuses" */
  eventTeamStatusesStream: Array<EventTeamStatuses>;
  /** fetch data from the table: "event_teams" */
  eventTeams: Array<EventTeams>;
  /** fetch aggregated fields from the table: "event_teams" */
  eventTeamsAggregate: EventTeamsAggregate;
  /** fetch data from the table: "event_teams" using primary key columns */
  eventTeamsByPk?: Maybe<EventTeams>;
  /** fetch data from the table in a streaming manner: "event_teams" */
  eventTeamsStream: Array<EventTeams>;
  /** fetch data from the table: "event_transaction_item_types" */
  eventTransactionItemTypes: Array<EventTransactionItemTypes>;
  /** fetch aggregated fields from the table: "event_transaction_item_types" */
  eventTransactionItemTypesAggregate: EventTransactionItemTypesAggregate;
  /** fetch data from the table: "event_transaction_item_types" using primary key columns */
  eventTransactionItemTypesByPk?: Maybe<EventTransactionItemTypes>;
  /** fetch data from the table in a streaming manner: "event_transaction_item_types" */
  eventTransactionItemTypesStream: Array<EventTransactionItemTypes>;
  /** fetch data from the table: "event_transaction_items" */
  eventTransactionItems: Array<EventTransactionItems>;
  /** fetch aggregated fields from the table: "event_transaction_items" */
  eventTransactionItemsAggregate: EventTransactionItemsAggregate;
  /** fetch data from the table: "event_transaction_items" using primary key columns */
  eventTransactionItemsByPk?: Maybe<EventTransactionItems>;
  /** fetch data from the table in a streaming manner: "event_transaction_items" */
  eventTransactionItemsStream: Array<EventTransactionItems>;
  /** fetch data from the table: "event_transactions" */
  eventTransactions: Array<EventTransactions>;
  /** fetch aggregated fields from the table: "event_transactions" */
  eventTransactionsAggregate: EventTransactionsAggregate;
  /** fetch data from the table: "event_transactions" using primary key columns */
  eventTransactionsByPk?: Maybe<EventTransactions>;
  /** fetch data from the table in a streaming manner: "event_transactions" */
  eventTransactionsStream: Array<EventTransactions>;
  /** fetch data from the table: "event_types" */
  eventTypes: Array<EventTypes>;
  /** fetch aggregated fields from the table: "event_types" */
  eventTypesAggregate: EventTypesAggregate;
  /** fetch data from the table: "event_types" using primary key columns */
  eventTypesByPk?: Maybe<EventTypes>;
  /** fetch data from the table in a streaming manner: "event_types" */
  eventTypesStream: Array<EventTypes>;
  /** An array relationship */
  events: Array<Events>;
  /** An aggregate relationship */
  eventsAggregate: EventsAggregate;
  /** fetch data from the table: "events" using primary key columns */
  eventsByPk?: Maybe<Events>;
  /** fetch data from the table in a streaming manner: "events" */
  eventsStream: Array<Events>;
  /** fetch data from the table: "feedback_sentiment" */
  feedbackSentiment: Array<FeedbackSentiment>;
  /** fetch aggregated fields from the table: "feedback_sentiment" */
  feedbackSentimentAggregate: FeedbackSentimentAggregate;
  /** fetch data from the table: "feedback_sentiment" using primary key columns */
  feedbackSentimentByPk?: Maybe<FeedbackSentiment>;
  /** fetch data from the table in a streaming manner: "feedback_sentiment" */
  feedbackSentimentStream: Array<FeedbackSentiment>;
  /** fetch data from the table: "file_category" */
  fileCategory: Array<FileCategory>;
  /** fetch aggregated fields from the table: "file_category" */
  fileCategoryAggregate: FileCategoryAggregate;
  /** fetch data from the table: "file_category" using primary key columns */
  fileCategoryByPk?: Maybe<FileCategory>;
  /** fetch data from the table in a streaming manner: "file_category" */
  fileCategoryStream: Array<FileCategory>;
  /** fetch data from the table: "file_format" */
  fileFormat: Array<FileFormat>;
  /** fetch aggregated fields from the table: "file_format" */
  fileFormatAggregate: FileFormatAggregate;
  /** fetch data from the table: "file_format" using primary key columns */
  fileFormatByPk?: Maybe<FileFormat>;
  /** fetch data from the table in a streaming manner: "file_format" */
  fileFormatStream: Array<FileFormat>;
  /** fetch data from the table: "follow_statuses" */
  followStatuses: Array<FollowStatuses>;
  /** fetch aggregated fields from the table: "follow_statuses" */
  followStatusesAggregate: FollowStatusesAggregate;
  /** fetch data from the table: "follow_statuses" using primary key columns */
  followStatusesByPk?: Maybe<FollowStatuses>;
  /** fetch data from the table in a streaming manner: "follow_statuses" */
  followStatusesStream: Array<FollowStatuses>;
  /** fetch data from the table: "game_net_statuses" */
  gameNetStatuses: Array<GameNetStatuses>;
  /** fetch aggregated fields from the table: "game_net_statuses" */
  gameNetStatusesAggregate: GameNetStatusesAggregate;
  /** fetch data from the table: "game_net_statuses" using primary key columns */
  gameNetStatusesByPk?: Maybe<GameNetStatuses>;
  /** fetch data from the table in a streaming manner: "game_net_statuses" */
  gameNetStatusesStream: Array<GameNetStatuses>;
  /** fetch data from the table: "gender" */
  gender: Array<Gender>;
  /** fetch aggregated fields from the table: "gender" */
  genderAggregate: GenderAggregate;
  /** fetch data from the table: "gender" using primary key columns */
  genderByPk?: Maybe<Gender>;
  /** fetch data from the table in a streaming manner: "gender" */
  genderStream: Array<Gender>;
  /** fetch data from the table: "group_comment_votes" */
  groupCommentVotes: Array<GroupCommentVotes>;
  /** fetch aggregated fields from the table: "group_comment_votes" */
  groupCommentVotesAggregate: GroupCommentVotesAggregate;
  /** fetch data from the table: "group_comment_votes" using primary key columns */
  groupCommentVotesByPk?: Maybe<GroupCommentVotes>;
  /** fetch data from the table in a streaming manner: "group_comment_votes" */
  groupCommentVotesStream: Array<GroupCommentVotes>;
  /** fetch data from the table: "group_members" */
  groupMembers: Array<GroupMembers>;
  /** fetch aggregated fields from the table: "group_members" */
  groupMembersAggregate: GroupMembersAggregate;
  /** fetch data from the table: "group_members" using primary key columns */
  groupMembersByPk?: Maybe<GroupMembers>;
  /** fetch data from the table in a streaming manner: "group_members" */
  groupMembersStream: Array<GroupMembers>;
  /** fetch data from the table: "group_thread_comment_files" */
  groupThreadCommentFiles: Array<GroupThreadCommentFiles>;
  /** fetch aggregated fields from the table: "group_thread_comment_files" */
  groupThreadCommentFilesAggregate: GroupThreadCommentFilesAggregate;
  /** fetch data from the table: "group_thread_comment_files" using primary key columns */
  groupThreadCommentFilesByPk?: Maybe<GroupThreadCommentFiles>;
  /** fetch data from the table in a streaming manner: "group_thread_comment_files" */
  groupThreadCommentFilesStream: Array<GroupThreadCommentFiles>;
  /** fetch data from the table: "group_thread_comments" */
  groupThreadComments: Array<GroupThreadComments>;
  /** fetch aggregated fields from the table: "group_thread_comments" */
  groupThreadCommentsAggregate: GroupThreadCommentsAggregate;
  /** fetch data from the table: "group_thread_comments" using primary key columns */
  groupThreadCommentsByPk?: Maybe<GroupThreadComments>;
  /** fetch data from the table in a streaming manner: "group_thread_comments" */
  groupThreadCommentsStream: Array<GroupThreadComments>;
  /** fetch data from the table: "group_threads" */
  groupThreads: Array<GroupThreads>;
  /** fetch aggregated fields from the table: "group_threads" */
  groupThreadsAggregate: GroupThreadsAggregate;
  /** fetch data from the table: "group_threads" using primary key columns */
  groupThreadsByPk?: Maybe<GroupThreads>;
  /** fetch data from the table in a streaming manner: "group_threads" */
  groupThreadsStream: Array<GroupThreads>;
  /** fetch data from the table: "group_types" */
  groupTypes: Array<GroupTypes>;
  /** fetch aggregated fields from the table: "group_types" */
  groupTypesAggregate: GroupTypesAggregate;
  /** fetch data from the table: "group_types" using primary key columns */
  groupTypesByPk?: Maybe<GroupTypes>;
  /** fetch data from the table in a streaming manner: "group_types" */
  groupTypesStream: Array<GroupTypes>;
  /** fetch data from the table: "group_venues" */
  groupVenues: Array<GroupVenues>;
  /** fetch aggregated fields from the table: "group_venues" */
  groupVenuesAggregate: GroupVenuesAggregate;
  /** fetch data from the table: "group_venues" using primary key columns */
  groupVenuesByPk?: Maybe<GroupVenues>;
  /** fetch data from the table in a streaming manner: "group_venues" */
  groupVenuesStream: Array<GroupVenues>;
  /** An array relationship */
  groups: Array<Groups>;
  /** An aggregate relationship */
  groupsAggregate: GroupsAggregate;
  /** fetch data from the table: "groups" using primary key columns */
  groupsByPk?: Maybe<Groups>;
  /** An array relationship */
  groupsPlaySessions: Array<GroupsPlaySessions>;
  /** An aggregate relationship */
  groupsPlaySessionsAggregate: GroupsPlaySessionsAggregate;
  /** fetch data from the table: "groups_play_sessions" using primary key columns */
  groupsPlaySessionsByPk?: Maybe<GroupsPlaySessions>;
  /** fetch data from the table in a streaming manner: "groups_play_sessions" */
  groupsPlaySessionsStream: Array<GroupsPlaySessions>;
  /** fetch data from the table in a streaming manner: "groups" */
  groupsStream: Array<Groups>;
  /** fetch data from the table: "identity_verification_providers" */
  identityVerificationProviders: Array<IdentityVerificationProviders>;
  /** fetch aggregated fields from the table: "identity_verification_providers" */
  identityVerificationProvidersAggregate: IdentityVerificationProvidersAggregate;
  /** fetch data from the table: "identity_verification_providers" using primary key columns */
  identityVerificationProvidersByPk?: Maybe<IdentityVerificationProviders>;
  /** fetch data from the table in a streaming manner: "identity_verification_providers" */
  identityVerificationProvidersStream: Array<IdentityVerificationProviders>;
  /** fetch data from the table: "identity_verification_statuses" */
  identityVerificationStatuses: Array<IdentityVerificationStatuses>;
  /** fetch aggregated fields from the table: "identity_verification_statuses" */
  identityVerificationStatusesAggregate: IdentityVerificationStatusesAggregate;
  /** fetch data from the table: "identity_verification_statuses" using primary key columns */
  identityVerificationStatusesByPk?: Maybe<IdentityVerificationStatuses>;
  /** fetch data from the table in a streaming manner: "identity_verification_statuses" */
  identityVerificationStatusesStream: Array<IdentityVerificationStatuses>;
  /** An array relationship */
  invoices: Array<Invoices>;
  /** An aggregate relationship */
  invoicesAggregate: InvoicesAggregate;
  /** fetch data from the table: "invoices" using primary key columns */
  invoicesByPk?: Maybe<Invoices>;
  /** fetch data from the table in a streaming manner: "invoices" */
  invoicesStream: Array<Invoices>;
  /** fetch data from the table: "learning_program_enrollment_schedule_media_watched" */
  learningProgramEnrollmentScheduleMediaWatched: Array<LearningProgramEnrollmentScheduleMediaWatched>;
  /** fetch aggregated fields from the table: "learning_program_enrollment_schedule_media_watched" */
  learningProgramEnrollmentScheduleMediaWatchedAggregate: LearningProgramEnrollmentScheduleMediaWatchedAggregate;
  /** fetch data from the table: "learning_program_enrollment_schedule_media_watched" using primary key columns */
  learningProgramEnrollmentScheduleMediaWatchedByPk?: Maybe<LearningProgramEnrollmentScheduleMediaWatched>;
  /** fetch data from the table in a streaming manner: "learning_program_enrollment_schedule_media_watched" */
  learningProgramEnrollmentScheduleMediaWatchedStream: Array<LearningProgramEnrollmentScheduleMediaWatched>;
  /** fetch data from the table: "learning_program_enrollment_schedule_progress" */
  learningProgramEnrollmentScheduleProgress: Array<LearningProgramEnrollmentScheduleProgress>;
  /** fetch aggregated fields from the table: "learning_program_enrollment_schedule_progress" */
  learningProgramEnrollmentScheduleProgressAggregate: LearningProgramEnrollmentScheduleProgressAggregate;
  /** fetch data from the table: "learning_program_enrollment_schedule_progress" using primary key columns */
  learningProgramEnrollmentScheduleProgressByPk?: Maybe<LearningProgramEnrollmentScheduleProgress>;
  /** fetch data from the table in a streaming manner: "learning_program_enrollment_schedule_progress" */
  learningProgramEnrollmentScheduleProgressStream: Array<LearningProgramEnrollmentScheduleProgress>;
  /** fetch data from the table: "learning_program_enrollments" */
  learningProgramEnrollments: Array<LearningProgramEnrollments>;
  /** fetch aggregated fields from the table: "learning_program_enrollments" */
  learningProgramEnrollmentsAggregate: LearningProgramEnrollmentsAggregate;
  /** fetch data from the table: "learning_program_enrollments" using primary key columns */
  learningProgramEnrollmentsByPk?: Maybe<LearningProgramEnrollments>;
  /** fetch data from the table in a streaming manner: "learning_program_enrollments" */
  learningProgramEnrollmentsStream: Array<LearningProgramEnrollments>;
  /** fetch data from the table: "learning_program_media" */
  learningProgramMedia: Array<LearningProgramMedia>;
  /** fetch aggregated fields from the table: "learning_program_media" */
  learningProgramMediaAggregate: LearningProgramMediaAggregate;
  /** fetch data from the table: "learning_program_media" using primary key columns */
  learningProgramMediaByPk?: Maybe<LearningProgramMedia>;
  /** fetch data from the table: "learning_program_media_categories" */
  learningProgramMediaCategories: Array<LearningProgramMediaCategories>;
  /** fetch aggregated fields from the table: "learning_program_media_categories" */
  learningProgramMediaCategoriesAggregate: LearningProgramMediaCategoriesAggregate;
  /** fetch data from the table: "learning_program_media_categories" using primary key columns */
  learningProgramMediaCategoriesByPk?: Maybe<LearningProgramMediaCategories>;
  /** fetch data from the table in a streaming manner: "learning_program_media_categories" */
  learningProgramMediaCategoriesStream: Array<LearningProgramMediaCategories>;
  /** fetch data from the table in a streaming manner: "learning_program_media" */
  learningProgramMediaStream: Array<LearningProgramMedia>;
  /** fetch data from the table: "learning_program_schedule_media" */
  learningProgramScheduleMedia: Array<LearningProgramScheduleMedia>;
  /** fetch aggregated fields from the table: "learning_program_schedule_media" */
  learningProgramScheduleMediaAggregate: LearningProgramScheduleMediaAggregate;
  /** fetch data from the table: "learning_program_schedule_media" using primary key columns */
  learningProgramScheduleMediaByPk?: Maybe<LearningProgramScheduleMedia>;
  /** fetch data from the table in a streaming manner: "learning_program_schedule_media" */
  learningProgramScheduleMediaStream: Array<LearningProgramScheduleMedia>;
  /** fetch data from the table: "learning_program_schedule_units" */
  learningProgramScheduleUnits: Array<LearningProgramScheduleUnits>;
  /** fetch aggregated fields from the table: "learning_program_schedule_units" */
  learningProgramScheduleUnitsAggregate: LearningProgramScheduleUnitsAggregate;
  /** fetch data from the table: "learning_program_schedule_units" using primary key columns */
  learningProgramScheduleUnitsByPk?: Maybe<LearningProgramScheduleUnits>;
  /** fetch data from the table in a streaming manner: "learning_program_schedule_units" */
  learningProgramScheduleUnitsStream: Array<LearningProgramScheduleUnits>;
  /** fetch data from the table: "learning_program_schedule_video_submissions" */
  learningProgramScheduleVideoSubmissions: Array<LearningProgramScheduleVideoSubmissions>;
  /** fetch aggregated fields from the table: "learning_program_schedule_video_submissions" */
  learningProgramScheduleVideoSubmissionsAggregate: LearningProgramScheduleVideoSubmissionsAggregate;
  /** fetch data from the table: "learning_program_schedule_video_submissions" using primary key columns */
  learningProgramScheduleVideoSubmissionsByPk?: Maybe<LearningProgramScheduleVideoSubmissions>;
  /** fetch data from the table in a streaming manner: "learning_program_schedule_video_submissions" */
  learningProgramScheduleVideoSubmissionsStream: Array<LearningProgramScheduleVideoSubmissions>;
  /** fetch data from the table: "learning_program_schedules" */
  learningProgramSchedules: Array<LearningProgramSchedules>;
  /** fetch aggregated fields from the table: "learning_program_schedules" */
  learningProgramSchedulesAggregate: LearningProgramSchedulesAggregate;
  /** fetch data from the table: "learning_program_schedules" using primary key columns */
  learningProgramSchedulesByPk?: Maybe<LearningProgramSchedules>;
  /** fetch data from the table in a streaming manner: "learning_program_schedules" */
  learningProgramSchedulesStream: Array<LearningProgramSchedules>;
  /** fetch data from the table: "learning_program_skill_level_values" */
  learningProgramSkillLevelValues: Array<LearningProgramSkillLevelValues>;
  /** fetch aggregated fields from the table: "learning_program_skill_level_values" */
  learningProgramSkillLevelValuesAggregate: LearningProgramSkillLevelValuesAggregate;
  /** fetch data from the table: "learning_program_skill_level_values" using primary key columns */
  learningProgramSkillLevelValuesByPk?: Maybe<LearningProgramSkillLevelValues>;
  /** fetch data from the table in a streaming manner: "learning_program_skill_level_values" */
  learningProgramSkillLevelValuesStream: Array<LearningProgramSkillLevelValues>;
  /** fetch data from the table: "learning_program_skills" */
  learningProgramSkills: Array<LearningProgramSkills>;
  /** fetch aggregated fields from the table: "learning_program_skills" */
  learningProgramSkillsAggregate: LearningProgramSkillsAggregate;
  /** fetch data from the table: "learning_program_skills" using primary key columns */
  learningProgramSkillsByPk?: Maybe<LearningProgramSkills>;
  /** fetch data from the table in a streaming manner: "learning_program_skills" */
  learningProgramSkillsStream: Array<LearningProgramSkills>;
  /** fetch data from the table: "learning_programs" */
  learningPrograms: Array<LearningPrograms>;
  /** fetch aggregated fields from the table: "learning_programs" */
  learningProgramsAggregate: LearningProgramsAggregate;
  /** fetch data from the table: "learning_programs" using primary key columns */
  learningProgramsByPk?: Maybe<LearningPrograms>;
  /** fetch data from the table in a streaming manner: "learning_programs" */
  learningProgramsStream: Array<LearningPrograms>;
  /** fetch data from the table: "lesson_age_groups" */
  lessonAgeGroups: Array<LessonAgeGroups>;
  /** fetch aggregated fields from the table: "lesson_age_groups" */
  lessonAgeGroupsAggregate: LessonAgeGroupsAggregate;
  /** fetch data from the table: "lesson_age_groups" using primary key columns */
  lessonAgeGroupsByPk?: Maybe<LessonAgeGroups>;
  /** fetch data from the table in a streaming manner: "lesson_age_groups" */
  lessonAgeGroupsStream: Array<LessonAgeGroups>;
  /** fetch data from the table: "lesson_collections" */
  lessonCollections: Array<LessonCollections>;
  /** fetch aggregated fields from the table: "lesson_collections" */
  lessonCollectionsAggregate: LessonCollectionsAggregate;
  /** fetch data from the table: "lesson_collections" using primary key columns */
  lessonCollectionsByPk?: Maybe<LessonCollections>;
  /** fetch data from the table in a streaming manner: "lesson_collections" */
  lessonCollectionsStream: Array<LessonCollections>;
  /** fetch data from the table: "lesson_equipment" */
  lessonEquipment: Array<LessonEquipment>;
  /** fetch aggregated fields from the table: "lesson_equipment" */
  lessonEquipmentAggregate: LessonEquipmentAggregate;
  /** fetch data from the table: "lesson_equipment" using primary key columns */
  lessonEquipmentByPk?: Maybe<LessonEquipment>;
  /** fetch data from the table: "lesson_equipment_options" */
  lessonEquipmentOptions: Array<LessonEquipmentOptions>;
  /** fetch aggregated fields from the table: "lesson_equipment_options" */
  lessonEquipmentOptionsAggregate: LessonEquipmentOptionsAggregate;
  /** fetch data from the table: "lesson_equipment_options" using primary key columns */
  lessonEquipmentOptionsByPk?: Maybe<LessonEquipmentOptions>;
  /** fetch data from the table in a streaming manner: "lesson_equipment_options" */
  lessonEquipmentOptionsStream: Array<LessonEquipmentOptions>;
  /** fetch data from the table in a streaming manner: "lesson_equipment" */
  lessonEquipmentStream: Array<LessonEquipment>;
  /** fetch data from the table: "lesson_order_items" */
  lessonOrderItems: Array<LessonOrderItems>;
  /** fetch aggregated fields from the table: "lesson_order_items" */
  lessonOrderItemsAggregate: LessonOrderItemsAggregate;
  /** fetch data from the table: "lesson_order_items" using primary key columns */
  lessonOrderItemsByPk?: Maybe<LessonOrderItems>;
  /** fetch data from the table in a streaming manner: "lesson_order_items" */
  lessonOrderItemsStream: Array<LessonOrderItems>;
  /** fetch data from the table: "lesson_orders" */
  lessonOrders: Array<LessonOrders>;
  /** fetch aggregated fields from the table: "lesson_orders" */
  lessonOrdersAggregate: LessonOrdersAggregate;
  /** fetch data from the table: "lesson_orders" using primary key columns */
  lessonOrdersByPk?: Maybe<LessonOrders>;
  /** fetch data from the table in a streaming manner: "lesson_orders" */
  lessonOrdersStream: Array<LessonOrders>;
  /** fetch data from the table: "lesson_participant_statuses" */
  lessonParticipantStatuses: Array<LessonParticipantStatuses>;
  /** fetch aggregated fields from the table: "lesson_participant_statuses" */
  lessonParticipantStatusesAggregate: LessonParticipantStatusesAggregate;
  /** fetch data from the table: "lesson_participant_statuses" using primary key columns */
  lessonParticipantStatusesByPk?: Maybe<LessonParticipantStatuses>;
  /** fetch data from the table in a streaming manner: "lesson_participant_statuses" */
  lessonParticipantStatusesStream: Array<LessonParticipantStatuses>;
  /** fetch data from the table: "lesson_participants" */
  lessonParticipants: Array<LessonParticipants>;
  /** fetch aggregated fields from the table: "lesson_participants" */
  lessonParticipantsAggregate: LessonParticipantsAggregate;
  /** fetch data from the table: "lesson_participants" using primary key columns */
  lessonParticipantsByPk?: Maybe<LessonParticipants>;
  /** fetch data from the table in a streaming manner: "lesson_participants" */
  lessonParticipantsStream: Array<LessonParticipants>;
  /** fetch data from the table: "lesson_player_skill_assessment_categories" */
  lessonPlayerSkillAssessmentCategories: Array<LessonPlayerSkillAssessmentCategories>;
  /** fetch aggregated fields from the table: "lesson_player_skill_assessment_categories" */
  lessonPlayerSkillAssessmentCategoriesAggregate: LessonPlayerSkillAssessmentCategoriesAggregate;
  /** fetch data from the table: "lesson_player_skill_assessment_categories" using primary key columns */
  lessonPlayerSkillAssessmentCategoriesByPk?: Maybe<LessonPlayerSkillAssessmentCategories>;
  /** fetch data from the table in a streaming manner: "lesson_player_skill_assessment_categories" */
  lessonPlayerSkillAssessmentCategoriesStream: Array<LessonPlayerSkillAssessmentCategories>;
  /** An array relationship */
  lessonPlayerSkillAssessments: Array<LessonPlayerSkillAssessments>;
  /** An aggregate relationship */
  lessonPlayerSkillAssessmentsAggregate: LessonPlayerSkillAssessmentsAggregate;
  /** fetch data from the table: "lesson_player_skill_assessments" using primary key columns */
  lessonPlayerSkillAssessmentsByPk?: Maybe<LessonPlayerSkillAssessments>;
  /** An array relationship */
  lessonPlayerSkillAssessmentsSkills: Array<LessonPlayerSkillAssessmentsSkills>;
  /** An aggregate relationship */
  lessonPlayerSkillAssessmentsSkillsAggregate: LessonPlayerSkillAssessmentsSkillsAggregate;
  /** fetch data from the table: "lesson_player_skill_assessments_skills" using primary key columns */
  lessonPlayerSkillAssessmentsSkillsByPk?: Maybe<LessonPlayerSkillAssessmentsSkills>;
  /** fetch data from the table in a streaming manner: "lesson_player_skill_assessments_skills" */
  lessonPlayerSkillAssessmentsSkillsStream: Array<LessonPlayerSkillAssessmentsSkills>;
  /** fetch data from the table in a streaming manner: "lesson_player_skill_assessments" */
  lessonPlayerSkillAssessmentsStream: Array<LessonPlayerSkillAssessments>;
  /** fetch data from the table: "lesson_privacy" */
  lessonPrivacy: Array<LessonPrivacy>;
  /** fetch aggregated fields from the table: "lesson_privacy" */
  lessonPrivacyAggregate: LessonPrivacyAggregate;
  /** fetch data from the table: "lesson_privacy" using primary key columns */
  lessonPrivacyByPk?: Maybe<LessonPrivacy>;
  /** fetch data from the table in a streaming manner: "lesson_privacy" */
  lessonPrivacyStream: Array<LessonPrivacy>;
  /** fetch data from the table: "lesson_reflection_comment_types" */
  lessonReflectionCommentTypes: Array<LessonReflectionCommentTypes>;
  /** fetch aggregated fields from the table: "lesson_reflection_comment_types" */
  lessonReflectionCommentTypesAggregate: LessonReflectionCommentTypesAggregate;
  /** fetch data from the table: "lesson_reflection_comment_types" using primary key columns */
  lessonReflectionCommentTypesByPk?: Maybe<LessonReflectionCommentTypes>;
  /** fetch data from the table in a streaming manner: "lesson_reflection_comment_types" */
  lessonReflectionCommentTypesStream: Array<LessonReflectionCommentTypes>;
  /** An array relationship */
  lessonReflectionComments: Array<LessonReflectionComments>;
  /** An aggregate relationship */
  lessonReflectionCommentsAggregate: LessonReflectionCommentsAggregate;
  /** fetch data from the table: "lesson_reflection_comments" using primary key columns */
  lessonReflectionCommentsByPk?: Maybe<LessonReflectionComments>;
  /** fetch data from the table in a streaming manner: "lesson_reflection_comments" */
  lessonReflectionCommentsStream: Array<LessonReflectionComments>;
  /** An array relationship */
  lessonReflectionFiles: Array<LessonReflectionFiles>;
  /** An aggregate relationship */
  lessonReflectionFilesAggregate: LessonReflectionFilesAggregate;
  /** fetch data from the table: "lesson_reflection_files" using primary key columns */
  lessonReflectionFilesByPk?: Maybe<LessonReflectionFiles>;
  /** fetch data from the table in a streaming manner: "lesson_reflection_files" */
  lessonReflectionFilesStream: Array<LessonReflectionFiles>;
  /** An array relationship */
  lessonReflections: Array<LessonReflections>;
  /** An aggregate relationship */
  lessonReflectionsAggregate: LessonReflectionsAggregate;
  /** fetch data from the table: "lesson_reflections" using primary key columns */
  lessonReflectionsByPk?: Maybe<LessonReflections>;
  /** fetch data from the table in a streaming manner: "lesson_reflections" */
  lessonReflectionsStream: Array<LessonReflections>;
  /** fetch data from the table: "lesson_skill_categories" */
  lessonSkillCategories: Array<LessonSkillCategories>;
  /** fetch aggregated fields from the table: "lesson_skill_categories" */
  lessonSkillCategoriesAggregate: LessonSkillCategoriesAggregate;
  /** fetch data from the table: "lesson_skill_categories" using primary key columns */
  lessonSkillCategoriesByPk?: Maybe<LessonSkillCategories>;
  /** fetch data from the table in a streaming manner: "lesson_skill_categories" */
  lessonSkillCategoriesStream: Array<LessonSkillCategories>;
  /** fetch data from the table: "lesson_skill_display_names" */
  lessonSkillDisplayNames: Array<LessonSkillDisplayNames>;
  /** fetch aggregated fields from the table: "lesson_skill_display_names" */
  lessonSkillDisplayNamesAggregate: LessonSkillDisplayNamesAggregate;
  /** fetch data from the table: "lesson_skill_display_names" using primary key columns */
  lessonSkillDisplayNamesByPk?: Maybe<LessonSkillDisplayNames>;
  /** fetch data from the table in a streaming manner: "lesson_skill_display_names" */
  lessonSkillDisplayNamesStream: Array<LessonSkillDisplayNames>;
  /** fetch data from the table: "lesson_skill_levels" */
  lessonSkillLevels: Array<LessonSkillLevels>;
  /** fetch aggregated fields from the table: "lesson_skill_levels" */
  lessonSkillLevelsAggregate: LessonSkillLevelsAggregate;
  /** fetch data from the table: "lesson_skill_levels" using primary key columns */
  lessonSkillLevelsByPk?: Maybe<LessonSkillLevels>;
  /** fetch data from the table in a streaming manner: "lesson_skill_levels" */
  lessonSkillLevelsStream: Array<LessonSkillLevels>;
  /** fetch data from the table: "lesson_skill_mappings" */
  lessonSkillMappings: Array<LessonSkillMappings>;
  /** fetch aggregated fields from the table: "lesson_skill_mappings" */
  lessonSkillMappingsAggregate: LessonSkillMappingsAggregate;
  /** fetch data from the table: "lesson_skill_mappings" using primary key columns */
  lessonSkillMappingsByPk?: Maybe<LessonSkillMappings>;
  /** fetch data from the table in a streaming manner: "lesson_skill_mappings" */
  lessonSkillMappingsStream: Array<LessonSkillMappings>;
  /** fetch data from the table: "lesson_skills" */
  lessonSkills: Array<LessonSkills>;
  /** fetch aggregated fields from the table: "lesson_skills" */
  lessonSkillsAggregate: LessonSkillsAggregate;
  /** fetch data from the table: "lesson_skills" using primary key columns */
  lessonSkillsByPk?: Maybe<LessonSkills>;
  /** fetch data from the table in a streaming manner: "lesson_skills" */
  lessonSkillsStream: Array<LessonSkills>;
  /** fetch data from the table: "lesson_statuses" */
  lessonStatuses: Array<LessonStatuses>;
  /** fetch aggregated fields from the table: "lesson_statuses" */
  lessonStatusesAggregate: LessonStatusesAggregate;
  /** fetch data from the table: "lesson_statuses" using primary key columns */
  lessonStatusesByPk?: Maybe<LessonStatuses>;
  /** fetch data from the table in a streaming manner: "lesson_statuses" */
  lessonStatusesStream: Array<LessonStatuses>;
  /** fetch data from the table: "lesson_template_skill_levels" */
  lessonTemplateSkillLevels: Array<LessonTemplateSkillLevels>;
  /** fetch aggregated fields from the table: "lesson_template_skill_levels" */
  lessonTemplateSkillLevelsAggregate: LessonTemplateSkillLevelsAggregate;
  /** fetch data from the table: "lesson_template_skill_levels" using primary key columns */
  lessonTemplateSkillLevelsByPk?: Maybe<LessonTemplateSkillLevels>;
  /** fetch data from the table in a streaming manner: "lesson_template_skill_levels" */
  lessonTemplateSkillLevelsStream: Array<LessonTemplateSkillLevels>;
  /** An array relationship */
  lessonTemplates: Array<LessonTemplates>;
  /** An aggregate relationship */
  lessonTemplatesAggregate: LessonTemplatesAggregate;
  /** fetch data from the table: "lesson_templates" using primary key columns */
  lessonTemplatesByPk?: Maybe<LessonTemplates>;
  /** fetch data from the table in a streaming manner: "lesson_templates" */
  lessonTemplatesStream: Array<LessonTemplates>;
  /** fetch data from the table: "lesson_times" */
  lessonTimes: Array<LessonTimes>;
  /** fetch aggregated fields from the table: "lesson_times" */
  lessonTimesAggregate: LessonTimesAggregate;
  /** fetch data from the table: "lesson_times" using primary key columns */
  lessonTimesByPk?: Maybe<LessonTimes>;
  /** fetch data from the table in a streaming manner: "lesson_times" */
  lessonTimesStream: Array<LessonTimes>;
  /** fetch data from the table: "lesson_types" */
  lessonTypes: Array<LessonTypes>;
  /** fetch aggregated fields from the table: "lesson_types" */
  lessonTypesAggregate: LessonTypesAggregate;
  /** fetch data from the table: "lesson_types" using primary key columns */
  lessonTypesByPk?: Maybe<LessonTypes>;
  /** fetch data from the table in a streaming manner: "lesson_types" */
  lessonTypesStream: Array<LessonTypes>;
  /** fetch data from the table: "lesson_waitlist_statuses" */
  lessonWaitlistStatuses: Array<LessonWaitlistStatuses>;
  /** fetch aggregated fields from the table: "lesson_waitlist_statuses" */
  lessonWaitlistStatusesAggregate: LessonWaitlistStatusesAggregate;
  /** fetch data from the table: "lesson_waitlist_statuses" using primary key columns */
  lessonWaitlistStatusesByPk?: Maybe<LessonWaitlistStatuses>;
  /** fetch data from the table in a streaming manner: "lesson_waitlist_statuses" */
  lessonWaitlistStatusesStream: Array<LessonWaitlistStatuses>;
  /** fetch data from the table: "lesson_waitlists" */
  lessonWaitlists: Array<LessonWaitlists>;
  /** fetch aggregated fields from the table: "lesson_waitlists" */
  lessonWaitlistsAggregate: LessonWaitlistsAggregate;
  /** fetch data from the table: "lesson_waitlists" using primary key columns */
  lessonWaitlistsByPk?: Maybe<LessonWaitlists>;
  /** fetch data from the table in a streaming manner: "lesson_waitlists" */
  lessonWaitlistsStream: Array<LessonWaitlists>;
  /** An array relationship */
  lessons: Array<Lessons>;
  /** An aggregate relationship */
  lessonsAggregate: LessonsAggregate;
  /** fetch data from the table: "lessons" using primary key columns */
  lessonsByPk?: Maybe<Lessons>;
  /** fetch data from the table in a streaming manner: "lessons" */
  lessonsStream: Array<Lessons>;
  /** fetch data from the table: "match_selection_criteria" */
  matchSelectionCriteria: Array<MatchSelectionCriteria>;
  /** fetch aggregated fields from the table: "match_selection_criteria" */
  matchSelectionCriteriaAggregate: MatchSelectionCriteriaAggregate;
  /** fetch data from the table: "match_selection_criteria" using primary key columns */
  matchSelectionCriteriaByPk?: Maybe<MatchSelectionCriteria>;
  /** fetch data from the table in a streaming manner: "match_selection_criteria" */
  matchSelectionCriteriaStream: Array<MatchSelectionCriteria>;
  /** An array relationship */
  messages: Array<Messages>;
  /** An aggregate relationship */
  messagesAggregate: MessagesAggregate;
  /** fetch data from the table: "messages" using primary key columns */
  messagesByPk?: Maybe<Messages>;
  /** fetch data from the table in a streaming manner: "messages" */
  messagesStream: Array<Messages>;
  /** fetch data from the table: "neighborhoods" */
  neighborhoods: Array<Neighborhoods>;
  /** fetch aggregated fields from the table: "neighborhoods" */
  neighborhoodsAggregate: NeighborhoodsAggregate;
  /** fetch data from the table: "neighborhoods" using primary key columns */
  neighborhoodsByPk?: Maybe<Neighborhoods>;
  /** fetch data from the table in a streaming manner: "neighborhoods" */
  neighborhoodsStream: Array<Neighborhoods>;
  /** fetch data from the table: "notification_action_types" */
  notificationActionTypes: Array<NotificationActionTypes>;
  /** fetch aggregated fields from the table: "notification_action_types" */
  notificationActionTypesAggregate: NotificationActionTypesAggregate;
  /** fetch data from the table: "notification_action_types" using primary key columns */
  notificationActionTypesByPk?: Maybe<NotificationActionTypes>;
  /** fetch data from the table in a streaming manner: "notification_action_types" */
  notificationActionTypesStream: Array<NotificationActionTypes>;
  /** fetch data from the table: "notification_statuses" */
  notificationStatuses: Array<NotificationStatuses>;
  /** fetch aggregated fields from the table: "notification_statuses" */
  notificationStatusesAggregate: NotificationStatusesAggregate;
  /** fetch data from the table: "notification_statuses" using primary key columns */
  notificationStatusesByPk?: Maybe<NotificationStatuses>;
  /** fetch data from the table in a streaming manner: "notification_statuses" */
  notificationStatusesStream: Array<NotificationStatuses>;
  /** fetch data from the table: "order_statuses" */
  orderStatuses: Array<OrderStatuses>;
  /** fetch aggregated fields from the table: "order_statuses" */
  orderStatusesAggregate: OrderStatusesAggregate;
  /** fetch data from the table: "order_statuses" using primary key columns */
  orderStatusesByPk?: Maybe<OrderStatuses>;
  /** fetch data from the table in a streaming manner: "order_statuses" */
  orderStatusesStream: Array<OrderStatuses>;
  /** fetch data from the table: "padel_rating_scales" */
  padelRatingScales: Array<PadelRatingScales>;
  /** fetch aggregated fields from the table: "padel_rating_scales" */
  padelRatingScalesAggregate: PadelRatingScalesAggregate;
  /** fetch data from the table: "padel_rating_scales" using primary key columns */
  padelRatingScalesByPk?: Maybe<PadelRatingScales>;
  /** fetch data from the table in a streaming manner: "padel_rating_scales" */
  padelRatingScalesStream: Array<PadelRatingScales>;
  /** fetch data from the table: "participant_roles" */
  participantRoles: Array<ParticipantRoles>;
  /** fetch aggregated fields from the table: "participant_roles" */
  participantRolesAggregate: ParticipantRolesAggregate;
  /** fetch data from the table: "participant_roles" using primary key columns */
  participantRolesByPk?: Maybe<ParticipantRoles>;
  /** fetch data from the table in a streaming manner: "participant_roles" */
  participantRolesStream: Array<ParticipantRoles>;
  /** fetch data from the table: "partner_booking_attempt_events" */
  partnerBookingAttemptEvents: Array<PartnerBookingAttemptEvents>;
  /** fetch aggregated fields from the table: "partner_booking_attempt_events" */
  partnerBookingAttemptEventsAggregate: PartnerBookingAttemptEventsAggregate;
  /** fetch data from the table: "partner_booking_attempt_events" using primary key columns */
  partnerBookingAttemptEventsByPk?: Maybe<PartnerBookingAttemptEvents>;
  /** fetch data from the table in a streaming manner: "partner_booking_attempt_events" */
  partnerBookingAttemptEventsStream: Array<PartnerBookingAttemptEvents>;
  /** fetch data from the table: "partner_booking_attempt_statuses" */
  partnerBookingAttemptStatuses: Array<PartnerBookingAttemptStatuses>;
  /** fetch aggregated fields from the table: "partner_booking_attempt_statuses" */
  partnerBookingAttemptStatusesAggregate: PartnerBookingAttemptStatusesAggregate;
  /** fetch data from the table: "partner_booking_attempt_statuses" using primary key columns */
  partnerBookingAttemptStatusesByPk?: Maybe<PartnerBookingAttemptStatuses>;
  /** fetch data from the table in a streaming manner: "partner_booking_attempt_statuses" */
  partnerBookingAttemptStatusesStream: Array<PartnerBookingAttemptStatuses>;
  /** fetch data from the table: "partner_booking_attempts" */
  partnerBookingAttempts: Array<PartnerBookingAttempts>;
  /** fetch aggregated fields from the table: "partner_booking_attempts" */
  partnerBookingAttemptsAggregate: PartnerBookingAttemptsAggregate;
  /** fetch data from the table: "partner_booking_attempts" using primary key columns */
  partnerBookingAttemptsByPk?: Maybe<PartnerBookingAttempts>;
  /** fetch data from the table in a streaming manner: "partner_booking_attempts" */
  partnerBookingAttemptsStream: Array<PartnerBookingAttempts>;
  /** fetch data from the table: "partner_booking_engines" */
  partnerBookingEngines: Array<PartnerBookingEngines>;
  /** fetch aggregated fields from the table: "partner_booking_engines" */
  partnerBookingEnginesAggregate: PartnerBookingEnginesAggregate;
  /** fetch data from the table: "partner_booking_engines" using primary key columns */
  partnerBookingEnginesByPk?: Maybe<PartnerBookingEngines>;
  /** fetch data from the table in a streaming manner: "partner_booking_engines" */
  partnerBookingEnginesStream: Array<PartnerBookingEngines>;
  /** fetch data from the table: "partner_booking_event_sources" */
  partnerBookingEventSources: Array<PartnerBookingEventSources>;
  /** fetch aggregated fields from the table: "partner_booking_event_sources" */
  partnerBookingEventSourcesAggregate: PartnerBookingEventSourcesAggregate;
  /** fetch data from the table: "partner_booking_event_sources" using primary key columns */
  partnerBookingEventSourcesByPk?: Maybe<PartnerBookingEventSources>;
  /** fetch data from the table in a streaming manner: "partner_booking_event_sources" */
  partnerBookingEventSourcesStream: Array<PartnerBookingEventSources>;
  /** fetch data from the table: "partner_booking_holds" */
  partnerBookingHolds: Array<PartnerBookingHolds>;
  /** fetch aggregated fields from the table: "partner_booking_holds" */
  partnerBookingHoldsAggregate: PartnerBookingHoldsAggregate;
  /** fetch data from the table: "partner_booking_holds" using primary key columns */
  partnerBookingHoldsByPk?: Maybe<PartnerBookingHolds>;
  /** fetch data from the table in a streaming manner: "partner_booking_holds" */
  partnerBookingHoldsStream: Array<PartnerBookingHolds>;
  /** fetch data from the table: "partner_booking_order_statuses" */
  partnerBookingOrderStatuses: Array<PartnerBookingOrderStatuses>;
  /** fetch aggregated fields from the table: "partner_booking_order_statuses" */
  partnerBookingOrderStatusesAggregate: PartnerBookingOrderStatusesAggregate;
  /** fetch data from the table: "partner_booking_order_statuses" using primary key columns */
  partnerBookingOrderStatusesByPk?: Maybe<PartnerBookingOrderStatuses>;
  /** fetch data from the table in a streaming manner: "partner_booking_order_statuses" */
  partnerBookingOrderStatusesStream: Array<PartnerBookingOrderStatuses>;
  /** fetch data from the table: "partner_booking_orders" */
  partnerBookingOrders: Array<PartnerBookingOrders>;
  /** fetch aggregated fields from the table: "partner_booking_orders" */
  partnerBookingOrdersAggregate: PartnerBookingOrdersAggregate;
  /** fetch data from the table: "partner_booking_orders" using primary key columns */
  partnerBookingOrdersByPk?: Maybe<PartnerBookingOrders>;
  /** fetch data from the table in a streaming manner: "partner_booking_orders" */
  partnerBookingOrdersStream: Array<PartnerBookingOrders>;
  /** fetch data from the table: "partner_booking_verification_methods" */
  partnerBookingVerificationMethods: Array<PartnerBookingVerificationMethods>;
  /** fetch aggregated fields from the table: "partner_booking_verification_methods" */
  partnerBookingVerificationMethodsAggregate: PartnerBookingVerificationMethodsAggregate;
  /** fetch data from the table: "partner_booking_verification_methods" using primary key columns */
  partnerBookingVerificationMethodsByPk?: Maybe<PartnerBookingVerificationMethods>;
  /** fetch data from the table in a streaming manner: "partner_booking_verification_methods" */
  partnerBookingVerificationMethodsStream: Array<PartnerBookingVerificationMethods>;
  /** fetch data from the table: "payment_fulfillment_channels" */
  paymentFulfillmentChannels: Array<PaymentFulfillmentChannels>;
  /** fetch aggregated fields from the table: "payment_fulfillment_channels" */
  paymentFulfillmentChannelsAggregate: PaymentFulfillmentChannelsAggregate;
  /** fetch data from the table: "payment_fulfillment_channels" using primary key columns */
  paymentFulfillmentChannelsByPk?: Maybe<PaymentFulfillmentChannels>;
  /** fetch data from the table in a streaming manner: "payment_fulfillment_channels" */
  paymentFulfillmentChannelsStream: Array<PaymentFulfillmentChannels>;
  /** fetch data from the table: "payment_processors" */
  paymentProcessors: Array<PaymentProcessors>;
  /** fetch aggregated fields from the table: "payment_processors" */
  paymentProcessorsAggregate: PaymentProcessorsAggregate;
  /** fetch data from the table: "payment_processors" using primary key columns */
  paymentProcessorsByPk?: Maybe<PaymentProcessors>;
  /** fetch data from the table in a streaming manner: "payment_processors" */
  paymentProcessorsStream: Array<PaymentProcessors>;
  /** fetch data from the table: "payment_statuses" */
  paymentStatuses: Array<PaymentStatuses>;
  /** fetch aggregated fields from the table: "payment_statuses" */
  paymentStatusesAggregate: PaymentStatusesAggregate;
  /** fetch data from the table: "payment_statuses" using primary key columns */
  paymentStatusesByPk?: Maybe<PaymentStatuses>;
  /** fetch data from the table in a streaming manner: "payment_statuses" */
  paymentStatusesStream: Array<PaymentStatuses>;
  /** fetch data from the table: "pickleball_rating_scales" */
  pickleballRatingScales: Array<PickleballRatingScales>;
  /** fetch aggregated fields from the table: "pickleball_rating_scales" */
  pickleballRatingScalesAggregate: PickleballRatingScalesAggregate;
  /** fetch data from the table: "pickleball_rating_scales" using primary key columns */
  pickleballRatingScalesByPk?: Maybe<PickleballRatingScales>;
  /** fetch data from the table in a streaming manner: "pickleball_rating_scales" */
  pickleballRatingScalesStream: Array<PickleballRatingScales>;
  /** fetch data from the table: "platform_subscription_intervals" */
  platformSubscriptionIntervals: Array<PlatformSubscriptionIntervals>;
  /** fetch aggregated fields from the table: "platform_subscription_intervals" */
  platformSubscriptionIntervalsAggregate: PlatformSubscriptionIntervalsAggregate;
  /** fetch data from the table: "platform_subscription_intervals" using primary key columns */
  platformSubscriptionIntervalsByPk?: Maybe<PlatformSubscriptionIntervals>;
  /** fetch data from the table in a streaming manner: "platform_subscription_intervals" */
  platformSubscriptionIntervalsStream: Array<PlatformSubscriptionIntervals>;
  /** fetch data from the table: "platform_subscription_personas" */
  platformSubscriptionPersonas: Array<PlatformSubscriptionPersonas>;
  /** fetch aggregated fields from the table: "platform_subscription_personas" */
  platformSubscriptionPersonasAggregate: PlatformSubscriptionPersonasAggregate;
  /** fetch data from the table: "platform_subscription_personas" using primary key columns */
  platformSubscriptionPersonasByPk?: Maybe<PlatformSubscriptionPersonas>;
  /** fetch data from the table in a streaming manner: "platform_subscription_personas" */
  platformSubscriptionPersonasStream: Array<PlatformSubscriptionPersonas>;
  /** fetch data from the table: "platform_subscription_plan_prices" */
  platformSubscriptionPlanPrices: Array<PlatformSubscriptionPlanPrices>;
  /** fetch aggregated fields from the table: "platform_subscription_plan_prices" */
  platformSubscriptionPlanPricesAggregate: PlatformSubscriptionPlanPricesAggregate;
  /** fetch data from the table: "platform_subscription_plan_prices" using primary key columns */
  platformSubscriptionPlanPricesByPk?: Maybe<PlatformSubscriptionPlanPrices>;
  /** fetch data from the table in a streaming manner: "platform_subscription_plan_prices" */
  platformSubscriptionPlanPricesStream: Array<PlatformSubscriptionPlanPrices>;
  /** fetch data from the table: "platform_subscription_plans" */
  platformSubscriptionPlans: Array<PlatformSubscriptionPlans>;
  /** fetch aggregated fields from the table: "platform_subscription_plans" */
  platformSubscriptionPlansAggregate: PlatformSubscriptionPlansAggregate;
  /** fetch data from the table: "platform_subscription_plans" using primary key columns */
  platformSubscriptionPlansByPk?: Maybe<PlatformSubscriptionPlans>;
  /** fetch data from the table in a streaming manner: "platform_subscription_plans" */
  platformSubscriptionPlansStream: Array<PlatformSubscriptionPlans>;
  /** An array relationship */
  platformSubscriptions: Array<PlatformSubscriptions>;
  /** An aggregate relationship */
  platformSubscriptionsAggregate: PlatformSubscriptionsAggregate;
  /** fetch data from the table: "platform_subscriptions" using primary key columns */
  platformSubscriptionsByPk?: Maybe<PlatformSubscriptions>;
  /** fetch data from the table in a streaming manner: "platform_subscriptions" */
  platformSubscriptionsStream: Array<PlatformSubscriptions>;
  /** fetch data from the table: "play_request_neighborhoods" */
  playRequestNeighborhoods: Array<PlayRequestNeighborhoods>;
  /** fetch aggregated fields from the table: "play_request_neighborhoods" */
  playRequestNeighborhoodsAggregate: PlayRequestNeighborhoodsAggregate;
  /** fetch data from the table: "play_request_neighborhoods" using primary key columns */
  playRequestNeighborhoodsByPk?: Maybe<PlayRequestNeighborhoods>;
  /** fetch data from the table in a streaming manner: "play_request_neighborhoods" */
  playRequestNeighborhoodsStream: Array<PlayRequestNeighborhoods>;
  /** fetch data from the table: "play_request_slots" */
  playRequestSlots: Array<PlayRequestSlots>;
  /** fetch aggregated fields from the table: "play_request_slots" */
  playRequestSlotsAggregate: PlayRequestSlotsAggregate;
  /** fetch data from the table: "play_request_slots" using primary key columns */
  playRequestSlotsByPk?: Maybe<PlayRequestSlots>;
  /** fetch data from the table in a streaming manner: "play_request_slots" */
  playRequestSlotsStream: Array<PlayRequestSlots>;
  /** fetch data from the table: "play_request_statuses" */
  playRequestStatuses: Array<PlayRequestStatuses>;
  /** fetch aggregated fields from the table: "play_request_statuses" */
  playRequestStatusesAggregate: PlayRequestStatusesAggregate;
  /** fetch data from the table: "play_request_statuses" using primary key columns */
  playRequestStatusesByPk?: Maybe<PlayRequestStatuses>;
  /** fetch data from the table in a streaming manner: "play_request_statuses" */
  playRequestStatusesStream: Array<PlayRequestStatuses>;
  /** fetch data from the table: "play_request_venues" */
  playRequestVenues: Array<PlayRequestVenues>;
  /** fetch aggregated fields from the table: "play_request_venues" */
  playRequestVenuesAggregate: PlayRequestVenuesAggregate;
  /** fetch data from the table: "play_request_venues" using primary key columns */
  playRequestVenuesByPk?: Maybe<PlayRequestVenues>;
  /** fetch data from the table in a streaming manner: "play_request_venues" */
  playRequestVenuesStream: Array<PlayRequestVenues>;
  /** An array relationship */
  playRequests: Array<PlayRequests>;
  /** An aggregate relationship */
  playRequestsAggregate: PlayRequestsAggregate;
  /** fetch data from the table: "play_requests" using primary key columns */
  playRequestsByPk?: Maybe<PlayRequests>;
  /** fetch data from the table in a streaming manner: "play_requests" */
  playRequestsStream: Array<PlayRequests>;
  /** fetch data from the table: "play_session_comments" */
  playSessionComments: Array<PlaySessionComments>;
  /** fetch aggregated fields from the table: "play_session_comments" */
  playSessionCommentsAggregate: PlaySessionCommentsAggregate;
  /** fetch data from the table: "play_session_comments" using primary key columns */
  playSessionCommentsByPk?: Maybe<PlaySessionComments>;
  /** fetch data from the table in a streaming manner: "play_session_comments" */
  playSessionCommentsStream: Array<PlaySessionComments>;
  /** fetch data from the table: "play_session_court_booking_statuses" */
  playSessionCourtBookingStatuses: Array<PlaySessionCourtBookingStatuses>;
  /** fetch aggregated fields from the table: "play_session_court_booking_statuses" */
  playSessionCourtBookingStatusesAggregate: PlaySessionCourtBookingStatusesAggregate;
  /** fetch data from the table: "play_session_court_booking_statuses" using primary key columns */
  playSessionCourtBookingStatusesByPk?: Maybe<PlaySessionCourtBookingStatuses>;
  /** fetch data from the table in a streaming manner: "play_session_court_booking_statuses" */
  playSessionCourtBookingStatusesStream: Array<PlaySessionCourtBookingStatuses>;
  /** fetch data from the table: "play_session_formats" */
  playSessionFormats: Array<PlaySessionFormats>;
  /** fetch aggregated fields from the table: "play_session_formats" */
  playSessionFormatsAggregate: PlaySessionFormatsAggregate;
  /** fetch data from the table: "play_session_formats" using primary key columns */
  playSessionFormatsByPk?: Maybe<PlaySessionFormats>;
  /** fetch data from the table in a streaming manner: "play_session_formats" */
  playSessionFormatsStream: Array<PlaySessionFormats>;
  /** fetch data from the table: "play_session_match_competitiveness" */
  playSessionMatchCompetitiveness: Array<PlaySessionMatchCompetitiveness>;
  /** fetch aggregated fields from the table: "play_session_match_competitiveness" */
  playSessionMatchCompetitivenessAggregate: PlaySessionMatchCompetitivenessAggregate;
  /** fetch data from the table: "play_session_match_competitiveness" using primary key columns */
  playSessionMatchCompetitivenessByPk?: Maybe<PlaySessionMatchCompetitiveness>;
  /** fetch data from the table in a streaming manner: "play_session_match_competitiveness" */
  playSessionMatchCompetitivenessStream: Array<PlaySessionMatchCompetitiveness>;
  /** fetch data from the table: "play_session_participant_statuses" */
  playSessionParticipantStatuses: Array<PlaySessionParticipantStatuses>;
  /** fetch aggregated fields from the table: "play_session_participant_statuses" */
  playSessionParticipantStatusesAggregate: PlaySessionParticipantStatusesAggregate;
  /** fetch data from the table: "play_session_participant_statuses" using primary key columns */
  playSessionParticipantStatusesByPk?: Maybe<PlaySessionParticipantStatuses>;
  /** fetch data from the table in a streaming manner: "play_session_participant_statuses" */
  playSessionParticipantStatusesStream: Array<PlaySessionParticipantStatuses>;
  /** fetch data from the table: "play_session_participants" */
  playSessionParticipants: Array<PlaySessionParticipants>;
  /** fetch aggregated fields from the table: "play_session_participants" */
  playSessionParticipantsAggregate: PlaySessionParticipantsAggregate;
  /** fetch data from the table: "play_session_participants" using primary key columns */
  playSessionParticipantsByPk?: Maybe<PlaySessionParticipants>;
  /** fetch data from the table in a streaming manner: "play_session_participants" */
  playSessionParticipantsStream: Array<PlaySessionParticipants>;
  /** fetch data from the table: "play_session_privacy" */
  playSessionPrivacy: Array<PlaySessionPrivacy>;
  /** fetch aggregated fields from the table: "play_session_privacy" */
  playSessionPrivacyAggregate: PlaySessionPrivacyAggregate;
  /** fetch data from the table: "play_session_privacy" using primary key columns */
  playSessionPrivacyByPk?: Maybe<PlaySessionPrivacy>;
  /** fetch data from the table in a streaming manner: "play_session_privacy" */
  playSessionPrivacyStream: Array<PlaySessionPrivacy>;
  /** fetch data from the table: "play_session_statuses" */
  playSessionStatuses: Array<PlaySessionStatuses>;
  /** fetch aggregated fields from the table: "play_session_statuses" */
  playSessionStatusesAggregate: PlaySessionStatusesAggregate;
  /** fetch data from the table: "play_session_statuses" using primary key columns */
  playSessionStatusesByPk?: Maybe<PlaySessionStatuses>;
  /** fetch data from the table in a streaming manner: "play_session_statuses" */
  playSessionStatusesStream: Array<PlaySessionStatuses>;
  /** An array relationship */
  playSessions: Array<PlaySessions>;
  /** An aggregate relationship */
  playSessionsAggregate: PlaySessionsAggregate;
  /** fetch data from the table: "play_sessions" using primary key columns */
  playSessionsByPk?: Maybe<PlaySessions>;
  /** fetch data from the table in a streaming manner: "play_sessions" */
  playSessionsStream: Array<PlaySessions>;
  /** fetch data from the table: "player_availabilities" */
  playerAvailabilities: Array<PlayerAvailabilities>;
  /** fetch aggregated fields from the table: "player_availabilities" */
  playerAvailabilitiesAggregate: PlayerAvailabilitiesAggregate;
  /** fetch data from the table: "player_availabilities" using primary key columns */
  playerAvailabilitiesByPk?: Maybe<PlayerAvailabilities>;
  /** fetch data from the table in a streaming manner: "player_availabilities" */
  playerAvailabilitiesStream: Array<PlayerAvailabilities>;
  /** fetch data from the table: "player_availability_neighborhoods" */
  playerAvailabilityNeighborhoods: Array<PlayerAvailabilityNeighborhoods>;
  /** fetch aggregated fields from the table: "player_availability_neighborhoods" */
  playerAvailabilityNeighborhoodsAggregate: PlayerAvailabilityNeighborhoodsAggregate;
  /** fetch data from the table: "player_availability_neighborhoods" using primary key columns */
  playerAvailabilityNeighborhoodsByPk?: Maybe<PlayerAvailabilityNeighborhoods>;
  /** fetch data from the table in a streaming manner: "player_availability_neighborhoods" */
  playerAvailabilityNeighborhoodsStream: Array<PlayerAvailabilityNeighborhoods>;
  /** fetch data from the table: "player_availability_rating_scales" */
  playerAvailabilityRatingScales: Array<PlayerAvailabilityRatingScales>;
  /** fetch aggregated fields from the table: "player_availability_rating_scales" */
  playerAvailabilityRatingScalesAggregate: PlayerAvailabilityRatingScalesAggregate;
  /** fetch data from the table: "player_availability_rating_scales" using primary key columns */
  playerAvailabilityRatingScalesByPk?: Maybe<PlayerAvailabilityRatingScales>;
  /** fetch data from the table in a streaming manner: "player_availability_rating_scales" */
  playerAvailabilityRatingScalesStream: Array<PlayerAvailabilityRatingScales>;
  /** fetch data from the table: "player_availability_slots" */
  playerAvailabilitySlots: Array<PlayerAvailabilitySlots>;
  /** fetch aggregated fields from the table: "player_availability_slots" */
  playerAvailabilitySlotsAggregate: PlayerAvailabilitySlotsAggregate;
  /** fetch data from the table: "player_availability_slots" using primary key columns */
  playerAvailabilitySlotsByPk?: Maybe<PlayerAvailabilitySlots>;
  /** fetch data from the table in a streaming manner: "player_availability_slots" */
  playerAvailabilitySlotsStream: Array<PlayerAvailabilitySlots>;
  /** fetch data from the table: "player_availability_venues" */
  playerAvailabilityVenues: Array<PlayerAvailabilityVenues>;
  /** fetch aggregated fields from the table: "player_availability_venues" */
  playerAvailabilityVenuesAggregate: PlayerAvailabilityVenuesAggregate;
  /** fetch data from the table: "player_availability_venues" using primary key columns */
  playerAvailabilityVenuesByPk?: Maybe<PlayerAvailabilityVenues>;
  /** fetch data from the table in a streaming manner: "player_availability_venues" */
  playerAvailabilityVenuesStream: Array<PlayerAvailabilityVenues>;
  /** fetch data from the table: "player_finder_goals" */
  playerFinderGoals: Array<PlayerFinderGoals>;
  /** fetch aggregated fields from the table: "player_finder_goals" */
  playerFinderGoalsAggregate: PlayerFinderGoalsAggregate;
  /** fetch data from the table: "player_finder_goals" using primary key columns */
  playerFinderGoalsByPk?: Maybe<PlayerFinderGoals>;
  /** fetch data from the table in a streaming manner: "player_finder_goals" */
  playerFinderGoalsStream: Array<PlayerFinderGoals>;
  /** fetch data from the table: "player_finder_time_of_day" */
  playerFinderTimeOfDay: Array<PlayerFinderTimeOfDay>;
  /** fetch aggregated fields from the table: "player_finder_time_of_day" */
  playerFinderTimeOfDayAggregate: PlayerFinderTimeOfDayAggregate;
  /** fetch data from the table: "player_finder_time_of_day" using primary key columns */
  playerFinderTimeOfDayByPk?: Maybe<PlayerFinderTimeOfDay>;
  /** fetch data from the table in a streaming manner: "player_finder_time_of_day" */
  playerFinderTimeOfDayStream: Array<PlayerFinderTimeOfDay>;
  /** fetch data from the table: "recurrence_kinds" */
  recurrenceKinds: Array<RecurrenceKinds>;
  /** fetch aggregated fields from the table: "recurrence_kinds" */
  recurrenceKindsAggregate: RecurrenceKindsAggregate;
  /** fetch data from the table: "recurrence_kinds" using primary key columns */
  recurrenceKindsByPk?: Maybe<RecurrenceKinds>;
  /** fetch data from the table in a streaming manner: "recurrence_kinds" */
  recurrenceKindsStream: Array<RecurrenceKinds>;
  /** fetch data from the table: "report_reasons" */
  reportReasons: Array<ReportReasons>;
  /** fetch aggregated fields from the table: "report_reasons" */
  reportReasonsAggregate: ReportReasonsAggregate;
  /** fetch data from the table: "report_reasons" using primary key columns */
  reportReasonsByPk?: Maybe<ReportReasons>;
  /** fetch data from the table in a streaming manner: "report_reasons" */
  reportReasonsStream: Array<ReportReasons>;
  /** fetch data from the table: "report_statuses" */
  reportStatuses: Array<ReportStatuses>;
  /** fetch aggregated fields from the table: "report_statuses" */
  reportStatusesAggregate: ReportStatusesAggregate;
  /** fetch data from the table: "report_statuses" using primary key columns */
  reportStatusesByPk?: Maybe<ReportStatuses>;
  /** fetch data from the table in a streaming manner: "report_statuses" */
  reportStatusesStream: Array<ReportStatuses>;
  /** fetch data from the table: "reviews" */
  reviews: Array<Reviews>;
  /** fetch aggregated fields from the table: "reviews" */
  reviewsAggregate: ReviewsAggregate;
  /** fetch data from the table: "reviews" using primary key columns */
  reviewsByPk?: Maybe<Reviews>;
  /** fetch data from the table in a streaming manner: "reviews" */
  reviewsStream: Array<Reviews>;
  /** An array relationship */
  sales: Array<Sales>;
  /** An aggregate relationship */
  salesAggregate: SalesAggregate;
  /** fetch data from the table: "sales" using primary key columns */
  salesByPk?: Maybe<Sales>;
  /** fetch data from the table in a streaming manner: "sales" */
  salesStream: Array<Sales>;
  /** fetch data from the table: "scoring_format" */
  scoringFormat: Array<ScoringFormat>;
  /** fetch aggregated fields from the table: "scoring_format" */
  scoringFormatAggregate: ScoringFormatAggregate;
  /** fetch data from the table: "scoring_format" using primary key columns */
  scoringFormatByPk?: Maybe<ScoringFormat>;
  /** fetch data from the table in a streaming manner: "scoring_format" */
  scoringFormatStream: Array<ScoringFormat>;
  /** fetch data from the table: "signup_requests" */
  signupRequests: Array<SignupRequests>;
  /** fetch aggregated fields from the table: "signup_requests" */
  signupRequestsAggregate: SignupRequestsAggregate;
  /** fetch data from the table: "signup_requests" using primary key columns */
  signupRequestsByPk?: Maybe<SignupRequests>;
  /** fetch data from the table in a streaming manner: "signup_requests" */
  signupRequestsStream: Array<SignupRequests>;
  /** fetch data from the table: "skill_level_values" */
  skillLevelValues: Array<SkillLevelValues>;
  /** fetch aggregated fields from the table: "skill_level_values" */
  skillLevelValuesAggregate: SkillLevelValuesAggregate;
  /** fetch data from the table: "skill_level_values" using primary key columns */
  skillLevelValuesByPk?: Maybe<SkillLevelValues>;
  /** fetch data from the table in a streaming manner: "skill_level_values" */
  skillLevelValuesStream: Array<SkillLevelValues>;
  /** fetch data from the table: "skill_levels" */
  skillLevels: Array<SkillLevels>;
  /** fetch aggregated fields from the table: "skill_levels" */
  skillLevelsAggregate: SkillLevelsAggregate;
  /** fetch data from the table: "skill_levels" using primary key columns */
  skillLevelsByPk?: Maybe<SkillLevels>;
  /** fetch data from the table in a streaming manner: "skill_levels" */
  skillLevelsStream: Array<SkillLevels>;
  /** fetch data from the table: "sports" */
  sports: Array<Sports>;
  /** fetch aggregated fields from the table: "sports" */
  sportsAggregate: SportsAggregate;
  /** fetch data from the table: "sports" using primary key columns */
  sportsByPk?: Maybe<Sports>;
  /** fetch data from the table in a streaming manner: "sports" */
  sportsStream: Array<Sports>;
  /** An array relationship */
  stripeCharges: Array<StripeCharges>;
  /** An aggregate relationship */
  stripeChargesAggregate: StripeChargesAggregate;
  /** fetch data from the table: "stripe_charges" using primary key columns */
  stripeChargesByPk?: Maybe<StripeCharges>;
  /** fetch data from the table in a streaming manner: "stripe_charges" */
  stripeChargesStream: Array<StripeCharges>;
  /** fetch data from the table: "stripe_payment_intents" */
  stripePaymentIntents: Array<StripePaymentIntents>;
  /** fetch aggregated fields from the table: "stripe_payment_intents" */
  stripePaymentIntentsAggregate: StripePaymentIntentsAggregate;
  /** fetch data from the table: "stripe_payment_intents" using primary key columns */
  stripePaymentIntentsByPk?: Maybe<StripePaymentIntents>;
  /** fetch data from the table in a streaming manner: "stripe_payment_intents" */
  stripePaymentIntentsStream: Array<StripePaymentIntents>;
  /** fetch data from the table: "subscription_statuses" */
  subscriptionStatuses: Array<SubscriptionStatuses>;
  /** fetch aggregated fields from the table: "subscription_statuses" */
  subscriptionStatusesAggregate: SubscriptionStatusesAggregate;
  /** fetch data from the table: "subscription_statuses" using primary key columns */
  subscriptionStatusesByPk?: Maybe<SubscriptionStatuses>;
  /** fetch data from the table in a streaming manner: "subscription_statuses" */
  subscriptionStatusesStream: Array<SubscriptionStatuses>;
  /** fetch data from the table: "team_types" */
  teamTypes: Array<TeamTypes>;
  /** fetch aggregated fields from the table: "team_types" */
  teamTypesAggregate: TeamTypesAggregate;
  /** fetch data from the table: "team_types" using primary key columns */
  teamTypesByPk?: Maybe<TeamTypes>;
  /** fetch data from the table in a streaming manner: "team_types" */
  teamTypesStream: Array<TeamTypes>;
  /** fetch data from the table: "tennis_rating_scales" */
  tennisRatingScales: Array<TennisRatingScales>;
  /** fetch aggregated fields from the table: "tennis_rating_scales" */
  tennisRatingScalesAggregate: TennisRatingScalesAggregate;
  /** fetch data from the table: "tennis_rating_scales" using primary key columns */
  tennisRatingScalesByPk?: Maybe<TennisRatingScales>;
  /** fetch data from the table in a streaming manner: "tennis_rating_scales" */
  tennisRatingScalesStream: Array<TennisRatingScales>;
  /** fetch data from the table: "twilio_group_texts" */
  twilioGroupTexts: Array<TwilioGroupTexts>;
  /** fetch aggregated fields from the table: "twilio_group_texts" */
  twilioGroupTextsAggregate: TwilioGroupTextsAggregate;
  /** fetch data from the table: "twilio_group_texts" using primary key columns */
  twilioGroupTextsByPk?: Maybe<TwilioGroupTexts>;
  /** fetch data from the table in a streaming manner: "twilio_group_texts" */
  twilioGroupTextsStream: Array<TwilioGroupTexts>;
  /** fetch data from the table: "upload_review_requests" */
  uploadReviewRequests: Array<UploadReviewRequests>;
  /** fetch aggregated fields from the table: "upload_review_requests" */
  uploadReviewRequestsAggregate: UploadReviewRequestsAggregate;
  /** fetch data from the table: "upload_review_requests" using primary key columns */
  uploadReviewRequestsByPk?: Maybe<UploadReviewRequests>;
  /** fetch data from the table in a streaming manner: "upload_review_requests" */
  uploadReviewRequestsStream: Array<UploadReviewRequests>;
  /** fetch data from the table: "user_auth_identities" */
  userAuthIdentities: Array<UserAuthIdentities>;
  /** fetch aggregated fields from the table: "user_auth_identities" */
  userAuthIdentitiesAggregate: UserAuthIdentitiesAggregate;
  /** fetch data from the table: "user_auth_identities" using primary key columns */
  userAuthIdentitiesByPk?: Maybe<UserAuthIdentities>;
  /** fetch data from the table in a streaming manner: "user_auth_identities" */
  userAuthIdentitiesStream: Array<UserAuthIdentities>;
  /** fetch data from the table: "user_blocks" */
  userBlocks: Array<UserBlocks>;
  /** fetch aggregated fields from the table: "user_blocks" */
  userBlocksAggregate: UserBlocksAggregate;
  /** fetch data from the table: "user_blocks" using primary key columns */
  userBlocksByPk?: Maybe<UserBlocks>;
  /** fetch data from the table in a streaming manner: "user_blocks" */
  userBlocksStream: Array<UserBlocks>;
  /** fetch data from the table: "user_coach_services" */
  userCoachServices: Array<UserCoachServices>;
  /** fetch aggregated fields from the table: "user_coach_services" */
  userCoachServicesAggregate: UserCoachServicesAggregate;
  /** fetch data from the table: "user_coach_services" using primary key columns */
  userCoachServicesByPk?: Maybe<UserCoachServices>;
  /** fetch data from the table in a streaming manner: "user_coach_services" */
  userCoachServicesStream: Array<UserCoachServices>;
  /** fetch data from the table: "user_communication_preferences" */
  userCommunicationPreferences: Array<UserCommunicationPreferences>;
  /** fetch aggregated fields from the table: "user_communication_preferences" */
  userCommunicationPreferencesAggregate: UserCommunicationPreferencesAggregate;
  /** fetch data from the table: "user_communication_preferences" using primary key columns */
  userCommunicationPreferencesByPk?: Maybe<UserCommunicationPreferences>;
  /** fetch data from the table in a streaming manner: "user_communication_preferences" */
  userCommunicationPreferencesStream: Array<UserCommunicationPreferences>;
  /** fetch data from the table: "user_connection_request_statuses" */
  userConnectionRequestStatuses: Array<UserConnectionRequestStatuses>;
  /** fetch aggregated fields from the table: "user_connection_request_statuses" */
  userConnectionRequestStatusesAggregate: UserConnectionRequestStatusesAggregate;
  /** fetch data from the table: "user_connection_request_statuses" using primary key columns */
  userConnectionRequestStatusesByPk?: Maybe<UserConnectionRequestStatuses>;
  /** fetch data from the table in a streaming manner: "user_connection_request_statuses" */
  userConnectionRequestStatusesStream: Array<UserConnectionRequestStatuses>;
  /** fetch data from the table: "user_connection_requests" */
  userConnectionRequests: Array<UserConnectionRequests>;
  /** fetch aggregated fields from the table: "user_connection_requests" */
  userConnectionRequestsAggregate: UserConnectionRequestsAggregate;
  /** fetch data from the table: "user_connection_requests" using primary key columns */
  userConnectionRequestsByPk?: Maybe<UserConnectionRequests>;
  /** fetch data from the table in a streaming manner: "user_connection_requests" */
  userConnectionRequestsStream: Array<UserConnectionRequests>;
  /** fetch data from the table: "user_connections" */
  userConnections: Array<UserConnections>;
  /** fetch aggregated fields from the table: "user_connections" */
  userConnectionsAggregate: UserConnectionsAggregate;
  /** fetch data from the table: "user_connections" using primary key columns */
  userConnectionsByPk?: Maybe<UserConnections>;
  /** fetch data from the table in a streaming manner: "user_connections" */
  userConnectionsStream: Array<UserConnections>;
  /** fetch data from the table: "user_content_beta_subscriptions" */
  userContentBetaSubscriptions: Array<UserContentBetaSubscriptions>;
  /** fetch aggregated fields from the table: "user_content_beta_subscriptions" */
  userContentBetaSubscriptionsAggregate: UserContentBetaSubscriptionsAggregate;
  /** fetch data from the table: "user_content_beta_subscriptions" using primary key columns */
  userContentBetaSubscriptionsByPk?: Maybe<UserContentBetaSubscriptions>;
  /** fetch data from the table in a streaming manner: "user_content_beta_subscriptions" */
  userContentBetaSubscriptionsStream: Array<UserContentBetaSubscriptions>;
  /** fetch data from the table: "user_content_files" */
  userContentFiles: Array<UserContentFiles>;
  /** fetch aggregated fields from the table: "user_content_files" */
  userContentFilesAggregate: UserContentFilesAggregate;
  /** fetch data from the table: "user_content_files" using primary key columns */
  userContentFilesByPk?: Maybe<UserContentFiles>;
  /** An array relationship */
  userContentFilesSkills: Array<UserContentFilesSkills>;
  /** An aggregate relationship */
  userContentFilesSkillsAggregate: UserContentFilesSkillsAggregate;
  /** fetch data from the table: "user_content_files_skills" using primary key columns */
  userContentFilesSkillsByPk?: Maybe<UserContentFilesSkills>;
  /** fetch data from the table in a streaming manner: "user_content_files_skills" */
  userContentFilesSkillsStream: Array<UserContentFilesSkills>;
  /** fetch data from the table in a streaming manner: "user_content_files" */
  userContentFilesStream: Array<UserContentFiles>;
  /** fetch data from the table: "user_content_skills" */
  userContentSkills: Array<UserContentSkills>;
  /** fetch aggregated fields from the table: "user_content_skills" */
  userContentSkillsAggregate: UserContentSkillsAggregate;
  /** fetch data from the table: "user_content_skills" using primary key columns */
  userContentSkillsByPk?: Maybe<UserContentSkills>;
  /** fetch data from the table in a streaming manner: "user_content_skills" */
  userContentSkillsStream: Array<UserContentSkills>;
  /** fetch data from the table: "user_content_tiers" */
  userContentTiers: Array<UserContentTiers>;
  /** fetch aggregated fields from the table: "user_content_tiers" */
  userContentTiersAggregate: UserContentTiersAggregate;
  /** fetch data from the table: "user_content_tiers" using primary key columns */
  userContentTiersByPk?: Maybe<UserContentTiers>;
  /** fetch data from the table in a streaming manner: "user_content_tiers" */
  userContentTiersStream: Array<UserContentTiers>;
  /** fetch data from the table: "user_credit_cards" */
  userCreditCards: Array<UserCreditCards>;
  /** fetch aggregated fields from the table: "user_credit_cards" */
  userCreditCardsAggregate: UserCreditCardsAggregate;
  /** fetch data from the table: "user_credit_cards" using primary key columns */
  userCreditCardsByPk?: Maybe<UserCreditCards>;
  /** fetch data from the table in a streaming manner: "user_credit_cards" */
  userCreditCardsStream: Array<UserCreditCards>;
  /** fetch data from the table: "user_custom_courts" */
  userCustomCourts: Array<UserCustomCourts>;
  /** fetch aggregated fields from the table: "user_custom_courts" */
  userCustomCourtsAggregate: UserCustomCourtsAggregate;
  /** fetch data from the table: "user_custom_courts" using primary key columns */
  userCustomCourtsByPk?: Maybe<UserCustomCourts>;
  /** fetch data from the table in a streaming manner: "user_custom_courts" */
  userCustomCourtsStream: Array<UserCustomCourts>;
  /** An array relationship */
  userFiles: Array<UserFiles>;
  /** An aggregate relationship */
  userFilesAggregate: UserFilesAggregate;
  /** fetch data from the table: "user_files" using primary key columns */
  userFilesByPk?: Maybe<UserFiles>;
  /** fetch data from the table in a streaming manner: "user_files" */
  userFilesStream: Array<UserFiles>;
  /** fetch data from the table: "user_follows" */
  userFollows: Array<UserFollows>;
  /** fetch aggregated fields from the table: "user_follows" */
  userFollowsAggregate: UserFollowsAggregate;
  /** fetch data from the table: "user_follows" using primary key columns */
  userFollowsByPk?: Maybe<UserFollows>;
  /** fetch data from the table in a streaming manner: "user_follows" */
  userFollowsStream: Array<UserFollows>;
  /** fetch data from the table: "user_identity_verifications" */
  userIdentityVerifications: Array<UserIdentityVerifications>;
  /** fetch aggregated fields from the table: "user_identity_verifications" */
  userIdentityVerificationsAggregate: UserIdentityVerificationsAggregate;
  /** fetch data from the table: "user_identity_verifications" using primary key columns */
  userIdentityVerificationsByPk?: Maybe<UserIdentityVerifications>;
  /** fetch data from the table in a streaming manner: "user_identity_verifications" */
  userIdentityVerificationsStream: Array<UserIdentityVerifications>;
  /** fetch data from the table: "user_image_log" */
  userImageLog: Array<UserImageLog>;
  /** fetch aggregated fields from the table: "user_image_log" */
  userImageLogAggregate: UserImageLogAggregate;
  /** fetch data from the table: "user_image_log" using primary key columns */
  userImageLogByPk?: Maybe<UserImageLog>;
  /** fetch data from the table in a streaming manner: "user_image_log" */
  userImageLogStream: Array<UserImageLog>;
  /** fetch data from the table: "user_notification_details" */
  userNotificationDetails: Array<UserNotificationDetails>;
  /** fetch aggregated fields from the table: "user_notification_details" */
  userNotificationDetailsAggregate: UserNotificationDetailsAggregate;
  /** fetch data from the table: "user_notification_details" using primary key columns */
  userNotificationDetailsByPk?: Maybe<UserNotificationDetails>;
  /** fetch data from the table in a streaming manner: "user_notification_details" */
  userNotificationDetailsStream: Array<UserNotificationDetails>;
  /** fetch data from the table: "user_notification_entities" */
  userNotificationEntities: Array<UserNotificationEntities>;
  /** fetch aggregated fields from the table: "user_notification_entities" */
  userNotificationEntitiesAggregate: UserNotificationEntitiesAggregate;
  /** fetch data from the table: "user_notification_entities" using primary key columns */
  userNotificationEntitiesByPk?: Maybe<UserNotificationEntities>;
  /** fetch data from the table in a streaming manner: "user_notification_entities" */
  userNotificationEntitiesStream: Array<UserNotificationEntities>;
  /** An array relationship */
  userNotifications: Array<UserNotifications>;
  /** An aggregate relationship */
  userNotificationsAggregate: UserNotificationsAggregate;
  /** fetch data from the table: "user_notifications" using primary key columns */
  userNotificationsByPk?: Maybe<UserNotifications>;
  /** fetch data from the table in a streaming manner: "user_notifications" */
  userNotificationsStream: Array<UserNotifications>;
  /** fetch data from the table: "user_padel_rating_scales" */
  userPadelRatingScales: Array<UserPadelRatingScales>;
  /** fetch aggregated fields from the table: "user_padel_rating_scales" */
  userPadelRatingScalesAggregate: UserPadelRatingScalesAggregate;
  /** fetch data from the table: "user_padel_rating_scales" using primary key columns */
  userPadelRatingScalesByPk?: Maybe<UserPadelRatingScales>;
  /** fetch data from the table in a streaming manner: "user_padel_rating_scales" */
  userPadelRatingScalesStream: Array<UserPadelRatingScales>;
  /** fetch data from the table: "user_pickleball_rating_scales" */
  userPickleballRatingScales: Array<UserPickleballRatingScales>;
  /** fetch aggregated fields from the table: "user_pickleball_rating_scales" */
  userPickleballRatingScalesAggregate: UserPickleballRatingScalesAggregate;
  /** fetch data from the table: "user_pickleball_rating_scales" using primary key columns */
  userPickleballRatingScalesByPk?: Maybe<UserPickleballRatingScales>;
  /** fetch data from the table in a streaming manner: "user_pickleball_rating_scales" */
  userPickleballRatingScalesStream: Array<UserPickleballRatingScales>;
  /** fetch data from the table: "user_played_with" */
  userPlayedWith: Array<UserPlayedWith>;
  /** fetch aggregated fields from the table: "user_played_with" */
  userPlayedWithAggregate: UserPlayedWithAggregate;
  /** fetch data from the table: "user_played_with_dismissals" */
  userPlayedWithDismissals: Array<UserPlayedWithDismissals>;
  /** fetch aggregated fields from the table: "user_played_with_dismissals" */
  userPlayedWithDismissalsAggregate: UserPlayedWithDismissalsAggregate;
  /** fetch data from the table: "user_played_with_dismissals" using primary key columns */
  userPlayedWithDismissalsByPk?: Maybe<UserPlayedWithDismissals>;
  /** fetch data from the table in a streaming manner: "user_played_with_dismissals" */
  userPlayedWithDismissalsStream: Array<UserPlayedWithDismissals>;
  /** fetch data from the table: "user_played_with_games" */
  userPlayedWithGames: Array<UserPlayedWithGames>;
  /** fetch aggregated fields from the table: "user_played_with_games" */
  userPlayedWithGamesAggregate: UserPlayedWithGamesAggregate;
  /** fetch data from the table in a streaming manner: "user_played_with_games" */
  userPlayedWithGamesStream: Array<UserPlayedWithGames>;
  /** fetch data from the table in a streaming manner: "user_played_with" */
  userPlayedWithStream: Array<UserPlayedWith>;
  /** fetch data from the table: "user_player_finder_availability" */
  userPlayerFinderAvailability: Array<UserPlayerFinderAvailability>;
  /** fetch aggregated fields from the table: "user_player_finder_availability" */
  userPlayerFinderAvailabilityAggregate: UserPlayerFinderAvailabilityAggregate;
  /** fetch data from the table: "user_player_finder_availability" using primary key columns */
  userPlayerFinderAvailabilityByPk?: Maybe<UserPlayerFinderAvailability>;
  /** fetch data from the table in a streaming manner: "user_player_finder_availability" */
  userPlayerFinderAvailabilityStream: Array<UserPlayerFinderAvailability>;
  /** fetch data from the table: "user_player_finder_goals" */
  userPlayerFinderGoals: Array<UserPlayerFinderGoals>;
  /** fetch aggregated fields from the table: "user_player_finder_goals" */
  userPlayerFinderGoalsAggregate: UserPlayerFinderGoalsAggregate;
  /** fetch data from the table: "user_player_finder_goals" using primary key columns */
  userPlayerFinderGoalsByPk?: Maybe<UserPlayerFinderGoals>;
  /** fetch data from the table in a streaming manner: "user_player_finder_goals" */
  userPlayerFinderGoalsStream: Array<UserPlayerFinderGoals>;
  /** fetch data from the table: "user_profiles" */
  userProfiles: Array<UserProfiles>;
  /** fetch aggregated fields from the table: "user_profiles" */
  userProfilesAggregate: UserProfilesAggregate;
  /** fetch data from the table in a streaming manner: "user_profiles" */
  userProfilesStream: Array<UserProfiles>;
  /** fetch data from the table: "user_registration_details" */
  userRegistrationDetails: Array<UserRegistrationDetails>;
  /** fetch aggregated fields from the table: "user_registration_details" */
  userRegistrationDetailsAggregate: UserRegistrationDetailsAggregate;
  /** fetch data from the table: "user_registration_details" using primary key columns */
  userRegistrationDetailsByPk?: Maybe<UserRegistrationDetails>;
  /** fetch data from the table in a streaming manner: "user_registration_details" */
  userRegistrationDetailsStream: Array<UserRegistrationDetails>;
  /** fetch data from the table: "user_sports" */
  userSports: Array<UserSports>;
  /** fetch aggregated fields from the table: "user_sports" */
  userSportsAggregate: UserSportsAggregate;
  /** fetch data from the table: "user_sports" using primary key columns */
  userSportsByPk?: Maybe<UserSports>;
  /** fetch data from the table in a streaming manner: "user_sports" */
  userSportsStream: Array<UserSports>;
  /** fetch data from the table: "user_tennis_rating_scales" */
  userTennisRatingScales: Array<UserTennisRatingScales>;
  /** fetch aggregated fields from the table: "user_tennis_rating_scales" */
  userTennisRatingScalesAggregate: UserTennisRatingScalesAggregate;
  /** fetch data from the table: "user_tennis_rating_scales" using primary key columns */
  userTennisRatingScalesByPk?: Maybe<UserTennisRatingScales>;
  /** fetch data from the table in a streaming manner: "user_tennis_rating_scales" */
  userTennisRatingScalesStream: Array<UserTennisRatingScales>;
  /** fetch data from the table: "user_terms_of_service" */
  userTermsOfService: Array<UserTermsOfService>;
  /** fetch aggregated fields from the table: "user_terms_of_service" */
  userTermsOfServiceAggregate: UserTermsOfServiceAggregate;
  /** fetch data from the table: "user_terms_of_service" using primary key columns */
  userTermsOfServiceByPk?: Maybe<UserTermsOfService>;
  /** fetch data from the table in a streaming manner: "user_terms_of_service" */
  userTermsOfServiceStream: Array<UserTermsOfService>;
  /** fetch data from the table: "user_vair_connections" */
  userVairConnections: Array<UserVairConnections>;
  /** fetch aggregated fields from the table: "user_vair_connections" */
  userVairConnectionsAggregate: UserVairConnectionsAggregate;
  /** fetch data from the table: "user_vair_connections" using primary key columns */
  userVairConnectionsByPk?: Maybe<UserVairConnections>;
  /** fetch data from the table in a streaming manner: "user_vair_connections" */
  userVairConnectionsStream: Array<UserVairConnections>;
  /** An array relationship */
  usernameLogs: Array<UsernameLogs>;
  /** An aggregate relationship */
  usernameLogsAggregate: UsernameLogsAggregate;
  /** fetch data from the table: "username_logs" using primary key columns */
  usernameLogsByPk?: Maybe<UsernameLogs>;
  /** fetch data from the table in a streaming manner: "username_logs" */
  usernameLogsStream: Array<UsernameLogs>;
  /** fetch data from the table: "usernames_active" */
  usernamesActive: Array<UsernamesActive>;
  /** fetch aggregated fields from the table: "usernames_active" */
  usernamesActiveAggregate: UsernamesActiveAggregate;
  /** fetch data from the table in a streaming manner: "usernames_active" */
  usernamesActiveStream: Array<UsernamesActive>;
  /** An array relationship */
  usernamesClaimed: Array<UsernamesClaimed>;
  /** An aggregate relationship */
  usernamesClaimedAggregate: UsernamesClaimedAggregate;
  /** fetch data from the table: "usernames_claimed" using primary key columns */
  usernamesClaimedByPk?: Maybe<UsernamesClaimed>;
  /** fetch data from the table in a streaming manner: "usernames_claimed" */
  usernamesClaimedStream: Array<UsernamesClaimed>;
  /** An array relationship */
  users: Array<Users>;
  /** An aggregate relationship */
  usersAggregate: UsersAggregate;
  /** fetch data from the table: "users" using primary key columns */
  usersByPk?: Maybe<Users>;
  /** fetch data from the table: "users_coach_qualifications" */
  usersCoachQualifications: Array<UsersCoachQualifications>;
  /** fetch aggregated fields from the table: "users_coach_qualifications" */
  usersCoachQualificationsAggregate: UsersCoachQualificationsAggregate;
  /** fetch data from the table: "users_coach_qualifications" using primary key columns */
  usersCoachQualificationsByPk?: Maybe<UsersCoachQualifications>;
  /** fetch data from the table in a streaming manner: "users_coach_qualifications" */
  usersCoachQualificationsStream: Array<UsersCoachQualifications>;
  /** fetch data from the table in a streaming manner: "users" */
  usersStream: Array<Users>;
  /** fetch data from the table: "venue_access_types" */
  venueAccessTypes: Array<VenueAccessTypes>;
  /** fetch aggregated fields from the table: "venue_access_types" */
  venueAccessTypesAggregate: VenueAccessTypesAggregate;
  /** fetch data from the table: "venue_access_types" using primary key columns */
  venueAccessTypesByPk?: Maybe<VenueAccessTypes>;
  /** fetch data from the table in a streaming manner: "venue_access_types" */
  venueAccessTypesStream: Array<VenueAccessTypes>;
  /** fetch data from the table: "venue_admin_claim_statuses" */
  venueAdminClaimStatuses: Array<VenueAdminClaimStatuses>;
  /** fetch aggregated fields from the table: "venue_admin_claim_statuses" */
  venueAdminClaimStatusesAggregate: VenueAdminClaimStatusesAggregate;
  /** fetch data from the table: "venue_admin_claim_statuses" using primary key columns */
  venueAdminClaimStatusesByPk?: Maybe<VenueAdminClaimStatuses>;
  /** fetch data from the table in a streaming manner: "venue_admin_claim_statuses" */
  venueAdminClaimStatusesStream: Array<VenueAdminClaimStatuses>;
  /** fetch data from the table: "venue_admin_claims" */
  venueAdminClaims: Array<VenueAdminClaims>;
  /** fetch aggregated fields from the table: "venue_admin_claims" */
  venueAdminClaimsAggregate: VenueAdminClaimsAggregate;
  /** fetch data from the table: "venue_admin_claims" using primary key columns */
  venueAdminClaimsByPk?: Maybe<VenueAdminClaims>;
  /** fetch data from the table in a streaming manner: "venue_admin_claims" */
  venueAdminClaimsStream: Array<VenueAdminClaims>;
  /** fetch data from the table: "venue_amenities" */
  venueAmenities: Array<VenueAmenities>;
  /** fetch aggregated fields from the table: "venue_amenities" */
  venueAmenitiesAggregate: VenueAmenitiesAggregate;
  /** fetch data from the table: "venue_amenities" using primary key columns */
  venueAmenitiesByPk?: Maybe<VenueAmenities>;
  /** fetch data from the table in a streaming manner: "venue_amenities" */
  venueAmenitiesStream: Array<VenueAmenities>;
  /** fetch data from the table: "venue_booking_config_versions" */
  venueBookingConfigVersions: Array<VenueBookingConfigVersions>;
  /** fetch aggregated fields from the table: "venue_booking_config_versions" */
  venueBookingConfigVersionsAggregate: VenueBookingConfigVersionsAggregate;
  /** fetch data from the table: "venue_booking_config_versions" using primary key columns */
  venueBookingConfigVersionsByPk?: Maybe<VenueBookingConfigVersions>;
  /** fetch data from the table in a streaming manner: "venue_booking_config_versions" */
  venueBookingConfigVersionsStream: Array<VenueBookingConfigVersions>;
  /** fetch data from the table: "venue_booking_connection_check_statuses" */
  venueBookingConnectionCheckStatuses: Array<VenueBookingConnectionCheckStatuses>;
  /** fetch aggregated fields from the table: "venue_booking_connection_check_statuses" */
  venueBookingConnectionCheckStatusesAggregate: VenueBookingConnectionCheckStatusesAggregate;
  /** fetch data from the table: "venue_booking_connection_check_statuses" using primary key columns */
  venueBookingConnectionCheckStatusesByPk?: Maybe<VenueBookingConnectionCheckStatuses>;
  /** fetch data from the table in a streaming manner: "venue_booking_connection_check_statuses" */
  venueBookingConnectionCheckStatusesStream: Array<VenueBookingConnectionCheckStatuses>;
  /** fetch data from the table: "venue_booking_connection_checks" */
  venueBookingConnectionChecks: Array<VenueBookingConnectionChecks>;
  /** fetch aggregated fields from the table: "venue_booking_connection_checks" */
  venueBookingConnectionChecksAggregate: VenueBookingConnectionChecksAggregate;
  /** fetch data from the table: "venue_booking_connection_checks" using primary key columns */
  venueBookingConnectionChecksByPk?: Maybe<VenueBookingConnectionChecks>;
  /** fetch data from the table in a streaming manner: "venue_booking_connection_checks" */
  venueBookingConnectionChecksStream: Array<VenueBookingConnectionChecks>;
  /** fetch data from the table: "venue_booking_court_rates" */
  venueBookingCourtRates: Array<VenueBookingCourtRates>;
  /** fetch aggregated fields from the table: "venue_booking_court_rates" */
  venueBookingCourtRatesAggregate: VenueBookingCourtRatesAggregate;
  /** fetch data from the table: "venue_booking_court_rates" using primary key columns */
  venueBookingCourtRatesByPk?: Maybe<VenueBookingCourtRates>;
  /** fetch data from the table in a streaming manner: "venue_booking_court_rates" */
  venueBookingCourtRatesStream: Array<VenueBookingCourtRates>;
  /** fetch data from the table: "venue_booking_integrations" */
  venueBookingIntegrations: Array<VenueBookingIntegrations>;
  /** fetch aggregated fields from the table: "venue_booking_integrations" */
  venueBookingIntegrationsAggregate: VenueBookingIntegrationsAggregate;
  /** fetch data from the table: "venue_booking_integrations" using primary key columns */
  venueBookingIntegrationsByPk?: Maybe<VenueBookingIntegrations>;
  /** fetch data from the table in a streaming manner: "venue_booking_integrations" */
  venueBookingIntegrationsStream: Array<VenueBookingIntegrations>;
  /** fetch data from the table: "venue_booking_rule_tiers" */
  venueBookingRuleTiers: Array<VenueBookingRuleTiers>;
  /** fetch aggregated fields from the table: "venue_booking_rule_tiers" */
  venueBookingRuleTiersAggregate: VenueBookingRuleTiersAggregate;
  /** fetch data from the table: "venue_booking_rule_tiers" using primary key columns */
  venueBookingRuleTiersByPk?: Maybe<VenueBookingRuleTiers>;
  /** fetch data from the table in a streaming manner: "venue_booking_rule_tiers" */
  venueBookingRuleTiersStream: Array<VenueBookingRuleTiers>;
  /** fetch data from the table: "venue_booking_rules" */
  venueBookingRules: Array<VenueBookingRules>;
  /** fetch aggregated fields from the table: "venue_booking_rules" */
  venueBookingRulesAggregate: VenueBookingRulesAggregate;
  /** fetch data from the table: "venue_booking_rules" using primary key columns */
  venueBookingRulesByPk?: Maybe<VenueBookingRules>;
  /** fetch data from the table in a streaming manner: "venue_booking_rules" */
  venueBookingRulesStream: Array<VenueBookingRules>;
  /** fetch data from the table: "venue_booking_windows" */
  venueBookingWindows: Array<VenueBookingWindows>;
  /** fetch aggregated fields from the table: "venue_booking_windows" */
  venueBookingWindowsAggregate: VenueBookingWindowsAggregate;
  /** fetch data from the table: "venue_booking_windows" using primary key columns */
  venueBookingWindowsByPk?: Maybe<VenueBookingWindows>;
  /** fetch data from the table in a streaming manner: "venue_booking_windows" */
  venueBookingWindowsStream: Array<VenueBookingWindows>;
  /** fetch data from the table: "venue_court_surfaces" */
  venueCourtSurfaces: Array<VenueCourtSurfaces>;
  /** fetch aggregated fields from the table: "venue_court_surfaces" */
  venueCourtSurfacesAggregate: VenueCourtSurfacesAggregate;
  /** fetch data from the table: "venue_court_surfaces" using primary key columns */
  venueCourtSurfacesByPk?: Maybe<VenueCourtSurfaces>;
  /** fetch data from the table in a streaming manner: "venue_court_surfaces" */
  venueCourtSurfacesStream: Array<VenueCourtSurfaces>;
  /** fetch data from the table: "venue_custom_amenities" */
  venueCustomAmenities: Array<VenueCustomAmenities>;
  /** fetch aggregated fields from the table: "venue_custom_amenities" */
  venueCustomAmenitiesAggregate: VenueCustomAmenitiesAggregate;
  /** fetch data from the table: "venue_custom_amenities" using primary key columns */
  venueCustomAmenitiesByPk?: Maybe<VenueCustomAmenities>;
  /** fetch data from the table in a streaming manner: "venue_custom_amenities" */
  venueCustomAmenitiesStream: Array<VenueCustomAmenities>;
  /** fetch data from the table: "venue_equipment" */
  venueEquipment: Array<VenueEquipment>;
  /** fetch aggregated fields from the table: "venue_equipment" */
  venueEquipmentAggregate: VenueEquipmentAggregate;
  /** fetch data from the table: "venue_equipment" using primary key columns */
  venueEquipmentByPk?: Maybe<VenueEquipment>;
  /** fetch data from the table in a streaming manner: "venue_equipment" */
  venueEquipmentStream: Array<VenueEquipment>;
  /** fetch data from the table: "venue_facility_types" */
  venueFacilityTypes: Array<VenueFacilityTypes>;
  /** fetch aggregated fields from the table: "venue_facility_types" */
  venueFacilityTypesAggregate: VenueFacilityTypesAggregate;
  /** fetch data from the table: "venue_facility_types" using primary key columns */
  venueFacilityTypesByPk?: Maybe<VenueFacilityTypes>;
  /** fetch data from the table in a streaming manner: "venue_facility_types" */
  venueFacilityTypesStream: Array<VenueFacilityTypes>;
  /** fetch data from the table: "venue_faqs" */
  venueFaqs: Array<VenueFaqs>;
  /** fetch aggregated fields from the table: "venue_faqs" */
  venueFaqsAggregate: VenueFaqsAggregate;
  /** fetch data from the table: "venue_faqs" using primary key columns */
  venueFaqsByPk?: Maybe<VenueFaqs>;
  /** fetch data from the table in a streaming manner: "venue_faqs" */
  venueFaqsStream: Array<VenueFaqs>;
  /** An array relationship */
  venueFollows: Array<VenueFollows>;
  /** An aggregate relationship */
  venueFollowsAggregate: VenueFollowsAggregate;
  /** fetch data from the table: "venue_follows" using primary key columns */
  venueFollowsByPk?: Maybe<VenueFollows>;
  /** fetch data from the table in a streaming manner: "venue_follows" */
  venueFollowsStream: Array<VenueFollows>;
  /** fetch data from the table: "venue_images" */
  venueImages: Array<VenueImages>;
  /** fetch aggregated fields from the table: "venue_images" */
  venueImagesAggregate: VenueImagesAggregate;
  /** fetch data from the table: "venue_images" using primary key columns */
  venueImagesByPk?: Maybe<VenueImages>;
  /** fetch data from the table in a streaming manner: "venue_images" */
  venueImagesStream: Array<VenueImages>;
  /** fetch data from the table: "venue_lines" */
  venueLines: Array<VenueLines>;
  /** fetch aggregated fields from the table: "venue_lines" */
  venueLinesAggregate: VenueLinesAggregate;
  /** fetch data from the table: "venue_lines" using primary key columns */
  venueLinesByPk?: Maybe<VenueLines>;
  /** fetch data from the table in a streaming manner: "venue_lines" */
  venueLinesStream: Array<VenueLines>;
  /** fetch data from the table: "venue_nets" */
  venueNets: Array<VenueNets>;
  /** fetch aggregated fields from the table: "venue_nets" */
  venueNetsAggregate: VenueNetsAggregate;
  /** fetch data from the table: "venue_nets" using primary key columns */
  venueNetsByPk?: Maybe<VenueNets>;
  /** fetch data from the table in a streaming manner: "venue_nets" */
  venueNetsStream: Array<VenueNets>;
  /** fetch data from the table: "venue_partner_booking_statuses" */
  venuePartnerBookingStatuses: Array<VenuePartnerBookingStatuses>;
  /** fetch aggregated fields from the table: "venue_partner_booking_statuses" */
  venuePartnerBookingStatusesAggregate: VenuePartnerBookingStatusesAggregate;
  /** fetch data from the table in a streaming manner: "venue_partner_booking_statuses" */
  venuePartnerBookingStatusesStream: Array<VenuePartnerBookingStatuses>;
  /** fetch data from the table: "venue_staff_coaches" */
  venueStaffCoaches: Array<VenueStaffCoaches>;
  /** fetch aggregated fields from the table: "venue_staff_coaches" */
  venueStaffCoachesAggregate: VenueStaffCoachesAggregate;
  /** fetch data from the table: "venue_staff_coaches" using primary key columns */
  venueStaffCoachesByPk?: Maybe<VenueStaffCoaches>;
  /** fetch data from the table in a streaming manner: "venue_staff_coaches" */
  venueStaffCoachesStream: Array<VenueStaffCoaches>;
  /** An array relationship */
  venues: Array<Venues>;
  /** An aggregate relationship */
  venuesAggregate: VenuesAggregate;
  /** fetch data from the table: "venues" using primary key columns */
  venuesByPk?: Maybe<Venues>;
  /** fetch data from the table in a streaming manner: "venues" */
  venuesStream: Array<Venues>;
  /** fetch data from the table: "video_analysis" */
  videoAnalysis: Array<VideoAnalysis>;
  /** fetch aggregated fields from the table: "video_analysis" */
  videoAnalysisAggregate: VideoAnalysisAggregate;
  /** fetch data from the table: "video_analysis" using primary key columns */
  videoAnalysisByPk?: Maybe<VideoAnalysis>;
  /** An array relationship */
  videoAnalysisComments: Array<VideoAnalysisComments>;
  /** An aggregate relationship */
  videoAnalysisCommentsAggregate: VideoAnalysisCommentsAggregate;
  /** fetch data from the table: "video_analysis_comments" using primary key columns */
  videoAnalysisCommentsByPk?: Maybe<VideoAnalysisComments>;
  /** fetch data from the table in a streaming manner: "video_analysis_comments" */
  videoAnalysisCommentsStream: Array<VideoAnalysisComments>;
  /** An array relationship */
  videoAnalysisFiles: Array<VideoAnalysisFiles>;
  /** An aggregate relationship */
  videoAnalysisFilesAggregate: VideoAnalysisFilesAggregate;
  /** fetch data from the table: "video_analysis_files" using primary key columns */
  videoAnalysisFilesByPk?: Maybe<VideoAnalysisFiles>;
  /** fetch data from the table in a streaming manner: "video_analysis_files" */
  videoAnalysisFilesStream: Array<VideoAnalysisFiles>;
  /** fetch data from the table: "video_analysis_files_upload_statuses" */
  videoAnalysisFilesUploadStatuses: Array<VideoAnalysisFilesUploadStatuses>;
  /** fetch aggregated fields from the table: "video_analysis_files_upload_statuses" */
  videoAnalysisFilesUploadStatusesAggregate: VideoAnalysisFilesUploadStatusesAggregate;
  /** fetch data from the table: "video_analysis_files_upload_statuses" using primary key columns */
  videoAnalysisFilesUploadStatusesByPk?: Maybe<VideoAnalysisFilesUploadStatuses>;
  /** fetch data from the table in a streaming manner: "video_analysis_files_upload_statuses" */
  videoAnalysisFilesUploadStatusesStream: Array<VideoAnalysisFilesUploadStatuses>;
  /** fetch data from the table: "video_analysis_order_items" */
  videoAnalysisOrderItems: Array<VideoAnalysisOrderItems>;
  /** fetch aggregated fields from the table: "video_analysis_order_items" */
  videoAnalysisOrderItemsAggregate: VideoAnalysisOrderItemsAggregate;
  /** fetch data from the table: "video_analysis_order_items" using primary key columns */
  videoAnalysisOrderItemsByPk?: Maybe<VideoAnalysisOrderItems>;
  /** fetch data from the table in a streaming manner: "video_analysis_order_items" */
  videoAnalysisOrderItemsStream: Array<VideoAnalysisOrderItems>;
  /** fetch data from the table: "video_analysis_orders" */
  videoAnalysisOrders: Array<VideoAnalysisOrders>;
  /** fetch aggregated fields from the table: "video_analysis_orders" */
  videoAnalysisOrdersAggregate: VideoAnalysisOrdersAggregate;
  /** fetch data from the table: "video_analysis_orders" using primary key columns */
  videoAnalysisOrdersByPk?: Maybe<VideoAnalysisOrders>;
  /** fetch data from the table in a streaming manner: "video_analysis_orders" */
  videoAnalysisOrdersStream: Array<VideoAnalysisOrders>;
  /** fetch data from the table: "video_analysis_requested_skills_review" */
  videoAnalysisRequestedSkillsReview: Array<VideoAnalysisRequestedSkillsReview>;
  /** fetch aggregated fields from the table: "video_analysis_requested_skills_review" */
  videoAnalysisRequestedSkillsReviewAggregate: VideoAnalysisRequestedSkillsReviewAggregate;
  /** fetch data from the table: "video_analysis_requested_skills_review" using primary key columns */
  videoAnalysisRequestedSkillsReviewByPk?: Maybe<VideoAnalysisRequestedSkillsReview>;
  /** fetch data from the table in a streaming manner: "video_analysis_requested_skills_review" */
  videoAnalysisRequestedSkillsReviewStream: Array<VideoAnalysisRequestedSkillsReview>;
  /** fetch data from the table: "video_analysis_review_statuses" */
  videoAnalysisReviewStatuses: Array<VideoAnalysisReviewStatuses>;
  /** fetch aggregated fields from the table: "video_analysis_review_statuses" */
  videoAnalysisReviewStatusesAggregate: VideoAnalysisReviewStatusesAggregate;
  /** fetch data from the table: "video_analysis_review_statuses" using primary key columns */
  videoAnalysisReviewStatusesByPk?: Maybe<VideoAnalysisReviewStatuses>;
  /** fetch data from the table in a streaming manner: "video_analysis_review_statuses" */
  videoAnalysisReviewStatusesStream: Array<VideoAnalysisReviewStatuses>;
  /** An array relationship */
  videoAnalysisSkillsComments: Array<VideoAnalysisSkillsComments>;
  /** An aggregate relationship */
  videoAnalysisSkillsCommentsAggregate: VideoAnalysisSkillsCommentsAggregate;
  /** fetch data from the table: "video_analysis_skills_comments" using primary key columns */
  videoAnalysisSkillsCommentsByPk?: Maybe<VideoAnalysisSkillsComments>;
  /** fetch data from the table in a streaming manner: "video_analysis_skills_comments" */
  videoAnalysisSkillsCommentsStream: Array<VideoAnalysisSkillsComments>;
  /** fetch data from the table in a streaming manner: "video_analysis" */
  videoAnalysisStream: Array<VideoAnalysis>;
  /** fetch data from the table: "video_analysis_submission_log" */
  videoAnalysisSubmissionLog: Array<VideoAnalysisSubmissionLog>;
  /** fetch aggregated fields from the table: "video_analysis_submission_log" */
  videoAnalysisSubmissionLogAggregate: VideoAnalysisSubmissionLogAggregate;
  /** fetch data from the table: "video_analysis_submission_log" using primary key columns */
  videoAnalysisSubmissionLogByPk?: Maybe<VideoAnalysisSubmissionLog>;
  /** fetch data from the table in a streaming manner: "video_analysis_submission_log" */
  videoAnalysisSubmissionLogStream: Array<VideoAnalysisSubmissionLog>;
  /** fetch data from the table: "video_lesson_skills" */
  videoLessonSkills: Array<VideoLessonSkills>;
  /** fetch aggregated fields from the table: "video_lesson_skills" */
  videoLessonSkillsAggregate: VideoLessonSkillsAggregate;
  /** fetch data from the table: "video_lesson_skills" using primary key columns */
  videoLessonSkillsByPk?: Maybe<VideoLessonSkills>;
  /** fetch data from the table in a streaming manner: "video_lesson_skills" */
  videoLessonSkillsStream: Array<VideoLessonSkills>;
  /** fetch data from the table: "welcome_email_configuration" */
  welcomeEmailConfiguration: Array<WelcomeEmailConfiguration>;
  /** fetch aggregated fields from the table: "welcome_email_configuration" */
  welcomeEmailConfigurationAggregate: WelcomeEmailConfigurationAggregate;
  /** fetch data from the table: "welcome_email_configuration" using primary key columns */
  welcomeEmailConfigurationByPk?: Maybe<WelcomeEmailConfiguration>;
  /** fetch data from the table in a streaming manner: "welcome_email_configuration" */
  welcomeEmailConfigurationStream: Array<WelcomeEmailConfiguration>;
  /** fetch data from the table: "win_reasons" */
  winReasons: Array<WinReasons>;
  /** fetch aggregated fields from the table: "win_reasons" */
  winReasonsAggregate: WinReasonsAggregate;
  /** fetch data from the table: "win_reasons" using primary key columns */
  winReasonsByPk?: Maybe<WinReasons>;
  /** fetch data from the table in a streaming manner: "win_reasons" */
  winReasonsStream: Array<WinReasons>;
};


export type Subscription_RootAmenitiesArgs = {
  distinctOn?: InputMaybe<Array<AmenitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AmenitiesOrderBy>>;
  where?: InputMaybe<AmenitiesBoolExp>;
};


export type Subscription_RootAmenitiesAggregateArgs = {
  distinctOn?: InputMaybe<Array<AmenitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AmenitiesOrderBy>>;
  where?: InputMaybe<AmenitiesBoolExp>;
};


export type Subscription_RootAmenitiesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootAmenitiesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<AmenitiesStreamCursorInput>>;
  where?: InputMaybe<AmenitiesBoolExp>;
};


export type Subscription_RootAppPersonasArgs = {
  distinctOn?: InputMaybe<Array<AppPersonasSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AppPersonasOrderBy>>;
  where?: InputMaybe<AppPersonasBoolExp>;
};


export type Subscription_RootAppPersonasAggregateArgs = {
  distinctOn?: InputMaybe<Array<AppPersonasSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AppPersonasOrderBy>>;
  where?: InputMaybe<AppPersonasBoolExp>;
};


export type Subscription_RootAppPersonasByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootAppPersonasStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<AppPersonasStreamCursorInput>>;
  where?: InputMaybe<AppPersonasBoolExp>;
};


export type Subscription_RootAppPingsArgs = {
  distinctOn?: InputMaybe<Array<AppPingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AppPingsOrderBy>>;
  where?: InputMaybe<AppPingsBoolExp>;
};


export type Subscription_RootAppPingsAggregateArgs = {
  distinctOn?: InputMaybe<Array<AppPingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AppPingsOrderBy>>;
  where?: InputMaybe<AppPingsBoolExp>;
};


export type Subscription_RootAppPingsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootAppPingsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<AppPingsStreamCursorInput>>;
  where?: InputMaybe<AppPingsBoolExp>;
};


export type Subscription_RootBallTypesArgs = {
  distinctOn?: InputMaybe<Array<BallTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BallTypesOrderBy>>;
  where?: InputMaybe<BallTypesBoolExp>;
};


export type Subscription_RootBallTypesAggregateArgs = {
  distinctOn?: InputMaybe<Array<BallTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BallTypesOrderBy>>;
  where?: InputMaybe<BallTypesBoolExp>;
};


export type Subscription_RootBallTypesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootBallTypesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<BallTypesStreamCursorInput>>;
  where?: InputMaybe<BallTypesBoolExp>;
};


export type Subscription_RootBirthdayVisibilityArgs = {
  distinctOn?: InputMaybe<Array<BirthdayVisibilitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BirthdayVisibilityOrderBy>>;
  where?: InputMaybe<BirthdayVisibilityBoolExp>;
};


export type Subscription_RootBirthdayVisibilityAggregateArgs = {
  distinctOn?: InputMaybe<Array<BirthdayVisibilitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BirthdayVisibilityOrderBy>>;
  where?: InputMaybe<BirthdayVisibilityBoolExp>;
};


export type Subscription_RootBirthdayVisibilityByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootBirthdayVisibilityStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<BirthdayVisibilityStreamCursorInput>>;
  where?: InputMaybe<BirthdayVisibilityBoolExp>;
};


export type Subscription_RootBookingConfigChangeTypesArgs = {
  distinctOn?: InputMaybe<Array<BookingConfigChangeTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BookingConfigChangeTypesOrderBy>>;
  where?: InputMaybe<BookingConfigChangeTypesBoolExp>;
};


export type Subscription_RootBookingConfigChangeTypesAggregateArgs = {
  distinctOn?: InputMaybe<Array<BookingConfigChangeTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BookingConfigChangeTypesOrderBy>>;
  where?: InputMaybe<BookingConfigChangeTypesBoolExp>;
};


export type Subscription_RootBookingConfigChangeTypesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootBookingConfigChangeTypesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<BookingConfigChangeTypesStreamCursorInput>>;
  where?: InputMaybe<BookingConfigChangeTypesBoolExp>;
};


export type Subscription_RootBookingConnectionStatusesArgs = {
  distinctOn?: InputMaybe<Array<BookingConnectionStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BookingConnectionStatusesOrderBy>>;
  where?: InputMaybe<BookingConnectionStatusesBoolExp>;
};


export type Subscription_RootBookingConnectionStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<BookingConnectionStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BookingConnectionStatusesOrderBy>>;
  where?: InputMaybe<BookingConnectionStatusesBoolExp>;
};


export type Subscription_RootBookingConnectionStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootBookingConnectionStatusesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<BookingConnectionStatusesStreamCursorInput>>;
  where?: InputMaybe<BookingConnectionStatusesBoolExp>;
};


export type Subscription_RootBookingIntegrationStatusesArgs = {
  distinctOn?: InputMaybe<Array<BookingIntegrationStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BookingIntegrationStatusesOrderBy>>;
  where?: InputMaybe<BookingIntegrationStatusesBoolExp>;
};


export type Subscription_RootBookingIntegrationStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<BookingIntegrationStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BookingIntegrationStatusesOrderBy>>;
  where?: InputMaybe<BookingIntegrationStatusesBoolExp>;
};


export type Subscription_RootBookingIntegrationStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootBookingIntegrationStatusesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<BookingIntegrationStatusesStreamCursorInput>>;
  where?: InputMaybe<BookingIntegrationStatusesBoolExp>;
};


export type Subscription_RootBookingInventoryTypesArgs = {
  distinctOn?: InputMaybe<Array<BookingInventoryTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BookingInventoryTypesOrderBy>>;
  where?: InputMaybe<BookingInventoryTypesBoolExp>;
};


export type Subscription_RootBookingInventoryTypesAggregateArgs = {
  distinctOn?: InputMaybe<Array<BookingInventoryTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BookingInventoryTypesOrderBy>>;
  where?: InputMaybe<BookingInventoryTypesBoolExp>;
};


export type Subscription_RootBookingInventoryTypesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootBookingInventoryTypesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<BookingInventoryTypesStreamCursorInput>>;
  where?: InputMaybe<BookingInventoryTypesBoolExp>;
};


export type Subscription_RootBookingScheduleModesArgs = {
  distinctOn?: InputMaybe<Array<BookingScheduleModesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BookingScheduleModesOrderBy>>;
  where?: InputMaybe<BookingScheduleModesBoolExp>;
};


export type Subscription_RootBookingScheduleModesAggregateArgs = {
  distinctOn?: InputMaybe<Array<BookingScheduleModesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BookingScheduleModesOrderBy>>;
  where?: InputMaybe<BookingScheduleModesBoolExp>;
};


export type Subscription_RootBookingScheduleModesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootBookingScheduleModesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<BookingScheduleModesStreamCursorInput>>;
  where?: InputMaybe<BookingScheduleModesBoolExp>;
};


export type Subscription_RootBookingSystemsArgs = {
  distinctOn?: InputMaybe<Array<BookingSystemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BookingSystemsOrderBy>>;
  where?: InputMaybe<BookingSystemsBoolExp>;
};


export type Subscription_RootBookingSystemsAggregateArgs = {
  distinctOn?: InputMaybe<Array<BookingSystemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BookingSystemsOrderBy>>;
  where?: InputMaybe<BookingSystemsBoolExp>;
};


export type Subscription_RootBookingSystemsByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootBookingSystemsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<BookingSystemsStreamCursorInput>>;
  where?: InputMaybe<BookingSystemsBoolExp>;
};


export type Subscription_RootBookingWindowKindsArgs = {
  distinctOn?: InputMaybe<Array<BookingWindowKindsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BookingWindowKindsOrderBy>>;
  where?: InputMaybe<BookingWindowKindsBoolExp>;
};


export type Subscription_RootBookingWindowKindsAggregateArgs = {
  distinctOn?: InputMaybe<Array<BookingWindowKindsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BookingWindowKindsOrderBy>>;
  where?: InputMaybe<BookingWindowKindsBoolExp>;
};


export type Subscription_RootBookingWindowKindsByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootBookingWindowKindsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<BookingWindowKindsStreamCursorInput>>;
  where?: InputMaybe<BookingWindowKindsBoolExp>;
};


export type Subscription_RootBoostChannelsArgs = {
  distinctOn?: InputMaybe<Array<BoostChannelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BoostChannelsOrderBy>>;
  where?: InputMaybe<BoostChannelsBoolExp>;
};


export type Subscription_RootBoostChannelsAggregateArgs = {
  distinctOn?: InputMaybe<Array<BoostChannelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BoostChannelsOrderBy>>;
  where?: InputMaybe<BoostChannelsBoolExp>;
};


export type Subscription_RootBoostChannelsByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootBoostChannelsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<BoostChannelsStreamCursorInput>>;
  where?: InputMaybe<BoostChannelsBoolExp>;
};


export type Subscription_RootBoostOrdersArgs = {
  distinctOn?: InputMaybe<Array<BoostOrdersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BoostOrdersOrderBy>>;
  where?: InputMaybe<BoostOrdersBoolExp>;
};


export type Subscription_RootBoostOrdersAggregateArgs = {
  distinctOn?: InputMaybe<Array<BoostOrdersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BoostOrdersOrderBy>>;
  where?: InputMaybe<BoostOrdersBoolExp>;
};


export type Subscription_RootBoostOrdersByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootBoostOrdersStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<BoostOrdersStreamCursorInput>>;
  where?: InputMaybe<BoostOrdersBoolExp>;
};


export type Subscription_RootBoostStatusesArgs = {
  distinctOn?: InputMaybe<Array<BoostStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BoostStatusesOrderBy>>;
  where?: InputMaybe<BoostStatusesBoolExp>;
};


export type Subscription_RootBoostStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<BoostStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BoostStatusesOrderBy>>;
  where?: InputMaybe<BoostStatusesBoolExp>;
};


export type Subscription_RootBoostStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootBoostStatusesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<BoostStatusesStreamCursorInput>>;
  where?: InputMaybe<BoostStatusesBoolExp>;
};


export type Subscription_RootBoostsArgs = {
  distinctOn?: InputMaybe<Array<BoostsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BoostsOrderBy>>;
  where?: InputMaybe<BoostsBoolExp>;
};


export type Subscription_RootBoostsAggregateArgs = {
  distinctOn?: InputMaybe<Array<BoostsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BoostsOrderBy>>;
  where?: InputMaybe<BoostsBoolExp>;
};


export type Subscription_RootBoostsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootBoostsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<BoostsStreamCursorInput>>;
  where?: InputMaybe<BoostsBoolExp>;
};


export type Subscription_RootBracketRankingMechanismArgs = {
  distinctOn?: InputMaybe<Array<BracketRankingMechanismSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BracketRankingMechanismOrderBy>>;
  where?: InputMaybe<BracketRankingMechanismBoolExp>;
};


export type Subscription_RootBracketRankingMechanismAggregateArgs = {
  distinctOn?: InputMaybe<Array<BracketRankingMechanismSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BracketRankingMechanismOrderBy>>;
  where?: InputMaybe<BracketRankingMechanismBoolExp>;
};


export type Subscription_RootBracketRankingMechanismByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootBracketRankingMechanismStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<BracketRankingMechanismStreamCursorInput>>;
  where?: InputMaybe<BracketRankingMechanismBoolExp>;
};


export type Subscription_RootCalendarAccountsArgs = {
  distinctOn?: InputMaybe<Array<CalendarAccountsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CalendarAccountsOrderBy>>;
  where?: InputMaybe<CalendarAccountsBoolExp>;
};


export type Subscription_RootCalendarAccountsAggregateArgs = {
  distinctOn?: InputMaybe<Array<CalendarAccountsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CalendarAccountsOrderBy>>;
  where?: InputMaybe<CalendarAccountsBoolExp>;
};


export type Subscription_RootCalendarAccountsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCalendarAccountsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<CalendarAccountsStreamCursorInput>>;
  where?: InputMaybe<CalendarAccountsBoolExp>;
};


export type Subscription_RootCalendarAuthProviderArgs = {
  distinctOn?: InputMaybe<Array<CalendarAuthProviderSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CalendarAuthProviderOrderBy>>;
  where?: InputMaybe<CalendarAuthProviderBoolExp>;
};


export type Subscription_RootCalendarAuthProviderAggregateArgs = {
  distinctOn?: InputMaybe<Array<CalendarAuthProviderSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CalendarAuthProviderOrderBy>>;
  where?: InputMaybe<CalendarAuthProviderBoolExp>;
};


export type Subscription_RootCalendarAuthProviderByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootCalendarAuthProviderStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<CalendarAuthProviderStreamCursorInput>>;
  where?: InputMaybe<CalendarAuthProviderBoolExp>;
};


export type Subscription_RootCalendarEventMappingsArgs = {
  distinctOn?: InputMaybe<Array<CalendarEventMappingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CalendarEventMappingsOrderBy>>;
  where?: InputMaybe<CalendarEventMappingsBoolExp>;
};


export type Subscription_RootCalendarEventMappingsAggregateArgs = {
  distinctOn?: InputMaybe<Array<CalendarEventMappingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CalendarEventMappingsOrderBy>>;
  where?: InputMaybe<CalendarEventMappingsBoolExp>;
};


export type Subscription_RootCalendarEventMappingsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCalendarEventMappingsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<CalendarEventMappingsStreamCursorInput>>;
  where?: InputMaybe<CalendarEventMappingsBoolExp>;
};


export type Subscription_RootCalendarPreferencesArgs = {
  distinctOn?: InputMaybe<Array<CalendarPreferencesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CalendarPreferencesOrderBy>>;
  where?: InputMaybe<CalendarPreferencesBoolExp>;
};


export type Subscription_RootCalendarPreferencesAggregateArgs = {
  distinctOn?: InputMaybe<Array<CalendarPreferencesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CalendarPreferencesOrderBy>>;
  where?: InputMaybe<CalendarPreferencesBoolExp>;
};


export type Subscription_RootCalendarPreferencesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCalendarPreferencesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<CalendarPreferencesStreamCursorInput>>;
  where?: InputMaybe<CalendarPreferencesBoolExp>;
};


export type Subscription_RootCitiesArgs = {
  distinctOn?: InputMaybe<Array<CitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CitiesOrderBy>>;
  where?: InputMaybe<CitiesBoolExp>;
};


export type Subscription_RootCitiesAggregateArgs = {
  distinctOn?: InputMaybe<Array<CitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CitiesOrderBy>>;
  where?: InputMaybe<CitiesBoolExp>;
};


export type Subscription_RootCitiesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCitiesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<CitiesStreamCursorInput>>;
  where?: InputMaybe<CitiesBoolExp>;
};


export type Subscription_RootCoachAvailabilityArgs = {
  distinctOn?: InputMaybe<Array<CoachAvailabilitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachAvailabilityOrderBy>>;
  where?: InputMaybe<CoachAvailabilityBoolExp>;
};


export type Subscription_RootCoachAvailabilityAggregateArgs = {
  distinctOn?: InputMaybe<Array<CoachAvailabilitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachAvailabilityOrderBy>>;
  where?: InputMaybe<CoachAvailabilityBoolExp>;
};


export type Subscription_RootCoachAvailabilityByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCoachAvailabilityStatusesArgs = {
  distinctOn?: InputMaybe<Array<CoachAvailabilityStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachAvailabilityStatusesOrderBy>>;
  where?: InputMaybe<CoachAvailabilityStatusesBoolExp>;
};


export type Subscription_RootCoachAvailabilityStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<CoachAvailabilityStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachAvailabilityStatusesOrderBy>>;
  where?: InputMaybe<CoachAvailabilityStatusesBoolExp>;
};


export type Subscription_RootCoachAvailabilityStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootCoachAvailabilityStatusesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<CoachAvailabilityStatusesStreamCursorInput>>;
  where?: InputMaybe<CoachAvailabilityStatusesBoolExp>;
};


export type Subscription_RootCoachAvailabilityStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<CoachAvailabilityStreamCursorInput>>;
  where?: InputMaybe<CoachAvailabilityBoolExp>;
};


export type Subscription_RootCoachBookingRequestsArgs = {
  distinctOn?: InputMaybe<Array<CoachBookingRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachBookingRequestsOrderBy>>;
  where?: InputMaybe<CoachBookingRequestsBoolExp>;
};


export type Subscription_RootCoachBookingRequestsAggregateArgs = {
  distinctOn?: InputMaybe<Array<CoachBookingRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachBookingRequestsOrderBy>>;
  where?: InputMaybe<CoachBookingRequestsBoolExp>;
};


export type Subscription_RootCoachBookingRequestsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCoachBookingRequestsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<CoachBookingRequestsStreamCursorInput>>;
  where?: InputMaybe<CoachBookingRequestsBoolExp>;
};


export type Subscription_RootCoachExternalReviewSourcesArgs = {
  distinctOn?: InputMaybe<Array<CoachExternalReviewSourcesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachExternalReviewSourcesOrderBy>>;
  where?: InputMaybe<CoachExternalReviewSourcesBoolExp>;
};


export type Subscription_RootCoachExternalReviewSourcesAggregateArgs = {
  distinctOn?: InputMaybe<Array<CoachExternalReviewSourcesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachExternalReviewSourcesOrderBy>>;
  where?: InputMaybe<CoachExternalReviewSourcesBoolExp>;
};


export type Subscription_RootCoachExternalReviewSourcesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootCoachExternalReviewSourcesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<CoachExternalReviewSourcesStreamCursorInput>>;
  where?: InputMaybe<CoachExternalReviewSourcesBoolExp>;
};


export type Subscription_RootCoachFaqsArgs = {
  distinctOn?: InputMaybe<Array<CoachFaqsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachFaqsOrderBy>>;
  where?: InputMaybe<CoachFaqsBoolExp>;
};


export type Subscription_RootCoachFaqsAggregateArgs = {
  distinctOn?: InputMaybe<Array<CoachFaqsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachFaqsOrderBy>>;
  where?: InputMaybe<CoachFaqsBoolExp>;
};


export type Subscription_RootCoachFaqsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCoachFaqsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<CoachFaqsStreamCursorInput>>;
  where?: InputMaybe<CoachFaqsBoolExp>;
};


export type Subscription_RootCoachLessonAgeGroupsArgs = {
  distinctOn?: InputMaybe<Array<CoachLessonAgeGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachLessonAgeGroupsOrderBy>>;
  where?: InputMaybe<CoachLessonAgeGroupsBoolExp>;
};


export type Subscription_RootCoachLessonAgeGroupsAggregateArgs = {
  distinctOn?: InputMaybe<Array<CoachLessonAgeGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachLessonAgeGroupsOrderBy>>;
  where?: InputMaybe<CoachLessonAgeGroupsBoolExp>;
};


export type Subscription_RootCoachLessonAgeGroupsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCoachLessonAgeGroupsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<CoachLessonAgeGroupsStreamCursorInput>>;
  where?: InputMaybe<CoachLessonAgeGroupsBoolExp>;
};


export type Subscription_RootCoachLessonSkillLevelsArgs = {
  distinctOn?: InputMaybe<Array<CoachLessonSkillLevelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachLessonSkillLevelsOrderBy>>;
  where?: InputMaybe<CoachLessonSkillLevelsBoolExp>;
};


export type Subscription_RootCoachLessonSkillLevelsAggregateArgs = {
  distinctOn?: InputMaybe<Array<CoachLessonSkillLevelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachLessonSkillLevelsOrderBy>>;
  where?: InputMaybe<CoachLessonSkillLevelsBoolExp>;
};


export type Subscription_RootCoachLessonSkillLevelsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCoachLessonSkillLevelsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<CoachLessonSkillLevelsStreamCursorInput>>;
  where?: InputMaybe<CoachLessonSkillLevelsBoolExp>;
};


export type Subscription_RootCoachQualificationGroupsArgs = {
  distinctOn?: InputMaybe<Array<CoachQualificationGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachQualificationGroupsOrderBy>>;
  where?: InputMaybe<CoachQualificationGroupsBoolExp>;
};


export type Subscription_RootCoachQualificationGroupsAggregateArgs = {
  distinctOn?: InputMaybe<Array<CoachQualificationGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachQualificationGroupsOrderBy>>;
  where?: InputMaybe<CoachQualificationGroupsBoolExp>;
};


export type Subscription_RootCoachQualificationGroupsByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootCoachQualificationGroupsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<CoachQualificationGroupsStreamCursorInput>>;
  where?: InputMaybe<CoachQualificationGroupsBoolExp>;
};


export type Subscription_RootCoachQualificationStatusesArgs = {
  distinctOn?: InputMaybe<Array<CoachQualificationStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachQualificationStatusesOrderBy>>;
  where?: InputMaybe<CoachQualificationStatusesBoolExp>;
};


export type Subscription_RootCoachQualificationStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<CoachQualificationStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachQualificationStatusesOrderBy>>;
  where?: InputMaybe<CoachQualificationStatusesBoolExp>;
};


export type Subscription_RootCoachQualificationStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootCoachQualificationStatusesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<CoachQualificationStatusesStreamCursorInput>>;
  where?: InputMaybe<CoachQualificationStatusesBoolExp>;
};


export type Subscription_RootCoachQualificationsArgs = {
  distinctOn?: InputMaybe<Array<CoachQualificationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachQualificationsOrderBy>>;
  where?: InputMaybe<CoachQualificationsBoolExp>;
};


export type Subscription_RootCoachQualificationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<CoachQualificationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachQualificationsOrderBy>>;
  where?: InputMaybe<CoachQualificationsBoolExp>;
};


export type Subscription_RootCoachQualificationsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCoachQualificationsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<CoachQualificationsStreamCursorInput>>;
  where?: InputMaybe<CoachQualificationsBoolExp>;
};


export type Subscription_RootCoachReviewTypesArgs = {
  distinctOn?: InputMaybe<Array<CoachReviewTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachReviewTypesOrderBy>>;
  where?: InputMaybe<CoachReviewTypesBoolExp>;
};


export type Subscription_RootCoachReviewTypesAggregateArgs = {
  distinctOn?: InputMaybe<Array<CoachReviewTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachReviewTypesOrderBy>>;
  where?: InputMaybe<CoachReviewTypesBoolExp>;
};


export type Subscription_RootCoachReviewTypesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootCoachReviewTypesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<CoachReviewTypesStreamCursorInput>>;
  where?: InputMaybe<CoachReviewTypesBoolExp>;
};


export type Subscription_RootCoachSportStatusesArgs = {
  distinctOn?: InputMaybe<Array<CoachSportStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachSportStatusesOrderBy>>;
  where?: InputMaybe<CoachSportStatusesBoolExp>;
};


export type Subscription_RootCoachSportStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<CoachSportStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachSportStatusesOrderBy>>;
  where?: InputMaybe<CoachSportStatusesBoolExp>;
};


export type Subscription_RootCoachSportStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootCoachSportStatusesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<CoachSportStatusesStreamCursorInput>>;
  where?: InputMaybe<CoachSportStatusesBoolExp>;
};


export type Subscription_RootCoachSportsArgs = {
  distinctOn?: InputMaybe<Array<CoachSportsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachSportsOrderBy>>;
  where?: InputMaybe<CoachSportsBoolExp>;
};


export type Subscription_RootCoachSportsAggregateArgs = {
  distinctOn?: InputMaybe<Array<CoachSportsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachSportsOrderBy>>;
  where?: InputMaybe<CoachSportsBoolExp>;
};


export type Subscription_RootCoachSportsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCoachSportsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<CoachSportsStreamCursorInput>>;
  where?: InputMaybe<CoachSportsBoolExp>;
};


export type Subscription_RootCoachStarterProfilesArgs = {
  distinctOn?: InputMaybe<Array<CoachStarterProfilesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachStarterProfilesOrderBy>>;
  where?: InputMaybe<CoachStarterProfilesBoolExp>;
};


export type Subscription_RootCoachStarterProfilesAggregateArgs = {
  distinctOn?: InputMaybe<Array<CoachStarterProfilesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachStarterProfilesOrderBy>>;
  where?: InputMaybe<CoachStarterProfilesBoolExp>;
};


export type Subscription_RootCoachStarterProfilesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCoachStarterProfilesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<CoachStarterProfilesStreamCursorInput>>;
  where?: InputMaybe<CoachStarterProfilesBoolExp>;
};


export type Subscription_RootCoachStatusArgs = {
  distinctOn?: InputMaybe<Array<CoachStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachStatusOrderBy>>;
  where?: InputMaybe<CoachStatusBoolExp>;
};


export type Subscription_RootCoachStatusAggregateArgs = {
  distinctOn?: InputMaybe<Array<CoachStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachStatusOrderBy>>;
  where?: InputMaybe<CoachStatusBoolExp>;
};


export type Subscription_RootCoachStatusByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootCoachStatusStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<CoachStatusStreamCursorInput>>;
  where?: InputMaybe<CoachStatusBoolExp>;
};


export type Subscription_RootCoachTipsArgs = {
  distinctOn?: InputMaybe<Array<CoachTipsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachTipsOrderBy>>;
  where?: InputMaybe<CoachTipsBoolExp>;
};


export type Subscription_RootCoachTipsAggregateArgs = {
  distinctOn?: InputMaybe<Array<CoachTipsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachTipsOrderBy>>;
  where?: InputMaybe<CoachTipsBoolExp>;
};


export type Subscription_RootCoachTipsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCoachTipsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<CoachTipsStreamCursorInput>>;
  where?: InputMaybe<CoachTipsBoolExp>;
};


export type Subscription_RootCommentVoteArgs = {
  distinctOn?: InputMaybe<Array<CommentVoteSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CommentVoteOrderBy>>;
  where?: InputMaybe<CommentVoteBoolExp>;
};


export type Subscription_RootCommentVoteAggregateArgs = {
  distinctOn?: InputMaybe<Array<CommentVoteSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CommentVoteOrderBy>>;
  where?: InputMaybe<CommentVoteBoolExp>;
};


export type Subscription_RootCommentVoteByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootCommentVoteStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<CommentVoteStreamCursorInput>>;
  where?: InputMaybe<CommentVoteBoolExp>;
};


export type Subscription_RootCommunicationPreferenceStatusesArgs = {
  distinctOn?: InputMaybe<Array<CommunicationPreferenceStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CommunicationPreferenceStatusesOrderBy>>;
  where?: InputMaybe<CommunicationPreferenceStatusesBoolExp>;
};


export type Subscription_RootCommunicationPreferenceStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<CommunicationPreferenceStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CommunicationPreferenceStatusesOrderBy>>;
  where?: InputMaybe<CommunicationPreferenceStatusesBoolExp>;
};


export type Subscription_RootCommunicationPreferenceStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootCommunicationPreferenceStatusesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<CommunicationPreferenceStatusesStreamCursorInput>>;
  where?: InputMaybe<CommunicationPreferenceStatusesBoolExp>;
};


export type Subscription_RootCompetitionFormatsArgs = {
  distinctOn?: InputMaybe<Array<CompetitionFormatsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompetitionFormatsOrderBy>>;
  where?: InputMaybe<CompetitionFormatsBoolExp>;
};


export type Subscription_RootCompetitionFormatsAggregateArgs = {
  distinctOn?: InputMaybe<Array<CompetitionFormatsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompetitionFormatsOrderBy>>;
  where?: InputMaybe<CompetitionFormatsBoolExp>;
};


export type Subscription_RootCompetitionFormatsByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootCompetitionFormatsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<CompetitionFormatsStreamCursorInput>>;
  where?: InputMaybe<CompetitionFormatsBoolExp>;
};


export type Subscription_RootCompetitionGenderArgs = {
  distinctOn?: InputMaybe<Array<CompetitionGenderSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompetitionGenderOrderBy>>;
  where?: InputMaybe<CompetitionGenderBoolExp>;
};


export type Subscription_RootCompetitionGenderAggregateArgs = {
  distinctOn?: InputMaybe<Array<CompetitionGenderSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompetitionGenderOrderBy>>;
  where?: InputMaybe<CompetitionGenderBoolExp>;
};


export type Subscription_RootCompetitionGenderByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootCompetitionGenderStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<CompetitionGenderStreamCursorInput>>;
  where?: InputMaybe<CompetitionGenderBoolExp>;
};


export type Subscription_RootContentReportsArgs = {
  distinctOn?: InputMaybe<Array<ContentReportsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContentReportsOrderBy>>;
  where?: InputMaybe<ContentReportsBoolExp>;
};


export type Subscription_RootContentReportsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ContentReportsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContentReportsOrderBy>>;
  where?: InputMaybe<ContentReportsBoolExp>;
};


export type Subscription_RootContentReportsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootContentReportsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<ContentReportsStreamCursorInput>>;
  where?: InputMaybe<ContentReportsBoolExp>;
};


export type Subscription_RootConversationParticipantsArgs = {
  distinctOn?: InputMaybe<Array<ConversationParticipantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ConversationParticipantsOrderBy>>;
  where?: InputMaybe<ConversationParticipantsBoolExp>;
};


export type Subscription_RootConversationParticipantsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ConversationParticipantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ConversationParticipantsOrderBy>>;
  where?: InputMaybe<ConversationParticipantsBoolExp>;
};


export type Subscription_RootConversationParticipantsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootConversationParticipantsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<ConversationParticipantsStreamCursorInput>>;
  where?: InputMaybe<ConversationParticipantsBoolExp>;
};


export type Subscription_RootConversationTypesArgs = {
  distinctOn?: InputMaybe<Array<ConversationTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ConversationTypesOrderBy>>;
  where?: InputMaybe<ConversationTypesBoolExp>;
};


export type Subscription_RootConversationTypesAggregateArgs = {
  distinctOn?: InputMaybe<Array<ConversationTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ConversationTypesOrderBy>>;
  where?: InputMaybe<ConversationTypesBoolExp>;
};


export type Subscription_RootConversationTypesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootConversationTypesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<ConversationTypesStreamCursorInput>>;
  where?: InputMaybe<ConversationTypesBoolExp>;
};


export type Subscription_RootConversationsArgs = {
  distinctOn?: InputMaybe<Array<ConversationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ConversationsOrderBy>>;
  where?: InputMaybe<ConversationsBoolExp>;
};


export type Subscription_RootConversationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ConversationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ConversationsOrderBy>>;
  where?: InputMaybe<ConversationsBoolExp>;
};


export type Subscription_RootConversationsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootConversationsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<ConversationsStreamCursorInput>>;
  where?: InputMaybe<ConversationsBoolExp>;
};


export type Subscription_RootCountriesArgs = {
  distinctOn?: InputMaybe<Array<CountriesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CountriesOrderBy>>;
  where?: InputMaybe<CountriesBoolExp>;
};


export type Subscription_RootCountriesAggregateArgs = {
  distinctOn?: InputMaybe<Array<CountriesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CountriesOrderBy>>;
  where?: InputMaybe<CountriesBoolExp>;
};


export type Subscription_RootCountriesByPkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootCountriesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<CountriesStreamCursorInput>>;
  where?: InputMaybe<CountriesBoolExp>;
};


export type Subscription_RootCountrySubdivisionsArgs = {
  distinctOn?: InputMaybe<Array<CountrySubdivisionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CountrySubdivisionsOrderBy>>;
  where?: InputMaybe<CountrySubdivisionsBoolExp>;
};


export type Subscription_RootCountrySubdivisionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<CountrySubdivisionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CountrySubdivisionsOrderBy>>;
  where?: InputMaybe<CountrySubdivisionsBoolExp>;
};


export type Subscription_RootCountrySubdivisionsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCountrySubdivisionsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<CountrySubdivisionsStreamCursorInput>>;
  where?: InputMaybe<CountrySubdivisionsBoolExp>;
};


export type Subscription_RootCourtSurfacesArgs = {
  distinctOn?: InputMaybe<Array<CourtSurfacesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CourtSurfacesOrderBy>>;
  where?: InputMaybe<CourtSurfacesBoolExp>;
};


export type Subscription_RootCourtSurfacesAggregateArgs = {
  distinctOn?: InputMaybe<Array<CourtSurfacesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CourtSurfacesOrderBy>>;
  where?: InputMaybe<CourtSurfacesBoolExp>;
};


export type Subscription_RootCourtSurfacesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootCourtSurfacesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<CourtSurfacesStreamCursorInput>>;
  where?: InputMaybe<CourtSurfacesBoolExp>;
};


export type Subscription_RootDayOfWeekArgs = {
  distinctOn?: InputMaybe<Array<DayOfWeekSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DayOfWeekOrderBy>>;
  where?: InputMaybe<DayOfWeekBoolExp>;
};


export type Subscription_RootDayOfWeekAggregateArgs = {
  distinctOn?: InputMaybe<Array<DayOfWeekSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DayOfWeekOrderBy>>;
  where?: InputMaybe<DayOfWeekBoolExp>;
};


export type Subscription_RootDayOfWeekByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootDayOfWeekStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<DayOfWeekStreamCursorInput>>;
  where?: InputMaybe<DayOfWeekBoolExp>;
};


export type Subscription_RootEngagementAnalyticsArgs = {
  distinctOn?: InputMaybe<Array<EngagementAnalyticsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EngagementAnalyticsOrderBy>>;
  where?: InputMaybe<EngagementAnalyticsBoolExp>;
};


export type Subscription_RootEngagementAnalyticsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EngagementAnalyticsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EngagementAnalyticsOrderBy>>;
  where?: InputMaybe<EngagementAnalyticsBoolExp>;
};


export type Subscription_RootEngagementAnalyticsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEngagementAnalyticsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EngagementAnalyticsStreamCursorInput>>;
  where?: InputMaybe<EngagementAnalyticsBoolExp>;
};


export type Subscription_RootEngagementEntityTypesArgs = {
  distinctOn?: InputMaybe<Array<EngagementEntityTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EngagementEntityTypesOrderBy>>;
  where?: InputMaybe<EngagementEntityTypesBoolExp>;
};


export type Subscription_RootEngagementEntityTypesAggregateArgs = {
  distinctOn?: InputMaybe<Array<EngagementEntityTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EngagementEntityTypesOrderBy>>;
  where?: InputMaybe<EngagementEntityTypesBoolExp>;
};


export type Subscription_RootEngagementEntityTypesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootEngagementEntityTypesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EngagementEntityTypesStreamCursorInput>>;
  where?: InputMaybe<EngagementEntityTypesBoolExp>;
};


export type Subscription_RootEngagementEventTypesArgs = {
  distinctOn?: InputMaybe<Array<EngagementEventTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EngagementEventTypesOrderBy>>;
  where?: InputMaybe<EngagementEventTypesBoolExp>;
};


export type Subscription_RootEngagementEventTypesAggregateArgs = {
  distinctOn?: InputMaybe<Array<EngagementEventTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EngagementEventTypesOrderBy>>;
  where?: InputMaybe<EngagementEventTypesBoolExp>;
};


export type Subscription_RootEngagementEventTypesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootEngagementEventTypesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EngagementEventTypesStreamCursorInput>>;
  where?: InputMaybe<EngagementEventTypesBoolExp>;
};


export type Subscription_RootEngagementSourcesArgs = {
  distinctOn?: InputMaybe<Array<EngagementSourcesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EngagementSourcesOrderBy>>;
  where?: InputMaybe<EngagementSourcesBoolExp>;
};


export type Subscription_RootEngagementSourcesAggregateArgs = {
  distinctOn?: InputMaybe<Array<EngagementSourcesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EngagementSourcesOrderBy>>;
  where?: InputMaybe<EngagementSourcesBoolExp>;
};


export type Subscription_RootEngagementSourcesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootEngagementSourcesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EngagementSourcesStreamCursorInput>>;
  where?: InputMaybe<EngagementSourcesBoolExp>;
};


export type Subscription_RootEquipmentAvailabilitiesArgs = {
  distinctOn?: InputMaybe<Array<EquipmentAvailabilitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EquipmentAvailabilitiesOrderBy>>;
  where?: InputMaybe<EquipmentAvailabilitiesBoolExp>;
};


export type Subscription_RootEquipmentAvailabilitiesAggregateArgs = {
  distinctOn?: InputMaybe<Array<EquipmentAvailabilitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EquipmentAvailabilitiesOrderBy>>;
  where?: InputMaybe<EquipmentAvailabilitiesBoolExp>;
};


export type Subscription_RootEquipmentAvailabilitiesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootEquipmentAvailabilitiesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EquipmentAvailabilitiesStreamCursorInput>>;
  where?: InputMaybe<EquipmentAvailabilitiesBoolExp>;
};


export type Subscription_RootEventAcceptedPlayRequestsArgs = {
  distinctOn?: InputMaybe<Array<EventAcceptedPlayRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventAcceptedPlayRequestsOrderBy>>;
  where?: InputMaybe<EventAcceptedPlayRequestsBoolExp>;
};


export type Subscription_RootEventAcceptedPlayRequestsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventAcceptedPlayRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventAcceptedPlayRequestsOrderBy>>;
  where?: InputMaybe<EventAcceptedPlayRequestsBoolExp>;
};


export type Subscription_RootEventAcceptedPlayRequestsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventAcceptedPlayRequestsStreamCursorInput>>;
  where?: InputMaybe<EventAcceptedPlayRequestsBoolExp>;
};


export type Subscription_RootEventAgeGroupsArgs = {
  distinctOn?: InputMaybe<Array<EventAgeGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventAgeGroupsOrderBy>>;
  where?: InputMaybe<EventAgeGroupsBoolExp>;
};


export type Subscription_RootEventAgeGroupsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventAgeGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventAgeGroupsOrderBy>>;
  where?: InputMaybe<EventAgeGroupsBoolExp>;
};


export type Subscription_RootEventAgeGroupsByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootEventAgeGroupsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventAgeGroupsStreamCursorInput>>;
  where?: InputMaybe<EventAgeGroupsBoolExp>;
};


export type Subscription_RootEventCollectionsArgs = {
  distinctOn?: InputMaybe<Array<EventCollectionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventCollectionsOrderBy>>;
  where?: InputMaybe<EventCollectionsBoolExp>;
};


export type Subscription_RootEventCollectionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventCollectionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventCollectionsOrderBy>>;
  where?: InputMaybe<EventCollectionsBoolExp>;
};


export type Subscription_RootEventCollectionsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEventCollectionsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventCollectionsStreamCursorInput>>;
  where?: InputMaybe<EventCollectionsBoolExp>;
};


export type Subscription_RootEventCompetitivenessArgs = {
  distinctOn?: InputMaybe<Array<EventCompetitivenessSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventCompetitivenessOrderBy>>;
  where?: InputMaybe<EventCompetitivenessBoolExp>;
};


export type Subscription_RootEventCompetitivenessAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventCompetitivenessSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventCompetitivenessOrderBy>>;
  where?: InputMaybe<EventCompetitivenessBoolExp>;
};


export type Subscription_RootEventCompetitivenessByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootEventCompetitivenessStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventCompetitivenessStreamCursorInput>>;
  where?: InputMaybe<EventCompetitivenessBoolExp>;
};


export type Subscription_RootEventContactDetailsArgs = {
  distinctOn?: InputMaybe<Array<EventContactDetailsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventContactDetailsOrderBy>>;
  where?: InputMaybe<EventContactDetailsBoolExp>;
};


export type Subscription_RootEventContactDetailsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventContactDetailsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventContactDetailsOrderBy>>;
  where?: InputMaybe<EventContactDetailsBoolExp>;
};


export type Subscription_RootEventContactDetailsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEventContactDetailsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventContactDetailsStreamCursorInput>>;
  where?: InputMaybe<EventContactDetailsBoolExp>;
};


export type Subscription_RootEventCouponGroupsArgs = {
  distinctOn?: InputMaybe<Array<EventCouponGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventCouponGroupsOrderBy>>;
  where?: InputMaybe<EventCouponGroupsBoolExp>;
};


export type Subscription_RootEventCouponGroupsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventCouponGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventCouponGroupsOrderBy>>;
  where?: InputMaybe<EventCouponGroupsBoolExp>;
};


export type Subscription_RootEventCouponGroupsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEventCouponGroupsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventCouponGroupsStreamCursorInput>>;
  where?: InputMaybe<EventCouponGroupsBoolExp>;
};


export type Subscription_RootEventCouponRedemptionsArgs = {
  distinctOn?: InputMaybe<Array<EventCouponRedemptionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventCouponRedemptionsOrderBy>>;
  where?: InputMaybe<EventCouponRedemptionsBoolExp>;
};


export type Subscription_RootEventCouponRedemptionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventCouponRedemptionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventCouponRedemptionsOrderBy>>;
  where?: InputMaybe<EventCouponRedemptionsBoolExp>;
};


export type Subscription_RootEventCouponRedemptionsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEventCouponRedemptionsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventCouponRedemptionsStreamCursorInput>>;
  where?: InputMaybe<EventCouponRedemptionsBoolExp>;
};


export type Subscription_RootEventCouponSourceArgs = {
  distinctOn?: InputMaybe<Array<EventCouponSourceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventCouponSourceOrderBy>>;
  where?: InputMaybe<EventCouponSourceBoolExp>;
};


export type Subscription_RootEventCouponSourceAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventCouponSourceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventCouponSourceOrderBy>>;
  where?: InputMaybe<EventCouponSourceBoolExp>;
};


export type Subscription_RootEventCouponSourceByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootEventCouponSourceStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventCouponSourceStreamCursorInput>>;
  where?: InputMaybe<EventCouponSourceBoolExp>;
};


export type Subscription_RootEventCouponTypeArgs = {
  distinctOn?: InputMaybe<Array<EventCouponTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventCouponTypeOrderBy>>;
  where?: InputMaybe<EventCouponTypeBoolExp>;
};


export type Subscription_RootEventCouponTypeAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventCouponTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventCouponTypeOrderBy>>;
  where?: InputMaybe<EventCouponTypeBoolExp>;
};


export type Subscription_RootEventCouponTypeByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootEventCouponTypeStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventCouponTypeStreamCursorInput>>;
  where?: InputMaybe<EventCouponTypeBoolExp>;
};


export type Subscription_RootEventCouponsArgs = {
  distinctOn?: InputMaybe<Array<EventCouponsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventCouponsOrderBy>>;
  where?: InputMaybe<EventCouponsBoolExp>;
};


export type Subscription_RootEventCouponsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventCouponsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventCouponsOrderBy>>;
  where?: InputMaybe<EventCouponsBoolExp>;
};


export type Subscription_RootEventCouponsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEventCouponsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventCouponsStreamCursorInput>>;
  where?: InputMaybe<EventCouponsBoolExp>;
};


export type Subscription_RootEventCourtStatusesArgs = {
  distinctOn?: InputMaybe<Array<EventCourtStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventCourtStatusesOrderBy>>;
  where?: InputMaybe<EventCourtStatusesBoolExp>;
};


export type Subscription_RootEventCourtStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventCourtStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventCourtStatusesOrderBy>>;
  where?: InputMaybe<EventCourtStatusesBoolExp>;
};


export type Subscription_RootEventCourtStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootEventCourtStatusesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventCourtStatusesStreamCursorInput>>;
  where?: InputMaybe<EventCourtStatusesBoolExp>;
};


export type Subscription_RootEventCourtsArgs = {
  distinctOn?: InputMaybe<Array<EventCourtsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventCourtsOrderBy>>;
  where?: InputMaybe<EventCourtsBoolExp>;
};


export type Subscription_RootEventCourtsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventCourtsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventCourtsOrderBy>>;
  where?: InputMaybe<EventCourtsBoolExp>;
};


export type Subscription_RootEventCourtsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEventCourtsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventCourtsStreamCursorInput>>;
  where?: InputMaybe<EventCourtsBoolExp>;
};


export type Subscription_RootEventFaqsArgs = {
  distinctOn?: InputMaybe<Array<EventFaqsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventFaqsOrderBy>>;
  where?: InputMaybe<EventFaqsBoolExp>;
};


export type Subscription_RootEventFaqsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventFaqsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventFaqsOrderBy>>;
  where?: InputMaybe<EventFaqsBoolExp>;
};


export type Subscription_RootEventFaqsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEventFaqsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventFaqsStreamCursorInput>>;
  where?: InputMaybe<EventFaqsBoolExp>;
};


export type Subscription_RootEventGameScoresArgs = {
  distinctOn?: InputMaybe<Array<EventGameScoresSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGameScoresOrderBy>>;
  where?: InputMaybe<EventGameScoresBoolExp>;
};


export type Subscription_RootEventGameScoresAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventGameScoresSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGameScoresOrderBy>>;
  where?: InputMaybe<EventGameScoresBoolExp>;
};


export type Subscription_RootEventGameScoresByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEventGameScoresStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventGameScoresStreamCursorInput>>;
  where?: InputMaybe<EventGameScoresBoolExp>;
};


export type Subscription_RootEventGroupFormatsArgs = {
  distinctOn?: InputMaybe<Array<EventGroupFormatsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGroupFormatsOrderBy>>;
  where?: InputMaybe<EventGroupFormatsBoolExp>;
};


export type Subscription_RootEventGroupFormatsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventGroupFormatsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGroupFormatsOrderBy>>;
  where?: InputMaybe<EventGroupFormatsBoolExp>;
};


export type Subscription_RootEventGroupFormatsByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootEventGroupFormatsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventGroupFormatsStreamCursorInput>>;
  where?: InputMaybe<EventGroupFormatsBoolExp>;
};


export type Subscription_RootEventGroupMergesArgs = {
  distinctOn?: InputMaybe<Array<EventGroupMergesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGroupMergesOrderBy>>;
  where?: InputMaybe<EventGroupMergesBoolExp>;
};


export type Subscription_RootEventGroupMergesAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventGroupMergesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGroupMergesOrderBy>>;
  where?: InputMaybe<EventGroupMergesBoolExp>;
};


export type Subscription_RootEventGroupMergesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEventGroupMergesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventGroupMergesStreamCursorInput>>;
  where?: InputMaybe<EventGroupMergesBoolExp>;
};


export type Subscription_RootEventGroupPoolsArgs = {
  distinctOn?: InputMaybe<Array<EventGroupPoolsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGroupPoolsOrderBy>>;
  where?: InputMaybe<EventGroupPoolsBoolExp>;
};


export type Subscription_RootEventGroupPoolsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventGroupPoolsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGroupPoolsOrderBy>>;
  where?: InputMaybe<EventGroupPoolsBoolExp>;
};


export type Subscription_RootEventGroupPoolsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEventGroupPoolsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventGroupPoolsStreamCursorInput>>;
  where?: InputMaybe<EventGroupPoolsBoolExp>;
};


export type Subscription_RootEventGroupRatingScalesArgs = {
  distinctOn?: InputMaybe<Array<EventGroupRatingScalesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGroupRatingScalesOrderBy>>;
  where?: InputMaybe<EventGroupRatingScalesBoolExp>;
};


export type Subscription_RootEventGroupRatingScalesAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventGroupRatingScalesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGroupRatingScalesOrderBy>>;
  where?: InputMaybe<EventGroupRatingScalesBoolExp>;
};


export type Subscription_RootEventGroupRatingScalesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEventGroupRatingScalesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventGroupRatingScalesStreamCursorInput>>;
  where?: InputMaybe<EventGroupRatingScalesBoolExp>;
};


export type Subscription_RootEventGroupRegistrationStatusesArgs = {
  distinctOn?: InputMaybe<Array<EventGroupRegistrationStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGroupRegistrationStatusesOrderBy>>;
  where?: InputMaybe<EventGroupRegistrationStatusesBoolExp>;
};


export type Subscription_RootEventGroupRegistrationStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventGroupRegistrationStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGroupRegistrationStatusesOrderBy>>;
  where?: InputMaybe<EventGroupRegistrationStatusesBoolExp>;
};


export type Subscription_RootEventGroupRegistrationStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootEventGroupRegistrationStatusesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventGroupRegistrationStatusesStreamCursorInput>>;
  where?: InputMaybe<EventGroupRegistrationStatusesBoolExp>;
};


export type Subscription_RootEventGroupRegistrationsArgs = {
  distinctOn?: InputMaybe<Array<EventGroupRegistrationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGroupRegistrationsOrderBy>>;
  where?: InputMaybe<EventGroupRegistrationsBoolExp>;
};


export type Subscription_RootEventGroupRegistrationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventGroupRegistrationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGroupRegistrationsOrderBy>>;
  where?: InputMaybe<EventGroupRegistrationsBoolExp>;
};


export type Subscription_RootEventGroupRegistrationsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEventGroupRegistrationsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventGroupRegistrationsStreamCursorInput>>;
  where?: InputMaybe<EventGroupRegistrationsBoolExp>;
};


export type Subscription_RootEventGroupSequenceSeedingArgs = {
  distinctOn?: InputMaybe<Array<EventGroupSequenceSeedingSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGroupSequenceSeedingOrderBy>>;
  where?: InputMaybe<EventGroupSequenceSeedingBoolExp>;
};


export type Subscription_RootEventGroupSequenceSeedingAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventGroupSequenceSeedingSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGroupSequenceSeedingOrderBy>>;
  where?: InputMaybe<EventGroupSequenceSeedingBoolExp>;
};


export type Subscription_RootEventGroupSequenceSeedingByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEventGroupSequenceSeedingStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventGroupSequenceSeedingStreamCursorInput>>;
  where?: InputMaybe<EventGroupSequenceSeedingBoolExp>;
};


export type Subscription_RootEventGroupSequencesArgs = {
  distinctOn?: InputMaybe<Array<EventGroupSequencesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGroupSequencesOrderBy>>;
  where?: InputMaybe<EventGroupSequencesBoolExp>;
};


export type Subscription_RootEventGroupSequencesAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventGroupSequencesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGroupSequencesOrderBy>>;
  where?: InputMaybe<EventGroupSequencesBoolExp>;
};


export type Subscription_RootEventGroupSequencesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEventGroupSequencesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventGroupSequencesStreamCursorInput>>;
  where?: InputMaybe<EventGroupSequencesBoolExp>;
};


export type Subscription_RootEventGroupTimeSlotsArgs = {
  distinctOn?: InputMaybe<Array<EventGroupTimeSlotsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGroupTimeSlotsOrderBy>>;
  where?: InputMaybe<EventGroupTimeSlotsBoolExp>;
};


export type Subscription_RootEventGroupTimeSlotsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventGroupTimeSlotsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGroupTimeSlotsOrderBy>>;
  where?: InputMaybe<EventGroupTimeSlotsBoolExp>;
};


export type Subscription_RootEventGroupTimeSlotsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEventGroupTimeSlotsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventGroupTimeSlotsStreamCursorInput>>;
  where?: InputMaybe<EventGroupTimeSlotsBoolExp>;
};


export type Subscription_RootEventGroupsArgs = {
  distinctOn?: InputMaybe<Array<EventGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGroupsOrderBy>>;
  where?: InputMaybe<EventGroupsBoolExp>;
};


export type Subscription_RootEventGroupsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGroupsOrderBy>>;
  where?: InputMaybe<EventGroupsBoolExp>;
};


export type Subscription_RootEventGroupsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEventGroupsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventGroupsStreamCursorInput>>;
  where?: InputMaybe<EventGroupsBoolExp>;
};


export type Subscription_RootEventInvitationStatusesArgs = {
  distinctOn?: InputMaybe<Array<EventInvitationStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventInvitationStatusesOrderBy>>;
  where?: InputMaybe<EventInvitationStatusesBoolExp>;
};


export type Subscription_RootEventInvitationStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventInvitationStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventInvitationStatusesOrderBy>>;
  where?: InputMaybe<EventInvitationStatusesBoolExp>;
};


export type Subscription_RootEventInvitationStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootEventInvitationStatusesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventInvitationStatusesStreamCursorInput>>;
  where?: InputMaybe<EventInvitationStatusesBoolExp>;
};


export type Subscription_RootEventInvitationTypesArgs = {
  distinctOn?: InputMaybe<Array<EventInvitationTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventInvitationTypesOrderBy>>;
  where?: InputMaybe<EventInvitationTypesBoolExp>;
};


export type Subscription_RootEventInvitationTypesAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventInvitationTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventInvitationTypesOrderBy>>;
  where?: InputMaybe<EventInvitationTypesBoolExp>;
};


export type Subscription_RootEventInvitationTypesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootEventInvitationTypesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventInvitationTypesStreamCursorInput>>;
  where?: InputMaybe<EventInvitationTypesBoolExp>;
};


export type Subscription_RootEventInvitationsArgs = {
  distinctOn?: InputMaybe<Array<EventInvitationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventInvitationsOrderBy>>;
  where?: InputMaybe<EventInvitationsBoolExp>;
};


export type Subscription_RootEventInvitationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventInvitationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventInvitationsOrderBy>>;
  where?: InputMaybe<EventInvitationsBoolExp>;
};


export type Subscription_RootEventInvitationsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEventInvitationsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventInvitationsStreamCursorInput>>;
  where?: InputMaybe<EventInvitationsBoolExp>;
};


export type Subscription_RootEventListingFeesArgs = {
  distinctOn?: InputMaybe<Array<EventListingFeesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventListingFeesOrderBy>>;
  where?: InputMaybe<EventListingFeesBoolExp>;
};


export type Subscription_RootEventListingFeesAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventListingFeesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventListingFeesOrderBy>>;
  where?: InputMaybe<EventListingFeesBoolExp>;
};


export type Subscription_RootEventListingFeesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEventListingFeesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventListingFeesStreamCursorInput>>;
  where?: InputMaybe<EventListingFeesBoolExp>;
};


export type Subscription_RootEventMatchGamesArgs = {
  distinctOn?: InputMaybe<Array<EventMatchGamesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventMatchGamesOrderBy>>;
  where?: InputMaybe<EventMatchGamesBoolExp>;
};


export type Subscription_RootEventMatchGamesAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventMatchGamesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventMatchGamesOrderBy>>;
  where?: InputMaybe<EventMatchGamesBoolExp>;
};


export type Subscription_RootEventMatchGamesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEventMatchGamesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventMatchGamesStreamCursorInput>>;
  where?: InputMaybe<EventMatchGamesBoolExp>;
};


export type Subscription_RootEventMatchesArgs = {
  distinctOn?: InputMaybe<Array<EventMatchesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventMatchesOrderBy>>;
  where?: InputMaybe<EventMatchesBoolExp>;
};


export type Subscription_RootEventMatchesAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventMatchesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventMatchesOrderBy>>;
  where?: InputMaybe<EventMatchesBoolExp>;
};


export type Subscription_RootEventMatchesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEventMatchesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventMatchesStreamCursorInput>>;
  where?: InputMaybe<EventMatchesBoolExp>;
};


export type Subscription_RootEventMatchesTeamsArgs = {
  distinctOn?: InputMaybe<Array<EventMatchesTeamsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventMatchesTeamsOrderBy>>;
  where?: InputMaybe<EventMatchesTeamsBoolExp>;
};


export type Subscription_RootEventMatchesTeamsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventMatchesTeamsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventMatchesTeamsOrderBy>>;
  where?: InputMaybe<EventMatchesTeamsBoolExp>;
};


export type Subscription_RootEventMatchesTeamsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEventMatchesTeamsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventMatchesTeamsStreamCursorInput>>;
  where?: InputMaybe<EventMatchesTeamsBoolExp>;
};


export type Subscription_RootEventOrganizerAccountTypesArgs = {
  distinctOn?: InputMaybe<Array<EventOrganizerAccountTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventOrganizerAccountTypesOrderBy>>;
  where?: InputMaybe<EventOrganizerAccountTypesBoolExp>;
};


export type Subscription_RootEventOrganizerAccountTypesAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventOrganizerAccountTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventOrganizerAccountTypesOrderBy>>;
  where?: InputMaybe<EventOrganizerAccountTypesBoolExp>;
};


export type Subscription_RootEventOrganizerAccountTypesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootEventOrganizerAccountTypesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventOrganizerAccountTypesStreamCursorInput>>;
  where?: InputMaybe<EventOrganizerAccountTypesBoolExp>;
};


export type Subscription_RootEventPlayerInviteStatusesArgs = {
  distinctOn?: InputMaybe<Array<EventPlayerInviteStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventPlayerInviteStatusesOrderBy>>;
  where?: InputMaybe<EventPlayerInviteStatusesBoolExp>;
};


export type Subscription_RootEventPlayerInviteStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventPlayerInviteStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventPlayerInviteStatusesOrderBy>>;
  where?: InputMaybe<EventPlayerInviteStatusesBoolExp>;
};


export type Subscription_RootEventPlayerInviteStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootEventPlayerInviteStatusesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventPlayerInviteStatusesStreamCursorInput>>;
  where?: InputMaybe<EventPlayerInviteStatusesBoolExp>;
};


export type Subscription_RootEventPlayerInvitesArgs = {
  distinctOn?: InputMaybe<Array<EventPlayerInvitesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventPlayerInvitesOrderBy>>;
  where?: InputMaybe<EventPlayerInvitesBoolExp>;
};


export type Subscription_RootEventPlayerInvitesAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventPlayerInvitesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventPlayerInvitesOrderBy>>;
  where?: InputMaybe<EventPlayerInvitesBoolExp>;
};


export type Subscription_RootEventPlayerInvitesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEventPlayerInvitesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventPlayerInvitesStreamCursorInput>>;
  where?: InputMaybe<EventPlayerInvitesBoolExp>;
};


export type Subscription_RootEventPoolRoundsArgs = {
  distinctOn?: InputMaybe<Array<EventPoolRoundsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventPoolRoundsOrderBy>>;
  where?: InputMaybe<EventPoolRoundsBoolExp>;
};


export type Subscription_RootEventPoolRoundsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventPoolRoundsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventPoolRoundsOrderBy>>;
  where?: InputMaybe<EventPoolRoundsBoolExp>;
};


export type Subscription_RootEventPoolRoundsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEventPoolRoundsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventPoolRoundsStreamCursorInput>>;
  where?: InputMaybe<EventPoolRoundsBoolExp>;
};


export type Subscription_RootEventPoolsTeamsArgs = {
  distinctOn?: InputMaybe<Array<EventPoolsTeamsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventPoolsTeamsOrderBy>>;
  where?: InputMaybe<EventPoolsTeamsBoolExp>;
};


export type Subscription_RootEventPoolsTeamsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventPoolsTeamsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventPoolsTeamsOrderBy>>;
  where?: InputMaybe<EventPoolsTeamsBoolExp>;
};


export type Subscription_RootEventPoolsTeamsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEventPoolsTeamsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventPoolsTeamsStreamCursorInput>>;
  where?: InputMaybe<EventPoolsTeamsBoolExp>;
};


export type Subscription_RootEventPrivacyArgs = {
  distinctOn?: InputMaybe<Array<EventPrivacySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventPrivacyOrderBy>>;
  where?: InputMaybe<EventPrivacyBoolExp>;
};


export type Subscription_RootEventPrivacyAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventPrivacySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventPrivacyOrderBy>>;
  where?: InputMaybe<EventPrivacyBoolExp>;
};


export type Subscription_RootEventPrivacyByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootEventPrivacyStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventPrivacyStreamCursorInput>>;
  where?: InputMaybe<EventPrivacyBoolExp>;
};


export type Subscription_RootEventRegistrationDetailsArgs = {
  distinctOn?: InputMaybe<Array<EventRegistrationDetailsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventRegistrationDetailsOrderBy>>;
  where?: InputMaybe<EventRegistrationDetailsBoolExp>;
};


export type Subscription_RootEventRegistrationDetailsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventRegistrationDetailsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventRegistrationDetailsOrderBy>>;
  where?: InputMaybe<EventRegistrationDetailsBoolExp>;
};


export type Subscription_RootEventRegistrationDetailsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEventRegistrationDetailsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventRegistrationDetailsStreamCursorInput>>;
  where?: InputMaybe<EventRegistrationDetailsBoolExp>;
};


export type Subscription_RootEventRegistrationsArgs = {
  distinctOn?: InputMaybe<Array<EventRegistrationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventRegistrationsOrderBy>>;
  where?: InputMaybe<EventRegistrationsBoolExp>;
};


export type Subscription_RootEventRegistrationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventRegistrationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventRegistrationsOrderBy>>;
  where?: InputMaybe<EventRegistrationsBoolExp>;
};


export type Subscription_RootEventRegistrationsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEventRegistrationsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventRegistrationsStreamCursorInput>>;
  where?: InputMaybe<EventRegistrationsBoolExp>;
};


export type Subscription_RootEventSequenceCompleteReasonsArgs = {
  distinctOn?: InputMaybe<Array<EventSequenceCompleteReasonsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventSequenceCompleteReasonsOrderBy>>;
  where?: InputMaybe<EventSequenceCompleteReasonsBoolExp>;
};


export type Subscription_RootEventSequenceCompleteReasonsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventSequenceCompleteReasonsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventSequenceCompleteReasonsOrderBy>>;
  where?: InputMaybe<EventSequenceCompleteReasonsBoolExp>;
};


export type Subscription_RootEventSequenceCompleteReasonsByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootEventSequenceCompleteReasonsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventSequenceCompleteReasonsStreamCursorInput>>;
  where?: InputMaybe<EventSequenceCompleteReasonsBoolExp>;
};


export type Subscription_RootEventSkillLevelsArgs = {
  distinctOn?: InputMaybe<Array<EventSkillLevelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventSkillLevelsOrderBy>>;
  where?: InputMaybe<EventSkillLevelsBoolExp>;
};


export type Subscription_RootEventSkillLevelsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventSkillLevelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventSkillLevelsOrderBy>>;
  where?: InputMaybe<EventSkillLevelsBoolExp>;
};


export type Subscription_RootEventSkillLevelsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEventSkillLevelsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventSkillLevelsStreamCursorInput>>;
  where?: InputMaybe<EventSkillLevelsBoolExp>;
};


export type Subscription_RootEventSponsorsArgs = {
  distinctOn?: InputMaybe<Array<EventSponsorsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventSponsorsOrderBy>>;
  where?: InputMaybe<EventSponsorsBoolExp>;
};


export type Subscription_RootEventSponsorsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventSponsorsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventSponsorsOrderBy>>;
  where?: InputMaybe<EventSponsorsBoolExp>;
};


export type Subscription_RootEventSponsorsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEventSponsorsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventSponsorsStreamCursorInput>>;
  where?: InputMaybe<EventSponsorsBoolExp>;
};


export type Subscription_RootEventStatusesArgs = {
  distinctOn?: InputMaybe<Array<EventStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventStatusesOrderBy>>;
  where?: InputMaybe<EventStatusesBoolExp>;
};


export type Subscription_RootEventStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventStatusesOrderBy>>;
  where?: InputMaybe<EventStatusesBoolExp>;
};


export type Subscription_RootEventStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootEventStatusesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventStatusesStreamCursorInput>>;
  where?: InputMaybe<EventStatusesBoolExp>;
};


export type Subscription_RootEventTeamMemberStatusesArgs = {
  distinctOn?: InputMaybe<Array<EventTeamMemberStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventTeamMemberStatusesOrderBy>>;
  where?: InputMaybe<EventTeamMemberStatusesBoolExp>;
};


export type Subscription_RootEventTeamMemberStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventTeamMemberStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventTeamMemberStatusesOrderBy>>;
  where?: InputMaybe<EventTeamMemberStatusesBoolExp>;
};


export type Subscription_RootEventTeamMemberStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootEventTeamMemberStatusesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventTeamMemberStatusesStreamCursorInput>>;
  where?: InputMaybe<EventTeamMemberStatusesBoolExp>;
};


export type Subscription_RootEventTeamMembersArgs = {
  distinctOn?: InputMaybe<Array<EventTeamMembersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventTeamMembersOrderBy>>;
  where?: InputMaybe<EventTeamMembersBoolExp>;
};


export type Subscription_RootEventTeamMembersAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventTeamMembersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventTeamMembersOrderBy>>;
  where?: InputMaybe<EventTeamMembersBoolExp>;
};


export type Subscription_RootEventTeamMembersByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEventTeamMembersStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventTeamMembersStreamCursorInput>>;
  where?: InputMaybe<EventTeamMembersBoolExp>;
};


export type Subscription_RootEventTeamStatusesArgs = {
  distinctOn?: InputMaybe<Array<EventTeamStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventTeamStatusesOrderBy>>;
  where?: InputMaybe<EventTeamStatusesBoolExp>;
};


export type Subscription_RootEventTeamStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventTeamStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventTeamStatusesOrderBy>>;
  where?: InputMaybe<EventTeamStatusesBoolExp>;
};


export type Subscription_RootEventTeamStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootEventTeamStatusesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventTeamStatusesStreamCursorInput>>;
  where?: InputMaybe<EventTeamStatusesBoolExp>;
};


export type Subscription_RootEventTeamsArgs = {
  distinctOn?: InputMaybe<Array<EventTeamsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventTeamsOrderBy>>;
  where?: InputMaybe<EventTeamsBoolExp>;
};


export type Subscription_RootEventTeamsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventTeamsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventTeamsOrderBy>>;
  where?: InputMaybe<EventTeamsBoolExp>;
};


export type Subscription_RootEventTeamsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEventTeamsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventTeamsStreamCursorInput>>;
  where?: InputMaybe<EventTeamsBoolExp>;
};


export type Subscription_RootEventTransactionItemTypesArgs = {
  distinctOn?: InputMaybe<Array<EventTransactionItemTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventTransactionItemTypesOrderBy>>;
  where?: InputMaybe<EventTransactionItemTypesBoolExp>;
};


export type Subscription_RootEventTransactionItemTypesAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventTransactionItemTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventTransactionItemTypesOrderBy>>;
  where?: InputMaybe<EventTransactionItemTypesBoolExp>;
};


export type Subscription_RootEventTransactionItemTypesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootEventTransactionItemTypesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventTransactionItemTypesStreamCursorInput>>;
  where?: InputMaybe<EventTransactionItemTypesBoolExp>;
};


export type Subscription_RootEventTransactionItemsArgs = {
  distinctOn?: InputMaybe<Array<EventTransactionItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventTransactionItemsOrderBy>>;
  where?: InputMaybe<EventTransactionItemsBoolExp>;
};


export type Subscription_RootEventTransactionItemsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventTransactionItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventTransactionItemsOrderBy>>;
  where?: InputMaybe<EventTransactionItemsBoolExp>;
};


export type Subscription_RootEventTransactionItemsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEventTransactionItemsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventTransactionItemsStreamCursorInput>>;
  where?: InputMaybe<EventTransactionItemsBoolExp>;
};


export type Subscription_RootEventTransactionsArgs = {
  distinctOn?: InputMaybe<Array<EventTransactionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventTransactionsOrderBy>>;
  where?: InputMaybe<EventTransactionsBoolExp>;
};


export type Subscription_RootEventTransactionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventTransactionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventTransactionsOrderBy>>;
  where?: InputMaybe<EventTransactionsBoolExp>;
};


export type Subscription_RootEventTransactionsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEventTransactionsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventTransactionsStreamCursorInput>>;
  where?: InputMaybe<EventTransactionsBoolExp>;
};


export type Subscription_RootEventTypesArgs = {
  distinctOn?: InputMaybe<Array<EventTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventTypesOrderBy>>;
  where?: InputMaybe<EventTypesBoolExp>;
};


export type Subscription_RootEventTypesAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventTypesOrderBy>>;
  where?: InputMaybe<EventTypesBoolExp>;
};


export type Subscription_RootEventTypesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootEventTypesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventTypesStreamCursorInput>>;
  where?: InputMaybe<EventTypesBoolExp>;
};


export type Subscription_RootEventsArgs = {
  distinctOn?: InputMaybe<Array<EventsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventsOrderBy>>;
  where?: InputMaybe<EventsBoolExp>;
};


export type Subscription_RootEventsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventsOrderBy>>;
  where?: InputMaybe<EventsBoolExp>;
};


export type Subscription_RootEventsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEventsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventsStreamCursorInput>>;
  where?: InputMaybe<EventsBoolExp>;
};


export type Subscription_RootFeedbackSentimentArgs = {
  distinctOn?: InputMaybe<Array<FeedbackSentimentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FeedbackSentimentOrderBy>>;
  where?: InputMaybe<FeedbackSentimentBoolExp>;
};


export type Subscription_RootFeedbackSentimentAggregateArgs = {
  distinctOn?: InputMaybe<Array<FeedbackSentimentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FeedbackSentimentOrderBy>>;
  where?: InputMaybe<FeedbackSentimentBoolExp>;
};


export type Subscription_RootFeedbackSentimentByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootFeedbackSentimentStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<FeedbackSentimentStreamCursorInput>>;
  where?: InputMaybe<FeedbackSentimentBoolExp>;
};


export type Subscription_RootFileCategoryArgs = {
  distinctOn?: InputMaybe<Array<FileCategorySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FileCategoryOrderBy>>;
  where?: InputMaybe<FileCategoryBoolExp>;
};


export type Subscription_RootFileCategoryAggregateArgs = {
  distinctOn?: InputMaybe<Array<FileCategorySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FileCategoryOrderBy>>;
  where?: InputMaybe<FileCategoryBoolExp>;
};


export type Subscription_RootFileCategoryByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootFileCategoryStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<FileCategoryStreamCursorInput>>;
  where?: InputMaybe<FileCategoryBoolExp>;
};


export type Subscription_RootFileFormatArgs = {
  distinctOn?: InputMaybe<Array<FileFormatSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FileFormatOrderBy>>;
  where?: InputMaybe<FileFormatBoolExp>;
};


export type Subscription_RootFileFormatAggregateArgs = {
  distinctOn?: InputMaybe<Array<FileFormatSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FileFormatOrderBy>>;
  where?: InputMaybe<FileFormatBoolExp>;
};


export type Subscription_RootFileFormatByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootFileFormatStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<FileFormatStreamCursorInput>>;
  where?: InputMaybe<FileFormatBoolExp>;
};


export type Subscription_RootFollowStatusesArgs = {
  distinctOn?: InputMaybe<Array<FollowStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FollowStatusesOrderBy>>;
  where?: InputMaybe<FollowStatusesBoolExp>;
};


export type Subscription_RootFollowStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<FollowStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FollowStatusesOrderBy>>;
  where?: InputMaybe<FollowStatusesBoolExp>;
};


export type Subscription_RootFollowStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootFollowStatusesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<FollowStatusesStreamCursorInput>>;
  where?: InputMaybe<FollowStatusesBoolExp>;
};


export type Subscription_RootGameNetStatusesArgs = {
  distinctOn?: InputMaybe<Array<GameNetStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GameNetStatusesOrderBy>>;
  where?: InputMaybe<GameNetStatusesBoolExp>;
};


export type Subscription_RootGameNetStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<GameNetStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GameNetStatusesOrderBy>>;
  where?: InputMaybe<GameNetStatusesBoolExp>;
};


export type Subscription_RootGameNetStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootGameNetStatusesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<GameNetStatusesStreamCursorInput>>;
  where?: InputMaybe<GameNetStatusesBoolExp>;
};


export type Subscription_RootGenderArgs = {
  distinctOn?: InputMaybe<Array<GenderSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GenderOrderBy>>;
  where?: InputMaybe<GenderBoolExp>;
};


export type Subscription_RootGenderAggregateArgs = {
  distinctOn?: InputMaybe<Array<GenderSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GenderOrderBy>>;
  where?: InputMaybe<GenderBoolExp>;
};


export type Subscription_RootGenderByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootGenderStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<GenderStreamCursorInput>>;
  where?: InputMaybe<GenderBoolExp>;
};


export type Subscription_RootGroupCommentVotesArgs = {
  distinctOn?: InputMaybe<Array<GroupCommentVotesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupCommentVotesOrderBy>>;
  where?: InputMaybe<GroupCommentVotesBoolExp>;
};


export type Subscription_RootGroupCommentVotesAggregateArgs = {
  distinctOn?: InputMaybe<Array<GroupCommentVotesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupCommentVotesOrderBy>>;
  where?: InputMaybe<GroupCommentVotesBoolExp>;
};


export type Subscription_RootGroupCommentVotesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootGroupCommentVotesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<GroupCommentVotesStreamCursorInput>>;
  where?: InputMaybe<GroupCommentVotesBoolExp>;
};


export type Subscription_RootGroupMembersArgs = {
  distinctOn?: InputMaybe<Array<GroupMembersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupMembersOrderBy>>;
  where?: InputMaybe<GroupMembersBoolExp>;
};


export type Subscription_RootGroupMembersAggregateArgs = {
  distinctOn?: InputMaybe<Array<GroupMembersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupMembersOrderBy>>;
  where?: InputMaybe<GroupMembersBoolExp>;
};


export type Subscription_RootGroupMembersByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootGroupMembersStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<GroupMembersStreamCursorInput>>;
  where?: InputMaybe<GroupMembersBoolExp>;
};


export type Subscription_RootGroupThreadCommentFilesArgs = {
  distinctOn?: InputMaybe<Array<GroupThreadCommentFilesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupThreadCommentFilesOrderBy>>;
  where?: InputMaybe<GroupThreadCommentFilesBoolExp>;
};


export type Subscription_RootGroupThreadCommentFilesAggregateArgs = {
  distinctOn?: InputMaybe<Array<GroupThreadCommentFilesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupThreadCommentFilesOrderBy>>;
  where?: InputMaybe<GroupThreadCommentFilesBoolExp>;
};


export type Subscription_RootGroupThreadCommentFilesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootGroupThreadCommentFilesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<GroupThreadCommentFilesStreamCursorInput>>;
  where?: InputMaybe<GroupThreadCommentFilesBoolExp>;
};


export type Subscription_RootGroupThreadCommentsArgs = {
  distinctOn?: InputMaybe<Array<GroupThreadCommentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupThreadCommentsOrderBy>>;
  where?: InputMaybe<GroupThreadCommentsBoolExp>;
};


export type Subscription_RootGroupThreadCommentsAggregateArgs = {
  distinctOn?: InputMaybe<Array<GroupThreadCommentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupThreadCommentsOrderBy>>;
  where?: InputMaybe<GroupThreadCommentsBoolExp>;
};


export type Subscription_RootGroupThreadCommentsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootGroupThreadCommentsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<GroupThreadCommentsStreamCursorInput>>;
  where?: InputMaybe<GroupThreadCommentsBoolExp>;
};


export type Subscription_RootGroupThreadsArgs = {
  distinctOn?: InputMaybe<Array<GroupThreadsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupThreadsOrderBy>>;
  where?: InputMaybe<GroupThreadsBoolExp>;
};


export type Subscription_RootGroupThreadsAggregateArgs = {
  distinctOn?: InputMaybe<Array<GroupThreadsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupThreadsOrderBy>>;
  where?: InputMaybe<GroupThreadsBoolExp>;
};


export type Subscription_RootGroupThreadsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootGroupThreadsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<GroupThreadsStreamCursorInput>>;
  where?: InputMaybe<GroupThreadsBoolExp>;
};


export type Subscription_RootGroupTypesArgs = {
  distinctOn?: InputMaybe<Array<GroupTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupTypesOrderBy>>;
  where?: InputMaybe<GroupTypesBoolExp>;
};


export type Subscription_RootGroupTypesAggregateArgs = {
  distinctOn?: InputMaybe<Array<GroupTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupTypesOrderBy>>;
  where?: InputMaybe<GroupTypesBoolExp>;
};


export type Subscription_RootGroupTypesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootGroupTypesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<GroupTypesStreamCursorInput>>;
  where?: InputMaybe<GroupTypesBoolExp>;
};


export type Subscription_RootGroupVenuesArgs = {
  distinctOn?: InputMaybe<Array<GroupVenuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupVenuesOrderBy>>;
  where?: InputMaybe<GroupVenuesBoolExp>;
};


export type Subscription_RootGroupVenuesAggregateArgs = {
  distinctOn?: InputMaybe<Array<GroupVenuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupVenuesOrderBy>>;
  where?: InputMaybe<GroupVenuesBoolExp>;
};


export type Subscription_RootGroupVenuesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootGroupVenuesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<GroupVenuesStreamCursorInput>>;
  where?: InputMaybe<GroupVenuesBoolExp>;
};


export type Subscription_RootGroupsArgs = {
  distinctOn?: InputMaybe<Array<GroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupsOrderBy>>;
  where?: InputMaybe<GroupsBoolExp>;
};


export type Subscription_RootGroupsAggregateArgs = {
  distinctOn?: InputMaybe<Array<GroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupsOrderBy>>;
  where?: InputMaybe<GroupsBoolExp>;
};


export type Subscription_RootGroupsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootGroupsPlaySessionsArgs = {
  distinctOn?: InputMaybe<Array<GroupsPlaySessionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupsPlaySessionsOrderBy>>;
  where?: InputMaybe<GroupsPlaySessionsBoolExp>;
};


export type Subscription_RootGroupsPlaySessionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<GroupsPlaySessionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupsPlaySessionsOrderBy>>;
  where?: InputMaybe<GroupsPlaySessionsBoolExp>;
};


export type Subscription_RootGroupsPlaySessionsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootGroupsPlaySessionsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<GroupsPlaySessionsStreamCursorInput>>;
  where?: InputMaybe<GroupsPlaySessionsBoolExp>;
};


export type Subscription_RootGroupsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<GroupsStreamCursorInput>>;
  where?: InputMaybe<GroupsBoolExp>;
};


export type Subscription_RootIdentityVerificationProvidersArgs = {
  distinctOn?: InputMaybe<Array<IdentityVerificationProvidersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IdentityVerificationProvidersOrderBy>>;
  where?: InputMaybe<IdentityVerificationProvidersBoolExp>;
};


export type Subscription_RootIdentityVerificationProvidersAggregateArgs = {
  distinctOn?: InputMaybe<Array<IdentityVerificationProvidersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IdentityVerificationProvidersOrderBy>>;
  where?: InputMaybe<IdentityVerificationProvidersBoolExp>;
};


export type Subscription_RootIdentityVerificationProvidersByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootIdentityVerificationProvidersStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<IdentityVerificationProvidersStreamCursorInput>>;
  where?: InputMaybe<IdentityVerificationProvidersBoolExp>;
};


export type Subscription_RootIdentityVerificationStatusesArgs = {
  distinctOn?: InputMaybe<Array<IdentityVerificationStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IdentityVerificationStatusesOrderBy>>;
  where?: InputMaybe<IdentityVerificationStatusesBoolExp>;
};


export type Subscription_RootIdentityVerificationStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<IdentityVerificationStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IdentityVerificationStatusesOrderBy>>;
  where?: InputMaybe<IdentityVerificationStatusesBoolExp>;
};


export type Subscription_RootIdentityVerificationStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootIdentityVerificationStatusesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<IdentityVerificationStatusesStreamCursorInput>>;
  where?: InputMaybe<IdentityVerificationStatusesBoolExp>;
};


export type Subscription_RootInvoicesArgs = {
  distinctOn?: InputMaybe<Array<InvoicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoicesOrderBy>>;
  where?: InputMaybe<InvoicesBoolExp>;
};


export type Subscription_RootInvoicesAggregateArgs = {
  distinctOn?: InputMaybe<Array<InvoicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoicesOrderBy>>;
  where?: InputMaybe<InvoicesBoolExp>;
};


export type Subscription_RootInvoicesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootInvoicesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<InvoicesStreamCursorInput>>;
  where?: InputMaybe<InvoicesBoolExp>;
};


export type Subscription_RootLearningProgramEnrollmentScheduleMediaWatchedArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramEnrollmentScheduleMediaWatchedSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramEnrollmentScheduleMediaWatchedOrderBy>>;
  where?: InputMaybe<LearningProgramEnrollmentScheduleMediaWatchedBoolExp>;
};


export type Subscription_RootLearningProgramEnrollmentScheduleMediaWatchedAggregateArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramEnrollmentScheduleMediaWatchedSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramEnrollmentScheduleMediaWatchedOrderBy>>;
  where?: InputMaybe<LearningProgramEnrollmentScheduleMediaWatchedBoolExp>;
};


export type Subscription_RootLearningProgramEnrollmentScheduleMediaWatchedByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootLearningProgramEnrollmentScheduleMediaWatchedStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<LearningProgramEnrollmentScheduleMediaWatchedStreamCursorInput>>;
  where?: InputMaybe<LearningProgramEnrollmentScheduleMediaWatchedBoolExp>;
};


export type Subscription_RootLearningProgramEnrollmentScheduleProgressArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramEnrollmentScheduleProgressSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramEnrollmentScheduleProgressOrderBy>>;
  where?: InputMaybe<LearningProgramEnrollmentScheduleProgressBoolExp>;
};


export type Subscription_RootLearningProgramEnrollmentScheduleProgressAggregateArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramEnrollmentScheduleProgressSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramEnrollmentScheduleProgressOrderBy>>;
  where?: InputMaybe<LearningProgramEnrollmentScheduleProgressBoolExp>;
};


export type Subscription_RootLearningProgramEnrollmentScheduleProgressByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootLearningProgramEnrollmentScheduleProgressStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<LearningProgramEnrollmentScheduleProgressStreamCursorInput>>;
  where?: InputMaybe<LearningProgramEnrollmentScheduleProgressBoolExp>;
};


export type Subscription_RootLearningProgramEnrollmentsArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramEnrollmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramEnrollmentsOrderBy>>;
  where?: InputMaybe<LearningProgramEnrollmentsBoolExp>;
};


export type Subscription_RootLearningProgramEnrollmentsAggregateArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramEnrollmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramEnrollmentsOrderBy>>;
  where?: InputMaybe<LearningProgramEnrollmentsBoolExp>;
};


export type Subscription_RootLearningProgramEnrollmentsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootLearningProgramEnrollmentsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<LearningProgramEnrollmentsStreamCursorInput>>;
  where?: InputMaybe<LearningProgramEnrollmentsBoolExp>;
};


export type Subscription_RootLearningProgramMediaArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramMediaSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramMediaOrderBy>>;
  where?: InputMaybe<LearningProgramMediaBoolExp>;
};


export type Subscription_RootLearningProgramMediaAggregateArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramMediaSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramMediaOrderBy>>;
  where?: InputMaybe<LearningProgramMediaBoolExp>;
};


export type Subscription_RootLearningProgramMediaByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootLearningProgramMediaCategoriesArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramMediaCategoriesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramMediaCategoriesOrderBy>>;
  where?: InputMaybe<LearningProgramMediaCategoriesBoolExp>;
};


export type Subscription_RootLearningProgramMediaCategoriesAggregateArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramMediaCategoriesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramMediaCategoriesOrderBy>>;
  where?: InputMaybe<LearningProgramMediaCategoriesBoolExp>;
};


export type Subscription_RootLearningProgramMediaCategoriesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootLearningProgramMediaCategoriesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<LearningProgramMediaCategoriesStreamCursorInput>>;
  where?: InputMaybe<LearningProgramMediaCategoriesBoolExp>;
};


export type Subscription_RootLearningProgramMediaStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<LearningProgramMediaStreamCursorInput>>;
  where?: InputMaybe<LearningProgramMediaBoolExp>;
};


export type Subscription_RootLearningProgramScheduleMediaArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramScheduleMediaSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramScheduleMediaOrderBy>>;
  where?: InputMaybe<LearningProgramScheduleMediaBoolExp>;
};


export type Subscription_RootLearningProgramScheduleMediaAggregateArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramScheduleMediaSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramScheduleMediaOrderBy>>;
  where?: InputMaybe<LearningProgramScheduleMediaBoolExp>;
};


export type Subscription_RootLearningProgramScheduleMediaByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootLearningProgramScheduleMediaStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<LearningProgramScheduleMediaStreamCursorInput>>;
  where?: InputMaybe<LearningProgramScheduleMediaBoolExp>;
};


export type Subscription_RootLearningProgramScheduleUnitsArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramScheduleUnitsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramScheduleUnitsOrderBy>>;
  where?: InputMaybe<LearningProgramScheduleUnitsBoolExp>;
};


export type Subscription_RootLearningProgramScheduleUnitsAggregateArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramScheduleUnitsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramScheduleUnitsOrderBy>>;
  where?: InputMaybe<LearningProgramScheduleUnitsBoolExp>;
};


export type Subscription_RootLearningProgramScheduleUnitsByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootLearningProgramScheduleUnitsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<LearningProgramScheduleUnitsStreamCursorInput>>;
  where?: InputMaybe<LearningProgramScheduleUnitsBoolExp>;
};


export type Subscription_RootLearningProgramScheduleVideoSubmissionsArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramScheduleVideoSubmissionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramScheduleVideoSubmissionsOrderBy>>;
  where?: InputMaybe<LearningProgramScheduleVideoSubmissionsBoolExp>;
};


export type Subscription_RootLearningProgramScheduleVideoSubmissionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramScheduleVideoSubmissionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramScheduleVideoSubmissionsOrderBy>>;
  where?: InputMaybe<LearningProgramScheduleVideoSubmissionsBoolExp>;
};


export type Subscription_RootLearningProgramScheduleVideoSubmissionsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootLearningProgramScheduleVideoSubmissionsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<LearningProgramScheduleVideoSubmissionsStreamCursorInput>>;
  where?: InputMaybe<LearningProgramScheduleVideoSubmissionsBoolExp>;
};


export type Subscription_RootLearningProgramSchedulesArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramSchedulesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramSchedulesOrderBy>>;
  where?: InputMaybe<LearningProgramSchedulesBoolExp>;
};


export type Subscription_RootLearningProgramSchedulesAggregateArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramSchedulesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramSchedulesOrderBy>>;
  where?: InputMaybe<LearningProgramSchedulesBoolExp>;
};


export type Subscription_RootLearningProgramSchedulesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootLearningProgramSchedulesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<LearningProgramSchedulesStreamCursorInput>>;
  where?: InputMaybe<LearningProgramSchedulesBoolExp>;
};


export type Subscription_RootLearningProgramSkillLevelValuesArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramSkillLevelValuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramSkillLevelValuesOrderBy>>;
  where?: InputMaybe<LearningProgramSkillLevelValuesBoolExp>;
};


export type Subscription_RootLearningProgramSkillLevelValuesAggregateArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramSkillLevelValuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramSkillLevelValuesOrderBy>>;
  where?: InputMaybe<LearningProgramSkillLevelValuesBoolExp>;
};


export type Subscription_RootLearningProgramSkillLevelValuesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootLearningProgramSkillLevelValuesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<LearningProgramSkillLevelValuesStreamCursorInput>>;
  where?: InputMaybe<LearningProgramSkillLevelValuesBoolExp>;
};


export type Subscription_RootLearningProgramSkillsArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramSkillsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramSkillsOrderBy>>;
  where?: InputMaybe<LearningProgramSkillsBoolExp>;
};


export type Subscription_RootLearningProgramSkillsAggregateArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramSkillsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramSkillsOrderBy>>;
  where?: InputMaybe<LearningProgramSkillsBoolExp>;
};


export type Subscription_RootLearningProgramSkillsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootLearningProgramSkillsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<LearningProgramSkillsStreamCursorInput>>;
  where?: InputMaybe<LearningProgramSkillsBoolExp>;
};


export type Subscription_RootLearningProgramsArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramsOrderBy>>;
  where?: InputMaybe<LearningProgramsBoolExp>;
};


export type Subscription_RootLearningProgramsAggregateArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramsOrderBy>>;
  where?: InputMaybe<LearningProgramsBoolExp>;
};


export type Subscription_RootLearningProgramsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootLearningProgramsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<LearningProgramsStreamCursorInput>>;
  where?: InputMaybe<LearningProgramsBoolExp>;
};


export type Subscription_RootLessonAgeGroupsArgs = {
  distinctOn?: InputMaybe<Array<LessonAgeGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonAgeGroupsOrderBy>>;
  where?: InputMaybe<LessonAgeGroupsBoolExp>;
};


export type Subscription_RootLessonAgeGroupsAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonAgeGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonAgeGroupsOrderBy>>;
  where?: InputMaybe<LessonAgeGroupsBoolExp>;
};


export type Subscription_RootLessonAgeGroupsByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootLessonAgeGroupsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<LessonAgeGroupsStreamCursorInput>>;
  where?: InputMaybe<LessonAgeGroupsBoolExp>;
};


export type Subscription_RootLessonCollectionsArgs = {
  distinctOn?: InputMaybe<Array<LessonCollectionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonCollectionsOrderBy>>;
  where?: InputMaybe<LessonCollectionsBoolExp>;
};


export type Subscription_RootLessonCollectionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonCollectionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonCollectionsOrderBy>>;
  where?: InputMaybe<LessonCollectionsBoolExp>;
};


export type Subscription_RootLessonCollectionsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootLessonCollectionsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<LessonCollectionsStreamCursorInput>>;
  where?: InputMaybe<LessonCollectionsBoolExp>;
};


export type Subscription_RootLessonEquipmentArgs = {
  distinctOn?: InputMaybe<Array<LessonEquipmentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonEquipmentOrderBy>>;
  where?: InputMaybe<LessonEquipmentBoolExp>;
};


export type Subscription_RootLessonEquipmentAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonEquipmentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonEquipmentOrderBy>>;
  where?: InputMaybe<LessonEquipmentBoolExp>;
};


export type Subscription_RootLessonEquipmentByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootLessonEquipmentOptionsArgs = {
  distinctOn?: InputMaybe<Array<LessonEquipmentOptionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonEquipmentOptionsOrderBy>>;
  where?: InputMaybe<LessonEquipmentOptionsBoolExp>;
};


export type Subscription_RootLessonEquipmentOptionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonEquipmentOptionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonEquipmentOptionsOrderBy>>;
  where?: InputMaybe<LessonEquipmentOptionsBoolExp>;
};


export type Subscription_RootLessonEquipmentOptionsByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootLessonEquipmentOptionsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<LessonEquipmentOptionsStreamCursorInput>>;
  where?: InputMaybe<LessonEquipmentOptionsBoolExp>;
};


export type Subscription_RootLessonEquipmentStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<LessonEquipmentStreamCursorInput>>;
  where?: InputMaybe<LessonEquipmentBoolExp>;
};


export type Subscription_RootLessonOrderItemsArgs = {
  distinctOn?: InputMaybe<Array<LessonOrderItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonOrderItemsOrderBy>>;
  where?: InputMaybe<LessonOrderItemsBoolExp>;
};


export type Subscription_RootLessonOrderItemsAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonOrderItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonOrderItemsOrderBy>>;
  where?: InputMaybe<LessonOrderItemsBoolExp>;
};


export type Subscription_RootLessonOrderItemsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootLessonOrderItemsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<LessonOrderItemsStreamCursorInput>>;
  where?: InputMaybe<LessonOrderItemsBoolExp>;
};


export type Subscription_RootLessonOrdersArgs = {
  distinctOn?: InputMaybe<Array<LessonOrdersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonOrdersOrderBy>>;
  where?: InputMaybe<LessonOrdersBoolExp>;
};


export type Subscription_RootLessonOrdersAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonOrdersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonOrdersOrderBy>>;
  where?: InputMaybe<LessonOrdersBoolExp>;
};


export type Subscription_RootLessonOrdersByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootLessonOrdersStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<LessonOrdersStreamCursorInput>>;
  where?: InputMaybe<LessonOrdersBoolExp>;
};


export type Subscription_RootLessonParticipantStatusesArgs = {
  distinctOn?: InputMaybe<Array<LessonParticipantStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonParticipantStatusesOrderBy>>;
  where?: InputMaybe<LessonParticipantStatusesBoolExp>;
};


export type Subscription_RootLessonParticipantStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonParticipantStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonParticipantStatusesOrderBy>>;
  where?: InputMaybe<LessonParticipantStatusesBoolExp>;
};


export type Subscription_RootLessonParticipantStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootLessonParticipantStatusesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<LessonParticipantStatusesStreamCursorInput>>;
  where?: InputMaybe<LessonParticipantStatusesBoolExp>;
};


export type Subscription_RootLessonParticipantsArgs = {
  distinctOn?: InputMaybe<Array<LessonParticipantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonParticipantsOrderBy>>;
  where?: InputMaybe<LessonParticipantsBoolExp>;
};


export type Subscription_RootLessonParticipantsAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonParticipantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonParticipantsOrderBy>>;
  where?: InputMaybe<LessonParticipantsBoolExp>;
};


export type Subscription_RootLessonParticipantsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootLessonParticipantsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<LessonParticipantsStreamCursorInput>>;
  where?: InputMaybe<LessonParticipantsBoolExp>;
};


export type Subscription_RootLessonPlayerSkillAssessmentCategoriesArgs = {
  distinctOn?: InputMaybe<Array<LessonPlayerSkillAssessmentCategoriesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonPlayerSkillAssessmentCategoriesOrderBy>>;
  where?: InputMaybe<LessonPlayerSkillAssessmentCategoriesBoolExp>;
};


export type Subscription_RootLessonPlayerSkillAssessmentCategoriesAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonPlayerSkillAssessmentCategoriesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonPlayerSkillAssessmentCategoriesOrderBy>>;
  where?: InputMaybe<LessonPlayerSkillAssessmentCategoriesBoolExp>;
};


export type Subscription_RootLessonPlayerSkillAssessmentCategoriesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootLessonPlayerSkillAssessmentCategoriesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<LessonPlayerSkillAssessmentCategoriesStreamCursorInput>>;
  where?: InputMaybe<LessonPlayerSkillAssessmentCategoriesBoolExp>;
};


export type Subscription_RootLessonPlayerSkillAssessmentsArgs = {
  distinctOn?: InputMaybe<Array<LessonPlayerSkillAssessmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonPlayerSkillAssessmentsOrderBy>>;
  where?: InputMaybe<LessonPlayerSkillAssessmentsBoolExp>;
};


export type Subscription_RootLessonPlayerSkillAssessmentsAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonPlayerSkillAssessmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonPlayerSkillAssessmentsOrderBy>>;
  where?: InputMaybe<LessonPlayerSkillAssessmentsBoolExp>;
};


export type Subscription_RootLessonPlayerSkillAssessmentsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootLessonPlayerSkillAssessmentsSkillsArgs = {
  distinctOn?: InputMaybe<Array<LessonPlayerSkillAssessmentsSkillsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonPlayerSkillAssessmentsSkillsOrderBy>>;
  where?: InputMaybe<LessonPlayerSkillAssessmentsSkillsBoolExp>;
};


export type Subscription_RootLessonPlayerSkillAssessmentsSkillsAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonPlayerSkillAssessmentsSkillsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonPlayerSkillAssessmentsSkillsOrderBy>>;
  where?: InputMaybe<LessonPlayerSkillAssessmentsSkillsBoolExp>;
};


export type Subscription_RootLessonPlayerSkillAssessmentsSkillsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootLessonPlayerSkillAssessmentsSkillsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<LessonPlayerSkillAssessmentsSkillsStreamCursorInput>>;
  where?: InputMaybe<LessonPlayerSkillAssessmentsSkillsBoolExp>;
};


export type Subscription_RootLessonPlayerSkillAssessmentsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<LessonPlayerSkillAssessmentsStreamCursorInput>>;
  where?: InputMaybe<LessonPlayerSkillAssessmentsBoolExp>;
};


export type Subscription_RootLessonPrivacyArgs = {
  distinctOn?: InputMaybe<Array<LessonPrivacySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonPrivacyOrderBy>>;
  where?: InputMaybe<LessonPrivacyBoolExp>;
};


export type Subscription_RootLessonPrivacyAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonPrivacySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonPrivacyOrderBy>>;
  where?: InputMaybe<LessonPrivacyBoolExp>;
};


export type Subscription_RootLessonPrivacyByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootLessonPrivacyStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<LessonPrivacyStreamCursorInput>>;
  where?: InputMaybe<LessonPrivacyBoolExp>;
};


export type Subscription_RootLessonReflectionCommentTypesArgs = {
  distinctOn?: InputMaybe<Array<LessonReflectionCommentTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonReflectionCommentTypesOrderBy>>;
  where?: InputMaybe<LessonReflectionCommentTypesBoolExp>;
};


export type Subscription_RootLessonReflectionCommentTypesAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonReflectionCommentTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonReflectionCommentTypesOrderBy>>;
  where?: InputMaybe<LessonReflectionCommentTypesBoolExp>;
};


export type Subscription_RootLessonReflectionCommentTypesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootLessonReflectionCommentTypesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<LessonReflectionCommentTypesStreamCursorInput>>;
  where?: InputMaybe<LessonReflectionCommentTypesBoolExp>;
};


export type Subscription_RootLessonReflectionCommentsArgs = {
  distinctOn?: InputMaybe<Array<LessonReflectionCommentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonReflectionCommentsOrderBy>>;
  where?: InputMaybe<LessonReflectionCommentsBoolExp>;
};


export type Subscription_RootLessonReflectionCommentsAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonReflectionCommentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonReflectionCommentsOrderBy>>;
  where?: InputMaybe<LessonReflectionCommentsBoolExp>;
};


export type Subscription_RootLessonReflectionCommentsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootLessonReflectionCommentsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<LessonReflectionCommentsStreamCursorInput>>;
  where?: InputMaybe<LessonReflectionCommentsBoolExp>;
};


export type Subscription_RootLessonReflectionFilesArgs = {
  distinctOn?: InputMaybe<Array<LessonReflectionFilesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonReflectionFilesOrderBy>>;
  where?: InputMaybe<LessonReflectionFilesBoolExp>;
};


export type Subscription_RootLessonReflectionFilesAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonReflectionFilesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonReflectionFilesOrderBy>>;
  where?: InputMaybe<LessonReflectionFilesBoolExp>;
};


export type Subscription_RootLessonReflectionFilesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootLessonReflectionFilesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<LessonReflectionFilesStreamCursorInput>>;
  where?: InputMaybe<LessonReflectionFilesBoolExp>;
};


export type Subscription_RootLessonReflectionsArgs = {
  distinctOn?: InputMaybe<Array<LessonReflectionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonReflectionsOrderBy>>;
  where?: InputMaybe<LessonReflectionsBoolExp>;
};


export type Subscription_RootLessonReflectionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonReflectionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonReflectionsOrderBy>>;
  where?: InputMaybe<LessonReflectionsBoolExp>;
};


export type Subscription_RootLessonReflectionsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootLessonReflectionsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<LessonReflectionsStreamCursorInput>>;
  where?: InputMaybe<LessonReflectionsBoolExp>;
};


export type Subscription_RootLessonSkillCategoriesArgs = {
  distinctOn?: InputMaybe<Array<LessonSkillCategoriesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonSkillCategoriesOrderBy>>;
  where?: InputMaybe<LessonSkillCategoriesBoolExp>;
};


export type Subscription_RootLessonSkillCategoriesAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonSkillCategoriesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonSkillCategoriesOrderBy>>;
  where?: InputMaybe<LessonSkillCategoriesBoolExp>;
};


export type Subscription_RootLessonSkillCategoriesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootLessonSkillCategoriesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<LessonSkillCategoriesStreamCursorInput>>;
  where?: InputMaybe<LessonSkillCategoriesBoolExp>;
};


export type Subscription_RootLessonSkillDisplayNamesArgs = {
  distinctOn?: InputMaybe<Array<LessonSkillDisplayNamesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonSkillDisplayNamesOrderBy>>;
  where?: InputMaybe<LessonSkillDisplayNamesBoolExp>;
};


export type Subscription_RootLessonSkillDisplayNamesAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonSkillDisplayNamesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonSkillDisplayNamesOrderBy>>;
  where?: InputMaybe<LessonSkillDisplayNamesBoolExp>;
};


export type Subscription_RootLessonSkillDisplayNamesByPkArgs = {
  id: LessonSkillsEnum;
};


export type Subscription_RootLessonSkillDisplayNamesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<LessonSkillDisplayNamesStreamCursorInput>>;
  where?: InputMaybe<LessonSkillDisplayNamesBoolExp>;
};


export type Subscription_RootLessonSkillLevelsArgs = {
  distinctOn?: InputMaybe<Array<LessonSkillLevelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonSkillLevelsOrderBy>>;
  where?: InputMaybe<LessonSkillLevelsBoolExp>;
};


export type Subscription_RootLessonSkillLevelsAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonSkillLevelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonSkillLevelsOrderBy>>;
  where?: InputMaybe<LessonSkillLevelsBoolExp>;
};


export type Subscription_RootLessonSkillLevelsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootLessonSkillLevelsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<LessonSkillLevelsStreamCursorInput>>;
  where?: InputMaybe<LessonSkillLevelsBoolExp>;
};


export type Subscription_RootLessonSkillMappingsArgs = {
  distinctOn?: InputMaybe<Array<LessonSkillMappingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonSkillMappingsOrderBy>>;
  where?: InputMaybe<LessonSkillMappingsBoolExp>;
};


export type Subscription_RootLessonSkillMappingsAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonSkillMappingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonSkillMappingsOrderBy>>;
  where?: InputMaybe<LessonSkillMappingsBoolExp>;
};


export type Subscription_RootLessonSkillMappingsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootLessonSkillMappingsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<LessonSkillMappingsStreamCursorInput>>;
  where?: InputMaybe<LessonSkillMappingsBoolExp>;
};


export type Subscription_RootLessonSkillsArgs = {
  distinctOn?: InputMaybe<Array<LessonSkillsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonSkillsOrderBy>>;
  where?: InputMaybe<LessonSkillsBoolExp>;
};


export type Subscription_RootLessonSkillsAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonSkillsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonSkillsOrderBy>>;
  where?: InputMaybe<LessonSkillsBoolExp>;
};


export type Subscription_RootLessonSkillsByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootLessonSkillsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<LessonSkillsStreamCursorInput>>;
  where?: InputMaybe<LessonSkillsBoolExp>;
};


export type Subscription_RootLessonStatusesArgs = {
  distinctOn?: InputMaybe<Array<LessonStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonStatusesOrderBy>>;
  where?: InputMaybe<LessonStatusesBoolExp>;
};


export type Subscription_RootLessonStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonStatusesOrderBy>>;
  where?: InputMaybe<LessonStatusesBoolExp>;
};


export type Subscription_RootLessonStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootLessonStatusesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<LessonStatusesStreamCursorInput>>;
  where?: InputMaybe<LessonStatusesBoolExp>;
};


export type Subscription_RootLessonTemplateSkillLevelsArgs = {
  distinctOn?: InputMaybe<Array<LessonTemplateSkillLevelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonTemplateSkillLevelsOrderBy>>;
  where?: InputMaybe<LessonTemplateSkillLevelsBoolExp>;
};


export type Subscription_RootLessonTemplateSkillLevelsAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonTemplateSkillLevelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonTemplateSkillLevelsOrderBy>>;
  where?: InputMaybe<LessonTemplateSkillLevelsBoolExp>;
};


export type Subscription_RootLessonTemplateSkillLevelsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootLessonTemplateSkillLevelsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<LessonTemplateSkillLevelsStreamCursorInput>>;
  where?: InputMaybe<LessonTemplateSkillLevelsBoolExp>;
};


export type Subscription_RootLessonTemplatesArgs = {
  distinctOn?: InputMaybe<Array<LessonTemplatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonTemplatesOrderBy>>;
  where?: InputMaybe<LessonTemplatesBoolExp>;
};


export type Subscription_RootLessonTemplatesAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonTemplatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonTemplatesOrderBy>>;
  where?: InputMaybe<LessonTemplatesBoolExp>;
};


export type Subscription_RootLessonTemplatesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootLessonTemplatesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<LessonTemplatesStreamCursorInput>>;
  where?: InputMaybe<LessonTemplatesBoolExp>;
};


export type Subscription_RootLessonTimesArgs = {
  distinctOn?: InputMaybe<Array<LessonTimesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonTimesOrderBy>>;
  where?: InputMaybe<LessonTimesBoolExp>;
};


export type Subscription_RootLessonTimesAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonTimesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonTimesOrderBy>>;
  where?: InputMaybe<LessonTimesBoolExp>;
};


export type Subscription_RootLessonTimesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootLessonTimesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<LessonTimesStreamCursorInput>>;
  where?: InputMaybe<LessonTimesBoolExp>;
};


export type Subscription_RootLessonTypesArgs = {
  distinctOn?: InputMaybe<Array<LessonTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonTypesOrderBy>>;
  where?: InputMaybe<LessonTypesBoolExp>;
};


export type Subscription_RootLessonTypesAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonTypesOrderBy>>;
  where?: InputMaybe<LessonTypesBoolExp>;
};


export type Subscription_RootLessonTypesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootLessonTypesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<LessonTypesStreamCursorInput>>;
  where?: InputMaybe<LessonTypesBoolExp>;
};


export type Subscription_RootLessonWaitlistStatusesArgs = {
  distinctOn?: InputMaybe<Array<LessonWaitlistStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonWaitlistStatusesOrderBy>>;
  where?: InputMaybe<LessonWaitlistStatusesBoolExp>;
};


export type Subscription_RootLessonWaitlistStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonWaitlistStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonWaitlistStatusesOrderBy>>;
  where?: InputMaybe<LessonWaitlistStatusesBoolExp>;
};


export type Subscription_RootLessonWaitlistStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootLessonWaitlistStatusesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<LessonWaitlistStatusesStreamCursorInput>>;
  where?: InputMaybe<LessonWaitlistStatusesBoolExp>;
};


export type Subscription_RootLessonWaitlistsArgs = {
  distinctOn?: InputMaybe<Array<LessonWaitlistsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonWaitlistsOrderBy>>;
  where?: InputMaybe<LessonWaitlistsBoolExp>;
};


export type Subscription_RootLessonWaitlistsAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonWaitlistsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonWaitlistsOrderBy>>;
  where?: InputMaybe<LessonWaitlistsBoolExp>;
};


export type Subscription_RootLessonWaitlistsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootLessonWaitlistsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<LessonWaitlistsStreamCursorInput>>;
  where?: InputMaybe<LessonWaitlistsBoolExp>;
};


export type Subscription_RootLessonsArgs = {
  distinctOn?: InputMaybe<Array<LessonsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonsOrderBy>>;
  where?: InputMaybe<LessonsBoolExp>;
};


export type Subscription_RootLessonsAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonsOrderBy>>;
  where?: InputMaybe<LessonsBoolExp>;
};


export type Subscription_RootLessonsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootLessonsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<LessonsStreamCursorInput>>;
  where?: InputMaybe<LessonsBoolExp>;
};


export type Subscription_RootMatchSelectionCriteriaArgs = {
  distinctOn?: InputMaybe<Array<MatchSelectionCriteriaSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MatchSelectionCriteriaOrderBy>>;
  where?: InputMaybe<MatchSelectionCriteriaBoolExp>;
};


export type Subscription_RootMatchSelectionCriteriaAggregateArgs = {
  distinctOn?: InputMaybe<Array<MatchSelectionCriteriaSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MatchSelectionCriteriaOrderBy>>;
  where?: InputMaybe<MatchSelectionCriteriaBoolExp>;
};


export type Subscription_RootMatchSelectionCriteriaByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootMatchSelectionCriteriaStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<MatchSelectionCriteriaStreamCursorInput>>;
  where?: InputMaybe<MatchSelectionCriteriaBoolExp>;
};


export type Subscription_RootMessagesArgs = {
  distinctOn?: InputMaybe<Array<MessagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MessagesOrderBy>>;
  where?: InputMaybe<MessagesBoolExp>;
};


export type Subscription_RootMessagesAggregateArgs = {
  distinctOn?: InputMaybe<Array<MessagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MessagesOrderBy>>;
  where?: InputMaybe<MessagesBoolExp>;
};


export type Subscription_RootMessagesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootMessagesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<MessagesStreamCursorInput>>;
  where?: InputMaybe<MessagesBoolExp>;
};


export type Subscription_RootNeighborhoodsArgs = {
  distinctOn?: InputMaybe<Array<NeighborhoodsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NeighborhoodsOrderBy>>;
  where?: InputMaybe<NeighborhoodsBoolExp>;
};


export type Subscription_RootNeighborhoodsAggregateArgs = {
  distinctOn?: InputMaybe<Array<NeighborhoodsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NeighborhoodsOrderBy>>;
  where?: InputMaybe<NeighborhoodsBoolExp>;
};


export type Subscription_RootNeighborhoodsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootNeighborhoodsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<NeighborhoodsStreamCursorInput>>;
  where?: InputMaybe<NeighborhoodsBoolExp>;
};


export type Subscription_RootNotificationActionTypesArgs = {
  distinctOn?: InputMaybe<Array<NotificationActionTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NotificationActionTypesOrderBy>>;
  where?: InputMaybe<NotificationActionTypesBoolExp>;
};


export type Subscription_RootNotificationActionTypesAggregateArgs = {
  distinctOn?: InputMaybe<Array<NotificationActionTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NotificationActionTypesOrderBy>>;
  where?: InputMaybe<NotificationActionTypesBoolExp>;
};


export type Subscription_RootNotificationActionTypesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootNotificationActionTypesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<NotificationActionTypesStreamCursorInput>>;
  where?: InputMaybe<NotificationActionTypesBoolExp>;
};


export type Subscription_RootNotificationStatusesArgs = {
  distinctOn?: InputMaybe<Array<NotificationStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NotificationStatusesOrderBy>>;
  where?: InputMaybe<NotificationStatusesBoolExp>;
};


export type Subscription_RootNotificationStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<NotificationStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NotificationStatusesOrderBy>>;
  where?: InputMaybe<NotificationStatusesBoolExp>;
};


export type Subscription_RootNotificationStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootNotificationStatusesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<NotificationStatusesStreamCursorInput>>;
  where?: InputMaybe<NotificationStatusesBoolExp>;
};


export type Subscription_RootOrderStatusesArgs = {
  distinctOn?: InputMaybe<Array<OrderStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrderStatusesOrderBy>>;
  where?: InputMaybe<OrderStatusesBoolExp>;
};


export type Subscription_RootOrderStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<OrderStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrderStatusesOrderBy>>;
  where?: InputMaybe<OrderStatusesBoolExp>;
};


export type Subscription_RootOrderStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootOrderStatusesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<OrderStatusesStreamCursorInput>>;
  where?: InputMaybe<OrderStatusesBoolExp>;
};


export type Subscription_RootPadelRatingScalesArgs = {
  distinctOn?: InputMaybe<Array<PadelRatingScalesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PadelRatingScalesOrderBy>>;
  where?: InputMaybe<PadelRatingScalesBoolExp>;
};


export type Subscription_RootPadelRatingScalesAggregateArgs = {
  distinctOn?: InputMaybe<Array<PadelRatingScalesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PadelRatingScalesOrderBy>>;
  where?: InputMaybe<PadelRatingScalesBoolExp>;
};


export type Subscription_RootPadelRatingScalesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPadelRatingScalesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PadelRatingScalesStreamCursorInput>>;
  where?: InputMaybe<PadelRatingScalesBoolExp>;
};


export type Subscription_RootParticipantRolesArgs = {
  distinctOn?: InputMaybe<Array<ParticipantRolesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ParticipantRolesOrderBy>>;
  where?: InputMaybe<ParticipantRolesBoolExp>;
};


export type Subscription_RootParticipantRolesAggregateArgs = {
  distinctOn?: InputMaybe<Array<ParticipantRolesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ParticipantRolesOrderBy>>;
  where?: InputMaybe<ParticipantRolesBoolExp>;
};


export type Subscription_RootParticipantRolesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootParticipantRolesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<ParticipantRolesStreamCursorInput>>;
  where?: InputMaybe<ParticipantRolesBoolExp>;
};


export type Subscription_RootPartnerBookingAttemptEventsArgs = {
  distinctOn?: InputMaybe<Array<PartnerBookingAttemptEventsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PartnerBookingAttemptEventsOrderBy>>;
  where?: InputMaybe<PartnerBookingAttemptEventsBoolExp>;
};


export type Subscription_RootPartnerBookingAttemptEventsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PartnerBookingAttemptEventsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PartnerBookingAttemptEventsOrderBy>>;
  where?: InputMaybe<PartnerBookingAttemptEventsBoolExp>;
};


export type Subscription_RootPartnerBookingAttemptEventsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPartnerBookingAttemptEventsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PartnerBookingAttemptEventsStreamCursorInput>>;
  where?: InputMaybe<PartnerBookingAttemptEventsBoolExp>;
};


export type Subscription_RootPartnerBookingAttemptStatusesArgs = {
  distinctOn?: InputMaybe<Array<PartnerBookingAttemptStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PartnerBookingAttemptStatusesOrderBy>>;
  where?: InputMaybe<PartnerBookingAttemptStatusesBoolExp>;
};


export type Subscription_RootPartnerBookingAttemptStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<PartnerBookingAttemptStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PartnerBookingAttemptStatusesOrderBy>>;
  where?: InputMaybe<PartnerBookingAttemptStatusesBoolExp>;
};


export type Subscription_RootPartnerBookingAttemptStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootPartnerBookingAttemptStatusesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PartnerBookingAttemptStatusesStreamCursorInput>>;
  where?: InputMaybe<PartnerBookingAttemptStatusesBoolExp>;
};


export type Subscription_RootPartnerBookingAttemptsArgs = {
  distinctOn?: InputMaybe<Array<PartnerBookingAttemptsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PartnerBookingAttemptsOrderBy>>;
  where?: InputMaybe<PartnerBookingAttemptsBoolExp>;
};


export type Subscription_RootPartnerBookingAttemptsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PartnerBookingAttemptsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PartnerBookingAttemptsOrderBy>>;
  where?: InputMaybe<PartnerBookingAttemptsBoolExp>;
};


export type Subscription_RootPartnerBookingAttemptsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPartnerBookingAttemptsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PartnerBookingAttemptsStreamCursorInput>>;
  where?: InputMaybe<PartnerBookingAttemptsBoolExp>;
};


export type Subscription_RootPartnerBookingEnginesArgs = {
  distinctOn?: InputMaybe<Array<PartnerBookingEnginesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PartnerBookingEnginesOrderBy>>;
  where?: InputMaybe<PartnerBookingEnginesBoolExp>;
};


export type Subscription_RootPartnerBookingEnginesAggregateArgs = {
  distinctOn?: InputMaybe<Array<PartnerBookingEnginesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PartnerBookingEnginesOrderBy>>;
  where?: InputMaybe<PartnerBookingEnginesBoolExp>;
};


export type Subscription_RootPartnerBookingEnginesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootPartnerBookingEnginesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PartnerBookingEnginesStreamCursorInput>>;
  where?: InputMaybe<PartnerBookingEnginesBoolExp>;
};


export type Subscription_RootPartnerBookingEventSourcesArgs = {
  distinctOn?: InputMaybe<Array<PartnerBookingEventSourcesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PartnerBookingEventSourcesOrderBy>>;
  where?: InputMaybe<PartnerBookingEventSourcesBoolExp>;
};


export type Subscription_RootPartnerBookingEventSourcesAggregateArgs = {
  distinctOn?: InputMaybe<Array<PartnerBookingEventSourcesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PartnerBookingEventSourcesOrderBy>>;
  where?: InputMaybe<PartnerBookingEventSourcesBoolExp>;
};


export type Subscription_RootPartnerBookingEventSourcesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootPartnerBookingEventSourcesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PartnerBookingEventSourcesStreamCursorInput>>;
  where?: InputMaybe<PartnerBookingEventSourcesBoolExp>;
};


export type Subscription_RootPartnerBookingHoldsArgs = {
  distinctOn?: InputMaybe<Array<PartnerBookingHoldsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PartnerBookingHoldsOrderBy>>;
  where?: InputMaybe<PartnerBookingHoldsBoolExp>;
};


export type Subscription_RootPartnerBookingHoldsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PartnerBookingHoldsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PartnerBookingHoldsOrderBy>>;
  where?: InputMaybe<PartnerBookingHoldsBoolExp>;
};


export type Subscription_RootPartnerBookingHoldsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPartnerBookingHoldsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PartnerBookingHoldsStreamCursorInput>>;
  where?: InputMaybe<PartnerBookingHoldsBoolExp>;
};


export type Subscription_RootPartnerBookingOrderStatusesArgs = {
  distinctOn?: InputMaybe<Array<PartnerBookingOrderStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PartnerBookingOrderStatusesOrderBy>>;
  where?: InputMaybe<PartnerBookingOrderStatusesBoolExp>;
};


export type Subscription_RootPartnerBookingOrderStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<PartnerBookingOrderStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PartnerBookingOrderStatusesOrderBy>>;
  where?: InputMaybe<PartnerBookingOrderStatusesBoolExp>;
};


export type Subscription_RootPartnerBookingOrderStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootPartnerBookingOrderStatusesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PartnerBookingOrderStatusesStreamCursorInput>>;
  where?: InputMaybe<PartnerBookingOrderStatusesBoolExp>;
};


export type Subscription_RootPartnerBookingOrdersArgs = {
  distinctOn?: InputMaybe<Array<PartnerBookingOrdersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PartnerBookingOrdersOrderBy>>;
  where?: InputMaybe<PartnerBookingOrdersBoolExp>;
};


export type Subscription_RootPartnerBookingOrdersAggregateArgs = {
  distinctOn?: InputMaybe<Array<PartnerBookingOrdersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PartnerBookingOrdersOrderBy>>;
  where?: InputMaybe<PartnerBookingOrdersBoolExp>;
};


export type Subscription_RootPartnerBookingOrdersByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPartnerBookingOrdersStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PartnerBookingOrdersStreamCursorInput>>;
  where?: InputMaybe<PartnerBookingOrdersBoolExp>;
};


export type Subscription_RootPartnerBookingVerificationMethodsArgs = {
  distinctOn?: InputMaybe<Array<PartnerBookingVerificationMethodsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PartnerBookingVerificationMethodsOrderBy>>;
  where?: InputMaybe<PartnerBookingVerificationMethodsBoolExp>;
};


export type Subscription_RootPartnerBookingVerificationMethodsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PartnerBookingVerificationMethodsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PartnerBookingVerificationMethodsOrderBy>>;
  where?: InputMaybe<PartnerBookingVerificationMethodsBoolExp>;
};


export type Subscription_RootPartnerBookingVerificationMethodsByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootPartnerBookingVerificationMethodsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PartnerBookingVerificationMethodsStreamCursorInput>>;
  where?: InputMaybe<PartnerBookingVerificationMethodsBoolExp>;
};


export type Subscription_RootPaymentFulfillmentChannelsArgs = {
  distinctOn?: InputMaybe<Array<PaymentFulfillmentChannelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentFulfillmentChannelsOrderBy>>;
  where?: InputMaybe<PaymentFulfillmentChannelsBoolExp>;
};


export type Subscription_RootPaymentFulfillmentChannelsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PaymentFulfillmentChannelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentFulfillmentChannelsOrderBy>>;
  where?: InputMaybe<PaymentFulfillmentChannelsBoolExp>;
};


export type Subscription_RootPaymentFulfillmentChannelsByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootPaymentFulfillmentChannelsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PaymentFulfillmentChannelsStreamCursorInput>>;
  where?: InputMaybe<PaymentFulfillmentChannelsBoolExp>;
};


export type Subscription_RootPaymentProcessorsArgs = {
  distinctOn?: InputMaybe<Array<PaymentProcessorsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentProcessorsOrderBy>>;
  where?: InputMaybe<PaymentProcessorsBoolExp>;
};


export type Subscription_RootPaymentProcessorsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PaymentProcessorsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentProcessorsOrderBy>>;
  where?: InputMaybe<PaymentProcessorsBoolExp>;
};


export type Subscription_RootPaymentProcessorsByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootPaymentProcessorsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PaymentProcessorsStreamCursorInput>>;
  where?: InputMaybe<PaymentProcessorsBoolExp>;
};


export type Subscription_RootPaymentStatusesArgs = {
  distinctOn?: InputMaybe<Array<PaymentStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentStatusesOrderBy>>;
  where?: InputMaybe<PaymentStatusesBoolExp>;
};


export type Subscription_RootPaymentStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<PaymentStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentStatusesOrderBy>>;
  where?: InputMaybe<PaymentStatusesBoolExp>;
};


export type Subscription_RootPaymentStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootPaymentStatusesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PaymentStatusesStreamCursorInput>>;
  where?: InputMaybe<PaymentStatusesBoolExp>;
};


export type Subscription_RootPickleballRatingScalesArgs = {
  distinctOn?: InputMaybe<Array<PickleballRatingScalesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PickleballRatingScalesOrderBy>>;
  where?: InputMaybe<PickleballRatingScalesBoolExp>;
};


export type Subscription_RootPickleballRatingScalesAggregateArgs = {
  distinctOn?: InputMaybe<Array<PickleballRatingScalesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PickleballRatingScalesOrderBy>>;
  where?: InputMaybe<PickleballRatingScalesBoolExp>;
};


export type Subscription_RootPickleballRatingScalesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPickleballRatingScalesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PickleballRatingScalesStreamCursorInput>>;
  where?: InputMaybe<PickleballRatingScalesBoolExp>;
};


export type Subscription_RootPlatformSubscriptionIntervalsArgs = {
  distinctOn?: InputMaybe<Array<PlatformSubscriptionIntervalsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlatformSubscriptionIntervalsOrderBy>>;
  where?: InputMaybe<PlatformSubscriptionIntervalsBoolExp>;
};


export type Subscription_RootPlatformSubscriptionIntervalsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PlatformSubscriptionIntervalsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlatformSubscriptionIntervalsOrderBy>>;
  where?: InputMaybe<PlatformSubscriptionIntervalsBoolExp>;
};


export type Subscription_RootPlatformSubscriptionIntervalsByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootPlatformSubscriptionIntervalsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PlatformSubscriptionIntervalsStreamCursorInput>>;
  where?: InputMaybe<PlatformSubscriptionIntervalsBoolExp>;
};


export type Subscription_RootPlatformSubscriptionPersonasArgs = {
  distinctOn?: InputMaybe<Array<PlatformSubscriptionPersonasSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlatformSubscriptionPersonasOrderBy>>;
  where?: InputMaybe<PlatformSubscriptionPersonasBoolExp>;
};


export type Subscription_RootPlatformSubscriptionPersonasAggregateArgs = {
  distinctOn?: InputMaybe<Array<PlatformSubscriptionPersonasSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlatformSubscriptionPersonasOrderBy>>;
  where?: InputMaybe<PlatformSubscriptionPersonasBoolExp>;
};


export type Subscription_RootPlatformSubscriptionPersonasByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootPlatformSubscriptionPersonasStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PlatformSubscriptionPersonasStreamCursorInput>>;
  where?: InputMaybe<PlatformSubscriptionPersonasBoolExp>;
};


export type Subscription_RootPlatformSubscriptionPlanPricesArgs = {
  distinctOn?: InputMaybe<Array<PlatformSubscriptionPlanPricesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlatformSubscriptionPlanPricesOrderBy>>;
  where?: InputMaybe<PlatformSubscriptionPlanPricesBoolExp>;
};


export type Subscription_RootPlatformSubscriptionPlanPricesAggregateArgs = {
  distinctOn?: InputMaybe<Array<PlatformSubscriptionPlanPricesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlatformSubscriptionPlanPricesOrderBy>>;
  where?: InputMaybe<PlatformSubscriptionPlanPricesBoolExp>;
};


export type Subscription_RootPlatformSubscriptionPlanPricesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPlatformSubscriptionPlanPricesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PlatformSubscriptionPlanPricesStreamCursorInput>>;
  where?: InputMaybe<PlatformSubscriptionPlanPricesBoolExp>;
};


export type Subscription_RootPlatformSubscriptionPlansArgs = {
  distinctOn?: InputMaybe<Array<PlatformSubscriptionPlansSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlatformSubscriptionPlansOrderBy>>;
  where?: InputMaybe<PlatformSubscriptionPlansBoolExp>;
};


export type Subscription_RootPlatformSubscriptionPlansAggregateArgs = {
  distinctOn?: InputMaybe<Array<PlatformSubscriptionPlansSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlatformSubscriptionPlansOrderBy>>;
  where?: InputMaybe<PlatformSubscriptionPlansBoolExp>;
};


export type Subscription_RootPlatformSubscriptionPlansByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPlatformSubscriptionPlansStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PlatformSubscriptionPlansStreamCursorInput>>;
  where?: InputMaybe<PlatformSubscriptionPlansBoolExp>;
};


export type Subscription_RootPlatformSubscriptionsArgs = {
  distinctOn?: InputMaybe<Array<PlatformSubscriptionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlatformSubscriptionsOrderBy>>;
  where?: InputMaybe<PlatformSubscriptionsBoolExp>;
};


export type Subscription_RootPlatformSubscriptionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PlatformSubscriptionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlatformSubscriptionsOrderBy>>;
  where?: InputMaybe<PlatformSubscriptionsBoolExp>;
};


export type Subscription_RootPlatformSubscriptionsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPlatformSubscriptionsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PlatformSubscriptionsStreamCursorInput>>;
  where?: InputMaybe<PlatformSubscriptionsBoolExp>;
};


export type Subscription_RootPlayRequestNeighborhoodsArgs = {
  distinctOn?: InputMaybe<Array<PlayRequestNeighborhoodsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayRequestNeighborhoodsOrderBy>>;
  where?: InputMaybe<PlayRequestNeighborhoodsBoolExp>;
};


export type Subscription_RootPlayRequestNeighborhoodsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PlayRequestNeighborhoodsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayRequestNeighborhoodsOrderBy>>;
  where?: InputMaybe<PlayRequestNeighborhoodsBoolExp>;
};


export type Subscription_RootPlayRequestNeighborhoodsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPlayRequestNeighborhoodsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PlayRequestNeighborhoodsStreamCursorInput>>;
  where?: InputMaybe<PlayRequestNeighborhoodsBoolExp>;
};


export type Subscription_RootPlayRequestSlotsArgs = {
  distinctOn?: InputMaybe<Array<PlayRequestSlotsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayRequestSlotsOrderBy>>;
  where?: InputMaybe<PlayRequestSlotsBoolExp>;
};


export type Subscription_RootPlayRequestSlotsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PlayRequestSlotsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayRequestSlotsOrderBy>>;
  where?: InputMaybe<PlayRequestSlotsBoolExp>;
};


export type Subscription_RootPlayRequestSlotsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPlayRequestSlotsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PlayRequestSlotsStreamCursorInput>>;
  where?: InputMaybe<PlayRequestSlotsBoolExp>;
};


export type Subscription_RootPlayRequestStatusesArgs = {
  distinctOn?: InputMaybe<Array<PlayRequestStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayRequestStatusesOrderBy>>;
  where?: InputMaybe<PlayRequestStatusesBoolExp>;
};


export type Subscription_RootPlayRequestStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<PlayRequestStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayRequestStatusesOrderBy>>;
  where?: InputMaybe<PlayRequestStatusesBoolExp>;
};


export type Subscription_RootPlayRequestStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootPlayRequestStatusesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PlayRequestStatusesStreamCursorInput>>;
  where?: InputMaybe<PlayRequestStatusesBoolExp>;
};


export type Subscription_RootPlayRequestVenuesArgs = {
  distinctOn?: InputMaybe<Array<PlayRequestVenuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayRequestVenuesOrderBy>>;
  where?: InputMaybe<PlayRequestVenuesBoolExp>;
};


export type Subscription_RootPlayRequestVenuesAggregateArgs = {
  distinctOn?: InputMaybe<Array<PlayRequestVenuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayRequestVenuesOrderBy>>;
  where?: InputMaybe<PlayRequestVenuesBoolExp>;
};


export type Subscription_RootPlayRequestVenuesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPlayRequestVenuesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PlayRequestVenuesStreamCursorInput>>;
  where?: InputMaybe<PlayRequestVenuesBoolExp>;
};


export type Subscription_RootPlayRequestsArgs = {
  distinctOn?: InputMaybe<Array<PlayRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayRequestsOrderBy>>;
  where?: InputMaybe<PlayRequestsBoolExp>;
};


export type Subscription_RootPlayRequestsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PlayRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayRequestsOrderBy>>;
  where?: InputMaybe<PlayRequestsBoolExp>;
};


export type Subscription_RootPlayRequestsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPlayRequestsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PlayRequestsStreamCursorInput>>;
  where?: InputMaybe<PlayRequestsBoolExp>;
};


export type Subscription_RootPlaySessionCommentsArgs = {
  distinctOn?: InputMaybe<Array<PlaySessionCommentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlaySessionCommentsOrderBy>>;
  where?: InputMaybe<PlaySessionCommentsBoolExp>;
};


export type Subscription_RootPlaySessionCommentsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PlaySessionCommentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlaySessionCommentsOrderBy>>;
  where?: InputMaybe<PlaySessionCommentsBoolExp>;
};


export type Subscription_RootPlaySessionCommentsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPlaySessionCommentsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PlaySessionCommentsStreamCursorInput>>;
  where?: InputMaybe<PlaySessionCommentsBoolExp>;
};


export type Subscription_RootPlaySessionCourtBookingStatusesArgs = {
  distinctOn?: InputMaybe<Array<PlaySessionCourtBookingStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlaySessionCourtBookingStatusesOrderBy>>;
  where?: InputMaybe<PlaySessionCourtBookingStatusesBoolExp>;
};


export type Subscription_RootPlaySessionCourtBookingStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<PlaySessionCourtBookingStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlaySessionCourtBookingStatusesOrderBy>>;
  where?: InputMaybe<PlaySessionCourtBookingStatusesBoolExp>;
};


export type Subscription_RootPlaySessionCourtBookingStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootPlaySessionCourtBookingStatusesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PlaySessionCourtBookingStatusesStreamCursorInput>>;
  where?: InputMaybe<PlaySessionCourtBookingStatusesBoolExp>;
};


export type Subscription_RootPlaySessionFormatsArgs = {
  distinctOn?: InputMaybe<Array<PlaySessionFormatsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlaySessionFormatsOrderBy>>;
  where?: InputMaybe<PlaySessionFormatsBoolExp>;
};


export type Subscription_RootPlaySessionFormatsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PlaySessionFormatsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlaySessionFormatsOrderBy>>;
  where?: InputMaybe<PlaySessionFormatsBoolExp>;
};


export type Subscription_RootPlaySessionFormatsByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootPlaySessionFormatsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PlaySessionFormatsStreamCursorInput>>;
  where?: InputMaybe<PlaySessionFormatsBoolExp>;
};


export type Subscription_RootPlaySessionMatchCompetitivenessArgs = {
  distinctOn?: InputMaybe<Array<PlaySessionMatchCompetitivenessSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlaySessionMatchCompetitivenessOrderBy>>;
  where?: InputMaybe<PlaySessionMatchCompetitivenessBoolExp>;
};


export type Subscription_RootPlaySessionMatchCompetitivenessAggregateArgs = {
  distinctOn?: InputMaybe<Array<PlaySessionMatchCompetitivenessSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlaySessionMatchCompetitivenessOrderBy>>;
  where?: InputMaybe<PlaySessionMatchCompetitivenessBoolExp>;
};


export type Subscription_RootPlaySessionMatchCompetitivenessByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootPlaySessionMatchCompetitivenessStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PlaySessionMatchCompetitivenessStreamCursorInput>>;
  where?: InputMaybe<PlaySessionMatchCompetitivenessBoolExp>;
};


export type Subscription_RootPlaySessionParticipantStatusesArgs = {
  distinctOn?: InputMaybe<Array<PlaySessionParticipantStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlaySessionParticipantStatusesOrderBy>>;
  where?: InputMaybe<PlaySessionParticipantStatusesBoolExp>;
};


export type Subscription_RootPlaySessionParticipantStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<PlaySessionParticipantStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlaySessionParticipantStatusesOrderBy>>;
  where?: InputMaybe<PlaySessionParticipantStatusesBoolExp>;
};


export type Subscription_RootPlaySessionParticipantStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootPlaySessionParticipantStatusesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PlaySessionParticipantStatusesStreamCursorInput>>;
  where?: InputMaybe<PlaySessionParticipantStatusesBoolExp>;
};


export type Subscription_RootPlaySessionParticipantsArgs = {
  distinctOn?: InputMaybe<Array<PlaySessionParticipantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlaySessionParticipantsOrderBy>>;
  where?: InputMaybe<PlaySessionParticipantsBoolExp>;
};


export type Subscription_RootPlaySessionParticipantsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PlaySessionParticipantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlaySessionParticipantsOrderBy>>;
  where?: InputMaybe<PlaySessionParticipantsBoolExp>;
};


export type Subscription_RootPlaySessionParticipantsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPlaySessionParticipantsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PlaySessionParticipantsStreamCursorInput>>;
  where?: InputMaybe<PlaySessionParticipantsBoolExp>;
};


export type Subscription_RootPlaySessionPrivacyArgs = {
  distinctOn?: InputMaybe<Array<PlaySessionPrivacySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlaySessionPrivacyOrderBy>>;
  where?: InputMaybe<PlaySessionPrivacyBoolExp>;
};


export type Subscription_RootPlaySessionPrivacyAggregateArgs = {
  distinctOn?: InputMaybe<Array<PlaySessionPrivacySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlaySessionPrivacyOrderBy>>;
  where?: InputMaybe<PlaySessionPrivacyBoolExp>;
};


export type Subscription_RootPlaySessionPrivacyByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootPlaySessionPrivacyStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PlaySessionPrivacyStreamCursorInput>>;
  where?: InputMaybe<PlaySessionPrivacyBoolExp>;
};


export type Subscription_RootPlaySessionStatusesArgs = {
  distinctOn?: InputMaybe<Array<PlaySessionStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlaySessionStatusesOrderBy>>;
  where?: InputMaybe<PlaySessionStatusesBoolExp>;
};


export type Subscription_RootPlaySessionStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<PlaySessionStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlaySessionStatusesOrderBy>>;
  where?: InputMaybe<PlaySessionStatusesBoolExp>;
};


export type Subscription_RootPlaySessionStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootPlaySessionStatusesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PlaySessionStatusesStreamCursorInput>>;
  where?: InputMaybe<PlaySessionStatusesBoolExp>;
};


export type Subscription_RootPlaySessionsArgs = {
  distinctOn?: InputMaybe<Array<PlaySessionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlaySessionsOrderBy>>;
  where?: InputMaybe<PlaySessionsBoolExp>;
};


export type Subscription_RootPlaySessionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PlaySessionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlaySessionsOrderBy>>;
  where?: InputMaybe<PlaySessionsBoolExp>;
};


export type Subscription_RootPlaySessionsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPlaySessionsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PlaySessionsStreamCursorInput>>;
  where?: InputMaybe<PlaySessionsBoolExp>;
};


export type Subscription_RootPlayerAvailabilitiesArgs = {
  distinctOn?: InputMaybe<Array<PlayerAvailabilitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayerAvailabilitiesOrderBy>>;
  where?: InputMaybe<PlayerAvailabilitiesBoolExp>;
};


export type Subscription_RootPlayerAvailabilitiesAggregateArgs = {
  distinctOn?: InputMaybe<Array<PlayerAvailabilitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayerAvailabilitiesOrderBy>>;
  where?: InputMaybe<PlayerAvailabilitiesBoolExp>;
};


export type Subscription_RootPlayerAvailabilitiesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPlayerAvailabilitiesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PlayerAvailabilitiesStreamCursorInput>>;
  where?: InputMaybe<PlayerAvailabilitiesBoolExp>;
};


export type Subscription_RootPlayerAvailabilityNeighborhoodsArgs = {
  distinctOn?: InputMaybe<Array<PlayerAvailabilityNeighborhoodsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayerAvailabilityNeighborhoodsOrderBy>>;
  where?: InputMaybe<PlayerAvailabilityNeighborhoodsBoolExp>;
};


export type Subscription_RootPlayerAvailabilityNeighborhoodsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PlayerAvailabilityNeighborhoodsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayerAvailabilityNeighborhoodsOrderBy>>;
  where?: InputMaybe<PlayerAvailabilityNeighborhoodsBoolExp>;
};


export type Subscription_RootPlayerAvailabilityNeighborhoodsByPkArgs = {
  availabilityId: Scalars['uuid'];
  neighborhoodId: Scalars['uuid'];
};


export type Subscription_RootPlayerAvailabilityNeighborhoodsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PlayerAvailabilityNeighborhoodsStreamCursorInput>>;
  where?: InputMaybe<PlayerAvailabilityNeighborhoodsBoolExp>;
};


export type Subscription_RootPlayerAvailabilityRatingScalesArgs = {
  distinctOn?: InputMaybe<Array<PlayerAvailabilityRatingScalesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayerAvailabilityRatingScalesOrderBy>>;
  where?: InputMaybe<PlayerAvailabilityRatingScalesBoolExp>;
};


export type Subscription_RootPlayerAvailabilityRatingScalesAggregateArgs = {
  distinctOn?: InputMaybe<Array<PlayerAvailabilityRatingScalesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayerAvailabilityRatingScalesOrderBy>>;
  where?: InputMaybe<PlayerAvailabilityRatingScalesBoolExp>;
};


export type Subscription_RootPlayerAvailabilityRatingScalesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPlayerAvailabilityRatingScalesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PlayerAvailabilityRatingScalesStreamCursorInput>>;
  where?: InputMaybe<PlayerAvailabilityRatingScalesBoolExp>;
};


export type Subscription_RootPlayerAvailabilitySlotsArgs = {
  distinctOn?: InputMaybe<Array<PlayerAvailabilitySlotsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayerAvailabilitySlotsOrderBy>>;
  where?: InputMaybe<PlayerAvailabilitySlotsBoolExp>;
};


export type Subscription_RootPlayerAvailabilitySlotsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PlayerAvailabilitySlotsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayerAvailabilitySlotsOrderBy>>;
  where?: InputMaybe<PlayerAvailabilitySlotsBoolExp>;
};


export type Subscription_RootPlayerAvailabilitySlotsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPlayerAvailabilitySlotsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PlayerAvailabilitySlotsStreamCursorInput>>;
  where?: InputMaybe<PlayerAvailabilitySlotsBoolExp>;
};


export type Subscription_RootPlayerAvailabilityVenuesArgs = {
  distinctOn?: InputMaybe<Array<PlayerAvailabilityVenuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayerAvailabilityVenuesOrderBy>>;
  where?: InputMaybe<PlayerAvailabilityVenuesBoolExp>;
};


export type Subscription_RootPlayerAvailabilityVenuesAggregateArgs = {
  distinctOn?: InputMaybe<Array<PlayerAvailabilityVenuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayerAvailabilityVenuesOrderBy>>;
  where?: InputMaybe<PlayerAvailabilityVenuesBoolExp>;
};


export type Subscription_RootPlayerAvailabilityVenuesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPlayerAvailabilityVenuesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PlayerAvailabilityVenuesStreamCursorInput>>;
  where?: InputMaybe<PlayerAvailabilityVenuesBoolExp>;
};


export type Subscription_RootPlayerFinderGoalsArgs = {
  distinctOn?: InputMaybe<Array<PlayerFinderGoalsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayerFinderGoalsOrderBy>>;
  where?: InputMaybe<PlayerFinderGoalsBoolExp>;
};


export type Subscription_RootPlayerFinderGoalsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PlayerFinderGoalsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayerFinderGoalsOrderBy>>;
  where?: InputMaybe<PlayerFinderGoalsBoolExp>;
};


export type Subscription_RootPlayerFinderGoalsByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootPlayerFinderGoalsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PlayerFinderGoalsStreamCursorInput>>;
  where?: InputMaybe<PlayerFinderGoalsBoolExp>;
};


export type Subscription_RootPlayerFinderTimeOfDayArgs = {
  distinctOn?: InputMaybe<Array<PlayerFinderTimeOfDaySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayerFinderTimeOfDayOrderBy>>;
  where?: InputMaybe<PlayerFinderTimeOfDayBoolExp>;
};


export type Subscription_RootPlayerFinderTimeOfDayAggregateArgs = {
  distinctOn?: InputMaybe<Array<PlayerFinderTimeOfDaySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayerFinderTimeOfDayOrderBy>>;
  where?: InputMaybe<PlayerFinderTimeOfDayBoolExp>;
};


export type Subscription_RootPlayerFinderTimeOfDayByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootPlayerFinderTimeOfDayStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PlayerFinderTimeOfDayStreamCursorInput>>;
  where?: InputMaybe<PlayerFinderTimeOfDayBoolExp>;
};


export type Subscription_RootRecurrenceKindsArgs = {
  distinctOn?: InputMaybe<Array<RecurrenceKindsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RecurrenceKindsOrderBy>>;
  where?: InputMaybe<RecurrenceKindsBoolExp>;
};


export type Subscription_RootRecurrenceKindsAggregateArgs = {
  distinctOn?: InputMaybe<Array<RecurrenceKindsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RecurrenceKindsOrderBy>>;
  where?: InputMaybe<RecurrenceKindsBoolExp>;
};


export type Subscription_RootRecurrenceKindsByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootRecurrenceKindsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<RecurrenceKindsStreamCursorInput>>;
  where?: InputMaybe<RecurrenceKindsBoolExp>;
};


export type Subscription_RootReportReasonsArgs = {
  distinctOn?: InputMaybe<Array<ReportReasonsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReportReasonsOrderBy>>;
  where?: InputMaybe<ReportReasonsBoolExp>;
};


export type Subscription_RootReportReasonsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ReportReasonsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReportReasonsOrderBy>>;
  where?: InputMaybe<ReportReasonsBoolExp>;
};


export type Subscription_RootReportReasonsByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootReportReasonsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<ReportReasonsStreamCursorInput>>;
  where?: InputMaybe<ReportReasonsBoolExp>;
};


export type Subscription_RootReportStatusesArgs = {
  distinctOn?: InputMaybe<Array<ReportStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReportStatusesOrderBy>>;
  where?: InputMaybe<ReportStatusesBoolExp>;
};


export type Subscription_RootReportStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<ReportStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReportStatusesOrderBy>>;
  where?: InputMaybe<ReportStatusesBoolExp>;
};


export type Subscription_RootReportStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootReportStatusesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<ReportStatusesStreamCursorInput>>;
  where?: InputMaybe<ReportStatusesBoolExp>;
};


export type Subscription_RootReviewsArgs = {
  distinctOn?: InputMaybe<Array<ReviewsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReviewsOrderBy>>;
  where?: InputMaybe<ReviewsBoolExp>;
};


export type Subscription_RootReviewsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ReviewsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReviewsOrderBy>>;
  where?: InputMaybe<ReviewsBoolExp>;
};


export type Subscription_RootReviewsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootReviewsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<ReviewsStreamCursorInput>>;
  where?: InputMaybe<ReviewsBoolExp>;
};


export type Subscription_RootSalesArgs = {
  distinctOn?: InputMaybe<Array<SalesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SalesOrderBy>>;
  where?: InputMaybe<SalesBoolExp>;
};


export type Subscription_RootSalesAggregateArgs = {
  distinctOn?: InputMaybe<Array<SalesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SalesOrderBy>>;
  where?: InputMaybe<SalesBoolExp>;
};


export type Subscription_RootSalesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSalesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<SalesStreamCursorInput>>;
  where?: InputMaybe<SalesBoolExp>;
};


export type Subscription_RootScoringFormatArgs = {
  distinctOn?: InputMaybe<Array<ScoringFormatSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScoringFormatOrderBy>>;
  where?: InputMaybe<ScoringFormatBoolExp>;
};


export type Subscription_RootScoringFormatAggregateArgs = {
  distinctOn?: InputMaybe<Array<ScoringFormatSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScoringFormatOrderBy>>;
  where?: InputMaybe<ScoringFormatBoolExp>;
};


export type Subscription_RootScoringFormatByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootScoringFormatStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<ScoringFormatStreamCursorInput>>;
  where?: InputMaybe<ScoringFormatBoolExp>;
};


export type Subscription_RootSignupRequestsArgs = {
  distinctOn?: InputMaybe<Array<SignupRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SignupRequestsOrderBy>>;
  where?: InputMaybe<SignupRequestsBoolExp>;
};


export type Subscription_RootSignupRequestsAggregateArgs = {
  distinctOn?: InputMaybe<Array<SignupRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SignupRequestsOrderBy>>;
  where?: InputMaybe<SignupRequestsBoolExp>;
};


export type Subscription_RootSignupRequestsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSignupRequestsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<SignupRequestsStreamCursorInput>>;
  where?: InputMaybe<SignupRequestsBoolExp>;
};


export type Subscription_RootSkillLevelValuesArgs = {
  distinctOn?: InputMaybe<Array<SkillLevelValuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SkillLevelValuesOrderBy>>;
  where?: InputMaybe<SkillLevelValuesBoolExp>;
};


export type Subscription_RootSkillLevelValuesAggregateArgs = {
  distinctOn?: InputMaybe<Array<SkillLevelValuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SkillLevelValuesOrderBy>>;
  where?: InputMaybe<SkillLevelValuesBoolExp>;
};


export type Subscription_RootSkillLevelValuesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootSkillLevelValuesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<SkillLevelValuesStreamCursorInput>>;
  where?: InputMaybe<SkillLevelValuesBoolExp>;
};


export type Subscription_RootSkillLevelsArgs = {
  distinctOn?: InputMaybe<Array<SkillLevelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SkillLevelsOrderBy>>;
  where?: InputMaybe<SkillLevelsBoolExp>;
};


export type Subscription_RootSkillLevelsAggregateArgs = {
  distinctOn?: InputMaybe<Array<SkillLevelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SkillLevelsOrderBy>>;
  where?: InputMaybe<SkillLevelsBoolExp>;
};


export type Subscription_RootSkillLevelsByPkArgs = {
  id: SkillLevelValuesEnum;
};


export type Subscription_RootSkillLevelsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<SkillLevelsStreamCursorInput>>;
  where?: InputMaybe<SkillLevelsBoolExp>;
};


export type Subscription_RootSportsArgs = {
  distinctOn?: InputMaybe<Array<SportsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SportsOrderBy>>;
  where?: InputMaybe<SportsBoolExp>;
};


export type Subscription_RootSportsAggregateArgs = {
  distinctOn?: InputMaybe<Array<SportsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SportsOrderBy>>;
  where?: InputMaybe<SportsBoolExp>;
};


export type Subscription_RootSportsByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootSportsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<SportsStreamCursorInput>>;
  where?: InputMaybe<SportsBoolExp>;
};


export type Subscription_RootStripeChargesArgs = {
  distinctOn?: InputMaybe<Array<StripeChargesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<StripeChargesOrderBy>>;
  where?: InputMaybe<StripeChargesBoolExp>;
};


export type Subscription_RootStripeChargesAggregateArgs = {
  distinctOn?: InputMaybe<Array<StripeChargesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<StripeChargesOrderBy>>;
  where?: InputMaybe<StripeChargesBoolExp>;
};


export type Subscription_RootStripeChargesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootStripeChargesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<StripeChargesStreamCursorInput>>;
  where?: InputMaybe<StripeChargesBoolExp>;
};


export type Subscription_RootStripePaymentIntentsArgs = {
  distinctOn?: InputMaybe<Array<StripePaymentIntentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<StripePaymentIntentsOrderBy>>;
  where?: InputMaybe<StripePaymentIntentsBoolExp>;
};


export type Subscription_RootStripePaymentIntentsAggregateArgs = {
  distinctOn?: InputMaybe<Array<StripePaymentIntentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<StripePaymentIntentsOrderBy>>;
  where?: InputMaybe<StripePaymentIntentsBoolExp>;
};


export type Subscription_RootStripePaymentIntentsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootStripePaymentIntentsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<StripePaymentIntentsStreamCursorInput>>;
  where?: InputMaybe<StripePaymentIntentsBoolExp>;
};


export type Subscription_RootSubscriptionStatusesArgs = {
  distinctOn?: InputMaybe<Array<SubscriptionStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SubscriptionStatusesOrderBy>>;
  where?: InputMaybe<SubscriptionStatusesBoolExp>;
};


export type Subscription_RootSubscriptionStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<SubscriptionStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SubscriptionStatusesOrderBy>>;
  where?: InputMaybe<SubscriptionStatusesBoolExp>;
};


export type Subscription_RootSubscriptionStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootSubscriptionStatusesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<SubscriptionStatusesStreamCursorInput>>;
  where?: InputMaybe<SubscriptionStatusesBoolExp>;
};


export type Subscription_RootTeamTypesArgs = {
  distinctOn?: InputMaybe<Array<TeamTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TeamTypesOrderBy>>;
  where?: InputMaybe<TeamTypesBoolExp>;
};


export type Subscription_RootTeamTypesAggregateArgs = {
  distinctOn?: InputMaybe<Array<TeamTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TeamTypesOrderBy>>;
  where?: InputMaybe<TeamTypesBoolExp>;
};


export type Subscription_RootTeamTypesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootTeamTypesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<TeamTypesStreamCursorInput>>;
  where?: InputMaybe<TeamTypesBoolExp>;
};


export type Subscription_RootTennisRatingScalesArgs = {
  distinctOn?: InputMaybe<Array<TennisRatingScalesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TennisRatingScalesOrderBy>>;
  where?: InputMaybe<TennisRatingScalesBoolExp>;
};


export type Subscription_RootTennisRatingScalesAggregateArgs = {
  distinctOn?: InputMaybe<Array<TennisRatingScalesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TennisRatingScalesOrderBy>>;
  where?: InputMaybe<TennisRatingScalesBoolExp>;
};


export type Subscription_RootTennisRatingScalesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootTennisRatingScalesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<TennisRatingScalesStreamCursorInput>>;
  where?: InputMaybe<TennisRatingScalesBoolExp>;
};


export type Subscription_RootTwilioGroupTextsArgs = {
  distinctOn?: InputMaybe<Array<TwilioGroupTextsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TwilioGroupTextsOrderBy>>;
  where?: InputMaybe<TwilioGroupTextsBoolExp>;
};


export type Subscription_RootTwilioGroupTextsAggregateArgs = {
  distinctOn?: InputMaybe<Array<TwilioGroupTextsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TwilioGroupTextsOrderBy>>;
  where?: InputMaybe<TwilioGroupTextsBoolExp>;
};


export type Subscription_RootTwilioGroupTextsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootTwilioGroupTextsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<TwilioGroupTextsStreamCursorInput>>;
  where?: InputMaybe<TwilioGroupTextsBoolExp>;
};


export type Subscription_RootUploadReviewRequestsArgs = {
  distinctOn?: InputMaybe<Array<UploadReviewRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UploadReviewRequestsOrderBy>>;
  where?: InputMaybe<UploadReviewRequestsBoolExp>;
};


export type Subscription_RootUploadReviewRequestsAggregateArgs = {
  distinctOn?: InputMaybe<Array<UploadReviewRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UploadReviewRequestsOrderBy>>;
  where?: InputMaybe<UploadReviewRequestsBoolExp>;
};


export type Subscription_RootUploadReviewRequestsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUploadReviewRequestsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<UploadReviewRequestsStreamCursorInput>>;
  where?: InputMaybe<UploadReviewRequestsBoolExp>;
};


export type Subscription_RootUserAuthIdentitiesArgs = {
  distinctOn?: InputMaybe<Array<UserAuthIdentitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserAuthIdentitiesOrderBy>>;
  where?: InputMaybe<UserAuthIdentitiesBoolExp>;
};


export type Subscription_RootUserAuthIdentitiesAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserAuthIdentitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserAuthIdentitiesOrderBy>>;
  where?: InputMaybe<UserAuthIdentitiesBoolExp>;
};


export type Subscription_RootUserAuthIdentitiesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUserAuthIdentitiesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<UserAuthIdentitiesStreamCursorInput>>;
  where?: InputMaybe<UserAuthIdentitiesBoolExp>;
};


export type Subscription_RootUserBlocksArgs = {
  distinctOn?: InputMaybe<Array<UserBlocksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserBlocksOrderBy>>;
  where?: InputMaybe<UserBlocksBoolExp>;
};


export type Subscription_RootUserBlocksAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserBlocksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserBlocksOrderBy>>;
  where?: InputMaybe<UserBlocksBoolExp>;
};


export type Subscription_RootUserBlocksByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUserBlocksStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<UserBlocksStreamCursorInput>>;
  where?: InputMaybe<UserBlocksBoolExp>;
};


export type Subscription_RootUserCoachServicesArgs = {
  distinctOn?: InputMaybe<Array<UserCoachServicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserCoachServicesOrderBy>>;
  where?: InputMaybe<UserCoachServicesBoolExp>;
};


export type Subscription_RootUserCoachServicesAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserCoachServicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserCoachServicesOrderBy>>;
  where?: InputMaybe<UserCoachServicesBoolExp>;
};


export type Subscription_RootUserCoachServicesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUserCoachServicesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<UserCoachServicesStreamCursorInput>>;
  where?: InputMaybe<UserCoachServicesBoolExp>;
};


export type Subscription_RootUserCommunicationPreferencesArgs = {
  distinctOn?: InputMaybe<Array<UserCommunicationPreferencesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserCommunicationPreferencesOrderBy>>;
  where?: InputMaybe<UserCommunicationPreferencesBoolExp>;
};


export type Subscription_RootUserCommunicationPreferencesAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserCommunicationPreferencesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserCommunicationPreferencesOrderBy>>;
  where?: InputMaybe<UserCommunicationPreferencesBoolExp>;
};


export type Subscription_RootUserCommunicationPreferencesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUserCommunicationPreferencesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<UserCommunicationPreferencesStreamCursorInput>>;
  where?: InputMaybe<UserCommunicationPreferencesBoolExp>;
};


export type Subscription_RootUserConnectionRequestStatusesArgs = {
  distinctOn?: InputMaybe<Array<UserConnectionRequestStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserConnectionRequestStatusesOrderBy>>;
  where?: InputMaybe<UserConnectionRequestStatusesBoolExp>;
};


export type Subscription_RootUserConnectionRequestStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserConnectionRequestStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserConnectionRequestStatusesOrderBy>>;
  where?: InputMaybe<UserConnectionRequestStatusesBoolExp>;
};


export type Subscription_RootUserConnectionRequestStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootUserConnectionRequestStatusesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<UserConnectionRequestStatusesStreamCursorInput>>;
  where?: InputMaybe<UserConnectionRequestStatusesBoolExp>;
};


export type Subscription_RootUserConnectionRequestsArgs = {
  distinctOn?: InputMaybe<Array<UserConnectionRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserConnectionRequestsOrderBy>>;
  where?: InputMaybe<UserConnectionRequestsBoolExp>;
};


export type Subscription_RootUserConnectionRequestsAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserConnectionRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserConnectionRequestsOrderBy>>;
  where?: InputMaybe<UserConnectionRequestsBoolExp>;
};


export type Subscription_RootUserConnectionRequestsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUserConnectionRequestsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<UserConnectionRequestsStreamCursorInput>>;
  where?: InputMaybe<UserConnectionRequestsBoolExp>;
};


export type Subscription_RootUserConnectionsArgs = {
  distinctOn?: InputMaybe<Array<UserConnectionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserConnectionsOrderBy>>;
  where?: InputMaybe<UserConnectionsBoolExp>;
};


export type Subscription_RootUserConnectionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserConnectionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserConnectionsOrderBy>>;
  where?: InputMaybe<UserConnectionsBoolExp>;
};


export type Subscription_RootUserConnectionsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUserConnectionsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<UserConnectionsStreamCursorInput>>;
  where?: InputMaybe<UserConnectionsBoolExp>;
};


export type Subscription_RootUserContentBetaSubscriptionsArgs = {
  distinctOn?: InputMaybe<Array<UserContentBetaSubscriptionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserContentBetaSubscriptionsOrderBy>>;
  where?: InputMaybe<UserContentBetaSubscriptionsBoolExp>;
};


export type Subscription_RootUserContentBetaSubscriptionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserContentBetaSubscriptionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserContentBetaSubscriptionsOrderBy>>;
  where?: InputMaybe<UserContentBetaSubscriptionsBoolExp>;
};


export type Subscription_RootUserContentBetaSubscriptionsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUserContentBetaSubscriptionsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<UserContentBetaSubscriptionsStreamCursorInput>>;
  where?: InputMaybe<UserContentBetaSubscriptionsBoolExp>;
};


export type Subscription_RootUserContentFilesArgs = {
  distinctOn?: InputMaybe<Array<UserContentFilesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserContentFilesOrderBy>>;
  where?: InputMaybe<UserContentFilesBoolExp>;
};


export type Subscription_RootUserContentFilesAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserContentFilesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserContentFilesOrderBy>>;
  where?: InputMaybe<UserContentFilesBoolExp>;
};


export type Subscription_RootUserContentFilesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUserContentFilesSkillsArgs = {
  distinctOn?: InputMaybe<Array<UserContentFilesSkillsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserContentFilesSkillsOrderBy>>;
  where?: InputMaybe<UserContentFilesSkillsBoolExp>;
};


export type Subscription_RootUserContentFilesSkillsAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserContentFilesSkillsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserContentFilesSkillsOrderBy>>;
  where?: InputMaybe<UserContentFilesSkillsBoolExp>;
};


export type Subscription_RootUserContentFilesSkillsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUserContentFilesSkillsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<UserContentFilesSkillsStreamCursorInput>>;
  where?: InputMaybe<UserContentFilesSkillsBoolExp>;
};


export type Subscription_RootUserContentFilesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<UserContentFilesStreamCursorInput>>;
  where?: InputMaybe<UserContentFilesBoolExp>;
};


export type Subscription_RootUserContentSkillsArgs = {
  distinctOn?: InputMaybe<Array<UserContentSkillsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserContentSkillsOrderBy>>;
  where?: InputMaybe<UserContentSkillsBoolExp>;
};


export type Subscription_RootUserContentSkillsAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserContentSkillsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserContentSkillsOrderBy>>;
  where?: InputMaybe<UserContentSkillsBoolExp>;
};


export type Subscription_RootUserContentSkillsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUserContentSkillsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<UserContentSkillsStreamCursorInput>>;
  where?: InputMaybe<UserContentSkillsBoolExp>;
};


export type Subscription_RootUserContentTiersArgs = {
  distinctOn?: InputMaybe<Array<UserContentTiersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserContentTiersOrderBy>>;
  where?: InputMaybe<UserContentTiersBoolExp>;
};


export type Subscription_RootUserContentTiersAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserContentTiersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserContentTiersOrderBy>>;
  where?: InputMaybe<UserContentTiersBoolExp>;
};


export type Subscription_RootUserContentTiersByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootUserContentTiersStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<UserContentTiersStreamCursorInput>>;
  where?: InputMaybe<UserContentTiersBoolExp>;
};


export type Subscription_RootUserCreditCardsArgs = {
  distinctOn?: InputMaybe<Array<UserCreditCardsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserCreditCardsOrderBy>>;
  where?: InputMaybe<UserCreditCardsBoolExp>;
};


export type Subscription_RootUserCreditCardsAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserCreditCardsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserCreditCardsOrderBy>>;
  where?: InputMaybe<UserCreditCardsBoolExp>;
};


export type Subscription_RootUserCreditCardsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUserCreditCardsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<UserCreditCardsStreamCursorInput>>;
  where?: InputMaybe<UserCreditCardsBoolExp>;
};


export type Subscription_RootUserCustomCourtsArgs = {
  distinctOn?: InputMaybe<Array<UserCustomCourtsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserCustomCourtsOrderBy>>;
  where?: InputMaybe<UserCustomCourtsBoolExp>;
};


export type Subscription_RootUserCustomCourtsAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserCustomCourtsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserCustomCourtsOrderBy>>;
  where?: InputMaybe<UserCustomCourtsBoolExp>;
};


export type Subscription_RootUserCustomCourtsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUserCustomCourtsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<UserCustomCourtsStreamCursorInput>>;
  where?: InputMaybe<UserCustomCourtsBoolExp>;
};


export type Subscription_RootUserFilesArgs = {
  distinctOn?: InputMaybe<Array<UserFilesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserFilesOrderBy>>;
  where?: InputMaybe<UserFilesBoolExp>;
};


export type Subscription_RootUserFilesAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserFilesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserFilesOrderBy>>;
  where?: InputMaybe<UserFilesBoolExp>;
};


export type Subscription_RootUserFilesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUserFilesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<UserFilesStreamCursorInput>>;
  where?: InputMaybe<UserFilesBoolExp>;
};


export type Subscription_RootUserFollowsArgs = {
  distinctOn?: InputMaybe<Array<UserFollowsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserFollowsOrderBy>>;
  where?: InputMaybe<UserFollowsBoolExp>;
};


export type Subscription_RootUserFollowsAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserFollowsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserFollowsOrderBy>>;
  where?: InputMaybe<UserFollowsBoolExp>;
};


export type Subscription_RootUserFollowsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUserFollowsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<UserFollowsStreamCursorInput>>;
  where?: InputMaybe<UserFollowsBoolExp>;
};


export type Subscription_RootUserIdentityVerificationsArgs = {
  distinctOn?: InputMaybe<Array<UserIdentityVerificationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserIdentityVerificationsOrderBy>>;
  where?: InputMaybe<UserIdentityVerificationsBoolExp>;
};


export type Subscription_RootUserIdentityVerificationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserIdentityVerificationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserIdentityVerificationsOrderBy>>;
  where?: InputMaybe<UserIdentityVerificationsBoolExp>;
};


export type Subscription_RootUserIdentityVerificationsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUserIdentityVerificationsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<UserIdentityVerificationsStreamCursorInput>>;
  where?: InputMaybe<UserIdentityVerificationsBoolExp>;
};


export type Subscription_RootUserImageLogArgs = {
  distinctOn?: InputMaybe<Array<UserImageLogSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserImageLogOrderBy>>;
  where?: InputMaybe<UserImageLogBoolExp>;
};


export type Subscription_RootUserImageLogAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserImageLogSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserImageLogOrderBy>>;
  where?: InputMaybe<UserImageLogBoolExp>;
};


export type Subscription_RootUserImageLogByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUserImageLogStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<UserImageLogStreamCursorInput>>;
  where?: InputMaybe<UserImageLogBoolExp>;
};


export type Subscription_RootUserNotificationDetailsArgs = {
  distinctOn?: InputMaybe<Array<UserNotificationDetailsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserNotificationDetailsOrderBy>>;
  where?: InputMaybe<UserNotificationDetailsBoolExp>;
};


export type Subscription_RootUserNotificationDetailsAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserNotificationDetailsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserNotificationDetailsOrderBy>>;
  where?: InputMaybe<UserNotificationDetailsBoolExp>;
};


export type Subscription_RootUserNotificationDetailsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUserNotificationDetailsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<UserNotificationDetailsStreamCursorInput>>;
  where?: InputMaybe<UserNotificationDetailsBoolExp>;
};


export type Subscription_RootUserNotificationEntitiesArgs = {
  distinctOn?: InputMaybe<Array<UserNotificationEntitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserNotificationEntitiesOrderBy>>;
  where?: InputMaybe<UserNotificationEntitiesBoolExp>;
};


export type Subscription_RootUserNotificationEntitiesAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserNotificationEntitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserNotificationEntitiesOrderBy>>;
  where?: InputMaybe<UserNotificationEntitiesBoolExp>;
};


export type Subscription_RootUserNotificationEntitiesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUserNotificationEntitiesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<UserNotificationEntitiesStreamCursorInput>>;
  where?: InputMaybe<UserNotificationEntitiesBoolExp>;
};


export type Subscription_RootUserNotificationsArgs = {
  distinctOn?: InputMaybe<Array<UserNotificationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserNotificationsOrderBy>>;
  where?: InputMaybe<UserNotificationsBoolExp>;
};


export type Subscription_RootUserNotificationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserNotificationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserNotificationsOrderBy>>;
  where?: InputMaybe<UserNotificationsBoolExp>;
};


export type Subscription_RootUserNotificationsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUserNotificationsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<UserNotificationsStreamCursorInput>>;
  where?: InputMaybe<UserNotificationsBoolExp>;
};


export type Subscription_RootUserPadelRatingScalesArgs = {
  distinctOn?: InputMaybe<Array<UserPadelRatingScalesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPadelRatingScalesOrderBy>>;
  where?: InputMaybe<UserPadelRatingScalesBoolExp>;
};


export type Subscription_RootUserPadelRatingScalesAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserPadelRatingScalesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPadelRatingScalesOrderBy>>;
  where?: InputMaybe<UserPadelRatingScalesBoolExp>;
};


export type Subscription_RootUserPadelRatingScalesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUserPadelRatingScalesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<UserPadelRatingScalesStreamCursorInput>>;
  where?: InputMaybe<UserPadelRatingScalesBoolExp>;
};


export type Subscription_RootUserPickleballRatingScalesArgs = {
  distinctOn?: InputMaybe<Array<UserPickleballRatingScalesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPickleballRatingScalesOrderBy>>;
  where?: InputMaybe<UserPickleballRatingScalesBoolExp>;
};


export type Subscription_RootUserPickleballRatingScalesAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserPickleballRatingScalesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPickleballRatingScalesOrderBy>>;
  where?: InputMaybe<UserPickleballRatingScalesBoolExp>;
};


export type Subscription_RootUserPickleballRatingScalesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUserPickleballRatingScalesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<UserPickleballRatingScalesStreamCursorInput>>;
  where?: InputMaybe<UserPickleballRatingScalesBoolExp>;
};


export type Subscription_RootUserPlayedWithArgs = {
  distinctOn?: InputMaybe<Array<UserPlayedWithSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPlayedWithOrderBy>>;
  where?: InputMaybe<UserPlayedWithBoolExp>;
};


export type Subscription_RootUserPlayedWithAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserPlayedWithSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPlayedWithOrderBy>>;
  where?: InputMaybe<UserPlayedWithBoolExp>;
};


export type Subscription_RootUserPlayedWithDismissalsArgs = {
  distinctOn?: InputMaybe<Array<UserPlayedWithDismissalsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPlayedWithDismissalsOrderBy>>;
  where?: InputMaybe<UserPlayedWithDismissalsBoolExp>;
};


export type Subscription_RootUserPlayedWithDismissalsAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserPlayedWithDismissalsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPlayedWithDismissalsOrderBy>>;
  where?: InputMaybe<UserPlayedWithDismissalsBoolExp>;
};


export type Subscription_RootUserPlayedWithDismissalsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUserPlayedWithDismissalsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<UserPlayedWithDismissalsStreamCursorInput>>;
  where?: InputMaybe<UserPlayedWithDismissalsBoolExp>;
};


export type Subscription_RootUserPlayedWithGamesArgs = {
  distinctOn?: InputMaybe<Array<UserPlayedWithGamesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPlayedWithGamesOrderBy>>;
  where?: InputMaybe<UserPlayedWithGamesBoolExp>;
};


export type Subscription_RootUserPlayedWithGamesAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserPlayedWithGamesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPlayedWithGamesOrderBy>>;
  where?: InputMaybe<UserPlayedWithGamesBoolExp>;
};


export type Subscription_RootUserPlayedWithGamesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<UserPlayedWithGamesStreamCursorInput>>;
  where?: InputMaybe<UserPlayedWithGamesBoolExp>;
};


export type Subscription_RootUserPlayedWithStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<UserPlayedWithStreamCursorInput>>;
  where?: InputMaybe<UserPlayedWithBoolExp>;
};


export type Subscription_RootUserPlayerFinderAvailabilityArgs = {
  distinctOn?: InputMaybe<Array<UserPlayerFinderAvailabilitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPlayerFinderAvailabilityOrderBy>>;
  where?: InputMaybe<UserPlayerFinderAvailabilityBoolExp>;
};


export type Subscription_RootUserPlayerFinderAvailabilityAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserPlayerFinderAvailabilitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPlayerFinderAvailabilityOrderBy>>;
  where?: InputMaybe<UserPlayerFinderAvailabilityBoolExp>;
};


export type Subscription_RootUserPlayerFinderAvailabilityByPkArgs = {
  dayOfWeek: DayOfWeekEnum;
  timeOfDay: PlayerFinderTimeOfDayEnum;
  userId: Scalars['uuid'];
};


export type Subscription_RootUserPlayerFinderAvailabilityStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<UserPlayerFinderAvailabilityStreamCursorInput>>;
  where?: InputMaybe<UserPlayerFinderAvailabilityBoolExp>;
};


export type Subscription_RootUserPlayerFinderGoalsArgs = {
  distinctOn?: InputMaybe<Array<UserPlayerFinderGoalsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPlayerFinderGoalsOrderBy>>;
  where?: InputMaybe<UserPlayerFinderGoalsBoolExp>;
};


export type Subscription_RootUserPlayerFinderGoalsAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserPlayerFinderGoalsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPlayerFinderGoalsOrderBy>>;
  where?: InputMaybe<UserPlayerFinderGoalsBoolExp>;
};


export type Subscription_RootUserPlayerFinderGoalsByPkArgs = {
  goal: PlayerFinderGoalsEnum;
  userId: Scalars['uuid'];
};


export type Subscription_RootUserPlayerFinderGoalsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<UserPlayerFinderGoalsStreamCursorInput>>;
  where?: InputMaybe<UserPlayerFinderGoalsBoolExp>;
};


export type Subscription_RootUserProfilesArgs = {
  distinctOn?: InputMaybe<Array<UserProfilesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserProfilesOrderBy>>;
  where?: InputMaybe<UserProfilesBoolExp>;
};


export type Subscription_RootUserProfilesAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserProfilesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserProfilesOrderBy>>;
  where?: InputMaybe<UserProfilesBoolExp>;
};


export type Subscription_RootUserProfilesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<UserProfilesStreamCursorInput>>;
  where?: InputMaybe<UserProfilesBoolExp>;
};


export type Subscription_RootUserRegistrationDetailsArgs = {
  distinctOn?: InputMaybe<Array<UserRegistrationDetailsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserRegistrationDetailsOrderBy>>;
  where?: InputMaybe<UserRegistrationDetailsBoolExp>;
};


export type Subscription_RootUserRegistrationDetailsAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserRegistrationDetailsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserRegistrationDetailsOrderBy>>;
  where?: InputMaybe<UserRegistrationDetailsBoolExp>;
};


export type Subscription_RootUserRegistrationDetailsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUserRegistrationDetailsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<UserRegistrationDetailsStreamCursorInput>>;
  where?: InputMaybe<UserRegistrationDetailsBoolExp>;
};


export type Subscription_RootUserSportsArgs = {
  distinctOn?: InputMaybe<Array<UserSportsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserSportsOrderBy>>;
  where?: InputMaybe<UserSportsBoolExp>;
};


export type Subscription_RootUserSportsAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserSportsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserSportsOrderBy>>;
  where?: InputMaybe<UserSportsBoolExp>;
};


export type Subscription_RootUserSportsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUserSportsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<UserSportsStreamCursorInput>>;
  where?: InputMaybe<UserSportsBoolExp>;
};


export type Subscription_RootUserTennisRatingScalesArgs = {
  distinctOn?: InputMaybe<Array<UserTennisRatingScalesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserTennisRatingScalesOrderBy>>;
  where?: InputMaybe<UserTennisRatingScalesBoolExp>;
};


export type Subscription_RootUserTennisRatingScalesAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserTennisRatingScalesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserTennisRatingScalesOrderBy>>;
  where?: InputMaybe<UserTennisRatingScalesBoolExp>;
};


export type Subscription_RootUserTennisRatingScalesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUserTennisRatingScalesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<UserTennisRatingScalesStreamCursorInput>>;
  where?: InputMaybe<UserTennisRatingScalesBoolExp>;
};


export type Subscription_RootUserTermsOfServiceArgs = {
  distinctOn?: InputMaybe<Array<UserTermsOfServiceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserTermsOfServiceOrderBy>>;
  where?: InputMaybe<UserTermsOfServiceBoolExp>;
};


export type Subscription_RootUserTermsOfServiceAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserTermsOfServiceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserTermsOfServiceOrderBy>>;
  where?: InputMaybe<UserTermsOfServiceBoolExp>;
};


export type Subscription_RootUserTermsOfServiceByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUserTermsOfServiceStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<UserTermsOfServiceStreamCursorInput>>;
  where?: InputMaybe<UserTermsOfServiceBoolExp>;
};


export type Subscription_RootUserVairConnectionsArgs = {
  distinctOn?: InputMaybe<Array<UserVairConnectionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserVairConnectionsOrderBy>>;
  where?: InputMaybe<UserVairConnectionsBoolExp>;
};


export type Subscription_RootUserVairConnectionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserVairConnectionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserVairConnectionsOrderBy>>;
  where?: InputMaybe<UserVairConnectionsBoolExp>;
};


export type Subscription_RootUserVairConnectionsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUserVairConnectionsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<UserVairConnectionsStreamCursorInput>>;
  where?: InputMaybe<UserVairConnectionsBoolExp>;
};


export type Subscription_RootUsernameLogsArgs = {
  distinctOn?: InputMaybe<Array<UsernameLogsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsernameLogsOrderBy>>;
  where?: InputMaybe<UsernameLogsBoolExp>;
};


export type Subscription_RootUsernameLogsAggregateArgs = {
  distinctOn?: InputMaybe<Array<UsernameLogsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsernameLogsOrderBy>>;
  where?: InputMaybe<UsernameLogsBoolExp>;
};


export type Subscription_RootUsernameLogsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUsernameLogsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<UsernameLogsStreamCursorInput>>;
  where?: InputMaybe<UsernameLogsBoolExp>;
};


export type Subscription_RootUsernamesActiveArgs = {
  distinctOn?: InputMaybe<Array<UsernamesActiveSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsernamesActiveOrderBy>>;
  where?: InputMaybe<UsernamesActiveBoolExp>;
};


export type Subscription_RootUsernamesActiveAggregateArgs = {
  distinctOn?: InputMaybe<Array<UsernamesActiveSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsernamesActiveOrderBy>>;
  where?: InputMaybe<UsernamesActiveBoolExp>;
};


export type Subscription_RootUsernamesActiveStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<UsernamesActiveStreamCursorInput>>;
  where?: InputMaybe<UsernamesActiveBoolExp>;
};


export type Subscription_RootUsernamesClaimedArgs = {
  distinctOn?: InputMaybe<Array<UsernamesClaimedSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsernamesClaimedOrderBy>>;
  where?: InputMaybe<UsernamesClaimedBoolExp>;
};


export type Subscription_RootUsernamesClaimedAggregateArgs = {
  distinctOn?: InputMaybe<Array<UsernamesClaimedSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsernamesClaimedOrderBy>>;
  where?: InputMaybe<UsernamesClaimedBoolExp>;
};


export type Subscription_RootUsernamesClaimedByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUsernamesClaimedStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<UsernamesClaimedStreamCursorInput>>;
  where?: InputMaybe<UsernamesClaimedBoolExp>;
};


export type Subscription_RootUsersArgs = {
  distinctOn?: InputMaybe<Array<UsersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
  where?: InputMaybe<UsersBoolExp>;
};


export type Subscription_RootUsersAggregateArgs = {
  distinctOn?: InputMaybe<Array<UsersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
  where?: InputMaybe<UsersBoolExp>;
};


export type Subscription_RootUsersByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUsersCoachQualificationsArgs = {
  distinctOn?: InputMaybe<Array<UsersCoachQualificationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersCoachQualificationsOrderBy>>;
  where?: InputMaybe<UsersCoachQualificationsBoolExp>;
};


export type Subscription_RootUsersCoachQualificationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<UsersCoachQualificationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersCoachQualificationsOrderBy>>;
  where?: InputMaybe<UsersCoachQualificationsBoolExp>;
};


export type Subscription_RootUsersCoachQualificationsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUsersCoachQualificationsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<UsersCoachQualificationsStreamCursorInput>>;
  where?: InputMaybe<UsersCoachQualificationsBoolExp>;
};


export type Subscription_RootUsersStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<UsersStreamCursorInput>>;
  where?: InputMaybe<UsersBoolExp>;
};


export type Subscription_RootVenueAccessTypesArgs = {
  distinctOn?: InputMaybe<Array<VenueAccessTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueAccessTypesOrderBy>>;
  where?: InputMaybe<VenueAccessTypesBoolExp>;
};


export type Subscription_RootVenueAccessTypesAggregateArgs = {
  distinctOn?: InputMaybe<Array<VenueAccessTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueAccessTypesOrderBy>>;
  where?: InputMaybe<VenueAccessTypesBoolExp>;
};


export type Subscription_RootVenueAccessTypesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootVenueAccessTypesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<VenueAccessTypesStreamCursorInput>>;
  where?: InputMaybe<VenueAccessTypesBoolExp>;
};


export type Subscription_RootVenueAdminClaimStatusesArgs = {
  distinctOn?: InputMaybe<Array<VenueAdminClaimStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueAdminClaimStatusesOrderBy>>;
  where?: InputMaybe<VenueAdminClaimStatusesBoolExp>;
};


export type Subscription_RootVenueAdminClaimStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<VenueAdminClaimStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueAdminClaimStatusesOrderBy>>;
  where?: InputMaybe<VenueAdminClaimStatusesBoolExp>;
};


export type Subscription_RootVenueAdminClaimStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootVenueAdminClaimStatusesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<VenueAdminClaimStatusesStreamCursorInput>>;
  where?: InputMaybe<VenueAdminClaimStatusesBoolExp>;
};


export type Subscription_RootVenueAdminClaimsArgs = {
  distinctOn?: InputMaybe<Array<VenueAdminClaimsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueAdminClaimsOrderBy>>;
  where?: InputMaybe<VenueAdminClaimsBoolExp>;
};


export type Subscription_RootVenueAdminClaimsAggregateArgs = {
  distinctOn?: InputMaybe<Array<VenueAdminClaimsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueAdminClaimsOrderBy>>;
  where?: InputMaybe<VenueAdminClaimsBoolExp>;
};


export type Subscription_RootVenueAdminClaimsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootVenueAdminClaimsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<VenueAdminClaimsStreamCursorInput>>;
  where?: InputMaybe<VenueAdminClaimsBoolExp>;
};


export type Subscription_RootVenueAmenitiesArgs = {
  distinctOn?: InputMaybe<Array<VenueAmenitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueAmenitiesOrderBy>>;
  where?: InputMaybe<VenueAmenitiesBoolExp>;
};


export type Subscription_RootVenueAmenitiesAggregateArgs = {
  distinctOn?: InputMaybe<Array<VenueAmenitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueAmenitiesOrderBy>>;
  where?: InputMaybe<VenueAmenitiesBoolExp>;
};


export type Subscription_RootVenueAmenitiesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootVenueAmenitiesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<VenueAmenitiesStreamCursorInput>>;
  where?: InputMaybe<VenueAmenitiesBoolExp>;
};


export type Subscription_RootVenueBookingConfigVersionsArgs = {
  distinctOn?: InputMaybe<Array<VenueBookingConfigVersionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueBookingConfigVersionsOrderBy>>;
  where?: InputMaybe<VenueBookingConfigVersionsBoolExp>;
};


export type Subscription_RootVenueBookingConfigVersionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<VenueBookingConfigVersionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueBookingConfigVersionsOrderBy>>;
  where?: InputMaybe<VenueBookingConfigVersionsBoolExp>;
};


export type Subscription_RootVenueBookingConfigVersionsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootVenueBookingConfigVersionsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<VenueBookingConfigVersionsStreamCursorInput>>;
  where?: InputMaybe<VenueBookingConfigVersionsBoolExp>;
};


export type Subscription_RootVenueBookingConnectionCheckStatusesArgs = {
  distinctOn?: InputMaybe<Array<VenueBookingConnectionCheckStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueBookingConnectionCheckStatusesOrderBy>>;
  where?: InputMaybe<VenueBookingConnectionCheckStatusesBoolExp>;
};


export type Subscription_RootVenueBookingConnectionCheckStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<VenueBookingConnectionCheckStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueBookingConnectionCheckStatusesOrderBy>>;
  where?: InputMaybe<VenueBookingConnectionCheckStatusesBoolExp>;
};


export type Subscription_RootVenueBookingConnectionCheckStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootVenueBookingConnectionCheckStatusesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<VenueBookingConnectionCheckStatusesStreamCursorInput>>;
  where?: InputMaybe<VenueBookingConnectionCheckStatusesBoolExp>;
};


export type Subscription_RootVenueBookingConnectionChecksArgs = {
  distinctOn?: InputMaybe<Array<VenueBookingConnectionChecksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueBookingConnectionChecksOrderBy>>;
  where?: InputMaybe<VenueBookingConnectionChecksBoolExp>;
};


export type Subscription_RootVenueBookingConnectionChecksAggregateArgs = {
  distinctOn?: InputMaybe<Array<VenueBookingConnectionChecksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueBookingConnectionChecksOrderBy>>;
  where?: InputMaybe<VenueBookingConnectionChecksBoolExp>;
};


export type Subscription_RootVenueBookingConnectionChecksByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootVenueBookingConnectionChecksStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<VenueBookingConnectionChecksStreamCursorInput>>;
  where?: InputMaybe<VenueBookingConnectionChecksBoolExp>;
};


export type Subscription_RootVenueBookingCourtRatesArgs = {
  distinctOn?: InputMaybe<Array<VenueBookingCourtRatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueBookingCourtRatesOrderBy>>;
  where?: InputMaybe<VenueBookingCourtRatesBoolExp>;
};


export type Subscription_RootVenueBookingCourtRatesAggregateArgs = {
  distinctOn?: InputMaybe<Array<VenueBookingCourtRatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueBookingCourtRatesOrderBy>>;
  where?: InputMaybe<VenueBookingCourtRatesBoolExp>;
};


export type Subscription_RootVenueBookingCourtRatesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootVenueBookingCourtRatesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<VenueBookingCourtRatesStreamCursorInput>>;
  where?: InputMaybe<VenueBookingCourtRatesBoolExp>;
};


export type Subscription_RootVenueBookingIntegrationsArgs = {
  distinctOn?: InputMaybe<Array<VenueBookingIntegrationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueBookingIntegrationsOrderBy>>;
  where?: InputMaybe<VenueBookingIntegrationsBoolExp>;
};


export type Subscription_RootVenueBookingIntegrationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<VenueBookingIntegrationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueBookingIntegrationsOrderBy>>;
  where?: InputMaybe<VenueBookingIntegrationsBoolExp>;
};


export type Subscription_RootVenueBookingIntegrationsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootVenueBookingIntegrationsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<VenueBookingIntegrationsStreamCursorInput>>;
  where?: InputMaybe<VenueBookingIntegrationsBoolExp>;
};


export type Subscription_RootVenueBookingRuleTiersArgs = {
  distinctOn?: InputMaybe<Array<VenueBookingRuleTiersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueBookingRuleTiersOrderBy>>;
  where?: InputMaybe<VenueBookingRuleTiersBoolExp>;
};


export type Subscription_RootVenueBookingRuleTiersAggregateArgs = {
  distinctOn?: InputMaybe<Array<VenueBookingRuleTiersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueBookingRuleTiersOrderBy>>;
  where?: InputMaybe<VenueBookingRuleTiersBoolExp>;
};


export type Subscription_RootVenueBookingRuleTiersByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootVenueBookingRuleTiersStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<VenueBookingRuleTiersStreamCursorInput>>;
  where?: InputMaybe<VenueBookingRuleTiersBoolExp>;
};


export type Subscription_RootVenueBookingRulesArgs = {
  distinctOn?: InputMaybe<Array<VenueBookingRulesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueBookingRulesOrderBy>>;
  where?: InputMaybe<VenueBookingRulesBoolExp>;
};


export type Subscription_RootVenueBookingRulesAggregateArgs = {
  distinctOn?: InputMaybe<Array<VenueBookingRulesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueBookingRulesOrderBy>>;
  where?: InputMaybe<VenueBookingRulesBoolExp>;
};


export type Subscription_RootVenueBookingRulesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootVenueBookingRulesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<VenueBookingRulesStreamCursorInput>>;
  where?: InputMaybe<VenueBookingRulesBoolExp>;
};


export type Subscription_RootVenueBookingWindowsArgs = {
  distinctOn?: InputMaybe<Array<VenueBookingWindowsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueBookingWindowsOrderBy>>;
  where?: InputMaybe<VenueBookingWindowsBoolExp>;
};


export type Subscription_RootVenueBookingWindowsAggregateArgs = {
  distinctOn?: InputMaybe<Array<VenueBookingWindowsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueBookingWindowsOrderBy>>;
  where?: InputMaybe<VenueBookingWindowsBoolExp>;
};


export type Subscription_RootVenueBookingWindowsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootVenueBookingWindowsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<VenueBookingWindowsStreamCursorInput>>;
  where?: InputMaybe<VenueBookingWindowsBoolExp>;
};


export type Subscription_RootVenueCourtSurfacesArgs = {
  distinctOn?: InputMaybe<Array<VenueCourtSurfacesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueCourtSurfacesOrderBy>>;
  where?: InputMaybe<VenueCourtSurfacesBoolExp>;
};


export type Subscription_RootVenueCourtSurfacesAggregateArgs = {
  distinctOn?: InputMaybe<Array<VenueCourtSurfacesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueCourtSurfacesOrderBy>>;
  where?: InputMaybe<VenueCourtSurfacesBoolExp>;
};


export type Subscription_RootVenueCourtSurfacesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootVenueCourtSurfacesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<VenueCourtSurfacesStreamCursorInput>>;
  where?: InputMaybe<VenueCourtSurfacesBoolExp>;
};


export type Subscription_RootVenueCustomAmenitiesArgs = {
  distinctOn?: InputMaybe<Array<VenueCustomAmenitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueCustomAmenitiesOrderBy>>;
  where?: InputMaybe<VenueCustomAmenitiesBoolExp>;
};


export type Subscription_RootVenueCustomAmenitiesAggregateArgs = {
  distinctOn?: InputMaybe<Array<VenueCustomAmenitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueCustomAmenitiesOrderBy>>;
  where?: InputMaybe<VenueCustomAmenitiesBoolExp>;
};


export type Subscription_RootVenueCustomAmenitiesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootVenueCustomAmenitiesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<VenueCustomAmenitiesStreamCursorInput>>;
  where?: InputMaybe<VenueCustomAmenitiesBoolExp>;
};


export type Subscription_RootVenueEquipmentArgs = {
  distinctOn?: InputMaybe<Array<VenueEquipmentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueEquipmentOrderBy>>;
  where?: InputMaybe<VenueEquipmentBoolExp>;
};


export type Subscription_RootVenueEquipmentAggregateArgs = {
  distinctOn?: InputMaybe<Array<VenueEquipmentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueEquipmentOrderBy>>;
  where?: InputMaybe<VenueEquipmentBoolExp>;
};


export type Subscription_RootVenueEquipmentByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootVenueEquipmentStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<VenueEquipmentStreamCursorInput>>;
  where?: InputMaybe<VenueEquipmentBoolExp>;
};


export type Subscription_RootVenueFacilityTypesArgs = {
  distinctOn?: InputMaybe<Array<VenueFacilityTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueFacilityTypesOrderBy>>;
  where?: InputMaybe<VenueFacilityTypesBoolExp>;
};


export type Subscription_RootVenueFacilityTypesAggregateArgs = {
  distinctOn?: InputMaybe<Array<VenueFacilityTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueFacilityTypesOrderBy>>;
  where?: InputMaybe<VenueFacilityTypesBoolExp>;
};


export type Subscription_RootVenueFacilityTypesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootVenueFacilityTypesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<VenueFacilityTypesStreamCursorInput>>;
  where?: InputMaybe<VenueFacilityTypesBoolExp>;
};


export type Subscription_RootVenueFaqsArgs = {
  distinctOn?: InputMaybe<Array<VenueFaqsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueFaqsOrderBy>>;
  where?: InputMaybe<VenueFaqsBoolExp>;
};


export type Subscription_RootVenueFaqsAggregateArgs = {
  distinctOn?: InputMaybe<Array<VenueFaqsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueFaqsOrderBy>>;
  where?: InputMaybe<VenueFaqsBoolExp>;
};


export type Subscription_RootVenueFaqsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootVenueFaqsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<VenueFaqsStreamCursorInput>>;
  where?: InputMaybe<VenueFaqsBoolExp>;
};


export type Subscription_RootVenueFollowsArgs = {
  distinctOn?: InputMaybe<Array<VenueFollowsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueFollowsOrderBy>>;
  where?: InputMaybe<VenueFollowsBoolExp>;
};


export type Subscription_RootVenueFollowsAggregateArgs = {
  distinctOn?: InputMaybe<Array<VenueFollowsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueFollowsOrderBy>>;
  where?: InputMaybe<VenueFollowsBoolExp>;
};


export type Subscription_RootVenueFollowsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootVenueFollowsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<VenueFollowsStreamCursorInput>>;
  where?: InputMaybe<VenueFollowsBoolExp>;
};


export type Subscription_RootVenueImagesArgs = {
  distinctOn?: InputMaybe<Array<VenueImagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueImagesOrderBy>>;
  where?: InputMaybe<VenueImagesBoolExp>;
};


export type Subscription_RootVenueImagesAggregateArgs = {
  distinctOn?: InputMaybe<Array<VenueImagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueImagesOrderBy>>;
  where?: InputMaybe<VenueImagesBoolExp>;
};


export type Subscription_RootVenueImagesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootVenueImagesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<VenueImagesStreamCursorInput>>;
  where?: InputMaybe<VenueImagesBoolExp>;
};


export type Subscription_RootVenueLinesArgs = {
  distinctOn?: InputMaybe<Array<VenueLinesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueLinesOrderBy>>;
  where?: InputMaybe<VenueLinesBoolExp>;
};


export type Subscription_RootVenueLinesAggregateArgs = {
  distinctOn?: InputMaybe<Array<VenueLinesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueLinesOrderBy>>;
  where?: InputMaybe<VenueLinesBoolExp>;
};


export type Subscription_RootVenueLinesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootVenueLinesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<VenueLinesStreamCursorInput>>;
  where?: InputMaybe<VenueLinesBoolExp>;
};


export type Subscription_RootVenueNetsArgs = {
  distinctOn?: InputMaybe<Array<VenueNetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueNetsOrderBy>>;
  where?: InputMaybe<VenueNetsBoolExp>;
};


export type Subscription_RootVenueNetsAggregateArgs = {
  distinctOn?: InputMaybe<Array<VenueNetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueNetsOrderBy>>;
  where?: InputMaybe<VenueNetsBoolExp>;
};


export type Subscription_RootVenueNetsByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootVenueNetsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<VenueNetsStreamCursorInput>>;
  where?: InputMaybe<VenueNetsBoolExp>;
};


export type Subscription_RootVenuePartnerBookingStatusesArgs = {
  distinctOn?: InputMaybe<Array<VenuePartnerBookingStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenuePartnerBookingStatusesOrderBy>>;
  where?: InputMaybe<VenuePartnerBookingStatusesBoolExp>;
};


export type Subscription_RootVenuePartnerBookingStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<VenuePartnerBookingStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenuePartnerBookingStatusesOrderBy>>;
  where?: InputMaybe<VenuePartnerBookingStatusesBoolExp>;
};


export type Subscription_RootVenuePartnerBookingStatusesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<VenuePartnerBookingStatusesStreamCursorInput>>;
  where?: InputMaybe<VenuePartnerBookingStatusesBoolExp>;
};


export type Subscription_RootVenueStaffCoachesArgs = {
  distinctOn?: InputMaybe<Array<VenueStaffCoachesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueStaffCoachesOrderBy>>;
  where?: InputMaybe<VenueStaffCoachesBoolExp>;
};


export type Subscription_RootVenueStaffCoachesAggregateArgs = {
  distinctOn?: InputMaybe<Array<VenueStaffCoachesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueStaffCoachesOrderBy>>;
  where?: InputMaybe<VenueStaffCoachesBoolExp>;
};


export type Subscription_RootVenueStaffCoachesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootVenueStaffCoachesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<VenueStaffCoachesStreamCursorInput>>;
  where?: InputMaybe<VenueStaffCoachesBoolExp>;
};


export type Subscription_RootVenuesArgs = {
  distinctOn?: InputMaybe<Array<VenuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenuesOrderBy>>;
  where?: InputMaybe<VenuesBoolExp>;
};


export type Subscription_RootVenuesAggregateArgs = {
  distinctOn?: InputMaybe<Array<VenuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenuesOrderBy>>;
  where?: InputMaybe<VenuesBoolExp>;
};


export type Subscription_RootVenuesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootVenuesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<VenuesStreamCursorInput>>;
  where?: InputMaybe<VenuesBoolExp>;
};


export type Subscription_RootVideoAnalysisArgs = {
  distinctOn?: InputMaybe<Array<VideoAnalysisSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoAnalysisOrderBy>>;
  where?: InputMaybe<VideoAnalysisBoolExp>;
};


export type Subscription_RootVideoAnalysisAggregateArgs = {
  distinctOn?: InputMaybe<Array<VideoAnalysisSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoAnalysisOrderBy>>;
  where?: InputMaybe<VideoAnalysisBoolExp>;
};


export type Subscription_RootVideoAnalysisByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootVideoAnalysisCommentsArgs = {
  distinctOn?: InputMaybe<Array<VideoAnalysisCommentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoAnalysisCommentsOrderBy>>;
  where?: InputMaybe<VideoAnalysisCommentsBoolExp>;
};


export type Subscription_RootVideoAnalysisCommentsAggregateArgs = {
  distinctOn?: InputMaybe<Array<VideoAnalysisCommentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoAnalysisCommentsOrderBy>>;
  where?: InputMaybe<VideoAnalysisCommentsBoolExp>;
};


export type Subscription_RootVideoAnalysisCommentsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootVideoAnalysisCommentsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<VideoAnalysisCommentsStreamCursorInput>>;
  where?: InputMaybe<VideoAnalysisCommentsBoolExp>;
};


export type Subscription_RootVideoAnalysisFilesArgs = {
  distinctOn?: InputMaybe<Array<VideoAnalysisFilesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoAnalysisFilesOrderBy>>;
  where?: InputMaybe<VideoAnalysisFilesBoolExp>;
};


export type Subscription_RootVideoAnalysisFilesAggregateArgs = {
  distinctOn?: InputMaybe<Array<VideoAnalysisFilesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoAnalysisFilesOrderBy>>;
  where?: InputMaybe<VideoAnalysisFilesBoolExp>;
};


export type Subscription_RootVideoAnalysisFilesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootVideoAnalysisFilesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<VideoAnalysisFilesStreamCursorInput>>;
  where?: InputMaybe<VideoAnalysisFilesBoolExp>;
};


export type Subscription_RootVideoAnalysisFilesUploadStatusesArgs = {
  distinctOn?: InputMaybe<Array<VideoAnalysisFilesUploadStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoAnalysisFilesUploadStatusesOrderBy>>;
  where?: InputMaybe<VideoAnalysisFilesUploadStatusesBoolExp>;
};


export type Subscription_RootVideoAnalysisFilesUploadStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<VideoAnalysisFilesUploadStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoAnalysisFilesUploadStatusesOrderBy>>;
  where?: InputMaybe<VideoAnalysisFilesUploadStatusesBoolExp>;
};


export type Subscription_RootVideoAnalysisFilesUploadStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootVideoAnalysisFilesUploadStatusesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<VideoAnalysisFilesUploadStatusesStreamCursorInput>>;
  where?: InputMaybe<VideoAnalysisFilesUploadStatusesBoolExp>;
};


export type Subscription_RootVideoAnalysisOrderItemsArgs = {
  distinctOn?: InputMaybe<Array<VideoAnalysisOrderItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoAnalysisOrderItemsOrderBy>>;
  where?: InputMaybe<VideoAnalysisOrderItemsBoolExp>;
};


export type Subscription_RootVideoAnalysisOrderItemsAggregateArgs = {
  distinctOn?: InputMaybe<Array<VideoAnalysisOrderItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoAnalysisOrderItemsOrderBy>>;
  where?: InputMaybe<VideoAnalysisOrderItemsBoolExp>;
};


export type Subscription_RootVideoAnalysisOrderItemsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootVideoAnalysisOrderItemsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<VideoAnalysisOrderItemsStreamCursorInput>>;
  where?: InputMaybe<VideoAnalysisOrderItemsBoolExp>;
};


export type Subscription_RootVideoAnalysisOrdersArgs = {
  distinctOn?: InputMaybe<Array<VideoAnalysisOrdersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoAnalysisOrdersOrderBy>>;
  where?: InputMaybe<VideoAnalysisOrdersBoolExp>;
};


export type Subscription_RootVideoAnalysisOrdersAggregateArgs = {
  distinctOn?: InputMaybe<Array<VideoAnalysisOrdersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoAnalysisOrdersOrderBy>>;
  where?: InputMaybe<VideoAnalysisOrdersBoolExp>;
};


export type Subscription_RootVideoAnalysisOrdersByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootVideoAnalysisOrdersStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<VideoAnalysisOrdersStreamCursorInput>>;
  where?: InputMaybe<VideoAnalysisOrdersBoolExp>;
};


export type Subscription_RootVideoAnalysisRequestedSkillsReviewArgs = {
  distinctOn?: InputMaybe<Array<VideoAnalysisRequestedSkillsReviewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoAnalysisRequestedSkillsReviewOrderBy>>;
  where?: InputMaybe<VideoAnalysisRequestedSkillsReviewBoolExp>;
};


export type Subscription_RootVideoAnalysisRequestedSkillsReviewAggregateArgs = {
  distinctOn?: InputMaybe<Array<VideoAnalysisRequestedSkillsReviewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoAnalysisRequestedSkillsReviewOrderBy>>;
  where?: InputMaybe<VideoAnalysisRequestedSkillsReviewBoolExp>;
};


export type Subscription_RootVideoAnalysisRequestedSkillsReviewByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootVideoAnalysisRequestedSkillsReviewStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<VideoAnalysisRequestedSkillsReviewStreamCursorInput>>;
  where?: InputMaybe<VideoAnalysisRequestedSkillsReviewBoolExp>;
};


export type Subscription_RootVideoAnalysisReviewStatusesArgs = {
  distinctOn?: InputMaybe<Array<VideoAnalysisReviewStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoAnalysisReviewStatusesOrderBy>>;
  where?: InputMaybe<VideoAnalysisReviewStatusesBoolExp>;
};


export type Subscription_RootVideoAnalysisReviewStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<VideoAnalysisReviewStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoAnalysisReviewStatusesOrderBy>>;
  where?: InputMaybe<VideoAnalysisReviewStatusesBoolExp>;
};


export type Subscription_RootVideoAnalysisReviewStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootVideoAnalysisReviewStatusesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<VideoAnalysisReviewStatusesStreamCursorInput>>;
  where?: InputMaybe<VideoAnalysisReviewStatusesBoolExp>;
};


export type Subscription_RootVideoAnalysisSkillsCommentsArgs = {
  distinctOn?: InputMaybe<Array<VideoAnalysisSkillsCommentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoAnalysisSkillsCommentsOrderBy>>;
  where?: InputMaybe<VideoAnalysisSkillsCommentsBoolExp>;
};


export type Subscription_RootVideoAnalysisSkillsCommentsAggregateArgs = {
  distinctOn?: InputMaybe<Array<VideoAnalysisSkillsCommentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoAnalysisSkillsCommentsOrderBy>>;
  where?: InputMaybe<VideoAnalysisSkillsCommentsBoolExp>;
};


export type Subscription_RootVideoAnalysisSkillsCommentsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootVideoAnalysisSkillsCommentsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<VideoAnalysisSkillsCommentsStreamCursorInput>>;
  where?: InputMaybe<VideoAnalysisSkillsCommentsBoolExp>;
};


export type Subscription_RootVideoAnalysisStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<VideoAnalysisStreamCursorInput>>;
  where?: InputMaybe<VideoAnalysisBoolExp>;
};


export type Subscription_RootVideoAnalysisSubmissionLogArgs = {
  distinctOn?: InputMaybe<Array<VideoAnalysisSubmissionLogSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoAnalysisSubmissionLogOrderBy>>;
  where?: InputMaybe<VideoAnalysisSubmissionLogBoolExp>;
};


export type Subscription_RootVideoAnalysisSubmissionLogAggregateArgs = {
  distinctOn?: InputMaybe<Array<VideoAnalysisSubmissionLogSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoAnalysisSubmissionLogOrderBy>>;
  where?: InputMaybe<VideoAnalysisSubmissionLogBoolExp>;
};


export type Subscription_RootVideoAnalysisSubmissionLogByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootVideoAnalysisSubmissionLogStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<VideoAnalysisSubmissionLogStreamCursorInput>>;
  where?: InputMaybe<VideoAnalysisSubmissionLogBoolExp>;
};


export type Subscription_RootVideoLessonSkillsArgs = {
  distinctOn?: InputMaybe<Array<VideoLessonSkillsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoLessonSkillsOrderBy>>;
  where?: InputMaybe<VideoLessonSkillsBoolExp>;
};


export type Subscription_RootVideoLessonSkillsAggregateArgs = {
  distinctOn?: InputMaybe<Array<VideoLessonSkillsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoLessonSkillsOrderBy>>;
  where?: InputMaybe<VideoLessonSkillsBoolExp>;
};


export type Subscription_RootVideoLessonSkillsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootVideoLessonSkillsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<VideoLessonSkillsStreamCursorInput>>;
  where?: InputMaybe<VideoLessonSkillsBoolExp>;
};


export type Subscription_RootWelcomeEmailConfigurationArgs = {
  distinctOn?: InputMaybe<Array<WelcomeEmailConfigurationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<WelcomeEmailConfigurationOrderBy>>;
  where?: InputMaybe<WelcomeEmailConfigurationBoolExp>;
};


export type Subscription_RootWelcomeEmailConfigurationAggregateArgs = {
  distinctOn?: InputMaybe<Array<WelcomeEmailConfigurationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<WelcomeEmailConfigurationOrderBy>>;
  where?: InputMaybe<WelcomeEmailConfigurationBoolExp>;
};


export type Subscription_RootWelcomeEmailConfigurationByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootWelcomeEmailConfigurationStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<WelcomeEmailConfigurationStreamCursorInput>>;
  where?: InputMaybe<WelcomeEmailConfigurationBoolExp>;
};


export type Subscription_RootWinReasonsArgs = {
  distinctOn?: InputMaybe<Array<WinReasonsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<WinReasonsOrderBy>>;
  where?: InputMaybe<WinReasonsBoolExp>;
};


export type Subscription_RootWinReasonsAggregateArgs = {
  distinctOn?: InputMaybe<Array<WinReasonsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<WinReasonsOrderBy>>;
  where?: InputMaybe<WinReasonsBoolExp>;
};


export type Subscription_RootWinReasonsByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootWinReasonsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<WinReasonsStreamCursorInput>>;
  where?: InputMaybe<WinReasonsBoolExp>;
};

export type UserAuthIdentitiesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<UserAuthIdentitiesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<UserAuthIdentitiesBoolExp>;
  predicate: IntComparisonExp;
};

export type UserCoachServicesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<UserCoachServicesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<UserCoachServicesBoolExp>;
  predicate: IntComparisonExp;
};

export type UserContentFilesSkillsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<UserContentFilesSkillsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<UserContentFilesSkillsBoolExp>;
  predicate: IntComparisonExp;
};

export type UserCreditCardsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<UserCreditCardsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<UserCreditCardsBoolExp>;
  predicate: IntComparisonExp;
};

export type UserCustomCourtsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<UserCustomCourtsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<UserCustomCourtsBoolExp>;
  predicate: IntComparisonExp;
};

export type UserFilesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<UserFilesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<UserFilesBoolExp>;
  predicate: IntComparisonExp;
};

export type UserFollowsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<UserFollowsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<UserFollowsBoolExp>;
  predicate: IntComparisonExp;
};

export type UserIdentityVerificationsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<UserIdentityVerificationsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<UserIdentityVerificationsBoolExp>;
  predicate: IntComparisonExp;
};

export type UserNotificationsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<UserNotificationsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<UserNotificationsBoolExp>;
  predicate: IntComparisonExp;
};

export type UserPadelRatingScalesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<UserPadelRatingScalesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<UserPadelRatingScalesBoolExp>;
  predicate: IntComparisonExp;
};

export type UserPickleballRatingScalesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<UserPickleballRatingScalesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<UserPickleballRatingScalesBoolExp>;
  predicate: IntComparisonExp;
};

export type UserPlayedWithGamesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<UserPlayedWithGamesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<UserPlayedWithGamesBoolExp>;
  predicate: IntComparisonExp;
};

export type UserPlayerFinderAvailabilityAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<UserPlayerFinderAvailabilitySelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<UserPlayerFinderAvailabilityBoolExp>;
  predicate: IntComparisonExp;
};

export type UserSportsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<UserSportsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<UserSportsBoolExp>;
  predicate: IntComparisonExp;
};

export type UserTennisRatingScalesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<UserTennisRatingScalesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<UserTennisRatingScalesBoolExp>;
  predicate: IntComparisonExp;
};

export type UserTermsOfServiceAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<UserTermsOfServiceSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<UserTermsOfServiceBoolExp>;
  predicate: IntComparisonExp;
};

export type UsernameLogsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<UsernameLogsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<UsernameLogsBoolExp>;
  predicate: IntComparisonExp;
};

export type UsernamesClaimedAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<UsernamesClaimedSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<UsernamesClaimedBoolExp>;
  predicate: IntComparisonExp;
};

export type UsersAggregateBoolExpBool_And = {
  arguments: UsersSelectColumnUsersAggregateBoolExpBool_AndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<UsersBoolExp>;
  predicate: BooleanComparisonExp;
};

export type UsersAggregateBoolExpBool_Or = {
  arguments: UsersSelectColumnUsersAggregateBoolExpBool_OrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<UsersBoolExp>;
  predicate: BooleanComparisonExp;
};

export type UsersAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<UsersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<UsersBoolExp>;
  predicate: IntComparisonExp;
};

export type UsersCoachQualificationsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<UsersCoachQualificationsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<UsersCoachQualificationsBoolExp>;
  predicate: IntComparisonExp;
};

export type VenueAmenitiesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<VenueAmenitiesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<VenueAmenitiesBoolExp>;
  predicate: IntComparisonExp;
};

export type VenueBookingConfigVersionsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<VenueBookingConfigVersionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<VenueBookingConfigVersionsBoolExp>;
  predicate: IntComparisonExp;
};

export type VenueBookingConnectionChecksAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<VenueBookingConnectionChecksSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<VenueBookingConnectionChecksBoolExp>;
  predicate: IntComparisonExp;
};

export type VenueBookingCourtRatesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<VenueBookingCourtRatesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<VenueBookingCourtRatesBoolExp>;
  predicate: IntComparisonExp;
};

export type VenueBookingRuleTiersAggregateBoolExpBool_And = {
  arguments: VenueBookingRuleTiersSelectColumnVenueBookingRuleTiersAggregateBoolExpBool_AndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<VenueBookingRuleTiersBoolExp>;
  predicate: BooleanComparisonExp;
};

export type VenueBookingRuleTiersAggregateBoolExpBool_Or = {
  arguments: VenueBookingRuleTiersSelectColumnVenueBookingRuleTiersAggregateBoolExpBool_OrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<VenueBookingRuleTiersBoolExp>;
  predicate: BooleanComparisonExp;
};

export type VenueBookingRuleTiersAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<VenueBookingRuleTiersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<VenueBookingRuleTiersBoolExp>;
  predicate: IntComparisonExp;
};

export type VenueBookingRulesAggregateBoolExpBool_And = {
  arguments: VenueBookingRulesSelectColumnVenueBookingRulesAggregateBoolExpBool_AndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<VenueBookingRulesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type VenueBookingRulesAggregateBoolExpBool_Or = {
  arguments: VenueBookingRulesSelectColumnVenueBookingRulesAggregateBoolExpBool_OrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<VenueBookingRulesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type VenueBookingRulesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<VenueBookingRulesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<VenueBookingRulesBoolExp>;
  predicate: IntComparisonExp;
};

export type VenueBookingWindowsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<VenueBookingWindowsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<VenueBookingWindowsBoolExp>;
  predicate: IntComparisonExp;
};

export type VenueCourtSurfacesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<VenueCourtSurfacesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<VenueCourtSurfacesBoolExp>;
  predicate: IntComparisonExp;
};

export type VenueCustomAmenitiesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<VenueCustomAmenitiesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<VenueCustomAmenitiesBoolExp>;
  predicate: IntComparisonExp;
};

export type VenueEquipmentAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<VenueEquipmentSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<VenueEquipmentBoolExp>;
  predicate: IntComparisonExp;
};

export type VenueFaqsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<VenueFaqsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<VenueFaqsBoolExp>;
  predicate: IntComparisonExp;
};

export type VenueFollowsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<VenueFollowsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<VenueFollowsBoolExp>;
  predicate: IntComparisonExp;
};

export type VenueImagesAggregateBoolExpBool_And = {
  arguments: VenueImagesSelectColumnVenueImagesAggregateBoolExpBool_AndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<VenueImagesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type VenueImagesAggregateBoolExpBool_Or = {
  arguments: VenueImagesSelectColumnVenueImagesAggregateBoolExpBool_OrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<VenueImagesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type VenueImagesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<VenueImagesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<VenueImagesBoolExp>;
  predicate: IntComparisonExp;
};

export type VenueStaffCoachesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<VenueStaffCoachesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<VenueStaffCoachesBoolExp>;
  predicate: IntComparisonExp;
};

export type VenuesAggregateBoolExpBool_And = {
  arguments: VenuesSelectColumnVenuesAggregateBoolExpBool_AndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<VenuesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type VenuesAggregateBoolExpBool_Or = {
  arguments: VenuesSelectColumnVenuesAggregateBoolExpBool_OrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<VenuesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type VenuesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<VenuesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<VenuesBoolExp>;
  predicate: IntComparisonExp;
};

export type VideoAnalysisAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<VideoAnalysisSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<VideoAnalysisBoolExp>;
  predicate: IntComparisonExp;
};

export type VideoAnalysisCommentsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<VideoAnalysisCommentsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<VideoAnalysisCommentsBoolExp>;
  predicate: IntComparisonExp;
};

export type VideoAnalysisFilesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<VideoAnalysisFilesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<VideoAnalysisFilesBoolExp>;
  predicate: IntComparisonExp;
};

export type VideoAnalysisOrderItemsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<VideoAnalysisOrderItemsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<VideoAnalysisOrderItemsBoolExp>;
  predicate: IntComparisonExp;
};

export type VideoAnalysisOrdersAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<VideoAnalysisOrdersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<VideoAnalysisOrdersBoolExp>;
  predicate: IntComparisonExp;
};

export type VideoAnalysisRequestedSkillsReviewAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<VideoAnalysisRequestedSkillsReviewSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<VideoAnalysisRequestedSkillsReviewBoolExp>;
  predicate: IntComparisonExp;
};

export type VideoAnalysisSkillsCommentsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<VideoAnalysisSkillsCommentsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<VideoAnalysisSkillsCommentsBoolExp>;
  predicate: IntComparisonExp;
};

export type EventPageFieldsFragment = { __typename?: 'Events', addressString?: string | null, cityId?: any | null, coverImageFileName?: string | null, coverImagePath?: string | null, coverImageUrl?: string | null, currency: string, createdAt: any, description: string, displayLocation: string, endDate: any, endDateTime: any, externalUrl?: string | null, geometry?: any | null, hasPrizes: boolean, id: any, isExternal: boolean, isShowPlayersGoing: boolean, organizerImageUrl?: string | null, organizerImagePath?: string | null, locale: string, isSanctioned: boolean, privacy: EventPrivacyEnum, prizeDescription: string, publishedAt?: any | null, canceledAt?: any | null, cancelReason: string, registrationClosedAt?: any | null, registrationDeadlineDate: any, registrationDeadlineDateTime?: any | null, registrationPriceUnitAmount: number, slug: string, scoringFormat?: ScoringFormatEnum | null, sport: SportsEnum, startDate: any, startDateTime: any, status: EventStatusesEnum, title: string, type: EventTypesEnum, isRfx: boolean, timezoneName: string, timezoneOffsetMinutes: number, timezoneAbbreviation: string, sourceRegistrationCount: number, sourceOrganizerTitle?: string | null, groupFormat?: EventGroupFormatsEnum | null, isRatingRequired: boolean, ballCustomName: string, ballType: BallTypesEnum, city?: { __typename?: 'Cities', id: any, name: string, slug: string, countrySubdivision: { __typename?: 'CountrySubdivisions', id: any, name: string, slug: string, code: string, country: { __typename?: 'Countries', id: string, name: string, slug: string } } } | null, venue?: { __typename?: 'Venues', id: any, title: string, venueSlug: string, slug: string, pickleballLines?: VenueLinesEnum | null, pickleballNets?: VenueNetsEnum | null, longitude: any, latitude: any, geometry?: any | null, addressString: string, outdoorCourtCount: number, indoorCourtCount: number, timezone: string, images: Array<{ __typename?: 'VenueImages', id: any, path: string, url: string }>, courtSurfaces: Array<{ __typename?: 'VenueCourtSurfaces', id: any, courtSurface: CourtSurfacesEnum }> } | null, pickleballRatingScale?: { __typename?: 'PickleballRatingScales', id: any, maximum: any, minimum: any, name: string, shortName: string } | null, hostUserProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null } | null, faqs: Array<{ __typename?: 'EventFaqs', id: any, question: string, answer: string }> };

export type ClaimPlayRequestForAcceptMutationVariables = Exact<{
  id: Scalars['uuid'];
  respondedAt: Scalars['timestamptz'];
}>;


export type ClaimPlayRequestForAcceptMutation = { __typename?: 'mutation_root', updatePlayRequests?: { __typename?: 'PlayRequestsMutationResponse', affectedRows: number } | null };

export type ReleasePlayRequestClaimMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type ReleasePlayRequestClaimMutation = { __typename?: 'mutation_root', updatePlayRequests?: { __typename?: 'PlayRequestsMutationResponse', affectedRows: number } | null };

export type AttachConversationToPlayRequestMutationVariables = Exact<{
  id: Scalars['uuid'];
  conversationId: Scalars['uuid'];
}>;


export type AttachConversationToPlayRequestMutation = { __typename?: 'mutation_root', updatePlayRequestsByPk?: { __typename?: 'PlayRequests', id: any, status: PlayRequestStatusesEnum, conversationId?: any | null } | null };

export type ActivateVenueBookingMutationVariables = Exact<{
  integrationId: Scalars['uuid'];
}>;


export type ActivateVenueBookingMutation = { __typename?: 'mutation_root', updateVenueBookingIntegrationsByPk?: { __typename?: 'VenueBookingIntegrations', id: any, status: BookingIntegrationStatusesEnum, activatedAt?: any | null, venue: { __typename?: 'Venues', title: string } } | null };

export type AdvanceTeamToNextMatchTeam1MutationVariables = Exact<{
  matchId: Scalars['uuid'];
  teamId: Scalars['uuid'];
}>;


export type AdvanceTeamToNextMatchTeam1Mutation = { __typename?: 'mutation_root', updateEventMatchesByPk?: { __typename?: 'EventMatches', id: any } | null };

export type AdvanceTeamToNextMatchTeam2MutationVariables = Exact<{
  matchId: Scalars['uuid'];
  teamId: Scalars['uuid'];
}>;


export type AdvanceTeamToNextMatchTeam2Mutation = { __typename?: 'mutation_root', updateEventMatchesByPk?: { __typename?: 'EventMatches', id: any } | null };

export type ApproveVenueClaimForUserMutationVariables = Exact<{
  userId: Scalars['uuid'];
  venueId: Scalars['uuid'];
}>;


export type ApproveVenueClaimForUserMutation = { __typename?: 'mutation_root', updateUsersByPk?: { __typename?: 'Users', id: any, adminVenueId?: any | null } | null, updateVenuesByPk?: { __typename?: 'Venues', id: any, isActive: boolean, deletedAt?: any | null } | null };

export type ArchiveUserCreditCardMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type ArchiveUserCreditCardMutation = { __typename?: 'mutation_root', updateUserCreditCardsByPk?: { __typename?: 'UserCreditCards', id: any, archivedAt?: any | null } | null };

export type AssignCourtToMatchMutationVariables = Exact<{
  matchId: Scalars['uuid'];
  courtId: Scalars['uuid'];
  courtNumber: Scalars['Int'];
  groupId?: InputMaybe<Scalars['uuid']>;
  poolId?: InputMaybe<Scalars['uuid']>;
}>;


export type AssignCourtToMatchMutation = { __typename?: 'mutation_root', updateEventMatchesByPk?: { __typename?: 'EventMatches', id: any, eventCourtId?: any | null, courtNumber?: number | null } | null, updateEventCourtsByPk?: { __typename?: 'EventCourts', id: any, updatedAt: any, courtNumber: number, courtStatus: EventCourtStatusesEnum, activeEventGroupId?: any | null, activeEventGroupPoolId?: any | null } | null };

export type AssignCourtToMatchAndActivateMutationVariables = Exact<{
  matchId: Scalars['uuid'];
  courtId: Scalars['uuid'];
  courtNumber: Scalars['Int'];
  groupId?: InputMaybe<Scalars['uuid']>;
  poolId?: InputMaybe<Scalars['uuid']>;
}>;


export type AssignCourtToMatchAndActivateMutation = { __typename?: 'mutation_root', updateEventMatchesByPk?: { __typename?: 'EventMatches', id: any, eventCourtId?: any | null, courtNumber?: number | null } | null, updateEventCourtsByPk?: { __typename?: 'EventCourts', id: any, updatedAt: any, courtNumber: number, courtStatus: EventCourtStatusesEnum, activeMatchId?: any | null, activeEventGroupId?: any | null, activeEventGroupPoolId?: any | null } | null };

export type AssignCourtsToGamedayMutationVariables = Exact<{
  courtUpdates?: InputMaybe<Array<EventCourtsUpdates> | EventCourtsUpdates>;
  matchUpdates?: InputMaybe<Array<EventMatchesUpdates> | EventMatchesUpdates>;
}>;


export type AssignCourtsToGamedayMutation = { __typename?: 'mutation_root', updateEventCourtsMany?: Array<{ __typename?: 'EventCourtsMutationResponse', returning: Array<{ __typename?: 'EventCourts', id: any }> } | null> | null, updateEventMatchesMany?: Array<{ __typename?: 'EventMatchesMutationResponse', returning: Array<{ __typename?: 'EventMatches', id: any }> } | null> | null };

export type AutoCancelOtherEventRequestsMutationVariables = Exact<{
  eventId: Scalars['uuid'];
  respondedAt: Scalars['timestamptz'];
}>;


export type AutoCancelOtherEventRequestsMutation = { __typename?: 'mutation_root', updatePlayRequests?: { __typename?: 'PlayRequestsMutationResponse', affectedRows: number, returning: Array<{ __typename?: 'PlayRequests', id: any, requesterUserId: any }> } | null };

export type BumpConversationForNewMessageMutationVariables = Exact<{
  conversationId: Scalars['uuid'];
  senderUserId: Scalars['uuid'];
  at: Scalars['timestamptz'];
}>;


export type BumpConversationForNewMessageMutation = { __typename?: 'mutation_root', updateConversations?: { __typename?: 'ConversationsMutationResponse', affectedRows: number } | null, updateConversationParticipants?: { __typename?: 'ConversationParticipantsMutationResponse', affectedRows: number } | null };

export type CancelOwnPendingEventRequestMutationVariables = Exact<{
  eventId: Scalars['uuid'];
  requesterUserId: Scalars['uuid'];
  respondedAt: Scalars['timestamptz'];
}>;


export type CancelOwnPendingEventRequestMutation = { __typename?: 'mutation_root', updatePlayRequests?: { __typename?: 'PlayRequestsMutationResponse', affectedRows: number } | null };

export type CancelPendingInvitationsForRegistrationMutationVariables = Exact<{
  groupRegistrationId: Scalars['uuid'];
  senderUserId: Scalars['uuid'];
  deletedAt: Scalars['timestamptz'];
}>;


export type CancelPendingInvitationsForRegistrationMutation = { __typename?: 'mutation_root', updateEventInvitations?: { __typename?: 'EventInvitationsMutationResponse', affectedRows: number } | null };

export type CascadeClearKnockoutMatchesMutationVariables = Exact<{
  matchIds: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type CascadeClearKnockoutMatchesMutation = { __typename?: 'mutation_root', cascadeGameScores?: { __typename?: 'EventGameScoresMutationResponse', affectedRows: number } | null, cascadeGames?: { __typename?: 'EventMatchGamesMutationResponse', affectedRows: number } | null, cascadeCourts?: { __typename?: 'EventCourtsMutationResponse', affectedRows: number } | null, cascadeMatches?: { __typename?: 'EventMatchesMutationResponse', affectedRows: number } | null };

export type ChangeUserEmailMutationVariables = Exact<{
  id: Scalars['uuid'];
  email: Scalars['String'];
}>;


export type ChangeUserEmailMutation = { __typename?: 'mutation_root', updateUsersByPk?: { __typename?: 'Users', id: any, email: string } | null };

export type CleanupSoloTeamOnPartnerAcceptMutationVariables = Exact<{
  oldTeamId: Scalars['uuid'];
  groupRegistrationId: Scalars['uuid'];
  newTeamId: Scalars['uuid'];
}>;


export type CleanupSoloTeamOnPartnerAcceptMutation = { __typename?: 'mutation_root', deleteEventTeamMembers?: { __typename?: 'EventTeamMembersMutationResponse', affectedRows: number } | null, deleteEventTeams?: { __typename?: 'EventTeamsMutationResponse', affectedRows: number } | null, updateEventGroupRegistrationsByPk?: { __typename?: 'EventGroupRegistrations', id: any } | null };

export type InsertConnectionRequestMutationVariables = Exact<{
  requesterUserId: Scalars['uuid'];
  recipientUserId: Scalars['uuid'];
  message?: InputMaybe<Scalars['String']>;
  attemptNumber: Scalars['smallint'];
}>;


export type InsertConnectionRequestMutation = { __typename?: 'mutation_root', insertUserConnectionRequestsOne?: { __typename?: 'UserConnectionRequests', id: any, status: UserConnectionRequestStatusesEnum } | null };

export type ClaimConnectionRequestMutationVariables = Exact<{
  id: Scalars['uuid'];
  status: UserConnectionRequestStatusesEnum;
  respondedAt: Scalars['timestamptz'];
}>;


export type ClaimConnectionRequestMutation = { __typename?: 'mutation_root', updateUserConnectionRequests?: { __typename?: 'UserConnectionRequestsMutationResponse', affectedRows: number } | null };

export type ArchiveConnectionRequestsForPairMutationVariables = Exact<{
  userId: Scalars['uuid'];
  otherUserId: Scalars['uuid'];
  archivedAt: Scalars['timestamptz'];
}>;


export type ArchiveConnectionRequestsForPairMutation = { __typename?: 'mutation_root', updateUserConnectionRequests?: { __typename?: 'UserConnectionRequestsMutationResponse', affectedRows: number } | null };

export type ArchiveConnectionRequestsFromMutationVariables = Exact<{
  requesterUserId: Scalars['uuid'];
  recipientUserId: Scalars['uuid'];
  archivedAt: Scalars['timestamptz'];
}>;


export type ArchiveConnectionRequestsFromMutation = { __typename?: 'mutation_root', updateUserConnectionRequests?: { __typename?: 'UserConnectionRequestsMutationResponse', affectedRows: number } | null };

export type CreateCalendarEventMappingMutationVariables = Exact<{
  lessonId: Scalars['uuid'];
  externalEventId: Scalars['String'];
  calendarPreferenceId: Scalars['uuid'];
}>;


export type CreateCalendarEventMappingMutation = { __typename?: 'mutation_root', insertCalendarEventMappings?: { __typename?: 'CalendarEventMappingsMutationResponse', returning: Array<{ __typename?: 'CalendarEventMappings', id: any, lessonId: any, externalEventId: string }> } | null };

export type CreateVenueAdminClaimMutationVariables = Exact<{
  venueId: Scalars['uuid'];
  userId: Scalars['uuid'];
  status: VenueAdminClaimStatusesEnum;
  reviewedAt?: InputMaybe<Scalars['timestamptz']>;
  reviewedByUserId?: InputMaybe<Scalars['uuid']>;
  notes?: InputMaybe<Scalars['String']>;
}>;


export type CreateVenueAdminClaimMutation = { __typename?: 'mutation_root', insertVenueAdminClaimsOne?: { __typename?: 'VenueAdminClaims', id: any, venueId: any, userId: any, status: VenueAdminClaimStatusesEnum } | null };

export type CreateVenueProfileMutationVariables = Exact<{
  title: Scalars['String'];
  venueSlug: Scalars['String'];
  slug: Scalars['String'];
  addressString: Scalars['String'];
  latitude: Scalars['numeric'];
  longitude: Scalars['numeric'];
  cityId?: InputMaybe<Scalars['uuid']>;
  googlePlaceId?: InputMaybe<Scalars['String']>;
  geometry: Scalars['geography'];
  coordinatesWkb: Scalars['String'];
  accessType?: InputMaybe<VenueAccessTypesEnum>;
  facilityType?: InputMaybe<VenueFacilityTypesEnum>;
  indoorCourtCount: Scalars['Int'];
  outdoorCourtCount: Scalars['Int'];
  totalCourtCount: Scalars['Int'];
  pickleballNets?: InputMaybe<VenueNetsEnum>;
  pickleballLines?: InputMaybe<VenueLinesEnum>;
  isActive: Scalars['Boolean'];
  hasTennis: Scalars['Boolean'];
  hasPickleball: Scalars['Boolean'];
  hasPadel: Scalars['Boolean'];
  hasReservations: Scalars['Boolean'];
  email?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  websiteUrl?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  timezone: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  instagramUrl?: InputMaybe<Scalars['String']>;
  facebookUrl?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  linkedinUrl?: InputMaybe<Scalars['String']>;
  twitterUrl?: InputMaybe<Scalars['String']>;
  venueAmenities: Array<VenueAmenitiesInsertInput> | VenueAmenitiesInsertInput;
  venueCourtSurfaces: Array<VenueCourtSurfacesInsertInput> | VenueCourtSurfacesInsertInput;
  venueEquipment: Array<VenueEquipmentInsertInput> | VenueEquipmentInsertInput;
  venueCustomAmenities: Array<VenueCustomAmenitiesInsertInput> | VenueCustomAmenitiesInsertInput;
  venueImages: Array<VenueImagesInsertInput> | VenueImagesInsertInput;
}>;


export type CreateVenueProfileMutation = { __typename?: 'mutation_root', insertVenuesOne?: { __typename?: 'Venues', id: any, title: string, venueSlug: string, slug: string } | null };

export type DeleteEmptyTeamMutationVariables = Exact<{
  teamId: Scalars['uuid'];
}>;


export type DeleteEmptyTeamMutation = { __typename?: 'mutation_root', deleteEventTeams?: { __typename?: 'EventTeamsMutationResponse', affectedRows: number } | null };

export type DeleteEventByIdMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type DeleteEventByIdMutation = { __typename?: 'mutation_root', deleteEventGameScores?: { __typename?: 'EventGameScoresMutationResponse', affectedRows: number } | null, deleteEventMatchGames?: { __typename?: 'EventMatchGamesMutationResponse', affectedRows: number } | null, deleteEventMatchesTeams?: { __typename?: 'EventMatchesTeamsMutationResponse', affectedRows: number } | null, deleteEventMatches?: { __typename?: 'EventMatchesMutationResponse', affectedRows: number } | null, deleteEventRegistrations?: { __typename?: 'EventRegistrationsMutationResponse', affectedRows: number } | null, deleteEventTeamMembers?: { __typename?: 'EventTeamMembersMutationResponse', affectedRows: number } | null, deleteEventPoolsTeams?: { __typename?: 'EventPoolsTeamsMutationResponse', affectedRows: number } | null, deleteEventTeams?: { __typename?: 'EventTeamsMutationResponse', affectedRows: number } | null, deleteEventPoolRounds?: { __typename?: 'EventPoolRoundsMutationResponse', affectedRows: number } | null, deleteEventGroupPools?: { __typename?: 'EventGroupPoolsMutationResponse', affectedRows: number } | null, deleteEventGroupRegistrations?: { __typename?: 'EventGroupRegistrationsMutationResponse', affectedRows: number } | null, deleteEventGroupSequences?: { __typename?: 'EventGroupSequencesMutationResponse', affectedRows: number } | null, deleteEventGroups?: { __typename?: 'EventGroupsMutationResponse', affectedRows: number } | null, deleteEventsByPk?: { __typename?: 'Events', id: any } | null };

export type DeleteEventCouponMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type DeleteEventCouponMutation = { __typename?: 'mutation_root', updateEventCouponsByPk?: { __typename?: 'EventCoupons', id: any } | null };

export type DeleteEventCourtsByGroupMutationVariables = Exact<{
  eventId: Scalars['uuid'];
  groupId: Scalars['uuid'];
}>;


export type DeleteEventCourtsByGroupMutation = { __typename?: 'mutation_root', deleteEventCourts?: { __typename?: 'EventCourtsMutationResponse', affectedRows: number } | null };

export type DeleteTeamsByGroupIdMutationVariables = Exact<{
  groupId: Scalars['uuid'];
}>;


export type DeleteTeamsByGroupIdMutation = { __typename?: 'mutation_root', deleteEventTeamMembers?: { __typename?: 'EventTeamMembersMutationResponse', affectedRows: number } | null, deleteEventTeams?: { __typename?: 'EventTeamsMutationResponse', affectedRows: number } | null };

export type ClaimPartnerBookingAttemptMutationVariables = Exact<{
  attemptId: Scalars['uuid'];
  orderId: Scalars['uuid'];
  now: Scalars['timestamptz'];
  firstCheckAt: Scalars['timestamptz'];
}>;


export type ClaimPartnerBookingAttemptMutation = { __typename?: 'mutation_root', updatePartnerBookingAttempts?: { __typename?: 'PartnerBookingAttemptsMutationResponse', affectedRows: number } | null, updatePartnerBookingOrders?: { __typename?: 'PartnerBookingOrdersMutationResponse', affectedRows: number } | null };

export type RecordPartnerBookingDispatchMutationVariables = Exact<{
  attemptId: Scalars['uuid'];
  runId?: InputMaybe<Scalars['String']>;
  event: Scalars['String'];
  body: Scalars['jsonb'];
}>;


export type RecordPartnerBookingDispatchMutation = { __typename?: 'mutation_root', updatePartnerBookingAttempts?: { __typename?: 'PartnerBookingAttemptsMutationResponse', affectedRows: number } | null, insertPartnerBookingAttemptEventsOne?: { __typename?: 'PartnerBookingAttemptEvents', id: any } | null };

export type RequeuePartnerBookingAttemptMutationVariables = Exact<{
  attemptId: Scalars['uuid'];
  body: Scalars['jsonb'];
}>;


export type RequeuePartnerBookingAttemptMutation = { __typename?: 'mutation_root', updatePartnerBookingAttempts?: { __typename?: 'PartnerBookingAttemptsMutationResponse', affectedRows: number } | null, insertPartnerBookingAttemptEventsOne?: { __typename?: 'PartnerBookingAttemptEvents', id: any } | null };

export type FailPartnerBookingDispatchMutationVariables = Exact<{
  attemptId: Scalars['uuid'];
  orderId: Scalars['uuid'];
  now: Scalars['timestamptz'];
  body: Scalars['jsonb'];
}>;


export type FailPartnerBookingDispatchMutation = { __typename?: 'mutation_root', updatePartnerBookingAttempts?: { __typename?: 'PartnerBookingAttemptsMutationResponse', affectedRows: number } | null, updatePartnerBookingOrders?: { __typename?: 'PartnerBookingOrdersMutationResponse', affectedRows: number } | null, updatePartnerBookingHolds?: { __typename?: 'PartnerBookingHoldsMutationResponse', affectedRows: number } | null, insertPartnerBookingAttemptEventsOne?: { __typename?: 'PartnerBookingAttemptEvents', id: any } | null };

export type InsertEventPlayerInvitesMutationVariables = Exact<{
  objects: Array<EventPlayerInvitesInsertInput> | EventPlayerInvitesInsertInput;
}>;


export type InsertEventPlayerInvitesMutation = { __typename?: 'mutation_root', insertEventPlayerInvites?: { __typename?: 'EventPlayerInvitesMutationResponse', returning: Array<{ __typename?: 'EventPlayerInvites', id: any, invitedUserId: any }> } | null };

export type ClaimEventPlayerInviteMutationVariables = Exact<{
  id: Scalars['uuid'];
  status: EventPlayerInviteStatusesEnum;
  respondedAt: Scalars['timestamptz'];
}>;


export type ClaimEventPlayerInviteMutation = { __typename?: 'mutation_root', updateEventPlayerInvites?: { __typename?: 'EventPlayerInvitesMutationResponse', affectedRows: number } | null };

export type ReleaseEventPlayerInviteMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type ReleaseEventPlayerInviteMutation = { __typename?: 'mutation_root', updateEventPlayerInvites?: { __typename?: 'EventPlayerInvitesMutationResponse', affectedRows: number } | null };

export type AttachPlayRequestToInviteMutationVariables = Exact<{
  id: Scalars['uuid'];
  playRequestId: Scalars['uuid'];
}>;


export type AttachPlayRequestToInviteMutation = { __typename?: 'mutation_root', updateEventPlayerInvitesByPk?: { __typename?: 'EventPlayerInvites', id: any } | null };

export type CancelEventPlayerInvitesMutationVariables = Exact<{
  eventId: Scalars['uuid'];
  invitedUserIds: Array<Scalars['uuid']> | Scalars['uuid'];
  respondedAt: Scalars['timestamptz'];
}>;


export type CancelEventPlayerInvitesMutation = { __typename?: 'mutation_root', updateEventPlayerInvites?: { __typename?: 'EventPlayerInvitesMutationResponse', affectedRows: number, returning: Array<{ __typename?: 'EventPlayerInvites', id: any, invitedUserId: any }> } | null };

export type CancelEventPlayerInvitesBetweenUsersMutationVariables = Exact<{
  userId: Scalars['uuid'];
  otherUserId: Scalars['uuid'];
  respondedAt: Scalars['timestamptz'];
}>;


export type CancelEventPlayerInvitesBetweenUsersMutation = { __typename?: 'mutation_root', updateEventPlayerInvites?: { __typename?: 'EventPlayerInvitesMutationResponse', affectedRows: number } | null };

export type DeclineEventPlayerInviteForPlayRequestMutationVariables = Exact<{
  playRequestId: Scalars['uuid'];
  respondedAt: Scalars['timestamptz'];
}>;


export type DeclineEventPlayerInviteForPlayRequestMutation = { __typename?: 'mutation_root', updateEventPlayerInvites?: { __typename?: 'EventPlayerInvitesMutationResponse', affectedRows: number } | null };

export type InsertEventsOneMutationVariables = Exact<{
  object: EventsInsertInput;
}>;


export type InsertEventsOneMutation = { __typename?: 'mutation_root', insertEventsOne?: { __typename?: 'Events', id: any } | null };

export type InsertEventFaqsMutationVariables = Exact<{
  objects: Array<EventFaqsInsertInput> | EventFaqsInsertInput;
}>;


export type InsertEventFaqsMutation = { __typename?: 'mutation_root', insertEventFaqs?: { __typename?: 'EventFaqsMutationResponse', returning: Array<{ __typename?: 'EventFaqs', id: any }> } | null };

export type InsertEventGroupsMutationVariables = Exact<{
  objects: Array<EventGroupsInsertInput> | EventGroupsInsertInput;
}>;


export type InsertEventGroupsMutation = { __typename?: 'mutation_root', insertEventGroups?: { __typename?: 'EventGroupsMutationResponse', returning: Array<{ __typename?: 'EventGroups', id: any }> } | null };

export type InsertEventSponsorsMutationVariables = Exact<{
  objects: Array<EventSponsorsInsertInput> | EventSponsorsInsertInput;
}>;


export type InsertEventSponsorsMutation = { __typename?: 'mutation_root', insertEventSponsors?: { __typename?: 'EventSponsorsMutationResponse', returning: Array<{ __typename?: 'EventSponsors', id: any }> } | null };

export type UpdateAdminProgramMutationVariables = Exact<{
  eventId: Scalars['uuid'];
  eventSet: EventsSetInput;
  updateEvent: Scalars['Boolean'];
  groupId: Scalars['uuid'];
  groupSet: EventGroupsSetInput;
  updateGroup: Scalars['Boolean'];
  replaceSlots: Scalars['Boolean'];
  deletedAt: Scalars['timestamptz'];
  slots: Array<EventGroupTimeSlotsInsertInput> | EventGroupTimeSlotsInsertInput;
}>;


export type UpdateAdminProgramMutation = { __typename?: 'mutation_root', updateEventGroupTimeSlots?: { __typename?: 'EventGroupTimeSlotsMutationResponse', affectedRows: number } | null, insertEventGroupTimeSlots?: { __typename?: 'EventGroupTimeSlotsMutationResponse', affectedRows: number } | null, updateEventGroupsByPk?: { __typename?: 'EventGroups', id: any } | null, updateEventsByPk?: { __typename?: 'Events', id: any } | null };

export type UpsertEventFromSourceMutationVariables = Exact<{
  object: EventsInsertInput;
}>;


export type UpsertEventFromSourceMutation = { __typename?: 'mutation_root', insertEventsOne?: { __typename?: 'Events', id: any, sourceId?: string | null } | null };

export type FreeCourtMutationVariables = Exact<{
  courtId: Scalars['uuid'];
}>;


export type FreeCourtMutation = { __typename?: 'mutation_root', updateEventCourtsByPk?: { __typename?: 'EventCourts', id: any, activeMatchId?: any | null } | null };

export type FreeCourtsForGroupMutationVariables = Exact<{
  eventId: Scalars['uuid'];
  groupId: Scalars['uuid'];
}>;


export type FreeCourtsForGroupMutation = { __typename?: 'mutation_root', updateEventCourts?: { __typename?: 'EventCourtsMutationResponse', affectedRows: number } | null };

export type InsertAcceptedPlayRequestMutationVariables = Exact<{
  requesterUserId: Scalars['uuid'];
  recipientUserId: Scalars['uuid'];
  eventId: Scalars['uuid'];
  status: PlayRequestStatusesEnum;
  respondedAt: Scalars['timestamptz'];
  conversationId?: InputMaybe<Scalars['uuid']>;
}>;


export type InsertAcceptedPlayRequestMutation = { __typename?: 'mutation_root', insertPlayRequestsOne?: { __typename?: 'PlayRequests', id: any, status: PlayRequestStatusesEnum } | null };

export type InsertActiveLessonOrderMutationVariables = Exact<{
  customerApplicationFeeUnitAmount: Scalars['Int'];
  customerUserId: Scalars['uuid'];
  externalStripePaymentIntentId: Scalars['String'];
  orderSubtotalUnitAmount: Scalars['Int'];
  itemPriceUnitAmount: Scalars['Int'];
  itemTotalUnitAmount: Scalars['Int'];
  lessonId: Scalars['uuid'];
  userId: Scalars['uuid'];
  orderTotalUnitAmount: Scalars['Int'];
  transferUnitAmount: Scalars['Int'];
  paidUnitAmount: Scalars['Int'];
  sellerApplicationFeeUnitAmount: Scalars['Int'];
  applicationFeeTotalUnitAmount: Scalars['Int'];
  sellerUserId: Scalars['uuid'];
  stripeCustomerId: Scalars['String'];
  stripeMerchantId: Scalars['String'];
  stripePaymentStatus: Scalars['String'];
  amount: Scalars['Int'];
  amountCapturable: Scalars['Int'];
  amountReceived: Scalars['Int'];
  application?: InputMaybe<Scalars['String']>;
  applicationFeeAmount?: InputMaybe<Scalars['Int']>;
  cancellationReason?: InputMaybe<Scalars['String']>;
  currency: Scalars['String'];
  onBehalfOf?: InputMaybe<Scalars['String']>;
  paymentIntentId: Scalars['String'];
  paymentMethod?: InputMaybe<Scalars['String']>;
  statementDescriptor?: InputMaybe<Scalars['String']>;
  paymentIntentStatus: Scalars['String'];
  paymentIntentStripeCustomerId: Scalars['String'];
  transferDataAmount?: InputMaybe<Scalars['Int']>;
  transferDataDestination?: InputMaybe<Scalars['String']>;
  transferGroup?: InputMaybe<Scalars['String']>;
  transferId?: InputMaybe<Scalars['String']>;
  sourceTransfer?: InputMaybe<Scalars['String']>;
  chargeAmount: Scalars['Int'];
  amountCaptured: Scalars['Int'];
  amountRefunded: Scalars['Int'];
  chargeApplication?: InputMaybe<Scalars['String']>;
  chargeApplicationFee?: InputMaybe<Scalars['String']>;
  chargeApplicationFeeAmount?: InputMaybe<Scalars['Int']>;
  calculatedStatementDescriptor?: InputMaybe<Scalars['String']>;
  captured: Scalars['Boolean'];
  chargeId: Scalars['String'];
  chargeCurrency: Scalars['String'];
  disputed: Scalars['Boolean'];
  chargeExternalStripePaymentIntentId: Scalars['String'];
  chargePaid: Scalars['Boolean'];
  chargePaymentMethod?: InputMaybe<Scalars['String']>;
  refunded: Scalars['Boolean'];
  chargeStripeCustomerId: Scalars['String'];
  userCreditCardId?: InputMaybe<Scalars['uuid']>;
  referralName?: InputMaybe<Scalars['String']>;
}>;


export type InsertActiveLessonOrderMutation = { __typename?: 'mutation_root', insertLessonOrdersOne?: { __typename?: 'LessonOrders', id: any, items: Array<{ __typename?: 'LessonOrderItems', id: any, lessonParticipant: { __typename?: 'LessonParticipants', id: any, status: LessonParticipantStatusesEnum, userId: any, lessonId: any, user: { __typename?: 'Users', id: any, fullName: string }, lesson: { __typename?: 'Lessons', id: any, status: LessonStatusesEnum, startDateTime?: any | null, title: string, type: LessonTypesEnum, locale: string, timezoneName: string, timezoneAbbreviation: string, timezoneOffsetMinutes: number, owner?: { __typename?: 'Users', id: any, email: string, preferredName: string, fullName: string } | null } } }> } | null };

export type InsertBoostOrderMutationVariables = Exact<{
  object: BoostOrdersInsertInput;
}>;


export type InsertBoostOrderMutation = { __typename?: 'mutation_root', insertBoostOrdersOne?: { __typename?: 'BoostOrders', id: any, boosts: Array<{ __typename?: 'Boosts', id: any }> } | null };

export type InsertCoachBookingRequestMutationVariables = Exact<{
  coachStarterProfileId?: InputMaybe<Scalars['uuid']>;
  coachUserId?: InputMaybe<Scalars['uuid']>;
  playerUserId: Scalars['uuid'];
  message: Scalars['String'];
}>;


export type InsertCoachBookingRequestMutation = { __typename?: 'mutation_root', insertCoachBookingRequestsOne?: { __typename?: 'CoachBookingRequests', id: any, createdAt: any, playerUserId: any, coachUserId?: any | null, coachStarterProfileId?: any | null } | null };

export type InsertCoachLessonOrderMutationVariables = Exact<{
  title: Scalars['String'];
  sport?: InputMaybe<SportsEnum>;
  type?: InputMaybe<LessonTypesEnum>;
  typeCustom?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<LessonStatusesEnum>;
  description?: InputMaybe<Scalars['String']>;
  startDateTime: Scalars['timestamptz'];
  endDateTime: Scalars['timestamptz'];
  ownerUserId: Scalars['uuid'];
  paymentFulfillmentChannel?: InputMaybe<PaymentFulfillmentChannelsEnum>;
  priceUnitAmount: Scalars['Int'];
  privacy?: InputMaybe<LessonPrivacyEnum>;
  locale: Scalars['String'];
  timezoneName: Scalars['String'];
  timezoneAbbreviation: Scalars['String'];
  timezoneOffsetMinutes: Scalars['Int'];
  userId: Scalars['uuid'];
  lessonId: Scalars['uuid'];
  customerApplicationFeeUnitAmount: Scalars['Int'];
  customerUserId: Scalars['uuid'];
  externalStripePaymentIntentId: Scalars['String'];
  orderSubtotalUnitAmount: Scalars['Int'];
  orderTotalUnitAmount: Scalars['Int'];
  paidUnitAmount: Scalars['Int'];
  transferUnitAmount: Scalars['Int'];
  sellerApplicationFeeUnitAmount: Scalars['Int'];
  applicationFeeTotalUnitAmount: Scalars['Int'];
  sellerUserId: Scalars['uuid'];
  stripeCustomerId: Scalars['String'];
  stripeMerchantId: Scalars['String'];
  stripePaymentStatus: Scalars['String'];
  phoneCountryCode?: InputMaybe<Scalars['String']>;
  amount: Scalars['Int'];
  amountCapturable: Scalars['Int'];
  amountReceived: Scalars['Int'];
  application?: InputMaybe<Scalars['String']>;
  applicationFeeAmount?: InputMaybe<Scalars['Int']>;
  cancellationReason?: InputMaybe<Scalars['String']>;
  currency: Scalars['String'];
  onBehalfOf?: InputMaybe<Scalars['String']>;
  paymentIntentId: Scalars['String'];
  paymentMethod?: InputMaybe<Scalars['String']>;
  statementDescriptor?: InputMaybe<Scalars['String']>;
  paymentIntentStatus: Scalars['String'];
  paymentIntentStripeCustomerId: Scalars['String'];
  transferDataAmount?: InputMaybe<Scalars['Int']>;
  transferDataDestination?: InputMaybe<Scalars['String']>;
  transferGroup?: InputMaybe<Scalars['String']>;
  transferId?: InputMaybe<Scalars['String']>;
  sourceTransfer?: InputMaybe<Scalars['String']>;
  chargeAmount: Scalars['Int'];
  amountCaptured: Scalars['Int'];
  amountRefunded: Scalars['Int'];
  chargeApplication?: InputMaybe<Scalars['String']>;
  chargeApplicationFee?: InputMaybe<Scalars['String']>;
  chargeApplicationFeeAmount?: InputMaybe<Scalars['Int']>;
  calculatedStatementDescriptor?: InputMaybe<Scalars['String']>;
  captured: Scalars['Boolean'];
  chargeId: Scalars['String'];
  chargeCurrency: Scalars['String'];
  disputed: Scalars['Boolean'];
  chargeExternalStripePaymentIntentId: Scalars['String'];
  chargePaid: Scalars['Boolean'];
  chargePaymentMethod?: InputMaybe<Scalars['String']>;
  refunded: Scalars['Boolean'];
  chargeStripeCustomerId: Scalars['String'];
  venueId?: InputMaybe<Scalars['uuid']>;
  userCustomCourtId?: InputMaybe<Scalars['uuid']>;
  lessonCurrency: Scalars['String'];
}>;


export type InsertCoachLessonOrderMutation = { __typename?: 'mutation_root', insertLessonsOne?: { __typename?: 'Lessons', id: any, status: LessonStatusesEnum, startDateTime?: any | null, title: string, type: LessonTypesEnum, locale: string, timezoneName: string, timezoneAbbreviation: string, timezoneOffsetMinutes: number, owner?: { __typename?: 'Users', id: any, email: string, preferredName: string, fullName: string } | null, participants: Array<{ __typename?: 'LessonParticipants', id: any, status: LessonParticipantStatusesEnum, userId: any, lessonId: any, user: { __typename?: 'Users', id: any, fullName: string } }>, venue?: { __typename?: 'Venues', id: any, title: string, addressString: string } | null, userCustomCourt?: { __typename?: 'UserCustomCourts', id: any, title: string, fullAddress: string } | null } | null };

export type InsertCoachRemoteAnalysisOrderMutationVariables = Exact<{
  reviewStatus?: InputMaybe<VideoAnalysisReviewStatusesEnum>;
  reviewerUserId: Scalars['uuid'];
  submissionUserId: Scalars['uuid'];
  submissionRequestedFeedback: Scalars['String'];
  paymentFulfillmentChannel?: InputMaybe<PaymentFulfillmentChannelsEnum>;
  priceUnitAmount: Scalars['Int'];
  locale: Scalars['String'];
  timezoneName: Scalars['String'];
  timezoneAbbreviation: Scalars['String'];
  timezoneOffsetMinutes: Scalars['Int'];
  videoAnalysisId: Scalars['uuid'];
  customerApplicationFeeUnitAmount: Scalars['Int'];
  customerUserId: Scalars['uuid'];
  externalStripePaymentIntentId: Scalars['String'];
  orderSubtotalUnitAmount: Scalars['Int'];
  orderTotalUnitAmount: Scalars['Int'];
  paidUnitAmount: Scalars['Int'];
  transferUnitAmount: Scalars['Int'];
  sellerApplicationFeeUnitAmount: Scalars['Int'];
  applicationFeeTotalUnitAmount: Scalars['Int'];
  sellerUserId: Scalars['uuid'];
  stripeCustomerId: Scalars['String'];
  stripeMerchantId: Scalars['String'];
  stripePaymentStatus: Scalars['String'];
  amount: Scalars['Int'];
  amountCapturable: Scalars['Int'];
  amountReceived: Scalars['Int'];
  application?: InputMaybe<Scalars['String']>;
  applicationFeeAmount?: InputMaybe<Scalars['Int']>;
  cancellationReason?: InputMaybe<Scalars['String']>;
  currency: Scalars['String'];
  onBehalfOf?: InputMaybe<Scalars['String']>;
  paymentIntentId: Scalars['String'];
  paymentMethod?: InputMaybe<Scalars['String']>;
  statementDescriptor?: InputMaybe<Scalars['String']>;
  paymentIntentStatus: Scalars['String'];
  paymentIntentStripeCustomerId: Scalars['String'];
  transferDataAmount?: InputMaybe<Scalars['Int']>;
  transferDataDestination?: InputMaybe<Scalars['String']>;
  transferGroup?: InputMaybe<Scalars['String']>;
  transferId?: InputMaybe<Scalars['String']>;
  sourceTransfer?: InputMaybe<Scalars['String']>;
  chargeAmount: Scalars['Int'];
  amountCaptured: Scalars['Int'];
  amountRefunded: Scalars['Int'];
  chargeApplication?: InputMaybe<Scalars['String']>;
  chargeApplicationFee?: InputMaybe<Scalars['String']>;
  chargeApplicationFeeAmount?: InputMaybe<Scalars['Int']>;
  calculatedStatementDescriptor?: InputMaybe<Scalars['String']>;
  captured: Scalars['Boolean'];
  chargeId: Scalars['String'];
  chargeCurrency: Scalars['String'];
  disputed: Scalars['Boolean'];
  chargeExternalStripePaymentIntentId: Scalars['String'];
  chargePaid: Scalars['Boolean'];
  chargePaymentMethod?: InputMaybe<Scalars['String']>;
  refunded: Scalars['Boolean'];
  chargeStripeCustomerId: Scalars['String'];
  videoAnalysisFileId?: InputMaybe<Scalars['uuid']>;
  skills?: InputMaybe<Array<VideoAnalysisRequestedSkillsReviewInsertInput> | VideoAnalysisRequestedSkillsReviewInsertInput>;
  lessonCurrency: Scalars['String'];
}>;


export type InsertCoachRemoteAnalysisOrderMutation = { __typename?: 'mutation_root', insertVideoAnalysisOne?: { __typename?: 'VideoAnalysis', id: any } | null };

export type InsertCoachReviewsMutationVariables = Exact<{
  objects: Array<ReviewsInsertInput> | ReviewsInsertInput;
}>;


export type InsertCoachReviewsMutation = { __typename?: 'mutation_root', insertReviews?: { __typename?: 'ReviewsMutationResponse', affectedRows: number, returning: Array<{ __typename?: 'Reviews', id: any, externalFullName?: string | null, rating: number }> } | null };

export type InsertCoachTipsMutationVariables = Exact<{
  coachUserId: Scalars['uuid'];
  customerUserId: Scalars['uuid'];
  lessonId: Scalars['uuid'];
  paidUnitAmount: Scalars['Int'];
  stripeCustomerId: Scalars['String'];
  stripeMerchantId: Scalars['String'];
  priceUnitAmount: Scalars['Int'];
  amount: Scalars['Int'];
  amountCapturable: Scalars['Int'];
  amountReceived: Scalars['Int'];
  application?: InputMaybe<Scalars['String']>;
  applicationFeeAmount?: InputMaybe<Scalars['Int']>;
  cancellationReason?: InputMaybe<Scalars['String']>;
  currency: Scalars['String'];
  onBehalfOf?: InputMaybe<Scalars['String']>;
  paymentIntentId: Scalars['String'];
  paymentMethod?: InputMaybe<Scalars['String']>;
  statementDescriptor?: InputMaybe<Scalars['String']>;
  paymentIntentStatus: Scalars['String'];
  paymentIntentStripeCustomerId: Scalars['String'];
  transferDataDestination?: InputMaybe<Scalars['String']>;
  transferGroup?: InputMaybe<Scalars['String']>;
  chargeAmount: Scalars['Int'];
  amountCaptured: Scalars['Int'];
  amountRefunded: Scalars['Int'];
  chargeApplication?: InputMaybe<Scalars['String']>;
  chargeApplicationFee?: InputMaybe<Scalars['String']>;
  chargeApplicationFeeAmount?: InputMaybe<Scalars['Int']>;
  calculatedStatementDescriptor?: InputMaybe<Scalars['String']>;
  captured: Scalars['Boolean'];
  chargeId: Scalars['String'];
  chargeCurrency: Scalars['String'];
  disputed: Scalars['Boolean'];
  chargeExternalStripePaymentIntentId: Scalars['String'];
  chargePaid: Scalars['Boolean'];
  chargePaymentMethod?: InputMaybe<Scalars['String']>;
  refunded: Scalars['Boolean'];
  chargeStripeCustomerId: Scalars['String'];
  transferDataAmount?: InputMaybe<Scalars['Int']>;
  transferId?: InputMaybe<Scalars['String']>;
  sourceTransfer?: InputMaybe<Scalars['String']>;
  externalStripePaymentIntentId: Scalars['String'];
}>;


export type InsertCoachTipsMutation = { __typename?: 'mutation_root', insertCoachTipsOne?: { __typename?: 'CoachTips', id: any } | null };

export type InsertContentReportMutationVariables = Exact<{
  object: ContentReportsInsertInput;
}>;


export type InsertContentReportMutation = { __typename?: 'mutation_root', insertContentReportsOne?: { __typename?: 'ContentReports', id: any, createdAt: any, reason: ReportReasonsEnum, description?: string | null, status: ReportStatusesEnum, conversationId?: any | null, messageId?: any | null, reporter: { __typename?: 'Users', id: any, fullName: string, email: string }, reportedUser?: { __typename?: 'Users', id: any, fullName: string, email: string } | null } | null };

export type InsertConversationMutationVariables = Exact<{
  object: ConversationsInsertInput;
}>;


export type InsertConversationMutation = { __typename?: 'mutation_root', insertConversationsOne?: { __typename?: 'Conversations', id: any } | null };

export type InsertConversationParticipantMutationVariables = Exact<{
  object: ConversationParticipantsInsertInput;
}>;


export type InsertConversationParticipantMutation = { __typename?: 'mutation_root', insertConversationParticipantsOne?: { __typename?: 'ConversationParticipants', id: any } | null };

export type InsertEmailInvitationMutationVariables = Exact<{
  object: EventInvitationsInsertInput;
}>;


export type InsertEmailInvitationMutation = { __typename?: 'mutation_root', insertEventInvitationsOne?: { __typename?: 'EventInvitations', id: any } | null };

export type InsertEngagementAnalyticsMutationVariables = Exact<{
  objects: Array<EngagementAnalyticsInsertInput> | EngagementAnalyticsInsertInput;
}>;


export type InsertEngagementAnalyticsMutation = { __typename?: 'mutation_root', insertEngagementAnalytics?: { __typename?: 'EngagementAnalyticsMutationResponse', affectedRows: number } | null };

export type InsertEventCouponMutationVariables = Exact<{
  eventId: Scalars['uuid'];
  name: Scalars['String'];
  code: Scalars['String'];
  source: EventCouponSourceEnum;
  couponType: EventCouponTypeEnum;
  percentOff?: InputMaybe<Scalars['numeric']>;
  amountOff?: InputMaybe<Scalars['Int']>;
  fixedPrice?: InputMaybe<Scalars['Int']>;
  isAutoApply: Scalars['Boolean'];
  validFrom?: InputMaybe<Scalars['timestamptz']>;
  validUntil?: InputMaybe<Scalars['timestamptz']>;
  tierPriority: Scalars['Int'];
  maxRedemptions?: InputMaybe<Scalars['Int']>;
  isActive: Scalars['Boolean'];
  groups: Array<EventCouponGroupsInsertInput> | EventCouponGroupsInsertInput;
}>;


export type InsertEventCouponMutation = { __typename?: 'mutation_root', insertEventCouponsOne?: { __typename?: 'EventCoupons', id: any, name: string, code: string } | null };

export type InsertEventCouponRedemptionMutationVariables = Exact<{
  object: EventCouponRedemptionsInsertInput;
}>;


export type InsertEventCouponRedemptionMutation = { __typename?: 'mutation_root', insertEventCouponRedemptionsOne?: { __typename?: 'EventCouponRedemptions', id: any } | null };

export type InsertEventCourtsMutationVariables = Exact<{
  objects?: InputMaybe<Array<EventCourtsInsertInput> | EventCourtsInsertInput>;
}>;


export type InsertEventCourtsMutation = { __typename?: 'mutation_root', insertEventCourts?: { __typename?: 'EventCourtsMutationResponse', returning: Array<{ __typename?: 'EventCourts', id: any, courtNumber: number }> } | null };

export type InsertEventGroupMergeMutationVariables = Exact<{
  eventId: Scalars['uuid'];
  baseGroupId: Scalars['uuid'];
  unmergeForKnockout: Scalars['Boolean'];
}>;


export type InsertEventGroupMergeMutation = { __typename?: 'mutation_root', insertEventGroupMergesOne?: { __typename?: 'EventGroupMerges', id: any } | null };

export type InsertEventTeamsMutationVariables = Exact<{
  objects: Array<EventTeamsInsertInput> | EventTeamsInsertInput;
}>;


export type InsertEventTeamsMutation = { __typename?: 'mutation_root', insertEventTeams?: { __typename?: 'EventTeamsMutationResponse', returning: Array<{ __typename?: 'EventTeams', id: any, members: Array<{ __typename?: 'EventTeamMembers', id: any, userId: any }> }> } | null };

export type InsertInAppUserNotificationEntityWithReceiversMutationVariables = Exact<{
  actingUserId: Scalars['uuid'];
  lessonId?: InputMaybe<Scalars['uuid']>;
  videoAnalysisId?: InputMaybe<Scalars['uuid']>;
  playSessionId?: InputMaybe<Scalars['uuid']>;
  playSessionCommentId?: InputMaybe<Scalars['uuid']>;
  groupId?: InputMaybe<Scalars['uuid']>;
  groupThreadCommentId?: InputMaybe<Scalars['uuid']>;
  groupThreadId?: InputMaybe<Scalars['uuid']>;
  eventGroupId?: InputMaybe<Scalars['uuid']>;
  playRequestId?: InputMaybe<Scalars['uuid']>;
  connectionRequestId?: InputMaybe<Scalars['uuid']>;
  eventPlayerInviteId?: InputMaybe<Scalars['uuid']>;
  messageId?: InputMaybe<Scalars['uuid']>;
  partnerBookingOrderId?: InputMaybe<Scalars['uuid']>;
  actionType: NotificationActionTypesEnum;
  userNotificationsData: Array<UserNotificationsInsertInput> | UserNotificationsInsertInput;
}>;


export type InsertInAppUserNotificationEntityWithReceiversMutation = { __typename?: 'mutation_root', insertUserNotificationEntitiesOne?: { __typename?: 'UserNotificationEntities', id: any } | null };

export type InsertInitializeGamedayMutationVariables = Exact<{
  competitionFormat: CompetitionFormatsEnum;
  groupId: Scalars['uuid'];
  nextSequence?: InputMaybe<EventGroupSequencesObjRelInsertInput>;
  poolData?: InputMaybe<Array<EventGroupPoolsInsertInput> | EventGroupPoolsInsertInput>;
}>;


export type InsertInitializeGamedayMutation = { __typename?: 'mutation_root', insertEventGroupSequencesOne?: { __typename?: 'EventGroupSequences', id: any, competitionFormat: CompetitionFormatsEnum, pools: Array<{ __typename?: 'EventGroupPools', id: any, rounds: Array<{ __typename?: 'EventPoolRounds', id: any, matches: Array<{ __typename?: 'EventMatches', id: any, courtNumber?: number | null }> }> }> } | null };

export type InsertInitializeSingleEliminationMutationVariables = Exact<{
  seedingObjects?: InputMaybe<Array<EventGroupSequenceSeedingInsertInput> | EventGroupSequenceSeedingInsertInput>;
  roundRobinSequenceId: Scalars['uuid'];
  teamsData?: InputMaybe<Array<EventPoolsTeamsInsertInput> | EventPoolsTeamsInsertInput>;
  nextSequenceId: Scalars['uuid'];
  groupId: Scalars['uuid'];
  startsAt?: InputMaybe<Scalars['timestamptz']>;
  endsAt?: InputMaybe<Scalars['timestamptz']>;
}>;


export type InsertInitializeSingleEliminationMutation = { __typename?: 'mutation_root', insertEventGroupSequenceSeeding?: { __typename?: 'EventGroupSequenceSeedingMutationResponse', returning: Array<{ __typename?: 'EventGroupSequenceSeeding', id: any, seed: number }> } | null, updateEventGroupSequencesByPk?: { __typename?: 'EventGroupSequences', id: any } | null, insertEventGroupPoolsOne?: { __typename?: 'EventGroupPools', id: any, sequenceId: any, groupId: any } | null };

export type InsertLearningProgramScheduleVideoSubmissionMutationVariables = Exact<{
  learningProgramEnrollmentId: Scalars['uuid'];
  learningProgramScheduleId: Scalars['uuid'];
  videoAnalysisId: Scalars['uuid'];
}>;


export type InsertLearningProgramScheduleVideoSubmissionMutation = { __typename?: 'mutation_root', insertLearningProgramScheduleVideoSubmissionsOne?: { __typename?: 'LearningProgramScheduleVideoSubmissions', id: any, videoAnalysisId?: any | null } | null };

export type InsertLessonParticipantOffPlatformPaymentMutationVariables = Exact<{
  userId: Scalars['uuid'];
  lessonId: Scalars['uuid'];
}>;


export type InsertLessonParticipantOffPlatformPaymentMutation = { __typename?: 'mutation_root', insertLessonParticipantsOne?: { __typename?: 'LessonParticipants', id: any, status: LessonParticipantStatusesEnum, userId: any, lessonId: any, user: { __typename?: 'Users', id: any, fullName: string }, lesson: { __typename?: 'Lessons', id: any, status: LessonStatusesEnum, startDateTime?: any | null, title: string, type: LessonTypesEnum, locale: string, timezoneName: string, timezoneAbbreviation: string, timezoneOffsetMinutes: number, owner?: { __typename?: 'Users', id: any, email: string, preferredName: string, fullName: string } | null } } | null };

export type InsertLessonReflectionMutationVariables = Exact<{
  objects: Array<LessonReflectionsInsertInput> | LessonReflectionsInsertInput;
}>;


export type InsertLessonReflectionMutation = { __typename?: 'mutation_root', insertLessonReflections?: { __typename?: 'LessonReflectionsMutationResponse', returning: Array<{ __typename?: 'LessonReflections', id: any, lessonId: any, playerUserId: any }> } | null };

export type InsertMessageMutationVariables = Exact<{
  object: MessagesInsertInput;
}>;


export type InsertMessageMutation = { __typename?: 'mutation_root', insertMessagesOne?: { __typename?: 'Messages', id: any, createdAt: any } | null };

export type InsertPartnerBookingOrderMutationVariables = Exact<{
  object: PartnerBookingOrdersInsertInput;
}>;


export type InsertPartnerBookingOrderMutation = { __typename?: 'mutation_root', insertPartnerBookingOrdersOne?: { __typename?: 'PartnerBookingOrders', id: any, marker: string, status: PartnerBookingOrderStatusesEnum } | null };

export type InsertPartnerRequestInvitationMutationVariables = Exact<{
  object: EventInvitationsInsertInput;
}>;


export type InsertPartnerRequestInvitationMutation = { __typename?: 'mutation_root', insertEventInvitationsOne?: { __typename?: 'EventInvitations', id: any } | null };

export type InsertPlayRequestMutationVariables = Exact<{
  object: PlayRequestsInsertInput;
}>;


export type InsertPlayRequestMutation = { __typename?: 'mutation_root', insertPlayRequestsOne?: { __typename?: 'PlayRequests', id: any, status: PlayRequestStatusesEnum } | null };

export type InsertPremiumContentSubscriptionMutationVariables = Exact<{
  customerApplicationFeeUnitAmount: Scalars['Int'];
  externalStripePaymentIntentId: Scalars['String'];
  orderSubtotalUnitAmount: Scalars['Int'];
  coachId: Scalars['uuid'];
  playerId: Scalars['uuid'];
  orderTotalUnitAmount: Scalars['Int'];
  transferUnitAmount: Scalars['Int'];
  paidUnitAmount: Scalars['Int'];
  sellerApplicationFeeUnitAmount: Scalars['Int'];
  applicationFeeTotalUnitAmount: Scalars['Int'];
  stripeCustomerId: Scalars['String'];
  stripeMerchantId: Scalars['String'];
  stripePaymentStatus: Scalars['String'];
  userCreditCardId?: InputMaybe<Scalars['uuid']>;
  amount: Scalars['Int'];
  amountCapturable: Scalars['Int'];
  amountReceived: Scalars['Int'];
  application?: InputMaybe<Scalars['String']>;
  applicationFeeAmount?: InputMaybe<Scalars['Int']>;
  cancellationReason?: InputMaybe<Scalars['String']>;
  currency: Scalars['String'];
  onBehalfOf?: InputMaybe<Scalars['String']>;
  paymentIntentId: Scalars['String'];
  paymentMethod?: InputMaybe<Scalars['String']>;
  statementDescriptor?: InputMaybe<Scalars['String']>;
  paymentIntentStatus: Scalars['String'];
  paymentIntentStripeCustomerId: Scalars['String'];
  transferDataAmount?: InputMaybe<Scalars['Int']>;
  transferDataDestination?: InputMaybe<Scalars['String']>;
  transferGroup?: InputMaybe<Scalars['String']>;
  transferId?: InputMaybe<Scalars['String']>;
  sourceTransfer?: InputMaybe<Scalars['String']>;
  chargeAmount: Scalars['Int'];
  amountCaptured: Scalars['Int'];
  amountRefunded: Scalars['Int'];
  chargeApplication?: InputMaybe<Scalars['String']>;
  chargeApplicationFee?: InputMaybe<Scalars['String']>;
  chargeApplicationFeeAmount?: InputMaybe<Scalars['Int']>;
  calculatedStatementDescriptor?: InputMaybe<Scalars['String']>;
  captured: Scalars['Boolean'];
  chargeId: Scalars['String'];
  chargeCurrency: Scalars['String'];
  disputed: Scalars['Boolean'];
  chargeExternalStripePaymentIntentId: Scalars['String'];
  chargePaid: Scalars['Boolean'];
  chargePaymentMethod?: InputMaybe<Scalars['String']>;
  refunded: Scalars['Boolean'];
  chargeStripeCustomerId?: InputMaybe<Scalars['String']>;
}>;


export type InsertPremiumContentSubscriptionMutation = { __typename?: 'mutation_root', insertUserContentBetaSubscriptionsOne?: { __typename?: 'UserContentBetaSubscriptions', id: any } | null };

export type InsertSignupRequestMutationVariables = Exact<{
  accountType?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  cityId?: InputMaybe<Scalars['uuid']>;
  country?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  fullName?: InputMaybe<Scalars['String']>;
  ip?: InputMaybe<Scalars['String']>;
  latitude?: InputMaybe<Scalars['numeric']>;
  longitude?: InputMaybe<Scalars['numeric']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<Scalars['String']>;
  preferredName?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
  objects?: InputMaybe<Array<WelcomeEmailConfigurationInsertInput> | WelcomeEmailConfigurationInsertInput>;
}>;


export type InsertSignupRequestMutation = { __typename?: 'mutation_root', insertSignupRequestsOne?: { __typename?: 'SignupRequests', id: any } | null, insertWelcomeEmailConfiguration?: { __typename?: 'WelcomeEmailConfigurationMutationResponse', affectedRows: number } | null };

export type InsertSingleEliminationMatchesMutationVariables = Exact<{
  objects?: InputMaybe<Array<EventPoolRoundsInsertInput> | EventPoolRoundsInsertInput>;
}>;


export type InsertSingleEliminationMatchesMutation = { __typename?: 'mutation_root', insertEventPoolRounds?: { __typename?: 'EventPoolRoundsMutationResponse', returning: Array<{ __typename?: 'EventPoolRounds', id: any }> } | null };

export type InsertTeamMemberMutationVariables = Exact<{
  object: EventTeamMembersInsertInput;
}>;


export type InsertTeamMemberMutation = { __typename?: 'mutation_root', insertEventTeamMembersOne?: { __typename?: 'EventTeamMembers', id: any } | null };

export type InsertTournamentRegistrationMutationVariables = Exact<{
  registrationObjects?: InputMaybe<Array<EventRegistrationsInsertInput> | EventRegistrationsInsertInput>;
  groupRegistrationObjects?: InputMaybe<Array<EventGroupRegistrationsInsertInput> | EventGroupRegistrationsInsertInput>;
}>;


export type InsertTournamentRegistrationMutation = { __typename?: 'mutation_root', insertEventRegistrations?: { __typename?: 'EventRegistrationsMutationResponse', returning: Array<{ __typename?: 'EventRegistrations', id: any }> } | null, insertEventGroupRegistrations?: { __typename?: 'EventGroupRegistrationsMutationResponse', returning: Array<{ __typename?: 'EventGroupRegistrations', id: any }> } | null };

export type InsertTournamentTransactionMutationVariables = Exact<{
  object?: InputMaybe<EventTransactionsInsertInput>;
}>;


export type InsertTournamentTransactionMutation = { __typename?: 'mutation_root', insertEventTransactionsOne?: { __typename?: 'EventTransactions', id: any } | null };

export type InsertUnpaidStripeSaleMutationVariables = Exact<{
  amountPaid?: InputMaybe<Scalars['numeric']>;
  currency?: InputMaybe<Scalars['String']>;
  originalPrice?: InputMaybe<Scalars['numeric']>;
  platformSubscriptionPlanPriceId?: InputMaybe<Scalars['uuid']>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  stripePaymentStatus?: InputMaybe<Scalars['String']>;
  stripePriceId?: InputMaybe<Scalars['String']>;
  stripeProductId?: InputMaybe<Scalars['String']>;
  stripeSessionId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['uuid']>;
}>;


export type InsertUnpaidStripeSaleMutation = { __typename?: 'mutation_root', insertSalesOne?: { __typename?: 'Sales', id: any } | null };

export type InsertUploadReviewRequestsMutationVariables = Exact<{
  objects: Array<UploadReviewRequestsInsertInput> | UploadReviewRequestsInsertInput;
}>;


export type InsertUploadReviewRequestsMutation = { __typename?: 'mutation_root', insertUploadReviewRequests?: { __typename?: 'UploadReviewRequestsMutationResponse', returning: Array<{ __typename?: 'UploadReviewRequests', id: any, userId: any, url: string, createdAt: any }> } | null };

export type InsertUserCommunicationPreferencesForRepairMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type InsertUserCommunicationPreferencesForRepairMutation = { __typename?: 'mutation_root', insertUserCommunicationPreferencesOne?: { __typename?: 'UserCommunicationPreferences', id: any } | null };

export type InsertUserForRepairMutationVariables = Exact<{
  id: Scalars['uuid'];
  email: Scalars['String'];
  firebaseId: Scalars['String'];
  stripeCustomerId: Scalars['String'];
  fullName: Scalars['String'];
  preferredName: Scalars['String'];
  username?: InputMaybe<Scalars['String']>;
  coachStatus: CoachStatusEnum;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  ip?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
  latitude?: InputMaybe<Scalars['numeric']>;
  longitude?: InputMaybe<Scalars['numeric']>;
  activeCityId?: InputMaybe<Scalars['uuid']>;
  geometry?: InputMaybe<Scalars['geography']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  eventOrganizerAccountType?: InputMaybe<EventOrganizerAccountTypesEnum>;
  claimData?: InputMaybe<Array<UsernamesClaimedInsertInput> | UsernamesClaimedInsertInput>;
  logData?: InputMaybe<Array<UsernameLogsInsertInput> | UsernameLogsInsertInput>;
}>;


export type InsertUserForRepairMutation = { __typename?: 'mutation_root', insertUsersOne?: { __typename?: 'Users', id: any, firebaseId: string, email: string, stripeCustomerId: string, fullName: string, username?: string | null } | null };

export type InsertUserIdentityVerificationMutationVariables = Exact<{
  userId: Scalars['uuid'];
  provider: IdentityVerificationProvidersEnum;
  verifiedAt: Scalars['timestamptz'];
}>;


export type InsertUserIdentityVerificationMutation = { __typename?: 'mutation_root', insertUserIdentityVerificationsOne?: { __typename?: 'UserIdentityVerifications', id: any } | null };

export type InsertVideoAnalysisFileMutationVariables = Exact<{
  videoImageFile: VideoAnalysisFilesInsertInput;
}>;


export type InsertVideoAnalysisFileMutation = { __typename?: 'mutation_root', insertVideoAnalysisFilesOne?: { __typename?: 'VideoAnalysisFiles', id: any } | null };

export type InsertVideoAnalysisForLearningProgramMutationVariables = Exact<{
  reviewerUserId: Scalars['uuid'];
  submissionUserId: Scalars['uuid'];
  submissionRequestedFeedback: Scalars['String'];
  videoAnalysisFileId: Scalars['uuid'];
  priceUnitAmount: Scalars['Int'];
  skills?: InputMaybe<Array<VideoAnalysisRequestedSkillsReviewInsertInput> | VideoAnalysisRequestedSkillsReviewInsertInput>;
}>;


export type InsertVideoAnalysisForLearningProgramMutation = { __typename?: 'mutation_root', insertVideoAnalysisOne?: { __typename?: 'VideoAnalysis', id: any } | null };

export type LinkPendingEmailInvitesToUserMutationVariables = Exact<{
  userId: Scalars['uuid'];
  email: Scalars['String'];
}>;


export type LinkPendingEmailInvitesToUserMutation = { __typename?: 'mutation_root', updateEventInvitations?: { __typename?: 'EventInvitationsMutationResponse', affectedRows: number } | null };

export type InsertPlayedWithDismissalMutationVariables = Exact<{
  userId: Scalars['uuid'];
  dismissedUserId: Scalars['uuid'];
  constraint: UserPlayedWithDismissalsConstraint;
  updateColumns: Array<UserPlayedWithDismissalsUpdateColumn> | UserPlayedWithDismissalsUpdateColumn;
}>;


export type InsertPlayedWithDismissalMutation = { __typename?: 'mutation_root', insertUserPlayedWithDismissalsOne?: { __typename?: 'UserPlayedWithDismissals', id: any } | null };

export type RemovePlayedWithDismissalMutationVariables = Exact<{
  userId: Scalars['uuid'];
  dismissedUserId: Scalars['uuid'];
}>;


export type RemovePlayedWithDismissalMutation = { __typename?: 'mutation_root', deleteUserPlayedWithDismissals?: { __typename?: 'UserPlayedWithDismissalsMutationResponse', affectedRows: number } | null };

export type RecordVenueBookingSystemChangeMutationVariables = Exact<{
  integrationId: Scalars['uuid'];
  nextVersion: Scalars['Int'];
  changedBy: Scalars['uuid'];
  snapshot: Scalars['jsonb'];
}>;


export type RecordVenueBookingSystemChangeMutation = { __typename?: 'mutation_root', insertVenueBookingConfigVersionsOne?: { __typename?: 'VenueBookingConfigVersions', id: any, version: number } | null, updateVenueBookingIntegrationsByPk?: { __typename?: 'VenueBookingIntegrations', id: any } | null };

export type RemoveUserFromTeamMutationVariables = Exact<{
  teamId: Scalars['uuid'];
  userId: Scalars['uuid'];
}>;


export type RemoveUserFromTeamMutation = { __typename?: 'mutation_root', deleteEventTeamMembers?: { __typename?: 'EventTeamMembersMutationResponse', affectedRows: number } | null };

export type ResetForfeitRetireMatchesForTeamMutationVariables = Exact<{
  teamId: Scalars['uuid'];
}>;


export type ResetForfeitRetireMatchesForTeamMutation = { __typename?: 'mutation_root', updateEventMatches?: { __typename?: 'EventMatchesMutationResponse', affectedRows: number } | null };

export type ResetGamedayForEventMutationVariables = Exact<{
  eventId: Scalars['uuid'];
}>;


export type ResetGamedayForEventMutation = { __typename?: 'mutation_root', updateEventMatches?: { __typename?: 'EventMatchesMutationResponse', affectedRows: number } | null, deleteEventGameScores?: { __typename?: 'EventGameScoresMutationResponse', affectedRows: number } | null, deleteEventMatchGames?: { __typename?: 'EventMatchGamesMutationResponse', affectedRows: number } | null, updateEventCourts?: { __typename?: 'EventCourtsMutationResponse', affectedRows: number } | null, deleteEventMatchesTeams?: { __typename?: 'EventMatchesTeamsMutationResponse', affectedRows: number } | null, deleteEventPoolsTeams?: { __typename?: 'EventPoolsTeamsMutationResponse', affectedRows: number } | null, deleteEventMatches?: { __typename?: 'EventMatchesMutationResponse', affectedRows: number } | null, deleteEventPoolRounds?: { __typename?: 'EventPoolRoundsMutationResponse', affectedRows: number } | null, deleteEventGroupPools?: { __typename?: 'EventGroupPoolsMutationResponse', affectedRows: number } | null, deleteEventGroupSequences?: { __typename?: 'EventGroupSequencesMutationResponse', affectedRows: number } | null };

export type ResolveMatchAsLossMutationVariables = Exact<{
  matchId: Scalars['uuid'];
  winningTeamId: Scalars['uuid'];
  losingTeamId: Scalars['uuid'];
  winReason: WinReasonsEnum;
}>;


export type ResolveMatchAsLossMutation = { __typename?: 'mutation_root', updateEventMatchesByPk?: { __typename?: 'EventMatches', id: any, winningTeamId?: any | null, losingTeamId?: any | null, winReason?: WinReasonsEnum | null } | null };

export type RestartEventGroupMutationVariables = Exact<{
  eventId: Scalars['uuid'];
  groupId: Scalars['uuid'];
}>;


export type RestartEventGroupMutation = { __typename?: 'mutation_root', nullMatchFKs?: { __typename?: 'EventMatchesMutationResponse', affectedRows: number } | null, gameScores?: { __typename?: 'EventGameScoresMutationResponse', affectedRows: number } | null, matchGames?: { __typename?: 'EventMatchGamesMutationResponse', affectedRows: number } | null, nullCourts?: { __typename?: 'EventCourtsMutationResponse', affectedRows: number } | null, matchTeams?: { __typename?: 'EventMatchesTeamsMutationResponse', affectedRows: number } | null, poolTeams?: { __typename?: 'EventPoolsTeamsMutationResponse', affectedRows: number } | null, matches?: { __typename?: 'EventMatchesMutationResponse', affectedRows: number } | null, rounds?: { __typename?: 'EventPoolRoundsMutationResponse', affectedRows: number } | null, pools?: { __typename?: 'EventGroupPoolsMutationResponse', affectedRows: number } | null, sequences?: { __typename?: 'EventGroupSequencesMutationResponse', affectedRows: number } | null };

export type SaveVenueBookingCourtRatesMutationVariables = Exact<{
  integrationId: Scalars['uuid'];
  currency: Scalars['String'];
  hourlyUnitAmount: Scalars['Int'];
  peakHourlyUnitAmount?: InputMaybe<Scalars['Int']>;
  updatedBy: Scalars['uuid'];
  promoCode?: InputMaybe<Scalars['String']>;
  maxAdvanceBookingDays?: InputMaybe<Scalars['Int']>;
  windows: Array<VenueBookingWindowsInsertInput> | VenueBookingWindowsInsertInput;
  confirmationNote?: InputMaybe<Scalars['String']>;
}>;


export type SaveVenueBookingCourtRatesMutation = { __typename?: 'mutation_root', deleteVenueBookingWindows?: { __typename?: 'VenueBookingWindowsMutationResponse', affectedRows: number } | null, insertVenueBookingWindows?: { __typename?: 'VenueBookingWindowsMutationResponse', affectedRows: number } | null, deleteVenueBookingCourtRates?: { __typename?: 'VenueBookingCourtRatesMutationResponse', affectedRows: number } | null, insertVenueBookingCourtRatesOne?: { __typename?: 'VenueBookingCourtRates', id: any } | null, updateVenueBookingIntegrationsByPk?: { __typename?: 'VenueBookingIntegrations', id: any } | null };

export type SaveVenueBookingProgramsMutationVariables = Exact<{
  integrationId: Scalars['uuid'];
  isPreferredPartner: Scalars['Boolean'];
  partnerPricingEnabled: Scalars['Boolean'];
  referralFeeEnabled: Scalars['Boolean'];
  nextVersion: Scalars['Int'];
  changedBy: Scalars['uuid'];
  termsVersion: Scalars['String'];
  snapshot: Scalars['jsonb'];
}>;


export type SaveVenueBookingProgramsMutation = { __typename?: 'mutation_root', updateVenueBookingIntegrationsByPk?: { __typename?: 'VenueBookingIntegrations', id: any, currentVersion: number } | null, insertVenueBookingConfigVersionsOne?: { __typename?: 'VenueBookingConfigVersions', id: any, version: number } | null };

export type SaveVenueBookingRulesMutationVariables = Exact<{
  integrationId: Scalars['uuid'];
  inventoryType: BookingInventoryTypesEnum;
  scheduleMode: BookingScheduleModesEnum;
  isCustomPricing: Scalars['Boolean'];
  tiers: Array<VenueBookingRuleTiersInsertInput> | VenueBookingRuleTiersInsertInput;
  windows: Array<VenueBookingWindowsInsertInput> | VenueBookingWindowsInsertInput;
  nextVersion: Scalars['Int'];
  changeType: BookingConfigChangeTypesEnum;
  changedBy: Scalars['uuid'];
  snapshot: Scalars['jsonb'];
}>;


export type SaveVenueBookingRulesMutation = { __typename?: 'mutation_root', deleteVenueBookingRuleTiers?: { __typename?: 'VenueBookingRuleTiersMutationResponse', affectedRows: number } | null, deleteVenueBookingWindows?: { __typename?: 'VenueBookingWindowsMutationResponse', affectedRows: number } | null, insertVenueBookingRulesOne?: { __typename?: 'VenueBookingRules', id: any } | null, insertVenueBookingWindows?: { __typename?: 'VenueBookingWindowsMutationResponse', affectedRows: number } | null, insertVenueBookingConfigVersionsOne?: { __typename?: 'VenueBookingConfigVersions', id: any, version: number } | null, updateVenueBookingIntegrationsByPk?: { __typename?: 'VenueBookingIntegrations', id: any, currentVersion: number } | null };

export type SetRegistrationCheckedInMutationVariables = Exact<{
  id: Scalars['uuid'];
  checkedInAt?: InputMaybe<Scalars['timestamptz']>;
}>;


export type SetRegistrationCheckedInMutation = { __typename?: 'mutation_root', updateEventGroupRegistrationsByPk?: { __typename?: 'EventGroupRegistrations', id: any, checkedInAt?: any | null } | null };

export type SetVenueBookingReadVerifiedMutationVariables = Exact<{
  integrationId: Scalars['uuid'];
  readVerifiedAt?: InputMaybe<Scalars['timestamptz']>;
}>;


export type SetVenueBookingReadVerifiedMutation = { __typename?: 'mutation_root', updateVenueBookingIntegrationsByPk?: { __typename?: 'VenueBookingIntegrations', id: any } | null };

export type SoftDeleteConversationParticipantsMutationVariables = Exact<{
  where: ConversationParticipantsBoolExp;
}>;


export type SoftDeleteConversationParticipantsMutation = { __typename?: 'mutation_root', updateConversationParticipants?: { __typename?: 'ConversationParticipantsMutationResponse', affectedRows: number } | null };

export type SoftDeleteConversationsMutationVariables = Exact<{
  where: ConversationsBoolExp;
}>;


export type SoftDeleteConversationsMutation = { __typename?: 'mutation_root', updateConversations?: { __typename?: 'ConversationsMutationResponse', affectedRows: number } | null };

export type SoftDeleteEventGroupByIdMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type SoftDeleteEventGroupByIdMutation = { __typename?: 'mutation_root', updateEventGroupsByPk?: { __typename?: 'EventGroups', id: any } | null };

export type SoftDeleteEventGroupMergeMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type SoftDeleteEventGroupMergeMutation = { __typename?: 'mutation_root', updateEventGroupMergesByPk?: { __typename?: 'EventGroupMerges', id: any } | null };

export type SoftDeleteEventRegistrationMutationVariables = Exact<{
  eventId: Scalars['uuid'];
  userId: Scalars['uuid'];
}>;


export type SoftDeleteEventRegistrationMutation = { __typename?: 'mutation_root', updateEventRegistrations?: { __typename?: 'EventRegistrationsMutationResponse', affectedRows: number } | null };

export type SoftDeleteInvitationMutationVariables = Exact<{
  id: Scalars['uuid'];
  deletedAt: Scalars['timestamptz'];
}>;


export type SoftDeleteInvitationMutation = { __typename?: 'mutation_root', updateEventInvitationsByPk?: { __typename?: 'EventInvitations', id: any } | null };

export type SoftDeletePendingInvitationsByInviteesMutationVariables = Exact<{
  groupId: Scalars['uuid'];
  userIds: Array<Scalars['uuid']> | Scalars['uuid'];
  emails: Array<Scalars['String']> | Scalars['String'];
  deletedAt: Scalars['timestamptz'];
}>;


export type SoftDeletePendingInvitationsByInviteesMutation = { __typename?: 'mutation_root', updateEventInvitations?: { __typename?: 'EventInvitationsMutationResponse', affectedRows: number } | null };

export type SoftDeletePendingInvitationsByRegistrationsMutationVariables = Exact<{
  registrationIds: Array<Scalars['uuid']> | Scalars['uuid'];
  deletedAt: Scalars['timestamptz'];
}>;


export type SoftDeletePendingInvitationsByRegistrationsMutation = { __typename?: 'mutation_root', updateEventInvitations?: { __typename?: 'EventInvitationsMutationResponse', affectedRows: number } | null };

export type SoftDeleteUserMutationVariables = Exact<{
  userId: Scalars['uuid'];
}>;


export type SoftDeleteUserMutation = { __typename?: 'mutation_root', updateUsersByPk?: { __typename?: 'Users', id: any, deletedAt?: any | null } | null };

export type UpdateAcceptInvitationByIdMutationVariables = Exact<{
  id: Scalars['uuid'];
  invitedUserId: Scalars['uuid'];
}>;


export type UpdateAcceptInvitationByIdMutation = { __typename?: 'mutation_root', updateEventInvitationsByPk?: { __typename?: 'EventInvitations', id: any } | null };

export type SettleBoostOrderMutationVariables = Exact<{
  id: Scalars['uuid'];
  paidUnitAmount: Scalars['Int'];
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  stripePaymentStatus?: InputMaybe<Scalars['String']>;
  externalStripePaymentIntentId?: InputMaybe<Scalars['String']>;
}>;


export type SettleBoostOrderMutation = { __typename?: 'mutation_root', updateBoostOrders?: { __typename?: 'BoostOrdersMutationResponse', affectedRows: number } | null, updateBoosts?: { __typename?: 'BoostsMutationResponse', affectedRows: number } | null };

export type FailBoostOrderMutationVariables = Exact<{
  id: Scalars['uuid'];
  stripePaymentStatus?: InputMaybe<Scalars['String']>;
}>;


export type FailBoostOrderMutation = { __typename?: 'mutation_root', updateBoostOrders?: { __typename?: 'BoostOrdersMutationResponse', affectedRows: number } | null, updateBoosts?: { __typename?: 'BoostsMutationResponse', affectedRows: number } | null };

export type UpsertCalendarAccountMutationVariables = Exact<{
  userId: Scalars['uuid'];
  provider: CalendarAuthProviderEnum;
  email: Scalars['String'];
  accessToken: Scalars['String'];
  refreshToken?: InputMaybe<Scalars['String']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']>;
}>;


export type UpsertCalendarAccountMutation = { __typename?: 'mutation_root', insertCalendarAccounts?: { __typename?: 'CalendarAccountsMutationResponse', returning: Array<{ __typename?: 'CalendarAccounts', id: any, email?: string | null }> } | null };

export type UpdateCalendarAccountStatusMutationVariables = Exact<{
  id: Scalars['uuid'];
  connected: Scalars['Boolean'];
}>;


export type UpdateCalendarAccountStatusMutation = { __typename?: 'mutation_root', updateCalendarAccounts?: { __typename?: 'CalendarAccountsMutationResponse', returning: Array<{ __typename?: 'CalendarAccounts', id: any, connected: boolean }> } | null };

export type UpsertCalendarPreferencesMutationVariables = Exact<{
  objects: Array<CalendarPreferencesInsertInput> | CalendarPreferencesInsertInput;
}>;


export type UpsertCalendarPreferencesMutation = { __typename?: 'mutation_root', insertCalendarPreferences?: { __typename?: 'CalendarPreferencesMutationResponse', returning: Array<{ __typename?: 'CalendarPreferences', id: any, calendarId: string, calendarName: string, isEnabled: boolean }> } | null };

export type UpdateCalendarTokensMutationVariables = Exact<{
  oldAccessToken: Scalars['String'];
  accessToken: Scalars['String'];
  expiresAt?: InputMaybe<Scalars['timestamptz']>;
}>;


export type UpdateCalendarTokensMutation = { __typename?: 'mutation_root', updateCalendarAccounts?: { __typename?: 'CalendarAccountsMutationResponse', returning: Array<{ __typename?: 'CalendarAccounts', id: any }> } | null };

export type UpdateCalendarTokensWithRefreshMutationVariables = Exact<{
  oldAccessToken: Scalars['String'];
  accessToken: Scalars['String'];
  refreshToken: Scalars['String'];
  expiresAt?: InputMaybe<Scalars['timestamptz']>;
}>;


export type UpdateCalendarTokensWithRefreshMutation = { __typename?: 'mutation_root', updateCalendarAccounts?: { __typename?: 'CalendarAccountsMutationResponse', returning: Array<{ __typename?: 'CalendarAccounts', id: any }> } | null };

export type UpdateCoachBookingRequestContactedAtMutationVariables = Exact<{
  id: Scalars['uuid'];
  contactedAt: Scalars['timestamptz'];
}>;


export type UpdateCoachBookingRequestContactedAtMutation = { __typename?: 'mutation_root', updateCoachBookingRequestsByPk?: { __typename?: 'CoachBookingRequests', id: any, contactedAt?: any | null } | null };

export type UpdateCoachLessonReflectionsMutationVariables = Exact<{
  reflectionIds: Array<Scalars['uuid']> | Scalars['uuid'];
  comments: Array<LessonReflectionCommentsInsertInput> | LessonReflectionCommentsInsertInput;
  files: Array<LessonReflectionFilesInsertInput> | LessonReflectionFilesInsertInput;
  details?: InputMaybe<Scalars['String']>;
  completedCategory?: InputMaybe<LessonSkillCategoriesEnum>;
  completedSport?: InputMaybe<SportsEnum>;
  upcomingCategory?: InputMaybe<LessonSkillCategoriesEnum>;
  upcomingSport?: InputMaybe<SportsEnum>;
  assignmentCategory?: InputMaybe<LessonSkillCategoriesEnum>;
  assignmentSport?: InputMaybe<SportsEnum>;
}>;


export type UpdateCoachLessonReflectionsMutation = { __typename?: 'mutation_root', deleteLessonReflectionComments?: { __typename?: 'LessonReflectionCommentsMutationResponse', returning: Array<{ __typename?: 'LessonReflectionComments', id: any, lessonReflectionId: any }> } | null, deleteLessonReflectionFiles?: { __typename?: 'LessonReflectionFilesMutationResponse', returning: Array<{ __typename?: 'LessonReflectionFiles', id: any, lessonReflectionId?: any | null }> } | null, updateLessonReflections?: { __typename?: 'LessonReflectionsMutationResponse', returning: Array<{ __typename?: 'LessonReflections', id: any }> } | null, insertLessonReflectionFiles?: { __typename?: 'LessonReflectionFilesMutationResponse', affectedRows: number } | null, insertLessonReflectionComments?: { __typename?: 'LessonReflectionCommentsMutationResponse', affectedRows: number } | null };

export type UpdateCoachRemoveParticipantMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type UpdateCoachRemoveParticipantMutation = { __typename?: 'mutation_root', updateLessonParticipantsByPk?: { __typename?: 'LessonParticipants', id: any } | null };

export type UpdateCoachRemoveParticipantAndRefundMutationVariables = Exact<{
  id: Scalars['uuid'];
  orderItemUpdates: Array<LessonOrderItemsUpdates> | LessonOrderItemsUpdates;
  orderUpdates: Array<LessonOrdersUpdates> | LessonOrdersUpdates;
}>;


export type UpdateCoachRemoveParticipantAndRefundMutation = { __typename?: 'mutation_root', updateLessonParticipantsByPk?: { __typename?: 'LessonParticipants', id: any } | null, updateLessonOrderItemsMany?: Array<{ __typename?: 'LessonOrderItemsMutationResponse', returning: Array<{ __typename?: 'LessonOrderItems', id: any }> } | null> | null, updateLessonOrdersMany?: Array<{ __typename?: 'LessonOrdersMutationResponse', returning: Array<{ __typename?: 'LessonOrders', id: any }> } | null> | null };

export type UpdateCompletedSaleMutationVariables = Exact<{
  id: Scalars['uuid'];
  amountPaid?: InputMaybe<Scalars['numeric']>;
  currency?: InputMaybe<Scalars['String']>;
  stripePriceId?: InputMaybe<Scalars['String']>;
  stripeProductId?: InputMaybe<Scalars['String']>;
  stripePaymentStatus?: InputMaybe<Scalars['String']>;
  status: PaymentStatusesEnum;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  platformSubscriptionPlanPriceId: Scalars['uuid'];
  platformSubscriptionId: Scalars['uuid'];
}>;


export type UpdateCompletedSaleMutation = { __typename?: 'mutation_root', updateSalesByPk?: { __typename?: 'Sales', id: any } | null };

export type UpdateCourtsForSingleEliminationMutationVariables = Exact<{
  updates?: InputMaybe<Array<EventCourtsUpdates> | EventCourtsUpdates>;
}>;


export type UpdateCourtsForSingleEliminationMutation = { __typename?: 'mutation_root', updateEventCourtsMany?: Array<{ __typename?: 'EventCourtsMutationResponse', returning: Array<{ __typename?: 'EventCourts', id: any, courtNumber: number, activeEventGroupId?: any | null, activeEventGroupPoolId?: any | null, activeMatchId?: any | null }> } | null> | null };

export type UpdateDefaultCalendarPreferenceMutationVariables = Exact<{
  userId: Scalars['uuid'];
  preferenceId: Scalars['uuid'];
}>;


export type UpdateDefaultCalendarPreferenceMutation = { __typename?: 'mutation_root', updateCalendarPreferences?: { __typename?: 'CalendarPreferencesMutationResponse', affectedRows: number } | null, updateCalendarPreferencesByPk?: { __typename?: 'CalendarPreferences', id: any, isDefault?: boolean | null } | null };

export type UpdateEventAsCanceledMutationVariables = Exact<{
  id: Scalars['uuid'];
  canceledAt: Scalars['timestamptz'];
}>;


export type UpdateEventAsCanceledMutation = { __typename?: 'mutation_root', updateEventsByPk?: { __typename?: 'Events', id: any, canceledAt?: any | null, status: EventStatusesEnum } | null };

export type UpdateEventAsPublishedMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type UpdateEventAsPublishedMutation = { __typename?: 'mutation_root', updateEventsByPk?: { __typename?: 'Events', id: any, status: EventStatusesEnum } | null };

export type UpdateEventCouponMutationVariables = Exact<{
  id: Scalars['uuid'];
  name: Scalars['String'];
  code: Scalars['String'];
  source: EventCouponSourceEnum;
  couponType: EventCouponTypeEnum;
  percentOff?: InputMaybe<Scalars['numeric']>;
  amountOff?: InputMaybe<Scalars['Int']>;
  fixedPrice?: InputMaybe<Scalars['Int']>;
  isAutoApply: Scalars['Boolean'];
  validFrom?: InputMaybe<Scalars['timestamptz']>;
  validUntil?: InputMaybe<Scalars['timestamptz']>;
  tierPriority: Scalars['Int'];
  maxRedemptions?: InputMaybe<Scalars['Int']>;
  isActive: Scalars['Boolean'];
  groups: Array<EventCouponGroupsInsertInput> | EventCouponGroupsInsertInput;
}>;


export type UpdateEventCouponMutation = { __typename?: 'mutation_root', updateEventCouponsByPk?: { __typename?: 'EventCoupons', id: any } | null, deleteEventCouponGroups?: { __typename?: 'EventCouponGroupsMutationResponse', affectedRows: number } | null, insertEventCouponGroups?: { __typename?: 'EventCouponGroupsMutationResponse', affectedRows: number } | null };

export type UpdateEventGroupRegistrationsMutationVariables = Exact<{
  updates: Array<EventGroupRegistrationsUpdates> | EventGroupRegistrationsUpdates;
}>;


export type UpdateEventGroupRegistrationsMutation = { __typename?: 'mutation_root', updateEventGroupRegistrationsMany?: Array<{ __typename?: 'EventGroupRegistrationsMutationResponse', affectedRows: number, returning: Array<{ __typename?: 'EventGroupRegistrations', id: any, userId: any, teamId?: any | null, status: EventGroupRegistrationStatusesEnum }> } | null> | null };

export type UpdateEventGroupsMergeIdMutationVariables = Exact<{
  groupIds: Array<Scalars['uuid']> | Scalars['uuid'];
  mergeId?: InputMaybe<Scalars['uuid']>;
}>;


export type UpdateEventGroupsMergeIdMutation = { __typename?: 'mutation_root', updateEventGroups?: { __typename?: 'EventGroupsMutationResponse', returning: Array<{ __typename?: 'EventGroups', id: any, mergeId?: any | null }> } | null };

export type UpdateEventNumberOfCourtsMutationVariables = Exact<{
  id: Scalars['uuid'];
  numberOfCourts: Scalars['numeric'];
}>;


export type UpdateEventNumberOfCourtsMutation = { __typename?: 'mutation_root', updateEventsByPk?: { __typename?: 'Events', id: any, numberOfCourts?: any | null } | null };

export type UpdateEventTeamsByPkMutationVariables = Exact<{
  id: Scalars['uuid'];
  groupId: Scalars['uuid'];
}>;


export type UpdateEventTeamsByPkMutation = { __typename?: 'mutation_root', updateEventTeamsByPk?: { __typename?: 'EventTeams', id: any } | null };

export type UpdateEventTeamStatusMutationVariables = Exact<{
  teamId: Scalars['uuid'];
  status: EventTeamStatusesEnum;
}>;


export type UpdateEventTeamStatusMutation = { __typename?: 'mutation_root', updateEventTeamsByPk?: { __typename?: 'EventTeams', id: any, status: EventTeamStatusesEnum } | null };

export type UpdateEventTransactionItemsMutationVariables = Exact<{
  updates: Array<EventTransactionItemsUpdates> | EventTransactionItemsUpdates;
}>;


export type UpdateEventTransactionItemsMutation = { __typename?: 'mutation_root', updateEventTransactionItemsMany?: Array<{ __typename?: 'EventTransactionItemsMutationResponse', affectedRows: number } | null> | null };

export type UpdateGroupRegistrationTeamMutationVariables = Exact<{
  groupRegistrationId: Scalars['uuid'];
  teamId: Scalars['uuid'];
}>;


export type UpdateGroupRegistrationTeamMutation = { __typename?: 'mutation_root', updateEventGroupRegistrationsByPk?: { __typename?: 'EventGroupRegistrations', id: any } | null };

export type UpdateInvitedUserMutationVariables = Exact<{
  id: Scalars['uuid'];
  invitedByUserId: Scalars['uuid'];
}>;


export type UpdateInvitedUserMutation = { __typename?: 'mutation_root', updateUsersByPk?: { __typename?: 'Users', id: any, email: string } | null };

export type UpdateInvitedUserAcceptMutationVariables = Exact<{
  id: Scalars['uuid'];
  fullName?: InputMaybe<Scalars['String']>;
  preferredName?: InputMaybe<Scalars['String']>;
}>;


export type UpdateInvitedUserAcceptMutation = { __typename?: 'mutation_root', updateUsersByPk?: { __typename?: 'Users', id: any } | null };

export type UpdateLessonAsCanceledAndRefundedMutationVariables = Exact<{
  lessonId: Scalars['uuid'];
  participantUpdates: Array<LessonParticipantsUpdates> | LessonParticipantsUpdates;
  orderItemUpdates: Array<LessonOrderItemsUpdates> | LessonOrderItemsUpdates;
  orderUpdates: Array<LessonOrdersUpdates> | LessonOrdersUpdates;
}>;


export type UpdateLessonAsCanceledAndRefundedMutation = { __typename?: 'mutation_root', updateLessonsByPk?: { __typename?: 'Lessons', id: any } | null, updateLessonParticipantsMany?: Array<{ __typename?: 'LessonParticipantsMutationResponse', returning: Array<{ __typename?: 'LessonParticipants', id: any }> } | null> | null, updateLessonOrderItemsMany?: Array<{ __typename?: 'LessonOrderItemsMutationResponse', returning: Array<{ __typename?: 'LessonOrderItems', id: any }> } | null> | null, updateLessonOrdersMany?: Array<{ __typename?: 'LessonOrdersMutationResponse', returning: Array<{ __typename?: 'LessonOrders', id: any }> } | null> | null };

export type UpdateLessonAsDeletedMutationVariables = Exact<{
  lessonId: Scalars['uuid'];
}>;


export type UpdateLessonAsDeletedMutation = { __typename?: 'mutation_root', updateLessonsByPk?: { __typename?: 'Lessons', id: any, deletedAt?: any | null } | null };

export type UpdateLessonCompletionHasuraEventIdMutationVariables = Exact<{
  id: Scalars['uuid'];
  completionHasuraEventId: Scalars['uuid'];
}>;


export type UpdateLessonCompletionHasuraEventIdMutation = { __typename?: 'mutation_root', updateLessonsByPk?: { __typename?: 'Lessons', id: any, completionHasuraEventId?: any | null } | null };

export type UpdateLessonReflectionFileTranscriptionMutationVariables = Exact<{
  id: Scalars['uuid'];
  transcriptionStartedAt?: InputMaybe<Scalars['timestamptz']>;
  transcript?: InputMaybe<Scalars['String']>;
  transcriptionCompletedAt?: InputMaybe<Scalars['timestamptz']>;
}>;


export type UpdateLessonReflectionFileTranscriptionMutation = { __typename?: 'mutation_root', updateLessonReflectionFilesByPk?: { __typename?: 'LessonReflectionFiles', id: any } | null };

export type UpdateLessonReminderEventIdMutationVariables = Exact<{
  id: Scalars['uuid'];
  reminderEventId: Scalars['uuid'];
}>;


export type UpdateLessonReminderEventIdMutation = { __typename?: 'mutation_root', updateLessonsByPk?: { __typename?: 'Lessons', id: any, reminderEventId?: any | null } | null };

export type UpdateMatchesVairSubmissionStatusMutationVariables = Exact<{
  matchIds: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type UpdateMatchesVairSubmissionStatusMutation = { __typename?: 'mutation_root', updateEventMatches?: { __typename?: 'EventMatchesMutationResponse', affectedRows: number } | null };

export type InsertPartnerBookingAttemptEventMutationVariables = Exact<{
  object: PartnerBookingAttemptEventsInsertInput;
}>;


export type InsertPartnerBookingAttemptEventMutation = { __typename?: 'mutation_root', insertPartnerBookingAttemptEventsOne?: { __typename?: 'PartnerBookingAttemptEvents', id: any } | null };

export type MarkPartnerBookingAttemptVerifyingMutationVariables = Exact<{
  attemptId: Scalars['uuid'];
  orderId: Scalars['uuid'];
  liveStatuses: Array<PartnerBookingAttemptStatusesEnum> | PartnerBookingAttemptStatusesEnum;
  event: Scalars['String'];
  claim: Scalars['jsonb'];
  confirmationNumber?: InputMaybe<Scalars['String']>;
  worker?: InputMaybe<Scalars['String']>;
}>;


export type MarkPartnerBookingAttemptVerifyingMutation = { __typename?: 'mutation_root', updatePartnerBookingAttempts?: { __typename?: 'PartnerBookingAttemptsMutationResponse', affectedRows: number } | null, updatePartnerBookingOrders?: { __typename?: 'PartnerBookingOrdersMutationResponse', affectedRows: number } | null, insertPartnerBookingAttemptEventsOne?: { __typename?: 'PartnerBookingAttemptEvents', id: any } | null };

export type SettlePartnerBookingAttemptMutationVariables = Exact<{
  attemptId: Scalars['uuid'];
  orderId: Scalars['uuid'];
  liveStatuses: Array<PartnerBookingAttemptStatusesEnum> | PartnerBookingAttemptStatusesEnum;
  attemptStatus: PartnerBookingAttemptStatusesEnum;
  orderStatus: PartnerBookingOrderStatusesEnum;
  confirmationNumber?: InputMaybe<Scalars['String']>;
  verificationMethod?: InputMaybe<PartnerBookingVerificationMethodsEnum>;
  verifiedAt?: InputMaybe<Scalars['timestamptz']>;
  releaseHold: Scalars['Boolean'];
  now: Scalars['timestamptz'];
  verification: Scalars['jsonb'];
  failureReason?: InputMaybe<Scalars['String']>;
}>;


export type SettlePartnerBookingAttemptMutation = { __typename?: 'mutation_root', updatePartnerBookingAttempts?: { __typename?: 'PartnerBookingAttemptsMutationResponse', affectedRows: number } | null, updatePartnerBookingOrders?: { __typename?: 'PartnerBookingOrdersMutationResponse', affectedRows: number } | null, updatePartnerBookingHolds?: { __typename?: 'PartnerBookingHoldsMutationResponse', affectedRows: number } | null, insertPartnerBookingAttemptEventsOne?: { __typename?: 'PartnerBookingAttemptEvents', id: any } | null };

export type PostponePartnerBookingCheckMutationVariables = Exact<{
  attemptId: Scalars['uuid'];
  dueAt: Scalars['timestamptz'];
  nextCheckAt: Scalars['timestamptz'];
  body: Scalars['jsonb'];
}>;


export type PostponePartnerBookingCheckMutation = { __typename?: 'mutation_root', updatePartnerBookingAttempts?: { __typename?: 'PartnerBookingAttemptsMutationResponse', affectedRows: number } | null, insertPartnerBookingAttemptEventsOne?: { __typename?: 'PartnerBookingAttemptEvents', id: any } | null };

export type MarkPartnerBookingAttemptUnknownMutationVariables = Exact<{
  attemptId: Scalars['uuid'];
  orderId: Scalars['uuid'];
  dueAt: Scalars['timestamptz'];
  body: Scalars['jsonb'];
}>;


export type MarkPartnerBookingAttemptUnknownMutation = { __typename?: 'mutation_root', updatePartnerBookingAttempts?: { __typename?: 'PartnerBookingAttemptsMutationResponse', affectedRows: number } | null, updatePartnerBookingOrders?: { __typename?: 'PartnerBookingOrdersMutationResponse', affectedRows: number } | null, insertPartnerBookingAttemptEventsOne?: { __typename?: 'PartnerBookingAttemptEvents', id: any } | null };

export type MarkPartnerBookingPaymentAuthorizedMutationVariables = Exact<{
  orderId: Scalars['uuid'];
  externalStripePaymentIntentId: Scalars['String'];
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  stripePaymentStatus: Scalars['String'];
  now: Scalars['timestamptz'];
}>;


export type MarkPartnerBookingPaymentAuthorizedMutation = { __typename?: 'mutation_root', updatePartnerBookingOrders?: { __typename?: 'PartnerBookingOrdersMutationResponse', affectedRows: number } | null };

export type InsertPartnerBookingAttemptMutationVariables = Exact<{
  orderId: Scalars['uuid'];
}>;


export type InsertPartnerBookingAttemptMutation = { __typename?: 'mutation_root', insertPartnerBookingAttemptsOne?: { __typename?: 'PartnerBookingAttempts', id: any } | null };

export type MarkPartnerBookingPaymentCapturedMutationVariables = Exact<{
  orderId: Scalars['uuid'];
  paidUnitAmount: Scalars['Int'];
  stripePaymentStatus: Scalars['String'];
  now: Scalars['timestamptz'];
}>;


export type MarkPartnerBookingPaymentCapturedMutation = { __typename?: 'mutation_root', updatePartnerBookingOrders?: { __typename?: 'PartnerBookingOrdersMutationResponse', affectedRows: number } | null };

export type MarkPartnerBookingPaymentReleasedMutationVariables = Exact<{
  orderId: Scalars['uuid'];
  stripePaymentStatus: Scalars['String'];
  now: Scalars['timestamptz'];
}>;


export type MarkPartnerBookingPaymentReleasedMutation = { __typename?: 'mutation_root', updatePartnerBookingOrders?: { __typename?: 'PartnerBookingOrdersMutationResponse', affectedRows: number } | null };

export type MarkPartnerBookingPaymentFailedMutationVariables = Exact<{
  orderId: Scalars['uuid'];
  stripePaymentStatus: Scalars['String'];
  externalStripePaymentIntentId?: InputMaybe<Scalars['String']>;
  now: Scalars['timestamptz'];
}>;


export type MarkPartnerBookingPaymentFailedMutation = { __typename?: 'mutation_root', updatePartnerBookingOrders?: { __typename?: 'PartnerBookingOrdersMutationResponse', affectedRows: number } | null, updatePartnerBookingHolds?: { __typename?: 'PartnerBookingHoldsMutationResponse', affectedRows: number } | null };

export type UpdatePlayRequestStatusMutationVariables = Exact<{
  id: Scalars['uuid'];
  status: PlayRequestStatusesEnum;
  respondedAt?: InputMaybe<Scalars['timestamptz']>;
  responseMessage?: InputMaybe<Scalars['String']>;
}>;


export type UpdatePlayRequestStatusMutation = { __typename?: 'mutation_root', updatePlayRequestsByPk?: { __typename?: 'PlayRequests', id: any, status: PlayRequestStatusesEnum } | null };

export type UpdatePlaySessionAsCanceledMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type UpdatePlaySessionAsCanceledMutation = { __typename?: 'mutation_root', updatePlaySessionsByPk?: { __typename?: 'PlaySessions', id: any } | null };

export type UpdatePlaySessionReminderEventIdMutationVariables = Exact<{
  id: Scalars['uuid'];
  reminderEventId: Scalars['uuid'];
}>;


export type UpdatePlaySessionReminderEventIdMutation = { __typename?: 'mutation_root', updatePlaySessionsByPk?: { __typename?: 'PlaySessions', id: any, reminderEventId?: any | null } | null };

export type UpdatePlayerRemoveFromLessonMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type UpdatePlayerRemoveFromLessonMutation = { __typename?: 'mutation_root', updateLessonParticipantsByPk?: { __typename?: 'LessonParticipants', id: any } | null };

export type UpdatePlayerRemoveFromLessonAndRefundMutationVariables = Exact<{
  id: Scalars['uuid'];
  orderItemUpdates: Array<LessonOrderItemsUpdates> | LessonOrderItemsUpdates;
  orderUpdates: Array<LessonOrdersUpdates> | LessonOrdersUpdates;
}>;


export type UpdatePlayerRemoveFromLessonAndRefundMutation = { __typename?: 'mutation_root', updateLessonParticipantsByPk?: { __typename?: 'LessonParticipants', id: any } | null, updateLessonOrderItemsMany?: Array<{ __typename?: 'LessonOrderItemsMutationResponse', returning: Array<{ __typename?: 'LessonOrderItems', id: any }> } | null> | null, updateLessonOrdersMany?: Array<{ __typename?: 'LessonOrdersMutationResponse', returning: Array<{ __typename?: 'LessonOrders', id: any }> } | null> | null };

export type UpdatePoolsForMatchesMutationVariables = Exact<{
  poolId: Scalars['uuid'];
  roundId: Scalars['uuid'];
}>;


export type UpdatePoolsForMatchesMutation = { __typename?: 'mutation_root', updateEventMatches?: { __typename?: 'EventMatchesMutationResponse', affectedRows: number } | null };

export type UpdateStripeMerchantOnboardingMutationVariables = Exact<{
  id: Scalars['uuid'];
  stripeMerchantChargesEnabled: Scalars['Boolean'];
  stripeMerchantCurrentlyDue?: InputMaybe<Scalars['jsonb']>;
  stripeMerchantDetailsSubmitted: Scalars['Boolean'];
  stripeMerchantEventuallyDue?: InputMaybe<Scalars['jsonb']>;
  stripeMerchantPastDue?: InputMaybe<Scalars['jsonb']>;
  stripeMerchantPayoutsEnabled: Scalars['Boolean'];
  stripeMerchantCountry?: InputMaybe<Scalars['String']>;
  stripeMerchantBusinessType?: InputMaybe<Scalars['String']>;
  stripeMerchantCurrency?: InputMaybe<Scalars['String']>;
  currencyCoachDefault?: InputMaybe<Scalars['String']>;
}>;


export type UpdateStripeMerchantOnboardingMutation = { __typename?: 'mutation_root', updateUsersByPk?: { __typename?: 'Users', id: any, stripeMerchantId?: string | null } | null };

export type UpdateUserAdminVenueIdMutationVariables = Exact<{
  userId: Scalars['uuid'];
  adminVenueId: Scalars['uuid'];
}>;


export type UpdateUserAdminVenueIdMutation = { __typename?: 'mutation_root', updateUsersByPk?: { __typename?: 'Users', id: any, adminVenueId?: any | null } | null };

export type UpdateUserDefaultCardIdMutationVariables = Exact<{
  id: Scalars['uuid'];
  defaultCreditCardId?: InputMaybe<Scalars['uuid']>;
}>;


export type UpdateUserDefaultCardIdMutation = { __typename?: 'mutation_root', updateUsersByPk?: { __typename?: 'Users', id: any, defaultCreditCardId?: any | null } | null };

export type UpdateUserDefaultSportMutationVariables = Exact<{
  id: Scalars['uuid'];
  defaultSport: SportsEnum;
}>;


export type UpdateUserDefaultSportMutation = { __typename?: 'mutation_root', updateUsersByPk?: { __typename?: 'Users', defaultSport?: SportsEnum | null, id: any } | null };

export type UpdateUserLatestAuthProviderMutationVariables = Exact<{
  id: Scalars['uuid'];
  latestAuthProvider?: InputMaybe<Scalars['String']>;
}>;


export type UpdateUserLatestAuthProviderMutation = { __typename?: 'mutation_root', updateUsersByPk?: { __typename?: 'Users', id: any, latestAuthProvider: string } | null };

export type UpdateUserPickleballSkillLevelMutationVariables = Exact<{
  id: Scalars['uuid'];
  pickleballSkillLevelId: Scalars['String'];
}>;


export type UpdateUserPickleballSkillLevelMutation = { __typename?: 'mutation_root', updateUsersByPk?: { __typename?: 'Users', id: any, pickleballSkillLevelId?: string | null } | null };

export type UpdateUserTennisSkillLevelMutationVariables = Exact<{
  id: Scalars['uuid'];
  tennisSkillLevelId: Scalars['String'];
}>;


export type UpdateUserTennisSkillLevelMutation = { __typename?: 'mutation_root', updateUsersByPk?: { __typename?: 'Users', id: any, tennisSkillLevelId?: string | null } | null };

export type UpdateUserStripeMerchantIdMutationVariables = Exact<{
  id: Scalars['uuid'];
  stripeMerchantId: Scalars['String'];
}>;


export type UpdateUserStripeMerchantIdMutation = { __typename?: 'mutation_root', updateUsersByPk?: { __typename?: 'Users', id: any, stripeMerchantId?: string | null } | null };

export type UpdateVenueBookingProviderAccessMutationVariables = Exact<{
  integrationId: Scalars['uuid'];
  externalOrgId: Scalars['String'];
  providerApiKeyEncrypted: Scalars['String'];
  readVerifiedAt: Scalars['timestamptz'];
}>;


export type UpdateVenueBookingProviderAccessMutation = { __typename?: 'mutation_root', updateVenueBookingIntegrationsByPk?: { __typename?: 'VenueBookingIntegrations', id: any, readVerifiedAt?: any | null } | null };

export type UpdateVenueFaqsMutationVariables = Exact<{
  venueId: Scalars['uuid'];
  faqs: Array<VenueFaqsInsertInput> | VenueFaqsInsertInput;
}>;


export type UpdateVenueFaqsMutation = { __typename?: 'mutation_root', deleteVenueFaqs?: { __typename?: 'VenueFaqsMutationResponse', affectedRows: number } | null, insertVenueFaqs?: { __typename?: 'VenueFaqsMutationResponse', affectedRows: number } | null };

export type UpdateVenueProfileMutationVariables = Exact<{
  venueId: Scalars['uuid'];
  title: Scalars['String'];
  description: Scalars['String'];
  email: Scalars['String'];
  phoneNumber: Scalars['String'];
  websiteUrl: Scalars['String'];
  accessType: VenueAccessTypesEnum;
  facilityType: VenueFacilityTypesEnum;
  indoorCourtCount: Scalars['Int'];
  outdoorCourtCount: Scalars['Int'];
  totalCourtCount: Scalars['Int'];
  pickleballNets?: InputMaybe<VenueNetsEnum>;
  pickleballLines?: InputMaybe<VenueLinesEnum>;
  isActive: Scalars['Boolean'];
  hasTennis: Scalars['Boolean'];
  hasPickleball: Scalars['Boolean'];
  hasPadel: Scalars['Boolean'];
  hasReservations: Scalars['Boolean'];
  amenities: Array<VenueAmenitiesInsertInput> | VenueAmenitiesInsertInput;
  courtSurfaces: Array<VenueCourtSurfacesInsertInput> | VenueCourtSurfacesInsertInput;
  equipment: Array<VenueEquipmentInsertInput> | VenueEquipmentInsertInput;
  customAmenities: Array<VenueCustomAmenitiesInsertInput> | VenueCustomAmenitiesInsertInput;
  venueImages: Array<VenueImagesInsertInput> | VenueImagesInsertInput;
  cityId?: InputMaybe<Scalars['uuid']>;
  instagramUrl?: InputMaybe<Scalars['String']>;
  facebookUrl?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  linkedinUrl?: InputMaybe<Scalars['String']>;
  twitterUrl?: InputMaybe<Scalars['String']>;
}>;


export type UpdateVenueProfileMutation = { __typename?: 'mutation_root', deleteVenueAmenities?: { __typename?: 'VenueAmenitiesMutationResponse', affectedRows: number } | null, deleteVenueCourtSurfaces?: { __typename?: 'VenueCourtSurfacesMutationResponse', affectedRows: number } | null, deleteVenueEquipment?: { __typename?: 'VenueEquipmentMutationResponse', affectedRows: number } | null, deleteVenueCustomAmenities?: { __typename?: 'VenueCustomAmenitiesMutationResponse', affectedRows: number } | null, deleteVenueImages?: { __typename?: 'VenueImagesMutationResponse', affectedRows: number } | null, insertVenueAmenities?: { __typename?: 'VenueAmenitiesMutationResponse', affectedRows: number } | null, insertVenueCourtSurfaces?: { __typename?: 'VenueCourtSurfacesMutationResponse', affectedRows: number } | null, insertVenueEquipment?: { __typename?: 'VenueEquipmentMutationResponse', affectedRows: number } | null, insertVenueCustomAmenities?: { __typename?: 'VenueCustomAmenitiesMutationResponse', affectedRows: number } | null, insertVenueImages?: { __typename?: 'VenueImagesMutationResponse', affectedRows: number } | null, updateVenuesByPk?: { __typename?: 'Venues', id: any, title: string } | null };

export type UpdateVideoAnalysisFileTranscriptionMutationVariables = Exact<{
  id: Scalars['uuid'];
  transcriptionStartedAt?: InputMaybe<Scalars['timestamptz']>;
  transcript?: InputMaybe<Scalars['String']>;
  transcriptionCompletedAt?: InputMaybe<Scalars['timestamptz']>;
}>;


export type UpdateVideoAnalysisFileTranscriptionMutation = { __typename?: 'mutation_root', updateVideoAnalysisFilesByPk?: { __typename?: 'VideoAnalysisFiles', id: any } | null };

export type UpsertFollowerConnectionMutationVariables = Exact<{
  followedUserId: Scalars['uuid'];
  followerUserId: Scalars['uuid'];
  status: FollowStatusesEnum;
}>;


export type UpsertFollowerConnectionMutation = { __typename?: 'mutation_root', insertUserFollowsOne?: { __typename?: 'UserFollows', followerUserId: any, followedUserId: any, status: FollowStatusesEnum } | null };

export type UpsertInvoiceMutationVariables = Exact<{
  amountDue?: InputMaybe<Scalars['numeric']>;
  amountPaid?: InputMaybe<Scalars['numeric']>;
  externalInvoiceId?: InputMaybe<Scalars['String']>;
  externalSubscriptionId?: InputMaybe<Scalars['String']>;
  paid?: InputMaybe<Scalars['Boolean']>;
  peerSubscriptionId?: InputMaybe<Scalars['uuid']>;
  periodEnd?: InputMaybe<Scalars['timestamptz']>;
  periodStart?: InputMaybe<Scalars['timestamptz']>;
  platformSubscriptionId?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['String']>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['uuid']>;
}>;


export type UpsertInvoiceMutation = { __typename?: 'mutation_root', insertInvoicesOne?: { __typename?: 'Invoices', id: any } | null };

export type UpsertLessonWaitlistMutationVariables = Exact<{
  objects: Array<LessonWaitlistsInsertInput> | LessonWaitlistsInsertInput;
}>;


export type UpsertLessonWaitlistMutation = { __typename?: 'mutation_root', insertLessonWaitlists?: { __typename?: 'LessonWaitlistsMutationResponse', returning: Array<{ __typename?: 'LessonWaitlists', lessonId: any, status: LessonWaitlistStatusesEnum, userId: any, id: any }> } | null };

export type UpsertPayingUserAsLessonParticipantMutationVariables = Exact<{
  lessonId: Scalars['uuid'];
  userId: Scalars['uuid'];
}>;


export type UpsertPayingUserAsLessonParticipantMutation = { __typename?: 'mutation_root', insertLessonParticipantsOne?: { __typename?: 'LessonParticipants', addedByUserId?: any | null, addedAt?: any | null, addedByPersona?: AppPersonasEnum | null, createdAt: any, id: any, lessonId: any, paidAt?: any | null, status: LessonParticipantStatusesEnum, userId: any } | null };

export type UpsertPlatformSubscriptionMutationVariables = Exact<{
  cancelAtPeriodEnd?: InputMaybe<Scalars['Boolean']>;
  canceledAt?: InputMaybe<Scalars['timestamptz']>;
  currentPeriodEndAt?: InputMaybe<Scalars['timestamptz']>;
  currentPeriodStartAt?: InputMaybe<Scalars['timestamptz']>;
  endedAt?: InputMaybe<Scalars['timestamptz']>;
  externalSubscriptionId?: InputMaybe<Scalars['String']>;
  platformSubscriptionPlanPriceId?: InputMaybe<Scalars['uuid']>;
  startDate?: InputMaybe<Scalars['timestamptz']>;
  status: SubscriptionStatusesEnum;
  statusChangedAt?: InputMaybe<Scalars['timestamptz']>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  stripeProductId?: InputMaybe<Scalars['String']>;
  stripeStatus?: InputMaybe<Scalars['String']>;
  stripePriceId?: InputMaybe<Scalars['String']>;
  stripeSubscriptionId?: InputMaybe<Scalars['String']>;
  trialEndAt?: InputMaybe<Scalars['timestamptz']>;
  trialStartAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
}>;


export type UpsertPlatformSubscriptionMutation = { __typename?: 'mutation_root', insertPlatformSubscriptionsOne?: { __typename?: 'PlatformSubscriptions', id: any, userId: any } | null };

export type UpsertPlaySessionParticipantJoinMutationVariables = Exact<{
  addedByUserId: Scalars['uuid'];
  playSessionId: Scalars['uuid'];
  userId: Scalars['uuid'];
  status: PlaySessionParticipantStatusesEnum;
}>;


export type UpsertPlaySessionParticipantJoinMutation = { __typename?: 'mutation_root', insertPlaySessionParticipantsOne?: { __typename?: 'PlaySessionParticipants', id: any, status: PlaySessionParticipantStatusesEnum, userId: any, user: { __typename?: 'Users', id: any, fullName: string } } | null };

export type UpsertPlaySessionParticipantLeaveMutationVariables = Exact<{
  playSessionId: Scalars['uuid'];
  userId: Scalars['uuid'];
  status: PlaySessionParticipantStatusesEnum;
}>;


export type UpsertPlaySessionParticipantLeaveMutation = { __typename?: 'mutation_root', insertPlaySessionParticipantsOne?: { __typename?: 'PlaySessionParticipants', id: any, status: PlaySessionParticipantStatusesEnum, userId: any, user: { __typename?: 'Users', id: any, preferredName: string, fullName: string, email: string } } | null };

export type UpsertStripeChargeMutationVariables = Exact<{
  amount?: InputMaybe<Scalars['Int']>;
  amountCaptured?: InputMaybe<Scalars['Int']>;
  amountRefunded?: InputMaybe<Scalars['Int']>;
  application?: InputMaybe<Scalars['String']>;
  applicationFee?: InputMaybe<Scalars['String']>;
  applicationFeeAmount?: InputMaybe<Scalars['Int']>;
  calculatedStatementDescriptor?: InputMaybe<Scalars['String']>;
  captured?: InputMaybe<Scalars['Boolean']>;
  chargeId?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  disputed?: InputMaybe<Scalars['Boolean']>;
  externalStripePaymentIntentId?: InputMaybe<Scalars['String']>;
  paid?: InputMaybe<Scalars['Boolean']>;
  paymentMethod?: InputMaybe<Scalars['String']>;
  refunded?: InputMaybe<Scalars['Boolean']>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  transferDataAmount?: InputMaybe<Scalars['Int']>;
  transferDataDestination?: InputMaybe<Scalars['String']>;
  transferId?: InputMaybe<Scalars['String']>;
  sourceTransfer?: InputMaybe<Scalars['String']>;
}>;


export type UpsertStripeChargeMutation = { __typename?: 'mutation_root', insertStripeChargesOne?: { __typename?: 'StripeCharges', id: any } | null };

export type UpsertStripeChargeAndPaymentIntentMutationVariables = Exact<{
  amount?: InputMaybe<Scalars['Int']>;
  amountCaptured?: InputMaybe<Scalars['Int']>;
  amountRefunded?: InputMaybe<Scalars['Int']>;
  application?: InputMaybe<Scalars['String']>;
  applicationFee?: InputMaybe<Scalars['String']>;
  applicationFeeAmount?: InputMaybe<Scalars['Int']>;
  calculatedStatementDescriptor?: InputMaybe<Scalars['String']>;
  captured?: InputMaybe<Scalars['Boolean']>;
  chargeId?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  disputed?: InputMaybe<Scalars['Boolean']>;
  externalStripePaymentIntentId?: InputMaybe<Scalars['String']>;
  paid?: InputMaybe<Scalars['Boolean']>;
  paymentMethod?: InputMaybe<Scalars['String']>;
  refunded?: InputMaybe<Scalars['Boolean']>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  transferDataAmount?: InputMaybe<Scalars['Int']>;
  transferDataDestination?: InputMaybe<Scalars['String']>;
  paymentIntentAmount?: InputMaybe<Scalars['Int']>;
  paymentIntentAmountCapturable?: InputMaybe<Scalars['Int']>;
  paymentIntentAmountReceived?: InputMaybe<Scalars['Int']>;
  paymentIntentApplication?: InputMaybe<Scalars['String']>;
  paymentIntentApplicationFeeAmount?: InputMaybe<Scalars['Int']>;
  cancellationReason?: InputMaybe<Scalars['String']>;
  paymentIntentCurrency?: InputMaybe<Scalars['String']>;
  onBehalfOf?: InputMaybe<Scalars['String']>;
  paymentIntentId?: InputMaybe<Scalars['String']>;
  paymentIntentPaymentMethod?: InputMaybe<Scalars['String']>;
  statementDescriptor?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  paymentIntentStripeCustomerId?: InputMaybe<Scalars['String']>;
  paymentIntentTransferDataAmount?: InputMaybe<Scalars['Int']>;
  paymentIntentTransferDataDestination?: InputMaybe<Scalars['String']>;
  transferGroup?: InputMaybe<Scalars['String']>;
  transferId?: InputMaybe<Scalars['String']>;
  sourceTransfer?: InputMaybe<Scalars['String']>;
}>;


export type UpsertStripeChargeAndPaymentIntentMutation = { __typename?: 'mutation_root', insertStripeChargesOne?: { __typename?: 'StripeCharges', id: any } | null };

export type UpsertTwilioConversationMutationVariables = Exact<{
  participantsKey: Scalars['String'];
  twilioConversationSid: Scalars['String'];
}>;


export type UpsertTwilioConversationMutation = { __typename?: 'mutation_root', insertTwilioGroupTextsOne?: { __typename?: 'TwilioGroupTexts', participantsKey: string, id: any, twilioConversationSid: string } | null };

export type UpsertUserAuthIdentitiesMutationVariables = Exact<{
  objects: Array<UserAuthIdentitiesInsertInput> | UserAuthIdentitiesInsertInput;
}>;


export type UpsertUserAuthIdentitiesMutation = { __typename?: 'mutation_root', insertUserAuthIdentities?: { __typename?: 'UserAuthIdentitiesMutationResponse', affectedRows: number } | null };

export type UpsertUserCreditCardMutationVariables = Exact<{
  billingCity?: InputMaybe<Scalars['String']>;
  billingCountry?: InputMaybe<Scalars['String']>;
  billingEmail?: InputMaybe<Scalars['String']>;
  billingLine1?: InputMaybe<Scalars['String']>;
  billingLine2?: InputMaybe<Scalars['String']>;
  billingName?: InputMaybe<Scalars['String']>;
  billingPhone?: InputMaybe<Scalars['String']>;
  billingPostalCode?: InputMaybe<Scalars['String']>;
  billingState?: InputMaybe<Scalars['String']>;
  brand: Scalars['String'];
  country?: InputMaybe<Scalars['String']>;
  expireMonth: Scalars['Int'];
  expireYear: Scalars['Int'];
  fingerprint?: InputMaybe<Scalars['String']>;
  funding?: InputMaybe<Scalars['String']>;
  last4: Scalars['String'];
  providerCardId: Scalars['String'];
  userId: Scalars['uuid'];
}>;


export type UpsertUserCreditCardMutation = { __typename?: 'mutation_root', insertUserCreditCardsOne?: { __typename?: 'UserCreditCards', id: any, providerCardId: string } | null };

export type UpsertVairConnectionMutationVariables = Exact<{
  userId: Scalars['uuid'];
  memberId: Scalars['String'];
  clerkId?: InputMaybe<Scalars['String']>;
  accessToken: Scalars['String'];
  refreshToken: Scalars['String'];
  tokenExpiry: Scalars['timestamptz'];
  connectedAt: Scalars['timestamptz'];
  lastSyncedAt: Scalars['timestamptz'];
  name: Scalars['String'];
  email: Scalars['String'];
}>;


export type UpsertVairConnectionMutation = { __typename?: 'mutation_root', insertUserVairConnections?: { __typename?: 'UserVairConnectionsMutationResponse', returning: Array<{ __typename?: 'UserVairConnections', id: any, userId: any, memberId: string, clerkId?: string | null, name: string, email: string, connectedAt: any, lastSyncedAt: any }> } | null };

export type UpsertVenueBookingConnectionMutationVariables = Exact<{
  venueId: Scalars['uuid'];
  bookingSystem: BookingSystemsEnum;
  accountAddedConfirmedAt?: InputMaybe<Scalars['timestamptz']>;
  accountAddedConfirmedBy?: InputMaybe<Scalars['uuid']>;
  helpRequestedAt?: InputMaybe<Scalars['timestamptz']>;
  updateColumns: Array<VenueBookingIntegrationsUpdateColumn> | VenueBookingIntegrationsUpdateColumn;
}>;


export type UpsertVenueBookingConnectionMutation = { __typename?: 'mutation_root', insertVenueBookingIntegrationsOne?: { __typename?: 'VenueBookingIntegrations', id: any, bookingSystem: BookingSystemsEnum, connectionStatus: BookingConnectionStatusesEnum, status: BookingIntegrationStatusesEnum } | null };

export type InsertUserBlockMutationVariables = Exact<{
  blockerUserId: Scalars['uuid'];
  blockedUserId: Scalars['uuid'];
}>;


export type InsertUserBlockMutation = { __typename?: 'mutation_root', insertUserBlocksOne?: { __typename?: 'UserBlocks', id: any } | null };

export type RemoveUserBlockMutationVariables = Exact<{
  blockerUserId: Scalars['uuid'];
  blockedUserId: Scalars['uuid'];
  deletedAt: Scalars['timestamptz'];
}>;


export type RemoveUserBlockMutation = { __typename?: 'mutation_root', updateUserBlocks?: { __typename?: 'UserBlocksMutationResponse', affectedRows: number } | null };

export type InsertUserConnectionMutationVariables = Exact<{
  userAId: Scalars['uuid'];
  userBId: Scalars['uuid'];
  requestId?: InputMaybe<Scalars['uuid']>;
}>;


export type InsertUserConnectionMutation = { __typename?: 'mutation_root', insertUserConnectionsOne?: { __typename?: 'UserConnections', id: any } | null };

export type RemoveUserConnectionMutationVariables = Exact<{
  userAId: Scalars['uuid'];
  userBId: Scalars['uuid'];
  removedByUserId: Scalars['uuid'];
  deletedAt: Scalars['timestamptz'];
}>;


export type RemoveUserConnectionMutation = { __typename?: 'mutation_root', updateUserConnections?: { __typename?: 'UserConnectionsMutationResponse', affectedRows: number } | null };

export type InsertVenueBookingConnectionCheckMutationVariables = Exact<{
  integrationId: Scalars['uuid'];
  trigger: Scalars['String'];
  requestedBy?: InputMaybe<Scalars['uuid']>;
}>;


export type InsertVenueBookingConnectionCheckMutation = { __typename?: 'mutation_root', insertVenueBookingConnectionChecksOne?: { __typename?: 'VenueBookingConnectionChecks', id: any, integration: { __typename?: 'VenueBookingIntegrations', id: any, venueId: any, venue: { __typename?: 'Venues', title: string, timezone: string } } } | null };

export type MarkVenueBookingConnectionCheckDispatchedMutationVariables = Exact<{
  checkId: Scalars['uuid'];
  runId?: InputMaybe<Scalars['String']>;
  now: Scalars['timestamptz'];
  report?: InputMaybe<Scalars['jsonb']>;
}>;


export type MarkVenueBookingConnectionCheckDispatchedMutation = { __typename?: 'mutation_root', updateVenueBookingConnectionChecksByPk?: { __typename?: 'VenueBookingConnectionChecks', id: any } | null };

export type SettleVenueBookingConnectionCheckMutationVariables = Exact<{
  checkId: Scalars['uuid'];
  integrationId: Scalars['uuid'];
  status: VenueBookingConnectionCheckStatusesEnum;
  connectionStatus: BookingConnectionStatusesEnum;
  verifiedAt?: InputMaybe<Scalars['timestamptz']>;
  now: Scalars['timestamptz'];
  report: Scalars['jsonb'];
  isDecided: Scalars['Boolean'];
}>;


export type SettleVenueBookingConnectionCheckMutation = { __typename?: 'mutation_root', updateVenueBookingIntegrations?: { __typename?: 'VenueBookingIntegrationsMutationResponse', affectedRows: number } | null, updateVenueBookingConnectionChecks?: { __typename?: 'VenueBookingConnectionChecksMutationResponse', affectedRows: number } | null };

export type MarkVenueBookingConnectionFailedMutationVariables = Exact<{
  integrationId: Scalars['uuid'];
}>;


export type MarkVenueBookingConnectionFailedMutation = { __typename?: 'mutation_root', updateVenueBookingIntegrationsByPk?: { __typename?: 'VenueBookingIntegrations', id: any } | null };

export type DeleteCalendarEventMappingMutationVariables = Exact<{
  lessonId: Scalars['uuid'];
}>;


export type DeleteCalendarEventMappingMutation = { __typename?: 'mutation_root', deleteCalendarEventMappings?: { __typename?: 'CalendarEventMappingsMutationResponse', affectedRows: number } | null };

export type FindConversationByEventQueryVariables = Exact<{
  eventId: Scalars['uuid'];
}>;


export type FindConversationByEventQuery = { __typename?: 'query_root', conversations: Array<{ __typename?: 'Conversations', id: any }> };

export type FindConversationByLessonQueryVariables = Exact<{
  lessonId: Scalars['uuid'];
}>;


export type FindConversationByLessonQuery = { __typename?: 'query_root', conversations: Array<{ __typename?: 'Conversations', id: any }> };

export type FindDirectConversationQueryVariables = Exact<{
  directKey: Scalars['String'];
}>;


export type FindDirectConversationQuery = { __typename?: 'query_root', conversations: Array<{ __typename?: 'Conversations', id: any }> };

export type GetActiveBoostPlacementsQueryVariables = Exact<{
  lessonIds?: InputMaybe<Array<Scalars['uuid']> | Scalars['uuid']>;
  eventIds?: InputMaybe<Array<Scalars['uuid']> | Scalars['uuid']>;
  now: Scalars['timestamptz'];
}>;


export type GetActiveBoostPlacementsQuery = { __typename?: 'query_root', boosts: Array<{ __typename?: 'Boosts', id: any, lessonId?: any | null, eventId?: any | null }> };

export type GetActiveCoachVairConnectionsByUserIdsQueryVariables = Exact<{
  userIds: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type GetActiveCoachVairConnectionsByUserIdsQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'Users', id: any, userVairConnection?: { __typename?: 'UserVairConnections', memberId: string } | null }> };

export type GetActiveCourtsForMatchesQueryVariables = Exact<{
  matchIds: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type GetActiveCourtsForMatchesQuery = { __typename?: 'query_root', eventCourts: Array<{ __typename?: 'EventCourts', id: any, courtNumber: number, activeMatchId?: any | null, activeEventGroupId?: any | null, activeEventGroupPoolId?: any | null }> };

export type GetActiveEventGroupRegistrationsForUserQueryVariables = Exact<{
  eventId: Scalars['uuid'];
  userId: Scalars['uuid'];
}>;


export type GetActiveEventGroupRegistrationsForUserQuery = { __typename?: 'query_root', eventGroupRegistrations: Array<{ __typename?: 'EventGroupRegistrations', id: any }> };

export type GetActiveGroupRegistrationsForUserQueryVariables = Exact<{
  userId: Scalars['uuid'];
  groupIds: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type GetActiveGroupRegistrationsForUserQuery = { __typename?: 'query_root', eventGroupRegistrations: Array<{ __typename?: 'EventGroupRegistrations', id: any, groupId: any, group: { __typename?: 'EventGroups', title: string } }> };

export type GetActivePlayRequestCountByRequesterQueryVariables = Exact<{
  requesterUserId: Scalars['uuid'];
}>;


export type GetActivePlayRequestCountByRequesterQuery = { __typename?: 'query_root', playRequestsAggregate: { __typename?: 'PlayRequestsAggregate', aggregate?: { __typename?: 'PlayRequestsAggregateFields', count: number } | null } };

export type GetAdminMcpCourtBookingsQueryVariables = Exact<{
  where: PartnerBookingOrdersBoolExp;
  limit: Scalars['Int'];
}>;


export type GetAdminMcpCourtBookingsQuery = { __typename?: 'query_root', partnerBookingOrders: Array<{ __typename?: 'PartnerBookingOrders', id: any, createdAt: any, status: PartnerBookingOrderStatusesEnum, inventoryType: BookingInventoryTypesEnum, localDate: any, startLocal: any, endLocal: any, timezone: string, playerCount: number, currency: string, clubPriceUnitAmount?: number | null, partnerDiscountPercent?: any | null, partnerDiscountUnitAmount?: number | null, bounceCostUnitAmount?: number | null, referralFeeUnitAmount?: number | null, orderSubtotalUnitAmount: number, orderTotalUnitAmount: number, paidUnitAmount: number, refundUnitAmount: number, capturedAt?: any | null, refundedAt?: any | null, venue: { __typename?: 'Venues', id: any, slug: string, title: string } }> };

export type GetAdminMcpCourtBookingTotalsQueryVariables = Exact<{
  where: PartnerBookingOrdersBoolExp;
  confirmedWhere: PartnerBookingOrdersBoolExp;
}>;


export type GetAdminMcpCourtBookingTotalsQuery = { __typename?: 'query_root', all: { __typename?: 'PartnerBookingOrdersAggregate', aggregate?: { __typename?: 'PartnerBookingOrdersAggregateFields', count: number } | null }, confirmed: { __typename?: 'PartnerBookingOrdersAggregate', aggregate?: { __typename?: 'PartnerBookingOrdersAggregateFields', count: number, sum?: { __typename?: 'PartnerBookingOrdersSumFields', orderTotalUnitAmount?: number | null, paidUnitAmount?: number | null, refundUnitAmount?: number | null, bounceCostUnitAmount?: number | null, referralFeeUnitAmount?: number | null } | null } | null } };

export type GetAdminMcpPartnerClubsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAdminMcpPartnerClubsQuery = { __typename?: 'query_root', venueBookingIntegrations: Array<{ __typename?: 'VenueBookingIntegrations', id: any, status: BookingIntegrationStatusesEnum, connectionStatus: BookingConnectionStatusesEnum, bookingSystem: BookingSystemsEnum, externalOrgId?: string | null, providerApiKeyEncrypted?: string | null, readVerifiedAt?: any | null, verifiedAt?: any | null, activatedAt?: any | null, pausedAt?: any | null, maxAdvanceBookingDays?: number | null, isPreferredPartner: boolean, partnerPricingEnabled: boolean, referralFeeEnabled: boolean, referralFeeCents: number, currentVersion: number, venue: { __typename?: 'Venues', id: any, slug: string, title: string, timezone: string, addressString: string, latitude: any, longitude: any }, windows: Array<{ __typename?: 'VenueBookingWindows', kind: BookingWindowKindsEnum, inventoryType?: BookingInventoryTypesEnum | null, sport?: SportsEnum | null, dayOfWeek: DayOfWeekEnum, startTime: any, endTime: any }>, courtRates: Array<{ __typename?: 'VenueBookingCourtRates', sport?: SportsEnum | null, currency: string, hourlyUnitAmount: number, peakHourlyUnitAmount?: number | null }>, rules: Array<{ __typename?: 'VenueBookingRules', inventoryType: BookingInventoryTypesEnum, scheduleMode: BookingScheduleModesEnum, isCustomPricing: boolean, tiers: Array<{ __typename?: 'VenueBookingRuleTiers', leadTimeHours: number, discountPercent: any, isEnabled: boolean }>, windows: Array<{ __typename?: 'VenueBookingWindows', dayOfWeek: DayOfWeekEnum, startTime: any, endTime: any }> }> }> };

export type GetAdminMcpProgramQueryVariables = Exact<{
  where: EventsBoolExp;
}>;


export type GetAdminMcpProgramQuery = { __typename?: 'query_root', events: Array<{ __typename?: 'Events', id: any, slug: string, title: string, description: string, type: EventTypesEnum, isRfx: boolean, status: EventStatusesEnum, privacy: EventPrivacyEnum, sport: SportsEnum, hostUserId?: any | null, canceledAt?: any | null, deletedAt?: any | null, startDateTime: any, endDateTime: any, timezoneName: string, registrationDeadlineDateTime?: any | null, participantLimit?: number | null, registrationPriceUnitAmount: number, coverImageProviderUrl?: string | null, venue?: { __typename?: 'Venues', id: any, title: string, timezone: string } | null, hostUserProfile?: { __typename?: 'UserProfiles', fullName?: string | null } | null, hostUser?: { __typename?: 'Users', id: any, email: string, stripeMerchantChargesEnabled: boolean } | null, groups: Array<{ __typename?: 'EventGroups', id: any, priceUnitAmount: number, teamLimit?: number | null, selfRatedMinSkillLevelId?: string | null, selfRatedMaxSkillLevelId?: string | null, startsAt?: any | null, endsAt?: any | null, timeSlots: Array<{ __typename?: 'EventGroupTimeSlots', id: any, startsAt: any, endsAt: any }> }>, registrationsAggregate: { __typename?: 'EventRegistrationsAggregate', aggregate?: { __typename?: 'EventRegistrationsAggregateFields', count: number } | null } }> };

export type GetAdminMcpProgramHostQueryVariables = Exact<{
  email: Scalars['String'];
}>;


export type GetAdminMcpProgramHostQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'Users', id: any, email: string, stripeMerchantChargesEnabled: boolean }> };

export type GetAdminMcpEventRegistrationsQueryVariables = Exact<{
  where: EventRegistrationsBoolExp;
  limit: Scalars['Int'];
}>;


export type GetAdminMcpEventRegistrationsQuery = { __typename?: 'query_root', eventRegistrations: Array<{ __typename?: 'EventRegistrations', id: any, createdAt: any, deletedAt?: any | null, event: { __typename?: 'Events', id: any, slug: string, title: string, type: EventTypesEnum, sport: SportsEnum, startDateTime: any, venue?: { __typename?: 'Venues', id: any, title: string } | null }, transactionItems: Array<{ __typename?: 'EventTransactionItems', transaction: { __typename?: 'EventTransactions', id: any, status: OrderStatusesEnum, orderSubtotalUnitAmount: number, orderTotalUnitAmount: number, paidUnitAmount: number, refundUnitAmount: number, refundedAt?: any | null, applicationFeeTotalUnitAmount: number, customerPlatformFeeUnitAmount: number, sellerPlatformFeeUnitAmount: number, customerProcessingFeeUnitAmount: number, sellerProcessingFeeUnitAmount: number } }> }> };

export type GetAdminMcpEventCouponRedemptionsQueryVariables = Exact<{
  transactionIds: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type GetAdminMcpEventCouponRedemptionsQuery = { __typename?: 'query_root', eventCouponRedemptions: Array<{ __typename?: 'EventCouponRedemptions', eventTransactionId?: any | null, discountUnitAmount: number, coupon: { __typename?: 'EventCoupons', code: string } }> };

export type GetAdminMcpLessonOrdersQueryVariables = Exact<{
  where: LessonOrdersBoolExp;
  limit: Scalars['Int'];
}>;


export type GetAdminMcpLessonOrdersQuery = { __typename?: 'query_root', lessonOrders: Array<{ __typename?: 'LessonOrders', id: any, createdAt: any, status: OrderStatusesEnum, orderSubtotalUnitAmount: number, orderTotalUnitAmount: number, paidUnitAmount: number, refundUnitAmount: number, refundedAt?: any | null, applicationFeeTotalUnitAmount: number, items: Array<{ __typename?: 'LessonOrderItems', lessonParticipant: { __typename?: 'LessonParticipants', lesson: { __typename?: 'Lessons', id: any, title: string, type: LessonTypesEnum, sport: SportsEnum, startDateTime?: any | null, venue?: { __typename?: 'Venues', id: any, title: string } | null } } }> }> };

export type GetAdminMcpProgramTotalsQueryVariables = Exact<{
  registrationsWhere: EventRegistrationsBoolExp;
  paidEventsWhere: EventTransactionsBoolExp;
  lessonsWhere: LessonOrdersBoolExp;
  paidLessonsWhere: LessonOrdersBoolExp;
}>;


export type GetAdminMcpProgramTotalsQuery = { __typename?: 'query_root', registrations: { __typename?: 'EventRegistrationsAggregate', aggregate?: { __typename?: 'EventRegistrationsAggregateFields', count: number } | null }, paidEvents: { __typename?: 'EventTransactionsAggregate', aggregate?: { __typename?: 'EventTransactionsAggregateFields', count: number, sum?: { __typename?: 'EventTransactionsSumFields', paidUnitAmount?: number | null, refundUnitAmount?: number | null, applicationFeeTotalUnitAmount?: number | null } | null } | null }, lessons: { __typename?: 'LessonOrdersAggregate', aggregate?: { __typename?: 'LessonOrdersAggregateFields', count: number } | null }, paidLessons: { __typename?: 'LessonOrdersAggregate', aggregate?: { __typename?: 'LessonOrdersAggregateFields', count: number, sum?: { __typename?: 'LessonOrdersSumFields', paidUnitAmount?: number | null, refundUnitAmount?: number | null, applicationFeeTotalUnitAmount?: number | null } | null } | null } };

export type GetAdminMcpProgramVenueQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetAdminMcpProgramVenueQuery = { __typename?: 'query_root', venuesByPk?: { __typename?: 'Venues', id: any, slug: string, title: string, timezone: string, latitude: any, longitude: any, addressString: string, cityId?: any | null, deletedAt?: any | null } | null };

export type GetAdminMcpSignupsQueryVariables = Exact<{
  where: UsersBoolExp;
  limit: Scalars['Int'];
}>;


export type GetAdminMcpSignupsQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'Users', createdAt: any, defaultSport?: SportsEnum | null, cityName: string, latitude?: any | null, longitude?: any | null, activeCity?: { __typename?: 'Cities', id: any, name: string, countrySubdivision: { __typename?: 'CountrySubdivisions', name: string } } | null }> };

export type GetAllCityVenuePathsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllCityVenuePathsQuery = { __typename?: 'query_root', cities: Array<{ __typename?: 'Cities', id: any, slug: string, venues: Array<{ __typename?: 'Venues', id: any }> }> };

export type GetAllCoachesPathsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllCoachesPathsQuery = { __typename?: 'query_root', userProfiles: Array<{ __typename?: 'UserProfiles', id?: any | null, username?: string | null }> };

export type GetAllGroupPathsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllGroupPathsQuery = { __typename?: 'query_root', groups: Array<{ __typename?: 'Groups', id: any, slug: string }> };

export type GetAllRemoteCoachesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetAllRemoteCoachesQuery = { __typename?: 'query_root', userProfiles: Array<{ __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, priceUnitAmountRemoteCoachDefault?: number | null, priceUnitAmountCoachDefault?: number | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProvider?: string | null, profileImageProviderUrl?: string | null, preferredName?: string | null, username?: string | null, defaultSport?: string | null, geometry?: any | null, stripeMerchantCurrency?: string | null, currencyCoachDefault?: string | null, coachAvailability: Array<{ __typename?: 'CoachAvailability', id: any }>, defaultCoachVenue?: { __typename?: 'Venues', addressString: string, id: any } | null, defaultCoachCustomCourt?: { __typename?: 'UserCustomCourts', title: string, id: any, fullAddress: string } | null, followersAggregate: { __typename?: 'UserFollowsAggregate', aggregate?: { __typename?: 'UserFollowsAggregateFields', count: number } | null } }> };

export type GetAllVenuePathsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllVenuePathsQuery = { __typename?: 'query_root', venues: Array<{ __typename?: 'Venues', id: any, slug: string }> };

export type GetAvailabilityNeighborhoodsForRequestQueryVariables = Exact<{
  slotId: Scalars['uuid'];
  availabilityId: Scalars['uuid'];
  neighborhoodIds: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type GetAvailabilityNeighborhoodsForRequestQuery = { __typename?: 'query_root', playerAvailabilitySlotsByPk?: { __typename?: 'PlayerAvailabilitySlots', id: any, availabilityId: any, dayOfWeek: string, startTime: any, endTime: any } | null, playerAvailabilityNeighborhoods: Array<{ __typename?: 'PlayerAvailabilityNeighborhoods', neighborhoodId: any, neighborhood: { __typename?: 'Neighborhoods', id: any, city: { __typename?: 'Cities', id: any, timezone?: string | null } } }> };

export type GetAvailabilitySlotForRequestQueryVariables = Exact<{
  slotId: Scalars['uuid'];
  venueId: Scalars['uuid'];
}>;


export type GetAvailabilitySlotForRequestQuery = { __typename?: 'query_root', playerAvailabilitySlotsByPk?: { __typename?: 'PlayerAvailabilitySlots', id: any, availabilityId: any, dayOfWeek: string, startTime: any, endTime: any } | null, venuesByPk?: { __typename?: 'Venues', id: any, timezone: string } | null };

export type GetAvailableCoachQualificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAvailableCoachQualificationsQuery = { __typename?: 'query_root', coachQualifications: Array<{ __typename?: 'CoachQualifications', id: any, name: string, order: number, groupId?: CoachQualificationGroupsEnum | null, displayKey: string }> };

export type GetBoostableProgramsQueryVariables = Exact<{
  venueId: Scalars['uuid'];
  now: Scalars['timestamptz'];
}>;


export type GetBoostableProgramsQuery = { __typename?: 'query_root', lessons: Array<{ __typename?: 'Lessons', id: any, title: string, startDateTime?: any | null, sport: SportsEnum, type: LessonTypesEnum, coverImageProviderUrl: string, ownerProfile?: { __typename?: 'UserProfiles', fullName?: string | null } | null }>, events: Array<{ __typename?: 'Events', id: any, title: string, startDateTime: any, sport: SportsEnum, type: EventTypesEnum, coverImageProviderUrl?: string | null, sourceOrganizerTitle?: string | null, hostUserProfile?: { __typename?: 'UserProfiles', fullName?: string | null } | null }> };

export type GetCalendarAccountByEmailQueryVariables = Exact<{
  email: Scalars['String'];
}>;


export type GetCalendarAccountByEmailQuery = { __typename?: 'query_root', calendarAccounts: Array<{ __typename?: 'CalendarAccounts', id: any, email?: string | null, provider: CalendarAuthProviderEnum, accessToken: string, refreshToken?: string | null, expiresAt?: any | null, createdAt: any, updatedAt: any, userId: any }> };

export type GetCalendarEventMappingQueryVariables = Exact<{
  lessonId: Scalars['uuid'];
}>;


export type GetCalendarEventMappingQuery = { __typename?: 'query_root', calendarEventMappings: Array<{ __typename?: 'CalendarEventMappings', id: any, lessonId: any, externalEventId: string, calendarPreferenceId: any }> };

export type GetCalendarTokenQueryVariables = Exact<{
  userId: Scalars['uuid'];
}>;


export type GetCalendarTokenQuery = { __typename?: 'query_root', calendarAccounts: Array<{ __typename?: 'CalendarAccounts', accessToken: string, refreshToken?: string | null, expiresAt?: any | null }> };

export type GetCityClinicsQueryVariables = Exact<{
  distance: Scalars['Float'];
  from: Scalars['geography'];
  sport: SportsEnum;
  startDate: Scalars['timestamptz'];
  endDate: Scalars['timestamptz'];
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetCityClinicsQuery = { __typename?: 'query_root', lessons: Array<{ __typename?: 'Lessons', title: string, id: any, startDateTime?: any | null, endDateTime?: any | null, timezoneName: string, timezoneAbbreviation: string, description: string, sport: SportsEnum, type: LessonTypesEnum, intendedAgeGroup?: EventAgeGroupsEnum | null, externalBookingUrl: string, externalSource?: string | null, coverImageProviderUrl: string, priceUnitAmount: number, currency: string, participantLimit?: number | null, skillLevels: Array<{ __typename?: 'LessonSkillLevels', id: any, skillLevel: string }>, ownerProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, profileImageUrl?: string | null, username?: string | null, isProfessionalRacquetRegistryActive?: boolean | null, priceUnitAmountCoachDefault?: number | null, stripeMerchantCurrency?: string | null, currencyCoachDefault?: string | null, coachReviewsAggregate: { __typename?: 'ReviewsAggregate', aggregate?: { __typename?: 'ReviewsAggregateFields', count: number, avg?: { __typename?: 'ReviewsAvgFields', rating?: number | null } | null } | null } } | null, participants: Array<{ __typename?: 'LessonParticipants', id: any, userProfile?: { __typename?: 'UserProfiles', fullName?: string | null, profileImagePath?: string | null } | null }>, userCustomCourt?: { __typename?: 'UserCustomCourts', fullAddress: string } | null, venue?: { __typename?: 'Venues', id: any, addressString: string, latitude: any, longitude: any, geometry?: any | null, timezone: string, title: string, indoorCourtCount: number, outdoorCourtCount: number, images: Array<{ __typename?: 'VenueImages', id: any, url: string, path: string, provider: string, fileName: string }> } | null }> };

export type GetCityCoachesQueryVariables = Exact<{
  distance: Scalars['Float'];
  from: Scalars['geography'];
  sport: SportsEnum;
  defaultSport: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetCityCoachesQuery = { __typename?: 'query_root', userProfiles: Array<{ __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, priceUnitAmountRemoteCoachDefault?: number | null, priceUnitAmountCoachDefault?: number | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProvider?: string | null, profileImageProviderUrl?: string | null, preferredName?: string | null, username?: string | null, defaultSport?: string | null, geometry?: any | null, isPprMember?: boolean | null, isPciMember?: boolean | null, isProfessionalRacquetRegistryActive?: boolean | null, gender?: string | null, stripeMerchantChargesEnabled?: boolean | null, stripeMerchantCurrency?: string | null, currencyCoachDefault?: string | null, coachReviewsAggregate: { __typename?: 'ReviewsAggregate', aggregate?: { __typename?: 'ReviewsAggregateFields', count: number, avg?: { __typename?: 'ReviewsAvgFields', rating?: number | null } | null } | null }, coachLessonsAggregate: { __typename?: 'LessonsAggregate', aggregate?: { __typename?: 'LessonsAggregateFields', count: number } | null }, coachSports: Array<{ __typename?: 'CoachSports', sport: SportsEnum }>, coachLessonSkillLevels: Array<{ __typename?: 'CoachLessonSkillLevels', skillLevel: string }>, coachLessonAgeGroups: Array<{ __typename?: 'CoachLessonAgeGroups', lessonAgeGroup: LessonAgeGroupsEnum }>, coachAvailability: Array<{ __typename?: 'CoachAvailability', id: any, status: CoachAvailabilityStatusesEnum }>, defaultCoachVenue?: { __typename?: 'Venues', addressString: string, id: any } | null, defaultCoachCustomCourt?: { __typename?: 'UserCustomCourts', title: string, id: any, fullAddress: string } | null, followersAggregate: { __typename?: 'UserFollowsAggregate', aggregate?: { __typename?: 'UserFollowsAggregateFields', count: number } | null }, activeCity?: { __typename?: 'Cities', id: any, name: string, countrySubdivision: { __typename?: 'CountrySubdivisions', id: any, name: string, country: { __typename?: 'Countries', id: string, iso3: string } } } | null }>, coachStarterProfiles: Array<{ __typename?: 'CoachStarterProfiles', id: any, name?: string | null, profileImageUrl?: string | null, aboutPhotoImageUrl?: string | null, logoImageUrl?: string | null, geometry?: any | null }> };

export type GetCityPageContentByCitySlugQueryVariables = Exact<{
  slug: Scalars['String'];
  limit: Scalars['Int'];
}>;


export type GetCityPageContentByCitySlugQuery = { __typename?: 'query_root', cities: Array<{ __typename?: 'Cities', id: any, latitude: any, longitude: any, name: string, slug: string, timezone?: string | null, venues: Array<{ __typename?: 'Venues', accessType?: VenueAccessTypesEnum | null, addressString: string, id: any, pickleballNets?: VenueNetsEnum | null, slug: string, outdoorCourtCount: number, indoorCourtCount: number, title: string, images: Array<{ __typename?: 'VenueImages', id: any, isVisible: boolean, fileName: string, fileType?: string | null, path: string, provider: string, url: string }> }>, events: Array<{ __typename?: 'Events', addressString?: string | null, coverImagePath?: string | null, coverImageUrl?: string | null, displayLocation: string, description: string, endDateTime: any, hasPrizes: boolean, id: any, latitude?: any | null, locale: string, longitude?: any | null, organizerImagePath?: string | null, registrationClosedAt?: any | null, registrationDeadlineDate: any, registrationPriceUnitAmount: number, scoringFormat?: ScoringFormatEnum | null, slug: string, isExternal: boolean, sourceRegistrationCount: number, sourceOrganizerTitle?: string | null, startDateTime: any, status: EventStatusesEnum, timezoneAbbreviation: string, timezoneName: string, timezoneOffsetMinutes: number, title: string, geometry?: any | null, city?: { __typename?: 'Cities', name: string, id: any, timezone?: string | null, countrySubdivision: { __typename?: 'CountrySubdivisions', name: string, id: any, code: string } } | null, registrationsAggregate: { __typename?: 'EventRegistrationsAggregate', aggregate?: { __typename?: 'EventRegistrationsAggregateFields', count: number } | null }, venue?: { __typename?: 'Venues', id: any, title: string, venueSlug: string, slug: string, addressString: string, pickleballLines?: VenueLinesEnum | null, pickleballNets?: VenueNetsEnum | null, longitude: any, latitude: any, geometry?: any | null, outdoorCourtCount: number, indoorCourtCount: number, timezone: string, images: Array<{ __typename?: 'VenueImages', id: any, path: string, url: string }>, courtSurfaces: Array<{ __typename?: 'VenueCourtSurfaces', id: any, courtSurface: CourtSurfacesEnum }> } | null }>, countrySubdivision: { __typename?: 'CountrySubdivisions', id: any, name: string, slug: string, country: { __typename?: 'Countries', id: string, name: string, nameSlug: string, slug: string } }, coaches: Array<{ __typename?: 'Users', id: any, fullName: string, priceUnitAmountCoachDefault?: number | null, profileImageFileName: string, profileImagePath: string, profileImageProvider: string, profileImageProviderUrl: string, preferredName: string, username?: string | null, geometry?: any | null, stripeMerchantCurrency?: string | null, currencyCoachDefault: string, defaultSport?: SportsEnum | null, isProfessionalRacquetRegistryActive: boolean, gender?: GenderEnum | null, stripeMerchantChargesEnabled: boolean, coachLessonsAggregate: { __typename?: 'LessonsAggregate', aggregate?: { __typename?: 'LessonsAggregateFields', count: number } | null }, coachSports: Array<{ __typename?: 'CoachSports', sport: SportsEnum }>, coachLessonSkillLevels: Array<{ __typename?: 'CoachLessonSkillLevels', skillLevel: string }>, coachAvailability: Array<{ __typename?: 'CoachAvailability', id: any, status: CoachAvailabilityStatusesEnum }>, defaultCoachVenue?: { __typename?: 'Venues', addressString: string, id: any } | null, defaultCoachCustomCourt?: { __typename?: 'UserCustomCourts', title: string, id: any, fullAddress: string } | null, followersAggregate: { __typename?: 'UserFollowsAggregate', aggregate?: { __typename?: 'UserFollowsAggregateFields', count: number } | null } }>, coachStarterProfiles: Array<{ __typename?: 'CoachStarterProfiles', id: any, name?: string | null, profileImageUrl?: string | null, aboutPhotoImageUrl?: string | null, logoImageUrl?: string | null, geometry?: any | null }>, groups: Array<{ __typename?: 'Groups', id: any, slug: string, memberDisplayCount?: number | null, profilePhotoProviderUrl: string, title: string, addressString: string, latitude?: any | null, longitude?: any | null, membersAggregate: { __typename?: 'GroupMembersAggregate', aggregate?: { __typename?: 'GroupMembersAggregateFields', count: number } | null } }> }> };

export type GetPickleballCityPageContentByCitySlugQueryVariables = Exact<{
  slug: Scalars['String'];
  limit: Scalars['Int'];
}>;


export type GetPickleballCityPageContentByCitySlugQuery = { __typename?: 'query_root', cities: Array<{ __typename?: 'Cities', id: any, latitude: any, longitude: any, name: string, slug: string, timezone?: string | null, venues: Array<{ __typename?: 'Venues', accessType?: VenueAccessTypesEnum | null, addressString: string, id: any, pickleballNets?: VenueNetsEnum | null, slug: string, outdoorCourtCount: number, indoorCourtCount: number, title: string, images: Array<{ __typename?: 'VenueImages', id: any, isVisible: boolean, fileName: string, fileType?: string | null, path: string, provider: string, url: string }> }>, events: Array<{ __typename?: 'Events', addressString?: string | null, coverImagePath?: string | null, coverImageUrl?: string | null, displayLocation: string, description: string, endDateTime: any, hasPrizes: boolean, id: any, latitude?: any | null, locale: string, longitude?: any | null, organizerImagePath?: string | null, registrationClosedAt?: any | null, registrationDeadlineDate: any, registrationPriceUnitAmount: number, scoringFormat?: ScoringFormatEnum | null, slug: string, isExternal: boolean, sourceRegistrationCount: number, sourceOrganizerTitle?: string | null, startDateTime: any, status: EventStatusesEnum, timezoneAbbreviation: string, timezoneName: string, timezoneOffsetMinutes: number, title: string, geometry?: any | null, city?: { __typename?: 'Cities', name: string, id: any, timezone?: string | null, countrySubdivision: { __typename?: 'CountrySubdivisions', name: string, id: any, code: string } } | null, registrationsAggregate: { __typename?: 'EventRegistrationsAggregate', aggregate?: { __typename?: 'EventRegistrationsAggregateFields', count: number } | null }, venue?: { __typename?: 'Venues', id: any, title: string, venueSlug: string, slug: string, addressString: string, pickleballLines?: VenueLinesEnum | null, pickleballNets?: VenueNetsEnum | null, longitude: any, latitude: any, geometry?: any | null, outdoorCourtCount: number, indoorCourtCount: number, timezone: string, images: Array<{ __typename?: 'VenueImages', id: any, path: string, url: string }>, courtSurfaces: Array<{ __typename?: 'VenueCourtSurfaces', id: any, courtSurface: CourtSurfacesEnum }> } | null }>, coaches: Array<{ __typename?: 'Users', id: any, fullName: string, priceUnitAmountCoachDefault?: number | null, profileImageFileName: string, profileImagePath: string, profileImageProvider: string, profileImageProviderUrl: string, preferredName: string, username?: string | null, geometry?: any | null, stripeMerchantCurrency?: string | null, currencyCoachDefault: string, defaultSport?: SportsEnum | null, isProfessionalRacquetRegistryActive: boolean, gender?: GenderEnum | null, stripeMerchantChargesEnabled: boolean, coachLessonsAggregate: { __typename?: 'LessonsAggregate', aggregate?: { __typename?: 'LessonsAggregateFields', count: number } | null }, coachSports: Array<{ __typename?: 'CoachSports', sport: SportsEnum }>, coachLessonSkillLevels: Array<{ __typename?: 'CoachLessonSkillLevels', skillLevel: string }>, coachAvailability: Array<{ __typename?: 'CoachAvailability', id: any, status: CoachAvailabilityStatusesEnum }>, defaultCoachVenue?: { __typename?: 'Venues', addressString: string, id: any } | null, defaultCoachCustomCourt?: { __typename?: 'UserCustomCourts', title: string, id: any, fullAddress: string } | null, followersAggregate: { __typename?: 'UserFollowsAggregate', aggregate?: { __typename?: 'UserFollowsAggregateFields', count: number } | null } }>, coachStarterProfiles: Array<{ __typename?: 'CoachStarterProfiles', id: any, name?: string | null, profileImageUrl?: string | null, aboutPhotoImageUrl?: string | null, logoImageUrl?: string | null, geometry?: any | null }>, groups: Array<{ __typename?: 'Groups', id: any, slug: string, memberDisplayCount?: number | null, profilePhotoProviderUrl: string, title: string, addressString: string, latitude?: any | null, longitude?: any | null, membersAggregate: { __typename?: 'GroupMembersAggregate', aggregate?: { __typename?: 'GroupMembersAggregateFields', count: number } | null } }>, countrySubdivision: { __typename?: 'CountrySubdivisions', id: any, name: string, slug: string, country: { __typename?: 'Countries', id: string, name: string, nameSlug: string, slug: string } } }> };

export type GetTennisCityPageContentByCitySlugQueryVariables = Exact<{
  slug: Scalars['String'];
  limit: Scalars['Int'];
}>;


export type GetTennisCityPageContentByCitySlugQuery = { __typename?: 'query_root', cities: Array<{ __typename?: 'Cities', id: any, latitude: any, longitude: any, name: string, slug: string, timezone?: string | null, venues: Array<{ __typename?: 'Venues', accessType?: VenueAccessTypesEnum | null, addressString: string, id: any, pickleballNets?: VenueNetsEnum | null, slug: string, outdoorCourtCount: number, indoorCourtCount: number, title: string, images: Array<{ __typename?: 'VenueImages', id: any, isVisible: boolean, fileName: string, fileType?: string | null, path: string, provider: string, url: string }> }>, events: Array<{ __typename?: 'Events', addressString?: string | null, coverImagePath?: string | null, coverImageUrl?: string | null, displayLocation: string, description: string, endDateTime: any, hasPrizes: boolean, id: any, latitude?: any | null, locale: string, longitude?: any | null, organizerImagePath?: string | null, registrationClosedAt?: any | null, registrationDeadlineDate: any, registrationPriceUnitAmount: number, scoringFormat?: ScoringFormatEnum | null, slug: string, isExternal: boolean, sourceRegistrationCount: number, sourceOrganizerTitle?: string | null, startDateTime: any, status: EventStatusesEnum, timezoneAbbreviation: string, timezoneName: string, timezoneOffsetMinutes: number, title: string, geometry?: any | null, city?: { __typename?: 'Cities', name: string, id: any, timezone?: string | null, countrySubdivision: { __typename?: 'CountrySubdivisions', name: string, id: any, code: string } } | null, registrationsAggregate: { __typename?: 'EventRegistrationsAggregate', aggregate?: { __typename?: 'EventRegistrationsAggregateFields', count: number } | null }, venue?: { __typename?: 'Venues', id: any, title: string, venueSlug: string, slug: string, addressString: string, pickleballLines?: VenueLinesEnum | null, pickleballNets?: VenueNetsEnum | null, longitude: any, latitude: any, geometry?: any | null, outdoorCourtCount: number, indoorCourtCount: number, timezone: string, images: Array<{ __typename?: 'VenueImages', id: any, path: string, url: string }>, courtSurfaces: Array<{ __typename?: 'VenueCourtSurfaces', id: any, courtSurface: CourtSurfacesEnum }> } | null }>, coaches: Array<{ __typename?: 'Users', id: any, fullName: string, priceUnitAmountCoachDefault?: number | null, profileImageFileName: string, profileImagePath: string, profileImageProvider: string, profileImageProviderUrl: string, preferredName: string, username?: string | null, geometry?: any | null, stripeMerchantCurrency?: string | null, currencyCoachDefault: string, defaultSport?: SportsEnum | null, isProfessionalRacquetRegistryActive: boolean, gender?: GenderEnum | null, stripeMerchantChargesEnabled: boolean, coachLessonsAggregate: { __typename?: 'LessonsAggregate', aggregate?: { __typename?: 'LessonsAggregateFields', count: number } | null }, coachSports: Array<{ __typename?: 'CoachSports', sport: SportsEnum }>, coachLessonSkillLevels: Array<{ __typename?: 'CoachLessonSkillLevels', skillLevel: string }>, coachAvailability: Array<{ __typename?: 'CoachAvailability', id: any, status: CoachAvailabilityStatusesEnum }>, defaultCoachVenue?: { __typename?: 'Venues', addressString: string, id: any } | null, defaultCoachCustomCourt?: { __typename?: 'UserCustomCourts', title: string, id: any, fullAddress: string } | null, followersAggregate: { __typename?: 'UserFollowsAggregate', aggregate?: { __typename?: 'UserFollowsAggregateFields', count: number } | null } }>, coachStarterProfiles: Array<{ __typename?: 'CoachStarterProfiles', id: any, name?: string | null, profileImageUrl?: string | null, aboutPhotoImageUrl?: string | null, logoImageUrl?: string | null, geometry?: any | null }>, groups: Array<{ __typename?: 'Groups', id: any, slug: string, memberDisplayCount?: number | null, profilePhotoProviderUrl: string, title: string, addressString: string, latitude?: any | null, longitude?: any | null, membersAggregate: { __typename?: 'GroupMembersAggregate', aggregate?: { __typename?: 'GroupMembersAggregateFields', count: number } | null } }>, countrySubdivision: { __typename?: 'CountrySubdivisions', id: any, name: string, slug: string, country: { __typename?: 'Countries', id: string, name: string, nameSlug: string, slug: string } } }> };

export type GetCityVenuesByCitySlugQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type GetCityVenuesByCitySlugQuery = { __typename?: 'query_root', cities: Array<{ __typename?: 'Cities', id: any, latitude: any, longitude: any, name: string, slug: string, timezone?: string | null, venues: Array<{ __typename?: 'Venues', accessType?: VenueAccessTypesEnum | null, addressString: string, id: any, pickleballNets?: VenueNetsEnum | null, slug: string, outdoorCourtCount: number, indoorCourtCount: number, title: string, geometry?: any | null, images: Array<{ __typename?: 'VenueImages', id: any, isVisible: boolean, fileName: string, fileType?: string | null, path: string, provider: string, url: string }> }>, countrySubdivision: { __typename?: 'CountrySubdivisions', id: any, name: string, slug: string, country: { __typename?: 'Countries', id: string, name: string, nameSlug: string, slug: string } } }> };

export type GetCityPickleballVenuesByCitySlugQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type GetCityPickleballVenuesByCitySlugQuery = { __typename?: 'query_root', cities: Array<{ __typename?: 'Cities', id: any, latitude: any, longitude: any, name: string, slug: string, timezone?: string | null, venues: Array<{ __typename?: 'Venues', accessType?: VenueAccessTypesEnum | null, addressString: string, id: any, pickleballNets?: VenueNetsEnum | null, slug: string, outdoorCourtCount: number, indoorCourtCount: number, title: string, geometry?: any | null, images: Array<{ __typename?: 'VenueImages', id: any, isVisible: boolean, fileName: string, fileType?: string | null, path: string, provider: string, url: string }> }>, countrySubdivision: { __typename?: 'CountrySubdivisions', id: any, name: string, slug: string, country: { __typename?: 'Countries', id: string, name: string, nameSlug: string, slug: string } } }> };

export type GetCityTennisVenuesByCitySlugQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type GetCityTennisVenuesByCitySlugQuery = { __typename?: 'query_root', cities: Array<{ __typename?: 'Cities', id: any, latitude: any, longitude: any, name: string, slug: string, timezone?: string | null, venues: Array<{ __typename?: 'Venues', accessType?: VenueAccessTypesEnum | null, addressString: string, id: any, pickleballNets?: VenueNetsEnum | null, slug: string, outdoorCourtCount: number, indoorCourtCount: number, title: string, geometry?: any | null, images: Array<{ __typename?: 'VenueImages', id: any, isVisible: boolean, fileName: string, fileType?: string | null, path: string, provider: string, url: string }> }>, countrySubdivision: { __typename?: 'CountrySubdivisions', id: any, name: string, slug: string, country: { __typename?: 'Countries', id: string, name: string, nameSlug: string, slug: string } } }> };

export type GetCoachActivationReportQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCoachActivationReportQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'Users', id: any, email: string, fullName: string, preferredName: string, username?: string | null, gender?: GenderEnum | null, phoneNumber?: string | null, phoneCountryCode?: string | null, cityName: string, createdAt: any, latitude?: any | null, longitude?: any | null, geometry?: any | null, lastLoginAt?: any | null, profileImagePath: string, priceUnitAmountCoachDefault?: number | null, activeCity?: { __typename?: 'Cities', id: any, name: string, countrySubdivision: { __typename?: 'CountrySubdivisions', name: string } } | null, coachAvailabilityAggregate: { __typename?: 'CoachAvailabilityAggregate', aggregate?: { __typename?: 'CoachAvailabilityAggregateFields', count: number } | null } }> };

export type GetCoachBookingPageQueryVariables = Exact<{
  username: Scalars['String'];
  id: Scalars['uuid'];
  startDateTime: Scalars['timestamptz'];
}>;


export type GetCoachBookingPageQuery = { __typename?: 'query_root', userProfiles: Array<{ __typename?: 'UserProfiles', id?: any | null, username?: string | null, defaultSport?: string | null, stripeMerchantChargesEnabled?: boolean | null, timezone?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, profileImageProvider?: string | null, profileImageProviderId?: string | null, profileImageUrl?: string | null, tiktokUrl?: string | null, xUrl?: string | null, websiteUrl?: string | null, facebookUrl?: string | null, instagramUrl?: string | null, linkedinUrl?: string | null, youtubeUrl?: string | null, preferredName?: string | null, fullName?: string | null, coachStatus?: string | null, coverImageFileName?: string | null, coverImagePath?: string | null, coverImageProviderUrl?: string | null, aboutMe?: string | null, aboutMeVideoUrl?: string | null, cityName?: string | null, gender?: string | null, coachExternalBookingUrl?: string | null, stripeMerchantCurrency?: string | null, currencyCoachDefault?: string | null, coachingStartYear?: number | null, normalizedTennisRating?: any | null, tennisRating?: any | null, pciId?: string | null, pprId?: string | null, isPciMember?: boolean | null, isIptpaMember?: boolean | null, iptpaId?: string | null, isQuatroPickleballMember?: boolean | null, quatroPickleballMemberId?: string | null, coachLessonDescription?: string | null, coachLessonHowToPrepare?: string | null, priceUnitAmountCoachDefault?: number | null, priceUnitAmountRemoteCoachDefault?: number | null, stripeMerchantDetailsSubmitted?: boolean | null, coachSports: Array<{ __typename?: 'CoachSports', sport: SportsEnum }>, activeCity?: { __typename?: 'Cities', id: any, name: string, geometry?: any | null, countrySubdivision: { __typename?: 'CountrySubdivisions', name: string } } | null, country?: { __typename?: 'Countries', id: string, iso2: string, iso3: string, name: string } | null, countrySubdivision?: { __typename?: 'CountrySubdivisions', code: string, id: any, name: string, type: string } | null, coachLessonsAggregate: { __typename?: 'LessonsAggregate', aggregate?: { __typename?: 'LessonsAggregateFields', count: number } | null }, followersAggregate: { __typename?: 'UserFollowsAggregate', aggregate?: { __typename?: 'UserFollowsAggregateFields', count: number } | null }, followers: Array<{ __typename?: 'UserFollows', followerUserId: any, followedUserId: any, followerProfile?: { __typename?: 'UserProfiles', id?: any | null, username?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, fullName?: string | null, preferredName?: string | null } | null }>, coachServices: Array<{ __typename?: 'UserCoachServices', currency: string, description: string, id: any, title: string, priceUnitAmount: number, type?: LessonTypesEnum | null, coverImageFileName: string, coverImagePath: string, coverImageProviderUrl: string }>, coachAvailability: Array<{ __typename?: 'CoachAvailability', id: any, endTimeMinutes: number, dayOfWeek: DayOfWeekEnum, startTimeMinutes: number, status: CoachAvailabilityStatusesEnum, coachAvailabilityCustomCourt?: { __typename?: 'UserCustomCourts', id: any } | null, coachAvailabilityVenueId?: { __typename?: 'Venues', id: any } | null }>, coachQualifications: Array<{ __typename?: 'UsersCoachQualifications', id: any, status: CoachQualificationStatusesEnum, qualification: { __typename?: 'CoachQualifications', id: any, name: string, order: number, groupId?: CoachQualificationGroupsEnum | null, displayKey: string } }>, normalizedTennisRatingScale?: { __typename?: 'TennisRatingScales', id: any, name: string, shortName: string } | null, tennisRatingScale?: { __typename?: 'TennisRatingScales', id: any, name: string, shortName: string } | null, tennisSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum, isDisplayed: boolean, rank: number, displayName: string } | null, pickleballSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum, isDisplayed: boolean, rank: number, displayName: string } | null, coachLessonAgeGroups: Array<{ __typename?: 'CoachLessonAgeGroups', lessonAgeGroup: LessonAgeGroupsEnum }>, coachLessonSkillLevels: Array<{ __typename?: 'CoachLessonSkillLevels', id: any, skillLevel: string }>, defaultCoachVenue?: { __typename?: 'Venues', id: any, addressString: string, isActive: boolean, latitude: any, longitude: any, outdoorCourtCount: number, geometry?: any | null, indoorCourtCount: number, slug: string, timezone: string, title: string, images: Array<{ __typename?: 'VenueImages', id: any, url: string, path: string, provider: string, fileName: string }> } | null, pickleballRatingScales: Array<{ __typename?: 'UserPickleballRatingScales', id: any, rating: any, pickleballRatingScaleId: any, scale: { __typename?: 'PickleballRatingScales', name: string, id: any, shortName: string } }>, defaultCoachCustomCourt?: { __typename?: 'UserCustomCourts', id: any, fullAddress: string, title: string, latitude?: any | null, longitude?: any | null } | null, coachLessons: Array<{ __typename?: 'Lessons', id: any, ownerUserId?: any | null, startDateTime?: any | null, endDateTime?: any | null, timezoneName: string, timezoneAbbreviation: string, timezoneOffsetMinutes: number, participantLimit?: number | null, currency: string }>, userFiles: Array<{ __typename?: 'UserFiles', fileCategory: FileCategoryEnum, fileFormat: FileFormatEnum, fileName: string, fileType: string, host: string, path: string, originalFileName?: string | null, provider: string, providerId: string, providerUrl: string, url: string }> }>, coachStarterProfilesByPk?: { __typename?: 'CoachStarterProfiles', aboutMe?: string | null, aboutPhotoImageUrl?: string | null, age?: string | null, birthdate?: string | null, addressDisplay?: string | null, addressString?: string | null, addressType?: string | null, cityName?: string | null, company?: string | null, countryName?: string | null, geometry?: any | null, id: any, gender?: string | null, latitude?: any | null, level?: string | null, longitude?: any | null, logoImageUrl?: string | null, name?: string | null, position?: string | null, profileImageUrl?: string | null, stateName?: string | null, usapRating?: string | null, facebook?: string | null, instagram?: string | null, twitter?: string | null, youtube?: string | null, linkedin?: string | null } | null };

export type GetCoachBookingRequestsCountForTodayQueryVariables = Exact<{
  playerUserId: Scalars['uuid'];
  startOfDay: Scalars['timestamptz'];
  endOfDay: Scalars['timestamptz'];
}>;


export type GetCoachBookingRequestsCountForTodayQuery = { __typename?: 'query_root', coachBookingRequestsAggregate: { __typename?: 'CoachBookingRequestsAggregate', aggregate?: { __typename?: 'CoachBookingRequestsAggregateFields', count: number } | null } };

export type GetCoachByEmailQueryVariables = Exact<{
  email: Scalars['String'];
}>;


export type GetCoachByEmailQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'Users', id: any, fullName: string, username?: string | null, profileImageUrl: string, coachStatus?: CoachStatusEnum | null, activeCity?: { __typename?: 'Cities', name: string, countrySubdivision: { __typename?: 'CountrySubdivisions', name: string } } | null }> };

export type GetCoachContactInfoQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetCoachContactInfoQuery = { __typename?: 'query_root', usersByPk?: { __typename?: 'Users', id: any, email: string, fullName: string, preferredName: string, defaultSport?: SportsEnum | null } | null };

export type GetCoachContactInfoByEmailQueryVariables = Exact<{
  email: Scalars['String'];
}>;


export type GetCoachContactInfoByEmailQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'Users', id: any, email: string, fullName: string, preferredName: string, defaultSport?: SportsEnum | null }> };

export type GetCoachStatusAndSlotsQueryVariables = Exact<{
  id: Scalars['uuid'];
  startDateTime: Scalars['timestamptz'];
}>;


export type GetCoachStatusAndSlotsQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'Users', id: any, username?: string | null, locale?: string | null, timezone?: string | null, defaultSport?: SportsEnum | null, defaultCoachVenueId?: any | null, defaultCoachUserCustomCourtId?: any | null, currencyCoachDefault: string, stripeMerchantCurrency?: string | null, stripeMerchantId?: string | null, coachAvailability: Array<{ __typename?: 'CoachAvailability', id: any, endTimeMinutes: number, dayOfWeek: DayOfWeekEnum, startTimeMinutes: number }>, coachLessons: Array<{ __typename?: 'Lessons', id: any, ownerUserId?: any | null, startDateTime?: any | null, endDateTime?: any | null, timezoneName: string, timezoneAbbreviation: string, timezoneOffsetMinutes: number, participantLimit?: number | null, currency: string }> }> };

export type GetCoachesForExternalListingsQueryVariables = Exact<{
  from: Scalars['geography'];
  distance: Scalars['Float'];
  sport: SportsEnum;
}>;


export type GetCoachesForExternalListingsQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'Users', id: any, geometry?: any | null, latitude?: any | null, longitude?: any | null, isProfessionalRacquetRegistryActive: boolean, priceUnitAmountCoachDefault?: number | null, preferredName: string, fullName: string, gender?: GenderEnum | null, genderPreference: string, email: string, defaultSport?: SportsEnum | null, profileImageFileName: string, profileImagePath: string, profileImageProviderId: string, profileImageProvider: string, profileImageProviderUrl: string, profileImageUrl: string, stripeMerchantId?: string | null, stripeMerchantChargesEnabled: boolean, stripeMerchantCurrency?: string | null, currencyCoachDefault: string, username?: string | null, aboutMe?: string | null, followersAggregate: { __typename?: 'UserFollowsAggregate', aggregate?: { __typename?: 'UserFollowsAggregateFields', count: number } | null }, coachSports: Array<{ __typename?: 'CoachSports', sport: SportsEnum, id: any, status: CoachSportStatusesEnum }>, coachLessonsAggregate: { __typename?: 'LessonsAggregate', aggregate?: { __typename?: 'LessonsAggregateFields', count: number } | null }, coachAvailabilityAggregate: { __typename?: 'CoachAvailabilityAggregate', aggregate?: { __typename?: 'CoachAvailabilityAggregateFields', count: number } | null }, activeCity?: { __typename?: 'Cities', id: any, name: string, countrySubdivision: { __typename?: 'CountrySubdivisions', id: any, name: string, country: { __typename?: 'Countries', id: string, iso3: string } } } | null }> };

export type GetConnectedUserIdsQueryVariables = Exact<{
  userId: Scalars['uuid'];
  otherUserIds: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type GetConnectedUserIdsQuery = { __typename?: 'query_root', userConnections: Array<{ __typename?: 'UserConnections', id: any, userAId: any, userBId: any }> };

export type GetConnectedVenueBookingIntegrationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetConnectedVenueBookingIntegrationsQuery = { __typename?: 'query_root', venueBookingIntegrations: Array<{ __typename?: 'VenueBookingIntegrations', id: any, bookingSystem: BookingSystemsEnum, externalOrgId?: string | null, providerApiKeyEncrypted?: string | null, readVerifiedAt?: any | null, venue: { __typename?: 'Venues', title: string } }> };

export type GetConnectionPairStateQueryVariables = Exact<{
  viewerId: Scalars['uuid'];
  otherUserId: Scalars['uuid'];
  lowId: Scalars['uuid'];
  highId: Scalars['uuid'];
}>;


export type GetConnectionPairStateQuery = { __typename?: 'query_root', otherUser: Array<{ __typename?: 'UserProfiles', id?: any | null, deletedAt?: any | null }>, userConnections: Array<{ __typename?: 'UserConnections', id: any }>, blocks: Array<{ __typename?: 'UserBlocks', id: any, blockerUserId: any, blockedUserId: any }>, outgoing: Array<{ __typename?: 'UserConnectionRequests', id: any, status: UserConnectionRequestStatusesEnum, attemptNumber: any }>, incoming: Array<{ __typename?: 'UserConnectionRequests', id: any, status: UserConnectionRequestStatusesEnum, attemptNumber: any }> };

export type GetConnectionRequestByIdQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetConnectionRequestByIdQuery = { __typename?: 'query_root', userConnectionRequestsByPk?: { __typename?: 'UserConnectionRequests', id: any, requesterUserId: any, recipientUserId: any, status: UserConnectionRequestStatusesEnum, attemptNumber: any, deletedAt?: any | null } | null };

export type GetConnectionRequestForNotificationQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetConnectionRequestForNotificationQuery = { __typename?: 'query_root', userConnectionRequestsByPk?: { __typename?: 'UserConnectionRequests', id: any, requesterUserId: any, recipientUserId: any, requester: { __typename?: 'Users', id: any, email: string, fullName: string, preferredName: string }, recipient: { __typename?: 'Users', id: any, email: string, fullName: string, preferredName: string }, requesterProfile?: { __typename?: 'UserProfiles', id?: any | null, username?: string | null, cityName?: string | null } | null, recipientProfile?: { __typename?: 'UserProfiles', id?: any | null, username?: string | null, cityName?: string | null } | null } | null };

export type GetConversationForParticipantQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetConversationForParticipantQuery = { __typename?: 'query_root', conversations: Array<{ __typename?: 'Conversations', id: any, type: ConversationTypesEnum, participants: Array<{ __typename?: 'ConversationParticipants', userId: any }> }> };

export type GetCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCountriesQuery = { __typename?: 'query_root', countries: Array<{ __typename?: 'Countries', id: string, name: string, slug: string }> };

export type GetCountryPageByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetCountryPageByIdQuery = { __typename?: 'query_root', countriesByPk?: { __typename?: 'Countries', id: string, iso2: string, iso3: string, slug: string, name: string, latitude: any, longitude: any, subdivisions: Array<{ __typename?: 'CountrySubdivisions', id: any, name: string, slug: string, cities: Array<{ __typename?: 'Cities', id: any, name: string, slug: string, venuesAggregate: { __typename?: 'VenuesAggregate', aggregate?: { __typename?: 'VenuesAggregateFields', count: number } | null } }> }> } | null };

export type GetCountrySubdivisionPageQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type GetCountrySubdivisionPageQuery = { __typename?: 'query_root', countrySubdivisions: Array<{ __typename?: 'CountrySubdivisions', id: any, latitude?: any | null, longitude?: any | null, name: string, slug: string, type: string, country: { __typename?: 'Countries', id: string, name: string, nameSlug: string, slug: string }, cities: Array<{ __typename?: 'Cities', id: any, name: string, latitude: any, longitude: any, slug: string, venues: Array<{ __typename?: 'Venues', id: any, latitude: any, longitude: any, slug: string, addressString: string, title: string, indoorCourtCount: number, outdoorCourtCount: number }>, events: Array<{ __typename?: 'Events', addressString?: string | null, coverImagePath?: string | null, coverImageUrl?: string | null, displayLocation: string, description: string, endDateTime: any, hasPrizes: boolean, id: any, latitude?: any | null, locale: string, longitude?: any | null, organizerImagePath?: string | null, registrationClosedAt?: any | null, registrationDeadlineDate: any, registrationPriceUnitAmount: number, scoringFormat?: ScoringFormatEnum | null, slug: string, isExternal: boolean, sourceRegistrationCount: number, sourceOrganizerTitle?: string | null, startDateTime: any, status: EventStatusesEnum, timezoneAbbreviation: string, timezoneName: string, timezoneOffsetMinutes: number, title: string, geometry?: any | null, city?: { __typename?: 'Cities', name: string, id: any, timezone?: string | null, countrySubdivision: { __typename?: 'CountrySubdivisions', name: string, id: any, code: string } } | null, registrationsAggregate: { __typename?: 'EventRegistrationsAggregate', aggregate?: { __typename?: 'EventRegistrationsAggregateFields', count: number } | null }, venue?: { __typename?: 'Venues', id: any, title: string, venueSlug: string, slug: string, addressString: string, pickleballLines?: VenueLinesEnum | null, pickleballNets?: VenueNetsEnum | null, longitude: any, latitude: any, geometry?: any | null, outdoorCourtCount: number, indoorCourtCount: number, timezone: string, images: Array<{ __typename?: 'VenueImages', id: any, path: string, url: string }>, courtSurfaces: Array<{ __typename?: 'VenueCourtSurfaces', id: any, courtSurface: CourtSurfacesEnum }> } | null }> }> }> };

export type GetPickleballCountrySubdivisionPageQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type GetPickleballCountrySubdivisionPageQuery = { __typename?: 'query_root', countrySubdivisions: Array<{ __typename?: 'CountrySubdivisions', id: any, latitude?: any | null, longitude?: any | null, name: string, slug: string, type: string, country: { __typename?: 'Countries', id: string, name: string, nameSlug: string, slug: string }, cities: Array<{ __typename?: 'Cities', id: any, name: string, latitude: any, longitude: any, slug: string, venues: Array<{ __typename?: 'Venues', id: any, latitude: any, longitude: any, slug: string, addressString: string, title: string, indoorCourtCount: number, outdoorCourtCount: number }>, events: Array<{ __typename?: 'Events', addressString?: string | null, coverImagePath?: string | null, coverImageUrl?: string | null, displayLocation: string, description: string, endDateTime: any, hasPrizes: boolean, id: any, latitude?: any | null, locale: string, longitude?: any | null, organizerImagePath?: string | null, registrationClosedAt?: any | null, registrationDeadlineDate: any, registrationPriceUnitAmount: number, scoringFormat?: ScoringFormatEnum | null, slug: string, isExternal: boolean, sourceRegistrationCount: number, sourceOrganizerTitle?: string | null, startDateTime: any, status: EventStatusesEnum, timezoneAbbreviation: string, timezoneName: string, timezoneOffsetMinutes: number, title: string, geometry?: any | null, city?: { __typename?: 'Cities', name: string, id: any, timezone?: string | null, countrySubdivision: { __typename?: 'CountrySubdivisions', name: string, id: any, code: string } } | null, registrationsAggregate: { __typename?: 'EventRegistrationsAggregate', aggregate?: { __typename?: 'EventRegistrationsAggregateFields', count: number } | null }, venue?: { __typename?: 'Venues', id: any, title: string, venueSlug: string, slug: string, addressString: string, pickleballLines?: VenueLinesEnum | null, pickleballNets?: VenueNetsEnum | null, longitude: any, latitude: any, geometry?: any | null, outdoorCourtCount: number, indoorCourtCount: number, timezone: string, images: Array<{ __typename?: 'VenueImages', id: any, path: string, url: string }>, courtSurfaces: Array<{ __typename?: 'VenueCourtSurfaces', id: any, courtSurface: CourtSurfacesEnum }> } | null }> }> }> };

export type GetTennisCountrySubdivisionPageQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type GetTennisCountrySubdivisionPageQuery = { __typename?: 'query_root', countrySubdivisions: Array<{ __typename?: 'CountrySubdivisions', id: any, latitude?: any | null, longitude?: any | null, name: string, slug: string, type: string, country: { __typename?: 'Countries', id: string, name: string, nameSlug: string, slug: string }, cities: Array<{ __typename?: 'Cities', id: any, name: string, latitude: any, longitude: any, slug: string, venues: Array<{ __typename?: 'Venues', id: any, latitude: any, longitude: any, slug: string, addressString: string, title: string, indoorCourtCount: number, outdoorCourtCount: number }>, events: Array<{ __typename?: 'Events', addressString?: string | null, coverImagePath?: string | null, coverImageUrl?: string | null, displayLocation: string, description: string, endDateTime: any, hasPrizes: boolean, id: any, latitude?: any | null, locale: string, longitude?: any | null, organizerImagePath?: string | null, registrationClosedAt?: any | null, registrationDeadlineDate: any, registrationPriceUnitAmount: number, scoringFormat?: ScoringFormatEnum | null, slug: string, isExternal: boolean, sourceRegistrationCount: number, sourceOrganizerTitle?: string | null, startDateTime: any, status: EventStatusesEnum, timezoneAbbreviation: string, timezoneName: string, timezoneOffsetMinutes: number, title: string, geometry?: any | null, city?: { __typename?: 'Cities', name: string, id: any, timezone?: string | null, countrySubdivision: { __typename?: 'CountrySubdivisions', name: string, id: any, code: string } } | null, registrationsAggregate: { __typename?: 'EventRegistrationsAggregate', aggregate?: { __typename?: 'EventRegistrationsAggregateFields', count: number } | null }, venue?: { __typename?: 'Venues', id: any, title: string, venueSlug: string, slug: string, addressString: string, pickleballLines?: VenueLinesEnum | null, pickleballNets?: VenueNetsEnum | null, longitude: any, latitude: any, geometry?: any | null, outdoorCourtCount: number, indoorCourtCount: number, timezone: string, images: Array<{ __typename?: 'VenueImages', id: any, path: string, url: string }>, courtSurfaces: Array<{ __typename?: 'VenueCourtSurfaces', id: any, courtSurface: CourtSurfacesEnum }> } | null }> }> }> };

export type GetCountrySubdivisionPathsQueryVariables = Exact<{
  activeCountryId: Scalars['String'];
}>;


export type GetCountrySubdivisionPathsQuery = { __typename?: 'query_root', countrySubdivisions: Array<{ __typename?: 'CountrySubdivisions', id: any, name: string, slug: string, cities: Array<{ __typename?: 'Cities', id: any, name: string, slug: string, venues: Array<{ __typename?: 'Venues', id: any }> }> }> };

export type GetDefaultCalendarPreferenceQueryVariables = Exact<{
  userId: Scalars['uuid'];
}>;


export type GetDefaultCalendarPreferenceQuery = { __typename?: 'query_root', calendarPreferences: Array<{ __typename?: 'CalendarPreferences', id: any, calendarId: string, calendarName: string, isDefault?: boolean | null, calendarAccount: { __typename?: 'CalendarAccounts', id: any, accessToken: string, refreshToken?: string | null, expiresAt?: any | null } }> };

export type ClubAreaPlayersQueryVariables = Exact<{
  from: Scalars['geography'];
  distance: Scalars['Float'];
  limit: Scalars['Int'];
}>;


export type ClubAreaPlayersQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'Users', id: any, birthday?: any | null, profile?: { __typename?: 'UserProfiles', gender?: string | null, defaultSport?: string | null, pickleballSkillLevelId?: string | null, tennisSkillLevelId?: string | null } | null }> };

export type GetDuePartnerBookingAttemptsQueryVariables = Exact<{
  now: Scalars['timestamptz'];
  limit: Scalars['Int'];
}>;


export type GetDuePartnerBookingAttemptsQuery = { __typename?: 'query_root', partnerBookingAttempts: Array<{ __typename?: 'PartnerBookingAttempts', id: any, dispatchedAt?: any | null, deadlineAt?: any | null, order: { __typename?: 'PartnerBookingOrders', id: any, venueId: any, marker: string, providerCourtId?: string | null, startAt: any, endAt: any, localDate: any, startLocal: any, timezone: string, maxPriceUnitAmount: number, externalStripePaymentIntentId?: string | null, venue: { __typename?: 'Venues', title: string }, integration: { __typename?: 'VenueBookingIntegrations', bookingSystem: BookingSystemsEnum, bookingAccountEmail: string, externalOrgId?: string | null, providerApiKeyEncrypted?: string | null } } }> };

export type GetEnabledCalendarsQueryVariables = Exact<{
  userId: Scalars['uuid'];
}>;


export type GetEnabledCalendarsQuery = { __typename?: 'query_root', calendarAccounts: Array<{ __typename?: 'CalendarAccounts', id: any, accessToken: string, refreshToken?: string | null, expiresAt?: any | null, calendarPreferences: Array<{ __typename?: 'CalendarPreferences', id: any, calendarId: string, calendarName: string }> }> };

export type GetEngagementEntityRefsQueryVariables = Exact<{
  lessonIds?: InputMaybe<Array<Scalars['uuid']> | Scalars['uuid']>;
  eventIds?: InputMaybe<Array<Scalars['uuid']> | Scalars['uuid']>;
}>;


export type GetEngagementEntityRefsQuery = { __typename?: 'query_root', lessons: Array<{ __typename?: 'Lessons', id: any, venueId?: any | null, ownerUserId?: any | null }>, events: Array<{ __typename?: 'Events', id: any, venueId?: any | null, hostUserId?: any | null }> };

export type GetEventByIdWithOrganizerQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetEventByIdWithOrganizerQuery = { __typename?: 'query_root', eventsByPk?: { __typename?: 'Events', id: any, title: string, hostUserId?: any | null } | null };

export type GetEventCapacityInfoQueryVariables = Exact<{
  eventId: Scalars['uuid'];
}>;


export type GetEventCapacityInfoQuery = { __typename?: 'query_root', eventsByPk?: { __typename?: 'Events', id: any, participantLimit?: number | null, groups: Array<{ __typename?: 'EventGroups', id: any, teamType?: TeamTypesEnum | null }> } | null, playRequestsAggregate: { __typename?: 'PlayRequestsAggregate', aggregate?: { __typename?: 'PlayRequestsAggregateFields', count: number } | null }, claimedInvites: { __typename?: 'EventPlayerInvitesAggregate', aggregate?: { __typename?: 'EventPlayerInvitesAggregateFields', count: number } | null } };

export type GetEventCouponByIdQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetEventCouponByIdQuery = { __typename?: 'query_root', eventCouponsByPk?: { __typename?: 'EventCoupons', id: any, eventId: any, code: string, couponType: EventCouponTypeEnum, percentOff?: any | null, amountOff?: number | null, fixedPrice?: number | null, isActive: boolean, validFrom?: any | null, validUntil?: any | null, maxRedemptions?: number | null, couponGroups: Array<{ __typename?: 'EventCouponGroups', eventGroupId: any }>, redemptionsAggregate: { __typename?: 'EventCouponRedemptionsAggregate', aggregate?: { __typename?: 'EventCouponRedemptionsAggregateFields', count: number } | null } } | null };

export type GetEventDetailsQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetEventDetailsQuery = { __typename?: 'query_root', eventsByPk?: { __typename?: 'Events', addressString?: string | null, cityId?: any | null, coverImageFileName?: string | null, coverImagePath?: string | null, coverImageUrl?: string | null, currency: string, createdAt: any, description: string, displayLocation: string, endDate: any, endDateTime: any, externalUrl?: string | null, geometry?: any | null, hasPrizes: boolean, id: any, isExternal: boolean, isShowPlayersGoing: boolean, organizerImageUrl?: string | null, organizerImagePath?: string | null, locale: string, isSanctioned: boolean, privacy: EventPrivacyEnum, prizeDescription: string, publishedAt?: any | null, registrationClosedAt?: any | null, registrationDeadlineDate: any, registrationDeadlineDateTime?: any | null, registrationPriceUnitAmount: number, registrationOpenDate?: any | null, registrationOpenDateTime?: any | null, isRatingRequired: boolean, slug: string, scoringFormat?: ScoringFormatEnum | null, sport: SportsEnum, startDate: any, startDateTime: any, status: EventStatusesEnum, title: string, type: EventTypesEnum, timezoneName: string, timezoneOffsetMinutes: number, timezoneAbbreviation: string, sourceRegistrationCount: number, sourceOrganizerTitle?: string | null, groupFormat?: EventGroupFormatsEnum | null, isQuickCreate: boolean, paymentFulfillmentChannel: PaymentFulfillmentChannelsEnum, isVairRequired?: boolean | null, canceledAt?: any | null, ballCustomName: string, ballType: BallTypesEnum, city?: { __typename?: 'Cities', id: any, name: string, slug: string, countrySubdivision: { __typename?: 'CountrySubdivisions', id: any, name: string, slug: string, code: string, country: { __typename?: 'Countries', id: string, name: string, slug: string } } } | null, venue?: { __typename?: 'Venues', id: any, title: string, slug: string, pickleballLines?: VenueLinesEnum | null, pickleballNets?: VenueNetsEnum | null, longitude: any, latitude: any, geometry?: any | null, addressString: string, outdoorCourtCount: number, indoorCourtCount: number, timezone: string, images: Array<{ __typename?: 'VenueImages', id: any, path: string, url: string }>, courtSurfaces: Array<{ __typename?: 'VenueCourtSurfaces', id: any, courtSurface: CourtSurfacesEnum }> } | null, pickleballRatingScale?: { __typename?: 'PickleballRatingScales', id: any, maximum: any, minimum: any, name: string, shortName: string } | null, hostUserProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, preferredName?: string | null, profileImageFileName?: string | null, profileImageProvider?: string | null } | null, faqs: Array<{ __typename?: 'EventFaqs', id: any, question: string, answer: string }>, registrations: Array<{ __typename?: 'EventRegistrations', id: any, userProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, username?: string | null, preferredName?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProvider?: string | null, profileImageProviderUrl?: string | null } | null }>, groups: Array<{ __typename?: 'EventGroups', id: any, gender: CompetitionGenderEnum, gamesPerMatch: number, formatCustomName: string, format?: EventGroupFormatsEnum | null, endsAt?: any | null, maximumAge?: number | null, maximumRating?: any | null, minimumNumberOfGames: number, minimumAge?: number | null, minimumRating?: any | null, priceUnitAmount: number, scoringFormat?: ScoringFormatEnum | null, startsAt?: any | null, teamLimit?: number | null, teamType?: TeamTypesEnum | null, title: string, totalPoints?: number | null, winBy?: number | null, teams: Array<{ __typename?: 'EventTeams', id: any, members: Array<{ __typename?: 'EventTeamMembers', id: any, userId: any, userProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, preferredName?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProvider?: string | null, profileImageProviderUrl?: string | null } | null }> }>, registrations: Array<{ __typename?: 'EventGroupRegistrations', id: any, userId: any, userProfile?: { __typename?: 'UserProfiles', id?: any | null, preferredName?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProvider?: string | null, profileImageProviderUrl?: string | null } | null }> }>, hostUser?: { __typename?: 'Users', id: any, email: string, fullName: string, stripeMerchantId?: string | null, stripeMerchantCurrency?: string | null, currencyCoachDefault: string } | null } | null };

export type GetEventDetailsForOrganizerQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetEventDetailsForOrganizerQuery = { __typename?: 'query_root', eventsByPk?: { __typename?: 'Events', addressString?: string | null, cityId?: any | null, coverImageFileName?: string | null, coverImagePath?: string | null, coverImageUrl?: string | null, currency: string, createdAt: any, description: string, displayLocation: string, endDate: any, endDateTime: any, externalUrl?: string | null, geometry?: any | null, hasPrizes: boolean, id: any, isExternal: boolean, isShowPlayersGoing: boolean, organizerImageUrl?: string | null, organizerImagePath?: string | null, locale: string, isSanctioned: boolean, privacy: EventPrivacyEnum, prizeDescription: string, publishedAt?: any | null, registrationClosedAt?: any | null, registrationDeadlineDate: any, registrationDeadlineDateTime?: any | null, registrationPriceUnitAmount: number, registrationOpenDate?: any | null, registrationOpenDateTime?: any | null, isRatingRequired: boolean, slug: string, scoringFormat?: ScoringFormatEnum | null, sport: SportsEnum, startDate: any, startDateTime: any, status: EventStatusesEnum, title: string, type: EventTypesEnum, timezoneName: string, timezoneOffsetMinutes: number, timezoneAbbreviation: string, sourceRegistrationCount: number, sourceOrganizerTitle?: string | null, groupFormat?: EventGroupFormatsEnum | null, isQuickCreate: boolean, paymentFulfillmentChannel: PaymentFulfillmentChannelsEnum, isVairRequired?: boolean | null, canceledAt?: any | null, ballCustomName: string, ballType: BallTypesEnum, city?: { __typename?: 'Cities', id: any, name: string, slug: string, countrySubdivision: { __typename?: 'CountrySubdivisions', id: any, name: string, slug: string, code: string, country: { __typename?: 'Countries', id: string, name: string, slug: string } } } | null, venue?: { __typename?: 'Venues', id: any, title: string, slug: string, pickleballLines?: VenueLinesEnum | null, pickleballNets?: VenueNetsEnum | null, longitude: any, latitude: any, geometry?: any | null, addressString: string, outdoorCourtCount: number, indoorCourtCount: number, timezone: string, images: Array<{ __typename?: 'VenueImages', id: any, path: string, url: string }>, courtSurfaces: Array<{ __typename?: 'VenueCourtSurfaces', id: any, courtSurface: CourtSurfacesEnum }> } | null, pickleballRatingScale?: { __typename?: 'PickleballRatingScales', id: any, maximum: any, minimum: any, name: string, shortName: string } | null, hostUserProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, preferredName?: string | null, profileImageFileName?: string | null, profileImageProvider?: string | null } | null, faqs: Array<{ __typename?: 'EventFaqs', id: any, question: string, answer: string }>, registrationsAggregate: { __typename?: 'EventRegistrationsAggregate', aggregate?: { __typename?: 'EventRegistrationsAggregateFields', count: number } | null }, registrations: Array<{ __typename?: 'EventRegistrations', id: any, userProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, username?: string | null, preferredName?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProvider?: string | null, profileImageProviderUrl?: string | null } | null }>, groups: Array<{ __typename?: 'EventGroups', id: any, gender: CompetitionGenderEnum, gamesPerMatch: number, formatCustomName: string, format?: EventGroupFormatsEnum | null, endsAt?: any | null, maximumAge?: number | null, maximumRating?: any | null, minimumNumberOfGames: number, minimumAge?: number | null, minimumRating?: any | null, desiredNumberOfPools?: number | null, numberOfEstimatedCourts?: number | null, priceUnitAmount: number, scoringFormat?: ScoringFormatEnum | null, startsAt?: any | null, teamLimit?: number | null, teamType?: TeamTypesEnum | null, title: string, totalPoints?: number | null, winBy?: number | null, mergeId?: any | null, merge?: { __typename?: 'EventGroupMerges', id: any, baseGroupId: any, unmergeForKnockout: boolean } | null, courts: Array<{ __typename?: 'EventCourts', id: any, courtNumber: number, courtName?: string | null }>, teams: Array<{ __typename?: 'EventTeams', id: any, status: EventTeamStatusesEnum, members: Array<{ __typename?: 'EventTeamMembers', id: any, userId: any, userProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, preferredName?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProvider?: string | null, profileImageProviderUrl?: string | null } | null }> }>, registrations: Array<{ __typename?: 'EventGroupRegistrations', id: any, userId: any, checkedInAt?: any | null, paymentStatus?: PaymentStatusesEnum | null, paymentFulfillmentChannel?: PaymentFulfillmentChannelsEnum | null, userProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, preferredName?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProvider?: string | null, profileImageProviderUrl?: string | null } | null }>, sequences: Array<{ __typename?: 'EventGroupSequences', id: any }>, allRegistrations: Array<{ __typename?: 'EventGroupRegistrations', id: any, userId: any, deletedAt?: any | null, checkedInAt?: any | null, paymentStatus?: PaymentStatusesEnum | null, paymentFulfillmentChannel?: PaymentFulfillmentChannelsEnum | null, userProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, preferredName?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProvider?: string | null, profileImageProviderUrl?: string | null } | null, transactionItems: Array<{ __typename?: 'EventTransactionItems', id: any, totalUnitAmount: number, refundUnitAmount: number, status: OrderStatusesEnum, transaction: { __typename?: 'EventTransactions', id: any, status: OrderStatusesEnum, applicationFeeTotalUnitAmount: number, customerApplicationFeeUnitAmount: number, customerPlatformFeeUnitAmount: number, customerProcessingFeeUnitAmount: number, sellerApplicationFeeUnitAmount: number, sellerPlatformFeeUnitAmount: number, sellerProcessingFeeUnitAmount: number, orderTotalUnitAmount: number } }> }> }>, hostUser?: { __typename?: 'Users', id: any, stripeMerchantId?: string | null, stripeMerchantCurrency?: string | null, currencyCoachDefault: string } | null } | null };

export type GetEventGroupForOrganizerQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetEventGroupForOrganizerQuery = { __typename?: 'query_root', eventGroupsByPk?: { __typename?: 'EventGroups', id: any, gender: CompetitionGenderEnum, gamesPerMatch: number, formatCustomName: string, format?: EventGroupFormatsEnum | null, endsAt?: any | null, maximumAge?: number | null, maximumRating?: any | null, minimumNumberOfGames: number, minimumAge?: number | null, minimumRating?: any | null, priceUnitAmount: number, scoringFormat?: ScoringFormatEnum | null, startsAt?: any | null, teamLimit?: number | null, teamType?: TeamTypesEnum | null, title: string, totalPoints?: number | null, winBy?: number | null, courts: Array<{ __typename?: 'EventCourts', id: any, courtNumber: number, courtName?: string | null }>, teams: Array<{ __typename?: 'EventTeams', id: any, members: Array<{ __typename?: 'EventTeamMembers', id: any, userId: any, userProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, preferredName?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProvider?: string | null, profileImageProviderUrl?: string | null } | null }> }>, registrations: Array<{ __typename?: 'EventGroupRegistrations', id: any, userId: any, teamId?: any | null, paymentStatus?: PaymentStatusesEnum | null, paymentFulfillmentChannel?: PaymentFulfillmentChannelsEnum | null, userProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, preferredName?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProvider?: string | null, profileImageProviderUrl?: string | null } | null, invitations: Array<{ __typename?: 'EventInvitations', id: any, invitationType: EventInvitationTypesEnum, invitationEmail?: string | null, invitationName?: string | null, invitedUserId?: any | null, invitedUserProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, preferredName?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProvider?: string | null, profileImageProviderUrl?: string | null } | null }>, acceptedInvitations: Array<{ __typename?: 'EventInvitations', id: any, invitedUserId?: any | null }>, transactionItems: Array<{ __typename?: 'EventTransactionItems', id: any, totalUnitAmount: number, refundUnitAmount: number, status: OrderStatusesEnum, transaction: { __typename?: 'EventTransactions', id: any, status: OrderStatusesEnum, applicationFeeTotalUnitAmount: number, externalStripePaymentIntentId: string } }> }>, event: { __typename?: 'Events', id: any, title: string, currency: string, hostUser?: { __typename?: 'Users', id: any } | null, groups: Array<{ __typename?: 'EventGroups', id: any, title: string }> } } | null };

export type GetEventGroupRegistrationForAlertQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetEventGroupRegistrationForAlertQuery = { __typename?: 'query_root', eventGroupRegistrationsByPk?: { __typename?: 'EventGroupRegistrations', invitedPartnerEmail?: string | null, invitedPartnerName?: string | null, user: { __typename?: 'Users', id: any, fullName: string, email: string }, group: { __typename?: 'EventGroups', id: any, title: string, event: { __typename?: 'Events', id: any, title: string } } } | null };

export type GetEventInvitationByIdQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetEventInvitationByIdQuery = { __typename?: 'query_root', eventInvitationsByPk?: { __typename?: 'EventInvitations', eventId: any, groupId: any, id: any, status: EventInvitationStatusesEnum, deletedAt?: any | null, senderUserId: any, groupRegistrationId?: any | null, groupRegistration?: { __typename?: 'EventGroupRegistrations', id: any, teamId?: any | null } | null } | null };

export type GetEventInvitationsByEmailQueryVariables = Exact<{
  email: Scalars['String'];
  eventId: Scalars['uuid'];
}>;


export type GetEventInvitationsByEmailQuery = { __typename?: 'query_root', eventInvitations: Array<{ __typename?: 'EventInvitations', eventId: any, groupId: any, id: any, senderUserId: any, groupRegistrationId?: any | null, groupRegistration?: { __typename?: 'EventGroupRegistrations', id: any, teamId?: any | null } | null }> };

export type GetEventInviteTargetQueryVariables = Exact<{
  eventId: Scalars['uuid'];
}>;


export type GetEventInviteTargetQuery = { __typename?: 'query_root', eventsByPk?: { __typename?: 'Events', id: any, hostUserId?: any | null, isPlayerListed: boolean, status: EventStatusesEnum, startDateTime: any, canceledAt?: any | null, deletedAt?: any | null } | null };

export type GetEventPlayerInviteByIdQueryVariables = Exact<{
  id: Scalars['uuid'];
  viewerUserId: Scalars['uuid'];
}>;


export type GetEventPlayerInviteByIdQuery = { __typename?: 'query_root', eventPlayerInvitesByPk?: { __typename?: 'EventPlayerInvites', id: any, eventId: any, inviterUserId: any, invitedUserId: any, status: EventPlayerInviteStatusesEnum, playRequestId?: any | null, deletedAt?: any | null, event: { __typename?: 'Events', id: any, hostUserId?: any | null, status: EventStatusesEnum, startDateTime: any, canceledAt?: any | null, deletedAt?: any | null, groups: Array<{ __typename?: 'EventGroups', id: any, teamType?: TeamTypesEnum | null }>, viewerPlayRequests: Array<{ __typename?: 'PlayRequests', id: any, status: PlayRequestStatusesEnum, conversationId?: any | null }> } } | null };

export type GetEventPlayerInviteForNotificationQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetEventPlayerInviteForNotificationQuery = { __typename?: 'query_root', eventPlayerInvitesByPk?: { __typename?: 'EventPlayerInvites', id: any, eventId: any, inviterUserId: any, invitedUserId: any, inviter: { __typename?: 'Users', id: any, email: string, fullName: string, preferredName: string }, invitedUser: { __typename?: 'Users', id: any, email: string, fullName: string, preferredName: string }, inviterProfile?: { __typename?: 'UserProfiles', id?: any | null, username?: string | null } | null, invitedUserProfile?: { __typename?: 'UserProfiles', id?: any | null, username?: string | null } | null, event: { __typename?: 'Events', id: any, startDateTime: any, endDateTime: any, timezoneName: string, displayLocation: string, addressString?: string | null, venue?: { __typename?: 'Venues', id: any, title: string, addressString: string, timezone: string } | null, groups: Array<{ __typename?: 'EventGroups', id: any, teamType?: TeamTypesEnum | null, selfRatedMinSkillLevel?: { __typename?: 'SkillLevels', displayName: string } | null, selfRatedMaxSkillLevel?: { __typename?: 'SkillLevels', displayName: string } | null, ratingScales: Array<{ __typename?: 'EventGroupRatingScales', minimumRating?: any | null, maximumRating?: any | null, pickleballRatingScale?: { __typename?: 'PickleballRatingScales', shortName: string } | null, tennisRatingScale?: { __typename?: 'TennisRatingScales', shortName: string } | null, padelRatingScale?: { __typename?: 'PadelRatingScales', shortName: string } | null }> }> } } | null };

export type GetEventRegistrantEmailsForOrganizerQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetEventRegistrantEmailsForOrganizerQuery = { __typename?: 'query_root', eventsByPk?: { __typename?: 'Events', id: any, hostUser?: { __typename?: 'Users', id: any } | null, registrations: Array<{ __typename?: 'EventRegistrations', id: any, user: { __typename?: 'Users', id: any, email: string, fullName: string } }> } | null };

export type GetEventRegistrationForUserQueryVariables = Exact<{
  eventId: Scalars['uuid'];
  userId: Scalars['uuid'];
}>;


export type GetEventRegistrationForUserQuery = { __typename?: 'query_root', eventRegistrations: Array<{ __typename?: 'EventRegistrations', id: any }>, eventGroupRegistrations: Array<{ __typename?: 'EventGroupRegistrations', id: any, status: EventGroupRegistrationStatusesEnum, group: { __typename?: 'EventGroups', id: any, title: string, format?: EventGroupFormatsEnum | null, formatCustomName: string, maximumAge?: number | null, maximumRating?: any | null, minimumAge?: number | null, minimumNumberOfGames: number, minimumRating?: any | null, teams: Array<{ __typename?: 'EventTeams', id: any, members: Array<{ __typename?: 'EventTeamMembers', userId: any, id: any, userProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, preferredName?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProvider?: string | null, profileImageProviderUrl?: string | null } | null }> }> }, invitations: Array<{ __typename?: 'EventInvitations', id: any, invitationEmail?: string | null, status: EventInvitationStatusesEnum }> }> };

export type GetEventRegistrationsForCleanupQueryVariables = Exact<{
  eventId: Scalars['uuid'];
  userId: Scalars['uuid'];
}>;


export type GetEventRegistrationsForCleanupQuery = { __typename?: 'query_root', eventRegistrations: Array<{ __typename?: 'EventRegistrations', id: any, transactionItems: Array<{ __typename?: 'EventTransactionItems', id: any, totalUnitAmount: number, refundUnitAmount: number, status: OrderStatusesEnum, transaction: { __typename?: 'EventTransactions', id: any, externalStripePaymentIntentId: string } }> }> };

export type GetEventTeamInviteByIdQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetEventTeamInviteByIdQuery = { __typename?: 'query_root', eventTeamsByPk?: { __typename?: 'EventTeams', id: any, groupId: any, members: Array<{ __typename?: 'EventTeamMembers', id: any, userProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, preferredName?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProvider?: string | null, profileImageProviderUrl?: string | null } | null }>, groupRegistrations: Array<{ __typename?: 'EventGroupRegistrations', id: any, status: EventGroupRegistrationStatusesEnum }> } | null };

export type GetEventToPrepareTournamentQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetEventToPrepareTournamentQuery = { __typename?: 'query_root', eventsByPk?: { __typename?: 'Events', id: any, title: string, hostUserId?: any | null, numberOfCourts?: any | null, venue?: { __typename?: 'Venues', id: any, indoorCourtCount: number, outdoorCourtCount: number } | null, groups: Array<{ __typename?: 'EventGroups', id: any, title: string, winBy?: number | null, totalPoints?: number | null, teamLimit?: number | null, teamType?: TeamTypesEnum | null, startsAt?: any | null, endsAt?: any | null, scoringFormat?: ScoringFormatEnum | null, gamesPerMatch: number, format?: EventGroupFormatsEnum | null, minimumNumberOfGames: number, numberOfEstimatedCourts?: number | null, desiredNumberOfPools?: number | null, registrations: Array<{ __typename?: 'EventGroupRegistrations', id: any, userId: any, teamId?: any | null, status: EventGroupRegistrationStatusesEnum, createdAt: any, userProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, preferredName?: string | null } | null }>, teams: Array<{ __typename?: 'EventTeams', id: any, matches: Array<{ __typename?: 'EventMatchesTeams', id: any, match: { __typename?: 'EventMatches', id: any, roundId: any } }>, members: Array<{ __typename?: 'EventTeamMembers', id: any, userId: any, userProfile?: { __typename?: 'UserProfiles', fullName?: string | null, id?: any | null, preferredName?: string | null } | null }> }>, pools: Array<{ __typename?: 'EventGroupPools', id: any, title: string, teams: Array<{ __typename?: 'EventPoolsTeams', id: any, team: { __typename?: 'EventTeams', id: any, members: Array<{ __typename?: 'EventTeamMembers', id: any, status: EventTeamMemberStatusesEnum, userProfile?: { __typename?: 'UserProfiles', fullName?: string | null, id?: any | null, preferredName?: string | null } | null }> } }> }>, sequences: Array<{ __typename?: 'EventGroupSequences', id: any, nextSequenceId?: any | null, order: number, groupId: any, competitionFormat: CompetitionFormatsEnum, completeReason: EventSequenceCompleteReasonsEnum }>, courts: Array<{ __typename?: 'EventCourts', id: any, courtNumber: number, courtStatus: EventCourtStatusesEnum, activeMatch?: { __typename?: 'EventMatches', id: any, teams: Array<{ __typename?: 'EventMatchesTeams', id: any, team: { __typename?: 'EventTeams', members: Array<{ __typename?: 'EventTeamMembers', userProfile?: { __typename?: 'UserProfiles', id?: any | null, preferredName?: string | null, fullName?: string | null } | null }> } }> } | null }> }> } | null };

export type GetExistingActivePlayRequestByEventQueryVariables = Exact<{
  requesterUserId: Scalars['uuid'];
  eventId: Scalars['uuid'];
}>;


export type GetExistingActivePlayRequestByEventQuery = { __typename?: 'query_root', playRequests: Array<{ __typename?: 'PlayRequests', id: any }> };

export type GetExistingActivePlayRequestByAvailabilityQueryVariables = Exact<{
  requesterUserId: Scalars['uuid'];
  availabilityId: Scalars['uuid'];
}>;


export type GetExistingActivePlayRequestByAvailabilityQuery = { __typename?: 'query_root', playRequests: Array<{ __typename?: 'PlayRequests', id: any }> };

export type GetExistingEventPlayerInvitesQueryVariables = Exact<{
  eventId: Scalars['uuid'];
  invitedUserIds: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type GetExistingEventPlayerInvitesQuery = { __typename?: 'query_root', eventPlayerInvites: Array<{ __typename?: 'EventPlayerInvites', id: any, invitedUserId: any, status: EventPlayerInviteStatusesEnum }> };

export type GetFollowerLessonsAndReflectionsQueryVariables = Exact<{
  followerIds: Array<Scalars['uuid']> | Scalars['uuid'];
  coachId: Scalars['uuid'];
}>;


export type GetFollowerLessonsAndReflectionsQuery = { __typename?: 'query_root', lessons: Array<{ __typename?: 'Lessons', id: any, times: Array<{ __typename?: 'LessonTimes', startDateTime: any, endDateTime: any }>, participants: Array<{ __typename?: 'LessonParticipants', userId: any }>, lessonReflections: Array<{ __typename?: 'LessonReflections', id: any, reviewStatus: VideoAnalysisReviewStatusesEnum, playerUserId: any, coachUserId: any, createdAt: any }> }> };

export type GetFollowerPendingVideosQueryVariables = Exact<{
  followerIds: Array<Scalars['uuid']> | Scalars['uuid'];
  coachId: Scalars['uuid'];
}>;


export type GetFollowerPendingVideosQuery = { __typename?: 'query_root', videoAnalysis: Array<{ __typename?: 'VideoAnalysis', id: any, createdAt: any, reviewStatus?: VideoAnalysisReviewStatusesEnum | null, reviewerUserId: any, submissionUserId: any }> };

export type GetGameDataForRestartQueryVariables = Exact<{
  groupId: Scalars['uuid'];
}>;


export type GetGameDataForRestartQuery = { __typename?: 'query_root', eventGroupsByPk?: { __typename?: 'EventGroups', id: any, event: { __typename?: 'Events', id: any, hostUser?: { __typename?: 'Users', id: any } | null }, sequences: Array<{ __typename?: 'EventGroupSequences', id: any }> } | null };

export type GetGroupAllRoundMatchesQueryVariables = Exact<{
  groupId: Scalars['uuid'];
}>;


export type GetGroupAllRoundMatchesQuery = { __typename?: 'query_root', eventGroupsByPk?: { __typename?: 'EventGroups', id: any, sequences: Array<{ __typename?: 'EventGroupSequences', id: any, pools: Array<{ __typename?: 'EventGroupPools', id: any, rounds: Array<{ __typename?: 'EventPoolRounds', id: any, roundOrder: number, matches: Array<{ __typename?: 'EventMatches', id: any, matchOrder: number }> }> }> }> } | null };

export type GetGroupFirstRoundMatchesQueryVariables = Exact<{
  groupId: Scalars['uuid'];
}>;


export type GetGroupFirstRoundMatchesQuery = { __typename?: 'query_root', eventGroupsByPk?: { __typename?: 'EventGroups', id: any, sequences: Array<{ __typename?: 'EventGroupSequences', id: any, pools: Array<{ __typename?: 'EventGroupPools', id: any, rounds: Array<{ __typename?: 'EventPoolRounds', id: any, matches: Array<{ __typename?: 'EventMatches', id: any, matchOrder: number }> }> }> }> } | null };

export type GetGroupPageContentByGroupSlugQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type GetGroupPageContentByGroupSlugQuery = { __typename?: 'query_root', groups: Array<{ __typename?: 'Groups', id: any, allowMemberSessionInvites: boolean, accessCode?: string | null, actionUrl: string, addressString: string, allowMemberInvites: boolean, cityId?: any | null, contactEmail?: string | null, contactMessage?: string | null, contactPhoneNumber?: string | null, contactUrl?: string | null, coverPhotoFileName: string, coverPhotoFileType?: string | null, coverPhotoHost: string, coverPhotoOriginalFileName: string, coverPhotoPath: string, coverPhotoProvider: string, coverPhotoProviderUrl: string, coverPhotoUrl: string, createdAt: any, deletedAt?: any | null, description: string, directorEmail?: string | null, directorName?: string | null, directorPhoneNumber?: string | null, displayOwnerContactInfo: boolean, duprUrl?: string | null, facebookUrl: string, geometry?: any | null, headline: string, instagramUrl: string, isPrivate: boolean, latitude?: any | null, longitude?: any | null, memberDisplayCount?: number | null, organizerEmail?: string | null, organizerName?: string | null, organizerPhoneNumber?: string | null, ownerUserId?: any | null, preferredContact?: string | null, primarySport?: SportsEnum | null, profilePhotoFileName: string, profilePhotoFileType?: string | null, profilePhotoHost: string, profilePhotoOriginalFileName: string, profilePhotoPath: string, profilePhotoProvider: string, profilePhotoProviderUrl: string, profilePhotoUrl: string, skillLevelMaximum?: any | null, skillLevelMinimum?: any | null, slug: string, tiktokUrl: string, title: string, type: GroupTypesEnum, updatedAt: any, websiteUrl: string, xUrl: string, youtubeUrl?: string | null, city?: { __typename?: 'Cities', id: any, name: string, slug: string } | null, members: Array<{ __typename?: 'GroupMembers', id: any, userProfile?: { __typename?: 'UserProfiles', coachStatus?: string | null, aboutMe?: string | null, cityName?: string | null, fullName?: string | null, id?: any | null, geometry?: any | null, priceUnitAmountCoachDefault?: number | null, username?: string | null, profileImagePath?: string | null, profileImageFileName?: string | null, profileImageProviderUrl?: string | null, currencyCoachDefault?: string | null, stripeMerchantCurrency?: string | null } | null }>, membersAggregate: { __typename?: 'GroupMembersAggregate', aggregate?: { __typename?: 'GroupMembersAggregateFields', count: number } | null }, venues: Array<{ __typename?: 'GroupVenues', id: any, venue: { __typename?: 'Venues', description: string, deletedAt?: any | null, createdAt: any, id: any, accessType?: VenueAccessTypesEnum | null, addressString: string, pickleballNets?: VenueNetsEnum | null, slug: string, outdoorCourtCount: number, indoorCourtCount: number, title: string, images: Array<{ __typename?: 'VenueImages', id: any, isVisible: boolean, fileName: string, fileType?: string | null, path: string, provider: string, url: string }> } }>, events: Array<{ __typename?: 'Events', addressString?: string | null, coverImagePath?: string | null, coverImageUrl?: string | null, displayLocation: string, description: string, endDateTime: any, hasPrizes: boolean, id: any, latitude?: any | null, locale: string, longitude?: any | null, organizerImagePath?: string | null, title: string, registrationClosedAt?: any | null, startDateTime: any, status: EventStatusesEnum, sourceOrganizerTitle?: string | null, sourceRegistrationCount: number, geometry?: any | null, isExternal: boolean, startDate: any, sport: SportsEnum, city?: { __typename?: 'Cities', name: string, id: any, timezone?: string | null, countrySubdivision: { __typename?: 'CountrySubdivisions', name: string, id: any, code: string, cities: Array<{ __typename?: 'Cities', id: any, name: string }> } } | null, registrationsAggregate: { __typename?: 'EventRegistrationsAggregate', aggregate?: { __typename?: 'EventRegistrationsAggregateFields', count: number } | null }, venue?: { __typename?: 'Venues', title: string, slug: string } | null }> }> };

export type GetGroupRankBracketQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetGroupRankBracketQuery = { __typename?: 'query_root', eventGroupsByPk?: { __typename?: 'EventGroups', id: any, title: string, winBy?: number | null, totalPoints?: number | null, teamLimit?: number | null, teamType?: TeamTypesEnum | null, startsAt?: any | null, endsAt?: any | null, scoringFormat?: ScoringFormatEnum | null, gamesPerMatch: number, format?: EventGroupFormatsEnum | null, minimumNumberOfGames: number, numberOfEliminationTeams?: number | null, event: { __typename?: 'Events', id: any, hostUserId?: any | null }, sequences: Array<{ __typename?: 'EventGroupSequences', id: any, nextSequenceId?: any | null, order: number, groupId: any, competitionFormat: CompetitionFormatsEnum, completeReason: EventSequenceCompleteReasonsEnum, isSequenceComplete: boolean, pools: Array<{ __typename?: 'EventGroupPools', id: any, title: string, startsAt?: any | null, endsAt?: any | null, rounds: Array<{ __typename?: 'EventPoolRounds', id: any, roundOrder: number, title: string, matches: Array<{ __typename?: 'EventMatches', courtNumber?: number | null, id: any, matchOrder: number, winningTeamId?: any | null, losingTeamId?: any | null, team1Id?: any | null, team2Id?: any | null, previousMatch1Id?: any | null, previousMatch2Id?: any | null, team1?: { __typename?: 'EventTeams', id: any, members: Array<{ __typename?: 'EventTeamMembers', id: any, status: EventTeamMemberStatusesEnum, userProfile?: { __typename?: 'UserProfiles', id?: any | null, preferredName?: string | null, fullName?: string | null } | null }> } | null, team2?: { __typename?: 'EventTeams', id: any, members: Array<{ __typename?: 'EventTeamMembers', id: any, status: EventTeamMemberStatusesEnum, userProfile?: { __typename?: 'UserProfiles', id?: any | null, preferredName?: string | null, fullName?: string | null } | null }> } | null, games: Array<{ __typename?: 'EventMatchGames', id: any, losingTeamId: any, team1Id: any, team1Score: any, team2Id: any, team2Score: any, winReason: WinReasonsEnum, winningTeamId: any, scores: Array<{ __typename?: 'EventGameScores', id: any, score: number, teamId: any }> }> }> }> }> }>, courts: Array<{ __typename?: 'EventCourts', id: any, updatedAt: any, courtNumber: number, courtStatus: EventCourtStatusesEnum, activeMatchId?: any | null, activeEventGroupPoolId?: any | null, activeEventGroupId?: any | null, activeMatch?: { __typename?: 'EventMatches', id: any, teams: Array<{ __typename?: 'EventMatchesTeams', id: any, team: { __typename?: 'EventTeams', id: any, members: Array<{ __typename?: 'EventTeamMembers', userProfile?: { __typename?: 'UserProfiles', id?: any | null, preferredName?: string | null, fullName?: string | null } | null }> } }> } | null }> } | null };

export type GetGroupThreadFromCommentQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetGroupThreadFromCommentQuery = { __typename?: 'query_root', groupThreadCommentsByPk?: { __typename?: 'GroupThreadComments', id: any, content: string, userId: any, isOriginalThreadComment: boolean, thread: { __typename?: 'GroupThreads', id: any, userId: any, group: { __typename?: 'Groups', id: any, title: string }, comments: Array<{ __typename?: 'GroupThreadComments', id: any, userId: any, isOriginalThreadComment: boolean, content: string, user?: { __typename?: 'Users', id: any, fullName: string, email: string, preferredName: string } | null }> } } | null };

export type GetGroupThreadFromUpvoteQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetGroupThreadFromUpvoteQuery = { __typename?: 'query_root', groupCommentVotesByPk?: { __typename?: 'GroupCommentVotes', userId: any, id: any, vote: CommentVoteEnum, comment: { __typename?: 'GroupThreadComments', id: any, user?: { __typename?: 'Users', email: string, id: any } | null, thread: { __typename?: 'GroupThreads', id: any, group: { __typename?: 'Groups', id: any, title: string } } } } | null };

export type GetInvitedUserByEmailQueryVariables = Exact<{
  email: Scalars['String'];
}>;


export type GetInvitedUserByEmailQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'Users', id: any, email: string, stripeCustomerId: string, firebaseId: string, fullName: string, preferredName: string, invitedByUserId?: any | null, isUpdatedAfterInvite: boolean }> };

export type GetIsFirstEventPlayerInviteQueryVariables = Exact<{
  id: Scalars['uuid'];
  eventId: Scalars['uuid'];
  invitedUserId: Scalars['uuid'];
}>;


export type GetIsFirstEventPlayerInviteQuery = { __typename?: 'query_root', eventPlayerInvites: Array<{ __typename?: 'EventPlayerInvites', id: any }> };

export type GetJwtClaimsDataQueryVariables = Exact<{
  userId: Scalars['uuid'];
}>;


export type GetJwtClaimsDataQuery = { __typename?: 'query_root', usersByPk?: { __typename?: 'Users', id: any, firebaseId: string, platformSubscriptions: Array<{ __typename?: 'PlatformSubscriptions', id: any, status: SubscriptionStatusesEnum, stripeStatus?: string | null, currentPeriodEndAt?: any | null, currentPeriodStartAt?: any | null, cancelAtPeriodEnd?: boolean | null }> } | null };

export type GetKnockoutMatchesForCascadeQueryVariables = Exact<{
  matchIds: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type GetKnockoutMatchesForCascadeQuery = { __typename?: 'query_root', eventMatches: Array<{ __typename?: 'EventMatches', id: any, pool?: { __typename?: 'EventGroupPools', id: any, groupId: any, sequence: { __typename?: 'EventGroupSequences', id: any, group: { __typename?: 'EventGroups', id: any, event: { __typename?: 'Events', id: any, hostUserId?: any | null } } } } | null }> };

export type GetLatestLessonReflectionFileQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetLatestLessonReflectionFileQuery = { __typename?: 'query_root', lessonReflectionFilesByPk?: { __typename?: 'LessonReflectionFiles', id: any, fileType: string, url: string, transcriptStartedAt?: any | null, fileFormat: string } | null };

export type GetLatestVideoAnalysisFileQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetLatestVideoAnalysisFileQuery = { __typename?: 'query_root', videoAnalysisFilesByPk?: { __typename?: 'VideoAnalysisFiles', id: any, fileType: string, url: string, transcriptionStartedAt?: any | null, uploadStatus: VideoAnalysisFilesUploadStatusesEnum, fileFormat: FileFormatEnum } | null };

export type GetLessonByIdQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetLessonByIdQuery = { __typename?: 'query_root', lessonsByPk?: { __typename?: 'Lessons', cancelReason: string, canceledAt?: any | null, coverImageFileName: string, coverImagePath: string, coverImageProviderUrl: string, createdAt: any, currency: string, deletedAt?: any | null, description: string, endDateTime?: any | null, id: any, ownerUserId?: any | null, participantLimit?: number | null, paymentFulfillmentChannel: PaymentFulfillmentChannelsEnum, priceUnitAmount: number, privacy: LessonPrivacyEnum, sport: SportsEnum, startDateTime?: any | null, status: LessonStatusesEnum, title: string, type: LessonTypesEnum, typeCustom: string, updatedAt: any, userCustomCourtId?: any | null, reminderEventId?: any | null, completionHasuraEventId?: any | null, locale: string, timezoneName: string, timezoneAbbreviation: string, timezoneOffsetMinutes: number, venueId?: any | null, venue?: { __typename?: 'Venues', id: any, addressString: string, isActive: boolean, latitude: any, longitude: any, outdoorCourtCount: number, geometry?: any | null, indoorCourtCount: number, slug: string, timezone: string, title: string, images: Array<{ __typename?: 'VenueImages', id: any, url: string, path: string, provider: string, fileName: string }> } | null, owner?: { __typename?: 'Users', id: any, preferredName: string, profileImageFileName: string, profileImagePath: string, profileImageProviderUrl: string, stripeMerchantId?: string | null, fullName: string, email: string, username?: string | null, stripeMerchantCurrency?: string | null, currencyCoachDefault: string } | null, userCustomCourt?: { __typename?: 'UserCustomCourts', createdAt: any, fullAddress: string, id: any, title: string, updatedAt: any } | null, participantsAggregate: { __typename?: 'LessonParticipantsAggregate', aggregate?: { __typename?: 'LessonParticipantsAggregateFields', count: number } | null }, waitlist: Array<{ __typename?: 'LessonWaitlists', id: any, status: LessonWaitlistStatusesEnum, userId: any, user: { __typename?: 'Users', id: any, email: string, fullName: string, preferredName: string } }> } | null };

export type GetLessonDetailsForSsrQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetLessonDetailsForSsrQuery = { __typename?: 'query_root', lessonsByPk?: { __typename?: 'Lessons', id: any, title: string, description: string, sport: SportsEnum, type: LessonTypesEnum, typeCustom: string, startDateTime?: any | null, endDateTime?: any | null, timezoneName: string, timezoneAbbreviation: string, priceUnitAmount: number, currency: string, participantLimit?: number | null, coverImageFileName: string, coverImagePath: string, coverImageProviderUrl: string, status: LessonStatusesEnum, ownerProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, profileImagePath?: string | null, stripeMerchantCurrency?: string | null, currencyCoachDefault?: string | null } | null, venue?: { __typename?: 'Venues', id: any, title: string, addressString: string, timezone: string } | null, userCustomCourt?: { __typename?: 'UserCustomCourts', id: any, title: string, fullAddress: string } | null, participantsAggregate: { __typename?: 'LessonParticipantsAggregate', aggregate?: { __typename?: 'LessonParticipantsAggregateFields', count: number } | null } } | null };

export type GetLessonParticipantByLessonIdAndUserIdQueryVariables = Exact<{
  lessonId: Scalars['uuid'];
  userId: Scalars['uuid'];
}>;


export type GetLessonParticipantByLessonIdAndUserIdQuery = { __typename?: 'query_root', lessonParticipants: Array<{ __typename?: 'LessonParticipants', id: any, refundedAt?: any | null, refundedByPersona?: AppPersonasEnum | null, status: LessonParticipantStatusesEnum, paymentFulfillmentChannel: PaymentFulfillmentChannelsEnum, userId: any, lesson: { __typename?: 'Lessons', id: any, status: LessonStatusesEnum, startDateTime?: any | null, locale: string, timezoneName: string, timezoneAbbreviation: string, timezoneOffsetMinutes: number, title: string, type: LessonTypesEnum, paymentFulfillmentChannel: PaymentFulfillmentChannelsEnum, owner?: { __typename?: 'Users', id: any, email: string, preferredName: string, fullName: string } | null, waitlist: Array<{ __typename?: 'LessonWaitlists', id: any, status: LessonWaitlistStatusesEnum, userId: any, user: { __typename?: 'Users', id: any, email: string, fullName: string, preferredName: string } }> }, orderItems: Array<{ __typename?: 'LessonOrderItems', status: OrderStatusesEnum, refundedByPersona?: AppPersonasEnum | null, refundedAt?: any | null, refundUnitAmount: number, totalUnitAmount: number, priceUnitAmount: number, id: any, order: { __typename?: 'LessonOrders', id: any, orderTotalUnitAmount: number, orderSubtotalUnitAmount: number, externalStripePaymentIntentId: string, paidUnitAmount: number, refundedAt?: any | null, refundedByPersona?: AppPersonasEnum | null, refundUnitAmount: number, status: OrderStatusesEnum } }>, user: { __typename?: 'Users', id: any, fullName: string, email: string, preferredName: string } }> };

export type GetLessonParticipantContactInfoQueryVariables = Exact<{
  lessonId: Scalars['uuid'];
}>;


export type GetLessonParticipantContactInfoQuery = { __typename?: 'query_root', lessonsByPk?: { __typename?: 'Lessons', id: any, ownerUserId?: any | null, participants: Array<{ __typename?: 'LessonParticipants', user: { __typename?: 'Users', id: any, fullName: string, email: string, phoneNumber?: string | null } }> } | null };

export type GetLessonParticipantsAndReflectionsQueryVariables = Exact<{
  lessonId: Scalars['uuid'];
  coachUserId: Scalars['uuid'];
}>;


export type GetLessonParticipantsAndReflectionsQuery = { __typename?: 'query_root', lessonParticipants: Array<{ __typename?: 'LessonParticipants', userId: any, user: { __typename?: 'Users', id: any, fullName: string, email: string } }>, lessonReflections: Array<{ __typename?: 'LessonReflections', playerUserId: any, id: any }> };

export type GetLessonReflectionFileByIdQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetLessonReflectionFileByIdQuery = { __typename?: 'query_root', lessonReflectionFilesByPk?: { __typename?: 'LessonReflectionFiles', id: any, fileType: string, url: string, fileFormat: string, transcriptStartedAt?: any | null, transcriptEndedAt?: any | null } | null };

export type GetLessonReportDataQueryVariables = Exact<{
  coachUserId: Scalars['uuid'];
  startDate: Scalars['timestamptz'];
  endDate: Scalars['timestamptz'];
}>;


export type GetLessonReportDataQuery = { __typename?: 'query_root', lessons: Array<{ __typename?: 'Lessons', id: any, title: string, startDateTime?: any | null, endDateTime?: any | null, priceUnitAmount: number, currency: string, paymentFulfillmentChannel: PaymentFulfillmentChannelsEnum, participantsAggregate: { __typename?: 'LessonParticipantsAggregate', aggregate?: { __typename?: 'LessonParticipantsAggregateFields', count: number } | null }, participants: Array<{ __typename?: 'LessonParticipants', paymentFulfillmentChannel: PaymentFulfillmentChannelsEnum, userProfile?: { __typename?: 'UserProfiles', fullName?: string | null, preferredName?: string | null } | null, orderItems: Array<{ __typename?: 'LessonOrderItems', priceUnitAmount: number, totalUnitAmount: number, order: { __typename?: 'LessonOrders', paidUnitAmount: number, orderTotalUnitAmount: number, paymentProcessor: PaymentProcessorsEnum, status: OrderStatusesEnum } }> }> }> };

export type GetLessonWithParticipantsByIdQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetLessonWithParticipantsByIdQuery = { __typename?: 'query_root', lessonsByPk?: { __typename?: 'Lessons', cancelReason: string, canceledAt?: any | null, coverImageFileName: string, coverImagePath: string, coverImageProviderUrl: string, createdAt: any, currency: string, deletedAt?: any | null, description: string, endDateTime?: any | null, id: any, ownerUserId?: any | null, participantLimit?: number | null, priceUnitAmount: number, privacy: LessonPrivacyEnum, reminderEventId?: any | null, startDateTime?: any | null, locale: string, timezoneName: string, timezoneAbbreviation: string, timezoneOffsetMinutes: number, status: LessonStatusesEnum, title: string, type: LessonTypesEnum, typeCustom: string, updatedAt: any, userCustomCourtId?: any | null, owner?: { __typename?: 'Users', id: any, preferredName: string, profileImageFileName: string, profileImagePath: string, profileImageProviderUrl: string, stripeMerchantId?: string | null, email: string, fullName: string } | null, userCustomCourt?: { __typename?: 'UserCustomCourts', createdAt: any, fullAddress: string, id: any, title: string, updatedAt: any } | null, venue?: { __typename?: 'Venues', id: any, addressString: string, title: string } | null, participants: Array<{ __typename?: 'LessonParticipants', id: any, userId: any, status: LessonParticipantStatusesEnum, user: { __typename?: 'Users', id: any, stripeCustomerId: string, fullName: string, email: string, preferredName: string }, orderItems: Array<{ __typename?: 'LessonOrderItems', id: any, priceUnitAmount: number, totalUnitAmount: number, status: OrderStatusesEnum, order: { __typename?: 'LessonOrders', id: any, customerApplicationFeeUnitAmount: number, orderSubtotalUnitAmount: number, orderTotalUnitAmount: number, paidUnitAmount: number, status: OrderStatusesEnum, paymentIntentInternal: { __typename?: 'StripePaymentIntents', id: any, paymentIntentId: string, amount: number, amountCapturable: number, amountReceived: number, application?: string | null, applicationFeeAmount?: number | null, stripeCharges: Array<{ __typename?: 'StripeCharges', amount: number, amountCaptured: number, amountRefunded: number, captured: boolean, chargeId: string, id: any }> } } }> }> } | null };

export type MarketBenchmarkGeoQueryVariables = Exact<{
  from: Scalars['geography'];
  distance: Scalars['Float'];
  startDate: Scalars['timestamptz'];
  viewsSince: Scalars['timestamptz'];
}>;


export type MarketBenchmarkGeoQuery = { __typename?: 'query_root', venuesAggregate: { __typename?: 'VenuesAggregate', aggregate?: { __typename?: 'VenuesAggregateFields', count: number } | null }, clubPageViews: Array<{ __typename?: 'EngagementAnalytics', venueId?: any | null }>, lessons: Array<{ __typename?: 'Lessons', id: any, type: LessonTypesEnum, priceUnitAmount: number, venueId?: any | null }>, events: Array<{ __typename?: 'Events', id: any, type: EventTypesEnum, registrationPriceUnitAmount: number, venueId?: any | null }> };

export type GetMaxEventCourtNumberQueryVariables = Exact<{
  eventId: Scalars['uuid'];
}>;


export type GetMaxEventCourtNumberQuery = { __typename?: 'query_root', eventCourtsAggregate: { __typename?: 'EventCourtsAggregate', aggregate?: { __typename?: 'EventCourtsAggregateFields', max?: { __typename?: 'EventCourtsMaxFields', courtNumber?: number | null } | null } | null } };

export type McpEventFieldsFragment = { __typename?: 'Events', id: any, slug: string, title: string, type: EventTypesEnum, sport: SportsEnum, startDateTime: any, endDateTime: any, timezoneName: string, displayLocation: string, addressString?: string | null, latitude?: any | null, longitude?: any | null, registrationPriceUnitAmount: number, currency: string, isExternal: boolean, isRegisterOffPlatform: boolean, sourceOrganizerTitle?: string | null, hostUserProfile?: { __typename?: 'UserProfiles', fullName?: string | null } | null, venue?: { __typename?: 'Venues', title: string, addressString: string, timezone: string, latitude: any, longitude: any } | null, groups: Array<{ __typename?: 'EventGroups', title: string, teamType?: TeamTypesEnum | null, gender: CompetitionGenderEnum, minimumAge?: number | null, maximumAge?: number | null, priceUnitAmount: number, minimumRating?: any | null, maximumRating?: any | null, selfRatedMinSkillLevelId?: string | null, selfRatedMaxSkillLevelId?: string | null, ratingScales: Array<{ __typename?: 'EventGroupRatingScales', minimumRating?: any | null, maximumRating?: any | null, pickleballRatingScale?: { __typename?: 'PickleballRatingScales', shortName: string } | null, tennisRatingScale?: { __typename?: 'TennisRatingScales', shortName: string } | null, padelRatingScale?: { __typename?: 'PadelRatingScales', shortName: string } | null }> }> };

export type GetMcpEventsQueryVariables = Exact<{
  where: EventsBoolExp;
  limit: Scalars['Int'];
}>;


export type GetMcpEventsQuery = { __typename?: 'query_root', events: Array<{ __typename?: 'Events', id: any, slug: string, title: string, type: EventTypesEnum, sport: SportsEnum, startDateTime: any, endDateTime: any, timezoneName: string, displayLocation: string, addressString?: string | null, latitude?: any | null, longitude?: any | null, registrationPriceUnitAmount: number, currency: string, isExternal: boolean, isRegisterOffPlatform: boolean, sourceOrganizerTitle?: string | null, hostUserProfile?: { __typename?: 'UserProfiles', fullName?: string | null } | null, venue?: { __typename?: 'Venues', title: string, addressString: string, timezone: string, latitude: any, longitude: any } | null, groups: Array<{ __typename?: 'EventGroups', title: string, teamType?: TeamTypesEnum | null, gender: CompetitionGenderEnum, minimumAge?: number | null, maximumAge?: number | null, priceUnitAmount: number, minimumRating?: any | null, maximumRating?: any | null, selfRatedMinSkillLevelId?: string | null, selfRatedMaxSkillLevelId?: string | null, ratingScales: Array<{ __typename?: 'EventGroupRatingScales', minimumRating?: any | null, maximumRating?: any | null, pickleballRatingScale?: { __typename?: 'PickleballRatingScales', shortName: string } | null, tennisRatingScale?: { __typename?: 'TennisRatingScales', shortName: string } | null, padelRatingScale?: { __typename?: 'PadelRatingScales', shortName: string } | null }> }> }> };

export type GetMcpEventByIdQueryVariables = Exact<{
  where: EventsBoolExp;
}>;


export type GetMcpEventByIdQuery = { __typename?: 'query_root', events: Array<{ __typename?: 'Events', description: string, registrationDeadlineDateTime?: any | null, registrationClosedAt?: any | null, id: any, slug: string, title: string, type: EventTypesEnum, sport: SportsEnum, startDateTime: any, endDateTime: any, timezoneName: string, displayLocation: string, addressString?: string | null, latitude?: any | null, longitude?: any | null, registrationPriceUnitAmount: number, currency: string, isExternal: boolean, isRegisterOffPlatform: boolean, sourceOrganizerTitle?: string | null, hostUserProfile?: { __typename?: 'UserProfiles', fullName?: string | null } | null, venue?: { __typename?: 'Venues', title: string, addressString: string, timezone: string, latitude: any, longitude: any } | null, groups: Array<{ __typename?: 'EventGroups', title: string, teamType?: TeamTypesEnum | null, gender: CompetitionGenderEnum, minimumAge?: number | null, maximumAge?: number | null, priceUnitAmount: number, minimumRating?: any | null, maximumRating?: any | null, selfRatedMinSkillLevelId?: string | null, selfRatedMaxSkillLevelId?: string | null, ratingScales: Array<{ __typename?: 'EventGroupRatingScales', minimumRating?: any | null, maximumRating?: any | null, pickleballRatingScale?: { __typename?: 'PickleballRatingScales', shortName: string } | null, tennisRatingScale?: { __typename?: 'TennisRatingScales', shortName: string } | null, padelRatingScale?: { __typename?: 'PadelRatingScales', shortName: string } | null }> }> }> };

export type McpLessonFieldsFragment = { __typename?: 'Lessons', id: any, title: string, type: LessonTypesEnum, sport: SportsEnum, startDateTime?: any | null, endDateTime?: any | null, timezoneName: string, priceUnitAmount: number, currency: string, externalBookingUrl: string, ownerProfile?: { __typename?: 'UserProfiles', fullName?: string | null } | null, venue?: { __typename?: 'Venues', title: string, addressString: string, timezone: string, latitude: any, longitude: any } | null, userCustomCourt?: { __typename?: 'UserCustomCourts', title: string, fullAddress: string, latitude?: any | null, longitude?: any | null } | null, skillLevels: Array<{ __typename?: 'LessonSkillLevels', skillLevel: string }> };

export type GetMcpLessonsQueryVariables = Exact<{
  where: LessonsBoolExp;
  limit: Scalars['Int'];
}>;


export type GetMcpLessonsQuery = { __typename?: 'query_root', lessons: Array<{ __typename?: 'Lessons', id: any, title: string, type: LessonTypesEnum, sport: SportsEnum, startDateTime?: any | null, endDateTime?: any | null, timezoneName: string, priceUnitAmount: number, currency: string, externalBookingUrl: string, ownerProfile?: { __typename?: 'UserProfiles', fullName?: string | null } | null, venue?: { __typename?: 'Venues', title: string, addressString: string, timezone: string, latitude: any, longitude: any } | null, userCustomCourt?: { __typename?: 'UserCustomCourts', title: string, fullAddress: string, latitude?: any | null, longitude?: any | null } | null, skillLevels: Array<{ __typename?: 'LessonSkillLevels', skillLevel: string }> }> };

export type GetMcpLessonByIdQueryVariables = Exact<{
  where: LessonsBoolExp;
}>;


export type GetMcpLessonByIdQuery = { __typename?: 'query_root', lessons: Array<{ __typename?: 'Lessons', description: string, intendedAgeGroup?: EventAgeGroupsEnum | null, id: any, title: string, type: LessonTypesEnum, sport: SportsEnum, startDateTime?: any | null, endDateTime?: any | null, timezoneName: string, priceUnitAmount: number, currency: string, externalBookingUrl: string, ownerProfile?: { __typename?: 'UserProfiles', fullName?: string | null } | null, venue?: { __typename?: 'Venues', title: string, addressString: string, timezone: string, latitude: any, longitude: any } | null, userCustomCourt?: { __typename?: 'UserCustomCourts', title: string, fullAddress: string, latitude?: any | null, longitude?: any | null } | null, skillLevels: Array<{ __typename?: 'LessonSkillLevels', skillLevel: string }> }> };

export type McpVenueFieldsFragment = { __typename?: 'Venues', id: any, slug: string, title: string, addressString: string, timezone: string, latitude: any, longitude: any, accessType?: VenueAccessTypesEnum | null, indoorCourtCount: number, outdoorCourtCount: number, totalCourtCount: number, hasPickleball: boolean, hasTennis: boolean, hasPadel: boolean, hasReservations?: boolean | null };

export type GetMcpVenuesQueryVariables = Exact<{
  where: VenuesBoolExp;
  limit: Scalars['Int'];
}>;


export type GetMcpVenuesQuery = { __typename?: 'query_root', venues: Array<{ __typename?: 'Venues', id: any, slug: string, title: string, addressString: string, timezone: string, latitude: any, longitude: any, accessType?: VenueAccessTypesEnum | null, indoorCourtCount: number, outdoorCourtCount: number, totalCourtCount: number, hasPickleball: boolean, hasTennis: boolean, hasPadel: boolean, hasReservations?: boolean | null }> };

export type GetMcpVenueByIdQueryVariables = Exact<{
  where: VenuesBoolExp;
}>;


export type GetMcpVenueByIdQuery = { __typename?: 'query_root', venues: Array<{ __typename?: 'Venues', description: string, accessDetails: string, facilityType?: VenueFacilityTypesEnum | null, id: any, slug: string, title: string, addressString: string, timezone: string, latitude: any, longitude: any, accessType?: VenueAccessTypesEnum | null, indoorCourtCount: number, outdoorCourtCount: number, totalCourtCount: number, hasPickleball: boolean, hasTennis: boolean, hasPadel: boolean, hasReservations?: boolean | null, amenities: Array<{ __typename?: 'VenueAmenities', amenity: AmenitiesEnum }> }> };

export type GetMessagingReportDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMessagingReportDataQuery = { __typename?: 'query_root', coachBookingRequests: Array<{ __typename?: 'CoachBookingRequests', id: any, createdAt: any, contactedAt?: any | null, playerUser: { __typename?: 'Users', email: string }, coachUser?: { __typename?: 'Users', id: any, latitude?: any | null, longitude?: any | null, activeCity?: { __typename?: 'Cities', id: any, name: string, countrySubdivision: { __typename?: 'CountrySubdivisions', name: string } } | null } | null }> };

export type GetNextKnockoutMatchQueryVariables = Exact<{
  matchId: Scalars['uuid'];
}>;


export type GetNextKnockoutMatchQuery = { __typename?: 'query_root', eventMatches: Array<{ __typename?: 'EventMatches', id: any, previousMatch1Id?: any | null, previousMatch2Id?: any | null, selectionCriteriaPreviousMatch1?: MatchSelectionCriteriaEnum | null, selectionCriteriaPreviousMatch2?: MatchSelectionCriteriaEnum | null }> };

export type GetNextUncourtedMatchesExcludingTeamQueryVariables = Exact<{
  excludeTeamId: Scalars['uuid'];
  groupId: Scalars['uuid'];
  limit: Scalars['Int'];
}>;


export type GetNextUncourtedMatchesExcludingTeamQuery = { __typename?: 'query_root', eventMatches: Array<{ __typename?: 'EventMatches', id: any }> };

export type GetOpenPartnerBookingHoldsQueryVariables = Exact<{
  venueId: Scalars['uuid'];
  localDate: Scalars['date'];
  now: Scalars['timestamptz'];
}>;


export type GetOpenPartnerBookingHoldsQuery = { __typename?: 'query_root', partnerBookingHolds: Array<{ __typename?: 'PartnerBookingHolds', providerResourceId: string, providerCourtId?: string | null, order: { __typename?: 'PartnerBookingOrders', startAt: any, endAt: any } }> };

export type GetPartnerBookingCheckoutContextQueryVariables = Exact<{
  venueId: Scalars['uuid'];
  playerUserId: Scalars['uuid'];
}>;


export type GetPartnerBookingCheckoutContextQuery = { __typename?: 'query_root', venueBookingIntegrations: Array<{ __typename?: 'VenueBookingIntegrations', id: any, status: BookingIntegrationStatusesEnum, maxAdvanceBookingDays?: number | null, bookingSystem: BookingSystemsEnum, externalOrgId?: string | null, providerApiKeyEncrypted?: string | null, readVerifiedAt?: any | null, connectionStatus: BookingConnectionStatusesEnum, windows: Array<{ __typename?: 'VenueBookingWindows', kind: BookingWindowKindsEnum, sport?: SportsEnum | null, dayOfWeek: DayOfWeekEnum, startTime: any, endTime: any }>, courtRates: Array<{ __typename?: 'VenueBookingCourtRates', sport?: SportsEnum | null, currency: string, hourlyUnitAmount: number, peakHourlyUnitAmount?: number | null }>, venue: { __typename?: 'Venues', title: string, timezone: string }, configVersions: Array<{ __typename?: 'VenueBookingConfigVersions', version: number, snapshot: any }> }>, previousConfirmedOrders: { __typename?: 'PartnerBookingOrdersAggregate', aggregate?: { __typename?: 'PartnerBookingOrdersAggregateFields', count: number } | null } };

export type GetPartnerBookingOrderByMarkerQueryVariables = Exact<{
  marker: Scalars['String'];
}>;


export type GetPartnerBookingOrderByMarkerQuery = { __typename?: 'query_root', partnerBookingOrders: Array<{ __typename?: 'PartnerBookingOrders', id: any, venueId: any, marker: string, providerCourtId?: string | null, startAt: any, endAt: any, localDate: any, startLocal: any, timezone: string, maxPriceUnitAmount: number, externalStripePaymentIntentId?: string | null, venue: { __typename?: 'Venues', title: string }, integration: { __typename?: 'VenueBookingIntegrations', id: any, bookingSystem: BookingSystemsEnum, bookingAccountEmail: string, externalOrgId?: string | null, providerApiKeyEncrypted?: string | null }, attempts: Array<{ __typename?: 'PartnerBookingAttempts', id: any, status: PartnerBookingAttemptStatusesEnum }> }> };

export type GetPartnerBookingOrderForNotificationQueryVariables = Exact<{
  orderId: Scalars['uuid'];
}>;


export type GetPartnerBookingOrderForNotificationQuery = { __typename?: 'query_root', partnerBookingOrdersByPk?: { __typename?: 'PartnerBookingOrders', id: any, inventoryType: BookingInventoryTypesEnum, startAt: any, endAt: any, timezone: string, providerCourtId?: string | null, failureReason?: string | null, orderTotalUnitAmount: number, refundUnitAmount: number, bounceCostUnitAmount?: number | null, referralFeeUnitAmount?: number | null, currency: string, utmSource?: string | null, utmMedium?: string | null, utmCampaign?: string | null, utmContent?: string | null, venue: { __typename?: 'Venues', id: any, title: string, slug: string, addressString: string }, player: { __typename?: 'Users', id: any, email: string, fullName: string, preferredName: string }, integration: { __typename?: 'VenueBookingIntegrations', bookingSystem: BookingSystemsEnum, confirmationNote?: string | null, externalOrgId?: string | null, providerApiKeyEncrypted?: string | null } } | null };

export type GetPartnerBookingVenueAccessQueryVariables = Exact<{
  venueId: Scalars['uuid'];
}>;


export type GetPartnerBookingVenueAccessQuery = { __typename?: 'query_root', venueBookingIntegrations: Array<{ __typename?: 'VenueBookingIntegrations', id: any, status: BookingIntegrationStatusesEnum, connectionStatus: BookingConnectionStatusesEnum, bookingSystem: BookingSystemsEnum, externalOrgId?: string | null, providerApiKeyEncrypted?: string | null, readVerifiedAt?: any | null, maxAdvanceBookingDays?: number | null, windows: Array<{ __typename?: 'VenueBookingWindows', kind: BookingWindowKindsEnum, sport?: SportsEnum | null, dayOfWeek: DayOfWeekEnum, startTime: any, endTime: any }>, courtRates: Array<{ __typename?: 'VenueBookingCourtRates', sport?: SportsEnum | null, currency: string, hourlyUnitAmount: number, peakHourlyUnitAmount?: number | null }>, venue: { __typename?: 'Venues', title: string, timezone: string } }> };

export type GetPartnerClinicsQueryVariables = Exact<{
  where: LessonsBoolExp;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type GetPartnerClinicsQuery = { __typename?: 'query_root', lessons: Array<{ __typename?: 'Lessons', id: any, title: string, type: LessonTypesEnum, sport: SportsEnum, description: string, startDateTime?: any | null, endDateTime?: any | null, timezoneName: string, timezoneAbbreviation: string, priceUnitAmount: number, currency: string, participantLimit?: number | null, intendedAgeGroup?: EventAgeGroupsEnum | null, externalSource?: string | null, externalBookingUrl: string, externalId?: string | null, coverImageUrl: string, coverImageProviderUrl: string, ownerProfile?: { __typename?: 'UserProfiles', fullName?: string | null, username?: string | null } | null, venue?: { __typename?: 'Venues', id: any, title: string, addressString: string, latitude: any, longitude: any } | null, userCustomCourt?: { __typename?: 'UserCustomCourts', fullAddress: string } | null, skillLevels: Array<{ __typename?: 'LessonSkillLevels', skillLevel: string }> }>, lessonsAggregate: { __typename?: 'LessonsAggregate', aggregate?: { __typename?: 'LessonsAggregateFields', count: number } | null } };

export type GetPartnerEventsQueryVariables = Exact<{
  where: EventsBoolExp;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type GetPartnerEventsQuery = { __typename?: 'query_root', events: Array<{ __typename?: 'Events', id: any, slug: string, title: string, type: EventTypesEnum, sport: SportsEnum, description: string, startDate: any, endDate: any, startDateTime: any, endDateTime: any, timezoneName: string, timezoneAbbreviation: string, registrationDeadlineDateTime?: any | null, registrationClosedAt?: any | null, displayLocation: string, addressString?: string | null, streetPrimaryString: string, cityString: string, regionString: string, countryString: string, zipcodeString: string, latitude?: any | null, longitude?: any | null, registrationPriceUnitAmount: number, currency: string, participantLimit?: number | null, source?: string | null, sourceId?: string | null, sourceOrganizerTitle?: string | null, externalUrl?: string | null, isExternal: boolean, isRegisterOffPlatform: boolean, isVairRequired?: boolean | null, groupFormat?: EventGroupFormatsEnum | null, coverImageUrl?: string | null, coverImagePath?: string | null, organizerImageUrl?: string | null, organizerImagePath?: string | null, city?: { __typename?: 'Cities', name: string, slug: string, countrySubdivision: { __typename?: 'CountrySubdivisions', name: string, code: string } } | null, venue?: { __typename?: 'Venues', id: any, title: string, addressString: string, latitude: any, longitude: any } | null, hostUserProfile?: { __typename?: 'UserProfiles', fullName?: string | null, username?: string | null } | null, groups: Array<{ __typename?: 'EventGroups', format?: EventGroupFormatsEnum | null, isVairRatingSession?: boolean | null }> }>, eventsAggregate: { __typename?: 'EventsAggregate', aggregate?: { __typename?: 'EventsAggregateFields', count: number } | null } };

export type GetPendingPlayRequestCountByEventQueryVariables = Exact<{
  eventId: Scalars['uuid'];
}>;


export type GetPendingPlayRequestCountByEventQuery = { __typename?: 'query_root', playRequestsAggregate: { __typename?: 'PlayRequestsAggregate', aggregate?: { __typename?: 'PlayRequestsAggregateFields', count: number } | null } };

export type GetPendingPlayRequestCountByAvailabilityQueryVariables = Exact<{
  availabilityId: Scalars['uuid'];
}>;


export type GetPendingPlayRequestCountByAvailabilityQuery = { __typename?: 'query_root', playRequestsAggregate: { __typename?: 'PlayRequestsAggregate', aggregate?: { __typename?: 'PlayRequestsAggregateFields', count: number } | null } };

export type GetPicklrP4CoachesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPicklrP4CoachesQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'Users', id: any, fullName: string, email: string, cityName: string, lastLoginAt?: any | null, coachLessonsAggregate: { __typename?: 'LessonsAggregate', aggregate?: { __typename?: 'LessonsAggregateFields', count: number, max?: { __typename?: 'LessonsMaxFields', startDateTime?: any | null } | null } | null }, coachLessons: Array<{ __typename?: 'Lessons', participantsAggregate: { __typename?: 'LessonParticipantsAggregate', aggregate?: { __typename?: 'LessonParticipantsAggregateFields', count: number } | null } }>, coachLessonReflectionsAggregate: { __typename?: 'LessonReflectionsAggregate', aggregate?: { __typename?: 'LessonReflectionsAggregateFields', count: number, max?: { __typename?: 'LessonReflectionsMaxFields', createdAt?: any | null } | null } | null } }> };

export type GetPlatformPriceByStripePriceQueryVariables = Exact<{
  stripePriceId: Scalars['String'];
}>;


export type GetPlatformPriceByStripePriceQuery = { __typename?: 'query_root', platformSubscriptionPlanPrices: Array<{ __typename?: 'PlatformSubscriptionPlanPrices', id: any, archivedAt?: any | null, createdAt: any, currency: string, interval: PlatformSubscriptionIntervalsEnum, platformSubscriptionPlanId: any, priceUnitAmount: number, stripePriceId: string }> };

export type GetPlatformSubscriptionPlanPriceByStripeIdQueryVariables = Exact<{
  stripePriceId: Scalars['String'];
}>;


export type GetPlatformSubscriptionPlanPriceByStripeIdQuery = { __typename?: 'query_root', platformSubscriptionPlanPrices: Array<{ __typename?: 'PlatformSubscriptionPlanPrices', id: any, interval: PlatformSubscriptionIntervalsEnum, platformSubscriptionPlanId: any, priceUnitAmount: number, stripePriceId: string, currency: string, plan: { __typename?: 'PlatformSubscriptionPlans', id: any, stripeProductId: string } }> };

export type GetPlayRequestByIdQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetPlayRequestByIdQuery = { __typename?: 'query_root', playRequests: Array<{ __typename?: 'PlayRequests', id: any, requesterUserId: any, recipientUserId: any, eventId?: any | null, availabilityId?: any | null, status: PlayRequestStatusesEnum }> };

export type GetPlayRequestTargetEventQueryVariables = Exact<{
  eventId: Scalars['uuid'];
  requesterUserId: Scalars['uuid'];
}>;


export type GetPlayRequestTargetEventQuery = { __typename?: 'query_root', eventsByPk?: { __typename?: 'Events', id: any, hostUserId?: any | null, canceledAt?: any | null, deletedAt?: any | null, status: EventStatusesEnum, startDateTime: any, privacy: EventPrivacyEnum } | null, requesterInvites: Array<{ __typename?: 'EventPlayerInvites', id: any }> };

export type GetPlayRequestTargetAvailabilityQueryVariables = Exact<{
  availabilityId: Scalars['uuid'];
}>;


export type GetPlayRequestTargetAvailabilityQuery = { __typename?: 'query_root', playerAvailabilitiesByPk?: { __typename?: 'PlayerAvailabilities', id: any, userId: any, isActive: boolean, deletedAt?: any | null } | null };

export type GetPlaySessionByIdQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetPlaySessionByIdQuery = { __typename?: 'query_root', playSessionsByPk?: { __typename?: 'PlaySessions', cancelReason: string, canceledAt?: any | null, deletedAt?: any | null, competitiveness?: PlaySessionMatchCompetitivenessEnum | null, courtBookingStatus: PlaySessionCourtBookingStatusesEnum, createdAt: any, currency: string, description: string, endDateTime?: any | null, extraRacketCount?: number | null, format: PlaySessionFormatsEnum, id: any, isBringingNet: boolean, participantLimit?: number | null, sport: SportsEnum, startDateTime?: any | null, status: PlaySessionStatusesEnum, targetSkillLevel?: string | null, title: string, userCustomCourtId?: any | null, locale: string, timezoneOffsetMinutes: number, timezoneName: string, timezoneAbbreviation: string, publishedAt?: any | null, priceUnitAmount: number, updatedAt: any, organizerUserId?: any | null, reminderEventId?: any | null, organizer?: { __typename?: 'Users', id: any, preferredName: string, profileImageFileName: string, profileImagePath: string, profileImageProviderUrl: string, fullName: string, username?: string | null, email: string } | null, venue?: { __typename?: 'Venues', id: any, title: string } | null, userCustomCourt?: { __typename?: 'UserCustomCourts', createdAt: any, fullAddress: string, id: any, title: string, updatedAt: any } | null, participantsAggregate: { __typename?: 'PlaySessionParticipantsAggregate', aggregate?: { __typename?: 'PlaySessionParticipantsAggregateFields', count: number } | null }, participants: Array<{ __typename?: 'PlaySessionParticipants', id: any, playSessionId: any, userId: any, status: PlaySessionParticipantStatusesEnum, user: { __typename?: 'Users', id: any, preferredName: string, fullName: string, username?: string | null, email: string, profileImageFileName: string, profileImagePath: string, profileImageProviderUrl: string, coverImageFileName: string, coverImagePath: string, coverImageProviderUrl: string } }> } | null };

export type GetPlaySessionFromCommentQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetPlaySessionFromCommentQuery = { __typename?: 'query_root', playSessionCommentsByPk?: { __typename?: 'PlaySessionComments', id: any, userId: any, content: string, playSession: { __typename?: 'PlaySessions', cancelReason: string, canceledAt?: any | null, deletedAt?: any | null, competitiveness?: PlaySessionMatchCompetitivenessEnum | null, courtBookingStatus: PlaySessionCourtBookingStatusesEnum, createdAt: any, currency: string, description: string, endDateTime?: any | null, extraRacketCount?: number | null, format: PlaySessionFormatsEnum, id: any, isBringingNet: boolean, participantLimit?: number | null, sport: SportsEnum, startDateTime?: any | null, status: PlaySessionStatusesEnum, targetSkillLevel?: string | null, title: string, userCustomCourtId?: any | null, locale: string, timezoneOffsetMinutes: number, timezoneName: string, timezoneAbbreviation: string, publishedAt?: any | null, priceUnitAmount: number, updatedAt: any, organizerUserId?: any | null, reminderEventId?: any | null, organizer?: { __typename?: 'Users', id: any, preferredName: string, profileImageFileName: string, profileImagePath: string, profileImageProviderUrl: string, fullName: string, username?: string | null, email: string } | null, userCustomCourt?: { __typename?: 'UserCustomCourts', createdAt: any, fullAddress: string, id: any, title: string, updatedAt: any } | null, participantsAggregate: { __typename?: 'PlaySessionParticipantsAggregate', aggregate?: { __typename?: 'PlaySessionParticipantsAggregateFields', count: number } | null }, participants: Array<{ __typename?: 'PlaySessionParticipants', id: any, playSessionId: any, userId: any, status: PlaySessionParticipantStatusesEnum, user: { __typename?: 'Users', id: any, preferredName: string, fullName: string, username?: string | null, email: string, profileImageFileName: string, profileImagePath: string, profileImageProviderUrl: string, coverImageFileName: string, coverImagePath: string, coverImageProviderUrl: string } }> } } | null };

export type GetPlayerActivationReportQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPlayerActivationReportQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'Users', id: any, email: string, fullName: string, preferredName: string, username?: string | null, gender?: GenderEnum | null, phoneNumber?: string | null, phoneCountryCode?: string | null, defaultSport?: SportsEnum | null, birthday?: any | null, cityName: string, createdAt: any, lastLoginAt?: any | null, isOnboardComplete: boolean, profileImagePath: string, latitude?: any | null, longitude?: any | null, geometry?: any | null, activeCity?: { __typename?: 'Cities', id: any, name: string, countrySubdivision: { __typename?: 'CountrySubdivisions', name: string } } | null, pickleballSkillLevel?: { __typename?: 'SkillLevels', displayName: string } | null, tennisSkillLevel?: { __typename?: 'SkillLevels', displayName: string } | null, participantLessonsAggregate: { __typename?: 'LessonParticipantsAggregate', aggregate?: { __typename?: 'LessonParticipantsAggregateFields', count: number } | null }, followingAggregate: { __typename?: 'UserFollowsAggregate', aggregate?: { __typename?: 'UserFollowsAggregateFields', count: number } | null } }> };

export type GetPlayerContactByBookingRequestQueryVariables = Exact<{
  bookingRequestId: Scalars['uuid'];
}>;


export type GetPlayerContactByBookingRequestQuery = { __typename?: 'query_root', coachBookingRequestsByPk?: { __typename?: 'CoachBookingRequests', id: any, coachUserId?: any | null, playerUserId: any, message?: string | null, playerUser: { __typename?: 'Users', id: any, fullName: string, email: string, phoneNumber?: string | null } } | null };

export type GetCoachPremiumUserContentForPlayerQueryVariables = Exact<{
  coachId: Scalars['uuid'];
  tier?: InputMaybe<Array<UserContentTiersEnum> | UserContentTiersEnum>;
}>;


export type GetCoachPremiumUserContentForPlayerQuery = { __typename?: 'query_root', userContentFiles: Array<{ __typename?: 'UserContentFiles', createdAt: any, description: string, fileCategory: FileCategoryEnum, fileFormat: FileFormatEnum, fileName: string, fileType: string, host: string, id: any, originalFileName?: string | null, provider: string, providerId: string, providerUrl: string, tier: UserContentTiersEnum, title: string, url: string, userContentFilesSkills: Array<{ __typename?: 'UserContentFilesSkills', userContentSkills: { __typename?: 'UserContentSkills', skill?: LessonSkillsEnum | null, customSkill?: string | null, id: any, userId: any } }> }>, userContentSkills: Array<{ __typename?: 'UserContentSkills', customSkill?: string | null, skill?: LessonSkillsEnum | null, id: any }> };

export type GetPlayerUserContentSubscribeStatusQueryVariables = Exact<{
  coachId: Scalars['uuid'];
  playerId: Scalars['uuid'];
}>;


export type GetPlayerUserContentSubscribeStatusQuery = { __typename?: 'query_root', userContentBetaSubscriptions: Array<{ __typename?: 'UserContentBetaSubscriptions', id: any }> };

export type GetProfileSeedDataQueryVariables = Exact<{
  username: Scalars['String'];
}>;


export type GetProfileSeedDataQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'Users', id: any, fullName: string, username?: string | null, preferredName: string, coachStatus?: CoachStatusEnum | null }> };

export type GetProgramBoostsQueryVariables = Exact<{
  venueId: Scalars['uuid'];
  programId: Scalars['uuid'];
  now: Scalars['timestamptz'];
}>;


export type GetProgramBoostsQuery = { __typename?: 'query_root', boosts: Array<{ __typename?: 'Boosts', channel: BoostChannelsEnum, priceUnitAmount: number, startsAt: any, endsAt: any }> };

export type GetProgramEngagementQueryVariables = Exact<{
  venueId: Scalars['uuid'];
  programId: Scalars['uuid'];
  since: Scalars['timestamptz'];
}>;


export type GetProgramEngagementQuery = { __typename?: 'query_root', engagementAnalytics: Array<{ __typename?: 'EngagementAnalytics', eventType: EngagementEventTypesEnum, entityType: EngagementEntityTypesEnum, occurredAt: any, lessonId?: any | null, eventId?: any | null, placementId?: any | null }> };

export type GetLessonForBoostQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetLessonForBoostQuery = { __typename?: 'query_root', lessonsByPk?: { __typename?: 'Lessons', id: any, venueId?: any | null, deletedAt?: any | null, title: string, venue?: { __typename?: 'Venues', title: string } | null } | null };

export type GetEventForBoostQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetEventForBoostQuery = { __typename?: 'query_root', eventsByPk?: { __typename?: 'Events', id: any, venueId?: any | null, deletedAt?: any | null, title: string, venue?: { __typename?: 'Venues', title: string } | null } | null };

export type GetClubCoachIdsQueryVariables = Exact<{
  venueId: Scalars['uuid'];
}>;


export type GetClubCoachIdsQuery = { __typename?: 'query_root', venuesByPk?: { __typename?: 'Venues', id: any, staffCoaches: Array<{ __typename?: 'VenueStaffCoaches', userId: any }> } | null };

export type GetClubEngagementQueryVariables = Exact<{
  venueId: Scalars['uuid'];
  coachIds?: InputMaybe<Array<Scalars['uuid']> | Scalars['uuid']>;
  since: Scalars['timestamptz'];
}>;


export type GetClubEngagementQuery = { __typename?: 'query_root', engagementAnalytics: Array<{ __typename?: 'EngagementAnalytics', eventType: EngagementEventTypesEnum, entityType: EngagementEntityTypesEnum, occurredAt: any, lessonId?: any | null, eventId?: any | null, placementId?: any | null }> };

export type GetQueuedPartnerBookingAttemptsQueryVariables = Exact<{
  limit: Scalars['Int'];
}>;


export type GetQueuedPartnerBookingAttemptsQuery = { __typename?: 'query_root', inFlight: { __typename?: 'PartnerBookingAttemptsAggregate', aggregate?: { __typename?: 'PartnerBookingAttemptsAggregateFields', count: number } | null }, partnerBookingAttempts: Array<{ __typename?: 'PartnerBookingAttempts', id: any, dispatchErrors: { __typename?: 'PartnerBookingAttemptEventsAggregate', aggregate?: { __typename?: 'PartnerBookingAttemptEventsAggregateFields', count: number } | null }, order: { __typename?: 'PartnerBookingOrders', id: any, venueId: any, marker: string, providerCourtId?: string | null, localDate: any, startLocal: any, startAt: any, endAt: any, externalStripePaymentIntentId?: string | null, maxPriceUnitAmount: number, venue: { __typename?: 'Venues', title: string }, integration: { __typename?: 'VenueBookingIntegrations', id: any, promoCode?: string | null, bookingSystem: BookingSystemsEnum, externalOrgId?: string | null, providerApiKeyEncrypted?: string | null } } }> };

export type GetRacketSocialAdminEventsQueryVariables = Exact<{
  email: Scalars['String'];
}>;


export type GetRacketSocialAdminEventsQuery = { __typename?: 'query_root', events: Array<{ __typename?: 'Events', id: any, slug: string, title: string, status: EventStatusesEnum, privacy: EventPrivacyEnum, startDateTime: any, endDateTime: any, timezoneName: string, displayLocation: string, cityString: string, registrationPriceUnitAmount: number, currency: string, participantLimit?: number | null, archivedAt?: any | null, canceledAt?: any | null, city?: { __typename?: 'Cities', name: string, countrySubdivision: { __typename?: 'CountrySubdivisions', code: string, name: string } } | null, venue?: { __typename?: 'Venues', title: string } | null, groups: Array<{ __typename?: 'EventGroups', id: any, title: string, startsAt?: any | null, endsAt?: any | null, registrationsAggregate: { __typename?: 'EventGroupRegistrationsAggregate', aggregate?: { __typename?: 'EventGroupRegistrationsAggregateFields', count: number } | null } }> }> };

export type GetRacketSocialAdminRegistrantsQueryVariables = Exact<{
  where: EventsBoolExp;
}>;


export type GetRacketSocialAdminRegistrantsQuery = { __typename?: 'query_root', events: Array<{ __typename?: 'Events', id: any, title: string, startDateTime: any, timezoneName: string, groups: Array<{ __typename?: 'EventGroups', id: any, title: string, startsAt?: any | null, registrations: Array<{ __typename?: 'EventGroupRegistrations', userId: any, status: EventGroupRegistrationStatusesEnum, checkedInAt?: any | null, user: { __typename?: 'Users', fullName: string, email: string, phoneCountryCode?: string | null, phoneNumber?: string | null } }> }>, registrations: Array<{ __typename?: 'EventRegistrations', userId: any, registrationDetails?: { __typename?: 'EventRegistrationDetails', referredBy?: string | null } | null }> }> };

export type GetRacketSocialEventsQueryVariables = Exact<{
  endDateAfter: Scalars['timestamptz'];
}>;


export type GetRacketSocialEventsQuery = { __typename?: 'query_root', events: Array<{ __typename?: 'Events', id: any, slug: string, title: string, startDateTime: any, endDateTime: any, registrationPriceUnitAmount: number, currency: string, coverImageUrl?: string | null, coverImagePath?: string | null, organizerImageUrl?: string | null, organizerImagePath?: string | null, displayLocation: string, addressString?: string | null, cityString: string, sourceOrganizerTitle?: string | null, timezoneName: string, city?: { __typename?: 'Cities', id: any, name: string, slug: string, countrySubdivision: { __typename?: 'CountrySubdivisions', id: any, name: string, code: string } } | null, venue?: { __typename?: 'Venues', id: any, title: string } | null, groups: Array<{ __typename?: 'EventGroups', id: any, startsAt?: any | null, endsAt?: any | null, timeSlots: Array<{ __typename?: 'EventGroupTimeSlots', id: any, startsAt: any, endsAt: any }> }> }> };

export type GetRecentSettledPartnerBookingAttemptsQueryVariables = Exact<{
  limit: Scalars['Int'];
}>;


export type GetRecentSettledPartnerBookingAttemptsQuery = { __typename?: 'query_root', partnerBookingAttempts: Array<{ __typename?: 'PartnerBookingAttempts', id: any, status: PartnerBookingAttemptStatusesEnum, botCallbacks: { __typename?: 'PartnerBookingAttemptEventsAggregate', aggregate?: { __typename?: 'PartnerBookingAttemptEventsAggregateFields', count: number } | null } }> };

export type GetRecentSignupRequestForRepairQueryVariables = Exact<{
  email: Scalars['String'];
}>;


export type GetRecentSignupRequestForRepairQuery = { __typename?: 'query_root', signupRequests: Array<{ __typename?: 'SignupRequests', accountType: string, createdAt: any, email: string, id: any, ip: string, username: string, fullName: string, preferredName: string, zip: string, timezone: string, region: string, platform: string, fullDetails?: any | null, country: string, city: string, latitude?: any | null, longitude?: any | null, cityId?: any | null, eventOrganizerAccountType?: EventOrganizerAccountTypesEnum | null, phoneNumber?: string | null }> };

export type GetRegistrationsForCancellationQueryVariables = Exact<{
  eventId: Scalars['uuid'];
}>;


export type GetRegistrationsForCancellationQuery = { __typename?: 'query_root', eventGroupRegistrations: Array<{ __typename?: 'EventGroupRegistrations', id: any, userId: any, paymentFulfillmentChannel?: PaymentFulfillmentChannelsEnum | null, transactionItems: Array<{ __typename?: 'EventTransactionItems', id: any, totalUnitAmount: number, refundUnitAmount: number, status: OrderStatusesEnum, transaction: { __typename?: 'EventTransactions', id: any, externalStripePaymentIntentId: string } }> }>, eventRegistrations: Array<{ __typename?: 'EventRegistrations', id: any, userId: any, transactionItems: Array<{ __typename?: 'EventTransactionItems', id: any, totalUnitAmount: number, refundUnitAmount: number, status: OrderStatusesEnum, transaction: { __typename?: 'EventTransactions', id: any, externalStripePaymentIntentId: string } }> }> };

export type GetRegistrationsForWithdrawalQueryVariables = Exact<{
  ids: Array<Scalars['uuid']> | Scalars['uuid'];
  userId: Scalars['uuid'];
}>;


export type GetRegistrationsForWithdrawalQuery = { __typename?: 'query_root', eventGroupRegistrations: Array<{ __typename?: 'EventGroupRegistrations', id: any, userId: any, teamId?: any | null, paymentFulfillmentChannel?: PaymentFulfillmentChannelsEnum | null, group: { __typename?: 'EventGroups', id: any, event: { __typename?: 'Events', id: any, registrationDeadlineDateTime?: any | null, registrations: Array<{ __typename?: 'EventRegistrations', id: any, transactionItems: Array<{ __typename?: 'EventTransactionItems', id: any, totalUnitAmount: number, refundUnitAmount: number, status: OrderStatusesEnum, transaction: { __typename?: 'EventTransactions', id: any, externalStripePaymentIntentId: string } }> }> }, teams: Array<{ __typename?: 'EventTeams', id: any, members: Array<{ __typename?: 'EventTeamMembers', id: any, userId: any }> }> }, transactionItems: Array<{ __typename?: 'EventTransactionItems', id: any, totalUnitAmount: number, refundUnitAmount: number, status: OrderStatusesEnum, transaction: { __typename?: 'EventTransactions', id: any, externalStripePaymentIntentId: string } }> }> };

export type GetSaleByStripeSessionIdQueryVariables = Exact<{
  stripeSessionId: Scalars['String'];
}>;


export type GetSaleByStripeSessionIdQuery = { __typename?: 'query_root', sales: Array<{ __typename?: 'Sales', id: any, status: PaymentStatusesEnum, stripeCustomerId: string, stripePaymentStatus: string, stripePriceId?: string | null, stripeSessionId: string, user: { __typename?: 'Users', email: string, stripeCustomerId: string, id: any } }> };

export type GetSubdivisionsForCountryQueryVariables = Exact<{
  countryId: Scalars['String'];
}>;


export type GetSubdivisionsForCountryQuery = { __typename?: 'query_root', countrySubdivisions: Array<{ __typename?: 'CountrySubdivisions', id: any, name: string, type: string }> };

export type GetTeamNextUnplayedMatchQueryVariables = Exact<{
  teamId: Scalars['uuid'];
}>;


export type GetTeamNextUnplayedMatchQuery = { __typename?: 'query_root', eventMatches: Array<{ __typename?: 'EventMatches', id: any, team1Id?: any | null, team2Id?: any | null }> };

export type GetTeamUnplayedMatchesQueryVariables = Exact<{
  teamId: Scalars['uuid'];
}>;


export type GetTeamUnplayedMatchesQuery = { __typename?: 'query_root', eventMatches: Array<{ __typename?: 'EventMatches', id: any, team1Id?: any | null, team2Id?: any | null }> };

export type GetTeamUnplayedMatchesWithCourtInfoQueryVariables = Exact<{
  teamId: Scalars['uuid'];
}>;


export type GetTeamUnplayedMatchesWithCourtInfoQuery = { __typename?: 'query_root', eventMatches: Array<{ __typename?: 'EventMatches', id: any, team1Id?: any | null, team2Id?: any | null, eventCourtId?: any | null, courtNumber?: number | null }> };

export type GetTennisRatingScalesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTennisRatingScalesQuery = { __typename?: 'query_root', tennisRatingScales: Array<{ __typename?: 'TennisRatingScales', id: any, maximum: any, minimum: any, name: string, order: number, shortName: string }> };

export type GetTournamentReportQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTournamentReportQuery = { __typename?: 'query_root', events: Array<{ __typename?: 'Events', id: any, title: string, status: EventStatusesEnum, sport: SportsEnum, startDate: any, startDateTime: any, endDate: any, createdAt: any, displayLocation: string, cityString: string, regionString: string, registrationPriceUnitAmount: number, currency: string, sourceRegistrationCount: number, sourceOrganizerTitle?: string | null, source?: string | null, isExternal: boolean, isQuickCreate: boolean, city?: { __typename?: 'Cities', name: string, countrySubdivision: { __typename?: 'CountrySubdivisions', name: string } } | null, hostUser?: { __typename?: 'Users', fullName: string, email: string } | null, registrationsAggregate: { __typename?: 'EventRegistrationsAggregate', aggregate?: { __typename?: 'EventRegistrationsAggregateFields', count: number } | null }, groups: Array<{ __typename?: 'EventGroups', id: any, format?: EventGroupFormatsEnum | null }>, groupsAggregate: { __typename?: 'EventGroupsAggregate', aggregate?: { __typename?: 'EventGroupsAggregateFields', count: number } | null } }> };

export type GetTournamentReportDashboardQueryVariables = Exact<{
  oneDayAgo: Scalars['timestamptz'];
  sevenDaysAgo: Scalars['timestamptz'];
  thirtyDaysAgo: Scalars['timestamptz'];
}>;


export type GetTournamentReportDashboardQuery = { __typename?: 'query_root', events: Array<{ __typename?: 'Events', id: any, createdAt: any, isExternal: boolean, isQuickCreate: boolean, isVairRequired?: boolean | null, source?: string | null, groups: Array<{ __typename?: 'EventGroups', format?: EventGroupFormatsEnum | null }> }>, vairGroupsAll: { __typename?: 'EventGroupsAggregate', aggregate?: { __typename?: 'EventGroupsAggregateFields', count: number } | null }, vairGroups30d: { __typename?: 'EventGroupsAggregate', aggregate?: { __typename?: 'EventGroupsAggregateFields', count: number } | null }, vairGroups7d: { __typename?: 'EventGroupsAggregate', aggregate?: { __typename?: 'EventGroupsAggregateFields', count: number } | null }, vairGroups24h: { __typename?: 'EventGroupsAggregate', aggregate?: { __typename?: 'EventGroupsAggregateFields', count: number } | null }, vairMatchesTotal: { __typename?: 'EventMatchesAggregate', aggregate?: { __typename?: 'EventMatchesAggregateFields', count: number } | null }, vairMatchesSubmitted: { __typename?: 'EventMatchesAggregate', aggregate?: { __typename?: 'EventMatchesAggregateFields', count: number } | null }, vairMatchesSubmitted30d: { __typename?: 'EventMatchesAggregate', aggregate?: { __typename?: 'EventMatchesAggregateFields', count: number } | null }, vairMatchesSubmitted7d: { __typename?: 'EventMatchesAggregate', aggregate?: { __typename?: 'EventMatchesAggregateFields', count: number } | null }, vairMatchesSubmitted24h: { __typename?: 'EventMatchesAggregate', aggregate?: { __typename?: 'EventMatchesAggregateFields', count: number } | null }, vairConnectionsAll: { __typename?: 'UserVairConnectionsAggregate', aggregate?: { __typename?: 'UserVairConnectionsAggregateFields', count: number } | null }, vairConnections30d: { __typename?: 'UserVairConnectionsAggregate', aggregate?: { __typename?: 'UserVairConnectionsAggregateFields', count: number } | null }, vairConnections7d: { __typename?: 'UserVairConnectionsAggregate', aggregate?: { __typename?: 'UserVairConnectionsAggregateFields', count: number } | null }, vairConnections24h: { __typename?: 'UserVairConnectionsAggregate', aggregate?: { __typename?: 'UserVairConnectionsAggregateFields', count: number } | null } };

export type GetTournamentStaticDataByIdQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetTournamentStaticDataByIdQuery = { __typename?: 'query_root', eventsByPk?: { __typename?: 'Events', addressString?: string | null, cityId?: any | null, coverImageFileName?: string | null, coverImagePath?: string | null, coverImageUrl?: string | null, currency: string, createdAt: any, description: string, displayLocation: string, endDate: any, endDateTime: any, externalUrl?: string | null, geometry?: any | null, hasPrizes: boolean, id: any, isExternal: boolean, isShowPlayersGoing: boolean, organizerImageUrl?: string | null, organizerImagePath?: string | null, locale: string, isSanctioned: boolean, privacy: EventPrivacyEnum, prizeDescription: string, publishedAt?: any | null, canceledAt?: any | null, cancelReason: string, registrationClosedAt?: any | null, registrationDeadlineDate: any, registrationDeadlineDateTime?: any | null, registrationPriceUnitAmount: number, slug: string, scoringFormat?: ScoringFormatEnum | null, sport: SportsEnum, startDate: any, startDateTime: any, status: EventStatusesEnum, title: string, type: EventTypesEnum, isRfx: boolean, timezoneName: string, timezoneOffsetMinutes: number, timezoneAbbreviation: string, sourceRegistrationCount: number, sourceOrganizerTitle?: string | null, groupFormat?: EventGroupFormatsEnum | null, isRatingRequired: boolean, ballCustomName: string, ballType: BallTypesEnum, city?: { __typename?: 'Cities', id: any, name: string, slug: string, countrySubdivision: { __typename?: 'CountrySubdivisions', id: any, name: string, slug: string, code: string, country: { __typename?: 'Countries', id: string, name: string, slug: string } } } | null, venue?: { __typename?: 'Venues', id: any, title: string, venueSlug: string, slug: string, pickleballLines?: VenueLinesEnum | null, pickleballNets?: VenueNetsEnum | null, longitude: any, latitude: any, geometry?: any | null, addressString: string, outdoorCourtCount: number, indoorCourtCount: number, timezone: string, images: Array<{ __typename?: 'VenueImages', id: any, path: string, url: string }>, courtSurfaces: Array<{ __typename?: 'VenueCourtSurfaces', id: any, courtSurface: CourtSurfacesEnum }> } | null, pickleballRatingScale?: { __typename?: 'PickleballRatingScales', id: any, maximum: any, minimum: any, name: string, shortName: string } | null, hostUserProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null } | null, faqs: Array<{ __typename?: 'EventFaqs', id: any, question: string, answer: string }> } | null };

export type GetTournamentStaticDataBySlugQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type GetTournamentStaticDataBySlugQuery = { __typename?: 'query_root', events: Array<{ __typename?: 'Events', addressString?: string | null, cityId?: any | null, coverImageFileName?: string | null, coverImagePath?: string | null, coverImageUrl?: string | null, currency: string, createdAt: any, description: string, displayLocation: string, endDate: any, endDateTime: any, externalUrl?: string | null, geometry?: any | null, hasPrizes: boolean, id: any, isExternal: boolean, isShowPlayersGoing: boolean, organizerImageUrl?: string | null, organizerImagePath?: string | null, locale: string, isSanctioned: boolean, privacy: EventPrivacyEnum, prizeDescription: string, publishedAt?: any | null, canceledAt?: any | null, cancelReason: string, registrationClosedAt?: any | null, registrationDeadlineDate: any, registrationDeadlineDateTime?: any | null, registrationPriceUnitAmount: number, slug: string, scoringFormat?: ScoringFormatEnum | null, sport: SportsEnum, startDate: any, startDateTime: any, status: EventStatusesEnum, title: string, type: EventTypesEnum, isRfx: boolean, timezoneName: string, timezoneOffsetMinutes: number, timezoneAbbreviation: string, sourceRegistrationCount: number, sourceOrganizerTitle?: string | null, groupFormat?: EventGroupFormatsEnum | null, isRatingRequired: boolean, ballCustomName: string, ballType: BallTypesEnum, city?: { __typename?: 'Cities', id: any, name: string, slug: string, countrySubdivision: { __typename?: 'CountrySubdivisions', id: any, name: string, slug: string, code: string, country: { __typename?: 'Countries', id: string, name: string, slug: string } } } | null, venue?: { __typename?: 'Venues', id: any, title: string, venueSlug: string, slug: string, pickleballLines?: VenueLinesEnum | null, pickleballNets?: VenueNetsEnum | null, longitude: any, latitude: any, geometry?: any | null, addressString: string, outdoorCourtCount: number, indoorCourtCount: number, timezone: string, images: Array<{ __typename?: 'VenueImages', id: any, path: string, url: string }>, courtSurfaces: Array<{ __typename?: 'VenueCourtSurfaces', id: any, courtSurface: CourtSurfacesEnum }> } | null, pickleballRatingScale?: { __typename?: 'PickleballRatingScales', id: any, maximum: any, minimum: any, name: string, shortName: string } | null, hostUserProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null } | null, faqs: Array<{ __typename?: 'EventFaqs', id: any, question: string, answer: string }> }> };

export type GetTournamentsByCityWithLimitAndCountQueryVariables = Exact<{
  citySlug: Scalars['String'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type GetTournamentsByCityWithLimitAndCountQuery = { __typename?: 'query_root', events: Array<{ __typename?: 'Events', coverImagePath?: string | null, displayLocation: string, endDateTime: any, hasPrizes: boolean, id: any, latitude?: any | null, locale: string, longitude?: any | null, organizerImagePath?: string | null, registrationClosedAt?: any | null, registrationDeadlineDate: any, registrationPriceUnitAmount: number, scoringFormat?: ScoringFormatEnum | null, slug: string, isExternal: boolean, sourceRegistrationCount: number, sourceOrganizerTitle?: string | null, startDateTime: any, status: EventStatusesEnum, timezoneAbbreviation: string, timezoneName: string, timezoneOffsetMinutes: number, title: string, geometry?: any | null, city?: { __typename?: 'Cities', name: string, id: any, slug: string, timezone?: string | null, countrySubdivision: { __typename?: 'CountrySubdivisions', name: string, id: any, code: string } } | null, registrationsAggregate: { __typename?: 'EventRegistrationsAggregate', aggregate?: { __typename?: 'EventRegistrationsAggregateFields', count: number } | null } }> };

export type GetTournamentsCountByCityQueryVariables = Exact<{
  citySlug: Scalars['String'];
}>;


export type GetTournamentsCountByCityQuery = { __typename?: 'query_root', events: Array<{ __typename?: 'Events', id: any }> };

export type GetTournamentsForMarketplaceQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTournamentsForMarketplaceQuery = { __typename?: 'query_root', events: Array<{ __typename?: 'Events', coverImagePath?: string | null, displayLocation: string, endDateTime: any, hasPrizes: boolean, id: any, latitude?: any | null, locale: string, longitude?: any | null, organizerImagePath?: string | null, registrationClosedAt?: any | null, registrationDeadlineDate: any, registrationPriceUnitAmount: number, groupFormat?: EventGroupFormatsEnum | null, scoringFormat?: ScoringFormatEnum | null, slug: string, sport: SportsEnum, source?: string | null, isExternal: boolean, isVairRequired?: boolean | null, currency: string, sourceRegistrationCount: number, sourceOrganizerTitle?: string | null, startDateTime: any, status: EventStatusesEnum, timezoneAbbreviation: string, timezoneName: string, timezoneOffsetMinutes: number, title: string, city?: { __typename?: 'Cities', name: string, id: any, timezone?: string | null, countrySubdivision: { __typename?: 'CountrySubdivisions', name: string, id: any, code: string } } | null, groups: Array<{ __typename?: 'EventGroups', id: any, gender: CompetitionGenderEnum, teamType?: TeamTypesEnum | null, format?: EventGroupFormatsEnum | null, isMoneyBall?: boolean | null, minimumAge?: number | null, maximumAge?: number | null }>, venue?: { __typename?: 'Venues', id: any, timezone: string, addressString: string } | null, registrationsAggregate: { __typename?: 'EventRegistrationsAggregate', aggregate?: { __typename?: 'EventRegistrationsAggregateFields', count: number } | null } }> };

export type GetTournamentsForStateQueryVariables = Exact<{
  stateId: Scalars['uuid'];
}>;


export type GetTournamentsForStateQuery = { __typename?: 'query_root', events: Array<{ __typename?: 'Events', addressString?: string | null, coverImagePath?: string | null, coverImageUrl?: string | null, displayLocation: string, description: string, endDateTime: any, hasPrizes: boolean, id: any, latitude?: any | null, locale: string, longitude?: any | null, organizerImagePath?: string | null, registrationClosedAt?: any | null, registrationDeadlineDate: any, registrationPriceUnitAmount: number, scoringFormat?: ScoringFormatEnum | null, slug: string, isExternal: boolean, sourceRegistrationCount: number, sourceOrganizerTitle?: string | null, startDateTime: any, status: EventStatusesEnum, timezoneAbbreviation: string, timezoneName: string, timezoneOffsetMinutes: number, title: string, geometry?: any | null, city?: { __typename?: 'Cities', name: string, id: any, timezone?: string | null, countrySubdivision: { __typename?: 'CountrySubdivisions', name: string, id: any, code: string } } | null, registrationsAggregate: { __typename?: 'EventRegistrationsAggregate', aggregate?: { __typename?: 'EventRegistrationsAggregateFields', count: number } | null }, venue?: { __typename?: 'Venues', id: any, title: string, venueSlug: string, slug: string, addressString: string, pickleballLines?: VenueLinesEnum | null, pickleballNets?: VenueNetsEnum | null, longitude: any, latitude: any, geometry?: any | null, outdoorCourtCount: number, indoorCourtCount: number, timezone: string, images: Array<{ __typename?: 'VenueImages', id: any, path: string, url: string }>, courtSurfaces: Array<{ __typename?: 'VenueCourtSurfaces', id: any, courtSurface: CourtSurfacesEnum }> } | null }> };

export type GetTwilioConversationByParticipantsKeyQueryVariables = Exact<{
  participantsKey: Scalars['String'];
}>;


export type GetTwilioConversationByParticipantsKeyQuery = { __typename?: 'query_root', twilioGroupTexts: Array<{ __typename?: 'TwilioGroupTexts', participantsKey: string, twilioConversationSid: string, id: any }> };

export type GetUserByEmailQueryVariables = Exact<{
  email: Scalars['String'];
}>;


export type GetUserByEmailQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'Users', id: any, email: string, stripeCustomerId: string, firebaseId: string, fullName: string, preferredName: string, profileImageUrl: string, profileImagePath: string }> };

export type GetUserByFirebaseIdQueryVariables = Exact<{
  firebaseId: Scalars['String'];
}>;


export type GetUserByFirebaseIdQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'Users', id: any, email: string, stripeCustomerId: string, firebaseId: string, fullName: string, preferredName: string }> };

export type GetUserByStripeCustomerIdQueryVariables = Exact<{
  stripeCustomerId: Scalars['String'];
}>;


export type GetUserByStripeCustomerIdQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'Users', email: string, id: any, stripeCustomerId: string, stripeMerchantId?: string | null, stripeMerchantChargesEnabled: boolean, stripeMerchantDetailsSubmitted: boolean, stripeMerchantEventuallyDue?: any | null, stripeMerchantCurrentlyDue?: any | null, stripeMerchantPastDue?: any | null, stripeMerchantPayoutsEnabled: boolean, stripeMerchantCountry?: string | null, stripeMerchantBusinessType?: string | null, stripeMerchantCurrency?: string | null }> };

export type GetUserByStripeMerchantIdQueryVariables = Exact<{
  stripeMerchantId: Scalars['String'];
}>;


export type GetUserByStripeMerchantIdQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'Users', email: string, id: any, stripeCustomerId: string, stripeMerchantId?: string | null, stripeMerchantChargesEnabled: boolean, stripeMerchantDetailsSubmitted: boolean, stripeMerchantEventuallyDue?: any | null, stripeMerchantCurrentlyDue?: any | null, stripeMerchantPastDue?: any | null, stripeMerchantPayoutsEnabled: boolean, stripeMerchantCountry?: string | null, stripeMerchantBusinessType?: string | null, stripeMerchantCurrency?: string | null }> };

export type GetUserByVairMemberIdQueryVariables = Exact<{
  memberId: Scalars['String'];
}>;


export type GetUserByVairMemberIdQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'Users', id: any, firebaseId: string, userVairConnection?: { __typename?: 'UserVairConnections', name: string, email: string } | null }> };

export type GetUserCommunicationPreferencesQueryVariables = Exact<{
  userIdList: Array<UserCommunicationPreferencesBoolExp> | UserCommunicationPreferencesBoolExp;
}>;


export type GetUserCommunicationPreferencesQuery = { __typename?: 'query_root', userCommunicationPreferences: Array<{ __typename?: 'UserCommunicationPreferences', id: any, lessonBookedEmail: CommunicationPreferenceStatusesEnum, lessonBookedPush: CommunicationPreferenceStatusesEnum, lessonCanceledEmail: CommunicationPreferenceStatusesEnum, lessonCanceledPushed: CommunicationPreferenceStatusesEnum, lessonReminderEmail: CommunicationPreferenceStatusesEnum, lessonReminderPush: CommunicationPreferenceStatusesEnum, marketingEmail: CommunicationPreferenceStatusesEnum, marketingPush: CommunicationPreferenceStatusesEnum, newFollowerEmail: CommunicationPreferenceStatusesEnum, newFollowerPush: CommunicationPreferenceStatusesEnum, newLessonPublishedEmail: CommunicationPreferenceStatusesEnum, newLessonPublishedPush: CommunicationPreferenceStatusesEnum, participantLeftLessonEmail: CommunicationPreferenceStatusesEnum, participantLeftLessonPush: CommunicationPreferenceStatusesEnum, payoutEmail: CommunicationPreferenceStatusesEnum, payoutPush: CommunicationPreferenceStatusesEnum, playSessionCanceledEmail: CommunicationPreferenceStatusesEnum, playSessionCanceledPush: CommunicationPreferenceStatusesEnum, playSessionParticipantJoinedEmail: CommunicationPreferenceStatusesEnum, playSessionParticipantJoinedPush: CommunicationPreferenceStatusesEnum, playSessionParticipantLeftEmail: CommunicationPreferenceStatusesEnum, playSessionParticipantLeftPush: CommunicationPreferenceStatusesEnum, playSessionReminderEmail: CommunicationPreferenceStatusesEnum, playSessionReminderPush: CommunicationPreferenceStatusesEnum }> };

export type GetUserCreditCardByIdQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetUserCreditCardByIdQuery = { __typename?: 'query_root', userCreditCardsByPk?: { __typename?: 'UserCreditCards', id: any, userId: any, providerCardId: string, last4: string, brand: string, expireMonth: number, expireYear: number, billingName?: string | null } | null };

export type GetUserEmailByIdQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetUserEmailByIdQuery = { __typename?: 'query_root', usersByPk?: { __typename?: 'Users', id: any, email: string, username?: string | null, fullName: string, preferredName: string, profileImageUrl: string, profileImagePath: string } | null };

export type GetUserFollowCoachQueryVariables = Exact<{
  coachId: Scalars['uuid'];
  userId: Scalars['uuid'];
}>;


export type GetUserFollowCoachQuery = { __typename?: 'query_root', userFollows: Array<{ __typename?: 'UserFollows', id: any, followerUserId: any, followedUserId: any, status: FollowStatusesEnum, followerProfile?: { __typename?: 'UserProfiles', id?: any | null, username?: string | null, profileImageUrl?: string | null, fullName?: string | null } | null }> };

export type GetUserFollowerProfilesQueryVariables = Exact<{
  followedUserId: Scalars['uuid'];
}>;


export type GetUserFollowerProfilesQuery = { __typename?: 'query_root', userFollows: Array<{ __typename?: 'UserFollows', status: FollowStatusesEnum, followerUserId: any, followedUserId: any, followerProfile?: { __typename?: 'UserProfiles', id?: any | null, preferredName?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, fullName?: string | null, username?: string | null } | null, userFollowerProfile: { __typename?: 'Users', email: string } }> };

export type GetUserForDeletionQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetUserForDeletionQuery = { __typename?: 'query_root', usersByPk?: { __typename?: 'Users', id: any, email: string, username?: string | null, firebaseId: string, coachStatus?: CoachStatusEnum | null } | null };

export type GetUserGroupRegistrationForGroupQueryVariables = Exact<{
  userId: Scalars['uuid'];
  groupId: Scalars['uuid'];
}>;


export type GetUserGroupRegistrationForGroupQuery = { __typename?: 'query_root', eventGroupRegistrations: Array<{ __typename?: 'EventGroupRegistrations', id: any, teamId?: any | null, team?: { __typename?: 'EventTeams', id: any, membersAggregate: { __typename?: 'EventTeamMembersAggregate', aggregate?: { __typename?: 'EventTeamMembersAggregateFields', count: number } | null } } | null }> };

export type GetCalendarAccountsQueryVariables = Exact<{
  userId: Scalars['uuid'];
}>;


export type GetCalendarAccountsQuery = { __typename?: 'query_root', calendarAccounts: Array<{ __typename?: 'CalendarAccounts', id: any, email?: string | null, provider: CalendarAuthProviderEnum, accessToken: string, refreshToken?: string | null, expiresAt?: any | null, createdAt: any, updatedAt: any, calendarPreferences: Array<{ __typename?: 'CalendarPreferences', id: any, calendarId: string, calendarName: string, isEnabled: boolean, isWritable: boolean }> }> };

export type GetVairConnectionQueryVariables = Exact<{
  userId: Scalars['uuid'];
}>;


export type GetVairConnectionQuery = { __typename?: 'query_root', userVairConnections: Array<{ __typename?: 'UserVairConnections', id: any, userId: any, memberId: string, clerkId?: string | null, accessToken: string, refreshToken: string, tokenExpiry: any, connectedAt: any, lastSyncedAt: any, name: string, email: string }> };

export type GetVairConnectionByEmailQueryVariables = Exact<{
  email: Scalars['String'];
}>;


export type GetVairConnectionByEmailQuery = { __typename?: 'query_root', userVairConnections: Array<{ __typename?: 'UserVairConnections', userId: any, memberId: string, connectedAt: any }> };

export type GetVairConnectionsByUserIdsQueryVariables = Exact<{
  userIds: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type GetVairConnectionsByUserIdsQuery = { __typename?: 'query_root', userVairConnections: Array<{ __typename?: 'UserVairConnections', id: any, userId: any, memberId: string, name: string, email: string }> };

export type GetVairProStatsQueryVariables = Exact<{
  userId: Scalars['uuid'];
}>;


export type GetVairProStatsQuery = { __typename?: 'query_root', ratingSessions: { __typename?: 'EventsAggregate', aggregate?: { __typename?: 'EventsAggregateFields', count: number } | null }, integratedEvents: { __typename?: 'EventsAggregate', aggregate?: { __typename?: 'EventsAggregateFields', count: number } | null } };

export type GetVenueBookingConfigQueryVariables = Exact<{
  venueId: Scalars['uuid'];
}>;


export type GetVenueBookingConfigQuery = { __typename?: 'query_root', venueBookingIntegrations: Array<{ __typename?: 'VenueBookingIntegrations', id: any, bookingSystem: BookingSystemsEnum, isPreferredPartner: boolean, partnerPricingEnabled: boolean, referralFeeEnabled: boolean, referralFeeCents: number, status: BookingIntegrationStatusesEnum, currentVersion: number, rules: Array<{ __typename?: 'VenueBookingRules', inventoryType: BookingInventoryTypesEnum, scheduleMode: BookingScheduleModesEnum, isCustomPricing: boolean, tiers: Array<{ __typename?: 'VenueBookingRuleTiers', leadTimeHours: number, discountPercent: any, isEnabled: boolean }>, windows: Array<{ __typename?: 'VenueBookingWindows', dayOfWeek: DayOfWeekEnum, startTime: any, endTime: any }> }> }> };

export type GetVenueBookingConnectionCheckQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetVenueBookingConnectionCheckQuery = { __typename?: 'query_root', venueBookingConnectionChecksByPk?: { __typename?: 'VenueBookingConnectionChecks', id: any, integration: { __typename?: 'VenueBookingIntegrations', id: any, venueId: any, venue: { __typename?: 'Venues', title: string, timezone: string } } } | null };

export type GetStaleVenueBookingConnectionChecksQueryVariables = Exact<{
  before: Scalars['timestamptz'];
}>;


export type GetStaleVenueBookingConnectionChecksQuery = { __typename?: 'query_root', venueBookingConnectionChecks: Array<{ __typename?: 'VenueBookingConnectionChecks', id: any, integration: { __typename?: 'VenueBookingIntegrations', id: any, venue: { __typename?: 'Venues', title: string } } }> };

export type GetVenueBoostsQueryVariables = Exact<{
  venueId: Scalars['uuid'];
  now: Scalars['timestamptz'];
}>;


export type GetVenueBoostsQuery = { __typename?: 'query_root', boosts: Array<{ __typename?: 'Boosts', id: any, entityType: EngagementEntityTypesEnum, lesson?: { __typename?: 'Lessons', id: any, title: string, startDateTime?: any | null, coverImageProviderUrl: string, ownerProfile?: { __typename?: 'UserProfiles', fullName?: string | null } | null } | null, event?: { __typename?: 'Events', id: any, title: string, startDateTime: any, coverImageProviderUrl?: string | null, sourceOrganizerTitle?: string | null, hostUserProfile?: { __typename?: 'UserProfiles', fullName?: string | null } | null } | null }> };

export type GetVenueBySlugQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type GetVenueBySlugQuery = { __typename?: 'query_root', venues: Array<{ __typename?: 'Venues', accessType?: VenueAccessTypesEnum | null, addressString: string, coordinatesWkb: string, description: string, email: string, facilityType?: VenueFacilityTypesEnum | null, featuredPriority?: number | null, hasPickleball: boolean, hasTennis: boolean, hasPadel: boolean, hasReservations?: boolean | null, id: any, instagramUrl?: string | null, facebookUrl?: string | null, youtubeUrl?: string | null, linkedinUrl?: string | null, twitterUrl?: string | null, indoorCourtCount: number, latitude: any, longitude: any, outdoorCourtCount: number, phoneNumber: string, pickleballLines?: VenueLinesEnum | null, pickleballNets?: VenueNetsEnum | null, scheduleDetails: string, shouldHideDefaultDescription: boolean, slug: string, timezone: string, title: string, websiteUrl: string, amenities: Array<{ __typename?: 'VenueAmenities', id: any, amenity: AmenitiesEnum }>, faqs: Array<{ __typename?: 'VenueFaqs', id: any, question: string, answer: string, position: number }>, city?: { __typename?: 'Cities', id: any, latitude: any, longitude: any, name: string, slug: string, timezone?: string | null, countrySubdivision: { __typename?: 'CountrySubdivisions', id: any, latitude?: any | null, longitude?: any | null, name: string, slug: string, country: { __typename?: 'Countries', name: string, nameSlug: string, slug: string, id: string } }, venues: Array<{ __typename?: 'Venues', accessType?: VenueAccessTypesEnum | null, addressString: string, id: any, pickleballNets?: VenueNetsEnum | null, slug: string, outdoorCourtCount: number, indoorCourtCount: number, title: string, images: Array<{ __typename?: 'VenueImages', id: any, isVisible: boolean, fileName: string, fileType?: string | null, path: string, provider: string, url: string }> }> } | null, courtSurfaces: Array<{ __typename?: 'VenueCourtSurfaces', id: any, courtSurface: CourtSurfacesEnum }>, customAmenities: Array<{ __typename?: 'VenueCustomAmenities', id: any, name: string }>, equipment: Array<{ __typename?: 'VenueEquipment', id: any, equipment: EquipmentAvailabilitiesEnum }>, images: Array<{ __typename?: 'VenueImages', id: any, fileName: string, fileType?: string | null, host: string, isCover: boolean, path: string, provider: string, providerId: string, url: string }> }>, followers: { __typename?: 'VenueFollowsAggregate', aggregate?: { __typename?: 'VenueFollowsAggregateFields', count: number } | null } };

export type GetVenueClaimStatusQueryVariables = Exact<{
  venueId: Scalars['uuid'];
}>;


export type GetVenueClaimStatusQuery = { __typename?: 'query_root', venuesByPk?: { __typename?: 'Venues', id: any, title: string, slug: string, isActive: boolean, deletedAt?: any | null, adminUser?: { __typename?: 'Users', id: any } | null } | null, venueAdminClaims: Array<{ __typename?: 'VenueAdminClaims', id: any, userId: any, status: VenueAdminClaimStatusesEnum }> };

export type ClubVenueGeometryQueryVariables = Exact<{
  venueId: Scalars['uuid'];
}>;


export type ClubVenueGeometryQuery = { __typename?: 'query_root', venuesByPk?: { __typename?: 'Venues', id: any, geometry?: any | null } | null };

export type GetVenueProfileByIdQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetVenueProfileByIdQuery = { __typename?: 'query_root', venuesByPk?: { __typename?: 'Venues', id: any, slug: string, title: string, description: string, addressString: string, latitude: any, longitude: any, timezone: string, googlePlaceId?: string | null, cityId?: any | null, email: string, phoneNumber: string, websiteUrl: string, accessType?: VenueAccessTypesEnum | null, facilityType?: VenueFacilityTypesEnum | null, indoorCourtCount: number, outdoorCourtCount: number, pickleballNets?: VenueNetsEnum | null, pickleballLines?: VenueLinesEnum | null, isActive: boolean, deletedAt?: any | null, hasPickleball: boolean, hasTennis: boolean, hasPadel: boolean, hasReservations?: boolean | null, instagramUrl?: string | null, facebookUrl?: string | null, youtubeUrl?: string | null, linkedinUrl?: string | null, twitterUrl?: string | null, amenities: Array<{ __typename?: 'VenueAmenities', id: any, amenity: AmenitiesEnum }>, courtSurfaces: Array<{ __typename?: 'VenueCourtSurfaces', id: any, courtSurface: CourtSurfacesEnum }>, equipment: Array<{ __typename?: 'VenueEquipment', id: any, equipment: EquipmentAvailabilitiesEnum }>, customAmenities: Array<{ __typename?: 'VenueCustomAmenities', id: any, name: string }>, faqs: Array<{ __typename?: 'VenueFaqs', id: any, question: string, answer: string, position: number }>, images: Array<{ __typename?: 'VenueImages', id: any, fileName: string, path: string, provider: string, providerId: string, url: string, isCover: boolean }> } | null };

export type GetVenueProgramsQueryVariables = Exact<{
  venueId: Scalars['uuid'];
  startDate: Scalars['timestamptz'];
  endDate: Scalars['timestamptz'];
}>;


export type GetVenueProgramsQuery = { __typename?: 'query_root', lessons: Array<{ __typename?: 'Lessons', id: any, title: string, description: string, sport: SportsEnum, type: LessonTypesEnum, typeCustom: string, startDateTime?: any | null, endDateTime?: any | null, timezoneName: string, externalBookingUrl: string, coverImageProviderUrl: string, priceUnitAmount: number, currency: string, participantLimit?: number | null, ownerProfile?: { __typename?: 'UserProfiles', fullName?: string | null, username?: string | null } | null, userCustomCourt?: { __typename?: 'UserCustomCourts', fullAddress: string } | null, venue?: { __typename?: 'Venues', addressString: string, title: string, latitude: any, longitude: any, images: Array<{ __typename?: 'VenueImages', id: any, url: string, path: string }> } | null }>, events: Array<{ __typename?: 'Events', id: any, title: string, description: string, sport: SportsEnum, type: EventTypesEnum, startDateTime: any, endDateTime: any, timezoneName: string, externalUrl?: string | null, coverImageProviderUrl?: string | null, registrationPriceUnitAmount: number, currency: string, participantLimit?: number | null, addressString?: string | null, sourceOrganizerTitle?: string | null, hostUserProfile?: { __typename?: 'UserProfiles', fullName?: string | null } | null, venue?: { __typename?: 'Venues', addressString: string, title: string, latitude: any, longitude: any, images: Array<{ __typename?: 'VenueImages', id: any, url: string, path: string }> } | null }> };

export type GetVenuesByGeoQueryVariables = Exact<{
  distance: Scalars['Float'];
  from: Scalars['geography'];
  limit?: InputMaybe<Scalars['Int']>;
  hasPickleball?: InputMaybe<Scalars['Boolean']>;
  hasTennis?: InputMaybe<Scalars['Boolean']>;
  hasPadel?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetVenuesByGeoQuery = { __typename?: 'query_root', venues: Array<{ __typename?: 'Venues', id: any, title: string, geometry?: any | null, slug: string, addressString: string, accessType?: VenueAccessTypesEnum | null, indoorCourtCount: number, outdoorCourtCount: number, pickleballNets?: VenueNetsEnum | null, latitude: any, longitude: any, images: Array<{ __typename?: 'VenueImages', id: any, isVisible: boolean, fileName: string, fileType?: string | null, path: string, provider: string, url: string }>, city?: { __typename?: 'Cities', id: any, name: string, countrySubdivision: { __typename?: 'CountrySubdivisions', id: any, name: string } } | null }> };

export type GetPickleballVenuesByGeoQueryVariables = Exact<{
  distance: Scalars['Float'];
  from: Scalars['geography'];
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetPickleballVenuesByGeoQuery = { __typename?: 'query_root', venues: Array<{ __typename?: 'Venues', id: any, title: string, geometry?: any | null, slug: string, addressString: string, accessType?: VenueAccessTypesEnum | null, indoorCourtCount: number, outdoorCourtCount: number, pickleballNets?: VenueNetsEnum | null, latitude: any, longitude: any, images: Array<{ __typename?: 'VenueImages', id: any, isVisible: boolean, fileName: string, fileType?: string | null, path: string, provider: string, url: string }>, city?: { __typename?: 'Cities', id: any, name: string, countrySubdivision: { __typename?: 'CountrySubdivisions', id: any, name: string } } | null }> };

export type GetTennisVenuesByGeoQueryVariables = Exact<{
  distance: Scalars['Float'];
  from: Scalars['geography'];
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetTennisVenuesByGeoQuery = { __typename?: 'query_root', venues: Array<{ __typename?: 'Venues', id: any, title: string, geometry?: any | null, slug: string, addressString: string, accessType?: VenueAccessTypesEnum | null, indoorCourtCount: number, outdoorCourtCount: number, pickleballNets?: VenueNetsEnum | null, latitude: any, longitude: any, images: Array<{ __typename?: 'VenueImages', id: any, isVisible: boolean, fileName: string, fileType?: string | null, path: string, provider: string, url: string }>, city?: { __typename?: 'Cities', id: any, name: string, countrySubdivision: { __typename?: 'CountrySubdivisions', id: any, name: string } } | null }> };

export type GetViewerByIdQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetViewerByIdQuery = { __typename?: 'query_root', usersByPk?: { __typename?: 'Users', createdAt: any, email: string, gender?: GenderEnum | null, id: any, stripeCustomerId: string, stripeMerchantId?: string | null, updatedAt: any, fullName: string, username?: string | null, duprId?: string | null, birthday?: any | null, phoneNumber?: string | null, activeCityId?: any | null, latitude?: any | null, longitude?: any | null, timezone?: string | null, profileImagePath: string, profileImageProviderUrl: string, profileImageUrl: string, stripeMerchantCurrency?: string | null, currencyCoachDefault: string, adminVenueId?: any | null } | null };

export type GetWarRoomCitiesDataQueryVariables = Exact<{
  fourteenDaysAgo: Scalars['timestamptz'];
}>;


export type GetWarRoomCitiesDataQuery = { __typename?: 'query_root', lessons: Array<{ __typename?: 'Lessons', createdAt: any, priceUnitAmount: number, owner?: { __typename?: 'Users', id: any, latitude?: any | null, longitude?: any | null, cityName: string, activeCity?: { __typename?: 'Cities', id: any, name: string, countrySubdivision: { __typename?: 'CountrySubdivisions', name: string } } | null } | null }>, events: Array<{ __typename?: 'Events', createdAt: any, hostUser?: { __typename?: 'Users', latitude?: any | null, longitude?: any | null, cityName: string, activeCity?: { __typename?: 'Cities', id: any, name: string, countrySubdivision: { __typename?: 'CountrySubdivisions', name: string } } | null } | null }>, lessonOrders: Array<{ __typename?: 'LessonOrders', createdAt: any, paidUnitAmount: number, seller: { __typename?: 'Users', latitude?: any | null, longitude?: any | null, cityName: string, activeCity?: { __typename?: 'Cities', id: any, name: string, countrySubdivision: { __typename?: 'CountrySubdivisions', name: string } } | null } }> };

export type GetWarRoomClubsDataQueryVariables = Exact<{
  thirtyDaysAgo: Scalars['timestamptz'];
  sevenDaysAgo: Scalars['timestamptz'];
}>;


export type GetWarRoomClubsDataQuery = { __typename?: 'query_root', venues: Array<{ __typename?: 'Venues', id: any, title: string, createdAt: any, latitude: any, longitude: any, hasPickleball: boolean, hasTennis: boolean, sourceCity?: string | null, sourceStateShort?: string | null, city?: { __typename?: 'Cities', name: string, countrySubdivision: { __typename?: 'CountrySubdivisions', name: string } } | null, staffCoachesAggregate: { __typename?: 'VenueStaffCoachesAggregate', aggregate?: { __typename?: 'VenueStaffCoachesAggregateFields', count: number } | null } }>, recentLessons: Array<{ __typename?: 'Lessons', venueId?: any | null, createdAt: any }>, recentPlaySessions: Array<{ __typename?: 'PlaySessions', venueId?: any | null }> };

export type GetWarRoomCohortsDataQueryVariables = Exact<{
  cohortStart: Scalars['timestamptz'];
  reactivationStart: Scalars['timestamptz'];
  reactivationEnd: Scalars['timestamptz'];
}>;


export type GetWarRoomCohortsDataQuery = { __typename?: 'query_root', cohortPlayers: Array<{ __typename?: 'Users', id: any, createdAt: any }>, cohortCoaches: Array<{ __typename?: 'Users', id: any, createdAt: any }>, cohortParticipants: Array<{ __typename?: 'LessonParticipants', userId: any, createdAt: any }>, cohortLessons: Array<{ __typename?: 'Lessons', ownerUserId?: any | null, createdAt: any }>, allParticipantsForPlayers: Array<{ __typename?: 'LessonParticipants', userId: any, createdAt: any }>, reactivationUsers: Array<{ __typename?: 'Users', id: any, fullName: string, preferredName: string, email: string, lastLoginAt?: any | null, latitude?: any | null, longitude?: any | null, cityName: string, activeCity?: { __typename?: 'Cities', id: any, name: string, countrySubdivision: { __typename?: 'CountrySubdivisions', name: string } } | null, participantLessonsAggregate: { __typename?: 'LessonParticipantsAggregate', aggregate?: { __typename?: 'LessonParticipantsAggregateFields', count: number } | null } }> };

export type GetWarRoomEventsDataQueryVariables = Exact<{
  now: Scalars['timestamptz'];
  oneDayAgo: Scalars['timestamptz'];
  sevenDaysAgo: Scalars['timestamptz'];
  thirtyDaysAgo: Scalars['timestamptz'];
  sevenDaysAhead: Scalars['timestamptz'];
}>;


export type GetWarRoomEventsDataQuery = { __typename?: 'query_root', events: Array<{ __typename?: 'Events', id: any, title: string, createdAt: any, startDateTime: any, type: EventTypesEnum, isExternal: boolean, isQuickCreate: boolean, isVairRequired?: boolean | null, source?: string | null, sport: SportsEnum, participantLimit?: number | null, cityString: string, city?: { __typename?: 'Cities', name: string, countrySubdivision: { __typename?: 'CountrySubdivisions', name: string } } | null, groups: Array<{ __typename?: 'EventGroups', format?: EventGroupFormatsEnum | null }>, registrationsAggregate: { __typename?: 'EventRegistrationsAggregate', aggregate?: { __typename?: 'EventRegistrationsAggregateFields', count: number } | null }, hostUser?: { __typename?: 'Users', id: any, fullName: string, preferredName: string } | null }>, vairGroupsAll: { __typename?: 'EventGroupsAggregate', aggregate?: { __typename?: 'EventGroupsAggregateFields', count: number } | null }, vairGroups30d: { __typename?: 'EventGroupsAggregate', aggregate?: { __typename?: 'EventGroupsAggregateFields', count: number } | null }, vairGroups7d: { __typename?: 'EventGroupsAggregate', aggregate?: { __typename?: 'EventGroupsAggregateFields', count: number } | null }, vairGroups24h: { __typename?: 'EventGroupsAggregate', aggregate?: { __typename?: 'EventGroupsAggregateFields', count: number } | null }, vairMatchesTotal: { __typename?: 'EventMatchesAggregate', aggregate?: { __typename?: 'EventMatchesAggregateFields', count: number } | null }, vairMatchesSubmitted: { __typename?: 'EventMatchesAggregate', aggregate?: { __typename?: 'EventMatchesAggregateFields', count: number } | null }, vairMatchesSubmitted30d: { __typename?: 'EventMatchesAggregate', aggregate?: { __typename?: 'EventMatchesAggregateFields', count: number } | null }, vairMatchesSubmitted7d: { __typename?: 'EventMatchesAggregate', aggregate?: { __typename?: 'EventMatchesAggregateFields', count: number } | null }, vairMatchesSubmitted24h: { __typename?: 'EventMatchesAggregate', aggregate?: { __typename?: 'EventMatchesAggregateFields', count: number } | null }, vairConnectionsAll: { __typename?: 'UserVairConnectionsAggregate', aggregate?: { __typename?: 'UserVairConnectionsAggregateFields', count: number } | null }, vairConnections30d: { __typename?: 'UserVairConnectionsAggregate', aggregate?: { __typename?: 'UserVairConnectionsAggregateFields', count: number } | null }, vairConnections7d: { __typename?: 'UserVairConnectionsAggregate', aggregate?: { __typename?: 'UserVairConnectionsAggregateFields', count: number } | null }, vairConnections24h: { __typename?: 'UserVairConnectionsAggregate', aggregate?: { __typename?: 'UserVairConnectionsAggregateFields', count: number } | null }, atRiskEvents: Array<{ __typename?: 'Events', id: any, title: string, startDateTime: any, participantLimit?: number | null, cityString: string, city?: { __typename?: 'Cities', name: string, countrySubdivision: { __typename?: 'CountrySubdivisions', name: string } } | null, registrationsAggregate: { __typename?: 'EventRegistrationsAggregate', aggregate?: { __typename?: 'EventRegistrationsAggregateFields', count: number } | null } }> };

export type GetWarRoomLessonsDataQueryVariables = Exact<{
  now: Scalars['timestamptz'];
  periodStart: Scalars['timestamptz'];
  priorStart: Scalars['timestamptz'];
  trendStart: Scalars['timestamptz'];
}>;


export type GetWarRoomLessonsDataQuery = { __typename?: 'query_root', bookedPeriod: { __typename?: 'LessonsAggregate', aggregate?: { __typename?: 'LessonsAggregateFields', count: number } | null }, bookedPrior: { __typename?: 'LessonsAggregate', aggregate?: { __typename?: 'LessonsAggregateFields', count: number } | null }, completedPeriod: { __typename?: 'LessonsAggregate', aggregate?: { __typename?: 'LessonsAggregateFields', count: number } | null }, cancelledPeriod: { __typename?: 'LessonsAggregate', aggregate?: { __typename?: 'LessonsAggregateFields', count: number } | null }, avgPricePeriod: { __typename?: 'LessonsAggregate', aggregate?: { __typename?: 'LessonsAggregateFields', avg?: { __typename?: 'LessonsAvgFields', priceUnitAmount?: number | null } | null } | null }, gmvPeriod: { __typename?: 'LessonOrdersAggregate', aggregate?: { __typename?: 'LessonOrdersAggregateFields', count: number, sum?: { __typename?: 'LessonOrdersSumFields', paidUnitAmount?: number | null, applicationFeeTotalUnitAmount?: number | null } | null } | null }, gmvPrior: { __typename?: 'LessonOrdersAggregate', aggregate?: { __typename?: 'LessonOrdersAggregateFields', count: number, sum?: { __typename?: 'LessonOrdersSumFields', paidUnitAmount?: number | null } | null } | null }, refundedPeriod: { __typename?: 'LessonOrdersAggregate', aggregate?: { __typename?: 'LessonOrdersAggregateFields', count: number } | null }, trendLessons: Array<{ __typename?: 'Lessons', createdAt: any, startDateTime?: any | null }>, topCoachLessons: Array<{ __typename?: 'Lessons', createdAt: any, priceUnitAmount: number, owner?: { __typename?: 'Users', id: any, fullName: string, preferredName: string, cityName: string, latitude?: any | null, longitude?: any | null, activeCity?: { __typename?: 'Cities', name: string, countrySubdivision: { __typename?: 'CountrySubdivisions', name: string } } | null } | null, participantsAggregate: { __typename?: 'LessonParticipantsAggregate', aggregate?: { __typename?: 'LessonParticipantsAggregateFields', count: number } | null } }>, participantSamples: Array<{ __typename?: 'LessonParticipants', createdAt: any, userId: any }>, playerSignups: Array<{ __typename?: 'Users', id: any, createdAt: any }> };

export type GetWarRoomMarketplaceDataQueryVariables = Exact<{
  periodStart: Scalars['timestamptz'];
}>;


export type GetWarRoomMarketplaceDataQuery = { __typename?: 'query_root', requests: Array<{ __typename?: 'CoachBookingRequests', id: any, createdAt: any, contactedAt?: any | null, playerUserId: any, coachUserId?: any | null, coachUser?: { __typename?: 'Users', id: any, fullName: string, preferredName: string, latitude?: any | null, longitude?: any | null, cityName: string, activeCity?: { __typename?: 'Cities', id: any, name: string, countrySubdivision: { __typename?: 'CountrySubdivisions', name: string } } | null } | null }>, recentLessons: Array<{ __typename?: 'Lessons', ownerUserId?: any | null, participants: Array<{ __typename?: 'LessonParticipants', userId: any }> }> };

export type GetWarRoomPartnerBookingsQueryVariables = Exact<{
  since: Scalars['timestamptz'];
  limit: Scalars['Int'];
}>;


export type GetWarRoomPartnerBookingsQuery = { __typename?: 'query_root', partnerBookingOrders: Array<{ __typename?: 'PartnerBookingOrders', id: any, marker: string, status: PartnerBookingOrderStatusesEnum, createdAt: any, updatedAt: any, localDate: any, startLocal: any, endLocal: any, timezone: string, providerCourtId?: string | null, playerCount: number, configVersion: number, clubPriceUnitAmount?: number | null, partnerDiscountPercent?: any | null, partnerDiscountUnitAmount?: number | null, bounceCostUnitAmount?: number | null, referralFeeUnitAmount?: number | null, orderTotalUnitAmount: number, venue: { __typename?: 'Venues', id: any, title: string }, player: { __typename?: 'Users', id: any, fullName: string, preferredName: string, email: string }, hold?: { __typename?: 'PartnerBookingHolds', releasedAt?: any | null } | null, attempts: Array<{ __typename?: 'PartnerBookingAttempts', id: any, createdAt: any, confirmationNumber?: string | null, events: Array<{ __typename?: 'PartnerBookingAttemptEvents', createdAt: any, source: PartnerBookingEventSourcesEnum, event: string, body: any }> }> }> };

export type GetWarRoomPartnerClubsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWarRoomPartnerClubsQuery = { __typename?: 'query_root', venueBookingIntegrations: Array<{ __typename?: 'VenueBookingIntegrations', id: any, status: BookingIntegrationStatusesEnum, connectionStatus: BookingConnectionStatusesEnum, verifiedAt?: any | null, readVerifiedAt?: any | null, bookingSystem: BookingSystemsEnum, externalOrgId?: string | null, providerApiKeyEncrypted?: string | null, maxAdvanceBookingDays?: number | null, promoCode?: string | null, venue: { __typename?: 'Venues', id: any, title: string, timezone: string }, courtRates: Array<{ __typename?: 'VenueBookingCourtRates', hourlyUnitAmount: number }>, connectionChecks: Array<{ __typename?: 'VenueBookingConnectionChecks', status: VenueBookingConnectionCheckStatusesEnum, trigger: string, createdAt: any, completedAt?: any | null, report?: any | null }> }> };

export type GetWarRoomProgrammingDataQueryVariables = Exact<{
  emailPattern: Scalars['String'];
  windowStart: Scalars['timestamptz'];
}>;


export type GetWarRoomProgrammingDataQuery = { __typename?: 'query_root', bounceLessons: Array<{ __typename?: 'Lessons', id: any, title: string, createdAt: any, ownerUserId?: any | null, venueId?: any | null, owner?: { __typename?: 'Users', id: any, email: string, fullName: string, preferredName: string, latitude?: any | null, longitude?: any | null, cityName: string, activeCity?: { __typename?: 'Cities', id: any, name: string, countrySubdivision: { __typename?: 'CountrySubdivisions', name: string } } | null } | null, venue?: { __typename?: 'Venues', id: any, title: string, sourceCity?: string | null, sourceStateShort?: string | null, latitude: any, longitude: any, city?: { __typename?: 'Cities', name: string, countrySubdivision: { __typename?: 'CountrySubdivisions', name: string } } | null } | null }>, bounceEvents: Array<{ __typename?: 'Events', id: any, title: string, createdAt: any, type: EventTypesEnum, isVairRequired?: boolean | null, cityString: string, city?: { __typename?: 'Cities', name: string, countrySubdivision: { __typename?: 'CountrySubdivisions', name: string } } | null, groups: Array<{ __typename?: 'EventGroups', format?: EventGroupFormatsEnum | null }>, hostUser?: { __typename?: 'Users', id: any, email: string, fullName: string, preferredName: string, latitude?: any | null, longitude?: any | null, cityName: string, activeCity?: { __typename?: 'Cities', id: any, name: string, countrySubdivision: { __typename?: 'CountrySubdivisions', name: string } } | null } | null, venue?: { __typename?: 'Venues', id: any, title: string, sourceCity?: string | null, sourceStateShort?: string | null, latitude: any, longitude: any, city?: { __typename?: 'Cities', name: string, countrySubdivision: { __typename?: 'CountrySubdivisions', name: string } } | null } | null }>, bounceLessonsAllTime: { __typename?: 'LessonsAggregate', aggregate?: { __typename?: 'LessonsAggregateFields', count: number } | null }, bounceEventsAllTime: { __typename?: 'EventsAggregate', aggregate?: { __typename?: 'EventsAggregateFields', count: number } | null } };

export type GetWarRoomPulseDataQueryVariables = Exact<{
  periodStart: Scalars['timestamptz'];
  priorStart: Scalars['timestamptz'];
  oneDayAgo: Scalars['timestamptz'];
  trendStart: Scalars['timestamptz'];
  topMoversPriorStart: Scalars['timestamptz'];
}>;


export type GetWarRoomPulseDataQuery = { __typename?: 'query_root', signupsPeriod: { __typename?: 'UsersAggregate', aggregate?: { __typename?: 'UsersAggregateFields', count: number } | null }, signupsPrior: { __typename?: 'UsersAggregate', aggregate?: { __typename?: 'UsersAggregateFields', count: number } | null }, signupsTotal: { __typename?: 'UsersAggregate', aggregate?: { __typename?: 'UsersAggregateFields', count: number } | null }, lessonsPeriod: { __typename?: 'LessonsAggregate', aggregate?: { __typename?: 'LessonsAggregateFields', count: number } | null }, lessonsPrior: { __typename?: 'LessonsAggregate', aggregate?: { __typename?: 'LessonsAggregateFields', count: number } | null }, lessonsTotal: { __typename?: 'LessonsAggregate', aggregate?: { __typename?: 'LessonsAggregateFields', count: number } | null }, eventsPeriod: { __typename?: 'EventsAggregate', aggregate?: { __typename?: 'EventsAggregateFields', count: number } | null }, eventsPrior: { __typename?: 'EventsAggregate', aggregate?: { __typename?: 'EventsAggregateFields', count: number } | null }, eventsTotal: { __typename?: 'EventsAggregate', aggregate?: { __typename?: 'EventsAggregateFields', count: number } | null }, gmvPeriod: { __typename?: 'LessonOrdersAggregate', aggregate?: { __typename?: 'LessonOrdersAggregateFields', count: number, sum?: { __typename?: 'LessonOrdersSumFields', paidUnitAmount?: number | null } | null } | null }, gmvPrior: { __typename?: 'LessonOrdersAggregate', aggregate?: { __typename?: 'LessonOrdersAggregateFields', count: number, sum?: { __typename?: 'LessonOrdersSumFields', paidUnitAmount?: number | null } | null } | null }, gmvTotal: { __typename?: 'LessonOrdersAggregate', aggregate?: { __typename?: 'LessonOrdersAggregateFields', sum?: { __typename?: 'LessonOrdersSumFields', paidUnitAmount?: number | null } | null } | null }, dau: { __typename?: 'UsersAggregate', aggregate?: { __typename?: 'UsersAggregateFields', count: number } | null }, trendSignups: Array<{ __typename?: 'Users', createdAt: any }>, trendLessons: Array<{ __typename?: 'Lessons', createdAt: any }>, trendEvents: Array<{ __typename?: 'Events', createdAt: any }>, trendOrders: Array<{ __typename?: 'LessonOrders', createdAt: any, paidUnitAmount: number }>, recentSignups24h: Array<{ __typename?: 'Users', latitude?: any | null, longitude?: any | null, cityName: string, activeCity?: { __typename?: 'Cities', id: any, name: string, countrySubdivision: { __typename?: 'CountrySubdivisions', name: string } } | null }>, topMoversLessons: Array<{ __typename?: 'Lessons', createdAt: any, owner?: { __typename?: 'Users', latitude?: any | null, longitude?: any | null, cityName: string, activeCity?: { __typename?: 'Cities', id: any, name: string, countrySubdivision: { __typename?: 'CountrySubdivisions', name: string } } | null } | null }>, feedSignups: Array<{ __typename?: 'Users', id: any, createdAt: any, fullName: string, preferredName: string, cityName: string, latitude?: any | null, longitude?: any | null, activeCity?: { __typename?: 'Cities', name: string, countrySubdivision: { __typename?: 'CountrySubdivisions', name: string } } | null }>, feedLessons: Array<{ __typename?: 'Lessons', id: any, createdAt: any, title: string, owner?: { __typename?: 'Users', fullName: string, preferredName: string, cityName: string, latitude?: any | null, longitude?: any | null, activeCity?: { __typename?: 'Cities', name: string, countrySubdivision: { __typename?: 'CountrySubdivisions', name: string } } | null } | null }>, feedEvents: Array<{ __typename?: 'Events', id: any, createdAt: any, title: string, hostUser?: { __typename?: 'Users', fullName: string, preferredName: string, cityName: string, latitude?: any | null, longitude?: any | null, activeCity?: { __typename?: 'Cities', name: string, countrySubdivision: { __typename?: 'CountrySubdivisions', name: string } } | null } | null }> };

export type GetWarRoomRevenueDataQueryVariables = Exact<{
  periodStart: Scalars['timestamptz'];
  priorStart: Scalars['timestamptz'];
  trendStart: Scalars['timestamptz'];
}>;


export type GetWarRoomRevenueDataQuery = { __typename?: 'query_root', lessonGmvPeriod: { __typename?: 'LessonOrdersAggregate', aggregate?: { __typename?: 'LessonOrdersAggregateFields', count: number, sum?: { __typename?: 'LessonOrdersSumFields', paidUnitAmount?: number | null, applicationFeeTotalUnitAmount?: number | null, customerApplicationFeeUnitAmount?: number | null, transferUnitAmount?: number | null } | null } | null }, lessonGmvPrior: { __typename?: 'LessonOrdersAggregate', aggregate?: { __typename?: 'LessonOrdersAggregateFields', count: number, sum?: { __typename?: 'LessonOrdersSumFields', paidUnitAmount?: number | null } | null } | null }, lessonOrdersStatusCounts: Array<{ __typename?: 'LessonOrders', status: OrderStatusesEnum }>, lessonRefundsPeriod: { __typename?: 'LessonOrdersAggregate', aggregate?: { __typename?: 'LessonOrdersAggregateFields', count: number, sum?: { __typename?: 'LessonOrdersSumFields', paidUnitAmount?: number | null } | null } | null }, eventGmvPeriod: { __typename?: 'EventTransactionItemsAggregate', aggregate?: { __typename?: 'EventTransactionItemsAggregateFields', count: number, sum?: { __typename?: 'EventTransactionItemsSumFields', totalUnitAmount?: number | null } | null } | null }, eventGmvPrior: { __typename?: 'EventTransactionItemsAggregate', aggregate?: { __typename?: 'EventTransactionItemsAggregateFields', count: number, sum?: { __typename?: 'EventTransactionItemsSumFields', totalUnitAmount?: number | null } | null } | null }, trendOrders: Array<{ __typename?: 'LessonOrders', createdAt: any, paidUnitAmount: number }>, cityOrders: Array<{ __typename?: 'LessonOrders', paidUnitAmount: number, seller: { __typename?: 'Users', id: any, fullName: string, preferredName: string, latitude?: any | null, longitude?: any | null, cityName: string, activeCity?: { __typename?: 'Cities', id: any, name: string, countrySubdivision: { __typename?: 'CountrySubdivisions', name: string } } | null } }>, ltvOrders: Array<{ __typename?: 'LessonOrders', createdAt: any, paidUnitAmount: number, customerUserId: any, customer: { __typename?: 'Users', createdAt: any } }>, totalUsers: { __typename?: 'UsersAggregate', aggregate?: { __typename?: 'UsersAggregateFields', count: number } | null }, payingUsersPeriod: Array<{ __typename?: 'LessonOrders', customerUserId: any }> };

export type SearchWarRoomVenuesQueryVariables = Exact<{
  where: VenuesBoolExp;
  orderBy?: InputMaybe<Array<VenuesOrderBy> | VenuesOrderBy>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type SearchWarRoomVenuesQuery = { __typename?: 'query_root', venues: Array<{ __typename?: 'Venues', id: any, title: string, slug: string, addressString: string, isActive: boolean, createdAt: any, hasPickleball: boolean, hasTennis: boolean, indoorCourtCount: number, outdoorCourtCount: number, sourceCity?: string | null, sourceStateShort?: string | null, city?: { __typename?: 'Cities', name: string, countrySubdivision: { __typename?: 'CountrySubdivisions', name: string } } | null }>, venuesAggregate: { __typename?: 'VenuesAggregate', aggregate?: { __typename?: 'VenuesAggregateFields', count: number } | null } };
